export const MaintenancePageImage = () => (
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 width="100%" viewBox="0 0 1024 1024" enable-background="new 0 0 1024 1024">
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M436.423462,1024.776367 
	C429.312347,1025.000000 422.624725,1025.000000 415.468536,1025.000000 
	C407.087952,1023.860779 399.132996,1024.732178 391.200684,1024.510498 
	C386.720764,1024.385254 382.234497,1024.487915 377.264954,1024.488037 
	C312.352173,1024.487549 247.925476,1024.488037 183.053680,1024.488281 
	C179.151321,1024.761230 175.949677,1023.838562 173.420349,1021.578064 
	C166.999115,1015.839172 159.518234,1015.498718 151.629868,1016.847717 
	C149.179230,1017.266724 146.734283,1017.534546 143.906189,1017.167358 
	C142.472321,1016.808289 141.657623,1016.240784 141.427795,1014.789307 
	C141.363449,1014.551575 141.122437,1014.155701 140.908112,1014.058350 
	C140.188400,1013.878052 139.680389,1013.810303 138.903046,1013.620239 
	C138.058121,1013.332397 137.510071,1013.076477 136.657196,1012.707275 
	C130.919296,1010.292908 130.863419,1010.315002 130.716064,1015.184021 
	C130.707779,1016.046631 130.571472,1016.520325 130.086670,1017.249268 
	C126.229866,1019.040649 122.576279,1018.132324 118.574509,1017.672241 
	C118.013275,1017.345032 117.816879,1017.172180 117.447563,1016.650391 
	C117.013557,1015.199646 117.380714,1014.338196 118.597649,1013.552368 
	C119.884392,1013.166748 121.007004,1013.758423 122.004051,1012.613403 
	C122.626511,1008.604797 121.349823,1005.160156 120.289291,1001.705627 
	C118.492607,995.853394 116.742393,989.968689 115.882538,983.919861 
	C115.378670,980.375366 113.847389,978.110657 110.327133,976.657593 
	C109.801888,976.394104 109.594315,976.284607 109.081924,976.000732 
	C108.174759,975.466431 107.600723,975.064880 106.774124,974.415771 
	C105.444435,973.364319 104.755478,971.243408 102.705338,973.420898 
	C101.285965,975.248474 100.480164,977.058472 99.401062,978.696960 
	C98.766190,979.661072 98.029236,980.698486 96.668625,980.315796 
	C95.090309,979.871887 95.012688,978.452759 94.989380,977.127625 
	C94.959663,975.437500 95.775520,973.985291 96.366142,972.459473 
	C96.914581,971.042480 98.431862,969.707275 96.730232,967.823120 
	C96.265778,967.541260 96.079552,967.425659 95.656937,967.078979 
	C94.475983,965.352356 93.220970,964.146301 91.624359,962.816162 
	C90.638374,961.868835 90.044800,960.997437 89.010429,960.185181 
	C88.202217,959.864258 87.763680,960.100159 87.182800,960.728821 
	C86.852936,961.129150 86.714615,961.293152 86.394867,961.739502 
	C82.335739,971.832764 82.549767,981.886780 84.755661,991.953552 
	C85.996193,997.614746 88.130241,1003.038330 90.167137,1008.466064 
	C90.561714,1009.027710 91.013199,1007.810486 90.569565,1008.308105 
	C90.435165,1008.458862 90.268860,1008.390015 90.145874,1008.072693 
	C88.354591,1003.449768 86.019173,998.934631 87.482117,993.377930 
	C87.932968,992.934326 88.165482,992.815430 88.782104,992.775452 
	C91.435692,995.357422 91.592224,998.628479 92.266609,1001.675537 
	C93.983437,1009.432739 93.929474,1009.444702 102.412766,1009.675659 
	C103.336250,1009.759460 103.855232,1009.869080 104.740616,1010.170715 
	C106.885048,1011.650513 109.287651,1011.407776 111.314377,1013.057251 
	C111.858902,1014.294678 111.773560,1015.147034 111.014397,1016.291382 
	C104.570221,1018.321167 98.326126,1017.077881 92.150154,1017.405334 
	C89.374519,1017.552490 86.584930,1017.419678 83.358971,1017.449463 
	C74.372681,1018.906494 65.705956,1019.362427 56.766144,1020.814941 
	C56.156113,1021.122864 55.922295,1021.266296 55.312897,1021.578979 
	C53.876266,1022.105469 52.799366,1022.138794 51.328201,1021.787720 
	C48.527477,1019.682068 45.397820,1020.847168 42.416138,1019.622559 
	C41.679062,1019.023621 41.454639,1018.547424 41.441612,1017.587036 
	C41.704605,1016.662231 42.043179,1016.244080 42.861263,1015.721375 
	C45.943729,1013.963989 49.165150,1014.755859 52.404858,1013.593994 
	C56.272541,1013.668579 59.667469,1012.691284 63.560112,1012.998779 
	C70.281990,1012.180298 76.621712,1012.645874 80.668709,1012.543030 
	C77.046959,1013.006592 71.089577,1011.850830 64.792389,1012.975952 
	C60.631664,1012.717712 56.946957,1013.448486 52.805161,1013.502991 
	C49.449520,1014.634949 46.185932,1014.061523 42.884308,1015.478638 
	C30.427050,1017.827759 18.284056,1019.205200 6.020357,1019.389771 
	C4.532616,1019.412170 3.015922,1019.444885 1.349919,1018.267883 
	C1.000000,1016.933289 1.000000,1015.866638 1.000000,1014.399963 
	C4.823085,1012.924500 8.792183,1013.058044 13.074566,1012.596008 
	C14.214508,1012.616455 14.968510,1012.595825 16.083054,1012.623291 
	C17.149794,1012.639893 17.854450,1012.618408 18.899652,1012.489197 
	C20.821274,1011.603210 22.427986,1011.911682 24.412167,1012.284790 
	C34.031986,1011.407288 43.293510,1010.788147 52.504707,1009.535400 
	C58.744671,1008.686707 59.398621,1008.225952 59.491879,1001.791565 
	C59.520741,999.800476 59.434933,997.807007 59.669048,995.400146 
	C60.097759,993.182068 60.934158,991.802002 63.313232,991.523071 
	C66.669273,994.562683 65.223839,998.517456 65.821815,1001.983948 
	C66.514145,1005.997314 67.767738,1008.351746 72.195572,1006.830566 
	C74.805626,1005.934021 78.475189,1008.539124 79.880020,1005.775146 
	C80.895744,1003.776917 78.870766,1000.759827 78.327538,998.166565 
	C77.986809,996.539978 77.687454,994.913269 77.568481,992.878601 
	C77.529427,991.731445 77.362259,990.987671 77.001053,989.877686 
	C74.607185,978.591797 74.783859,967.985413 80.880325,957.781860 
	C81.613220,956.670898 82.509109,956.025024 82.232391,954.629944 
	C81.444130,953.612427 80.600433,953.052795 79.630638,952.140137 
	C73.544952,944.416077 67.790131,936.852966 62.020645,928.869629 
	C61.668053,928.418335 61.539413,928.229614 61.255722,927.738159 
	C60.499554,925.768005 59.856354,924.123596 58.352661,922.567139 
	C57.838428,921.938538 57.571560,921.554443 57.156937,920.836548 
	C54.467834,910.545227 50.457062,901.879883 38.571690,899.605347 
	C34.786545,892.918030 32.073082,886.251160 32.412685,878.392822 
	C33.865265,876.979980 35.143311,877.372986 36.754578,878.166931 
	C39.713367,881.376343 39.964619,885.394958 41.580341,888.824036 
	C42.750050,891.306580 43.051189,894.391235 46.447842,895.753174 
	C57.709019,899.783813 68.615417,901.237793 79.840714,895.726318 
	C94.082268,890.586853 105.543488,881.570862 117.585526,872.855469 
	C118.860352,872.181030 119.607635,871.334412 120.873032,870.707886 
	C121.445419,870.474426 121.635323,870.188660 121.871086,870.092834 
	C122.484695,869.843262 121.559082,869.388794 121.942970,869.933838 
	C121.944351,869.935791 121.844795,870.047058 121.378204,870.407593 
	C119.950424,871.046143 119.027992,871.923279 117.653732,872.721802 
	C107.261124,878.333740 97.419029,884.361816 85.583786,886.528442 
	C85.047997,886.249390 84.865776,886.083862 84.567482,885.569580 
	C84.439285,883.260132 85.921623,882.378784 87.228432,881.366272 
	C100.740021,870.898193 114.714561,861.048462 128.143677,850.459839 
	C134.906921,845.127136 140.652863,838.613708 148.194366,833.691895 
	C153.542603,829.904968 157.683029,825.322388 161.731461,820.727417 
	C164.404648,817.693481 167.273682,815.037842 170.886780,812.694336 
	C171.731842,812.218140 170.928391,812.566528 171.526459,812.271973 
	C171.369888,812.324036 171.264465,812.453735 170.829010,812.689087 
	C163.001175,816.804443 154.687485,818.540039 146.699463,821.193970 
	C144.033997,822.079468 141.308319,822.791687 138.302338,823.907959 
	C126.305252,827.286499 115.658066,822.874390 111.427765,812.639526 
	C111.933159,811.169922 112.771225,810.617920 114.259743,810.463806 
	C120.306587,812.549500 125.763168,811.439087 128.571960,807.327209 
	C128.751816,806.543213 128.905975,806.111450 129.281738,805.401184 
	C129.782150,804.780457 130.152878,804.534241 130.912109,804.338196 
	C132.066711,804.268921 132.912659,804.383728 133.988098,803.868225 
	C137.215668,801.645508 141.238068,803.038696 144.365219,800.617004 
	C144.778183,800.672302 144.918655,800.782166 145.041031,800.628723 
	C144.562881,799.757690 144.018066,799.227844 143.254944,798.461914 
	C140.270370,795.182983 138.710144,791.077332 134.595703,788.762329 
	C127.503815,779.971252 117.440216,775.579590 108.859138,768.718262 
	C104.614647,764.133118 102.151413,758.619507 97.369446,754.009521 
	C96.678246,753.366882 96.527199,753.180359 96.193748,752.681030 
	C94.940697,749.392883 94.124344,746.369629 94.414398,742.834717 
	C97.202133,740.918213 97.892593,743.490356 99.026253,744.757751 
	C101.847885,747.912354 103.540535,752.000000 107.356155,754.770752 
	C107.793381,755.115173 107.957199,755.263855 108.332916,755.662109 
	C109.058678,756.558350 109.370667,757.394104 110.528374,757.843323 
	C111.431740,758.252747 111.975731,758.624329 112.649918,759.380615 
	C114.910233,763.205994 117.915184,765.789734 121.193542,768.319031 
	C121.625725,767.178894 121.208054,766.378235 121.429626,765.231812 
	C121.931503,763.957886 122.617729,763.280029 123.785278,762.588684 
	C129.364273,762.736694 133.095093,766.383118 137.478317,768.562195 
	C140.580536,770.104431 143.412582,772.191223 147.131592,773.071899 
	C148.292068,772.324524 147.945251,771.589233 147.475479,770.866150 
	C135.819427,752.925293 127.715134,733.430786 122.091545,712.850769 
	C121.653038,711.245972 121.026161,709.714783 120.152267,707.862061 
	C119.047707,700.256958 115.243347,693.567200 115.937714,685.629944 
	C116.266235,684.738953 116.581909,684.317078 117.371979,683.865112 
	C119.671799,684.621765 119.980515,686.524719 120.480209,688.236572 
	C121.740585,692.554565 124.081055,696.387207 125.914536,700.300659 
	C124.341110,694.706055 124.297943,688.595093 121.736496,682.664307 
	C120.893135,669.058044 118.521828,655.986755 118.069489,642.736938 
	C117.990555,640.424500 117.622162,638.122559 118.023247,635.426270 
	C120.500130,632.244141 121.474655,635.082275 121.631462,636.372742 
	C122.502831,643.543457 126.485588,649.824646 127.233818,657.021423 
	C127.733429,661.826904 129.049713,666.363892 133.341232,669.402405 
	C134.564529,670.268494 134.466476,671.955505 135.057938,673.762695 
	C138.895721,668.035950 138.198730,662.214722 137.865692,656.093140 
	C137.800964,655.227295 137.818527,654.727966 137.959442,653.852783 
	C140.846054,649.393494 138.544495,645.036377 138.267441,640.965881 
	C137.772934,633.699768 137.268768,626.407104 136.544815,619.144897 
	C136.409515,617.787659 136.233124,616.511536 135.261154,614.997070 
	C134.301849,610.195557 133.646149,605.787781 136.358124,601.303528 
	C140.105316,600.992310 139.919937,603.898926 140.281281,605.913086 
	C141.652527,613.556885 142.530563,621.279602 143.495377,629.404114 
	C143.469498,630.632812 143.479111,631.439880 143.907684,632.594482 
	C144.407181,634.256775 144.772888,635.541504 145.176880,637.237061 
	C146.614487,652.413086 150.891266,666.596313 154.134811,680.986084 
	C155.316376,686.227966 156.681717,691.445251 157.949173,695.277771 
	C157.305023,678.173096 155.825394,659.873413 151.997726,641.435791 
	C149.161652,630.966919 145.315247,621.240051 143.094894,611.010437 
	C141.288910,602.689758 140.143524,594.356750 140.553391,585.410645 
	C140.468887,582.677917 140.352676,580.370972 141.105988,577.709961 
	C141.495575,577.133972 141.710419,576.950378 142.342606,576.724915 
	C145.186920,578.037231 145.081558,580.485413 145.417892,582.762878 
	C146.092697,587.332336 146.249680,592.049194 149.286926,596.359253 
	C151.969711,604.817932 154.544891,612.914429 157.340454,621.315918 
	C157.836868,623.700439 158.864975,625.453674 160.149612,627.447266 
	C161.248489,629.154602 161.547058,630.986572 163.397018,632.181396 
	C164.259750,632.759460 164.803482,633.196228 165.499542,634.001343 
	C168.024231,641.043884 168.883224,648.278870 172.711182,654.891479 
	C176.253006,666.258423 184.439697,673.592346 192.969101,681.076599 
	C196.226486,683.705261 198.618271,686.912354 202.773682,688.316162 
	C203.891006,689.278870 204.924713,689.611389 206.255890,690.074341 
	C206.818573,691.016602 206.860321,691.729919 206.578796,692.819397 
	C205.877625,694.053162 205.133713,694.760559 203.978256,695.588623 
	C200.373657,696.815186 197.060532,696.450439 193.752274,696.098267 
	C191.786423,695.889099 189.787949,695.305359 187.732117,696.994629 
	C185.435547,698.252075 184.068405,696.553223 182.397247,696.102661 
	C179.984985,695.452393 177.012299,693.888977 175.461807,697.101135 
	C173.677490,700.797729 176.033569,704.744141 180.033279,705.592590 
	C180.676163,705.729004 181.337143,705.779480 182.344742,705.950623 
	C183.660660,706.244568 184.589310,706.619995 185.985931,706.623779 
	C187.173111,706.667786 187.962021,706.783997 189.160263,706.957886 
	C202.897202,709.543030 216.341553,711.375916 230.117523,713.870239 
	C237.995544,716.443665 245.730255,717.223206 253.497681,717.361023 
	C264.391937,717.554321 275.300659,717.706726 286.580444,716.566528 
	C288.260498,716.463989 289.538116,716.541260 291.136292,716.310242 
	C293.810608,713.580078 292.158081,710.373596 292.638397,707.154663 
	C292.574799,706.458557 292.477692,706.082397 292.068848,705.552490 
	C291.645935,705.290833 291.460693,705.203369 290.986755,704.982178 
	C290.299194,704.639709 289.950439,704.365112 289.478485,703.722778 
	C289.130981,702.667847 289.189209,701.949768 289.683807,700.937988 
	C293.313507,699.266541 294.753143,696.526306 295.249329,693.077454 
	C295.667175,690.173340 296.200836,687.287231 296.925964,684.045105 
	C298.231079,678.072998 297.392151,672.625732 295.845703,666.830139 
	C295.920074,665.640442 296.169128,664.912292 296.952454,664.050293 
	C300.141846,664.724426 301.735352,663.279236 303.093231,660.897583 
	C305.804840,656.141602 307.057922,650.876465 308.850250,645.414795 
	C313.723480,636.744385 310.823029,629.148987 306.519562,621.350342 
	C305.333221,617.941467 304.107727,614.913696 303.894714,611.270874 
	C304.143616,609.644897 304.860199,608.877319 306.466370,608.594849 
	C309.288971,603.865784 311.664307,599.221497 309.963989,593.331421 
	C309.994263,592.474426 310.110992,591.998047 310.494812,591.221191 
	C311.112732,590.596313 311.575500,590.434509 312.450714,590.504150 
	C313.004028,590.733093 313.197205,590.880798 313.581360,591.335083 
	C314.258514,592.871460 314.326965,594.160217 314.336060,595.462646 
	C314.340729,596.128296 314.359589,596.611511 314.317139,595.946472 
	C314.316559,595.937256 314.575897,595.911377 314.810211,595.660278 
	C315.394104,594.782349 315.949951,594.198486 316.795471,593.402466 
	C317.736664,592.786255 318.430084,592.597778 319.470825,593.144714 
	C321.786713,596.804932 321.535004,600.499146 321.115082,604.566895 
	C320.750824,606.242126 319.408173,607.200806 319.806732,609.062805 
	C319.893127,609.849731 319.916016,610.302734 319.937256,611.098633 
	C322.473938,616.379211 322.803009,621.478455 321.557343,624.828918 
	C322.612915,619.090759 324.275787,611.478760 325.979767,603.530762 
	C326.109039,602.703064 327.190155,602.689697 326.685303,601.964050 
	C326.566772,601.793701 326.322449,601.941345 325.856445,602.079468 
	C325.446228,601.670288 325.325195,601.454224 325.098145,600.863953 
	C324.747162,598.310120 325.229523,596.236023 325.978058,594.220337 
	C326.387939,593.116638 327.026978,592.038940 328.338226,591.987793 
	C329.747925,591.932678 330.138855,593.212463 330.587128,594.232910 
	C331.397614,596.077942 331.485809,598.064209 331.476410,600.039246 
	C331.456848,604.150269 331.562256,608.252747 332.043243,612.731628 
	C330.950928,621.325806 331.333923,629.679382 329.443237,637.800903 
	C329.068481,639.410645 328.949677,641.080261 328.627930,642.764587 
	C331.056763,639.002930 333.089569,635.011169 335.349060,630.741211 
	C335.565369,630.182617 335.651764,629.958496 336.031311,629.075012 
	C338.567963,624.183228 340.177856,619.684509 341.992126,614.880737 
	C343.829437,610.385742 344.978607,606.045959 346.317535,601.766541 
	C346.692535,600.567993 347.107880,598.766602 348.736511,599.149841 
	C350.167297,599.486450 350.220581,601.240540 350.119385,602.568542 
	C349.879425,605.717346 349.254028,608.816650 348.674622,611.917480 
	C346.881409,621.514832 344.738647,631.041565 343.068909,640.848022 
	C365.249420,621.500854 383.111267,599.116699 393.102783,570.679382 
	C393.316040,569.948425 393.735687,569.653320 393.612030,569.459351 
	C392.486694,572.346008 390.698364,574.435547 388.729736,576.820007 
	C388.011658,577.581055 387.462067,578.009338 386.642639,578.665039 
	C385.988251,579.181824 385.594757,579.457764 384.873718,579.914062 
	C380.645325,581.813354 376.768524,583.234619 373.501526,578.423828 
	C373.435608,577.223145 373.755768,576.516968 374.476440,575.569458 
	C379.384521,571.435120 381.750885,566.508362 381.599731,560.468384 
	C381.511383,556.937866 382.613129,553.586182 383.037537,549.752930 
	C383.349274,548.911743 383.610413,548.476318 384.190125,547.804688 
	C390.949524,542.089722 397.921417,537.428040 406.305420,534.435852 
	C407.046448,534.101318 407.473877,533.929382 408.217834,533.652222 
	C412.182434,531.225647 409.288147,528.008301 409.660950,524.899048 
	C409.637878,520.905334 409.154907,517.343689 407.575928,513.621338 
	C406.716187,511.924561 406.285370,510.481720 406.161926,508.582703 
	C406.501648,504.753265 407.748169,501.210358 404.992737,497.741333 
	C404.531067,497.051239 404.364471,496.612488 404.260071,495.798401 
	C404.593231,493.489441 404.992767,491.521393 403.535645,489.415466 
	C403.283905,488.669983 403.213959,488.227356 403.221069,487.442322 
	C404.084961,484.579620 403.303223,482.442535 401.507446,480.204498 
	C401.236481,479.445984 401.166992,478.988983 401.154724,478.171478 
	C401.347717,474.743622 400.645660,471.753296 400.214966,468.378845 
	C400.014557,467.309967 400.026031,466.592682 400.251343,465.532928 
	C402.082062,462.908051 401.993866,460.398438 400.180756,458.489166 
	C397.955902,456.146362 397.749054,453.699524 398.383423,450.612274 
	C398.150970,450.210541 398.019562,450.069733 397.469238,449.494080 
	C396.782318,448.736938 396.529419,448.403198 396.107239,447.789246 
	C394.861603,445.681519 393.795563,443.846008 392.132904,442.139801 
	C390.860504,443.612030 391.477112,445.386627 390.832764,447.150757 
	C390.794250,447.957611 389.395477,447.960327 390.459869,449.022705 
	C390.752106,449.759125 390.797791,450.210205 390.691833,451.006714 
	C388.959473,453.695160 387.251404,452.758789 385.753082,451.274414 
	C384.265778,449.800934 382.572113,449.104340 380.259644,449.244904 
	C378.966003,450.475586 378.854950,452.027313 377.899994,453.536133 
	C377.554901,453.978973 377.394257,454.140839 376.929169,454.463989 
	C376.400360,454.674683 376.176025,454.724121 375.607880,454.762634 
	C374.211945,454.476807 373.225403,453.811737 373.559326,452.735016 
	C374.494873,449.718506 372.968353,452.367371 372.847321,452.434143 
	C371.511993,453.170441 370.191406,453.798676 368.528503,452.478271 
	C368.071014,451.539764 368.000214,450.859314 368.065918,449.831451 
	C368.191315,448.518494 368.814453,447.472748 367.475311,446.490845 
	C366.803101,446.193115 366.407288,446.035156 365.709137,445.732056 
	C364.396515,444.954315 363.942200,443.930542 363.503082,442.891846 
	C362.148407,439.687256 360.432129,439.480255 358.168823,442.550415 
	C357.574280,443.333344 357.102264,443.776581 356.366302,444.392273 
	C355.818970,444.857422 355.526398,445.141174 355.091736,445.712219 
	C354.839691,446.172760 354.750885,446.367645 354.554169,446.873840 
	C354.312866,447.632599 354.187195,448.082245 353.981079,448.907227 
	C350.546906,460.355774 351.716949,471.602203 352.756836,482.812775 
	C353.460510,490.399231 354.511230,497.953400 356.044312,505.850616 
	C356.395447,507.605713 356.253693,509.020782 356.917175,510.723633 
	C357.163788,511.672699 357.260773,512.225464 357.351746,513.206848 
	C358.197693,524.586304 359.261322,535.520935 360.345276,546.857666 
	C360.399261,548.034485 360.405762,548.811401 360.667786,549.927246 
	C360.891449,550.506470 360.980255,550.738159 361.202637,551.317505 
	C361.873901,554.495239 363.741455,557.256653 361.422485,560.331665 
	C358.237122,559.935486 358.118286,557.308411 357.166199,555.368530 
	C356.097443,553.191040 355.170929,550.943542 353.692047,548.551758 
	C353.332031,547.743408 353.224792,547.251282 353.196747,546.362732 
	C353.555145,544.225464 353.598022,542.480591 352.904083,540.367920 
	C352.300415,533.201843 351.724609,526.435425 350.678406,519.277710 
	C348.940430,499.282074 345.690857,479.859924 345.419495,460.172729 
	C345.366241,456.310303 345.749908,452.519409 347.231323,448.494507 
	C348.286865,446.177643 349.397858,444.335663 350.353790,442.410004 
	C351.648254,439.802368 351.047668,438.312469 347.703979,437.969055 
	C346.717743,437.708801 346.084503,437.460815 345.093628,437.230225 
	C340.520355,437.961121 336.877380,440.348175 332.819855,441.633514 
	C331.103210,442.177307 329.503357,443.148041 327.243774,442.811707 
	C326.436584,442.492004 326.082489,442.158844 325.767517,441.362671 
	C329.191925,436.682648 334.644379,435.739807 339.427673,432.958618 
	C342.103027,431.925537 344.561768,432.000305 347.004608,431.955566 
	C345.487671,431.973755 343.964600,432.156189 342.176880,431.456482 
	C340.712097,429.417267 341.818268,427.867828 342.655029,425.928802 
	C344.967102,421.026215 341.699127,417.162567 341.163177,412.572876 
	C341.800995,410.029816 340.401398,407.809570 341.497131,405.337738 
	C342.726593,404.396698 343.679993,404.781799 344.375916,405.510620 
	C347.331696,408.605988 351.046387,409.434296 355.105652,409.330597 
	C350.284332,408.799225 344.944183,409.118591 343.945740,402.084534 
	C344.024231,400.117126 346.138519,399.642395 346.080688,397.631226 
	C346.049286,396.619843 346.147522,395.958557 346.595642,395.048004 
	C347.313293,394.387695 347.903992,394.207733 348.770996,394.267609 
	C348.985046,394.302399 349.207581,394.465515 349.207581,394.465515 
	C349.207581,394.465515 349.424866,394.318604 349.275208,394.250183 
	C348.235474,393.525513 347.228577,393.016998 346.322754,391.838745 
	C345.029388,388.294708 341.898529,385.633942 343.423035,381.337585 
	C343.998718,380.658081 344.444366,380.445740 345.323456,380.399719 
	C347.700775,381.022827 348.077850,383.047760 349.155548,384.448059 
	C351.814789,387.903290 354.861877,390.426331 359.910278,389.312500 
	C354.332428,388.375916 349.498108,386.746033 347.393280,380.652130 
	C347.055847,379.639099 346.962830,378.936737 346.947937,377.867981 
	C347.000275,377.278015 347.040955,377.044128 347.195435,376.473022 
	C347.718018,375.266479 348.363586,374.578522 349.278381,373.658875 
	C350.091827,372.968903 350.708252,372.636414 351.750275,372.438049 
	C352.316101,372.484009 352.534424,372.547363 353.000244,372.837708 
	C353.919067,374.495911 352.652985,376.360565 354.529877,377.618347 
	C355.177826,377.596039 355.545074,377.501099 356.195496,377.279877 
	C357.302887,376.958038 358.134064,376.947327 359.276947,377.049713 
	C360.596985,377.240753 361.555664,377.078949 362.732483,376.451782 
	C363.530426,376.068268 364.077057,375.859772 364.488281,375.140961 
	C364.199829,374.294678 363.642822,374.042664 362.817230,373.582642 
	C360.291229,371.672699 358.306152,369.692566 356.421967,367.119354 
	C355.986359,366.091644 355.871094,365.359772 355.837524,364.235962 
	C356.037170,362.282349 356.421112,360.754028 357.500702,359.543945 
	C358.362671,358.577850 359.098419,358.853577 359.806030,360.270721 
	C363.377686,363.352295 366.040863,361.304657 368.668274,359.427002 
	C366.016602,360.335083 363.592590,363.031128 360.107574,360.447845 
	C359.491638,359.594818 359.363647,358.908051 359.243225,357.879578 
	C359.343719,357.311890 359.417694,357.092102 359.681152,356.584656 
	C360.034058,356.140015 360.197571,355.983063 360.649994,355.653687 
	C361.353912,355.339264 361.778381,355.239288 362.525116,355.159760 
	C363.447327,355.040131 364.033722,354.877350 364.821716,354.355621 
	C367.128113,352.677795 369.129211,351.172485 367.218933,347.938049 
	C366.299652,346.756592 365.365967,346.056519 364.428253,344.867310 
	C363.845917,343.628845 363.719971,342.645874 363.595215,341.278473 
	C363.278931,338.598633 362.170288,336.548157 361.564545,334.345856 
	C361.175446,332.931183 360.624512,331.307434 361.995880,330.233917 
	C363.272675,329.234467 364.419769,330.468628 365.524048,331.063141 
	C368.287292,332.550781 371.138062,333.694519 374.718750,333.511719 
	C376.740692,333.544159 378.145325,332.335876 379.571411,332.281616 
	C378.371582,332.110657 377.236938,333.256775 375.529907,333.425751 
	C373.607300,333.152466 371.638947,334.360626 370.481628,331.904724 
	C371.118317,329.065308 373.560883,328.352539 375.434387,326.577759 
	C382.007690,323.944855 387.612793,320.837952 391.832947,315.167633 
	C395.625610,310.071686 402.048645,308.857910 408.055634,306.776276 
	C404.190216,305.681793 400.944397,308.107056 397.105591,307.457275 
	C396.123932,306.807129 395.752258,306.153168 395.763733,304.952057 
	C400.222839,300.485901 405.543793,300.047424 411.497284,300.511383 
	C413.730621,300.702667 415.618927,300.099396 416.563721,300.487030 
	C415.954041,300.486664 414.453247,300.488434 412.564758,300.488159 
	C410.306610,300.530426 408.451660,300.509644 406.692230,298.861389 
	C405.865356,296.676117 406.880493,295.405762 408.313110,293.905518 
	C408.852997,293.501801 409.088287,293.367828 409.704529,293.095764 
	C410.864014,292.758453 411.661102,292.703094 412.845154,292.618469 
	C419.065552,292.066040 424.801422,293.251373 430.574280,293.795410 
	C428.941589,293.749603 426.833069,294.763458 426.041138,292.609528 
	C425.395935,290.854706 427.092590,289.629578 428.393463,288.616302 
	C430.103058,287.284576 432.065125,286.375244 434.277710,285.483643 
	C434.488037,285.404724 434.796753,285.404266 434.668579,285.298737 
	C431.836548,285.862335 429.222656,286.786835 426.389160,288.117737 
	C425.675446,288.511139 425.275879,288.756775 424.589417,289.231201 
	C422.340057,290.830566 420.232208,291.516998 417.473328,290.710571 
	C416.195221,289.945526 415.728577,289.034332 415.379761,287.628479 
	C415.351715,286.466064 415.628632,285.779053 416.360992,284.916199 
	C417.417816,284.143311 418.307159,283.993195 419.549255,284.071472 
	C420.231354,284.231873 420.600708,284.361664 421.237610,284.496399 
	C421.687225,284.408203 421.861786,284.335938 422.293701,284.128845 
	C422.907043,283.803253 423.264832,283.615906 423.911835,283.281799 
	C424.400604,283.039734 424.601959,282.947815 425.119751,282.740601 
	C430.549377,280.556274 435.579285,278.120392 441.531738,279.003967 
	C441.699493,278.999695 441.855011,279.148834 441.769226,279.051208 
	C440.845245,278.994812 440.023346,278.939972 438.999969,278.322571 
	C438.521149,277.675476 438.436432,277.219330 438.576508,276.390686 
	C439.059174,275.678040 439.489136,275.441589 440.354004,275.280060 
	C441.948608,275.386932 443.147278,275.708557 444.753540,275.686737 
	C447.599426,275.843781 449.781769,276.964630 452.372742,277.955017 
	C453.953186,278.873871 454.913452,280.048584 455.935944,280.500366 
	C456.795868,281.095093 456.778625,280.606201 456.570648,280.575531 
	C455.421814,280.406067 454.623413,279.502594 453.509827,278.529297 
	C447.953247,274.752625 442.288330,273.628967 435.780640,275.734558 
	C435.184723,275.738281 434.945709,275.711395 434.366974,275.557373 
	C432.782440,274.538635 432.291443,273.136688 431.463684,271.527374 
	C431.243469,270.957672 431.171082,270.723236 431.036133,270.124939 
	C430.915619,269.013794 431.008392,268.286011 431.432098,267.258057 
	C431.788300,266.778412 431.968414,266.618958 432.470367,266.305054 
	C435.745300,265.342377 439.225037,267.391876 442.040527,264.264008 
	C442.478546,263.919128 442.668732,263.802185 443.182678,263.614929 
	C443.722076,263.570831 443.937775,263.597076 444.734009,263.872620 
	C445.861328,264.389130 446.412964,264.642792 447.325104,264.763550 
	C448.449036,264.848969 449.267212,264.927399 450.356262,265.231323 
	C451.467499,266.150757 451.638458,265.516571 452.040283,264.597443 
	C452.511963,264.270721 452.725830,264.169098 453.292725,263.978210 
	C454.654724,263.754944 455.657135,263.841431 457.044830,264.049377 
	C460.275604,265.091187 463.320496,264.189880 466.553589,265.230042 
	C467.665558,265.898773 468.089172,266.582214 467.987640,267.841400 
	C464.409393,270.806396 460.343658,268.125916 456.455566,269.730377 
	C455.447876,269.952637 454.803528,270.088593 454.125824,270.031311 
	C453.597198,269.986633 453.153015,269.436676 452.569855,269.782562 
	C453.091644,269.929718 453.348022,270.323547 453.557556,271.119324 
	C453.532440,272.557007 454.088898,273.447327 455.143097,273.354797 
	C455.995850,273.279999 455.042603,272.767548 454.870117,272.140808 
	C454.757416,270.763031 455.462372,270.242523 456.701630,269.764709 
	C457.724091,269.471924 458.399994,269.236359 459.469910,269.181335 
	C460.754486,269.363586 461.660034,269.665741 462.976562,269.652069 
	C472.839386,269.978058 478.682495,276.375916 484.895020,282.791626 
	C486.379089,284.618347 488.110748,285.678070 489.678467,287.312286 
	C490.215576,287.436157 490.050629,288.249054 490.380341,287.747803 
	C488.842682,286.327026 487.411438,285.100281 485.814148,283.558533 
	C485.518372,283.079956 485.430481,282.870575 485.281677,282.326050 
	C485.390045,280.428345 485.088531,278.840973 485.644653,276.998322 
	C489.484100,275.790131 490.335022,279.874603 493.278717,280.912323 
	C493.735626,281.215210 493.909027,281.347778 494.306488,281.714111 
	C495.137482,282.783813 495.667908,283.695099 496.945129,284.294556 
	C498.211639,285.174774 498.885132,286.259796 500.223755,287.043304 
	C501.438873,287.658112 502.472595,287.759003 503.810974,287.960175 
	C505.387085,288.309143 506.642548,288.685211 508.268188,288.095032 
	C509.761322,287.804932 510.914001,287.803741 512.367798,288.301392 
	C513.828796,289.063995 514.315430,290.658417 516.247681,290.660278 
	C519.161865,291.156891 521.696472,291.769135 524.534302,292.632629 
	C530.142212,294.180481 534.420471,297.425537 539.114502,300.608978 
	C539.571777,300.919403 539.745117,301.052673 540.152710,301.407349 
	C540.949280,302.227722 541.363464,302.953125 542.227661,303.671814 
	C542.627502,303.960693 542.785217,304.078613 543.171997,304.381104 
	C543.544556,304.697693 543.688110,304.829742 544.029175,305.174103 
	C544.344604,305.536682 544.462646,305.687012 544.740479,306.071533 
	C545.100281,306.618835 545.300232,306.931915 545.663940,307.463562 
	C545.940002,307.824860 546.052307,307.967621 546.336914,308.322052 
	C546.625061,308.675018 546.741028,308.816254 547.027466,309.175293 
	C547.305115,309.545319 547.412170,309.697601 547.668579,310.087463 
	C548.014465,310.646301 548.214661,310.965363 548.587585,311.518372 
	C548.858459,311.923828 548.960510,312.092896 549.168884,312.515625 
	C549.560974,312.679901 549.108887,313.874695 549.760315,313.061371 
	C549.936340,312.841644 549.947876,312.455994 550.399170,311.990448 
	C550.842346,311.721375 551.041931,311.655090 551.553162,311.626099 
	C552.499756,312.120972 552.550598,312.941559 553.035400,313.627502 
	C553.059875,313.747375 553.214722,313.526764 553.070435,313.415131 
	C552.236450,311.145142 550.559143,309.204041 551.675293,306.412354 
	C554.590332,305.528748 555.024414,307.854706 556.077881,309.391235 
	C556.961182,310.679504 556.834290,312.664307 558.717041,313.309418 
	C560.841003,306.700195 559.577759,304.774261 551.629700,302.753357 
	C551.124634,302.418884 550.947144,302.246338 550.685486,301.707581 
	C550.747864,300.249634 551.445251,299.515167 552.549011,298.617767 
	C553.109741,298.297791 553.348022,298.195099 553.962158,297.991882 
	C555.359741,297.706818 556.390747,297.713501 557.804810,297.765259 
	C568.901001,300.574707 573.637207,309.170166 569.766663,319.274658 
	C568.593262,322.337921 569.354675,324.350739 571.151917,326.925598 
	C575.292725,332.857910 581.004639,336.016510 588.057129,338.033783 
	C596.365417,344.709198 597.128357,350.482697 590.960815,359.751526 
	C589.979126,360.724426 589.055237,361.088348 587.896973,361.737183 
	C584.169800,365.388275 583.404114,370.427155 580.230103,374.419952 
	C579.605469,375.369263 579.030029,375.947540 578.379395,376.814758 
	C577.945190,377.786560 578.431213,378.546234 577.999023,379.552551 
	C576.314270,381.537048 573.716797,381.040863 572.097656,382.579498 
	C576.197449,386.434845 580.669495,386.591827 585.280273,383.140442 
	C586.726807,382.057617 587.633972,380.307861 589.848511,379.845703 
	C591.866943,383.132721 589.733765,385.173523 587.896179,387.227234 
	C586.583313,388.694519 584.751892,389.552307 582.918579,390.993164 
	C582.392273,391.322174 582.170715,391.434967 581.592041,391.642151 
	C580.992676,391.753876 580.750427,391.771210 580.149780,391.760040 
	C576.146362,390.944366 572.120483,391.758636 568.820618,389.226654 
	C570.355103,390.984467 571.912476,392.660583 574.278076,393.349731 
	C576.468384,393.987823 578.936218,393.267273 581.115967,395.060486 
	C579.568909,400.008514 575.695007,399.172058 572.356873,399.167450 
	C572.677490,399.343384 571.742310,398.973206 572.034241,399.144592 
	C580.122070,403.893005 580.986023,409.558807 574.000977,416.387268 
	C573.116333,416.538116 572.634644,416.430542 571.965698,415.875671 
	C571.416138,413.437500 573.152710,411.928619 573.477722,409.973785 
	C573.858276,407.685272 573.561584,405.530304 571.533508,404.214233 
	C569.309753,402.771149 569.418823,406.355927 567.362427,406.250244 
	C565.486145,404.898041 565.195740,402.658539 563.326172,401.199524 
	C562.982727,400.751221 562.864319,400.515686 562.795105,400.261780 
	C562.713501,399.962830 562.678650,400.036591 562.790405,400.741943 
	C563.255981,401.961243 563.474487,402.958435 563.655945,404.300659 
	C563.147278,406.722961 561.969116,406.968689 560.423828,405.677246 
	C559.247131,404.693909 558.744629,403.216797 558.009705,401.872406 
	C557.688904,407.121185 554.195801,411.284210 553.131592,416.622742 
	C552.499695,418.248230 551.583618,419.337280 550.976685,420.977661 
	C549.301331,424.770996 548.449524,428.342865 549.209900,432.516968 
	C549.091980,434.082550 548.717896,435.211548 548.009766,436.596252 
	C545.950684,439.476959 542.631592,439.267273 539.958008,441.017395 
	C539.529236,441.355438 539.360046,441.493896 538.933960,441.835999 
	C536.778015,443.253448 535.477661,444.904083 534.845764,447.436462 
	C534.133240,448.966156 532.994324,449.696198 531.870911,450.880646 
	C531.471863,451.251709 531.304871,451.392029 530.868286,451.716492 
	C529.011414,452.668335 527.798462,453.876831 526.466064,455.456818 
	C525.555359,456.324188 524.739563,456.689880 523.537537,457.024384 
	C519.915100,460.806152 521.077454,465.409698 520.800781,469.996979 
	C521.184814,470.739960 521.392029,471.176941 521.729065,471.970825 
	C522.030212,472.816864 522.148193,473.321442 522.273926,474.235779 
	C522.412781,476.854034 522.562866,479.076691 521.518494,481.580811 
	C521.046143,482.120148 520.811707,482.295929 520.150146,482.591064 
	C519.114624,482.736572 518.539734,482.609741 517.690552,482.001526 
	C515.452271,468.366760 513.820923,455.061646 517.294312,441.344543 
	C520.260254,435.982727 526.019836,434.501068 530.018555,430.344391 
	C531.578674,429.176361 532.851746,428.278656 534.793457,427.838623 
	C535.942566,427.669830 536.712646,427.628723 537.859741,427.609375 
	C542.728333,428.719116 544.346619,426.782104 545.619812,422.396881 
	C548.665771,411.906128 551.589722,401.469086 551.859375,390.469971 
	C551.504822,395.867493 550.929321,401.232971 549.498535,406.477722 
	C548.975403,408.395081 548.632324,410.404572 546.094971,411.173279 
	C544.083252,408.833282 544.584839,406.305023 544.918762,403.858368 
	C545.413696,400.231262 546.049500,396.617340 546.408203,392.977448 
	C547.147278,385.478546 546.476624,384.663971 538.819214,383.097046 
	C534.400818,378.078400 528.925415,374.943451 523.936035,371.204651 
	C523.542114,370.909454 523.057129,370.317078 522.705994,370.493134 
	C516.944031,373.382263 514.012634,368.597992 510.033844,365.739349 
	C509.078766,364.937592 508.941315,363.360046 507.172241,364.384644 
	C506.227539,364.632782 507.077362,364.832672 506.433167,364.731689 
	C499.820587,363.695496 494.281769,366.434540 488.858765,369.638184 
	C488.293213,369.972229 487.603394,370.041962 486.604004,370.203430 
	C483.795593,370.109680 481.747253,370.863831 480.055450,373.177979 
	C479.570618,373.432251 479.361877,373.496307 478.831451,373.553375 
	C477.897461,373.387146 477.422607,373.006317 476.764160,372.413696 
	C476.428864,372.126099 476.298737,372.015564 475.979034,371.758972 
	C475.789459,371.612885 475.400085,371.401184 475.195984,371.361450 
	C474.991882,371.321747 474.621002,371.489471 474.520203,371.668884 
	C474.457367,372.160950 474.540405,372.461304 474.717468,373.024902 
	C474.782440,374.148712 474.445099,374.860077 473.701294,375.729309 
	C471.934296,377.109924 472.418976,379.077728 471.497070,380.816345 
	C471.013550,381.605469 470.640198,382.092621 470.218323,382.898865 
	C470.008423,383.344116 469.924713,383.520996 469.704834,383.954956 
	C469.182007,384.857056 468.718689,385.455414 468.295227,386.393921 
	C468.126892,386.816559 468.060791,386.985443 467.776154,387.646820 
	C467.395142,388.455261 467.230621,388.770142 466.949951,389.324219 
	C466.755615,389.723999 466.675537,389.883545 466.470337,390.281189 
	C466.177002,390.844513 466.009918,391.170288 465.716614,391.755035 
	C465.488525,392.182648 465.387634,392.351837 465.110565,392.764832 
	C464.673676,393.331757 464.399963,393.643494 463.889496,394.182068 
	C459.102325,398.798431 453.313568,400.754883 447.224579,402.842926 
	C446.793182,403.205505 446.614838,403.343445 446.154297,403.666626 
	C443.461517,404.958405 441.069916,406.092773 439.189240,408.535522 
	C438.859711,408.985413 438.722473,409.161926 438.373291,409.598907 
	C436.676361,411.816681 434.952423,413.616241 433.970459,416.308838 
	C433.718170,416.818939 433.603973,417.017120 433.288055,417.492920 
	C431.243866,420.369324 431.516724,423.399261 431.390198,426.664490 
	C431.613068,427.866760 432.177429,428.569183 432.580933,429.704773 
	C432.675690,430.253784 432.685333,430.478333 432.649902,431.037659 
	C431.618011,436.116486 433.092255,440.960297 432.169983,446.002625 
	C432.404022,446.512360 432.492004,446.720551 432.682678,447.254242 
	C434.102051,450.422455 432.415405,452.792877 431.300537,455.060669 
	C428.785828,460.175903 425.926422,465.121735 424.790436,471.113403 
	C424.290710,471.686432 423.995636,471.999115 423.475037,472.525146 
	C423.054474,473.027649 422.802795,473.147522 422.506073,473.100830 
	C422.192749,473.051544 422.283966,473.083069 422.998505,472.993164 
	C423.512268,472.492767 423.807709,472.203003 424.370178,471.734558 
	C425.358185,471.516083 425.886169,471.806030 426.174316,472.809906 
	C423.834625,475.748474 427.016907,479.815765 423.518616,482.405975 
	C420.332062,485.139038 423.297974,487.723785 424.225311,488.877747 
	C426.232208,491.375153 427.365967,494.572845 430.308563,496.721008 
	C430.790924,497.006500 430.983124,497.122467 431.467773,497.404602 
	C433.135101,498.377930 435.498260,498.087830 435.759125,500.100586 
	C436.493195,505.764740 439.812103,504.448090 443.560486,503.153137 
	C444.081604,503.216156 444.281616,503.267303 444.739685,503.468201 
	C445.496735,503.994354 444.890289,504.684418 445.338531,504.787231 
	C445.369476,504.354828 445.467682,504.191376 445.775574,503.820221 
	C446.174347,503.540924 446.363373,503.469330 446.861511,503.385773 
	C447.589294,503.457611 447.955658,503.647034 448.426666,504.207092 
	C448.652649,506.399506 448.903778,508.229034 450.978882,509.571381 
	C452.007782,511.102722 450.024902,511.728210 450.645844,513.178955 
	C451.978088,519.136719 456.966766,520.701111 461.217346,523.018005 
	C462.607269,523.775635 464.168762,523.560181 465.499725,522.782532 
	C468.932983,520.776733 472.931519,519.992249 476.286896,517.930847 
	C479.961700,515.673218 483.015472,515.744690 486.029602,519.431885 
	C486.543915,520.040405 486.765747,520.433777 487.043823,521.165527 
	C487.436554,523.131653 488.743835,523.839233 490.264374,524.816040 
	C490.881073,525.674805 491.070007,526.352356 491.210846,527.422363 
	C491.255798,528.526367 491.148804,529.249390 490.823975,530.291199 
	C490.573181,530.814270 490.449768,531.006409 490.082733,531.423828 
	C489.051361,532.233887 488.071075,532.586487 487.503876,533.778015 
	C487.433228,534.206360 487.435608,534.381897 487.418793,535.350342 
	C487.282196,536.479980 487.146698,536.809448 486.882446,537.376221 
	C486.680786,537.776855 486.592590,537.934082 486.345703,538.312500 
	C486.064758,538.669434 485.942474,538.805176 485.616150,539.127380 
	C485.264069,539.426086 485.116058,539.538269 484.736420,539.807251 
	C484.187866,540.172363 483.873566,540.384644 483.329620,540.780945 
	C482.778259,541.206787 482.450897,541.440979 481.852264,541.834656 
	C480.066040,542.793274 478.556061,543.612000 476.531738,543.973755 
	C475.028168,544.123352 473.836884,543.492615 472.398865,544.182861 
	C470.858002,545.656067 471.507385,547.735962 469.972229,549.247925 
	C467.025177,549.704224 467.044861,547.400757 466.282715,545.881287 
	C465.589417,544.499084 464.805023,543.010010 463.079407,543.195679 
	C461.211731,543.396545 461.072388,545.246826 460.847870,546.666321 
	C459.393860,555.858643 457.660370,564.989380 455.182922,573.967896 
	C454.758759,575.505066 454.351013,577.047363 453.730652,578.522461 
	C457.350525,572.163757 460.362244,565.566833 461.618652,558.280151 
	C461.759735,557.461975 461.886108,556.634888 462.132996,555.843872 
	C462.805939,553.687988 462.942474,550.510986 465.874115,550.750305 
	C469.052887,551.009888 468.250580,554.260803 468.338409,556.410278 
	C468.723114,565.824951 465.874451,574.408020 461.170166,582.833618 
	C461.045776,583.614014 460.581848,583.915466 460.652313,584.389221 
	C460.820923,584.118225 460.945312,583.827148 461.125946,583.192993 
	C462.662231,579.445190 465.087891,577.494629 468.949066,577.828430 
	C471.892731,578.082947 473.576599,579.440674 471.665100,582.366089 
	C469.761444,585.279480 469.384277,588.035400 470.634857,591.300476 
	C471.696686,594.072754 470.304321,596.458618 468.585052,598.634155 
	C466.395081,601.405334 463.316864,603.174500 460.220703,606.055237 
	C467.708557,605.775574 473.757721,602.783813 480.365967,600.463989 
	C481.215515,600.242310 481.716278,600.217896 482.593628,600.376221 
	C483.676819,600.853394 484.179535,601.426270 484.664124,602.497314 
	C485.004120,604.174316 484.606140,605.363953 483.893402,606.848877 
	C478.069580,614.356262 472.036896,621.160095 464.204285,626.597229 
	C463.642975,626.869812 463.337891,626.965759 463.078857,627.136719 
	C462.522644,627.503662 462.669861,628.145874 462.898346,627.519592 
	C463.126831,626.893311 463.856873,627.658936 463.523682,627.294800 
	C464.428101,627.104736 465.041199,627.186401 465.928467,627.591064 
	C466.974182,628.806641 467.240265,630.288086 466.452423,630.974426 
	C462.103485,634.763306 464.810028,638.643677 466.041779,642.531128 
	C466.337982,643.465942 466.614532,644.405579 466.702026,645.747559 
	C466.031982,648.987732 463.705750,649.679199 461.290680,650.548889 
	C459.242249,651.286499 456.463287,650.505493 455.080261,653.481323 
	C454.660828,654.184387 454.373169,654.547791 453.795563,655.106445 
	C452.634399,655.941589 451.615784,656.362366 450.430298,657.143066 
	C449.512726,657.500549 448.864349,657.477905 447.894287,657.424438 
	C446.508789,657.424255 445.472778,657.560303 444.285645,658.309570 
	C442.842773,661.075012 444.053406,662.984863 446.052490,664.940674 
	C448.901733,666.610229 450.919189,668.703552 452.973083,671.251526 
	C453.615021,672.022522 453.965149,672.587524 454.413391,673.474731 
	C454.669281,674.189270 454.744507,674.612732 454.752563,675.361267 
	C454.630798,676.499390 454.577606,677.321350 454.831818,678.457642 
	C454.979523,679.438904 454.960510,680.102844 454.841187,681.109009 
	C453.466125,686.892090 455.782135,691.483704 458.451172,696.327026 
	C459.539276,697.660034 459.986328,698.832825 459.651306,700.577576 
	C455.593719,704.944824 455.149017,704.902161 449.029480,699.688599 
	C448.496826,698.972229 448.316071,698.504272 448.199768,697.635254 
	C448.275177,691.540771 445.038391,686.914368 442.756561,682.085999 
	C440.287109,676.860535 437.526703,671.786560 435.502380,666.341492 
	C433.238068,660.250977 431.656342,659.185913 425.173187,659.477844 
	C421.898621,659.625305 418.798706,657.208923 415.280334,659.223999 
	C414.402863,660.406128 414.211060,661.498169 413.883392,662.902771 
	C413.201904,664.991150 412.982117,666.954102 410.880737,668.228516 
	C408.807465,668.718384 407.061249,669.170532 404.974548,669.081299 
	C404.049316,667.785217 404.439972,666.649353 404.609344,665.177124 
	C404.459290,663.340515 405.861816,661.121643 402.516663,660.983276 
	C401.757965,661.093079 401.325623,661.147888 400.576355,661.241516 
	C399.120300,661.313293 398.299774,661.844055 397.573486,663.103271 
	C393.934753,665.878540 391.097107,668.937012 388.796509,672.933960 
	C387.981964,673.885437 387.298340,674.491638 386.420654,675.393799 
	C377.137817,684.693176 369.119537,694.665527 360.541107,704.134338 
	C347.551575,718.472046 333.906403,732.017212 317.061401,741.874084 
	C310.458862,745.737610 304.657867,750.267212 302.005005,757.809204 
	C301.589569,758.990295 300.482544,760.081848 301.676392,761.635132 
	C303.494751,762.210083 303.674652,760.992249 304.215118,759.713135 
	C305.165039,758.121155 306.376129,757.479736 308.138916,757.132629 
	C310.069580,757.028076 311.935272,758.183777 313.282288,755.819702 
	C314.757263,754.329041 316.087921,753.169189 317.879089,752.047119 
	C318.573059,751.663269 318.972717,751.443726 319.668030,751.032349 
	C321.653839,749.853271 323.333923,748.833679 325.783630,749.390869 
	C327.028046,750.095276 327.558533,750.915649 327.809570,752.307983 
	C327.793243,752.906311 327.753387,753.139343 327.568481,753.686157 
	C326.203796,755.271362 324.309570,754.997986 322.759796,756.017090 
	C322.567902,756.081360 322.197144,756.091125 322.397095,756.106323 
	C323.455170,755.919495 324.203979,755.395935 325.398071,755.262207 
	C326.818909,755.447632 327.797638,755.315369 328.599487,753.904297 
	C333.957245,750.051758 340.085815,748.833496 345.796387,746.725098 
	C356.342377,742.831360 366.886383,738.843262 378.219299,736.336914 
	C380.349121,738.360291 378.817383,739.899048 377.844666,741.270386 
	C371.384888,750.377747 365.943909,760.104858 360.133484,770.024963 
	C357.062439,773.545349 355.779541,777.683716 353.272308,781.798218 
	C355.635376,779.124146 357.446960,776.774963 359.164276,773.918945 
	C365.157349,766.884949 370.127899,759.469238 376.446594,752.697754 
	C376.978760,752.408264 377.207062,752.320312 377.799866,752.176819 
	C378.655701,752.134583 379.132996,752.220825 379.890137,752.600464 
	C381.373566,755.284912 379.513214,756.898682 378.405548,758.627441 
	C373.316437,766.569763 369.318787,775.062439 365.473541,783.656372 
	C368.753723,779.922913 372.136169,776.305603 374.736816,771.646118 
	C381.180145,763.351868 385.973175,754.169373 394.047638,747.635559 
	C395.070312,746.808044 395.998993,745.856873 397.687286,745.499878 
	C401.132050,747.195190 399.131012,749.190613 398.197174,750.902466 
	C392.876190,760.656738 387.545380,770.412415 380.550659,779.124390 
	C379.824463,780.028870 379.195770,781.011475 378.613739,782.017090 
	C378.119751,782.870667 377.344696,783.819214 377.859680,784.762451 
	C378.561188,786.047363 379.908081,785.467834 381.019897,785.345337 
	C390.187775,784.335022 397.751373,780.758545 403.134003,772.793640 
	C408.235474,765.244751 414.254395,758.331726 419.262695,750.249023 
	C419.978302,749.374390 420.610748,748.989502 421.687531,748.631836 
	C422.851135,748.560547 423.522247,748.868896 424.320557,749.693420 
	C425.503845,752.380432 424.076294,754.136780 422.896881,755.890503 
	C419.131317,761.489441 415.656708,767.295044 411.083130,772.751465 
	C409.353516,774.910706 407.640289,776.639160 406.173065,778.846924 
	C406.015686,779.000305 405.821716,779.326965 405.821716,779.326965 
	C405.821716,779.326965 406.116943,779.161011 406.393555,779.050781 
	C415.665863,777.511536 423.737366,773.403503 432.471375,770.057007 
	C434.858643,769.638489 436.860413,769.241333 439.137878,768.296265 
	C441.080078,768.106567 442.290527,768.531799 442.658722,770.660889 
	C442.069153,773.072021 440.388550,773.877808 438.721741,774.629517 
	C414.397400,785.600037 389.052795,792.730713 362.275055,793.395508 
	C339.194397,793.968445 316.648407,797.018799 294.782043,804.626892 
	C289.114563,806.598816 283.986542,809.727417 277.963501,811.809082 
	C276.973907,811.713501 276.471161,811.480896 275.828308,810.743896 
	C275.724609,807.312500 278.650208,806.712463 280.647308,804.763794 
	C288.368347,801.232361 289.710510,795.214966 289.650848,787.740173 
	C289.583435,779.291992 290.605835,770.816650 291.123230,762.354980 
	C291.844940,750.552490 290.225006,738.774963 289.987610,726.972656 
	C289.962372,725.718445 290.156006,723.794556 287.645325,723.403687 
	C274.846344,724.329834 262.516327,725.787537 250.049377,725.567688 
	C243.382462,725.450134 236.731262,725.107056 230.221909,724.013123 
	C214.501556,721.371216 198.752151,718.888000 182.670959,715.931763 
	C181.798080,715.629761 181.307571,715.472412 180.462708,715.273438 
	C179.740402,715.063049 179.352478,714.973083 178.961929,715.137573 
	C178.927887,715.151978 179.115112,715.291931 179.625916,715.699829 
	C180.003906,716.751587 179.994507,717.501404 179.806122,718.652039 
	C179.788239,729.580261 181.352005,740.002747 182.039291,750.489807 
	C182.189697,752.784607 182.546951,755.071289 182.555267,757.798096 
	C182.948730,761.152527 183.356689,764.090454 183.832184,767.414429 
	C185.598969,783.426025 190.070984,798.374023 194.986557,813.210815 
	C200.946823,831.200806 207.284439,849.058777 213.928482,866.806946 
	C216.207474,872.894714 219.022858,878.725586 223.088089,884.306213 
	C223.550690,884.734375 223.741638,884.898376 224.179276,885.343262 
	C224.561981,885.828857 224.697998,886.033569 225.009033,886.557739 
	C230.262375,895.577209 236.750381,903.310730 242.259338,912.097290 
	C240.233017,915.286072 237.965973,913.739258 235.838730,912.659973 
	C234.086288,911.770752 232.628113,910.436829 231.227936,908.586182 
	C230.633148,908.109985 230.310928,907.832947 229.805573,907.330078 
	C229.343033,906.879089 229.059128,906.665222 228.475540,906.509949 
	C228.036331,906.551147 227.858841,906.586304 227.402420,906.646240 
	C226.933655,906.645752 226.743835,906.620422 226.082886,906.260864 
	C225.539627,905.742004 225.467484,905.557312 225.364624,905.076111 
	C225.394150,903.798157 225.747589,902.867798 225.860229,901.606201 
	C225.901245,901.133362 225.919952,900.945862 225.981506,900.483398 
	C226.066605,900.034119 226.108841,899.859802 226.229416,899.443787 
	C226.538544,898.588562 226.244141,898.301758 225.393753,898.053345 
	C218.079056,890.839905 213.175232,882.340698 209.259964,873.296509 
	C205.427002,864.442444 202.315765,855.293701 199.196198,845.799438 
	C200.004318,841.152344 196.968567,838.328308 195.010010,834.757996 
	C194.590057,834.129822 194.434967,833.737915 194.351425,833.019226 
	C194.414841,832.177856 194.628204,831.664551 194.637253,830.880493 
	C194.584213,830.642395 194.374741,830.205078 194.253479,829.995361 
	C193.988266,829.503906 193.861465,829.214661 193.609192,828.740723 
	C193.466568,828.563416 193.014801,828.485352 193.014801,828.485352 
	C193.014801,828.485352 193.304443,828.861694 193.189941,829.114868 
	C192.931137,829.502808 192.786819,829.637695 192.389130,829.949341 
	C189.445450,831.488220 188.307953,834.076477 187.125305,836.589233 
	C184.828964,841.467896 181.887909,846.042969 180.113800,851.541687 
	C179.453766,853.390076 178.078339,854.311768 177.079758,855.920898 
	C176.603149,856.812622 176.311798,857.423584 175.961792,858.396484 
	C175.340515,859.868713 174.711151,860.904724 173.258087,861.709717 
	C172.151825,862.023010 171.405899,861.984131 170.340179,861.566650 
	C169.688522,861.008118 169.471649,860.580505 169.409393,859.737061 
	C169.614288,858.215088 171.121033,857.023254 169.947723,855.942383 
	C169.020721,855.088379 168.400009,856.483093 167.501038,857.297913 
	C164.102081,859.914001 162.768661,864.128662 158.623245,865.979126 
	C154.355759,867.691040 151.874847,871.503418 148.685944,873.428528 
	C143.892227,876.322632 146.488968,878.929321 146.696808,882.215759 
	C146.324905,883.224731 145.773560,883.579163 144.769653,883.815552 
	C144.234222,883.847290 144.021698,883.834595 143.504333,883.745483 
	C142.825119,883.509033 142.479233,883.302795 142.017365,882.796265 
	C141.840591,882.372925 141.817993,882.188110 141.764832,882.281006 
	C141.726715,882.746033 141.719177,882.933289 141.650055,883.396362 
	C141.509979,883.843933 141.431519,884.015686 141.191650,884.419373 
	C140.689148,885.100769 140.334091,885.540710 139.947845,886.309448 
	C139.716919,886.740662 139.617218,886.911194 139.338913,887.321777 
	C138.628387,888.166443 138.042709,888.723267 137.371948,889.618713 
	C137.066055,890.040405 136.942734,890.210083 136.631714,890.636047 
	C136.055222,891.416199 135.629410,891.905212 134.805878,892.432190 
	C129.258133,898.099060 125.248749,904.454529 121.985680,911.706543 
	C121.543831,912.956604 120.899467,913.643494 119.955322,914.536011 
	C114.407547,919.507935 109.902222,924.948425 105.798889,930.701721 
	C104.423523,932.630127 102.756401,934.673340 103.419128,937.735229 
	C103.671494,938.975708 103.519234,939.785767 102.385071,940.421631 
	C101.674400,940.593689 101.503845,939.990723 101.181618,940.089478 
	C100.892349,940.178162 101.022491,940.458374 101.643875,940.802368 
	C105.648132,947.137329 110.603004,951.973145 117.472343,954.393311 
	C119.428375,955.082397 119.680206,955.999756 119.325760,957.676392 
	C119.062431,958.921936 117.741280,959.904968 118.673965,961.559570 
	C121.454994,962.933167 123.116562,965.083923 125.158646,967.318481 
	C126.152092,968.397766 126.847351,970.368469 127.858002,967.775208 
	C128.320572,966.588257 128.193604,965.244934 128.873993,963.753052 
	C129.137817,963.248962 129.257080,963.055847 129.584869,962.596802 
	C131.845795,960.005554 133.495605,957.429321 134.752975,954.218933 
	C134.942780,953.681580 135.025742,953.467346 135.429840,952.633179 
	C138.891449,946.463806 140.839920,940.307190 144.702423,934.746277 
	C147.196182,933.398376 149.103470,934.332092 150.996094,935.405945 
	C154.700714,937.507812 158.511490,939.415344 162.534332,941.675842 
	C163.487671,942.119263 164.095352,942.466553 165.113068,942.712524 
	C167.211349,943.271790 168.851257,944.040955 170.714813,945.110779 
	C171.828110,945.904785 172.590912,946.665405 174.048828,946.724487 
	C175.020370,946.816162 175.663849,946.933044 176.619507,947.208008 
	C178.985504,947.935242 180.216537,951.640930 183.379089,948.695129 
	C184.168518,947.935852 184.786499,947.556458 185.857605,947.244995 
	C186.739014,947.169861 187.229996,947.263184 188.004471,947.682190 
	C188.735580,948.550842 188.875763,949.267395 188.791199,950.380981 
	C188.024536,952.684875 189.324448,953.478455 190.760208,954.069702 
	C196.880524,956.589600 202.929504,959.323547 209.459656,960.681946 
	C213.595993,961.542236 216.941833,960.159851 219.841522,956.704102 
	C220.208710,956.216431 220.372925,956.031006 220.839355,955.620239 
	C221.832230,955.039917 222.573578,954.850464 223.723969,954.684326 
	C225.950897,954.725220 227.793945,954.355591 229.955719,954.950806 
	C235.961243,955.099609 241.590240,954.058472 247.237488,954.571899 
	C247.404053,953.721069 247.423126,954.088318 247.162613,954.124146 
	C242.004700,954.834839 236.738449,954.216003 231.206696,955.404907 
	C229.900864,954.858154 228.983994,954.331421 227.474747,954.374878 
	C227.261353,950.413208 231.063370,952.295471 233.016052,950.584473 
	C239.788940,948.742676 244.015213,944.141418 248.245514,938.980286 
	C249.118652,938.020020 249.839233,937.413147 250.905334,936.672546 
	C254.466736,936.740845 256.885864,935.560669 258.377228,932.533630 
	C259.052002,931.164001 260.263702,930.117371 261.727112,929.730713 
	C266.920044,928.358398 270.589172,923.046265 277.025146,924.459534 
	C279.364899,924.973267 281.580414,922.162537 283.710754,919.993408 
	C297.306152,911.375610 311.575378,904.989441 326.296570,899.587585 
	C341.304657,894.080505 356.257751,888.424988 371.652771,884.012939 
	C383.860657,880.514282 396.327118,879.681213 408.789520,880.820190 
	C426.529541,882.441650 444.228394,884.741455 461.512177,889.325623 
	C470.528503,891.717041 479.490967,894.299133 488.727020,895.756287 
	C490.630890,896.056702 492.266083,896.820435 492.433289,899.480103 
	C491.823395,900.582092 491.092163,900.928223 489.893066,901.219727 
	C484.567505,901.184143 479.899658,902.736572 475.515747,904.536621 
	C465.967499,908.457275 456.017090,911.167725 446.388000,914.823364 
	C442.790192,916.189270 439.793823,918.671753 435.764587,919.899048 
	C432.676270,920.848755 430.028687,921.926270 427.068909,923.157104 
	C424.591370,923.925537 422.378510,924.508240 420.441772,925.624817 
	C418.304718,926.856934 420.516693,927.070923 421.405579,927.792969 
	C422.333313,928.275635 422.915894,928.662720 423.717834,929.357971 
	C424.066071,929.837646 424.161499,930.060059 424.152771,930.631958 
	C423.566284,931.579651 422.911285,931.871704 421.825195,932.079468 
	C418.121155,932.178162 415.113159,929.906433 411.470428,930.797729 
	C424.667480,934.148926 436.915222,939.794739 449.705139,943.875061 
	C450.668579,944.182434 451.533691,944.677979 452.412720,945.768555 
	C452.886322,946.829529 452.899567,947.582642 452.503082,948.689941 
	C448.478210,950.727966 445.266510,948.376587 441.486603,947.279358 
	C438.707306,946.046387 436.261871,944.994385 433.383972,944.060791 
	C431.921814,943.528015 430.764038,943.300232 429.202209,943.256958 
	C428.354889,943.169861 427.875977,943.079895 427.049927,942.858154 
	C423.697083,941.356934 420.630554,940.144104 417.490295,939.077942 
	C412.575134,937.409424 407.669922,936.274597 402.193115,937.933716 
	C400.838715,937.603760 399.972870,936.831482 398.513306,937.020020 
	C388.658447,940.353088 379.222565,943.865479 370.158203,948.928528 
	C369.906525,949.376953 369.814301,949.553223 369.593384,949.972412 
	C371.809601,952.973816 375.712189,951.517822 378.643860,953.618042 
	C379.137024,953.821533 379.331360,953.904419 379.811188,954.113281 
	C381.013763,954.681091 381.990326,954.926270 383.275879,955.189148 
	C383.753632,955.338074 383.940338,955.410217 384.396729,955.608643 
	C385.385101,956.122986 386.181610,956.168213 387.275208,956.309204 
	C387.780090,956.431702 387.977905,956.502258 388.450562,956.730103 
	C390.262024,958.114441 392.138428,958.597229 394.248474,959.372803 
	C400.925781,960.174561 407.299377,958.587769 413.670013,959.633545 
	C415.434143,959.923157 417.293793,959.547913 419.329132,960.404053 
	C421.068512,963.351562 423.224823,964.900879 426.774506,964.417358 
	C431.145844,962.640320 434.726501,959.804810 439.631256,959.578735 
	C440.347229,960.086975 440.557007,960.531677 440.572693,961.424683 
	C439.602264,963.810547 437.767853,964.535828 435.498169,965.244019 
	C432.269867,966.816650 429.397949,968.309998 426.462952,969.677612 
	C425.900330,970.042603 426.951111,970.411438 426.472351,969.947510 
	C429.054779,968.237915 431.952271,967.142090 435.009583,965.595337 
	C435.999237,965.156067 436.685486,965.105042 437.700989,965.480103 
	C439.708771,969.227173 436.410400,969.380310 434.593384,970.579956 
	C440.820465,970.061218 446.207336,967.343811 451.848877,964.272827 
	C457.152740,962.566040 461.559326,959.279663 467.368958,959.322693 
	C469.371796,962.905518 472.988495,964.823303 474.365662,968.735596 
	C475.536072,972.060730 478.597748,971.905457 481.608307,969.572815 
	C482.384460,969.287842 482.851471,969.231934 483.675751,969.302002 
	C485.784271,970.613464 487.116364,972.112732 489.826630,970.366333 
	C492.815247,968.440613 496.983368,970.861145 500.486511,968.357910 
	C501.859406,967.344727 503.070129,966.927490 504.812683,966.876221 
	C505.776703,966.985107 506.299500,967.167480 507.113281,967.717896 
	C508.551727,969.959717 508.324005,971.854858 506.878418,974.028320 
	C505.505066,975.288757 504.205322,975.785278 502.433777,976.192383 
	C498.968842,976.333069 495.937622,976.822266 492.531433,977.075439 
	C490.906830,976.901123 489.607941,976.329529 488.125610,977.477112 
	C487.189056,977.865173 486.524017,977.940308 485.503906,977.884644 
	C484.427032,977.749146 483.684601,977.567749 482.884155,977.885925 
	C483.527313,978.780518 484.352783,978.585144 485.464478,978.670959 
	C489.035309,978.929993 492.061951,979.761108 495.145996,981.664551 
	C495.949677,986.897766 495.378845,987.333679 488.473572,986.991089 
	C484.470734,986.761597 481.100220,985.198975 477.108704,985.073792 
	C472.506439,983.459290 468.309692,980.773682 463.472290,984.498291 
	C457.121613,980.555908 451.096985,981.476746 444.782288,983.968933 
	C439.881744,985.903015 434.547638,986.520752 429.445892,987.905945 
	C424.872711,989.147705 420.914581,985.684326 416.055359,985.469238 
	C406.770508,984.261902 397.770264,983.109070 389.208588,980.796997 
	C371.032135,975.888428 353.747955,978.014404 336.419373,984.178101 
	C323.744476,988.686584 310.788452,992.362854 297.447205,995.966125 
	C295.880280,996.068176 294.671997,995.865356 293.897491,996.010559 
	C294.113129,995.943787 294.761475,996.038635 295.732971,996.006653 
	C296.945526,996.006714 297.826324,996.009338 299.022217,996.094727 
	C300.279572,996.530945 301.220428,996.931885 302.526611,996.187988 
	C304.458099,995.642578 306.087585,995.627197 308.065247,996.099121 
	C308.832733,996.453613 309.181152,996.771179 309.527222,997.524658 
	C309.608765,998.088257 309.600250,998.314453 309.494110,998.856934 
	C308.952789,1000.051941 308.158844,1000.815125 308.671417,1002.175354 
	C314.644135,1002.718994 320.424957,1002.890381 326.578278,1002.135132 
	C330.153290,1002.590820 333.282593,1001.971069 336.831299,1001.570435 
	C339.426361,1001.614441 341.616882,1001.411682 344.206909,1001.664185 
	C348.058472,1002.635620 348.775421,1004.599487 346.553467,1007.772705 
	C346.022095,1008.390991 345.090149,1008.033325 345.234650,1008.891357 
	C345.345367,1009.548706 344.804230,1008.646790 345.406586,1008.932434 
	C346.008942,1009.218079 345.224640,1009.112061 345.866394,1008.378113 
	C347.234283,1007.803711 348.371368,1007.682190 349.885681,1007.676086 
	C351.702423,1007.755310 353.149567,1007.869629 354.323730,1009.415894 
	C354.490082,1010.173035 354.386505,1010.570740 353.871460,1011.104675 
	C353.848328,1011.811584 352.683990,1011.398743 353.252197,1011.846924 
	C353.645233,1011.357117 353.927887,1011.114014 354.485107,1010.743774 
	C356.352173,1010.123840 358.093994,1010.491821 359.972717,1009.697266 
	C361.486755,1009.570923 362.449036,1010.058350 363.399414,1011.224487 
	C363.690918,1011.915771 363.686981,1012.341064 363.753601,1012.752441 
	C363.817017,1013.144287 363.998779,1013.249512 364.053497,1013.107971 
	C364.012177,1013.094177 364.022400,1012.953613 364.346924,1012.485107 
	C368.261719,1010.021057 372.318176,1011.300720 376.185760,1011.008545 
	C385.196289,1010.327759 394.400635,1010.852478 402.802979,1006.509949 
	C402.223572,1003.471252 398.554199,1003.855347 397.512604,1001.071289 
	C398.844788,996.334778 403.076813,995.071228 406.291351,992.727417 
	C407.294189,991.996216 408.526611,992.658813 409.518250,993.234192 
	C411.582733,994.432312 413.816437,994.688477 416.498474,994.602905 
	C419.602112,994.380920 422.547852,995.372437 425.220764,992.981201 
	C426.245514,992.101562 427.122162,991.727905 428.455017,991.604614 
	C430.548096,992.649353 432.220581,993.822754 434.601013,994.277771 
	C435.719330,994.864319 436.331329,995.561279 437.340363,996.310120 
	C441.420959,1000.626770 445.466248,1004.438354 450.988129,1007.242920 
	C448.378693,1005.606628 445.975616,1004.547180 444.382538,1001.923828 
	C443.802399,999.713440 444.352997,998.030640 445.460876,996.103210 
	C447.947815,994.468811 449.579742,995.552246 451.295532,997.445679 
	C452.103027,998.659058 452.627289,999.659851 454.158203,1000.048584 
	C457.825317,1002.458862 460.329895,1005.958435 464.622681,1006.765930 
	C461.062378,1002.633118 457.925873,997.900391 453.317047,993.943420 
	C452.921753,993.509949 452.784180,993.318665 452.549927,992.787964 
	C455.239746,988.452393 458.820190,987.896484 463.296906,991.235168 
	C469.922455,996.176453 476.237366,1001.525024 482.921326,1006.645020 
	C482.115417,1004.795837 480.855164,1003.328857 480.133728,1001.193359 
	C479.934448,1000.122864 479.992859,999.412170 480.390320,998.400085 
	C482.635773,996.466003 484.301483,997.952332 485.992615,998.859802 
	C491.236572,1001.673828 496.255859,1004.887878 501.618866,1007.558838 
	C497.062164,1003.396790 493.017181,998.696716 487.313019,995.861633 
	C484.879242,994.651978 482.071869,993.620605 480.692810,990.489380 
	C480.811768,989.665771 481.063904,989.261963 481.708313,988.714233 
	C487.143433,988.244446 490.663910,992.198547 495.528046,993.625122 
	C496.100647,993.796875 496.327881,993.873169 496.889893,994.082336 
	C497.887329,994.499634 498.531647,994.824402 499.529144,995.250488 
	C506.658691,998.073914 513.892090,999.421082 520.646484,1002.231079 
	C522.065674,1002.821472 523.588440,1002.592102 525.433899,1002.488098 
	C529.239441,1005.109192 533.088867,1007.541687 530.020874,1012.898071 
	C529.603271,1013.627197 530.843506,1014.150330 531.505371,1015.089966 
	C532.132263,1016.385620 532.192200,1017.405334 531.883911,1018.834473 
	C530.645935,1021.208801 528.763184,1021.264465 526.451782,1021.122742 
	C525.055115,1021.122009 524.459290,1019.716980 523.296265,1020.250854 
	C522.690369,1020.528992 522.911682,1021.075073 523.294128,1020.528992 
	C523.676575,1019.982910 523.715332,1021.427124 523.723633,1021.125000 
	C523.533813,1023.077271 522.528442,1023.806458 520.561279,1024.004028 
	C517.996277,1024.626831 515.827637,1024.482788 513.670288,1024.486572 
	C488.062531,1024.531738 462.454620,1024.401733 436.423462,1024.776367 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M1.352819,419.262695 
	C1.000000,417.611115 1.000000,416.222198 1.000000,414.416656 
	C1.615610,413.744141 0.728388,413.945190 1.350874,413.709534 
	C1.777525,413.547943 2.221752,413.519348 2.655781,413.421051 
	C2.271729,413.347015 1.884662,413.489136 1.250376,413.202454 
	C1.000000,411.611115 1.000000,410.222198 1.000000,408.416656 
	C2.007262,406.950043 3.420297,407.092926 5.040307,406.652039 
	C16.133558,406.507202 26.549288,403.842957 32.128601,403.350891 
	C26.338827,403.935913 15.682016,406.427643 4.379214,406.740723 
	C3.187466,406.940948 2.397709,406.885223 1.329813,406.244415 
	C1.000000,404.285645 1.000000,402.571289 1.000000,400.428467 
	C7.364347,397.504089 14.190082,397.490295 21.193794,396.183502 
	C22.378963,395.838501 23.188089,395.735931 24.391811,395.644501 
	C30.255909,395.619537 35.559566,394.497589 41.076820,392.935364 
	C41.539894,391.066864 44.856964,387.949371 39.176189,389.072083 
	C27.427853,391.259521 16.004484,393.140991 4.135005,394.819061 
	C2.860452,394.659332 2.149512,394.258789 1.297580,393.292358 
	C1.000000,391.611115 1.000000,390.222198 1.000000,388.416656 
	C4.410290,386.464661 8.003856,386.583557 11.543789,386.593262 
	C8.316691,385.796967 4.915440,387.910583 1.317391,386.242249 
	C1.000000,384.611115 1.000000,383.222198 1.000000,381.416656 
	C4.242733,380.094696 7.700093,380.646942 11.327938,379.527771 
	C14.868087,380.113739 17.857027,377.456268 21.019722,378.947327 
	C18.149933,377.418915 15.448343,379.795105 12.215384,379.488983 
	C8.445956,379.825012 5.162312,380.907715 1.366455,380.215820 
	C1.000000,378.611115 1.000000,377.222198 1.000000,375.416656 
	C5.148051,372.693939 9.864130,373.420837 14.288002,372.585327 
	C15.867888,372.286926 17.502289,372.196503 19.475071,371.632568 
	C21.280111,371.490723 22.675507,371.521149 24.485193,371.505646 
	C29.618906,370.632568 34.322914,369.613617 39.121532,369.522888 
	C34.620495,369.631134 30.180555,370.408081 25.341578,371.402130 
	C23.514677,371.501068 22.100355,371.480530 20.254562,371.504364 
	C13.838583,372.628693 7.862306,373.813751 1.360921,373.249298 
	C1.000000,371.933319 1.000000,370.866669 1.000000,369.399994 
	C5.686898,366.512573 10.970695,366.932404 16.346107,365.828949 
	C19.328291,365.730225 21.726618,364.482635 24.707127,364.512115 
	C25.386011,364.518890 25.685698,364.508728 25.983749,364.480957 
	C25.929413,364.442902 25.877047,364.489685 25.441214,364.486145 
	C22.396248,364.122375 19.993698,365.689789 16.963406,365.623749 
	C11.606584,366.294037 6.755485,367.801147 1.344248,367.245667 
	C1.000000,365.933319 1.000000,364.866669 1.000000,363.399994 
	C2.254949,361.824310 3.842091,361.726868 5.420543,361.601257 
	C6.093677,361.562836 5.338074,360.712769 5.556544,361.342621 
	C4.207448,361.561829 2.871274,362.273315 1.247395,361.224609 
	C1.000000,359.933319 1.000000,358.866669 1.000000,357.399994 
	C7.542273,353.659821 15.026019,354.477997 21.415035,352.337769 
	C15.117064,353.436279 8.510215,355.246979 1.326276,355.234192 
	C1.000000,353.611115 1.000000,352.222198 1.000000,350.416656 
	C10.620585,347.466675 20.590351,347.320587 27.753351,345.773102 
	C20.775484,346.664185 11.261553,348.052124 1.373117,349.214722 
	C1.000000,347.285645 1.000000,345.571289 1.000000,343.428467 
	C3.426949,341.111237 6.384530,342.559265 9.377087,341.639404 
	C10.847672,341.492401 11.922332,341.520935 13.390083,341.485809 
	C15.982358,340.347046 18.453650,340.548584 19.840025,340.508087 
	C18.751251,340.902527 16.419083,340.101685 14.049263,341.306641 
	C12.564604,341.523224 11.460924,341.472260 9.930468,341.524353 
	C6.904702,342.104279 4.309001,342.320862 1.359360,341.255707 
	C1.000000,339.933319 1.000000,338.866669 1.000000,337.399994 
	C9.628782,334.583069 18.696215,334.806702 27.378479,332.606201 
	C29.543497,332.057526 31.784378,330.898773 33.354103,331.452698 
	C23.378441,333.372772 12.595625,335.156921 1.369574,336.214783 
	C1.000000,334.611115 1.000000,333.222198 1.000000,331.416656 
	C5.762798,329.923676 10.646657,329.688385 14.505039,328.937469 
	C10.831532,329.081665 6.351936,330.538818 1.350170,330.216888 
	C1.000000,328.611115 1.000000,327.222198 1.000000,325.416656 
	C8.650145,322.393921 16.891733,322.997284 23.264616,320.760223 
	C16.952061,321.665558 9.502297,324.200043 1.325611,323.245361 
	C1.000000,321.933319 1.000000,320.866669 1.000000,319.399994 
	C4.965225,316.439728 9.611633,316.646393 13.985622,316.112976 
	C23.576355,314.943298 32.972370,312.703949 39.565556,311.821655 
	C29.625793,314.001129 16.540791,315.485901 3.574742,317.701721 
	C2.890392,317.818665 2.260628,317.749695 1.319238,317.237488 
	C1.000000,315.611115 1.000000,314.222198 1.000000,312.416656 
	C2.400192,311.826019 3.806967,311.773102 5.229999,311.522675 
	C3.987781,311.657898 2.711572,312.062592 1.265181,311.216187 
	C1.000000,309.933319 1.000000,308.866669 1.000000,307.399994 
	C4.832963,305.086548 8.991116,304.727722 13.507535,304.274048 
	C14.688965,303.139374 15.987043,303.870941 16.928497,303.286957 
	C15.945343,303.799896 14.651150,303.177917 13.428455,304.290771 
	C9.195889,303.946564 5.588898,306.414856 1.338114,305.244141 
	C1.000000,303.933319 1.000000,302.866669 1.000000,301.399994 
	C6.945404,297.988342 13.788465,298.812347 19.884571,296.444611 
	C20.559048,296.402313 19.491102,295.558899 19.910192,296.077362 
	C19.997522,296.185394 19.881987,296.300568 19.553883,296.385040 
	C13.666291,297.900116 7.803671,299.561981 1.319530,299.233582 
	C1.000000,297.611115 1.000000,296.222198 1.000000,294.416656 
	C4.123136,293.161102 7.225857,292.188599 10.118391,292.518372 
	C7.481242,291.785645 4.684284,293.540619 1.349873,293.216919 
	C1.000000,289.638702 1.000000,286.277435 1.000000,282.458069 
	C4.971407,280.323425 9.300859,280.370544 13.741764,279.191833 
	C17.874434,278.370636 21.601192,277.275818 24.827904,276.627197 
	C21.635220,277.047516 18.030270,278.512482 13.916410,279.037537 
	C9.661007,280.166840 5.637092,280.582764 1.345923,281.216064 
	C1.000000,279.611115 1.000000,278.222198 1.000000,276.416656 
	C5.256218,273.396942 10.403326,274.188110 15.237730,272.278687 
	C10.504632,273.432892 6.181286,274.726227 1.305710,274.235657 
	C1.000000,272.933319 1.000000,271.866669 1.000000,270.399994 
	C2.142529,268.771149 3.619257,268.464874 4.849913,268.516022 
	C5.872870,268.399048 4.844073,267.549622 5.187387,268.121094 
	C4.006803,268.749939 2.771237,268.748108 1.254560,268.220886 
	C1.000000,266.611115 1.000000,265.222198 1.000000,263.416656 
	C2.445606,262.020844 4.183666,261.773254 6.107002,261.065796 
	C7.995622,260.880157 9.581345,260.944092 10.708684,260.193665 
	C10.053534,260.829132 8.824700,260.540649 7.466573,260.959717 
	C5.170372,260.814423 3.568405,262.166779 1.335740,262.112061 
	C1.000000,258.638702 1.000000,255.277420 1.000000,251.458069 
	C2.443566,250.045715 4.071916,250.783157 5.324260,250.492569 
	C4.283810,250.464005 2.977366,250.528336 1.336725,250.217865 
	C1.000000,248.611115 1.000000,247.222214 1.000000,245.416656 
	C6.797853,242.482773 13.125954,242.111694 19.400738,240.515808 
	C20.308447,240.621475 19.527430,241.013351 19.987278,240.548553 
	C20.245363,240.287689 20.054222,240.156281 19.497078,240.516266 
	C13.277459,241.090118 7.738586,243.935425 1.319862,243.238922 
	C1.000000,241.933334 1.000000,240.866653 1.000000,239.399994 
	C3.006934,237.125641 5.752020,237.365997 8.170296,236.468491 
	C5.907832,236.705475 3.871548,238.107224 1.271293,237.225372 
	C1.000000,225.979111 1.000000,214.958206 1.000000,203.468658 
	C1.192123,202.839020 1.384246,202.678024 1.886233,202.304565 
	C11.934018,199.450394 21.630253,196.693878 31.226913,193.543335 
	C34.848980,192.354202 35.541283,190.889038 34.264565,188.119583 
	C34.500645,189.294159 35.360153,190.871262 33.252251,192.151672 
	C31.389915,190.549469 31.729620,188.425369 31.108082,186.226471 
	C29.687225,183.214386 27.794958,185.104660 26.330551,185.499496 
	C19.335857,187.385544 12.509964,189.851303 5.511355,191.741165 
	C4.236901,192.085312 2.994637,192.546478 1.320586,192.159241 
	C1.000000,188.638718 1.000000,185.277420 1.000000,181.458069 
	C3.656006,178.940689 7.204181,178.722702 10.192358,176.544266 
	C10.723573,176.308792 10.939725,176.227737 11.486931,176.059601 
	C14.169812,175.640671 16.643431,175.780075 18.908976,173.972336 
	C19.470348,173.443985 19.810066,173.161499 20.439468,172.706604 
	C20.918367,172.424713 21.119734,172.329773 21.635595,172.135925 
	C22.161457,171.993591 22.372822,171.950180 22.899387,171.863785 
	C24.438627,171.743896 25.633938,171.560699 26.965786,170.767609 
	C28.525764,170.075104 27.718554,168.932281 27.960999,167.744797 
	C28.035179,167.220810 28.080975,167.015823 28.242268,166.525238 
	C28.245014,165.812012 29.557259,165.811951 28.484470,164.927582 
	C27.838133,163.968948 27.566315,163.188004 27.705959,162.005432 
	C28.226362,161.128555 28.780699,160.777435 29.807613,160.647461 
	C30.585957,160.841446 30.986025,161.071228 31.616085,161.585571 
	C33.246456,163.428635 34.376968,165.239700 36.010101,166.630508 
	C38.532898,168.778992 40.997532,170.420151 44.003883,167.243774 
	C45.181007,166.000092 46.843422,165.707031 48.837036,166.497650 
	C50.085213,166.866989 48.863514,169.435028 51.153938,168.378769 
	C52.645664,167.690811 54.203796,168.915588 56.089798,169.084442 
	C56.628555,169.101593 56.844383,169.104187 57.383690,169.119263 
	C57.920761,169.159363 58.134361,169.187012 58.659698,169.297058 
	C59.365612,169.537430 59.745476,169.724106 60.362709,170.123474 
	C61.085361,170.710754 61.415043,171.203568 61.509117,172.103394 
	C61.384144,172.662903 61.164253,172.811752 60.901028,172.912811 
	C61.197906,172.934128 61.420677,172.790543 61.799660,172.271271 
	C66.681610,171.115341 70.140846,174.825500 74.792107,175.298019 
	C75.837036,175.494431 76.516640,175.703339 77.556824,175.954330 
	C82.221191,178.109772 86.657631,177.178253 91.073601,176.553223 
	C96.494522,175.785934 101.798027,174.471939 107.051338,172.961472 
	C109.334709,172.304962 111.609932,171.527328 111.216133,168.044800 
	C111.075638,167.228531 111.005775,166.761734 110.906395,165.948059 
	C110.856606,165.375320 110.847298,165.147812 110.854141,164.583939 
	C110.936592,163.185516 111.571846,162.217194 111.324829,160.795456 
	C111.211876,160.037155 111.205803,159.596161 111.284149,158.817535 
	C111.876259,154.641861 114.233093,152.700150 117.723541,151.130432 
	C124.029205,148.294647 130.714127,146.502777 137.318848,143.503204 
	C146.107742,141.324326 154.397919,138.623764 163.300598,136.880859 
	C166.229874,136.739944 168.774429,136.543991 171.230469,134.699326 
	C171.977295,134.373886 172.424500,134.256302 173.225037,134.166977 
	C176.390533,133.880295 179.271164,134.052078 182.298553,132.941925 
	C182.782639,132.718842 182.975235,132.629608 183.454773,132.407867 
	C184.308151,132.009506 184.875168,131.744843 185.671936,131.242676 
	C186.668396,130.625687 187.445343,130.316849 188.629303,130.317444 
	C190.140839,130.587097 191.339767,130.812637 192.839050,130.240677 
	C193.342194,130.078903 193.546051,130.017654 194.061050,129.875458 
	C196.646332,129.203217 199.031342,128.916733 201.153427,127.139587 
	C201.546783,124.908203 202.734207,122.398460 198.644211,122.674988 
	C192.687225,122.912392 187.254150,124.349274 181.322601,124.970551 
	C180.125122,124.676170 179.457321,124.236076 178.717316,123.245773 
	C178.203003,119.670044 180.485611,119.077156 182.854660,118.683617 
	C190.761642,117.370155 198.516281,115.351021 206.336121,113.637360 
	C208.882355,113.079361 210.045731,114.185379 210.591095,116.833755 
	C210.322403,118.499413 209.458328,119.465431 208.637848,120.850067 
	C207.136765,121.474991 205.390747,121.512413 207.288055,123.479836 
	C207.912888,124.127747 208.265442,125.089676 208.916992,126.203529 
	C211.257538,129.119659 213.237228,131.378036 217.434326,129.802429 
	C219.986725,128.844238 222.492706,131.020096 224.476288,132.781815 
	C228.339859,136.213242 233.080795,135.842896 237.700317,136.300156 
	C240.304794,136.557983 242.755096,137.442566 245.236664,138.547058 
	C249.454132,140.424194 253.819916,143.069717 259.147095,140.437164 
	C260.020538,140.240036 260.537109,140.237839 261.448273,140.406189 
	C264.291168,141.485184 266.771210,140.982285 269.232849,140.613571 
	C295.565765,136.669281 321.883972,132.622849 348.275055,129.079163 
	C357.014771,127.905655 365.779205,126.918251 374.503296,125.622688 
	C376.471375,125.330437 378.564240,125.355446 379.832581,122.846695 
	C380.351685,121.936615 380.731415,121.400291 380.902222,120.762596 
	C382.812378,113.631081 382.811676,113.630890 390.613464,112.662292 
	C393.884369,112.689171 393.884369,112.689171 392.941467,110.695946 
	C392.611359,110.279800 392.491302,110.102051 392.227356,109.634186 
	C391.686829,108.331261 391.387299,107.288734 391.074371,105.908295 
	C391.004700,105.363350 390.991516,105.143105 390.997803,104.590378 
	C391.057434,104.038010 391.097595,103.818115 391.237640,103.276382 
	C391.512787,102.534286 391.715576,102.127731 392.138489,101.444244 
	C392.495575,100.984863 392.658966,100.815536 393.127869,100.462204 
	C393.657776,100.194016 393.882233,100.109825 394.459076,99.940918 
	C395.051758,99.818871 395.292053,99.781517 395.896576,99.706543 
	C417.890228,97.206505 439.585846,95.337242 461.199036,92.793587 
	C468.953369,91.880974 476.769653,91.947853 484.441162,90.650566 
	C487.401367,90.149986 491.567932,90.638847 491.996002,85.402359 
	C492.580566,84.065376 493.282440,83.453514 494.786194,83.705307 
	C497.236298,85.329651 498.782562,87.311905 500.222168,89.823418 
	C500.802032,90.629402 501.155151,91.186134 501.717163,91.993088 
	C502.168365,92.605171 502.440247,92.945671 502.956696,93.516846 
	C507.514465,98.512863 512.497498,102.075775 519.126892,102.812164 
	C521.125671,103.034180 522.762146,104.306129 524.835205,105.274788 
	C525.277832,105.566849 525.447510,105.686768 525.858887,105.988419 
	C526.559998,106.514893 527.017334,106.862839 527.783264,107.224220 
	C528.575745,107.473999 529.117432,107.473709 529.962341,107.289719 
	C532.056458,106.782898 532.994202,109.392906 535.234192,108.465210 
	C537.163940,108.257004 537.875122,109.898132 539.617798,110.276917 
	C553.197083,110.671593 566.148254,108.216957 579.114319,106.405861 
	C614.002014,101.532784 648.931091,96.835960 683.412537,89.443962 
	C693.332581,87.317345 703.123596,84.714966 712.942383,80.734993 
	C713.861084,80.357094 714.415039,80.288300 715.379272,80.465881 
	C716.223877,80.938004 716.498962,81.387436 716.568359,82.340820 
	C713.947754,87.092224 708.752502,86.882195 704.707275,89.438843 
	C703.703003,89.879585 702.996765,90.037399 701.935303,90.220230 
	C700.903259,90.365570 700.215210,90.440117 699.225342,90.763062 
	C698.452698,90.995438 698.006348,91.114929 697.218872,91.312683 
	C694.361145,91.975212 691.833862,92.522560 689.132629,93.752197 
	C687.847168,94.165085 686.872742,94.254555 685.526733,94.335175 
	C682.912659,94.213188 680.837219,94.915192 678.414551,95.770454 
	C677.576782,96.022339 677.087402,96.128952 676.217407,96.261627 
	C673.314148,96.516655 670.871582,97.138573 668.070984,97.936188 
	C661.859497,99.309830 655.866821,99.739464 649.709045,101.422714 
	C647.287109,102.164864 645.085449,101.214943 642.657959,102.246689 
	C608.380615,107.462570 574.555481,112.924469 540.487732,116.666153 
	C539.659302,116.757141 538.846924,116.937630 537.667786,117.287292 
	C536.305115,117.694893 535.311279,117.801430 533.962280,117.453506 
	C533.240845,117.181923 532.853943,117.025467 532.229004,116.865982 
	C531.656433,117.026108 531.567444,117.288330 531.791077,117.914093 
	C531.937378,118.811234 531.891602,119.430931 531.739624,120.397911 
	C531.253662,122.471626 530.811951,124.191940 530.524719,126.367554 
	C529.654297,139.509201 529.032471,152.246475 527.991882,164.952866 
	C527.383301,172.384369 527.256897,179.845535 526.881348,187.277420 
	C526.430481,196.201538 525.791260,205.130722 525.522827,214.535187 
	C525.518799,226.871964 524.559265,238.706329 523.920288,250.987152 
	C523.536743,251.650833 523.340820,251.887802 522.692078,252.190247 
	C519.603271,249.345444 520.398743,245.533463 519.582031,241.709518 
	C519.373474,238.737350 519.990601,236.150665 519.004333,233.238571 
	C518.514954,230.824173 518.440247,228.806992 518.512390,226.350098 
	C516.071228,203.746780 513.364197,181.603973 511.369659,159.382126 
	C510.328156,147.778244 508.999207,136.200348 508.359161,124.561592 
	C508.295135,123.396988 508.211975,122.187172 507.572632,121.186516 
	C506.395203,119.343719 504.803162,116.861374 502.823151,117.262978 
	C500.491028,117.735992 501.515289,120.654449 501.720886,122.419441 
	C504.225891,143.919769 505.286285,165.534332 507.059235,187.520538 
	C507.554535,193.654282 507.818390,199.375778 508.244385,205.496979 
	C507.976898,207.209366 507.586334,208.497437 508.025391,210.227264 
	C508.271881,214.125732 509.662170,217.543243 508.690125,221.490891 
	C507.973267,222.539658 507.237183,222.882599 506.032227,223.184113 
	C505.106689,223.310349 504.577087,223.338028 503.659271,223.358185 
	C502.762207,223.388245 502.252197,223.403397 501.366272,223.432495 
	C498.506073,224.126724 496.034973,223.438354 493.184753,223.380463 
	C491.571198,223.428406 490.331024,223.370544 488.722656,223.374298 
	C487.871552,223.376953 487.388397,223.372787 486.551331,223.364716 
	C484.168243,223.446396 482.077362,222.909500 479.857056,224.159882 
	C479.361450,224.456528 479.154663,224.562057 478.617950,224.782623 
	C477.835541,225.003662 477.377594,225.074081 476.569244,225.115707 
	C475.772247,225.093750 475.325317,225.028961 474.572388,224.829971 
	C473.749115,224.626633 473.322205,223.888596 472.430908,224.678467 
	C470.877655,225.283722 469.583466,225.256119 467.978729,224.900421 
	C467.041504,224.812317 467.136078,223.759216 466.230713,224.167297 
	C465.609070,224.831039 465.072235,225.111389 464.194641,225.407990 
	C463.255127,225.545883 462.623322,225.477692 461.669189,225.428131 
	C460.455780,225.382507 459.617126,225.638931 458.442322,225.975769 
	C456.005310,226.487381 453.872620,226.293716 451.414459,226.396423 
	C449.960693,226.470139 448.956451,226.932236 447.595917,227.297760 
	C446.427979,227.170578 445.706543,226.670029 444.559448,226.422684 
	C443.206635,226.303146 442.171631,226.206207 441.009888,226.631653 
	C442.654907,227.586380 444.565521,227.475006 446.783600,227.600586 
	C448.278046,227.522064 449.427032,227.577454 450.928711,227.707794 
	C452.008423,227.794968 452.712891,227.951981 453.717926,228.399750 
	C454.830292,229.286224 455.177063,230.235229 455.597382,231.571671 
	C455.707001,232.207642 455.722595,232.467590 455.668823,233.114365 
	C455.475891,233.733582 455.352325,233.965973 454.912933,234.437164 
	C453.049011,235.371857 451.503571,234.980667 449.571991,234.592865 
	C448.657684,234.520126 448.148376,234.618317 447.286774,234.941742 
	C445.891083,235.326035 444.862122,235.246475 443.468140,235.046417 
	C440.951080,234.091827 438.811340,233.147537 436.556580,233.448929 
	C437.434814,233.765427 438.569031,233.289246 439.876617,233.889252 
	C439.962585,237.362808 442.888000,235.791199 444.531006,236.807892 
	C447.011597,237.713409 447.257721,235.501831 448.715302,234.611511 
	C449.962982,234.673691 450.824768,234.986343 452.001343,235.397552 
	C455.924408,237.289017 454.306396,240.926804 455.365021,243.950562 
	C455.576294,244.718292 455.577301,245.167465 455.301666,245.905579 
	C454.479889,246.606155 453.679962,246.297775 453.018036,246.641724 
	C453.630432,246.451340 454.324677,246.656616 454.887726,246.396866 
	C456.372040,245.712143 458.009827,245.973801 459.522461,245.239441 
	C459.729004,243.605667 460.732483,243.201691 462.208252,242.904083 
	C463.022308,242.861343 463.486206,242.897018 464.287659,243.043457 
	C465.514374,243.374100 466.367950,243.719788 467.518921,244.244873 
	C467.993256,244.562103 468.164520,244.715149 468.501831,245.168503 
	C468.724854,245.689255 468.781860,245.909668 468.853638,246.466187 
	C468.835663,247.019821 468.802887,247.237350 468.661499,247.760864 
	C468.345612,248.433487 468.114716,248.784195 467.682831,249.347412 
	C468.420044,251.507660 468.618622,253.324371 466.550751,255.099762 
	C466.295349,255.579102 466.203308,255.777710 465.956177,256.268829 
	C465.674316,256.743591 465.547607,256.925842 465.178528,257.337341 
	C463.422180,258.464203 461.971558,259.587219 459.709564,258.897583 
	C459.187256,258.807526 458.980713,258.766144 458.475952,258.632141 
	C457.735840,258.646179 457.521332,257.378967 456.675354,258.500244 
	C456.005737,258.797394 455.588745,258.866882 454.836975,258.878052 
	C452.322235,258.233124 450.897888,260.072083 448.718506,260.533447 
	C447.719086,260.311005 447.212921,259.871033 446.476318,259.186462 
	C446.089233,258.792572 445.943176,258.627106 445.622681,258.181244 
	C445.193878,257.287628 445.110657,256.646973 445.183533,255.674393 
	C445.361908,254.758438 445.557617,254.170883 445.708923,253.263794 
	C445.756989,252.763138 445.770782,252.562363 445.796326,252.059692 
	C445.818512,251.354309 445.829102,250.950806 445.835693,250.242584 
	C445.830750,249.532166 445.835022,249.126526 445.840393,248.417038 
	C445.837891,247.711777 445.843689,247.310471 445.849335,246.613739 
	C445.842987,246.123688 445.841217,245.929138 445.835907,245.447357 
	C445.825775,244.972092 445.819153,244.784073 445.786316,244.320770 
	C445.694794,243.687698 445.598816,243.338440 445.275269,242.808014 
	C443.983124,242.172852 442.833771,242.234283 441.425232,242.311096 
	C440.573364,242.494614 440.406952,242.947571 440.272217,243.741241 
	C439.889435,244.482956 439.114258,244.393265 438.921051,244.863785 
	C438.674469,245.464340 438.697662,244.722305 439.446930,245.246841 
	C439.637848,245.951996 439.593719,246.369431 439.283630,247.056244 
	C438.910004,247.453979 438.722687,247.575592 438.217133,247.804840 
	C437.224518,248.038681 436.553986,248.005981 435.559082,247.757339 
	C434.414124,247.280914 433.754211,246.632431 432.621796,246.223511 
	C432.171509,246.050659 431.999115,245.981140 431.593323,245.797821 
	C431.359924,245.684021 430.931580,245.467529 430.931580,245.467529 
	C430.931580,245.467529 430.452362,245.469772 430.257385,245.612671 
	C429.801971,245.978180 429.525940,246.179779 428.985901,246.484375 
	C428.547821,246.646667 428.362701,246.690979 427.886414,246.758301 
	C427.397095,246.778244 427.198853,246.775192 426.700287,246.762894 
	C424.934662,246.703140 423.515503,247.091064 421.739044,247.238907 
	C420.277527,247.321991 419.142670,247.283005 417.657715,247.374283 
	C416.344330,247.461090 415.395020,247.645294 414.059570,247.660583 
	C411.214203,247.230911 408.756622,247.311081 405.944763,247.991974 
	C403.275085,248.522064 400.949066,248.411133 398.255371,248.435242 
	C396.675171,248.341187 395.472778,248.372330 393.927307,248.578156 
	C393.352051,248.636292 393.123260,248.649368 392.557800,248.644897 
	C391.384613,248.510040 390.537231,248.316971 389.548828,249.149170 
	C388.909088,249.513046 388.513367,249.642441 387.789185,249.711060 
	C386.693054,249.637085 385.904022,249.510086 384.820374,249.787628 
	C384.116791,249.922363 383.705261,249.964066 382.981628,250.027527 
	C382.242096,250.193726 381.777008,250.213821 381.395905,250.487396 
	C382.121857,250.445496 382.805115,250.174820 383.888184,250.058197 
	C386.866516,249.961868 389.481659,249.931854 392.485474,249.582306 
	C393.710724,249.561127 394.529205,249.477310 395.762451,249.553192 
	C398.925568,249.460495 401.676422,249.511063 404.828430,249.532639 
	C406.545898,249.614639 407.844849,249.460953 409.526215,249.174683 
	C411.263458,248.925217 412.547455,249.090424 414.027802,250.081497 
	C415.009674,251.175598 415.346222,252.146072 415.336914,253.596130 
	C415.097839,254.159225 414.927155,254.345612 414.432312,254.722107 
	C412.740570,255.445221 411.303101,255.717133 409.530334,256.105042 
	C408.487122,256.248230 407.790131,256.255005 406.758331,256.292114 
	C405.546906,256.336670 404.678589,256.408173 403.560547,256.900696 
	C402.251190,257.553284 401.206696,257.953278 399.725800,258.030579 
	C399.166504,258.011139 398.943359,257.987579 398.390411,257.898010 
	C397.238892,257.627533 396.431854,257.325409 395.323120,257.536743 
	C394.764008,257.794037 394.651550,258.059326 394.865021,258.651825 
	C395.464478,259.952881 394.696259,260.765106 394.312317,261.985046 
	C393.868652,263.156281 393.443420,263.956787 392.354706,264.685303 
	C389.540802,265.668518 386.789734,264.992889 384.025543,266.277710 
	C383.484192,266.457184 383.267334,266.514923 382.739563,266.603333 
	C382.126984,266.608398 381.830872,266.512085 381.534698,266.501617 
	C380.869171,266.478119 380.625031,267.050934 381.184509,266.688385 
	C381.743988,266.325836 381.805023,267.411377 381.802246,266.862762 
	C383.349335,267.043640 384.641357,266.560974 386.216370,267.147766 
	C388.676270,268.610535 387.610077,270.708954 387.877075,272.808167 
	C388.095337,273.279327 388.194183,273.465546 388.418396,273.948364 
	C388.634674,274.681061 388.629211,275.117371 388.396240,275.862000 
	C388.068756,276.319946 387.892181,276.469849 387.401917,276.778198 
	C386.864075,277.012360 386.639984,277.088043 386.067566,277.241180 
	C382.847931,277.582214 379.965454,277.738678 376.733215,278.210510 
	C375.553589,278.125732 374.804230,277.899536 373.820007,277.204529 
	C371.966797,273.937500 374.159424,270.985046 373.593201,267.599579 
	C373.651367,264.730743 373.439301,262.230408 374.955750,259.638763 
	C375.535553,258.912292 375.969269,258.661194 376.856201,258.568207 
	C378.980713,259.446655 380.695496,260.683167 382.964539,259.090576 
	C383.479248,258.579041 383.825775,258.355835 384.498871,258.120300 
	C385.085052,258.038727 385.374847,258.021729 385.636810,257.990692 
	C385.608734,257.971680 385.227936,258.012695 384.998474,258.027283 
	C383.953339,258.110931 383.378021,258.588135 382.600647,259.375824 
	C381.166840,260.211060 380.047150,259.561890 378.558380,259.306641 
	C377.612274,258.634155 376.866058,258.464600 375.781769,258.085693 
	C374.430054,256.451660 374.050934,254.838425 373.848511,252.730682 
	C375.014954,247.439423 374.144714,242.468643 374.644104,237.125885 
	C376.278748,226.861786 374.485229,216.828461 376.522156,206.581940 
	C376.392303,204.004181 376.330872,201.879166 376.517517,199.296539 
	C375.877228,190.271957 376.846497,181.767899 377.538757,172.809601 
	C377.054688,160.893982 378.220551,149.498184 379.210144,138.100433 
	C379.812836,131.159332 379.192566,130.463318 372.418365,131.503036 
	C363.558594,132.862839 354.649475,133.875000 345.376221,135.307159 
	C343.586456,135.398361 342.227112,135.556885 340.483093,135.918335 
	C339.553650,136.125000 339.017273,136.210526 338.072449,136.304550 
	C332.303558,136.655655 327.070404,137.802002 321.430420,138.946075 
	C318.413422,139.618713 315.698120,139.093857 312.697510,139.817596 
	C311.813202,140.085480 311.299744,140.198776 310.397095,140.347992 
	C297.552582,142.535263 284.906097,143.392593 272.509705,145.992447 
	C266.301117,147.294525 265.314056,148.126404 264.023682,155.230225 
	C266.311920,157.298325 269.465302,157.098022 271.353516,159.725616 
	C271.323792,160.643616 271.056976,161.077942 270.262482,161.579346 
	C265.446899,162.323654 261.596252,159.829910 256.961182,159.300369 
	C254.247070,159.530807 254.967331,161.348373 254.722534,162.716568 
	C253.254532,170.921341 253.097885,179.268295 252.832932,187.524551 
	C252.171753,208.128204 250.403397,228.659042 249.350388,249.233658 
	C248.993820,256.200226 248.743668,263.174042 248.335205,270.589600 
	C247.328094,279.013580 247.408493,287.062531 246.608032,295.051117 
	C246.412766,296.999939 246.651917,298.994476 245.693329,301.283508 
	C244.606827,302.607941 243.797562,302.120880 242.686081,301.256531 
	C240.710281,297.156677 241.470688,293.102448 241.026215,289.206360 
	C240.244247,282.351807 239.671524,275.458893 239.468231,268.106689 
	C239.525238,267.072998 239.529770,266.483734 239.470474,265.459351 
	C238.184967,260.753387 238.517365,256.364563 238.452209,251.573761 
	C236.722855,243.619232 237.209885,235.900269 236.609421,228.286011 
	C234.869354,206.220917 233.499405,184.118011 233.443451,161.965744 
	C233.433136,157.882858 231.851562,155.356659 227.698608,154.494797 
	C224.930954,153.920441 222.262955,152.901978 219.504532,152.251648 
	C214.591660,151.093323 214.040665,151.478394 214.714462,156.298386 
	C216.283035,167.519150 217.764786,178.748993 218.939835,190.018387 
	C219.803192,198.298584 220.569595,206.586472 220.909424,215.313202 
	C220.835617,216.399826 219.703766,216.877701 220.677612,218.051849 
	C222.536072,223.227219 222.305573,228.328873 223.022461,233.686844 
	C222.968964,235.112549 222.847275,236.146301 223.189148,237.561646 
	C224.265976,242.049835 225.121246,246.153458 223.587296,250.719620 
	C222.731766,251.731598 221.929306,252.035324 220.644318,252.280212 
	C218.517059,252.387589 216.811829,252.517380 214.772217,251.821899 
	C213.024338,250.661636 213.304962,249.359268 213.862335,247.696320 
	C214.584351,246.333908 215.501678,245.663727 216.642014,244.823822 
	C217.089401,244.395538 217.259933,244.111984 217.243805,243.544800 
	C216.951019,243.032944 216.713760,242.778107 216.216965,242.377716 
	C213.841263,241.492355 211.790909,243.012314 209.324341,242.398636 
	C207.803177,241.986053 207.077393,241.147919 206.523315,239.749634 
	C206.577179,238.840515 206.900436,238.359589 207.426529,237.740448 
	C207.105301,236.490982 206.577011,237.509583 205.793015,237.635193 
	C203.065506,238.448898 200.583908,238.942001 197.837708,239.805908 
	C197.026535,239.922363 196.561264,239.917206 195.769165,239.752960 
	C194.919800,239.884033 195.121445,238.259003 194.050644,239.416016 
	C192.797653,240.134552 191.686310,240.259491 190.342712,240.703705 
	C189.446121,240.959717 188.840759,241.061386 187.989136,241.215195 
	C187.359695,241.240479 187.250732,241.386429 187.419525,241.700058 
	C187.435822,241.730347 187.572144,241.737625 188.090485,241.733917 
	C188.787704,241.723480 189.193756,241.720840 189.922272,241.718750 
	C191.116455,241.733063 191.980316,241.816803 193.130402,242.132904 
	C194.288239,242.049301 193.846558,244.476257 195.541931,242.999634 
	C196.397339,242.565720 196.999908,242.343185 197.934448,242.070312 
	C200.468048,241.626129 202.664017,242.105911 205.198364,242.149292 
	C206.609329,242.341156 207.711868,242.271851 209.129089,242.478775 
	C210.870529,242.393616 212.190506,242.929321 213.898529,243.179779 
	C214.869812,243.739487 215.287796,244.260300 214.757843,245.369843 
	C213.019241,247.299393 210.868073,246.303345 208.530548,246.978363 
	C211.236954,247.083557 212.992798,247.746918 212.848495,250.308548 
	C212.712662,252.719849 211.146225,253.711731 208.872757,253.800217 
	C207.884323,253.838684 206.902069,253.938217 205.594543,254.211121 
	C204.113129,254.420074 202.989838,254.807617 201.472260,254.532715 
	C198.565491,254.191513 195.475204,256.020447 193.571075,251.717972 
	C193.598526,251.993240 192.920273,253.072510 193.472275,252.698700 
	C194.596588,255.092422 191.594574,257.896851 194.245239,260.483490 
	C194.097870,261.353516 193.631668,261.691711 193.382599,262.173920 
	C193.655014,262.299835 193.933151,262.292816 194.516022,262.077087 
	C195.760269,261.717682 196.866119,261.836029 197.678513,260.621887 
	C198.545639,258.350403 197.972198,255.745544 200.847137,254.575745 
	C201.892120,254.685806 202.536423,254.952545 203.383514,255.593536 
	C204.636673,257.638367 206.632736,258.331116 207.964462,259.717255 
	C209.559174,261.377136 210.215698,263.169312 206.687317,263.866150 
	C206.198639,263.872589 206.013702,263.879608 205.685638,264.128296 
	C204.459290,266.081940 206.164734,266.054688 207.159393,266.873413 
	C207.617584,267.841248 207.518936,268.494965 206.831268,269.323059 
	C204.781616,269.982574 203.467667,270.712250 204.576141,273.217896 
	C204.703705,273.979828 204.626266,274.413025 204.621460,274.844818 
	C204.616791,275.262909 204.767471,275.403015 204.832306,275.260345 
	C204.833313,275.258148 204.839020,275.104187 205.272217,274.798553 
	C207.099640,275.484344 207.375671,276.904541 207.668243,278.679871 
	C207.604874,279.279419 207.541489,279.514221 207.268784,280.047974 
	C206.083298,281.107971 204.863113,281.283783 203.425873,281.861115 
	C201.568924,282.628876 199.995697,283.091949 198.002991,283.281433 
	C197.001389,283.371399 196.335938,283.397919 195.345490,283.447449 
	C194.202972,283.524475 193.455887,283.879120 192.475525,284.101959 
	C192.291595,284.178314 192.349213,284.520538 192.464569,284.351929 
	C193.223083,283.928864 193.903580,283.819977 194.884369,283.703674 
	C195.587524,283.925934 195.927490,284.187378 196.408295,284.791473 
	C196.844559,285.742493 196.892761,286.424194 196.672363,287.451538 
	C196.437805,287.973602 196.311386,288.165039 195.929916,288.582275 
	C195.298447,289.058685 194.902527,289.272583 194.192932,289.523193 
	C193.555298,289.682251 193.171158,289.303040 192.904755,289.554596 
	C192.715088,289.733673 192.955673,289.975739 193.493408,290.240234 
	C193.865143,291.183746 193.833099,291.853394 193.440872,292.850342 
	C193.053589,293.338257 192.851288,293.496460 192.291016,293.810181 
	C190.898804,294.262482 189.852295,294.259125 188.419495,293.992859 
	C187.007782,293.482483 186.386765,292.719269 186.062897,291.296509 
	C186.026581,290.701294 186.041473,290.465576 186.146881,289.911987 
	C186.358032,289.299866 186.562546,289.093201 186.794067,288.904358 
	C187.310471,288.483124 186.695862,289.117645 187.192444,288.677795 
	C187.533005,288.376129 187.512543,288.371887 186.684448,288.505859 
	C186.209915,288.431763 186.028152,288.343262 185.647186,288.017059 
	C185.159378,287.208923 185.046997,286.599487 185.079987,285.659943 
	C185.275391,284.566010 185.804733,283.975098 186.239624,283.044250 
	C186.268066,282.396576 186.300690,282.024628 186.452881,281.383392 
	C186.651474,280.954254 186.758072,280.796661 187.061523,280.438934 
	C187.651566,279.848694 187.986328,279.423370 188.115631,278.568909 
	C188.181915,277.877197 188.290131,277.493530 188.525421,276.819702 
	C188.953232,275.618164 189.680496,275.287628 190.874237,275.238922 
	C191.724274,275.420410 192.165390,275.751526 192.817108,276.192810 
	C193.234497,276.246460 193.405258,276.247498 193.846130,276.262024 
	C194.287445,276.312286 194.458664,276.349091 194.868805,276.498779 
	C195.347916,276.889709 195.647797,276.940155 196.228516,276.737915 
	C196.646149,276.668915 196.821869,276.704132 197.188110,276.933289 
	C197.449600,277.484314 197.473206,277.843964 197.330322,278.438965 
	C196.789001,279.178040 197.099228,278.402527 196.931625,279.040771 
	C196.776840,279.630219 196.863449,279.644470 197.110413,278.803833 
	C197.559875,278.060272 197.528320,277.460999 197.763763,276.601257 
	C198.495972,275.161530 198.816635,273.945190 198.716248,272.313354 
	C196.186340,268.841949 193.387222,268.735107 188.596344,271.741150 
	C186.935684,272.338531 185.431656,272.083130 183.979095,272.898499 
	C184.597931,274.247253 185.918777,273.628784 187.201141,274.191681 
	C187.700348,274.422546 187.888107,274.544922 188.267059,274.948578 
	C188.542664,275.678864 188.546234,276.127655 188.322464,276.888184 
	C187.858917,277.494385 187.490158,277.727234 186.770599,277.964111 
	C185.699707,278.207214 184.894974,278.213440 183.984497,278.786987 
	C183.487106,279.596680 183.782745,280.089111 184.291306,280.865662 
	C184.616379,281.608093 184.656036,282.070557 184.493958,282.885742 
	C183.965652,283.867645 183.397980,284.326752 182.387512,284.815674 
	C181.563431,285.083862 181.079712,285.180878 180.227386,285.281952 
	C177.463638,285.314209 175.205505,286.062439 172.583267,286.747742 
	C170.439270,287.160889 168.857834,288.126526 166.788879,288.681152 
	C164.849899,288.776978 163.217453,287.569855 161.477692,289.081329 
	C161.045502,289.684753 160.711838,289.942444 160.018677,290.238342 
	C158.207550,290.139099 156.894653,289.075439 154.966553,289.483612 
	C153.517273,290.224792 152.142639,289.707306 150.222870,290.774323 
	C152.004196,290.201782 152.981644,289.966766 154.311493,289.854767 
	C156.412781,289.281525 157.959229,290.505249 160.006561,290.413147 
	C160.789413,290.290863 161.233032,290.334381 161.950531,290.679779 
	C162.321594,291.096619 162.410980,291.309814 162.499542,291.869019 
	C163.556976,292.956848 158.870972,293.609283 162.528091,294.634338 
	C164.131378,295.083679 163.462891,296.788269 162.439880,298.205017 
	C161.141190,299.762085 161.913345,300.648895 163.093170,301.764771 
	C163.348938,303.946381 161.894531,304.886993 160.477539,306.252441 
	C159.761642,306.705200 159.311478,306.882141 158.484756,307.081116 
	C157.404999,307.233063 156.683228,307.210083 155.611542,307.090424 
	C155.037201,306.972961 154.812958,306.907654 154.275604,306.691467 
	C152.894653,306.140869 152.620621,304.246796 150.737747,305.136871 
	C150.211945,305.557770 149.919617,305.796234 149.477386,306.246399 
	C149.322952,306.452576 149.173050,306.929077 149.216980,307.175659 
	C149.322479,307.578796 149.384064,307.735413 149.526184,308.132263 
	C149.668732,308.703674 149.709076,309.037384 149.796051,309.601562 
	C151.046844,310.406372 152.201996,309.651123 153.713348,309.740509 
	C155.879486,309.675018 157.721771,309.683777 159.351349,307.956299 
	C160.619019,307.031250 162.100998,307.422272 163.119263,306.084595 
	C164.317352,304.809509 163.361496,303.627594 163.621948,302.217682 
	C164.094025,301.342834 164.631622,300.950989 165.497650,300.417725 
	C166.414413,299.913147 167.057770,299.639343 168.044281,299.265564 
	C169.078064,298.978821 169.785034,298.938416 170.846024,299.041962 
	C175.069031,301.370392 178.573700,298.497406 182.607346,298.199127 
	C183.402222,297.994690 183.864883,297.907928 184.685760,297.793396 
	C185.750519,297.690552 186.462418,297.693451 187.524170,297.673096 
	C189.975845,297.556519 192.020081,297.946045 193.304520,298.250519 
	C192.855377,298.301575 192.492401,297.554230 192.672302,296.149963 
	C193.157547,295.497955 193.559494,295.253540 194.347046,294.982178 
	C195.383789,294.764191 196.085785,294.739105 197.126007,294.676147 
	C198.358932,294.631226 199.231033,294.470612 200.414612,294.189209 
	C201.173294,294.082733 201.612259,294.071411 202.384232,294.117249 
	C203.608780,294.259125 204.471085,294.189972 205.562592,293.597595 
	C206.246857,293.337128 206.645096,293.233307 207.327972,293.093201 
	C208.426453,292.741913 208.704605,292.106659 208.724960,290.982758 
	C208.730515,290.441620 208.734344,290.220306 208.760956,289.658508 
	C208.865005,288.610626 209.052902,287.934387 209.596527,287.010529 
	C210.424698,285.651031 213.102386,287.518188 212.710434,284.520508 
	C212.621811,283.842773 215.398178,283.242798 217.194153,284.349060 
	C217.448395,285.061432 217.249237,285.397217 217.088211,285.783875 
	C216.836411,286.388489 216.993271,285.524048 217.154938,286.170654 
	C217.196808,286.338104 217.306168,286.203705 217.687210,285.674805 
	C221.032776,286.354889 221.975677,281.865936 225.310089,283.006714 
	C226.531235,286.931152 226.615845,290.712921 226.988708,294.838287 
	C226.658432,296.354095 226.315506,297.480560 226.405914,298.657654 
	C226.733780,302.926941 225.224396,305.512329 221.221725,305.046173 
	C224.551910,303.634033 226.449600,305.149475 226.535065,309.374969 
	C226.555847,310.402557 227.351898,311.172058 227.917633,312.477509 
	C228.636856,321.102753 229.502121,329.331573 227.278656,337.817688 
	C224.128601,338.865570 221.217407,338.289490 218.339874,338.507965 
	C217.674652,338.548065 218.636551,339.488403 218.293854,338.916565 
	C220.528717,338.080109 222.849854,338.712372 225.536377,338.524750 
	C229.540649,339.701263 229.635330,341.657166 226.835281,344.318604 
	C223.761276,345.292847 221.010208,344.914459 218.688446,345.115662 
	C220.704834,345.034760 223.129990,345.061279 225.961182,344.782867 
	C229.726746,346.627106 229.447556,349.136688 227.189178,352.138123 
	C222.163666,352.367035 217.536682,352.719055 212.997025,353.821533 
	C217.429291,352.854980 221.891251,352.190948 226.862762,352.749695 
	C228.445251,354.481415 228.458206,356.202881 227.710114,358.387390 
	C225.572128,360.391754 223.077713,359.800323 220.487701,360.476410 
	C217.829575,360.308319 215.512283,360.883423 213.317719,360.200562 
	C215.180054,360.760071 217.160004,360.399384 219.495483,360.511322 
	C222.163040,360.383270 224.375931,359.907166 226.994934,359.950256 
	C228.606384,362.391693 228.702942,364.485046 226.281128,366.417053 
	C222.018448,366.923492 218.131485,367.287811 214.237488,367.569214 
	C217.865067,367.336975 221.486710,367.031342 225.468567,366.684814 
	C227.769928,368.528473 227.456879,370.698578 226.839127,373.267456 
	C223.547882,376.715363 219.808807,374.287567 216.068497,374.898315 
	C215.335281,375.209045 214.911743,375.355469 214.174896,375.492920 
	C213.712250,375.539734 213.544189,375.539886 213.204376,375.428772 
	C213.032608,375.317444 212.711670,375.489197 213.070419,375.656738 
	C213.748886,375.732117 214.069168,375.641937 214.679291,375.511780 
	C215.377777,375.366547 215.794098,375.315155 216.562012,375.316284 
	C219.587479,375.944214 222.346497,375.113190 225.298920,376.074127 
	C226.412811,377.922363 226.408051,379.525482 225.604630,381.514709 
	C223.081146,383.178864 220.596741,382.052612 217.823547,382.390015 
	C214.191452,382.816711 210.898560,381.099365 207.330338,382.765381 
	C204.533264,383.396790 202.044983,383.561615 199.236877,383.924683 
	C197.274734,383.599426 195.749756,382.013580 193.704285,383.722107 
	C191.074387,384.425079 188.698151,384.636230 186.010025,385.077026 
	C183.786209,384.906342 181.830704,383.407501 179.790436,385.606018 
	C177.840958,386.448883 176.151718,386.396881 174.104507,386.009888 
	C169.938919,384.207031 166.319183,385.755951 162.329102,386.710083 
	C161.103134,387.042145 160.196533,387.107544 158.960297,386.835510 
	C158.131485,386.828583 158.180710,385.403076 157.102875,386.441040 
	C156.181442,386.852509 155.523743,386.906616 154.529694,386.751160 
	C153.678925,386.597839 153.196014,385.823547 152.318451,386.747314 
	C146.343628,389.493896 140.208786,389.193817 133.848602,389.677734 
	C132.955978,389.798096 132.709122,388.269958 131.718628,389.577118 
	C129.489578,390.571930 127.474541,390.300232 125.119675,390.262939 
	C122.691742,389.681091 120.660896,389.737427 118.342361,390.687592 
	C117.332039,390.943512 116.647804,390.976807 115.634171,390.848907 
	C114.404488,391.015686 113.813599,388.900085 112.616554,390.707764 
	C112.199577,391.481720 111.822090,391.936035 111.341331,392.678741 
	C110.572578,394.055664 110.685760,395.245209 110.839996,396.755432 
	C110.783920,397.711365 110.641945,398.335236 110.451874,399.278503 
	C110.330795,400.458221 110.230682,401.315704 110.194138,402.498749 
	C110.188240,403.683960 109.821114,404.829834 111.740189,404.407715 
	C112.470642,404.237152 112.899361,404.202087 113.657532,404.237366 
	C115.234138,404.516205 116.481987,404.837250 118.053017,404.283020 
	C118.738640,403.961823 119.134178,403.780457 119.848145,403.497009 
	C120.605385,403.315063 121.046692,403.317596 121.784309,403.554199 
	C122.368813,404.043701 122.543282,404.434021 122.506325,404.883728 
	C122.471268,405.310486 122.464447,405.462799 122.537796,405.341217 
	C122.541397,405.335266 122.576004,405.188202 122.944534,404.709656 
	C123.755524,404.141754 124.392387,403.988922 125.374901,403.867981 
	C126.135895,403.812988 126.571297,403.796417 127.331833,403.758179 
	C128.312988,403.658569 128.963135,403.556366 129.921356,403.237823 
	C130.478302,403.066040 130.706085,403.003845 131.286682,402.872559 
	C134.831512,402.598450 138.022949,402.512329 141.554230,402.939362 
	C142.492691,403.218750 143.066956,403.652557 144.026657,403.002930 
	C145.544952,402.180847 146.754532,402.015686 148.185867,403.181458 
	C148.786575,407.818146 145.808105,408.120392 142.689468,408.379486 
	C138.341751,408.740784 133.814163,407.448914 129.337952,409.985718 
	C128.536987,410.476593 128.050034,410.692505 127.162506,410.954315 
	C126.531540,411.088013 126.278046,411.123535 125.645538,411.171661 
	C124.775650,411.158691 124.287994,411.105164 123.460678,410.945862 
	C121.818398,410.433472 120.512306,410.258270 118.856262,410.853149 
	C117.612862,411.148773 116.687729,411.179779 115.407150,411.102997 
	C113.016113,410.511810 110.977615,409.984344 108.734932,411.639893 
	C107.572174,411.901489 106.808182,411.789856 105.774345,411.121277 
	C103.411545,406.221100 105.554131,401.640656 105.770111,397.063263 
	C105.980949,392.594940 106.493729,388.116638 106.867874,383.204529 
	C110.222458,360.856903 111.562180,338.743561 113.693222,316.294250 
	C113.805321,315.625366 113.872131,315.368134 114.111588,314.764435 
	C115.942780,312.770508 117.992737,313.802277 119.270111,313.610107 
	C120.529480,313.595123 119.830986,312.588135 119.976379,313.238770 
	C120.014885,313.411133 119.904083,313.536163 119.661438,313.499115 
	C117.932312,313.235413 116.039978,314.083618 114.265945,312.397766 
	C112.732925,307.483643 113.749664,302.951813 114.207367,298.395020 
	C114.551208,294.971893 114.657585,291.523254 114.548965,287.626465 
	C115.183228,278.503601 112.628456,269.847534 114.402946,260.726776 
	C113.959793,249.927750 113.171448,239.578979 113.469109,229.201569 
	C113.615868,224.085327 113.383934,219.002701 112.548431,213.513367 
	C112.341148,210.225189 112.489861,207.368958 112.507584,204.110992 
	C112.515167,196.928574 111.394623,190.218094 111.404976,183.418655 
	C111.411964,178.820602 110.265633,178.200821 105.913177,179.242661 
	C101.568764,180.282547 97.239716,181.390549 92.712349,183.067596 
	C92.171043,183.265396 91.956398,183.333450 91.419464,183.458221 
	C90.251038,183.547821 89.569374,183.112350 88.618164,182.677734 
	C88.024063,182.709320 87.721848,182.875626 87.278854,183.335495 
	C85.724464,186.074951 84.529472,188.677032 83.018448,191.514542 
	C82.249023,192.954498 82.229614,194.218399 81.951874,195.836960 
	C80.932854,210.565353 80.148804,224.901978 78.545425,239.620407 
	C79.095802,252.368073 76.741882,264.493561 76.217079,276.738708 
	C75.848152,285.347107 74.657372,293.920715 74.436035,302.994324 
	C74.405540,306.321777 73.364700,309.104706 73.549095,312.448425 
	C73.544823,313.177002 73.538399,313.469421 73.563286,314.202698 
	C72.615074,323.812531 72.741280,333.091949 70.601692,342.555817 
	C69.862228,343.343628 69.296715,343.523407 68.232178,343.317749 
	C65.973228,340.739960 66.602776,337.911743 66.498291,334.766205 
	C66.602898,332.540741 66.603233,330.762268 66.580917,328.538452 
	C66.569603,327.496735 66.565872,326.900208 66.553436,325.852844 
	C66.221687,299.957947 64.043823,274.594360 63.102940,248.754562 
	C62.240871,239.566071 61.893726,230.758499 61.633862,221.978683 
	C61.402542,214.163177 60.199493,206.412323 60.422031,198.587372 
	C60.504990,195.670380 59.174545,193.926910 56.237602,193.333420 
	C52.322720,192.542343 48.493374,191.386017 44.685165,190.199524 
	C41.381630,189.170258 40.099258,189.764221 40.730545,193.584335 
	C43.252243,208.843918 44.597126,224.257401 46.471447,240.019104 
	C46.626614,243.485367 47.352673,246.445557 47.988899,249.851196 
	C48.389595,251.699295 48.511642,253.146484 48.452881,255.054520 
	C48.850178,267.876831 49.993801,280.210327 50.521519,293.020355 
	C50.415974,295.519257 50.382496,297.574097 50.462616,300.070129 
	C50.606712,301.703796 51.090366,302.818665 51.315575,304.460632 
	C51.547935,322.635834 51.959103,340.337708 50.963512,358.073822 
	C50.267220,370.477936 49.791473,382.884155 48.356228,395.685730 
	C46.949047,401.980347 47.113716,408.032074 45.883495,413.895508 
	C45.474590,415.844452 45.385899,417.869476 44.254005,420.047363 
	C43.269962,421.381683 42.277794,421.530243 40.811028,421.047699 
	C39.935143,420.898712 39.864147,419.586426 38.743332,420.574677 
	C37.079056,421.293732 35.678478,421.279938 33.934242,420.884338 
	C33.072083,420.661102 32.738880,419.718384 31.676090,420.489899 
	C30.839663,420.599731 30.373562,420.476135 29.694889,419.946869 
	C29.159853,418.881653 29.162422,418.117584 29.648586,417.022278 
	C30.993212,415.849579 32.315670,416.070557 33.944695,416.005219 
	C35.196693,415.993164 36.090832,416.020538 37.219612,415.848877 
	C37.913048,415.874084 37.840996,415.501709 37.771954,415.543518 
	C36.880699,416.083771 35.904140,415.930939 34.593727,415.993896 
	C31.392288,415.776917 28.651455,416.231262 25.597092,417.285706 
	C22.536482,417.859436 19.863415,418.341827 16.806171,419.071716 
	C11.487111,418.909027 6.631966,420.680450 1.352819,419.262695 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M32.698204,1.265150 
	C355.020905,1.000000 677.041809,1.000000 999.531372,1.000000 
	C1001.676697,3.258795 1003.960510,1.989618 1006.017639,2.034512 
	C1007.358704,2.063778 1008.928833,1.954801 1009.302551,3.599961 
	C1009.700500,5.351804 1008.157898,5.792262 1006.890442,6.197584 
	C1002.338501,7.653248 998.521912,9.459882 997.131592,14.935364 
	C996.449158,17.623091 993.073425,19.336887 990.253113,20.361631 
	C986.774109,21.625666 983.947144,24.093040 980.220337,25.498266 
	C979.827332,25.929129 979.656433,26.089336 979.193542,26.445782 
	C976.993591,27.288984 975.589722,28.711393 973.955322,29.783592 
	C971.189819,31.597807 969.209778,30.437057 968.902954,27.044846 
	C968.651794,24.267653 967.122131,23.787289 963.845276,25.785097 
	C963.397217,26.163784 963.198975,26.292439 962.656860,26.508053 
	C959.983398,26.575985 959.605957,24.441868 958.493652,23.092562 
	C957.621399,22.034529 957.113831,20.056078 955.109558,21.327421 
	C953.705627,22.217983 951.383911,22.539131 952.322815,25.211868 
	C952.893677,26.836819 953.298706,28.672344 951.215210,29.459288 
	C949.238281,30.205992 948.361267,28.408197 947.201294,27.237984 
	C946.156738,26.184034 945.428650,23.707405 943.452148,25.059729 
	C941.884521,26.132263 939.789368,27.111769 940.235107,30.081306 
	C940.783325,33.733124 939.404358,34.530540 936.040222,32.866150 
	C933.822510,31.768925 931.842041,30.805744 929.104858,31.083931 
	C926.458679,31.352861 924.940002,29.192898 925.134705,26.457514 
	C925.238647,24.997894 926.002319,23.576170 924.973267,22.128372 
	C926.002502,24.588799 923.844116,27.119205 925.358276,29.643118 
	C925.786072,30.356136 925.048340,31.207640 924.168030,31.508711 
	C923.137024,31.861319 922.250854,31.523743 921.384033,30.907665 
	C920.041809,29.953859 920.381653,28.211996 919.514893,27.004160 
	C915.567322,34.226196 914.948792,34.426857 909.357544,30.026859 
	C908.950806,29.597263 908.807251,29.407902 908.543335,28.883266 
	C908.371338,28.046295 908.333618,27.486444 908.614441,27.094273 
	C910.003845,25.153633 911.786499,22.691143 908.931946,21.244646 
	C906.581299,20.053551 903.442017,18.738920 900.699280,21.440023 
	C897.633667,24.458860 894.152832,25.129784 890.637085,22.232180 
	C889.291199,21.122911 889.014343,22.574703 888.332642,22.866581 
	C882.491577,25.367344 879.645691,25.201263 876.713013,21.846230 
	C876.504700,21.572397 876.450195,21.466076 876.456177,21.629892 
	C875.002625,26.252239 874.540039,26.486244 871.106506,23.713181 
	C868.926697,21.952618 866.933838,20.146181 863.968445,19.696579 
	C862.648621,19.496473 862.228516,20.126938 861.363708,21.097965 
	C858.489319,24.133039 855.112610,23.965076 851.363647,23.692192 
	C850.277283,23.426634 849.761658,22.978321 849.490845,21.900833 
	C849.644043,20.937519 849.960754,20.378090 850.099365,19.547585 
	C850.076233,19.332491 849.814026,19.111532 849.805176,19.314808 
	C849.781677,20.026726 849.634644,20.495825 849.212158,21.193075 
	C848.581848,21.931707 848.016418,22.262646 847.085205,22.660778 
	C846.048828,22.937197 845.346252,22.927292 844.318970,22.632393 
	C842.061584,22.365921 842.277710,16.919350 838.696899,20.707733 
	C837.748840,21.977127 836.413025,22.497444 835.956421,24.174522 
	C835.687500,24.659866 835.561157,24.845531 835.173889,25.249397 
	C834.276062,25.773165 833.609314,25.834154 832.604126,25.600964 
	C831.556091,25.081270 830.878174,24.515388 829.619568,24.732967 
	C828.338989,24.854162 827.467346,24.684212 826.639038,23.618235 
	C826.173096,22.182842 827.331238,21.097698 826.562012,19.965511 
	C826.156006,23.905884 819.893372,25.172638 812.269165,22.622744 
	C809.786133,20.073332 807.849304,24.216761 805.391418,22.537899 
	C803.592773,17.797920 802.563049,17.615639 797.346069,21.246319 
	C796.619690,21.587999 796.171448,21.656067 795.390625,21.518120 
	C794.426392,20.773470 794.035645,19.887093 793.170532,19.461857 
	C793.310425,20.101784 793.984314,20.334915 794.376343,21.202847 
	C793.936646,24.720442 791.833374,23.513605 789.674927,22.962215 
	C788.156677,22.153276 787.012268,21.611008 785.766113,22.801243 
	C785.035522,23.499010 784.063110,23.697601 783.030579,23.738228 
	C781.149048,23.812258 778.881714,21.289562 778.690979,21.794952 
	C777.720337,24.366711 775.751038,23.594023 774.125244,23.677790 
	C771.966919,23.788992 769.765564,24.601181 769.613770,20.542265 
	C769.492554,17.300079 765.902283,19.547348 763.644287,19.162926 
	C763.214966,19.414011 763.069458,19.554796 762.783447,19.969406 
	C762.418152,21.659952 762.707947,23.452816 760.493591,23.518185 
	C757.987854,23.592157 756.554382,22.135746 755.567932,19.413986 
	C753.234009,22.386763 751.133240,24.376225 747.615540,20.802795 
	C745.283081,18.433273 742.156799,20.416407 739.219849,21.681681 
	C738.487732,21.344515 737.930725,21.193249 737.907837,20.556044 
	C737.810364,20.821125 737.914978,21.053442 738.347656,21.550594 
	C737.253357,24.684532 734.763062,23.581108 732.345581,23.624649 
	C727.190613,23.294325 722.365540,23.103544 717.299438,24.496513 
	C711.666870,22.241299 706.168579,23.926741 700.765930,23.885368 
	C696.819275,23.855145 692.962585,23.804007 689.164307,21.882893 
	C688.711182,22.141850 688.534302,22.254606 688.087524,22.531321 
	C686.243347,23.356050 684.887756,24.302147 683.650269,25.945362 
	C683.225891,26.303770 683.035706,26.425020 682.518433,26.645454 
	C677.049255,25.768726 680.367493,23.575663 681.482544,21.431561 
	C678.999817,24.494469 676.544678,23.915565 674.296997,21.507051 
	C672.316162,19.384480 670.687317,19.515020 669.136658,21.887369 
	C667.848083,23.858671 666.144653,24.415087 663.714478,24.538248 
	C660.215698,24.715570 659.252930,27.357355 661.428040,30.141251 
	C662.543701,31.569311 662.811340,32.697998 661.316406,34.275223 
	C660.572815,34.638382 660.107605,34.712231 659.282654,34.603977 
	C657.457886,33.765957 656.473999,32.336094 654.981995,31.605713 
	C652.657349,30.467772 651.794434,28.969366 653.355896,26.509007 
	C655.264099,23.502277 652.865540,23.430437 651.061768,23.741066 
	C647.634766,24.331245 645.772827,22.768713 644.524048,19.546024 
	C644.198120,18.783775 645.407166,18.386883 644.608398,18.055534 
	C644.041199,17.820253 644.860657,17.900494 644.255981,18.670017 
	C641.502563,19.728266 640.338867,25.789879 636.200012,20.868340 
	C635.660828,20.227184 634.652588,21.724327 633.984619,22.367298 
	C631.505493,24.753586 630.069702,23.591185 629.026855,20.881910 
	C627.108521,22.223047 625.560791,24.162708 622.868774,24.010384 
	C623.205383,25.481831 624.608948,25.510790 625.406921,26.229153 
	C627.008545,27.670946 626.770752,29.191185 625.586426,30.619167 
	C624.448364,31.991278 623.022522,31.934284 621.595764,30.925030 
	C617.968323,28.359060 615.436523,25.346191 617.544678,20.286694 
	C616.042419,23.455431 613.090698,24.124443 610.645569,25.372671 
	C608.889099,26.269321 607.439514,25.439804 606.543579,23.712982 
	C604.783569,20.320778 602.507385,19.933910 599.587769,22.575411 
	C598.719727,23.360746 597.887817,24.166075 596.392700,24.568289 
	C595.822693,24.574602 595.597229,24.535908 595.078613,24.325285 
	C594.373474,23.602249 594.210266,22.981144 594.356812,22.011639 
	C594.606689,21.475611 594.781250,21.240566 594.973450,21.019178 
	C595.156738,20.808075 595.086426,20.882343 594.558838,21.477161 
	C593.206909,23.812601 591.546875,23.777861 589.365906,23.431747 
	C586.100708,22.913568 582.759216,23.083168 579.839600,25.832497 
	C579.405701,26.216751 579.214294,26.350899 578.691406,26.602482 
	C577.506653,26.816669 576.661133,26.776106 576.056641,26.085901 
	C570.371826,19.594971 565.060974,18.926762 558.258179,23.838963 
	C557.085022,24.686153 555.946350,26.116976 554.305176,25.117809 
	C552.775879,24.186695 553.759338,22.756910 553.980408,21.507210 
	C554.106689,20.793194 553.628723,20.252041 553.312866,19.673710 
	C553.373657,19.010313 552.363220,19.924185 552.996277,19.715229 
	C553.190430,19.651131 553.106873,19.830244 553.200195,20.088333 
	C553.720886,21.529413 553.056519,22.699812 551.795776,22.688801 
	C548.368958,22.658869 544.765015,24.762093 541.563049,21.247343 
	C539.406982,18.880697 536.464233,17.668526 532.990540,19.536074 
	C530.250854,21.009026 527.495422,18.966301 524.685120,18.873941 
	C520.102966,18.723354 515.802979,20.442171 511.055115,20.610073 
	C510.660400,21.029478 510.489929,21.186304 510.027283,21.532516 
	C508.002106,22.343636 506.464142,23.455950 504.256653,23.750694 
	C502.939819,23.581583 501.876678,22.979847 501.004730,23.526815 
	C497.824432,25.521727 495.653198,23.884912 493.741608,21.583727 
	C491.325439,18.675058 489.137726,18.281820 485.198822,19.689606 
	C480.668518,21.308746 475.506073,21.610310 470.325653,20.698631 
	C467.706512,20.237701 464.736481,18.635172 461.676758,20.546249 
	C461.321320,20.978657 461.150360,21.125725 460.648712,21.334070 
	C458.636200,20.756477 456.871796,19.471085 455.371216,22.250656 
	C452.397034,24.967606 449.088745,23.547796 446.075043,23.604347 
	C442.052948,23.679823 437.917175,22.467686 434.601868,25.946037 
	C434.012695,26.564226 432.800293,26.798241 432.333282,26.172966 
	C430.770813,24.080879 429.499237,24.668951 427.969238,26.163599 
	C427.215118,26.900297 425.815552,27.033791 425.224731,26.283031 
	C422.742126,23.128325 419.020996,23.337202 415.712463,22.394417 
	C415.583313,22.357615 415.330658,21.648508 415.207062,21.770012 
	C410.804596,26.097685 410.655304,21.286528 409.114929,18.456337 
	C408.945099,22.848810 406.264954,23.108763 403.009613,23.118149 
	C402.486053,23.364504 402.269806,23.450487 401.708984,23.601086 
	C400.134064,23.709854 399.069824,23.198179 398.273254,22.367811 
	C396.337952,20.350372 394.701202,19.914633 392.740082,22.483381 
	C391.884491,23.604036 390.211853,24.241076 388.884247,22.751179 
	C385.928253,19.433712 383.412628,19.307806 380.049591,22.416374 
	C379.810577,22.637268 379.622894,22.913546 379.206726,23.446875 
	C378.844177,23.900652 378.687195,24.072412 378.260376,24.465061 
	C375.537567,26.323921 373.693695,25.564138 372.045471,22.974121 
	C371.712433,22.551386 371.584076,22.382483 371.262512,21.976368 
	C367.824249,23.007401 364.790863,22.816956 361.446381,21.504559 
	C359.724640,20.828941 357.022644,19.930017 355.376404,23.298422 
	C353.840851,26.440367 351.547150,24.152527 349.540009,22.527351 
	C349.147614,22.143314 349.059143,22.054829 349.059143,22.054829 
	C348.737213,21.695768 348.722595,21.684685 349.198608,22.240692 
	C349.081726,26.199156 347.002197,26.573296 344.394806,24.738300 
	C342.455414,23.373421 340.479950,22.546354 338.405548,23.563807 
	C334.934204,25.266430 335.116577,20.714428 332.674011,20.547295 
	C330.034149,20.366663 328.680023,23.813440 325.839020,22.655548 
	C324.152893,21.968340 323.013794,20.018829 321.109283,20.098320 
	C318.531586,20.205908 315.433807,19.237261 314.153778,23.005831 
	C313.589294,24.667707 311.964020,24.901184 310.434937,23.879398 
	C308.529236,22.605902 307.372711,20.447716 304.072754,21.915386 
	C301.526154,23.048012 300.425446,24.954630 298.836792,26.691727 
	C298.506378,27.052988 298.352478,27.553307 297.970551,28.312210 
	C297.644836,28.802652 297.494751,28.985334 297.046814,29.360231 
	C293.662567,30.307898 292.238037,28.095697 290.903992,26.059395 
	C289.940063,24.587992 290.902527,23.598246 293.252563,22.855387 
	C289.450195,23.471642 286.638458,24.496399 283.363342,24.387609 
	C282.269287,23.339188 282.487427,20.556278 280.091217,22.716112 
	C279.116211,23.594927 277.669952,23.738289 276.623016,24.564892 
	C273.823761,26.775045 271.667389,25.900972 270.313721,22.966948 
	C269.315430,20.803190 268.130188,20.268778 265.911621,21.811237 
	C264.912659,22.733150 263.872681,23.097994 263.113617,24.268784 
	C262.813751,24.695656 262.684418,24.861362 262.328491,25.249741 
	C261.758423,25.730024 261.398804,25.962673 260.731445,26.321499 
	C260.231812,26.549580 260.024475,26.627628 259.489136,26.775337 
	C258.708862,26.880926 258.259857,26.854164 257.488892,26.663284 
	C256.971497,26.426291 256.778809,26.300840 256.343994,25.929808 
	C252.453949,22.536434 247.653992,22.578651 243.305511,26.026571 
	C241.116287,27.248947 240.248856,26.195833 239.025085,24.732101 
	C236.665131,21.909395 233.547256,20.005053 229.650360,20.406630 
	C228.352066,20.540421 226.596344,19.902056 226.113220,22.543858 
	C225.756424,24.494841 223.439346,23.796717 221.537323,23.014820 
	C221.043655,22.696224 220.858322,22.550581 220.435944,22.143707 
	C219.318466,20.431812 218.303986,19.184128 216.140549,19.327835 
	C215.885605,20.946110 217.292435,24.128326 214.243454,23.596836 
	C211.768539,23.165419 207.852158,28.091278 206.511780,21.714468 
	C206.180435,20.138094 203.152618,19.715502 201.571518,21.299944 
	C198.576691,24.301167 194.441559,21.474787 191.319138,23.592325 
	C190.916061,23.865685 190.018616,23.308170 189.754807,22.639090 
	C188.032684,18.271400 187.873764,23.370270 186.612823,23.361145 
	C185.893890,24.130011 185.356796,24.603901 184.848114,25.107004 
	C185.254944,24.822151 185.573593,24.445158 186.168427,23.853416 
	C187.434311,23.139166 188.692841,23.150095 189.052231,24.115753 
	C190.308228,27.490559 187.458908,29.165554 185.670303,31.160070 
	C184.030106,32.989117 182.238495,32.935238 180.695435,30.852381 
	C179.696289,29.503721 178.339172,28.540688 176.740509,27.300629 
	C176.270111,26.910080 176.097626,26.738056 175.738464,26.255894 
	C174.986633,24.091602 176.104599,22.920334 177.402344,21.598551 
	C177.554718,21.436911 177.779037,21.248083 177.779037,21.248083 
	C177.779037,21.248083 177.703262,21.328827 177.509827,21.493183 
	C173.821472,23.250248 170.143646,24.413008 168.386124,28.511696 
	C167.564056,30.428850 165.574203,29.981056 164.298141,28.507036 
	C162.109039,25.978323 159.900940,24.064053 156.373245,26.322918 
	C155.535431,26.859390 154.440643,26.622961 153.621475,25.875025 
	C151.153732,23.621817 151.155151,23.620268 147.004089,23.692337 
	C146.584152,24.083344 146.404129,24.227551 145.911301,24.521175 
	C143.355515,25.411247 141.545090,23.579323 139.387756,23.628252 
	C138.323380,23.652393 137.472549,22.910780 137.583176,21.723078 
	C138.067932,16.518908 135.188553,19.192375 132.894714,20.008785 
	C132.399673,20.313555 132.190247,20.418043 131.638672,20.606388 
	C128.644821,20.153242 126.474876,20.538589 125.046463,23.253441 
	C124.156464,24.944996 122.448044,24.873659 120.607162,25.266426 
	C115.915947,26.267328 112.088890,25.478485 107.756615,23.614981 
	C105.854492,22.796799 102.283333,23.112579 99.275398,24.311287 
	C98.696320,24.368542 98.462250,24.359303 97.907379,24.210566 
	C94.193512,22.574821 90.525505,21.843050 87.403397,19.535370 
	C85.213737,17.916906 83.505379,19.983229 81.807480,21.815905 
	C80.626030,22.990831 79.519165,23.758144 78.517807,25.112637 
	C77.677727,26.033989 77.011337,26.647774 75.944801,27.305218 
	C69.987122,27.010292 73.505608,23.831697 73.966797,21.403593 
	C72.352379,25.173504 69.848175,23.708736 67.166199,22.642408 
	C63.639805,17.762665 58.528564,20.124138 53.952248,19.146961 
	C53.094845,19.205845 52.597511,19.208067 51.711010,19.157034 
	C45.470764,16.742685 39.705750,14.473897 33.067905,16.161097 
	C29.979883,16.946007 27.178043,15.303430 25.632153,12.320327 
	C23.928860,9.033487 26.226900,7.084220 28.253492,5.057333 
	C29.543417,3.767219 30.700140,2.336930 32.698204,1.265150 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M30.193602,160.891083 
	C29.392504,161.266525 28.914574,161.545059 28.182434,161.932831 
	C27.748335,162.171127 27.568445,162.300201 27.058502,162.460419 
	C24.792179,162.288177 22.852558,161.947876 20.625069,162.774597 
	C20.097717,163.014328 19.883377,163.112930 19.338097,163.358475 
	C15.344039,165.048752 11.443633,165.924637 7.811005,167.582520 
	C5.813468,168.494202 3.648792,168.687622 1.298330,167.242661 
	C1.000000,165.285645 1.000000,163.571289 1.000000,161.428467 
	C4.533787,158.059967 9.176488,157.801636 13.543270,155.840240 
	C42.705387,146.643021 71.615089,137.991287 100.759163,130.135239 
	C101.563217,129.918488 102.378891,129.770798 103.606613,129.640930 
	C119.902328,125.992599 135.746918,122.167496 151.663208,118.648262 
	C170.511185,114.480789 189.485931,110.949532 208.395203,107.090858 
	C210.772949,106.605652 213.460434,106.663567 215.080170,103.868683 
	C215.257141,102.236618 215.549759,101.016899 216.020386,99.458832 
	C216.400177,98.421951 216.747101,97.779068 217.344208,96.868423 
	C220.121521,93.960320 223.807327,95.074631 227.167206,93.682640 
	C226.207413,91.055618 222.410843,89.868408 223.258148,86.107483 
	C225.814713,80.494438 230.554962,79.139877 235.717743,79.132599 
	C237.915756,79.129517 239.343475,78.792603 240.890427,77.129822 
	C248.024002,69.462242 250.807007,69.347626 258.885284,75.925514 
	C260.374054,77.137764 266.458618,74.886574 267.789612,72.631050 
	C272.797821,64.144119 274.706085,63.464855 283.689667,67.482681 
	C285.414520,68.254097 286.455750,67.797844 287.715881,66.809273 
	C289.963287,65.046127 292.535583,63.851566 295.217865,62.912849 
	C298.501617,61.763634 301.511810,62.012337 303.694824,65.066429 
	C305.488770,67.576180 307.130707,67.952599 309.058868,65.203751 
	C311.520996,61.693680 314.833221,60.552959 319.096466,61.447491 
	C322.345093,62.129143 325.367737,61.870789 328.626038,60.040672 
	C331.615356,58.361629 335.628601,58.871433 339.172394,58.235432 
	C341.662842,57.788467 341.790131,60.820381 343.552399,62.592911 
	C347.049591,57.639385 351.911469,53.892044 357.787170,56.281105 
	C364.499084,59.010189 369.373535,57.729343 374.104584,52.895176 
	C375.137360,51.839855 376.918091,51.524033 378.370819,51.917210 
	C385.184235,53.761261 393.070404,53.028316 397.805481,59.997452 
	C398.796936,61.456680 400.674652,61.538471 402.337524,61.763885 
	C404.039825,61.994644 405.817017,62.393757 406.286102,64.280144 
	C406.885559,66.690765 404.774536,67.232132 403.368958,67.952866 
	C407.278473,67.693260 411.288300,66.594055 415.400269,66.650116 
	C421.125397,66.728172 425.275391,64.641182 427.402649,58.867615 
	C430.441925,63.943546 434.970612,64.372192 439.649323,63.037121 
	C446.582703,61.058670 453.573853,60.408951 460.741486,60.346451 
	C465.675018,60.303436 470.115601,56.916958 475.699585,57.720116 
	C481.201782,58.677517 486.294861,58.784584 491.829193,57.897079 
	C499.298859,57.649078 506.338348,57.447922 513.764648,56.577232 
	C516.123474,56.666634 518.019043,56.456341 520.263550,55.805489 
	C523.711365,55.297577 526.886780,56.294449 530.198486,54.738792 
	C530.776917,54.403027 531.019958,54.284763 531.650940,54.035995 
	C537.793152,53.101963 543.614502,53.980938 549.777039,53.162720 
	C550.454224,53.113918 550.724609,53.116646 551.391724,53.183540 
	C554.914734,55.015312 558.184753,54.789768 561.894226,53.864456 
	C562.834351,53.691143 563.383118,53.646843 564.362305,53.631477 
	C574.490479,54.735508 584.200134,54.984665 593.923523,53.906754 
	C595.262146,53.758369 596.560791,53.969513 598.213745,54.570442 
	C603.463562,57.824871 608.880615,58.255138 614.831177,57.988525 
	C619.940796,58.343094 624.526794,59.732555 629.664185,59.813652 
	C631.226685,60.053555 632.369141,60.660320 633.978027,60.169189 
	C635.840027,59.841652 637.269348,60.306866 639.094238,60.558235 
	C640.723206,60.626881 641.980042,60.653893 643.622681,60.619507 
	C645.043579,60.546734 646.080505,60.593529 647.509888,60.588898 
	C648.426514,60.600086 648.950012,60.602051 649.865662,60.595181 
	C652.074646,60.499012 653.885864,60.666920 656.073425,60.738388 
	C658.840454,61.636894 661.114563,60.878555 663.761780,60.295441 
	C666.297546,61.830502 668.180969,63.794514 671.101501,64.791107 
	C671.549255,65.581871 671.569885,66.095215 671.192017,66.941467 
	C668.764465,67.552467 666.623230,66.697060 664.016968,66.991318 
	C659.994934,66.419380 656.362915,66.434662 652.317505,66.483276 
	C650.329651,66.192070 648.758972,65.756020 646.780518,66.379944 
	C644.774292,66.522308 643.139832,66.460526 641.503479,66.532120 
	C648.861145,66.184410 656.208984,66.249634 663.930908,66.997887 
	C669.087097,67.822067 673.795776,66.357025 678.960449,66.677567 
	C679.642029,66.737091 679.910706,66.771294 680.570496,66.888519 
	C683.152527,67.871315 685.461609,67.635773 688.122681,67.677689 
	C689.014404,67.689346 689.522888,67.730759 690.408142,67.877853 
	C691.030945,68.042839 691.274597,68.131920 691.849731,68.428391 
	C692.751648,69.205757 693.110168,69.894547 693.358765,71.059181 
	C693.328491,71.704826 693.259033,71.958138 692.931458,72.508530 
	C690.160400,74.659042 687.288940,74.368454 684.058594,74.138687 
	C682.698914,73.930199 681.714722,73.815102 680.347229,74.101944 
	C676.834351,74.520561 673.694946,74.511261 670.169556,74.189911 
	C668.562012,73.904839 667.351501,73.441147 665.715942,74.014984 
	C662.296265,74.575142 659.237000,74.487854 655.818726,74.243156 
	C654.575134,74.055672 653.709229,73.780090 652.484741,73.784912 
	C651.754395,73.817497 651.339661,73.817108 650.623352,73.763138 
	C649.535522,73.592224 648.747803,73.519241 647.646484,73.728561 
	C646.907043,73.808838 646.476196,73.802216 645.709229,73.720825 
	C643.708862,73.185425 642.105469,73.514534 640.131592,74.126518 
	C638.263916,74.482101 636.759949,74.544632 635.266357,74.484985 
	C615.965515,73.714111 596.833435,76.360542 577.615845,77.210434 
	C568.660950,77.606461 559.752197,78.789474 550.750671,78.530220 
	C538.249329,78.170189 525.984436,80.759567 513.605652,81.954842 
	C505.501709,82.737350 497.193054,81.974815 489.284027,83.433144 
	C483.980377,84.411064 478.523804,83.430412 473.024719,85.529007 
	C472.343933,85.761803 472.065002,85.833397 471.360046,85.966553 
	C463.907196,86.634262 456.862762,86.446442 449.414337,86.494492 
	C448.472107,86.460747 447.938934,86.431679 447.019592,86.403503 
	C446.380066,86.407356 446.126587,86.413567 445.497650,86.414978 
	C443.903412,86.345451 442.687073,86.319763 441.132690,86.695190 
	C440.286591,86.756752 439.808411,86.703430 439.014893,86.425339 
	C436.096924,83.978104 432.423096,84.014305 430.239014,85.286491 
	C426.501953,87.463257 422.386078,87.789070 418.252869,89.469131 
	C417.436493,89.755669 416.944092,89.826836 416.061035,89.821045 
	C413.039185,89.249199 410.435699,89.227478 407.803192,89.979988 
	C404.276855,90.987976 400.755768,91.607353 397.036957,90.551338 
	C394.551117,89.845436 392.131012,90.893593 389.470123,92.062180 
	C388.355469,92.375900 387.603455,92.541389 386.474365,92.743683 
	C375.613708,92.713127 365.269073,93.686394 354.933350,97.151855 
	C354.005310,97.694244 353.329651,97.909828 352.302521,98.168106 
	C351.517731,98.343369 351.067139,98.420647 350.279175,98.513367 
	C349.724060,98.525764 349.503540,98.506401 348.971344,98.387146 
	C347.485291,97.443848 346.348602,97.534370 344.940857,98.565781 
	C343.973907,98.917725 343.292084,98.969559 342.249359,98.905090 
	C336.181152,97.906731 330.713043,99.421532 324.870178,100.659264 
	C324.305420,100.829102 324.076172,100.884766 323.497803,100.994331 
	C319.930298,100.852867 316.739990,100.890694 313.393372,102.349228 
	C312.646149,102.673386 312.194214,102.782845 311.380676,102.862961 
	C310.371796,102.896950 309.566589,103.079071 309.075134,102.827026 
	C302.601654,99.507210 297.246185,102.915550 291.429108,105.704475 
	C290.196564,106.065765 289.271576,106.150726 288.002014,106.244545 
	C287.432526,106.275223 287.205536,106.282852 286.640625,106.297928 
	C285.855652,106.318581 285.409180,106.343079 284.633850,106.438988 
	C283.863861,106.596405 283.424927,106.700356 282.654114,106.902908 
	C280.488861,107.355171 278.652649,107.693611 276.482117,108.149475 
	C274.528900,108.370918 272.902832,108.230576 270.980957,108.611389 
	C270.441711,108.757759 270.225098,108.805099 269.682678,108.895317 
	C268.128815,109.067261 266.850281,108.592224 265.386383,109.397491 
	C264.909637,109.634682 264.712646,109.720970 264.206238,109.908630 
	C263.043427,110.230927 262.174408,110.386238 260.990723,110.697891 
	C260.197906,110.829178 259.737946,110.845978 258.930115,110.782028 
	C255.681046,110.154533 252.726074,110.143684 249.788727,110.023224 
	C247.471512,109.928207 245.731918,111.084251 244.241547,113.282349 
	C243.050888,114.024925 242.064148,114.124489 240.675720,114.033882 
	C233.691330,111.783028 227.439331,113.193878 221.010391,116.063690 
	C220.488495,116.339935 220.269806,116.430252 219.701416,116.577271 
	C217.912613,116.830803 216.442200,114.794533 214.783325,116.920074 
	C213.848114,117.697960 213.026642,117.970802 211.891846,118.312073 
	C211.371857,118.408417 211.160126,118.425491 210.488098,118.081543 
	C209.347839,114.653297 208.065781,113.018135 205.156128,115.826973 
	C204.383469,116.572853 203.562866,117.144577 202.551376,116.947647 
	C194.994186,115.476250 188.486191,120.824440 181.051697,120.229248 
	C180.062256,120.150032 179.377594,121.172646 179.055359,122.599365 
	C174.498337,126.249626 168.959900,125.897324 163.920258,127.283707 
	C147.004623,131.937180 129.290619,133.173920 112.727585,139.474014 
	C108.481255,141.089218 103.607712,140.934464 98.812622,142.281067 
	C98.060104,142.453735 97.641701,142.576645 96.945648,142.873245 
	C96.091461,143.337372 95.494026,143.567139 94.526978,143.613129 
	C93.653633,143.519592 93.058273,143.276978 92.420303,144.182220 
	C88.647675,147.041245 84.223640,145.995224 80.346687,147.316437 
	C74.181870,149.417313 68.117195,151.926376 61.223557,152.797485 
	C59.107811,153.338928 56.910873,151.848755 55.272057,154.272888 
	C52.751667,155.523056 50.243969,155.669586 47.590363,156.451309 
	C46.746418,156.435989 46.142349,156.507874 45.727642,155.840378 
	C45.378063,156.029251 45.268803,156.158890 44.935577,156.419556 
	C44.543671,156.599854 44.375725,156.649139 43.944427,156.736969 
	C43.504112,156.802765 43.327141,156.830017 42.895172,156.946747 
	C42.143654,157.335312 41.736710,157.740372 41.067375,158.326141 
	C40.397560,158.665344 39.974346,158.755402 39.204296,158.788971 
	C35.796619,158.254547 33.260582,159.956650 30.193602,160.891083 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M864.260559,1024.682739 
	C841.979126,1025.000000 819.958191,1025.000000 797.468628,1025.000000 
	C789.560852,1024.565552 782.139954,1023.331177 774.332275,1024.746216 
	C773.555542,1025.000000 773.111084,1025.000000 772.333313,1025.000000 
	C769.762939,1022.034546 770.173462,1018.379395 769.226257,1014.750244 
	C768.884827,1014.319031 768.720276,1014.169312 768.288513,1013.814758 
	C767.830688,1013.486206 767.640015,1013.362427 767.148804,1013.062866 
	C766.641724,1012.770203 766.435181,1012.653381 765.921753,1012.347168 
	C760.672729,1009.661255 755.238586,1010.835449 749.681030,1009.980835 
	C748.531799,1009.635803 747.831543,1009.257690 746.896484,1008.493164 
	C746.309387,1007.764099 746.082214,1007.284485 745.839600,1006.390686 
	C745.644836,1005.200745 745.644348,1004.383423 745.586731,1003.569946 
	C745.250122,998.815674 743.706970,995.039368 737.942566,994.203003 
	C737.377441,990.372803 736.837830,986.848145 736.866089,982.265198 
	C736.720825,986.596375 737.455750,989.859863 737.362793,993.567627 
	C736.712891,994.679077 735.931702,994.929749 734.649902,995.013794 
	C733.948608,994.933411 733.673523,994.865540 733.021301,994.604248 
	C731.215088,993.290100 730.508789,991.667664 730.753784,990.021240 
	C731.463562,985.251099 729.263428,982.184082 725.209229,979.512146 
	C724.024780,968.667297 724.755554,958.196289 724.595032,947.737488 
	C724.495544,941.257568 724.461487,934.772583 724.713501,927.839966 
	C724.968872,926.206787 725.503540,925.178406 726.501465,923.934387 
	C728.710388,922.340210 730.268311,920.664551 732.000977,918.616333 
	C732.850586,918.233276 733.377014,918.142212 734.326172,918.169617 
	C740.207275,918.990234 745.727478,918.083374 751.585083,918.731750 
	C755.223206,919.857117 754.184448,921.933594 753.090759,923.897705 
	C751.225586,927.247375 749.944031,930.812073 748.819519,934.443542 
	C750.888733,929.126648 752.415405,923.558899 756.562683,918.928589 
	C763.720886,918.083740 770.441467,918.984558 777.189209,919.515625 
	C779.949341,919.732849 782.814880,920.010315 785.903198,918.805664 
	C786.996704,918.255066 787.775391,918.106934 788.956604,918.166016 
	C791.370178,919.114380 793.302917,920.418213 795.639709,920.362976 
	C797.821716,920.311340 798.312622,919.453735 796.435669,917.502747 
	C796.171936,916.321228 796.343140,915.555847 797.171875,914.605713 
	C798.932556,913.760254 800.427063,913.605774 801.911499,913.573059 
	C819.123291,913.193481 836.331909,913.003784 853.921143,914.963196 
	C856.501709,916.417908 856.825073,918.247437 855.657349,920.769653 
	C853.739624,922.553162 851.678650,921.698425 850.216125,922.005371 
	C853.379395,922.067505 856.941345,921.934021 860.815552,921.033203 
	C862.230042,920.719666 863.289734,920.615417 864.785522,920.583496 
	C866.089905,920.479919 866.967834,920.496521 868.304749,920.561096 
	C877.355347,920.641724 878.525146,921.829163 878.495422,930.424194 
	C878.479858,934.916748 878.518311,939.409363 878.467712,944.370605 
	C880.489807,964.172424 877.899109,983.503723 878.448730,1003.294067 
	C878.669006,1006.481384 878.619385,1009.194763 877.758545,1012.259766 
	C875.806213,1014.748169 873.343140,1014.404785 871.065247,1014.367615 
	C867.979492,1014.317444 866.430725,1015.561768 866.301208,1018.729187 
	C866.219849,1020.720764 865.713867,1022.676514 864.260559,1024.682739 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M1024.799316,889.750000 
	C1025.000000,891.066711 1025.000000,892.133362 1025.000000,893.600037 
	C1024.821655,894.136108 1024.643188,894.272156 1024.129517,894.400635 
	C1020.549683,893.644165 1017.731323,893.913757 1016.174561,897.847168 
	C1015.812195,898.591064 1015.534485,898.974731 1014.907043,899.526001 
	C1007.434448,900.949036 1000.236328,900.589905 993.058838,899.908997 
	C989.890381,899.608459 986.766174,898.918640 983.795654,900.242310 
	C985.327759,902.116394 983.889404,903.653015 983.703735,905.562866 
	C983.758667,908.991699 986.964111,907.125061 988.301514,908.880981 
	C990.427917,914.801819 988.566650,920.685120 989.760010,926.589539 
	C990.183960,926.857361 990.366577,926.944031 990.844849,927.103821 
	C991.786499,927.237915 992.414978,927.133423 993.386230,926.895020 
	C998.070129,926.386353 1002.408447,926.448242 1007.113037,926.807800 
	C1008.171509,927.044067 1008.852356,927.278809 1009.933594,927.261719 
	C1010.776550,927.211487 1011.261108,927.237122 1012.101868,927.423828 
	C1013.404053,928.002075 1014.173645,928.627502 1014.410034,930.095093 
	C1013.948914,931.533081 1013.021423,931.897949 1011.665161,932.223999 
	C1010.822815,932.347595 1009.970886,932.238831 1009.910095,932.414185 
	C1009.704773,933.006226 1010.301025,932.628357 1010.469604,932.633545 
	C1015.155212,932.779114 1019.914795,931.731873 1024.747314,933.770508 
	C1025.000000,934.750000 1025.000000,935.500000 1025.000000,936.625000 
	C1023.022766,939.522278 1020.189880,939.591370 1017.370422,939.609070 
	C1009.635315,939.657654 1001.899963,939.664978 993.757080,939.585938 
	C990.147034,938.538452 988.691833,939.627258 988.978088,943.050781 
	C989.107605,944.599243 988.986084,946.167419 989.000610,947.342224 
	C989.817139,945.133484 987.331055,941.783875 991.137573,940.014038 
	C992.648499,941.976746 992.660278,944.032410 992.429504,945.951294 
	C991.890381,950.433472 993.642029,952.830933 998.529419,953.309143 
	C999.519592,954.035034 999.815857,954.748657 999.934570,955.934875 
	C999.123535,959.723022 996.206970,959.078796 993.859314,959.393372 
	C991.294617,959.736938 990.030823,960.602966 991.739746,963.240051 
	C998.553528,973.753967 1003.268860,985.391785 1009.591919,996.581055 
	C1010.611267,999.703918 1012.300537,1002.152771 1013.230591,1005.305420 
	C1013.607788,1009.041565 1014.810608,1012.078308 1017.028076,1015.087158 
	C1019.148804,1017.745789 1022.358215,1015.786438 1024.728516,1017.766113 
	C1025.000000,1019.388916 1025.000000,1020.777771 1025.000000,1022.583374 
	C1023.767212,1024.101929 1022.243835,1023.963928 1020.315002,1023.995239 
	C1013.976440,1023.658691 1008.118103,1024.593140 1001.794556,1024.488159 
	C998.482178,1024.518921 995.605286,1024.421143 992.364868,1024.772705 
	C987.310730,1025.000000 982.621521,1025.000000 977.466125,1025.000000 
	C975.119385,1022.894226 975.588684,1020.294312 975.583740,1017.839661 
	C975.541382,996.678467 975.575134,975.517273 975.552124,953.876099 
	C975.594910,941.644592 975.530334,929.892761 975.588623,918.141235 
	C975.607544,914.328369 975.508606,910.541687 974.682251,906.369263 
	C974.696533,905.657227 974.718140,905.379028 974.836243,904.710083 
	C975.033813,903.673401 976.140198,903.371948 975.415649,902.164612 
	C974.947632,900.934448 974.865295,899.997986 974.902283,898.707214 
	C975.454285,896.537842 975.040710,894.934814 973.543884,893.267456 
	C970.746155,891.567017 968.040527,891.010986 965.167114,891.892334 
	C960.981873,893.176147 956.936707,891.113037 952.368652,891.430542 
	C936.794189,891.685364 921.633545,890.834290 906.065063,891.875244 
	C905.076172,891.465149 904.702271,891.039917 904.521912,890.026733 
	C904.923706,888.296875 906.059448,887.885132 907.184875,887.829834 
	C910.017517,887.690796 911.849548,886.863342 911.643188,883.488831 
	C911.548523,881.939941 912.499023,880.995483 914.318970,882.541199 
	C914.406494,884.597717 914.727783,886.308472 914.251587,887.981995 
	C914.789307,886.568970 914.388977,885.091492 914.496399,883.249756 
	C914.391724,882.307373 914.226746,881.787476 913.800049,880.910522 
	C912.108826,877.710815 909.249634,877.714722 906.691406,877.455872 
	C903.224731,877.105164 901.599548,875.382568 901.627930,871.977356 
	C901.728882,859.856934 901.158203,847.730591 902.123657,835.213379 
	C902.878723,833.990173 903.602661,833.728088 904.848633,834.452454 
	C907.430786,838.884094 905.911682,843.429138 906.412048,847.782349 
	C906.757568,850.788574 907.032959,853.847778 910.905334,854.427246 
	C911.886353,854.574097 912.914062,854.509644 913.408936,852.940186 
	C913.459961,851.813477 913.494568,851.051636 913.531372,849.891602 
	C913.553528,845.112366 913.782043,840.728333 913.283691,835.957703 
	C913.068604,835.031067 913.022217,834.493652 913.053711,833.556885 
	C913.631958,831.191528 913.567688,829.164001 913.622681,826.789246 
	C913.719910,824.087769 913.363708,821.999817 910.505310,821.623474 
	C909.087585,821.436829 907.232300,820.709167 906.523315,822.492310 
	C905.899048,824.062561 907.774780,824.562744 908.932068,825.701904 
	C909.275391,826.865479 908.765320,827.366943 907.693726,827.876343 
	C906.805176,828.099304 906.284424,828.126892 905.375122,828.019958 
	C904.244263,827.738831 903.594727,827.354675 902.796143,826.554932 
	C901.424316,824.608154 902.242981,822.333069 900.569580,820.615845 
	C899.420349,820.335571 898.550415,820.290283 897.341919,820.161133 
	C895.401550,819.698792 894.323853,818.974670 895.346252,816.755798 
	C895.668579,815.701782 895.924805,815.008240 896.420471,813.999451 
	C897.135071,813.054199 897.783936,812.643127 898.963501,812.426880 
	C899.620544,812.492188 899.877380,812.569336 900.458496,812.885376 
	C902.483521,815.747864 904.921387,816.645569 907.997009,816.585144 
	C915.453674,816.438354 922.891968,816.638367 930.322815,817.554077 
	C935.989014,818.252380 941.133057,820.006531 944.722595,824.480286 
	C948.105652,828.696655 953.702759,830.202026 956.812988,835.191162 
	C960.749573,841.326111 962.310242,847.826477 963.297119,854.938110 
	C963.312744,860.023376 964.561768,864.599548 964.452698,869.685486 
	C964.399170,870.609253 964.354431,871.130615 964.259277,872.026978 
	C964.034424,873.358093 963.735413,874.281738 963.397827,875.549683 
	C963.242554,876.322632 963.137939,876.754883 962.930054,877.489258 
	C962.606812,878.570679 962.354675,879.342712 962.404663,880.464844 
	C962.575378,881.547058 962.717834,882.333496 963.081421,883.376953 
	C965.359436,885.497681 968.224670,884.856628 970.981689,885.867065 
	C973.897949,886.707947 976.417603,887.594971 978.973633,889.294312 
	C980.496155,890.646240 980.665466,892.529846 982.414795,893.674194 
	C989.886902,895.291992 997.112793,894.408203 1004.304626,894.417236 
	C1008.086792,894.421936 1008.440308,890.073303 1011.179504,888.166199 
	C1011.748413,886.154236 1010.512207,885.478027 1009.168518,884.480713 
	C1008.555542,882.518311 1008.940002,880.664612 1007.931885,878.714478 
	C1007.538147,876.888000 1006.917847,875.494080 1006.202271,873.791199 
	C1005.803223,872.687317 1005.583374,871.864746 1005.201538,870.764893 
	C1004.901428,869.878845 1004.724548,869.281860 1004.343323,868.427673 
	C1003.911682,867.584717 1003.613220,867.024841 1003.087158,866.214172 
	C1001.551453,863.564636 1001.458679,860.701477 999.799683,858.097046 
	C999.310059,857.247986 999.019836,856.666382 998.498291,855.849976 
	C998.073425,855.235474 997.834290,854.880798 997.424316,854.250122 
	C996.914978,853.413147 996.634644,852.821594 996.217651,851.926880 
	C994.505066,847.182678 992.210876,843.107666 989.543945,838.849487 
	C988.579041,836.989441 987.675049,835.491760 986.140137,834.034302 
	C985.725037,833.656250 985.561829,833.500183 985.164429,833.096802 
	C980.820862,827.084229 978.041504,820.427124 972.897400,814.946411 
	C972.572815,814.483826 972.455994,814.291443 972.195435,813.796875 
	C971.494263,811.825134 970.586609,810.346985 969.356323,808.663696 
	C968.886047,808.013123 968.635559,807.622070 968.228455,806.900696 
	C967.668579,805.655151 967.250366,804.744629 966.572876,803.509949 
	C964.619568,799.297913 961.582581,798.340576 957.470642,798.406067 
	C942.179199,798.649780 926.912476,799.514404 911.195190,800.049316 
	C906.463989,800.415771 902.163696,800.837463 897.498169,799.637268 
	C896.690247,798.906799 896.493774,798.346741 896.668335,797.286011 
	C898.620300,795.298706 900.844543,795.524597 902.984436,795.453125 
	C919.922485,794.887024 936.854370,794.004578 953.812744,794.426697 
	C954.972412,794.455566 956.145447,794.508118 957.287048,794.218933 
	C959.028137,793.777893 958.696472,792.711609 957.824951,791.219360 
	C957.101074,790.179260 956.724670,789.421082 956.121460,788.311768 
	C952.467896,779.776550 951.714539,778.852661 944.006165,779.623169 
	C928.087708,781.214355 912.154846,780.147522 896.234497,780.498901 
	C890.119934,780.633850 889.915283,780.876831 891.987427,787.146362 
	C892.269287,788.045776 892.373291,788.570740 892.460938,789.496704 
	C892.449402,790.142822 892.406433,790.397217 892.134155,790.957764 
	C888.863037,792.211670 888.400085,789.253418 886.605896,787.670898 
	C884.460022,784.127686 882.624817,780.813354 880.943115,777.025818 
	C880.523926,775.322205 879.894104,774.056580 879.522583,772.340698 
	C879.589111,771.001343 879.893188,770.093262 880.717407,769.026245 
	C883.843750,768.712280 884.213806,771.307129 885.656921,773.256348 
	C887.951477,777.176514 891.065796,775.284058 894.257690,774.986084 
	C895.167969,774.926636 895.697998,774.953796 896.640930,775.102661 
	C911.986755,773.946533 926.946655,774.851318 942.311768,774.574341 
	C943.261169,774.573853 943.789429,774.579712 944.675537,774.594849 
	C945.904907,774.611267 946.774231,774.702393 947.912964,774.597534 
	C948.305237,774.410950 948.431335,774.292786 948.569458,773.904907 
	C948.304871,772.864197 947.855164,772.178040 947.376160,771.146606 
	C946.792236,769.462891 946.602234,768.006531 946.050354,766.324341 
	C945.825623,765.634277 945.691345,765.241028 945.418884,764.560059 
	C945.189880,764.077637 945.092834,763.885071 944.836426,763.403198 
	C944.560181,762.921814 944.443237,762.729675 944.131775,762.246216 
	C943.805542,761.751587 943.673828,761.548218 943.272705,761.086182 
	C923.183472,761.754089 903.348999,761.279175 883.521179,761.438904 
	C881.963501,761.451355 880.582947,761.834595 879.070190,763.148132 
	C878.191528,763.643005 877.649658,763.830322 876.651123,763.974609 
	C875.010132,763.907898 874.001770,763.491882 873.452515,761.851929 
	C873.641846,759.469727 874.448059,757.722046 875.792297,755.781006 
	C877.148132,754.928528 878.248474,754.913696 879.776123,755.310364 
	C888.520325,757.532959 897.048706,756.758118 905.391174,756.170410 
	C914.520203,755.527405 923.617065,755.587830 932.730042,755.469788 
	C940.306641,755.371582 940.307556,755.440613 940.315918,747.705078 
	C941.121887,746.254517 942.184326,746.008057 943.706116,745.912354 
	C948.695862,747.761658 947.914795,752.926147 950.566711,756.372620 
	C950.887390,756.848267 951.023987,757.030762 951.337280,757.502197 
	C951.810791,758.386047 952.023010,759.014648 952.366394,759.938843 
	C952.553040,760.443481 952.623596,760.646606 952.778687,761.160400 
	C952.922668,761.894836 952.964905,762.320251 953.022949,763.064514 
	C953.652466,765.214050 954.540039,766.890930 955.907227,768.654541 
	C956.169250,769.076904 956.261902,769.247009 956.449951,769.679871 
	C956.593323,770.285706 956.596497,770.628174 956.629761,771.050537 
	C956.763489,770.964417 956.798096,770.797424 956.944763,770.383118 
	C957.752991,768.272034 956.348938,767.561768 954.912842,766.502930 
	C954.053040,765.535828 953.698669,764.657471 953.206909,763.454956 
	C953.092773,762.613708 953.098694,762.128235 953.228455,761.288391 
	C953.772156,759.771667 954.532593,758.869446 955.937378,758.092285 
	C957.152466,757.653259 957.931458,757.162659 958.933594,756.340088 
	C960.530151,755.334167 961.943298,754.905212 963.854431,754.874634 
	C964.747864,754.974670 965.233276,755.130615 965.999878,755.590271 
	C967.257690,757.105469 967.259460,758.588196 967.154907,760.426636 
	C966.910095,761.826843 966.842957,762.869873 967.621216,764.130005 
	C968.516724,766.954529 968.765076,769.682617 970.630737,771.765625 
	C971.181274,772.380127 971.830688,773.045898 972.746277,772.486328 
	C973.354431,772.114624 973.465942,771.395569 973.391602,770.722656 
	C973.129944,768.353821 972.317749,766.216553 970.403809,764.213989 
	C969.872437,763.606812 969.631836,763.217896 969.389404,762.453613 
	C969.339966,761.888428 969.355469,761.660156 969.478882,761.105896 
	C969.705078,760.583069 969.823364,760.386353 970.407898,759.679565 
	C971.237610,758.874207 971.631897,758.627441 972.389404,758.315552 
	C973.446716,758.092407 974.144836,758.172729 975.127441,758.627197 
	C978.896240,762.788086 980.459778,767.907043 983.651245,772.464233 
	C984.366943,773.862427 984.775574,774.997498 985.231445,776.500977 
	C987.834229,784.935974 992.295044,792.169250 995.564880,800.303162 
	C997.025085,802.870972 996.267944,805.899231 998.734924,807.916748 
	C999.912537,808.176636 1000.774902,808.367249 1002.002869,808.356689 
	C1003.788879,807.957458 1005.237305,807.732605 1007.075684,808.188171 
	C1011.004150,814.148438 1011.686584,820.978027 1013.971252,827.254211 
	C1014.518433,828.757263 1014.635559,830.440613 1015.175293,830.937195 
	C1012.440735,820.698669 1008.337158,810.023499 1005.077271,798.656799 
	C1004.130493,795.792480 1002.323486,793.506897 1003.481140,790.274963 
	C1004.109985,789.558350 1004.599182,789.338440 1005.559753,789.282227 
	C1006.789612,789.529541 1007.379517,790.049500 1007.982910,791.119202 
	C1009.415466,796.093201 1011.421387,800.445068 1013.166138,805.293823 
	C1016.852234,817.298584 1019.980042,829.086243 1024.750000,840.713257 
	C1025.000000,848.020935 1025.000000,855.041931 1025.000000,862.531433 
	C1022.125061,864.261719 1021.689087,861.733704 1020.865601,860.167419 
	C1018.111389,854.928772 1016.151733,849.303223 1012.736450,843.412903 
	C1016.904968,853.635376 1020.917664,862.990662 1024.753418,872.757690 
	C1025.000000,875.041687 1025.000000,877.083313 1025.000000,879.562500 
	C1024.771606,880.225830 1024.520996,880.428101 1024.290649,880.650330 
	C1023.418579,881.492065 1021.445679,881.505981 1021.714722,883.088806 
	C1021.895386,884.151794 1023.714844,883.723083 1024.755859,884.772461 
	C1025.000000,886.066711 1025.000000,887.133362 1025.000000,888.600037 
	C1024.866211,889.166687 1024.732422,889.333313 1024.799316,889.750000 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1024.763184,66.771500 
	C1025.000000,67.444443 1025.000000,67.888893 1025.000000,68.666672 
	C1025.008179,69.332062 1023.936462,69.172356 1024.814209,69.907898 
	C1025.000000,71.388893 1025.000000,72.777779 1025.000000,74.583336 
	C1024.521606,75.456490 1023.938843,75.669617 1023.317505,75.895676 
	C1021.746643,76.467186 1019.869507,73.479942 1018.647156,76.136482 
	C1017.629517,78.348152 1017.177551,80.768532 1018.719727,83.354515 
	C1018.783081,83.811508 1018.816895,83.980148 1019.129028,84.172417 
	C1021.429321,84.294472 1023.059082,85.245354 1024.762939,86.775269 
	C1025.000000,90.692909 1025.000000,94.385818 1025.000000,98.539368 
	C1024.384399,99.655571 1023.668152,100.150795 1022.466553,100.471848 
	C1021.920898,100.575951 1021.698364,100.596184 1021.141235,100.588844 
	C1019.934692,100.393448 1019.109070,100.092148 1018.055420,99.533318 
	C1017.372742,99.008812 1017.072693,98.539444 1016.499329,98.081909 
	C1016.303833,98.024063 1016.001343,98.241951 1016.086304,98.434021 
	C1016.171265,98.626083 1016.446594,99.006439 1016.556519,99.233627 
	C1016.831909,99.995033 1016.847473,100.539108 1016.688599,101.375671 
	C1016.494812,101.833473 1016.386047,102.004669 1016.027466,102.356346 
	C1015.418823,102.671806 1015.049805,102.760376 1014.417114,102.790222 
	C1014.168274,102.798790 1013.754272,103.057251 1013.738281,103.329636 
	C1011.052185,108.319420 1009.480713,104.114037 1007.392456,102.732033 
	C1008.870544,104.709114 1010.275085,106.499352 1012.492126,108.006775 
	C1012.948608,108.388107 1013.116577,108.559937 1013.453857,109.052704 
	C1014.063965,113.234085 1010.825195,114.024452 1008.109680,115.564125 
	C1007.527588,115.506340 1007.304688,115.435631 1006.835388,115.125336 
	C1005.426086,113.192177 1007.346802,111.780907 1006.932617,110.023804 
	C1006.843933,109.883606 1006.601318,109.913109 1006.658813,110.102951 
	C1006.695801,111.958977 1005.612732,113.136772 1004.227905,112.548790 
	C1000.508606,110.969604 999.250610,113.843117 997.236694,116.109070 
	C996.909119,116.596817 996.761658,116.782028 996.339844,117.196037 
	C995.409790,117.762398 994.713440,117.858620 993.648438,117.681488 
	C993.112488,117.467712 992.914856,117.348312 992.483521,116.979797 
	C991.460693,114.482567 988.131897,113.996788 988.439880,110.783310 
	C988.751282,110.279411 988.943665,110.061157 989.130127,109.799515 
	C989.107483,109.993408 988.981445,110.152580 988.531250,110.385529 
	C987.281799,110.916122 986.290955,110.692184 985.496582,110.046585 
	C983.488342,108.414398 981.823975,108.316116 979.944885,110.430428 
	C978.067688,112.542641 975.819153,112.426353 973.914673,110.285919 
	C972.071533,108.214371 971.882019,106.191231 974.374878,104.356918 
	C975.475037,103.547379 976.151062,102.421440 976.033752,100.722687 
	C976.189880,100.330666 974.894958,100.663170 975.558289,100.729515 
	C975.678345,100.741524 975.643982,100.852562 975.592773,101.092033 
	C974.935547,104.166840 971.946411,104.340370 969.564697,105.588303 
	C965.913574,103.036819 963.901245,99.221672 960.105713,96.764496 
	C959.161499,95.908112 958.552063,95.210533 957.763245,94.210083 
	C957.270081,93.274963 957.191650,92.605667 957.506470,91.622742 
	C958.670654,90.499542 959.253723,89.363731 960.062622,88.032188 
	C960.472046,87.620735 960.634094,87.395729 960.709900,87.125824 
	C960.735229,87.035492 960.723083,86.986465 960.739807,86.997475 
	C960.742249,86.999092 960.685059,87.127190 960.366089,87.599289 
	C959.427856,88.592712 959.205078,89.695076 958.255981,90.716835 
	C957.025574,91.815498 956.301392,92.925323 955.173096,94.128418 
	C950.431519,92.619301 947.715820,96.437515 943.879333,97.693604 
	C942.628540,97.419975 941.819946,96.545441 940.490967,97.278229 
	C939.397400,97.959999 938.534973,98.466560 937.852356,99.635559 
	C937.533875,100.051994 937.395081,100.211922 937.014343,100.581665 
	C935.089783,101.657379 934.299316,103.994881 931.607422,103.637932 
	C931.101379,103.421692 930.917603,103.294922 930.561401,102.880844 
	C929.932068,100.112289 931.796936,98.016014 931.757263,95.305313 
	C932.139282,94.365799 934.141907,94.899460 933.013611,93.269638 
	C932.159241,92.035408 930.641174,91.546761 929.777222,89.979202 
	C929.409607,89.741982 929.219910,89.727760 929.301392,89.804512 
	C930.101257,91.691895 933.088867,92.003746 932.159546,94.803391 
	C930.467651,96.422791 928.581665,97.135490 926.945251,98.245735 
	C924.276428,100.056396 921.735352,100.924065 920.595398,96.623451 
	C920.419678,95.960335 920.327759,95.384285 919.401306,95.531067 
	C917.658447,95.807182 916.274902,95.350838 916.614624,93.267464 
	C916.919373,91.397804 918.106628,89.251389 919.911438,89.434166 
	C923.362610,89.783661 922.183472,87.373009 922.709900,85.651535 
	C922.765625,85.413643 922.350647,85.225082 922.329346,85.487579 
	C921.954712,86.545135 921.244995,86.973160 920.304199,87.616547 
	C919.690552,88.037048 919.349426,88.287041 918.775452,88.753632 
	C918.199097,89.229126 917.836426,89.455795 917.137634,89.745232 
	C916.393066,89.919991 915.957825,89.935204 915.201416,89.831711 
	C914.490967,89.604416 914.126953,89.399010 913.590820,88.924103 
	C913.017212,88.327995 912.712830,87.871284 911.965454,87.699997 
	C913.016785,92.906204 908.645752,97.648178 901.343689,98.529068 
	C900.163147,97.893272 899.492737,97.184219 898.561279,96.209000 
	C894.110779,90.064613 894.598328,88.298866 901.270630,86.475693 
	C902.063293,87.023521 902.488403,87.474716 902.707214,88.357780 
	C902.737854,88.614372 902.768005,89.075264 903.002686,89.149109 
	C903.570862,89.232559 903.895081,89.291695 904.384888,89.487228 
	C904.559692,89.574104 904.637024,89.873650 904.637024,89.873650 
	C904.637024,89.873650 904.818420,89.590767 904.617188,89.503143 
	C903.724243,88.685020 903.001343,87.985603 902.043579,87.038261 
	C900.058044,84.987213 898.771057,86.515129 897.572632,87.506882 
	C896.028137,88.785065 894.538940,90.042114 892.476318,90.394714 
	C890.864319,90.670296 888.876343,91.532555 887.949280,89.764107 
	C886.706238,87.392807 889.582031,87.498146 890.574341,86.458168 
	C891.026917,85.983818 890.645935,86.650452 890.892639,86.109993 
	C891.213806,85.406792 890.373413,85.982666 889.928711,85.636696 
	C889.354126,85.636948 889.362122,84.803146 889.046753,85.226646 
	C888.656860,85.750153 888.926270,84.891449 889.419800,85.689980 
	C887.451660,88.179771 885.278809,90.210373 881.771851,90.653503 
	C880.490356,90.195892 879.804382,89.507530 878.886108,88.555298 
	C877.187500,86.434654 876.466187,83.836617 873.345032,83.233734 
	C872.228577,83.042084 871.547302,82.670067 870.877563,82.270920 
	C870.745544,82.955406 871.394592,83.407631 871.412720,84.404488 
	C871.286011,85.220154 871.063293,85.632263 870.475830,86.218826 
	C869.780151,86.638428 869.341309,86.770523 868.547363,86.805832 
	C867.804749,86.692650 867.412537,86.546692 866.813843,86.181030 
	C866.253601,85.871407 865.916382,85.842422 865.349426,86.130783 
	C863.135254,87.480942 862.947632,90.767609 859.618835,90.672852 
	C858.045654,90.469986 857.296082,88.205521 855.406006,89.941010 
	C852.397095,91.375854 854.304199,92.563095 855.369690,94.063339 
	C855.775879,95.062279 855.769348,95.757347 855.338806,96.756042 
	C854.578369,97.559341 853.913635,97.744591 852.850098,97.564270 
	C852.039490,96.996803 852.677795,97.626007 852.194458,97.167000 
	C851.981812,96.965088 851.766846,96.770325 851.585510,96.544746 
	C851.685730,96.744400 851.865479,96.872551 852.228394,97.267899 
	C852.763000,98.165016 852.744446,98.830971 852.299561,99.805580 
	C851.499451,100.593628 850.811218,100.753937 849.718445,100.592125 
	C848.176575,100.131393 847.434875,97.566971 845.450256,99.946091 
	C844.810608,100.395470 844.398804,100.553711 843.625977,100.615150 
	C841.939819,100.249184 840.640747,99.158997 838.848938,100.390823 
	C835.966309,100.463120 834.503601,99.411514 835.107300,96.304611 
	C835.616516,95.313171 836.267944,94.687775 835.584717,93.554474 
	C834.727722,92.484596 833.764893,92.000572 832.783813,91.030441 
	C831.821838,88.917152 832.387634,87.507271 834.103333,86.603188 
	C836.018127,85.594185 837.099365,87.092949 838.612854,88.513985 
	C838.053467,86.778778 837.154785,85.977562 835.641235,85.338310 
	C833.726074,84.839073 832.864624,85.890396 831.764282,87.190170 
	C831.198669,87.794724 830.835327,88.099815 830.126587,88.545670 
	C829.114990,88.983574 828.394043,89.094040 827.286133,89.090042 
	C826.170776,88.940544 825.501465,88.653366 824.750366,87.820648 
	C824.247620,86.552681 824.464111,85.622978 824.821289,84.374786 
	C825.026978,83.859276 825.124756,83.664085 825.423828,83.221458 
	C826.108948,82.675674 826.628479,82.679604 827.167236,82.715431 
	C826.866394,82.638939 826.561829,82.609932 825.961792,82.591423 
	C822.336975,82.110626 819.384583,79.637657 815.431030,80.593826 
	C813.934021,79.672531 813.133972,78.484100 811.835693,77.310333 
	C811.229736,76.419472 811.011475,75.742798 810.774841,74.698288 
	C810.425171,72.271065 809.609436,70.191727 810.861572,67.800423 
	C811.166870,67.305550 811.306641,67.120491 811.703369,66.706192 
	C813.048889,65.765709 814.399963,65.357765 815.036011,63.647789 
	C815.307739,63.156033 815.425781,62.963108 815.744263,62.495342 
	C817.805786,57.873489 822.104919,55.836758 825.098389,52.562614 
	C826.080139,51.488811 827.272278,50.881557 828.642212,51.664646 
	C830.043579,52.465691 829.763184,53.824848 829.642456,55.208481 
	C829.412964,57.836662 827.924194,59.340378 825.435120,60.566441 
	C824.727783,61.280933 825.307251,60.639786 824.857788,61.131962 
	C824.646912,61.362892 824.305481,61.554100 824.246521,61.824734 
	C824.149963,62.268070 824.346985,62.274715 824.365295,61.784325 
	C824.389954,61.121967 824.323364,61.978935 824.859619,61.159485 
	C827.578918,59.291725 828.911621,62.105019 831.219971,62.530048 
	C831.534729,60.122242 827.142334,57.783882 830.594910,55.688148 
	C832.588440,54.478062 835.375305,56.418739 837.749634,55.106956 
	C837.097046,54.394371 836.369568,53.971718 835.676086,53.013290 
	C835.311401,52.265575 835.224243,51.800312 835.270630,50.967358 
	C835.439880,50.402760 835.548767,50.191402 835.942688,49.767914 
	C837.450195,49.137543 838.506775,49.594738 839.814087,50.369923 
	C841.175598,51.572754 842.358887,52.450336 843.964355,53.259827 
	C844.549011,53.667866 844.855347,53.934738 845.364258,54.410839 
	C846.943176,55.288059 848.210266,52.626495 849.812256,54.756622 
	C850.649353,55.675266 851.308777,56.307907 851.172119,57.612778 
	C850.663452,58.343010 850.194397,58.705654 849.978027,59.462151 
	C849.973328,59.654404 850.278442,59.785709 850.275024,59.574944 
	C850.319092,59.026577 850.443665,58.716759 850.809204,58.193237 
	C852.291870,56.371914 850.686462,55.785042 849.745667,54.594723 
	C849.161621,50.252380 851.954529,47.864025 854.611206,45.878006 
	C857.340820,43.837475 861.052429,46.863811 862.454834,52.387558 
	C861.758850,53.339718 861.124451,53.698456 859.962036,53.574730 
	C859.234802,53.186958 858.881165,52.865780 858.513123,52.562077 
	C858.288879,52.377041 858.156433,52.281116 858.131104,52.280716 
	C857.878052,52.276737 857.984131,52.370060 858.689941,52.741364 
	C859.715881,53.804932 860.537415,54.460239 861.880432,53.126724 
	C862.906616,52.264614 863.736755,51.679157 862.994995,50.473633 
	C862.425537,49.548100 862.313782,48.002071 863.245667,47.911655 
	C866.893677,47.557690 868.307434,43.026691 872.501587,43.524727 
	C873.727722,44.706417 873.272583,47.048496 875.935242,46.886253 
	C876.929321,47.945148 876.556152,50.683102 878.994568,48.381557 
	C884.197021,43.470974 884.274292,43.552811 889.425415,50.481300 
	C888.566345,52.333881 887.197205,53.312820 885.831360,54.600777 
	C887.054565,54.821880 888.062500,53.950691 889.448364,54.420891 
	C891.018005,55.459007 892.246460,56.586067 893.995789,54.665066 
	C896.105591,53.834755 897.205322,54.688236 898.161743,56.360569 
	C898.348022,56.483665 898.454712,56.809406 898.454712,56.809406 
	C898.454712,56.809406 898.681335,56.543026 898.473389,56.487503 
	C897.294312,54.586411 898.345215,53.878868 900.244507,53.545250 
	C901.035828,54.082882 900.463806,53.465103 900.929993,53.941662 
	C900.947815,53.864117 900.864258,53.845474 900.678101,53.527298 
	C900.459351,51.305588 901.610657,50.491398 903.643311,50.280006 
	C904.194763,50.419407 904.561584,50.702633 904.760986,50.456131 
	C905.176147,49.942944 904.953918,50.712513 904.479370,49.930866 
	C907.512451,45.135090 908.630615,44.756718 911.656616,47.504368 
	C911.605652,48.148140 911.185120,48.472530 911.261780,48.695774 
	C911.475525,49.317642 910.997803,48.798500 911.871216,48.411621 
	C914.992920,50.120342 918.816101,49.249516 921.448364,52.009201 
	C921.290710,52.622467 921.098755,52.871677 920.885864,53.104656 
	C920.572876,53.447136 920.168884,53.733452 920.148376,54.262787 
	C920.736328,54.056938 920.441101,53.268318 921.222290,52.778992 
	C923.830200,50.721874 926.086304,48.800472 928.026245,46.536709 
	C929.210693,45.154552 929.894287,42.283806 932.438049,44.135376 
	C935.045959,46.033646 933.598022,48.183151 931.699219,50.292400 
	C930.482422,51.502628 929.507385,52.458515 928.311523,53.673286 
	C927.278870,54.765282 926.314941,55.373779 925.037659,55.972397 
	C926.135437,55.568954 926.847107,55.025208 927.780212,54.215546 
	C928.981201,53.041374 929.939453,52.100868 931.117676,50.886459 
	C932.798462,49.317581 934.163635,47.836666 936.748413,48.675270 
	C937.576233,49.456135 937.753174,50.141602 937.528809,51.234982 
	C936.139343,53.260361 933.426575,53.995609 934.027893,56.905266 
	C934.091919,54.824802 935.250916,53.420689 937.015869,51.988701 
	C938.038574,51.025753 938.961975,51.006634 940.257324,51.296566 
	C942.213745,52.721329 943.575500,55.157009 946.316589,52.453613 
	C948.442932,49.699383 951.031677,47.802750 952.950256,44.855495 
	C953.257629,44.349728 953.396912,44.154881 953.812988,43.724651 
	C954.753540,43.138660 955.462830,43.016022 956.560364,43.141766 
	C958.214539,43.647957 958.331909,44.921761 958.897278,45.907082 
	C961.744568,50.869274 961.767395,50.862976 955.884033,51.350803 
	C955.191406,51.408230 954.432190,51.478596 954.351746,52.261097 
	C954.252258,53.228878 955.096863,53.931084 955.846252,53.931831 
	C961.921814,53.937889 968.818054,56.425953 972.492920,48.718616 
	C972.875122,47.917122 973.591980,47.335552 974.490540,47.591030 
	C977.305298,48.391335 979.592834,50.076797 981.085938,52.546009 
	C982.439819,54.784966 980.688660,56.602699 979.216125,57.658737 
	C976.089844,59.900658 973.852051,65.281204 968.494629,61.385452 
	C967.990784,61.019047 967.806335,61.272701 966.880981,65.345078 
	C967.644104,64.898949 967.200073,64.219246 967.431519,63.773609 
	C967.858032,62.952271 968.625488,62.194992 969.351074,62.627007 
	C973.489197,65.090836 975.084412,60.950504 977.723328,59.553467 
	C978.166809,59.318684 978.569763,59.002998 978.837891,58.583626 
	C983.103882,51.910950 988.573486,51.874332 994.938354,55.949440 
	C994.989563,57.367451 993.425293,58.317795 994.872681,59.871506 
	C995.605835,60.618114 996.087524,61.221939 997.086304,60.840473 
	C997.202820,60.760715 997.139648,60.599274 996.953979,60.651283 
	C996.227844,60.742680 995.746155,60.577461 995.064636,60.047112 
	C994.378357,59.218971 994.244446,58.560299 994.596558,57.519875 
	C996.271790,55.436119 997.979004,54.054173 1000.818787,54.079910 
	C1001.427734,54.200867 1001.664978,54.275558 1002.230469,54.523647 
	C1005.601929,57.595219 1010.068665,59.312336 1010.375977,64.633591 
	C1008.511353,66.224533 1007.375610,64.890968 1005.977539,63.939087 
	C1005.824951,63.799110 1005.595032,63.684643 1005.729736,63.784584 
	C1006.981689,65.063248 1008.446289,65.804214 1009.898682,67.094208 
	C1010.830444,67.845543 1011.515564,68.333542 1012.651733,67.484375 
	C1014.281433,66.112907 1015.410156,64.680473 1017.207397,63.478447 
	C1018.963074,62.900688 1020.300171,62.916073 1021.390564,64.554237 
	C1021.574463,65.109505 1021.270325,65.357216 1021.648560,65.537369 
	C1022.960144,65.301277 1023.802612,65.778610 1024.763184,66.771500 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M957.174622,758.792358 
	C955.589539,758.993164 955.011169,760.134216 953.850098,761.020142 
	C953.200989,761.416870 952.826965,761.501282 952.197266,761.224792 
	C951.976868,761.020447 952.001404,761.002441 951.990967,761.014893 
	C951.328674,760.294250 951.608521,759.351379 951.196045,758.269653 
	C950.977356,758.024048 950.997559,758.001709 950.984009,758.008179 
	C948.984375,754.201660 948.643127,749.815308 946.754517,745.971008 
	C946.726624,745.914368 946.428345,745.935974 946.294861,746.000793 
	C946.156311,746.067993 946.064819,746.232178 945.749939,746.586914 
	C944.227600,746.905334 942.908081,746.990784 941.095703,747.132324 
	C938.487793,748.991089 935.907288,748.535339 933.463135,748.595703 
	C919.216614,748.947998 904.964966,748.128723 890.705750,749.375732 
	C885.912781,749.794922 882.468018,750.645142 880.603394,755.755920 
	C879.077881,755.997803 877.937439,755.997253 876.369385,755.997437 
	C873.576843,753.960938 876.140381,750.542297 873.602173,748.206055 
	C872.607178,746.839294 872.176086,745.654968 872.358032,743.919739 
	C874.596558,738.734680 879.011719,738.835388 882.714600,739.957031 
	C888.960266,741.848755 895.207703,741.482971 901.492371,741.523804 
	C911.804565,741.590759 922.117493,741.563232 932.430054,741.532837 
	C937.776245,741.517029 943.083374,736.844177 943.676819,731.743164 
	C943.974609,729.182739 941.942993,728.747559 940.289062,728.184143 
	C936.494751,726.891296 933.540710,724.651001 931.583313,721.140808 
	C930.337585,718.906982 929.627991,716.653503 930.417053,714.000244 
	C931.879211,709.084106 929.051575,701.543884 924.407227,698.153198 
	C921.480286,695.449280 920.436768,692.190247 919.602600,688.459595 
	C921.734009,685.767395 922.620911,682.066467 927.009705,682.032593 
	C928.458984,682.212952 929.539612,682.691162 930.980896,682.102234 
	C931.928101,681.782837 932.562378,681.577576 933.209778,681.431030 
	C934.831970,681.063904 936.547241,680.541016 937.915100,681.916687 
	C939.654480,683.665894 936.651306,684.677002 937.358032,686.351746 
	C938.225220,686.412231 938.637634,686.073853 939.113892,685.323425 
	C940.377686,682.911804 938.841431,681.317444 938.120728,679.560791 
	C938.026855,679.331848 938.218323,679.042053 937.464355,679.247742 
	C933.340027,680.372498 933.306274,680.248840 932.978088,675.398682 
	C933.119202,674.853210 933.196838,674.643127 933.457275,674.156250 
	C933.982910,673.594238 934.368530,673.389221 935.123047,673.220947 
	C935.862000,673.193176 936.272583,673.226501 936.939209,673.257629 
	C937.280518,673.078796 937.363647,672.927185 937.426514,672.503296 
	C937.429016,672.043945 937.451843,671.856934 937.596802,671.407837 
	C938.127380,670.656067 938.664673,670.427856 939.583984,670.403870 
	C940.048279,670.493286 940.216125,670.552002 940.586365,670.718384 
	C940.788818,670.825928 941.150696,670.936523 941.178894,670.727051 
	C941.227356,670.013245 941.356262,669.541077 941.849854,668.914246 
	C942.280823,668.711487 942.487000,668.704895 942.918701,668.920776 
	C945.188171,670.741516 945.788818,673.194092 947.216858,676.139404 
	C946.435974,674.146240 945.828918,672.933411 946.638428,671.331055 
	C949.487915,670.238037 949.668091,672.568054 950.320557,673.470520 
	C949.536377,672.846985 950.343689,670.130798 947.340759,670.734497 
	C945.426941,671.749817 944.726013,670.153870 943.369995,669.332275 
	C941.143311,667.207886 943.277222,665.427307 943.322998,663.251099 
	C943.414307,662.705017 943.468506,662.489502 943.680908,661.981445 
	C946.450134,659.559814 944.259583,658.015686 942.989807,656.071228 
	C942.571716,655.430847 942.364075,655.047302 942.091309,654.978699 
	C941.832031,655.440430 941.652161,655.579468 941.149963,655.847717 
	C939.177856,656.351685 937.514954,656.285645 935.491028,656.060181 
	C934.418152,655.791687 933.794006,655.432373 933.051636,654.622192 
	C932.585022,653.553101 932.889343,652.962524 933.744507,652.268799 
	C934.420593,651.863647 934.815674,651.656067 935.488159,651.283447 
	C936.660767,650.510864 937.393433,649.756836 938.047485,648.497681 
	C938.740356,647.189819 938.883728,646.006226 939.806274,644.793701 
	C940.716248,644.174011 941.424377,644.043518 942.525940,644.071289 
	C944.977112,644.533447 947.069397,644.843872 949.526855,644.173950 
	C956.627869,642.607300 956.739136,642.406494 953.567932,635.985291 
	C945.916016,620.491760 938.236572,605.011902 929.104370,589.919312 
	C928.991516,588.832520 929.121704,588.133057 929.667847,587.192322 
	C930.093445,586.792664 930.296570,586.672058 930.846924,586.496033 
	C931.422180,586.486450 931.650330,586.532227 932.171143,586.764343 
	C932.788696,587.274414 933.089966,587.618713 933.573853,588.251526 
	C934.051147,588.879211 934.314453,589.244751 934.771240,589.888550 
	C937.009705,592.575623 938.195007,595.611389 940.852173,597.949463 
	C943.004028,598.997681 945.559021,598.956848 945.992798,602.096497 
	C945.381836,605.048401 946.164551,607.333862 947.730713,609.795776 
	C950.773315,617.183105 953.937195,624.127625 957.704529,631.179199 
	C960.317993,636.395386 962.419128,641.289307 962.133850,647.070496 
	C961.927734,651.247559 964.588623,654.907227 965.823120,658.845825 
	C966.628052,661.413757 967.318359,663.760010 965.414429,666.347961 
	C963.482422,668.974121 964.844116,671.741699 966.192566,674.270142 
	C967.207764,676.173706 968.525513,677.886536 969.991943,679.911987 
	C970.268799,680.416748 970.360107,680.627441 970.515320,681.173462 
	C970.586670,682.594849 970.331116,683.703430 970.990540,685.050781 
	C973.267883,690.380249 974.034912,695.939392 977.403809,701.209656 
	C978.977539,699.024292 980.541321,696.820801 983.473999,697.045227 
	C986.339539,697.264526 988.245605,699.168945 990.314941,700.831421 
	C991.713318,701.954834 992.912109,703.461731 995.265198,703.582153 
	C996.312927,703.565918 997.002808,703.467651 998.028320,703.163330 
	C998.871765,702.988525 999.364502,702.941895 1000.240356,702.958374 
	C1004.005310,703.747192 1005.308105,706.437012 1006.332336,709.298889 
	C1008.956909,716.632751 1012.336609,723.685425 1014.671326,731.115234 
	C1016.252319,736.146362 1018.374512,740.260925 1024.703613,740.758057 
	C1025.000000,741.750000 1025.000000,742.500000 1025.000000,743.625000 
	C1019.576721,746.981750 1019.558838,747.060181 1023.840210,750.472046 
	C1024.491333,751.305847 1024.506592,751.962524 1024.193970,752.934937 
	C1023.416565,753.999756 1022.425293,754.588745 1022.746216,756.164795 
	C1022.764526,756.958679 1022.686035,757.410278 1022.374817,758.170349 
	C1021.677307,759.054260 1021.040161,759.400330 1019.905823,759.473755 
	C1017.208862,758.142029 1016.930725,755.659241 1016.264465,753.504089 
	C1012.238220,740.481201 1007.099976,727.858215 1002.525940,715.033264 
	C1001.885681,713.237793 1001.360291,711.301514 999.059692,709.109558 
	C999.524170,713.571777 1000.795471,716.740234 1002.029480,719.893250 
	C1007.420227,733.666992 1011.630859,747.852661 1016.688171,761.742126 
	C1017.087952,762.840027 1017.273682,763.990723 1017.440674,765.525940 
	C1019.409607,775.825195 1023.889404,785.136475 1024.772705,795.683350 
	C1025.000000,801.354919 1025.000000,806.709900 1025.000000,812.532410 
	C1022.407959,812.895020 1022.551758,810.590942 1022.079773,809.047546 
	C1016.115173,789.545349 1009.784485,770.138000 1004.623474,750.415955 
	C1002.641602,742.842224 998.396057,737.048035 994.005310,731.117737 
	C991.874634,728.240051 988.682190,728.063477 985.099365,729.204346 
	C984.582886,729.523438 984.374878,729.645386 983.852783,729.937073 
	C981.018433,730.909424 981.501099,732.654358 982.062988,734.533386 
	C983.255981,738.522522 984.806763,742.381775 986.288879,746.648804 
	C989.180664,755.297180 992.131592,763.542175 995.291992,772.113159 
	C997.762207,781.268921 1001.987976,789.391785 1004.763000,798.440430 
	C1005.549438,802.009216 1007.276306,804.949951 1007.170654,808.657410 
	C1005.492004,808.991211 1003.968811,808.896484 1002.233032,809.820862 
	C997.608459,799.310181 994.836426,788.187622 991.034790,777.404785 
	C988.121704,769.142090 984.020752,761.275208 982.556885,752.132324 
	C982.393921,750.319580 981.527710,749.069275 981.483398,747.612000 
	C981.495056,748.820190 982.016052,749.898865 982.416748,751.399292 
	C984.206238,762.897522 989.920227,772.693604 992.993225,783.367310 
	C993.805603,786.189087 995.505493,788.835571 994.560181,792.311768 
	C991.776672,793.754517 991.823914,791.288635 991.185852,790.122437 
	C989.145020,786.391968 988.393433,782.133423 986.430664,777.953186 
	C985.683655,776.274109 985.119507,774.922302 984.262573,773.314758 
	C982.068054,770.088318 981.868286,766.555908 980.761597,763.333679 
	C979.559326,759.833435 978.484131,756.152222 975.249756,753.672791 
	C975.063477,755.346008 975.791809,756.967651 974.946411,758.789490 
	C973.965759,759.020691 973.254272,759.030823 972.187561,759.059387 
	C971.693237,759.244202 971.554199,759.410583 971.197876,759.819092 
	C970.980591,760.061218 970.988403,759.991943 971.021484,759.980957 
	C970.802673,760.195007 970.558472,760.428162 970.153992,760.858765 
	C969.986023,761.048279 969.987061,760.994568 970.013489,760.999268 
	C969.069641,761.924622 967.979614,762.512146 966.283997,762.006836 
	C965.985352,760.131897 965.985779,758.497620 965.988159,756.454468 
	C966.009766,755.546265 966.850708,755.094543 966.219910,754.619324 
	C965.912964,754.388062 965.406616,754.765076 964.885010,755.324890 
	C963.116394,756.005676 961.543091,756.439758 959.569824,756.945312 
	C956.793213,755.494080 958.086365,758.152954 957.174622,758.792358 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M905.040405,50.651653 
	C903.235779,50.970154 901.589539,51.148159 901.044678,53.645493 
	C899.613281,54.231117 898.034119,54.283722 898.898621,56.725403 
	C897.203918,57.128975 896.603821,54.684185 894.068054,54.855625 
	C892.381653,53.612499 891.458618,52.390133 889.479980,51.437496 
	C888.940308,49.897049 888.189392,48.573780 887.383728,48.898476 
	C883.044617,50.647366 884.476196,47.237629 884.497986,45.201942 
	C882.009155,45.967381 880.733276,47.405380 880.040588,49.316803 
	C879.324646,51.292305 877.381409,51.851677 876.087708,51.440517 
	C873.856506,50.731403 875.952698,49.004345 876.122437,47.044819 
	C878.236389,44.251827 880.362549,42.341896 882.804626,39.802254 
	C879.890198,42.144409 875.546143,38.343830 873.520813,43.532387 
	C871.479248,43.952385 869.969910,44.085094 869.218445,45.648170 
	C868.042908,48.093426 866.314209,49.383293 863.403381,48.300297 
	C863.689392,50.511158 866.491333,51.318142 865.327332,53.337639 
	C864.756042,54.328804 863.591003,53.066521 862.334656,53.033699 
	C862.301331,49.495853 858.564026,48.885708 857.245728,46.486221 
	C856.764282,45.609898 855.082642,46.125050 854.690308,46.984089 
	C853.472168,49.650902 850.400208,51.093975 850.005737,54.625084 
	C848.220764,54.060841 847.742676,55.078888 846.854675,56.531212 
	C845.258728,59.141552 845.294678,56.742649 845.003540,55.338177 
	C845.069946,53.893620 845.662476,53.000916 846.338257,51.803814 
	C847.288208,50.234825 846.815369,48.576996 847.932129,47.075356 
	C848.426086,46.640907 848.724426,46.497646 848.985291,46.307312 
	C849.800171,45.712898 851.539124,45.688850 850.770813,44.057465 
	C850.475037,43.429478 848.900452,42.944164 848.670166,43.157646 
	C847.812805,43.952450 849.136292,45.037781 848.503540,46.343204 
	C846.443726,48.965042 842.119446,46.088303 840.497925,50.540386 
	C838.895264,50.694153 837.792969,50.385063 836.346558,50.040634 
	C833.995300,47.140923 836.878235,46.085819 838.105591,44.473343 
	C839.788086,42.262711 839.842896,42.304447 836.847656,41.008400 
	C836.366577,41.300270 836.167603,41.412712 835.636536,41.630867 
	C831.310242,40.197655 831.300964,40.119244 834.710938,34.777473 
	C835.046509,34.292706 835.190308,34.106716 835.578369,33.669395 
	C837.304749,32.352955 838.696594,31.192677 839.975281,29.412491 
	C840.366150,28.984352 840.537170,28.825504 841.011841,28.489452 
	C841.972656,28.046696 842.662231,27.926975 843.709717,27.835024 
	C844.748230,27.804485 845.428894,27.887175 846.402344,28.194941 
	C846.918091,28.379541 847.129883,28.430471 847.660522,28.535267 
	C848.897156,29.084665 849.406372,30.097544 850.697998,30.566372 
	C851.812927,30.823462 852.635803,30.991253 853.605103,31.657215 
	C854.492004,32.356747 855.104065,32.981453 856.123047,32.032112 
	C856.511841,31.637611 856.610474,31.524811 856.411743,31.609581 
	C855.641846,32.244251 854.952576,32.368046 853.960327,31.951180 
	C851.901367,29.724878 849.735474,28.370298 846.694946,27.946512 
	C846.184631,27.284794 846.007324,26.832085 845.829102,25.978279 
	C845.732117,24.536148 845.891541,23.522676 846.754028,22.314743 
	C847.468567,21.687176 847.937195,21.366756 848.702881,21.023056 
	C849.167542,20.872248 849.335022,20.744726 849.752563,20.810232 
	C850.174927,21.557753 850.347351,22.112246 850.762329,22.837700 
	C851.773010,23.613340 852.481812,24.291309 853.545288,25.000736 
	C853.986145,25.240831 854.166199,25.333578 854.625488,25.546539 
	C857.922180,26.399811 858.358643,22.846439 860.901367,22.171532 
	C862.122742,22.017653 863.017395,21.984581 864.156799,22.350216 
	C864.653564,22.674061 864.825012,22.812393 864.773621,22.788458 
	C863.907043,21.907160 862.885498,22.067135 861.501831,21.402348 
	C861.325562,18.675505 861.227661,15.438269 864.777405,18.675863 
	C865.944641,19.740494 866.554016,19.451485 867.732910,18.905851 
	C869.479919,18.097282 869.575439,18.269312 869.722656,20.373728 
	C869.895020,22.838459 873.647766,21.840181 873.645691,24.457031 
	C875.454041,24.406214 875.413330,22.825253 875.965210,21.348701 
	C880.392883,23.914162 884.845886,23.677002 889.849365,20.132044 
	C890.538452,19.643879 891.144531,18.851786 891.960388,19.284399 
	C893.108704,19.893284 891.754395,21.028725 891.868591,21.179020 
	C893.522217,23.356079 895.849365,23.015984 897.985291,22.257761 
	C898.973938,21.906822 899.829956,20.812532 900.446594,19.861164 
	C901.675232,17.965649 903.109985,17.520760 905.052490,18.673635 
	C905.611267,19.005219 906.168823,19.397757 906.781006,19.568142 
	C908.084290,19.930889 909.469849,16.206776 910.525391,19.292767 
	C911.422058,21.914221 914.710144,25.384699 909.440857,27.398230 
	C909.237305,27.476036 909.198853,27.986046 909.041748,28.647568 
	C908.795837,29.206289 908.586853,29.406906 908.372925,29.602331 
	C908.159119,29.797569 908.231750,29.733706 908.795349,29.205112 
	C909.762573,29.284378 910.548645,29.519268 911.282349,29.865345 
	C912.513062,30.445850 913.711426,33.036846 914.529114,31.852293 
	C915.519470,30.417780 918.166504,29.783314 917.628662,27.688848 
	C916.713318,24.124462 919.625000,25.172041 921.201904,24.063650 
	C922.230408,26.408443 918.965637,30.717993 925.057068,30.662094 
	C921.786621,27.475136 925.277832,23.781569 923.150940,20.621281 
	C922.697205,19.947050 923.587891,18.611290 924.726685,18.503283 
	C925.808228,18.400717 925.823059,19.454529 926.036194,20.250959 
	C926.549316,22.167660 926.776123,23.936403 926.296936,26.038485 
	C925.629944,28.963921 926.780762,30.850002 930.418518,29.587803 
	C933.375671,28.561739 935.138306,31.137808 937.326477,32.349052 
	C938.128174,32.792850 938.875183,33.095589 939.518372,32.293175 
	C939.951416,31.752920 940.054688,30.842951 939.371094,30.543537 
	C935.367188,28.790060 939.241943,27.843210 939.677429,26.488472 
	C940.135315,25.064001 942.233032,25.490892 942.347900,23.867605 
	C942.553833,20.959494 944.059143,22.032255 945.280945,23.004423 
	C946.434265,23.922104 947.400574,25.078310 948.427002,26.150835 
	C949.294739,27.057514 949.073792,29.861963 951.239014,28.412996 
	C952.865723,27.324381 951.261414,25.750629 950.537354,24.521955 
	C950.229736,23.999969 949.773010,23.565830 949.301086,22.990570 
	C952.314270,21.329479 955.001892,19.847883 958.064453,18.159559 
	C958.907837,21.142628 960.026733,23.913916 962.678589,25.968859 
	C963.459290,26.463869 964.004150,27.182915 964.580322,26.961863 
	C965.101013,26.762079 964.760498,27.310265 964.313965,26.823849 
	C964.127136,26.620319 963.718018,26.591797 963.219177,26.207722 
	C963.263306,23.999149 964.291748,21.992840 966.304932,22.485363 
	C968.236511,22.957914 970.243591,24.274696 971.419373,26.213850 
	C971.596863,26.506582 971.365845,27.085516 971.246948,27.510580 
	C971.058044,28.186277 968.514954,26.892437 969.994080,28.819059 
	C970.789795,29.855608 972.274292,30.232670 973.497070,28.950726 
	C974.824219,27.559494 975.723694,25.475456 978.621582,26.001266 
	C979.000000,26.000839 979.161194,26.159180 979.080566,26.079170 
	C979.522095,23.415951 980.705994,21.695444 983.728455,22.373356 
	C984.047241,22.444855 984.365295,22.520002 984.683655,22.593449 
	C985.930481,16.717213 993.593872,20.307062 995.471191,15.296066 
	C995.679993,14.738729 996.749573,14.346083 996.741638,13.888829 
	C996.601318,5.792904 1003.851990,6.790943 1008.565125,4.215132 
	C1007.425232,2.468691 1005.820068,2.882159 1004.402832,3.393065 
	C1002.383850,4.120963 1000.833923,4.099166 1000.045410,1.365997 
	C1007.589355,1.000000 1015.179749,1.069602 1022.767212,0.950070 
	C1024.617310,0.920923 1025.105103,1.347357 1025.052124,3.224102 
	C1024.903076,8.499428 1025.000000,13.781709 1025.000000,19.530624 
	C1021.044189,22.259010 1016.447998,20.861664 1012.877991,22.479708 
	C1013.607178,22.834219 1014.678101,24.039696 1016.311707,22.582649 
	C1018.910522,20.264805 1019.676819,22.032099 1019.888489,24.836815 
	C1019.755127,25.411802 1019.672791,25.635443 1019.392700,26.158669 
	C1017.537354,27.763748 1016.164612,29.584669 1013.426636,29.298683 
	C1012.344543,28.302145 1011.480530,27.628479 1010.939575,27.473070 
	C1011.337769,27.484751 1011.991394,28.208752 1012.994385,28.979542 
	C1013.476196,33.124481 1011.282959,33.329403 1008.570068,32.037441 
	C1006.807007,31.197836 1005.244324,29.905401 1003.401245,28.637564 
	C1003.411804,29.871632 1004.127319,31.205349 1002.890991,32.053612 
	C1001.521729,32.993118 1000.101929,32.382343 999.316345,31.423492 
	C995.913269,27.269676 993.344238,28.877443 991.258789,32.539711 
	C989.117737,36.299446 986.117737,34.708614 983.035095,34.481548 
	C982.694092,34.934669 982.546875,35.109779 982.143799,35.517143 
	C980.194092,36.817616 978.288696,37.946209 977.357483,39.569927 
	C974.668762,44.257942 969.701233,43.263058 965.750732,44.411968 
	C962.908081,45.238705 963.391602,42.293060 963.593323,40.351704 
	C961.332947,41.092983 960.217773,43.736687 957.304688,43.833363 
	C956.250427,44.002285 955.501831,44.009342 954.379028,44.018242 
	C953.265076,42.970654 953.102417,41.184479 951.051392,41.758553 
	C951.924683,42.656445 953.100464,43.244614 953.793823,44.731380 
	C953.599304,48.990414 948.997437,49.618141 947.347107,52.943783 
	C946.012573,52.930382 945.298523,52.324387 944.298096,51.532021 
	C941.835449,49.096344 937.784180,47.228966 942.201111,44.494041 
	C941.538818,45.649651 939.063232,46.111851 937.498840,48.537132 
	C934.740784,48.333313 933.795227,51.133247 931.369385,50.992756 
	C929.890320,48.682922 934.926758,46.703964 932.021667,45.075069 
	C928.951050,43.353359 930.408569,48.536449 927.989258,49.030937 
	C925.481384,49.543530 925.048767,53.520866 921.389526,52.998802 
	C920.856934,52.175842 920.419495,50.885914 919.708130,51.272354 
	C916.200806,53.177773 914.237183,50.299358 911.378540,49.008762 
	C910.850037,47.422028 911.143982,45.145828 908.447815,47.080864 
	C907.190674,47.983173 905.380981,48.382015 905.040405,50.651653 
z"/>
<path fill="#F9FAF4" opacity="1.000000" stroke="none" 
	d="
M1.311775,513.248047 
	C1.000000,494.645782 1.000000,476.291534 1.000000,457.468658 
	C1.163923,456.977173 1.440063,456.884247 1.475811,456.941498 
	C5.095425,462.736481 4.896380,469.269165 5.925933,474.929718 
	C10.817677,467.835876 15.235187,459.211609 19.208611,450.340759 
	C19.948610,448.688690 20.436632,446.889923 22.296019,445.530212 
	C24.525667,444.890991 26.664528,445.620117 28.743725,444.046997 
	C36.840244,442.964233 44.452152,444.955566 52.532566,444.813904 
	C57.560490,447.838409 62.733917,446.081207 67.986809,446.418823 
	C69.291985,445.874054 70.304588,445.745880 71.739212,445.781067 
	C72.672928,445.907684 73.181488,446.078827 73.990112,446.569702 
	C77.295616,453.717133 76.493813,460.757355 74.680580,467.678162 
	C71.377800,480.284363 66.224411,492.029510 57.494999,501.947998 
	C56.728001,502.819519 55.980537,503.703003 54.517990,504.316772 
	C49.010551,501.672424 44.365204,502.938202 39.674309,505.741699 
	C33.399273,509.492004 26.425331,511.711945 19.574629,514.131836 
	C13.563974,516.255127 7.537765,515.690674 1.311775,513.248047 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1013.139771,108.859619 
	C1008.369080,108.820557 1007.999146,103.337166 1004.308472,101.954414 
	C1004.231567,101.925613 1004.305908,100.956505 1004.572754,100.703918 
	C1004.820740,100.469185 1005.645813,100.406151 1005.829468,100.612404 
	C1007.021301,101.950897 1009.075562,101.801315 1010.144897,103.595062 
	C1011.494751,105.859261 1012.647644,105.129761 1012.992554,102.371941 
	C1013.753723,101.998810 1014.503235,102.001671 1015.627625,102.000755 
	C1016.002441,101.996986 1016.318909,102.322746 1016.318909,102.322746 
	C1016.318909,102.322746 1016.280518,102.282234 1016.139038,102.142624 
	C1015.996765,101.250717 1015.995972,100.498413 1015.990234,99.369980 
	C1016.382812,98.671570 1016.837158,98.522247 1017.664185,98.742294 
	C1018.822327,99.109421 1019.664551,99.280190 1020.716431,99.698463 
	C1021.032532,100.350037 1021.289307,100.503700 1021.845886,100.204330 
	C1022.531860,99.108177 1023.407166,99.009033 1024.662231,99.004089 
	C1025.000000,108.020897 1025.000000,117.041786 1025.000000,126.531342 
	C1023.932983,130.508865 1019.531982,131.961090 1019.457153,136.394592 
	C1019.671875,137.684509 1020.323792,138.401077 1020.864258,139.587463 
	C1021.557495,142.484940 1021.494873,145.043564 1020.977600,147.958618 
	C1020.373047,149.309753 1019.431152,149.977707 1018.490662,149.659332 
	C1015.568298,148.670029 1013.082458,150.092010 1010.104126,150.748810 
	C1009.535950,150.616730 1009.319153,150.525604 1008.852295,150.186981 
	C1007.289551,148.326096 1009.886841,146.586655 1008.211548,144.762726 
	C1007.534607,144.171585 1007.078247,143.836441 1006.251831,144.387512 
	C1006.718445,147.483047 1005.565369,150.231720 1005.452759,153.055283 
	C1005.325684,156.240067 1003.673645,156.134842 1001.502258,154.788910 
	C1000.153442,153.952820 999.833496,151.266159 997.092773,152.717041 
	C996.644653,153.105591 996.450806,153.248047 995.923584,153.540405 
	C995.106018,153.808456 994.615295,153.843124 993.753906,153.711761 
	C993.176514,153.478043 992.964111,153.341324 992.543091,152.887543 
	C991.953918,151.588181 991.986389,150.606201 992.513123,149.305298 
	C994.394531,147.339508 996.345337,146.235611 998.271362,146.200195 
	C996.161011,147.632019 993.124207,145.403748 990.282227,147.407303 
	C988.482971,148.880844 986.972473,150.146423 985.393677,151.316727 
	C982.696472,153.316116 981.148438,152.821228 981.371460,148.888977 
	C981.828308,148.197235 982.152283,147.852463 982.489685,147.519577 
	C982.714539,147.297592 982.919250,147.056824 983.116638,146.810364 
	C982.837036,146.998856 982.691467,147.311646 982.204285,147.787018 
	C981.236572,148.753510 980.350586,149.016937 978.997803,148.928848 
	C978.412292,148.810638 978.184387,148.739487 977.639526,148.507233 
	C975.452820,146.615097 972.589722,145.552109 973.362244,142.313110 
	C967.388916,146.246277 963.231201,152.316116 956.411743,155.452850 
	C954.581360,153.026733 954.581360,153.026733 956.066895,149.082520 
	C953.847229,151.520370 952.051331,152.287735 949.907104,150.260086 
	C949.273376,149.255371 949.051453,148.424347 949.392700,147.667465 
	C950.244202,145.779266 949.935913,145.597275 948.129333,146.534698 
	C946.635742,147.309662 944.646057,145.223587 942.909668,147.352600 
	C941.026855,147.960434 939.834717,147.621017 939.321411,145.574646 
	C939.413269,144.840271 939.643494,144.525528 939.758667,144.460632 
	C938.269470,146.060104 936.790833,147.336716 935.868530,149.441422 
	C935.555969,149.885406 935.411621,150.047302 934.989319,150.362244 
	C933.569214,150.464981 932.900818,150.757401 933.602051,152.373260 
	C933.546143,152.924728 933.493774,153.146347 933.308838,153.689163 
	C932.641785,154.903748 932.922607,155.985382 932.554565,156.891953 
	C931.723938,158.937820 930.217346,158.965317 929.340576,157.231583 
	C927.498779,153.589417 925.161499,149.999268 926.078613,145.226318 
	C926.327026,143.996918 928.257690,144.008255 927.345154,142.257721 
	C927.370728,141.715668 927.410645,141.499619 927.581116,140.981812 
	C929.443237,139.122192 926.556519,136.799454 928.848328,135.088226 
	C929.842346,134.207428 930.543030,133.482224 931.405762,132.620636 
	C931.551514,132.467606 931.861328,132.138763 931.861328,132.138763 
	C931.861328,132.138763 931.741577,132.251022 931.578125,132.411774 
	C930.728088,133.242844 930.055908,133.927567 929.144714,134.833496 
	C927.125854,136.012772 925.750793,137.602036 923.502686,138.455688 
	C922.482971,138.714371 921.815918,138.646317 920.945557,138.066437 
	C920.505493,137.482956 920.562256,136.889252 920.228821,136.766907 
	C919.615417,136.541992 920.335144,136.581360 919.806274,137.356384 
	C918.797058,137.613495 918.179260,137.405029 917.393005,136.723938 
	C916.068359,134.456390 912.905579,134.241913 912.421631,131.422668 
	C911.916748,131.361725 911.713989,131.297455 911.223572,131.071121 
	C909.054016,129.232132 906.024536,127.684380 910.600464,125.321236 
	C911.089294,125.257553 911.277405,125.749237 911.389893,125.084885 
	C911.215637,123.408875 911.864502,122.557114 913.491211,122.294312 
	C913.705750,122.289284 914.015869,122.378403 914.015869,122.378403 
	C914.015869,122.378403 914.229675,122.143875 914.072510,122.032608 
	C912.246887,120.712791 910.539734,120.054924 908.352356,120.566605 
	C906.353516,121.034164 905.156738,120.046112 905.485962,117.498764 
	C906.366699,116.040504 907.651428,115.399162 908.641846,114.009781 
	C910.176331,112.997612 911.617859,113.006676 912.493591,114.096260 
	C915.084412,117.319511 917.692383,116.485519 920.670715,114.445404 
	C921.147827,114.590271 921.393066,114.594360 921.501587,114.301491 
	C921.217224,113.709351 921.212708,113.238594 921.392944,112.474510 
	C921.624634,112.018623 921.754883,111.851768 922.169189,111.527687 
	C924.142700,111.491600 925.897156,111.703026 925.870728,108.845581 
	C926.576904,108.418404 927.046936,108.350143 927.889404,108.467499 
	C930.996338,110.558052 934.200317,112.173126 934.429993,116.439453 
	C933.808167,117.237450 933.306030,117.638428 932.366455,117.690620 
	C932.126282,117.680855 931.807861,117.513756 931.807861,117.513756 
	C931.807861,117.513756 931.525208,117.721252 931.713440,117.774475 
	C932.766846,118.256676 933.283386,117.663933 934.083008,116.919678 
	C935.925293,114.978554 937.011475,112.420685 940.431885,113.455757 
	C942.263000,116.174957 946.586609,118.570778 940.924927,121.494980 
	C940.379150,121.508698 940.328979,121.071350 940.243164,121.364029 
	C940.757446,122.067421 940.745850,122.643105 940.422913,123.503906 
	C939.523193,124.366356 939.048828,125.179207 938.247864,125.925491 
	C938.976318,125.438690 939.208618,124.743324 939.950867,124.047150 
	C942.773010,123.505333 942.702515,118.205719 946.618164,120.231621 
	C946.495361,119.324280 945.556702,118.904350 944.933777,118.215965 
	C942.989136,116.067017 941.671387,114.055939 946.261597,113.773018 
	C946.591431,113.752678 946.226807,112.890327 946.344910,112.100815 
	C946.657288,111.382721 946.983032,111.041061 947.237976,110.649887 
	C947.370789,110.446114 947.442383,110.238197 947.439087,110.236191 
	C947.014709,109.979584 946.924683,109.941620 947.167786,110.122284 
	C947.406250,110.299507 947.380920,110.543968 946.873169,111.093872 
	C945.855225,111.984329 944.952820,111.978317 943.691040,111.640228 
	C942.982483,111.201477 942.700317,110.829597 942.485718,110.031090 
	C942.517395,109.455086 942.580750,109.230507 942.862000,108.735413 
	C944.156860,107.652771 945.254211,106.866219 946.526001,105.758118 
	C947.234314,105.412148 947.673828,105.336647 948.452271,105.428886 
	C948.962280,105.630325 949.148193,105.750244 949.549500,106.119118 
	C950.142517,106.891670 950.407410,107.489586 951.016724,108.240738 
	C951.305481,108.682068 951.406677,108.866760 951.607666,109.348373 
	C951.856384,110.879311 952.317017,111.966232 953.386414,113.093872 
	C953.890808,114.036285 953.972412,114.768066 953.842651,115.707230 
	C953.805481,115.888687 953.602356,116.150307 953.739563,116.020630 
	C954.117798,114.160774 955.399170,113.233711 956.882385,112.061409 
	C957.417847,111.544487 957.745239,111.275513 958.356201,110.869843 
	C958.814636,110.653976 959.006653,110.595825 959.492554,110.541229 
	C960.160461,110.658043 960.515625,110.813286 961.095032,111.137703 
	C961.515747,111.263603 961.688843,111.272423 962.101685,111.156479 
	C962.487427,110.906609 962.633545,110.781494 963.016541,110.470047 
	C963.756897,109.920288 964.296875,109.600304 964.848511,108.825760 
	C965.144714,108.397339 965.266663,108.230301 965.597046,107.838242 
	C966.556396,106.978424 967.487610,106.556984 968.529175,105.356613 
	C969.940674,104.738472 972.025879,105.441849 971.368896,103.639435 
	C970.214172,100.470932 970.651917,100.395416 973.196045,102.171631 
	C974.522705,103.097939 974.865784,102.240768 974.818481,100.994247 
	C974.792786,100.316322 973.137024,99.860809 974.402649,99.157593 
	C974.902527,98.879845 976.077759,99.271263 976.612793,99.738770 
	C977.313965,100.351334 978.019409,101.377907 977.454834,102.363274 
	C976.740417,103.609940 975.972351,105.165596 974.807495,105.747658 
	C971.878174,107.211479 974.086548,108.339012 974.819946,109.507568 
	C975.913879,111.250435 977.799500,111.811157 978.778198,109.962875 
	C981.510071,104.803604 984.052002,106.925514 986.852661,109.697052 
	C987.143188,109.984512 987.793335,109.908577 988.635864,109.998657 
	C988.054504,113.521156 993.700745,112.854767 992.987061,116.623672 
	C993.002441,117.002136 992.649597,117.340492 992.649597,117.340492 
	C992.649597,117.340492 992.695679,117.305077 992.846619,117.151527 
	C993.747681,116.993889 994.497864,116.989799 995.623047,116.993736 
	C996.527039,117.522957 996.746460,118.154526 996.545349,119.207901 
	C995.527649,120.514084 994.547852,121.416168 993.398682,122.592316 
	C992.986084,123.023033 992.782654,123.217667 992.564148,123.395241 
	C992.293396,123.615334 992.350464,123.572266 992.945679,123.061020 
	C994.024780,121.994034 994.887878,121.127426 995.971069,120.028038 
	C996.518555,119.557541 996.870972,119.377655 997.529663,119.273529 
	C997.791199,119.254547 998.259705,119.137512 998.247925,118.866402 
	C998.251648,117.823471 998.520447,117.148468 999.051086,116.377510 
	C998.389893,116.990822 997.681152,117.762909 996.227905,117.207077 
	C996.063354,113.365685 999.383301,112.097534 1001.335022,109.888908 
	C1002.367432,108.720596 1002.667786,110.470695 1003.290710,111.046204 
	C1005.096313,112.714203 1005.811157,111.733658 1006.003784,109.362839 
	C1012.525574,109.589752 1005.955383,112.632309 1007.012207,114.634064 
	C1006.402283,115.592903 1005.803040,116.184349 1004.989746,117.006088 
	C1002.942444,118.716583 1005.025208,120.262886 1004.653870,121.968323 
	C1004.607239,122.162331 1004.609863,122.455856 1004.711670,122.310715 
	C1005.846313,120.602867 1003.610840,119.387856 1004.520386,117.579697 
	C1005.306946,116.695724 1005.925781,116.085487 1006.764587,115.229675 
	C1009.781189,114.138580 1011.719971,112.318871 1012.990967,109.364822 
	C1013.000000,109.000305 1013.327515,108.680664 1013.327515,108.680664 
	C1013.327515,108.680664 1013.279541,108.719536 1013.139771,108.859619 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M1.219102,607.216309 
	C1.000000,602.975464 1.000000,598.950928 1.000000,594.463196 
	C2.590767,592.445374 4.621028,592.602478 6.592183,592.597961 
	C13.020710,592.583130 19.449268,592.541565 25.929092,592.649902 
	C26.043329,591.121887 25.453135,589.712341 25.590536,587.849243 
	C25.585894,586.617554 25.613039,585.792419 25.712410,584.550171 
	C26.067833,582.659119 26.770605,581.538818 28.769386,581.186401 
	C29.964306,581.209839 30.718521,581.433594 31.838566,581.738037 
	C33.757824,582.257263 35.303852,581.941895 36.510468,581.079163 
	C39.920914,578.640686 43.377621,579.149719 47.211761,580.788635 
	C48.360195,582.462402 48.368225,584.042236 48.413734,586.016235 
	C48.401638,587.765564 48.935326,589.069275 48.689064,590.837830 
	C48.311985,592.037292 47.849018,592.705750 46.764313,593.323059 
	C45.715729,593.473999 45.052986,593.525146 44.538033,593.459351 
	C56.501194,591.694702 68.683594,592.964844 81.215973,592.569824 
	C84.399323,592.586609 87.193024,592.621521 90.313095,592.585449 
	C91.232887,592.512268 91.764633,592.356567 92.022881,591.433167 
	C92.067940,590.534424 92.164658,589.938110 92.551315,589.094910 
	C93.215057,588.402222 93.800354,588.202515 94.734695,588.122803 
	C95.589043,588.154297 96.142570,588.262085 96.949890,588.099976 
	C97.503471,587.845764 97.801201,587.663818 98.297165,587.301758 
	C98.778725,586.911316 99.041595,586.673340 99.457611,586.209717 
	C100.046867,585.380432 100.283936,584.705872 100.252800,583.650146 
	C100.247337,582.271118 100.619484,581.291321 101.196884,580.036804 
	C102.109711,578.646545 102.336014,577.359558 102.738846,575.775269 
	C108.605858,566.729858 113.678009,557.575195 119.675743,549.017517 
	C120.958321,547.187500 120.914436,545.745239 119.598495,543.761841 
	C119.467873,543.198853 119.458336,542.965454 119.560814,542.400513 
	C121.099655,540.619629 123.302704,541.836548 125.058762,540.384277 
	C126.649429,539.245789 127.509628,537.990967 128.017090,536.094910 
	C128.236084,535.568542 128.343750,535.366516 128.690125,534.917725 
	C129.341705,534.476624 129.774796,534.376282 130.545746,534.488953 
	C131.192123,534.957886 131.599503,535.307983 131.222061,535.878662 
	C131.482178,535.773254 131.574356,535.539551 131.485535,534.853333 
	C133.146820,531.108948 135.666382,528.270020 138.089111,524.951416 
	C138.606689,524.342163 138.925507,524.013550 139.513474,523.464294 
	C145.628906,518.357422 150.933731,512.863403 157.064926,507.765381 
	C157.900436,507.098480 158.531464,506.795868 159.592377,506.692291 
	C160.575851,507.082397 160.984177,507.643768 161.454208,508.586792 
	C161.687225,509.349792 161.727371,509.798828 161.621582,510.576050 
	C161.319595,511.497955 161.030243,512.073242 160.715912,512.975891 
	C160.536163,513.464111 160.453308,513.654724 160.164124,514.077271 
	C159.588654,514.493835 159.199356,514.596436 158.496017,514.526733 
	C157.902527,514.281311 157.644119,513.808472 157.348709,513.899902 
	C156.720917,514.094116 157.302780,513.636780 157.467926,514.576294 
	C157.341278,515.051758 157.237366,515.227417 156.906372,515.613525 
	C155.646591,516.532349 154.543839,517.154541 153.561127,518.446411 
	C152.571960,519.595337 151.671219,520.347839 150.448853,521.295532 
	C137.068909,533.209717 127.732887,547.877991 118.494186,562.476379 
	C103.524567,586.130432 90.204407,610.724121 80.158073,636.934692 
	C72.099266,657.959900 66.454102,679.739746 60.591892,701.442261 
	C52.296654,732.152100 42.464851,762.414734 33.944988,793.060120 
	C32.481487,798.324280 32.108673,803.457703 33.242023,808.826050 
	C34.547909,815.011719 36.184479,821.140564 36.836002,827.458496 
	C37.024288,829.284424 37.444550,831.089905 36.247231,833.132690 
	C34.993282,834.022095 33.951420,834.061401 32.524479,833.573486 
	C31.669056,832.956421 31.136419,832.448547 31.070795,831.795654 
	C30.632572,827.436096 27.720297,826.121826 23.599899,825.682129 
	C22.246746,822.989624 24.380590,822.766357 25.763718,822.480957 
	C27.866961,822.046814 29.310099,821.339722 28.476038,818.947327 
	C27.565060,816.334290 28.485008,812.285339 24.600462,811.783630 
	C21.446297,811.376221 17.870882,811.701416 16.226692,815.960327 
	C13.331062,815.557617 13.888439,813.332275 13.656352,811.529175 
	C13.332138,809.010437 14.393795,806.364136 12.753404,803.611816 
	C12.317555,802.792053 12.170424,802.281006 12.086856,801.336792 
	C12.263810,799.531555 12.695519,798.227661 13.833975,796.800720 
	C14.937532,796.191650 15.736572,796.163330 16.886171,796.605591 
	C18.682154,798.656616 18.379148,800.885498 18.479145,803.004700 
	C18.596704,805.496155 19.838449,806.533936 22.283827,806.479431 
	C24.641539,806.426941 25.313013,805.108276 25.533535,802.994385 
	C26.178177,796.814819 25.696623,796.251892 17.478161,794.720947 
	C15.480055,793.353699 15.879265,791.107971 14.466742,789.327332 
	C13.892189,787.875244 13.857598,786.781311 14.373721,785.299805 
	C15.517095,783.806641 16.734030,783.303101 18.565107,783.513123 
	C19.933039,784.412292 20.128407,785.572754 20.314266,786.713135 
	C20.584133,788.368835 21.334225,789.476257 23.169422,789.547058 
	C24.896324,789.613647 26.485035,789.373535 27.522726,787.773254 
	C27.793016,787.356445 28.014278,786.909546 28.185936,786.443909 
	C29.217352,783.645691 31.072374,780.456665 30.275007,777.922974 
	C29.167032,774.402405 25.139763,777.191101 22.553246,776.256836 
	C21.790321,775.981262 20.940365,775.928162 19.943962,775.243469 
	C19.218670,773.905579 19.519413,772.963989 20.470440,771.818359 
	C22.069099,770.735840 23.553717,770.597473 25.026772,770.637146 
	C34.289425,770.886414 32.880184,769.324219 34.982887,762.917236 
	C35.238430,762.138550 35.437958,761.341980 35.789997,760.222717 
	C36.598637,757.796082 39.859962,756.682922 38.182407,753.360962 
	C40.116913,742.611511 44.085140,732.778320 46.870209,722.603516 
	C47.785015,719.261414 48.846371,715.958374 49.703903,712.190552 
	C55.162144,694.399963 59.573017,676.717590 64.898796,659.299866 
	C67.418358,651.059875 70.258377,642.923340 73.456680,634.511475 
	C74.813675,631.493958 75.948105,628.797852 76.917038,625.651855 
	C77.297035,624.657837 77.622887,624.033020 78.113937,623.108887 
	C79.434807,621.190369 80.468781,619.506226 81.180443,617.284729 
	C81.866966,615.694763 83.123077,614.679688 82.732468,612.796631 
	C82.205811,611.849304 81.688263,611.276123 80.774429,610.672485 
	C80.164055,610.294922 79.818916,610.064514 79.221985,609.630615 
	C77.475128,608.107483 76.056068,607.638733 74.644989,610.045288 
	C73.821884,611.036682 73.071388,611.542419 71.789787,611.764038 
	C70.494209,611.722046 69.747040,611.213257 68.752205,610.465759 
	C68.306519,610.138611 68.127609,610.008850 67.683014,609.681152 
	C67.062508,609.214783 66.712067,608.940796 66.099564,608.451904 
	C64.857849,608.711182 65.390419,604.215454 63.153336,607.585815 
	C62.145493,609.104187 59.220970,607.524109 56.866230,607.787048 
	C55.979393,607.906006 55.961182,606.575317 55.200104,607.505676 
	C54.974705,608.122986 54.690262,608.391235 54.054802,608.731628 
	C53.097965,609.017639 52.434357,609.022949 51.434395,608.883606 
	C49.273567,608.553528 47.676075,606.725891 45.340187,608.187256 
	C44.026310,608.690979 42.810356,608.604431 42.618954,607.519531 
	C42.034241,604.205566 41.299442,607.541077 40.369427,607.565552 
	C39.614178,607.883179 39.158413,608.003906 38.334305,608.140808 
	C37.490986,608.218872 37.007271,608.216370 36.164009,608.135986 
	C35.090660,607.928833 34.449680,607.630249 33.765060,606.793640 
	C33.798916,604.459900 33.798916,604.459900 29.619673,605.810852 
	C27.123507,607.808044 26.427685,611.033325 23.246387,612.419006 
	C22.243517,612.838806 21.535017,612.882751 20.477036,612.601257 
	C19.965050,612.303894 19.789244,612.143372 19.457348,611.667603 
	C19.197704,610.900391 19.166197,610.444519 19.349422,609.686401 
	C19.638317,609.165344 19.771626,608.925415 19.866842,608.667664 
	C19.980606,608.359558 19.909763,608.405823 19.480919,609.051575 
	C18.817720,609.968750 18.193089,610.504333 17.304974,611.214233 
	C16.836006,611.441162 16.631636,611.494751 16.111540,611.521973 
	C14.613157,611.357178 15.440085,608.757263 13.193943,609.467773 
	C12.515093,609.154541 12.272050,608.579041 11.640833,609.040283 
	C11.555638,609.438171 11.511585,609.604065 11.325949,610.005493 
	C11.035316,610.361694 10.886268,610.482422 10.475122,610.740662 
	C9.647284,611.113892 9.061152,611.289673 8.168612,611.553345 
	C7.436553,611.711426 7.009387,611.733215 6.260380,611.652832 
	C5.109193,611.334778 4.372715,610.890381 3.402321,610.213867 
	C2.996243,609.873108 2.844054,609.726013 2.500054,609.328125 
	C2.027841,608.524048 1.837047,607.923279 1.219102,607.216309 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M74.840340,633.711121 
	C65.669945,659.359558 59.072823,685.531921 51.295582,711.717773 
	C47.061558,710.528381 50.462631,707.428345 49.636131,704.844116 
	C49.679348,703.920715 49.745380,703.400513 49.922630,702.507751 
	C50.533913,700.721191 50.669209,699.224060 51.042915,697.407593 
	C52.980499,692.435547 55.040401,687.863708 54.664627,682.701599 
	C54.583576,681.588196 55.117001,680.083496 53.908257,679.513794 
	C52.691029,678.940063 51.299446,679.562439 50.214115,680.348694 
	C43.752407,685.029846 36.847572,683.605774 29.965309,681.762573 
	C28.733681,681.432739 27.584110,680.651611 26.304396,680.267883 
	C22.650393,679.172302 18.358521,681.745667 17.544739,685.563538 
	C16.741859,689.330383 16.741859,689.330383 13.065853,690.786865 
	C13.304577,692.574280 14.996060,692.242126 16.045969,692.790283 
	C17.723045,693.665955 20.644453,693.716125 20.252333,696.202087 
	C19.852489,698.737061 18.231916,701.148987 15.309848,701.858337 
	C9.055930,703.376465 5.194603,699.580811 1.245107,695.248413 
	C1.000000,693.285645 1.000000,691.571289 1.000000,689.428467 
	C2.457305,687.667053 4.013675,687.883118 5.863194,688.915222 
	C6.325124,689.337036 6.533038,689.548950 6.756371,689.743652 
	C6.981336,689.939819 7.177501,690.158752 7.329947,690.417542 
	C7.614831,690.156982 7.631665,690.015564 7.395851,690.065735 
	C7.109094,690.126648 6.892264,690.021667 6.577633,689.416138 
	C5.717583,688.325684 7.975483,686.279175 4.900689,686.244934 
	C2.307445,686.216187 3.164436,682.714539 1.236147,681.232178 
	C1.000000,670.979126 1.000000,660.958191 1.000000,650.468628 
	C1.115907,649.462891 3.465255,649.526428 1.213771,648.205078 
	C1.000000,647.250000 1.000000,646.500000 1.000000,645.375000 
	C1.694744,644.300781 2.728876,644.217407 3.262846,644.762085 
	C5.542400,647.086853 7.346237,644.258789 9.387098,644.350525 
	C9.354437,642.990784 8.229136,641.982117 8.149210,640.275391 
	C8.119775,639.454468 8.203866,638.995972 8.556511,638.259888 
	C11.205388,638.157288 13.772304,637.772400 16.242456,639.348022 
	C16.910889,639.194824 17.368204,639.833008 17.506365,639.454773 
	C17.651361,639.057800 16.999382,638.951538 16.385317,638.557861 
	C15.441805,637.496399 15.375146,636.642822 16.406841,635.583984 
	C17.170198,635.225830 17.641644,635.135620 18.481773,635.158569 
	C21.728954,636.677673 24.309994,638.804810 27.621607,635.263062 
	C29.231915,633.540894 32.016003,634.651306 34.118484,636.598755 
	C34.868992,637.842102 34.190815,638.563049 33.831558,639.345154 
	C34.690636,639.027527 34.950653,638.250427 35.430122,637.213379 
	C37.747833,634.773071 37.574055,631.265930 40.327957,629.087891 
	C40.789330,628.742126 40.995567,628.635315 41.546139,628.484253 
	C42.347233,628.515198 42.760040,628.689514 43.317383,629.249268 
	C43.942928,630.581543 44.880367,631.062561 46.064659,631.749084 
	C47.813663,633.458313 43.671104,634.904907 46.545013,636.540466 
	C47.443954,636.894714 48.035004,636.852478 48.849693,636.275269 
	C51.236336,634.183289 53.410877,634.201355 54.987530,636.537415 
	C56.182129,638.307434 57.336971,638.573242 59.298492,637.550171 
	C59.553894,637.473816 60.007652,637.409607 59.910385,637.180786 
	C58.853565,635.921692 57.268955,635.271606 57.845398,633.133423 
	C60.236855,632.452087 62.282074,627.374084 64.610580,632.939514 
	C63.795513,634.134033 63.272701,635.072266 63.715538,636.546387 
	C64.552216,637.592224 65.754730,637.805542 66.143051,639.215332 
	C66.146790,639.853821 65.651382,640.059021 65.651337,640.142029 
	C65.650978,640.803589 65.361061,640.156311 66.108025,639.828125 
	C66.249756,638.281799 65.328545,637.789307 64.161255,637.082703 
	C63.481457,636.301086 63.518410,635.640137 63.644722,634.665955 
	C64.762291,633.178162 65.685577,631.896606 67.611343,631.387207 
	C68.146706,631.322266 68.361923,631.318115 68.894302,631.320679 
	C71.651382,630.420593 73.932594,629.931702 74.840340,633.711121 
z"/>
<path fill="#0F050A" opacity="1.000000" stroke="none" 
	d="
M933.798584,590.177368 
	C933.445496,589.976746 933.190369,589.660461 933.100342,589.611572 
	C932.786621,588.890686 932.516113,588.232117 932.206360,587.240967 
	C931.991638,586.958984 931.987732,587.007324 932.011963,587.005737 
	C931.522583,586.496338 930.974182,586.023132 930.318176,585.159241 
	C926.739807,575.254150 919.865479,570.318176 909.404114,569.681763 
	C904.739746,567.564270 904.296509,563.265198 908.385010,559.481750 
	C915.593018,562.490112 922.886292,562.429871 930.059631,562.956299 
	C933.171997,563.184753 936.321350,562.909607 939.751038,563.885620 
	C941.511292,564.006958 942.878479,564.124817 943.132812,564.249756 
	C943.072021,564.235474 941.934937,564.003845 940.372192,563.943726 
	C934.758362,561.988281 929.059570,564.121765 923.503662,561.815552 
	C921.989990,560.191711 922.565369,559.060486 924.009399,557.780823 
	C925.035156,557.198181 925.780823,557.031799 926.912292,556.994995 
	C928.330872,557.203308 929.396362,557.422546 930.675232,556.611816 
	C931.361511,556.362183 931.768677,556.302673 932.477783,556.357361 
	C933.310608,556.560669 933.847412,556.743774 934.697754,556.524109 
	C935.351318,556.306519 935.740479,556.220886 936.452393,556.156982 
	C936.980225,556.178589 937.192383,556.208984 937.716064,556.337769 
	C938.226685,556.530762 938.425781,556.625488 938.912720,556.885742 
	C942.855652,558.429321 946.524475,559.457520 950.637695,557.369019 
	C951.646606,557.075439 952.335388,557.046570 953.360840,557.242432 
	C954.671570,557.732422 955.505920,558.627136 957.045593,558.153442 
	C958.244568,557.888611 959.134766,557.820435 960.362793,557.751099 
	C961.145020,557.730896 961.590759,557.742493 962.367432,557.788574 
	C963.132324,557.861877 963.558960,557.948730 964.268433,558.196411 
	C965.070129,558.176575 964.703186,559.610779 965.800903,558.699951 
	C966.443237,558.389771 966.842163,558.315430 967.553406,558.367432 
	C968.352600,558.496216 968.836670,559.101379 969.638306,558.317261 
	C970.996033,557.803589 972.094910,557.866577 973.537476,558.078247 
	C974.332703,558.231567 974.786255,558.336304 975.593689,558.487671 
	C978.643921,558.705078 981.325684,559.187805 984.436462,558.845215 
	C989.195007,559.764038 993.620300,559.636536 998.471436,559.568054 
	C999.192261,559.554504 999.482727,559.559265 1000.208252,559.622070 
	C1006.571411,560.778564 1012.543152,561.456055 1018.575439,561.577759 
	C1020.516052,561.616882 1022.518372,561.310242 1024.645874,562.728943 
	C1025.000000,570.020935 1025.000000,577.041931 1025.000000,584.531433 
	C1023.753967,586.213745 1022.355347,585.786926 1020.624390,585.278259 
	C1018.948364,584.715576 1017.597900,584.896240 1015.890747,585.169067 
	C1014.798340,585.254822 1014.064392,585.212891 1012.952271,585.102905 
	C1010.558960,584.595825 1008.500793,584.376892 1006.106689,583.844727 
	C993.761658,577.566772 983.375854,574.462158 974.227600,574.551819 
	C977.343445,576.076782 979.756165,577.497925 981.329285,579.910034 
	C983.424316,583.122314 982.724365,584.801147 978.875610,585.268555 
	C975.098877,585.727234 971.268311,585.838928 967.485657,586.054993 
	C956.980957,586.654968 946.823181,589.236267 936.083313,590.749634 
	C935.138428,590.792847 934.626831,590.651733 933.798584,590.177368 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M50.660069,703.906616 
	C51.674633,706.562317 49.695049,708.974915 50.800758,711.797180 
	C48.080734,726.047546 43.203957,739.523193 39.032642,753.594604 
	C33.402454,757.052795 28.221514,755.475586 22.764118,752.515137 
	C21.083700,752.459961 19.800833,752.444153 18.153999,752.419678 
	C16.389523,752.362305 14.987181,752.293274 13.758596,753.874756 
	C13.294916,754.298401 13.090418,754.453674 12.529804,754.777588 
	C9.195227,755.691650 6.191744,755.550293 2.780787,755.076782 
	C2.139584,754.808899 1.899959,754.664062 1.330167,754.259583 
	C1.000000,736.979126 1.000000,719.958191 1.000000,702.468628 
	C3.434132,700.956787 5.819205,702.581909 8.269583,702.137329 
	C9.058924,701.994080 10.335081,702.589722 10.203693,703.324341 
	C9.529523,707.093750 12.668777,707.323853 14.743717,707.992249 
	C16.565540,708.579163 17.391016,709.396362 17.581799,711.135071 
	C19.190113,709.894226 19.874426,707.814514 21.401257,706.607544 
	C23.081976,705.279114 25.161486,704.402649 27.398813,704.431702 
	C31.185986,704.480835 34.992981,705.160706 38.667095,703.511841 
	C39.573368,703.105103 40.557537,703.467102 41.325569,704.341675 
	C45.102821,708.642883 45.396103,708.629211 49.515297,704.416870 
	C49.747047,704.179871 50.013210,703.985046 50.660069,703.906616 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M1.243884,103.246208 
	C1.000000,87.312439 1.000000,71.624878 1.000000,55.468658 
	C3.672742,53.089680 6.065437,50.819283 9.311151,48.617851 
	C5.896972,50.344093 4.295988,48.452137 2.911440,46.492088 
	C1.473816,44.456902 2.604537,42.817944 4.073097,41.262932 
	C5.798289,39.436188 7.546201,38.852440 9.652759,40.620674 
	C10.410077,41.256367 11.346028,41.639984 12.413279,42.443222 
	C13.649074,43.737762 14.792107,44.645443 15.654392,45.816738 
	C15.021604,44.775536 14.010094,44.084698 12.952415,42.968910 
	C12.252886,39.517311 15.722092,39.198486 16.904781,37.101421 
	C18.508583,34.257675 20.471888,35.611713 22.750019,36.838486 
	C24.361986,37.706524 25.676720,34.284134 28.297318,35.263290 
	C28.852268,35.512882 29.058056,35.652077 29.477940,36.101898 
	C30.218241,37.631161 30.229759,38.876499 29.741684,40.480118 
	C27.174398,43.274696 25.176264,46.122746 22.645105,48.389595 
	C23.950905,47.593399 24.707359,45.992992 26.328024,45.473194 
	C28.181017,44.878883 29.491840,45.884411 30.781590,46.942913 
	C32.136074,48.054543 34.044361,48.800362 33.472385,51.410217 
	C32.840649,52.173996 33.420464,51.571892 32.953125,52.047314 
	C32.720539,52.283916 32.488964,52.521229 32.267521,52.768230 
	C32.497566,52.593464 32.649178,52.345070 33.096397,51.902588 
	C35.310566,47.930172 38.055939,45.737103 42.556297,46.984489 
	C43.902184,47.357536 45.084904,47.965885 45.380524,49.449768 
	C45.725128,51.179527 44.386200,51.697647 42.819588,52.338234 
	C42.290886,52.533474 42.090019,52.622299 41.608917,52.843708 
	C39.749454,55.196236 42.548664,54.758263 43.291843,55.908699 
	C43.755352,56.204044 43.934155,56.331921 44.357536,56.679283 
	C45.066139,57.363060 45.505360,57.851013 46.177193,58.576973 
	C46.498268,59.028316 46.603462,59.225697 46.803837,59.746384 
	C47.296852,63.363438 44.493683,65.243568 43.343536,68.222145 
	C42.857384,69.637367 42.242485,70.575485 41.132927,71.552994 
	C40.375999,72.267136 39.573608,72.657372 40.375847,73.801987 
	C40.743309,74.138466 40.892578,74.274750 41.252731,74.634857 
	C42.077625,75.682541 42.565239,76.620018 43.754845,77.357803 
	C44.109207,77.757515 44.224342,77.940956 44.374863,78.446732 
	C44.350037,78.975105 44.289825,79.181145 44.060024,79.653488 
	C43.752579,80.069489 43.614723,80.219193 43.261929,80.564346 
	C42.730465,81.138626 42.231209,81.470200 42.907951,82.278778 
	C43.224491,82.670448 43.345211,82.838509 43.584312,83.303314 
	C43.840595,84.259850 43.781265,84.903931 43.374077,85.819168 
	C41.732140,87.384857 39.804626,88.108490 38.460007,90.047318 
	C36.741581,91.131035 35.377590,92.122292 34.239647,93.855202 
	C30.738159,94.504204 27.296474,97.435226 24.171745,93.069336 
	C23.820723,92.623230 23.699739,92.429901 23.478188,91.909653 
	C23.257544,89.222412 25.170134,88.109726 26.655495,86.363998 
	C27.777760,85.251106 28.818077,84.512619 29.779690,83.229584 
	C30.594494,82.306160 31.446674,82.058952 32.376350,81.522179 
	C32.542355,81.379356 32.842319,81.345131 32.842319,81.345131 
	C32.842319,81.345131 32.635246,81.135551 32.543419,81.327576 
	C31.805447,81.961861 31.000366,82.105766 30.148216,82.854401 
	C29.022776,84.103745 28.075590,85.051315 26.817806,86.177628 
	C25.148102,87.768608 23.864054,89.277306 22.297510,90.457123 
	C20.186691,92.046860 18.382000,92.097099 17.536955,88.795250 
	C18.401907,87.720970 18.934008,86.704720 20.040813,86.159439 
	C19.158438,86.323685 18.957273,87.129417 18.197990,87.794380 
	C16.134024,90.168739 17.978844,91.578217 18.973419,93.167488 
	C20.417200,95.474564 23.255424,96.771553 23.688782,100.116417 
	C23.520767,100.680351 23.411385,100.893288 23.021879,101.334259 
	C21.829086,102.005234 20.892694,102.024948 19.646265,101.529663 
	C18.950411,101.002998 18.670414,100.511536 18.123835,100.352249 
	C18.435583,100.460793 18.698246,100.646645 19.140684,101.150970 
	C18.917490,105.690697 15.743945,108.458496 11.908129,107.862213 
	C11.435831,107.788803 10.927696,107.316574 10.500600,107.570786 
	C5.520439,110.535072 3.757654,106.464836 1.243884,103.246208 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M1024.683960,492.752472 
	C1025.000000,497.356903 1025.000000,501.713806 1025.000000,506.535339 
	C1022.761353,507.830475 1006.982056,509.059753 1005.107300,508.198669 
	C1003.237000,507.339630 1001.950806,508.566742 1000.416687,508.885712 
	C998.289734,509.327911 996.177917,509.423035 993.734741,508.811951 
	C991.379211,506.947876 989.864136,508.483002 987.959961,509.659515 
	C986.333069,510.212128 984.880188,510.417542 983.765686,509.651978 
	C981.657227,508.203522 979.792969,508.327423 977.847900,509.829224 
	C977.324097,510.233673 976.545715,510.777618 976.052124,510.600952 
	C970.508362,508.616913 964.766602,511.952240 959.254150,509.912659 
	C958.945435,509.798462 958.560974,509.439453 958.349854,509.552246 
	C953.289062,512.255554 947.642151,509.705841 942.477295,511.353241 
	C942.004639,511.503967 941.486938,511.966278 941.085876,511.842102 
	C936.251038,510.344910 931.399841,512.481079 926.689270,511.813477 
	C924.149231,511.453491 921.959961,510.991882 919.549927,512.078125 
	C918.196167,512.688232 916.531799,513.110107 915.184753,512.303772 
	C913.033936,511.016266 911.131897,511.202820 909.126343,512.476746 
	C908.421204,512.924622 907.373413,513.349731 906.748474,513.001282 
	C902.423218,510.589661 898.514954,513.037354 894.118286,513.813599 
	C893.548279,513.665161 893.329163,513.573486 892.834595,513.258179 
	C891.673645,511.514343 890.682007,510.889069 889.031311,512.216492 
	C885.770325,514.838562 882.991333,513.455933 880.992310,510.589935 
	C879.279846,508.134766 875.355713,506.429962 877.809082,502.085571 
	C882.524536,499.894989 887.259399,500.635223 891.824951,500.131561 
	C898.544495,499.390320 905.279724,498.751099 912.477417,498.433624 
	C918.759094,498.468414 924.526611,497.052460 930.826904,497.515076 
	C933.538391,497.026093 935.819763,496.589630 938.495605,495.848206 
	C947.577637,495.269623 956.230286,495.433777 965.340332,495.367493 
	C978.074768,496.083649 990.194153,494.114319 1002.355408,493.079773 
	C1006.487732,492.728241 1010.591736,492.773224 1015.139648,492.575562 
	C1016.138123,492.569855 1016.702637,492.559174 1017.672363,492.486023 
	C1018.606384,492.316132 1019.137573,492.213104 1020.067261,492.046753 
	C1021.814575,491.783508 1023.148132,491.729492 1024.683960,492.752472 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M918.243591,1024.697754 
	C916.611084,1025.000000 915.222229,1025.000000 913.416626,1025.000000 
	C912.211365,1023.169861 915.234070,1022.682068 914.354187,1020.566223 
	C912.390015,1021.190002 912.708191,1023.480408 911.236938,1024.749023 
	C909.933289,1025.000000 908.866638,1025.000000 907.399963,1025.000000 
	C905.789124,1023.697571 905.455444,1022.080383 905.397583,1020.386963 
	C904.578857,996.431946 904.251526,972.471008 904.550110,948.502747 
	C904.560608,947.660034 904.775391,946.857727 905.283813,945.666382 
	C905.699768,945.037842 905.899597,944.816528 906.456299,944.345947 
	C908.538147,943.575989 909.380432,942.660400 909.609192,940.624695 
	C910.742371,930.539795 917.040833,927.512268 925.718689,933.501953 
	C929.719849,936.263672 933.309875,938.418091 938.255676,937.991028 
	C939.887085,937.850220 941.684875,938.376343 941.083618,941.140015 
	C938.610840,942.876770 936.004089,942.447083 933.591003,942.947205 
	C928.194580,944.065735 924.601990,947.634949 924.510986,953.123657 
	C924.296509,966.056702 924.404175,978.995056 924.497437,991.931213 
	C924.531616,996.669800 928.202087,998.172974 931.823608,1000.286011 
	C933.221191,1003.155457 931.329163,1003.798096 929.555603,1004.328674 
	C925.650879,1005.496887 924.444458,1008.073975 925.109985,1011.937073 
	C925.678772,1015.239075 925.458557,1018.275391 921.492859,1019.530518 
	C919.163940,1020.267578 919.660522,1022.874756 918.243591,1024.697754 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M969.828125,682.517883 
	C970.138550,682.001587 970.201416,681.800293 970.221252,681.285645 
	C972.607605,681.068665 974.920471,680.275391 977.171143,679.636963 
	C978.985229,679.122375 981.266418,677.824036 978.067627,675.365540 
	C977.613403,675.101624 977.434326,674.996399 976.992065,674.738159 
	C975.824707,673.886475 974.854126,674.224609 973.573120,674.374084 
	C973.070129,674.221008 972.887756,674.097595 972.572510,673.664185 
	C973.999756,668.167419 977.078430,666.349121 982.557861,667.196777 
	C983.998962,667.419678 985.493286,666.792603 986.978210,667.118042 
	C990.428101,667.874023 990.814636,669.257507 988.202209,672.501343 
	C987.659607,672.422119 987.496521,672.354065 987.609497,672.451050 
	C990.647583,670.879272 995.167175,673.375183 996.970154,668.960938 
	C998.973816,669.823059 1001.007019,669.120605 1002.993347,668.946777 
	C1005.195007,668.754150 1006.884583,668.935547 1006.878235,670.559204 
	C1007.006836,670.865173 1006.359924,670.326294 1006.672241,669.174072 
	C1009.618164,667.676819 1011.876221,668.720032 1013.939758,670.434631 
	C1010.406433,666.451965 1014.153442,666.781189 1017.143005,666.502136 
	C1015.649780,663.692078 1012.965942,661.623596 1014.080200,658.315063 
	C1014.447021,657.225891 1015.130127,655.207397 1015.828674,655.765869 
	C1019.333252,658.567566 1021.469177,653.747375 1024.729736,654.778748 
	C1025.000000,669.020874 1025.000000,683.041809 1025.000000,697.531372 
	C1021.584045,699.288879 1018.688965,698.753235 1016.526611,695.266846 
	C1016.525696,694.324341 1017.143677,694.119934 1017.147278,693.707764 
	C1016.364258,694.371460 1016.143616,695.560974 1015.323364,695.575684 
	C1008.940002,695.690002 1004.881104,699.989746 1000.211975,703.895935 
	C999.599915,704.326050 999.227722,704.501953 998.544189,704.649658 
	C997.586060,704.303467 996.966187,703.845764 996.070923,704.453064 
	C992.431458,706.289124 990.982788,703.250000 989.116150,701.469849 
	C983.676025,696.281738 980.760254,696.714050 977.663086,703.687622 
	C973.121887,698.463135 972.261353,691.871277 969.974731,685.523743 
	C969.458008,684.432068 969.508240,683.634155 969.828125,682.517883 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1019.192139,26.185688 
	C1018.631897,23.053249 1018.649475,23.082674 1016.503967,24.363272 
	C1013.412659,26.208426 1012.033691,22.496946 1009.585266,22.072147 
	C1009.078247,21.984188 1009.911072,20.637430 1010.498230,20.099405 
	C1011.283203,19.380131 1012.215088,18.880772 1012.877991,20.225996 
	C1014.052612,22.610004 1014.535278,21.649225 1016.288757,20.355356 
	C1018.376587,18.814972 1021.591431,19.805313 1024.662109,19.964733 
	C1025.000000,31.354227 1025.000000,42.708454 1025.000000,54.531342 
	C1020.311035,54.402351 1015.014954,56.004082 1011.485474,51.185738 
	C1011.022400,50.553555 1010.203979,50.121117 1009.029480,50.621552 
	C1008.621277,50.974201 1008.459412,51.121605 1008.020874,51.455139 
	C1005.809692,52.283222 1003.958557,53.065205 1002.307373,54.849216 
	C999.447266,54.176147 997.975525,56.748207 995.377930,56.991165 
	C992.553406,55.408886 989.094666,56.226673 987.046265,53.629910 
	C986.851501,53.383099 985.878723,53.336227 985.698486,53.553860 
	C983.095825,56.695084 977.513184,58.860363 977.031128,61.368923 
	C976.060181,66.420845 972.957336,63.842491 970.965942,64.677528 
	C970.256104,64.975174 969.799255,62.966244 968.373718,63.794876 
	C968.346863,64.171326 968.179810,64.674286 968.306702,65.086922 
	C968.648071,66.197517 970.888855,66.892426 969.346924,68.335915 
	C968.399841,69.222534 967.192261,67.969055 967.152527,67.187233 
	C967.074524,65.650917 962.809998,66.600159 965.303040,63.914932 
	C965.977051,63.188992 966.849182,62.716389 966.621216,61.472816 
	C966.424988,60.402576 964.007874,59.426617 966.197998,58.296474 
	C967.484314,57.632767 968.234497,59.208817 968.941345,60.003151 
	C972.927734,64.482735 975.555054,59.882885 977.495850,58.070190 
	C982.278320,53.603378 981.955444,53.227192 973.879211,48.392838 
	C973.151733,53.555355 964.960632,57.566517 960.265747,54.908955 
	C958.578857,53.954105 958.349915,54.932182 957.745850,55.994793 
	C957.103333,57.125153 955.537781,57.100563 955.441528,56.163296 
	C955.177429,53.592670 950.929932,54.682331 951.772400,52.496086 
	C952.343872,51.012959 953.890869,47.782665 956.959290,49.987431 
	C958.153687,50.845730 959.150635,51.402500 960.696228,50.025421 
	C959.511902,48.239651 955.921021,47.650051 957.190552,44.217113 
	C958.941406,42.299900 960.965759,40.686306 962.782837,38.865852 
	C963.438293,38.209057 963.615173,36.870590 964.882263,37.691513 
	C965.999146,38.415138 966.264526,39.550354 965.325623,40.649605 
	C964.571167,41.532951 963.353455,42.558853 964.751587,43.466782 
	C966.578430,44.652939 966.716125,42.663788 967.320740,41.613670 
	C967.821045,40.744637 968.861389,39.666882 969.551758,40.847412 
	C972.190491,45.359386 973.353088,41.087486 974.856812,40.001045 
	C977.046448,38.418919 978.465393,35.834518 981.633972,35.007866 
	C983.095398,36.019806 982.717651,37.207142 982.324707,38.457298 
	C983.571106,37.465565 983.411987,36.491898 982.246094,35.245174 
	C981.986206,33.467327 982.013489,31.832821 983.782166,31.296892 
	C985.719666,30.709820 985.685181,32.407246 986.197083,33.599991 
	C986.862976,35.151726 987.717224,34.184185 988.417969,33.496155 
	C989.710938,32.226505 991.611023,31.152027 992.146851,29.610085 
	C994.128723,23.906593 996.175964,26.262672 998.499939,29.222385 
	C999.000366,29.859703 999.725525,30.328407 1000.376099,30.837746 
	C1000.999451,31.325830 1001.672241,32.104511 1002.482422,31.277689 
	C1003.221252,30.523796 1002.783081,29.694464 1002.141846,29.128855 
	C1000.954407,28.081362 1000.876953,26.944599 1001.734131,24.995443 
	C1003.551575,28.070618 1006.748169,28.734035 1008.907593,30.863146 
	C1010.880188,32.808029 1012.077454,31.831688 1012.956787,29.354919 
	C1015.385620,29.140863 1016.192810,26.419029 1018.653564,26.037651 
	C1019.184387,26.193237 1019.373352,26.381454 1019.564514,26.567471 
	C1019.756226,26.753962 1019.695374,26.689474 1019.192139,26.185688 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M1.224221,148.216614 
	C1.000000,144.638718 1.000000,141.277420 1.000000,137.458069 
	C1.533632,136.597260 2.161984,136.483612 3.112524,136.308441 
	C6.247190,133.289917 9.420954,131.967575 13.641867,134.203384 
	C15.095960,135.321304 16.336061,136.228012 16.239248,137.805298 
	C16.852749,137.208466 16.139029,135.887207 17.061945,134.724854 
	C18.401424,132.634537 19.492392,130.773254 21.089287,129.317215 
	C25.468378,125.324379 29.262421,120.265434 36.598228,123.867142 
	C40.809292,125.934677 43.730373,123.755180 44.928474,118.904572 
	C45.218052,118.383507 45.352207,118.184608 45.747108,117.737839 
	C46.211498,117.365585 46.415142,117.241196 46.942825,116.970078 
	C53.840172,114.387939 57.558922,115.751884 61.394814,122.005760 
	C61.735542,118.200554 62.796707,114.571182 66.913658,113.565659 
	C71.574684,112.427254 76.231224,112.567284 79.524963,117.523705 
	C81.264481,120.849892 77.880714,122.660423 77.927834,125.608498 
	C78.463455,127.749130 78.691658,129.643509 79.847824,131.444031 
	C80.676544,131.622467 81.229156,131.530029 82.060013,131.253738 
	C82.748123,131.046982 83.152008,130.956253 83.872696,130.824432 
	C86.061569,130.702423 87.333725,129.704636 88.450188,127.881134 
	C89.457428,126.941841 90.254608,126.629692 91.345787,127.107277 
	C94.608276,128.535156 96.790573,126.883095 98.110504,124.161942 
	C99.308296,121.692566 100.824333,120.541039 103.862595,121.537766 
	C104.338669,121.927612 104.495972,122.126640 104.813255,122.678284 
	C105.129402,123.536247 105.228722,124.052620 105.294617,124.984390 
	C105.321411,126.494812 105.180511,127.572250 104.467270,128.921539 
	C74.458855,137.721802 44.601307,145.901978 14.825283,155.758835 
	C10.095091,156.769440 6.271821,159.555908 1.322882,159.229202 
	C1.000000,158.555557 1.000000,158.111099 1.000000,157.333328 
	C1.494776,156.525238 1.946112,156.005081 2.781610,155.407364 
	C5.672447,154.700912 5.938768,153.280457 4.434824,150.974396 
	C3.852325,149.976578 3.258873,149.442825 2.204725,148.974945 
	C1.769048,148.697845 1.608745,148.565552 1.224221,148.216614 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M1.268336,917.242554 
	C1.000000,907.645752 1.000000,898.291565 1.000000,888.468628 
	C1.452578,887.634521 1.962255,887.386780 2.954334,887.243103 
	C4.348988,887.439697 5.345450,887.449890 6.319829,887.591431 
	C9.533467,888.058105 10.681534,886.784241 10.639312,883.509460 
	C10.513867,873.779846 10.541682,864.046631 10.646882,853.891724 
	C10.730703,852.897766 10.866096,852.345764 11.295384,851.439575 
	C12.131567,850.382751 12.950685,850.138245 14.250345,849.976318 
	C16.871572,850.343262 19.295773,849.217468 21.477018,851.350342 
	C22.387838,864.527283 22.692074,877.314697 22.496307,890.113586 
	C22.458067,892.613647 22.572273,895.128967 20.793953,897.641602 
	C17.317318,900.327393 13.479772,899.015503 9.747874,899.951965 
	C8.974812,901.093567 9.437587,901.713257 10.434683,902.437012 
	C14.278666,903.411682 17.918959,905.174561 21.282845,901.434753 
	C23.582258,884.224609 22.248100,867.326538 22.037495,850.025269 
	C21.741308,849.020020 21.651999,848.429626 21.601894,847.385986 
	C21.422548,843.120972 21.610836,839.302002 21.646587,835.041992 
	C21.725197,834.013916 21.860043,833.445129 22.299606,832.520508 
	C23.534060,831.195007 24.597021,831.356689 25.996231,832.274048 
	C26.459282,832.784851 26.608810,833.016541 26.904556,833.629883 
	C27.583466,836.334717 27.229265,838.706909 27.488579,841.436584 
	C27.578154,842.086243 27.617781,842.347351 27.722599,843.006836 
	C27.826982,843.677246 27.866175,843.949219 27.939560,844.638611 
	C27.988462,845.631897 27.966362,846.206421 27.892330,847.229614 
	C27.337011,868.680115 27.876877,889.685547 27.551775,911.145935 
	C27.707319,916.418945 27.534555,921.235657 27.574938,926.485229 
	C27.495007,927.768677 27.544815,928.604126 27.960701,929.799927 
	C28.803322,937.072510 28.574917,943.973145 28.252943,950.854004 
	C28.112747,953.850037 28.963409,955.224976 32.415176,954.902527 
	C34.252243,955.368347 35.855961,955.787415 35.889252,957.637146 
	C35.904228,958.468933 34.814228,958.753906 34.032211,959.043823 
	C32.258995,959.700989 29.619921,958.812927 28.860338,961.233032 
	C28.007547,963.950012 28.151237,966.819397 29.115360,969.564697 
	C29.390335,970.347778 29.900217,971.027893 30.413216,972.143555 
	C30.763605,973.655823 30.435318,974.668335 29.539103,975.918701 
	C28.143648,976.835510 27.102659,976.582397 25.757561,975.715088 
	C23.849720,973.825745 22.651510,971.966736 21.906404,969.363403 
	C20.614819,959.985168 22.457590,951.083618 22.421259,942.137939 
	C22.386877,933.672668 22.570328,925.204712 22.346081,916.742920 
	C22.153019,909.457886 21.500465,908.868958 14.588132,908.210205 
	C20.332191,909.390015 21.456629,910.554138 21.526726,916.398071 
	C21.666082,928.015991 21.623487,939.636108 21.532022,951.254761 
	C21.514057,953.537048 21.679216,955.984802 19.099701,957.813354 
	C17.229107,958.421021 15.745464,958.373840 13.826957,957.956665 
	C12.544234,957.402588 11.974625,956.730225 11.507616,955.443726 
	C11.628811,952.437805 11.630809,949.857666 11.578390,946.844238 
	C11.578413,940.031189 11.579858,933.650330 11.567353,926.871338 
	C11.716222,923.572876 10.134017,921.936890 7.671539,920.730225 
	C5.598559,919.714294 3.350298,918.999268 1.268336,917.242554 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M918.468628,1025.000000 
	C918.320312,1021.911682 916.374878,1017.737061 922.402405,1017.705566 
	C924.858337,1017.692688 924.043335,1014.776550 923.913635,1013.150879 
	C923.264771,1005.022461 923.363281,1004.794617 931.239258,1002.548096 
	C931.486816,1002.477539 931.632996,1002.051575 931.908691,1001.428467 
	C933.997498,998.485596 936.942200,998.492188 939.730164,998.530518 
	C945.915222,998.615417 951.992004,997.615356 958.503601,996.946533 
	C962.132874,995.786438 966.074036,996.195129 967.511780,991.699158 
	C968.166504,989.651855 970.414246,989.735779 972.119568,990.904846 
	C973.337769,991.740112 974.098816,993.076599 974.973389,994.763916 
	C975.072083,1004.887268 976.980347,1014.721619 973.286865,1024.636963 
	C954.979126,1025.000000 936.958191,1025.000000 918.468628,1025.000000 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M29.234447,35.740891 
	C28.334616,36.026249 27.359631,35.768948 27.060709,36.107891 
	C24.736338,38.743439 22.531618,40.804699 19.991390,36.321346 
	C19.929905,36.212833 18.422430,36.586208 18.381733,36.854858 
	C17.911024,39.962116 14.807937,40.444843 13.059376,42.652588 
	C11.715048,42.882645 10.118744,43.444633 9.288307,42.147179 
	C7.132709,38.779327 5.988873,41.606045 4.435197,42.736084 
	C2.841408,43.895298 2.610393,45.129169 4.090044,46.368004 
	C5.584407,47.619152 7.151392,49.901943 9.087304,46.689270 
	C9.520107,45.971027 10.543443,45.928707 11.317853,46.466961 
	C11.970737,46.920750 12.026484,47.990841 11.581150,48.179070 
	C7.813503,49.771530 6.237798,54.493443 1.379648,55.004559 
	C1.000000,37.921139 1.052308,20.841928 0.937329,3.763843 
	C0.922040,1.492840 1.280562,0.873552 3.710008,0.922481 
	C13.157588,1.112757 22.611271,1.000000 32.531342,1.000000 
	C32.006939,3.493706 30.166113,5.343064 28.277283,7.141547 
	C25.274979,10.000243 26.037006,13.560970 30.029951,14.779285 
	C31.095867,15.104514 32.438927,15.284159 33.441906,14.929213 
	C39.979774,12.615522 45.673801,14.901291 51.638367,17.962519 
	C53.236282,20.144159 51.434509,20.631334 49.792656,21.525156 
	C48.948227,21.748756 48.457924,21.794775 47.611870,21.721161 
	C44.115242,20.627079 42.502537,24.067816 39.560181,23.862501 
	C39.756733,26.394644 43.084930,26.303675 42.721790,29.013290 
	C42.588680,29.561842 42.497112,29.770763 42.164230,30.222076 
	C39.473866,32.353603 37.244781,29.505098 34.722443,30.422432 
	C34.476963,30.891754 34.363186,31.074921 34.012497,31.485504 
	C32.456341,32.485729 31.310984,33.683529 29.310373,33.238205 
	C28.499336,32.524277 28.188784,31.811426 27.532656,30.775103 
	C27.697792,32.153328 28.511316,32.410374 29.184551,33.211990 
	C29.755981,34.124241 29.746157,34.795219 29.234447,35.740891 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M51.003517,703.651733 
	C49.952034,706.134033 48.965260,707.884277 46.147675,708.740784 
	C41.605770,710.121277 40.487820,709.695435 40.451252,703.642700 
	C35.594563,708.087524 30.078987,705.249817 24.912418,706.280579 
	C21.043404,707.052429 21.365683,711.756897 17.814537,712.635986 
	C16.885645,712.865906 16.444708,715.661194 15.043819,714.605042 
	C13.145984,713.174072 15.795556,712.312073 16.257536,711.120239 
	C16.373913,710.820068 16.484266,710.517456 16.840857,709.567078 
	C12.635966,711.721008 11.168204,704.196960 6.826540,708.390198 
	C6.205505,705.213013 9.278467,705.796631 9.483215,703.663452 
	C7.255470,701.902405 3.615609,705.435425 1.348773,702.059570 
	C1.000000,699.958313 1.000000,697.916687 1.000000,695.437500 
	C3.989038,695.886536 6.423526,697.980347 8.965408,699.521667 
	C13.030407,701.986511 15.413520,701.614136 17.841873,697.893311 
	C18.260813,697.251343 19.065367,696.861023 19.879150,696.203064 
	C17.873207,694.248047 15.415548,694.247742 13.416510,693.273010 
	C12.250592,692.704468 9.726512,693.432617 10.400478,691.093872 
	C10.836318,689.581543 12.123061,687.762695 14.543507,688.686584 
	C15.083049,688.892456 15.768260,688.716736 16.767664,688.716736 
	C15.184306,685.045166 15.384912,682.205505 19.405586,680.940552 
	C20.357294,680.641113 20.615208,680.148621 20.565374,679.138489 
	C20.423161,676.255554 21.961143,677.115906 23.700081,677.656677 
	C28.428036,679.127197 32.413826,682.565735 37.921379,682.174316 
	C40.505497,681.990723 43.521446,678.226074 45.996868,682.436096 
	C46.519501,682.076172 47.465508,681.751465 47.498917,681.350769 
	C47.814156,677.569397 51.615433,678.378906 53.594154,676.851868 
	C55.352631,675.494690 55.846775,677.833069 55.961555,679.266052 
	C56.447910,685.338196 55.680992,691.184998 52.289803,696.780762 
	C50.339142,698.133850 51.063290,699.828247 51.000137,701.676880 
	C51.005699,702.453064 51.004398,702.888977 51.003517,703.651733 
z"/>
<path fill="#F7EBDA" opacity="1.000000" stroke="none" 
	d="
M1024.613281,540.704834 
	C1025.000000,541.444458 1025.000000,541.888916 1025.000000,542.666687 
	C1020.895447,545.035095 1016.488586,544.082336 1012.290222,543.893250 
	C1000.455139,543.360046 988.615662,543.651611 980.503296,543.492249 
	C990.967468,543.072815 1005.132019,543.923035 1019.309814,544.012268 
	C1020.955933,544.022583 1022.636108,543.794250 1024.612549,544.735229 
	C1025.000000,545.444458 1025.000000,545.888916 1025.000000,546.666687 
	C1021.602905,548.466858 1019.723511,550.673157 1019.675598,554.748230 
	C1019.629822,558.648926 1018.173828,559.188660 1013.353760,557.843628 
	C1012.753479,557.268555 1012.518799,556.865845 1012.328735,556.073181 
	C1012.329651,554.061096 1010.511658,553.926453 1009.812744,552.489807 
	C1009.681763,551.314392 1011.721375,550.988831 1010.038208,549.774902 
	C1008.004822,551.176941 1009.427673,552.978577 1009.229858,554.601440 
	C1009.001282,556.477173 1008.847473,558.522583 1006.503845,558.695862 
	C1004.217896,558.864868 1001.807251,558.674377 999.979309,556.976807 
	C999.313782,556.358826 999.496704,555.434387 1000.274109,554.826660 
	C1001.915100,553.544067 1000.476990,552.149475 1000.564087,550.482056 
	C998.981384,551.491089 999.538391,552.885254 999.312805,554.010254 
	C998.978149,555.679382 999.771973,557.943054 997.329346,558.578918 
	C994.913574,559.207764 993.152100,558.166870 991.997314,555.579224 
	C991.804138,554.781250 991.743591,554.319519 991.690552,553.515991 
	C991.487366,552.145020 992.068604,550.523315 990.730713,550.312500 
	C989.675476,550.146301 990.369507,551.476257 990.317139,552.486450 
	C989.944458,553.932190 989.297241,554.928101 988.817627,556.395691 
	C988.498169,556.926147 988.342590,557.123169 987.871460,557.531860 
	C985.840820,558.462280 984.083374,558.424133 981.964478,557.912109 
	C979.094360,555.690491 981.502014,553.002136 980.797119,550.669556 
	C978.921509,552.393494 980.465454,554.771301 979.389832,556.962158 
	C976.259216,558.195374 973.323669,559.106262 970.354126,556.600037 
	C970.106812,555.828064 970.046326,555.372986 970.020874,554.585571 
	C970.008911,553.966431 970.007507,553.674194 970.008423,553.381958 
	C969.941772,553.491272 970.003113,553.609802 969.982300,554.028381 
	C969.972351,554.764343 969.943970,555.193176 969.806274,555.952026 
	C967.276550,558.476990 964.976868,559.418640 963.429993,555.417847 
	C962.893921,554.031433 961.907715,553.347168 960.562988,552.971985 
	C959.150085,552.577759 958.156921,551.849182 958.562256,550.200989 
	C957.478638,554.241089 962.754150,552.256348 963.231567,555.276367 
	C963.200134,556.093933 962.907471,556.429871 962.129272,556.731934 
	C961.557373,556.816956 961.325195,556.815125 960.761475,556.720276 
	C960.024902,556.396545 959.753906,556.064453 959.499329,555.901489 
	C959.163330,556.338745 958.982544,556.476990 958.489197,556.759338 
	C956.365112,557.374695 954.552917,557.857056 952.654541,556.263367 
	C951.639648,554.660950 951.852478,552.926086 950.941772,551.489014 
	C950.180420,552.335327 950.285156,553.164185 950.041321,554.254822 
	C947.821411,557.572937 945.299500,557.322205 942.523071,555.118042 
	C942.440796,553.651123 943.441650,552.889771 943.503418,551.537903 
	C943.481079,551.276306 943.226868,550.858521 942.994263,550.802246 
	C942.249695,550.960266 941.944946,551.398376 941.399841,552.031250 
	C940.997803,552.349121 940.809814,552.443787 940.307983,552.584839 
	C939.785889,552.599915 939.577637,552.568604 939.088501,552.396606 
	C938.206116,551.727356 937.846130,550.968079 936.874023,550.450623 
	C936.206543,550.311157 935.817017,550.267090 935.121765,550.250427 
	C933.774353,550.283325 932.744629,550.454651 931.383667,550.564575 
	C930.407776,550.530090 929.766296,550.400513 928.786377,550.346924 
	C927.574951,550.313354 926.692688,550.268555 925.471069,550.323181 
	C922.921143,551.007812 919.243774,549.005554 919.132080,553.953796 
	C918.893677,555.017151 918.570618,555.646240 917.674744,556.275269 
	C916.048035,554.476074 914.214722,556.667297 912.560791,555.547119 
	C911.508606,554.005920 912.166504,551.990051 909.989258,551.058350 
	C907.263794,548.507324 903.682739,546.537354 907.094238,542.116943 
	C909.805054,541.392395 912.169556,541.672607 914.968079,541.566162 
	C924.992615,541.312988 934.579468,542.125488 944.587646,540.993042 
	C953.132019,540.229797 961.241455,540.745300 969.809082,540.553711 
	C971.534241,540.570984 972.759399,540.386597 974.414551,539.865112 
	C990.042175,539.326660 1005.205017,539.654358 1020.366333,539.597473 
	C1021.701538,539.592468 1023.039490,539.666931 1024.613281,540.704834 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M46.620094,118.172470 
	C46.148579,119.382004 45.569016,120.201027 45.228008,121.109596 
	C43.924034,124.583855 43.138508,128.214661 37.807365,125.205894 
	C36.137028,124.263206 32.931744,126.889015 31.210541,123.572083 
	C30.949848,123.069710 29.747181,123.506386 29.033348,124.114815 
	C25.267302,127.324791 21.092142,130.121948 18.438917,134.887924 
	C16.624136,135.837814 15.630654,134.664276 14.202908,133.777557 
	C13.758902,133.409515 13.599687,133.241058 13.259243,132.776398 
	C11.571516,129.602676 14.705322,128.658813 15.668249,126.558922 
	C12.810754,125.344391 10.525402,122.907433 6.798423,123.738129 
	C6.356757,123.795006 6.192051,123.822670 5.967659,124.113487 
	C5.955579,124.997612 5.923635,125.613235 5.647532,126.544960 
	C5.354766,127.047997 5.198286,127.227669 4.723421,127.579628 
	C3.422001,128.050064 2.470954,128.026001 1.286321,127.235367 
	C1.000000,120.978844 1.000000,114.957695 1.000000,108.468269 
	C1.517628,107.575806 1.679957,107.055122 1.214254,106.211037 
	C1.000000,105.250000 1.000000,104.500000 1.000000,103.375000 
	C3.273508,102.895058 3.867581,105.040886 5.190994,106.184860 
	C6.616931,107.417465 7.872507,109.255341 9.167040,106.107292 
	C9.551013,105.173546 10.528170,104.800697 11.191262,105.372658 
	C16.554443,109.998833 16.296623,102.748543 18.988670,101.371872 
	C20.072527,100.993256 21.138063,100.993530 22.603167,100.995529 
	C23.214066,101.215775 23.427719,101.431992 23.643721,101.645882 
	C23.860081,101.860153 23.789637,101.787552 23.214809,101.215424 
	C22.478354,97.550247 19.373436,95.960098 17.493402,93.500275 
	C16.050255,91.612076 14.963561,90.044197 17.637249,88.075546 
	C18.448849,90.682106 19.308830,91.370796 21.775196,89.374336 
	C23.202433,88.219032 23.868666,85.875526 26.634830,86.006500 
	C27.743324,88.718056 24.410734,89.178009 24.035389,91.648270 
	C23.791954,92.216888 23.572659,92.421669 23.344118,92.616318 
	C23.115582,92.810974 23.192719,92.747223 23.786810,92.211533 
	C26.292379,92.502548 28.317202,97.385399 31.047335,92.476601 
	C31.058376,92.456734 32.585487,93.280067 34.012882,93.968399 
	C35.393539,94.819656 35.656681,95.610405 35.425743,96.862900 
	C35.041550,97.855370 34.366100,98.468307 35.162476,99.481041 
	C36.046028,100.090355 36.724739,100.228470 37.687561,99.621025 
	C39.051716,98.905251 39.869595,98.013779 40.879845,96.844391 
	C43.090202,95.682686 44.408974,96.872299 45.819324,97.949997 
	C46.884125,98.763641 47.675198,100.284042 49.751698,99.479523 
	C51.596893,98.689369 53.124081,98.023872 55.197517,98.284729 
	C55.745117,98.509903 55.945076,98.641037 56.307159,99.090744 
	C54.813469,103.732498 50.870293,104.728531 46.999760,106.155113 
	C49.562271,108.913383 50.628098,111.858643 46.798801,114.751099 
	C45.689362,115.589119 45.799873,116.746315 46.620094,118.172470 
z"/>
<path fill="#F7EBCF" opacity="1.000000" stroke="none" 
	d="
M1024.664673,528.742676 
	C1025.000000,532.030579 1025.000000,535.061218 1025.000000,538.545898 
	C1019.141418,541.099976 1013.075684,539.492371 1006.656738,539.998413 
	C995.928955,539.633545 985.694580,540.654297 974.976074,540.501038 
	C973.603271,540.715271 972.703613,540.964661 971.299011,540.997070 
	C964.052124,541.968018 957.232910,541.307129 950.432678,541.473572 
	C947.944702,541.534485 945.450806,541.401123 942.534302,541.971802 
	C932.846680,542.052063 923.621765,541.909912 913.953064,542.132935 
	C911.768921,542.707764 909.986023,542.400635 907.783569,542.490051 
	C902.306702,541.861450 899.885803,538.845947 900.582764,533.340271 
	C907.169556,531.738281 913.572144,531.627686 919.786316,531.622986 
	C936.411011,531.610596 952.994995,530.467957 969.608337,530.210693 
	C982.033325,530.018250 994.500000,529.982056 1007.366455,529.284912 
	C1009.995422,528.450378 1012.153503,527.521545 1014.954590,528.045776 
	C1015.971741,528.132019 1016.286865,529.545715 1017.464478,528.321655 
	C1020.028809,527.475159 1022.219116,527.276611 1024.664673,528.742676 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M984.103516,729.356934 
	C986.739380,725.956238 992.986938,726.904663 995.744629,730.256958 
	C1001.799683,737.617981 1004.745483,746.216187 1007.268860,755.249817 
	C1012.641174,774.482544 1018.593567,793.553162 1024.654053,812.845093 
	C1025.000000,818.354919 1025.000000,823.709900 1025.000000,829.532410 
	C1021.383728,831.232300 1021.240173,828.016479 1020.555786,826.163879 
	C1017.785645,818.665710 1015.376831,811.036499 1012.905396,803.433228 
	C1011.462891,798.995483 1009.815063,794.641541 1008.122742,790.299438 
	C1006.969177,790.863098 1008.718384,787.306458 1006.221802,789.194519 
	C1004.285461,788.496765 1003.787415,787.051819 1003.314758,785.640442 
	C997.365662,767.876099 990.645081,750.384338 984.621704,732.646729 
	C984.304932,731.714050 983.939880,730.767578 984.103516,729.356934 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1025.000000,654.531372 
	C1022.304138,655.212952 1020.831909,656.708679 1020.586792,660.194397 
	C1018.949158,658.381042 1017.762451,656.935364 1015.742859,656.398682 
	C1015.561584,658.706299 1013.555908,661.223450 1016.393311,663.052429 
	C1018.291504,664.276062 1019.858215,665.677368 1018.719421,667.773376 
	C1017.464417,670.083435 1015.512695,666.934937 1013.419922,668.307251 
	C1012.928406,669.063049 1014.887329,669.143066 1014.833679,670.066345 
	C1014.777466,671.033997 1016.353271,672.363281 1014.412781,672.907654 
	C1012.260010,673.511475 1013.588135,671.621948 1013.166870,671.070740 
	C1011.861206,669.362244 1009.442139,670.122070 1007.383301,669.049072 
	C1004.511902,666.913879 999.263611,667.402771 1000.339417,661.883972 
	C1000.425842,661.440918 999.993835,661.421753 1000.062622,662.025085 
	C992.819946,662.845215 997.152283,656.389160 994.737915,653.887695 
	C993.429138,656.160828 994.148193,658.706665 993.833191,661.081238 
	C993.698120,662.099609 993.413696,663.077637 992.246399,663.347168 
	C991.146606,663.601013 990.014465,663.097534 989.694824,662.227295 
	C988.519470,659.027100 985.797241,656.667542 984.831543,653.856140 
	C984.404053,654.923157 986.889404,657.222229 984.452209,658.176392 
	C982.201843,659.057373 980.364807,657.152161 978.984985,655.540100 
	C977.539124,653.850830 977.450195,651.283203 975.117310,649.995544 
	C973.945068,649.348450 974.646484,647.890869 975.508179,646.984253 
	C976.349915,646.098755 977.341431,645.482788 978.600708,646.136658 
	C980.018250,646.872559 980.854980,648.054749 981.012573,649.416443 
	C981.665100,646.999329 978.353333,641.693604 985.329346,643.360840 
	C985.671936,643.442688 985.937866,643.333069 986.261108,643.178772 
	C991.062683,640.888062 991.416687,641.137573 991.159912,646.610352 
	C991.136658,647.106018 991.004517,647.592468 990.917236,648.082214 
	C996.354431,643.404297 996.354431,643.404297 997.927002,636.401855 
	C997.952515,633.874084 999.746643,633.702881 1000.947937,634.406799 
	C1002.936646,635.572144 1003.891357,633.854553 1005.643250,633.375549 
	C1006.440979,633.197449 1006.903992,633.175232 1007.705200,633.276611 
	C1009.507324,633.814819 1010.359314,634.891602 1010.899170,636.347839 
	C1011.133606,635.280029 1010.425720,634.425781 1010.619019,633.122314 
	C1011.205688,631.907776 1011.999329,631.409119 1013.260498,630.967163 
	C1014.751099,630.632629 1015.934021,630.572571 1017.372437,630.039673 
	C1018.968201,629.724609 1020.767273,629.044556 1021.284973,630.347717 
	C1022.405884,633.168823 1023.493958,629.851013 1024.732422,630.784546 
	C1025.000000,638.687561 1025.000000,646.375183 1025.000000,654.531372 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M586.065796,1024.617798 
	C573.979126,1025.000000 561.958191,1025.000000 549.468628,1025.000000 
	C547.317810,1023.221924 544.570374,1022.549622 543.702148,1019.565979 
	C544.159729,1018.065063 545.195923,1017.514038 546.494324,1016.762695 
	C547.039307,1016.585022 547.266235,1016.547668 547.834167,1016.534180 
	C550.160828,1017.246277 551.990967,1017.319763 553.459229,1014.997009 
	C553.747864,1014.546265 553.860168,1014.364380 554.137024,1013.909424 
	C555.289185,1012.372192 554.913635,1010.748413 555.610657,1009.064697 
	C555.982666,1008.630737 556.173767,1008.491943 556.702271,1008.225891 
	C558.948608,1007.690247 560.572876,1008.407654 562.030457,1009.500488 
	C564.500732,1011.352722 567.257751,1011.952942 570.642334,1011.632202 
	C577.950623,1012.300171 584.762695,1012.059143 591.500244,1008.742065 
	C592.447998,1008.313538 593.093506,1008.078796 594.021362,1007.669373 
	C594.907715,1007.267090 595.507202,1007.027100 596.372009,1006.595459 
	C596.849548,1006.350586 597.042297,1006.253784 597.529236,1006.016418 
	C598.227234,1005.694336 598.639099,1005.533020 599.385498,1005.294922 
	C600.168823,1005.125610 600.627258,1005.092834 601.437988,1005.131958 
	C603.314941,1005.620544 605.484619,1005.538269 605.905823,1007.265625 
	C606.312683,1008.934387 604.036438,1009.185669 603.072021,1010.193420 
	C602.605591,1010.680847 602.355042,1011.268127 601.937988,1012.176758 
	C601.244385,1013.346863 600.542908,1014.020203 599.649719,1014.579224 
	C611.962219,1010.763672 624.776978,1009.414734 637.713440,1006.789307 
	C639.668823,1006.674377 641.200134,1006.835388 642.821899,1008.072998 
	C643.407654,1008.774292 643.593384,1009.248901 643.638916,1010.149231 
	C643.040283,1011.876038 642.723328,1013.348572 641.433960,1014.723022 
	C633.776917,1017.766602 626.027710,1018.418335 618.630066,1019.493958 
	C622.679749,1019.688232 626.846008,1017.196594 631.603271,1018.487427 
	C632.069458,1018.925171 632.197632,1019.155396 632.285400,1019.777527 
	C629.715698,1023.681152 625.782349,1022.156189 622.508545,1022.693787 
	C616.155457,1023.736877 609.725525,1024.877197 603.265137,1023.119263 
	C602.614502,1023.072327 603.406128,1023.822266 603.444458,1023.156677 
	C603.450623,1023.049011 603.607117,1023.072571 603.932434,1023.144714 
	C604.752258,1023.326416 605.545837,1023.546326 606.052673,1024.619507 
	C599.978821,1025.000000 593.957703,1025.000000 587.468262,1025.000000 
	C582.985901,1021.448608 577.931152,1023.237305 574.841797,1022.525269 
	C577.705383,1022.553528 582.090149,1022.235413 586.065796,1024.617798 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M1009.101013,997.618835 
	C1003.488403,987.776306 998.248840,977.783752 992.915039,967.841675 
	C991.435852,965.084534 989.676819,962.477478 987.942322,959.631165 
	C991.439453,957.785156 995.086182,958.134033 999.032959,957.796997 
	C999.481995,957.283691 999.146362,956.655396 999.873413,956.541626 
	C1007.994873,955.270386 1016.122803,954.822937 1024.629150,956.716431 
	C1025.000000,965.354248 1025.000000,973.708496 1025.000000,982.531372 
	C1023.991394,984.850037 1025.237671,988.283447 1020.999512,988.119629 
	C1020.361023,988.036377 1020.113586,987.973755 1019.534424,987.734985 
	C1018.629456,987.025269 1018.525635,986.328613 1018.524353,985.266174 
	C1018.875427,984.366211 1018.293640,985.054321 1018.690735,984.519470 
	C1018.957336,984.160339 1019.194397,983.792969 1019.697083,983.760132 
	C1019.304016,983.779053 1019.026001,983.991028 1018.661865,984.585510 
	C1018.167358,986.524719 1019.187805,987.961121 1019.238037,989.901794 
	C1019.114624,993.085449 1017.110901,994.184692 1014.840576,995.037598 
	C1012.985474,995.734497 1010.978271,996.095703 1009.101013,997.618835 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M892.833740,513.155640 
	C894.165955,512.804077 895.378540,512.887512 896.411621,512.496521 
	C899.389954,511.369202 902.115540,507.072998 905.423401,511.992371 
	C909.951294,509.045258 914.669434,510.669250 919.380066,511.326294 
	C920.903870,511.538788 921.584595,510.119049 922.353882,509.024139 
	C922.869568,508.290314 923.752258,507.923279 924.546387,508.324829 
	C930.949951,511.562500 930.940002,511.582123 935.379639,507.631439 
	C937.402771,512.222778 940.241577,512.057678 943.602234,509.060333 
	C944.852539,507.945160 945.462708,507.269501 947.303711,509.302826 
	C949.841675,512.106018 953.399475,510.137817 956.301697,508.470856 
	C957.786438,507.618134 958.641968,505.873169 960.045837,509.192322 
	C961.098816,511.681946 964.383484,510.436493 966.265869,508.591492 
	C967.622742,507.261536 967.775574,507.048035 969.729858,508.567047 
	C972.135498,510.436890 976.165527,510.848145 979.101196,507.657379 
	C980.477966,506.161011 982.306274,503.453369 982.970947,508.423981 
	C983.252563,510.529968 985.452820,508.541534 987.175171,508.787720 
	C988.225464,508.729279 988.789429,508.480103 989.648193,508.147034 
	C990.536377,507.902954 991.145020,507.870880 992.355591,507.970825 
	C996.669800,507.616852 1000.887207,509.430084 1003.859009,505.593414 
	C1004.256287,505.080505 1004.898804,504.871796 1005.562927,505.399048 
	C1009.585999,508.593445 1010.695068,508.645142 1014.922607,505.815735 
	C1016.462341,504.785309 1017.916748,507.025604 1019.440308,505.892609 
	C1020.477966,508.195068 1022.604675,506.995056 1024.618652,507.192078 
	C1025.000000,508.388885 1025.000000,509.777802 1025.000000,511.583344 
	C1023.682495,513.242615 1022.031189,513.474548 1020.346802,513.391846 
	C1008.369446,512.804260 996.488281,515.128113 984.499207,514.506042 
	C980.208679,514.283447 976.003235,516.149841 971.165161,515.473145 
	C970.078796,515.453430 969.459595,515.445740 968.380127,515.439331 
	C965.479736,515.304504 963.041565,515.739319 960.142456,515.458557 
	C947.827637,516.287109 935.946472,517.099609 924.086731,517.356689 
	C913.010742,517.596741 901.984863,519.403198 890.462891,518.439392 
	C889.013794,518.473022 887.967773,518.400146 886.672363,519.017517 
	C882.550354,519.320251 881.308289,515.926697 878.842224,513.715393 
	C878.473755,513.351807 878.322449,513.213623 877.951660,512.866821 
	C877.448730,512.382385 877.170410,512.101562 876.694580,511.610077 
	C876.233459,511.124176 875.990723,510.830627 875.599487,510.295898 
	C875.142456,509.591888 874.874756,509.100769 874.370300,508.426392 
	C873.950378,507.904877 873.715881,507.597656 873.317017,507.037903 
	C872.522827,505.719513 871.740173,504.717957 871.750366,503.094910 
	C872.275757,502.252655 872.834045,501.895721 873.772095,501.506531 
	C875.085266,501.274994 875.923462,501.500244 876.501404,502.750122 
	C877.925598,504.927094 879.349670,506.739624 880.713440,508.596436 
	C883.297058,512.114075 885.733032,514.659241 889.997253,510.188110 
	C892.108521,507.974518 893.012512,510.001556 893.008972,512.606812 
	C892.699768,513.356934 892.278259,513.666687 891.782898,513.872070 
	C892.093750,513.755798 892.376831,513.589783 892.833740,513.155640 
z"/>
<path fill="#F6DFD3" opacity="1.000000" stroke="none" 
	d="
M1.000000,513.466858 
	C8.680867,513.843628 16.394861,514.973389 23.772036,511.488800 
	C30.438160,508.340057 37.409756,505.871460 43.825733,502.149536 
	C47.248390,500.164062 50.755405,500.184113 53.826057,503.805267 
	C55.036568,505.515076 53.982464,506.377747 52.933044,507.566528 
	C44.286255,515.836060 34.982265,522.660095 25.282557,528.970459 
	C23.480284,530.143005 21.641993,531.251343 19.148401,531.801880 
	C12.880922,532.242920 6.965592,532.711060 1.279697,529.241699 
	C1.000000,523.977905 1.000000,518.955811 1.000000,513.466858 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M1000.324524,704.228149 
	C1003.134766,699.186401 1006.594727,694.646179 1013.375183,694.991455 
	C1015.313904,695.090149 1015.449768,693.609924 1016.261597,692.363586 
	C1017.522034,690.428467 1017.785767,692.204224 1017.992004,693.648438 
	C1016.285217,696.083435 1018.102478,696.489563 1019.479065,696.897034 
	C1021.030029,697.356018 1022.649841,697.582336 1024.619873,697.954895 
	C1025.000000,712.020874 1025.000000,726.041809 1025.000000,740.531311 
	C1023.504700,740.994751 1021.978394,740.794373 1020.520691,741.025879 
	C1017.680481,741.477112 1016.585876,740.341980 1015.616577,737.628174 
	C1012.098511,727.778564 1008.179443,718.072021 1004.400574,708.315735 
	C1003.695312,706.494812 1003.356384,704.305786 1000.324524,704.228149 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M886.036865,519.734131 
	C885.992920,518.295898 886.266907,517.361694 887.746643,517.083740 
	C894.012939,518.908203 899.781433,519.716309 906.132812,518.202515 
	C910.715881,517.110168 915.690063,516.218506 920.725098,518.248779 
	C924.264648,519.676025 928.161316,517.464600 932.262451,517.270996 
	C933.595764,517.629578 934.334473,518.602356 935.811523,518.388306 
	C938.690125,516.717041 941.140625,515.890015 944.484070,516.405212 
	C947.485474,516.867676 950.979736,517.725647 954.086914,515.505981 
	C955.613403,514.415466 957.633667,515.087158 959.735046,515.704590 
	C962.060242,516.700256 963.916260,516.194763 966.072449,515.151001 
	C967.394775,515.004272 968.369324,515.019836 969.716980,515.188965 
	C971.537292,515.711487 973.041260,516.002075 974.525391,515.778259 
	C987.777161,513.779480 1001.215332,514.672852 1014.503967,513.168884 
	C1017.760315,512.800293 1021.130249,512.505310 1024.696167,513.759033 
	C1025.000000,516.370544 1025.000000,518.741150 1025.000000,521.555847 
	C1024.685303,522.327209 1024.306519,522.540588 1023.531067,522.633667 
	C1022.541138,522.496521 1021.934082,522.227905 1021.032349,521.793640 
	C1019.762817,521.060852 1018.768433,520.624390 1017.307495,521.217773 
	C1016.796143,521.416626 1016.591187,521.495117 1016.070679,521.668823 
	C1015.322205,521.851440 1014.885132,521.903442 1014.109192,521.903687 
	C1013.551086,521.865784 1013.327209,521.838928 1012.767212,521.758301 
	C1011.222168,521.354309 1010.115356,521.870789 1008.587830,522.197266 
	C987.315918,522.398682 966.492554,524.244385 945.185547,524.506165 
	C944.480835,524.611145 944.203125,524.675720 943.508972,524.836792 
	C942.530090,525.011597 941.964966,525.056152 940.976318,525.080688 
	C934.408325,525.722961 928.244934,525.412537 921.664185,525.421509 
	C920.676880,525.442017 920.112183,525.445557 919.123047,525.436890 
	C915.879517,525.426514 913.060059,525.339417 909.832397,525.495117 
	C904.642822,526.092712 899.479004,523.794800 894.844238,527.719971 
	C894.174194,528.369263 893.706787,528.602417 892.789795,528.734863 
	C891.602234,528.618652 890.976746,528.233398 890.470825,527.173523 
	C890.403076,524.880737 891.038513,522.719116 888.248657,521.520508 
	C887.783020,521.249695 887.598328,521.139832 887.147217,520.850708 
	C886.715881,520.535522 886.550964,520.399658 886.036865,519.734131 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M1009.257202,928.304688 
	C1003.647034,928.183105 998.284058,928.135376 992.454956,928.134888 
	C991.805115,928.229187 991.621277,928.276123 991.248535,928.110229 
	C991.059631,927.897461 991.039062,927.993164 991.071289,927.956299 
	C988.078369,921.982666 989.597778,915.804443 990.395630,909.259888 
	C991.058655,908.560425 991.404541,908.114563 991.902466,908.073975 
	C1002.660828,907.198242 1013.432983,906.957520 1024.609375,907.710144 
	C1025.000000,915.354248 1025.000000,922.708496 1025.000000,930.531372 
	C1020.560913,933.955444 1015.868225,933.250732 1011.128174,931.502502 
	C1011.991089,930.978271 1012.860718,930.912231 1013.992981,930.644409 
	C1015.086792,928.098938 1017.051270,929.532959 1018.160828,929.001465 
	C1016.539307,928.948853 1014.565247,928.996033 1012.345459,928.319702 
	C1011.570007,928.168030 1011.117737,928.131531 1010.329102,928.153809 
	C1009.829895,928.267944 1009.667053,928.323242 1009.257202,928.304688 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M57.589241,632.561157 
	C57.747223,635.277588 61.578209,634.744202 60.994789,637.632935 
	C58.271526,639.381775 55.512184,642.188782 53.749313,636.648071 
	C53.145554,634.750366 51.020496,636.078979 49.360817,636.957886 
	C48.618282,637.445679 48.128288,637.808594 47.207642,638.012207 
	C45.474045,637.177673 44.046310,636.302795 42.675133,635.462646 
	C43.244778,633.662903 45.642849,634.405273 45.936523,632.251831 
	C45.301880,631.088196 44.172775,631.051880 43.177055,630.203247 
	C42.760639,629.695618 42.543087,629.417175 42.084854,629.019287 
	C41.459053,628.362305 41.572311,627.709412 41.431206,627.115356 
	C41.396748,627.555420 41.528881,627.995972 41.229301,628.677612 
	C39.116142,631.357239 39.535343,635.048279 36.165768,636.847412 
	C35.376251,636.439148 35.195812,635.896118 34.340118,636.736694 
	C28.537365,633.416626 25.710312,638.907532 21.832962,640.618835 
	C20.279825,639.684265 22.386559,636.663574 19.230968,636.498596 
	C18.708775,635.679871 18.240952,635.391724 17.317532,635.745483 
	C16.357679,636.383362 15.978468,636.917969 16.821701,637.882690 
	C17.367409,638.366028 17.523884,638.758545 17.391289,639.510925 
	C15.519126,639.794128 15.591517,641.231445 15.685231,642.465393 
	C13.334748,641.723877 14.612407,639.259338 13.236703,638.409668 
	C11.235944,639.119019 13.815301,640.976990 11.969302,641.672119 
	C11.178985,640.562134 10.373623,639.430969 9.267004,638.145386 
	C7.507854,637.299927 8.941788,638.725647 8.427980,638.725647 
	C8.460361,639.391541 8.454961,638.552795 8.646679,639.468872 
	C9.903987,642.222595 11.439459,644.638184 10.641850,647.727905 
	C8.904744,647.209412 9.971847,645.027466 8.345387,644.794678 
	C7.252726,645.674927 7.752940,646.875671 7.623312,647.985962 
	C7.502362,649.021973 5.872777,649.142700 5.899905,648.586548 
	C6.062952,645.243958 2.697265,646.594299 1.297923,645.040527 
	C1.000000,643.285645 1.000000,641.571289 1.000000,639.428467 
	C1.133764,638.833313 1.267529,638.666687 1.200646,638.250000 
	C1.000000,637.250000 1.000000,636.500000 1.000000,635.375000 
	C1.542473,634.643494 2.080558,634.286804 2.305478,633.624695 
	C4.325618,627.677795 4.326355,627.678040 11.016861,628.761963 
	C11.650590,629.131470 11.913484,629.769104 12.605595,629.035889 
	C13.325463,627.254456 12.145273,626.154968 11.741799,624.536499 
	C11.848121,624.028564 11.965064,623.847168 12.351950,623.492310 
	C13.011250,623.176697 13.411071,623.080688 14.113729,623.051758 
	C14.587013,623.095032 14.771343,623.132446 15.209564,623.276489 
	C15.868383,623.757507 15.945833,623.559143 16.069191,622.889404 
	C18.832119,621.527588 21.419785,620.310974 24.173628,622.752441 
	C24.350908,623.251892 24.524475,623.379150 24.739105,623.168152 
	C24.716028,622.540894 24.863247,622.100769 25.224148,621.418823 
	C25.538603,621.015137 25.691687,620.869385 26.147800,620.604065 
	C29.598173,620.355225 29.724291,625.488708 33.653580,624.453491 
	C34.246552,624.787415 34.414616,624.648621 34.485821,623.967896 
	C35.789940,620.919189 36.954586,617.611816 40.409180,622.316284 
	C40.568790,622.773438 40.620964,622.948730 40.958199,623.168152 
	C42.694572,623.158264 43.480560,624.119385 44.367359,625.330505 
	C44.598679,625.587341 44.642075,625.702332 44.591248,625.581909 
	C43.805450,624.162659 42.317474,623.372375 42.678825,621.403931 
	C45.328148,619.320923 46.041058,622.557983 48.111122,622.929871 
	C49.082005,623.011292 49.734280,623.064392 50.711178,623.244507 
	C51.693153,623.544250 52.301163,623.858215 53.172226,624.416016 
	C54.160206,625.255859 54.615368,626.044922 54.937752,627.281250 
	C55.037441,628.050232 55.042690,628.491882 55.004539,629.257324 
	C55.004837,630.203308 55.089794,630.800293 55.835709,631.418640 
	C56.452351,631.762085 56.809364,631.950073 57.589241,632.561157 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M22.844463,445.713013 
	C18.064264,457.008453 12.572063,467.668640 5.366613,478.402435 
	C4.049217,470.876129 2.870315,464.141022 1.345707,457.202972 
	C1.000000,454.299988 1.000000,451.599976 1.000000,448.449982 
	C1.122572,447.868469 1.245143,447.736938 1.623625,447.493622 
	C2.070729,447.372803 2.261925,447.363770 2.739354,447.390259 
	C3.426000,447.469269 3.779713,447.349396 4.330931,446.889496 
	C6.809999,444.727295 8.557963,442.380920 10.312262,439.588806 
	C14.083566,434.069336 16.155224,428.149017 18.592325,421.987244 
	C19.247442,421.374725 19.710487,421.148529 20.603682,420.930023 
	C21.801929,420.801056 22.583788,420.917755 23.680050,421.409607 
	C24.374117,422.005707 24.610069,422.459381 24.756962,423.350891 
	C24.072920,427.089020 25.575937,430.295929 25.584076,433.951477 
	C25.713924,434.515045 25.752033,434.742279 25.809259,435.312073 
	C25.812176,436.776978 25.398071,437.835449 25.278576,439.271118 
	C25.245718,439.815796 25.234709,440.034058 25.208336,440.581207 
	C25.179155,441.130432 25.165340,441.350769 25.117393,441.902405 
	C25.045534,442.453705 25.007807,442.673706 24.881432,443.218140 
	C24.507240,444.437500 23.901545,445.083313 22.844463,445.713013 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M991.992310,938.272522 
	C1002.917542,937.862488 1013.565002,937.567383 1024.606201,937.136108 
	C1025.000000,942.688049 1025.000000,948.376038 1025.000000,954.532043 
	C1023.770325,956.068237 1022.265015,955.991699 1020.789917,955.986755 
	C1013.756958,955.963379 1006.725769,955.893188 999.332886,954.605713 
	C991.135498,953.662598 991.132874,953.662598 991.159790,945.796692 
	C991.165344,944.169678 991.199219,942.542725 991.158508,940.452637 
	C991.016174,939.345032 991.235535,938.816223 991.992310,938.272522 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M1024.720947,394.717163 
	C1025.000000,395.444458 1025.000000,395.888885 1025.000000,396.666687 
	C1022.174622,401.412048 1024.350708,406.001068 1024.760864,410.759583 
	C1025.000000,421.020905 1025.000000,431.041779 1025.000000,441.531342 
	C1024.113037,443.128143 1023.759888,444.723389 1021.792480,445.248016 
	C1020.939697,445.047363 1020.567017,444.716156 1020.136414,443.918518 
	C1018.719666,439.810120 1020.000671,435.846497 1018.937988,431.666107 
	C1018.424072,428.685944 1018.448181,426.104279 1018.892822,423.083618 
	C1020.035889,412.376434 1019.684448,402.101013 1018.970886,391.384430 
	C1018.204102,385.411835 1018.770935,379.860260 1018.562256,373.866272 
	C1018.579102,371.617767 1018.311584,369.827393 1018.518372,367.594879 
	C1018.520264,362.881134 1018.829163,358.599365 1018.216858,353.931244 
	C1017.822571,352.453003 1017.792542,351.357971 1017.920044,349.864014 
	C1018.529297,347.521454 1018.935364,345.563873 1018.119202,343.191711 
	C1017.746887,341.574280 1017.662659,340.305878 1017.661682,338.649994 
	C1017.676697,337.519318 1017.755005,336.774261 1017.948853,335.676361 
	C1018.451904,333.961884 1018.721313,332.599030 1018.077271,330.867188 
	C1017.548706,328.463593 1017.712830,326.364777 1017.626831,324.279449 
	C1017.561279,322.690430 1017.739502,320.956879 1015.381348,320.171112 
	C1012.892029,318.972137 1010.422302,318.718597 1008.070496,317.224854 
	C1007.560974,316.627747 1007.686462,315.869659 1007.396912,315.884308 
	C1006.755981,315.916779 1007.548218,315.647064 1006.851257,316.366455 
	C1006.008850,316.604370 1005.521973,316.536530 1004.793213,316.051025 
	C1004.193542,315.070831 1004.145386,314.340240 1004.509827,313.268677 
	C1007.695312,311.531311 1010.662231,312.927612 1013.648560,313.124146 
	C1015.119934,313.221039 1016.898987,314.496704 1017.608887,311.628784 
	C1017.676697,310.617401 1017.729065,309.940216 1017.833313,308.923096 
	C1017.926697,308.360840 1017.978210,308.139282 1018.152039,307.604919 
	C1018.217773,306.804779 1019.512329,306.672729 1018.445557,305.690491 
	C1017.825195,304.351715 1017.827209,303.240875 1017.952515,301.791809 
	C1018.156250,300.607300 1018.292297,299.750702 1018.037476,298.550049 
	C1017.604065,296.163452 1017.760986,294.060455 1017.376953,291.649109 
	C1017.333679,291.059143 1017.331543,290.821838 1017.375854,290.231873 
	C1018.460266,286.909393 1017.247498,283.789154 1018.106445,280.453094 
	C1018.376038,279.396088 1018.452698,278.693054 1017.955078,277.624023 
	C1017.428894,268.268555 1016.841248,259.296265 1018.148438,249.939056 
	C1020.883545,248.123444 1020.951904,250.331055 1021.222351,251.706711 
	C1021.730103,254.289719 1021.981995,256.924255 1022.403992,259.527771 
	C1022.693054,261.310913 1022.840942,263.161224 1024.697510,264.717651 
	C1025.000000,266.066681 1025.000000,267.133331 1025.000000,268.600006 
	C1022.908142,271.435730 1022.649658,274.468170 1022.569092,277.425110 
	C1022.393066,283.888885 1022.284607,290.390259 1023.737732,296.740021 
	C1024.536499,300.230499 1022.541992,303.210724 1022.514343,306.520782 
	C1022.418762,317.962494 1022.395081,329.406982 1023.326233,340.816162 
	C1023.919128,348.080109 1021.765747,355.330200 1023.409912,362.987976 
	C1023.418091,363.679291 1023.419800,363.955536 1023.420532,364.645569 
	C1023.398438,366.705597 1023.364136,368.351776 1023.398254,370.407227 
	C1023.410095,371.357910 1023.411865,371.899719 1023.417114,372.844025 
	C1023.277954,378.561554 1023.853821,383.868927 1023.523621,389.192688 
	C1023.414612,390.950348 1022.980835,392.895538 1024.720947,394.717163 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M1.228842,550.221985 
	C1.000000,546.638733 1.000000,543.277405 1.000000,539.458069 
	C1.697671,538.280701 2.570253,537.936523 3.894606,537.774780 
	C5.586145,537.631836 7.000798,537.875916 8.480783,536.742065 
	C9.024749,536.472595 9.257122,536.387756 9.864603,536.257446 
	C11.359479,536.256836 12.197183,536.766418 12.907423,538.091370 
	C12.816147,550.723816 12.453700,562.999817 12.037026,575.274292 
	C12.025726,575.607178 12.000268,575.939270 11.970443,576.270874 
	C12.023921,576.172241 12.077398,576.073608 12.231108,575.690430 
	C12.461555,575.227783 12.591772,575.049683 13.020568,574.691284 
	C16.098898,574.193237 15.511112,576.486633 16.054157,578.305176 
	C16.389925,581.556030 17.897739,582.035400 20.627514,580.702881 
	C22.255184,580.620117 23.068346,581.454102 24.080429,582.564087 
	C24.973078,585.476624 22.692202,588.554443 25.424564,591.244568 
	C23.464783,594.266479 20.619413,593.346924 18.082470,593.463135 
	C15.609382,593.576416 13.126995,593.489075 10.246597,593.480286 
	C8.360671,593.285522 7.606224,592.179443 6.650842,590.752625 
	C6.155872,589.728027 6.006923,589.001709 5.961641,587.902710 
	C6.023307,586.252075 6.756907,585.018005 6.270114,583.354858 
	C6.077147,582.615173 5.972779,582.188965 5.793890,581.434448 
	C5.668751,580.885559 5.624750,580.663269 5.500131,580.107605 
	C5.010290,578.415161 4.849093,577.031311 5.049383,575.266357 
	C6.145745,571.689148 3.994397,568.305908 5.536738,565.310425 
	C5.681118,564.446228 4.590416,564.992188 5.256555,564.965637 
	C5.090830,566.872253 5.139854,568.804260 4.348486,570.951538 
	C3.067465,571.722168 2.155147,571.618530 1.221696,570.315918 
	C1.000000,564.311951 1.000000,558.623962 1.000000,552.467957 
	C1.455718,551.585144 1.505060,551.005127 1.808079,550.229126 
	C2.264786,549.729797 2.542182,549.457214 3.028088,548.974792 
	C3.517568,548.487610 3.798232,548.209961 4.284279,547.719055 
	C4.715874,547.274292 4.909852,547.018250 5.072948,546.739014 
	C5.205885,546.511353 5.127338,546.604248 4.662898,547.229858 
	C4.242335,547.738098 3.980268,548.019592 3.490105,548.505859 
	C2.983396,549.013977 2.689068,549.302612 2.173218,549.816162 
	C1.787993,550.176392 1.622838,550.310181 1.228842,550.221985 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M606.416626,1025.000000 
	C604.733643,1022.056152 602.172913,1025.164917 599.860901,1022.955750 
	C610.869995,1023.294128 621.060852,1021.644714 631.672302,1020.356079 
	C635.671204,1017.895081 639.802917,1017.859131 644.306152,1017.532959 
	C656.639221,1015.949829 668.624023,1015.393494 681.001343,1014.510010 
	C683.137512,1014.705200 684.721619,1014.039185 686.783936,1013.717041 
	C689.434753,1013.452026 691.675415,1013.549927 694.332520,1013.506714 
	C699.100464,1012.032104 703.708618,1013.141174 708.517334,1012.037659 
	C710.052307,1011.690430 711.186646,1011.576538 712.759033,1011.581909 
	C720.177734,1011.342712 727.120544,1010.156738 734.527466,1010.359802 
	C736.612061,1009.751099 738.369507,1009.421631 740.328369,1008.505066 
	C741.158630,1008.286011 741.640747,1008.245667 742.470520,1008.357483 
	C744.344482,1009.475281 745.970886,1009.954224 748.453491,1009.223877 
	C755.169312,1009.742126 761.402405,1008.580017 767.487183,1011.376099 
	C767.570068,1011.946045 767.428467,1012.180908 766.942993,1012.643616 
	C765.599304,1013.359131 764.458923,1013.379883 763.040405,1013.936646 
	C761.519836,1014.308533 760.381470,1014.341064 758.808105,1014.405396 
	C748.817383,1013.627258 739.506165,1016.260132 729.575012,1016.434204 
	C720.910889,1017.283325 712.630737,1017.361938 703.987915,1018.438477 
	C702.959351,1018.473083 702.372070,1018.486267 701.347778,1018.534607 
	C691.791138,1019.821533 682.599915,1020.380859 673.457886,1021.418030 
	C671.836365,1021.601929 670.160461,1021.290466 668.151123,1022.057434 
	C655.371155,1022.604370 643.061523,1023.771118 630.268188,1023.999023 
	C626.450256,1024.075439 623.099304,1024.706177 619.352905,1024.771118 
	C617.285645,1025.000000 615.571289,1025.000000 613.428467,1025.000000 
	C612.564453,1024.515625 612.020874,1024.475586 611.216370,1024.809570 
	C609.611084,1025.000000 608.222229,1025.000000 606.416626,1025.000000 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M907.189270,944.598511 
	C905.901733,946.660889 906.333862,948.533447 906.346680,950.322510 
	C906.523193,974.902954 906.748535,999.483154 906.980957,1024.531738 
	C905.933289,1025.000000 904.866638,1025.000000 903.399963,1025.000000 
	C901.360779,1023.231750 901.593506,1021.015747 901.581421,1018.881104 
	C901.534424,1010.603760 901.605164,1002.326050 901.521118,993.563538 
	C901.452698,977.666870 901.537659,962.255493 901.561646,946.377441 
	C901.560364,944.694641 901.586548,943.478638 901.577393,941.820984 
	C901.556519,940.217224 901.453491,939.055664 901.559814,937.462402 
	C901.600403,935.597900 901.621399,934.163513 901.573669,932.292175 
	C901.458801,930.970337 901.455139,930.084900 901.552002,928.745911 
	C901.586914,918.439819 901.565796,908.586914 901.566650,898.285034 
	C901.554077,896.372681 901.482300,894.904114 902.092468,893.090576 
	C902.537903,892.225891 902.924133,891.855896 903.797485,891.526367 
	C904.941833,891.588928 905.539795,892.012146 906.302246,892.814880 
	C907.246338,893.964600 908.125061,894.688416 909.102051,895.791138 
	C909.325195,896.568604 909.260437,897.036011 908.980591,897.836670 
	C908.714172,898.680908 908.645996,899.190918 908.633667,900.132751 
	C908.393005,913.182007 908.430725,925.809021 908.413147,938.435913 
	C908.410461,940.403809 908.701172,942.450745 907.189270,944.598511 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M64.302567,992.270142 
	C62.294464,992.123962 61.258583,992.931519 60.881500,994.926270 
	C57.035278,997.317444 52.781956,997.204285 48.760361,997.345215 
	C42.482689,997.565308 36.276157,998.728516 29.996439,998.569763 
	C25.966654,998.468018 24.373192,1000.268738 24.528694,1004.253174 
	C24.643301,1007.189880 24.972898,1010.208862 23.576538,1013.428284 
	C22.305584,1013.502563 21.319908,1012.016418 19.993828,1013.764282 
	C17.510403,1009.678284 20.616856,1005.459412 19.395699,1001.444336 
	C17.860106,1005.098328 19.026297,1009.299377 17.602436,1013.438843 
	C16.542395,1013.804626 15.686369,1013.886292 14.399809,1013.964844 
	C13.452124,1013.338989 13.027849,1012.665344 12.759024,1011.483154 
	C12.433894,1008.587463 12.844380,1006.042603 12.174079,1003.207703 
	C11.980723,1002.643677 11.895003,1002.422729 11.666237,1001.882812 
	C8.611548,999.194824 4.550698,1000.533447 1.272093,998.235291 
	C1.000000,997.555542 1.000000,997.111084 1.000000,996.333313 
	C4.335366,993.725891 6.591920,990.529541 8.854239,986.871643 
	C10.136536,986.205811 11.030915,986.520874 12.158354,987.361572 
	C13.204819,988.600342 13.687580,989.792664 14.910913,990.905640 
	C16.909897,993.466980 19.411606,993.624268 21.949146,993.505310 
	C32.908314,992.991760 43.788185,991.227966 54.796944,991.427368 
	C55.863628,991.446716 57.429428,991.493835 57.464252,989.900757 
	C57.492039,988.629578 56.101608,988.692627 55.181351,988.466675 
	C54.374474,988.268616 53.546131,988.158325 52.429710,987.660095 
	C51.490021,986.924744 51.242901,986.224548 51.253197,985.071289 
	C52.252487,982.155151 56.324486,983.402100 56.987175,979.935059 
	C58.015747,978.976135 58.954704,978.654175 60.374413,978.655151 
	C62.726517,979.797546 63.215672,981.808228 63.713810,983.704041 
	C64.670639,987.345581 66.907310,988.818176 70.635818,988.609619 
	C72.909615,988.482422 75.301796,988.199036 77.728271,989.760620 
	C78.301033,990.591858 78.570755,991.178894 78.774544,992.101624 
	C74.050667,994.264709 69.376579,994.145752 64.302567,992.270142 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M51.806580,983.994995 
	C51.978481,984.971802 51.991199,985.639526 51.999161,986.641052 
	C50.693428,988.521301 48.840714,988.599976 46.658104,988.830933 
	C44.734921,988.471863 43.214214,988.453247 41.318169,989.108154 
	C32.343666,988.971313 23.832703,991.584961 14.816144,989.623901 
	C13.845520,989.302979 13.322036,989.054260 12.509558,988.431824 
	C11.364271,987.781616 10.549291,987.418030 9.400658,987.015015 
	C7.833805,987.278503 6.580554,987.368530 4.931131,987.327271 
	C3.496715,987.293091 2.485936,987.121094 1.302781,986.244995 
	C1.000000,985.555542 1.000000,985.111084 1.000000,984.333313 
	C6.740304,981.159668 12.750400,982.641052 18.479424,982.877930 
	C17.362856,982.645874 16.474394,982.340027 15.239343,982.092407 
	C14.717568,981.966248 14.509751,981.909119 13.993928,981.751099 
	C13.072039,981.437073 12.463472,981.208191 11.523233,980.928589 
	C10.996948,980.760986 10.787708,980.687134 10.268859,980.488037 
	C7.212386,978.894104 3.698649,979.097412 1.240604,976.237183 
	C1.000000,975.250000 1.000000,974.500000 1.000000,973.375000 
	C2.031704,971.185120 3.522262,970.108704 6.028008,970.117798 
	C7.072463,970.248901 7.740769,970.449341 8.750336,970.691772 
	C9.531321,970.857300 9.970165,970.980713 10.721449,971.249634 
	C11.238010,971.486023 11.436497,971.597107 11.912580,971.904785 
	C12.365869,972.243164 12.541560,972.385010 12.969782,972.748413 
	C16.342720,974.892151 19.668514,976.066956 23.744041,975.792114 
	C25.519939,975.960693 26.713116,976.658569 28.113926,977.664734 
	C28.921192,978.510437 29.514513,979.085388 30.729321,979.219849 
	C33.927151,980.251953 36.510208,982.322998 40.175110,981.647461 
	C41.397659,981.603882 42.281315,981.479736 43.498970,981.535889 
	C45.006039,982.069702 46.095322,982.763550 47.610710,983.283081 
	C48.337406,983.335754 48.503223,984.688354 49.414955,983.497009 
	C50.398666,983.196960 51.047161,983.304260 51.806580,983.994995 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M1016.516968,766.007019 
	C1011.794922,750.557556 1006.466431,735.705750 1001.152466,720.848755 
	C1000.035706,717.726501 998.865112,714.614868 997.960083,711.429871 
	C997.577820,710.084717 995.694580,708.199402 998.224182,707.209595 
	C1001.027344,706.112732 1001.430603,708.590393 1002.108459,710.408386 
	C1004.195312,716.004700 1006.331421,721.583923 1008.328430,727.212280 
	C1012.036499,737.663574 1016.254578,747.939758 1019.484070,758.884399 
	C1023.460266,761.991882 1023.619873,766.363831 1024.777832,770.703674 
	C1025.000000,774.361267 1025.000000,777.722595 1025.000000,781.541931 
	C1021.764343,781.811707 1021.611633,778.855957 1020.629272,776.844360 
	C1018.989929,773.487366 1018.464111,769.671204 1016.516968,766.007019 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M12.708883,946.540039 
	C12.803428,949.460144 12.728106,951.974548 12.336270,954.744629 
	C9.220431,954.793335 10.796730,952.610779 10.304779,951.018433 
	C7.590068,948.470764 4.155038,951.706604 1.251741,949.227051 
	C1.000000,938.645752 1.000000,928.291565 1.000000,917.468628 
	C5.684667,918.323792 10.537008,919.373413 12.923854,924.703979 
	C12.063866,932.081726 12.647990,939.113281 12.708883,946.540039 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M3.363805,888.007202 
	C2.480051,888.011963 2.057119,888.015320 1.317093,888.009277 
	C1.000000,875.645752 1.000000,863.291565 1.000000,850.468628 
	C1.656248,849.450623 2.368708,849.013855 3.660149,848.854126 
	C6.102933,848.989868 8.037830,849.450195 10.142183,850.739502 
	C10.744268,851.573181 10.903729,852.138184 10.961073,853.189453 
	C11.018285,862.870728 11.000780,872.100525 10.992849,881.330322 
	C10.986723,888.459351 10.913198,888.512451 3.363805,888.007202 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M763.270935,1024.712891 
	C755.312439,1025.000000 747.624817,1025.000000 739.468628,1025.000000 
	C738.006287,1022.046509 740.309448,1022.361023 742.904480,1021.540283 
	C730.929016,1024.096802 719.715332,1023.692932 708.300293,1024.789795 
	C700.312439,1025.000000 692.624817,1025.000000 684.468628,1025.000000 
	C683.917969,1024.723755 683.835876,1024.447632 684.022339,1023.832031 
	C689.022583,1020.997925 694.391846,1021.959778 699.785400,1020.672485 
	C718.397095,1018.554688 736.660461,1017.236084 755.204590,1014.616577 
	C756.450195,1014.557129 757.275940,1014.533875 758.481323,1014.268188 
	C759.680664,1014.060425 760.486938,1014.065613 761.677612,1014.305420 
	C762.536011,1014.704224 762.947510,1015.048706 763.509399,1015.809204 
	C764.357910,1018.924255 765.861023,1021.716614 763.270935,1024.712891 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1022.355713,364.247986 
	C1021.697021,346.293396 1021.305664,328.538361 1021.058777,310.781342 
	C1021.009216,307.215851 1021.202271,303.779755 1022.412476,300.126465 
	C1023.581055,296.598816 1020.907166,292.413849 1021.178650,288.263397 
	C1021.459351,283.971313 1020.853577,279.621582 1021.127319,275.328461 
	C1021.273987,273.028320 1021.307556,270.199463 1024.627197,269.046051 
	C1025.000000,296.687561 1025.000000,324.375122 1025.000000,352.531342 
	C1023.183350,354.707947 1024.733643,356.695618 1024.770020,358.769196 
	C1025.000000,359.750000 1025.000000,360.500000 1025.000000,361.625000 
	C1024.252319,362.841949 1024.501099,364.631226 1022.355713,364.247986 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M980.570251,556.782349 
	C982.919495,557.021240 985.000000,557.039856 987.513184,556.949585 
	C988.805481,556.249512 989.546448,555.508423 990.672913,554.743591 
	C991.369080,554.458740 991.792664,554.441833 992.482788,554.707764 
	C992.938599,557.568115 994.796753,558.190979 996.910217,557.825745 
	C999.707703,557.342224 997.758057,555.208008 997.979492,553.828186 
	C998.082825,553.184326 997.811279,552.463562 997.976685,551.849670 
	C998.320801,550.572998 996.545837,548.034790 999.573975,548.326233 
	C1001.335815,548.495728 1003.207397,548.782410 1002.150269,552.166382 
	C1001.720398,553.542664 1004.595215,555.956360 1000.220459,555.934937 
	C1001.650146,557.797607 1003.555298,556.347351 1005.021423,557.333374 
	C1007.621643,559.082153 1008.144348,557.449036 1007.972534,555.167114 
	C1007.835632,553.347656 1007.668335,551.529968 1007.480591,549.715027 
	C1007.251160,547.497131 1007.987793,546.851929 1010.086060,548.419067 
	C1010.872742,549.493652 1010.846985,550.366333 1010.288574,551.664307 
	C1010.869446,553.509338 1012.315186,552.614258 1013.441589,552.926575 
	C1015.381531,553.464417 1014.769287,554.208923 1013.475342,555.296387 
	C1012.969604,555.774841 1011.910706,555.484924 1012.881958,556.507751 
	C1016.402954,558.244690 1019.262512,559.454712 1018.500427,553.620667 
	C1017.977295,549.616638 1018.804382,546.302185 1024.565186,547.083862 
	C1025.000000,549.700012 1025.000000,552.400024 1025.000000,555.550049 
	C1024.326416,556.388672 1023.762512,556.806335 1024.789795,557.794617 
	C1025.000000,558.750000 1025.000000,559.500000 1025.000000,560.625000 
	C1023.128296,562.653259 1020.783508,561.892273 1018.826477,561.736572 
	C1012.754883,561.253601 1006.659973,561.157715 1000.280151,560.791870 
	C999.960571,561.029785 999.555176,561.210510 999.345947,561.136292 
	C994.446228,559.381775 989.473694,560.377014 984.388550,559.744751 
	C981.335999,560.885315 978.598938,559.839417 975.459961,559.828125 
	C974.862183,559.655823 974.660889,559.563904 974.135010,559.403503 
	C972.476501,559.352844 971.142700,559.370728 969.409302,559.406616 
	C968.838318,559.409180 968.667053,559.393860 968.238037,559.390015 
	C967.547119,559.371399 967.113892,559.341370 966.354858,559.312134 
	C965.851196,559.334839 965.673340,559.356689 965.231567,559.328369 
	C964.433838,559.143188 963.900085,559.008240 963.017639,558.650452 
	C962.282227,557.814636 962.236938,557.172058 962.688354,556.221741 
	C962.702393,554.699951 961.674072,554.133301 960.751282,554.280090 
	C957.740723,554.758850 956.147949,553.846985 957.029114,550.666565 
	C957.936218,547.392822 960.180969,549.135681 962.126648,549.249512 
	C961.582947,551.228210 959.876282,549.733459 958.945129,551.095398 
	C961.263672,552.466064 964.155762,553.125000 964.495422,556.778625 
	C964.625854,558.180298 967.333801,557.431152 969.014526,556.370117 
	C969.488403,555.636536 969.877197,555.500488 970.587097,555.760010 
	C971.044922,556.760193 971.888855,558.020020 972.054749,557.793945 
	C973.957581,555.201599 976.297546,557.810791 978.677368,557.060852 
	C979.404602,556.647339 979.820435,556.511841 980.570251,556.782349 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M10.069510,851.340698 
	C7.992341,850.822083 6.336145,850.466125 4.321622,850.050415 
	C2.027745,848.676941 2.175740,846.397034 1.215739,844.265381 
	C1.000000,840.969421 1.000000,837.938782 1.000000,834.454102 
	C5.021097,831.909790 9.450020,832.121033 13.773418,831.733582 
	C15.136252,831.611389 16.736778,832.594727 18.014179,830.574463 
	C19.086224,829.435181 20.082062,829.053650 21.659704,829.182007 
	C22.928839,829.626587 23.455097,830.238281 23.442492,831.593018 
	C23.263988,832.453796 23.197264,832.901917 23.042934,833.678711 
	C21.781721,838.128357 20.531673,842.246399 22.706520,846.739258 
	C22.992464,847.445618 23.045164,847.900452 23.013390,848.690796 
	C22.678999,849.725403 22.199924,850.181091 21.148048,850.324463 
	C19.014807,849.864136 17.253290,849.786865 15.300146,850.948853 
	C14.294319,851.110840 13.602590,851.154663 12.564590,851.162964 
	C11.683064,851.439758 11.107119,851.565063 10.069510,851.340698 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M1.367001,823.269836 
	C1.000000,823.000000 1.000000,822.500000 1.000000,822.250000 
	C2.848166,820.663696 2.875396,818.565674 2.894636,816.673157 
	C2.926179,813.570557 3.344661,810.543030 3.800589,807.214722 
	C3.430678,806.686401 3.506996,806.296143 3.297858,806.038025 
	C3.146597,806.331726 3.235518,806.584351 3.701746,807.086792 
	C3.965323,809.349365 3.421779,811.020386 1.346887,812.080078 
	C1.000000,808.638733 1.000000,805.277405 1.000000,801.458069 
	C3.459998,793.927673 3.654385,786.390320 5.514748,779.176270 
	C7.171123,772.753418 8.059423,766.137878 9.935823,759.325562 
	C10.651718,757.850952 11.536037,757.273438 13.180603,757.332031 
	C14.382834,757.742249 14.892303,758.365417 15.452009,759.453125 
	C15.122712,764.465454 14.488484,769.090759 13.122341,773.961670 
	C12.182373,775.934265 12.430954,777.700684 12.298672,779.804016 
	C12.246811,780.715271 12.177118,781.235901 11.989803,782.146851 
	C11.067473,788.486877 9.063051,794.269775 9.434797,800.804443 
	C9.360626,808.203064 8.258159,815.059326 6.829311,822.307373 
	C6.446507,822.945007 6.251005,823.174622 5.656936,823.622803 
	C4.040355,824.245728 2.862828,824.177124 1.367001,823.269836 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M10.678797,758.358337 
	C9.338949,767.424561 7.593586,776.211548 5.864422,785.001709 
	C5.138276,788.693054 4.564804,792.419617 3.682818,796.072510 
	C3.311107,797.611938 3.819870,799.839294 1.185426,800.662598 
	C1.000000,787.312439 1.000000,773.624878 1.000000,759.468628 
	C3.907343,756.817200 7.067724,757.187866 10.678797,758.358337 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M117.584106,1017.220032 
	C121.713028,1017.091980 125.424881,1017.016174 129.559753,1016.869751 
	C133.585556,1014.820312 137.492416,1015.672852 141.615112,1015.899780 
	C147.548080,1015.802490 153.212631,1015.712646 158.765503,1014.878906 
	C163.634506,1014.147888 167.437973,1015.823120 171.191376,1018.453735 
	C174.035706,1020.447083 177.008255,1022.257446 180.258087,1024.217773 
	C180.841873,1024.301392 181.091339,1024.316772 181.170410,1024.666016 
	C178.958328,1025.000000 176.916672,1025.000000 174.437500,1025.000000 
	C168.036636,1020.561218 161.792084,1019.370117 154.052078,1019.989563 
	C135.730255,1021.455811 117.366676,1023.057861 98.942253,1023.035400 
	C98.616333,1023.035034 98.292229,1022.910217 97.569855,1022.626587 
	C96.721298,1022.001038 96.471710,1021.481323 96.495758,1020.430786 
	C97.823189,1017.769409 99.997124,1017.681091 102.162529,1017.630188 
	C106.608887,1017.525757 111.057823,1017.679810 115.922379,1017.472656 
	C116.616150,1017.375183 116.891594,1017.323669 117.584106,1017.220032 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M991.336548,908.548767 
	C991.097229,914.919067 991.096252,920.958008 991.099365,927.458191 
	C988.095276,928.962219 986.829773,929.081726 987.640259,924.835876 
	C988.550964,920.065613 987.931091,915.003174 988.002808,909.610107 
	C987.431274,908.370239 986.583984,907.845947 985.722595,906.940796 
	C985.205200,906.566528 984.870300,906.442383 984.232178,906.385010 
	C983.765930,906.361633 983.579651,906.332031 983.191406,906.104492 
	C981.666077,904.264771 982.872681,903.157410 983.897705,901.719482 
	C984.151306,900.519714 984.870544,900.351868 985.997070,900.275635 
	C988.758057,902.157776 991.360779,902.076233 994.387756,901.025452 
	C1000.689087,900.283813 1006.682922,900.864136 1012.654236,900.564392 
	C1014.031677,900.495239 1015.907288,901.645874 1016.674988,899.195923 
	C1016.411987,898.442261 1016.385437,897.981995 1016.562378,897.165527 
	C1018.561646,894.806519 1021.233032,894.541809 1023.945007,893.834045 
	C1024.280273,894.032227 1024.638428,893.976929 1024.819214,893.988464 
	C1025.000000,895.714355 1025.000000,897.428711 1025.000000,899.571533 
	C1024.482666,900.424255 1024.319946,900.944824 1024.785767,901.788940 
	C1025.000000,902.444458 1025.000000,902.888916 1025.000000,903.666687 
	C1024.703247,904.479187 1024.383423,904.942505 1023.686523,905.616821 
	C1014.538696,907.045044 1005.620605,906.215454 996.827942,907.464478 
	C995.076538,907.713257 993.191284,907.017212 991.336548,908.548767 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M1005.563293,582.755981 
	C1008.258972,583.112244 1010.691956,582.555847 1013.222351,584.199280 
	C1014.219116,585.103760 1014.851440,585.107117 1015.701172,584.267944 
	C1017.325256,584.120300 1018.865906,582.485718 1020.343933,584.684082 
	C1021.631165,586.126404 1023.307129,585.765564 1024.771729,586.784363 
	C1025.000000,589.370544 1025.000000,591.741150 1025.000000,594.555847 
	C1022.993042,596.659241 1020.816345,596.605713 1018.229858,595.403931 
	C1016.981812,594.047668 1016.879761,592.803101 1017.268188,591.444519 
	C1016.736328,592.353577 1017.079468,593.563721 1016.096069,594.706665 
	C1012.230286,597.432556 1008.160706,596.157349 1003.866577,596.438110 
	C1002.325317,596.395508 1001.206604,596.366211 999.768677,595.822754 
	C999.203857,595.493652 999.004028,595.329834 998.652588,594.820679 
	C999.289429,591.054443 999.407715,587.207336 1003.536560,586.009827 
	C1001.965820,585.709656 1000.220459,587.280823 998.029419,586.201721 
	C997.659119,585.721252 997.587830,585.470642 997.571899,584.822327 
	C999.624695,581.684631 1002.292053,581.633972 1005.563293,582.755981 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M96.626114,1022.028198 
	C117.917007,1020.807373 138.826385,1019.560120 159.721237,1018.104126 
	C165.787125,1017.681458 170.292450,1020.248474 174.147186,1024.661621 
	C172.285645,1025.000000 170.571289,1025.000000 168.428467,1025.000000 
	C166.737595,1023.211914 164.922546,1022.360352 162.477615,1021.853516 
	C154.337143,1020.497314 146.675781,1022.225647 138.987946,1022.811890 
	C136.213638,1023.023499 133.427094,1023.326111 130.227386,1023.452148 
	C126.425606,1023.773682 122.993073,1023.754150 119.324776,1024.776855 
	C106.312439,1025.000000 93.624878,1025.000000 80.468658,1025.000000 
	C79.615440,1024.534912 79.475876,1024.005127 79.793243,1023.038696 
	C81.744690,1021.392273 83.771095,1021.617493 86.160446,1021.574768 
	C87.125473,1021.588074 87.674538,1021.593445 88.629471,1021.598450 
	C91.433151,1021.782104 93.861099,1021.298157 96.626114,1022.028198 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M1019.618042,149.328186 
	C1019.907776,145.934372 1019.943054,142.899734 1019.949829,139.409576 
	C1019.904480,135.988708 1021.524231,134.667633 1024.671875,134.775986 
	C1025.000000,135.750000 1025.000000,136.500000 1025.000000,137.625000 
	C1024.573242,138.390747 1024.207153,138.829330 1023.804199,139.608002 
	C1023.425842,140.451477 1023.349426,141.062012 1023.351074,142.032196 
	C1023.380005,142.878433 1023.400269,143.377121 1023.447876,144.290100 
	C1023.525452,161.919388 1023.240906,179.137756 1023.999451,196.345566 
	C1024.057495,197.661240 1023.875305,199.004532 1024.734863,200.627594 
	C1025.000000,208.687576 1025.000000,216.375168 1025.000000,224.531372 
	C1024.198730,225.629272 1023.312439,225.777420 1021.963623,225.192535 
	C1019.707764,221.071014 1020.959961,216.951050 1020.537109,212.515747 
	C1019.351013,205.067505 1019.584534,198.016022 1019.560425,190.517883 
	C1018.249512,180.990067 1018.639771,171.859406 1018.566040,162.296387 
	C1018.560547,161.550354 1018.559692,161.253235 1018.560059,160.512970 
	C1018.614197,157.444778 1018.576416,154.818695 1018.685547,151.754883 
	C1018.830444,150.731964 1019.045044,150.189102 1019.618042,149.328186 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M2.231500,202.791931 
	C1.945071,203.012146 1.472551,203.004913 1.236275,203.002457 
	C1.000000,200.299988 1.000000,197.599976 1.000000,194.449982 
	C1.276608,193.590363 1.508870,193.001648 1.928340,192.870438 
	C11.590725,189.848312 21.079329,186.242279 31.402443,184.272522 
	C32.884407,186.414825 33.166031,188.587769 32.989349,191.260803 
	C32.805573,193.256790 31.624311,193.633102 29.970921,193.880737 
	C28.465347,193.783386 27.381161,193.288895 25.881737,193.400970 
	C24.625463,193.471085 23.930954,194.024704 22.908615,194.684006 
	C19.271767,196.544189 15.465861,196.239670 11.977853,197.349945 
	C9.584535,198.111786 7.186966,198.750717 5.242852,201.027039 
	C4.382348,202.114273 3.506583,202.455902 2.231500,202.791931 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M898.294922,1024.619629 
	C888.979126,1025.000000 879.958191,1025.000000 870.468628,1025.000000 
	C868.839661,1021.536621 871.884827,1021.908142 873.569458,1021.268127 
	C875.770630,1020.432007 878.531494,1020.906128 880.239319,1018.131897 
	C881.707031,1017.194397 882.627747,1017.555115 883.590332,1018.477600 
	C887.962341,1022.667725 889.696228,1022.211304 891.480408,1016.477722 
	C891.627930,1016.003540 891.733215,1015.516296 891.965454,1014.669800 
	C892.180603,1014.063049 892.284363,1013.820496 892.602905,1013.233887 
	C894.106567,1006.367737 893.744934,999.807312 893.048706,993.278076 
	C892.574219,988.829041 892.242920,984.424988 893.340454,979.618835 
	C893.822083,979.067078 894.070496,978.898621 894.762207,978.816162 
	C897.648193,981.462952 897.206604,984.712708 897.438110,987.844421 
	C897.752380,992.097290 896.395203,996.508484 898.777100,1001.016602 
	C899.614685,1009.054565 900.278931,1016.666504 898.294922,1024.619629 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M181.468658,1025.000000 
	C181.000000,1025.000000 180.616714,1024.745483 180.604568,1024.515869 
	C192.576523,1024.180298 204.560577,1023.987183 216.544708,1023.983643 
	C269.706421,1023.968262 322.868134,1024.007202 376.495300,1024.054565 
	C377.142883,1024.227905 377.324951,1024.373413 377.253540,1024.759399 
	C311.979095,1025.000000 246.958206,1025.000000 181.468658,1025.000000 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M21.510921,421.662872 
	C20.670206,421.947815 20.146208,421.989105 19.228352,422.047852 
	C15.847014,425.579590 13.556726,429.622375 10.168598,433.191467 
	C8.407171,433.327423 8.684357,431.572998 7.525203,431.163513 
	C8.069263,432.133911 8.962362,433.008514 7.916914,434.422852 
	C5.711360,435.447205 3.729920,435.872009 1.318721,435.229553 
	C1.000000,432.958344 1.000000,430.916656 1.000000,428.437500 
	C2.963305,426.406494 5.300289,426.527557 7.466226,426.510223 
	C5.593236,425.934357 3.534665,427.424408 1.257995,426.229309 
	C1.000000,424.611115 1.000000,423.222198 1.000000,421.416656 
	C5.875950,418.444489 11.306579,419.204803 16.768776,418.111694 
	C19.263809,416.350708 21.940172,416.806763 24.705872,416.033020 
	C26.481613,417.129364 28.188858,415.469879 29.809774,416.880768 
	C30.041964,417.824066 30.032619,418.458527 30.028252,419.410614 
	C27.821085,422.829956 24.432451,420.222900 21.510921,421.662872 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M898.375000,1025.000000 
	C897.990723,1017.299744 897.981506,1009.599426 897.908569,1001.432251 
	C897.239014,1000.118530 897.043884,999.150269 897.034729,998.136292 
	C896.854309,978.210571 897.149597,958.291748 898.084412,937.921631 
	C898.618347,936.880798 899.116272,936.474670 900.244507,936.162842 
	C901.401123,936.103271 902.018799,936.293884 902.810791,937.088928 
	C903.028198,938.310059 903.018738,939.096741 903.023560,940.178223 
	C901.959839,941.920654 901.964783,943.601868 901.999023,945.731873 
	C901.593750,961.436523 901.349915,976.700439 901.531738,992.440186 
	C902.045105,1003.345703 902.452576,1013.779602 901.267578,1024.606201 
	C900.250000,1025.000000 899.500000,1025.000000 898.375000,1025.000000 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M39.727943,388.166840 
	C40.833164,386.858429 42.289505,386.454376 42.965309,387.211243 
	C44.364956,388.778748 43.664989,390.740540 42.922913,392.873718 
	C42.489891,393.459106 42.077370,393.597809 41.302494,393.568604 
	C39.357811,392.672424 38.155823,393.608582 36.624214,394.612549 
	C32.730888,395.126221 29.219313,395.928009 25.385483,396.712097 
	C24.374945,396.969238 23.646353,396.995239 22.553211,397.022644 
	C15.335041,397.598602 8.575640,398.974121 1.354216,399.216583 
	C1.000000,397.285645 1.000000,395.571289 1.000000,393.428467 
	C1.530014,393.116760 2.060029,393.233490 2.766216,393.561951 
	C7.426991,394.923126 11.592453,392.797729 15.942019,392.464783 
	C23.879852,391.857239 31.554516,389.525299 39.727943,388.166840 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M1005.892273,789.150024 
	C1007.133545,787.649292 1007.987915,787.199768 1008.757019,789.146301 
	C1010.085815,792.509399 1011.674561,795.778320 1012.851562,799.191223 
	C1015.914307,808.071838 1018.797119,817.014343 1021.791992,825.918579 
	C1022.299500,827.427734 1022.447083,829.217957 1024.637207,829.968262 
	C1025.000000,833.361267 1025.000000,836.722595 1025.000000,840.541931 
	C1022.102234,841.354492 1022.614075,838.716919 1022.001587,837.322571 
	C1017.668518,827.458618 1015.675049,816.815857 1012.007019,806.349365 
	C1011.605713,801.163757 1009.573425,796.893982 1007.365540,792.350098 
	C1006.807861,791.591125 1006.472778,791.090637 1006.002075,790.318604 
	C1005.792114,789.828369 1005.717773,789.609741 1005.892273,789.150024 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1025.000000,264.531342 
	C1022.094360,265.370758 1020.967407,264.264984 1020.903809,261.178864 
	C1020.823792,257.296539 1020.052490,253.428467 1019.284058,249.278625 
	C1017.794067,247.935364 1017.788086,246.525482 1017.919617,244.682571 
	C1018.555542,242.241867 1019.204468,240.271423 1018.875671,238.053314 
	C1018.234253,233.726212 1020.223633,230.926102 1024.664429,229.782959 
	C1025.000000,241.354233 1025.000000,252.708450 1025.000000,264.531342 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M683.928650,1023.395447 
	C683.988159,1023.995911 683.984253,1024.196777 683.990173,1024.698730 
	C665.979126,1025.000000 647.958191,1025.000000 629.468628,1025.000000 
	C628.667542,1024.703003 628.506653,1024.335693 628.721924,1023.620850 
	C641.595947,1021.827637 654.354065,1021.122009 667.591064,1020.502808 
	C668.291260,1021.153015 668.390686,1021.777527 667.671082,1022.214844 
	C668.063416,1022.464722 668.276428,1022.034668 668.588074,1021.971680 
	C673.774170,1020.923706 678.902649,1020.717285 683.928650,1023.395447 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M1025.000000,200.531342 
	C1022.873840,200.725876 1023.119873,199.106827 1023.004211,197.608917 
	C1021.619751,179.680740 1021.930542,161.724854 1022.174988,143.299103 
	C1022.915588,142.299103 1023.633301,142.252975 1024.697998,142.768982 
	C1025.000000,146.361282 1025.000000,149.722580 1025.000000,153.541931 
	C1024.011719,155.416382 1024.628906,156.985199 1024.786865,158.745087 
	C1025.000000,172.687561 1025.000000,186.375122 1025.000000,200.531342 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M1025.000000,513.666687 
	C1006.707153,514.948181 988.442932,516.436523 970.005554,516.634888 
	C969.564331,515.894714 969.452148,515.380554 969.786316,514.488953 
	C988.026733,513.162292 1006.021667,511.959198 1024.532471,511.959503 
	C1025.000000,512.444458 1025.000000,512.888916 1025.000000,513.666687 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M41.757030,1017.012817 
	C42.050198,1017.799927 42.059723,1018.223511 42.070229,1018.964844 
	C41.382034,1022.577759 39.346935,1021.723511 37.287121,1020.848389 
	C36.982285,1020.718872 36.876263,1021.376221 36.844612,1022.402588 
	C32.829292,1024.866699 28.490313,1023.255005 24.296843,1024.755127 
	C23.555555,1025.000000 23.111111,1025.000000 22.333332,1025.000000 
	C19.190609,1023.220581 16.168268,1024.084717 12.818981,1024.378662 
	C9.512308,1024.543457 6.583766,1024.412354 3.328738,1024.770996 
	C-0.085014,1025.612183 1.263320,1023.268921 1.000000,1021.500000 
	C2.076276,1019.880981 3.368373,1019.105774 4.931106,1019.098511 
	C16.863573,1019.042908 28.676071,1017.462219 40.527138,1016.368408 
	C40.835285,1016.340027 41.160088,1016.535278 41.757030,1017.012817 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M976.367676,952.785828 
	C976.893982,976.670837 976.957703,1000.366882 977.010742,1024.531494 
	C976.555542,1025.000000 976.111084,1025.000000 975.333313,1025.000000 
	C972.911682,1022.023010 974.571472,1018.815063 974.599426,1015.764587 
	C974.765625,997.644470 972.853455,979.567871 973.560852,961.442566 
	C973.651550,959.118469 973.403198,956.778503 974.086914,954.011719 
	C974.643372,952.932861 975.186951,952.615540 976.367676,952.785828 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M543.357788,1018.837524 
	C544.760498,1021.675659 548.308655,1021.527161 549.071289,1024.649780 
	C539.979126,1025.000000 530.958191,1025.000000 521.468628,1025.000000 
	C520.652893,1024.621338 520.524414,1024.179077 520.891479,1023.432129 
	C522.433594,1023.105957 523.107117,1022.151550 524.002563,1021.025024 
	C523.967102,1020.382874 523.337341,1020.297058 523.561890,1019.838745 
	C523.650208,1019.658447 524.130920,1019.670410 524.699463,1020.111450 
	C526.902161,1021.122131 528.671753,1020.187988 530.888123,1019.813538 
	C532.919556,1016.277710 536.026611,1017.864990 539.037598,1017.549683 
	C540.750244,1017.631531 541.987732,1017.733337 543.357788,1018.837524 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1002.267639,55.224014 
	C1002.440918,51.958298 1004.378479,50.876614 1007.618530,51.000702 
	C1008.105835,49.889721 1008.047424,47.725365 1008.486633,47.875591 
	C1010.330566,48.506245 1012.630554,49.375454 1013.516052,50.887756 
	C1015.050415,53.508392 1015.812622,54.710682 1018.917908,52.471264 
	C1020.752075,51.148594 1022.015076,54.975979 1024.640137,54.961662 
	C1025.000000,55.750000 1025.000000,56.500000 1025.000000,57.625000 
	C1024.192627,59.027908 1022.838562,59.191589 1021.610718,60.158058 
	C1021.148499,60.435581 1020.952332,60.530418 1020.436157,60.704330 
	C1018.191284,61.237232 1016.063416,58.236023 1014.002319,61.324875 
	C1010.132812,63.030598 1008.478149,60.110607 1006.859497,58.079044 
	C1005.617065,56.519527 1004.446045,55.569065 1002.267639,55.224014 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M1018.913391,987.112244 
	C1019.381775,986.990540 1019.572815,987.031067 1020.048096,987.142395 
	C1021.702576,987.758057 1023.367493,987.377014 1024.768555,988.775879 
	C1025.000000,990.714355 1025.000000,992.428711 1025.000000,994.571533 
	C1024.097046,995.958679 1023.129883,996.840576 1021.841553,997.241577 
	C1017.666382,998.541443 1015.429382,1001.492920 1014.366821,1005.950073 
	C1013.664062,1006.467712 1013.179382,1006.531250 1012.374634,1006.194702 
	C1010.975342,1003.439392 1009.873901,1000.916260 1008.767944,998.071533 
	C1009.221069,996.275513 1008.297913,994.217468 1011.628052,994.479370 
	C1013.948486,994.661926 1017.332397,994.104553 1018.098755,990.122681 
	C1018.710388,988.993408 1018.407715,988.081665 1018.913391,987.112244 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M991.561523,908.882751 
	C989.575623,906.950745 989.321899,905.927368 992.499268,905.861755 
	C1002.691406,905.651245 1012.878540,905.191833 1023.529968,904.750244 
	C1024.183594,904.655334 1024.374756,904.638611 1024.782959,904.810913 
	C1025.000000,905.750000 1025.000000,906.500000 1025.000000,907.625000 
	C1014.023865,908.875183 1003.035950,909.313293 991.561523,908.882751 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M22.799770,969.764526 
	C24.003035,971.440735 24.947115,972.866821 25.956490,974.617310 
	C25.753874,975.300781 25.413868,975.563599 24.666620,975.767517 
	C23.246580,975.828979 22.244019,975.408936 20.906576,975.047485 
	C20.403788,974.899780 20.204359,974.836853 19.708544,974.676025 
	C18.622253,974.316833 17.817888,974.114136 16.680889,973.923035 
	C16.156578,973.809265 15.947343,973.755066 15.426645,973.602417 
	C13.183474,973.051575 11.731539,971.322876 9.265709,971.333496 
	C6.602721,970.093628 4.126367,970.051758 1.305454,970.161133 
	C1.000000,967.629456 1.000000,965.258850 1.000000,962.444153 
	C3.011712,960.641663 3.848114,962.557007 5.098838,963.423096 
	C5.830755,963.929932 6.101604,965.911255 7.737705,964.048523 
	C7.951787,963.540710 8.041128,963.335571 8.285854,962.826050 
	C8.943441,961.723267 9.515973,961.005859 10.821222,960.827393 
	C12.005657,961.752258 12.089000,962.871094 12.298517,964.258911 
	C12.445271,965.123535 12.649226,965.636353 13.337767,966.165344 
	C14.250510,966.642517 14.955947,966.888794 16.014725,966.962463 
	C18.768089,966.091125 16.958258,962.461060 20.005079,961.920288 
	C22.123739,964.238281 20.619097,967.385254 22.799770,969.764526 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M1025.000000,872.625000 
	C1024.011719,872.669250 1022.880066,872.991516 1022.428040,871.344482 
	C1019.868591,862.020081 1015.315247,853.467651 1011.805176,844.507202 
	C1011.288086,843.187256 1009.819397,841.342285 1011.479065,840.534668 
	C1013.178528,839.707520 1013.618774,841.961060 1014.309265,843.230774 
	C1017.935242,849.898071 1019.955383,857.360596 1024.706543,863.306763 
	C1025.000000,863.444458 1025.000000,863.888916 1025.000000,864.666687 
	C1024.508667,865.436157 1024.491089,866.022339 1024.488525,866.908569 
	C1024.507324,867.988403 1024.425537,868.778381 1024.806641,869.777039 
	C1025.000000,870.750000 1025.000000,871.500000 1025.000000,872.625000 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M12.657259,1001.691650 
	C14.809117,1004.488586 13.510055,1007.364319 13.928148,1010.478943 
	C10.104155,1013.279968 5.931550,1012.936768 1.373846,1012.253845 
	C1.000000,1009.299988 1.000000,1006.599976 1.000000,1003.449951 
	C4.587191,1001.216675 8.256259,1000.019836 12.657259,1001.691650 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M1025.000000,528.625000 
	C1022.732910,529.067383 1020.465820,529.134705 1017.781006,529.144653 
	C1017.047913,529.182800 1016.732605,529.278259 1015.942139,529.237549 
	C1013.574463,529.422241 1011.681885,529.743103 1009.436584,529.987915 
	C999.782837,530.106750 990.480713,529.974976 981.179260,529.978271 
	C978.514587,529.979187 975.927490,530.321838 973.301514,530.749573 
	C971.402100,531.058899 969.295166,530.657410 967.930420,528.351501 
	C973.368042,525.622009 979.228821,526.314514 984.888000,525.700562 
	C990.124878,525.132385 995.466675,525.588684 1001.204346,525.563293 
	C1003.357422,525.593628 1005.055847,525.198975 1007.180237,525.461060 
	C1009.999695,525.670349 1012.413452,525.617249 1015.224487,525.599731 
	C1016.939880,525.520874 1018.274963,525.605225 1019.943970,525.048950 
	C1021.728210,524.731201 1023.090698,524.697144 1024.670166,525.748230 
	C1025.000000,526.750000 1025.000000,527.500000 1025.000000,528.625000 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M19.628685,162.046555 
	C22.147945,160.448471 24.362587,160.843552 26.833509,161.901917 
	C27.661585,163.035736 27.958401,163.940811 27.666752,165.299164 
	C22.732431,166.369797 18.399799,168.659500 13.445753,170.026306 
	C11.393021,170.335098 9.638313,170.522995 7.706700,171.458008 
	C7.164130,171.599625 6.943704,171.641495 6.389188,171.710510 
	C4.537220,171.564774 2.965307,172.243866 1.243471,171.223984 
	C1.000000,169.933334 1.000000,168.866653 1.000000,167.399994 
	C7.692285,167.694351 13.029716,163.324265 19.628685,162.046555 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1017.639771,593.792603 
	C1019.757324,595.904419 1022.094421,594.609314 1024.580811,595.005005 
	C1025.000000,595.750000 1025.000000,596.500000 1025.000000,597.625000 
	C1024.878906,598.109985 1024.775635,598.259033 1024.634033,598.324402 
	C1017.147949,601.778442 1017.097534,602.406372 1024.103760,608.108154 
	C1024.157593,608.973267 1024.017700,609.165771 1023.547363,609.498169 
	C1022.978577,609.666870 1022.740417,609.695679 1022.143433,609.700562 
	C1020.614136,609.438782 1019.434753,609.286072 1017.867310,609.314575 
	C1016.739014,609.336487 1015.984497,609.284790 1014.850708,609.108887 
	C1013.417664,608.674744 1012.628479,608.076843 1012.520142,606.513428 
	C1015.546570,600.850159 1014.886536,599.637939 1008.870300,599.383850 
	C1007.075195,599.308044 1005.253967,599.459473 1003.228271,598.502014 
	C1002.391663,597.633484 1002.286621,596.893616 1002.705505,595.765259 
	C1007.063965,595.106018 1011.199524,594.776428 1015.688477,594.223511 
	C1016.411133,593.650391 1016.848267,593.506226 1017.639771,593.792603 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M11.762745,623.706665 
	C11.997343,625.905090 17.613256,626.353027 13.220348,629.649292 
	C12.690025,630.345581 12.247265,630.528198 11.373981,630.272095 
	C5.735597,628.595337 4.334573,629.151184 3.649889,633.662964 
	C3.393027,635.355652 3.499818,636.343628 1.270128,635.117676 
	C1.000000,632.958313 1.000000,630.916687 1.000000,628.437500 
	C1.517618,627.575806 1.679908,627.055115 1.214245,626.211060 
	C1.000000,624.611084 1.000000,623.222229 1.000000,621.416626 
	C1.370134,620.657837 1.783471,620.379822 2.605372,620.078857 
	C3.468172,619.959412 3.963594,619.973877 4.815415,620.121826 
	C7.461738,620.946045 9.418674,622.345276 11.762745,623.706665 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M1012.046875,1006.347412 
	C1012.489136,1005.970215 1012.901489,1005.977966 1013.623413,1005.989014 
	C1016.749390,1002.895325 1020.159607,1000.939453 1024.693237,1000.776489 
	C1025.000000,1003.041687 1025.000000,1005.083313 1025.000000,1007.562500 
	C1023.638550,1011.344177 1019.635193,1012.140747 1017.808472,1015.515991 
	C1017.414551,1015.935730 1017.231201,1016.078796 1016.699097,1016.222168 
	C1013.769592,1013.578064 1012.657227,1010.263000 1012.046875,1006.347412 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M42.269218,1017.200989 
	C28.722462,1019.641052 15.172650,1019.133484 1.399654,1020.869141 
	C1.000000,1020.250000 1.000000,1019.500000 1.000000,1018.375000 
	C13.527361,1018.402344 25.905205,1016.865173 38.273800,1015.166260 
	C39.576416,1014.987305 40.920967,1015.113586 42.599182,1015.207764 
	C43.111526,1015.420898 43.270748,1015.524536 43.225914,1015.827148 
	C42.847164,1016.359253 42.672462,1016.692444 42.269218,1017.200989 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M4.779068,538.743652 
	C3.476789,538.992126 2.534250,539.213013 1.295856,539.216919 
	C1.000000,535.969421 1.000000,532.938782 1.000000,529.454102 
	C6.745932,530.398682 12.512177,531.602600 18.823982,530.965820 
	C17.206459,535.142822 13.160161,535.482971 9.190111,536.689087 
	C8.850191,536.819519 8.875351,536.782593 8.852918,536.784302 
	C8.043287,538.277466 6.508095,538.338135 4.779068,538.743652 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M6.538030,589.648560 
	C7.795144,590.331055 8.590448,591.029602 8.975354,592.509399 
	C6.726614,594.203186 4.223291,593.212280 1.410215,593.216309 
	C1.000000,585.645752 1.000000,578.291504 0.999992,570.468628 
	C1.672052,570.284424 2.344121,570.568787 3.286242,570.907776 
	C3.784278,571.022522 4.012261,571.082703 4.362497,571.474365 
	C4.582876,574.482727 3.803132,577.361389 6.563951,579.644775 
	C6.915232,579.991577 6.954599,580.191895 6.993633,580.698486 
	C6.487676,581.419189 6.317111,581.927307 6.762963,582.766357 
	C8.450366,584.143005 7.804428,585.379517 6.937432,586.933228 
	C5.289756,587.695984 6.241807,588.619751 6.538030,589.648560 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M880.815552,1017.697632 
	C880.637817,1020.778809 879.551208,1022.285156 876.263367,1022.092529 
	C874.189453,1021.971069 871.772949,1022.411438 870.064209,1024.627563 
	C869.250000,1025.000000 868.500000,1025.000000 867.375000,1025.000000 
	C864.667847,1022.118713 865.725098,1018.788452 866.465942,1015.922852 
	C867.443420,1012.142273 871.145325,1013.906921 874.141357,1013.506592 
	C875.614197,1013.425171 876.763977,1013.866272 876.732971,1014.872803 
	C876.632629,1018.117615 879.291260,1016.677551 880.815552,1017.697632 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M708.468628,1025.000000 
	C713.696594,1022.132874 720.000977,1023.186768 725.999268,1022.419128 
	C732.990540,1021.524414 740.049500,1020.054504 747.472473,1021.195984 
	C745.450806,1024.941406 741.107483,1021.275574 739.069824,1024.615967 
	C728.979126,1025.000000 718.958191,1025.000000 708.468628,1025.000000 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1025.000000,86.550018 
	C1022.512573,87.602272 1021.092407,84.861343 1018.375610,85.002808 
	C1016.929688,82.203018 1015.711060,79.515755 1016.952820,76.332100 
	C1018.016785,73.604324 1018.276428,69.938705 1021.878601,74.580551 
	C1022.240784,75.047272 1023.427917,74.873871 1024.616089,74.998764 
	C1025.000000,75.444443 1025.000000,75.888893 1025.000000,76.666672 
	C1025.061157,77.358376 1023.890137,77.131943 1024.808594,77.903183 
	C1025.000000,80.700012 1025.000000,83.400032 1025.000000,86.550018 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M975.769958,952.458252 
	C974.462402,957.138611 975.111755,961.476074 975.089905,965.760376 
	C974.990601,985.194214 975.038513,1004.628723 975.016724,1024.531494 
	C974.555542,1025.000000 974.111084,1025.000000 973.333313,1025.000000 
	C974.438721,1015.009460 973.956238,1004.956177 973.952637,994.450562 
	C972.783142,992.069763 972.385498,989.930420 972.368469,987.777283 
	C972.271301,975.488098 972.213562,963.197693 972.570007,950.910889 
	C972.622498,949.102844 972.515198,947.202393 974.588501,945.723572 
	C977.923950,947.387695 975.879028,949.839172 975.769958,952.458252 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M520.739624,1023.172852 
	C521.117554,1023.591736 521.067017,1023.992615 521.008240,1024.696777 
	C492.979095,1025.000000 464.958221,1025.000000 436.468658,1025.000000 
	C438.033813,1023.328857 440.466187,1024.038330 442.704437,1024.032227 
	C465.948730,1023.968201 489.193268,1023.997192 512.437744,1024.003784 
	C515.093872,1024.004517 517.749817,1024.024292 520.739624,1023.172852 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1024.715088,476.724121 
	C1025.000000,481.024536 1025.000000,485.049103 1025.000000,489.536804 
	C1023.224670,491.528656 1021.205261,491.570618 1018.680786,490.783569 
	C1017.503235,490.057617 1017.215515,489.257507 1017.076416,487.953796 
	C1017.351868,485.959656 1017.734192,484.393768 1017.616699,482.373718 
	C1017.564026,480.918610 1017.589294,479.860199 1017.652222,478.401306 
	C1017.770752,476.906097 1018.038452,475.876221 1019.122498,474.802063 
	C1021.531738,474.096161 1023.079285,475.010773 1024.715088,476.724121 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M1016.284485,766.056946 
	C1019.679016,767.956177 1019.623535,771.919128 1021.099304,775.121582 
	C1022.133972,777.367126 1023.237488,779.580872 1024.655151,781.904419 
	C1025.000000,786.356873 1025.000000,790.713806 1025.000000,795.535339 
	C1021.200806,786.407715 1018.886536,776.372620 1016.284485,766.056946 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M762.023804,1015.304810 
	C761.080200,1015.271301 760.386841,1015.275146 759.346619,1015.270630 
	C758.633667,1014.803711 758.488281,1014.283447 758.790649,1013.348755 
	C760.072998,1012.958313 761.128357,1012.920593 762.569885,1012.792908 
	C763.808777,1012.440247 764.698303,1012.558228 765.894470,1012.463257 
	C766.510010,1012.424194 766.797119,1012.372559 767.397949,1012.015991 
	C767.711731,1011.711182 767.710266,1011.819641 767.656616,1011.827820 
	C767.933899,1012.072632 768.257080,1012.319397 768.840210,1012.723022 
	C769.106812,1012.871094 769.142273,1012.899353 769.142761,1012.876587 
	C770.179443,1016.609802 770.820801,1020.381531 769.298218,1024.613770 
	C767.285645,1025.000000 765.571289,1025.000000 763.428467,1025.000000 
	C764.124573,1022.297302 763.099670,1019.596558 762.945557,1016.507996 
	C762.748474,1015.814758 762.543274,1015.552734 762.023804,1015.304810 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M18.088131,981.822021 
	C20.299564,981.729614 21.842213,982.368774 24.283360,983.817383 
	C16.084215,983.817383 8.980756,983.817383 1.438648,983.908691 
	C1.000000,982.285645 1.000000,980.571289 1.000000,978.428467 
	C4.333536,977.202148 7.192310,979.231384 10.700126,979.748291 
	C11.064861,979.928955 10.999903,979.977051 11.008900,979.937622 
	C11.651706,980.779480 12.648604,980.398682 13.769814,980.769287 
	C14.063214,980.932983 14.006047,980.983826 14.008352,980.945679 
	C15.064005,982.041809 16.530706,981.198730 18.088131,981.822021 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1025.000000,630.536804 
	C1022.834045,634.251526 1020.715820,630.149292 1018.253052,630.916504 
	C1017.799805,630.711487 1017.659119,630.548157 1017.500244,629.743408 
	C1017.556763,628.898438 1017.631348,628.694824 1017.848267,628.202026 
	C1018.435181,625.629944 1017.767029,623.028442 1020.055298,620.947815 
	C1020.399475,620.212036 1020.523682,619.730164 1020.340515,619.264893 
	C1019.819092,617.940308 1018.738647,616.435120 1020.736267,615.557251 
	C1022.564697,614.753662 1023.806091,615.808777 1024.790649,617.736694 
	C1025.000000,622.024536 1025.000000,626.049072 1025.000000,630.536804 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M36.857391,1022.375610 
	C38.801174,1021.644714 33.945156,1020.563354 37.213200,1020.273010 
	C38.745937,1020.136841 40.397419,1021.400879 41.942093,1019.579102 
	C45.079853,1018.880127 48.068905,1018.738342 51.181252,1020.262329 
	C51.082298,1022.174805 49.742973,1021.802673 48.687744,1021.991089 
	C50.649212,1022.017456 52.614609,1021.999756 54.922638,1021.996155 
	C55.493130,1021.993042 55.720890,1021.996521 56.282162,1022.067383 
	C57.260956,1022.328857 57.882484,1022.588928 58.826958,1022.939453 
	C59.335335,1023.166138 59.531502,1023.272583 59.971760,1023.607422 
	C60.280350,1024.048462 60.344849,1024.261108 60.204674,1024.736816 
	C53.978848,1025.000000 47.957695,1025.000000 41.468269,1025.000000 
	C40.118286,1023.786255 38.626038,1024.161133 37.208817,1023.450378 
	C36.851234,1023.053223 36.760803,1022.851440 36.857391,1022.375610 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,317.333313 
	C13.038689,315.956787 24.872297,313.564545 36.768406,311.579712 
	C39.986904,311.042755 43.226925,310.634735 46.537365,310.596649 
	C31.896477,314.769012 16.681602,315.953644 1.398024,318.922516 
	C1.000000,318.555542 1.000000,318.111115 1.000000,317.333313 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M1025.000000,544.666687 
	C1008.405334,545.193115 991.870422,543.167725 975.259827,543.015320 
	C991.527466,543.015320 1007.795105,543.015320 1024.531372,543.007690 
	C1025.000000,543.444458 1025.000000,543.888916 1025.000000,544.666687 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M1024.712158,461.756653 
	C1025.000000,465.692902 1025.000000,469.385834 1025.000000,473.539368 
	C1023.863525,475.056213 1022.548218,475.101593 1020.755005,474.572937 
	C1019.842346,474.285278 1019.366821,474.028656 1018.678772,473.381348 
	C1017.579041,471.333435 1017.611816,469.511902 1018.003113,467.307495 
	C1018.131226,466.360474 1019.405884,466.148163 1018.451294,464.982239 
	C1018.100037,463.916718 1018.119873,463.187225 1018.542297,462.135223 
	C1019.116943,461.468475 1019.552979,461.218384 1020.409973,460.968048 
	C1021.539368,460.775024 1022.296387,460.799316 1023.415405,461.021301 
	C1023.994263,461.253632 1024.209351,461.383453 1024.712158,461.756653 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M1025.000000,1000.571533 
	C1021.554016,1002.650024 1018.108032,1004.299988 1014.297485,1005.971130 
	C1013.790771,999.417480 1014.851379,998.296448 1024.631836,995.036499 
	C1025.000000,996.714355 1025.000000,998.428711 1025.000000,1000.571533 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M973.828857,540.414673 
	C984.408325,539.700256 994.792480,539.350525 1005.648071,539.067749 
	C1012.128967,540.020386 1018.179016,539.208374 1024.600464,539.784302 
	C1025.000000,540.000000 1025.000000,540.500000 1025.000000,540.750000 
	C1008.284851,540.730164 991.572693,540.822266 974.396851,541.488586 
	C973.830322,541.294922 973.731934,541.037231 973.828857,540.414673 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M998.951294,954.796265 
	C1007.323547,953.608032 1015.676514,955.243835 1024.536499,954.971008 
	C1025.000000,955.444458 1025.000000,955.888916 1025.000000,956.666687 
	C1016.681335,956.412903 1008.403076,957.065918 999.783569,957.762451 
	C999.288330,956.882141 999.137207,956.049072 998.951294,954.796265 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M901.333313,1025.000000 
	C900.858704,1014.641235 900.717407,1004.282471 900.693665,993.530029 
	C901.182922,992.508911 901.742920,992.422058 902.597412,992.815857 
	C902.876160,1003.384399 902.947754,1013.723633 903.009705,1024.531494 
	C902.555542,1025.000000 902.111084,1025.000000 901.333313,1025.000000 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M32.071541,184.196014 
	C21.755882,187.502975 11.726895,190.611053 1.348955,193.859558 
	C1.000000,193.555557 1.000000,193.111099 1.000001,192.333328 
	C10.122487,189.170685 19.242912,186.334671 28.369669,183.519196 
	C29.746710,183.094406 31.124287,182.216782 32.590389,183.279678 
	C32.664234,183.333206 32.706879,183.527725 32.668919,183.615387 
	C32.606178,183.760315 32.465847,183.871643 32.071541,184.196014 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1025.000000,617.555847 
	C1024.352051,617.521606 1023.652100,617.098450 1023.069519,616.550537 
	C1022.360657,615.883850 1021.514038,615.746826 1020.899292,616.335510 
	C1019.636230,617.544922 1021.123169,617.804565 1021.747314,618.376099 
	C1022.692017,619.241211 1023.332825,620.151062 1021.046875,620.937256 
	C1017.807068,619.858093 1016.464111,617.277222 1013.914307,615.610962 
	C1011.843323,612.914612 1010.434082,610.493835 1014.500000,608.258057 
	C1015.727600,608.053284 1016.628418,608.056519 1017.976868,608.112793 
	C1018.786743,608.698303 1018.917114,609.289368 1018.807495,610.168762 
	C1018.875549,610.629761 1018.227539,610.839233 1018.835938,610.872437 
	C1019.194580,610.494568 1019.486633,610.389709 1020.076965,610.381775 
	C1020.511719,610.451782 1020.678833,610.509399 1021.050659,610.721313 
	C1021.410889,611.178894 1021.658081,611.333862 1022.153015,611.157227 
	C1022.414429,610.837463 1022.519653,610.700989 1022.817871,610.372192 
	C1023.170715,610.080566 1023.330627,609.981201 1023.755859,609.765259 
	C1024.215088,609.621155 1024.409180,609.593567 1024.801514,609.783020 
	C1025.000000,612.370544 1025.000000,614.741150 1025.000000,617.555847 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M1024.187012,609.224854 
	C1024.065063,607.478577 1023.094666,606.798950 1021.834045,606.805481 
	C1018.334229,606.823669 1017.151733,604.293274 1017.217163,601.727539 
	C1017.295227,598.666443 1020.040527,598.108826 1022.687988,598.093140 
	C1023.185852,598.090210 1023.683411,598.036865 1024.590576,598.003418 
	C1025.000000,601.361267 1025.000000,604.722595 1025.000000,608.541931 
	C1024.820068,609.146729 1024.640259,609.293457 1024.187012,609.224854 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M60.144516,1024.187256 
	C59.821648,1023.966248 59.647400,1023.929382 59.212334,1023.834595 
	C58.933357,1023.484253 58.915199,1023.191772 59.225243,1022.606262 
	C67.544540,1019.919434 75.875359,1019.920593 84.055145,1018.861084 
	C85.050980,1018.732056 86.021912,1019.092529 87.130219,1020.049316 
	C87.611946,1020.961121 87.641083,1021.536926 87.248894,1022.490051 
	C84.990875,1023.004700 82.974930,1023.151062 80.539963,1023.404419 
	C76.126221,1024.959229 71.969406,1024.373413 67.463150,1024.488281 
	C66.254944,1024.490601 65.451622,1024.474854 64.325012,1024.770020 
	C63.250000,1025.000000 62.500000,1025.000000 61.375000,1025.000000 
	C60.766590,1024.787964 60.530972,1024.578491 60.144516,1024.187256 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1025.000000,394.541931 
	C1021.952759,395.259491 1022.001587,393.204865 1022.015442,391.088501 
	C1022.053162,385.320190 1022.042297,379.551544 1022.093628,373.322998 
	C1022.814392,372.325714 1023.560547,372.248596 1024.680176,372.766479 
	C1025.000000,374.714355 1025.000000,376.428711 1025.000000,378.571533 
	C1024.012085,380.416473 1024.628296,381.985413 1024.786621,383.745300 
	C1025.000000,387.361298 1025.000000,390.722565 1025.000000,394.541931 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M11.295668,758.427246 
	C8.019412,758.808899 4.961055,758.981445 1.451349,759.077026 
	C1.000000,757.933289 1.000000,756.866638 1.000000,755.399963 
	C1.137436,754.839355 1.274871,754.678711 1.707443,754.401978 
	C5.345400,754.219238 8.688222,754.152588 12.466024,753.941162 
	C14.302203,754.674866 14.800479,755.927185 14.185804,757.880859 
	C13.120481,758.225891 12.317024,758.221985 11.295668,758.427246 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M1000.352722,561.166138 
	C1000.786377,560.559021 1001.628174,559.655457 1002.435608,559.685059 
	C1009.721802,559.952942 1017.002014,560.384277 1024.641968,560.883789 
	C1025.000000,561.444458 1025.000000,561.888916 1025.000000,562.666687 
	C1016.853699,563.309692 1008.809265,562.163025 1000.352722,561.166138 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M1025.000000,229.583344 
	C1021.476501,232.130966 1018.743774,234.559311 1020.540955,239.330719 
	C1021.076416,240.752350 1020.081726,242.202026 1019.228760,243.783508 
	C1015.007690,236.881866 1016.768433,229.523987 1018.216614,221.794250 
	C1018.623047,221.198166 1018.829590,220.995712 1019.463135,220.778900 
	C1021.579895,222.292282 1020.798523,224.311722 1020.923096,226.515564 
	C1020.736023,227.523438 1020.465393,228.143829 1020.519714,228.806747 
	C1020.538330,229.034271 1020.253357,229.311371 1020.593445,229.502029 
	C1020.509338,229.182251 1020.493896,228.857574 1020.609131,228.203247 
	C1021.003052,227.032471 1021.002502,226.062210 1021.935303,225.161224 
	C1022.933838,224.999298 1023.622559,225.001114 1024.655640,225.001465 
	C1025.000000,226.388885 1025.000000,227.777786 1025.000000,229.583344 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M14.084564,135.221680 
	C9.818753,133.810486 6.408294,134.372223 3.356619,138.023300 
	C1.234953,135.792892 3.421692,132.715073 1.210089,130.254211 
	C1.000000,130.000000 1.000000,129.500000 1.000000,129.250000 
	C1.667346,128.302261 2.457044,128.350632 3.501757,128.716660 
	C3.719634,128.807846 4.128189,128.870956 4.183642,128.641129 
	C4.294224,128.058990 4.420978,127.732658 4.798213,127.212608 
	C4.999180,127.000916 5.000000,127.000000 5.000407,126.999542 
	C8.290210,125.250893 10.050968,127.536102 11.690913,129.701569 
	C12.332587,130.548859 12.446931,131.797318 13.716888,132.739349 
	C13.997906,132.998001 14.000000,133.000000 14.001005,133.001007 
	C14.401713,133.556732 14.527782,134.167877 14.084564,135.221680 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M22.711195,829.642822 
	C21.636332,830.121887 20.603376,830.168762 19.277729,830.472168 
	C17.751728,832.516174 15.935869,831.997742 13.817152,831.868164 
	C9.720019,829.311462 5.565361,830.967041 1.328431,830.233276 
	C1.000000,829.250000 1.000000,828.500000 1.000000,827.375000 
	C1.869447,826.232605 2.880093,825.787720 4.453271,825.648865 
	C5.706196,825.598328 6.540766,825.596802 7.790712,825.585388 
	C10.146147,825.404358 12.084236,825.670166 14.445044,825.593750 
	C16.881626,825.524475 18.862968,825.665466 21.085468,826.796143 
	C22.161095,827.590942 22.627016,828.299744 22.711195,829.642822 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M128.914795,1022.373169 
	C138.921921,1022.157410 148.456802,1019.629822 158.212967,1019.952209 
	C160.018600,1020.011902 161.822205,1020.133606 163.812698,1020.619934 
	C162.918137,1022.260620 161.416931,1022.335144 159.502014,1022.461182 
	C150.658768,1023.808350 142.121658,1023.553162 133.339951,1024.743896 
	C132.250000,1025.000000 131.500000,1025.000000 130.375000,1025.000000 
	C129.677124,1024.719482 129.322296,1024.486938 128.750763,1024.036255 
	C128.456665,1023.353699 128.481125,1022.937256 128.914795,1022.373169 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M11.139713,960.867981 
	C10.347411,961.656494 9.842557,962.195801 9.072945,962.827515 
	C8.808187,962.919861 8.387973,962.879700 8.387973,962.879700 
	C8.387973,962.879700 8.359123,963.319580 8.544394,963.496826 
	C8.874880,964.968384 9.330151,966.449158 7.421174,966.818176 
	C6.093167,967.074890 5.487418,966.262878 4.808834,965.130554 
	C4.090640,963.932129 2.762391,963.099426 1.350310,962.053467 
	C1.000000,960.933289 1.000000,959.866638 1.000000,958.399963 
	C1.601354,957.555969 2.439850,957.472595 3.119837,956.581787 
	C4.392766,955.889282 5.483928,955.872070 6.932824,955.995728 
	C7.506636,956.091736 7.735970,956.143494 8.306263,956.299866 
	C9.563112,956.745239 10.465852,957.110535 11.404491,958.095398 
	C11.831541,959.173889 11.780458,959.908142 11.139713,960.867981 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M3.205783,956.763794 
	C3.041870,957.553650 3.105458,958.098450 3.169046,958.643311 
	C2.615102,958.499146 2.061157,958.354980 1.253606,958.105347 
	C1.000000,955.958313 1.000000,953.916687 1.000000,951.437500 
	C2.014523,950.004700 3.282947,949.995789 4.928713,950.141357 
	C5.845419,950.446472 6.306089,950.801636 6.654650,951.322510 
	C6.859223,951.628174 6.947089,952.299805 7.312572,952.141724 
	C7.628773,952.004944 7.429842,951.325684 7.587782,950.554077 
	C8.615735,949.069092 9.768325,948.937988 11.365859,949.692078 
	C12.691385,951.529724 11.192070,953.026672 11.755075,954.795471 
	C12.276724,955.452881 12.533710,955.905518 12.938221,956.576660 
	C11.828055,958.237366 10.214922,957.258606 8.374313,957.198853 
	C7.978179,956.968994 7.990153,957.017090 8.014076,957.010620 
	C6.588702,956.030273 4.970989,956.653992 3.205783,956.763794 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M158.611969,1021.429443 
	C160.351288,1021.162964 161.753067,1021.102722 163.576752,1021.027832 
	C165.865204,1021.444763 168.730865,1020.643677 168.005920,1024.632812 
	C161.312363,1025.000000 154.624710,1025.000000 147.468536,1025.000000 
	C146.874313,1022.990601 148.414520,1023.084167 149.646088,1023.056763 
	C152.598618,1022.991028 155.414734,1022.203186 158.611969,1021.429443 
z"/>
<path fill="#4B225C" opacity="1.000000" stroke="none" 
	d="
M4.741818,986.687683 
	C6.095499,985.994263 7.306628,985.934875 8.785719,986.734131 
	C9.215287,990.281555 5.150910,995.283936 1.393795,995.967529 
	C1.000000,993.299988 1.000000,990.599976 1.000000,987.449951 
	C2.191342,985.968872 3.422893,988.656311 4.741818,986.687683 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M158.530548,1021.182495 
	C155.833511,1024.740234 151.204590,1022.879822 147.268219,1024.717041 
	C142.643097,1025.000000 138.286194,1025.000000 133.464645,1025.000000 
	C132.331665,1023.049561 133.998322,1023.279724 134.898575,1023.193848 
	C142.631134,1022.456299 150.372711,1021.813110 158.530548,1021.182495 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M2.595026,447.522278 
	C2.153071,447.831635 1.924352,447.877533 1.347816,447.961731 
	C1.000000,444.307098 1.000000,440.614166 1.000000,436.460632 
	C2.661888,435.126862 4.456200,434.992889 6.664020,435.100098 
	C7.276014,435.240784 7.509294,435.334473 8.019691,435.679138 
	C8.915446,437.120239 8.552233,438.295502 8.138899,439.808472 
	C7.945238,440.361725 7.856043,440.578094 7.598504,441.100891 
	C7.169278,441.789764 6.888221,442.156677 6.362578,442.766846 
	C4.811004,444.265717 3.788657,445.745789 2.595026,447.522278 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M1010.704590,931.012329 
	C1015.443542,933.455750 1019.826111,931.312439 1024.590820,931.109009 
	C1025.000000,931.750000 1025.000000,932.500000 1025.000000,933.625000 
	C1019.717712,933.998596 1014.434021,934.063782 1009.154236,933.947388 
	C1007.885742,933.919495 1005.587341,934.865601 1005.631714,932.613403 
	C1005.667480,930.798584 1007.831482,931.064270 1009.292603,930.975708 
	C1009.623047,930.955688 1009.955994,930.977661 1010.704590,931.012329 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M1.000000,607.444153 
	C1.736966,607.202759 2.546214,607.311157 2.754749,608.575806 
	C2.822289,608.859436 2.647057,609.144531 2.647057,609.144531 
	C2.647057,609.144531 2.898926,609.362427 2.995143,609.224121 
	C3.972464,609.625244 4.853568,610.164734 5.891531,610.971985 
	C6.648376,611.819458 7.372946,612.188110 8.439361,612.595093 
	C9.302894,613.090210 9.609292,613.635193 9.752178,614.616699 
	C9.663267,615.600159 9.386198,616.176697 8.749285,616.915161 
	C7.872456,617.644226 7.101355,617.955933 6.185469,618.614502 
	C5.781831,618.934509 5.616092,619.060120 5.173071,619.336670 
	C4.481052,619.609070 4.058794,619.637756 3.326004,619.472900 
	C2.867255,619.202087 2.712854,619.048462 2.422142,618.597656 
	C1.131200,617.596863 4.442997,615.619873 1.234438,615.217529 
	C1.000000,612.629456 1.000000,610.258850 1.000000,607.444153 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M1.000000,336.250000 
	C12.089813,334.625946 23.098616,332.703918 34.151901,331.029785 
	C23.683626,334.692780 12.699186,335.459656 1.424857,336.984589 
	C1.000000,337.000000 1.000000,336.500000 1.000000,336.250000 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M12.982927,830.168823 
	C15.029140,830.357361 16.610483,830.487854 18.588432,830.673462 
	C18.829744,832.070923 18.401247,834.028931 16.964947,833.498596 
	C11.808499,831.594543 6.923475,835.193481 1.444791,833.928711 
	C1.000000,833.555542 1.000000,833.111084 1.000000,832.333313 
	C4.363956,828.471863 8.642386,830.519165 12.982927,830.168823 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M1.000000,681.444153 
	C2.111055,681.096558 3.729750,680.842163 3.777076,682.339417 
	C3.945895,687.680603 6.214100,684.496033 8.163785,682.888123 
	C8.925637,685.604492 7.462169,687.354797 7.039954,689.637756 
	C5.256655,689.668518 3.515517,689.334595 1.387190,689.000366 
	C1.000000,686.629456 1.000000,684.258850 1.000000,681.444153 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M1.000000,812.454102 
	C2.721285,810.690735 3.075077,808.877319 3.000575,806.369995 
	C6.704420,809.242676 3.583477,813.264832 4.052120,816.955322 
	C4.258223,818.578369 5.247506,821.554749 1.393788,821.972656 
	C1.000000,818.969421 1.000000,815.938782 1.000000,812.454102 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,349.250000 
	C10.714686,347.547577 20.429373,346.095154 30.144058,344.642761 
	C20.970900,347.979889 11.329558,348.504669 1.432657,350.026367 
	C1.000000,350.000000 1.000000,349.500000 1.000000,349.250000 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M1017.394409,1016.197449 
	C1016.914551,1010.838013 1022.280396,1011.143616 1024.693604,1008.147217 
	C1025.000000,1010.370544 1025.000000,1012.741150 1025.000000,1015.555847 
	C1022.674133,1017.510925 1020.210205,1017.125061 1017.394409,1016.197449 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1.000000,1012.333313 
	C4.961837,1011.073608 8.980888,1010.827881 13.477677,1010.950073 
	C13.942151,1011.675110 13.963039,1012.438599 13.976601,1013.581909 
	C9.903236,1013.310852 5.869235,1016.181946 1.394966,1014.036255 
	C1.000000,1013.555542 1.000000,1013.111084 1.000000,1012.333313 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M1.000000,593.250000 
	C3.379138,592.981140 5.758276,592.962219 8.585826,592.888855 
	C12.859320,592.883484 16.684290,592.949463 20.509529,592.974304 
	C22.335093,592.986206 23.996546,592.571045 24.917809,590.459717 
	C24.706953,589.884827 24.604143,589.701721 24.524830,589.203430 
	C24.834143,588.065002 25.289562,587.377197 26.401823,586.964966 
	C27.396915,589.165588 25.617363,592.023132 29.341417,594.041382 
	C19.653708,594.041382 10.795772,594.041382 1.468919,594.020691 
	C1.000000,594.000000 1.000000,593.500000 1.000000,593.250000 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1014.371826,61.485229 
	C1015.006958,54.087658 1018.219788,60.672367 1020.621704,59.989746 
	C1022.174744,60.863811 1023.353333,61.722855 1024.772461,62.781895 
	C1025.000000,64.066673 1025.000000,65.133339 1025.000000,66.600021 
	C1023.897766,66.688866 1022.795593,66.377708 1021.344849,66.031517 
	C1020.819702,63.864578 1019.244690,64.007782 1017.117554,63.852348 
	C1015.883972,63.137165 1015.404541,62.462570 1014.371826,61.485229 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M1024.088867,751.427612 
	C1020.166992,751.247375 1018.559387,748.720398 1018.948914,745.932800 
	C1019.328247,743.218262 1022.335999,744.639343 1024.612305,744.184204 
	C1025.000000,746.041687 1025.000000,748.083313 1025.000000,750.562500 
	C1024.818604,751.188538 1024.637329,751.377014 1024.088867,751.427612 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M1018.158752,489.763489 
	C1020.460815,489.978302 1022.326233,489.987000 1024.595825,489.997864 
	C1025.000000,490.750000 1025.000000,491.500000 1025.000000,492.625000 
	C1023.662537,493.121063 1022.325073,493.242126 1020.584229,493.383362 
	C1019.960022,493.429993 1019.739319,493.456482 1019.187683,493.524689 
	C1018.504089,493.571564 1018.151428,493.576721 1017.534607,493.566040 
	C1016.794556,493.322144 1016.325623,493.080475 1015.476562,492.705780 
	C1012.356384,492.251404 1009.596436,492.585480 1006.871216,492.307831 
	C1005.246094,492.142212 1003.093323,492.491333 1003.313110,489.547760 
	C1008.382324,487.887573 1013.069153,487.919434 1018.158752,489.763489 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,323.333313 
	C9.645410,323.554291 17.885851,320.430023 26.460966,320.203339 
	C18.521967,323.210541 10.095971,323.654236 1.425114,325.008911 
	C1.000000,324.555542 1.000000,324.111115 1.000000,323.333313 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M377.468658,1025.000000 
	C377.000000,1025.000000 376.988953,1024.540161 376.974854,1024.311279 
	C389.444183,1024.127197 401.932922,1023.563660 414.704651,1024.704956 
	C402.645782,1025.000000 390.291534,1025.000000 377.468658,1025.000000 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M876.187866,1014.430298 
	C866.505066,1013.660767 866.503357,1013.662598 867.015381,1024.545898 
	C866.250000,1025.000000 865.500000,1025.000000 864.375000,1025.000000 
	C864.114441,1024.193359 864.216309,1023.384766 864.345093,1022.580505 
	C865.937012,1012.641052 865.938049,1012.641235 876.680237,1013.130981 
	C877.310120,1013.493286 877.307312,1013.680664 877.140503,1014.096985 
	C876.801331,1014.394287 876.626282,1014.462646 876.187866,1014.430298 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M1.000000,355.333313 
	C8.482102,354.487000 15.727539,351.991211 23.386040,352.691223 
	C16.190874,354.096527 8.995709,355.501862 1.400272,356.953613 
	C1.000000,356.555542 1.000000,356.111115 1.000000,355.333313 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1025.000000,410.535339 
	C1024.362305,410.914551 1023.576355,411.030212 1023.122131,410.695648 
	C1022.475159,410.218933 1022.697144,397.810303 1023.277832,397.210938 
	C1023.460388,397.022552 1023.890625,397.074249 1024.603760,397.008026 
	C1025.000000,401.356903 1025.000000,405.713806 1025.000000,410.535339 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M774.468628,1025.000000 
	C774.507263,1022.331848 776.636719,1022.922729 778.309021,1023.031616 
	C784.341370,1023.424683 790.364014,1023.965942 796.695190,1024.725586 
	C789.645752,1025.000000 782.291504,1025.000000 774.468628,1025.000000 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M1021.681946,445.270996 
	C1022.777588,444.026642 1023.590759,443.101105 1024.701904,442.087769 
	C1025.000000,446.689240 1025.000000,451.378510 1025.000000,456.533875 
	C1024.730957,457.090332 1024.461792,457.180664 1023.834351,457.038940 
	C1021.411621,453.321930 1019.646545,449.781525 1021.681946,445.270996 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000002,299.333344 
	C7.779738,297.955719 14.559472,296.911407 21.339207,295.867096 
	C15.210391,299.224030 8.296679,299.224426 1.408058,300.997253 
	C1.000000,300.555542 1.000000,300.111115 1.000002,299.333344 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M11.022242,176.549301 
	C8.473155,179.524689 5.390555,180.844910 1.394631,180.984955 
	C1.000000,180.250000 1.000000,179.500000 1.000000,178.375000 
	C2.887716,175.828171 5.144637,174.466415 8.559288,174.790665 
	C9.799188,175.043182 10.523486,175.412811 11.022242,176.549301 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M9.096865,175.526947 
	C6.239330,175.548065 4.067908,176.987244 1.395314,178.041656 
	C1.000000,176.611115 1.000000,175.222214 1.000000,173.416656 
	C2.184228,171.753021 3.806582,171.435165 5.688838,170.871094 
	C6.028126,170.793259 6.490269,170.768158 6.720910,170.749283 
	C8.597644,171.759857 9.138287,173.357376 9.096865,175.526947 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M1.000000,399.250000 
	C7.897888,398.157593 14.795777,397.315186 21.941166,396.748413 
	C15.531137,398.833191 8.715499,399.645905 1.433285,400.124420 
	C1.000000,400.000000 1.000000,399.500000 1.000000,399.250000 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M1025.000000,770.562500 
	C1022.313171,767.731384 1021.541931,763.595581 1019.860474,759.472473 
	C1020.432800,758.785645 1021.089966,758.459717 1022.093506,758.012451 
	C1022.879944,757.976196 1023.251953,758.180237 1023.696899,758.810547 
	C1024.156616,760.559143 1024.546387,762.006104 1024.794922,763.755615 
	C1025.000000,766.041687 1025.000000,768.083313 1025.000000,770.562500 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M1000.855164,1024.288452 
	C1007.178833,1023.948364 1013.079834,1022.506165 1019.564148,1023.019409 
	C1020.355347,1023.454712 1020.503296,1023.898254 1020.219238,1024.703857 
	C1013.978821,1025.000000 1007.957703,1025.000000 1001.468262,1025.000000 
	C1000.838135,1024.812378 1000.676208,1024.624634 1000.855164,1024.288452 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M20.577282,239.934540 
	C14.971573,243.096176 8.131572,243.101166 1.404857,245.032608 
	C1.000000,244.555557 1.000000,244.111099 1.000000,243.333328 
	C7.595045,243.232224 13.626593,240.006561 20.577282,239.934540 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,274.333313 
	C6.188595,274.463928 10.962896,271.207642 16.606209,272.180573 
	C11.836984,275.140961 6.565579,274.607208 1.412511,276.045837 
	C1.000000,275.555542 1.000000,275.111115 1.000000,274.333313 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M1.000000,998.375000 
	C5.014341,998.642883 9.260822,998.038696 13.005524,1000.639404 
	C9.287862,1001.419861 5.578248,1002.412537 1.393740,1001.267578 
	C1.000000,1000.250000 1.000000,999.500000 1.000000,998.375000 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M911.333374,1025.000000 
	C911.228882,1023.905090 911.418945,1022.800171 911.696716,1021.717773 
	C912.031982,1020.411072 911.503113,1018.389343 913.570312,1018.309509 
	C915.061340,1018.251892 916.343262,1019.283936 916.802246,1020.844177 
	C917.503967,1023.229370 915.461487,1023.345093 914.069885,1023.966370 
	C913.775635,1024.097900 913.460449,1024.182373 913.077454,1024.644287 
	C912.555542,1025.000000 912.111084,1025.000000 911.333374,1025.000000 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M36.618687,1022.113403 
	C37.044411,1022.101624 37.089188,1022.375061 37.082039,1022.513428 
	C37.066387,1023.259705 37.123558,1023.859741 37.145454,1024.723267 
	C32.975456,1025.000000 28.950911,1025.000000 24.463184,1025.000000 
	C23.902868,1023.109192 25.169796,1022.901611 26.561367,1023.032410 
	C29.835955,1023.340149 32.990818,1022.508362 36.618687,1022.113403 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M1018.383057,137.291290 
	C1016.807312,131.778122 1021.821899,130.308304 1024.693237,127.138092 
	C1025.000000,128.388885 1025.000000,129.777786 1025.000000,131.583344 
	C1022.966064,133.850662 1021.432068,136.287338 1018.383057,137.291290 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M1.000000,159.333328 
	C5.090105,157.714844 9.180210,156.429688 13.644369,155.145721 
	C14.356322,155.484314 14.486162,155.893311 14.225187,156.629974 
	C9.934624,158.273392 5.856120,159.650681 1.388808,161.013992 
	C1.000000,160.555557 1.000000,160.111099 1.000000,159.333328 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M769.375000,1025.000000 
	C768.971313,1021.257874 768.942627,1017.515747 769.028564,1013.313721 
	C771.099426,1012.178040 770.838257,1013.755798 770.943481,1014.741577 
	C771.278625,1017.881042 771.511047,1021.031433 771.891602,1024.588867 
	C771.250000,1025.000000 770.500000,1025.000000 769.375000,1025.000000 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M16.605312,417.918579 
	C12.383526,420.790009 6.879612,419.732147 1.419256,420.966187 
	C1.000000,420.555542 1.000000,420.111115 1.000000,419.333313 
	C6.055703,418.761963 11.053268,417.620789 16.605312,417.918579 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M1.000000,373.333313 
	C7.208266,373.392517 13.187844,371.531372 19.725119,371.486877 
	C16.592588,374.100647 12.434841,373.105530 8.603438,373.877777 
	C6.412272,374.319427 4.083566,374.518677 1.412299,374.944183 
	C1.000000,374.555542 1.000000,374.111115 1.000000,373.333313 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M17.266853,365.730591 
	C12.135535,367.977509 6.761725,367.351410 1.403219,368.944214 
	C1.000000,368.555542 1.000000,368.111115 1.000000,367.333313 
	C6.065343,366.364777 11.130686,365.729523 16.606958,365.071045 
	C17.191214,365.202393 17.364538,365.356995 17.266853,365.730591 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M13.200006,829.943604 
	C9.714585,831.999878 5.549971,830.320251 1.382965,831.843262 
	C1.000000,831.555542 1.000000,831.111084 1.000000,830.333313 
	C4.960549,829.059204 8.934353,828.584717 13.200006,829.943604 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M1025.000000,884.750000 
	C1024.675171,885.010498 1024.333862,885.091187 1024.028076,885.019897 
	C1022.304626,884.618042 1019.282959,885.756104 1019.278625,883.325745 
	C1019.275513,881.604248 1021.305603,879.267212 1024.603760,879.950500 
	C1025.000000,880.444458 1025.000000,880.888916 1025.000000,881.666687 
	C1024.643921,882.459167 1023.185730,882.662720 1024.821167,883.771118 
	C1025.000000,884.000000 1025.000000,884.500000 1025.000000,884.750000 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M11.731756,949.572144 
	C10.583557,950.093872 9.503076,950.249268 8.208364,950.656921 
	C7.637122,951.351074 7.178029,951.527832 6.292108,951.218506 
	C4.587577,951.006531 3.207784,951.015442 1.413995,951.012207 
	C1.000000,950.555542 1.000000,950.111084 1.000000,949.333313 
	C4.592227,949.467163 8.236782,947.189392 11.731756,949.572144 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M1.000001,330.250000 
	C5.815410,329.361908 10.630818,328.723816 15.446227,328.085724 
	C11.255543,330.851074 6.525161,330.801544 1.439994,331.086792 
	C1.000000,331.000000 1.000000,330.500000 1.000001,330.250000 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M586.250000,1025.000000 
	C581.517273,1023.230225 576.744995,1023.214294 572.064758,1022.523804 
	C577.073975,1022.500732 582.301025,1020.298218 586.944763,1024.619751 
	C587.000000,1025.000000 586.500000,1025.000000 586.250000,1025.000000 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M1018.138306,137.496094 
	C1020.146057,135.366394 1022.253418,133.502014 1024.680420,131.818817 
	C1025.000000,132.750000 1025.000000,133.500000 1025.000000,134.625000 
	C1022.638428,135.032181 1021.886719,137.308151 1020.099304,138.671265 
	C1019.068420,138.968445 1018.506653,138.571716 1018.138306,137.496094 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M1.000000,426.333313 
	C3.920267,425.779785 6.978285,426.517090 9.666110,424.682678 
	C10.394540,424.185547 11.313840,423.966766 11.519258,425.154785 
	C11.668721,426.019226 11.034449,426.779694 10.141994,426.899170 
	C7.369399,427.270416 4.582366,427.533783 1.400467,427.919495 
	C1.000000,427.555542 1.000000,427.111115 1.000000,426.333313 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M1.000000,386.333313 
	C5.070028,386.000000 9.140056,386.000000 13.210084,386.000000 
	C13.248371,386.247345 13.286658,386.494659 13.324945,386.742004 
	C9.505201,387.173218 5.685456,387.604431 1.432856,388.017822 
	C1.000000,387.555542 1.000000,387.111115 1.000000,386.333313 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M1025.000000,539.750000 
	C1018.910767,539.882812 1012.821594,539.765625 1006.426025,539.391541 
	C1012.101135,539.076477 1018.082581,539.018372 1024.531982,538.980103 
	C1025.000000,539.000000 1025.000000,539.500000 1025.000000,539.750000 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M1016.907104,1016.006592 
	C1019.416809,1015.983643 1021.775879,1016.101746 1024.567383,1016.109863 
	C1025.000000,1016.444458 1025.000000,1016.888916 1025.000000,1017.666687 
	C1022.180664,1017.415100 1018.950623,1020.351624 1016.401978,1016.612915 
	C1016.350342,1016.222595 1016.756348,1016.147644 1016.907104,1016.006592 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M1025.000000,525.600037 
	C1023.580811,526.063599 1022.161682,526.127136 1020.317017,526.225281 
	C1020.343689,523.712402 1016.680542,525.487610 1016.936157,522.974731 
	C1018.667664,521.338806 1020.489014,522.017883 1022.614868,522.046265 
	C1023.444641,522.051208 1023.888916,522.035400 1024.666626,522.009827 
	C1025.000000,523.066711 1025.000000,524.133362 1025.000000,525.600037 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M12.717993,1024.198242 
	C16.007267,1023.222351 19.061987,1021.607483 22.001526,1024.584595 
	C19.299986,1025.000000 16.599972,1025.000000 13.449980,1025.000000 
	C12.819526,1024.824341 12.639050,1024.648560 12.717993,1024.198242 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M128.786346,1022.138916 
	C129.137985,1022.540894 129.139862,1022.863586 129.199249,1023.429504 
	C128.313599,1025.191162 126.804207,1024.156860 125.321297,1024.771729 
	C123.285645,1025.000000 121.571281,1025.000000 119.428467,1025.000000 
	C121.410690,1021.738159 125.325783,1023.275208 128.786346,1022.138916 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1.000000,1001.333252 
	C4.699611,1001.012756 8.399222,1001.025574 12.561613,1001.042908 
	C13.024393,1001.047485 13.019250,1001.503784 13.022656,1001.731567 
	C9.306437,1002.294373 5.586810,1002.629456 1.433592,1002.982300 
	C1.000000,1002.555542 1.000000,1002.111084 1.000000,1001.333252 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,305.333313 
	C5.142551,305.791504 8.975629,303.077698 13.539480,303.945160 
	C10.244607,306.335388 5.671463,305.193726 1.403247,306.969971 
	C1.000000,306.555542 1.000000,306.111115 1.000000,305.333313 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1025.000000,372.541931 
	C1024.281738,372.976807 1023.563477,372.953613 1022.490845,372.896667 
	C1022.129883,372.477051 1022.123291,372.091187 1022.114502,371.414581 
	C1023.367676,369.304230 1023.265320,367.397736 1022.265198,365.189026 
	C1022.054993,364.930786 1022.049438,364.489380 1022.043457,364.269257 
	C1023.270935,364.075653 1023.877136,363.216949 1024.731689,362.165161 
	C1025.000000,365.361298 1025.000000,368.722565 1025.000000,372.541931 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M10.269365,341.714111 
	C7.432813,343.317566 4.646618,343.118317 1.430794,342.964539 
	C1.000000,342.555542 1.000000,342.111115 1.000000,341.333313 
	C3.697621,340.993042 6.395243,340.986053 9.542664,340.984039 
	C10.161951,341.145142 10.331437,341.301270 10.269365,341.714111 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M1.000000,130.437500 
	C4.774151,131.579559 3.707507,134.483643 2.991996,137.670929 
	C2.218014,138.412354 1.885507,137.841583 1.256358,137.178207 
	C1.000000,134.958328 1.000000,132.916672 1.000000,130.437500 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M66.483246,1024.656250 
	C70.451332,1024.006592 74.865471,1023.700623 79.700279,1023.453003 
	C80.095245,1023.842957 80.057022,1024.173096 80.003143,1024.750977 
	C75.643097,1025.000000 71.286201,1025.000000 66.483246,1024.656250 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M13.591358,278.994598 
	C10.266697,281.248016 5.927341,281.072083 1.414836,281.963257 
	C1.000000,282.000000 1.000000,281.500000 1.000001,281.250000 
	C5.043768,280.309906 9.087533,279.619781 13.591358,278.994598 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M1.000000,970.375000 
	C3.593686,968.928528 6.168880,968.988464 9.024307,970.348450 
	C9.334933,970.776367 9.347707,970.982178 9.078085,971.308044 
	C8.390445,971.468811 7.985022,971.472900 7.299231,971.319458 
	C4.863971,970.524475 2.665098,969.555176 1.000500,972.558228 
	C1.000000,972.250000 1.000000,971.500000 1.000000,970.375000 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M10.985861,979.562012 
	C7.775187,980.289734 4.837465,978.871582 1.386830,978.045349 
	C1.000000,977.555542 1.000000,977.111084 1.000004,976.333313 
	C4.302293,977.065002 7.604577,978.130005 10.985861,979.562012 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M5.252905,826.384766 
	C3.915797,826.713257 2.843760,826.738037 1.385861,826.881409 
	C1.000000,825.933289 1.000000,824.866638 1.000000,823.399963 
	C2.064615,823.014648 3.129230,823.029358 4.591475,823.081299 
	C5.807240,823.991516 5.993314,824.977295 5.252905,826.384766 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M1023.433960,759.136353 
	C1023.094421,758.602356 1022.964172,758.353210 1022.615234,758.008911 
	C1022.362427,757.484924 1022.284973,757.078796 1022.179810,756.363159 
	C1022.048462,755.180420 1021.984009,754.311768 1022.635376,753.233276 
	C1023.078186,752.568054 1023.341431,752.176453 1023.663208,751.537292 
	C1023.932373,751.231018 1024.143066,751.172302 1024.676880,751.056763 
	C1025.000000,753.370544 1025.000000,755.741150 1025.000000,758.555847 
	C1024.629150,759.353455 1024.188110,759.475403 1023.433960,759.136353 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M3.141299,155.923172 
	C2.561950,156.505722 2.070188,156.754883 1.289213,157.002014 
	C1.000000,155.285645 1.000000,153.571289 1.000000,151.428467 
	C1.777981,150.278336 2.676930,149.946152 4.082269,150.277283 
	C6.841091,152.782608 4.393208,154.038391 3.141299,155.923172 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M12.263435,379.678772 
	C8.762895,381.267700 5.316938,381.105469 1.443679,381.039978 
	C1.000000,381.000000 1.000000,380.500000 1.000001,380.250000 
	C4.391057,379.698883 7.782114,379.397736 11.596066,379.108459 
	C12.181088,379.244049 12.343216,379.367767 12.263435,379.678772 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M628.499268,1023.331116 
	C628.917480,1023.719910 628.935913,1024.085205 628.977173,1024.725220 
	C625.969421,1025.000000 622.938782,1025.000000 619.454102,1025.000000 
	C621.828186,1023.333679 625.052795,1023.798462 628.499268,1023.331116 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M1023.631348,456.731812 
	C1024.075928,456.936920 1024.259033,456.968292 1024.721191,456.999817 
	C1025.000000,458.388885 1025.000000,459.777802 1025.000000,461.583344 
	C1024.819336,462.003906 1024.638794,462.007812 1024.188232,461.992584 
	C1023.257385,461.004517 1022.060852,461.074310 1020.927856,460.337738 
	C1020.473328,459.738037 1020.350708,459.326874 1020.332397,458.566772 
	C1020.972656,456.983215 1021.292786,455.199554 1023.631348,456.731812 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M1.000000,844.428467 
	C3.349275,845.004028 2.952462,847.513000 3.930350,849.638672 
	C3.222169,849.968140 2.481046,849.945557 1.369961,849.961487 
	C1.000000,848.285645 1.000000,846.571289 1.000000,844.428467 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M1.000000,237.333328 
	C3.920122,237.662140 6.596284,235.058792 10.190881,236.523010 
	C7.019317,237.387222 4.383406,238.105484 1.373748,238.911865 
	C1.000000,238.555557 1.000000,238.111099 1.000000,237.333328 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M1.000000,293.250000 
	C4.072448,293.047607 6.982287,290.962250 11.230370,292.625061 
	C7.440778,293.188293 4.639265,293.604645 1.418876,294.010498 
	C1.000000,294.000000 1.000000,293.500000 1.000000,293.250000 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1025.000000,62.625000 
	C1023.346436,62.837383 1021.157288,63.628090 1021.010559,60.381996 
	C1021.000000,59.999393 1021.000000,60.000000 1021.000000,60.000290 
	C1021.991577,59.181835 1023.070496,58.930725 1024.637451,59.748550 
	C1025.000000,60.750000 1025.000000,61.500000 1025.000000,62.625000 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M8.118212,435.439270 
	C5.889251,435.841187 3.874762,435.996735 1.430137,436.076141 
	C1.000000,436.000000 1.000000,435.500000 0.999999,435.250000 
	C3.065935,434.669556 5.131873,434.339142 7.596455,434.002197 
	C8.285455,434.344635 8.397962,434.743683 8.118212,435.439270 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M1.000000,361.333313 
	C3.376117,361.000000 5.752235,361.000000 8.128352,361.000000 
	C8.178517,361.154785 8.228683,361.309570 8.278847,361.464355 
	C6.112715,361.985168 3.946583,362.505951 1.390225,363.013367 
	C1.000000,362.555542 1.000000,362.111115 1.000000,361.333313 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M1.000000,311.250000 
	C3.512201,310.843842 6.024402,310.687653 8.536603,310.531494 
	C6.465256,312.127197 4.232441,313.009186 1.308192,312.196228 
	C1.000000,312.000000 1.000000,311.500000 1.000000,311.250000 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M1025.000000,586.666687 
	C1023.315491,586.975342 1021.272217,588.240845 1020.395752,585.365845 
	C1021.810791,584.658203 1023.094604,584.766602 1024.679688,585.120789 
	C1025.000000,585.444458 1025.000000,585.888916 1025.000000,586.666687 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M4.494111,986.332092 
	C4.790351,987.387451 6.700556,988.194763 5.785529,988.717407 
	C4.299873,989.566101 2.581344,989.081177 1.294777,987.176270 
	C1.000000,987.000000 1.000000,986.500000 0.999999,986.250000 
	C2.037212,986.083313 3.074425,986.166565 4.494111,986.332092 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M1.000000,262.250000 
	C2.800942,261.365540 4.327311,259.946655 6.771495,260.150879 
	C7.411875,260.490875 7.524267,260.843506 7.336849,261.486786 
	C5.374094,262.108368 3.774690,263.344604 1.400746,263.001160 
	C1.000000,263.000000 1.000000,262.500000 1.000000,262.250000 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M1019.894165,474.294922 
	C1021.443115,474.069275 1022.807373,474.063019 1024.585815,474.028381 
	C1025.000000,474.750000 1025.000000,475.500000 1025.000000,476.625000 
	C1023.406677,476.818695 1021.982483,476.221924 1020.448486,475.042480 
	C1020.028137,474.725647 1019.868835,474.619995 1019.894165,474.294922 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M4.982398,150.047592 
	C3.957782,150.610367 2.879623,150.706406 1.400732,150.901215 
	C1.000000,150.555557 1.000000,150.111099 1.000000,149.333328 
	C1.212315,148.740677 1.451887,148.509293 1.947056,148.207367 
	C3.391124,148.048599 4.564651,148.056870 4.982398,150.047592 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1025.000000,988.571533 
	C1023.556091,988.576538 1022.112183,988.153015 1020.500305,987.471375 
	C1023.173096,987.352783 1024.146118,985.684631 1024.622559,983.085266 
	C1025.000000,984.714355 1025.000000,986.428711 1025.000000,988.571533 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M4.998134,129.624954 
	C3.898407,129.683807 2.795441,129.368820 1.346238,129.026917 
	C1.000000,128.555557 1.000000,128.111115 1.000000,127.333328 
	C2.066466,126.998589 3.132931,126.997169 4.599288,126.998337 
	C4.997751,127.750984 4.996323,128.501053 4.998134,129.624954 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M1.000000,413.250000 
	C3.015374,412.820160 4.859247,410.987946 7.247155,412.425781 
	C5.701126,414.218048 3.690908,413.806488 1.419799,413.963318 
	C1.000000,414.000000 1.000000,413.500000 1.000000,413.250000 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M1025.000000,142.583344 
	C1024.312256,142.971970 1023.624573,142.943924 1022.599976,142.871429 
	C1022.253845,142.457550 1022.244507,142.088150 1022.240601,141.439926 
	C1022.496948,140.641251 1022.849182,140.166794 1022.968262,139.291519 
	C1023.447937,138.638550 1023.913635,138.275589 1024.689697,137.956299 
	C1025.000000,139.388885 1025.000000,140.777786 1025.000000,142.583344 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1025.000000,358.571533 
	C1023.057129,357.231171 1022.401245,355.319519 1024.673706,353.059570 
	C1025.000000,354.714355 1025.000000,356.428711 1025.000000,358.571533 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M1020.498901,1025.000000 
	C1019.997498,1024.570557 1019.994995,1024.141235 1020.007690,1023.390137 
	C1021.409363,1022.983826 1022.795898,1022.899231 1024.591187,1022.907349 
	C1025.296021,1026.928711 1022.222778,1024.115112 1020.498901,1025.000000 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M12.540443,1023.840698 
	C12.977054,1024.103149 12.976697,1024.282593 12.988171,1024.730957 
	C9.969407,1025.000000 6.938814,1025.000000 3.454110,1025.000000 
	C5.906485,1023.647827 9.029462,1023.882202 12.540443,1023.840698 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M37.399994,1025.000000 
	C36.881302,1024.332397 36.762604,1023.664795 36.859402,1022.824463 
	C38.217773,1023.524780 40.269932,1022.214172 40.963158,1024.627686 
	C39.933331,1025.000000 38.866661,1025.000000 37.399994,1025.000000 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M1000.745483,1024.082275 
	C1001.196106,1024.140015 1001.094604,1024.569336 1001.047302,1024.784668 
	C998.299988,1025.000000 995.599976,1025.000000 992.449951,1025.000000 
	C994.585022,1023.144470 997.519836,1024.263794 1000.745483,1024.082275 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M5.808706,170.525330 
	C5.114380,172.537369 3.116539,172.176193 1.365890,173.002808 
	C1.000000,172.555557 1.000000,172.111099 1.000000,171.333328 
	C2.713418,171.887497 3.888757,169.449570 5.808706,170.525330 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1025.000000,557.666687 
	C1023.826172,557.176392 1021.072266,558.240173 1021.494995,555.751648 
	C1021.739136,554.314270 1023.355835,555.124268 1024.670654,555.887451 
	C1025.000000,556.444458 1025.000000,556.888916 1025.000000,557.666687 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M1.000000,615.399963 
	C3.891883,614.752258 3.065784,616.792847 3.008456,618.673279 
	C2.564252,619.327332 2.109672,619.466980 1.300735,619.216064 
	C1.000000,617.933289 1.000000,616.866638 1.000000,615.399963 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M1.000000,648.333313 
	C2.270813,648.066406 3.775515,647.765991 3.917503,649.709961 
	C3.951569,650.176453 3.794801,650.656799 3.725796,651.130798 
	C3.025144,650.776489 2.324497,650.422180 1.311925,650.033936 
	C1.000000,649.555542 1.000000,649.111084 1.000000,648.333313 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1025.000000,59.666668 
	C1023.933289,60.000298 1022.866638,60.000591 1021.399963,60.000732 
	C1021.185242,57.874626 1022.763977,58.012772 1024.625000,58.000126 
	C1025.000000,58.444447 1025.000000,58.888889 1025.000000,59.666668 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,268.333313 
	C2.746172,268.000000 4.492345,268.000000 6.238517,268.000000 
	C6.276588,268.165222 6.314659,268.330444 6.352729,268.495667 
	C4.815128,268.956299 3.277527,269.416931 1.369963,269.938782 
	C1.000000,269.555542 1.000000,269.111115 1.000000,268.333313 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1023.166687,759.233521 
	C1023.584412,758.923035 1023.987488,758.971924 1024.695312,759.010376 
	C1025.000000,760.388916 1025.000000,761.777771 1025.000000,763.583374 
	C1023.378906,762.952454 1023.682312,761.097900 1023.166687,759.233521 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1025.000000,69.750000 
	C1024.133179,70.298386 1023.975281,71.726135 1022.813843,71.445107 
	C1022.533386,71.377243 1022.186462,70.733292 1022.217224,70.384888 
	C1022.327087,69.139458 1023.347839,69.088326 1024.650391,69.007195 
	C1025.000000,69.000000 1025.000000,69.500000 1025.000000,69.750000 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M5.182653,406.983887 
	C4.224999,408.183289 2.981926,408.110779 1.371319,408.027466 
	C1.000000,407.555542 1.000000,407.111115 1.000000,406.333344 
	C1.782066,406.023407 2.564133,406.046783 3.734597,406.116577 
	C4.445418,406.362762 4.778477,406.542938 5.182653,406.983887 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1025.000000,77.750000 
	C1023.961304,78.360168 1023.020447,79.349907 1021.809387,78.569054 
	C1021.628906,78.452698 1021.503418,77.911476 1021.616028,77.736015 
	C1022.263367,76.727509 1023.347290,77.106987 1024.639648,77.000748 
	C1025.000000,77.000000 1025.000000,77.500000 1025.000000,77.750000 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M1025.000000,158.583344 
	C1023.458130,157.644043 1023.860840,156.041534 1024.709595,154.209641 
	C1025.000000,155.388885 1025.000000,156.777786 1025.000000,158.583344 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1025.000000,383.583344 
	C1023.513489,382.636841 1023.861877,381.045471 1024.715576,379.213318 
	C1025.000000,380.388885 1025.000000,381.777802 1025.000000,383.583344 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M125.416664,1025.000000 
	C125.839111,1023.662964 127.238121,1024.059082 128.825516,1023.778809 
	C129.583572,1023.913452 129.968903,1024.153931 130.177124,1024.697144 
	C128.611115,1025.000000 127.222221,1025.000000 125.416664,1025.000000 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M1.000000,250.250000 
	C2.377810,250.242706 3.858996,249.454681 5.239704,250.423981 
	C4.192457,251.430496 2.993083,251.346039 1.382384,251.060913 
	C1.000000,251.000000 1.000000,250.500000 1.000000,250.250000 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M1025.000000,883.666687 
	C1024.255981,883.496582 1023.511963,882.993103 1022.767944,882.489624 
	C1023.313599,882.294983 1023.859314,882.100342 1024.702515,881.952820 
	C1025.000000,882.444458 1025.000000,882.888916 1025.000000,883.666687 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M0.999999,106.333328 
	C1.515155,106.236053 2.282286,106.341904 2.487119,106.738312 
	C2.803844,107.351257 2.217166,107.758392 1.297892,107.963669 
	C1.000000,107.555557 1.000000,107.111107 0.999999,106.333328 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M0.999999,619.333374 
	C1.436518,619.023071 1.873037,619.046082 2.637337,619.041016 
	C2.965117,619.012939 2.991195,618.978638 2.970024,618.973206 
	C3.354697,619.343567 3.521730,619.805664 3.242904,620.681763 
	C2.554612,621.172180 2.073421,621.334839 1.296115,621.248779 
	C1.000000,620.555542 1.000000,620.111084 0.999999,619.333374 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M1.000000,626.333313 
	C1.885140,625.647217 2.503322,625.911499 2.749198,626.836182 
	C2.998619,627.774231 2.274928,627.765930 1.337846,627.925659 
	C1.000000,627.555542 1.000000,627.111084 1.000000,626.333313 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1025.000000,901.666687 
	C1024.449341,901.780090 1023.608765,901.703003 1023.414062,901.307739 
	C1023.096191,900.662598 1023.735474,900.261719 1024.693359,900.054077 
	C1025.000000,900.444458 1025.000000,900.888916 1025.000000,901.666687 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M1025.000000,869.625000 
	C1023.548218,869.718994 1024.031616,868.578613 1024.034058,867.316650 
	C1024.256836,866.803772 1024.415283,866.654480 1024.786865,866.752563 
	C1025.000000,867.750000 1025.000000,868.500000 1025.000000,869.625000 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M611.333313,1025.000000 
	C611.246765,1023.586426 612.098694,1023.928162 612.984192,1024.660645 
	C612.555542,1025.000000 612.111084,1025.000000 611.333313,1025.000000 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M65.727295,1024.242554 
	C66.037193,1024.312622 66.054581,1024.658203 66.027290,1024.829102 
	C65.555557,1025.000000 65.111107,1025.000000 64.333328,1025.000000 
	C64.130898,1024.139160 64.796959,1024.194824 65.727295,1024.242554 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M1025.000000,866.666687 
	C1025.000000,867.000000 1024.546753,867.023254 1024.322510,866.988159 
	C1024.162109,866.242920 1024.225830,865.532776 1024.644775,864.911377 
	C1025.000000,865.444458 1025.000000,865.888916 1025.000000,866.666687 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M2.326796,550.262817 
	C2.049217,550.863831 1.722109,551.262329 1.197500,551.830383 
	C1.000000,551.555542 1.000000,551.111084 1.000000,550.333313 
	C1.000000,550.000000 1.458950,550.044983 1.676860,549.969604 
	C1.894769,549.894226 2.277266,550.060303 2.326796,550.262817 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M59.984055,1024.252441 
	C60.329029,1024.145264 60.662163,1024.287476 60.997650,1024.714844 
	C61.000000,1025.000000 60.500000,1025.000000 60.250000,1025.000000 
	C60.000000,1025.000000 59.972210,1024.501709 59.984055,1024.252441 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M1023.939148,608.998230 
	C1024.095947,609.159729 1024.278320,609.309998 1024.730347,609.230164 
	C1025.000000,609.000000 1025.000000,609.500000 1025.000000,609.750000 
	C1025.000000,610.000000 1024.771729,610.030701 1024.656616,610.027954 
	C1024.273438,609.933594 1024.005493,609.841919 1023.867065,609.345581 
	C1023.996582,608.940918 1023.964783,608.987000 1023.939148,608.998230 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M1.759754,754.187012 
	C1.864631,754.544006 1.664004,754.737000 1.200348,754.932373 
	C1.000000,755.000000 1.000000,754.500000 1.000000,754.250000 
	C1.172310,754.029419 1.344620,754.058777 1.759754,754.187012 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1025.000000,904.750000 
	C1024.827148,904.960815 1024.654175,904.921631 1024.236694,904.777222 
	C1024.107422,904.393921 1024.307373,904.206177 1024.796143,904.054443 
	C1025.000000,904.000000 1025.000000,904.500000 1025.000000,904.750000 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M1.000002,638.250000 
	C1.255179,638.156921 1.510355,638.313782 1.765527,638.470703 
	C1.668264,638.602356 1.571005,638.734070 1.236873,638.932861 
	C1.000000,639.000000 1.000000,638.500000 1.000002,638.250000 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1025.000000,889.750000 
	C1024.800171,889.835083 1024.589111,889.680420 1024.413574,889.492798 
	C1024.390381,889.467957 1024.546875,889.275024 1024.810059,889.079956 
	C1025.000000,889.000000 1025.000000,889.500000 1025.000000,889.750000 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M1.884570,148.081161 
	C1.981992,148.462219 1.784979,148.811829 1.293983,149.080719 
	C1.000000,149.000000 1.000000,148.500000 1.000000,148.250000 
	C1.196711,148.016571 1.393423,148.033142 1.884570,148.081161 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M281.248535,805.219849 
	C280.055420,807.594482 277.908966,808.171265 276.249512,809.809021 
	C275.733093,811.411804 274.288055,812.273254 274.676636,813.962891 
	C284.326294,812.294312 293.234894,808.519897 303.087219,807.120300 
	C304.927673,807.556030 305.969849,808.685608 307.242584,809.424866 
	C311.202484,811.724976 314.903656,809.690613 315.492432,804.641357 
	C315.682556,804.122864 315.806335,803.937744 316.218811,803.594727 
	C317.849823,803.140381 319.484406,803.453003 320.315979,801.438171 
	C321.277313,800.285461 322.328674,800.010010 323.755524,799.811523 
	C324.711761,799.706848 325.347809,799.657593 326.272583,799.407471 
	C326.775024,799.220154 326.976013,799.139526 327.481079,798.932129 
	C328.204773,798.635803 328.632416,798.489685 329.414734,798.299500 
	C330.244019,798.206726 330.723328,798.233521 331.560059,798.391846 
	C335.621490,799.272461 339.454590,799.328247 343.064636,800.698669 
	C345.279327,801.539307 347.009399,802.598694 346.875031,805.230652 
	C346.753876,807.603516 345.137421,808.694641 343.028961,809.185730 
	C341.230927,809.604553 339.508759,810.183044 337.980347,811.242249 
	C334.948853,813.342896 331.833466,813.510864 328.592926,811.729248 
	C325.639374,810.105469 323.242279,810.563904 321.379883,813.554382 
	C319.305908,816.884460 315.785553,817.582275 312.295746,817.990845 
	C309.353485,818.335327 307.262573,819.276917 306.672119,822.516479 
	C306.307220,824.518433 305.147766,826.228149 303.524719,827.482483 
	C300.971344,829.455505 301.924652,830.704895 303.606415,833.034180 
	C308.505096,839.818665 314.579926,839.915771 321.671936,837.735107 
	C327.178925,836.041809 332.423096,836.432007 338.091003,838.694824 
	C345.108948,841.496643 352.491699,840.077820 359.036957,836.069397 
	C361.677246,834.452393 364.427032,833.590515 367.437714,833.219360 
	C370.006470,832.902649 372.064606,833.446411 373.281799,836.374634 
	C373.290009,838.918579 371.466309,839.220703 369.969452,839.812927 
	C359.008331,844.150208 347.788147,847.716125 336.169098,851.146362 
	C334.356720,852.055725 332.963257,851.239197 331.229126,850.983643 
	C330.727997,851.007812 330.527893,851.029541 330.029419,851.101318 
	C328.500702,851.325378 327.399261,851.891602 325.929077,852.339844 
	C323.754211,851.792725 321.882996,851.617798 319.667236,852.287598 
	C317.417755,853.180298 315.446320,853.320801 313.090576,852.702881 
	C310.963989,852.363098 309.165924,852.204041 307.002441,852.337097 
	C306.418945,852.375122 306.183228,852.388794 305.590881,852.437988 
	C304.505920,852.619995 303.778351,852.770142 302.670349,853.042603 
	C294.381073,854.181702 286.454132,853.678711 278.561951,853.206543 
	C269.684387,852.675476 260.858795,851.325378 251.509766,851.444153 
	C247.647430,851.576599 244.222763,851.583130 240.531647,850.223022 
	C237.453293,848.608765 238.501968,846.334717 238.993225,843.842346 
	C242.099503,838.468811 243.939529,832.840820 247.733887,827.881104 
	C250.798538,823.170288 255.089066,820.232056 259.256531,816.680115 
	C262.075684,814.847168 264.375061,813.179260 260.484924,810.078369 
	C258.748657,806.693787 256.309692,804.054993 255.433502,800.191589 
	C252.877747,790.675415 250.376694,781.542786 248.610855,772.232544 
	C248.486404,771.576782 247.540741,772.521790 248.151093,772.253601 
	C248.367264,772.158508 248.513443,772.206482 248.542847,772.404297 
	C250.371094,784.708313 252.174896,797.013855 250.369370,809.883789 
	C249.874283,815.584717 247.195847,820.179321 245.401062,825.444946 
	C245.224075,826.022095 245.146713,826.249878 244.933899,826.809326 
	C244.700577,827.357178 244.602737,827.573364 244.351135,828.110229 
	C244.091141,828.643372 243.984863,828.855896 243.714539,829.385559 
	C242.825485,830.955200 242.265015,832.314392 240.867584,833.538574 
	C236.397583,835.380127 234.543015,831.605652 231.437836,829.777161 
	C229.814285,828.258423 229.691452,826.598572 229.581848,824.513184 
	C226.903152,796.747986 217.941818,770.796570 211.737946,743.806152 
	C211.324493,741.602722 210.884964,739.819275 210.779877,737.994141 
	C210.395905,731.325134 215.013474,726.112488 221.690521,725.628113 
	C230.961639,724.955566 237.802109,728.622314 240.370453,735.917480 
	C240.679596,736.568176 240.878952,736.831787 241.117111,737.064087 
	C240.901672,736.789001 240.685898,736.514099 240.382584,735.819946 
	C239.238403,730.708984 242.278214,728.470398 245.791855,726.637207 
	C248.329895,725.313049 251.152222,724.974976 253.972794,725.028748 
	C261.896759,725.179810 269.810242,724.869812 277.711792,724.404724 
	C280.112488,724.263367 281.904724,724.803223 283.575134,727.070557 
	C285.526428,737.870300 284.871582,748.350403 284.364502,758.758545 
	C283.742920,771.516541 282.416565,784.238464 282.644714,797.038940 
	C282.691711,799.673767 282.960968,802.383606 281.248535,805.219849 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M538.214844,381.528381 
	C540.591980,380.931244 542.114685,385.113190 544.756287,382.039551 
	C545.124146,381.611572 548.653381,384.582703 548.373535,387.475922 
	C547.976685,391.580109 547.469238,395.674530 546.950806,399.765747 
	C546.473877,403.529205 545.919983,407.282928 545.218262,411.523254 
	C546.559998,413.571106 546.297729,415.438019 545.573303,417.132721 
	C544.144104,420.476166 542.007812,423.499084 541.517090,427.260773 
	C541.324036,428.740753 539.725525,428.416016 538.329224,428.768372 
	C537.226501,429.184204 536.405029,429.382782 535.209229,429.382294 
	C534.051697,428.159271 534.339294,426.990204 534.352112,425.826538 
	C534.093689,427.851715 532.070557,428.737579 531.211060,430.778198 
	C527.306946,433.937653 523.598328,436.814178 519.583496,439.783081 
	C514.914246,441.978790 513.821228,445.745697 513.113342,450.257812 
	C512.016663,457.248047 512.719910,464.038116 513.794250,470.879425 
	C514.101074,472.833649 514.474121,474.775299 514.206421,477.133850 
	C514.091309,477.731964 514.028992,477.963806 513.834961,478.518860 
	C512.157043,480.508087 515.538513,483.975098 511.199463,484.736847 
	C509.876770,484.530914 509.165405,483.936157 508.348633,482.904907 
	C506.940704,479.741272 504.286102,478.740265 501.717010,477.609406 
	C499.437805,476.606140 497.445618,475.138031 495.224487,473.439209 
	C494.315430,472.717499 493.501923,472.481110 492.644226,471.793884 
	C489.196899,471.154022 489.647125,474.232849 488.826477,475.839905 
	C487.534088,478.370667 489.313171,482.222229 486.141663,483.934235 
	C482.618622,485.835968 478.583282,486.104004 474.250397,486.038849 
	C473.684662,485.903748 473.462738,485.833374 472.923431,485.622559 
	C466.235260,484.391907 461.150818,486.874390 456.973633,491.406464 
	C455.433136,493.077850 454.244385,495.088257 452.336151,496.926331 
	C451.773834,497.488586 451.443359,497.798828 450.858154,498.331665 
	C450.272644,498.855377 449.921417,499.132141 449.285522,499.581848 
	C446.698486,500.898132 444.625336,502.641174 441.532227,502.583374 
	C441.016052,502.564484 440.812317,502.541412 440.322632,502.415466 
	C439.740387,502.040649 439.520782,501.718323 439.342804,501.053131 
	C439.283783,500.094696 439.147308,500.394196 438.740479,500.902191 
	C434.065125,498.299652 430.769958,494.528351 428.484375,489.549377 
	C429.426086,487.402985 431.226227,486.289093 432.347107,484.235657 
	C433.481842,482.806488 434.912476,482.088867 435.668640,480.367126 
	C435.867035,479.898285 435.951508,479.715912 436.176270,479.273254 
	C436.516998,478.691772 436.723389,478.374359 437.056030,477.824829 
	C437.293671,477.256256 437.361450,476.913544 437.360687,476.291138 
	C437.288177,475.644684 437.276215,475.267914 437.339844,474.593811 
	C437.465851,474.107574 437.542023,473.917633 437.788330,473.466980 
	C438.224731,472.880188 438.504578,472.566101 439.011627,472.025909 
	C441.347626,469.236176 439.260773,465.979919 440.748474,462.980286 
	C443.324524,459.059387 440.792938,455.612793 440.415985,452.132538 
	C440.227417,450.391327 439.043030,448.786194 438.143585,447.202667 
	C435.321198,442.233917 432.191681,437.396057 431.761963,431.174683 
	C431.900787,430.856415 432.028778,430.423401 432.191559,430.266968 
	C432.819977,429.191956 432.377075,428.399048 431.892090,427.272949 
	C430.345490,423.659363 433.796326,420.911041 432.913696,417.338837 
	C433.019470,417.007843 433.000000,416.998779 433.004639,417.008362 
	C433.886719,414.104492 437.893677,413.179718 437.862457,409.302246 
	C438.001923,409.004272 438.000000,409.000000 438.002411,409.001160 
	C440.214478,406.731323 443.233185,405.574066 445.855225,403.298218 
	C446.126770,403.099518 446.049011,403.011505 446.066620,403.067505 
	C452.153839,399.977631 459.225006,399.124268 465.161926,394.778229 
	C468.744812,394.108582 471.584778,393.002472 472.877258,389.579315 
	C473.233276,388.636414 473.789825,387.552856 474.896057,387.601715 
	C478.913910,387.779053 480.553864,384.605347 482.972595,381.960938 
	C484.442383,380.066956 483.792969,378.677734 482.864380,377.131378 
	C479.586792,371.673431 479.767090,371.281342 486.096313,369.363220 
	C487.629852,368.792816 489.017578,368.443817 489.968811,367.601746 
	C492.750763,365.139099 495.616058,363.356567 500.169769,365.635956 
	C499.102295,363.822815 498.548553,362.882294 497.742981,361.513977 
	C500.854034,362.586700 503.528748,363.509003 506.585144,364.320923 
	C509.313446,364.988037 509.004486,366.776062 508.661438,368.601471 
	C508.516174,369.374512 507.219147,370.286377 509.124146,371.103516 
	C509.890228,372.066162 509.980743,372.896881 509.677490,374.049988 
	C509.447540,374.746490 508.818970,374.749237 508.813110,375.249786 
	C509.058167,375.080658 509.048615,374.681122 509.611633,374.357697 
	C512.136292,370.763947 515.192749,370.594147 518.646545,372.008423 
	C525.275024,374.722656 531.526001,378.194122 538.214844,381.528381 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M488.836823,900.395996 
	C489.727448,900.057617 490.423309,899.989197 491.466309,899.876526 
	C493.277161,897.582581 495.379333,896.748413 498.028168,896.489258 
	C502.112762,896.089478 506.242310,895.759399 510.548462,894.213318 
	C529.364868,892.551697 547.135437,886.752319 564.822937,884.890503 
	C558.197937,881.567749 550.106995,879.290100 541.965454,877.314758 
	C530.317810,874.488892 518.647156,871.699463 506.713989,870.259033 
	C504.393494,869.978882 502.149475,869.317566 499.518066,868.579346 
	C497.804016,868.283569 496.573456,867.705078 494.844971,867.478943 
	C493.053711,867.519592 491.679779,867.361328 489.879395,867.207642 
	C466.177704,863.193481 442.673096,860.901428 419.294189,857.679626 
	C417.814972,857.475769 416.305511,857.428406 414.584229,856.546875 
	C413.091919,853.670227 415.424225,853.289551 416.857727,852.521118 
	C426.070892,847.582397 435.319946,842.710693 444.806580,837.516357 
	C447.129578,836.095459 449.415009,835.456726 451.827209,834.245972 
	C452.580170,833.902100 453.023560,833.734009 453.825378,833.500732 
	C454.416534,833.394958 454.657623,833.376404 455.261230,833.381470 
	C457.300751,833.730042 459.019196,833.708252 461.070618,834.079346 
	C473.392120,837.436035 485.405884,840.505066 497.496826,844.677490 
	C498.992126,845.382935 500.208008,845.707397 501.806335,846.080811 
	C512.926086,850.380310 523.942383,853.901184 534.806641,858.851196 
	C548.083496,865.395691 561.452576,870.938049 573.652527,878.762878 
	C575.463745,879.924561 577.455566,880.856628 578.595337,883.267822 
	C578.730042,883.774536 578.824707,884.021057 578.751404,884.090576 
	C574.111145,888.494629 578.460876,891.166138 580.745300,894.151184 
	C584.148254,898.597595 587.924622,902.746277 591.349792,907.175537 
	C593.470337,909.917725 595.396423,912.794861 595.618347,916.769104 
	C594.525574,919.585266 592.671936,921.015137 589.746948,921.678101 
	C588.744629,922.114258 588.055603,922.350342 587.024780,922.710938 
	C582.177734,920.652344 578.214600,922.639465 574.291992,924.510803 
	C560.979370,930.861816 547.843567,937.582520 534.106201,943.850708 
	C533.647400,944.252869 533.452698,944.402161 532.939575,944.738525 
	C524.553894,947.842468 517.263062,952.633911 508.500610,954.728394 
	C505.017059,953.778015 502.884155,951.314087 500.270874,949.615540 
	C498.013824,948.148499 498.671539,946.686646 500.968445,945.752808 
	C505.409363,943.947388 509.778290,941.998169 514.008728,939.001953 
	C514.862305,938.331665 515.486328,937.972778 516.442383,937.482178 
	C516.978394,937.245361 517.196289,937.162842 517.745605,936.981689 
	C522.172363,936.230713 525.039917,932.975647 529.187317,931.681641 
	C531.135071,931.183838 532.500244,930.155823 534.324829,929.439087 
	C534.812012,929.141724 535.032654,928.979919 535.226074,928.804565 
	C535.016052,928.967407 534.816406,929.121887 534.353638,929.405579 
	C532.636169,930.076782 531.303101,930.909180 529.473999,931.512573 
	C517.016113,935.817993 504.348724,938.088928 492.256226,942.355774 
	C488.495789,943.682739 484.562408,944.504028 480.832794,945.958862 
	C479.746002,946.382812 478.627686,946.854248 477.467712,946.849792 
	C474.682220,946.839050 470.917480,947.393066 469.965820,944.460327 
	C468.965790,941.378479 472.880249,940.999268 474.918213,940.065430 
	C484.149841,935.835388 492.585693,930.036499 502.428833,926.213379 
	C506.408783,924.551758 509.819702,922.568787 513.389954,920.910889 
	C510.204651,922.342712 506.699738,922.940613 503.320709,924.828125 
	C489.984314,930.502380 477.153137,936.439026 464.333984,942.407471 
	C462.089691,943.452393 458.709198,945.585083 457.363556,942.224304 
	C456.111176,939.096558 460.180206,938.857300 462.148132,937.865295 
	C475.642517,931.063110 489.096497,924.174683 502.818726,917.835449 
	C500.690002,918.883789 498.524536,919.825867 495.810577,920.227966 
	C493.865601,920.254272 492.403961,920.537231 491.310089,922.370544 
	C487.806824,924.895203 484.076080,925.980835 479.930695,926.930664 
	C477.711121,926.564087 476.128235,926.745117 475.349243,929.237244 
	C472.472412,931.586060 469.236633,932.407837 465.807678,933.577881 
	C462.431305,932.037476 460.725281,933.271301 459.661499,936.564331 
	C455.897003,940.557068 451.883484,941.694397 447.030731,939.373840 
	C444.527405,938.176758 441.754944,937.596497 439.153473,936.593384 
	C437.430206,935.928955 435.778198,935.209473 435.580261,932.690552 
	C436.509308,930.882446 437.974091,930.452515 439.451965,930.248230 
	C443.322357,929.713440 446.285706,927.668579 448.535126,924.658325 
	C450.606720,921.886169 453.180237,920.422852 456.617493,920.708374 
	C461.750977,921.134766 465.710724,919.010803 468.616302,915.002136 
	C469.958069,913.151123 473.764709,912.578674 471.534058,908.521057 
	C470.505249,906.649719 473.585968,905.444824 475.335480,904.695618 
	C479.609558,902.865356 484.294830,902.310974 488.836823,900.395996 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M296.708130,665.907837 
	C298.430664,671.940186 300.792450,677.534851 298.517181,683.957153 
	C296.459656,685.211304 294.737061,684.519104 292.646729,684.014648 
	C289.924805,682.380493 287.233887,682.425842 284.242065,682.128540 
	C283.548004,681.591248 283.298676,681.158508 283.100983,680.287476 
	C283.068665,679.409363 283.158630,678.921997 283.527588,678.146484 
	C284.840851,676.940430 286.136871,677.051880 287.410706,677.275513 
	C290.301971,677.783142 291.705750,676.590820 291.681396,673.344849 
	C291.658600,672.362183 291.627960,671.710999 291.399109,670.755493 
	C291.222198,670.232361 291.148956,670.021973 290.965088,669.492432 
	C288.724823,662.256531 282.916901,657.888672 278.882568,651.880310 
	C278.508026,651.199890 278.378845,650.784851 278.354736,650.039978 
	C278.520416,649.353699 278.761688,649.070801 278.952209,648.710571 
	C278.642700,648.325989 278.529358,648.156982 278.272491,647.707031 
	C277.869598,646.841187 277.644165,646.240723 277.170319,645.418213 
	C276.902283,644.987610 276.797852,644.817566 276.549713,644.392395 
	C276.230469,643.797180 276.057587,643.455688 275.744995,642.867676 
	C275.506897,642.456970 275.410919,642.291565 275.190063,641.865051 
	C274.841827,640.804138 274.248596,640.250916 273.596680,639.349121 
	C271.432434,634.657654 268.525543,630.720032 266.578674,625.915649 
	C266.098267,625.116699 265.670929,624.658508 265.438660,623.770020 
	C264.902740,623.005005 265.803345,623.367310 265.175140,623.144958 
	C265.123474,623.126648 265.200928,623.133423 265.306885,623.408203 
	C265.524292,624.269409 265.787323,624.795715 266.339386,625.541199 
	C268.434326,630.722595 271.526733,635.016907 274.038879,640.004578 
	C274.487152,640.716553 274.530396,641.181824 274.231262,641.971802 
	C271.255798,643.312012 268.650635,641.737244 265.572876,641.654053 
	C258.827118,636.650269 255.237183,629.584656 251.081726,623.024963 
	C244.322998,612.355835 238.746384,600.983215 231.986755,590.811157 
	C234.503891,604.891663 235.893997,619.599426 235.382462,634.443542 
	C235.300003,636.836365 236.250290,640.207214 233.455460,641.113708 
	C230.548004,642.056824 229.352448,638.726807 228.204315,636.704041 
	C215.051712,613.531860 205.626907,589.253723 206.649658,561.595337 
	C206.693527,560.693542 206.749878,560.181763 206.920593,559.297852 
	C207.094437,558.682129 207.183884,558.441895 207.468887,557.870850 
	C207.988754,557.139893 208.364441,556.795898 209.129776,556.332642 
	C210.648407,555.703552 211.901489,555.474976 213.440323,554.858765 
	C222.063065,550.879944 230.833160,549.871460 240.187302,550.002686 
	C245.340988,550.122925 250.010742,551.085449 254.765793,551.386780 
	C250.200516,551.088623 245.717743,550.161011 240.752548,549.998413 
	C236.001694,549.932617 231.634064,549.901123 226.940308,550.746887 
	C225.674057,547.627441 227.291443,545.289612 230.906891,545.522400 
	C235.198471,545.798706 239.498657,545.270020 243.759979,545.879028 
	C248.591415,546.569580 253.147186,545.090454 258.104889,544.001038 
	C258.665436,543.697266 258.903107,543.602661 259.520508,543.461914 
	C268.197388,544.906860 275.116364,549.220825 282.014587,554.353210 
	C283.363739,556.380737 283.022766,558.289185 282.208893,559.881531 
	C280.739258,562.757019 282.010864,564.278259 284.433777,565.333862 
	C287.073669,566.483948 288.984039,568.109497 286.997437,570.989380 
	C284.716949,574.295227 282.761292,571.556824 280.837891,570.170410 
	C280.345398,569.815430 280.017395,569.214233 278.745239,569.084595 
	C286.215881,578.072510 292.021790,587.715393 298.272797,597.485840 
	C299.883728,602.078613 303.242554,605.400818 304.397797,610.083435 
	C305.378174,613.608398 306.507202,616.809753 307.716339,620.400635 
	C307.052856,624.073425 310.852509,627.374878 307.472290,630.891968 
	C304.828522,631.305115 304.599609,629.292175 304.129578,627.854736 
	C301.788422,620.695557 297.978577,614.219421 294.598633,607.166199 
	C291.841400,603.458557 289.924805,599.596191 286.936615,596.523560 
	C286.460968,598.519409 286.512360,600.395935 287.376740,602.556946 
	C288.524872,605.427368 286.970642,606.463379 283.118286,605.401978 
	C282.711609,604.848389 282.434143,604.630249 281.812622,604.676758 
	C280.300781,605.451965 279.261353,606.624207 277.381348,606.294250 
	C276.500854,605.490906 275.882935,604.871277 275.024841,604.026245 
	C274.206299,603.089905 273.992706,602.286560 274.247833,601.107666 
	C274.444550,600.684814 274.548370,600.538635 274.778046,600.174988 
	C275.173645,599.665344 275.441742,599.665894 275.622345,599.770874 
	C275.536469,599.582642 275.074738,599.655090 275.074738,599.655090 
	C275.074738,599.655090 274.950226,600.117493 274.728180,600.309753 
	C273.569916,601.481140 273.929596,602.464783 274.720581,603.697876 
	C275.566833,604.572449 276.185822,605.200745 277.050049,606.051331 
	C279.921356,608.834595 279.721039,612.401794 280.601135,615.904053 
	C280.461945,616.637634 280.255707,616.991699 280.144135,617.492493 
	C280.463562,617.909973 280.565002,618.101990 280.755676,618.615845 
	C280.246918,622.682556 282.210815,625.598511 284.109924,628.911499 
	C285.727173,634.130920 287.092804,639.054382 288.968048,644.203308 
	C290.546478,651.922302 294.991425,658.232544 296.708130,665.907837 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M471.781433,543.209412 
	C473.176086,541.437561 474.282257,542.936279 475.728149,542.977844 
	C478.598480,544.285706 480.044189,542.355957 481.852112,540.750122 
	C481.995575,540.442078 482.257355,540.104248 482.349030,540.047729 
	C483.118713,539.780151 483.781982,539.516785 484.767273,539.191528 
	C485.044037,538.968750 485.027405,539.036621 484.992554,539.034607 
	C485.199249,538.811401 485.433594,538.582825 485.818176,538.158569 
	C485.975677,537.970215 486.000000,538.000671 485.981689,537.993652 
	C486.453308,537.580505 486.501831,536.975647 486.835693,536.183044 
	C487.004303,535.942810 487.012390,536.007202 486.980194,536.011047 
	C487.257263,535.696838 487.456573,535.318604 487.707031,534.593750 
	C488.552155,533.440918 488.793396,532.307861 489.769318,531.238098 
	C490.028534,530.133911 490.060364,529.270935 490.169189,527.982788 
	C491.619202,525.946350 490.572266,524.124084 490.688202,522.404236 
	C490.939178,518.682434 491.647888,515.257507 496.190613,513.835266 
	C499.025513,512.495361 501.925659,512.382446 504.549957,510.613861 
	C507.650421,507.114105 511.214355,506.446503 515.092346,507.947510 
	C517.652100,508.938324 520.351074,508.169617 523.215942,509.087402 
	C526.420227,509.762360 529.366577,509.800201 532.569580,510.565613 
	C533.425903,510.643311 533.914124,510.697021 534.764343,510.822021 
	C537.756775,511.431946 540.156677,512.361694 542.134216,514.328430 
	C544.997009,517.175476 549.097046,515.905518 552.760376,517.383301 
	C556.100891,521.100220 558.608093,525.037354 561.511597,528.998779 
	C561.251709,529.699158 561.015320,530.048218 560.601990,530.218384 
	C560.846741,530.285706 560.943604,530.031372 561.447937,529.918579 
	C563.113831,531.612366 564.272766,533.461609 566.040833,530.037292 
	C568.384216,525.498840 572.102844,522.165100 576.458862,519.569885 
	C579.441650,517.792786 582.573914,516.985718 586.167480,518.941711 
	C586.977844,520.110840 587.056396,521.083130 586.685852,522.446960 
	C585.804321,523.848755 584.648499,524.112732 583.505737,524.318420 
	C577.683411,525.366394 573.800964,529.043457 570.465881,533.625366 
	C564.176575,542.265930 559.071411,551.590637 554.226685,561.079773 
	C553.327942,562.840088 552.599304,564.757141 550.511475,566.105469 
	C549.647278,566.341919 549.182190,566.210632 548.551758,565.569824 
	C548.131226,564.812073 547.987366,564.340881 547.876343,563.490845 
	C548.259705,559.820068 546.827698,559.070374 543.830811,560.046143 
	C538.765808,561.695251 537.328552,566.167480 540.352539,572.156738 
	C540.826660,572.821960 541.044373,573.233337 541.263550,574.014771 
	C541.241638,574.513000 541.219543,574.735474 541.105286,574.803589 
	C536.431946,577.591858 536.430847,577.590027 539.561218,581.879333 
	C541.790283,580.264954 539.046265,573.866150 545.451050,576.335205 
	C546.230896,578.061768 545.984680,579.509094 545.493652,580.879089 
	C544.668884,583.180237 545.292786,584.970154 547.354736,586.722168 
	C547.678650,587.219360 547.784973,587.435181 548.000000,587.998901 
	C548.621094,591.675598 547.833130,595.281372 550.402771,598.530212 
	C551.130554,599.993835 551.208252,601.214478 551.174133,602.804932 
	C551.307861,606.146484 553.781067,608.467041 553.609070,611.904419 
	C553.618103,613.688171 553.357849,615.074585 552.603149,616.691406 
	C551.098816,618.044861 549.822754,617.584290 548.886902,616.568237 
	C547.025574,614.547302 545.393372,615.474487 543.371033,616.827271 
	C541.417053,617.354553 539.812866,617.822144 537.957458,618.730835 
	C536.553589,619.128540 535.524414,619.096130 534.180054,618.468201 
	C532.402100,615.116455 534.532593,612.522156 535.330933,609.352417 
	C535.745483,608.832520 535.947815,608.657898 536.515625,608.328613 
	C538.899597,607.877991 540.419678,608.391541 540.886963,610.966187 
	C541.152222,611.960083 540.043457,612.119507 540.528564,612.616211 
	C541.269897,611.976929 541.977600,611.773315 542.718506,611.135620 
	C543.261108,610.260437 543.395386,609.625671 542.438660,608.929565 
	C541.014832,608.266357 539.747253,608.078430 538.247559,607.527222 
	C537.823303,607.174194 537.686951,606.996338 537.450806,606.498352 
	C537.343689,605.957336 537.336365,605.736450 537.380371,605.200073 
	C537.897339,602.803406 536.301453,603.335815 535.307617,603.292725 
	C533.494995,603.214172 531.676514,603.281006 529.518921,603.242798 
	C528.718384,603.188171 528.262939,603.122192 527.468689,602.961670 
	C526.444458,602.732178 525.786438,602.470215 524.722290,602.396606 
	C523.386230,602.346375 522.408447,602.324707 521.047180,602.362793 
	C519.617798,602.382141 518.571777,602.364014 517.119873,602.322144 
	C515.311584,602.096497 514.004150,601.749390 513.534668,599.765503 
	C514.256287,598.016541 515.602173,597.796265 517.246948,597.345398 
	C518.343933,597.075195 519.081970,596.984009 520.183899,597.067871 
	C521.844055,597.419495 523.149048,597.774963 524.844849,597.421143 
	C526.715393,597.405823 528.225220,597.805115 530.096558,597.728149 
	C530.638916,597.709045 530.855469,597.700745 531.395508,597.674438 
	C532.366943,597.612000 533.006592,597.518982 533.946045,597.228638 
	C534.480591,597.083679 534.697510,597.034180 535.247437,596.952148 
	C537.032410,597.072388 538.469421,596.983765 539.746094,596.660583 
	C540.557190,596.618103 539.691528,595.816467 539.772522,596.478210 
	C539.811096,596.793335 539.683533,596.664185 539.284058,596.577271 
	C538.845215,596.481750 538.342651,596.718994 537.505737,596.830811 
	C522.440186,596.343872 507.729279,596.506531 493.019287,596.567993 
	C492.520050,596.570068 492.091187,596.875366 491.608551,597.587769 
	C491.337097,598.381165 491.172943,598.828857 490.794800,599.567383 
	C489.902008,600.800720 488.830353,601.286499 487.682983,602.220093 
	C486.666412,602.954773 485.865143,603.364136 484.616333,603.521362 
	C483.928314,602.832886 483.579041,602.153809 483.080933,601.122925 
	C487.649658,593.055420 484.651459,585.839844 481.335022,578.286377 
	C480.909210,577.199463 480.778046,576.436462 480.787476,575.265381 
	C481.577118,568.289856 480.070038,561.859009 479.800293,555.117676 
	C478.556274,561.397644 481.154846,567.183350 480.514801,573.521301 
	C478.499664,574.740845 477.875763,573.227600 477.359131,572.155579 
	C475.714111,568.742004 473.614349,565.489258 473.111206,561.190918 
	C474.651184,554.854004 471.713623,549.311951 471.781433,543.209412 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M585.943237,518.622070 
	C573.860107,518.607849 569.019531,527.748108 563.425415,535.850952 
	C561.501770,534.477051 561.288208,532.817322 561.486938,530.661499 
	C561.128662,530.344543 560.917114,530.333557 560.730713,530.005981 
	C558.268860,525.997070 554.533325,523.189209 552.929443,518.428040 
	C551.500122,516.377075 551.452942,514.429504 551.462585,512.389587 
	C551.561157,491.617920 551.541382,470.845886 551.549438,450.074005 
	C551.550781,446.578033 551.681091,443.105347 552.364807,439.206421 
	C552.792786,435.282379 553.536743,431.851990 553.557617,427.933594 
	C553.398560,424.160889 553.988037,420.723206 552.339722,417.158203 
	C551.883606,413.882019 553.157043,411.496918 554.545654,408.996765 
	C556.173828,406.065186 556.929626,402.725647 557.447754,397.817047 
	C559.067139,401.169067 559.971069,403.200806 561.020874,405.154205 
	C561.668030,406.358337 562.402039,406.407654 562.797363,404.573730 
	C562.509338,403.453766 562.741089,402.850372 563.578003,402.910919 
	C565.422913,403.044373 565.756653,404.665833 566.624146,406.227417 
	C569.545227,405.516266 568.489014,403.332001 568.432434,401.478577 
	C576.108459,404.128632 577.308594,408.023315 572.291016,414.834717 
	C571.521179,416.178314 570.729187,416.849365 569.658203,416.932281 
	C570.594543,417.260040 571.528381,416.409851 572.911743,416.270508 
	C579.914673,410.763397 579.047546,405.991974 569.522949,398.301849 
	C573.704163,397.888458 577.838684,398.871460 580.927612,395.427368 
	C580.228882,393.644318 580.713867,392.413879 581.649048,390.838135 
	C583.084167,388.142731 586.037781,388.012604 587.619690,385.998566 
	C588.844971,384.438568 590.263916,383.040314 589.895569,380.441895 
	C592.758362,379.464630 595.838196,378.907715 598.573669,378.769836 
	C602.895447,378.551910 602.604492,376.605347 602.323059,373.801971 
	C602.064453,371.225830 601.889465,368.684631 605.886230,368.660461 
	C607.765198,370.716766 607.020203,372.940704 607.113220,375.397522 
	C607.567383,378.421814 607.540771,381.142639 607.856079,384.158722 
	C607.667786,385.131317 607.409241,385.734131 607.060913,386.642761 
	C606.681763,387.782684 606.692566,388.623108 607.033081,389.809387 
	C607.293457,390.897369 607.359009,391.655487 607.499023,392.829254 
	C607.390198,409.377350 607.580139,425.510406 607.316467,441.638306 
	C607.257874,445.222809 606.905090,448.921417 605.108276,452.675964 
	C604.381714,453.423859 603.888550,453.736023 602.937500,454.080292 
	C600.235718,454.579437 597.895264,454.577484 595.594543,455.030853 
	C589.768188,456.178894 589.600037,456.337402 589.479004,462.973694 
	C589.558594,465.659912 589.534790,467.936188 589.165283,470.631287 
	C587.675354,476.208038 589.134399,481.540833 587.924255,487.102112 
	C587.618591,487.716675 587.465637,487.939758 586.990112,488.389099 
	C583.616150,488.747925 582.062439,489.812622 582.278137,493.392700 
	C582.635742,499.326752 582.314087,505.299194 582.418457,511.252991 
	C582.444641,512.746643 581.588745,514.661682 584.032471,515.700439 
	C584.593933,515.867188 584.816833,515.942444 585.357239,516.175049 
	C586.058411,516.613708 586.343445,516.970398 586.521118,517.758301 
	C586.445496,518.296326 586.354919,518.496582 585.943237,518.622070 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M511.241272,895.115967 
	C506.817230,897.537781 502.103882,897.321838 497.568207,897.957642 
	C495.722198,898.216431 493.966675,898.326721 492.197937,899.775269 
	C491.929230,898.162842 491.029327,897.389648 489.479584,897.213867 
	C474.892792,895.559570 461.221527,889.845093 446.805084,887.513794 
	C428.952301,884.626770 411.127441,881.472778 392.889343,882.018555 
	C380.721436,882.382629 369.224548,885.818909 357.995941,889.739746 
	C338.072052,896.696838 317.945496,903.263916 299.084656,912.957214 
	C294.207092,915.463928 289.410187,918.127625 284.290436,920.918884 
	C280.102295,922.775208 277.313080,920.207153 274.307190,918.249756 
	C274.395508,917.497925 274.984558,917.330200 274.903961,916.848633 
	C274.897491,916.809875 274.486969,917.307861 273.833557,916.940430 
	C271.890656,912.693726 273.119049,909.912292 277.450439,907.786438 
	C282.109497,905.499817 287.213165,904.684143 292.502075,903.165466 
	C295.823730,902.540161 298.629761,901.439575 301.917297,900.741089 
	C303.750458,900.639954 305.052856,900.029358 306.703674,899.327271 
	C308.179718,898.778503 309.400085,898.648499 310.883087,898.082397 
	C345.103027,888.048096 377.327332,874.260254 408.042786,856.909851 
	C409.758026,855.940857 411.327362,854.553650 413.817902,854.960938 
	C425.906342,856.780457 437.694458,858.315918 449.463257,859.987305 
	C462.732727,861.871826 476.121765,862.896362 489.635803,865.699768 
	C490.513672,866.281372 489.718231,865.992920 490.319427,866.233948 
	C496.470551,868.700317 500.489777,872.753113 500.769867,879.774963 
	C500.809418,880.766785 501.581360,881.886414 502.498932,882.080322 
	C508.217377,883.289001 509.098053,889.080811 512.505798,892.456116 
	C513.979919,893.916077 512.460449,894.326477 511.241272,895.115967 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M137.100067,599.261597 
	C135.187241,604.312988 136.324707,609.191528 136.248047,614.459961 
	C136.727509,623.809937 137.443420,632.682861 138.203491,641.943970 
	C138.006134,643.086609 137.766541,643.813293 137.578552,644.923340 
	C137.442154,645.505737 137.359512,645.729492 136.997833,646.170776 
	C133.632034,644.407104 129.335266,644.370056 127.400955,640.512573 
	C126.908623,639.530762 125.674316,639.701904 124.527664,639.050476 
	C120.938133,634.159302 119.018158,628.956482 118.331055,623.274414 
	C118.024971,622.680420 117.355736,623.539551 117.938034,623.214905 
	C118.161415,623.090454 118.322060,623.167786 118.372589,623.455261 
	C118.943184,626.701111 119.821350,629.923584 119.033615,633.634277 
	C119.644188,650.255005 121.803299,666.369568 123.588356,683.008545 
	C121.681213,683.934692 120.021034,682.696716 117.831123,682.644897 
	C114.267235,678.668762 113.564041,673.796875 112.025932,668.863403 
	C111.200294,665.077698 110.208321,661.723022 108.831047,658.187378 
	C106.801224,656.292847 104.317627,658.852661 102.348663,656.692139 
	C99.702225,648.238708 99.505653,639.853699 99.593910,631.440735 
	C99.705551,630.764282 98.632401,631.428833 99.280746,631.273621 
	C99.583504,633.866638 99.741295,636.455566 98.903412,639.367188 
	C98.463165,640.130066 98.179657,640.674927 97.732895,640.787109 
	C84.816162,644.031677 80.703362,654.730774 76.484528,665.848999 
	C75.810295,666.444458 75.326164,666.580627 74.433113,666.449890 
	C72.258530,664.356628 73.371376,662.222717 73.866173,660.208313 
	C75.378708,654.050476 77.724358,648.136902 80.486504,642.488892 
	C97.141777,608.432129 115.233147,575.196045 137.696564,544.523071 
	C139.368835,542.239685 141.330551,540.199646 143.143433,538.035095 
	C144.179031,536.798584 145.223633,535.318115 147.505493,536.322021 
	C148.864975,544.183472 149.639984,551.686035 144.968872,558.910950 
	C144.210663,559.836365 143.654663,560.409790 143.353333,561.591064 
	C141.321365,566.567261 143.467712,571.637512 141.336548,576.547974 
	C141.072906,579.258911 141.065018,581.656372 140.915466,584.471069 
	C139.755524,587.440979 141.768173,591.298462 137.173065,592.299133 
	C136.624054,589.227722 136.102722,586.368591 135.379929,583.543518 
	C135.221802,582.895813 134.573074,583.841431 135.153442,583.513367 
	C135.347122,583.403870 135.485245,583.484863 135.530029,583.762451 
	C136.262970,588.305542 137.168030,592.825134 137.411163,597.815247 
	C137.384323,598.445435 137.349869,598.696716 137.100067,599.261597 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M147.294235,535.678467 
	C137.571991,545.903015 129.480957,557.014832 122.421005,568.866089 
	C107.271706,594.296631 91.883095,619.602173 79.914963,646.768250 
	C77.297394,652.709778 74.836983,658.716858 74.089050,665.641235 
	C75.344742,667.561218 74.752693,669.215088 74.452698,671.263062 
	C72.478889,683.847534 68.709442,695.584656 65.143173,707.293884 
	C60.055199,723.999268 58.555294,741.077026 57.495945,758.297424 
	C57.414471,759.621826 57.460182,760.954102 57.053272,762.657532 
	C56.788963,763.289001 56.650406,763.524841 56.191315,764.010986 
	C54.542763,764.434631 54.066013,763.382446 53.215748,762.242065 
	C52.619045,761.264099 52.224884,760.613770 51.505684,759.724487 
	C51.128666,759.215759 50.985935,759.006531 50.665100,758.463379 
	C49.910587,757.323425 49.412148,756.463501 48.797966,755.683716 
	C46.452126,761.388367 45.235447,792.439270 47.054447,802.456970 
	C47.076542,804.971436 47.474514,807.391602 43.814423,807.322998 
	C40.710434,805.644775 38.967094,802.647095 35.749790,801.707275 
	C35.213444,802.821472 35.896229,803.664307 36.204479,804.915710 
	C39.289158,814.120667 40.302650,823.651978 45.462448,832.154297 
	C45.632713,834.513306 43.800678,835.208496 42.704262,836.817017 
	C41.240723,847.204285 44.805141,855.429565 52.254486,862.536865 
	C53.635761,864.153870 54.680927,865.655823 57.075562,865.720947 
	C60.073437,866.237366 60.862492,867.428040 59.050789,869.772827 
	C56.326416,873.298889 52.542286,875.377441 48.604095,877.043701 
	C44.506523,878.777344 42.934902,881.273438 44.841789,885.841980 
	C45.271347,887.517456 45.704254,888.824463 46.494186,890.381470 
	C46.725731,890.934021 46.807228,891.161804 46.975952,891.745605 
	C47.262840,893.599182 47.338528,895.080139 46.216377,896.697754 
	C42.924789,896.900757 42.433781,894.259521 41.660667,892.309021 
	C40.020115,888.169922 38.783421,883.870850 37.177399,879.318970 
	C33.267033,874.120911 34.679569,868.458679 34.531906,862.580200 
	C34.352528,859.411682 34.411087,856.696045 34.499077,853.528076 
	C34.435184,850.951904 34.479923,848.828796 34.538124,846.245667 
	C34.488865,841.767578 33.789333,837.709229 35.509659,833.394165 
	C36.040409,828.973938 35.488503,824.960693 34.349125,821.175476 
	C30.435789,808.174744 31.391088,795.745178 35.349785,782.655457 
	C48.529636,739.075378 60.466038,695.120300 73.507942,651.497009 
	C79.657166,630.928711 89.081406,611.649292 99.441910,592.797852 
	C108.194237,576.872498 117.194138,561.193298 127.735893,546.342529 
	C134.322906,537.062988 141.143402,528.116516 149.669312,520.229370 
	C150.927414,520.588684 151.135391,521.670959 151.947174,522.184814 
	C152.655182,521.098206 152.605423,519.822693 152.980042,518.330566 
	C153.002899,515.856323 155.115021,516.012573 156.544662,515.003784 
	C157.371704,514.093811 159.352737,515.529785 158.851135,513.289551 
	C158.618027,513.062012 158.471481,512.594604 158.555206,512.364441 
	C162.846024,512.722839 166.475800,511.194061 169.469986,508.520203 
	C171.683517,506.543518 173.662109,504.775238 176.877335,505.630737 
	C177.676407,505.843353 178.570404,505.716522 179.294250,505.275299 
	C185.991150,501.193146 194.028091,500.405945 200.810120,496.483734 
	C202.616760,495.438904 204.779999,494.655914 207.159607,496.229614 
	C207.478165,499.237122 205.186234,499.540497 203.493500,500.436279 
	C192.876694,506.054565 181.471558,509.849976 170.501068,514.653503 
	C163.707474,517.628113 158.437119,522.168152 154.219559,528.169128 
	C152.318588,530.873962 150.460220,533.677002 147.294235,535.678467 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M376.185364,333.687256 
	C371.034424,334.810089 366.250397,334.826782 361.911377,330.981415 
	C362.993042,334.153198 364.074677,337.325012 365.019165,340.873413 
	C364.234863,341.778046 363.490692,342.084137 362.271240,342.253662 
	C356.301941,341.613739 350.835876,340.157898 345.164398,340.210266 
	C342.721619,340.232849 340.958374,340.896576 340.468536,343.539886 
	C340.060272,345.742920 339.597961,347.998749 336.551086,347.508331 
	C333.193695,346.967957 330.627991,345.418396 329.999420,341.719818 
	C329.711456,340.025238 330.365112,338.446655 330.550232,336.811035 
	C330.934448,333.416229 330.218018,330.956024 326.699005,329.174866 
	C320.776154,326.176971 314.885254,323.316528 307.878967,322.251251 
	C307.267426,322.101501 307.029999,322.023438 306.458984,321.785767 
	C302.842865,318.320953 299.251038,316.115387 294.089935,318.210205 
	C292.404602,316.522736 291.796661,317.253204 290.965332,318.742371 
	C288.936005,322.377441 285.707245,322.669342 282.379242,320.938293 
	C277.089417,318.186920 271.896545,315.835571 265.901917,318.926758 
	C264.894653,319.446136 263.602844,319.152496 262.125854,318.610382 
	C260.912170,317.838531 260.182404,317.084412 259.357239,315.863525 
	C259.098114,310.457520 259.010559,305.418915 261.244324,300.317749 
	C266.372528,296.912628 271.234009,297.231720 276.595612,299.003632 
	C280.980133,300.452637 285.850220,299.369995 290.501282,299.973297 
	C297.239990,300.847290 304.144135,300.339996 310.752472,302.400940 
	C311.370697,302.593750 312.112640,302.623962 312.738678,302.467926 
	C323.608765,299.759186 334.923370,301.541046 345.848419,299.088623 
	C351.227936,297.881012 356.756561,298.038666 362.139526,299.788208 
	C367.465576,301.519257 367.490112,301.461517 369.467438,296.360474 
	C369.893707,295.260834 370.323029,294.181396 371.858154,293.576569 
	C374.399292,294.200226 374.177216,296.041077 374.025848,297.626587 
	C373.412231,304.053253 372.681763,310.466095 372.193420,316.907990 
	C371.888550,320.929840 370.500458,321.305084 365.582550,318.782715 
	C368.372040,321.831116 371.094635,324.476990 370.408020,328.939575 
	C370.921661,329.563019 371.133453,329.969055 371.189209,330.747253 
	C371.141510,334.690826 373.853912,332.226868 375.596680,332.856201 
	C376.121277,333.018280 376.242371,333.208771 376.185364,333.687256 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M326.190430,749.388855 
	C324.062500,750.116211 322.312164,750.943359 320.273010,751.989319 
	C319.698578,752.347046 319.432526,752.516541 318.968750,752.811646 
	C317.224945,753.569824 315.698364,754.233154 313.925659,755.083374 
	C313.221741,757.694214 311.346466,757.606567 309.168823,757.763672 
	C307.655609,758.407288 306.498993,758.902344 305.153229,759.651306 
	C304.238251,760.745178 303.594360,761.692749 302.037476,761.850220 
	C300.729401,761.699524 300.126373,763.100647 298.915222,762.442200 
	C301.482056,754.111023 305.719574,747.119812 313.601166,742.696289 
	C333.474335,731.542480 348.905670,715.319641 363.921143,698.585938 
	C370.976990,690.722717 377.407959,682.285400 385.557007,675.186829 
	C388.499786,677.931763 390.068146,681.026367 389.706207,685.191284 
	C388.940369,686.282349 388.327789,687.035278 390.393524,687.220215 
	C392.329620,688.170715 393.140411,689.625000 393.652710,691.232666 
	C396.229736,699.320374 399.403198,707.198120 402.061798,715.258301 
	C403.203278,718.718933 402.589539,721.024963 398.843201,722.197266 
	C374.840271,729.708374 351.392242,738.676270 328.516632,749.135071 
	C327.904877,749.414734 327.240021,749.493958 326.190430,749.388855 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M368.859924,448.757812 
	C368.783936,449.637726 368.623260,450.235565 368.425354,451.141663 
	C368.807587,454.810089 366.994049,457.617737 365.950073,460.987000 
	C361.387299,469.196503 359.121674,477.898651 357.159302,485.104553 
	C359.086639,481.013885 361.904724,475.637909 364.582947,469.788147 
	C366.044434,466.439453 367.258209,463.372314 368.728577,460.421387 
	C369.310394,459.253662 369.974701,457.686005 371.494751,458.092194 
	C373.358887,458.590393 372.393860,460.190582 372.147217,461.403687 
	C372.015900,462.049744 371.856506,462.690704 372.087982,463.006561 
	C372.725922,460.081268 372.780762,456.726440 376.005249,454.315369 
	C376.326965,454.164398 376.650330,454.072296 376.808197,454.014465 
	C378.206390,454.294128 379.322937,454.889618 380.692810,455.844940 
	C384.118774,459.160889 387.957550,460.289124 392.236633,460.586151 
	C397.745270,460.968567 398.531494,461.985718 397.462921,467.500092 
	C395.705292,476.570160 394.648560,485.759186 392.719360,494.796570 
	C392.471771,495.956329 392.434113,497.084412 392.889099,498.615540 
	C392.550201,506.043396 391.139923,512.900452 389.209167,520.038696 
	C388.139984,524.319397 383.122437,525.051270 382.292023,529.087341 
	C381.686432,532.030701 380.499023,534.807617 379.563965,538.002563 
	C378.259521,539.242188 378.038361,540.503967 377.975037,542.134521 
	C376.458374,542.659973 375.237915,542.337402 373.626831,542.093994 
	C370.674774,540.916870 370.622101,538.711670 370.992950,536.514404 
	C371.692444,532.370544 371.552277,528.206909 371.530701,524.045898 
	C371.476868,513.679138 367.386566,509.221436 356.699219,508.100952 
	C356.061432,507.850586 355.820587,507.716125 355.238617,507.347412 
	C351.643250,490.806488 349.428619,474.414093 350.661591,457.718414 
	C350.909180,454.365784 351.618469,451.167816 353.172058,447.785889 
	C353.245605,447.004944 353.387512,446.640472 353.931458,446.179596 
	C354.195984,446.029694 354.402374,445.874207 354.403259,445.745026 
	C354.238770,445.127045 354.344238,444.706085 355.072937,444.283813 
	C355.861176,443.896240 356.296875,443.577820 356.827881,443.000824 
	C360.143494,441.244293 362.879669,441.095856 364.162415,445.249146 
	C364.587067,446.624084 365.312866,445.717468 366.258911,445.426605 
	C367.194550,445.266937 367.809753,445.080383 368.869141,445.084106 
	C368.240601,446.191376 369.069824,447.428009 368.859924,448.757812 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M56.158806,764.405090 
	C55.569214,742.213989 59.121170,721.033264 65.426620,700.143250 
	C68.252396,690.781372 71.486420,681.470398 73.124886,671.339966 
	C76.838280,670.247925 76.909851,673.157654 77.281189,675.238281 
	C79.205818,686.022156 82.111572,696.593506 84.201950,707.746765 
	C85.856766,714.583008 87.372520,721.042542 89.518188,727.728638 
	C89.747887,728.324219 89.831894,728.565552 90.022110,729.175049 
	C90.618088,734.315735 93.911583,738.509033 92.898949,743.921082 
	C92.115204,745.457397 91.286049,745.391602 90.116989,744.340698 
	C89.746284,743.873108 89.616661,743.674255 89.334839,743.158508 
	C88.780373,741.781555 88.506432,740.673157 87.832840,739.355713 
	C86.941154,736.934265 86.249184,735.220764 83.200745,736.245544 
	C81.140121,736.938171 78.655823,735.987183 76.201416,737.280029 
	C71.129517,735.456848 66.585365,733.185547 62.583290,730.028687 
	C62.813675,730.948242 64.286385,731.303284 64.196373,732.261719 
	C63.515842,739.508057 68.874794,743.802368 72.298615,749.022278 
	C73.309189,750.563049 74.283501,752.060913 74.665939,754.215942 
	C74.685791,754.954102 74.639999,755.364929 74.536972,756.057739 
	C74.579964,756.529968 74.637703,756.715088 74.821671,757.167603 
	C75.130928,757.799683 75.307838,758.167358 75.611526,758.834839 
	C75.815826,759.342285 75.888031,759.552612 76.044998,760.091370 
	C80.433701,779.991699 90.688797,795.255798 108.759476,805.277710 
	C110.667076,807.075256 111.323608,809.128784 111.805939,811.619568 
	C117.943192,822.240356 125.752533,825.591187 137.554077,822.811401 
	C140.051849,825.194824 138.601227,827.243652 137.021973,829.602966 
	C136.399414,830.243164 135.970490,830.490417 135.132874,830.690796 
	C133.440781,830.632751 132.107605,830.553894 130.784058,831.877441 
	C127.521461,833.460876 124.445160,834.346863 120.753006,834.020630 
	C112.558960,831.589233 109.231216,824.342163 104.160934,818.987793 
	C103.705948,818.507385 104.174065,819.170044 103.874405,818.583130 
	C95.528465,802.237183 82.061432,791.870972 65.367661,785.018433 
	C60.064999,782.841797 55.243263,779.609680 55.185852,772.395996 
	C55.937191,769.653442 55.350929,767.129639 56.158806,764.405090 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M119.277023,914.493164 
	C119.827705,913.488281 120.222778,912.866394 120.731110,911.986755 
	C127.184647,902.738831 134.545105,894.569824 141.805008,885.912170 
	C143.073624,885.805176 143.695923,886.403198 143.845627,887.246948 
	C144.528183,891.094482 147.272491,892.209778 150.967346,892.681641 
	C152.254745,893.922485 153.524460,894.532898 154.856079,895.105347 
	C156.881348,895.975891 157.174423,897.547363 156.178436,899.690674 
	C155.803650,900.159973 155.594070,900.380615 155.334412,900.595093 
	C155.294891,900.599182 155.552307,900.529236 155.669998,900.391968 
	C156.289413,899.792664 156.884155,899.518677 157.848450,899.360596 
	C158.987671,899.392700 159.744797,899.703125 160.742798,900.250854 
	C161.325668,900.676758 161.614304,900.966797 161.938171,900.991760 
	C162.183487,900.564514 162.356003,900.439087 162.838776,900.210327 
	C167.181335,902.056519 169.543320,898.517944 172.927963,897.270935 
	C173.470978,897.396484 173.677307,897.484375 174.116486,897.812622 
	C175.036484,899.032349 173.867630,900.580994 175.633331,901.423767 
	C176.832214,901.984802 177.797333,902.236328 179.139679,902.280212 
	C179.664764,902.381348 179.873260,902.441040 180.382217,902.633911 
	C182.849564,903.411316 184.348328,905.323059 186.879211,905.969299 
	C187.387558,906.154602 187.583755,906.239441 188.050095,906.484802 
	C188.806580,906.994751 189.246582,907.399597 189.902924,907.969666 
	C190.241165,908.262634 190.371292,908.380554 190.704712,908.656738 
	C190.902344,908.985901 190.896729,909.156616 190.966217,909.082153 
	C190.709229,908.648071 190.493958,908.361755 190.333847,907.704834 
	C193.242172,904.684509 197.030792,905.757935 200.311813,905.667725 
	C203.288193,905.585815 206.573380,906.320435 209.784454,907.860840 
	C211.458725,908.424072 213.470535,907.737854 214.035202,909.470825 
	C214.631439,911.300781 213.125641,912.524048 211.872223,913.628052 
	C202.376129,921.991821 191.858917,928.986328 181.212646,936.420776 
	C179.035843,937.396973 177.396744,936.714417 175.654419,936.014465 
	C164.572433,931.562805 153.578247,926.903625 142.989349,921.377136 
	C139.302429,919.452881 137.192215,920.315491 135.507553,923.874451 
	C133.237122,928.671204 130.830612,933.406128 128.364166,938.106079 
	C127.398788,939.945557 126.734695,942.261230 123.658249,941.852417 
	C121.185081,932.793579 119.263840,923.977051 119.277023,914.493164 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M515.796265,939.316650 
	C510.729401,943.000305 505.117706,945.266113 499.036560,947.907349 
	C502.618073,949.313354 505.013336,951.756470 507.827148,954.197388 
	C515.076294,953.319214 521.207153,949.766663 527.551392,946.777222 
	C529.183960,946.007874 530.806885,945.224487 532.758911,944.315552 
	C533.042358,944.094421 532.868286,944.007568 532.869446,943.910278 
	C542.206543,939.760742 551.431335,935.440002 561.466492,932.148376 
	C562.950806,932.356750 563.751953,932.960083 564.420776,934.275208 
	C563.987854,938.468445 560.492065,939.460815 557.970154,941.349670 
	C554.991516,943.580444 551.192688,944.685425 548.715332,948.203247 
	C539.962280,952.851379 530.997803,956.127380 521.966675,959.257446 
	C519.217773,960.210266 516.137146,960.560791 514.138245,963.277344 
	C516.605713,965.963074 518.090576,963.456421 520.195740,962.367554 
	C521.505493,961.893188 522.495178,961.911377 523.860840,962.254639 
	C525.509277,963.384460 526.833130,963.396545 528.399841,962.958252 
	C530.296631,962.427490 532.226196,961.890198 534.217407,961.761047 
	C539.420776,961.423645 540.589905,963.289490 538.067444,968.545776 
	C537.253296,969.750366 536.416748,970.395081 535.352295,971.356384 
	C533.916626,972.263977 532.584534,972.320801 531.052795,972.947876 
	C525.440674,974.550781 520.062012,975.471924 513.770264,976.708374 
	C524.612610,974.886353 534.584717,974.283203 544.998413,974.592407 
	C547.238342,974.550415 549.001770,975.012878 550.752258,975.560425 
	C552.464844,976.096191 553.786743,976.995850 553.785889,979.001648 
	C553.785034,980.980042 552.419861,981.886414 550.826843,982.598511 
	C549.122131,983.360596 547.286072,983.548645 545.478577,983.689758 
	C532.642090,984.692261 519.999023,988.484558 507.381134,986.385681 
	C506.280396,986.405457 507.082306,987.504761 506.884583,986.868103 
	C506.806152,986.615601 506.914642,986.463623 507.203430,986.488342 
	C520.202515,987.597717 533.050537,986.642151 545.783386,983.813599 
	C547.555176,983.419983 549.874268,983.318237 550.714172,985.164856 
	C551.391418,986.653687 549.833374,988.313904 548.796509,989.464661 
	C546.795227,991.686035 543.983582,992.967834 541.335938,995.076050 
	C535.790405,996.873596 532.056091,1001.426147 526.206421,1002.556763 
	C524.364258,1003.094482 522.842773,1003.189453 521.459961,1002.577148 
	C514.534729,999.510315 507.129242,997.686157 500.015411,994.115601 
	C498.077209,992.283752 497.994446,990.468445 499.095825,988.205383 
	C499.420288,987.663757 499.607697,987.430847 499.797699,987.199890 
	C499.988647,986.967651 500.203064,986.761292 500.451111,986.589111 
	C500.154663,986.334106 500.019470,986.333618 500.105042,986.565491 
	C500.206604,986.840698 500.111084,987.054077 499.556763,987.471619 
	C496.457153,994.625488 496.453125,994.629944 490.687958,989.399902 
	C489.722260,988.523865 488.438995,987.979614 487.921295,986.356567 
	C489.301147,984.353271 490.642670,985.978699 491.950836,986.021423 
	C494.285156,986.097595 495.173706,985.071350 494.991577,982.473755 
	C497.713654,980.555725 500.671021,979.263611 501.534821,975.415039 
	C502.911652,974.788940 504.076874,974.435974 505.605988,974.039795 
	C507.539185,975.975586 505.723358,977.592163 505.279175,980.148682 
	C507.267303,976.030090 507.583832,972.391357 507.290497,968.366211 
	C506.623444,968.039551 506.128906,968.014771 505.263672,967.968750 
	C502.739197,964.368286 499.132996,962.231323 496.072327,959.066711 
	C491.589081,955.304993 487.421783,958.972778 483.215973,958.806091 
	C487.366608,958.842224 491.446136,955.556274 495.919373,958.931335 
	C496.915588,961.994141 494.604340,962.009583 493.024078,962.415283 
	C487.799194,963.756653 482.868134,965.894348 477.792419,967.635681 
	C477.179260,967.826416 477.829773,968.037476 477.891663,967.995056 
	C479.657349,966.782715 480.875366,967.838074 482.020844,969.486694 
	C478.234619,974.496887 473.907593,973.869324 471.808289,967.885498 
	C471.177032,966.086243 471.407867,964.963745 469.070740,964.544739 
	C467.327850,964.232178 468.217010,961.996399 468.011047,960.174072 
	C468.740997,955.942322 472.052490,956.180908 475.066528,955.312134 
	C476.462677,954.753601 477.466614,954.194641 478.769714,953.457336 
	C479.743073,953.067017 480.424500,952.967102 481.465454,953.016785 
	C484.249573,952.912292 486.500061,951.679382 489.274414,951.606567 
	C489.938080,951.168823 490.333130,950.945129 491.077637,950.655518 
	C499.567413,951.755676 503.286804,958.864868 509.301331,963.630615 
	C504.053131,958.036743 499.846191,951.783997 491.443726,950.531738 
	C490.402466,950.823975 489.761688,951.172180 488.796814,951.719482 
	C486.349243,951.949524 484.266907,952.112061 481.825134,952.487000 
	C478.688049,949.138367 481.377014,947.571533 483.551880,946.137024 
	C485.930664,944.567932 488.848389,944.211731 491.503357,943.252258 
	C497.141296,941.214844 503.052094,940.083496 508.652954,937.887512 
	C510.978302,936.975769 513.802002,935.667480 515.796265,939.316650 
z"/>
<path fill="#6A7594" opacity="1.000000" stroke="none" 
	d="
M44.339859,887.279968 
	C40.967781,879.486267 41.056095,879.226685 48.133171,875.713257 
	C51.817173,873.884338 55.694298,872.347839 58.268272,868.873657 
	C58.900585,868.020203 59.611053,867.158081 57.402458,867.251587 
	C57.396511,862.820801 60.619606,863.925903 63.568077,863.957031 
	C65.135117,868.726562 68.219398,867.665649 71.387390,866.576111 
	C73.096771,865.988281 74.717010,865.226013 76.659637,864.306763 
	C82.635597,862.354126 88.028526,859.990417 93.233917,856.405273 
	C107.011345,848.710083 120.928894,842.028198 134.618835,834.154297 
	C135.372314,833.775635 135.810699,833.577209 136.578522,833.234497 
	C138.010681,832.607666 139.142456,832.218384 140.697327,832.008606 
	C143.902191,832.060913 147.241730,829.499756 149.237976,833.845703 
	C135.563522,846.744324 120.849510,857.867920 106.099327,868.941162 
	C99.195648,874.123901 92.179504,879.156860 85.017715,884.533997 
	C84.773193,885.373047 83.637077,885.723572 84.731247,886.532959 
	C96.008415,882.402710 106.707535,877.446716 117.469109,871.764709 
	C118.348648,871.517761 118.763802,871.710693 118.994675,872.571533 
	C107.500038,882.214966 95.718651,890.952576 81.420822,896.385742 
	C72.269119,894.629028 63.136379,894.036926 54.847954,890.244873 
	C51.536095,888.729553 48.951763,888.753662 46.113937,891.379639 
	C45.748184,891.332031 45.731525,891.129883 45.828865,891.101318 
	C45.326874,889.943909 45.460083,888.531128 44.339859,887.279968 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M370.110229,329.661499 
	C368.808777,329.776978 367.849121,329.831177 365.644806,329.955627 
	C371.022522,326.612976 369.694427,324.059509 366.417145,321.315857 
	C364.797302,319.959778 363.763184,317.970825 364.127899,315.540558 
	C364.437531,315.540558 364.794312,315.434540 364.909576,315.556580 
	C366.441498,317.178925 367.421051,320.454285 369.856018,319.732208 
	C372.430115,318.968933 370.908813,315.712524 371.182251,313.622192 
	C371.996216,307.399353 372.370880,301.119049 372.853546,294.436951 
	C371.747711,292.702484 371.522644,291.002686 370.534119,289.267029 
	C370.061432,287.969696 370.149139,287.015778 370.628967,285.732788 
	C371.768280,283.915863 371.656525,282.155945 372.093964,280.145508 
	C372.503998,278.791626 372.936890,277.869781 374.096832,277.072937 
	C375.130249,277.003021 375.782043,277.009521 376.759583,277.026428 
	C379.912750,277.617096 382.696167,277.493958 385.692993,276.268494 
	C386.134155,276.016968 386.308472,276.012451 386.744324,276.004761 
	C387.332825,276.362488 387.692352,276.348419 388.029175,275.785980 
	C387.965424,275.241058 387.958801,275.004028 387.972382,274.588806 
	C388.185516,273.998230 388.092438,273.707764 387.403778,273.750183 
	C386.214203,273.770355 384.814117,273.665070 385.870728,272.275299 
	C386.755707,271.111298 387.041870,269.968109 387.006042,268.243103 
	C388.348175,266.663147 390.090179,265.989838 391.525696,264.359741 
	C392.745453,263.605408 392.983521,262.712921 393.007019,261.342255 
	C393.602081,260.469482 394.362213,260.525543 395.399719,260.290741 
	C395.976959,260.259735 396.206085,260.290253 396.749512,260.453766 
	C398.286591,262.774231 400.263702,262.122284 402.438416,261.953979 
	C403.320190,262.037140 403.814850,262.399384 404.402374,262.344177 
	C403.798401,262.136719 403.318359,261.773804 402.910522,260.899689 
	C404.239563,259.171997 404.898499,257.361786 405.743347,255.280502 
	C406.719513,255.017960 407.482178,255.011749 408.626221,255.006821 
	C410.050842,256.459442 411.613922,256.591125 413.526703,256.656342 
	C414.890564,256.303253 417.852783,257.282135 415.171631,254.228668 
	C414.687744,252.951035 414.380219,251.930527 414.086731,250.505966 
	C414.230927,248.639099 418.159790,250.141953 416.349823,246.848755 
	C417.932373,246.348007 419.542328,246.184448 421.640076,246.042603 
	C423.779175,248.337891 425.327545,247.353760 427.181213,245.949432 
	C427.500946,245.984177 427.599182,245.957123 427.650116,245.957001 
	C427.855713,246.065063 428.010376,246.173248 428.399414,246.440674 
	C429.362610,246.943573 430.137909,246.771942 431.193207,246.792755 
	C432.509338,246.778580 433.531616,246.674927 434.845642,246.954346 
	C435.916321,247.005112 436.679871,247.018570 437.824585,247.055832 
	C440.909729,247.135986 443.674316,245.834702 446.644073,247.691849 
	C446.981934,248.409271 446.984985,248.875824 446.984619,249.692276 
	C444.912079,251.952484 441.889526,250.118347 439.749420,251.737350 
	C441.678619,250.395615 443.848022,251.157089 446.281616,251.239853 
	C446.702454,251.644180 446.763306,251.938461 446.885986,252.679260 
	C446.195831,253.748184 445.320190,254.072479 444.018372,254.234619 
	C443.445557,254.282593 443.216492,254.294006 442.645935,254.316345 
	C441.220215,254.392517 440.066437,254.297852 439.421631,255.857376 
	C439.261780,256.581451 439.176422,256.996002 439.029053,257.722107 
	C438.772797,258.865082 438.493439,259.673828 438.238525,260.830383 
	C438.060425,261.587097 437.915588,262.008881 437.556458,262.709198 
	C437.193085,263.137512 437.010468,263.275818 436.492798,263.496124 
	C433.777130,262.741028 431.899048,260.038239 428.543884,261.714020 
	C428.002441,261.873871 427.785461,261.934540 427.242310,262.076111 
	C425.784424,262.556091 423.998718,262.398926 424.363159,264.297272 
	C424.632843,265.701752 426.053955,265.561768 427.175995,265.527039 
	C428.814941,265.476379 430.407654,265.539551 431.906738,266.938599 
	C432.040588,267.927063 432.028137,268.613739 432.009064,269.643799 
	C430.533752,270.138062 429.177063,270.656158 427.579071,271.300171 
	C427.032196,271.356842 426.798004,271.265778 426.610687,271.072418 
	C426.522552,271.340424 426.665985,271.448059 427.329376,271.404541 
	C428.868103,271.117920 429.950470,270.069427 431.655762,270.776367 
	C433.091705,271.722504 433.474457,272.954254 433.972900,274.463379 
	C433.248352,276.993896 431.062988,276.923798 429.511414,277.619568 
	C431.322052,277.329285 432.987762,276.210419 435.220642,275.581177 
	C436.558563,275.185425 437.539429,274.979004 438.757019,275.834412 
	C439.005707,276.553436 439.000641,276.982422 438.998169,277.733215 
	C437.033142,280.584869 433.824066,279.490662 431.324554,280.646149 
	C429.109772,281.670013 426.730072,282.393188 424.268311,283.813812 
	C423.978973,284.054596 423.980469,284.011932 423.974060,284.035950 
	C423.520477,284.452179 422.927521,284.471069 422.185852,284.849274 
	C421.966736,285.028351 421.980286,284.971893 422.009155,284.974915 
	C421.871979,285.097626 421.705872,285.217255 421.281128,285.171387 
	C419.945709,285.003601 418.868896,285.001404 417.388275,285.002502 
	C415.729584,286.092133 414.006409,285.843567 412.598999,286.530792 
	C413.533264,286.199097 414.454224,285.910706 415.674896,286.631958 
	C416.271729,287.631836 416.601349,288.425659 416.973267,289.539917 
	C415.968414,291.334229 414.405273,290.988953 412.963898,290.967041 
	C408.043427,290.892181 403.489960,291.913788 399.978882,295.130554 
	C402.360596,293.893860 404.969574,292.240784 408.514832,293.341217 
	C409.299988,295.393738 407.249512,296.160339 406.900360,298.099182 
	C398.281250,299.194397 392.145996,303.908081 386.986206,310.303436 
	C385.929688,311.612915 384.367004,312.997314 385.228058,314.640533 
	C387.713379,319.383575 383.991913,321.213135 381.354889,323.509644 
	C380.125702,324.580139 378.673737,325.454041 376.776154,326.156128 
	C374.535797,327.537506 372.880005,329.267334 370.110229,329.661499 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M146.948303,536.223755 
	C154.882782,522.410889 165.998505,513.345947 181.011719,508.579041 
	C189.804443,505.787292 198.062378,501.311188 206.805450,497.348511 
	C207.452835,496.524933 207.878479,495.967407 208.818146,495.437378 
	C209.372833,495.218170 209.604599,495.154266 210.196945,495.053772 
	C211.296570,495.030640 211.989380,495.207153 212.858643,495.868347 
	C213.562164,498.665985 211.755737,499.643066 210.004944,500.662537 
	C208.415237,501.588196 206.627487,502.063873 204.986969,502.864197 
	C199.723938,505.431763 198.943573,509.103943 202.788696,514.359985 
	C203.855347,516.903015 202.088409,517.956482 200.746216,519.012512 
	C195.047058,523.496582 190.421860,529.059265 185.055573,534.335876 
	C184.270950,534.875549 183.720993,535.178528 183.027344,535.798584 
	C182.682144,536.169006 182.547379,536.321716 182.206635,536.706055 
	C181.853928,537.088745 181.707199,537.239990 181.048157,537.789368 
	C180.137817,538.396484 179.716782,538.540344 178.932373,538.645386 
	C177.630325,538.546204 176.799240,538.148804 175.838623,537.268433 
	C175.326279,536.238647 175.316986,535.474182 175.664474,534.814636 
	C166.505005,541.393433 161.094650,550.401489 158.411301,561.590759 
	C156.634720,565.168335 157.684570,568.629822 157.412872,572.412231 
	C155.964417,587.174438 155.496277,601.482178 158.132156,615.757385 
	C158.571213,618.135315 158.981995,620.724609 156.539215,622.804077 
	C154.937805,616.045288 151.731888,609.945007 150.008987,603.382385 
	C149.545975,601.618774 149.209656,599.821960 148.809830,597.646362 
	C146.408203,589.783447 146.318832,582.075989 146.442291,573.949463 
	C146.729416,571.422791 146.146667,569.025024 147.175095,567.192017 
	C149.197906,563.586670 146.775192,563.036072 144.014496,562.111938 
	C143.495132,561.813354 143.300552,561.669556 142.894699,561.228394 
	C142.564362,560.453064 142.537552,559.970032 142.815216,559.182373 
	C146.487595,556.089111 146.769485,552.075134 146.958023,548.132751 
	C147.139679,544.333862 146.980591,540.518799 146.948303,536.223755 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M283.204773,726.611694 
	C280.311005,724.943115 277.359344,725.831848 274.565460,725.927612 
	C266.020111,726.220520 257.395691,725.009827 248.940582,726.986816 
	C243.279160,728.310608 241.159164,730.948914 241.001190,736.601807 
	C237.817398,731.684082 233.553711,727.931824 227.153473,726.975647 
	C215.887390,725.292480 210.664520,730.864502 212.914871,742.622925 
	C213.220184,748.902649 213.870056,754.741516 216.016113,760.255066 
	C216.768890,762.188904 216.895767,764.123291 217.057968,766.082336 
	C217.169281,767.427124 216.844467,768.849915 215.358734,769.383362 
	C213.862747,769.920532 212.828568,769.326355 212.325424,767.744568 
	C211.707336,765.801331 211.314224,767.893005 211.199188,767.973511 
	C208.432678,769.907349 205.563812,770.822327 202.296890,769.295410 
	C201.692520,769.012878 200.974045,768.594177 200.401260,768.760498 
	C194.871399,770.366394 191.940689,767.472717 189.654022,762.615662 
	C186.046707,756.460754 186.542664,749.631714 184.783051,743.344971 
	C184.344452,741.777832 184.002350,740.159180 183.441589,738.202637 
	C182.878601,736.592346 182.779129,735.277100 182.293274,733.648071 
	C182.090683,733.019287 182.019394,732.763306 181.869125,732.114136 
	C182.286942,726.050720 179.797729,720.628723 180.641418,714.627869 
	C197.216980,716.989136 213.518173,719.869324 229.885956,722.301208 
	C246.560684,724.778687 263.309204,724.496094 280.037445,722.549194 
	C282.337799,722.281433 284.644836,722.070923 287.387085,721.851746 
	C289.652924,726.149719 289.208130,727.269165 284.775146,728.661499 
	C283.823853,727.887024 284.587585,726.665771 283.204773,726.611694 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M389.155426,686.390137 
	C389.867584,682.048279 386.068390,679.607788 385.874084,675.631653 
	C385.979828,674.399841 386.121094,673.564819 387.346313,673.071045 
	C389.862854,673.701599 390.320068,675.831482 391.212708,677.539307 
	C396.707825,688.052551 400.317871,699.308594 404.062225,710.508240 
	C406.235626,717.009094 406.216034,717.007385 412.515808,714.954834 
	C415.517853,713.976746 418.553986,713.112793 421.539001,712.071167 
	C426.622894,710.297180 426.767792,710.037048 424.811707,705.016479 
	C424.262024,703.605591 423.489990,702.338074 422.566406,700.718262 
	C422.280121,700.167847 422.177002,699.939880 421.947021,699.355835 
	C421.256805,695.892700 419.122559,693.491394 418.053802,690.616089 
	C417.436218,688.954529 416.764923,687.267273 417.586426,685.099426 
	C418.415253,684.264648 419.142792,684.052612 420.305267,684.052307 
	C423.270264,684.826050 423.996735,687.189941 424.998810,689.225830 
	C427.412537,694.129761 429.356110,699.255798 431.985321,704.062317 
	C433.204315,706.290771 434.564880,708.051392 437.760468,706.342651 
	C439.645264,705.673218 441.293152,705.591614 442.903839,705.341125 
	C446.362854,704.803345 448.683472,703.252747 448.954102,699.190674 
	C450.490234,699.046082 451.455627,699.735168 452.125244,700.672302 
	C454.209747,703.589600 456.372620,702.996460 459.005219,700.900024 
	C460.207611,699.564941 461.524567,699.124512 463.225220,698.668823 
	C464.000275,698.395752 464.439209,698.218811 465.208679,697.885132 
	C473.264343,694.670654 481.683960,693.849670 489.623840,690.203186 
	C494.081665,688.566956 498.426910,688.113464 503.005066,687.039673 
	C507.484222,686.489868 506.476654,683.785156 505.574951,681.450378 
	C502.283661,672.928284 499.014587,664.393799 495.479309,655.970215 
	C493.036835,650.150574 490.613434,644.319397 487.931061,638.598633 
	C486.690948,635.953796 485.626831,636.200806 484.048157,638.655273 
	C482.973145,639.831787 481.912201,640.344116 480.359009,640.629700 
	C479.766296,640.596680 479.532623,640.543579 479.000000,640.291870 
	C478.574799,639.890686 478.448517,639.688049 478.217346,639.145447 
	C478.088562,638.571228 478.064697,638.337097 478.067505,637.752869 
	C478.711426,635.081604 480.629547,633.662048 482.177246,631.574341 
	C483.733124,630.056763 484.661194,628.512024 485.712524,626.623291 
	C489.605225,623.591614 490.427124,620.226562 488.940369,615.802429 
	C487.808167,612.433289 485.950348,608.993347 487.627197,604.888916 
	C488.572723,604.163635 489.334595,603.994141 490.543365,604.036865 
	C491.200714,604.181335 491.455048,604.274231 492.040222,604.602051 
	C494.851654,610.124512 496.270294,615.714783 497.040710,621.849976 
	C496.825867,622.712097 496.626343,623.169373 496.166687,623.894287 
	C494.777130,625.515686 493.561523,626.824585 492.746979,628.825439 
	C491.906342,630.157410 491.977753,631.214966 492.609802,632.599854 
	C493.060852,633.734436 493.292023,634.591187 493.800293,635.700317 
	C494.761139,637.880737 495.709534,639.696228 496.761719,641.846680 
	C502.275482,654.478516 506.740997,667.167664 512.257202,679.420837 
	C513.001648,681.074402 513.177368,683.539490 516.287109,683.420532 
	C518.819885,683.441772 521.094543,684.937988 523.451538,682.801147 
	C524.146545,682.437134 524.572632,682.313416 525.342773,682.248657 
	C527.005493,682.524841 528.184448,682.002502 529.715454,681.454041 
	C540.597778,679.232300 551.218445,677.611816 561.915222,676.492737 
	C563.503174,676.326599 564.610107,675.267151 566.259705,674.385498 
	C567.123047,674.072937 567.638428,673.965820 568.560547,673.865112 
	C575.167786,672.274048 581.645081,672.733582 587.886963,671.206543 
	C591.050964,670.432495 593.590881,671.401428 592.411499,675.947510 
	C591.078979,677.168823 589.754456,677.384460 588.416748,677.384399 
	C572.084412,677.384155 556.403687,681.839661 540.733521,685.367371 
	C512.979004,691.615540 485.003937,697.286072 458.146362,707.024353 
	C441.556305,713.039795 424.509552,717.653748 407.529297,723.747803 
	C406.419891,724.155029 405.653046,724.323181 404.560486,724.726562 
	C403.013458,725.268616 401.797485,725.597412 400.268860,726.189209 
	C375.787598,733.998840 352.156464,742.973206 329.043671,753.309143 
	C328.574036,753.519226 328.085175,753.530457 327.289673,753.186890 
	C326.671509,751.974060 326.352142,751.002686 325.922821,749.660156 
	C347.088745,738.520874 369.430603,730.414490 392.061188,723.103577 
	C402.604736,719.697510 402.707123,720.016235 398.754974,709.449158 
	C396.077820,702.291260 393.402405,695.132690 390.414124,687.769836 
	C390.102051,687.565247 389.685394,687.501709 389.544678,687.343018 
	C389.403992,687.184387 389.208466,686.806213 389.155426,686.390137 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M553.224609,299.474182 
	C552.646790,300.144775 552.051819,300.513062 551.206482,300.965637 
	C550.281189,302.329773 549.538391,303.515442 547.399780,303.179321 
	C533.764404,293.375702 535.818787,297.567444 535.604736,281.592438 
	C535.536072,276.463196 536.148193,271.417175 537.715698,266.140869 
	C541.292542,271.979126 547.003296,270.473053 552.306152,270.486938 
	C561.292114,270.510468 570.245850,269.455475 579.227051,269.679596 
	C586.365051,269.857697 593.481201,270.876923 600.639465,269.722015 
	C602.494141,269.422791 604.233093,270.308044 605.570740,272.385315 
	C606.876709,280.338531 606.709900,287.865692 604.776855,295.697205 
	C598.334534,299.967468 591.745605,297.191193 585.303528,297.238953 
	C576.373169,297.305115 567.290955,294.643158 558.266479,298.855591 
	C556.955505,299.266113 555.926819,299.377319 554.508423,299.491516 
	C553.890869,299.172546 553.894531,298.196442 553.224609,299.474182 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M393.681580,569.122559 
	C394.015045,575.752869 390.642548,581.532227 387.724731,587.159851 
	C377.304901,607.256958 363.661102,624.983643 346.603943,639.976318 
	C344.880432,641.491272 343.028412,642.880798 340.228394,643.813171 
	C343.921478,629.038574 347.140320,614.572937 348.427368,599.690552 
	C346.819733,604.642883 345.212067,609.595154 343.330780,614.781189 
	C341.062073,615.632019 341.341675,619.409058 339.222961,618.749451 
	C337.034149,618.068115 337.587006,615.090332 337.275604,613.055786 
	C336.780060,609.818176 336.615112,606.544678 337.324402,602.885681 
	C339.017212,600.256042 338.544342,597.698242 338.570465,595.243225 
	C338.632172,589.436768 338.506226,583.627930 338.639740,577.823120 
	C338.682404,575.968140 338.198700,573.680115 341.273682,573.081665 
	C341.891479,573.335266 342.118469,573.469788 342.653809,573.837158 
	C344.757080,575.719971 344.813782,578.477905 346.997070,580.283203 
	C347.496521,580.908142 347.715790,581.305115 348.016754,582.033569 
	C348.346069,583.212158 348.801880,583.952942 349.512756,584.944214 
	C349.779358,585.447205 349.869476,585.659119 350.058899,586.205078 
	C350.408325,588.391479 351.140686,590.199158 350.490906,592.406616 
	C349.120483,593.773926 349.606934,595.069336 349.516449,595.842651 
	C349.225708,595.390503 349.557587,594.403442 349.906372,593.155273 
	C351.603546,591.604797 353.496246,591.216858 355.610657,590.507812 
	C356.846008,590.613586 357.444672,591.103516 357.766022,591.935547 
	C357.875153,591.226440 357.251404,590.778320 357.124359,590.165588 
	C355.831299,583.928894 355.162476,577.533264 352.244934,571.333069 
	C352.035004,570.743896 351.961700,570.500000 351.809662,569.874023 
	C351.737305,567.352295 350.933380,565.313354 350.854645,563.211365 
	C350.787750,561.425293 350.256195,559.066284 353.675598,559.186279 
	C357.337097,565.630432 359.541870,572.379517 362.796967,579.057495 
	C364.058014,585.414673 367.878479,589.473389 372.544556,593.091736 
	C370.536591,591.179443 367.739899,590.099121 367.703064,586.478882 
	C368.580566,585.578125 369.376312,585.704956 370.181976,585.923584 
	C379.898499,588.560852 382.516907,587.433777 387.511017,578.162659 
	C387.608215,577.609558 387.638824,577.387146 387.660828,576.827942 
	C389.569519,574.086548 391.486816,571.681946 393.681580,569.122559 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M338.342346,602.490601 
	C338.417450,607.864563 338.747498,612.859497 339.095062,618.119690 
	C340.448151,617.105164 340.026428,614.583618 342.687469,615.023071 
	C341.654480,619.740723 339.988739,624.362671 337.366150,628.935120 
	C336.725037,628.809631 336.394714,628.446777 336.263977,627.949402 
	C335.956085,626.778076 336.390472,625.691101 336.649139,624.584290 
	C336.135559,625.327454 336.072052,626.546936 334.766754,626.466980 
	C332.416992,626.323059 331.159210,625.065430 331.050842,622.700256 
	C330.929932,620.061462 331.082031,617.418335 330.885986,614.373230 
	C329.011414,606.972839 330.708313,599.584290 328.697693,591.829956 
	C326.296631,595.091309 326.865723,598.491943 325.341156,601.602051 
	C324.953064,605.357544 324.538086,608.616333 320.009521,609.063354 
	C319.265015,608.161377 319.077606,607.437134 319.219421,606.266785 
	C320.385437,601.869324 319.866089,597.810852 319.532959,593.344727 
	C317.457184,584.411438 317.211578,575.619446 315.604675,567.042114 
	C313.378387,555.158875 309.998444,543.614868 304.457703,532.364014 
	C304.216278,531.752991 304.141785,531.502136 304.013855,530.866089 
	C304.560150,525.406433 309.045746,522.632446 311.347961,518.126343 
	C312.163605,517.289124 312.826355,516.896423 313.930450,516.514282 
	C314.558624,516.416260 314.812042,516.414612 315.424683,516.519226 
	C318.632477,518.691711 318.582703,522.038208 319.383820,524.971191 
	C320.722961,529.874390 321.359741,534.916504 322.003174,539.949768 
	C322.044281,540.271179 321.936523,540.873535 322.005280,540.889648 
	C322.699219,541.052307 322.409302,540.169495 323.164276,539.827759 
	C325.284515,539.240479 325.919067,540.888000 327.319000,541.917419 
	C331.065216,546.820801 335.234039,551.078796 336.763000,557.400146 
	C339.133667,565.328979 339.057312,573.105713 338.967041,580.859680 
	C338.884613,587.943481 339.472321,595.041748 338.342346,602.490601 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M200.030075,844.613770 
	C205.631287,858.990417 209.220230,873.842590 217.847504,886.514526 
	C220.459045,890.350342 223.342560,894.001038 226.346619,897.950317 
	C226.804321,898.227295 227.016968,898.290344 227.141891,898.674194 
	C227.062195,899.217957 227.070221,899.440735 227.092651,899.997559 
	C225.178131,901.591309 222.973404,901.706726 220.894196,901.250366 
	C209.176132,898.678711 197.226593,897.088989 185.492981,892.873840 
	C184.274963,891.859985 184.053574,890.864441 184.319717,889.395264 
	C186.158722,886.333740 188.801117,884.472900 191.125000,881.887024 
	C191.624619,881.384155 191.903900,881.103149 192.377350,880.629028 
	C192.816681,880.188171 193.052231,879.931763 193.353851,879.432861 
	C193.434448,879.203613 193.881027,879.026978 193.645874,879.069458 
	C193.364594,879.452209 193.213455,879.742065 192.802002,880.190918 
	C192.345795,880.648132 192.077271,880.913208 191.594879,881.394958 
	C189.379639,883.598572 187.376633,885.583923 185.165939,887.848145 
	C184.130066,889.017395 184.106491,890.345886 182.955597,891.454163 
	C177.548874,892.832703 173.405655,889.522949 168.796295,888.477173 
	C165.857651,887.810486 167.165344,884.528137 168.111145,882.470764 
	C170.476044,877.326538 173.611298,872.599243 176.641983,867.834595 
	C181.730804,859.834412 186.273270,851.515991 191.144974,843.390625 
	C191.742462,842.394043 192.381943,841.416260 193.094833,840.494080 
	C195.855896,836.923035 196.683365,836.990356 198.883453,840.964722 
	C199.448425,841.985291 199.999847,843.015198 200.030075,844.613770 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M335.808716,556.718140 
	C335.315399,556.924988 334.913330,556.824341 334.782440,556.578979 
	C333.075287,553.380005 333.593445,548.915833 329.042419,547.264343 
	C328.154236,546.942078 327.951843,544.729980 327.144775,543.185059 
	C323.160950,536.605408 323.421539,529.239563 321.863251,522.344421 
	C320.819580,517.726379 318.624176,513.215210 319.560852,507.886780 
	C319.731293,507.293091 319.809540,507.063293 320.051483,506.518402 
	C321.117096,504.975220 322.348419,503.978851 322.973877,502.166687 
	C323.306580,501.479980 323.548248,501.117493 324.061401,500.546997 
	C324.466675,500.174805 324.638245,500.035767 325.080933,499.702026 
	C325.538361,499.381897 325.724640,499.256470 326.196289,498.948242 
	C329.840424,496.606262 331.965118,493.199646 335.050598,490.258484 
	C335.475189,489.843781 335.661591,489.694153 336.172119,489.388092 
	C337.438690,488.925964 338.380463,488.943176 339.634521,489.400940 
	C340.281219,489.898468 340.529846,490.285522 340.744873,491.071777 
	C340.862396,492.577332 341.368042,493.598816 341.981018,494.977783 
	C343.083557,506.512360 345.272095,517.486755 347.898315,528.776184 
	C348.294281,531.398010 349.204285,533.457764 350.074829,535.903564 
	C350.538422,537.824951 351.319977,539.242188 352.008484,541.050720 
	C352.350800,542.904785 353.433289,544.048523 354.104980,545.735535 
	C354.377716,546.425232 354.557709,546.806763 354.786865,547.502075 
	C354.545258,548.897278 353.656708,549.559509 352.821472,550.637817 
	C351.753815,551.695557 350.761383,552.452026 351.152008,554.219604 
	C351.257294,559.668579 351.239258,564.785400 352.809113,570.127808 
	C352.934601,570.495361 352.989563,570.500000 352.965454,570.498169 
	C354.017883,574.495483 355.035339,578.505188 354.980774,583.118713 
	C353.774109,585.618652 352.149719,586.738708 349.344604,586.253967 
	C348.952484,586.031738 348.894165,585.592651 348.884399,585.371399 
	C348.492157,584.494934 347.954132,583.965088 347.290039,583.174744 
	C347.069855,582.536194 347.021973,582.120789 346.956299,581.392334 
	C345.354614,579.482056 345.610657,576.808167 343.435913,575.175293 
	C343.234100,574.911987 342.872070,574.879028 342.702881,574.945496 
	C339.067047,569.717896 338.919800,563.467224 337.557068,557.575134 
	C336.476410,552.902649 335.577972,548.186646 334.707275,543.067993 
	C333.482727,540.374207 332.442749,538.036560 332.409973,536.277100 
	C332.029816,534.791077 331.355560,535.764465 331.926270,535.419861 
	C332.855621,537.607544 332.930817,540.103577 334.466064,542.504272 
	C335.061005,547.376526 337.324432,551.669617 335.808716,556.718140 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M558.300903,299.325775 
	C559.045837,295.683655 561.782898,294.692566 564.913147,295.051971 
	C572.660278,295.941498 580.418152,294.669617 588.281006,296.173615 
	C592.856506,297.048828 598.249329,297.891693 603.595215,296.013550 
	C604.601929,296.510986 604.801819,297.181915 604.878662,298.269653 
	C604.827881,299.583466 604.798767,300.537842 605.095215,301.851990 
	C606.095154,310.472778 604.418030,318.622955 604.283203,326.825378 
	C604.238037,329.576416 604.884521,332.310791 603.908875,335.044403 
	C603.046326,337.461029 601.773010,339.291290 598.901428,338.855103 
	C595.416077,338.325714 592.133545,340.895386 588.269592,339.233795 
	C578.525085,338.298584 573.364868,331.323669 567.451050,325.338806 
	C565.399353,323.262482 567.066223,322.170105 567.872864,320.691467 
	C572.913696,311.451752 568.849487,302.146576 558.300903,299.325775 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M504.507996,222.298370 
	C505.551666,222.076248 506.338531,222.040894 507.519348,222.000824 
	C509.930115,223.373566 510.342499,225.546417 510.414215,227.693741 
	C510.817841,239.780960 512.231262,251.801743 512.651550,263.891418 
	C512.916077,271.501068 513.762878,279.089844 513.800171,287.177399 
	C513.654419,287.931305 513.551636,288.223389 513.120789,288.844147 
	C511.539032,289.120911 510.285370,289.068970 508.654724,289.025940 
	C507.614471,289.002960 506.952087,288.962738 505.991516,288.708679 
	C504.125000,287.472107 502.407318,287.643280 500.343231,287.976074 
	C498.457855,288.065216 497.968719,286.832489 497.183167,285.513977 
	C496.270386,284.232483 495.203491,283.505371 494.222137,282.266296 
	C493.988129,282.054321 494.010773,282.003906 494.008301,282.032043 
	C491.714691,280.166382 490.427368,277.343658 488.051880,275.547241 
	C486.341553,274.253815 484.502380,273.152710 481.863220,273.814392 
	C480.908936,274.213867 480.258789,274.443268 479.233154,274.610657 
	C475.752899,273.724518 473.674805,270.771454 470.028564,270.114868 
	C469.287842,269.802826 468.893524,269.571930 468.144104,268.739960 
	C467.579163,267.644196 467.396667,267.103394 467.091248,266.299988 
	C467.259064,265.655914 467.619598,265.362366 468.400482,265.074951 
	C469.199890,264.913727 469.662048,264.886536 470.460144,264.924316 
	C471.007751,264.983124 471.221771,265.017456 471.744934,265.120300 
	C472.973724,265.363892 473.951630,265.880035 474.783295,264.472900 
	C475.109100,263.823395 475.329407,263.465240 475.798096,262.879456 
	C477.361023,261.738678 478.775238,261.154724 480.701538,261.745544 
	C481.524597,262.627075 481.439117,263.485718 481.597656,264.587860 
	C481.696014,265.067596 481.743774,265.256989 481.906860,265.712524 
	C482.454254,266.728027 483.236572,266.985748 484.238403,267.496704 
	C486.680511,268.924805 488.240967,268.706757 488.887329,265.632660 
	C489.099365,264.863922 489.309021,264.469055 489.902435,263.972168 
	C491.429962,264.238403 492.668152,264.625702 494.333527,264.449341 
	C494.878693,264.563202 495.090118,264.642975 495.567078,264.937073 
	C496.756226,266.098541 496.517181,267.187744 496.215515,268.284576 
	C498.260284,267.301270 500.320404,267.959839 502.381104,268.200867 
	C502.480927,268.212555 502.377167,267.918915 502.013641,267.800079 
	C505.299347,262.805908 505.145203,262.033722 500.899597,262.332184 
	C499.461609,262.433289 497.968262,263.141632 496.743042,261.777313 
	C495.238007,260.101532 496.397644,262.519470 495.704773,262.649384 
	C495.224182,263.312195 494.850342,263.588440 494.087891,263.897156 
	C493.072540,264.213379 492.385345,264.341064 491.338013,264.113129 
	C490.382996,263.629333 489.642792,263.639984 488.737610,263.116882 
	C487.981598,261.983582 487.930298,261.033630 488.089233,259.707947 
	C488.343201,258.675201 488.636505,258.034882 489.056824,257.077881 
	C490.464172,254.099060 489.188660,251.536758 488.780365,248.973770 
	C488.380157,246.461670 488.534637,244.020950 489.023682,241.231110 
	C489.206268,240.705124 489.302643,240.504471 489.626587,240.062958 
	C490.725037,239.537628 491.549042,240.001266 492.714539,239.986496 
	C494.044830,240.067413 494.987213,239.649033 496.218323,239.529068 
	C496.460114,239.524216 496.860229,239.686371 496.963684,239.501801 
	C495.748688,239.595337 494.427917,239.858978 492.728119,239.954376 
	C491.632233,239.886551 490.916046,239.655258 489.793945,239.735611 
	C486.973358,240.632050 484.518250,240.529999 481.691681,239.792816 
	C480.888580,239.296539 480.601013,238.879105 480.488220,237.983719 
	C481.353607,235.875427 482.833588,236.637222 485.223511,236.626572 
	C483.226257,236.442352 482.264832,236.541122 481.032654,236.214264 
	C480.507416,235.610092 480.418701,235.153763 480.559570,234.329086 
	C481.535706,232.992645 482.752136,232.748138 484.271149,232.309021 
	C485.785400,232.043518 486.919647,231.699631 488.430908,231.542145 
	C489.882446,231.551270 490.988129,231.630157 492.380493,231.666779 
	C492.913788,231.476791 493.488495,231.962296 493.475800,231.332642 
	C493.462433,230.670975 493.709564,231.582840 492.816162,231.319931 
	C491.459076,231.361984 490.388153,231.462387 488.965820,231.455658 
	C487.659729,231.419266 486.769684,231.777130 485.492126,231.974915 
	C482.969818,232.688065 480.280487,231.753815 478.357300,234.314224 
	C477.380920,234.819809 476.675262,234.909760 475.608643,234.685211 
	C472.389740,232.724503 472.389740,232.724503 467.485413,232.708069 
	C469.857788,233.106857 471.860474,232.526138 473.949188,233.643173 
	C474.281006,234.111160 474.349243,234.340652 474.273010,234.901978 
	C472.490631,236.576279 470.433411,236.146118 468.231476,236.654831 
	C467.665131,236.842667 467.440247,236.923508 466.878235,237.128082 
	C466.089966,237.418793 465.635712,237.576843 464.829010,237.828491 
	C463.275513,238.204712 462.072388,238.206543 460.531372,237.799515 
	C458.857666,236.708984 457.297791,236.259567 455.448242,235.600677 
	C455.013214,235.222198 454.877960,235.029602 454.840790,234.497925 
	C454.938873,234.158813 454.950684,233.696564 454.953644,233.465363 
	C456.128662,231.694443 458.033264,233.175629 459.409119,232.158234 
	C459.990204,232.047119 458.988403,231.339447 459.333618,231.909744 
	C459.494049,232.174698 459.416840,232.301697 459.114655,232.358459 
	C457.812653,232.602921 456.513245,232.504242 454.873993,232.159729 
	C454.355438,231.226776 454.175781,230.488403 453.993103,229.457886 
	C455.133331,227.319336 457.189087,228.184036 458.927338,227.341217 
	C459.483429,225.900330 460.189606,224.962982 461.618652,224.244690 
	C462.431458,224.305634 462.999573,224.550278 463.859558,224.900650 
	C467.924652,224.736572 471.748871,225.567841 475.774872,224.235855 
	C476.565948,224.012466 477.066406,224.034531 477.940857,224.093063 
	C481.252167,223.438217 484.469727,224.524139 487.433960,222.460999 
	C489.308044,222.197601 490.980316,222.196777 493.142822,222.310486 
	C495.737183,223.368164 497.854218,224.037247 500.310638,222.488876 
	C501.126465,222.185028 501.696045,222.120178 502.695923,222.056610 
	C503.436371,222.371109 503.808014,222.522339 504.507996,222.298370 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M398.141510,745.535828 
	C388.781799,752.666748 383.403839,762.764099 376.035461,771.620117 
	C372.147827,770.716003 373.488342,768.555908 374.668701,766.246216 
	C376.889465,761.900696 380.708893,758.312561 380.993347,752.673462 
	C381.172272,750.805969 381.901276,749.542236 382.912964,748.025146 
	C385.844940,744.731018 389.031677,742.165161 391.712341,738.656494 
	C392.018616,738.179565 392.150818,737.994263 392.507050,737.549683 
	C392.899170,737.135071 393.067291,736.979675 393.513672,736.622314 
	C393.989990,736.305420 394.188110,736.190552 394.690613,735.919678 
	C397.655029,733.928162 399.596008,731.442566 401.450623,728.431519 
	C401.711548,727.898682 401.844849,727.697998 402.250366,727.253784 
	C408.558838,724.904480 414.826111,723.558655 421.201172,721.313232 
	C422.452423,720.880737 423.399780,720.701538 424.624084,720.225952 
	C427.605377,719.334351 430.177490,718.284973 433.250732,717.805542 
	C434.001312,717.689880 434.424805,717.618958 435.148193,717.450928 
	C435.646271,717.288025 435.843231,717.215332 436.332275,717.021484 
	C437.018768,716.730103 437.415680,716.565918 438.125000,716.288147 
	C438.867310,716.036316 439.304169,715.921692 440.089447,715.750977 
	C440.668671,715.637451 440.904022,715.597534 441.491150,715.466553 
	C449.170288,713.458191 456.309174,710.742126 464.295013,710.313354 
	C466.144531,712.325012 464.447723,713.146118 463.365173,713.975098 
	C461.661621,715.279724 460.000580,716.675110 457.721710,717.729614 
	C456.820374,718.077209 456.212616,718.250000 455.387146,718.646301 
	C454.991211,718.911194 454.835876,719.017761 454.448181,719.278198 
	C453.902771,719.616638 453.584442,719.791626 453.028992,720.083618 
	C452.642822,720.292603 452.487976,720.374146 452.099976,720.572144 
	C451.554871,720.844055 451.248871,721.010437 450.735992,721.351868 
	C450.387146,721.639282 450.251160,721.762695 449.916351,722.088379 
	C449.585632,722.436829 449.453735,722.582947 448.909729,723.198486 
	C443.354004,729.758423 435.890167,733.332947 430.858276,740.040283 
	C428.323364,742.856995 426.177399,745.596924 422.802185,747.435303 
	C421.801392,746.064270 421.262268,746.189941 420.656952,747.923096 
	C420.319977,748.378601 420.161163,748.545349 419.714294,748.908203 
	C413.189606,756.228821 406.612457,763.043091 400.293518,770.093079 
	C399.246979,771.260681 398.193848,773.209595 396.267303,772.138000 
	C394.338196,771.065125 394.832611,768.951904 395.216766,767.166748 
	C395.985077,763.596436 397.452972,760.212463 398.113342,756.252930 
	C400.953461,748.685608 406.124268,743.059937 411.096832,736.915039 
	C411.754883,736.248169 412.213715,735.832825 412.505188,734.968994 
	C412.271820,734.252441 413.427460,734.486023 412.815369,734.185181 
	C412.453308,734.917175 412.403870,735.499451 411.824219,736.151184 
	C410.401123,737.479553 409.399780,738.859985 407.482605,739.594482 
	C403.740692,740.793457 401.672577,743.987854 398.141510,745.535828 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M77.970970,989.578308 
	C76.060593,990.060364 74.088936,990.186157 72.119347,990.159485 
	C64.108643,990.050903 64.123001,990.029480 61.812263,982.092468 
	C61.540024,981.157349 61.009312,980.297424 60.306442,979.187317 
	C51.611988,976.341797 42.735893,977.054138 33.810692,975.205200 
	C32.363937,974.741028 31.373764,974.282471 30.336218,973.144775 
	C27.467503,970.990662 25.243036,960.393005 27.359619,958.536682 
	C29.197815,956.924438 31.817162,957.998718 34.072746,957.717163 
	C34.687939,957.640442 35.560883,957.636536 34.475487,956.818726 
	C34.222397,956.628052 33.855534,956.588379 33.273178,956.337646 
	C31.825142,953.062927 34.292465,952.869324 36.125248,952.708191 
	C45.847824,951.853394 55.531834,952.095459 65.517334,954.439697 
	C69.503441,956.278625 73.306213,955.327087 77.001450,955.574646 
	C78.931755,955.703918 80.915665,955.275818 83.151733,956.389526 
	C76.333939,964.876282 76.904045,974.827393 77.366730,984.742432 
	C77.435555,986.217529 77.723862,987.682312 77.970970,989.578308 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M300.307678,997.250977 
	C298.929138,997.017456 297.866974,996.989563 296.406464,996.976562 
	C295.623566,996.608643 295.483185,996.150940 295.835907,995.332520 
	C308.794189,991.178223 321.504730,987.313477 334.212311,983.439087 
	C338.823059,982.033264 343.452850,980.683228 348.028503,979.170227 
	C360.415436,975.074280 372.788391,975.862244 385.328979,978.601807 
	C395.187347,980.755493 405.199158,982.206970 415.560608,984.020447 
	C416.893188,985.117188 417.055054,986.294617 416.324127,987.964600 
	C414.001862,989.778625 411.628448,989.532593 409.324921,989.577576 
	C394.429565,989.868652 379.684967,991.983521 364.869476,993.237488 
	C361.900482,993.488770 358.887939,993.226318 355.536194,994.059204 
	C353.462036,994.322937 351.821564,994.562134 349.804382,994.989380 
	C348.362152,995.236572 347.310150,995.215759 345.873413,995.094421 
	C344.204895,994.767029 342.962799,994.994080 341.340332,995.482971 
	C330.598511,997.124878 320.204376,997.917664 309.359924,997.279541 
	C306.948395,997.029724 304.913452,997.005432 302.442963,997.009155 
	C301.612671,997.395813 301.151581,997.535706 300.307678,997.250977 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M65.562332,956.362061 
	C62.271397,953.727051 58.477558,954.701660 55.244560,954.307434 
	C48.586948,953.495422 41.762623,954.041565 35.006947,954.053284 
	C34.114006,954.054810 33.443623,954.504944 33.074520,955.797180 
	C26.407587,957.213562 26.438541,957.213867 26.500351,950.401062 
	C26.559240,943.909729 26.544235,937.417786 26.626190,930.460632 
	C28.537485,928.050232 30.962669,928.740723 33.191628,928.594360 
	C37.589851,928.305542 42.032013,929.131531 46.681347,927.812927 
	C48.149902,925.447510 47.612000,922.873779 49.157692,920.530396 
	C51.691734,919.332458 53.975662,919.578247 56.669128,919.973877 
	C57.325661,920.276733 57.572670,920.429932 58.244118,920.682617 
	C58.912636,920.892395 59.064873,921.077881 59.113342,921.523682 
	C59.670959,923.036621 60.147533,924.382446 59.745384,926.249146 
	C58.657547,928.037842 56.913479,927.049438 55.044136,928.067017 
	C55.144039,928.046936 56.332626,928.411621 55.887760,927.915100 
	C57.734501,927.469055 59.582836,927.034973 61.876717,927.289307 
	C66.237030,931.187927 68.518951,936.247864 72.008675,940.406311 
	C74.872902,943.819336 77.636436,947.316895 80.624741,951.062317 
	C80.749603,951.544678 80.694351,951.741577 80.442734,952.148865 
	C79.268623,952.671326 78.880798,953.090515 80.119720,954.083130 
	C80.174606,954.606934 80.098038,954.828735 79.759331,955.308594 
	C75.071014,957.190857 70.475792,956.251831 65.562332,956.362061 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M91.854614,962.011963 
	C93.563675,962.885132 95.563629,963.527161 95.530647,966.121094 
	C95.397903,966.777588 95.471451,967.106995 95.890312,967.271545 
	C97.114296,966.789978 98.063972,965.653931 99.151207,967.027283 
	C100.105423,968.232666 99.206993,969.265686 98.816345,970.255920 
	C97.611717,973.309570 95.037888,976.021484 96.490875,980.145325 
	C99.135078,978.184204 99.581284,975.281555 101.283371,972.803955 
	C103.314064,972.079102 104.590675,974.125549 106.778473,973.650024 
	C107.934731,973.360229 108.574013,973.693054 109.272736,974.632568 
	C113.661705,976.307068 116.259850,978.269226 117.049751,983.521729 
	C118.367699,992.285767 121.234001,1000.815796 123.421371,1009.451233 
	C123.781258,1010.872009 124.331444,1012.309082 123.329781,1014.010315 
	C122.244057,1014.525330 121.474976,1014.490601 120.355621,1014.280273 
	C118.749519,1013.944458 117.477539,1013.702026 116.546616,1015.354248 
	C116.424706,1015.956421 116.261696,1016.068909 115.814095,1016.098389 
	C114.837677,1015.659790 114.189095,1015.222656 113.198166,1014.809814 
	C112.388840,1014.456665 111.927261,1014.094238 111.195320,1013.613647 
	C109.302628,1012.183289 106.677544,1014.126709 105.387680,1011.391724 
	C107.841576,1003.498901 110.518105,996.072144 113.450783,988.386780 
	C113.581772,987.757935 113.706383,987.483765 113.863106,987.225159 
	C114.022095,986.962708 114.224113,986.740540 114.478836,986.564392 
	C113.663155,986.276489 114.373314,987.391296 113.640877,987.623596 
	C111.630089,994.068726 108.714500,999.832031 107.060387,1006.043152 
	C106.640732,1007.618958 106.001251,1008.880676 103.715828,1007.980469 
	C101.332542,1000.580688 99.525467,993.421387 100.020523,985.523315 
	C99.908073,983.768250 100.765839,982.728088 101.329674,981.509094 
	C99.670967,981.857483 99.860085,983.056213 99.947220,984.562744 
	C99.334206,993.107483 101.596855,1000.863403 103.479095,1009.087219 
	C103.524597,1009.757812 103.480896,1010.028076 103.188393,1010.625122 
	C102.623642,1011.046814 102.300865,1011.243042 101.992729,1011.222351 
	C91.316208,1010.501892 93.220467,1013.360474 90.890419,1002.032593 
	C90.325935,999.288330 89.608894,996.575439 88.963409,993.450745 
	C85.605598,985.086975 85.274750,977.152344 89.232300,969.270630 
	C89.971481,967.798523 90.862267,966.389404 90.996658,964.268188 
	C91.097290,963.300049 91.272560,962.777466 91.854614,962.011963 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M206.119110,689.810974 
	C204.746048,690.930786 203.371414,693.527405 202.979919,689.289490 
	C200.751633,687.221558 200.445358,684.446716 199.325485,682.118286 
	C196.687988,676.634338 192.423767,672.211060 189.281250,666.612488 
	C187.878571,664.560852 187.276474,662.582031 186.702896,660.180176 
	C185.370102,653.436462 183.009964,647.369568 181.628387,641.043213 
	C178.575867,627.065308 176.408112,612.980835 176.536926,598.617981 
	C176.546951,597.500000 176.864288,596.286377 175.813889,595.001465 
	C171.158981,600.622498 167.172394,605.946167 169.429108,614.124573 
	C171.496246,621.615967 172.384048,629.438721 174.161072,637.450684 
	C175.535828,645.894897 177.761795,653.762695 178.935730,662.226440 
	C177.797226,664.892090 176.783829,664.029114 175.686951,662.623779 
	C174.235672,660.764221 174.265442,658.258789 172.712372,656.014587 
	C168.530396,642.197876 166.149857,628.445618 164.958099,614.089355 
	C165.048538,612.781982 165.038864,611.844666 165.743668,611.113220 
	C165.015640,611.846558 165.035828,612.801514 164.910675,614.132568 
	C164.925980,620.876953 166.573883,627.175171 164.995178,633.795593 
	C164.172272,633.840027 163.714310,633.637268 163.129623,633.210693 
	C161.931793,631.576782 161.173172,630.030090 160.827225,627.825928 
	C159.227310,623.586365 159.256256,619.551392 159.638031,615.648254 
	C160.924179,602.499512 159.476334,589.224060 161.668945,575.706787 
	C163.741852,569.551270 166.214798,564.004883 168.681198,558.025635 
	C169.859772,555.857727 170.140137,553.428894 173.067963,553.188171 
	C174.638245,555.552917 173.838562,557.634827 173.113403,559.622375 
	C171.257111,564.710266 171.114624,569.925171 171.800766,575.570679 
	C172.567383,578.132019 174.140747,580.321045 172.809341,581.883850 
	C175.710846,578.116211 179.093613,573.403625 184.660706,570.500671 
	C185.818741,570.638062 186.333282,571.118225 186.703339,572.201660 
	C186.425827,575.931213 183.498611,577.328491 181.586914,579.395020 
	C186.391479,575.970825 190.036362,571.081726 194.969681,567.659912 
	C196.181503,566.819397 197.190643,565.649780 199.149384,565.567017 
	C199.968338,565.883606 200.281418,566.257568 200.488007,567.134033 
	C197.748459,573.684143 191.863251,577.055115 187.307861,581.472351 
	C181.381958,587.218689 179.788086,593.236450 180.836182,601.141968 
	C182.559799,614.142456 184.119888,627.136414 187.800842,640.164307 
	C188.298843,642.251343 188.840454,643.928650 189.347809,645.996399 
	C190.910614,652.499817 194.033798,658.040771 195.959534,664.392212 
	C196.006744,664.984680 196.015228,665.221130 196.032272,665.807739 
	C199.069565,672.108032 203.434555,677.353333 205.353165,683.892395 
	C205.899551,685.754517 207.051392,687.490784 206.119110,689.810974 
z"/>
<path fill="#8395B3" opacity="1.000000" stroke="none" 
	d="
M288.039459,717.590210 
	C272.458313,719.399536 256.949646,719.800903 241.471252,717.960571 
	C237.839539,717.528748 233.831589,718.048096 230.423767,715.059082 
	C226.850616,711.070374 225.082657,706.383362 222.386398,702.256592 
	C219.198273,697.377014 220.321075,695.869995 226.822845,696.015625 
	C231.436844,697.631470 235.928879,697.741943 240.679871,698.551880 
	C248.925919,698.961426 256.685089,700.686340 264.902527,700.125549 
	C267.104797,698.087830 269.601562,701.350891 271.736511,698.965698 
	C274.952759,698.417114 277.069336,700.152222 279.538391,701.918274 
	C283.592651,706.633179 284.790192,712.526855 288.039459,717.590210 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M588.105957,339.327606 
	C592.298279,339.683838 596.109009,335.575043 600.786682,337.624359 
	C601.857422,338.093475 601.939758,335.923737 602.496094,334.982086 
	C604.436218,331.698120 603.859131,327.563660 603.522156,324.568420 
	C602.659302,316.899139 605.156494,309.473053 604.005005,301.474609 
	C603.629333,300.616272 603.484253,300.152130 603.787415,299.302094 
	C604.006836,298.245178 604.008301,297.502167 604.010986,296.388123 
	C605.175903,288.704681 605.007080,281.331360 605.016113,273.502533 
	C602.542786,266.720337 603.157043,262.912415 607.424316,260.276123 
	C609.419189,266.341309 608.461487,272.203949 608.461060,277.976715 
	C608.460632,285.458557 608.815857,292.959869 608.395691,300.424255 
	C607.517273,316.031036 607.561951,331.646576 607.438110,347.721527 
	C607.517334,350.254425 607.166504,352.357483 607.945068,354.829529 
	C607.226501,359.618439 608.037476,364.154694 606.183472,368.711639 
	C603.547424,369.347809 602.630920,370.608917 603.436584,372.842957 
	C604.138794,374.789978 604.266296,376.742188 603.571472,378.669128 
	C603.122009,379.915527 602.236633,381.601654 600.784302,380.634277 
	C597.851807,378.681152 596.612671,379.360229 595.477905,382.531006 
	C594.850891,384.283142 593.386047,384.012543 593.019165,381.989838 
	C592.761841,380.571655 591.993347,380.005493 590.256836,380.058777 
	C582.770874,388.701050 576.357117,389.430176 569.187805,382.292847 
	C571.515991,380.208618 574.798157,380.627045 577.633789,378.973206 
	C578.543762,377.349609 579.853882,376.584015 580.982727,375.664612 
	C585.765564,371.769226 588.872131,367.001434 589.010437,360.268829 
	C595.708069,351.078674 595.522827,346.312012 588.105957,339.327606 
z"/>
<path fill="#4B2766" opacity="1.000000" stroke="none" 
	d="
M553.562500,437.894470 
	C553.471130,464.492096 553.219666,490.809387 552.894043,517.594360 
	C548.121399,517.551270 542.948181,518.716736 539.612488,513.673645 
	C538.973389,512.707520 536.929993,512.670288 535.197998,512.042358 
	C533.175781,507.458344 534.270020,502.883331 534.234375,497.964691 
	C536.224731,495.500275 537.231079,496.832581 537.943054,498.574677 
	C538.581787,500.137482 538.547180,501.858948 538.469971,503.512177 
	C538.266174,507.875458 540.874268,510.127960 544.359863,511.905792 
	C546.940308,513.221863 548.122375,512.308167 548.382446,509.690094 
	C548.712036,506.372986 548.831482,503.001648 548.614624,499.714874 
	C547.759705,486.758209 550.884399,473.842651 548.723694,460.857635 
	C547.959412,456.264343 549.708679,451.619812 549.783569,446.953644 
	C549.807434,445.462189 550.233643,443.545837 548.552185,442.987152 
	C546.345459,442.253937 546.693665,444.695923 545.928955,445.782257 
	C540.033875,454.156677 537.833374,463.497192 538.363892,473.637054 
	C538.462280,475.518188 538.518188,477.794403 535.522034,478.419250 
	C532.507507,475.043060 534.993591,471.116455 533.846252,467.828857 
	C533.838684,482.189789 534.871948,496.759521 533.313354,511.604431 
	C529.909790,511.452301 526.721924,511.007477 523.255371,510.281982 
	C521.494385,508.407166 521.568909,506.434113 521.528748,504.442902 
	C521.393066,497.710968 521.327332,490.980774 521.614197,483.819550 
	C521.947754,480.752686 522.368164,478.126129 522.226624,475.094177 
	C521.991333,473.529449 522.150146,472.357513 522.514221,470.868591 
	C522.618164,469.878357 522.622192,469.219879 522.488770,468.230225 
	C522.456604,467.670624 522.464661,467.444000 522.700989,466.568054 
	C524.825439,463.715637 524.865479,459.915527 528.961914,459.382782 
	C530.793335,461.068481 529.782104,463.101837 530.503113,464.548645 
	C529.628723,461.064392 530.139648,457.692932 534.246765,455.618958 
	C532.220642,456.807373 530.793762,456.726501 529.891907,454.174744 
	C529.680908,453.092438 529.712158,452.368530 530.002808,451.295929 
	C530.234924,450.861359 530.389832,450.786163 530.745605,450.873291 
	C532.490662,448.530060 535.253662,449.233490 536.787476,448.957855 
	C536.385193,449.215485 535.332703,448.992523 534.127686,448.074768 
	C533.763367,444.489746 535.194458,442.237091 538.634521,441.040649 
	C540.628540,438.308319 543.706055,438.375153 546.509888,437.158722 
	C547.726868,436.342621 548.456177,435.472992 549.648193,434.644897 
	C552.511353,433.974548 552.539368,436.257538 553.562500,437.894470 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M317.045166,803.737305 
	C316.710785,803.832031 316.354095,803.803650 316.180206,803.845703 
	C312.764496,806.778809 308.884033,807.872498 304.254486,807.857605 
	C295.287994,810.125916 286.711914,812.503235 278.106323,814.768250 
	C276.574097,815.171509 275.109070,816.365845 273.161072,815.222107 
	C273.215332,812.696472 274.984467,812.046448 277.044495,811.300720 
	C299.006714,800.314819 321.759125,793.404297 346.109833,793.102173 
	C374.324738,792.752136 401.633789,787.954956 427.982971,777.872742 
	C432.634277,776.092896 437.087677,773.795776 441.864685,771.480835 
	C444.037140,768.463684 447.156158,767.553528 450.055786,766.518738 
	C452.376282,765.690674 453.940491,766.747498 453.456360,769.929077 
	C445.153748,777.230957 435.204224,780.660095 425.628723,784.820557 
	C413.259155,790.195190 400.670258,794.844238 387.274628,796.971680 
	C385.465393,797.259033 383.654663,797.500549 381.824341,797.463989 
	C365.058136,797.128784 348.362274,798.575317 331.301208,799.177368 
	C330.518250,798.945190 330.077026,798.962219 329.306946,799.019775 
	C328.737030,799.292480 328.480621,799.506409 327.981842,799.808472 
	C327.754730,799.914917 327.380829,799.903503 327.197571,799.940918 
	C326.567139,800.476440 325.917572,800.471375 325.063416,800.780884 
	C323.667084,801.091431 322.549622,801.272095 321.211304,801.711243 
	C320.038177,803.069946 318.952148,803.881409 317.045166,803.737305 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M422.800903,699.366089 
	C425.571716,702.101318 426.137726,705.840149 427.969177,708.937744 
	C428.864258,710.451538 428.102753,711.410889 426.567047,711.906250 
	C419.975494,714.032227 413.409882,716.243347 406.783905,718.255737 
	C404.061249,719.082703 404.484650,716.220398 404.135162,715.114319 
	C400.653076,704.093994 397.023499,693.136536 392.237579,682.598999 
	C390.872162,679.592651 389.355591,676.655029 387.781128,673.338135 
	C389.233582,669.937012 391.561981,667.482239 393.867584,664.980835 
	C394.943481,663.813538 395.910004,663.584473 397.531799,663.973389 
	C397.722687,663.508240 397.609253,663.336121 397.800690,663.109619 
	C398.371094,663.368896 398.554138,663.723328 398.649292,664.421509 
	C398.626190,665.278381 398.541809,665.839172 398.599182,666.675781 
	C398.661621,667.123047 398.691895,667.300781 398.793854,667.737244 
	C399.124847,668.717651 399.715454,669.195129 400.299896,670.048584 
	C400.424438,670.950439 400.591888,671.618530 400.409454,671.753052 
	C400.754913,671.249268 400.346069,670.160706 400.809509,668.950195 
	C401.474915,668.507629 401.932831,668.467285 402.724792,668.701965 
	C403.590118,669.376282 403.874573,670.027222 404.111908,671.082886 
	C404.216614,671.880371 404.241333,672.332642 404.252411,673.106445 
	C404.273041,673.834900 404.293915,674.242432 404.387177,674.926880 
	C404.705231,676.016785 405.347229,676.298401 406.398712,676.476562 
	C406.862793,676.630798 407.040894,676.717712 407.432739,677.012878 
	C408.223938,678.029724 408.833984,678.807617 409.888794,679.584839 
	C410.340790,680.130859 410.507812,680.494141 410.598877,681.191040 
	C410.517761,681.866577 410.383240,682.223450 410.013367,682.756592 
	C409.632660,683.205872 409.522827,683.327393 409.522827,683.327393 
	C409.462585,683.936646 409.568085,683.959656 410.116943,683.328491 
	C412.924469,684.512268 414.191467,687.125061 416.562866,689.038940 
	C417.041443,689.661194 417.282654,690.038940 417.656891,690.727051 
	C418.887573,693.370911 419.872131,695.755981 420.927002,698.407593 
	C421.532684,698.971619 421.966492,699.301086 422.800903,699.366089 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M481.353271,574.663208 
	C481.726440,575.548584 481.852356,576.239014 481.998657,577.280396 
	C483.778015,585.149841 484.981049,592.659607 481.351776,600.408508 
	C473.858337,605.448425 465.766541,606.941101 457.596924,608.158630 
	C457.403168,607.774414 457.209381,607.390259 457.015594,607.006042 
	C460.324921,604.140015 463.714722,601.360474 466.918182,598.380615 
	C469.488708,595.989502 471.025543,593.573181 468.700653,589.677551 
	C466.448059,585.903259 469.885834,582.921753 472.294189,579.713745 
	C467.404449,577.837036 464.268768,579.087952 461.969666,583.540283 
	C461.398438,584.300171 460.908539,584.509888 459.942902,584.267883 
	C463.463776,575.069824 467.677185,566.160583 467.087769,555.964661 
	C467.049408,555.301270 467.152283,554.627319 467.087311,553.968323 
	C466.996765,553.049805 467.425262,551.724182 466.089081,551.502563 
	C464.557983,551.248657 464.225739,552.600586 463.965240,553.729370 
	C463.554535,555.508972 463.279938,557.319641 462.884613,559.103210 
	C460.968384,567.748596 457.957031,575.878906 451.692200,582.519165 
	C453.473877,574.500732 456.087250,566.718567 457.399658,558.626099 
	C458.117035,554.202698 458.805420,549.767090 459.772980,545.395874 
	C460.104340,543.898804 458.947601,541.270996 461.934937,541.168091 
	C464.713013,541.072327 466.656494,542.499207 467.759705,545.041382 
	C468.256134,546.185425 467.278351,547.797363 469.176025,548.767151 
	C471.807220,549.692078 471.224579,551.782104 471.381927,553.412720 
	C471.617737,555.856873 471.767914,558.275818 473.535034,560.653931 
	C475.686218,565.128235 477.581665,569.300232 479.727295,573.703491 
	C480.393250,574.028809 480.767578,574.210571 481.353271,574.663208 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M379.104614,538.280457 
	C379.238770,533.404846 380.908295,529.171753 382.679626,524.993958 
	C383.547729,522.946533 387.046600,523.993286 387.813538,521.157227 
	C390.421173,524.474243 388.379028,528.130981 388.658142,530.493347 
	C389.999817,518.664124 393.742645,506.161163 395.972900,493.373901 
	C396.416962,490.827789 396.079071,487.992981 398.332031,485.578857 
	C399.493927,485.044037 400.312469,485.038879 401.500946,485.466492 
	C404.552979,490.254333 404.365845,495.576660 404.756256,500.522797 
	C405.078003,504.599060 407.663330,508.338440 406.093658,512.788818 
	C404.336639,512.939697 404.603271,511.782684 404.316956,510.563965 
	C403.765472,509.965851 403.846832,509.390320 403.468292,509.089661 
	C403.619507,509.325623 403.749786,509.572968 404.045715,510.091095 
	C404.535553,510.977112 404.479187,511.644348 404.385071,512.645813 
	C401.481201,516.029358 400.545837,519.738892 400.582062,523.773438 
	C400.594147,525.120117 400.294830,526.370056 399.622253,527.863831 
	C399.607910,528.558105 399.771912,528.767151 400.074036,528.772583 
	C400.740570,528.784607 400.525330,528.129517 400.246918,528.735229 
	C400.242859,528.744080 400.101257,528.687866 399.869476,528.257629 
	C401.216034,526.233521 402.362671,524.363464 404.789703,523.432007 
	C405.325958,523.441162 405.539581,523.483643 406.041382,523.675903 
	C407.278473,524.633545 408.387878,524.268433 409.777832,524.317871 
	C410.288177,524.510010 410.470184,524.636963 410.735107,525.086304 
	C410.504303,527.295776 411.277252,528.981262 411.844574,530.690796 
	C412.558380,532.841553 411.895203,534.165527 409.292145,534.711914 
	C408.774017,534.629395 408.634613,534.511292 408.310181,534.234741 
	C408.125183,534.076233 407.751007,533.875061 407.672058,534.099976 
	C407.517242,534.474060 407.441376,534.623108 407.195770,534.957031 
	C399.150055,538.204895 392.148804,542.710876 385.342163,548.207214 
	C381.515259,548.750061 378.410309,550.423340 374.749939,551.366943 
	C373.198395,550.690430 372.990082,549.525269 372.773285,547.995361 
	C372.782990,546.050415 372.740631,544.437439 373.856995,542.819946 
	C373.832062,542.341736 373.803680,542.151306 373.912018,541.706604 
	C375.180511,541.041199 376.293579,540.875183 377.648956,541.843140 
	C378.670013,541.209229 379.562439,540.890320 380.816162,540.825073 
	C381.043762,540.757202 381.413635,540.535278 381.604126,540.470215 
	C381.794586,540.405212 381.735168,540.011597 381.675079,540.217529 
	C381.614990,540.423401 381.138916,540.535950 380.872253,540.506042 
	C379.739441,540.126526 379.376678,539.437378 379.104614,538.280457 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M227.325897,697.120361 
	C225.413025,697.277893 223.648178,697.089111 221.008194,696.806641 
	C223.745544,703.288940 228.548157,707.895935 230.113861,714.459717 
	C222.955872,715.061035 216.140976,712.732117 209.116287,711.874146 
	C202.566879,711.074341 196.088760,709.690735 189.275482,708.322998 
	C186.794724,704.831604 189.564651,700.545898 186.679581,697.058960 
	C186.821625,693.284363 189.360764,693.838135 191.315674,694.244629 
	C195.222382,695.056824 199.149567,694.940613 203.537704,695.038086 
	C204.541962,694.485840 205.186447,694.177307 206.301483,694.112671 
	C209.129395,694.621765 210.521591,694.051575 209.598145,691.171631 
	C208.964035,689.194031 207.885513,687.356689 207.690826,684.858887 
	C207.595520,680.681274 207.878113,677.015076 211.981934,674.625977 
	C215.711594,674.522461 215.313217,678.238281 217.634766,679.800415 
	C221.752762,685.245483 225.326599,690.603394 227.325897,697.120361 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M516.069580,939.699646 
	C514.567383,938.055847 512.994202,937.864868 511.026031,938.512146 
	C502.604370,941.281799 494.141693,943.926514 485.716583,946.685791 
	C483.405029,947.442871 480.942078,948.241211 481.747559,951.768433 
	C482.396423,952.377380 482.547272,952.851746 482.232605,953.721802 
	C481.269318,954.059875 480.532440,954.078186 479.427124,954.105957 
	C478.518433,953.906555 478.164795,953.471558 477.580963,952.874084 
	C476.920776,952.316467 476.429504,952.011108 475.597961,951.655457 
	C475.092682,951.452637 474.885315,951.369263 474.357941,951.154419 
	C465.934235,947.461914 456.856079,947.212158 448.776031,943.514282 
	C441.364532,940.122253 433.626007,937.536682 426.011230,934.647644 
	C424.465912,934.061462 422.854431,933.533020 421.712646,931.713867 
	C422.296265,931.032104 422.999268,930.711487 423.929260,930.074219 
	C424.707153,929.296387 425.357483,929.147949 426.391357,929.190796 
	C427.588440,929.420044 428.409210,929.748657 429.565155,930.087708 
	C430.289001,930.301086 430.704315,930.415955 431.443115,930.574707 
	C432.852142,930.805603 433.964996,930.854614 435.299316,931.427612 
	C435.703644,931.795105 435.819305,931.987549 435.688782,932.409851 
	C438.223816,936.499084 443.222534,935.653442 446.729950,937.956421 
	C451.066101,940.803589 454.879150,939.251953 458.825989,936.391602 
	C460.091614,933.891968 462.129639,933.325928 464.670227,933.051880 
	C468.128265,931.775696 471.231995,930.455627 474.662231,928.962036 
	C475.947906,927.420715 477.121887,926.387268 479.234558,926.294861 
	C483.162598,924.883423 486.747681,923.458130 490.656860,921.847412 
	C491.929199,920.250977 493.485535,919.834045 495.272675,919.225586 
	C499.318512,919.160217 502.303497,916.490051 506.404816,917.152283 
	C489.977722,925.272583 473.550659,933.392944 456.833893,941.656433 
	C459.408813,943.804443 461.504913,942.539307 463.548615,941.607178 
	C476.397766,935.746948 489.232697,929.855469 502.422943,923.903687 
	C504.649841,923.579712 504.591919,924.780579 504.204407,926.427856 
	C492.690735,932.397339 481.413757,937.990051 469.441803,943.927490 
	C473.170471,945.667847 476.184875,946.367798 479.645264,945.165955 
	C495.939575,939.506836 512.586548,935.048706 529.698730,930.692200 
	C530.199219,930.832947 530.291016,931.074890 530.182739,931.649292 
	C526.310059,934.079468 522.637512,936.177124 518.609619,938.337891 
	C517.925598,938.220703 517.858337,937.091492 517.159424,938.402588 
	C516.841309,939.016602 516.563110,939.338379 516.069580,939.699646 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M388.073853,957.357239 
	C386.729980,956.559448 385.165161,959.170410 384.033264,956.329956 
	C382.797363,955.851379 381.598389,955.707153 380.215332,955.300171 
	C375.872284,954.006470 371.609070,953.263306 367.602753,951.811279 
	C365.857758,951.178894 368.206573,950.802063 368.685974,950.041748 
	C369.905182,948.986389 370.957520,948.240417 372.532959,947.745850 
	C373.020233,947.560364 373.214691,947.490662 373.700531,947.329102 
	C374.563110,947.075012 375.144470,946.950562 375.980927,946.673035 
	C376.430084,946.509949 376.609467,946.445496 377.059570,946.293274 
	C377.871429,946.046570 378.420349,945.913757 379.215454,945.619141 
	C379.655792,945.446350 379.833130,945.378540 380.280579,945.218140 
	C380.915222,945.010498 381.279602,944.894714 381.915161,944.670410 
	C382.368469,944.485718 382.550293,944.408813 383.005432,944.209473 
	C383.650574,943.916870 384.023315,943.748535 384.689392,943.448303 
	C385.186584,943.236633 385.391357,943.158752 385.914551,942.981995 
	C391.136230,941.580994 395.466553,938.802979 400.678040,937.464905 
	C410.414825,933.017395 418.385132,938.219971 426.873169,941.567261 
	C427.119019,943.398438 429.385132,944.573914 427.564575,946.599121 
	C422.495453,948.748169 418.551544,952.189941 413.630951,954.622681 
	C408.832184,956.742493 404.500977,959.201965 399.243866,958.288452 
	C397.604553,958.003601 396.390808,959.866760 394.331085,959.832153 
	C391.657043,960.156738 389.702423,959.462463 388.073853,957.357239 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M284.443085,726.933838 
	C285.081543,728.028992 285.568085,729.309937 286.532318,727.923950 
	C287.603119,726.384827 288.295044,724.583252 287.978302,722.235046 
	C291.591888,719.875427 291.075378,722.916260 291.193909,724.861328 
	C292.172638,740.922607 293.123779,756.984253 291.879272,773.081848 
	C291.329651,780.191223 290.548279,787.318237 290.630463,794.428528 
	C290.686249,799.253906 289.140137,802.193787 284.652802,803.741394 
	C283.574066,804.113464 282.615234,804.833252 281.290680,805.505737 
	C280.292450,779.661682 284.134338,753.823730 282.952759,727.383423 
	C282.885773,726.911133 282.901886,726.909180 282.902496,726.900818 
	C283.309296,726.595764 283.757904,726.519531 284.443085,726.933838 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M184.858780,891.615234 
	C196.211426,894.337524 207.296005,896.802795 218.337006,899.449768 
	C220.962555,900.079285 223.579010,899.978210 226.653870,900.267578 
	C227.107086,900.331665 227.054840,900.689453 227.025665,900.867798 
	C225.883057,901.879211 225.291992,903.179138 223.950348,904.262451 
	C221.873657,904.677917 220.144455,904.315674 218.018448,904.147095 
	C211.020203,902.131897 204.100311,901.502258 197.125320,899.353943 
	C187.167236,896.778992 177.436096,894.896362 168.050690,891.695435 
	C166.782791,891.263000 165.437576,891.393982 163.743500,891.696899 
	C162.853958,891.852844 162.343460,891.848267 161.471863,891.670166 
	C158.395081,889.344299 155.044022,888.537170 151.830505,887.436523 
	C149.815384,886.746399 147.842438,886.021973 146.279739,883.970459 
	C145.496796,879.711365 141.490448,875.710266 146.622330,872.056641 
	C146.798233,872.498352 146.941254,873.671204 147.381775,873.796326 
	C148.337326,874.067627 147.854202,872.964661 148.075516,872.491699 
	C149.971207,868.440857 153.611755,866.637756 157.856125,865.129517 
	C159.203110,868.272278 156.276535,869.785950 155.275558,872.097778 
	C154.491043,873.909607 153.159103,875.457092 152.547440,877.427917 
	C157.231491,870.849243 161.730698,864.139893 166.719666,857.364502 
	C167.249359,855.017944 168.339386,852.799744 170.463593,853.606506 
	C172.673553,854.445740 172.712524,856.849670 170.626678,858.875122 
	C168.234009,862.986877 165.406143,866.565308 163.397507,871.005371 
	C163.152756,871.770020 162.983673,872.195984 162.611572,872.906433 
	C160.381943,875.002563 158.844894,877.165466 157.726715,880.030334 
	C157.341766,881.287781 155.629028,882.204773 157.261414,883.192078 
	C158.500061,883.941162 159.341370,883.165955 159.871887,881.912537 
	C160.954239,879.355408 161.889450,876.741516 163.088654,873.849854 
	C165.461685,869.501953 166.344177,864.803650 169.762573,861.091370 
	C170.933578,861.014771 171.753052,861.047485 172.980591,861.120483 
	C173.597290,861.555115 173.703262,861.975403 173.656616,862.746704 
	C173.201447,864.312927 172.509720,865.424683 171.872437,866.918091 
	C171.462463,867.807434 171.156540,868.385681 170.741943,869.280090 
	C169.293961,871.929626 168.297379,874.415344 167.227203,877.239380 
	C166.406357,879.191589 165.381699,880.680664 164.783890,882.814270 
	C166.205154,881.368774 166.459686,879.742737 167.305389,878.043396 
	C172.668701,869.798645 177.709076,861.769287 182.125275,852.949829 
	C185.816727,847.902893 188.208206,842.471375 191.618973,837.674011 
	C192.552994,836.360352 193.100388,834.726746 195.090012,833.987183 
	C198.800491,836.694885 200.431412,840.245117 200.307877,844.760010 
	C198.861343,842.857910 197.665573,840.718689 196.325226,838.320862 
	C192.868393,842.199890 190.757706,846.872192 188.141525,851.195007 
	C181.793518,861.684021 175.596436,872.264465 169.240982,882.748840 
	C167.008377,886.431946 167.753342,888.317993 172.145676,887.965393 
	C175.866592,887.666809 178.264725,891.899170 182.527924,890.460815 
	C183.606171,890.451782 184.075623,890.960510 184.858780,891.615234 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M449.080566,698.684570 
	C450.473480,704.818176 446.997894,707.493896 438.256165,707.051636 
	C435.677643,706.830933 435.402283,704.925476 434.781738,703.518921 
	C429.248199,690.975769 422.892700,678.835083 416.812592,666.559448 
	C415.866058,664.648438 414.732300,662.757141 415.435913,660.100586 
	C416.789948,658.212891 418.348297,658.001465 420.073730,658.576660 
	C421.195587,658.950623 422.430847,659.313416 423.498108,659.111023 
	C430.931030,657.701843 433.681274,662.267700 436.019196,668.138794 
	C439.825531,677.697327 444.809723,686.745483 448.838867,696.647461 
	C448.942566,697.478394 448.934967,697.929810 449.080566,698.684570 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M452.762573,770.295776 
	C453.252258,767.837646 453.668793,765.666321 450.254578,767.565125 
	C447.858551,768.897522 445.313507,769.961975 442.465973,771.185120 
	C441.991882,769.871277 441.403412,769.006714 439.553467,769.064514 
	C438.592102,767.257324 440.164001,767.331665 441.439758,766.789246 
	C442.926086,766.669495 443.763733,766.100525 444.577942,764.887817 
	C444.976715,764.509766 445.156036,764.377319 445.632416,764.084839 
	C451.216858,762.302612 454.320587,757.771423 458.699158,754.350220 
	C464.180359,751.741516 469.737946,750.347900 475.400330,748.287598 
	C476.522736,748.147278 477.355988,748.196899 478.242828,747.410034 
	C478.782776,746.921204 479.143982,746.710083 479.866425,746.508240 
	C483.293365,747.929565 485.192596,745.006409 488.073334,744.428528 
	C488.629639,744.540039 488.839600,744.632568 489.248413,745.003662 
	C490.709167,746.889526 486.905182,748.202332 489.331390,750.166199 
	C489.510040,753.360901 487.132843,753.556396 485.212494,754.275818 
	C483.164642,755.042969 480.599518,754.892700 479.540100,757.792114 
	C479.391968,759.604187 479.853241,760.965149 480.356110,762.702820 
	C480.938171,765.130615 481.531006,767.186768 480.553223,769.650940 
	C480.129456,770.138611 479.910645,770.283813 479.307129,770.491211 
	C473.552917,768.075989 474.774506,762.703613 473.728241,758.916931 
	C473.473145,763.515198 476.272919,768.151062 475.997864,773.628296 
	C474.823730,775.518738 473.536255,776.971436 473.148132,779.243225 
	C470.944244,781.006042 467.588623,780.680176 466.750122,784.277832 
	C466.143188,785.191895 465.552673,785.557922 464.456940,785.682129 
	C461.677643,784.930420 461.851196,782.655029 461.288818,780.843384 
	C460.164673,777.222229 459.223389,773.546326 458.029816,769.534546 
	C458.744019,775.481567 460.132385,780.867859 461.901306,786.536499 
	C462.126160,790.196838 467.106018,791.396912 465.513489,795.697510 
	C463.656555,797.228333 462.412323,795.956543 460.718140,795.130127 
	C457.674652,793.263306 457.389221,790.190552 456.012024,787.292480 
	C454.502777,781.545715 452.397949,776.312622 452.762573,770.295776 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M49.016045,920.847290 
	C49.836750,923.259949 48.916122,925.347290 48.941879,927.811401 
	C41.709427,929.681763 34.471779,929.167297 26.913906,928.117798 
	C26.517855,922.802307 26.439623,917.842529 26.484112,912.431458 
	C27.459558,910.608521 29.361139,909.801208 29.352003,908.028931 
	C29.318985,901.624817 34.245731,900.376221 39.122395,898.758545 
	C39.879459,899.108459 40.282463,899.392822 40.714966,899.621460 
	C49.378700,904.201172 52.682831,907.712830 56.995415,916.928955 
	C57.482944,917.970886 57.992027,919.002686 58.579842,920.410706 
	C58.405975,920.825623 58.143394,920.868958 57.485153,920.965332 
	C54.460251,919.947876 51.720474,920.703186 49.016045,920.847290 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M108.765427,767.481689 
	C116.022224,773.345459 124.811913,776.661316 131.212799,783.310852 
	C132.471115,784.617981 133.684921,785.967957 135.083405,787.597595 
	C135.534760,790.117676 134.670029,791.569397 132.332443,791.436890 
	C130.390335,791.326843 128.894852,792.595398 126.737976,792.686401 
	C124.184425,791.971924 122.377281,789.885864 119.383316,790.705078 
	C118.370445,790.640930 117.751854,790.399780 116.894287,789.882629 
	C115.661461,788.948486 114.772972,788.023804 113.044083,788.364746 
	C111.532318,788.348450 110.643745,787.659119 109.476784,786.772949 
	C100.900917,781.143616 93.138191,774.942017 84.405815,769.631592 
	C82.065247,769.397339 80.978371,767.884949 79.510864,766.344788 
	C79.124176,765.951294 78.974503,765.789551 78.623154,765.367065 
	C78.056297,764.560791 77.747208,763.981750 77.240173,763.137329 
	C76.379219,761.699951 75.849220,760.482178 75.650543,758.797729 
	C76.637276,754.958923 78.205589,753.572266 81.693771,756.177856 
	C86.095413,759.465637 91.151817,761.713684 95.881599,764.484436 
	C97.981033,765.714294 100.052887,765.270508 102.535446,765.103394 
	C103.103859,765.178833 103.325050,765.233215 103.849823,765.432617 
	C105.166023,766.255859 105.747475,767.612061 107.543533,767.534912 
	C108.052933,767.520752 108.256577,767.510864 108.765427,767.481689 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M288.634338,645.287598 
	C285.224854,640.414673 284.985779,634.776611 282.986877,629.346436 
	C285.430695,627.317871 286.879456,630.727173 289.476501,630.338867 
	C293.489807,631.966248 294.790344,635.942078 298.122253,638.916016 
	C297.030792,629.832397 296.542053,621.440918 294.645477,613.222290 
	C294.129944,610.988220 293.291626,608.738647 294.716187,606.200195 
	C300.094147,613.626953 303.513153,622.090149 306.712982,631.049927 
	C309.572052,635.617371 310.200775,640.307861 309.879578,645.598755 
	C307.685791,652.484314 306.760040,659.552734 301.752502,664.908630 
	C300.216370,666.551575 299.136810,667.708313 298.077087,664.315491 
	C293.508972,658.562134 291.527527,651.887878 288.634338,645.287598 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M123.801613,942.908569 
	C127.435745,936.417114 130.824081,930.138794 134.047562,923.776917 
	C137.291000,917.375549 137.424042,917.447083 143.677353,920.380249 
	C154.969879,925.677185 166.388306,930.706665 177.787704,935.772339 
	C178.424881,936.055542 179.366165,935.654480 180.511230,935.392090 
	C181.543289,935.465881 182.031342,935.969727 182.767685,936.726685 
	C189.433899,938.435791 195.390991,941.132568 201.785400,943.678772 
	C206.261154,946.746155 209.441635,946.002258 213.478210,942.646606 
	C220.715942,936.629700 228.354355,931.016663 236.334778,925.944153 
	C237.864960,924.971497 239.360229,923.829895 241.686951,924.503967 
	C243.042542,927.140137 240.942078,928.251770 239.676941,929.529358 
	C235.371201,933.877563 231.203430,938.362854 226.381485,942.198059 
	C223.747726,944.292908 221.062408,946.516052 219.217575,950.048218 
	C224.772690,950.773010 228.071228,945.369812 233.390717,946.335632 
	C234.959000,947.606873 234.545151,949.005310 234.166656,950.674194 
	C232.706848,954.088074 229.579193,952.333252 227.269318,953.686157 
	C226.467941,954.984558 225.219193,954.893311 224.225891,955.779175 
	C223.359634,956.005737 222.710495,956.011536 221.736755,956.018860 
	C216.262344,955.563110 211.555450,953.353943 206.212067,952.179749 
	C205.632339,952.013977 205.405426,951.935242 204.852997,951.709290 
	C198.695770,948.797852 192.756088,946.302612 186.256226,944.266846 
	C185.698257,944.090820 185.477310,944.011169 184.930725,943.794922 
	C184.174072,943.462463 183.745178,943.262085 182.989105,942.914062 
	C171.063660,937.886902 159.709305,932.420349 147.443405,928.209473 
	C146.867645,928.026917 146.643646,927.937561 146.107422,927.669434 
	C144.703400,926.501099 143.668839,925.510925 142.252335,924.875427 
	C139.735855,923.746460 138.328796,923.924194 136.781265,926.714600 
	C132.695557,934.081665 129.437973,941.880066 124.748428,949.313232 
	C123.727081,950.221008 122.874130,950.650452 121.485519,950.426331 
	C120.241051,947.347107 122.236275,945.337524 123.801613,942.908569 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M223.972900,886.874146 
	C219.346054,882.683044 216.691849,877.276001 214.612930,871.718140 
	C203.414032,841.778259 191.554077,812.043213 184.686096,780.680542 
	C183.837463,776.805298 183.352188,772.850586 182.661560,768.493408 
	C182.831909,767.916748 183.039246,767.779358 183.619492,767.648071 
	C186.408173,768.934509 186.390686,771.477661 186.992508,773.640564 
	C188.013550,777.310181 189.035049,780.970032 190.833679,784.741577 
	C191.204224,785.236450 191.341949,785.443604 191.642120,785.988892 
	C192.069504,787.034180 192.232880,787.768311 192.486816,788.869385 
	C201.036758,813.253052 209.241364,837.356262 217.566132,861.812378 
	C218.003571,862.836182 218.247772,863.534241 218.668762,864.555176 
	C219.231598,866.028137 219.506485,867.214844 220.133698,868.670776 
	C221.632767,873.855774 225.500824,877.705444 225.738373,883.363159 
	C225.390335,884.805054 225.076950,885.843994 223.972900,886.874146 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M398.134888,745.881226 
	C400.102722,742.482727 402.953979,740.034973 406.817871,738.942383 
	C408.473969,741.770569 406.063324,743.156311 405.048859,744.742554 
	C402.845612,748.187622 400.401123,751.492432 397.982361,754.802734 
	C397.571503,755.365051 397.609711,755.392944 398.862793,755.782776 
	C399.876892,759.514771 397.539795,762.401367 396.907837,765.685730 
	C396.542175,767.585999 395.330322,769.376892 396.588867,771.779114 
	C399.929016,769.261536 402.263458,765.939636 404.998535,763.008789 
	C409.709503,757.960388 414.545074,753.028320 419.673767,748.014160 
	C420.377808,748.429321 420.521515,748.938416 420.233948,749.856934 
	C419.769897,754.181824 416.505249,756.445496 414.575775,759.414246 
	C411.328827,764.409973 407.204620,768.838440 403.993195,773.853699 
	C398.078674,783.090271 389.062469,785.913391 378.972931,786.831787 
	C377.859222,786.933167 376.228546,787.025452 375.674561,786.391052 
	C374.616516,785.179504 375.986816,783.930298 376.681549,782.904053 
	C383.838806,772.331177 391.247192,761.916931 397.017975,750.478699 
	C397.706268,749.114441 399.514221,748.042969 398.134888,745.881226 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M23.717421,1013.778992 
	C23.255919,1008.817871 21.606136,1003.078735 23.551025,999.094055 
	C25.783821,994.519653 32.200558,997.358032 36.726086,996.759399 
	C44.411846,995.742676 52.209808,995.574158 60.387108,995.164551 
	C60.793911,997.920959 60.760807,1000.561768 60.757137,1003.202637 
	C60.747627,1010.048218 60.456532,1010.335938 53.640305,1010.965820 
	C43.796864,1011.875549 33.958210,1012.836914 23.717421,1013.778992 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M340.132660,433.595032 
	C335.532135,436.196442 331.065521,438.415955 326.295227,440.809601 
	C324.122437,443.286743 321.337097,443.933258 319.039551,444.989960 
	C321.497467,444.503174 323.684448,442.389435 326.920502,442.376892 
	C333.222168,439.992493 339.177216,437.644226 345.303833,435.622375 
	C345.175873,440.585266 341.922333,443.928589 339.920288,448.147980 
	C339.154602,448.447357 338.695129,448.435822 337.961670,448.099396 
	C335.273682,446.406372 333.737183,448.519379 331.582642,449.508240 
	C331.067810,449.829529 330.854034,449.954163 330.300049,450.246429 
	C328.497070,451.198792 326.880463,451.786743 325.623596,452.848938 
	C318.194366,459.127655 309.526581,459.114288 300.220520,457.806274 
	C297.155823,455.687134 294.060120,456.576019 291.121948,456.438385 
	C285.448151,456.172607 284.991943,455.354584 288.130554,450.091309 
	C293.102203,446.216705 298.842896,444.857483 304.192871,442.768494 
	C312.971161,439.340912 322.020264,436.614075 330.848053,433.278748 
	C333.449097,432.296021 336.173523,431.346527 339.427612,432.370392 
	C339.943817,432.780731 340.105194,432.996948 340.132660,433.595032 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M353.704407,993.235046 
	C358.472717,990.964600 363.436371,991.645935 368.110535,991.331787 
	C383.752075,990.280457 399.270447,987.433350 415.478149,987.868713 
	C418.449554,986.061523 421.185608,986.413940 423.896240,987.078674 
	C426.593262,987.740051 429.264191,988.239136 432.387482,987.523987 
	C433.215210,987.919861 433.590546,988.269226 434.053650,989.028870 
	C434.286102,992.908997 431.454193,991.565918 429.354004,992.016907 
	C428.243286,992.316406 427.474609,992.634705 426.393738,992.980957 
	C425.417511,993.405212 424.850891,993.103516 424.319550,992.731140 
	C420.754944,990.232239 418.690155,991.589905 417.341492,995.613403 
	C414.108551,995.854919 410.874634,996.901001 408.422943,994.030579 
	C407.895111,993.412842 407.036896,992.953064 406.349335,993.855347 
	C404.187927,996.691772 400.296173,997.377930 398.143127,1000.709351 
	C395.079407,1003.888123 390.809235,1001.088379 387.561890,1003.732971 
	C387.153015,1004.128357 386.966675,1004.263245 386.443939,1004.480347 
	C383.447906,1003.817688 380.785461,1002.977539 378.165833,1004.686829 
	C376.353058,1005.869690 374.746124,1004.314331 372.706543,1004.273315 
	C371.423035,1004.101135 370.438690,1003.882080 369.493469,1005.049194 
	C368.799438,1005.739990 368.231018,1006.061462 367.278961,1006.382202 
	C366.712036,1006.435059 366.481750,1006.411499 365.949036,1006.215088 
	C365.336609,1005.698120 365.064270,1005.326843 364.684753,1004.619263 
	C363.581757,1002.241577 361.732574,1002.364868 359.925232,1002.474609 
	C358.152435,1002.582214 356.332184,1003.090149 354.585815,1001.367004 
	C352.792297,998.723267 351.752502,996.286255 353.704407,993.235046 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M298.074646,597.890808 
	C294.372498,596.787964 294.049225,593.207520 292.497467,590.633850 
	C288.391052,583.823181 283.530365,577.578613 278.867554,571.176208 
	C277.872742,569.810181 276.404449,568.551880 276.393005,566.355225 
	C279.723328,566.435669 281.231689,569.035278 283.293671,570.751587 
	C284.172424,571.482971 285.128418,572.544983 286.053558,570.826355 
	C286.668243,569.684387 287.673096,567.701111 286.098175,567.408203 
	C277.963318,565.895569 280.960632,560.660217 281.937012,555.663086 
	C284.390076,554.188599 284.788391,556.673889 286.270416,557.913940 
	C287.809113,559.578247 288.779419,561.283142 290.446228,562.817261 
	C290.837830,563.175049 290.983643,563.328857 291.297180,563.750122 
	C291.857788,564.104370 291.097443,565.227112 292.438599,564.757324 
	C294.225311,565.476196 294.907104,566.853455 295.791504,568.457764 
	C296.113220,569.101990 296.305450,569.460571 296.687256,570.052368 
	C297.107452,570.608582 297.332092,570.937378 297.682526,571.540833 
	C297.989746,572.169678 298.147186,572.538269 298.421570,573.186768 
	C298.630951,573.647400 298.715363,573.831604 298.932037,574.288635 
	C299.398804,575.303223 299.876068,575.927002 300.818207,576.532593 
	C301.239807,576.792847 301.407532,576.896729 301.817871,577.164673 
	C302.212891,577.446838 302.365234,577.564819 302.933533,578.067322 
	C303.476654,578.586975 303.603912,578.722107 303.909729,579.067505 
	C304.195526,579.425415 304.302765,579.572998 304.549133,579.953613 
	C304.857788,580.503601 305.028107,580.820068 305.349152,581.362183 
	C305.610352,581.734802 305.721497,581.881409 306.014282,582.241333 
	C306.457153,582.741150 306.717743,583.028259 307.178589,583.553589 
	C307.488434,583.974182 307.597321,584.157288 307.830566,584.640869 
	C308.540405,587.573181 309.901306,589.940063 310.600677,592.883545 
	C314.295837,599.789062 308.826660,604.833496 307.420410,610.766785 
	C305.533600,607.810730 304.123077,604.646484 303.907196,600.727539 
	C303.916443,600.122803 303.930664,599.883057 303.975983,599.289551 
	C303.720398,594.079712 301.011383,590.163879 299.164825,585.914856 
	C300.169952,587.765076 301.286133,589.568726 300.740356,592.199707 
	C300.479889,592.720642 300.337494,592.907532 299.859436,593.195801 
	C298.670288,593.138123 298.060486,592.676086 297.734985,591.858398 
	C297.823914,592.833740 298.588867,593.531250 298.798004,594.456238 
	C299.055267,595.594116 299.042938,596.695679 298.074646,597.890808 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M433.276306,989.165527 
	C427.625824,988.612305 422.245819,988.272400 416.403076,987.877136 
	C415.955322,986.822021 415.970337,985.822266 415.981873,984.446533 
	C427.619385,989.078430 438.463135,984.551147 449.295441,981.058655 
	C454.725677,979.308044 459.284515,979.809387 463.632507,984.068848 
	C468.369110,986.355835 470.363098,991.061096 474.180725,993.872375 
	C476.665070,995.701782 479.448975,997.317627 480.769318,1000.778442 
	C482.602844,1003.694519 484.239532,1006.324646 486.305328,1009.644348 
	C482.474335,1009.031128 480.758789,1006.428528 478.569824,1004.856689 
	C473.233826,1001.025330 468.093719,996.886902 463.142853,992.564941 
	C459.681549,989.543396 456.533966,989.641663 453.046448,992.624390 
	C452.985901,992.984741 452.933777,993.144409 452.970795,993.077881 
	C456.779053,993.673157 457.983124,997.098694 460.070038,999.572937 
	C462.704895,1002.696838 465.335876,1005.823975 467.658203,1009.288513 
	C462.549896,1007.775269 458.021393,1005.498047 454.395538,1001.117493 
	C453.250671,1000.349487 452.191132,1000.101440 451.246765,999.104126 
	C450.077759,997.224304 448.839417,995.951111 446.448578,995.772644 
	C443.143066,990.685791 439.966003,987.366699 433.276306,989.165527 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M124.080574,942.234009 
	C123.626122,945.114746 122.986954,947.437317 121.206345,949.654907 
	C122.206985,952.510681 120.333832,952.797485 118.649895,952.900513 
	C113.158104,953.236450 103.388550,943.910034 103.082764,938.422424 
	C99.813347,937.076111 101.818649,935.258545 102.494949,933.932190 
	C106.443459,926.188049 112.362183,920.022461 119.075790,914.173584 
	C121.524574,923.226013 123.000916,932.444580 124.080574,942.234009 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M538.296204,265.673553 
	C536.851379,274.566345 537.154053,283.196533 536.853516,291.802246 
	C536.779175,293.931946 537.740784,295.015930 539.400513,296.107178 
	C542.292114,298.008301 545.305054,299.807281 547.760254,302.802429 
	C548.944519,303.710693 549.783691,304.494934 550.526733,305.842529 
	C550.907471,308.011108 551.959900,309.626740 552.030762,311.745117 
	C551.395935,312.114990 550.971741,312.207153 549.916016,312.458099 
	C548.990295,312.463501 548.678345,312.368042 548.154053,312.177979 
	C547.959473,312.025360 548.005676,312.005768 547.993408,312.027740 
	C547.587952,311.577728 547.527283,310.975250 547.147827,310.200226 
	C546.953674,309.978760 547.016174,309.987885 547.012573,310.019226 
	C546.793762,309.795227 546.565674,309.551880 546.135742,309.156952 
	C545.944885,308.995026 546.005554,308.995789 546.000061,309.025635 
	C545.444153,308.192139 544.897827,307.326233 544.155334,306.225464 
	C543.951416,305.995483 544.007385,305.993896 544.002686,306.021484 
	C543.795227,305.787537 543.572021,305.544861 543.138672,305.162048 
	C542.949036,305.003052 543.018433,304.996796 543.023499,305.031311 
	C542.183411,304.163177 541.306641,303.291962 540.183350,302.231018 
	C539.951843,302.026245 540.000000,302.000031 539.987610,302.024536 
	C535.792725,298.263214 531.377869,294.867035 525.382324,293.465546 
	C522.363281,292.605347 519.741211,291.581085 516.592834,291.708862 
	C514.679688,292.062744 513.197388,292.032257 512.877808,289.538086 
	C512.792664,289.172852 512.935669,289.050934 513.003906,288.986267 
	C516.627014,286.241974 520.282288,289.209564 523.874695,288.719666 
	C523.934265,288.711517 524.018677,288.546600 524.011536,288.461548 
	C523.998291,288.303986 523.925903,288.151367 524.173706,287.735840 
	C524.723877,287.388489 524.978394,287.302002 525.642334,287.192505 
	C528.626953,287.126923 530.727905,290.898163 532.681641,289.394012 
	C534.677063,287.857758 533.344421,284.385376 533.438110,281.769501 
	C534.075378,263.974487 535.387268,246.214355 536.186646,228.431320 
	C536.693970,217.147583 537.901917,205.886429 537.610901,194.143433 
	C537.619446,193.147934 537.670044,192.581665 537.846436,191.598480 
	C538.215393,190.079285 538.643982,189.006622 538.508545,187.396057 
	C540.026123,168.607040 540.721680,150.185852 543.358093,131.513779 
	C544.077087,130.692322 544.636414,130.489182 545.710449,130.659821 
	C548.536072,134.661453 547.424622,138.845535 547.222717,142.923660 
	C547.132996,144.737823 546.688660,146.532288 546.555847,148.783356 
	C547.345642,153.900192 546.242798,158.452972 545.477600,163.438797 
	C545.409973,164.663239 545.389771,165.481781 545.409058,166.715485 
	C545.505432,167.967331 545.497986,168.807144 545.469604,170.073944 
	C544.498108,177.078430 544.743652,183.758972 543.664429,190.760559 
	C543.598145,197.300537 542.187195,203.330643 542.559753,209.899857 
	C542.511414,210.917908 542.476013,211.499023 542.478149,212.517334 
	C542.539062,213.536026 542.542175,214.118652 542.469849,215.136200 
	C541.198486,224.175140 541.433411,232.887100 540.496643,241.950317 
	C540.443420,242.967728 540.429077,243.550217 540.431519,244.572037 
	C540.471069,245.599365 540.488281,246.188034 540.457092,247.220795 
	C538.997375,253.475555 540.470764,259.584137 538.296204,265.673553 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M488.624329,900.028442 
	C489.290802,900.827637 491.565857,901.579407 488.721924,902.118164 
	C484.830231,902.855408 480.948334,903.866516 477.235596,905.231689 
	C475.404572,905.904846 472.615051,906.254028 472.295654,908.671631 
	C471.960358,911.209778 475.237030,910.577332 477.537506,912.523743 
	C472.665131,912.435181 470.561554,914.778503 468.316986,917.497559 
	C465.630829,920.751587 461.941254,922.727844 457.308167,922.031189 
	C453.946503,921.525757 451.446075,922.489807 449.413269,925.738098 
	C446.493805,930.403076 441.331024,931.569885 435.818695,932.482544 
	C435.442596,932.639648 435.427704,932.614990 435.415466,932.607178 
	C435.353455,931.471375 435.028229,930.241089 435.829620,929.298523 
	C439.122528,925.425659 437.790771,922.215393 434.667328,918.924866 
	C449.757355,911.240417 465.747620,906.716797 481.407440,901.314209 
	C483.578064,900.565308 485.942444,900.378113 488.624329,900.028442 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M39.264484,898.528442 
	C36.971092,899.607849 35.607880,902.229370 32.664165,902.525635 
	C30.603550,902.733032 31.113216,905.080688 31.000975,906.680969 
	C30.826347,909.170593 30.951992,911.879822 26.963978,911.974243 
	C26.009682,890.075012 25.865938,868.167664 26.643194,845.978149 
	C27.963417,845.013916 28.511030,844.096863 28.588818,842.532532 
	C29.112455,840.453186 29.109489,838.289001 32.194138,838.968628 
	C33.932011,841.664124 33.419273,844.320251 33.437386,847.354309 
	C33.485447,848.973267 33.626637,850.151184 33.466438,851.775818 
	C33.586212,855.489929 33.645947,858.759949 33.464863,862.477173 
	C33.422585,867.696289 34.090218,872.491943 32.839443,877.651733 
	C33.658936,885.151001 36.400070,891.667114 39.264484,898.528442 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M373.676086,541.277710 
	C374.048737,541.452271 374.034058,541.492737 374.025391,541.513184 
	C373.693848,543.209900 373.197021,544.872925 373.838379,546.911621 
	C374.105408,548.385620 373.736389,549.640198 375.038635,550.786377 
	C376.043610,552.730652 374.867859,553.830933 373.606171,555.259094 
	C371.897919,556.220459 370.901917,558.561584 369.260712,557.819214 
	C367.157349,556.867920 367.780579,554.405396 367.782257,552.461060 
	C367.783264,551.313599 368.145477,550.158020 367.533020,548.701172 
	C366.508942,547.594177 367.787323,545.732910 365.611328,545.573669 
	C364.547272,545.866211 363.829926,545.772339 362.831177,545.196045 
	C360.750732,541.332275 362.246368,537.212341 360.690002,533.163086 
	C360.104462,529.196289 359.945251,525.556091 358.414551,521.805542 
	C357.478394,518.845154 357.061096,516.148315 356.110107,513.285034 
	C355.738861,512.689026 355.661926,512.315735 355.588470,511.655823 
	C355.563812,510.276764 355.464996,509.185181 355.707581,507.711670 
	C365.943970,506.018738 372.981873,511.899170 373.012543,521.894897 
	C373.028168,526.979980 373.564301,532.110596 372.164642,537.145630 
	C371.772186,538.557434 371.714691,540.135254 373.676086,541.277710 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M348.982361,446.592407 
	C345.367889,458.604858 347.167969,470.332275 348.290436,482.026855 
	C349.446472,494.070618 350.764130,506.098816 351.972046,518.569580 
	C351.207672,519.516846 351.726868,522.241577 349.551239,520.366943 
	C349.502716,520.325073 348.581360,521.650452 347.249878,521.358948 
	C346.620178,520.888672 346.416382,520.482666 346.263550,519.682251 
	C346.535767,517.813416 345.712280,516.613831 344.970612,514.978638 
	C341.618652,496.777405 338.994354,478.898163 339.495636,460.696899 
	C339.713989,452.768524 341.253021,445.233826 345.658936,438.069733 
	C347.992340,437.149200 348.595886,438.345184 348.722473,439.982025 
	C348.882111,442.046570 349.278290,444.105499 348.982361,446.592407 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M152.878998,640.712646 
	C156.391541,650.803711 156.439316,661.163452 157.928970,671.294250 
	C159.274597,680.445496 159.429794,689.670166 158.421188,698.980957 
	C151.425110,679.132935 146.894135,658.698547 143.584320,637.519165 
	C144.973328,635.786194 146.417557,636.068298 147.530792,637.297363 
	C148.937195,638.850098 150.881104,639.417419 152.878998,640.712646 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M347.182861,518.681030 
	C347.084900,519.428406 347.095886,519.864746 347.183533,520.619873 
	C348.840302,523.395508 349.521301,526.033691 348.684448,529.315857 
	C348.279602,529.872498 348.064697,530.053101 347.446899,530.111450 
	C343.567841,518.654907 342.268738,506.914948 340.529510,494.825989 
	C340.567657,493.740692 340.141541,493.213806 339.961243,492.297302 
	C339.865845,491.612366 339.818787,491.238434 339.755127,490.582214 
	C339.058319,488.204834 337.839203,488.679779 336.327942,489.894104 
	C336.134491,490.162842 336.091309,490.194275 336.113831,490.208618 
	C336.136383,490.222961 335.789001,490.464539 335.581848,490.488037 
	C335.374725,490.511566 334.987244,490.403137 334.796783,490.366882 
	C334.606323,490.330658 334.258301,490.528809 334.100494,490.665222 
	C333.942688,490.801666 333.631744,491.105316 333.311157,491.431915 
	C332.990601,491.758514 332.643188,492.085510 332.456116,492.241638 
	C332.269012,492.397797 331.865875,492.684509 331.656921,492.820312 
	C331.165253,493.136902 330.886261,493.323242 330.414307,493.680298 
	C329.829071,494.192322 329.444031,494.542786 328.932465,495.145935 
	C328.547241,495.652069 328.335999,495.951965 327.980103,496.502594 
	C327.718536,496.911865 327.608246,497.075073 327.309509,497.474731 
	C326.979340,497.860474 326.837616,498.009705 326.458862,498.368073 
	C326.044739,498.699371 325.867615,498.821503 325.408661,499.110046 
	C322.408203,501.126312 321.068237,504.066742 319.148773,506.974518 
	C318.897156,507.490875 318.784302,507.691193 318.464661,508.166779 
	C315.714844,510.413086 314.441895,513.404297 312.168274,516.009521 
	C311.076111,517.159302 310.253143,518.108215 309.404541,519.428284 
	C309.107117,519.836548 308.983154,519.994141 308.661377,520.373657 
	C308.192963,520.872925 307.916779,521.144714 307.437408,521.610962 
	C307.113190,521.947449 306.985321,522.082458 306.676178,522.427124 
	C306.268677,522.932068 306.051147,523.233765 305.684814,523.781738 
	C305.409149,524.176392 305.289520,524.329956 304.970093,524.700439 
	C304.490479,525.206909 304.208130,525.493958 303.701630,526.005127 
	C303.313293,526.369873 303.147095,526.508484 302.701477,526.823364 
	C301.373383,527.510254 300.305695,527.854919 298.883026,527.137695 
	C298.421082,526.461670 298.330750,526.000183 298.406464,525.164551 
	C300.483765,521.156433 304.043762,518.790405 306.555359,515.067505 
	C309.427429,511.949158 311.760651,508.936981 312.727264,505.091003 
	C313.158539,503.374939 314.483856,502.378601 315.642517,501.168854 
	C321.511627,495.040955 327.228912,488.770020 334.313232,483.954620 
	C336.519684,482.454865 336.581757,480.041931 336.586731,477.666626 
	C336.599213,471.673676 336.536377,465.680176 336.613373,459.687958 
	C336.662506,455.862061 336.858063,452.037506 338.987396,448.325104 
	C340.305847,443.812927 343.117126,440.369080 345.197998,436.196167 
	C345.909576,436.178131 346.343658,436.407532 346.895416,436.863281 
	C347.180664,437.254364 347.348267,437.419098 347.204712,437.749359 
	C342.970306,444.297516 341.411255,451.384857 341.101746,458.728058 
	C340.300446,477.737854 342.592682,496.494080 346.195801,515.543579 
	C346.792664,516.688110 347.107300,517.501892 347.182861,518.681030 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M146.205368,926.769531 
	C146.543762,927.007690 146.486618,927.027039 146.474274,926.999512 
	C158.503799,932.349243 170.656952,937.461548 183.290802,942.388062 
	C183.900742,942.518860 184.148453,942.553284 184.713852,942.787292 
	C185.031525,942.986877 184.997284,943.004761 184.997925,942.985474 
	C191.432693,945.599060 197.735321,948.567200 204.722900,950.791138 
	C205.033829,951.000305 204.992355,951.012573 204.988220,950.991333 
	C209.844193,953.487122 215.638245,953.358948 220.606415,956.621704 
	C219.030609,961.734741 214.350906,963.065735 210.483490,962.319702 
	C202.645279,960.807617 195.196915,957.574036 187.893402,954.203125 
	C185.721054,953.200439 185.161026,952.376404 187.919189,950.988159 
	C189.092041,949.978760 189.172287,949.085632 187.798798,948.136414 
	C187.154221,947.983398 186.785507,947.982788 186.141052,947.954224 
	C185.098969,947.530945 184.694534,947.985474 184.168625,948.857483 
	C181.193558,955.269165 179.383224,950.214050 177.129303,948.237305 
	C176.218613,947.465637 175.859665,944.794922 174.281616,947.720337 
	C172.887833,947.995056 171.679642,948.137817 171.028076,946.416870 
	C170.824615,944.741577 171.736359,943.136902 170.114594,942.173035 
	C168.096573,940.973694 166.947525,942.845032 165.231476,943.810730 
	C164.419998,943.818787 163.866592,943.619263 163.153061,943.164612 
	C162.725632,940.203491 161.219315,938.886414 158.649475,937.865601 
	C153.747879,935.918518 148.947800,933.626587 144.583344,929.943176 
	C144.140350,928.834656 144.184662,928.066833 144.783020,927.004700 
	C145.326218,926.640808 145.596603,926.586121 146.205368,926.769531 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M405.428162,780.027466 
	C405.188202,777.050659 407.341705,775.288696 409.388550,773.133179 
	C412.182220,771.259583 413.990814,768.917847 415.641632,766.409546 
	C416.252167,765.481812 416.860535,764.305542 418.327026,764.636719 
	C421.924347,765.449280 421.927917,765.469055 424.126465,762.899475 
	C425.419952,761.387756 426.625366,759.807068 427.903381,757.848511 
	C431.083160,753.685425 433.976868,749.714111 438.850769,747.427429 
	C439.610901,747.534058 439.981262,747.734436 440.547546,747.898804 
	C441.037140,747.699280 441.253937,747.665710 441.795502,747.717407 
	C444.205872,749.183167 444.138611,750.901367 442.843719,752.753845 
	C441.831207,754.202332 440.600525,755.487671 439.494598,757.241333 
	C439.291260,757.697327 439.210388,757.873291 439.001007,758.293091 
	C438.706604,758.837463 438.573914,759.151428 438.522949,759.726074 
	C438.637207,760.285828 438.680542,760.609802 438.668884,761.186523 
	C438.651978,761.434143 438.527527,761.915466 438.429871,762.143433 
	C438.184814,762.667542 438.036774,762.963257 437.783142,763.485657 
	C437.597992,763.859863 437.517700,764.007080 437.295837,764.363159 
	C437.053070,764.707275 436.951874,764.842407 436.562378,765.399292 
	C436.188995,765.971924 436.103912,766.122925 435.895630,766.508057 
	C435.689362,766.901367 435.606293,767.060425 435.397003,767.460876 
	C435.102234,768.033142 434.935547,768.364990 434.645325,768.958679 
	C434.242462,769.747803 433.833160,770.166748 433.184998,770.769409 
	C424.169434,774.734192 415.702820,779.491882 405.428162,780.027466 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M366.676605,1006.164978 
	C367.371399,1005.636475 367.870148,1005.324463 368.675415,1004.989380 
	C369.674622,1004.183167 370.624268,1003.816406 371.769470,1003.195801 
	C375.066101,1003.462341 378.045380,1003.671814 381.014191,1002.221436 
	C383.055206,1001.224426 384.711395,1002.696106 386.637512,1003.936646 
	C385.782227,1000.983154 387.890198,1001.071289 389.802155,1001.045776 
	C392.265228,1001.012939 394.729095,1001.038391 397.590393,1001.029907 
	C399.304413,1001.666199 400.641449,1002.272705 401.931824,1002.966064 
	C403.584351,1003.854065 405.155304,1004.949463 404.921936,1007.101379 
	C404.614288,1009.938293 402.310333,1007.987671 401.158569,1008.558289 
	C391.846436,1013.171265 381.628662,1011.450623 371.867706,1012.712402 
	C369.653259,1012.998657 367.042664,1012.990784 364.305786,1012.951416 
	C363.802338,1012.808472 363.607208,1012.685425 363.218597,1012.275513 
	C362.218353,1011.457031 361.411652,1010.925354 360.321716,1010.304565 
	C359.233063,1009.033325 359.908508,1008.078613 360.737976,1006.869507 
	C361.126495,1006.484192 361.291656,1006.342590 361.709351,1006.001526 
	C362.698395,1005.325562 363.059265,1004.512939 363.925964,1003.729126 
	C364.630859,1003.455200 365.060089,1003.471313 365.740112,1003.803101 
	C366.006042,1004.450623 366.017212,1004.890808 366.037170,1005.661133 
	C366.190796,1006.121277 366.335693,1006.251343 366.676605,1006.164978 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M431.620667,431.027191 
	C435.360443,433.416199 433.444672,438.021210 436.178894,441.284668 
	C439.152039,444.833313 441.268921,449.555206 442.299255,454.096771 
	C442.874512,456.632477 446.676208,460.367096 441.496338,463.019165 
	C440.471069,464.485809 439.272308,465.376740 437.891846,465.869354 
	C433.707153,467.362640 430.197327,469.786957 426.617920,473.044067 
	C425.776947,472.263092 425.433624,471.806091 424.333008,472.008514 
	C425.128723,466.533783 426.367859,461.292297 429.752075,456.376068 
	C430.904053,454.702637 433.111664,451.280548 432.357300,447.733459 
	C432.481262,447.108185 432.373413,446.817413 431.918579,446.624634 
	C431.091431,446.563904 429.893127,446.495361 430.186401,445.936646 
	C432.695953,441.156067 430.274261,436.043396 431.620667,431.027191 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M102.845367,657.306519 
	C105.231094,658.495667 106.668953,652.735718 109.033089,656.846558 
	C111.253647,660.288086 110.647766,664.209534 112.321320,667.852417 
	C112.985397,673.923706 116.372421,678.955688 116.356392,685.180725 
	C116.970329,693.022827 120.187714,699.835938 121.692322,707.496704 
	C120.479324,709.542297 121.633446,712.284363 118.874199,713.408569 
	C115.468193,711.837952 115.017464,708.698303 114.155640,705.916016 
	C113.273148,703.066956 112.586998,700.162354 111.121994,697.090210 
	C108.155922,685.811523 104.687111,675.068604 102.797440,663.934082 
	C102.442017,661.839783 101.614357,659.745178 102.845367,657.306519 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M89.259491,728.791992 
	C85.645706,723.005981 85.458939,716.036438 83.081833,709.339172 
	C83.886353,706.854797 82.779083,704.819092 82.840294,702.737244 
	C82.876129,701.518372 81.635063,699.998779 83.106316,699.166321 
	C84.753304,698.234436 85.672020,699.944336 86.999878,701.139282 
	C87.393913,701.641113 87.529274,701.857056 87.810165,702.423218 
	C90.993645,715.408875 97.437660,726.476746 104.210510,737.327637 
	C108.426964,744.082886 113.007858,750.624695 117.796684,757.011780 
	C119.462265,759.233215 121.411903,761.392273 121.937134,764.664307 
	C122.543793,766.840271 123.165375,768.650452 124.086937,771.334229 
	C118.296593,768.402588 114.476639,764.724548 111.214752,759.923096 
	C111.434921,757.903015 111.434921,757.903015 107.995956,754.098816 
	C107.648735,753.649170 107.519829,753.460205 107.226730,752.967896 
	C104.913986,748.128662 102.528076,743.725098 99.427223,739.453796 
	C95.330872,737.479065 95.036674,733.282471 92.979057,730.259827 
	C92.293930,729.253357 92.258835,725.760376 89.259491,728.791992 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M274.712036,916.815552 
	C275.736206,919.750000 275.736206,919.750000 279.443146,917.370911 
	C278.390442,921.374817 281.511383,920.409058 283.661926,921.105164 
	C280.815674,923.349548 278.837036,929.113281 273.354736,924.771179 
	C273.205658,924.653076 272.421539,925.081848 272.141266,925.425232 
	C270.151215,927.862793 267.252411,928.503235 264.530670,929.648987 
	C261.929474,930.744080 259.404938,932.136597 258.138641,935.175720 
	C256.950684,938.026733 254.627457,938.896179 251.262726,936.769531 
	C252.523270,932.485046 255.746201,929.530457 258.561188,925.899963 
	C263.262634,923.005737 265.115173,918.220886 267.818726,914.196655 
	C269.503357,911.689026 266.104828,912.262390 264.851746,911.082947 
	C263.935608,909.606995 264.167572,908.440735 265.073730,907.011230 
	C265.850616,906.189392 266.492035,905.841858 267.594971,905.716064 
	C269.634552,908.150024 271.506683,907.912964 273.677490,905.873901 
	C274.000366,905.434998 274.135315,905.265930 274.497986,904.870850 
	C275.221161,904.262268 275.770142,903.975586 276.633148,903.649292 
	C277.121735,903.540833 277.324341,903.522339 277.831940,903.516235 
	C278.543274,903.506897 278.917511,903.383362 279.517029,902.987427 
	C279.968292,902.722412 280.166901,902.643066 280.689758,902.549133 
	C281.591858,902.250244 282.294220,903.648254 282.925232,902.132446 
	C283.866669,901.044434 284.882812,900.983276 286.244965,901.159729 
	C287.116058,901.376526 287.687286,901.468994 288.524078,901.029297 
	C289.397644,900.511414 290.047638,900.370972 291.099854,900.519470 
	C292.694153,901.173889 293.625793,901.951782 293.260559,903.822876 
	C288.094513,905.677185 283.107391,907.137573 278.167664,908.743835 
	C274.277283,910.008850 272.752289,913.404602 274.712036,916.815552 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M153.184830,640.533936 
	C148.906708,642.766296 147.454712,638.150085 144.013214,637.061890 
	C143.344406,635.965759 143.107834,634.854431 142.869720,633.397949 
	C142.944077,632.480591 142.873856,631.936951 142.397369,631.208557 
	C140.612701,620.753113 140.130920,610.356384 137.222321,599.926697 
	C136.884705,599.575195 136.925247,599.533020 136.944046,599.527588 
	C136.149246,597.268066 136.584061,594.949585 136.966614,592.309387 
	C140.961456,590.790039 137.260529,586.553772 140.484375,584.986450 
	C142.456390,593.129639 142.449982,601.585571 144.299103,609.841614 
	C146.607712,620.149109 150.684708,629.898376 153.184830,640.533936 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M149.440552,834.095703 
	C147.001541,830.456360 143.920517,833.920227 141.098846,833.011108 
	C140.634705,830.444702 142.488632,829.665710 144.204193,828.774597 
	C141.660828,829.693481 139.246780,831.188843 136.160187,830.049438 
	C136.386353,827.617126 138.642380,826.060181 137.981628,823.160278 
	C149.068665,819.140137 160.165802,815.513245 171.613968,811.931702 
	C164.517273,819.271790 157.698807,827.200500 149.440552,834.095703 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M119.237717,634.219971 
	C117.539154,630.529907 118.282829,626.894043 118.445320,623.146179 
	C120.178268,628.420654 122.400490,633.442444 125.150948,638.623901 
	C126.320709,643.003723 129.044083,646.328003 130.085510,650.375488 
	C130.665390,652.629028 132.964813,652.546753 134.513977,652.746216 
	C136.417603,652.991333 137.596741,653.636169 138.594849,655.529419 
	C140.302383,661.430237 139.709900,666.953064 137.802856,672.373230 
	C137.218674,674.033630 136.197739,675.290588 134.118851,674.986938 
	C131.234451,674.565796 134.654953,673.153625 133.610931,672.076538 
	C131.249481,669.640320 128.588242,667.484741 127.694519,663.769104 
	C125.664650,655.330139 123.144997,647.009949 120.992920,638.598450 
	C120.620583,637.143127 120.447891,635.684326 119.237717,634.219971 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M402.050110,727.528809 
	C401.943420,727.831848 401.877960,728.201294 401.863525,728.388367 
	C399.150726,732.291321 394.383118,732.167847 390.580261,734.610291 
	C388.629974,735.290955 386.951904,735.561584 384.973694,736.101318 
	C382.992493,736.373169 381.447693,737.147461 379.415436,736.821533 
	C362.303864,741.894653 345.810181,747.881775 329.090393,754.242065 
	C328.761292,754.696777 328.722534,754.962280 328.282959,755.275146 
	C327.353485,755.176819 326.887573,754.918091 326.280060,754.197937 
	C326.243317,753.713623 326.410736,753.578125 326.784485,753.193970 
	C350.473389,742.074707 374.702637,733.138062 399.636292,725.054688 
	C401.058044,725.459534 401.948456,726.004578 402.050110,727.528809 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M45.599396,891.705811 
	C47.637112,886.963928 50.204746,886.516846 54.597805,888.572571 
	C59.046715,890.654358 63.687675,892.588318 68.995644,892.713806 
	C72.924210,892.806824 76.810608,894.682190 80.887863,896.141052 
	C72.524933,901.147339 63.567848,902.060364 54.234833,899.527100 
	C51.686375,898.835388 49.162289,898.053833 46.288055,897.136108 
	C46.657722,895.242981 45.598190,893.707825 45.599396,891.705811 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M375.774323,326.313446 
	C378.714996,323.851257 381.570679,321.876526 384.186005,319.622864 
	C385.188049,318.759338 387.235779,317.145203 384.054443,316.179810 
	C382.858124,315.816711 383.211182,315.090424 383.337799,314.277924 
	C384.536316,306.588318 398.190491,297.055939 406.394287,298.495239 
	C408.288391,298.997833 409.757568,299.505402 411.560059,300.078979 
	C412.097198,300.259338 412.301056,300.373718 412.207977,300.674561 
	C406.545654,301.030487 401.447205,302.276886 396.328888,304.865540 
	C395.381470,307.007233 393.214294,307.043579 391.760345,308.463745 
	C391.175415,308.862091 390.874115,309.115356 390.413788,309.583405 
	C390.230164,309.769501 389.890778,310.116913 389.698425,310.237671 
	C389.506073,310.358459 389.641693,310.774292 389.461670,310.654968 
	C389.597229,310.452209 389.839630,310.270294 390.191772,309.808807 
	C390.635162,309.369019 390.903351,309.118652 391.424011,308.701050 
	C393.082306,307.516907 394.557037,306.665405 396.689453,306.745178 
	C401.752258,306.096954 406.526947,303.823120 411.915588,307.321411 
	C404.302551,308.911652 396.953979,310.244324 392.377563,316.249573 
	C388.345276,321.540833 383.037750,324.497314 377.258942,327.058685 
	C377.108643,327.125244 376.941833,327.154541 376.417419,327.294312 
	C375.899231,327.154816 375.746338,326.922272 375.774323,326.313446 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M144.880493,926.808167 
	C144.977371,927.892578 144.992615,928.608521 145.017822,929.682495 
	C146.478790,931.869385 145.467697,933.313965 144.141739,935.066650 
	C141.193481,940.120361 139.415100,945.380737 136.080780,950.221191 
	C134.181458,952.480408 133.460083,955.344788 130.284790,956.095093 
	C128.305298,953.917419 129.667404,952.149170 130.593750,950.485657 
	C134.130417,944.134521 137.586746,937.744873 140.495636,931.066528 
	C137.565903,938.066956 133.632950,944.537842 130.120712,951.230530 
	C129.408707,952.587402 128.057861,954.061584 129.981415,955.939819 
	C131.104370,958.243774 131.161926,960.344238 130.227905,962.746887 
	C129.996460,963.023987 129.995438,962.995911 130.009491,962.995483 
	C128.355789,964.418579 127.938560,966.954895 125.365204,967.921997 
	C121.985176,967.439026 121.591484,963.417664 118.112961,962.892700 
	C116.704170,960.319885 118.733994,958.902649 119.823807,957.213196 
	C121.149498,955.158264 122.807823,953.317688 123.931473,950.695190 
	C129.058472,943.511597 132.259888,935.704773 136.004303,928.202026 
	C138.927383,922.345093 139.164795,922.189575 144.880493,926.808167 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M340.367004,432.295105 
	C322.865662,437.117889 306.186737,443.383484 289.310852,450.204468 
	C288.507477,450.636078 288.002441,450.718903 287.105286,450.516479 
	C285.585724,449.578339 285.082306,448.433990 285.023193,446.694092 
	C285.110840,446.083923 285.176086,445.848083 285.422729,445.300354 
	C288.289246,443.824066 291.375580,444.028137 294.277649,442.409729 
	C294.802399,442.205994 295.014252,442.129395 295.546783,441.947296 
	C297.175507,441.488068 298.418274,440.975525 299.903534,440.143127 
	C303.451538,438.527069 307.063080,438.129272 310.556671,436.315308 
	C313.149902,435.401794 315.418060,434.642883 318.059479,433.889526 
	C319.078430,433.639618 319.768921,433.529633 320.720032,433.091736 
	C325.583038,431.126648 330.224121,429.615601 335.079163,428.829346 
	C336.149780,428.656006 337.536377,428.838043 337.218628,426.666931 
	C337.457306,423.710602 337.435364,421.065582 338.162201,418.536469 
	C338.524292,417.276581 339.140900,415.883270 340.689331,415.926605 
	C342.198364,415.968872 342.629822,417.340698 343.187714,418.591125 
	C344.160614,420.771790 343.318542,423.172089 344.107056,425.690491 
	C343.339600,427.473297 342.695160,428.885468 342.025879,430.632416 
	C341.835480,431.680450 341.369171,432.108398 340.367004,432.295105 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M118.310135,713.691284 
	C120.949883,712.381958 117.879860,708.762146 121.371140,707.996460 
	C123.414322,712.952454 125.366112,717.920105 126.676445,723.051453 
	C131.018738,740.056152 139.589569,755.062500 148.339294,770.013062 
	C149.267929,771.599792 151.773041,773.277527 148.341919,775.177856 
	C146.320923,772.487793 143.749756,771.019348 141.213852,769.512634 
	C139.646484,768.581421 138.194992,767.535889 137.209641,765.525391 
	C136.745895,762.704895 135.226334,760.548401 135.045654,757.696960 
	C135.147110,756.979065 135.248688,756.586182 135.423187,755.923706 
	C135.411423,755.462830 135.357498,755.279846 135.176620,754.833374 
	C134.862656,754.209412 134.677536,753.848083 134.342880,753.195312 
	C134.097244,752.700256 134.002853,752.495667 133.784851,751.968872 
	C129.729675,741.541931 124.178070,732.180908 120.114319,722.137207 
	C119.059464,719.530090 117.607895,717.016541 118.310135,713.691284 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M279.429871,703.182739 
	C276.925446,701.679810 274.794525,700.439270 272.329865,699.132446 
	C270.959137,699.543457 270.047913,699.079102 269.197144,698.600708 
	C260.711761,693.829346 252.535034,688.602783 245.196503,682.156799 
	C244.445679,681.497375 243.832550,680.726440 243.514648,679.375488 
	C244.660828,676.232849 246.431839,677.690308 247.923523,678.507996 
	C250.816177,680.093445 253.342575,682.286682 256.659973,683.881104 
	C257.608154,684.386597 258.197235,684.788757 259.069092,685.400085 
	C261.758667,687.968933 263.757355,687.988098 265.360901,684.698242 
	C265.924347,683.542297 266.731781,682.452637 268.624695,682.720581 
	C270.517944,685.651428 268.431854,687.536072 267.052917,689.889038 
	C266.550842,690.496399 266.010040,690.706726 265.988556,691.223206 
	C265.970886,691.648071 266.050049,691.574768 266.207245,690.784058 
	C266.883881,690.156250 267.378326,689.807983 268.290680,689.646973 
	C268.777466,689.697815 268.964233,689.762634 269.385040,689.982788 
	C273.781219,687.686768 274.477356,683.087708 276.608887,678.978638 
	C277.253906,678.503601 277.694855,678.398987 278.493042,678.483154 
	C279.612823,678.739868 279.519287,680.711182 281.237183,679.463989 
	C282.240143,679.174316 282.902435,679.252197 283.745300,679.884338 
	C283.891327,680.586426 283.814362,681.022400 283.846863,682.100769 
	C283.737823,684.445435 282.738983,685.870728 282.171936,687.780701 
	C281.991547,688.268005 281.912140,688.459656 281.690735,688.926331 
	C281.440613,689.375854 281.332458,689.550476 280.899963,690.245361 
	C280.284363,691.315613 280.025360,691.880127 279.689148,692.767944 
	C276.702148,698.355347 276.728149,698.396973 283.432739,698.656860 
	C285.854401,698.695435 287.979675,698.485291 289.773071,700.534729 
	C289.975006,701.603088 290.002625,702.319519 290.047302,703.394043 
	C286.553650,706.670959 283.192719,704.583191 279.429871,703.182739 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M63.922638,992.443237 
	C68.572357,992.009705 73.229851,992.032715 78.297974,992.246460 
	C79.418282,997.874329 80.800354,1003.146912 82.807091,1008.738586 
	C77.549896,1008.210938 72.502853,1008.091614 67.489067,1008.807190 
	C65.008194,1009.161316 64.877411,1007.631531 64.783096,1005.804504 
	C64.560875,1001.499695 64.222061,997.200867 63.922638,992.443237 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M191.108734,785.911377 
	C188.061630,785.764771 188.593033,783.184570 188.009949,781.565918 
	C186.500992,777.376770 185.424667,773.031799 184.060287,768.389221 
	C181.989487,765.667480 182.999832,762.588196 181.906860,759.657227 
	C179.751205,751.457825 180.260544,743.313660 179.221039,735.331604 
	C178.500488,729.798767 178.576202,724.162292 178.524094,718.242249 
	C181.026230,717.564758 180.850555,719.435242 181.163208,720.706604 
	C182.099976,724.515808 182.406815,728.412292 182.768555,732.681763 
	C182.995987,733.040100 183.015472,732.993042 182.991272,732.985168 
	C183.802673,733.942261 183.371902,735.115601 183.540192,736.614197 
	C186.448029,748.620361 188.372726,760.417664 191.309662,772.405884 
	C189.345490,777.114319 192.777069,781.358948 191.108734,785.911377 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M367.611969,548.163025 
	C371.102631,550.619385 367.644104,554.118774 369.358490,556.955627 
	C370.346008,556.575623 370.478333,554.649597 372.459595,554.988770 
	C373.465363,555.046570 374.080231,555.270264 374.638214,555.632568 
	C377.144104,557.259705 379.150940,558.315613 379.894196,553.831238 
	C380.232361,551.790771 381.205627,549.324585 384.166199,548.762329 
	C383.317139,553.285278 383.393585,557.777771 383.040527,562.235779 
	C382.610626,567.664246 380.637146,572.416809 375.549988,575.539185 
	C368.822388,569.846008 363.274445,563.802002 365.425018,553.832703 
	C365.753418,551.626343 365.623138,549.675964 367.611969,548.163025 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M350.232361,373.694458 
	C349.613495,374.716370 349.181549,375.475616 348.495178,376.445007 
	C347.660065,376.511871 347.125305,376.111908 346.198242,376.500916 
	C345.070404,378.036743 342.956970,376.028412 342.092468,378.240967 
	C341.211365,378.808380 340.537262,378.872162 339.509888,378.602417 
	C338.810028,378.162079 338.554504,377.781128 338.448151,376.961304 
	C338.163788,376.084900 339.809570,375.996826 338.563904,374.996857 
	C338.107819,374.000610 338.054474,373.278564 338.145782,372.172302 
	C338.292969,371.306091 338.388245,370.809753 338.491547,369.923462 
	C338.285828,360.674805 339.283081,351.933838 341.200134,342.912964 
	C342.692352,340.705719 343.687836,341.814636 344.972748,342.815735 
	C346.789825,344.231537 347.259033,347.232727 350.343933,347.229340 
	C351.100861,347.228516 351.491364,348.346741 351.334930,349.256683 
	C351.206757,350.002380 350.646362,350.453613 349.956390,350.467773 
	C348.816589,350.491150 347.659790,350.644379 346.936157,350.464813 
	C348.896088,350.661438 351.465515,350.333954 353.481262,352.749146 
	C354.568542,356.248322 354.599579,359.608551 355.573853,363.162659 
	C355.395538,363.790405 355.269928,364.025024 354.820374,364.493652 
	C354.249512,364.826019 354.002563,364.924347 353.365906,365.102112 
	C351.624756,365.406403 350.433624,364.747467 348.804443,364.398285 
	C347.668091,363.568451 346.718170,363.427307 345.352356,363.479858 
	C343.956879,363.293701 342.956024,362.888062 342.972656,361.704102 
	C342.993774,360.203949 344.323700,360.700134 345.202759,360.504822 
	C346.383667,360.242462 348.525513,361.271454 348.550842,359.604309 
	C348.577881,357.822784 350.022278,355.208893 346.970337,353.913666 
	C346.672668,353.544220 346.439484,354.808624 346.788788,354.240784 
	C346.922791,354.022949 347.009308,354.157196 347.266388,354.344543 
	C348.590515,355.309784 349.055908,356.265198 347.399292,357.342896 
	C347.265259,357.430084 346.863861,357.276947 346.989349,357.509674 
	C348.379517,360.088165 348.403351,360.245453 345.577057,360.438965 
	C342.886353,360.623108 341.351654,360.936554 344.641418,363.446533 
	C345.678650,363.514771 346.374298,363.505432 347.394165,363.676575 
	C349.433655,364.558105 351.141357,365.320007 352.297546,367.376160 
	C353.014648,368.458954 353.346741,369.319336 353.346008,370.608887 
	C352.612061,372.094208 350.813049,371.952209 350.232361,373.694458 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M344.688721,993.961853 
	C346.135315,993.882751 347.269806,993.837463 348.830109,993.786804 
	C350.153229,996.439514 348.941956,999.195312 349.744873,1002.215698 
	C349.987000,1003.046936 350.099274,1003.529114 350.261322,1004.381165 
	C350.472076,1005.970764 350.926056,1007.184387 350.218719,1008.721680 
	C348.601715,1009.010742 347.215302,1009.006531 345.416321,1009.002502 
	C344.813995,1006.973328 349.272736,1005.313232 345.125366,1002.898804 
	C343.116852,1001.630493 342.773651,999.493164 341.380157,998.050537 
	C339.672821,999.239563 339.849304,1001.851074 337.423248,1002.729004 
	C333.966553,1002.527771 330.916748,1005.189697 327.326416,1003.143677 
	C322.373932,1002.570801 317.769409,1002.655640 313.191101,1003.068787 
	C310.509735,1003.310669 309.016144,1002.530518 308.955322,999.357178 
	C308.993225,998.563416 308.989410,998.131775 308.984497,997.377075 
	C316.964752,995.273376 325.188782,996.390259 333.212616,995.017395 
	C335.815735,994.571960 338.483826,994.506653 341.529510,994.246826 
	C342.791687,994.590088 343.559875,994.035767 344.688721,993.961853 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M512.684143,479.041565 
	C513.571167,474.461487 512.349609,470.049347 511.580566,465.704224 
	C510.360443,458.810059 511.664398,452.186066 512.331970,445.456970 
	C512.710632,441.639862 515.236389,440.397644 518.919556,439.944580 
	C515.492920,448.936646 517.448547,458.439606 517.201843,467.762421 
	C517.084290,472.205841 517.452026,476.662140 517.723511,481.560181 
	C519.021912,482.802002 519.117920,483.996857 518.987976,485.615967 
	C518.834412,486.210632 518.744690,486.441223 518.433838,486.971436 
	C518.003235,487.405060 517.793762,487.539093 517.229980,487.790588 
	C516.629395,487.941467 516.382935,487.974854 515.763794,488.000061 
	C513.385498,487.592682 511.563202,486.925507 510.751526,484.439240 
	C512.803101,483.744324 513.972839,482.677521 511.830658,481.256378 
	C509.218842,479.523743 511.480865,479.616760 512.684143,479.041565 
z"/>
<path fill="#F7EBCF" opacity="1.000000" stroke="none" 
	d="
M415.807861,660.082703 
	C415.423981,662.447876 416.877075,663.794250 417.663147,665.379456 
	C424.422333,679.010010 431.515076,692.481934 437.524963,706.805176 
	C435.854187,710.589355 434.023865,710.575317 431.968018,706.989014 
	C427.998627,700.064636 425.383911,692.521423 421.681580,685.118896 
	C421.260101,684.794556 421.050751,684.732910 420.607971,684.441162 
	C419.554413,683.170715 419.197357,681.892761 418.459778,680.446472 
	C418.008972,679.355713 417.787537,678.526855 417.379456,677.423340 
	C416.985596,676.316345 416.766052,675.487549 416.269379,674.409485 
	C416.031006,673.911499 415.935547,673.710144 415.703186,673.199707 
	C414.612976,669.825867 412.932007,666.952393 413.176941,663.244873 
	C413.399231,661.743103 412.521057,660.545044 413.673096,659.227295 
	C414.704346,658.974609 415.300964,659.231140 415.807861,660.082703 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M440.342438,960.005371 
	C435.932129,961.686646 431.865051,963.387939 427.423981,965.136230 
	C424.425934,964.163330 425.579773,963.058167 427.223083,961.733887 
	C427.768127,961.231873 428.064758,960.941101 428.543427,960.457153 
	C428.728058,960.266541 429.047943,959.901611 429.092590,959.763428 
	C429.071014,959.787964 429.004852,959.950806 428.727661,960.293823 
	C428.234009,960.757996 427.947845,961.038330 427.399292,961.526062 
	C425.219696,963.047607 423.248871,963.722900 420.905701,961.905884 
	C420.675873,961.097168 420.773865,960.631226 421.253540,959.923218 
	C425.276001,956.765381 429.735809,954.879944 433.601105,951.518372 
	C433.998413,951.150391 434.159271,951.008057 434.577911,950.679443 
	C435.528839,950.059021 436.310059,949.771423 437.168976,949.035034 
	C437.560852,948.721252 437.721313,948.600769 438.132538,948.317078 
	C438.874847,947.832336 439.410248,947.565491 439.933990,946.816406 
	C440.255981,946.429810 440.395721,946.283569 440.803650,945.995422 
	C444.462250,946.877991 447.852661,947.902466 451.623596,948.967896 
	C453.861267,948.204712 455.611572,948.560852 456.837006,950.038269 
	C457.610840,950.971375 456.451019,951.743958 455.572723,952.668091 
	C455.135376,953.024170 454.954285,953.157959 454.489075,953.471191 
	C453.816559,953.869751 453.424377,954.081909 452.737915,954.452881 
	C452.251831,954.728699 452.056122,954.838440 451.562073,955.107300 
	C447.697906,956.764221 444.501007,959.082153 440.342438,960.005371 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M379.035675,737.076538 
	C380.497620,736.187073 381.916412,735.660339 383.671753,735.171509 
	C385.519867,739.162109 382.683075,742.018127 381.357544,745.197876 
	C380.300079,747.734436 378.275513,749.806274 377.216675,752.773315 
	C371.603302,759.973572 366.162659,766.878540 360.468506,774.001831 
	C357.823792,773.995056 358.145203,772.418396 358.711975,770.389038 
	C364.987549,758.742432 371.544037,747.815369 379.035675,737.076538 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M392.398499,499.052734 
	C390.770905,497.994720 391.026520,496.605896 391.242340,495.322876 
	C392.862183,485.692078 394.217682,475.999664 396.335754,466.477783 
	C397.249176,462.371368 395.836182,461.906555 392.577606,461.955383 
	C387.798553,462.026978 383.380829,460.986023 379.995972,456.871094 
	C379.694916,454.837555 380.261719,453.272980 380.819305,451.720703 
	C381.592316,449.568726 383.092102,449.237183 384.551727,450.814941 
	C387.565643,454.072723 391.544617,454.921204 395.577728,455.880096 
	C400.524567,457.056244 401.925476,459.135742 401.491577,464.731628 
	C401.191315,465.815826 401.063171,466.531738 400.934509,467.611877 
	C398.333435,478.369904 397.495392,489.224365 392.398499,499.052734 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M486.097656,519.774902 
	C479.437653,514.538940 474.522644,520.378540 469.673553,522.590088 
	C461.196198,526.456543 452.250763,522.935791 450.006042,513.421509 
	C450.392303,512.137146 451.016724,511.527802 452.367920,511.449463 
	C452.912872,511.602234 453.116974,511.706573 453.573456,512.042236 
	C455.250153,513.477783 455.918854,515.584534 458.403320,515.753418 
	C458.886566,515.577759 459.082489,515.514526 459.585388,515.425415 
	C460.298187,515.458191 460.686249,515.573792 461.316681,515.886475 
	C463.244446,516.827271 464.659363,513.233826 466.431274,516.054810 
	C466.230225,516.745789 465.734192,517.049316 465.747101,517.430054 
	C465.764648,517.945801 465.913452,517.987732 465.826782,517.560181 
	C465.770935,517.284607 465.916229,517.037476 466.472778,516.670715 
	C470.832794,517.558289 472.950012,516.145020 472.815796,511.769073 
	C472.786255,510.805695 473.054413,509.848175 473.896484,508.792725 
	C476.093506,507.886444 477.869293,508.647766 479.284943,509.658691 
	C481.640472,511.340820 484.361298,511.801178 487.227203,512.951965 
	C487.978119,515.490173 487.513031,517.566528 486.097656,519.774902 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M122.202003,764.898193 
	C109.813354,748.012024 97.134178,731.343933 89.323112,711.696533 
	C88.283463,709.081482 86.887009,706.582886 86.978798,703.234741 
	C89.382942,702.819580 89.736420,704.947876 90.624283,706.413879 
	C97.593788,717.922241 104.131065,729.690369 111.601974,741.318176 
	C114.895065,749.082092 119.326653,755.742615 124.063782,762.540894 
	C123.501076,763.518005 122.991432,764.142151 122.202003,764.898193 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M182.219452,937.987793 
	C181.549561,937.358643 181.238831,936.680054 180.892319,935.606934 
	C191.102417,927.874390 201.713501,921.041016 211.198456,912.658875 
	C213.958282,910.219971 213.526413,909.282410 210.135376,908.385864 
	C207.382523,905.273254 211.753769,905.408142 212.165222,903.536011 
	C214.012299,902.833252 215.542770,902.960999 217.449921,903.475159 
	C220.299011,904.467468 222.972443,904.559631 225.737915,905.753296 
	C226.049530,905.994873 225.993759,906.006104 225.993896,905.977661 
	C226.377762,906.371643 226.856766,906.525757 227.647141,906.324402 
	C227.878311,906.194885 227.892365,905.993652 227.930054,905.900146 
	C228.417877,905.556519 228.894180,905.487854 229.654938,905.871582 
	C230.023590,906.437500 230.205460,906.678589 230.662109,906.971069 
	C232.186600,908.579224 230.929230,909.364807 229.656418,910.427368 
	C228.862778,910.799683 228.253021,911.175659 227.914566,910.984619 
	C223.679138,908.594116 221.333374,912.149719 218.304184,913.842285 
	C207.685257,919.775635 198.528412,927.744324 188.739777,934.831177 
	C186.842087,936.205139 184.919128,937.470215 182.219452,937.987793 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M391.969727,499.434509 
	C394.265106,494.363312 394.728210,489.204346 395.829285,484.237793 
	C397.018127,478.875397 398.437256,473.616516 400.705872,468.249451 
	C402.424133,471.041809 402.544098,474.309814 402.044189,477.830261 
	C400.050812,480.250885 401.114746,483.315277 399.168121,485.746399 
	C396.933533,495.840729 395.015564,505.724854 392.914093,515.569824 
	C391.678406,521.358948 390.151215,527.085876 388.222260,532.786133 
	C388.222260,529.188477 388.222260,525.590881 388.178101,521.537842 
	C389.405487,514.000305 390.677032,506.918030 391.969727,499.434509 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M351.864868,551.616943 
	C352.014099,549.556702 352.147980,548.187561 354.416870,547.870056 
	C356.663391,551.757690 358.490723,555.699402 360.571503,559.885132 
	C365.316864,565.769958 369.233276,571.834167 373.735779,577.880005 
	C377.053375,582.211365 380.641846,580.741028 384.601868,578.794983 
	C385.106628,578.872437 385.263245,579.083740 385.471008,579.686707 
	C381.581848,585.200928 374.470459,586.034912 368.836761,581.739380 
	C362.007782,576.532471 358.277802,569.089722 354.767029,561.111633 
	C354.333740,558.510132 351.741089,557.661926 351.328003,555.113098 
	C351.297241,553.905029 351.533264,553.069031 351.864868,551.616943 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M475.997559,955.652100 
	C473.947449,957.745605 470.412476,956.653809 468.281494,959.556152 
	C462.549255,960.458374 458.009155,963.830078 452.339233,965.098267 
	C451.854858,964.962402 451.755585,964.784546 451.768860,964.377930 
	C451.881470,964.149170 452.111664,963.951416 452.121887,963.994385 
	C452.132080,964.037415 451.791382,964.169800 451.636017,964.332947 
	C450.511597,965.227966 449.404388,965.569092 447.885437,965.615417 
	C447.367798,965.485657 447.171234,965.394226 446.776337,965.043945 
	C446.449738,964.359558 446.455292,963.933960 446.785339,963.257751 
	C447.610626,962.395996 448.229218,961.786560 449.063843,960.933228 
	C449.654877,960.258362 450.384796,960.307861 450.629242,959.706299 
	C450.362274,960.091980 449.893402,960.200378 449.308441,960.711182 
	C448.420898,961.574341 447.774597,962.209045 446.887939,963.101807 
	C446.006622,963.782288 445.310181,963.853333 444.230988,963.602600 
	C443.241302,963.059692 442.807770,962.480286 442.509155,961.399902 
	C444.454620,957.445129 448.790527,957.098511 451.755615,954.257507 
	C452.013092,954.013306 452.000000,954.000000 452.004364,954.007324 
	C452.432373,953.573120 453.022522,953.528381 453.787384,953.186707 
	C454.012878,953.010803 454.000000,953.000000 454.002899,953.008179 
	C461.921814,947.528564 468.715881,952.641724 475.997559,955.652100 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M344.328186,425.860199 
	C342.747375,424.643860 342.260406,423.237274 342.817047,421.199005 
	C343.274200,419.525055 342.445160,417.715302 340.670746,416.173798 
	C338.005127,419.198364 339.281921,422.982208 338.358582,426.612640 
	C338.047058,427.120697 337.826599,427.243256 337.227203,427.336884 
	C336.380981,427.087402 335.981750,426.778748 335.454926,426.052612 
	C334.868378,424.765137 334.770172,423.752502 334.672302,422.361420 
	C334.641663,421.740051 334.633728,421.492798 334.619507,420.877441 
	C334.102722,417.169647 336.168488,413.205933 331.980591,410.425690 
	C331.514069,409.702393 331.408447,409.226227 331.532104,408.371338 
	C334.314545,406.620209 335.043640,404.331177 334.611481,401.142029 
	C334.603027,399.503540 334.630737,398.236328 334.600586,396.584045 
	C334.528290,394.921661 334.604065,393.644257 334.596313,391.994812 
	C334.604248,391.379883 334.605896,391.137024 334.610626,390.536072 
	C334.264801,387.897614 335.878540,385.190735 332.903412,383.170593 
	C332.144592,381.565887 332.875580,380.569061 333.791260,379.253326 
	C334.963104,375.962433 334.474213,372.897827 334.534790,369.469147 
	C334.560394,368.529724 334.579651,367.988251 334.577820,367.026672 
	C334.507904,364.867950 334.578308,363.153778 335.838715,361.315247 
	C340.205902,363.357910 338.201019,367.192535 338.278320,370.365906 
	C338.353790,373.463226 337.366333,376.594391 339.143738,379.945496 
	C339.834778,381.050110 340.065979,381.875183 340.266693,383.149048 
	C340.338318,383.850281 340.356934,384.130737 340.396240,384.830627 
	C340.524109,386.360474 340.400848,387.469849 340.406799,388.992676 
	C340.435730,392.689178 340.597748,395.974731 340.230103,399.643250 
	C338.497681,404.128998 340.383545,407.713074 341.822296,411.733154 
	C343.521790,416.467010 344.862091,420.903107 344.328186,425.860199 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M116.710930,788.801025 
	C117.484879,789.186584 117.947914,789.519653 118.659996,789.993896 
	C120.827759,790.759827 123.120872,790.062012 124.923462,791.959045 
	C125.267769,792.419067 125.501266,792.579712 125.688919,792.474976 
	C125.559761,792.332703 125.649574,791.947327 125.777939,791.796753 
	C128.730988,790.007812 132.699203,791.688721 135.121216,788.206055 
	C139.507217,789.765991 140.949799,794.146667 143.815552,797.681091 
	C143.087601,800.084717 141.685562,800.172302 139.549225,799.873718 
	C136.491028,799.446350 133.218826,797.555481 130.228836,800.651245 
	C129.011383,801.911804 127.843246,800.202454 126.939537,799.384277 
	C124.957657,797.590088 122.864410,797.376831 120.201736,798.654663 
	C117.068443,799.313477 115.342163,797.736206 113.646400,795.455444 
	C112.945030,794.284363 112.691582,793.238953 111.666321,792.328796 
	C111.262787,792.040527 111.099777,791.926880 110.686523,791.649048 
	C110.093483,791.269104 109.757401,791.043274 109.184212,790.612122 
	C108.816933,790.245239 108.692253,790.075439 108.472473,789.601440 
	C108.279541,788.152100 108.707626,787.200012 109.730377,786.197632 
	C110.810516,786.679932 111.614655,787.329529 112.686493,788.140198 
	C114.128960,788.248657 114.980118,790.689941 116.710930,788.801025 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M124.357002,762.986694 
	C117.813545,757.445862 114.362511,750.203491 110.902359,742.574829 
	C112.711143,740.435242 113.951263,742.031738 114.886108,743.235840 
	C121.320122,751.523071 129.528412,757.902771 137.749817,764.803345 
	C139.335632,767.839722 142.406860,768.325989 144.552795,770.034424 
	C146.030579,771.210815 148.252045,771.781921 147.969330,774.719971 
	C139.664459,772.117981 132.673935,766.651367 124.357002,762.986694 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M87.556038,992.491821 
	C88.519341,998.656311 89.660728,1004.450562 90.802116,1010.244873 
	C83.988670,997.955505 80.089165,985.057495 82.449493,970.858032 
	C83.097374,966.960449 83.149521,962.866943 86.219376,959.377747 
	C88.683937,960.136597 88.785820,962.668762 90.364388,964.639160 
	C90.902931,969.308716 87.593330,972.501038 87.265236,976.817810 
	C86.870789,982.007568 87.860962,987.022644 87.556038,992.491821 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M421.229309,931.282227 
	C436.206482,936.441833 449.962463,943.914917 465.363678,946.854858 
	C468.867706,947.523682 472.170868,949.244568 475.795471,950.753052 
	C475.040375,952.113525 473.705566,952.388245 472.419647,952.093933 
	C465.747070,950.566589 458.988953,949.330566 452.295776,946.397766 
	C437.269684,941.123413 423.069763,934.670288 407.469238,931.211365 
	C412.257599,927.764404 416.557953,929.794678 421.229309,931.282227 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M519.488342,342.132263 
	C513.905701,326.867889 501.453003,322.695129 487.429077,321.092133 
	C483.975098,320.697296 480.438995,321.021057 476.475372,320.986877 
	C474.354645,319.288544 470.903717,319.844482 470.769226,316.254456 
	C483.842133,315.570770 496.402374,316.330780 507.639069,323.789825 
	C514.146606,328.109650 518.630798,333.680756 520.462708,341.747345 
	C520.323486,342.206909 520.070068,342.279846 519.488342,342.132263 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M208.778183,684.717041 
	C208.602005,687.638550 210.647003,689.477234 211.282104,691.815308 
	C212.344131,695.724915 211.230652,696.633911 207.319702,695.609131 
	C206.684052,694.848450 206.228012,694.330261 206.251465,693.301392 
	C206.229309,692.241760 206.130035,691.508423 205.945740,690.414795 
	C203.807678,682.309814 201.010300,674.934021 195.460251,668.905273 
	C194.818954,668.208618 193.895050,667.563599 194.748199,666.179810 
	C193.700882,659.518433 189.921555,653.953491 188.201523,647.247314 
	C188.543732,646.552795 188.998001,646.358459 189.887054,646.336426 
	C191.287262,646.705811 191.924652,647.483887 192.717804,648.631592 
	C198.316635,658.331482 200.943802,669.026367 206.785980,678.211853 
	C207.949844,680.041809 208.105942,682.310303 208.778183,684.717041 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M480.597168,989.765198 
	C487.641449,995.214294 495.631165,998.788391 501.525482,1005.257935 
	C502.690063,1006.536194 504.435455,1007.364136 504.782715,1010.285583 
	C496.093414,1007.093628 489.429291,1001.503052 481.387817,997.848328 
	C476.279388,995.562988 471.735382,993.107483 469.478394,987.640198 
	C469.681641,987.064880 469.819458,986.855286 470.279236,986.443604 
	C474.547577,985.227234 477.603729,986.975647 480.597168,989.765198 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M470.662659,315.821289 
	C471.110138,317.546387 472.117584,318.043488 473.549835,318.023224 
	C475.025421,318.002319 475.944244,318.608704 475.991638,320.580261 
	C465.500793,321.685699 456.659088,329.466766 445.008606,328.575226 
	C446.769257,326.231415 449.656128,327.359436 450.734985,324.968872 
	C448.079224,322.910522 444.002625,323.583832 441.406006,320.386627 
	C449.388550,321.125854 456.878418,321.852234 464.301178,318.449127 
	C467.714844,316.884033 466.183258,316.172791 464.979706,314.341553 
	C466.771637,314.574554 468.554962,315.132965 470.662659,315.821289 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M490.908142,524.971558 
	C488.796783,524.729431 486.049866,525.800110 486.183228,521.913696 
	C486.426544,516.713806 488.586090,512.807434 491.733002,508.973633 
	C492.340149,508.186462 492.763000,507.681122 493.382324,506.924622 
	C494.456421,505.849213 495.515411,505.146423 495.573029,503.450409 
	C495.499786,502.058533 495.590576,500.992218 495.925842,499.619110 
	C495.503815,496.072662 492.515808,496.402496 490.459534,495.457581 
	C487.333801,494.021240 483.492340,495.167084 480.438354,492.475647 
	C479.640656,489.237488 481.172729,488.268799 483.789154,488.148804 
	C486.316193,488.032959 488.735748,488.487183 491.118225,489.256683 
	C492.218964,489.612244 493.319092,490.197021 494.486816,489.973907 
	C496.526581,489.584106 498.915222,486.849792 500.435852,490.147766 
	C502.078583,493.710693 505.167480,497.355347 501.849213,501.646027 
	C501.449432,502.162964 501.897034,501.475922 501.463318,502.386719 
	C501.234558,502.902405 501.133606,503.099609 500.847687,503.552765 
	C500.339508,504.100006 500.250000,504.463318 500.339539,505.203125 
	C499.604614,507.404541 498.257538,508.918518 497.058624,510.920471 
	C496.696472,511.366272 496.542633,511.538513 496.141022,511.954254 
	C491.470306,515.329468 491.468628,520.106140 490.908142,524.971558 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M186.272858,696.693604 
	C192.016022,699.171509 189.178406,703.508179 188.981857,707.665283 
	C188.230515,708.033386 187.489319,707.984924 186.384140,707.859192 
	C185.315155,707.185303 184.492401,706.991333 183.265717,707.109741 
	C181.613556,707.072327 180.284622,707.006592 178.957138,706.918640 
	C175.435822,706.685242 173.213715,705.184998 173.937363,701.279175 
	C174.391174,698.829773 171.725769,695.176331 174.710526,694.150513 
	C178.424942,692.873901 182.798676,693.190674 186.272858,696.693604 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M462.914490,626.473877 
	C470.599823,620.797119 476.604370,614.091248 482.767700,607.120605 
	C487.138885,610.452026 485.969391,615.614685 487.328430,619.931763 
	C487.760773,621.305054 487.471985,622.874817 487.047333,624.735718 
	C486.688843,625.637695 486.339172,626.041504 485.498169,626.453979 
	C484.880493,626.539734 484.632629,626.510437 484.068787,626.299072 
	C483.000732,624.475220 482.007050,623.130371 479.691132,622.899048 
	C479.049347,622.472351 478.811768,622.124756 478.571106,621.984009 
	C478.277588,622.440247 478.124756,622.600647 477.709595,622.969604 
	C473.982880,625.368652 470.146393,626.742615 466.235657,627.907959 
	C465.298706,627.824524 464.487518,628.062622 463.297913,628.489380 
	C462.552216,628.112549 462.449738,627.502502 462.914490,626.473877 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M390.778992,389.215149 
	C393.417755,384.667328 396.194061,380.863953 400.847717,378.774200 
	C403.477722,377.593231 405.396240,377.922577 407.489960,380.003479 
	C413.078918,385.558228 414.942566,392.519745 415.599335,400.400757 
	C415.255432,401.212341 414.856323,401.439667 413.989990,401.330322 
	C411.344391,399.449371 411.228119,396.567169 410.092010,394.206573 
	C405.525482,384.718353 401.079987,384.470703 395.611572,390.547241 
	C395.168030,391.040100 394.546326,391.337921 393.562256,391.700684 
	C391.680023,391.802734 390.539368,391.380219 390.778992,389.215149 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M482.359406,969.871826 
	C480.253632,969.098083 478.479065,968.339172 476.312805,967.412781 
	C482.416321,963.258118 489.634094,962.633972 495.945709,959.377563 
	C499.833252,960.827026 503.887451,962.408508 504.950867,967.585815 
	C503.714752,967.845276 502.598022,968.003296 501.307831,968.884399 
	C495.727295,970.846863 490.196777,969.671387 484.420410,970.238342 
	C483.568726,969.988647 483.129700,969.937622 482.359406,969.871826 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M290.347687,700.913513 
	C288.042267,699.795166 285.933624,700.041321 283.476166,699.963013 
	C282.732788,699.602356 282.294922,699.132263 282.449249,698.695496 
	C284.511658,692.858826 286.458130,686.945435 291.785156,682.850830 
	C294.076080,682.605286 295.749695,683.451660 297.853149,684.174194 
	C297.443146,688.483887 296.761139,692.699890 295.822357,696.857971 
	C295.246216,699.409790 294.028229,701.560669 290.347687,700.913513 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M110.949646,1013.807861 
	C111.503204,1013.461182 112.068184,1013.447693 112.838333,1013.637085 
	C113.405525,1014.344727 113.823288,1014.806152 114.345810,1015.570801 
	C115.066010,1017.214294 116.624954,1016.813171 117.793594,1017.726746 
	C117.746040,1020.118164 116.096626,1019.148376 114.972847,1019.149963 
	C109.223351,1019.157837 103.465492,1018.726929 97.339485,1019.696838 
	C96.391228,1020.757629 95.447540,1021.025757 94.130310,1021.352661 
	C93.282127,1021.509338 92.800362,1021.617126 91.955566,1021.825684 
	C90.828979,1021.966675 90.070694,1021.972351 88.930984,1021.884644 
	C88.058197,1021.653442 87.637863,1021.369080 87.237228,1020.596313 
	C77.984375,1020.179810 68.994270,1022.246155 59.440197,1023.025269 
	C58.578762,1023.415222 58.098259,1023.517090 57.278328,1023.150879 
	C56.985676,1022.902771 57.005398,1022.994385 57.050957,1022.983398 
	C56.407745,1022.336121 55.151722,1022.651733 54.871460,1021.231934 
	C55.010757,1020.900269 54.913521,1020.710327 54.931202,1020.605103 
	C58.722492,1018.856506 62.837395,1018.841125 66.771370,1018.653687 
	C71.748444,1018.416687 76.592094,1017.633240 81.902832,1016.685913 
	C91.587662,1016.414490 100.832108,1016.607971 110.507843,1016.301514 
	C110.947235,1015.472839 110.954147,1014.806946 110.949646,1013.807861 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M484.129089,382.117615 
	C481.435822,385.098236 480.407288,389.860443 475.070984,388.525757 
	C474.085114,388.279236 474.405457,389.741425 474.065002,390.371674 
	C472.499725,393.269501 470.654022,395.889435 466.435974,395.210632 
	C465.933258,394.599365 465.699799,394.002991 466.068665,393.672211 
	C471.488556,388.812134 471.707458,382.102539 472.826385,375.325073 
	C473.375275,374.242859 473.653259,373.449188 473.925171,372.333130 
	C473.832794,371.830933 473.746490,371.651184 473.869385,371.257629 
	C474.078583,371.043884 474.086853,371.131256 474.130707,371.132263 
	C474.490356,370.719818 474.908356,370.507751 475.775024,370.633545 
	C476.121582,370.770264 476.354126,371.050537 476.493591,371.167603 
	C477.403839,371.354126 477.448761,372.005371 477.838806,372.760773 
	C478.038452,372.981537 478.315643,373.244141 478.469177,373.357666 
	C481.583466,375.498047 485.122498,377.129974 484.129089,382.117615 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M535.946533,324.437256 
	C539.959412,327.745056 542.555298,332.375977 543.725220,337.573029 
	C545.666748,346.197937 541.960144,351.327881 531.639038,353.689392 
	C538.434753,344.370850 538.164978,334.706726 535.946533,324.437256 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M400.183075,528.724304 
	C399.438538,528.720825 398.381348,528.343994 398.413849,528.145569 
	C399.030792,524.378235 399.588928,520.632996 399.762604,516.789734 
	C399.820618,515.506165 402.076721,514.322021 403.806183,513.146851 
	C404.284363,513.201294 404.509674,513.481812 404.755432,513.239685 
	C406.807190,511.378387 405.733582,509.630035 405.119904,508.000580 
	C402.549561,501.175568 403.343933,493.868103 402.305206,486.330994 
	C403.025696,485.914612 403.370819,486.144653 403.704590,486.792938 
	C403.791718,487.533325 403.820312,487.960449 403.949219,488.693756 
	C405.060577,490.596832 405.123047,492.447174 405.313110,494.595154 
	C405.194397,495.415161 405.208923,495.867859 405.345764,496.639313 
	C407.645416,500.060883 407.056641,503.704437 407.375000,507.551880 
	C407.501831,509.395203 407.715118,510.840393 408.051941,512.632935 
	C408.970337,516.745789 410.397003,520.385315 410.196381,524.649048 
	C408.734741,523.755249 406.985138,528.626404 406.011810,524.341309 
	C406.030670,524.026794 406.211426,523.771057 406.088104,523.867554 
	C403.011749,524.090759 402.864288,527.724243 400.183075,528.724304 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M525.713501,1002.536865 
	C530.499207,1000.479919 533.935730,996.222900 539.377075,995.022461 
	C541.494995,994.548828 543.694031,992.120361 544.935730,994.304993 
	C546.436462,996.945435 543.055725,997.426208 541.541199,998.670959 
	C539.596863,1000.268982 535.234619,999.948120 536.791321,1004.779907 
	C536.458740,1005.489929 536.174438,1005.836853 535.623352,1006.372070 
	C535.193970,1006.820374 534.974182,1007.029480 534.741760,1007.224915 
	C534.518921,1007.412170 534.601624,1007.346741 535.215393,1006.794006 
	C535.761414,1006.240479 536.094116,1005.934875 536.791321,1005.585205 
	C539.701782,1006.563293 539.775513,1008.868408 539.949280,1011.469116 
	C539.574524,1013.101807 538.747437,1014.029297 537.572754,1015.150635 
	C535.387207,1016.361023 533.525940,1016.145264 531.345215,1015.091248 
	C529.532837,1014.966125 527.856995,1015.088867 527.415039,1013.275330 
	C527.080139,1011.900940 528.303162,1011.384338 529.416565,1010.978149 
	C531.333679,1010.278809 530.254822,1009.517578 529.571716,1008.531677 
	C528.492432,1006.973633 527.646179,1005.254150 526.531860,1003.319397 
	C526.151184,1002.978760 525.940002,1002.921753 525.713501,1002.536865 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M538.427917,429.085144 
	C539.549500,427.904053 540.720154,426.984314 540.838684,424.623169 
	C541.058228,420.250854 545.778625,417.316986 545.176331,412.263153 
	C548.249756,410.453400 548.151245,407.117798 548.802124,404.394562 
	C550.224854,398.441498 551.110535,392.370270 551.209167,386.165771 
	C554.258240,389.835541 553.074829,393.995911 552.617004,397.941498 
	C551.428101,408.187012 548.174377,417.972687 545.409912,427.849274 
	C544.294800,431.833008 540.949707,428.326538 538.427917,429.085144 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M195.385986,833.654724 
	C191.587082,840.263123 187.719818,846.551636 183.587646,853.052490 
	C181.868698,853.214661 179.784531,855.672852 178.951630,851.977661 
	C181.157211,844.526367 185.185715,838.089722 188.576248,831.346313 
	C189.305176,829.896484 190.506668,829.118347 192.582016,829.599670 
	C193.401611,829.450623 193.871460,829.447998 194.538605,829.947021 
	C194.734802,830.257446 194.917740,829.984680 194.834747,830.125610 
	C195.213455,830.481750 195.473358,830.842468 195.422119,831.691528 
	C195.314301,832.468018 195.315964,832.901367 195.385986,833.654724 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M408.990662,293.527283 
	C404.568146,292.778809 401.631317,296.482361 397.619873,296.939941 
	C400.893707,291.080200 406.030792,289.177124 416.624695,289.898865 
	C419.547272,291.361145 421.598267,290.189026 423.817810,288.369263 
	C424.290497,287.726135 424.587250,287.449310 425.244171,287.212158 
	C429.024872,286.015808 432.242310,283.971771 436.492554,284.056396 
	C437.336151,284.396210 437.495239,284.850037 437.063782,285.646240 
	C432.536255,286.969177 428.883423,289.003082 425.198700,292.745819 
	C427.775085,292.975616 429.624725,293.140594 432.654327,293.410828 
	C425.805450,295.450500 420.100281,293.290619 414.025513,293.613953 
	C412.457977,293.674286 411.285156,293.206177 409.733215,293.776672 
	C409.373138,293.812012 409.163269,293.537170 408.990662,293.527283 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M440.254456,502.463043 
	C443.148438,501.765198 445.472900,500.347382 448.078186,498.890564 
	C449.074951,498.831543 449.703339,498.460480 450.699829,498.752380 
	C451.085999,499.149811 451.189148,499.352570 451.134796,500.199158 
	C450.854797,501.025208 450.732300,501.207397 450.172211,501.860748 
	C449.575836,502.469208 449.417053,502.606537 449.004669,502.923157 
	C448.566620,503.189514 448.382111,503.276611 447.899658,503.412933 
	C447.201996,503.474243 446.811127,503.537720 446.209473,503.857605 
	C445.988464,504.053589 445.995819,503.993256 446.025085,504.001434 
	C445.905151,504.131195 445.755890,504.252777 445.367126,504.212952 
	C443.380432,503.730957 441.722015,504.189972 440.474121,505.291473 
	C437.335236,508.062164 435.539246,505.938049 435.479279,503.310242 
	C435.401733,499.912415 433.028778,499.748413 431.039612,498.325134 
	C428.884003,498.371613 428.545624,496.219757 427.368408,495.535126 
	C422.987122,492.987061 423.399750,487.389374 419.797638,484.377319 
	C419.167786,483.850616 420.831696,482.630280 422.131805,482.046509 
	C423.367371,481.779785 424.155243,481.233337 425.361389,480.841675 
	C426.108826,481.116791 426.415192,481.453186 426.714783,482.205566 
	C427.288605,484.607147 427.638672,486.734802 429.256409,488.713318 
	C430.250793,493.826263 435.439117,495.791656 436.872528,500.324982 
	C437.223358,501.434540 438.505249,499.941010 439.709595,499.940247 
	C439.924622,500.394104 439.828949,500.758270 439.701965,501.404266 
	C439.521790,502.047668 439.622498,502.287933 440.254456,502.463043 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M416.107758,660.152832 
	C415.348755,660.089355 414.879974,659.758179 414.196655,659.235229 
	C414.214447,656.938599 415.786438,656.871826 417.300598,657.029419 
	C422.126892,657.531738 426.936615,658.197144 431.765717,658.666321 
	C433.455902,658.830505 433.998108,660.229675 434.461914,661.223328 
	C439.648651,672.335144 444.692078,683.514038 449.713989,694.701843 
	C449.934601,695.193359 449.576538,695.944580 449.219116,696.800903 
	C446.834778,696.513855 446.174713,694.659729 445.640228,692.983643 
	C442.447601,682.971313 436.654785,674.139038 432.822266,664.433167 
	C431.479309,661.032104 429.553314,659.305908 425.761414,659.821472 
	C422.662109,660.242920 419.518036,659.057251 416.107758,660.152832 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M304.437500,530.541992 
	C315.017761,549.726501 318.548126,570.704956 319.633331,592.585938 
	C318.870239,593.194519 318.247498,593.457458 317.325623,593.874146 
	C316.332916,593.490601 316.007324,592.738892 315.736237,591.514282 
	C315.464752,584.960632 314.122925,578.941711 313.585693,572.432861 
	C313.615265,567.229980 312.336273,562.675659 310.841064,557.761658 
	C309.550934,549.663086 307.446106,542.242004 303.425201,535.015991 
	C302.855957,533.203308 302.918427,531.854980 304.437500,530.541992 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M374.006714,577.874023 
	C368.075348,573.505493 364.060333,567.496094 360.877441,560.479492 
	C362.194702,557.169983 360.705444,554.460144 360.074097,551.283325 
	C360.237946,545.971802 359.218018,541.092834 359.581665,535.727295 
	C359.746429,534.085693 359.991394,532.933655 361.452515,532.098511 
	C362.787903,536.018250 363.210632,540.005798 363.118530,544.494446 
	C365.234680,547.117249 363.368103,550.443604 365.652649,552.852783 
	C366.088959,553.224548 366.252533,553.386047 366.643463,553.806702 
	C364.931274,558.678589 366.416901,562.725281 369.039429,566.516052 
	C370.997223,569.345947 373.102997,572.073425 375.187469,575.168091 
	C374.879791,576.169922 374.527496,576.850342 374.006714,577.874023 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M413.747559,401.244080 
	C414.380859,400.917633 414.711975,400.839874 415.298309,400.778290 
	C415.553680,404.494507 416.761627,408.243591 414.648865,411.848816 
	C413.992798,412.968323 414.254669,414.580841 416.180725,414.690033 
	C419.059937,414.853180 418.311340,417.915619 417.856873,418.188843 
	C414.842926,420.000732 415.906799,422.774597 416.146210,425.048340 
	C416.493256,428.344818 415.234558,430.400238 412.013153,431.618561 
	C410.816010,428.823547 411.971802,427.292084 413.796478,426.201996 
	C412.405273,426.107941 410.928528,425.486084 409.501953,423.966461 
	C408.356140,421.006226 408.229645,418.186310 407.503723,415.496094 
	C406.806396,412.911865 407.418091,410.569763 409.169952,408.626831 
	C411.075531,406.513367 412.202637,403.978882 413.747559,401.244080 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M381.584442,751.804932 
	C383.097198,758.345154 378.084320,762.366943 375.498352,767.276306 
	C374.568817,769.041077 374.320068,770.061768 375.611633,771.722595 
	C372.831116,777.615295 368.573700,782.317261 363.651611,786.616577 
	C367.420746,774.790649 373.618134,764.223206 379.970917,753.346191 
	C380.226257,752.352356 380.660187,751.965210 381.584442,751.804932 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M164.730820,634.440674 
	C163.950073,627.355713 163.665329,620.655701 164.027985,613.472046 
	C164.412338,612.665405 164.804688,612.509338 165.528961,612.794250 
	C167.253571,622.122803 168.642105,631.241882 170.232178,640.325684 
	C171.099518,645.280640 172.308456,650.175781 173.455856,655.518677 
	C173.286789,656.078674 173.025192,656.217957 172.346649,656.203003 
	C167.877457,649.543091 166.453384,642.157715 164.730820,634.440674 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M428.988312,757.695679 
	C426.579346,763.294495 421.907715,766.573853 417.944122,770.812500 
	C416.570099,768.698181 419.272766,767.333069 418.353516,765.305786 
	C414.924866,767.177368 414.618103,772.168152 410.052460,772.963745 
	C414.709106,765.535095 420.532288,758.604553 424.548279,750.028137 
	C423.425903,748.043152 425.333313,747.864807 426.226929,746.938416 
	C427.241364,746.577759 427.837463,746.749512 428.437927,747.622192 
	C428.580261,748.137024 428.598236,748.351501 428.575439,748.883789 
	C428.401886,749.813538 428.245239,750.420715 428.144806,751.348877 
	C428.010315,752.637573 427.809723,753.596619 427.233826,754.702637 
	C427.118011,754.920166 427.033936,755.366028 427.276520,755.452515 
	C428.316772,755.897095 428.760010,756.533386 428.988312,757.695679 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M330.599548,614.299927 
	C333.091156,616.562744 331.688354,619.690369 332.028046,622.558289 
	C332.210571,624.099121 332.826141,625.083862 334.214783,625.520447 
	C336.408875,626.210266 335.529114,623.709961 337.029877,622.860901 
	C337.029877,624.870056 337.029877,626.590027 337.057007,628.731018 
	C337.084137,629.152039 337.031433,629.079163 337.064575,629.048706 
	C336.939789,629.160156 336.781891,629.302002 336.796936,629.711182 
	C334.488312,635.707153 331.735229,641.273254 327.264862,645.960999 
	C328.420715,635.486206 330.339233,625.148438 330.599548,614.299927 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M538.414429,381.229828 
	C533.933289,381.971741 530.493347,378.989655 526.624329,377.244812 
	C524.367065,376.226807 522.126892,375.140106 519.988342,373.896271 
	C516.279785,371.739227 512.877197,371.580750 509.301025,374.869415 
	C508.884064,373.740326 508.964417,372.710938 509.073181,371.036072 
	C509.248657,369.832062 509.150879,369.279968 509.042847,368.411804 
	C509.049957,366.976257 508.899048,365.828186 509.848145,364.604004 
	C512.130005,366.082306 513.962219,368.063446 516.191528,369.363708 
	C517.802917,370.303589 519.968872,372.927734 521.825317,369.240845 
	C522.472412,367.955688 523.101196,369.238525 523.612366,369.693542 
	C528.218628,373.794525 534.284851,375.996918 538.414429,381.229828 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M390.683533,389.051331 
	C391.070496,390.244354 391.715332,391.047485 393.552399,390.971313 
	C394.995209,394.910736 391.187469,397.492767 391.015076,401.454712 
	C390.701569,402.716003 390.457581,403.626770 390.373169,404.927399 
	C390.191650,412.982483 394.304169,418.920929 398.498413,425.201721 
	C397.600555,427.447479 400.213715,428.433533 399.690918,430.557983 
	C399.476105,431.129028 399.347137,431.341248 398.875244,431.699036 
	C390.399933,422.885529 386.263000,412.335114 386.250458,400.256927 
	C386.246216,396.164490 388.098755,392.574738 390.683533,389.051331 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M124.829422,950.752686 
	C123.991035,955.573730 119.401161,957.872070 117.863464,962.496948 
	C115.493828,962.698730 115.876122,961.385864 116.626869,960.099121 
	C117.451309,958.686035 118.594307,957.440247 118.689903,955.674438 
	C113.521042,956.297241 101.560020,946.154785 100.987427,940.363403 
	C101.720947,939.913391 102.502579,939.881409 102.710388,938.648438 
	C103.086533,937.868591 103.477875,937.077881 104.127159,937.646912 
	C104.416626,937.900574 104.015488,938.854553 104.069382,939.478455 
	C104.558853,945.144287 116.313065,952.958557 120.947647,950.306335 
	C121.779823,949.693115 122.532974,949.439758 123.546822,949.015991 
	C124.541008,949.158752 124.655609,949.786316 124.829422,950.752686 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M119.915436,798.456299 
	C122.367943,795.114441 124.845421,795.935242 127.297050,797.943726 
	C128.055252,798.564819 128.663818,799.368530 129.340866,800.088623 
	C133.038803,794.137695 137.890213,799.593994 142.103195,798.776978 
	C142.547409,798.690796 142.931808,798.296143 143.641434,798.019165 
	C145.018433,798.437805 145.707230,799.211731 145.979706,800.674927 
	C142.898056,804.260864 138.204712,802.719360 134.331635,804.823853 
	C133.558472,804.976318 133.113983,805.005066 132.337921,805.077454 
	C131.557831,805.083679 131.109772,805.052795 130.325424,805.001953 
	C129.673996,805.327148 129.282761,805.508057 128.487747,805.446899 
	C126.815247,804.606689 125.674484,803.514709 123.909698,802.788696 
	C121.993912,801.700745 120.262154,800.881226 119.915436,798.456299 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M394.028320,960.111023 
	C396.389404,957.826355 398.389404,956.022339 402.271454,957.168030 
	C405.648315,958.164612 408.907623,955.130005 412.619995,953.890015 
	C413.772217,953.589417 414.201721,953.990112 414.461975,954.997009 
	C414.154816,955.882935 413.709442,956.283203 412.802307,956.542114 
	C412.630005,957.101868 411.752655,956.485596 412.192261,956.920776 
	C412.896881,956.490417 413.495758,956.460083 414.137207,955.844360 
	C414.906525,955.055054 415.542023,954.598145 416.645081,954.387573 
	C417.144623,954.395569 417.345917,954.432068 417.798523,954.616089 
	C418.128540,954.916748 418.207275,955.069702 418.231201,955.446594 
	C418.176331,955.670532 418.556946,955.921204 418.731079,955.732178 
	C420.505463,954.050598 422.417206,952.994080 424.503662,951.597229 
	C425.235687,951.273865 425.679871,951.174500 426.474976,951.144775 
	C427.027954,951.222412 427.242371,951.284302 427.732117,951.531128 
	C428.567871,954.254883 425.974060,954.633545 424.778625,956.332764 
	C424.419678,956.686218 424.275635,956.823914 423.915405,957.157715 
	C423.555298,957.478271 423.411438,957.602661 423.052795,957.903687 
	C422.695435,958.191528 422.552856,958.302734 422.198883,958.573486 
	C421.846008,958.831970 421.704468,958.930969 421.383179,959.211914 
	C421.024353,959.682190 420.853241,959.975159 420.345764,960.634888 
	C411.818634,961.069031 403.621002,960.179626 395.453888,961.340881 
	C394.672150,961.451965 394.225159,961.196838 394.028320,960.111023 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M300.059387,593.023926 
	C300.288452,589.065430 297.797943,586.010132 296.805847,582.398132 
	C301.625854,586.807861 304.065491,592.464905 305.282715,598.814880 
	C304.786652,602.861023 306.793274,606.330933 307.092285,610.520142 
	C306.212036,610.868713 305.979095,609.079346 304.479858,610.209229 
	C301.961121,606.643066 299.201477,603.132324 297.894684,598.427246 
	C298.779327,595.616394 296.690125,593.467712 297.052307,590.995850 
	C298.523956,590.725891 298.464935,592.425232 299.698242,592.885010 
	C299.995941,593.003723 300.114838,593.050598 300.059387,593.023926 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M436.791046,329.086914 
	C444.489746,330.698090 452.075317,330.517944 459.680298,329.526947 
	C463.067291,329.085571 466.120270,330.118652 469.504242,331.360138 
	C458.366516,338.226318 447.933929,334.133881 437.212585,330.291687 
	C436.826416,329.847260 436.714783,329.626801 436.791046,329.086914 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M353.235016,352.742279 
	C350.359619,351.075073 347.245605,350.843170 344.085480,350.418640 
	C344.455414,350.281097 344.817139,350.113007 345.196655,350.011261 
	C346.962616,349.537659 350.560608,350.710297 350.249542,348.928833 
	C349.656891,345.534851 347.286926,350.190796 345.629944,348.898193 
	C345.276642,348.622620 344.852753,348.437500 343.671204,347.752838 
	C341.730988,346.989868 351.132111,347.231323 344.810120,345.539825 
	C344.000275,345.323120 343.647949,343.396332 342.771240,342.145203 
	C342.201141,339.308319 344.333771,340.179504 345.615295,340.045837 
	C351.017700,339.482300 356.209290,341.573151 362.034424,341.310547 
	C363.084473,341.172333 363.690125,341.142090 364.588867,341.180908 
	C364.921570,342.201721 364.961121,343.153473 365.059296,344.465729 
	C364.108215,346.327728 362.469055,346.210144 360.605713,346.477631 
	C358.365082,346.293121 357.687775,348.267334 355.864380,348.831421 
	C354.604340,349.107819 353.356445,348.922852 353.658203,350.864319 
	C353.696838,351.639343 353.616455,352.072327 353.235016,352.742279 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M279.164246,703.252075 
	C282.443726,703.251160 285.831055,703.581970 289.641418,703.832520 
	C290.557251,703.872559 291.050140,703.992920 291.905029,704.230408 
	C293.807770,708.468262 292.526093,712.779053 293.103210,717.389282 
	C291.660706,717.915894 290.231293,718.017029 288.376953,718.030151 
	C284.519073,715.942017 284.181641,712.070618 282.516296,708.996765 
	C281.515167,707.148926 280.358765,705.385315 279.164246,703.252075 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M519.560059,302.905151 
	C522.513489,305.154175 525.463928,306.706207 527.359619,310.016602 
	C512.812195,300.882782 495.894958,307.840302 480.803009,302.573730 
	C489.948883,304.256104 498.987518,302.116608 508.513550,301.947021 
	C512.557617,299.630890 515.921692,300.898376 519.560059,302.905151 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M469.706177,986.917725 
	C471.975525,992.107117 477.304321,993.613342 480.862305,997.496582 
	C481.018707,998.590088 481.000702,999.415771 480.974426,1000.652954 
	C474.928284,996.111389 468.805145,991.245544 464.121155,984.467712 
	C464.506317,981.264160 465.652130,979.449890 468.894409,981.508423 
	C470.981140,982.833191 474.047150,980.710754 475.871765,983.751587 
	C478.048676,985.433350 481.169891,985.194092 482.085754,988.499634 
	C481.788086,989.172852 481.550293,989.502136 481.034180,989.975220 
	C477.359497,989.423950 474.723938,986.410950 470.545288,986.864319 
	C469.972473,986.770996 469.794159,986.710571 469.706177,986.917725 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M138.807968,655.525940 
	C137.394516,653.555786 134.938232,655.171448 133.057587,654.198242 
	C127.295654,651.216553 127.194649,644.864990 124.332451,640.177612 
	C124.235855,640.019470 124.558319,639.605530 124.987915,639.136963 
	C126.556908,638.810913 127.698708,638.424561 128.666107,639.995605 
	C129.394150,641.177917 129.540298,644.058655 132.669846,641.845398 
	C133.768982,641.067993 134.138733,645.260620 136.626068,645.939209 
	C139.988647,647.919556 138.916229,650.734070 138.646317,653.796326 
	C138.772659,654.546875 138.787552,654.903259 138.807968,655.525940 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M89.000183,729.003540 
	C89.217926,727.575012 88.622917,726.044128 89.683861,724.403259 
	C93.813057,726.818787 94.762680,731.337097 96.760345,735.054321 
	C97.466171,736.367676 98.070549,737.666321 99.424164,738.904114 
	C102.665146,743.353455 104.712814,748.135071 107.724945,752.758545 
	C107.958878,753.026550 107.995499,752.999268 107.981384,753.015991 
	C108.533310,753.764343 108.771912,754.560791 108.171036,755.801880 
	C103.946907,755.272644 102.824547,751.493469 100.562645,748.926086 
	C98.737061,746.853821 97.255539,744.478394 95.041153,741.895996 
	C94.191307,741.188660 93.957840,740.801025 93.618118,740.081177 
	C91.811485,736.482178 90.715317,732.969177 89.209778,729.264221 
	C88.991531,728.996704 89.000259,728.999023 89.000183,729.003540 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M466.082825,627.980347 
	C469.840088,625.684570 473.570282,623.782837 477.667358,621.935303 
	C479.639252,624.544678 477.179932,625.917358 476.197205,628.049622 
	C475.917450,628.512085 475.794403,628.690186 475.448547,629.102905 
	C475.048584,629.458435 474.871460,629.579224 474.411102,629.846313 
	C473.555847,630.261108 472.982300,630.526794 472.223755,631.115479 
	C467.988892,634.563599 469.965485,637.922729 471.981750,641.565552 
	C472.440735,642.595886 472.249573,643.276184 471.674866,644.233459 
	C470.116547,645.810425 468.530762,646.430481 466.338623,646.162598 
	C463.194519,640.111328 461.047699,634.231995 466.082825,627.980347 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M156.143494,623.138245 
	C158.420517,620.078186 156.723709,617.149719 156.369568,614.383972 
	C154.611740,600.655396 153.998917,586.938843 156.127655,572.791443 
	C158.905487,572.584106 158.473663,574.952209 158.445862,576.450378 
	C158.244781,587.280579 159.232117,598.062378 159.547882,608.868774 
	C159.712860,614.514099 159.729828,620.167542 160.787262,626.205688 
	C160.678650,626.955627 160.576324,627.245300 160.140167,627.852539 
	C157.416214,627.522522 157.889603,624.677551 156.143494,623.138245 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M401.651306,464.972260 
	C401.032501,459.596710 399.212860,457.222870 393.889526,456.618500 
	C389.236938,456.090271 385.494598,454.309540 382.712524,450.417236 
	C381.894073,452.437286 381.176208,454.209045 380.207184,456.261719 
	C378.305573,456.571533 378.619873,454.761353 377.326538,454.037628 
	C376.966064,453.956665 377.013214,453.982239 376.988708,453.965698 
	C378.968475,452.704834 379.022400,450.595337 379.174713,448.305389 
	C381.429474,446.080170 383.161285,447.895081 385.164673,448.968597 
	C386.702850,449.792755 387.031708,453.040588 390.038574,451.115967 
	C391.848358,450.447083 393.069000,452.126099 394.927856,451.471497 
	C395.721985,450.674347 396.020325,449.896057 396.677002,448.963837 
	C397.109161,448.674561 397.320038,448.623108 397.785706,448.774414 
	C398.040527,448.977142 398.006775,449.006226 398.005219,448.984039 
	C398.207092,449.233276 398.442810,449.472900 398.901306,449.847900 
	C398.995972,453.497406 399.811707,456.558868 402.124176,459.391144 
	C403.266815,460.790710 403.757507,463.073334 401.651306,464.972260 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M473.188049,342.678162 
	C462.286713,343.329132 452.126801,340.721527 442.076202,336.930664 
	C453.231995,340.003510 464.016418,336.865509 474.844635,334.528198 
	C474.921967,334.971802 474.999298,335.415405 475.076660,335.858978 
	C471.973724,337.109222 468.870789,338.359436 465.211761,339.833740 
	C467.861725,340.341034 469.951752,340.741119 472.429108,341.174011 
	C473.255096,341.475952 473.443329,341.865997 473.188049,342.678162 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M147.750244,571.810303 
	C147.291077,580.188660 149.285492,588.199890 148.908005,596.780640 
	C144.287827,593.956360 145.217453,588.697083 144.173279,584.176941 
	C143.692505,582.095764 143.711609,579.899048 143.464157,577.353882 
	C141.539200,573.236023 142.010498,569.252686 142.214157,564.937134 
	C143.188400,563.164185 144.517685,563.597717 146.068207,563.910522 
	C147.209595,565.174377 146.968903,566.416382 146.996277,567.956177 
	C147.048889,569.408264 146.841949,570.557617 147.750244,571.810303 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M189.934708,665.742798 
	C195.147354,672.952881 200.810013,679.573792 202.930862,688.593140 
	C198.291992,689.135315 196.324173,685.058167 193.045609,682.457764 
	C191.697861,680.387390 189.698410,679.108887 189.472748,676.369141 
	C190.042160,673.916321 190.019470,671.905029 189.102066,669.850220 
	C188.469864,668.434143 187.613800,666.776550 189.934708,665.742798 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M434.468750,918.684448 
	C440.923767,922.364075 440.964996,922.920593 435.604950,932.203125 
	C434.087250,933.269531 432.899933,932.648865 431.330566,932.048950 
	C430.681427,931.628540 430.379852,931.408142 429.787842,931.170044 
	C428.775940,930.985046 428.042236,930.834473 427.086670,930.509155 
	C425.337280,927.703735 428.331238,927.185669 429.116730,925.588379 
	C428.220123,924.313782 425.595551,925.252808 425.815582,922.603271 
	C428.720551,921.144470 431.414551,919.950317 434.468750,918.684448 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M472.725159,375.102783 
	C473.505310,382.411530 473.593414,389.676453 466.283081,394.748169 
	C460.653687,399.982361 453.217133,400.213074 446.468445,403.079498 
	C446.103607,400.737183 448.240082,400.586609 449.622406,400.397675 
	C454.979462,399.665558 458.916443,396.470642 463.201721,393.165222 
	C463.881104,392.893097 464.253876,392.709991 464.789124,392.194305 
	C464.998016,391.956116 465.005615,392.006683 464.980286,392.003174 
	C465.434479,391.593933 465.502716,391.004120 465.809937,390.207031 
	C465.970856,389.964813 466.001617,389.999146 465.979218,389.993774 
	C466.446045,389.586243 466.501923,388.987610 466.827118,388.195679 
	C466.993500,387.955719 467.006409,388.004639 466.981140,388.003296 
	C467.245270,387.710602 467.456909,387.369812 467.719421,386.705109 
	C468.109131,385.655060 468.433075,384.907684 468.870728,383.876587 
	C468.976868,383.589783 468.930939,383.381104 468.939026,383.274597 
	C469.317688,382.726440 469.506897,382.209534 469.728241,381.406677 
	C472.231567,379.800385 469.711792,376.419586 472.725159,375.102783 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M223.617630,887.044189 
	C223.884079,885.901794 224.167160,884.747375 224.766922,883.282593 
	C228.830521,883.149475 229.037552,886.935364 231.275497,889.130859 
	C231.723648,889.789001 231.969345,890.171875 232.404785,890.840332 
	C232.729568,891.312683 232.859726,891.502625 233.181885,891.981812 
	C236.182922,897.130798 239.350021,901.776428 241.993973,906.735596 
	C242.767761,908.187012 243.802689,909.529114 243.410355,911.647034 
	C243.060303,912.099060 242.856323,912.223755 242.307281,912.250854 
	C235.893784,906.711792 232.678726,899.139099 227.623367,892.937927 
	C226.279160,891.289062 225.113403,889.494751 223.751129,887.432983 
	C223.882507,886.989502 224.112503,886.854736 224.326324,886.694214 
	C224.542526,886.531982 224.448959,886.543945 223.838165,886.899597 
	C223.630524,887.068848 223.634262,887.032166 223.617630,887.044189 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M485.843506,626.487549 
	C487.435669,619.574402 483.728699,613.815491 483.359253,607.307739 
	C483.455231,606.058350 483.816681,605.090637 484.227844,603.817444 
	C484.963470,602.876587 485.170746,601.709961 486.680511,601.817627 
	C487.961487,602.699219 488.349731,603.612122 487.642670,604.821777 
	C488.110992,608.205017 488.368591,611.884705 489.975525,614.827698 
	C493.021271,620.405823 490.832581,624.033386 486.390198,627.662476 
	C485.971008,627.599426 485.823395,627.287964 485.843506,626.487549 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M451.975800,946.496094 
	C459.934143,946.641113 467.270416,950.201904 475.606140,950.997009 
	C476.024445,951.024902 475.994141,950.989685 475.972046,950.982544 
	C476.252747,951.269592 476.611633,951.455566 477.307037,951.666504 
	C478.033905,952.331787 478.480255,952.864136 478.992645,953.755981 
	C478.531952,955.002014 477.932922,955.801331 476.521027,955.979065 
	C472.950836,955.066895 469.590912,954.370178 466.418762,953.175110 
	C462.474976,951.689148 458.671082,950.881348 454.383179,953.042114 
	C454.718994,952.168823 455.432190,951.321411 456.238525,950.363281 
	C454.993408,949.992554 453.801941,949.637817 452.307281,949.145935 
	C451.999298,948.290771 451.994507,947.572754 451.975800,946.496094 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M377.246277,753.024353 
	C374.496246,750.251221 377.832184,748.023621 378.740875,746.870667 
	C381.390106,743.509216 382.308044,739.605957 383.956604,735.562378 
	C385.601715,734.668884 387.195129,734.128357 389.110352,733.769470 
	C391.959320,733.390015 394.751099,732.172852 395.053802,736.722168 
	C394.738739,737.098633 394.597473,737.126587 394.549713,737.072693 
	C394.094940,737.112732 393.735626,737.300598 393.212769,737.800659 
	C393.008026,738.031799 393.013702,737.993103 393.026611,738.007935 
	C390.254303,740.875366 387.056702,743.325928 384.483887,746.852051 
	C382.085480,748.668396 381.346802,751.765747 378.151672,752.712646 
	C377.839417,752.843262 377.448547,752.980042 377.246277,753.024353 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M138.841827,653.920959 
	C137.263901,651.909302 138.331833,649.080322 137.061432,646.351990 
	C136.960297,645.974304 136.941696,645.505493 136.913666,645.272583 
	C136.797699,644.862610 136.709747,644.685486 136.724335,644.229980 
	C136.343552,637.269165 135.845520,630.587769 135.383957,623.903748 
	C135.193329,621.143250 134.702133,618.349121 136.158966,615.303589 
	C137.444031,615.216492 137.903854,615.992432 137.973450,617.102112 
	C138.685440,628.454590 139.018494,639.858032 141.059647,651.064331 
	C141.540924,653.706543 138.762070,652.151428 138.841827,653.920959 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M319.736389,609.536499 
	C323.721375,608.403198 322.899292,604.400208 325.036194,602.227295 
	C325.517151,601.994690 325.815125,601.990662 326.552124,601.989990 
	C326.370483,611.651611 323.610565,620.818054 321.501068,630.134033 
	C321.021027,630.074036 320.540985,630.014038 320.060944,629.954041 
	C320.060944,627.940247 319.710205,625.848816 320.134796,623.928955 
	C320.988098,620.070374 322.123260,616.353394 318.168579,613.414917 
	C317.913757,613.225586 318.287445,612.190430 318.618774,611.288940 
	C319.175659,610.765808 319.377869,610.436035 319.736389,609.536499 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M189.941742,675.698242 
	C190.923370,677.867188 191.898956,679.673157 192.863663,681.833008 
	C183.657944,675.562439 176.155502,667.550781 171.977600,656.411987 
	C172.197098,656.024536 172.464493,656.000122 173.140137,655.957642 
	C176.240585,657.627197 174.638901,661.817993 178.015381,663.047119 
	C181.543396,662.221008 182.655502,665.130981 184.314011,666.877686 
	C186.647736,669.335632 189.207108,671.761658 189.941742,675.698242 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M348.463562,530.308167 
	C348.131165,527.263000 347.657959,524.520569 347.222534,521.358459 
	C348.610138,520.223083 349.836090,519.186890 351.719177,519.151123 
	C353.170654,525.974915 354.104370,532.977112 354.119629,540.524353 
	C353.650024,542.093384 352.860931,542.571960 351.387238,542.195984 
	C350.417847,540.507019 349.750793,539.050964 349.070251,537.245972 
	C350.452515,534.610168 347.435150,532.838562 348.463562,530.308167 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M178.537933,851.998535 
	C179.691284,853.813660 181.626831,852.061279 183.130951,853.027466 
	C179.247269,861.951172 173.669647,869.773865 168.821106,878.411865 
	C168.376038,878.757812 168.133484,878.824097 167.690720,878.578247 
	C167.077515,875.050171 169.342163,872.610657 170.005402,869.353455 
	C170.200027,868.461426 170.364548,867.914062 170.736343,867.166260 
	C171.958359,866.077515 172.974518,865.189941 173.072845,863.359253 
	C173.175064,862.612549 173.239227,862.198364 173.346039,861.472534 
	C173.934402,860.306091 174.480103,859.451416 175.201675,858.344604 
	C175.618851,857.592163 175.924286,857.125671 176.269104,856.366577 
	C176.245789,854.423401 177.615311,853.506165 178.537933,851.998535 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M364.693970,461.219299 
	C365.617432,458.042084 366.793579,455.035461 368.178925,451.739380 
	C372.966431,454.139832 373.185669,449.599670 374.848297,447.167023 
	C377.096039,449.477814 372.219635,452.219910 375.974213,454.100006 
	C374.734283,457.419434 373.141571,460.674438 371.496216,464.037048 
	C371.113678,462.074890 372.683960,460.228577 371.483185,457.943939 
	C368.856567,461.521942 367.947784,465.587555 366.014801,469.534729 
	C363.131378,469.445007 364.460144,467.467407 364.413208,466.014130 
	C364.362579,464.446198 366.043457,463.078217 364.693970,461.219299 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M141.686646,885.738892 
	C142.079224,887.040466 141.632935,887.896790 140.971436,888.673401 
	C134.475815,896.299805 127.979256,903.925415 121.163666,911.640137 
	C121.777458,905.292358 127.033760,901.291077 129.860672,895.911316 
	C130.485886,894.721497 131.481674,894.158264 131.421875,892.323914 
	C131.310989,888.922791 133.177765,891.914307 134.450867,891.936646 
	C135.334610,891.659302 135.504227,891.073608 135.806091,890.207642 
	C135.974289,889.948547 135.992157,890.004272 135.967484,889.988525 
	C137.137299,889.414795 137.886551,888.407959 138.786713,887.107788 
	C138.987549,886.864685 138.952484,886.445923 138.962311,886.236023 
	C139.287216,885.687866 139.667618,885.451538 140.445557,885.293579 
	C141.004684,885.358398 141.221390,885.430664 141.686646,885.738892 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M482.380676,988.926880 
	C480.708435,986.660461 477.827881,986.573547 476.181976,984.328369 
	C479.924225,983.656189 483.617157,984.539368 487.609558,985.970032 
	C491.472107,987.122498 493.108887,990.438660 495.772461,992.663513 
	C498.076477,991.403442 496.911560,988.138794 499.626251,987.028320 
	C500.095825,988.800049 498.242767,990.454651 499.950256,992.586243 
	C500.076202,993.857056 500.165894,994.866821 499.210449,995.935913 
	C498.391724,996.037781 497.866821,995.914368 497.139099,995.609253 
	C496.858063,995.044556 496.630951,994.798584 496.083618,994.902710 
	C491.519562,993.080933 487.127533,991.045593 482.380676,988.926880 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M433.119171,989.187317 
	C437.157501,986.099792 440.705109,986.129822 443.605255,990.840881 
	C444.402100,992.135315 446.172302,994.455994 446.064362,995.451172 
	C445.745850,997.518555 445.387268,999.309937 445.026001,1001.486938 
	C441.310120,1002.452881 440.505188,998.177734 437.308105,997.213257 
	C436.135803,996.932129 435.349182,996.710022 435.046509,995.385071 
	C436.967621,993.315735 436.114563,991.884766 434.267456,990.290588 
	C433.783783,989.832153 433.508148,989.627319 433.119171,989.187317 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M468.683838,268.640564 
	C472.732605,269.282135 475.726105,271.197632 478.703247,273.877014 
	C480.234558,274.468781 481.304871,275.154388 482.442017,276.313538 
	C483.983856,277.957733 485.233215,279.419769 485.895081,281.633423 
	C486.043182,281.916260 486.110901,282.335815 486.153809,282.543945 
	C486.387512,283.359253 486.218994,283.840637 485.270142,284.154602 
	C481.418823,281.083527 477.936371,278.110443 474.573761,275.007477 
	C471.666840,272.325012 468.189758,271.065552 464.030304,270.556519 
	C462.683411,270.760284 461.730621,270.378174 460.383972,270.382629 
	C459.261627,270.257507 458.501190,270.208557 457.362976,270.214844 
	C456.237946,270.518250 455.545044,270.537262 455.131897,269.451111 
	C459.069366,268.151062 462.960388,267.892944 467.327454,268.168335 
	C467.761658,268.184998 467.801270,268.153778 467.780823,268.158417 
	C467.972839,268.256226 468.185303,268.349365 468.683838,268.640564 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M310.155762,645.667603 
	C308.189697,641.529541 307.591217,636.811035 306.953918,631.715210 
	C309.511017,627.937439 305.852905,624.490479 307.432434,620.940063 
	C311.838684,628.646423 315.006409,636.592773 310.155762,645.667603 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M117.650604,682.464172 
	C119.780159,681.107056 121.272820,682.371704 123.215164,683.338623 
	C125.946182,689.724731 126.132217,696.296570 126.795341,702.823730 
	C122.571373,697.384460 119.715607,691.383789 118.021851,684.420288 
	C117.604828,683.686035 117.456413,683.261047 117.650604,682.464172 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M462.634247,359.612793 
	C463.315491,360.900330 463.658905,361.887207 464.024994,363.189728 
	C463.694305,364.532898 462.854553,364.893616 461.419250,365.074280 
	C454.788330,364.860168 448.659271,366.679138 442.214905,364.984131 
	C442.264893,362.497711 441.179230,359.724884 444.967163,359.125763 
	C451.004547,358.540436 456.661438,357.818909 462.634247,359.612793 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M97.958420,753.066711 
	C102.783661,756.717712 104.632568,762.741516 109.011139,767.155518 
	C109.070633,767.462402 109.049095,767.825928 109.010162,768.003784 
	C106.981834,768.915466 105.764847,767.662476 104.293579,766.175903 
	C104.057022,765.896667 104.016441,765.977844 104.056755,765.957031 
	C99.706314,762.992615 95.150314,760.241150 91.997353,755.335144 
	C91.173561,753.077271 90.502090,751.156128 91.379684,748.754639 
	C95.421082,747.010010 95.000496,750.961182 96.818245,752.696655 
	C97.066437,752.974854 97.003326,752.992432 97.011932,752.960815 
	C97.162155,753.325073 97.422684,753.432434 97.958420,753.066711 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M432.579590,1018.875610 
	C434.036621,1020.072205 433.604309,1020.892944 432.291534,1020.862671 
	C430.506683,1020.821472 428.575806,1020.685730 426.982819,1019.974304 
	C422.479431,1017.963074 417.264801,1020.562866 412.863159,1017.608276 
	C412.314789,1017.240234 410.831512,1018.322266 410.993744,1016.354004 
	C411.129456,1014.708252 411.840240,1014.141968 413.513489,1014.072937 
	C419.743011,1013.815857 425.499298,1015.258057 430.861359,1018.406433 
	C431.263306,1018.642395 431.814728,1018.623718 432.579590,1018.875610 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M501.336609,975.104065 
	C502.138000,979.468689 501.297821,982.735840 495.410004,982.050415 
	C491.993103,981.356995 488.994629,980.632935 485.608398,979.901184 
	C484.440155,979.339111 484.323151,978.575745 484.779297,977.376587 
	C485.769623,977.012634 486.513062,976.981628 487.622437,976.880615 
	C488.681061,976.247070 489.482025,976.008118 490.685577,976.012207 
	C494.356354,976.155457 497.533844,974.475525 501.336609,975.104065 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M143.347992,935.237305 
	C143.582443,933.543640 145.188934,932.550781 144.997406,930.385254 
	C151.653824,932.093262 157.124756,936.673828 163.996109,938.407288 
	C166.533142,939.047302 163.347290,940.861511 163.041519,942.562866 
	C158.787170,940.777466 154.553040,938.698792 150.391083,936.484436 
	C148.941940,935.713440 147.691589,934.547974 145.485138,934.988159 
	C144.692810,935.386169 144.215073,935.535034 143.347992,935.237305 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M360.694550,534.691284 
	C360.738922,540.158142 361.621490,545.245544 360.332947,550.597046 
	C360.060059,550.892395 360.015198,550.940613 360.043274,550.956848 
	C359.529083,550.544556 359.525818,549.882507 359.264709,548.994507 
	C358.041016,537.111023 356.897888,525.530151 355.785278,513.505859 
	C357.940552,514.944275 358.921021,517.346130 359.013916,520.522949 
	C360.198883,525.287903 361.032684,529.715149 360.694550,534.691284 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M481.348877,600.771179 
	C483.075836,593.332642 482.180908,585.837219 481.945618,577.997559 
	C485.751160,582.802856 486.247192,588.933899 487.137726,594.943787 
	C487.581879,597.941284 484.678741,598.503296 483.103027,600.463257 
	C482.509033,600.788818 482.086029,600.806519 481.348877,600.771179 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M550.823059,302.887085 
	C554.429749,301.136597 557.413574,302.343842 559.564087,304.691895 
	C561.843750,307.180969 561.256592,310.606018 560.645264,313.672485 
	C560.459778,314.602814 559.328247,315.785126 558.418152,316.015808 
	C557.346436,316.287506 557.168091,314.815063 556.752686,313.943329 
	C555.482422,311.277466 554.144409,308.643921 552.148315,305.813660 
	C551.052429,305.362061 550.737427,305.008606 550.463135,304.211914 
	C550.463562,303.619415 550.518982,303.384674 550.823059,302.887085 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M441.576111,364.716919 
	C448.030121,364.328278 454.109528,364.057617 460.664062,363.828003 
	C461.530457,364.602325 461.158813,365.089691 460.282410,365.577026 
	C453.214600,367.114441 446.471710,368.593964 439.330170,370.223816 
	C438.831757,370.137878 438.731964,369.901611 438.834900,369.338379 
	C439.037628,369.011444 439.316559,368.878021 439.399689,368.747681 
	C438.554718,368.235596 440.896881,367.791077 439.214783,367.282288 
	C437.898743,367.113525 436.827698,367.081604 435.355469,367.075317 
	C434.849854,366.904724 434.745453,366.708496 434.906799,366.311035 
	C437.182251,365.684784 439.191925,365.259827 441.576111,364.716919 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M166.627594,857.146973 
	C163.212723,866.144287 156.806778,873.329041 150.803772,880.845093 
	C151.004395,874.678406 155.124374,870.538452 158.134125,865.467468 
	C162.018173,863.597168 162.847626,859.060791 166.627594,857.146973 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M353.018829,353.425720 
	C353.167511,352.581696 353.322113,352.169617 353.454102,351.426880 
	C353.182617,349.863953 353.868591,349.091675 355.057251,348.334808 
	C357.225372,348.126282 356.523376,345.410431 358.694672,345.231934 
	C360.011444,346.166260 360.219788,347.406372 360.183044,349.090393 
	C359.706146,351.736725 359.054138,354.007721 359.955841,356.678406 
	C360.005188,357.753479 360.017090,358.482666 360.008514,359.575989 
	C360.148346,360.150208 360.308685,360.360260 360.143372,360.796265 
	C356.198730,359.301788 358.072510,363.266327 356.664673,364.313354 
	C356.113464,364.673645 355.710541,364.562653 355.191895,364.054291 
	C353.404968,360.662872 352.578644,357.389923 353.018829,353.425720 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M447.591858,656.493347 
	C448.241364,656.306519 448.720154,656.425110 449.332001,656.761719 
	C452.212494,657.156860 452.677338,659.574158 453.664520,661.385010 
	C457.847748,669.058777 459.562744,677.593384 462.159882,686.211121 
	C462.336456,687.047058 462.434448,687.520386 462.656281,688.324707 
	C462.906311,689.101929 463.038757,689.547302 463.273376,690.321655 
	C463.864258,692.409607 465.008453,693.999756 464.638367,696.286499 
	C464.377899,696.802063 464.227509,696.983093 463.726257,697.211670 
	C459.590790,695.182861 459.535645,691.054932 457.993225,687.355591 
	C457.734344,686.593689 457.588104,686.159180 457.315674,685.406555 
	C457.112061,684.874207 457.032898,684.660583 456.845581,684.123169 
	C455.732269,680.557983 455.097656,677.230225 454.294342,673.609131 
	C454.058960,673.112122 453.962769,672.915222 453.703430,672.434937 
	C453.328705,671.771667 453.103180,671.400269 452.699280,670.756836 
	C452.447113,670.278442 452.359619,670.080566 452.168457,669.576355 
	C451.764252,668.257751 451.641144,667.176758 450.719543,666.067810 
	C450.380615,665.631287 450.246216,665.452942 449.922241,664.993164 
	C448.561249,662.191223 447.356537,659.680420 447.591858,656.493347 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M499.177734,996.407837 
	C499.129364,995.220581 499.342072,994.280029 499.842316,993.109192 
	C508.376221,996.048096 516.444702,999.693726 525.328369,1002.177734 
	C525.795715,1002.356201 525.893250,1002.503357 526.176575,1002.843201 
	C525.179871,1004.450073 523.555603,1004.168884 522.191162,1003.758301 
	C514.583435,1001.468689 507.018433,999.037292 499.177734,996.407837 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M426.432220,480.915710 
	C425.081787,481.297058 424.134644,481.601898 422.812500,481.963593 
	C422.455139,480.112518 428.013275,479.160431 423.387177,476.273743 
	C422.910034,475.976074 424.570648,474.230865 425.678467,473.119293 
	C425.939819,472.961273 426.124573,473.044800 426.217651,473.084961 
	C431.017151,472.180756 430.253967,477.017365 432.572540,479.070465 
	C433.071655,479.635040 433.299652,479.992889 433.535706,480.683533 
	C433.591034,481.177460 433.581757,481.373871 433.501373,481.845062 
	C433.375366,482.293579 433.320496,482.467285 433.200226,482.898560 
	C433.143341,483.331818 433.151886,483.507568 433.175385,483.946869 
	C433.293915,486.553436 431.348785,487.510437 429.716492,488.942749 
	C424.513550,489.631805 427.503357,484.810120 425.780151,483.209045 
	C426.445129,482.552124 426.921661,482.138519 427.164429,481.320557 
	C427.159241,481.096741 426.835480,480.839203 426.432220,480.915710 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M443.679932,962.760132 
	C444.738525,962.835693 445.437073,962.835693 446.616455,962.966675 
	C447.034668,963.487793 446.972015,963.877808 446.892029,964.563843 
	C446.516693,965.492004 445.771118,965.470459 444.985321,966.011719 
	C444.360352,966.440857 443.853882,966.338379 443.539886,966.695190 
	C443.779694,966.599670 443.982025,966.399109 444.537537,966.281128 
	C445.311920,965.727112 445.897766,965.517456 446.797729,965.247131 
	C448.433472,964.684021 449.795349,964.277161 451.634613,963.994995 
	C452.094330,964.290588 452.076691,964.461487 452.006592,964.886353 
	C447.407745,968.660950 442.296478,970.997192 436.557556,971.248718 
	C434.778503,971.326660 432.656891,974.804443 431.729614,971.890686 
	C431.037476,969.715759 434.762756,969.662781 436.466461,968.576538 
	C437.095642,968.175415 437.448181,967.340393 437.963562,966.346069 
	C439.003540,963.647949 441.004974,962.913940 443.679932,962.760132 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M440.830902,945.597656 
	C441.056000,946.020752 441.040192,946.187988 441.019073,946.606995 
	C440.411804,947.791321 439.396759,948.124695 438.233276,948.791748 
	C437.984222,948.979431 438.000000,949.000000 437.991028,948.989502 
	C437.537628,949.493347 436.972504,949.728455 436.033386,949.636353 
	C435.454834,949.716553 435.518616,948.956177 435.301819,949.457153 
	C435.555176,949.959595 435.508698,950.289307 435.179321,950.794922 
	C434.979736,950.979187 435.000000,951.000000 434.990723,950.989136 
	C434.578552,951.461853 434.065063,951.738098 433.147278,951.791504 
	C432.671265,951.740295 432.486206,951.699524 432.039886,951.571899 
	C431.432251,951.388000 431.079620,951.340515 430.454468,951.425049 
	C430.009277,951.553528 429.829224,951.609009 429.364441,951.707947 
	C428.469604,951.747620 427.926056,951.467041 427.102142,951.133423 
	C426.050140,949.472351 423.257294,948.161377 426.793823,946.193054 
	C429.087372,944.674194 425.524200,943.661682 426.975647,942.118774 
	C427.502716,941.888672 427.928589,941.922791 428.674072,941.985168 
	C429.876007,943.132385 431.160217,942.964172 432.664246,943.099854 
	C435.796448,942.876343 438.012878,944.731995 440.830902,945.597656 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M234.372528,950.970154 
	C233.123337,949.751648 232.963013,948.517334 234.077179,946.951050 
	C237.419876,941.410767 243.018829,939.879639 248.513916,937.696960 
	C249.023529,937.948730 249.175735,938.136841 249.210190,938.668213 
	C245.815063,944.801331 241.557373,949.414429 234.372528,950.970154 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M553.850952,437.765228 
	C551.086731,438.802673 552.470154,435.529480 550.546021,435.166748 
	C549.310486,435.058533 549.084656,434.249084 548.558716,433.338989 
	C546.924072,429.084381 548.247192,425.274780 549.434753,421.149536 
	C551.375366,420.055450 551.618469,421.530945 551.924866,422.512329 
	C552.422974,424.107513 552.837036,425.689636 554.590271,426.877563 
	C555.312073,430.556122 554.297424,433.926178 553.850952,437.765228 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M142.317413,886.107056 
	C141.935181,885.974792 141.441055,885.989868 141.193878,885.989685 
	C140.587769,885.512756 140.451935,884.979187 140.753448,884.019409 
	C140.967773,883.649963 140.921951,883.362427 140.944275,883.218506 
	C141.330002,882.616516 141.797455,882.450073 142.712097,882.779175 
	C143.055542,882.984009 142.998138,882.999451 143.000702,882.969849 
	C146.607544,885.404297 151.220810,886.064697 154.485535,889.680847 
	C154.430496,891.737671 153.926193,893.140686 151.611572,893.136963 
	C146.122208,894.523010 143.338425,892.357666 142.317413,886.107056 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M369.357178,949.115845 
	C368.350800,948.591125 368.012756,947.724182 368.685760,947.463074 
	C378.553284,943.634155 387.921295,938.519287 398.662170,935.897461 
	C399.519623,937.416138 398.360352,938.043457 397.353821,938.468262 
	C393.412018,940.132080 389.806274,942.576355 385.285034,943.796387 
	C384.994598,944.027039 384.997498,943.994568 385.012146,944.001587 
	C384.572784,944.418274 383.975769,944.472229 383.209290,944.841431 
	C382.989655,945.031982 382.994843,944.991272 383.014038,944.998474 
	C382.297577,945.680115 381.335968,945.383972 380.239624,945.813843 
	C379.986359,946.030701 379.994598,945.989563 380.014160,945.997131 
	C379.298340,946.680359 378.336334,946.383850 377.239960,946.814087 
	C376.986816,947.031189 376.994690,946.990234 377.014099,946.997925 
	C376.299622,947.678284 375.342865,947.386963 374.248718,947.807983 
	C373.996765,948.024719 373.999237,947.995972 374.011292,948.003906 
	C372.695129,948.788635 371.035919,948.378784 369.357178,949.115845 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M473.851135,560.542114 
	C471.780579,561.510315 470.653198,560.867676 470.510590,558.670654 
	C470.318390,555.708862 470.043335,552.752441 469.637817,549.365356 
	C470.113525,546.946289 468.744141,544.385071 471.605133,542.896484 
	C472.561737,545.082642 472.765259,547.344604 474.055145,549.343506 
	C476.364136,552.921509 474.721893,556.539490 473.851135,560.542114 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M384.617737,548.887573 
	C380.689514,551.680237 380.543304,556.352905 378.492981,560.397278 
	C377.967499,556.954834 374.197601,557.807434 372.831055,555.268921 
	C372.823639,553.325378 374.722473,552.999756 375.250977,551.292480 
	C378.153076,548.856201 381.133698,547.299133 384.902283,548.038818 
	C385.026428,548.550903 384.944946,548.727661 384.617737,548.887573 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M581.678528,390.525604 
	C582.059082,391.790192 582.032654,393.097412 581.144043,394.687012 
	C572.518616,395.590179 567.518127,392.750763 565.277893,385.481171 
	C569.683472,390.252441 575.220337,390.383484 581.205566,390.317566 
	C581.240601,390.920410 580.773010,390.838593 580.671387,390.961639 
	C580.251587,391.470367 581.305603,391.787933 580.837830,391.312927 
	C580.370056,390.837921 581.779358,390.824249 581.374512,390.914307 
	C581.615601,390.839539 581.594177,390.606628 581.678528,390.525604 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M461.404633,688.038574 
	C458.630890,677.365112 455.968994,666.841064 449.715149,657.253052 
	C449.443848,655.032898 450.804657,654.968811 452.606445,654.922363 
	C456.698975,658.953003 456.863831,664.517517 459.187317,669.607727 
	C460.616333,674.180481 461.443329,678.496643 462.752350,682.687622 
	C463.335968,684.556152 463.643127,686.548035 461.404633,688.038574 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M352.595215,371.205353 
	C352.599182,370.292603 352.396118,369.599884 352.224121,368.621460 
	C351.887970,367.041351 351.666901,365.758514 352.826050,364.279602 
	C353.099335,363.996216 353.437805,364.091522 353.606934,364.043488 
	C354.664734,364.661713 355.600311,365.281616 356.246735,366.631805 
	C358.047211,369.265717 359.884521,371.401611 362.827759,372.821472 
	C364.175842,373.032471 365.341644,372.850494 365.959412,374.488037 
	C365.562592,375.900970 364.426788,375.821930 363.327148,376.392853 
	C362.589935,377.752167 362.188721,379.075775 360.215820,378.294220 
	C357.701935,376.646759 355.438660,375.167389 353.092316,373.219482 
	C352.853149,372.977600 352.402100,373.012421 352.176880,372.991425 
	C351.587799,372.311493 351.904175,371.844757 352.595215,371.205353 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M33.056404,878.077942 
	C31.165667,873.454041 31.681482,868.650879 31.533234,863.464600 
	C32.690781,862.477234 33.464699,861.333923 35.163879,861.805054 
	C36.101082,867.373230 35.534389,872.860107 36.996605,878.575317 
	C35.791267,878.694153 34.608894,878.387756 33.056404,878.077942 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M350.361481,1009.022339 
	C349.681366,1007.910400 349.374573,1006.805908 349.034485,1005.356445 
	C349.991364,1004.028259 351.250824,1003.746094 352.965363,1003.614258 
	C354.134491,1003.555115 354.903534,1003.449036 356.041382,1003.138062 
	C358.929688,1002.860718 361.462982,1002.576782 362.166321,1006.312012 
	C361.481720,1007.655701 360.854309,1008.596130 360.132660,1009.875977 
	C358.518677,1012.126099 356.591949,1011.878113 354.296631,1011.119080 
	C353.773407,1008.910278 352.205933,1009.049988 350.361481,1009.022339 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M451.883484,354.391968 
	C460.712250,351.500885 469.418121,351.002838 478.058289,354.957184 
	C475.664062,354.957184 473.269867,354.957184 470.439972,354.981750 
	C468.875458,356.050262 467.494507,356.358948 465.586975,356.389130 
	C461.511108,356.309753 457.870819,356.414734 453.831543,356.814423 
	C452.555298,356.353607 452.037292,355.705139 451.883484,354.391968 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M396.309998,451.589050 
	C393.806641,456.677429 392.543213,451.809418 390.515228,451.039368 
	C390.126190,450.447815 390.001465,450.059052 389.811310,449.370850 
	C389.704742,448.884064 389.663605,448.696808 389.618469,448.221924 
	C389.906250,444.901947 389.265106,441.598389 392.345734,438.818909 
	C393.297913,442.198730 395.664001,444.290924 397.328857,447.255127 
	C397.380402,447.773468 397.318848,447.964569 396.993042,448.312195 
	C396.375092,448.586395 396.015015,448.646881 395.445618,448.511475 
	C395.249420,448.431885 394.954224,448.679565 395.165283,448.753540 
	C396.151794,449.473480 396.421356,450.333466 396.309998,451.589050 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M463.355255,359.818665 
	C457.287262,359.712402 451.583527,360.717255 445.630554,359.395386 
	C445.618134,359.045380 445.827972,358.873627 446.068817,358.442383 
	C447.399139,356.554321 449.236694,356.662964 451.473633,356.685364 
	C455.975708,356.770172 459.958527,355.498230 464.484619,356.002563 
	C466.377716,356.042694 467.844666,355.896027 469.688263,356.427063 
	C471.844849,356.656616 473.593231,356.726715 475.772339,356.716736 
	C476.251709,356.881104 476.300415,357.125549 476.068237,357.616699 
	C471.771027,358.483612 467.754730,359.103790 463.355255,359.818665 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M428.194763,261.196533 
	C431.807648,258.012177 434.038239,261.251984 436.948700,263.253387 
	C437.283325,263.348602 437.476776,263.548096 437.476776,263.548096 
	C437.476776,263.548096 437.603394,263.312927 437.462524,263.296143 
	C437.295258,262.642609 437.268829,262.005829 437.325439,260.896973 
	C439.903839,259.234802 442.445740,258.340607 445.610016,259.395782 
	C446.328186,260.008240 446.533936,260.485352 446.498901,261.418854 
	C445.817200,263.122986 444.254761,263.029633 443.158936,264.221619 
	C440.927032,269.220001 437.031158,266.863464 433.389587,266.970612 
	C432.691772,266.079651 432.441681,265.148712 431.413391,264.304840 
	C430.935181,262.462677 429.471344,262.189026 428.194763,261.196533 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M425.670807,922.360718 
	C426.435730,924.263000 427.672913,924.036743 429.040710,923.509338 
	C430.407257,922.982483 431.351501,923.575623 431.737671,924.832886 
	C432.199280,926.335876 431.089539,926.763489 429.905487,927.172241 
	C428.675903,927.596619 427.389221,928.074707 426.941467,929.958252 
	C426.192841,930.160950 425.520874,929.987366 424.502625,929.785706 
	C424.156311,929.757629 424.104004,929.481812 424.109741,929.341553 
	C423.561890,928.783081 423.611176,928.060913 423.274017,927.536804 
	C423.101410,927.268433 422.843323,927.068665 422.580719,926.885315 
	C422.280670,927.397644 422.909607,927.683838 422.735962,928.399475 
	C420.051422,929.224304 418.527100,927.351868 416.135132,926.059021 
	C419.475342,924.721497 422.395203,923.552185 425.670807,922.360718 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M344.068237,380.695251 
	C343.170929,384.857086 345.838348,387.521454 347.249207,390.948364 
	C347.419281,392.191650 347.875214,393.075928 347.258484,394.399353 
	C347.013367,395.586670 347.037933,396.394928 347.027954,397.608826 
	C345.959747,399.989868 344.139679,400.052490 341.907349,399.843781 
	C339.432190,398.119873 341.303772,397.127594 341.974945,395.742462 
	C342.619843,394.411652 345.098724,392.073914 340.889984,391.720428 
	C340.169983,391.659943 340.122253,390.403564 340.130768,389.241455 
	C341.318756,386.328278 339.676086,383.723114 340.248627,381.127106 
	C340.461334,380.162659 340.409393,379.030609 341.518585,378.686096 
	C342.902893,378.256073 343.633575,379.150482 344.068237,380.695251 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M532.595581,341.408569 
	C532.777283,345.454376 531.097107,348.375214 528.512390,351.066742 
	C529.963013,344.407257 528.218140,338.119904 526.275208,331.032959 
	C530.482849,333.805237 531.395264,337.473145 532.595581,341.408569 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M97.157959,752.575439 
	C94.694885,752.246582 94.279251,749.642517 92.043343,747.914734 
	C91.255829,746.923828 91.253601,746.301086 91.755173,745.456299 
	C92.938271,739.707581 89.308571,735.079346 88.977310,729.401917 
	C92.568031,731.612549 92.428726,736.254089 94.784439,739.918091 
	C94.592514,740.669556 94.514915,741.083923 94.829887,741.772949 
	C95.049286,742.018372 94.997459,742.018433 94.996841,741.993042 
	C95.021675,745.530640 96.450447,748.783875 97.157959,752.575439 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M347.703705,379.842957 
	C350.835419,387.704224 357.115509,388.354218 364.103546,387.785278 
	C357.770874,393.579987 351.158539,391.165131 346.370544,381.304504 
	C346.027771,380.838074 345.829041,380.676270 345.785339,380.162537 
	C346.403748,379.545166 346.896088,379.470306 347.703705,379.842957 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M316.442505,590.273315 
	C316.755554,591.456238 316.869263,592.310120 317.004700,593.596069 
	C316.950806,594.841309 316.750488,595.582520 315.628601,596.042969 
	C313.659760,595.355164 313.793182,593.618652 313.112427,591.877380 
	C312.945190,591.530640 313.001923,591.502991 313.006165,591.534302 
	C311.161133,589.400146 310.352814,586.727905 309.216705,583.792725 
	C308.268646,581.095947 305.884613,579.285278 306.885040,576.102783 
	C310.259857,574.772095 312.141815,576.145508 313.340057,578.965515 
	C314.837402,582.489441 315.665192,586.181763 316.442505,590.273315 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M582.492310,339.992371 
	C586.845093,339.227386 587.859070,343.303925 589.366943,345.860687 
	C591.274048,349.094299 590.775696,352.576996 587.016541,355.356506 
	C586.086060,350.131470 585.805786,344.978302 582.612915,340.424164 
	C582.424255,340.084717 582.582092,339.921570 582.492310,339.992371 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M588.819092,359.947723 
	C590.809448,367.227112 587.167175,373.793213 578.302612,378.775452 
	C577.399719,378.346771 576.833496,377.887054 576.359619,377.216614 
	C577.124939,376.806061 577.763000,376.534454 578.589661,375.874329 
	C582.592468,371.640045 585.084900,366.949463 586.737427,361.406555 
	C587.221802,360.376373 587.830078,360.095947 588.819092,359.947723 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M17.688530,1013.746582 
	C17.512880,1008.939453 17.657455,1004.156311 17.719135,999.372070 
	C17.733320,998.271851 17.824333,997.307556 19.134848,997.284485 
	C20.733372,997.256287 20.912956,998.391724 20.824883,999.672729 
	C20.519444,1004.115295 20.232731,1008.559204 19.830561,1013.407593 
	C19.141033,1013.798462 18.559837,1013.784302 17.688530,1013.746582 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M433.361145,770.983948 
	C433.230682,770.217163 433.493073,769.462769 433.875671,768.430298 
	C434.207184,767.874023 434.430145,767.605530 434.860046,767.172241 
	C435.055298,766.997742 434.995911,767.001831 435.006897,767.029480 
	C435.417572,766.596497 435.504669,766.010681 435.852234,765.231750 
	C436.043945,765.011047 436.000977,764.995178 436.008820,765.016724 
	C436.222260,764.791870 436.441864,764.558716 436.855255,764.179199 
	C437.035004,764.019653 436.998138,764.008179 437.015442,764.019897 
	C437.437988,763.578918 437.503510,762.990295 437.859558,762.223389 
	C438.050262,762.005127 437.996063,762.006531 438.012115,762.028320 
	C439.497223,760.596985 440.102814,758.325928 442.641052,757.514893 
	C443.460938,757.574341 443.869263,757.782410 444.358704,758.435974 
	C444.743896,760.695251 443.686066,762.139587 442.450500,763.788574 
	C442.274841,763.993958 441.990936,764.379517 441.889954,764.550781 
	C442.085175,764.704346 442.381561,764.689697 442.922577,764.761353 
	C443.282410,764.981140 443.397766,765.117615 443.615784,765.509338 
	C443.829376,766.336853 443.767303,766.885803 443.323181,767.635742 
	C441.966248,768.071960 440.783356,768.279175 439.399475,768.778687 
	C437.908813,771.197754 435.824097,771.076416 433.361145,770.983948 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M241.709030,912.394897 
	C241.962219,912.153259 242.336105,911.957703 242.541382,911.909058 
	C243.645569,911.307129 244.577698,910.880066 246.050079,911.203247 
	C247.850098,912.172363 247.512436,913.525757 247.244431,915.170410 
	C246.196655,916.661194 244.953720,917.050354 243.209137,917.245117 
	C239.954865,916.964966 237.114914,916.580688 234.180389,915.076904 
	C232.566391,913.067444 230.289963,912.457520 228.937042,910.411987 
	C229.605240,909.267761 230.234909,908.482300 230.864990,907.386658 
	C233.604919,907.478760 233.854874,910.799500 236.308441,911.656006 
	C238.005966,912.248535 239.495926,913.538757 241.709030,912.394897 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M451.730469,510.197052 
	C448.015045,509.713898 446.140900,508.409637 447.944305,504.324768 
	C447.795380,503.776611 447.636383,503.602173 447.751221,503.203430 
	C448.025055,502.979065 448.000000,503.002045 447.988068,503.014160 
	C448.213257,502.797577 448.447571,502.566010 448.850891,502.154053 
	C449.022675,501.976471 448.999786,502.000092 448.987793,502.011353 
	C449.215210,501.795532 449.450470,501.564240 449.852997,501.150269 
	C450.024353,500.971741 449.996826,500.997589 449.981628,501.008789 
	C450.409607,500.617859 451.053040,500.500122 451.509460,499.698608 
	C451.854401,499.058563 452.196991,498.837067 452.923950,498.771912 
	C454.007965,499.286407 454.597107,499.924896 455.230469,500.951416 
	C455.424896,501.796448 454.932220,502.151367 454.903748,502.655365 
	C455.346375,502.247437 455.840424,501.937439 456.761597,501.986389 
	C458.083435,503.666504 456.994263,504.797882 456.135223,506.314026 
	C454.834747,508.069946 454.507965,510.337769 451.730469,510.197052 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M360.225739,356.906006 
	C357.822113,355.160950 357.158020,353.082886 359.200928,350.275360 
	C361.853699,348.657013 365.355713,350.748230 367.636780,347.417328 
	C370.685913,350.882568 368.962738,353.250214 365.351379,355.317566 
	C364.613983,355.667694 364.182922,355.845428 363.404541,356.090759 
	C362.595428,356.162231 362.124847,356.145020 361.348633,356.035156 
	C360.848022,356.224274 360.653107,356.506012 360.225739,356.906006 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M520.291992,470.802856 
	C518.455688,465.433258 520.350098,460.235657 521.134827,454.963043 
	C521.138855,454.935822 521.753967,454.999573 522.302124,455.316589 
	C523.235291,456.443756 524.361938,456.679688 525.365112,457.755188 
	C526.632629,461.316223 523.937622,463.554474 523.118652,466.648499 
	C522.838928,466.932922 522.903687,466.874115 522.861023,466.864502 
	C522.297852,468.269867 522.141113,469.891663 520.291992,470.802856 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M288.344910,645.405884 
	C292.857361,650.437012 294.960815,657.084778 297.981201,663.628784 
	C297.668152,664.529724 297.327026,665.067261 296.911133,665.931763 
	C293.092163,659.805969 290.196655,653.000183 288.344910,645.405884 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M340.837952,399.760803 
	C342.764984,398.863403 344.840973,399.733276 346.636475,398.160034 
	C348.949280,400.654968 346.435699,400.299316 344.980804,400.970398 
	C343.973572,401.976685 343.578003,403.107788 342.490662,404.138367 
	C341.171295,406.792053 343.283356,409.150604 342.125977,411.847473 
	C339.030273,409.073364 337.435211,405.641388 338.540222,401.106323 
	C339.404175,400.535522 339.878082,400.036560 340.837952,399.760803 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M87.777023,992.890381 
	C85.319336,983.552673 85.967049,974.501892 90.029083,965.402222 
	C90.395660,964.455566 90.901009,964.165710 91.818481,964.044556 
	C92.721413,964.495300 93.043129,965.194336 92.623795,965.748596 
	C86.461014,973.895386 87.593636,983.014343 88.994423,992.617188 
	C88.701904,993.008545 88.438995,992.963623 87.777023,992.890381 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M451.224365,510.236633 
	C453.681091,509.862396 453.754639,507.878418 454.690125,506.197205 
	C459.970795,507.644348 459.602386,511.765472 459.206238,516.184998 
	C458.230530,518.112915 456.874695,519.853088 456.240326,516.970886 
	C455.753784,514.760315 452.381683,515.380798 453.080200,512.414429 
	C453.050568,512.044067 453.282257,511.740906 453.413086,511.602051 
	C453.543884,511.463226 453.816284,511.196045 453.677429,511.326477 
	C453.538544,511.456940 453.261108,511.718170 453.115845,511.841492 
	C452.171967,512.229919 451.373383,512.494995 450.283813,512.893982 
	C448.798645,511.552155 450.766418,511.350403 451.224365,510.236633 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M129.680618,806.928711 
	C129.721130,810.863647 127.993027,812.498230 124.208702,812.313293 
	C121.166306,812.164551 118.086960,813.808838 114.841400,811.853394 
	C114.600334,811.287720 114.560890,811.048218 114.806107,810.583740 
	C116.170097,809.825928 117.360909,809.694946 118.854019,809.352661 
	C121.003082,810.140320 121.810272,809.693848 121.534225,807.321533 
	C123.654533,805.018738 125.954773,805.777161 128.551834,806.255737 
	C129.096634,806.421509 129.301407,806.526245 129.680618,806.928711 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M417.567932,995.898560 
	C417.471466,993.854065 415.550690,990.820129 418.948639,990.160706 
	C421.273193,989.709717 424.382599,988.844360 425.785828,992.768555 
	C425.142456,998.849609 420.610260,994.712891 417.567932,995.898560 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M465.839355,646.314697 
	C467.444244,645.415894 468.886047,644.839111 470.631287,644.120605 
	C471.155823,643.844055 471.376923,643.709290 471.949097,643.741211 
	C473.103058,648.609436 468.878937,648.966248 466.017242,650.966919 
	C462.526917,652.614136 459.339111,653.993896 455.511597,654.624634 
	C454.898407,654.530518 454.661652,654.446655 454.191895,654.066772 
	C453.928711,651.452942 454.888550,650.287537 457.368286,649.935547 
	C460.336212,649.514221 463.655243,649.593079 465.839355,646.314697 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M439.343018,276.044769 
	C437.882660,276.173523 436.754517,276.222626 435.246582,276.464142 
	C434.780945,276.376099 434.695129,276.095703 434.808044,275.422852 
	C441.604767,272.782593 447.935242,272.791382 453.924500,277.545990 
	C454.282074,278.476562 454.090149,278.970978 453.099060,279.279846 
	C450.419250,278.452179 448.175690,277.669220 445.571655,276.892883 
	C444.099792,276.248169 442.860107,276.592468 441.351562,276.304260 
	C440.571320,276.097382 440.123260,276.031250 439.343018,276.044769 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M342.473328,404.595215 
	C342.007812,402.750885 341.991211,401.269897 344.487915,401.140015 
	C345.392914,405.984558 348.678131,408.627625 353.948669,408.395508 
	C355.853790,408.311584 357.748077,407.981964 360.329041,407.686401 
	C354.792542,412.243927 348.568634,411.004242 342.473328,404.595215 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M367.817261,346.934631 
	C366.808136,351.637390 365.491058,352.095581 359.699463,349.941620 
	C359.215973,348.602325 359.112915,347.289764 359.012451,345.584351 
	C360.764404,345.137238 362.513794,345.082977 364.690521,344.927490 
	C365.980103,345.428101 366.842316,346.029938 367.817261,346.934631 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M403.299988,676.208862 
	C403.015350,675.608582 403.002167,675.212891 402.977295,674.520447 
	C403.162231,673.931030 403.328125,673.621704 403.491211,673.034668 
	C403.533478,672.595642 403.551849,672.419861 403.651825,671.991699 
	C403.853607,671.403687 403.946228,671.060547 404.059631,670.443359 
	C404.214264,669.825867 404.376923,669.502686 404.813690,669.049072 
	C406.514862,670.026062 407.325378,664.640076 409.337402,668.716919 
	C411.803558,669.927490 412.652191,671.746582 412.653748,674.369202 
	C412.321899,675.109802 412.022552,675.455139 411.361633,675.912354 
	C410.094574,676.557190 409.272552,677.385620 407.792725,677.302185 
	C407.487518,677.183350 407.183502,677.004211 407.044403,676.895691 
	C406.660034,675.721313 405.900726,675.636230 403.299988,676.208862 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M458.193604,684.898071 
	C458.559998,685.233887 458.675201,685.401245 458.914185,685.666016 
	C458.922089,685.919189 458.824158,686.062378 458.545105,686.392029 
	C458.001801,687.098572 458.190582,687.581116 458.578674,688.331177 
	C458.780945,689.010559 458.811371,689.421631 458.760071,690.162964 
	C457.943939,692.475098 459.481476,694.567566 458.188049,696.777405 
	C453.991089,693.927002 452.153595,686.599121 454.330505,680.919495 
	C456.655853,680.354675 456.467804,682.100037 457.168701,683.389282 
	C457.431793,684.075134 457.642975,684.429504 458.193604,684.898071 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M142.858109,935.316650 
	C143.488235,935.010864 143.948715,935.008972 144.755341,935.011353 
	C142.741104,941.131714 139.660873,946.900269 136.288605,952.857727 
	C135.032547,952.549194 134.922150,951.588379 134.811752,950.335205 
	C137.495789,945.203918 140.092117,940.412231 142.858109,935.316650 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M505.154755,315.712158 
	C500.589935,315.560242 497.283112,312.438293 493.001282,311.948608 
	C499.513123,310.358276 506.867645,312.115356 511.202454,316.278564 
	C511.357605,316.820160 511.396851,317.029877 511.115997,317.240723 
	C508.684845,317.571930 507.803040,314.295258 505.154755,315.712158 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M358.613922,770.129517 
	C359.129364,771.228699 359.353424,772.495056 359.896271,773.990723 
	C357.785828,777.569763 355.373260,780.931824 352.901489,784.249695 
	C352.657013,784.577942 352.050781,784.636597 350.628876,784.277039 
	C353.193420,779.616882 355.757996,774.956726 358.613922,770.129517 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M103.350891,1010.945923 
	C102.944977,1010.779968 102.950363,1010.608032 103.020187,1010.186157 
	C103.475006,1009.489624 103.325920,1008.880310 103.763397,1008.203857 
	C106.614815,1008.291870 106.059769,1005.892456 106.579781,1004.636169 
	C108.952560,998.903931 111.110016,993.082520 113.684052,987.155396 
	C112.429993,995.266113 109.039429,1002.900269 105.678955,1010.825073 
	C104.859230,1010.988525 104.310707,1010.964233 103.350891,1010.945923 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M523.175049,466.840149 
	C522.144531,463.868286 524.274719,461.489624 524.887878,458.350098 
	C524.485779,456.983459 525.253906,456.321991 525.788330,455.280304 
	C526.250183,452.862976 527.917786,451.953918 529.809082,450.969788 
	C530.347900,451.664886 530.615723,452.393219 530.927612,453.508423 
	C529.383789,455.483521 531.005188,457.965820 529.086609,459.766327 
	C525.402527,460.978394 526.031189,465.088531 523.175049,466.840149 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M460.171021,365.858826 
	C460.265533,365.204376 460.573578,364.773804 461.010406,364.106140 
	C461.873322,363.820709 462.607422,363.772339 463.694641,363.614685 
	C465.779938,365.200439 464.003815,366.260895 463.175110,367.212708 
	C459.245697,371.725677 454.207153,374.428833 448.124115,375.355438 
	C451.014923,373.499023 453.927063,371.674744 456.787567,369.772736 
	C458.235687,368.809875 460.168182,368.266327 460.171021,365.858826 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M446.033020,262.129303 
	C446.028168,261.435822 446.011536,261.048798 446.013092,260.371643 
	C446.152466,259.933197 446.273651,259.784821 446.669434,259.551575 
	C447.132996,259.497803 447.321960,259.528870 447.712219,259.764893 
	C450.361908,260.014954 451.215759,255.283234 454.812805,257.921082 
	C455.585541,258.622742 455.889893,259.240509 455.971008,260.302002 
	C455.930847,260.871765 455.889862,261.095764 455.725037,261.634460 
	C455.251495,262.522583 454.764191,262.948944 453.900024,263.390808 
	C452.854584,263.666840 452.088684,263.820801 451.608368,264.904236 
	C451.456085,265.358734 451.414154,265.547211 451.134094,265.900696 
	C449.856049,266.044434 448.816101,266.023224 447.386047,265.998108 
	C446.622955,265.468475 446.496124,264.860077 446.320312,263.942963 
	C446.125336,263.249725 446.052307,262.846405 446.033020,262.129303 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M366.249146,445.223022 
	C365.974976,446.909393 365.370605,448.365265 364.144806,451.318146 
	C362.734161,446.902557 364.318390,440.980621 357.383789,442.736115 
	C357.692474,440.418915 359.129791,438.243835 361.574310,438.303619 
	C363.826050,438.358612 363.736938,441.275879 364.793793,442.852386 
	C365.240051,443.518066 365.548096,444.276337 366.249146,445.223022 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M437.154541,997.312134 
	C440.688293,996.620850 441.911102,1000.143127 444.717163,1001.747437 
	C447.935486,1003.859497 450.847656,1005.846375 453.759796,1007.833313 
	C453.490814,1008.213074 453.221802,1008.592896 452.952820,1008.972717 
	C446.443146,1007.117004 441.531647,1002.866516 437.154541,997.312134 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M412.204224,675.186646 
	C412.203400,672.824219 410.195953,671.496948 409.725830,669.243225 
	C410.601074,667.090759 411.603821,665.231689 412.920288,663.137451 
	C414.376373,666.034119 415.518738,669.165833 416.700287,672.654053 
	C415.940643,674.027527 414.795288,674.551331 413.402161,675.253662 
	C412.893463,675.359985 412.682312,675.358521 412.204224,675.186646 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M308.998535,998.997559 
	C310.019653,1001.945068 312.024963,1002.683716 314.989258,1001.997009 
	C318.837189,1001.105591 322.726562,1001.036987 326.745605,1002.712341 
	C320.252472,1004.753967 313.483826,1004.187988 306.809814,1003.124939 
	C308.283386,1002.104797 307.759583,1000.461731 308.775238,999.232605 
	C308.995514,998.997375 309.000000,999.000000 308.998535,998.997559 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M134.646362,950.196899 
	C135.242676,950.794495 135.585892,951.593445 135.964905,952.720520 
	C136.000702,953.048706 135.997574,952.983948 136.029510,952.978516 
	C135.912460,953.105347 135.763443,953.237610 135.767838,953.626465 
	C135.231369,957.502747 133.151825,960.314941 130.338791,962.961914 
	C130.176697,960.898621 128.643478,958.793945 129.925201,956.298950 
	C132.354843,954.848328 132.819092,952.176575 134.646362,950.196899 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M554.924683,426.608582 
	C549.021301,428.558777 552.151367,422.954193 549.970337,421.078857 
	C549.749207,419.347137 550.389099,418.160858 551.940918,417.112732 
	C554.556335,416.757690 555.168579,418.094849 555.018005,420.262970 
	C554.882202,422.218689 554.990479,424.191315 554.924683,426.608582 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M347.159973,438.131073 
	C346.893494,437.914917 346.963959,437.503662 346.988525,437.296661 
	C348.961639,436.713226 351.412231,436.190460 352.561523,437.741821 
	C353.990814,439.671143 352.084503,441.695770 351.117889,443.545624 
	C350.588928,444.557983 350.061584,445.571198 349.252930,446.789124 
	C346.955750,444.380280 347.479156,441.312256 347.159973,438.131073 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M481.368774,273.183228 
	C484.659637,270.981323 487.241272,272.732574 489.425385,275.032867 
	C491.243866,276.948090 492.664886,279.240662 494.133911,281.713135 
	C490.641693,281.092224 489.427460,277.494141 486.156555,275.798859 
	C485.894775,276.162079 485.664093,276.408997 484.834198,276.348969 
	C483.306702,275.553833 482.309082,274.627594 481.368774,273.183228 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M484.154602,970.263611 
	C489.299286,968.704102 494.696045,969.019409 500.537323,969.031738 
	C500.603516,971.429199 498.729523,970.946167 497.164276,970.991882 
	C493.646149,971.094910 490.309479,970.772888 487.014618,973.250122 
	C483.398590,975.968872 485.723236,970.988892 484.154602,970.263611 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M455.073975,262.135162 
	C454.986359,261.824890 455.014648,261.347046 455.040466,261.109070 
	C455.790802,260.263153 456.001465,259.329376 456.741882,258.333313 
	C457.200012,257.666931 457.460266,257.366455 458.005371,258.024811 
	C458.669678,258.778381 459.081787,259.447540 459.525726,260.447998 
	C459.749084,260.893036 459.842163,261.072418 460.097382,261.513092 
	C460.613617,262.345245 461.167358,262.610748 462.100403,262.846985 
	C464.635193,263.907257 464.710266,261.052795 466.548920,260.677307 
	C467.092438,260.565155 467.318573,260.561188 467.861877,260.685974 
	C468.489044,261.156799 468.736359,261.538788 469.017212,262.294250 
	C469.324127,263.518738 469.475739,264.419495 469.207794,265.654785 
	C468.600952,265.980743 468.134766,265.995300 467.318420,266.023651 
	C463.736420,265.641510 460.363953,266.796722 457.004456,264.787476 
	C456.005035,263.943726 455.509094,263.254852 455.073975,262.135162 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M154.280884,889.816223 
	C150.557236,887.388428 146.347076,886.434326 143.045471,883.289185 
	C143.884552,882.420776 144.599838,882.969543 145.731567,883.476929 
	C149.694031,885.560181 153.463318,886.942322 157.382065,888.009766 
	C158.714813,888.372742 160.745392,887.972046 160.833771,890.518738 
	C158.318741,892.660156 156.309784,891.626099 154.280884,889.816223 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M162.221161,871.286743 
	C163.580521,866.453979 167.042801,863.116882 169.935135,859.073730 
	C170.226669,859.407410 170.166779,859.855652 170.110504,860.642944 
	C168.283798,865.202271 166.453491,869.422485 164.319778,873.823120 
	C161.793823,874.294006 162.819733,872.478333 162.221161,871.286743 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M433.862427,990.276306 
	C436.844177,989.735107 438.065002,991.762207 438.441376,993.797363 
	C438.725250,995.332458 436.732758,994.707886 435.360321,995.024292 
	C432.840118,994.801575 430.177673,995.800476 429.076538,992.364746 
	C429.867859,989.321716 432.339691,991.717224 433.862427,990.276306 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M431.269836,263.313354 
	C431.759735,264.625153 433.834991,264.776855 433.100769,266.690002 
	C433.000336,266.975281 432.525543,267.102966 432.289276,267.171692 
	C430.313904,267.108490 428.696686,266.406342 426.812225,266.796326 
	C425.310486,267.107056 422.985260,267.830139 422.580658,265.114319 
	C422.167572,262.341736 423.616241,261.013000 426.717285,261.041687 
	C428.019165,262.402832 429.306671,263.125275 431.269836,263.313354 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M586.619141,361.153717 
	C587.099182,367.339691 584.311035,372.081482 579.294678,376.011902 
	C578.828857,375.961151 578.678894,375.766754 578.694824,375.243652 
	C581.331177,370.332703 583.801575,365.750488 586.619141,361.153717 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M337.564026,1002.932922 
	C337.928680,1001.329651 339.220825,1000.000610 339.054932,997.955139 
	C338.905029,996.106628 340.378510,995.947327 341.793579,995.993835 
	C343.279572,996.042664 343.922974,996.700562 343.392242,998.223145 
	C342.796326,999.932861 345.424591,1000.429077 344.827698,1002.464600 
	C342.509491,1002.848206 340.249054,1002.896545 337.564026,1002.932922 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M346.522949,379.855133 
	C346.451447,380.329620 346.454224,380.702148 346.340332,380.851013 
	C345.749908,380.987793 345.273346,380.975677 344.436646,381.000244 
	C343.146332,380.755432 342.522430,378.787872 341.920959,379.554138 
	C340.897736,380.857788 340.599792,382.884949 341.292297,384.533386 
	C341.887878,385.951050 343.747345,387.116608 341.063751,388.690918 
	C340.578186,389.309601 340.217346,389.460785 339.548340,389.145630 
	C339.344482,387.903809 339.354248,386.902924 339.410339,385.524994 
	C339.447296,384.933533 339.437836,384.719177 339.456787,384.184174 
	C339.416443,383.138031 339.347717,382.412537 339.185181,381.334534 
	C338.379517,380.261749 338.302032,379.436188 339.061951,378.298035 
	C340.098785,378.032074 340.758820,378.002289 341.748810,377.956482 
	C343.936371,377.315704 345.873901,376.440338 346.522949,379.855133 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M117.574051,681.877502 
	C117.859894,682.573975 117.902252,682.994202 117.936905,683.732056 
	C117.572296,684.371338 117.215378,684.693054 116.613167,685.292480 
	C114.052979,680.200867 112.696579,674.572937 111.802551,668.389771 
	C111.961662,667.862427 112.164619,667.753662 112.652153,667.840576 
	C114.401344,672.557983 115.865952,677.079590 117.574051,681.877502 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M172.655899,841.029358 
	C170.500320,846.605835 166.462662,850.910522 161.776718,854.678894 
	C164.034866,849.149353 168.083984,845.031860 172.655899,841.029358 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M424.351562,284.184814 
	C426.053162,279.905701 430.465424,280.429230 433.947906,279.142395 
	C435.305084,278.640930 436.844879,278.633789 438.651123,278.228241 
	C440.126373,278.325806 441.252014,278.596649 442.723572,278.864075 
	C443.784088,278.331299 444.193634,278.506866 443.819031,279.569611 
	C436.724304,279.592468 430.584778,281.385254 424.351562,284.184814 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M490.639832,525.463013 
	C490.890106,520.033020 490.787689,514.787781 495.444366,510.857605 
	C497.262909,511.390747 498.369476,512.303650 498.152832,514.342896 
	C492.977356,514.245361 492.688477,517.945801 492.058411,521.303528 
	C491.665039,523.399841 493.178345,525.808350 490.634155,527.588623 
	C490.388397,526.961670 490.530579,526.365784 490.639832,525.463013 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M130.364777,1015.136230 
	C128.620239,1013.276917 128.620056,1011.054626 129.966446,1010.111328 
	C132.217209,1008.534424 134.450333,1010.373840 136.767181,1011.755737 
	C138.103973,1015.043518 135.537125,1014.921631 133.488434,1015.708008 
	C132.240265,1015.918030 131.415131,1015.894836 130.364777,1015.136230 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M531.003662,1015.441650 
	C532.763000,1013.299011 534.507141,1015.690002 536.635254,1014.999634 
	C539.307068,1014.484131 540.489319,1015.363831 540.232788,1018.082336 
	C537.380005,1018.790222 534.750732,1019.177795 531.685791,1019.606445 
	C531.168457,1018.400513 531.086609,1017.153503 531.003662,1015.441650 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M385.388550,944.059204 
	C389.545868,941.504822 394.097168,938.982605 398.854492,936.171082 
	C400.492920,934.593201 400.760406,935.676758 401.007446,937.175476 
	C396.327698,940.604980 391.265808,942.836731 385.388550,944.059204 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M165.326385,944.066040 
	C166.085571,941.417114 166.821259,938.718262 170.862839,940.805420 
	C173.956085,942.402771 173.251648,943.771667 171.262207,945.873108 
	C169.196472,945.424133 167.437943,944.768982 165.326385,944.066040 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M432.669922,417.031128 
	C434.093353,418.048096 437.090637,418.489288 433.784943,420.701599 
	C432.013306,421.887207 433.731537,424.508942 432.675446,426.501404 
	C432.549408,427.896057 431.898987,428.493408 430.406982,428.277161 
	C430.656311,424.394226 428.941986,420.207977 432.669922,417.031128 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M572.832520,338.019958 
	C578.701416,341.093353 578.093933,346.787781 578.609375,352.430450 
	C578.379639,353.236176 578.056091,353.436768 577.385254,353.155731 
	C576.929504,348.716980 575.870789,344.756683 573.126587,340.824249 
	C572.464233,340.340912 572.385010,340.153656 572.270203,339.662842 
	C572.273010,338.949341 572.386536,338.562256 572.832520,338.019958 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M82.274086,1017.186584 
	C73.399239,1019.299988 64.553024,1019.270508 55.369881,1020.299744 
	C58.642136,1018.086426 62.958218,1018.320312 67.032021,1018.025024 
	C71.821243,1017.678040 76.530350,1017.033447 81.634682,1016.155396 
	C82.189232,1016.403442 82.334236,1016.625000 82.274086,1017.186584 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M519.870117,302.854736 
	C516.513062,302.843018 513.165955,302.440369 509.392212,301.969330 
	C508.903717,299.824615 509.868958,298.904114 511.982208,298.977081 
	C515.106506,299.085052 518.445190,298.578674 519.870117,302.854736 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M484.246765,382.256348 
	C485.278290,377.854492 480.305847,377.046021 478.745605,373.778503 
	C480.128265,370.705688 482.052307,368.622894 486.021973,369.279907 
	C486.204590,369.591461 485.993103,369.974030 485.726959,370.016846 
	C480.000000,370.937927 481.138641,373.545380 483.983246,376.732605 
	C485.377625,378.294891 486.228516,380.078064 484.246765,382.256348 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M352.855194,373.357025 
	C356.420868,372.506348 357.662994,375.884308 360.039276,377.698883 
	C358.932922,378.054779 357.855652,378.048706 356.374573,378.075073 
	C355.820862,378.228333 355.671021,378.349121 355.374939,378.718811 
	C353.334808,381.258179 352.429169,379.313751 352.168457,377.936646 
	C351.920532,376.626984 352.590729,375.143494 352.855194,373.357025 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M143.363434,563.625000 
	C142.575958,568.121826 143.572617,572.201965 143.586029,576.638245 
	C143.034042,576.955872 142.643814,576.958801 141.667191,576.911621 
	C140.683716,571.800232 140.654907,566.758667 141.928864,561.368042 
	C142.149063,560.799194 142.328339,560.646973 142.750549,560.750549 
	C142.993484,561.006348 143.117737,561.026428 143.153656,560.974731 
	C143.666641,561.651489 143.816467,562.437073 143.363434,563.625000 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M507.111145,968.454102 
	C509.264618,976.155212 508.355438,979.927673 503.406799,982.601807 
	C502.897522,979.448547 505.504425,977.406372 505.942322,974.358826 
	C507.312531,972.491333 507.257812,970.678528 507.111145,968.454102 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M524.776123,292.727448 
	C530.956665,293.955383 536.158752,297.019562 540.256348,301.766754 
	C535.045044,299.727295 530.989258,295.834198 525.375183,294.032288 
	C524.895386,293.680389 524.762451,293.414490 524.776123,292.727448 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M451.527557,353.944641 
	C452.244751,354.417725 452.524384,354.867920 452.941345,355.545593 
	C452.520996,356.884155 451.473114,356.917542 450.056305,356.984192 
	C448.670868,356.996918 447.668915,357.039001 446.323364,357.177185 
	C443.570465,357.393250 441.179077,357.704865 438.381836,358.045258 
	C437.853394,357.893158 437.730804,357.712311 437.784912,357.255432 
	C442.025757,354.620544 446.409485,353.634003 451.527557,353.944641 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M427.624268,961.034180 
	C428.440643,962.626526 425.654907,962.947449 426.828247,964.964722 
	C426.334991,967.364868 424.448822,967.702454 423.466339,966.167786 
	C422.285492,964.323059 421.035126,964.035461 419.162720,963.926758 
	C417.638885,963.838257 417.653625,963.584412 419.815674,961.256470 
	C420.002441,960.997559 420.000000,961.000000 419.999084,961.001099 
	C420.174622,960.877808 420.351074,960.753418 420.782959,960.828003 
	C423.091583,963.130676 425.136353,961.708252 427.624268,961.034180 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M447.431488,656.197876 
	C448.782745,658.905884 449.802917,661.623962 450.932678,664.689392 
	C450.470428,665.633911 449.752716,665.806396 448.590637,665.656616 
	C445.769684,663.410095 443.911774,660.851746 443.028992,657.404053 
	C444.493134,656.784119 445.796753,656.495972 447.431488,656.197876 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M360.029175,361.330750 
	C359.858521,360.843842 359.899353,360.665436 359.964081,360.213562 
	C365.012268,362.423645 367.871368,357.662842 371.838074,356.265625 
	C369.575806,362.167328 365.520111,364.003174 360.029175,361.330750 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M427.455078,746.914185 
	C426.409515,747.863525 425.735626,748.616394 424.904205,749.526855 
	C424.051208,749.525879 423.355713,749.367188 422.318787,749.101746 
	C421.977386,748.994995 421.677856,748.599243 421.875793,748.186035 
	C424.500122,745.182556 426.926514,742.592285 429.656494,739.832336 
	C431.993530,742.844238 430.275818,744.891541 427.455078,746.914185 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M65.505936,956.454651 
	C69.981773,955.856934 74.922760,956.609558 79.828056,954.392090 
	C80.766426,953.353271 81.608078,953.336731 82.885536,953.786743 
	C85.238876,954.327209 84.757729,955.295776 83.709274,956.501709 
	C77.634773,957.133362 71.739174,957.055359 65.505936,956.454651 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M183.132599,732.597656 
	C180.303070,728.476257 181.887024,722.892944 179.112793,718.087402 
	C178.641113,717.229065 178.530197,716.545776 178.357361,715.519653 
	C178.389572,714.983887 178.483658,714.790894 178.810150,714.374878 
	C179.454468,714.162354 179.866379,714.172852 180.582428,714.244507 
	C181.580750,720.268860 183.546646,726.062317 183.132599,732.597656 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M458.107117,697.309326 
	C458.369385,694.816895 456.364349,692.786865 457.725525,690.277344 
	C460.459503,689.930847 459.593842,692.313293 460.458282,693.430054 
	C461.635590,694.950928 461.788147,697.165222 463.931641,698.473145 
	C464.239929,698.982300 464.300293,699.220337 464.067871,699.681885 
	C462.513245,700.187683 461.251404,700.470032 459.678558,700.787476 
	C459.005157,699.750061 458.642761,698.677551 458.107117,697.309326 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M451.649750,954.027100 
	C450.286499,957.667358 446.575043,958.694702 443.223633,960.748901 
	C442.388275,961.759888 441.658356,962.298035 440.309509,962.139587 
	C439.993378,961.551941 439.998199,961.104431 440.001099,960.321167 
	C443.412018,957.340088 447.406677,955.799622 451.649750,954.027100 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M442.851074,657.251892 
	C444.854950,659.390747 446.520386,661.709290 448.317139,664.341675 
	C448.200409,665.505554 447.540161,665.801025 446.368225,665.932251 
	C441.570709,664.437744 441.821167,661.024658 442.851074,657.251892 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M510.147766,364.068176 
	C510.032013,365.834839 509.936279,367.276947 509.843689,369.144745 
	C510.044861,370.029449 509.940155,370.382416 509.205566,370.795959 
	C508.928986,370.980255 508.987274,370.965607 508.974213,370.937683 
	C507.754028,371.519562 506.961731,373.081757 504.965393,372.702240 
	C505.983704,369.968048 509.819611,368.252869 507.156586,364.515106 
	C507.151184,363.147614 506.730011,361.546814 508.173492,361.376099 
	C509.439941,361.226288 509.874542,362.617981 510.147766,364.068176 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M82.527756,1017.430420 
	C82.064705,1017.302429 82.060478,1017.078186 82.050240,1016.517944 
	C91.367828,1016.142517 100.691422,1016.103149 110.477669,1016.101257 
	C105.326920,1017.865967 99.551865,1016.613403 93.864464,1017.041443 
	C90.251625,1017.313293 86.613411,1017.248230 82.527756,1017.430420 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M130.049652,1015.168640 
	C130.830627,1014.861389 131.592209,1014.880554 132.734619,1014.875183 
	C134.962433,1014.231201 137.200699,1014.869080 139.063278,1013.034241 
	C140.074265,1012.968811 140.716431,1012.983643 141.678680,1012.999084 
	C142.379959,1013.876099 142.762466,1014.752441 142.029419,1015.946533 
	C138.309280,1017.425293 134.556488,1016.689331 130.426666,1016.876892 
	C129.998596,1016.364441 130.014420,1015.929749 130.049652,1015.168640 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M220.997620,956.633362 
	C215.757004,954.948547 210.218430,954.233826 205.149811,951.298340 
	C210.503372,951.676208 215.760361,953.311646 221.143066,955.737793 
	C221.412155,956.020386 221.101303,956.407715 220.997620,956.633362 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M573.043579,337.877258 
	C573.037292,338.323212 572.996826,338.808228 572.972046,339.657990 
	C572.794922,340.154022 572.602173,340.285309 572.059509,340.399078 
	C571.028931,340.161957 570.518433,339.669830 569.605286,339.204895 
	C566.955200,337.500732 566.655457,335.130737 566.860229,332.325592 
	C569.106384,332.735718 570.513062,334.202759 571.927307,336.100128 
	C572.094360,336.844879 572.276428,337.237671 572.825928,337.782501 
	C573.089111,337.982910 573.009399,337.916321 573.043579,337.877258 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M443.360046,352.369202 
	C440.616852,352.834290 438.443024,354.326416 435.366180,353.734436 
	C439.760315,350.330444 444.518372,349.942383 449.911285,349.454865 
	C448.040009,351.779846 445.778229,351.776367 443.360046,352.369202 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M453.744141,653.906189 
	C453.958923,653.770691 454.413635,653.882507 454.644958,653.918579 
	C458.079346,658.478027 459.172089,663.679016 459.553711,669.424683 
	C459.164856,669.960144 458.947327,670.124451 458.351318,670.134216 
	C456.349609,665.201416 454.726440,660.423035 453.053253,655.262207 
	C453.178619,654.600403 453.354004,654.321045 453.744141,653.906189 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M492.882141,508.763611 
	C490.012970,512.504272 487.582703,516.357727 486.476501,521.259644 
	C486.156494,521.137634 486.074799,520.802429 485.872864,520.236755 
	C485.391602,517.778625 486.246674,515.829590 487.227295,513.501221 
	C487.080017,512.419556 487.129120,511.738708 487.535339,510.749695 
	C488.259003,509.641998 488.956329,508.998474 490.140198,508.383148 
	C491.222839,508.098907 491.938202,508.169800 492.882141,508.763611 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M94.335640,934.957458 
	C95.809410,930.511597 99.652199,927.899780 103.677635,925.093567 
	C101.972427,929.365295 98.536896,932.345093 94.335640,934.957458 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M401.759583,660.243408 
	C408.081177,657.107849 405.834991,661.830078 405.966064,664.745117 
	C405.164795,666.347900 404.050964,667.102661 402.283417,667.451660 
	C401.711609,667.458496 401.484253,667.421326 400.973816,667.188599 
	C400.452484,666.599854 400.299591,666.176941 400.276398,665.392944 
	C401.704681,663.804199 400.057159,661.727356 401.759583,660.243408 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M525.889954,450.474487 
	C522.042542,453.100861 520.380676,452.089508 520.812439,447.647736 
	C521.007629,445.639648 520.331909,443.446930 522.213257,441.108734 
	C524.065369,444.202637 521.422546,447.779877 524.630981,450.009277 
	C525.411194,449.802765 525.718262,449.839783 525.889954,450.474487 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M293.426025,717.566650 
	C290.923157,713.756958 292.097809,709.440491 292.191010,704.780518 
	C292.267029,704.347473 292.576233,704.288269 292.727844,704.245972 
	C293.184235,704.313904 293.464935,704.467896 293.946228,704.580688 
	C294.034546,708.769897 293.898224,713.044250 293.426025,717.566650 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M92.099884,963.668701 
	C91.638344,964.361267 91.156349,964.666443 90.383392,965.002441 
	C87.148148,964.542236 87.309380,962.001160 86.607880,959.530518 
	C86.481537,959.114746 86.516876,959.138977 86.497818,959.130859 
	C87.374817,959.761230 87.426590,958.937805 87.838272,958.169922 
	C90.138168,958.005432 90.197166,960.493896 91.987503,961.465088 
	C92.138130,962.252075 92.108788,962.766724 92.099884,963.668701 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M112.071655,811.887756 
	C109.856804,810.803345 109.766953,808.549866 108.725006,806.473145 
	C109.382942,805.303467 110.317505,805.564392 111.549545,805.643188 
	C112.120384,805.705200 112.349510,805.732544 112.923279,805.818970 
	C113.496094,805.936401 113.724258,805.994873 114.283188,806.185486 
	C116.303223,807.400757 116.954254,808.705505 115.255173,810.723938 
	C115.012062,810.987793 114.817719,811.245789 114.728745,811.386536 
	C113.877205,811.616455 113.114624,811.705688 112.071655,811.887756 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M353.769958,404.563690 
	C349.584473,406.385773 349.907074,402.997955 349.283020,400.916412 
	C349.007111,399.996124 350.047729,399.367706 350.811737,399.699951 
	C352.741638,400.539093 355.515137,400.990662 353.769958,404.563690 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M54.651299,1020.850342 
	C55.020046,1022.070251 56.168987,1021.934937 56.931007,1022.702393 
	C52.637043,1022.757690 48.040131,1023.859314 42.782406,1021.919495 
	C45.942383,1020.517761 48.277561,1021.084839 50.960785,1020.691101 
	C52.368141,1020.649658 53.329994,1020.724976 54.651299,1020.850342 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M411.830597,431.822205 
	C408.508942,435.544098 404.585236,435.746063 400.081024,433.393127 
	C400.022095,432.907684 400.190308,432.729401 400.653687,432.330566 
	C404.213074,430.688812 407.601074,430.770386 411.341553,431.464539 
	C411.658752,431.649323 411.773010,431.764862 411.830597,431.822205 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M125.047821,968.302612 
	C126.396278,966.273010 127.393364,964.247864 129.690125,963.033997 
	C129.914810,964.590271 129.023727,965.989441 129.546570,967.807739 
	C130.049423,969.556458 127.916191,970.405884 126.802086,970.880432 
	C125.496651,971.436523 125.482780,969.558228 125.047821,968.302612 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M437.650940,409.040710 
	C438.718536,410.326813 440.586639,411.491455 437.918304,412.972687 
	C436.287476,413.877960 435.057434,415.505280 433.328308,416.913147 
	C432.739532,413.452454 435.561554,411.557587 437.650940,409.040710 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M63.827682,1012.326172 
	C70.909325,1012.088562 77.757172,1012.088562 84.605019,1012.088562 
	C84.613068,1012.585266 84.621124,1013.082031 84.629181,1013.578735 
	C78.093811,1013.578735 71.558449,1013.578735 64.620659,1013.577515 
	C63.767906,1013.388123 63.571693,1013.043274 63.827682,1012.326172 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M230.280228,955.292969 
	C235.938828,953.249207 241.963379,954.198730 247.979935,954.553894 
	C242.114212,953.988403 236.461884,956.727356 230.280228,955.292969 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M439.687317,962.132690 
	C440.781219,961.690735 441.573883,961.382080 442.685333,961.041077 
	C443.264954,961.465515 443.525818,961.922302 443.913330,962.607361 
	C442.230316,963.790649 440.420624,964.745667 438.305573,965.844727 
	C437.239777,966.022827 436.479309,966.056885 435.340332,966.130493 
	C434.843353,965.970032 434.724884,965.769958 434.781738,965.268433 
	C436.433380,964.066589 437.909729,963.166260 439.687317,962.132690 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M531.333130,430.966919 
	C530.566467,428.747833 533.170898,427.556488 533.087708,425.293365 
	C533.043335,424.087036 533.342163,422.226288 535.091003,422.715240 
	C536.666382,423.155731 535.921814,424.895447 535.725098,426.100433 
	C535.596741,426.886627 535.221924,427.632568 534.896240,428.789886 
	C533.126526,428.527069 532.739868,430.361877 531.333130,430.966919 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M399.313629,485.978821 
	C399.014801,482.743042 399.396027,479.563141 400.534149,476.511658 
	C400.650208,476.564636 400.813965,476.586273 400.873383,476.676544 
	C401.049774,476.944824 401.185120,477.240051 401.533081,477.781189 
	C401.745026,478.484222 401.760406,478.930817 401.885315,479.695801 
	C403.026764,481.648224 403.599701,483.343323 402.385498,485.583008 
	C402.081329,485.930237 402.044525,485.963684 402.026672,485.980957 
	C401.238770,485.993683 400.468719,485.989166 399.313629,485.978821 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M563.754883,338.092468 
	C563.887634,339.245209 563.930481,340.047028 563.973389,340.848846 
	C563.702209,340.931976 563.431091,341.015106 563.159912,341.098236 
	C561.720215,337.368896 560.280579,333.639587 558.840881,329.910248 
	C562.158813,331.630310 562.585999,334.863770 563.754883,338.092468 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M326.974304,442.189209 
	C324.205780,444.255127 320.985718,445.702118 317.025818,445.278473 
	C319.772766,443.852264 322.519745,442.426056 325.629150,440.991821 
	C326.221527,441.335052 326.451508,441.686340 326.974304,442.189209 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M405.850250,1014.085876 
	C407.064819,1015.505249 409.356110,1013.529541 409.796417,1015.658569 
	C409.895142,1016.135681 409.390198,1016.975281 408.922455,1017.288391 
	C407.410828,1018.300415 406.090729,1017.093994 404.781921,1016.596375 
	C403.738342,1016.199707 402.851837,1015.389832 402.024353,1014.847717 
	C403.528351,1012.509521 404.544464,1014.162659 405.850250,1014.085876 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M340.063171,432.681580 
	C340.551819,431.897919 341.067017,431.547119 341.791626,431.081787 
	C344.544800,431.133484 347.088562,431.299774 350.337891,431.512177 
	C346.986511,433.729095 343.484070,432.371948 340.400391,434.037964 
	C340.029053,433.689484 340.059387,433.401978 340.063171,432.681580 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M446.180603,666.221008 
	C446.579041,665.592468 447.169861,665.239807 448.104553,664.771362 
	C449.091522,664.779602 449.734650,664.903687 450.710022,665.032227 
	C451.042267,665.036804 451.021576,664.992432 450.997314,664.995850 
	C451.977325,666.332947 452.246826,667.930420 452.799927,669.775146 
	C453.010498,670.048584 453.013367,669.992126 452.987061,669.981812 
	C453.247833,670.273743 453.415070,670.632019 453.204773,671.549622 
	C450.059143,671.024841 449.201813,667.594604 446.180603,666.221008 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M445.757812,403.094849 
	C444.562714,406.202911 441.347168,407.209839 438.355225,408.973938 
	C438.992981,405.191681 442.196808,404.148285 445.757812,403.094849 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M106.954491,973.371948 
	C104.835030,977.753723 103.447975,975.694702 101.815765,972.722412 
	C103.892944,966.804810 105.162224,971.616394 106.954491,973.371948 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M195.028992,971.103516 
	C196.604065,970.668884 197.820343,970.342102 199.036636,970.015259 
	C199.179306,970.430481 199.321991,970.845642 199.464676,971.260864 
	C195.694092,972.557129 191.923508,973.853455 188.152924,975.149719 
	C189.635513,972.445557 192.422150,972.339661 195.028992,971.103516 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M456.926422,684.166626 
	C456.107849,683.009521 455.615723,682.013000 454.914215,680.852417 
	C454.638733,680.054077 454.572632,679.419861 454.505035,678.460327 
	C454.274414,677.608887 454.099213,677.070007 454.147949,676.203308 
	C454.114838,675.486267 454.046783,675.052307 453.910828,674.295898 
	C453.608337,673.543884 453.518066,673.085938 453.767761,672.298645 
	C456.283905,675.405579 456.570984,679.523132 457.913086,683.662720 
	C457.701141,684.141602 457.477020,684.234375 456.926422,684.166626 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M566.848511,406.087769 
	C565.618042,407.480408 565.379089,406.471375 565.074158,405.554901 
	C564.763245,404.620239 564.907593,403.183655 562.966797,403.991760 
	C561.570557,403.306244 562.015991,401.800568 561.350952,400.279053 
	C561.539612,399.799469 561.856262,399.689819 562.657166,399.714813 
	C565.112854,401.334290 566.856689,402.961700 566.848511,406.087769 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M438.659729,368.998444 
	C439.021149,369.237885 439.004639,369.464355 438.959808,370.032471 
	C437.173706,373.106873 434.560303,373.038177 431.115082,372.724304 
	C433.456909,370.423828 435.693146,369.384796 438.659729,368.998444 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M410.175201,525.098755 
	C410.089081,521.141907 407.377625,517.771118 408.117859,513.401611 
	C411.279266,516.288879 410.632629,520.496582 410.874939,524.943115 
	C410.817993,525.408630 410.389618,525.201782 410.175201,525.098755 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M63.628403,1012.002075 
	C64.113625,1012.413452 64.165771,1012.738403 64.218079,1013.319824 
	C60.448593,1013.828552 56.678951,1014.080811 52.444443,1014.363037 
	C51.873245,1014.172546 51.766907,1013.952087 51.854553,1013.420044 
	C55.764133,1012.710754 59.479733,1012.313232 63.628403,1012.002075 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M407.513367,507.628021 
	C406.650604,504.543945 406.012634,501.137848 405.421387,497.344940 
	C410.197296,499.535980 407.299164,503.787018 407.513367,507.628021 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M522.465271,473.643311 
	C524.720825,476.182648 522.944275,478.707947 522.986328,481.557800 
	C522.770508,482.269440 522.488342,482.483490 521.859558,482.609222 
	C521.410706,482.547882 521.237671,482.485321 520.878174,482.219330 
	C520.793152,479.624969 520.894592,477.234039 521.046997,474.395813 
	C521.397400,473.639038 521.762451,473.487366 522.465271,473.643311 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M454.719482,271.628418 
	C456.622009,272.291260 457.994843,273.053192 459.471344,274.791779 
	C456.183228,275.440338 453.989258,274.481384 451.994812,272.780823 
	C451.931183,272.726562 451.982147,272.442688 452.067230,272.335022 
	C452.158447,272.219513 452.353241,272.185852 452.744080,271.994537 
	C453.403534,271.567108 453.871399,271.426605 454.719482,271.628418 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M166.289429,948.581177 
	C164.043503,949.869873 162.172272,951.287170 159.612381,951.148132 
	C161.721420,949.814148 162.498169,945.711670 166.289429,948.581177 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M577.096741,353.364685 
	C577.493469,352.904114 577.805420,352.858459 578.348328,352.803467 
	C579.271057,356.163940 579.320374,359.415619 577.016968,362.401031 
	C577.016968,359.538544 577.016968,356.676025 577.096741,353.364685 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M309.643677,582.876099 
	C311.748474,585.283936 311.936188,588.179443 312.985596,591.160645 
	C312.570923,591.444214 312.131470,591.322815 311.360046,591.041077 
	C309.446472,589.091919 307.960480,587.248291 307.588379,584.433472 
	C307.963989,583.353516 308.533936,582.942017 309.643677,582.876099 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M307.707214,583.940613 
	C308.337677,586.452759 310.831696,587.718323 311.024933,590.530273 
	C310.956970,591.401855 310.885895,591.923035 310.731140,592.831116 
	C308.400543,590.785461 307.214752,587.881714 306.929993,584.234314 
	C307.197174,583.815063 307.365326,583.783325 307.707214,583.940613 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M434.602051,965.013367 
	C434.963837,965.166870 434.970612,965.366699 434.969604,965.868286 
	C432.312134,968.124817 429.467529,969.594543 426.066681,969.753662 
	C428.413635,967.488708 431.337952,966.287476 434.602051,965.013367 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M567.353271,367.941864 
	C568.242554,364.831238 569.546570,361.709076 570.850525,358.586914 
	C571.238770,358.744354 571.627075,358.901794 572.015320,359.059235 
	C571.212158,362.248077 570.444275,365.450256 567.353271,367.941864 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M484.794495,976.770142 
	C485.048187,977.759155 485.070190,978.474670 485.156403,979.541809 
	C483.402466,979.812927 480.657898,980.749878 480.551880,978.027893 
	C480.458862,975.639282 482.722595,975.790833 484.794495,976.770142 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M226.005447,905.795044 
	C223.457123,905.898743 220.789642,906.252930 218.190552,904.445618 
	C217.772614,903.997498 217.599915,903.829590 217.701233,903.426270 
	C219.792542,902.817261 221.571625,902.829712 223.638702,903.794861 
	C224.773849,903.601624 225.279083,903.953430 225.786713,904.874390 
	C225.891876,905.191956 225.961365,905.595215 226.005447,905.795044 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M346.700806,380.254333 
	C345.851166,378.640472 344.792206,377.648651 342.473328,377.956451 
	C341.808960,376.903931 341.539093,375.867401 341.218384,374.635559 
	C343.138977,373.997040 343.405212,377.665924 345.678802,376.010742 
	C346.619537,375.923798 347.187592,376.091339 347.987610,376.547913 
	C348.198334,377.490967 348.114960,378.357269 348.010773,379.661621 
	C347.643372,380.126099 347.296783,380.152588 346.700806,380.254333 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M362.985901,372.691406 
	C359.319458,373.216919 357.931274,370.174988 355.966553,367.490845 
	C356.040070,367.002808 356.181580,366.848755 356.600037,366.842285 
	C358.877502,368.782990 360.878021,370.576172 362.985901,372.691406 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M402.328125,486.016266 
	C402.027435,484.239716 401.973572,482.549225 401.957275,480.436432 
	C404.750397,481.529205 405.839172,483.639557 404.066528,486.884888 
	C403.367065,486.771545 402.970978,486.436920 402.328125,486.016266 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M401.681915,659.945862 
	C403.528717,660.559448 398.874634,663.821472 403.359344,663.133850 
	C403.856964,663.057495 404.143433,663.572449 403.921844,664.090149 
	C403.076508,666.064880 401.830139,663.478882 400.718201,664.692017 
	C400.194214,665.416199 399.749695,665.624390 398.851013,665.619446 
	C398.252289,665.445129 398.030670,665.320312 397.885864,664.821899 
	C397.597473,664.372314 397.467896,664.155273 397.749268,663.672180 
	C397.763397,662.151489 398.587189,661.286194 399.850098,660.278809 
	C400.549194,659.999451 400.961975,659.944458 401.681915,659.945862 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M193.636963,961.955566 
	C192.490067,964.156860 190.627197,964.973511 188.440842,965.371216 
	C189.493057,963.271851 189.831650,960.301147 193.636963,961.955566 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M359.295349,399.182007 
	C357.883881,398.991486 356.950256,398.716187 356.501495,397.282867 
	C359.094269,397.464417 361.570892,397.637817 364.047516,397.811249 
	C364.074097,398.118317 364.100677,398.425385 364.127228,398.732422 
	C362.647278,398.896545 361.167297,399.060669 359.295349,399.182007 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M533.638000,447.963165 
	C535.722412,447.943298 537.493652,448.099609 539.714172,448.295532 
	C537.224304,450.952118 533.974915,449.218536 531.297607,450.849731 
	C530.194092,448.801392 532.472961,449.056244 533.638000,447.963165 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M452.867126,279.511841 
	C453.048462,278.982239 453.434082,278.729370 453.965271,278.158875 
	C456.325195,279.482513 458.507111,281.156708 459.654144,284.099182 
	C457.459930,282.662323 455.265686,281.225433 452.867126,279.511841 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M485.284546,275.641571 
	C485.722076,275.629120 485.763977,275.702301 485.772034,275.674194 
	C485.685822,277.530426 487.239471,279.248840 486.191895,281.565216 
	C484.149506,281.039551 483.383087,279.114594 481.975647,277.368195 
	C482.535095,275.921387 483.596130,275.586090 485.284546,275.641571 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M295.675720,995.024170 
	C296.051086,995.478394 296.017365,995.909973 295.995880,996.666504 
	C293.841583,996.475220 291.765442,998.308777 289.256134,997.360352 
	C290.786133,994.744141 293.080353,995.010132 295.675720,995.024170 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M485.010559,284.399048 
	C485.189484,283.848389 485.529724,283.583740 486.033325,283.035583 
	C487.839508,284.320068 489.482361,285.888123 491.362427,287.711304 
	C491.332581,288.111908 491.065491,288.257416 490.353668,288.300995 
	C488.329926,287.027740 486.750885,285.856384 485.010559,284.399048 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M547.049561,350.210449 
	C547.241943,346.686310 546.677551,343.150665 548.515137,339.804626 
	C549.976318,343.120514 548.485718,346.137634 548.064270,349.604950 
	C547.804321,350.139374 547.590332,350.260406 547.049561,350.210449 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M351.091553,542.305237 
	C351.877838,541.719543 352.670807,541.476013 353.755859,541.105591 
	C354.883423,542.402527 354.689880,543.923401 354.333435,545.745239 
	C352.661804,545.370422 351.473663,544.379700 351.091553,542.305237 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M378.212280,752.884888 
	C379.673340,750.833557 381.507233,748.823914 383.645874,746.646118 
	C384.104095,746.741455 384.257599,747.004883 384.293091,747.710083 
	C383.510773,749.204590 382.846436,750.257385 382.035217,751.582275 
	C381.449829,752.165649 381.011292,752.476746 380.327393,752.901489 
	C379.583069,752.985596 379.084106,752.955994 378.212280,752.884888 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M552.010620,312.277771 
	C551.080811,310.357025 550.341553,308.691223 549.523560,306.688263 
	C549.481750,306.130585 549.518738,305.910065 549.860535,305.550110 
	C550.613953,305.389954 551.053162,305.444305 551.785828,305.714081 
	C552.088623,305.853760 552.090881,305.747559 552.137085,305.722290 
	C551.032837,308.884064 553.612793,311.162018 554.277527,314.297180 
	C554.365845,314.666107 554.320618,315.143402 554.080872,315.143829 
	C553.294434,314.273773 552.747742,313.403259 552.010620,312.277771 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M107.923370,756.117188 
	C107.869118,755.359192 107.846413,754.583008 107.895485,753.419800 
	C110.068039,754.762390 113.059532,755.956543 111.547897,759.573547 
	C110.977760,759.450623 110.795517,759.369812 110.563461,759.165100 
	C109.383392,758.554749 108.897598,757.529602 108.169296,756.268372 
	C107.927711,756.031494 107.954918,756.098999 107.923370,756.117188 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M51.643562,1013.069824 
	C52.037457,1013.322144 52.026379,1013.536011 51.997440,1014.071411 
	C49.425308,1015.814514 46.331558,1014.391663 43.411980,1015.984985 
	C43.021877,1016.026062 42.843533,1015.685425 42.897919,1015.501343 
	C45.238277,1012.829285 48.634274,1014.365295 51.643562,1013.069824 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M181.740082,759.671326 
	C183.934174,761.576416 182.636154,764.770996 183.964630,767.634644 
	C183.724777,768.027649 183.504593,768.025940 182.954498,768.039185 
	C181.343796,765.491699 182.122681,762.683838 181.740082,759.671326 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M527.742920,448.149292 
	C527.919678,446.206177 524.591919,446.600159 525.870667,444.525208 
	C526.359680,443.731781 527.449707,444.056274 528.009155,444.715057 
	C528.820374,445.670288 531.776489,446.048096 528.783447,448.279053 
	C528.197205,448.450775 527.945679,448.489288 527.742920,448.149292 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M174.415619,947.994263 
	C174.082001,947.641602 173.993561,947.205078 174.171539,947.002380 
	C175.202759,945.828125 174.058441,942.486206 176.964478,943.402527 
	C179.729279,944.274414 174.942322,945.925964 176.943604,947.621887 
	C176.251205,947.956299 175.517517,947.987366 174.415619,947.994263 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M402.285706,667.113647 
	C403.082153,665.869019 404.811066,666.599121 405.640778,665.163269 
	C406.786957,666.476807 405.059296,667.081604 405.046570,668.543335 
	C405.017059,669.379333 404.993866,669.863403 404.951477,670.710571 
	C404.767761,671.228760 404.603210,671.383911 404.210144,671.789795 
	C403.981628,672.040527 403.985779,671.985352 404.013336,671.987793 
	C403.895020,672.153931 403.749146,672.317627 403.347168,672.275024 
	C403.019684,671.259094 402.948334,670.449463 402.895691,669.035889 
	C402.914398,668.431946 402.626343,668.107910 402.492859,667.930054 
	C402.359375,667.752258 402.212402,667.326538 402.285706,667.113647 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M481.661591,540.603394 
	C481.659027,543.257568 476.925446,545.992432 474.439423,544.588440 
	C473.813873,544.235229 475.026062,543.767151 475.785706,543.246887 
	C478.099304,542.952820 479.741943,541.925598 481.661591,540.603394 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M476.208405,357.917175 
	C475.849762,357.658173 475.912201,357.452881 476.088806,356.942139 
	C476.807831,356.419006 477.404327,356.046661 478.019104,356.013641 
	C479.656067,355.925598 481.300903,355.983673 483.568573,355.983673 
	C481.121033,357.971649 478.902832,358.075989 476.208405,357.917175 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M524.604248,292.166046 
	C524.934998,292.579987 524.947205,292.853668 524.993835,293.536804 
	C522.359741,293.284454 519.691223,292.622650 516.655518,291.920868 
	C518.998474,289.481720 521.610046,292.523590 524.604248,292.166046 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M442.267456,268.989258 
	C443.861328,270.041656 445.315887,268.880524 446.747192,269.170380 
	C444.583862,270.889435 444.583862,270.889435 439.858032,270.727142 
	C440.743713,270.018158 441.339752,269.541046 442.267456,268.989258 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M519.162842,342.300446 
	C519.397034,341.934357 519.634094,341.956940 520.223999,342.056763 
	C521.106018,344.401611 522.181458,346.629150 520.816284,350.325409 
	C520.099182,347.007721 519.632446,344.848450 519.162842,342.300446 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M375.634033,326.037109 
	C375.974945,326.178650 375.994690,326.420044 376.033264,327.024445 
	C374.598755,328.544617 373.145416,329.701843 371.395782,330.971527 
	C370.846588,330.736298 370.593689,330.388611 370.054596,329.881897 
	C371.616577,328.527557 373.464752,327.332275 375.634033,326.037109 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M500.244659,288.254822 
	C501.625488,285.980713 503.480469,285.879028 505.777374,287.467255 
	C505.883698,288.525848 505.236237,288.622437 504.257996,288.828125 
	C502.810181,288.852020 501.641815,288.688812 500.244659,288.254822 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M473.228882,343.250427 
	C472.967163,342.583374 472.939575,342.187286 472.864197,341.499023 
	C474.668640,341.113190 476.198090,341.788757 477.774994,342.926331 
	C476.232788,344.524445 474.846527,344.008270 473.228882,343.250427 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M378.912598,448.345337 
	C381.026733,450.766052 380.316589,452.927826 377.264191,454.296387 
	C377.580292,452.193146 378.196320,450.437164 378.912598,448.345337 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M437.596130,356.986084 
	C437.969757,357.161591 437.977875,357.343719 437.980957,357.799927 
	C436.224548,359.360504 434.306519,360.051849 431.448456,359.768890 
	C433.410248,358.055237 435.142731,357.189636 437.596130,356.986084 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M357.058868,381.332336 
	C359.080048,381.563843 360.897583,379.852020 362.707794,381.660187 
	C360.595428,383.364777 358.599548,384.066010 356.312256,381.439880 
	C356.388519,381.134369 356.557739,381.309021 357.058868,381.332336 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M455.206879,271.609863 
	C454.591583,271.854675 454.132965,271.903259 453.329834,271.912231 
	C453.148193,270.058258 451.152557,270.288666 450.265991,268.993317 
	C451.814728,268.993317 453.157135,268.993317 454.866760,269.044495 
	C455.648773,269.404846 456.063629,269.714081 456.731812,270.146667 
	C456.444672,270.651276 455.904114,271.032501 455.206879,271.609863 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M295.266998,1003.795898 
	C293.280151,1005.537415 291.471069,1005.188416 289.329102,1004.296021 
	C290.729065,1002.326599 292.639587,1003.260559 294.627625,1003.022095 
	C295.203522,1003.206665 295.369385,1003.380737 295.266998,1003.795898 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M277.122314,811.117737 
	C276.043762,812.313599 274.691437,813.359070 273.150452,814.663330 
	C270.846649,811.843567 274.850830,811.954102 275.710724,810.160217 
	C276.302765,810.363037 276.575684,810.665222 277.122314,811.117737 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M569.296875,339.501282 
	C570.029968,339.235596 570.794006,339.340454 571.796875,339.752350 
	C572.213501,340.210693 572.391357,340.362000 572.802307,340.774658 
	C573.035461,341.035980 573.004883,340.992340 572.997131,340.967041 
	C571.791443,341.503113 572.577209,342.350494 572.709473,343.518524 
	C572.443604,344.313873 572.056885,344.476379 571.323669,344.204315 
	C570.487122,342.612701 569.907410,341.242279 569.296875,339.501282 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M161.531830,627.562256 
	C162.201157,629.196716 162.593979,630.701538 162.994843,632.596558 
	C160.554077,632.681213 160.292007,630.728210 159.854462,628.520630 
	C159.806351,628.170105 159.980118,628.016235 160.065491,627.937622 
	C160.469269,627.588074 160.837494,627.446106 161.531830,627.562256 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M454.719482,262.013794 
	C456.081787,262.053223 457.053162,262.403900 456.856628,264.117096 
	C455.781586,264.294464 454.799194,264.169861 453.401825,263.719147 
	C453.475433,262.996246 453.964020,262.599457 454.719482,262.013794 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M390.840668,309.026367 
	C391.876526,307.005249 393.657745,306.106476 395.698853,305.099915 
	C396.275848,305.514191 396.521881,305.946930 396.888245,306.599365 
	C395.356079,307.601929 393.703552,308.384796 391.735962,309.300232 
	C391.248047,309.384613 391.075195,309.336456 390.840668,309.026367 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M563.906860,311.282410 
	C563.066406,309.212860 562.561157,307.366486 561.924011,305.038025 
	C564.336426,306.492950 564.270142,308.599701 564.928955,310.676392 
	C564.681824,311.197296 564.461975,311.351471 563.906860,311.282410 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M519.740845,482.342926 
	C519.989807,482.017914 520.340759,481.997284 520.516235,482.006592 
	C520.691711,482.015900 520.936646,482.015656 521.056885,481.992432 
	C522.128418,484.529510 522.942688,487.077362 520.071777,489.374512 
	C519.022461,489.274261 518.621033,488.906647 518.404907,487.882568 
	C518.561890,485.820740 518.763733,484.182800 519.740845,482.342926 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M325.776855,753.842041 
	C326.531708,753.929077 326.987488,754.008911 327.747192,754.269043 
	C328.225769,755.533997 327.424896,755.655762 326.298401,755.818115 
	C324.517059,756.215149 323.120026,756.629700 321.355743,757.036133 
	C320.867523,756.846069 320.746521,756.664062 320.868591,756.262207 
	C322.567078,755.306580 324.022430,754.570740 325.776855,753.842041 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M309.160187,758.064087 
	C310.205078,757.079102 311.597931,756.245911 313.335175,755.341553 
	C314.035248,758.725098 312.559845,759.586670 309.160187,758.064087 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M146.988586,942.902100 
	C145.785873,944.010132 144.796600,944.104919 145.409988,942.509033 
	C145.919296,941.183899 146.189926,939.025696 148.296432,939.226929 
	C149.297653,939.322571 148.918304,940.437927 148.396957,941.116699 
	C148.005539,941.626465 147.592102,942.119202 146.988586,942.902100 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M572.988892,416.050598 
	C571.645264,417.660400 569.833008,418.353210 567.591736,417.821625 
	C568.165283,415.831421 570.293274,416.306366 571.684692,415.145142 
	C572.260376,415.361481 572.499329,415.640991 572.988892,416.050598 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M422.726807,928.835693 
	C422.652313,926.861511 420.377808,927.578796 419.790436,925.862366 
	C421.660736,926.570435 424.681305,924.513184 424.146210,928.923950 
	C423.698761,929.134827 423.282043,929.068359 422.726807,928.835693 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M59.327919,927.114990 
	C59.021877,925.403442 59.034405,923.983582 59.074177,922.136230 
	C60.651321,922.975159 61.336990,924.781067 62.161060,926.893799 
	C61.370354,927.553467 60.509113,927.491882 59.327919,927.114990 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M299.204132,1003.166870 
	C299.934845,1000.019836 301.470917,1000.742615 303.175140,1002.250671 
	C304.398376,1003.333130 304.519745,1003.985107 302.296204,1003.998535 
	C301.275024,1003.235779 300.296082,1003.598083 299.204132,1003.166870 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M457.140167,1010.418274 
	C458.934387,1010.057617 460.700256,1010.139099 461.640289,1012.369141 
	C459.512878,1013.292786 458.208069,1012.411865 457.140167,1010.418274 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M470.070557,356.323822 
	C468.669159,356.708313 467.241852,356.830109 465.386871,356.906525 
	C464.630432,356.498383 464.497040,356.074127 464.772034,355.309174 
	C466.380371,354.992218 467.775421,354.954590 469.587402,354.961670 
	C470.017761,355.357941 470.031219,355.709503 470.070557,356.323822 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M434.767334,274.944031 
	C434.993347,275.302246 434.979919,275.574036 434.916626,276.251190 
	C432.904785,277.292419 430.983459,278.184357 428.728607,277.685242 
	C430.361450,276.797241 431.886627,275.967773 433.718140,274.959656 
	C434.192230,274.806519 434.360016,274.832092 434.767334,274.944031 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M301.810699,762.195068 
	C302.600616,761.195557 303.497162,760.569458 304.678894,759.924316 
	C304.653442,763.608704 304.311279,763.907776 301.810699,762.195068 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M226.040741,904.857788 
	C225.414185,904.875000 224.936508,904.558044 224.235962,904.058105 
	C223.936630,902.269714 224.239578,900.966431 226.633911,901.043274 
	C226.727539,902.205383 226.458572,903.364502 226.040741,904.857788 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M174.288757,952.521240 
	C176.966339,953.940552 174.444855,954.473389 173.877716,955.348694 
	C173.741364,955.559082 172.720856,955.555176 172.631897,955.381287 
	C171.881989,953.915100 173.279388,953.441101 174.288757,952.521240 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M110.666183,918.031494 
	C110.766357,920.025940 109.516182,921.199890 107.323036,921.899902 
	C107.306702,919.938171 108.459488,918.679077 110.666183,918.031494 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M546.496582,350.273804 
	C546.938843,350.044647 547.154907,350.049896 547.694580,350.036713 
	C547.604187,351.878632 547.226135,353.754547 545.657349,355.495087 
	C544.483154,353.466370 546.143860,352.066437 546.496582,350.273804 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M376.371460,334.008789 
	C376.037689,333.783783 376.068176,333.592377 376.049438,333.114349 
	C377.519348,332.099182 379.038483,331.370575 380.557648,330.641998 
	C379.865387,332.784424 378.345978,333.478088 376.371460,334.008789 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M139.175751,1012.729858 
	C138.365875,1015.758484 135.898697,1014.671448 133.517242,1014.894653 
	C134.000931,1013.499390 136.385925,1014.702698 136.937714,1012.324036 
	C137.649460,1012.165894 138.284439,1012.335754 139.175751,1012.729858 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M487.049988,534.946472 
	C483.922943,532.090149 487.684296,532.304077 488.923828,531.126953 
	C489.868347,532.970947 488.680603,533.926514 487.049988,534.946472 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M416.089783,286.607361 
	C414.469757,286.838013 412.997375,286.838013 411.353546,286.838013 
	C412.631073,284.893860 414.409424,284.868439 416.596130,284.950562 
	C416.735443,285.462830 416.486420,285.919769 416.089783,286.607361 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M520.086182,471.116150 
	C520.694763,469.494049 521.418945,468.116547 522.480713,466.796936 
	C522.899475,467.094147 522.980652,467.333466 523.137817,467.944092 
	C523.402710,468.716980 523.480469,469.139069 523.359741,469.898285 
	C522.921875,471.023438 522.608948,471.861023 521.371338,472.111145 
	C520.771851,471.791870 520.486816,471.576294 520.086182,471.116150 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M224.394531,956.012329 
	C224.007843,954.454285 224.986572,954.031616 226.659470,953.974731 
	C227.870361,954.134460 228.726074,954.316895 229.787827,954.756531 
	C229.993866,955.013672 230.005157,954.994629 230.014252,954.985962 
	C228.275665,955.326416 226.527954,955.675537 224.394531,956.012329 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M363.435608,376.660706 
	C361.596100,372.947327 364.795990,375.716125 365.699341,374.856873 
	C367.316162,377.824463 365.051941,376.711792 363.435608,376.660706 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M405.411591,494.706238 
	C404.768494,493.229828 404.357056,491.497192 403.997559,489.382202 
	C406.407562,490.282379 406.237091,492.304260 405.411591,494.706238 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M427.286682,271.394043 
	C428.476990,270.921844 429.293365,268.232971 431.694489,269.900208 
	C432.010712,270.153870 432.019043,270.320557 431.979736,270.732971 
	C430.482727,271.058594 429.242828,272.494202 427.286682,271.394043 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M459.360565,584.264893 
	C460.067535,584.023071 460.560699,583.979797 461.417480,583.888245 
	C461.152710,585.445862 460.398315,586.943054 458.694336,587.757812 
	C457.760468,586.330139 458.889862,585.474915 459.360565,584.264893 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M312.771912,591.919067 
	C314.213776,592.521973 314.470825,594.069519 315.214600,595.775757 
	C315.222778,596.587891 315.165497,597.075684 314.966309,597.496338 
	C314.488708,598.505005 314.120575,598.075439 313.915588,597.335876 
	C313.452850,595.666382 313.034882,593.984375 312.771912,591.919067 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M462.876434,626.155762 
	C463.104980,626.666382 462.993042,627.233032 462.900330,628.238831 
	C462.559326,629.925659 461.319153,630.389465 460.761749,629.552246 
	C459.594513,627.799194 461.591064,627.167908 462.876434,626.155762 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M572.422607,350.249054 
	C574.749695,351.912231 572.150391,353.771912 572.073853,355.726318 
	C572.073853,354.001556 572.073853,352.276794 572.422607,350.249054 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M436.764893,328.512238 
	C436.977600,328.984192 436.976257,329.200989 436.956482,329.742737 
	C435.120911,329.747345 433.574432,328.912170 432.143250,327.298523 
	C433.742371,326.642181 435.125763,327.523743 436.764893,328.512238 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M572.827026,349.517120 
	C572.771362,349.946075 572.567566,349.748932 572.426758,349.735260 
	C571.867126,348.055969 571.448364,346.390320 571.048218,344.353912 
	C571.438538,343.971497 571.810242,343.959839 572.461243,343.943054 
	C572.787903,345.654663 572.835266,347.371399 572.827026,349.517120 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M551.025879,302.231934 
	C551.157715,302.951050 551.131714,303.268677 550.939087,303.813721 
	C550.702087,304.416199 550.581543,304.801483 550.387451,305.479919 
	C550.127625,305.864777 550.002747,305.975800 549.661377,306.218964 
	C548.962708,305.465485 548.480591,304.579895 547.976318,303.384399 
	C548.743408,302.406433 549.532654,301.738312 550.639038,301.060059 
	C550.964111,301.313141 550.972046,301.576385 551.025879,302.231934 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M548.359619,433.451294 
	C549.134460,433.386383 549.922485,433.617035 550.146851,434.863770 
	C549.596436,436.173401 548.712463,436.918335 547.156250,437.113739 
	C547.314270,435.939545 547.813721,434.875641 548.359619,433.451294 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M84.946716,886.152710 
	C84.072807,887.279602 83.184456,887.965332 81.732971,887.558716 
	C82.088188,886.179565 83.236267,885.659058 84.528320,884.908569 
	C84.857262,885.108032 84.893425,885.405701 84.946716,886.152710 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M308.647247,999.063782 
	C308.789093,1000.353699 309.646759,1002.087524 307.276306,1002.810059 
	C307.186188,1001.515625 306.486450,999.848755 308.647247,999.063782 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M187.582275,948.362061 
	C188.568085,948.093262 189.931885,947.710083 190.407486,948.944214 
	C190.818405,950.010498 189.912003,950.582642 188.602600,950.877991 
	C188.074219,950.200500 187.857910,949.470276 187.582275,948.362061 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M58.616524,926.873047 
	C59.811710,926.904907 60.614079,926.986572 61.813477,927.162170 
	C62.210510,927.256104 62.260277,927.328186 62.253563,927.369263 
	C59.826427,928.312134 57.350677,928.105408 54.738560,927.834961 
	C55.687283,926.317444 57.111080,927.230225 58.616524,926.873047 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M399.713074,660.054565 
	C399.878815,661.231689 399.727142,662.463257 398.232910,663.355774 
	C397.924622,663.547241 397.861664,663.602661 397.848877,663.641479 
	C396.656738,661.804688 396.683960,660.412781 399.713074,660.054565 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M432.758423,942.842346 
	C431.533386,944.268066 430.198944,944.560364 429.058533,942.345459 
	C430.178741,942.192139 431.363861,942.370850 432.758423,942.842346 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M207.381744,965.444031 
	C209.617920,966.010010 208.619324,966.819397 207.695251,967.499634 
	C207.054794,967.971130 206.072342,968.271057 205.762680,967.346619 
	C205.629639,966.949585 206.619171,966.176392 207.381744,965.444031 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M347.327850,394.888977 
	C347.052063,393.903900 347.115326,393.029388 347.250916,391.717651 
	C348.212769,392.209473 349.102325,393.138519 350.142029,394.353027 
	C350.353821,394.859467 350.415405,395.080353 350.138031,395.242615 
	C349.088348,395.122498 348.377625,395.061005 347.327850,394.888977 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M520.992432,472.333740 
	C521.517883,471.413513 521.979004,470.819580 522.675415,470.053833 
	C523.113525,469.740631 523.316284,469.599274 523.621948,469.814026 
	C523.477112,471.182892 523.229370,472.195618 522.859619,473.500885 
	C522.371887,473.814728 522.006287,473.836029 521.369263,473.902954 
	C521.041321,473.519043 520.984619,473.089539 520.992432,472.333740 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M493.832886,282.388489 
	C496.202606,281.348846 496.288452,283.371552 497.067535,284.855225 
	C495.400513,285.095978 494.500000,283.961639 493.832886,282.388489 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M356.816162,366.702332 
	C356.705505,366.968475 356.534088,366.947113 356.130646,367.041321 
	C355.071381,366.438629 353.938782,365.979431 353.786560,364.337555 
	C353.982574,363.928192 354.189148,363.860931 354.720459,363.781799 
	C355.379395,363.970612 355.713684,364.171265 356.297791,364.521545 
	C356.616882,365.252380 356.686157,365.833588 356.816162,366.702332 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M348.255310,376.618164 
	C347.661011,376.562592 347.040314,376.500549 346.203979,376.205231 
	C346.324158,375.082825 345.343872,373.359863 347.173279,373.465576 
	C348.413635,373.537262 347.969086,374.960876 348.172668,376.250183 
	C348.240723,376.655090 348.228851,376.611694 348.255310,376.618164 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M365.589630,386.802490 
	C367.200073,386.373810 368.465790,386.135223 369.731476,385.896606 
	C368.231689,386.889557 367.122681,388.847656 365.015259,387.822571 
	C364.963226,387.797272 364.981415,387.558929 365.018829,387.435730 
	C365.066345,387.279510 365.167084,387.139496 365.589630,386.802490 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M519.632690,482.014801 
	C519.701477,483.426910 519.413208,484.835907 519.081177,486.605225 
	C518.749207,487.074860 518.460999,487.184174 517.810425,487.006226 
	C517.511902,485.403717 517.575745,484.088501 517.743347,482.390503 
	C518.323303,482.009064 518.799438,482.010376 519.632690,482.014801 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M547.935303,312.381042 
	C548.428467,311.333771 548.730591,311.691803 549.147278,312.404663 
	C549.889343,313.953064 551.117615,315.081665 550.860291,317.046173 
	C549.020447,315.922516 548.778809,314.115723 547.935303,312.381042 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M446.007996,357.375610 
	C446.775391,356.743958 447.588959,356.406311 448.734192,356.065308 
	C449.872986,356.929321 451.270050,356.081421 452.009430,357.409088 
	C450.321350,357.884583 448.655182,358.032959 446.574158,358.218445 
	C446.124207,358.060272 446.089172,357.864960 446.007996,357.375610 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M434.798523,366.055664 
	C435.127686,366.272980 435.082764,366.436188 434.996033,366.850159 
	C433.931274,368.165710 432.125885,368.524750 431.819092,367.320038 
	C431.351898,365.485565 433.381287,366.212036 434.798523,366.055664 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M445.625305,261.876526 
	C446.344238,262.027435 446.643646,262.231995 446.968811,262.710449 
	C446.924347,263.961121 446.642181,264.812805 445.323242,265.148712 
	C444.988831,265.047302 445.012146,265.021118 444.995667,265.015228 
	C444.842773,264.851837 444.706360,264.694366 444.267578,264.457825 
	C443.805664,264.428528 443.646088,264.478271 443.236145,264.542297 
	C442.750397,262.856628 443.288330,261.810364 445.625305,261.876526 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M369.181274,448.884338 
	C367.383545,447.952637 368.903259,446.813019 369.100525,445.486938 
	C369.861755,446.410309 370.373352,447.547333 369.181274,448.884338 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M539.942810,302.366425 
	C542.142456,301.205750 542.230835,303.364532 543.104126,304.684845 
	C541.392944,305.071777 540.845276,303.650574 539.942810,302.366425 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M103.928574,924.934326 
	C104.101341,923.469116 104.862152,922.497803 106.484314,921.873291 
	C106.787643,921.765442 106.994247,921.985046 107.104538,922.091370 
	C106.854996,923.520081 106.188438,924.580322 104.488327,925.107666 
	C104.177132,925.192383 104.013451,925.018372 103.928574,924.934326 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M140.635925,962.084106 
	C140.243927,963.109497 139.800491,963.842346 138.853195,963.613403 
	C138.640366,963.562012 138.360367,962.738220 138.499344,962.475037 
	C138.941498,961.637878 139.519501,960.745483 140.635925,962.084106 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M509.958588,334.685913 
	C508.705505,334.989319 507.789673,334.455017 507.399445,333.269867 
	C507.213135,332.703979 507.566620,332.333649 508.113373,332.390717 
	C509.207947,332.505005 509.654816,333.360382 509.958588,334.685913 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M532.108765,438.855927 
	C533.838623,437.413422 534.082947,438.635803 534.129761,439.896210 
	C534.148682,440.405273 534.253174,441.516815 533.342529,441.182373 
	C532.771729,440.972748 532.515808,439.905640 532.108765,438.855927 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M418.881500,968.378601 
	C417.749573,968.703552 416.843903,968.826477 415.514465,969.006897 
	C416.690765,967.480713 417.639099,966.800720 419.061707,967.355347 
	C419.166595,967.396301 419.264374,967.595154 419.266907,967.722595 
	C419.269897,967.872803 419.165558,968.025146 418.881500,968.378601 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M486.797180,535.102783 
	C487.488800,533.961670 488.292328,532.873779 489.175812,531.455078 
	C489.255798,531.124146 489.633820,531.104309 489.815277,531.050659 
	C489.562683,532.345398 491.127502,534.145142 488.677307,535.079590 
	C488.087616,535.142944 487.885162,535.252502 487.390137,535.178589 
	C487.097595,534.995178 486.909058,535.156006 486.797180,535.102783 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M525.260254,441.521942 
	C526.149841,438.965393 528.038696,440.424194 529.711670,440.567719 
	C528.304810,440.994904 526.897949,441.422089 525.260254,441.521942 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M118.048691,1017.727661 
	C116.546402,1017.815979 115.059860,1017.716370 113.304382,1017.360474 
	C113.750557,1016.269531 114.626213,1015.808716 116.141655,1015.940979 
	C116.528656,1015.945312 116.591682,1015.892822 116.589706,1015.868408 
	C116.768517,1016.123108 116.949303,1016.402283 117.565636,1016.924622 
	C118.001175,1017.167847 118.064438,1017.539734 118.048691,1017.727661 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M526.094971,450.663055 
	C525.695801,450.535767 525.528503,450.381714 525.182068,450.166260 
	C525.595642,449.174286 525.652283,447.836182 527.468140,447.827911 
	C527.791687,447.770721 528.116882,448.092804 528.282837,448.252502 
	C527.759460,449.134094 527.070129,449.855957 526.094971,450.663055 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M490.082764,288.474365 
	C490.190582,288.159546 490.472198,288.120056 491.176758,288.023499 
	C492.559631,288.124939 494.004883,288.727478 493.435944,289.484467 
	C492.416229,290.841156 491.267914,289.371796 490.082764,288.474365 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M504.285095,289.154877 
	C504.460266,288.650024 504.942078,288.284851 505.725098,287.790710 
	C506.658081,287.921234 507.289825,288.180725 508.099670,288.737549 
	C507.119293,290.118103 505.883850,290.108490 504.285095,289.154877 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M119.245041,872.856201 
	C118.717522,872.629761 118.487633,872.314758 118.027176,871.809448 
	C118.574387,870.491821 119.729950,870.002563 121.326759,869.672729 
	C121.810722,869.670532 121.974922,869.714111 122.203354,870.004211 
	C121.359268,871.089722 120.450966,871.928711 119.245041,872.856201 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M298.569824,1002.953735 
	C299.834259,1003.108704 300.706787,1003.287598 301.786072,1003.731384 
	C299.953064,1004.004456 297.913330,1004.012756 295.436157,1004.028992 
	C295.003387,1003.869446 295.008026,1003.701843 295.025146,1003.283386 
	C296.084412,1003.014221 297.131165,1002.995972 298.569824,1002.953735 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M412.320984,300.976471 
	C411.911041,300.860992 411.907654,300.502808 411.900513,300.323883 
	C413.949097,300.144958 416.004852,300.144958 418.816895,300.144958 
	C416.385925,301.449036 414.516479,300.944580 412.320984,300.976471 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M430.227173,428.411835 
	C430.813049,427.789124 431.548615,427.462769 432.548981,426.971802 
	C433.191254,427.854156 434.422607,428.867401 432.646912,430.049194 
	C432.261536,428.844421 431.064331,429.135712 430.227173,428.411835 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M429.146912,330.259216 
	C430.447479,330.108429 431.470978,330.608948 431.580109,331.978363 
	C431.595856,332.175781 431.225952,332.587189 431.033173,332.588013 
	C429.841980,332.593231 429.423248,331.654266 429.146912,330.259216 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M352.432312,370.949158 
	C352.577728,371.470337 352.353210,371.955353 352.040161,372.705383 
	C351.489685,373.247650 351.027740,373.524872 350.305634,373.879578 
	C349.807617,372.339355 349.796906,370.872070 352.432312,370.949158 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M368.989624,949.243652 
	C370.293854,948.165527 371.740082,947.881714 373.648315,947.978027 
	C372.883453,949.350342 371.154083,949.356201 369.322174,949.923950 
	C368.966522,949.913696 368.988281,949.467163 368.989624,949.243652 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M319.046631,606.021301 
	C319.443634,606.674194 319.604553,607.459412 319.873962,608.634155 
	C319.982483,609.023743 319.999298,609.001465 320.008911,608.991333 
	C319.836884,609.167480 319.655243,609.353882 319.197449,609.264343 
	C317.884308,608.082581 317.791412,607.139832 319.046631,606.021301 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M205.972000,693.010925 
	C206.554321,693.567200 206.780029,694.159363 207.003021,695.091064 
	C206.249008,695.329712 205.497742,695.228638 204.371460,695.068726 
	C204.098816,693.994812 204.478119,693.208252 205.972000,693.010925 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M138.663086,886.925903 
	C138.916321,888.432434 138.282242,889.573181 136.293854,889.962891 
	C136.508530,888.790710 136.941772,887.502319 138.663086,886.925903 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M183.187439,707.364990 
	C183.929672,705.842773 184.911179,705.559204 185.950592,707.474121 
	C185.157806,707.715210 184.295425,707.648499 183.187439,707.364990 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M427.014282,326.350830 
	C428.348236,326.628326 429.012177,327.727325 429.245178,329.434998 
	C429.308594,329.751923 429.064606,329.945984 428.944427,330.048218 
	C427.658508,329.373230 426.961884,328.304504 427.014282,326.350830 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M452.820312,263.114380 
	C452.986877,263.393036 453.138947,263.623016 453.130798,263.683044 
	C453.010132,264.054810 452.897644,264.366577 452.417786,265.013306 
	C451.852264,265.408569 451.654083,265.468872 451.203094,265.348480 
	C451.012878,264.021332 450.178101,262.219482 452.820312,263.114380 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M490.810791,975.759460 
	C490.435883,976.864441 489.574310,976.968201 488.321045,976.864990 
	C488.285980,975.207642 489.106049,974.661682 490.810791,975.759460 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M445.122284,265.320435 
	C445.472076,264.438843 445.955322,263.830353 446.716553,263.103119 
	C448.101135,263.710663 447.669250,264.584717 447.114075,265.726715 
	C446.415863,265.860626 445.835785,265.727112 445.122284,265.320435 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M326.130188,756.091797 
	C326.469055,755.497559 327.024048,755.194519 327.815063,754.670410 
	C328.051086,754.449280 328.423401,754.348694 328.611755,754.389954 
	C328.871124,756.199341 328.546478,757.470093 326.130188,756.091797 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M563.631592,311.457428 
	C563.793335,311.055908 564.015015,311.052643 564.569092,311.046265 
	C565.208923,312.799194 565.289062,314.542450 564.715271,316.490509 
	C563.419922,314.965118 564.150024,313.286133 563.631592,311.457428 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M350.172028,394.777710 
	C351.530914,394.758789 352.329559,395.478790 352.925018,396.544189 
	C351.691376,397.180328 350.770203,396.714172 349.874390,395.507263 
	C349.799072,395.183990 350.051819,394.916840 350.172028,394.777710 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M451.095154,999.213318 
	C452.195160,998.969910 453.099854,999.484863 453.940613,1000.671509 
	C452.902740,1000.934753 451.567444,1001.219604 451.095154,999.213318 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M468.697296,383.800293 
	C468.875671,384.551361 468.774475,385.512939 468.428589,386.735168 
	C467.990204,387.122223 467.796539,387.248627 467.308136,387.192108 
	C466.972534,385.771332 467.627930,384.859589 468.697296,383.800293 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M525.627441,454.981873 
	C525.776062,455.832672 525.565308,456.650299 525.149475,457.719666 
	C524.243652,457.398163 523.542847,456.824982 522.681274,455.932068 
	C523.436340,455.391144 524.352234,455.169922 525.627441,454.981873 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M107.730011,756.396118 
	C109.256187,756.284485 109.740616,757.348450 110.364616,758.734985 
	C108.881340,759.114258 108.031258,758.165527 107.730011,756.396118 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M230.136124,957.780029 
	C229.038742,958.209717 227.935013,959.466431 227.468109,958.006104 
	C227.172226,957.080811 228.490479,957.054871 229.601852,956.971069 
	C230.081558,957.148987 230.240433,957.335938 230.136124,957.780029 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M83.125923,953.727051 
	C82.469048,954.067688 81.671783,954.130432 80.481003,954.148682 
	C80.087494,954.104187 80.055473,954.067261 80.041473,954.047485 
	C79.635818,953.656250 79.476448,953.203125 79.756752,952.351562 
	C80.095978,951.911011 80.227692,951.787231 80.582123,951.505615 
	C81.531746,952.048218 82.258644,952.748718 83.125923,953.727051 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M184.249435,949.028198 
	C183.931442,948.197571 183.431000,947.091492 184.440674,946.439697 
	C185.088394,946.021545 185.640518,946.521545 185.863007,947.587708 
	C185.412964,948.255676 184.960648,948.585022 184.249435,949.028198 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M484.796722,365.751160 
	C483.527252,365.953217 482.398071,366.545410 481.503876,365.404022 
	C482.743866,364.816040 483.913544,364.542084 484.796722,365.751160 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M461.037781,311.299561 
	C461.810303,311.062927 462.470581,311.347504 462.654053,312.256836 
	C462.671204,312.341949 462.472382,312.553894 462.355713,312.569275 
	C461.602448,312.668579 461.322174,312.144501 461.037781,311.299561 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M421.654877,747.804077 
	C421.959076,748.034668 421.862427,748.516785 421.919891,748.755859 
	C421.525391,749.352417 421.073425,749.709900 420.319397,750.136597 
	C420.009399,749.711121 420.001434,749.216492 420.006348,748.351318 
	C420.019226,747.980896 419.996063,748.004089 419.984741,748.015381 
	C420.353363,747.635132 420.812531,747.484314 421.654877,747.804077 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M132.168747,805.317932 
	C132.376984,804.380371 132.867035,803.981934 133.845917,804.736816 
	C133.616791,805.647827 133.117355,806.007324 132.168747,805.317932 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M145.990631,801.008423 
	C146.598343,801.106506 147.296722,801.110168 147.455215,801.891968 
	C147.487869,802.053101 147.140335,802.291260 146.968033,802.493958 
	C146.678864,802.173767 146.389709,801.853516 146.058411,801.257568 
	C146.016251,800.981812 145.999680,801.000000 145.990631,801.008423 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M537.030884,308.343109 
	C536.098877,307.970337 534.678284,307.526459 535.341064,306.488831 
	C535.931946,305.563690 536.642090,306.773895 537.381226,307.541595 
	C537.547852,307.836792 537.218872,308.191162 537.030884,308.343109 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M543.744141,306.302490 
	C545.460693,306.093109 545.815674,307.343964 546.177124,308.730713 
	C544.653320,308.764679 544.160339,307.621552 543.744141,306.302490 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M194.786743,829.914673 
	C194.260910,830.152710 193.787018,830.047913 193.122971,829.793762 
	C192.942520,829.370056 192.952209,829.095764 192.980286,828.411865 
	C193.963013,828.114014 194.784714,828.392883 194.786743,829.914673 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M320.822357,756.058899 
	C321.111755,756.042419 321.002014,756.529175 320.995239,756.778564 
	C320.576477,757.586975 319.977478,758.049377 319.552277,757.259888 
	C319.158722,756.529236 319.879211,756.213867 320.822357,756.058899 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M195.584473,831.963989 
	C195.143372,831.651611 194.974091,831.268555 194.778290,830.576050 
	C195.300339,830.351746 196.038193,830.248718 196.353638,830.565796 
	C196.838608,831.053589 196.447983,831.598572 195.584473,831.963989 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M176.072174,856.206665 
	C177.198669,857.010193 176.784271,857.570801 175.623962,858.043701 
	C175.505051,857.494751 175.632553,856.897095 176.072174,856.206665 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M441.293945,276.404449 
	C442.230560,276.249023 443.441742,276.334564 444.932098,276.659790 
	C443.997009,276.814758 442.782806,276.730072 441.293945,276.404449 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M443.715698,279.793915 
	C443.270660,279.549713 443.208313,279.349030 443.112122,279.003174 
	C443.820770,278.474243 444.715790,277.643890 445.245026,278.932220 
	C445.562103,279.704071 444.633881,279.715179 443.715698,279.793915 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M249.396088,938.962036 
	C249.053848,938.825500 249.015244,938.639465 248.921753,938.173889 
	C248.884323,936.949585 249.455032,936.607239 250.633514,936.761963 
	C250.959793,936.952637 251.022156,937.019470 251.054565,937.052856 
	C250.919739,937.919189 250.641449,938.667786 249.396088,938.962036 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M185.385010,966.976501 
	C185.772583,966.669250 186.142960,966.618896 186.513351,966.568604 
	C186.498474,966.828064 186.483612,967.087463 186.468735,967.346924 
	C186.101761,967.309143 185.734787,967.271301 185.385010,966.976501 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M476.070312,370.476074 
	C475.688385,370.850494 475.255188,370.930695 474.498291,371.072083 
	C474.142029,369.561127 474.416718,368.584534 476.070312,370.476074 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M343.386536,1007.461121 
	C342.582764,1007.688599 342.290680,1007.408203 342.413757,1006.783630 
	C342.439240,1006.654114 342.623322,1006.479797 342.754517,1006.460022 
	C343.383606,1006.365051 343.651031,1006.668518 343.386536,1007.461121 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M437.076599,285.897705 
	C436.851868,285.477844 436.943787,285.067596 436.963074,284.350098 
	C437.430176,284.271942 438.280396,284.372040 438.440979,284.758636 
	C438.721588,285.434143 438.057861,285.792297 437.076599,285.897705 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M563.079468,399.541931 
	C562.821289,399.846466 562.501221,399.843475 561.702026,399.874817 
	C561.216614,399.312317 560.989380,398.332703 561.242981,398.186340 
	C562.227600,397.618134 562.566772,398.612488 563.079468,399.541931 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M363.211823,356.386780 
	C363.532990,355.898865 364.000000,355.618225 364.750977,355.401550 
	C364.871277,356.429413 364.505096,357.092285 363.211823,356.386780 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M140.622375,883.719055 
	C140.995178,884.171692 141.022583,884.693359 140.998352,885.602295 
	C140.508347,886.001526 140.069962,886.013550 139.301849,886.025879 
	C138.970337,885.025513 139.233704,884.179443 140.622375,883.719055 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M453.918030,676.097656 
	C454.786438,676.383545 454.909332,676.997009 454.621582,677.918457 
	C453.619263,677.789734 452.943939,677.348938 453.918030,676.097656 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M142.195847,631.263184 
	C143.179916,631.212585 144.163040,631.422852 143.106964,632.902588 
	C142.629135,632.552246 142.390076,632.051758 142.195847,631.263184 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M355.626495,507.256165 
	C355.846375,508.410858 355.829651,509.489655 355.702423,510.968842 
	C355.318817,510.193420 355.045685,509.017578 354.835052,507.477478 
	C354.897522,507.113159 355.389893,507.180267 355.626495,507.256165 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M229.909698,905.838806 
	C229.480331,906.074219 229.047440,906.005981 228.291138,905.872192 
	C228.123245,905.176086 228.239960,904.403198 229.081207,904.509094 
	C229.394318,904.548584 229.633377,905.175842 229.909698,905.838806 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M407.034698,533.362000 
	C407.834290,533.007263 408.586090,533.156250 408.863647,534.449707 
	C408.497803,534.853271 408.082184,534.958984 407.346313,535.103271 
	C407.046112,534.663025 407.066162,534.184143 407.034698,533.362000 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M300.036072,997.335083 
	C300.439758,997.015930 300.888245,996.986389 301.672058,996.997009 
	C301.909058,997.680969 301.853394,998.450867 301.045502,998.494263 
	C300.740417,998.510681 300.403351,997.932129 300.036072,997.335083 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M120.193939,1014.339600 
	C120.756325,1014.077454 121.506104,1014.037964 122.617599,1014.108521 
	C122.206795,1015.039612 121.338501,1015.136780 120.193939,1014.339600 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M524.885986,1020.281616 
	C524.783081,1020.720215 524.589355,1020.763123 524.254639,1020.731445 
	C523.755676,1020.319092 522.631287,1020.308167 523.074707,1019.576477 
	C523.660400,1018.610107 524.301819,1019.389221 524.885986,1020.281616 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M578.561401,375.034241 
	C578.892761,375.120453 578.924622,375.326019 578.967651,375.843536 
	C578.620605,376.926758 577.928345,377.096558 576.813721,377.081482 
	C577.055298,376.388428 577.658630,375.770996 578.561401,375.034241 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M129.900452,806.853577 
	C129.855042,807.226440 129.428925,807.104370 129.213089,807.054016 
	C128.597504,806.809326 128.254715,806.543213 128.006363,805.577515 
	C128.469650,804.961365 128.903992,804.962341 129.663727,804.972595 
	C129.974716,805.481506 129.960281,805.981140 129.900452,806.853577 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M532.109253,304.277283 
	C532.906738,303.901947 533.680115,304.033813 533.942932,305.028473 
	C533.972778,305.141418 533.805786,305.306366 533.730042,305.447205 
	C533.213318,305.164368 532.696594,304.881531 532.109253,304.277283 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M409.903809,293.879181 
	C410.492096,292.891144 411.779968,293.312775 413.328491,293.580780 
	C412.569550,293.854431 411.502014,293.900391 409.903809,293.879181 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M365.734863,949.859253 
	C365.239166,949.763245 364.976929,949.621704 364.714722,949.480103 
	C364.978790,949.331970 365.248260,949.055542 365.505768,949.066284 
	C365.872742,949.081482 366.625458,949.073547 365.734863,949.859253 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M439.071350,367.522705 
	C439.753052,367.202179 440.536346,367.258911 441.319641,367.315674 
	C440.902618,367.693909 440.485596,368.072174 439.775696,368.533875 
	C439.379547,368.378204 439.276276,368.139069 439.071350,367.522705 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M460.332092,270.526611 
	C461.024200,270.286835 462.026276,270.267212 463.348938,270.454102 
	C462.660339,270.689331 461.651184,270.718048 460.332092,270.526611 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M227.564911,906.147461 
	C227.336960,906.721741 226.760178,907.020569 226.023376,906.213867 
	C226.413193,905.999451 226.832352,906.049744 227.564911,906.147461 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M469.636597,381.326904 
	C469.721863,381.712036 469.567200,382.255066 469.179840,382.983063 
	C469.096985,382.606964 469.246826,382.045868 469.636597,381.326904 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M465.642761,390.048218 
	C466.320984,390.670349 466.066711,391.248444 465.271606,391.889465 
	C465.074860,391.376953 465.194763,390.754303 465.642761,390.048218 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M581.581299,390.820618 
	C581.140808,391.069611 580.819092,391.852295 580.115173,391.255188 
	C580.372253,391.104858 580.629333,390.954559 581.195190,390.770325 
	C581.503845,390.736450 581.547058,390.801727 581.581299,390.820618 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M142.956512,882.612366 
	C142.590805,882.988953 142.126068,882.993835 141.313965,883.036682 
	C140.867767,882.839111 140.768951,882.603638 140.477859,882.036987 
	C140.448837,881.744690 140.612106,881.783630 140.763580,881.571167 
	C141.453705,881.626648 142.155609,881.933655 142.956512,882.612366 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M470.244873,1011.595276 
	C470.005798,1011.578796 469.877472,1011.455627 469.749146,1011.332458 
	C469.951324,1011.384521 470.153473,1011.436523 470.244873,1011.595276 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M457.030182,1010.099365 
	C456.572754,1009.981567 456.123871,1009.808960 455.674988,1009.636353 
	C456.044830,1008.937744 456.436279,1009.314758 456.986450,1009.815979 
	C457.146759,1010.018738 457.038757,1010.044556 457.030182,1010.099365 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M466.711517,388.095703 
	C466.873779,388.598419 466.754028,389.241089 466.295593,389.936096 
	C466.114410,389.404175 466.271973,388.819916 466.711517,388.095703 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M352.762878,1012.010742 
	C352.657471,1012.247620 352.312500,1012.492798 351.967529,1012.737915 
	C351.882141,1012.615845 351.796783,1012.493774 351.711395,1012.371704 
	C351.982025,1012.254150 352.252686,1012.136597 352.762878,1012.010742 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M363.020569,1012.223755 
	C363.327057,1012.094604 363.577637,1012.272827 363.887085,1012.727417 
	C363.153961,1013.845947 363.135101,1013.048462 363.020569,1012.223755 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M135.720032,890.123657 
	C135.763855,890.540161 135.553421,891.131836 135.039719,891.857544 
	C134.979538,891.427368 135.222656,890.863037 135.720032,890.123657 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M566.239380,369.837463 
	C566.112305,369.397247 566.279053,368.840973 566.692200,368.119049 
	C566.938599,367.953400 567.011841,368.013245 567.048462,368.046387 
	C566.901123,368.626862 566.717163,369.174133 566.239380,369.837463 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M478.000366,372.673828 
	C477.613068,372.609222 477.187683,372.236877 476.697693,371.574585 
	C477.076111,371.645142 477.519196,372.005615 478.000366,372.673828 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M141.189575,958.985474 
	C141.380096,958.857849 141.569168,958.917725 141.758240,958.977600 
	C141.568192,959.042725 141.378159,959.107788 141.189575,958.985474 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M87.744141,957.893677 
	C87.946075,958.568970 87.894386,959.244263 86.770706,959.280151 
	C86.811417,958.710205 87.144081,958.297668 87.744141,957.893677 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M143.284821,947.870972 
	C143.162140,947.435120 143.293579,946.845276 143.716019,946.130188 
	C143.850983,946.575623 143.694962,947.146301 143.284821,947.870972 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M230.047211,958.206116 
	C229.888443,957.858521 229.903961,957.679688 229.921082,957.231445 
	C230.613815,957.307861 231.688156,957.572693 230.047211,958.206116 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M536.014893,323.993530 
	C535.783325,323.706207 535.531128,323.434967 535.295837,323.149780 
	C535.290833,323.143677 535.480347,322.977020 535.579102,322.885254 
	C535.696045,323.127991 535.812988,323.370728 535.947021,323.828064 
	C535.964111,324.042664 535.996277,324.007996 536.014893,323.993530 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M426.857971,326.127991 
	C426.429810,325.764282 426.122955,325.290771 425.985352,324.322906 
	C426.466858,324.298279 426.779083,324.768005 427.157654,325.519409 
	C427.223999,325.801025 426.979248,326.018188 426.857971,326.127991 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M185.041138,975.758423 
	C184.923401,975.585205 184.981140,975.409180 185.038879,975.233215 
	C185.098114,975.407349 185.157364,975.581482 185.041138,975.758423 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M450.945190,265.392761 
	C451.133575,265.198486 451.316803,265.229248 451.775238,265.304138 
	C451.919678,265.825317 452.183929,266.634674 451.039429,266.222656 
	C450.895996,266.065674 450.940094,265.617737 450.945190,265.392761 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M486.629883,536.043335 
	C487.769348,536.723511 487.031250,537.286682 486.341370,537.949097 
	C484.901428,537.188660 485.954895,536.725891 486.629883,536.043335 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M484.722473,538.691284 
	C484.831696,540.064636 484.001648,540.460876 482.747803,540.358154 
	C483.094086,539.465332 483.747498,538.939514 484.722473,538.691284 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M546.714722,310.275940 
	C547.917358,310.029602 548.179138,310.822937 548.268799,311.771851 
	C547.063232,311.981720 546.824036,311.221893 546.714722,310.275940 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M540.677551,310.639862 
	C540.731873,311.055023 540.601807,311.306763 540.471741,311.558533 
	C540.347839,311.450684 540.101868,311.306366 540.121277,311.241364 
	C540.201416,310.973297 540.362061,310.729309 540.677551,310.639862 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M359.149963,549.026123 
	C359.493774,549.236023 359.803406,549.780273 360.092224,550.648804 
	C359.752808,550.435547 359.434296,549.897949 359.149963,549.026123 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M422.848541,473.068359 
	C422.728943,473.150665 422.491913,473.324707 422.254883,473.498718 
	C422.413635,473.385864 422.572388,473.272980 422.848541,473.068359 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M318.931885,609.328979 
	C319.103943,608.957153 319.286621,608.925842 319.743896,608.937805 
	C319.850159,609.592163 319.681824,610.203186 319.191132,610.921753 
	C318.893341,610.576050 318.917908,610.122803 318.931885,609.328979 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M422.312927,285.137085 
	C422.436340,284.599365 422.905914,284.170410 423.671570,283.900696 
	C424.170624,285.160492 423.330902,285.110535 422.312927,285.137085 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M385.956787,578.050537 
	C386.213867,577.411011 386.663086,577.053833 387.382263,576.593933 
	C387.652191,576.491211 387.914795,576.899231 388.040741,577.106628 
	C388.120392,577.790710 387.891235,578.151489 387.143677,578.455933 
	C386.587799,578.454285 386.368347,578.393616 385.956787,578.050537 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M453.986694,671.998413 
	C453.952698,672.438232 453.941803,672.878723 453.886902,673.646301 
	C453.567444,673.516418 453.291992,673.059326 452.981567,672.327759 
	C452.946594,672.053223 453.018341,671.983398 453.054443,671.948730 
	C453.264954,671.785950 453.439331,671.657898 453.811157,671.787354 
	C454.008606,672.044861 454.009796,671.999023 453.986694,671.998413 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M385.364624,580.127441 
	C385.027893,579.841797 385.009399,579.606323 384.970459,579.015991 
	C384.986450,578.359863 385.131439,578.125732 385.574829,577.863464 
	C385.909241,577.910400 386.053894,578.052612 386.415833,578.407898 
	C386.593262,579.308838 386.302704,579.843750 385.364624,580.127441 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M544.343933,315.242554 
	C544.357605,315.003632 544.477478,314.876007 544.597290,314.748352 
	C544.548279,314.950165 544.499268,315.151978 544.343933,315.242554 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M504.997345,315.965515 
	C505.492065,316.074646 506.259277,315.792358 506.237396,316.718872 
	C505.850708,316.660339 505.463989,316.601807 504.981323,316.278290 
	C504.885315,316.013306 504.983551,316.012634 504.997345,315.965515 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M554.234558,314.785522 
	C554.912109,315.299255 555.382385,315.942230 554.635193,316.743103 
	C554.390381,316.423523 554.145630,316.103943 553.870972,315.464294 
	C553.841125,315.144257 554.103271,314.904938 554.234558,314.785522 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M447.704010,502.924255 
	C448.025055,502.979065 448.013947,503.466492 447.984161,503.708740 
	C447.510529,504.080353 447.066681,504.209686 446.305634,504.196289 
	C446.453278,503.658875 446.918121,503.264160 447.704010,502.924255 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M511.189148,316.769409 
	C511.746582,316.887878 512.510681,316.884186 512.295654,317.674896 
	C512.274475,317.752899 511.561920,317.642914 510.983093,317.431000 
	C510.795929,317.241821 511.059906,316.928375 511.189148,316.769409 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M560.481201,396.578857 
	C560.472778,396.606903 560.489685,396.550842 560.481201,396.578857 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M473.903442,371.104309 
	C474.099274,371.212799 474.119965,371.381683 474.029846,371.780640 
	C473.781281,371.825775 473.624207,371.650757 473.520142,371.448486 
	C473.496216,371.401917 473.654083,371.261810 473.903442,371.104309 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M157.563812,952.460815 
	C157.599579,952.515015 157.528061,952.406616 157.563812,952.460815 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M464.653870,391.933655 
	C464.728455,392.324615 464.458893,392.693085 463.825684,393.021759 
	C463.744568,392.625031 464.027100,392.268097 464.653870,391.933655 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M457.465027,589.422974 
	C457.527466,589.377991 457.402557,589.467957 457.465027,589.422974 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M143.565750,954.476562 
	C143.603928,954.539307 143.527573,954.413757 143.565750,954.476562 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M354.001831,1010.998779 
	C353.900940,1011.320435 353.712921,1011.581970 353.221069,1011.892273 
	C353.002441,1012.002441 353.000000,1012.000000 352.998840,1011.998779 
	C353.098541,1011.673279 353.285858,1011.410706 353.780396,1011.102905 
	C354.001221,1010.996033 354.000000,1011.000000 354.001831,1010.998779 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M135.944824,953.653687 
	C135.778732,953.715637 135.624329,953.556030 135.506927,953.372681 
	C135.489944,953.346191 135.651047,953.205750 135.895599,953.045593 
	C136.061462,952.973145 135.968384,953.424500 135.944824,953.653687 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M142.000473,1013.000488 
	C142.087418,1012.964539 142.173904,1012.927979 142.129578,1012.945557 
	C141.998779,1012.999634 142.000000,1013.000000 142.000473,1013.000488 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M91.481621,936.454285 
	C91.530838,936.427917 91.432404,936.480652 91.481621,936.454285 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M445.098877,505.318787 
	C444.501678,505.845673 444.182648,505.887665 444.539978,505.073181 
	C444.867157,505.024109 445.038849,505.053345 445.098877,505.318787 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M143.997696,945.997314 
	C144.113434,945.781006 144.231583,945.567444 144.349731,945.353882 
	C144.359406,945.541016 144.369080,945.728210 144.192871,945.960083 
	C144.006989,946.004883 144.000092,946.000000 143.997696,945.997314 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M101.011147,939.990479 
	C100.870941,939.828247 100.721245,939.674133 100.571548,939.520081 
	C100.680786,939.571167 100.790024,939.622253 100.942657,939.845398 
	C100.986069,940.017456 101.001656,939.998718 101.011147,939.990479 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M142.991882,947.987427 
	C142.887253,948.009277 142.793839,948.045105 142.865555,948.052917 
	C143.030685,948.024902 143.003098,948.001465 142.991882,947.987427 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M566.012634,370.017609 
	C565.890564,370.064453 565.815369,371.058258 565.773682,370.012085 
	C565.945618,369.953552 565.991760,369.994781 566.012634,370.017609 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M94.014862,935.020386 
	C93.901642,934.992310 93.879639,935.904907 93.807297,935.023315 
	C93.954567,934.962891 93.996475,934.999512 94.014862,935.020386 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M327.003357,602.004272 
	C327.093628,601.971252 327.180481,601.933838 327.129242,601.944824 
	C326.991150,601.993286 327.000000,602.000000 327.003357,602.004272 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M355.404327,378.875061 
	C355.298309,378.637573 355.367950,378.307495 355.704163,378.042450 
	C355.928070,378.383209 355.797852,378.608154 355.404327,378.875061 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M444.090363,264.544250 
	C444.294556,264.387848 444.623901,264.396912 444.966217,264.707642 
	C444.691498,264.993896 444.436951,264.894012 444.090363,264.544250 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M496.170105,995.186462 
	C496.183136,994.773010 496.428009,994.264404 496.901794,995.195007 
	C496.767090,995.370667 496.597839,995.313660 496.170105,995.186462 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M487.000366,535.241333 
	C487.296234,535.002747 487.494904,535.010376 487.991791,535.025696 
	C488.068451,535.462036 487.846863,535.890747 487.286621,536.167236 
	C486.933044,535.839050 486.918091,535.663269 487.000366,535.241333 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M357.250244,381.107300 
	C357.186981,381.188080 356.983246,381.195160 356.499420,381.080994 
	C356.523651,380.917572 356.820435,380.942200 357.250244,381.107300 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M485.579407,537.792236 
	C485.848877,538.311890 485.722076,538.653564 485.276489,539.013916 
	C484.525513,538.479187 484.606567,538.007324 485.579407,537.792236 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M394.007812,569.016602 
	C394.105743,569.000916 394.189545,568.967041 394.116211,568.950439 
	C393.959076,568.967834 393.993683,568.998413 394.007812,569.016602 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M445.023987,504.289368 
	C445.127686,504.051544 445.590302,504.014130 445.822327,504.011871 
	C445.905487,504.407532 445.756592,504.805420 445.297424,505.379150 
	C444.987213,505.554962 444.960968,505.213104 444.828247,505.104004 
	C444.770416,504.838989 444.845367,504.683105 445.023987,504.289368 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M564.533203,372.529602 
	C564.467590,372.572754 564.598877,372.486450 564.533203,372.529602 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M344.998535,1008.997925 
	C344.909424,1009.033264 344.821838,1009.070618 344.869019,1009.055298 
	C345.003784,1009.002686 345.000000,1009.000000 344.998535,1008.997925 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M142.552490,956.568237 
	C142.480026,956.619812 142.459641,956.416565 142.459641,956.416565 
	C142.459641,956.416565 142.624954,956.516602 142.552490,956.568237 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M201.551666,969.570312 
	C201.472458,969.619751 201.441650,969.419250 201.441650,969.419250 
	C201.441650,969.419250 201.630859,969.520813 201.551666,969.570312 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M466.969940,387.255676 
	C467.207672,386.990997 467.401947,386.972870 467.890015,386.975220 
	C467.977295,387.339325 467.770813,387.682861 467.260071,388.014160 
	C466.946045,387.835358 466.936279,387.668793 466.969940,387.255676 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M203.447205,968.428467 
	C203.522079,968.381775 203.550430,968.571594 203.550430,968.571594 
	C203.550430,968.571594 203.372330,968.475159 203.447205,968.428467 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M349.412720,398.564026 
	C349.348755,398.472260 349.593414,398.432098 349.593414,398.432098 
	C349.593414,398.432098 349.476654,398.655792 349.412720,398.564026 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M565.351685,330.406311 
	C565.583618,330.386810 565.665833,330.481750 565.748047,330.576660 
	C565.565979,330.558014 565.383972,330.539368 565.351685,330.406311 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M382.504120,330.498596 
	C382.509796,330.516846 382.498444,330.480377 382.504120,330.498596 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M172.948547,840.937561 
	C173.062271,840.828674 173.248245,840.002930 173.230133,840.990540 
	C173.089127,841.074707 172.992920,840.985779 172.948547,840.937561 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M538.088379,308.716492 
	C538.511658,308.923309 538.687012,309.180176 538.862427,309.437012 
	C538.592285,309.500061 538.322083,309.563141 537.891968,309.443298 
	C537.768127,309.095764 537.804321,308.931152 538.088379,308.716492 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M545.925415,309.361328 
	C546.317261,309.106628 546.689697,309.218231 547.035522,309.690216 
	C546.525208,310.339142 546.151001,310.253967 545.925415,309.361328 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M461.019775,310.989777 
	C460.755310,310.804962 460.472382,310.634705 460.079803,310.253357 
	C460.265961,310.201324 460.561798,310.360382 460.914429,310.779968 
	C460.971283,311.040497 461.001343,311.004333 461.019775,310.989777 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M398.992828,449.754883 
	C398.803467,449.822235 398.515259,449.629364 398.115356,449.199158 
	C398.300415,449.139465 398.597198,449.317078 398.992828,449.754883 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M318.998474,752.875916 
	C318.992035,752.676697 319.232544,752.446838 319.728607,752.212524 
	C319.822815,752.518921 319.576569,752.731323 318.998474,752.875916 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M97.837265,752.802979 
	C97.893936,753.203979 97.759354,753.711792 97.110733,753.117554 
	C97.200294,752.860718 97.380051,752.792297 97.837265,752.802979 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M431.994995,327.003906 
	C431.789001,326.873108 431.589874,326.736481 431.390717,326.599823 
	C431.579193,326.601196 431.767700,326.602539 431.985870,326.793152 
	C432.015564,326.982452 432.001831,326.998047 431.994995,327.003906 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M398.093964,448.701416 
	C397.865723,449.003632 397.690918,449.030121 397.250916,449.055420 
	C396.985718,449.054230 396.652161,448.697998 396.710266,448.460999 
	C396.768341,448.224030 397.098541,447.900818 397.270264,447.741608 
	C397.677124,447.863495 397.912262,448.144592 398.093964,448.701416 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M389.515381,448.070343 
	C389.672211,448.119690 389.729950,448.305054 389.766785,448.780884 
	C389.635986,448.783020 389.526123,448.494659 389.515381,448.070343 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M459.106689,309.234253 
	C459.261963,309.205383 459.552826,309.371643 459.906921,309.790100 
	C459.970154,310.042267 459.999359,310.006409 460.017822,309.992615 
	C459.697235,309.903168 459.432587,309.720032 459.106689,309.234253 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M401.141357,432.694611 
	C400.863800,433.015533 400.661316,433.022675 400.156372,433.057892 
	C399.853912,433.085999 399.441315,432.890686 399.331116,432.690796 
	C399.346039,432.314087 399.471100,432.137268 399.892578,431.828583 
	C400.628296,431.779297 400.975677,431.999969 401.141357,432.694611 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M511.071045,336.241730 
	C511.343140,336.101227 511.617859,336.278931 511.886475,336.796570 
	C511.611450,336.944336 511.342560,336.752136 511.071045,336.241730 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M542.907471,305.366272 
	C543.329590,305.118164 543.710083,305.233276 544.044312,305.698730 
	C543.513977,306.320221 543.131042,306.233459 542.907471,305.366272 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M160.427795,856.542664 
	C160.376831,856.463684 160.582352,856.435425 160.582352,856.435425 
	C160.582352,856.435425 160.478775,856.621643 160.427795,856.542664 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M178.806305,714.036133 
	C178.969910,714.360535 178.897278,714.569153 178.560059,714.977295 
	C177.891617,714.649841 178.019867,714.239014 178.806305,714.036133 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M573.091675,337.631592 
	C572.797058,337.671234 572.505005,337.359528 572.114868,336.725800 
	C572.375916,336.695923 572.735046,336.988098 573.091675,337.631592 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M512.046814,336.964844 
	C512.216675,337.130707 512.328613,337.351318 512.440552,337.571930 
	C512.313354,337.532257 512.186218,337.492584 511.969666,337.294739 
	C511.880341,337.136536 511.988831,337.019623 512.046814,336.964844 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M459.015228,308.995544 
	C458.915985,308.919250 458.799713,308.854767 458.683441,308.790283 
	C458.765717,308.770050 458.847961,308.749786 458.950653,308.884308 
	C458.971069,309.039093 458.998199,309.007355 459.015228,308.995544 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M537.338318,307.965698 
	C537.765747,307.975677 537.955994,308.145508 538.227417,308.506378 
	C538.336243,308.666473 538.035339,308.962006 537.883667,309.111206 
	C537.505798,309.122681 537.293518,308.966156 536.968994,308.642914 
	C536.842834,308.495056 537.128784,308.094635 537.338318,307.965698 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M171.454407,851.531067 
	C171.424713,851.479248 171.484116,851.582886 171.454407,851.531067 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M510.047028,334.958679 
	C510.446655,334.973480 510.717651,335.153625 510.989014,335.687988 
	C511.068420,335.923523 510.995422,336.002777 510.953064,336.042542 
	C510.633698,335.912109 510.356659,335.741913 509.992065,335.338318 
	C509.904480,335.104950 509.997345,335.005249 510.047028,334.958679 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M508.940613,319.260925 
	C508.516327,318.984161 508.320648,318.664093 508.125000,318.344025 
	C508.395416,318.323151 508.665833,318.302307 509.095734,318.520844 
	C509.255219,318.760254 509.169220,319.217621 508.940613,319.260925 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M424.421936,321.408905 
	C424.530121,321.322449 424.579193,321.637085 424.579193,321.637085 
	C424.579193,321.637085 424.313782,321.495361 424.421936,321.408905 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M172.019989,812.025879 
	C172.114883,811.993286 172.193085,811.942627 172.118134,811.934509 
	C171.964981,811.977051 172.003296,812.007874 172.019989,812.025879 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M552.014954,318.756226 
	C551.776978,318.817078 551.349243,318.522766 551.386108,318.442871 
	C551.578552,318.025970 551.849426,318.069489 552.014954,318.756226 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M150.306885,776.225464 
	C150.549561,776.177734 150.645248,776.277466 150.740936,776.377197 
	C150.547241,776.375732 150.353577,776.374329 150.306885,776.225464 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M355.108337,444.313782 
	C355.260010,444.577850 355.094482,444.941010 354.666565,445.460022 
	C354.533142,445.214874 354.662140,444.813904 355.108337,444.313782 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M404.987610,779.983643 
	C404.896515,780.015869 404.817139,780.062073 404.882721,780.064331 
	C405.027679,780.020386 404.999359,779.997620 404.987610,779.983643 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M509.118286,318.895142 
	C509.421844,319.000916 509.588501,319.241577 509.755127,319.482239 
	C509.510773,319.533203 509.266388,319.584137 508.867004,319.469666 
	C508.711975,319.304230 508.981354,319.029999 509.118286,318.895142 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M513.445801,319.520294 
	C513.403564,319.449921 513.488098,319.590668 513.445801,319.520294 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M552.017456,318.984009 
	C552.166626,319.128876 552.305115,319.283264 552.443604,319.437683 
	C552.339294,319.395905 552.235046,319.354156 552.060547,319.162415 
	C551.990356,319.012451 552.006775,318.993530 552.017456,318.984009 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M193.000839,827.999451 
	C192.883850,827.862671 192.766022,827.726379 192.648209,827.590149 
	C192.729919,827.638489 192.811646,827.686829 192.946014,827.868774 
	C192.998672,828.002319 193.000000,828.000000 193.000839,827.999451 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M465.016754,313.983276 
	C464.783539,313.906250 464.539703,313.839874 464.295837,313.773529 
	C464.478149,313.726685 464.660492,313.679871 464.915527,313.824585 
	C464.988281,314.016144 465.006104,313.993927 465.016754,313.983276 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M542.460449,313.414795 
	C542.538513,313.362274 542.566589,313.570282 542.566589,313.570282 
	C542.566589,313.570282 542.382385,313.467346 542.460449,313.414795 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M353.915131,446.162720 
	C354.060577,446.401367 353.925201,446.773010 353.515564,447.283813 
	C353.372314,447.047211 353.503296,446.671478 353.915131,446.162720 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M425.847412,324.139557 
	C425.577698,324.012329 425.412262,323.783356 425.246826,323.554382 
	C425.470154,323.523376 425.693512,323.492371 426.035736,323.644958 
	C426.154633,323.828522 425.951721,324.037781 425.847412,324.139557 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M227.203613,898.864563 
	C227.054184,898.995117 226.736313,898.628113 226.664001,898.396118 
	C226.976196,898.179443 227.450775,898.074402 227.203613,898.864563 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M423.022766,473.028748 
	C423.179260,472.705811 423.318665,472.363586 423.751160,472.031494 
	C424.044220,472.041656 424.006836,472.005463 423.989807,471.985626 
	C423.814728,472.271332 423.656647,472.576874 423.232239,472.929504 
	C422.965942,472.976624 423.005676,473.009430 423.022766,473.028748 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M425.242432,287.220459 
	C425.252350,287.458282 424.953644,287.721863 424.351135,288.022888 
	C424.342773,287.788940 424.638275,287.517578 425.242432,287.220459 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M421.099731,285.231079 
	C421.192047,285.010742 421.361542,285.015686 421.784546,284.999268 
	C422.062622,285.698334 421.744080,285.801025 421.099731,285.231079 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M110.928093,917.917419 
	C110.989761,917.538879 111.188820,917.285828 111.771469,917.079712 
	C111.991966,917.394409 111.813072,917.659973 111.335175,917.987671 
	C111.126175,918.110535 110.991280,917.984619 110.928093,917.917419 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M112.775688,916.088623 
	C112.980560,916.393372 112.788673,916.650452 112.296478,916.956238 
	C112.080856,917.068176 111.994797,916.989319 111.953827,916.944824 
	C112.014709,916.578308 112.198303,916.312927 112.775688,916.088623 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M112.948990,915.937256 
	C113.063583,915.838806 113.240860,914.968567 113.232040,915.986694 
	C113.087746,916.073059 112.992668,915.985046 112.948990,915.937256 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M114.454826,913.565735 
	C114.410637,913.494751 114.593285,913.471985 114.593285,913.471985 
	C114.593285,913.471985 114.499016,913.636719 114.454826,913.565735 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M116.523407,912.548584 
	C116.460037,912.586121 116.586777,912.511047 116.523407,912.548584 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M337.045227,629.744202 
	C336.811554,629.798279 336.641693,629.625977 336.508820,629.428650 
	C336.490997,629.402161 336.659973,629.249939 336.920105,629.087097 
	C337.097687,629.018311 337.120575,629.509949 337.045227,629.744202 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M478.502563,301.482269 
	C478.527008,301.484283 478.478088,301.480255 478.502563,301.482269 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M121.799866,869.784912 
	C122.100471,869.337646 122.730568,868.484436 122.453903,870.094116 
	C122.267570,870.250793 121.953209,869.942749 121.799866,869.784912 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M530.971924,302.799744 
	C530.771423,302.884186 530.556213,302.751892 530.341064,302.619629 
	C530.546448,302.607422 530.751892,302.595245 530.971924,302.799744 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M124.807243,868.014160 
	C124.850746,868.188477 124.703217,868.378113 124.555695,868.567810 
	C124.575867,868.388367 124.596039,868.208923 124.807243,868.014160 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M531.985779,304.010925 
	C531.692322,303.850159 531.417786,303.672302 531.064941,303.255463 
	C530.986572,303.016479 531.001038,302.999084 531.010498,302.990845 
	C531.312561,303.141754 531.605225,303.300934 531.968262,303.708008 
	C532.038696,303.955902 532.004700,303.993835 531.985779,304.010925 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M294.021118,704.272339 
	C294.170837,704.495605 293.714783,704.583740 293.714783,704.583740 
	C293.714783,704.583740 293.267609,704.458191 293.073547,704.330933 
	C293.210144,704.152161 293.540771,704.100647 294.021118,704.272339 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M125.001106,868.001221 
	C125.134796,868.022217 124.950485,867.065735 125.171448,867.945068 
	C124.998283,867.998779 125.000000,868.000000 125.001106,868.001221 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M553.486145,299.784241 
	C553.367737,299.453735 552.889526,298.595093 554.003784,299.270813 
	C554.118713,299.494507 553.730530,299.791992 553.486145,299.784241 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M514.569275,341.442932 
	C514.606995,341.504852 514.531555,341.380981 514.569275,341.442932 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M582.300171,340.226349 
	C582.528503,340.022522 582.790588,339.797211 583.052734,339.571869 
	C582.975403,339.777710 582.898132,339.983551 582.532776,340.207855 
	C582.244690,340.226318 582.333923,340.204865 582.300171,340.226349 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M513.420166,339.560913 
	C513.365601,339.476715 513.580933,339.440765 513.580933,339.440765 
	C513.580933,339.440765 513.474731,339.645142 513.420166,339.560913 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M399.425842,432.379639 
	C399.006378,432.424652 398.830200,432.302917 398.612366,431.985168 
	C398.532349,431.844604 398.730927,431.400574 398.867065,431.199036 
	C399.462708,430.830231 399.843933,430.927277 400.070526,431.662659 
	C400.007080,431.992950 399.630768,432.268372 399.425842,432.379639 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M223.647125,887.070801 
	C223.755371,887.020081 223.880234,886.971375 223.820831,887.010681 
	C223.636551,887.098755 223.663757,887.072876 223.647125,887.070801 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M433.452637,354.543671 
	C433.410645,354.480255 433.494629,354.607086 433.452637,354.543671 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M140.504913,881.733276 
	C140.285583,881.705750 140.236038,881.334473 140.236038,881.334473 
	C140.236038,881.334473 140.601318,881.185852 140.676575,881.252747 
	C140.751816,881.319641 140.724228,881.760864 140.504913,881.733276 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M453.443970,349.537354 
	C453.412811,349.485535 453.475159,349.589142 453.443970,349.537354 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M714.296875,81.215630 
	C702.911865,87.226738 690.648010,89.582764 678.472717,91.982788 
	C639.974792,99.571556 601.161377,105.189758 562.224976,109.993713 
	C554.460388,110.951706 546.729370,112.179504 538.438843,112.151566 
	C537.529785,109.114731 537.164978,106.470009 534.191528,104.509445 
	C531.580811,102.788017 531.117859,99.085190 529.879700,96.278229 
	C528.612427,93.405128 534.491333,88.601173 537.750122,89.167564 
	C541.353943,89.793900 544.745544,87.623550 548.386963,88.089378 
	C550.675171,88.382103 553.570984,86.975235 554.663086,90.754425 
	C554.436646,91.482239 554.182983,91.833229 553.640320,92.352814 
	C553.033630,92.902908 552.846924,93.452278 552.295959,93.602997 
	C552.655334,93.745033 552.855042,93.594048 553.091980,92.928917 
	C553.582092,92.423218 553.874512,92.137962 554.393677,91.625801 
	C555.728638,87.882172 560.733643,86.294380 565.591248,88.180588 
	C566.896667,88.687492 567.441040,88.797592 568.896912,88.080063 
	C572.433777,86.336914 576.576050,86.361053 580.474548,85.857597 
	C588.083862,84.874916 595.708008,83.923195 603.375183,83.443680 
	C604.686890,83.361633 606.028809,83.189720 607.291382,84.447128 
	C607.438721,85.201035 607.153503,85.526276 607.002563,85.903923 
	C606.761230,86.507843 606.869385,85.646301 607.253723,86.190811 
	C607.342102,86.315987 607.315735,86.163231 607.269165,85.527298 
	C607.546753,83.771584 608.221680,82.545097 609.720215,82.401627 
	C615.583191,81.840248 621.473694,82.001801 627.353577,82.041748 
	C628.987488,82.052849 628.577148,83.678024 628.901123,84.680443 
	C629.552124,83.174950 630.739075,82.359329 632.323669,82.155907 
	C633.942200,81.948120 635.437195,82.785522 637.187317,82.471725 
	C639.069519,82.134270 641.567627,83.561668 640.915283,79.704208 
	C640.691040,78.378220 642.322449,78.067734 643.473389,77.891159 
	C645.299500,77.611008 647.309631,77.537392 648.870300,78.283524 
	C654.138672,80.802177 658.737976,79.493813 663.547119,76.362686 
	C664.128113,76.241364 664.364075,76.212524 664.955811,76.195786 
	C669.961182,79.502388 674.890503,76.508713 679.610535,76.496048 
	C687.187805,76.475708 694.825623,75.885818 702.780884,75.263435 
	C703.626160,75.200043 704.107300,75.254730 704.922363,75.506882 
	C706.919373,77.201355 709.119263,77.155617 711.137085,77.659386 
	C712.841797,78.085007 714.858704,78.242157 714.296875,81.215630 
z"/>
<path fill="#F8D2D8" opacity="1.000000" stroke="none" 
	d="
M67.685379,333.758087 
	C67.933662,336.670105 67.979034,339.330627 68.057709,342.435364 
	C68.373756,343.257965 68.576057,343.676239 68.732994,344.478119 
	C68.535835,345.967896 68.514954,347.101746 68.897339,348.564514 
	C68.970650,350.377441 68.393684,351.772614 68.418419,352.903564 
	C68.330887,353.903412 69.385056,353.207245 68.728607,353.323547 
	C68.537628,353.357391 68.408508,353.220795 68.489838,352.960022 
	C69.467064,349.826935 68.132347,346.455688 69.630463,343.059448 
	C70.502274,333.454102 71.227379,324.153198 72.051590,314.420380 
	C72.242088,313.829712 72.333473,313.670959 72.311768,313.261841 
	C72.329300,310.257904 72.459930,307.504425 72.745972,304.374451 
	C74.703194,302.234802 75.441124,299.762177 77.007149,297.841339 
	C77.663345,297.036469 78.427032,296.337524 79.529961,296.751465 
	C80.362358,297.063843 80.929146,297.938324 80.734962,298.734589 
	C79.064758,305.583130 84.908859,311.626617 82.238632,318.868256 
	C84.170441,317.593109 83.364342,314.247345 86.667480,315.606689 
	C88.712219,324.745056 86.551971,333.445648 86.016243,342.149780 
	C85.673531,347.717682 84.933060,353.356262 84.653870,358.918121 
	C84.098061,369.990601 82.292763,380.968872 82.349136,392.073853 
	C82.357750,393.770874 81.899117,395.354553 80.508850,397.011627 
	C78.107079,398.457611 76.274704,398.052795 75.133011,396.007141 
	C73.885864,393.772522 72.340843,393.497131 70.220200,394.585846 
	C68.117538,395.665314 66.838409,397.204742 67.123520,399.690613 
	C67.217369,400.508881 67.525429,401.290863 67.695831,402.098206 
	C68.413300,405.497406 66.919365,407.334198 63.557518,407.124084 
	C59.780663,406.888031 55.979950,406.602325 52.254272,405.875153 
	C47.749229,404.995819 46.706093,401.730988 46.870773,397.320129 
	C49.173096,370.098358 50.325363,343.215912 49.773609,316.272644 
	C49.695370,312.452026 49.458393,308.634644 49.354408,304.340759 
	C54.026497,302.900146 58.364532,305.508759 60.394970,311.259552 
	C62.171146,316.290222 64.761124,320.837189 67.576096,325.725342 
	C67.889145,326.455017 67.951714,326.896118 67.925941,327.662659 
	C66.600952,329.755615 66.786285,331.614655 67.685379,333.758087 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M378.547546,171.761749 
	C378.508881,180.709564 378.250519,189.396774 377.905396,198.545959 
	C374.494507,199.994858 374.050201,197.075180 373.106110,195.254227 
	C372.094238,193.302551 371.559601,191.753983 368.714508,191.405609 
	C364.378540,190.874649 363.792755,188.597595 366.292084,184.027542 
	C364.588959,185.460114 363.239563,186.802124 361.884399,188.631927 
	C361.492188,189.066132 361.316010,189.222488 360.817261,189.524460 
	C358.395569,190.171524 356.611786,188.252228 354.214142,189.249252 
	C352.382141,190.011032 351.381500,188.109756 351.249695,186.220154 
	C350.811676,179.939560 345.094849,182.524323 341.940521,181.013000 
	C339.871490,180.021683 338.220428,183.236603 336.322235,184.472198 
	C335.847046,184.781525 335.970032,185.342697 336.303864,185.785995 
	C337.245941,187.036987 338.293091,188.446686 336.295074,189.501434 
	C334.367462,190.519043 332.710846,189.543289 331.511475,187.964508 
	C330.792908,187.018585 329.766510,186.421051 329.469391,186.024963 
	C331.304657,187.995605 330.835815,189.748795 327.451721,190.099945 
	C323.594818,190.500153 319.787140,189.494751 315.754456,190.402451 
	C313.412231,190.929672 310.044403,188.827652 310.885162,184.660690 
	C308.768463,185.580399 306.197296,189.523010 304.300476,183.956207 
	C304.527191,182.692215 305.475922,181.845139 304.466888,180.553802 
	C303.506744,179.684784 302.849854,178.576279 301.509705,180.062408 
	C300.018860,182.073868 297.090271,182.996124 298.434509,186.398926 
	C297.344269,190.189026 295.314972,188.741516 293.481293,187.547302 
	C291.838531,186.477417 290.835358,184.537537 288.465515,183.825989 
	C286.355316,181.551956 284.105621,179.841873 282.736664,177.361679 
	C282.417786,176.783905 282.960999,177.138046 282.452026,177.046387 
	C282.013489,176.967453 282.771210,177.494568 282.641785,178.140396 
	C282.613007,179.141968 282.384949,179.772491 281.979065,180.706665 
	C281.531281,181.643921 281.180756,182.242630 280.621155,183.127991 
	C280.102600,183.775940 279.739868,184.079788 279.004089,184.466721 
	C278.195618,184.648193 277.730438,184.613632 276.992065,184.273682 
	C275.928955,182.095505 276.349335,179.165802 272.663513,179.025879 
	C271.703979,177.695557 271.566803,176.412170 271.020508,174.857269 
	C270.474243,171.546173 270.222870,168.623566 271.425842,165.428436 
	C275.156982,164.239807 274.485046,160.119064 277.105194,158.107666 
	C277.558472,157.746170 277.755066,157.619888 278.284790,157.380798 
	C282.808838,159.054825 286.060150,157.611893 288.801422,154.335266 
	C289.961243,152.948914 291.171875,153.637543 292.343994,154.348557 
	C293.733582,155.191498 294.709198,156.779953 296.903625,156.613876 
	C297.954193,156.179886 298.582947,155.676514 299.312561,154.809006 
	C299.796509,154.269409 300.101227,153.988007 300.677185,153.542389 
	C301.602936,152.895508 302.406250,152.595749 303.021973,151.565979 
	C303.344971,151.130569 303.484741,150.961624 303.874878,150.574203 
	C307.265289,146.922409 310.034943,149.755676 313.205994,150.739532 
	C313.713348,150.522751 313.920593,150.441208 314.457031,150.285492 
	C318.040588,151.864090 320.571503,150.931107 322.824646,147.824661 
	C323.720032,147.269501 324.387543,147.158768 325.419373,147.338043 
	C326.932251,148.363159 328.157532,149.200073 329.933411,149.270416 
	C330.119202,149.321640 330.319092,149.522095 330.319092,149.522095 
	C330.319092,149.522095 330.497620,149.275620 330.373779,149.104645 
	C329.914032,147.332901 330.229919,146.027069 332.229584,145.269547 
	C332.811188,145.237991 333.045654,145.262970 333.607849,145.422165 
	C334.111206,145.713226 334.286865,145.870087 334.656860,146.319916 
	C335.178375,147.224060 335.434998,147.870331 335.947845,148.772995 
	C337.556671,151.556351 336.331848,153.379013 334.724304,155.219833 
	C333.519806,156.599091 331.570465,157.582993 331.907318,159.973267 
	C332.468689,157.829437 333.282928,155.931396 336.050293,155.412964 
	C336.625061,155.497650 336.847534,155.575104 337.342407,155.877991 
	C340.613251,158.966553 339.480042,162.036148 337.511078,165.418839 
	C340.857941,165.619080 343.783539,166.881836 344.027740,161.938431 
	C344.111603,160.240417 343.022369,156.936035 346.211700,156.665863 
	C349.754486,156.365723 352.409851,158.384888 354.390564,161.361343 
	C354.765472,161.924713 353.299927,163.528305 355.171936,162.987885 
	C356.571381,162.583878 357.787689,162.155899 358.475037,163.823990 
	C359.057159,165.236755 358.288696,166.376968 357.393158,167.413498 
	C356.854126,168.037354 356.189697,168.572845 355.860748,169.348022 
	C355.620178,169.914825 355.861420,170.269745 356.497070,170.155945 
	C356.988922,170.067871 357.384186,169.736572 358.024017,169.188873 
	C358.459167,168.810577 358.639099,168.665710 359.114929,168.341187 
	C362.787231,166.052399 365.970917,165.631989 369.070496,168.819046 
	C370.582153,170.373398 372.458557,171.258621 374.832916,170.364914 
	C376.125885,169.878265 377.406433,170.366791 378.547546,171.761749 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M377.441803,205.805878 
	C377.330688,216.077774 376.945190,226.135208 376.439575,236.588562 
	C373.083160,240.055145 370.887970,239.705597 367.240601,235.200073 
	C367.298279,234.642258 367.351624,234.422531 367.539001,233.896729 
	C368.099182,232.413849 367.784637,230.472351 366.658478,231.324677 
	C362.173462,234.719009 360.186401,231.700592 357.976929,228.344940 
	C357.136414,232.276505 354.992218,232.712402 352.052429,230.951111 
	C350.626160,230.096619 349.624847,228.739807 348.423737,227.618210 
	C347.468597,226.726318 346.511353,226.128799 345.759064,228.264221 
	C345.502228,228.777130 345.368683,228.967651 344.928467,229.329315 
	C343.146729,229.826355 341.837952,229.222839 341.067749,228.163925 
	C337.930115,223.850143 334.825745,225.228912 332.394562,228.516602 
	C329.606659,232.286652 327.283539,232.125839 325.201874,229.303436 
	C325.541473,229.631775 326.622833,230.441223 327.252167,231.631149 
	C327.829437,232.722534 328.007324,233.923248 327.093536,234.886124 
	C325.979889,236.059570 324.505951,235.948441 323.549408,234.874832 
	C321.381836,232.442017 319.279236,231.782791 316.188080,233.478989 
	C314.502838,234.403717 309.642853,230.498978 309.630096,228.492218 
	C309.611786,225.612686 311.851410,226.240265 313.866455,226.137894 
	C311.270477,224.631912 309.587830,226.192245 308.082336,227.548843 
	C305.840240,229.569153 303.381287,231.245926 300.806061,232.761780 
	C299.675659,233.427155 298.239685,234.143478 297.127960,232.973846 
	C295.708374,231.480286 296.997620,230.269516 297.960114,229.116287 
	C297.179840,229.575592 296.564941,230.420959 295.574921,230.414932 
	C294.335388,230.407410 293.606171,229.783478 293.166016,232.101425 
	C292.576477,235.205948 289.867737,233.432831 287.697754,232.292725 
	C287.223724,231.957352 287.043304,231.811569 286.619263,231.419586 
	C284.791931,228.966583 283.112427,226.848083 280.678406,224.949814 
	C279.731171,223.000336 279.901825,221.439362 281.257751,219.753265 
	C281.876770,219.068481 282.398499,218.737854 282.635956,218.165863 
	C282.463013,218.490112 282.239105,218.774750 281.738220,219.243347 
	C279.017975,220.486603 278.271881,222.818695 277.112610,225.290924 
	C275.002258,227.352966 272.323975,228.210800 271.027191,230.692368 
	C270.675781,231.364853 270.207977,232.228836 269.185059,231.865784 
	C268.324524,231.560394 268.074615,230.710419 267.896301,229.912018 
	C267.320740,227.335007 267.967651,224.661011 267.205261,221.717499 
	C266.888214,220.346725 266.853394,219.333755 266.940216,217.940155 
	C267.090759,216.578079 267.167206,215.590103 266.950684,214.217743 
	C267.853821,209.198456 267.038330,204.391495 268.453918,199.474121 
	C271.423584,197.454895 272.817383,200.182358 274.683807,201.146317 
	C276.187958,201.923157 277.050781,202.328049 277.106262,199.781372 
	C277.256439,199.228607 277.338409,199.012375 277.596436,198.495483 
	C279.060547,196.911484 279.603241,195.565414 278.635223,193.756927 
	C278.055481,192.673782 278.205017,191.437134 279.423126,190.702271 
	C280.371582,190.130112 281.468750,190.210617 282.225098,190.922577 
	C285.363342,193.876633 289.110474,196.188644 291.633362,199.792862 
	C292.019409,200.344345 292.635742,201.113708 292.394165,201.571548 
	C290.466919,205.224426 293.734589,205.971695 295.560425,207.632217 
	C298.013550,209.863281 299.963593,210.692322 303.202515,208.236862 
	C305.495819,206.498260 309.192932,206.455658 312.222656,206.730423 
	C314.541443,206.940689 316.064728,206.432083 317.779480,204.652237 
	C318.753632,204.160858 319.454987,204.096207 320.507446,204.356125 
	C322.534027,207.391983 325.578430,202.671341 327.268921,205.616364 
	C327.699860,204.554169 326.815582,203.423157 327.637421,202.078033 
	C328.247742,201.535629 328.695862,201.409225 329.523163,201.458679 
	C333.378967,203.285019 334.003906,207.849518 337.667206,209.551956 
	C336.632477,208.696426 335.100647,208.124710 335.809875,206.434769 
	C336.366730,205.107880 337.786926,204.913284 338.773041,205.527969 
	C342.735229,207.997757 344.875244,205.527985 347.293304,202.591782 
	C347.828339,202.370499 348.054840,202.320328 348.625092,202.286453 
	C350.881561,202.372147 351.839081,207.128281 354.702881,203.166901 
	C355.244354,202.353851 355.586212,201.798904 355.998474,200.899292 
	C356.259979,200.404114 356.378784,200.212326 356.733063,199.774658 
	C358.562927,198.659332 360.106323,197.673370 362.289612,197.374359 
	C362.861145,197.467941 363.083862,197.539597 363.609558,197.788773 
	C364.796967,198.709549 365.934601,199.207581 366.458557,200.306946 
	C367.633514,202.772278 366.396362,204.608704 363.707916,204.156326 
	C362.373199,203.931747 361.160370,203.206329 360.204132,204.732910 
	C359.808472,205.364517 359.788300,206.030350 360.425354,206.494370 
	C361.627869,207.370270 362.547333,206.393127 363.617188,206.007919 
	C367.739838,204.523453 370.740112,207.761230 369.762665,212.942627 
	C369.702911,213.451279 369.226746,213.456573 369.506165,213.522034 
	C371.154327,209.758636 372.399017,205.947693 377.441803,205.805878 
z"/>
<path fill="#F9D8DA" opacity="1.000000" stroke="none" 
	d="
M227.154495,352.975189 
	C227.558411,349.639130 228.349609,347.046234 226.677704,344.572083 
	C228.809814,342.857941 227.686935,340.587921 226.590698,338.530518 
	C228.392075,338.543243 227.586533,336.843353 227.555618,335.725952 
	C227.345367,328.124847 227.047897,320.526184 226.651764,312.475006 
	C225.847839,310.407532 225.980362,308.731598 226.302734,306.677917 
	C230.621613,305.227295 231.904022,305.952026 231.806656,310.302185 
	C231.729645,313.742615 232.735291,315.129364 236.259552,315.047394 
	C240.099426,314.958130 242.175781,317.071655 241.841125,321.013672 
	C241.647552,323.293762 242.151352,325.252869 243.402679,327.142883 
	C244.878143,329.371429 244.495255,331.874390 244.426346,334.560211 
	C244.920425,329.580078 242.995590,324.946747 243.538757,319.797424 
	C243.620438,315.993103 243.570526,312.591827 243.605164,308.758240 
	C243.649918,307.454529 243.757111,306.596497 244.296600,305.404083 
	C250.235428,302.163330 251.375168,302.408264 254.097198,307.702789 
	C255.204453,309.856476 257.326660,311.002533 258.716522,313.372589 
	C258.283752,323.669647 258.968597,333.590393 257.669464,343.454620 
	C257.086426,347.881683 257.455841,352.392548 257.414429,357.320404 
	C256.040436,364.167969 256.472473,370.654633 256.413635,377.114655 
	C256.393860,379.285400 256.307159,381.435791 255.273712,383.835754 
	C253.670944,386.207153 251.900986,386.406769 249.950867,385.044983 
	C246.507751,382.640594 245.136383,383.023071 243.684723,386.958130 
	C243.168579,388.357269 243.096115,389.892578 242.326599,391.598206 
	C240.590027,394.596802 242.107147,397.843506 240.350525,400.794800 
	C237.004868,402.217468 235.954132,399.515778 234.963760,397.798553 
	C232.820053,394.081543 230.801544,393.773285 228.064178,397.037048 
	C227.336807,397.904297 226.301163,398.476288 224.736786,398.536926 
	C224.155243,398.368073 223.937012,398.246063 223.498566,397.812317 
	C222.948700,396.781891 222.797424,396.019714 222.704529,394.839081 
	C222.991470,390.980042 223.776962,387.570892 223.900375,383.683350 
	C224.133514,383.045288 224.260803,382.803162 224.668976,382.262024 
	C225.128006,380.270996 225.306137,378.579041 225.397949,376.469971 
	C225.106903,375.511078 225.129868,374.980682 225.528870,374.224060 
	C225.767914,371.625977 225.869217,369.266083 225.583740,366.731232 
	C227.753189,365.268555 226.427582,362.798584 226.906006,360.478546 
	C226.745041,359.882965 226.602646,359.692535 226.689148,359.228516 
	C227.001724,357.210052 227.085419,355.465088 227.154495,352.975189 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M375.337585,252.732605 
	C375.707794,254.264587 375.733063,255.770645 375.865692,257.640045 
	C376.169678,258.166443 376.366241,258.329468 376.275024,258.745361 
	C374.951904,261.293549 375.184692,263.764008 374.884583,266.574036 
	C373.177704,269.233063 374.484222,272.167938 372.992554,274.501007 
	C372.443634,275.359619 372.161652,276.336334 370.942810,276.304077 
	C369.951813,276.277893 369.450195,275.536163 369.259674,274.719604 
	C367.647125,267.808258 361.599426,268.723419 356.824829,267.989227 
	C345.283081,266.214447 334.027069,269.667664 322.625153,270.570709 
	C319.423157,270.824341 316.334656,270.887543 313.218750,270.393799 
	C309.412170,269.790680 305.617249,269.469055 301.787842,270.093384 
	C291.150787,271.827667 280.567932,269.485565 269.948334,269.649750 
	C266.468964,269.703522 263.760925,268.328644 263.055481,264.038361 
	C263.581818,258.209503 262.989319,252.657211 264.693237,246.976837 
	C265.701874,245.610855 266.739532,245.056244 267.876343,245.974701 
	C269.881561,247.594757 273.973175,247.680038 276.706055,245.729065 
	C277.071442,245.287262 277.231781,245.121490 277.677612,244.760315 
	C278.182098,244.495285 278.401154,244.425705 278.963226,244.339233 
	C279.530426,244.360855 279.754608,244.399384 280.298615,244.542374 
	C283.718628,243.487061 285.786652,247.212311 289.158447,246.409424 
	C289.709991,246.528931 289.920868,246.618317 290.378387,246.939697 
	C294.979065,247.382385 298.922394,248.537445 302.298645,251.532242 
	C303.582672,252.671204 304.716797,251.254715 305.716003,250.395966 
	C308.242859,248.224258 310.884277,246.179810 313.594330,244.263336 
	C315.093994,243.202820 317.226440,241.274414 318.898956,243.196777 
	C320.740082,245.312866 317.936707,246.556824 317.087494,248.382660 
	C320.202515,247.201141 322.784393,249.134720 325.641541,250.397980 
	C325.142609,247.631378 327.038208,246.058151 328.509705,244.350494 
	C329.729858,242.934494 331.667236,243.081772 332.443817,244.375229 
	C334.645477,248.042343 339.244232,248.265350 341.851624,252.047424 
	C341.713257,250.163132 340.417236,249.524017 340.424805,247.963470 
	C340.521545,247.387726 340.607788,247.167358 340.956543,246.708923 
	C342.864685,245.643417 344.438934,246.463150 346.065674,246.579086 
	C351.402466,246.959396 356.873932,242.985794 362.113129,247.095688 
	C365.056152,245.016266 368.139771,244.510941 371.509857,246.075195 
	C372.844971,246.694916 374.329041,247.756287 373.454407,248.959702 
	C371.630035,251.469818 373.985291,251.689896 375.337585,252.732605 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M340.861206,246.858459 
	C341.043854,248.913254 342.354095,249.944122 343.742615,250.913513 
	C344.647675,251.545380 345.303192,252.356476 344.448883,253.352615 
	C343.629822,254.307724 342.697937,253.715683 341.786591,253.207443 
	C338.659821,251.463699 336.784088,247.065201 332.093262,248.594574 
	C331.993896,248.626953 331.694550,248.422897 331.701233,248.348175 
	C331.859192,246.583420 333.337585,243.240814 329.641571,244.925186 
	C327.817169,245.756607 324.563416,249.130905 329.081696,252.139893 
	C326.473755,253.061325 325.114441,251.452728 323.579468,250.743851 
	C320.970947,249.539185 318.538025,247.945999 315.802490,250.448624 
	C315.151398,251.044281 314.096222,251.133224 313.591583,250.335632 
	C313.064362,249.502365 313.759308,248.785736 314.492615,248.316956 
	C316.273987,247.178162 318.122559,246.110443 318.845062,243.163315 
	C313.546753,244.890793 309.875793,248.264587 306.523254,251.552444 
	C304.162933,253.867249 302.925476,254.516968 300.562927,252.145157 
	C299.405304,250.983002 297.921570,250.149597 296.608978,249.136856 
	C295.300659,248.127396 294.374420,247.618759 292.933228,249.376312 
	C291.250519,251.428391 290.968079,251.196777 290.001465,247.387268 
	C290.000000,247.000000 290.160370,246.841507 290.080200,246.920746 
	C288.747284,246.992859 287.879120,247.784332 286.895599,248.397324 
	C286.391113,248.711761 285.658691,248.660477 285.029297,248.774445 
	C285.596893,244.240662 281.108368,247.707153 280.052979,245.331909 
	C279.556976,245.002258 279.111542,245.002075 278.334259,245.000000 
	C276.494965,246.931580 277.247162,251.979904 271.949890,248.434265 
	C269.334595,246.683792 269.707092,251.372604 268.122467,252.459106 
	C265.048553,250.803818 269.437012,247.597382 266.143738,246.024292 
	C265.520996,245.597748 265.351196,245.176224 265.284973,244.369415 
	C265.770966,241.830444 266.476013,239.633942 265.150635,237.084503 
	C266.224701,231.711060 264.302155,226.297256 267.409546,221.245453 
	C270.432953,223.951340 268.131592,227.688660 269.460449,231.513672 
	C270.173157,227.261887 273.295776,226.236877 276.838013,225.286224 
	C277.769073,228.040634 275.829926,229.296448 274.635040,230.990265 
	C276.343567,229.226654 278.746552,228.219818 280.512329,225.482773 
	C284.572571,224.979187 285.363770,228.067673 286.961426,230.648529 
	C288.261047,230.990448 289.145721,231.762619 290.111206,232.423721 
	C290.806091,232.899536 291.718750,233.219040 292.358521,232.422806 
	C293.036285,231.579269 292.228668,230.955170 291.780273,230.281158 
	C291.209839,229.423721 289.489105,228.687698 290.822266,227.474854 
	C291.918488,226.477554 293.033173,227.462479 293.690247,228.473770 
	C295.061432,230.584152 296.073456,229.232681 297.253296,228.271057 
	C298.435791,227.307236 299.865936,224.877106 301.200012,226.682693 
	C302.614441,228.597031 299.377014,228.763947 298.545837,230.002930 
	C298.108459,230.654877 297.632843,231.281158 296.517792,232.832916 
	C301.127777,231.873138 303.693512,229.607391 306.132690,227.184662 
	C310.698639,222.649521 314.206299,223.006729 316.428101,228.297607 
	C316.135651,228.396942 315.773895,228.658066 315.561188,228.567841 
	C313.974609,227.894852 312.463623,225.945389 310.685883,227.668274 
	C309.815369,228.511902 311.025818,229.767410 311.891693,229.852875 
	C313.832275,230.044373 314.137177,235.238846 317.201233,231.586487 
	C319.913727,228.353210 321.435242,231.113907 323.175995,232.752747 
	C324.134094,233.654739 324.722321,235.998932 326.489380,234.213470 
	C327.679291,233.011185 325.853302,231.970749 325.418823,230.827774 
	C324.649384,228.803665 319.758698,229.309662 321.720856,226.887939 
	C323.712555,224.429688 325.323853,228.352890 326.998749,229.565140 
	C328.466248,230.627243 329.053802,231.135498 330.286621,229.026611 
	C331.473694,226.996094 333.786224,225.625092 335.598480,223.958054 
	C336.976227,222.690689 337.945770,223.570251 339.017303,224.499298 
	C340.754578,226.005554 341.926575,228.195633 344.655029,228.963684 
	C344.828461,227.570496 344.656891,226.141006 344.473053,224.609314 
	C348.536377,223.941895 349.672516,227.550629 351.895660,229.427032 
	C353.091858,230.436691 354.391174,231.555817 355.839508,230.695419 
	C357.583771,229.659225 355.325134,228.911896 355.249481,227.932480 
	C355.117004,226.216736 356.180817,225.717651 357.376190,226.396194 
	C358.615814,227.099823 359.922882,228.181473 360.517242,229.424484 
	C361.873108,232.260208 363.045319,233.241791 365.193207,230.103607 
	C366.481262,228.221771 367.831238,229.205582 368.699066,230.564041 
	C369.336914,231.562485 372.139313,232.926636 368.315460,233.972275 
	C368.155579,235.361160 367.824829,237.422485 370.162903,236.577194 
	C371.647430,236.040497 372.463074,233.875381 372.618866,237.640320 
	C372.719238,240.066208 374.390808,236.423798 375.979675,237.019073 
	C376.196991,241.996765 376.074524,247.009048 375.817322,252.389923 
	C373.221283,253.604782 371.583221,251.393692 369.437225,251.335144 
	C369.345337,250.016464 369.945221,249.559647 370.892944,249.593964 
	C371.718567,249.623856 372.668793,249.906876 372.796997,248.720840 
	C372.960327,247.209885 371.796722,247.631210 370.875183,247.345444 
	C368.258148,246.533951 366.016113,244.945023 363.539734,248.175674 
	C362.089874,250.067093 359.515259,249.190201 357.929993,247.372040 
	C356.089325,245.260910 354.466797,244.610046 352.331116,247.067673 
	C348.873230,251.046844 345.315918,246.660538 341.394226,247.002930 
	C340.997589,247.001831 340.680603,246.675797 340.680603,246.675797 
	C340.680603,246.675797 340.720001,246.718750 340.861206,246.858459 
z"/>
<path fill="#FAF4D5" opacity="1.000000" stroke="none" 
	d="
M114.435577,314.825897 
	C114.002472,334.755554 112.292648,354.407562 109.761986,373.991791 
	C109.379135,376.954529 109.144623,379.936493 108.619339,383.289185 
	C106.191788,384.613159 106.812576,386.741425 106.766502,388.313782 
	C106.657272,392.041473 104.962654,395.004303 102.883644,397.825378 
	C99.676613,402.177094 96.075478,401.707581 93.981873,396.736847 
	C93.603546,395.838623 93.666412,394.737579 92.662369,394.018250 
	C90.407143,394.756378 90.524651,397.088593 89.646233,398.730103 
	C88.842926,400.231201 88.139580,401.923767 86.046989,401.487427 
	C83.990585,401.058563 83.887520,399.190063 83.730904,397.529510 
	C83.357880,393.574463 84.227448,389.535400 82.838806,385.241089 
	C82.943367,372.569489 84.274719,360.368805 85.263924,348.155029 
	C86.066795,338.241913 86.855644,328.327271 87.672783,318.014862 
	C88.063934,316.076782 89.625130,314.725342 88.372055,312.602814 
	C88.383476,309.782776 88.452583,307.309021 89.264870,304.578796 
	C93.237633,302.523651 95.508278,305.685852 96.398964,307.841522 
	C98.855240,313.786285 104.412682,314.941986 109.104599,317.467285 
	C111.994347,319.022644 111.787437,314.400116 114.435577,314.825897 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M545.491699,150.265472 
	C545.078674,143.980499 546.599609,138.001663 545.900452,131.474182 
	C543.866089,128.980316 541.095764,128.734390 538.647888,127.815086 
	C532.400513,125.468895 531.697083,123.469330 535.484131,117.214859 
	C539.381958,113.169838 544.310913,114.881912 548.501953,114.363945 
	C578.988220,110.596130 609.310974,105.755745 639.670166,101.147034 
	C640.490417,101.022507 641.327515,101.009087 642.585449,100.955765 
	C643.877625,102.368507 643.217346,103.777245 642.948486,105.530914 
	C642.578125,106.784813 642.195984,107.648239 641.535522,108.763458 
	C640.364197,109.999161 639.245911,110.801178 638.167358,112.134010 
	C637.276306,112.696983 636.611145,112.789230 635.601929,112.573456 
	C634.469971,112.231339 634.017639,110.740288 632.626831,111.972946 
	C631.849548,112.830589 631.255615,113.439774 630.457092,114.313766 
	C627.169739,116.803925 624.986572,119.890274 622.501404,122.680702 
	C620.789185,124.603172 619.210449,125.432869 617.366577,122.465637 
	C617.221863,121.678169 617.262329,121.226974 617.587463,120.504028 
	C618.929199,118.388306 621.354980,117.869888 622.264771,115.723083 
	C621.612976,117.558708 619.393188,117.953888 618.189453,119.802536 
	C615.083374,120.375076 615.083374,120.375076 612.005371,117.431862 
	C611.728760,116.825279 611.144897,117.943886 611.716064,117.600037 
	C611.861389,117.512550 611.945007,117.642838 612.125183,117.858887 
	C612.701782,118.550316 612.760437,119.336914 612.526489,120.488373 
	C611.690369,121.922127 610.382019,122.483376 609.518066,123.902977 
	C608.092102,125.048935 607.201965,126.204704 606.419006,127.868103 
	C604.111328,129.490616 602.277344,131.334808 599.333496,131.818329 
	C598.758911,131.742493 598.534058,131.681396 598.005127,131.449432 
	C596.550903,129.885910 594.890991,128.877991 594.469543,126.611038 
	C594.591309,126.051445 594.683533,125.838509 594.990479,125.352585 
	C596.651855,123.540245 598.455017,122.374237 599.754395,120.553665 
	C597.856384,123.322533 595.564270,123.415611 593.249756,121.399124 
	C590.881165,119.335480 587.747437,121.624046 585.306335,119.898659 
	C585.215820,119.834671 582.158264,120.589233 583.747375,123.055283 
	C584.163025,123.439949 584.322937,123.602745 584.692200,124.038963 
	C585.473755,125.777283 587.327637,127.111603 586.107361,128.788101 
	C584.801147,130.582687 583.154724,129.499268 581.746338,128.553162 
	C580.827393,127.935837 579.958740,127.793884 579.034302,128.535934 
	C575.528381,131.350204 571.869080,133.992157 570.986877,138.903534 
	C570.660034,140.723480 571.995850,141.209641 572.929810,141.982086 
	C574.609009,143.370941 576.600098,144.514816 575.188416,147.508347 
	C574.211121,148.866547 572.856506,149.342148 571.922241,150.745514 
	C571.556946,151.157333 571.401184,151.313919 570.983704,151.673737 
	C569.444153,152.707977 567.989075,153.298325 566.803589,154.824142 
	C566.366882,155.188080 566.173645,155.312836 565.645081,155.528595 
	C562.001709,155.216751 560.177063,152.663422 557.822388,150.301971 
	C555.795776,146.670273 560.769104,145.128860 559.545898,141.737885 
	C556.192566,138.573502 555.704041,138.781143 554.499146,143.794968 
	C553.733704,145.083969 553.107300,146.061584 552.208374,147.290878 
	C550.076721,148.898849 548.928467,151.813248 545.491699,150.265472 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M539.197266,192.612335 
	C538.050903,226.296097 535.489807,259.767365 534.723877,293.833435 
	C531.517944,291.787140 528.631775,289.944977 525.413818,288.003723 
	C523.802307,287.251770 522.305176,287.278351 521.031738,286.606140 
	C520.430847,286.317902 520.909180,287.460083 521.109924,286.824341 
	C521.215576,286.489807 521.273621,286.641174 521.594604,286.915466 
	C521.933960,287.205414 522.453979,287.304871 523.054321,287.855652 
	C524.072083,289.018402 525.329285,290.164062 522.767090,289.982147 
	C519.808350,289.772034 516.869690,289.278107 513.497192,288.914551 
	C511.337891,281.747253 511.811981,274.377533 511.216370,267.105225 
	C510.008392,252.355743 509.129883,237.579269 508.014465,222.405014 
	C507.642578,218.277023 507.371796,214.557968 506.994720,210.415039 
	C506.444794,209.295654 506.516113,208.522079 506.670074,207.388229 
	C506.412598,201.002731 506.034363,194.983292 505.731995,188.507751 
	C506.889923,186.425171 508.417908,185.111923 510.332489,185.753357 
	C512.659851,186.533081 512.463135,188.961914 512.380127,190.878006 
	C512.172363,195.673477 511.652740,200.450424 511.751831,205.266769 
	C511.805023,207.851669 512.104431,210.229584 514.280945,211.970276 
	C516.518860,213.760025 516.481201,216.325928 516.447388,218.809738 
	C516.411621,221.439499 516.982849,223.731842 519.423950,225.716278 
	C519.889404,228.039734 520.098022,230.051468 520.242554,232.492767 
	C520.379639,235.452805 518.873413,238.046036 520.679810,240.767715 
	C521.254333,244.373825 521.607056,247.737823 522.003540,251.530396 
	C523.002380,254.804306 522.191528,257.743988 522.510193,260.311432 
	C522.544556,257.998047 522.455811,255.372040 522.758362,252.353821 
	C523.297363,239.947159 523.637451,227.933929 524.079956,215.468002 
	C525.575500,213.877487 527.318665,213.173782 528.211304,211.417450 
	C528.743286,210.370758 529.745422,209.223663 530.932617,209.593094 
	C536.145508,211.215363 535.258179,207.269394 535.556946,204.592957 
	C535.832336,202.125900 535.457947,199.604996 535.831543,197.135345 
	C536.131897,195.150101 536.548584,193.153778 539.197266,192.612335 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M263.779480,264.337921 
	C264.950653,266.746033 266.403259,268.012787 269.628113,268.228973 
	C278.067749,268.794647 286.678864,269.697632 294.934479,269.413635 
	C302.914490,269.139130 310.790192,269.649628 318.638092,269.441956 
	C324.983093,269.274109 331.866394,269.232452 338.293793,266.717102 
	C341.587952,265.427979 345.682709,265.970428 349.408173,266.047607 
	C355.087341,266.165192 360.751007,266.648651 366.295929,268.048706 
	C370.211334,269.037292 370.454010,272.196167 370.422882,276.043030 
	C373.897827,272.896820 372.533691,269.215149 373.222443,266.082001 
	C373.238770,266.007751 373.527344,265.900360 373.591827,265.945953 
	C373.858704,266.134399 374.088135,266.375854 374.552185,266.784790 
	C374.606720,270.046021 374.440399,273.120300 374.376282,276.595551 
	C374.297821,277.841614 374.117126,278.686676 373.817505,279.834778 
	C371.161163,281.474579 373.158752,283.929382 372.309937,286.136230 
	C372.552216,287.219116 372.814850,287.853302 373.040344,288.772827 
	C371.031250,290.351898 369.491119,289.262268 368.090149,288.043945 
	C365.012543,285.367462 361.408966,284.526825 357.443298,284.622131 
	C339.168030,285.061340 320.887665,283.991272 302.598602,285.357544 
	C294.871277,285.934814 287.039337,284.307434 279.209412,284.596069 
	C273.885101,284.792328 268.289368,283.318146 263.270874,287.324646 
	C261.125732,285.233978 261.502167,282.860291 261.529907,280.606537 
	C261.596039,275.230682 262.055664,269.890167 263.779480,264.337921 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M83.181519,386.057495 
	C86.486717,389.366699 84.370285,393.500000 84.994362,397.296631 
	C85.197449,398.532135 84.529396,400.319916 86.269859,400.659454 
	C88.158150,401.027771 87.938614,398.991547 88.497108,397.927948 
	C88.876625,397.205170 88.882973,396.274170 89.303467,395.587738 
	C90.280487,393.992645 90.250488,391.118134 92.760643,391.297699 
	C95.551628,391.497375 94.848961,394.171722 95.033134,396.060394 
	C95.212914,397.903870 96.194290,399.257599 97.919098,399.730225 
	C99.913887,400.276825 100.710495,398.513397 101.859383,397.329742 
	C105.743423,393.328033 104.573380,387.457672 107.297371,383.055267 
	C107.363235,382.948822 107.580040,382.859619 107.702263,382.883972 
	C107.847099,382.912750 107.965683,383.073547 108.246414,383.423004 
	C107.996941,392.974701 106.626625,402.174438 105.482018,411.913269 
	C105.925270,411.919800 106.205719,411.975189 106.510132,412.863464 
	C106.623016,417.512848 104.709686,421.542847 104.839111,426.206818 
	C104.673592,427.490204 104.407066,428.391785 104.146286,429.650574 
	C103.885071,430.891815 103.511475,431.746643 103.380127,433.016449 
	C103.287857,434.309875 103.166618,435.248779 102.946617,436.545135 
	C102.723167,437.638611 102.446281,438.343811 102.357811,439.491669 
	C102.283188,440.431213 102.212082,440.973602 102.010483,441.932495 
	C100.898109,449.736389 99.482422,457.060272 98.549782,464.452362 
	C98.046494,468.441406 95.960075,470.459625 92.026718,470.489258 
	C88.026772,470.519318 84.119370,471.571442 80.118568,471.464874 
	C76.758026,471.375397 74.824486,470.167480 75.425491,466.252777 
	C77.536591,452.501953 78.219734,438.602264 79.246696,424.752197 
	C80.079544,413.519958 81.015701,402.300049 82.001106,391.082092 
	C82.143913,389.456360 81.678627,387.736176 83.181519,386.057495 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M219.720428,217.264069 
	C218.066132,195.486816 216.046982,173.991013 212.513046,152.678177 
	C211.938370,149.212326 212.454254,148.525482 215.825012,149.595062 
	C220.565994,151.099426 225.372742,152.519226 230.253998,153.417709 
	C233.796432,154.069763 234.617493,155.854263 234.734131,159.102692 
	C235.336563,175.880325 236.009338,192.657394 236.890930,209.422394 
	C237.606522,223.030884 238.652039,236.622040 239.425934,250.614471 
	C235.554703,252.321533 234.681900,249.522781 233.962280,247.010803 
	C233.324463,244.784378 232.953644,242.490814 231.757416,240.458694 
	C230.971481,239.123596 230.102158,237.735016 228.270325,238.687119 
	C224.208725,240.798111 223.496185,238.193741 222.866089,235.274567 
	C222.682663,235.432007 222.185806,235.394791 222.000610,235.228180 
	C221.243698,229.650665 220.672012,224.239746 219.996658,218.412354 
	C219.802979,217.837173 219.712982,217.678482 219.720428,217.264069 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M261.220306,141.170700 
	C260.481018,141.089630 260.076416,140.893051 259.373718,140.535782 
	C257.310455,140.575119 256.277985,139.186890 254.692108,138.229095 
	C253.489929,136.469421 252.365799,135.102142 250.952271,133.965546 
	C250.167572,133.334579 249.462509,132.542114 250.486267,131.558929 
	C254.113083,128.075745 249.865189,129.241425 248.405273,128.609894 
	C246.551285,128.717590 245.027817,128.773590 243.542633,127.525055 
	C243.156219,126.711243 243.084030,126.139824 243.259399,125.300354 
	C243.321976,125.051170 243.356659,124.564278 243.268494,124.804901 
	C243.049149,125.386070 242.858231,125.690628 242.390747,126.133919 
	C241.975372,126.338867 241.793152,126.378922 241.342010,126.363731 
	C240.806366,126.087044 240.584610,125.832199 240.439850,125.289429 
	C240.408691,125.081749 240.558441,124.748299 240.374374,124.692825 
	C240.190308,124.637344 239.775116,124.684425 239.549088,124.683838 
	C239.323059,124.683258 238.842682,124.648323 238.592377,124.635666 
	C237.794235,124.623245 237.255173,124.696350 236.413010,124.880997 
	C234.102783,125.463814 232.101837,123.970947 229.805267,125.090302 
	C229.301392,125.298241 229.092712,125.358910 228.561905,125.412018 
	C227.116562,124.840500 225.801636,124.786850 224.552505,123.804550 
	C223.816696,120.540504 225.370743,119.282440 228.089645,119.158020 
	C229.497955,119.093590 231.032837,119.762047 232.300995,117.918930 
	C232.987106,117.421310 233.423325,117.206284 234.232849,116.915787 
	C235.316727,116.626770 236.049469,116.460243 237.118835,116.049332 
	C237.744339,115.847610 238.000671,115.776627 238.654068,115.631050 
	C259.140686,111.923332 279.139526,107.802734 299.449402,105.409904 
	C308.824066,104.305428 318.086609,102.251701 327.944519,101.574974 
	C329.434357,101.550705 330.516388,101.562645 331.927979,101.033600 
	C335.973633,100.384987 339.573242,99.364357 343.695221,99.565384 
	C346.128082,99.533661 348.188782,100.171394 350.560181,99.429771 
	C352.576141,98.350822 354.406616,98.478317 356.583984,98.666367 
	C357.603577,98.673347 358.282837,98.678299 359.300354,98.577187 
	C360.317810,98.388260 360.982117,98.189087 362.001892,97.958717 
	C363.984924,97.659431 365.622375,97.637794 367.580322,97.989471 
	C368.431610,98.202583 368.851807,98.880959 369.763977,98.219543 
	C372.062775,96.528572 374.175446,98.365379 376.539490,97.836166 
	C377.236633,97.644341 377.625275,97.506371 378.289520,97.212799 
	C379.188812,96.804024 379.788849,96.793610 380.586365,97.420082 
	C381.433624,98.558060 381.789978,99.520027 381.195984,100.870270 
	C380.998566,101.664948 379.894196,100.665756 380.354675,101.937424 
	C380.545746,102.392509 380.587585,102.589241 380.599579,103.087463 
	C380.482697,103.571205 380.395660,103.753456 380.060669,104.109558 
	C379.183136,104.366074 378.622955,104.153748 377.802704,103.769363 
	C373.638306,105.224464 370.164001,108.155617 365.514008,107.248039 
	C365.185516,107.183922 364.816284,108.174156 364.957611,108.348450 
	C368.433533,112.634506 368.444092,112.625946 362.538269,114.945938 
	C359.874268,115.580460 357.717041,115.760345 355.935242,113.572739 
	C354.249084,111.502533 351.596405,113.730232 349.922760,112.721100 
	C345.907928,110.300385 343.709412,112.658722 341.103394,115.112129 
	C337.407562,118.591515 338.023438,113.318146 336.082336,112.379517 
	C330.263885,108.200584 323.148560,110.629807 320.538696,117.581909 
	C319.865875,118.213470 319.337402,118.346420 318.506042,118.057785 
	C318.267914,117.995430 317.790741,118.102646 317.567627,118.219254 
	C317.198181,118.430740 317.051910,118.525620 316.672363,118.754639 
	C315.932037,119.146370 315.401917,119.334602 314.534027,119.388268 
	C314.056335,119.236229 313.882568,119.116997 313.585449,118.697235 
	C313.245148,116.795387 314.900177,116.162193 315.471558,114.606247 
	C315.877502,114.062263 316.117737,113.803841 316.384857,113.570808 
	C316.649506,114.182693 316.554596,113.418602 315.862000,114.106522 
	C314.713959,115.844696 312.869141,116.695702 312.329407,118.921646 
	C311.869965,119.242020 311.640900,119.295227 311.077332,119.235504 
	C306.318298,113.363182 304.814117,113.154572 298.679871,117.339073 
	C297.177032,118.364243 295.421143,118.925308 293.807861,119.759392 
	C290.478790,121.480515 288.344879,119.531067 286.345520,116.267029 
	C283.971039,122.487083 278.455780,124.680176 274.461395,128.455154 
	C272.041077,130.742523 269.522552,132.821503 267.960815,136.238922 
	C265.933655,138.363297 263.357727,139.176559 261.220306,141.170700 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M359.380432,169.002670 
	C359.537689,173.423782 354.974579,170.486343 353.933136,172.776657 
	C353.430359,170.378555 353.860046,168.487625 355.768097,167.155350 
	C356.997986,166.296585 358.829590,165.328781 357.421783,163.786301 
	C356.160339,162.404175 355.284119,164.510971 354.318878,165.202209 
	C353.534302,165.764038 353.015106,166.756805 351.834412,166.597702 
	C349.467651,164.652283 356.531464,163.281952 351.952332,160.317093 
	C349.935760,159.011414 347.476196,159.328537 345.698883,157.493683 
	C347.279144,160.492798 342.914948,163.307999 345.740692,166.312042 
	C345.874573,166.454361 345.536987,167.249619 345.232117,167.553009 
	C344.524780,168.256882 337.032166,167.014694 336.311890,166.268204 
	C335.460022,165.385300 335.182800,164.608765 336.350220,163.876877 
	C339.727905,161.759293 337.999451,159.210770 337.000183,156.355804 
	C338.791473,154.625870 338.531952,151.150925 342.126282,151.415466 
	C343.382050,152.253326 344.140656,153.647263 345.823639,152.170258 
	C346.464386,151.545746 346.961304,151.290939 347.819031,151.382080 
	C348.209961,151.554825 348.353790,151.648849 348.309021,151.549316 
	C347.223633,150.748123 346.661072,151.355225 345.846710,152.142365 
	C345.011719,152.744125 344.380096,152.780396 343.451691,152.379211 
	C338.721313,148.905777 339.036041,153.841934 337.229370,155.759338 
	C334.894928,156.348541 333.198578,157.152084 333.505219,159.700516 
	C333.629639,160.734589 335.871918,161.882217 333.694763,162.696915 
	C332.141113,163.278290 331.344574,161.231888 330.212311,160.405228 
	C328.535156,159.180695 329.897919,158.384827 330.891815,157.415573 
	C332.630096,155.720383 334.235657,153.865067 335.690308,151.922211 
	C336.002777,151.504929 335.436829,150.429962 335.125610,149.344360 
	C335.095764,148.388672 334.899933,147.854141 334.208191,147.202164 
	C333.990906,146.989868 333.993622,146.494614 333.996216,146.247009 
	C334.368561,145.647614 334.707550,145.265778 335.223755,144.778122 
	C335.379913,144.651703 335.585175,144.414032 335.401428,144.451706 
	C334.904785,144.837997 334.690765,145.260391 334.190918,145.805817 
	C331.608032,145.779785 330.803986,147.035980 331.003174,149.611237 
	C329.506805,148.924255 326.651062,152.875397 325.996948,148.285294 
	C325.384796,147.263931 324.614075,147.004257 323.434998,146.924286 
	C322.722107,146.747177 322.347015,146.563141 321.760864,146.124878 
	C321.237305,145.627350 320.951752,145.330521 320.432556,144.835693 
	C319.688354,144.272278 319.150421,143.955933 318.263611,143.581543 
	C316.683258,142.818298 315.358521,142.225967 315.683594,140.105042 
	C316.198883,139.469391 316.609406,139.244339 317.420319,139.082245 
	C320.915924,139.547867 324.312561,138.829407 327.298767,141.222382 
	C327.602905,141.905899 327.698273,142.314026 327.675964,143.023926 
	C327.492249,143.606171 327.367554,143.911469 327.478516,144.179718 
	C327.989075,144.038773 328.292053,143.990555 328.817627,143.992584 
	C329.245758,143.927399 329.352173,143.893280 329.352173,143.893280 
	C329.265747,143.618668 329.089386,143.413162 328.619568,143.030502 
	C328.326019,142.577255 328.236023,142.370255 328.083740,141.816833 
	C328.403503,137.762405 329.944244,136.285645 333.760834,138.856583 
	C339.780548,141.568375 342.271698,140.403931 343.785950,134.370209 
	C355.353119,132.427307 366.703003,130.783539 378.034607,129.022308 
	C380.533051,128.633987 381.127167,129.350632 380.969788,131.857361 
	C380.273529,142.949173 379.781982,154.053925 379.230499,165.154694 
	C379.131958,167.139114 379.100311,169.126862 378.902496,171.567719 
	C377.651672,171.728210 375.957397,170.820663 375.514038,171.238983 
	C372.527466,174.056686 370.424255,172.156845 368.650879,170.018478 
	C365.911224,166.715103 362.902740,167.899582 359.380432,169.002670 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M663.997314,76.174210 
	C661.599854,79.438683 656.966980,79.672775 655.147522,83.668282 
	C652.740173,79.326553 650.061707,78.493492 641.893127,79.385391 
	C641.854614,81.074341 644.084351,82.724815 642.341125,84.362808 
	C640.922974,85.695297 639.786560,84.345009 638.464417,83.596268 
	C636.854614,82.684654 635.064392,84.398720 632.862793,83.273384 
	C630.902405,82.271317 629.358887,84.998428 628.266357,87.610817 
	C629.819214,81.327484 625.148987,84.508560 623.485474,83.938828 
	C618.053406,82.078400 612.635071,82.898521 607.262451,85.799973 
	C606.950684,84.994591 606.606262,84.537308 605.463806,84.688835 
	C601.426331,85.224342 597.164062,84.561142 593.340332,85.343666 
	C586.033691,86.838951 578.673645,87.669083 571.307129,88.131355 
	C569.210754,88.262901 568.372559,92.691330 565.039734,89.301102 
	C563.568054,87.804108 559.307556,89.048790 556.090576,89.048790 
	C558.554993,91.560013 557.267517,92.121109 554.359009,91.996918 
	C553.827026,91.208260 553.926941,90.013962 553.451538,89.704956 
	C550.890381,88.040344 540.941101,90.077850 539.033936,92.586967 
	C538.080688,88.958801 535.391785,89.944023 533.015869,90.177368 
	C531.966736,91.620758 534.658081,91.538742 533.982971,93.008514 
	C531.224243,99.014931 531.937134,101.607323 538.031189,105.805786 
	C541.125183,107.937370 536.988464,109.483292 538.003479,111.647758 
	C536.180664,112.129204 536.723877,110.005966 535.291504,109.396667 
	C529.699646,104.363777 524.347046,99.474419 519.160645,93.950996 
	C518.763428,93.592361 518.588257,93.466949 518.134888,93.175919 
	C513.084839,91.761070 508.278625,91.158859 503.091187,92.152649 
	C502.328125,91.871231 502.117310,91.193283 501.198120,91.395653 
	C500.757263,91.437111 500.578369,91.426628 500.146667,91.324982 
	C498.440186,89.416351 496.986572,87.598885 495.334900,85.529938 
	C497.571686,82.935188 500.781036,83.673584 503.583252,83.533371 
	C512.145935,83.104942 520.515808,81.714096 528.918457,80.100365 
	C535.082642,78.916519 541.524902,78.904045 547.769348,78.929451 
	C558.601746,78.973541 569.269470,77.492760 580.019531,76.891243 
	C598.532959,75.855347 617.052246,75.084007 635.606689,74.837021 
	C645.069641,74.711060 654.454285,74.570076 663.997314,76.174210 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M224.571198,382.803345 
	C224.609116,386.750122 224.321915,390.458557 223.973511,394.582275 
	C223.605774,395.313019 223.263992,395.583710 222.582916,395.918060 
	C221.283203,396.258942 220.266998,396.379578 218.998260,396.570251 
	C218.737122,396.590546 218.275330,396.542633 218.064529,396.534729 
	C217.853729,396.526855 217.517075,396.317444 217.676361,396.453094 
	C217.835632,396.588745 218.284393,396.686737 218.525360,396.733582 
	C219.702530,396.764343 220.635971,396.809418 221.875534,396.959229 
	C222.595535,397.127838 222.969788,397.319977 223.518707,397.822205 
	C223.724258,398.070496 223.924408,398.172455 223.993500,398.083923 
	C225.202087,399.423340 224.846786,400.859985 223.873901,402.609009 
	C223.478928,403.087006 223.297577,403.254913 222.791016,403.590454 
	C221.785782,403.984528 221.086365,404.041229 220.048706,403.959717 
	C218.907654,403.769196 218.096573,403.558899 216.964417,403.884186 
	C215.847137,404.267212 215.014938,404.484802 213.806213,404.382538 
	C209.886703,403.733673 206.335510,404.290283 202.447052,404.772949 
	C201.443695,404.983856 200.766464,405.011749 199.757629,404.935669 
	C197.808472,404.574341 196.169739,403.948059 194.350830,405.322998 
	C193.647949,405.597260 193.223114,405.640869 192.485321,405.502563 
	C191.229950,404.504181 190.147202,404.110138 188.551331,404.597351 
	C187.272247,404.789307 186.270554,404.862549 185.406433,406.015686 
	C184.989639,406.357513 184.795044,406.464142 184.266235,406.645416 
	C183.697891,406.719391 183.463760,406.718658 182.877975,406.653992 
	C180.806183,406.079865 179.350708,405.230804 178.466064,403.141663 
	C178.292282,402.257416 178.349533,401.751678 178.749939,400.942322 
	C179.404770,400.321320 179.878510,400.132568 180.777008,400.008392 
	C183.083221,399.350311 185.143997,399.749817 187.428162,399.118164 
	C188.883438,398.990082 189.988190,399.010773 191.092468,399.003906 
	C189.878387,398.998749 188.663986,398.971161 187.099014,399.118835 
	C185.055878,399.658173 183.266739,399.260223 181.202728,399.836945 
	C178.516464,400.050964 176.226135,400.591492 173.522919,400.216736 
	C171.991516,399.955261 170.829147,399.738525 169.295166,400.019714 
	C168.488708,400.144836 168.025436,400.195129 167.212433,400.253235 
	C165.052994,400.392609 163.141907,400.006165 161.252045,401.514038 
	C160.699783,401.788605 160.467072,401.881439 159.865082,402.071228 
	C155.584503,402.151031 151.718292,403.575317 147.366562,402.514618 
	C141.923660,403.314972 136.848007,402.900085 131.376785,403.005585 
	C129.606491,403.035828 128.305267,403.428680 126.591049,403.727478 
	C125.428482,403.957275 124.642815,403.969910 123.471008,403.912354 
	C122.839233,403.811279 122.591949,403.746765 121.973221,403.597046 
	C119.084564,403.644501 116.721046,404.569885 113.875931,404.981873 
	C113.502495,405.026367 113.062790,405.040619 113.062790,405.040619 
	C113.062790,405.040619 112.622879,405.035522 112.403160,405.025330 
	C111.215462,404.913086 110.353271,404.591980 109.443665,403.588409 
	C109.125969,402.161865 109.073456,400.966888 109.044876,399.323547 
	C110.688187,397.633423 112.555176,398.358032 114.683075,398.241760 
	C114.977798,398.263214 114.231468,397.401215 114.378517,398.051453 
	C113.042412,398.346405 111.781761,398.052155 110.291481,397.334686 
	C109.751541,395.514648 109.293915,393.918579 110.178131,391.994080 
	C112.725410,390.708832 115.448524,391.452698 117.943527,390.157867 
	C119.792847,388.834930 121.568878,387.615143 124.074890,389.084167 
	C130.309311,391.305756 136.176498,389.055054 141.994171,388.696777 
	C148.829407,388.275818 155.669571,387.020752 162.924927,386.161499 
	C168.630234,384.999969 174.036255,386.750702 179.669708,385.234436 
	C180.058563,380.156372 182.543228,383.172363 184.539276,383.804993 
	C186.851227,385.568237 188.985367,384.149963 190.907104,383.885406 
	C196.162720,383.162018 201.532242,383.845917 206.846649,382.149658 
	C209.898758,378.798737 213.305313,381.782227 216.835846,381.106079 
	C216.178955,383.482117 214.315567,382.090424 213.127029,382.382843 
	C216.539963,383.198364 220.473541,380.908386 224.571198,382.803345 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M222.176605,237.206757 
	C222.540695,235.534515 222.829910,234.457809 223.192490,233.108047 
	C224.378265,234.134613 223.815292,235.338623 224.077026,236.304230 
	C224.577789,238.151596 225.240677,239.715683 227.244186,237.496033 
	C229.395187,235.112976 230.971039,235.930450 232.151672,238.387756 
	C233.355331,240.892944 235.121216,243.178207 235.032639,246.203812 
	C234.960556,248.665497 236.557434,250.036865 238.966766,250.985748 
	C239.757111,255.394272 240.213577,259.780487 240.608673,264.572113 
	C240.291214,265.476746 240.143982,265.987610 240.512787,266.779114 
	C241.430954,278.036713 242.216324,289.054657 243.077560,300.527527 
	C244.468216,303.048035 244.370972,305.297760 244.007843,307.957123 
	C243.684189,311.823181 244.505890,315.259796 244.621399,319.083710 
	C244.750763,324.865326 244.750763,330.299011 244.750763,335.732697 
	C244.393097,331.938477 243.646774,328.402771 240.543488,325.649506 
	C239.469193,324.696381 239.921585,322.849731 240.355423,321.377533 
	C241.447342,317.672089 239.955521,316.162079 236.208344,316.388000 
	C231.178528,316.691193 229.446060,315.216064 230.474182,310.465820 
	C231.160233,307.295959 229.752869,306.669830 227.123917,306.019287 
	C224.312668,302.877747 226.026352,299.267395 225.579880,295.489441 
	C225.430725,291.300385 225.228714,287.546600 224.934753,283.402283 
	C222.849518,280.457703 223.327332,277.322479 222.994522,274.436829 
	C222.126663,266.912354 222.144272,259.342621 222.719742,251.387024 
	C222.684784,246.598633 222.393265,242.200455 222.176605,237.206757 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M539.628113,192.525421 
	C537.135376,194.167572 537.006348,196.468307 536.981079,198.866196 
	C536.947754,202.022980 537.190674,205.254181 536.587158,208.309647 
	C536.145142,210.547180 536.025391,215.276978 531.509827,210.853073 
	C530.116821,209.488327 529.359497,211.383331 528.981140,212.631439 
	C528.343262,214.735489 527.548645,216.480438 524.517456,215.057739 
	C525.266846,192.782928 526.310730,170.548447 527.458862,148.319336 
	C527.844238,140.856598 528.494995,133.407547 529.030029,125.509552 
	C530.032349,124.148506 531.256531,124.175919 532.231506,124.803070 
	C535.959473,127.200958 540.691772,127.348457 544.202026,130.624420 
	C542.826355,149.740234 541.433655,168.457214 539.922974,187.596939 
	C539.180908,188.786682 538.943909,189.632187 539.432251,190.907211 
	C539.635498,191.573257 539.689575,191.926590 539.628113,192.525421 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M45.446091,241.308777 
	C42.626183,223.774399 41.841476,206.286148 38.222610,189.187317 
	C37.705677,186.744843 38.777367,186.564270 40.571362,187.171219 
	C46.869358,189.301956 53.226322,191.235977 59.767300,192.444763 
	C62.491062,192.948120 61.947311,194.899582 62.033913,196.620331 
	C62.878189,213.395676 63.703842,230.171921 64.431915,247.398560 
	C63.965981,250.125046 63.732117,252.408356 63.820271,254.719879 
	C63.876606,256.197113 63.381088,257.365814 61.725365,257.529877 
	C60.100628,257.690887 59.366821,256.593567 58.944008,255.245865 
	C58.349586,253.351166 58.156818,251.368576 57.740154,249.435059 
	C57.368736,247.711533 57.579769,245.765427 55.751766,244.216599 
	C53.403053,246.119141 53.005814,248.882614 52.317684,251.520294 
	C51.657829,254.049561 50.787930,256.412079 47.021145,255.212265 
	C46.496170,253.728500 46.286255,252.459686 46.311081,250.871613 
	C47.093761,247.483414 46.559265,244.525131 45.446091,241.308777 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M46.625278,255.456894 
	C49.525631,255.186203 51.201172,254.111237 50.988506,251.042740 
	C50.842182,248.931473 51.778728,247.161255 52.813587,245.482895 
	C53.772377,243.927948 53.845154,240.930847 56.436283,241.555420 
	C58.519398,242.057541 58.456554,244.769135 58.875671,246.624222 
	C59.452206,249.176025 59.666565,251.810989 60.007080,254.414108 
	C60.135033,255.392303 60.074169,256.607574 61.377251,256.664886 
	C63.082973,256.739899 62.868690,255.285645 62.990746,254.175491 
	C63.203636,252.239151 62.492500,250.196945 63.992310,248.109314 
	C65.047058,259.460541 65.903160,271.065430 66.447716,282.684875 
	C67.109901,296.814362 67.509605,310.956146 67.924721,325.553253 
	C63.086235,323.337830 61.530064,318.516541 60.060749,313.843964 
	C58.446629,308.710907 55.554287,305.215424 49.822769,303.904419 
	C49.327003,303.090820 49.240082,302.315918 49.248482,301.261047 
	C50.168587,298.855682 50.508530,296.710388 49.386314,294.262756 
	C48.290558,281.313019 47.417519,268.614746 46.625278,255.456894 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M247.074341,271.224335 
	C247.578705,255.551605 248.308441,240.107544 249.196732,224.672638 
	C250.419952,203.417389 251.770203,182.169464 253.044891,160.917145 
	C253.188400,158.524582 252.891373,155.818176 256.995605,157.551117 
	C256.451935,162.063416 255.758804,166.162170 256.693451,170.553543 
	C257.487427,174.283859 255.095963,177.853531 254.718201,181.643814 
	C254.832108,181.739349 255.019028,181.599838 255.349640,181.332565 
	C261.758209,176.152161 261.761932,176.153336 266.629486,182.815414 
	C267.213898,183.615234 268.087311,184.155731 268.752808,185.378586 
	C269.102020,194.160873 267.881500,202.487900 266.912811,210.827957 
	C266.762604,212.121155 266.566711,213.441956 266.240967,215.118866 
	C265.906616,216.167404 265.481506,216.791183 265.706238,217.903076 
	C265.919495,218.958252 265.915039,219.666992 265.670990,220.711700 
	C264.198639,222.846054 264.137787,224.815399 264.858398,227.239044 
	C264.972565,228.356308 264.863464,229.089157 264.376465,230.117126 
	C259.900055,232.413269 259.900055,232.413269 257.485840,228.046127 
	C257.699768,234.318924 256.990417,239.484024 253.316803,244.430420 
	C250.987534,247.566666 252.092422,252.464355 253.207932,256.512512 
	C254.436340,260.970337 252.816940,265.021790 251.576492,269.098663 
	C251.015915,270.941132 249.640778,272.223358 247.074341,271.224335 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M46.609177,397.281799 
	C49.102417,398.723389 47.024826,402.778168 50.505322,403.968475 
	C55.093330,405.537537 59.940956,405.226410 64.653091,405.848511 
	C67.383759,406.209015 67.178444,404.020996 66.399460,402.059723 
	C64.248711,396.644836 67.986259,391.166229 73.667030,391.405151 
	C75.154068,391.467682 75.545464,392.792267 75.733673,393.848969 
	C76.101479,395.914032 76.913300,397.252441 79.665298,397.200195 
	C81.793892,400.214996 81.115242,403.431671 80.820503,406.484161 
	C79.631416,418.798676 79.107620,431.162292 77.872635,443.914337 
	C77.529381,445.249542 76.918716,445.829956 75.649841,446.222900 
	C73.907959,445.443085 73.844841,444.065033 73.648834,442.366211 
	C73.457886,440.214752 73.519493,438.325806 71.137825,437.325378 
	C69.248703,436.822662 68.002983,436.004852 67.024086,434.237488 
	C64.531685,425.171783 64.516891,425.300934 55.444061,424.261566 
	C51.671501,423.829346 47.852516,423.733887 43.755772,422.751221 
	C43.205357,422.358795 43.020485,422.155182 42.963043,421.559265 
	C44.194027,413.320496 45.297588,405.474060 46.609177,397.281799 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M313.676300,118.969528 
	C314.009979,119.016434 314.503235,119.007576 314.749786,119.000946 
	C315.454498,118.592720 316.132324,118.823120 316.794861,118.224731 
	C316.993500,118.011322 317.000488,117.999611 317.005249,117.994537 
	C317.449677,117.572586 317.503174,116.993446 317.826111,116.229645 
	C318.317047,116.473732 318.636505,116.943626 318.982269,117.710281 
	C321.285370,118.242798 322.778198,116.881233 324.447418,115.608337 
	C326.759003,113.845604 329.320282,112.607399 331.990662,115.513336 
	C332.644592,115.139259 333.034241,114.935745 333.771118,114.647438 
	C334.347321,114.549370 334.585907,114.554283 335.160889,114.691452 
	C335.889954,115.106956 336.232025,115.441071 336.674103,116.155464 
	C337.855377,123.200645 341.628784,125.495918 348.497345,124.541985 
	C353.325348,123.871452 358.344940,124.547630 363.276550,122.110977 
	C367.080444,121.427505 370.502350,120.740524 373.940155,120.161293 
	C376.720551,119.692818 379.603577,119.381142 381.761169,122.234451 
	C382.129059,125.220032 381.441467,126.527054 378.450500,126.862770 
	C341.150970,131.049530 304.070801,136.817245 266.982666,142.522644 
	C265.028198,142.823318 263.031128,143.302750 261.059143,141.614899 
	C261.717896,138.462585 263.546021,136.813919 266.760681,136.257660 
	C271.818787,134.460434 276.597290,132.882904 281.815002,133.673584 
	C284.304871,134.050903 286.296143,133.599503 284.734772,130.202744 
	C284.088287,128.796280 284.022064,127.150742 285.629303,126.223503 
	C287.337921,125.237762 288.348480,126.778275 289.496460,127.627823 
	C290.028625,128.021652 290.359192,128.684387 290.890839,129.040024 
	C292.160065,129.889053 291.733276,132.554810 292.641022,132.342590 
	C295.542389,131.664322 299.029816,132.915161 301.356262,129.705185 
	C301.427521,129.136398 301.473480,128.909897 301.675110,128.371338 
	C304.674957,125.518158 306.930756,129.500595 309.928467,128.699402 
	C309.723938,126.848198 308.044952,126.280396 306.963928,125.286140 
	C305.006653,123.485916 304.153931,121.629036 306.728699,119.306488 
	C307.255310,119.092926 307.472900,119.029114 308.023376,118.908859 
	C309.023041,118.780632 309.687622,118.785927 310.673950,118.958496 
	C311.166046,119.005898 311.332855,119.005562 311.749817,119.001930 
	C312.445129,118.930939 312.892548,118.903435 313.676300,118.969528 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M246.610840,271.369232 
	C249.582977,271.280212 250.267105,269.476746 251.019943,267.216583 
	C252.733810,262.071106 251.481461,257.057434 251.108521,251.937256 
	C250.789413,247.556259 249.879211,242.946915 254.876465,239.600906 
	C257.328125,237.959320 255.852936,233.979340 255.962921,231.052292 
	C256.059265,228.488708 256.005096,226.017487 259.800049,225.752106 
	C260.220978,227.856827 257.791718,232.809647 263.847778,230.016922 
	C266.443787,235.675278 264.546448,241.461777 264.188538,247.100616 
	C263.370239,259.993744 262.411285,272.891876 261.306549,285.763092 
	C260.544769,294.638733 260.947296,303.679962 258.179993,312.697906 
	C255.973938,312.044769 253.379608,311.655762 253.120224,309.117950 
	C252.615356,304.178162 249.427536,304.455292 245.547333,305.006226 
	C244.377899,304.409332 244.217087,303.612000 244.617523,302.320251 
	C245.361908,291.875671 245.902664,281.811279 246.610840,271.369232 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M377.814697,205.590683 
	C373.355377,206.921875 372.145386,211.042511 369.341980,213.941986 
	C368.716095,212.041214 370.679443,209.990250 367.584381,208.084045 
	C365.655762,206.896286 365.459534,205.217026 363.552216,208.084610 
	C362.055542,210.334915 360.073792,208.297592 358.459534,207.218765 
	C356.733093,206.064926 357.282562,204.766846 358.681152,204.257858 
	C360.243164,203.689377 359.726715,199.393555 362.852448,201.942627 
	C363.726959,202.655807 364.416229,204.767471 365.712463,202.737595 
	C366.564453,201.403351 365.550842,200.300797 364.042175,199.790771 
	C363.657898,199.660843 363.426880,199.077591 363.061523,198.351929 
	C363.189941,197.813614 363.380737,197.624390 363.569946,197.433578 
	C363.759674,197.242218 363.694977,197.303848 363.187347,197.810150 
	C360.945282,197.879990 359.851196,200.296829 357.364532,199.998199 
	C356.215637,199.041824 356.625061,198.194244 357.673798,196.759613 
	C354.332123,198.531738 351.672485,200.994919 348.132721,198.886505 
	C347.458893,198.485153 346.745056,199.539368 345.861694,200.271851 
	C344.891083,201.091766 344.166260,201.664276 343.135376,202.403183 
	C342.669983,202.613983 342.428253,202.747070 342.360077,202.686096 
	C339.433716,200.068466 334.818726,200.553802 332.275940,198.069016 
	C329.374084,195.233353 326.417877,196.165756 324.571777,197.561264 
	C320.660339,200.517944 317.598053,199.495255 313.930481,197.027359 
	C313.419067,196.751602 313.224762,196.623093 312.798767,196.233795 
	C312.238312,195.351486 312.136017,194.684448 312.204346,193.671539 
	C312.522369,192.345322 312.118591,191.540314 311.334595,190.793884 
	C311.701019,191.361053 311.636719,192.029099 311.318665,193.004593 
	C310.446014,193.941666 309.569580,194.255341 308.352051,194.680450 
	C307.287109,194.938843 306.567444,194.940781 305.515503,194.641296 
	C305.005646,194.348328 304.828583,194.192474 304.496277,193.724457 
	C303.884277,192.099899 304.802948,190.857880 304.353760,189.310638 
	C304.032104,188.913300 303.894989,188.760666 303.541077,188.389694 
	C302.873138,187.757599 302.420410,187.345917 301.591644,186.931915 
	C301.138672,186.700424 300.959900,186.606003 300.517944,186.371735 
	C299.908142,186.050720 299.543427,185.923584 298.577667,185.931396 
	C293.919952,182.141327 299.084351,181.878296 300.926025,180.199829 
	C302.255371,181.113892 303.108185,181.705139 304.534515,182.573761 
	C306.400391,189.683640 308.757782,183.924408 310.528442,183.290207 
	C311.409454,182.974640 311.329041,180.213165 313.199829,182.007004 
	C314.444336,183.200302 314.045074,184.378586 312.385132,185.056442 
	C311.037964,185.606522 311.088379,186.715240 312.091522,187.287094 
	C313.724609,188.218048 315.612457,191.041321 317.105194,189.468628 
	C319.540955,186.902374 321.151031,187.346573 323.786896,188.774048 
	C325.181976,189.529572 327.322998,188.907761 329.177765,188.907761 
	C329.570923,185.617020 325.557312,185.433472 325.421600,182.369583 
	C330.039978,182.875122 331.469269,188.871948 336.487762,188.801483 
	C336.331268,186.653137 332.611481,186.144791 334.317017,184.273788 
	C336.233612,182.171249 339.780609,178.925522 341.190277,179.526550 
	C344.318817,180.860413 348.120758,179.231613 350.697540,182.076782 
	C351.751404,183.240448 355.055542,183.093613 352.347992,186.072891 
	C351.498779,187.007339 353.664978,189.266129 354.117706,188.406738 
	C356.939880,183.049789 358.219147,189.553055 360.627838,188.989487 
	C361.041840,185.071716 365.296509,184.320465 366.764984,181.434372 
	C366.996460,180.979477 368.026215,181.002670 368.483246,181.668076 
	C369.224274,182.746964 368.235626,183.341949 367.843079,184.204254 
	C367.088959,185.860657 364.015869,186.521439 366.742249,189.800339 
	C368.975311,192.485901 372.526398,186.287094 373.186005,191.716248 
	C373.518555,194.453232 374.660034,197.133408 377.484802,198.936920 
	C377.850128,201.058945 377.881653,203.109985 377.814697,205.590683 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M87.054382,314.992737 
	C84.024460,315.678375 85.567184,319.964813 81.796814,319.766571 
	C82.875214,312.351227 77.379814,305.501129 79.956985,296.615570 
	C76.917000,299.330139 76.745331,302.936035 73.258850,303.962097 
	C74.087570,286.417725 75.272186,268.837372 76.461273,251.257309 
	C76.696983,247.772369 76.949875,244.288589 77.306000,240.416229 
	C79.371696,239.083221 79.689125,240.720551 80.093117,241.869370 
	C81.106392,244.750809 82.566147,244.560516 84.396538,242.665314 
	C85.085182,241.952271 85.753304,241.216980 86.661163,240.766739 
	C87.601189,240.300522 88.583939,240.152756 89.487633,240.749466 
	C90.521698,241.432281 90.230888,242.491989 89.991173,243.437408 
	C89.585854,245.035934 88.895332,246.542480 88.500534,248.156555 
	C87.528069,252.132248 87.693359,255.697998 91.767731,258.507324 
	C93.554344,265.159058 91.806702,271.381226 91.307137,277.584137 
	C90.605568,286.295258 90.680092,295.090942 88.810440,304.078735 
	C86.670097,306.147247 85.032272,307.926392 87.521500,310.876740 
	C88.025673,312.425659 88.118958,313.632904 87.054382,314.992737 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M519.742798,225.608444 
	C516.325867,226.311951 514.923645,224.890305 514.933228,221.416183 
	C514.942749,217.961761 515.255432,215.046127 511.743469,211.681885 
	C508.173462,208.262039 509.878174,201.433044 510.571045,196.129517 
	C510.984070,192.967804 510.840729,189.929993 510.926208,186.920090 
	C508.921539,186.169174 508.148529,188.467743 506.186584,188.028778 
	C505.007294,178.636307 504.210327,169.220657 503.405243,159.805695 
	C502.300812,146.890808 501.154236,133.979355 500.112457,121.059448 
	C499.903229,118.464943 500.082214,115.839134 500.082214,113.136826 
	C507.729004,116.274261 509.861511,121.656403 510.393158,129.917023 
	C512.153992,157.275711 515.109924,184.561691 518.420959,211.793228 
	C518.962708,216.248672 519.347473,220.723175 519.742798,225.608444 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M113.734085,212.879761 
	C115.469650,228.396927 115.301140,243.871490 115.544212,259.690643 
	C114.697853,262.258575 114.468918,264.515350 114.458397,266.840912 
	C114.441261,270.632355 112.058891,273.138275 108.622932,271.766479 
	C103.571556,269.749725 98.969490,271.244873 93.773857,271.673737 
	C93.146606,271.415222 92.914917,271.259888 92.469292,270.737061 
	C91.442001,261.212921 93.325218,252.216904 94.120232,243.175644 
	C94.651840,237.129913 94.960930,230.987167 96.699265,224.725769 
	C97.194206,224.186020 97.659927,223.829254 97.751945,223.922760 
	C101.949539,228.188309 105.717766,223.571442 109.665009,223.260956 
	C111.772057,223.095200 111.474792,220.834503 111.646164,219.202057 
	C111.880257,216.972168 111.077049,214.445755 113.734085,212.879761 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M91.974075,257.621643 
	C87.166496,258.100769 85.849266,255.934143 86.554634,251.658722 
	C87.124115,248.206894 87.697960,244.819504 89.552429,241.716202 
	C87.244987,240.386078 86.023483,242.034836 85.526764,243.368866 
	C84.626854,245.785782 83.103256,246.293030 80.895576,245.922562 
	C78.407593,245.505066 79.275490,243.456512 78.945518,241.961426 
	C78.814224,241.366562 78.386658,240.837082 77.755569,240.153015 
	C78.463791,225.227844 79.510422,210.427490 80.758995,195.258011 
	C81.449196,194.541183 81.982872,194.289993 83.004601,194.099274 
	C85.405792,194.440308 87.341599,194.889374 89.274147,195.404846 
	C98.587601,197.889099 99.224586,198.072037 98.276001,207.008438 
	C96.561119,223.163849 95.074974,239.348938 92.948563,255.460541 
	C92.860168,256.130341 92.675018,256.757843 91.974075,257.621643 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M222.616959,250.999298 
	C223.643494,261.369751 224.310669,271.742676 224.910309,282.563721 
	C222.427933,284.046906 221.842468,289.069489 217.336029,286.145325 
	C214.649628,284.492096 214.527115,284.408112 213.194824,286.351593 
	C212.419907,287.482025 211.492950,286.712372 210.370972,287.001343 
	C209.920547,288.239685 207.372742,286.583313 207.927612,288.855774 
	C208.229187,290.090820 209.196411,288.875305 209.746323,289.787964 
	C209.996140,290.207184 209.986771,290.395477 209.957123,290.865784 
	C209.210312,291.934998 209.548782,293.300842 208.134354,293.955933 
	C207.443787,294.020355 207.068176,294.014191 206.411102,293.995667 
	C205.362076,294.561920 204.476288,294.831970 203.191833,294.997864 
	C202.429291,295.012573 202.016769,295.004547 201.294785,294.993835 
	C200.343536,294.378632 199.530945,294.346313 198.414917,294.323792 
	C197.077774,294.309021 196.134689,294.619324 194.947601,295.235535 
	C193.659927,295.121063 193.182175,294.453094 192.986084,293.188904 
	C192.984375,292.175568 192.987839,291.496002 192.987823,290.476624 
	C193.600632,288.862885 195.734314,290.129395 196.001953,287.999847 
	C195.979507,287.070007 195.984650,286.458221 195.983704,285.540588 
	C196.023468,284.320465 195.938797,283.380310 196.724060,282.301025 
	C198.683350,281.719147 200.425201,281.405853 202.542328,281.035950 
	C204.139389,281.626434 205.316681,282.543732 207.037247,281.449890 
	C208.062622,280.695465 208.025681,280.056732 207.192841,279.166199 
	C206.527634,277.787384 206.069244,276.622253 205.390442,275.237671 
	C204.763977,274.987762 204.467667,274.797241 204.114075,274.201508 
	C203.647217,272.167267 200.298782,269.684631 205.357239,268.953918 
	C206.925095,269.563782 207.679794,269.297272 207.636658,267.536804 
	C205.971695,267.101074 204.445435,266.944824 202.925552,266.789246 
	C202.698944,265.002991 204.840424,265.032806 204.952667,263.333771 
	C206.087570,262.837646 207.676804,263.561249 208.135025,262.311310 
	C208.578232,261.102264 207.435303,260.308014 206.187225,259.906342 
	C204.595840,259.394135 202.943512,258.840546 203.022202,256.279327 
	C203.275391,255.055893 203.867249,254.408752 204.534729,253.432709 
	C206.333191,253.043991 207.701355,251.948959 209.545685,252.541168 
	C211.200653,253.072556 211.831848,251.617050 211.915451,250.156830 
	C211.998474,248.706802 211.162354,248.218430 209.774734,248.026245 
	C208.562592,247.858368 206.448807,250.075882 206.370758,247.455780 
	C206.340225,246.431046 208.653397,244.332184 210.995697,245.476120 
	C211.854492,245.895538 212.593353,245.667831 213.644440,245.114624 
	C214.272507,245.221985 214.546494,245.508347 214.858215,246.124786 
	C214.655090,247.690186 214.371521,248.967087 214.045593,250.637878 
	C215.707489,253.602188 217.665878,252.467850 219.860260,251.192841 
	C220.820511,250.979752 221.539062,250.990768 222.616959,250.999298 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M664.287231,76.528320 
	C643.919983,74.579872 623.649048,76.105141 603.429565,76.609085 
	C580.901672,77.170563 558.409058,79.349495 535.920471,81.076897 
	C532.633240,81.329399 529.270752,81.621147 525.871887,82.589569 
	C522.633545,83.512238 518.193665,83.778389 514.320679,84.149834 
	C509.099396,84.650589 503.633240,83.368340 498.572052,85.806961 
	C498.115204,86.027084 496.973663,84.746628 495.506683,85.212555 
	C494.676544,84.501343 494.219208,83.715080 493.041382,84.931702 
	C492.403748,85.666344 491.997803,86.664818 491.577179,86.613930 
	C485.337372,85.859055 479.043518,88.359642 472.844696,86.291092 
	C472.549408,86.192551 472.345001,85.880318 472.026245,85.287216 
	C474.671143,83.166855 477.456360,81.708122 480.790497,83.700974 
	C481.293762,84.001762 482.156097,84.070740 482.709564,83.864265 
	C494.667084,79.403351 507.380554,82.373711 519.544678,80.090080 
	C541.750854,75.921204 564.356506,77.093246 586.736694,75.090286 
	C604.398621,73.509605 622.178406,72.156311 640.445557,73.242401 
	C642.371765,72.836151 643.852966,72.656868 645.689697,73.008186 
	C646.445496,73.032272 646.878052,73.046432 647.634399,73.086731 
	C648.490784,73.057098 649.022827,73.048096 649.815674,73.181244 
	C650.503052,73.158005 650.928833,73.082794 651.678284,72.989655 
	C652.455627,72.991020 652.908875,73.016151 653.700928,73.078514 
	C657.702820,73.124870 661.365723,73.139900 665.484741,73.153946 
	C666.773132,73.037766 667.607117,72.994865 668.755493,73.132858 
	C672.740479,73.104286 676.414551,73.032372 680.548584,72.935623 
	C681.419006,72.631149 681.871643,72.515022 682.679932,72.742630 
	C686.087952,73.069191 689.177612,73.144066 692.609131,72.293045 
	C700.204529,70.364761 707.105042,71.663773 713.879761,74.214706 
	C715.156921,74.695610 716.225464,75.459862 716.386169,77.383568 
	C712.571350,79.091408 709.158203,77.546364 705.333191,76.354202 
	C704.566345,75.972664 704.142639,75.847008 703.384033,75.792290 
	C695.219727,76.381371 687.364563,76.017372 679.535400,76.553352 
	C674.765198,76.879913 669.993042,76.829201 664.864380,76.698135 
	C664.507690,76.817360 664.410950,76.572784 664.287231,76.528320 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M92.734863,271.298401 
	C93.057922,271.013947 93.527740,270.993469 93.762802,270.999176 
	C95.617867,272.599152 95.212105,274.689026 95.353523,276.634521 
	C95.687798,281.232880 97.035439,285.030579 102.221947,286.196014 
	C103.486221,286.480042 104.733482,287.097809 105.867172,287.754364 
	C109.276756,289.729004 112.468803,290.617706 115.413269,286.827026 
	C116.306534,295.391632 115.306313,303.721741 115.042114,312.532288 
	C115.222534,313.168213 115.391174,313.343262 115.263283,313.730347 
	C114.933731,314.123810 114.900726,314.305145 114.794083,314.752991 
	C111.687019,315.317657 114.164818,319.972839 111.546227,319.653564 
	C108.883667,319.328918 106.330116,317.682831 103.852921,316.379578 
	C101.091835,314.927002 96.316650,313.331665 96.216766,311.581635 
	C95.975517,307.355072 92.256653,306.791046 90.484070,304.083923 
	C89.490318,303.494965 89.465981,302.816223 89.746017,301.747620 
	C90.108063,300.729340 90.301682,300.039185 90.233047,298.917694 
	C89.571243,289.435486 90.474876,280.466553 92.734863,271.298401 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M471.784363,85.066666 
	C476.316223,87.068802 480.863190,85.614578 485.263885,85.136948 
	C487.663910,84.876465 489.974731,86.545036 492.577454,85.170967 
	C492.274689,91.502129 492.246643,91.206879 483.636078,92.024666 
	C454.404144,94.800972 425.193848,97.804970 395.545349,100.782608 
	C394.925568,100.783119 394.735687,100.723015 394.574585,100.960274 
	C394.354034,101.316605 394.104706,101.375565 393.498474,101.291885 
	C392.704895,100.797493 392.445465,100.344566 392.384338,99.389709 
	C392.982483,97.007195 394.441467,95.927666 396.364319,95.835037 
	C399.084137,95.704010 401.384766,94.478241 404.138306,93.359993 
	C412.607452,90.483307 421.194519,90.875771 429.530853,89.549896 
	C442.133331,87.545494 454.866699,87.032204 467.574341,86.204216 
	C468.572876,86.139160 469.915070,86.569359 471.017456,85.298454 
	C471.334656,85.219223 471.660461,85.174744 471.784363,85.066666 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M304.229797,150.787598 
	C304.008209,151.056351 304.008392,151.527924 304.002991,151.763657 
	C303.346130,152.862900 302.213867,152.947876 301.213318,153.808975 
	C300.901154,154.335922 300.723572,154.588257 300.262695,154.896942 
	C299.494720,155.525085 298.941742,156.051590 298.204346,156.799362 
	C297.459259,159.739227 295.994537,159.178757 294.481842,157.908707 
	C293.001343,156.665756 291.627899,155.295364 289.731415,153.540344 
	C289.225586,155.781845 292.948975,161.621628 286.619171,157.477798 
	C285.993195,157.067993 283.101227,160.119522 281.177887,161.629745 
	C279.539795,160.889862 281.888855,157.446121 278.344269,158.002075 
	C275.949646,155.288727 273.836792,153.646271 270.501740,156.494644 
	C268.388702,158.299347 265.869385,155.931961 263.265747,156.742355 
	C262.548523,156.823441 261.786133,156.792572 261.686218,156.519409 
	C260.697327,153.815399 265.734833,145.551971 268.550049,145.105026 
	C280.969147,143.133316 293.325073,140.717636 305.907715,139.900116 
	C307.003021,139.828918 308.068085,139.291473 309.567017,139.009949 
	C309.530151,142.863708 309.610748,146.966537 304.565125,148.355927 
	C303.634888,147.707230 303.298981,147.089783 303.412170,145.975037 
	C303.671021,145.406021 303.850861,145.179520 304.045776,144.965561 
	C304.073608,144.934982 304.266754,144.873184 304.347260,144.670975 
	C304.470215,144.361969 304.376129,144.371552 304.058289,144.955475 
	C302.577789,146.189987 302.921173,147.144028 304.252747,148.303833 
	C304.772308,149.213440 304.755890,149.867081 304.229797,150.787598 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M77.274460,176.560776 
	C76.429062,176.819153 75.799866,176.803299 75.063858,176.467285 
	C70.411026,173.470444 67.295982,167.103333 68.121506,161.817444 
	C68.402908,159.561935 69.476700,158.449158 71.746811,158.186249 
	C72.946236,158.269165 73.576195,159.071289 74.743896,158.722778 
	C76.606865,157.002075 78.713066,156.371323 80.739151,155.873413 
	C87.842674,154.127701 94.911346,152.265854 102.254166,150.307892 
	C102.760727,150.538025 102.942764,150.668121 103.240921,151.066071 
	C103.599548,151.734085 102.419472,151.806061 103.110283,152.240356 
	C103.667191,152.590454 102.783310,152.218140 103.644043,151.884064 
	C105.583488,153.740570 106.567970,156.344940 109.809418,156.177551 
	C111.161438,156.107742 112.088959,157.247742 112.294632,159.016083 
	C112.226440,159.716522 112.236710,160.075684 112.150009,160.687454 
	C107.434624,166.119781 107.429932,166.130447 101.574646,163.555603 
	C101.333504,163.449554 101.349335,162.986694 101.304535,163.027390 
	C101.145180,163.172150 101.495544,163.378754 101.480843,163.446930 
	C100.878334,166.241150 107.128410,164.552856 104.537560,168.758972 
	C99.331009,171.770416 93.764755,172.344620 87.941254,173.421204 
	C85.793640,173.378983 84.034119,173.276047 81.919983,173.600281 
	C81.317719,173.705185 81.074966,173.724564 80.473312,173.702179 
	C78.049286,170.508926 78.023308,170.157913 79.665596,166.398956 
	C76.655449,166.511444 77.656578,168.483444 78.232864,169.690796 
	C79.117699,171.544556 76.813858,172.594635 77.497437,174.578674 
	C77.641869,175.376892 77.607422,175.834366 77.274460,176.560776 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M59.710499,152.227600 
	C70.795609,149.130020 81.377457,145.465149 92.729980,143.193878 
	C93.229057,142.909622 93.368507,142.764984 93.782700,142.744171 
	C94.606323,142.735245 95.155197,142.602493 95.888702,142.249512 
	C96.215225,141.856354 96.357117,141.683395 96.779953,141.326904 
	C107.566498,139.557632 117.809181,136.849701 127.899979,133.608902 
	C134.781509,131.398804 141.994446,131.075394 148.971054,129.395905 
	C158.655136,127.064651 168.448074,125.185539 178.597504,123.047394 
	C179.564407,123.312378 180.128220,123.642815 180.989044,124.110092 
	C180.956329,126.408165 179.245270,127.382385 177.346207,128.630768 
	C171.169327,130.764801 164.967117,130.992004 158.991241,132.290756 
	C147.151688,134.863876 135.685974,139.016937 123.625427,140.740585 
	C121.693398,141.016708 119.609077,140.846161 117.522964,142.080200 
	C101.890961,146.329987 86.379097,149.706604 70.973526,153.519485 
	C64.569733,155.104431 58.337429,157.382675 51.429749,158.429810 
	C49.152855,158.617828 47.217884,159.270737 44.999901,158.279999 
	C44.504528,157.574265 44.453213,157.088425 44.737991,156.269501 
	C44.939323,155.952667 44.988029,155.996658 44.972298,155.968109 
	C45.138954,155.780457 45.321342,155.621368 45.766388,155.712891 
	C48.578285,154.817642 51.253654,154.148727 54.414848,153.794113 
	C56.034439,152.214798 57.678192,152.159485 59.710499,152.227600 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M257.892487,313.437317 
	C259.529510,291.702728 261.223114,270.401794 262.909882,249.100327 
	C263.393860,242.988144 263.858002,236.874374 264.276123,230.372620 
	C264.391235,229.298645 264.561493,228.613419 264.674683,227.573181 
	C263.848602,225.386765 263.770416,223.537659 264.709259,221.334076 
	C265.086975,220.260727 265.230988,219.521820 265.295593,218.412369 
	C265.019012,217.847717 264.821808,217.653595 264.950653,217.202621 
	C266.181335,206.586838 267.085999,196.227936 267.924377,185.437103 
	C265.884888,182.446915 266.962769,179.646088 267.194641,176.903076 
	C267.623108,171.833725 267.476624,166.686829 269.568787,161.448013 
	C270.128235,160.910919 270.410034,160.736450 270.834595,160.356567 
	C271.134949,159.972626 271.292480,159.794098 271.806488,159.659729 
	C272.823517,160.063568 273.277344,160.613312 273.725098,161.622375 
	C273.870026,162.211014 273.898285,162.453232 273.891113,163.059418 
	C273.716095,163.896317 273.476746,164.309525 272.760101,164.699356 
	C272.170166,167.842545 271.939880,170.938629 271.739716,174.471344 
	C273.181274,176.555893 271.995667,178.813660 273.120575,180.956299 
	C273.054993,183.033966 272.513428,184.604492 272.133118,186.614929 
	C271.411011,189.313385 271.371552,191.673538 271.397125,194.443619 
	C271.365356,195.389969 271.324615,195.931900 271.176819,196.878357 
	C270.915131,197.819672 270.622559,198.282272 269.800781,198.695435 
	C268.944061,203.869873 268.501587,209.021011 268.092773,214.596695 
	C268.389069,215.449387 268.479706,215.914246 268.207703,216.706573 
	C267.872925,218.062927 267.753448,219.123260 267.680878,220.582184 
	C267.177765,226.380127 266.627808,231.779480 266.136932,237.595062 
	C267.095947,239.728210 266.274597,241.521896 266.185394,243.645477 
	C265.849487,244.452728 265.758850,244.886505 265.730225,245.649353 
	C265.200317,251.708145 264.608368,257.437866 264.076141,263.589966 
	C263.489624,271.321411 262.843353,278.630493 262.242035,286.394653 
	C263.172821,288.049133 263.200165,289.453461 263.257782,291.196289 
	C263.275330,291.764709 263.278198,291.990936 263.276611,292.553986 
	C263.252777,293.553680 263.191864,294.213745 263.106506,295.195007 
	C263.036591,295.724487 262.998749,295.933350 262.878662,296.446198 
	C262.428162,297.704681 262.160431,298.702209 261.418823,299.821503 
	C260.860748,305.100433 260.473572,310.127930 260.153687,315.580200 
	C261.991699,319.442200 261.810852,323.226227 261.280975,326.749603 
	C259.896973,335.952301 261.108887,345.286987 259.529968,354.452667 
	C259.388824,355.271973 259.267242,356.089783 258.755493,357.292908 
	C258.084869,358.221405 257.526001,358.462585 256.428864,358.214264 
	C256.653137,343.285614 257.299805,328.578217 257.892487,313.437317 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M128.168243,410.021057 
	C129.405853,407.464478 131.429413,406.851562 133.945816,406.970764 
	C137.065125,407.118561 140.202454,406.891235 143.321121,407.045593 
	C145.602631,407.158539 147.158371,406.479767 147.936127,403.867035 
	C147.980881,403.270386 147.929398,403.022491 148.217499,402.608948 
	C149.310898,402.197174 150.032516,402.407288 151.068588,402.794800 
	C151.825638,403.595459 152.035629,404.289246 152.201385,405.368408 
	C152.270691,406.179443 152.280518,406.639099 152.264786,407.429901 
	C151.608597,409.584015 152.244415,409.926941 154.166840,409.158813 
	C155.287247,409.276489 156.096100,409.394257 157.216736,409.143463 
	C157.939819,408.977264 158.359894,408.902008 159.108246,408.805786 
	C161.398682,408.662354 163.372070,408.796936 165.647186,408.529541 
	C166.166245,408.462219 166.371429,408.434113 166.879761,408.421143 
	C167.689026,408.363251 167.911240,409.388824 168.821106,408.678223 
	C169.281937,408.538147 169.474838,408.510254 169.959778,408.503296 
	C171.014450,408.659363 171.771393,408.838654 172.850525,408.799683 
	C173.347061,408.757416 173.546829,408.736206 174.048553,408.677094 
	C175.763351,408.346436 177.246536,408.423584 178.903656,407.710327 
	C180.505646,407.373535 181.848373,407.620270 183.464020,407.177185 
	C185.511703,406.634918 187.333542,406.557800 189.288452,405.658386 
	C189.812241,405.463104 190.027573,405.404449 190.574387,405.330292 
	C192.340179,405.911957 193.842697,405.765289 195.646545,405.721649 
	C196.769302,405.736481 197.573944,405.690948 198.641266,405.321838 
	C199.735107,405.003113 200.568222,404.904907 201.666885,404.551147 
	C202.192230,404.446960 202.403107,404.402771 202.938965,404.362579 
	C204.562134,404.675018 205.862839,404.608246 207.511047,404.375000 
	C210.001373,404.580750 212.164291,404.590607 214.666367,404.894073 
	C217.027664,404.503296 219.068726,404.545868 221.439880,404.127899 
	C222.081223,404.216278 222.332962,404.285248 222.914520,404.567200 
	C224.106903,405.886444 224.201126,407.156250 223.938110,408.845398 
	C223.640778,409.657745 223.359344,410.047546 222.657623,410.492432 
	C222.116623,410.650116 221.894821,410.676666 221.347504,410.679474 
	C220.212585,410.511688 219.405334,410.336365 218.276352,410.530823 
	C217.775116,410.585205 217.573090,410.595154 217.068939,410.586060 
	C215.966431,410.458344 215.167007,410.401154 214.063721,410.671875 
	C213.331085,410.786072 212.905823,410.798340 212.157181,410.732239 
	C210.576553,410.367737 209.307327,410.203186 207.692078,410.486633 
	C207.158264,410.560211 206.943787,410.579132 206.408203,410.593658 
	C205.252441,410.519684 204.416290,410.346130 203.275726,410.714020 
	C202.752899,410.856689 202.541031,410.911011 202.003113,411.030090 
	C201.455215,411.125092 201.233353,411.155365 200.674408,411.212769 
	C199.202942,411.281128 198.070862,411.234314 196.605194,411.116150 
	C195.015137,410.906555 193.734055,410.276489 192.255676,411.466553 
	C190.470047,412.372223 188.890991,412.627533 186.896576,412.442627 
	C184.098358,412.417267 181.584885,411.824036 178.956284,413.298401 
	C178.443314,413.558228 178.231888,413.650879 177.691116,413.847839 
	C177.137833,413.999420 176.913864,414.046722 176.351257,414.136230 
	C175.124466,414.243591 174.231857,414.200897 173.021729,414.331726 
	C172.271698,414.444702 171.848663,414.533997 171.113708,414.718689 
	C170.158066,414.921631 169.513107,414.942291 168.550323,414.840149 
	C167.426987,414.619141 166.627090,414.367065 165.476715,414.605774 
	C160.873856,416.789093 156.093964,414.201782 151.428162,416.154083 
	C150.845062,416.243896 150.609528,416.270203 150.017807,416.315369 
	C148.474213,416.351227 147.286667,416.318542 145.748825,416.345947 
	C139.683914,416.144257 134.278900,418.520660 128.225494,418.376343 
	C125.561913,418.591309 123.244446,418.552368 120.584084,418.342712 
	C119.560699,418.328888 118.881355,418.302063 117.867180,418.330475 
	C116.865997,418.385803 116.202179,418.444885 115.228043,418.714172 
	C114.221176,418.924561 113.542435,418.931915 112.537048,418.709351 
	C111.717651,418.749054 111.498337,417.254913 110.523102,418.539917 
	C109.446480,418.867462 108.729767,418.750092 107.783630,418.084869 
	C106.771004,416.127136 107.244789,414.640930 108.471466,412.935303 
	C110.094643,411.703461 111.654320,411.710022 113.556808,411.643829 
	C115.520943,411.733093 117.009933,411.382782 118.636414,410.302917 
	C119.937149,408.736328 121.198914,408.781097 122.792145,409.789307 
	C124.728218,411.938599 126.970673,410.593048 129.270065,411.032104 
	C131.243591,411.551575 132.873795,411.482086 134.855316,411.022552 
	C139.198288,410.767090 143.230545,410.898407 147.124069,409.783722 
	C143.700989,410.259308 140.275803,410.703156 136.475861,410.790253 
	C133.926483,410.944824 131.717361,411.861633 129.161743,410.841980 
	C128.650894,410.610962 128.466843,410.476898 128.168243,410.021057 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M90.641052,183.237152 
	C96.905800,178.756851 104.258682,178.605530 110.934837,176.423050 
	C112.840225,175.800156 112.443901,178.031296 112.522530,179.252457 
	C113.013855,186.882782 113.491989,194.513962 113.918549,202.586029 
	C112.682976,204.188843 111.530693,205.448990 110.089432,206.225754 
	C107.598923,207.567993 105.120926,207.698471 104.189384,204.370758 
	C103.610420,202.302505 102.359077,201.362244 100.199509,200.629242 
	C97.876297,197.649002 94.594398,197.250565 91.698982,196.197388 
	C90.003708,195.580765 88.121170,195.460709 86.663254,193.643860 
	C87.076492,189.751953 88.294540,186.462967 90.641052,183.237152 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M116.748627,142.200958 
	C117.272995,138.756760 120.526718,139.600967 121.767876,139.440826 
	C131.968430,138.124725 141.819290,135.639999 151.683228,132.760742 
	C159.619003,130.444305 167.968124,129.544006 176.550858,127.963654 
	C177.502518,127.988335 177.397705,129.414047 178.156769,128.690506 
	C180.131638,126.808014 182.181366,125.882034 184.850662,127.212013 
	C185.606491,127.588593 186.464951,127.352844 187.265549,127.029839 
	C192.208984,125.035393 192.211594,125.041862 194.199219,130.581650 
	C193.818512,130.955765 193.661133,131.058731 193.241455,131.057800 
	C191.720245,130.860855 190.558197,131.717621 188.962494,131.262970 
	C187.990982,131.688126 187.326462,132.182449 186.370850,132.533142 
	C185.494568,132.172653 184.944794,132.212906 184.274933,132.853333 
	C184.105026,133.091888 184.049774,133.080200 184.055954,133.107758 
	C180.948776,134.023315 177.634918,133.710190 174.264252,134.899185 
	C173.537048,135.211044 173.088226,135.348145 172.333786,135.279968 
	C169.594574,136.081787 167.029968,136.670029 164.252380,137.618881 
	C155.461243,140.019516 146.934952,142.225342 138.200073,144.162109 
	C132.605560,145.623474 126.828545,145.808411 121.571037,148.057251 
	C120.578026,148.482025 119.653648,148.176575 118.584320,147.274597 
	C117.517212,145.594147 116.293343,144.330597 116.748627,142.200958 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M115.787888,286.556030 
	C115.548462,287.067749 115.390831,287.116425 115.233688,287.166656 
	C112.535301,288.028961 115.627846,292.443298 112.464043,292.324585 
	C110.397995,292.247101 108.507545,289.980469 106.347061,289.338806 
	C103.180244,288.398315 100.378960,286.674927 97.202492,285.695892 
	C93.727287,284.624695 94.975937,280.520355 94.106750,277.804077 
	C93.531982,276.007874 93.995560,273.879456 93.996063,271.452332 
	C98.581772,269.931122 102.857269,266.915100 107.916435,270.598328 
	C110.435158,272.432068 113.778969,269.495636 114.016724,266.054321 
	C114.148468,264.147614 113.262192,262.082520 115.090973,260.200867 
	C116.349358,268.720337 115.710518,277.413818 115.787888,286.556030 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M99.701019,200.277878 
	C102.578239,200.343567 106.183914,198.603714 105.432793,204.177261 
	C105.045509,207.051010 108.296593,206.410736 109.575241,204.995041 
	C110.650940,203.804031 111.429207,202.849426 113.474335,203.011459 
	C113.991043,206.046921 114.119499,209.066605 114.158157,212.531342 
	C111.929832,215.451492 113.432144,218.409378 113.000038,221.112152 
	C112.799240,222.368134 113.218773,224.685944 111.888268,224.521774 
	C108.116264,224.056305 105.506981,227.388580 101.966393,227.030167 
	C100.044792,226.835648 101.723175,229.763535 99.677193,229.334152 
	C98.232475,227.983246 99.754669,225.718475 97.947266,224.140213 
	C97.406998,223.536819 97.292412,223.110580 97.256912,222.324860 
	C97.284782,221.288010 97.212578,220.597412 97.054901,219.532150 
	C97.410393,212.899826 97.431412,206.602173 99.701019,200.277878 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M269.466858,161.015625 
	C270.089844,168.840714 268.740173,176.474442 267.971588,184.583176 
	C264.850433,184.720886 264.692841,181.921173 263.541779,180.036041 
	C262.678711,178.622559 261.329895,177.074875 260.179260,178.738022 
	C258.429321,181.267471 254.665085,181.866531 254.447189,186.322418 
	C252.376984,183.735306 253.152466,181.926559 253.809113,180.141022 
	C255.904449,174.443390 254.952255,168.541183 254.995453,162.706146 
	C255.007797,161.038406 254.849686,159.322601 256.887024,158.051392 
	C261.185822,158.891068 265.136536,159.918457 269.466858,161.015625 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M499.911133,91.471909 
	C500.085754,91.243736 500.277710,91.253639 500.721985,91.124046 
	C501.158081,90.863152 501.341919,90.741753 501.823425,90.763733 
	C506.916595,90.377647 511.684052,90.445595 516.481018,91.113457 
	C517.599976,91.269257 518.325500,91.336411 518.876953,92.672012 
	C521.612854,95.187080 525.111389,96.510406 526.428284,100.042274 
	C526.695312,100.758430 526.305542,101.944519 527.437439,101.935471 
	C532.016357,101.898903 532.658936,106.062157 534.894531,108.971893 
	C534.426331,110.059547 533.797546,111.250160 532.949280,109.724022 
	C532.178223,108.336639 531.046875,108.062141 529.140015,107.963661 
	C528.592163,107.910515 528.537781,107.511261 528.279053,107.742691 
	C527.403625,107.850395 526.786926,107.726669 526.106262,107.319649 
	C522.158325,104.112297 517.197815,104.185349 512.859802,102.383308 
	C508.527039,100.583412 505.514771,97.626854 502.197357,94.325264 
	C501.757294,93.815506 501.514282,93.507553 501.056519,92.997101 
	C500.540955,92.430206 500.234711,92.070099 499.911133,91.471909 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M168.298279,299.653839 
	C167.476791,300.239258 166.905289,300.631287 165.977158,301.072937 
	C164.491058,299.277161 161.202332,301.233521 160.848602,298.017761 
	C161.641861,296.827728 164.563705,295.966400 161.074371,295.017700 
	C159.876984,294.692139 158.640015,294.512146 157.305069,294.242188 
	C158.276459,292.066956 160.455688,293.657654 161.809814,292.231445 
	C162.888229,291.327789 162.843781,290.237061 163.497818,289.180328 
	C163.829437,288.855652 163.985840,288.763184 164.406494,288.652466 
	C164.670761,288.634216 165.090469,288.871490 165.090469,288.871490 
	C165.090469,288.871490 165.498383,288.613129 165.557037,288.376160 
	C165.615692,288.139191 166.007660,287.839478 166.245453,287.905212 
	C168.003464,287.251953 169.066116,285.464508 171.461060,285.972961 
	C174.658264,287.125885 177.069443,285.940887 179.678558,284.284607 
	C180.355011,284.020477 180.789627,283.994537 181.550842,283.962585 
	C182.398621,284.367004 182.965775,284.726074 183.534286,285.563721 
	C184.016769,286.439484 184.234344,287.063599 184.369461,288.036682 
	C183.943634,289.108215 183.943634,289.108215 186.601761,289.588074 
	C187.070938,290.682495 187.271500,291.604706 187.743988,292.758148 
	C188.136154,293.189941 188.256393,293.390442 188.246460,293.915588 
	C187.013321,295.312195 185.569412,295.638824 184.152954,295.934814 
	C182.427902,296.295227 182.798050,297.415100 183.077057,298.878723 
	C179.181030,298.985291 175.721954,304.184204 171.144608,300.041077 
	C170.149353,299.230560 169.420715,298.945648 168.298279,299.653839 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M254.726257,137.811798 
	C256.425262,138.254257 257.962799,138.270432 258.905060,140.112137 
	C257.575745,145.162537 254.174408,142.512619 251.439072,142.285110 
	C247.783722,141.981094 245.066711,139.240570 241.025681,139.018951 
	C236.776932,138.785934 232.482330,137.114838 228.017532,136.666702 
	C224.592361,136.322906 223.095337,131.883118 219.366531,131.419495 
	C218.788925,131.347672 217.888245,130.451614 217.774078,130.567017 
	C212.639969,135.756760 211.196182,129.132187 208.112625,127.272476 
	C208.217651,126.507149 208.463089,126.120651 209.081055,125.624695 
	C212.507874,125.836349 215.621460,126.030708 219.093918,125.804001 
	C223.718765,127.779343 229.115219,126.692429 232.729324,129.390579 
	C236.481155,132.191559 240.791779,133.166336 244.689774,135.265915 
	C245.612701,135.763016 246.185867,135.692719 246.401321,134.200287 
	C246.927429,133.292480 247.473099,132.898636 248.500305,132.689774 
	C250.864029,134.158325 252.597046,135.954575 254.726257,137.811798 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M703.736450,88.625298 
	C707.473755,86.134575 711.917480,85.748138 715.693726,82.967896 
	C717.698242,79.484390 721.892456,77.822090 721.987427,73.157356 
	C721.916565,71.007523 720.668945,69.469154 720.870605,67.562019 
	C721.169067,64.739471 722.862854,63.370178 725.476990,63.474438 
	C728.207153,63.583317 727.895081,65.881371 727.522400,67.575226 
	C726.514282,72.156815 728.276917,74.001427 732.842407,73.762459 
	C735.371033,73.630119 737.057556,75.361603 738.935852,77.307129 
	C739.454590,78.027580 739.609436,78.502861 739.605042,79.396225 
	C739.389343,80.253654 739.126587,80.673477 738.476440,81.245644 
	C734.556824,80.978607 731.007935,80.729225 728.711914,84.936958 
	C726.860657,89.909187 722.888428,88.265717 719.385193,88.727798 
	C717.029602,89.191978 716.458252,91.727150 714.156128,92.069710 
	C712.328369,90.726753 711.548157,92.182976 710.532166,92.838341 
	C706.091492,95.702950 704.109131,94.579956 703.736450,88.625298 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M392.642273,98.808304 
	C392.903625,99.521553 392.964966,99.986504 393.083923,100.800346 
	C393.141571,101.149231 393.358551,101.355644 393.281219,101.483871 
	C392.463562,101.489487 392.365326,102.012573 392.118591,102.758408 
	C391.966125,102.977127 391.784058,103.330208 391.690063,103.505203 
	C391.584839,103.858406 391.573547,104.036629 391.334534,104.343872 
	C391.106812,104.472908 390.633667,104.528938 390.417603,104.489075 
	C389.563171,104.892204 390.406830,105.061638 390.473694,105.669098 
	C390.716766,107.063271 390.452179,107.963982 389.002716,108.455170 
	C388.376801,108.553711 388.207458,108.703171 388.220551,108.974457 
	C388.224731,109.061836 388.252594,109.113380 388.294922,109.129555 
	C388.917725,109.367386 388.136322,109.335182 388.759552,108.708252 
	C390.197815,108.606445 391.346832,107.789368 392.716003,108.836754 
	C392.912994,109.071060 393.059326,109.452423 393.139313,109.640335 
	C393.732239,111.161865 393.345886,112.290962 392.131226,113.530334 
	C385.906342,113.466087 382.292053,115.848412 381.887665,122.411957 
	C377.780518,119.683960 373.650360,121.698448 369.682770,122.328537 
	C367.749084,122.635628 365.848236,122.916908 363.470093,122.943253 
	C361.376282,120.181992 363.143494,119.164238 365.719727,118.348282 
	C367.543701,118.267860 368.208038,120.221489 369.872009,119.766548 
	C370.481903,119.599800 369.661041,119.794075 370.310150,119.665886 
	C370.543610,119.619789 370.392059,119.434280 369.663910,119.550278 
	C369.207428,119.419136 369.034027,119.310417 368.706543,118.919342 
	C369.386536,113.519493 374.181122,115.148170 377.369385,113.466888 
	C377.901123,113.079300 378.117737,112.789925 378.295502,112.174942 
	C378.359894,111.728416 378.381989,111.549461 378.462524,111.107086 
	C378.634644,110.516884 378.777466,110.203873 379.065582,109.699829 
	C379.170380,109.489738 379.158447,109.044182 379.158447,109.044182 
	C379.158447,109.044182 378.931976,109.455719 378.678528,109.575485 
	C378.230652,109.727089 378.036194,109.758934 377.538025,109.763596 
	C375.432648,107.577141 374.956024,105.462395 377.720612,103.259201 
	C378.489227,103.298843 378.982849,103.526596 379.730988,103.862366 
	C380.289673,103.666252 380.642212,103.433929 381.353027,103.219147 
	C381.881500,103.202995 382.092743,103.230217 382.595978,103.384453 
	C383.135864,103.722404 383.314758,103.975494 383.423431,104.271187 
	C383.533417,104.570465 383.537354,104.462799 383.321716,103.650238 
	C383.065277,102.708908 383.117188,102.074814 383.438049,101.153656 
	C384.206268,99.982834 385.020935,99.306084 386.208557,98.604385 
	C386.692078,98.446335 386.892395,98.412354 387.391510,98.389496 
	C388.278442,98.483810 388.859406,98.459824 389.726746,98.210922 
	C390.875122,98.018005 391.692261,98.096352 392.642273,98.808304 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M192.041748,140.016846 
	C197.578598,139.633438 202.586929,137.528030 207.934723,139.731750 
	C204.524475,140.326614 201.088669,140.803391 197.708023,141.535034 
	C170.933411,147.329605 144.170074,153.176285 117.398720,158.986084 
	C116.440132,159.194107 115.019272,160.258728 114.782326,158.235977 
	C114.586227,156.562012 115.665611,156.201370 117.222580,155.935913 
	C142.236755,151.671234 166.803680,145.299179 192.041748,140.016846 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M86.706924,172.230560 
	C92.734550,171.850525 97.999184,169.704178 103.741554,168.336548 
	C106.267952,166.567612 108.633446,165.534546 111.801254,166.689880 
	C113.840569,170.733871 112.893501,172.884888 108.574898,174.027878 
	C100.744347,176.100357 92.817932,177.600723 84.836243,178.830399 
	C82.379532,179.208878 79.871727,178.723755 77.387665,177.028259 
	C77.050713,176.444199 77.043167,176.053375 77.040543,175.369263 
	C77.533180,173.846756 78.627068,173.521423 80.084427,173.147583 
	C80.408325,173.040054 80.499977,173.134171 80.562103,173.112823 
	C82.437157,171.996796 84.456123,172.765930 86.706924,172.230560 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M392.780396,119.572159 
	C428.096191,115.166649 462.856354,108.106995 498.166473,105.469719 
	C498.225342,105.915489 498.284210,106.361267 498.343079,106.807037 
	C489.779266,107.883598 481.202087,108.864014 472.654358,110.056023 
	C452.619293,112.849998 432.603363,115.781044 412.568726,118.578407 
	C406.335022,119.448799 400.066284,120.068321 393.396912,120.804298 
	C392.648102,120.545807 392.525360,120.203529 392.780396,119.572159 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M431.702759,238.719849 
	C431.998260,238.995239 432.005066,239.428680 432.008362,239.645416 
	C431.846893,240.726410 431.068756,241.032761 430.302338,241.740814 
	C427.924957,242.113449 425.742462,242.272308 423.278748,242.717163 
	C421.914124,243.000504 420.830780,242.997864 419.341248,242.986633 
	C416.343842,241.954193 413.650970,242.710770 410.685364,242.691467 
	C408.897156,242.910431 407.435425,242.963669 405.534851,243.021790 
	C402.618896,241.927307 400.032898,242.663422 397.183411,242.805878 
	C396.245972,243.030914 395.620850,243.025955 394.683136,243.020737 
	C393.082520,243.071365 391.745605,242.746567 390.314514,243.742661 
	C389.609161,243.980606 389.140564,243.993469 388.320496,243.997040 
	C387.824738,243.840317 387.680511,243.692886 387.279663,243.371399 
	C386.441681,242.973602 385.824249,242.829086 385.157043,242.156891 
	C384.988892,241.260635 384.989685,240.630692 384.986389,239.685760 
	C385.033356,238.160248 385.771454,237.829987 387.088074,238.141861 
	C387.383881,238.850815 387.697174,239.356079 387.248108,239.814590 
	C387.517944,239.746048 387.638702,239.527863 387.748291,238.862625 
	C388.772949,237.721146 389.942169,236.993774 390.884552,237.994507 
	C392.377838,239.580338 391.874512,236.995728 392.929688,237.130249 
	C394.435913,237.074600 395.740601,236.787506 397.003906,238.013397 
	C399.898468,238.630722 402.574036,238.646362 405.590759,238.172684 
	C407.260864,238.020538 408.589508,238.001816 410.316589,237.977829 
	C412.404907,238.500656 414.117462,238.769409 416.132812,238.362274 
	C416.381989,238.300690 416.734650,238.032242 416.647400,237.808990 
	C416.289337,237.347229 416.076233,237.063446 415.931946,236.454468 
	C415.967255,235.347015 415.973846,234.533325 415.966187,233.312958 
	C416.711853,228.405472 418.777924,232.450073 420.458130,232.507309 
	C420.952026,236.560501 423.985077,237.102921 427.108856,237.964279 
	C428.778229,238.100540 430.155426,237.735977 431.702759,238.719849 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M118.589485,146.835648 
	C124.188507,145.759003 129.502090,144.695007 134.778946,143.472473 
	C135.755280,143.246292 136.617905,142.913025 137.785339,143.616913 
	C134.575333,146.870071 129.887772,146.552429 126.055901,148.508224 
	C122.560959,150.292084 118.915207,151.778778 115.352821,153.432816 
	C113.050293,154.501907 112.896988,156.659256 112.485985,159.078522 
	C111.728340,158.032349 110.792389,156.702347 109.416550,157.098129 
	C105.022728,158.362076 104.424545,155.311539 103.291336,152.195297 
	C102.975029,151.827133 102.951714,151.655472 102.930962,151.223999 
	C105.237137,150.598511 107.580437,150.580566 109.377335,148.559448 
	C110.483505,147.315247 112.249344,147.031326 114.278152,147.234680 
	C115.315208,147.469009 115.959686,148.091965 117.020081,147.518768 
	C117.571938,147.111847 117.919685,146.930298 118.589485,146.835648 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M304.364990,151.040527 
	C304.005310,150.292023 304.002411,149.527695 304.000366,148.381256 
	C306.541748,147.941772 307.275085,145.942810 307.762207,144.083115 
	C308.182465,142.478668 308.440277,140.898987 309.826965,139.365051 
	C310.403564,138.937576 310.820221,138.825867 311.560669,138.736618 
	C312.682404,138.989807 313.172394,139.532288 313.494751,140.562988 
	C314.188690,141.010254 313.231934,140.954773 313.898041,140.927719 
	C313.961426,140.925140 313.980774,140.891968 313.956146,140.828094 
	C313.881561,140.634918 313.807861,140.538315 313.841766,140.272720 
	C314.404877,139.558990 314.945099,139.454514 315.776978,139.807404 
	C315.914154,141.810898 317.524780,141.855164 318.783569,142.732300 
	C319.649872,144.630600 320.720551,145.959000 322.552338,147.516922 
	C321.315430,153.153824 319.298553,153.889313 314.374756,151.001007 
	C313.614136,153.173538 311.844147,153.703262 310.999237,152.095108 
	C309.146393,148.568604 307.021332,150.049591 304.364990,151.040527 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M194.360199,130.835892 
	C194.074890,128.676346 191.061844,128.672821 190.994080,126.550415 
	C190.969254,125.772461 190.158951,125.234886 189.714035,126.046417 
	C187.890869,129.371826 185.878143,130.321487 182.556427,127.677193 
	C181.999496,127.233833 179.666519,128.628616 178.419724,129.538086 
	C176.609940,130.858231 177.125763,129.311447 176.952484,128.229187 
	C178.326813,126.902306 179.685776,125.892662 181.165405,124.564972 
	C187.066101,123.602921 192.608887,121.294930 198.791229,122.100021 
	C201.252396,123.299843 202.724075,124.716896 202.573700,127.646263 
	C200.537689,130.403229 197.319077,129.720764 194.360199,130.835892 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M722.402466,72.890305 
	C724.580627,78.917969 719.061035,79.753983 716.297607,82.656395 
	C715.985413,82.355461 715.988464,81.961258 715.992798,81.271332 
	C715.651184,80.391945 715.705383,79.791245 716.116028,79.309631 
	C716.679565,78.648666 717.099976,78.134560 715.901001,77.792404 
	C712.545715,74.175026 707.906616,73.949150 703.560364,73.201302 
	C700.326294,72.644836 696.956238,72.878677 693.328613,72.514786 
	C692.943542,71.849182 692.876587,71.429329 692.689941,70.383080 
	C692.755310,69.705124 692.940369,69.653580 693.395386,69.490463 
	C694.222961,69.082451 694.763062,68.755783 695.638428,68.281769 
	C704.958069,68.160263 713.889587,68.528725 722.402466,72.890305 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M44.668171,157.670334 
	C46.791523,158.534134 48.468853,156.345490 50.666672,157.680298 
	C51.213570,161.699860 46.836285,160.187317 45.665859,162.469986 
	C46.026569,164.075943 47.746410,163.656631 48.952930,164.644104 
	C49.429756,165.322250 49.480484,165.788727 49.195889,166.571289 
	C45.645115,167.128906 42.411636,167.572418 41.349480,171.564056 
	C37.363350,169.159424 33.413174,166.845428 31.022533,162.332550 
	C32.635826,160.078751 35.095467,159.938477 37.591412,159.077393 
	C38.994205,158.934952 40.112015,159.123932 41.310062,158.234589 
	C41.686295,157.859299 41.831673,157.703583 42.268284,157.415787 
	C42.769608,157.248413 42.979706,157.213135 43.507469,157.206055 
	C44.020187,157.317505 44.215240,157.400787 44.668171,157.670334 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M703.440552,88.313156 
	C703.930542,90.412201 705.013245,92.822586 706.598511,93.158775 
	C708.351135,93.530464 710.450073,91.996246 711.543274,89.985016 
	C711.902039,89.325142 712.221863,88.176018 713.248108,88.626564 
	C714.327820,89.100586 713.899902,90.332390 713.915771,91.936172 
	C713.336914,93.531364 712.824829,94.452103 711.890869,95.472809 
	C708.107117,96.924255 709.830383,99.674278 709.754456,102.265686 
	C709.522766,102.790604 709.393860,102.985260 708.969421,103.373138 
	C705.314880,104.449997 704.557861,100.938278 702.133423,99.588051 
	C701.056885,98.426880 701.415405,97.259331 701.258423,96.156197 
	C700.725281,97.046890 700.016479,97.735504 699.331604,98.847946 
	C698.296753,99.889542 697.273621,100.231728 695.873108,100.419312 
	C695.378479,100.379990 695.188782,100.331268 694.765137,100.129272 
	C694.243774,99.771355 693.934265,99.611656 693.333984,99.551926 
	C692.899292,99.645409 692.724487,99.701256 692.274231,99.829483 
	C691.198730,100.051582 690.396362,100.052567 689.278687,99.858574 
	C688.555725,99.597206 688.208740,99.332611 687.780151,98.686394 
	C687.617981,97.658142 687.856628,97.019547 688.400269,96.127777 
	C688.780212,95.697540 688.956604,95.548752 689.431641,95.228630 
	C693.133606,92.833359 698.356934,94.190437 700.774719,89.323135 
	C701.698975,88.835594 702.387512,88.588737 703.440552,88.313156 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M188.205017,160.776566 
	C187.002747,161.660385 185.943588,162.043488 184.398575,161.892609 
	C183.312943,161.111267 183.417877,160.256485 184.230209,159.849030 
	C186.224823,158.848526 183.132233,159.313660 184.015808,158.422791 
	C191.841827,156.313293 199.606857,154.551590 207.344223,152.675751 
	C208.821976,152.317490 210.090225,151.939072 209.955795,154.059753 
	C209.869156,155.426407 211.403839,157.571030 208.450165,157.870621 
	C203.029099,158.420471 197.787384,160.232925 191.858658,160.172577 
	C190.396774,159.999939 189.361252,159.877274 188.205017,160.776566 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M235.162750,117.700119 
	C234.505524,117.901688 234.083755,117.926071 233.347198,117.994156 
	C230.798187,120.221588 227.563889,118.546692 224.849030,120.276657 
	C224.324295,120.592499 224.111160,120.709755 223.556625,120.942688 
	C220.849136,121.460320 218.622818,122.181046 216.045868,121.768837 
	C213.234909,121.319183 210.585190,122.502411 208.587570,125.179893 
	C206.948242,124.235336 206.939651,123.026741 207.727875,121.375443 
	C208.289780,119.965981 208.204559,118.688797 209.705902,117.861572 
	C210.027771,117.720520 210.047882,117.940163 210.157745,117.930519 
	C210.335587,118.076698 210.403580,118.232529 210.626068,118.185486 
	C211.627808,117.812721 212.475006,117.642822 213.628021,117.354477 
	C215.372803,116.485283 216.835144,115.859283 218.818420,116.227631 
	C219.124817,116.077087 219.539490,116.107521 219.745605,116.134598 
	C225.679947,114.036804 231.659348,113.540627 238.009598,113.679459 
	C238.736923,114.699104 238.768738,115.485985 238.202026,116.619858 
	C237.947647,116.947212 237.497437,117.088692 237.262482,117.066818 
	C236.419876,116.984245 235.868637,117.115852 235.162750,117.700119 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M68.747498,161.595337 
	C67.424660,167.908234 72.993530,170.866287 74.838364,175.800278 
	C71.773361,175.954697 68.725685,175.160339 65.905220,173.714508 
	C64.522469,173.005661 63.298561,172.187469 61.401321,173.059067 
	C60.936569,172.355316 60.792854,171.621124 60.273701,170.786407 
	C61.073685,167.169449 61.139809,167.128281 64.487152,167.572678 
	C64.586334,167.585846 64.477097,167.286575 64.541573,167.157410 
	C64.933876,166.371674 64.576370,165.401230 63.768803,164.787292 
	C62.794144,164.046371 62.372883,163.025879 62.659012,161.443787 
	C64.755981,159.466049 66.660912,159.413422 68.747498,161.595337 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M12.672591,169.972015 
	C12.879819,169.141998 12.866250,168.257614 13.002925,168.233765 
	C17.102428,167.518036 20.936462,165.964371 24.853539,164.665604 
	C25.159512,164.564148 25.801847,165.477158 26.593201,165.921906 
	C27.302618,165.611328 27.761145,165.492569 28.568871,165.756592 
	C29.607689,167.710876 28.881199,169.375732 28.344578,171.010590 
	C26.156065,170.415710 25.044167,172.298340 23.109619,172.729172 
	C22.839249,172.920364 22.428034,172.990814 22.219444,172.993256 
	C21.529903,172.620651 21.506342,172.132248 21.664728,171.598770 
	C21.509981,171.890564 21.436548,172.204178 21.294636,172.792755 
	C20.938242,173.240677 20.727716,173.431091 20.305428,173.662613 
	C18.484087,174.439575 16.929604,175.509644 14.714340,174.410583 
	C13.222796,173.190613 12.466799,171.949463 12.672591,169.972015 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M647.887085,100.620789 
	C654.155396,99.022537 660.624451,97.755936 667.517212,96.432800 
	C668.310120,96.702194 668.541565,97.103294 668.564819,97.946640 
	C665.003784,99.317680 667.458984,101.079185 668.036987,102.959183 
	C668.098633,104.064468 667.948181,104.778244 667.429382,105.768585 
	C666.666382,106.604248 665.992676,106.896751 664.918579,107.170998 
	C662.550232,107.156380 661.208008,108.624619 659.235596,109.524445 
	C658.429321,109.694450 657.963684,109.672241 657.201782,109.377716 
	C656.107483,107.345238 656.834717,105.796112 657.701111,104.159592 
	C658.012817,103.570755 660.040466,104.082451 658.718140,102.764580 
	C658.401855,102.449379 657.195190,100.616852 656.165527,102.669022 
	C655.444336,104.106323 653.997131,103.782799 652.373901,103.246559 
	C650.806824,102.230141 649.080261,102.269409 647.887085,100.620789 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M5.628977,407.233337 
	C4.961072,407.047791 4.678510,406.832245 4.259470,406.389832 
	C16.979002,404.420258 29.835011,402.677612 42.691021,400.934967 
	C42.762459,401.432129 42.833897,401.929260 42.905338,402.426422 
	C30.775892,405.093506 18.627592,407.639648 5.628977,407.233337 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M155.906097,167.414871 
	C149.407410,170.249451 142.457291,170.438690 135.314270,171.738281 
	C133.221542,171.778122 131.553726,172.232437 129.548492,171.617004 
	C129.074890,171.255188 128.924927,171.063080 128.887070,170.523026 
	C135.658325,168.221542 142.427750,166.760986 149.654480,165.679428 
	C151.923904,166.473022 154.301361,165.098297 155.906097,167.414871 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M187.997253,275.344452 
	C185.752045,274.737518 183.284088,275.787720 181.165985,273.457520 
	C183.051086,271.939575 185.417175,271.685181 188.105560,271.126404 
	C190.851318,266.231598 195.265274,268.918671 198.692169,268.445099 
	C200.525162,268.191803 199.771271,270.697449 199.518021,272.523956 
	C198.345840,274.498169 196.842957,275.238556 194.718872,275.452148 
	C193.852219,275.363525 193.323975,274.957245 192.597656,275.589874 
	C192.319275,275.966644 192.195160,276.110382 191.812256,276.135040 
	C190.600174,276.052063 189.636108,276.058929 188.823212,277.264832 
	C188.646271,277.573090 188.247894,277.444061 188.126602,277.273407 
	C188.007706,276.639191 188.010101,276.175659 187.997253,275.344452 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M2.351141,203.071960 
	C2.049328,201.984665 2.946736,201.920868 3.858198,201.406693 
	C7.954042,197.832031 13.003206,197.475830 17.611160,196.004425 
	C19.319799,195.458832 21.105577,195.148178 23.127155,194.288757 
	C23.662865,193.709518 23.831009,193.252777 24.086481,192.645355 
	C25.644430,192.442886 26.994938,193.237823 28.792908,193.160812 
	C30.200947,192.825958 31.293112,192.435410 32.686157,191.860229 
	C35.022022,190.537003 33.153694,188.265686 34.375313,186.891052 
	C36.325394,192.778076 36.369293,192.900406 30.475237,195.015411 
	C21.402937,198.270889 12.228659,201.219879 2.351141,203.071960 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M170.030273,380.744507 
	C164.292099,380.893188 158.852798,380.893188 153.413498,380.893188 
	C166.966324,377.155121 181.042191,378.820953 194.780869,376.881592 
	C187.384216,379.609985 179.593506,379.702301 171.411499,380.309937 
	C170.740128,380.424927 170.534622,380.510376 170.030273,380.744507 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M163.211960,386.733521 
	C150.937485,388.958099 138.736679,389.765503 126.579834,390.962463 
	C125.569687,391.061890 124.309280,391.998749 123.461136,390.553589 
	C123.409256,390.465210 123.477180,390.270935 123.543564,390.157715 
	C123.625610,390.017822 123.764404,389.911194 124.140167,389.510712 
	C126.660271,389.101898 128.918884,388.972595 131.602661,388.756653 
	C132.027817,388.670013 132.482773,388.624207 132.706024,388.574951 
	C139.363632,387.676117 145.946335,388.071991 152.626709,386.137482 
	C153.148071,385.910126 153.304321,385.767975 153.730377,385.791901 
	C154.755600,385.948853 155.511017,385.939728 156.640076,385.873230 
	C157.169601,385.751587 157.325455,385.687317 157.728149,385.677979 
	C159.067535,385.777466 160.160049,385.821991 161.659637,385.783081 
	C162.274643,385.655121 162.482590,385.610626 162.969666,385.720032 
	C163.304291,386.078827 163.359802,386.283661 163.211960,386.733521 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M334.628021,139.798279 
	C332.193909,139.887741 329.368256,135.841354 329.001740,141.654404 
	C328.609558,142.384674 328.149475,142.527451 327.310730,142.222351 
	C326.540863,141.550507 326.079010,141.098770 325.617157,140.647034 
	C323.060120,143.349579 321.079315,139.802643 318.369507,140.008057 
	C317.705902,137.704269 320.053101,139.051666 320.778564,137.656937 
	C326.282135,136.473373 331.709473,135.677078 337.570496,134.883575 
	C338.287598,135.257660 338.374146,135.674683 338.172607,136.444672 
	C337.934998,136.949783 337.817871,137.140854 337.489410,137.592712 
	C336.665222,138.505463 335.993622,139.089264 334.628021,139.798279 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M193.937958,261.426392 
	C188.848404,259.081207 193.246185,255.050461 192.096497,252.195389 
	C192.743347,252.134781 193.781296,251.790222 193.975769,252.058060 
	C195.675751,254.399460 198.389221,252.511261 200.616013,253.834503 
	C201.113464,254.214462 201.308609,254.457687 201.070236,254.876556 
	C198.826416,256.618500 199.817383,258.980591 198.869171,261.122040 
	C197.787445,262.018219 196.776535,262.456055 195.288712,262.473175 
	C194.483719,262.405334 194.136719,262.161377 193.937958,261.426392 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M544.486023,131.034210 
	C539.400330,128.977158 534.581665,126.931084 529.399292,124.975937 
	C529.485840,123.534477 529.936157,122.002090 530.612793,120.212402 
	C532.969604,119.423508 531.375000,117.097610 532.991333,116.036690 
	C533.951721,116.248306 534.587036,116.584969 535.496094,116.935356 
	C535.682678,117.267387 535.589111,117.584122 535.508972,117.904221 
	C533.765991,124.868835 533.793701,124.786659 540.700195,127.089043 
	C542.604431,127.723862 545.146973,127.650406 545.856812,130.654694 
	C545.465271,131.026581 545.109131,131.035889 544.486023,131.034210 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M39.592094,387.909393 
	C36.251644,390.955994 31.492476,390.504181 27.147417,391.328735 
	C19.268225,392.824005 11.443865,394.957428 3.119293,394.147949 
	C15.014069,391.820526 27.085751,389.867371 39.592094,387.909393 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M178.932388,336.144531 
	C177.930237,336.373383 177.124191,336.924622 176.733963,336.207581 
	C176.045349,334.942230 177.275177,334.925476 177.974136,334.850128 
	C184.409119,334.156250 190.856949,333.577118 197.286072,332.835052 
	C201.933441,332.298615 206.558121,331.565521 211.281967,331.662231 
	C200.726181,333.910034 190.100693,335.553162 178.932388,336.144531 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M156.315613,167.742218 
	C154.339493,166.102783 151.866486,167.874512 150.162506,165.995087 
	C152.839813,163.957108 156.206360,164.162888 159.599609,163.059616 
	C160.563828,163.006577 161.115967,162.901016 161.887970,162.515503 
	C162.528061,162.326767 162.908783,162.253586 163.578217,162.240250 
	C164.804260,163.011627 166.087906,162.908829 167.212723,163.928375 
	C167.412277,164.449402 167.416153,164.681732 167.251587,165.219177 
	C163.756180,166.841568 160.333755,167.709122 156.315613,167.742218 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M465.195862,255.273315 
	C467.667358,253.330826 465.719940,250.941727 466.203674,248.918518 
	C469.018555,249.108810 471.531830,248.125153 474.384583,248.926895 
	C474.840973,249.258545 475.000275,249.418869 475.310120,249.878357 
	C475.618866,250.810135 475.713593,251.459946 476.123932,252.362823 
	C476.357147,252.874100 476.438995,253.087784 476.554016,253.650269 
	C476.348999,255.576508 475.272614,256.560486 473.774292,257.668823 
	C471.628723,258.500885 469.758484,258.343628 467.489685,258.263000 
	C466.535217,258.104797 466.025879,257.900391 465.268494,257.302429 
	C464.984406,256.998840 465.010590,256.538055 465.029114,256.308044 
	C465.163116,255.895294 465.278656,255.712585 465.195862,255.273315 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M188.261169,370.757019 
	C178.643051,371.962830 169.260437,372.981964 159.445740,373.998596 
	C158.828003,373.795441 158.642380,373.594879 158.708557,373.070770 
	C168.185150,370.147797 177.653244,370.145508 187.588654,370.133942 
	C188.204987,370.295563 188.350830,370.432953 188.261169,370.757019 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M272.062225,160.282715 
	C271.686035,160.184036 271.332062,160.156479 271.154724,160.153809 
	C268.559906,159.142807 266.142456,158.134460 263.364227,157.046417 
	C265.152100,154.812637 275.222748,152.993576 277.212372,154.442825 
	C278.145050,155.122208 277.943573,156.220612 278.001892,157.599731 
	C278.001221,157.998779 278.000000,158.000000 277.999390,158.000610 
	C276.372406,159.325134 274.712219,160.569962 272.062225,160.282715 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M62.598518,161.688828 
	C63.850368,161.960068 62.551666,165.058746 65.151070,163.381302 
	C66.656082,162.410095 65.704025,164.770737 66.363190,165.314407 
	C64.953667,166.772614 64.911873,168.632446 65.320496,170.795959 
	C63.284496,169.686386 64.471581,168.048431 63.405769,166.419022 
	C63.340649,169.086533 61.389507,169.297028 59.901848,170.387878 
	C59.609108,170.709381 59.319958,170.732864 58.912266,170.514099 
	C58.806751,169.848816 58.573326,169.635712 58.087563,169.806046 
	C57.845039,170.137543 57.698677,170.218597 57.301765,170.285477 
	C55.647335,169.125153 55.779518,167.543640 55.899925,165.608368 
	C56.046703,164.996277 56.129498,164.759430 56.406975,164.204346 
	C57.275925,163.162659 58.211758,162.817749 59.283409,162.039780 
	C60.443100,161.337631 61.345188,161.122711 62.598518,161.688828 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M159.250671,351.785217 
	C148.653854,354.776764 138.053284,355.337646 127.365417,355.305115 
	C137.613632,353.742249 147.981522,353.039612 158.590576,351.121948 
	C159.171371,351.245697 159.336868,351.400909 159.250671,351.785217 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M475.078278,127.837662 
	C471.844849,129.263687 468.733673,128.428391 465.837982,129.178116 
	C465.252106,129.329788 464.433472,129.145142 464.450775,128.232925 
	C464.465393,127.463425 465.106323,126.981590 465.753082,127.029205 
	C474.172882,127.649078 482.256134,125.134323 490.562714,124.476601 
	C486.098297,128.141571 480.485321,126.497665 475.078278,127.837662 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M56.833923,163.670456 
	C56.942719,165.773514 56.883549,167.579391 56.937798,169.828293 
	C54.455280,171.776215 52.163353,166.720047 49.488838,169.920898 
	C49.443935,169.104797 49.399036,168.288696 49.172180,167.171753 
	C48.996422,166.464890 49.002613,166.058884 49.035435,165.349487 
	C50.808811,160.907059 53.948536,163.099991 56.833923,163.670456 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M343.665588,134.052002 
	C345.086273,136.564377 345.180664,139.042999 342.650085,140.459579 
	C339.994537,141.946121 337.007782,142.106720 334.062317,140.347275 
	C335.015289,139.312088 336.229370,138.831848 336.810822,137.245071 
	C337.001221,136.998383 337.000000,137.000000 336.999390,137.000610 
	C337.867889,136.317764 339.035980,136.046646 339.780090,134.735229 
	C341.025940,134.273560 342.173645,134.132095 343.665588,134.052002 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M197.135010,239.130676 
	C199.846436,237.502640 202.407272,236.926849 205.785370,237.213562 
	C206.650146,237.958176 206.679062,238.462646 206.540695,239.366669 
	C206.911270,240.791428 206.978119,241.802673 205.930878,242.883453 
	C203.186493,243.954575 200.836258,242.657898 198.078796,242.912354 
	C196.264008,241.979980 195.938004,240.795425 197.135010,239.130676 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M700.731567,89.051735 
	C700.636902,92.639145 699.552063,95.285294 695.082520,94.237740 
	C693.065247,93.764931 692.030945,96.809433 689.409424,95.970947 
	C687.426880,95.166489 687.508118,94.170975 688.768738,92.678856 
	C691.338013,91.578506 693.822449,90.844772 696.674011,90.113800 
	C697.558777,90.539253 698.093811,90.543350 698.783813,89.923180 
	C699.433411,89.449257 699.943115,89.235130 700.731567,89.051735 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M144.663956,325.797241 
	C141.430710,325.868622 138.651001,325.868622 135.871307,325.868622 
	C145.740738,323.737305 155.702103,322.859802 165.705963,322.500336 
	C165.744766,322.924103 165.783585,323.347900 165.822388,323.771667 
	C158.920761,324.423065 152.019135,325.074463 144.663956,325.797241 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M31.259689,382.324890 
	C35.980785,381.765747 40.054729,379.694946 44.546104,380.472687 
	C35.191223,384.051025 25.265484,384.483246 15.494855,385.799011 
	C20.335550,383.394440 25.781984,383.776428 31.259689,382.324890 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M468.204407,246.246429 
	C468.011780,245.995834 467.996002,245.613968 467.987122,245.423065 
	C468.477203,244.348892 469.231506,244.444046 469.199463,244.434662 
	C468.546173,244.339417 467.019592,244.631241 465.254944,244.188217 
	C464.542297,243.993851 464.105682,243.993073 463.341553,243.986832 
	C462.641754,243.555527 462.368378,243.073578 462.161682,242.117279 
	C462.309296,240.469269 462.907654,239.631989 464.634033,239.508606 
	C467.999023,241.335007 471.536926,239.927216 474.911072,241.549408 
	C476.536377,243.907852 475.958221,245.716675 474.023499,247.649673 
	C472.096161,249.008072 470.410034,249.244705 468.296082,248.219391 
	C467.979645,247.905823 468.001038,247.455078 468.010376,247.229645 
	C468.145508,246.835144 468.271240,246.666077 468.204407,246.246429 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M134.065475,340.024597 
	C137.928253,339.745697 141.329544,339.465454 144.730820,339.185181 
	C144.767685,339.594727 144.804550,340.004272 144.841400,340.413788 
	C135.146271,341.378510 125.451134,342.343231 115.755997,343.307953 
	C121.479324,340.567841 127.653259,341.050629 134.065475,340.024597 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M32.590633,409.454712 
	C25.315517,412.284210 17.388430,412.465271 9.419028,412.288452 
	C16.817602,409.775726 24.594704,410.231659 32.590633,409.454712 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M459.302246,122.055794 
	C450.669830,123.816910 442.268280,125.394897 433.525665,124.471985 
	C441.742096,123.394485 449.958496,122.316994 458.591797,121.241150 
	C459.179138,121.416267 459.349609,121.589722 459.302246,122.055794 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M112.227951,166.572998 
	C109.731979,167.289383 107.283386,167.669495 104.418442,168.057037 
	C104.150642,167.186752 104.936424,166.054108 103.133415,165.976440 
	C100.478630,165.862045 101.106949,163.931030 101.101295,162.271652 
	C105.141037,166.763336 108.060814,162.651169 111.676003,160.992096 
	C112.104477,161.823563 112.155922,162.707047 112.084442,163.833099 
	C111.815308,164.213562 111.669083,164.351471 111.728577,164.709778 
	C112.047966,165.365692 112.161644,165.801208 112.227951,166.572998 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M42.771339,421.034119 
	C43.090466,421.166901 43.203243,421.353119 43.129848,421.433502 
	C42.215927,423.367249 40.444752,423.515381 38.823956,423.554199 
	C34.181652,423.665405 29.521622,424.143463 24.423908,423.095825 
	C23.253111,422.711823 22.557463,422.478943 21.528011,422.076294 
	C20.778934,419.602112 22.471733,420.138733 23.683134,420.086670 
	C25.506889,420.008301 27.332779,419.979614 29.595495,419.829010 
	C30.473324,419.767273 30.913418,419.806335 31.679380,419.774048 
	C32.005249,419.702728 32.493267,419.621643 32.740093,419.637756 
	C34.708481,419.699493 36.430038,419.745087 38.579094,419.738708 
	C39.172119,419.664978 39.337654,419.643188 39.749802,419.665039 
	C40.815014,420.106232 41.633614,420.503784 42.771339,421.034119 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M187.261063,328.262756 
	C183.234329,328.611267 179.678497,329.579590 174.949081,328.621948 
	C185.578491,326.062500 195.437653,326.487213 205.129395,325.369934 
	C199.522293,327.595581 193.533279,327.375092 187.261063,328.262756 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M12.583590,169.443161 
	C13.466463,170.901581 14.109571,172.177917 14.877715,173.786774 
	C15.255738,176.130157 13.259190,175.718536 12.139627,176.732819 
	C11.876964,176.931473 11.449203,176.997971 11.233522,176.981461 
	C10.546403,176.578506 10.074965,176.192047 9.279261,175.839172 
	C8.324671,174.392136 7.694349,172.911514 7.007789,171.080658 
	C8.606569,169.718018 9.957467,167.589554 12.583590,169.443161 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M148.687897,332.526794 
	C145.896271,333.448212 143.460846,333.061340 141.003235,332.529388 
	C149.185822,330.417969 157.600433,330.634979 167.057510,329.570526 
	C163.663361,332.428955 160.705521,331.812653 157.958664,332.026947 
	C155.004410,332.257446 152.041809,332.380890 148.687897,332.526794 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M206.566376,381.912415 
	C207.542145,382.100494 208.334564,382.224976 208.607361,382.668854 
	C209.070679,383.422638 208.280167,384.005615 207.705978,383.947510 
	C200.026047,383.170624 192.470078,385.837311 184.812012,384.346619 
	C187.607956,383.615051 190.379562,383.278107 193.565369,382.853394 
	C194.957245,382.127563 196.003006,382.028656 197.506836,382.439819 
	C200.655884,382.336578 203.402588,382.164520 206.566376,381.912415 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M194.739624,305.001892 
	C186.926590,305.058899 179.786835,307.579498 172.349411,306.901550 
	C182.316864,305.255768 192.225372,303.184143 202.474533,303.582825 
	C200.046249,304.052094 197.617981,304.521332 194.739624,305.001892 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M474.792511,119.682762 
	C482.160583,118.203827 489.388062,117.034958 496.615540,115.866096 
	C496.687164,116.323204 496.758789,116.780312 496.830414,117.237427 
	C489.957794,119.193169 482.814514,119.693268 475.332275,120.581116 
	C474.835724,120.407913 474.743805,120.200378 474.792511,119.682762 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M464.662994,257.004456 
	C465.368073,257.027832 465.751709,257.056793 466.417969,257.027100 
	C467.094879,257.137726 467.383820,257.412415 467.566040,258.120117 
	C467.518799,259.222351 466.958038,259.874908 466.951355,260.970032 
	C465.200867,261.800079 465.165039,265.427002 461.911407,263.869019 
	C461.016846,263.107330 460.088135,262.948639 459.212555,262.140503 
	C458.998962,261.894104 459.006012,261.430695 458.998047,261.199097 
	C458.458740,260.170502 459.061401,259.373047 458.992157,258.266174 
	C460.777283,257.641022 462.559418,257.325531 464.662994,257.004456 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M397.035217,247.332764 
	C399.965210,247.100235 402.513611,247.047150 405.490051,247.068542 
	C406.965210,248.221710 406.967743,249.387619 405.730469,250.610657 
	C402.583282,250.710831 399.913788,250.817505 396.835999,250.884399 
	C394.541992,249.600815 395.787384,248.569351 397.035217,247.332764 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M24.788851,283.950073 
	C17.482166,285.591034 10.586923,287.261871 3.355926,286.481689 
	C11.883275,284.936707 20.410625,283.391693 28.937973,281.846710 
	C29.042511,282.143341 29.147047,282.439972 29.251585,282.736603 
	C27.899023,283.134918 26.546463,283.533264 24.788851,283.950073 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M134.757446,362.193176 
	C141.946243,360.222595 149.050232,359.561859 156.606476,359.412292 
	C149.983673,360.896576 143.018234,362.633270 135.398010,362.853760 
	C134.809402,362.679230 134.661758,362.533325 134.757446,362.193176 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M128.599380,170.139465 
	C128.999161,170.175079 129.008316,170.580414 129.003632,170.783081 
	C129.083344,171.706924 128.954132,172.383148 128.308411,173.238098 
	C124.177483,173.940918 120.258545,175.859375 115.984085,172.756332 
	C120.344490,171.809509 124.272049,170.956680 128.599380,170.139465 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M162.839798,315.373505 
	C172.067413,313.988586 181.116302,312.867584 190.165207,311.746582 
	C181.515396,314.065613 172.799438,315.709808 163.460938,316.157928 
	C162.892563,315.993835 162.776810,315.815613 162.839798,315.373505 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M160.037140,308.096985 
	C159.440964,311.656006 156.899704,310.954529 154.356628,311.010010 
	C152.544861,309.930603 150.847931,310.873077 149.130905,310.021179 
	C148.944458,309.314453 148.979050,308.939209 149.009369,308.281281 
	C150.187607,305.142029 152.743195,306.945587 154.877258,306.145874 
	C156.044006,306.041046 156.926086,306.142670 158.227081,306.391449 
	C159.130417,306.934448 159.707214,307.225830 160.037140,308.096985 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M123.811699,382.667572 
	C131.754135,381.516876 139.582703,382.550110 147.606857,381.235657 
	C142.173920,384.191864 135.811432,382.499512 129.426025,383.873718 
	C128.842682,384.084869 128.677658,384.231567 128.251495,384.174561 
	C127.549194,383.981476 127.108047,383.992065 126.343216,384.078857 
	C125.606255,384.416595 125.154526,384.516235 124.330048,384.364288 
	C123.668816,383.875000 123.543785,383.436462 123.811699,382.667572 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M420.745483,232.773132 
	C419.175903,232.627380 417.631927,232.497681 416.019897,232.637115 
	C414.565430,232.960770 413.178955,233.015259 411.375122,233.041855 
	C409.982849,231.636414 410.529785,230.542953 411.936523,229.331757 
	C414.555969,229.053802 416.843689,228.992157 419.560303,228.872726 
	C422.188721,229.201340 421.889374,230.661011 421.127319,232.507004 
	C420.817413,232.827682 420.771027,232.789154 420.745483,232.773132 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M391.334656,264.082092 
	C391.642578,266.684052 390.302277,267.927063 387.365631,267.845886 
	C385.650665,266.471985 383.734436,267.619232 381.857849,266.976562 
	C381.467926,267.136749 381.594940,266.692322 381.804260,266.596710 
	C382.013611,266.501099 382.457397,266.388336 382.561829,266.184601 
	C384.866913,262.991760 388.283051,265.204834 391.334656,264.082092 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M647.477783,100.195709 
	C649.225281,101.348190 651.567932,100.212860 652.674072,102.835312 
	C651.640503,104.145515 650.496582,104.369408 649.331665,105.271271 
	C648.604187,105.589676 648.158325,105.662148 647.364868,105.614952 
	C645.406372,104.737076 644.085754,105.931458 642.312988,106.114120 
	C642.013550,104.515076 641.860291,102.998642 642.867432,101.309433 
	C644.314514,100.099030 645.773926,100.012756 647.477783,100.195709 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M187.766235,294.168213 
	C188.026596,293.954132 188.022781,293.471863 188.019348,293.230652 
	C189.103424,292.999023 190.190948,293.008636 191.686401,293.031128 
	C192.776688,293.795288 193.022171,294.698517 193.018692,296.048889 
	C193.049866,298.505096 195.720673,296.552551 195.811310,298.965912 
	C193.560150,298.965912 191.119690,298.965912 188.236191,298.933350 
	C187.354340,298.394714 186.849899,297.939453 186.469757,296.988770 
	C186.247864,295.652954 186.683502,294.921722 187.766235,294.168213 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M81.796799,191.314270 
	C83.499054,188.122421 84.969872,185.258591 86.697891,182.172028 
	C87.226997,181.718567 87.512199,181.505783 88.078766,181.287811 
	C88.928055,181.422348 89.526497,181.570984 89.201065,182.628082 
	C88.438988,186.412903 87.280876,189.820450 85.213516,193.247498 
	C84.439301,193.699753 83.937141,193.795547 83.028015,193.687714 
	C81.842728,193.187531 81.544220,192.503082 81.796799,191.314270 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M141.242050,347.704773 
	C132.559814,348.160278 124.187386,349.698517 115.690536,348.151001 
	C123.829712,347.725708 131.968887,347.300385 140.577377,346.899628 
	C141.201111,347.105530 141.355530,347.286926 141.242050,347.704773 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M225.261414,373.976990 
	C225.663406,374.530975 225.660187,375.076080 225.484283,375.836975 
	C222.485229,377.212921 219.581375,377.293610 216.325058,376.431580 
	C215.714676,375.834839 215.360931,375.535767 214.977173,374.931030 
	C215.956161,372.138519 217.940628,372.899200 219.543076,373.387756 
	C221.318298,373.928986 223.074081,373.897369 225.261414,373.976990 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M421.252380,232.886719 
	C421.067810,231.619247 421.384064,230.406387 420.283813,229.041901 
	C419.989197,228.814941 419.986511,228.456238 419.984711,228.276886 
	C421.272156,226.946945 422.859894,227.794708 424.581879,227.251556 
	C425.316620,227.025696 425.740051,227.005432 426.481079,226.970444 
	C427.297394,227.331100 427.510040,227.828735 427.209442,228.815948 
	C427.232910,229.518906 427.483429,229.854538 427.879944,230.342133 
	C427.751129,231.149338 427.488373,231.808594 427.122253,232.776428 
	C425.152130,233.009048 423.419739,232.977417 421.252380,232.886719 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M405.630859,255.018982 
	C405.494171,257.039276 407.726257,260.390930 402.891785,260.979065 
	C402.069824,261.758636 401.605713,261.898926 400.749573,261.983673 
	C399.383911,262.196350 398.431854,262.086639 397.249481,261.336121 
	C396.946442,261.129486 396.535980,261.000763 396.324219,260.963257 
	C394.889648,259.199921 395.251709,257.931244 397.613922,257.081726 
	C398.018341,257.040558 398.459625,256.943024 398.685577,256.946533 
	C400.329987,258.269440 401.598572,258.398193 402.806152,256.216827 
	C403.585968,255.184799 404.412323,255.017715 405.630859,255.018982 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M28.984018,326.835632 
	C27.622417,326.915894 26.646938,326.915894 24.582294,326.915894 
	C32.338902,322.981995 39.933132,323.704590 47.254242,322.952057 
	C41.292873,324.219818 35.331505,325.487579 28.984018,326.835632 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M485.918457,214.815872 
	C489.406799,214.582077 492.589691,214.582077 495.772552,214.582077 
	C490.037659,215.315353 484.485382,217.631073 478.155273,216.690643 
	C480.345306,212.814072 483.628326,217.341675 485.918457,214.815872 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M129.844940,402.366089 
	C135.752914,402.096924 141.416397,402.080505 147.550995,402.046356 
	C148.134506,402.179352 148.246902,402.330109 148.169174,402.689209 
	C147.979050,402.897552 148.056854,403.202820 148.044617,403.360565 
	C146.849136,402.817291 145.725311,402.963928 144.320297,403.915771 
	C143.846146,404.173370 143.698425,404.270782 143.291626,404.310608 
	C138.996536,404.159027 134.960571,404.065094 130.460968,403.939453 
	C129.690567,403.531830 129.558228,403.102173 129.844940,402.366089 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M40.675259,392.822144 
	C41.409977,393.033752 41.826824,393.086792 42.556717,393.179199 
	C42.838486,394.110687 42.592915,394.743347 41.522804,394.884521 
	C36.329292,395.570007 31.143032,396.310425 25.528868,396.987305 
	C28.168278,393.562225 32.524006,394.859955 36.657429,393.724640 
	C37.998528,392.682861 39.130573,392.503265 40.675259,392.822144 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M479.547455,198.699036 
	C482.854431,198.606735 485.710266,197.169296 488.629944,198.987488 
	C483.023376,200.813461 477.094696,199.198410 471.451691,200.662933 
	C473.592102,197.648880 476.728149,200.261002 479.547455,198.699036 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M192.711670,347.300659 
	C200.053329,347.252869 207.038040,345.360016 215.027847,346.173462 
	C210.107071,348.126129 205.793442,348.061432 201.526337,347.991302 
	C198.726349,347.945282 196.015701,348.231659 193.021179,348.668915 
	C192.622070,348.149231 192.526703,347.883575 192.711670,347.300659 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M225.422745,295.385773 
	C225.883301,298.456421 226.133881,301.858704 226.564285,305.623840 
	C226.735947,307.717072 226.727783,309.447388 226.622284,311.600525 
	C225.674423,311.748749 225.069717,311.220428 225.068329,310.284576 
	C225.063400,306.957642 225.543961,303.154083 219.734863,306.548706 
	C220.768082,303.187805 224.708862,305.079620 224.933365,302.083221 
	C225.091980,299.966187 225.124146,297.839661 225.422745,295.385773 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M39.719734,348.958984 
	C42.130733,347.901917 44.210590,347.813354 47.150665,348.380249 
	C39.653919,350.874603 32.589291,351.271271 25.428295,351.196808 
	C30.049593,350.459167 34.670891,349.721527 39.719734,348.958984 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M183.682755,158.074631 
	C187.061539,159.112671 184.999649,160.200302 184.099121,161.559235 
	C184.055756,161.851974 183.592117,162.023331 183.346191,162.047791 
	C181.116058,161.661896 179.180939,162.548553 176.851044,162.172623 
	C176.499374,162.049835 176.509430,162.004349 176.509445,162.029480 
	C175.415421,162.623093 174.456451,162.540359 173.824585,160.946716 
	C176.871307,158.896133 180.036057,158.312286 183.682755,158.074631 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M85.056053,193.113953 
	C86.102524,189.640411 86.357056,185.977539 88.894554,182.989105 
	C89.444313,182.872726 89.734261,182.898972 90.460678,182.939697 
	C90.476479,186.390030 89.193024,189.503632 87.198944,192.724518 
	C86.545654,193.416138 86.000961,193.531998 85.056053,193.113953 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M39.180038,159.581543 
	C36.544327,160.564301 34.354671,161.973587 31.362263,161.950043 
	C30.702696,161.797562 30.428429,161.605835 30.012299,161.201065 
	C31.926657,157.805115 35.189800,157.555328 38.754303,157.675934 
	C39.383438,158.301605 39.523525,158.759552 39.180038,159.581543 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M405.672485,250.719666 
	C406.203918,249.858582 405.962433,248.861938 405.871399,247.515091 
	C408.484650,245.360092 411.102600,245.484985 413.955231,247.308838 
	C413.436676,249.244278 411.697357,248.852036 410.271576,249.799622 
	C408.905273,251.292542 407.476776,250.958237 405.672485,250.719666 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M715.664185,77.580231 
	C718.719788,78.222687 717.764221,79.289291 716.158813,80.688629 
	C715.588318,81.102005 715.182556,81.228416 714.471619,81.455582 
	C713.457336,77.412392 709.799927,79.195847 707.518127,78.523453 
	C706.280945,78.158897 705.020264,78.700035 705.002441,76.448410 
	C708.528076,75.905968 711.881104,76.930519 715.664185,77.580231 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M192.331863,250.623367 
	C190.322327,251.000229 188.788849,250.994995 187.563431,253.021942 
	C186.425415,254.904343 183.994827,253.900375 181.746338,253.801941 
	C183.465256,252.346466 186.529053,253.645859 186.926575,250.300537 
	C186.428101,249.316223 186.219223,248.609222 186.540710,247.470276 
	C188.319229,248.964905 189.768799,246.857208 191.620529,246.976990 
	C192.112625,247.157883 192.281372,247.336166 192.619171,247.842789 
	C192.967560,248.917603 192.891739,249.635529 192.331863,250.623367 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M445.251801,237.625015 
	C443.142273,237.594971 441.436615,237.638733 439.730621,237.660934 
	C438.952362,237.671066 437.956909,237.744980 438.139374,236.595093 
	C438.212128,236.136597 439.020477,235.794815 439.732788,235.153656 
	C440.610962,234.187576 441.454895,234.025269 442.689514,234.034637 
	C444.079956,234.017929 445.141357,233.997528 446.601379,233.988556 
	C447.921356,235.728989 447.956635,237.135147 445.251801,237.625015 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M30.836487,357.721039 
	C29.152399,358.024139 27.848307,358.399841 25.973770,357.289276 
	C32.961330,355.550964 39.431313,354.463348 46.154408,355.542664 
	C41.179016,356.222137 36.203625,356.901611 30.836487,357.721039 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M474.917603,145.103516 
	C471.230225,145.169983 467.926117,146.248962 463.200775,145.089752 
	C467.863159,143.301422 471.370178,143.277542 474.799286,143.081482 
	C476.135620,143.005066 476.307892,144.007339 474.917603,145.103516 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M183.811310,257.182373 
	C185.711899,256.214661 187.545532,255.010010 188.890579,257.127625 
	C190.733658,260.029236 186.757584,259.784729 186.129333,261.795563 
	C185.991501,262.100067 185.623764,262.407837 185.384186,262.398254 
	C185.197144,260.508575 183.632156,260.136292 182.185379,259.162964 
	C181.651260,257.481689 182.787933,257.632263 183.811310,257.182373 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M455.321045,243.694946 
	C453.007782,243.741379 452.345398,242.081284 453.364197,240.984406 
	C455.615784,238.560303 452.703796,238.245193 452.062347,236.706039 
	C452.243713,235.505341 452.965973,235.280334 454.165100,235.253387 
	C455.513763,235.611298 456.533539,235.428619 457.812653,235.811279 
	C458.849548,237.271851 458.017334,238.567261 458.053101,240.139420 
	C457.844818,240.590515 457.737885,240.754547 457.436279,241.125458 
	C456.972626,241.570511 456.708679,241.814194 456.306702,242.271530 
	C455.999054,242.769913 455.837402,243.062836 455.321045,243.694946 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M395.771423,231.211609 
	C396.776123,230.982712 397.515320,230.943710 398.619354,230.842621 
	C399.731995,230.339661 400.512939,230.215927 401.670929,230.780029 
	C403.391357,231.018021 404.780914,231.010300 406.587280,230.985901 
	C408.475739,230.174957 409.231232,230.648056 408.983154,232.559845 
	C404.465851,232.892731 400.295288,232.949310 395.687683,232.951706 
	C394.465393,232.250412 395.056335,231.838013 395.771423,231.211609 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M29.190393,257.404785 
	C23.862947,258.553192 19.004791,260.258118 13.752947,259.432556 
	C19.000422,258.258179 24.241840,257.054352 29.508135,255.971527 
	C29.884790,255.894089 31.659636,255.006729 30.963680,256.932770 
	C30.875368,257.177185 30.044416,257.153198 29.190393,257.404785 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M155.259842,373.731934 
	C149.949142,374.626404 144.883865,375.298157 139.385620,375.910828 
	C138.792755,375.698395 138.632812,375.545013 138.733002,375.184753 
	C143.929993,373.443970 149.078094,373.612732 154.581161,373.077698 
	C155.182312,373.207611 155.343781,373.358429 155.259842,373.731934 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M466.081543,153.480011 
	C468.204102,150.787811 471.542358,152.194504 474.345551,151.287537 
	C474.522583,151.230270 475.148376,151.851044 475.182129,152.194092 
	C475.280945,153.198578 474.524506,153.693817 473.670685,153.716446 
	C471.246063,153.780685 468.818207,153.722504 466.081543,153.480011 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M471.234497,218.295929 
	C468.910950,217.966644 466.785431,218.545990 464.405487,217.609451 
	C467.035492,216.070740 469.683807,217.469025 472.402374,216.633133 
	C470.380829,215.366943 468.078949,216.787125 466.051941,215.045624 
	C468.633911,215.045624 470.864746,215.050461 473.095581,215.043518 
	C474.175201,215.040161 475.685516,214.479019 475.691559,216.274979 
	C475.697876,218.140900 474.183807,218.101944 472.408630,218.042648 
	C471.831512,218.244980 471.653107,218.402603 471.234497,218.295929 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M668.671570,99.476593 
	C667.989441,98.417900 667.978943,97.835190 667.954712,96.814377 
	C670.368347,95.901863 672.795715,95.427452 675.613159,94.992157 
	C676.578186,95.703697 676.758362,96.477188 676.421204,97.719292 
	C674.349304,100.217644 671.958435,100.503151 668.671570,99.476593 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M115.955566,371.146912 
	C114.684258,371.083191 113.717934,372.115112 112.424026,370.356323 
	C118.741798,369.781891 124.648796,369.244781 130.555786,368.707703 
	C130.603027,369.104034 130.650253,369.500336 130.697495,369.896667 
	C125.912033,370.302124 121.126572,370.707611 115.955566,371.146912 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M173.617004,160.475525 
	C174.165329,161.328094 174.695587,161.909515 176.078308,162.053177 
	C174.676254,165.910385 170.877243,164.486084 167.490082,165.392670 
	C167.083740,165.300507 167.084351,165.076721 167.080475,164.517303 
	C167.032364,163.565887 166.583862,163.053802 166.785263,162.152924 
	C167.394714,161.735931 167.842911,161.582596 168.541473,161.455505 
	C169.737274,161.858765 170.681030,162.141052 171.827789,161.230499 
	C172.461090,160.862549 172.873917,160.696198 173.617004,160.475525 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M191.658691,276.306580 
	C191.610718,275.838959 191.667953,275.661957 191.843170,275.232086 
	C192.342834,274.652344 192.784836,274.482605 193.626068,274.609985 
	C195.606888,274.185669 197.248840,273.621521 199.137848,273.005249 
	C200.315781,274.469696 200.345490,275.814362 198.328003,276.932098 
	C197.845230,277.210754 197.679962,277.386414 197.249756,277.315735 
	C196.984802,277.069458 196.489487,277.021179 196.244781,277.066345 
	C195.837936,277.200409 195.675797,277.289276 195.260162,277.265564 
	C194.833832,277.114197 194.661011,277.075470 194.223007,277.020813 
	C193.851425,276.871399 193.745041,276.737976 193.501740,276.820862 
	C192.530426,277.984955 192.058960,277.612030 191.658691,276.306580 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M410.339752,250.060059 
	C410.445984,248.003922 412.239380,248.370316 413.880920,247.834885 
	C414.727814,247.328735 415.301331,246.971817 416.098633,246.563217 
	C416.711273,247.901855 418.053497,248.095474 419.159546,248.667740 
	C417.954132,250.254272 416.132874,249.430618 414.411743,250.046295 
	C412.960327,250.100510 411.819855,250.099121 410.339752,250.060059 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M197.091125,238.977539 
	C196.799271,240.006729 195.976791,241.057922 197.500870,242.558823 
	C197.346008,243.074356 197.005203,243.269989 196.542282,243.633118 
	C195.589127,244.342712 195.638779,241.728607 194.256622,243.090546 
	C193.039505,242.939713 192.093948,242.971039 190.803604,242.912933 
	C189.390518,242.545334 189.242035,241.709335 189.368042,240.378586 
	C190.754089,239.763611 191.999130,239.562454 193.616669,239.250748 
	C194.124557,238.978195 194.259979,238.816162 194.693878,238.760254 
	C195.551437,238.912949 196.110535,238.959518 197.091125,238.977539 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M141.407776,347.974731 
	C140.994507,347.772400 141.014877,347.603516 141.040985,347.179413 
	C146.519470,346.251648 151.992233,345.579132 157.465012,344.906586 
	C157.524811,345.418152 157.584625,345.929688 157.644440,346.441254 
	C152.376755,346.963593 147.109085,347.485901 141.407776,347.974731 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M174.953568,358.087646 
	C172.880981,358.083191 171.249817,358.083191 169.618668,358.083191 
	C175.152756,355.792419 180.868927,355.835602 186.624924,356.102570 
	C183.017044,357.596008 178.963425,356.480072 174.953568,358.087646 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M412.085266,127.590103 
	C417.626038,126.505096 423.109467,125.779961 428.592896,125.054825 
	C423.985687,127.301262 419.092255,127.927589 413.706726,128.270630 
	C412.778046,128.475342 412.357849,128.371796 412.085266,127.590103 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M475.717651,223.911530 
	C472.750763,227.880737 468.540222,225.546219 464.414490,225.317810 
	C464.603699,224.764725 465.055969,224.523087 465.757782,224.209595 
	C466.140594,223.913940 466.273834,223.690125 466.704529,223.719681 
	C468.738068,224.060043 470.474213,224.147034 472.612152,224.037933 
	C473.013977,223.841812 473.461304,223.629776 473.708618,223.639893 
	C474.427216,223.710892 474.898499,223.771759 475.717651,223.911530 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M429.203857,177.059479 
	C431.773193,177.053101 433.643188,178.520065 436.855225,177.724350 
	C433.867401,180.043945 431.447021,180.034271 429.053986,180.056595 
	C428.125031,180.065277 426.815277,180.388336 426.586945,179.093292 
	C426.314514,177.548126 427.622406,177.266068 429.203857,177.059479 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M20.889383,205.941650 
	C16.452597,207.286423 12.439781,208.700806 8.004438,208.381454 
	C12.947812,206.880524 17.891186,205.379593 23.049509,203.813400 
	C22.859707,205.374802 22.024742,205.565979 20.889383,205.941650 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M473.931366,167.524048 
	C476.005432,167.794296 477.359161,168.835602 474.742615,169.376114 
	C471.753082,169.993668 468.505035,170.633713 464.649597,169.566864 
	C467.739136,167.048752 470.891418,168.495041 473.931366,167.524048 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M676.435547,98.485939 
	C675.998901,97.256439 676.000244,96.514709 676.002380,95.402130 
	C676.410339,94.885857 676.817383,94.740448 677.546021,94.550583 
	C679.059509,95.170822 680.369751,95.517593 681.972900,96.028503 
	C682.480042,96.239494 682.674133,96.340614 683.116943,96.651550 
	C683.900879,97.521797 684.251160,98.303848 684.938171,99.246216 
	C685.199158,99.708801 685.281494,99.907135 685.357910,100.430420 
	C685.242371,100.944313 685.132629,101.133247 684.748535,101.505119 
	C684.061279,101.849266 683.635376,101.960655 682.864990,102.043045 
	C680.007446,102.204636 678.804810,99.921745 676.435547,98.485939 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M455.504211,137.120941 
	C457.299652,138.266678 459.029053,136.978058 461.235809,137.974426 
	C458.570068,140.991653 455.543030,139.946381 452.769104,139.684647 
	C452.033447,139.615219 451.833282,138.818192 452.117584,138.146774 
	C452.715546,136.734665 454.134186,137.512924 455.504211,137.120941 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M163.469299,387.068207 
	C163.008606,386.978485 163.013763,386.545624 163.019623,386.329254 
	C165.963699,384.607758 169.138184,385.278473 172.639374,385.214417 
	C175.081955,385.199524 177.107147,385.084442 179.569199,384.971375 
	C180.024902,387.324829 178.143890,386.961121 176.819824,387.005554 
	C172.526337,387.149536 168.227051,387.120392 163.469299,387.068207 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M207.627869,230.022919 
	C209.164749,226.089752 212.148178,226.995224 215.397644,227.419556 
	C215.576920,228.084671 215.054260,228.308853 214.307922,228.701691 
	C213.341904,232.185928 210.652847,230.634918 208.305511,230.989075 
	C207.784332,230.780594 207.687256,230.572769 207.627869,230.022919 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M183.256958,320.783936 
	C178.343842,322.864166 173.548294,323.348816 168.586014,322.350403 
	C173.275589,322.275238 177.654709,320.492737 182.675949,320.107605 
	C183.232391,320.315460 183.372833,320.464783 183.256958,320.783936 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M438.432983,258.419861 
	C438.062134,257.594055 438.072784,257.077362 438.098328,256.173401 
	C439.035492,254.908813 440.059082,254.175964 441.434387,253.400848 
	C441.957062,253.179230 442.250336,253.174316 442.981506,253.212250 
	C444.016113,253.950500 444.987152,253.982086 445.852203,254.797516 
	C446.035034,255.698059 446.035919,256.325470 446.050964,257.267303 
	C443.950562,259.874603 441.342377,259.048004 438.432983,258.419861 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M187.736710,277.143372 
	C188.005310,277.102753 188.253067,277.437317 188.449677,277.505188 
	C188.449066,277.824738 188.379242,278.107849 188.510269,278.634308 
	C188.662964,279.676544 188.191376,280.176361 187.242859,280.765137 
	C186.937912,280.957214 186.978455,281.007294 186.972198,280.975800 
	C186.332962,281.558472 185.580734,281.774750 184.350800,281.431641 
	C182.108200,280.990997 179.968704,280.875671 182.721771,278.156189 
	C183.781479,277.266235 184.827774,277.658783 186.049042,277.246216 
	C186.750107,277.159210 187.109116,277.171600 187.736710,277.143372 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M429.597412,151.290527 
	C427.949127,151.315399 426.651642,151.315399 425.354126,151.315399 
	C427.931732,149.156967 430.730438,149.027176 434.054474,149.736526 
	C432.846527,151.442062 431.310394,151.125061 429.597412,151.290527 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M404.865112,173.281738 
	C406.881714,175.833755 406.411011,177.125946 403.198425,176.968079 
	C401.201019,176.869934 399.090546,177.530258 396.627655,176.026047 
	C399.527924,174.546875 403.005371,176.447632 404.865112,173.281738 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M437.957947,258.352295 
	C440.424255,257.989655 442.797058,257.868561 445.617523,257.664612 
	C446.065186,257.581757 446.414703,257.875732 446.624451,257.966003 
	C447.327789,258.387146 447.523468,258.845642 447.082611,259.648621 
	C446.741974,259.866302 446.368622,259.915009 446.199951,259.998291 
	C443.406891,260.278137 440.782501,260.474731 437.783264,260.548096 
	C437.065887,259.691406 437.379944,259.121399 437.957947,258.352295 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M399.667694,129.436768 
	C395.018127,131.392944 389.896454,132.406723 384.507050,131.235107 
	C389.423187,130.498047 394.339294,129.761002 399.667694,129.436768 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M391.038513,224.439117 
	C396.291199,223.741364 401.472778,223.373734 406.654327,223.006104 
	C402.339111,225.983444 397.590790,224.723511 392.553894,225.065491 
	C391.627411,225.303223 391.255035,225.165482 391.038513,224.439117 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M179.530380,284.049744 
	C178.042023,287.402618 174.993317,288.428314 171.831299,286.359253 
	C174.036087,284.502014 176.709366,284.743622 179.530380,284.049744 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M438.623383,132.616577 
	C435.832733,133.365097 433.380249,134.807983 430.365509,133.130402 
	C430.007751,133.005951 429.891449,132.758667 429.890320,132.622040 
	C429.906342,131.805573 430.253021,131.497421 431.328003,131.695557 
	C432.269836,132.469238 433.253174,133.296555 433.629578,132.289505 
	C434.819427,129.105911 437.278168,130.185455 439.887054,130.264771 
	C440.661224,131.593430 440.199463,132.317612 438.623383,132.616577 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M187.632080,293.957886 
	C187.743729,294.699188 187.460846,295.444244 187.131042,296.484863 
	C186.934937,297.719086 186.088028,298.014496 185.255905,298.740814 
	C184.606659,299.006531 184.176620,299.057098 183.426666,299.160889 
	C181.731583,298.433044 180.486877,297.291351 180.865005,295.707397 
	C181.201721,294.297058 182.882294,295.238617 183.910187,294.875305 
	C184.991821,294.492981 186.126221,294.259918 187.632080,293.957886 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M415.605103,236.154388 
	C416.425964,236.412750 416.891235,236.664780 417.636810,236.935822 
	C418.357452,237.457428 418.501984,238.034424 417.921692,238.871948 
	C415.241882,240.289749 413.053131,240.536301 410.854797,238.316254 
	C411.804382,236.315292 413.823578,236.968872 415.605103,236.154388 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M159.450607,352.052917 
	C158.998993,352.014343 158.997208,351.552307 159.001541,351.321381 
	C165.384827,351.076538 171.646317,349.168854 178.509216,349.927887 
	C172.746246,351.976074 166.219254,351.101166 159.450607,352.052917 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M155.748489,282.042358 
	C160.021942,282.007690 163.931458,279.235657 169.010925,281.358704 
	C164.408768,282.883881 160.594818,283.050751 156.338562,282.959167 
	C155.783539,282.716156 155.638763,282.514862 155.748489,282.042358 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M134.606262,262.376404 
	C135.050659,263.745483 135.530396,265.590820 133.819687,265.702271 
	C132.194824,265.808075 130.268936,265.217163 128.934143,264.279572 
	C128.212021,263.772339 128.699234,261.871338 130.404953,262.213074 
	C131.709106,262.474335 132.917130,262.972412 134.606262,262.376404 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M474.533112,119.332138 
	C474.856354,119.644730 474.830780,119.921494 474.891998,120.409225 
	C469.945465,121.196846 464.963318,121.778252 459.532776,122.354034 
	C459.077881,122.163719 459.071350,121.979012 459.036743,121.518555 
	C464.050140,120.592400 469.091644,119.941994 474.533112,119.332138 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M224.816742,366.290894 
	C225.196960,366.556305 225.130310,366.518799 225.157257,366.491455 
	C221.021927,369.099060 216.399948,367.566071 212.041626,368.423737 
	C211.989365,368.023254 211.937088,367.622772 211.884827,367.222290 
	C216.068726,366.823364 220.252625,366.424408 224.816742,366.290894 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M195.291687,362.992004 
	C190.751068,364.619568 186.303192,363.850189 181.466400,364.143921 
	C180.893280,363.954620 180.781677,363.789764 180.853821,363.389587 
	C185.406540,362.778687 189.775513,362.403107 194.590042,362.069336 
	C195.198532,362.304779 195.361465,362.498444 195.291687,362.992004 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M420.842041,183.626740 
	C417.337555,183.885117 414.133179,183.885117 410.928802,183.885117 
	C414.316650,182.301575 417.687744,180.576736 420.842041,183.626740 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M191.038773,340.518799 
	C196.833939,339.832825 202.551086,339.516083 208.268234,339.199341 
	C203.478577,342.028137 198.190582,340.723022 192.672653,341.251221 
	C191.683517,341.526062 191.262604,341.387909 191.038773,340.518799 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M150.708191,338.611908 
	C156.075012,337.931244 161.278290,337.482422 167.345200,336.959137 
	C162.012802,340.722382 156.485992,337.854553 151.352554,339.839600 
	C150.628967,339.571594 150.507721,339.238770 150.708191,338.611908 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M487.009552,183.669846 
	C483.769257,185.409286 480.599335,184.122849 477.423828,184.152924 
	C480.643768,183.501907 483.605469,180.520569 487.009552,183.669846 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M187.747604,320.189148 
	C192.096558,318.142914 196.526550,318.610046 200.845093,318.196228 
	C197.219925,320.962463 192.748947,319.825775 188.335815,320.823730 
	C187.775513,320.644775 187.635101,320.500000 187.747604,320.189148 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M460.710571,129.099213 
	C457.495117,130.341782 454.395996,130.250137 451.251862,129.458420 
	C454.369080,128.253418 457.507721,127.462051 460.710571,129.099213 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M170.434830,211.935654 
	C175.305588,211.224503 179.778442,210.588684 184.251297,209.952850 
	C179.686829,211.958618 175.046509,213.404312 170.073395,213.011703 
	C169.932938,213.000626 169.677597,212.792984 169.693008,212.739670 
	C169.766525,212.484894 169.915070,212.251785 170.434830,211.935654 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M154.625275,366.490662 
	C150.846283,369.106445 146.105896,367.507935 141.383636,368.815430 
	C140.809753,368.684052 140.655701,368.558807 140.744843,368.261719 
	C145.210220,366.098358 149.848602,366.944244 154.625275,366.490662 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M419.680969,200.104675 
	C416.645325,200.136124 414.027771,200.136124 411.599152,200.136124 
	C412.854340,198.450974 418.986542,197.537888 420.798706,199.039841 
	C420.829681,199.065521 420.343781,199.714874 419.680969,200.104675 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M445.248596,225.223175 
	C445.968933,225.664017 446.354156,226.135712 446.862549,226.805435 
	C447.131989,227.193283 447.278290,227.383118 447.107605,227.742599 
	C443.959930,228.097092 441.101349,229.437317 438.182068,227.413055 
	C439.867828,224.772018 442.795624,226.504745 445.248596,225.223175 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M207.320099,229.844971 
	C207.628845,229.982101 207.665878,230.273926 207.829041,230.772400 
	C205.634964,231.628433 203.441162,232.714264 200.608978,231.716599 
	C199.749527,231.306549 199.579315,230.867371 200.068756,230.242065 
	C202.615570,229.899338 204.779846,229.322861 207.320099,229.844971 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M224.994156,382.776215 
	C220.517868,383.041718 216.139420,383.041718 211.422592,383.041718 
	C213.091385,380.820312 215.172516,382.625153 216.975128,381.422424 
	C219.560684,381.492920 221.972443,380.625061 224.571747,381.879974 
	C224.997269,382.145569 225.044647,382.328156 224.994156,382.776215 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M491.046692,198.835419 
	C494.305084,197.021820 498.500275,198.326614 502.109863,195.653778 
	C502.436188,198.433640 501.438446,199.146835 499.260193,199.046173 
	C496.633148,198.924759 493.994659,199.051727 491.046692,198.835419 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M184.868683,262.578491 
	C185.144623,262.388702 185.598969,262.334930 185.795227,262.217499 
	C186.671387,262.678253 188.627792,261.272247 188.124725,263.802795 
	C186.657806,266.521271 184.492172,266.056488 181.939758,265.700134 
	C181.543777,265.775024 181.303406,265.635590 181.178009,265.695435 
	C179.595596,266.540833 179.784897,265.366180 179.999176,264.315308 
	C181.422485,262.499939 183.124802,263.021210 184.868683,262.578491 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M482.921814,160.973434 
	C480.865204,160.893692 479.236206,160.813309 476.390930,160.672897 
	C480.408813,158.431396 483.507904,158.853485 486.819427,159.128326 
	C486.340790,161.474823 484.534119,160.611649 482.921814,160.973434 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M472.979309,159.636658 
	C474.079071,159.477249 474.792603,159.466766 475.049957,160.197540 
	C475.401184,161.194748 474.778351,161.889969 473.855255,161.830475 
	C470.993500,161.646088 468.081635,162.607040 464.876404,161.567856 
	C466.637726,159.229568 468.895905,160.025574 471.284119,159.807617 
	C471.984680,159.727631 472.266785,159.673889 472.979309,159.636658 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M454.583862,170.092987 
	C456.764954,171.532852 458.475769,167.122757 460.490143,170.311264 
	C457.801819,173.622879 454.248169,171.400604 450.902954,171.978821 
	C451.705872,170.260742 452.906647,169.991898 454.583862,170.092987 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M12.298616,176.940002 
	C11.482985,174.770859 13.784910,175.528244 14.736429,174.327515 
	C16.915348,174.809189 18.332859,173.089417 20.098866,173.390045 
	C18.749134,177.316757 15.579341,176.778961 12.298616,176.940002 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M419.089996,134.117340 
	C418.864563,132.456955 419.745056,131.979630 420.805237,132.108292 
	C422.198761,132.277405 421.795441,133.549896 421.936310,134.466278 
	C422.092346,135.481277 421.617188,136.251144 420.673492,136.058670 
	C417.857330,135.484238 415.293030,137.789124 412.347687,136.677826 
	C414.345490,134.756073 417.162384,135.735794 419.089996,134.117340 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M473.885620,183.555878 
	C475.677490,184.352493 475.704010,185.634811 474.076965,185.638901 
	C471.239655,185.646042 468.295410,186.673187 464.963898,185.088776 
	C467.342102,183.128906 469.810883,184.126816 472.451965,183.872269 
	C473.101105,183.777267 473.320343,183.695694 473.885620,183.555878 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M174.309219,135.043274 
	C176.429886,131.314285 180.291458,133.446594 183.772003,132.962311 
	C181.075150,134.545685 177.949463,135.259308 174.309219,135.043274 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M447.146667,228.064804 
	C446.790680,227.912231 446.838989,227.447281 446.912354,227.225372 
	C447.991821,226.419250 448.452667,224.942642 450.324890,225.245697 
	C451.978210,225.829620 453.348358,225.303253 454.966797,225.768326 
	C455.500702,226.361359 455.590332,226.819031 455.445312,227.640610 
	C454.261200,228.844101 452.979187,228.317459 451.508179,228.732727 
	C449.895447,229.060394 448.645569,228.919144 447.146667,228.064804 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M393.656982,250.716141 
	C390.317047,251.118912 387.113892,251.121689 383.438232,251.100861 
	C382.613098,250.549500 382.509705,249.976593 383.099579,249.274109 
	C383.874756,249.054001 384.204865,248.918549 384.802612,248.781250 
	C385.499908,248.878311 385.933502,248.954605 386.700378,249.035812 
	C387.467590,249.097214 387.905487,249.131134 388.671295,249.108612 
	C389.633728,248.355148 390.299164,247.713852 391.671021,247.864655 
	C392.000336,247.977585 392.490265,248.028931 392.736572,248.029663 
	C393.694275,248.635834 393.879425,249.427948 393.656982,250.716141 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M420.371460,168.247208 
	C417.067596,168.340668 414.161987,168.340668 411.256409,168.340668 
	C413.949707,166.121552 416.998322,167.206207 419.800323,166.342255 
	C420.816376,166.028961 421.606659,166.909042 420.371460,168.247208 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M109.909943,397.328308 
	C113.281334,398.178467 116.687035,395.922821 121.188240,397.914124 
	C116.835190,399.708313 113.295914,398.787506 109.510422,399.001587 
	C109.306961,398.432739 109.545135,397.990326 109.909943,397.328308 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M174.759872,342.940430 
	C176.165726,342.889252 177.145447,342.889252 178.125153,342.889252 
	C173.399155,344.498932 168.665970,345.546509 163.677307,344.189026 
	C167.229446,343.789886 170.781586,343.390778 174.759872,342.940430 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M202.595352,127.560181 
	C202.151886,125.795235 200.118774,124.763863 199.026337,122.730713 
	C199.469772,121.754532 199.776810,120.718285 200.372375,120.511009 
	C201.698227,120.049568 202.048782,121.412399 202.202057,122.252480 
	C202.494339,123.854446 202.460510,125.515923 202.595352,127.560181 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M683.299194,96.829849 
	C681.130615,97.009109 679.231079,97.287140 678.008911,94.878876 
	C679.996521,94.050781 682.125427,93.595421 684.633728,93.140518 
	C686.184875,94.953827 684.739990,95.764000 683.299194,96.829849 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M67.870850,345.351685 
	C67.844749,344.572906 67.867638,344.081635 67.990768,343.234985 
	C68.466843,342.875610 68.842682,342.871643 69.497841,342.811340 
	C70.789536,347.214203 68.707588,351.387848 68.195892,355.774841 
	C68.087700,353.464600 67.979515,351.154327 67.890564,348.405701 
	C67.987686,347.191589 68.011154,346.415649 67.870850,345.351685 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M173.016159,384.990295 
	C170.063217,386.419220 166.941010,385.643158 163.458893,386.027252 
	C162.863174,386.049805 162.700851,385.986694 162.302612,385.811584 
	C165.582001,384.078064 169.173386,383.259521 173.016159,384.990295 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M226.672791,352.172119 
	C227.139877,352.230225 227.315018,352.550964 227.208496,352.699280 
	C221.900558,353.271973 216.699127,353.696320 211.497696,354.120667 
	C216.258453,351.973846 221.168793,351.440308 226.672791,352.172119 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M117.227180,357.021667 
	C116.045410,356.910248 114.777016,356.911194 114.619499,356.493347 
	C114.287621,355.613007 115.165428,355.050812 116.047211,355.036255 
	C118.956444,354.988251 121.866974,355.018188 125.975365,355.018188 
	C122.565277,356.411804 120.153946,356.874420 117.227180,357.021667 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M24.755539,371.199707 
	C29.700296,369.783478 34.414459,368.781586 39.350971,369.641357 
	C34.832954,370.409088 30.314932,371.176788 25.385113,371.924255 
	C24.816824,371.743530 24.660334,371.583069 24.755539,371.199707 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M208.786285,242.165649 
	C210.636719,241.482895 212.491241,241.801605 214.046600,240.654465 
	C215.343765,239.697723 216.499802,239.937378 217.085358,242.012848 
	C217.654755,244.872711 216.160233,244.136490 214.565109,243.829437 
	C212.501740,244.230255 210.975449,243.414505 208.966934,242.896286 
	C208.556900,242.812317 208.605209,242.328140 208.786285,242.165649 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M151.769745,240.325195 
	C155.391617,239.389511 158.796570,238.763687 162.201508,238.137863 
	C162.281174,238.656876 162.360825,239.175888 162.440475,239.694901 
	C158.778290,239.814072 155.338898,241.245834 151.769745,240.325195 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M520.958679,240.590164 
	C519.335876,240.948120 517.770203,240.859543 518.292908,238.583496 
	C518.690918,236.850174 519.149414,235.130753 519.879700,233.163757 
	C521.186646,235.254166 520.750122,237.752899 520.958679,240.590164 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M150.463852,225.376953 
	C147.796280,226.515442 144.697281,224.791641 143.166519,228.275238 
	C144.157410,224.671616 148.259506,223.569000 155.451462,224.351517 
	C154.087540,225.822998 152.256424,224.441345 150.463852,225.376953 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M485.944183,205.876694 
	C488.575378,206.057877 488.784058,207.273560 486.801208,207.714539 
	C484.304199,208.269897 481.589905,207.848434 478.338348,207.848434 
	C480.669006,205.032349 483.306763,206.381104 485.944183,205.876694 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M480.047455,151.177643 
	C482.794739,151.009796 485.212585,151.009796 487.630432,151.009796 
	C484.999634,152.747330 482.377380,153.954102 480.047455,151.177643 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M414.821533,254.049179 
	C416.151184,254.818710 418.476410,252.483963 418.824097,255.168472 
	C419.223175,258.250122 416.470886,257.440338 414.445343,257.973938 
	C413.171326,256.998749 412.994659,255.924896 413.937744,254.455811 
	C414.269287,254.168045 414.647736,254.126831 414.821533,254.049179 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M11.561930,254.691803 
	C14.914820,252.126251 18.976839,252.019485 23.203381,252.770203 
	C19.430010,253.486771 15.656639,254.203339 11.561930,254.691803 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M219.674026,250.864441 
	C220.346786,252.995636 219.080063,253.290726 217.449371,253.649826 
	C215.304398,254.122147 213.940186,253.808090 213.789185,251.234253 
	C215.750839,250.941254 217.498459,250.850708 219.674026,250.864441 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M192.592102,346.999451 
	C192.946762,347.221832 192.901550,347.460236 192.786896,348.056793 
	C190.800690,351.028473 187.872650,348.956360 185.264801,349.904480 
	C184.779877,349.673431 184.636353,349.487640 184.732864,349.044128 
	C187.213715,347.521027 189.622482,346.940186 192.592102,346.999451 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M117.621201,390.000916 
	C118.893608,390.234528 120.604721,389.270142 120.633148,390.981873 
	C120.652122,392.124268 119.250244,392.117859 118.307312,392.114166 
	C115.903320,392.104736 113.499641,392.017517 110.680054,391.806274 
	C110.691910,391.425537 111.119553,391.199982 111.763084,390.859619 
	C112.702591,390.184174 113.524483,389.851807 114.716385,389.854614 
	C115.760246,390.060547 116.509041,390.105499 117.621201,390.000916 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M190.759338,340.126587 
	C191.333710,340.432220 191.550629,340.714844 191.995361,341.150452 
	C188.672241,342.234344 185.128845,342.676239 181.578964,340.777710 
	C184.519943,340.553009 187.460907,340.328278 190.759338,340.126587 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M487.495850,176.164825 
	C484.616211,177.093796 482.062805,177.272247 478.216736,175.981781 
	C482.223816,174.810913 484.953857,173.687958 487.495850,176.164825 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M413.880005,254.111389 
	C414.171265,255.183029 414.073242,256.197998 414.011169,257.595123 
	C412.178345,257.705017 409.490143,259.315735 409.021118,255.401993 
	C410.501984,254.690308 411.996338,254.372513 413.880005,254.111389 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M467.177002,176.564056 
	C469.948547,176.567810 472.377136,175.030090 475.509613,176.850052 
	C472.067047,178.793091 468.967346,178.188797 465.889069,177.739777 
	C465.946075,177.584198 465.961945,177.386765 466.068695,177.281754 
	C466.291565,177.062546 466.562439,176.892136 467.177002,176.564056 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M412.588348,143.812378 
	C415.893982,143.678864 418.868378,143.678864 421.842773,143.678864 
	C418.645020,144.670761 415.459930,146.660248 412.588348,143.812378 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M113.843384,405.211487 
	C115.260574,401.488098 118.565331,403.730743 121.505486,403.049255 
	C122.068336,403.297546 122.200386,403.497070 122.157806,404.010071 
	C121.567574,404.342865 121.151947,404.362122 120.425636,404.338318 
	C119.903130,404.365753 119.691307,404.436249 119.204422,404.697723 
	C117.527954,406.742401 115.856010,406.068451 113.843384,405.211487 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M416.873962,216.021194 
	C414.740906,215.709320 412.931854,216.484955 410.840729,215.238159 
	C413.658203,213.576523 416.347778,214.451981 418.911011,214.493347 
	C419.524780,214.503250 420.230286,215.242935 419.635773,215.739304 
	C419.130615,216.161087 418.109528,215.964935 416.873962,216.021194 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M427.712128,211.461090 
	C430.088135,211.319656 432.158386,210.142685 434.380524,212.037521 
	C431.833618,213.999100 429.003876,212.682053 426.441345,212.979202 
	C425.630707,213.073181 425.451813,212.241837 426.034973,211.681778 
	C426.315033,211.412811 426.910614,211.472412 427.712128,211.461090 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M496.990143,149.665283 
	C498.206665,149.618896 499.115234,149.690506 498.681946,150.885895 
	C498.561920,151.217102 497.898499,151.542389 497.483856,151.543076 
	C495.569763,151.546280 493.661346,152.632614 491.769806,151.651566 
	C491.520691,151.522354 491.339813,150.596695 491.512085,150.424194 
	C493.012115,148.922394 494.945160,150.309174 496.990143,149.665283 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M197.876312,355.825531 
	C194.641556,356.719788 191.699661,355.600891 188.781479,356.046326 
	C191.921799,355.731140 194.922089,352.888824 197.876312,355.825531 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M462.808472,241.768188 
	C463.008820,242.460129 463.008331,242.894989 463.010895,243.655609 
	C462.008698,244.096512 460.849854,243.758789 460.112671,245.232758 
	C458.820862,247.362778 457.056122,246.200867 455.264038,245.966583 
	C454.984894,245.218628 454.985138,244.879654 454.975525,244.287231 
	C454.965698,244.033783 455.002502,243.996918 455.020691,243.978317 
	C455.497559,243.522202 455.922760,243.045959 456.766907,242.596313 
	C458.274811,242.229935 459.436310,241.856461 460.683411,240.877258 
	C461.683197,240.634338 462.201050,240.956100 462.808472,241.768188 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M446.727844,241.845322 
	C447.010376,242.548218 446.990814,243.013153 446.948730,243.826385 
	C444.915558,245.652542 442.808777,245.613922 440.316071,244.221771 
	C439.945221,242.944351 436.360748,242.340469 440.054199,241.126648 
	C442.337799,241.949493 444.422668,241.235458 446.727844,241.845322 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M491.954437,158.462097 
	C494.554596,157.883606 496.830322,157.628296 499.480804,158.463379 
	C496.619934,161.031097 493.434326,159.923294 490.534027,159.925369 
	C489.417786,159.926132 490.026154,159.228683 490.691620,158.986267 
	C491.001465,158.873398 491.318726,158.780914 491.954437,158.462097 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M480.869629,191.931076 
	C480.162628,191.536133 478.662170,191.669220 479.384888,191.206802 
	C481.902771,189.595947 484.741577,189.425568 488.578094,191.128525 
	C485.573853,192.490051 483.370850,192.036591 480.869629,191.931076 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M164.380371,137.727753 
	C165.505127,134.310776 169.000870,135.468918 171.826401,134.823608 
	C170.170807,137.515762 167.481674,137.606094 164.380371,137.727753 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M30.437794,417.124420 
	C28.555855,416.996429 27.060398,416.803284 25.332741,416.325836 
	C28.061718,415.216278 31.064926,414.739685 34.586716,414.978210 
	C35.159775,415.156555 35.297127,415.307373 35.486656,415.759827 
	C35.466190,416.252228 35.393551,416.442963 35.028160,416.723328 
	C33.431702,416.895050 32.127991,416.977173 30.437794,417.124420 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M196.865250,376.339294 
	C197.186066,376.092346 197.344757,376.024353 197.743164,375.858398 
	C199.880157,374.184967 202.185165,375.352783 204.626343,374.944031 
	C205.181854,375.071014 205.350037,375.084473 205.756165,375.011780 
	C206.388275,374.612366 206.839569,374.467773 207.678040,374.612762 
	C210.417084,376.627045 207.987228,376.760193 207.097885,376.820404 
	C204.053299,377.026550 200.990723,376.967163 197.481720,376.942108 
	C197.028427,376.875183 196.703125,376.518250 196.865250,376.339294 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M160.575134,297.802002 
	C161.374298,298.257812 161.732559,298.797241 162.090820,299.336670 
	C165.064255,296.751251 163.492386,301.389465 165.302704,301.140106 
	C165.237518,301.373840 164.854507,301.625122 164.251587,301.989563 
	C163.855118,302.250000 163.678574,302.397247 163.215912,302.351990 
	C160.127670,301.958221 158.499847,300.988831 160.575134,297.802002 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M467.675110,247.998810 
	C469.502289,248.012039 471.024963,248.118240 472.888000,248.042542 
	C473.231537,247.202087 473.373962,246.553009 474.205200,246.747910 
	C475.566772,247.067139 475.659058,248.166458 475.329132,249.777527 
	C472.482880,248.871384 469.605011,250.890610 466.730011,249.281403 
	C466.773804,248.667648 467.072205,248.379715 467.675110,247.998810 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M138.447144,290.976074 
	C140.844177,291.281647 144.298035,288.372925 144.606796,291.376495 
	C144.905045,294.277649 140.869461,290.926971 139.097809,292.658386 
	C138.647263,293.098694 136.499573,292.874847 138.447144,290.976074 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M22.753746,265.069702 
	C19.185369,265.719818 16.178555,267.416046 11.854530,266.743927 
	C16.135647,264.992554 19.636822,263.823273 23.465788,263.932434 
	C23.621679,263.936920 23.851227,263.974640 23.918161,264.079102 
	C24.610092,265.158936 23.444563,264.750305 22.753746,265.069702 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M137.803558,219.837372 
	C134.957367,220.803680 132.512589,221.766510 129.149323,220.452911 
	C133.691086,219.325500 137.841553,219.720413 142.094421,217.481796 
	C141.083237,220.369568 139.600418,219.978912 137.803558,219.837372 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M447.095703,138.654236 
	C444.946259,141.711853 441.944061,139.319138 439.261627,139.864365 
	C441.690399,138.838898 444.005768,137.336472 447.095703,138.654236 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M320.423279,137.263123 
	C320.847290,138.879211 319.342560,138.837692 318.213318,139.730927 
	C317.546295,140.001190 317.105560,140.000290 316.334259,139.999084 
	C315.449341,140.168457 314.895020,140.338120 314.170776,140.750427 
	C314.115234,141.162613 314.229614,141.332153 314.168823,141.753510 
	C313.377136,141.126434 312.760681,140.247528 312.014343,139.063858 
	C314.425507,137.387299 317.363922,138.159760 320.423279,137.263123 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M150.081055,208.000473 
	C151.788101,207.953506 153.073502,207.953506 154.358917,207.953506 
	C154.376892,208.201691 154.394867,208.449890 154.412842,208.698074 
	C150.395203,209.383835 146.377548,210.069595 141.322556,210.932404 
	C144.270309,208.169113 147.492004,209.715714 150.081055,208.000473 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M474.117920,137.625488 
	C470.659760,137.857941 467.609222,138.007751 464.558685,138.157578 
	C464.540192,137.891235 464.521729,137.624893 464.503265,137.358551 
	C467.631226,136.848282 470.747345,136.234329 473.892639,135.876450 
	C475.235382,135.723663 476.463959,136.170349 474.117920,137.625488 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M498.536560,182.005432 
	C498.063629,183.904358 494.405426,181.559052 494.346497,185.125961 
	C494.344727,185.232239 492.454620,185.591293 491.609833,185.319641 
	C490.768494,185.049118 490.915497,183.949417 491.103149,183.136215 
	C491.409546,181.808334 492.512268,181.992142 493.474548,181.961288 
	C494.961975,181.913605 496.450195,181.891144 498.536560,182.005432 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M442.563141,161.964783 
	C443.950043,161.783920 444.924805,161.658737 445.900818,161.647659 
	C446.644287,161.639221 447.169128,162.125885 447.101196,162.849380 
	C447.066437,163.220016 446.558655,163.829376 446.241974,163.844116 
	C444.297943,163.934708 442.346222,163.924789 440.399628,163.865005 
	C439.618591,163.840988 439.861755,163.100891 440.009216,162.768616 
	C440.432373,161.815170 441.426392,162.294388 442.563141,161.964783 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M384.307861,178.133499 
	C386.831665,178.691330 389.055267,178.585709 391.345703,178.889297 
	C388.573517,180.353973 385.683594,180.495453 382.812958,179.418823 
	C382.384521,179.258133 383.399811,178.499313 384.307861,178.133499 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M144.164505,318.822510 
	C140.487854,318.985657 137.192871,318.985657 133.897903,318.985657 
	C137.457336,319.213959 140.965332,315.162628 144.164505,318.822510 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M429.846863,172.979279 
	C431.236267,173.091446 432.221954,173.186844 433.621552,173.322327 
	C430.939514,176.163788 428.274170,174.899155 425.236328,174.454559 
	C426.492645,172.368759 428.129089,173.184509 429.846863,172.979279 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M13.996065,278.992126 
	C18.010454,277.180511 22.236031,276.317902 26.606237,276.122864 
	C22.879900,277.910126 19.011126,279.061279 14.471085,279.117676 
	C14.051416,279.059540 14.013816,279.015167 13.996065,278.992126 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M387.210968,239.345932 
	C386.445343,238.014694 385.967865,238.937546 385.229553,239.280182 
	C384.982239,239.370773 384.627380,239.056656 384.398010,238.997131 
	C383.518890,238.251556 384.024475,237.825027 384.780579,237.206726 
	C387.467834,236.937012 389.889740,236.855774 392.765503,236.862396 
	C392.340546,239.605942 392.372772,239.551926 390.136902,238.218170 
	C389.787994,238.010025 388.992493,238.550522 388.193024,238.975372 
	C387.807587,239.314636 387.632599,239.423370 387.210968,239.345932 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M155.186920,289.715332 
	C153.698349,291.786987 150.331360,290.330139 150.049072,294.072662 
	C147.539703,288.271545 151.411728,288.947479 154.592072,288.738831 
	C155.114929,289.071747 155.228027,289.253052 155.186920,289.715332 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M427.270508,245.696014 
	C425.496826,249.810699 424.327332,249.991501 422.086060,246.446014 
	C423.765259,245.845490 425.402649,245.626678 427.270508,245.696014 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M492.103271,141.045456 
	C494.398041,141.695465 496.472626,140.225342 498.559082,141.827545 
	C496.334351,143.839172 493.694855,142.799347 491.395691,143.005646 
	C490.769745,143.061829 490.931702,141.685135 492.103271,141.045456 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M493.899292,134.691437 
	C492.420288,134.821762 490.802643,135.216812 490.672028,133.778748 
	C490.496857,131.849625 492.208221,132.603409 493.151154,132.819992 
	C494.351959,133.095825 495.741608,132.368835 496.791748,133.470215 
	C496.280914,134.637100 495.113892,134.274948 493.899292,134.691437 
z"/>
<path fill="#F8D2D8" opacity="1.000000" stroke="none" 
	d="
M49.096054,294.443726 
	C52.170067,295.186401 52.185661,295.311096 49.676502,300.877991 
	C49.238705,298.946136 49.133606,296.911133 49.096054,294.443726 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M456.164246,184.670792 
	C457.581635,184.764740 458.844299,184.165726 459.564941,185.548706 
	C457.209930,187.522797 454.840424,185.633148 452.480865,185.587296 
	C453.595428,185.269791 454.710175,184.956604 456.164246,184.670792 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M134.751007,312.225067 
	C138.371735,311.909485 141.633545,310.249115 145.442902,311.234497 
	C142.301743,313.518799 138.983078,312.757385 135.400543,312.960144 
	C134.806152,312.778412 134.653168,312.614105 134.751007,312.225067 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M459.164612,195.964203 
	C457.237427,198.346893 454.737427,196.643417 451.975372,197.099167 
	C454.357819,195.131378 456.277802,193.302094 459.164612,195.964203 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M495.539490,189.993866 
	C498.028442,190.502090 500.172913,189.123749 503.533051,190.825165 
	C498.564545,190.825165 494.865387,190.825165 490.932220,190.825165 
	C492.057770,188.683594 493.769775,190.089981 495.539490,189.993866 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M430.930176,161.432098 
	C430.112061,161.787399 429.145966,161.897797 428.179779,161.898270 
	C426.854492,161.898926 425.507660,161.870163 425.225891,160.098450 
	C425.096832,159.286957 424.876892,158.397964 425.974884,158.163254 
	C427.682373,157.798264 428.058411,159.072479 428.667450,160.287308 
	C428.922699,160.796387 430.050873,160.867798 430.930176,161.432098 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M388.145538,187.133606 
	C385.763245,186.343903 383.536530,188.015594 381.401703,186.453705 
	C384.406097,185.133667 387.683441,186.820251 390.459686,185.116974 
	C390.991455,184.790726 391.897308,185.240814 391.710907,186.048737 
	C391.269897,187.960068 389.788727,187.298340 388.145538,187.133606 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M386.259857,162.038788 
	C388.409637,162.390747 390.260864,161.214874 392.291290,162.714737 
	C389.704346,165.071045 386.773926,164.051041 384.319855,163.431686 
	C383.457153,163.213989 385.004730,162.314636 386.259857,162.038788 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M413.858765,175.223572 
	C412.904907,175.062424 411.995880,174.355057 412.371429,174.307480 
	C415.294983,173.937180 418.260895,173.901093 422.576843,173.697342 
	C419.059509,176.628815 416.572113,174.864487 413.858765,175.223572 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M114.595062,411.735260 
	C113.276993,412.619476 111.560890,412.846863 109.411835,413.134644 
	C108.133087,413.745911 107.255363,413.783905 106.076950,412.984863 
	C105.805107,412.611084 105.703857,412.458252 105.650894,412.449280 
	C106.443626,412.009888 107.289330,411.579468 108.560364,410.938110 
	C110.798920,409.714935 112.533188,409.874084 114.595062,411.735260 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M500.236603,222.225418 
	C499.005066,224.797729 495.777740,225.109451 493.439697,222.690506 
	C495.720062,222.142578 497.860138,223.347458 500.236603,222.225418 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M390.482056,147.592834 
	C388.278351,148.891541 386.353668,149.496643 383.936768,148.122269 
	C385.690094,145.510223 388.078949,146.146866 390.660217,146.111771 
	C391.205627,146.600906 391.108368,147.030212 390.482056,147.592834 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M129.190933,411.757050 
	C126.638290,412.094330 124.213707,412.150085 121.789268,412.144104 
	C121.143120,412.142517 120.359352,411.853943 120.720673,411.067383 
	C120.906677,410.662476 121.786942,410.576447 122.679474,410.204285 
	C123.361809,410.131042 123.718132,410.199890 124.341660,410.213135 
	C124.941925,410.241791 125.276939,410.317352 125.781876,410.187531 
	C126.413765,409.892029 126.878006,409.791718 127.697983,409.695343 
	C128.053711,409.699280 127.960274,409.846466 127.993973,409.926880 
	C128.532043,410.422943 129.104111,410.778076 129.190933,411.757050 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M204.777527,374.778076 
	C203.009583,375.879059 200.916489,376.081238 198.379456,375.856995 
	C199.188583,370.243469 202.383041,375.063904 204.777527,374.778076 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M476.105164,207.504227 
	C472.408203,209.078079 468.768677,207.678162 465.080383,207.564774 
	C468.741913,207.053391 472.388763,206.449478 476.105164,207.504227 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M117.205048,202.563339 
	C118.369896,202.829147 119.308548,203.397675 120.267197,203.930191 
	C121.465134,204.595657 122.231888,201.616486 123.505859,203.487503 
	C123.968094,204.166382 123.251808,204.962189 122.648277,204.801254 
	C120.874855,204.328415 119.042320,207.452072 117.420494,204.705185 
	C117.112488,204.183517 117.123772,203.473297 117.205048,202.563339 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M29.716219,275.387146 
	C33.354774,274.365692 36.610386,273.037445 40.205448,273.506470 
	C36.856247,275.318420 33.289181,276.129852 29.716219,275.387146 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M173.230743,266.743622 
	C171.852158,267.213440 170.775604,267.325226 170.382217,266.230469 
	C169.980148,265.111572 171.069870,265.083588 171.840332,264.956787 
	C173.524933,264.679443 175.207962,264.392578 177.271790,264.131775 
	C178.306152,268.165131 175.262787,266.276245 173.230743,266.743622 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M225.852722,344.442291 
	C226.252472,344.681152 226.163620,344.646698 226.198044,344.613892 
	C223.471878,346.725739 220.399521,346.251373 216.396713,345.847046 
	C219.766510,343.700592 222.825333,345.171204 225.852722,344.442291 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M446.746033,251.138641 
	C444.057434,251.750061 441.488159,252.468338 438.662659,251.813278 
	C440.781403,249.063034 443.638184,250.257339 446.558655,250.001343 
	C447.133423,250.366180 447.089844,250.661255 446.746033,251.138641 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M208.021942,281.905365 
	C206.268860,282.737244 204.146271,286.141113 202.933289,281.338013 
	C203.647507,279.940247 204.731842,279.823792 206.198578,279.901306 
	C207.475235,280.044128 207.799942,280.720703 208.021942,281.905365 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M205.547821,222.261597 
	C206.062958,222.044266 206.284851,222.023544 206.839828,221.974457 
	C207.599243,221.611664 208.069397,221.530182 208.808594,222.005157 
	C208.599319,226.471512 205.783066,224.845947 203.261200,224.313324 
	C202.650421,221.961884 204.336334,222.753876 205.547821,222.261597 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M162.771576,302.447327 
	C163.112061,302.123810 163.294312,302.088074 163.754120,302.077515 
	C163.517212,303.421936 167.017105,304.437408 164.033691,306.025513 
	C162.773743,307.207733 161.703705,307.738831 160.195404,306.451172 
	C159.636398,304.083832 161.819962,303.931793 162.771576,302.447327 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M472.247101,190.472900 
	C473.693115,190.289886 474.919708,189.493912 475.826447,191.447601 
	C472.432404,192.609085 469.093506,191.837814 465.496246,191.973923 
	C467.495941,189.609772 469.957275,191.625290 472.247101,190.472900 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M170.754700,251.268494 
	C172.220047,248.578415 173.973038,248.760544 176.313324,249.984222 
	C174.224274,248.925568 174.582458,254.381287 171.324280,251.984482 
	C170.868652,251.713928 170.680389,251.594666 170.754700,251.268494 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M487.437988,222.274994 
	C486.702484,222.967789 490.251862,225.014908 486.866943,225.030869 
	C484.174316,225.043579 481.480713,224.855591 478.551208,224.443115 
	C478.314819,224.129547 478.689880,224.120789 478.842834,224.012131 
	C480.981049,222.232300 483.626770,223.649460 486.074066,222.312012 
	C486.674286,222.334656 486.943787,222.399277 487.437988,222.274994 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M119.706711,252.399841 
	C119.091446,251.061584 119.872940,250.734497 120.705307,250.595764 
	C122.021744,250.376389 123.986778,248.858719 124.454742,250.958817 
	C124.847252,252.720276 122.592239,252.075241 121.460182,252.373627 
	C120.988708,252.497910 120.492332,252.527771 119.706711,252.399841 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M458.592987,205.966568 
	C458.972443,206.722198 461.330261,207.574463 459.190491,207.869324 
	C457.043304,208.165222 454.787415,207.672119 451.770020,207.470825 
	C454.061127,205.312439 456.200165,206.080658 458.592987,205.966568 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M27.494606,225.349182 
	C26.100370,226.253494 24.989906,226.143005 23.487680,225.672195 
	C26.545588,223.321014 29.950615,223.531403 33.690559,222.758530 
	C31.698132,224.627533 29.857122,225.147232 27.494606,225.349182 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M387.692749,108.889877 
	C387.453583,107.014206 390.201599,107.776291 389.847168,105.683472 
	C389.624695,105.100716 389.532593,104.751266 389.808838,104.169617 
	C390.024750,103.981339 390.420441,103.908417 390.619385,103.878555 
	C391.054626,104.108101 391.312439,104.343712 391.705994,104.790192 
	C392.214294,106.135315 392.611847,107.242020 392.961182,108.709892 
	C391.544922,109.232307 390.176819,109.393562 388.540894,109.418297 
	C388.102783,109.236191 387.932495,109.190598 387.692749,108.889877 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M413.264526,226.382935 
	C412.659790,225.827988 410.758484,225.630859 412.147339,225.164642 
	C414.802948,224.273193 417.789764,224.368347 421.484253,223.960831 
	C419.280792,226.735657 416.821075,225.547562 414.488281,226.152649 
	C413.902954,226.316666 413.721741,226.435928 413.264526,226.382935 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M455.222168,228.099670 
	C454.890930,227.441589 454.904022,227.086151 454.915527,226.463776 
	C455.895081,224.917862 457.424011,225.879288 458.803894,224.979034 
	C459.777405,224.454498 460.523529,224.252136 461.566528,224.055359 
	C461.244690,225.142273 460.626007,226.223587 460.009094,227.627380 
	C458.612335,228.915253 457.060059,228.370651 455.222168,228.099670 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M29.355644,301.654388 
	C25.948456,302.794922 22.797922,303.504211 19.479736,302.856934 
	C22.824896,302.114807 26.047390,300.644318 29.355644,301.654388 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M40.286934,336.034485 
	C42.612217,335.885620 44.542221,335.791168 46.472229,335.696716 
	C46.506180,335.967712 46.540131,336.238739 46.574081,336.509735 
	C43.235184,337.003784 39.896286,337.497833 36.183670,338.047211 
	C37.288925,336.390381 38.707264,336.493774 40.286934,336.034485 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M414.118561,212.064789 
	C412.757233,212.102997 411.743347,212.296249 410.873749,211.390900 
	C414.100525,211.390900 417.198639,211.390900 421.228760,211.390900 
	C418.378937,214.034073 416.412628,211.415176 414.118561,212.064789 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M427.835236,219.883957 
	C430.328430,219.754242 432.462158,219.197098 435.534760,220.066925 
	C431.511047,221.636887 428.249664,220.790817 424.939789,221.024139 
	C425.503052,219.518799 426.661163,220.159592 427.835236,219.883957 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M155.371826,254.811996 
	C152.931747,254.662048 150.815292,256.562469 147.303940,254.536957 
	C150.990753,254.645126 153.116272,251.565262 155.371826,254.811996 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M121.896873,197.449081 
	C120.104843,197.424438 118.633301,197.373413 117.521545,196.389145 
	C119.134399,195.404297 120.777962,193.930145 122.737389,195.335815 
	C123.461182,195.855042 122.993675,196.801285 121.896873,197.449081 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M181.906342,265.932861 
	C183.456161,265.225830 185.368546,264.676636 187.653534,264.098541 
	C188.147385,270.555450 184.766739,267.065674 181.906342,265.932861 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M499.216766,164.895691 
	C497.069916,166.965118 494.198517,167.144531 489.715790,166.580231 
	C493.518127,164.865463 496.205841,165.081558 499.216766,164.895691 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M164.186768,365.204285 
	C167.345215,365.175903 170.146286,363.902222 174.317627,364.900024 
	C170.098587,366.431366 166.980606,366.345245 163.853302,366.164825 
	C163.788376,366.161072 163.685577,365.928894 163.691223,365.807526 
	C163.698593,365.649475 163.796844,365.495636 164.186768,365.204285 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M128.387115,173.605469 
	C128.200928,172.745407 128.358826,172.021179 128.757812,171.141357 
	C130.767487,171.080643 132.536057,171.175537 134.599945,171.490082 
	C133.163910,173.367950 130.663147,172.691711 128.387115,173.605469 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M390.335907,233.505096 
	C387.668762,234.034271 385.137268,234.284882 382.013306,233.522537 
	C383.429535,231.726089 384.785370,231.764175 386.587769,231.985764 
	C387.931854,231.665634 388.843994,231.055618 390.166809,231.804749 
	C390.577454,232.404587 390.592682,232.809494 390.335907,233.505096 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M40.471073,361.968567 
	C37.020744,363.787445 32.920872,363.928894 28.769136,363.711792 
	C32.473652,362.728149 36.132217,361.443512 40.471073,361.968567 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M392.219696,113.883400 
	C392.267151,112.684212 392.701721,111.607338 393.177795,110.179367 
	C394.457611,110.817818 395.695892,111.807388 396.929199,112.792946 
	C395.603241,114.708755 393.934113,113.607941 392.219696,113.883400 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M171.081360,234.471710 
	C172.650742,234.917938 173.679230,231.934982 175.027710,233.960831 
	C175.462936,234.614670 175.700211,235.712250 174.668839,235.960297 
	C173.237671,236.304489 171.239594,237.607895 171.081360,234.471710 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M493.733948,174.498383 
	C494.248596,174.154251 494.585815,173.990982 494.877991,174.050186 
	C496.806061,174.440887 500.394562,172.677750 500.375305,174.679565 
	C500.347687,177.552414 496.769745,175.382095 494.452271,176.048401 
	C493.646881,175.670670 493.497192,175.263794 493.733948,174.498383 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M425.880981,168.538727 
	C427.302582,165.424210 429.458344,167.452866 432.582703,167.361664 
	C429.931305,169.353622 428.023560,168.864212 425.880981,168.538727 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M204.116928,310.695129 
	C200.577896,311.290375 197.219513,311.679596 193.435394,312.009338 
	C192.907425,311.792358 192.805191,311.634888 192.852631,311.238770 
	C196.370667,310.724365 199.652054,309.579559 203.524902,310.023865 
	C204.072968,310.201050 204.185272,310.345093 204.116928,310.695129 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M141.217316,269.932709 
	C139.187820,269.888458 138.488449,268.900452 140.265701,268.365936 
	C141.770279,267.913422 143.744125,267.349548 145.534988,268.346313 
	C144.937759,271.057861 143.029633,269.761017 141.217316,269.932709 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M154.912186,305.810181 
	C154.190063,309.450409 151.141907,306.125031 149.284424,307.819153 
	C149.005127,307.998627 148.530197,307.970551 148.292603,307.958862 
	C147.686218,307.600250 147.526260,307.170105 147.663788,306.326355 
	C148.302673,305.690125 148.823334,305.396057 149.663666,305.086243 
	C151.215515,304.464935 152.392319,304.707672 153.831146,305.424927 
	C154.298294,305.591461 154.480362,305.636200 154.912186,305.810181 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M411.022400,206.187927 
	C413.908173,203.949051 417.295258,205.344559 420.576355,205.195297 
	C417.627930,206.837784 414.351685,205.864456 411.022400,206.187927 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M33.427479,409.885986 
	C33.019054,409.808044 33.024612,409.506775 33.021446,409.356384 
	C35.837784,408.466248 38.657291,407.726532 41.476803,406.986816 
	C39.501480,409.590088 36.735985,409.961456 33.427479,409.885986 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M115.420006,313.921082 
	C114.916412,313.778168 114.866089,313.613861 114.934822,313.221375 
	C118.193298,312.799713 121.332703,312.606262 124.472115,312.412781 
	C121.805595,314.733185 118.764664,313.714966 115.420006,313.921082 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M169.090820,188.598022 
	C167.074875,186.430603 168.879593,186.196411 170.176743,185.960251 
	C171.031158,185.804672 172.463440,185.715378 172.400940,187.008987 
	C172.319595,188.692978 170.663116,188.519089 169.090820,188.598022 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M441.203033,204.012955 
	C439.377045,203.177948 439.923828,202.365128 441.072754,202.280075 
	C442.970001,202.139618 445.052734,201.078796 447.190033,202.963348 
	C445.362183,204.644211 443.409790,203.891785 441.203033,204.012955 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M385.623871,276.047821 
	C383.799011,279.816711 380.497101,277.584106 377.353088,277.318420 
	C379.819550,276.715973 382.553711,276.395081 385.623871,276.047821 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M142.655701,277.113586 
	C141.413879,276.848236 140.502167,277.849915 139.327164,276.877838 
	C140.199249,275.088226 142.336884,276.615448 143.418900,275.404480 
	C143.803970,274.973511 145.261642,274.843719 145.327194,275.938660 
	C145.424286,277.560760 144.246094,277.680908 142.655701,277.113586 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M453.299744,162.910370 
	C455.074677,161.431808 457.177917,160.149658 459.654694,162.459137 
	C457.691132,163.907318 455.599731,162.839569 453.299744,162.910370 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M15.912944,308.933228 
	C17.274065,308.869446 18.235445,308.869446 19.196823,308.869446 
	C16.390299,309.833618 13.781824,311.720001 10.466488,310.772247 
	C11.807387,308.484558 13.871910,309.404572 15.912944,308.933228 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M403.354797,185.440277 
	C400.980133,185.766754 398.744324,186.399918 396.218323,185.559860 
	C397.874054,182.997742 400.264923,184.335464 402.655151,184.077133 
	C403.385468,184.403198 403.515289,184.764008 403.354797,185.440277 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M117.947891,336.089539 
	C116.764595,335.819855 115.718307,335.491089 117.146027,334.689514 
	C119.386856,333.431396 121.767723,334.150146 124.829231,333.902008 
	C122.547729,336.439240 120.042259,334.858368 117.947891,336.089539 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M400.130798,161.786804 
	C399.170441,162.255463 397.716125,161.787048 397.871216,162.561554 
	C398.498871,165.695816 396.070801,164.006561 395.618805,163.811752 
	C393.903839,163.072693 395.890503,162.496307 395.967468,161.750961 
	C396.183319,159.659729 397.952850,160.113922 399.735779,160.063782 
	C400.443634,160.520966 400.535339,160.998444 400.130798,161.786804 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M173.147186,266.998688 
	C174.054550,265.024078 176.933578,267.486023 177.757324,264.517334 
	C178.250046,264.112427 178.848145,264.070831 179.897247,264.041260 
	C180.482376,264.501495 180.616501,264.949707 180.901611,265.576599 
	C178.751083,267.417908 176.198257,267.739532 173.147186,266.998688 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M442.771301,154.358765 
	C444.460846,154.496964 447.040649,152.323563 447.279449,155.345993 
	C447.457367,157.598038 445.152832,156.687332 443.446442,156.853348 
	C442.416473,156.220886 442.302490,155.492081 442.771301,154.358765 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M137.208954,306.594635 
	C138.788177,304.334717 141.271362,304.555542 143.173965,305.568909 
	C144.237167,306.135254 143.651199,307.433563 141.808929,306.955292 
	C140.463669,306.606049 138.953598,306.891663 137.208954,306.594635 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M122.355843,292.464233 
	C124.011383,292.132660 125.370567,292.468201 124.045471,293.915802 
	C123.091705,294.957703 121.212433,295.418304 119.680519,294.134460 
	C120.033485,292.805420 121.294029,293.114899 122.355843,292.464233 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M393.882965,251.084808 
	C393.408539,250.340317 393.296936,249.564514 393.084106,248.409546 
	C393.940826,246.761047 395.312164,247.048340 397.014435,247.109955 
	C397.114166,248.173508 396.811554,249.193710 396.468323,250.529251 
	C395.700378,250.914230 394.973083,250.983856 393.882965,251.084808 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M195.510788,363.302490 
	C195.052094,363.095154 195.045197,362.898407 195.036957,362.406433 
	C198.777176,361.877380 202.518753,361.643616 207.091415,361.357941 
	C203.147110,364.111755 199.338058,362.392822 195.510788,363.302490 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M120.615967,364.087128 
	C118.253777,364.098816 116.291016,364.098816 114.328247,364.098816 
	C117.436760,362.245544 120.784966,363.338348 124.062958,362.785767 
	C123.420174,364.222565 122.031281,363.715790 120.615967,364.087128 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M401.052338,137.804230 
	C399.476898,139.656723 397.248657,140.032333 396.373047,138.070175 
	C395.624115,136.391830 397.636200,135.827377 399.700684,136.170334 
	C400.500519,136.581757 400.882782,136.970749 401.052338,137.804230 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M392.836548,138.904938 
	C390.811554,140.802811 388.973785,139.765701 387.094604,138.946182 
	C389.041168,138.869247 390.844025,137.329544 392.836548,138.904938 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M458.966187,251.339996 
	C460.368530,250.872330 461.973206,249.914246 462.251648,252.450928 
	C462.506470,254.772461 460.423798,254.478821 459.645294,254.477264 
	C457.005890,254.471985 459.110474,252.699600 458.966187,251.339996 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M485.980530,222.113998 
	C485.095764,225.974808 482.003296,223.115189 479.430725,223.894302 
	C480.356476,220.380020 483.326904,222.593704 485.980530,222.113998 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M154.867935,246.274567 
	C157.876221,246.922043 159.784637,243.896225 162.853271,244.264267 
	C163.620422,244.414368 163.906143,244.661041 164.083267,245.281021 
	C161.457169,246.528275 158.808807,247.172028 155.628937,247.144760 
	C155.047821,247.008057 154.860626,246.816864 154.867935,246.274567 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M384.657166,242.026825 
	C385.890442,242.051620 386.792786,242.212646 387.838013,242.685471 
	C387.847290,243.154449 387.713745,243.311630 387.325012,243.643723 
	C384.873657,244.049805 382.677490,244.280975 380.095642,244.552734 
	C381.132355,242.483017 383.123810,243.028427 384.657166,242.026825 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M214.457489,244.018448 
	C214.014603,242.549545 214.437897,242.107849 215.659027,242.938049 
	C216.194565,243.302155 216.643127,244.443649 217.161865,242.659302 
	C217.446503,242.345581 217.659348,242.470337 217.936951,242.865082 
	C218.391113,243.379730 218.569687,243.820175 218.553528,244.659882 
	C217.500305,245.435242 216.532303,245.857529 215.251465,246.346542 
	C214.567154,246.099167 214.195648,245.785049 213.886353,245.227600 
	C214.373520,244.858078 215.020325,244.920517 214.457489,244.018448 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M169.675873,243.246338 
	C169.989777,242.850418 170.060135,242.661774 170.189804,242.602234 
	C171.658051,241.927933 173.179031,241.482712 174.732941,242.217773 
	C174.989487,242.339127 175.212952,243.178665 175.051834,243.430847 
	C173.897980,245.236893 172.179337,245.177536 170.142288,244.347504 
	C169.761765,243.858246 169.610825,243.685913 169.675873,243.246338 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M45.222599,241.412720 
	C48.170147,243.505325 47.421963,246.722977 46.779236,250.213013 
	C46.091927,247.639908 45.638039,244.727448 45.222599,241.412720 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M195.765259,287.787292 
	C197.214188,288.004974 198.330353,288.712463 197.578888,290.046722 
	C196.450211,292.050751 195.029068,289.567444 193.348877,290.070892 
	C192.401215,289.815338 191.411163,290.410156 191.165390,289.329041 
	C191.907837,289.193146 192.650269,289.057281 193.703705,288.898010 
	C194.198090,288.736237 194.381470,288.597839 194.837967,288.249268 
	C195.111084,288.039124 195.556137,287.892822 195.765259,287.787292 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M141.582581,240.970413 
	C142.812408,240.911804 143.692810,239.668198 144.815735,241.368744 
	C142.098938,242.087204 139.731766,243.492828 136.476364,242.849213 
	C137.920532,241.272537 139.443253,240.844879 141.582581,240.970413 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M401.592316,206.780289 
	C403.538696,206.606979 405.022644,205.378296 406.890656,206.679672 
	C403.482330,209.029190 399.958557,207.868271 396.198059,207.819077 
	C397.921082,206.429169 399.640259,207.117920 401.592316,206.780289 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M397.803162,256.780396 
	C397.335144,258.093170 395.848572,258.663300 396.096863,260.595886 
	C395.337708,260.946991 394.562958,260.968201 393.402374,260.984558 
	C393.109985,260.165466 394.698395,260.190948 393.915039,258.862946 
	C393.496613,258.334930 393.447388,257.928040 393.772400,257.267334 
	C395.026581,255.724075 396.268829,255.852112 397.803162,256.780396 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M392.597778,119.334618 
	C392.951050,119.675880 392.947418,119.998589 392.974091,120.563728 
	C390.353821,121.076981 387.727325,121.348083 385.100861,121.619179 
	C387.126343,119.206421 389.882477,120.097763 392.597778,119.334618 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M161.048920,213.936844 
	C162.847961,213.072815 164.131989,213.350967 165.346664,214.539688 
	C163.685181,215.865509 161.958862,216.228775 160.093719,215.940674 
	C159.755386,215.888412 158.852615,216.089874 159.261673,215.290405 
	C159.529007,214.767899 160.243820,214.474350 161.048920,213.936844 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M141.258423,258.723450 
	C142.337128,257.149414 142.102386,253.442917 146.462555,255.444626 
	C144.023560,255.841599 144.799164,259.702942 141.258423,258.723450 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M682.977844,96.976616 
	C682.867493,95.441895 684.520508,94.997635 684.956421,93.456924 
	C686.031738,92.891647 687.050354,92.642334 688.461243,92.352646 
	C688.835144,93.336105 688.816772,94.359940 688.914368,95.672852 
	C689.030334,95.961922 688.997009,95.999809 688.979431,96.017899 
	C687.156433,96.471451 685.487244,97.430214 683.312805,97.246178 
	C683.054749,97.052872 683.003296,97.002190 682.977844,96.976616 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M38.115696,376.105164 
	C36.757420,376.041443 35.797703,375.964569 34.837990,375.887695 
	C38.222317,375.000610 41.504028,373.632355 45.894535,374.371979 
	C42.882401,375.073975 40.698330,375.583008 38.115696,376.105164 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M481.730713,143.240509 
	C484.162933,141.967743 486.342102,141.272308 489.139832,142.823822 
	C486.973480,144.756622 484.813904,143.985031 482.433868,144.029358 
	C481.834381,143.782394 481.653168,143.631821 481.730713,143.240509 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M115.245094,412.066711 
	C113.318962,411.820404 111.805275,410.471313 109.375092,410.840393 
	C110.236359,407.765778 112.332710,409.079224 114.618385,409.830597 
	C115.364891,410.468475 115.534004,411.028564 115.245094,412.066711 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M122.685188,223.091431 
	C121.049065,222.718414 119.677811,223.576355 118.251640,222.482681 
	C119.567940,220.192673 122.234169,221.046555 123.681526,221.325928 
	C125.505600,221.677994 124.486656,222.849777 122.685188,223.091431 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M169.948792,194.557800 
	C170.662460,193.532898 170.749176,191.538879 172.309128,193.136337 
	C172.901382,193.742889 173.938736,194.829865 172.796036,195.627808 
	C171.880127,196.267380 170.350204,197.047821 169.948792,194.557800 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M415.792694,222.972641 
	C414.104218,223.029755 412.823914,223.029755 411.543579,223.029755 
	C411.530151,222.742035 411.516724,222.454315 411.503296,222.166580 
	C414.343872,221.997604 417.184448,221.828613 420.346893,221.640472 
	C419.119659,223.682541 417.501251,222.656281 415.792694,222.972641 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M390.770874,224.062622 
	C391.164703,224.462067 391.347565,224.727005 391.878357,225.021896 
	C392.239990,228.496475 390.405670,227.717789 388.252655,226.690552 
	C387.808075,226.253983 387.637909,225.973297 387.730713,225.276352 
	C388.626251,224.057983 389.496979,223.944046 390.770874,224.062622 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M447.296783,148.781281 
	C444.789154,149.868958 442.492645,149.796555 438.988373,149.346329 
	C442.001007,147.486954 444.332886,148.008133 446.845459,147.681488 
	C447.355072,148.062531 447.432343,148.282852 447.296783,148.781281 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M415.000549,189.918365 
	C417.183197,189.918121 418.962799,189.918121 420.742432,189.918121 
	C417.587524,191.391312 414.351227,190.973083 410.787506,190.860168 
	C412.098969,189.529175 413.408508,190.015152 415.000549,189.918365 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M129.058838,298.223206 
	C129.564575,298.036224 129.730972,297.976532 129.883286,298.001770 
	C131.511322,298.271637 133.408325,297.093506 134.721573,298.863464 
	C134.833542,299.014343 134.333267,299.952728 134.140045,299.945160 
	C132.217560,299.870117 129.932434,300.912170 129.058838,298.223206 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M444.874084,187.727478 
	C443.091827,187.534241 441.692566,187.332657 440.293335,187.131073 
	C440.257996,186.800537 440.222626,186.470001 440.187286,186.139450 
	C442.056396,186.025635 444.092468,185.394485 445.752075,185.929977 
	C447.790466,186.587692 446.165192,187.282684 444.874084,187.727478 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M121.324341,188.929657 
	C119.983192,188.811920 118.366417,189.678177 118.277298,187.879395 
	C118.220650,186.735748 119.564903,186.305298 120.495209,186.370041 
	C122.059669,186.478897 123.016907,187.216599 121.324341,188.929657 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M402.455688,153.901917 
	C400.899048,155.321854 398.860107,155.159378 396.726074,154.526016 
	C398.481659,153.697937 400.071198,151.967026 402.455688,153.901917 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M183.256287,234.649323 
	C181.175903,235.520233 179.289261,235.908157 176.968140,235.053253 
	C178.570557,233.486496 180.212219,232.784866 182.652832,233.036423 
	C183.364288,233.407700 183.505203,233.847366 183.256287,234.649323 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M426.851807,140.145203 
	C429.649445,139.949982 432.090851,139.949982 434.532257,139.949982 
	C431.845001,139.919174 429.223816,143.747009 426.851807,140.145203 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M159.842987,306.348236 
	C161.070862,306.735321 162.141357,306.682831 163.486633,306.228577 
	C164.227432,306.835663 165.328766,307.376984 164.292389,308.462250 
	C163.058197,309.754700 161.957489,308.576904 160.414276,308.366333 
	C159.364014,307.995972 157.905609,308.675812 158.390656,306.788147 
	C158.982574,306.533722 159.319153,306.528778 159.842987,306.348236 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M442.222717,211.958893 
	C441.231293,211.834976 440.654297,211.687363 440.077271,211.539764 
	C440.189209,211.135010 440.301147,210.730255 440.413086,210.325516 
	C442.534637,210.970993 444.808502,209.226044 447.048798,210.545731 
	C445.923279,212.767075 444.130310,211.820984 442.222717,211.958893 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M401.456177,138.056061 
	C400.762146,137.645508 400.439850,137.214188 400.105103,136.496796 
	C400.732422,136.268326 401.371155,136.346939 402.012177,136.378723 
	C403.045013,136.429932 403.831970,133.870743 405.061462,136.078964 
	C405.343475,136.585510 405.499115,137.162415 405.712891,137.706955 
	C404.417877,137.816391 403.122894,137.925842 401.456177,138.056061 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M13.846643,214.246002 
	C16.722065,212.909058 19.375004,211.426346 22.554520,212.440079 
	C19.688911,212.507095 17.632519,214.831848 14.435450,214.984131 
	C13.933219,214.789444 13.817504,214.639755 13.846643,214.246002 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M441.737854,144.633957 
	C443.582092,144.340118 445.102020,143.575150 446.851257,144.940414 
	C444.687347,146.991714 442.545044,146.042496 440.421265,145.314529 
	C440.468842,145.182541 440.478668,144.983658 440.571259,144.931320 
	C440.829773,144.785263 441.122589,144.699951 441.737854,144.633957 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M397.062378,200.339539 
	C400.294708,199.951416 403.234283,199.807144 406.173828,199.662872 
	C406.190430,200.066406 406.207001,200.469940 406.223572,200.873474 
	C403.095795,201.166855 399.970276,201.497864 397.062378,200.339539 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M445.930878,132.057037 
	C444.621490,131.886139 443.239471,133.019714 442.695435,131.421509 
	C442.437378,130.663391 443.224548,130.257080 443.827789,130.124756 
	C445.182678,129.827560 446.704102,129.039597 447.645203,130.805817 
	C447.705139,130.918335 446.749451,131.572037 445.930878,132.057037 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M442.055359,195.531174 
	C441.184235,195.400787 440.537750,195.584122 440.292389,195.348953 
	C439.614349,194.699173 440.104340,194.107681 440.805939,194.100357 
	C442.738068,194.080170 444.705475,193.482635 446.722626,194.273239 
	C445.652527,196.104645 444.180939,196.263275 442.055359,195.531174 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M456.165710,147.766754 
	C454.176758,148.040497 452.310516,148.680893 450.383362,146.405716 
	C452.307068,145.939407 453.892059,145.555191 455.846619,145.196426 
	C456.730255,145.928909 456.760834,146.682297 456.165710,147.766754 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M155.340576,290.065552 
	C155.016525,289.812286 155.000351,289.628296 154.993011,289.167358 
	C156.909683,287.058990 158.185577,288.130768 159.616119,290.015015 
	C160.070526,290.337891 160.233429,290.477112 160.104172,290.750427 
	C158.190369,291.933014 156.763458,291.899963 155.340576,290.065552 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M383.134796,249.138535 
	C383.359619,249.595795 383.174622,250.002136 382.977661,250.742889 
	C381.756744,252.362900 380.419617,252.261902 379.112000,251.315399 
	C378.841827,251.119812 378.643158,250.365723 378.801331,250.113342 
	C379.756989,248.588562 381.319611,249.085831 383.134796,249.138535 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M413.576904,159.100754 
	C414.849701,159.301163 415.479980,159.983826 414.908722,160.803619 
	C413.530823,162.781006 412.108154,161.026978 409.980835,160.571198 
	C411.453735,159.919708 412.356171,159.520554 413.576904,159.100754 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M177.059540,249.973846 
	C176.673569,249.925812 176.813522,249.965607 176.777618,249.975098 
	C178.426788,249.524994 179.381836,246.994781 182.064514,248.219666 
	C183.876541,248.519226 182.835632,249.086014 182.266876,249.718140 
	C180.449417,250.123886 178.972900,250.785614 177.059540,249.973846 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M128.385773,180.761673 
	C128.257065,178.338699 128.257065,178.338699 132.818420,178.950684 
	C131.930649,180.756607 129.975784,180.025604 128.385773,180.761673 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M120.058853,327.310547 
	C123.216835,326.807861 126.076904,326.536224 128.936981,326.264587 
	C126.044792,328.309174 122.975105,328.584778 120.058853,327.310547 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M19.559425,289.904785 
	C20.281492,290.202759 22.327248,289.945557 20.603304,290.914001 
	C18.317467,292.198090 15.586947,292.185120 12.849940,291.332184 
	C14.960019,290.858582 17.070097,290.384949 19.559425,289.904785 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M23.222443,172.934326 
	C23.731529,170.297348 25.762545,169.916824 28.113441,170.591858 
	C26.862682,172.233078 25.630505,173.481888 23.222443,172.934326 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M201.940155,368.999146 
	C204.389938,367.427551 206.782639,367.959625 209.176346,368.292145 
	C206.766205,369.090424 204.411194,370.203918 201.940155,368.999146 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M222.404053,289.079773 
	C220.663986,290.572174 218.847961,289.682800 215.946548,290.286896 
	C218.595108,287.903015 220.357025,287.450500 222.404053,289.079773 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M244.605057,301.833893 
	C244.884888,302.709625 244.948624,303.479218 245.082001,304.629852 
	C245.074768,305.742889 244.997879,306.474823 244.880157,307.573730 
	C244.570221,308.319153 244.204086,308.449860 243.567902,308.103699 
	C243.254791,305.788361 243.127594,303.735046 243.076920,301.332062 
	C243.565292,301.230835 243.977127,301.479279 244.605057,301.833893 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M533.145264,115.646439 
	C532.510437,117.598541 533.423706,119.842422 531.598816,121.187744 
	C531.546631,121.226227 531.307922,121.085846 531.216980,120.977745 
	C531.117493,120.859428 531.088684,120.681679 530.934082,120.242455 
	C530.857910,119.217644 530.876709,118.480202 530.885986,117.373917 
	C530.792603,116.827438 530.708740,116.649796 530.807495,116.240921 
	C531.445984,115.151558 532.063171,114.802589 533.145264,115.646439 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M135.445770,332.408417 
	C136.742355,332.126434 137.707047,331.958374 138.691208,332.988312 
	C136.572556,334.881958 134.247864,333.827301 131.964661,333.362885 
	C133.012619,333.092072 134.060562,332.821289 135.445770,332.408417 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M67.993004,333.588440 
	C64.721474,332.437531 65.674843,330.334503 67.486397,328.077087 
	C67.924309,329.714478 68.011017,331.440857 67.993004,333.588440 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M400.868652,160.442322 
	C401.779572,160.181305 402.922729,159.849686 403.339813,160.258621 
	C404.494293,161.390503 406.619812,157.944290 406.661133,160.701355 
	C406.698090,163.162796 404.190887,161.778732 402.349640,161.893005 
	C401.476624,161.574997 400.982788,161.282852 400.868652,160.442322 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M180.619507,363.109314 
	C181.037567,363.154266 181.024689,363.636475 181.014786,363.877960 
	C179.126572,365.317017 177.242203,365.495392 174.749680,364.216492 
	C176.699326,362.599945 178.533951,363.204590 180.619507,363.109314 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M207.619751,120.963333 
	C208.084381,122.188927 208.208511,123.328522 208.602051,124.681084 
	C209.046997,125.091469 209.222565,125.288887 209.225647,125.843079 
	C209.025162,126.554352 208.841537,126.784874 208.269989,126.912903 
	C207.197723,125.381508 205.901520,124.106712 205.550400,122.247406 
	C205.209763,120.443741 206.504562,121.071251 207.619751,120.963333 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M502.391693,214.188538 
	C502.102814,217.820221 500.032379,215.494263 498.260956,215.655426 
	C499.097717,213.186554 500.793274,214.359512 502.391693,214.188538 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M150.449677,267.919830 
	C152.562912,267.658813 154.237183,266.486084 156.215897,267.367249 
	C154.411926,269.719116 151.946274,269.056732 149.626114,268.953491 
	C149.475891,268.946808 149.331497,268.809174 149.184387,268.732452 
	C149.491852,268.482086 149.799301,268.231720 150.449677,267.919830 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M13.895374,227.376465 
	C16.594259,226.946823 18.866053,224.957092 21.829638,226.551788 
	C18.967331,227.624176 16.419600,228.417053 13.895374,227.376465 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M12.435616,379.930939 
	C12.021526,379.866058 12.008043,379.493195 12.013502,379.306763 
	C15.079417,378.939453 18.004004,377.171631 22.198917,378.598358 
	C18.453056,379.158264 15.651381,379.577057 12.435616,379.930939 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M130.682663,210.603363 
	C131.928116,210.162949 133.109070,209.600586 133.437103,210.936920 
	C133.782120,212.342514 132.353622,212.291885 131.471008,212.386871 
	C130.495972,212.491776 129.124725,213.720810 128.623138,211.985168 
	C128.339233,211.002747 129.635132,210.984192 130.682663,210.603363 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M435.041992,246.616211 
	C434.215698,248.192215 432.908875,248.056656 431.237396,247.885712 
	C430.337311,247.183884 430.252502,246.489990 430.708679,245.436890 
	C432.377258,245.071640 434.093964,244.061020 435.041992,246.616211 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M432.113647,238.780334 
	C430.585144,238.927994 429.172058,238.860748 427.608154,238.388306 
	C428.910248,237.501358 430.363190,237.019592 432.122009,236.409332 
	C433.168457,236.164841 433.500336,236.479279 433.197723,237.607178 
	C432.620392,238.046402 432.372467,238.238480 432.113647,238.780334 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M192.259918,248.257172 
	C191.944992,247.847656 191.889389,247.677063 191.888824,247.243042 
	C192.127197,246.978912 192.310486,246.978210 192.755783,246.894165 
	C193.352661,246.603943 193.687485,246.397018 194.317459,246.200043 
	C195.745941,246.875839 197.988571,244.702148 198.188019,247.948090 
	C197.598999,248.503967 197.137573,248.873734 196.347626,249.254517 
	C195.908264,249.453339 195.733124,249.527130 195.278168,249.655594 
	C194.012787,249.630585 193.199951,249.198227 192.259918,248.257172 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M166.255493,251.780411 
	C164.673538,254.207275 161.854279,252.257553 159.808517,253.695206 
	C161.347183,251.344055 163.915985,252.214584 166.255493,251.780411 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M122.759918,259.712250 
	C121.665672,259.617401 120.174614,259.770935 120.517776,258.859161 
	C121.107445,257.292389 123.038170,256.955231 124.178299,257.907196 
	C125.624786,259.114929 123.737350,259.214752 122.759918,259.712250 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M134.102936,257.430847 
	C133.224869,260.548981 131.098694,258.549103 128.360077,259.237000 
	C130.553741,257.220581 131.972488,256.533997 134.102936,257.430847 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M409.022583,232.886261 
	C408.847748,231.920166 408.558258,231.315231 407.292664,231.053284 
	C408.201141,229.609329 409.718536,229.003372 411.891357,229.084198 
	C411.802032,230.181412 411.335754,231.247391 410.913635,232.663666 
	C410.441437,232.988098 409.925079,232.962250 409.022583,232.886261 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M192.551849,233.232407 
	C193.045227,231.006042 194.513794,230.931259 196.448151,231.064301 
	C197.304092,231.369644 197.516571,231.790756 197.266815,232.679245 
	C196.267258,233.336136 195.458862,233.662415 194.330444,234.074905 
	C193.448059,234.244904 192.992004,234.062683 192.551849,233.232407 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M442.744019,233.749298 
	C442.680176,235.387894 441.798859,235.429123 440.345398,234.949951 
	C438.681152,233.341431 436.596375,234.451553 434.081024,233.261581 
	C437.577209,232.961578 440.022522,232.653107 442.744019,233.749298 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M124.049393,263.209839 
	C125.339966,264.713196 125.274780,265.819641 123.360359,266.036163 
	C122.517784,266.131470 121.028214,266.417816 120.997223,265.267731 
	C120.959442,263.865723 122.141953,263.026093 124.049393,263.209839 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M33.377102,235.805969 
	C34.224617,235.713806 34.751144,235.487839 35.176708,235.610931 
	C35.772648,235.783295 35.652554,236.638840 35.319534,236.662918 
	C32.798233,236.845383 30.474337,238.578583 27.658342,237.755173 
	C29.056726,235.617569 31.210419,236.229141 33.377102,235.805969 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M168.139648,178.091568 
	C169.123932,177.742233 169.910522,176.729767 170.459976,177.871948 
	C170.949219,178.888962 170.409973,179.907181 169.252151,179.977173 
	C168.195816,180.041000 166.787964,180.687653 166.203964,179.112289 
	C166.171906,179.025772 167.262177,178.523193 168.139648,178.091568 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M159.974747,189.924255 
	C158.631104,189.752304 157.669876,189.598495 156.145081,189.354492 
	C157.837341,188.650955 159.247986,187.492096 160.409393,187.703354 
	C162.677002,188.115845 162.078812,189.206696 159.974747,189.924255 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M199.070587,190.181000 
	C199.721939,189.450043 200.443268,188.769989 201.095734,188.830643 
	C202.009232,188.915588 201.600174,186.324570 202.957062,188.010315 
	C203.352646,188.501801 203.986816,189.414032 203.831543,189.619537 
	C203.391388,190.202057 202.637039,190.773239 201.936676,190.876709 
	C201.029648,191.010712 200.055222,190.688324 199.070587,190.181000 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M431.000092,182.652115 
	C429.091217,184.130478 427.342010,183.865936 425.537781,182.471542 
	C427.438812,181.483963 429.230804,181.732254 431.000092,182.652115 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M182.059082,185.289078 
	C180.694031,187.859985 178.785339,186.743790 176.155685,186.802170 
	C178.299698,184.766602 179.906708,184.029495 182.059082,185.289078 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M129.186981,185.892883 
	C130.153427,185.980042 130.795044,186.103195 131.460709,186.230942 
	C130.260742,188.496689 128.462845,188.435593 126.224846,187.439133 
	C127.189957,186.886459 128.026062,186.407654 129.186981,185.892883 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M384.803162,175.966248 
	C384.107910,175.907074 383.788696,175.862869 383.480103,175.779404 
	C382.992889,175.647568 382.998016,175.257874 383.497498,175.247787 
	C386.563019,175.185867 389.630371,175.216766 392.736877,175.963577 
	C390.219238,175.963577 387.701569,175.963577 384.803162,175.966248 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M445.238739,182.970215 
	C443.228210,183.023895 441.588196,183.023895 439.948151,183.023895 
	C439.906616,182.801895 439.865082,182.579895 439.823547,182.357895 
	C441.575897,181.933868 443.311981,181.289520 445.085938,181.158859 
	C446.393219,181.062561 446.854797,181.895721 445.238739,182.970215 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M403.529541,195.022797 
	C401.002869,194.985291 398.886047,194.985291 396.769226,194.985291 
	C396.758911,194.748352 396.748566,194.511429 396.738251,194.274490 
	C399.451324,194.042801 402.161438,193.754166 404.879242,193.614777 
	C405.675751,193.573944 406.003204,194.264221 405.371185,194.866592 
	C405.088837,195.135712 404.428284,195.007950 403.529541,195.022797 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M390.333160,232.228073 
	C389.119598,232.151749 388.236176,232.286865 387.168671,232.231262 
	C387.380951,226.082352 390.158813,231.677383 392.026520,231.160217 
	C392.174500,232.159760 391.524963,232.453110 390.333160,232.228073 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M165.234680,289.382965 
	C164.921097,289.235199 164.499878,289.180634 164.288361,289.199707 
	C163.867325,289.328613 163.657791,289.438416 163.095367,289.593994 
	C162.259415,289.559418 161.853989,289.333344 161.805847,288.777008 
	C162.687775,285.885803 164.470810,286.867340 166.275269,287.623535 
	C166.420334,288.150909 166.357437,288.330841 166.137985,288.750122 
	C165.837051,289.169861 165.692642,289.350281 165.234680,289.382965 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M455.206055,235.816299 
	C454.145996,236.132629 453.415283,236.160721 452.333374,236.300919 
	C451.361084,235.918564 450.740021,235.424072 449.863220,234.758377 
	C449.318329,234.532639 449.029175,234.478104 449.176422,234.357285 
	C451.133423,234.287354 452.654083,234.283722 454.556793,234.219452 
	C454.938873,234.158813 454.967468,234.492020 454.992157,234.657410 
	C455.189728,235.057877 455.362579,235.292953 455.206055,235.816299 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M449.181519,234.197830 
	C449.612793,234.290985 449.569733,234.442886 449.588623,234.515030 
	C447.853760,235.439758 449.264282,240.245926 445.000427,237.856293 
	C446.490784,237.312363 447.306976,236.421326 447.033875,234.354340 
	C447.583435,234.034897 448.166840,234.069778 449.181519,234.197830 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M36.076401,243.414124 
	C34.120064,243.718491 32.528004,243.910629 30.935947,244.102753 
	C32.957260,243.144440 34.707195,241.332306 37.146206,242.148666 
	C37.282166,242.194183 37.387318,242.331757 37.506813,242.426483 
	C37.151436,242.718277 36.796059,243.010086 36.076401,243.414124 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M133.737518,243.765030 
	C131.792343,244.048920 130.165344,244.048920 128.538361,244.048920 
	C130.358322,243.277115 132.046677,240.357056 133.737518,243.765030 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M183.308350,286.129211 
	C182.607025,285.509186 182.222717,285.055023 181.857910,284.278717 
	C182.414124,283.722504 182.950806,283.488403 183.741150,283.107910 
	C184.681396,282.420959 185.442963,282.234131 186.653442,282.675110 
	C188.447739,284.158020 186.628250,283.970612 186.118347,284.651611 
	C185.377411,285.666107 184.702530,286.301849 183.308350,286.129211 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M447.024963,247.639771 
	C444.204498,247.661819 441.401733,248.673111 438.423462,247.419556 
	C438.205688,247.079620 438.578369,247.052032 438.753052,246.985687 
	C439.564880,246.453690 440.218781,246.019623 441.383484,245.752060 
	C443.310577,245.707901 444.837341,245.045731 446.672424,245.850113 
	C446.993713,246.523331 447.032379,246.930054 447.024963,247.639771 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M458.444092,177.735168 
	C458.205902,182.298264 455.446564,179.581757 453.502472,179.527695 
	C454.017700,179.199463 454.532959,178.871216 455.078552,178.242508 
	C456.036194,177.270187 457.087219,177.570694 458.444092,177.735168 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M124.788040,286.363373 
	C123.489212,288.265900 121.975616,288.125061 119.743263,287.270874 
	C121.554642,285.717224 122.955864,285.129089 124.788040,286.363373 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M208.717636,241.803040 
	C208.967361,242.003174 208.715958,242.384338 208.636429,242.598328 
	C207.783997,243.397736 207.206848,244.697357 205.755371,243.270203 
	C205.924942,242.044144 206.291626,241.074081 206.342010,239.841492 
	C206.187286,239.351776 206.348831,239.124573 206.312653,239.265869 
	C206.108734,241.235428 207.979721,240.592758 208.717636,241.803040 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M193.641968,261.106995 
	C194.086304,261.358215 194.254929,261.574310 194.671921,261.837982 
	C195.064331,262.092072 195.272614,262.248505 195.232452,262.706451 
	C193.580582,263.799255 191.700592,264.944641 190.775848,263.252106 
	C190.066010,261.952850 192.179535,261.584198 193.641968,261.106995 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M426.806213,189.928864 
	C429.418915,189.860886 431.658356,189.860886 433.897827,189.860886 
	C431.315125,191.199371 428.685913,191.190155 426.038635,190.900345 
	C425.881805,190.883179 425.633209,190.860718 425.591278,190.767181 
	C425.114624,189.704254 426.192413,190.305405 426.806213,189.928864 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M122.662781,210.891357 
	C125.116524,217.653046 119.720879,213.711639 117.935585,214.846542 
	C118.743065,213.186646 121.131783,214.580658 121.951164,212.305893 
	C121.825401,211.492203 121.930809,211.100891 122.662781,210.891357 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M258.546936,149.065765 
	C259.161072,151.418854 257.595734,153.176544 256.772430,156.464890 
	C255.266602,152.747971 256.690857,150.924484 258.546936,149.065765 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M406.221985,215.712875 
	C402.929962,215.955368 399.985596,215.955368 397.041229,215.955368 
	C400.221832,214.811813 403.392365,214.539276 406.221985,215.712875 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M459.338684,201.737625 
	C457.106506,202.087128 455.032837,202.087128 452.230469,202.087128 
	C454.433929,200.391861 456.327209,200.149399 458.631470,199.961914 
	C459.389740,200.384018 459.545288,200.852249 459.338684,201.737625 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M399.015503,145.241486 
	C400.345856,144.452026 401.225708,144.408356 401.265564,145.870483 
	C401.305115,147.319977 400.128662,147.268158 399.219666,147.052628 
	C398.399261,146.858063 396.808197,147.895294 396.963348,145.931747 
	C396.979858,145.722672 398.097565,145.600586 399.015503,145.241486 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M414.440735,195.041367 
	C413.060211,194.966766 412.089874,194.865891 411.119537,194.765015 
	C411.127045,194.599609 411.134521,194.434219 411.141998,194.268814 
	C414.308044,194.268814 417.474060,194.268814 421.377045,194.268814 
	C418.782745,195.763260 416.762177,194.632904 414.440735,195.041367 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M392.218048,194.178650 
	C389.230469,195.827087 385.892975,194.344284 382.541840,193.895691 
	C385.656952,193.895691 388.772034,193.895691 392.218048,194.178650 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M38.982216,299.689209 
	C36.263973,299.385864 34.196850,301.774200 30.694746,300.542145 
	C34.023544,299.261505 36.467800,298.391663 38.982216,299.689209 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M381.812195,266.845886 
	C381.447479,267.050995 381.392670,267.158112 381.430298,267.147430 
	C380.387512,267.271942 378.540710,268.582825 378.507294,266.699890 
	C378.471375,264.673889 380.420746,264.608673 382.380737,265.670410 
	C382.500214,266.186127 382.338531,266.413452 381.812195,266.845886 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M445.111877,225.141891 
	C443.769379,227.576889 440.913116,226.093719 438.379822,227.080750 
	C439.252167,223.212967 442.412415,225.669083 445.111877,225.141891 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M413.402283,152.950836 
	C416.009430,153.026520 418.194458,153.140213 420.379486,153.253922 
	C420.363403,153.502579 420.347321,153.751221 420.331238,153.999878 
	C417.780579,153.999878 415.229919,154.004410 412.679443,153.983368 
	C412.577209,153.982544 412.366364,153.661102 412.394012,153.622009 
	C412.558716,153.389236 412.778748,153.195618 413.402283,152.950836 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M454.800110,154.324829 
	C456.421875,154.078552 458.474060,151.975540 459.045135,154.397415 
	C459.519775,156.410263 457.262207,155.952728 455.522461,155.931213 
	C454.709229,155.556992 454.535614,155.133652 454.800110,154.324829 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M208.418152,316.827179 
	C209.599243,316.087402 210.435516,315.665894 211.579865,316.618713 
	C209.131348,318.797729 206.410843,317.583588 203.054077,318.271606 
	C205.115997,316.373962 206.658859,317.157745 208.418152,316.827179 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M223.448120,316.153748 
	C220.470612,317.477692 217.156250,317.035461 213.826172,315.857330 
	C216.922272,315.857330 220.018356,315.857330 223.448120,316.153748 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M389.486938,155.540924 
	C387.461517,156.038071 385.744415,156.481354 383.892822,155.451141 
	C385.323792,153.382584 387.410553,154.312225 389.595551,154.059509 
	C390.204834,154.537704 390.129700,154.973358 389.486938,155.540924 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M496.885040,124.529037 
	C495.433838,125.502029 494.125641,125.791954 492.766663,124.323662 
	C494.246490,123.037979 495.536743,122.204842 496.885040,124.529037 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M162.610687,315.081848 
	C163.017090,315.286438 163.015656,315.463257 163.011261,315.906067 
	C161.097168,316.893066 159.207092,316.731293 156.939667,316.381165 
	C158.640182,314.151794 160.582443,315.401276 162.610687,315.081848 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M226.519501,358.970398 
	C226.959122,359.142700 227.000198,359.330444 226.964355,359.795776 
	C224.865753,360.585175 222.876221,361.317139 220.328781,360.927185 
	C219.787827,360.728394 219.647568,360.575256 219.745544,360.221375 
	C222.000305,359.502594 223.949158,358.583069 226.519501,358.970398 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M17.410465,366.000214 
	C16.995844,365.949585 16.987091,365.498169 17.002491,365.272980 
	C19.733778,364.660522 22.449665,364.273285 25.581455,363.952637 
	C26.097250,364.168945 26.197142,364.318665 26.140808,364.688568 
	C23.264751,365.289459 20.544920,365.670166 17.410465,366.000214 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M109.082977,403.636322 
	C110.358353,403.055298 111.176292,403.552063 111.978897,404.774475 
	C111.227150,405.792145 110.189087,406.926514 108.957634,406.386169 
	C107.808716,405.882050 108.787132,404.761169 109.082977,403.636322 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M431.533936,131.522583 
	C431.302368,131.937454 430.879120,132.045975 430.172546,132.319946 
	C428.500793,132.516205 427.064484,133.340942 425.357971,132.179291 
	C427.345154,130.439392 429.341888,130.818085 431.533936,131.522583 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M165.612137,196.704407 
	C163.759552,195.273788 164.731277,194.614349 166.007706,194.249084 
	C166.812469,194.018814 167.779877,194.167374 167.891281,195.268127 
	C168.032547,196.663757 167.015671,196.829681 165.612137,196.704407 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M381.175934,272.436798 
	C380.586700,274.976990 379.058014,273.824646 377.408783,273.575653 
	C378.113892,271.271454 379.691620,272.222931 381.175934,272.436798 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M469.237366,195.997345 
	C471.265259,196.095078 472.933960,195.344452 474.755127,196.563065 
	C471.650970,197.448639 468.796539,196.920197 465.900787,196.371216 
	C466.872894,196.231949 467.844971,196.092682 469.237366,195.997345 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M153.291931,199.890930 
	C152.004135,199.994720 151.058090,199.994720 148.903610,199.994720 
	C151.362335,198.466080 152.616333,197.304306 154.235931,199.120743 
	C154.271774,199.160980 154.134567,199.397812 154.036133,199.504105 
	C153.927185,199.621780 153.769928,199.694702 153.291931,199.890930 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M165.606384,275.103516 
	C163.739487,275.119080 162.236984,275.119080 160.734482,275.119080 
	C162.649582,274.305389 164.439041,272.845947 166.621552,274.070282 
	C166.688889,274.108063 166.691666,274.428009 166.612564,274.525757 
	C166.436310,274.743652 166.189087,274.904114 165.606384,275.103516 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M131.544525,203.905426 
	C130.270966,204.075699 128.877167,204.446304 128.668274,203.420013 
	C128.441818,202.307358 129.832397,202.055923 130.779419,201.935013 
	C132.436432,201.723465 132.984238,202.293945 131.544525,203.905426 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M432.507233,203.778442 
	C433.312286,204.074692 434.651764,204.202820 433.953400,204.723557 
	C432.685608,205.668823 430.944977,205.811920 429.300201,204.955597 
	C429.803711,203.346420 431.159058,203.962891 432.507233,203.778442 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M163.264847,205.944275 
	C162.041946,207.554169 160.272614,208.387192 157.934219,207.621307 
	C159.296082,205.868912 161.236725,206.274719 163.264847,205.944275 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M455.378387,190.205231 
	C457.087067,189.917664 458.545349,189.528961 459.987122,191.144699 
	C457.884521,192.031738 456.252777,193.009750 455.378387,190.205231 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M147.671844,191.190002 
	C148.979736,189.714050 150.314056,189.439789 151.763702,190.004303 
	C152.008682,190.099701 152.265060,190.873413 152.129089,191.122055 
	C151.372711,192.505249 149.915436,191.995300 148.335114,192.169098 
	C147.781631,191.904510 147.623688,191.706696 147.671844,191.190002 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M400.406219,190.050568 
	C400.658600,193.492538 398.158630,191.158051 396.929901,191.888229 
	C397.221313,189.805969 398.767456,190.139938 400.406219,190.050568 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M131.363358,195.398804 
	C129.824997,196.078949 128.534058,196.768646 127.483833,195.409348 
	C127.342850,195.226868 127.724930,194.269669 128.000824,194.198486 
	C129.345932,193.851440 130.986816,192.750427 131.363358,195.398804 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M456.824219,145.465607 
	C458.239563,145.143005 459.999329,144.371902 460.693909,146.093018 
	C461.326904,147.661469 459.816498,147.797165 458.331360,147.977020 
	C457.293182,147.376236 456.949127,146.624146 456.824219,145.465607 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M35.333046,416.221436 
	C34.988747,415.836090 34.973518,415.669647 34.990356,415.254486 
	C36.336498,414.834320 37.660149,414.714661 38.961391,414.473877 
	C39.892963,414.301514 41.296558,413.618195 41.389870,414.933655 
	C41.513958,416.682983 39.728184,415.891022 38.363541,416.166443 
	C37.240067,416.528412 36.451710,416.490509 35.333046,416.221436 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M210.040955,289.641998 
	C209.323792,289.096802 206.822998,291.878510 207.138000,288.344513 
	C207.348602,285.981567 208.696854,287.449524 209.726547,286.997192 
	C210.058548,287.753387 210.067474,288.509216 210.040955,289.641998 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M140.563614,368.001709 
	C140.988022,368.089844 140.968750,368.449524 140.966278,368.629395 
	C138.452423,369.015289 135.941071,369.221344 133.429703,369.427399 
	C135.447556,367.304474 137.879303,368.144379 140.563614,368.001709 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M122.299118,298.943298 
	C123.873955,298.887573 125.312988,299.116791 123.824135,300.531006 
	C123.164185,301.157867 121.413818,300.636749 120.089203,300.636749 
	C120.212204,299.485352 121.209770,299.378571 122.299118,298.943298 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M176.633087,162.472260 
	C178.622147,162.577301 180.405319,159.740738 182.872787,161.750824 
	C181.133942,163.461777 178.938431,163.086258 176.633087,162.472260 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M134.432465,286.637390 
	C132.333542,287.707153 131.365189,286.036499 129.959122,285.609436 
	C131.690018,285.210144 133.653687,283.507843 134.432465,286.637390 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M430.053406,164.093781 
	C431.776855,164.085678 433.074615,164.085678 434.372406,164.085678 
	C434.374023,164.310898 434.375641,164.536133 434.377289,164.761353 
	C431.565216,164.761353 428.753143,164.761353 425.821198,164.761353 
	C426.947876,163.249176 428.401459,164.347214 430.053406,164.093781 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M188.463074,371.021240 
	C188.025665,370.943695 188.046860,370.551086 188.052994,370.354645 
	C190.988571,370.158203 193.918015,370.158203 197.926834,370.158203 
	C194.304459,371.650543 191.543716,370.788879 188.463074,371.021240 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M403.031738,154.329498 
	C402.801086,153.963394 402.830872,154.053452 402.821899,154.077850 
	C403.644958,152.831802 404.721924,152.066040 406.267578,152.723755 
	C406.505157,152.824860 406.669189,153.639771 406.530762,153.992493 
	C405.824310,155.792450 404.423828,154.757004 403.031738,154.329498 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M186.934601,289.562103 
	C185.017151,289.912018 183.163925,290.063721 181.233109,290.221771 
	C181.497070,288.304199 183.178558,289.502258 184.095764,288.484680 
	C184.549316,287.797791 184.908829,287.562439 185.702164,287.604492 
	C186.187805,287.775818 186.351379,287.831360 186.768921,287.938049 
	C187.187485,288.137604 187.352066,288.286011 187.397766,288.744873 
	C187.278915,289.055328 186.998840,289.363892 186.934601,289.562103 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M419.665131,149.956024 
	C420.222565,150.101135 420.442535,150.194656 420.454285,150.309540 
	C420.475433,150.515671 420.373566,150.920959 420.319519,150.921570 
	C417.603668,150.951996 414.887482,150.948288 412.161713,150.263275 
	C414.519073,150.146866 416.876465,150.030457 419.665131,149.956024 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M115.027214,412.448608 
	C114.989731,411.917633 114.945564,411.364929 114.925209,410.397583 
	C116.009415,410.059753 117.069817,410.136627 118.526848,410.177612 
	C118.695023,412.089417 117.895432,413.266327 115.339577,412.466400 
	C114.993095,412.392059 115.020531,412.426941 115.027214,412.448608 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M486.592224,135.156509 
	C485.063446,136.382553 483.541718,136.296417 481.521576,135.513626 
	C483.428345,134.693069 484.787384,133.402252 486.592224,135.156509 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M148.551483,309.766296 
	C150.439651,309.923248 151.969406,310.156738 153.733246,310.688416 
	C152.248291,311.273407 150.533691,311.752594 148.809036,311.791931 
	C147.140839,311.830048 146.054718,311.232849 148.551483,309.766296 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M414.125000,140.899872 
	C416.122711,138.977112 418.729614,140.677963 421.234650,140.923233 
	C418.980072,140.923233 416.725494,140.923233 414.125000,140.899872 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M405.961578,167.457397 
	C405.578705,168.655090 405.877869,170.583435 403.828796,170.062881 
	C403.518768,169.984116 403.083954,169.430786 403.114380,169.139526 
	C403.273468,167.615570 403.991791,166.697357 405.961578,167.457397 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M147.741028,175.753174 
	C148.821152,175.141907 149.459381,174.085602 150.553116,174.836639 
	C150.761642,174.979843 150.819000,175.776657 150.628433,175.996353 
	C149.507355,177.288666 147.518661,177.371704 146.602936,176.762604 
	C145.344604,175.925613 147.146027,176.245209 147.741028,175.753174 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M18.482037,234.089111 
	C19.370731,231.128464 21.828979,232.159042 24.125425,232.606812 
	C22.365652,233.109085 20.605877,233.611343 18.482037,234.089111 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M201.879150,247.468353 
	C202.606354,246.210236 203.423203,245.773331 204.370270,246.557770 
	C205.134781,247.190994 204.976822,248.175873 204.201706,248.568771 
	C203.324112,249.013580 202.000977,249.731720 201.879150,247.468353 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M454.627808,245.714478 
	C456.385925,245.594757 457.787140,245.631897 459.604767,245.600143 
	C460.926727,248.409531 458.489777,246.873611 457.801025,246.965469 
	C455.786957,247.234131 453.713928,247.061020 451.469818,247.061020 
	C452.273804,245.654968 453.407349,246.166580 454.627808,245.714478 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M14.573112,247.952606 
	C12.827286,249.435898 10.458064,249.945236 7.512568,250.060928 
	C9.521250,247.417435 11.976546,248.116364 14.573112,247.952606 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M454.535217,227.856613 
	C456.303772,227.866531 457.729614,227.936035 459.583191,227.977722 
	C458.631439,230.064316 456.453339,228.416351 454.376312,229.114868 
	C453.291168,229.116867 452.592224,229.067993 451.545929,228.970856 
	C451.819061,227.464233 453.114197,228.012756 454.535217,227.856613 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M434.481873,228.639160 
	C432.972198,228.776016 431.596375,229.672043 430.335999,227.974472 
	C432.035706,226.946442 433.456543,225.951569 434.481873,228.639160 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M188.163818,242.657944 
	C186.627991,242.851028 184.891129,243.878143 184.265976,241.999695 
	C183.881195,240.843582 185.161026,240.588821 186.367966,240.221481 
	C187.828064,240.443527 188.536316,241.074966 188.163818,242.657944 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M382.676819,258.918304 
	C383.090057,259.852203 385.180634,262.093689 381.817932,261.029114 
	C380.637024,260.655273 379.530731,260.045807 378.199219,259.265930 
	C379.428619,258.978912 380.849121,258.969910 382.676819,258.918304 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M129.719238,402.076660 
	C130.051392,402.511475 130.013367,402.909546 129.986359,403.607697 
	C129.997360,403.907745 130.030792,404.082611 129.998016,404.165405 
	C129.457611,404.444824 128.908646,404.478546 128.181366,404.814453 
	C127.492203,404.955994 127.015480,404.930023 126.185013,404.848083 
	C125.562630,404.391785 125.472473,403.954681 125.785202,403.213196 
	C126.864426,401.691223 128.155762,402.046356 129.719238,402.076660 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M459.502075,219.022736 
	C456.996277,219.080826 454.888672,219.080826 451.489716,219.080826 
	C455.097931,217.970825 457.492554,217.701614 459.957520,218.079910 
	C460.102448,218.102142 460.226227,218.262360 460.359863,218.358368 
	C460.206665,218.560455 460.053497,218.762543 459.502075,219.022736 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M13.702502,340.908783 
	C16.416346,339.477875 18.970675,339.987671 21.578068,340.582031 
	C19.306547,341.005280 17.035027,341.428528 14.364962,341.860413 
	C13.806877,341.659515 13.647337,341.449982 13.702502,340.908783 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M39.486931,267.624573 
	C38.038998,267.875427 36.928341,267.941528 35.817688,268.007629 
	C37.849140,266.353821 40.052483,265.731506 42.659687,266.409576 
	C41.627712,266.784546 40.725960,267.112183 39.486931,267.624573 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M26.621460,269.732880 
	C28.285511,267.320190 30.764692,267.941650 33.289616,268.649658 
	C31.167393,269.087341 29.045166,269.525055 26.621460,269.732880 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M459.197998,209.926346 
	C458.157959,211.861420 456.628418,210.825912 455.141632,210.484451 
	C456.272827,209.411606 457.528320,209.102982 459.197998,209.926346 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M38.163643,222.098877 
	C37.086342,222.297318 36.327480,223.227478 35.616493,222.432556 
	C35.023006,221.769028 35.708832,221.293488 36.289112,221.007339 
	C37.363586,220.477509 38.490208,219.132782 39.605984,220.714737 
	C39.977467,221.241425 39.122883,221.783325 38.163643,222.098877 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M225.780914,338.406189 
	C226.163071,338.687958 226.082397,338.636993 226.128296,338.623779 
	C223.103302,338.993134 220.032639,339.292114 215.996872,338.731384 
	C219.716064,337.329468 222.588348,338.294403 225.780914,338.406189 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M180.662476,241.132843 
	C182.086487,242.219482 182.014420,243.162689 180.718506,243.797928 
	C179.951935,244.173691 179.077454,243.917648 178.833710,243.030594 
	C178.524246,241.904449 179.270279,241.322937 180.662476,241.132843 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M190.879150,168.753433 
	C190.976685,165.177139 193.948700,168.065613 195.309036,166.761673 
	C194.492157,168.646561 192.381836,167.588745 190.879150,168.753433 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M140.679443,258.444946 
	C140.987930,258.725189 141.003189,258.680328 140.994110,258.662231 
	C140.005249,257.805328 138.393600,259.628601 137.638580,257.851593 
	C137.308578,257.074921 137.850632,256.537231 138.376907,256.359070 
	C139.980118,255.816391 140.211212,256.996124 140.679443,258.444946 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M186.435516,247.122696 
	C186.823532,247.832535 186.916840,248.528976 186.985580,249.577835 
	C186.291473,249.950714 185.621933,249.971161 184.620453,249.927582 
	C183.724182,249.634766 183.486908,249.219055 183.830597,248.307114 
	C184.770477,247.701340 185.455643,247.405319 186.435516,247.122696 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M410.776062,242.852585 
	C412.985443,241.342682 415.753265,241.983063 418.718262,242.650726 
	C416.354492,242.934708 413.773865,242.891342 410.776062,242.852585 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M402.652466,256.031464 
	C403.234070,260.165222 401.180511,259.123535 398.937286,257.327393 
	C400.027039,256.610870 401.354675,257.131958 402.652466,256.031464 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M130.924225,291.575928 
	C132.162857,291.045105 133.111389,290.708435 133.783096,291.735992 
	C133.925858,291.954376 133.672241,292.745850 133.417938,292.858093 
	C131.924072,293.517670 130.447647,293.139709 129.009338,292.550842 
	C129.537430,292.274231 130.065536,291.997620 130.924225,291.575928 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M35.135788,260.678345 
	C36.694256,260.123169 37.920193,259.559265 40.149277,260.623322 
	C37.728077,261.154877 36.005661,261.539917 34.277420,261.896759 
	C34.163700,261.920258 34.005497,261.728394 33.867981,261.636719 
	C34.183720,261.362061 34.499462,261.087402 35.135788,260.678345 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M155.301147,261.377136 
	C154.391434,262.532196 153.449173,262.662659 152.538879,262.004150 
	C151.693558,261.392639 152.401566,260.885010 152.890335,260.555023 
	C153.879318,259.887390 154.923477,259.338013 155.301147,261.377136 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M200.940887,255.152359 
	C200.702560,254.876984 200.768372,254.701767 200.876236,254.248901 
	C201.977600,253.720016 203.036911,253.468765 204.413818,253.196808 
	C204.827408,254.245926 205.149811,255.405624 203.343903,255.876221 
	C202.426849,255.685791 201.835953,255.469147 200.940887,255.152359 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M522.729736,252.001953 
	C523.582031,254.556747 522.716736,257.066681 522.401978,259.624542 
	C522.218567,257.352844 522.035095,255.081116 521.949585,252.384186 
	C522.047424,251.958984 522.502197,252.043518 522.729736,252.001953 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M208.470276,282.244141 
	C207.650879,281.721527 207.259720,281.145874 206.698242,280.263733 
	C206.575134,279.776428 206.622345,279.595703 206.827805,279.183716 
	C208.049881,279.330475 209.711792,278.021545 210.174667,280.116791 
	C210.427734,281.262329 210.163986,282.015869 208.470276,282.244141 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M154.676163,245.878128 
	C155.103973,246.134323 155.145508,246.345200 155.211029,246.877655 
	C153.161880,248.420380 151.009506,248.175079 148.161301,247.650955 
	C150.636169,246.916733 152.463013,246.374771 154.676163,245.878128 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M442.587708,154.024368 
	C442.997681,154.735672 442.991577,155.430573 443.026489,156.471252 
	C441.967957,156.676285 440.356445,157.873444 439.893188,156.139282 
	C439.487213,154.619598 440.589935,153.853333 442.587708,154.024368 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M454.655884,153.980072 
	C455.022461,154.443756 455.019104,154.854584 455.071655,155.568970 
	C453.549072,156.204651 452.019073,156.344406 450.730255,154.930695 
	C451.782745,153.547577 453.106415,154.012878 454.655884,153.980072 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M26.759106,289.764862 
	C25.613495,289.938843 24.797626,289.938843 23.228058,289.938843 
	C25.821844,288.250336 27.867649,287.622009 30.380627,288.113525 
	C29.639181,289.782196 27.848495,288.487122 26.759106,289.764862 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M21.916363,245.745255 
	C23.213213,244.149612 24.959742,243.466507 27.191351,244.526581 
	C25.576904,245.154373 24.172857,246.347458 21.916363,245.745255 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M191.993988,248.382462 
	C193.066040,247.913452 194.142090,247.776382 194.895477,249.322678 
	C194.718750,251.017349 193.651108,250.865311 192.412903,250.934906 
	C192.073395,250.197800 192.030380,249.472244 191.993988,248.382462 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M439.814148,243.962708 
	C442.018646,243.924469 444.043640,243.978638 446.497406,244.103745 
	C446.926208,244.174683 446.934509,244.515259 446.938660,244.685547 
	C445.810242,245.873367 444.353882,245.743042 442.575745,245.972015 
	C441.307800,245.953064 440.459320,245.943924 439.372009,245.219940 
	C438.356384,244.072983 439.309509,244.270538 439.814148,243.962708 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M200.762360,198.043533 
	C202.182190,197.538437 203.315308,196.675339 204.767670,197.810089 
	C203.567795,199.627304 202.004929,199.054916 200.520630,198.773697 
	C200.410568,198.752853 200.223145,198.598206 200.233902,198.571762 
	C200.292786,198.427032 200.402374,198.302933 200.762360,198.043533 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M209.364105,222.213043 
	C208.621414,222.216125 208.209076,222.123489 207.484818,221.988464 
	C207.553940,219.112579 209.921600,219.717667 211.109070,220.396851 
	C212.019104,220.917343 210.315765,221.581375 209.364105,222.213043 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M207.320038,267.521912 
	C208.132584,267.916107 210.287033,267.363708 209.362198,269.176361 
	C208.682373,270.508820 207.286026,270.405243 205.875259,269.263275 
	C206.174850,268.560455 206.658493,268.173492 207.320038,267.521912 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M196.715820,224.256409 
	C197.478867,223.168823 198.364059,223.016388 199.662811,223.004410 
	C200.180984,223.158752 200.351608,223.316162 200.271240,223.714905 
	C199.283005,225.558365 198.006104,226.114182 195.937683,225.803558 
	C195.586380,225.103104 195.987198,224.727554 196.715820,224.256409 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M424.302063,224.672150 
	C426.271179,223.589996 428.509491,224.013794 430.805878,224.903809 
	C428.719482,224.903809 426.633118,224.903809 424.302063,224.672150 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M458.593933,224.616272 
	C458.702637,226.865280 456.864319,225.693146 455.328247,226.161163 
	C453.693207,225.979538 452.472412,225.762268 450.969055,225.426117 
	C453.176544,225.063400 455.666595,224.819550 458.593933,224.616272 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M122.781143,210.708359 
	C122.710648,211.131622 122.478088,211.321136 122.178452,211.767761 
	C120.838890,211.691254 119.427887,212.580566 118.134705,211.147385 
	C119.448547,209.628372 121.003952,210.002167 122.781143,210.708359 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M204.577515,207.219482 
	C203.015976,208.355515 201.486954,208.278931 199.337692,207.458221 
	C201.447998,206.999069 202.784103,205.374161 204.577515,207.219482 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M184.223541,201.001953 
	C184.075668,203.697159 182.482208,203.138458 180.735245,202.558716 
	C181.370590,200.872162 182.570068,200.746826 184.223541,201.001953 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M188.019012,270.904602 
	C186.519958,272.585693 184.115372,272.779877 181.349854,273.129578 
	C182.496735,270.488007 185.218262,271.198639 188.019012,270.904602 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M173.918137,272.238220 
	C174.862030,272.122101 175.523361,272.102173 176.515961,272.089783 
	C177.331024,272.433624 177.511749,272.890442 177.051910,273.677338 
	C174.999298,273.967285 173.232239,274.589447 171.817780,273.136902 
	C172.446136,272.442719 173.041061,272.389160 173.918137,272.238220 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M205.943176,236.941742 
	C206.579285,234.072418 208.373795,235.739990 209.631241,236.118332 
	C211.038727,236.541794 210.824921,237.338348 209.271118,237.950470 
	C208.247665,237.376587 207.272324,237.991684 206.297668,237.259583 
	C206.053619,237.050186 205.979675,236.978210 205.943176,236.941742 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M216.713654,235.620789 
	C217.287231,235.793732 217.616653,235.793396 217.917969,235.885223 
	C218.339554,236.013687 218.829391,236.644318 218.426743,236.704849 
	C216.874512,236.938202 215.244019,237.061752 213.706711,236.819733 
	C212.871063,236.688156 213.691971,236.203690 213.996170,236.038467 
	C214.266525,235.891617 214.612930,235.884781 215.164886,235.618103 
	C215.768768,235.231186 216.120438,235.243652 216.713654,235.620789 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M32.705635,281.138733 
	C34.946594,279.297363 37.096046,279.717651 40.288876,280.388062 
	C37.473774,281.038361 35.626644,281.465088 33.404564,281.807678 
	C32.837471,281.604218 32.645325,281.484833 32.705635,281.138733 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M405.951721,238.024918 
	C403.384552,240.091736 400.584625,238.751953 397.549286,238.475433 
	C399.529572,238.187225 401.836456,238.062073 404.579895,237.893250 
	C405.196320,237.791046 405.376190,237.732544 405.765503,237.865326 
	C405.975006,238.056641 405.971252,238.010574 405.951721,238.024918 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M149.145111,232.589600 
	C151.223572,232.234573 152.981094,232.094650 154.738602,231.954727 
	C154.772949,232.186996 154.807312,232.419266 154.841660,232.651520 
	C152.877487,233.053757 150.914444,233.461868 148.946106,233.842514 
	C148.836594,233.863708 148.562881,233.643784 148.572571,233.560043 
	C148.602463,233.302017 148.732834,233.055618 149.145111,232.589600 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M190.863495,234.593979 
	C189.404861,234.554825 188.024124,234.923706 187.911133,233.305542 
	C187.782578,231.464752 189.275223,232.091309 190.618225,231.969299 
	C191.536453,232.781998 191.757019,233.600311 190.863495,234.593979 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M134.565094,361.940979 
	C135.000809,361.998901 134.971436,362.411652 134.964249,362.618408 
	C132.372910,362.971069 129.788742,363.116974 127.204590,363.262878 
	C127.163544,362.920593 127.122490,362.578278 127.081444,362.235992 
	C129.430756,362.118347 131.780060,362.000702 134.565094,361.940979 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M219.238831,309.034973 
	C217.372009,310.514435 215.619400,309.927765 212.992218,309.701385 
	C215.227646,308.729431 216.589203,307.847778 218.724213,308.069580 
	C219.230362,308.331848 219.355240,308.543823 219.238831,309.034973 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M42.150803,316.954041 
	C44.110622,317.006287 45.531364,315.208984 47.387791,316.504028 
	C45.698677,318.395966 43.668240,318.261169 41.557358,317.754547 
	C41.511406,317.743500 41.460999,317.530060 41.496841,317.447662 
	C41.561058,317.300110 41.689430,317.180450 42.150803,316.954041 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M509.917542,115.018921 
	C508.007172,114.758774 508.007172,114.758774 508.275635,111.704857 
	C510.069763,112.007210 509.501190,113.624107 509.917542,115.018921 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M194.655319,295.210358 
	C195.253723,294.078552 195.655121,293.230621 197.098419,293.319153 
	C198.933792,293.239258 198.515259,294.323364 198.214508,295.587830 
	C197.205704,296.038239 196.448318,296.097198 195.315277,296.087280 
	C194.781830,295.847015 194.624023,295.675629 194.655319,295.210358 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M154.016876,305.278656 
	C152.830750,305.543304 151.545273,305.539917 150.121582,305.303528 
	C151.237167,301.271057 152.585312,303.662689 154.016876,305.278656 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M197.443939,233.000580 
	C197.033890,232.579941 196.992126,232.150009 196.885437,231.402710 
	C197.774139,230.761993 198.727737,230.438660 200.062592,230.141098 
	C200.426575,230.499527 200.404160,230.831833 200.291687,231.398819 
	C199.726608,232.647354 198.846146,232.954712 197.443939,233.000580 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M200.391785,223.988251 
	C200.020264,223.956268 200.016342,223.478806 200.013367,223.240082 
	C201.568909,221.983032 203.286133,221.765030 205.466492,222.029358 
	C205.022827,222.572266 204.204605,223.079544 203.192139,223.818878 
	C202.253036,224.040710 201.508163,224.030472 200.391785,223.988251 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M6.575819,229.891357 
	C7.622604,228.201370 7.622604,228.201370 10.661139,228.324860 
	C9.727466,229.694458 8.292050,229.736526 6.575819,229.891357 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M424.466309,227.052948 
	C423.772217,228.492767 422.129028,227.696472 420.363770,228.054657 
	C419.275024,228.036911 418.567139,227.976273 417.503662,227.915955 
	C416.930267,227.778778 416.712433,227.641296 416.817810,227.292099 
	C419.440521,227.073578 421.739960,227.066757 424.466309,227.052948 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M133.206436,249.268005 
	C132.945557,252.828354 130.477676,250.188995 128.265198,251.384567 
	C129.909653,249.289963 131.666031,250.155304 133.206436,249.268005 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M38.555206,248.836395 
	C36.769100,250.007492 35.164711,250.455872 33.412300,249.419632 
	C35.257801,249.388123 36.688667,247.256897 38.555206,248.836395 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M441.837524,245.385712 
	C443.433777,245.078384 444.786255,245.026749 446.540771,244.915466 
	C446.950531,245.065887 446.958191,245.275940 446.960449,245.801300 
	C445.572845,246.412186 444.190674,246.707779 442.461304,246.919556 
	C441.711090,246.537643 441.537689,246.139511 441.837524,245.385712 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M397.328979,243.049866 
	C399.319977,240.851746 402.145935,242.329483 404.952148,242.622620 
	C402.659637,243.039078 400.223236,243.051468 397.328979,243.049866 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M390.453796,243.960358 
	C390.097900,240.391739 392.381561,242.100540 394.190979,242.651703 
	C393.307465,243.776154 392.145813,244.157562 390.453796,243.960358 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M446.248535,254.886856 
	C445.174988,254.502686 443.600433,255.700333 443.323181,253.594238 
	C444.360046,253.177017 445.300720,253.098923 446.594604,253.073303 
	C446.786224,253.651535 446.624573,254.177292 446.248535,254.886856 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M132.463837,235.756927 
	C133.437088,235.458389 134.093933,235.052216 134.576477,235.801804 
	C134.845245,236.219345 134.869629,236.873230 134.235794,236.911850 
	C132.668411,237.007355 131.091293,236.943176 129.370239,236.943176 
	C130.082642,235.280075 131.173721,235.861908 132.463837,235.756927 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M122.394394,237.057465 
	C121.109528,237.261917 119.252007,239.003677 118.829498,236.951096 
	C118.541489,235.551941 120.423645,236.130264 121.840157,236.317108 
	C122.230515,236.364639 122.447281,236.813782 122.394394,237.057465 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M40.348892,235.678741 
	C39.418423,235.617172 37.934357,236.225296 38.529339,234.914185 
	C39.107071,233.641068 40.635345,233.670059 41.923904,234.369003 
	C41.503239,234.774429 41.082569,235.179840 40.348892,235.678741 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M190.752701,234.833771 
	C190.648163,234.026001 190.866928,233.363007 191.044098,232.350342 
	C191.382919,232.189529 191.763336,232.378387 192.302582,232.708817 
	C192.770065,233.190079 193.078690,233.529755 193.698883,234.015274 
	C193.595901,236.456863 192.305634,235.608810 190.752701,234.833771 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M209.410721,172.470886 
	C208.009964,172.639297 206.040680,173.934204 205.714157,172.008621 
	C205.484360,170.653488 207.400146,171.241837 208.807236,171.159973 
	C209.453323,171.471481 209.561844,171.823608 209.410721,172.470886 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M445.476349,169.074997 
	C443.452179,169.049240 441.818054,168.967621 440.183929,168.885986 
	C440.178253,168.616806 440.172607,168.347610 440.166931,168.078430 
	C442.095673,168.078430 444.024475,168.072327 445.953003,168.092316 
	C446.079987,168.093613 446.328339,168.357697 446.310852,168.391586 
	C446.194550,168.617203 446.021210,168.813385 445.476349,169.074997 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M444.758362,179.226425 
	C442.910004,179.078430 441.465179,178.926178 439.375214,178.705963 
	C441.958405,177.919571 444.118927,177.225006 445.882233,178.113235 
	C447.400696,178.878113 445.550201,178.893066 444.758362,179.226425 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M210.956573,180.194153 
	C209.326889,179.836060 209.127075,179.058060 210.125259,178.212112 
	C210.768005,177.667374 211.741547,177.635178 212.253433,178.415833 
	C212.881638,179.373871 212.046249,179.794708 210.956573,180.194153 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M405.908508,144.786469 
	C405.064301,145.641357 405.240723,147.105087 403.807617,146.937180 
	C402.880737,146.828598 402.775909,146.158249 402.965118,145.523407 
	C403.488617,143.766602 404.679688,143.779526 405.908508,144.786469 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M177.943756,176.192062 
	C179.179779,175.946365 180.146896,175.602737 181.326202,176.574448 
	C179.895004,177.257416 178.798172,178.680496 177.943756,176.192062 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M493.599670,174.110977 
	C493.950470,174.609314 493.968719,175.003983 494.001434,175.694519 
	C493.039764,176.229462 491.762970,177.176117 491.279083,175.628784 
	C490.784576,174.047455 492.095856,173.944626 493.599670,174.110977 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M427.566925,145.640060 
	C427.569519,142.166855 429.885162,144.796051 431.293823,144.640076 
	C430.152863,145.020020 429.011902,145.399963 427.566925,145.640060 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M206.069580,164.721680 
	C207.325226,164.108658 208.882584,163.618515 211.282379,162.863220 
	C209.714355,165.796936 207.830368,164.640152 206.069580,164.721680 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M400.064270,179.983795 
	C401.389313,180.062393 402.331390,180.144958 404.153809,180.304657 
	C401.151886,181.232758 399.043427,181.233459 395.888031,180.315048 
	C397.830719,180.147430 398.756012,180.067596 400.064270,179.983795 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M430.267151,201.024994 
	C431.767944,201.020966 432.948822,200.702454 434.387482,201.747528 
	C431.989807,201.747528 430.003357,201.747528 428.016907,201.747528 
	C428.010254,201.582199 428.003601,201.416855 427.996948,201.251526 
	C428.631866,201.180222 429.266754,201.108917 430.267151,201.024994 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M470.561157,209.372635 
	C468.802429,209.972748 466.793915,210.393036 464.535309,209.531891 
	C466.583649,208.496613 468.453796,208.955292 470.561157,209.372635 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M176.412842,203.064484 
	C176.808823,201.859497 177.336594,200.958557 178.445160,201.555847 
	C178.773972,201.733002 178.979080,202.806976 178.759644,203.204117 
	C178.196198,204.223816 177.296722,204.165604 176.412842,203.064484 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M446.250336,219.681580 
	C443.710358,219.956955 441.500366,219.956955 439.290344,219.956955 
	C441.732452,219.340271 444.140961,217.804291 446.250336,219.681580 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M135.856293,211.151932 
	C137.006912,209.992783 138.139877,209.694504 139.645264,210.459656 
	C138.537537,211.921890 137.391663,212.508438 135.856293,211.151932 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M26.607727,211.428207 
	C25.773289,211.678299 25.270350,211.914825 24.810446,211.849289 
	C24.292456,211.775497 24.038649,211.257721 24.649137,210.986557 
	C26.220497,210.288605 27.787935,209.254318 29.653105,210.264465 
	C29.005568,211.462082 27.816921,210.904282 26.607727,211.428207 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M150.239227,183.983704 
	C148.914154,184.015274 147.968948,183.961639 147.023743,183.908020 
	C148.240768,183.563721 149.635452,179.874344 150.239227,183.983704 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M471.584320,133.714752 
	C471.533020,131.807724 472.781158,132.108765 473.854126,132.309937 
	C474.124207,132.360596 474.555023,133.191528 474.445587,133.358856 
	C473.811157,134.328873 472.813782,134.109848 471.584320,133.714752 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M442.404968,190.059204 
	C444.029907,190.039703 445.353821,189.441681 446.620392,190.693848 
	C444.312653,191.408051 442.216492,190.980362 440.109894,190.206116 
	C440.747803,190.158524 441.385712,190.110947 442.404968,190.059204 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M186.017502,287.361206 
	C185.646133,287.833832 185.268021,287.947357 184.605042,288.141296 
	C183.905182,287.699554 183.490204,287.177399 183.033264,286.309326 
	C183.753983,285.586761 184.516617,285.210144 185.608521,284.840454 
	C185.962097,285.565643 185.986435,286.283844 186.017502,287.361206 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M129.911835,319.999695 
	C128.741104,320.035858 127.928680,320.035858 126.146820,320.035858 
	C128.240784,318.539429 129.352798,317.194031 130.865845,319.315887 
	C130.907425,319.374237 130.782303,319.596283 130.686783,319.695801 
	C130.575623,319.811676 130.411346,319.876556 129.911835,319.999695 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M42.509510,329.813904 
	C43.587891,328.407440 45.167675,327.918793 47.128559,328.223358 
	C46.064949,330.212921 44.442635,330.089752 42.509510,329.813904 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M120.018402,376.012695 
	C120.996910,376.121124 121.930794,376.322876 121.564316,377.040314 
	C120.423203,379.274139 118.752899,377.502197 116.260056,377.856873 
	C118.047081,376.903107 118.842697,376.478455 120.018402,376.012695 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M148.290405,381.641174 
	C147.949097,381.424866 147.951752,381.351166 147.947617,381.342987 
	C148.747086,380.102570 149.829971,379.591797 151.252121,380.147552 
	C151.441376,380.221466 151.668777,380.720123 151.589859,380.875488 
	C150.943039,382.148926 149.717026,381.813049 148.290405,381.641174 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M41.012398,285.313660 
	C42.703320,285.145538 43.798748,283.350281 45.804279,284.441833 
	C44.257820,286.026611 42.692924,286.397522 41.012398,285.313660 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M114.069977,384.790894 
	C113.291145,384.560547 112.406769,384.276642 112.319885,383.835602 
	C112.160896,383.028625 113.025421,382.930481 113.669525,382.922943 
	C114.829636,382.909424 115.990364,382.949738 117.552307,382.989594 
	C118.097015,383.172821 118.240234,383.333954 118.188171,383.752869 
	C117.540909,384.057190 117.088921,384.103729 116.298599,384.194275 
	C115.439438,384.474945 114.856789,384.475342 114.069977,384.790894 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M203.747864,353.941986 
	C205.874802,353.882263 207.615509,353.882263 209.356216,353.882263 
	C209.376785,354.229950 209.397354,354.577606 209.417923,354.925293 
	C207.365082,354.925293 205.312195,354.930847 203.259537,354.911407 
	C203.137878,354.910248 202.898514,354.644989 202.916992,354.610046 
	C203.033188,354.390320 203.206924,354.201050 203.747864,353.941986 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M119.797485,306.074524 
	C120.853470,306.472961 121.561066,306.862762 122.514709,307.388092 
	C120.896530,307.709015 118.964828,309.310150 119.797485,306.074524 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M178.507080,280.074097 
	C177.499176,281.147186 176.462112,281.458282 175.414413,280.582886 
	C175.283844,280.473785 175.328064,279.881714 175.489365,279.741852 
	C176.468002,278.893280 177.503799,278.801117 178.507080,280.074097 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M136.496765,306.201630 
	C136.900909,306.294952 136.800034,306.562073 136.793152,306.704529 
	C134.677475,306.997375 132.561371,307.400818 130.009262,306.568726 
	C132.248337,305.459473 134.174530,305.824799 136.496765,306.201630 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M198.286606,295.976074 
	C197.839630,295.301483 197.716171,294.623657 197.483276,293.616089 
	C198.657928,293.116180 200.035370,292.604828 200.906525,294.611328 
	C200.193588,295.318359 199.401855,295.645599 198.286606,295.976074 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M219.552094,359.973938 
	C219.983749,360.020660 219.998688,360.453888 219.963379,360.667725 
	C217.521286,360.881561 215.114502,360.881561 212.707718,360.881561 
	C212.700409,360.563446 212.693115,360.245331 212.685806,359.927216 
	C214.830688,359.927216 216.975571,359.927216 219.552094,359.973938 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M385.769043,169.442261 
	C384.958069,170.173569 383.957977,171.504120 382.243286,170.374985 
	C382.882080,168.861908 384.158447,168.998505 385.769043,169.442261 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M386.535706,169.907867 
	C386.145233,169.831604 386.140747,169.499039 386.142578,169.332794 
	C388.049652,169.089493 389.982513,168.311661 391.927429,169.398331 
	C390.339905,170.721832 388.579498,169.908569 386.535706,169.907867 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M430.902039,245.058594 
	C430.942871,245.803879 430.964203,246.472290 430.922302,247.470749 
	C429.971588,247.775970 429.084076,247.751129 428.145874,247.385162 
	C428.219116,246.855453 428.343140,246.666870 428.670074,246.207260 
	C429.087616,245.664688 429.302277,245.393143 429.762329,245.015503 
	C430.175964,244.825485 430.344177,244.741577 430.766296,244.780273 
	C431.020203,244.902878 430.882507,244.981689 430.902039,245.058594 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M191.255768,285.171997 
	C191.107086,282.304626 192.810364,282.968170 194.629410,283.105713 
	C195.089005,283.237823 195.172455,283.404327 195.121216,283.815552 
	C194.189728,284.306488 193.392929,284.552643 192.292648,284.889191 
	C191.801163,285.161804 191.613159,285.344086 191.255768,285.171997 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M36.369549,228.935516 
	C37.299305,227.741180 38.947079,227.653549 41.193317,227.166000 
	C39.941467,229.909546 38.109806,228.618927 36.369549,228.935516 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M481.642792,142.952393 
	C481.989502,142.999786 482.000641,143.466431 482.008118,143.699707 
	C480.845215,144.206009 479.664825,144.884628 478.477966,143.837753 
	C479.115601,142.550858 480.281281,142.949692 481.642792,142.952393 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M465.130005,244.305893 
	C466.883484,244.246765 468.836121,243.100021 470.724487,244.197571 
	C470.288574,245.130554 469.384705,244.949814 468.298370,245.161041 
	C467.079193,245.027176 466.180176,244.822159 465.130005,244.305893 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M482.282959,167.711151 
	C480.851929,168.271408 479.645905,169.034805 478.372742,167.953857 
	C479.030090,166.515839 480.298035,167.039627 481.711182,167.012482 
	C482.214722,167.224930 482.360046,167.365189 482.282959,167.711151 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M191.257477,175.780930 
	C190.029007,175.981979 189.065109,175.981979 188.101227,175.981979 
	C189.238358,175.644257 190.199661,172.425446 191.257477,175.780930 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M138.580383,374.910217 
	C138.993103,374.977814 138.955978,375.414001 138.954330,375.632874 
	C136.883133,376.318542 134.842422,376.264374 132.267548,375.365662 
	C134.604614,375.158478 136.386139,375.000549 138.580383,374.910217 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M26.756458,338.855469 
	C27.624739,338.858795 28.185724,338.738129 28.569511,338.945435 
	C29.586491,339.494873 28.943546,339.914337 28.303379,339.950989 
	C26.739799,340.040527 25.167639,339.980194 23.327513,339.980194 
	C24.254087,338.510620 25.423637,339.075836 26.756458,338.855469 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M412.553528,134.564514 
	C413.265747,132.622589 414.868927,133.349319 416.387665,133.608734 
	C415.189087,134.007233 413.990479,134.405746 412.553528,134.564514 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M444.770386,175.895538 
	C445.479675,176.220001 447.360260,176.095230 445.677216,176.997864 
	C444.276215,177.749191 442.623230,176.950897 440.564880,176.391022 
	C442.200104,176.177597 443.300049,176.034058 444.770386,175.895538 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M384.689087,237.014282 
	C384.786011,237.483887 384.526062,237.949493 384.217407,238.676361 
	C383.086151,238.937607 382.003632,238.937607 380.622620,238.937607 
	C381.727142,237.253311 383.008423,237.084351 384.689087,237.014282 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M170.657959,280.445251 
	C171.666321,280.053009 172.493546,279.695679 173.107681,280.422150 
	C173.246567,280.586426 172.989120,281.411652 172.732239,281.526764 
	C171.752960,281.965576 170.542389,282.642975 170.657959,280.445251 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M150.518066,338.338348 
	C150.864410,338.703613 150.879333,339.026154 150.924866,339.590118 
	C149.627686,339.989594 148.314270,340.383850 146.952438,339.310669 
	C147.049545,338.811798 147.231064,338.704437 147.721497,338.529114 
	C148.741760,338.406311 149.453079,338.351471 150.518066,338.338348 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M196.585297,224.031860 
	C196.606110,224.504074 196.262894,224.913147 195.739929,225.531067 
	C194.641907,225.859512 193.266846,226.179840 193.456116,224.812637 
	C193.659256,223.345230 195.156387,223.861908 196.585297,224.031860 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M149.280334,275.733032 
	C150.861252,274.515442 152.704315,274.626862 154.875473,275.249573 
	C152.989212,276.533661 151.254562,276.232788 149.280334,275.733032 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M458.697906,177.558929 
	C457.807556,177.900345 456.825745,177.891907 455.476440,177.912750 
	C454.795776,177.836990 454.464203,177.767624 454.174072,177.617950 
	C453.802307,177.426147 453.895538,177.454666 454.259735,177.338303 
	C455.708740,176.875320 457.139740,176.685196 458.697906,177.558929 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M119.503357,179.488434 
	C120.570869,179.232971 121.543968,179.069870 121.332985,180.269257 
	C121.174957,181.167664 120.198502,181.232574 119.429390,181.091919 
	C118.083679,180.845779 118.530846,180.233444 119.503357,179.488434 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M155.587128,281.710052 
	C155.991714,281.962311 155.980453,282.153534 155.948730,282.631104 
	C154.024277,283.356567 152.133636,283.317108 149.734955,282.684937 
	C151.770050,281.833893 153.350418,281.209106 155.587128,281.710052 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M7.510853,261.713623 
	C7.151253,261.388519 7.125991,261.047516 7.118546,260.450439 
	C8.512801,259.941040 9.897516,259.490570 11.307967,260.364441 
	C10.433718,261.658539 8.962778,261.229553 7.510853,261.713623 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M446.894592,241.700592 
	C444.936890,242.449234 442.870026,242.369385 440.601776,241.435120 
	C442.495972,241.269882 444.648041,240.510040 446.894592,241.700592 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M214.414703,228.963608 
	C214.495499,228.510773 214.925552,228.175934 215.611481,227.698212 
	C216.669754,227.200119 217.855118,227.267502 217.713776,228.090530 
	C217.435944,229.708344 215.931839,229.229324 214.414703,228.963608 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M209.576187,172.785370 
	C209.250824,172.378922 209.225082,172.033325 209.198669,171.427795 
	C209.929306,170.909561 210.564713,169.267410 211.343613,170.613708 
	C211.788589,171.382828 211.406494,172.773804 209.576187,172.785370 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M439.890320,172.301468 
	C442.248779,172.454803 444.431213,170.717163 446.931854,172.010620 
	C444.952759,174.072327 442.706970,172.880875 440.335052,173.170135 
	C439.831024,172.881287 439.763824,172.699646 439.890320,172.301468 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M44.691620,278.092529 
	C45.122917,280.709625 43.437870,279.905457 41.935173,279.762177 
	C42.457951,278.618805 43.389694,278.291809 44.691620,278.092529 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M150.495483,317.146545 
	C151.294495,314.828583 152.886154,316.250244 154.625168,316.087708 
	C153.421646,317.705414 152.042938,317.428497 150.495483,317.146545 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M188.342255,242.968018 
	C187.628235,242.199646 187.338531,241.437119 186.871765,240.408112 
	C187.399323,240.088501 188.103958,240.035339 189.158813,239.973480 
	C189.758560,240.675217 190.008072,241.385635 190.358185,242.459793 
	C189.894730,242.873627 189.330658,242.923737 188.342255,242.968018 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M197.714813,382.281708 
	C196.862991,382.633972 195.816803,382.759338 194.375107,382.825165 
	C194.693909,380.207733 196.066833,380.930359 197.714813,382.281708 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M177.013580,273.846375 
	C176.783051,273.491150 176.854248,273.094452 176.886353,272.397522 
	C177.812027,271.905609 179.062119,270.374237 179.681046,271.978821 
	C180.580902,274.311707 177.960373,272.960297 177.013580,273.846375 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M220.149780,331.020630 
	C218.867722,332.254150 217.100449,332.609802 216.351425,331.278900 
	C215.783295,330.269440 217.462585,330.165253 218.774200,330.143982 
	C219.466995,330.364807 219.792175,330.554535 220.149780,331.020630 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M411.751343,127.284607 
	C412.378418,127.483917 412.614197,127.737610 413.063110,128.147583 
	C411.297577,129.332230 409.227753,129.158646 406.923340,129.000366 
	C408.070831,126.886208 410.199097,128.538879 411.751343,127.284607 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M158.369232,230.666367 
	C159.296921,230.364288 159.794662,228.383682 161.357437,229.292679 
	C161.531418,229.393875 161.631256,229.908554 161.537369,230.138245 
	C160.896210,231.706802 159.665344,230.858780 158.369232,230.666367 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M194.587921,294.786316 
	C194.844070,295.101593 194.843735,295.286713 194.891510,295.745117 
	C194.513000,296.100281 194.086395,296.182190 193.341293,296.336029 
	C191.863007,295.842346 192.083694,294.777252 192.085785,293.419189 
	C192.094345,293.043976 192.540039,292.961151 192.760468,292.908142 
	C193.431091,293.455505 193.881271,294.055847 194.587921,294.786316 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M389.527466,155.842133 
	C389.388977,155.303574 389.604828,154.890503 389.923462,154.267853 
	C391.045166,154.032837 392.673950,153.302917 392.631348,154.978516 
	C392.594940,156.411545 390.939423,155.939972 389.527466,155.842133 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M430.686340,154.981903 
	C431.371002,155.281433 432.672028,155.274338 432.002289,155.624725 
	C430.487640,156.417130 428.633789,156.316238 426.809967,155.651001 
	C427.881775,154.428497 429.156952,155.018951 430.686340,154.981903 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M216.773254,300.757812 
	C218.448746,300.018677 220.461929,299.652008 223.104660,300.192688 
	C220.916641,301.890808 218.874741,300.477722 216.773254,300.757812 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M429.982330,187.085266 
	C429.116699,187.037689 428.513763,187.146271 428.155365,186.899597 
	C426.999023,186.103638 428.162994,185.995239 428.565582,185.992722 
	C430.028503,185.983551 431.492249,186.101532 432.971283,186.638519 
	C432.099854,186.785263 431.228424,186.932022 429.982330,187.085266 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M220.558487,331.245728 
	C219.909119,331.082306 219.639893,330.861023 219.258255,330.403961 
	C221.137329,330.168182 223.128815,330.168182 225.658951,330.168182 
	C223.834976,331.475739 222.334030,331.004761 220.558487,331.245728 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M31.520603,200.766556 
	C32.074265,200.357407 32.571869,200.114075 33.004734,200.199341 
	C34.418289,200.477814 35.251434,198.093201 36.809105,199.409134 
	C36.966034,199.541687 36.980759,200.071732 36.847702,200.282089 
	C35.796806,201.943588 34.205200,200.607834 32.497032,201.028168 
	C31.871498,201.099686 31.653202,201.091263 31.520603,200.766556 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M124.007980,319.428467 
	C123.971695,321.327667 122.859352,321.193909 121.690147,320.788910 
	C121.500099,320.723114 121.271469,320.228210 121.342705,320.036346 
	C121.798225,318.809479 122.805771,319.027802 124.007980,319.428467 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M166.554596,161.867477 
	C167.121628,162.538193 167.296707,163.187088 167.273895,164.008820 
	C166.066803,163.771988 164.692413,164.261505 163.957764,162.626129 
	C164.632172,162.148636 165.397415,161.997147 166.554596,161.867477 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M28.939125,166.059052 
	C28.432592,165.945435 27.994377,165.920792 27.227356,165.910645 
	C26.957617,164.935379 27.016685,163.945633 27.072680,162.582077 
	C27.069607,162.208282 27.498035,162.120026 27.713129,162.081055 
	C28.292442,162.809982 28.656660,163.577896 29.071989,164.664642 
	C29.195969,165.157242 29.268841,165.331009 29.276634,165.779785 
	C29.211555,166.054825 29.007446,166.148056 28.939125,166.059052 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M124.821930,376.238098 
	C127.035919,375.935760 128.889267,375.841492 130.742615,375.747223 
	C128.661728,376.676453 126.617538,377.631409 124.821930,376.238098 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M134.569031,311.985229 
	C135.001831,312.000336 135.034683,312.474030 134.996918,312.708374 
	C132.818497,312.526703 130.573898,313.661316 128.257446,312.623749 
	C130.259628,311.200043 132.292847,312.581665 134.569031,311.985229 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M403.562500,185.783264 
	C403.161163,185.347733 403.117035,184.993942 403.082062,184.372925 
	C404.119507,184.019241 405.565735,183.129120 405.790497,184.925964 
	C405.921692,185.974777 404.736267,185.895126 403.562500,185.783264 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M212.947128,186.208649 
	C212.682785,187.607452 212.121353,188.302277 210.986832,187.796951 
	C210.748001,187.690582 210.534454,186.997742 210.651367,186.718216 
	C211.059341,185.742859 211.455856,184.424988 212.947128,186.208649 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M188.873596,131.480316 
	C190.049667,131.401337 191.077698,129.744263 192.772079,130.690002 
	C191.695969,131.285309 190.664856,132.822144 188.873596,131.480316 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M388.753418,201.298462 
	C390.235870,201.010406 391.483917,199.982269 392.720917,201.170853 
	C392.046814,202.676682 390.715515,201.857788 389.352844,202.013977 
	C388.832489,201.795044 388.663422,201.651276 388.753418,201.298462 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M431.505920,195.258850 
	C430.177612,196.908066 428.536194,195.513794 426.899353,195.755188 
	C428.215607,194.434738 429.768494,195.108246 431.505920,195.258850 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M210.740219,205.116699 
	C210.676987,207.490936 209.252380,206.944855 207.144684,206.924927 
	C208.764954,205.960617 209.685120,205.412979 210.740219,205.116699 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M173.897827,203.050461 
	C173.878098,204.330994 173.369278,205.011246 172.488495,204.682816 
	C171.658585,204.373398 171.576691,203.304153 171.924316,202.657166 
	C172.382492,201.804550 173.183243,201.996262 173.897827,203.050461 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M29.520210,202.200073 
	C28.104479,202.870941 26.956686,204.080551 25.126781,203.586914 
	C25.559048,201.840302 26.930548,202.006744 28.465887,201.832458 
	C29.072021,201.812805 29.318357,201.822876 29.520210,202.200073 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M384.204651,202.104828 
	C383.118561,202.326981 382.387634,203.079865 381.622681,202.358887 
	C381.440918,202.187622 381.319702,201.625687 381.431183,201.521133 
	C382.374847,200.635803 383.478333,200.825760 384.573883,201.202148 
	C384.647980,201.227615 384.709473,201.422272 384.698730,201.530502 
	C384.683197,201.687469 384.596405,201.837387 384.204651,202.104828 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M81.766296,191.220428 
	C82.188560,191.631531 82.348877,192.276810 82.818161,193.080078 
	C83.416107,193.586960 83.518661,193.987991 83.250168,194.680969 
	C82.576851,194.945541 82.114883,194.962860 81.306931,194.934540 
	C81.142082,193.744141 81.323227,192.599380 81.766296,191.220428 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M168.387085,299.951385 
	C168.596252,297.962402 169.360092,297.068115 170.804352,299.558411 
	C170.118362,299.930542 169.422119,299.993042 168.387085,299.951385 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M171.627731,160.964386 
	C171.848938,163.675980 170.597733,163.344131 168.907593,161.789398 
	C169.596970,161.287811 170.402069,161.093826 171.627731,160.964386 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M188.356476,161.047119 
	C188.206314,158.892471 189.258606,158.587769 191.185669,159.902649 
	C190.808899,161.269531 189.730759,161.067932 188.356476,161.047119 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M157.412598,359.907349 
	C157.046005,359.833984 157.049210,359.497162 157.044891,359.328827 
	C158.260727,359.006348 159.442261,358.124237 160.983810,359.068481 
	C160.166397,360.547333 158.888489,360.020264 157.412598,359.907349 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M21.377535,359.035767 
	C20.685764,358.974884 20.366156,358.933563 20.062733,358.839813 
	C19.917330,358.794922 19.802567,358.650848 19.673935,358.551636 
	C21.293467,357.624084 22.922247,357.676788 24.742250,358.339020 
	C23.742374,359.307617 22.718830,359.008789 21.377535,359.035767 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M208.070862,294.264465 
	C208.356781,293.168396 208.894165,292.310333 209.684204,291.300049 
	C209.084610,292.114868 211.549118,294.678223 208.070862,294.264465 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M144.506348,298.303467 
	C144.705170,299.539673 144.156403,300.073242 143.168350,299.830200 
	C142.806778,299.741211 142.258102,299.166931 142.301407,298.894623 
	C142.484177,297.745270 143.429169,298.012665 144.506348,298.303467 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M185.381134,298.987732 
	C184.948395,297.915680 185.196182,297.094391 186.734650,296.833435 
	C187.339462,297.293976 187.594803,297.807495 187.821655,298.610931 
	C187.103958,298.940369 186.414780,298.979950 185.381134,298.987732 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M184.573822,348.849365 
	C184.964722,348.965363 184.956573,349.144257 184.935913,349.591248 
	C183.217468,349.914215 181.511566,349.969147 179.376053,349.985992 
	C178.946457,349.947876 178.976868,349.978424 178.987198,349.996002 
	C180.457489,348.397064 182.370544,348.910492 184.573822,348.849365 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M33.439831,306.997925 
	C34.640102,305.469727 36.448036,305.910217 38.694729,306.269348 
	C36.886219,307.514984 35.305008,306.768402 33.439831,306.997925 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M192.269516,183.372772 
	C191.297455,184.080185 190.405670,184.297852 189.794769,183.710968 
	C188.996689,182.944229 190.084747,182.663895 190.473297,182.475372 
	C191.243500,182.101685 192.507568,180.766785 192.269516,183.372772 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M33.011677,307.008026 
	C31.505163,308.356598 29.795704,308.312958 27.714396,307.696716 
	C29.236807,306.269135 30.839586,307.335358 32.645798,307.041626 
	C33.052189,307.037750 33.004246,307.029968 33.011677,307.008026 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M155.396683,366.969666 
	C155.004837,366.836182 155.117966,366.549316 155.113739,366.395325 
	C156.870560,365.812469 158.616211,365.642456 160.445526,366.448242 
	C158.922653,367.776459 157.344757,367.351593 155.396683,366.969666 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M167.828308,306.354431 
	C169.031189,306.088959 170.427063,305.724121 170.671280,306.812103 
	C170.986557,308.216553 169.476410,307.942841 168.238358,308.124908 
	C167.557800,307.635345 167.463745,307.158295 167.828308,306.354431 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M482.474609,168.015778 
	C482.060577,167.916855 482.058929,167.500763 482.064178,167.292725 
	C483.886749,166.650177 485.710815,165.640549 487.753632,167.259216 
	C486.232025,168.738602 484.494598,168.112656 482.474609,168.015778 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M187.006180,282.554993 
	C186.257858,282.918304 185.503769,282.960480 184.372253,282.982117 
	C183.995056,282.580109 183.995316,282.198639 183.990173,281.531128 
	C184.728882,281.157196 185.472992,281.069336 186.591537,280.962891 
	C186.977448,281.374146 186.988937,281.804016 187.006180,282.554993 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M158.745270,173.109528 
	C158.147675,174.133453 157.418152,174.320404 156.735855,173.665359 
	C156.537125,173.474564 156.544098,172.731171 156.746704,172.522339 
	C157.435272,171.812592 158.139664,172.067291 158.745270,173.109528 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M195.082275,284.305939 
	C194.986511,284.060303 194.988327,283.565338 194.996948,283.318359 
	C195.455399,282.739349 195.905228,282.407379 196.648285,282.053925 
	C197.200470,283.001862 197.340393,283.954407 196.265488,285.005280 
	C195.711105,285.007019 195.444565,284.779297 195.082275,284.305939 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M122.427254,230.843704 
	C121.478233,230.051102 121.327690,229.370804 122.436783,229.067307 
	C122.809486,228.965302 123.503845,229.098465 123.674034,229.364990 
	C124.298630,230.343155 123.537277,230.676727 122.427254,230.843704 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M441.703308,245.080261 
	C442.078156,245.509048 442.075012,245.888062 442.093018,246.551422 
	C441.318237,246.861465 440.522308,246.887207 439.327087,246.916138 
	C438.963440,246.483246 438.999146,246.047150 439.039185,245.282562 
	C439.804138,244.979538 440.564728,245.005020 441.703308,245.080261 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M391.868744,247.714905 
	C391.218475,248.401825 390.436646,248.826065 389.326965,249.151215 
	C389.250854,247.387680 389.381531,245.516113 391.868744,247.714905 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M164.197098,229.743301 
	C164.144196,228.046265 165.113083,227.819565 166.342102,228.169266 
	C166.543488,228.226562 166.829254,228.619904 166.789398,228.791275 
	C166.502502,230.025162 165.450974,229.902588 164.197098,229.743301 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M401.953003,230.699966 
	C401.246887,230.974045 400.491974,230.922333 399.360657,230.825577 
	C399.694397,228.754166 400.622833,228.296127 401.953003,230.699966 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M160.338669,259.152222 
	C161.282578,259.170319 161.903290,259.277161 162.524002,259.384033 
	C162.056854,260.334167 161.149323,260.911346 160.243118,260.815369 
	C158.917389,260.674927 159.293488,259.893829 160.338669,259.152222 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M140.146606,248.237366 
	C141.124863,248.244858 141.774826,248.351929 142.424774,248.459000 
	C141.611420,248.975769 140.774673,249.950638 139.989761,249.910553 
	C138.517654,249.835373 139.238678,248.957611 140.146606,248.237366 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M456.664886,258.076874 
	C457.068726,259.230408 457.886261,260.671814 455.438782,260.907471 
	C455.022552,260.164001 454.978790,259.456848 455.039490,258.407288 
	C455.549500,258.068054 455.955017,258.071259 456.664886,258.076874 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M160.614426,266.454529 
	C161.467804,266.317719 162.349609,266.191376 162.576126,266.518585 
	C162.997986,267.127960 162.425980,267.634186 161.764969,267.778259 
	C160.893768,267.968109 160.193893,267.837769 160.614426,266.454529 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M133.385742,228.664185 
	C131.866943,228.944031 130.616562,229.713440 129.308289,228.580536 
	C130.825409,227.231827 132.247299,227.906158 133.385742,228.664185 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M114.845825,389.769226 
	C114.213539,390.281342 113.415634,390.547058 112.298355,390.778809 
	C111.872559,388.111847 113.019394,388.249268 114.845825,389.769226 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M138.522156,227.009064 
	C139.355881,226.789413 139.943176,226.690552 140.530457,226.591675 
	C140.581467,226.894913 140.785706,227.333237 140.657593,227.478561 
	C140.025330,228.195724 139.192184,227.980820 138.397247,227.790085 
	C138.265350,227.758438 138.052979,227.632294 138.056351,227.557938 
	C138.062958,227.412231 138.195374,227.272232 138.522156,227.009064 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M381.195374,226.777466 
	C380.218231,226.020737 379.984985,225.395035 381.173737,225.105728 
	C381.770050,224.960602 382.518463,224.989655 382.667755,225.694229 
	C382.823822,226.430695 382.130341,226.689087 381.195374,226.777466 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M125.637451,402.899475 
	C125.971809,403.356140 125.934021,403.766693 125.863754,404.484650 
	C125.127251,404.853973 124.423233,404.915863 123.366371,404.935852 
	C122.664085,404.531860 122.524200,404.097076 122.827484,403.352356 
	C123.815193,403.021088 124.540245,402.937225 125.637451,402.899475 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M166.782074,235.155716 
	C166.686401,236.160614 166.417343,236.849625 165.622482,236.664352 
	C164.944977,236.506424 164.643539,235.846237 164.908630,235.153442 
	C165.303345,234.122009 165.965378,234.102478 166.782074,235.155716 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M195.339386,263.042419 
	C194.961487,262.829498 194.938965,262.650970 194.886261,262.204071 
	C195.938828,261.701508 197.021606,261.467346 198.423340,261.324707 
	C198.678146,263.716339 196.888199,262.849274 195.339386,263.042419 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M430.454529,241.978027 
	C429.979095,240.940750 430.554810,240.380478 431.695435,239.921265 
	C432.271515,240.368591 432.849274,240.976578 432.726562,241.360825 
	C432.452667,242.218262 431.547241,242.059402 430.454529,241.978027 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M11.899418,235.846832 
	C12.231409,234.596832 13.283786,234.329224 14.408731,234.375809 
	C14.573249,234.382614 14.951764,235.300552 14.814732,235.481552 
	C14.139089,236.373901 13.113536,236.023972 11.899418,235.846832 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M21.006565,240.006653 
	C20.992659,238.806519 21.653387,238.251907 22.783781,238.364807 
	C23.100975,238.396484 23.660564,238.949036 23.616158,239.157837 
	C23.389420,240.223923 22.417923,239.874619 21.344852,239.995377 
	C20.991844,239.991837 21.001041,240.001038 21.006565,240.006653 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M36.724632,208.765564 
	C35.745365,208.840714 35.118069,208.784027 34.490776,208.727356 
	C35.139629,207.692612 36.160778,206.788391 37.266972,207.092667 
	C38.803768,207.515366 37.461807,208.134674 36.724632,208.765564 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M122.627365,237.524780 
	C122.372925,237.089554 122.362740,236.879974 122.270737,236.518524 
	C123.140213,235.882751 124.444702,235.501602 124.776764,236.528610 
	C125.166756,237.734772 124.035995,238.062775 122.627365,237.524780 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M123.673347,382.437256 
	C124.034622,382.663544 124.031586,382.937744 124.020706,383.417908 
	C123.898659,383.901703 123.782524,384.179443 123.317886,384.170013 
	C122.522697,383.914154 122.076012,383.945435 121.308212,384.076416 
	C120.816933,384.231018 120.646767,384.285889 120.226746,384.243286 
	C120.036682,381.481079 122.276436,383.192993 123.673347,382.437256 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M123.389511,242.949829 
	C124.574219,243.083328 125.162994,243.591278 124.774345,244.500580 
	C124.507576,245.124741 123.804138,245.313873 123.179031,244.995499 
	C122.142059,244.467361 122.649071,243.746048 123.389511,242.949829 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M164.435349,245.570938 
	C163.864136,245.283417 163.682571,244.997787 163.375946,244.490234 
	C164.239380,243.882904 165.227859,243.497498 166.540955,243.141113 
	C167.285797,243.464111 167.467163,243.872330 167.240387,244.676529 
	C166.299911,245.173904 165.562439,245.373367 164.435349,245.570938 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M139.594452,263.389404 
	C140.436752,262.878296 141.117950,262.625610 141.450058,263.411774 
	C141.732925,264.081482 141.380203,264.649628 140.668381,264.845703 
	C139.648758,265.126526 139.168488,264.732178 139.594452,263.389404 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M219.309143,323.682892 
	C217.382965,323.884491 215.652161,323.884491 213.416809,323.884491 
	C215.239761,322.548889 216.839951,323.235992 218.691559,323.026398 
	C219.232849,323.223755 219.368683,323.352509 219.309143,323.682892 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M183.385635,235.082520 
	C183.037247,234.523788 183.019150,234.096512 183.017792,233.348877 
	C183.931641,232.525055 184.929245,232.119629 185.245178,233.530411 
	C185.469391,234.531708 185.103775,235.451660 183.385635,235.082520 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M219.521362,323.921204 
	C219.113754,323.884491 219.052383,323.490875 219.074707,323.292969 
	C220.877930,323.035278 222.683411,322.548981 224.533829,323.415527 
	C223.036392,324.543579 221.441711,323.920990 219.521362,323.921204 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M454.570435,232.305695 
	C456.471405,231.977066 458.447479,231.528687 460.359894,232.410721 
	C459.047546,234.255463 457.283295,232.871094 455.373566,233.209595 
	C454.839661,233.038177 454.722717,232.842194 454.570435,232.305695 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M27.814213,251.047424 
	C28.782562,249.422714 30.221296,250.160416 31.915148,250.048325 
	C30.619200,251.529266 29.193604,250.874680 27.814213,251.047424 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M175.839737,220.291367 
	C174.981598,221.270111 174.086533,221.197983 173.199661,220.712723 
	C173.149994,220.685532 173.241028,220.142853 173.397400,220.041061 
	C174.180954,219.530945 175.004929,218.919296 175.839737,220.291367 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M388.330780,258.580566 
	C387.341187,258.930725 386.512787,258.951569 385.270386,258.950714 
	C384.546478,258.409607 384.503235,257.868591 385.115295,257.135101 
	C386.111755,256.972412 386.717621,256.980682 387.626404,256.982666 
	C388.314667,257.314026 388.492401,257.743317 388.330780,258.580566 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M382.003296,209.848572 
	C380.890106,209.055145 381.030548,208.436401 382.011047,208.047821 
	C382.688843,207.779175 383.367859,208.021347 383.529877,208.694794 
	C383.723358,209.498840 382.976440,209.702850 382.003296,209.848572 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M183.693634,256.975037 
	C183.955048,257.998444 183.042755,258.076569 182.162857,258.651031 
	C181.253204,258.729767 180.048874,258.833618 180.414093,257.731659 
	C180.876953,256.335114 182.302231,257.113098 183.693634,256.975037 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M165.852722,269.100464 
	C165.154282,273.965332 164.208038,268.011383 163.503113,269.260559 
	C164.035767,269.166046 164.816269,269.027527 165.852722,269.100464 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M37.374443,254.960281 
	C38.074669,253.520874 39.717968,254.256470 41.662601,254.071152 
	C40.970409,255.487778 39.314159,254.697296 37.374443,254.960281 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M187.593079,319.954590 
	C188.000519,320.023132 187.944443,320.405090 187.930176,320.597351 
	C186.551758,320.864838 185.187622,320.940094 183.412048,320.984558 
	C183.000641,320.953796 183.052063,320.560333 183.072021,320.363220 
	C184.456512,320.072754 185.821075,319.979370 187.593079,319.954590 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M162.766479,289.185852 
	C163.204391,288.992371 163.385117,289.010925 163.821350,289.124146 
	C163.860062,290.252502 164.468323,291.691315 162.375610,291.966431 
	C162.027618,291.958130 161.913269,291.511139 161.886383,291.282043 
	C161.513855,290.280487 161.954803,289.816895 162.766479,289.185852 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M162.895966,288.832886 
	C162.739029,289.494965 162.454407,290.016113 162.014633,290.795044 
	C161.405136,291.014648 160.950775,290.976410 160.154205,290.911346 
	C159.812012,290.884521 159.868454,290.542572 159.888031,290.370605 
	C160.348923,289.772827 160.790207,289.347015 161.664825,288.744995 
	C162.362015,288.389221 162.585388,288.430298 162.895966,288.832886 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M15.842978,360.018677 
	C14.894358,359.878601 14.294839,359.748230 13.695320,359.617889 
	C14.683729,358.624390 15.851180,358.936005 17.001198,359.179840 
	C17.140146,359.209290 17.251814,359.367432 17.376125,359.465942 
	C16.981445,359.653442 16.586761,359.840912 15.842978,360.018677 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M41.290993,292.287109 
	C40.347961,293.297333 39.079395,293.119690 37.720020,292.702148 
	C38.671215,291.452972 39.907204,292.104004 41.290993,292.287109 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M40.209145,241.771912 
	C40.897591,240.899017 41.631042,240.704727 42.362659,241.306534 
	C42.471542,241.396103 42.405640,241.942734 42.251698,242.064682 
	C41.606403,242.575882 40.896564,242.932968 40.209145,241.771912 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M3.660390,255.973068 
	C5.201642,254.539902 6.799563,254.980682 8.855546,254.896622 
	C7.487741,256.542816 6.084376,255.806747 4.579514,256.202209 
	C3.994480,256.241974 3.792384,256.255341 3.660390,255.973068 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M458.781189,258.065552 
	C460.229980,258.624756 460.493500,259.424469 459.159119,260.692535 
	C458.001740,260.590973 457.612244,259.910492 458.008057,258.546936 
	C458.089325,258.221252 458.567291,258.174622 458.781189,258.065552 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M37.631058,343.243225 
	C38.981960,342.968231 40.036919,342.913177 41.091873,342.858154 
	C39.918148,344.206909 38.665924,344.358826 37.631058,343.243225 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M151.137360,298.673065 
	C152.140640,298.237122 153.082306,298.123718 154.985641,297.894470 
	C153.198883,299.137817 152.377472,300.067993 151.137360,298.673065 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M456.704163,145.163193 
	C457.265991,145.880814 457.664124,146.608505 458.005829,147.648682 
	C457.494629,148.012497 457.039886,148.063843 456.242432,148.089264 
	C455.948303,147.359192 455.996826,146.655029 456.130768,145.586365 
	C456.216156,145.221863 456.540497,145.173264 456.704163,145.163193 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M390.538208,147.858459 
	C390.422791,147.372482 390.665192,146.967361 390.991455,146.341156 
	C391.846222,146.015289 392.830841,145.856949 392.886810,146.897385 
	C392.964813,148.346786 391.761871,147.955017 390.538208,147.858459 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M32.185600,319.259338 
	C31.250780,320.188354 30.008034,320.242767 28.670340,319.818878 
	C29.518633,318.348297 30.827919,319.140228 32.185600,319.259338 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M203.029755,295.271240 
	C203.398331,293.985718 204.314087,293.782349 205.754349,293.953857 
	C205.558441,295.252167 204.775711,296.120697 203.029755,295.271240 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M167.342102,244.949371 
	C167.013535,244.572037 166.989716,244.169647 166.915726,243.468674 
	C167.621002,243.102325 168.376465,243.034546 169.511871,242.972931 
	C169.939728,243.153519 169.987625,243.327972 169.974121,243.766510 
	C169.157425,244.328476 168.402130,244.626373 167.342102,244.949371 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M198.359329,165.959610 
	C198.973450,165.454300 199.571518,165.075577 200.120697,165.136627 
	C200.744644,165.206009 200.590225,165.807587 200.281982,166.193375 
	C199.679688,166.947205 199.013611,167.126724 198.359329,165.959610 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M42.389488,297.981262 
	C43.670616,297.946625 44.643108,297.395264 45.640274,298.437042 
	C44.446831,299.526764 43.128284,299.020508 41.885586,298.887451 
	C41.754742,298.873474 41.641190,298.697968 41.519608,298.597412 
	C41.682457,298.413147 41.845306,298.228882 42.389488,297.981262 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M416.806030,227.052246 
	C417.141052,227.080414 417.098114,227.499374 417.123108,227.707825 
	C415.756836,227.837799 414.157959,228.565704 413.082764,226.552246 
	C413.170776,226.185822 413.352997,226.160965 413.809662,226.166779 
	C414.698181,226.997223 415.592773,226.987030 416.806030,227.052246 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M209.780960,310.057770 
	C208.490906,310.114563 207.505478,310.392090 206.706909,309.491364 
	C207.979736,308.582794 209.249359,308.584686 210.551529,309.347260 
	C210.583832,309.366180 210.546509,309.576904 210.488068,309.660828 
	C210.399765,309.787628 210.264252,309.881500 209.780960,310.057770 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M207.880524,186.977386 
	C209.187851,187.062210 209.769104,187.550613 209.101639,188.518829 
	C208.888046,188.828659 208.185150,189.062622 207.814819,188.955505 
	C206.539688,188.586700 207.090256,187.803589 207.880524,186.977386 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M43.658470,367.912659 
	C44.330822,368.193115 45.677269,368.037415 44.793602,368.750977 
	C43.919193,369.457031 42.493256,369.445740 41.475708,368.413361 
	C42.084358,368.244598 42.693008,368.075806 43.658470,367.912659 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M147.535370,190.880066 
	C147.858627,191.077744 147.839279,191.284348 147.879745,191.796631 
	C147.062119,192.366592 145.849335,193.463577 145.353760,192.348938 
	C144.707809,190.896194 146.418716,191.226364 147.535370,190.880066 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M31.555458,376.983246 
	C30.417778,377.047943 29.631027,377.047943 28.844278,377.047943 
	C29.880571,375.818573 31.020510,375.654449 32.259605,376.324188 
	C32.310856,376.351868 32.332767,376.557983 32.286625,376.615997 
	C32.188389,376.739532 32.036366,376.820282 31.555458,376.983246 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M132.490677,325.572205 
	C133.394638,326.173920 133.646164,326.709015 132.639221,326.958191 
	C132.218048,327.062408 131.421173,326.945099 131.290375,326.682190 
	C130.902313,325.902161 131.480118,325.566010 132.490677,325.572205 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M219.400024,309.297607 
	C219.015747,309.115143 219.033905,308.916107 219.078796,308.418518 
	C220.500977,308.119904 221.896454,308.119904 223.491791,308.119904 
	C222.455215,309.999756 220.957687,308.968781 219.400024,309.297607 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M339.549255,134.411469 
	C339.999481,135.940842 339.490723,136.951935 337.389893,136.991470 
	C337.267487,136.480469 337.536163,135.959747 337.904510,135.162689 
	C338.409515,134.726898 338.814911,134.567413 339.549255,134.411469 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M438.673523,132.726776 
	C439.169098,132.303513 440.265961,132.174789 440.345032,130.636520 
	C442.155396,132.387711 441.207031,132.898071 438.673523,132.726776 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M200.660889,215.759735 
	C201.546463,214.583710 202.767822,214.729401 204.085358,215.206833 
	C203.246368,216.535049 202.029984,216.072906 200.660889,215.759735 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M24.601440,370.940033 
	C25.007231,370.976807 25.013960,371.441284 24.993637,371.672638 
	C23.624651,371.928619 22.275988,371.953247 20.530434,371.905151 
	C20.133539,371.832428 20.160143,371.524811 20.158680,371.370605 
	C21.503363,371.112030 22.849506,371.007660 24.601440,370.940033 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M39.548119,329.854889 
	C39.044792,332.038330 37.699657,331.056274 36.225979,330.642578 
	C37.184624,329.605865 38.228054,329.901184 39.548119,329.854889 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M386.097656,209.244812 
	C386.759827,207.273026 388.546967,208.229568 389.988464,207.942139 
	C390.202393,207.899506 391.161987,208.056717 390.575653,208.699219 
	C390.237976,209.069260 389.494568,209.069000 388.537964,209.277893 
	C387.592316,209.446686 387.036591,209.482880 386.097656,209.244812 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M170.222580,328.974579 
	C171.529999,329.025574 172.463806,329.132812 173.967728,329.305511 
	C172.079056,330.000092 170.782181,330.506348 169.427277,329.635620 
	C169.393539,329.613953 169.426392,329.413635 169.484207,329.341461 
	C169.582245,329.219055 169.724991,329.132446 170.222580,328.974579 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M400.497253,129.916931 
	C400.079987,129.849609 400.107147,129.527618 400.101868,129.366135 
	C401.661530,129.204895 403.239624,128.370865 404.926178,129.249313 
	C403.721222,130.738541 402.196075,129.692337 400.497253,129.916931 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M493.109253,205.765549 
	C494.066345,205.948425 494.655762,206.108810 495.245148,206.269180 
	C494.497955,207.588516 493.113770,207.474442 492.224091,206.988312 
	C490.750366,206.183044 492.197449,206.031479 493.109253,205.765549 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M387.395935,274.017548 
	C387.521057,272.930786 388.188660,271.863129 389.238373,272.514984 
	C390.234161,273.133331 389.369293,273.865875 388.288025,274.343445 
	C387.979004,274.411011 387.618530,274.101013 387.395935,274.017548 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M426.270050,215.979553 
	C427.101685,216.146194 427.629059,216.333649 428.156464,216.521088 
	C427.177704,217.331589 426.155823,217.087875 425.133667,216.629913 
	C425.092926,216.611664 425.088043,216.361267 425.126617,216.342422 
	C425.397491,216.210236 425.684174,216.110474 426.270050,215.979553 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M154.558319,215.997894 
	C154.416641,218.264191 153.068451,216.664749 151.949585,216.748199 
	C152.568588,215.778091 153.466919,216.025421 154.558319,215.997894 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M187.899841,200.751923 
	C188.688904,199.495789 189.778290,200.029312 191.445999,200.122314 
	C190.118790,201.274918 189.125885,201.194305 187.899841,200.751923 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M44.660667,272.692688 
	C43.960796,273.222717 43.366966,273.438049 42.773132,273.653412 
	C42.682117,273.244659 42.376808,272.631866 42.537647,272.462921 
	C43.190151,271.777649 43.999809,271.870758 44.660667,272.692688 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M433.296051,237.954514 
	C432.879303,237.600952 432.785767,237.212708 432.560059,236.552643 
	C433.222931,236.172775 434.127136,234.940445 434.772308,236.267426 
	C435.187103,237.120605 434.455353,237.674286 433.296051,237.954514 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M444.636719,231.062180 
	C445.557220,231.052444 446.189392,231.086304 446.900848,231.124405 
	C446.167175,232.526016 445.145538,231.931671 444.220093,231.761841 
	C444.124054,231.744232 443.972504,231.507568 444.001862,231.438904 
	C444.059875,231.303284 444.226562,231.214157 444.636719,231.062180 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M40.925331,362.001465 
	C42.273018,360.746796 43.829590,360.959259 45.842266,360.984985 
	C44.365616,362.800171 42.938282,361.632202 41.296501,361.904358 
	C40.879574,361.947571 40.905655,361.988159 40.925331,362.001465 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M395.604370,231.017975 
	C395.796417,231.477814 395.555878,231.933914 395.283020,232.643768 
	C394.739410,232.927811 394.228149,232.958084 393.333801,232.984909 
	C392.636078,232.675491 392.479919,232.303070 392.536469,231.551910 
	C393.451141,231.164474 394.311493,231.089355 395.604370,231.017975 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M187.286774,280.968781 
	C187.350861,280.372131 187.763824,279.787018 188.380249,279.024109 
	C189.074661,279.156219 189.745636,279.405212 189.497330,280.154785 
	C189.201660,281.047272 188.349976,280.909119 187.286774,280.968781 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M206.079224,237.477097 
	C206.971512,236.882416 207.901932,236.593460 208.842926,237.657562 
	C208.206863,238.337265 207.454758,238.685623 206.408813,239.334167 
	C206.114960,239.634338 206.085571,239.582153 206.055649,239.580566 
	C206.052094,239.020660 206.078445,238.462326 206.079224,237.477097 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M392.541870,231.261597 
	C392.714447,231.620117 392.838074,232.000610 392.956207,232.681274 
	C392.224335,233.225540 391.497925,233.469620 390.485718,233.750977 
	C390.118408,233.396957 390.036926,233.005646 389.979248,232.315491 
	C390.640442,231.905350 391.277802,231.794022 392.154358,231.463120 
	C392.393494,231.243546 392.492981,231.283554 392.541870,231.261597 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M184.366455,133.036072 
	C184.134369,131.931274 184.153290,130.756622 185.954361,132.099701 
	C185.595795,132.586411 185.111832,132.783325 184.366455,133.036072 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M31.616713,338.686951 
	C32.368549,337.538055 33.413284,337.957214 34.683746,338.051971 
	C33.782421,339.397369 32.791054,338.991028 31.616713,338.686951 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M23.398735,327.209167 
	C22.660839,328.242767 21.658159,328.242889 20.604300,327.545013 
	C21.313772,326.606354 22.261948,326.915009 23.398735,327.209167 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M13.523251,340.607513 
	C13.925430,340.792480 13.933652,341.007812 13.954144,341.546112 
	C12.919163,341.917725 11.871910,341.966400 10.431232,341.992920 
	C10.037808,341.970764 9.924192,341.484131 9.958328,341.236572 
	C11.038074,340.871948 12.083683,340.754913 13.523251,340.607513 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M170.696045,336.220398 
	C170.924240,337.105957 170.589966,337.619049 169.859497,337.471741 
	C169.593033,337.417969 169.430710,336.847961 169.220886,336.513489 
	C169.621216,336.354034 170.021530,336.194550 170.696045,336.220398 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M13.996011,304.005157 
	C14.964045,302.903534 16.053116,302.733032 18.065405,303.923767 
	C16.414520,303.923767 15.544262,303.923767 14.314725,303.942200 
	C13.955445,303.960663 13.985466,303.988220 13.996011,304.005157 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M127.110977,334.223816 
	C128.124771,333.877350 128.914108,333.599030 129.563477,334.258698 
	C129.645538,334.342041 129.524048,334.832031 129.401611,334.877594 
	C128.484222,335.219025 127.577774,335.305725 127.110977,334.223816 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M206.728958,302.653107 
	C206.083466,302.617004 205.628998,302.530823 205.174530,302.444641 
	C205.756348,302.497437 206.338165,302.550232 206.728958,302.653107 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M36.399673,317.962891 
	C37.361057,317.990479 37.952618,318.056885 38.544182,318.123322 
	C38.049175,319.659454 36.862438,318.755890 35.961666,318.837463 
	C35.847340,318.847809 35.595562,318.583008 35.608398,318.560547 
	C35.723232,318.359619 35.883183,318.184479 36.399673,317.962891 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M167.769104,306.090118 
	C168.011200,306.511963 167.945465,306.954926 167.870850,307.734436 
	C167.348862,307.806824 166.531769,307.649811 166.392273,307.253998 
	C166.170486,306.624695 166.831284,306.256042 167.769104,306.090118 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M186.834518,183.327332 
	C187.732437,183.811127 188.139587,184.375839 187.241791,184.802155 
	C186.903717,184.962677 186.351669,184.672546 185.897171,184.587860 
	C186.090866,184.166214 186.284546,183.744583 186.834518,183.327332 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M144.834564,233.428009 
	C145.067154,234.352478 144.875427,235.013138 144.030045,234.907547 
	C143.693817,234.865540 143.144699,234.427780 143.145691,234.171936 
	C143.148956,233.338135 143.856689,233.229568 144.834564,233.428009 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M214.660721,374.638367 
	C215.335144,374.882812 215.684525,375.185181 216.028290,375.837341 
	C215.559570,376.215820 215.096466,376.244446 214.288483,376.321625 
	C213.504562,376.446320 213.062881,376.471497 212.295135,376.356628 
	C211.972046,376.275330 212.026413,376.138733 212.012390,376.066589 
	C211.872375,375.816010 211.746399,375.637634 211.719360,375.147400 
	C212.003891,374.721191 212.189468,374.606873 212.698349,374.541290 
	C213.459656,374.625427 213.897659,374.660858 214.660721,374.638367 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M504.491455,222.114868 
	C504.795227,222.893799 505.042572,223.801010 503.823517,223.917450 
	C502.959137,224.000000 502.724670,223.523392 502.998047,222.406799 
	C503.490204,222.077988 503.854156,222.098068 504.491455,222.114868 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M240.739441,266.678345 
	C239.395020,266.704224 238.611984,266.243561 240.295135,265.034180 
	C240.642654,265.431030 240.737976,265.884491 240.739441,266.678345 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M427.306641,229.132095 
	C426.921783,228.689392 426.861176,228.195511 426.799622,227.328674 
	C428.355682,227.162994 429.692078,227.456680 427.306641,229.132095 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M174.103607,227.861664 
	C175.258469,228.163925 175.435303,228.677338 174.873672,229.276520 
	C174.391571,229.790863 173.762421,230.010666 173.227478,229.361603 
	C172.691818,228.711685 173.009628,228.222900 174.103607,227.861664 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M205.000916,262.999054 
	C204.365189,262.914276 203.649063,262.907196 203.509521,262.089172 
	C203.480133,261.916962 203.840195,261.678314 204.020813,261.470276 
	C204.324692,261.792023 204.628555,262.113739 204.965302,262.718933 
	C204.998169,263.002411 205.000000,263.000000 205.000916,262.999054 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M200.100113,173.962967 
	C199.807022,172.747025 200.243530,172.189102 201.212189,172.259430 
	C201.449921,172.276703 201.834869,172.611633 201.858521,172.832031 
	C201.969452,173.866348 201.232895,174.126801 200.100113,173.962967 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M161.214691,172.897324 
	C161.555923,172.149261 161.996841,172.100555 162.368851,172.507263 
	C162.507675,172.659042 162.509583,173.146500 162.372025,173.300247 
	C161.995102,173.721527 161.560486,173.642181 161.214691,172.897324 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M26.488962,377.243347 
	C25.810585,378.316223 24.795046,378.241180 23.721912,377.734924 
	C24.261448,376.410309 25.320993,376.982941 26.488962,377.243347 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M114.720345,377.169312 
	C114.032776,378.549530 112.951164,378.116028 111.843063,377.763336 
	C112.417236,376.489624 113.534737,376.971985 114.720345,377.169312 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M139.434967,235.266815 
	C139.125244,234.088043 139.797501,234.059616 140.447556,234.145615 
	C140.603302,234.166214 140.842621,234.782379 140.810730,234.805649 
	C140.454895,235.065369 140.053329,235.262436 139.434967,235.266815 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M412.989960,178.922607 
	C412.445679,178.805878 412.168304,178.688675 411.890961,178.571472 
	C412.609497,177.797668 413.337097,177.825333 414.072510,178.546829 
	C413.800629,178.671936 413.528778,178.797043 412.989960,178.922607 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M222.146210,236.222748 
	C222.251465,236.611206 222.042023,236.923141 221.971771,236.948578 
	C221.269104,236.577011 220.945084,236.089890 221.623505,235.213745 
	C221.890564,235.319138 221.965759,235.576706 222.146210,236.222748 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M444.864929,198.068710 
	C444.012695,197.912277 442.896515,197.991684 443.420715,197.326767 
	C444.110840,196.451385 445.608154,196.509323 446.292480,197.342117 
	C446.820312,197.984406 445.657745,197.852676 444.864929,198.068710 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M459.470490,202.031891 
	C459.177856,201.617096 459.175507,201.147079 459.101868,200.330261 
	C460.509583,200.195190 461.463562,200.599258 459.470490,202.031891 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M155.410461,374.027954 
	C155.014435,373.954681 155.011261,373.505707 155.016052,373.281250 
	C156.071487,372.906921 157.122131,372.757050 158.566559,372.677185 
	C158.982300,372.954865 159.004242,373.162445 159.019928,373.683044 
	C157.944595,374.031097 156.875549,374.066193 155.410461,374.027954 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M8.947634,215.649231 
	C9.565229,215.012436 10.416190,214.639862 11.311556,215.316620 
	C11.379213,215.367752 11.422254,215.584396 11.378539,215.630005 
	C10.711811,216.325912 9.925305,215.918594 8.947634,215.649231 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M207.956238,374.482208 
	C207.568390,374.827087 207.121140,374.898193 206.334015,374.947449 
	C206.230560,373.631165 206.572144,372.615692 207.956238,374.482208 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M19.579407,271.045410 
	C20.778778,272.331329 19.309446,271.917847 18.969826,272.183716 
	C18.462271,272.581055 18.081465,272.100159 18.253258,271.623627 
	C18.355957,271.338715 18.936871,271.226196 19.579407,271.045410 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M467.741638,199.929962 
	C467.570923,202.368423 466.226044,200.796097 464.908600,200.910248 
	C465.706909,199.790497 466.542816,199.896606 467.741638,199.929962 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M404.235779,190.364212 
	C405.103577,190.242065 405.954895,189.978516 405.837921,190.962631 
	C405.801270,191.270920 405.269684,191.696793 404.913116,191.755386 
	C404.070740,191.893753 403.902893,191.268021 404.235779,190.364212 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M217.458374,220.604492 
	C217.684525,221.407730 217.402847,221.699051 216.779678,221.577744 
	C216.650391,221.552597 216.476212,221.368408 216.456299,221.237244 
	C216.360565,220.606461 216.669373,220.344238 217.458374,220.604492 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M19.219887,220.754059 
	C18.063814,220.858444 17.117306,221.570023 16.304811,220.614563 
	C17.388420,219.649551 18.445374,219.737366 19.219887,220.754059 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M12.217735,221.964935 
	C11.153945,223.410049 9.889232,222.700897 8.623919,222.376633 
	C9.416512,222.182571 10.209106,221.988510 11.326885,221.697174 
	C11.840339,221.626511 12.028605,221.653122 12.217735,221.964935 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M3.356426,217.045273 
	C3.806427,215.511292 5.027115,215.899261 6.430323,216.060638 
	C5.776811,217.511856 4.702258,217.046753 3.356426,217.045273 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M184.270248,218.856461 
	C184.044907,217.967010 184.307755,217.452194 185.088913,217.555084 
	C185.317368,217.585175 185.650833,217.881973 185.689896,218.100540 
	C185.854507,219.021591 185.112579,218.963455 184.270248,218.856461 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M212.954010,374.329163 
	C212.854767,374.667267 212.687897,374.744537 212.265869,374.926697 
	C211.818146,375.140625 211.625565,375.249634 211.199585,375.122650 
	C211.220001,373.707520 211.500168,372.590179 212.954010,374.329163 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M136.980469,192.984314 
	C138.148422,193.048935 138.906845,193.174103 140.452805,193.429260 
	C138.552444,193.711334 137.215607,195.466537 136.980469,192.984314 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M182.471375,192.533096 
	C182.811981,193.507126 182.578918,194.080856 181.856064,194.142151 
	C181.556122,194.167587 180.964554,193.771729 180.944748,193.531281 
	C180.878845,192.731232 181.061172,191.964432 182.471375,192.533096 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M393.645996,256.984436 
	C393.941315,257.411804 393.893829,257.791046 393.774902,258.446533 
	C392.961548,258.738770 392.119751,258.843384 392.052612,257.780396 
	C391.997467,256.906555 392.743347,257.011749 393.645996,256.984436 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M388.474854,258.852600 
	C388.074860,258.483795 387.980133,258.057739 387.907349,257.304016 
	C388.518463,257.105652 389.409729,257.049438 389.628632,257.406006 
	C389.991547,257.997131 389.443695,258.547607 388.474854,258.852600 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M161.847565,162.363571 
	C161.807693,163.234421 161.540680,164.194717 160.144928,163.245636 
	C160.509705,162.792160 161.028748,162.559677 161.847565,162.363571 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M183.677155,248.033661 
	C184.140472,248.410843 184.195633,248.824310 184.269638,249.550659 
	C183.610519,250.008224 182.932541,250.152908 182.097382,250.079514 
	C182.074509,249.444168 182.208847,249.026901 182.400894,248.401031 
	C182.728745,248.151611 182.998856,248.110779 183.677155,248.033661 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M455.210358,252.335083 
	C454.668091,250.969681 455.280426,250.391998 456.651062,250.040955 
	C457.170563,250.140244 457.339935,250.280197 457.377197,250.722107 
	C456.997498,251.313293 456.749908,251.602554 456.260803,252.045441 
	C455.834747,252.310623 455.650177,252.422195 455.210358,252.335083 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M196.280502,249.546997 
	C196.184738,248.572067 196.694885,248.229584 197.796387,248.221008 
	C198.042389,249.277695 197.613342,249.901718 196.280502,249.546997 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M386.904358,248.837738 
	C386.628296,250.271622 385.987488,249.914490 385.190796,249.052750 
	C385.583191,248.144272 386.146149,248.020706 386.904358,248.837738 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M214.113342,294.297180 
	C213.683548,293.798004 213.485809,293.377838 213.288071,292.957672 
	C213.564987,292.901459 213.963181,292.701721 214.097092,292.814819 
	C214.585861,293.227661 215.169327,293.718781 214.113342,294.297180 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M385.119568,256.867493 
	C385.377075,257.405426 385.248260,257.846741 384.987885,258.608521 
	C384.462280,258.916748 384.068176,258.904480 383.379028,258.883972 
	C383.083984,258.875732 383.006714,258.987396 383.063599,258.947815 
	C383.047485,257.735077 383.323212,256.825073 385.119568,256.867493 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M194.018158,243.203613 
	C194.851578,242.184357 195.748169,241.154282 196.384354,243.470551 
	C195.605377,243.897339 194.641327,245.165894 194.018158,243.203613 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M179.018921,169.005524 
	C179.754333,169.198090 180.146713,169.370560 180.539078,169.543030 
	C179.548660,170.070755 178.556366,170.496475 177.539627,169.598419 
	C177.918381,169.394073 178.297134,169.189743 179.018921,169.005524 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M397.448547,168.644928 
	C397.685608,169.434402 397.317596,169.588150 396.797638,169.521118 
	C396.675781,169.505386 396.488708,169.344467 396.476868,169.234711 
	C396.413452,168.646347 396.746887,168.440643 397.448547,168.644928 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M37.088783,255.108353 
	C36.172009,256.347168 35.023998,256.234680 33.745277,255.626389 
	C34.339359,254.561768 35.379536,255.108429 36.486248,254.812378 
	C36.821159,254.790878 36.999447,255.002640 37.088783,255.108353 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M218.722626,244.940521 
	C218.320679,244.575089 218.173065,244.137207 218.055176,243.346222 
	C219.293045,243.184784 220.404907,243.422256 218.722626,244.940521 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M123.114815,384.135742 
	C123.135963,383.808746 123.302544,383.734650 123.741959,383.642242 
	C124.454498,383.757233 124.894203,383.890503 125.676720,384.089417 
	C125.302811,386.631439 124.225052,384.842896 123.114815,384.135742 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M385.557190,209.246124 
	C386.262146,209.084610 386.803955,209.108627 387.743958,209.226501 
	C387.254913,210.068069 386.349060,210.356934 385.557190,209.246124 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M132.824463,267.760925 
	C132.028610,268.198456 130.692673,268.209961 130.770813,267.497864 
	C130.857330,266.709442 132.040390,266.785797 132.824463,267.760925 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M22.781532,270.682617 
	C23.202328,269.964020 23.858944,269.579437 24.606712,270.237732 
	C24.684605,270.306305 24.677826,270.471069 24.710327,270.591187 
	C24.141300,270.701965 23.572273,270.812775 22.781532,270.682617 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M451.320862,252.093750 
	C450.270142,251.261353 450.881958,250.976501 451.500061,250.934647 
	C451.893555,250.908005 452.311951,251.248718 452.719177,251.424698 
	C452.363678,251.666443 452.008209,251.908188 451.320862,252.093750 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M392.157776,102.843231 
	C391.903107,102.196854 390.927246,100.979675 393.023193,101.379150 
	C392.919067,101.977852 392.634247,102.343597 392.157776,102.843231 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M37.321732,215.044647 
	C36.214260,213.999176 37.243031,214.118607 37.703148,214.020538 
	C37.952267,213.967438 38.269436,214.233566 38.555908,214.355713 
	C38.249111,214.591980 37.942310,214.828262 37.321732,215.044647 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M133.038086,267.963928 
	C133.889359,267.985626 134.672836,268.085693 135.602966,268.204498 
	C134.792297,269.255402 134.033142,268.955383 133.056580,268.426025 
	C132.839905,268.203278 132.970306,268.042267 133.038086,267.963928 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M454.968567,252.421951 
	C455.133301,252.132050 455.311493,252.127686 455.754486,252.161194 
	C455.810425,252.822021 456.428894,253.754044 455.329956,254.044556 
	C455.213989,253.598862 455.097992,253.153168 454.968567,252.421951 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M17.343948,246.995697 
	C17.480534,246.308548 18.126707,245.968674 18.957787,246.139130 
	C19.148277,246.178192 19.279989,246.503830 19.438749,246.697586 
	C18.843634,246.786102 18.248518,246.874634 17.343948,246.995697 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M35.998291,228.999496 
	C35.547485,230.151871 34.611713,230.128906 33.650890,229.930206 
	C33.534927,229.906235 33.500668,229.487183 33.428535,229.251251 
	C34.027740,229.098862 34.626949,228.946487 35.576469,228.851959 
	C35.926788,228.909805 35.974483,228.969574 35.998291,228.999496 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M122.801758,403.090454 
	C123.091530,403.503906 123.092903,403.902802 123.053909,404.597839 
	C122.539719,405.973480 122.218063,405.550568 121.957184,404.553986 
	C121.971878,404.119385 121.960571,403.915131 121.942780,403.404449 
	C122.128662,403.090668 122.321022,403.083282 122.801758,403.090454 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M450.310852,243.138062 
	C450.805695,242.361771 451.305084,242.795853 451.277954,243.203354 
	C451.228241,243.950272 450.724609,243.675156 450.310852,243.138062 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M144.386200,261.997986 
	C145.751526,263.363373 144.400757,263.215973 143.848602,263.368042 
	C143.613724,263.432739 143.220612,262.922821 142.899414,262.674072 
	C143.271927,262.427704 143.644440,262.181335 144.386200,261.997986 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M11.793153,221.762939 
	C12.661846,220.953293 13.675338,220.516479 14.714800,221.545654 
	C14.106304,221.746078 13.497808,221.946503 12.553956,222.198532 
	C12.218599,222.250137 11.934235,221.925980 11.793153,221.762939 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M9.123051,268.026367 
	C7.882899,267.087463 8.821208,267.001099 9.318094,266.987244 
	C9.720746,266.976105 10.686091,266.661011 10.341495,267.735870 
	C10.283205,267.917694 9.774442,267.955139 9.123051,268.026367 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M23.306404,219.300125 
	C22.971449,220.111969 22.036125,220.284790 21.869011,219.670013 
	C21.610262,218.718155 22.570892,219.045929 23.306404,219.300125 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M471.000214,218.326263 
	C471.164948,218.015442 471.335602,217.999237 471.758118,218.035187 
	C471.795105,218.731094 472.437500,219.676361 471.334473,220.007675 
	C471.225037,219.545410 471.115570,219.083160 471.000214,218.326263 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M170.761658,251.045105 
	C171.017288,251.061600 171.067139,251.445877 171.062027,251.639542 
	C170.434189,251.725296 169.811462,251.617401 169.188736,251.509506 
	C169.627838,251.349197 170.066940,251.188889 170.761658,251.045105 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M387.628845,224.871948 
	C388.005127,225.138916 388.016510,225.417725 388.003052,226.115601 
	C387.123840,226.254257 385.581940,226.038666 385.548218,225.680893 
	C385.459015,224.734787 386.602356,225.050232 387.628845,224.871948 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M498.880646,181.856781 
	C499.532532,181.023682 500.477600,180.339478 501.181091,181.460144 
	C501.474701,181.927887 500.339081,182.063614 499.442688,182.144714 
	C499.135010,182.152863 498.965149,181.955719 498.880646,181.856781 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M191.080139,285.102112 
	C191.086411,284.817596 191.536346,284.907196 191.762756,284.943359 
	C192.053986,285.514038 192.796509,286.226868 192.047424,286.528992 
	C191.324615,286.820618 191.161163,285.990875 191.080139,285.102112 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M258.815002,148.878662 
	C258.961121,148.321762 259.178955,147.808090 259.396790,147.294403 
	C259.765045,147.503769 260.309540,147.625381 260.466248,147.940079 
	C260.834045,148.678711 260.321198,148.997559 259.322449,149.066971 
	C259.008545,149.036942 258.886749,148.921921 258.815002,148.878662 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M419.338318,178.928711 
	C418.469940,178.352615 419.002319,178.118820 419.385437,178.103577 
	C419.697784,178.091171 420.023315,178.409821 420.342987,178.581696 
	C420.092285,178.711594 419.841583,178.841507 419.338318,178.928711 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M34.947716,416.208740 
	C35.753319,416.030609 36.502663,416.058685 37.622322,416.147247 
	C37.287567,416.968140 36.378494,417.008606 35.085838,416.872498 
	C34.735413,416.812958 34.891457,416.414948 34.947716,416.208740 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M499.162415,185.236542 
	C499.676392,185.221329 500.861023,184.616867 500.943909,185.555511 
	C500.990051,186.077835 499.889801,185.825500 499.162415,185.236542 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M400.761536,160.113388 
	C401.256470,160.582626 401.545227,160.990250 401.891907,161.642838 
	C401.488647,161.972534 401.027466,162.057251 400.213196,162.098145 
	C399.880188,161.615448 399.900269,161.176575 400.023285,160.412262 
	C400.126251,160.086838 400.555298,160.051773 400.761536,160.113388 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M387.753174,275.631897 
	C388.639984,275.702911 389.823456,275.694458 389.287170,276.744446 
	C388.876343,277.548798 387.914948,277.163055 387.123199,276.322937 
	C387.177490,275.929718 387.349060,275.857910 387.753174,275.631897 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M186.018097,277.103180 
	C185.704041,278.035278 184.689041,277.980530 183.362076,278.030212 
	C183.660461,277.048767 184.629440,276.987549 186.018097,277.103180 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M400.716431,169.749207 
	C399.212738,169.372314 399.690186,168.203979 400.215240,168.082703 
	C401.398285,167.809387 400.910004,168.986969 400.716431,169.749207 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M139.242691,285.206146 
	C139.040329,284.480499 138.986664,284.025360 139.024002,283.577789 
	C139.029190,283.515625 139.640991,283.377808 139.704742,283.466675 
	C140.231567,284.201202 139.956924,284.868378 139.242691,285.206146 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M434.692871,167.866699 
	C435.786255,168.921738 434.855957,168.903671 434.337311,168.983719 
	C434.086517,169.022400 433.786041,168.739273 433.508087,168.601852 
	C433.801178,168.330063 434.094269,168.058273 434.692871,167.866699 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M408.950104,176.307312 
	C409.509979,176.281204 409.902771,176.402466 410.295593,176.523743 
	C410.184631,176.622864 410.052856,176.821991 409.966278,176.803986 
	C409.565002,176.720566 409.176270,176.576828 408.950104,176.307312 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M31.967278,200.944855 
	C31.755964,202.097122 30.773148,202.003922 29.760128,202.450912 
	C29.366055,202.441086 29.256382,202.314957 28.986197,201.995789 
	C29.248768,200.857452 30.224091,200.917679 31.301834,200.530151 
	C31.606302,200.450272 31.844759,200.781601 31.967278,200.944855 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M173.944153,272.033508 
	C173.669662,272.418823 173.138626,272.695618 172.296982,272.933380 
	C172.059280,271.704010 172.579300,271.298279 173.944153,272.033508 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M28.864323,294.004578 
	C30.006590,295.509094 28.635414,294.803711 28.215918,294.948883 
	C28.033426,295.012054 27.722542,294.704163 27.469969,294.564789 
	C27.826406,294.367249 28.182840,294.169678 28.864323,294.004578 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M429.997620,132.997406 
	C429.762329,133.537216 429.529633,134.079803 429.296936,134.622391 
	C429.081177,134.511520 428.865417,134.400650 428.649658,134.289780 
	C428.930634,133.919098 429.211578,133.548416 429.750122,133.091843 
	C430.007751,133.005951 430.000214,133.000183 429.997620,132.997406 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M466.560394,133.910187 
	C466.027618,133.833923 465.514465,133.629410 465.522369,133.606689 
	C465.791962,132.833908 466.373901,133.071671 466.910065,133.238525 
	C467.018585,133.272293 467.174469,133.479233 467.149231,133.547256 
	C467.101349,133.676331 466.938232,133.762634 466.560394,133.910187 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M506.582947,207.226837 
	C506.870270,207.765244 506.949707,208.508316 506.958801,209.621277 
	C505.984009,209.284988 505.863281,208.421661 506.582947,207.226837 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M213.312775,290.062561 
	C213.282440,289.530609 213.407028,289.153320 213.531601,288.776031 
	C213.634842,288.879272 213.841125,289.005676 213.823975,289.081818 
	C213.737122,289.467438 213.592239,289.840027 213.312775,290.062561 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M698.596802,89.670494 
	C698.700317,90.459061 698.332947,91.004166 697.214966,90.330574 
	C697.450684,89.970253 697.860291,89.823929 698.596802,89.670494 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M114.112228,384.928345 
	C114.331383,384.650085 114.846878,384.384888 115.661316,384.178986 
	C115.443031,384.472687 114.925797,384.707062 114.112228,384.928345 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M118.135101,384.161499 
	C118.008995,383.843262 118.025093,383.675903 117.997490,383.260071 
	C118.401604,383.360657 119.571480,383.530029 118.135101,384.161499 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M117.411896,328.677551 
	C116.788643,328.834595 116.221954,328.941071 116.486259,328.236816 
	C116.506401,328.183136 117.230347,328.393585 117.411896,328.677551 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M128.248505,404.976898 
	C128.442749,404.709747 128.916565,404.437531 129.677826,404.206726 
	C129.486206,404.489380 129.007141,404.730591 128.248505,404.976898 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M212.132492,376.446381 
	C212.415146,376.245392 212.858231,376.215454 213.622467,376.277832 
	C213.461487,376.907104 212.919876,377.047058 212.132492,376.446381 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M466.981445,223.722916 
	C466.850525,224.087204 466.699097,224.201370 466.277496,224.226639 
	C466.138916,223.679749 466.270477,223.221741 466.402069,222.763733 
	C466.588348,223.000076 466.774628,223.236435 466.981445,223.722916 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M473.989777,221.257538 
	C474.094116,221.416382 474.042664,221.576324 473.991180,221.736282 
	C473.938751,221.577072 473.886353,221.417862 473.989777,221.257538 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M166.209579,266.791656 
	C165.592972,267.005646 165.224792,266.943237 165.460632,266.384949 
	C165.479828,266.339569 166.066025,266.533722 166.209579,266.791656 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M447.349396,149.052185 
	C447.139008,148.860153 447.194061,148.660904 447.263428,148.151932 
	C447.650024,148.002884 448.022278,148.163574 448.394531,148.324280 
	C448.134644,148.564514 447.874725,148.804749 447.349396,149.052185 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M34.455395,215.675537 
	C34.078960,215.713516 33.852306,215.610260 33.625656,215.506989 
	C33.963566,215.107086 34.290588,215.097717 34.455395,215.675537 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M222.315048,293.721863 
	C221.660873,293.898712 221.005219,293.922577 221.384720,293.283203 
	C221.653275,292.830750 222.225739,293.070129 222.315048,293.721863 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M180.675934,219.199249 
	C180.556473,219.929535 180.007919,220.086670 179.762268,219.627548 
	C179.430634,219.007675 180.084351,219.016953 180.675934,219.199249 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M26.548599,218.291412 
	C26.343620,218.572937 25.627058,218.730713 25.611654,218.679123 
	C25.401106,217.973953 25.975595,218.123383 26.548599,218.291412 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M387.752014,260.989929 
	C387.587555,261.098053 387.421692,261.044891 387.255829,260.991760 
	C387.420776,260.937378 387.585693,260.882996 387.752014,260.989929 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M427.277161,232.909714 
	C427.045471,232.324371 427.206451,231.608063 427.696655,230.692902 
	C428.378784,231.329132 428.310730,232.098587 427.277161,232.909714 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M452.244202,210.813538 
	C451.476105,210.623611 451.464844,210.414093 451.978973,210.206360 
	C452.124512,210.147552 452.322174,210.111450 452.461060,210.161591 
	C452.952301,210.338959 452.955200,210.580795 452.244202,210.813538 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M147.591492,306.167999 
	C147.843918,306.419403 147.905838,306.854645 148.011383,307.618530 
	C147.201584,307.675903 146.984955,307.143524 147.591492,306.167999 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M58.176849,170.166718 
	C57.991737,169.472977 57.861786,168.839417 58.577408,168.530594 
	C58.724018,168.908981 58.870632,169.287354 58.905487,169.968781 
	C58.793724,170.271835 58.362301,170.276932 58.176849,170.166718 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M203.938263,274.217377 
	C204.271698,274.138275 204.613937,274.294495 205.063095,274.734436 
	C204.402176,275.608673 204.096039,275.200623 203.938263,274.217377 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M21.362892,173.060089 
	C21.007919,172.469833 21.005404,171.934357 21.694769,171.733124 
	C21.739450,171.720093 21.929214,172.204132 22.031170,172.726318 
	C22.010855,172.995712 21.580944,173.074265 21.362892,173.060089 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M196.991608,277.390442 
	C197.154144,277.016907 197.323486,276.964325 197.751678,276.973419 
	C197.836441,277.582031 197.662369,278.128937 197.241394,278.835815 
	C196.995789,278.567688 196.997101,278.139587 196.991608,277.390442 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M32.670708,280.976105 
	C32.958096,280.912048 33.005341,281.317169 33.017479,281.520386 
	C32.515133,281.693787 31.874557,282.253174 31.567240,281.403778 
	C31.559950,281.383606 32.099060,281.165802 32.670708,280.976105 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M111.989975,164.718109 
	C111.542786,164.849258 111.151291,164.768341 110.759804,164.687424 
	C110.988297,164.474518 111.216797,164.261627 111.703407,164.062195 
	C111.961525,164.075653 112.045662,164.506027 111.989975,164.718109 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M498.904114,184.769501 
	C498.560516,184.878418 498.121033,184.756821 497.681549,184.635239 
	C498.003784,183.979156 498.399139,184.178864 498.904114,184.769501 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M31.976086,209.917633 
	C31.535480,209.690887 31.305910,209.327042 31.375736,209.255539 
	C31.730242,208.892487 32.199818,208.666092 32.579182,209.197861 
	C32.663704,209.316330 32.418556,209.669983 31.976086,209.917633 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M187.519836,289.029968 
	C187.253662,288.873474 187.228394,288.691589 187.113022,288.249481 
	C187.467224,288.113647 187.911545,288.238068 188.355865,288.362488 
	C188.157501,288.576538 187.959122,288.790558 187.519836,289.029968 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M388.681915,201.057068 
	C389.012482,201.089417 388.969574,201.513763 388.985565,201.726273 
	C388.427917,201.827271 387.854248,201.715744 387.280609,201.604218 
	C387.637512,201.411072 387.994446,201.217896 388.681915,201.057068 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M41.983761,253.976593 
	C42.283115,253.271774 42.916817,252.785950 43.440666,253.371979 
	C43.926506,253.915482 43.077877,253.949905 42.451324,254.163452 
	C42.166859,254.194351 42.044724,254.049240 41.983761,253.976593 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M164.964828,259.856659 
	C165.309067,259.166412 165.723801,259.159332 165.960236,259.635406 
	C166.048340,259.812775 165.844070,260.195618 165.674271,260.404388 
	C165.622650,260.467834 165.240341,260.262268 164.964828,259.856659 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M179.272339,254.397766 
	C179.149063,254.553162 178.936478,254.575333 178.723907,254.597504 
	C178.876953,254.486511 179.029999,254.375519 179.272339,254.397766 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M376.320679,259.000763 
	C375.929901,258.833160 375.872559,258.668121 375.894165,258.253235 
	C376.534943,258.169922 377.096771,258.336456 377.833374,258.745483 
	C378.008087,258.987946 377.999207,259.000824 377.993164,259.007080 
	C377.542755,259.009979 377.098389,259.006653 376.320679,259.000763 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M447.033813,259.903992 
	C446.770386,259.464691 446.798767,259.063110 446.830688,258.358887 
	C447.191193,258.493744 447.548126,258.931213 447.909271,259.669250 
	C447.717529,259.960449 447.521606,259.951080 447.033813,259.903992 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M15.000461,248.008423 
	C15.485474,247.723602 15.959999,247.423218 16.734509,247.075531 
	C17.034494,247.028214 17.010319,247.008362 17.002968,246.995789 
	C16.515114,247.282227 16.034607,247.581238 15.257544,247.924072 
	C14.960985,247.967896 14.989974,247.992889 15.000461,248.008423 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M42.529282,248.702057 
	C41.906898,248.737717 41.545555,248.555450 41.184212,248.373169 
	C41.763069,247.780792 42.291012,247.925278 42.529282,248.702057 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M457.526184,251.025726 
	C457.215027,250.850891 457.184937,250.677734 457.078064,250.252441 
	C457.560059,250.158249 458.118896,250.316223 458.857727,250.709412 
	C459.037750,250.944626 458.987000,251.010315 458.958496,251.041916 
	C458.555725,251.058151 458.181488,251.042786 457.526184,251.025726 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M4.078912,256.091797 
	C3.767355,256.746704 3.141722,257.153290 2.633957,256.643982 
	C2.133791,256.142334 2.894226,256.032349 3.469239,255.752029 
	C3.730492,255.677460 3.961248,255.954987 4.078912,256.091797 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M195.105606,277.292664 
	C195.170532,277.105743 195.334412,277.058563 195.749176,277.061462 
	C195.734909,277.218506 195.469727,277.325439 195.105606,277.292664 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M474.052307,183.424072 
	C474.018005,183.600250 473.804321,183.702850 473.236267,183.832153 
	C473.212219,183.689407 473.542603,183.519958 474.052307,183.424072 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M193.513519,277.036865 
	C193.399567,276.732605 193.238647,276.172211 193.914642,276.827301 
	C193.957825,277.004852 193.662186,277.036530 193.513519,277.036865 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M458.953308,205.940308 
	C459.062683,205.858109 459.259308,205.040359 459.236938,205.999466 
	C459.103699,206.086746 459.000580,205.991959 458.953308,205.940308 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M393.578186,208.529388 
	C393.503693,208.566757 393.652710,208.492004 393.578186,208.529388 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M465.006866,255.282227 
	C465.345001,255.197296 465.843353,255.306030 465.223785,255.970352 
	C465.037109,255.901230 465.026611,255.724472 465.006866,255.282227 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M440.705872,197.673157 
	C440.420929,197.710587 440.312195,197.605957 440.203461,197.501343 
	C440.429688,197.511261 440.655884,197.521164 440.705872,197.673157 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M400.471893,252.455231 
	C400.523163,252.425842 400.420624,252.484604 400.471893,252.455231 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M216.743607,235.579498 
	C216.580841,235.790634 216.191330,235.828308 215.602905,235.643005 
	C215.774948,235.415375 216.145905,235.410690 216.743607,235.579498 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M201.548004,259.472107 
	C201.577621,259.522797 201.518402,259.421448 201.548004,259.472107 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M120.076431,384.282928 
	C120.145554,384.141479 120.314217,384.137146 120.734985,384.154480 
	C120.716728,384.257446 120.446350,384.338745 120.076431,384.282928 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M430.922852,244.754745 
	C430.851746,244.949387 430.683289,244.995895 430.261292,244.975891 
	C430.280334,244.808472 430.552948,244.707535 430.922852,244.754745 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M128.083939,384.138489 
	C128.158905,383.935303 128.327484,383.899719 128.751892,383.901123 
	C128.730988,384.060791 128.454254,384.183472 128.083939,384.138489 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M119.151581,404.843506 
	C119.155685,404.644196 119.382019,404.399719 119.861649,404.225250 
	C119.913704,404.530396 119.666664,404.698090 119.151581,404.843506 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M387.291016,243.880096 
	C387.169312,243.541626 387.344879,243.326767 387.788696,243.085663 
	C388.019684,243.162811 388.058502,243.328384 388.033142,243.740860 
	C387.968964,243.987747 387.512177,243.941574 387.291016,243.880096 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M423.001648,242.998779 
	C423.120483,243.136917 423.237671,243.276291 423.354858,243.415649 
	C423.271973,243.367401 423.189117,243.319153 423.051880,243.137024 
	C422.997498,243.003159 423.000000,243.000000 423.001648,242.998779 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M143.145264,404.374695 
	C143.185486,404.183990 143.338440,404.114960 143.742645,404.060944 
	C143.864380,404.464142 143.619080,404.604279 143.145264,404.374695 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M157.870163,385.611938 
	C157.975006,385.732941 157.501617,385.858398 157.257675,385.837128 
	C157.178360,385.460815 157.428894,385.352509 157.870163,385.611938 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M196.792389,376.173096 
	C197.027374,376.160309 197.027237,376.518005 197.027832,376.696594 
	C196.665359,376.786224 195.888519,376.979980 196.792389,376.173096 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M430.527863,231.545868 
	C430.476349,231.575516 430.579376,231.516205 430.527863,231.545868 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M153.898621,385.801544 
	C153.836731,386.022430 153.673248,386.086945 153.250809,386.101868 
	C153.260254,385.916565 153.528656,385.780853 153.898621,385.801544 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M194.312805,246.204819 
	C194.283264,246.432831 193.953903,246.655655 193.321167,246.844635 
	C193.349518,246.607071 193.681259,246.403351 194.312805,246.204819 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M452.690430,232.380249 
	C452.726410,232.605469 452.613678,232.756149 452.511383,232.749390 
	C452.409637,232.742630 452.318329,232.577744 452.222473,232.482208 
	C452.330414,232.400360 452.438324,232.318527 452.690430,232.380249 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M405.913025,237.887695 
	C405.975006,238.056641 405.481995,238.016861 405.249237,237.933212 
	C405.294678,237.805954 405.572845,237.762344 405.913025,237.887695 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M44.318619,265.419556 
	C44.426266,265.344543 44.495609,265.612701 44.495609,265.612701 
	C44.495609,265.612701 44.210968,265.494537 44.318619,265.419556 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M194.869492,238.724060 
	C194.839935,238.966095 194.687561,239.065826 194.262161,239.152893 
	C194.241653,238.954071 194.494156,238.767914 194.869492,238.724060 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M169.963013,380.873169 
	C169.889740,380.584167 170.133240,380.373749 170.703751,380.300720 
	C170.755646,380.598907 170.505310,380.770142 169.963013,380.873169 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M219.679413,217.110321 
	C219.879700,217.169189 219.941528,217.330017 219.948181,217.743362 
	C219.775650,217.734665 219.658295,217.473465 219.679413,217.110321 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M3.084636,217.097046 
	C2.977342,217.338379 2.794377,217.500809 2.611414,217.663254 
	C2.581242,217.463211 2.551068,217.263168 2.685893,216.965118 
	C2.850891,216.867111 3.008964,217.018158 3.084636,217.097046 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M132.820541,388.436768 
	C132.929291,388.525665 132.495880,388.706085 132.261841,388.688049 
	C132.180984,388.380035 132.408981,388.272644 132.820541,388.436768 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M195.531021,373.546570 
	C195.479126,373.576691 195.582916,373.516418 195.531021,373.546570 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M13.761587,214.061218 
	C13.991497,214.001953 13.970288,214.473679 14.009611,214.706421 
	C13.620378,214.828094 12.972382,214.855698 13.761587,214.061218 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M125.612442,410.018158 
	C125.811295,410.583069 125.451645,410.751129 124.752243,410.350952 
	C124.831032,410.119690 125.053200,410.081848 125.612442,410.018158 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M428.580139,245.950623 
	C428.771057,246.237305 428.669159,246.538376 428.331177,246.941727 
	C428.068115,246.849670 428.041138,246.655334 427.857605,246.208939 
	C427.896484,245.959595 428.091919,245.962311 428.580139,245.950623 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M197.553253,265.465485 
	C197.586639,265.520874 197.519882,265.410095 197.553253,265.465485 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M468.011230,246.247955 
	C468.121307,246.269958 468.230835,246.544098 468.180054,246.911224 
	C468.016724,246.836182 468.013672,246.668137 468.011230,246.247955 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M210.967316,375.189575 
	C211.140045,374.912170 211.313934,374.937744 211.749298,374.997437 
	C212.010742,375.031586 211.975037,375.512695 211.986694,375.753540 
	C211.655060,375.827118 211.311752,375.659790 210.967316,375.189575 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M220.446686,246.531281 
	C220.413406,246.477097 220.479950,246.585449 220.446686,246.531281 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M381.840179,267.306610 
	C381.655182,266.876617 381.862854,266.702240 382.366180,266.243317 
	C382.661865,265.958771 382.639893,265.970581 382.653076,265.975708 
	C382.976562,266.632629 382.827911,267.158600 381.840179,267.306610 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M473.841553,223.539062 
	C473.955933,223.650009 473.508240,223.860382 473.261108,223.851105 
	C473.138916,223.475525 473.376648,223.337616 473.841553,223.539062 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M192.751038,311.047852 
	C193.002319,311.000183 192.995270,311.475159 193.002472,311.712524 
	C192.571060,311.825409 191.928162,311.822876 192.751038,311.047852 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M394.798706,101.237183 
	C394.558411,101.004387 394.513397,100.751122 394.468414,100.497864 
	C394.613831,100.484970 394.759216,100.472069 395.010040,100.651199 
	C395.115448,100.843231 394.994019,101.216728 394.798706,101.237183 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M204.170593,310.870697 
	C203.936279,310.901184 203.981400,310.479828 203.971024,310.268402 
	C204.213181,310.201263 204.465729,310.345551 204.718277,310.489807 
	C204.613815,310.606598 204.509369,310.723419 204.170593,310.870697 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M500.876221,93.129425 
	C501.215759,93.006287 501.584290,93.222237 501.973389,93.783340 
	C501.631012,93.908493 501.268127,93.688499 500.876221,93.129425 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M147.797180,338.367126 
	C147.833817,338.684296 147.590363,338.828400 147.084030,338.906250 
	C147.099976,338.703796 147.331940,338.488434 147.797180,338.367126 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M221.458527,134.423523 
	C221.522873,134.381851 221.394196,134.465195 221.458527,134.423523 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M21.255207,308.677002 
	C21.205606,308.420715 21.321400,308.242157 21.433130,308.244690 
	C21.544348,308.247192 21.651489,308.431458 21.760418,308.536011 
	C21.646551,308.635376 21.532686,308.734741 21.255207,308.677002 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M528.996338,107.995224 
	C528.900024,108.567970 528.716553,108.967705 528.043945,108.219986 
	C528.020325,107.974121 527.991516,108.006126 527.976318,108.021263 
	C528.133667,107.925591 528.306152,107.814781 528.745422,107.856964 
	C529.012207,108.009941 529.001709,108.001328 528.996338,107.995224 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M530.835693,116.092583 
	C530.994385,116.178314 530.998535,116.346924 530.939575,116.760315 
	C530.747742,116.824913 530.598511,116.654648 530.503967,116.458069 
	C530.478271,116.404610 530.617615,116.271835 530.835693,116.092583 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M72.105751,313.251709 
	C72.332886,313.180298 72.487007,313.338348 72.588654,313.524994 
	C72.617508,313.578003 72.493431,313.714264 72.295097,313.900391 
	C72.104744,313.822968 72.058784,313.657501 72.105751,313.251709 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M391.791748,104.686584 
	C391.579529,104.783165 391.342346,104.537704 390.961731,104.070473 
	C390.818329,103.848694 391.173187,103.607536 391.384644,103.643860 
	C391.652954,103.901634 391.709839,104.123085 391.791748,104.686584 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M29.334103,165.933014 
	C29.147417,165.880356 29.083277,165.705872 29.071117,165.257431 
	C29.234282,165.259399 29.345465,165.535309 29.334103,165.933014 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M217.003448,286.004456 
	C216.910126,286.040497 216.813324,286.072052 216.853821,286.048370 
	C216.991104,285.993103 217.000000,286.000000 217.003448,286.004456 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M473.200012,159.567566 
	C473.128296,159.711838 472.846863,159.770493 472.134003,159.805252 
	C472.131805,159.681564 472.561066,159.581757 473.200012,159.567566 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M194.884033,288.113892 
	C194.919983,288.326202 194.728912,288.613312 194.276276,288.887512 
	C194.151031,288.573151 194.365128,288.344482 194.884033,288.113892 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M416.542969,178.552612 
	C416.477661,178.591293 416.608276,178.513947 416.542969,178.552612 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M197.002274,279.003052 
	C196.912994,279.039581 196.821426,279.073029 196.862183,279.051147 
	C196.994476,278.995819 197.000000,279.000000 197.002274,279.003052 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M88.063820,181.250153 
	C88.061256,181.473999 87.777786,181.686188 87.224701,181.923828 
	C87.231033,181.712341 87.506973,181.475403 88.063820,181.250153 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M26.244167,364.877258 
	C25.984581,364.908752 26.007334,364.464203 26.002346,364.241699 
	C26.399837,364.151550 27.147009,364.072693 26.244167,364.877258 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M63.753868,174.349823 
	C63.795391,174.583435 63.693134,174.745377 63.595688,174.742523 
	C63.498684,174.739685 63.406517,174.571411 63.312225,174.475677 
	C63.412216,174.385773 63.512203,174.295868 63.753868,174.349823 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M61.028744,173.024521 
	C60.931324,172.883621 60.678493,174.087311 60.903843,173.027267 
	C61.080280,173.089523 61.044846,173.047028 61.028744,173.024521 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M439.814575,172.084106 
	C440.084015,172.084946 439.960083,172.568054 439.929138,172.815491 
	C439.302917,172.908478 438.904785,172.682983 439.814575,172.084106 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M32.885353,419.529114 
	C32.825890,419.713501 32.664856,419.773132 32.254536,419.767761 
	C32.183247,419.360107 32.442760,419.260620 32.885353,419.529114 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M39.902832,419.573425 
	C39.830303,419.757294 39.664196,419.805908 39.252335,419.770660 
	C39.204540,419.341217 39.472099,419.258331 39.902832,419.573425 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M156.574875,304.452515 
	C156.621918,304.523315 156.433151,304.546234 156.433151,304.546234 
	C156.433151,304.546234 156.527832,304.381744 156.574875,304.452515 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M211.497650,291.496704 
	C211.509567,291.515625 211.485748,291.477753 211.497650,291.496704 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M31.332329,293.573364 
	C31.228689,293.459656 31.582264,293.394287 31.582264,293.394287 
	C31.582264,293.394287 31.435968,293.687103 31.332329,293.573364 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M218.375717,293.350708 
	C218.613235,293.328400 218.699051,293.422852 218.784866,293.517273 
	C218.597916,293.500671 218.410950,293.484070 218.375717,293.350708 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M32.348656,344.401093 
	C32.458691,344.333527 32.533875,344.580994 32.533875,344.580994 
	C32.533875,344.580994 32.238625,344.468658 32.348656,344.401093 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M426.878815,58.568199 
	C426.019440,66.831596 426.021790,66.852043 417.964417,67.778893 
	C414.164948,68.215942 410.359955,68.630966 406.546875,68.913338 
	C404.396240,69.072601 402.224121,68.942047 399.958832,68.942047 
	C400.528931,66.770149 402.702179,67.496742 403.906372,66.597618 
	C404.678864,66.020836 405.891815,65.692558 405.593872,64.436066 
	C405.336029,63.348721 404.303467,62.838593 403.282776,62.879890 
	C399.202972,63.044956 395.635284,62.432468 394.341736,57.771107 
	C390.269745,58.710144 387.935120,51.250408 383.185974,55.463379 
	C382.638519,55.949062 382.118225,56.150208 381.550781,55.455341 
	C377.576141,50.588017 374.097656,53.941910 371.459991,56.690628 
	C368.219421,60.067657 365.558289,61.380322 361.122009,58.690979 
	C355.576355,55.329102 349.009033,57.245956 344.771820,62.326851 
	C344.101776,63.130306 345.311493,65.282394 343.309631,64.663048 
	C342.248138,64.334625 340.966797,63.641697 340.919708,61.887375 
	C340.783875,56.829288 337.980347,58.503155 335.877991,60.295193 
	C334.494293,61.474663 333.747192,62.856487 332.017303,60.910236 
	C331.296478,60.099251 329.851990,59.787338 329.366089,60.679668 
	C326.504242,65.935425 321.554077,63.495991 318.293518,62.697052 
	C313.401062,61.498260 310.610596,63.960670 309.452820,66.966026 
	C307.749359,71.388046 305.635925,69.492531 304.072479,67.980423 
	C302.374115,66.337814 301.628052,63.418251 298.765045,63.449894 
	C295.080383,63.490616 291.682220,65.293335 289.165894,67.626991 
	C286.347382,70.240852 284.955475,70.977974 281.868500,67.764519 
	C278.709656,64.476212 273.417450,66.636520 270.901093,70.785713 
	C269.492706,73.107994 269.111755,76.934807 264.449188,76.335236 
	C262.089905,76.031845 261.463806,79.326477 260.075745,81.471626 
	C258.258759,79.806770 258.935486,77.288948 257.181183,75.759079 
	C251.545547,70.844292 244.762787,71.909775 240.951019,79.006012 
	C239.589401,81.540924 239.080612,81.433884 236.342285,80.578209 
	C231.641830,79.109413 227.670868,81.945038 224.268600,85.784233 
	C220.563385,83.961052 216.932907,82.072891 217.627487,76.904869 
	C218.536926,76.296989 219.226501,76.188599 220.287506,76.378273 
	C221.527512,76.961861 222.367218,77.905861 223.759308,76.690956 
	C226.821167,75.045700 229.331070,73.212090 231.767273,70.743591 
	C232.102234,70.308662 232.245514,70.143013 232.630371,69.758301 
	C233.738419,68.940147 234.683777,68.425957 235.348877,67.139496 
	C235.682007,66.702263 235.829468,66.535835 236.228851,66.146088 
	C238.528900,64.664688 240.587997,60.323917 242.613068,65.951965 
	C242.821106,66.530144 242.914825,66.510887 242.893005,65.944977 
	C242.881165,65.638161 243.135864,65.314026 243.115372,65.000671 
	C242.938904,62.304016 237.106827,62.329090 239.821823,58.176399 
	C239.969406,57.950668 239.576065,58.021332 239.181427,58.137211 
	C234.261429,59.581856 233.131622,55.621613 231.259842,52.244503 
	C230.669266,49.752750 231.236160,48.001450 233.117798,46.729424 
	C233.802078,46.266823 234.569672,45.827103 235.040726,45.175137 
	C237.360916,41.963898 239.672180,39.042435 244.307724,39.057961 
	C245.625839,39.062374 247.059814,37.830257 248.340118,39.101341 
	C249.821045,40.571594 250.116898,42.240974 248.418808,43.922821 
	C251.711060,41.403625 255.946930,42.244194 259.541168,40.536469 
	C261.375610,39.664871 261.986847,42.264618 261.289276,44.407383 
	C263.011292,42.561756 264.173004,40.676945 266.848511,40.241722 
	C267.430145,40.324837 267.657135,40.392651 268.186462,40.647041 
	C269.341492,41.616749 269.992401,42.576679 270.745758,43.446041 
	C272.530945,45.506165 273.925781,46.165176 275.171509,42.903736 
	C275.743073,41.407280 276.861633,40.007748 278.249390,39.105991 
	C280.344666,37.744545 282.161133,37.719120 282.634186,40.881695 
	C284.398926,39.035133 281.596191,37.520454 282.491882,35.765392 
	C283.704254,33.389748 285.739716,35.182140 287.725159,34.614197 
	C286.693085,32.855305 284.868958,32.575958 283.188873,31.530727 
	C282.642517,30.930822 282.484070,30.505634 282.527405,29.706047 
	C283.014893,28.551220 283.751648,28.169786 284.846497,27.824230 
	C285.240875,27.623646 285.387604,27.541237 285.282837,27.548937 
	C284.444092,27.780336 283.881897,27.694691 283.081238,27.255123 
	C282.392456,26.501837 282.247650,25.866148 282.653534,24.587982 
	C285.775970,23.731585 288.458405,22.651318 290.932587,21.727304 
	C294.131012,20.532835 294.470093,22.464239 295.910767,23.662470 
	C294.433319,25.572533 292.726135,23.117344 291.382477,24.983856 
	C292.994141,26.280598 293.647583,28.697025 296.638550,28.990074 
	C297.750244,29.838997 298.505463,30.634993 299.818634,29.187931 
	C300.698853,28.315115 301.473846,28.015266 302.685394,28.169968 
	C303.366852,28.358997 303.500153,28.866095 303.946045,28.877863 
	C304.059479,28.880857 304.112183,28.756287 304.100403,28.646553 
	C304.029297,27.983688 304.311676,28.714451 303.497681,28.384865 
	C303.214539,27.486954 303.307831,26.887905 303.905396,26.103569 
	C304.665771,25.446405 305.261566,25.245863 306.219910,25.441864 
	C306.867188,25.871225 307.198425,26.229391 307.637817,26.484653 
	C307.419342,26.439669 307.222260,26.315992 306.905212,25.900730 
	C305.984558,24.702314 305.202332,24.656469 304.146698,25.845783 
	C302.891724,27.348850 301.228302,27.744835 299.854492,29.123070 
	C298.936493,29.749376 298.254974,29.752863 297.279053,29.227968 
	C295.661163,26.109596 300.847961,24.720110 298.694183,21.639168 
	C299.154236,21.609533 299.742218,21.380533 300.054565,21.581022 
	C303.270264,23.644909 305.942657,16.238314 309.454407,21.105387 
	C310.114807,22.020664 310.888763,24.346195 312.762756,23.321737 
	C315.424164,21.866804 311.778992,20.311163 312.676819,18.297806 
	C314.579498,19.027447 316.531281,20.320650 318.668365,18.398853 
	C319.873566,17.315073 321.754608,18.464226 322.849426,19.111797 
	C325.600128,20.738798 328.099854,23.961798 330.245300,18.587990 
	C332.295715,19.500450 334.617401,18.334015 336.308472,18.811956 
	C338.257202,19.362713 335.030823,20.948196 335.754791,22.802147 
	C339.453339,21.550018 343.228851,20.274290 346.190948,24.633730 
	C346.870361,25.633636 348.488800,24.148096 348.958069,22.360775 
	C349.651031,22.073269 350.320404,22.074472 350.948059,22.236826 
	C352.105804,22.536297 352.749207,24.690805 354.246307,23.496151 
	C356.118225,22.002419 353.264557,21.102737 353.552765,19.305086 
	C357.422760,20.279503 361.601379,18.624182 365.294922,21.500359 
	C366.645111,22.551794 368.465027,22.316938 369.133118,20.062065 
	C369.420166,19.093189 370.097321,18.083527 371.242615,18.588131 
	C372.273621,19.042385 371.938110,20.295303 371.996155,21.623827 
	C371.700104,22.206547 371.466949,22.408638 371.468475,22.410019 
	C371.964600,22.855198 371.008850,22.230909 371.839172,22.117474 
	C374.050751,21.979952 374.439728,26.220373 377.657928,24.034260 
	C378.316589,24.237637 378.628906,24.480917 379.056915,24.896496 
	C379.187836,25.049911 378.981110,25.357912 379.149353,25.288948 
	C379.192596,24.740274 378.796844,24.529062 378.205017,24.154358 
	C379.632385,20.455027 381.094543,16.773685 386.265015,19.516891 
	C388.412903,20.656448 389.168396,17.000996 391.358643,17.431190 
	C392.231781,19.767454 388.941132,20.206474 389.432129,22.222836 
	C390.207092,23.012777 391.319183,22.666985 391.575867,22.081440 
	C394.245941,15.990322 396.871704,19.506733 399.575653,21.998888 
	C400.040894,22.427677 400.723328,22.620821 401.651489,22.962404 
	C402.755737,18.970821 405.640381,22.850557 407.316010,21.466927 
	C408.866974,19.783085 403.724731,20.094511 406.042145,18.088821 
	C407.895966,16.484339 409.842712,17.246721 411.631805,18.111727 
	C414.502594,19.499725 410.383423,20.775259 411.906433,22.479332 
	C414.712555,23.013380 414.472809,18.803596 417.026581,18.338495 
	C418.694550,19.898722 415.860657,20.747993 416.486755,22.238846 
	C416.864716,22.194935 417.358032,22.255251 417.733704,22.072989 
	C419.132324,21.394445 420.331879,20.989153 421.828857,22.176071 
	C424.431885,24.239965 426.521027,26.754570 430.371490,22.689526 
	C433.093353,19.815941 431.576874,25.008224 433.303284,25.822971 
	C437.684113,19.075985 444.224396,22.803644 449.962433,22.628016 
	C451.463593,22.582069 452.834015,22.458494 454.602722,22.009151 
	C456.601654,21.426825 457.499084,22.755735 458.897705,23.662737 
	C459.949036,24.968748 459.029053,25.964037 458.974731,26.962252 
	C461.487579,26.365021 463.718201,21.964163 466.523560,26.758171 
	C466.556702,26.975815 466.346130,27.325693 466.346130,27.325693 
	C466.346130,27.325693 466.691406,27.559381 466.931213,27.486431 
	C468.379150,27.476898 469.418884,28.028446 470.323578,28.734676 
	C471.806335,29.892082 474.535645,30.595949 473.852386,32.907528 
	C473.111359,35.414665 470.851227,33.722000 469.175323,33.568226 
	C465.526917,33.233459 466.768494,36.887886 465.104919,38.680561 
	C459.180603,41.632771 452.929626,41.387871 446.936829,42.286842 
	C441.550232,43.094872 436.160980,44.055412 430.716980,44.490246 
	C428.472961,44.669479 427.419861,45.787762 427.454926,48.410786 
	C427.417450,51.260445 427.219757,53.714531 427.864685,56.540077 
	C427.815369,57.524426 427.620514,58.041538 426.878815,58.568199 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M268.233795,40.760475 
	C264.843964,40.864983 263.972870,43.887421 262.146851,45.481953 
	C261.020996,46.465088 260.105194,47.542439 258.939026,46.518364 
	C257.539856,45.289677 259.244354,44.612610 260.016022,43.911221 
	C260.899323,43.108364 261.223938,42.184853 260.196899,41.435596 
	C259.249359,40.744366 258.131927,41.221825 257.621887,42.125526 
	C256.369263,44.344898 255.112518,45.521736 252.621246,43.501514 
	C251.542404,42.626652 250.364151,43.144417 250.067566,44.677345 
	C249.828995,45.910522 249.600418,47.163155 247.917480,46.370422 
	C247.055618,45.964447 245.910751,45.394489 245.645874,44.636013 
	C244.977936,42.723164 246.934891,43.294064 247.787354,42.808353 
	C249.454285,41.858597 248.372391,40.797119 247.789536,39.927460 
	C247.110107,38.913677 245.814590,38.803257 245.370041,39.865379 
	C244.314590,42.387012 242.970383,42.194183 241.177139,40.804199 
	C240.625381,40.376503 239.546188,40.184921 239.494949,40.829937 
	C239.124405,45.494659 234.734161,46.550480 232.230743,49.282249 
	C231.874130,49.671402 232.065857,50.563057 232.002228,51.612511 
	C231.429047,53.054173 229.590103,52.141239 229.440292,54.578011 
	C229.195435,58.560879 222.670715,63.126514 218.017242,63.246399 
	C217.492447,63.000496 217.290421,62.884983 216.809784,62.558746 
	C215.566391,61.346195 214.460983,60.476021 213.557022,58.972950 
	C213.390076,58.170933 213.465805,57.720562 213.930069,57.052101 
	C216.801865,55.019379 219.553665,53.379692 221.620529,50.423485 
	C222.203888,49.778133 222.631027,49.443974 222.948074,49.004585 
	C222.736298,49.258518 222.509308,49.498356 222.037964,49.954987 
	C219.191528,52.291378 217.019485,54.909996 213.953247,57.036934 
	C212.065048,58.525158 210.208725,58.950577 207.855637,58.648590 
	C206.305649,57.707157 206.453384,56.672241 207.037994,55.548069 
	C207.763184,54.153584 206.605240,53.879440 205.746353,53.569164 
	C204.613113,53.159782 204.335464,53.796295 204.563568,55.128654 
	C201.996613,56.966553 201.731750,61.408504 197.270081,60.982452 
	C196.691101,60.817135 196.465881,60.721127 195.949799,60.392525 
	C194.102325,57.546703 195.194626,55.302029 196.820099,52.782562 
	C197.148544,52.266426 197.297195,52.074257 197.711945,51.641121 
	C201.500046,49.241871 204.585526,46.577408 207.191940,43.371597 
	C205.651550,43.725048 204.050934,44.070789 203.314758,41.724403 
	C203.276657,41.473133 203.201218,41.056866 202.994812,41.180267 
	C201.663589,42.803753 203.523483,43.631504 203.600418,44.880035 
	C203.679443,46.162277 203.408615,47.670010 202.053284,47.409477 
	C198.531799,46.732552 196.653976,49.387245 194.139297,50.747860 
	C190.119507,52.922840 187.419769,51.512871 186.646500,46.512802 
	C182.710846,50.097202 178.659073,53.292366 175.449493,57.844528 
	C173.351700,59.150101 172.080231,58.043770 170.904251,56.863327 
	C169.628723,55.582966 168.375977,54.297237 166.353973,53.313309 
	C166.141373,55.441322 165.417099,57.309910 163.074432,57.683151 
	C160.939606,58.023277 159.480331,56.296970 157.341034,55.582741 
	C155.995407,54.349689 154.977554,53.233463 153.197693,52.598545 
	C151.828430,51.654091 150.562073,51.215622 149.127365,50.377869 
	C147.954773,49.326809 148.281769,47.979565 147.473694,46.877762 
	C144.147308,50.301052 140.651154,53.452049 135.870300,55.347614 
	C135.296524,55.299324 135.074020,55.223442 134.647766,54.859711 
	C133.833298,51.653896 135.581253,49.786812 137.595718,48.305897 
	C139.129074,47.178661 139.067444,46.361111 137.873093,45.201557 
	C136.806900,44.166428 135.925018,42.899914 134.156555,44.347511 
	C132.345673,45.829823 131.060150,47.813625 129.159607,49.197021 
	C127.165382,50.648609 125.172714,51.640274 122.758362,50.162365 
	C121.567108,49.433155 120.347130,47.281261 119.031029,48.671757 
	C117.175835,50.631817 113.536308,51.090927 113.464996,54.515526 
	C113.423950,56.487450 113.083038,57.785545 110.597626,57.859741 
	C110.321144,57.836662 109.852974,57.730282 109.852974,57.730282 
	C109.852974,57.730282 109.672165,58.195377 109.665115,58.504486 
	C108.112358,62.037121 105.860115,60.896656 104.122902,59.337345 
	C102.215584,57.625359 98.372864,56.271820 101.802612,52.428406 
	C102.049446,52.344601 102.427917,52.451180 102.424850,52.264969 
	C99.542419,52.059666 98.919441,56.581242 95.231949,55.330048 
	C93.274048,53.155247 95.304268,51.319847 95.200218,49.052757 
	C95.648201,46.144730 97.367950,44.872158 99.758904,44.249786 
	C98.635780,43.881973 97.957924,42.723106 96.269669,42.602154 
	C97.511169,46.053215 95.009361,46.709812 92.494659,47.762917 
	C92.030090,48.327084 91.703613,48.581028 91.055458,48.902672 
	C90.011742,49.293503 89.330246,49.680355 88.654495,50.611809 
	C87.793938,51.530106 86.984222,51.806686 85.718544,51.709087 
	C85.174049,51.543888 84.967186,51.443951 84.497765,51.123726 
	C82.792381,48.419121 80.964691,50.242836 79.514580,50.696850 
	C74.096001,52.393349 74.127022,52.492424 69.096901,49.426983 
	C68.700668,48.890846 68.280464,49.995987 68.737450,49.510590 
	C68.812302,49.431084 68.918465,49.555336 69.157433,49.770737 
	C69.918961,50.457150 70.534470,51.201645 70.296509,52.643387 
	C69.471046,53.784176 68.538162,53.959927 67.183495,53.934616 
	C66.595451,53.826878 66.367378,53.758747 65.825478,53.530418 
	C64.027420,51.664471 62.543694,52.142189 60.852829,53.160332 
	C59.367329,54.054821 58.355671,55.804600 55.997437,55.726566 
	C55.448475,55.585217 55.240429,55.490261 54.799217,55.145210 
	C53.687004,53.335773 54.837967,51.938324 54.780136,50.194221 
	C54.507160,49.784904 54.374149,49.637001 53.998039,49.316082 
	C48.837791,49.438808 47.708630,54.267719 44.315498,56.882263 
	C41.718391,57.540272 40.358440,55.655006 38.974232,54.610195 
	C37.050426,53.158092 38.395298,52.206039 40.630699,52.007782 
	C41.649403,50.423748 44.235840,51.774536 44.468464,49.829884 
	C44.609726,48.648972 43.421143,48.015472 42.446533,48.133457 
	C40.522705,48.366344 37.826454,46.558701 36.839764,49.261616 
	C36.181824,51.063961 35.038731,51.401836 33.346054,51.963139 
	C31.151979,46.485012 27.589243,45.397831 23.658894,49.166767 
	C22.833239,49.958508 22.126110,50.881496 21.254768,51.613564 
	C20.971935,51.851189 20.260817,51.834946 19.883854,51.651188 
	C19.107225,51.272621 19.205212,50.407093 19.688463,50.007915 
	C22.909037,47.347569 24.673132,43.308384 28.626728,41.005692 
	C29.268768,39.496498 33.739941,38.474960 29.253174,36.229630 
	C28.992596,36.003574 28.999481,35.999783 28.997952,36.003567 
	C28.997604,35.255989 28.998787,34.504631 29.001076,33.375565 
	C30.778801,33.088753 31.400269,30.684265 33.643753,31.007095 
	C34.000000,31.000076 34.319138,31.327187 34.319138,31.327187 
	C34.319138,31.327187 34.279953,31.279175 34.139977,31.139549 
	C34.298199,29.768688 32.399242,28.371626 33.922504,27.406961 
	C35.364269,26.493906 36.283791,27.898386 37.079662,28.955334 
	C38.178665,30.414854 39.770294,29.868174 41.598709,30.000010 
	C42.216076,30.222530 42.423820,30.452517 42.623230,30.689863 
	C42.827484,30.932966 42.769051,30.850597 42.223961,30.221430 
	C42.210106,27.929604 41.233238,27.006521 39.196136,26.835077 
	C38.164711,26.748270 37.203648,26.013493 37.387142,24.885885 
	C37.532913,23.990091 38.486347,22.402414 38.684582,22.461123 
	C42.025124,23.450432 43.505024,20.248377 45.984928,19.430489 
	C46.168800,19.369848 46.593712,20.040054 46.950703,20.683315 
	C47.386028,21.593977 47.915897,21.695915 48.770649,21.217201 
	C49.585987,19.752974 51.599735,20.262310 51.953121,18.328617 
	C52.445637,18.002985 52.889397,18.002716 53.666000,18.002626 
	C55.851860,20.750723 58.482838,21.642546 61.995354,21.237576 
	C63.334553,21.361435 64.243889,22.099459 65.625679,21.655659 
	C66.129349,21.575611 66.335342,21.574713 66.774170,21.776974 
	C68.724968,22.261950 70.442947,22.543770 72.091400,22.814186 
	C73.359314,20.604563 70.064201,21.385756 70.575470,19.732388 
	C71.689301,18.311729 72.833855,19.665842 73.978111,19.879213 
	C75.828117,20.224188 75.993774,21.268566 75.081192,22.694672 
	C74.133408,24.175779 71.672066,25.724895 75.971649,27.070595 
	C78.185432,28.387978 79.762474,29.587727 80.254181,25.981476 
	C80.398209,25.464518 80.479546,25.263300 80.750366,24.803093 
	C81.282524,24.098940 81.874382,23.759567 81.288605,22.521429 
	C83.400658,16.803993 85.372368,16.220491 89.695961,19.373093 
	C91.669945,20.812441 93.491562,22.565435 96.378548,21.467999 
	C97.728844,20.954710 97.883965,22.265884 97.982056,23.630520 
	C97.496864,24.596783 97.618904,25.104189 98.461884,25.656799 
	C98.677605,25.787247 99.055275,26.089088 99.055275,26.089088 
	C99.055275,26.089088 99.085274,26.058504 98.898422,25.937571 
	C98.311172,25.466402 97.904816,25.120718 97.889412,24.293415 
	C102.896049,20.914139 108.541649,21.314894 113.267586,25.099146 
	C113.394279,25.200596 113.471840,25.376183 113.608566,25.450459 
	C117.226349,27.415840 116.197983,21.665127 119.083366,22.172684 
	C120.685623,22.454529 122.028000,27.477621 123.981667,22.573818 
	C125.449593,18.889210 127.678703,17.579924 131.641327,19.963951 
	C132.215500,20.250919 132.448990,20.493225 132.744019,20.634357 
	C133.200256,20.852613 133.210159,20.866123 132.830902,20.609116 
	C132.280258,20.235958 132.977203,20.704285 132.197098,20.191301 
	C133.365341,16.939775 135.772354,16.663260 138.455246,17.825348 
	C141.439636,19.118038 138.800812,20.715275 138.256531,22.874790 
	C141.234879,21.019199 142.830276,24.079184 145.634460,23.993488 
	C147.231689,25.245705 146.729050,26.491865 145.819031,28.010532 
	C145.310974,28.694786 144.932251,29.058638 144.586578,29.475548 
	C144.674179,29.286789 144.812851,29.110477 145.211731,28.788601 
	C146.063782,27.286629 148.080017,26.322468 146.225159,24.220150 
	C146.103851,22.891817 146.368820,20.715557 147.262650,21.333099 
	C151.120224,23.998291 153.560638,21.269146 156.389374,18.940718 
	C156.869705,22.034472 154.913071,23.258390 153.604843,24.570570 
	C154.456741,26.094795 155.562973,25.997812 156.285934,25.273359 
	C160.216324,21.334755 162.595764,24.580229 164.846436,27.218576 
	C165.816971,28.356295 167.148956,29.804380 167.542801,28.016733 
	C168.766220,22.463623 172.741974,21.584969 177.626846,21.044270 
	C178.167191,22.799887 176.318970,23.699947 176.036072,25.658159 
	C175.639618,26.360369 175.264908,26.705488 174.880615,27.040281 
	C175.134720,26.857609 175.368820,26.651518 175.790649,26.210220 
	C178.441528,26.653238 180.576675,27.793949 181.864944,30.066490 
	C182.265106,30.772373 182.578537,32.026470 183.413696,31.472876 
	C185.619720,30.010559 187.329636,27.908445 188.474731,25.547829 
	C189.135956,24.184727 187.652679,24.142485 186.347198,24.003311 
	C185.364349,19.802124 188.748077,19.561415 191.110672,18.300915 
	C193.032013,20.200863 190.033875,20.954832 190.655029,22.539562 
	C191.051773,22.593967 191.807419,22.856607 191.919586,22.688881 
	C193.366150,20.526100 194.859589,19.317797 197.183029,21.730085 
	C197.500046,22.059200 198.928909,21.990894 199.033371,21.752234 
	C201.334702,16.494541 205.787155,20.385319 209.070679,19.210434 
	C210.319290,21.355829 206.581604,21.413313 207.712967,23.658081 
	C210.169449,23.198092 212.659241,21.525011 215.338699,22.777000 
	C215.948853,20.643324 212.270172,21.144730 213.662079,19.089962 
	C214.174820,18.333014 215.304901,17.286972 215.909637,17.426834 
	C218.074326,17.927481 220.620148,18.258909 220.992050,21.633842 
	C222.451401,21.873859 223.702682,23.349962 225.589035,22.467560 
	C223.868332,19.401840 222.881683,18.399117 228.031631,19.123739 
	C231.268265,19.579149 234.209793,21.122299 237.125961,21.173767 
	C241.064560,21.243279 239.218491,26.020784 242.920807,26.063549 
	C244.361908,26.523418 244.898407,26.120510 245.558838,25.243090 
	C249.400635,23.962049 253.111221,21.281137 256.749756,25.750652 
	C257.000000,25.999254 257.000000,26.000000 257.000183,25.999725 
	C258.007690,26.658037 258.951263,27.380991 259.667358,28.624456 
	C259.821045,28.760151 260.031281,28.960728 260.031281,28.960728 
	C260.031281,28.960728 259.766785,28.767714 259.613525,28.534811 
	C259.222229,27.688231 259.290680,27.092123 259.780945,26.252888 
	C259.998779,25.998062 260.000000,26.000000 259.999359,25.999411 
	C260.432495,25.576311 261.019226,25.528055 261.775085,25.177189 
	C261.992432,24.992563 262.000000,24.999542 261.995850,24.994377 
	C262.549377,24.470442 263.209961,24.260002 264.292419,24.434608 
	C265.605133,25.552525 266.540131,27.077438 268.133789,24.661549 
	C272.749878,24.836151 273.266327,25.735592 270.779968,29.265493 
	C270.300018,29.712914 270.087158,29.927282 269.871948,30.139311 
	C269.397034,30.607182 269.685699,29.764919 269.517426,30.409996 
	C269.349121,31.055063 270.136108,30.993700 269.598816,30.599047 
	C269.586365,30.589907 269.643372,30.458723 269.987061,30.003773 
	C271.047394,29.062191 271.975525,28.487310 273.455688,28.324810 
	C274.499634,28.499783 275.115967,28.819298 275.926483,29.486362 
	C276.765259,32.294353 278.598175,32.287483 280.911316,31.728565 
	C281.572632,31.379894 281.963226,31.209242 282.683472,31.032421 
	C284.924927,30.747097 286.542633,31.355743 287.940460,32.683167 
	C288.676483,33.382130 291.256714,32.593555 289.952637,34.852406 
	C289.181152,36.188702 287.963745,37.693123 285.923676,36.326229 
	C285.177246,35.826103 284.321472,34.673168 283.431702,35.837963 
	C282.658051,36.850742 283.558136,37.585297 284.394714,38.218838 
	C285.155731,38.795132 286.327881,40.028824 285.172699,40.447887 
	C283.312927,41.122547 283.364624,43.869961 281.272064,43.699760 
	C279.939880,43.591408 279.979095,42.432907 280.573578,41.452999 
	C281.022705,40.712646 282.373657,40.029888 280.751068,39.247314 
	C279.914673,38.843929 279.103394,39.414780 278.609039,40.092827 
	C277.456787,41.673218 275.479248,43.319935 275.474945,44.944134 
	C275.461975,49.836273 273.595612,47.945507 271.788055,46.221310 
	C270.383728,44.881760 268.620239,43.766998 268.039978,41.349625 
	C268.223602,40.764259 268.518524,40.632385 268.757355,40.442616 
	C269.343903,39.976566 270.020447,40.642994 270.593750,40.249870 
	C269.806244,39.722198 269.113159,39.925056 268.233795,40.760475 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M722.895630,73.103180 
	C713.777344,70.797897 704.743286,69.792580 695.268982,69.233757 
	C694.807617,70.204826 694.166321,70.464256 693.031494,70.602142 
	C692.665161,70.628456 692.708984,70.193748 692.639648,69.975220 
	C692.457764,69.457848 692.345215,69.159019 692.126953,68.698288 
	C691.879639,68.418274 691.738159,68.300156 691.357117,68.320206 
	C690.625732,68.514771 690.133789,68.571182 688.899475,68.396339 
	C682.667725,67.103416 676.936646,67.630470 671.252686,65.420288 
	C668.292603,64.874626 665.219177,65.408615 664.167175,61.447868 
	C663.843567,60.956863 663.694885,60.769501 663.768188,60.304535 
	C664.552307,59.516296 665.243408,59.515430 666.256714,59.624393 
	C666.937927,59.944756 667.240662,60.235180 667.498779,60.904259 
	C667.532349,61.590279 667.171631,61.615288 666.947083,61.779076 
	C667.196472,62.001255 667.400024,61.912468 667.797485,61.315845 
	C669.805359,60.175915 671.383057,58.417618 673.754456,60.037609 
	C671.335999,56.696373 669.976929,61.049801 667.647888,60.450584 
	C666.424683,59.384296 665.389893,59.243774 663.977539,60.054352 
	C662.562256,60.543190 661.646790,60.371738 662.041504,58.902195 
	C662.494812,57.214252 664.303345,57.298016 665.286377,56.717773 
	C661.638123,55.995827 657.801453,55.963776 653.671753,56.481979 
	C652.480774,55.492905 651.634399,54.586548 650.559509,53.549484 
	C650.375610,53.373997 650.033691,53.050953 650.033691,53.050953 
	C650.033691,53.050953 650.119507,53.125786 650.291687,53.297127 
	C651.280273,54.298630 652.088318,55.137192 653.158264,56.163368 
	C654.422485,58.322906 656.194458,59.699848 657.191223,61.879364 
	C654.994568,62.210022 652.925293,62.230789 650.426758,62.131401 
	C649.593506,61.498203 649.088867,61.309505 648.228516,61.721817 
	C646.924194,61.914825 645.847595,61.919426 644.385376,61.796066 
	C639.531982,61.056847 638.773071,57.355755 637.757080,54.030411 
	C635.748657,57.050304 641.460144,58.074711 639.260681,61.367813 
	C637.508911,62.364582 636.158020,61.373238 634.387207,61.170444 
	C633.207275,61.008980 632.380249,60.990776 631.245117,61.108246 
	C625.804321,61.019310 620.596069,61.397820 615.401550,58.840958 
	C611.534729,56.936100 606.921631,56.454067 606.488525,51.159878 
	C606.362915,49.624657 606.069397,48.218105 608.045227,47.355503 
	C608.291382,47.295795 608.692017,47.240917 608.577148,47.049774 
	C606.330688,46.654793 605.944885,48.743397 604.714783,49.722130 
	C603.951843,50.329144 603.254578,51.356384 602.183716,50.894363 
	C601.182678,50.462502 600.894470,49.276325 601.147949,48.313087 
	C602.008667,45.042099 603.415100,42.000542 603.883911,38.509533 
	C604.186646,36.254532 606.678345,37.476471 608.163452,38.856010 
	C611.626221,42.072754 618.305542,41.809349 621.697937,38.333805 
	C622.847168,37.156368 624.311890,36.891209 625.151794,38.028122 
	C626.992310,40.519665 629.056885,41.105793 631.944397,40.209236 
	C633.055054,39.864395 634.214539,40.573658 634.390259,42.352409 
	C633.968140,43.029911 633.628723,43.364395 633.040527,43.960121 
	C631.101074,45.775261 630.201172,48.617661 626.725708,47.573082 
	C625.219727,45.804100 623.897400,45.806084 622.238586,46.821827 
	C620.627869,47.808105 619.065613,49.176495 616.669312,48.515732 
	C616.286865,48.305500 616.155334,48.194000 616.219238,48.258362 
	C619.971924,50.513939 621.822876,45.747829 625.277588,46.462814 
	C627.444031,48.009033 628.943359,50.137966 631.945679,49.396248 
	C632.300903,49.003864 632.445312,48.849224 632.808105,48.471298 
	C634.342468,46.874886 632.177246,46.030178 632.644897,44.493038 
	C633.123413,43.873829 633.451477,43.558659 634.002380,42.988876 
	C637.696289,43.146774 639.940063,40.632935 642.983276,39.268120 
	C643.524719,39.392105 643.730408,39.477036 644.182800,39.781292 
	C645.195679,40.980576 645.324951,42.311928 646.363037,43.374580 
	C646.604370,43.404305 646.440979,43.373497 646.309387,43.008698 
	C647.333557,37.270157 649.937805,35.552162 653.634155,38.143299 
	C653.839661,38.742912 653.296936,39.086964 653.858521,39.221069 
	C655.522278,37.554333 656.764832,35.766083 658.684570,34.158081 
	C659.444763,34.005054 659.888550,34.005245 660.665283,34.005432 
	C662.725037,36.179119 661.112671,37.887001 660.050293,39.872261 
	C659.895752,40.051373 659.610352,40.287964 659.610352,40.287964 
	C659.610352,40.287964 659.752258,40.630714 659.937378,40.527313 
	C662.118713,41.056381 664.113525,41.603836 666.343506,40.309212 
	C666.609375,40.294312 667.090271,40.374958 667.090271,40.374958 
	C667.090271,40.374958 667.398438,39.991970 667.447998,39.711315 
	C669.340881,36.132385 671.118958,37.755684 672.923889,39.485382 
	C674.712280,41.199230 675.465088,42.990517 673.332153,44.954914 
	C671.498108,46.644005 669.633362,48.338848 666.532227,47.538013 
	C665.988464,47.578197 665.552795,47.698997 665.826233,48.043633 
	C666.234863,48.558739 665.499695,48.069050 666.434509,47.954334 
	C667.824036,48.572727 669.011597,48.804279 670.001160,47.983284 
	C674.167786,44.526432 679.815979,43.010330 682.892029,38.129177 
	C683.806580,36.677990 685.103760,35.930779 686.627258,37.039360 
	C688.304138,38.259506 691.002747,38.573227 691.360413,41.020950 
	C691.634399,42.896145 690.008606,44.603378 688.347717,44.023640 
	C685.807129,43.136833 684.705383,44.718040 683.041260,45.961376 
	C682.903137,46.096115 682.809631,46.233128 682.936523,46.100906 
	C687.641907,43.338203 688.305481,43.628319 688.669922,48.422070 
	C693.633728,43.940464 699.007080,46.293907 704.031006,47.949829 
	C706.369263,48.720524 707.734558,49.630211 709.187500,46.927952 
	C709.848145,45.699341 711.500244,45.122284 712.568481,43.572426 
	C714.377625,41.849449 715.984680,40.538864 718.671021,41.570637 
	C719.552734,42.367516 719.772400,43.077087 719.676514,44.230850 
	C718.610352,46.474949 715.856934,46.510494 715.147156,48.855057 
	C717.080750,48.517979 718.064514,46.974255 719.691650,45.744118 
	C720.977295,45.190205 721.884949,45.422832 723.055542,46.125717 
	C724.371338,47.321762 725.617920,48.068741 726.612061,49.549278 
	C726.926758,50.471500 726.969360,51.091419 726.767822,51.909370 
	C726.703369,52.100304 726.501343,52.271198 726.501343,52.271198 
	C726.501343,52.271198 726.707947,52.430733 726.820007,52.273041 
	C729.363647,49.969196 730.735718,46.666199 734.449280,45.488808 
	C735.666016,45.241917 736.209045,46.371151 737.071594,45.994675 
	C737.150574,45.960201 736.671143,45.289799 736.372070,44.549744 
	C736.314575,41.056789 738.306946,40.528419 740.616028,41.476582 
	C742.931641,42.427441 744.980103,44.017563 744.363708,47.092216 
	C744.131165,48.252193 743.382385,49.161884 742.210693,50.125851 
	C741.456177,50.871010 740.860107,49.917828 740.627319,50.606926 
	C744.995056,48.927021 747.506165,45.095337 751.011414,42.473915 
	C752.441589,41.404396 753.667419,39.356186 755.612122,40.813847 
	C757.691223,42.372246 755.814758,44.049820 755.039795,45.581020 
	C754.614685,46.420792 753.687439,47.145184 754.827026,48.425594 
	C755.823975,49.418945 756.570374,50.231293 757.828064,48.731918 
	C758.275330,48.353745 758.398987,48.230503 758.468933,48.211781 
	C761.097290,47.508221 761.242310,43.273743 764.340942,43.673775 
	C766.819763,43.993782 767.566711,47.272388 770.305054,48.248051 
	C771.447876,49.560276 772.336121,50.436974 773.870300,48.674469 
	C774.630737,48.379986 775.093445,48.344601 775.893188,48.530903 
	C776.632690,48.929054 776.964844,49.291412 777.330627,49.616322 
	C781.924561,53.697083 781.929321,53.697113 786.286926,49.473972 
	C787.692139,48.112156 788.910522,46.481850 790.791931,45.752232 
	C793.025879,44.885906 794.733215,45.132763 794.445312,48.445862 
	C793.295227,49.516289 792.889526,50.732948 791.980225,51.625610 
	C793.028687,51.161079 793.005676,49.986351 793.924683,49.074257 
	C798.294434,48.820972 798.455017,49.185490 796.288818,53.764877 
	C798.204590,50.881973 800.275391,50.312111 802.550720,53.227257 
	C803.458557,54.390438 804.170715,55.715599 805.581421,56.769867 
	C805.766357,56.929184 806.069031,57.194462 806.069031,57.194462 
	C806.069031,57.194462 806.301941,56.840286 806.313354,56.555126 
	C807.655396,53.194542 809.628235,53.968296 811.182739,55.797173 
	C812.948914,57.875034 815.196289,59.626377 816.109619,62.654469 
	C816.004883,63.014061 816.000427,63.507637 815.999023,63.754429 
	C815.047241,65.178581 813.406311,65.393349 812.222473,66.776840 
	C812.002441,67.001831 812.000000,67.000000 812.001221,67.000664 
	C809.409607,68.676682 809.632507,71.124413 810.177917,74.018364 
	C810.128113,75.111191 809.947815,75.811813 809.408325,76.770737 
	C808.616150,77.550896 807.945312,77.744370 806.876343,77.662605 
	C805.510986,77.307724 804.691467,75.857681 803.115234,77.166618 
	C802.436584,77.481766 802.014893,77.507599 801.311890,77.240601 
	C799.744995,75.871742 797.288452,75.403290 798.368896,72.784821 
	C798.527222,72.400917 798.812378,72.369041 798.692383,72.349045 
	C798.311523,72.285561 798.322815,72.444054 798.242188,72.578827 
	C796.544189,75.416054 799.534424,75.527138 800.905334,76.960213 
	C802.027893,79.144150 800.534180,79.778229 798.936523,80.684494 
	C797.851379,81.009056 797.107117,81.042633 795.995850,80.857628 
	C795.419495,80.652481 795.202698,80.538147 794.737183,80.156631 
	C794.123230,79.267662 793.920410,78.585320 793.666870,77.562164 
	C791.838135,74.894119 792.621094,72.268921 792.588379,69.429153 
	C791.938477,68.257767 791.506287,67.209389 789.937073,68.383293 
	C788.816956,68.958824 787.950073,69.030769 786.813843,68.636421 
	C786.320984,68.513969 786.319031,68.090050 786.213074,68.318451 
	C786.696960,68.889000 786.753845,69.376472 786.640747,70.076416 
	C786.582581,70.266251 786.387817,70.661362 786.387817,70.661362 
	C786.387817,70.661362 786.507568,70.541534 786.717773,70.448853 
	C787.493408,70.221550 788.037781,70.313263 788.856323,70.696152 
	C789.822327,71.599747 790.033081,72.517319 790.298157,73.789551 
	C790.430908,74.841087 790.540955,75.538589 790.536011,76.591187 
	C790.388062,78.026550 789.331238,78.717003 789.438599,80.066017 
	C789.888672,80.572868 790.147156,80.873497 790.520630,81.479797 
	C790.761047,82.191536 790.786926,82.622238 790.662842,83.380936 
	C790.457397,83.895927 790.340454,84.087395 789.971191,84.501190 
	C787.542969,85.672546 786.162048,88.203812 783.043823,87.852928 
	C782.520630,87.705315 782.318420,87.621010 781.841980,87.359833 
	C780.654236,86.388046 779.462585,86.695419 778.139526,86.204895 
	C777.605713,85.689651 777.407288,85.334930 777.286194,84.690125 
	C777.260864,84.451073 777.239746,84.053505 777.034241,84.148483 
	C776.268494,84.763451 775.943542,85.467697 775.218140,86.268509 
	C773.316528,87.688293 772.353760,89.967728 769.573669,89.885452 
	C769.299255,89.870644 768.806885,89.951096 768.784546,90.229660 
	C768.656738,92.064659 767.754761,93.231361 766.837219,94.379021 
	C766.070984,95.337486 765.098450,95.879898 763.843201,95.478317 
	C762.501038,95.048950 762.018738,93.860863 762.434021,92.758453 
	C763.332397,90.374153 761.453735,89.216042 760.304565,87.372993 
	C759.932800,86.957497 759.788391,86.790016 759.439453,86.369591 
	C757.884033,84.122787 756.068054,86.429413 754.276855,85.488434 
	C752.061096,84.074593 750.459351,82.472473 748.883057,80.378998 
	C748.555176,79.704147 748.466919,79.299141 748.568970,78.648880 
	C748.884033,78.182777 748.991089,78.072845 748.818237,78.203308 
	C748.027771,78.967896 747.317505,79.530708 746.322021,80.255981 
	C745.231750,80.867836 744.354065,80.997566 743.100464,80.892113 
	C742.543335,80.759644 742.326660,80.683365 741.810547,80.438522 
	C740.778625,79.731453 740.143616,79.082878 739.234741,78.235825 
	C735.622498,75.870155 732.123535,74.408920 727.949402,74.719154 
	C726.396240,74.834595 725.459839,73.653397 725.862793,71.652077 
	C726.308350,69.438477 726.258240,67.125069 726.454346,64.438705 
	C724.715149,64.662422 722.749390,64.480232 722.195312,66.594620 
	C721.767151,68.228600 721.434875,70.114090 723.771667,71.194130 
	C725.003723,71.763588 723.683472,72.430321 722.895630,73.103180 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M609.990967,47.636696 
	C608.906799,48.107567 606.765686,48.345268 607.368530,49.209007 
	C608.678528,51.085953 607.273743,54.024216 610.069336,55.188965 
	C611.780884,55.902061 614.156006,55.679298 614.939209,58.421066 
	C609.398132,61.053219 604.335388,58.967659 599.082764,56.541500 
	C597.529175,50.312935 597.513489,50.284805 592.435974,53.111530 
	C591.234985,53.780125 589.937561,54.445621 588.678345,54.157291 
	C583.664429,53.009190 577.987366,54.402710 574.165161,48.900799 
	C571.145569,44.554234 570.529114,50.695564 568.222290,51.318565 
	C567.888123,51.760414 567.745422,51.927773 567.364502,52.317638 
	C566.115906,53.272266 564.941528,53.802490 564.118896,55.187977 
	C563.588562,55.531040 563.164429,55.582722 562.430115,55.543144 
	C559.122375,52.187504 554.164429,50.339615 554.560730,44.419525 
	C555.263367,43.534538 555.918335,43.294697 556.961548,43.381111 
	C557.590332,43.314499 557.505676,44.132465 557.760498,43.675396 
	C556.866211,42.667515 555.806519,42.170902 554.761719,41.161140 
	C553.710388,39.590332 552.881592,39.714752 551.804443,40.744026 
	C550.953613,41.557030 550.956055,42.145111 551.333740,43.274662 
	C553.363647,49.345665 550.198364,53.402126 544.114380,52.430584 
	C541.931885,52.082054 540.276306,52.904346 538.438721,53.599396 
	C537.129456,54.094612 535.670288,54.084213 534.875977,52.777225 
	C534.023804,51.375137 534.882202,50.152718 536.085510,49.444756 
	C538.377869,48.096149 539.866028,45.738400 542.574463,44.399330 
	C543.298096,43.700066 542.683594,44.336491 543.148499,43.858681 
	C543.357117,43.644253 543.569031,43.433239 543.772583,43.214317 
	C543.581421,43.345684 543.459106,43.545273 543.056274,43.935997 
	C539.402161,45.223972 537.757751,50.383266 532.986145,48.379055 
	C532.100342,48.006989 532.049255,48.970222 531.875183,49.545181 
	C531.069763,52.205872 528.640442,53.129368 526.281494,54.609512 
	C524.987488,54.953514 524.065979,54.889774 522.983887,54.078320 
	C522.361450,53.257420 522.744873,52.639942 522.630310,52.056568 
	C522.007996,52.546925 521.955872,53.402027 521.145142,54.199257 
	C513.755920,56.658634 506.785706,54.995388 499.809326,53.646049 
	C498.689545,53.429470 481.131287,41.070904 480.398560,39.687546 
	C481.003510,38.350025 482.009583,37.870319 482.939697,38.122997 
	C488.624084,39.667206 491.967773,36.178848 495.384247,32.627983 
	C496.674866,31.286572 497.417175,29.076897 500.230347,29.391472 
	C501.471008,29.941896 501.969452,30.770046 502.536102,31.560158 
	C502.752106,31.861399 502.636383,32.647343 503.412964,32.379364 
	C503.242218,31.915203 503.231750,31.437094 503.384705,30.629234 
	C504.215729,29.224728 504.979675,28.145586 503.484680,26.649822 
	C502.999817,25.386198 503.016602,24.454651 503.761169,23.288975 
	C505.931122,22.806644 506.994446,20.354031 509.625244,21.003548 
	C510.000000,21.000381 510.160767,21.158823 510.080383,21.079220 
	C510.055756,20.021368 510.068878,18.256485 510.890991,18.435431 
	C517.021729,19.769930 523.142090,15.507764 529.211121,18.494122 
	C530.506287,19.131409 531.851868,19.229044 532.986267,18.336847 
	C535.993408,15.971785 538.877991,17.049389 541.026550,19.210217 
	C544.467346,22.670620 548.437561,21.377394 552.350403,21.685955 
	C552.430908,19.343603 549.958862,20.573946 549.620850,19.139851 
	C549.615967,17.747440 553.045959,16.899591 553.784180,18.269291 
	C554.493408,19.585217 556.973389,20.825003 554.745728,22.882212 
	C554.457825,23.148029 554.486938,23.757069 554.350952,24.276793 
	C556.735107,25.234497 557.197083,22.820894 558.234436,21.965807 
	C562.604553,18.363663 567.144958,18.497372 571.924011,20.632353 
	C572.964233,21.097059 573.802551,22.003069 575.063599,21.976929 
	C577.514038,21.926130 577.916138,22.703821 576.596802,24.883739 
	C576.080566,25.736679 577.547974,25.862778 578.659546,25.997791 
	C580.330872,27.650520 581.967651,26.383387 583.303833,26.317158 
	C582.147461,25.876860 580.818604,27.445839 579.253601,26.220940 
	C580.354004,23.054266 586.545654,20.239216 589.206177,21.967381 
	C591.616455,23.532980 592.735168,22.037214 594.654846,21.055641 
	C594.999512,21.750607 594.998962,22.500168 594.999268,23.625246 
	C597.473267,23.807291 598.654480,21.921873 599.905090,20.181955 
	C601.200867,18.379114 602.396301,16.553713 604.134216,19.790438 
	C604.478333,20.431477 605.047180,20.886816 605.635803,20.120358 
	C606.372559,19.161009 606.709900,17.171688 608.405762,18.679401 
	C609.654541,19.789646 608.098816,20.643232 607.523621,21.557104 
	C606.751038,22.784494 607.225403,23.808483 608.346985,24.498001 
	C609.308594,25.089201 610.077637,24.884800 610.864624,23.903784 
	C612.532104,21.825024 616.785950,22.192589 616.342285,17.997171 
	C616.270752,17.320082 617.400757,17.276367 617.951538,17.693171 
	C618.989624,18.478886 620.474609,19.454292 619.358215,20.887186 
	C615.817505,25.431606 619.785339,27.417421 622.197266,30.015236 
	C623.285339,31.187111 624.185974,31.057089 624.978638,29.825182 
	C625.605957,28.850332 626.352356,27.743568 624.578247,27.063517 
	C624.115173,26.886023 623.419189,26.823729 623.238525,26.488443 
	C622.494202,25.107298 619.529907,25.802780 620.095642,23.680483 
	C620.548645,21.981092 622.327515,22.610506 623.884216,22.694139 
	C626.461060,22.832577 627.037170,19.221773 629.652405,18.842215 
	C630.243164,18.756483 630.788818,18.102739 631.424194,18.633694 
	C632.038330,19.146875 631.894836,19.798504 631.544067,20.412806 
	C631.128845,21.140053 629.617310,21.874599 631.127258,22.671103 
	C632.256165,23.266624 632.642517,21.986958 633.190125,21.137774 
	C634.321838,19.382788 636.138611,18.699362 638.035278,18.430395 
	C639.450317,19.628021 636.087219,20.856030 638.183228,21.729803 
	C639.435425,22.251823 640.508606,21.277922 640.815369,20.072891 
	C641.306946,18.141708 642.634888,17.938837 644.611816,18.001652 
	C646.233582,21.161585 647.586792,23.775179 651.950867,22.197908 
	C653.128906,21.772161 655.418945,22.679312 656.331970,23.728657 
	C657.353088,24.902199 655.525940,25.954107 654.652527,26.798958 
	C652.661682,28.724560 653.193298,29.727066 655.654968,30.388397 
	C657.176514,30.797161 658.089905,31.975481 658.860962,33.689217 
	C658.138000,36.789642 656.674561,39.044491 653.360168,39.992195 
	C652.902771,37.424503 652.288330,35.780525 649.964966,38.688553 
	C648.849915,40.084190 646.241089,40.581512 647.001221,43.608299 
	C644.620117,44.215916 643.789978,42.987484 644.007568,40.397331 
	C644.009766,40.009239 644.178650,39.819057 644.084473,39.904427 
	C643.021667,40.032230 641.579224,39.841385 641.338806,40.774292 
	C640.231689,45.069351 637.612915,44.288021 634.366638,43.004772 
	C633.695312,42.438606 633.253662,41.357079 633.111145,41.395168 
	C629.437439,42.376652 625.755371,43.699032 624.130066,38.388168 
	C623.998047,37.956829 622.828064,38.152039 622.418396,38.756172 
	C621.402405,40.254646 623.669006,40.905975 623.363892,42.564228 
	C621.836670,42.936779 619.508911,39.639160 618.387573,43.347343 
	C618.089722,44.332317 616.616882,43.869347 616.125000,42.746899 
	C615.686707,41.746574 614.624756,40.553692 614.028687,41.387840 
	C610.025208,46.989773 609.116699,40.842976 607.121277,39.548321 
	C606.370728,39.061367 605.939575,37.766773 604.860779,38.395725 
	C603.782593,39.024364 604.035400,40.098400 604.898254,40.888062 
	C606.546204,42.396233 605.680481,43.308788 604.340149,44.453018 
	C602.665527,45.882648 601.740295,47.761650 602.150330,50.172947 
	C603.756897,48.650898 605.109558,47.193295 606.644165,45.962574 
	C608.343445,44.599880 609.728027,44.652805 609.990967,47.636696 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M807.008484,57.637413 
	C804.390869,58.506084 803.289673,57.031548 802.173828,54.903400 
	C801.030151,52.722221 799.268738,49.856342 797.500916,54.716572 
	C797.291931,55.291088 796.674133,55.738892 796.191101,56.186337 
	C795.546021,56.783932 794.655762,57.178692 793.936462,56.662796 
	C792.722961,55.792519 794.132690,54.986828 794.174683,54.178883 
	C794.265198,52.440258 799.731018,51.206623 794.361572,49.006931 
	C793.913940,46.885235 793.822754,45.146088 790.920959,47.023129 
	C788.776550,48.410210 786.482300,50.345917 785.525696,52.048443 
	C783.237244,56.121727 781.583252,55.065338 779.135559,52.754951 
	C778.086792,51.764931 776.363220,51.466022 776.037537,49.357693 
	C776.154602,48.837482 776.314148,48.664867 776.791260,48.341797 
	C778.442871,47.828976 779.605408,48.240990 780.796387,49.007401 
	C778.977234,47.859470 779.308594,46.202267 779.559021,44.237820 
	C779.697205,42.111385 778.466370,41.249741 776.940674,40.181576 
	C775.652222,36.932529 776.925293,35.260277 779.895447,35.420853 
	C786.157227,35.759377 792.097473,35.705956 796.747314,30.410530 
	C798.419373,28.506296 800.844971,28.622683 802.113708,31.126003 
	C803.095032,33.062160 804.913147,33.897160 806.523315,35.537453 
	C809.107727,39.185875 810.883911,34.330498 813.345154,35.492336 
	C814.127869,35.993359 814.375549,36.616173 814.962769,36.872581 
	C814.723999,36.705757 814.505981,36.514553 814.084106,36.078335 
	C812.819397,34.635666 811.701721,34.454185 810.430481,35.541721 
	C809.512695,36.326790 808.500244,36.846748 807.010132,36.020706 
	C805.381531,33.981400 802.393555,33.190742 803.359863,29.717781 
	C804.518188,28.137058 805.645142,28.463469 806.868530,29.079464 
	C807.102417,29.197214 807.462280,30.301407 807.815552,29.237999 
	C807.910950,28.950819 807.399292,28.438255 807.234253,27.651112 
	C807.218567,27.105719 807.242126,26.888479 807.375732,26.364830 
	C807.816467,25.507591 808.262939,25.052565 808.907593,24.363039 
	C809.257446,23.991041 809.400024,23.845926 809.766113,23.495529 
	C810.294556,23.026772 810.608154,22.773945 811.465149,22.266232 
	C815.798218,23.882483 819.969177,19.909788 823.786865,22.761007 
	C824.323853,23.162058 825.444885,22.210201 825.517273,21.378353 
	C825.690308,19.389143 822.841675,20.569275 822.492798,18.871828 
	C827.303833,17.612816 827.758118,17.955309 827.128540,22.663910 
	C826.742004,23.310087 826.608887,23.664982 826.475342,24.334290 
	C826.222473,24.969376 826.032776,25.310831 825.647583,25.874033 
	C825.347351,26.248810 825.218323,26.388279 824.900452,26.724884 
	C824.013611,27.766415 824.819580,28.154211 825.451050,28.894283 
	C826.155762,29.779371 826.530945,30.506697 827.002075,31.170877 
	C828.436890,33.193619 829.562988,35.898193 832.751282,33.140594 
	C833.410461,32.570435 834.644653,32.986843 835.767944,33.745857 
	C835.857605,35.709148 834.930176,36.952103 833.838562,38.230087 
	C832.328430,39.998192 833.376831,40.798428 835.638550,40.991409 
	C836.108459,40.069759 835.758118,38.526707 836.907471,38.527908 
	C838.994995,38.530087 840.110657,40.545460 841.556335,41.776814 
	C842.223389,42.345051 841.738037,43.247631 840.978821,43.816013 
	C838.983276,45.309921 836.936768,46.770622 836.011597,49.629631 
	C836.002441,50.005291 836.000000,49.999863 836.002441,50.001228 
	C835.482056,50.424809 835.321594,50.946316 835.787476,51.791603 
	C836.903015,52.722664 837.840942,53.401447 838.693909,54.173885 
	C839.591492,54.986774 841.607727,55.441772 840.604858,57.086655 
	C839.665649,58.627052 838.612610,56.413136 837.706726,56.584557 
	C835.656982,56.972439 833.914856,58.288960 831.649414,56.379566 
	C830.657471,55.543583 829.801819,57.247623 830.590454,58.521114 
	C831.194397,59.496517 832.000610,60.357033 832.780334,61.210751 
	C833.792236,62.318714 833.524170,63.415512 832.639221,64.307602 
	C831.587463,65.367821 830.380249,64.949005 829.640381,63.916737 
	C828.621094,62.494400 827.430420,61.463905 825.357056,61.039562 
	C823.918030,57.727295 829.436340,58.438763 828.538269,55.109985 
	C828.327942,54.330601 829.304382,53.104080 828.240601,52.472591 
	C826.768250,51.598476 826.498718,53.022556 825.766785,53.895035 
	C824.642273,55.235374 823.311401,56.789112 821.755798,57.298477 
	C818.782898,58.271881 819.363647,62.013210 816.354248,63.005089 
	C814.006775,60.753185 811.683777,58.828388 809.967590,56.253036 
	C808.522034,54.083649 807.341248,54.984650 807.008484,57.637413 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M803.621643,28.520245 
	C802.717529,32.169445 806.765686,32.792221 806.989380,35.622841 
	C804.279602,36.216934 802.417480,34.324062 801.510620,32.472328 
	C799.427490,28.218966 798.031372,30.597738 796.266541,32.496494 
	C794.255737,34.659786 792.904968,38.730587 788.741638,35.259365 
	C788.458679,35.023468 787.454041,35.380966 786.959229,35.718086 
	C784.716248,37.246162 783.079895,41.288284 779.765747,36.427143 
	C778.883179,35.132526 777.163452,37.414528 776.843140,39.865131 
	C776.084229,41.006763 775.382812,41.381756 774.611816,42.158791 
	C774.238281,42.509762 774.083130,42.646687 773.680298,42.975544 
	C771.366943,44.150520 771.016846,45.818684 771.282288,48.422981 
	C770.334656,48.985603 769.298584,49.241787 769.059570,48.914963 
	C765.540710,44.104507 762.151306,45.962883 758.161804,48.728325 
	C757.002563,46.456284 758.780823,45.391232 759.530762,43.780212 
	C758.268311,45.278763 757.019836,46.613117 755.541382,48.592995 
	C753.873413,48.894161 752.318604,49.455055 751.746277,48.385571 
	C751.003845,46.998173 752.990173,46.756817 753.505615,45.806114 
	C753.899109,45.080231 754.383911,44.403534 754.833435,43.708408 
	C755.261597,43.046276 756.118103,42.335938 755.327148,41.573990 
	C754.347900,40.630703 753.672119,41.478962 752.907227,42.215054 
	C749.699951,45.301228 746.430969,48.324177 743.149170,51.331596 
	C741.876831,52.497505 740.404785,54.073689 740.005249,50.344482 
	C744.657410,46.866898 744.790466,44.658611 740.414429,42.525368 
	C738.602539,41.642120 737.242065,41.880543 737.014038,44.624405 
	C736.640991,45.562332 736.072021,45.642399 735.237427,45.828285 
	C731.432922,47.365276 730.655762,52.022068 726.372559,52.991741 
	C725.998169,52.246216 726.003723,51.499733 726.011902,50.380005 
	C726.446045,49.521366 726.770081,48.952332 727.424500,48.227325 
	C729.117249,45.792721 731.399536,44.299217 732.951050,41.742733 
	C733.250305,41.279144 733.382874,41.102982 733.758911,40.705841 
	C735.028931,39.776878 736.350586,39.412682 736.969849,37.769203 
	C737.226440,37.285606 737.338623,37.094635 737.654419,36.635712 
	C738.373230,35.812630 739.016296,35.400867 739.559875,34.889332 
	C740.034973,34.442307 739.605591,33.856953 739.522644,34.518433 
	C739.439636,35.179913 738.654907,34.286991 738.846130,34.776970 
	C738.101562,34.805447 737.679749,34.704475 736.986938,34.332405 
	C734.749268,30.308844 739.828613,29.627312 740.090027,26.405972 
	C740.504639,25.400543 741.030090,24.926529 741.776672,24.213747 
	C742.604004,23.431232 743.293945,23.096678 744.319336,23.111855 
	C744.514954,23.124348 744.790405,23.243483 744.742554,23.086651 
	C743.790955,22.435856 743.117676,22.859898 742.288452,23.699398 
	C741.466553,24.696732 740.325684,24.969547 739.935059,26.354839 
	C739.320923,27.886295 738.706055,29.038555 737.011475,29.593452 
	C735.978210,29.614710 735.338928,29.383087 734.417786,28.911804 
	C733.928528,28.606262 733.741394,28.469440 733.299561,28.094715 
	C732.118652,26.794655 731.144958,25.754965 731.652100,23.589828 
	C734.042908,22.814095 736.084290,22.621487 737.961975,21.292789 
	C741.231140,19.459486 744.372253,17.648401 748.237549,18.710510 
	C748.738892,18.848263 749.326538,18.494087 749.803772,19.156029 
	C751.359436,21.313715 751.341003,21.257486 753.306763,18.961006 
	C754.305969,17.793741 755.707458,17.400955 757.231506,17.505888 
	C757.610107,19.557543 756.518127,22.369114 760.087585,22.504675 
	C763.853149,22.647690 758.261719,19.169411 761.708252,19.041290 
	C763.007385,19.726566 764.122314,20.255211 765.262634,20.734318 
	C764.413452,20.188816 763.447693,19.875570 762.278687,19.205265 
	C764.245483,17.013824 770.749146,17.216818 772.181702,19.237705 
	C773.683655,21.356396 769.633423,20.655037 770.673096,22.493500 
	C771.790894,23.402426 772.795593,22.279869 773.872192,22.234209 
	C774.972229,22.187555 776.084473,22.430397 777.175903,22.544880 
	C778.011902,21.148598 775.044556,19.791063 777.169739,18.678814 
	C779.239441,17.595581 778.776123,20.164726 779.746399,20.757393 
	C781.726929,21.967188 783.509338,24.503721 785.798889,20.977190 
	C786.584290,19.767469 788.038818,19.527769 788.834778,21.966572 
	C788.531616,23.108583 788.049561,23.538786 788.607178,24.294270 
	C790.492004,24.343096 792.183960,24.015911 793.647583,25.666336 
	C794.218384,25.979082 794.323853,26.203100 794.155945,26.523403 
	C794.383728,26.236168 794.299011,26.022085 793.724792,25.626652 
	C794.971191,21.044470 797.379517,23.502710 799.882324,24.653332 
	C800.377502,24.932461 800.565857,25.055557 801.001709,25.399670 
	C801.930603,26.412239 802.346924,27.422188 803.621643,28.520245 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M668.038818,40.657433 
	C667.505371,41.029987 666.720886,40.870541 666.559570,41.117767 
	C664.215454,44.709465 661.967468,42.557652 659.348999,41.037090 
	C658.394165,38.514332 661.139832,37.096008 660.993164,34.380322 
	C661.916199,32.451038 661.886536,31.476034 659.884216,30.620394 
	C658.784668,30.150547 656.544800,28.493139 657.751221,27.413610 
	C659.621216,25.740364 661.275757,21.597134 663.301941,22.640213 
	C668.033203,25.075888 668.150391,20.541204 669.627014,19.002131 
	C670.984497,17.587233 671.507751,16.830696 672.845459,18.403681 
	C675.753967,21.823864 678.592346,24.538786 682.282593,19.247505 
	C682.488892,18.951740 683.488525,19.209267 684.458618,19.209267 
	C684.061462,21.618443 681.997559,22.426329 681.006470,23.971439 
	C679.775757,25.890131 681.143921,25.806759 682.656860,25.999981 
	C683.421814,26.414127 683.797058,26.894852 684.370300,27.112257 
	C684.504700,27.163231 684.627930,27.064676 684.621643,27.058908 
	C684.287537,26.752407 683.836304,26.659855 683.233032,26.211369 
	C683.328064,23.496288 684.753113,22.174704 687.628357,22.011715 
	C688.413879,22.420471 688.827087,22.840338 689.455444,23.460043 
	C689.868713,23.879084 690.092957,24.066582 690.337891,24.227711 
	C690.582886,24.388872 690.504883,24.329771 689.886658,23.853249 
	C689.253296,23.241184 688.837524,22.826052 688.215088,22.201633 
	C688.135437,20.292837 688.405334,17.739969 690.533386,20.272818 
	C693.441711,23.734539 697.297607,22.757029 700.351501,22.473841 
	C704.616638,22.078352 709.049500,23.268332 713.251465,21.319862 
	C715.101807,20.461840 714.684448,23.695745 716.657715,23.929529 
	C717.130249,24.172890 717.261230,24.358284 717.418945,24.882336 
	C717.247498,25.934198 716.779358,26.350269 715.734131,26.427828 
	C714.408997,25.543613 713.413391,24.657202 711.879272,26.113304 
	C710.418152,28.405018 707.874268,28.339045 706.033142,29.914146 
	C705.699036,30.435314 705.465088,30.541735 705.158752,30.452120 
	C705.411011,30.612591 705.621643,30.524881 705.987122,29.957775 
	C707.997864,28.586912 710.426453,28.444471 711.891846,26.115128 
	C712.685547,25.421591 713.301880,25.237614 714.318481,25.598118 
	C715.973633,27.817286 717.899231,26.106850 719.818115,26.632597 
	C720.416870,27.167288 720.584106,27.595911 720.624756,28.418161 
	C720.266724,29.931751 719.495300,30.817755 718.511841,31.963245 
	C717.381470,32.911503 716.321411,33.218395 714.953735,33.581207 
	C713.833618,33.853931 713.272705,34.348480 712.830078,35.416946 
	C712.159546,36.699371 711.350647,37.394714 710.013672,37.955383 
	C708.500793,38.413326 707.258118,38.685913 706.126465,39.872215 
	C705.693054,40.474236 705.016418,40.451023 705.051636,41.059444 
	C705.224976,40.826145 705.414612,40.606579 705.830688,40.173958 
	C706.532532,39.471191 707.122009,39.234398 708.142273,39.287098 
	C708.680603,39.453716 708.881531,39.559124 709.293945,39.927834 
	C710.182434,41.326221 708.846619,44.023899 712.460571,43.652538 
	C712.890259,47.542042 706.761475,47.789574 708.379272,52.401814 
	C708.479370,52.687233 706.787170,53.062904 706.407959,52.148720 
	C704.651855,47.914474 701.567810,47.418602 697.700439,48.807419 
	C697.400146,48.915253 696.874634,49.030952 696.744324,48.884499 
	C693.324646,45.041203 691.263306,47.935432 688.930969,50.302982 
	C687.912109,51.337189 686.728516,50.435524 685.839539,49.708370 
	C685.169861,49.160667 685.469727,48.472145 686.145630,48.157269 
	C687.264587,47.635956 688.549988,47.053925 687.442688,45.695496 
	C686.368042,44.377163 685.482117,45.694962 684.573364,46.366825 
	C684.080750,46.730980 683.360107,46.786762 682.371216,46.990364 
	C683.374023,42.961754 684.754700,42.135284 688.368530,43.100014 
	C689.623535,43.435055 690.497620,42.342678 690.420715,41.581921 
	C690.168091,39.082458 686.900391,39.966473 685.854370,37.826942 
	C685.334534,36.763550 684.516907,37.994045 683.956299,38.938419 
	C680.634216,44.534744 674.203369,46.106937 669.400024,49.813992 
	C668.263000,50.691517 666.493652,49.922905 665.287903,48.212715 
	C665.256592,47.058456 665.121399,44.705120 666.308289,45.720142 
	C669.572083,48.511314 670.428589,45.007980 672.285095,44.099968 
	C674.110657,43.207104 674.758789,41.884224 672.549805,41.191418 
	C671.194092,40.766220 670.456665,35.153156 668.038818,40.657433 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M501.482239,29.629013 
	C499.853027,30.066145 498.638123,29.900816 498.069305,31.326742 
	C496.268768,35.840698 491.360687,37.060436 488.395752,40.363304 
	C487.492615,41.369343 486.156036,41.094204 485.256470,40.202908 
	C484.022461,38.980263 482.623657,38.947441 480.666260,39.281715 
	C475.471527,36.615910 470.393250,39.499580 465.265991,38.295700 
	C465.122406,31.185062 465.145325,31.171160 473.633209,33.372429 
	C471.690125,30.516611 469.056061,29.467621 466.346130,28.035694 
	C465.025879,22.641321 462.572021,26.912903 460.879913,27.315523 
	C459.456909,27.654121 458.874237,31.302828 456.797150,28.875349 
	C454.976196,26.747173 458.690704,26.361881 459.083649,24.057987 
	C459.775665,22.829807 460.356995,22.261053 460.823120,21.242813 
	C461.146912,19.545540 460.341431,17.560465 461.600220,16.760777 
	C463.421143,15.603988 463.734131,18.206697 464.914185,18.877464 
	C466.151184,19.580612 467.075806,19.983128 468.351624,18.666281 
	C471.425964,15.493097 471.408936,18.680180 471.821808,20.582026 
	C473.795685,20.959717 475.052429,15.183371 477.450775,20.125059 
	C477.991302,21.238808 478.732574,19.405817 479.078247,19.416435 
	C483.316467,19.546633 486.924194,15.906412 491.296692,17.355185 
	C492.154510,17.639423 492.884460,18.507812 493.515350,19.242481 
	C495.606567,21.677715 497.117737,25.713181 501.178955,21.299723 
	C501.926544,20.487293 502.818085,21.927906 503.738251,22.822628 
	C504.005707,24.080235 504.003571,25.140047 503.846375,26.863571 
	C503.129181,28.116800 502.443756,28.583305 501.482239,29.629013 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M274.339783,28.941364 
	C272.894806,29.309418 271.792023,29.620457 270.344635,29.965710 
	C270.080688,28.205542 274.166138,25.382053 268.093384,24.847445 
	C266.880829,24.123537 266.412109,23.440435 265.367065,22.478964 
	C265.126587,17.955002 268.264008,19.814854 270.124451,19.546806 
	C272.785553,19.163401 271.262573,21.038033 271.165405,22.054495 
	C271.021759,23.556967 272.107849,24.055414 273.157440,24.520906 
	C274.324036,25.038286 274.601776,24.205734 275.451538,23.538721 
	C277.744232,21.739113 281.011932,19.515463 283.314545,19.561810 
	C286.751343,19.630983 282.478271,21.884113 283.032104,23.653952 
	C282.997559,24.002064 283.000000,23.999950 283.001221,23.998932 
	C280.421234,25.954103 277.545166,27.408258 274.339783,28.941364 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M825.850098,24.242752 
	C826.104919,23.673454 826.290833,23.418093 826.766968,23.107914 
	C827.514771,23.875166 828.373230,23.998648 829.626770,23.977623 
	C830.120605,24.120836 830.279236,24.268394 830.559692,24.715176 
	C830.942444,26.376978 830.099731,27.396338 829.567749,28.805393 
	C831.862305,30.172180 833.655762,27.501673 836.263062,28.295021 
	C836.807983,28.521908 837.010254,28.652958 837.410034,29.091671 
	C838.149109,30.997786 837.655945,32.315327 836.253296,33.727135 
	C836.000000,33.999546 836.000000,34.000000 836.000000,34.000168 
	C834.918579,35.054985 831.114624,31.615486 832.141174,36.393837 
	C832.297363,37.121147 830.845337,36.900196 830.171021,36.477219 
	C827.624146,34.879498 825.911682,32.621738 825.003174,29.382154 
	C824.663696,28.204409 824.204285,27.417011 824.777893,26.241714 
	C824.995117,25.993740 825.000000,26.000000 824.996948,25.997955 
	C825.471863,25.611586 825.789856,25.151491 825.850098,24.242752 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M807.853271,25.719833 
	C808.046570,26.968967 807.882751,28.073187 808.840088,28.673956 
	C809.901550,29.340063 811.775940,29.778971 810.312378,31.360188 
	C809.067566,32.704998 807.703308,31.798634 806.662781,30.457325 
	C806.198792,29.859251 805.377136,29.538679 804.360107,29.046925 
	C804.002441,29.001698 804.000000,29.000000 803.998779,28.999199 
	C803.153381,28.129410 802.293640,27.275946 801.215820,26.212240 
	C801.000000,25.999771 801.000000,26.000000 801.000000,26.000114 
	C800.481628,25.493134 800.255798,24.871750 800.345520,23.830109 
	C800.357788,22.881674 801.588318,22.653389 800.672241,21.870991 
	C800.043030,21.960001 799.666138,21.991499 798.968262,21.984726 
	C798.217102,21.877804 797.813721,21.717024 797.213013,21.244404 
	C797.875610,16.682819 801.633484,17.516911 804.306946,17.491175 
	C806.194824,17.473005 806.196594,19.696877 805.143127,21.675716 
	C806.135803,22.966543 806.577698,24.473860 807.853271,25.719833 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M720.232544,29.159767 
	C719.998291,28.548923 719.999023,28.104753 719.998657,27.327459 
	C719.370361,26.095974 718.196716,26.119059 717.219299,25.241444 
	C717.012756,24.844019 717.009949,24.672773 717.003296,24.244511 
	C719.807434,22.055729 723.334595,20.653910 726.056946,22.437017 
	C728.567932,24.081650 730.047852,18.712208 731.942749,22.658627 
	C732.000000,23.000610 732.000000,23.000000 732.000000,22.999668 
	C731.002625,23.784916 731.021484,24.944454 730.760010,26.364784 
	C730.509216,26.870087 730.377747,27.055355 729.966675,27.433378 
	C728.849670,27.994963 727.979126,28.025602 726.802612,27.800690 
	C726.345276,27.637857 726.176697,27.555136 725.794189,27.323961 
	C725.580139,27.175507 725.151917,26.957546 724.917358,27.008892 
	C724.682739,27.060238 724.265137,27.330103 724.057617,27.479092 
	C723.404602,27.913652 722.942322,28.171068 722.266724,28.612808 
	C721.887207,28.887739 721.729126,28.991869 721.307312,29.209276 
	C720.851624,29.323851 720.659607,29.325148 720.232544,29.159767 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M66.993622,21.605656 
	C67.006996,21.980131 66.509338,21.997162 66.260422,22.002243 
	C65.209229,22.357349 64.412743,22.743034 63.247169,22.208160 
	C59.482777,22.375158 55.301170,24.629766 54.000923,18.399380 
	C58.435940,18.636763 63.708710,15.910468 66.993622,21.605656 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M834.844360,25.300024 
	C834.993835,24.982319 834.998230,24.489939 835.001587,24.243763 
	C835.782593,23.056364 837.003357,22.581133 837.820190,21.245342 
	C838.225525,19.536808 837.333862,17.320917 839.781372,17.184937 
	C842.380676,17.040522 842.925964,19.504358 843.958008,21.640772 
	C844.129639,22.172016 844.259277,22.341284 844.285339,22.808695 
	C843.467407,23.822960 842.283752,23.580778 841.537598,24.645203 
	C841.374390,26.125423 841.936646,27.338396 841.210510,28.767721 
	C841.000000,28.998779 841.000000,29.000000 840.999146,29.000610 
	C840.007812,29.819586 838.929077,30.063044 837.364746,29.253420 
	C837.002441,29.003456 837.000000,28.999931 836.998413,28.998249 
	C836.035339,28.002628 834.787781,27.203516 834.844360,25.300024 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M796.661865,20.991348 
	C797.433899,20.996140 797.875122,20.999800 798.647217,21.003073 
	C799.375427,21.431379 799.838074,21.776638 800.672119,22.535984 
	C801.001404,23.751938 801.000427,24.501364 800.999695,25.625509 
	C798.567322,27.184258 796.826050,21.622519 794.066589,25.650993 
	C792.237122,25.654583 790.485657,24.857780 788.363159,25.962809 
	C786.912109,24.687338 787.588562,23.616289 788.743286,22.289083 
	C789.006042,22.003931 789.000000,21.999960 789.002441,22.003132 
	C790.585999,21.142750 792.437439,24.081827 793.962341,21.329617 
	C794.180908,20.871832 794.344727,20.742208 794.757935,20.802288 
	C795.448547,20.991396 795.889771,20.990805 796.661865,20.991348 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M854.053345,26.325836 
	C852.411316,26.028282 850.975708,25.865898 851.010986,23.377647 
	C853.908630,21.505810 857.573792,23.531345 860.629089,21.004692 
	C861.000000,20.997482 861.000000,21.000072 861.001221,21.000341 
	C861.378967,21.384769 861.526123,21.842684 861.229370,22.685799 
	C858.518127,23.848612 858.649109,29.655567 854.053345,26.325836 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M256.992371,25.630711 
	C253.585495,23.322302 249.970764,24.924465 246.200729,25.739122 
	C245.320465,26.573652 244.548416,26.728054 243.344788,26.231983 
	C243.001709,25.995771 243.000000,25.999918 243.002136,25.998970 
	C243.075073,25.344738 242.914886,24.519140 243.253296,24.065462 
	C245.931137,20.475433 254.310196,21.239519 256.992371,25.630711 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M834.619385,24.982956 
	C835.641602,26.103249 836.289368,27.224169 836.967041,28.670828 
	C834.845276,29.006338 832.810486,29.543442 831.150269,30.893000 
	C829.276123,32.416500 828.303650,32.154213 828.008423,29.359713 
	C829.071167,27.997116 830.650208,27.504375 831.537231,25.438244 
	C832.746643,24.995518 833.495789,24.989552 834.619385,24.982956 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M843.791748,23.201077 
	C843.984436,22.845669 843.988342,22.677088 843.996155,22.255627 
	C844.750000,22.003529 845.500000,22.004309 846.625000,22.006344 
	C846.999634,23.078398 846.999268,24.149195 846.997009,25.621698 
	C846.114197,26.853868 845.268555,27.720186 844.192566,28.783901 
	C843.232849,28.996929 842.488586,28.997437 841.372192,28.998362 
	C840.669922,27.577061 840.339844,26.155344 840.004883,24.364439 
	C840.478333,23.591656 841.032837,23.611280 841.864868,23.774731 
	C842.307434,23.849808 842.486328,23.857204 842.918213,23.780846 
	C843.315186,23.594028 843.459106,23.490967 843.791748,23.201077 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M808.000000,25.999931 
	C805.607605,26.225683 804.792786,24.981365 805.000977,22.394451 
	C806.530457,21.870550 808.031738,22.281071 809.158630,20.385975 
	C810.511169,18.111248 811.642334,18.960215 811.992432,21.627935 
	C812.000000,22.000736 812.000000,22.000000 812.000000,21.999619 
	C811.457642,22.525124 810.927979,23.063713 810.197510,23.802103 
	C809.997559,24.002781 810.000000,24.000000 810.001221,23.998604 
	C809.468445,24.531307 808.928101,25.059055 808.197693,25.797321 
	C808.000000,26.000153 808.000000,26.000000 808.000000,25.999931 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M257.382690,21.405834 
	C255.927399,20.734686 253.973389,20.569239 254.578812,18.852448 
	C255.100632,17.372715 256.658600,18.183395 257.440674,19.005276 
	C258.994232,20.637842 260.035126,18.294619 261.927185,18.735743 
	C260.596832,20.232718 261.632843,24.083803 257.382690,21.405834 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M459.228210,23.758528 
	C457.511780,24.156519 456.307037,23.709778 455.247742,22.163176 
	C454.882904,20.382027 455.355774,19.178745 456.966736,18.545864 
	C458.843048,17.808744 459.021790,19.457413 459.868439,20.688091 
	C460.037933,21.880186 460.108521,22.777439 459.228210,23.758528 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M794.995850,20.622583 
	C795.007324,20.991989 794.511963,20.999294 794.264526,21.000374 
	C793.858032,20.983715 793.693604,20.985920 793.540710,20.945127 
	C792.156799,20.575846 790.636047,20.323963 790.223877,18.649408 
	C790.070068,18.024363 790.462463,17.215197 791.241272,17.425903 
	C792.824524,17.854280 794.958984,17.710842 794.995850,20.622583 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M186.003662,24.003738 
	C185.964081,25.484819 186.102142,27.076073 184.241287,27.635107 
	C183.507782,27.855463 182.806839,27.411083 182.724701,26.756308 
	C182.494156,24.918257 183.506866,24.052889 185.644348,23.998468 
	C185.992249,23.992239 186.000000,23.999943 186.003662,24.003738 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M837.630005,21.007145 
	C839.516663,23.729967 837.933105,24.103804 835.362061,23.997959 
	C834.964233,22.404305 835.149048,20.981594 837.630005,21.007145 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M265.349915,24.427361 
	C264.248047,24.999119 263.496094,24.997702 262.367920,24.992748 
	C261.948486,23.391453 262.139282,21.972242 264.625305,22.008572 
	C264.995209,21.995331 265.000000,22.000330 265.002380,22.002583 
	C265.536713,22.508442 265.761627,23.127439 265.349915,24.427361 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M178.000824,21.000561 
	C177.857574,20.144020 176.566513,19.105196 177.853607,18.491831 
	C178.909134,17.988815 180.230957,18.729727 180.453857,19.924204 
	C180.660904,21.033617 179.420074,20.852011 178.335571,20.994772 
	C177.998779,20.998808 178.000000,21.000000 178.000824,21.000561 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M348.999756,22.000311 
	C347.836639,21.830772 346.242645,22.301720 346.266602,20.313774 
	C346.270782,19.968288 346.728271,19.406982 347.068359,19.324495 
	C348.684937,18.932405 348.869568,20.090208 348.988708,21.632313 
	C349.000488,21.999372 349.000000,22.000000 348.999756,22.000311 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M850.343506,20.943653 
	C849.835388,21.002501 849.668274,21.001730 849.250610,21.000366 
	C848.999451,20.249807 848.998901,19.499842 848.999146,18.375015 
	C850.023621,18.128521 851.298950,17.732317 851.747253,19.140570 
	C852.036255,20.048700 851.503784,20.584846 850.343506,20.943653 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M459.334686,23.995626 
	C459.162384,23.137211 459.324768,22.274424 459.747192,21.201637 
	C460.007233,20.991636 460.503021,20.995384 460.750916,20.996237 
	C461.757446,22.528749 462.329956,23.977745 459.334686,23.995626 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M875.997559,21.002258 
	C875.075256,20.874817 873.888977,21.315451 873.465393,20.051270 
	C873.217712,19.312111 873.746765,18.715199 874.402466,18.536272 
	C875.980652,18.105572 875.836487,19.374699 876.000122,20.651283 
	C876.004883,20.995485 876.000000,21.000000 875.997559,21.002258 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M78.549927,25.337658 
	C78.081184,23.463243 78.741966,22.396612 80.661560,22.035950 
	C81.000000,22.000076 81.000000,22.000000 81.000000,21.999962 
	C81.577095,22.680254 81.728821,23.447977 81.239090,24.640211 
	C81.005730,24.980881 80.998093,24.997938 80.989594,25.001848 
	C80.472954,25.537567 79.850349,25.760550 78.549927,25.337658 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M259.623993,26.001076 
	C259.999664,26.748276 260.000549,27.498491 260.000122,28.624924 
	C258.364227,29.022930 257.902802,27.710075 257.132629,26.298752 
	C257.749969,26.000996 258.499603,26.002542 259.623993,26.001076 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M830.312622,25.225710 
	C829.996582,24.836445 829.992432,24.663841 829.975159,24.232254 
	C830.283325,23.465410 830.596313,22.533068 830.927490,22.526566 
	C832.077332,22.503981 831.879395,23.571714 831.997437,24.668957 
	C831.997559,25.001486 832.000000,25.000000 832.001221,24.999264 
	C831.617493,25.377401 831.158203,25.525322 830.312622,25.225710 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M75.998535,27.001751 
	C76.077858,26.104221 76.316483,25.315746 77.662262,25.031031 
	C77.978966,24.980087 78.000580,25.001009 78.010506,25.011410 
	C78.800591,26.451393 78.235931,27.175545 76.378944,27.212593 
	C75.996666,27.002865 75.999931,27.000000 75.998535,27.001751 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M595.000000,20.999428 
	C595.089294,20.368898 595.095032,19.655615 595.905151,19.514854 
	C596.075806,19.485203 596.313660,19.842360 596.520508,20.021286 
	C596.201172,20.323603 595.881775,20.625923 595.281250,20.964645 
	C595.000000,21.001045 595.000000,21.000000 595.000000,20.999428 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M296.044617,18.408808 
	C296.770050,18.804083 296.777863,19.203293 296.262512,19.557125 
	C296.154785,19.631104 295.903961,19.627911 295.798157,19.551201 
	C295.293030,19.184917 295.309296,18.786280 296.044617,18.408808 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M738.000000,20.999710 
	C737.755188,20.656446 737.510315,20.313471 737.265503,19.970497 
	C737.387146,19.886337 737.508850,19.802174 737.630493,19.718014 
	C737.744995,19.988373 737.859497,20.258730 737.987000,20.765003 
	C738.000000,21.000916 738.000000,21.000000 738.000000,20.999710 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M261.695923,25.013876 
	C261.525909,25.313429 261.059418,25.634300 260.295807,25.976997 
	C260.465607,25.677616 260.932526,25.356405 261.695923,25.013876 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M849.000000,17.999956 
	C848.881409,17.862658 848.762817,17.725401 848.644226,17.588150 
	C848.727234,17.636011 848.810242,17.683870 848.946655,17.865940 
	C849.000000,18.000153 849.000000,18.000000 849.000000,17.999956 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M645.001221,18.001114 
	C645.089355,17.965847 645.176208,17.929464 645.130371,17.945698 
	C644.997559,17.998316 645.000000,18.000000 645.001221,18.001114 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M217.368591,76.594833 
	C217.549210,81.358192 222.599380,82.066368 223.799393,85.726227 
	C223.505356,88.876549 225.362747,90.098137 227.567764,91.107719 
	C229.062439,91.792076 229.942490,93.031708 229.597778,94.633545 
	C229.160309,96.666344 227.556488,95.415657 226.398514,95.543739 
	C223.819489,95.829010 221.261337,96.302788 218.351227,96.871628 
	C211.575424,100.589371 204.245941,100.640366 197.315308,101.975380 
	C184.112640,104.518555 171.039505,107.680237 157.799789,110.022400 
	C156.145767,110.315002 154.503494,110.456474 152.456314,110.219963 
	C151.075150,109.979271 150.218338,109.478767 149.388901,108.920113 
	C148.984268,108.647591 148.411636,108.712036 148.091797,108.271027 
	C148.119171,109.070518 149.283478,108.640625 149.384964,109.765091 
	C145.494858,113.112411 140.480331,113.007538 135.741089,114.656975 
	C132.938339,112.354729 128.637741,113.447708 126.627426,109.704948 
	C125.976852,109.224289 125.668633,108.881676 125.265930,108.170654 
	C124.922905,107.156403 124.878914,106.450142 124.945557,105.383492 
	C125.183464,103.883659 125.545341,102.767097 125.658096,101.247803 
	C125.695740,100.184967 125.771561,99.478737 125.943298,98.423813 
	C126.100464,97.850746 126.184662,97.628502 126.461349,97.108093 
	C128.303085,95.627846 130.237213,94.808411 131.681396,92.855064 
	C132.596573,92.255058 133.324051,92.070572 134.307648,92.093826 
	C134.511978,92.105362 134.835129,92.002831 134.658127,91.875374 
	C132.964050,90.709885 131.844940,89.492424 132.757904,87.173279 
	C135.043579,85.650932 136.498260,87.512238 138.557922,88.066055 
	C139.650299,88.434715 140.612518,88.945564 141.159821,88.153984 
	C144.213913,83.736656 148.767059,83.272491 153.733276,83.292274 
	C153.937164,83.311440 154.172333,83.497322 154.172333,83.497322 
	C154.172333,83.497322 154.323990,83.229584 154.153610,83.100342 
	C152.823059,82.040169 151.751221,81.013268 150.959244,79.750687 
	C150.224121,78.578720 149.799515,77.250206 150.902679,76.126801 
	C152.152649,74.853889 153.292267,75.827911 154.628006,76.811874 
	C155.846420,78.096138 156.930984,78.308556 158.491058,77.395340 
	C162.191635,77.463394 164.102600,79.282211 164.666962,82.846313 
	C164.464066,83.395653 164.394730,83.519691 164.394730,83.519691 
	C164.035416,83.859642 164.026978,83.904747 164.594818,83.495682 
	C165.881241,82.805443 166.958160,82.835457 168.330429,83.448227 
	C169.432388,84.409363 169.257034,85.244347 168.639435,86.299858 
	C168.285217,86.704391 168.159439,86.831390 168.234314,86.760651 
	C169.331268,85.823761 169.630280,84.900787 168.631409,83.540146 
	C167.296143,80.411461 169.852844,78.231476 169.952942,75.455246 
	C170.016129,73.702408 172.538071,74.431030 174.243729,75.293030 
	C174.741974,75.728584 174.869019,75.877403 174.725372,75.749985 
	C173.326996,74.339172 172.039200,73.085320 170.248779,71.903793 
	C169.814224,71.544930 169.648376,71.389671 169.260330,70.973785 
	C168.024078,68.979790 165.470276,67.921700 166.510941,65.287270 
	C167.261612,63.387005 169.000275,62.596447 170.827957,62.483982 
	C173.264481,62.334057 175.094681,62.895580 173.932449,66.183594 
	C172.852982,69.237488 174.285446,70.179169 177.456268,69.018745 
	C178.960464,67.832367 180.363144,67.057358 181.585434,65.514481 
	C183.105850,64.135422 184.341064,62.909931 186.612946,63.450191 
	C189.224075,66.976746 186.059143,67.749283 184.260620,69.176697 
	C183.609634,69.054413 184.538239,70.284088 184.293503,69.663971 
	C184.197021,69.419502 184.342789,69.424545 184.738464,69.437195 
	C188.121307,69.545303 188.586655,71.333496 186.564819,73.470062 
	C185.208145,74.903732 183.631149,75.432610 186.231491,77.170021 
	C187.174850,77.800308 186.521255,79.321983 185.458252,80.522629 
	C184.239136,81.758011 183.249771,82.733231 182.029053,83.971611 
	C181.200668,84.710510 180.535187,84.781212 179.528625,84.422638 
	C178.258438,83.124969 176.997253,82.523537 175.285446,82.106583 
	C176.457764,82.587646 177.408615,82.800827 178.484192,83.538551 
	C179.649719,84.673805 180.720581,85.439674 181.727997,86.725792 
	C182.209030,87.220230 182.478287,87.464729 182.987183,87.595924 
	C183.144196,87.595474 183.210190,87.521255 183.041687,87.522087 
	C182.563873,87.484116 182.302979,87.349007 181.894836,86.892197 
	C181.298523,86.106308 181.253174,85.484436 181.558655,84.538269 
	C182.740204,83.285515 183.712265,82.293564 184.939636,81.063057 
	C186.625626,79.450829 187.810196,77.851151 189.189987,76.435295 
	C193.211349,72.308846 195.777420,72.035522 199.615387,76.118240 
	C201.917694,78.567398 204.084183,79.626038 207.543396,78.494492 
	C209.193436,80.414474 210.892868,79.541298 212.728622,79.287712 
	C212.948273,79.309319 213.251297,79.528328 213.251297,79.528328 
	C213.251297,79.528328 213.540085,79.292961 213.430908,79.108856 
	C213.229675,78.374733 213.348145,77.856064 213.759277,77.074722 
	C214.783096,76.128815 215.728470,76.022408 217.368591,76.594833 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M464.654724,38.245789 
	C467.740417,37.708145 470.662109,37.857807 473.169342,36.910522 
	C476.224609,35.756165 478.099884,36.503860 479.988098,39.162430 
	C481.283356,41.024094 483.130066,41.450153 484.707428,42.307251 
	C488.641785,44.445122 492.680908,45.963692 495.663055,50.030296 
	C498.764282,54.259247 504.731750,52.995895 509.479034,53.762665 
	C513.012146,54.333332 516.709045,53.890213 520.729614,53.776451 
	C521.244934,52.816608 521.714600,52.488136 522.618042,53.202606 
	C523.587830,53.805950 524.481445,53.885353 525.709839,53.899223 
	C527.652039,53.457661 529.269348,52.554661 530.966187,54.329102 
	C531.087952,54.735161 530.987000,54.952389 530.906677,55.041245 
	C528.075928,57.017365 524.938232,56.364151 521.500854,56.488491 
	C519.123047,56.533218 517.224304,57.034512 514.879395,57.361198 
	C508.854828,57.586819 503.250275,57.886066 497.273132,58.478203 
	C496.544922,58.442383 496.077179,58.412674 495.969452,58.173893 
	C492.469910,50.419655 485.725830,46.246815 478.435242,42.667267 
	C477.889404,46.215401 479.080933,50.191547 477.348785,54.180016 
	C477.078400,54.960594 475.733490,54.510082 476.492157,55.818600 
	C476.873199,56.736835 476.967133,57.383335 476.822998,58.368530 
	C464.796661,62.369186 452.018799,60.845947 440.065521,64.668930 
	C437.355530,65.535660 434.168152,64.935799 431.200073,64.963142 
	C427.044739,65.001434 428.763489,60.926788 426.819946,58.893608 
	C426.312958,58.332352 426.269409,58.022678 426.434875,57.479004 
	C427.598846,54.757183 426.950012,52.217030 426.540466,49.362717 
	C425.342529,44.996853 427.054352,43.495667 431.074524,43.016075 
	C442.175720,41.691757 453.232605,39.995850 464.654724,38.245789 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M103.829559,129.359283 
	C104.116859,128.084351 104.169975,126.999023 104.205444,125.506218 
	C104.377090,124.946007 104.566376,124.793282 105.115234,124.582016 
	C109.131401,125.046967 112.592476,124.154137 116.376678,122.942429 
	C117.446388,122.574890 118.176430,122.364311 119.278519,122.017288 
	C132.477844,119.307007 145.130539,115.982910 157.886276,113.107513 
	C164.345154,111.651566 170.936203,110.833298 177.724655,108.980988 
	C178.612595,108.621338 179.123688,108.420731 180.030823,108.092056 
	C191.793427,107.155617 202.654526,103.559608 214.289566,101.967422 
	C214.975845,102.127861 215.240677,102.230644 215.824905,102.615509 
	C217.937241,105.432457 217.537186,106.679688 214.225677,107.348618 
	C190.456512,112.150032 166.693771,116.990318 142.981308,122.062714 
	C130.182495,124.800552 117.486748,128.020126 104.397476,130.795944 
	C103.707977,130.314392 103.556267,129.974182 103.829559,129.359283 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M230.802658,102.596596 
	C242.698654,98.952789 254.669525,97.347946 267.063110,95.788605 
	C269.180389,91.924416 272.975769,93.368752 275.601288,93.035889 
	C287.405029,91.539429 299.085236,89.252075 310.890350,87.817162 
	C312.689789,87.598427 314.516357,87.302170 316.670898,88.305641 
	C334.964050,86.720123 352.671295,83.061447 370.782837,83.272125 
	C324.488312,90.715363 277.792816,95.413223 231.430542,104.769951 
	C230.418533,104.232002 230.337692,103.577606 230.802658,102.596596 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M238.359833,116.906700 
	C237.948471,116.219498 237.949295,115.491791 238.000809,114.403114 
	C238.428604,113.467331 238.976074,113.252876 239.934174,113.400497 
	C241.263000,113.410698 242.300156,113.310371 243.664093,112.990425 
	C248.537445,110.679848 253.412140,110.341774 258.707642,110.147766 
	C259.543304,110.186806 259.974579,110.169662 260.713379,110.046974 
	C261.782593,109.298912 262.753906,109.632576 263.908264,109.249405 
	C264.215546,109.111366 264.605713,109.248207 264.800232,109.178131 
	C266.025238,107.760864 267.541718,108.767548 269.153381,108.244263 
	C269.546570,108.157860 269.751465,108.301430 269.853149,108.228630 
	C271.648163,106.840729 273.640472,107.846931 275.821228,107.274643 
	C278.309631,108.060265 280.176056,106.474342 282.566101,106.369751 
	C283.184753,105.787804 283.541107,105.446220 284.373474,105.241653 
	C284.748779,105.273628 285.153992,105.400558 285.233887,105.320663 
	C285.888824,105.038948 286.490082,105.638496 287.367096,105.195496 
	C288.586639,105.465775 289.494934,105.811653 290.721985,105.061218 
	C297.312134,102.968628 303.746643,102.148071 310.723877,102.265228 
	C311.520935,102.425438 311.896393,102.516739 312.563293,102.580925 
	C315.847748,100.339867 319.398193,100.582932 323.200317,100.223091 
	C323.573273,100.154846 323.618225,100.363243 323.724701,100.368561 
	C329.658691,99.172615 335.469849,97.840347 341.823547,98.251480 
	C342.886780,98.367798 343.614777,98.397789 344.668884,98.235657 
	C345.901672,97.184143 346.978424,96.982506 348.575989,97.358452 
	C349.157104,97.577263 349.331696,97.660423 349.795135,97.716766 
	C350.420746,97.544807 350.742279,97.371384 351.323334,97.170547 
	C352.241058,97.303139 352.884094,97.434929 353.756348,97.327682 
	C356.162750,95.466591 358.622253,95.921310 361.453613,96.353317 
	C362.305725,97.047630 362.517944,97.605995 362.337036,98.688377 
	C361.663605,99.337425 361.148407,99.551666 360.357666,99.815498 
	C359.243347,99.438896 358.351990,99.341461 357.119019,99.584831 
	C355.095673,99.825668 353.382477,99.922470 351.344086,100.043114 
	C349.257294,100.996201 347.345062,100.209076 345.153442,100.676888 
	C340.809692,101.238052 336.844208,101.670845 332.453125,102.129059 
	C331.238861,102.632835 330.333191,102.406075 329.221436,102.752953 
	C308.707794,105.015732 288.591095,107.969536 268.568115,111.585442 
	C258.641937,113.377983 248.704422,115.107918 238.359833,116.906700 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M134.657745,113.615387 
	C139.559479,112.760429 144.109650,111.725739 148.931976,110.529869 
	C149.221756,109.389427 149.901642,109.382530 150.905151,109.580605 
	C170.269424,106.008698 189.334274,102.262352 208.403290,98.537392 
	C211.315979,97.968422 214.248016,97.498375 217.589447,97.013031 
	C217.842758,97.585724 217.677719,98.127945 217.277313,98.837036 
	C215.115753,101.464676 212.191086,101.783966 209.479004,102.202431 
	C194.643066,104.491524 180.069534,108.047623 164.993530,111.213226 
	C162.169617,111.641174 159.798615,112.206245 157.049469,112.971115 
	C147.714706,114.036194 139.147797,116.696510 130.472412,118.832771 
	C123.556213,120.535843 116.575050,121.954178 109.677528,123.726959 
	C108.030449,124.150284 106.432991,124.416824 104.464745,123.459587 
	C104.087761,123.037048 104.066872,122.830658 104.023987,122.313873 
	C104.199707,121.238518 104.701416,120.713837 105.673843,120.135162 
	C108.928062,118.901497 111.746651,117.518097 115.192978,116.856613 
	C116.254906,116.622513 116.970505,116.494545 118.010574,116.136765 
	C120.071701,115.642891 121.808884,115.405418 123.881180,114.883392 
	C127.654358,114.690376 130.841064,113.038734 134.657745,113.615387 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M515.663391,65.904587 
	C516.283997,69.647827 519.101868,67.872269 520.555969,67.807716 
	C532.853333,67.261848 545.138794,66.452118 557.429321,65.747597 
	C581.878235,64.346146 606.348694,65.125542 630.810669,65.067963 
	C631.711975,65.065842 632.770447,64.743523 633.757080,66.016129 
	C632.168762,67.694061 630.107483,66.928482 628.402588,66.903824 
	C606.098755,66.581314 583.796326,66.616859 561.510010,67.557014 
	C544.403442,68.278679 527.353271,70.242859 510.192963,69.872086 
	C508.897888,69.844101 507.590790,70.372437 505.907410,70.706787 
	C505.181976,68.433167 505.162872,68.355103 507.067871,67.888725 
	C509.299835,67.342293 511.736816,67.758171 514.161072,66.259460 
	C514.759949,65.968163 515.016174,65.887215 515.663391,65.904587 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M423.632996,75.018723 
	C443.404694,73.673798 462.781372,72.434853 482.451111,70.053909 
	C483.035889,69.764427 483.244629,69.638588 483.799194,69.389557 
	C486.579193,69.052376 489.015625,68.358902 491.756409,69.511536 
	C492.371063,70.150574 492.487000,70.625229 492.199463,71.454056 
	C459.732910,74.920181 427.484375,78.077583 395.189087,81.239563 
	C394.844543,78.212814 396.947174,79.204269 398.524902,78.696014 
	C401.409729,76.132668 404.727875,76.484627 407.720154,76.198616 
	C412.877167,75.705704 417.941681,73.925934 423.632996,75.018723 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M476.152588,55.214497 
	C476.683899,50.201599 476.683899,45.472256 476.683899,39.898964 
	C484.072937,45.485035 493.823242,47.002151 496.007324,57.588448 
	C495.107025,58.954433 493.705994,58.230202 492.294006,58.922493 
	C487.062469,60.457314 482.032532,60.477352 476.859375,59.071640 
	C476.775024,58.021667 476.818817,57.356876 476.779175,56.367210 
	C476.337616,55.860893 475.979431,55.679489 476.152588,55.214497 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M317.051636,88.032494 
	C300.812592,90.851707 284.552429,93.207314 267.875366,95.623100 
	C267.347839,95.288574 267.237183,94.893867 266.977295,93.902634 
	C267.146851,92.645416 267.714691,92.276680 268.681213,91.880623 
	C269.584106,91.412674 270.639191,91.736633 270.671021,90.693375 
	C270.675720,90.539909 269.791748,90.605667 268.968262,90.680984 
	C267.274292,90.638283 266.378326,90.007690 266.020447,88.299370 
	C267.891449,83.132828 271.430267,85.775627 274.868713,86.124054 
	C276.362396,89.653664 278.867065,90.177292 282.323608,89.276550 
	C284.142090,88.796288 285.685425,88.666557 287.494202,88.237442 
	C288.728668,87.423157 289.673187,86.765381 290.971649,86.097992 
	C291.900452,86.824631 291.940582,88.022377 293.444031,88.149643 
	C295.473145,87.746315 295.776489,85.736908 297.565369,85.005943 
	C297.893646,84.943619 298.252014,85.274757 298.252014,85.274757 
	C298.252014,85.274757 298.228638,85.209557 298.088501,85.055786 
	C298.873505,80.873657 300.868896,81.908371 303.366028,83.902374 
	C305.009460,86.156105 304.622925,82.919792 305.698547,83.260681 
	C306.686676,80.957626 308.206329,81.651878 309.963562,82.102699 
	C310.819458,82.713676 310.970947,83.520744 311.541260,84.049835 
	C312.045715,83.413879 311.247009,83.051468 311.110809,82.221268 
	C312.511200,80.533691 314.094360,80.760765 315.936951,81.996002 
	C317.498718,82.816902 317.918701,83.793633 317.345398,85.433426 
	C317.095490,86.334564 317.063019,86.951729 317.051636,88.032494 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M470.990784,85.033722 
	C470.831146,87.547928 468.666840,87.464523 467.176147,87.532875 
	C446.633362,88.474785 426.262482,91.097000 405.480316,93.676819 
	C399.611145,95.413818 393.979095,95.902946 388.022339,96.261429 
	C387.282806,96.590065 386.819305,96.593857 386.035217,96.312454 
	C385.418457,95.721344 385.215851,95.270668 385.061340,94.402840 
	C385.071075,93.505142 385.215057,93.018822 385.738403,92.295395 
	C386.446136,91.875534 386.877716,91.723289 387.434326,91.373238 
	C394.178375,90.065125 401.022247,91.750175 407.559418,89.532440 
	C410.124695,88.662178 412.780060,88.718750 415.775604,89.163605 
	C416.545013,89.189491 416.972809,89.155060 417.702271,89.004303 
	C424.660339,87.473198 431.369843,86.444061 438.603302,86.100677 
	C439.445312,86.130836 439.859100,86.170471 440.584625,86.200012 
	C442.181763,86.006035 443.411652,85.572876 444.990906,85.231781 
	C445.294464,85.118301 445.519958,85.180313 445.630676,85.142715 
	C446.343109,85.400925 446.966827,85.541061 447.930542,85.233414 
	C455.700256,85.012299 463.173584,84.930252 470.990784,85.033722 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M531.550354,54.702812 
	C529.654297,54.485939 528.220703,54.236717 526.415771,53.910599 
	C527.615601,51.439453 532.473816,51.113495 530.488525,46.390118 
	C530.020264,45.276134 531.838745,44.693134 532.361145,45.631458 
	C534.815430,50.039524 536.779541,47.193932 538.688049,45.303005 
	C539.744141,44.256676 540.878418,43.963833 542.618530,44.002102 
	C542.297363,47.248180 539.271362,48.265659 537.084900,50.058346 
	C536.325989,50.680622 535.030396,51.080219 535.598999,52.171467 
	C536.260071,53.440186 537.766296,53.209839 538.549927,52.328812 
	C540.571472,50.055923 542.599121,50.037323 545.117554,51.464245 
	C546.626953,52.319454 548.559021,52.532352 548.995056,50.177540 
	C549.372192,48.140091 553.919739,46.951408 550.302612,44.133911 
	C549.062866,43.168270 548.421936,41.384277 549.541992,40.861515 
	C551.394226,39.996975 551.562378,37.155567 553.810608,37.360817 
	C555.339966,37.500446 554.851929,39.142811 554.903870,40.865288 
	C554.569153,41.980579 554.359497,42.455509 554.809204,43.498920 
	C554.935425,46.941322 556.452515,49.384472 558.730286,50.564434 
	C560.711975,51.590992 561.021912,53.183594 561.986755,55.076305 
	C558.501770,55.919098 554.895630,56.051136 551.060547,54.712662 
	C551.131958,54.089722 551.493591,53.850826 552.172058,53.517681 
	C552.841492,53.086842 553.170593,52.740791 553.447449,52.345673 
	C553.242554,52.346684 553.322876,52.563011 553.033997,52.880302 
	C552.335938,53.490608 551.655029,53.498631 550.920776,54.116302 
	C544.493652,56.433403 538.252930,55.537151 531.550354,54.702812 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M103.622261,129.209564 
	C104.152046,129.476746 104.181458,129.789368 104.101219,130.338531 
	C77.501076,137.869736 50.970486,145.233444 24.781706,153.766968 
	C21.463448,154.848221 18.111908,155.827332 14.394456,156.874908 
	C14.006184,156.507324 13.999241,156.118561 14.005360,155.438354 
	C37.042625,147.250519 60.383488,140.403656 83.858109,133.990784 
	C88.787079,132.644272 93.644623,131.029114 98.508423,129.455353 
	C100.081512,128.946350 101.564819,128.080734 103.622261,129.209564 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M566.606689,52.012146 
	C566.883057,48.774761 569.873108,47.457729 571.566833,45.678467 
	C572.882751,44.295921 574.352966,47.119125 575.584778,48.307671 
	C577.506226,50.161636 578.538086,54.656773 582.422546,50.478580 
	C582.869873,49.997364 583.645691,50.365078 584.165161,50.873463 
	C587.147705,53.792336 588.963989,53.808159 592.585571,51.142460 
	C594.150513,49.990551 595.889648,48.686794 597.894104,50.007046 
	C599.937378,51.352867 600.635376,53.253452 599.037842,55.884331 
	C596.085327,54.171284 593.106140,55.929794 590.217834,55.876678 
	C581.758362,55.721092 573.296143,55.711361 564.423828,55.561928 
	C564.006348,53.856457 563.802673,52.107861 566.606689,52.012146 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M385.796509,91.775162 
	C386.016571,92.536461 386.018585,93.045143 385.965149,93.931412 
	C383.122620,97.352348 379.043457,96.712440 375.705994,97.069138 
	C371.531311,97.515320 367.198486,97.947693 362.529572,97.437927 
	C359.727386,97.195862 357.311310,97.167419 354.440430,97.113815 
	C356.807281,93.643311 361.076721,93.735100 364.828003,93.123360 
	C371.669403,92.007729 378.573639,90.874519 385.796509,91.775162 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M164.049927,110.476845 
	C180.342529,106.709663 196.639740,103.365364 212.933014,100.001892 
	C214.055298,99.770210 215.148071,99.395470 216.648254,99.045578 
	C217.111984,100.144501 217.383057,101.326744 216.257599,102.570381 
	C215.941360,102.904861 215.738449,102.912117 215.231873,102.895927 
	C211.363846,102.026306 208.071533,103.544350 204.710022,104.179367 
	C196.591461,105.713043 188.565460,107.732323 180.201569,109.198120 
	C179.981720,109.871819 179.803589,110.048698 179.310974,110.117386 
	C175.600555,109.214050 172.392456,110.733292 169.102997,111.456535 
	C167.293640,111.854347 165.588654,112.469917 164.049927,110.476845 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M663.704224,59.960548 
	C664.000732,60.193272 663.999084,60.383343 663.994873,60.858818 
	C661.979370,61.994186 660.131470,63.623657 657.379883,62.333061 
	C655.387024,60.627346 652.228271,60.178482 653.002197,56.386826 
	C657.819580,53.112560 663.292725,56.579628 668.182617,54.421631 
	C668.075500,55.068832 665.808411,56.963078 662.903870,58.856495 
	C662.806213,58.920162 662.721802,59.191742 662.773621,59.263115 
	C662.950012,59.506351 663.190186,59.703285 663.704224,59.960548 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M424.024719,74.778069 
	C416.065857,77.130653 407.806183,77.192581 399.340485,78.603394 
	C398.887146,78.243401 398.892609,77.922653 398.958557,77.361671 
	C399.345428,75.828484 400.583710,75.357315 401.652740,74.305275 
	C402.725189,73.751442 403.438019,72.911819 404.730804,73.473709 
	C407.860931,74.081055 410.903320,75.818977 413.633606,72.521255 
	C414.701752,71.896973 415.431427,70.896080 416.788208,71.647675 
	C417.647034,72.741035 418.434418,73.133430 419.711792,72.359283 
	C420.364746,71.797699 420.791046,71.419426 421.511353,70.988129 
	C421.201508,72.728149 422.719147,72.238609 423.754028,72.751503 
	C423.995636,73.458305 423.998993,73.938423 424.024719,74.778069 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M439.011444,85.698746 
	C438.929596,87.579102 437.973083,87.931953 436.667542,88.000237 
	C430.747192,88.309906 424.829224,88.665062 418.457153,88.945908 
	C418.435333,86.456810 420.379242,87.167313 421.911407,86.992752 
	C424.324890,86.717789 426.591858,86.560699 428.303558,84.156372 
	C429.731323,82.150917 437.543884,83.260452 439.011444,85.698746 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M236.207062,93.754288 
	C238.055206,95.213333 239.063553,95.632301 240.254944,93.293022 
	C241.414169,91.016876 244.201355,89.583702 246.450943,89.678627 
	C249.187164,89.794090 248.816986,93.109833 249.897736,95.774498 
	C244.600830,95.469612 239.813446,97.895241 234.366455,96.050995 
	C233.136154,93.968536 234.134918,93.462845 236.207062,93.754288 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M514.623413,65.539978 
	C514.670044,67.498230 515.080139,68.661926 512.632690,68.897491 
	C510.272034,69.124710 507.475220,67.748657 505.461670,70.382576 
	C503.399841,71.036980 501.737213,70.529388 500.948334,67.997696 
	C501.040802,67.503304 500.687531,66.591743 500.214386,66.383026 
	C499.594482,66.109596 499.177856,65.608078 498.924225,64.647308 
	C500.834290,62.301559 502.663544,62.249313 504.680969,64.772026 
	C506.230438,65.654610 506.485626,64.621498 507.210571,63.917198 
	C509.053894,64.326576 510.582153,64.667068 512.452515,65.010643 
	C512.945068,64.859337 513.095459,64.704933 513.569214,64.571182 
	C514.074280,64.708824 514.256104,64.825829 514.623413,65.539978 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M415.848053,88.899963 
	C406.758667,90.746719 397.450073,92.820854 387.709503,91.478714 
	C396.707092,88.238113 406.215790,89.191620 415.848053,88.899963 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M239.994507,113.152611 
	C239.693741,113.646011 239.161621,113.781006 238.340500,113.979073 
	C232.184067,114.912468 226.316650,115.782776 220.200470,116.407387 
	C223.433777,112.487305 228.142838,111.700424 232.765152,111.266174 
	C235.029984,111.053406 237.426331,112.240608 239.994507,113.152611 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M492.292419,70.435616 
	C489.432281,69.294456 486.970490,70.505348 484.199524,70.292068 
	C483.275848,68.853233 483.519531,67.604805 484.085175,66.171364 
	C485.092957,65.985680 485.672455,65.993042 486.541687,65.991379 
	C487.751526,65.984619 488.681641,66.039909 489.746643,65.241180 
	C489.998657,65.004982 490.474304,64.980774 490.712463,64.978584 
	C492.215576,65.434006 493.464233,65.762878 494.748047,64.297943 
	C495.413361,63.337803 495.953552,63.024395 496.875336,63.852478 
	C497.929352,64.975510 498.277374,66.054977 498.055786,67.656212 
	C498.254486,68.500694 498.511047,68.996750 498.886658,69.742714 
	C498.657776,70.012878 498.309875,70.033134 497.701111,70.036613 
	C495.788879,69.875137 494.350708,71.498528 492.292419,70.435616 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M310.957703,102.038452 
	C304.900299,104.487534 298.324127,104.309319 291.455750,104.976685 
	C293.416809,103.255432 296.568939,103.075676 298.495544,100.424629 
	C299.678223,98.797234 301.859863,99.040909 303.491669,100.052422 
	C305.772339,101.466141 308.195984,101.820595 310.957703,102.038452 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M372.693115,72.707733 
	C373.331635,74.126617 375.237701,73.869591 375.152802,75.764557 
	C375.044525,78.182198 374.268585,80.347107 371.776337,80.442566 
	C369.587311,80.526398 369.236267,78.236191 369.074738,76.392632 
	C368.870514,74.061974 370.744598,72.574814 371.585419,70.667534 
	C371.792389,70.198105 372.815887,69.997688 373.043060,70.968468 
	C373.138611,71.376724 372.807983,71.884720 372.693115,72.707733 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M258.847534,109.888168 
	C254.653778,112.674393 249.695053,112.509659 244.417633,112.842285 
	C243.692291,108.328659 247.461273,108.695229 249.858307,108.479141 
	C252.710526,108.222008 255.670044,109.155045 258.847534,109.888168 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M639.392822,61.739746 
	C637.993103,58.430706 636.498047,55.524872 633.755859,51.634094 
	C637.212402,52.920723 640.402100,51.849133 639.677246,56.787132 
	C639.347595,59.032745 641.858093,60.234890 643.937622,61.392315 
	C642.624084,62.246555 641.210815,62.125294 639.392822,61.739746 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M283.035583,89.575470 
	C276.795105,92.478218 275.497925,91.988991 275.289246,86.582520 
	C276.826416,85.887207 278.375122,85.614807 280.262817,85.374146 
	C282.608887,85.460670 280.185486,87.673828 282.092346,88.071556 
	C282.697174,88.513733 282.941193,88.859612 283.035583,89.575470 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M254.427795,91.272438 
	C258.037872,88.148918 260.932556,87.973740 261.933502,93.811813 
	C260.235870,94.143105 258.487274,94.484344 256.367706,94.796539 
	C254.786423,94.004875 255.154175,92.564682 254.427795,91.272438 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M492.537048,59.247410 
	C492.732422,57.652618 494.147095,58.032299 495.781372,57.938034 
	C502.115784,57.168358 508.074219,56.760235 514.532104,57.022736 
	C515.113708,57.192600 515.228943,57.342449 515.122803,57.669445 
	C507.600616,58.316643 500.299896,58.786694 492.537048,59.247410 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M358.614746,75.595818 
	C360.287018,74.724419 361.502350,75.066772 362.347504,76.264771 
	C363.202545,77.476700 366.778198,77.250732 364.908875,79.635345 
	C363.794342,81.057053 361.209534,81.227119 359.313843,79.235184 
	C358.271057,78.139496 357.701294,77.265594 358.614746,75.595818 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M341.942871,98.021515 
	C336.289856,99.873489 330.241272,100.116760 324.044312,100.599998 
	C329.514404,97.593033 335.473267,96.660713 341.942871,98.021515 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M650.693481,65.727188 
	C655.080994,65.949890 659.057434,66.000725 663.490112,66.101776 
	C664.320679,66.414131 664.452271,66.773598 664.127563,67.415817 
	C654.540100,67.614319 645.198669,67.614319 635.857300,67.614319 
	C635.862061,66.990593 635.866821,66.366867 635.871643,65.743141 
	C639.145935,64.573631 642.529968,65.653679 646.304749,65.708557 
	C647.905579,65.381210 649.098083,65.532104 650.693481,65.727188 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M325.637756,82.329651 
	C326.325409,81.055290 325.315399,79.319046 327.890381,79.369781 
	C328.599915,79.809601 328.664307,80.130669 328.597198,80.452133 
	C328.519470,80.824387 328.424683,81.071236 328.359802,81.202461 
	C328.055695,80.609200 328.212189,81.296783 329.006836,80.753952 
	C329.633179,80.473366 330.020752,80.498535 330.582825,80.864349 
	C331.733124,81.915329 332.703857,82.728806 333.750641,83.606033 
	C331.653259,85.522453 329.167603,84.775612 326.484039,84.993317 
	C325.437408,84.316803 325.253998,83.558739 325.637756,82.329651 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M230.682480,102.339134 
	C231.042038,102.946236 231.032425,103.546875 231.030472,104.448318 
	C228.024536,105.211609 225.015350,105.706200 221.995178,106.120880 
	C220.777267,106.288101 219.595596,106.220642 220.624329,104.191635 
	C221.398575,103.611534 221.888519,103.460747 222.796890,103.725548 
	C225.535721,103.390198 227.924515,102.861435 230.682480,102.339134 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M381.823242,74.018066 
	C382.246063,75.778801 383.026703,76.849030 384.873322,77.378220 
	C382.605896,77.737907 380.806732,80.881599 379.146454,78.952507 
	C377.977325,77.594086 379.373505,74.988182 381.823242,74.018066 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M347.903809,80.705841 
	C350.230377,81.215240 352.439392,82.206284 353.286560,79.062759 
	C353.458771,78.423737 354.195251,77.560135 355.117737,78.549950 
	C355.553986,79.018044 356.197174,79.467239 356.318329,80.019035 
	C356.576538,81.195328 355.340637,81.218369 354.727325,81.343575 
	C351.451904,82.012283 348.144775,82.525681 344.425232,83.043457 
	C343.877350,82.787682 343.752838,82.581245 343.715942,82.022476 
	C344.213257,81.035751 344.787689,80.608223 345.840698,80.260170 
	C346.688660,80.191750 347.155762,80.295494 347.903809,80.705841 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M222.971527,103.576370 
	C222.664856,103.967003 222.182785,104.015038 221.338852,104.023766 
	C221.478073,101.887428 219.590164,98.704765 223.544373,98.181900 
	C224.774429,98.019249 226.402252,97.460365 226.952423,99.112679 
	C227.454468,100.620445 225.734161,100.736603 224.907990,101.396263 
	C224.179092,101.978264 222.965805,102.009979 222.971527,103.576370 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M670.935608,65.452545 
	C676.880554,65.557457 682.812683,66.130302 688.768555,68.148598 
	C686.542297,68.440277 684.130371,68.558311 681.327881,68.206093 
	C680.934875,67.981949 681.016968,67.963928 681.031250,68.003433 
	C677.943604,66.789047 674.678345,67.905533 671.230774,67.059502 
	C670.941895,66.390488 670.947998,66.049179 670.935608,65.452545 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M236.623444,93.599358 
	C235.503860,94.009850 234.394012,93.921768 234.024445,95.611801 
	C230.768921,97.252075 232.004562,94.564400 231.941071,93.451401 
	C231.867493,92.161430 231.009094,90.130699 232.984024,89.758446 
	C235.325195,89.317154 236.394470,91.045982 236.623444,93.599358 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M317.486084,85.715363 
	C316.873291,84.745026 317.528259,83.603485 316.371185,82.523705 
	C317.949249,82.595459 319.870789,79.361015 321.807434,82.723053 
	C322.409424,83.367668 322.543457,83.842209 322.277679,84.707474 
	C320.671722,85.264168 319.257965,85.488747 317.486084,85.715363 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M670.549072,66.745102 
	C674.146790,66.938843 677.357727,67.145905 680.807129,67.697952 
	C675.626892,68.001503 670.208191,67.960060 664.335449,67.766464 
	C663.773560,67.286636 663.784851,66.963127 663.930908,66.397888 
	C666.018433,66.354141 668.090393,66.556282 670.549072,66.745102 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M269.281189,92.449585 
	C268.482910,92.858612 267.912292,92.946548 267.084869,93.170303 
	C261.002869,93.192421 266.480988,89.853264 265.702026,88.160713 
	C266.940918,88.439682 266.845001,90.119659 268.658997,89.999237 
	C269.607605,90.580688 269.725891,91.314575 269.281189,92.449585 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M283.324005,90.080246 
	C282.798218,89.732925 282.658997,89.556931 282.500549,89.200027 
	C280.737518,87.917511 281.728973,86.910439 282.940399,85.733475 
	C285.138763,85.398865 285.484222,87.798561 287.492249,87.966660 
	C287.778381,91.353661 285.170837,89.755264 283.324005,90.080246 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M344.031006,81.733719 
	C344.019531,82.059875 343.967560,82.526184 343.984711,82.760155 
	C342.067291,84.251610 339.987000,84.331703 337.290955,83.591034 
	C340.518951,82.645164 340.777618,79.908035 342.757812,77.622223 
	C344.189209,78.781082 344.237396,80.082352 344.031006,81.733719 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M348.138092,80.523575 
	C347.692230,80.934158 347.172180,80.972908 346.262085,80.976074 
	C344.493042,80.148384 344.235596,78.576958 343.193909,77.176575 
	C342.976318,76.953835 342.980408,77.019737 343.013367,77.021225 
	C342.600037,76.716629 342.154907,76.408867 341.542175,75.728600 
	C341.283966,74.809448 341.340576,74.276611 341.820007,73.460144 
	C344.872589,74.819878 347.824890,76.327850 348.138092,80.523575 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M413.460083,72.240059 
	C414.596741,73.209808 415.878723,74.544891 413.390991,74.713654 
	C410.730774,74.894135 407.976074,75.789261 405.145691,74.050835 
	C407.569977,72.561089 410.713745,74.528023 413.460083,72.240059 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M341.910889,72.927994 
	C342.039001,73.776451 341.980957,74.391853 341.960327,75.470009 
	C342.127869,76.117867 342.257996,76.302956 342.197815,76.769043 
	C342.007477,77.050034 342.000885,76.999443 342.025696,77.003799 
	C340.372467,76.724159 337.961884,77.212364 338.231293,74.437515 
	C338.416534,72.529678 339.645599,71.443642 341.910889,72.927994 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M310.837463,82.022652 
	C313.235992,81.754532 313.856995,83.288933 313.818146,85.001305 
	C313.784027,86.506172 312.226135,86.713615 311.214569,86.507195 
	C308.861786,86.027069 311.068939,84.011391 310.261536,82.546837 
	C310.286804,82.159592 310.674835,82.129524 310.837463,82.022652 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M323.167877,100.113937 
	C320.444397,102.053490 316.630402,101.518890 313.122437,102.787918 
	C315.322510,98.392769 319.183929,99.797768 323.167877,100.113937 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M513.737366,65.084290 
	C513.420166,64.991531 513.110962,65.102303 512.952759,65.058014 
	C512.859558,62.415470 514.416931,61.280529 516.656067,62.095528 
	C519.370544,63.083534 516.461548,64.283867 516.244019,65.714172 
	C515.838257,65.946472 515.622192,65.890030 515.107544,65.985352 
	C514.808899,66.137115 514.873840,66.045547 514.919373,66.078339 
	C514.732056,65.730957 514.428711,65.419533 513.737366,65.084290 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M498.338959,68.017067 
	C497.631683,66.927643 497.265472,65.850647 496.960693,64.429558 
	C497.444641,64.131821 497.867126,64.178169 498.606018,64.271500 
	C499.553619,67.357780 502.469879,64.546394 503.657837,66.172066 
	C503.362732,67.542786 502.044800,66.904343 501.001465,67.598007 
	C500.035553,67.893021 499.357788,67.961258 498.338959,68.017067 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M389.095154,75.000427 
	C390.802643,74.491142 392.551453,73.640625 392.888947,75.910431 
	C393.096252,77.304718 391.521088,76.940720 390.645691,77.048889 
	C389.272461,77.218590 387.225006,77.892639 389.095154,75.000427 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M218.837479,115.879105 
	C217.839951,117.421043 216.119781,117.434212 214.192627,117.420898 
	C214.614838,114.171158 215.798859,112.599670 218.837479,115.879105 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M595.601074,60.064968 
	C594.215149,59.946472 592.894348,60.610947 592.330017,59.166706 
	C592.050598,58.451626 592.587402,57.934299 593.175781,57.654808 
	C594.740112,56.911690 596.145081,57.726910 597.052246,58.716599 
	C597.958008,59.704735 596.656860,59.842319 595.601074,60.064968 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M521.514893,56.578918 
	C524.077698,55.872684 527.151611,56.122189 530.431641,55.063248 
	C528.564270,59.173229 524.850464,56.066265 521.514893,56.578918 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M494.617432,64.021767 
	C494.113007,67.576096 493.685303,67.756706 491.026001,65.342957 
	C491.813049,63.857410 493.000824,63.808659 494.617432,64.021767 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M330.673309,80.709717 
	C330.487396,81.158852 330.209747,81.178207 329.729553,81.097450 
	C328.291962,81.179527 328.654633,80.143951 328.190674,79.249825 
	C327.952423,78.957397 328.010529,78.962021 328.010986,78.990753 
	C328.577667,78.020416 328.574310,75.959869 330.154358,76.558708 
	C331.792358,77.179543 330.798157,78.990448 330.673309,80.709717 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M282.843231,85.529663 
	C283.018494,86.522064 282.745056,87.475220 282.466492,88.731667 
	C281.994598,89.002785 281.403900,89.139877 281.084778,88.906151 
	C280.188416,88.249603 278.508240,89.578758 278.208191,87.964394 
	C277.922882,86.429268 280.227844,87.259949 280.536896,85.692184 
	C281.199371,85.434059 281.796967,85.462234 282.843231,85.529663 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M491.964172,70.517838 
	C493.707245,70.419640 495.076599,68.422226 497.196259,69.725266 
	C496.488739,72.233025 494.349792,71.259766 492.371338,71.763153 
	C491.961914,71.431061 491.952209,71.099037 491.964172,70.517838 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M424.117157,72.738228 
	C423.013855,72.806572 421.214905,73.974640 421.716919,71.232758 
	C422.974182,70.219627 424.187164,69.900352 425.691620,70.786507 
	C426.075348,71.242569 426.272614,71.434753 426.061340,71.688202 
	C425.182556,71.999062 424.712311,72.248665 424.117157,72.738228 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M322.484955,85.041298 
	C322.092010,84.576653 322.098511,84.113716 322.086487,83.301254 
	C323.106567,82.660904 324.145233,82.370094 325.505707,82.021515 
	C325.869751,82.712173 325.911957,83.460609 326.014832,84.578636 
	C325.011749,84.979828 323.948090,85.011421 322.484955,85.041298 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M401.516388,74.091774 
	C402.487640,76.072105 401.201569,76.619904 399.321106,77.053963 
	C397.235107,74.312454 399.278839,74.260582 401.516388,74.091774 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M520.688782,56.153862 
	C521.086182,56.224171 521.091187,56.529121 521.076233,56.680870 
	C519.266602,57.228661 517.471863,57.624706 515.289307,57.933670 
	C514.901367,57.846592 514.957397,57.445580 514.977905,57.244167 
	C516.614441,55.904518 518.492432,56.212242 520.688782,56.153862 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M254.103394,91.356216 
	C256.243042,91.241814 255.923782,92.770477 255.993256,94.423836 
	C251.876404,96.022057 253.703339,93.331482 254.103394,91.356216 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M645.771118,72.745377 
	C644.622009,74.482201 642.886902,73.396255 641.119690,73.462784 
	C642.177612,71.453697 643.832092,71.840263 645.771118,72.745377 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M383.275208,82.865784 
	C381.478455,85.078377 379.286133,85.283836 376.275879,84.722153 
	C378.472931,83.918480 380.125763,83.313889 382.082001,82.516830 
	C382.672516,82.360458 382.959625,82.396561 383.275208,82.865784 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M59.645084,151.972565 
	C58.846691,153.475021 56.887730,152.779099 55.161560,153.707550 
	C55.132633,150.244415 57.270248,151.239975 59.645084,151.972565 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M293.550049,87.945572 
	C292.818329,89.394142 291.439636,89.550858 290.360260,88.756149 
	C289.602295,88.198090 290.931458,87.496071 291.199310,86.425842 
	C292.491455,86.079361 292.986206,86.870842 293.550049,87.945572 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M507.422974,63.648819 
	C506.228485,65.534874 509.516113,65.839218 508.487183,66.728241 
	C507.419830,67.650475 506.116119,66.785797 505.152710,65.294304 
	C505.504913,64.088760 505.570435,62.523697 507.422974,63.648819 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M348.877258,97.195801 
	C348.029633,98.193947 346.957794,98.467545 345.390930,98.214714 
	C345.595428,95.491104 346.974670,95.505424 348.877258,97.195801 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M305.631653,82.992538 
	C305.724243,83.681984 305.158966,84.356697 305.289825,84.844803 
	C305.569977,85.889885 307.511719,87.327576 304.905273,87.519821 
	C302.660248,87.685402 304.754669,85.514442 303.821198,84.336296 
	C303.941376,83.210442 304.486908,82.862068 305.631653,82.992538 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M681.247131,68.229172 
	C683.317200,68.083015 685.699585,68.184074 688.517090,68.395042 
	C688.952332,68.504944 688.950928,68.452034 688.936462,68.429932 
	C686.474854,69.191841 684.017578,68.879807 681.247131,68.229172 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M389.523560,62.311825 
	C389.115814,61.444313 389.174194,60.792885 389.811340,60.511444 
	C390.038879,60.410927 390.731171,60.786430 390.828308,61.073997 
	C391.125824,61.955261 390.796234,62.561131 389.523560,62.311825 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M631.147949,61.358940 
	C631.634216,60.008427 632.533325,59.780319 633.843628,60.813675 
	C633.287842,62.038166 632.328491,61.832336 631.147949,61.358940 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M43.187550,157.588806 
	C42.951824,157.861252 42.655773,158.057495 42.488579,158.117386 
	C42.013813,158.271408 41.706242,158.365524 41.127468,158.060608 
	C41.198643,156.750381 40.603687,155.034500 42.821571,155.801636 
	C43.347500,156.386612 43.488571,156.817719 43.187550,157.588806 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M444.887512,85.081848 
	C444.200958,86.237404 443.001740,87.084656 441.103577,86.428543 
	C441.765656,84.789352 443.154938,85.017044 444.887512,85.081848 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M478.200317,65.033249 
	C479.303406,65.776955 479.366913,66.565475 478.431366,66.998650 
	C477.590088,67.388184 476.798767,66.963715 476.580109,66.011116 
	C476.345825,64.990471 477.302429,65.216675 478.200317,65.033249 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M484.378967,65.600677 
	C484.301270,67.052139 484.089050,68.125969 483.905457,69.616661 
	C483.747101,70.028801 483.560181,70.024086 483.100220,69.954819 
	C482.679291,68.691200 482.561859,67.487404 482.376740,66.294121 
	C482.061829,64.264183 483.214783,64.867668 484.378967,65.600677 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M489.640808,64.946320 
	C489.630585,66.624641 489.052429,67.882675 486.946991,66.346619 
	C487.320831,64.883408 488.307434,64.897911 489.640808,64.946320 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M419.587341,72.032288 
	C419.269958,74.582993 418.281036,74.683891 416.986816,72.229736 
	C417.736755,71.878448 418.486511,71.883537 419.587341,72.032288 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M668.883911,72.896042 
	C668.268555,74.006966 667.360413,74.085899 666.153198,73.362701 
	C666.667664,71.979439 667.583923,71.780334 668.883911,72.896042 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M275.768158,107.067337 
	C274.767059,109.125412 272.599121,108.025299 270.367584,108.273209 
	C271.436554,106.267899 273.510895,107.225746 275.768158,107.067337 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M269.167572,108.103058 
	C268.614197,109.581886 267.001892,108.822571 265.389343,109.218826 
	C265.444916,105.839378 267.444794,108.118195 269.167572,108.103058 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M382.609192,82.573463 
	C383.052612,81.879387 382.908417,80.074989 384.228607,80.918640 
	C384.921143,81.361206 384.244049,82.365356 383.559174,83.168472 
	C383.146790,83.140137 382.989868,82.981354 382.609192,82.573463 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M40.547409,157.705994 
	C41.092804,157.768707 41.329334,157.875854 41.943626,158.080139 
	C41.827534,159.380493 40.957214,160.000992 39.284042,159.893723 
	C38.953091,159.438110 38.968899,159.004272 38.993633,158.243866 
	C39.414555,157.861679 39.826553,157.806046 40.547409,157.705994 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M465.428101,68.929161 
	C465.659760,68.076355 465.968353,67.422096 466.708069,67.745743 
	C466.932648,67.844025 467.062866,68.637665 466.923309,68.988213 
	C466.636658,69.708328 466.062012,69.811409 465.428101,68.929161 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M650.813171,65.773666 
	C649.933105,65.954720 648.761658,66.010391 647.169678,65.925758 
	C648.006714,65.739731 649.264221,65.694008 650.813171,65.773666 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M648.325806,62.018841 
	C648.098206,61.261757 648.175598,60.497017 648.999451,60.499866 
	C649.309631,60.500938 649.617737,61.098217 649.962158,61.717472 
	C649.548645,62.049984 649.099731,62.088718 648.325806,62.018841 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M649.937134,72.970314 
	C649.567322,73.880348 648.971313,74.017014 648.114868,73.325203 
	C648.427185,72.324852 648.994629,71.983376 649.937134,72.970314 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M653.900513,72.872040 
	C653.547241,73.747520 652.983276,73.987976 652.138672,73.199142 
	C652.475098,72.268959 653.031433,72.000122 653.900513,72.872040 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M263.863403,109.076096 
	C263.644409,110.101830 262.524963,109.802368 261.357727,110.062195 
	C261.634827,109.043472 262.551697,108.983078 263.863403,109.076096 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M373.240082,85.342079 
	C373.728088,85.384338 374.039398,85.514481 374.350708,85.644623 
	C373.921600,85.573067 373.492493,85.501511 373.240082,85.342079 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M447.813416,85.067390 
	C447.712158,85.989090 447.068176,86.389137 445.933105,85.374321 
	C446.294220,85.083565 446.847046,85.062004 447.813416,85.067390 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M682.847412,72.710213 
	C682.551758,72.948502 682.109924,72.973640 681.338257,72.954788 
	C681.443298,72.243584 681.977844,71.984200 682.847412,72.710213 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M291.727692,83.361832 
	C291.978760,83.376541 292.115662,83.510353 292.252563,83.644180 
	C292.039551,83.589767 291.826538,83.535355 291.727692,83.361832 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M550.710327,54.322517 
	C551.224609,53.911854 551.770569,53.499306 552.658264,53.043430 
	C552.557373,53.375137 552.114746,53.750164 551.231750,54.242916 
	C550.791382,54.360641 550.742004,54.320629 550.710327,54.322517 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M691.337952,68.541855 
	C691.215881,68.191750 691.314209,67.925156 691.412476,67.658585 
	C691.569031,67.835228 691.725586,68.011856 691.951660,68.362434 
	C692.021179,68.536392 691.558350,68.625359 691.337952,68.541855 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M425.924927,71.804291 
	C425.652802,71.749458 425.744476,71.392616 425.811279,71.221497 
	C426.272614,71.163467 426.667114,71.276558 427.061615,71.389648 
	C426.773438,71.546143 426.485260,71.702629 425.924927,71.804291 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M44.923786,157.539368 
	C44.785751,157.958084 44.645454,158.059570 44.265549,158.060806 
	C43.622768,157.599854 43.465542,157.152603 43.774750,156.314377 
	C43.995766,156.009796 44.467205,155.967224 44.703266,155.959946 
	C44.933392,156.375809 44.927456,156.798965 44.923786,157.539368 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M43.746738,156.005646 
	C43.998699,156.443542 44.001629,156.877274 44.015255,157.635773 
	C43.845737,157.960678 43.665531,157.960831 43.218575,157.911102 
	C42.966930,157.453094 42.982037,157.044952 42.998596,156.329926 
	C43.000053,156.023056 43.497711,156.001495 43.746738,156.005646 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M45.997482,155.725983 
	C45.850231,155.967407 45.671421,155.971329 45.224586,155.957397 
	C45.139202,155.536423 45.321838,155.133301 45.504475,154.730179 
	C45.658295,154.982941 45.812111,155.235718 45.997482,155.725983 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M510.465546,62.455208 
	C510.520813,62.423275 510.410278,62.487137 510.465546,62.455208 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M351.317993,97.167816 
	C351.286896,97.420753 350.975769,97.670151 350.374298,97.804749 
	C350.401947,97.514725 350.719940,97.339508 351.317993,97.167816 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M210.651779,117.971970 
	C210.744919,118.209389 210.709244,118.436157 210.673569,118.662933 
	C210.512955,118.584343 210.352325,118.505760 210.229660,118.174026 
	C210.267609,117.920876 210.522964,117.961319 210.651779,117.971970 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M284.379120,105.280701 
	C284.401215,105.615189 284.053619,105.956741 283.317688,106.266464 
	C283.289337,105.919006 283.649414,105.603394 284.379120,105.280701 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M287.085999,105.181511 
	C287.256531,106.063583 286.553192,106.079254 285.540527,105.545029 
	C285.707428,105.212418 286.101013,105.184059 287.085999,105.181511 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M498.996338,70.002808 
	C499.110291,70.140610 499.227875,70.275612 499.345490,70.410614 
	C499.264832,70.361198 499.184204,70.311775 499.054626,70.127487 
	C499.005646,69.992615 499.000000,70.000000 498.996338,70.002808 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M96.824783,141.194885 
	C96.923065,141.419525 96.728897,141.647690 96.275864,141.928619 
	C96.114494,141.682297 96.286278,141.421326 96.824783,141.194885 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M93.941818,142.723022 
	C94.057442,142.867996 93.581795,143.008926 93.335709,143.031586 
	C93.335144,142.895508 93.580666,142.736771 93.941818,142.723022 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M899.456787,936.656128 
	C898.779053,958.059326 898.365051,979.049438 897.897949,1000.502441 
	C895.138855,1000.347351 896.116699,998.144348 896.027283,996.509705 
	C895.722168,990.932800 896.667053,985.282288 894.977051,979.359863 
	C893.162537,976.989685 893.628906,974.565186 893.588501,972.278687 
	C893.397888,961.473022 893.888062,950.661499 893.154785,939.465942 
	C892.677673,938.619446 892.335266,938.191284 891.727539,937.474426 
	C890.836121,935.964294 890.644592,934.641907 890.574036,933.320862 
	C890.371582,929.527893 887.743042,929.446167 884.923279,929.450073 
	C881.922546,929.454224 881.414490,931.322571 881.433777,933.735046 
	C881.451050,935.889282 881.418396,938.044128 881.422791,940.566101 
	C881.417542,941.179443 881.409241,941.425415 881.367798,942.040405 
	C881.267395,942.900696 881.162964,943.383850 880.881714,944.202515 
	C880.598389,944.746887 880.455078,944.947693 879.998474,945.343750 
	C879.206360,945.671448 878.722534,945.686829 877.914062,945.424744 
	C876.509460,940.533569 877.181396,935.753967 877.168518,931.011414 
	C877.141846,921.216309 877.367126,922.736511 868.330200,921.702332 
	C867.611450,921.106812 867.519104,920.607361 867.816284,919.728271 
	C869.354492,918.413513 869.542419,917.022156 869.547607,915.477600 
	C869.562622,911.046631 869.595032,906.615967 869.532104,902.185120 
	C869.508301,900.507935 869.539429,898.795715 866.925842,898.334229 
	C859.858337,898.344177 853.177856,898.586853 846.074097,898.211426 
	C843.642456,896.691223 839.535095,899.154907 839.491577,894.415771 
	C844.762634,892.980469 849.752197,893.699219 854.703674,893.608215 
	C861.815796,893.477417 868.942810,893.805420 876.432617,892.576233 
	C878.802551,892.634399 880.726807,892.518372 883.034912,892.144531 
	C884.733765,892.316101 886.002930,892.694092 887.721619,892.673584 
	C889.470520,892.769043 890.742981,893.157471 892.343140,893.885376 
	C894.940979,895.513550 898.213867,896.183472 896.834167,900.269104 
	C895.608093,900.650635 894.838562,900.365601 893.994080,900.026306 
	C896.014771,900.913818 897.117676,902.381409 896.969177,904.596436 
	C896.096313,917.618347 895.791748,930.653259 896.594727,943.713867 
	C896.374573,940.076904 896.459167,936.464539 896.326599,932.809631 
	C895.930725,921.891846 896.095215,910.978760 898.244873,900.004517 
	C899.621155,900.382812 900.164062,901.283691 900.171570,902.271851 
	C900.257507,913.598145 901.265198,924.938782 899.456787,936.656128 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M732.173462,918.661255 
	C731.425476,921.118835 730.509033,922.938843 728.119141,924.079590 
	C721.097778,923.312622 717.424438,926.177612 717.376770,932.291382 
	C717.354675,935.123657 717.460693,937.959229 717.321289,940.787415 
	C717.233215,942.574463 717.385010,944.564941 714.750732,945.328674 
	C711.406250,940.902649 712.306213,935.787415 711.617432,930.985901 
	C711.176880,927.914673 712.346985,924.655518 710.357117,921.331299 
	C708.906006,913.780945 709.176819,906.616394 710.123169,899.052612 
	C710.472168,898.439575 710.647766,898.220886 711.175049,897.799194 
	C711.785767,897.568604 712.044800,897.541077 712.666870,897.624023 
	C715.243103,902.809326 716.651062,898.207458 718.708313,897.137634 
	C722.480591,896.335144 725.925659,896.564697 729.755737,896.900696 
	C731.152588,897.325989 731.912781,898.064270 733.123291,898.791016 
	C734.576355,899.647278 735.862305,899.736450 737.484375,900.100647 
	C743.141235,901.005188 748.433289,900.496277 754.150757,900.570190 
	C756.677734,902.253906 756.422852,904.319580 755.516968,906.846313 
	C751.417297,909.517456 747.195679,908.418884 743.126648,908.457397 
	C734.646179,908.537720 733.259155,908.063477 733.241028,916.537476 
	C733.239624,917.196777 732.852783,917.792236 732.173462,918.661255 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M817.846924,939.991333 
	C819.156738,940.027588 820.171692,940.014648 821.064758,941.226685 
	C822.116638,945.623352 819.314392,949.111938 819.420044,953.470947 
	C819.330322,955.566772 819.485657,957.307800 817.885071,958.872559 
	C810.184570,959.640320 803.004272,957.895935 795.738098,957.984558 
	C794.348206,958.001465 793.096252,957.752319 792.161255,956.066650 
	C797.156494,953.737610 802.607300,954.043457 807.554382,953.400452 
	C800.040588,952.639282 792.165161,951.514221 783.814209,951.296753 
	C782.083313,951.105774 780.852600,950.406677 779.046631,950.452087 
	C778.335266,950.447998 778.047913,950.449768 777.323730,950.461548 
	C763.642090,949.367371 750.329468,949.550476 737.088196,948.377136 
	C735.918152,948.273499 734.770325,948.095764 733.440796,947.099304 
	C733.088257,945.373962 733.061157,943.967773 733.047058,942.034302 
	C733.491760,941.313477 733.945251,941.211243 734.774414,941.183350 
	C735.880676,941.184814 736.624695,941.111816 737.780701,941.041382 
	C751.020874,941.350647 763.833618,942.708862 776.686768,941.621399 
	C778.522217,941.466125 780.269165,942.096863 782.484131,942.491333 
	C791.960938,942.716675 800.947388,943.768555 810.346741,944.129456 
	C811.741943,944.568848 812.810425,944.753479 813.802246,945.206116 
	C813.972229,945.283691 814.210327,945.606079 814.474365,945.303711 
	C814.158203,945.251099 813.908386,945.087219 813.614319,944.493042 
	C813.481567,943.424255 813.771667,942.836487 814.693481,942.219971 
	C815.302979,941.902283 815.567200,941.710022 815.884949,941.214172 
	C816.444824,940.558716 816.883484,940.112915 817.846924,939.991333 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M732.160400,918.992065 
	C731.777710,907.143738 731.777649,907.137756 743.616455,907.050659 
	C747.077637,907.025208 750.539124,907.043945 754.455078,906.948975 
	C755.367737,906.565308 755.866516,906.439514 756.769226,906.623291 
	C758.581848,909.809082 759.422424,913.598633 764.623474,912.555298 
	C773.387329,912.305359 781.722412,912.534241 790.487610,913.527222 
	C792.845398,913.413818 794.724609,913.405396 796.717529,914.844604 
	C797.014893,915.902283 797.010254,916.594238 797.007568,917.632263 
	C795.065735,919.831726 792.759827,919.583069 789.983032,919.060242 
	C788.835999,919.023071 788.121887,919.040039 787.051514,919.083313 
	C782.546509,920.943970 778.158752,920.068970 773.945496,919.832825 
	C769.463440,919.581726 764.992554,919.611206 760.096497,919.489990 
	C757.376831,919.639099 756.038696,917.531067 753.658447,916.908264 
	C753.118835,916.598633 752.918030,916.455261 752.476807,916.039062 
	C750.177551,912.933655 742.783203,910.556702 739.580383,911.577576 
	C737.105774,912.366272 737.537659,914.667725 736.685791,916.715820 
	C735.976746,917.890442 735.243347,918.525574 733.921753,918.960815 
	C733.181030,919.017151 732.809998,919.008484 732.160400,918.992065 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M782.797852,950.177490 
	C792.228882,949.735229 801.240601,951.618408 810.362366,952.052307 
	C811.280579,952.095886 812.653748,951.895569 812.764465,953.199768 
	C812.902466,954.824768 811.443970,954.852844 810.309998,954.896606 
	C804.508484,955.120850 798.705078,955.297180 792.458984,955.587646 
	C791.580750,955.626831 791.145874,955.568604 790.394897,955.613037 
	C788.276978,957.441101 786.502686,955.841431 784.352783,955.477905 
	C782.598328,955.217529 781.207520,955.150208 779.417480,955.219666 
	C778.591797,955.570801 778.138733,955.674805 777.323120,955.585205 
	C774.652405,955.205933 772.321228,954.924438 769.549438,954.684326 
	C761.285522,955.059265 753.451782,955.637695 745.342285,953.485718 
	C742.640747,953.013489 740.320496,952.788086 737.566895,952.626343 
	C735.273499,953.031372 733.416809,953.252930 731.277161,952.278076 
	C730.870850,951.290649 730.773193,950.562317 730.768066,949.478027 
	C735.650146,946.501831 740.606201,948.737915 745.435669,948.843811 
	C754.373596,949.040039 763.343933,949.222534 772.240295,950.454773 
	C773.831177,950.675171 775.575562,950.828979 777.476624,949.656006 
	C778.045105,949.349792 778.252380,949.298035 778.779907,949.234497 
	C780.044861,950.208618 781.093018,950.885071 782.797852,950.177490 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M866.944275,897.209778 
	C869.411560,896.688354 870.906006,897.431274 870.950378,899.472473 
	C871.086731,905.758484 870.991577,912.050232 870.934753,918.339233 
	C870.923401,919.590332 869.951782,919.915955 868.459717,919.959229 
	C865.462524,916.912109 866.862122,913.278992 866.549316,909.915405 
	C866.381592,908.111572 866.545044,906.279907 866.497681,904.848328 
	C866.127808,909.989685 867.153748,915.556885 865.638672,921.353821 
	C864.305237,921.777588 863.189148,921.895996 861.652771,922.048462 
	C859.365234,920.163269 862.082458,916.976807 859.042847,915.109863 
	C857.859558,914.335876 857.265625,913.553711 857.008423,912.132080 
	C856.838806,910.766907 856.657837,909.790161 856.517517,908.806274 
	C856.183960,906.467224 857.681335,903.202454 854.866760,902.049255 
	C851.662659,900.736450 847.968689,901.178467 844.552551,901.858521 
	C842.194763,902.327881 842.587585,904.616333 842.485901,906.384277 
	C842.366516,908.462341 843.506714,909.382935 845.505737,909.464661 
	C847.661926,909.552734 849.839478,909.325500 851.969482,909.637085 
	C853.612610,909.877380 855.850891,909.459961 855.699158,912.441956 
	C850.572632,914.347595 845.651733,913.788696 840.796936,913.326111 
	C836.605042,912.926697 836.423584,909.588074 836.486694,905.851135 
	C837.066711,898.110596 837.641418,897.493835 844.595215,897.320679 
	C852.196350,897.424805 859.345886,897.863037 866.944275,897.209778 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M857.481079,911.949890 
	C858.256287,912.882019 858.827026,913.507263 859.660400,914.325195 
	C860.306335,914.967224 860.403320,915.472534 859.917114,916.314087 
	C858.287476,917.261475 856.969360,917.286011 855.327271,916.295654 
	C835.917725,915.140259 816.831909,914.969177 797.380127,915.170044 
	C795.270264,915.089539 793.521118,914.968872 791.347412,914.738281 
	C789.597351,913.583557 788.959595,912.360535 790.275940,910.462036 
	C794.656494,908.798523 798.815308,909.502380 802.908386,909.441284 
	C810.658142,909.325745 818.412842,909.307861 826.161377,909.453003 
	C829.609985,909.517639 832.318420,908.722229 834.160767,905.073975 
	C835.342529,904.249146 836.232483,904.172485 837.557129,904.728577 
	C838.270996,912.624512 836.865112,911.998474 845.183716,911.957031 
	C848.457458,911.940735 851.731567,912.015869 855.467041,911.998047 
	C856.325500,911.613098 856.774841,911.511780 857.481079,911.949890 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M832.246216,937.128418 
	C832.531555,936.968445 832.756042,936.597351 832.864014,936.567566 
	C833.220459,935.883850 833.519043,935.245911 833.800049,934.247437 
	C833.991821,933.953613 834.005920,934.004395 833.979614,934.003540 
	C834.213196,933.794495 834.456665,933.568726 834.850586,933.140137 
	C835.017395,932.955078 835.019104,933.017212 834.988159,933.020264 
	C835.116028,932.875793 835.274719,932.728333 835.642456,932.331848 
	C837.092346,932.097229 838.507874,931.737488 838.998352,933.892578 
	C839.270996,934.859070 839.095093,935.405823 838.760559,936.212463 
	C838.426941,937.014587 838.248108,937.563293 838.146790,938.444092 
	C838.080688,939.163269 838.023438,939.577576 837.881470,940.311401 
	C836.590942,943.293945 836.089172,946.263672 834.052002,948.871155 
	C829.124512,952.376404 827.380188,957.649170 830.137939,960.820190 
	C826.590088,961.307739 823.299866,961.032898 819.647705,960.046875 
	C817.771545,958.355164 818.833435,956.333496 818.520996,954.085693 
	C819.679626,949.584534 819.942749,945.203186 822.729675,941.252197 
	C822.985779,940.944275 823.002136,941.001160 822.972595,940.999512 
	C823.439148,940.594177 823.502136,939.991882 823.824463,939.188232 
	C823.988342,938.943115 824.003052,939.002014 823.972717,939.001953 
	C824.796326,938.347351 825.204529,937.396362 825.806152,936.202698 
	C825.979065,935.946411 825.999756,936.000488 825.970886,935.998047 
	C826.216125,935.784607 826.463623,935.545654 826.856323,935.086060 
	C827.209900,933.101501 828.543762,932.211426 829.974670,932.481018 
	C831.660522,932.798401 830.731750,934.614502 831.020508,936.109985 
	C831.002502,937.117737 830.998718,937.759094 832.246216,937.128418 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M714.642883,945.353516 
	C716.730103,940.404297 715.917908,935.614380 715.755920,930.947510 
	C715.623352,927.127808 716.382568,924.733704 720.468201,923.885925 
	C722.344971,923.496521 724.052795,922.312744 725.851074,921.520508 
	C728.057434,920.548279 727.976685,921.895569 727.747375,923.785400 
	C727.322998,924.698547 726.870300,925.224548 726.189819,925.883423 
	C724.580688,927.757568 725.024475,929.822205 725.016113,931.772217 
	C724.949402,947.363281 725.066040,962.954712 724.887024,979.014465 
	C724.360657,981.091431 723.419495,981.434631 721.703308,980.198364 
	C720.164246,977.533569 720.424255,974.996582 720.416260,972.518311 
	C720.378723,960.866699 720.414612,949.214783 720.385681,937.563171 
	C720.381165,935.752563 720.684326,933.902161 719.783081,931.617310 
	C718.359192,933.357178 718.600159,935.154419 718.629089,936.793335 
	C718.808167,946.933289 718.107300,957.083191 719.406799,967.215393 
	C719.929504,971.291138 720.122314,975.555420 717.574890,979.740723 
	C716.965454,980.198059 716.670532,980.311035 715.899414,980.366333 
	C713.788269,979.306885 713.494385,977.622314 713.455017,975.965942 
	C713.237793,966.831482 713.189575,957.695007 713.479736,948.560486 
	C713.511475,947.560974 713.805603,946.596069 714.642883,945.353516 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M789.952515,994.071533 
	C793.195435,994.380798 795.993469,994.925537 798.792480,994.930359 
	C803.558472,994.938599 803.969055,997.838196 804.015991,1001.574829 
	C804.072754,1006.090271 800.979614,1004.958801 798.499939,1005.028259 
	C793.794678,1005.160095 789.121277,1004.220398 784.843750,1002.675354 
	C780.449463,1001.088135 779.532654,995.697266 774.724792,992.250061 
	C780.926819,992.050232 785.148804,993.621338 789.952515,994.071533 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M824.037537,968.346924 
	C826.709473,963.906433 829.195435,966.868591 831.960144,968.622253 
	C834.857483,970.304749 833.424011,973.376953 834.657776,975.368835 
	C833.814819,974.014099 834.000244,972.884338 835.620850,971.970459 
	C835.973511,972.033020 835.991028,972.002441 835.990723,972.019165 
	C836.158752,972.148315 836.327087,972.260681 836.754883,972.215332 
	C837.048889,971.609375 837.083496,971.161133 837.127686,970.375732 
	C837.599060,969.142639 838.387634,968.808228 839.630981,968.926025 
	C840.791870,973.799683 844.050232,977.211670 846.418396,981.105652 
	C847.356262,982.647766 848.913635,984.425293 847.540222,986.045288 
	C845.988525,987.875549 843.390076,987.418823 841.617615,986.334839 
	C840.046875,985.374268 838.380615,984.777100 836.398682,983.934082 
	C834.983582,982.935364 835.785034,981.539062 835.320129,980.452698 
	C835.123718,979.820801 834.342224,980.695862 834.978088,980.525330 
	C835.357117,980.423767 835.487549,980.764404 835.481873,981.152039 
	C835.469910,981.976501 835.422607,982.757935 834.283203,983.255127 
	C833.519470,983.145020 833.117310,983.046997 832.408447,982.901367 
	C828.582031,978.618713 825.847168,973.942932 824.037537,968.346924 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M819.146606,1001.744141 
	C816.536987,999.930420 815.478455,997.457703 816.384338,995.093018 
	C817.227356,992.892395 819.888367,994.147583 821.753906,993.972839 
	C822.901123,993.865356 824.080322,993.908325 825.228333,994.035767 
	C829.623840,994.523987 834.325745,994.444641 833.261230,1001.334106 
	C832.909729,1003.608887 834.548706,1005.972229 835.844177,1007.957703 
	C831.768433,1007.957703 828.033020,1007.948364 824.297668,1007.960999 
	C821.647949,1007.969971 818.921753,1008.152039 820.594238,1004.004578 
	C820.773315,1003.560547 819.849854,1002.671936 819.146606,1001.744141 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M785.451782,971.097961 
	C788.402832,971.500916 790.990479,971.859497 791.945801,975.213135 
	C787.665771,978.193542 783.043884,976.427917 778.627869,976.072998 
	C770.693237,975.435120 762.707275,975.670593 754.807800,974.563110 
	C753.812256,974.423523 752.817200,974.538635 751.662598,975.489807 
	C750.697998,975.674683 750.033691,975.547180 749.157837,975.142639 
	C748.465271,974.346375 748.099976,973.766113 748.005981,972.703064 
	C748.257019,970.158569 746.546570,969.374512 743.953064,968.024597 
	C747.494141,968.024597 749.862061,968.024597 752.672485,968.043640 
	C755.990906,969.782166 759.286682,969.142700 762.334045,969.377808 
	C769.898071,969.961548 777.456238,970.670166 785.451782,971.097961 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M751.754272,975.883789 
	C751.008240,973.610901 751.836365,972.931519 754.103027,973.106506 
	C766.466187,974.060852 778.840393,974.871399 791.612915,975.637085 
	C793.047729,975.781128 794.080322,976.019409 795.500000,976.348755 
	C798.145325,977.558594 798.061157,978.588928 795.379883,979.419800 
	C791.962769,979.142578 788.935791,978.981445 785.456177,978.876099 
	C783.164978,980.720032 781.456360,979.265503 779.346863,978.536011 
	C770.036987,977.556519 761.091553,976.760864 751.754272,975.883789 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M732.545349,994.461670 
	C733.088501,994.104187 733.324219,994.124329 733.911804,994.190796 
	C734.795227,994.635864 735.391724,995.003052 736.050842,994.920044 
	C743.913086,993.929077 744.284546,994.361572 746.744202,1005.551514 
	C746.980652,1006.289856 747.017029,1006.693237 747.064087,1007.400330 
	C742.535461,1009.518005 737.989136,1008.449768 733.052490,1007.451904 
	C730.893616,1003.113831 731.349060,998.983948 732.545349,994.461670 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M864.012329,931.900330 
	C859.894592,936.342407 857.894226,941.829651 855.406555,946.972595 
	C854.332947,949.192078 854.974792,951.857178 855.932983,954.634888 
	C855.759705,955.197083 855.552429,955.358948 855.049561,955.259644 
	C851.822205,956.951477 850.326843,959.431274 851.505127,963.088379 
	C852.054810,964.794495 852.665344,966.764404 849.331543,966.951660 
	C847.605286,964.387878 847.925171,961.650391 848.030518,958.579285 
	C848.355896,957.251160 848.697937,956.314697 849.013977,954.979980 
	C850.068420,949.147339 851.123352,943.703186 853.453186,938.216919 
	C854.311340,935.432678 856.509216,933.782166 857.038452,930.962158 
	C858.861572,928.926758 860.486816,931.373535 862.675049,931.021851 
	C863.315063,931.274841 863.619385,931.475220 864.012329,931.900330 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M778.765503,959.490234 
	C781.801575,959.866821 784.583313,960.119141 787.715881,960.567017 
	C788.164368,961.058228 788.262146,961.354004 788.094727,962.034912 
	C783.096008,964.499756 778.113037,963.090210 772.808411,963.444031 
	C768.336914,962.689209 764.290222,962.256348 759.762878,962.450073 
	C757.628479,962.483276 755.925232,962.502808 753.830078,962.118164 
	C751.841064,961.508789 750.200745,961.449524 748.143738,961.410156 
	C746.317139,961.435791 744.924683,961.360962 743.323120,960.361206 
	C742.262756,959.938782 741.546936,959.758911 740.462219,959.638916 
	C738.919983,959.981812 737.749390,960.102722 736.271423,959.475830 
	C734.461548,958.661560 732.625122,959.123230 730.049622,956.756958 
	C746.220520,957.724121 761.086243,958.613220 776.409912,959.476318 
	C777.405945,959.231750 777.950928,959.148132 778.765503,959.490234 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M849.223633,957.777832 
	C848.633972,960.849426 850.558228,963.517456 849.016113,966.571228 
	C847.921814,966.900208 846.904541,966.877258 845.505066,966.838684 
	C844.622131,966.527832 844.160583,966.158813 843.296265,965.959839 
	C842.590271,965.892456 842.172974,965.869385 841.444641,965.806763 
	C839.542725,965.055603 838.511719,963.735107 837.297485,962.160339 
	C836.986023,961.595276 836.778564,961.350952 836.269470,961.069702 
	C834.783447,960.157471 835.263428,958.532898 834.185425,957.315063 
	C833.934692,957.108704 833.941711,957.059082 833.916748,957.057129 
	C833.803406,956.780212 833.715027,956.505310 833.767212,955.819702 
	C837.702271,951.705994 846.745911,952.863953 849.223633,957.777832 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M856.516724,930.679199 
	C857.477539,931.091003 859.354675,930.448914 858.236328,932.254822 
	C857.203003,933.923462 856.215149,935.620422 855.075989,937.620361 
	C852.910767,939.227722 850.498047,937.170044 848.155334,938.779602 
	C846.685852,939.236084 845.503784,939.406311 844.019043,939.883667 
	C841.684265,940.303101 839.730042,940.990601 837.438721,940.109314 
	C837.179810,939.466370 837.169922,939.113037 837.129395,938.496277 
	C837.361877,937.687256 837.509766,937.108154 837.767090,936.263611 
	C838.268555,935.605103 838.600586,935.194702 839.002136,934.526123 
	C843.671021,927.934143 850.193237,930.829468 856.516724,930.679199 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M777.421997,949.241089 
	C778.263184,952.238159 776.476440,952.228821 774.472839,952.087219 
	C761.725586,951.185730 748.976624,950.309387 736.227478,949.434753 
	C734.736877,949.332458 733.242065,949.291443 731.304810,949.171997 
	C730.619812,947.840088 730.623291,946.726135 732.769897,946.814758 
	C747.745605,947.546997 762.375793,948.313843 777.421997,949.241089 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M836.978027,940.127136 
	C839.197571,939.446350 841.205383,939.072937 843.607056,938.679077 
	C845.219116,941.048096 848.550781,940.088196 850.042053,942.655273 
	C850.338745,944.457153 849.241577,945.058594 847.868225,945.817627 
	C846.451416,946.237793 845.525757,947.059753 844.306641,946.945679 
	C845.397949,947.159729 846.325684,946.516602 847.718933,946.399902 
	C850.031372,947.201599 850.084290,948.734680 849.497253,950.809814 
	C844.668640,953.851257 839.832397,951.640564 834.676270,951.738037 
	C833.994141,951.546692 833.736816,951.421814 833.470093,950.867920 
	C833.619751,950.152222 833.698853,949.844910 833.725769,949.278320 
	C834.543030,946.096069 834.893555,942.998840 836.978027,940.127136 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M811.489502,984.620361 
	C806.600891,984.199951 805.971252,982.796631 808.606323,978.078491 
	C809.874023,978.235291 810.785339,979.496765 811.579041,978.701294 
	C812.175964,978.102905 810.878113,977.481812 810.314941,976.532715 
	C809.774658,975.435669 809.426575,974.627747 809.030334,973.492310 
	C810.709473,971.522522 812.669312,971.948730 815.089661,972.769897 
	C816.238708,972.994202 816.944519,972.976868 818.002625,972.938110 
	C819.227356,972.947571 819.428772,973.541138 819.515015,974.591309 
	C820.272034,976.771484 820.785950,978.696838 821.817200,980.762329 
	C822.031067,981.013977 821.988464,981.007385 821.994385,980.986694 
	C822.428711,981.431702 822.468262,982.067871 822.936646,982.822754 
	C825.940796,982.691406 824.927673,984.015869 824.090210,985.525818 
	C823.781128,986.218933 823.511169,986.638489 822.870544,987.038391 
	C820.985596,987.207214 820.131592,986.249573 819.046875,985.044434 
	C816.511353,983.494812 814.213135,982.688293 811.489502,984.620361 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M814.532104,942.006104 
	C814.704773,942.537292 814.431519,943.063354 814.052246,943.867310 
	C813.466614,944.517578 812.928223,944.758179 811.884521,944.886597 
	C802.925659,943.946716 794.365784,943.619690 785.377686,942.997681 
	C780.147644,942.455078 775.284424,942.967712 770.273926,941.498657 
	C770.061096,939.977112 769.794800,938.680725 771.616699,938.050415 
	C775.943909,936.853149 779.960144,937.620789 784.386902,937.812378 
	C789.966003,939.428833 795.490723,937.556152 800.972412,939.765564 
	C802.382812,940.260864 803.416809,940.568359 804.748413,940.885986 
	C807.824890,943.182495 811.091248,941.481262 814.532104,942.006104 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M724.432068,980.164062 
	C724.123474,963.213623 724.087219,946.495483 724.075623,929.777405 
	C724.074707,928.492065 723.825500,927.075684 725.570435,926.098999 
	C725.974854,943.696533 725.987732,961.376709 726.022095,979.524658 
	C725.655090,980.311218 725.208008,980.436707 724.432068,980.164062 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M785.419312,939.092896 
	C780.915344,938.751465 776.735413,939.772827 772.338684,938.175537 
	C773.035034,934.852234 775.207397,933.039246 778.524719,932.966064 
	C785.792725,932.805542 793.067200,932.491760 800.552002,933.561401 
	C796.461304,937.133118 791.870056,934.744812 787.383972,934.502686 
	C786.726562,934.469482 787.139771,935.274475 787.148438,934.607849 
	C787.150085,934.480774 787.312256,934.516541 787.641785,934.528381 
	C788.783508,934.569580 790.147217,934.323059 790.336060,935.944214 
	C790.465149,937.052673 789.606140,937.725159 788.689148,938.202698 
	C787.797302,938.667236 786.819397,938.865173 785.419312,939.092896 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M816.712158,1016.401001 
	C831.644226,1017.849304 846.345703,1019.558105 861.047241,1021.266907 
	C860.998596,1021.709656 860.949890,1022.152466 860.901245,1022.595215 
	C846.271912,1022.844604 831.994263,1019.406311 817.265625,1017.415894 
	C816.812683,1016.986084 816.647156,1016.823730 816.712158,1016.401001 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M877.549561,945.666504 
	C877.921570,945.210449 878.240906,945.135986 878.798279,945.013733 
	C881.755310,950.493286 879.976685,956.360840 880.467896,962.517578 
	C880.241577,975.755249 880.696533,988.513733 880.298584,1001.740356 
	C879.851807,1003.152649 879.365112,1003.954407 877.899902,1003.996338 
	C877.491638,984.532104 877.498535,965.308228 877.549561,945.666504 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M769.539185,941.238770 
	C774.592468,942.421387 779.333740,941.476990 784.426270,942.117432 
	C785.382385,943.575317 784.236145,943.347961 783.220581,943.631592 
	C767.593079,943.054504 752.268494,942.394226 736.481812,941.806152 
	C735.828491,942.043091 735.637329,942.207886 735.201538,942.083740 
	C734.541626,941.670227 734.126343,941.545715 733.385498,941.463989 
	C733.589417,938.636108 735.944153,939.860291 737.357422,939.907349 
	C747.935669,940.259888 758.506470,940.835999 769.539185,941.238770 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M723.992981,980.144775 
	C724.573181,979.958313 724.992920,979.984863 725.728149,980.001953 
	C730.781860,980.222046 732.084290,983.204346 732.100952,987.370056 
	C732.108887,989.347778 732.428528,991.324280 732.729858,993.692688 
	C732.849121,998.074219 732.845459,1002.064392 732.951782,1006.503967 
	C732.573425,1007.328125 732.028687,1007.450500 731.064697,1007.079590 
	C729.198303,1004.782410 729.648499,1002.383545 729.520813,1000.083923 
	C729.355286,997.103149 729.655823,994.131470 729.116211,991.130127 
	C727.932617,984.546631 728.203552,984.369263 721.266418,984.446228 
	C719.461914,984.466309 717.566895,984.502686 715.781006,982.857178 
	C715.348633,981.929932 715.333923,981.355774 715.729248,980.410889 
	C715.972290,980.044617 716.402649,979.876709 716.631348,979.844360 
	C718.238892,978.886047 719.665527,978.638245 721.516907,979.808228 
	C722.512634,980.244263 723.093262,980.928894 723.992981,980.144775 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M785.313965,939.421143 
	C785.771545,938.567078 786.454590,937.701294 787.322815,937.431641 
	C791.485901,936.138855 788.628113,935.296997 786.183777,933.956970 
	C791.413574,933.956970 795.650513,933.956970 800.332397,933.931152 
	C800.901123,935.639771 801.024902,937.374268 801.248779,939.531006 
	C796.095276,940.573730 790.862244,940.000916 785.313965,939.421143 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M733.881592,919.343201 
	C733.950928,918.206909 734.183167,917.258301 735.519897,916.800171 
	C741.168091,914.610535 746.552795,913.389709 752.532715,915.795959 
	C752.884705,916.104248 752.995728,916.009277 752.945801,916.062744 
	C753.832825,917.014587 753.974060,918.061096 753.183167,919.538635 
	C746.664795,919.787170 740.438049,919.723877 733.881592,919.343201 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M865.733032,921.687866 
	C865.359070,915.372437 865.277954,909.085754 865.252258,902.798950 
	C865.247742,901.705505 864.981079,899.982361 866.468994,899.991577 
	C868.369812,900.003357 867.854736,901.923584 867.875610,903.113342 
	C867.968689,908.412537 867.951111,913.713562 868.007080,919.475952 
	C868.004089,920.300720 867.967468,920.663574 867.918579,921.297852 
	C867.285767,921.618347 866.665161,921.667480 865.733032,921.687866 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M753.101685,920.070557 
	C752.909241,918.854614 752.926819,917.858826 752.920166,916.489624 
	C754.820984,916.054688 756.906067,915.555481 758.000610,918.303467 
	C757.819275,919.642151 756.867554,919.427063 755.866821,919.902222 
	C753.213684,926.304443 750.909546,932.532593 748.605408,938.760681 
	C748.156494,938.596985 747.707581,938.433289 747.258728,938.269592 
	C746.861328,931.549683 751.148499,926.239807 753.101685,920.070557 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M877.333496,1004.197754 
	C877.932495,1003.569153 878.380310,1003.382324 879.004700,1003.011963 
	C883.153809,1000.512878 886.713196,1002.355225 890.589111,1004.203979 
	C891.783875,1006.812561 889.714783,1006.708069 888.534790,1007.294128 
	C885.473572,1008.814331 882.076050,1009.774658 879.550232,1012.881836 
	C878.844604,1013.446167 878.358643,1013.582275 877.470154,1013.431152 
	C877.109131,1013.291260 877.023560,1013.086243 876.988220,1012.980957 
	C877.029297,1010.130310 877.105774,1007.384949 877.333496,1004.197754 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M744.907654,953.538269 
	C752.774841,953.587952 760.588623,953.937073 768.755615,954.505981 
	C767.984558,956.482483 766.188965,955.969971 764.605164,955.981323 
	C758.322693,956.026367 752.037598,955.902466 745.757996,956.043213 
	C742.950623,956.106201 744.382935,954.880737 744.907654,953.538269 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M771.762390,962.222107 
	C777.025024,961.946106 782.056458,962.018616 787.551392,962.016663 
	C788.498108,961.599976 789.028137,961.495972 789.811157,961.996643 
	C790.104126,965.118958 788.198730,965.015747 786.295288,965.001648 
	C781.821411,964.968445 777.347168,964.976135 772.401184,964.944458 
	C771.356262,964.212463 771.231140,963.427490 771.762390,962.222107 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M846.720337,1000.677185 
	C846.491394,1003.671814 848.558716,1008.142700 845.497498,1008.403442 
	C842.119019,1008.691101 843.043335,1003.763855 842.204651,1001.138489 
	C841.735107,999.668762 841.036011,996.957214 843.214294,996.362305 
	C846.025024,995.594727 845.773193,998.654968 846.720337,1000.677185 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M823.683105,968.246948 
	C827.199768,972.388000 829.906128,977.089111 832.030945,982.507019 
	C827.564087,981.575317 823.897583,975.496094 823.683105,968.246948 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M859.859558,915.775757 
	C859.964172,915.273010 859.938171,915.056702 859.928650,914.677795 
	C863.505676,916.145630 861.645386,918.878357 861.266479,921.692993 
	C855.578857,923.805237 849.984314,922.785095 843.022583,922.323242 
	C845.710999,920.118774 847.502930,920.998047 849.084595,920.873718 
	C850.712341,920.745789 852.356995,920.832336 854.445435,920.776123 
	C855.915527,919.906555 857.355774,919.903015 858.443237,918.674072 
	C858.695068,917.970825 858.842285,917.567261 859.175659,916.888672 
	C859.460693,916.424927 859.583740,916.244873 859.859558,915.775757 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M785.509521,970.870605 
	C781.195618,973.035461 776.518311,970.876953 771.884949,970.721558 
	C766.807983,970.551208 761.692444,970.031921 756.574951,969.961975 
	C755.373413,969.945557 754.263794,969.755798 753.290527,968.401672 
	C763.791931,968.938660 774.468689,969.814636 785.509521,970.870605 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M756.029175,920.113525 
	C756.120239,919.650208 756.722595,919.223999 757.697327,918.724243 
	C767.316650,918.764160 776.563538,918.877563 786.252930,919.050293 
	C786.682190,922.065552 784.440430,920.874878 783.116943,920.851440 
	C774.256775,920.694702 765.398987,920.400269 756.029175,920.113525 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M874.982544,954.780151 
	C875.413025,955.211487 875.612976,955.458435 875.812866,955.705444 
	C870.394104,958.537720 874.958313,962.704651 874.456421,966.195618 
	C874.347900,966.950500 874.815430,967.788269 874.115906,968.468933 
	C870.870544,966.114990 869.410889,959.497742 871.533813,955.052368 
	C872.848022,955.043640 873.749756,954.278687 874.982544,954.780151 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M807.992920,1006.014954 
	C803.950745,1002.888977 808.438049,999.775269 807.540710,996.570007 
	C810.425293,999.252258 810.712891,1003.410461 813.688477,1005.990356 
	C811.692200,1007.637756 810.053711,1005.663208 807.992920,1006.014954 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M815.364014,972.618164 
	C813.657288,973.035522 811.781555,973.059387 809.443970,973.124023 
	C807.278076,973.177246 805.574097,973.189636 803.448853,973.262695 
	C802.476624,973.679565 801.953186,974.071350 801.254517,974.765625 
	C801.006653,975.742432 800.986145,976.483521 800.976196,977.595337 
	C798.116211,977.289551 797.923950,974.906189 797.826660,972.315308 
	C798.843506,971.748962 799.613647,971.487000 800.702637,971.179138 
	C801.950989,970.157715 803.033813,969.955261 804.631958,970.739624 
	C808.362183,971.704407 812.041321,969.797363 815.364014,972.618164 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M771.613037,961.698242 
	C771.987061,962.637085 771.980530,963.400452 771.951660,964.542725 
	C767.974792,964.015320 763.961426,963.859253 759.474976,963.974609 
	C758.392395,963.332947 758.282410,962.579407 758.754761,961.416260 
	C763.068787,961.231384 767.150635,961.377136 771.613037,961.698242 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M746.956421,1005.480225 
	C746.667786,1005.503113 746.223450,1005.153076 746.140015,1004.731567 
	C744.962524,998.784973 742.637634,994.315369 735.301758,995.911438 
	C735.053772,995.965454 734.651062,995.308411 734.291992,994.609985 
	C734.913269,994.145935 735.562927,994.054688 736.541870,993.942993 
	C737.089172,993.760254 737.307068,993.597961 737.873840,993.646606 
	C745.498901,994.659912 746.247070,995.619446 746.956421,1005.480225 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M789.634216,919.438354 
	C791.539612,917.156433 793.952393,918.417969 796.580444,918.043152 
	C797.876221,918.395081 799.159790,917.258118 799.649475,918.321106 
	C800.174316,919.460327 799.268677,921.053955 798.396729,921.137756 
	C795.458923,921.420044 792.244019,922.662781 789.634216,919.438354 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M803.276001,1015.609619 
	C796.329346,1014.896423 789.647278,1013.936951 782.561157,1012.909119 
	C781.991150,1012.673279 781.825134,1012.505859 781.773682,1012.003906 
	C788.733948,1012.566711 795.579712,1013.464172 802.742065,1014.593079 
	C803.219299,1015.004150 803.379944,1015.183716 803.276001,1015.609619 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M797.688965,972.084106 
	C798.856506,973.863647 799.639587,975.716370 800.704712,977.767578 
	C799.839111,980.942993 798.019836,981.948730 795.082642,979.625000 
	C796.038208,978.830566 797.138245,978.381470 795.991638,976.686279 
	C796.258240,974.978760 795.339233,973.090698 797.688965,972.084106 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M803.368896,963.610291 
	C801.513123,963.238464 800.059753,963.092224 798.211182,962.754211 
	C797.584106,962.235657 797.493103,961.876160 797.764099,961.267395 
	C802.253357,961.096130 806.544495,961.092102 810.832275,961.209412 
	C811.825745,961.236572 813.455383,960.703979 813.351501,962.534851 
	C813.332397,962.871521 811.657776,963.114197 810.393250,963.510925 
	C807.977234,964.493835 805.896118,964.805908 803.368896,963.610291 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M837.025513,962.301392 
	C839.048218,962.212036 840.227661,963.423035 841.059326,965.453674 
	C840.214844,966.391296 839.991882,967.325745 839.950684,968.725037 
	C839.189087,969.389709 838.456909,969.683716 837.430969,970.008179 
	C834.964233,967.646790 836.239502,965.162354 837.025513,962.301392 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M854.774231,955.344849 
	C854.956299,955.001038 855.158691,955.003723 855.664062,955.020813 
	C855.998413,959.411987 859.249512,963.347229 857.098450,968.089050 
	C857.163147,963.756409 852.626221,960.529236 854.774231,955.344849 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M805.057739,940.965454 
	C804.875732,936.771484 804.575684,932.596130 806.312744,928.556213 
	C806.706970,932.577209 807.465149,936.594238 805.380005,940.714844 
	C805.046021,940.896057 805.014587,940.990051 805.057739,940.965454 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M731.131897,1007.746094 
	C731.489136,1006.999695 731.938782,1006.997742 732.725098,1006.974548 
	C737.488220,1006.460876 741.735779,1008.634827 746.628906,1007.768921 
	C747.632080,1008.017212 748.189270,1008.330444 748.930420,1008.908691 
	C749.114258,1009.173706 749.031006,1009.110352 749.067505,1009.072876 
	C747.233032,1010.038635 745.303101,1010.249573 742.850098,1009.242188 
	C742.331909,1009.349854 742.135498,1009.463623 741.706665,1009.194702 
	C738.606018,1009.766357 735.623291,1010.722107 732.158875,1009.334229 
	C731.608398,1008.902466 731.416321,1008.696472 731.131897,1007.746094 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M758.570801,960.983887 
	C758.994690,961.806885 759.002441,962.528137 759.016846,963.609253 
	C756.985840,965.354675 754.994873,965.811401 753.058960,963.307739 
	C752.595154,962.437744 752.454834,961.871460 752.801147,960.857788 
	C754.745117,960.608643 756.449829,960.745361 758.570801,960.983887 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M822.672119,940.716309 
	C821.927673,944.797241 820.869507,948.650208 819.570435,952.783447 
	C819.129456,953.212463 818.929382,953.361145 818.428650,953.287598 
	C818.414795,949.269836 819.509827,945.688232 821.120972,941.882446 
	C821.614502,941.198792 821.986450,940.843628 822.672119,940.716309 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M764.428345,1002.144714 
	C764.373291,998.999756 761.013733,996.734863 762.952454,992.638550 
	C764.604919,996.264404 767.267822,998.770630 764.428345,1002.144714 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M863.749268,954.358154 
	C861.919617,947.501160 867.329895,951.779297 868.967529,950.459900 
	C867.935730,952.033569 866.963928,953.651245 865.853027,955.166931 
	C864.976196,956.363220 864.070251,956.745667 863.749268,954.358154 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M809.982056,976.463745 
	C812.240051,976.011047 813.272339,977.617188 815.122681,979.261963 
	C812.683411,979.506592 810.778748,983.490845 809.002136,978.367981 
	C809.263184,977.555115 809.552307,977.119507 809.982056,976.463745 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M802.996155,963.747192 
	C805.036865,963.388916 807.107178,963.393127 809.608398,963.509521 
	C807.909485,966.773743 805.613098,967.532593 802.996155,963.747192 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M811.657104,984.860901 
	C812.995300,981.069885 814.745117,980.918640 818.672119,984.554321 
	C816.536133,984.874329 814.304016,984.867493 811.657104,984.860901 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M859.950317,918.861938 
	C859.797485,922.350525 857.328064,920.625610 855.303955,920.830322 
	C855.406372,919.390991 855.733154,918.047913 855.019714,916.361633 
	C856.403503,915.978394 857.815491,915.900635 859.619995,915.654785 
	C860.077576,915.704346 860.142761,915.922058 860.225952,916.480225 
	C860.052246,917.427124 858.164368,917.564209 859.950317,918.861938 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M738.143311,993.424316 
	C737.998230,993.881775 737.773743,993.906067 737.210266,993.926514 
	C737.532715,990.286987 734.726135,986.867493 736.535034,982.376770 
	C738.917053,986.053589 737.852966,989.643372 738.143311,993.424316 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M747.619141,972.335938 
	C748.302185,973.007507 748.582703,973.660034 748.904785,974.589111 
	C746.443237,975.381104 744.426697,974.475220 742.238159,972.987854 
	C744.105469,971.500305 745.727356,972.639099 747.619141,972.335938 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M835.853760,971.712891 
	C834.401550,972.958435 835.413879,974.768372 834.570618,976.112244 
	C832.207275,974.453003 833.657043,971.555176 832.269287,969.276733 
	C834.018066,968.798584 835.089722,969.789307 835.853760,971.712891 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M818.062500,953.487793 
	C818.328186,953.071350 818.528503,953.077454 819.029175,953.073608 
	C819.237793,955.103149 819.146118,957.142517 819.151001,959.611450 
	C819.245605,962.725952 819.243591,965.410950 819.217163,968.544556 
	C819.007812,969.106750 818.822876,969.220398 818.378662,969.137146 
	C817.963257,965.926086 817.807251,962.911865 817.564087,959.452637 
	C817.650269,957.308594 817.823608,955.609436 818.062500,953.487793 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M742.993408,960.504395 
	C744.365723,960.130005 745.752930,960.141357 747.545532,960.260376 
	C748.602966,960.886658 748.684326,961.562012 748.281616,962.614807 
	C746.250000,962.585510 743.633911,964.228882 742.993408,960.504395 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M748.484741,962.930420 
	C748.038452,962.279419 747.999084,961.643555 747.955322,960.687866 
	C749.413879,960.343262 750.876892,960.318481 752.690125,960.382812 
	C753.027649,961.021484 753.014954,961.571045 752.992920,962.531616 
	C751.619568,962.943481 750.255676,962.944519 748.484741,962.930420 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M803.412354,1015.953491 
	C803.018738,1015.683960 803.026062,1015.512085 803.046021,1015.082336 
	C805.823425,1015.049072 808.588196,1015.273560 811.681763,1015.722961 
	C812.183350,1016.094177 812.356201,1016.240601 812.283752,1016.622192 
	C809.296814,1016.588623 806.555054,1016.319946 803.412354,1015.953491 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M869.619202,986.004333 
	C867.435364,986.778137 864.580811,989.892639 862.739868,984.671997 
	C862.714294,984.154236 862.746765,983.985168 863.031860,983.762817 
	C865.068481,985.017517 866.846558,986.340881 869.619202,986.004333 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M779.075073,978.672241 
	C780.743652,978.477356 782.504883,978.602478 784.634827,978.829712 
	C783.099670,982.957153 781.128784,980.491577 779.075073,978.672241 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M730.789917,952.254395 
	C732.837646,951.578857 734.691650,951.684937 736.834229,952.432129 
	C734.899719,954.572815 732.711792,954.958252 730.789917,952.254395 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M797.515381,961.007935 
	C797.915894,961.386475 797.868347,961.716919 797.818481,962.304932 
	C797.417725,962.570190 797.019287,962.577820 796.339233,962.686035 
	C795.221802,963.026001 794.386047,963.168640 793.259033,962.652710 
	C792.229614,962.415161 791.491516,962.311096 790.385376,962.285400 
	C789.572449,962.275513 789.127380,962.187256 788.348633,962.020630 
	C788.026367,961.745728 788.037842,961.549194 788.057983,961.057556 
	C791.066895,960.828247 794.067078,960.894104 797.515381,961.007935 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M866.780518,974.320801 
	C865.710144,973.562256 864.640137,972.753845 866.369629,972.266846 
	C867.600037,971.920349 869.285034,972.546753 869.304138,973.965149 
	C869.323242,975.386719 867.934509,974.697876 866.780518,974.320801 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M818.042358,969.334961 
	C818.298340,968.946289 818.477417,968.952209 818.924561,968.975586 
	C820.511475,970.549988 819.964355,972.522827 820.439758,974.679688 
	C820.270447,975.163330 820.033325,975.250000 819.482605,975.124329 
	C819.012817,974.387695 818.856567,973.863464 818.527649,973.128052 
	C818.225098,971.854370 818.095276,970.791992 818.042358,969.334961 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M819.159912,975.272644 
	C819.392700,974.926208 819.616333,974.940430 820.173706,975.015625 
	C821.025574,976.814514 821.543640,978.552368 822.046387,980.652100 
	C819.592896,980.011658 820.177673,977.391113 819.159912,975.272644 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M818.120483,939.530762 
	C817.648621,940.315430 817.138245,940.641968 816.313538,940.981201 
	C815.939087,940.205627 815.769836,939.406860 815.844238,938.631531 
	C815.958923,937.436890 815.799377,935.557373 817.597534,935.918030 
	C819.596924,936.319092 817.626526,938.031006 818.120483,939.530762 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M784.092834,955.625122 
	C785.801025,954.517395 787.548340,955.528137 789.706543,955.597290 
	C788.193726,957.579895 786.229980,957.593933 784.092834,955.625122 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M792.989746,962.852905 
	C793.817505,962.490601 794.667175,962.461975 795.787231,962.609985 
	C795.896851,963.761047 795.763916,964.788818 794.448425,964.806946 
	C793.393188,964.821411 793.175049,964.008179 792.989746,962.852905 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M781.668884,1011.439697 
	C781.948730,1011.860901 782.009399,1012.052551 782.113647,1012.542480 
	C780.582520,1013.199585 779.254761,1012.660645 777.864624,1011.737305 
	C779.027100,1010.519104 780.255127,1010.979126 781.668884,1011.439697 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M833.950562,957.475464 
	C836.093262,957.174316 835.922485,958.781128 836.023682,960.594238 
	C833.912292,960.886475 834.008057,959.318481 833.950562,957.475464 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M736.043701,959.642334 
	C737.130554,959.321533 738.307007,959.330322 739.788452,959.518921 
	C738.886963,961.436829 737.562195,961.458191 736.043701,959.642334 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M833.985718,983.512573 
	C835.277954,982.561279 834.613647,980.846191 835.809937,979.687744 
	C835.893982,981.029480 835.961182,982.102905 836.026367,983.528564 
	C835.308594,984.999878 834.651245,984.951233 833.985718,983.512573 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M809.617920,989.387085 
	C809.468323,991.046936 808.639404,991.132568 807.656372,990.482422 
	C807.028381,990.067139 806.998901,989.334290 807.458557,988.795044 
	C808.207581,987.916321 808.868530,988.525696 809.617920,989.387085 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M804.932007,970.644775 
	C803.940002,971.043091 802.879028,971.097290 801.419800,971.142334 
	C801.746033,968.290771 803.090637,968.308838 804.932007,970.644775 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M832.187500,936.736816 
	C831.475891,937.806458 831.939514,940.794556 829.644165,939.592468 
	C828.226196,938.849854 829.999817,937.844788 830.783691,936.750610 
	C831.290955,936.479553 831.567200,936.492371 832.187500,936.736816 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M875.185852,954.603394 
	C874.184998,955.184998 873.316467,956.350891 871.982178,955.176758 
	C872.875427,954.216431 873.405212,950.985413 875.185852,954.603394 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M833.319214,950.843750 
	C833.460632,950.438904 833.809326,950.628296 833.961731,950.755310 
	C835.474487,952.214050 834.630188,953.712891 834.233643,955.566406 
	C834.005310,956.151123 833.981995,956.331665 833.925232,956.783691 
	C831.413574,955.395081 833.617554,953.159241 833.319214,950.843750 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M784.141602,1005.274902 
	C785.190308,1005.659668 785.827759,1006.192993 785.636047,1007.107788 
	C785.591614,1007.319824 784.772461,1007.624878 784.518188,1007.491028 
	C783.645264,1007.031616 782.855713,1006.399353 784.141602,1005.274902 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M865.367310,930.968140 
	C866.394043,929.449280 868.122559,929.885925 870.020081,930.193481 
	C868.752808,931.777649 867.160706,930.757019 865.367310,930.968140 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M822.624939,987.356201 
	C822.786133,986.658142 823.077087,986.300537 823.712402,985.872986 
	C824.072205,986.439331 824.141907,987.080078 824.088806,987.710510 
	C824.028320,988.428040 824.988953,989.569824 824.037537,989.756104 
	C822.708801,990.016296 823.093811,988.473572 822.624939,987.356201 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M812.446045,1016.922852 
	C812.038513,1016.857361 812.014771,1016.402893 812.012695,1016.175354 
	C813.382751,1015.977051 814.755005,1016.006287 816.534973,1016.088013 
	C816.951050,1016.308350 816.959351,1016.476196 816.972900,1016.896240 
	C815.603333,1017.095032 814.228516,1017.041687 812.446045,1016.922852 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M825.674622,936.068481 
	C827.139282,937.632263 825.413696,938.158630 824.327820,939.049438 
	C823.726501,937.713501 824.779907,937.069641 825.674622,936.068481 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M791.804688,925.682373 
	C792.866211,924.525330 794.193848,924.812622 795.605530,925.480347 
	C794.495911,926.665771 793.249573,925.937988 791.804688,925.682373 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M801.318542,974.965210 
	C801.000977,974.042603 801.266113,973.308838 802.708557,973.280701 
	C802.877441,974.143127 802.496948,974.759644 801.318542,974.965210 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M843.175659,966.181885 
	C843.880249,964.918274 844.502991,965.227783 845.052124,966.558044 
	C844.529846,966.698181 843.936768,966.573181 843.175659,966.181885 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M777.049316,955.729004 
	C777.433960,955.377686 777.884338,955.267944 778.676514,955.257324 
	C778.700073,956.540833 778.263916,957.359924 777.049316,955.729004 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M778.946655,959.332397 
	C778.469238,959.639832 777.918762,959.665222 777.118042,959.570435 
	C777.356140,958.412415 777.922852,957.768311 778.946655,959.332397 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M823.614502,939.038208 
	C824.396057,939.674500 824.088745,940.265564 823.281128,940.911316 
	C821.913086,940.196106 823.009827,939.733765 823.614502,939.038208 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M833.589111,934.079590 
	C834.282593,934.748657 833.989258,935.395630 833.224182,936.262329 
	C832.382690,935.699646 832.658813,934.941040 833.589111,934.079590 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M823.171021,982.699280 
	C822.276001,982.997314 821.890930,982.471619 821.895264,981.314697 
	C822.782349,981.103699 823.077026,981.656189 823.171021,982.699280 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M864.286987,932.030762 
	C863.791443,931.955261 863.511230,931.741089 863.135742,931.278198 
	C863.455444,930.961670 863.870544,930.893860 864.596313,930.857666 
	C864.907104,930.889221 864.972290,930.967834 865.005981,931.007141 
	C864.860535,931.328308 864.681458,931.610168 864.286987,932.030762 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M860.011841,980.760498 
	C859.589844,980.648682 858.751831,980.405823 859.649536,979.703064 
	C859.775940,979.973633 859.902405,980.244202 860.011841,980.760498 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M875.462158,951.538330 
	C875.478149,951.523926 875.446167,951.552734 875.462158,951.538330 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M769.158081,1012.387451 
	C768.664429,1012.755615 768.222107,1012.640137 767.691406,1012.180298 
	C768.163391,1011.267761 768.699036,1011.286499 769.158081,1012.387451 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M835.598511,932.133667 
	C835.841797,932.425720 835.693359,932.690918 835.181641,932.950806 
	C835.086670,932.743652 835.216187,932.464050 835.598511,932.133667 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M826.733765,934.941528 
	C826.900513,935.357239 826.776489,935.824951 826.297241,936.144165 
	C826.109009,935.661621 826.276001,935.327637 826.733765,934.941528 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M870.320679,949.580017 
	C870.258789,949.516541 870.472656,949.489258 870.472656,949.489258 
	C870.472656,949.489258 870.382507,949.643494 870.320679,949.580017 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M834.721802,932.960754 
	C834.857239,933.292969 834.697205,933.630859 834.245239,933.985718 
	C834.110901,933.657227 834.268555,933.311890 834.721802,932.960754 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M860.892822,981.761475 
	C860.543701,982.010803 860.304504,981.786194 860.066772,981.244873 
	C859.994812,981.006287 860.000061,980.999939 860.004089,980.996216 
	C860.315186,981.116943 860.622314,981.241333 860.892822,981.761475 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M862.030884,982.764648 
	C862.557983,982.861206 862.806885,983.057861 863.143188,983.516113 
	C863.284485,983.709473 862.984070,984.014465 862.832886,984.168823 
	C862.388489,984.168274 862.149597,983.952942 861.853516,983.461182 
	C861.741882,983.245056 861.806641,982.796631 862.030884,982.764648 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M861.132751,981.874817 
	C861.519470,981.914429 861.767639,982.105408 862.112915,982.543823 
	C862.255188,982.732666 862.001831,982.988953 861.871826,983.117004 
	C861.473328,983.068359 861.250732,982.845703 860.965210,982.367188 
	C860.856262,982.157227 861.039307,981.967712 861.132751,981.874817 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M870.008118,986.011230 
	C870.091125,985.977234 870.165894,985.932556 870.109558,985.936096 
	C869.978516,985.984314 869.999878,986.000610 870.008118,986.011230 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M836.758545,972.040527 
	C836.835815,972.440735 836.629639,972.751282 836.077209,972.209106 
	C836.161255,972.031677 836.332031,972.027527 836.758545,972.040527 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M896.238098,776.321655 
	C895.437012,776.537354 895.074036,776.622864 894.442444,776.611206 
	C891.518494,775.094727 888.085571,777.025879 885.360352,774.267578 
	C883.907288,772.390869 882.771057,770.789001 881.331238,769.054993 
	C879.897278,768.199036 879.451965,767.120544 879.489197,765.369629 
	C880.393311,761.781677 882.647278,761.171265 885.605652,760.946350 
	C899.210999,759.911987 912.803040,760.751404 926.392456,761.080750 
	C930.901917,761.190002 935.233643,759.739502 939.752014,760.202271 
	C941.417175,760.372803 943.056763,760.264648 944.851013,761.593750 
	C945.231873,761.853088 945.105957,761.880127 945.114624,761.816284 
	C945.190063,762.103149 945.353943,762.400208 945.803833,762.824768 
	C945.992798,763.005737 946.213623,763.293152 946.157349,763.465454 
	C946.177673,763.986938 946.328430,764.300537 946.723633,764.781372 
	C947.053284,766.753296 948.866638,768.098450 948.240601,770.472168 
	C947.913696,772.408630 947.718506,774.021851 946.262695,775.456421 
	C945.560059,775.749207 945.108459,775.811584 944.323059,775.787292 
	C936.974609,774.193176 929.849060,774.842285 922.824097,775.132019 
	C914.110657,775.491394 905.346497,774.834595 896.238098,776.321655 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M956.069824,836.276367 
	C948.783630,831.057983 943.999084,823.307983 935.601135,819.954712 
	C932.076294,818.547302 928.436401,818.708191 924.846802,818.432922 
	C918.252625,817.927185 911.623840,817.542175 905.018677,817.653137 
	C901.814026,817.706909 901.471680,815.322998 900.082397,813.344604 
	C900.274780,812.819946 900.468018,812.670532 901.022583,812.432312 
	C901.636108,812.347595 901.888428,812.351746 902.516846,812.425720 
	C903.922729,812.739990 904.964050,812.935852 906.401611,813.330322 
	C928.691650,813.576416 950.561340,813.841125 972.875610,813.416016 
	C978.765686,818.914124 981.706116,826.049011 986.569092,832.224243 
	C986.718506,833.372314 986.087158,833.812012 985.466797,833.770752 
	C979.169800,833.351257 972.949036,835.056946 966.618958,834.304993 
	C963.887939,833.980652 961.831970,832.165527 959.387634,831.524780 
	C957.734985,832.965759 960.094055,836.555298 956.069824,836.276367 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M955.853333,836.442383 
	C957.237366,835.809753 958.710754,835.094299 957.386841,833.560547 
	C955.736267,831.648376 956.619873,830.638977 958.091553,829.605042 
	C959.500061,828.615417 960.430664,829.359314 961.366943,830.560181 
	C963.185303,832.892273 965.820496,833.024719 968.533081,833.024963 
	C971.639221,833.025269 974.785034,832.601624 977.797241,833.638977 
	C979.677979,832.538208 976.297668,831.355835 977.896729,830.401611 
	C979.174988,829.638733 980.101685,830.600708 980.885559,831.414429 
	C982.303528,832.886353 983.964172,833.199463 986.288147,832.644226 
	C986.713318,832.534607 986.674744,832.550476 986.683472,832.561035 
	C986.673462,834.869324 988.130737,836.274475 990.036682,837.739868 
	C993.415161,841.921143 995.813782,846.304321 997.305969,851.568970 
	C990.183533,853.975220 982.813232,853.356079 976.282471,853.495361 
	C982.807678,854.291382 990.146423,852.129700 997.871460,853.626709 
	C998.517151,854.056213 998.763184,854.280945 999.147583,854.721069 
	C998.707947,857.668945 996.443848,857.150269 994.572937,857.370056 
	C991.571045,857.722778 988.754456,856.277649 985.307495,856.445312 
	C978.986145,856.413635 973.126892,856.417236 966.799683,856.445923 
	C965.039917,856.530762 963.826050,856.287781 962.353577,855.283020 
	C960.832642,848.639404 959.689636,842.281799 955.853333,836.442383 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M891.427917,789.237793 
	C890.999939,788.658752 891.064392,788.309143 890.984436,787.996521 
	C890.223022,785.020203 886.784607,781.593140 888.527649,779.541870 
	C889.886841,777.942383 894.477661,779.072083 897.632874,779.018494 
	C914.621460,778.729858 931.611938,778.520935 948.597168,778.099487 
	C951.476257,778.028076 953.343323,778.764771 954.466003,781.424866 
	C955.304077,783.410706 956.287903,785.334961 957.173462,787.666626 
	C955.866943,789.428467 954.154480,789.422546 952.502258,789.397339 
	C934.219055,789.118347 915.980347,791.159363 897.689148,790.437317 
	C895.699524,790.358826 893.677551,790.546753 891.427917,789.237793 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M880.210144,756.317932 
	C882.153687,747.806580 882.153320,747.775208 891.345764,747.660889 
	C907.469910,747.460266 923.594666,747.302490 940.161011,747.157593 
	C941.494324,750.342407 942.385620,753.496399 943.655334,757.989136 
	C922.694519,757.989136 902.343567,757.997803 881.992676,757.953735 
	C881.266724,757.952148 879.795654,758.417236 880.210144,756.317932 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M874.089355,760.351318 
	C874.160706,761.527344 874.129211,762.430115 875.640747,762.931458 
	C878.390564,765.271423 879.193115,768.356018 880.113159,771.663391 
	C880.473877,773.298035 881.948914,774.069519 881.862793,775.989136 
	C880.849854,779.368286 883.406677,781.209167 884.348755,783.565979 
	C887.982849,792.657959 891.458130,801.791138 893.765503,811.331665 
	C894.190735,813.090027 894.570801,814.933472 896.455444,816.369141 
	C897.441650,817.462952 894.597229,818.006348 896.792847,818.997925 
	C897.185608,820.736206 896.091492,820.634705 894.948120,820.465393 
	C894.934998,820.463440 894.914734,820.509338 894.897827,820.532837 
	C895.532349,820.328430 895.021423,821.423706 895.472168,821.085449 
	C896.751892,823.399963 894.975281,827.764038 900.152832,826.511353 
	C901.377075,826.215149 901.606995,828.397217 902.447266,829.745850 
	C902.661133,830.527161 902.673035,830.984863 902.461548,831.755981 
	C901.436157,833.710938 898.068176,832.219727 898.330139,835.642334 
	C899.872192,849.293396 899.503540,862.624207 899.445312,876.364502 
	C898.820190,877.267517 898.284485,877.570007 897.174927,877.715454 
	C892.735291,877.306519 891.543701,874.844116 891.563171,871.176270 
	C891.607117,862.881470 891.596130,854.585571 891.559326,845.828979 
	C891.580505,841.205505 891.587158,837.043091 891.572021,832.465332 
	C891.646545,829.967163 891.438843,827.916809 890.807617,825.564636 
	C890.872498,822.859680 888.558350,823.916016 887.447632,822.720093 
	C886.624512,821.013489 886.691956,819.535522 886.923767,817.676880 
	C888.065247,814.826843 887.316772,812.417175 886.643494,810.034241 
	C884.173218,801.291382 882.051514,792.436462 878.218201,783.770264 
	C877.884705,783.288513 877.751648,783.097717 877.455322,782.602783 
	C877.045044,781.782104 877.128967,781.143188 876.833740,780.682800 
	C876.479736,780.130493 875.804199,780.506470 876.450989,780.667969 
	C877.097778,780.829468 875.807800,781.420593 876.206787,781.335571 
	C873.727478,781.488098 869.691223,776.907410 870.433899,774.197693 
	C871.653198,769.749268 869.354065,768.945374 865.658325,768.551392 
	C864.874084,768.501526 864.449890,768.378113 863.812012,767.938538 
	C863.188721,767.182251 862.932922,766.586243 862.586365,765.681274 
	C862.364868,764.970764 862.304199,764.552368 862.339905,763.812988 
	C862.469360,763.306030 862.554077,763.112549 862.851318,762.684326 
	C863.562378,762.054382 864.115479,761.745178 864.943604,761.272217 
	C865.797546,760.805420 866.394592,760.544128 867.320312,760.195190 
	C869.222839,759.713196 870.827026,759.736328 872.782837,759.879333 
	C873.353333,760.003967 873.575989,760.078308 874.089355,760.351318 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M961.927856,855.440552 
	C963.085388,855.000671 964.192749,855.005066 965.714905,855.028442 
	C972.226196,855.853271 978.355652,856.025452 984.946777,856.002563 
	C989.995361,856.256775 994.585144,856.698608 999.621277,856.725464 
	C1002.932495,858.984680 1002.386108,862.617737 1004.096680,865.632568 
	C1002.469666,868.926697 999.384644,867.991699 996.885498,867.837708 
	C993.440063,867.625488 990.002319,867.536621 986.107056,867.478638 
	C979.492126,866.541809 973.246704,866.625488 969.476013,866.419861 
	C972.742737,866.305359 978.407532,866.903687 984.514893,867.287048 
	C991.386597,867.302246 997.831055,868.388794 1004.686401,867.729126 
	C1005.393616,868.463562 1005.702637,869.004700 1006.088989,869.854309 
	C1005.567749,870.778259 1004.842896,871.255493 1003.998596,871.286865 
	C991.234985,871.761902 978.493713,873.172607 965.696350,872.237183 
	C965.028076,872.188354 964.422485,871.876648 963.507202,871.166504 
	C962.725891,865.850830 962.301819,860.867859 961.927856,855.440552 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M949.741089,844.835327 
	C948.916077,846.289612 948.076355,847.361267 947.069214,848.811401 
	C944.945435,849.241089 944.216553,847.420898 942.885925,846.522705 
	C940.139343,844.668884 937.483459,843.906555 934.645752,846.884766 
	C934.341370,847.301453 934.226990,847.469177 933.932739,847.868958 
	C933.631958,848.238342 933.510986,848.375793 933.024780,848.842041 
	C932.659546,849.170898 932.602783,849.618225 932.602783,849.618225 
	C932.602783,849.618225 933.076416,849.527649 933.370605,849.627197 
	C935.290710,852.360657 933.817627,854.919250 933.457153,857.845276 
	C933.486877,860.902527 933.644287,863.654968 936.405334,865.120483 
	C940.721985,867.411560 944.806702,864.559204 944.756897,858.996704 
	C944.632385,857.347412 944.671082,856.074280 945.241882,854.481079 
	C945.652954,853.987061 945.876831,853.843872 946.499634,853.709595 
	C948.116211,854.570862 948.248657,855.915344 948.530945,857.603882 
	C951.355164,863.356262 951.041565,868.508911 947.284363,873.747314 
	C947.036377,874.049500 947.001160,873.999939 947.028809,874.012573 
	C946.190308,875.205505 945.139954,876.244629 944.213013,877.773804 
	C944.041565,878.037781 944.000000,878.000000 944.023438,878.016113 
	C942.491455,878.999451 940.708557,879.194641 938.586914,879.584167 
	C933.982178,879.028870 931.405457,876.472656 929.805664,872.262573 
	C929.600220,871.664734 929.514038,871.426880 929.276978,870.836182 
	C929.015259,870.247864 928.904541,870.012451 928.635254,869.415222 
	C925.052917,863.051392 923.964050,856.831787 925.794861,849.978821 
	C928.645508,839.308289 934.442200,835.732300 945.691772,838.633911 
	C948.180481,840.102905 949.309875,842.045105 949.741089,844.835327 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M957.580505,789.395630 
	C959.586548,789.771423 959.973206,791.134644 960.769287,792.164978 
	C963.168518,795.270386 961.989014,795.852539 958.657349,795.794006 
	C938.400024,795.438232 918.170715,796.629272 897.464539,797.122070 
	C896.356018,797.658325 895.642700,797.849915 894.493835,797.633057 
	C892.586731,796.429199 891.961426,794.791260 891.444946,792.699829 
	C891.493347,792.086426 891.564514,791.847534 891.948242,791.403320 
	C892.260742,791.197998 892.034546,791.027405 892.137512,791.124695 
	C893.166992,789.973816 894.544617,789.987793 895.864197,790.029053 
	C915.640076,790.647156 935.375732,788.939392 955.141724,789.021973 
	C955.808167,789.024780 956.468567,789.098450 957.580505,789.395630 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M946.196411,839.833984 
	C936.985535,836.435913 930.812439,839.447327 927.787354,848.443665 
	C925.279968,855.900269 926.359863,862.765869 929.679077,869.837891 
	C929.199463,870.434265 928.863098,870.615173 928.192993,870.731262 
	C927.716858,870.729675 927.528137,870.706726 927.067322,870.609863 
	C926.451050,870.417175 926.108032,870.295227 925.516602,870.094116 
	C924.939453,869.912292 924.611816,869.806152 924.041870,869.687927 
	C923.498413,869.878601 923.350586,870.174500 923.261536,870.835815 
	C923.154663,872.043396 922.983704,872.909729 922.224121,873.898560 
	C918.901978,869.283936 918.731628,863.937683 919.341309,858.419128 
	C920.271423,860.773193 919.629883,863.631470 922.290955,866.803528 
	C921.877747,860.539856 920.621277,855.507080 920.947510,850.382751 
	C921.560547,840.754456 929.391602,832.501587 938.750793,832.359375 
	C939.751770,833.993591 941.206421,833.764099 942.383484,833.943665 
	C945.682068,834.446899 947.330811,836.030579 946.196411,839.833984 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M962.744385,875.918701 
	C962.710449,874.873596 962.796997,874.204712 962.949341,873.285156 
	C966.597168,871.043762 970.528809,871.857544 974.208557,872.114868 
	C983.008301,872.730469 991.717102,871.270569 1000.478394,871.509155 
	C1002.449219,871.562744 1004.481750,871.231750 1006.698364,872.619263 
	C1007.596436,874.280701 1008.093201,875.684692 1008.604370,877.403564 
	C1005.237549,880.832581 1001.102539,879.479492 997.330200,879.311890 
	C992.472961,879.096069 987.633362,878.374023 982.747498,878.477173 
	C986.205933,878.386353 989.647217,878.590393 993.082642,879.006958 
	C994.770935,879.211670 996.515564,879.232483 996.095947,882.014099 
	C986.840881,882.334656 977.882263,883.704895 968.853027,883.420288 
	C966.312988,883.340210 963.958130,882.868164 961.505554,881.115845 
	C961.230469,879.946350 961.291992,879.085205 961.635681,878.055847 
	C962.797668,877.211182 963.814819,877.005127 965.280579,877.013000 
	C966.662537,877.002319 967.659912,877.004456 969.012573,877.004272 
	C970.572205,877.014465 971.783875,876.949890 973.035278,877.396851 
	C972.095459,876.765381 971.119507,877.110352 969.849548,876.997681 
	C968.525024,876.996216 967.554260,876.995850 966.202637,876.991089 
	C964.791382,876.948486 963.732910,877.027649 962.744385,875.918701 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M909.410156,895.907593 
	C908.070862,895.300842 906.847229,895.708557 906.016541,894.375854 
	C906.264282,891.303345 908.365112,891.472534 910.382385,891.361816 
	C924.280334,890.599121 938.188904,891.193359 952.561523,891.002075 
	C960.172241,892.245483 967.546509,890.431396 974.858765,893.059204 
	C977.239441,894.346680 976.439026,895.965515 976.018555,897.748169 
	C975.418945,898.407227 974.848999,898.577271 973.778687,898.413940 
	C970.931519,897.068542 968.368835,896.499451 965.678284,896.497070 
	C954.732361,896.487488 943.774963,896.192688 932.845276,896.619080 
	C927.242126,896.837708 921.647461,897.578186 916.013245,897.408142 
	C913.871765,897.343445 911.667175,897.558960 909.410156,895.907593 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M1007.642944,857.259521 
	C1003.788208,854.925232 1003.830688,850.833618 1002.210815,847.681152 
	C999.489868,842.385864 997.256714,836.840332 994.548584,831.537903 
	C992.678040,827.875610 995.693420,827.273987 997.615967,826.073914 
	C1000.543030,824.246765 1000.431030,827.257751 1000.999634,828.584961 
	C1004.778442,837.406067 1008.425903,846.283386 1012.169006,855.515869 
	C1011.167664,857.381897 1009.669067,857.688721 1007.642944,857.259521 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M1012.528320,886.646729 
	C1012.484314,891.280334 1008.059143,895.988403 1004.173828,895.963135 
	C996.704041,895.914551 989.216858,896.462097 981.405212,895.223877 
	C979.669067,891.953064 981.340942,890.524292 983.939026,889.477112 
	C985.661072,888.782959 987.434021,888.652039 989.688965,888.588196 
	C994.888367,889.165649 999.633484,889.799316 1003.727173,889.542908 
	C1002.623352,888.936035 1000.560669,889.776550 998.651978,889.473145 
	C997.188965,889.240723 995.182251,890.343445 994.640747,887.470703 
	C1000.446289,884.227661 1006.322632,885.677551 1012.528320,886.646729 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M1006.019714,788.565186 
	C1006.084534,789.096069 1006.027893,789.283203 1005.918823,789.758667 
	C1005.386902,789.999756 1004.907349,789.952515 1004.067749,789.873047 
	C1000.591003,788.385132 1000.209351,785.147583 999.034424,782.481689 
	C997.629028,779.292664 996.950684,775.815674 995.231567,772.326660 
	C992.283447,763.188049 989.226929,754.486328 986.159302,745.374634 
	C985.018616,741.653503 983.589294,738.451111 982.504150,735.127930 
	C981.932434,733.377197 981.460388,731.591675 982.587952,729.457153 
	C983.041504,729.097351 983.266479,729.066711 983.830688,729.004517 
	C991.247192,744.546936 995.424011,761.196960 1001.971252,776.971130 
	C1003.491394,780.633606 1004.600220,784.466797 1006.019714,788.565186 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M921.981445,874.080811 
	C921.958679,873.004883 921.953857,871.890930 921.987671,870.360718 
	C922.425903,869.452881 922.773926,868.903381 923.721313,868.828613 
	C924.386597,868.978760 924.759338,868.999512 925.412170,869.027100 
	C926.030457,869.181458 926.335693,869.380249 926.789917,869.833435 
	C926.967407,870.043335 926.963135,870.000000 926.954590,870.021729 
	C928.747864,871.615967 929.093384,874.024170 930.419373,876.219849 
	C930.562805,876.890015 930.595764,877.267395 930.745300,877.861206 
	C931.000732,878.196045 931.121216,878.315918 931.392700,878.641235 
	C932.706055,882.194580 935.715332,881.531494 938.637939,881.981628 
	C940.914185,882.817810 942.802429,882.676697 944.850464,881.783569 
	C945.868774,880.419678 946.995239,879.990295 948.630371,879.988037 
	C949.603394,880.828247 948.906982,881.440491 948.410706,882.369385 
	C947.906189,883.076599 947.466309,883.406494 946.642090,883.612793 
	C945.899963,884.158508 946.224487,883.238159 946.085876,883.889709 
	C946.083374,883.901672 946.047791,883.825134 946.348267,883.717163 
	C947.184265,883.469116 947.743103,883.283081 948.336792,882.528809 
	C949.318970,881.381348 950.033813,880.246155 951.612244,881.754578 
	C952.256104,883.413330 952.216064,884.682983 951.188171,886.218445 
	C942.505554,886.952026 933.792908,888.420349 926.548096,881.991943 
	C924.545349,880.214966 922.633484,878.399719 922.120117,875.245361 
	C922.213440,874.709717 922.294617,874.535767 922.150696,874.182251 
	C921.925537,874.002747 921.999390,874.042847 921.981445,874.080811 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M910.762268,799.071899 
	C923.090942,797.374146 935.745850,798.215149 948.348999,797.461426 
	C951.005066,797.302612 953.750305,797.659851 956.313171,797.114990 
	C962.067444,795.891663 965.847473,797.827087 968.070312,803.602417 
	C967.286987,807.202942 964.296265,806.906982 961.892029,807.246704 
	C958.674194,807.701416 955.384827,807.379700 951.669861,807.429443 
	C949.419922,807.369568 947.601013,807.545288 945.518372,806.625183 
	C944.471558,802.673462 947.439575,802.929626 949.517456,802.653992 
	C953.128784,802.174988 956.802673,802.658142 960.447632,802.065552 
	C946.522644,801.299500 932.572937,801.510071 918.218079,801.148804 
	C915.628784,800.163391 913.078796,800.809509 910.762268,799.071899 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M980.016113,787.362366 
	C979.988708,786.574036 980.072510,785.930481 979.790710,785.631287 
	C978.606567,784.373962 977.077881,782.545044 978.944458,781.554688 
	C981.213257,780.350952 981.242554,783.440491 981.697266,784.575928 
	C986.436523,796.410706 991.652283,808.029358 997.000122,819.595764 
	C997.597473,820.887573 999.569275,822.826050 997.430359,823.815125 
	C994.956482,824.958923 994.840271,822.106201 994.080688,820.619385 
	C990.091553,812.811279 986.088623,805.010010 982.153137,797.174927 
	C981.192139,795.261780 980.466064,793.230530 979.800781,790.924866 
	C979.308044,789.621582 979.497986,788.644043 980.016113,787.362366 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M958.025024,789.323364 
	C936.423645,790.931213 914.778259,790.996155 892.686890,791.151855 
	C891.889709,790.683350 891.538940,790.144775 891.095398,789.298645 
	C912.729980,788.657349 934.457458,788.323486 956.662476,788.018188 
	C957.430603,788.392395 957.721069,788.738098 958.025024,789.323364 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M982.634277,750.886230 
	C987.714600,768.409546 995.256226,784.760071 1000.399841,801.936157 
	C1001.107788,804.300110 1002.371033,806.540161 1001.984253,809.536438 
	C1001.194824,809.677551 1000.514282,809.420410 999.601013,809.002136 
	C995.986023,806.369263 996.830872,802.007996 994.782593,798.562805 
	C994.557678,798.036316 994.466125,797.827454 994.273499,797.294067 
	C993.965881,796.097290 993.873352,795.211243 993.941040,793.664124 
	C993.082947,783.641785 988.971924,775.251404 985.803345,766.574890 
	C984.042053,761.752075 981.863586,757.060364 981.780884,751.354004 
	C981.945007,750.835022 982.159729,750.743042 982.634277,750.886230 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M969.861328,807.704224 
	C971.175415,809.125671 972.134277,810.728821 973.078247,812.695435 
	C972.174744,813.569397 971.143250,813.820740 970.194031,813.808716 
	C957.396729,813.647339 944.617371,815.010742 931.813843,814.237671 
	C926.169434,813.896912 920.521484,813.656677 914.434326,814.465332 
	C913.684143,814.403687 913.389587,814.339233 912.855835,813.893616 
	C912.535217,812.901733 912.667542,812.342773 913.353882,811.559082 
	C918.184875,809.743164 922.882996,809.267944 927.962952,808.686707 
	C928.888672,808.736511 929.398804,808.836487 930.228394,809.154602 
	C930.746094,809.455261 930.931152,809.603210 931.288635,810.036438 
	C943.727722,811.163513 955.888794,809.844360 968.422485,808.389709 
	C969.031860,808.126709 969.269043,808.006348 969.861328,807.704224 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M914.663574,849.453247 
	C914.825562,850.675171 914.850830,851.487305 914.767578,852.694031 
	C908.534363,855.981812 906.120300,854.789429 906.097412,848.368835 
	C906.081726,843.982422 905.019165,839.460815 907.330017,834.871704 
	C909.094177,833.717285 910.587524,833.634277 912.526733,834.357910 
	C914.946716,839.233521 914.337769,844.182861 914.663574,849.453247 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M945.222412,761.470947 
	C939.488647,760.347046 933.771973,761.794556 928.037842,761.873291 
	C919.280579,761.993530 910.505798,761.458069 901.751770,760.964478 
	C895.915955,760.635376 890.210327,761.824463 884.432678,761.952698 
	C881.777588,762.011597 881.257080,763.890808 880.097839,765.871277 
	C877.515076,766.864258 877.471741,765.324280 877.584595,763.398682 
	C878.304688,760.300842 880.432129,760.091553 882.566467,760.064758 
	C902.340942,759.816223 922.124084,760.165894 941.888245,759.190674 
	C943.370544,759.117554 945.031738,758.835632 945.222412,761.470947 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M996.004883,882.145630 
	C995.517517,879.045105 993.328735,880.257080 991.940002,880.099731 
	C987.134216,879.555237 982.118774,880.508240 976.653381,877.765015 
	C987.640991,877.765015 997.690491,877.765015 1008.179443,877.741760 
	C1007.973267,879.729980 1012.972534,881.035522 1009.180786,883.712646 
	C1006.796082,886.027649 1004.177612,885.494446 1001.197998,884.981628 
	C1000.513794,881.694641 997.524353,883.707214 996.004883,882.145630 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M1007.099365,872.581482 
	C992.715820,872.861206 978.334839,873.726807 963.481934,873.024780 
	C963.005615,872.542480 962.996155,872.050476 963.068359,871.196167 
	C977.169006,870.619446 991.188110,870.405090 1005.686646,870.176697 
	C1006.477173,870.870544 1006.788086,871.578369 1007.099365,872.581482 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M902.295654,833.785339 
	C903.153320,846.985840 903.251404,859.967712 903.131653,872.947510 
	C903.106262,875.696289 904.187317,876.395142 906.621216,876.372375 
	C908.442322,876.355286 910.263428,876.749451 912.090576,876.846008 
	C914.221863,876.958679 915.080200,878.015442 914.639404,880.450317 
	C914.047302,880.920654 913.603088,880.913574 912.862122,880.624023 
	C911.151672,879.171265 909.415161,879.237732 907.342163,879.339722 
	C905.148071,879.147522 904.182922,880.780029 902.355957,881.458496 
	C899.936401,880.857971 899.838684,879.215820 899.952454,877.073486 
	C900.289246,866.080078 899.483032,855.529480 899.482300,844.965332 
	C899.482056,841.824402 899.217651,838.672119 899.996460,835.135254 
	C900.439392,834.164856 900.875183,833.781677 902.295654,833.785339 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M947.564087,882.872803 
	C948.022644,881.879944 948.431824,881.213074 948.892822,880.257568 
	C954.431335,874.218689 955.122375,866.721130 956.863159,859.364929 
	C960.288879,866.431030 958.754333,873.495667 956.473328,880.831055 
	C955.154846,881.994507 954.191162,881.295410 952.930542,880.877747 
	C952.470642,880.862793 952.288513,880.883301 951.562622,880.943970 
	C950.251953,881.632080 949.485046,882.280090 948.446167,883.063965 
	C947.954285,883.199463 947.734497,883.199097 947.564087,882.872803 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M896.791199,816.294312 
	C894.696716,817.159546 893.658813,816.346252 893.197571,814.307800 
	C890.524841,802.495361 886.342773,791.201599 881.370300,780.180847 
	C880.888550,779.113281 880.865601,777.924622 881.590454,776.564148 
	C883.458618,779.679443 885.082703,783.021790 886.866333,786.680298 
	C889.562012,791.263000 891.580627,795.766174 893.318970,800.771240 
	C893.614563,801.491821 893.754395,801.907532 893.965454,802.628723 
	C894.164551,803.315125 894.272400,803.702881 894.469360,804.364502 
	C894.671814,804.995850 894.773743,805.356506 894.939087,805.980164 
	C895.067505,806.410095 895.120605,806.580261 895.261597,807.001221 
	C895.410461,807.417725 895.471497,807.583496 895.616516,807.999878 
	C895.796387,808.588989 895.887207,808.928711 896.053955,809.521606 
	C896.198059,809.940002 896.260254,810.106750 896.424133,810.523987 
	C896.590515,810.945435 896.655212,811.116333 896.797729,811.552795 
	C896.999939,812.368652 897.037903,812.922485 896.910217,813.760010 
	C896.865723,814.684204 896.857300,815.330261 896.791199,816.294312 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M912.515503,813.542908 
	C920.671509,812.480347 928.432556,813.566589 936.217773,813.716919 
	C948.175354,813.947693 960.149963,813.301270 972.590332,813.042969 
	C973.063293,813.058899 973.354980,813.230286 973.338623,813.398499 
	C970.638489,815.300842 967.603699,814.895935 964.671814,814.890625 
	C944.976501,814.855042 925.281433,814.764404 905.326050,814.365845 
	C907.236145,812.083862 909.660767,812.452820 912.515503,813.542908 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M987.177979,901.590393 
	C986.097229,901.396729 985.388550,901.358704 984.329834,901.382690 
	C983.820496,901.402100 983.653381,901.377991 983.503113,901.314087 
	C982.192871,900.757385 979.588135,902.173767 979.761292,899.470459 
	C979.905762,897.216064 982.152100,898.271240 983.395325,898.283447 
	C991.303467,898.360718 999.210022,898.611389 1007.117065,898.803284 
	C1009.423462,898.859253 1011.729980,898.910034 1014.499146,898.902100 
	C1015.391235,898.574097 1015.858215,898.457153 1016.696045,898.652466 
	C1018.480286,898.924255 1020.031738,898.377380 1021.374695,899.496033 
	C1020.936768,902.396729 1018.555237,901.894104 1016.721252,901.966736 
	C1009.405273,902.256775 1002.083618,902.405151 994.287964,902.665710 
	C991.887817,901.355408 989.569092,902.508850 987.177979,901.590393 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M953.253052,891.692749 
	C941.243896,891.947754 929.415955,891.775146 917.607788,892.179382 
	C913.940918,892.304810 909.906433,891.107910 906.200867,893.873169 
	C905.204285,893.813904 905.085083,893.257751 905.097412,892.302246 
	C904.889648,891.870544 904.743408,891.740906 904.848389,891.460083 
	C920.738647,888.700684 936.476501,890.321716 952.628418,890.350464 
	C953.360474,890.767090 953.472229,891.101685 953.253052,891.692749 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M995.387329,881.753662 
	C997.237183,881.900391 998.714783,881.873779 1000.168701,882.046997 
	C1001.852722,882.247742 1000.796997,882.930481 1000.161865,883.711304 
	C998.042786,886.002319 995.486023,885.325012 992.666626,885.498657 
	C985.330994,885.792297 978.447937,885.283997 971.102905,885.461060 
	C967.894836,884.959351 965.019226,885.406494 962.147095,883.903931 
	C961.685425,882.776550 961.426941,882.075684 961.168701,881.091187 
	C970.635620,883.099609 980.150635,881.080383 989.642456,881.151306 
	C991.431030,881.164673 993.217285,881.488342 995.387329,881.753662 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M974.855835,759.323853 
	C973.857666,756.983887 972.960876,754.187439 975.046265,753.256226 
	C977.718384,752.063110 978.839417,754.737305 979.641052,757.056702 
	C981.393005,762.125549 983.270386,767.151001 985.121643,772.584839 
	C984.642517,773.393677 984.063171,773.588684 982.952271,773.440491 
	C980.008850,768.759338 977.521729,764.198242 974.855835,759.323853 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M970.522522,884.790283 
	C976.220825,883.446228 981.805725,884.083862 987.366455,884.424866 
	C988.727661,884.508362 989.942322,884.557861 991.545288,883.972534 
	C992.774536,885.024231 994.129456,885.575928 995.019775,887.046692 
	C997.675842,891.191833 1001.880676,887.488403 1005.489746,890.001526 
	C1000.218140,890.001526 995.567627,890.001526 990.449341,889.990540 
	C989.834900,889.824768 989.688293,889.669983 989.318359,889.283325 
	C985.811279,887.360657 982.052795,889.117188 978.741638,887.625732 
	C978.843262,888.069214 979.436646,888.173645 979.486450,889.012207 
	C979.436951,889.573120 979.362488,889.791748 978.987549,890.182983 
	C976.282043,889.293152 973.876953,888.230774 971.162476,886.972534 
	C970.413696,886.284119 970.282715,885.707153 970.522522,884.790283 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M970.130981,807.302490 
	C970.171448,807.766785 970.126282,808.011047 970.039795,808.625549 
	C961.906555,811.561707 953.469666,809.798523 945.259827,810.964539 
	C940.809753,811.596497 936.313293,811.643494 931.421936,811.175293 
	C931.023254,810.927734 931.022583,810.511963 931.026001,810.304077 
	C934.697998,805.863159 939.926575,808.114929 944.349854,806.999207 
	C946.148560,806.545410 948.250671,806.971375 950.672119,807.001770 
	C956.921326,807.111694 962.655396,805.954651 968.893433,806.343994 
	C969.625366,806.612915 969.862793,806.815491 970.130981,807.302490 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M1007.262207,809.256287 
	C1005.958496,805.955261 1004.915649,802.910767 1003.846802,799.486511 
	C1004.037231,798.388367 1004.544312,797.989136 1005.575928,797.901062 
	C1009.430176,809.300537 1013.712952,820.392883 1015.427551,832.227600 
	C1011.757385,825.010925 1009.935974,817.157715 1007.262207,809.256287 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M1005.883911,797.622681 
	C1005.395691,798.299133 1004.887939,798.602539 1004.100464,799.006287 
	C1000.615234,790.626953 997.409668,782.147156 994.177002,773.296326 
	C994.502441,772.231812 994.934998,771.630188 996.093140,771.719604 
	C998.740967,777.716614 1001.076782,783.496765 1003.560181,789.558838 
	C1003.635742,792.540649 1005.007507,794.820190 1005.883911,797.622681 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M896.165527,776.557007 
	C896.457397,776.000977 897.120056,775.149597 897.771362,775.158142 
	C912.716125,775.353455 927.605469,773.161621 942.561462,774.143372 
	C942.966064,774.169861 943.338684,774.683960 943.857727,775.335693 
	C928.169800,776.021179 912.350464,776.341675 896.165527,776.557007 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M969.146118,762.652344 
	C972.796082,764.207886 975.679749,769.466980 974.902954,772.599854 
	C974.648010,773.627991 974.170593,774.428650 973.127197,774.750549 
	C971.820618,775.153748 970.834351,774.468811 970.128113,773.539124 
	C968.213074,771.018127 966.711243,768.306458 966.969360,764.571289 
	C967.126160,763.110596 967.827209,762.660522 969.146118,762.652344 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M975.846924,952.894653 
	C975.682922,950.893616 975.716125,948.890259 975.717468,946.507202 
	C973.895752,943.306458 974.481018,940.160645 974.455261,937.099792 
	C974.426697,933.699036 974.899231,930.268127 973.763916,926.466064 
	C973.672546,919.082092 973.148560,912.156189 974.214783,904.823608 
	C974.672241,904.185486 974.911499,903.973816 975.615845,903.878113 
	C977.477539,919.991882 976.973572,936.024231 976.892273,952.511353 
	C976.566162,952.967346 976.304138,952.939758 975.846924,952.894653 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M986.677490,776.764404 
	C990.267395,781.738342 990.834595,787.590881 993.738892,792.805054 
	C994.029297,793.011658 993.994385,792.998596 994.003357,792.981689 
	C994.837708,794.028503 994.300171,795.311646 994.804443,796.743896 
	C995.033142,797.023865 994.983093,797.008972 994.991394,796.984253 
	C995.761108,798.075012 995.441772,799.342957 995.281799,800.961792 
	C991.397644,793.472412 987.738525,785.577881 984.081787,777.313110 
	C984.765015,776.401245 985.518982,776.261841 986.677490,776.764404 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M946.063599,840.438232 
	C946.926025,834.780640 941.659973,835.425781 939.182373,832.920166 
	C945.587524,832.493591 950.314819,835.500610 953.601318,841.460693 
	C953.406189,843.711182 954.585632,845.628479 953.376953,847.809998 
	C951.275085,848.653259 950.354248,847.507935 949.800354,845.783936 
	C950.015198,845.474487 949.943542,845.287354 949.849609,845.252686 
	C948.436279,843.832581 948.279053,841.532837 946.063599,840.438232 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M902.286255,830.250366 
	C900.174438,828.603271 899.052673,823.677795 896.100464,829.944458 
	C894.523865,827.168091 895.637390,824.455933 894.870850,821.633057 
	C896.378113,819.782104 898.573792,820.444275 900.615112,819.358704 
	C904.872498,819.907837 902.022339,823.242981 903.174805,825.494507 
	C903.766296,827.412842 904.370300,828.915588 902.286255,830.250366 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M995.525696,887.325867 
	C993.655823,886.938782 991.889771,886.885620 991.928467,884.315796 
	C994.312683,883.965820 996.706726,884.004272 999.544922,883.997070 
	C1002.703552,884.020264 1005.417847,884.089050 1008.580933,884.080811 
	C1010.431641,884.555908 1012.766418,883.428650 1012.916626,886.549316 
	C1007.246155,887.034241 1001.606262,887.149536 995.525696,887.325867 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M948.416504,858.132080 
	C947.808105,856.861877 947.465576,855.781372 946.987793,854.386597 
	C946.486267,853.512634 945.835693,853.398560 945.062744,852.896545 
	C944.669006,852.556580 944.522827,852.408264 944.175598,852.022949 
	C943.307922,850.661865 942.177185,850.146362 940.805786,849.430176 
	C938.588928,847.739136 936.424927,848.591492 933.995361,848.646240 
	C933.454529,848.497986 933.249573,848.398621 932.907959,847.986206 
	C936.727539,841.311096 941.666626,841.732727 946.603577,849.009277 
	C947.470154,851.909485 949.244934,854.283813 949.211792,857.578186 
	C949.051147,858.090088 948.866760,858.205933 948.416504,858.132080 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M895.117554,809.719482 
	C895.358154,809.362549 895.490112,809.186890 895.300781,808.740479 
	C896.288269,805.451355 893.924683,802.551697 894.673950,799.112183 
	C895.297668,798.504761 895.772766,798.371826 896.650879,798.507812 
	C901.225586,799.099854 905.438293,798.981018 910.078979,798.649780 
	C912.803223,798.943420 915.098999,799.183105 917.689880,799.708984 
	C914.554749,802.513489 910.602600,800.942200 906.910645,801.410217 
	C904.707642,801.689453 901.795532,800.481201 900.556335,802.933655 
	C899.265320,805.488464 901.377747,807.595581 903.058594,809.909424 
	C903.414001,811.553650 902.346252,811.920959 901.266663,812.742432 
	C900.982178,812.993591 900.533142,812.934082 900.307373,812.951782 
	C900.081543,812.969421 899.752380,812.846069 899.578613,812.819458 
	C898.369934,812.427917 897.228821,812.282104 896.282227,811.085449 
	C896.103455,810.804993 896.048767,810.897339 896.099670,810.914307 
	C895.753113,810.719971 895.438965,810.419189 895.117554,809.719482 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M907.930054,834.187622 
	C905.953430,840.076965 906.732666,845.923279 907.337280,851.525513 
	C907.761475,855.456055 911.769409,851.961365 914.276550,853.071289 
	C915.298889,856.034485 913.332092,856.223816 911.457520,855.712646 
	C909.403809,855.152710 905.976562,856.819092 905.736938,852.799866 
	C905.401733,847.176575 905.188965,841.546021 904.994568,835.145386 
	C905.202393,834.208252 905.339355,834.044373 905.750488,833.714111 
	C906.677551,833.372009 907.281311,833.454163 907.930054,834.187622 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M909.331787,825.831421 
	C907.601562,825.221985 905.619995,826.096008 904.998840,823.726929 
	C904.725220,822.683044 903.512695,821.761353 904.197510,820.607788 
	C904.769226,819.644897 905.979370,820.033447 906.902405,820.110901 
	C910.389282,820.403564 914.903137,819.128723 914.892090,825.478882 
	C913.201233,828.686646 911.411865,826.825012 909.331787,825.831421 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M908.872070,826.017456 
	C910.956665,823.963440 912.470642,827.148499 914.623169,826.009766 
	C914.861145,828.036621 914.820435,830.193359 914.613159,832.705078 
	C911.741211,833.683777 908.974548,832.903992 905.993042,833.622437 
	C905.610474,834.025818 905.499146,834.223572 905.228455,834.722107 
	C905.069092,835.022888 904.960571,835.061523 904.918152,835.022339 
	C904.457214,834.701538 904.038635,834.419800 903.376526,834.071411 
	C903.132935,834.004761 902.909424,834.030396 902.797546,834.018677 
	C902.286072,833.447388 901.940979,832.865356 901.943237,831.809814 
	C901.752869,831.258240 901.680420,831.005981 901.784485,830.512207 
	C903.444275,829.539978 902.965515,828.026794 903.139160,826.318542 
	C903.695862,826.360657 904.196045,826.807800 904.960083,827.463623 
	C905.597717,827.981995 905.856689,828.379639 906.057983,828.811829 
	C906.349243,829.437378 906.850403,829.770081 907.503662,829.910889 
	C907.453918,829.187622 906.545776,828.880310 906.736938,827.786987 
	C907.474243,827.103271 908.098267,826.727600 908.872070,826.017456 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M1013.344116,1018.440857 
	C1002.478333,1019.372314 991.185181,1020.716797 979.800354,1019.682129 
	C990.827087,1019.068359 1001.789795,1017.349487 1013.344116,1018.440857 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M1007.169556,857.400635 
	C1008.699036,856.668396 1010.089233,856.297363 1011.850708,855.907715 
	C1013.071289,858.639343 1015.697205,860.890991 1014.260437,864.537720 
	C1013.700317,865.224182 1013.359558,865.464172 1012.614624,865.550903 
	C1012.095154,865.464783 1011.893372,865.404236 1011.882080,865.091553 
	C1008.053101,864.146423 1008.445618,860.310181 1007.169556,857.400635 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M931.932922,878.953491 
	C931.543762,878.846558 931.559631,878.906860 931.563171,878.937866 
	C931.005432,878.828186 930.481018,878.601929 930.037170,877.861755 
	C928.917847,875.224609 926.966431,873.415466 926.824341,870.398071 
	C927.591858,870.080933 928.237732,870.118408 929.186646,870.161621 
	C929.489624,870.167358 929.791565,870.151184 929.989441,870.546204 
	C931.625000,874.464966 934.068420,877.068420 937.725098,879.012329 
	C938.675476,879.317993 939.037476,879.737000 939.078735,880.615356 
	C936.469971,881.259216 934.496216,879.795227 931.932922,878.953491 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M945.694458,747.141968 
	C945.725464,745.309631 944.373840,743.570251 946.993469,741.772095 
	C948.599670,747.153442 950.132507,752.289001 951.317871,757.719604 
	C947.264221,755.468384 947.601074,750.956726 945.694458,747.141968 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M953.520264,891.921997 
	C953.040833,891.583618 953.059021,891.271606 953.100891,890.727173 
	C958.382996,890.458435 963.686340,890.304382 968.981445,890.449158 
	C971.152222,890.508484 973.778564,889.915405 975.104370,893.042969 
	C968.101868,892.414246 961.040955,892.153687 953.520264,891.921997 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M1015.910278,865.742554 
	C1016.762878,866.621277 1017.582886,867.266479 1017.605286,867.938293 
	C1017.669006,869.848877 1020.797546,871.469971 1018.216858,873.571350 
	C1017.507446,874.148926 1016.345032,875.178833 1015.680664,874.287781 
	C1014.253723,872.373779 1012.027222,870.574829 1013.121460,867.317322 
	C1012.977051,865.050659 1014.347595,865.460144 1015.910278,865.742554 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M913.248169,879.849854 
	C913.844299,880.139832 914.092468,880.326050 914.396729,880.692139 
	C914.602844,881.321045 914.710571,881.829712 914.697510,882.696899 
	C913.842651,882.877991 912.039978,880.926392 912.564880,882.869751 
	C914.468933,889.919189 909.969971,889.051880 905.445740,889.021729 
	C903.546387,887.648438 903.651611,885.978821 904.189209,883.875000 
	C904.651367,882.992615 905.085571,882.756287 906.016174,882.970276 
	C907.514648,883.600159 909.362122,887.228088 909.386780,882.503906 
	C909.400085,879.960632 910.179321,878.637329 913.248169,879.849854 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M998.250488,853.546875 
	C990.307434,853.831421 982.343689,853.831421 974.379944,853.831421 
	C974.366882,853.635132 974.353882,853.438904 974.340820,853.242615 
	C981.701538,852.845032 989.062256,852.447388 996.903931,851.995300 
	C997.666504,852.381287 997.948181,852.821777 998.250488,853.546875 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M991.847656,938.105652 
	C992.003601,938.635437 991.737061,939.113281 991.283691,939.790344 
	C988.517578,944.155762 991.118835,949.000977 989.462646,953.442810 
	C986.415771,948.640686 987.652649,939.544434 991.847656,938.105652 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M873.631775,747.778687 
	C879.440613,748.791626 874.858093,752.697388 875.915894,755.573608 
	C875.510376,757.347168 875.078979,758.696289 874.513794,760.297729 
	C874.380066,760.550049 874.279297,760.640198 874.279358,760.707825 
	C873.580811,760.426697 872.972473,759.966797 872.331299,758.987061 
	C871.181824,755.511597 872.301636,752.526794 872.890991,749.123291 
	C873.116455,748.516357 873.234863,748.284424 873.631775,747.778687 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M929.802979,825.700317 
	C932.099854,826.048157 933.847412,826.830078 935.900208,826.106934 
	C937.778015,825.445435 939.761414,825.860168 940.977112,828.703613 
	C937.394287,827.992188 934.200989,828.065735 930.920288,829.899048 
	C930.267639,829.946228 929.984070,829.870361 929.319580,829.571289 
	C928.304810,828.630798 928.149109,827.790710 928.477905,826.463501 
	C928.897034,825.887329 929.140808,825.718872 929.802979,825.700317 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M929.931763,825.596008 
	C930.044189,825.903381 929.867065,825.956482 929.413086,825.991211 
	C928.110413,826.830017 927.386597,827.733032 928.988159,828.953857 
	C929.522095,829.114258 929.754883,829.263245 930.269409,829.717163 
	C929.337158,831.051453 928.123230,832.080933 926.621460,833.229248 
	C926.116699,833.385010 925.899841,833.421936 925.481079,833.197876 
	C925.319214,831.971069 925.619568,830.927063 925.356567,830.052307 
	C923.818787,824.936340 923.869934,824.843933 929.931763,825.596008 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M905.473938,882.791870 
	C905.157837,884.703857 905.068909,886.418091 904.995178,888.561646 
	C905.015137,889.506836 905.019897,890.022766 905.062134,890.923828 
	C905.099609,891.308960 905.192749,891.666077 905.114319,891.833130 
	C904.420715,892.122742 903.805542,892.245239 902.761108,892.563477 
	C902.216736,892.523987 902.101624,892.288879 901.890747,891.671570 
	C901.675171,890.503052 901.654419,889.710327 901.628418,888.514099 
	C901.618347,885.930969 901.242920,883.716492 902.381958,881.252075 
	C902.628174,878.407837 904.238586,878.114502 906.570374,878.351929 
	C907.278564,878.673157 907.466858,879.022583 907.424561,879.761230 
	C906.881653,880.955200 906.279236,881.766724 905.473938,882.791870 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M969.320801,806.177490 
	C963.537598,806.883911 957.742188,807.293213 951.521606,807.649353 
	C950.728271,807.349792 950.546204,807.010559 950.798096,806.336914 
	C956.650574,805.485657 962.410645,806.382874 968.104614,804.319214 
	C969.167786,804.264160 969.094788,805.149597 969.320801,806.177490 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M893.106445,802.079590 
	C890.832947,797.465393 888.886169,792.609741 886.982666,787.375244 
	C889.650024,787.092041 888.804504,791.048523 891.892212,791.118164 
	C892.260742,791.197998 892.342468,791.608459 892.231567,791.785889 
	C891.185120,793.896667 892.742126,795.263916 893.330566,796.797668 
	C893.995972,798.531860 894.253052,800.137817 893.106445,802.079590 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M948.135864,858.323364 
	C948.331482,857.943359 948.512390,857.944214 948.964417,857.959717 
	C952.487915,863.822144 951.937378,869.322327 947.381104,874.268677 
	C948.995178,869.047363 951.113037,864.056396 948.135864,858.323364 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M919.666504,823.352417 
	C919.639282,821.567627 917.897766,819.505127 921.529480,819.842651 
	C924.603455,820.128357 927.724976,819.901550 931.011902,819.901550 
	C930.441956,821.472473 929.373230,821.099426 928.642517,821.035034 
	C925.354980,820.745728 922.420532,820.828735 921.174194,824.775085 
	C920.889709,825.675659 919.657104,826.875610 918.506836,825.645020 
	C917.914307,825.011047 918.934143,824.257446 919.666504,823.352417 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M1024.287720,893.647705 
	C1022.097351,895.001953 1019.914429,895.971802 1017.378662,897.051880 
	C1016.580688,897.456787 1016.102844,897.526123 1015.366333,897.067444 
	C1016.788513,891.927795 1020.468567,892.403931 1024.287720,893.647705 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M984.830322,867.065918 
	C991.197388,866.693542 997.428467,867.532898 1003.974487,866.205566 
	C1004.578735,866.408752 1004.834778,866.879456 1005.087646,867.636292 
	C998.710205,869.436462 992.336548,867.900574 985.514160,867.862061 
	C984.936523,867.647949 984.807129,867.489868 984.830322,867.065918 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M951.681519,880.379089 
	C954.131897,876.055847 954.071289,881.969971 955.889160,881.041382 
	C955.626587,883.622559 954.367737,885.582825 951.377808,886.481934 
	C951.035095,885.026611 951.052429,883.471497 951.044312,881.450195 
	C951.018860,880.984009 950.999329,881.031494 950.973633,881.031433 
	C951.108276,880.883301 951.268555,880.735229 951.681519,880.379089 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M995.044678,801.728394 
	C995.037964,800.187561 995.019043,799.008240 994.999939,797.394165 
	C997.265930,800.347412 997.582581,804.459473 999.254883,808.475586 
	C997.650330,809.179321 995.773438,810.063904 995.930176,806.841064 
	C996.006348,805.275574 995.354736,803.674683 995.044678,801.728394 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M955.768860,846.844238 
	C958.174988,848.844360 958.157715,851.253540 957.843506,854.299377 
	C955.840393,852.508911 954.212219,849.872498 951.312988,851.999634 
	C951.205444,851.539368 951.097961,851.079163 950.996460,850.308228 
	C951.292542,849.415955 951.637451,848.882263 952.558350,848.516846 
	C953.895447,848.087158 954.330750,846.851685 955.768860,846.844238 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M917.944397,833.218018 
	C918.014832,831.197571 918.091614,829.626038 918.168335,828.054565 
	C919.093262,832.975037 921.584534,837.864868 917.950684,843.886902 
	C917.950684,839.752930 917.950684,836.709961 917.944397,833.218018 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M970.239319,884.428589 
	C970.744019,885.075256 970.827209,885.636414 970.881653,886.487061 
	C968.261292,886.610291 965.668152,886.462952 963.078430,886.270081 
	C961.660583,886.164551 960.378662,885.877625 961.571289,883.706909 
	C964.568542,883.765991 967.193176,884.054504 970.239319,884.428589 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M905.216064,834.202820 
	C907.443054,830.723511 910.695068,832.562195 914.067627,832.895142 
	C914.467224,833.508362 914.487732,833.956665 914.514221,834.741455 
	C914.262878,835.192627 914.005676,835.307251 913.348022,835.287231 
	C911.584961,834.973999 910.222290,834.795410 908.451172,834.550903 
	C907.365356,834.476929 906.688049,834.468811 905.717529,834.650635 
	C905.428894,834.670349 905.433289,834.500061 905.216064,834.202820 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M989.646118,888.613892 
	C990.026489,889.077271 990.015076,889.257690 989.992615,889.708801 
	C986.641174,890.657837 982.165710,888.953125 981.031799,894.636475 
	C979.439514,894.154114 979.864075,892.201904 978.788513,890.675598 
	C978.766235,890.170837 978.845337,889.986145 978.964111,889.502686 
	C982.261230,887.041382 985.797424,888.151306 989.646118,888.613892 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M1007.207397,792.448303 
	C1011.345520,795.627136 1011.615662,800.752136 1012.313354,805.778809 
	C1010.442566,801.580688 1008.857178,797.192871 1007.207397,792.448303 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M877.457947,763.002625 
	C878.228271,763.997559 877.299805,765.598633 879.427185,766.068604 
	C880.166016,766.833923 880.539124,767.571716 880.969849,768.616211 
	C880.858093,769.805603 880.688599,770.688416 880.256470,771.789185 
	C878.026001,769.561462 876.890686,766.721497 876.030518,763.367676 
	C876.378723,763.004578 876.771240,763.004211 877.457947,763.002625 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M1000.026489,856.625122 
	C995.367676,856.908630 990.691162,856.903503 985.554626,856.878906 
	C984.699463,856.581604 984.548706,856.205750 984.924683,855.551575 
	C989.716187,855.443176 994.224854,855.515137 999.009705,855.261719 
	C999.526855,855.403137 999.767761,855.869873 1000.026489,856.625122 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M912.962646,835.578430 
	C913.208557,835.115173 913.469421,835.077820 914.125244,835.059265 
	C915.620056,839.679504 914.889404,844.329529 914.844421,849.411621 
	C914.192810,845.243408 913.585266,840.623840 912.962646,835.578430 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M982.691833,906.031128 
	C983.158997,905.944092 983.328613,905.981689 983.754150,905.970520 
	C984.422363,905.583008 984.890198,905.464905 985.709290,905.802490 
	C986.729248,906.846313 988.352417,906.849243 988.103821,908.807678 
	C986.412781,909.001038 984.770569,908.980225 983.188965,908.660156 
	C981.697876,908.358521 980.660461,907.621094 982.691833,906.031128 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M885.098877,774.374146 
	C887.938599,774.597656 890.833618,775.202576 893.951294,776.160767 
	C891.152649,776.003357 887.432190,779.079163 885.098877,774.374146 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M955.955261,846.684448 
	C955.304932,847.599792 954.561096,848.193481 953.527039,848.849670 
	C953.014771,848.807556 952.792725,848.702881 952.784180,848.298157 
	C953.949036,846.026306 951.461975,844.063904 953.336670,841.953613 
	C955.162598,842.975464 955.243835,844.797241 955.955261,846.684448 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M906.573364,827.429565 
	C907.576477,829.815247 910.213379,828.298828 911.287109,830.212646 
	C909.174927,829.890137 906.184875,833.618347 905.185669,828.022034 
	C905.581360,827.575012 905.938965,827.477661 906.573364,827.429565 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M946.406616,775.753418 
	C945.928650,773.960205 946.552917,772.499329 947.983765,771.047546 
	C949.665771,771.049683 948.639526,772.855408 949.979980,773.440063 
	C950.320679,774.155029 950.422119,774.618774 950.202637,775.391846 
	C948.924622,775.726257 947.863159,775.773132 946.406616,775.753418 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M964.912109,755.632202 
	C963.812439,750.239990 967.506897,754.018677 969.010925,752.892395 
	C969.249451,755.339111 967.359741,754.906799 966.260254,755.845398 
	C965.707458,755.921936 965.422241,755.804382 964.912109,755.632202 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M1012.238220,928.439514 
	C1014.616455,928.204529 1017.210571,928.204529 1020.083862,928.204529 
	C1018.815002,930.294983 1016.715698,929.885803 1014.628418,930.392578 
	C1013.655090,929.853333 1013.054626,929.263916 1012.238220,928.439514 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M956.280273,769.705322 
	C953.061829,768.945312 953.494263,765.752502 952.062439,763.347290 
	C952.388977,762.646301 952.821289,762.508789 953.605469,762.763062 
	C954.281921,763.773438 954.668457,764.573425 955.197388,765.675537 
	C956.384766,766.892944 957.095581,767.924194 956.280273,769.705322 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M957.287292,759.015198 
	C956.907837,758.360962 956.825439,757.699524 956.848450,757.041809 
	C956.896667,755.663208 953.991882,754.332947 955.984863,753.349060 
	C958.403503,752.155273 957.610168,755.518982 958.976074,756.705200 
	C959.011597,757.954407 958.772522,758.829773 957.287292,759.015198 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M939.294067,880.906372 
	C938.689819,880.470947 938.429810,880.060242 938.101196,879.415588 
	C939.345459,877.157532 941.764343,878.555908 943.711182,877.743530 
	C943.191467,879.932251 940.916687,879.674011 939.294067,880.906372 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M956.026917,769.990723 
	C955.839294,768.894531 955.642700,767.777649 955.392944,766.319092 
	C958.375732,766.460876 959.963806,767.697388 957.552002,770.926147 
	C956.802979,771.015564 956.502136,770.833191 956.160278,770.198181 
	C955.972107,769.970154 956.017944,769.969910 956.026917,769.990723 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M990.227051,837.567505 
	C987.470703,837.710083 985.883972,836.393433 986.489563,832.941772 
	C987.831543,834.130798 988.971008,835.690002 990.227051,837.567505 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M986.959839,776.673584 
	C986.276428,776.989136 985.545105,776.981018 984.448975,776.957886 
	C983.623169,775.944641 983.162048,774.946472 982.598511,773.634399 
	C983.082275,773.218140 983.668518,773.115845 984.700806,772.994446 
	C985.735107,774.100220 986.323547,775.225098 986.959839,776.673584 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M976.224121,903.900024 
	C975.897644,904.002747 975.714417,904.011475 975.256226,904.026123 
	C972.413757,903.752136 972.994507,901.765503 972.986084,899.741211 
	C973.230286,899.076721 973.368347,898.826965 973.847900,898.319153 
	C974.575500,898.050659 974.961670,898.040161 975.637451,898.029968 
	C976.037109,899.018250 976.146973,900.006287 976.204407,901.365601 
	C976.227661,902.020813 976.303467,902.304749 976.346313,903.028137 
	C976.313354,903.467651 976.367371,903.806030 976.224121,903.900024 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M982.953247,815.208374 
	C987.418152,814.999817 983.443909,818.033630 984.953674,819.193237 
	C982.821167,818.614197 983.215088,816.935303 982.953247,815.208374 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M900.530518,819.099243 
	C900.147583,822.292969 897.548767,820.928162 895.224121,821.244812 
	C894.545105,820.173401 894.545105,820.173401 896.903381,819.303955 
	C898.085693,819.040771 899.116028,819.048706 900.530518,819.099243 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M969.617554,762.477661 
	C968.771423,763.090820 968.074036,763.424622 967.170288,763.967163 
	C965.439575,764.307434 964.547119,763.944153 965.701050,761.983398 
	C967.170898,761.304260 968.356812,760.842407 969.791321,760.692261 
	C969.948730,761.402100 969.857544,761.800232 969.617554,762.477661 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M952.692139,847.991272 
	C952.997681,847.998169 953.188354,848.436890 953.212524,848.674561 
	C952.680298,849.188416 952.123840,849.464661 951.284912,849.869263 
	C950.103882,848.852295 948.369324,848.031311 949.753418,845.788330 
	C950.805664,846.311096 951.596130,847.147766 952.692139,847.991272 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M895.976562,811.141907 
	C898.205505,808.400696 898.293579,811.166687 899.272095,812.390198 
	C898.777344,813.113770 898.149780,813.434753 897.198242,813.896851 
	C896.060791,813.373901 895.929810,812.436523 895.976562,811.141907 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M962.456665,875.917419 
	C963.562744,875.673279 964.501587,875.804016 965.783081,876.043762 
	C966.404419,876.499207 966.528625,876.890991 966.288513,877.599854 
	C964.988159,877.892090 963.872253,877.920044 962.337097,877.917847 
	C962.041687,877.355896 962.165588,876.824097 962.456665,875.917419 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M979.760132,787.220703 
	C981.331238,788.049500 980.183472,788.980347 979.985840,790.265625 
	C978.798645,790.987122 977.558777,790.836731 977.332397,789.585266 
	C977.103699,788.321472 978.603943,788.010925 979.760132,787.220703 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M1016.182922,865.546753 
	C1015.358093,866.124390 1014.409241,866.284790 1013.225708,866.723145 
	C1012.579407,866.950134 1012.167786,866.899170 1011.695435,866.525635 
	C1011.658203,865.925232 1011.681763,865.647522 1012.094482,865.216797 
	C1012.896667,865.056213 1013.309631,865.048584 1013.844971,864.958130 
	C1014.718811,864.512878 1015.506958,863.850281 1016.182922,865.546753 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M952.848877,855.651733 
	C954.504944,857.159485 954.019653,858.634827 953.655090,861.596497 
	C952.882080,859.048157 952.528442,857.882385 952.133545,856.378906 
	C952.241333,855.841614 952.390381,855.641907 952.848877,855.651733 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M944.392456,877.971069 
	C942.988098,875.676697 945.578308,875.417908 946.687439,874.058411 
	C947.858765,876.256409 945.560547,876.638794 944.392456,877.971069 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M944.597412,881.600830 
	C943.639038,883.989136 941.536621,883.127869 939.277283,882.337646 
	C940.756470,881.940430 942.473511,881.845947 944.597412,881.600830 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M914.467346,883.441528 
	C914.576660,883.055420 914.540527,883.046387 914.523499,883.053467 
	C914.681274,884.765015 915.473694,886.454224 914.636414,888.302124 
	C913.463074,886.799622 914.375854,885.284302 914.467346,883.441528 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M897.025146,798.389160 
	C896.560425,798.678223 896.109436,798.730469 895.327515,798.867920 
	C894.302002,798.745911 893.911865,798.258484 893.871216,797.279114 
	C894.757385,797.032654 895.503418,797.085266 896.626099,797.171265 
	C897.013916,797.520569 897.026001,797.836487 897.025146,798.389160 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M1017.063721,890.273499 
	C1018.210938,890.080872 1019.126221,890.080872 1020.960754,890.080872 
	C1018.977539,891.114136 1017.910828,891.305542 1017.063721,890.273499 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M923.300903,835.897095 
	C922.984619,837.081543 922.273132,837.983704 921.671082,837.674500 
	C920.685364,837.168396 921.541931,836.419861 922.259827,835.708801 
	C922.786804,835.543091 923.056702,835.517090 923.300903,835.897095 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M924.669312,834.006836 
	C924.712891,834.789062 924.271606,835.428345 923.552795,836.185303 
	C923.150513,836.179749 923.025757,836.056458 922.708923,835.751160 
	C923.072693,835.000671 923.628540,834.432251 924.669312,834.006836 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M953.854248,762.670288 
	C953.480408,762.984070 953.065491,762.994751 952.339294,762.999023 
	C951.903870,762.544189 951.779785,762.095703 951.816284,761.333862 
	C952.328857,760.922180 952.680908,760.823975 953.286255,760.950684 
	C953.630798,761.572815 953.722046,761.969971 953.854248,762.670288 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M1015.090576,897.109070 
	C1015.559082,896.853699 1015.977783,896.942871 1016.711182,897.097168 
	C1017.019470,897.529724 1017.013062,897.897156 1017.018066,898.539795 
	C1016.568237,898.881042 1016.107056,898.947144 1015.303833,898.927185 
	C1014.988159,898.378601 1015.014465,897.916138 1015.090576,897.109070 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M955.803589,770.300293 
	C956.281433,770.159607 956.590820,770.349121 957.065369,770.771606 
	C957.222107,771.465454 957.213623,771.926331 957.121643,772.672852 
	C955.856079,772.613098 955.832397,771.569458 955.803589,770.300293 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M987.964111,827.317383 
	C988.902527,827.380798 989.257019,828.056702 988.935486,828.965271 
	C988.893860,829.082764 988.264526,829.141479 988.246277,829.094788 
	C988.071899,828.649414 987.970642,828.175537 987.964111,827.317383 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M950.674988,758.302307 
	C952.838196,757.940552 952.391724,759.479553 952.343567,760.755249 
	C950.536987,760.808105 950.652954,759.564148 950.674988,758.302307 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M985.995117,823.306763 
	C986.383728,823.420105 986.754395,823.852295 987.008484,824.692627 
	C986.586975,824.609009 986.282043,824.117310 985.995117,823.306763 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M953.110718,855.599670 
	C952.981140,855.895447 952.803894,855.929749 952.359497,856.002686 
	C952.075989,855.517090 951.820312,854.884033 952.584534,854.688965 
	C952.682495,854.663940 952.900635,855.110291 953.110718,855.599670 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M987.071228,824.941956 
	C987.434937,825.370056 987.737854,825.849792 988.060303,826.627319 
	C988.079834,826.924988 987.994629,827.002563 987.948486,827.041504 
	C987.585876,826.618347 987.269287,826.156311 986.922363,825.397461 
	C986.891968,825.100769 987.010376,824.993652 987.071228,824.941956 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M956.978027,773.015259 
	C957.229309,773.277954 957.511658,773.514038 957.753845,773.785828 
	C957.771729,773.805969 957.501526,774.082703 957.365295,774.240173 
	C957.253723,773.981873 957.142212,773.723572 957.034424,773.211914 
	C957.038208,772.958557 956.999084,772.997498 956.978027,773.015259 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M950.287903,775.705383 
	C950.000549,775.240295 950.015015,774.801147 950.079407,774.035950 
	C950.912781,774.240234 951.161621,774.892334 950.287903,775.705383 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M1009.108521,928.362305 
	C1009.173096,928.186340 1009.336060,928.141907 1009.745850,928.155029 
	C1009.992676,928.212646 1009.656494,928.550354 1009.656494,928.550354 
	C1009.656494,928.550354 1009.207031,928.493774 1009.108521,928.362305 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M991.101318,928.076599 
	C991.059631,927.897461 991.552002,927.949097 991.770447,928.065674 
	C991.706970,928.206726 991.424988,928.231201 991.101318,928.076599 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M1014.055054,1018.800415 
	C1013.797363,1018.764404 1013.743896,1018.498291 1013.770386,1018.365173 
	C1014.201355,1018.235046 1014.883362,1018.001160 1014.055054,1018.800415 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M925.115356,833.134277 
	C925.464050,832.980774 925.648987,833.024658 926.083801,833.208313 
	C926.182983,833.659851 925.947876,833.882507 925.391235,834.082886 
	C925.154175,834.149780 924.984131,833.986877 924.896484,833.905518 
	C924.856445,833.659973 924.904053,833.495789 925.115356,833.134277 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M946.022461,762.713501 
	C945.748169,762.759644 945.503540,762.513611 945.191101,762.010010 
	C945.432861,761.975464 945.742432,762.198425 946.022461,762.713501 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M971.198975,759.968140 
	C971.076477,759.784851 971.172363,759.508484 971.550293,759.154907 
	C971.874878,759.437622 971.736572,759.703430 971.198975,759.968140 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M970.283691,761.030212 
	C969.569519,760.514465 969.660095,760.092224 970.659424,759.876465 
	C970.896851,760.317322 970.739136,760.664734 970.283691,761.030212 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M985.312744,822.159180 
	C985.199646,821.572876 985.168396,820.962463 985.882690,821.770508 
	C985.795044,822.105164 985.655640,822.225708 985.312744,822.159180 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M946.917908,764.694702 
	C946.670959,764.710571 946.447632,764.437073 946.162720,763.900635 
	C946.381287,763.893555 946.661438,764.149414 946.917908,764.694702 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M985.160767,822.214478 
	C985.109253,821.972107 985.522339,821.979187 985.728394,821.981873 
	C985.972717,822.149902 986.010925,822.315186 986.031128,822.734253 
	C986.013123,822.987976 986.001038,822.999084 985.995605,823.003784 
	C985.627808,822.969910 985.368469,822.786011 985.160767,822.214478 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M976.413269,903.257019 
	C976.236938,903.184021 976.160583,902.900452 976.118103,902.176880 
	C976.272339,902.173401 976.392761,902.609863 976.413269,903.257019 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M921.924194,874.235474 
	C922.335510,874.101685 922.485352,874.323242 922.253662,874.775513 
	C922.132263,874.883667 921.922791,874.468140 921.924194,874.235474 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M1012.378418,865.012207 
	C1012.375854,865.278748 1012.268066,865.493652 1011.897461,865.955750 
	C1011.623535,865.856323 1011.612488,865.509583 1011.837036,865.001160 
	C1012.072571,864.839417 1012.273193,864.960571 1012.378418,865.012207 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M781.830811,87.273819 
	C785.343445,88.261383 786.354431,83.857330 789.623840,84.010269 
	C790.421448,84.411369 790.804260,84.891731 791.455872,84.924461 
	C791.610657,84.932251 791.716858,84.807777 791.702393,84.797089 
	C791.332520,84.524300 790.859863,84.584259 790.226685,84.209679 
	C789.998352,83.544472 789.999207,83.087120 790.001221,82.286743 
	C790.985779,80.293991 792.052795,78.794899 794.676453,79.755966 
	C794.995117,79.985558 795.000000,80.000458 795.007324,80.002670 
	C795.761841,80.839729 796.598633,81.121635 797.802124,80.212204 
	C799.094177,79.356522 800.509949,79.119728 800.958496,77.320190 
	C801.444458,77.001122 801.888916,77.002548 802.906006,77.211998 
	C803.946899,78.171333 803.964722,79.026649 804.111816,80.173965 
	C805.814941,82.691635 807.452393,84.900818 810.027161,86.880852 
	C810.397217,84.110222 812.443726,82.681335 814.461792,80.416710 
	C818.808411,78.612572 822.266052,79.100685 825.635925,81.962151 
	C826.164917,82.161812 826.344543,82.323631 826.265869,82.739891 
	C826.006409,83.165314 826.005310,83.336288 826.000916,83.763710 
	C824.997375,84.915138 823.864563,85.226250 822.244995,84.672890 
	C820.724976,84.163841 819.939636,81.883934 818.018311,83.973389 
	C816.846680,85.152725 814.819763,86.324638 817.308411,87.325356 
	C820.608521,88.652412 820.344116,90.470688 818.761108,93.105743 
	C818.481750,93.427711 818.415649,93.598267 818.435791,93.500748 
	C820.424072,91.100624 822.078613,88.948555 818.011963,87.183380 
	C817.135315,86.802879 817.153931,85.527748 817.779602,84.268562 
	C818.523621,83.474144 819.154480,83.243202 820.224121,83.460228 
	C821.683594,84.834190 823.631348,84.936546 824.775391,86.746414 
	C825.461060,87.336411 825.926025,87.646408 826.683167,87.978661 
	C827.726013,88.811470 828.557678,89.137466 829.772156,88.224907 
	C830.180298,87.748390 830.377686,87.479706 830.799438,87.093903 
	C832.108459,85.988091 833.364807,85.205551 834.710693,84.085007 
	C838.695862,83.547844 838.702759,88.021164 841.623230,88.745590 
	C839.632812,89.737762 837.922363,91.635452 836.485779,88.013374 
	C835.773132,86.216721 834.500366,86.881630 832.933838,90.945770 
	C832.106384,93.217812 833.989746,95.891037 830.547791,96.367722 
	C829.599976,95.387199 828.593567,95.076714 827.522827,94.469345 
	C827.345276,94.346840 827.271179,94.058685 827.271179,94.058685 
	C827.271179,94.058685 827.082092,94.271500 827.279419,94.324112 
	C828.018127,94.962646 828.847961,95.048203 829.708374,95.739922 
	C830.710632,96.717468 831.452881,97.480713 832.363403,98.373489 
	C832.520752,98.513824 832.799011,98.726067 832.799011,98.726067 
	C832.799011,98.726067 832.621704,98.518745 832.493530,98.268555 
	C832.169617,96.277756 832.943542,95.376663 835.348755,95.661667 
	C834.806396,98.497803 836.536987,99.246147 838.908264,100.187439 
	C839.636597,100.812935 839.749939,101.208595 839.754150,101.930740 
	C839.663330,102.425659 839.599487,102.616409 839.385376,103.059372 
	C839.022217,103.619904 838.928223,103.957710 839.124817,104.574249 
	C839.355774,104.986824 839.443787,105.157249 839.646118,105.594208 
	C840.079834,106.614471 840.646484,107.201675 841.177246,108.185684 
	C841.012451,109.225014 840.468262,109.616096 839.464844,109.986290 
	C838.407593,110.205490 837.693909,110.195961 836.635254,110.041069 
	C835.867554,109.828651 835.464417,109.641899 834.855469,109.204224 
	C834.227051,108.692337 833.907715,108.221786 833.095215,108.522644 
	C832.784546,108.831070 832.668335,108.969284 832.376282,109.324417 
	C831.834534,109.986992 831.441772,110.412262 831.001099,111.176544 
	C830.723206,111.592239 830.602539,111.751480 830.257690,112.106033 
	C829.397705,112.669624 828.578674,112.778450 828.124878,113.830612 
	C827.926697,114.268585 827.844299,114.443962 827.611206,114.870667 
	C826.979614,115.740448 826.388672,116.260559 825.713379,117.102066 
	C825.268433,117.636253 824.993103,117.924255 824.479980,118.401962 
	C823.632080,119.128647 823.021362,119.667702 822.149902,120.386719 
	C821.497925,120.744720 821.091248,120.873451 820.344238,120.982513 
	C819.579163,120.993439 819.148315,120.920639 818.423950,120.665634 
	C817.951172,120.395073 817.779480,120.259697 817.399841,119.875076 
	C816.810059,119.134468 816.534485,118.549736 815.702148,118.061394 
	C815.273560,117.782341 815.104248,117.668495 814.693237,117.370216 
	C813.838562,116.658257 813.188843,116.190468 812.106812,115.835175 
	C809.467407,115.155983 807.987244,113.499535 806.419678,111.409142 
	C805.395081,110.391045 804.628784,109.595863 803.675537,108.675507 
	C803.508179,108.530952 803.445374,108.203575 803.445374,108.203575 
	C803.445374,108.203575 803.218262,108.460167 803.423096,108.546173 
	C804.341980,109.373444 805.069458,110.101273 806.058105,111.061829 
	C807.335144,113.199730 805.999390,114.187408 804.927307,115.466461 
	C802.832825,117.965401 799.869263,119.566109 797.849609,122.579651 
	C797.048218,123.659683 795.379211,124.283302 797.409729,125.745865 
	C798.845703,127.108490 799.992493,128.279251 799.625793,130.473358 
	C797.802856,133.406143 794.482544,133.295914 791.997192,135.284851 
	C790.816833,135.970123 789.870605,136.004166 788.548035,135.645935 
	C787.083374,134.825775 786.381042,133.775711 785.537048,132.368591 
	C785.158447,131.300705 785.147827,130.572037 785.562012,129.544861 
	C786.325073,128.295349 787.700989,128.254715 788.553894,126.257355 
	C787.802185,127.844078 787.055054,128.045914 786.271606,128.740875 
	C785.334839,129.726044 784.470581,129.991425 783.136963,129.860092 
	C782.579041,129.688477 782.367615,129.586487 781.912476,129.231995 
	C781.501282,128.545227 781.433350,128.097519 781.605225,127.320267 
	C782.436768,125.934914 783.564026,125.228943 784.426392,123.890526 
	C785.039917,122.960274 785.225159,122.262947 784.582886,121.259575 
	C783.813416,119.897591 783.088562,118.883041 781.876465,117.846863 
	C780.925720,117.029701 780.185730,116.794724 779.089966,117.612938 
	C776.012207,120.081139 773.588013,122.697754 771.393677,125.977676 
	C766.594055,127.095314 766.122131,126.686447 767.581970,122.779869 
	C767.942200,121.815781 767.718750,121.317886 766.910706,120.485626 
	C765.242798,118.237335 763.219177,116.803146 761.304810,114.817566 
	C760.250916,113.815331 759.369141,113.659676 758.097534,114.443130 
	C757.155334,114.803970 756.497253,114.832924 755.518066,114.591843 
	C754.355530,114.083023 753.609619,113.080162 752.283447,114.218346 
	C751.192383,116.164345 746.716614,115.566032 749.112122,119.553146 
	C749.674683,120.468994 749.821777,121.154373 749.735718,122.238342 
	C749.571106,122.818787 749.471252,123.040619 749.146973,123.549225 
	C747.280334,125.259354 746.018555,126.938560 745.007568,128.888626 
	C743.713013,131.385696 741.724731,133.022522 738.325867,132.616272 
	C735.120239,130.265732 732.936340,127.933838 736.528015,124.492615 
	C737.938171,123.141495 737.336121,121.878128 736.241638,120.604523 
	C734.945801,119.096550 733.702820,117.551483 731.761963,116.225555 
	C731.288391,115.914108 731.102905,115.783249 730.651367,115.444283 
	C729.142944,113.952988 727.981873,114.691566 726.911804,115.459122 
	C724.994263,116.834610 723.007385,116.943512 720.588989,115.854584 
	C720.098816,115.545029 719.920593,115.395782 719.567993,114.946655 
	C718.685181,112.338203 721.606567,110.018532 719.037415,107.459717 
	C718.148804,106.574646 720.458008,104.853127 721.408508,103.202225 
	C722.826233,102.027176 723.016541,101.071144 721.524414,99.766830 
	C721.031433,98.794456 720.907715,98.079224 720.941528,96.959473 
	C721.414185,94.840965 722.550293,94.061386 724.620239,94.194717 
	C725.232666,94.385834 725.475281,94.542557 725.612732,94.601891 
	C725.298828,94.132713 725.238464,93.722618 725.239990,93.011551 
	C725.333313,92.531158 725.397766,92.341690 725.626953,91.895844 
	C726.480164,90.893753 727.380249,90.359230 728.127869,89.239052 
	C728.450989,88.833656 728.587097,88.675117 728.939026,88.292587 
	C730.224915,87.212929 730.126770,86.487091 728.457275,85.444138 
	C727.360779,81.818718 730.772217,81.479156 731.984680,79.514778 
	C734.674561,75.156914 734.913757,82.332451 737.626953,80.995438 
	C738.833557,81.644730 738.950989,82.555550 738.875000,83.855095 
	C738.732727,84.404831 738.647522,84.616272 738.369934,85.098251 
	C737.843018,85.808838 737.210449,86.106979 737.675171,87.045746 
	C738.010010,87.394455 738.149292,87.531891 738.482300,87.884529 
	C739.057861,88.441505 739.399719,88.941872 740.203979,88.218018 
	C740.560181,87.861923 740.708984,87.721237 741.115479,87.405243 
	C742.729797,86.615799 744.029968,85.927658 745.055298,84.335770 
	C745.445190,83.929291 745.617920,83.780067 746.101501,83.477783 
	C746.866028,83.206093 747.326843,83.153931 748.138550,83.253265 
	C748.685303,83.441803 748.889160,83.554176 749.304932,83.941330 
	C749.790222,84.875221 749.807861,85.543755 749.403198,86.500053 
	C748.788818,87.207718 748.355713,87.629982 747.791260,88.220451 
	C747.647522,88.376274 747.383484,88.680191 747.510803,88.494186 
	C748.057251,87.962952 748.434998,87.574173 749.040894,86.963448 
	C750.305054,85.873405 751.747375,86.209480 753.426514,85.265831 
	C755.178040,84.993317 756.181335,84.788109 757.160156,83.907219 
	C758.925476,82.318573 759.766113,83.303101 759.991455,85.636848 
	C759.445679,86.539055 758.902222,87.090729 758.291626,87.569092 
	C758.753479,87.256775 759.136719,86.855682 759.765137,86.233505 
	C761.589600,88.185272 766.806274,88.749481 763.257324,93.281937 
	C763.108704,93.471725 763.422852,94.260963 763.731873,94.519470 
	C764.265137,94.965576 765.189636,95.016342 765.432617,94.363319 
	C766.058960,92.680290 768.026794,91.765350 767.995300,89.374786 
	C771.187622,90.328583 771.784424,86.220833 774.878601,86.108459 
	C775.984070,86.434196 776.461182,86.637077 777.504211,86.184502 
	C779.235352,87.214668 781.037231,82.413437 781.998047,86.684212 
	C780.838379,88.524132 779.831421,90.169228 778.243164,91.749886 
	C777.803833,92.178642 777.596924,92.401276 777.406067,92.638344 
	C777.218567,92.871307 777.286011,92.793121 777.824219,92.179367 
	C779.426270,90.632675 780.754578,89.262962 781.830811,87.273819 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M839.249878,106.232811 
	C839.004883,105.986305 838.998535,105.488617 838.995483,105.239769 
	C838.616333,104.604309 838.471863,104.144859 838.780701,103.305069 
	C839.002441,102.997559 839.005249,102.514282 839.006287,102.272644 
	C839.721008,101.264030 840.514771,100.586815 841.617554,99.787231 
	C842.104553,99.609009 842.315979,99.590546 842.767700,99.780838 
	C843.449585,99.990105 843.891174,99.990616 844.956604,100.046310 
	C846.324158,100.359566 847.072021,100.566010 848.430481,100.138802 
	C849.748901,99.994072 850.495361,99.991470 851.831665,100.190796 
	C852.663025,100.893120 852.759277,101.415665 852.617188,102.120178 
	C852.572693,102.272568 852.640625,102.534454 852.791016,102.432770 
	C853.418945,102.217300 853.883728,102.262535 854.572876,102.617020 
	C855.345093,103.353706 855.895386,103.903732 856.603760,104.589233 
	C856.760193,104.726425 856.829285,104.978256 856.829285,104.978256 
	C856.829285,104.978256 857.022949,104.848984 856.857605,104.803101 
	C856.291748,104.232864 855.793457,103.801460 855.118530,103.111740 
	C854.453613,102.402077 854.228088,101.825233 854.286377,100.836639 
	C854.448914,100.315681 854.551819,100.119286 854.914368,99.711807 
	C855.542786,99.353600 855.920898,99.244972 856.546448,99.239471 
	C856.772644,99.254059 857.136169,99.373779 857.038879,99.179337 
	C856.598999,98.576241 856.140991,98.306488 855.366455,97.490189 
	C855.005249,96.250633 855.008667,95.499649 855.158569,94.090454 
	C856.182556,92.527245 857.274658,91.842346 858.504883,90.397842 
	C862.331543,90.220413 862.063965,86.176453 864.772949,85.157761 
	C865.415466,84.631989 865.862000,84.497673 866.674255,84.735947 
	C867.075623,85.252037 867.244873,85.523659 867.695679,85.876907 
	C868.374939,86.518661 868.932129,86.678139 869.809448,86.173798 
	C870.138855,85.632210 870.329041,85.379860 870.812378,85.079018 
	C871.710449,84.227043 871.761475,83.096573 872.785950,82.217361 
	C876.980896,81.480331 877.859558,84.506737 878.754272,87.815521 
	C878.124390,88.811996 877.267029,87.916245 877.095154,88.821526 
	C876.972778,89.466553 877.066040,88.533958 877.733459,89.213593 
	C878.146545,89.509239 878.300964,89.651924 878.652588,90.052673 
	C879.963562,92.294121 881.310120,94.063705 883.598877,95.423676 
	C884.603027,97.049286 885.869202,97.921707 887.327637,99.085297 
	C887.983948,100.236053 888.028992,101.138832 887.519409,102.361313 
	C886.613342,103.628036 885.438660,103.914719 884.237854,104.775192 
	C883.548096,105.429825 883.102600,105.843040 882.482544,106.335159 
	C882.347656,106.459297 882.109741,106.698799 882.256592,106.571465 
	C882.759094,106.081497 883.187622,105.802757 883.773743,105.225655 
	C884.700195,104.122864 885.890991,104.021828 886.930664,103.075951 
	C888.221191,101.659454 888.431213,99.923302 890.030151,98.704147 
	C891.020691,98.237473 891.720886,98.227867 892.728516,98.642883 
	C893.511414,99.354767 893.717041,99.979729 893.642822,100.939163 
	C893.400818,101.474190 893.322449,101.644447 893.489990,101.589325 
	C894.211365,101.107376 894.855225,101.054031 895.795288,101.193375 
	C896.430481,101.384041 896.529480,101.902412 896.977356,101.869179 
	C897.080811,101.861481 897.115845,101.739029 897.092773,101.640205 
	C896.941345,100.990974 897.320618,101.726334 896.565857,101.365303 
	C896.733582,99.172112 898.426941,99.010162 900.376038,98.196678 
	C905.595215,97.921280 907.915771,94.104507 911.084290,91.741638 
	C912.444946,90.726982 911.082825,89.834076 910.237366,89.073021 
	C908.284485,87.315277 908.918396,86.369614 911.617615,86.010986 
	C912.521301,86.536140 913.062561,87.074921 913.798584,87.823891 
	C914.099487,88.335152 914.277100,88.587433 914.737427,88.896759 
	C915.394348,89.513000 915.930969,89.687218 916.799316,89.216339 
	C917.323486,88.909851 917.579407,88.744537 917.907043,88.307510 
	C918.230225,87.833824 918.457458,87.578598 918.908813,87.184860 
	C919.967346,86.524994 920.822510,86.021889 921.853394,85.280060 
	C922.079834,84.682106 922.249207,84.388191 922.774475,84.083450 
	C925.609009,84.484810 924.250305,85.459045 923.468567,86.608467 
	C921.817200,89.036812 926.883301,89.479706 925.264160,91.329872 
	C923.592651,93.239906 922.180481,88.733482 920.158691,90.263504 
	C919.027466,91.119576 917.406799,92.619545 917.549805,93.605614 
	C917.867493,95.796425 919.161926,94.981300 919.960571,93.591911 
	C920.301147,92.999207 920.535583,92.418488 921.379028,92.607918 
	C922.187073,93.445480 922.052185,94.448524 921.737000,95.398636 
	C921.314636,96.671646 921.602295,97.757683 922.611145,98.502487 
	C923.932861,99.478249 924.562195,97.971336 925.536438,97.574188 
	C927.468506,96.786568 928.739502,94.514259 931.612549,95.004120 
	C933.587097,97.683678 931.863953,99.912727 931.003967,102.631195 
	C933.880737,103.984612 933.766785,99.711174 936.629456,100.004684 
	C937.216614,100.208496 937.421570,100.427185 937.617249,100.654350 
	C937.812439,100.881027 937.748291,100.804146 937.211060,100.212708 
	C936.945618,98.396126 937.128662,96.968712 939.897095,97.089981 
	C941.008728,97.384201 941.475891,97.645630 942.517578,97.199493 
	C944.406982,97.071053 945.549255,96.769516 946.363342,95.428001 
	C948.425476,92.029984 950.955383,90.716530 954.960693,94.106453 
	C956.802856,94.805855 957.370544,96.264633 959.424683,96.180969 
	C964.250793,97.398460 966.597473,100.830307 968.947021,104.659973 
	C969.000000,105.004189 969.000000,104.999695 969.002441,104.999916 
	C966.318848,106.436317 965.462769,103.615166 963.520203,102.509186 
	C962.462952,101.366669 961.578247,100.795830 960.155029,101.850464 
	C959.104004,102.950699 958.078979,103.536324 956.871704,104.171600 
	C956.719177,104.264297 956.911621,104.525673 956.954956,104.340347 
	C958.034302,103.582138 959.127991,103.091209 960.137329,101.882324 
	C961.056763,101.252419 961.739746,101.258064 962.730835,101.788399 
	C964.125122,103.847893 967.394409,104.299774 966.235474,107.733429 
	C966.004883,108.045334 966.000916,108.525459 965.998047,108.765518 
	C965.341370,109.864929 964.209839,109.949219 963.211792,110.812706 
	C963.001282,111.033775 963.008362,111.498070 963.011536,111.730225 
	C962.629272,112.362030 962.161804,112.521782 961.291016,112.221657 
	C960.659790,111.889099 960.408997,111.698799 960.108582,111.217758 
	C960.000000,111.004776 959.723755,110.616096 959.723755,110.616096 
	C959.723755,110.616096 959.248413,110.645744 959.137695,110.854759 
	C958.904663,111.363045 958.711426,111.605919 958.236450,111.896637 
	C957.177673,112.974998 955.915161,112.972534 954.469421,113.348938 
	C953.945374,113.183678 953.771057,113.031792 953.397339,112.599350 
	C952.557434,111.406837 952.411743,110.195000 951.228882,109.234573 
	C950.988464,109.003143 951.000000,108.999153 950.998779,109.005211 
	C950.513184,108.512138 950.024109,108.017563 949.287231,107.278976 
	C949.032471,106.854691 949.025391,106.674576 949.003418,106.224487 
	C948.690247,105.662064 948.508301,105.315826 948.574829,104.659698 
	C948.803833,104.240692 948.910583,104.109077 948.849121,104.151566 
	C948.276917,104.721436 947.826843,105.172157 947.197571,105.842651 
	C946.241272,107.412361 945.804626,109.143784 943.346680,108.994858 
	C942.794922,108.782768 942.578613,108.576752 942.351074,108.382942 
	C942.122253,108.188011 942.196350,108.253807 942.786743,108.789642 
	C943.005371,109.440636 943.010681,109.882179 942.931885,110.952965 
	C942.557251,112.129814 942.252808,112.669243 941.448364,113.594795 
	C937.813416,112.698128 937.225708,116.809769 934.378540,116.993454 
	C933.633484,113.279663 929.855286,112.299507 928.057495,109.327568 
	C927.568481,108.504242 927.078979,108.255638 926.224304,108.757050 
	C925.615051,110.707611 926.981079,111.893196 927.772583,113.200386 
	C925.287842,114.860374 924.605225,111.394455 922.368225,112.003746 
	C922.004089,111.995934 921.928223,111.756676 921.928223,111.756676 
	C921.928223,111.756676 921.752136,111.927017 921.873657,111.965652 
	C921.997925,112.753204 922.000671,113.502121 922.001709,114.625519 
	C917.664368,119.798935 913.862854,117.950989 910.212341,114.065689 
	C910.129211,113.977249 909.896973,114.028885 909.082397,113.804085 
	C907.853149,112.564842 907.356018,111.478714 906.198853,110.707573 
	C908.830078,112.884293 905.695068,114.128342 905.777039,116.426178 
	C906.182129,118.578766 905.960571,120.892143 908.632141,119.312706 
	C912.350159,117.114647 913.453613,120.014008 914.984314,122.630112 
	C913.373535,122.951950 911.974609,123.151917 912.006958,125.630951 
	C910.927002,126.123299 909.521912,125.729393 909.242065,127.297058 
	C908.887756,129.281693 911.684143,128.685654 911.939209,130.653107 
	C912.593811,130.741180 913.163879,130.398102 913.781494,130.236710 
	C914.705322,129.995270 916.072876,129.700653 916.317505,130.754410 
	C916.733154,132.544907 914.501648,131.472687 913.944641,132.496338 
	C915.157288,133.621475 917.440552,133.391785 917.930298,135.853394 
	C915.892761,137.374130 914.046387,136.262543 912.291626,135.479614 
	C906.520691,132.904800 900.467834,131.066925 894.657593,128.629471 
	C891.020020,127.103439 888.261780,127.447891 885.778198,131.038177 
	C883.797668,132.681793 882.245483,134.354767 879.540161,134.696320 
	C872.745361,131.723633 871.350708,129.550018 871.912109,123.380219 
	C870.897339,121.604622 871.348633,120.336037 872.367798,119.108200 
	C873.762512,117.427879 872.061340,116.651222 871.135071,116.160454 
	C869.656189,115.376884 868.840759,116.314148 868.915527,118.129379 
	C869.213989,118.560539 869.331421,118.736931 869.568604,119.210678 
	C870.857178,121.365440 867.300964,122.528816 869.182617,124.698303 
	C870.239624,126.451912 872.162415,127.781792 871.160645,129.702652 
	C870.057739,131.817627 867.842285,129.805984 865.997559,130.710159 
	C865.565369,131.060211 865.383057,131.191132 864.883423,131.441956 
	C861.343933,131.690338 860.428589,128.287766 857.674072,127.080688 
	C857.199158,126.779137 857.017761,126.647911 856.595459,126.288086 
	C855.338745,124.712372 854.189392,123.454529 853.464478,121.590630 
	C853.300293,121.168312 853.217285,121.013924 852.857788,120.815292 
	C852.334045,121.874725 850.249146,118.318146 850.781372,121.804466 
	C850.675293,122.356667 850.597229,122.574150 850.296509,123.066643 
	C849.435791,123.739395 848.737488,123.850227 847.650085,123.681747 
	C847.093811,123.464722 846.887878,123.342422 846.434387,122.964958 
	C845.003723,120.956566 843.623474,119.272171 842.894714,117.306473 
	C842.297363,115.695007 841.806091,114.613640 839.800598,114.511047 
	C838.512451,114.445137 838.169678,113.109550 838.453918,111.520065 
	C839.909973,109.690865 842.153442,109.078529 842.887939,106.642303 
	C843.030212,105.987083 843.212952,105.412254 842.265625,106.218887 
	C841.843201,106.503639 841.649475,106.592064 841.129333,106.737900 
	C840.344482,106.782768 839.909912,106.671539 839.249878,106.232811 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M888.932373,85.352226 
	C890.734741,84.729256 892.469177,84.459679 894.871094,84.086349 
	C893.287476,87.161324 890.230774,87.352646 887.881714,89.374535 
	C892.783020,90.417534 895.466797,87.531143 898.379456,85.505714 
	C900.086365,84.318764 901.424194,82.855812 901.989014,86.633636 
	C896.419312,88.530052 895.982056,89.732986 898.730103,95.873161 
	C897.759155,96.768875 897.051025,96.752411 896.038086,96.290680 
	C894.055908,92.371498 890.877380,93.721840 887.743408,93.744446 
	C886.289185,93.001526 885.142700,92.587631 883.592896,93.559212 
	C881.519226,93.840904 880.375183,93.259323 880.656006,90.659935 
	C884.235352,89.696999 886.098450,86.874763 888.932373,85.352226 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1002.057251,55.341820 
	C1004.326233,54.430592 1006.511353,53.095081 1007.685425,57.111053 
	C1008.051697,58.363972 1010.053894,61.599083 1013.607056,60.998470 
	C1014.000000,61.000458 1014.000000,61.000000 1014.000000,60.999771 
	C1015.022339,62.050434 1014.535339,63.136486 1013.889038,64.522156 
	C1013.537842,64.991325 1013.372559,65.160240 1012.891541,65.491592 
	C1012.112183,65.766838 1011.643738,65.800461 1010.584717,65.371231 
	C1009.050903,60.473572 1004.634399,58.881214 1002.057251,55.341820 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M954.000000,44.755920 
	C951.776672,43.747871 947.886353,42.716946 948.550720,40.232773 
	C949.435303,36.925217 951.676575,42.338577 953.706360,40.662395 
	C954.169617,40.279861 954.915466,40.161285 955.493774,40.975227 
	C955.045227,41.745144 954.567444,42.565304 954.047241,43.702774 
	C954.004822,44.020081 954.002441,44.510647 954.000000,44.755920 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M936.631958,52.010246 
	C936.472778,54.470760 933.526978,56.704918 937.363525,59.756355 
	C933.525146,59.786793 932.436890,57.498894 932.350098,55.732868 
	C932.256104,53.820808 933.991821,52.268635 936.631958,52.010246 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M928.973999,89.316803 
	C931.427979,89.779755 932.934143,91.675644 934.495422,93.515083 
	C935.189941,94.333252 936.679138,95.136444 935.440186,96.249840 
	C934.268494,97.302841 933.799194,95.042000 932.327087,95.045792 
	C932.000000,95.001122 932.000000,95.000000 932.000000,94.999527 
	C932.872314,92.135773 927.534058,92.805893 928.973999,89.316803 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M890.352600,54.411507 
	C889.832764,55.003551 889.649048,55.053215 889.506042,54.997776 
	C887.610229,54.262661 885.608765,58.740410 884.278625,55.345627 
	C883.702942,53.876583 886.467651,52.117615 888.657410,51.038864 
	C889.000000,50.999542 889.000000,51.000000 889.000000,51.000229 
	C890.012451,51.671982 890.909607,52.413307 890.352600,54.411507 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M944.718018,50.861000 
	C945.590088,51.489895 946.174255,51.981155 946.879211,52.738136 
	C944.835876,56.364849 942.792419,57.240002 941.202515,52.101639 
	C942.314697,50.872814 943.311707,50.557632 944.718018,50.861000 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M809.341980,74.227295 
	C808.952942,71.413231 806.953369,68.185715 811.654236,67.039429 
	C811.481995,69.078323 810.624207,71.150734 811.956299,73.613663 
	C811.317322,74.574928 810.543823,74.723679 809.341980,74.227295 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M956.325684,61.067871 
	C958.293457,60.740673 957.772339,57.410595 960.133240,58.425972 
	C961.177185,58.874928 961.199036,60.175758 960.682068,60.987427 
	C959.634521,62.632328 957.986511,63.334229 956.065979,62.706436 
	C955.268860,62.445873 955.461365,61.733376 956.325684,61.067871 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M973.824951,57.792515 
	C971.909851,57.920795 970.524780,57.574730 971.964355,55.740673 
	C973.091614,54.304569 974.537170,53.022438 976.723083,52.371296 
	C976.940186,54.985271 974.810059,55.976997 973.824951,57.792515 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M917.950500,59.352036 
	C919.858887,59.952118 922.387695,60.358990 920.780334,63.062080 
	C920.207153,64.026115 920.101990,66.280334 918.371704,65.695023 
	C916.108765,64.929558 918.100708,63.677162 918.558350,62.738857 
	C919.232300,61.357021 917.684448,60.680096 917.950500,59.352036 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M946.700439,59.124928 
	C946.650330,60.493328 947.901550,63.271847 944.752686,62.617699 
	C943.144348,62.283562 940.879822,60.567730 941.588684,58.910725 
	C942.569458,56.618195 943.777161,59.559177 945.014404,59.611752 
	C945.469727,59.631096 945.936768,59.376644 946.700439,59.124928 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M981.524780,63.591003 
	C983.159912,62.821365 981.214050,59.440754 984.168640,60.252541 
	C985.385315,60.586807 986.270447,61.635792 985.364746,62.835556 
	C984.439453,64.061127 983.381775,66.183487 981.524780,63.591003 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M840.651611,60.992958 
	C841.378052,62.148685 842.601135,63.660873 840.229919,63.894260 
	C837.371033,64.175644 837.021729,61.854435 836.105164,59.885147 
	C838.109558,59.052959 838.742065,61.545612 840.651611,60.992958 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M924.031799,68.653564 
	C922.327759,68.905548 920.326660,68.959473 921.496460,66.379150 
	C922.084106,65.082855 923.421265,63.437794 924.835083,64.316208 
	C927.141541,65.749176 923.773560,66.816086 924.031799,68.653564 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M872.658569,81.955231 
	C873.036682,83.168411 873.302307,84.433884 871.374634,84.927895 
	C870.795227,84.535439 870.431396,84.121307 870.356384,83.660187 
	C870.109070,82.140503 866.789001,81.416023 868.625977,79.779716 
	C870.385925,78.212044 870.658630,81.819519 872.658569,81.955231 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M927.633545,54.004761 
	C927.580566,57.146351 924.934631,57.561272 921.961304,59.180008 
	C923.138672,55.829212 924.561279,54.236767 927.633545,54.004761 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M920.041992,72.356117 
	C922.485474,71.855934 923.864258,73.353180 924.747009,75.379723 
	C924.998596,75.957352 924.494629,76.820869 923.759705,76.721954 
	C921.490540,76.416512 920.984558,74.355057 920.041992,72.356117 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1005.007751,63.363564 
	C1006.915955,62.537327 1007.893127,64.216797 1009.655701,64.945061 
	C1010.000000,65.000610 1010.000000,65.000000 1010.000000,64.999985 
	C1010.536255,65.502289 1010.761536,66.122276 1010.350159,67.425346 
	C1008.198853,66.738480 1005.390808,66.651329 1005.007751,63.363564 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M958.006714,68.366318 
	C959.845886,68.470413 961.580872,66.519997 963.503784,67.885643 
	C961.600159,67.825806 960.774231,73.644882 958.006714,68.366318 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M876.001221,46.999054 
	C874.590332,47.557968 873.178162,48.117832 871.730774,48.691677 
	C870.778687,46.760494 873.011719,46.098930 872.966309,44.335587 
	C873.002441,43.997372 873.000000,44.000000 872.998779,44.001251 
	C875.318787,42.953266 876.177002,44.146725 876.219788,46.625668 
	C875.997559,47.001831 876.000000,47.000000 876.001221,46.999054 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M866.958069,60.654480 
	C864.674438,61.058846 862.887085,60.372520 862.264404,57.328571 
	C864.562927,57.583221 866.247375,58.069908 866.958069,60.654480 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M924.005798,68.993790 
	C925.522644,69.289200 926.896484,67.193893 929.151550,69.311470 
	C926.972961,68.974693 926.608032,74.459000 924.001770,69.357346 
	C923.988586,69.011513 924.000000,68.999802 924.005798,68.993790 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M946.998779,58.998550 
	C946.999207,57.360748 947.034363,55.667198 949.065430,55.234966 
	C950.610657,54.906109 950.911133,56.044579 950.991577,57.630997 
	C949.897278,58.311005 948.794495,58.622433 947.347107,58.968319 
	C947.002441,59.002777 947.000000,59.000000 946.998779,58.998550 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M939.458984,66.876282 
	C940.639893,65.829285 941.036194,63.944721 942.850220,64.271126 
	C943.153748,64.325737 943.651367,65.115715 943.560303,65.268372 
	C942.638733,66.813774 941.503113,68.054268 939.458984,66.876282 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M855.001221,93.998840 
	C852.984253,93.860352 851.915894,92.800095 852.090332,90.760559 
	C852.240417,89.006691 853.513611,89.992439 854.943115,90.245834 
	C856.004395,91.505516 856.020081,92.468040 855.235962,93.711174 
	C854.997559,94.002472 855.000000,94.000000 855.001221,93.998840 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M844.997559,99.997971 
	C845.083008,98.681076 844.917358,97.196838 846.867310,97.089165 
	C848.375977,97.005852 848.922729,97.884613 848.988281,99.617935 
	C849.002441,99.996681 849.000000,100.000107 848.998413,100.001709 
	C848.007019,100.818909 846.930237,101.068771 845.366699,100.254761 
	C845.004883,100.004272 845.000000,100.000244 844.997559,99.997971 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M934.389648,70.991638 
	C933.993225,70.245285 933.994019,69.498199 933.999695,68.373573 
	C935.322998,68.264603 937.396851,67.296738 937.664307,69.371292 
	C937.917664,71.336555 935.982239,70.820816 934.389648,70.991638 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M812.365967,66.997375 
	C811.779785,64.612465 813.024109,63.795719 815.609131,64.000465 
	C815.881348,66.061508 814.724609,66.985161 812.365967,66.997375 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M821.142700,84.297096 
	C822.397339,83.997528 823.782043,84.008026 825.582153,84.019348 
	C825.748962,84.825195 825.500366,85.630219 825.123901,86.730835 
	C823.254150,86.990768 822.230042,85.850426 821.142700,84.297096 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M858.936157,52.652946 
	C857.473328,52.557613 856.015442,54.163197 854.194580,53.083969 
	C855.573792,50.976387 856.883972,49.874649 858.936157,52.652946 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M906.616211,60.110870 
	C905.943359,61.535542 905.328430,62.809406 903.708740,62.488750 
	C903.462463,62.440010 903.092285,61.552979 903.229431,61.278732 
	C903.912537,59.912495 904.829224,58.814209 906.616211,60.110870 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M958.354248,90.955826 
	C958.147034,89.341194 957.391602,87.178520 960.621704,87.015335 
	C961.042847,88.784897 960.832275,90.415970 958.354248,90.955826 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M936.995117,51.995255 
	C936.990845,51.244019 936.991455,50.497608 936.993652,49.377968 
	C936.995117,49.004738 937.000000,48.999676 937.002441,48.997517 
	C939.528015,47.646042 941.014771,48.369205 941.218018,51.605927 
	C940.995117,51.998291 941.000000,52.000153 940.998779,51.997967 
	C939.933960,52.000507 938.870361,52.005230 937.408264,52.010056 
	C937.009766,52.010162 937.000000,52.000080 936.995117,51.995255 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M937.792236,90.185379 
	C937.365906,91.996864 936.437317,92.297592 935.438721,91.185219 
	C934.786499,90.458687 934.763184,89.213043 935.647827,88.656677 
	C936.703857,87.992493 937.317017,88.945465 937.792236,90.185379 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M909.516235,75.475563 
	C909.171387,74.207962 909.092834,72.954803 910.600403,73.804688 
	C911.386597,74.247871 912.994873,75.060631 912.225464,76.287430 
	C911.596008,77.291168 910.553589,76.078514 909.516235,75.475563 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M825.000000,61.000458 
	C824.692871,62.085411 825.747375,63.687847 824.010925,64.182747 
	C823.273987,64.392776 822.421753,63.757820 822.254395,62.906929 
	C821.940979,61.313549 823.078796,61.084949 824.641541,61.006893 
	C825.000000,60.999084 825.000000,61.000000 825.000000,61.000458 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M894.001221,55.001549 
	C893.942810,56.199093 893.586548,57.364353 892.332764,57.620697 
	C890.976807,57.897926 890.377197,56.855095 890.037354,55.338028 
	C889.997559,55.002762 890.000000,54.999920 890.001221,54.998554 
	C890.994019,54.185127 892.071289,53.933167 893.635498,54.746635 
	C893.997559,54.996777 894.000000,54.999893 894.001221,55.001549 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M849.998779,55.001122 
	C851.193054,55.261662 852.896423,54.312756 853.461914,56.002495 
	C853.842224,57.138794 852.690430,57.637970 851.348755,57.955032 
	C850.688599,57.205193 850.372498,56.419640 850.029419,55.315918 
	C850.002441,54.997742 850.000000,55.000000 849.998779,55.001122 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1017.004395,64.004868 
	C1016.655762,65.962509 1015.180847,66.948891 1013.091675,67.700699 
	C1012.229309,66.837692 1012.226624,66.174965 1012.772095,65.258301 
	C1012.999390,65.000565 1013.002808,64.997223 1013.006409,64.993683 
	C1013.961670,64.125595 1014.867493,63.154686 1016.675354,63.767982 
	C1016.990234,63.989853 1016.999084,63.999062 1017.004395,64.004868 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M854.998779,89.998932 
	C855.114380,88.902695 854.753235,87.458221 856.342712,87.221329 
	C857.815918,87.001762 858.081970,88.464508 858.853638,89.686661 
	C858.997803,90.002296 859.000000,90.000000 859.001221,89.998787 
	C858.011230,90.816650 856.930603,91.055733 855.365112,90.252403 
	C855.002441,90.002396 855.000000,90.000000 854.998779,89.998932 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M861.998779,52.998932 
	C861.891296,54.025829 862.285645,55.368870 860.852844,55.710579 
	C859.296021,56.081856 859.107849,54.885960 859.007263,53.368156 
	C859.000000,52.999390 859.000000,53.000000 859.000000,53.000305 
	C859.750549,53.002327 860.501160,53.004044 861.627075,53.003944 
	C862.002441,53.002136 862.000000,53.000000 861.998779,52.998932 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M920.998779,52.998993 
	C920.857422,54.074070 921.501770,55.465462 920.449341,56.137596 
	C919.760376,56.577629 918.951294,55.611660 918.625793,54.915291 
	C917.796570,53.141174 919.168152,53.136654 920.659485,53.008583 
	C921.002441,53.001999 921.000000,53.000000 920.998779,52.998993 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M931.000000,51.000534 
	C931.045349,52.600838 930.859924,54.025818 928.368591,53.991905 
	C927.997559,53.998569 928.000000,54.000000 928.001221,54.000717 
	C927.947510,52.396454 928.138916,50.977505 930.629028,51.006508 
	C931.000000,50.998932 931.000000,51.000000 931.000000,51.000534 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M977.416016,68.600311 
	C977.937744,69.946220 977.671326,70.748177 976.401733,70.773506 
	C975.702026,70.787468 975.198792,70.274910 975.226013,69.578140 
	C975.275208,68.315681 976.077881,68.052216 977.416016,68.600311 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M852.002930,97.373001 
	C852.754089,96.997910 853.503296,97.000374 854.627197,97.002228 
	C855.001831,97.001625 855.000000,97.000000 854.998779,96.998962 
	C855.575378,97.683800 855.714417,98.458626 855.234497,99.655319 
	C855.002441,99.998779 855.000000,100.000000 854.999939,100.000031 
	C854.313477,100.576141 853.538879,100.714348 852.343567,100.233322 
	C852.000732,100.000778 851.999023,99.998932 851.993652,99.993568 
	C851.992493,99.242317 851.996765,98.496437 852.002930,97.373001 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M809.000000,74.365906 
	C809.748901,73.990768 810.497803,73.992218 811.620850,73.984299 
	C811.996399,74.731598 811.997742,75.488243 811.750305,76.861839 
	C811.069031,77.654388 810.619812,77.727837 809.576965,77.350250 
	C809.000000,76.248108 809.000061,75.495293 809.000000,74.365906 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M850.999695,60.624466 
	C849.977051,60.883141 848.630554,61.276836 848.291748,59.853558 
	C847.921997,58.300018 849.134766,58.126858 850.636719,58.004692 
	C851.004639,57.990746 851.000000,57.999870 851.004517,57.997795 
	C851.005859,58.746891 851.002625,59.498062 850.999695,60.624466 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M870.367493,60.989296 
	C869.997559,60.252331 869.993469,59.503181 869.997131,58.374573 
	C871.105469,58.117191 872.572571,57.738140 872.758606,59.389080 
	C872.910889,60.740913 871.767517,60.895088 870.367493,60.989296 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M995.009155,60.367580 
	C995.750000,60.000977 996.500000,60.001438 997.625000,60.000877 
	C997.883118,61.022156 998.273987,62.366730 996.853455,62.705963 
	C995.304321,63.075901 995.121704,61.872669 995.009155,60.367580 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M834.822998,83.779266 
	C834.235962,85.360825 833.317383,86.556854 831.350098,86.951492 
	C831.486084,85.056686 832.453186,83.667816 834.822998,83.779266 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M904.988403,89.630600 
	C904.247559,89.997795 903.497559,89.992973 902.375000,89.995102 
	C902.006470,89.251984 902.010437,88.501907 902.005981,87.376915 
	C901.997559,87.001999 902.000000,87.000000 902.001099,86.999077 
	C903.600952,86.953049 905.009338,87.158623 904.988403,89.630600 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M955.001221,94.000954 
	C954.954773,92.401001 955.139099,90.975327 957.631287,91.007133 
	C958.002441,91.002167 958.000000,91.000000 957.998779,90.998924 
	C957.998352,91.747139 957.999084,92.496429 957.754639,93.862198 
	C956.841064,94.778267 956.176147,94.783844 955.256348,94.226799 
	C954.997559,93.998116 955.000000,94.000000 955.001221,94.000954 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M851.997559,97.002068 
	C850.473999,96.890442 849.246582,96.291283 848.029968,94.783691 
	C850.316833,93.722252 851.359558,94.428062 851.964233,96.646812 
	C852.004883,96.995445 852.000000,97.000000 851.997559,97.002068 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M905.001221,89.998749 
	C905.921387,90.132904 907.110229,89.686317 907.537231,90.949112 
	C907.787598,91.689598 907.255798,92.285828 906.601379,92.465370 
	C905.007874,92.902519 905.182800,91.614761 905.009155,90.346687 
	C904.997559,90.002617 905.000000,90.000000 905.001221,89.998749 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1017.980835,98.610901 
	C1017.537109,98.955040 1017.094177,98.971436 1016.318237,98.990845 
	C1015.985352,98.993851 1015.506104,98.995697 1015.266479,98.998672 
	C1014.633362,98.621735 1014.479431,98.161667 1014.789124,97.310760 
	C1016.499146,96.279152 1017.959717,95.617020 1017.980835,98.610901 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M844.219482,53.677544 
	C842.372192,53.778404 840.837891,53.390312 840.046753,51.339966 
	C839.997559,51.003250 840.000000,50.999901 840.001221,50.998421 
	C841.297302,49.957645 842.492920,50.506168 843.961609,51.509525 
	C844.486511,52.287819 844.551147,52.805267 844.219482,53.677544 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M954.935059,65.659187 
	C953.898987,65.888672 952.681030,66.319550 951.770813,65.424423 
	C951.628235,65.284187 951.865173,64.385239 952.094177,64.302841 
	C953.241516,63.889935 954.338745,63.911865 954.935059,65.659187 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M844.112000,54.225235 
	C844.001770,53.562302 844.003662,53.114258 844.006470,52.330284 
	C844.674988,51.336407 845.463989,51.246811 846.661743,51.748756 
	C846.988037,53.146351 846.558777,54.074802 845.288635,54.856899 
	C844.683960,54.894268 844.424927,54.707569 844.112000,54.225235 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M840.996338,60.996330 
	C841.092407,59.634460 841.798035,58.747028 843.171997,58.774349 
	C844.005249,58.790924 844.029846,59.671921 843.933289,60.302338 
	C843.672729,62.003147 842.476440,61.037846 841.316650,61.029243 
	C841.007324,61.007324 841.000000,61.000000 840.996338,60.996330 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M869.997559,58.002441 
	C868.816711,57.922123 867.712036,57.602230 867.418701,56.315350 
	C867.262085,55.627953 867.815979,55.121723 868.565552,55.192574 
	C869.829590,55.312061 869.932007,56.301250 869.997803,57.639816 
	C870.004883,57.995117 870.000000,58.000000 869.997559,58.002441 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M986.331543,58.847679 
	C984.944519,57.490917 985.827820,57.202976 986.899292,57.096512 
	C987.526978,57.034138 988.311279,57.141895 988.353455,57.890797 
	C988.420044,59.073158 987.380066,58.827782 986.331543,58.847679 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M899.002441,56.997578 
	C900.060486,57.114067 901.379150,56.750439 901.760010,58.230103 
	C901.917480,58.841801 901.743042,59.600563 900.876221,59.566952 
	C899.742126,59.522972 899.308594,58.663799 899.032593,57.344753 
	C898.995117,57.004841 899.000000,57.000000 899.002441,56.997578 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M869.999268,60.999252 
	C869.903320,62.127419 869.655090,63.309643 868.399963,63.536953 
	C867.057129,63.780144 867.105896,62.589348 867.001831,61.343468 
	C867.000000,61.000610 867.000000,61.000000 867.000000,60.999695 
	C867.750427,61.000534 868.500793,61.001675 869.626465,61.002151 
	C870.001709,61.001484 870.000000,61.000000 869.999268,60.999252 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M951.000000,58.000217 
	C952.100342,58.108761 953.318481,57.673626 954.230774,58.571278 
	C954.374512,58.712708 954.139160,59.613441 953.910522,59.695919 
	C952.760925,60.110577 951.664001,60.083138 951.063721,58.340824 
	C951.000000,57.999588 951.000000,58.000000 951.000000,58.000217 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M888.999817,85.000565 
	C887.948486,84.877930 886.623230,85.275620 886.230103,83.793701 
	C886.068726,83.185440 886.233948,82.422501 887.103455,82.444481 
	C888.252502,82.473526 888.657227,83.358727 888.956360,84.660858 
	C889.000366,84.998840 889.000000,85.000000 888.999817,85.000565 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M934.003662,71.003693 
	C933.861450,71.923897 934.299377,73.116257 933.037048,73.534790 
	C932.297546,73.779984 931.702942,73.247444 931.526123,72.591934 
	C931.097473,71.003334 932.378479,71.173447 933.648193,71.003372 
	C933.992432,70.992371 934.000000,70.999962 934.003662,71.003693 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M812.000000,77.000366 
	C813.522522,77.084084 814.602783,77.725723 814.963989,79.659767 
	C815.000000,79.999084 815.000000,80.000000 815.000000,80.000458 
	C812.630798,81.191246 811.339844,80.668518 811.759644,77.404549 
	C812.000000,76.999161 812.000000,77.000000 812.000000,77.000366 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M842.847290,99.693527 
	C843.007996,99.989601 842.511353,99.997520 842.263000,99.999069 
	C841.329651,100.597809 840.557190,100.763901 839.347046,100.237457 
	C839.002441,100.002647 839.000000,100.000000 838.998779,99.998711 
	C839.769897,96.985222 841.184814,97.924286 842.847290,99.693527 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1016.873169,91.593124 
	C1015.268066,92.848427 1015.025940,91.298225 1014.412659,90.523308 
	C1014.321411,90.408043 1014.610840,89.756371 1014.713684,89.759026 
	C1015.764832,89.786240 1016.590820,90.202705 1016.873169,91.593124 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1005.000000,62.999771 
	C1004.119263,62.906574 1003.069336,63.231808 1002.555237,62.204884 
	C1002.465149,62.024940 1002.887512,61.354534 1003.185852,61.257702 
	C1004.093811,60.963017 1004.612366,61.520393 1004.947266,62.671001 
	C1005.000000,63.000458 1005.000000,63.000000 1005.000000,62.999771 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M927.521606,62.022461 
	C927.028687,62.904858 926.413330,63.008823 925.811157,62.597847 
	C925.321838,62.263969 925.327332,61.728550 925.825562,61.407452 
	C926.435852,61.014156 927.050659,61.123459 927.521606,62.022461 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M901.001221,53.998413 
	C902.245056,54.157391 903.473145,54.346100 904.196472,55.637814 
	C902.847168,56.194965 901.735352,56.190041 901.053101,54.328739 
	C900.997559,54.003323 901.000000,54.000000 901.001221,53.998413 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M995.002441,57.002052 
	C995.003357,57.753162 995.001831,58.502224 995.000122,59.625900 
	C995.000000,60.000515 995.000000,60.000000 995.000000,59.999760 
	C992.817322,59.485744 992.380676,58.569153 994.663330,57.049000 
	C994.995117,56.996227 995.000000,57.000000 995.002441,57.002052 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M912.196960,54.794174 
	C911.243652,54.156033 911.317688,53.568722 912.078369,53.277317 
	C912.428894,53.143021 913.199463,53.325256 913.351074,53.600193 
	C913.775269,54.369717 913.221558,54.730068 912.196960,54.794174 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M998.000000,60.000076 
	C998.143005,59.037560 998.371887,58.092937 999.621033,58.216801 
	C999.939148,58.248344 1000.482727,58.767521 1000.457886,59.016258 
	C1000.351196,60.085373 999.396484,59.868755 998.340881,59.995358 
	C998.000000,59.999847 998.000000,60.000000 998.000000,60.000076 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M829.607544,88.006729 
	C829.452942,90.176132 828.576416,90.792023 827.029968,88.334396 
	C827.727600,87.999405 828.479858,87.997902 829.607544,88.006729 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M926.791748,81.724289 
	C925.799988,81.770996 924.369812,82.543312 923.370605,80.972267 
	C924.728088,79.670898 925.615784,81.004959 926.791748,81.724289 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M865.474243,78.300079 
	C865.085205,77.409012 865.112366,76.731422 865.889648,76.554848 
	C866.127380,76.500847 866.723816,77.041908 866.778992,77.373276 
	C866.896790,78.079643 866.552673,78.614090 865.474243,78.300079 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M922.834717,83.771713 
	C922.912720,84.332588 922.721252,84.593132 922.241943,84.919937 
	C921.259277,84.872658 920.132385,84.779724 920.549988,83.699776 
	C920.884766,82.834068 921.883423,83.027313 922.834717,83.771713 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M929.000000,89.000381 
	C927.964539,88.824493 926.976807,88.573196 927.246582,87.180840 
	C927.296448,86.923279 927.634277,86.524277 927.836670,86.525764 
	C929.072632,86.534851 928.830444,87.568428 928.992249,88.660080 
	C929.000000,88.999084 929.000000,89.000000 929.000000,89.000381 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M835.657898,93.560234 
	C838.191711,93.517166 838.622375,94.439201 836.331482,95.946579 
	C835.999634,95.998886 836.000000,96.000000 836.000122,96.000610 
	C835.463013,95.493393 835.237488,94.868774 835.657898,93.560234 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M955.001221,65.998474 
	C956.134644,66.062096 957.407654,65.819626 957.942444,67.658188 
	C958.000000,68.000305 958.000000,68.000000 958.000000,67.999847 
	C956.862915,67.945030 955.593750,68.181557 955.053223,66.345917 
	C954.997559,66.003197 955.000000,66.000000 955.001221,65.998474 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M972.332153,94.953506 
	C972.107056,94.122696 971.771973,93.063812 972.813416,92.562263 
	C972.996826,92.473938 973.661133,92.905502 973.758972,93.208267 
	C974.054199,94.121651 973.492432,94.634857 972.332153,94.953506 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1013.000000,67.999695 
	C1012.484314,70.178894 1011.570312,70.622787 1010.052429,68.331902 
	C1010.685974,67.421654 1011.458618,67.270454 1012.657349,67.765198 
	C1013.000000,68.000031 1013.000000,68.000000 1013.000000,67.999695 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M929.197937,65.788033 
	C928.245850,65.150833 928.310486,64.563843 929.075623,64.272018 
	C929.426208,64.138290 930.195129,64.322044 930.348145,64.598038 
	C930.773804,65.366005 930.225464,65.729340 929.197937,65.788033 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M940.001221,97.001251 
	C940.514282,94.828400 941.424255,94.362183 942.955322,96.658440 
	C943.009766,96.990051 942.998901,97.001053 942.994568,97.005554 
	C942.302795,97.580688 941.532593,97.734108 940.338379,97.233032 
	C939.997559,96.997498 940.000000,97.000000 940.001221,97.001251 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M998.679077,70.501831 
	C998.497009,69.068687 999.263123,69.045158 1000.113953,69.346527 
	C1000.312073,69.416718 1000.542664,69.927849 1000.469910,70.134529 
	C1000.202148,70.894554 999.560913,70.903450 998.679077,70.501831 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1023.292847,92.518654 
	C1022.408203,92.895790 1021.770630,92.876190 1021.527466,92.109566 
	C1021.461487,91.901421 1021.705261,91.401253 1021.904785,91.336349 
	C1022.754578,91.059837 1023.520020,91.090942 1023.292847,92.518654 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M919.998779,72.000992 
	C919.041077,71.850685 918.086853,71.629906 918.203125,70.381485 
	C918.232666,70.064621 918.756348,69.521553 919.010071,69.545074 
	C920.085205,69.644737 919.867065,70.601341 919.994507,71.657379 
	C920.002441,71.997803 920.000000,72.000000 919.998779,72.000992 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M833.000000,91.000458 
	C834.134277,91.057404 835.403625,90.813698 835.954102,92.643570 
	C836.014343,92.984749 835.999084,93.000900 835.992188,93.007896 
	C834.392456,93.910988 833.075439,94.024521 832.788879,91.406403 
	C833.000000,90.999084 833.000000,91.000000 833.000000,91.000458 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1005.983948,109.015579 
	C1005.003479,108.868050 1004.055603,108.622017 1004.194153,107.371292 
	C1004.230103,107.047081 1004.743225,106.504631 1005.003479,106.523651 
	C1006.083557,106.602600 1005.891235,107.564613 1006.029541,108.623398 
	C1006.038330,108.962807 1006.002075,108.997978 1005.983948,109.015579 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M904.998779,51.001068 
	C905.955933,51.147053 906.905884,51.367752 906.788452,52.616295 
	C906.758667,52.932999 906.238037,53.476810 905.988647,53.452259 
	C904.919373,53.347000 905.135498,52.393307 905.008667,51.338173 
	C905.002441,50.997700 905.000000,51.000000 904.998779,51.001068 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M910.998779,48.998798 
	C910.863892,49.962841 910.642151,50.909096 909.389160,50.787792 
	C909.070068,50.756893 908.523926,50.238598 908.547668,49.988338 
	C908.649353,48.913887 909.609131,49.139610 910.661804,49.007896 
	C911.002441,49.002388 911.000000,49.000000 910.998779,48.998798 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M879.000000,88.000458 
	C879.909790,88.071487 880.702332,88.307175 880.956055,89.681183 
	C880.997559,90.002174 881.000000,90.000000 881.001221,89.999130 
	C880.315430,90.577950 879.541504,90.729416 878.340881,90.233505 
	C877.997803,89.998077 878.000000,90.000000 878.000610,90.000969 
	C877.546387,89.278374 877.976379,88.828537 878.747437,88.203445 
	C879.000000,88.000786 879.000000,88.000000 879.000000,88.000458 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M826.290955,83.117569 
	C826.007446,82.994339 825.992554,82.497261 825.988953,82.248627 
	C826.735229,81.995667 827.485107,81.991333 828.626038,82.001740 
	C828.882324,83.780144 828.006897,84.066055 826.290955,83.117569 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M972.000000,94.999847 
	C971.894592,95.912445 971.896851,96.904083 970.765869,97.211311 
	C970.617432,97.251640 970.218689,96.932724 970.184814,96.737053 
	C970.025452,95.818199 970.542786,95.319382 971.690674,95.043045 
	C972.000000,95.000305 972.000000,95.000000 972.000000,94.999847 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1021.001831,66.001877 
	C1020.825195,66.759529 1020.646790,67.515297 1020.468384,68.271072 
	C1020.183777,68.140579 1019.779236,68.087791 1019.635437,67.866013 
	C1019.040894,66.949051 1019.423462,66.370758 1020.696045,66.038116 
	C1020.996399,65.996475 1021.000000,66.000000 1021.001831,66.001877 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1012.997559,102.002014 
	C1012.355774,101.919777 1011.634277,101.915794 1011.496460,101.091148 
	C1011.467163,100.915504 1011.828125,100.674660 1012.009277,100.463829 
	C1012.315918,100.785439 1012.622620,101.107071 1012.966736,101.712326 
	C1013.004150,101.995949 1013.000000,102.000000 1012.997559,102.002014 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M913.960327,87.702087 
	C913.092834,87.932571 912.279114,87.706718 912.016724,86.324814 
	C912.899902,86.069946 913.710876,86.298027 913.960327,87.702087 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M869.673523,85.953560 
	C869.734436,87.306030 869.438232,88.658539 867.958374,86.308098 
	C868.373657,85.991875 868.846619,85.977501 869.673523,85.953560 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1021.727783,99.993164 
	C1021.877136,100.768768 1021.891846,101.695503 1020.721680,101.462440 
	C1020.577942,101.433800 1020.574280,100.701935 1020.715820,100.120956 
	C1021.104004,99.958855 1021.282043,99.971733 1021.727783,99.993164 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M988.967163,107.718185 
	C988.388367,107.881554 987.663330,107.893852 987.518982,107.085876 
	C987.489136,106.918968 987.848633,106.682518 988.028687,106.478127 
	C988.328369,106.799835 988.627991,107.121536 988.967163,107.718185 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1018.000000,84.999847 
	C1017.909180,85.630066 1017.907593,86.347542 1017.092041,86.484833 
	C1016.919739,86.513855 1016.682068,86.155251 1016.474487,85.975250 
	C1016.794800,85.672867 1017.115112,85.370491 1017.717712,85.034210 
	C1018.000000,85.000305 1018.000000,85.000000 1018.000000,84.999847 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M899.003113,95.997253 
	C899.916016,96.069565 900.701660,96.317001 900.961426,97.677185 
	C901.002441,97.997253 900.998840,98.001167 900.995667,98.004013 
	C899.570679,98.824356 898.846558,98.259666 898.782471,96.402496 
	C898.985168,96.016052 898.996460,96.003853 899.003113,95.997253 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M901.998779,89.998894 
	C901.894775,90.626335 901.894348,91.349648 901.080383,91.491928 
	C900.910706,91.521591 900.672913,91.161293 900.466553,90.980682 
	C900.789795,90.677711 901.112976,90.374756 901.719360,90.036926 
	C902.002441,90.002060 902.000000,90.000000 901.998779,89.998894 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M916.673889,88.998520 
	C916.668640,90.207710 916.436218,91.800255 914.991882,89.308807 
	C915.405090,89.003891 915.866638,89.000000 916.673889,88.998520 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M988.996582,108.003250 
	C989.517456,108.237221 990.302307,108.333771 990.506104,108.729576 
	C990.825806,109.350372 990.227661,109.760551 989.297119,109.963562 
	C988.995117,109.996063 989.000000,110.000000 989.002075,110.001968 
	C989.007568,109.557121 989.010986,109.110313 989.010559,108.328323 
	C989.006714,107.993141 989.000000,108.000000 988.996582,108.003250 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M958.002441,93.997681 
	C958.915222,94.065437 959.699341,94.313385 959.961792,95.675705 
	C960.004883,95.995728 960.000000,96.000237 959.997559,96.002090 
	C958.568115,96.824760 957.785645,96.367546 957.783630,94.393616 
	C957.995117,94.005188 958.000000,94.000420 958.002441,93.997681 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1014.714783,97.040283 
	C1015.013489,97.444870 1015.013855,97.889671 1015.020508,98.668060 
	C1014.507202,98.769203 1013.734558,98.669678 1013.526428,98.273552 
	C1013.202515,97.656982 1013.793884,97.250999 1014.714783,97.040283 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1019.400269,88.952148 
	C1019.797302,88.220955 1020.198547,88.219994 1020.553711,88.734772 
	C1020.628479,88.843079 1020.626831,89.095367 1020.550049,89.201408 
	C1020.181091,89.711052 1019.780334,89.688004 1019.400269,88.952148 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M933.997559,68.001984 
	C933.360718,67.914871 932.646301,67.903435 932.504272,67.091278 
	C932.474365,66.920258 932.833496,66.681221 933.013428,66.473549 
	C933.318481,66.793213 933.623535,67.112862 933.966553,67.714264 
	C934.004578,67.996033 934.000000,68.000000 933.997559,68.001984 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1003.459717,66.617538 
	C1003.686340,67.417221 1003.404846,67.704765 1002.785278,67.582954 
	C1002.656128,67.557564 1002.481689,67.375618 1002.462097,67.245590 
	C1002.367432,66.618446 1002.673462,66.356850 1003.459717,66.617538 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1017.460571,69.614166 
	C1017.686462,70.411278 1017.409180,70.701019 1016.789429,70.577904 
	C1016.660645,70.552338 1016.487427,70.370872 1016.467712,70.241005 
	C1016.372498,69.615921 1016.676636,69.354065 1017.460571,69.614166 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M882.381958,52.465553 
	C881.572998,52.696503 881.281372,52.413826 881.405273,51.786335 
	C881.431091,51.655922 881.615356,51.480228 881.746948,51.460396 
	C882.378235,51.365250 882.648743,51.668064 882.381958,52.465553 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M915.955200,57.602577 
	C915.216492,57.201015 915.209534,56.795227 915.733704,56.435539 
	C915.843567,56.360161 916.098572,56.362324 916.206055,56.440136 
	C916.720642,56.812771 916.702148,57.218323 915.955200,57.602577 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M851.000000,61.000153 
	C851.631348,61.095249 852.350037,61.100586 852.489502,61.915226 
	C852.518799,62.086369 852.159363,62.324055 851.979065,62.531055 
	C851.676575,62.209030 851.374023,61.887016 851.035767,61.282349 
	C851.000000,60.999695 851.000000,61.000000 851.000000,61.000153 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M836.005127,51.669323 
	C835.488159,51.768330 834.720520,51.663910 834.518311,51.269512 
	C834.204773,50.658146 834.795532,50.254433 835.708069,50.042191 
	C836.005859,50.447041 836.006897,50.891495 836.005127,51.669323 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M832.039185,77.282684 
	C832.646484,77.085754 833.366821,77.099709 833.507629,77.916428 
	C833.537415,78.089287 833.177185,78.329399 832.996643,78.538536 
	C832.687317,78.217598 832.377991,77.896645 832.039185,77.282684 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M926.398804,77.971519 
	C926.798462,77.241173 927.201416,77.225563 927.558838,77.750755 
	C927.633545,77.860435 927.631592,78.113892 927.554016,78.220047 
	C927.183716,78.726677 926.780090,78.716698 926.398804,77.971519 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M914.045715,78.382744 
	C914.801575,78.789253 914.797424,79.200012 914.269653,79.563782 
	C914.158203,79.640610 913.899414,79.639908 913.790710,79.561317 
	C913.268799,79.183563 913.287231,78.772537 914.045715,78.382744 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M831.995117,77.004730 
	C831.356506,76.912514 830.640869,76.893974 830.505554,76.080452 
	C830.476929,75.908348 830.837219,75.671562 831.018372,75.464569 
	C831.324524,75.784683 831.630676,76.104805 831.973267,76.707306 
	C832.009766,76.989670 832.000000,76.999901 831.995117,77.004730 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M916.717651,83.034363 
	C916.912781,83.638351 916.901184,84.355263 916.085144,84.488762 
	C915.911804,84.517113 915.675049,84.157410 915.467529,83.976440 
	C915.787659,83.671860 916.107788,83.367325 916.717651,83.034363 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M918.467041,75.608894 
	C918.699341,76.425262 918.411194,76.717415 917.779480,76.593292 
	C917.647644,76.567375 917.469543,76.382187 917.449280,76.249565 
	C917.351379,75.608330 917.665955,75.344254 918.467041,75.608894 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M866.944336,84.638733 
	C866.549988,84.947174 866.117065,84.961639 865.359863,84.973633 
	C865.250183,84.452538 865.328430,83.678497 865.710999,83.474060 
	C866.311829,83.152962 866.735657,83.720055 866.944336,84.638733 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M828.992310,81.991943 
	C829.093994,81.356415 829.103699,80.633255 829.920715,80.504730 
	C830.095398,80.477242 830.330994,80.836914 830.538574,81.018234 
	C830.218994,81.324020 829.899414,81.629799 829.298462,81.976028 
	C829.017090,82.016479 829.000183,82.000359 828.992310,81.991943 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M916.996582,82.996750 
	C917.086487,82.357559 917.088013,81.633125 917.908020,81.489311 
	C918.081970,81.458794 918.324219,81.817680 918.535034,81.997177 
	C918.214233,82.306816 917.893433,82.616440 917.289917,82.966003 
	C917.007324,83.005936 917.000000,83.000000 916.996582,82.996750 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1012.618835,71.547775 
	C1013.411255,71.324150 1013.697815,71.602005 1013.576782,72.216843 
	C1013.551636,72.344604 1013.370483,72.516670 1013.241272,72.536125 
	C1012.619873,72.629684 1012.359192,72.327774 1012.618835,71.547775 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M920.720703,78.602760 
	C920.849182,78.438705 921.070496,78.414322 921.291748,78.389938 
	C921.132324,78.507439 920.972839,78.624931 920.720703,78.602760 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M973.640076,66.754326 
	C973.625488,66.992813 973.496277,67.122787 973.367065,67.252762 
	C973.419861,67.050446 973.472656,66.848137 973.640076,66.754326 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M998.472046,64.450539 
	C998.526489,64.418701 998.417664,64.482376 998.472046,64.450539 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1000.528137,64.549850 
	C1000.473145,64.582375 1000.583130,64.517319 1000.528137,64.549850 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M963.464783,62.448357 
	C963.519592,62.415825 963.409973,62.480892 963.464783,62.448357 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M940.546570,56.467094 
	C940.579529,56.522110 940.513611,56.412075 940.546570,56.467094 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M926.530762,94.541763 
	C926.479370,94.570702 926.582153,94.512825 926.530762,94.541763 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M926.992981,81.987183 
	C927.105957,82.116982 927.225403,82.258850 927.344849,82.400711 
	C927.260864,82.352264 927.176819,82.303833 927.034180,82.120926 
	C926.975586,81.986458 926.999512,81.999252 926.992981,81.987183 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M960.994019,86.991982 
	C961.087463,86.955490 961.187988,86.927612 961.153687,86.957153 
	C961.018982,87.014580 961.000977,87.000595 960.994019,86.991982 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M918.858459,87.124123 
	C918.899780,87.299561 918.687317,87.571007 918.250854,87.976265 
	C918.219482,87.813423 918.412109,87.516777 918.858459,87.124123 
z"/>
<path fill="#E5E2C5" opacity="1.000000" stroke="none" 
	d="
M923.859741,696.638672 
	C931.422363,698.678955 930.125732,706.733582 934.119568,711.226501 
	C934.273926,711.400085 934.022644,712.290833 933.745422,712.435425 
	C931.323486,713.698853 930.217651,715.457153 931.482788,718.120300 
	C933.234741,721.808472 935.488037,724.902649 939.649353,726.356689 
	C947.863953,729.227051 946.812073,728.848694 943.185425,736.564453 
	C940.034241,743.268982 935.582336,743.156250 929.911316,743.091187 
	C916.580811,742.938049 903.242737,742.944153 889.915833,743.243835 
	C885.639648,743.339966 882.120117,739.854370 877.643433,741.339722 
	C876.125854,741.843262 874.286926,741.396851 873.294189,743.628601 
	C871.178040,745.739685 868.781311,745.624451 866.459900,745.634521 
	C855.796021,745.680969 845.131653,745.705017 834.468079,745.620667 
	C831.666992,745.598450 828.683777,745.791321 826.734131,742.439514 
	C825.378296,738.933716 824.503113,735.675781 822.005005,732.777466 
	C821.611938,732.265808 821.474121,732.045349 821.196533,731.459229 
	C820.423645,727.268799 822.011597,726.096680 825.806091,726.470764 
	C830.207031,726.904724 834.600708,728.344482 839.456665,727.002502 
	C846.532532,725.659851 850.079895,721.571045 850.815002,714.844482 
	C851.028137,712.893799 851.543762,710.977783 852.204956,708.724731 
	C855.544312,703.966309 859.803406,702.043823 865.265747,702.516296 
	C867.904480,702.744507 870.631104,702.372864 873.196899,703.096130 
	C884.689819,706.335999 895.562256,703.112427 906.499817,700.163757 
	C912.185364,698.631042 917.915405,697.605469 923.161377,701.620850 
	C922.976257,700.038940 922.524292,698.393066 923.859741,696.638672 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M924.066772,696.090271 
	C923.987793,698.994263 923.110840,701.823181 926.950195,703.206543 
	C924.788208,703.626099 923.008606,706.424927 921.695862,702.400024 
	C920.881836,699.903870 917.550659,700.407776 915.556030,700.292969 
	C912.042480,700.090698 908.281738,700.350525 905.085632,702.355408 
	C903.178345,703.552002 901.202393,704.096558 898.955872,704.021301 
	C894.978271,703.888000 891.040527,703.666260 887.570007,706.481506 
	C886.169861,707.617310 884.017944,707.254211 882.275208,706.560608 
	C875.318054,703.791687 868.024963,704.098267 860.748901,703.959290 
	C856.925171,703.886292 856.118774,708.007263 852.892761,709.226440 
	C849.110107,707.097595 850.855530,703.138306 850.155090,699.931702 
	C848.962097,694.470276 848.141724,688.876953 848.563171,683.207336 
	C848.762024,680.531555 849.493652,678.562256 852.489746,677.677124 
	C862.803406,674.629944 866.151611,669.554688 865.350647,658.708313 
	C865.265320,657.552979 865.057434,656.409363 864.997681,654.867432 
	C865.438416,650.585266 868.201965,650.719177 871.363281,651.154297 
	C875.417603,656.352539 878.303284,662.047974 883.344604,666.092773 
	C885.162292,667.551147 886.759338,669.393738 888.953796,670.195374 
	C892.938171,671.650818 895.644836,674.417664 898.018188,678.134521 
	C898.906738,679.089661 899.122253,680.235779 900.559204,680.540771 
	C901.782654,680.592651 902.522217,680.152588 903.519287,679.481934 
	C904.916199,678.566467 905.778687,677.575562 906.854858,676.292480 
	C909.570618,674.337708 911.972534,674.747253 913.859802,676.771729 
	C916.670349,679.786621 919.669250,682.778442 920.156616,687.593628 
	C921.393188,690.576172 922.681580,693.177734 924.066772,696.090271 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M997.711121,635.753418 
	C998.956604,636.407349 1001.431274,636.119507 999.604553,638.078857 
	C998.281982,639.497437 998.389160,640.959473 997.921875,642.487915 
	C996.715881,646.432861 992.664001,647.987305 990.075867,650.802368 
	C989.427490,651.507629 987.985657,650.350769 989.158447,648.793457 
	C990.866882,646.524719 989.612671,644.078735 989.530518,641.344666 
	C987.602539,644.006714 986.783997,649.755127 982.774902,643.188599 
	C980.851257,646.850281 983.288818,650.301453 982.190857,653.857605 
	C980.232483,652.091187 980.546631,649.619934 979.281860,647.935547 
	C978.822144,647.323303 978.295654,646.366943 977.328979,646.894836 
	C976.634583,647.274109 975.790222,647.940613 975.632935,648.622070 
	C975.325378,649.954651 976.504578,649.542053 977.250610,649.596313 
	C978.522522,649.688843 979.027588,650.678162 978.903931,651.668091 
	C978.377930,655.881409 982.059448,655.894836 984.604919,657.998047 
	C984.349121,654.892334 983.476379,652.482910 984.721069,649.836792 
	C984.858521,654.186096 988.892029,656.465637 989.797852,660.441711 
	C990.037231,661.492310 990.659973,662.946045 992.124817,662.470154 
	C993.363464,662.067749 992.525024,660.845581 992.542114,659.922668 
	C992.593018,657.182373 992.887451,654.446533 993.111206,651.372375 
	C998.364502,652.669983 995.732361,657.351440 997.440796,659.916199 
	C997.841187,660.517212 997.201477,661.872375 998.730164,661.805908 
	C1000.220825,661.741028 999.267944,660.113159 1001.139221,658.842285 
	C999.061462,664.957520 1004.436218,665.483215 1006.866577,668.681152 
	C1006.958801,670.721802 1008.390381,671.010193 1009.534973,671.698669 
	C1008.052368,671.585999 1005.113831,675.573303 1005.665771,670.179626 
	C1003.628113,671.026978 1000.330200,667.544495 999.640198,672.291016 
	C998.616821,671.356201 999.358398,669.951050 997.764038,669.444092 
	C996.057068,676.370300 990.956116,672.326599 987.038940,672.328369 
	C988.927490,671.617371 990.215271,670.525635 988.432739,668.885071 
	C985.907898,666.561279 981.802185,670.585266 979.330566,667.017700 
	C978.887512,670.734314 972.908875,668.997803 973.079102,673.693298 
	C973.472107,674.412170 973.463379,674.952148 973.746887,675.562988 
	C973.873413,675.701599 973.779724,676.013123 973.779724,676.013123 
	C973.779724,676.013123 973.990906,675.720642 973.811584,675.587952 
	C973.520203,675.137451 973.505127,674.814819 973.747925,674.274292 
	C974.784424,673.346924 975.201050,670.830750 976.897217,673.612732 
	C976.906067,673.923157 976.663025,674.345703 976.874146,674.223999 
	C979.638794,673.448975 980.588623,676.121765 982.584656,676.617432 
	C980.718750,680.837219 976.441895,681.126526 973.064392,682.787964 
	C971.479126,683.567810 972.105042,680.876282 970.459351,681.056274 
	C965.033142,677.907471 963.881897,672.488647 962.190674,667.393677 
	C961.949707,666.667725 962.209717,666.028564 962.973816,665.840820 
	C967.164062,664.811096 965.608337,662.259155 964.755432,659.702271 
	C962.924805,654.214233 960.003601,649.175476 960.785522,642.781311 
	C961.177856,639.572693 958.543030,635.993896 957.174988,632.228455 
	C958.476624,629.986511 959.438293,627.597473 962.555298,627.401733 
	C963.961670,628.133484 964.420105,629.371643 965.600708,630.286255 
	C966.199341,630.474548 966.550232,630.464050 967.119995,630.215210 
	C967.613525,629.817444 967.852173,629.536865 968.219116,628.977539 
	C968.683594,628.170288 969.038513,627.651245 969.722534,626.971680 
	C970.217590,626.755493 970.444763,626.742798 970.990112,626.862732 
	C972.133728,627.552490 973.018738,628.303711 973.180176,629.165588 
	C974.033142,633.719788 978.368774,633.537415 981.248291,635.320251 
	C981.496826,634.912537 981.419861,634.409912 981.864319,633.722168 
	C987.739197,630.166626 992.448486,633.876099 997.711121,635.753418 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M920.456421,687.931519 
	C918.361389,683.697876 915.588257,680.200317 912.317505,676.957520 
	C910.350647,675.007385 909.265991,675.935059 907.648438,677.653381 
	C904.856140,676.644348 905.178528,674.537292 905.637695,672.037476 
	C906.220947,668.509949 908.954468,666.457886 910.079834,663.663269 
	C908.696411,662.441162 907.283813,663.285889 905.722961,662.777832 
	C905.176453,662.545776 904.971252,662.420044 904.527100,662.020996 
	C900.554810,652.977356 894.644226,645.480896 889.959656,637.266785 
	C888.066101,633.946655 886.139038,630.648132 884.880981,626.639282 
	C884.634705,624.941223 884.414490,623.597412 883.874756,621.989990 
	C877.642700,618.995605 875.564148,612.363037 870.583740,608.071167 
	C869.727966,605.680786 870.351807,603.873352 871.869263,601.971741 
	C876.422180,601.416016 876.399170,606.214783 879.469482,607.846375 
	C879.900879,608.212219 880.061646,608.369629 880.420898,608.795410 
	C881.294128,610.381592 881.800842,611.812012 883.336426,612.906982 
	C884.315247,613.584961 885.152222,613.805969 886.268677,614.236450 
	C890.467957,618.312073 892.870056,623.265442 895.703430,627.909607 
	C900.708679,636.113647 905.602539,644.384399 911.450623,652.450256 
	C911.824158,652.879517 911.978271,653.046631 912.342163,653.478149 
	C912.675293,653.927002 912.798706,654.111511 913.087402,654.580566 
	C914.020752,656.359497 914.668396,657.931091 916.190674,659.294312 
	C917.325378,660.360413 918.439880,660.836365 919.886902,661.352905 
	C923.397217,662.576172 924.363770,659.449585 926.506592,657.920105 
	C926.809387,657.466064 926.933167,657.285461 927.256836,656.842896 
	C927.738281,656.241089 928.032532,655.912598 928.569092,655.354492 
	C929.821350,654.244019 930.803833,653.287354 932.592224,653.735718 
	C933.538879,654.301514 934.219116,654.664734 935.250671,655.187378 
	C937.105896,659.763977 932.588623,660.902344 930.832275,663.941284 
	C929.560364,665.184204 928.359558,665.904541 926.759949,666.622192 
	C925.128723,667.185425 924.721497,668.008362 925.525330,669.195496 
	C926.219849,670.221191 926.806396,669.403259 927.647705,668.750488 
	C928.679260,667.984314 929.561401,667.671265 930.748230,667.168457 
	C935.150696,665.684631 938.128418,661.558777 943.332031,662.528198 
	C946.893005,664.965271 942.431824,666.319458 943.003540,668.626038 
	C942.995056,669.009216 942.536499,668.990356 942.307068,668.984375 
	C941.444214,669.465576 941.104309,670.209412 940.262939,670.875244 
	C939.425842,671.206970 938.855774,671.411621 938.119263,671.878662 
	C937.359802,672.606995 936.945740,673.258484 936.098816,673.861267 
	C935.450867,674.013855 935.036377,674.008118 934.310913,674.001221 
	C934.001587,674.989502 933.971008,675.980408 934.013367,676.968140 
	C934.061096,678.082336 933.802490,679.569763 935.364258,679.723572 
	C937.308228,679.915039 936.703003,677.875122 937.804993,676.059204 
	C937.947937,679.901001 943.319336,681.121643 940.228027,685.570496 
	C939.546082,686.460815 938.958252,687.012756 938.178223,687.797241 
	C936.770386,687.759399 934.923401,688.666321 934.539429,687.015930 
	C934.056519,684.940552 936.078613,684.118347 937.850220,683.246094 
	C935.613098,680.787964 933.674805,683.293396 931.403442,682.991211 
	C930.336182,682.994629 929.655640,682.996155 928.634888,683.011108 
	C923.767456,681.518372 923.693787,686.864868 920.456421,687.931519 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M1005.845703,582.631897 
	C1003.281372,582.641296 1000.891968,583.798828 998.145264,584.570862 
	C997.380737,585.480591 996.731995,585.910767 995.574463,586.218323 
	C994.059875,586.439941 992.916382,586.372192 991.774780,586.386047 
	C984.958862,586.468445 984.410645,587.052673 984.532410,594.515747 
	C984.522705,595.162292 984.483154,595.422546 984.259766,596.038330 
	C982.580017,597.827515 980.833862,598.297485 978.477112,597.570496 
	C977.982727,597.171204 977.836670,596.958984 977.679932,596.367676 
	C977.978333,595.226074 978.319336,594.472839 978.601501,593.704041 
	C980.098816,589.624146 979.476501,588.561096 975.301636,588.399414 
	C968.481750,588.135315 961.883606,589.604919 955.334229,591.261475 
	C953.777649,591.655151 952.089233,592.199219 951.917480,594.651184 
	C951.930359,596.519287 951.529541,597.952271 951.006653,599.751648 
	C950.548523,601.112305 950.134094,602.071472 949.219727,603.205200 
	C947.889038,604.015625 946.841980,604.032471 945.485596,603.281250 
	C945.446106,599.168152 942.266479,600.329773 940.074463,599.390137 
	C938.690613,596.800903 940.653442,595.646790 941.802612,593.865479 
	C941.032715,591.363098 938.512573,592.127075 936.585571,590.463684 
	C947.582092,586.725403 959.342896,585.333435 971.191956,584.508789 
	C974.640869,584.268799 978.090698,584.041382 981.853882,583.787048 
	C980.265503,577.706238 974.795776,576.507019 969.233154,573.775146 
	C983.443726,571.541992 994.504272,577.338440 1005.845703,582.631897 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M957.214600,690.678772 
	C955.599304,692.612183 956.822327,692.895203 958.077148,692.988647 
	C960.966431,693.203735 962.648010,694.964600 963.939392,697.691772 
	C963.128174,698.398560 962.610474,697.892944 961.790222,697.156128 
	C960.757629,697.277710 960.052307,697.567200 959.074951,697.950562 
	C957.146851,698.441895 956.105896,697.219543 954.886047,696.517883 
	C953.260071,695.582703 951.624573,695.142395 949.827332,695.982117 
	C949.523071,696.124390 949.045776,696.382263 949.105164,696.521301 
	C949.430054,697.281067 950.135071,696.631165 950.974243,696.861206 
	C951.533875,696.914490 951.755310,696.948853 952.299438,697.069214 
	C953.244995,697.373901 953.825073,697.680298 954.654785,698.198120 
	C955.410156,698.786560 955.779846,699.298645 956.335449,700.059448 
	C956.646362,700.473572 956.770447,700.639954 957.077515,701.059387 
	C957.849426,702.180725 958.412109,703.067505 959.262817,704.152344 
	C959.582031,704.598816 959.703735,704.783997 959.988037,705.263245 
	C961.482239,708.504822 961.769897,711.712036 962.448059,715.164795 
	C962.285950,715.954407 962.011414,716.306763 961.339417,716.770325 
	C960.600952,716.740479 960.141113,716.506897 959.454224,716.147339 
	C957.927124,716.042053 958.755188,717.246399 958.127441,717.981812 
	C958.269531,720.205261 957.433472,721.969482 956.928772,724.209961 
	C956.127136,726.254333 954.474731,726.294006 952.771423,726.903320 
	C952.476990,727.040466 952.434265,727.095825 952.399780,727.090149 
	C942.099060,720.610168 939.510986,710.858582 940.905579,699.256592 
	C941.633057,699.255371 942.061279,699.532349 942.727051,699.901855 
	C944.021240,700.581055 943.387207,701.771362 943.970947,702.772034 
	C943.587463,701.635010 944.227173,700.603027 943.345825,699.473999 
	C943.421753,697.076538 943.704529,694.927917 943.987000,692.366821 
	C943.472717,691.592896 942.945801,691.243469 942.858398,690.314941 
	C946.770264,689.378479 950.555359,688.730530 954.751099,688.034180 
	C956.913879,687.823914 957.354797,688.915344 957.214600,690.678772 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M929.731445,589.070679 
	C939.366882,604.646057 947.669800,620.482727 955.191528,636.736145 
	C958.445007,643.766479 958.421326,643.777405 950.414673,645.046631 
	C948.854797,643.745544 950.001526,642.580139 950.178772,641.035278 
	C946.734497,632.158447 942.651917,623.928833 938.226685,615.462036 
	C935.256714,610.561646 933.716431,604.981140 927.581848,603.166687 
	C925.807922,602.641968 924.867493,600.759338 925.614990,598.323914 
	C926.975891,597.062561 928.014954,597.106262 929.029358,598.136719 
	C929.414734,594.817932 925.727966,592.730042 925.757690,589.030151 
	C926.359070,588.392334 926.826904,588.191040 927.739136,588.076965 
	C928.683838,588.137756 929.171509,588.345947 929.731445,589.070679 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M963.130981,628.215698 
	C962.028870,628.174927 960.381287,627.612244 960.732849,629.037720 
	C961.683105,632.891357 958.865662,631.075684 957.276978,631.650391 
	C952.898865,625.288147 950.073853,618.035400 946.718018,610.655518 
	C946.746582,607.240662 948.588928,605.808777 951.736450,605.085449 
	C955.165222,604.480408 958.182739,604.167358 961.432983,605.708618 
	C962.792786,606.731750 963.144897,608.010742 964.127686,609.284973 
	C964.984802,610.547913 965.569641,611.571411 966.807129,612.526611 
	C967.807739,616.885559 965.054077,615.720337 962.598267,615.470520 
	C961.545959,615.303467 960.930298,614.989868 960.023682,614.560547 
	C959.291077,614.352966 959.148315,613.836853 958.913818,613.900757 
	C959.407227,614.305603 959.720520,614.507141 960.257263,614.906250 
	C960.526672,615.324219 960.588501,615.520813 960.655029,616.028015 
	C960.613647,616.539490 960.567749,616.740417 960.397949,617.220886 
	C959.715271,618.353088 959.356934,619.213928 960.365601,620.347290 
	C961.674438,621.896973 963.386841,622.298340 964.953857,623.522095 
	C965.279053,623.971008 965.369263,624.180359 965.485168,624.735229 
	C965.404358,626.031433 965.099121,626.913879 964.355225,627.990051 
	C963.877380,628.310181 963.646667,628.371094 963.130981,628.215698 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M826.912781,739.704956 
	C827.649353,743.260437 829.521973,744.014832 832.795349,743.940125 
	C845.889038,743.641296 858.990601,743.686829 872.545410,743.724243 
	C873.280090,744.854980 873.558533,745.866455 873.873657,747.191406 
	C873.910278,747.504883 873.648499,747.929199 873.821594,748.108582 
	C871.645325,750.008301 868.909119,749.578918 866.278198,749.632080 
	C852.808472,749.904236 839.324524,749.093994 825.437134,750.155090 
	C823.649292,750.045166 822.504395,749.326782 820.914185,748.757446 
	C819.801880,748.714600 819.053589,748.586670 817.945312,748.511230 
	C816.074707,747.236694 814.824829,745.998291 816.212402,743.640381 
	C818.785889,742.597900 820.636841,741.281677 821.937561,738.748718 
	C823.889404,737.938660 825.269043,738.567505 826.912781,739.704956 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M939.424072,644.777832 
	C939.634338,646.420410 940.444519,647.649475 939.380127,649.205444 
	C937.384216,649.111267 935.864868,648.538635 934.108032,647.609375 
	C931.534973,643.692627 929.315979,639.929138 926.569580,636.098267 
	C925.758850,634.879272 925.222290,633.893372 924.500610,632.630676 
	C924.029114,631.755920 923.765076,631.149902 923.357727,630.248535 
	C922.734741,628.506409 922.245789,627.064087 921.102112,625.555298 
	C919.247192,619.351013 915.864990,614.087891 914.350464,607.733643 
	C914.555176,605.825867 915.518127,605.221802 917.355957,605.336548 
	C920.457581,607.643188 922.528503,610.442871 924.126587,613.508362 
	C928.631653,622.149780 933.263306,630.721130 937.941040,639.268982 
	C938.814880,640.865784 939.578735,642.522644 939.424072,644.777832 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M939.766357,645.105225 
	C932.520203,632.180420 926.302979,618.895142 918.067261,606.334412 
	C919.535278,602.420227 921.782104,603.851501 923.698486,605.386169 
	C925.230225,606.612793 926.026184,608.519409 926.891968,610.690308 
	C927.073853,611.252319 927.137695,611.474854 927.286377,612.020752 
	C927.426453,612.552002 927.481628,612.759888 927.623413,613.269226 
	C927.832581,613.955872 927.964050,614.338013 928.230286,614.978638 
	C928.442749,615.410950 928.530029,615.581360 928.751892,616.002808 
	C929.067627,616.583069 929.251709,616.910645 929.594116,617.468872 
	C929.952332,618.010864 930.148926,618.324524 930.482422,618.876038 
	C930.717773,619.266418 930.809082,619.423401 931.031982,619.816101 
	C931.246765,620.209839 931.330017,620.367737 931.529297,620.764404 
	C931.791443,621.322205 931.937744,621.640930 932.209656,622.189453 
	C932.420227,622.572632 932.505676,622.725830 932.721558,623.110596 
	C932.942932,623.496948 933.033752,623.651672 933.272278,624.037964 
	C933.527344,624.423401 933.634827,624.577209 933.913269,624.964966 
	C934.197815,625.361877 934.311462,625.524841 934.584595,625.950806 
	C934.839844,626.402283 934.935425,626.590637 935.159302,627.075562 
	C937.793945,633.152466 942.107422,638.094421 943.019531,644.776123 
	C941.932678,645.051025 941.065796,645.062256 939.766357,645.105225 
z"/>
<path fill="#0F050A" opacity="1.000000" stroke="none" 
	d="
M929.896790,589.112488 
	C929.446411,589.310120 929.033142,589.164673 928.319031,588.886719 
	C927.085083,587.950562 926.066895,587.264160 924.782654,586.385010 
	C922.695557,584.200562 921.734924,581.418518 918.743958,580.099548 
	C918.259338,579.862610 918.070862,579.764038 917.362183,579.339966 
	C916.510742,578.807007 916.168213,578.620056 915.538574,578.388306 
	C914.886230,578.268188 914.507141,578.254700 913.839661,578.340698 
	C912.385315,578.605225 911.955566,579.664673 910.968384,580.618774 
	C908.157532,582.251953 905.870605,582.512634 904.253784,579.063232 
	C904.101013,577.138123 905.013672,575.925110 905.719299,574.269104 
	C906.384888,571.812378 906.178406,568.916382 910.222656,570.087402 
	C920.235962,570.085327 926.214050,575.345337 930.243225,583.979065 
	C930.518250,585.071167 931.018066,585.663574 931.073853,586.697144 
	C930.576294,587.606567 930.255066,588.187988 929.896790,589.112488 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M933.617432,647.090576 
	C935.933472,646.598328 937.418152,647.478027 938.911133,649.009155 
	C938.150940,650.149353 937.291870,650.927002 936.216553,651.903809 
	C935.735046,652.312256 935.464111,652.513733 934.946960,652.787354 
	C934.187988,653.064392 933.669373,653.261414 933.004700,653.698364 
	C931.717773,654.472961 930.576904,655.007568 929.217590,655.780823 
	C928.771729,656.255737 928.532288,656.479126 928.059265,656.796143 
	C927.837830,656.902771 927.929260,656.883911 927.896484,656.850708 
	C926.004333,659.291870 923.734375,661.191589 920.312988,661.916992 
	C918.591980,662.031799 917.098572,663.035828 915.975586,660.944092 
	C914.690247,658.460693 915.234741,656.765381 917.341980,655.688599 
	C922.714417,652.943542 927.517700,649.155334 933.617432,647.090576 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M929.730713,664.340332 
	C930.273621,660.359985 935.256592,659.865173 935.478516,655.676758 
	C937.453003,655.233093 939.304077,655.119385 941.572144,654.995850 
	C943.499695,656.696167 944.577454,658.582764 944.222900,661.277161 
	C943.975159,661.785339 943.933533,661.985596 943.762695,662.462524 
	C938.911438,662.626099 936.063049,666.840271 931.470581,667.834473 
	C929.924927,667.103210 929.640015,665.954468 929.730713,664.340332 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M943.097900,645.298279 
	C940.430176,638.537598 936.446655,632.847107 933.762634,626.286194 
	C934.198730,625.856934 934.407654,625.758789 934.958923,625.707397 
	C939.201111,628.887573 941.667542,633.207642 944.908691,637.286377 
	C945.308960,637.607483 945.477356,637.720642 945.891357,638.001465 
	C946.464966,638.373596 946.802673,638.560364 947.421387,638.816162 
	C948.051819,639.018188 948.411133,639.135864 949.035583,639.355957 
	C949.996460,639.750061 950.580688,640.249390 951.535461,640.655762 
	C952.460571,642.577148 949.929810,642.797607 950.033569,644.677368 
	C947.884827,646.142700 945.687866,646.450073 943.097900,645.298279 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M996.292786,771.560181 
	C995.843933,772.188721 995.282715,772.440918 994.435791,772.809204 
	C991.135986,764.513428 988.122070,756.101685 985.115906,747.314209 
	C985.655823,746.242493 985.393982,745.066650 986.790039,744.839233 
	C990.990051,753.414307 993.183105,762.438293 996.292786,771.560181 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M954.746582,699.153931 
	C954.007507,698.948547 953.586182,698.869385 953.064087,698.579224 
	C952.871948,698.042358 952.686401,697.784241 952.230225,697.759949 
	C950.140381,697.926086 948.226868,697.926086 946.467468,697.926086 
	C950.025513,692.587402 952.481201,692.503296 958.497681,697.901917 
	C960.625122,700.584778 962.245850,703.225830 962.916870,706.703979 
	C961.409729,709.722046 961.376038,709.735962 960.485291,707.575989 
	C960.187866,706.854919 959.959534,706.116943 959.189331,705.277344 
	C958.926025,705.047363 958.986084,704.992249 958.964233,705.026184 
	C958.106934,703.835327 958.022095,702.107056 956.185608,701.199646 
	C955.906372,701.032898 955.979004,701.018616 955.975342,701.055420 
	C955.546082,700.549927 955.555115,699.789978 954.746582,699.153931 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M941.147217,698.633850 
	C940.550781,709.160645 941.783081,718.569336 951.529053,724.582520 
	C951.942627,724.837708 951.954285,725.744263 952.259277,726.715942 
	C944.069397,725.094177 941.583313,718.323486 940.175720,711.272217 
	C939.314575,706.958496 939.521851,702.297668 940.061279,697.892151 
	C940.350586,695.530151 940.830139,697.751831 941.147217,698.633850 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M987.054077,744.592285 
	C986.606567,745.528442 986.108215,746.080688 985.366821,746.785767 
	C983.570374,742.454651 982.056213,737.956604 980.445679,733.493408 
	C979.730408,731.511169 979.673340,729.925476 982.456055,729.175537 
	C982.866333,734.528381 986.180969,739.022400 987.054077,744.592285 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M969.154053,696.750977 
	C964.565186,696.387634 959.663330,688.041565 961.651855,684.052124 
	C967.012024,686.633057 967.962463,691.690247 969.154053,696.750977 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M988.509155,709.259399 
	C989.756409,710.251343 990.825439,711.539917 991.508667,713.008118 
	C992.180298,714.451172 994.999573,715.692139 993.049316,717.388306 
	C991.777771,718.494263 989.031982,718.680786 987.483459,717.424133 
	C985.688965,715.967834 985.395325,713.862000 987.426880,711.930664 
	C987.937744,711.444946 987.930908,710.414734 988.509155,709.259399 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M984.124512,717.224365 
	C984.354065,718.232483 984.491821,718.873901 984.699158,719.491943 
	C985.326477,721.362000 984.785400,722.637268 982.913330,723.393372 
	C981.710754,723.879028 980.600342,724.080322 980.133179,722.578674 
	C979.466125,720.434387 978.647461,718.244995 980.645508,716.247681 
	C982.147461,714.746216 983.176941,715.212158 984.124512,717.224365 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M968.940552,697.026978 
	C967.895081,692.270020 964.781860,688.552002 962.268677,684.193726 
	C963.171082,679.547546 964.700928,683.191284 965.233459,684.093140 
	C967.495300,687.923706 969.453125,691.934753 970.804077,696.566162 
	C970.497314,697.308044 970.087463,697.464172 969.324463,697.203491 
	C969.051758,696.981873 968.975952,697.008118 968.940552,697.026978 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M956.387573,654.494629 
	C959.109375,655.310852 960.797974,658.175110 959.442688,659.438477 
	C957.165100,661.561646 954.163635,659.679321 951.135071,657.829590 
	C953.098633,656.715759 955.136353,656.394653 956.387573,654.494629 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M969.240967,729.988403 
	C967.207886,732.245117 964.686218,733.294312 961.770264,734.253906 
	C960.371704,733.829956 960.339478,732.985229 960.745178,731.695251 
	C962.621277,729.170959 965.152832,728.458252 967.765442,727.308960 
	C968.811584,727.928528 969.218201,728.697571 969.240967,729.988403 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M943.903381,594.182800 
	C942.230652,595.331726 940.557556,596.353271 939.835815,598.773621 
	C937.836609,596.260254 935.869568,593.403564 933.674011,590.261841 
	C934.032471,589.965698 934.619385,589.954651 935.660156,589.966309 
	C936.113892,589.989075 936.026550,589.997559 936.021240,589.953979 
	C938.165527,592.046326 941.647339,591.584534 943.903381,594.182800 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M951.911865,605.620483 
	C950.546021,607.340515 947.784851,607.218689 946.965576,610.060181 
	C946.134705,608.076660 942.813660,606.576721 945.080322,603.335571 
	C946.174011,602.997192 947.158569,602.996155 948.512451,602.994995 
	C950.308167,603.200867 950.985352,604.340210 951.911865,605.620483 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M947.348206,670.900635 
	C948.944214,669.730896 945.755188,668.140564 947.215515,666.723083 
	C949.954468,668.442139 951.663086,672.156860 952.336975,678.115784 
	C949.318359,676.374573 949.704773,672.726746 947.348206,670.900635 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M946.970764,671.076294 
	C946.443848,674.077637 949.150696,676.508057 948.476196,680.999207 
	C946.358032,676.488647 944.766174,673.098938 943.084717,669.359253 
	C942.995056,669.009216 943.002075,669.000000 943.004578,668.993286 
	C944.722412,668.524963 945.688721,669.440369 946.715942,670.992432 
	C947.035034,671.154358 946.981628,671.109436 946.970764,671.076294 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M960.513123,723.808960 
	C963.406494,721.273010 965.039001,717.693604 969.169922,715.374878 
	C967.810974,720.173706 965.147522,722.381287 961.560547,724.161255 
	C960.977966,724.222961 960.732483,724.200378 960.513123,723.808960 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M961.639160,697.321411 
	C962.089600,697.241394 962.716125,697.494568 963.660767,697.898071 
	C965.622620,700.797974 968.178589,703.083130 968.749817,707.593323 
	C964.863831,704.556458 963.762146,700.797668 961.639160,697.321411 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M944.381836,661.698242 
	C943.350708,659.627380 942.684753,657.669739 942.004028,655.349121 
	C941.989258,654.986084 941.998535,654.999329 941.992920,654.994019 
	C942.162720,654.875916 942.338196,654.763123 942.805908,654.762390 
	C945.045044,655.988953 945.883789,657.942688 946.675964,659.853088 
	C947.457886,661.738892 946.365540,662.114136 944.381836,661.698242 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M969.061035,697.356934 
	C969.444397,696.973389 969.837097,696.964966 970.521790,696.940674 
	C972.328735,699.937866 973.625427,703.009155 973.711426,707.166077 
	C970.211548,704.419434 970.842346,700.486572 969.061035,697.356934 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M958.912598,705.431885 
	C960.421814,704.922424 960.984070,705.772522 961.100708,707.110168 
	C961.239197,708.699768 961.824707,708.124268 962.662354,707.228882 
	C963.501099,709.726746 963.967407,712.376343 962.966309,715.494263 
	C962.613159,716.079590 962.383057,716.230591 961.784668,716.194946 
	C961.218506,712.452576 959.942200,709.163330 958.912598,705.431885 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M988.904053,708.526306 
	C988.856323,708.884094 988.583801,708.882202 988.448853,708.870422 
	C987.306030,707.803894 986.407898,706.602722 985.256592,705.739075 
	C984.268982,704.998230 983.472351,704.282471 983.554504,703.013977 
	C983.578003,702.650391 984.017944,702.059265 984.332886,702.012024 
	C985.923462,701.773376 986.689026,703.098022 987.336670,704.113770 
	C988.104980,705.318787 988.432983,706.804443 988.904053,708.526306 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M954.133667,670.670776 
	C953.525085,668.821350 952.226379,667.451050 953.446350,665.540588 
	C957.301575,667.072021 955.266846,670.803955 957.325134,673.333374 
	C954.714417,673.385315 954.738770,671.947388 954.133667,670.670776 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M958.405151,678.583618 
	C957.315308,677.242065 956.549683,676.061768 958.236206,675.109314 
	C959.052429,674.648315 959.923523,675.051514 960.283264,675.872009 
	C960.828369,677.114746 962.522217,678.346008 961.154480,679.761597 
	C960.308105,680.637451 959.540955,679.128357 958.405151,678.583618 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M969.569336,730.239746 
	C968.375671,729.790710 967.897278,729.056580 968.086670,727.646973 
	C969.491516,726.873230 970.870422,726.447876 972.602051,725.946899 
	C973.107178,726.077637 973.259521,726.284119 973.245911,726.837891 
	C972.867432,729.088379 971.122314,729.346130 969.569336,730.239746 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M973.449829,727.076294 
	C973.056335,726.966553 973.032654,726.747925 972.981934,726.200317 
	C972.633911,723.818665 972.312866,721.766113 971.991882,719.713562 
	C973.312866,721.997070 977.121033,723.722900 973.449829,727.076294 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M952.906250,727.131714 
	C953.767822,726.322876 955.058716,725.605408 956.614990,724.752930 
	C957.860107,724.299133 958.839844,723.980347 960.179443,723.550842 
	C960.652893,723.574402 960.766541,723.708618 961.051819,724.044189 
	C958.987549,726.280334 956.351379,727.254333 952.906250,727.131714 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M952.751953,736.039368 
	C952.161865,735.016663 951.660034,734.154602 952.354553,733.496582 
	C953.281311,732.618530 953.692078,733.626038 954.116211,734.269836 
	C954.720825,735.187805 955.315186,736.112732 955.924194,737.050537 
	C954.433960,738.221191 953.772095,736.980103 952.751953,736.039368 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M957.330872,690.839844 
	C956.949829,689.910461 956.512268,689.008545 955.424988,688.139893 
	C955.249084,687.221863 955.055969,686.173706 955.482117,685.753357 
	C956.365845,684.881531 956.807556,685.949524 957.173767,686.589478 
	C957.906616,687.870544 958.475281,689.201111 957.330872,690.839844 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M943.129883,699.425293 
	C946.908691,700.407593 943.189392,702.374146 944.373901,704.549866 
	C942.491943,703.030334 943.123901,701.806335 942.983521,700.362732 
	C942.964539,699.994446 943.120850,699.625488 943.129883,699.425293 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M959.889526,665.923584 
	C961.012878,666.854736 961.224060,667.771790 960.336304,668.542419 
	C960.164734,668.691345 959.119690,668.166321 958.781189,667.721252 
	C958.092651,666.815979 957.924988,665.883301 959.889526,665.923584 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M960.604858,731.235840 
	C961.073914,732.062134 961.154968,732.793884 961.328369,733.885376 
	C960.700134,734.998962 959.712219,735.608215 959.321777,734.246338 
	C959.049377,733.296143 957.448425,731.416992 960.604858,731.235840 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M935.107971,704.475220 
	C934.993347,703.394897 934.821350,702.347168 936.006958,702.494507 
	C937.004578,702.618530 937.019043,703.619568 936.888489,704.408447 
	C936.668152,705.739014 935.948486,705.330994 935.107971,704.475220 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M968.420959,711.302734 
	C968.027466,710.269287 967.787964,709.421082 968.541016,708.820129 
	C968.653992,708.729919 969.456726,709.180908 969.611450,709.528137 
	C970.038635,710.486694 970.195251,711.474548 968.420959,711.302734 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M952.415588,652.593018 
	C952.165771,650.994934 953.044617,650.463989 954.233521,650.317139 
	C954.400269,650.296509 954.789124,650.704529 954.787659,650.912231 
	C954.778381,652.283691 953.948425,652.817932 952.415588,652.593018 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M942.590088,690.010315 
	C943.293518,690.485901 943.601990,690.945435 943.948608,691.679626 
	C942.672119,692.101074 940.971252,693.266296 940.313538,691.264709 
	C939.851074,689.857239 941.307861,690.070374 942.590088,690.010315 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M933.759949,692.270691 
	C934.202087,693.546570 934.551453,694.567932 933.378052,695.020325 
	C932.705200,695.279785 932.156433,694.761047 932.105469,694.077698 
	C932.029358,693.057495 931.621887,691.703857 933.759949,692.270691 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M940.166016,671.237305 
	C940.077209,670.066772 940.368103,669.283447 941.746338,669.014038 
	C942.062866,669.723572 942.048157,670.468811 941.985229,671.637695 
	C941.403442,671.864990 940.869812,671.668640 940.166016,671.237305 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M928.449341,683.292114 
	C928.978699,682.343872 929.720825,682.089417 930.799683,682.850830 
	C930.511902,684.463013 929.644348,684.382263 928.449341,683.292114 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M996.240173,704.755310 
	C995.630798,704.210388 995.304199,703.740173 994.977661,703.269897 
	C996.157532,702.739136 997.127869,703.051270 998.085693,704.313599 
	C997.662903,704.690979 997.092896,704.760437 996.240173,704.755310 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M982.908142,750.786621 
	C982.700562,751.091309 982.507019,751.061035 982.021851,750.978882 
	C980.866577,750.003784 980.777588,748.988708 981.364563,747.822937 
	C982.602722,748.312073 982.620056,749.468262 982.908142,750.786621 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M1022.501160,753.023926 
	C1022.751526,753.834961 1022.688171,754.710327 1022.388550,755.819702 
	C1020.846863,755.049622 1020.601746,754.058105 1022.501160,753.023926 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M936.117188,674.085327 
	C935.909546,673.068115 935.818909,672.022827 937.599976,672.088135 
	C937.952759,672.141113 938.011169,672.587585 938.048767,672.809570 
	C938.183411,673.180664 938.280457,673.329712 938.252686,673.714539 
	C937.623291,674.733215 936.990356,674.392090 936.117188,674.085327 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M1000.013794,731.317627 
	C1000.874817,731.447510 1001.710388,731.959778 1001.602905,733.090698 
	C1001.585144,733.278259 1001.162720,733.604675 1000.983582,733.570618 
	C999.924927,733.369568 1000.117188,732.426758 1000.013794,731.317627 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M963.145203,739.068665 
	C963.731506,738.279419 964.393372,738.017334 964.725952,738.691467 
	C964.891052,739.026062 964.487488,739.934937 964.088867,740.190613 
	C963.348755,740.665283 963.085632,740.036255 963.145203,739.068665 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M938.305908,687.964539 
	C937.996094,687.032715 938.286804,686.230713 939.685181,685.877686 
	C940.043213,686.820740 939.753906,687.634460 938.305908,687.964539 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M931.296021,687.339844 
	C929.921509,686.950867 929.291443,686.249084 930.254822,685.339905 
	C931.226135,684.423279 931.846252,685.159729 932.053345,686.605225 
	C931.852417,687.130737 931.715576,687.266968 931.296021,687.339844 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M979.992065,742.338135 
	C980.988708,742.600281 981.067749,743.536682 980.873901,744.528503 
	C980.836121,744.721863 980.505310,744.857910 980.309692,745.020386 
	C980.201965,744.238159 980.094238,743.456055 979.992065,742.338135 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M931.062500,687.540588 
	C931.170227,687.209534 931.327087,687.142517 931.736694,687.035034 
	C932.524597,687.356018 933.013062,687.873962 932.409729,688.406921 
	C931.806885,688.939453 931.352173,688.437317 931.062500,687.540588 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M958.206299,718.010681 
	C958.002625,717.333069 957.600769,716.293823 958.991821,715.881592 
	C958.963684,716.608643 958.700317,717.195923 958.206299,718.010681 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M969.781921,682.321899 
	C970.043518,682.940552 970.011475,683.678223 969.952881,684.784302 
	C968.708862,684.421814 968.869263,683.468384 969.781921,682.321899 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M931.183105,587.069946 
	C930.647888,586.528076 930.398254,586.031067 930.104980,585.253296 
	C930.294800,584.807617 930.528320,584.642578 931.121094,584.711731 
	C931.759399,585.453369 932.038391,585.960938 932.176758,586.736328 
	C931.846985,587.041077 931.657776,587.077942 931.183105,587.069946 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M980.001221,741.998779 
	C979.278870,741.557800 978.956116,740.931885 979.186584,740.098450 
	C979.203308,740.038086 979.769409,740.034241 979.782532,740.083313 
	C979.896912,740.513306 979.943604,740.961182 980.003967,741.703125 
	C979.997559,742.002441 980.000000,742.000000 980.001221,741.998779 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M999.976562,731.015259 
	C999.164490,730.598022 998.968872,729.904236 999.161072,729.086548 
	C999.177734,729.015564 999.749939,728.977661 999.762634,729.018372 
	C999.897156,729.450073 999.970703,729.900757 1000.060669,730.644775 
	C1000.060425,730.943298 1000.005554,730.992554 999.976562,731.015259 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M928.583008,687.683960 
	C927.985779,687.724060 927.631653,687.522705 927.277527,687.321289 
	C927.856689,686.557007 928.344910,686.954468 928.583008,687.683960 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M978.034790,735.242432 
	C978.620544,735.231689 979.146484,735.768005 978.612793,736.246643 
	C978.141479,736.669373 978.089661,735.926270 978.034790,735.242432 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M977.952576,735.033691 
	C977.459229,734.687561 976.801697,734.339905 977.586365,733.678772 
	C977.739746,733.926819 977.893127,734.174866 978.088501,734.650024 
	C978.130615,734.877197 978.013367,734.983154 977.952576,735.033691 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M961.302429,716.142822 
	C961.653931,715.989380 961.891479,715.970459 962.486084,715.940063 
	C962.929382,716.761719 962.559387,717.161926 961.389160,717.044128 
	C961.112976,716.743591 961.155518,716.511353 961.302429,716.142822 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M976.976807,713.728821 
	C976.369995,713.792786 975.848389,713.248718 976.328369,712.729004 
	C976.771118,712.249695 976.940430,712.939392 976.976807,713.728821 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M938.221252,720.414673 
	C938.170044,720.588623 937.967407,720.734375 937.897827,720.686523 
	C937.530273,720.434082 937.623169,720.282410 938.221252,720.414673 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M942.025391,671.983154 
	C942.505249,672.332397 943.277588,672.622803 942.412415,673.336670 
	C942.269714,673.070984 942.127075,672.805237 941.960815,672.300415 
	C941.937134,672.061340 941.994751,672.007751 942.025391,671.983154 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M931.949829,587.324646 
	C933.205200,587.000977 933.278198,587.984131 933.269287,589.191956 
	C932.642883,588.938599 932.275452,588.314453 931.949829,587.324646 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M970.273926,734.925781 
	C970.116943,734.661804 970.418945,734.491272 970.720947,734.320679 
	C970.724854,734.553467 970.728882,734.786255 970.273926,734.925781 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M970.160400,735.172913 
	C970.041870,735.439514 969.809998,735.590698 969.578125,735.741943 
	C969.540771,735.520691 969.503418,735.299377 969.640503,734.955200 
	C969.814880,734.832336 970.047058,735.057556 970.160400,735.172913 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M972.647461,732.845459 
	C972.916077,732.470947 973.231750,732.329285 973.547485,732.187622 
	C973.557678,732.420166 973.567810,732.652649 973.368896,733.029846 
	C973.159912,733.174500 972.694580,733.078369 972.647461,732.845459 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M973.022095,733.031921 
	C972.845825,733.324280 972.531738,733.474060 972.217590,733.623779 
	C972.213928,733.398315 972.210266,733.172913 972.403442,732.780029 
	C972.600342,732.612610 972.884338,732.889343 973.022095,733.031921 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M936.606201,718.274048 
	C936.591431,718.524963 936.405762,718.577026 936.220093,718.629089 
	C936.291809,718.444458 936.363586,718.259827 936.606201,718.274048 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M960.556213,718.462219 
	C960.592468,718.521301 960.519958,718.403137 960.556213,718.462219 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M977.128296,713.885437 
	C977.392944,713.992920 977.554077,714.201294 977.715210,714.409668 
	C977.499390,714.447449 977.283569,714.485291 976.946167,714.358765 
	C976.824585,714.194519 977.024902,713.986267 977.128296,713.885437 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M942.963623,654.747314 
	C942.915039,654.913879 942.732056,654.953308 942.268188,654.990723 
	C942.267944,654.865845 942.548584,654.742981 942.963623,654.747314 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M934.968628,652.832092 
	C934.962402,652.635864 935.218079,652.404297 935.737061,652.137817 
	C935.743713,652.334229 935.487183,652.565491 934.968628,652.832092 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M975.540894,710.467773 
	C975.577148,710.532959 975.504700,710.402527 975.540894,710.467773 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M938.266602,673.861206 
	C938.127930,673.950317 938.054321,673.493042 938.070312,673.262329 
	C938.477234,673.187012 938.583496,673.433838 938.266602,673.861206 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M949.426880,681.475586 
	C949.462708,681.463989 949.391113,681.487244 949.426880,681.475586 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M876.372498,46.995483 
	C875.914185,45.478741 875.269409,44.401119 873.336853,44.039276 
	C873.787720,40.885689 873.808411,36.776283 879.011475,39.701614 
	C880.056519,40.289200 881.307861,40.068367 881.912476,38.688610 
	C882.432312,37.502365 883.170593,36.478054 884.452820,37.689030 
	C885.327881,38.515469 884.815674,39.613541 884.004517,40.275463 
	C881.444092,42.364841 880.136475,45.805645 876.372498,46.995483 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M941.346313,51.996506 
	C940.887085,49.932922 939.734070,49.005230 937.368652,48.998383 
	C936.909729,46.927280 936.943054,45.007427 939.791626,44.834827 
	C940.828918,44.771973 941.429138,43.936718 941.837280,42.954235 
	C942.243042,41.977192 941.697693,39.625507 943.881653,40.777969 
	C945.704590,41.739964 944.549622,44.133255 943.808167,44.597492 
	C939.247864,47.452587 943.735718,48.604156 944.854126,50.697338 
	C943.903137,51.330666 942.800293,51.662689 941.346313,51.996506 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M847.325684,51.944496 
	C846.249939,51.997509 845.502258,51.996849 844.380981,51.995274 
	C842.902527,51.683750 841.797668,51.373146 840.347656,51.029747 
	C841.035217,45.837875 842.031860,45.291534 847.648865,46.997272 
	C847.121277,48.575413 850.107971,50.424240 847.325684,51.944496 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M848.001221,47.000969 
	C847.850586,46.201183 847.939941,45.215511 847.497070,44.637932 
	C846.556213,43.410931 845.259399,42.242233 846.914429,40.865997 
	C848.895325,39.218826 848.695374,41.920334 849.611145,42.450508 
	C850.842896,43.163548 852.129944,41.364243 853.658691,42.838074 
	C852.216064,44.481152 853.278381,48.677559 848.344604,47.035454 
	C847.997559,46.997974 848.000000,47.000000 848.001221,47.000969 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M888.005249,44.364868 
	C889.567444,43.889881 891.353882,44.432014 892.127258,42.262829 
	C892.519165,41.163742 893.497131,40.730534 894.416992,41.647243 
	C895.279541,42.506714 894.899597,43.742207 894.032288,44.179329 
	C892.297791,45.053432 891.937317,47.874722 889.541443,47.513863 
	C888.243591,47.318382 888.031555,45.938774 888.005249,44.364868 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M953.462891,37.358128 
	C951.812622,36.534534 951.889526,36.579643 952.749878,35.113117 
	C953.312500,34.154064 953.761353,32.403088 954.974731,33.873783 
	C956.154236,35.303429 959.114746,36.166542 958.317566,38.165165 
	C957.547119,40.096512 955.930237,37.993301 954.714661,37.489132 
	C954.421814,37.367691 954.089233,37.342014 953.462891,37.358128 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M853.992188,31.636948 
	C852.933289,31.999853 851.866638,31.998638 850.399963,31.998520 
	C849.332947,31.229380 849.147217,30.164188 848.210938,29.212910 
	C847.997559,28.997654 847.518311,28.992306 847.278687,28.991013 
	C846.903625,28.826963 846.768127,28.664209 846.839722,28.260603 
	C850.488403,26.696245 852.779236,27.826855 853.992188,31.636948 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M836.997314,29.372068 
	C838.067993,29.002924 839.133606,29.002392 840.598694,29.001541 
	C840.620605,31.570595 838.922424,32.984959 836.343750,33.964645 
	C836.330688,32.579922 836.661438,31.160301 836.997314,29.372068 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1013.000000,29.000191 
	C1010.583008,29.016174 1008.557678,28.324543 1006.810303,25.418818 
	C1009.675659,25.821873 1011.962341,25.516760 1012.957642,28.646975 
	C1013.000000,28.999619 1013.000000,29.000000 1013.000000,29.000191 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M893.954224,54.629322 
	C892.932190,54.998600 891.866760,55.000423 890.401855,54.999722 
	C889.760620,53.878403 889.518799,52.759609 889.138489,51.320633 
	C891.571777,50.680012 893.398438,51.481506 893.954224,54.629322 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M901.858765,35.651089 
	C902.812500,34.891365 903.464417,33.796654 904.487244,34.703995 
	C905.223572,35.357227 904.886230,36.292389 904.180725,36.742508 
	C903.170288,37.387196 902.132263,38.507481 900.793457,37.438278 
	C900.709839,37.371460 901.332031,36.421040 901.858765,35.651089 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M963.036133,26.327698 
	C964.389648,25.826881 965.779297,25.653769 967.235535,25.472357 
	C965.376038,29.035110 965.376038,29.035110 963.036133,26.327698 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M875.627075,26.439194 
	C876.747925,25.934460 877.748718,24.384659 878.554871,26.040459 
	C878.961060,26.874760 878.234009,28.075148 877.383667,28.407850 
	C875.987122,28.954264 875.376038,28.066416 875.627075,26.439194 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M856.682983,31.027077 
	C856.758423,32.345867 857.682983,34.268654 855.601562,34.729633 
	C854.325562,35.012215 854.095398,33.781048 854.008423,32.372726 
	C854.000000,32.001068 854.000000,32.000000 854.000000,31.999355 
	C854.786194,31.682203 855.572388,31.365694 856.682983,31.027077 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M909.000000,28.999748 
	C908.729553,30.384829 908.662415,31.917797 906.964661,32.395477 
	C906.787903,32.445229 906.230774,31.825306 906.161682,31.457510 
	C905.856262,29.833694 906.657471,29.055410 908.630981,29.011551 
	C909.000000,29.000490 909.000000,29.000000 909.000000,28.999748 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M847.030823,27.686981 
	C847.046814,28.019751 847.032166,28.504763 847.035645,28.747242 
	C846.273560,28.993925 845.508118,28.998131 844.359863,28.999378 
	C843.968567,27.417297 844.137451,25.974451 846.625732,26.026733 
	C847.001709,26.467007 847.008301,26.910608 847.030823,27.686981 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M921.257324,48.156921 
	C922.148621,46.986309 923.032532,46.893311 923.616394,47.944370 
	C923.819336,48.309765 923.549194,49.335148 923.196533,49.536652 
	C922.185181,50.114574 921.417908,49.686520 921.257324,48.156921 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M865.006714,23.344097 
	C865.924011,23.126722 867.106506,22.697819 867.536255,23.951900 
	C867.790649,24.694159 867.255859,25.284006 866.601135,25.462034 
	C865.020569,25.891836 865.171570,24.619230 865.006714,23.344097 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M861.412720,22.997841 
	C861.012207,22.553602 861.009827,22.109896 861.004944,21.333401 
	C862.368591,21.193083 864.055359,20.421982 864.933960,22.642132 
	C865.002380,22.998550 865.000000,23.000000 864.998779,23.000725 
	C863.935303,23.000425 862.872986,22.999399 861.412720,22.997841 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M910.899414,36.752300 
	C909.319275,36.607059 909.032898,35.952744 909.831604,34.926907 
	C910.253113,34.385471 910.902161,34.156582 911.431702,34.666222 
	C912.137451,35.345482 911.835571,36.060467 910.899414,36.752300 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M979.000000,25.999580 
	C979.880981,26.090467 980.930786,25.765575 981.443787,26.793854 
	C981.533875,26.974285 981.110718,27.644096 980.811584,27.741703 
	C979.904114,28.037710 979.383545,27.483662 979.051392,26.330528 
	C979.000000,26.000839 979.000000,26.000000 979.000000,25.999580 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M887.994507,43.659523 
	C887.034241,43.863693 886.093811,43.632977 886.215759,42.384464 
	C886.246948,42.065899 886.764099,41.520695 887.012573,41.544949 
	C888.082764,41.649429 887.862976,42.606373 887.994507,43.659523 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M931.678589,33.495590 
	C931.490906,32.055344 932.264832,32.051266 933.108337,32.347160 
	C933.306213,32.416565 933.538269,32.926670 933.465820,33.132378 
	C933.198425,33.892330 932.558044,33.897331 931.678589,33.495590 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M954.802612,23.212551 
	C955.744751,23.843365 955.677917,24.425720 954.922546,24.715034 
	C954.575867,24.847786 953.814514,24.665342 953.662415,24.391712 
	C953.238586,23.629045 953.785767,23.272934 954.802612,23.212551 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M848.025269,29.318756 
	C849.440552,29.086880 850.031677,29.917263 849.997559,31.646664 
	C848.954529,31.540163 848.229187,30.816528 848.025269,29.318756 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M856.997559,30.996870 
	C857.087524,30.960878 857.180054,30.928085 857.139893,30.950129 
	C857.007324,31.004967 857.000000,31.000069 856.997559,30.996870 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M83.368774,195.122879 
	C83.039131,194.551239 83.039436,194.174240 83.083435,193.517670 
	C83.480003,193.149414 83.832878,193.060776 84.448929,192.908356 
	C85.228355,192.889587 85.744598,192.934631 86.647430,193.007629 
	C89.827629,195.236954 93.303543,195.807053 96.556679,196.809341 
	C98.108116,197.287338 99.357506,197.620865 99.879585,199.671814 
	C99.284187,206.695602 98.551598,213.384567 97.837402,220.518753 
	C98.024879,221.172882 98.193947,221.381775 98.042587,221.835297 
	C97.636635,222.491470 97.551102,222.903015 97.539864,223.625763 
	C96.051071,239.333206 94.487999,254.729431 92.991425,270.569824 
	C91.945549,280.168457 90.795555,289.320038 91.124207,298.865448 
	C92.064484,300.039886 91.448227,300.821686 90.717972,301.729858 
	C90.189079,302.378387 90.092079,302.923492 90.067154,303.739075 
	C89.831879,306.736176 89.524529,309.462799 89.259476,312.586182 
	C89.696770,313.721039 89.842682,314.487946 89.375671,315.656647 
	C87.260803,338.990509 85.339615,361.970886 83.504555,385.401398 
	C82.106018,404.714233 80.461609,423.566345 79.210297,442.444550 
	C78.660278,450.742615 77.668419,458.966644 76.486557,467.175995 
	C76.105934,469.819885 76.342247,470.886353 79.426514,470.228027 
	C82.493332,469.573486 85.687302,469.500732 88.829399,469.215607 
	C96.954903,468.478302 96.874733,468.476776 97.963806,460.390198 
	C98.802200,454.164948 99.877304,447.971558 100.975327,441.384735 
	C102.906212,439.943085 103.432800,441.286285 104.089127,442.925964 
	C104.258423,444.067963 104.209763,444.821259 103.942223,445.903900 
	C102.372108,447.179138 103.787010,448.621490 103.141342,450.037659 
	C102.810905,451.182281 102.453873,451.977051 102.341415,453.167603 
	C102.264961,454.346283 102.195251,455.202545 102.094223,456.376587 
	C101.890518,457.713959 101.621391,458.725098 101.852158,460.077942 
	C102.058762,461.193207 102.071274,462.019104 102.237366,463.132629 
	C104.951271,465.445343 107.728439,463.025635 110.757172,463.665344 
	C111.569511,463.642609 112.035278,463.639038 112.854324,463.636841 
	C114.623825,463.649445 116.040260,463.662628 117.789818,463.884888 
	C119.430504,464.295929 120.750000,464.309906 122.411812,464.178040 
	C123.179947,464.305389 123.582611,464.481995 124.147934,465.005280 
	C124.428551,465.583923 124.477013,465.905548 124.494820,466.231018 
	C124.512642,466.556396 124.560455,466.451599 124.783318,465.611694 
	C125.221786,464.950653 125.564018,464.648773 126.258698,464.230560 
	C129.092255,462.977234 131.708359,463.791077 134.630524,463.677277 
	C135.916016,463.659943 136.848953,463.705475 138.128021,463.680023 
	C138.702774,463.668304 138.931808,463.664581 139.502258,463.655334 
	C140.975021,463.650055 142.088501,463.479065 143.540070,463.262390 
	C145.239685,463.283417 146.600082,463.335480 148.305008,463.068604 
	C151.537735,464.020020 154.436584,462.702087 157.682663,463.252380 
	C159.257462,464.040283 160.065216,465.007874 160.243591,466.778748 
	C158.494400,469.147034 156.250748,469.311920 153.555298,469.040405 
	C152.633820,468.795105 152.176895,468.204285 151.178757,468.541199 
	C150.469315,468.720215 150.050110,468.764771 149.301788,468.769775 
	C148.062363,468.699951 147.261002,469.061310 146.136963,469.498199 
	C145.594940,469.550415 145.377838,469.535553 144.851929,469.436829 
	C143.522949,468.869232 142.519836,469.165649 141.199432,469.458008 
	C140.243057,469.491425 139.603043,469.487549 138.646484,469.458191 
	C137.805023,469.301880 137.293625,468.670380 136.428513,469.445557 
	C134.789215,469.564850 133.467682,469.445953 131.810120,469.471252 
	C130.420013,469.025757 129.342346,468.744476 127.828674,468.968201 
	C121.571320,469.148590 115.678520,469.557983 110.914246,469.492798 
	C117.538513,469.988861 125.328865,468.278900 133.463531,469.512848 
	C134.542801,469.362549 135.111557,470.264496 136.212708,469.653259 
	C139.092087,469.452118 141.611374,469.544769 144.493073,469.857269 
	C151.003448,470.712402 157.047012,469.989471 163.394836,468.593262 
	C164.206955,468.347412 164.684372,468.307922 165.503448,468.469971 
	C167.364563,470.856537 169.078720,471.423706 171.378265,468.949524 
	C172.069824,468.519440 172.511765,468.390259 173.323853,468.413483 
	C174.162109,468.137177 174.214523,469.877380 175.169403,468.520020 
	C176.357193,467.900726 177.307251,467.857025 178.629745,468.036987 
	C179.201981,468.217499 179.419876,468.318542 179.900833,468.662720 
	C179.472076,471.479034 179.173508,473.536194 183.113739,473.217468 
	C185.315369,473.039398 187.586258,473.825470 190.224701,473.644867 
	C192.792694,473.628326 195.002609,473.642303 197.578888,473.651031 
	C198.187317,473.665314 198.429382,473.676788 199.028503,473.725769 
	C199.617508,473.805481 199.849472,473.847656 200.420578,473.970764 
	C201.848663,474.422852 202.944519,474.584167 204.398956,474.068542 
	C207.373337,473.534454 209.982376,472.979675 212.900421,472.058533 
	C213.775208,471.802185 214.289368,471.690369 215.214539,471.561096 
	C220.529129,469.917816 224.916870,467.090332 229.831238,465.495972 
	C232.400650,464.662415 233.198273,462.639130 233.533051,460.135010 
	C234.612747,452.058350 234.736343,443.911621 235.450943,435.809601 
	C235.552811,434.654572 235.397888,433.477478 235.500717,432.321381 
	C235.757629,429.433136 235.266205,424.904419 238.786392,425.056488 
	C242.782013,425.229126 240.403900,429.567139 240.537018,432.048004 
	C240.983017,440.359955 239.909241,448.631378 239.566071,456.924377 
	C239.378799,461.449829 239.564224,461.457520 243.985489,459.884644 
	C249.551605,457.904419 250.576813,456.844391 250.398315,450.768616 
	C249.992661,436.960052 251.862228,423.229370 251.556915,408.989105 
	C252.236526,402.653748 252.501953,396.744751 252.414154,390.814301 
	C252.387466,389.010559 252.425156,387.171478 253.945984,385.307739 
	C254.799484,376.269348 255.303879,367.540405 255.907349,358.402252 
	C256.375824,357.997498 256.745178,358.001984 257.391663,358.005127 
	C259.530304,359.188782 259.496277,361.098602 259.216187,362.858002 
	C258.330322,368.422974 258.848297,374.035889 258.451080,380.055420 
	C258.399445,394.616943 257.545593,408.703796 256.817505,422.796417 
	C256.337738,432.082153 256.475159,441.387329 255.620209,450.669647 
	C255.199707,455.235046 255.959717,455.538666 260.457184,453.759094 
	C268.498505,450.577271 276.690063,447.862854 285.453461,445.696960 
	C286.210632,447.079742 286.550446,448.372589 287.035980,450.043091 
	C286.519257,453.560638 283.644867,453.683075 281.410004,454.401489 
	C259.406036,461.474915 237.925003,469.917694 216.687454,478.996094 
	C199.078506,486.523407 182.231964,495.404938 167.170288,507.388092 
	C166.256500,508.115173 165.218079,508.648590 163.818802,509.313782 
	C162.955536,509.602051 162.444427,509.620941 161.597641,509.314453 
	C160.859772,508.586609 160.452988,508.062347 160.000488,507.193573 
	C159.650726,506.275635 159.837387,505.746704 160.259521,504.984619 
	C160.658173,504.445892 160.912811,504.159271 161.375763,503.670227 
	C161.708054,503.316620 161.843536,503.175568 162.408676,502.614410 
	C162.993042,502.058319 163.147736,501.922333 163.551392,501.591370 
	C163.977661,501.273956 164.154999,501.151581 164.608551,500.852631 
	C167.221451,499.248810 168.951340,497.068939 171.502502,495.366943 
	C171.982529,495.072968 172.185318,494.975800 172.702103,494.761841 
	C173.648773,494.498413 174.342117,494.551605 175.116776,493.859802 
	C176.111359,492.972961 177.093307,492.750488 177.985260,492.207153 
	C177.190903,492.771362 176.045303,492.867523 175.073837,493.887146 
	C174.481628,494.351257 174.083374,494.472015 173.330414,494.501221 
	C171.555725,494.774017 170.061920,494.122589 168.317932,494.822815 
	C166.979401,495.332733 165.951584,495.754883 164.491043,495.796814 
	C163.726761,495.667145 163.323578,495.496948 162.715607,495.034180 
	C161.919449,494.212952 161.471313,493.466003 160.227600,493.261841 
	C158.507278,492.908386 157.157074,492.513763 155.820709,491.259277 
	C155.524902,490.726257 155.456573,490.487183 155.398865,489.874329 
	C159.699112,482.770020 172.646255,477.473083 180.804413,479.077545 
	C184.390320,479.782806 187.782303,481.200714 191.372040,481.880981 
	C177.320557,476.934235 170.632462,477.788116 162.349945,480.273132 
	C155.400467,481.042084 149.086456,479.500610 142.712402,478.458923 
	C131.168900,476.572479 119.522331,477.773651 107.497070,477.439117 
	C103.510765,477.418915 100.148438,478.704224 96.248680,478.986542 
	C94.635742,478.880432 93.424988,478.374329 91.823486,478.954254 
	C88.001167,479.156464 84.701981,480.626373 80.825226,480.285278 
	C78.703896,480.538025 76.954407,480.850555 74.822556,481.321411 
	C76.563232,481.006897 77.898712,480.730164 79.596939,480.521240 
	C80.957382,482.899139 80.987144,482.943176 78.540794,484.596039 
	C74.738136,487.165222 70.937263,489.722534 67.946022,493.744843 
	C66.292786,495.299011 64.837204,496.578064 63.924026,498.719971 
	C63.645164,499.185730 63.524048,499.366577 63.198357,499.802399 
	C62.847847,500.218933 62.701912,500.380493 62.331413,500.777466 
	C61.114613,501.926361 60.721649,503.197571 59.960091,504.641357 
	C59.673763,505.126984 59.546329,505.314850 59.192795,505.761108 
	C58.796284,506.174500 58.625874,506.329529 58.176689,506.690796 
	C56.692280,507.597778 55.556126,508.440613 53.793091,508.743286 
	C52.688633,508.643188 52.094124,508.303772 51.844677,507.261932 
	C52.586143,506.175201 53.225849,505.432617 53.944412,504.402710 
	C65.400215,492.028900 71.660698,477.463013 74.612808,461.337067 
	C75.430649,456.869629 74.678375,452.405609 73.878235,447.555115 
	C73.283920,446.308472 72.686661,445.509338 72.277939,444.179596 
	C72.042152,443.041626 72.088707,442.283936 72.560013,441.217072 
	C73.226624,440.603729 73.719200,440.513947 74.508644,440.908417 
	C74.860191,442.508789 74.950974,443.823212 75.071785,445.532410 
	C75.987366,446.728302 76.161110,447.864136 76.508247,448.918457 
	C76.336830,447.788635 75.962601,446.655273 76.723053,445.239014 
	C77.995407,429.298615 79.111618,413.658112 80.168060,397.637085 
	C80.975624,388.043365 81.938667,378.837952 82.689865,369.615295 
	C84.141556,351.792450 85.473785,333.959900 86.806267,315.678589 
	C86.860191,314.048370 86.963379,312.870880 86.989044,311.344727 
	C85.826431,309.234436 85.664818,307.432129 87.098297,305.361084 
	C88.932770,289.717590 90.341858,274.291351 91.702873,258.394043 
	C93.545639,239.252731 95.368073,220.574982 97.416161,201.921997 
	C97.664886,199.656708 96.918686,198.903152 95.126945,198.413849 
	C91.319626,197.374069 87.508362,196.348770 83.368774,195.122879 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M24.069618,440.711975 
	C23.948906,440.447784 23.996471,440.491516 23.968033,440.506866 
	C25.808580,435.805267 29.973589,436.169739 33.652443,436.697083 
	C44.892292,438.308258 56.168812,437.179840 67.880013,437.632263 
	C71.251968,437.948975 72.793106,439.417633 72.492828,442.918152 
	C72.584862,444.227631 72.851952,445.100342 72.051331,446.208069 
	C70.706810,446.579865 69.710007,446.689148 68.335739,446.779419 
	C63.545109,446.708160 59.119507,447.424927 54.347088,446.302185 
	C45.622391,445.728027 37.270309,445.397949 28.471245,445.151184 
	C25.996658,446.064148 24.926905,445.048798 24.103790,442.891846 
	C23.956871,442.508270 23.979589,442.541138 23.959545,442.539551 
	C24.061979,442.023590 24.646084,441.583405 24.069618,440.711975 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M54.184898,446.336334 
	C58.428986,445.613953 62.873016,445.849335 67.636276,446.512207 
	C63.423817,447.965179 58.902950,447.905640 54.184898,446.336334 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M23.610336,442.672729 
	C27.012270,440.907135 25.036583,445.607361 27.618423,445.171112 
	C26.907106,448.613770 24.876450,445.832001 22.897299,445.867493 
	C22.768267,444.809784 23.016035,443.823456 23.610336,442.672729 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M72.083710,446.480560 
	C71.804016,445.818756 71.904404,445.166901 72.091408,444.195404 
	C72.379784,443.761353 72.581551,443.646973 73.045563,443.761230 
	C74.138474,444.648621 73.963936,445.594910 73.929718,446.803070 
	C73.381653,446.917206 72.922729,446.703857 72.083710,446.480560 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M1019.532471,148.975876 
	C1019.902649,149.441025 1019.932861,149.913025 1019.913330,150.737061 
	C1019.534058,153.069290 1019.241394,155.084564 1016.270630,154.804718 
	C1016.113098,154.904312 1016.079468,155.107147 1016.236877,155.008179 
	C1020.644226,154.277512 1018.783447,157.702972 1019.640137,159.718124 
	C1019.882141,160.150772 1019.905701,160.334457 1019.910645,160.795288 
	C1018.419678,165.619705 1020.071228,170.296753 1019.097168,175.175262 
	C1016.970703,176.587433 1015.091492,176.471100 1013.004761,175.111877 
	C1012.611572,174.575317 1012.505981,174.264725 1012.545166,173.944794 
	C1012.590271,173.576569 1012.702148,173.354721 1012.805359,173.269974 
	C1013.119324,173.858093 1012.953979,173.164612 1012.170166,173.745331 
	C1009.083008,175.299377 1006.770630,177.330368 1004.593384,179.581512 
	C1003.481750,180.730942 1002.143677,182.133026 1000.357361,181.165482 
	C998.624084,180.226700 999.418274,178.639267 999.943115,177.264969 
	C1000.236084,176.497681 999.765564,176.067093 999.057861,175.378113 
	C998.408875,174.567932 998.239868,173.932495 998.410217,172.919189 
	C998.997009,171.925964 999.723938,171.420029 999.953308,170.371399 
	C999.981445,170.188736 999.925049,169.989166 999.930542,170.155396 
	C999.872009,170.792374 999.674194,171.204727 999.186218,171.799698 
	C997.264587,173.588715 995.179321,174.741669 993.494934,176.832916 
	C990.595215,177.856003 992.537842,178.859314 993.279663,180.113312 
	C993.546692,182.595108 992.127075,183.060043 990.528625,182.569504 
	C988.470886,181.938004 986.518860,181.066315 984.284363,181.500504 
	C983.810364,181.592606 983.088135,181.345474 982.989258,180.946075 
	C981.427429,174.635559 976.884705,177.684845 972.941528,177.745209 
	C972.399170,177.579559 972.194092,177.477844 971.752319,177.136932 
	C970.851013,175.809937 970.039856,175.693741 969.083252,176.529205 
	C968.284241,177.227051 968.373901,177.914581 969.086792,178.616348 
	C970.347717,179.857407 971.511963,181.376099 969.990540,182.914429 
	C968.534973,184.386139 966.971619,182.622223 965.446167,182.424789 
	C960.595276,181.796890 957.235657,179.245468 954.826233,175.220535 
	C954.103638,174.013306 953.261047,174.366913 952.264587,174.578461 
	C949.995850,175.060165 947.768616,175.772446 945.374451,175.520203 
	C943.954895,175.370651 943.178040,176.131912 943.427917,177.657715 
	C943.670593,179.138779 944.193237,180.897827 942.147339,181.360489 
	C940.223389,181.795578 938.588501,180.624985 937.227844,179.385986 
	C935.929688,178.204025 936.128052,176.710297 936.919312,175.267105 
	C937.322388,174.531982 937.894348,173.919571 938.472168,173.121429 
	C936.531067,173.543198 934.445679,175.964523 932.898865,173.690247 
	C931.033813,170.948212 933.999817,169.341385 935.822144,166.801575 
	C933.212891,169.269623 931.711609,171.568436 930.469849,174.086151 
	C929.896423,175.248749 929.284119,176.715408 927.580139,176.262802 
	C925.999512,175.842972 925.894226,174.310837 925.813599,173.000122 
	C925.568054,169.007874 925.751465,165.007156 925.699524,161.010300 
	C925.673645,159.016891 925.819092,157.004456 925.012695,154.719284 
	C924.504639,152.049652 924.652771,149.719513 924.695435,146.995392 
	C924.828064,145.781693 925.099060,145.031509 926.323486,144.211121 
	C926.211243,149.105988 928.927612,153.139313 930.743896,157.589508 
	C932.683777,156.413177 929.616150,153.777328 932.666016,153.052277 
	C933.000305,152.998779 933.146423,153.211670 933.073120,153.106216 
	C933.297546,150.930588 930.097290,150.886841 930.503479,148.676498 
	C932.229309,147.746368 932.902405,150.038757 934.665405,149.960159 
	C935.435547,150.426224 935.855469,150.888672 936.525146,150.902893 
	C936.685181,150.906281 936.789612,150.774323 936.775085,150.764633 
	C936.382019,150.503601 935.898804,150.580765 935.236572,150.213715 
	C934.855835,146.889786 936.702271,145.210236 939.649048,144.037415 
	C939.950073,145.617722 940.129089,147.041779 942.871460,147.252350 
	C943.921448,148.304916 942.930115,150.704605 945.742188,149.231857 
	C946.300293,149.308594 946.515991,149.372681 947.012207,149.616531 
	C947.919800,150.371521 948.238831,151.218002 949.229736,151.869141 
	C949.656250,152.156906 949.823364,152.276901 950.224976,152.596130 
	C950.898865,153.220383 951.309937,153.673141 951.954651,154.329224 
	C952.283203,154.727112 952.399414,154.900787 952.622925,155.372818 
	C952.788086,156.062653 952.794189,156.454132 952.655762,157.102753 
	C952.610046,157.539291 952.639099,157.718719 952.854004,157.685181 
	C955.368713,157.525726 956.315186,159.815384 958.212341,160.598419 
	C956.761353,159.438232 955.019592,158.451141 955.645081,155.585938 
	C961.660950,150.959152 966.711060,146.217621 971.686707,141.377777 
	C972.510620,140.576447 973.191101,138.708786 974.840698,139.725098 
	C976.351135,140.655670 974.994141,141.517776 974.546936,142.545258 
	C973.243530,145.539764 977.169373,145.406052 977.856384,147.694000 
	C977.713501,148.375885 977.452759,148.768845 976.908325,149.343674 
	C975.280884,149.771973 974.416931,148.925613 973.496399,148.232346 
	C971.395508,146.650055 970.676819,148.192902 969.930115,149.949051 
	C972.296631,148.751984 974.648193,149.640320 977.193726,149.419556 
	C977.472778,148.954041 977.545532,148.746155 977.806641,148.266968 
	C979.064087,148.000397 980.133118,148.005127 981.599121,148.003082 
	C982.097168,149.110992 981.525818,150.620361 982.570251,151.226654 
	C983.976135,152.042755 984.220337,150.101303 985.114868,149.569275 
	C986.510376,148.739304 987.902832,147.904144 989.945801,147.115295 
	C991.140686,147.441254 991.677063,147.738968 992.590088,148.540482 
	C992.995300,150.064240 992.995422,151.133118 993.000000,152.602814 
	C991.937927,154.025909 991.436523,155.770950 989.300903,155.702209 
	C989.071167,155.684677 988.779785,155.506882 988.779785,155.506882 
	C988.779785,155.506882 988.509216,155.705948 988.677307,155.798798 
	C989.832825,156.656082 990.650085,157.994644 992.251099,156.608124 
	C992.289490,156.140106 992.270203,155.947983 992.211182,155.462357 
	C992.133911,154.552109 992.234375,153.967453 992.784912,153.217331 
	C993.747559,152.993576 994.499634,152.991058 995.627686,152.992294 
	C996.963928,153.917343 997.992188,154.770996 999.060547,156.060638 
	C999.735657,156.884247 999.787292,157.529510 999.412170,158.492279 
	C998.879089,159.109985 998.509216,159.441620 998.237549,159.846527 
	C998.022034,160.167847 997.605042,160.354736 997.582458,160.805191 
	C997.856079,160.399109 998.142944,160.002747 998.662964,159.373795 
	C999.718872,158.324997 1000.398254,157.495331 999.127441,156.124191 
	C998.161499,155.013046 997.397888,154.174866 996.244019,153.241043 
	C997.222778,147.994965 999.333374,150.393814 1001.375610,152.370529 
	C1002.227478,153.195221 1002.190186,155.506668 1003.984863,154.637329 
	C1005.680420,153.815994 1003.299133,152.396805 1003.636047,151.865509 
	C1005.243286,149.330566 1005.641357,147.016266 1003.491333,144.643890 
	C1004.095215,144.429352 1004.699158,144.214798 1005.899658,144.026154 
	C1006.663330,144.066269 1006.830444,144.080490 1007.498779,144.047363 
	C1014.390625,144.601440 1009.281250,147.408905 1009.008362,149.645111 
	C1008.578247,150.569397 1007.765015,150.819702 1007.795898,151.780090 
	C1007.927979,151.911179 1008.283936,151.840546 1008.273071,151.617401 
	C1008.304993,151.047531 1008.425598,150.727661 1008.797119,150.211212 
	C1012.371887,149.417801 1015.464294,146.005920 1019.532471,148.975876 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M885.101685,131.151154 
	C886.827515,126.568329 889.720337,125.125420 894.454163,127.132866 
	C901.953796,130.313232 909.633789,133.068207 917.596985,136.104218 
	C918.431030,136.487488 918.905518,136.769699 919.661377,137.092468 
	C920.176208,137.003555 920.409790,136.874084 920.770691,137.124451 
	C921.385254,137.704742 921.872498,137.905182 922.624268,138.143112 
	C924.933777,137.966965 926.526062,138.710922 927.689331,140.781982 
	C927.723511,141.129547 927.764404,141.462524 927.793152,141.627792 
	C927.673096,141.994537 927.524292,142.196030 927.032593,142.550842 
	C917.861084,140.340454 909.543823,136.560532 901.004150,133.398529 
	C898.512207,132.475830 896.026184,131.514923 893.599121,130.421906 
	C891.423767,129.442307 889.430359,129.663132 887.256348,131.372803 
	C886.387390,131.609619 885.884216,131.576126 885.101685,131.151154 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M943.006714,110.993698 
	C944.081299,110.989731 945.147949,110.993355 946.613037,110.988571 
	C946.321838,113.234016 948.684326,113.770393 949.578430,115.070633 
	C947.524292,117.252960 946.290649,114.524101 944.279846,114.538162 
	C944.705688,117.395134 947.155090,118.446838 948.770874,120.045708 
	C949.497070,120.764397 949.847839,121.308502 949.176636,122.028183 
	C948.776245,122.457397 947.596558,122.889603 947.539734,122.804512 
	C944.797791,118.698677 943.939270,123.248482 942.252197,123.899765 
	C941.814209,124.068848 941.273132,123.970711 940.388428,123.997040 
	C939.997498,123.248856 939.997437,122.498932 939.998657,121.374962 
	C942.941345,120.104088 944.841492,119.023109 940.868408,116.698135 
	C939.940369,116.155083 940.436646,115.333641 940.865234,114.310059 
	C940.991333,114.006157 941.000671,113.999359 941.003906,113.995850 
	C941.880615,113.361671 941.952881,112.239952 942.775452,111.232117 
	C942.985352,111.014839 942.998840,111.001274 943.006714,110.993698 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M972.188721,124.825668 
	C971.981323,125.044144 971.986694,125.526543 971.992126,125.767700 
	C971.301880,126.603989 970.523682,126.755119 969.328918,126.185768 
	C968.998352,125.928314 968.999695,125.457764 968.995728,125.222519 
	C968.419678,124.308243 968.267090,123.542816 968.745483,122.349976 
	C969.138733,122.007233 969.306091,122.008469 969.724487,122.011078 
	C971.374023,121.036064 970.386841,119.685425 970.721191,118.261597 
	C971.428162,118.265594 971.938660,118.519302 972.710022,118.890991 
	C974.914795,118.643585 975.600525,121.097168 977.741333,121.007202 
	C978.540588,120.749397 979.024353,120.481796 979.767822,120.119331 
	C981.272034,121.672791 980.104065,123.011322 979.195190,124.709717 
	C978.632751,125.102371 978.393188,125.277534 978.104980,125.727600 
	C977.633911,126.346481 977.174255,126.516449 976.304321,126.215195 
	C975.676697,125.890182 975.424500,125.708405 975.121582,125.237389 
	C974.257690,124.161156 973.411987,123.854103 972.188721,124.825668 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M949.647949,150.578827 
	C951.116760,149.422058 954.047485,152.905350 953.505981,148.198273 
	C953.294861,146.362640 955.273682,147.737930 956.090271,148.135864 
	C957.531189,148.838104 958.776733,150.085114 957.225037,151.565826 
	C956.307495,152.441376 954.647400,152.562805 955.869080,154.696243 
	C955.997559,155.002441 956.000000,155.000000 956.001221,154.998779 
	C955.009033,155.817108 953.926758,156.056152 952.360107,155.248215 
	C951.997559,154.996948 952.000000,155.000000 952.001221,155.001526 
	C951.468445,154.467407 950.939087,153.927155 950.198303,153.197205 
	C949.997559,152.996841 950.000000,153.000000 950.001221,153.001465 
	C949.464050,152.502335 949.238586,151.882675 949.647949,150.578827 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M943.001648,147.001831 
	C943.169556,145.785950 942.936401,143.585358 944.774353,144.384598 
	C946.857849,145.290588 948.336487,146.867661 949.606323,143.630905 
	C949.857971,142.989532 950.868591,143.066879 951.306458,143.580597 
	C951.681763,144.020889 951.877686,144.764282 951.856384,145.363083 
	C951.802124,146.887558 949.723633,147.506577 950.004761,149.622589 
	C949.996948,150.003418 950.000000,150.000000 950.001587,149.998291 
	C949.318237,150.577209 948.545593,150.729263 947.345581,150.236191 
	C947.002441,150.001831 947.000000,150.000000 946.998779,149.999084 
	C946.120300,148.722595 944.523376,148.442017 943.224609,147.215179 
	C942.996704,146.996353 943.000000,147.000000 943.001648,147.001831 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M990.001221,147.001450 
	C990.857178,145.815964 989.860046,140.801315 993.507385,145.352219 
	C994.322388,146.369064 995.589050,146.153381 996.617859,145.371292 
	C998.649353,143.827103 999.726074,146.327011 1001.353333,146.517685 
	C1001.436829,146.527481 1001.517578,147.374283 1001.418274,147.787903 
	C1001.368896,147.993851 1000.714478,148.283234 1000.661560,148.226974 
	C998.000122,145.393326 996.041870,148.765732 993.368835,148.992996 
	C992.995117,148.995361 993.000000,149.000381 993.002441,149.002502 
	C992.367981,148.120926 991.233093,148.046219 990.216614,147.210358 
	C989.997559,146.997360 990.000000,147.000000 990.001221,147.001450 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M968.603516,122.002029 
	C968.977051,122.751427 968.982788,123.496864 968.990173,124.614792 
	C967.415710,125.920578 965.550842,122.832344 964.046570,125.666779 
	C957.450195,125.446617 964.123962,122.339851 962.994873,120.372116 
	C965.261475,119.313271 966.182129,122.140625 968.603516,122.002029 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M928.057739,141.074188 
	C926.264343,140.293854 924.805115,139.458160 923.117310,138.401550 
	C924.403870,136.649689 925.935425,135.146545 928.637146,135.005981 
	C928.304993,136.173813 928.529236,137.109207 929.524963,138.068924 
	C931.341248,139.819473 930.181641,140.574387 928.057739,141.074188 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M979.282227,124.955154 
	C979.268494,123.585388 979.610168,122.168938 979.989746,120.388481 
	C980.027649,120.024467 980.005737,120.013733 980.012817,120.020050 
	C980.913208,119.198677 981.634338,118.215042 982.724792,117.171158 
	C984.611023,116.918465 986.014404,117.118469 985.980957,119.620102 
	C985.756470,121.019814 985.149414,121.821419 984.231567,122.781624 
	C982.060791,122.485420 981.090210,124.251579 979.282227,124.955154 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M930.680054,127.024780 
	C930.592957,129.948914 928.253906,131.181717 926.297302,132.793228 
	C924.694336,131.428894 926.430298,131.054672 926.599548,130.304855 
	C927.064148,128.245621 928.792419,126.724411 930.680054,127.024780 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M966.375610,108.030777 
	C966.717651,105.343750 963.452332,104.817299 963.043945,102.351883 
	C965.386414,101.867889 966.199829,104.578323 968.659790,104.967636 
	C969.031311,106.589043 968.859131,108.029236 966.375610,108.030777 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1004.664490,117.037704 
	C1004.980042,118.185410 1005.195190,119.177643 1006.085815,120.155533 
	C1007.699890,121.927681 1006.687805,122.751884 1004.364380,122.983276 
	C1005.502563,121.102356 999.574402,118.799889 1004.664490,117.037704 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M962.406128,138.476471 
	C964.556274,139.509384 966.665955,140.542175 965.163269,143.510910 
	C965.192505,141.154861 960.402588,142.089600 962.406128,138.476471 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M984.262268,122.996956 
	C984.061340,121.861389 983.699036,120.547707 985.637634,120.034332 
	C985.987793,119.991783 986.433105,120.006248 986.655884,120.006714 
	C987.091125,120.952423 987.547180,121.637764 988.806213,121.905258 
	C988.988586,123.181526 988.997498,124.204224 989.004272,125.610451 
	C988.831665,126.110962 988.661011,126.227936 988.235474,126.168106 
	C987.980469,125.991302 987.504700,125.993706 987.266846,125.998230 
	C986.202026,125.335869 985.724365,124.439400 985.170349,123.227356 
	C984.978516,122.987709 984.500977,122.991722 984.262268,122.996956 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M996.000977,116.999054 
	C997.794678,117.122414 998.393250,114.673775 1000.643494,115.006409 
	C1001.099548,116.785843 998.691589,117.405693 999.007568,119.643265 
	C998.255066,119.989395 997.505066,119.984177 996.374634,119.986694 
	C995.998413,119.246246 996.002563,118.498070 996.002441,117.375824 
	C995.998047,117.001770 996.000000,117.000000 996.000977,116.999054 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M953.347473,137.601837 
	C951.814636,138.113144 950.978027,140.651138 949.441833,139.096420 
	C948.369568,138.011292 949.990967,137.131302 950.764709,136.352768 
	C952.389832,134.717606 953.315674,135.109253 953.347473,137.601837 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M953.533325,113.412415 
	C955.137756,112.674896 956.230774,112.335304 957.674622,111.998306 
	C957.239075,114.213959 954.926147,115.073486 953.345581,116.944328 
	C953.007263,115.936577 953.014587,114.873451 953.533325,113.412415 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M940.001221,124.000732 
	C940.080261,126.913979 938.235229,128.032486 935.857971,128.675873 
	C936.216736,126.489792 937.233521,124.861794 939.653198,124.036110 
	C939.997559,123.998779 940.000000,124.000000 940.001221,124.000732 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M950.233459,132.425018 
	C950.443359,132.938202 950.503357,133.425613 950.332886,133.527496 
	C949.133057,134.244614 948.397888,135.940872 946.607422,135.404297 
	C946.401001,135.342422 946.154053,134.823151 946.208191,134.578415 
	C946.658203,132.543884 948.229797,132.226791 950.233459,132.425018 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M950.958618,109.351166 
	C952.532837,108.985764 954.016785,109.050491 953.972534,111.562500 
	C953.808044,112.201469 953.608948,112.447784 953.199768,112.826309 
	C953.022156,112.984779 953.004578,112.997498 952.996338,113.005463 
	C950.060059,113.301590 950.003662,111.805313 950.958618,109.351166 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M959.365479,147.413727 
	C959.650757,145.576080 960.460999,144.445190 962.201782,144.472214 
	C962.420410,144.475601 962.910400,145.358566 962.793091,145.594879 
	C962.132202,146.926163 961.580322,148.596771 959.365479,147.413727 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M970.715210,117.892647 
	C970.466919,119.294250 973.128052,120.806824 970.301392,121.974991 
	C969.974792,120.735550 969.830688,119.775063 968.463623,118.907822 
	C966.172668,117.454552 968.065491,117.242195 969.653564,117.004906 
	C970.093689,117.306274 970.265442,117.564941 970.715210,117.892647 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M943.963318,137.071777 
	C944.992310,138.329041 945.378784,139.509613 943.559448,139.557755 
	C942.551147,139.584427 941.132568,138.917175 941.235535,137.571533 
	C941.382019,135.657852 942.651611,136.410675 943.963318,137.071777 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M977.864014,120.742790 
	C975.552490,123.486023 974.935547,120.040611 973.177124,119.267303 
	C975.477417,116.469231 976.098450,120.001221 977.864014,120.742790 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M982.001892,148.001953 
	C981.718140,145.930756 982.755432,144.911469 984.711914,144.742737 
	C985.056335,144.713013 985.754150,145.115128 985.753479,145.316101 
	C985.747070,147.312180 984.005310,147.381134 982.347656,147.962936 
	C981.996155,147.996292 982.000000,148.000000 982.001892,148.001953 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M982.992859,117.007736 
	C983.038025,118.602715 982.839294,120.004066 980.386719,120.007812 
	C979.888184,118.823334 979.756531,117.620300 979.820679,116.202644 
	C981.006653,115.426926 981.734619,116.061996 982.743530,116.771927 
	C982.988342,117.011818 982.998962,117.001747 982.992859,117.007736 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M918.719727,121.549751 
	C918.742371,119.729530 919.809204,118.939301 921.784851,118.285576 
	C921.340698,120.252350 921.366089,121.908859 918.719727,121.549751 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M931.630798,132.008820 
	C932.025818,133.585220 931.863037,135.027039 929.371948,134.990234 
	C929.002441,135.002106 929.000000,135.000000 928.998779,134.998962 
	C928.966736,133.409821 929.144470,131.979614 931.630798,132.008820 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M931.012451,117.367691 
	C931.757324,116.995361 932.504883,117.001190 933.626221,117.004089 
	C934.000000,117.001167 934.000000,117.000000 934.000000,116.999390 
	C933.874451,118.019371 934.282593,119.370583 932.858826,119.715759 
	C931.304993,120.092468 931.124390,118.883156 931.012451,117.367691 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M942.594849,130.592911 
	C943.929199,130.082291 944.735596,130.329620 944.758362,131.601151 
	C944.770996,132.302322 944.257629,132.789001 943.565674,132.764130 
	C942.305908,132.718857 942.043945,131.924698 942.594849,130.592911 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M921.011353,128.368317 
	C922.040039,128.145737 923.351013,127.736885 923.753418,129.231064 
	C923.938721,129.919159 923.647095,130.539474 922.942932,130.700790 
	C921.314575,131.073853 921.127319,129.920868 921.011353,128.368317 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1015.998779,102.001511 
	C1017.053772,102.115509 1018.349548,101.739639 1018.764221,103.229172 
	C1018.957458,103.923210 1018.657837,104.541748 1017.952332,104.701645 
	C1016.327209,105.069962 1016.114014,103.934464 1016.010681,102.365997 
	C1016.002441,101.996986 1016.000000,102.000000 1015.998779,102.001511 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M930.992310,123.631332 
	C929.958130,123.864708 928.653931,124.258163 928.251343,122.765709 
	C928.065369,122.076401 928.362061,121.458641 929.067688,121.298714 
	C930.698669,120.929047 930.884399,122.078697 930.992310,123.631332 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M940.000000,120.999542 
	C938.959167,120.852615 937.646912,121.253990 937.251221,119.753853 
	C937.069458,119.064789 937.359131,118.443642 938.069458,118.286285 
	C939.702271,117.924568 939.883911,119.077446 939.990601,120.631622 
	C940.000000,121.000916 940.000000,121.000000 940.000000,120.999542 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M931.367859,126.990601 
	C930.999329,126.249710 930.998718,125.499420 931.000000,124.373955 
	C931.002014,123.998779 931.000000,124.000000 930.999023,124.000610 
	C932.020081,124.120705 933.371521,123.715134 933.711914,125.140724 
	C934.081726,126.689445 932.875793,126.876122 931.367859,126.990601 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1013.000000,108.999847 
	C1013.155640,107.823593 1012.686096,106.228722 1014.685425,106.246170 
	C1015.033203,106.249207 1015.599182,106.709106 1015.684021,107.052078 
	C1016.088135,108.686089 1014.918823,108.862648 1013.367859,108.982681 
	C1013.000000,109.000305 1013.000000,109.000000 1013.000000,108.999847 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M982.951233,116.690010 
	C982.191528,116.756691 981.394714,116.501572 980.307251,116.117233 
	C979.846741,115.238190 979.676941,114.488365 979.507202,113.738556 
	C981.589233,113.388924 982.047119,115.143570 982.951233,116.690010 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M909.000000,113.999451 
	C909.043274,115.596230 908.864380,117.025505 906.370789,116.992416 
	C906.000000,117.000610 906.000000,117.000000 906.000000,116.999695 
	C904.991089,114.694778 906.317261,113.924286 908.630127,113.780045 
	C909.000000,114.001030 909.000000,114.000000 909.000000,113.999451 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M992.998779,116.998993 
	C992.817261,118.676285 991.838562,119.226212 990.308960,118.764809 
	C990.010559,118.674767 989.590027,117.922523 989.691772,117.748878 
	C990.278931,116.747330 991.352905,117.062920 992.639465,116.993027 
	C993.002441,117.002136 993.000000,117.000000 992.998779,116.998993 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M920.650879,126.006554 
	C921.014771,126.456329 921.008667,126.896469 921.002441,127.666702 
	C921.002441,127.996780 921.000000,128.000000 920.998779,128.002090 
	C920.053223,128.205780 918.834839,129.552521 918.267883,127.847824 
	C917.781616,126.386086 919.083801,126.062363 920.650879,126.006554 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M984.857666,123.292557 
	C986.441956,123.062508 987.042969,123.894951 987.015564,125.646988 
	C985.589294,125.844833 983.500732,126.305237 984.857666,123.292557 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M996.002808,120.003021 
	C995.934814,121.541260 995.261963,122.596870 993.339294,122.963272 
	C993.035400,121.442085 993.717102,120.397011 995.654663,120.036301 
	C995.994202,119.994431 996.000000,120.000000 996.002808,120.003021 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M973.298645,131.481140 
	C972.485229,130.777145 971.880859,130.103180 972.809021,129.496078 
	C973.082764,129.317001 974.032654,129.719437 974.321960,130.113113 
	C974.880798,130.873779 974.680298,131.549652 973.298645,131.481140 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M956.209717,144.202972 
	C957.231262,144.260269 957.771301,144.624725 957.349976,145.384598 
	C957.197388,145.659668 956.437012,145.846237 956.090515,145.714417 
	C955.328552,145.424713 955.276245,144.839478 956.209717,144.202972 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M947.514160,142.331207 
	C946.064758,142.516800 946.056274,141.736008 946.350464,140.884186 
	C946.418884,140.686020 946.934875,140.452652 947.141907,140.526016 
	C947.905457,140.796707 947.915710,141.442902 947.514160,142.331207 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M939.993530,143.993423 
	C940.081848,143.105148 939.752869,142.048874 940.793945,141.543930 
	C940.979614,141.453873 941.647339,141.879501 941.747559,142.181458 
	C942.049072,143.090607 941.492432,143.613647 940.341431,143.956665 
	C940.012207,144.011810 939.999878,143.999725 939.993530,143.993423 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M1005.997559,143.997955 
	C1006.104431,143.098984 1005.650879,141.798691 1006.905090,141.575439 
	C1008.048950,141.371811 1007.836304,142.584198 1007.995483,143.656494 
	C1007.615601,144.378128 1007.157043,144.525040 1006.314697,144.222488 
	C1006.004883,144.004181 1006.000000,144.000336 1005.997559,143.997955 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M979.495300,142.681656 
	C980.938660,142.495773 980.951111,143.269867 980.653381,144.119522 
	C980.583984,144.317444 980.070557,144.548340 979.862793,144.475372 
	C979.100281,144.207550 979.090149,143.565414 979.495300,142.681656 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M930.995117,117.005188 
	C930.106812,116.919319 929.049805,117.246391 928.549072,116.198677 
	C928.459839,116.011841 928.887695,115.346954 929.190491,115.246986 
	C930.101135,114.946266 930.623535,115.502449 930.958252,116.658813 
	C931.009766,116.989525 931.000000,117.000000 930.995117,117.005188 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M922.054443,115.329910 
	C922.884033,115.092865 923.940186,114.755043 924.457703,115.789772 
	C924.548950,115.972343 924.126648,116.647415 923.826782,116.746025 
	C922.913574,117.046364 922.394592,116.482628 922.054443,115.329910 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M915.011475,122.988335 
	C915.898743,123.082626 916.954956,122.760437 917.446472,123.803474 
	C917.534912,123.991196 917.109070,124.650406 916.807861,124.749611 
	C915.904663,125.047142 915.382141,124.493851 915.034424,123.351357 
	C914.977539,123.023605 915.000000,122.999969 915.011475,122.988335 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M972.360474,125.041061 
	C972.477966,122.780945 973.406555,122.328964 974.968384,124.685005 
	C974.255615,125.030945 973.497559,125.034462 972.360474,125.041061 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1003.997559,122.997375 
	C1003.882690,123.985550 1003.655273,124.934944 1002.378906,124.804642 
	C1002.054077,124.771461 1001.502869,124.248199 1001.525269,123.991066 
	C1001.620422,122.899986 1002.587219,123.110497 1003.660278,122.999596 
	C1004.004883,123.005318 1004.000000,123.000000 1003.997559,122.997375 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M925.675354,119.506073 
	C925.489868,118.062454 926.261475,118.043053 927.115479,118.345734 
	C927.314575,118.416275 927.546204,118.929726 927.473145,119.137672 
	C927.204834,119.901726 926.562134,119.913727 925.675354,119.506073 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M953.000000,117.000153 
	C952.853760,117.975533 952.614380,118.925865 951.354431,118.804733 
	C951.034851,118.774017 950.485291,118.251450 950.511719,118.005432 
	C950.626709,116.935524 951.587646,117.135071 952.656494,117.003265 
	C953.000000,116.999695 953.000000,117.000000 953.000000,117.000153 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M926.338928,108.971466 
	C926.123291,108.075462 925.655090,106.780655 926.915833,106.565239 
	C928.048889,106.371651 927.854126,107.559090 927.992188,108.634315 
	C927.555237,108.977142 927.112854,108.979073 926.338928,108.971466 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M963.355164,111.025391 
	C963.055359,109.561806 963.884338,108.963089 965.639771,109.006744 
	C965.926025,110.463600 965.085388,111.044754 963.355164,111.025391 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M966.024475,128.312988 
	C967.287170,128.053955 968.068176,128.710953 968.240234,129.992294 
	C968.264648,130.173996 967.921204,130.592926 967.778076,130.579559 
	C966.620483,130.471481 966.297058,129.570160 966.024475,128.312988 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M969.038391,126.271851 
	C969.748230,125.947113 970.498047,125.965919 971.622742,125.996788 
	C971.442627,128.223343 970.517212,128.654739 969.038391,126.271851 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M972.697144,113.512245 
	C972.511902,112.057739 973.288574,112.039909 974.147827,112.346039 
	C974.347778,112.417267 974.579407,112.934525 974.505432,113.143448 
	C974.233887,113.910149 973.589417,113.928177 972.697144,113.512245 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M993.000000,123.000381 
	C992.870789,123.973457 992.693909,124.930443 991.399231,124.867470 
	C991.156372,124.855652 990.715027,124.554016 990.725281,124.412094 
	C990.796082,123.429520 991.598694,123.240326 992.685791,123.024704 
	C993.000000,122.999374 993.000000,123.000000 993.000000,123.000381 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M931.998169,131.998169 
	C932.109314,131.172318 932.230530,130.271423 933.337402,130.392090 
	C933.674011,130.428772 933.950500,131.016922 934.254517,131.352493 
	C933.709351,131.569122 933.164246,131.785751 932.312012,132.003021 
	C932.004883,132.003662 932.000000,132.000000 931.998169,131.998169 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M988.960693,121.806702 
	C988.141357,121.748497 986.310303,122.734970 986.803101,120.282654 
	C987.883728,120.037369 988.732178,120.290649 988.960693,121.806702 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M998.997314,120.002510 
	C999.507263,120.244949 1000.032227,120.464516 1000.514160,120.755478 
	C1000.563904,120.785515 1000.412903,121.420670 1000.259521,121.468483 
	C999.512085,121.701424 999.241516,121.178635 999.042236,120.281685 
	C999.005005,119.994614 999.000000,120.000000 998.997314,120.002510 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M991.602478,129.067932 
	C991.195801,129.809250 990.783142,129.820724 990.415649,129.295670 
	C990.339600,129.187057 990.346497,128.928131 990.425842,128.818604 
	C990.801575,128.300064 991.212036,128.314713 991.602478,129.067932 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M949.064941,107.354401 
	C949.938477,107.100899 950.711609,107.343765 950.960327,108.693451 
	C950.099243,108.940079 949.294373,108.735565 949.064941,107.354401 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1000.998779,114.998627 
	C1001.077637,114.356155 1001.050781,113.619354 1001.888794,113.472511 
	C1002.067078,113.441261 1002.314514,113.804482 1002.530090,113.985992 
	C1002.210938,114.301498 1001.891785,114.616997 1001.287598,114.967476 
	C1001.002441,115.002449 1001.000000,115.000000 1000.998779,114.998627 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M957.058594,118.374191 
	C957.354309,118.738487 957.393982,119.102158 957.433716,119.465828 
	C957.173889,119.463905 956.914062,119.461983 956.654236,119.460052 
	C956.703674,119.097893 956.753113,118.735725 957.058594,118.374191 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M961.008789,112.306396 
	C961.424072,111.994598 961.878601,111.987556 962.673889,111.971443 
	C962.782471,112.495819 962.688904,113.285286 962.285950,113.503555 
	C961.660034,113.842621 961.230713,113.249496 961.008789,112.306396 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M963.997070,126.002731 
	C964.889709,126.096405 965.682800,126.330803 965.948730,127.686554 
	C965.995422,128.004623 966.000000,128.000000 966.002441,127.997734 
	C965.092285,127.928383 964.318665,127.666725 964.051147,126.313339 
	C964.005432,125.994133 964.000000,126.000000 963.997070,126.002731 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1020.591309,106.532837 
	C1021.396423,106.306351 1021.688416,106.589600 1021.567139,107.214226 
	C1021.541931,107.344093 1021.357910,107.519363 1021.226562,107.539490 
	C1020.592163,107.636742 1020.333618,107.322533 1020.591309,106.532837 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M976.024170,126.296982 
	C976.434021,125.981621 976.882080,125.970581 977.665894,125.943695 
	C977.777466,126.466484 977.696228,127.261566 977.296204,127.484573 
	C976.673340,127.831703 976.240479,127.243629 976.024170,126.296982 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M963.000000,119.999695 
	C962.367126,119.905243 961.644958,119.901711 961.515320,119.078217 
	C961.487976,118.904541 961.852417,118.669189 962.036255,118.462234 
	C962.335815,118.785576 962.635437,119.108932 962.967529,119.716454 
	C963.000000,120.000610 963.000000,120.000000 963.000000,119.999695 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M947.335815,106.040863 
	C947.056091,105.121346 947.296265,104.323463 948.675903,104.042862 
	C948.997131,104.432709 948.996765,104.868011 948.992493,105.628906 
	C948.547974,105.980499 948.107422,106.006485 947.335815,106.040863 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M970.001221,117.001373 
	C970.083496,116.358284 970.085449,115.632751 970.916016,115.492203 
	C971.091125,115.462570 971.332886,115.826653 971.544006,116.009308 
	C971.219299,116.317238 970.894592,116.625191 970.283691,116.965271 
	C969.997559,116.997406 970.000000,117.000000 970.001221,117.001373 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M923.610229,121.537292 
	C924.412598,121.308609 924.703247,121.587532 924.577881,122.211395 
	C924.551758,122.341263 924.370178,122.515762 924.239563,122.535934 
	C923.609375,122.633278 923.348022,122.326126 923.610229,121.537292 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1004.998169,116.998108 
	C1005.060791,116.079567 1005.331238,115.310997 1006.685547,115.048492 
	C1007.005554,115.005470 1007.000000,115.000000 1006.997314,114.997070 
	C1006.924316,115.901779 1006.694031,116.697395 1005.325439,116.962051 
	C1005.004883,117.003525 1005.000000,117.000000 1004.998169,116.998108 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M960.478882,115.597374 
	C960.417297,116.077080 960.177551,116.369263 959.937805,116.661453 
	C959.754578,116.471443 959.571350,116.281418 959.388123,116.091385 
	C959.692322,115.864204 959.996460,115.637024 960.478882,115.597374 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M959.270020,111.044876 
	C958.483704,110.659966 957.941956,110.081573 958.667786,109.578606 
	C959.378479,109.086113 959.753296,109.771446 959.968262,110.718094 
	C960.000000,111.004776 959.513062,111.025986 959.270020,111.044876 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M959.388733,142.464203 
	C958.580383,142.696121 958.296570,142.407700 958.416992,141.786316 
	C958.442139,141.656570 958.625671,141.480942 958.756531,141.461212 
	C959.386719,141.366196 959.652771,141.671280 959.388733,142.464203 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M912.001221,125.998932 
	C912.450928,126.151711 912.899414,126.305565 913.347900,126.459412 
	C913.217590,126.738152 913.155457,127.175644 912.944397,127.266357 
	C912.267151,127.557335 912.134766,127.013359 912.014465,126.256027 
	C911.997559,126.002220 912.000000,126.000000 912.001221,125.998932 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M926.536499,142.487213 
	C926.899963,142.126099 927.077820,142.041153 927.538757,141.874634 
	C928.012146,142.549347 929.152527,143.404846 927.323181,144.015778 
	C926.922852,143.947739 926.792969,143.842392 926.467041,143.580536 
	C926.297668,143.203781 926.324280,142.983566 926.536499,142.487213 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M947.007568,110.993469 
	C947.134766,110.564987 947.254272,110.142639 947.373718,109.720291 
	C948.071655,110.032928 947.689575,110.389946 947.213623,110.861343 
	C947.011536,110.980179 946.999939,110.999603 947.007568,110.993469 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M988.071045,126.165222 
	C988.150757,125.991432 988.321045,125.991570 988.746826,125.992844 
	C988.823608,126.356316 988.651001,126.733299 988.071045,126.165222 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M920.991577,125.988876 
	C921.083496,125.951057 921.183777,125.923759 921.152466,125.956329 
	C921.020935,126.016182 921.000000,125.999413 920.991577,125.988876 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M920.875671,137.271271 
	C920.736877,137.447372 920.575867,137.390427 920.178711,137.233246 
	C920.211487,136.767380 920.465942,136.263748 920.875671,137.271271 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M119.801483,542.903687 
	C123.264656,545.064758 123.885246,547.204407 120.631531,549.929749 
	C118.111488,552.040527 116.521416,554.668640 115.266296,557.905457 
	C113.814751,561.648865 112.918053,566.168518 108.504181,568.270325 
	C105.414406,569.741699 106.755684,574.265930 103.318451,575.962402 
	C100.775360,576.334167 100.895470,573.216064 98.558983,573.211060 
	C96.991776,572.832947 95.767731,572.818054 94.339264,573.647339 
	C92.281128,574.700989 92.900459,575.603638 94.271637,576.792786 
	C94.683754,577.535400 94.788803,578.016113 94.790359,578.904419 
	C94.625481,579.818604 94.433334,580.317566 93.976349,581.150940 
	C92.419975,583.720032 92.151596,586.271912 92.188301,588.695496 
	C92.248428,592.665283 90.569199,594.054504 86.787361,593.517151 
	C85.489799,593.332825 84.143990,593.487793 82.394562,593.488037 
	C79.680984,593.486145 77.392883,593.470642 75.105209,593.490723 
	C72.833702,593.510681 71.321320,592.642334 71.042358,589.822388 
	C71.012863,588.974426 71.005104,588.510864 71.002853,588.047241 
	C71.000595,587.583862 70.988770,587.120422 71.003906,586.657043 
	C70.860596,587.084167 71.047966,587.515198 70.990387,588.314331 
	C71.395195,592.033203 70.287285,593.313904 66.580933,593.156250 
	C63.165630,593.010925 59.675346,593.181702 56.222046,593.281189 
	C48.823734,593.494141 48.826553,593.592041 48.586739,586.259766 
	C48.553963,584.465698 48.617794,583.091980 49.331764,581.416626 
	C50.331501,580.176819 51.370510,579.975830 52.873577,580.065552 
	C54.178837,580.438965 55.086731,580.836243 56.451580,580.666809 
	C57.923672,580.669739 59.044132,580.643127 60.464439,580.311279 
	C62.259499,579.888672 63.740578,580.257568 65.512939,580.176270 
	C66.364822,580.078674 66.925415,580.050659 67.718887,579.985352 
	C67.951683,579.946960 68.254959,579.600037 68.254959,579.600037 
	C68.254959,579.600037 68.044159,579.168823 67.890549,578.882080 
	C66.547668,575.121582 66.091133,571.529419 66.003937,567.505676 
	C65.966003,565.639099 66.103432,564.137512 65.727127,562.293091 
	C65.131828,556.260437 64.408134,550.659424 60.430573,545.719360 
	C58.949612,543.933594 57.583961,542.503235 56.831295,540.638672 
	C57.520882,542.348083 58.663315,543.742310 60.156208,545.333984 
	C63.834034,550.260437 65.311501,555.548157 65.529625,561.642639 
	C66.049484,563.256104 65.980667,564.547424 65.989258,566.210266 
	C65.980812,567.087585 65.962303,567.584167 65.878357,568.437988 
	C63.208725,572.930542 59.999664,574.960388 54.708641,576.134888 
	C50.594803,577.048035 48.288445,574.355103 44.719715,574.883240 
	C43.927654,574.955322 43.476082,574.942871 42.701683,574.803345 
	C40.874802,574.117981 40.199924,572.695679 39.047394,571.318359 
	C38.720055,570.935669 38.590103,570.784668 38.075745,570.194336 
	C37.567272,569.609802 37.443195,569.464722 37.141663,569.098877 
	C36.855995,568.725403 36.747787,568.572815 36.497360,568.181519 
	C36.183933,567.618835 36.013901,567.294312 35.698769,566.738220 
	C35.445057,566.357788 35.337475,566.208374 35.052330,565.844299 
	C34.618069,565.346558 34.356373,565.068176 33.875710,564.579590 
	C33.529041,564.205872 33.396698,564.046692 33.086399,563.627075 
	C31.877342,561.176514 30.269293,559.416809 28.442310,557.398438 
	C25.808994,553.210938 22.251232,550.058777 20.392082,545.349487 
	C20.397810,542.928406 19.181467,540.458435 22.448000,539.202515 
	C24.272593,539.153320 25.644156,539.618225 27.361687,540.083130 
	C29.668633,541.238831 31.636347,542.238586 32.417198,538.611328 
	C32.245888,537.683289 32.153439,537.057556 32.167683,536.096924 
	C32.252018,535.561096 32.308857,535.350037 32.507553,534.842041 
	C32.887669,534.175659 33.150124,533.824097 33.648743,533.239441 
	C35.441425,531.494263 36.809490,529.730286 39.282303,528.891296 
	C40.140720,528.647522 40.707645,528.311707 41.202866,528.918823 
	C40.961800,528.580383 40.622803,528.469849 39.896984,528.500000 
	C39.369362,528.404419 39.168873,528.306885 38.825974,527.900879 
	C38.817497,525.783752 40.146790,524.743164 41.540920,523.335083 
	C43.014927,522.181396 44.430389,521.891541 46.243385,521.674377 
	C47.321613,521.574036 48.028530,521.448120 49.070553,521.134888 
	C50.641773,520.801697 51.852676,520.791992 53.382057,521.291626 
	C54.401108,521.869995 54.810055,522.566406 55.341515,523.153687 
	C57.825130,525.898499 59.140331,525.575195 61.168877,521.601318 
	C62.572975,520.661987 63.646778,519.855042 64.841705,518.655396 
	C69.546234,517.714661 72.656174,521.004944 76.793083,522.278931 
	C77.533257,522.686157 77.896843,523.005005 78.420898,523.682007 
	C79.339806,525.700500 78.988838,527.370239 78.382416,529.372437 
	C78.159721,530.630859 78.438080,531.360962 79.321205,531.738098 
	C83.171333,533.382324 86.658684,535.605164 89.934372,538.200500 
	C90.723030,538.825317 91.724594,539.191467 92.908943,537.771240 
	C90.714073,536.713318 89.627274,535.568054 90.878731,532.610962 
	C92.309586,529.230042 90.309341,527.670410 84.707184,526.882324 
	C83.919563,526.573792 83.527908,526.295654 82.974136,525.653320 
	C82.712204,525.115112 82.655899,524.878540 82.687347,524.290283 
	C82.956955,523.782166 83.138824,523.625916 83.654488,523.341858 
	C86.525818,523.091736 89.030518,522.817627 91.659119,521.495117 
	C92.429008,521.245361 92.882912,521.164001 93.687660,521.117554 
	C96.759796,521.349609 99.360245,520.291077 102.394173,520.385376 
	C103.736290,520.917480 104.399071,521.839844 105.618423,522.540894 
	C106.947670,523.038574 107.973251,523.423950 108.557480,524.829346 
	C108.669724,525.760071 108.564667,526.369751 108.481918,527.271912 
	C108.553322,527.949707 108.668938,528.324341 108.990601,528.946167 
	C110.351418,531.028381 113.320618,529.598511 114.304428,532.283691 
	C114.636673,533.177795 113.691109,534.093567 115.193634,534.323792 
	C116.097984,534.132874 116.713791,534.149841 117.627754,534.437012 
	C118.086662,534.731567 118.244370,534.888428 118.539307,535.349854 
	C118.881363,536.519592 119.397034,537.276672 119.576904,538.484253 
	C119.555489,539.220276 119.442436,539.613281 119.071983,540.202026 
	C118.678123,540.676453 118.468582,540.939331 118.262268,541.439270 
	C118.236740,541.654175 118.422142,542.046021 118.597305,542.186157 
	C119.053757,542.464417 119.334564,542.603455 119.801483,542.903687 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M162.806488,509.239685 
	C175.831345,497.384247 190.941360,489.272980 206.449295,482.057190 
	C232.507095,469.932648 259.478271,460.042236 286.958862,450.685425 
	C287.582977,450.416962 287.984253,450.413239 288.686523,450.405365 
	C288.350037,451.859772 287.712524,453.318298 287.074371,454.778290 
	C291.308960,455.676056 295.695892,453.838989 299.855347,456.307251 
	C299.453064,457.941101 298.259979,458.189697 297.133942,458.351959 
	C284.457825,460.178711 272.464386,464.725708 260.049866,467.568146 
	C256.855286,468.299561 253.626511,469.034851 251.793427,469.342407 
	C260.566711,467.505035 270.649933,464.815643 281.462646,464.139648 
	C283.043640,464.112671 284.222748,464.611847 285.806763,464.272980 
	C286.664032,464.215454 287.151428,464.271606 287.974213,464.540588 
	C289.319305,465.508118 290.172760,466.413788 290.045898,468.129822 
	C281.408020,472.965546 271.975128,474.650635 263.048157,477.773071 
	C258.023895,479.530487 252.974533,481.197266 247.734344,483.382050 
	C246.584457,483.852203 245.708359,484.000305 244.563263,484.299377 
	C244.094528,484.451782 243.912064,484.517456 243.473251,484.704071 
	C242.734039,485.119171 242.318268,485.485504 241.841019,486.203247 
	C241.181870,487.149841 240.520782,487.559937 239.334656,487.541626 
	C238.015106,487.176056 237.017410,487.197845 235.737518,487.717499 
	C234.033157,488.217743 232.571365,488.443176 230.985535,489.310059 
	C230.508072,489.543762 230.314133,489.632507 229.821747,489.838562 
	C227.662430,490.488556 225.916016,491.291504 223.920929,492.352325 
	C223.421127,492.586212 223.216232,492.671417 222.692902,492.858612 
	C219.479446,493.431549 216.797424,494.542450 213.459106,495.726868 
	C212.088135,495.769714 211.390274,495.789551 210.335693,495.846252 
	C209.778030,495.828033 209.577103,495.772980 209.238037,495.998291 
	C208.607101,496.535919 208.114273,496.793213 207.335739,497.077393 
	C201.824677,495.137726 198.437256,499.837524 194.042282,500.962433 
	C191.887527,501.513916 189.758698,502.804657 187.297348,503.236816 
	C185.179474,503.608673 182.572739,503.588074 181.274994,506.031769 
	C181.131790,506.301422 180.753799,506.676758 180.538818,506.644348 
	C174.914749,505.796021 170.997559,509.206787 166.716766,511.910431 
	C165.743881,512.524902 164.181091,512.295898 163.278870,513.467224 
	C161.649536,515.582458 160.485794,514.025818 158.958679,512.525146 
	C158.996307,511.297699 159.604980,510.891937 160.762817,511.011780 
	C161.519135,510.460876 162.066162,509.951508 162.806488,509.239685 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M55.192158,580.277100 
	C53.702663,580.499451 52.475807,580.744934 50.778145,581.031250 
	C49.273190,580.914795 48.236755,580.926575 46.886696,581.045410 
	C43.217388,581.134338 39.717258,579.681152 36.662655,582.730164 
	C35.991524,583.399963 33.709534,584.325195 31.920349,582.698120 
	C31.228367,581.190125 32.258022,580.177002 32.127506,579.020752 
	C30.782618,579.334106 31.291241,580.765381 30.404549,581.727844 
	C28.815420,581.970459 27.423742,581.916138 26.836048,584.035034 
	C26.028276,584.227661 25.591961,583.774109 25.114033,582.996460 
	C24.964964,582.798706 24.475466,582.797058 24.240309,582.864929 
	C22.650248,583.184143 22.029558,582.228210 21.075123,581.188599 
	C18.877972,581.669800 16.914223,582.480896 16.286282,579.133972 
	C16.656761,577.554993 17.655598,577.060913 18.664150,576.483643 
	C19.809734,575.827881 20.328730,574.832336 19.090551,573.773621 
	C18.034067,572.870300 16.109632,572.428955 16.773836,570.564636 
	C17.497417,568.533691 19.603472,569.584473 21.063124,569.167908 
	C21.843542,568.945129 22.675549,569.080627 23.762983,569.493347 
	C24.405869,570.030579 24.572218,570.465393 24.535561,570.973389 
	C27.292469,568.897522 29.852119,571.020691 32.471653,571.688660 
	C32.786678,569.786377 31.227076,569.258972 30.598202,567.792847 
	C30.505289,565.773499 31.586267,565.203125 33.414009,565.007812 
	C34.367165,565.082458 34.883751,565.237122 35.702656,565.732300 
	C36.035877,565.969421 36.004425,566.000000 36.016739,565.984009 
	C36.420689,566.433044 36.472267,567.030945 36.851830,567.793213 
	C37.045982,568.009888 36.991032,568.013306 36.991631,567.985779 
	C37.203762,568.212463 37.430000,568.452881 37.857059,568.842896 
	C38.043175,569.006348 37.991302,569.012634 37.990906,568.986511 
	C38.224312,569.235474 38.481190,569.486938 38.983986,569.867798 
	C40.642742,570.561340 41.037342,571.959778 41.873863,573.361938 
	C42.256454,574.187012 42.634708,574.567688 43.550941,574.356812 
	C46.998749,572.265869 49.417801,572.724304 50.518623,576.604004 
	C52.941055,576.015930 51.323822,573.881409 52.324661,572.889404 
	C56.759048,575.913147 58.140358,575.519653 64.911880,569.220215 
	C66.635635,571.293213 66.633293,573.560913 65.099136,576.124756 
	C64.655830,576.530151 64.464676,576.666870 63.980885,576.972168 
	C62.541939,577.530823 62.247375,578.518188 61.896805,579.833008 
	C61.667534,580.291870 61.546204,580.459595 61.223686,580.863892 
	C60.140762,582.109680 58.912395,581.902832 57.424332,582.027771 
	C56.427299,581.551514 56.157700,580.723511 55.192158,580.277100 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M54.185219,628.167725 
	C53.744701,627.110168 53.482212,626.301758 53.096184,625.195312 
	C52.653732,624.556824 52.480331,624.156677 52.565628,623.361206 
	C53.352512,621.762085 54.716534,621.414978 56.144550,620.610352 
	C56.656281,620.441467 56.867699,620.401794 57.699860,620.441406 
	C58.890633,620.673767 59.448273,620.916443 60.343307,620.656799 
	C60.816902,620.480530 61.008152,620.409058 61.500389,620.263794 
	C62.413666,620.115173 63.011906,620.170959 63.832577,620.522583 
	C64.286072,620.920471 64.460213,621.200623 64.579849,621.729980 
	C64.609306,621.932739 64.722412,622.291382 64.856476,622.108704 
	C65.080276,621.785217 65.170013,621.644470 65.403305,621.283691 
	C65.948433,620.422241 66.058098,619.706543 66.095901,618.680542 
	C66.148438,618.204956 66.184113,618.017090 66.323242,617.568604 
	C66.536903,617.164307 66.647118,617.020508 66.990150,616.764282 
	C67.535927,616.629639 67.847000,616.644592 68.055550,616.494873 
	C67.696251,616.079834 67.425529,615.882629 66.949417,615.479919 
	C66.665092,615.080078 66.578880,614.895630 66.460434,614.397949 
	C66.496544,613.647461 66.680244,613.262024 67.241959,612.737549 
	C69.464920,612.200989 70.506958,613.389343 71.548935,615.104370 
	C71.842232,615.925781 71.826981,616.490479 72.284882,616.989014 
	C72.744850,616.807434 72.966988,616.591492 73.346802,616.136719 
	C73.694611,615.816223 73.852982,615.701721 74.298912,615.491821 
	C74.792747,615.384399 74.999031,615.372437 75.515182,615.412476 
	C77.020180,615.786926 78.051514,616.718262 79.734329,616.396118 
	C80.498222,616.355225 80.925606,616.429260 81.590790,616.787903 
	C82.493568,619.540649 80.164925,621.024475 79.399689,623.423340 
	C78.479797,623.588989 78.161903,623.838013 78.406319,624.757202 
	C77.469208,627.780640 76.383446,630.569214 75.136322,633.683105 
	C73.548416,631.172974 71.027153,633.075012 69.021713,632.318176 
	C69.759697,631.048157 69.655327,630.076050 68.916115,628.820007 
	C69.013199,626.692261 70.573212,626.656799 72.031410,626.099854 
	C72.186501,625.571411 72.064873,625.302979 71.610870,624.957581 
	C71.422508,624.815369 71.044510,624.535950 70.865547,624.376892 
	C70.686584,624.217834 70.348610,623.870728 70.146393,623.735352 
	C69.776268,623.600281 69.608360,623.600525 69.223320,623.759155 
	C68.761246,624.207153 68.585800,624.535400 68.435051,625.197266 
	C68.524361,626.681580 68.072670,627.961670 69.190826,629.264526 
	C69.511353,630.174805 69.490692,630.818909 69.194298,631.733582 
	C67.154625,631.727661 66.401375,633.754028 64.342346,633.957275 
	C63.919556,631.452271 63.421062,629.748718 61.133575,632.595520 
	C60.215168,633.738464 59.500072,633.031189 58.339859,632.994629 
	C58.016697,632.975525 58.007889,632.999146 58.015984,632.993652 
	C57.600212,632.545410 57.114109,632.191528 56.278557,631.802612 
	C55.858746,631.512085 55.707478,631.372192 55.385857,630.974121 
	C54.931438,629.949585 54.773300,629.136475 54.185219,628.167725 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M118.353027,535.371460 
	C117.236893,535.200378 116.495003,535.194092 115.392487,535.280762 
	C113.982788,535.320374 113.545502,534.729309 113.799744,533.360596 
	C113.502220,531.628540 112.460777,530.841980 111.122101,531.464722 
	C109.048569,532.429321 108.556862,531.014038 107.975349,529.359375 
	C109.607811,524.860229 112.722794,523.384705 116.966957,523.616699 
	C119.748634,523.768738 122.546410,523.498718 125.694687,523.888123 
	C128.047348,524.760986 129.688782,523.061890 131.953735,523.220703 
	C134.261887,523.839783 136.431488,523.338928 138.494080,524.799316 
	C137.319901,528.690002 134.568497,531.382629 132.198975,534.741699 
	C131.841263,535.187195 131.685287,535.361023 131.266251,535.303589 
	C130.553299,534.969299 130.103409,534.866394 129.325760,534.884338 
	C128.138092,535.763916 127.148155,536.224670 125.584526,536.360657 
	C123.523064,536.475403 121.879807,536.434692 119.864075,535.996094 
	C119.226845,535.754395 118.977058,535.645264 118.353027,535.371460 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M36.743176,758.633301 
	C36.378044,762.173279 35.636730,765.381958 34.922508,768.596619 
	C34.377438,771.049988 33.004932,772.218445 30.366484,772.059937 
	C27.566841,771.891785 24.749393,772.020020 21.478359,771.990112 
	C18.047401,766.288574 18.756844,760.689087 23.291939,757.745422 
	C28.004982,757.351257 32.248672,756.733704 36.743176,758.633301 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M158.061188,507.717804 
	C152.248764,513.545837 146.448883,519.064514 140.273804,524.467590 
	C139.167892,523.549622 139.224548,522.585144 139.399704,521.261963 
	C139.604858,519.521057 139.483307,518.138306 139.303406,516.408325 
	C139.363281,515.833984 139.419632,515.609253 139.667236,515.096741 
	C141.641922,514.543152 143.786911,515.125732 144.436508,512.468384 
	C144.971512,510.279938 142.365997,510.438873 141.807648,508.311279 
	C141.634827,507.438141 141.690277,507.212494 142.000626,506.748474 
	C145.414566,505.853607 148.867661,505.401245 146.260529,500.393097 
	C146.329376,499.822052 146.396332,499.599701 146.676239,499.101776 
	C148.092422,498.351349 149.553146,499.032013 150.621887,498.134552 
	C153.361038,495.834686 155.303452,497.231689 157.305511,499.712952 
	C157.772415,500.668854 157.835358,501.348328 157.508698,502.344788 
	C156.723557,503.264771 155.854263,503.619141 155.255768,504.651428 
	C155.024475,505.033813 154.854828,505.134033 154.929169,505.097839 
	C155.534424,504.271545 155.978348,503.629211 156.927216,503.032349 
	C157.539062,502.565796 157.946381,502.459076 158.692596,502.605194 
	C159.115234,502.909149 159.235443,503.089172 159.385590,503.590759 
	C159.205612,505.168793 158.234299,506.133057 158.061188,507.717804 
z"/>
<path fill="#E9E5C8" opacity="1.000000" stroke="none" 
	d="
M19.658360,774.946716 
	C24.186117,774.957886 28.436949,775.159302 33.260384,773.966492 
	C32.010323,778.505920 31.030130,782.471680 29.817669,786.364990 
	C28.318607,791.178650 26.138178,792.334412 20.384718,791.000916 
	C16.317675,790.058411 20.082666,786.817993 18.889009,784.460693 
	C18.516684,783.581726 18.277582,783.132446 18.040569,782.270142 
	C17.951757,780.351624 18.462780,778.894287 18.732822,777.011841 
	C18.917067,776.130615 19.113295,775.658386 19.658360,774.946716 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M15.203595,826.646179 
	C12.953258,826.887024 10.910794,826.888489 8.438969,826.802002 
	C6.910552,825.971924 6.138593,825.020752 6.029297,823.322266 
	C5.776152,815.886536 7.892481,808.988281 8.029372,801.460083 
	C9.087563,799.902161 9.662126,798.048828 12.086091,798.948853 
	C12.530977,799.762329 12.569330,800.303650 12.493776,801.267944 
	C12.447288,807.783020 10.878807,813.783447 11.622602,819.937317 
	C11.127347,814.417969 11.899104,808.998474 12.926851,803.288330 
	C15.154596,803.214905 15.483105,804.157471 15.222465,806.060791 
	C14.801981,809.131348 14.695918,812.276123 15.591938,815.687134 
	C17.610594,817.427307 17.359280,819.359619 17.077644,821.632202 
	C16.162861,823.354553 14.768784,824.517761 15.203595,826.646179 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M16.621189,823.063416 
	C15.503969,820.880981 16.208942,818.828064 15.905767,816.430298 
	C16.777142,814.218445 14.166300,810.297363 18.752575,810.762756 
	C22.468103,811.139832 27.958672,807.356323 28.972773,814.811340 
	C29.364048,817.687805 30.035934,820.526062 30.616972,823.575928 
	C27.607748,823.853516 24.501686,822.193665 22.529284,825.300049 
	C22.761507,825.852478 22.668139,826.021790 22.282703,826.197754 
	C21.412333,826.040039 20.922602,825.714172 20.203428,825.190796 
	C18.983280,824.286865 17.728872,824.082703 16.621189,823.063416 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M16.904263,794.434814 
	C26.741379,793.558350 26.315878,793.587280 26.968525,803.190735 
	C27.354195,808.865662 24.127504,807.521606 20.974619,807.884705 
	C16.568274,808.392151 16.522095,806.006409 16.929462,802.878906 
	C17.142666,801.242004 17.159805,799.579651 17.213993,797.468140 
	C16.319502,796.369873 16.558367,795.527405 16.904263,794.434814 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M19.984600,774.386902 
	C19.896677,775.195374 19.859383,775.713989 19.725348,776.610229 
	C18.759060,777.942383 17.691195,777.962891 16.207363,777.430298 
	C15.394869,775.358215 15.252903,773.503235 15.990712,771.143677 
	C14.994215,773.307861 16.003496,775.272644 14.773769,777.141113 
	C12.588122,777.499268 12.192443,776.279541 12.059635,774.406982 
	C12.970045,769.605713 13.879282,765.211853 14.809076,760.474976 
	C14.279294,758.426147 15.893727,758.847290 16.855228,758.212402 
	C18.106565,757.579041 18.972490,756.906311 20.273657,756.278564 
	C20.846603,756.106873 21.086363,756.062195 21.699017,756.017700 
	C23.446533,756.265686 24.534023,756.790833 24.219656,758.785889 
	C21.979746,759.474976 20.380453,759.930481 20.755596,762.752808 
	C21.117638,765.476562 20.817926,768.288208 20.912958,771.511353 
	C20.689737,772.673218 20.362482,773.385132 19.984600,774.386902 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M24.464546,759.180298 
	C23.954157,757.629150 23.134455,756.990173 21.349957,757.000610 
	C18.929155,754.924744 22.674141,753.473328 21.786793,751.205444 
	C23.898621,750.620117 25.915791,749.769104 26.502092,752.851257 
	C26.842358,754.639954 28.537699,754.004578 29.766245,754.025513 
	C32.539986,754.072754 35.314045,754.101501 38.544968,754.056641 
	C42.928143,756.754395 39.468597,757.489929 37.402306,758.827209 
	C33.046551,759.058655 28.985399,759.155273 24.464546,759.180298 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M71.470734,587.693298 
	C71.603432,595.508179 77.677620,591.889221 81.572937,593.066528 
	C82.182693,593.205139 82.340576,593.317749 82.271439,593.612305 
	C67.862411,593.794128 53.680412,593.794128 39.498417,593.794128 
	C39.482170,593.615845 39.465923,593.437561 39.449680,593.259277 
	C41.638901,593.064758 43.828125,592.870300 46.447792,592.608887 
	C47.326275,592.379272 47.552723,592.052246 47.732628,591.280396 
	C47.577980,589.868530 47.279625,588.760376 47.039009,587.300842 
	C47.572544,586.085388 48.118511,585.331055 49.573299,585.757324 
	C49.790565,587.119202 49.968456,588.358459 49.604084,589.409851 
	C48.568035,592.399170 50.184685,592.956970 52.554787,592.905273 
	C57.850292,592.789917 63.144329,592.557739 68.440048,592.518433 
	C72.299675,592.489807 69.722328,590.145142 69.988205,588.375610 
	C70.381187,587.643311 70.758316,587.496399 71.470734,587.693298 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M50.713028,608.416931 
	C51.973660,608.026855 52.909184,607.759033 54.334000,607.502380 
	C54.971542,607.910461 55.032093,608.318665 54.913872,609.035461 
	C54.612415,610.029724 54.210728,610.704468 54.680794,611.728455 
	C55.537857,612.977112 56.524181,613.826111 56.551102,615.495972 
	C55.589222,617.876526 53.820061,617.577332 51.798119,617.461121 
	C51.309231,617.590454 51.118999,617.664062 50.651508,617.872192 
	C49.421085,618.454590 48.563374,619.085022 47.250786,619.526245 
	C45.485001,619.514221 44.415749,618.670105 43.085873,617.625793 
	C42.733173,617.191406 42.622776,616.995483 42.448265,616.470886 
	C42.407368,615.467285 42.652912,614.880432 43.314610,614.173584 
	C43.714935,613.899231 43.887280,613.819275 44.326870,613.725403 
	C44.798138,614.062683 45.020367,614.104126 45.335472,613.502930 
	C45.519062,612.471680 45.040707,611.875061 44.692596,610.914917 
	C44.670429,610.407104 44.718349,610.199585 45.002312,609.764709 
	C46.872566,608.779968 48.883770,609.967407 50.713028,608.416931 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M54.494560,610.570435 
	C54.166134,609.528687 54.224773,608.920532 54.553352,607.912964 
	C54.823288,607.513611 54.913410,607.487244 54.940643,607.499512 
	C55.019646,607.236633 55.071419,606.961609 55.514454,606.838745 
	C57.937706,607.583923 59.630096,605.349609 62.030807,606.671509 
	C63.764523,607.626221 63.406391,604.820557 64.624680,603.656799 
	C65.175232,605.130249 65.149002,606.887207 66.874664,607.906982 
	C67.168839,608.358398 67.290054,608.510132 67.469193,608.944092 
	C67.528328,609.415833 67.529533,609.605286 67.456894,610.064026 
	C67.215698,610.842468 66.992783,611.338623 67.002281,612.422607 
	C67.060997,613.406860 67.132843,613.861084 67.140152,614.654663 
	C66.804085,615.315613 66.459656,615.517151 65.745804,615.615479 
	C65.243240,615.561157 65.047333,615.506531 64.586182,615.304504 
	C64.001595,614.919556 63.699230,614.662109 63.213524,614.178833 
	C62.888672,613.833252 62.765411,613.692139 62.468506,613.337646 
	C62.069725,612.851318 61.834347,612.587585 61.382950,612.184448 
	C61.030354,611.957764 60.881756,611.881226 60.492561,611.739014 
	C59.912437,611.638977 59.573009,611.642761 58.967888,611.727173 
	C58.148190,611.875122 57.590984,611.893738 56.745220,611.799927 
	C55.891029,611.591675 55.372856,611.326233 54.494560,610.570435 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M92.724602,580.499756 
	C93.225029,579.775574 93.556465,579.491577 94.057205,578.923462 
	C94.417625,578.622925 94.608742,578.606567 95.068161,578.690491 
	C95.854904,579.053711 96.398262,579.238525 97.280624,579.369751 
	C99.352882,580.106262 100.489319,581.270020 100.643646,583.578613 
	C102.210907,584.918640 100.846893,585.761353 100.362106,586.873169 
	C99.727058,586.982117 99.447639,587.158386 99.121902,587.791809 
	C98.671150,588.134766 98.441071,588.307251 98.149475,588.732788 
	C97.634666,589.347046 97.141991,589.515747 96.202309,589.226440 
	C95.172569,589.018738 94.501671,589.011658 93.495735,589.022766 
	C90.898048,586.494568 92.557243,583.655273 92.724602,580.499756 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M32.130325,848.228271 
	C31.742264,845.292480 31.661018,842.572449 31.445885,839.421021 
	C30.981007,838.184937 30.812420,837.349182 30.827633,836.153992 
	C30.836571,835.614075 30.847969,835.397766 30.902334,834.858215 
	C31.000380,834.324036 31.055456,834.113098 31.482527,833.374146 
	C32.898674,832.898621 33.942829,832.951050 35.379349,833.005127 
	C35.831699,837.031616 35.891689,841.056335 35.863777,845.536560 
	C34.915058,847.152588 34.431232,848.826538 32.130325,848.228271 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M7.874270,616.743286 
	C8.261816,616.226013 8.543015,616.009399 8.927011,615.645325 
	C9.717087,614.295715 9.340787,613.070312 9.166704,611.473755 
	C9.344380,610.877441 9.464669,610.655518 9.846435,610.159790 
	C10.107912,609.885925 10.589520,609.910034 10.795304,610.035645 
	C11.368872,610.061035 11.703890,609.894714 12.482067,609.353943 
	C14.413342,608.817261 15.075540,609.618164 15.592342,611.022766 
	C16.585890,611.570312 16.496691,612.222534 16.127899,613.193359 
	C15.766065,613.927795 15.150107,614.261658 15.844440,614.936401 
	C16.721624,614.992371 17.327494,615.049072 18.243006,615.333496 
	C19.198280,615.917297 19.516794,616.530396 19.430645,617.671753 
	C18.736343,618.924438 17.833315,619.378540 16.523235,619.878906 
	C15.196164,620.220093 14.210507,620.246338 12.865317,620.244995 
	C12.040812,620.192444 11.579596,620.116394 10.802956,619.891602 
	C9.653825,619.407898 9.055197,618.754639 8.239435,617.869629 
	C7.945108,617.430664 7.856517,617.237305 7.874270,616.743286 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M119.135681,535.118164 
	C120.934326,534.877319 122.364433,534.803894 124.139252,534.834473 
	C125.731346,535.866089 127.393684,535.116577 128.637634,536.409302 
	C129.547867,538.995605 127.614151,539.626221 126.286148,540.870361 
	C123.449387,542.215271 121.230667,541.821472 119.259949,539.211914 
	C118.729790,538.063049 117.784424,537.207458 119.499695,536.431274 
	C118.835327,536.246704 118.581718,535.983521 119.135681,535.118164 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M22.966742,825.899902 
	C22.927097,825.524353 22.920542,825.618164 22.887707,825.650635 
	C30.550875,823.822144 31.226511,824.295654 31.880390,832.436523 
	C31.854521,832.846130 31.910166,832.865540 31.890587,832.844238 
	C30.119156,834.458984 28.412811,833.301147 26.364157,832.537476 
	C24.495975,830.579102 24.020872,828.292603 22.966742,825.899902 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M22.953197,611.912231 
	C24.737282,609.422302 26.515148,607.260010 28.928593,605.191223 
	C30.371197,606.024414 30.982758,606.905396 31.525627,608.208740 
	C31.622202,609.213928 31.390118,609.809143 30.697784,610.544189 
	C28.561745,611.955383 30.751858,613.586670 29.773720,615.125122 
	C29.338749,615.415771 29.139668,615.483093 28.633011,615.549744 
	C27.943073,615.453735 27.568605,615.334229 26.939186,615.115051 
	C26.108662,614.988831 25.575138,615.125244 24.749371,615.344055 
	C24.253290,615.317993 24.056566,615.254272 23.643702,614.959717 
	C22.983999,613.953918 22.782862,613.132141 22.953197,611.912231 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M92.565582,580.254944 
	C92.947205,582.753784 93.000824,585.447998 93.107574,588.591553 
	C93.099342,589.775208 93.037987,590.509521 93.032951,591.609253 
	C93.410835,592.415649 93.508026,592.901550 93.071701,593.664307 
	C89.485046,593.918030 86.208405,593.939758 82.488083,593.877808 
	C82.044411,593.794128 82.049660,593.442932 82.037239,593.267761 
	C82.185036,593.058655 82.344963,592.996460 82.505508,592.994812 
	C90.924866,592.909180 90.902481,592.908081 91.500107,584.791077 
	C91.607391,583.333984 91.984863,581.896790 92.565582,580.254944 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M74.025764,610.413452 
	C73.732162,607.289429 76.027946,606.644409 77.567360,606.202148 
	C79.414284,605.671509 78.527969,608.255554 79.822891,609.214478 
	C80.272644,609.568481 80.393677,609.759521 80.661682,610.257812 
	C80.956116,611.000366 81.050629,611.446838 81.104446,612.250488 
	C81.085564,613.297852 80.937950,613.971680 80.451324,614.895081 
	C79.869171,615.427856 79.452553,615.584656 78.668640,615.577637 
	C77.074997,614.994263 76.684235,613.671204 75.643616,612.525391 
	C75.296173,612.161987 75.151566,612.022461 74.798035,611.666260 
	C74.465240,611.292175 74.341370,611.134644 74.025764,610.413452 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M97.451935,572.485718 
	C100.459541,571.457092 102.056595,572.584412 102.684410,575.769531 
	C103.796898,577.432190 104.199074,578.771362 102.110565,579.914978 
	C100.153877,580.238403 98.929321,579.163330 97.291367,578.338196 
	C96.404236,576.301758 97.393715,574.577698 97.451935,572.485718 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M50.862206,607.977783 
	C50.630417,612.522827 48.367241,611.609497 45.566296,610.163391 
	C44.752804,609.814331 44.536957,609.333069 44.809036,608.387329 
	C45.322102,606.822998 44.209015,604.106262 47.326408,605.955261 
	C48.404354,606.594543 49.563965,607.096252 50.862206,607.977783 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M13.152834,802.691406 
	C12.719428,809.080872 12.203255,815.159729 11.687081,821.238586 
	C10.367914,814.779785 11.246057,808.385681 12.122594,801.571960 
	C12.292237,800.936157 12.387874,800.718018 12.665781,800.807129 
	C12.922057,801.536560 12.996061,801.958740 13.152834,802.691406 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M17.062346,793.752441 
	C17.283094,794.948486 18.424610,795.582275 17.303375,796.773560 
	C16.408804,797.005005 15.655117,797.002380 14.524639,796.994141 
	C13.925508,796.805908 13.703167,796.623291 13.270823,796.062622 
	C12.565535,793.396118 12.217887,791.127136 14.343839,789.028809 
	C17.674131,789.284058 16.819942,791.587158 17.062346,793.752441 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M30.366827,582.049500 
	C30.234976,581.484863 30.331940,580.998352 30.338810,580.510498 
	C30.362366,578.838257 29.165966,576.830750 31.381077,575.770081 
	C31.905443,575.519104 33.511196,576.163269 33.511326,576.396301 
	C33.512390,578.272522 34.454876,580.508789 31.884285,582.047974 
	C31.345161,582.295715 30.949755,582.211365 30.366827,582.049500 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M35.554008,607.319336 
	C36.197807,607.067871 36.569839,607.008911 37.224449,606.945557 
	C38.167065,607.229004 38.816170,607.538696 39.732277,608.122498 
	C40.171349,608.537354 40.313072,608.738647 40.547974,609.299683 
	C40.642056,610.165100 40.521027,610.641541 40.021187,611.347900 
	C36.498989,612.971436 33.418552,613.783936 31.854939,608.925049 
	C32.459332,606.600464 34.063400,607.688782 35.554008,607.319336 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M49.960201,585.566406 
	C49.118824,586.210693 48.377373,586.455688 47.366337,586.825073 
	C46.956139,585.267029 46.815525,583.584534 46.624611,581.481384 
	C47.482151,579.286926 48.434143,577.714722 50.296349,580.659912 
	C50.224937,582.437073 50.142532,583.802063 49.960201,585.566406 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M140.768768,519.940735 
	C141.369080,521.350647 140.298172,522.268799 139.889374,523.882996 
	C139.741699,524.644775 139.510864,524.857361 138.973053,525.043335 
	C136.540588,524.959290 134.341171,524.821716 131.961029,524.308105 
	C131.748169,523.475220 131.867950,523.066772 132.432495,522.521851 
	C133.839539,521.784912 135.157318,521.694275 136.503494,520.810303 
	C137.969116,520.232849 139.190125,519.964111 140.768768,519.940735 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M14.768602,788.531982 
	C13.716571,790.879639 14.100245,793.023865 13.893956,795.495239 
	C13.589432,795.987000 13.320942,796.076843 12.743046,795.875244 
	C11.043326,792.631714 11.598174,789.535583 11.821220,786.061035 
	C12.362643,784.104492 12.672327,782.522278 12.925225,780.512146 
	C13.158806,779.872253 13.284603,779.627869 13.712230,779.100037 
	C14.606431,778.781921 15.093490,778.992981 15.684490,779.811646 
	C16.356049,781.583069 16.339928,782.955750 15.397032,784.637756 
	C15.035624,786.039612 14.904940,787.087524 14.768602,788.531982 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M152.707550,518.101562 
	C153.331589,518.699890 153.795654,519.371033 153.950699,520.107239 
	C154.350830,522.007202 153.134323,523.612427 151.719086,523.894897 
	C150.612183,524.115784 150.709671,521.910156 150.048553,520.551575 
	C150.804016,519.553589 151.605408,518.878723 152.707550,518.101562 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M79.780533,614.913696 
	C79.931801,613.863464 79.898758,613.092285 80.461197,611.900513 
	C81.379486,611.583069 81.697899,611.698242 82.490143,611.926636 
	C86.570396,614.034851 83.104790,615.166626 82.117653,616.822388 
	C81.440102,616.951660 81.040398,616.899719 80.114624,616.670410 
	C79.447975,616.058838 79.443527,615.625305 79.780533,614.913696 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M96.750214,578.547546 
	C98.445511,578.411499 100.687546,576.689636 101.583038,579.754211 
	C101.537704,581.113464 101.258522,582.182373 100.869888,583.567322 
	C99.580849,582.601807 99.275574,580.623779 97.165039,579.795776 
	C96.718666,579.579041 96.620155,579.373230 96.750214,578.547546 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M14.619086,613.439087 
	C15.111670,612.621643 15.480698,612.187500 15.834484,611.448547 
	C15.819243,611.143738 16.254522,611.026855 16.479660,611.017090 
	C17.441130,610.433289 18.249634,610.189026 19.552177,610.689819 
	C19.931871,610.912720 20.041956,611.202393 20.008984,611.353760 
	C20.113094,611.700623 20.250175,611.896179 20.415066,612.449829 
	C20.016994,613.953674 19.275948,614.866211 18.040956,615.818237 
	C17.107891,615.976746 16.481730,615.957397 15.541142,615.916382 
	C14.414352,615.404541 14.292376,614.670837 14.619086,613.439087 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M44.708912,607.976440 
	C45.051769,608.517151 45.064575,608.995667 45.152073,609.827026 
	C45.226761,610.179871 45.209743,610.574707 45.204773,610.772278 
	C45.064148,611.115845 44.928490,611.261841 44.218662,611.512695 
	C43.459709,611.562012 43.274921,611.506470 42.856503,611.287109 
	C42.379101,610.853455 42.149860,610.571838 41.768562,610.093689 
	C41.598557,609.911621 41.185268,609.652466 40.946289,609.592957 
	C40.707314,609.533447 40.249138,609.350830 40.100700,609.153870 
	C39.952267,608.956909 39.993584,609.000793 40.013466,609.023438 
	C39.673717,608.676941 39.505161,608.239380 39.768444,607.415649 
	C42.152164,603.508850 43.133064,606.435669 44.708912,607.976440 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M19.783558,614.110718 
	C19.934666,613.400574 19.936153,613.021973 19.956827,612.074219 
	C20.719997,611.547180 21.463985,611.589172 22.583691,611.607910 
	C23.950968,612.180664 23.996130,613.169312 24.078114,614.528137 
	C24.133419,615.641296 23.875069,616.291443 23.110935,617.079651 
	C20.431313,617.829041 19.890184,616.294739 19.783558,614.110718 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M118.978806,539.075684 
	C121.092178,539.711975 122.648087,541.796936 125.618156,540.992920 
	C124.578651,542.836487 122.816521,543.038696 120.486755,542.063293 
	C119.511665,542.024231 118.882988,542.279602 117.973701,541.964783 
	C117.499207,541.378357 117.440720,540.965942 117.739746,540.276428 
	C118.239929,539.790405 118.540703,539.559082 118.978806,539.075684 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M15.483276,784.960449 
	C15.135042,783.614624 15.103779,782.237427 15.061798,780.446777 
	C15.198988,779.876770 15.346895,779.720276 15.815472,779.519531 
	C17.374077,779.629517 17.871321,780.633118 18.682550,781.758667 
	C18.919125,782.448486 18.948050,782.894409 18.899048,783.668335 
	C17.814161,784.307190 16.807203,784.618225 15.483276,784.960449 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M71.597771,615.989624 
	C69.811760,615.287231 69.435966,613.219055 67.322113,613.002075 
	C66.989151,612.952637 67.037773,612.992249 67.025665,613.021179 
	C66.466133,612.326599 66.263329,611.535645 66.788696,610.301636 
	C67.034103,609.953308 67.038681,610.032776 66.999954,610.042114 
	C67.244316,609.672852 67.538620,609.303162 68.199020,608.957153 
	C68.554291,608.972229 68.488083,608.973206 68.497726,608.941528 
	C69.811638,609.744629 69.629402,611.811096 71.569992,612.548401 
	C71.943878,612.956482 72.078247,613.133240 72.362282,613.607483 
	C72.626869,614.334106 72.664886,614.769104 72.486984,615.511230 
	C72.190926,615.939758 72.018257,616.067932 71.597771,615.989624 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M24.785004,581.412720 
	C26.810368,581.368103 25.688967,583.041016 26.501514,584.175903 
	C26.750746,585.054382 26.807703,585.696899 26.790941,586.653687 
	C26.338526,587.542236 25.959827,588.116577 25.352245,588.823242 
	C22.943785,586.735046 24.689447,584.208801 24.785004,581.412720 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M70.850723,611.370361 
	C71.742149,610.764954 72.518692,610.476440 73.564636,610.018921 
	C73.834038,609.849854 74.035301,610.037720 74.135498,610.132141 
	C74.365364,610.364563 74.495026,610.502502 74.827820,610.838867 
	C75.030952,611.037354 74.997757,611.005737 74.980011,610.991211 
	C77.489296,614.380432 74.857002,614.284851 72.278923,614.217041 
	C71.950531,613.985291 72.011101,613.989563 72.007652,614.019714 
	C71.482948,613.315186 71.040421,612.538269 70.850723,611.370361 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M28.996372,604.994385 
	C30.681318,603.367188 32.897316,603.222534 34.720200,604.018372 
	C36.669926,604.869690 34.078362,605.039429 33.937622,606.014893 
	C33.400116,606.536499 32.979546,606.664612 32.193813,606.659790 
	C30.982937,606.419556 30.183321,606.053223 29.251759,605.239929 
	C29.012592,605.012207 29.001829,605.001587 28.996372,604.994385 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M78.737686,624.906982 
	C77.581818,624.875488 76.156036,624.838623 76.449013,623.596985 
	C76.633125,622.816711 76.640167,621.023621 78.319221,621.278625 
	C78.668755,621.331726 78.876617,622.317261 79.140816,623.282349 
	C79.061371,624.068420 78.990883,624.445190 78.737686,624.906982 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M158.324249,507.950623 
	C156.349915,506.635559 156.884125,505.426208 158.649414,504.138000 
	C159.620087,503.928711 160.242874,504.075836 161.002838,504.722656 
	C160.871674,505.436279 160.541946,505.888641 160.083496,506.595032 
	C159.503128,507.190765 159.051498,507.532440 158.324249,507.950623 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M34.355087,592.541260 
	C35.684368,592.033020 36.625957,591.966064 37.326649,592.888062 
	C37.608555,593.259033 37.594513,593.955750 36.991516,593.949341 
	C35.728767,593.935974 34.210384,594.861084 33.309559,593.162048 
	C33.281055,593.108215 33.447609,592.917603 33.556252,592.833313 
	C33.681313,592.736267 33.843151,592.686584 34.355087,592.541260 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M12.701485,796.101074 
	C13.061671,795.944519 13.461180,795.943115 13.659551,795.920166 
	C13.916830,796.076233 13.975738,796.255310 14.091251,796.711426 
	C13.838081,798.154175 13.528303,799.319885 13.033291,800.799988 
	C12.848056,801.114441 12.522764,801.142639 12.359680,801.148438 
	C12.112767,800.686951 12.028938,800.219543 11.910705,799.396973 
	C11.187744,797.972900 11.485036,797.068604 12.701485,796.101074 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M31.868755,606.376587 
	C32.473602,606.137512 32.848991,606.170288 33.504097,606.247925 
	C34.269604,606.559753 34.755394,606.826782 35.533478,607.110291 
	C35.705662,611.191223 33.401661,606.126709 32.155052,607.613159 
	C31.602579,607.121399 31.620939,606.884949 31.868755,606.376587 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M70.706558,610.835815 
	C71.305870,611.832764 71.646156,612.612183 71.995331,613.720703 
	C69.824905,613.365173 69.018181,611.695923 68.658783,609.253540 
	C69.602829,608.969666 70.127235,609.677979 70.706558,610.835815 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M11.312889,609.229370 
	C10.485809,608.383179 8.610962,608.185547 9.556311,607.265259 
	C10.360869,606.481934 12.300745,606.342529 12.947426,608.680176 
	C12.957812,609.045227 12.986469,609.013000 13.000048,608.996216 
	C12.636990,609.383545 12.176523,609.538696 11.312889,609.229370 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M19.220108,609.062683 
	C19.765070,607.436157 20.826056,606.341187 22.304350,607.581482 
	C22.703550,607.916382 21.615980,608.784241 20.491077,608.966553 
	C19.952877,609.105957 19.718302,609.236572 19.220108,609.062683 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M18.643784,608.892456 
	C19.161951,608.792053 19.367414,608.825806 19.880163,608.917419 
	C20.091108,609.403381 19.994772,609.831360 19.915150,610.586060 
	C19.109919,611.064575 18.287970,611.216431 17.085411,611.187805 
	C16.881691,610.047180 17.355389,609.330811 18.643784,608.892456 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M158.595154,513.085449 
	C158.927582,513.716003 159.619949,514.488098 159.462585,514.997986 
	C159.182571,515.905273 158.269455,515.526794 157.229828,515.091309 
	C156.886398,514.950806 157.021515,514.471619 157.099213,514.235107 
	C157.401657,513.853394 157.626419,513.708069 158.162689,513.309448 
	C158.474197,513.056152 158.572266,513.108887 158.595154,513.085449 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M10.985031,609.300903 
	C11.441524,608.981628 11.889422,608.949280 12.675476,608.948181 
	C13.199698,609.562378 13.719180,610.414307 13.507690,610.676392 
	C12.933472,611.387878 12.058030,611.112366 11.154575,610.431702 
	C10.992871,609.970154 10.984654,609.778992 10.985031,609.300903 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M8.367751,612.741577 
	C6.312199,614.734802 6.417052,612.920166 6.077205,611.545776 
	C6.388333,611.094299 6.728284,610.948853 7.325575,610.687683 
	C7.801259,610.587646 8.019604,610.603271 8.402683,610.902649 
	C8.664871,611.617004 8.666265,612.046692 8.367751,612.741577 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M96.425186,591.591614 
	C96.385574,592.287537 96.152931,592.799866 95.867302,593.280640 
	C95.849380,593.310730 95.234451,593.129028 95.207901,592.987549 
	C95.056839,592.182861 95.126350,591.443054 96.425186,591.591614 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M128.730164,536.390625 
	C127.084335,536.770813 125.334557,537.760681 124.322006,535.437378 
	C125.689713,534.916504 126.895462,534.894714 128.549606,534.939026 
	C128.946747,535.314758 128.895477,535.624329 128.730164,536.390625 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M117.959839,542.829224 
	C118.571594,541.919189 119.185608,541.807556 119.978233,541.871338 
	C120.145042,542.218872 120.133247,542.390991 120.054764,542.813477 
	C119.238785,542.985962 118.941429,544.532288 117.959839,542.829224 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M81.120850,609.704834 
	C82.535027,609.693787 83.037491,610.326965 83.051910,611.694580 
	C82.969582,612.024414 83.029671,612.009155 83.031372,611.978149 
	C82.641052,612.363953 82.162872,612.524780 81.277390,612.192627 
	C80.956108,611.955139 80.965897,612.035034 81.006104,612.036987 
	C80.717751,611.753967 80.546005,611.394043 80.546318,610.645508 
	C80.644508,610.137878 80.726677,609.944336 81.120850,609.704834 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M25.499878,604.515747 
	C25.737728,605.248718 25.523260,605.630005 24.958071,605.579224 
	C24.754036,605.560852 24.432112,605.219604 24.420351,605.011230 
	C24.388153,604.440613 24.784576,604.253845 25.499878,604.515747 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M55.845573,606.699341 
	C55.727348,607.037903 55.548981,607.084778 55.169243,607.321716 
	C53.627663,607.034790 53.706596,605.560730 54.238880,605.135071 
	C54.928997,604.583191 55.172050,606.031128 55.845573,606.699341 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M162.742157,509.185730 
	C162.938065,509.963287 162.642548,510.710480 161.311584,510.958191 
	C161.054657,510.575470 161.114838,510.157898 161.220795,509.425598 
	C161.666534,509.179230 162.066498,509.247528 162.742157,509.185730 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M39.576958,606.958069 
	C40.007011,607.539307 40.036747,607.969482 40.049915,608.722900 
	C39.336296,608.517822 38.639240,607.989502 37.724606,607.201172 
	C38.063564,606.896423 38.620106,606.851685 39.576958,606.958069 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M131.024109,535.317261 
	C131.167313,535.036133 131.331467,535.000000 131.746414,534.988647 
	C131.845169,535.445801 131.693115,535.878296 131.541061,536.310730 
	C131.375732,536.061279 131.210403,535.811768 131.024109,535.317261 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M68.380798,608.727966 
	C68.209297,609.226013 67.864304,609.479736 67.240265,609.892456 
	C66.973015,609.642517 66.984802,609.233643 67.022095,608.515747 
	C67.434174,608.299011 67.820747,608.391357 68.380798,608.727966 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M9.769264,609.765747 
	C10.089887,610.077393 10.071862,610.268799 10.027898,610.747498 
	C9.662943,611.361450 9.254868,611.508911 8.487726,611.343689 
	C8.187849,611.184631 7.883856,610.880981 7.733385,610.726440 
	C8.198813,610.263184 8.814714,609.954407 9.769264,609.765747 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M18.847958,606.668457 
	C17.901196,606.407959 17.834179,605.925415 18.487324,605.402588 
	C18.700613,605.761780 18.913902,606.120911 18.847958,606.668457 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M93.026764,593.822266 
	C92.815575,593.466370 92.869469,593.036499 93.006310,592.290649 
	C93.710907,592.502625 94.061676,593.061401 93.026764,593.822266 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M47.685623,591.121643 
	C47.729206,591.474976 47.582069,591.973328 47.156593,592.506775 
	C47.083801,592.116821 47.289352,591.691711 47.685623,591.121643 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M99.195503,587.931152 
	C99.142067,587.510925 98.678062,586.563416 99.994980,586.874390 
	C99.917000,587.323608 99.678940,587.579224 99.195503,587.931152 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M96.020752,589.264099 
	C96.331467,588.998718 96.819466,588.971680 97.673264,588.932678 
	C97.635475,589.779541 97.057396,590.086060 96.020752,589.264099 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M158.243698,512.931763 
	C158.304626,513.277405 158.135071,513.498718 157.571198,513.859375 
	C157.013138,513.290894 157.499756,513.039734 158.243698,512.931763 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M61.452496,603.440674 
	C61.529755,603.388367 61.552872,603.598206 61.552872,603.598206 
	C61.552872,603.598206 61.375237,603.492981 61.452496,603.440674 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M80.128326,609.811279 
	C80.008667,609.431763 80.090645,609.432251 80.121124,609.404907 
	C80.454453,609.186218 80.772606,609.156067 81.269455,609.472900 
	C81.432846,609.658752 81.223862,609.820679 81.120354,609.902954 
	C80.760559,610.053711 80.504272,610.122314 80.128326,609.811279 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M59.357002,648.835815 
	C58.990814,646.052917 57.637089,644.106812 56.105316,642.241333 
	C59.998047,642.982666 60.185101,645.792114 59.357002,648.835815 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M35.999924,637.000000 
	C35.729023,642.102234 32.558525,638.934326 30.732559,639.602295 
	C31.186214,637.310913 33.462120,639.960693 33.934986,637.346069 
	C33.970604,637.027649 34.001503,636.998230 34.016655,636.983521 
	C34.426582,636.631348 34.884342,636.504517 35.698463,636.780212 
	C36.000153,637.000000 36.000000,637.000000 35.999924,637.000000 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M51.279396,701.760010 
	C50.468868,700.310669 46.947262,698.424988 51.658218,697.006470 
	C51.856441,698.500977 51.704117,700.001953 51.279396,701.760010 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M42.874344,630.269043 
	C44.102459,630.029541 45.364491,629.772217 45.922226,631.580566 
	C44.921875,631.437744 42.881329,633.291809 42.874344,630.269043 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M8.817871,639.428406 
	C7.144188,638.479248 8.723560,636.437500 6.779392,634.958008 
	C9.185624,635.174255 8.711863,636.403198 8.930445,637.630127 
	C8.916014,638.373413 8.866282,638.755859 8.817871,639.428406 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M17.411037,639.993042 
	C17.185843,639.417908 17.117422,639.025574 17.053783,638.333862 
	C19.254204,638.152771 19.496740,639.890259 18.628695,641.005432 
	C17.393414,642.592346 18.103535,640.287537 17.411037,639.993042 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M66.267639,639.791138 
	C65.404640,639.177124 64.824104,638.364136 64.119553,637.278076 
	C65.607704,637.116333 67.585991,636.866333 66.267639,639.791138 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M3.340036,675.135376 
	C4.220370,675.996155 4.208733,677.031372 3.515190,678.108521 
	C2.701935,677.230591 3.061136,676.257812 3.340036,675.135376 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M7.589964,696.044922 
	C7.196433,696.767273 6.799225,696.773865 6.447452,696.260986 
	C6.373727,696.153503 6.376035,695.903809 6.452270,695.798767 
	C6.817308,695.295837 7.214256,695.314209 7.589964,696.044922 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M62.590912,643.047241 
	C62.182182,643.789673 61.768730,643.821228 61.401073,643.275574 
	C61.325211,643.162964 61.330280,642.904846 61.409775,642.793945 
	C61.788342,642.265869 62.200611,642.287170 62.590912,643.047241 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M17.411961,635.983215 
	C17.329374,635.431580 17.476561,634.568115 17.830988,634.472473 
	C18.512753,634.288452 18.827082,635.001770 18.998459,635.964844 
	C18.583244,636.203674 18.159296,636.110962 17.411961,635.983215 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M60.998093,638.001709 
	C61.521362,638.239563 62.057388,638.456909 62.553371,638.743530 
	C62.598251,638.769531 62.445381,639.420959 62.281494,639.476074 
	C61.524109,639.730652 61.225685,639.218689 61.033310,638.289307 
	C61.003643,637.996338 61.000000,638.000000 60.998093,638.001709 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M47.110901,638.256226 
	C47.406425,637.708679 47.911057,637.364929 48.737705,637.013123 
	C48.895107,637.986694 48.808525,639.061584 47.110901,638.256226 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M64.064758,634.060852 
	C64.088341,634.834351 64.052429,635.556519 64.006012,636.641785 
	C63.995522,637.004883 63.999916,637.000000 64.001938,636.998657 
	C62.971046,636.285400 62.727589,635.390137 63.628448,634.099609 
	C63.882538,633.911255 64.005249,634.009521 64.064758,634.060852 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M41.234386,628.925781 
	C41.061054,628.167542 40.514214,627.083923 41.416828,626.800964 
	C41.959869,626.630859 41.972927,627.683350 41.896042,628.592163 
	C41.844173,628.899841 41.438011,628.932251 41.234386,628.925781 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M66.010536,640.010254 
	C65.854210,640.705627 66.382034,641.858643 65.426498,641.941345 
	C64.934311,641.983887 65.127556,640.878723 65.745712,640.151001 
	C65.985161,639.990051 66.002396,640.002136 66.010536,640.010254 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M7.001770,689.998779 
	C7.424710,690.119263 7.845901,690.241028 8.267084,690.362793 
	C7.952156,691.057495 7.595560,690.667236 7.120786,690.202271 
	C6.997801,690.002441 7.000021,690.000000 7.001770,689.998779 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M41.394871,637.670166 
	C41.647381,637.783142 41.757519,638.005432 41.805283,638.240417 
	C41.815723,638.291687 41.603523,638.388306 41.493851,638.464050 
	C41.405926,638.237366 41.318008,638.010742 41.394871,637.670166 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M22.663921,642.721558 
	C22.648169,643.006897 22.495258,643.163513 22.342358,643.320129 
	C22.403831,643.077698 22.465296,642.835205 22.663921,642.721558 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M45.385941,640.715576 
	C45.565044,640.855896 45.592693,641.101196 45.620338,641.346558 
	C45.491714,641.171265 45.363102,640.995911 45.385941,640.715576 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M42.568455,641.565063 
	C42.489304,641.618408 42.460213,641.407837 42.460213,641.407837 
	C42.460213,641.407837 42.647606,641.511658 42.568455,641.565063 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M910.176514,570.721008 
	C906.395935,569.393555 908.019714,572.783081 906.923828,573.905762 
	C903.747681,572.860779 903.840637,570.158875 903.618774,567.750000 
	C903.298767,564.274109 903.534607,560.772156 903.505249,556.876099 
	C903.536072,555.684814 903.487488,554.902893 903.380371,553.753418 
	C904.072144,550.729370 902.811646,548.595459 901.709534,546.321960 
	C898.747253,540.211060 893.764343,535.259399 891.790649,528.342529 
	C892.446533,527.987488 892.974426,527.959656 893.896667,527.889832 
	C894.477905,527.787170 894.664795,527.726501 895.136902,527.748474 
	C895.593506,527.933716 895.764954,528.036377 896.397278,528.533203 
	C897.148193,529.221252 897.431702,529.521362 897.931885,530.054810 
	C899.004822,531.264221 900.087402,532.086670 900.197388,533.776123 
	C901.871887,537.038086 903.024841,540.477112 906.481934,542.490601 
	C906.019592,545.355896 906.164612,545.687439 910.611816,550.506653 
	C912.910095,553.295105 910.083801,555.424561 910.146545,558.218384 
	C909.879211,559.091614 909.610962,559.531921 908.861206,559.962646 
	C905.863953,563.967468 906.321838,567.559814 909.883057,568.189026 
	C910.740967,568.867065 910.769043,569.633118 910.176514,570.721008 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M934.827271,549.200867 
	C935.484741,548.979797 935.917603,548.972473 936.674561,548.985840 
	C938.039124,549.867554 937.840515,551.272278 938.686768,552.616150 
	C939.837463,554.309875 940.275146,555.695496 938.422729,556.999023 
	C938.037964,556.969299 938.013733,556.975037 938.003174,556.968445 
	C937.807678,556.848389 937.622742,556.734985 937.157043,556.786011 
	C936.495117,556.894470 936.114075,556.838623 935.443604,556.761475 
	C934.586304,556.721069 934.055725,556.935608 933.220642,557.017700 
	C932.518372,557.015198 932.097351,556.999207 931.361084,557.009521 
	C930.114502,557.071716 929.281372,557.531067 928.035645,557.736816 
	C927.037476,557.895203 926.374329,557.973328 925.388245,557.939453 
	C924.308594,557.734009 923.805481,557.278870 923.271851,556.353210 
	C922.544373,553.715759 922.978455,551.605652 924.617554,549.426392 
	C925.997620,549.123535 927.208008,549.105042 928.869324,549.144043 
	C929.818237,549.679504 929.756836,550.703125 931.049683,550.591675 
	C932.071777,549.079346 934.056763,551.413818 934.827271,549.200867 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M908.608887,560.401855 
	C908.588013,559.567566 908.703552,559.125732 908.918091,558.355225 
	C913.661194,557.821045 918.060730,559.031189 922.756104,560.538757 
	C928.758667,561.473572 934.447266,562.215942 940.554565,563.030640 
	C941.336426,563.410278 941.467590,563.802551 941.151611,564.491272 
	C930.950500,563.899658 920.916870,563.999207 911.062256,562.065125 
	C910.135620,561.883301 909.026184,562.118835 908.608887,560.401855 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M910.149597,571.344604 
	C909.933289,570.285706 909.969299,569.559998 910.125305,568.489197 
	C911.182983,568.436951 912.103210,568.896912 913.060974,568.996704 
	C922.571228,569.987671 927.931030,575.876831 931.350342,584.598022 
	C931.244019,584.957703 931.007690,584.969543 930.416321,584.976990 
	C928.998718,583.306946 927.824341,581.701233 926.893250,579.965027 
	C923.325073,573.312134 917.552429,571.148621 910.149597,571.344604 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M923.123962,560.428833 
	C918.484314,560.442261 913.751770,560.863770 909.360596,557.998291 
	C908.523865,555.477600 910.741516,553.717041 910.941284,551.036743 
	C914.510803,549.837158 912.795654,552.426575 912.845215,554.162354 
	C912.529419,558.072876 915.016296,556.092163 916.742188,556.194580 
	C917.370117,555.613647 917.678040,555.163147 918.092163,554.433105 
	C918.625183,553.978638 919.020203,554.045837 919.630127,554.531677 
	C920.446045,555.439209 921.103760,555.932861 922.394409,555.653931 
	C922.931030,555.615051 923.146851,555.623352 923.598694,555.853394 
	C924.189819,556.482056 924.544861,556.888977 924.982544,557.561707 
	C924.436096,558.593811 923.806946,559.360107 923.123962,560.428833 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M943.268555,553.611206 
	C943.991150,555.557068 945.706909,555.724243 949.109436,554.124390 
	C950.634949,553.741211 951.547546,554.678162 952.714600,555.777588 
	C954.701660,557.141724 956.421875,555.683228 958.528198,555.908203 
	C959.858948,557.156128 959.411987,557.947510 957.639709,558.486328 
	C956.399414,558.777954 955.573364,558.956848 954.295044,558.734863 
	C953.159668,558.549744 952.439209,558.453186 951.355103,558.393921 
	C948.730103,558.727966 946.471130,558.587708 944.214722,558.377991 
	C940.991211,558.078369 939.118164,556.530884 939.526978,552.650757 
	C939.887329,552.170288 940.081055,552.099243 940.583679,552.010254 
	C941.640503,551.380371 941.823120,550.399902 942.626587,549.411255 
	C943.466064,549.301392 944.080750,549.457947 944.749390,549.942383 
	C944.316284,551.279663 944.312378,552.491882 943.268555,553.611206 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M939.533142,552.220764 
	C939.550110,555.901428 941.326355,557.464661 944.959534,557.383850 
	C946.718018,557.344666 948.487671,557.809753 950.621826,558.238892 
	C946.546448,561.239136 942.345276,559.622375 938.098755,557.346680 
	C939.525085,555.935059 938.874451,554.812683 938.065918,553.387695 
	C937.669189,552.535339 937.797119,552.108582 938.718079,551.921631 
	C939.093750,552.036194 939.372620,552.200256 939.533142,552.220764 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M984.493774,560.003235 
	C989.108154,557.752075 994.028381,558.930359 999.037964,560.736755 
	C994.346985,561.374939 989.603210,561.036438 984.493774,560.003235 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M1015.608765,584.112671 
	C1015.835693,585.190735 1016.907898,586.838501 1014.659424,587.006104 
	C1013.238708,587.111877 1013.031921,586.267944 1013.520020,584.756226 
	C1014.185730,584.324890 1014.755432,584.247742 1015.608765,584.112671 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M957.344849,558.836426 
	C957.719055,558.200867 958.758118,557.939270 958.829407,556.278320 
	C958.881042,555.906250 958.914490,555.916748 958.926453,555.904358 
	C959.124329,555.813416 959.310181,555.734924 959.775513,555.772278 
	C960.055115,555.888123 960.510559,555.986450 960.739136,556.031128 
	C961.525635,556.504150 961.694153,557.082825 961.486572,558.048523 
	C960.196106,558.585205 959.035461,558.829834 957.344849,558.836426 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M941.294739,564.874756 
	C940.936890,564.357300 940.970459,563.999634 940.988708,563.372437 
	C942.588135,563.483765 944.202881,563.864624 946.297119,564.358582 
	C944.432373,565.452576 943.039612,565.059448 941.294739,564.874756 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M933.007935,557.335510 
	C933.805542,557.053528 933.353210,553.929565 935.139954,556.427612 
	C934.762329,557.734741 934.831482,559.793884 933.007935,557.335510 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M927.970215,557.945679 
	C928.483032,556.947815 929.184509,555.882935 930.835938,556.821167 
	C930.435974,558.261292 929.618286,558.925354 927.970215,557.945679 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M961.571533,558.394165 
	C961.268066,557.773682 961.179382,557.206787 961.029236,556.357788 
	C961.390686,556.036316 961.813599,555.996887 962.555725,555.949219 
	C962.851318,556.562683 962.827698,557.184265 962.736572,558.116760 
	C962.669006,558.427612 962.228333,558.466309 962.228333,558.466309 
	C962.228333,558.466309 961.786316,558.447754 961.571533,558.394165 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M956.447998,558.482666 
	C956.814880,558.598389 956.883423,558.879700 956.931274,559.016479 
	C956.020508,560.060608 955.061279,560.209412 953.990540,558.900940 
	C954.613770,558.553162 955.347473,558.460022 956.447998,558.482666 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M965.080811,559.392334 
	C965.145813,559.244751 965.323914,559.211426 965.765503,559.245483 
	C966.028992,559.312927 965.642212,559.578979 965.642212,559.578979 
	C965.642212,559.578979 965.194031,559.506470 965.080811,559.392334 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M937.154663,557.018433 
	C937.188843,556.841064 937.501526,556.731689 937.903381,556.792114 
	C937.806152,557.003357 937.619629,557.044922 937.154663,557.018433 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M973.996521,559.464966 
	C974.130432,559.193237 974.436523,559.218872 974.895996,559.579712 
	C975.063477,559.747681 974.609314,559.750854 974.609314,559.750854 
	C974.609314,559.750854 974.182739,559.595093 973.996521,559.464966 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M968.093018,559.501221 
	C968.152649,559.373779 968.324890,559.346191 968.753418,559.371582 
	C969.009644,559.424561 968.634216,559.656799 968.634216,559.656799 
	C968.634216,559.656799 968.205627,559.601074 968.093018,559.501221 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M21.592052,750.803772 
	C23.210823,752.992004 20.973528,754.444946 20.996010,756.653687 
	C20.988577,756.990234 20.494629,756.993896 20.247654,756.995361 
	C18.882925,757.054443 18.201078,757.800171 17.355404,758.809326 
	C16.774872,760.130493 15.690228,759.163757 14.974316,759.936951 
	C14.546108,759.678406 14.262601,759.224792 13.951514,758.500488 
	C13.618594,757.002136 13.313252,755.774475 12.954458,754.171631 
	C12.901004,753.796387 12.861788,753.348694 12.982618,753.159180 
	C13.749413,751.430847 15.139014,751.515137 16.711403,751.230347 
	C18.372721,750.918945 19.775885,750.812134 21.592052,750.803772 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M16.571732,750.953491 
	C15.874514,751.583984 14.779475,752.142151 13.393942,752.835022 
	C12.548635,749.953125 14.781362,751.034729 16.571732,750.953491 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M54.770035,55.230202 
	C58.172913,55.312153 59.483723,52.280125 61.741600,50.981838 
	C64.319984,49.499249 64.789925,50.796009 65.858719,52.684967 
	C64.493927,55.144341 59.727417,54.115040 60.816093,58.804634 
	C61.555462,59.558681 62.094635,60.036697 62.994984,60.535458 
	C62.211475,59.929874 61.589657,59.603611 60.870411,58.852695 
	C60.058907,54.803471 63.969093,55.286247 65.751518,53.250656 
	C67.065712,52.999928 68.133560,53.002007 69.846283,53.256920 
	C70.675751,53.945522 70.776131,54.399006 70.714294,55.217731 
	C70.551041,55.772633 70.451508,55.983013 70.133240,56.460564 
	C67.691299,58.679985 70.702599,60.855808 69.703629,62.901863 
	C69.647987,63.015831 70.448433,62.654896 71.188179,62.854759 
	C71.703064,63.029545 71.900024,63.127209 72.361626,63.421562 
	C73.891396,65.075821 75.209015,66.463226 77.449196,67.151459 
	C77.918602,67.420250 78.095970,67.545380 78.498772,67.904114 
	C79.986465,69.859177 81.632416,71.213638 83.373566,72.905861 
	C83.795029,73.220787 83.955963,73.356087 84.328751,73.722824 
	C85.064835,74.573677 85.370705,75.379753 86.379608,75.985870 
	C86.796371,76.306831 86.956009,76.446556 87.305222,76.844940 
	C87.765396,77.699539 87.847374,78.325737 87.727295,79.283386 
	C87.572800,79.785934 87.485596,79.978638 87.226311,80.431335 
	C86.686874,81.217224 86.559692,81.755943 87.166351,82.588287 
	C87.464996,83.057838 87.564301,83.262321 87.736702,83.806671 
	C87.722160,86.422478 86.636810,87.707275 83.943527,87.603485 
	C82.624908,86.681808 81.785744,85.643639 80.241760,85.151619 
	C79.757423,84.985313 79.654282,84.390846 79.548973,84.620125 
	C79.276688,85.212975 79.403770,84.295410 80.026627,84.992363 
	C80.887306,86.240059 82.155502,86.392792 83.272224,87.347000 
	C83.691376,89.938087 82.846451,91.437149 80.021454,91.592590 
	C78.888275,90.983902 78.300484,90.256653 77.417229,89.415321 
	C76.980225,88.989616 76.867104,88.880104 76.867104,88.880104 
	C76.547653,88.529884 76.522858,88.492050 76.970139,88.953949 
	C77.709084,89.718742 78.278969,90.287865 79.092514,91.093323 
	C80.797668,92.788437 83.044075,93.680519 82.847565,96.649437 
	C82.619164,97.460304 82.377350,97.869362 81.765099,98.434845 
	C81.068336,98.838219 80.644485,99.002136 79.904678,99.206100 
	C77.667671,100.389633 79.975410,101.108223 79.964890,102.308571 
	C80.078148,102.573082 80.364151,102.982605 80.599709,103.022041 
	C81.143845,102.912933 81.434525,102.734497 81.953964,102.382126 
	C82.729935,101.943565 83.295982,101.748146 84.211548,101.657745 
	C85.170242,101.929665 85.556252,102.427635 85.938309,103.338257 
	C86.278557,104.692520 86.544037,105.727127 87.461914,106.849365 
	C87.716553,107.357239 87.798347,107.572937 87.949509,108.132675 
	C88.084549,109.194809 87.998520,109.895859 87.630768,110.905563 
	C85.535553,113.652298 81.046745,113.309669 80.486145,117.760986 
	C80.055893,118.162712 79.838593,118.270958 79.286972,118.234848 
	C75.915169,114.431602 71.953110,113.704987 67.522537,114.508789 
	C64.701668,115.020561 61.906555,119.787651 63.107170,122.547363 
	C63.532188,123.524300 65.109222,124.109268 63.326878,125.045525 
	C61.724247,125.887367 59.709553,125.127670 59.836361,123.654526 
	C60.049026,121.183983 57.947472,120.411583 57.048546,119.071053 
	C54.733704,115.619041 51.177856,115.891426 47.428463,118.110916 
	C46.913143,117.770477 46.669987,117.730637 46.488403,118.236038 
	C46.629223,118.463509 46.595924,118.483826 46.607254,118.502838 
	C44.143517,117.538582 42.126465,116.640312 45.667725,114.145660 
	C48.906166,111.864342 48.566158,109.219002 45.836597,106.533463 
	C45.135277,105.843452 43.681900,104.817329 44.634495,103.647575 
	C45.715141,102.320541 46.588078,103.739250 47.456291,104.426727 
	C48.432682,105.199875 49.180756,104.694191 50.043335,103.999596 
	C51.926662,102.483025 53.932915,101.119095 55.945236,99.347198 
	C58.024376,98.154442 60.051247,97.324043 62.597359,97.676193 
	C63.267609,101.823769 59.657490,106.349838 55.883804,106.432358 
	C54.577362,106.460930 53.212036,105.850792 52.813663,107.899719 
	C53.104916,108.269653 53.241940,108.404762 53.620262,108.699295 
	C55.723362,109.447105 56.370678,107.640564 57.594917,106.969948 
	C59.506863,105.922607 61.081047,105.857330 61.628426,108.769821 
	C61.428146,109.261200 61.288605,109.429352 61.394218,109.378387 
	C62.422920,107.523613 63.888393,106.390663 64.986626,104.570969 
	C65.297340,104.107529 65.432167,103.930466 65.795532,103.516037 
	C68.480637,99.898216 64.609901,99.876343 63.205269,98.191940 
	C60.591263,95.709183 58.595882,97.908989 56.231777,98.758820 
	C54.254799,99.328217 52.511127,99.657959 50.253578,99.697647 
	C49.842258,98.034081 50.683632,97.046013 51.713280,95.815483 
	C52.468319,95.056641 53.153091,94.554878 52.089012,93.532364 
	C51.147362,92.652618 50.746609,91.676773 49.592697,91.009903 
	C49.191429,90.710922 49.037910,90.581406 48.690727,90.220673 
	C47.965942,89.156425 47.718147,88.168983 46.888073,87.169830 
	C46.559429,86.801071 46.424809,86.655624 46.083340,86.295174 
	C45.019447,85.233673 44.197914,84.354431 43.215172,83.213470 
	C43.000916,83.000648 43.000000,83.000000 42.999619,82.999542 
	C42.421982,82.315338 42.270321,81.544800 42.761944,80.348412 
	C42.995426,80.006142 43.000225,79.999763 43.003784,79.997597 
	C43.281811,79.779083 43.580631,79.605644 43.952316,79.228149 
	C43.995869,78.972427 43.996117,78.501190 43.996597,78.265579 
	C43.162022,77.148895 42.307716,76.286797 41.227699,75.221062 
	C40.839886,75.000816 40.665836,74.995979 40.230728,74.983185 
	C39.182793,73.995178 38.949150,72.930428 39.719635,71.390945 
	C41.010483,70.561279 41.749424,69.834190 41.969612,68.328094 
	C42.269917,67.716629 42.575268,67.471588 43.183807,67.153381 
	C44.041348,66.881592 44.561626,66.626450 44.986755,65.776772 
	C45.616310,64.139656 46.542301,63.058937 47.438236,61.975113 
	C48.641491,60.519527 47.235981,60.130318 46.247345,59.226353 
	C46.003098,58.998501 46.000000,59.000000 46.000126,58.998592 
	C45.577843,58.554283 44.990780,58.497887 44.224190,58.157120 
	C43.999786,57.978081 43.999962,57.488220 43.999413,57.243271 
	C45.011852,53.309578 47.822845,50.961594 50.499805,48.593029 
	C51.694206,47.536232 53.281044,45.884987 54.943253,48.657227 
	C59.753620,50.741520 53.911674,52.516102 55.007164,54.634987 
	C54.528961,55.474388 53.959106,55.705017 53.046383,55.642891 
	C52.565708,55.450676 52.420296,55.374512 52.501255,55.498447 
	C53.328346,56.206909 53.945896,55.962933 54.770035,55.230202 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M44.196335,67.813202 
	C43.532974,67.998207 43.094807,68.000191 42.327988,68.003288 
	C42.634655,64.920128 46.257324,63.287014 46.001469,59.383766 
	C47.488728,59.311848 49.681335,58.126591 50.351913,59.885365 
	C51.043987,61.700508 48.663795,62.225479 47.673294,63.363708 
	C46.964088,64.178688 46.594307,65.289040 46.036560,66.622086 
	C45.567905,67.421547 44.973549,67.474739 44.196335,67.813202 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M38.473640,90.333450 
	C38.378143,87.535675 39.737247,86.133766 42.949982,86.172897 
	C47.307110,90.347862 47.246815,90.996559 42.634377,93.438866 
	C41.106564,92.584869 40.579861,90.963898 38.473640,90.333450 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M28.995554,36.419792 
	C30.421160,35.830406 31.849724,35.657242 34.075523,35.387436 
	C31.997622,37.334915 33.002090,40.626064 29.318439,40.968891 
	C28.994522,39.611511 28.996517,38.223759 28.995554,36.419792 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M13.000286,42.999710 
	C15.575078,43.869232 18.320850,44.596970 17.559175,48.914062 
	C15.449383,47.290203 13.943153,45.793068 13.035204,43.350384 
	C12.999444,43.000610 13.000000,43.000000 13.000286,42.999710 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M23.513954,76.469360 
	C22.560175,75.165665 21.863960,74.079742 20.853077,72.503006 
	C23.828043,72.366356 24.899956,74.081848 25.513891,75.806679 
	C25.871975,76.812706 24.634878,76.885712 23.513954,76.469360 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M34.573746,84.559319 
	C36.019264,84.129097 37.054214,82.953430 38.521915,83.658981 
	C38.557251,85.683174 37.272041,86.578873 35.606468,86.779213 
	C34.353741,86.929893 34.035671,85.940826 34.573746,84.559319 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M18.001419,88.001450 
	C17.580986,84.797859 20.696239,84.902969 22.857800,82.337646 
	C22.813274,86.386925 20.451309,86.911407 18.350863,87.960724 
	C17.997147,87.997292 18.000000,88.000000 18.001419,88.001450 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M34.000870,94.000885 
	C33.904724,91.723091 34.557835,90.049339 37.600327,89.987312 
	C37.973183,89.972855 38.000084,90.000008 38.013336,90.013260 
	C39.015602,93.024910 38.157490,94.663498 34.386284,94.220978 
	C33.997715,93.998352 34.000000,94.000000 34.000870,94.000885 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M32.999321,51.999313 
	C32.996002,52.160648 32.979160,52.323879 32.992889,52.484501 
	C33.146755,54.285313 32.084213,55.171005 30.541945,55.581387 
	C29.867817,55.760765 29.175182,55.455711 29.213327,54.631912 
	C29.302071,52.715416 30.990244,52.607170 32.644493,52.039757 
	C33.001373,52.001289 33.000000,52.000000 32.999321,51.999313 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M40.977112,64.015656 
	C40.070244,64.840927 39.037266,65.240768 38.672871,64.321312 
	C38.139565,62.975658 39.745472,62.471249 40.420288,61.631535 
	C40.997066,60.913818 42.048317,60.865211 42.435150,61.810703 
	C42.818775,62.748360 41.613182,63.099808 40.977112,64.015656 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M18.996372,101.003632 
	C17.560806,100.968811 15.977192,101.113701 15.449564,99.339539 
	C15.261472,98.707085 15.830589,98.207016 16.570295,98.112068 
	C18.196209,97.903374 18.941202,98.673737 18.993864,100.620384 
	C19.006992,100.992973 18.999969,101.000008 18.996372,101.003632 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M27.898674,57.215019 
	C29.041113,58.083515 30.014442,59.023586 29.450735,60.164986 
	C28.938713,61.201736 27.991831,60.425133 27.478691,59.880680 
	C26.654060,59.005737 25.275986,57.953018 27.898674,57.215019 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M41.021778,75.375000 
	C42.627415,74.952492 44.032906,75.171013 43.992928,77.656517 
	C42.434349,78.012772 40.966244,77.872734 41.021778,75.375000 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M42.628288,80.015388 
	C42.994678,80.754341 42.993931,81.502541 42.996208,82.624908 
	C41.907467,82.859482 40.429852,83.265846 40.239124,81.611259 
	C40.082745,80.254585 41.228062,80.106544 42.628288,80.015388 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M43.002888,83.375885 
	C44.754063,83.009056 45.774162,84.144402 46.854607,85.707146 
	C46.034321,86.980415 44.923756,87.019379 43.362633,86.250168 
	C42.997066,85.997063 42.999893,86.000000 43.001396,86.001465 
	C43.003555,85.252335 43.004208,84.501732 43.002888,83.375885 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M29.660889,83.037430 
	C30.028921,84.587265 29.854681,86.020454 27.370810,85.992477 
	C27.000992,86.000916 27.000000,86.000000 26.999527,85.999542 
	C27.073118,84.468468 27.735313,83.404732 29.660889,83.037430 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M39.622997,71.090561 
	C39.975170,72.084167 39.986904,73.135735 39.984158,74.581268 
	C37.228245,74.150780 37.366016,72.809349 39.622997,71.090561 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M33.344204,80.988693 
	C33.127892,80.078926 32.702782,78.897018 33.950352,78.462639 
	C34.690525,78.204926 35.283985,78.741631 35.463882,79.396614 
	C35.904099,80.999367 34.598579,80.800850 33.344204,80.988693 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M35.321983,57.951389 
	C34.668716,57.103523 34.067120,56.134094 35.312805,55.514046 
	C35.630482,55.355927 36.390411,55.474297 36.553253,55.723267 
	C37.251404,56.790646 36.744007,57.503887 35.321983,57.951389 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M35.051373,60.330269 
	C35.880901,60.097565 36.933769,59.772015 37.442863,60.803398 
	C37.531967,60.983906 37.106140,61.650913 36.806675,61.747437 
	C35.899315,62.039886 35.377193,61.489853 35.051373,60.330269 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M35.003807,58.003784 
	C35.006531,58.450035 35.005444,58.892502 35.002789,59.666878 
	C35.001221,59.998779 35.000000,60.000000 34.999390,60.000610 
	C34.109741,59.870064 32.804234,60.329945 32.578308,59.090748 
	C32.371284,57.955235 33.577984,58.155842 34.650051,57.999451 
	C34.992428,57.992428 35.000000,58.000000 35.003807,58.003784 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M29.999645,82.999634 
	C30.074944,81.540359 30.919783,80.968491 32.648827,81.005463 
	C33.002495,81.002472 33.000000,81.000000 32.998856,80.998764 
	C32.907043,82.435471 32.090187,83.039711 30.353643,82.996979 
	C30.000763,83.000740 30.000000,83.000000 29.999645,82.999634 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M27.983231,79.524414 
	C27.098925,79.030815 26.994242,78.414444 27.405338,77.811745 
	C27.739851,77.321327 28.277115,77.330956 28.598028,77.828011 
	C28.992151,78.438454 28.883850,79.054031 27.983231,79.524414 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M24.939583,80.407768 
	C25.954039,80.931412 25.743008,81.515419 25.216024,82.017883 
	C25.052063,82.174210 24.512207,82.231880 24.415342,82.113335 
	C23.917959,81.504677 24.084326,80.916313 24.939583,80.407768 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M20.456451,69.612823 
	C20.684998,70.415604 20.406578,70.707100 19.781919,70.581268 
	C19.652119,70.555115 19.478119,70.372795 19.457928,70.241867 
	C19.360748,69.611656 19.666412,69.348686 20.456451,69.612823 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M7.389038,57.467319 
	C6.569666,57.699585 6.272789,57.413078 6.396304,56.777378 
	C6.421913,56.645580 6.609860,56.467484 6.743287,56.447720 
	C7.381998,56.353085 7.657923,56.659618 7.389038,57.467319 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M32.283440,73.964951 
	C32.072399,73.346565 32.083340,72.626122 32.909096,72.495338 
	C33.086414,72.467255 33.325497,72.829170 33.536125,73.011436 
	C33.217945,73.322212 32.899765,73.632996 32.283440,73.964951 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M32.006985,74.007401 
	C31.908062,74.636566 31.896175,75.349670 31.092319,75.483932 
	C30.920975,75.512550 30.685602,75.157814 30.479727,74.979683 
	C30.795914,74.676392 31.112099,74.373100 31.706791,74.027969 
	C31.985298,73.986122 31.999996,74.000061 32.006985,74.007401 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M43.782364,79.091431 
	C44.765362,79.808838 44.064468,79.865128 43.235718,79.985085 
	C43.113934,79.676125 43.301105,79.414459 43.782364,79.091431 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M44.164181,58.227859 
	C44.555305,58.153770 45.110825,58.329464 45.833298,58.751171 
	C45.443024,58.824005 44.885799,58.650822 44.164181,58.227859 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M966.079346,496.642670 
	C956.755676,496.873138 947.842529,497.013580 938.460205,497.152740 
	C936.165771,495.506714 934.155212,495.847046 931.998657,496.398224 
	C927.186401,497.628174 922.321045,497.962708 917.130615,496.430603 
	C916.541565,495.722137 916.423584,495.217285 916.592896,494.301544 
	C919.865051,491.464325 923.819824,493.369324 927.500122,491.845703 
	C928.274963,491.528473 928.714844,491.357910 929.471436,491.074646 
	C930.188477,490.793671 930.588745,490.625977 931.245911,490.275757 
	C932.539673,489.389221 933.336670,488.460693 934.142578,487.118774 
	C934.425659,486.667847 934.543762,486.488220 935.043884,485.771454 
	C935.692993,484.868195 935.971619,484.511108 936.497559,483.898010 
	C936.923462,483.484222 937.111084,483.333405 937.606018,482.985474 
	C942.808594,480.390320 947.477295,477.217041 953.692383,478.473816 
	C954.118347,482.791809 949.775269,481.992157 947.796021,484.326080 
	C946.508606,485.399506 945.436584,486.255066 944.849609,487.427582 
	C943.344727,490.433990 944.741699,492.731873 948.098999,492.603149 
	C951.874084,492.458435 955.617554,491.823700 959.384888,491.483643 
	C961.966309,491.250641 962.736389,489.602417 961.025269,486.998657 
	C960.700256,486.546509 960.582275,486.359131 960.327637,485.873444 
	C959.892517,484.791351 959.774536,483.943115 959.136841,482.981659 
	C957.667114,481.290741 954.209473,482.518860 954.521606,478.811218 
	C955.160095,477.276703 956.257568,477.044647 957.800903,477.061646 
	C958.574036,477.213501 958.991150,477.366638 959.662842,477.721558 
	C960.462036,478.139832 960.989502,478.368134 961.817566,477.790955 
	C962.915527,477.173370 963.784241,477.114594 964.996216,477.546356 
	C968.602722,481.652710 971.064697,486.580597 977.306152,487.507965 
	C982.944763,487.369598 988.185791,487.385620 993.426025,487.479858 
	C995.233521,487.512390 997.036987,487.675842 998.859070,489.178680 
	C999.466003,490.032501 999.600830,490.598358 999.429199,491.618713 
	C996.888184,494.090698 993.964233,493.424255 991.225403,493.462585 
	C982.859497,493.579590 974.381104,492.670441 966.079346,496.642670 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M916.616333,495.581268 
	C923.186279,495.698395 929.545105,496.670990 935.509766,493.948242 
	C938.613708,492.531342 937.763489,494.970428 937.991699,496.770142 
	C936.486328,498.575317 934.317078,497.945526 932.288269,498.896240 
	C925.852722,497.816406 919.849121,498.636963 913.472168,499.716400 
	C901.211609,500.929138 889.327332,501.966156 876.985840,503.048859 
	C875.968811,502.613861 875.408875,502.133148 874.600098,501.522400 
	C872.218323,500.300568 871.857971,498.951965 874.168396,497.093506 
	C879.321777,496.234497 884.095398,496.507965 888.839539,496.639709 
	C893.957703,496.781860 898.954773,495.777252 904.455688,495.558441 
	C906.587036,495.556396 908.174438,494.872681 910.262268,494.694885 
	C911.494141,494.624664 912.314819,494.647705 913.543640,494.669403 
	C914.779419,494.727539 915.561829,494.932953 916.616333,495.581268 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M966.150146,496.836670 
	C970.345459,493.076233 975.442566,491.393372 981.560059,491.969147 
	C986.948486,492.476288 992.434937,491.941803 998.332520,491.836243 
	C1004.524597,490.721649 1010.292603,491.918549 1016.459229,491.821594 
	C1016.965759,492.398163 1017.053223,492.728851 1017.205566,493.304871 
	C1000.337952,493.890472 983.641113,497.751465 966.150146,496.836670 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M913.524292,499.912445 
	C918.977417,497.021759 925.177185,497.929779 931.629639,498.634644 
	C925.932800,499.253448 919.942688,499.593109 913.524292,499.912445 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M991.371643,508.732727 
	C990.272156,508.916718 989.378418,508.924072 988.043579,508.858704 
	C988.674744,507.844513 989.650085,506.745972 990.847595,506.007507 
	C991.951416,505.326752 993.492615,504.659210 993.043030,507.627197 
	C992.953674,508.060669 992.993164,507.972168 993.040161,507.983948 
	C992.635132,508.320282 992.121704,508.479706 991.371643,508.732727 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M1019.080200,493.665405 
	C1019.094604,493.316254 1019.385864,493.200958 1019.955688,493.312012 
	C1019.944702,493.660767 1019.652283,493.781067 1019.080200,493.665405 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M941.298645,941.231079 
	C939.413147,936.920654 935.809143,939.332458 933.702271,939.396240 
	C930.714111,939.486877 928.880554,938.544922 927.481201,936.607300 
	C925.219788,933.476074 921.766418,932.802795 918.563904,932.138550 
	C913.817932,931.154114 911.348816,933.834290 910.910278,938.784180 
	C910.724243,940.884399 912.757202,944.033691 908.420166,944.974182 
	C906.918762,939.056946 907.436096,933.059143 907.629822,927.120483 
	C907.781494,922.470947 907.921387,917.818481 908.021301,913.165039 
	C908.063110,911.217773 907.681885,908.992615 910.828369,908.361572 
	C913.364929,908.671387 915.346619,908.645020 916.261963,905.804565 
	C916.294006,905.039429 916.246460,904.601746 916.050903,903.830322 
	C915.869263,903.256958 915.796509,903.021362 915.634766,902.414917 
	C914.829285,898.714783 916.916992,897.671021 920.020264,897.064331 
	C933.359375,896.337402 946.269409,896.515076 959.176697,896.512512 
	C960.991577,896.512207 962.824707,896.343994 965.040955,897.045288 
	C967.645203,898.851990 967.137451,900.913696 966.242737,903.399841 
	C958.125488,910.876038 958.493958,919.155579 962.402344,928.089844 
	C963.884705,931.478455 963.728760,935.275085 964.033569,938.899353 
	C964.286194,941.902588 962.716248,943.292297 959.636047,941.990784 
	C957.637817,941.146545 955.537842,940.651855 953.483826,940.003235 
	C951.522034,939.383850 950.313538,940.073364 948.799316,941.631104 
	C946.121094,942.628235 943.834167,942.740051 941.298645,941.231079 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M940.563965,940.991455 
	C943.376709,940.906372 945.756042,940.910950 948.571045,940.819031 
	C954.583984,938.894348 958.373840,940.232727 961.100403,945.087708 
	C962.317444,947.254944 963.468079,949.467896 964.215576,952.336914 
	C964.972168,964.857056 964.576843,976.936707 964.540833,989.013062 
	C964.530457,992.475525 963.418640,995.507874 959.988037,997.739319 
	C954.371765,999.810913 948.891785,999.288208 943.556946,999.877502 
	C939.984375,1000.272156 936.328918,999.812561 932.401123,1000.966797 
	C924.536560,998.558167 923.159912,996.911499 923.100403,989.310242 
	C923.014465,978.338501 923.120239,967.365173 923.168762,956.392578 
	C923.216797,945.533386 926.811890,941.767761 937.638977,941.180115 
	C938.468811,941.135010 939.299988,941.113586 940.563965,940.991455 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M913.749695,909.407104 
	C910.398499,909.143616 908.715637,909.720215 908.880005,913.835510 
	C909.282288,923.909241 907.313965,933.946472 908.008179,944.521118 
	C907.824158,944.984009 907.636047,944.979736 907.165894,944.965088 
	C906.966492,929.608215 907.049133,914.261658 907.303711,898.478088 
	C907.713806,897.880005 907.951965,897.718994 908.604797,897.439209 
	C912.154968,896.799988 915.282288,896.713806 918.685059,897.816040 
	C917.101746,899.051025 915.572510,900.126648 916.932556,902.894165 
	C914.144409,904.264221 913.072754,906.192749 913.749695,909.407104 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M1018.644531,682.011108 
	C1018.212463,684.473083 1020.883850,686.865112 1019.295654,689.615845 
	C1016.286804,683.364746 1016.286804,683.364746 1018.644531,682.011108 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1022.807495,661.257874 
	C1022.913879,662.837830 1023.329224,664.204102 1021.903870,666.001160 
	C1020.758972,663.792358 1020.780884,662.324219 1022.807495,661.257874 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M987.002930,671.997070 
	C985.989685,671.890442 984.637634,672.428467 984.395386,670.798523 
	C984.348206,670.480652 984.816833,669.845825 985.155457,669.753601 
	C986.479797,669.392822 986.634949,670.494324 986.961182,671.688599 
	C986.994568,672.005615 987.000000,672.000000 987.002930,671.997070 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M1019.305908,681.998901 
	C1019.117188,681.186584 1019.220825,680.279602 1020.326721,680.397644 
	C1020.661560,680.433350 1020.937927,681.017883 1021.241089,681.351074 
	C1020.697998,681.566589 1020.154968,681.782166 1019.305908,681.998901 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M974.010742,675.674927 
	C973.679443,675.541687 973.353210,675.091309 973.041687,674.343384 
	C973.056458,674.045776 973.483948,674.029053 973.696411,674.045227 
	C973.944397,674.493530 973.980042,674.925720 974.010742,675.674927 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1016.993164,660.248413 
	C1017.100037,660.411438 1017.047607,660.575439 1016.995239,660.739380 
	C1016.941406,660.576050 1016.887634,660.412659 1016.993164,660.248413 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M1018.000244,694.000000 
	C1018.118286,694.136963 1018.236084,694.273987 1018.353882,694.411011 
	C1018.271484,694.363159 1018.189026,694.315308 1018.053284,694.133911 
	C1018.000000,694.000366 1018.000000,694.000000 1018.000244,694.000000 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M1014.545776,679.472778 
	C1014.575439,679.523804 1014.516113,679.421692 1014.545776,679.472778 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M984.423340,680.544922 
	C984.366272,680.460693 984.591309,680.429810 984.591309,680.429810 
	C984.591309,680.429810 984.480347,680.629211 984.423340,680.544922 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M981.554443,681.576538 
	C981.473694,681.631531 981.444031,681.415405 981.444031,681.415405 
	C981.444031,681.415405 981.635193,681.521545 981.554443,681.576538 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M982.000000,35.000153 
	C983.508301,35.082798 985.579346,35.075920 984.594727,37.297775 
	C983.791138,39.111073 982.833984,41.887032 979.510620,40.447433 
	C979.844238,38.486225 982.471313,37.907421 981.993530,35.367519 
	C982.000000,34.999695 982.000000,35.000000 982.000000,35.000153 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M983.200317,43.292030 
	C985.031860,41.613670 985.962524,42.892742 986.718201,44.188568 
	C987.081177,44.811001 986.636475,45.561268 985.911926,45.715500 
	C984.263794,46.066288 983.455078,45.138302 983.200317,43.292030 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M1019.001221,25.998661 
	C1020.154297,26.087933 1021.235168,26.354357 1021.536499,27.653591 
	C1021.591858,27.892136 1021.067932,28.533419 1020.822510,28.527479 
	C1019.677307,28.499773 1019.311829,27.601301 1019.031006,26.327065 
	C1018.997559,26.002823 1019.000000,26.000000 1019.001221,25.998661 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M1023.453125,21.529278 
	C1023.422791,21.477230 1023.483398,21.581324 1023.453125,21.529278 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M106.141228,120.506378 
	C105.512680,121.112007 104.996758,121.388046 104.241409,121.833786 
	C101.783859,122.356873 98.426178,120.628357 99.290474,125.743591 
	C99.658051,127.918999 95.546783,127.672905 93.966454,129.224182 
	C91.281281,131.860016 91.349129,127.049850 89.178726,127.812683 
	C88.418381,128.086075 88.018677,127.974663 87.591721,127.281456 
	C87.495255,126.738800 87.508087,126.515762 87.651703,125.986771 
	C89.089180,124.488213 89.895798,123.030457 90.210800,120.951401 
	C90.761490,118.108665 93.970901,116.696648 93.114960,113.299858 
	C93.095383,111.990700 93.363472,111.112015 94.207413,110.090027 
	C95.781761,108.923790 97.115433,108.015739 99.001221,107.472870 
	C99.559143,107.544563 99.773087,107.622925 100.202164,107.964828 
	C101.015968,109.954140 99.756592,111.152756 99.085007,112.840485 
	C98.699020,113.922646 98.681297,114.682922 99.400711,115.639244 
	C99.771439,116.266937 99.963310,116.639931 100.289810,117.301636 
	C101.643097,119.307434 103.744240,118.429565 105.562050,119.422928 
	C105.990959,119.793976 106.122398,119.985382 106.141228,120.506378 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M104.003479,123.567650 
	C118.125824,120.904922 131.737976,116.797050 145.592148,113.746407 
	C149.125000,112.968483 152.655273,112.178871 156.624420,111.335159 
	C157.837921,113.551254 156.154282,113.631683 154.686981,114.022621 
	C143.009888,117.133797 131.240143,119.864441 119.262802,122.996918 
	C118.541512,123.566086 118.039192,123.780624 117.255310,123.977081 
	C113.075058,124.151695 109.301956,125.372826 105.012749,125.233841 
	C104.645531,125.092804 104.418800,125.267433 104.303299,125.183083 
	C104.091309,124.696442 103.994812,124.294151 104.003479,123.567650 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M71.079910,134.965164 
	C64.611351,137.506378 58.205891,139.180511 51.347511,140.615112 
	C50.868240,140.403305 50.769699,140.172226 50.804604,139.588715 
	C53.674889,139.837387 53.814167,137.789276 54.176090,136.021866 
	C54.575146,134.073151 56.006714,132.709702 57.622559,132.398453 
	C59.192261,132.096100 59.306248,134.109039 59.645699,135.306305 
	C59.981983,136.492416 60.713581,136.892029 61.804642,136.834534 
	C63.038048,136.769547 63.585228,135.656921 63.628521,134.828964 
	C63.758041,132.351974 65.032387,130.982330 67.346077,129.952759 
	C67.644478,131.249710 67.884842,132.310944 68.148094,133.366486 
	C68.156860,133.401672 68.468384,133.435074 68.516762,133.373474 
	C68.695000,133.146530 68.821823,132.879196 69.065430,132.304825 
	C70.267570,131.125259 71.010391,131.744293 71.970367,132.863892 
	C72.246300,133.124664 72.509834,133.357620 72.457535,133.525543 
	C71.996353,133.972290 71.628761,134.297729 71.079910,134.965164 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M19.766464,148.303696 
	C18.670969,153.408508 13.568776,152.124893 10.398511,154.093903 
	C9.943980,154.376205 9.119571,153.620987 9.219915,152.867020 
	C9.473271,150.963379 8.641394,148.734024 10.580133,147.301956 
	C11.391065,146.702942 12.515244,146.467834 13.342529,147.264084 
	C14.156640,148.047653 14.757584,149.052704 15.074905,149.467529 
	C17.776993,151.388168 15.860636,143.374176 19.766464,148.303696 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M78.956924,118.461639 
	C78.952644,118.090492 79.127411,117.758820 79.299744,117.685059 
	C81.234833,117.869308 80.875435,119.348938 81.101074,120.820129 
	C80.989326,121.576500 80.846718,121.971146 80.389053,122.482651 
	C80.236511,122.794136 80.313278,122.955025 80.596733,123.285179 
	C81.297226,123.722977 81.827202,123.885536 82.675606,124.057663 
	C83.381729,124.252129 83.757195,124.444153 84.317749,124.944435 
	C84.823822,125.836449 84.890205,126.500671 84.712448,127.517776 
	C84.530220,128.054977 84.434456,128.260910 84.156738,128.751526 
	C83.323051,129.943329 83.024887,131.055878 82.132828,132.209167 
	C81.502647,132.670425 81.039017,132.842667 80.319016,133.022003 
	C77.445122,131.533569 79.061951,128.311432 77.077988,126.212921 
	C75.373894,124.559219 76.081383,123.273125 77.344849,122.453209 
	C78.780365,121.521645 79.068573,120.326324 78.956924,118.461639 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M50.829971,138.900574 
	C50.922459,139.547134 50.921070,139.858047 50.950333,140.401703 
	C48.597389,141.059708 46.227997,141.485016 43.458122,141.866241 
	C42.910316,141.695602 42.762993,141.569077 42.810474,141.225952 
	C45.876812,139.844650 48.271549,138.344940 47.829449,134.637817 
	C47.736721,133.860260 47.675583,132.742554 48.798878,132.700073 
	C49.951630,132.656479 50.669601,133.621048 50.448917,134.675400 
	C50.161724,136.047470 50.188675,137.298111 50.829971,138.900574 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M42.630844,141.017944 
	C43.005280,141.009369 43.096821,141.411560 43.077232,141.616852 
	C39.373299,145.973770 34.056225,144.028702 29.548708,146.149582 
	C29.537359,143.540192 31.558733,143.486023 32.575909,142.157501 
	C33.234310,141.648514 33.677780,141.496109 34.493378,141.734772 
	C37.621914,144.383575 39.723026,140.935989 42.630844,141.017944 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M84.148376,128.123413 
	C84.134651,127.086235 84.038666,126.373047 83.886467,125.303940 
	C87.070992,121.510582 86.602058,125.695076 87.827171,127.148544 
	C88.115219,127.738007 88.288292,127.881859 88.714691,127.951340 
	C89.338455,131.304108 87.086357,131.528824 84.334297,131.626526 
	C83.859131,131.449539 83.757843,131.254593 83.649292,130.728287 
	C83.696342,129.728149 83.851112,129.081223 84.148376,128.123413 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M20.369652,148.656006 
	C20.047194,148.430359 20.048903,148.492920 20.072853,148.512817 
	C22.304966,146.715607 20.305716,145.478806 19.141768,143.666489 
	C21.422331,143.504700 23.700874,141.639328 24.449560,145.452301 
	C25.086882,148.698105 22.899508,148.786072 20.369652,148.656006 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M5.039759,150.886856 
	C5.035941,150.514313 4.961698,150.402283 4.940872,150.341019 
	C7.827651,154.892670 7.827651,154.892670 3.402154,156.155182 
	C1.339669,153.644196 5.391320,153.327713 5.039759,150.886856 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M13.876517,135.881622 
	C13.850227,135.029190 13.911567,134.450516 13.987457,133.436920 
	C15.550700,132.913467 16.454309,134.080902 17.884937,134.976257 
	C17.314575,137.614258 16.196049,139.157227 13.876517,135.881622 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M76.843399,126.376480 
	C80.935349,126.532867 77.868652,130.664551 79.980942,132.646210 
	C79.251854,133.399673 78.305534,134.393661 77.971748,132.573502 
	C77.616600,130.636887 77.260788,128.700378 76.843399,126.376480 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M72.139389,132.767685 
	C71.432701,132.785278 70.619102,132.445877 69.484192,132.044540 
	C69.142868,131.180298 69.057335,130.273315 70.170715,130.183960 
	C71.759712,130.056488 71.848579,131.299789 72.139389,132.767685 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M74.082558,131.635712 
	C75.910805,130.846481 75.676575,132.340942 75.909775,133.294815 
	C75.946396,133.444626 75.226585,134.019058 74.929619,133.968430 
	C73.766228,133.770126 74.117142,132.765198 74.082558,131.635712 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M84.155228,130.738571 
	C83.987160,131.036682 83.921158,131.338257 83.940788,131.491379 
	C83.534599,131.872528 83.108780,132.100555 82.324615,132.413376 
	C82.396790,131.079239 80.934761,129.506866 82.755920,128.071213 
	C83.773392,128.705368 84.125168,129.537704 84.155228,130.738571 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M34.893402,141.607727 
	C34.367832,141.989151 33.934929,142.040894 33.178825,142.041016 
	C32.902699,140.973099 32.989918,139.762039 34.136337,139.584579 
	C35.445698,139.381897 35.036324,140.528122 34.893402,141.607727 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M71.266930,135.138519 
	C71.154625,134.864487 71.451897,134.468460 72.077194,133.882950 
	C72.539375,134.342163 72.296562,134.783234 71.266930,135.138519 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M46.771229,118.447113 
	C46.561821,118.201218 46.494423,117.938927 46.427021,117.676636 
	C46.564259,117.720566 46.701492,117.764503 46.950565,117.997635 
	C47.062401,118.186829 46.913235,118.430725 46.771229,118.447113 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M23.131004,969.549438 
	C18.772984,969.018494 20.554075,965.453979 19.997944,962.446167 
	C18.942238,961.154602 18.589611,959.863953 17.793282,958.466492 
	C17.635225,957.949402 17.612677,957.731384 17.796818,957.257568 
	C20.283991,956.937683 19.962299,955.294800 19.969143,953.810669 
	C20.029734,940.673645 20.045923,927.535950 20.208885,914.400085 
	C20.254478,910.724915 18.616089,909.370850 15.104957,909.419434 
	C12.669282,909.453125 10.227814,909.067871 7.765969,908.124451 
	C12.437082,906.738831 17.230225,906.796204 21.967911,907.282898 
	C23.485321,907.438782 22.998095,909.522583 23.113743,910.768799 
	C24.361156,924.211426 23.709211,937.680847 23.592316,951.141418 
	C23.540369,957.123047 23.337465,963.103333 23.131004,969.549438 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M20.783936,850.338623 
	C21.532455,849.782227 21.990473,849.515625 22.688702,849.137695 
	C24.463146,862.061646 23.535395,875.143250 23.595436,888.203674 
	C23.617443,892.991089 23.089767,897.781067 22.515421,902.844788 
	C21.830601,903.384460 21.429550,903.394592 20.765724,902.975464 
	C19.947342,902.115723 19.532160,901.352783 18.815388,900.409851 
	C18.509165,899.715942 18.475063,899.290955 18.758064,898.602417 
	C21.426121,896.957642 20.595852,894.537292 20.602728,892.522827 
	C20.648628,879.072205 20.572805,865.621155 20.606236,851.799500 
	C20.615118,851.161987 20.554274,850.895264 20.783936,850.338623 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M3.197825,888.273438 
	C3.022916,887.894836 3.129078,887.702393 3.264844,887.678589 
	C9.874094,886.519165 9.811084,886.520874 9.791756,879.229858 
	C9.769402,870.797791 9.873057,862.365479 9.980755,853.467773 
	C10.255643,852.886353 10.471782,852.770386 10.995776,852.855896 
	C12.395627,864.414185 11.668971,875.806763 11.969843,887.179321 
	C12.016942,888.959534 11.554624,889.988098 9.346625,889.379883 
	C7.461137,888.860413 5.448892,888.801086 3.197825,888.273438 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M23.693901,975.328857 
	C24.358782,975.086914 24.833906,975.047363 25.665409,974.974731 
	C26.795383,975.296509 27.568979,975.651306 28.663944,976.034302 
	C30.161098,975.762939 31.338224,975.800659 32.871502,976.119629 
	C34.417362,976.494141 35.609882,976.789368 37.181870,977.163330 
	C39.748631,978.260010 42.295074,978.985291 41.100712,982.598511 
	C36.809277,984.213745 33.813396,982.020752 30.389679,979.985107 
	C29.401716,979.947388 28.858440,979.755066 28.253307,979.078857 
	C26.923927,978.257263 25.739519,977.694641 24.226345,977.088135 
	C23.782919,976.899658 23.668259,976.755005 23.477955,976.343506 
	C23.436258,975.895020 23.470201,975.713196 23.693901,975.328857 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M31.676701,834.646484 
	C31.748854,836.076904 31.673273,837.153259 31.454845,838.609619 
	C29.363541,839.726135 30.195724,841.447693 29.999792,843.118286 
	C29.683161,844.601135 28.716244,844.553467 27.354473,844.441345 
	C26.916967,844.293396 27.111506,844.074646 27.084412,843.930786 
	C26.879622,843.696167 26.701925,843.605347 26.375416,843.254822 
	C26.155579,840.329590 26.084557,837.664001 26.029892,834.555237 
	C26.998642,832.953308 28.245270,832.970886 29.918087,833.354126 
	C30.803911,833.585510 31.219328,833.858521 31.676701,834.646484 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M26.489262,928.038574 
	C33.731049,927.881226 40.866009,928.000366 48.460556,928.151367 
	C48.429691,930.645752 46.432789,929.901917 44.947495,929.918640 
	C39.188725,929.983582 33.428516,929.921509 27.179750,929.950928 
	C26.587915,929.435120 26.485176,928.875061 26.489262,928.038574 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M20.587387,901.679199 
	C21.151167,902.219299 21.411768,902.529297 21.945187,902.979492 
	C22.198608,904.647400 21.322014,905.126770 19.941822,904.960144 
	C16.526794,904.547913 13.014230,905.842651 9.550820,904.002441 
	C9.259490,901.821716 9.673993,899.767578 11.781261,900.395203 
	C14.624025,901.241821 17.611847,899.994080 20.587387,901.679199 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M23.003353,846.531738 
	C20.990566,846.806885 19.913616,845.680847 20.059908,843.780823 
	C20.313101,840.492126 20.328259,837.117371 22.582905,834.094238 
	C22.992531,838.029175 23.029736,842.051025 23.003353,846.531738 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M20.854906,901.588379 
	C17.730400,901.692017 14.464784,903.608582 11.354623,901.285583 
	C10.850995,900.909424 10.116209,902.100525 9.638764,903.263367 
	C8.213259,902.919739 7.224938,902.061951 7.698791,900.207275 
	C11.183041,898.282471 14.666924,899.368347 18.495569,899.576172 
	C19.787340,899.980652 20.619558,900.209534 20.854906,901.588379 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M22.890411,825.195312 
	C25.722584,826.203918 26.061846,828.412598 26.187233,831.127441 
	C26.310076,831.767822 26.429876,832.036987 26.275871,832.653076 
	C25.300842,832.692871 24.599617,832.385742 23.614552,832.042175 
	C23.234785,831.488037 23.138857,830.970398 22.856106,830.263794 
	C22.325701,829.442078 21.982113,828.809204 21.320507,827.984619 
	C20.425501,826.815491 20.186258,825.791870 20.943062,824.279785 
	C22.099422,823.776611 22.497902,824.288086 22.890411,825.195312 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M12.933815,946.483276 
	C11.251394,939.903564 12.256709,932.796509 12.603626,925.391235 
	C12.898062,932.054077 12.943472,939.037476 12.933815,946.483276 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M18.934059,899.568115 
	C15.542300,899.873413 12.174511,899.935974 8.340240,899.989990 
	C7.428348,898.029846 8.588982,897.770508 10.103769,897.836426 
	C12.792293,897.953552 15.481920,898.045288 18.564545,898.247192 
	C18.949127,898.673035 18.949137,898.999207 18.934059,899.568115 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M33.239563,976.759644 
	C31.805786,976.938110 30.644100,976.746887 29.233877,976.309082 
	C29.261379,975.194397 29.537418,974.326294 29.948671,973.139893 
	C30.935839,972.978455 31.787794,973.135315 32.863266,973.530518 
	C33.595840,974.583069 33.814648,975.444275 33.239563,976.759644 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M20.811205,849.767944 
	C21.021887,850.282104 20.969336,850.515381 20.796371,851.088745 
	C18.958145,850.501099 17.231789,851.699402 15.248732,851.237488 
	C16.041601,847.729614 18.422571,849.058228 20.811205,849.767944 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M17.594662,956.958618 
	C18.031202,957.197815 18.058897,957.393738 18.095196,957.886475 
	C17.686558,958.586792 17.203096,958.882141 16.234324,959.161865 
	C14.362720,959.425964 12.957557,959.335144 11.345650,958.253784 
	C10.071357,957.876587 9.134252,957.760742 8.087663,957.306885 
	C9.398081,956.946777 10.817984,956.924561 12.661818,956.848755 
	C14.452438,956.835144 15.819128,956.875183 17.594662,956.958618 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M26.009665,833.278137 
	C26.027748,832.749146 26.053448,832.498230 26.134714,831.872925 
	C27.840483,831.947876 29.490688,832.397156 31.505951,832.834717 
	C31.897652,833.021118 31.924295,833.219238 31.970207,833.716675 
	C31.834576,834.141052 31.679680,834.266052 31.260931,834.251221 
	C29.621056,834.083069 28.245033,834.054688 26.457630,834.069153 
	C26.036594,833.926819 26.026939,833.741577 26.009665,833.278137 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M26.941944,844.526794 
	C27.681534,843.999390 28.446104,843.705444 29.622757,843.427734 
	C30.187807,845.131165 28.922396,845.449829 27.360851,845.767273 
	C26.997465,845.385437 26.988178,845.072632 26.941944,844.526794 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M11.496347,852.755371 
	C11.023762,853.041016 10.743808,853.026184 10.251642,853.007690 
	C9.956181,852.595886 9.872849,852.189453 9.719028,851.480530 
	C10.219795,851.136536 10.791050,851.095093 11.790310,851.090515 
	C12.041898,851.569397 11.865480,852.011414 11.496347,852.755371 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M26.186539,843.284302 
	C26.498772,843.058105 26.717678,843.202087 26.970314,843.607056 
	C26.753702,843.715881 26.450090,843.644714 26.186539,843.284302 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M959.924011,997.907959 
	C962.327576,994.527832 963.276611,990.716736 963.169006,986.337036 
	C962.895447,975.197388 962.946594,964.049866 962.859253,952.434326 
	C967.219910,952.304993 967.861450,955.658569 968.292908,958.966125 
	C968.786377,962.748413 968.115784,966.609558 968.883972,970.393494 
	C967.791626,965.417542 968.680664,960.356628 969.165466,955.502502 
	C969.773193,949.417725 969.322937,943.201233 970.922913,937.212708 
	C971.713989,934.251953 971.326904,931.295349 970.982483,928.301819 
	C970.731384,926.119568 969.989197,923.487122 973.596313,922.645264 
	C974.798157,923.618530 974.278748,924.819824 974.897339,926.151917 
	C977.159363,932.663025 975.596313,938.974304 975.806030,945.663391 
	C972.900085,947.119629 974.122620,949.517639 974.105896,951.255005 
	C973.972351,965.185669 973.999084,979.117920 973.950012,993.515625 
	C972.779602,993.906006 972.426025,993.004700 971.785034,992.235046 
	C970.205750,990.338989 968.532959,990.458374 968.120483,993.095398 
	C967.704346,995.755676 968.187683,998.725037 963.806091,996.707825 
	C963.015503,996.343811 961.810303,998.322510 959.924011,997.907959 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M966.145142,1019.182617 
	C968.381531,1019.198486 969.072083,1020.350769 968.760437,1022.002197 
	C968.508057,1023.339783 967.258911,1023.115417 966.443298,1022.758362 
	C964.697388,1021.994141 964.688965,1020.700623 966.145142,1019.182617 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M22.002823,32.627853 
	C18.381943,33.109943 18.453396,29.267775 16.405396,27.681324 
	C16.280674,27.584711 16.791149,26.479490 17.172419,25.967422 
	C17.619621,25.366804 18.320957,25.228630 18.758667,25.984972 
	C21.058989,29.959805 22.071779,26.876003 23.530960,25.223028 
	C27.066196,21.218283 28.698076,21.418430 31.679087,26.037968 
	C27.243080,24.947292 23.996220,27.035227 22.002823,32.627853 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M28.998966,33.001068 
	C27.451443,32.598831 24.376322,34.022255 25.564106,30.320419 
	C25.944660,29.134384 27.300690,28.834518 28.480553,29.147186 
	C30.721235,29.740973 29.054897,31.201735 29.039896,32.643955 
	C29.002182,32.997864 29.000000,33.000000 28.998966,33.001068 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M22.000023,32.997803 
	C22.970116,33.132339 23.917452,33.361904 23.799320,34.616192 
	C23.769224,34.935741 23.247437,35.482670 22.993296,35.459877 
	C21.914083,35.363071 22.128283,34.401703 22.000160,33.341690 
	C21.995499,33.000000 22.000046,33.000031 22.000023,32.997803 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M48.659904,21.002274 
	C48.855175,22.055811 48.559021,23.020807 47.218285,22.809454 
	C46.461174,22.690100 46.155430,22.149294 46.768726,21.189432 
	C47.438885,20.997665 47.882935,20.999203 48.659904,21.002274 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M913.079468,542.155334 
	C922.300110,540.471680 931.759338,541.462891 941.646606,541.116211 
	C942.913818,541.688538 943.837280,541.421509 944.907898,541.854004 
	C935.386047,543.842896 925.553589,542.627869 915.292603,542.901367 
	C914.359802,542.441284 913.775757,542.501160 913.079468,542.155334 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M980.867004,556.651855 
	C980.444763,556.981812 980.050537,556.960999 979.360107,556.968384 
	C978.890747,556.042358 978.746582,555.081787 978.539246,554.134949 
	C977.695862,550.283020 978.865784,548.181580 983.995178,548.636841 
	C981.093872,550.877991 982.992126,554.190063 980.867004,556.651855 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M945.587891,542.120117 
	C944.281006,541.940918 943.431702,541.782715 942.350342,541.403931 
	C951.387207,540.947205 960.656189,540.710938 970.314392,540.463623 
	C971.198853,540.569641 971.416504,540.891052 971.147217,541.623474 
	C962.615845,541.951843 954.330688,542.046448 945.587891,542.120117 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M919.474792,555.157471 
	C919.042419,554.868408 918.875916,554.596130 918.413818,554.263184 
	C916.939026,548.655273 920.792053,549.297791 924.432434,549.200439 
	C925.986572,551.408325 923.485840,553.160400 923.881592,555.698364 
	C923.834778,556.075134 923.437744,556.054138 923.238953,556.049377 
	C922.039307,555.485107 921.591187,552.989990 919.474792,555.157471 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M952.913940,555.651001 
	C951.563660,555.963623 950.086792,556.111572 949.465393,554.022705 
	C949.497375,552.323792 947.619629,549.929199 950.688904,549.598083 
	C954.025513,549.238159 951.873047,552.141663 952.657288,553.351501 
	C952.975647,553.842712 952.831299,554.633728 952.913940,555.651001 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M990.001709,553.120056 
	C988.242188,551.869202 987.217773,550.567200 988.170959,548.792786 
	C988.888184,547.457336 990.284241,548.331238 991.288940,548.529602 
	C993.827026,549.030457 992.875488,550.852539 992.457825,552.811035 
	C991.701416,553.679199 990.990662,553.716125 990.001709,553.120056 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M916.831299,555.894348 
	C915.554932,559.206238 913.174805,557.436584 911.364502,556.757385 
	C910.183044,556.314209 911.037415,555.213257 912.371216,554.629517 
	C913.498291,556.632629 915.993652,553.134521 916.831299,555.894348 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M969.371582,554.209473 
	C968.981445,553.684204 968.684814,553.234497 968.789551,553.101929 
	C970.017639,551.547119 966.459106,550.519104 968.341553,549.039551 
	C968.738586,548.727539 969.654968,548.792725 970.204834,549.008362 
	C972.415527,549.875122 970.341919,551.850159 971.050781,553.546509 
	C970.575378,554.344299 970.146790,554.483154 969.371582,554.209473 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M1010.435303,552.018188 
	C1010.075012,551.215759 1010.099792,550.379028 1010.164185,549.125366 
	C1011.134277,548.708862 1012.376770,546.963318 1012.902100,548.781982 
	C1013.302612,550.168457 1013.483337,552.212891 1010.435303,552.018188 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M989.406799,552.846313 
	C990.403992,552.986755 991.055847,553.133362 992.043213,553.254028 
	C992.505615,553.588745 992.632629,553.949463 992.752075,554.603882 
	C992.318054,554.925537 991.891479,554.953491 991.149292,555.039795 
	C990.220886,555.764893 989.449890,556.114319 988.364258,555.972534 
	C988.250000,554.693359 987.293701,553.346619 989.406799,552.846313 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M931.310425,550.766541 
	C930.818970,552.041260 931.461670,554.002747 929.873596,553.662415 
	C928.083679,553.278992 929.181885,551.237549 929.145813,549.565308 
	C929.790466,549.313904 930.260803,549.426270 930.886719,549.727295 
	C931.206360,550.100952 931.370239,550.285889 931.310425,550.766541 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M912.477966,541.907288 
	C913.428833,542.098022 913.940735,542.268494 914.635010,542.633789 
	C912.434448,542.835938 910.051453,542.843323 907.261108,542.649780 
	C906.853699,542.448853 906.910278,542.487122 906.881592,542.506226 
	C908.487610,541.548767 910.307983,542.081055 912.477966,541.907288 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M1013.202271,556.450073 
	C1012.122864,555.946350 1010.796997,558.278931 1009.937500,556.340881 
	C1009.780518,555.987000 1009.871277,555.278992 1010.131287,555.027161 
	C1011.176819,554.014465 1011.596924,555.624878 1012.809814,555.591919 
	C1013.284546,555.753906 1013.301697,556.006836 1013.202271,556.450073 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M931.369385,550.976379 
	C931.069092,550.871643 931.051270,550.681091 931.037964,550.203247 
	C932.146851,549.623535 933.251282,549.331116 934.703857,549.012878 
	C935.971741,553.288879 932.547729,549.831787 931.369385,550.976379 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M939.058594,551.672852 
	C938.810425,552.237671 938.527039,552.439148 938.101074,552.863892 
	C936.893311,552.197754 936.875916,550.961487 936.922729,549.367737 
	C938.564026,548.991272 939.099365,549.881653 939.058594,551.672852 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M971.214478,541.925049 
	C970.951416,541.535095 970.927368,541.218628 970.766235,540.680237 
	C971.529846,540.295654 972.356079,540.138794 973.603271,540.015930 
	C974.010864,540.299316 973.997437,540.548706 973.956421,541.175354 
	C973.128540,541.699402 972.328247,541.846191 971.214478,541.925049 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M943.400757,553.879333 
	C943.489868,552.797607 943.946594,551.739319 944.603271,550.475586 
	C944.592529,551.519287 946.106445,553.259705 943.400757,553.879333 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M988.098633,555.993652 
	C988.869873,555.498535 989.574036,555.282532 990.555908,555.082397 
	C991.295105,557.132446 989.920593,556.905273 988.313843,556.842957 
	C987.974365,556.651306 988.002930,556.462036 988.098633,555.993652 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M942.504883,549.159668 
	C942.854919,550.273376 942.284180,551.118042 941.200562,551.926880 
	C940.953552,550.890808 940.522095,549.568176 942.504883,549.159668 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M969.045288,554.319092 
	C969.499573,553.992310 969.907471,553.997986 970.620728,553.993896 
	C970.947510,554.427917 970.968933,554.871765 970.916138,555.640747 
	C970.468262,555.973938 970.094727,555.981995 969.443604,555.976196 
	C969.110352,555.525391 969.054626,555.088562 969.045288,554.319092 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M916.544556,551.566956 
	C916.479492,551.609131 916.609680,551.524780 916.544556,551.566956 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M959.933228,555.758789 
	C959.869019,555.910828 959.682983,555.933533 959.217651,555.924072 
	C959.229431,555.804443 959.520386,555.716980 959.933228,555.758789 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M13.976791,132.684998 
	C11.506914,133.397537 11.581908,131.193253 10.516758,129.961288 
	C9.406963,128.677704 7.868400,127.119484 5.377189,127.003586 
	C5.003836,125.935379 5.006858,124.871681 5.010107,123.398407 
	C10.425521,119.429504 13.860879,125.506081 18.495476,125.760826 
	C17.914057,128.603882 12.996713,128.472122 13.976791,132.684998 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M43.001297,86.344650 
	C44.064816,86.000519 45.132561,86.003967 46.600689,86.004791 
	C47.001068,86.002159 47.000000,86.000000 46.998951,85.999100 
	C47.848862,87.020172 47.974987,88.371834 48.795189,89.750046 
	C48.999390,89.999413 49.000000,90.000000 49.000229,90.000305 
	C49.528648,90.543159 49.743423,91.195877 49.589134,92.273376 
	C49.458683,94.093628 45.794281,93.822449 47.937332,96.487244 
	C48.916077,97.500137 49.229206,98.519768 49.803856,99.753448 
	C50.000263,100.001221 50.000000,100.000000 49.999371,99.999695 
	C49.365711,102.619789 48.354328,102.296089 46.750687,100.613602 
	C45.336292,99.129692 44.108105,97.227638 41.154060,96.747902 
	C40.254665,95.542831 40.535526,94.700356 41.494293,93.444077 
	C47.995903,91.802994 43.568230,88.939011 43.001297,86.344650 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M34.122833,94.293488 
	C36.452232,94.291740 37.404106,92.768089 37.982502,90.383011 
	C40.016029,89.594315 42.460285,88.354172 42.001198,92.633926 
	C41.997894,93.002075 42.000000,93.000000 42.001087,92.998962 
	C41.147522,93.974335 39.758514,94.434448 39.138580,96.087395 
	C38.844933,96.562965 38.713207,96.745247 38.331047,97.156036 
	C37.463612,97.724258 36.805244,97.821213 35.557648,97.360710 
	C34.750793,96.197273 34.499371,95.392952 34.122833,94.293488 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M41.001385,97.001373 
	C41.083385,98.628647 40.830032,100.000893 38.131714,99.742386 
	C37.229221,98.838936 37.226429,98.175484 37.772533,97.257797 
	C38.000168,96.999832 37.999847,97.000000 37.998383,97.001564 
	C38.681698,96.422783 39.454189,96.270576 40.654064,96.763184 
	C40.997307,96.997253 40.999912,97.000000 41.001385,97.001373 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M23.999043,91.998993 
	C23.909920,93.173164 23.602486,94.285980 22.310232,94.578598 
	C21.624033,94.733978 21.106209,94.182869 21.181665,93.433578 
	C21.308857,92.170563 22.314648,92.087097 23.646164,92.009575 
	C24.002028,92.002007 24.000000,92.000000 23.999043,91.998993 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M22.998627,101.001373 
	C23.921329,101.117332 25.100965,100.681969 25.530121,101.944794 
	C25.781822,102.685463 25.253365,103.282173 24.597330,103.459946 
	C23.019165,103.887589 23.162237,102.621338 23.005278,101.341797 
	C23.002735,100.997253 23.000000,101.000000 22.998627,101.001373 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M17.624985,114.004723 
	C17.905920,115.135750 17.653511,116.324837 16.395462,116.550575 
	C15.040318,116.793716 15.108224,115.590866 15.005008,114.344284 
	C15.747814,114.004265 16.498018,114.005981 17.624985,114.004723 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M19.078758,119.614838 
	C17.995884,119.388451 17.310015,118.953148 17.798180,117.998306 
	C18.096525,117.414742 18.821783,117.102119 19.378004,117.529999 
	C20.121332,118.101814 19.986603,118.874962 19.078758,119.614838 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M35.350060,99.425331 
	C34.109928,99.867134 32.816669,100.358704 32.546909,99.125259 
	C32.278961,97.900101 33.719292,97.842766 34.703911,97.134949 
	C35.002220,97.001602 35.000000,97.000000 34.999931,96.999931 
	C35.536278,97.502151 35.761559,98.122185 35.350060,99.425331 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M10.552692,116.330635 
	C9.436802,116.792908 8.716934,116.419968 8.653215,115.535194 
	C8.626657,115.166397 9.404413,114.405273 9.817192,114.404747 
	C10.868333,114.403397 10.905855,115.265907 10.552692,116.330635 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M3.127468,114.378639 
	C4.182447,114.770699 4.848955,115.262253 4.472507,116.249115 
	C4.398342,116.443550 3.843130,116.660538 3.651914,116.569283 
	C2.726884,116.127838 1.843767,115.587158 3.127468,114.378639 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M38.000694,100.000763 
	C37.489258,102.208778 36.571014,102.651428 35.047409,100.335213 
	C34.999847,100.000000 35.000000,100.000000 35.000004,100.000000 
	C35.685966,99.421700 36.458576,99.270424 37.657272,99.765129 
	C37.999924,99.999924 38.000000,100.000000 38.000694,100.000763 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M11.321945,109.494812 
	C11.510139,110.939049 10.736962,110.944641 9.890769,110.643242 
	C9.691170,110.572136 9.457631,110.062164 9.530172,109.856575 
	C9.798883,109.095009 10.441645,109.093048 11.321945,109.494812 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M5.999056,111.657944 
	C5.040672,111.850517 4.075319,111.641212 4.200806,110.377838 
	C4.232536,110.058380 4.758281,109.514702 5.014129,109.538338 
	C6.093517,109.638046 5.878128,110.597923 5.999056,111.657944 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M21.328625,105.492401 
	C21.512093,106.934319 20.743334,106.963120 19.885084,106.658234 
	C19.685596,106.587364 19.453804,106.072685 19.527109,105.864349 
	C19.795946,105.100311 20.440102,105.086189 21.328625,105.492401 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M17.999193,113.999130 
	C18.150183,113.035484 18.374542,112.078712 19.633060,112.208282 
	C19.952929,112.241211 20.497049,112.764145 20.472080,113.015671 
	C20.364929,114.094963 19.405634,113.870323 18.343941,113.994202 
	C18.001747,114.001747 18.000000,114.000000 17.999193,113.999130 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M23.292873,116.517990 
	C22.403576,116.887062 21.759161,116.871231 21.511530,116.102806 
	C21.444719,115.895477 21.691267,115.391609 21.891001,115.327866 
	C22.744930,115.055313 23.516607,115.087288 23.292873,116.517990 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M6.051086,118.383530 
	C6.799045,118.787781 6.791879,119.196983 6.272117,119.559082 
	C6.162147,119.635696 5.904265,119.635292 5.796752,119.557205 
	C5.278813,119.180939 5.301590,118.772118 6.051086,118.383530 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M12.530131,119.386978 
	C12.295985,118.566780 12.588013,118.276443 13.220390,118.399437 
	C13.352662,118.425156 13.531838,118.611107 13.551950,118.744019 
	C13.649199,119.386742 13.334455,119.652893 12.530131,119.386978 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M42.462669,112.611183 
	C42.692547,113.421028 42.408508,113.713226 41.780033,113.588730 
	C41.649052,113.562782 41.472641,113.378891 41.452377,113.247009 
	C41.354446,112.609673 41.667233,112.348022 42.462669,112.611183 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M15.403170,120.970856 
	C15.801493,120.241714 16.203470,120.232582 16.559092,120.753258 
	C16.633762,120.862572 16.632765,121.115654 16.555506,121.221008 
	C16.185570,121.725471 15.783423,121.715508 15.403170,120.970856 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M15.001278,113.998802 
	C14.366085,113.907547 13.646978,113.899841 13.502486,113.083809 
	C13.472178,112.912643 13.832170,112.672379 14.012312,112.463951 
	C14.315749,112.787895 14.619185,113.111847 14.960115,113.719177 
	C14.997609,114.002548 15.000000,114.000000 15.001278,113.998802 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M4.994403,123.005203 
	C4.365746,122.896156 3.635365,122.904282 3.493138,122.090088 
	C3.463037,121.917763 3.821446,121.677567 4.000850,121.468651 
	C4.307288,121.788376 4.613727,122.108093 4.965250,122.708321 
	C5.010333,122.988831 4.999971,123.000000 4.994403,123.005203 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M5.998848,112.001114 
	C6.423002,112.123199 6.848301,112.244164 7.273600,112.365128 
	C6.956727,113.068954 6.599099,112.681038 6.123495,112.200729 
	C6.001398,111.997948 5.999993,112.000000 5.998848,112.001114 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M900.511841,533.993652 
	C898.987366,532.890259 897.920837,531.705261 896.729492,530.193359 
	C896.538879,529.703735 896.473022,529.540894 896.199585,529.215942 
	C895.991943,529.053833 896.009338,529.004883 895.983398,529.005249 
	C895.810913,528.839783 895.664429,528.674011 895.265320,528.292969 
	C895.012695,528.077698 894.653931,527.950012 894.472412,527.898926 
	C893.651367,524.933044 895.067383,523.897522 897.780701,523.960693 
	C901.253174,524.041443 904.726868,524.068359 908.654663,524.250488 
	C912.218262,526.374695 915.366699,524.671570 918.754395,524.254150 
	C919.465637,524.028198 919.921448,524.031006 920.716553,524.077148 
	C922.099792,525.207520 923.899719,524.960876 924.881836,526.340271 
	C925.070740,526.605591 924.155579,528.382935 925.530518,527.272095 
	C927.767578,525.464783 930.079590,525.603821 932.569763,526.276917 
	C933.210388,526.450073 933.939270,526.710205 934.531738,526.518433 
	C943.941711,523.472290 953.527649,527.022400 962.643555,525.883362 
	C956.443848,526.237671 949.949036,526.133362 943.298218,524.297363 
	C949.032227,521.670776 955.351013,522.923096 961.474365,522.616272 
	C977.278625,521.824280 993.076538,520.442749 1009.386841,520.854004 
	C1010.174927,520.873840 1010.503662,520.952209 1011.062805,521.123047 
	C1011.295715,521.205200 1011.755798,521.363037 1011.989075,521.421631 
	C1012.222351,521.480164 1012.701477,521.484985 1012.939270,521.459778 
	C1013.177063,521.434570 1013.631409,521.287048 1013.776062,521.096985 
	C1014.394287,520.884277 1014.867859,520.861694 1015.697144,520.839172 
	C1016.671143,521.226196 1016.991333,521.805908 1017.145264,522.844727 
	C1017.995911,524.177185 1019.210144,523.773865 1020.241516,524.047058 
	C1022.539734,524.655762 1020.129517,525.132385 1020.027222,525.974609 
	C1018.936157,527.275696 1017.724426,527.053650 1016.174927,526.895508 
	C1013.147644,524.879456 1010.342651,526.930786 1007.369934,526.752319 
	C1005.944641,526.379639 1004.781311,526.640991 1003.313660,527.006958 
	C998.346680,525.892944 993.609009,526.774658 988.914795,526.492432 
	C986.788208,526.364563 984.634155,526.751648 982.153687,526.104126 
	C981.526245,526.051331 981.277222,526.047485 980.662231,526.078125 
	C976.538818,527.876282 972.392822,526.197998 968.324341,527.676941 
	C970.479919,529.485840 972.974365,529.536865 975.874817,529.375244 
	C986.714844,528.771179 997.584900,528.696899 1008.762146,529.633789 
	C1007.547241,530.835022 1005.843933,530.443604 1004.207947,530.498169 
	C969.795532,531.645874 935.382568,532.777283 900.511841,533.993652 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M1015.681274,529.248657 
	C1015.782166,529.078247 1016.097229,529.055176 1016.887756,529.059631 
	C1016.874023,529.190186 1016.384766,529.293091 1015.681274,529.248657 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M998.208191,635.726318 
	C995.247742,636.880493 993.098450,634.961853 990.746887,634.273926 
	C988.017822,633.475525 985.479797,633.054749 982.392090,633.992188 
	C980.875671,634.982117 979.533386,634.341553 978.296204,634.477112 
	C975.740417,634.757202 974.007324,634.411743 975.770508,631.220886 
	C976.435425,630.017639 975.789734,628.698242 975.503235,627.097534 
	C974.656799,625.628784 977.711975,624.366455 975.023193,623.164551 
	C974.577820,622.836670 974.442627,622.646484 974.178345,622.122681 
	C973.875549,621.068420 973.860596,620.340515 974.033447,619.245117 
	C974.218323,618.657471 974.320068,618.432617 974.657471,617.924377 
	C976.807739,616.686707 978.884338,616.178345 981.218506,615.536865 
	C982.414490,616.288574 982.998291,617.174744 983.558044,618.352539 
	C983.863342,618.711731 983.988525,618.908813 984.044189,619.135254 
	C983.989136,619.027222 983.934021,618.919128 983.747009,618.618225 
	C983.177124,617.553040 982.756165,616.669617 981.802734,615.734863 
	C981.639648,613.095947 983.201477,613.022888 984.561707,613.986267 
	C987.186523,615.845459 990.369995,617.290588 991.364197,621.209839 
	C991.844543,621.891968 992.266235,622.173828 992.547241,622.586731 
	C992.426392,622.332764 992.234985,622.139465 991.784241,621.765503 
	C991.635864,616.611938 992.992065,612.865906 998.903198,612.774963 
	C1000.030090,612.757690 1000.789307,611.529419 1002.059875,610.720032 
	C1004.249390,610.256104 1005.207520,611.336243 1005.993652,613.210022 
	C1006.231812,614.324280 1006.231384,615.073853 1006.097961,616.182068 
	C1006.780212,617.083923 1003.661377,618.152161 1006.604187,618.538879 
	C1007.466248,619.051575 1007.710266,619.635376 1007.821899,620.608643 
	C1007.793884,621.125366 1007.760071,621.327881 1007.638733,621.817871 
	C1007.364502,622.662842 1007.248718,623.227295 1007.442871,624.117676 
	C1007.492310,624.628601 1007.483826,624.838074 1007.384277,625.354309 
	C1006.779663,626.691467 1006.111328,627.513184 1004.519043,627.358154 
	C1003.604736,626.656189 1003.152832,625.988464 1002.804565,625.018555 
	C1002.706543,624.846985 1002.398254,624.618530 1002.567627,624.744263 
	C1003.041809,625.535522 1003.259216,626.248230 1004.019287,627.034302 
	C1004.514465,627.664490 1004.632385,628.098816 1004.576538,628.912598 
	C1003.638733,631.172607 1002.448608,631.869751 1000.422974,630.018433 
	C999.874451,629.385315 999.615417,628.955933 999.271362,628.600220 
	C998.927063,628.244141 998.552917,627.915894 998.183167,627.584839 
	C997.798950,628.237305 998.706421,628.338745 998.880127,629.111572 
	C1000.365967,632.377075 1003.692749,630.666870 1005.872498,632.459229 
	C1006.203430,632.920227 1006.285339,633.137329 1006.189331,633.653687 
	C1005.338562,634.371948 1004.276550,634.650452 1004.064880,635.236206 
	C1003.399353,637.078369 1003.278503,639.532349 1001.523621,635.688904 
	C1001.034546,634.617920 999.531128,634.833496 998.208191,635.726318 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1014.289795,631.649048 
	C1013.260193,632.151733 1012.445068,632.452393 1011.329712,632.893066 
	C1010.824463,633.143433 1010.619385,633.253662 1010.082458,633.257202 
	C1005.785767,629.143860 1009.236938,626.663269 1011.717529,623.637390 
	C1012.059937,622.915466 1012.424255,622.655518 1013.222961,622.493408 
	C1013.801819,622.556702 1014.027161,622.630310 1014.544189,622.908081 
	C1015.941284,624.964478 1019.585938,625.099609 1018.225464,628.734497 
	C1017.995728,629.004883 1018.000000,629.000000 1017.999268,629.000000 
	C1017.477783,629.360474 1016.864807,629.548889 1016.103638,630.088928 
	C1015.441528,630.702576 1014.960327,631.059937 1014.289795,631.649048 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1004.003174,627.326660 
	C1005.310547,627.116638 1005.891479,626.195740 1006.774658,625.159058 
	C1008.832520,624.776611 1008.893372,626.035950 1008.485901,627.099304 
	C1007.800537,628.888306 1008.365417,630.553284 1008.570923,632.605835 
	C1008.537842,633.161499 1008.489624,633.381104 1008.239990,633.871094 
	C1007.587158,634.108398 1007.135803,634.075195 1006.347900,633.997437 
	C1006.011414,633.952759 1005.975952,633.469666 1005.950562,633.228760 
	C1005.045532,632.011780 1004.058411,631.095886 1004.039062,629.305176 
	C1004.012268,628.546082 1003.993530,628.115417 1004.003174,627.326660 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M1008.249207,634.394775 
	C1008.029297,633.957031 1008.020020,633.772583 1007.985962,633.312134 
	C1008.354614,632.668335 1008.819336,632.511230 1009.671143,632.781311 
	C1010.160706,633.000977 1010.334473,633.004395 1010.768860,633.020508 
	C1011.322815,633.793457 1011.854065,634.552185 1011.859192,635.314392 
	C1011.869324,636.831909 1012.785095,639.408752 1010.846375,639.557861 
	C1007.586853,639.808655 1010.800232,637.080139 1009.805908,636.030212 
	C1009.363708,635.563354 1008.908997,635.108337 1008.249207,634.394775 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1014.412964,631.915161 
	C1014.207764,631.355408 1014.340271,630.859619 1014.686768,630.208740 
	C1015.574585,629.401550 1016.359985,629.256836 1017.614990,629.734985 
	C1017.990601,629.930176 1017.967529,630.403870 1017.953979,630.639343 
	C1016.877197,631.242920 1015.813965,631.611084 1014.412964,631.915161 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M1009.748169,667.358887 
	C1009.994080,667.373657 1010.128174,667.506287 1010.262207,667.638977 
	C1010.053589,667.584900 1009.844971,667.530823 1009.748169,667.358887 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M827.236023,739.541992 
	C825.644287,740.212769 824.219788,739.553955 822.378540,739.045532 
	C815.980164,735.871094 819.366516,742.175598 817.441284,743.623718 
	C814.980957,746.247742 818.345093,747.126892 818.715088,749.242676 
	C819.932129,750.813599 820.070374,752.264038 820.205078,754.089722 
	C820.161682,755.228638 819.973389,755.957581 819.375977,756.942017 
	C817.302673,758.062134 816.177612,756.875061 814.768982,755.504517 
	C813.732422,753.834045 813.728943,752.306702 813.611694,750.436768 
	C813.391052,748.445312 813.157593,746.816956 813.250122,744.818604 
	C813.313110,744.245911 813.364746,744.020996 813.458862,743.453857 
	C813.546692,741.012817 813.461548,738.912903 813.558960,736.489136 
	C813.556152,736.148132 812.679382,736.763184 813.330322,736.619324 
	C813.660034,738.856567 813.465088,741.100220 813.261353,743.649170 
	C809.068848,745.532837 810.770874,740.896301 808.725159,740.002014 
	C806.910156,741.429260 807.558838,743.522034 807.427734,745.781128 
	C807.402039,752.473022 807.448914,758.777954 807.384033,765.519104 
	C807.335815,766.539429 807.246948,767.115051 806.935974,768.086182 
	C806.588562,768.718689 806.408997,768.947327 805.830261,769.347656 
	C805.142456,769.517090 804.853699,769.514832 804.171387,769.335022 
	C803.606140,768.928101 803.434387,768.698730 803.100281,768.072876 
	C802.583435,766.296143 802.580322,764.886169 802.583618,763.057495 
	C802.441223,759.601746 803.020264,756.524170 801.971436,753.120056 
	C801.350769,748.733521 801.706787,744.736145 801.551636,740.334595 
	C801.603333,738.259277 800.875000,736.727905 800.738403,734.700562 
	C800.706299,733.522095 800.800110,732.753540 801.136841,731.654114 
	C801.659180,730.409058 802.521790,729.815002 802.974243,728.559753 
	C799.243591,730.813660 798.095886,734.012756 798.234192,738.217346 
	C798.182190,739.008301 798.114197,739.453552 797.928101,740.211304 
	C797.753113,740.726074 797.667297,740.923828 797.414307,741.389587 
	C797.120850,741.819031 796.994629,741.980530 796.678467,742.372070 
	C796.138855,743.072021 795.881470,743.581848 795.786865,744.471069 
	C795.707153,745.186890 795.583008,745.583740 795.205078,746.226990 
	C793.777710,747.443420 792.312195,748.245544 792.712646,750.530151 
	C792.812256,751.320129 792.821228,751.774109 792.752930,752.566223 
	C792.608276,753.346191 792.490173,753.784180 792.253296,754.542847 
	C791.548096,756.590942 790.786926,758.240417 789.651184,760.082947 
	C787.008179,763.370605 785.761658,766.776550 786.051697,771.042358 
	C785.991760,771.873352 785.882996,772.340271 785.578003,773.134888 
	C780.188965,783.268738 777.850037,793.887817 776.593018,805.159668 
	C776.656006,805.765991 776.655884,806.008789 776.580261,806.603882 
	C773.779297,809.790955 772.625061,813.004883 774.135010,817.203186 
	C774.142090,818.012146 774.094971,818.471558 773.934570,819.264160 
	C773.715759,820.036255 773.556274,820.464355 773.258057,821.200684 
	C773.057495,821.724121 772.978027,821.932861 772.785889,822.455322 
	C771.395081,825.785767 771.301880,828.714172 773.387451,831.834717 
	C773.410339,832.422974 773.368469,832.661560 773.112610,833.200745 
	C769.836304,835.166138 767.160950,837.721558 763.005859,837.459106 
	C761.484131,836.083679 761.025085,834.608215 760.933838,832.597839 
	C761.161133,830.706299 761.576111,829.253174 762.254578,827.502075 
	C763.043030,826.448792 764.647888,826.031250 763.098145,824.310303 
	C762.591248,817.154663 765.312134,810.778931 765.835571,803.685669 
	C766.837769,799.709351 766.710632,795.855286 768.921204,792.251648 
	C773.542236,789.903076 773.768188,785.244446 775.784912,781.306885 
	C776.313599,779.952026 778.717957,779.820618 777.307007,777.630127 
	C777.380859,776.632690 777.560974,775.988892 777.759583,775.005859 
	C777.937134,774.241882 778.083984,773.820007 778.426941,773.120361 
	C779.277100,772.046082 780.097656,771.314026 779.605286,769.771301 
	C779.490662,769.234924 779.452454,769.017395 779.394958,768.467651 
	C779.997559,764.946228 777.268005,762.266052 778.056030,758.731018 
	C778.268677,757.753967 778.484131,757.123291 778.705078,756.150269 
	C778.864746,755.392517 778.982727,754.967224 779.230835,754.238770 
	C779.793274,752.966736 780.221680,751.996582 780.192139,750.581299 
	C780.199219,750.054565 780.209839,749.845215 780.261353,749.328003 
	C780.394104,748.432556 780.550903,747.850464 780.313110,746.995239 
	C778.972046,745.992310 777.723938,745.474731 776.045166,746.140991 
	C775.397949,746.667786 775.056519,747.075562 774.999146,747.923767 
	C775.145996,748.770996 775.286499,749.337280 775.365479,750.223755 
	C774.704773,752.080505 773.292114,753.177246 772.690002,755.128235 
	C771.219910,757.177368 771.414062,759.182007 771.593384,761.548584 
	C770.126099,767.073364 769.207275,772.314331 769.212769,778.080994 
	C769.078857,778.708435 769.003662,778.954163 768.753296,779.536255 
	C768.414368,780.057434 768.250671,780.242249 767.788696,780.633301 
	C766.316650,782.371033 762.763000,780.585815 762.974609,784.622986 
	C763.059326,786.238647 760.425293,785.831238 759.114014,783.881836 
	C758.341187,781.413879 759.190979,779.392944 759.416626,777.977051 
	C756.156067,790.905273 755.268127,804.854797 753.160034,818.984619 
	C752.627136,820.704590 752.201111,822.086914 750.637085,823.048523 
	C749.795166,822.991699 749.378479,822.591553 748.762329,822.780396 
	C748.697021,823.002563 748.624268,823.453308 748.547729,823.661377 
	C748.070801,824.126587 748.136902,824.223938 748.670959,824.201538 
	C749.336914,824.173645 748.453857,824.124390 749.424072,824.130493 
	C750.156616,824.219055 750.553406,824.384155 751.171387,824.862244 
	C752.458679,827.708191 752.266785,830.438232 752.325806,833.507812 
	C752.298035,834.610352 752.168701,835.326843 751.850464,836.366211 
	C751.215088,837.728821 750.372375,838.550293 749.724487,839.893738 
	C748.863098,841.080261 748.298767,842.028687 748.235474,843.560303 
	C747.885254,845.167053 747.413086,846.275024 745.578613,846.536987 
	C743.401123,845.543823 741.473633,845.208923 739.067444,845.383545 
	C737.420471,845.369568 736.150146,845.366821 734.593140,844.793457 
	C732.482727,843.275513 732.941162,841.184570 732.659607,838.446655 
	C732.277893,841.309448 732.378418,843.251892 732.421204,845.577515 
	C732.565979,854.055786 732.555359,862.146667 731.936890,870.627441 
	C731.716248,871.529419 731.484985,871.990906 730.917480,872.670532 
	C728.582397,874.664185 729.391663,876.947021 729.612549,879.399597 
	C729.941162,880.087952 730.118958,880.486877 730.322632,881.224243 
	C730.342163,881.763306 730.302856,881.978638 730.088501,882.468018 
	C729.751831,882.882812 729.590210,883.023560 729.134949,883.287537 
	C728.209839,883.498047 727.582153,883.414734 726.634644,883.370483 
	C725.417236,883.373779 724.642944,883.718262 723.683472,884.430664 
	C722.818604,885.153503 722.283447,885.747498 721.809570,886.767212 
	C721.522949,887.421936 721.357117,887.798218 721.075928,888.468689 
	C720.520752,889.750977 720.289612,890.791748 720.122498,892.194153 
	C719.958008,892.965698 719.795166,893.385498 719.375610,894.055664 
	C717.200500,895.980774 713.580078,894.146912 712.195312,897.756226 
	C709.730042,902.469177 711.284546,907.245300 710.906494,911.868530 
	C710.680725,914.629517 710.935486,917.429749 711.122437,920.668396 
	C712.580322,929.145996 712.361389,937.264648 712.535095,945.333984 
	C712.923828,963.396545 712.876648,981.467529 711.945801,999.981567 
	C711.267761,1001.388367 710.411194,1001.703491 708.952026,1001.654419 
	C707.260986,1001.004272 707.013123,999.838989 706.703735,998.275024 
	C706.634033,997.097717 706.648499,996.324341 706.610107,995.199036 
	C706.573975,994.618774 706.554077,994.390869 706.456970,993.838928 
	C704.253357,991.405151 701.769104,992.262512 699.470581,992.905762 
	C697.614624,993.425171 695.924622,993.536072 693.871216,992.553711 
	C692.546204,991.470764 692.072998,990.365234 692.347290,988.646240 
	C692.729065,987.859131 693.071716,987.506958 693.827026,987.081787 
	C695.297424,986.622803 696.277344,985.948120 697.698364,985.426270 
	C699.424805,985.274536 700.736267,985.670349 702.359863,986.097656 
	C703.350952,986.434448 703.953369,987.056091 705.001282,986.501099 
	C706.044861,985.747742 706.726685,985.087524 706.641724,983.648193 
	C706.655334,982.454346 706.628052,981.577332 706.515259,980.356934 
	C706.026489,978.195007 704.521179,978.514160 703.251709,978.455017 
	C695.241333,978.082031 687.271118,978.436279 679.739136,981.437256 
	C672.688354,984.246643 665.463135,986.657349 658.523560,990.474670 
	C658.035461,991.392761 657.677551,991.984253 657.478882,992.996277 
	C657.381042,995.677795 658.675476,997.721008 658.940796,1000.336121 
	C657.988831,1003.622314 660.883484,1005.531189 660.956360,1008.530762 
	C660.881165,1009.092102 660.826782,1009.312927 660.631592,1009.843506 
	C659.939026,1011.189941 658.341614,1012.096985 659.357422,1013.379578 
	C660.296265,1014.565002 661.675354,1013.508606 663.181519,1013.145020 
	C665.398682,1012.624390 667.239197,1012.922119 669.402527,1013.445374 
	C671.386047,1013.669922 672.621521,1012.582642 674.364380,1011.971558 
	C676.321960,1011.607361 677.462402,1010.471802 679.059326,1009.395508 
	C684.575928,1009.507141 685.343323,1010.935059 682.279114,1015.426575 
	C670.009705,1017.559875 657.881287,1017.553772 645.455872,1018.840942 
	C644.937073,1018.685913 644.715759,1018.508789 644.745178,1018.441895 
	C645.468018,1016.796997 644.644348,1016.390198 642.913513,1016.236694 
	C642.396484,1015.565308 642.280212,1015.091858 642.343750,1014.221130 
	C642.371033,1013.088074 642.202820,1012.321106 642.775146,1011.271973 
	C643.006775,1010.499023 643.000183,1010.032898 642.966553,1009.218018 
	C641.793701,1006.068726 639.486816,1007.710693 637.296570,1007.500732 
	C630.293945,1008.763245 623.542786,1009.287598 616.945068,1010.757202 
	C615.028015,1011.184265 613.365845,1010.536133 611.463989,1009.267334 
	C610.074524,1008.025696 609.483337,1006.802002 609.391968,1004.941528 
	C609.569214,1004.274719 609.696960,1004.024841 610.167969,1003.529663 
	C611.567505,1002.803528 612.688599,1002.763367 614.238647,1002.834717 
	C621.552124,1002.804993 628.329346,1000.921692 635.278992,1001.573364 
	C637.237854,1001.757019 639.246216,1001.473816 641.488892,1002.410461 
	C644.010010,1002.620117 646.135620,1002.476013 648.238525,1002.005737 
	C646.621643,1002.135620 645.041687,1002.669678 643.029236,1002.479858 
	C641.881775,1002.484924 641.161987,1002.331421 640.469482,1001.338867 
	C640.229553,1000.449524 640.264893,999.931519 640.622070,999.086975 
	C643.581543,997.033752 646.586304,997.668396 649.827515,997.860718 
	C650.456238,997.908875 650.733826,997.790344 650.733765,997.539673 
	C650.197083,997.479065 649.930603,997.307068 649.610352,996.781128 
	C649.191589,994.320679 651.545288,994.202454 652.425415,992.563354 
	C652.658630,991.154175 652.720642,990.047974 652.753174,988.582764 
	C652.826599,987.741455 652.917175,987.262329 653.171387,986.431274 
	C653.526794,985.605957 653.806824,985.172913 654.405762,984.479919 
	C655.072083,983.827942 655.501160,983.511108 656.319702,983.047607 
	C662.494019,981.491333 667.986511,979.249878 673.376282,976.717041 
	C681.386292,972.953003 690.057495,973.194519 698.963806,972.602661 
	C706.464050,972.631958 706.705566,972.424988 706.230713,966.322693 
	C702.614685,969.275879 698.785706,971.389587 693.742554,971.192627 
	C693.144348,971.126709 692.904480,971.087158 692.307068,970.958069 
	C690.997864,970.560669 690.076599,970.177490 688.846191,969.552490 
	C686.235718,967.092224 683.266174,965.958862 680.531128,964.418762 
	C676.536194,962.169250 676.133972,960.221863 678.748291,955.790039 
	C679.819458,955.445496 680.554626,955.588501 681.287537,955.807495 
	C681.739563,955.942566 681.888855,955.971802 681.721558,955.941223 
	C681.065735,955.821411 682.162903,955.769409 681.263489,955.728699 
	C680.859985,955.602966 680.690186,955.552673 680.250732,955.436279 
	C679.436096,955.203674 678.870117,955.143311 678.041321,954.967407 
	C677.601929,954.824463 677.433472,954.756165 677.039917,954.553955 
	C676.194702,953.845825 676.081543,954.153992 675.998413,955.033081 
	C675.330505,955.664673 674.735718,955.823975 673.776611,955.947266 
	C666.470947,956.450439 660.149719,959.482544 653.117188,961.110718 
	C649.570618,961.689819 648.857361,964.479431 647.408203,967.061279 
	C646.808411,967.604065 646.397522,967.819702 645.624634,968.089478 
	C643.513306,968.251404 642.293640,969.333557 640.771118,970.638733 
	C637.563721,971.750366 634.848083,970.530212 631.690491,970.110291 
	C629.904968,969.517090 628.372437,969.302368 626.936401,968.044556 
	C626.527161,967.144714 626.399475,966.440857 626.858215,965.970764 
	C629.400269,963.365967 627.431335,962.963013 624.982056,962.458191 
	C621.811523,960.035645 619.462585,960.562561 617.353271,963.928833 
	C613.345398,965.942383 609.378357,966.376282 604.917969,966.002991 
	C602.590759,964.447937 600.235352,964.495850 597.995483,964.085571 
	C596.835449,963.873169 595.681946,963.405518 595.680359,961.960632 
	C595.679077,960.814941 596.597534,960.146973 597.549194,959.933289 
	C600.791199,959.205261 602.288330,957.605469 602.688293,953.976318 
	C603.103699,950.207336 607.256470,949.139587 610.320129,946.903198 
	C613.237366,945.267883 615.984131,945.444031 619.156128,946.032715 
	C620.335632,946.541260 620.883484,947.139160 621.302124,948.323853 
	C620.471008,951.825500 617.704224,951.988708 614.875305,952.705688 
	C612.680847,953.106079 610.990845,953.710938 609.598389,955.376526 
	C609.447693,955.548523 609.185852,955.874512 609.185852,955.874512 
	C609.185852,955.874512 609.310486,955.707886 609.523804,955.566895 
	C610.314575,955.190613 610.899902,955.227417 611.792480,955.530151 
	C613.666260,958.210083 616.406982,958.457703 617.873535,956.670593 
	C621.020874,952.835571 624.808960,953.229675 628.859497,953.647217 
	C629.827393,953.747070 630.815857,953.628479 632.118042,953.372314 
	C632.903259,953.201477 633.358704,953.161804 634.155518,953.186035 
	C634.927979,953.282715 635.359009,953.372620 636.094727,953.555298 
	C637.012939,953.752991 637.612915,953.916626 638.502869,954.116577 
	C639.929871,954.170654 639.822205,953.224976 640.144653,952.177979 
	C640.880127,950.523254 641.981567,950.066589 643.742310,950.185181 
	C645.526733,950.844299 645.947754,952.019836 646.020386,953.769897 
	C645.980103,955.088257 645.196472,956.220337 646.002441,956.936279 
	C646.970032,957.795898 647.786499,956.736145 648.449097,956.112610 
	C651.005737,953.706604 652.506226,950.958313 650.802307,947.037598 
	C646.118286,941.882446 639.876953,942.219360 634.119446,941.536194 
	C626.860352,940.674927 619.617798,941.871033 612.046997,942.970337 
	C611.187561,943.150574 610.692078,943.212158 609.828430,943.285889 
	C608.981628,943.350342 608.500305,943.381348 607.667358,943.456665 
	C605.956238,943.889343 604.561768,944.088806 602.816650,944.319458 
	C601.230774,944.383667 600.241577,945.068237 598.838745,945.719910 
	C597.448853,946.111023 596.431885,946.056091 595.102417,945.430908 
	C594.625366,944.979431 594.483276,944.751099 594.230957,944.134033 
	C595.133545,936.377380 597.601440,929.280334 597.653992,921.708435 
	C597.718018,912.478394 594.444580,904.520081 589.422119,897.091492 
	C588.124023,895.171448 586.444641,893.496094 586.085083,890.659241 
	C586.152832,889.988464 586.223633,889.725891 586.500549,889.111389 
	C596.041382,884.071838 605.689819,880.165710 615.694763,877.154846 
	C616.669861,876.861450 617.670166,876.975098 618.969849,877.556030 
	C621.071655,879.986267 621.355774,882.586670 621.219971,885.648376 
	C620.165588,888.368164 618.409363,890.595520 619.934448,893.730042 
	C619.853882,898.078674 621.898315,901.851807 621.444336,905.891296 
	C621.839478,902.245544 620.161011,898.818909 620.147156,894.855347 
	C620.359131,894.025940 620.587158,893.597412 621.149170,892.958618 
	C623.240051,891.485046 625.482300,891.268494 627.401917,890.284485 
	C628.784363,889.575867 630.780579,889.354248 630.367798,886.747681 
	C629.974121,886.096558 629.742004,885.723633 629.363159,885.043213 
	C627.894897,881.215881 627.651245,876.919312 622.534546,875.788574 
	C621.226074,874.929077 620.235596,874.032471 618.814331,875.668091 
	C615.016724,877.332092 611.392761,878.386353 607.220337,878.888184 
	C605.694580,878.772766 604.813660,878.296875 604.353149,876.777161 
	C604.619812,874.184509 606.463806,873.789429 608.454956,873.064758 
	C609.444763,872.783325 610.102478,872.625793 610.991699,872.163513 
	C611.629700,871.763550 611.999268,871.545227 612.661377,871.197144 
	C613.973816,870.690857 614.718323,869.973999 615.582764,868.886353 
	C615.998047,868.529785 616.186523,868.410583 616.691772,868.169556 
	C618.530334,867.645264 620.203857,867.902954 621.835571,866.761353 
	C623.066650,865.393372 623.600708,864.055969 623.791870,862.229980 
	C623.884583,861.689270 623.932373,861.472961 624.095459,860.942505 
	C624.328674,860.438477 624.446533,860.248718 624.825317,859.849243 
	C627.596863,859.006470 627.799194,861.254883 628.955444,862.796204 
	C629.427734,863.308350 629.695190,863.593689 630.177612,864.045410 
	C630.696899,864.390137 631.025696,864.497681 631.647522,864.458862 
	C632.094482,864.328491 632.273804,864.263245 632.723877,864.100342 
	C634.064819,863.623779 634.443970,862.981018 633.592407,861.682251 
	C633.005066,860.896606 632.621094,860.359131 631.994934,859.571655 
	C631.245972,858.488770 631.039856,857.593872 631.158081,856.288330 
	C634.350525,852.570435 638.835754,852.344910 642.815125,850.954468 
	C643.438538,850.736694 642.704285,851.138489 643.296936,850.873230 
	C644.343750,850.404846 643.297791,850.547668 642.856750,850.255005 
	C641.383301,848.613770 641.287170,847.054138 642.382080,845.123047 
	C643.110840,844.371643 643.735901,844.094727 644.658203,843.713684 
	C644.415527,839.512085 643.141174,838.822327 636.948242,839.536621 
	C633.357056,839.555359 630.719971,837.386475 627.209534,836.852905 
	C625.911438,836.277100 625.113342,835.673096 624.597534,834.330200 
	C627.417969,831.020996 631.046570,828.449890 629.741089,823.080566 
	C629.805054,822.486389 629.841553,822.250427 629.957214,821.666626 
	C630.286743,820.415710 630.569397,819.520020 630.697449,818.229370 
	C630.768799,817.402466 630.835754,816.931641 631.006226,816.112305 
	C632.128784,813.272400 633.565125,811.078308 636.073242,809.259521 
	C637.221008,808.624207 638.010437,808.098206 639.058228,807.313660 
	C641.570007,805.715210 644.556152,806.297974 646.475342,804.682617 
	C646.603760,803.979675 646.511414,803.486023 646.254883,803.482117 
	C638.183899,803.359680 630.097900,802.882812 622.057373,803.945190 
	C614.691223,804.918457 610.611206,809.942017 607.385254,816.416260 
	C606.410950,818.754578 604.256653,819.654541 603.034607,821.794434 
	C602.587891,822.463989 602.321289,822.837708 601.854492,823.489380 
	C597.932068,828.363892 594.674866,833.316895 590.658203,838.125122 
	C588.344482,840.242676 587.104431,842.917175 584.282532,844.481506 
	C582.586121,844.495178 581.659790,843.736633 580.699829,842.418579 
	C579.825684,839.554993 582.156799,838.322021 583.146240,836.127075 
	C590.201172,827.408569 596.558350,818.626770 601.963440,809.102722 
	C593.441101,815.576599 587.627441,824.831787 578.859619,831.515259 
	C572.241638,837.381348 564.866760,841.598450 557.971252,846.481995 
	C552.503662,850.354248 547.699158,854.849426 543.215271,860.266479 
	C540.427429,861.935059 538.125183,860.112061 535.340637,860.063416 
	C524.120422,855.999634 513.270996,851.918518 502.135345,847.636536 
	C501.292908,845.715271 499.864349,846.072815 498.263428,846.107544 
	C485.794312,842.676941 473.650116,839.205566 461.188019,835.545776 
	C459.423279,833.080444 457.386932,833.993591 455.139465,834.224365 
	C454.826599,834.092407 454.504120,834.175293 454.347137,834.119934 
	C454.017517,834.171204 453.844910,834.277771 453.376465,834.456055 
	C450.963348,835.666809 448.846039,836.805847 446.374451,837.996338 
	C444.587067,837.890747 443.104736,838.425232 441.408844,837.543518 
	C440.257965,835.305969 441.963318,835.065735 443.460571,834.422119 
	C444.053101,833.850281 444.889404,836.032898 445.023315,833.874023 
	C449.318146,830.145569 454.493134,828.683228 459.231812,826.365234 
	C461.011932,825.494507 462.708191,824.452087 464.206818,822.984802 
	C460.787018,823.729370 457.465973,824.933228 454.387451,826.515259 
	C448.333588,829.626404 441.353424,830.417542 435.307800,834.416260 
	C431.836334,835.654724 428.500275,836.144653 425.075195,837.589172 
	C424.077026,837.986877 423.402527,838.228699 422.402740,838.633423 
	C421.834229,838.838989 421.602539,838.911316 421.015167,839.066528 
	C418.960632,839.346741 417.292206,839.854187 415.197510,839.529907 
	C413.934601,838.822998 413.432922,837.996216 413.407928,836.546875 
	C419.049896,830.508423 426.154633,826.947754 432.898712,822.333008 
	C434.328033,821.785400 435.669434,821.975403 436.755676,820.752075 
	C437.031982,820.341125 437.143921,820.176453 437.437073,819.770996 
	C437.755188,819.381470 437.892090,819.232666 438.259460,818.884033 
	C438.658234,818.568787 438.826569,818.453430 439.260681,818.184387 
	C439.708099,817.934998 439.889771,817.839294 440.349487,817.607422 
	C440.817169,817.387512 441.006897,817.303772 441.488098,817.108398 
	C442.769836,816.664612 443.779846,816.393433 445.059937,815.918457 
	C445.559631,815.725891 445.760498,815.648315 446.265137,815.452332 
	C446.773529,815.255127 446.978180,815.176331 447.494324,814.985413 
	C451.469635,813.883301 454.751953,812.002747 458.389893,810.231201 
	C459.495117,807.859619 456.288971,808.041321 456.443542,805.948730 
	C458.674500,802.333862 461.276703,799.173889 460.283844,794.431396 
	C462.197235,793.665955 462.970184,795.408997 464.685486,795.915161 
	C465.049896,795.971008 465.428711,795.738037 465.635040,795.778198 
	C465.841370,795.818359 466.212036,795.637573 466.068481,795.441040 
	C465.582153,793.046387 464.972931,790.960144 463.281952,788.926636 
	C462.881378,787.567871 462.907043,786.572998 463.599091,785.315796 
	C464.450409,784.847839 465.043427,784.668640 465.822510,784.234863 
	C466.502197,783.485352 467.098633,783.212769 468.119263,783.154907 
	C469.219574,783.164429 470.046356,783.525024 470.894531,782.579224 
	C471.677643,781.264954 472.446899,780.295837 473.024475,778.895996 
	C473.006348,777.044312 470.161041,774.224243 475.057861,774.805481 
	C476.531769,775.085388 476.823029,776.045410 477.197998,777.343750 
	C477.361328,779.783875 478.165588,781.792297 478.023163,783.914551 
	C477.923248,785.403931 478.820862,785.884949 480.413574,786.031494 
	C481.495270,786.306030 482.148804,786.707397 482.757599,787.528320 
	C482.872437,787.705811 483.032410,787.998352 483.014984,787.798706 
	C482.860352,786.909241 482.429993,786.341309 482.107178,785.390381 
	C481.743774,784.045288 481.542297,782.978882 480.935730,781.682739 
	C480.585724,780.957336 480.390503,780.535400 480.052612,779.780762 
	C478.977234,776.644775 477.275085,774.013916 478.108154,770.498352 
	C478.662811,770.109985 479.068451,770.067139 480.083252,769.966431 
	C483.585907,771.140686 483.722626,774.116089 484.931030,776.789368 
	C485.173431,777.744995 485.295197,778.389587 485.636993,779.312744 
	C485.862061,779.814148 485.954895,780.014465 486.185852,780.518005 
	C489.163544,788.321960 490.292023,788.934509 497.045410,786.341248 
	C497.888733,786.134705 498.388550,786.097473 499.281891,786.153809 
	C504.146851,786.979553 508.689667,786.262024 513.539307,786.892761 
	C514.900574,786.487610 514.550110,789.168579 516.213623,787.669189 
	C517.019165,787.432251 517.492188,787.507446 518.207642,787.975098 
	C519.415649,791.826965 516.744629,791.975281 514.099731,792.600891 
	C513.255676,792.803040 512.769470,792.855225 511.930542,792.849670 
	C510.303955,792.606689 509.023773,792.361267 507.600159,793.383179 
	C506.983459,793.684875 506.628143,793.833130 506.043884,794.082764 
	C505.462006,794.403687 505.428223,794.658875 505.711426,794.971985 
	C505.864594,795.141235 505.991913,795.232300 506.388306,795.360657 
	C507.267731,795.770996 507.844482,796.094421 508.730530,796.604248 
	C510.594147,798.296814 514.665527,797.040649 514.178040,800.274048 
	C513.740417,803.176331 510.413971,802.099731 508.242126,802.387573 
	C507.260254,802.517761 506.250458,802.453918 505.060059,803.222412 
	C504.143738,803.850098 503.496643,804.203491 502.584167,804.794128 
	C500.304993,806.978699 502.526123,807.124207 503.504089,807.412354 
	C519.239319,812.048340 535.027405,816.469788 551.360046,818.551208 
	C556.616821,819.221191 561.873169,820.039062 567.054260,821.046082 
	C571.929199,821.993713 575.408997,820.734497 578.496338,817.105164 
	C580.102905,815.216492 581.735657,813.326599 583.751953,811.314392 
	C586.144470,809.330872 588.345764,807.667786 590.401611,805.334717 
	C590.777222,804.920776 590.927368,804.756592 591.296509,804.343628 
	C591.653076,803.922607 591.790649,803.750488 592.118103,803.307922 
	C593.458740,800.521118 595.902161,799.120117 597.705444,796.723511 
	C598.037720,796.269226 598.179871,796.094055 598.559448,795.677734 
	C601.893799,793.187378 604.509460,790.510498 606.427246,786.770142 
	C606.745239,786.311157 606.880981,786.133911 607.239868,785.707764 
	C607.778809,785.146790 608.105042,784.845947 608.685852,784.333252 
	C610.524170,782.861511 611.436707,781.005310 613.196899,779.437317 
	C614.804749,778.488281 616.236877,778.083618 618.099609,777.752502 
	C625.221863,778.154663 631.891113,778.963623 638.146667,781.708801 
	C639.992676,782.518921 642.806274,783.197144 639.320435,786.046875 
	C637.617981,787.184875 635.887085,787.362610 634.199219,788.432373 
	C633.370178,788.999756 632.823547,789.382507 631.979370,789.911377 
	C631.496948,790.171875 631.302124,790.271729 630.817505,790.525391 
	C628.961731,791.456116 627.430725,792.287903 625.830688,793.654297 
	C619.137634,796.551086 612.431396,798.505005 605.884644,801.786011 
	C604.745239,802.011475 603.927979,801.973633 602.589417,802.304077 
	C604.924072,801.976624 606.729614,801.905396 608.774475,801.175598 
	C612.841309,800.541809 615.954895,798.246704 619.904663,797.329956 
	C621.603149,797.059387 623.285767,797.628906 624.151001,795.475220 
	C624.465637,795.036438 624.608582,794.873108 625.022644,794.529541 
	C626.932190,793.604126 629.242004,794.059814 630.169800,791.448975 
	C630.508667,791.024109 630.668457,790.873718 631.121643,790.571899 
	C633.916321,789.638611 636.518433,789.055481 638.599121,786.701416 
	C639.076172,786.391357 639.284546,786.293945 639.831116,786.125366 
	C641.311340,785.848145 642.454407,785.713440 643.922852,786.107910 
	C644.769714,786.155090 644.811646,787.501282 645.892334,786.528748 
	C646.827332,786.152100 647.484863,786.112000 648.470947,786.328491 
	C649.259827,786.227234 649.258057,787.822632 650.265564,786.584473 
	C651.040100,786.349548 651.506958,786.370422 652.313354,786.604309 
	C654.563660,788.123352 657.755005,788.247620 657.395203,792.062988 
	C653.724182,795.675476 649.286133,794.794006 645.445312,794.105774 
	C639.512268,793.042603 634.692139,794.321289 629.974426,798.693298 
	C641.578979,797.817078 653.385498,801.215088 663.655518,792.953735 
	C665.085388,789.065186 668.189148,790.088257 670.630432,790.234558 
	C674.521423,790.467712 676.833557,789.481262 676.480469,785.103271 
	C676.397583,784.074585 676.860413,783.148560 677.446838,782.323303 
	C678.240173,781.206970 679.162537,780.222717 680.708801,780.442932 
	C682.576721,780.708984 682.393311,782.212708 682.443359,783.520630 
	C682.488098,784.690979 682.615234,785.842773 683.010132,787.346069 
	C683.439514,790.158813 683.636658,792.578430 681.786865,795.029907 
	C680.616089,795.964417 679.582581,796.219604 678.168213,796.517090 
	C667.695496,798.265381 666.528259,804.987976 668.307007,813.725281 
	C668.251953,814.512512 668.180908,814.949524 667.962524,815.666382 
	C667.921570,816.419800 666.638184,816.148376 667.520508,816.741943 
	C667.933472,816.528198 668.137207,816.518433 668.638367,816.615845 
	C669.709961,817.222595 670.185974,817.970398 670.776550,819.068726 
	C671.795288,821.488037 671.985352,823.613037 671.059204,826.128418 
	C669.585571,829.413452 671.871460,832.333191 670.882812,835.629761 
	C670.251831,837.200378 669.540100,838.213440 667.792603,838.512146 
	C664.838562,837.162292 665.042786,834.495605 664.466370,832.214905 
	C663.998901,830.365356 663.348999,831.328003 662.450439,832.295654 
	C661.294861,833.249023 660.198547,833.957886 660.556946,835.312012 
	C662.145691,841.315674 662.588074,847.720886 666.833496,853.161011 
	C667.186157,853.637512 667.301147,853.847595 667.488647,854.410400 
	C667.582642,855.718872 667.350281,856.665710 667.519592,857.985168 
	C668.334717,861.818115 666.744629,865.296021 667.816772,869.098267 
	C669.621521,872.369568 668.304932,875.280029 667.899353,878.184509 
	C666.800659,886.054932 664.743530,893.784973 664.436462,902.169678 
	C664.496582,909.946716 664.511597,909.895874 671.664551,912.006226 
	C676.911133,913.554077 682.212402,914.882019 687.526672,916.155884 
	C694.333008,917.787415 699.370117,914.550415 700.588440,907.742493 
	C702.250977,898.452209 703.907898,889.165222 706.914673,879.795654 
	C708.186584,877.288696 709.252075,875.099792 710.019592,872.391113 
	C711.120117,869.897766 712.063721,867.731384 712.666992,865.063904 
	C713.000366,863.540649 713.469177,862.450806 714.283447,861.132202 
	C717.368530,857.642212 718.586670,853.468750 720.841248,849.895142 
	C722.112732,847.879883 720.979004,847.287231 718.743896,847.368042 
	C716.465698,847.376343 715.331055,849.192017 713.203369,849.560425 
	C712.632812,849.517883 712.408325,849.458557 711.896301,849.203247 
	C706.057007,845.914246 700.198853,847.413757 694.424622,847.936096 
	C693.809082,847.991760 693.765869,848.975464 693.779663,850.004395 
	C693.421326,852.884155 691.570618,852.832764 689.738953,852.606079 
	C687.754639,852.360413 685.871033,852.542114 683.716797,853.503296 
	C680.769714,853.824768 680.085266,852.482910 680.707825,850.222351 
	C681.243347,848.277771 682.314575,846.565247 683.481506,844.956604 
	C685.114502,842.705261 684.429749,841.346802 681.764954,840.230469 
	C680.950745,839.116333 680.886719,838.151794 681.053223,836.797607 
	C681.888367,834.714905 682.846680,833.056152 682.924927,830.748657 
	C683.438110,828.836975 682.886780,827.210754 683.364807,825.306091 
	C684.071899,823.949463 684.755066,822.988281 685.811279,821.864990 
	C686.346863,821.601196 686.587952,821.554932 687.194092,821.568359 
	C691.588257,824.098755 688.764282,827.826355 689.242065,831.217529 
	C689.091431,832.146179 688.873047,831.283997 689.155518,831.884399 
	C689.333496,832.262573 689.526062,832.166138 689.562866,831.372070 
	C692.033081,817.470825 693.621277,803.792236 694.797852,789.688232 
	C696.244263,787.084595 694.881348,785.062012 694.332520,782.636597 
	C694.316101,781.610046 694.522278,780.971741 695.002563,780.075439 
	C695.614502,779.071350 696.222290,778.426819 696.151611,777.174805 
	C696.097900,776.637329 696.073242,776.420898 696.025513,775.875732 
	C695.995850,775.101196 696.005493,774.655823 696.039673,773.871460 
	C696.089417,772.155457 695.631470,770.971619 694.821167,769.853271 
	C692.486633,766.631042 693.359192,764.994751 697.674072,765.053833 
	C700.773193,766.298035 702.297607,768.686035 703.827576,771.049194 
	C704.822266,772.585571 705.685181,774.230591 708.117981,774.533813 
	C711.563171,774.610535 714.676941,774.835022 718.139832,774.221619 
	C714.647461,769.518433 715.430908,765.344543 718.861511,761.107361 
	C719.519226,760.626648 719.938782,760.438416 720.723938,760.275635 
	C721.928650,760.232422 722.795593,760.423218 723.984070,760.190430 
	C724.517151,760.074402 724.732483,760.030273 725.277100,759.940063 
	C726.504639,759.811890 727.395630,759.891846 728.617065,760.062927 
	C731.265686,760.695557 733.036072,759.920837 734.415833,757.986694 
	C733.382141,756.360229 731.757812,757.048645 730.067871,756.737000 
	C729.005005,756.501343 728.396973,756.131042 727.646729,755.335510 
	C726.195923,750.235229 725.160889,745.320190 720.376831,742.019775 
	C719.374634,740.527039 717.980469,740.408264 716.825317,739.841064 
	C713.392944,738.155701 709.336365,737.293396 707.948242,732.883301 
	C707.669617,731.998169 706.264038,732.022034 705.074951,731.428101 
	C704.143311,726.525574 701.159424,722.876526 699.205200,718.401001 
	C699.302002,717.791931 699.379639,717.556213 699.686523,717.028687 
	C700.354187,716.519531 700.815918,716.399231 701.646118,716.472900 
	C706.465210,717.511108 705.825623,713.014832 707.815186,710.883179 
	C708.713867,708.055054 710.959106,706.007019 710.196411,702.743164 
	C709.655762,701.623047 709.089661,700.915894 708.410950,699.864258 
	C707.912292,698.614197 707.969177,697.688660 708.482788,696.457581 
	C710.421143,694.375183 711.990662,695.415405 713.457825,696.579834 
	C715.117676,697.897339 716.718018,698.673340 719.265015,696.453125 
	C715.311096,696.100647 712.468018,693.013550 708.650635,695.746704 
	C707.710022,698.304688 706.457214,700.272522 704.593262,702.268921 
	C701.922119,704.238220 699.813660,702.596924 697.293701,701.778259 
	C696.557068,701.393738 696.179932,701.109436 695.603394,700.519409 
	C693.461914,696.517212 691.032410,693.389099 686.226074,692.534180 
	C685.665710,691.988586 685.491272,691.588196 685.511719,690.819824 
	C686.374573,689.553955 687.311279,688.740601 688.350647,687.656128 
	C688.801575,687.247192 689.174927,686.780151 689.121155,686.737244 
	C688.602966,686.323853 689.524475,687.110840 688.667358,687.311218 
	C687.765991,688.223206 687.051697,688.931519 686.134399,689.869446 
	C685.317505,690.642090 684.600037,690.951416 683.530151,691.129944 
	C683.092102,691.217712 682.921326,691.253723 682.287842,691.462524 
	C681.548157,691.799011 681.308167,692.005615 680.973328,692.455994 
	C680.841675,692.656982 680.594604,693.074219 680.474487,693.286316 
	C680.196777,693.786377 680.047852,694.078796 679.811646,694.609558 
	C679.652710,695.001953 679.589844,695.160522 679.443970,695.562561 
	C679.219177,696.317993 679.139709,696.837769 679.200012,697.653564 
	C679.317322,698.987305 679.779968,699.863831 680.665833,700.917969 
	C681.622803,702.493103 682.080322,703.867676 681.905640,705.768799 
	C681.726501,706.380798 681.620483,706.615173 681.253174,707.134399 
	C680.070984,707.985107 679.090027,708.084778 677.742310,707.623352 
	C675.172791,705.729248 674.563538,703.106384 673.673279,700.634460 
	C673.057373,698.924255 672.320068,697.260620 671.371887,695.712280 
	C670.708008,694.628052 670.097961,692.971558 668.517944,693.524780 
	C666.949463,694.073975 667.457947,695.687317 667.783569,697.290649 
	C668.615662,699.660522 669.456604,701.653137 671.274048,703.474365 
	C672.365845,706.045532 674.657104,705.865784 676.723022,706.777344 
	C677.421204,707.717834 677.142090,708.353455 676.545288,709.257080 
	C673.917419,711.675171 670.800537,712.386719 667.677856,713.904541 
	C665.818970,714.953186 664.265991,715.787415 662.119019,716.171997 
	C660.138916,716.309937 658.618347,716.090027 657.011230,714.850403 
	C655.473206,712.038269 653.198547,709.964844 653.126160,706.552124 
	C653.314575,705.806152 653.811890,705.604370 653.858093,705.135498 
	C653.869934,705.015442 653.761719,704.937500 653.653687,704.913513 
	C653.002869,704.769104 653.788330,704.762512 653.205383,705.441162 
	C652.566223,705.473389 652.130371,705.432617 652.001343,705.181213 
	C649.997803,701.277100 646.904602,699.693176 642.278198,700.474854 
	C641.865540,700.082581 641.750427,699.878296 641.632080,699.322510 
	C643.018616,695.782898 646.553467,695.573303 648.855530,693.617615 
	C642.630066,696.531860 636.736633,700.083069 630.615295,703.193970 
	C629.017700,704.005920 627.541748,705.208191 625.232422,704.486816 
	C624.749634,704.149841 624.588501,703.971741 624.261963,703.472656 
	C621.996216,692.603638 616.070557,685.155273 605.870361,680.729126 
	C604.220886,678.420654 602.472229,676.986328 599.464844,677.406006 
	C598.716064,677.664490 598.267944,677.736450 597.464600,677.744995 
	C596.423645,677.641724 595.751831,677.433105 594.704895,677.297058 
	C593.641602,677.089111 592.973267,676.836609 592.190857,676.095459 
	C591.923096,674.007874 592.144714,671.300293 589.450317,672.221680 
	C582.913452,674.457092 575.889771,673.207764 569.200806,675.234192 
	C567.285583,672.713013 569.700073,670.850464 569.618347,668.878540 
	C568.845764,670.647888 568.665833,672.771423 567.179565,674.731812 
	C565.595032,676.477356 564.191711,678.165527 562.009094,677.934692 
	C554.169373,677.105591 547.016907,681.944275 539.104736,680.538513 
	C535.865601,679.963013 533.454773,684.435486 529.513672,682.136353 
	C529.046692,681.822449 528.892273,681.690857 528.735718,681.254639 
	C529.044556,680.204895 529.581665,679.591431 530.089111,678.618530 
	C530.354797,678.207397 530.472168,678.052002 530.809265,677.709839 
	C531.352478,677.336182 531.684143,677.165344 532.249146,676.877197 
	C532.927734,676.384155 533.066040,675.891235 533.064880,675.030273 
	C533.080566,673.057800 533.625732,671.519409 534.333618,669.635132 
	C535.730774,667.158875 537.747864,666.676270 540.389099,666.685181 
	C543.826172,667.271790 546.909363,667.612549 550.277466,668.480103 
	C551.134338,668.638428 551.618469,668.739075 552.445557,668.962280 
	C553.685364,669.365967 554.561829,669.713806 555.783447,670.122803 
	C558.357605,670.675476 559.858337,673.493652 562.801514,672.013245 
	C563.099548,671.560730 563.220032,671.377869 563.545898,670.935486 
	C566.639832,665.553040 568.247803,659.954956 569.894226,653.998718 
	C570.047058,653.430359 570.118347,653.204163 570.321594,652.644531 
	C571.906921,650.132324 572.062683,647.158081 574.925415,645.607361 
	C577.999817,647.044739 575.661499,649.085876 575.822754,651.165405 
	C575.632019,651.802917 575.566833,652.104309 575.522644,652.409912 
	C575.451416,652.902344 575.658081,653.515137 574.958130,653.741821 
	C575.971619,653.623291 575.324524,652.785645 575.660156,651.997986 
	C576.617615,648.452087 577.560425,645.264893 578.805969,641.824341 
	C582.462769,638.028625 579.084656,635.496704 577.596313,632.357178 
	C577.463989,627.657471 581.003296,624.764954 581.853821,621.255920 
	C580.940186,622.428711 580.587341,624.494934 578.932495,626.149963 
	C576.366211,626.013184 574.951355,627.710632 572.864868,628.745789 
	C571.560120,629.142151 570.577881,629.182068 569.214111,628.949463 
	C568.615295,628.735168 568.387756,628.617126 567.894531,628.220459 
	C567.001648,623.401978 569.353699,619.651306 571.098877,615.388062 
	C571.859009,614.462219 572.663452,614.492981 573.367737,614.273865 
	C570.985779,613.639648 572.090698,609.484924 568.836548,609.762878 
	C567.434021,609.882629 566.475830,610.854187 565.275940,611.965881 
	C564.664490,612.657959 564.380066,613.160645 564.562927,614.117493 
	C564.644287,614.655518 564.657593,614.879028 564.619995,615.445312 
	C563.385864,618.209045 562.409363,620.832886 558.870605,621.074280 
	C556.243835,618.060852 555.363159,614.951782 556.209534,611.305054 
	C556.766235,608.906128 556.406982,606.439209 555.903503,603.633667 
	C555.466797,600.303345 555.352051,597.360657 555.971619,594.044250 
	C557.477173,591.094604 559.852966,588.957336 559.655151,585.295349 
	C559.786865,583.417725 560.150208,581.987183 561.163818,580.404663 
	C562.656555,578.940063 564.170166,577.868713 563.350830,575.410400 
	C563.246033,574.410583 563.343872,573.763733 563.801270,572.876709 
	C565.066223,571.592773 565.853821,570.407104 566.210205,568.606934 
	C566.428223,568.114624 566.535889,567.925781 566.856079,567.487793 
	C568.763367,566.026184 569.555725,564.287842 570.035706,561.996094 
	C570.220093,561.480408 570.308838,561.280457 570.573120,560.805969 
	C571.582886,559.574951 572.397888,558.606262 572.877502,557.050415 
	C573.072449,556.545349 573.158691,556.345032 573.400269,555.854126 
	C573.789917,555.186340 574.034851,554.816040 574.472595,554.167053 
	C577.014832,550.210266 580.110779,547.083923 583.018188,542.526855 
	C583.783020,541.523804 583.957825,541.375366 584.415588,541.036133 
	C587.827515,539.160095 590.787659,537.246948 593.416382,534.325806 
	C596.851562,531.519043 601.003113,530.558960 604.418945,527.695923 
	C605.704041,527.014526 606.806885,526.832153 608.143738,526.337708 
	C609.222412,525.828308 609.900818,525.298889 610.845215,524.571777 
	C611.531555,524.210205 611.958618,524.099060 612.737793,524.038086 
	C613.755249,523.904663 614.485840,524.182983 615.431885,523.663391 
	C614.211365,524.136902 613.240906,523.926575 611.909363,524.027954 
	C603.213806,525.129272 594.922424,524.982849 586.322510,523.380249 
	C585.940186,521.869690 585.883850,520.653320 585.724792,518.992188 
	C585.622070,518.547363 585.561462,518.454651 585.592163,518.408630 
	C587.829346,517.381653 589.969604,518.621521 592.553406,518.554810 
	C595.067810,518.445435 597.177979,518.577026 599.661194,518.539917 
	C602.002930,518.724426 603.735474,518.188232 605.475281,516.623291 
	C609.101379,513.448120 613.799683,514.342957 617.709656,512.078369 
	C618.821899,511.029541 619.954163,510.405884 620.172241,508.735535 
	C620.252747,508.000397 620.371033,507.592834 620.752441,506.945740 
	C623.740234,506.020081 623.472412,504.302124 622.345947,501.999817 
	C622.063416,500.971313 622.070557,500.270935 622.312134,499.232697 
	C623.835632,496.604675 623.936646,494.160309 623.171631,491.278259 
	C622.945129,490.210571 622.921753,489.485901 623.082397,488.399170 
	C623.444214,487.336853 623.906799,486.811554 624.975281,486.513733 
	C626.262939,486.255157 625.896606,487.803223 627.143066,487.497314 
	C628.428345,487.273712 629.235962,487.612549 630.152649,488.508453 
	C630.434509,488.982513 630.508850,489.190521 630.601074,489.724365 
	C630.423096,491.216370 629.689941,492.345184 630.499878,493.853149 
	C630.828979,494.724426 630.891479,495.331726 630.783203,496.246765 
	C630.495056,497.259369 630.171448,497.965820 630.533508,499.033813 
	C630.708496,499.728333 630.727173,500.141907 630.628296,500.879944 
	C630.160706,502.832581 627.287354,504.077484 629.994629,506.434326 
	C630.282532,506.925079 630.360779,507.141388 630.436829,507.701965 
	C629.674683,509.903503 628.812134,511.761749 630.722534,513.835083 
	C631.108215,514.240906 631.260193,514.407043 631.630310,514.832520 
	C635.729126,519.051392 637.026672,514.507874 639.554443,512.824097 
	C640.295349,513.068359 640.594055,513.422852 640.911377,514.189331 
	C641.160522,515.217529 641.177795,515.917847 641.133911,516.966064 
	C641.074768,517.538269 641.038147,517.765076 640.911865,518.323486 
	C640.595581,519.300598 640.278076,519.901917 639.746765,520.771851 
	C639.416382,521.226501 639.268921,521.397400 638.870239,521.795654 
	C637.294006,523.334900 634.896790,524.058594 636.236755,526.984985 
	C638.092407,528.492859 639.095276,527.896118 639.549683,526.066711 
	C639.895874,524.672729 639.668457,523.181824 640.369019,521.492676 
	C640.730957,521.022888 640.917480,520.868225 641.466919,520.666870 
	C642.853210,520.737976 643.667969,521.236328 644.538940,522.295349 
	C645.558044,523.922241 645.501160,526.340759 647.635986,526.113037 
	C649.637695,525.899414 650.162781,524.387634 650.083557,522.129211 
	C650.015320,520.186646 652.157043,519.378418 654.492065,519.660034 
	C655.358887,520.088806 654.619995,520.977783 655.274475,521.094543 
	C655.911194,521.208130 655.226379,521.324707 655.408691,520.391968 
	C657.145081,518.342224 659.418213,516.796692 657.504089,513.596375 
	C656.889221,512.461731 656.550110,511.591492 656.362366,510.307281 
	C656.437988,509.236176 656.749878,508.622742 657.492188,507.877686 
	C659.733459,506.756439 660.859253,508.758209 662.799194,509.083862 
	C663.325684,509.141754 663.537842,509.163666 664.065308,509.251526 
	C664.579407,509.399841 664.778137,509.482239 665.237976,509.750061 
	C666.761414,511.410065 668.141479,510.528717 669.819946,510.047852 
	C670.583618,509.873749 671.028137,509.811340 671.813782,509.742065 
	C674.792236,509.643433 677.544495,510.063110 680.037842,507.886078 
	C681.583740,507.808990 682.634033,508.832520 684.229675,508.361084 
	C685.075439,508.079895 685.632690,507.880005 686.432739,507.497803 
	C687.215515,507.110687 687.746216,506.875946 688.492065,506.438538 
	C689.192688,505.958191 689.629883,505.604950 690.147949,504.926025 
	C690.604675,504.186859 690.876343,503.672852 691.152710,502.827393 
	C691.565063,501.328644 691.443848,499.964325 692.751221,498.840576 
	C694.636841,498.336121 695.448608,500.265594 697.321045,500.034973 
	C698.492310,499.854492 699.357605,499.782990 700.554810,499.639252 
	C708.386597,497.828674 714.019653,493.117126 719.598450,487.707031 
	C720.387207,487.161682 720.936523,486.848877 721.584290,486.179810 
	C721.960144,485.561737 722.170715,485.201782 722.554382,484.568542 
	C722.581421,482.455719 727.954468,482.910522 724.384644,479.588226 
	C723.046082,479.301270 723.061951,480.312225 722.476929,481.193787 
	C721.831726,482.033600 721.264709,482.436737 720.287354,482.851868 
	C719.320862,483.111572 718.677185,483.206696 718.029846,483.151367 
	C712.009766,482.636902 712.010010,482.633881 711.917786,489.141296 
	C711.589417,490.114227 711.185547,490.643707 710.458557,491.328247 
	C709.904724,491.811951 709.592957,492.086578 709.084656,492.593353 
	C708.622864,493.123474 708.351501,493.416992 707.593872,494.026245 
	C706.939697,494.390167 706.759277,494.426788 706.318176,494.460632 
	C705.699707,494.426880 705.397583,494.541901 705.015442,495.028748 
	C704.637146,495.763397 704.356506,496.249512 703.560303,497.104523 
	C702.916748,497.597198 702.729492,497.685638 702.244995,497.871765 
	C701.744446,498.022003 701.541199,498.074554 701.031006,498.201355 
	C699.454102,498.527039 698.295715,499.132141 696.701843,499.455444 
	C695.162170,499.235565 694.200500,498.627258 693.361816,497.292419 
	C692.956604,495.727203 693.408691,494.566101 693.582520,493.015442 
	C693.677734,491.435730 693.722534,490.214996 694.149475,488.679626 
	C694.190613,487.797241 695.643250,487.542358 694.350403,486.499512 
	C693.476501,484.439117 693.640015,482.603790 693.544922,480.407379 
	C693.647278,478.746155 693.608276,477.458527 694.086914,475.875885 
	C695.691162,473.561157 697.422668,473.781342 699.227478,474.994843 
	C700.553345,475.886230 700.370117,474.974518 700.287354,473.809753 
	C700.426758,472.082947 701.249329,471.373444 702.938599,471.157166 
	C705.145447,471.351135 707.191650,471.078888 708.402283,473.496460 
	C708.713806,474.479401 708.690735,475.133057 708.228210,476.027008 
	C707.522583,476.844482 706.867188,477.309540 706.608582,478.409576 
	C706.360046,479.499420 706.018372,480.234100 705.389771,481.162445 
	C704.598694,482.052399 703.330383,482.103088 703.485779,483.645538 
	C703.645203,484.316528 703.641418,484.710144 703.506531,485.393494 
	C703.446960,485.682495 703.234497,486.121277 703.126953,486.300049 
	C703.019470,486.478790 702.893005,486.832153 703.017883,486.652283 
	C703.317383,486.168365 703.457031,485.848358 703.679504,485.215454 
	C706.329285,480.083832 708.934753,475.284882 711.260132,469.955688 
	C711.767639,469.309601 712.117615,469.001099 712.833618,468.613220 
	C717.583984,469.134949 715.660095,472.124664 715.366638,474.508759 
	C715.285217,475.170105 715.267273,474.324371 715.269897,474.985138 
	C715.271545,475.414307 715.609192,475.480377 716.225586,475.042267 
	C719.386658,472.380798 718.102234,468.652313 719.331482,465.307434 
	C720.993958,462.986359 724.532471,463.213531 725.130493,459.725677 
	C725.383362,459.232178 725.506531,459.045654 725.885010,458.640381 
	C726.526245,458.194427 726.927979,457.999603 727.653931,457.713745 
	C728.175476,457.528442 728.386536,457.462494 728.921509,457.328064 
	C729.683655,457.214905 730.122009,457.212402 730.882202,457.302368 
	C731.835266,457.480927 732.459778,457.648895 733.431519,457.704773 
	C736.135986,457.715820 738.614136,458.110138 740.736511,455.862671 
	C741.275208,455.536774 741.557739,455.391357 741.815796,455.210693 
	C741.888550,455.159760 741.867188,454.989960 741.932617,454.910583 
	C742.356506,454.396179 741.073730,454.688141 741.740051,454.710205 
	C741.745117,454.710358 741.758728,454.867798 741.477234,455.224854 
	C740.531372,455.098480 740.027466,454.724976 739.466125,453.913696 
	C738.406799,450.741394 741.339844,449.201294 741.759521,446.429565 
	C741.886108,445.869812 741.941772,445.646179 742.091309,445.088440 
	C742.552185,443.641205 742.804260,442.495880 743.256470,441.028442 
	C744.460205,438.547882 746.035950,437.799438 748.594360,439.131409 
	C749.074097,439.509369 749.244141,439.684784 749.593628,440.176086 
	C750.130188,441.370941 750.290833,442.304321 750.603638,443.551727 
	C750.736511,444.329529 750.741089,444.772278 750.572754,445.514374 
	C750.337280,445.953186 750.206787,446.092590 749.859985,446.313995 
	C749.643677,446.396027 749.266663,446.380188 749.266663,446.380188 
	C749.266663,446.380188 749.334656,446.753754 749.477539,446.606293 
	C749.620422,446.458832 750.099548,446.501587 750.637878,446.633484 
	C751.314575,446.922913 751.453003,447.080505 751.737305,447.530792 
	C752.360596,450.071136 752.658630,452.346771 752.931946,454.958221 
	C752.659729,456.586182 752.778320,457.813995 753.705566,459.223755 
	C754.419189,461.494110 755.160339,463.433380 754.950806,465.864136 
	C754.697632,466.942627 754.372009,467.707733 755.229858,468.652405 
	C756.059753,469.812256 756.357788,470.846069 756.440430,472.276917 
	C756.756836,473.020416 755.241211,473.205383 756.563965,473.901337 
	C757.704346,474.989197 757.996826,476.078003 757.898193,477.624207 
	C757.469543,479.261902 756.575134,480.275421 755.756714,481.689148 
	C754.993164,482.742920 753.911316,483.080750 753.587463,484.426025 
	C756.073364,490.401154 762.229187,491.601379 766.421265,495.202209 
	C768.780945,497.229095 771.785278,498.497375 773.764404,501.497314 
	C775.585815,504.206451 775.317566,508.347931 780.090820,508.323669 
	C784.257568,510.153748 789.475586,509.304749 791.486206,514.688232 
	C787.494446,517.561890 783.782959,520.445557 778.679443,521.352051 
	C772.602295,521.347412 767.131897,522.175110 762.098267,525.857605 
	C760.381226,527.263306 759.071716,528.570801 757.682007,530.285706 
	C755.201965,532.087036 755.031738,534.807312 753.636475,537.245667 
	C753.143127,537.922058 752.815430,538.272705 752.180298,538.829041 
	C750.869507,540.027832 748.627930,540.407898 749.068054,542.060486 
	C749.576172,543.968140 751.802185,543.569458 753.365051,543.549683 
	C760.460327,543.459839 767.579224,544.151367 774.646301,542.981140 
	C775.964905,542.762817 777.281860,542.762573 778.880066,543.477783 
	C781.330994,546.507690 780.058533,547.756287 777.093750,548.258301 
	C775.237793,548.572571 773.056824,547.910767 771.447266,550.242126 
	C770.405945,550.946716 769.604248,551.163025 768.362610,551.359131 
	C766.008240,551.398315 764.070007,551.376953 761.723877,551.430542 
	C754.320923,551.416443 747.405151,552.787598 740.387939,552.550781 
	C737.044189,552.437927 734.323181,554.104675 732.044067,556.493530 
	C725.953186,562.877441 720.164307,569.540771 713.928223,575.794800 
	C710.213318,579.520447 709.251648,584.600220 708.595703,589.539124 
	C707.019958,601.402893 704.961853,613.188416 703.092407,625.003235 
	C702.672668,627.656067 703.248474,630.330994 702.482971,633.331055 
	C702.282898,640.713806 702.894287,647.650085 703.473938,654.975220 
	C704.281738,658.595459 706.588562,660.387146 709.465332,661.592163 
	C715.593506,664.159058 721.503723,667.230835 728.101562,669.609985 
	C734.103210,672.114136 739.725403,674.596619 745.402039,676.953308 
	C748.289490,678.151978 750.458496,677.438660 753.222717,675.914673 
	C763.755554,670.107605 768.182312,659.949524 773.023438,649.569275 
	C773.768250,648.022095 774.619873,646.918884 775.135498,645.261353 
	C775.806763,643.664734 776.453430,642.435974 777.165649,640.845825 
	C779.523865,637.047363 781.381592,633.380371 783.291016,629.736572 
	C784.747742,626.956726 786.443726,624.294556 790.169800,623.442627 
	C790.763062,623.587524 790.985962,623.698547 791.429993,624.112061 
	C792.800720,628.862732 790.039246,632.366882 788.696045,636.175842 
	C787.432495,639.758728 785.482483,643.058350 783.353516,646.630310 
	C781.179321,652.019836 777.455627,656.098145 775.220154,661.102844 
	C772.077698,668.137817 771.807495,668.017151 777.815002,673.144897 
	C778.666687,674.026978 778.997314,674.848328 779.624390,675.857666 
	C780.235901,676.590942 780.682739,677.044983 781.393188,677.700623 
	C784.592041,681.561218 787.890259,684.924500 790.512817,689.235291 
	C790.620667,689.791260 790.629333,690.019653 790.559570,690.582397 
	C790.187134,691.542969 789.733582,692.056030 789.095947,692.855286 
	C788.750122,693.304871 788.607300,693.481628 788.240540,693.916199 
	C784.786987,697.998657 780.727478,701.210876 779.372925,706.394287 
	C780.177368,706.939148 780.493286,707.469238 780.619324,708.456543 
	C780.509521,709.464417 780.258667,710.089111 779.826782,710.999023 
	C780.702759,712.769409 775.440674,712.257812 778.970337,714.469849 
	C779.817017,714.519287 780.334534,714.418213 780.858643,713.699097 
	C781.124023,713.305359 781.230103,713.144897 781.510498,712.748535 
	C781.818420,712.367126 781.952087,712.221497 782.310974,711.882690 
	C782.700684,711.581848 782.865112,711.474182 783.288452,711.231079 
	C784.221436,710.759216 784.951416,710.518372 785.662476,709.733765 
	C785.945496,709.362976 786.060120,709.215759 786.348938,708.849854 
	C786.641296,708.486450 786.759460,708.341797 787.222351,707.751038 
	C787.783020,706.986267 787.995544,706.665344 788.367859,706.086548 
	C788.655701,705.666138 788.780701,705.501465 789.110107,705.097717 
	C790.048157,704.066833 790.646667,703.172607 791.455200,702.027466 
	C792.708679,700.673218 793.542847,699.424194 794.409241,697.787842 
	C796.125061,695.479309 797.674194,693.464111 799.296509,691.046631 
	C804.276306,682.958435 809.180847,675.263855 814.454407,667.802856 
	C816.706177,664.617004 819.333923,662.396912 823.472473,662.635071 
	C832.309937,663.143738 841.014526,662.835449 849.405884,658.507446 
	C851.620789,660.501587 850.129883,662.285767 849.540588,664.046936 
	C848.656860,666.688171 847.513672,669.235168 846.324036,672.144287 
	C846.051086,672.668518 845.932434,672.869873 845.613281,673.346252 
	C845.268188,673.786560 845.123657,673.951843 844.755737,674.346375 
	C843.710876,675.231873 843.229370,676.076477 843.070679,677.426758 
	C842.976135,677.925964 842.930542,678.125427 842.790771,678.619019 
	C842.542603,679.297791 842.375061,679.676453 842.061157,680.332642 
	C841.831421,680.801086 841.734741,680.986145 841.481812,681.441772 
	C840.742310,682.582520 840.261963,683.505371 839.764648,684.792236 
	C839.083557,686.078674 838.424438,687.000244 837.879211,688.346558 
	C837.637695,688.812500 837.530884,688.989136 837.243286,689.405579 
	C836.824219,689.961365 836.613281,690.294495 836.370483,690.940063 
	C836.213989,691.856384 836.151306,692.483765 836.043213,693.456055 
	C835.019104,696.671570 833.395813,699.125793 830.855225,701.359924 
	C828.315063,701.474365 828.013367,699.863525 827.693848,697.850403 
	C827.646179,696.685852 827.689453,695.917419 827.861328,694.791138 
	C828.630859,692.444092 829.990295,690.795654 830.935791,688.568237 
	C831.419495,687.749512 831.780884,687.237366 832.044800,686.346619 
	C832.109924,685.846924 832.124817,685.644531 832.164307,685.134277 
	C832.220886,684.620483 832.252991,684.414429 832.359924,683.902222 
	C832.555298,683.183777 832.680481,682.772888 832.898804,682.041016 
	C833.217773,680.924988 833.447144,680.127686 833.745483,679.359558 
	C835.128113,675.799805 833.534119,675.253357 830.157837,676.179993 
	C829.338013,676.288391 828.867004,676.325012 828.040894,676.358643 
	C825.824463,676.357178 823.961670,676.340637 821.768616,676.352661 
	C820.610840,676.430420 819.740295,676.313965 818.798462,677.134888 
	C818.385864,677.474731 818.218750,677.612427 817.792603,677.954285 
	C815.104980,680.146240 812.347778,681.948975 813.048035,686.087280 
	C810.797729,686.991943 810.682556,688.443298 811.265259,690.513184 
	C811.305298,691.292358 811.306335,691.739807 811.284058,692.528076 
	C811.332092,694.326538 810.358215,696.000488 812.439331,697.290344 
	C813.247864,697.974060 813.536682,698.568420 813.435913,699.626221 
	C811.515503,702.032166 808.990173,700.435303 806.728882,701.429382 
	C806.419922,702.072083 806.318054,702.475647 806.178467,703.203491 
	C805.897583,704.617188 805.498779,705.642822 804.725098,706.860718 
	C803.082947,708.201233 803.076172,709.386902 804.405762,710.964172 
	C804.640808,711.708618 804.641418,712.154297 804.422119,712.915649 
	C799.745056,715.444275 799.346375,715.221069 796.754700,709.183350 
	C792.738708,710.573425 790.015442,712.973022 788.686768,716.797791 
	C788.578064,717.110718 788.487549,717.418396 788.489258,717.746338 
	C788.700562,717.527039 788.619751,717.214905 788.950928,716.710693 
	C790.589417,715.507080 792.361755,715.787476 794.212280,715.020630 
	C795.489380,714.681274 796.429199,714.509521 797.724915,714.701111 
	C798.617188,716.183289 797.914856,718.051270 799.716064,719.257446 
	C799.724976,719.922485 799.651245,720.270325 799.690552,720.546265 
	C800.081970,720.433838 800.234436,720.355530 800.633911,720.172791 
	C801.411804,719.872498 801.950867,719.699341 802.767578,719.401001 
	C803.251770,719.251160 803.449768,719.202332 803.952698,719.115723 
	C804.661438,719.070068 805.063782,719.090027 805.753113,719.176819 
	C806.795471,719.339050 807.495911,719.310486 808.101807,718.307434 
	C808.372314,717.895447 808.485596,717.730530 808.797852,717.333008 
	C809.150085,716.961365 809.303406,716.822327 809.714539,716.505005 
	C810.340576,716.121460 810.719910,715.939331 811.732910,715.649658 
	C812.562317,715.555237 812.770874,715.594910 813.254639,715.792847 
	C814.341431,716.614075 814.991516,717.430359 815.880493,718.443909 
	C816.886719,719.815735 818.248413,719.738953 819.671509,720.311035 
	C820.351440,720.665222 820.682434,720.947205 821.217407,721.498657 
	C822.785034,723.201477 824.185120,724.548157 826.667480,724.692017 
	C827.225403,724.734009 827.449585,724.752319 828.010864,724.809326 
	C830.823303,725.315979 833.344299,725.346741 836.205261,725.642334 
	C836.822021,725.673828 837.072388,725.693237 837.701843,725.777100 
	C839.134644,726.127075 840.070862,726.563171 840.322693,728.075562 
	C834.934143,729.859680 829.729858,728.578735 824.603882,727.839355 
	C820.085327,727.187622 821.803101,729.020935 822.649658,731.325439 
	C822.209351,731.972351 821.732666,731.939819 821.656250,732.053772 
	C821.288635,732.601257 822.365356,732.790161 821.830627,732.392090 
	C821.295898,731.993958 822.524414,731.552002 822.281494,731.928040 
	C826.314270,732.848389 826.317139,736.301758 827.236023,739.541992 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M601.452759,1012.632446 
	C600.656372,1009.374878 601.903381,1007.745850 605.278015,1007.972778 
	C604.372192,1006.379089 602.677673,1007.307312 601.246216,1006.035400 
	C600.674744,1005.543518 600.667969,1005.342285 600.816528,1004.881470 
	C601.399597,1004.208130 601.901123,1003.889954 602.583252,1003.347290 
	C603.028625,1002.882324 603.249756,1002.594849 603.552124,1002.066895 
	C600.576660,1000.598694 598.288696,1002.498413 595.636841,1004.024841 
	C595.291199,1004.410339 595.158630,1004.566833 594.807922,1004.934692 
	C594.282471,1005.392822 593.961365,1005.620239 593.389160,1005.980103 
	C592.998779,1006.236694 592.844482,1006.339233 592.465576,1006.600830 
	C591.945862,1006.979126 591.651978,1007.199890 591.147461,1007.602539 
	C590.507263,1008.157654 590.085083,1008.539368 589.459961,1009.151855 
	C589.060974,1009.476379 588.886292,1009.593201 588.418579,1009.842346 
	C587.276794,1010.272644 586.502563,1010.756287 585.279541,1011.099854 
	C581.219238,1012.835205 577.330933,1011.835083 573.138428,1011.955872 
	C571.522827,1011.825012 570.366028,1011.343201 568.797607,1011.070312 
	C567.550354,1010.739502 566.680481,1010.376282 565.389893,1010.263794 
	C564.573547,1010.155029 564.108643,1010.066467 563.295715,1009.868408 
	C562.232361,1009.562744 561.581970,1009.206055 560.577271,1008.705933 
	C560.033997,1008.359009 559.824280,1008.203491 559.420288,1007.701538 
	C558.876038,1006.273499 558.961426,1005.225220 559.730347,1003.894165 
	C564.328735,1001.517822 568.433594,1003.907227 572.631775,1004.292725 
	C576.871094,1004.682068 581.014160,1006.608521 585.685425,1004.721313 
	C588.791687,1003.051086 590.877991,1000.586853 594.092163,999.064514 
	C597.899414,997.733276 601.354187,996.614502 605.046448,996.722961 
	C607.113708,996.783630 608.898376,997.530334 610.439941,999.571411 
	C611.105957,1001.081299 611.117249,1002.202881 610.254089,1003.649292 
	C609.997559,1004.002441 610.000000,1004.000000 610.000366,1003.999207 
	C608.247742,1005.846252 609.764832,1007.439636 610.369080,1009.474548 
	C607.912720,1012.044800 605.175110,1013.353149 601.452759,1012.632446 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M540.361084,1018.537964 
	C540.218079,1016.575012 538.900696,1015.920288 537.299805,1015.129761 
	C536.945984,1013.726685 537.922791,1013.137146 538.872742,1012.141846 
	C544.782532,1008.937622 548.784851,1003.705566 554.584839,1000.285278 
	C555.439514,1000.141968 555.932373,1000.182007 556.765015,1000.450073 
	C557.716064,1001.088745 558.138306,1001.712402 558.629883,1002.740479 
	C559.018982,1004.063599 558.967834,1005.048218 558.755554,1006.381348 
	C558.233154,1007.697632 557.236816,1007.963989 556.224609,1008.762573 
	C555.966614,1009.002808 556.008911,1009.008057 556.007751,1008.986816 
	C554.490417,1010.085999 555.712830,1011.769287 555.117432,1013.400635 
	C555.053955,1013.940979 555.032471,1014.168274 554.989014,1014.737427 
	C554.568054,1015.328125 554.147034,1015.531860 553.366272,1015.785767 
	C551.083313,1016.228149 549.948425,1014.227661 547.967773,1014.395874 
	C547.746826,1014.768677 547.693115,1014.937622 547.607300,1015.656372 
	C547.522827,1016.385559 547.470581,1016.565002 547.198975,1016.919312 
	C546.443237,1018.208923 545.567627,1018.867126 543.997070,1019.125671 
	C542.672729,1019.023132 541.692749,1018.848206 540.361084,1018.537964 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M600.849548,1012.651062 
	C604.372986,1011.641846 607.638062,1010.845703 610.921387,1009.580505 
	C610.495239,1009.024231 610.317993,1008.877258 610.408142,1008.670471 
	C610.512146,1008.431946 610.627747,1008.312744 610.890991,1008.655579 
	C613.477295,1010.645996 616.063477,1009.874451 618.632202,1009.427429 
	C624.738403,1008.364868 630.838257,1007.251282 637.490356,1007.148254 
	C638.119446,1007.317688 638.317383,1007.432434 638.261597,1007.778259 
	C632.510437,1009.020752 627.022461,1010.086243 621.513550,1011.030151 
	C614.337402,1012.259705 607.190491,1013.606873 600.189331,1015.636353 
	C598.642517,1016.084717 597.106140,1016.571594 594.642517,1015.923157 
	C597.070007,1014.674805 598.830566,1013.769470 600.849548,1012.651062 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M642.691772,1013.752686 
	C642.922791,1014.487854 642.895203,1014.904236 642.752563,1015.611572 
	C642.509583,1016.087830 642.381775,1016.273132 641.974243,1016.648560 
	C641.489624,1016.933289 641.284790,1017.027832 640.761719,1017.236694 
	C637.853271,1017.945251 635.432983,1019.538757 632.292725,1018.539612 
	C626.793457,1018.675781 621.742371,1020.689697 615.093567,1019.640808 
	C624.665100,1017.855042 632.988464,1016.421631 641.317566,1013.461365 
	C641.903625,1013.295654 642.168396,1013.364746 642.691772,1013.752686 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M571.637146,1010.779663 
	C576.458008,1011.236877 580.903992,1011.245728 585.698730,1010.288696 
	C586.691345,1009.230286 587.679565,1009.650330 588.676880,1009.149231 
	C588.878906,1008.892700 588.985718,1008.913391 588.938904,1008.885620 
	C589.763916,1008.222473 590.742310,1007.988953 592.176270,1008.198853 
	C592.748474,1008.467896 592.952271,1008.622925 593.114258,1009.159790 
	C586.363220,1012.935608 579.223999,1013.707581 571.429749,1012.899414 
	C569.798584,1012.024109 568.039978,1013.195190 566.914856,1011.533630 
	C568.060181,1009.766357 569.821899,1010.769653 571.637146,1010.779663 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M641.775085,1016.235962 
	C641.961670,1016.065186 642.271729,1015.866272 642.454590,1015.884399 
	C643.510376,1016.617920 647.150818,1014.373718 645.073364,1018.510986 
	C640.995911,1019.298279 636.950195,1019.784912 632.468994,1020.215454 
	C632.024658,1019.865356 632.015869,1019.571411 631.998047,1018.835327 
	C634.779724,1017.677673 637.570496,1016.962097 640.736206,1016.242920 
	C641.270203,1016.295166 641.429382,1016.350952 641.775085,1016.235962 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M571.703430,1010.822388 
	C570.748901,1010.994446 569.494812,1010.994446 568.181702,1010.994446 
	C568.519348,1012.575562 569.935364,1011.662415 570.799927,1012.544800 
	C567.488342,1013.210999 564.168823,1012.663208 561.310242,1010.449158 
	C559.914307,1009.367981 558.411438,1009.049377 556.350037,1009.085449 
	C555.899475,1007.980225 556.470398,1007.447205 557.685425,1007.098755 
	C558.634766,1006.503479 559.111877,1006.849121 559.815186,1007.503540 
	C560.063965,1007.689453 560.523682,1007.876038 560.764404,1007.935913 
	C561.388245,1008.434753 561.918579,1008.503357 562.704651,1008.652466 
	C563.349854,1008.849365 563.740295,1008.963379 564.431885,1009.126160 
	C565.587036,1009.553833 566.507935,1009.488403 567.694092,1009.758362 
	C569.123108,1010.175964 570.263550,1010.413147 571.703430,1010.822388 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M560.931274,1021.841431 
	C560.102844,1021.624084 559.554626,1021.544678 559.214417,1021.236023 
	C558.618347,1020.695190 559.200745,1020.317810 559.626770,1020.357605 
	C562.732544,1020.647583 565.831055,1021.015808 570.099731,1021.488647 
	C566.415649,1022.441040 563.850403,1021.949219 560.931274,1021.841431 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M552.742188,1015.215210 
	C553.444885,1014.978394 553.884216,1014.955872 554.645386,1015.006287 
	C553.513000,1017.996887 551.513489,1019.548706 547.974487,1017.534546 
	C547.814697,1017.060425 547.870667,1016.836426 548.200500,1016.399780 
	C549.734619,1015.540222 551.208801,1016.024658 552.742188,1015.215210 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M555.340088,1013.620972 
	C555.268433,1012.170654 552.166687,1010.427734 555.682007,1009.016113 
	C555.642029,1010.466125 557.087280,1012.126099 555.340088,1013.620972 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M638.363098,1008.104492 
	C638.007751,1008.009277 637.899719,1007.613037 637.910645,1007.407959 
	C639.479492,1008.140991 642.080933,1003.403809 642.941284,1008.497803 
	C641.532532,1008.646179 640.125488,1008.422913 638.363098,1008.104492 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M609.667603,1020.025269 
	C611.492798,1020.025391 612.998474,1019.544983 614.471069,1020.439392 
	C612.755676,1021.482056 610.972656,1020.946411 609.250732,1020.952087 
	C609.123413,1020.952454 608.871155,1020.697449 608.888184,1020.661560 
	C608.988525,1020.450562 609.151550,1020.269348 609.667603,1020.025269 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M642.994385,1013.685181 
	C642.713501,1013.960754 642.476685,1013.850037 641.939331,1013.482910 
	C640.993591,1012.137207 641.054688,1011.313416 642.744568,1010.983154 
	C643.021729,1011.743103 643.030090,1012.521057 642.994385,1013.685181 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M636.956055,1011.325928 
	C637.482483,1011.298035 637.855042,1011.420959 638.227539,1011.543945 
	C638.124573,1011.644836 637.998779,1011.846741 637.922485,1011.829468 
	C637.541931,1011.743591 637.174316,1011.600037 636.956055,1011.325928 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M595.310059,1008.104370 
	C594.793884,1008.735413 594.230713,1009.010620 593.370056,1009.413757 
	C593.072571,1009.541687 592.987610,1009.130737 592.798706,1009.039368 
	C592.662476,1008.126953 593.140076,1007.667480 594.251099,1007.445801 
	C594.827942,1007.549561 595.045532,1007.649048 595.310059,1008.104370 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M600.787048,1004.807617 
	C601.171936,1005.165100 601.271301,1005.323792 601.293640,1005.752197 
	C600.745605,1006.063965 600.274658,1006.106079 599.312744,1005.804199 
	C599.147095,1004.713440 599.739746,1004.494324 600.787048,1004.807617 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M597.383118,1007.106384 
	C596.900146,1007.742126 596.410583,1008.031738 595.639038,1008.390808 
	C595.357056,1008.460266 595.114563,1008.146423 594.992737,1007.989868 
	C594.841919,1007.001831 595.332153,1006.608643 596.410156,1006.436584 
	C596.962769,1006.555603 597.169678,1006.657898 597.383118,1007.106384 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M547.176025,1017.135193 
	C546.944946,1016.915588 546.910156,1016.737122 546.923096,1016.289917 
	C547.332947,1015.781555 547.724548,1015.729370 548.408081,1015.997559 
	C548.522400,1016.345520 548.369934,1016.533386 547.988037,1017.002930 
	C547.758667,1017.284485 547.372375,1017.176270 547.176025,1017.135193 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M598.207458,1006.726746 
	C598.019348,1007.004395 597.767639,1007.317383 597.578613,1007.384949 
	C597.389648,1007.452515 597.133484,1007.156189 597.005493,1007.007996 
	C596.846558,1006.384338 597.048950,1006.032532 597.780273,1005.812439 
	C598.207520,1006.043335 598.301514,1006.246216 598.207458,1006.726746 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M598.283936,1006.959045 
	C598.019348,1007.004395 598.002014,1006.569031 597.991333,1006.351440 
	C598.141479,1005.985962 598.302368,1005.838074 598.742432,1005.861572 
	C599.021729,1006.033081 599.064941,1006.055725 599.080933,1006.076782 
	C598.914124,1006.369812 598.731323,1006.641724 598.283936,1006.959045 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M597.533813,1010.549377 
	C597.478210,1010.581848 597.589355,1010.516907 597.533813,1010.549377 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M1009.371948,975.213989 
	C1004.227112,974.589233 1002.532654,972.531128 1003.226013,967.598999 
	C1003.704529,964.194702 1004.071838,960.401062 1009.161743,960.761475 
	C1011.399231,960.919861 1013.043945,961.807251 1013.751648,963.920044 
	C1014.649292,966.599731 1015.659424,969.428955 1013.485657,971.951477 
	C1012.428162,973.178711 1010.980896,974.070190 1009.371948,975.213989 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M1019.115356,986.592346 
	C1019.002136,987.749939 1018.813660,988.549805 1018.388428,989.542725 
	C1018.072021,987.917053 1017.495422,986.092896 1018.627197,984.163147 
	C1019.041077,984.773621 1019.040527,985.504089 1019.115356,986.592346 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M1018.928528,983.913330 
	C1019.328735,983.158203 1019.836487,982.755310 1020.602661,983.475647 
	C1020.280823,983.656494 1019.959045,983.837341 1019.339355,984.030640 
	C1019.041565,984.043091 1018.965210,983.957397 1018.928528,983.913330 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M874.244690,497.919678 
	C872.200623,499.152130 873.354126,500.024506 874.194702,501.148132 
	C873.791931,501.896759 873.232605,502.401123 872.286987,502.971222 
	C869.240295,503.415680 868.179077,501.171753 866.788635,499.709290 
	C862.409302,495.102997 857.471741,493.583801 851.128662,495.175720 
	C844.090637,496.941956 837.131042,499.013336 829.695312,500.745605 
	C828.856689,501.031128 828.367310,501.155792 827.501465,501.318237 
	C824.218689,501.854309 821.453674,503.119171 818.086426,502.937286 
	C813.977966,500.958527 816.860229,499.507996 818.233215,497.651550 
	C818.508362,497.173889 818.630310,496.987732 819.006592,496.581299 
	C820.030579,495.873138 820.888855,495.589539 822.062500,495.183319 
	C825.440247,494.442505 828.647522,494.477875 831.744263,492.753052 
	C832.826965,491.357910 835.108582,491.517181 834.809570,489.015198 
	C834.700439,487.745209 834.708618,486.814758 834.673706,485.529877 
	C834.660889,484.696899 834.661743,484.219482 834.664429,483.380127 
	C834.648804,482.292358 834.673828,481.566650 834.658813,480.476196 
	C834.650024,479.868622 834.646973,479.625763 834.642212,479.018951 
	C834.636475,477.208130 834.694946,475.762848 834.777222,473.964447 
	C834.835327,473.380981 834.868164,473.150574 834.969238,472.582520 
	C835.864136,470.193665 834.951721,468.334595 834.311829,466.100037 
	C834.160767,465.298340 834.140076,464.830444 834.193787,464.004395 
	C834.677246,461.763123 834.670593,459.844666 834.641357,457.558563 
	C834.626709,456.946045 834.623169,456.700317 834.618164,456.084839 
	C834.594604,454.231781 834.685181,452.749329 834.641113,450.898132 
	C834.629761,450.286804 834.627319,450.043335 834.624268,449.436981 
	C834.586914,445.053650 834.248047,441.028137 834.955200,436.716614 
	C835.644653,435.752197 835.792908,435.058350 835.133667,434.007263 
	C834.561829,430.544312 834.447327,427.382935 834.895264,423.864441 
	C834.812866,423.032654 834.768311,422.551178 834.701782,421.691223 
	C834.610229,418.943146 834.631897,416.589752 836.279602,414.217346 
	C837.204041,413.464417 837.924011,413.366577 839.003906,413.788544 
	C840.136353,414.701904 840.805176,415.693329 842.440308,415.636597 
	C848.340820,415.049591 853.546204,417.465363 859.581909,417.720093 
	C852.176270,415.194305 844.753967,415.516754 837.557373,413.059143 
	C836.715393,413.024963 836.236572,412.968719 835.427612,412.713257 
	C834.250671,411.964752 833.841553,411.096588 833.516846,409.796753 
	C833.498413,407.481995 834.682312,405.677704 834.240479,403.329102 
	C834.148682,402.797272 834.116943,402.583862 834.066284,402.047943 
	C834.017822,400.267639 834.820374,398.849335 834.160156,397.066223 
	C833.734070,394.231445 831.718262,394.198364 829.503540,393.884979 
	C817.331726,393.340027 806.218201,389.068512 794.619080,387.376923 
	C791.845642,386.972443 789.112305,386.272583 785.916382,386.067108 
	C785.031067,386.032440 784.533264,385.980499 783.688538,385.798767 
	C781.602722,384.772308 779.709534,385.116791 777.499756,384.957275 
	C776.624939,384.697906 776.199524,384.400360 775.848999,383.581360 
	C779.359070,378.859497 784.239868,380.488556 788.426880,380.822418 
	C796.003540,381.426544 803.591187,382.436768 811.422546,384.389404 
	C814.636475,384.459930 817.313354,385.221405 820.421143,385.862000 
	C830.480591,389.197449 839.967163,389.421295 849.292480,384.627380 
	C852.539368,382.958252 856.265076,382.306152 859.486084,380.600433 
	C864.085266,378.164886 868.421692,378.635010 872.825684,380.888214 
	C877.267761,383.160889 881.804504,385.227631 886.779297,387.304260 
	C887.922729,388.345947 888.332031,389.374542 888.854614,390.811188 
	C889.443542,393.152039 889.363770,395.111237 889.115662,397.498413 
	C888.912964,399.072296 888.484985,400.172333 888.454590,401.798706 
	C888.362061,430.283447 888.914185,458.310822 888.633057,486.789185 
	C888.586792,487.525940 888.550842,487.813660 888.467407,488.523254 
	C888.369812,489.474182 888.284668,489.997406 888.035278,490.849304 
	C887.730103,492.226929 886.087158,492.206390 886.334473,493.769897 
	C886.490784,495.067383 887.467773,495.916565 886.674500,497.227051 
	C882.414368,497.641937 878.447693,497.303680 874.244690,497.919678 
z"/>
<path fill="#E0CEF7" opacity="1.000000" stroke="none" 
	d="
M873.987915,506.688599 
	C874.668152,506.886017 874.894653,507.039703 875.056641,507.550110 
	C875.465698,508.409821 875.400635,509.279236 876.478760,509.707825 
	C876.858826,509.651855 877.187256,509.955566 877.215210,510.066437 
	C877.093140,510.761353 877.239746,511.257599 878.097900,511.644775 
	C878.512085,511.623688 878.390137,511.523865 878.466431,511.543457 
	C878.666565,512.741516 879.061829,513.829529 879.739929,514.792236 
	C884.086975,520.963684 887.522644,527.491943 888.766602,535.091980 
	C889.219849,537.861755 891.733826,539.364990 894.056335,540.755432 
	C900.523193,544.626953 900.511230,544.635925 898.577026,551.976562 
	C898.452698,552.448608 898.553345,552.969788 898.555542,553.839050 
	C895.339966,557.657532 893.665894,557.724365 891.271423,554.349365 
	C890.419617,553.148804 889.654419,551.875977 888.613159,550.355957 
	C882.104736,539.802368 874.933777,530.260071 865.456665,522.179565 
	C864.793579,521.720154 864.434875,521.431091 863.840881,520.884949 
	C863.280640,520.307190 863.002258,519.943542 862.620483,519.244995 
	C862.442200,518.719727 862.403198,518.501892 862.378967,517.958496 
	C862.986511,516.107605 862.271729,514.859192 861.477051,513.296997 
	C861.437073,512.763550 861.462402,512.547119 861.647888,512.045105 
	C862.096619,511.492035 862.155396,511.278168 861.991211,511.111053 
	C861.854126,510.971375 861.725769,510.897400 861.473389,510.559875 
	C861.230774,508.896027 861.784668,507.783386 862.709473,506.402039 
	C867.515930,502.844513 868.852539,502.895569 873.987915,506.688599 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M898.594910,554.800537 
	C896.912170,552.920837 895.668152,551.438110 898.022156,549.312866 
	C900.340942,547.219238 900.108215,545.384155 896.870605,543.779602 
	C894.153442,542.433044 891.011536,541.448853 889.153564,538.670105 
	C888.699280,537.990662 887.535034,537.308960 887.632263,536.810486 
	C888.784546,530.899170 882.657104,527.213501 883.064087,521.669739 
	C883.230225,519.406616 881.054077,519.850342 880.463440,518.705505 
	C879.428528,516.699585 877.744751,514.878967 878.393555,511.945282 
	C880.737061,513.997803 882.931335,516.432556 885.406677,519.035889 
	C885.687683,519.204468 885.702148,519.146240 885.698914,519.173462 
	C886.108093,519.273865 886.451294,519.468872 886.681519,520.087769 
	C886.637085,520.390625 886.752747,519.980835 886.682617,520.182373 
	C888.931702,521.291809 890.109131,523.138733 890.749512,525.765198 
	C890.969971,526.639648 891.196655,527.170959 891.671021,527.858765 
	C895.865540,535.099609 901.057617,541.423218 904.570496,548.779114 
	C905.246338,550.194153 906.615112,551.424438 904.397827,553.011353 
	C902.745117,554.792236 901.009216,555.307129 898.594910,554.800537 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M874.240356,506.561859 
	C872.302063,507.530426 871.147949,505.693634 869.529663,505.181519 
	C867.313049,504.480072 865.440002,505.328125 863.461243,506.928345 
	C860.087769,506.700500 857.705078,504.512970 854.433899,503.924316 
	C852.463013,500.702881 849.894348,499.919159 846.586060,500.244354 
	C843.444641,500.553101 840.372742,501.021515 837.296143,501.740387 
	C834.463440,502.402252 831.431213,503.313324 828.949707,500.376556 
	C837.422729,497.065033 846.103333,495.079071 854.758545,492.995056 
	C858.682800,492.050140 861.878784,493.160797 864.614807,496.082672 
	C866.763062,498.376801 869.071655,500.520874 871.604797,502.884338 
	C872.645996,504.107147 873.391357,505.177307 874.240356,506.561859 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M933.196594,518.314697 
	C929.801392,519.782776 926.061035,518.010681 922.879822,519.934753 
	C922.107056,520.402100 920.263184,520.196960 919.610168,519.571716 
	C916.911499,516.987793 914.429871,517.290588 911.820740,519.521851 
	C911.695190,519.629333 911.546570,519.858765 911.455811,519.836792 
	C903.859741,517.998596 895.635681,522.946777 888.229858,517.374512 
	C911.771545,516.063965 935.441895,515.085815 959.567749,514.157227 
	C960.578613,514.724792 960.676331,515.356140 960.270142,516.325562 
	C957.181152,516.435486 954.541626,515.776245 951.806885,518.287842 
	C949.940002,520.002502 945.993103,518.269836 944.137329,517.549927 
	C940.363586,516.085999 939.046631,518.388306 936.537354,519.825073 
	C935.269409,519.453857 934.294006,519.101868 933.196594,518.314697 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M960.375977,516.779663 
	C960.038513,515.995361 960.019165,515.399231 960.011597,514.505005 
	C962.373230,514.150146 964.723145,514.093445 967.507935,514.110596 
	C968.288574,515.645569 966.901245,515.323547 966.137451,516.102661 
	C964.420837,518.461426 962.708923,519.153137 960.375977,516.779663 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M893.019043,512.967651 
	C892.905212,514.316772 892.198303,515.042236 890.763245,514.932129 
	C890.260498,514.893555 889.675232,514.738831 889.880859,514.133240 
	C890.278931,512.961182 891.405090,513.093323 892.715332,512.978210 
	C893.063232,512.965271 893.002686,512.997864 893.019043,512.967651 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M966.388794,516.367920 
	C966.509399,515.822327 967.029297,515.234558 967.746033,514.415588 
	C968.405762,514.139893 968.868774,514.095398 969.677490,514.104065 
	C969.995117,514.647339 969.967041,515.137451 969.912659,515.995239 
	C968.857910,515.990845 967.827271,515.799377 966.388794,516.367920 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M991.516479,508.943787 
	C991.197693,508.066803 991.820679,507.944763 992.774841,507.920715 
	C993.413452,509.233276 992.437378,508.853760 991.516479,508.943787 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M876.712158,509.353302 
	C876.007812,509.705322 875.395813,509.397430 875.123108,508.144470 
	C875.581604,508.193512 876.073486,508.624146 876.712158,509.353302 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M878.368286,511.323120 
	C878.112976,511.389160 877.713867,511.154663 877.278931,510.548737 
	C877.570251,510.459076 877.897400,510.740845 878.368286,511.323120 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M32.244896,534.259155 
	C32.691254,535.281799 32.830303,536.141663 32.995609,537.438171 
	C32.736691,539.629944 31.590836,540.394226 29.575497,540.507324 
	C27.335028,539.383301 25.233219,538.884338 23.194637,538.223999 
	C22.567770,538.021057 22.125221,538.328186 22.776058,538.430420 
	C23.039946,538.471924 23.174646,538.923523 23.249153,539.559387 
	C19.428999,540.217468 22.278078,543.131714 21.140560,544.810059 
	C17.705004,545.425842 17.919510,541.478760 15.232746,540.793823 
	C14.720931,540.648010 14.519220,540.581482 14.044102,540.354858 
	C13.321931,539.757385 13.035805,539.201050 12.441636,538.507446 
	C11.637969,537.302307 10.699239,536.995483 9.233690,536.891113 
	C12.152409,535.112976 15.454628,533.406494 18.959797,531.404297 
	C31.014191,524.651733 41.698376,516.625366 51.638603,507.051300 
	C52.429993,507.260223 52.913555,507.602631 53.705933,507.980560 
	C54.586861,508.944916 54.152138,509.759033 53.518505,510.835968 
	C52.232254,512.102295 50.650280,512.479370 49.664467,514.099609 
	C48.340210,515.606018 46.815170,516.427063 45.513500,517.962769 
	C44.305023,518.974060 43.066090,519.355469 41.871597,520.393921 
	C40.995449,521.178284 40.358921,521.755188 39.537346,522.623779 
	C38.475174,523.660461 37.555798,524.334717 36.257774,525.074219 
	C31.091684,527.972961 26.840553,531.595276 21.953793,534.370972 
	C25.385332,533.271851 28.657238,533.613403 32.244896,534.259155 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M943.038818,524.039795 
	C950.878845,524.489319 958.704590,524.933350 966.530396,525.377380 
	C960.865234,527.448364 955.098694,527.416504 949.390015,526.727600 
	C945.753662,526.288757 942.460388,525.700623 938.862610,527.575317 
	C936.694397,528.705017 933.621521,528.501587 931.125061,527.344910 
	C930.156128,526.895996 929.668701,526.545105 928.575378,527.251648 
	C925.185791,529.441956 923.118774,526.904297 921.027710,524.460510 
	C927.564453,523.893494 934.073120,523.666504 940.917603,523.590698 
	C941.422485,524.492798 941.968506,524.490234 942.792969,524.225830 
	C943.025391,524.055786 943.024536,524.034302 943.038818,524.039795 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M918.560425,523.955688 
	C918.952759,525.850098 917.699646,525.992249 916.284790,526.051025 
	C914.245178,526.135742 912.396851,525.968567 910.335388,527.390442 
	C908.436035,528.700623 907.426147,527.009277 908.879333,524.629333 
	C912.109924,524.216980 915.110535,524.051453 918.560425,523.955688 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M891.046509,525.891968 
	C889.446777,524.400940 888.150269,522.693665 886.733093,520.685181 
	C889.934509,520.587524 892.975403,521.042786 891.046509,525.891968 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M1017.544067,523.142578 
	C1016.791260,522.635742 1016.420959,522.085693 1016.051758,521.187500 
	C1016.052795,520.839233 1016.111511,520.829590 1016.136841,520.845093 
	C1017.485046,520.378113 1018.815186,519.988037 1020.588013,520.736938 
	C1021.519409,521.146667 1022.083069,521.356812 1022.823486,521.816895 
	C1021.513000,523.413025 1019.627380,522.801636 1017.544067,523.142578 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M1020.857788,520.622253 
	C1019.620789,520.902832 1018.285767,520.869080 1016.556519,520.848022 
	C1017.608582,519.959778 1018.877136,517.579590 1020.857788,520.622253 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M1011.421997,522.246460 
	C1010.797913,521.819641 1010.468628,521.585632 1009.991638,521.078491 
	C1010.734619,519.994385 1011.695312,519.610168 1013.042358,520.575256 
	C1013.300842,521.048584 1013.351685,521.261719 1013.177490,521.714233 
	C1012.952332,521.953613 1013.003784,521.992737 1012.980713,521.968506 
	C1012.620850,522.301758 1012.207214,522.466614 1011.421997,522.246460 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M933.048706,518.469971 
	C934.334351,517.512512 934.965515,518.671143 936.001526,519.619751 
	C935.012573,520.013611 933.794800,520.217285 933.048706,518.469971 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M942.730469,523.996643 
	C942.545410,524.830078 941.968689,524.843079 941.285645,524.007385 
	C941.647583,523.807129 942.041565,523.872314 942.730469,523.996643 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M886.624146,520.101685 
	C886.368530,520.167297 886.099976,519.943970 885.763550,519.460693 
	C886.000854,519.404785 886.306030,519.608765 886.624146,520.101685 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M1013.188416,521.859009 
	C1012.955627,521.755737 1012.958923,521.557800 1013.106201,521.097656 
	C1013.250061,520.835510 1013.584595,520.888062 1013.752686,520.897461 
	C1013.755310,521.192749 1013.589905,521.478638 1013.188416,521.859009 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M27.752426,615.064941 
	C31.776937,614.403320 28.480820,612.865356 28.154108,612.487000 
	C26.874609,611.004944 25.920681,610.005920 29.317591,610.285645 
	C30.055437,610.329956 30.394926,610.465576 30.890125,610.932556 
	C31.485418,611.576294 31.966497,611.902222 32.733406,612.353516 
	C34.537922,613.952515 36.731758,613.126892 38.695152,614.212402 
	C39.947437,615.246887 41.273617,615.086853 42.626617,615.727051 
	C42.851871,615.938904 42.964027,616.340759 42.973007,616.549194 
	C43.357105,617.270447 43.930050,617.602478 44.288353,618.464966 
	C44.215969,618.950867 44.115589,619.128052 43.799110,619.490479 
	C43.441795,619.777039 43.300583,619.878357 43.082745,620.454224 
	C42.545597,622.859314 44.829590,623.599304 44.956268,625.635193 
	C43.102150,626.266846 42.627937,623.568176 40.363308,623.967163 
	C38.361923,620.726685 38.361923,620.726685 35.019272,624.656311 
	C30.121536,628.090576 28.985779,623.362793 26.336205,621.044922 
	C24.925709,621.556274 24.361624,620.881653 23.710831,619.847290 
	C23.563162,618.864441 23.771912,618.253296 24.225086,617.389038 
	C24.527929,616.959290 24.667019,616.802307 25.055576,616.459290 
	C26.005741,615.863037 26.738461,615.515503 27.752426,615.064941 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M46.851875,619.528687 
	C48.245014,618.713501 48.203346,616.324951 50.661762,616.964478 
	C51.034992,616.981628 51.141052,617.153564 51.065674,617.088196 
	C50.916496,615.708923 51.058277,614.510071 52.614826,615.968567 
	C53.657898,616.945984 54.463718,617.716675 55.852859,615.948364 
	C57.734165,614.883423 58.774494,615.963074 60.141121,617.031860 
	C60.714245,617.615906 60.994499,617.989014 61.385796,618.705933 
	C61.616428,619.488770 61.600006,619.946838 61.249222,620.673340 
	C61.036663,620.947815 60.972851,621.037170 60.925129,621.064331 
	C60.186756,621.624634 59.427074,621.691040 58.284603,621.203857 
	C57.950897,620.981995 58.010445,620.979065 58.012638,621.008789 
	C57.887947,620.678894 57.632305,620.506287 57.156158,620.744995 
	C56.194939,622.350952 54.604969,622.346191 52.849163,623.030762 
	C52.383572,623.143372 51.984360,623.277771 51.823719,623.421692 
	C51.663078,623.565613 51.333424,623.854614 51.131393,623.939697 
	C50.198868,624.001160 49.468380,623.977539 48.372780,623.975891 
	C47.317314,623.539673 46.886086,622.890869 46.569248,621.826050 
	C46.491898,620.941406 46.571739,620.359375 46.851875,619.528687 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M15.618080,619.432983 
	C16.772930,618.824219 17.683849,618.445068 18.967604,618.021973 
	C20.189270,617.127869 21.002016,617.684509 22.100639,618.225830 
	C23.350452,619.577209 24.078142,620.981750 25.767078,621.896240 
	C25.705770,622.603333 25.438946,623.057007 25.089935,623.751160 
	C22.246325,622.428284 19.371481,622.437927 16.207304,623.694275 
	C15.794844,624.012939 15.604980,624.010376 15.140288,623.933044 
	C14.410534,623.323425 14.187478,622.704102 14.237093,621.667603 
	C14.484081,620.668884 14.843262,620.109680 15.618080,619.432983 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M4.778965,619.325012 
	C5.035561,618.846924 5.071343,618.660767 5.213804,618.210938 
	C7.567718,617.922974 9.080473,620.728088 11.971590,619.582764 
	C12.787373,619.743652 13.171109,620.019287 13.644616,620.725403 
	C13.929595,621.820618 13.895503,622.557190 13.318062,623.562073 
	C12.911324,623.885803 12.726986,623.903625 12.266485,623.952148 
	C9.241488,624.634338 7.680348,622.046143 5.147478,621.255493 
	C4.618123,620.569519 4.499046,620.118713 4.778965,619.325012 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M24.880623,627.177979 
	C25.471272,627.020935 25.806612,627.007935 26.127661,627.069458 
	C27.912815,627.411926 29.085852,628.538940 29.307724,630.267334 
	C29.376461,630.802856 28.441923,631.782288 27.768574,632.039124 
	C25.689203,632.832581 25.082680,630.932190 24.075014,629.425171 
	C24.036366,628.462097 24.177471,627.858765 24.880623,627.177979 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M46.717583,620.955322 
	C47.098553,622.001282 47.485062,622.702698 47.939621,623.700928 
	C45.504181,624.611206 45.594296,621.299805 43.316284,621.015747 
	C43.006123,620.928833 43.004074,620.979126 43.026428,620.970581 
	C42.642494,620.596008 42.485485,620.143494 42.814434,619.306641 
	C43.224133,618.984436 43.397236,618.960144 43.831299,618.910400 
	C45.560116,618.559387 46.065697,619.700806 46.717583,620.955322 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M36.025620,636.693298 
	C35.562397,636.993958 35.124641,636.987976 34.359344,636.975342 
	C34.157925,635.712830 33.735958,633.745911 35.394279,633.723328 
	C37.424175,633.695801 35.955868,635.427612 36.025620,636.693298 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M25.980148,621.872253 
	C24.200542,622.100220 23.341450,620.669983 22.012802,619.388550 
	C21.642836,618.663208 21.734852,618.260254 22.375278,617.783447 
	C23.148636,617.787720 23.502262,618.050415 23.822351,618.771729 
	C24.398308,619.677002 24.921482,620.244263 25.710487,620.925781 
	C25.980116,621.225037 25.983912,621.409973 25.980148,621.872253 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M13.389447,623.911133 
	C13.070378,623.169495 13.045095,622.471069 13.011965,621.421936 
	C13.358718,620.649963 13.801833,620.511719 14.614285,620.904236 
	C14.937434,621.832336 14.979497,622.511963 14.943510,623.524902 
	C14.471384,623.890320 14.077309,623.922302 13.389447,623.911133 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M56.198105,632.679504 
	C55.050480,632.191772 52.933617,632.475342 53.792458,630.122986 
	C54.763313,629.555786 55.206200,629.988953 55.798615,630.783081 
	C55.982170,631.049133 55.994759,630.995544 55.969559,631.006653 
	C56.353752,631.381836 56.515018,631.834351 56.198105,632.679504 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M44.990646,626.002197 
	C45.948166,626.662476 47.436081,626.742065 47.649746,628.390503 
	C45.901558,629.031738 45.488861,627.813293 45.033123,626.298767 
	C45.010818,625.971619 45.006470,626.003662 44.990646,626.002197 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M11.050807,630.375122 
	C11.484330,630.022461 11.923496,629.964844 12.696877,629.911804 
	C13.982088,631.034851 12.910828,631.340820 12.244343,631.630127 
	C11.426931,631.984985 11.096792,631.436340 11.050807,630.375122 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M35.005360,624.996094 
	C35.917751,625.402466 36.757412,625.893555 36.667759,627.062561 
	C36.652920,627.256104 36.225002,627.601379 36.043484,627.568665 
	C34.972759,627.375671 35.124569,626.426208 34.981285,625.341370 
	C34.987644,625.011963 34.999313,625.000732 35.005360,624.996094 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M24.853748,626.916199 
	C24.966301,627.605225 24.790066,628.210876 24.321381,628.963501 
	C23.706774,628.448059 23.087780,627.763184 23.136009,627.129089 
	C23.199314,626.296692 24.008797,626.643677 24.853748,626.916199 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M51.101814,624.270508 
	C50.961445,623.601807 50.993534,623.178833 51.012260,622.438110 
	C51.743160,621.342651 52.135044,622.046753 52.766888,622.786621 
	C52.946705,623.075195 52.849972,623.089661 52.825790,623.133179 
	C52.857445,623.557800 52.913284,623.938843 52.970886,624.608643 
	C52.406521,624.770203 51.840393,624.643188 51.101814,624.270508 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M24.996540,624.003235 
	C25.886763,624.233337 26.965042,624.192871 27.224743,625.385864 
	C27.260300,625.549133 26.920933,625.949158 26.712173,625.984314 
	C25.691673,626.156189 25.366381,625.410156 25.054413,624.311035 
	C25.007748,623.991577 25.000246,624.000000 24.996540,624.003235 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M55.971252,630.718933 
	C55.499180,630.762268 55.016193,630.475342 54.279064,630.067932 
	C54.015537,629.497437 54.006153,629.047424 54.001976,628.258057 
	C55.045864,628.435486 55.812859,629.167175 55.971252,630.718933 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M16.005032,623.995117 
	C16.574165,624.195740 17.136879,624.402649 17.699596,624.609497 
	C17.594368,624.887756 17.563282,625.327393 17.370855,625.415894 
	C16.607544,625.766541 16.248672,625.265686 16.005936,624.313843 
	C15.984707,624.015503 15.998610,624.001404 16.005032,623.995117 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M39.987816,623.986450 
	C39.953930,624.598511 39.895794,625.242920 39.161533,625.414795 
	C38.944923,625.465393 38.473663,625.234863 38.423626,625.050415 
	C38.206085,624.248779 38.733780,624.006409 39.722790,623.993896 
	C40.027622,624.028687 40.000988,624.000610 39.987816,623.986450 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M56.310814,632.986572 
	C55.971428,632.546814 55.974682,632.109924 55.961143,631.345398 
	C56.895401,631.025269 57.687893,631.275818 57.990078,632.659058 
	C57.567204,632.988525 57.110329,632.988953 56.310814,632.986572 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M21.084263,625.137817 
	C21.319946,624.492188 21.581051,624.477478 21.810102,624.886475 
	C21.878925,625.009338 21.831282,625.197449 21.836998,625.355652 
	C21.585966,625.362915 21.334936,625.370178 21.084263,625.137817 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M6.444059,644.528687 
	C6.408075,644.474182 6.480043,644.583252 6.444059,644.528687 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M3.538947,639.477295 
	C3.590342,639.554688 3.378115,639.570984 3.378115,639.570984 
	C3.378115,639.570984 3.487552,639.399902 3.538947,639.477295 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M23.956587,423.070251 
	C29.906668,421.151062 36.095585,422.534210 42.587078,421.568726 
	C49.168049,422.005188 55.277435,422.829773 61.392017,422.870300 
	C65.449974,422.897217 67.191284,424.215210 67.128944,428.243866 
	C67.103645,429.879272 67.591164,431.522552 67.824966,433.565491 
	C67.336250,434.345490 66.807312,434.477600 65.853577,434.147705 
	C63.880791,431.620911 61.695053,430.719238 58.863514,430.308197 
	C52.293900,429.354584 45.713787,429.586395 38.733261,429.441772 
	C36.777081,429.403442 35.217342,429.426422 33.321091,429.103882 
	C31.071852,428.391479 29.395248,426.131989 26.816111,428.369995 
	C26.037336,428.590698 25.579285,428.539734 24.862577,428.143799 
	C23.928692,426.808929 23.951569,425.540039 23.852123,424.023468 
	C24.001102,423.531219 23.978535,423.364075 23.956587,423.070251 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M65.698792,433.884827 
	C66.480972,433.966248 66.859161,433.960815 67.520973,433.962036 
	C68.726151,434.992950 69.617622,436.066956 71.522415,436.099426 
	C72.158478,437.099060 71.773979,437.768524 70.670395,438.405945 
	C69.683128,438.486786 69.110138,438.487671 68.094452,438.482544 
	C64.713745,437.948090 61.744625,437.898590 58.777779,438.007507 
	C47.730434,438.413025 36.743916,437.409760 25.383785,436.362396 
	C24.999422,435.906189 24.977816,435.730896 24.973463,435.291199 
	C24.249895,434.127319 24.599167,433.055878 24.559490,431.675293 
	C25.458860,430.029144 26.625908,430.319153 27.686058,430.839874 
	C30.925520,432.430878 34.414631,432.445374 38.261719,432.597748 
	C39.659424,432.588287 40.648575,432.291046 42.064224,432.244568 
	C42.727219,432.304901 42.991615,432.352966 43.644974,432.514343 
	C49.233669,434.253174 54.580143,433.204742 59.853447,433.489288 
	C61.667568,433.587189 63.504326,433.275482 65.698792,433.884827 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M24.851370,436.437195 
	C37.792934,436.446686 50.565552,436.789795 63.335838,437.204803 
	C64.947884,437.257172 66.547668,437.687134 68.572853,438.017914 
	C69.163536,438.224121 69.334496,438.354614 69.246529,438.677521 
	C58.401279,439.865967 47.833618,438.977509 37.261761,438.549652 
	C35.113045,438.462677 32.934875,438.515747 30.826418,438.165955 
	C28.003843,437.697693 26.074085,438.626831 24.376804,440.824188 
	C24.272095,439.296051 23.554712,437.860962 24.851370,436.437195 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M7.076752,441.085663 
	C6.529812,439.635620 7.278947,438.713257 7.938018,437.398682 
	C8.789264,435.964233 8.566516,434.454559 9.800451,433.234802 
	C12.329542,429.097778 14.144403,424.825287 18.516254,422.153870 
	C18.527826,428.823242 14.554628,434.086365 11.350036,439.992798 
	C9.785145,440.384460 8.748712,441.477539 7.076752,441.085663 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M6.844157,440.924866 
	C8.354723,441.198425 8.919683,438.357300 10.929852,439.935547 
	C9.765493,443.453033 7.669315,446.016449 4.294487,447.903778 
	C3.841208,448.190155 3.666744,448.284332 3.236123,448.227417 
	C2.979966,448.076355 2.722446,447.845123 2.552118,447.815430 
	C0.738995,444.636047 4.608803,444.301636 5.473949,442.112671 
	C6.090415,441.788910 6.395147,441.597107 6.806297,441.121857 
	C6.944368,440.887878 6.879423,440.956024 6.844157,440.924866 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M25.425081,430.777710 
	C25.178387,432.129395 25.101677,433.181793 25.007843,434.630524 
	C23.270538,431.559387 23.352079,427.812439 23.662899,423.892212 
	C24.325928,424.888367 24.619740,426.079529 24.946489,427.636108 
	C25.322594,428.314697 25.567665,428.693237 25.752195,429.470764 
	C25.715069,430.035614 25.655067,430.257050 25.425081,430.777710 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M3.075028,448.230499 
	C3.152851,448.062225 3.325737,448.048126 3.757144,448.065002 
	C3.733808,448.192200 3.451949,448.288422 3.075028,448.230499 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M23.867714,440.969971 
	C25.845936,440.319763 25.883947,441.222443 24.531811,442.552704 
	C23.888508,442.189331 23.837515,441.840759 23.867714,440.969971 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1019.454834,220.675995 
	C1018.443115,228.396790 1018.351807,235.768753 1018.845703,243.574310 
	C1018.877747,245.396210 1018.812195,246.794662 1018.867554,248.598068 
	C1019.026611,258.682037 1019.064575,268.361023 1019.142639,278.505493 
	C1019.247925,279.143738 1019.313110,279.316528 1019.298767,279.754730 
	C1018.792847,283.354065 1019.706055,286.752563 1018.385132,290.024384 
	C1016.403625,289.890259 1015.339661,288.522522 1013.899841,287.996765 
	C1015.120972,288.744751 1016.206238,289.687347 1017.777222,290.480774 
	C1020.036560,292.920898 1018.584534,295.762604 1019.408936,298.679932 
	C1017.742554,300.035645 1016.133484,299.286621 1014.777100,298.403351 
	C1010.342773,295.515503 1005.465271,295.255676 1000.393433,295.359070 
	C994.296387,295.483398 988.185852,295.418091 981.798462,294.180542 
	C979.745605,287.341461 980.913391,285.820740 988.262329,285.583282 
	C992.788330,286.066742 996.935547,285.934875 1001.076721,285.999878 
	C1001.743286,286.010345 1000.912781,286.039490 1001.574951,285.984863 
	C1001.853638,285.961884 1001.516479,285.974670 1001.253296,285.886292 
	C1000.426636,285.672943 999.966248,285.158142 999.037170,285.637146 
	C997.192566,286.119202 995.666443,285.942932 993.813599,285.555786 
	C993.027954,285.581848 992.579773,285.648956 991.787842,285.785095 
	C990.967651,285.863159 990.494507,285.856964 989.666077,285.755463 
	C987.170959,285.236603 984.929871,285.585052 982.522766,284.728149 
	C981.686035,284.705261 981.673157,282.641510 980.816467,284.219238 
	C980.143738,285.458099 979.030457,285.931549 977.386841,286.290588 
	C970.744995,285.825684 964.600952,287.938660 957.936768,287.007751 
	C955.380920,283.640778 950.901123,285.379944 948.320068,282.341309 
	C947.754211,279.927917 946.915894,278.640106 944.491516,279.757416 
	C943.305298,280.304108 942.071899,280.805420 940.342529,280.742371 
	C937.432129,279.470245 937.655945,277.303680 938.200989,274.696228 
	C938.531677,274.091125 938.701904,273.871582 939.220703,273.426086 
	C941.891418,272.387970 944.321472,272.048309 947.128479,271.520996 
	C948.351135,271.266174 949.141846,270.977203 950.388794,270.712219 
	C964.338074,268.984192 977.898193,267.915100 991.956909,267.921265 
	C995.885193,267.100281 999.496216,267.963867 1003.385254,267.145264 
	C1005.228088,267.093933 1006.638733,267.810577 1008.462891,267.287628 
	C1009.269592,267.114594 1009.736450,267.066437 1010.553833,267.057770 
	C1011.354004,267.095795 1011.789978,267.198883 1012.473267,267.570892 
	C1012.965942,267.964203 1013.205627,268.153778 1013.465454,268.315460 
	C1013.645386,268.427490 1013.775208,268.508301 1013.849487,268.566956 
	C1013.794922,268.450348 1013.660400,268.445801 1013.331909,268.208069 
	C1012.472595,267.407074 1011.743469,267.018433 1010.495056,267.006531 
	C1009.443909,266.981171 1008.734558,266.990723 1007.659241,266.876282 
	C1002.479980,266.323853 997.664246,265.711456 992.564819,267.434601 
	C991.460754,267.885101 990.681946,267.917084 989.516602,267.776428 
	C985.654236,265.863739 982.124756,265.716766 978.203003,267.594818 
	C976.870972,268.165955 975.832825,268.312469 974.382202,268.394287 
	C969.618896,268.890015 965.218567,265.673279 960.546143,268.772278 
	C957.312561,270.500061 954.192505,270.090179 950.721436,269.934631 
	C948.630859,268.837677 947.154236,267.591827 944.911499,267.702606 
	C941.990967,267.846771 940.578735,265.724121 940.806641,263.184601 
	C941.314392,257.526459 941.087708,251.981888 939.771790,246.457809 
	C939.544983,245.505493 939.895325,244.486725 940.586914,243.246033 
	C941.501221,242.370850 942.274963,242.186478 943.512329,242.386414 
	C946.796326,245.014160 946.591675,248.667160 947.453857,252.320206 
	C947.585327,252.927567 947.652466,253.164536 947.853516,253.743851 
	C948.095947,254.305923 948.204468,254.525635 948.521118,255.044800 
	C958.141052,256.011749 967.544678,256.043579 976.935913,254.999237 
	C984.706909,254.135071 992.535217,254.446350 1000.325867,254.161423 
	C1007.617554,253.894775 1009.046021,253.401978 1009.595215,245.662506 
	C1009.586121,244.192245 1009.663208,243.131699 1010.070068,241.720764 
	C1010.920227,240.015518 1011.816406,238.738968 1011.573486,236.700562 
	C1011.545471,228.679062 1013.095581,221.228699 1014.182495,213.318176 
	C1014.298096,211.551636 1013.330383,210.277756 1014.213806,208.606964 
	C1017.147522,207.476227 1019.194153,207.870895 1020.226196,211.211945 
	C1020.389526,212.521072 1020.458435,213.397308 1020.437988,214.715668 
	C1020.328979,216.893387 1020.567627,218.681213 1019.454834,220.675995 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M981.810852,293.633728 
	C988.140442,293.833954 994.102112,293.985657 1000.043091,293.702850 
	C1006.926025,293.375214 1013.114929,295.057495 1019.097839,299.074707 
	C1020.171631,300.210968 1019.437012,300.727448 1018.303650,301.266571 
	C1016.430176,302.069702 1015.000732,301.498993 1013.716858,300.760254 
	C1005.208557,295.864838 996.109619,297.298431 987.049438,298.148163 
	C983.864441,298.446838 982.219666,300.012421 982.446167,303.705444 
	C982.484863,304.921875 982.530762,305.736298 982.476440,306.963379 
	C982.638062,310.269226 984.274109,311.390137 987.044128,311.410645 
	C991.023621,311.440094 995.003540,311.382263 998.982178,311.460571 
	C1000.961609,311.499481 1002.988037,311.389648 1004.926331,313.010193 
	C1005.126526,313.903778 1005.126343,314.427002 1005.095703,315.215515 
	C1003.859131,317.960114 1001.487000,317.381073 999.482178,317.468018 
	C994.869568,317.667938 990.242981,317.354431 985.632080,317.650604 
	C984.231506,317.740540 982.236023,317.720856 982.407104,319.808258 
	C982.543701,321.474731 984.347595,321.342896 985.609497,321.400146 
	C988.905090,321.549652 992.205994,321.583649 995.483582,321.058716 
	C997.792908,320.688873 1000.085266,320.515625 1002.545288,322.065002 
	C1003.281921,322.754120 1003.506653,323.263916 1003.484131,324.279480 
	C1003.107788,325.227417 1002.682922,325.610870 1001.721558,326.004944 
	C1000.734253,326.278748 1000.155762,326.365204 999.134521,326.431458 
	C998.407837,326.477051 998.117432,326.499817 997.390869,326.546692 
	C987.671509,325.918030 978.481323,327.877258 968.794800,327.574463 
	C967.576538,327.617126 966.767883,327.550751 965.588989,327.816833 
	C964.162903,328.088776 963.119324,328.128510 961.688599,327.861115 
	C960.808594,327.562042 960.356079,327.288513 959.670410,326.651672 
	C958.918518,325.678436 958.654663,324.937500 959.031128,323.787354 
	C959.746704,323.189606 960.230774,322.971405 961.132202,322.747986 
	C965.631531,322.393646 969.676514,321.425110 973.832336,321.471619 
	C975.086487,321.485657 976.856384,321.521393 976.842590,319.713318 
	C976.826904,317.661438 974.968750,317.620270 973.506348,317.717590 
	C969.095032,318.011078 964.686157,319.320831 959.986938,317.309937 
	C959.408142,316.532562 959.283875,315.989594 959.391357,314.986145 
	C962.295532,311.260620 966.123413,313.098114 969.887634,312.555420 
	C972.505493,311.978760 976.554321,313.659760 976.556641,310.636505 
	C976.559448,307.040253 972.473145,308.777924 970.143982,308.502533 
	C967.064514,308.138367 963.894775,308.832428 960.517029,307.637695 
	C960.030273,307.247620 959.872864,307.049194 959.690552,306.472839 
	C961.107971,303.322632 963.850281,303.107849 966.453979,302.743896 
	C968.751160,302.422729 971.086365,302.666840 973.399292,302.542175 
	C975.186829,302.445831 977.512085,302.656494 977.779480,300.296692 
	C978.031555,298.071747 975.372742,298.527740 973.900879,297.264740 
	C973.183777,296.215149 973.141724,295.401306 973.569458,294.173523 
	C975.287231,292.558075 977.083252,292.570435 979.329895,292.670776 
	C980.363525,292.863495 980.916565,293.083191 981.810852,293.633728 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M981.475464,303.940857 
	C980.397705,298.684906 981.910767,296.214203 987.385803,296.462311 
	C993.636169,296.745575 999.920776,296.204895 1006.179932,296.386658 
	C1010.440430,296.510406 1013.725586,299.399384 1017.649780,301.312012 
	C1019.388062,302.264496 1019.015442,303.774506 1019.214478,305.539764 
	C1019.306885,306.132996 1019.342773,306.310059 1019.321289,306.751984 
	C1019.219971,307.178497 1019.176025,307.340118 1019.057251,307.741608 
	C1014.118347,308.123444 1009.970825,304.520020 1004.563477,305.271790 
	C998.118652,303.847046 992.023743,304.508881 985.958557,304.727783 
	C984.474792,304.781311 983.049438,305.214722 981.475464,303.940857 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1020.406738,422.495789 
	C1020.354553,425.650208 1020.365601,428.380676 1020.317993,431.563812 
	C1020.006958,432.141174 1019.754517,432.265839 1019.079956,432.386719 
	C1011.917236,430.807159 1005.221985,428.915466 997.744507,429.450348 
	C989.774475,429.315430 982.227173,429.940887 974.316528,428.929077 
	C972.032410,425.242401 975.346985,425.851044 976.679504,425.744690 
	C982.316589,425.294495 987.985840,425.686615 993.636597,425.489105 
	C995.206482,425.434265 997.620667,426.354614 997.690857,422.915833 
	C997.756348,422.287994 997.835083,422.043304 998.211121,421.558197 
	C998.737366,421.214905 998.966248,421.112000 999.555664,420.919525 
	C1005.090332,420.854248 1010.101501,422.269745 1015.300476,422.409821 
	C1010.557007,419.769073 1004.890991,420.653198 999.675781,418.383362 
	C996.690552,414.408722 999.280701,413.218964 1002.665894,412.092285 
	C1008.351013,411.423492 1013.335571,412.891174 1018.717590,414.370728 
	C1020.400085,416.934509 1020.353638,419.518280 1020.406738,422.495789 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M1005.515015,313.374023 
	C998.673157,312.313721 992.145081,312.666687 985.726318,313.181671 
	C980.841248,313.573639 979.772705,311.942688 980.823547,307.239716 
	C988.040955,302.962250 995.649353,304.744476 1003.545898,304.917358 
	C1009.508362,304.881378 1013.963867,307.640320 1018.698730,310.723999 
	C1018.991028,312.491974 1018.991028,313.969147 1018.991028,316.002899 
	C1014.577637,314.182587 1010.178223,314.161316 1005.515015,313.374023 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M1003.395447,323.337646 
	C996.626038,321.573547 990.142029,323.170715 983.675354,322.884644 
	C981.462585,322.786743 979.835876,322.866119 979.892761,319.839905 
	C979.944519,317.085785 980.847290,315.950409 983.658020,315.957367 
	C990.486389,315.974243 997.315247,315.798035 1004.604614,315.590179 
	C1005.470093,315.566742 1005.874817,315.652771 1006.588135,315.772034 
	C1007.116821,315.766876 1007.337036,315.728424 1007.683960,316.000397 
	C1010.089294,316.917969 1012.367798,317.525085 1014.962891,318.301147 
	C1015.582764,320.791351 1018.407410,322.433258 1016.752930,325.382446 
	C1012.120300,325.314423 1007.886597,324.662079 1003.395447,323.337646 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M1020.573608,422.588684 
	C1019.883118,420.646301 1019.422668,418.372864 1018.948730,415.713776 
	C1018.228394,413.427887 1015.862549,413.476257 1014.818848,411.557312 
	C1015.584351,409.734375 1016.894958,408.469391 1017.055481,406.285614 
	C1017.443237,404.876160 1017.607971,403.770355 1017.620850,402.301697 
	C1017.314575,396.202148 1012.512756,397.328186 1008.691406,396.358643 
	C1004.955078,395.483002 1001.124817,395.916504 998.451843,392.390808 
	C998.235474,391.417206 998.299133,390.858276 998.748535,389.967407 
	C1001.604614,388.050720 1004.439575,388.568146 1007.622070,388.769226 
	C1011.675049,390.132294 1015.437012,390.911560 1019.699097,390.948212 
	C1021.947021,394.182922 1020.955872,397.705261 1021.003174,401.074158 
	C1021.102295,408.132996 1020.888794,415.196228 1020.573608,422.588684 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1016.663086,325.484924 
	C1017.937378,322.668121 1012.841187,322.002197 1015.140381,318.801453 
	C1018.067993,318.536407 1019.386597,319.721985 1019.058716,322.734528 
	C1018.794983,325.157990 1019.006714,327.633209 1019.070801,330.542023 
	C1019.677246,332.030914 1019.442383,333.139832 1019.330078,334.617371 
	C1019.020569,335.750610 1018.832642,336.491211 1018.563477,337.605469 
	C1018.244019,337.970367 1018.005859,337.961639 1017.471313,337.755524 
	C1012.731384,333.970276 1007.438477,333.679962 1001.706848,333.691895 
	C998.855713,333.311005 996.285645,333.687531 993.520386,332.726135 
	C992.198853,328.725159 992.800964,327.883698 996.228577,328.543213 
	C997.687012,328.823822 999.059875,329.499146 1000.583435,329.556915 
	C1002.594421,329.633209 1004.300415,329.327972 1004.515015,326.467499 
	C1007.501587,324.250641 1010.209412,326.135590 1012.976379,326.525696 
	C1014.262024,326.706909 1015.772156,328.140350 1016.663086,325.484924 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1019.572632,367.291626 
	C1019.558777,369.198578 1019.584351,370.686676 1019.601257,372.550354 
	C1019.223389,373.340302 1018.763489,373.584473 1017.812744,373.677368 
	C1013.206299,373.123718 1008.839844,373.271576 1004.739502,370.624512 
	C1003.265076,368.528198 1002.762451,366.718079 1004.728516,364.634674 
	C1009.670959,363.127777 1013.816528,365.678680 1018.617188,366.119843 
	C1019.204956,366.486603 1019.408447,366.679657 1019.572632,367.291626 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M1018.848999,432.040710 
	C1019.389221,431.862946 1019.568054,431.859589 1020.003174,431.936371 
	C1020.450073,435.704590 1020.640747,439.392700 1020.843201,443.482666 
	C1020.620789,448.147552 1022.778870,452.291595 1021.352356,456.988586 
	C1021.146240,458.010071 1021.075684,458.650177 1021.020874,459.773743 
	C1021.361023,460.566284 1021.494751,460.943054 1021.229858,461.629547 
	C1020.626526,461.958221 1020.231140,462.044830 1019.532593,462.150757 
	C1018.444580,461.740082 1018.098633,461.005005 1017.783569,459.799438 
	C1017.569641,458.097534 1017.599304,456.788544 1017.599487,455.106812 
	C1017.639526,453.523926 1017.496826,452.326324 1017.334229,450.777344 
	C1017.299622,448.811096 1016.986206,447.207214 1017.157959,445.243774 
	C1017.678467,443.323212 1017.616394,441.750183 1017.070007,439.827515 
	C1016.681458,437.963440 1016.669678,436.450714 1017.052124,434.554077 
	C1017.437927,433.410645 1017.882996,432.758453 1018.848999,432.040710 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M1017.680725,373.377625 
	C1018.258423,373.015015 1018.638489,372.970612 1019.305542,372.926086 
	C1019.681274,378.635773 1019.769958,384.345642 1019.958130,390.512207 
	C1016.503235,393.564850 1013.012268,391.604095 1009.187622,390.627380 
	C1009.073608,386.251038 1012.817566,387.567291 1015.320312,386.314148 
	C1016.859558,385.466553 1017.582825,384.458496 1017.631226,382.676575 
	C1017.631592,380.924744 1017.671631,379.513184 1017.585571,377.738953 
	C1017.551941,376.148560 1017.116089,374.932404 1017.680725,373.377625 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M1018.135498,337.997253 
	C1018.548340,338.018463 1018.528137,337.983826 1018.505127,337.981445 
	C1019.424255,339.242096 1019.106201,340.722321 1019.244385,342.556793 
	C1019.492432,344.319000 1019.778748,345.661591 1018.673096,347.102295 
	C1013.655029,344.583160 1008.314758,344.072876 1003.058838,342.176880 
	C1003.427917,339.473328 1005.469727,339.826080 1007.200806,339.636658 
	C1009.138916,339.424530 1011.183472,339.973450 1013.332947,338.581970 
	C1014.986511,337.783905 1016.325073,337.574829 1018.135498,337.997253 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1019.023376,310.636169 
	C1014.617249,309.291748 1010.243408,307.568726 1005.498779,305.785675 
	C1004.715393,305.446075 1004.532654,305.058289 1004.807007,304.296448 
	C1010.104492,302.968353 1014.093811,305.774475 1018.649902,307.861786 
	C1019.006897,308.740173 1019.031311,309.498871 1019.023376,310.636169 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1018.638367,348.746155 
	C1018.995300,350.098419 1019.060242,351.159149 1019.191895,352.613037 
	C1019.517334,353.765076 1019.490967,354.547394 1019.321289,355.702454 
	C1015.324219,356.471405 1012.116394,354.885712 1008.923462,352.362000 
	C1009.508423,349.043060 1012.620605,349.812744 1014.778748,348.318665 
	C1016.253479,347.895630 1017.322632,347.913116 1018.638367,348.746155 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M1021.409912,457.295685 
	C1020.948120,453.078674 1020.679382,448.787415 1020.632812,444.190338 
	C1021.065674,444.166016 1021.276367,444.447479 1021.725769,444.840546 
	C1021.140991,448.931000 1022.917664,452.466980 1023.881592,456.524414 
	C1023.161194,457.241058 1022.114563,455.291626 1021.409912,457.295685 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1018.129517,290.478821 
	C1017.838928,290.840790 1017.497925,291.250580 1017.388489,291.196014 
	C1015.111267,290.060211 1012.200623,289.814758 1011.130249,286.962433 
	C1011.015442,286.656738 1011.546875,285.742340 1011.685059,285.762115 
	C1014.221497,286.125641 1016.143005,287.640442 1018.005859,289.640930 
	C1018.035095,289.988495 1018.187012,290.310364 1018.129517,290.478821 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1018.688721,356.561584 
	C1019.038147,355.574097 1019.064941,354.713165 1019.175171,353.429260 
	C1020.824341,357.515442 1019.717590,362.141327 1019.695129,367.211670 
	C1019.533142,367.710510 1019.174194,367.572906 1019.111328,367.391296 
	C1018.746338,366.837555 1018.456421,366.456238 1018.056213,365.731018 
	C1017.604858,363.366425 1017.708374,361.255188 1016.735474,358.988831 
	C1016.694946,357.529327 1017.483643,357.068024 1018.688721,356.561584 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1019.234863,348.828430 
	C1017.946350,348.910004 1016.962280,348.782318 1015.607178,348.565094 
	C1014.364136,348.657074 1013.980286,348.154602 1013.894470,347.099365 
	C1015.139526,346.071106 1016.262756,346.359192 1017.727661,346.797607 
	C1019.705872,346.225922 1018.847717,344.782043 1019.192383,343.338959 
	C1020.361023,344.817291 1020.288757,346.703278 1019.234863,348.828430 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1022.033203,365.372009 
	C1025.125366,366.560516 1024.584473,368.653748 1022.466980,371.013824 
	C1022.078674,369.353638 1022.045105,367.583435 1022.033203,365.372009 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1019.416931,334.769653 
	C1019.143494,333.939178 1019.078430,332.868378 1019.073730,331.398071 
	C1020.168457,332.054382 1020.098938,333.263733 1019.416931,334.769653 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1019.404480,306.917267 
	C1019.198608,306.839722 1019.133301,306.662598 1019.169495,306.220703 
	C1019.362366,306.243195 1019.453674,306.530426 1019.404480,306.917267 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M1007.835876,316.105774 
	C1007.632874,316.273071 1007.455017,316.235352 1007.086914,316.001465 
	C1007.263672,315.376892 1007.579102,315.469513 1007.835876,316.105774 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M1019.366577,279.924805 
	C1019.136169,279.847809 1019.053040,279.675507 1019.076355,279.237061 
	C1019.293152,279.257080 1019.403503,279.543274 1019.366577,279.924805 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M13.817903,540.347534 
	C14.157828,540.003601 14.510511,540.022827 14.687093,540.025574 
	C15.537265,539.474426 16.121964,539.763184 16.433725,540.380188 
	C19.481298,546.411438 24.260349,551.206726 28.220831,557.007202 
	C30.415493,559.122620 31.787508,561.473816 33.776810,563.747070 
	C34.022903,563.975525 34.000610,564.000000 34.013496,563.988953 
	C34.357285,564.348938 34.521152,564.783081 34.369492,565.609314 
	C33.130051,566.218262 31.690849,565.544922 31.013664,567.451782 
	C29.608116,569.603638 27.634710,569.341492 25.378010,569.325012 
	C23.729988,568.938904 22.438171,569.127014 21.149885,569.094116 
	C17.608660,569.003601 15.534129,570.473938 15.023864,574.392090 
	C14.532886,574.725769 14.253152,574.786560 13.551508,574.927246 
	C11.643940,573.728516 11.942290,571.957336 12.038726,570.366455 
	C12.637986,560.480103 12.089615,550.537903 13.817903,540.347534 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M14.021935,539.739014 
	C13.769146,551.368042 13.380465,562.732422 13.060692,574.552002 
	C12.481883,577.271790 12.973995,579.850281 10.978862,582.706848 
	C10.283897,567.580505 11.322220,553.386719 12.212023,538.753174 
	C13.931968,537.012390 13.844087,538.337585 14.021935,539.739014 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M14.860304,574.930298 
	C13.490578,567.141541 18.926003,568.386536 23.630867,568.247742 
	C24.391588,568.889709 24.487818,569.499268 23.925827,570.435913 
	C21.535122,568.848938 19.426563,571.794006 16.801167,569.421265 
	C18.000168,572.965210 19.751984,572.945435 21.719189,572.556396 
	C20.523432,574.855835 21.458862,578.679199 16.977764,578.680786 
	C16.509382,579.321838 16.121897,579.468384 15.432810,579.132446 
	C15.113398,577.648315 15.010693,576.421997 14.860304,574.930298 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M3.959749,572.285583 
	C3.904137,571.716797 3.882508,571.546814 3.708587,571.169556 
	C4.678147,567.653015 4.898649,564.216980 4.170975,560.647705 
	C4.687784,560.656311 5.204593,560.664917 5.721401,560.673462 
	C6.000263,565.240356 6.279124,569.807251 6.388361,574.699341 
	C4.144226,575.511780 4.252926,573.923218 3.959749,572.285583 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M3.556819,572.068359 
	C5.103927,572.428406 5.266830,573.611938 5.943810,574.834412 
	C6.404151,576.385864 6.589568,577.747131 6.825424,579.449829 
	C1.985380,579.067993 3.152847,575.382080 3.556819,572.068359 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M24.759443,581.158020 
	C25.023815,583.356079 25.046040,585.714722 25.095810,588.514526 
	C25.055492,589.136658 24.987625,589.317627 24.864761,589.783203 
	C22.867189,590.870300 22.003906,590.250854 22.455744,588.169617 
	C22.790070,586.629700 23.282528,585.124146 23.854843,583.268066 
	C24.175861,582.394714 24.346579,581.856689 24.759443,581.158020 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M15.202921,579.263428 
	C15.571317,578.889832 15.926534,578.904968 16.546890,578.935486 
	C16.630301,582.047974 19.290192,579.837158 20.515972,580.919556 
	C17.729668,584.129517 16.468935,583.815186 15.202921,579.263428 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M3.869318,548.038757 
	C4.194996,546.574463 4.561196,545.344604 5.031498,544.155884 
	C5.182703,543.773804 5.608490,543.500305 6.572656,542.462219 
	C7.065478,545.138733 7.362358,546.871216 4.779286,548.278931 
	C4.288038,548.383545 4.119130,548.336304 3.869318,548.038757 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M6.746092,589.582275 
	C3.636691,589.987610 5.083189,587.757751 5.324830,586.653381 
	C5.584990,585.464355 5.953936,586.907837 6.564511,587.099854 
	C6.782195,587.915344 6.782395,588.582520 6.746092,589.582275 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M18.120480,588.242432 
	C19.334808,586.687927 19.778240,587.754333 20.130404,588.633606 
	C20.246517,588.923523 19.972294,589.681885 19.747913,589.741455 
	C18.822117,589.987183 18.229828,589.525757 18.120480,588.242432 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M4.846050,538.836182 
	C5.658382,538.125977 6.897444,537.480713 8.483496,536.810791 
	C8.812582,539.455750 6.858302,538.868347 4.846050,538.836182 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M6.989306,582.652649 
	C6.172238,583.166321 5.160541,583.371338 4.871895,582.500305 
	C4.626462,581.759644 5.189302,580.988586 6.598037,580.978088 
	C7.000127,581.444397 7.006954,581.884094 6.989306,582.652649 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M2.017532,550.035034 
	C2.028280,549.587952 2.161795,549.281677 2.531145,548.868713 
	C2.958072,548.815735 3.149163,548.869385 3.436357,549.204773 
	C3.309001,549.749817 3.085541,550.013062 2.619202,550.370850 
	C2.376323,550.465393 2.140298,550.175781 2.017532,550.035034 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M4.289821,548.270203 
	C4.333314,548.729492 4.150534,548.985962 3.720538,549.343384 
	C3.401820,549.369141 3.271172,549.251709 2.953752,548.948120 
	C2.883118,548.446106 3.071211,548.181396 3.559834,547.878052 
	C3.788411,547.788391 4.122694,548.109619 4.289821,548.270203 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M693.224609,987.684204 
	C693.262939,989.041565 693.491943,990.212646 693.865112,991.717896 
	C694.183044,992.483582 694.163513,992.900574 693.701538,993.549316 
	C692.556213,994.633484 691.339478,995.205627 690.886353,996.859863 
	C690.370117,1000.053650 692.226013,1000.478943 694.425781,1000.603210 
	C696.885376,1000.742249 699.420593,1000.275818 702.028809,1001.716003 
	C702.514587,1002.433044 702.582153,1002.920654 702.349609,1003.777344 
	C699.269653,1005.557739 696.250244,1003.999512 692.980347,1004.435486 
	C692.241333,1004.563416 691.640137,1004.336304 691.766663,1005.170349 
	C695.300781,1005.730652 698.621765,1005.397278 701.928284,1005.563782 
	C703.892761,1005.662781 705.964417,1005.508484 707.505859,1007.730469 
	C707.753479,1009.859253 706.706238,1010.673584 704.821777,1011.240234 
	C699.615234,1011.726990 694.769714,1010.818237 689.708984,1012.116394 
	C688.831543,1013.162903 688.125427,1013.864197 687.219727,1014.879761 
	C685.556641,1015.392822 684.120483,1015.615906 682.327026,1015.753174 
	C681.734497,1013.593384 685.826416,1009.859070 679.440552,1010.010681 
	C677.590759,1007.589966 680.485229,1005.879700 680.361633,1003.473511 
	C677.650208,1002.916443 676.762146,1005.954956 674.235840,1005.998413 
	C673.373779,1006.024658 672.883728,1005.950317 672.043579,1005.687073 
	C668.797607,1003.354492 665.711731,1001.352112 663.401794,998.526794 
	C661.422729,996.106140 659.509644,993.516602 660.622070,989.665649 
	C672.710876,984.572937 684.148193,978.054016 698.100464,980.093994 
	C698.962524,980.495789 699.331299,980.865662 699.692871,981.723877 
	C699.935852,983.143555 699.678467,984.104614 698.908081,985.289062 
	C697.709778,986.338257 696.753052,987.103027 695.432495,987.947144 
	C694.561829,987.711670 694.264954,986.739990 693.224609,987.684204 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M684.420532,1023.845825 
	C678.061646,1022.456604 672.059448,1022.286438 665.480591,1023.003845 
	C666.573242,1022.117432 667.186707,1021.619812 667.931641,1020.810669 
	C678.748047,1019.403870 689.432861,1018.308594 700.526001,1017.233582 
	C702.930725,1018.810913 702.566467,1020.162964 700.316956,1021.578247 
	C695.149597,1023.648987 689.929077,1023.267212 684.420532,1023.845825 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M700.481079,1021.821594 
	C699.988953,1020.364746 702.240601,1019.509766 700.977661,1017.533203 
	C701.432556,1017.201782 701.930908,1017.149719 702.802063,1017.154907 
	C711.542480,1017.634766 719.845093,1016.716431 728.611450,1016.002014 
	C736.697937,1016.099182 744.134521,1013.934937 751.761414,1014.026428 
	C753.527710,1014.047607 755.461304,1013.530884 756.976074,1015.540833 
	C738.310791,1017.952454 719.607605,1019.906433 700.481079,1021.821594 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M687.433472,1015.239868 
	C687.117310,1014.286560 687.241943,1013.403381 687.606018,1012.283691 
	C690.858093,1010.072144 694.223206,1011.273071 697.420166,1011.052063 
	C699.220459,1010.927612 700.992004,1010.645752 703.171997,1010.326782 
	C704.735046,1009.922791 706.157654,1010.292358 706.917664,1008.468384 
	C707.721130,1007.136108 706.829285,1006.212708 706.950073,1004.877441 
	C707.086182,1003.979736 707.281677,1003.502075 707.855835,1002.793945 
	C708.887695,1002.165039 709.655396,1002.116699 710.790710,1002.504883 
	C712.278931,1003.903259 712.227173,1005.467224 712.420654,1007.333130 
	C712.569092,1008.424255 712.959351,1009.035278 713.439697,1010.003662 
	C713.796814,1011.064087 713.780334,1011.777222 713.221436,1012.753235 
	C712.089844,1013.169495 711.190979,1013.303528 709.972290,1013.311890 
	C705.062683,1014.206970 700.260559,1012.491394 695.351196,1014.491638 
	C692.606750,1014.914307 690.240479,1015.112122 687.433472,1015.239868 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M713.426025,1013.149170 
	C712.994751,1012.359070 713.000916,1011.682617 713.125488,1010.361267 
	C714.584290,1008.551758 716.506042,1009.072205 718.168945,1007.939087 
	C718.775635,1007.589905 719.144714,1007.454407 719.818604,1007.390137 
	C720.440552,1007.411133 720.536743,1007.831848 720.869873,1007.858154 
	C720.863586,1007.569519 720.831543,1007.283203 720.960815,1006.755005 
	C721.337769,1006.404358 721.527710,1006.297913 722.043701,1006.093079 
	C724.489868,1005.644043 726.257202,1006.319946 728.001343,1008.105957 
	C730.484375,1010.599792 733.750793,1009.156311 736.375000,1010.973633 
	C729.000793,1011.960938 721.432129,1012.611938 713.426025,1013.149170 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M757.296021,1016.006226 
	C753.293152,1014.021301 749.388794,1015.076843 745.556641,1015.379333 
	C740.335571,1015.791443 735.127869,1016.372620 729.480652,1016.855591 
	C728.678406,1016.525879 728.520508,1016.136597 728.795044,1015.406616 
	C738.710754,1014.367615 748.404541,1013.583740 758.557983,1012.897949 
	C759.015320,1013.498230 759.013000,1014.000427 759.005249,1014.882446 
	C758.525879,1015.512878 758.051941,1015.763428 757.296021,1016.006226 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M728.581177,1015.108765 
	C729.014648,1015.525513 729.012207,1015.899719 729.028320,1016.551880 
	C720.647583,1017.700684 712.253845,1018.731079 703.481567,1017.465454 
	C711.498352,1016.496765 719.821838,1015.781433 728.581177,1015.108765 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M736.949707,1011.329956 
	C733.559814,1010.050720 729.886047,1012.520203 727.096008,1009.227783 
	C727.867493,1007.698547 728.945923,1007.245117 730.530396,1007.966797 
	C734.035889,1008.513733 737.339478,1008.743347 741.122314,1009.001953 
	C741.700928,1012.609375 738.706970,1010.490540 736.949707,1011.329956 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M695.382996,1014.780640 
	C696.411072,1011.547058 699.221375,1013.360962 701.383667,1013.078125 
	C703.760071,1012.767090 706.212830,1013.039307 709.142334,1013.121826 
	C705.158203,1014.788635 700.359619,1013.847351 695.382996,1014.780640 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M742.137085,1009.461670 
	C744.316956,1009.017334 746.232971,1009.017639 748.626465,1009.026672 
	C746.985474,1011.747986 744.524109,1011.614197 742.137085,1009.461670 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M765.899597,1012.327515 
	C765.353516,1012.584167 764.484009,1012.692383 763.285339,1012.751831 
	C763.714783,1011.954712 764.628052,1011.979675 765.899597,1012.327515 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M919.443970,898.080017 
	C915.457825,898.112244 911.938843,898.088684 907.943359,898.022217 
	C907.858398,897.500061 908.250122,897.020813 908.828430,896.114502 
	C928.609497,895.544495 948.203918,895.368225 967.798645,895.304810 
	C970.000854,895.297668 972.561035,894.812073 974.139282,897.662720 
	C974.189392,898.061096 973.928162,898.435608 973.842163,898.647095 
	C973.605774,899.045776 973.455383,899.233093 972.998413,899.612854 
	C972.232971,899.967102 971.761902,900.075195 970.914001,900.146729 
	C969.056885,900.080933 967.650757,899.772461 966.283508,898.403564 
	C950.642029,898.119934 935.276611,898.072144 919.443970,898.080017 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M902.909790,992.583374 
	C902.304932,993.059631 901.805359,993.074097 901.058472,993.112488 
	C899.689636,982.045654 900.434570,970.935791 900.497192,959.834106 
	C900.523376,955.187012 900.734802,950.541077 900.968506,945.438232 
	C901.405884,944.649475 901.804810,944.505371 902.537720,944.755676 
	C902.874146,960.681702 902.944641,976.401611 902.909790,992.583374 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M897.942261,900.210938 
	C896.862244,896.711792 893.640137,896.493347 891.492798,894.496826 
	C894.903625,892.980530 898.306274,893.077271 901.396851,896.488159 
	C902.430298,905.362366 901.773254,913.844971 902.009277,922.314697 
	C902.068909,924.456116 901.643799,926.647888 902.798889,929.119629 
	C903.084595,930.012268 903.124634,930.505493 903.104614,931.240601 
	C901.729492,932.925537 902.338623,934.999695 901.080688,936.807007 
	C900.427979,937.050232 900.074219,937.046143 899.456665,937.055664 
	C899.160095,926.826660 899.149780,916.583984 899.074646,906.341736 
	C899.060303,904.384399 899.445129,902.366943 897.942261,900.210938 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M903.076050,929.015137 
	C899.802673,929.515808 901.086426,926.969055 901.069580,925.551208 
	C900.960510,916.359863 901.050110,907.166138 900.991699,897.512634 
	C901.285828,896.706848 901.729919,896.539246 902.553101,896.749268 
	C902.945923,907.469849 903.026672,917.990479 903.076050,929.015137 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M902.908569,896.590576 
	C902.430237,896.969299 901.995361,896.989441 901.234619,897.030823 
	C898.543152,894.497314 895.452026,894.129395 891.739319,894.166748 
	C890.327759,894.010193 889.401794,893.858154 888.210571,893.589478 
	C887.658081,893.189697 887.507690,892.842957 887.492493,892.147644 
	C887.633850,891.244324 887.689636,890.623962 888.175476,889.813965 
	C889.299988,889.105042 890.215515,889.183044 891.487915,889.593140 
	C895.107178,891.742737 899.226685,889.372742 902.392944,892.187256 
	C902.367493,892.585693 902.328125,892.667542 902.329956,892.713379 
	C902.538513,893.916809 902.745239,895.074463 902.908569,896.590576 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M901.055420,937.428589 
	C901.572571,935.244507 900.018738,932.872314 902.593384,931.432251 
	C903.045959,933.161133 903.047363,934.839783 903.043213,937.020874 
	C902.468201,937.616516 901.898682,937.709656 901.055420,937.428589 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M902.880249,944.518188 
	C902.419434,944.965820 902.035278,944.969788 901.363037,944.977844 
	C901.190308,943.314819 900.071228,941.372559 902.595703,940.308533 
	C903.010925,941.673523 902.983948,942.874084 902.880249,944.518188 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M907.516357,897.941040 
	C907.466736,897.979309 907.504333,898.039185 907.468811,898.053833 
	C907.433289,898.068542 907.468872,898.049927 907.472290,898.045532 
	C907.475708,898.041077 907.565918,897.902832 907.516357,897.941040 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M45.512428,987.533325 
	C47.682098,987.411255 49.459667,987.275452 51.615822,987.057251 
	C53.818310,986.985046 55.644573,987.058167 57.465542,986.989929 
	C59.861885,986.900085 60.032661,988.433716 60.115292,990.240845 
	C60.202377,992.145203 59.466038,992.935547 57.526817,992.889282 
	C44.561859,992.579529 31.730337,994.713379 18.797129,995.073364 
	C16.203005,995.145630 14.659142,994.381958 14.140272,991.372070 
	C13.420963,990.349487 13.310458,989.611389 13.928673,988.555786 
	C23.204378,989.137085 32.140995,987.955994 41.556732,987.863953 
	C43.023891,987.366699 44.082081,987.556641 45.512428,987.533325 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M33.211433,977.354614 
	C32.990276,976.288574 33.013084,975.447876 33.061337,974.187988 
	C39.553463,975.483765 46.291561,974.718323 52.819550,975.931702 
	C55.257965,976.384949 57.743465,976.567078 59.873016,978.629150 
	C59.485703,979.879150 58.613823,979.994324 57.060711,980.024414 
	C55.854858,980.131042 55.272629,980.099487 54.391289,980.106262 
	C53.269939,980.103149 52.458694,980.014526 51.371254,979.687988 
	C50.629780,979.643127 50.335842,978.398071 49.486439,979.591553 
	C48.017231,980.139648 46.892750,979.908020 45.467682,979.284302 
	C42.660248,977.967163 40.030628,978.358154 37.085411,978.314087 
	C35.643841,978.005798 34.549618,977.792908 33.211433,977.354614 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M50.752998,978.764771 
	C51.921654,979.057007 52.855373,979.206787 54.143661,979.326416 
	C55.173782,979.243713 55.797276,979.516724 56.719025,979.802124 
	C56.988281,979.995850 56.997036,980.001648 57.002449,980.005127 
	C60.012657,985.850708 54.961166,983.545471 52.384422,984.235229 
	C51.211430,984.302673 50.457096,984.301208 49.329857,984.363586 
	C48.956955,984.427429 48.500900,984.378784 48.271801,984.388794 
	C46.731163,983.793701 44.671177,985.109741 43.939377,982.437256 
	C42.755329,980.077026 42.434254,978.351807 45.573078,977.940186 
	C46.918369,979.136047 48.132130,978.977966 49.667854,978.916321 
	C50.186813,978.778687 50.352440,978.700562 50.752998,978.764771 
z"/>
<path fill="#4B225C" opacity="1.000000" stroke="none" 
	d="
M13.902514,988.221436 
	C14.160140,988.981506 14.080402,989.654602 13.994186,990.669434 
	C12.588874,990.938110 11.999252,990.169922 12.138374,988.477966 
	C12.641223,988.141602 13.103187,988.138062 13.902514,988.221436 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M45.703472,977.949341 
	C43.157352,978.022766 44.633694,980.275269 43.981056,981.686157 
	C43.063953,982.341370 42.261612,982.637024 41.131714,982.901917 
	C41.599537,979.851624 39.668598,979.075378 37.030514,978.429565 
	C39.612999,977.357178 42.464798,976.163330 45.703472,977.949341 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M23.807690,976.028809 
	C23.985092,976.317383 23.904556,976.676208 23.901066,976.860229 
	C19.586428,977.226746 15.496518,976.697021 12.304222,973.054810 
	C13.362125,972.334290 14.389464,972.541565 15.731195,972.811523 
	C16.050125,973.030396 16.000305,973.002930 15.975148,972.989746 
	C16.971254,973.918945 18.269726,973.309143 19.707920,973.798706 
	C20.007439,974.003235 19.999872,974.000000 19.996712,973.997131 
	C21.036589,974.928711 22.485703,975.017334 23.807690,976.028809 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M15.888766,972.694824 
	C15.059858,972.963257 14.069592,972.896118 12.715110,972.755249 
	C12.350892,972.681519 12.286325,972.690491 12.259983,972.709717 
	C12.019593,972.666260 11.805545,972.603638 11.296017,972.384155 
	C10.582326,972.154053 10.164117,972.080811 9.428426,971.980225 
	C8.918440,971.837097 8.725935,971.721375 8.735744,971.336182 
	C8.938059,971.066772 9.134233,970.827698 9.228191,970.699219 
	C11.457236,971.166809 13.592323,971.763000 15.888766,972.694824 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M28.103970,979.127563 
	C28.632015,979.037598 29.155701,979.255249 29.849621,979.705017 
	C29.033287,981.095520 28.432573,980.777588 28.103970,979.127563 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M45.654495,987.377441 
	C44.869892,987.661194 43.835258,987.775269 42.410183,987.840698 
	C43.005146,986.769775 44.187084,986.886108 45.654495,987.377441 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M18.179962,981.657654 
	C17.125051,981.826355 15.793822,981.691528 14.236624,981.232056 
	C15.409979,980.170288 16.618408,981.096924 18.179962,981.657654 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M13.967337,980.561768 
	C13.156659,980.794556 12.250099,980.656189 11.180718,980.208008 
	C12.067551,979.034424 12.931290,979.985535 13.967337,980.561768 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M8.617847,971.089966 
	C8.938059,971.066772 8.997374,971.515015 9.054161,971.733887 
	C8.548882,971.843323 7.986815,971.733826 7.221911,971.414551 
	C7.445260,971.174255 7.871448,971.143677 8.617847,971.089966 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M48.133469,984.509155 
	C48.042702,984.398865 48.504040,984.280518 48.730499,984.354004 
	C48.956955,984.427429 48.625938,984.679382 48.625938,984.679382 
	C48.625938,984.679382 48.224232,984.619446 48.133469,984.509155 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M11.161068,972.403870 
	C11.327785,972.249146 11.655025,972.271057 12.107953,972.510986 
	C12.233642,972.728943 11.757719,972.776733 11.757719,972.776733 
	C11.757719,972.776733 11.321592,972.580505 11.161068,972.403870 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M761.952148,1015.421265 
	C762.094177,1015.379456 762.414734,1015.491394 762.816895,1015.862183 
	C762.655701,1015.920593 762.399719,1015.738647 761.952148,1015.421265 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M11.949516,838.324585 
	C12.179479,837.012390 12.366288,835.634705 13.643880,836.455505 
	C14.960334,837.301208 16.104761,838.668213 15.983037,840.444824 
	C15.904836,841.586243 14.923052,842.006836 13.862115,841.943787 
	C11.692017,841.814636 12.000425,840.138855 11.949516,838.324585 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M13.054146,795.492249 
	C12.720086,796.760742 12.378513,797.576904 11.956620,798.717468 
	C10.360435,798.887451 9.938280,800.613159 8.365046,800.960144 
	C7.238178,794.643250 9.598317,788.683411 10.752838,782.257690 
	C12.913192,781.750793 12.776701,783.221619 13.083699,784.719727 
	C13.102725,788.401428 13.074679,791.720703 13.054146,795.492249 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M14.459048,778.947754 
	C14.269698,779.293030 14.161393,779.666138 14.056290,779.829468 
	C13.331921,780.569275 12.612273,780.726013 11.478113,780.291382 
	C11.273211,778.233704 11.392859,776.391357 11.786661,774.274292 
	C12.595666,774.924744 13.130517,775.849854 13.943531,776.951904 
	C14.544867,777.567566 14.686902,778.058838 14.459048,778.947754 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M11.108496,780.392456 
	C11.851852,780.045837 12.550138,780.015503 13.599806,779.989014 
	C13.879153,781.531433 13.807119,783.070129 13.432928,784.845459 
	C11.952966,784.569946 12.149592,783.240051 11.281849,782.190552 
	C11.042286,781.560547 11.052856,781.134583 11.108496,780.392456 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M5.756792,823.014160 
	C6.651692,824.036987 7.287677,825.066772 7.966634,826.405273 
	C7.250607,826.765137 6.491608,826.816284 5.360221,826.777893 
	C4.990913,825.734741 4.993992,824.781006 4.993089,823.472900 
	C5.158695,823.086060 5.328286,823.053589 5.756792,823.014160 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M2.918356,806.067261 
	C2.755631,805.911560 2.659164,805.694275 2.562702,805.476990 
	C2.683630,805.512451 2.804551,805.547852 3.017075,805.728516 
	C3.108677,805.873840 2.984615,806.005615 2.918356,806.067261 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M92.847687,1020.137878 
	C94.100334,1019.846558 95.131493,1019.819458 96.552643,1019.807861 
	C96.962082,1020.336792 96.981529,1020.850098 97.007065,1021.748779 
	C94.722504,1023.352295 92.226242,1022.767273 89.400955,1022.873535 
	C88.606476,1022.254639 88.547989,1021.684021 88.925201,1020.639771 
	C89.726791,1020.209167 90.411766,1020.219360 91.239700,1020.564575 
	C91.853119,1020.873535 92.267609,1020.707642 92.847687,1020.137878 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M986.910156,901.748047 
	C989.145081,901.162537 991.512207,900.427979 993.780273,902.289917 
	C991.573914,902.217957 988.988708,905.264893 986.910156,901.748047 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M985.970703,905.740356 
	C985.557678,906.051025 985.110474,906.064514 984.336731,905.999817 
	C984.259033,905.423523 984.392090,904.658325 984.783508,904.488403 
	C985.399353,904.221191 985.779968,904.829712 985.970703,905.740356 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M1002.543030,595.345764 
	C1002.926086,595.978882 1002.923706,596.522217 1002.942261,597.337524 
	C1002.231262,599.603088 1000.256409,599.133423 998.805664,599.663879 
	C997.396973,600.178955 995.822937,600.497681 995.449951,602.208069 
	C995.025085,604.156189 996.875549,604.557251 998.194214,605.740234 
	C998.681702,606.462524 998.823914,606.943726 998.867920,607.846008 
	C998.300537,611.098450 996.308044,612.130798 993.275146,612.349487 
	C992.642639,612.382446 992.392944,612.391968 991.775574,612.414551 
	C989.765869,612.112244 987.364258,613.990479 986.716858,610.803101 
	C985.537720,611.158752 984.610962,612.338196 982.829346,611.790405 
	C982.259521,611.573120 982.044434,611.450439 981.579712,611.048828 
	C980.563660,609.430298 980.115356,608.026245 980.621704,606.139343 
	C981.032471,605.596069 981.286621,605.372620 981.591248,605.269104 
	C987.369080,603.305298 987.355896,603.317810 983.941895,598.772156 
	C983.532898,598.227539 983.776367,597.511780 984.152100,596.572998 
	C984.368164,596.035034 984.434814,595.811279 984.588318,595.246948 
	C984.844238,594.745117 985.013184,594.583801 985.484863,594.249390 
	C989.128479,592.721619 992.430420,589.759155 996.236328,593.867432 
	C997.256653,593.974182 997.910522,594.145081 998.752502,594.760498 
	C1000.061096,595.075623 1001.109314,595.165771 1002.543030,595.345764 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M996.593506,594.372253 
	C996.159424,594.817932 995.623657,595.110229 995.588562,595.059143 
	C992.639282,590.759644 989.645569,593.932739 986.302612,594.983643 
	C985.669800,594.664062 985.335449,594.496887 984.404175,594.806641 
	C981.494019,587.347961 983.152283,584.981934 990.966003,585.016052 
	C992.129089,585.021179 993.292175,585.041199 994.929016,585.110840 
	C996.059326,585.708313 996.854980,585.437744 997.862183,585.617371 
	C1001.690735,585.623840 1005.245667,584.600281 1009.242615,586.243591 
	C1003.578674,585.694214 1001.224548,589.223022 999.109131,593.623657 
	C996.658020,594.447205 996.886902,592.661438 996.464844,591.748291 
	C996.356323,592.327393 996.816284,593.172119 996.593506,594.372253 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M996.767700,594.794067 
	C995.937561,593.113464 995.831604,591.516602 996.200562,589.610413 
	C997.684204,590.660889 996.597656,592.908997 998.580688,593.740479 
	C998.902527,594.089111 998.928772,594.267822 998.983948,594.716003 
	C998.366516,594.957703 997.720215,594.929932 996.767700,594.794067 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1017.953857,593.616821 
	C1017.507629,594.000488 1017.088806,593.983032 1016.355957,593.982849 
	C1016.391174,592.462402 1016.740540,590.924622 1017.130127,589.209900 
	C1018.862976,590.509460 1017.569336,592.000549 1017.953857,593.616821 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M998.156677,585.463440 
	C997.342957,586.090393 996.556152,586.074341 995.590210,585.406860 
	C996.024841,585.055786 996.646851,584.944214 997.586914,584.846313 
	C997.904968,584.860107 998.175415,585.233643 998.156677,585.463440 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M88.736053,1020.131958 
	C89.031807,1020.777283 89.021812,1021.355713 88.997849,1022.363342 
	C88.544121,1022.858276 88.104362,1022.923889 87.335709,1022.923950 
	C87.031494,1022.270081 87.056183,1021.681763 87.133171,1020.653564 
	C87.600418,1020.164062 88.015350,1020.114502 88.736053,1020.131958 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1018.680420,175.357513 
	C1020.017151,170.567978 1016.580078,165.941483 1019.641479,161.301620 
	C1020.154846,170.493179 1019.690369,179.941864 1020.874390,189.763245 
	C1020.323547,191.052872 1020.609070,192.035843 1019.983154,193.110413 
	C1019.444763,193.281342 1019.202820,193.248810 1018.693115,192.956512 
	C1018.306946,192.473709 1018.188416,192.250656 1017.957031,191.661591 
	C1017.570923,189.757797 1017.688416,188.199768 1017.572388,186.260254 
	C1017.527588,184.024551 1017.594177,182.181351 1017.594666,179.939423 
	C1017.622864,179.007935 1017.650269,178.475342 1017.743713,177.543945 
	C1017.916443,176.614853 1018.130127,176.125702 1018.680420,175.357513 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M1019.295349,215.451996 
	C1019.069580,214.294403 1019.010376,213.479568 1019.067566,212.270355 
	C1019.316895,211.758331 1019.449829,211.640686 1019.833740,211.430740 
	C1020.445129,211.308121 1020.795837,211.356110 1021.343689,211.643188 
	C1021.746582,215.900497 1021.943909,219.985291 1022.193115,224.533783 
	C1022.011108,225.861160 1021.777100,226.724854 1021.268799,227.786880 
	C1020.765137,228.117035 1020.535889,228.248840 1020.266113,227.986115 
	C1020.119141,225.695312 1020.012817,223.799042 1019.849182,221.497559 
	C1019.206177,219.356110 1019.688049,217.553391 1019.295349,215.451996 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M1021.566284,211.399902 
	C1021.194397,211.858887 1020.839539,211.902069 1020.215515,211.968201 
	C1019.303223,210.481918 1019.449219,208.767746 1018.682983,206.883484 
	C1018.430176,203.457535 1018.982056,200.339905 1017.475525,197.083313 
	C1017.180359,195.957092 1017.218201,195.208969 1017.744690,194.181244 
	C1018.394714,193.607025 1018.855957,193.453033 1019.655273,193.218262 
	C1020.116272,192.227875 1020.284729,191.461990 1020.612183,190.449692 
	C1021.041992,197.130203 1021.312622,204.057144 1021.566284,211.399902 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1015.310974,155.972992 
	C1015.221497,154.873337 1014.598938,152.895889 1016.809875,153.517624 
	C1018.893066,154.103394 1018.811890,152.516617 1019.627197,151.295868 
	C1019.893982,153.752930 1019.924377,156.416763 1019.906616,159.523834 
	C1018.896057,159.687744 1016.707092,160.566589 1017.914917,158.151642 
	C1019.633118,154.716431 1017.374451,155.652771 1015.310974,155.972992 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M1022.728699,139.187286 
	C1023.997437,139.782867 1023.947693,140.456543 1022.512207,141.089081 
	C1022.322388,140.565094 1022.398804,139.969055 1022.728699,139.187286 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M23.042965,194.111420 
	C21.151619,197.499603 16.970613,196.594482 13.849695,198.289703 
	C11.140916,199.761047 7.867134,200.192230 4.457738,201.141312 
	C6.036056,195.815018 11.346318,196.573029 15.408784,195.182846 
	C17.666958,194.410095 20.188417,194.406723 23.042965,194.111420 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M28.825876,192.885162 
	C27.483465,193.964691 25.868433,195.341492 24.185621,192.895767 
	C25.636992,192.012115 27.097731,191.710266 28.825876,192.885162 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M891.772339,937.385742 
	C892.538879,937.034424 892.941711,937.021240 893.646851,937.000000 
	C895.118530,942.214172 894.369690,947.505493 894.445984,952.760620 
	C894.568604,961.200562 894.556335,969.644775 894.233765,978.534424 
	C894.347839,988.989319 894.694763,998.995850 894.947083,1009.004700 
	C894.987000,1010.588379 895.433167,1012.316833 893.863647,1013.880737 
	C893.219299,1014.167297 892.928650,1014.314392 892.186890,1014.269470 
	C889.859863,1011.332642 890.356506,1008.477051 891.245117,1005.117432 
	C890.197510,1002.605713 890.314270,1000.424866 890.310791,998.276489 
	C890.282043,980.355591 890.282532,962.434631 890.311523,944.513733 
	C890.315247,942.203735 890.156006,939.843018 891.772339,937.385742 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M875.945679,1014.735535 
	C875.924561,1014.329651 876.376587,1014.235046 876.603760,1014.193481 
	C882.111877,1014.075378 887.455933,1012.419983 892.814209,1015.167603 
	C892.141846,1017.820618 893.102905,1020.730835 890.038879,1022.213440 
	C885.337341,1024.488525 883.383728,1021.746460 881.340088,1018.074402 
	C880.666626,1017.911987 880.358459,1017.760437 880.046143,1017.751221 
	C878.078308,1017.692627 879.622986,1022.059387 876.898315,1020.524170 
	C874.971008,1019.438293 876.364929,1016.952820 875.945679,1014.735535 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M894.262024,978.982605 
	C893.999939,965.298340 893.967773,951.614685 893.942383,937.461426 
	C895.494324,938.279541 894.946106,940.057617 894.950378,941.648621 
	C894.982910,953.769165 894.956421,965.889832 894.948669,978.471985 
	C894.949097,978.933472 894.491943,978.983154 894.262024,978.982605 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M893.114319,1015.167480 
	C887.749451,1015.276062 882.459900,1015.917725 877.051392,1014.424011 
	C876.830872,1014.151917 877.001770,1013.731750 877.055420,1013.511475 
	C877.556641,1013.190735 878.004211,1013.090332 878.780334,1012.887634 
	C883.267090,1010.386780 887.223328,1012.183655 891.558838,1013.650757 
	C892.174255,1013.956848 892.439941,1013.979980 893.107788,1014.011658 
	C893.419861,1014.274353 893.329773,1014.528625 893.114319,1015.167480 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M9.808354,432.840302 
	C9.558339,434.238770 9.057389,435.450958 8.295398,436.865234 
	C8.008381,436.837616 7.982406,436.607941 7.930086,436.031952 
	C7.950387,435.311188 7.997034,434.936707 8.019389,434.278961 
	C8.084337,431.050781 4.574352,432.766632 3.862867,430.832642 
	C8.438850,429.459167 8.502583,429.479736 9.808354,432.840302 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M40.954723,392.671478 
	C40.001968,394.021759 38.794319,393.798279 37.325844,393.572632 
	C37.948158,391.905579 38.797989,390.130676 40.954723,392.671478 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1013.171997,54.860382 
	C1013.751953,55.718716 1013.842224,56.441513 1012.969727,56.564316 
	C1012.024170,56.697418 1011.341980,56.022934 1011.468445,55.074757 
	C1011.585571,54.197292 1012.309448,54.289242 1013.171997,54.860382 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1019.803772,55.210155 
	C1020.750061,55.842045 1020.680786,56.424873 1019.923889,56.714157 
	C1019.575867,56.847145 1018.812378,56.665340 1018.660278,56.391422 
	C1018.235596,55.626640 1018.785461,55.271027 1019.803772,55.210155 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M1008.000000,51.000076 
	C1008.629883,51.094719 1009.348267,51.096909 1009.490417,51.909508 
	C1009.520203,52.080009 1009.161804,52.318466 1008.982300,52.525635 
	C1008.678772,52.205090 1008.375183,51.884533 1008.035767,51.281914 
	C1008.000000,50.999847 1008.000000,51.000000 1008.000000,51.000076 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M11.040578,958.382874 
	C12.432333,958.037842 13.856205,958.083130 15.703722,958.185547 
	C18.161827,961.126892 17.773476,964.148804 16.309082,967.552124 
	C15.128456,967.751221 14.275952,967.611389 13.183884,967.248291 
	C12.005944,966.128418 12.937451,964.792725 12.208891,963.848572 
	C12.683566,964.769592 12.546377,965.559204 11.353922,966.121094 
	C10.973873,964.671265 10.944489,963.301270 10.883703,961.524170 
	C10.925765,960.335876 10.999229,959.554565 11.040578,958.382874 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M16.209812,968.167603 
	C15.999940,964.961975 16.018923,962.032837 16.082638,958.673218 
	C16.565632,958.220093 17.003893,958.197449 17.772976,958.179016 
	C20.360035,958.210999 19.986153,959.882935 20.003544,961.656738 
	C18.456125,963.352295 19.196377,965.142273 19.014174,966.732422 
	C18.824726,968.385742 18.231060,969.276184 16.209812,968.167603 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M8.741629,963.484741 
	C7.140601,964.124451 6.094187,963.779602 6.187908,961.878113 
	C6.228322,961.058105 6.308226,960.057434 7.465812,960.276367 
	C8.405951,960.454346 8.467325,961.463257 8.731933,962.588623 
	C8.808187,962.919861 8.753592,963.295410 8.741629,963.484741 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M23.951391,976.020386 
	C22.487228,976.081055 20.952192,975.943481 19.904556,974.370972 
	C21.241074,973.596924 22.304802,973.982605 23.579569,974.945557 
	C23.895002,975.325378 23.906347,975.524353 23.951391,976.020386 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M11.149761,966.294922 
	C11.585063,965.344299 12.166872,964.647339 12.748685,963.950317 
	C12.820679,964.755188 12.892671,965.560120 12.954494,966.694946 
	C12.394974,966.866150 11.845622,966.707336 11.149761,966.294922 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M19.880018,973.637329 
	C18.683531,974.846558 17.497967,973.923584 16.103437,973.343018 
	C17.259529,972.533386 18.503336,972.937561 19.880018,973.637329 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M980.760620,525.239014 
	C987.479126,526.429749 994.013123,526.090332 1000.532837,525.603882 
	C1001.548035,525.528198 1002.402893,525.024719 1002.967102,526.653076 
	C991.666199,527.330688 980.324036,527.639771 968.527344,527.933716 
	C967.920776,526.231079 967.871460,524.951294 970.389404,525.578430 
	C973.303711,526.304321 976.317627,526.146667 979.628479,525.123657 
	C980.192627,525.180908 980.354980,525.297974 980.760620,525.239014 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M1007.551270,526.986450 
	C1009.966980,526.260254 1012.609009,523.421326 1015.800171,526.474792 
	C1013.203125,526.896729 1010.594482,526.956909 1007.551270,526.986450 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M20.020939,161.984436 
	C20.157824,162.127441 20.274178,162.288605 20.390530,162.449768 
	C20.290150,162.408554 20.189770,162.367340 20.026920,162.185059 
	C19.964453,162.043991 20.000410,162.002594 20.020939,161.984436 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M998.354370,606.438354 
	C996.136475,605.677368 993.354797,606.274719 993.499268,603.203918 
	C993.617432,600.695190 994.539368,598.493225 997.798279,598.492981 
	C999.248474,598.492859 1000.698730,598.042053 1002.556030,597.702637 
	C1006.097107,597.677490 1009.233398,597.693787 1012.363892,597.836670 
	C1013.807007,597.902466 1015.826477,597.858276 1015.554443,599.965881 
	C1015.289490,602.018616 1017.928894,605.052917 1013.458679,606.161377 
	C1009.343079,608.423889 1005.310791,607.391235 1000.924805,607.366150 
	C999.852722,607.212341 999.275879,607.007385 998.354370,606.438354 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M999.712524,606.651367 
	C1003.939575,604.870422 1008.050537,606.613770 1012.594421,606.224976 
	C1013.062134,607.111084 1013.112793,607.920288 1014.524597,608.041016 
	C1012.743347,610.120544 1011.330383,612.198608 1014.894348,614.673340 
	C1014.555603,615.556824 1013.935425,615.789917 1012.897949,615.850220 
	C1011.460815,615.661499 1010.361267,615.656982 1008.920654,615.875488 
	C1007.356812,615.859741 1006.329163,615.406555 1005.287903,614.217407 
	C1004.970764,612.485840 1004.378723,611.433838 1002.153198,611.042480 
	C1000.458923,609.760681 999.457336,608.620422 999.712524,606.651367 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M1021.329102,610.897583 
	C1020.551880,610.999512 1020.087830,610.978577 1019.275146,610.975159 
	C1018.817932,611.174622 1018.709534,611.356506 1018.400146,611.292358 
	C1018.197327,610.319824 1018.195435,609.593384 1018.309021,608.516357 
	C1019.599243,607.900024 1020.780701,607.504639 1022.063538,608.676208 
	C1022.478638,609.743713 1022.187500,610.301270 1021.329102,610.897583 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1021.006775,611.008850 
	C1021.297668,610.507568 1021.579407,609.994629 1022.045105,609.244141 
	C1022.423340,609.029968 1022.617676,609.053223 1023.102722,609.116455 
	C1023.454956,609.542969 1023.467896,609.931030 1023.291748,610.577454 
	C1023.151428,610.834167 1023.089783,610.903076 1023.059448,610.937988 
	C1022.635620,611.367554 1022.163757,611.520569 1021.296387,611.203247 
	C1020.979248,610.974487 1020.997620,610.997253 1021.006775,611.008850 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M1023.418823,610.771729 
	C1023.200439,610.460754 1023.249451,610.087402 1023.345947,609.435242 
	C1023.393494,609.156494 1023.723755,609.128418 1023.860168,609.034668 
	C1024.224609,609.052612 1024.452637,609.164307 1024.611084,609.650635 
	C1024.256470,610.253296 1023.971313,610.481262 1023.418823,610.771729 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M4.659880,618.985291 
	C4.994573,619.462341 4.989368,619.891602 4.963313,620.641235 
	C4.519450,620.983276 4.096437,621.004944 3.354612,621.018066 
	C3.004340,620.556091 2.972881,620.102661 2.945138,619.308533 
	C3.405896,618.957703 3.862940,618.947571 4.659880,618.985291 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M999.138794,490.631927 
	C997.738098,488.751129 996.200623,488.897003 994.454102,488.937592 
	C988.673950,489.071899 982.888428,488.971985 976.652832,488.897034 
	C975.366333,488.156769 975.272949,487.282166 975.774414,485.922791 
	C980.457581,482.386414 985.552856,483.717529 990.402039,483.430237 
	C992.206177,483.323364 994.023315,483.383514 996.277588,483.598816 
	C1003.087891,484.739441 1009.618958,484.287933 1016.376953,485.828247 
	C1017.069885,486.094727 1017.333801,486.234558 1017.900024,486.705261 
	C1018.333008,487.765961 1018.463806,488.495789 1018.594971,489.597626 
	C1013.697632,489.991455 1008.799927,490.013306 1003.439819,490.124298 
	C1001.933228,490.975952 1000.772339,491.004852 999.138794,490.631927 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1018.426025,477.979736 
	C1018.673706,479.244690 1018.709534,480.154083 1018.731079,481.404541 
	C1018.415222,482.229279 1018.012756,482.605286 1017.114807,483.012787 
	C1010.602844,483.226135 1004.750305,481.536041 998.404297,480.327393 
	C997.754883,480.043976 997.505371,479.903839 996.942139,479.466003 
	C996.140808,478.401978 995.995117,477.559113 996.172852,476.243958 
	C996.650574,474.977295 997.298462,474.441742 998.571777,474.051392 
	C1005.005920,474.410156 1010.990356,475.084473 1017.194824,476.930389 
	C1017.785767,477.276245 1017.999939,477.450195 1018.426025,477.979736 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M1016.613403,482.482239 
	C1017.280334,482.046600 1017.686890,481.947845 1018.405151,481.797302 
	C1018.693542,483.299652 1018.670166,484.853760 1018.424561,486.721985 
	C1017.972656,486.998444 1017.743164,486.960785 1017.170471,486.860107 
	C1015.750916,485.580627 1015.768433,484.233673 1016.613403,482.482239 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M1018.780640,477.951843 
	C1018.637878,478.335266 1018.430054,478.342560 1018.361450,478.264404 
	C1016.863770,477.074524 1016.697510,475.616119 1017.360718,473.579041 
	C1017.833740,472.988007 1018.086914,472.808258 1018.788086,472.755981 
	C1019.506653,473.099396 1019.777222,473.315308 1020.063354,473.803406 
	C1020.078857,474.075562 1020.216431,474.440918 1020.201904,474.636108 
	C1018.842957,475.317352 1019.228516,476.602356 1018.780640,477.951843 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1018.342163,628.941406 
	C1018.918335,625.629883 1014.296997,626.298035 1014.070679,623.359131 
	C1016.190613,622.290833 1017.418213,619.089600 1020.692871,620.744141 
	C1020.952332,620.959106 1021.001892,621.004272 1021.026672,621.028320 
	C1018.148560,623.022156 1020.498413,626.578003 1018.342163,628.941406 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1017.980591,629.697510 
	C1017.220398,630.010376 1016.450195,630.090637 1015.290283,630.112305 
	C1015.020813,628.249634 1015.810852,627.729736 1017.700928,628.874084 
	C1017.998535,629.000061 1017.970520,629.464905 1017.980591,629.697510 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M57.120911,1023.170166 
	C57.437794,1022.919495 57.889908,1022.936218 58.677170,1023.022766 
	C59.012314,1023.092529 58.975063,1023.435547 58.963291,1023.606140 
	C58.386395,1023.663696 57.821270,1023.550659 57.120911,1023.170166 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1019.177856,472.472839 
	C1019.008850,472.952667 1018.781677,473.021820 1018.200439,473.130676 
	C1013.730164,475.080200 1009.954468,472.072174 1005.927307,472.332672 
	C1003.989258,472.458099 1002.065674,471.780731 999.725769,471.421448 
	C998.509521,471.161530 997.758240,470.844574 996.842468,470.011902 
	C996.098572,468.642212 996.195984,467.620178 997.006470,466.319458 
	C997.459961,465.860077 997.668335,465.706207 998.239075,465.425262 
	C998.852539,465.270630 999.103638,465.243103 999.728516,465.234131 
	C1000.585999,465.314911 1001.068909,465.382507 1001.904419,465.485291 
	C1006.625977,465.270325 1010.960938,466.453766 1015.458313,465.589874 
	C1011.594971,463.128143 1007.118286,463.089386 1002.458740,462.325836 
	C1000.762024,462.121521 999.526428,461.671997 997.956116,460.914246 
	C995.955261,459.531921 995.115601,458.227448 997.312744,456.288208 
	C1004.870667,455.120392 1011.819397,455.968353 1018.747314,459.056488 
	C1018.982483,460.134247 1019.008484,460.819092 1019.131897,461.836975 
	C1019.083069,462.823181 1018.936768,463.476318 1018.913086,464.446503 
	C1019.149963,465.007080 1019.264221,465.250610 1019.238220,465.872498 
	C1018.470886,468.190308 1018.990051,470.125519 1019.177856,472.472839 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M1021.377502,461.966370 
	C1021.021057,461.511505 1021.020264,461.151367 1021.028015,460.524231 
	C1022.166016,460.111755 1023.366028,459.769867 1023.908325,461.629486 
	C1023.189697,462.002686 1022.461365,462.031891 1021.377502,461.966370 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M1019.292847,466.100220 
	C1018.994507,466.007812 1018.890991,465.764740 1018.911560,465.142578 
	C1019.538269,465.024719 1019.783569,465.384003 1019.292847,466.100220 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1020.886475,620.614807 
	C1019.810547,621.569946 1017.656006,619.963928 1017.525391,623.046875 
	C1017.454773,624.713806 1015.687439,622.831421 1014.342285,623.009827 
	C1014.005066,623.005188 1014.000000,623.000000 1013.997192,622.997192 
	C1013.424255,622.288513 1012.541016,621.982971 1011.700378,621.088745 
	C1011.038574,619.991455 1010.910889,619.086426 1010.848450,617.816284 
	C1010.879211,617.001648 1010.956665,616.542603 1011.463135,615.513672 
	C1012.640381,614.973572 1013.437073,615.011902 1014.633179,615.032837 
	C1016.961975,616.767212 1018.891296,618.518860 1020.886475,620.614807 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M1018.028442,611.360352 
	C1018.199219,611.046326 1018.563049,611.020325 1018.744751,611.006470 
	C1018.926392,612.242249 1018.926392,613.491821 1018.926392,615.139954 
	C1016.893677,614.150024 1017.107910,612.987366 1018.028442,611.360352 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M1020.928040,611.271240 
	C1021.436157,611.010376 1021.893066,611.046265 1022.689575,611.027588 
	C1022.700500,612.115356 1022.827576,613.572388 1021.108276,613.754517 
	C1021.031128,613.025696 1020.953979,612.296875 1020.928040,611.271240 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1014.178467,611.658508 
	C1014.293823,610.760864 1014.504089,610.181885 1015.298035,610.491028 
	C1015.485229,610.563843 1015.702454,611.101929 1015.614075,611.241821 
	C1015.307983,611.726624 1015.240356,612.917236 1014.178467,611.658508 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1019.102661,215.532654 
	C1020.436829,216.677460 1019.734558,218.563583 1019.871094,220.698425 
	C1019.791870,221.092331 1019.498901,221.077866 1019.353516,221.058350 
	C1019.164246,219.344604 1019.120361,217.650345 1019.102661,215.532654 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M1020.159546,227.961365 
	C1020.225464,227.591583 1020.631042,227.747391 1020.812744,227.866302 
	C1020.917664,229.010315 1020.840942,230.035431 1020.764160,231.060532 
	C1020.540649,231.041626 1020.317200,231.022720 1020.093689,231.003799 
	C1020.093689,230.112915 1020.093689,229.222015 1020.159546,227.961365 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M4.999283,130.000610 
	C5.628633,130.103241 6.364341,130.084824 6.501675,130.914322 
	C6.530614,131.089111 6.167414,131.328857 5.984904,131.538666 
	C5.680569,131.215073 5.376231,130.891479 5.036633,130.283340 
	C5.001373,129.998779 5.000000,130.000000 4.999283,130.000610 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M21.114117,823.639709 
	C21.213795,824.856018 21.118570,825.834656 21.012920,827.303040 
	C19.248278,827.557617 17.494062,827.322388 15.367785,826.986328 
	C15.793578,825.652710 8.839099,823.050171 16.092899,822.838501 
	C17.962360,822.992615 19.440786,823.197266 21.114117,823.639709 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M3.401496,957.022217 
	C4.318575,955.061157 6.058188,956.380493 7.840815,956.721313 
	C6.633568,957.014648 5.229136,957.025085 3.401496,957.022217 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M5.940859,951.405396 
	C6.420218,951.012573 6.873066,951.027527 7.660025,950.975830 
	C7.937327,952.275635 10.379663,953.090088 8.895898,954.691284 
	C8.570034,955.042847 7.644594,955.049194 7.064098,954.915588 
	C5.206573,954.487915 5.680021,953.082031 5.940859,951.405396 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M6.630454,440.852600 
	C6.733513,441.189056 6.522667,441.490265 6.035022,441.864624 
	C5.944330,441.564270 6.130439,441.190826 6.630454,440.852600 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M12.252763,619.739868 
	C9.374787,621.677185 7.328098,621.077881 5.551618,618.185059 
	C5.380816,616.537476 6.649640,617.082275 7.661946,616.569702 
	C7.980604,616.442566 8.187400,616.842102 8.396844,616.924194 
	C8.836403,617.563354 9.126238,618.083557 9.759691,618.732361 
	C10.427281,618.991699 10.877822,619.044495 11.668789,619.112305 
	C12.177323,619.265869 12.345429,619.404419 12.252763,619.739868 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M8.166825,611.489868 
	C8.589614,611.125488 8.991377,611.066345 9.697546,611.020996 
	C9.855325,612.321716 9.708696,613.608643 9.295935,615.196716 
	C8.898018,614.833435 8.766234,614.169067 8.407579,613.256226 
	C8.169072,612.603638 8.157435,612.199402 8.166825,611.489868 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M3.025141,609.027954 
	C2.913574,609.829773 2.735767,610.573730 2.557959,611.317749 
	C1.743244,610.701904 1.939663,609.980164 2.581172,609.048218 
	C2.822289,608.859436 2.958901,608.970154 3.025141,609.027954 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1016.985046,63.620304 
	C1015.892517,64.303368 1014.794739,64.616890 1013.353516,64.960274 
	C1013.318054,63.889599 1013.626099,62.789070 1013.967102,61.344040 
	C1015.591797,60.957706 1017.021057,61.131035 1016.985046,63.620304 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M998.687988,490.726288 
	C999.847595,490.383118 1000.984741,490.257935 1002.549683,490.173096 
	C1007.311340,492.060425 1011.989807,490.121796 1016.625366,491.750061 
	C1011.161377,492.074921 1005.444458,492.082336 999.257202,491.947449 
	C998.789062,491.512238 998.748596,491.225250 998.687988,490.726288 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M452.633789,769.990540 
	C454.340240,775.359436 455.688507,780.751465 457.067444,786.543457 
	C452.314240,794.541382 445.914520,800.888672 440.455719,808.426208 
	C438.263641,810.831665 435.806976,812.290955 433.147095,813.188232 
	C415.380524,819.181702 398.925507,828.239380 381.551849,835.139648 
	C378.978943,836.161560 376.578522,837.871460 373.288086,837.235229 
	C370.322998,834.027527 364.719452,833.397461 361.286652,836.365295 
	C354.692505,842.066162 346.470581,841.825134 339.096100,841.089966 
	C335.625427,840.744019 331.771515,837.652832 327.341217,837.953430 
	C325.326019,838.090149 323.336792,838.093872 321.582001,839.203735 
	C317.170685,841.993713 312.542572,839.729248 308.027344,839.735107 
	C306.520874,839.737061 305.617188,838.139709 304.894226,836.773743 
	C304.353546,835.752258 303.932098,834.250061 303.067688,833.884827 
	C297.007812,831.324585 298.636139,828.984497 302.988586,826.338867 
	C305.177704,825.008179 305.605255,822.472839 305.875549,820.223816 
	C306.143707,817.992493 306.837616,817.129028 309.187408,816.932129 
	C314.216919,816.510559 319.366882,816.561035 321.789490,810.285278 
	C322.700287,807.926025 326.272491,808.413391 328.418671,810.025391 
	C331.997681,812.713501 335.165283,812.386658 338.174103,809.318665 
	C339.657318,807.806213 341.512421,808.118103 343.302490,807.923889 
	C345.065826,807.732605 345.962128,806.656006 345.908600,804.884827 
	C345.854340,803.088196 344.819672,802.058411 343.079956,802.068115 
	C339.820312,802.086426 337.064667,799.105713 333.525574,800.565979 
	C333.036224,800.767883 332.097107,799.879822 331.162842,799.212280 
	C335.040558,798.291321 339.114960,797.165955 343.203949,797.110229 
	C354.977722,796.949707 366.701019,795.645203 378.497406,795.941223 
	C391.874817,796.276855 404.251617,791.784912 416.416779,786.951050 
	C428.709717,782.066467 441.059235,777.215332 452.633789,769.990540 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M230.795288,890.179810 
	C228.863983,887.813721 227.239273,885.576355 225.349091,883.155518 
	C223.052307,878.565369 221.021011,874.158569 218.943817,869.390808 
	C219.604980,867.632263 219.034500,866.479065 217.874207,865.274536 
	C217.338974,864.654175 217.128784,864.135742 216.908783,863.330933 
	C216.880539,858.219788 213.938675,854.293640 212.816650,849.805542 
	C212.576141,848.843506 211.979630,847.988220 211.749863,847.010193 
	C211.011063,843.864868 211.264359,840.496155 214.138794,838.997925 
	C217.179550,837.413025 218.693314,840.604004 220.260223,842.692566 
	C220.737305,843.328491 220.948181,844.200928 221.922577,844.529724 
	C221.928314,841.962036 221.489029,839.482239 221.685379,836.987122 
	C222.051132,832.339844 223.133820,831.705017 228.016388,833.669312 
	C228.529648,834.019165 228.723312,834.177246 229.146454,834.633667 
	C229.548965,835.402954 229.628937,835.887878 229.497528,836.740845 
	C226.706238,841.515076 230.291672,845.931702 229.414124,850.405518 
	C228.966492,852.687622 230.239273,854.482300 232.760956,855.534241 
	C235.699280,856.191711 235.519302,854.362976 235.671356,852.709717 
	C235.847534,850.794312 234.755676,848.860840 236.078339,846.763428 
	C236.876358,846.451477 237.362808,846.497437 238.112427,846.938171 
	C239.346420,851.060852 239.070755,854.916321 238.452988,857.780762 
	C238.452606,859.440552 239.567627,858.596680 238.942825,858.829224 
	C238.302658,855.776184 239.093109,852.790710 239.599823,849.461182 
	C243.244766,849.497131 246.660049,849.852844 250.510834,850.267578 
	C252.846863,851.711243 254.719879,853.081360 257.318359,852.102417 
	C258.341492,851.716980 259.300323,851.859070 259.476257,853.288940 
	C259.499878,853.480713 259.540131,853.216187 259.543030,853.203979 
	C259.882568,851.766479 260.855743,851.495056 261.431580,852.754700 
	C262.986359,856.156311 264.898560,856.743469 268.591980,855.518982 
	C272.740723,854.143494 275.844818,857.363586 275.107513,861.670044 
	C274.780029,863.582825 274.964081,865.658997 273.553833,867.619263 
	C267.284149,869.388550 261.239868,867.823730 256.506805,868.285522 
	C263.728394,868.351624 271.922852,870.190979 280.055908,872.350342 
	C281.261047,872.670349 282.858032,872.990845 282.850067,874.683838 
	C282.845184,875.721680 281.565674,875.676270 280.873291,876.032166 
	C284.776215,876.759888 288.795685,876.160645 293.076538,877.091370 
	C294.507111,877.902039 294.690399,878.798767 293.840332,880.135925 
	C293.321808,880.463867 293.089081,880.545654 292.495117,880.664429 
	C289.323212,880.284180 288.097748,881.896362 287.633789,884.580444 
	C287.889038,884.996216 288.014771,885.149170 288.342346,885.526367 
	C288.775787,886.046509 288.976227,886.361877 289.226501,886.931519 
	C289.498749,887.563599 289.781219,887.527954 290.433105,887.332520 
	C293.793762,888.907715 293.136993,890.578918 290.720886,891.984070 
	C289.278351,892.823059 287.588165,893.069397 285.628967,892.128784 
	C284.395569,891.808777 286.177063,889.002441 283.607239,890.328857 
	C280.235352,892.069153 276.702850,893.505432 272.610138,894.454468 
	C263.997131,896.423889 255.750015,898.357239 247.362137,893.759583 
	C246.256699,891.419312 245.195236,889.574951 242.336243,889.217163 
	C241.851532,889.016602 241.665894,888.923584 241.235641,888.641357 
	C240.776672,888.137939 240.528336,887.854736 239.959930,887.637329 
	C239.326553,887.692749 238.963821,887.687561 238.346680,887.539246 
	C237.841354,887.260315 237.537384,886.865051 237.295135,887.037659 
	C236.759232,887.419434 237.144684,886.775024 237.565369,887.612061 
	C237.566620,888.102539 237.529877,888.301880 237.403381,888.798950 
	C237.112610,889.709045 236.796249,890.317383 236.780716,890.949951 
	C236.669510,895.479858 234.712082,894.324097 232.188660,892.216064 
	C231.901337,892.054260 231.971863,892.011108 231.961426,892.051147 
	C231.556229,891.550110 231.546494,890.825745 230.795288,890.179810 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M228.268646,834.792786 
	C223.096207,832.389465 223.011459,832.419922 223.015320,837.887573 
	C223.016815,840.025696 222.762329,842.179565 223.578018,844.285583 
	C224.039505,845.477112 224.572403,847.115784 222.821350,847.657532 
	C221.071655,848.198914 220.856750,846.316345 220.151031,845.302307 
	C219.963928,845.033508 219.878754,844.695923 219.709915,844.411865 
	C218.474106,842.332764 217.078094,838.643433 214.860626,839.795410 
	C212.296722,841.127319 211.880905,844.848633 213.023712,848.174500 
	C214.656845,852.927368 217.760773,857.244263 217.178223,862.818726 
	C213.249023,855.364258 211.050644,847.168579 208.324661,839.154480 
	C202.704208,822.630859 196.868942,806.180420 191.100006,789.328003 
	C191.703735,788.181274 191.512665,787.312500 191.107849,786.244080 
	C190.849594,786.039368 190.871780,786.127869 190.833893,786.152100 
	C191.346405,781.940979 187.552399,777.989990 190.052216,773.240295 
	C192.028656,771.317688 190.039764,769.789246 190.121368,768.257019 
	C190.225800,766.295593 188.504120,764.514343 189.777283,762.226318 
	C191.700180,761.960510 193.069595,762.337708 192.974213,764.416565 
	C192.791321,768.402893 194.855301,768.253113 197.772430,767.291931 
	C199.460602,766.735596 201.199371,766.870728 203.001083,767.902161 
	C206.518921,769.916138 209.827805,768.516113 211.920853,764.542175 
	C212.185028,764.684326 212.528305,764.763367 212.699844,764.979004 
	C213.597107,766.107178 212.092773,769.124390 214.814072,768.546753 
	C216.900192,768.103943 215.713013,765.813782 215.702179,764.247559 
	C215.690323,762.535767 214.632401,761.197998 214.287338,759.722900 
	C213.049255,754.430298 211.819519,749.077393 212.657455,743.288574 
	C219.163330,769.752625 228.169373,795.859741 230.850494,823.786865 
	C230.521408,824.286499 230.277771,824.366211 229.658997,824.369080 
	C225.493469,819.814636 227.157898,814.342529 226.455444,810.175232 
	C226.461655,810.107056 226.346085,810.913818 225.111542,811.384766 
	C221.966415,808.849365 221.816528,805.473145 221.939911,801.695312 
	C222.211426,800.772339 222.623245,800.322021 223.014740,799.903076 
	C223.245468,799.656189 223.491501,799.689880 223.390198,799.648254 
	C223.092407,799.526123 222.914963,799.664185 222.554565,800.155884 
	C218.380615,798.201111 220.119080,793.476501 217.527466,790.466675 
	C216.819305,789.797729 217.032104,788.874817 216.254211,788.650330 
	C216.367523,788.931702 216.364990,789.221191 216.124268,789.815247 
	C215.421524,797.865601 217.809036,805.246216 218.877701,812.791992 
	C219.037811,813.922607 219.307999,815.041382 219.471191,816.522949 
	C219.555984,817.081787 219.592941,817.300659 219.625122,817.834229 
	C219.645096,818.629395 219.001343,819.101562 219.873825,819.615967 
	C220.327164,819.617310 220.509293,819.591614 220.928452,819.432129 
	C221.300339,818.939087 221.323273,818.569580 221.189453,817.889221 
	C221.017395,817.170654 220.940002,816.752258 220.840225,816.005127 
	C220.715759,814.342346 220.721619,812.998047 220.476425,811.321289 
	C220.512497,810.739502 220.563065,810.508423 220.833405,809.995972 
	C223.420624,808.713379 223.475937,811.595459 225.257584,812.285522 
	C226.025345,813.089661 226.346191,813.741943 226.548676,814.831421 
	C226.037399,818.547485 226.755051,821.724548 228.118561,825.153931 
	C229.356400,827.796936 229.790588,830.255188 229.766342,833.164185 
	C229.451385,834.030334 229.094589,834.381592 228.268646,834.792786 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M372.765717,837.278564 
	C384.819672,832.411133 396.465210,827.419739 407.982666,822.102417 
	C416.024323,818.389771 424.042572,814.591736 432.610931,812.087830 
	C435.005554,811.388000 437.037018,809.445435 439.574310,808.013672 
	C443.632080,809.353760 443.125397,811.774963 441.360168,814.354126 
	C439.883789,816.511353 437.516327,817.943909 436.186249,820.702148 
	C435.684784,821.723206 435.140167,822.213318 434.152161,822.757935 
	C427.377167,827.127869 420.931946,831.328430 414.238098,835.769104 
	C410.649567,840.451355 405.296326,841.252991 400.633698,843.153809 
	C391.009216,847.077393 381.536804,851.459595 371.007996,853.924927 
	C369.506775,853.716187 368.445099,853.318542 367.509155,852.665466 
	C364.326965,850.444885 363.591339,851.859131 363.934448,855.374512 
	C359.660400,860.183777 354.458282,861.763489 348.210144,860.743225 
	C347.303223,859.187073 347.217163,858.095093 349.188232,857.438721 
	C349.807129,856.882202 350.403900,856.998230 350.764313,856.665955 
	C350.482147,856.739197 350.219269,856.859863 349.701172,857.201904 
	C347.480469,857.966248 345.313354,856.436584 343.051514,858.158325 
	C344.543457,859.185852 346.973358,857.535095 347.550049,860.274902 
	C345.680084,864.977661 340.903137,863.781860 337.353424,865.830200 
	C335.680145,866.256104 334.382935,866.308777 332.733948,865.816772 
	C331.455200,865.129089 331.154144,864.241516 331.081482,862.914001 
	C331.220184,861.979431 331.695496,861.513672 331.617798,861.142822 
	C331.275787,861.463013 331.086304,861.530762 330.587097,861.578552 
	C330.081421,861.476868 329.885498,861.395081 329.441315,861.104675 
	C327.807800,859.247070 328.428619,857.538635 329.194153,855.528748 
	C329.484406,855.052063 329.623352,854.877136 330.031433,854.507019 
	C331.924286,853.696411 333.308716,852.736633 334.631989,851.164795 
	C336.920105,847.625427 340.774841,848.371765 343.723846,847.488892 
	C353.475922,844.569092 362.972992,840.985840 372.765717,837.278564 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M274.246674,867.098389 
	C273.269806,865.645935 272.738159,864.480591 273.448914,863.086426 
	C274.660248,860.710388 274.645294,858.133728 272.161224,857.012024 
	C269.233276,855.689941 266.359802,856.217529 265.401825,860.626526 
	C267.358429,855.428162 258.878723,857.798828 261.316040,852.651978 
	C259.371033,853.693176 260.512512,855.154968 259.539764,855.989746 
	C259.109467,850.245789 251.349609,857.178589 251.024246,850.665039 
	C259.767151,849.290405 268.450012,851.154785 277.200928,851.586487 
	C285.692566,852.005432 294.180420,852.673157 302.887512,851.681702 
	C304.766907,857.377502 303.670624,858.819641 298.148926,859.128235 
	C295.701141,859.265076 293.297241,860.304199 291.371429,857.774292 
	C291.085999,857.399292 290.383209,858.398010 289.560486,858.893860 
	C288.832581,859.198669 288.417267,859.177185 288.019043,858.940247 
	C287.981445,858.917847 287.832245,858.976257 287.601379,859.062927 
	C287.464508,859.114319 287.609772,859.090942 288.342682,859.139282 
	C290.078339,859.498291 290.825897,860.369995 290.261597,861.701050 
	C289.676697,863.080688 288.375092,863.459412 286.694763,863.245239 
	C286.375946,863.562439 286.271454,863.714355 285.872253,864.357178 
	C285.286438,865.377991 284.996918,865.908813 284.502930,866.695557 
	C283.637848,867.645447 282.800476,867.850159 281.549316,867.719849 
	C280.139801,867.070496 279.058411,866.371033 277.583801,867.651917 
	C276.282135,868.032715 275.342590,867.950623 274.246674,867.098389 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M285.713745,863.287354 
	C286.483521,862.669067 285.235352,860.446411 286.917053,861.664856 
	C288.050323,862.486023 288.642761,862.254395 289.201569,861.677856 
	C290.274475,860.571045 288.913727,860.127075 288.173950,859.248901 
	C290.025604,858.413208 289.973419,856.072754 291.416718,854.893799 
	C292.804108,856.021057 292.762787,859.939453 294.815613,858.539429 
	C297.562653,856.665771 304.550323,860.277710 303.080566,852.271729 
	C303.592377,851.660217 304.074341,851.454773 304.814484,851.192078 
	C305.285004,851.382324 305.422150,851.657043 305.452637,851.962158 
	C305.505981,852.496216 305.483551,853.032166 305.468506,853.567566 
	C305.524933,852.946045 305.505737,852.320740 305.743744,851.417969 
	C308.137787,851.137207 310.382751,850.540344 312.783813,851.819336 
	C314.168213,853.426941 313.544312,854.995728 313.688232,856.733032 
	C313.527496,857.396912 313.331512,857.715027 312.854828,858.148315 
	C312.674438,858.329956 312.329651,858.663940 312.191925,858.841614 
	C312.054199,859.019287 311.646912,858.927246 311.849548,858.987549 
	C312.052155,859.047791 312.315582,858.679443 312.490051,858.517090 
	C312.914124,858.110901 313.201996,857.922852 313.796570,857.835571 
	C315.013245,858.400574 315.721283,859.137695 316.420227,860.328247 
	C316.790833,862.647461 315.781128,864.222046 314.518555,866.041626 
	C313.458038,866.812012 312.588165,866.871155 311.414551,866.434204 
	C310.657776,866.084167 311.183075,865.124268 310.074585,865.274109 
	C309.446808,865.334045 309.107483,865.233459 308.667053,864.806641 
	C308.595947,864.244019 308.555542,863.918213 308.347290,863.838989 
	C308.282196,864.072571 307.959625,864.441162 307.801422,864.630371 
	C307.643219,864.819580 307.333466,865.208435 307.131470,865.349670 
	C306.929443,865.490906 306.440704,865.550598 306.205261,865.514282 
	C305.105530,865.781921 304.806244,866.871399 303.474365,867.126099 
	C297.387024,867.618225 291.652405,868.086487 285.559875,866.676941 
	C284.713867,866.000854 284.518494,865.456299 284.805542,864.422363 
	C285.029999,864.025940 285.001221,864.004883 285.014954,864.011841 
	C285.179962,863.855347 285.331238,863.691895 285.713745,863.287354 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M244.117798,827.084656 
	C244.575485,821.484741 247.881683,816.992920 249.021576,811.373901 
	C250.666107,808.614380 250.858704,805.746704 251.875092,803.173096 
	C252.640305,801.235413 253.168259,798.890259 256.485168,799.795288 
	C257.098938,803.602356 260.282928,805.767517 261.310364,809.380249 
	C261.582092,812.021973 261.815765,814.326233 260.316650,816.800537 
	C256.928864,821.021545 252.099319,823.174316 249.210251,827.771118 
	C247.303848,828.556702 245.873245,827.656921 244.117798,827.084656 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M256.709625,799.657715 
	C254.197083,799.781860 253.563919,801.580750 253.037430,803.573730 
	C252.351349,806.170898 252.324860,809.077393 249.454498,810.931763 
	C251.056122,797.310303 247.606308,783.739929 248.258392,770.022644 
	C252.087173,779.502014 253.953964,789.512451 256.709625,799.657715 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M318.725067,851.291748 
	C321.084991,851.487671 323.474304,848.541931 325.710480,851.697510 
	C326.168427,852.018860 326.333893,852.169434 326.645508,852.623169 
	C326.977386,853.584167 326.994507,854.252563 326.850983,855.254028 
	C326.711121,855.789001 326.636475,855.996887 326.410187,856.496460 
	C324.897644,858.517761 324.223816,860.512695 323.888428,862.992188 
	C323.684631,863.502808 323.577454,863.696899 323.223480,864.115112 
	C320.520386,863.289368 315.579742,865.358948 317.041992,859.229675 
	C317.331757,858.661621 317.568024,858.449158 317.808289,858.237183 
	C317.934113,858.126221 317.942993,857.974670 317.928131,857.888306 
	C317.815063,857.231323 317.116425,857.537231 317.770264,857.667542 
	C317.773865,857.668335 317.773804,857.828979 317.460327,858.127563 
	C316.992981,857.962891 316.835327,857.820251 316.552673,857.377075 
	C316.184143,854.882263 317.370758,853.223389 318.725067,851.291748 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M237.902054,846.777588 
	C237.515564,846.911621 237.088440,846.864075 237.088440,846.864075 
	C237.088440,846.864075 236.659683,846.893433 236.445023,846.898499 
	C234.528870,846.118958 234.977142,844.075073 233.717377,842.635376 
	C232.718140,840.963257 232.958359,839.196777 231.723297,837.595215 
	C231.419647,837.077209 231.311676,836.858887 231.084778,836.289368 
	C230.601532,833.923340 230.507095,831.912598 231.248566,829.579224 
	C233.286270,828.846313 234.629807,829.753052 235.466644,831.190613 
	C236.576950,833.097900 238.245956,833.071472 240.426361,832.956787 
	C242.344910,835.726868 240.527328,837.978210 239.544479,840.766479 
	C238.774780,842.922607 239.397064,844.967651 237.902054,846.777588 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M326.198364,853.197998 
	C325.998627,852.751892 326.003021,852.575745 326.005219,852.134033 
	C326.692566,850.426575 327.878296,849.903015 329.766449,850.045654 
	C330.281281,850.194641 330.442841,850.323547 330.800964,850.212646 
	C332.609558,848.171570 333.117584,850.727356 334.534088,850.849731 
	C334.772278,853.590515 333.706177,855.267944 330.357422,854.998047 
	C330.515747,856.780579 328.380737,858.492249 330.039062,861.346680 
	C329.435516,864.492798 327.834229,865.860474 325.240662,866.596008 
	C324.387726,866.722961 323.901001,866.676453 323.110992,866.343750 
	C322.559540,865.700562 322.468353,865.228699 322.724213,864.416382 
	C322.921844,864.104736 322.978516,863.744629 322.986298,863.562500 
	C323.248627,862.778625 323.509491,862.181396 324.429138,861.807983 
	C324.934540,862.043823 325.169250,862.182800 325.458130,862.210876 
	C325.279572,862.028564 324.972504,862.092590 324.610657,861.598511 
	C323.710724,859.471069 324.784241,858.065186 325.812622,856.294189 
	C326.026093,855.994202 325.994629,855.995789 326.000183,856.010498 
	C326.711609,855.261780 326.498901,854.355835 326.198364,853.197998 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M304.046509,808.119751 
	C307.660126,806.506287 311.446136,805.225708 315.619232,803.916504 
	C315.959381,805.683167 319.352509,807.506226 316.107208,809.237244 
	C313.336426,810.715149 310.711334,813.512512 307.148621,811.066223 
	C306.078400,810.331421 305.190369,809.331177 304.046509,808.119751 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M243.883087,826.879150 
	C245.591904,825.974121 247.093903,826.258179 248.662369,827.831299 
	C246.297211,832.955688 243.649582,837.942749 240.676041,843.041626 
	C239.430908,842.773987 239.214905,841.984314 239.192871,840.689392 
	C240.950989,836.858459 241.870514,833.192810 242.751709,829.091980 
	C242.907547,828.717224 242.872589,828.368408 242.911987,828.197632 
	C243.211197,827.828613 243.448013,827.605957 243.800003,827.157715 
	C243.938171,826.956543 243.893555,826.909790 243.883087,826.879150 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M318.654724,851.052979 
	C318.298492,853.114014 317.646393,855.187256 316.973572,857.921204 
	C316.902405,858.771851 316.851929,858.961792 316.403992,859.572754 
	C314.715240,860.091370 314.135223,859.204834 313.294403,858.122131 
	C312.756653,856.264038 311.813660,854.538879 313.005371,852.480408 
	C314.493042,850.264893 316.927429,853.138306 318.654724,851.052979 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M239.548950,839.855042 
	C239.896774,840.888916 239.971573,841.661682 240.198257,842.793945 
	C240.023712,844.977905 239.697296,846.802368 239.600189,848.884094 
	C239.970093,852.846375 239.822861,856.512695 237.742142,860.009705 
	C237.742142,855.947815 237.742142,851.885864 237.628845,847.367798 
	C237.738617,845.004639 237.961655,843.097656 238.264511,840.791138 
	C238.350250,839.769958 238.660507,839.503723 239.548950,839.855042 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M260.408783,817.065186 
	C260.202301,814.857849 259.400940,812.472046 261.052734,810.000244 
	C266.052856,812.995972 266.035065,813.189331 260.408783,817.065186 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M240.122955,839.882385 
	C239.491089,840.167480 239.160233,840.218811 238.586838,840.330933 
	C239.106293,838.138794 239.868301,835.885925 240.724121,833.287109 
	C241.348068,831.693848 241.878220,830.446594 242.657959,828.958313 
	C243.470856,832.677124 241.867325,836.144653 240.122955,839.882385 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M231.290649,828.913330 
	C231.707825,831.547119 231.976608,833.847351 232.146576,836.577393 
	C229.846695,837.214905 230.248505,835.252075 229.585297,833.699219 
	C229.411484,830.393738 228.469421,827.539368 229.558624,824.296570 
	C229.836487,823.957764 230.284836,824.143250 230.524933,824.175049 
	C230.890778,825.664429 231.016541,827.122131 231.290649,828.913330 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M317.035339,803.977661 
	C317.913757,803.236755 319.116730,802.641479 320.655090,802.008057 
	C320.715820,804.264832 319.780182,805.445557 317.035339,803.977661 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M305.711853,851.114319 
	C305.797943,851.810669 306.467834,852.722351 305.339752,853.097595 
	C305.230804,852.637512 305.121887,852.177490 305.042816,851.426147 
	C305.072662,851.134888 305.498840,851.091919 305.711853,851.114319 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M330.778137,849.996704 
	C330.929626,850.509521 331.208527,851.196045 330.412140,851.399902 
	C330.363831,851.412292 330.181152,850.899658 330.090332,850.348511 
	C330.119690,850.065735 330.558716,850.020508 330.778137,849.996704 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M241.112762,736.906616 
	C241.688034,737.193359 242.158661,737.737976 241.672424,738.223755 
	C241.217239,738.678528 241.097626,737.980896 240.867889,737.418091 
	C240.811478,737.169983 241.011902,736.993896 241.112762,736.906616 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M325.111084,800.921021 
	C325.318756,800.614624 325.852997,800.318481 326.700775,800.000366 
	C326.488770,800.296021 325.963196,800.613647 325.111084,800.921021 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M243.609100,742.361633 
	C243.426483,742.217285 243.395462,741.956604 243.364456,741.695984 
	C243.496536,741.879089 243.628616,742.062256 243.609100,742.361633 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M244.527283,744.520142 
	C244.477463,744.550842 244.577103,744.489502 244.527283,744.520142 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M328.012146,799.858521 
	C327.998444,799.677673 328.242126,799.440369 328.731964,799.131653 
	C328.741913,799.307495 328.505737,799.554749 328.012146,799.858521 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M243.682648,827.026550 
	C243.758743,827.234680 243.579315,827.512756 243.175629,827.908813 
	C243.109955,827.716675 243.268539,827.406616 243.682648,827.026550 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M506.113342,441.611053 
	C505.357697,442.546021 504.638123,443.088013 503.296570,442.939392 
	C500.892578,443.028137 499.757111,441.605988 498.283417,440.104065 
	C497.536194,440.534485 497.088562,441.107330 496.309326,441.830444 
	C494.371277,443.733521 492.361206,443.952209 489.832001,443.441772 
	C489.027435,443.280273 488.574860,443.156219 487.803223,442.865936 
	C487.283447,442.589355 487.090210,442.451782 486.709503,442.011292 
	C486.481842,441.474304 486.441620,441.240173 486.464447,440.656677 
	C486.657013,440.110992 486.786530,439.914642 487.223999,439.550201 
	C490.020538,439.540009 492.499573,439.622803 495.040863,438.247253 
	C495.324188,437.644348 495.805847,437.633240 495.922760,437.311890 
	C495.949066,437.239563 495.759338,437.174866 495.642700,437.222931 
	C495.026398,437.477112 495.885651,437.080872 495.357300,437.888184 
	C493.461670,439.283173 491.524689,439.460663 489.214233,439.365417 
	C484.810028,435.673767 488.237183,432.401947 489.521362,428.485077 
	C486.713928,429.411743 483.398315,427.907043 482.027252,432.042511 
	C482.097076,432.885559 482.109711,433.376068 482.050507,434.252747 
	C481.879028,435.156830 481.655792,435.629761 481.004578,436.284241 
	C480.401917,436.515320 480.133179,436.520752 479.501373,436.701477 
	C478.120331,434.482697 477.102356,432.088593 476.031311,429.334473 
	C475.860260,428.774445 475.742279,428.574371 475.744446,428.047424 
	C477.427307,426.472290 479.292084,425.530884 480.427551,423.346252 
	C483.639008,422.386688 486.599945,422.072754 489.946716,422.007629 
	C491.768250,422.039551 493.246277,421.897583 493.768616,422.022980 
	C493.714569,422.026245 492.716187,421.993256 491.341705,421.996887 
	C488.806030,421.980713 486.583801,422.194183 484.551331,421.323151 
	C479.788544,419.281952 474.840607,419.272339 469.821259,419.706146 
	C468.192749,419.846924 466.483093,420.314178 465.126831,418.484863 
	C466.812469,417.376862 468.587524,416.870453 470.130280,415.967224 
	C484.270355,407.688843 497.809875,407.974823 510.719543,418.589661 
	C511.478729,419.213806 512.427673,419.607086 513.630371,420.212036 
	C514.582275,420.142670 515.130066,420.251617 515.725098,420.947021 
	C521.816467,425.548065 522.376038,425.314270 523.432129,418.046570 
	C525.346130,427.481873 523.976501,430.722900 515.679382,435.273651 
	C513.157227,436.656921 511.263550,438.614624 508.923096,440.702637 
	C508.154724,440.162170 508.739380,438.828400 506.839111,439.338165 
	C505.046387,439.819092 506.232574,440.600128 506.113342,441.611053 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M453.717407,499.147583 
	C453.388702,499.058136 452.891632,499.042511 452.891632,499.042511 
	C452.891632,499.042511 452.413666,499.179962 452.223511,499.340210 
	C451.928589,499.722931 451.823853,499.945404 451.380249,500.022156 
	C450.400482,499.580353 449.759552,499.284302 448.757324,498.956482 
	C448.670807,498.622955 448.945587,498.321228 449.527527,497.970398 
	C450.143921,497.771912 450.415405,497.570801 450.806763,497.119751 
	C456.237030,489.567383 462.068176,483.118652 472.265808,484.052856 
	C472.904022,484.488861 471.892914,485.276154 472.934814,485.320251 
	C476.012939,484.949158 478.820984,484.738220 481.604828,484.352600 
	C485.090485,483.869812 488.367035,484.028046 487.264404,478.192413 
	C486.443909,473.849976 489.399689,469.832001 494.505249,468.220520 
	C494.884796,470.378418 492.642090,470.022186 492.093201,471.490967 
	C491.282715,474.344666 491.917938,475.905975 494.644257,477.078339 
	C498.709259,478.826263 502.581970,481.122772 505.704437,484.391022 
	C508.378998,487.190430 512.101135,486.623810 515.692749,487.675812 
	C516.130310,488.011505 516.231018,488.229126 516.260498,488.800690 
	C515.740601,489.753235 514.958374,489.847321 514.116699,490.509888 
	C509.469299,491.832520 505.309723,492.247864 501.871674,488.417664 
	C500.860870,487.291626 499.354950,486.378937 497.878448,487.474457 
	C494.915222,489.673126 491.970642,488.831604 488.859436,487.988159 
	C485.969604,487.204681 483.117432,487.122223 480.125305,488.319519 
	C476.847229,489.631256 473.223633,488.282349 469.438110,488.747131 
	C468.478638,488.562378 467.868591,488.323700 466.892151,488.551178 
	C461.406586,489.169006 459.200684,493.425995 456.145691,497.115967 
	C455.765717,497.821869 455.502075,498.194183 454.937683,498.757263 
	C454.465424,499.062347 454.255768,499.149689 453.717407,499.147583 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M476.664581,427.625488 
	C476.595612,428.106873 476.477509,428.284302 476.168823,428.718079 
	C470.126099,429.059082 466.553192,425.221008 462.959198,421.414795 
	C460.784058,419.111328 462.268616,418.398193 464.793762,418.022095 
	C467.034241,419.708008 469.035339,418.309692 470.776184,417.947388 
	C477.994843,416.445160 484.247131,420.482300 491.467255,421.153473 
	C492.069550,421.703766 491.977722,422.125000 491.296326,422.614624 
	C487.620239,423.259033 484.349701,424.327209 480.477539,424.109528 
	C479.083466,425.445190 476.718842,425.133087 476.664581,427.625488 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M433.521606,479.694946 
	C429.738586,480.562775 428.851776,476.385712 429.024628,475.938385 
	C430.313385,472.603668 426.924286,474.754547 426.458679,473.372803 
	C429.031189,466.974182 435.382812,466.052856 440.810303,463.193481 
	C441.475983,463.447845 442.139465,463.989349 442.059845,464.141205 
	C440.618744,466.890045 443.799316,470.784180 439.585785,472.968689 
	C438.941345,473.186218 438.644287,473.374878 438.206970,473.814697 
	C438.036682,474.018646 438.003998,474.021149 438.018890,474.030457 
	C437.553162,474.472137 437.313568,475.055176 436.896362,475.894318 
	C436.500061,476.496338 436.236633,476.810669 435.751221,477.331085 
	C435.008270,478.131622 434.491394,478.730164 433.521606,479.694946 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M515.692871,487.453857 
	C510.751953,488.742340 506.452545,487.686401 502.760101,483.344635 
	C500.353546,480.514862 496.676758,478.352264 493.042450,477.663483 
	C487.837158,476.676910 489.473297,474.636871 491.620239,471.915100 
	C492.771149,471.765259 493.655609,471.746246 494.816376,471.907715 
	C496.858063,475.420746 500.320984,476.469971 503.281647,478.207123 
	C505.123779,479.287994 507.166107,480.079926 508.768005,482.067017 
	C509.383972,482.869843 509.854767,483.352295 510.548004,483.952820 
	C511.702728,486.027771 513.657898,486.358765 515.692871,487.453857 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M515.853821,420.829468 
	C515.315552,421.073822 514.789429,420.929596 514.117859,420.550781 
	C511.314819,412.563110 508.657257,404.809998 505.999695,397.056854 
	C510.562805,404.366638 513.206665,412.406860 515.853821,420.829468 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M508.928406,482.003937 
	C504.791748,480.059601 500.690094,477.695496 496.535645,475.428101 
	C495.423859,474.821289 494.593903,474.230835 495.008301,472.454895 
	C498.216980,474.201935 501.328766,476.268219 504.876923,477.728210 
	C506.484314,478.389587 508.716461,479.169189 508.928406,482.003937 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M488.171631,444.510620 
	C483.917389,444.320526 481.333527,442.020172 479.739624,438.019226 
	C480.079865,437.873810 480.370453,437.878998 480.664490,437.324402 
	C480.791534,436.918793 480.938202,436.795990 481.371887,436.632385 
	C482.242310,436.709442 482.745728,436.994324 483.446228,437.518250 
	C483.812500,437.826050 483.953003,437.954712 484.293121,438.284210 
	C484.621490,438.620636 484.750275,438.756256 485.254639,439.301514 
	C485.744843,439.855072 485.859406,439.998993 486.226013,440.627716 
	C486.550140,441.278687 486.622223,441.444885 486.871155,441.817322 
	C487.048035,442.023560 486.978058,442.021667 486.974701,441.986816 
	C487.280151,442.225098 487.618347,442.455109 488.193634,442.871582 
	C488.521545,443.503510 488.529541,443.907043 488.171631,444.510620 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M488.360291,444.828369 
	C487.931824,444.374176 487.928711,444.038391 487.938232,443.450928 
	C487.949615,442.805450 488.123352,442.532959 488.713562,442.231598 
	C491.042480,442.675018 493.148743,442.633881 495.610474,441.962646 
	C495.097443,446.647858 491.522705,444.781799 488.360291,444.828369 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M498.078796,440.461670 
	C499.552734,440.763763 501.121613,441.565887 502.824097,442.654541 
	C501.869873,444.317413 500.369537,444.837280 498.353333,444.999756 
	C498.065979,443.657074 498.119873,442.309357 498.078796,440.461670 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M506.311005,442.010376 
	C504.316986,441.078094 504.273315,439.433716 505.231384,438.352905 
	C505.849701,437.655365 507.567749,438.766663 508.806793,437.960449 
	C508.971008,437.853607 508.928925,439.346313 508.699188,440.466125 
	C508.179657,441.710236 507.489410,442.075134 506.311005,442.010376 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M436.712830,478.841003 
	C437.164581,481.419525 435.973999,483.012878 433.519897,484.114685 
	C433.190369,484.210388 433.041748,484.046112 432.966125,483.965179 
	C432.590790,483.487457 432.490417,483.041595 432.785400,482.272522 
	C433.007904,481.991882 433.000000,482.000275 432.996765,482.005371 
	C433.504974,481.528748 433.500610,480.845520 433.845764,479.947449 
	C434.676880,479.012787 435.468384,478.667297 436.712830,478.841003 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M437.003906,478.991394 
	C436.258392,479.339935 435.501282,479.696106 434.215210,479.856201 
	C433.779144,478.803864 434.327240,478.145081 434.862244,477.154114 
	C435.167572,476.660004 435.330872,476.448273 435.718262,476.170898 
	C436.242767,475.658295 436.685760,475.488403 437.540649,475.750610 
	C438.568542,476.340149 439.007721,476.830322 438.254883,477.829865 
	C437.808411,478.231140 437.566010,478.451874 437.145203,478.839691 
	C436.982697,479.024323 436.992279,478.999023 437.003906,478.991394 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M499.279419,379.714630 
	C497.810638,379.709229 497.314148,379.027161 498.486389,378.520966 
	C500.222626,377.771240 502.170166,377.510864 504.777557,376.852966 
	C503.369324,379.570709 501.014801,378.703674 499.279419,379.714630 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M509.030884,375.039642 
	C508.544312,375.894165 508.014343,376.738190 506.900421,376.659851 
	C506.702087,376.645935 506.346313,376.245911 506.374054,376.074463 
	C506.536865,375.068024 507.424469,375.052124 508.492676,374.823914 
	C508.803680,374.769745 508.954559,374.950165 509.030884,375.039642 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M503.909851,373.992737 
	C503.625427,374.699829 503.049744,375.063293 502.439880,374.542633 
	C502.265839,374.394073 502.519257,373.744781 502.845459,373.218079 
	C503.334259,373.339722 503.541901,373.579163 503.909851,373.992737 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M437.922729,475.631104 
	C437.425751,475.988770 436.989929,476.032104 436.222412,476.070404 
	C436.413300,475.455963 436.935913,474.846558 437.746155,474.138489 
	C438.017151,474.465454 438.000549,474.891083 437.922729,475.631104 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M499.260742,376.002930 
	C499.294647,375.719696 499.610443,375.457458 499.952271,375.235321 
	C499.971344,375.222870 500.205383,375.541107 500.339386,375.705444 
	C500.075653,375.814453 499.811920,375.923462 499.260742,376.002930 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M480.316345,437.279968 
	C480.002655,437.553253 479.753967,437.734100 479.785522,437.634552 
	C479.817078,437.535004 479.864929,437.463379 479.899780,437.463440 
	C480.166443,437.311249 480.398254,437.158966 480.316345,437.279968 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M499.009552,376.013733 
	C498.667145,376.545135 498.356079,377.225159 497.650299,376.383636 
	C497.929626,376.257660 498.208984,376.131683 498.730774,375.989502 
	C498.973236,375.973297 498.998596,375.999298 499.009552,376.013733 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M450.790436,497.102081 
	C450.775879,497.230316 450.592377,497.545776 450.121796,497.891235 
	C450.096985,497.710602 450.359222,497.499939 450.790436,497.102081 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M440.077637,500.070374 
	C440.163544,499.995392 440.231354,499.904907 440.159760,499.922180 
	C440.020325,500.029938 440.059601,500.054810 440.077637,500.070374 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M504.115051,373.861023 
	C503.777405,374.017181 503.514648,373.821411 503.204254,373.339966 
	C503.458740,373.262665 503.803192,373.414276 504.115051,373.861023 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M480.364960,437.371399 
	C480.002655,437.553253 479.965393,437.509918 479.950012,437.486725 
	C479.755402,437.427063 479.576233,437.390625 479.267700,437.115479 
	C479.444092,436.696106 479.749878,436.515411 480.560913,436.165649 
	C481.066162,435.996613 481.358826,436.283508 481.363586,436.488342 
	C481.154663,436.858643 480.940979,437.024109 480.364960,437.371399 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M497.978516,444.977905 
	C497.813293,444.943268 498.213867,445.793884 497.840881,445.080566 
	C498.012085,445.004761 497.989166,444.988708 497.978516,444.977905 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M437.220886,478.926575 
	C437.178741,478.752289 437.374786,478.480255 437.802826,478.100586 
	C437.842926,478.271545 437.650970,478.550171 437.220886,478.926575 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M438.297943,473.942200 
	C438.263367,473.737610 438.490051,473.456573 438.992523,473.110107 
	C439.031952,473.318390 438.795563,473.592072 438.297943,473.942200 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M616.271606,868.409546 
	C616.000427,870.217957 616.082764,871.894958 613.457642,872.003418 
	C610.330078,870.950439 611.199158,866.098633 607.645081,866.328064 
	C605.076355,866.493835 602.854736,868.449402 600.399048,869.451660 
	C595.488770,871.455872 590.758423,873.871643 586.180847,876.544250 
	C584.922791,877.278748 582.331970,877.690552 583.256287,879.788330 
	C584.188477,881.903687 586.473328,882.590637 588.802063,881.591858 
	C592.149475,880.156189 595.558533,878.865234 598.810913,877.201233 
	C600.548279,876.312378 602.232483,875.084900 604.676208,875.692871 
	C605.076111,876.919128 605.430237,877.761230 606.922058,878.088989 
	C607.023438,880.592224 605.007935,881.237549 603.229980,881.877502 
	C597.851868,883.813171 592.783630,886.458679 587.231689,888.838257 
	C586.898010,889.434570 586.817017,889.759033 586.598206,890.565796 
	C582.712646,890.009827 580.643372,886.979126 578.179443,883.897339 
	C572.518066,878.724609 566.006775,875.471252 559.572876,872.177795 
	C551.627808,868.110718 543.480347,864.439209 535.195068,860.338745 
	C537.425659,857.458923 539.977966,860.798889 542.880615,859.925903 
	C546.753174,857.775696 549.268494,860.314819 551.867676,861.786133 
	C558.636719,865.618103 558.538879,865.645447 563.413452,859.705322 
	C567.813599,854.343567 572.260193,849.019836 576.610168,843.616760 
	C577.456421,842.565796 578.349426,841.611267 580.156494,841.686646 
	C581.408508,842.414734 582.332703,843.019714 583.545532,843.792725 
	C584.367615,847.859253 580.741943,849.300110 579.088684,851.898926 
	C578.123657,853.415955 576.682312,854.579468 575.062744,855.945801 
	C574.678345,856.526978 574.158264,856.451904 574.021301,856.824646 
	C573.989563,856.910889 574.149109,856.988892 574.277771,856.976990 
	C574.941650,856.915955 574.016113,857.059998 574.684570,856.351196 
	C577.786133,853.540100 581.437378,852.174316 584.899414,849.873291 
	C585.556763,849.456665 585.941711,849.237915 586.623047,848.877075 
	C587.105896,848.620605 587.300476,848.520935 587.788513,848.275146 
	C588.476318,847.932007 588.869507,847.732544 589.555054,847.357849 
	C590.049866,847.070312 590.250916,846.955200 590.765991,846.679932 
	C600.525391,841.932373 610.248657,837.996155 620.024841,834.186035 
	C621.413879,833.644714 622.826477,833.064880 624.678467,833.727661 
	C625.590393,834.551697 626.206238,835.155762 626.964600,836.053406 
	C626.159546,838.960144 623.567871,839.200867 621.505493,839.980286 
	C608.428223,844.922668 595.754333,850.728394 583.149048,857.540039 
	C578.054688,860.240112 573.403564,862.993835 569.039978,866.196838 
	C568.140808,866.856750 566.380005,867.112061 567.268799,869.200073 
	C568.783997,870.624451 570.238342,871.574646 572.132080,872.475464 
	C574.517822,874.759277 576.589233,873.721558 578.784790,872.740173 
	C585.890381,869.563965 592.797485,865.978516 600.128906,862.498108 
	C602.156311,861.775269 603.641968,860.313416 605.687439,860.908752 
	C605.690247,860.853760 605.713928,860.788391 605.692566,860.745361 
	C605.552856,860.463623 605.299255,860.317505 604.723267,860.056030 
	C604.189819,859.189453 604.124023,858.534302 604.351685,857.535095 
	C604.718323,856.840149 605.030457,856.526001 605.702759,856.129822 
	C606.375244,855.789795 606.760925,855.607544 607.418518,855.274170 
	C608.575989,854.604797 609.523804,854.234314 610.777832,853.830566 
	C611.413513,853.561462 611.758789,853.371582 612.317627,852.953552 
	C613.319275,852.023926 614.011353,851.209717 615.158752,850.395264 
	C617.222717,849.571777 619.120117,849.448364 621.262268,848.795776 
	C622.340393,848.542786 623.036987,848.294373 624.066162,847.819580 
	C630.253357,845.437195 636.012573,842.773438 642.771851,844.890625 
	C642.747559,846.560364 642.199280,847.891846 642.985168,849.540527 
	C639.242859,853.680542 633.531311,852.880249 629.265869,855.549805 
	C629.933777,855.156128 630.636536,855.186584 631.638550,855.576538 
	C632.135315,856.731689 632.347290,857.681030 632.844482,858.864990 
	C633.233521,859.521606 633.214905,859.936401 632.922974,860.632690 
	C632.658142,861.087708 632.526062,861.252869 632.160645,861.630005 
	C631.075928,862.430359 630.340698,863.165771 629.211243,863.883850 
	C626.250977,864.042053 627.738770,860.624878 625.367554,860.059692 
	C624.815002,860.084290 624.603455,860.175232 624.119690,860.059204 
	C621.777710,856.217773 619.118958,856.782043 616.041687,858.995239 
	C615.686035,859.572144 615.063843,859.433044 615.066833,859.745728 
	C615.069275,860.007141 615.410645,859.924561 615.777344,859.285156 
	C618.292114,857.462708 620.608521,857.509521 623.187683,859.212219 
	C623.754211,859.775879 624.090088,860.084900 624.684509,860.618652 
	C624.946228,861.059387 624.961914,861.261963 624.971619,861.769287 
	C623.860291,863.286133 623.562195,864.863892 623.016479,866.676025 
	C622.216797,870.231201 619.580139,868.554565 617.336182,868.979614 
	C616.463684,868.485107 616.534607,867.788818 615.995972,867.025513 
	C615.488342,866.485596 615.195618,866.176392 614.743774,865.579651 
	C614.534363,864.864990 614.584656,864.438477 614.967896,863.806091 
	C615.622192,863.351868 616.061279,863.191101 616.527344,863.096924 
	C616.920715,863.017517 617.338806,863.142700 617.717163,862.948792 
	C617.248657,863.002258 616.776367,863.007568 616.005371,863.139832 
	C614.829346,863.551392 614.410339,864.165283 614.651367,865.395691 
	C615.020447,866.005371 615.292847,866.310852 615.804565,866.814941 
	C616.296753,867.354309 616.441711,867.722961 616.271606,868.409546 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M511.528564,895.392944 
	C511.307190,895.024902 511.525635,894.591309 511.744110,894.157715 
	C507.663208,892.421753 509.484161,886.275574 504.695404,884.914673 
	C501.177917,883.915039 499.029327,881.990784 498.742645,877.596497 
	C498.537537,874.452515 498.293304,869.712891 492.703278,869.854858 
	C490.920898,869.900085 490.535522,868.083252 490.029510,866.269531 
	C491.383026,865.966980 492.782043,866.057434 494.591888,866.235413 
	C496.113220,866.875122 497.027496,868.012268 498.749023,867.294922 
	C518.523010,870.716492 538.169678,873.809753 557.059692,880.191406 
	C560.907349,881.491272 564.557434,883.375793 568.184937,885.396912 
	C549.154541,887.782898 530.973633,893.924805 511.528564,895.392944 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M440.245819,836.658447 
	C442.201416,837.029175 443.830292,837.245850 445.739655,837.755188 
	C435.889679,844.192200 425.325287,849.532166 414.451660,855.043091 
	C404.731201,860.122314 395.367432,865.121399 385.933868,869.984985 
	C362.234039,882.203491 337.393829,891.537292 311.465149,899.117249 
	C310.036285,898.865295 309.588013,898.106201 309.454651,896.779053 
	C309.595703,896.240601 309.700562,896.042480 310.084229,895.668091 
	C311.136505,895.259338 312.007874,895.213013 312.649902,894.104370 
	C317.664642,890.453857 323.721008,890.232666 329.175598,887.458374 
	C329.736694,887.230347 329.964203,887.147705 330.539185,886.963501 
	C334.206879,886.310791 337.260925,885.020752 340.557678,883.346924 
	C342.908875,882.465698 345.010376,881.949524 347.293152,880.863647 
	C360.612854,875.511658 373.304169,869.649048 386.213379,863.387085 
	C390.660187,861.389099 394.727509,859.457397 398.580078,856.419373 
	C403.724945,854.846130 407.959412,852.245361 412.510345,849.475464 
	C420.265381,846.545898 426.782410,842.011414 434.108276,838.251709 
	C436.245270,837.508911 437.908508,836.406372 440.245819,836.658447 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M578.113037,883.973267 
	C581.215942,885.277344 583.413879,888.108887 586.184570,890.827393 
	C594.450012,900.659119 599.862610,911.311157 598.949829,924.198975 
	C598.493469,930.642212 597.243164,937.008789 594.904907,943.487305 
	C591.190613,941.801147 592.419067,938.410950 592.825500,935.605591 
	C593.275146,932.502136 593.423218,929.433716 593.441528,925.890991 
	C593.631653,924.021118 593.563965,922.574219 593.776245,920.718628 
	C594.017883,919.462708 594.148193,918.618103 594.697205,917.454712 
	C594.293396,913.387512 592.454407,910.317078 590.118530,907.499146 
	C584.657654,900.911011 579.189331,894.329102 573.593811,887.587952 
	C574.728943,886.065063 578.058716,887.322388 578.113037,883.973267 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M562.240601,932.771606 
	C554.315491,936.353210 546.129211,938.386841 538.784729,942.468872 
	C537.200500,943.349426 535.545593,944.096924 533.263062,943.909424 
	C533.878052,941.278442 536.430725,940.987976 538.487915,940.146301 
	C550.201660,935.354065 561.222168,929.118652 572.711121,923.871826 
	C576.972290,921.925903 581.257874,918.756592 586.804993,922.313232 
	C587.209412,922.885010 587.133911,923.103882 586.823486,923.577271 
	C584.692932,925.103516 582.681458,926.125916 580.128662,926.718018 
	C579.169739,926.752014 578.537170,926.681274 577.600952,926.820129 
	C577.097595,926.969543 576.897400,927.044006 576.396851,927.248657 
	C571.500916,928.915100 567.474121,931.919373 562.240601,932.771606 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M532.665588,944.036316 
	C529.198364,947.995544 524.201233,950.098816 519.268250,951.857361 
	C515.846497,953.077271 512.682495,955.818054 508.310120,954.691833 
	C516.105469,950.990295 524.197144,947.484253 532.665588,944.036316 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M504.313995,926.771667 
	C503.756470,925.946411 503.545227,925.088196 503.053772,924.031494 
	C506.919922,921.394653 511.674347,920.778076 516.296692,919.493896 
	C512.985413,922.846741 508.570953,924.399902 504.313995,926.771667 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M464.963928,932.745667 
	C463.258636,934.055786 461.492737,935.015747 459.394409,936.061035 
	C459.825104,931.648865 461.370789,930.656372 464.963928,932.745667 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M455.142120,834.318604 
	C456.985352,832.745483 459.157806,831.250061 460.873779,835.004639 
	C459.065979,835.086548 457.261810,834.815674 455.142120,834.318604 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M479.206787,926.139282 
	C478.265533,927.112183 476.953552,927.915649 475.315186,928.753784 
	C474.872437,925.939880 475.423126,924.001526 479.206787,926.139282 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M594.580383,917.211609 
	C594.940918,917.800598 594.994141,918.526001 594.982605,919.610474 
	C594.679016,920.373962 594.447571,920.782654 593.941895,921.412842 
	C592.522522,922.140503 591.354187,922.166138 589.594604,921.437866 
	C590.689575,919.678833 593.220398,919.568115 594.580383,917.211609 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M530.325684,931.986694 
	C529.996216,931.750122 530.009766,931.518433 530.065308,930.938904 
	C531.308960,929.552612 532.696533,928.978638 534.659119,928.972656 
	C534.109619,930.802551 532.338928,931.323059 530.325684,931.986694 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M498.661438,867.024292 
	C497.558411,870.365173 496.386322,867.883728 495.072876,866.618042 
	C496.108978,866.533264 497.215240,866.743591 498.661438,867.024292 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M498.207642,846.367737 
	C499.465057,844.685974 500.844971,844.308044 501.851257,847.056702 
	C500.725006,847.152893 499.600891,846.869995 498.207642,846.367737 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M495.189636,919.155396 
	C494.707214,920.707825 493.004974,920.875000 491.307495,921.628174 
	C490.907990,918.831848 492.800415,918.910522 495.189636,919.155396 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M447.783936,932.206787 
	C447.723083,933.217834 447.373047,933.768860 446.610931,933.345032 
	C446.337891,933.193176 446.155273,932.436096 446.286804,932.090454 
	C446.572784,931.339050 447.152222,931.266113 447.783936,932.206787 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M536.692871,927.990234 
	C536.531555,928.320496 536.077515,928.651733 535.326355,929.006165 
	C535.029297,929.029297 535.000671,928.999512 534.987793,928.982544 
	C535.449951,928.640869 535.925049,928.316101 536.692871,927.990234 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M587.004639,922.009766 
	C587.477234,921.681885 587.939026,921.338684 588.712891,921.010559 
	C589.024902,921.025574 588.998230,920.998779 588.985107,920.985596 
	C589.117981,921.132202 589.263916,921.291931 589.319946,921.764038 
	C589.055176,922.204834 588.880249,922.333130 588.385376,922.520874 
	C587.855347,922.527222 587.645142,922.474121 587.202698,922.193481 
	C586.970459,921.965881 586.993958,921.994507 587.004639,922.009766 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M537.006470,928.008423 
	C537.100952,927.971802 537.189270,927.927795 537.131592,927.936523 
	C536.985657,927.989258 537.000244,928.000977 537.006470,928.008423 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M517.421997,938.694336 
	C517.215027,938.245239 517.091248,937.550232 518.101562,938.177368 
	C518.077637,938.498596 517.901123,938.596252 517.421997,938.694336 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M439.470520,933.454956 
	C439.521332,933.425720 439.419739,933.484192 439.470520,933.454956 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M453.290222,834.520935 
	C453.260406,834.301453 453.491150,834.156006 453.981506,834.078064 
	C454.020721,834.307617 453.790588,834.457458 453.290222,834.520935 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M192.201843,649.237244 
	C191.377808,648.530884 190.915237,647.934875 190.227234,647.164124 
	C188.610184,645.403442 188.546753,643.195801 187.164673,641.262695 
	C181.633469,624.858765 179.517120,608.181641 179.064056,591.238098 
	C178.999878,588.838318 180.356873,587.234253 181.766357,585.561890 
	C187.236771,579.071350 193.711853,573.585388 199.828430,567.287720 
	C200.494675,565.559631 201.438156,564.398865 202.548615,562.967651 
	C202.841995,562.526733 202.962906,562.352783 203.278458,561.927490 
	C203.615585,561.519287 203.758072,561.362427 204.135193,560.991211 
	C204.540909,560.651978 204.712006,560.527222 205.160553,560.247864 
	C206.021988,559.828430 206.630463,559.665710 207.573120,559.758240 
	C206.962173,587.879211 215.995651,613.051941 229.901810,636.824890 
	C230.718369,638.220825 231.476715,639.711731 233.639465,640.859070 
	C235.103470,622.147461 233.007553,604.038696 230.203445,585.853333 
	C242.611023,603.809143 251.123184,624.100586 265.688995,640.853149 
	C269.942291,642.667969 272.110382,646.402832 275.514069,649.233154 
	C281.683441,655.632629 287.605316,661.792908 291.790283,669.766296 
	C291.999542,670.042419 292.012970,669.992859 291.987549,669.989136 
	C292.401306,670.408020 292.474243,670.982971 292.800598,671.741821 
	C293.090240,679.500977 292.574677,679.880737 284.415955,677.980103 
	C282.497894,678.827026 281.411255,677.826965 279.997620,676.904907 
	C279.092529,676.104614 278.506989,675.443176 277.410645,674.898926 
	C276.929382,674.628418 276.739624,674.513672 276.278656,674.205200 
	C272.163422,671.712891 268.148438,669.785583 263.558594,668.334595 
	C263.043488,668.169128 262.841827,668.095520 262.348389,667.895508 
	C261.683563,667.588135 261.315155,667.398193 260.683838,667.061890 
	C260.244812,666.825134 260.073090,666.726379 259.655457,666.470703 
	C259.077179,665.998169 258.744629,666.037537 258.090698,666.328247 
	C251.105469,663.731873 245.060852,660.055359 240.323822,656.416809 
	C243.067764,659.614685 247.905228,662.042419 252.091827,665.812012 
	C252.682419,666.845642 253.116089,667.565247 254.399719,667.768738 
	C255.627457,668.027771 256.492188,668.297302 257.190430,669.408630 
	C256.662994,671.779724 254.697891,673.154053 253.202240,672.596375 
	C248.453232,670.825378 245.523071,674.137024 241.637756,675.863403 
	C241.057236,675.882996 240.824387,675.868469 240.247803,675.789307 
	C239.225922,675.556213 238.560059,675.341003 237.532471,675.108093 
	C234.019791,674.002014 231.875351,671.562683 230.001648,669.116821 
	C225.699966,663.501404 220.556030,658.440308 217.786346,651.343872 
	C217.616714,650.779419 217.549576,650.554016 217.377533,649.992554 
	C217.198853,649.433594 217.125061,649.210693 216.940399,648.653259 
	C214.049896,640.366699 209.917679,633.033508 206.060928,625.605713 
	C203.854904,621.356995 202.337708,616.812134 199.771210,612.367737 
	C199.517715,611.840332 199.424606,611.626343 199.217834,611.083618 
	C198.686996,608.515991 198.092697,606.358398 196.108826,604.478271 
	C194.952255,603.156982 194.207169,601.987366 193.697754,600.108704 
	C195.699173,612.745667 199.488815,624.410706 202.588058,636.598999 
	C202.708801,638.079102 202.290665,639.217407 202.725555,640.696411 
	C202.841309,641.280090 202.878937,641.518005 202.932129,642.122009 
	C202.682724,645.427124 201.025986,647.033813 198.139755,647.269836 
	C196.058105,647.440002 194.429276,648.680176 192.201843,649.237244 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M294.816040,605.649536 
	C296.482422,616.598389 297.990814,627.245056 299.509460,637.890259 
	C299.687836,639.140930 300.624603,640.752075 299.122070,641.450928 
	C297.590424,642.163391 296.910248,640.423157 296.158722,639.418335 
	C294.076477,636.634216 292.228851,633.664307 289.311584,631.144775 
	C284.743713,627.802124 281.932434,623.623718 280.211548,618.262085 
	C279.997009,617.984680 279.997498,618.001648 280.005188,618.005005 
	C279.892883,617.824219 279.772888,617.640015 279.834900,617.180908 
	C279.013550,613.516602 278.010254,610.127319 277.007172,606.365356 
	C278.784576,606.092102 279.401459,603.687622 281.816833,604.087280 
	C282.351013,604.163086 282.500488,604.518738 282.753296,604.255249 
	C284.039856,604.436523 284.543396,606.697754 286.146820,605.101135 
	C287.292664,603.960205 287.238281,602.713867 285.514008,602.009277 
	C284.436859,601.569153 283.584503,600.486816 284.452637,599.799194 
	C287.140106,597.670288 284.797882,595.731506 283.929382,592.323303 
	C289.483032,596.251343 291.914490,600.936035 294.816040,605.649536 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M258.872498,544.058350 
	C254.847412,547.746887 249.790024,547.174988 245.003571,547.446472 
	C238.676041,547.805359 232.062088,544.950256 226.062271,549.624084 
	C222.930832,553.004028 218.396469,552.666260 214.519119,554.738159 
	C213.608521,554.580872 213.176056,554.305420 212.694611,553.526367 
	C213.251984,549.723633 216.533936,549.130310 218.851151,547.525024 
	C221.122009,545.951782 223.401413,544.362610 226.267700,542.968506 
	C237.474426,537.819092 248.114914,540.048462 258.872498,544.058350 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M291.950134,682.663574 
	C287.832977,687.675781 285.889404,693.715027 283.055878,699.603088 
	C282.916229,699.968384 282.753723,699.965332 282.592865,699.980042 
	C280.108521,700.208130 276.978241,700.201233 275.828186,698.348938 
	C274.635223,696.427429 277.497253,694.600708 278.782715,692.465332 
	C279.375580,691.690613 279.502686,691.078918 279.824890,690.219727 
	C280.010223,689.968384 280.005402,690.003418 279.988922,690.009766 
	C280.208893,689.800903 280.438385,689.578430 280.822632,689.171753 
	C280.984375,688.994812 280.998779,688.999023 280.994751,688.992310 
	C282.172607,686.993896 283.213593,684.944763 283.776947,682.332214 
	C283.967102,682.041321 283.926178,682.076904 283.904358,682.093079 
	C286.541840,680.973755 289.172150,680.758057 291.950134,682.663574 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M212.518829,552.648315 
	C213.143219,553.113342 213.417068,553.487305 213.987503,554.048950 
	C214.269897,554.746155 214.070663,555.168457 213.367203,555.685547 
	C212.305573,557.115112 211.052567,556.981567 209.510193,557.002563 
	C208.871735,557.185425 208.600189,557.414673 208.152145,557.845398 
	C207.968933,558.039001 207.976913,557.976013 208.008667,557.975952 
	C207.290024,558.960754 206.652115,560.054993 205.219666,560.804749 
	C204.969772,560.989929 205.002625,561.003723 205.000153,560.986084 
	C204.780365,561.206909 204.555908,561.438293 204.147507,561.827759 
	C203.970703,561.992676 204.002365,562.000549 203.994080,561.986450 
	C202.837738,563.604492 201.390717,564.880005 199.261841,565.837402 
	C191.972061,570.924011 186.240036,577.333618 179.213257,582.446960 
	C179.880936,578.482361 183.464355,576.428589 185.773392,573.146362 
	C192.902863,563.787354 200.964188,556.142700 212.518829,552.648315 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M259.215088,544.411865 
	C252.882492,543.377380 246.733154,542.327393 240.596725,541.206726 
	C235.728439,540.317627 231.662949,542.930481 226.913147,544.104614 
	C226.271301,544.170166 225.990112,544.269043 225.282928,544.232422 
	C223.931305,541.255188 226.292160,540.836304 227.955032,539.963806 
	C232.985214,537.324463 238.442917,537.320740 244.358643,537.473145 
	C249.926788,538.400330 255.178467,538.804810 260.184326,541.573853 
	C260.600525,542.529175 260.590912,543.110596 260.095642,544.013489 
	C259.791595,544.337891 259.403931,544.365784 259.215088,544.411865 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M260.054626,544.592041 
	C259.854889,543.848877 259.918213,543.359924 259.998901,542.502258 
	C260.238892,541.875305 260.487030,541.577393 260.788025,541.551086 
	C268.562378,540.870300 284.274261,549.971130 287.551910,557.415894 
	C287.474945,558.346375 287.206329,558.775269 286.372040,559.056885 
	C284.828674,557.831116 283.675171,556.642578 282.222046,555.376343 
	C275.075104,551.082153 268.800537,545.681946 260.054626,544.592041 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M275.213440,650.221924 
	C272.016907,647.214539 269.155243,644.403931 266.141174,641.298584 
	C268.577118,640.002808 270.874756,641.291443 273.614655,641.969482 
	C274.363342,641.624084 274.829163,641.476013 275.681183,641.797485 
	C275.991028,642.026978 276.005157,641.998901 275.989563,641.999207 
	C276.417603,642.422241 276.472321,643.008728 276.799530,643.781738 
	C276.971436,644.010681 276.997559,644.001404 276.988007,644.011475 
	C277.874176,645.023254 277.967987,646.397766 278.800598,647.777588 
	C278.996368,648.035217 279.008423,647.994019 278.987000,647.992859 
	C279.090942,648.154724 279.216309,648.317688 279.172028,648.738342 
	C279.005676,649.434753 279.008942,649.873596 279.016235,650.641418 
	C277.643066,652.170166 276.651093,650.945801 275.213440,650.221924 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M275.038025,650.323242 
	C276.021332,650.322449 277.164093,650.619690 278.663544,650.943726 
	C283.916199,656.665771 290.003113,661.518982 291.984863,669.663818 
	C286.314301,663.641907 281.439484,656.540222 275.038025,650.323242 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M213.421112,555.850952 
	C213.355240,555.459595 213.662552,555.051697 214.126968,554.440186 
	C217.970200,552.927185 221.656326,551.617798 225.674744,550.136658 
	C230.658447,549.924561 235.256897,548.717468 240.371964,549.408447 
	C241.217529,549.659180 241.422012,549.963379 241.143951,550.607300 
	C231.477875,550.394531 222.508041,552.425354 213.421112,555.850952 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M279.964233,618.352051 
	C282.918884,622.100464 285.840790,626.216309 288.901733,630.640564 
	C286.208282,633.227844 285.641754,629.053406 283.270599,629.002563 
	C280.835022,625.867920 278.462372,622.855652 279.964233,618.352051 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M241.346283,550.871582 
	C240.929642,550.501831 240.922546,550.206482 240.842316,549.698120 
	C246.804459,549.314819 252.661591,550.153320 258.466339,551.365112 
	C258.424774,551.766663 258.383179,552.168274 258.341614,552.569824 
	C252.825272,552.028259 247.308914,551.486755 241.346283,550.871582 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M273.997803,639.609131 
	C269.987061,636.038086 267.745819,631.044678 266.000580,625.371948 
	C269.576294,629.189026 272.182404,633.957458 273.997803,639.609131 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M279.707214,675.616516 
	C281.051300,676.480713 282.230194,677.093811 283.709900,677.847778 
	C283.991425,678.468872 283.972168,678.949097 283.960571,679.789856 
	C283.205627,680.172607 282.442963,680.194885 281.336365,680.386414 
	C280.408844,680.383728 280.021393,679.917603 279.256348,679.532532 
	C278.540344,679.411011 278.110321,679.345825 277.350525,679.296997 
	C275.875336,679.134949 275.036835,678.411011 273.962585,677.457153 
	C273.666290,676.982666 273.589386,676.766968 273.524261,676.204834 
	C273.710052,675.165100 274.045013,674.556946 274.795410,673.807983 
	C275.540649,673.461487 276.002380,673.448547 276.721680,673.822144 
	C276.977234,674.065674 277.000488,674.006714 276.970642,674.017334 
	C277.695160,674.693054 278.946777,674.390991 279.707214,675.616516 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M274.652771,600.008301 
	C275.003235,601.068909 275.002380,602.132874 274.997986,603.601074 
	C273.218170,603.825989 272.445740,602.636597 272.436523,601.058716 
	C272.430328,600.001892 273.530487,600.117554 274.652771,600.008301 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M279.014160,647.682861 
	C277.603455,647.366272 276.968140,646.211243 276.922058,644.367920 
	C278.509033,644.599487 279.003174,645.820618 279.014160,647.682861 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M205.287292,561.092529 
	C205.268555,559.595398 206.493027,559.013977 207.737473,558.079956 
	C208.043579,558.395874 208.046738,558.815857 207.960617,559.549561 
	C207.115829,560.307251 206.360321,560.751221 205.287292,561.092529 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M274.997253,599.997864 
	C274.860138,599.145081 273.548340,598.036743 274.963593,597.537292 
	C275.879333,597.214111 275.901520,598.566040 275.994751,599.677185 
	C275.997986,600.002441 275.500977,600.001526 275.252502,600.003174 
	C275.004059,600.004883 275.000000,600.000000 274.997253,599.997864 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M276.995972,606.003662 
	C276.093689,605.918701 275.310944,605.669067 275.040863,604.322876 
	C274.994446,604.005310 275.000000,604.000000 275.003052,603.997437 
	C275.905060,604.080811 276.687714,604.329407 276.960144,605.675293 
	C277.007385,605.992676 277.000000,606.000000 276.995972,606.003662 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M275.960388,641.708008 
	C275.543030,642.054382 275.095001,642.081787 274.310455,642.060852 
	C273.966675,641.587524 273.959442,641.162659 273.920227,640.422180 
	C273.888275,640.106628 274.016846,639.980713 274.081360,639.913940 
	C275.029510,640.026733 275.743378,640.402710 275.960388,641.708008 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M276.990479,643.703979 
	C276.197266,643.884216 275.935455,643.340698 275.917023,642.322510 
	C276.319153,642.465454 276.664337,642.931335 276.990479,643.703979 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M276.001831,599.998779 
	C276.423492,600.119080 276.843323,600.240662 277.263153,600.362183 
	C276.948730,601.056458 276.594421,600.661804 276.121460,600.200928 
	C275.997986,600.002441 276.000000,600.000000 276.001831,599.998779 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M264.993103,623.303711 
	C265.335510,623.445129 265.666260,623.896362 266.036133,624.637512 
	C266.075226,624.927368 265.997009,624.998901 265.954590,625.033447 
	C265.601959,624.583130 265.291687,624.098328 264.993103,623.303711 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M292.949768,671.660095 
	C292.693420,671.482422 292.391754,671.014587 292.026123,670.266052 
	C292.276245,670.446899 292.590363,670.908386 292.949768,671.660095 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M281.997620,603.996460 
	C282.269165,603.883789 282.544769,603.776245 282.913269,603.830200 
	C283.006134,603.991699 282.998291,604.001770 282.994263,604.005737 
	C282.826813,604.175049 282.663422,604.340271 282.254883,604.257568 
	C282.009766,604.009766 282.001648,604.001526 281.997620,603.996460 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M208.265427,558.010925 
	C208.203552,557.770630 208.438187,557.502197 208.910980,557.098511 
	C208.953384,557.303040 208.757645,557.642944 208.265427,558.010925 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M279.176758,648.902344 
	C278.987549,648.828979 278.972717,648.661987 278.961731,648.243347 
	C279.347992,648.144226 279.740875,648.291870 279.176758,648.902344 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M263.436493,620.551270 
	C263.398407,620.486755 263.474579,620.615845 263.436493,620.551270 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M264.996338,623.002686 
	C264.861450,622.850952 264.730225,622.696594 264.598999,622.542236 
	C264.696259,622.591980 264.793518,622.641724 264.947784,622.842651 
	C265.004761,622.993835 265.000000,623.000000 264.996338,623.002686 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M279.834747,617.016296 
	C280.021545,617.089722 280.026215,617.273438 280.021851,617.732788 
	C279.816193,617.831787 279.605957,617.666626 279.437195,617.466492 
	C279.411194,617.435730 279.576019,617.243958 279.834747,617.016296 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M262.518097,618.548340 
	C262.472839,618.574951 262.563354,618.521667 262.518097,618.548340 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M541.527100,667.483398 
	C539.411194,668.305359 537.016296,667.215454 535.380981,669.747681 
	C533.227539,672.168640 533.233032,675.252869 531.258057,677.765381 
	C531.026978,678.029785 531.000000,678.003357 531.014404,678.012939 
	C530.221802,678.846191 530.023865,680.034302 529.139832,681.205811 
	C528.978027,681.502869 529.082336,681.731262 529.141724,681.842651 
	C528.722168,683.486816 528.021973,684.539001 526.082886,683.016418 
	C524.664673,680.725098 526.068665,678.982544 526.457886,677.141785 
	C526.844177,675.315308 528.364746,673.255554 526.273560,671.769653 
	C524.453552,670.476501 523.735352,673.397400 521.749695,673.381653 
	C519.077148,671.615845 520.163635,669.284607 520.116882,667.083801 
	C520.079651,665.335388 519.717346,663.548706 519.192505,661.440186 
	C518.669739,656.418945 521.409302,652.681458 522.817627,648.166931 
	C524.693542,642.899292 527.103271,638.213501 528.028809,632.643738 
	C529.025818,630.375000 529.799561,628.423035 529.819946,625.904297 
	C529.899353,625.324585 529.943054,625.094788 530.084961,624.529053 
	C530.589844,623.113525 531.182007,622.121643 531.804565,620.764038 
	C532.376160,619.633301 532.856689,618.853699 533.888428,618.116760 
	C535.188049,617.992432 536.166748,617.993958 537.512451,617.992188 
	C539.540649,619.628235 538.032166,621.349304 537.989441,623.408081 
	C537.950195,624.032471 537.931274,624.280884 537.832886,624.892212 
	C533.510437,634.676331 529.905945,644.347229 526.552063,654.111938 
	C524.071106,661.335144 524.118164,661.351318 531.787659,663.756470 
	C535.140442,664.792786 536.761475,663.554382 537.703552,660.670654 
	C540.625671,651.725586 543.045776,642.615295 546.461060,633.833008 
	C547.617859,630.858582 546.473389,629.160461 543.666077,628.088257 
	C541.677979,627.328918 539.602600,626.587219 538.351929,624.178467 
	C538.190430,621.602722 539.430664,620.519226 541.832520,620.107605 
	C545.645691,620.466370 548.789490,622.207214 552.417236,622.056763 
	C550.409180,620.973816 548.332092,620.051025 545.837280,619.175659 
	C544.366028,618.604614 543.257385,618.107849 542.198242,616.887329 
	C545.311768,612.449829 548.428406,613.260376 551.795532,616.992126 
	C554.519348,616.015503 554.248840,614.216919 553.281433,612.145142 
	C551.845642,609.461853 550.697021,606.929871 549.785767,604.196411 
	C552.067017,602.974060 554.165588,605.693909 556.528015,603.943176 
	C558.387268,605.785278 558.354736,608.336487 557.781555,609.965332 
	C556.417847,613.840576 557.703857,617.036194 559.038696,620.796509 
	C559.384338,621.574829 559.561951,622.006409 559.506470,622.853271 
	C558.051025,625.638611 555.535095,627.303101 554.569702,630.457520 
	C550.844055,640.068848 548.051208,649.606689 544.988770,659.447998 
	C543.548401,662.146118 542.743164,664.709473 541.527100,667.483398 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M585.593140,523.143188 
	C594.666931,523.157654 603.337341,523.229248 612.393921,523.312866 
	C613.232788,523.568604 613.458923,523.940674 613.201538,524.744080 
	C612.630859,525.128479 612.282532,525.229431 611.665649,525.375671 
	C609.994751,525.927490 608.495361,526.070312 606.742188,526.687988 
	C602.788635,527.499573 599.637146,529.461792 595.786255,530.499023 
	C593.457703,530.096313 591.359863,529.869629 589.892090,531.433289 
	C586.744019,534.786987 583.413757,536.247009 578.899292,533.515015 
	C577.662598,534.024292 576.653137,534.314514 575.936646,535.559082 
	C575.633179,535.986816 575.504089,536.154297 575.159058,536.556152 
	C573.969543,537.672363 573.308350,538.743469 572.881409,540.339844 
	C570.327942,547.012695 564.414307,550.976562 561.323608,557.296997 
	C559.757141,559.612000 558.963989,561.848083 558.800415,564.628540 
	C558.787842,565.609741 558.659790,566.241028 558.246765,567.122070 
	C557.477417,568.253845 557.121643,569.221252 556.755005,570.537292 
	C556.539673,571.036560 556.434937,571.230530 556.134644,571.695374 
	C553.260437,576.328674 552.179932,581.239014 550.907532,586.452393 
	C550.576843,586.938843 550.417908,587.115234 549.948364,587.467529 
	C549.406311,587.699219 549.174866,587.755005 548.586914,587.801880 
	C548.005493,587.716675 547.780640,587.640381 547.252441,587.377441 
	C539.898926,585.380127 545.102295,581.118652 545.086853,577.525269 
	C545.146790,573.022339 546.869873,569.572144 549.739197,566.242371 
	C556.143677,554.703003 561.902893,543.187378 569.447327,532.710510 
	C573.346191,527.296204 577.828247,522.871399 585.593140,523.143188 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M518.827515,489.159210 
	C522.254944,487.795807 520.444519,484.958435 521.097046,482.384308 
	C521.575562,481.972504 521.973999,481.975800 522.670288,481.963928 
	C522.939758,490.986969 522.911194,500.025116 522.929688,509.532288 
	C520.123535,509.960022 517.170166,510.361908 514.576172,508.806946 
	C511.058746,506.698456 508.151276,509.691681 504.600098,509.513489 
	C504.164215,510.115112 503.621185,510.335510 502.555664,509.940063 
	C500.883789,508.172821 501.050842,506.184845 500.707581,503.967468 
	C502.069305,501.102234 502.821198,498.006409 506.633850,497.482147 
	C505.769318,500.099518 510.704132,501.366394 508.280914,504.109406 
	C509.001251,504.540405 509.915497,504.736877 510.561035,504.409302 
	C512.554626,503.397736 514.639709,503.466492 517.082031,503.559906 
	C517.809753,503.740662 518.007568,504.253265 518.514954,504.189514 
	C518.418579,503.529846 518.632629,504.417267 517.816650,503.906677 
	C514.708801,502.784790 511.898956,504.201355 508.895172,504.242432 
	C510.772125,500.546692 510.772125,500.546692 517.951050,500.508209 
	C516.182007,500.527130 514.403687,500.336426 512.647827,500.673462 
	C509.874939,501.205719 507.894562,500.467163 507.004761,497.238281 
	C506.402985,496.339722 506.490417,495.679718 507.253784,494.875122 
	C510.584869,494.691772 513.140015,492.585510 517.236389,492.894836 
	C513.845825,492.445251 511.672729,494.381561 509.006012,493.050232 
	C508.794891,488.653778 512.015137,491.258789 513.974609,490.336426 
	C514.523804,490.065186 514.731934,489.934937 515.292603,489.702271 
	C516.561646,489.285400 517.443909,488.786682 518.827515,489.159210 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M549.763428,565.858032 
	C548.556946,569.563599 547.081482,573.112976 545.344421,576.906311 
	C543.098755,575.230530 542.385620,576.221680 542.004578,578.407410 
	C541.592896,580.769043 541.019775,583.102539 540.426331,585.871643 
	C537.371643,584.038818 538.599731,578.902100 534.252563,578.979614 
	C534.920410,575.477539 537.169861,574.239868 540.749573,574.372192 
	C541.416809,573.126160 542.803101,573.940552 543.281128,572.977173 
	C542.538208,573.855469 541.556946,573.370850 540.372498,573.228638 
	C536.851685,571.510742 536.439880,568.081055 537.164551,565.754333 
	C538.004333,563.057800 538.833191,559.344055 543.056946,558.922546 
	C546.022827,558.626648 550.474792,555.131104 549.017334,562.665527 
	C548.989990,562.991760 548.676636,563.359070 548.607544,563.587952 
	C548.538452,563.816833 548.439514,564.277588 548.612732,564.484192 
	C549.022156,565.027771 549.258301,565.364746 549.763428,565.858032 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M548.529663,588.073853 
	C548.980530,587.626770 549.194397,587.522034 549.738464,587.281189 
	C552.806885,586.117065 556.392639,586.157349 556.729309,581.616760 
	C558.327332,577.962158 558.265869,574.000000 561.363037,571.030273 
	C563.450623,570.594116 563.729370,571.654968 563.559692,573.406860 
	C563.499390,573.979797 563.489502,574.207092 563.450806,574.768433 
	C563.272095,576.166077 562.737427,577.114563 562.475952,578.458191 
	C562.426331,578.963989 562.410339,579.166382 562.381287,579.673157 
	C561.893982,581.347046 561.419739,582.716614 560.911621,584.448120 
	C560.194702,587.541504 559.123901,590.105286 557.362305,592.741211 
	C557.061523,596.370300 556.970459,599.719360 556.868530,603.525085 
	C555.050659,609.513855 552.723877,604.447144 550.330322,604.140747 
	C549.937561,602.606018 549.851990,601.217224 549.671021,599.422729 
	C548.724060,595.534668 547.523682,592.094604 548.529663,588.073853 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M532.182678,598.624207 
	C531.943726,598.781433 531.498779,598.913086 531.276489,598.846802 
	C528.904785,597.866638 526.699097,597.447815 524.076538,598.206787 
	C523.057861,598.504456 522.341858,598.494995 521.341797,598.189087 
	C520.277893,597.923096 519.497375,597.882935 518.326660,597.876953 
	C517.144531,598.794739 516.086060,598.384033 514.762573,598.493408 
	C513.899597,598.568909 513.433655,598.718140 512.641174,599.053101 
	C512.044373,599.185730 511.803528,599.222107 511.201416,599.285767 
	C509.430725,599.352539 508.019745,599.220947 506.268951,599.391418 
	C505.470825,599.476074 505.020355,599.552307 504.239502,599.736328 
	C503.221466,599.937195 502.534851,599.955078 501.506348,599.850037 
	C500.501831,599.678162 499.854004,599.458984 498.828613,599.429077 
	C496.146423,599.632080 493.791412,600.091858 491.217468,598.845947 
	C490.747467,598.489990 490.585907,598.315186 490.498047,597.791016 
	C489.853180,594.516602 491.923615,595.129089 493.499603,595.146484 
	C502.683838,595.247925 511.867798,595.397644 521.052246,595.448853 
	C526.433594,595.478821 531.815674,595.356201 537.596008,595.313477 
	C538.838501,597.678650 537.071533,597.376465 535.353516,597.661865 
	C534.955139,597.794495 534.512756,597.968140 534.281677,598.023621 
	C533.466370,598.035278 532.916077,598.133728 532.182678,598.624207 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M535.447205,496.654968 
	C535.108276,501.674530 535.018127,506.321472 534.894775,511.424377 
	C534.468994,511.914276 534.076477,511.948242 533.390747,511.939697 
	C533.114258,495.407410 531.973816,478.893066 533.863525,462.430389 
	C535.791321,467.256531 534.742432,472.230072 535.107788,477.551758 
	C536.604980,479.752747 536.463196,481.888000 536.537842,484.415405 
	C536.372131,486.620941 536.397339,488.385223 536.474487,490.592590 
	C536.566406,492.835297 536.560425,494.625336 535.447205,496.654968 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M528.885803,602.354248 
	C532.264343,602.155945 535.387634,602.129700 538.510254,602.069458 
	C542.771545,601.987183 539.336487,603.669067 538.842163,604.812073 
	C538.167358,605.200439 537.635315,605.241211 537.319702,605.464478 
	C537.038635,605.663330 537.635254,605.548950 537.905396,605.925659 
	C538.088013,606.113708 538.169495,606.560974 538.158081,606.788025 
	C538.158875,607.627625 537.913269,608.134216 537.350586,608.818604 
	C537.194946,609.062622 536.892273,609.136780 536.742554,609.093506 
	C535.065918,610.068298 534.004761,612.194641 531.286255,611.229614 
	C528.501831,611.360291 527.063293,608.570740 524.164551,609.075562 
	C521.828308,608.831055 518.712341,611.227295 518.313721,606.622070 
	C518.485718,606.088501 518.585938,605.885742 518.896729,605.416870 
	C519.895935,604.337830 520.773926,603.644592 522.092285,602.999939 
	C523.213684,602.565918 523.977600,602.174805 524.847534,601.337646 
	C525.680603,601.227966 526.256104,601.312622 527.028442,601.619507 
	C527.494263,602.483093 527.957214,602.717590 528.885803,602.354248 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M530.776184,611.007080 
	C531.728638,608.228577 531.997131,608.032471 533.137817,609.593872 
	C534.878967,611.977356 534.692932,607.516052 536.276855,609.007080 
	C535.786072,611.778259 534.979309,614.506226 534.190918,617.612549 
	C533.853760,618.808655 533.498291,619.626404 533.017090,620.754639 
	C532.130676,621.562744 531.324036,621.971680 530.148071,622.350220 
	C528.800232,622.197266 528.398193,621.468506 528.179016,620.253296 
	C528.166077,619.379272 528.245117,618.808105 528.020264,617.993835 
	C527.834412,617.589600 527.752258,617.432007 527.570068,617.030640 
	C527.440430,616.615784 527.410767,616.444763 527.399048,616.020874 
	C527.599731,615.151245 527.337280,615.457275 526.843567,615.677551 
	C523.966003,615.301941 524.256409,613.519348 524.747131,611.370361 
	C524.956482,610.847900 525.057800,610.648071 525.365662,610.187317 
	C526.897644,609.032654 527.953674,609.630859 529.140991,610.737061 
	C529.467712,611.036560 529.607483,611.136047 529.968872,611.332520 
	C530.190491,611.429504 530.582397,611.149902 530.776184,611.007080 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M481.743103,574.489929 
	C481.132263,574.702515 480.196411,575.634033 480.111511,574.105103 
	C479.671906,567.420288 476.634521,561.004333 479.626617,553.787170 
	C482.298401,560.677673 482.840790,567.300537 481.743103,574.489929 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M541.699951,616.622437 
	C543.134460,616.943970 544.269897,617.310486 545.703796,617.873840 
	C546.273499,619.895569 544.689819,620.058777 543.326965,620.785767 
	C540.909180,620.367737 539.542358,621.077393 538.917847,623.607788 
	C538.377319,624.375183 537.896790,624.574524 536.946045,624.409180 
	C536.993408,622.438171 537.419861,620.613098 537.862915,618.388489 
	C538.640503,616.448730 539.772339,615.896423 541.699951,616.622437 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M502.417358,509.485992 
	C503.242371,509.560028 503.709930,509.429749 504.233002,509.267670 
	C505.927765,513.360229 502.215271,513.552856 500.346832,513.414734 
	C498.659485,513.289917 499.243774,514.563904 498.219788,514.688721 
	C497.240112,513.554626 496.581757,512.491394 495.853729,511.101196 
	C495.784088,510.774261 495.851959,510.824463 495.853210,510.866669 
	C497.829712,510.010986 499.684113,508.652252 502.417358,509.485992 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M548.607605,587.621094 
	C548.714294,591.257690 550.349731,594.614014 549.697327,598.602661 
	C546.037659,596.253906 547.254639,592.316345 547.057007,588.284668 
	C547.220825,587.709656 547.363037,587.583435 547.789612,587.435181 
	C548.073975,587.413147 548.448547,587.510803 548.607605,587.621094 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M537.562561,609.056396 
	C537.339600,608.488953 537.484253,607.915283 537.887817,607.178345 
	C539.638367,607.121399 541.199219,606.666016 542.828979,607.854431 
	C544.044983,609.070923 543.425781,610.281189 543.801086,611.634277 
	C543.208313,613.240234 541.915710,612.947632 540.369324,612.998413 
	C539.790710,611.432434 540.721680,609.264893 537.562561,609.056396 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M552.891357,612.346191 
	C556.628357,610.994385 555.614807,613.388916 555.034058,615.028442 
	C554.641418,616.136963 556.229187,619.732178 552.317017,617.302429 
	C552.369812,615.587769 552.579102,614.143188 552.891357,612.346191 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M535.400146,597.863159 
	C535.685547,596.850159 537.307800,597.317688 537.897522,595.660889 
	C539.873291,595.679077 543.211121,593.551575 543.336243,596.514648 
	C543.457581,599.390686 540.104919,597.543030 538.308105,597.856628 
	C537.507202,597.996521 536.667358,597.913635 535.400146,597.863159 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M530.002563,570.209473 
	C535.176880,571.289612 529.977661,573.494080 530.648376,575.526001 
	C531.238098,577.312439 528.826294,576.794739 527.159302,576.007874 
	C526.605103,575.505737 526.506104,575.130676 526.625977,574.455566 
	C527.862976,573.508484 529.280090,573.229797 529.922485,571.512146 
	C529.885498,570.941345 529.780518,570.693665 530.002563,570.209473 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M487.720673,604.901550 
	C487.129181,604.097534 487.014221,603.337097 486.949524,602.288696 
	C487.104492,600.600037 487.872620,599.953918 489.610168,600.013916 
	C490.658569,600.339111 491.110565,600.904419 491.600281,601.905640 
	C491.893555,602.990234 491.841919,603.707214 491.280701,604.687256 
	C490.109772,604.970337 489.153473,604.957764 487.720673,604.901550 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M512.119812,598.178772 
	C512.678162,597.806885 512.907654,597.755371 513.329529,597.887207 
	C513.768250,598.085205 514.039978,598.212463 513.864563,598.288696 
	C512.235046,600.937683 514.489136,600.613403 516.365295,601.087769 
	C517.312317,601.493530 517.504761,601.967590 517.242920,602.921936 
	C516.385376,603.826660 515.601074,604.057617 514.339478,604.108215 
	C512.757263,603.898376 511.826172,603.365906 511.153778,601.875122 
	C510.931824,600.929077 510.930298,600.378357 511.146790,599.435791 
	C511.437683,598.824951 511.601624,598.605713 512.119812,598.178772 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M516.549561,603.022644 
	C516.680664,602.350830 516.756653,602.006287 516.838379,601.397095 
	C517.943604,601.089966 519.043091,601.047485 520.553467,601.046631 
	C521.114685,601.212341 521.265076,601.336365 521.653320,601.632568 
	C522.246948,601.981506 522.581299,602.192383 523.088013,602.667969 
	C523.324158,603.096802 523.367798,603.293335 523.213074,603.717529 
	C521.829590,603.891541 521.231689,604.696350 520.443604,605.752075 
	C519.171021,604.809448 517.330383,604.798462 516.549561,603.022644 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M522.748962,579.499329 
	C525.122681,580.330627 526.955322,581.521667 524.627075,584.235229 
	C522.877625,583.194336 523.258667,581.208374 522.748962,579.499329 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M524.065552,598.012695 
	C526.277527,597.120361 528.661560,596.192444 530.959717,598.427185 
	C529.278503,598.661316 527.398376,599.638428 525.359863,598.188843 
	C524.722412,598.201416 524.466553,598.299316 524.065552,598.012695 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M544.062744,611.593628 
	C540.128113,612.019104 543.329773,609.861511 543.022705,608.492676 
	C546.537109,608.094482 544.082825,610.122192 544.062744,611.593628 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M535.832642,588.500244 
	C536.381775,587.053284 537.147949,586.868164 538.187500,587.390198 
	C537.584778,588.404785 537.146118,589.611023 536.297180,590.338074 
	C535.965027,590.622498 534.944519,589.731812 535.832642,588.500244 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M523.360962,603.960571 
	C522.987549,603.765808 522.960449,603.586487 522.897034,603.137451 
	C522.439453,602.472107 521.836365,602.498291 521.175415,602.019958 
	C520.987305,601.817627 520.983032,601.452087 520.973633,601.270203 
	C522.069397,601.071533 523.174500,601.054749 524.692383,601.090576 
	C524.845947,602.189514 525.263184,603.569580 523.360962,603.960571 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M491.396484,602.153625 
	C490.743988,601.539001 490.416229,601.071289 490.024048,600.309204 
	C490.035645,599.425659 490.111694,598.836670 490.379700,597.844666 
	C490.571716,597.441711 490.925171,597.733459 490.982422,597.955322 
	C491.979034,598.978699 492.728973,599.874878 492.436066,601.560547 
	C492.111237,602.029053 491.916229,602.164795 491.396484,602.153625 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M509.994995,554.167664 
	C510.755096,554.874695 510.816559,555.500916 509.959442,555.606018 
	C509.124969,555.708435 508.318268,555.117615 508.393433,554.265503 
	C508.483887,553.239990 509.237823,553.874451 509.994995,554.167664 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M519.066895,530.875732 
	C519.444824,533.031616 519.444824,533.031616 516.081055,531.155823 
	C517.110779,531.027710 517.885803,530.931335 519.066895,530.875732 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M526.448975,574.105347 
	C526.794250,574.553406 526.843506,574.923462 526.856079,575.571167 
	C526.231018,575.551392 525.660950,575.207520 525.050049,574.967468 
	C524.065735,574.580566 523.720886,573.441528 524.175232,573.018799 
	C525.263123,572.006531 525.152344,574.273010 526.448975,574.105347 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M532.847656,566.617920 
	C532.787109,565.687073 533.194397,565.217712 533.982361,565.355957 
	C534.201111,565.394348 534.537048,565.803772 534.513123,566.006836 
	C534.409546,566.885254 533.739502,566.902161 532.847656,566.617920 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M538.243225,605.851074 
	C536.767578,606.008118 535.297302,606.439087 534.201111,605.098633 
	C535.465271,603.963623 536.658997,605.327026 538.196899,604.993774 
	C538.520996,605.200500 538.459717,605.394470 538.243225,605.851074 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M528.819092,602.149109 
	C528.945801,603.170654 528.604004,604.069824 527.443054,604.074890 
	C527.317261,604.075439 527.186829,603.016418 527.141968,602.145264 
	C527.649109,601.928040 528.072998,602.014404 528.819092,602.149109 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M491.646240,590.496948 
	C491.063995,591.197266 490.479675,591.671509 490.154083,590.822449 
	C489.993622,590.403809 490.274933,589.451477 490.620117,589.283875 
	C491.224915,588.990173 491.727661,589.475647 491.646240,590.496948 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M495.631744,551.006226 
	C495.283508,551.837769 494.400330,552.528015 493.520355,553.215759 
	C492.468933,551.408691 493.882233,551.202026 495.631744,551.006226 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M532.256470,598.844849 
	C532.132568,597.769043 532.417114,596.904114 533.889893,597.851196 
	C533.822083,598.829346 533.245483,598.957886 532.256470,598.844849 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M540.153320,573.263306 
	C541.031250,573.078674 542.106750,572.556396 542.855225,573.607422 
	C542.424316,573.762390 541.993347,573.917358 541.265137,574.111206 
	C540.673889,573.987488 540.428650,573.769836 540.153320,573.263306 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M513.795349,598.432373 
	C513.417419,598.237610 513.395264,598.080811 513.445923,598.019409 
	C514.688599,597.857239 515.880676,597.756470 517.504578,597.783447 
	C516.894653,599.267334 515.522583,598.887329 513.795349,598.432373 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M523.557251,597.661682 
	C524.096680,597.707947 524.272949,597.787659 524.713745,597.985474 
	C523.902039,599.188110 522.703247,599.075867 521.255859,598.213867 
	C521.770325,597.873901 522.482239,597.784485 523.557251,597.661682 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M561.192139,530.190552 
	C560.395020,531.322571 559.079773,531.557739 558.516052,530.399170 
	C557.995117,529.328735 559.311768,529.436157 560.409180,529.550598 
	C560.755737,529.689270 561.044189,530.025696 561.192139,530.190552 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M536.320801,561.055359 
	C536.291382,560.525574 536.415161,560.150146 536.539001,559.774780 
	C536.641418,559.877808 536.846313,560.003906 536.829102,560.079956 
	C536.742554,560.463745 536.598083,560.834473 536.320801,561.055359 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M548.126587,564.848877 
	C548.034241,564.281677 548.235291,563.736023 548.713257,563.091064 
	C548.970703,563.372314 548.951355,563.752808 548.859009,564.412109 
	C548.785950,564.690796 548.420105,564.870422 548.126587,564.848877 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M500.191528,556.866150 
	C500.112518,556.565063 500.236603,556.139832 500.360687,555.714661 
	C501.054230,556.034607 500.661255,556.390442 500.191528,556.866150 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M521.338440,573.675781 
	C520.934509,573.716980 520.686523,573.589478 520.438599,573.461975 
	C520.547302,573.353943 520.686768,573.136902 520.759094,573.157349 
	C521.016602,573.230286 521.251160,573.384033 521.338440,573.675781 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M530.026245,567.788025 
	C529.902954,567.611145 529.959167,567.438660 530.015381,567.266174 
	C530.078857,567.441589 530.142273,567.616943 530.026245,567.788025 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M521.880127,570.795044 
	C521.554504,570.895569 521.124512,570.772278 520.694580,570.648926 
	C521.008179,569.972168 521.392578,570.279114 521.880127,570.795044 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M535.645081,552.731445 
	C535.630127,552.987549 535.490540,553.128113 535.351013,553.268616 
	C535.407471,553.051025 535.463989,552.833374 535.645081,552.731445 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M547.814209,587.248962 
	C547.951782,587.678772 547.745056,587.800049 547.266113,587.806396 
	C547.078613,587.835876 547.002014,587.515625 546.975586,587.353271 
	C547.150879,587.155518 547.352661,587.120117 547.814209,587.248962 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M520.429504,580.396912 
	C520.545410,580.317993 520.607788,580.613525 520.607788,580.613525 
	C520.607788,580.613525 520.313599,580.475830 520.429504,580.396912 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M539.999756,612.998779 
	C539.910400,613.033691 539.821350,613.069763 539.867310,613.053223 
	C540.002441,613.000488 540.000000,613.000000 539.999756,612.998779 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M495.852173,550.840942 
	C495.961975,550.573181 496.174866,550.409424 496.387756,550.245728 
	C496.425781,550.464722 496.463806,550.683716 496.334290,551.025146 
	C496.166718,551.147522 495.955231,550.944885 495.852173,550.840942 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M540.451416,551.429688 
	C540.526672,551.379395 540.551575,551.580444 540.551575,551.580444 
	C540.551575,551.580444 540.376099,551.479919 540.451416,551.429688 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M537.446655,552.429932 
	C537.523193,552.378723 537.549622,552.582825 537.549622,552.582825 
	C537.549622,552.582825 537.370178,552.481201 537.446655,552.429932 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M522.005737,570.995850 
	C522.130554,571.147644 522.247803,571.305603 522.365051,571.463623 
	C522.266418,571.415955 522.167786,571.368286 522.026794,571.169800 
	C521.984436,571.018921 521.998169,571.002075 522.005737,570.995850 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M530.044922,569.983643 
	C530.259827,570.171387 530.190186,570.369873 530.055542,570.878662 
	C529.416443,570.886658 529.121094,570.530579 530.044922,569.983643 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M500.004242,557.005371 
	C499.866852,556.924377 499.975647,557.896301 499.826080,557.041321 
	C499.988403,556.990234 499.999756,557.000000 500.004242,557.005371 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M494.405151,558.556396 
	C494.336792,558.462341 494.594910,558.421753 494.594910,558.421753 
	C494.594910,558.421753 494.473511,558.650452 494.405151,558.556396 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M544.535645,556.560303 
	C544.466370,556.604309 544.604980,556.516296 544.535645,556.560303 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M502.425629,556.417297 
	C502.524323,556.347839 502.569946,556.610779 502.569946,556.610779 
	C502.569946,556.610779 502.326935,556.486755 502.425629,556.417297 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M495.448120,556.427551 
	C495.518066,556.381409 495.540833,556.567017 495.540833,556.567017 
	C495.540833,556.567017 495.378174,556.473694 495.448120,556.427551 
z"/>
<path fill="#4B225C" opacity="1.000000" stroke="none" 
	d="
M601.387085,519.324646 
	C598.625183,519.625916 596.188354,519.666687 593.311951,519.575562 
	C590.681030,518.899231 588.449951,518.485596 586.116150,517.287231 
	C585.832336,517.098328 585.398865,517.082581 585.192383,517.016113 
	C582.942871,515.535095 581.932007,513.693237 581.978271,511.100922 
	C582.078491,505.487427 582.043457,499.869751 581.992920,494.254669 
	C581.970093,491.716614 582.587280,489.682159 585.590637,488.512634 
	C586.183228,488.257294 586.389526,488.234955 586.890564,488.112671 
	C587.185303,488.012695 587.387512,487.574097 587.586365,487.694550 
	C587.785217,487.815002 588.141846,487.525513 588.141846,487.525513 
	C588.141846,487.525513 587.778687,487.236115 587.820190,486.988464 
	C587.984009,486.224762 588.069092,485.698151 588.426270,484.964722 
	C588.975586,484.072845 589.205872,483.380005 589.052063,482.293701 
	C588.926819,481.106445 588.993164,480.245361 589.523315,479.133118 
	C590.969788,477.970459 592.596924,477.867462 593.183289,479.158630 
	C594.829956,482.784485 599.113525,485.408264 596.743469,490.656036 
	C595.341064,493.761230 597.482117,494.765381 600.793213,493.199280 
	C604.542542,492.431488 606.102783,494.093414 606.358215,497.301605 
	C606.972412,505.014374 606.425537,512.485779 601.387085,519.324646 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M603.680420,453.051208 
	C605.730164,450.671753 605.650085,448.146149 605.668091,445.676361 
	C605.796570,428.038605 605.900635,410.400665 606.080811,392.394470 
	C606.513062,391.664490 606.926575,391.373901 607.751038,391.069397 
	C609.898865,391.014038 611.832520,391.425751 611.292969,393.626923 
	C610.518860,396.784912 612.157593,396.513794 614.152832,396.210968 
	C615.290588,396.038269 616.425232,395.809906 617.585815,395.922119 
	C619.424072,396.099854 620.757019,396.859772 620.808167,398.925171 
	C620.851868,400.687408 619.818848,401.630524 618.216309,402.041840 
	C616.443665,402.496765 614.615662,402.323212 612.665344,402.480560 
	C615.059326,402.817139 617.414307,402.303223 619.861206,403.561646 
	C620.413513,404.200104 620.550232,404.658661 620.473999,405.507050 
	C618.716980,407.754211 616.417725,407.086304 614.344971,407.392731 
	C612.707825,407.634796 610.533142,406.922760 610.010010,409.850830 
	C610.028442,410.681671 610.032654,411.159515 610.044006,412.000854 
	C610.653687,415.194427 613.017944,414.372284 614.762756,414.488495 
	C620.133606,414.846283 625.548218,414.021606 631.256592,415.208710 
	C631.802002,415.557190 631.992920,415.736450 632.239075,416.299530 
	C632.164551,416.901367 632.034790,417.119446 631.597412,417.551270 
	C624.580811,418.831390 617.762512,418.285461 611.039551,419.139771 
	C610.379089,419.223724 611.248718,419.125793 610.672913,419.432434 
	C610.402832,419.576233 610.613159,420.020447 611.292603,420.327118 
	C612.746460,420.681122 613.923645,420.633881 615.471375,420.726379 
	C616.358093,420.830841 616.852234,420.962158 617.677856,421.327759 
	C618.658203,421.984680 619.097046,422.591431 619.200623,423.733215 
	C616.598572,426.372009 612.965393,424.274048 610.300903,426.548950 
	C610.357788,427.168976 610.623413,427.385681 611.302246,427.551392 
	C613.324402,427.694672 615.053467,427.569855 616.934082,428.621979 
	C617.479736,429.327148 617.582703,429.818542 617.414856,430.695801 
	C615.253845,433.081482 612.535767,431.844727 610.171265,432.942932 
	C617.146606,434.897400 624.495361,432.241119 631.765015,434.513428 
	C632.395813,435.160980 632.548645,435.643982 632.442505,436.554565 
	C632.170105,437.121307 631.999084,437.311066 631.502319,437.690063 
	C624.671631,438.759491 618.057312,438.391785 611.871582,439.719818 
	C614.135376,439.877838 616.747009,439.254578 619.611206,440.237549 
	C620.392273,440.673462 620.742004,441.040955 621.140259,441.852020 
	C621.255005,442.468689 621.238525,442.721008 620.969116,443.246704 
	C617.642090,445.180115 614.136963,443.746979 610.961975,445.202698 
	C615.360718,445.803436 619.822388,445.389069 624.605469,445.816345 
	C626.033264,446.068085 626.996582,446.510559 628.297363,447.205750 
	C630.221069,449.473969 629.111328,450.398254 626.792847,451.027527 
	C620.901001,450.351929 615.407349,449.944336 609.953003,451.449280 
	C614.148438,454.097260 618.834473,450.101746 623.252808,452.939484 
	C623.828979,454.048798 623.813782,454.856995 623.275513,456.027588 
	C618.469849,458.522278 613.660034,457.263702 608.521423,457.405151 
	C606.931274,457.172394 605.842468,456.803375 604.494263,455.956238 
	C603.978210,455.487305 603.802063,455.269775 603.512817,454.650940 
	C603.433777,453.975067 603.467712,453.700470 603.680420,453.051208 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M599.966309,493.698547 
	C600.888794,497.238220 598.904419,495.647247 597.671509,495.357941 
	C595.114014,494.757812 594.137634,493.156189 594.938049,490.680725 
	C596.267517,486.569183 594.568542,481.717926 590.352783,479.019989 
	C588.087097,476.930603 588.404358,474.235962 587.926270,471.368713 
	C587.904907,468.608459 587.921265,466.230591 588.040588,463.417847 
	C588.344971,462.545502 588.575317,462.123871 589.137329,461.516998 
	C590.358398,460.931824 591.299194,460.941742 592.573120,461.301788 
	C594.437439,463.512085 597.054871,462.130249 599.117920,463.515137 
	C599.574097,464.122314 599.760986,464.515198 600.036865,465.220398 
	C605.144592,468.198608 605.144592,468.198608 607.078125,474.130981 
	C607.394165,474.610779 607.507446,474.812073 607.737183,475.340759 
	C607.315308,479.056610 607.315308,479.056610 602.897766,479.741119 
	C604.361633,479.684540 607.201233,478.933838 610.445068,479.342102 
	C610.921082,479.668671 611.082703,479.838165 611.303101,480.353546 
	C611.006592,482.041321 609.234985,483.877869 612.636414,483.777832 
	C615.384033,483.697021 618.200806,483.228760 621.094238,484.770325 
	C621.535950,485.488251 621.591370,485.967285 621.390991,486.804810 
	C617.230286,489.920502 612.399719,487.455627 607.893250,489.340149 
	C607.124512,489.691376 606.677246,489.860657 605.889404,490.105560 
	C603.653992,490.610657 601.750488,491.017609 599.686707,491.706604 
	C599.447266,492.454224 599.665771,492.940948 599.966309,493.698547 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M606.414429,385.211548 
	C606.068970,382.205719 606.024048,379.425629 606.047791,376.314209 
	C606.449646,375.622742 606.830566,375.324982 607.607910,374.990295 
	C612.568115,374.100250 617.229797,375.329712 621.937927,374.943176 
	C621.663879,373.119324 620.147217,373.360535 619.078552,372.445587 
	C618.560974,371.814178 618.429443,371.371399 618.491577,370.553864 
	C619.742737,368.656250 621.393677,368.917145 623.039673,368.942261 
	C624.709351,368.967804 622.898438,368.287842 623.059937,367.669739 
	C622.655151,366.098999 622.678955,364.857300 623.073242,363.245819 
	C623.978699,361.481750 625.093750,361.211090 626.793640,362.101685 
	C628.295776,365.384003 630.532166,366.818542 634.100708,366.801819 
	C634.764282,367.640411 634.877502,368.317993 634.688477,369.368958 
	C634.111389,370.868744 632.723694,370.786102 631.847229,371.727753 
	C632.912842,371.553314 633.881226,371.344574 634.738892,372.602051 
	C635.962585,375.990387 635.185547,379.213654 635.806335,382.323944 
	C636.122681,383.909119 635.456970,385.390381 633.801880,385.912048 
	C630.471069,386.961884 627.083740,387.968658 623.602844,386.498779 
	C622.110901,385.868713 620.101013,385.443848 620.155640,383.437256 
	C620.202759,381.706482 621.990051,381.320343 623.761902,380.838623 
	C624.323486,380.504211 624.912292,381.232941 624.716431,380.389038 
	C623.225281,379.891235 621.962341,379.546173 620.650452,379.496948 
	C615.510254,379.303986 609.789429,377.891022 607.819580,385.405640 
	C607.213135,385.489624 606.963989,385.463409 606.414429,385.211548 
z"/>
<path fill="#4B225C" opacity="1.000000" stroke="none" 
	d="
M589.292908,461.749451 
	C588.954468,462.249268 588.790405,462.514954 588.343872,462.856384 
	C587.750122,455.041443 587.747925,455.027893 595.376099,453.780579 
	C597.302612,453.465546 599.248413,453.268005 601.613770,453.065125 
	C602.471741,453.494568 603.032349,453.502594 603.683960,453.876709 
	C603.821533,454.110474 603.882202,454.579254 603.925903,454.811523 
	C605.324219,457.530212 603.123169,457.709320 601.768311,458.314789 
	C599.492432,459.331848 596.919434,458.970825 594.157715,460.209412 
	C593.592407,460.850372 593.443359,461.004120 593.004517,461.293701 
	C591.663025,461.551392 590.600037,461.412354 589.292908,461.749451 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M585.641846,488.127319 
	C583.120605,490.936157 582.537659,494.293091 582.959351,497.976410 
	C583.653687,504.039917 581.257019,510.428070 584.929932,516.567261 
	C582.229614,517.704041 580.807495,517.355286 580.963989,513.795471 
	C581.299683,506.157104 581.368835,498.488525 581.088562,490.849152 
	C580.944336,486.916412 582.039734,486.213409 585.641846,488.127319 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M608.285400,375.697083 
	C607.639709,375.965363 607.204529,375.968811 606.442871,375.977600 
	C606.079224,373.902405 606.042053,371.821869 605.922607,369.369965 
	C605.922607,364.719574 606.004883,360.440552 606.213989,355.798706 
	C606.470947,355.190430 606.601074,354.945007 607.144104,354.665222 
	C607.801331,354.754944 608.045715,354.878967 608.526489,355.335632 
	C608.981445,356.148926 609.138672,356.648621 609.273438,357.536743 
	C609.176636,360.351135 609.620728,362.147430 612.784424,361.771423 
	C614.405823,361.578735 616.105591,361.782928 617.489502,363.500183 
	C617.753723,364.278992 617.777405,364.744843 617.578491,365.538696 
	C616.155212,367.335022 614.511963,366.775269 612.937622,366.640228 
	C611.166687,366.488281 609.523621,366.498993 610.212341,369.405762 
	C610.496216,370.684296 610.039795,371.475647 609.571167,372.610352 
	C609.251099,373.804962 609.039246,374.684601 608.285400,375.697083 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M587.779541,471.375183 
	C589.656067,473.080902 590.047485,475.572693 589.973145,478.607056 
	C589.973755,480.068329 589.971924,481.122253 589.968262,482.571686 
	C589.964172,483.580780 589.791626,484.136963 589.196411,484.830994 
	C588.736938,485.830322 588.490234,486.621185 588.118896,487.709778 
	C587.994263,488.007507 587.589539,488.028656 587.387451,488.020691 
	C587.347046,482.596466 587.508850,477.180267 587.779541,471.375183 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M585.868835,517.317383 
	C588.264221,517.109619 590.558228,517.656494 592.777588,519.152710 
	C590.549194,520.560364 588.570068,518.977722 586.028687,518.492737 
	C585.608215,518.050049 585.702332,517.774658 585.868835,517.317383 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M606.025879,385.239319 
	C606.416260,384.992096 606.718628,384.998322 607.474243,384.988922 
	C609.764526,386.807922 609.595825,388.919708 608.499084,391.503357 
	C607.760559,391.915588 607.300171,391.945831 606.494446,392.001099 
	C606.067139,391.255371 605.985107,390.484589 605.845459,389.327271 
	C605.868530,388.527771 605.898132,388.111237 605.814697,387.382751 
	C605.814575,386.547241 605.876221,386.020020 606.025879,385.239319 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M605.569824,387.221222 
	C605.818420,387.578400 605.883972,388.082367 605.868713,388.763489 
	C605.189514,388.535034 604.936157,388.041290 605.569824,387.221222 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M603.854126,453.752625 
	C603.327881,453.927338 602.834167,453.744232 602.191406,453.337463 
	C602.444336,453.011108 602.846497,452.908447 603.553833,452.741211 
	C603.868286,452.915985 603.877502,453.155365 603.854126,453.752625 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M309.506989,895.566956 
	C310.130951,896.682312 310.456390,897.580383 310.927307,898.811035 
	C310.244537,900.095032 309.076965,899.990601 307.652283,900.138184 
	C306.063568,900.546204 304.693909,900.574036 303.269897,901.498047 
	C299.942993,902.473267 296.895813,903.271667 293.454895,904.112000 
	C293.047882,902.795959 292.075470,902.084839 291.128510,900.738037 
	C291.428925,899.791748 291.807068,899.503052 292.559387,899.135803 
	C295.995239,898.073425 298.906647,896.377136 302.644958,896.537720 
	C303.433807,896.371521 303.876923,896.242554 304.638550,895.947266 
	C306.329498,895.193665 307.714996,894.764221 309.506989,895.566956 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M303.322662,901.709351 
	C303.482239,899.621521 305.113708,900.069092 306.925995,900.100464 
	C306.095184,900.675720 304.875153,901.209717 303.322662,901.709351 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M275.018921,917.020630 
	C275.149689,916.575012 275.265564,916.114624 275.381470,915.654236 
	C276.082642,915.998840 275.760071,916.397156 275.205872,916.888184 
	C274.970428,916.981140 275.004028,917.005859 275.018921,917.020630 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M282.470856,918.454651 
	C282.681488,918.449524 282.749115,918.545166 282.816711,918.640747 
	C282.653778,918.612305 282.490814,918.583862 282.470856,918.454651 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M284.523438,917.589966 
	C284.410767,917.661316 284.358246,917.379944 284.358246,917.379944 
	C284.358246,917.379944 284.636139,917.518677 284.523438,917.589966 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M137.996399,764.661255 
	C131.447479,761.851318 125.981819,757.194763 120.996071,751.979614 
	C117.861992,748.701172 115.166969,745.002441 111.193069,742.207520 
	C102.197159,729.761292 94.956207,716.461487 87.273369,703.041138 
	C86.993210,702.823914 87.075951,702.436584 87.071617,702.238586 
	C81.609467,693.921814 78.932289,684.727844 77.116760,675.288025 
	C76.571259,672.451660 74.035881,669.967712 75.690948,666.439453 
	C76.254898,659.650085 79.188530,653.978699 83.003517,649.269043 
	C86.503113,644.948669 89.940781,639.270691 97.523239,640.068359 
	C99.415092,641.227173 99.330711,642.928284 99.283318,644.584412 
	C98.902809,657.882568 100.831726,671.031128 101.924706,684.229065 
	C102.389587,689.842529 102.929955,695.464722 103.375191,701.075317 
	C104.350983,713.371704 108.799042,723.827820 117.905457,732.274536 
	C121.062698,735.203186 123.841705,738.532227 127.472427,741.522339 
	C131.124878,744.614258 132.385635,748.811523 134.778381,752.740479 
	C134.994812,753.046692 135.011124,752.992981 134.983459,752.988281 
	C135.418961,753.417236 135.471603,754.030518 135.837128,754.821533 
	C136.017242,755.057434 136.025711,754.981934 135.988708,754.973389 
	C135.951706,754.964905 136.251373,755.316345 136.199005,755.541260 
	C134.970688,758.986328 138.492508,761.181580 137.996399,764.661255 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M128.299103,742.584045 
	C122.312508,740.842468 119.690392,735.227417 115.331406,731.571167 
	C103.438446,721.595581 102.617142,707.444458 101.132576,693.657837 
	C99.558380,679.039001 99.064346,664.318176 97.212151,649.712769 
	C96.846970,646.833130 98.423271,643.905457 97.941620,640.455200 
	C98.390038,636.435242 98.863503,632.852295 99.485023,628.149048 
	C100.763863,638.211792 101.904930,647.190430 103.094810,656.594849 
	C104.757904,669.267273 108.203049,681.085815 111.524940,692.934204 
	C111.789185,693.876648 111.907974,694.859924 112.046112,696.206909 
	C116.004311,710.816101 120.226738,724.960327 127.431381,737.997559 
	C128.148834,739.295776 128.871033,740.650696 128.299103,742.584045 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M75.629242,666.073608 
	C77.649651,676.203369 80.983635,685.807739 84.719711,695.292236 
	C85.502075,697.278442 86.231949,699.285217 87.026657,701.661560 
	C85.254089,702.299500 85.045761,699.973572 83.189842,699.716919 
	C83.319878,702.686768 84.834419,705.534363 83.322678,708.683105 
	C80.689362,697.789978 78.299713,686.634155 75.990402,675.461670 
	C75.648827,673.809082 75.448463,672.189941 73.590225,671.043823 
	C73.477234,669.538513 73.705826,668.131897 74.034592,666.381226 
	C74.534050,666.036194 74.933342,666.035217 75.629242,666.073608 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M137.235962,591.637695 
	C137.366013,594.198792 137.407013,596.431030 137.205429,599.092712 
	C134.217468,594.336975 137.242096,588.546265 135.068527,583.286438 
	C137.137039,585.663208 136.936905,588.534302 137.235962,591.637695 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M112.957832,667.640625 
	C112.740715,668.026001 112.544678,668.015625 112.053665,667.988281 
	C109.703568,664.931580 110.419128,661.187378 109.155197,657.564270 
	C112.621506,659.686829 111.350128,664.024902 112.957832,667.640625 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M134.218262,556.792969 
	C134.278061,555.781067 134.628860,555.232056 135.390244,555.655579 
	C135.663132,555.807373 135.845688,556.563965 135.714218,556.909424 
	C135.428406,557.660522 134.849274,557.733398 134.218262,556.792969 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M143.033569,560.654541 
	C142.822739,561.001038 142.651993,560.995667 142.225525,560.970886 
	C142.149475,560.377930 142.329147,559.804443 142.768707,559.057007 
	C143.043610,559.356201 143.058624,559.829468 143.033569,560.654541 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M136.700073,644.071716 
	C136.864410,644.131470 136.901947,644.311279 136.912567,644.765381 
	C136.781525,644.757080 136.677383,644.474426 136.700073,644.071716 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M56.318100,771.390259 
	C56.109837,776.816101 58.683765,780.188477 63.010681,782.342041 
	C68.935814,785.291016 74.339081,789.224976 80.660812,791.437012 
	C87.397224,793.794067 91.948936,798.771057 95.775650,804.554016 
	C100.433067,811.592468 105.107483,818.629700 110.678368,824.993408 
	C113.280884,827.966187 115.872353,831.030945 119.819687,832.962891 
	C119.631149,835.820068 117.388046,836.136597 115.597260,836.661560 
	C100.507607,841.085022 86.973183,848.828369 73.314476,856.310059 
	C71.991608,857.034729 70.573364,857.477112 68.840263,858.179443 
	C64.954544,860.111938 61.226826,861.504700 57.874008,863.657837 
	C56.137585,864.773071 54.314850,865.469116 52.116570,863.839172 
	C44.959282,858.576599 41.499813,851.755310 41.064644,843.334473 
	C40.954510,841.203186 41.011478,839.063293 41.027321,836.471375 
	C43.390003,834.746033 45.316910,836.057495 46.974022,837.285645 
	C51.582825,840.701538 57.051094,842.217102 62.475319,844.633911 
	C63.009785,844.791382 63.218716,844.860718 63.731976,845.038696 
	C65.035301,845.583618 66.046211,845.609741 67.383072,845.147217 
	C73.823433,844.585999 77.333801,840.012817 81.388847,836.304871 
	C82.960663,834.867615 84.052071,832.993225 85.870018,831.303467 
	C87.104675,830.390442 87.825569,829.434998 89.040497,828.491943 
	C92.682892,827.112488 95.381134,829.763489 98.856155,829.874023 
	C100.281136,830.169434 101.307755,830.661072 102.677887,830.491943 
	C102.908089,830.445923 103.225922,830.202698 103.168808,830.012573 
	C102.864967,829.627014 102.595581,829.470215 102.040802,829.226074 
	C90.497757,823.363464 81.404472,814.933228 73.085556,805.958557 
	C72.915459,812.143372 75.358658,817.302490 80.729485,821.013489 
	C81.958138,821.862488 83.104820,822.884521 82.970634,824.900940 
	C80.438271,826.639282 78.570610,825.019897 76.251480,824.065796 
	C71.390228,821.251831 66.464958,819.330872 61.696922,816.267700 
	C63.600391,818.053345 66.474907,818.023376 66.858574,821.049255 
	C65.424515,822.163879 64.038185,822.218872 62.821686,821.627136 
	C55.366966,818.000671 47.516525,815.117859 40.674366,809.701599 
	C40.429062,807.873230 41.296635,806.955017 42.701378,805.992676 
	C45.942337,807.653137 45.560314,805.335815 45.799171,803.393066 
	C46.520931,794.955566 45.262096,786.873108 45.805717,778.718811 
	C46.191116,772.937744 46.986652,767.171814 47.067791,761.361450 
	C47.109734,758.357971 48.623905,757.085144 52.093674,758.256897 
	C52.539642,758.334290 52.596771,758.498291 52.582699,758.583984 
	C52.058620,759.630554 52.804073,760.072510 53.595200,760.775024 
	C54.204319,761.729614 54.581337,762.500732 55.025192,763.589966 
	C56.504215,766.089417 56.575191,768.528137 56.318100,771.390259 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M87.206543,831.700684 
	C83.353935,836.260498 79.285233,840.065491 74.936707,843.638550 
	C72.702408,845.474487 70.535698,846.388000 67.333214,845.999756 
	C66.219200,846.569580 65.421997,846.486023 64.309273,846.173950 
	C63.991570,845.931702 64.002220,845.996582 64.032272,845.983276 
	C57.417072,842.460144 50.277908,839.700134 45.174797,833.301819 
	C39.969463,827.266479 39.162426,819.866455 37.106201,812.967773 
	C36.400082,810.598694 35.843956,808.184937 35.211861,805.410645 
	C38.409561,804.016785 38.572079,807.585999 40.682892,808.816223 
	C49.131149,813.565369 57.187729,818.419067 66.886047,821.162598 
	C67.690544,821.221191 67.844093,821.313599 68.202194,821.583008 
	C68.534775,821.888611 68.662811,822.017029 68.989914,822.330933 
	C69.482803,822.751831 69.798157,822.954407 70.414551,823.237427 
	C74.321709,823.941040 76.838814,826.681763 80.261169,828.336914 
	C80.795326,828.801392 81.092102,829.065186 81.675316,829.363220 
	C82.101494,829.514526 82.253830,829.617493 82.228027,829.510010 
	C81.641251,829.392578 81.300644,829.263794 80.775627,828.764038 
	C79.007935,826.457886 74.344658,827.079956 75.794800,822.774414 
	C78.182869,823.628357 80.238266,824.396545 83.011024,825.168579 
	C83.932602,825.294678 84.136810,825.416809 84.603134,825.780151 
	C85.909302,827.729736 88.382088,828.762085 87.206543,831.700684 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M52.467407,758.019653 
	C48.814892,758.286926 47.959648,760.159973 47.865658,763.749573 
	C47.685440,770.632568 46.841808,777.505615 46.098129,784.363770 
	C45.645168,788.540894 46.624794,792.559082 46.935131,796.651917 
	C47.081673,798.584534 47.405846,800.621033 46.178642,802.787964 
	C43.890652,785.679016 44.515388,768.422302 48.143002,751.222717 
	C49.756004,753.427063 50.355362,756.019165 52.467407,758.019653 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M51.919189,863.918518 
	C54.924656,865.034851 56.749054,862.490662 58.995625,861.400452 
	C61.792198,860.043457 64.566658,858.640869 67.690224,857.164185 
	C69.014664,857.400513 69.575127,858.111206 69.889130,859.437622 
	C69.729347,862.128662 68.550041,863.668091 65.970886,864.042725 
	C63.085060,865.197693 59.780731,864.325256 57.249352,866.751831 
	C54.564438,867.762878 53.351784,865.858887 51.919189,863.918518 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M44.853851,833.259888 
	C51.061703,837.527344 57.459175,841.515137 64.038162,845.614746 
	C55.759361,844.601746 49.045506,839.681152 41.419899,836.008118 
	C41.576393,834.178162 43.805305,834.849182 44.853851,833.259888 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M41.087227,808.822998 
	C37.782009,809.629700 37.553703,806.471008 35.535492,805.105347 
	C34.384613,803.433044 33.792370,801.789368 34.205883,799.375183 
	C37.714668,800.593750 40.023277,803.241943 42.881966,805.568604 
	C43.132092,807.182434 42.184013,807.847046 41.087227,808.822998 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M35.576889,861.562744 
	C34.420624,862.327698 33.372162,862.653992 31.987103,862.995850 
	C31.595207,859.631409 31.539902,856.251343 31.599209,852.422729 
	C32.995190,851.007568 34.117161,851.356995 35.387447,852.702515 
	C35.640697,855.717285 35.662693,858.420654 35.576889,861.562744 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M35.728699,852.586182 
	C34.544849,852.683167 33.471012,852.352356 32.055496,851.997803 
	C31.660265,850.907410 31.606710,849.840759 31.688332,848.393311 
	C33.394085,848.205017 33.957916,846.627014 35.455864,846.060547 
	C35.796822,848.047485 35.817764,850.102966 35.728699,852.586182 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M56.428261,771.515991 
	C55.795372,769.422974 55.407978,767.069214 55.056309,764.311768 
	C55.287849,763.950195 55.483665,763.992432 55.980461,764.046387 
	C57.558758,766.394775 57.052803,768.828491 56.428261,771.515991 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M44.125580,887.385193 
	C46.265743,887.275818 46.006840,888.871338 45.960136,890.700073 
	C44.251823,890.539368 44.570591,888.928772 44.125580,887.385193 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M53.808693,760.677612 
	C52.837093,760.840759 52.092384,760.489807 52.405289,758.979553 
	C52.975792,759.245300 53.382954,759.821045 53.808693,760.677612 
z"/>
<path fill="#EBE7C9" opacity="1.000000" stroke="none" 
	d="
M261.759064,296.005646 
	C261.540466,295.178497 261.594452,294.433533 261.807129,293.345581 
	C262.109924,292.846985 262.254028,292.691406 262.219696,292.272461 
	C262.059967,290.526428 262.078674,289.043732 262.192169,287.205383 
	C263.093994,286.718903 264.541962,286.738495 264.613220,286.434937 
	C266.002686,280.515869 270.354645,282.950256 273.904114,282.983246 
	C283.352203,283.071106 292.899384,284.186340 302.199982,283.666077 
	C318.487549,282.755035 334.740143,283.596313 350.988281,282.956451 
	C358.724487,282.651825 366.219086,282.683868 372.530701,288.970795 
	C372.992157,290.487213 372.981140,291.916168 372.880035,293.678925 
	C369.826019,295.478119 370.317566,298.450409 370.093262,300.893188 
	C369.849365,303.548737 369.123199,304.025146 366.727997,302.916046 
	C360.885864,300.210999 354.261108,298.279327 348.397522,300.278290 
	C338.572723,303.627716 328.328186,300.075256 318.562439,303.631744 
	C314.693481,305.040741 309.704559,304.887390 305.394257,302.785522 
	C304.255096,302.230042 302.843964,302.092682 301.544556,302.028107 
	C293.767944,301.641449 285.984375,301.388092 278.210663,300.954865 
	C276.420746,300.855103 274.468964,300.588196 272.924927,299.769592 
	C269.396240,297.898773 266.407654,297.511200 263.953674,301.333466 
	C263.922241,301.382446 262.602264,300.604095 261.565796,300.142426 
	C261.226776,299.167847 261.205597,298.262726 261.290619,297.105042 
	C261.602570,296.592682 262.690247,297.065216 261.759064,296.005646 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M261.790558,318.229797 
	C263.631195,317.839386 265.685028,318.252930 266.818909,317.417603 
	C272.170929,313.474976 276.783386,316.649048 281.178375,318.901520 
	C286.662720,321.712250 287.788910,321.683136 290.426331,316.281281 
	C290.912537,315.285492 291.284271,313.902130 292.824127,314.315643 
	C294.346252,314.724457 293.855072,316.154785 294.001953,317.624023 
	C294.150787,318.161530 294.296722,318.310150 294.505737,318.766052 
	C294.617493,319.923676 294.690857,320.770447 295.005951,321.930725 
	C296.056427,327.202789 292.455566,331.126740 292.005859,336.138977 
	C291.822083,336.751038 291.731445,336.991821 291.463867,337.576416 
	C290.976288,345.665192 285.274323,352.081909 285.648041,360.364990 
	C282.467499,360.339996 278.865479,363.418915 276.579498,359.110809 
	C276.000275,358.019196 275.741730,358.970917 275.233978,359.228668 
	C271.096832,361.329132 267.271362,360.473114 264.331604,356.946442 
	C261.276367,353.281219 260.199341,349.650024 260.438416,344.391876 
	C260.772797,337.037903 260.980255,329.512329 260.578247,321.750854 
	C260.704773,320.857300 261.830963,321.111084 261.483887,319.963623 
	C261.381104,319.251556 261.440765,318.849609 261.790558,318.229797 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M261.966858,317.699646 
	C262.000458,318.444305 261.999695,318.887390 261.998840,319.662781 
	C262.113953,320.162750 262.229126,320.330353 262.170929,320.748993 
	C261.100861,321.689117 260.829407,322.707397 261.037079,323.686218 
	C262.340393,329.829803 260.626404,336.159302 262.228333,342.275879 
	C262.395447,342.914032 262.881653,343.811951 262.628326,344.164825 
	C259.307800,348.791229 262.719177,351.739258 264.796234,355.451385 
	C266.768494,358.976196 269.882538,359.171570 272.763245,359.497711 
	C275.975464,359.861328 274.198486,356.009491 275.632019,354.654419 
	C278.577148,353.888611 275.868011,365.057648 282.148224,357.569641 
	C283.668915,357.970856 282.431854,360.548126 284.937927,361.195068 
	C287.780609,367.167633 285.132111,372.876831 285.742920,378.568024 
	C285.917816,380.198059 285.910919,381.810211 286.756287,383.670685 
	C287.364441,384.671387 287.601379,385.394226 287.494354,386.558899 
	C287.262512,387.133057 287.120605,387.337769 286.701050,387.783630 
	C282.940277,390.585083 281.022064,389.632629 280.685425,385.027924 
	C280.174866,388.839508 280.517853,392.287201 280.283783,395.714081 
	C280.141724,397.793640 280.401611,400.536011 277.352966,400.564941 
	C274.288727,400.594086 273.928528,397.994324 273.716522,395.591400 
	C273.672882,395.096985 273.691559,394.597931 273.654816,394.103363 
	C273.521820,392.312469 273.999451,390.021606 272.281097,389.065979 
	C270.315430,387.972839 269.734711,390.537292 268.537537,391.450714 
	C266.044861,393.352478 264.275665,392.573608 262.845459,390.156250 
	C262.058960,388.826874 261.832489,387.336060 261.999176,385.836975 
	C262.365906,382.538910 260.738373,381.302399 257.393799,381.222656 
	C257.349823,373.626343 257.580383,366.245056 257.739807,358.433777 
	C258.464996,344.309906 259.261292,330.615997 260.139313,316.463531 
	C261.081604,316.112915 261.750519,316.456360 261.966858,317.699646 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M339.360474,377.716858 
	C339.358795,378.792633 339.278839,379.523376 339.145081,380.618103 
	C336.204987,380.719269 337.080200,378.435364 337.000763,376.838226 
	C336.748749,371.772949 336.655090,366.699738 335.960754,361.037170 
	C334.606934,359.031494 334.742981,357.458649 334.642212,355.547394 
	C334.605988,354.683411 334.605743,354.194366 334.622009,353.352264 
	C335.170959,349.192932 331.305786,349.314117 329.479614,347.138977 
	C328.742798,345.658051 328.680206,344.397736 328.615662,342.757812 
	C328.613556,341.880646 328.616089,341.383331 328.621826,340.523499 
	C328.639343,338.764496 328.710358,337.368958 328.682098,335.646667 
	C328.606964,334.508148 328.647278,333.663483 327.737366,332.828247 
	C327.339172,332.481232 327.173645,332.344574 326.753845,332.000122 
	C322.605957,328.442780 317.642609,327.378448 313.057526,325.508545 
	C311.075287,324.700165 308.858093,324.422943 306.991974,322.601074 
	C306.731934,322.077301 306.678711,321.844574 306.806458,321.302887 
	C315.597229,321.147369 322.792450,325.444641 329.930878,329.412262 
	C333.487274,331.388916 332.277130,335.644684 331.433838,339.007782 
	C330.595673,342.350555 331.598785,344.552612 334.734711,345.767639 
	C337.038971,346.660461 339.111023,347.536530 339.138092,343.372375 
	C339.159210,340.124878 341.397247,338.842468 344.868683,338.883331 
	C350.558044,338.950317 356.059326,339.965118 362.028046,341.140717 
	C359.345215,342.980804 356.147034,341.658295 352.979218,341.375336 
	C349.581116,341.071838 346.190674,340.730652 342.625549,341.682281 
	C340.821075,351.229736 339.991547,360.506958 339.839539,370.297913 
	C339.749023,370.951385 339.657898,371.154938 339.494995,371.685181 
	C339.384674,372.763702 339.346130,373.515503 339.425018,374.631653 
	C339.487854,375.163910 339.433258,375.331757 339.472107,375.747314 
	C339.471069,376.453918 339.376587,376.912872 339.360474,377.716858 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M284.998840,360.998871 
	C284.996521,358.507538 284.995667,356.019989 285.000519,353.532410 
	C285.002167,352.703369 284.665222,351.479980 285.082520,351.106232 
	C289.283661,347.343903 288.385529,341.761536 290.614594,337.089905 
	C292.294952,338.168121 291.900024,339.740723 292.009949,341.193207 
	C291.926941,339.947754 292.216095,338.648315 291.234070,337.249878 
	C290.225006,333.344360 292.159027,330.345215 293.431030,327.203003 
	C294.142426,325.445679 293.938904,323.648010 294.000427,321.427979 
	C293.628235,320.613129 293.484619,320.151550 293.784363,319.306458 
	C294.000000,318.993896 294.002258,318.503265 294.003571,318.258118 
	C299.400696,314.595764 300.725189,314.850983 305.638550,320.915375 
	C304.886932,321.734955 304.366089,321.838867 303.432800,321.792236 
	C298.138672,320.509918 298.094299,320.606598 297.390991,325.359863 
	C296.109497,334.020569 296.565063,342.851257 294.576538,351.780762 
	C293.418274,353.031189 292.169495,353.173706 290.600677,353.429718 
	C286.907593,355.031464 289.344238,358.769989 287.208282,361.110168 
	C286.505432,361.514679 286.046051,361.536530 285.294617,361.224548 
	C285.010376,361.010437 285.002594,361.002625 284.998840,360.998871 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M306.741333,320.994263 
	C306.987427,320.993896 306.996490,321.429108 307.000153,321.646729 
	C306.646484,322.142822 306.298828,322.117493 305.871460,321.540833 
	C305.783356,321.250671 305.892426,321.125488 305.947784,321.063599 
	C306.003143,321.001740 306.495270,320.994629 306.741333,320.994263 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M389.871460,686.957275 
	C390.062347,687.153015 390.228394,687.345032 390.165222,687.455139 
	C388.359589,688.247925 386.703918,688.364502 385.075348,687.131348 
	C386.038422,685.467224 387.298401,686.314941 388.706635,686.045532 
	C389.102386,685.973999 389.016357,685.996948 389.005676,685.953735 
	C389.211884,686.203552 389.439850,686.487732 389.871460,686.957275 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M364.197571,461.251587 
	C366.026245,460.528351 367.476166,460.046997 366.693329,462.773621 
	C366.068665,464.949158 365.031555,467.064911 365.615662,469.651459 
	C363.409241,475.930908 360.209961,481.597168 356.193451,488.281738 
	C356.971008,477.870605 360.478546,469.667297 364.197571,461.251587 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M378.779785,538.264343 
	C379.713013,538.639160 380.523590,539.268127 381.687988,539.964111 
	C381.804962,542.156494 380.202179,541.971252 378.344604,541.988647 
	C378.030853,540.795410 375.805420,539.151428 378.779785,538.264343 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M69.372635,860.428406 
	C68.809479,859.376709 68.553520,858.530212 68.163681,857.377075 
	C84.934280,848.752869 101.195396,839.018677 119.725632,833.489136 
	C123.512566,833.028015 126.937447,832.289673 130.645081,831.004272 
	C131.868973,830.755859 132.703629,830.868469 133.824158,831.242065 
	C134.888336,831.827515 135.491516,832.455017 136.156372,833.471436 
	C136.334488,833.987976 136.362259,834.207947 136.236908,834.723145 
	C123.843941,841.974487 110.902527,847.624756 98.888474,855.005737 
	C97.646851,855.768616 96.208351,856.211060 94.570496,856.996338 
	C87.903198,856.275024 81.964409,857.866028 75.853600,860.453674 
	C75.299072,860.566223 75.072792,860.576660 74.528000,860.499451 
	C73.832756,860.165649 73.710930,859.480957 73.487076,859.438354 
	C72.710167,859.290527 73.611946,860.200012 72.763992,860.499878 
	C71.537056,861.041077 70.604195,861.052124 69.372635,860.428406 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M92.777046,754.735901 
	C95.882401,759.247620 100.824127,761.303772 104.035278,765.600220 
	C97.389305,769.018982 92.631714,764.203247 87.699173,761.367188 
	C85.017387,759.825073 81.965302,758.672058 79.601898,756.193970 
	C77.964287,754.476929 77.334839,757.387756 76.271889,758.780945 
	C75.846375,759.165344 75.672104,759.342529 75.250183,759.241028 
	C75.002533,758.962402 74.988091,759.006287 75.010895,759.010254 
	C74.581665,758.580566 74.528038,757.976135 74.173996,757.190796 
	C73.996140,756.957336 73.985619,757.009766 74.012146,757.013306 
	C73.916328,756.866211 73.793968,756.715576 73.818108,756.313477 
	C72.569550,749.127136 66.757538,744.805908 63.701004,738.834351 
	C62.868328,737.207581 61.304226,736.101562 62.866116,734.112000 
	C64.945175,731.463562 58.122208,731.077332 61.864773,728.053711 
	C65.454109,731.794006 71.286087,732.816833 75.660217,736.870422 
	C82.061935,742.303955 86.588196,749.070007 92.777046,754.735901 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M74.982964,759.380127 
	C75.172188,758.965454 75.341835,758.968567 75.766068,758.979919 
	C76.669373,760.058899 77.318108,761.129761 77.991348,762.515564 
	C78.394897,763.342407 78.470711,763.963745 78.848206,764.776794 
	C79.058525,765.001465 78.996735,764.991882 79.011047,764.964111 
	C80.376427,766.439575 81.011398,768.555542 83.240608,769.760986 
	C84.487503,773.170105 88.468750,774.604736 88.239563,778.697937 
	C87.038109,779.705750 86.197739,779.531799 85.464874,778.566223 
	C89.958542,783.701904 95.588020,787.551819 100.741295,791.936890 
	C104.288261,794.955139 107.871666,797.928955 110.841972,801.544006 
	C111.995758,802.948303 113.313927,804.346863 112.241791,806.714905 
	C111.138527,806.739868 110.256737,806.487122 109.022301,806.180481 
	C108.176018,806.081177 107.588226,806.195251 107.202255,805.967407 
	C89.440147,795.483093 78.538879,780.194824 74.982964,759.380127 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M92.998154,754.580200 
	C89.033104,754.038330 87.209526,750.419128 84.502029,747.931274 
	C81.251892,744.944702 78.631027,741.371338 76.110626,737.333374 
	C77.708809,733.023560 81.591705,736.541748 83.610298,735.018311 
	C89.237633,730.771484 86.947533,737.487183 88.838562,738.773071 
	C88.440880,740.405090 89.203346,741.443604 89.836449,742.780029 
	C90.034592,743.012207 89.989853,743.007019 89.996201,742.985474 
	C90.779549,744.382996 90.792137,746.067200 91.780670,747.759094 
	C91.990410,748.032532 91.994217,748.002686 91.978035,748.009521 
	C91.825043,750.151428 92.104057,752.218994 92.998154,754.580200 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M136.393921,834.256165 
	C135.189240,833.614441 134.400986,832.872498 133.814575,831.392273 
	C133.672638,830.826172 133.675903,830.651978 133.861969,830.291016 
	C134.472549,830.042603 134.900330,829.980835 135.644073,829.845459 
	C139.388916,828.965881 142.817780,828.159912 146.712402,827.244446 
	C145.338333,829.909912 142.687302,830.519043 140.980652,832.603882 
	C139.734299,833.297302 138.682587,833.715698 137.300201,834.225708 
	C136.969559,834.317322 136.535217,834.430542 136.393921,834.256165 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M133.857513,829.841431 
	C134.048935,830.335144 133.977676,830.539612 133.750168,830.859009 
	C132.945663,831.041504 132.221939,831.082764 131.255219,830.994873 
	C131.283661,829.167664 132.124908,828.646118 133.857513,829.841431 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M91.995987,747.680176 
	C90.027763,747.198181 89.932709,745.480164 89.974152,743.337524 
	C90.506134,743.585388 91.009735,744.206848 91.750610,745.031067 
	C91.992455,745.931885 91.997002,746.629883 91.995987,747.680176 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M90.037170,742.667725 
	C88.492599,742.272583 87.598602,741.238159 88.676376,739.270874 
	C89.311806,740.182129 89.675774,741.252686 90.037170,742.667725 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M74.001923,757.269836 
	C74.327347,757.437256 74.658554,757.917236 75.011734,758.705688 
	C74.691696,758.536865 74.349701,758.059631 74.001923,757.269836 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M73.804688,756.147278 
	C73.964600,756.061951 73.985542,756.540405 74.012115,756.778625 
	C73.907379,756.755432 73.776077,756.494019 73.804688,756.147278 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M212.027863,903.304199 
	C212.559738,905.609070 209.214325,905.446228 210.017120,907.827271 
	C207.627914,909.214539 205.146698,907.833862 203.340027,907.093140 
	C198.950180,905.293396 195.092072,909.144897 190.993225,907.417786 
	C190.931046,907.743896 190.868866,908.070068 190.918320,908.677612 
	C190.140671,908.489807 188.501724,909.856689 188.198547,907.475098 
	C188.146423,907.125854 188.313568,906.830750 188.313568,906.830750 
	C188.313568,906.830750 188.053284,906.603638 187.927658,906.718018 
	C184.507095,907.634521 182.642578,904.840942 180.115967,903.441528 
	C180.137665,903.116882 180.301056,902.731934 180.210983,902.487183 
	C180.120911,902.242432 179.982986,902.641602 179.771820,902.643555 
	C178.434814,902.537048 177.301376,905.662598 176.136139,902.055298 
	C176.159790,901.315430 176.229675,901.157898 176.555298,900.542358 
	C176.896683,899.926270 176.982346,899.768188 177.203186,899.367676 
	C177.439987,898.964233 177.541611,898.803101 177.820190,898.406250 
	C178.130234,898.015930 178.263290,897.861389 178.868225,897.267578 
	C179.528000,896.702332 179.715897,896.576355 180.221527,896.301392 
	C180.769989,896.082825 181.000732,896.013123 181.596405,895.887695 
	C186.861343,895.915588 191.386307,898.045349 196.603394,898.555786 
	C201.600266,901.325684 207.197922,900.568237 212.027863,903.304199 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M174.043167,898.344238 
	C173.369308,898.029358 172.324036,897.787048 172.140396,898.081665 
	C169.840012,901.773438 166.770569,902.877319 162.354858,901.105103 
	C161.244385,899.143433 162.956726,898.195007 163.764587,896.534668 
	C164.056519,896.041077 164.177826,895.844849 164.487640,895.355713 
	C165.605179,893.985779 165.888260,892.448730 167.503357,891.499756 
	C171.140060,892.227722 174.313965,893.417175 177.641342,894.066956 
	C178.861862,894.305298 180.307114,894.418030 180.271271,896.531738 
	C180.103577,896.886902 180.071198,896.922913 180.055511,896.941284 
	C179.798904,897.192810 179.560028,897.427979 179.148102,897.845581 
	C178.972595,898.025635 178.999268,898.000122 179.011963,897.986694 
	C178.787384,898.201965 178.552872,898.433472 178.147842,898.844116 
	C177.974533,899.020325 177.996689,898.998108 178.005035,898.984863 
	C177.568253,899.408386 177.496658,900.004089 177.160568,900.797485 
	C176.984451,901.032715 177.004166,901.002502 177.016510,900.989258 
	C176.792725,901.207092 176.552597,901.433838 176.142822,901.840576 
	C175.977188,902.024780 175.999619,902.002197 176.012054,901.992310 
	C174.847321,902.218506 173.670135,902.454590 172.289337,902.731567 
	C171.808289,900.855896 173.771530,900.090149 174.043167,898.344238 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M154.100266,889.733887 
	C156.119461,889.843750 158.011230,890.299438 160.251648,890.799316 
	C161.126984,890.879944 161.653687,890.916382 162.574417,890.978638 
	C163.156937,890.864258 163.345444,890.724121 163.859070,890.719421 
	C164.874283,892.320068 165.651199,893.762268 165.197998,895.748535 
	C164.985291,896.022583 165.000443,895.999756 165.008698,895.988831 
	C164.055420,896.803101 163.784622,899.037170 161.617676,897.316040 
	C161.509842,896.704712 161.648346,896.474548 161.856384,896.263489 
	C161.965424,896.152832 161.939331,896.007935 161.924820,895.973389 
	C161.666992,895.358643 161.058777,895.903503 161.720032,895.818726 
	C161.724869,895.818115 161.760162,895.961975 161.622406,896.456726 
	C160.690353,897.905579 160.066345,899.251648 158.173370,899.734375 
	C157.179794,900.282410 156.483536,900.729309 155.356934,901.056641 
	C155.854599,898.095520 157.365860,894.992737 151.921417,895.681335 
	C151.039490,895.792969 150.945847,894.573547 151.175751,893.319946 
	C153.064560,892.808716 153.260468,891.199463 154.100266,889.733887 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M158.214264,899.995544 
	C159.011963,898.563049 160.147842,897.290527 161.668976,896.031494 
	C162.724289,899.108276 163.658844,896.259583 164.743835,896.065552 
	C165.029251,898.021240 163.212357,898.963989 162.146454,900.747803 
	C161.974152,901.033447 161.995834,900.982178 162.023468,900.985840 
	C162.051102,900.989441 161.727142,901.249817 161.539215,901.161133 
	C160.418350,900.766724 159.485397,900.461121 158.214264,899.995544 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M153.862335,902.060669 
	C153.895111,902.029358 153.829544,902.091980 153.862335,902.060669 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M161.353455,901.265503 
	C161.351288,901.072388 161.707031,901.080444 161.879059,901.034912 
	C162.053787,901.493469 161.889099,901.749390 161.353455,901.265503 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M154.007568,902.015808 
	C154.172836,901.741272 154.324295,901.448853 154.701172,901.046814 
	C154.926590,900.937134 155.043015,901.047913 155.101624,901.108521 
	C154.938019,901.430420 154.715820,901.691711 154.227142,901.959839 
	C153.960678,901.966797 153.993729,901.997925 154.007568,902.015808 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M190.893524,910.089600 
	C190.919327,910.055359 190.867752,910.123901 190.893524,910.089600 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M191.012756,910.021240 
	C191.063919,909.856750 191.103745,909.677551 191.086761,909.228760 
	C191.029938,908.959106 191.008209,908.987549 190.993958,908.996460 
	C191.198349,909.228943 191.809143,909.289429 191.142365,909.898193 
	C190.970871,909.986755 191.001404,910.006531 191.012756,910.021240 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M555.272156,1000.771057 
	C551.484497,1003.930481 547.928589,1006.798218 544.547180,1009.858704 
	C543.126221,1011.144714 541.723999,1012.032104 539.409058,1011.869324 
	C538.989380,1009.678589 538.468079,1007.686951 536.345093,1006.068237 
	C536.290955,1003.905518 536.135132,1002.156067 532.504517,1002.349548 
	C537.135559,999.658569 540.821533,997.519958 544.496155,995.362000 
	C544.577576,995.314209 544.530762,995.048096 544.552307,994.777405 
	C543.149414,993.535217 541.869385,995.453003 540.120850,995.026001 
	C542.626892,991.278687 548.090271,990.272949 549.785522,984.526978 
	C534.407593,988.275635 518.815735,989.401184 503.117340,986.219788 
	C518.140686,987.023010 532.713257,983.311096 547.522888,981.973206 
	C548.665161,981.869995 549.777039,981.457336 550.911072,981.228149 
	C552.212769,980.965027 552.981689,980.312500 552.945374,978.873474 
	C552.906189,977.319092 551.875244,977.042114 550.635925,976.845764 
	C549.003662,976.587341 547.389404,976.215332 545.356934,975.817017 
	C544.084473,973.111267 546.195740,972.993164 547.697876,972.822815 
	C550.181824,972.541321 552.563477,971.933350 555.327209,971.273071 
	C556.186646,971.437134 556.557373,971.782104 556.983826,972.005981 
	C557.564758,972.311035 556.791748,972.064758 557.414795,971.827698 
	C557.574402,971.767029 557.410400,971.796082 556.740051,971.653076 
	C556.412170,970.823425 556.443604,970.321228 556.846558,969.505249 
	C561.136658,966.619019 565.924744,967.211609 570.346375,966.197144 
	C575.287354,965.063721 580.246155,964.087708 585.041016,961.439819 
	C587.922546,963.221619 586.744629,965.307678 585.680542,967.079651 
	C578.573547,978.914612 569.790527,989.379700 559.553345,998.635498 
	C558.398010,999.680115 556.934937,999.989502 555.272156,1000.771057 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M586.500549,962.229492 
	C577.473938,967.836426 567.342834,967.774719 557.341187,969.782715 
	C550.174072,972.648254 542.985901,973.555115 535.803223,974.414124 
	C534.022278,974.627197 532.128967,974.439392 530.835327,972.314087 
	C531.884888,971.478699 532.954895,971.098145 534.345215,970.596436 
	C535.904602,969.993164 537.445496,970.204102 538.594604,968.673889 
	C545.184692,966.644470 551.768005,965.751892 557.840942,963.114624 
	C560.507446,961.956665 563.550354,961.218018 564.947144,957.801636 
	C565.056763,957.258240 565.100464,957.040955 565.232056,956.503296 
	C565.475220,955.772888 565.659180,955.376404 566.052124,954.725952 
	C566.489624,954.132629 566.784851,953.843079 567.380005,953.456543 
	C567.978577,953.187805 568.327026,953.088257 568.915894,953.016846 
	C569.144348,953.000427 569.546753,952.952332 569.705688,952.878296 
	C569.864685,952.804260 569.898254,952.486877 569.714478,952.502014 
	C569.235596,952.448120 568.989868,952.297241 568.688232,951.811157 
	C568.591492,951.361206 568.600037,951.164673 568.722656,950.679749 
	C570.796326,947.469971 575.238159,946.572021 575.526550,941.903931 
	C578.820923,937.764282 583.947327,937.294189 588.097351,934.513550 
	C588.659668,934.214905 588.949768,934.022461 589.444458,933.756470 
	C589.654724,933.691528 589.990540,933.432678 589.812134,933.547302 
	C589.633728,933.661926 589.213562,933.804260 589.035034,933.953857 
	C588.856506,934.103516 588.447388,934.354187 588.203857,934.365906 
	C587.602722,934.430969 587.061523,933.709656 586.721313,934.840820 
	C585.297119,935.854797 584.015381,936.551575 582.196472,936.804321 
	C578.616455,936.921997 576.166992,936.061401 576.259277,931.832275 
	C576.454346,931.273560 576.569702,931.065063 576.961182,930.632141 
	C582.305176,929.580383 585.473816,925.990479 588.825439,922.209900 
	C588.930786,921.906189 588.991943,921.441284 588.981934,921.206848 
	C590.359375,920.914978 591.746765,920.857605 593.550537,920.805176 
	C594.888306,921.815369 594.309204,923.066650 594.617981,924.527710 
	C595.766174,931.009766 593.287659,937.067627 594.514954,943.522095 
	C594.770508,944.018677 594.786255,944.201904 594.764038,944.658325 
	C593.764648,951.450012 591.935547,957.574951 586.500549,962.229492 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M566.061096,955.741699 
	C567.003784,958.757324 566.417725,960.423340 563.557556,961.877075 
	C556.110229,965.662170 548.227173,967.768066 539.664612,969.115356 
	C538.697815,969.434265 538.101746,969.531799 537.090820,969.129639 
	C536.533386,966.828125 539.931824,965.421265 538.401245,963.714478 
	C536.821533,961.952881 534.135864,963.303833 531.898010,963.459229 
	C529.317200,963.638428 526.813477,966.280396 524.048218,963.458496 
	C523.648621,962.087402 524.248535,961.411194 525.043274,961.196960 
	C533.522278,958.911377 541.723694,955.646973 550.750061,954.082397 
	C553.204590,955.130005 552.433899,956.573547 551.917847,958.136414 
	C551.190186,960.340393 552.717041,958.802063 553.579468,958.767456 
	C554.407654,958.472900 554.978699,959.088867 555.662842,958.373291 
	C556.024353,957.981628 556.229675,957.825195 556.428101,957.667114 
	C556.223022,957.825684 556.022888,957.984802 555.554565,958.251709 
	C555.112671,958.304016 554.923340,958.229187 554.505127,957.930725 
	C553.745178,956.950500 553.433350,956.119202 553.482056,954.840149 
	C554.235718,953.052124 555.679810,952.724365 557.298157,952.051514 
	C561.552307,952.061401 565.130127,949.690002 569.053772,950.657104 
	C568.882263,951.172119 568.784973,951.353760 568.539246,951.806396 
	C568.372986,952.289673 568.355164,952.501953 568.135132,952.958984 
	C566.973022,953.669678 566.117798,954.224731 566.061096,955.741699 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M558.252441,952.711548 
	C556.763611,953.476318 555.552734,953.991638 554.175720,954.789551 
	C553.678467,955.393250 553.283020,955.571594 552.505127,955.498413 
	C547.216980,954.272583 543.387817,957.822937 538.875977,958.688293 
	C534.009277,959.621643 529.270691,961.223633 524.223877,962.819580 
	C522.996094,963.206238 522.020813,963.307312 520.690186,963.503052 
	C518.097656,963.961365 516.053040,965.627380 513.222839,964.390869 
	C510.179260,962.357483 511.503601,961.433594 513.642090,960.745483 
	C525.026978,957.082275 536.153259,952.736145 547.507385,947.975403 
	C549.209717,946.883667 550.634338,946.072388 552.728455,946.194946 
	C553.558899,946.096252 553.721985,947.480408 554.596558,946.279663 
	C555.346741,945.554138 555.974548,945.401123 556.988892,945.667969 
	C559.458984,949.244080 562.383118,945.399353 565.046265,946.837402 
	C565.947754,949.492004 564.224976,950.308594 562.506165,950.813843 
	C561.100342,951.227112 559.684509,951.488953 558.252441,952.711548 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M530.416626,971.854614 
	C533.705994,973.950012 536.851807,972.895752 539.881653,972.467224 
	C545.298645,971.701050 550.567871,969.993103 556.530029,969.904907 
	C556.979858,970.383972 556.993530,970.846558 557.004700,971.653381 
	C553.449524,974.508545 548.916321,973.200623 545.067627,975.386230 
	C533.197632,976.100952 521.432861,976.255920 509.737335,978.741699 
	C510.705780,975.954285 510.705017,975.950745 518.815063,974.216858 
	C522.547607,973.418945 526.283752,972.638245 530.416626,971.854614 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M554.239685,947.148193 
	C552.162903,947.309570 550.396851,947.652527 548.241943,947.934448 
	C548.134033,945.777466 549.728943,944.904907 551.347839,943.966064 
	C555.643433,941.474915 559.927063,938.955505 563.940552,935.461548 
	C567.406616,932.099304 570.725952,929.091980 575.646484,927.958252 
	C577.220703,928.417603 578.843323,928.599670 577.295349,930.749695 
	C576.961060,930.958618 577.000000,930.997559 576.979370,930.980225 
	C573.883667,935.271240 568.768311,937.334290 565.469604,941.430176 
	C564.360229,942.807678 562.858704,943.877197 561.639465,945.688110 
	C560.341125,946.903259 559.141602,947.114319 557.496826,946.456177 
	C556.588135,946.256104 555.997192,946.281494 555.206482,946.539856 
	C554.854614,946.958496 554.702515,947.144165 554.239685,947.148193 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M490.647400,950.205444 
	C498.395599,949.641357 509.922180,959.160156 510.721954,966.698120 
	C504.643280,960.923645 499.634552,954.175232 491.385925,950.942383 
	C490.877563,950.779175 490.725464,950.641602 490.647400,950.205444 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M575.831299,928.850708 
	C571.027161,929.500977 569.020935,934.175110 564.495972,935.157471 
	C563.594604,934.535339 563.047791,933.880737 562.212769,933.072510 
	C566.295532,929.712708 571.413391,928.079590 576.725220,926.053162 
	C577.775879,927.251221 577.305420,928.091003 575.831299,928.850708 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M496.016846,958.986206 
	C490.067749,957.244324 484.529114,960.287476 478.375793,960.829285 
	C483.354980,956.545166 492.362946,955.386780 495.922607,958.672241 
	C495.973602,959.031006 496.001312,959.000061 496.016846,958.986206 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M482.276062,954.149536 
	C482.006531,953.583191 482.006866,953.124878 482.006805,952.322815 
	C483.929260,950.834473 486.049408,950.897583 488.576172,950.973389 
	C489.330933,951.037048 489.612213,951.213562 489.898926,951.737671 
	C487.490814,952.743958 485.018372,953.500732 482.276062,954.149536 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M512.928772,964.543701 
	C515.073181,963.872314 517.309631,963.555664 519.940552,963.418457 
	C518.201782,965.745911 515.934875,967.141968 512.928772,964.543701 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M536.441528,968.910461 
	C537.277344,968.911560 537.841492,968.966370 538.831177,969.065308 
	C538.603455,971.096619 537.048096,971.039124 535.040100,970.639954 
	C535.166992,969.971558 535.668518,969.467834 536.441528,968.910461 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M490.195709,951.868652 
	C489.649200,951.873474 489.395538,951.680359 489.091614,951.191284 
	C489.381317,950.639709 489.781708,950.304688 490.451752,949.938293 
	C490.785980,950.071167 490.850555,950.235474 490.972382,950.658203 
	C490.829132,951.194458 490.628632,951.472229 490.195709,951.868652 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M499.945435,986.947021 
	C500.069885,986.508118 500.230225,986.102478 500.390564,985.696777 
	C500.990723,986.027832 500.743652,986.401611 500.250977,986.910156 
	C500.056824,987.042297 499.981354,986.980164 499.945435,986.947021 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M497.546356,983.471802 
	C497.576508,983.523254 497.516205,983.420349 497.546356,983.471802 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M476.431763,961.534729 
	C476.369019,961.452209 476.612000,961.432068 476.612000,961.432068 
	C476.612000,961.432068 476.494476,961.617249 476.431763,961.534729 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M74.818237,860.233215 
	C79.663849,856.247437 89.921394,854.506531 93.986832,857.000610 
	C89.330223,860.804810 83.713547,863.072205 77.684448,865.324951 
	C74.602425,864.783813 74.712807,862.570129 74.818237,860.233215 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M74.795433,859.933472 
	C75.653503,861.659058 76.249718,863.344238 77.085602,865.223572 
	C74.372955,867.269287 71.018272,868.127502 67.707970,868.893921 
	C66.037064,869.280762 63.629322,871.101807 62.436733,868.632263 
	C61.412621,866.511658 64.611130,866.256592 65.473022,864.241821 
	C66.786232,862.805664 67.865051,861.793884 69.004654,860.502686 
	C70.112991,860.155029 71.160568,860.086792 72.603104,860.014160 
	C73.172256,860.020691 73.346458,860.031738 73.763237,859.944275 
	C74.181732,859.861572 74.357651,859.877380 74.795433,859.933472 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M60.489758,885.301025 
	C60.336605,886.957214 59.565048,887.130737 58.558857,886.376587 
	C57.967751,885.933350 57.918556,885.212769 58.395039,884.668335 
	C59.154770,883.800110 59.797840,884.337830 60.489758,885.301025 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M136.172119,834.309082 
	C136.252609,834.081787 136.621521,834.167664 136.795532,834.242493 
	C136.840134,834.546448 136.662857,834.729187 136.260757,834.941956 
	C136.083786,835.018433 136.091644,834.536316 136.172119,834.309082 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M409.830536,267.858368 
	C408.112000,267.052277 407.019012,265.897827 408.892273,264.965240 
	C411.498993,263.667542 414.390961,263.101685 417.308655,262.799591 
	C418.279938,262.699036 418.800415,262.960876 418.928436,264.033539 
	C419.105743,265.518890 418.845673,266.741913 417.195770,267.003082 
	C414.949310,267.358643 412.674133,267.532440 409.830536,267.858368 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M408.967407,268.217072 
	C409.249817,267.932526 409.409729,267.925812 409.451660,267.914551 
	C410.933990,269.576904 412.920990,268.620575 414.634003,268.981934 
	C415.825989,269.233337 417.537048,268.284668 418.093384,270.009521 
	C418.587952,271.542786 416.973114,272.229309 416.196625,273.562500 
	C415.771393,274.309692 415.260925,274.490356 414.310181,274.205872 
	C413.641357,272.166534 411.909973,272.177704 410.856689,272.184326 
	C407.690125,272.204163 407.641998,270.766693 408.967407,268.217072 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M432.271240,251.876129 
	C435.905701,251.717285 431.888062,254.870483 434.118835,255.178131 
	C433.706055,256.740479 432.516632,256.105560 431.824432,255.746933 
	C429.644684,254.617706 428.575165,257.946320 426.391724,256.927490 
	C425.628510,256.571350 424.173737,257.473175 423.764984,256.432983 
	C423.470886,255.684509 423.801941,254.145844 424.403961,253.696747 
	C425.919281,252.566422 425.542480,254.486053 426.093567,255.017380 
	C427.138855,256.025116 427.588348,254.865448 427.689941,254.217346 
	C428.110748,251.533432 430.216675,252.102524 432.271240,251.876129 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M381.466736,287.380127 
	C384.787201,288.140167 387.865479,286.367828 390.712036,288.811249 
	C386.264709,289.076080 381.817383,289.340881 376.818420,289.638550 
	C378.080627,287.173004 379.653320,287.503418 381.466736,287.380127 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M431.765808,263.171692 
	C429.697693,263.807892 426.847412,266.909363 426.984253,261.423462 
	C427.070374,261.061707 427.528992,261.003235 427.756775,260.963745 
	C429.094238,260.985565 430.203369,261.062317 431.313782,261.104767 
	C433.070892,261.171997 432.578278,262.009460 431.765808,263.171692 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M383.829041,301.845215 
	C384.404724,302.218384 384.650543,302.505859 384.896332,302.793365 
	C382.162567,303.085480 379.428833,303.377594 376.695068,303.669739 
	C378.758453,301.984406 380.875854,300.774780 383.829041,301.845215 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M378.488342,308.233704 
	C380.392853,308.207794 381.876404,307.036530 383.811371,307.936615 
	C382.008453,310.738007 379.886139,310.308136 377.606506,309.013763 
	C377.588623,309.003632 377.678925,308.736450 377.765686,308.626251 
	C377.862762,308.502991 378.013397,308.421936 378.488342,308.233704 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M413.602417,273.992004 
	C414.453064,273.973572 414.952332,273.969513 415.824829,273.928772 
	C416.968353,274.035248 418.136475,274.124115 417.338531,275.236237 
	C416.780243,276.014313 415.587677,277.488434 414.612152,276.236176 
	C413.027374,274.201721 412.543610,276.236023 411.246918,276.697388 
	C410.559052,276.190033 410.469360,275.634094 410.901398,274.713684 
	C411.877625,274.259918 412.564331,274.133148 413.602417,273.992004 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M384.528625,294.477692 
	C386.032257,294.802917 387.011963,295.449646 384.972382,295.794830 
	C382.468414,296.218628 379.890289,296.203918 377.298431,296.009613 
	C379.349091,294.268707 381.958099,295.297150 384.528625,294.477692 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M424.050934,274.598999 
	C426.122192,273.856659 427.852905,273.894745 430.001587,274.162567 
	C427.673126,276.654327 425.210724,276.207642 422.725525,275.642731 
	C422.789490,275.493927 422.815643,275.302460 422.925323,275.205170 
	C423.154327,275.001953 423.427429,274.848419 424.050934,274.598999 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M396.980225,261.489807 
	C397.995178,261.048187 399.043945,260.966919 400.486572,260.890900 
	C401.348816,261.415253 401.981232,261.513336 402.909698,261.737061 
	C403.269806,262.099731 403.347321,262.302185 403.210693,262.749451 
	C401.131653,261.937042 398.223236,266.336060 396.980225,261.489807 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M396.423431,283.431763 
	C395.185089,283.664062 394.075317,284.178772 393.498749,283.057037 
	C393.038055,282.160767 393.960754,281.976868 394.544220,281.873505 
	C395.650726,281.677460 397.384155,280.690765 396.423431,283.431763 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M441.329712,253.140320 
	C442.420288,255.913483 439.753998,254.936020 438.460510,255.803726 
	C438.208740,253.962265 438.895386,252.771912 441.329712,253.140320 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M410.816589,274.393250 
	C411.087738,274.898224 410.984558,275.409760 410.881165,276.314880 
	C409.737183,277.075623 408.443054,277.473694 408.181549,275.769745 
	C407.886353,273.846191 409.285950,274.207123 410.816589,274.393250 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M400.934265,282.080750 
	C402.301056,281.478027 402.964020,279.782257 404.532043,280.596985 
	C404.716492,280.692810 404.808746,281.211029 404.749023,281.492065 
	C404.362823,283.310089 402.953369,283.018219 401.278137,282.893555 
	C400.837616,282.663391 400.774567,282.473083 400.934265,282.080750 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M378.238251,282.663696 
	C379.679901,281.729553 381.357330,281.661346 383.164795,282.474426 
	C381.578217,283.398132 380.019348,283.029480 378.238251,282.663696 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M426.823334,270.810791 
	C426.924042,271.147888 426.870422,271.380249 426.883026,271.499146 
	C425.838379,272.254700 424.742737,272.389526 423.243866,271.730804 
	C424.326416,270.705475 425.007629,269.432800 426.823334,270.810791 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M402.095886,274.173889 
	C403.294037,272.857086 404.063721,273.849396 404.855164,274.449249 
	C404.945770,274.517914 404.665741,275.452026 404.395966,275.552948 
	C403.361267,275.940063 402.662109,275.275421 402.095886,274.173889 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M372.719055,286.479675 
	C372.001648,284.485931 371.389893,282.355438 373.292969,280.283813 
	C374.000671,282.259460 373.654510,284.324005 372.719055,286.479675 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M400.984863,281.624084 
	C401.103119,282.038361 401.049225,282.197968 400.948029,282.605652 
	C400.360565,283.159637 399.820435,283.465576 399.280334,283.771515 
	C399.149048,283.382782 398.881592,282.983124 398.911835,282.607422 
	C399.005493,281.443176 399.524536,280.774475 400.984863,281.624084 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M414.645752,281.974060 
	C413.521271,281.933411 412.728943,281.892426 411.185547,281.812622 
	C413.253113,280.842621 414.586609,280.784363 415.945587,281.377106 
	C415.965363,281.385773 415.935638,281.644745 415.879120,281.668610 
	C415.587677,281.791565 415.279968,281.875916 414.645752,281.974060 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M407.449371,286.190247 
	C408.351318,285.741486 409.063934,285.646088 409.416718,286.326721 
	C409.522461,286.530823 409.049713,287.245331 408.687836,287.441284 
	C407.651154,288.002533 407.207520,287.465973 407.449371,286.190247 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M375.678833,319.596924 
	C376.599640,319.322449 377.125793,319.486725 376.933838,320.320953 
	C376.881409,320.548859 376.569763,320.847778 376.342682,320.881317 
	C375.540955,320.999756 375.321381,320.525299 375.678833,319.596924 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M409.602570,281.502319 
	C409.852325,282.267273 409.616394,282.651031 409.039795,282.608612 
	C408.828583,282.593048 408.642181,282.240601 408.444458,282.041840 
	C408.766998,281.794678 409.089539,281.547485 409.602570,281.502319 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M403.287689,263.019409 
	C402.967194,262.824738 402.937744,262.655212 402.915344,262.227661 
	C402.771332,261.798065 402.620270,261.626495 402.729736,261.231964 
	C402.990265,261.009003 402.999176,261.000885 403.004456,260.997742 
	C403.720490,261.507172 404.431244,262.019775 405.141998,262.532410 
	C404.620911,262.703125 404.099854,262.873840 403.287689,263.019409 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M396.782532,275.288788 
	C397.006592,276.246460 396.790466,276.799133 395.965729,276.698334 
	C395.742493,276.671112 395.400787,276.343506 395.382996,276.131165 
	C395.316193,275.334259 395.872864,275.087860 396.782532,275.288788 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M420.381470,283.451355 
	C419.588440,283.675903 419.295044,283.405304 419.421326,282.784576 
	C419.447418,282.656433 419.628723,282.485565 419.758759,282.465454 
	C420.381439,282.369019 420.644379,282.668640 420.381470,283.451355 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M398.422668,275.402527 
	C398.623169,275.384766 398.689911,275.481354 398.756683,275.577942 
	C398.600769,275.557587 398.444824,275.537262 398.422668,275.402527 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M234.869476,487.059204 
	C236.417938,485.923767 237.608475,484.515350 239.510162,485.895874 
	C243.347015,492.413605 241.078445,497.335938 237.255203,502.869354 
	C230.506897,512.636353 221.626923,520.570496 214.859787,530.270386 
	C213.458618,532.278809 211.685806,534.169434 208.645172,534.739502 
	C204.278030,532.857910 204.110855,529.048218 203.615295,525.457397 
	C203.365097,523.644409 203.546387,521.796509 203.693268,519.587524 
	C204.233398,516.595032 205.612442,514.496216 207.428391,512.746033 
	C206.165146,513.405762 205.458725,515.148132 203.362762,515.115112 
	C200.484177,515.251526 199.298477,513.695068 199.144958,511.525024 
	C198.941879,508.654205 198.267365,505.680603 201.230026,503.370728 
	C203.777542,501.384491 206.972382,501.063873 209.626999,499.390381 
	C210.921341,498.574371 212.204620,498.031525 212.727905,496.108154 
	C212.785995,495.749847 212.841354,495.779358 212.858383,495.805725 
	C216.135895,494.841736 219.065521,492.925476 222.708038,492.102356 
	C222.925308,491.808411 222.997498,491.871002 222.949738,491.870911 
	C225.183990,491.276642 227.416183,490.550323 229.675201,489.090881 
	C229.866013,488.792664 229.948257,488.830811 229.930878,488.872681 
	C231.430496,488.191132 233.236328,488.348572 234.869476,487.059204 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M202.876114,515.297852 
	C205.750961,513.962158 206.673584,509.936401 210.848389,510.291565 
	C208.787659,512.920532 207.042801,515.146545 205.148132,517.672913 
	C203.933441,520.033752 202.818069,522.050476 201.552658,524.011780 
	C197.039154,531.007385 192.595963,538.023132 190.104034,546.116882 
	C187.597366,554.258545 181.703934,560.441040 176.940567,567.233826 
	C174.718613,570.402344 172.689438,573.557983 171.204681,577.470703 
	C168.471527,572.445129 169.633316,567.121094 170.799988,561.839539 
	C171.403229,559.108704 172.333374,556.450073 173.081482,553.043213 
	C173.212814,551.727295 173.495361,551.170105 173.787781,550.289551 
	C173.949249,549.804199 174.014954,549.610596 174.184952,549.129028 
	C174.504501,548.267029 174.735931,547.699097 175.035858,546.823120 
	C175.222305,546.335144 175.306122,546.142334 175.541931,545.670532 
	C175.806076,545.209656 175.918228,545.027649 176.372238,544.292419 
	C177.890884,541.591858 178.922562,539.353271 180.827759,537.269653 
	C181.036942,537.006714 181.001175,536.991943 181.002686,537.011230 
	C181.224258,536.788757 181.451630,536.554016 181.865204,536.158813 
	C182.044113,535.991272 181.991013,535.993896 181.997498,536.019653 
	C182.445541,535.582397 182.500122,534.946411 182.968002,534.188599 
	C185.698532,533.111633 186.786163,530.698242 188.416107,528.947205 
	C192.876938,524.154846 197.747513,519.835205 202.876114,515.297852 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M161.736893,627.307922 
	C161.442459,627.771057 161.076584,627.850159 160.430801,627.894165 
	C157.375702,609.652222 157.171509,591.281494 156.393036,572.659424 
	C156.374695,568.666138 154.886627,564.794495 157.486877,561.152283 
	C160.042145,563.865356 157.434235,566.310547 157.566895,568.899658 
	C158.450546,567.667175 157.742035,565.877197 158.528351,564.460510 
	C159.294266,563.080505 159.403091,560.643799 161.426392,561.052490 
	C163.601318,561.491699 162.625519,563.660156 162.499252,565.242004 
	C162.343430,567.193970 161.108383,569.003906 161.946899,571.346741 
	C162.554993,572.219543 162.878113,572.848145 163.365891,573.788025 
	C161.972733,583.948669 161.756729,593.854126 162.091415,603.818054 
	C162.268051,609.076294 160.287430,614.207397 160.727127,619.573730 
	C160.930054,622.050659 160.980057,624.518677 161.736893,627.307922 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M161.399750,572.795776 
	C158.254181,569.221191 162.480331,565.592041 161.461502,561.495178 
	C158.856598,563.949341 159.668457,567.670898 157.513855,570.323608 
	C156.328323,567.198364 157.541153,564.546997 157.869293,561.456726 
	C158.989426,549.126892 167.372208,538.618042 178.404572,531.205872 
	C179.067810,533.702209 176.102798,534.373657 176.015732,536.636963 
	C176.811829,537.886597 176.528351,538.842468 175.971054,539.691528 
	C169.760635,549.153381 165.099884,559.265503 162.920959,570.439026 
	C162.763000,571.248962 162.284546,571.953064 161.399750,572.795776 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M161.397369,573.167969 
	C163.212097,560.070557 168.210800,548.312012 175.917725,537.318359 
	C176.802185,537.276062 177.622086,537.571594 178.731049,538.033447 
	C179.628403,538.792114 179.463104,539.422241 178.881836,540.318237 
	C178.492889,540.739624 178.333313,540.904297 177.737198,541.601074 
	C174.098526,546.925781 172.158600,552.349731 169.833206,557.754639 
	C168.010895,563.214661 165.982315,568.397705 163.748169,573.836670 
	C162.927795,573.829712 162.313019,573.566895 161.397369,573.167969 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M143.355743,564.071899 
	C143.087219,563.199890 143.049683,562.436035 143.100861,561.297607 
	C144.617889,561.262207 146.031555,561.696167 147.477737,561.919678 
	C149.995667,562.308838 150.734558,563.763794 149.218063,565.624451 
	C147.756851,567.417236 148.145309,569.302673 147.979553,571.636780 
	C146.528107,571.935852 145.927246,571.103455 145.989075,569.360352 
	C146.987427,567.580872 146.387863,566.010803 146.182068,564.249451 
	C145.186798,564.315125 144.433167,564.864197 143.355743,564.071899 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M178.027618,540.139648 
	C178.497910,539.565369 178.738785,539.132385 178.999893,538.449585 
	C179.506409,537.863892 179.992722,537.527893 180.757996,537.099304 
	C180.543015,539.851990 178.946106,542.200073 177.305588,544.850525 
	C175.991592,544.077576 176.097305,542.947571 176.781113,541.385620 
	C177.008850,541.003906 177.000000,541.000000 177.001984,541.003601 
	C177.252258,540.747070 177.517807,540.505798 178.027618,540.139648 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M182.903870,534.128418 
	C182.965317,534.551453 182.736359,535.119812 182.255707,535.866821 
	C182.207153,535.454895 182.410294,534.864319 182.903870,534.128418 
z"/>
<path fill="#EFEEDA" opacity="1.000000" stroke="none" 
	d="
M209.335754,496.215454 
	C209.307678,496.054260 209.515472,495.829926 209.851120,495.744324 
	C209.978973,495.883057 209.571625,496.152374 209.335754,496.215454 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M181.808868,536.094116 
	C181.859787,536.278564 181.675461,536.565857 181.247665,536.941895 
	C181.194000,536.752686 181.383804,536.474792 181.808868,536.094116 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M189.861526,761.643921 
	C190.311325,766.557739 191.589050,770.966125 192.737503,775.576538 
	C190.660126,775.402893 191.259552,773.918762 190.349457,773.088013 
	C187.762726,761.148376 185.396027,749.448364 183.068604,737.343933 
	C183.318680,736.790466 183.529465,736.641418 184.057037,736.715027 
	C187.229416,744.818420 187.518402,753.260437 189.861526,761.643921 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M284.745941,726.891418 
	C284.259094,727.145142 283.875305,727.057373 283.197327,726.931030 
	C283.216797,725.843079 281.374878,724.329895 282.920074,723.893921 
	C284.306976,723.502625 285.204742,724.904907 284.745941,726.891418 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M184.302551,736.568237 
	C184.162796,736.944519 183.951767,736.951233 183.424316,736.948792 
	C183.004059,735.879883 182.900223,734.820251 182.881744,733.368896 
	C184.507309,733.612061 183.893417,735.092102 184.302551,736.568237 
z"/>
<path fill="#F5F5D5" opacity="1.000000" stroke="none" 
	d="
M605.735962,679.666748 
	C616.826477,683.481506 622.831421,691.204407 625.035828,702.512573 
	C624.442810,703.515381 623.771179,703.790527 622.615356,703.798340 
	C620.573669,703.338623 619.078735,702.458862 617.119385,701.770874 
	C609.418945,697.145203 601.767090,693.051819 596.311157,686.046387 
	C594.396606,683.588013 592.023865,684.215759 589.537415,685.144226 
	C584.742188,686.934753 580.217651,689.600037 574.536133,689.784180 
	C567.320190,689.004395 560.793213,691.382812 554.054565,691.770630 
	C551.454041,691.920227 548.823059,692.489807 546.191284,692.368042 
	C541.327515,692.143188 536.647156,692.697815 531.916626,695.179382 
	C531.070435,695.616272 530.552124,695.760498 529.615845,695.836243 
	C526.095581,695.167664 523.026367,695.282227 519.928101,696.170959 
	C513.762573,697.939453 507.402374,698.998291 501.010742,701.327515 
	C500.430176,701.491211 500.202759,701.566040 499.633453,701.735718 
	C498.393005,702.045044 497.484894,702.217773 496.256958,702.524170 
	C495.696747,702.618774 495.470367,702.640381 494.904358,702.656006 
	C492.236267,702.475708 490.144226,703.077576 488.020386,704.757507 
	C480.505737,707.351135 473.163727,709.250732 465.341492,710.421692 
	C457.260834,712.416748 449.519806,714.590942 441.403442,716.767456 
	C440.632721,716.649902 440.543976,715.656006 439.959320,716.255188 
	C439.513672,716.711853 439.895569,715.920837 440.112793,716.723267 
	C439.643158,717.057373 439.310394,717.153931 438.717285,717.235596 
	C438.084930,717.190369 437.752411,717.290833 437.236877,717.677002 
	C436.838989,717.876648 436.663635,717.921448 436.217163,717.978577 
	C435.848969,718.126526 435.751984,718.262146 435.411316,718.341553 
	C432.086761,719.199890 429.005890,720.114441 425.538635,721.063110 
	C424.334473,721.642273 423.352814,721.379578 422.283752,721.925720 
	C415.752716,724.475342 409.405823,726.706848 402.339569,727.827881 
	C401.378265,727.082458 400.813110,726.333130 400.131653,725.324585 
	C401.084076,724.634338 402.152771,724.203308 403.568909,723.734375 
	C404.516663,723.934143 405.076508,723.904602 405.787659,723.234802 
	C419.232117,717.558167 433.164734,714.179443 446.599335,709.330505 
	C468.109802,701.566833 490.152710,695.727417 512.364624,690.347656 
	C533.675903,685.185974 555.115417,680.726074 576.650818,676.668518 
	C581.423279,675.769348 586.228577,675.435791 591.537476,675.851685 
	C592.665466,675.909546 593.330627,676.031494 594.334290,676.139343 
	C595.253174,676.310181 595.828613,676.514587 596.716125,676.707764 
	C597.411072,676.971924 597.830200,677.105652 598.578979,677.265259 
	C601.393494,677.089722 603.542114,677.918823 605.735962,679.666748 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M464.780945,650.336731 
	C467.824402,648.257141 470.664825,646.479736 473.661438,644.304565 
	C471.228546,643.992432 473.365234,642.438049 473.219788,641.434692 
	C473.528076,640.979553 473.678833,640.820068 474.114136,640.504883 
	C474.796600,640.230591 475.202179,640.160461 475.901855,640.184326 
	C476.532654,640.296509 476.880829,640.375793 477.475647,640.399902 
	C478.036133,640.231995 478.359802,640.144409 478.941345,640.129639 
	C480.048767,639.689758 480.906647,639.207886 482.055389,638.800659 
	C484.893646,638.028015 485.019592,640.242432 485.548645,641.601501 
	C491.138702,655.962463 497.340088,670.051819 504.117554,683.889832 
	C504.640259,684.957031 504.967499,686.049500 504.309296,687.559998 
	C499.739044,689.041443 495.387939,690.198242 490.666687,691.487610 
	C483.851044,691.362671 480.835052,686.466003 477.937469,681.914062 
	C472.560760,673.467590 468.964172,664.091553 464.850983,654.995605 
	C464.234039,653.631287 463.883667,652.139282 464.780945,650.336731 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M523.765991,647.765930 
	C522.615906,652.041748 521.220886,656.075806 519.726440,660.478088 
	C520.020264,665.836304 520.414612,670.826294 519.388794,676.169556 
	C519.286743,677.033386 519.207703,677.522705 519.026306,678.368042 
	C518.774414,679.437866 518.487488,680.117004 518.322205,681.206665 
	C518.107666,682.298950 517.839111,682.977173 517.006714,683.701538 
	C514.252808,686.795959 513.211609,685.133240 512.175293,682.625610 
	C506.700195,669.377258 501.160095,656.155762 495.503235,642.573242 
	C496.423309,641.014709 494.826172,639.777954 495.569397,638.274658 
	C495.928650,637.871704 496.123688,637.759766 496.658752,637.654297 
	C498.340515,638.028015 499.233582,640.886108 501.306030,638.129272 
	C502.009186,637.350525 502.586945,636.963257 503.516174,636.468994 
	C504.055328,636.238953 504.277435,636.162598 504.842896,636.008545 
	C506.581421,635.740417 507.976593,635.768250 509.712402,635.998779 
	C510.269501,636.145325 510.485962,636.223572 510.999878,636.473145 
	C512.009216,637.204407 512.614563,637.867798 513.323730,638.837524 
	C513.801086,639.327148 513.174866,640.033325 513.912720,639.997803 
	C513.997131,639.993652 514.039001,639.437073 514.171814,638.821655 
	C514.388977,638.323975 514.511658,638.136841 514.911743,637.749634 
	C517.628723,636.879089 519.560120,638.599182 521.748108,639.085754 
	C523.219421,639.412964 524.017578,641.939209 522.941589,642.695557 
	C519.655762,645.005127 522.555481,646.041504 523.765991,647.765930 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M464.629883,650.072632 
	C469.745300,663.942566 474.932251,677.588562 484.972076,688.838501 
	C486.536591,690.591675 488.979950,688.938965 490.080811,691.382874 
	C482.418640,694.896057 473.998138,696.282837 465.487854,698.668762 
	C464.523071,698.450195 464.220459,697.986511 464.198578,697.073364 
	C463.580811,695.059143 462.902313,693.333008 462.117828,691.274414 
	C462.608337,690.396118 462.498077,689.674622 462.528564,688.624695 
	C463.678345,684.151794 461.156219,680.695007 460.480164,676.903442 
	C460.109070,674.822510 459.358368,672.818726 459.103271,670.346558 
	C457.679932,664.909363 456.243896,659.834961 454.842041,654.357666 
	C458.064148,652.807190 461.385406,651.985718 464.629883,650.072632 
z"/>
<path fill="#F7EBCF" opacity="1.000000" stroke="none" 
	d="
M504.519348,687.932129 
	C503.519226,683.841309 501.013062,680.578735 499.327118,677.057495 
	C493.383118,664.643250 488.331543,651.869629 482.727722,639.017578 
	C483.603729,636.946350 484.861237,635.017395 486.391113,632.670654 
	C490.300385,639.306152 492.742523,645.980774 495.456360,652.505798 
	C499.729004,662.778809 503.726868,673.165833 507.893433,683.483459 
	C509.119141,686.518677 508.762421,688.334290 504.519348,687.932129 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M474.825531,640.962891 
	C474.497070,641.153015 474.534180,641.042175 474.586853,641.067505 
	C474.362518,641.235229 474.085541,641.377686 473.356873,641.398315 
	C470.577271,638.015869 469.954132,634.528503 471.681885,630.324219 
	C472.305786,629.567200 472.753113,629.237793 473.485077,628.876709 
	C473.999512,629.126953 474.291901,629.292908 474.827240,629.122314 
	C474.997314,628.920898 474.984497,628.991333 474.950562,628.979980 
	C475.174469,628.761719 475.426239,628.546875 475.641785,628.298096 
	C479.947113,623.329468 479.937073,623.332703 482.146271,629.124878 
	C482.437897,629.889465 482.918701,630.581421 483.079803,631.766235 
	C481.745453,633.704895 480.369507,635.292542 478.947754,637.187134 
	C478.290314,639.315979 477.133728,640.514893 474.825531,640.962891 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M416.442627,690.347656 
	C414.067505,688.190247 411.955078,686.102051 409.546692,684.028809 
	C409.046356,683.802551 408.841980,683.561462 408.815979,682.880981 
	C408.994293,682.441711 409.222961,682.068237 409.332153,682.039307 
	C410.256775,681.738220 410.540070,681.152649 410.359131,679.972900 
	C410.293732,678.514221 410.794617,677.754333 412.173309,677.291199 
	C416.099274,678.248718 417.692291,680.515137 416.641083,684.191101 
	C416.325745,685.293884 417.336151,684.226685 417.315430,684.993286 
	C418.165161,690.037903 421.411896,693.747986 422.906616,698.585510 
	C422.561035,699.447144 422.080536,699.811279 421.146454,699.980408 
	C418.008362,698.091675 418.666595,694.492493 416.979553,691.657043 
	C417.138336,690.919128 417.060333,690.624756 416.442627,690.347656 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M495.922546,623.061829 
	C496.433167,616.776001 492.497955,611.827393 491.777893,605.749390 
	C492.502289,601.604126 495.625031,604.708130 497.578064,603.575012 
	C498.274628,604.006409 498.684662,604.487488 498.540680,604.886719 
	C498.009796,606.358765 498.438141,607.423401 499.671844,608.595276 
	C497.093872,610.210510 499.946045,611.471252 499.650146,613.043213 
	C499.489532,613.701660 499.399963,614.068848 499.434265,614.705383 
	C499.866302,615.631226 500.218292,616.296631 500.371979,617.335754 
	C500.267517,617.998047 500.075317,618.316467 500.030823,618.699707 
	C500.386169,619.017883 500.481995,619.198792 500.628601,619.692566 
	C500.656433,620.447754 500.545502,620.868408 500.167175,621.553223 
	C498.905823,622.845337 497.721436,623.541016 495.922546,623.061829 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M521.801758,673.347534 
	C523.579834,672.026245 522.545715,668.118530 526.124573,669.504761 
	C529.128845,670.668335 529.236023,672.928894 528.284058,675.556152 
	C527.505798,677.703918 526.771973,679.867798 525.957642,682.376953 
	C525.474243,682.827942 525.051758,682.926453 524.321594,683.131592 
	C519.969666,684.295166 519.851562,684.156860 519.754883,677.779663 
	C520.071899,675.983215 520.503174,674.675964 521.801758,673.347534 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M483.388489,631.956177 
	C481.245697,630.297668 478.756836,628.762634 480.663269,625.401062 
	C477.729279,625.534729 477.925140,628.847961 475.260254,628.929810 
	C474.345001,626.104858 477.597870,625.106506 478.003235,622.346802 
	C478.034210,621.989563 478.009430,622.023315 477.988464,622.025269 
	C477.967499,622.027283 478.308716,621.738831 478.516113,621.821899 
	C480.488892,623.004089 485.024109,619.722656 483.999451,625.620728 
	C484.448822,626.000488 484.895233,625.998474 485.676453,625.997559 
	C486.052612,626.315918 486.093872,626.633179 486.126953,627.430664 
	C486.321167,629.854614 484.660004,630.616638 483.388489,631.956177 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M417.905884,685.200562 
	C416.314240,685.392517 415.228333,685.504211 413.629333,685.668762 
	C417.770691,682.975647 415.167175,680.728088 413.453735,678.175598 
	C412.449860,677.467468 412.308807,676.753174 412.661957,675.602417 
	C413.452332,673.853271 414.428711,672.992004 416.390350,673.019165 
	C416.839294,673.156006 416.939087,673.301636 417.026550,673.711670 
	C417.709900,674.708313 417.350647,675.701843 417.917297,676.734558 
	C418.519470,677.567017 418.851776,678.197815 419.183777,679.106567 
	C419.426239,680.813660 419.543091,682.283630 420.764282,683.739380 
	C421.140503,684.118591 421.264221,684.235413 421.428711,684.604248 
	C420.450165,684.944275 419.430878,685.032349 417.905884,685.200562 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M520.813354,676.762573 
	C521.069519,678.499695 521.026611,679.993408 520.879883,681.476807 
	C520.677124,683.527649 521.765625,683.653687 523.658630,683.219727 
	C522.156189,686.277832 519.885620,686.273926 516.999390,684.000000 
	C516.790466,683.131531 516.908997,682.408264 517.142456,681.336609 
	C517.591553,680.532166 517.875000,680.055847 517.820862,679.186951 
	C517.798035,678.474976 517.822632,678.039246 517.971802,677.297668 
	C518.794617,676.374512 519.588928,676.233887 520.813354,676.762573 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M498.934570,603.783569 
	C496.514526,604.973022 494.276550,604.556824 491.938538,605.093384 
	C491.754211,605.370789 491.424072,605.152039 491.245056,605.067505 
	C491.070587,604.241943 491.075104,603.500916 491.075684,602.383301 
	C491.240692,601.990356 491.409637,601.973999 491.825684,601.896484 
	C493.575104,599.501526 495.822876,599.787903 498.462524,600.316284 
	C499.807007,601.404297 499.875763,602.432678 498.934570,603.783569 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M491.682861,629.165833 
	C491.208221,626.498169 493.746399,626.005920 494.590698,624.126587 
	C496.890991,622.937256 497.457947,624.218811 497.831360,626.239258 
	C497.299164,628.721375 496.707733,630.703857 493.622070,630.713745 
	C492.647491,630.398315 492.194183,630.045349 491.682861,629.165833 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M497.464844,627.474365 
	C497.186829,625.716553 497.049683,624.590576 495.239685,624.036011 
	C494.998352,623.659790 495.108734,623.351074 495.443970,622.928101 
	C496.998108,622.267639 498.327332,621.721497 500.005066,621.074707 
	C500.570892,620.928650 500.788147,620.883240 501.248596,621.067200 
	C501.706573,621.692749 501.852020,622.113525 501.966370,622.891113 
	C501.980042,623.678162 501.927277,624.124817 501.750061,624.894287 
	C500.909088,626.797485 500.595428,628.976379 497.464844,627.474365 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M567.264587,674.977905 
	C567.590698,671.714539 568.463379,668.549927 570.656738,665.235352 
	C571.437195,668.925049 569.073669,671.347717 568.995850,674.594727 
	C568.523010,674.986206 568.065613,674.990295 567.264587,674.977905 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M496.183655,637.754883 
	C495.655151,639.319885 496.859619,640.644653 495.658813,642.077576 
	C494.611298,640.359070 493.858582,638.496582 493.165070,636.290649 
	C493.387146,635.819641 493.550049,635.691956 494.019196,635.505249 
	C494.531250,635.481750 494.737061,635.517273 495.216156,635.708008 
	C495.964050,636.305298 496.271454,636.835510 496.183655,637.754883 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M491.221191,628.795532 
	C491.950226,629.023193 492.367462,629.289062 492.959747,629.880737 
	C493.420166,630.568848 493.544067,630.983032 493.434265,631.763489 
	C493.103302,632.475586 492.802368,632.803406 492.106018,633.145630 
	C490.986328,631.858459 489.402557,630.651855 491.221191,628.795532 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M491.850159,633.537720 
	C492.008820,632.926270 492.239868,632.630737 493.047638,632.258911 
	C493.810608,632.319946 493.996826,632.457153 494.373596,632.884766 
	C494.625549,633.397949 494.686981,633.620911 494.744659,634.190186 
	C494.621735,634.987366 494.409882,635.387695 493.780579,635.878296 
	C493.470917,636.027344 493.344971,635.995911 493.284607,635.971619 
	C492.308411,635.549072 492.071198,634.728882 491.850159,633.537720 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M474.697327,641.495728 
	C475.485352,639.750000 476.664429,638.554688 478.552246,637.622253 
	C478.888336,637.844482 478.874786,638.194946 478.931000,639.279358 
	C479.000763,640.013367 479.082123,640.108887 479.136475,640.140259 
	C479.128021,640.516846 478.942169,640.772705 478.397339,641.001343 
	C477.868042,641.172791 477.574646,641.282166 476.823242,641.495667 
	C475.876038,641.679382 475.386810,641.758911 474.697327,641.495728 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M405.714752,722.989746 
	C405.898560,723.891052 406.233521,725.009338 405.184631,725.424500 
	C404.459503,725.711426 404.221741,724.927551 403.971558,724.022461 
	C404.419464,723.449646 404.922577,723.202820 405.714752,722.989746 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M421.000061,700.343872 
	C421.333008,699.664062 421.826935,699.323914 422.637878,698.968628 
	C422.954865,698.953369 423.187103,699.105408 423.128052,699.229980 
	C422.964905,700.561218 422.537628,701.303833 421.000061,700.343872 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M464.109741,696.904907 
	C464.526031,697.241943 464.792694,697.698486 465.089447,698.426575 
	C464.870422,699.029236 464.621277,699.360413 464.073608,699.798462 
	C463.775116,699.905334 463.863403,699.421448 463.870819,699.175598 
	C463.603180,698.614624 463.456635,698.248047 463.548248,697.545288 
	C463.658386,697.260376 463.960144,697.024475 464.109741,696.904907 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M478.943237,639.906738 
	C478.858337,639.904236 478.734436,639.777832 478.695007,639.613464 
	C478.760925,639.592651 478.885742,639.800171 478.943237,639.906738 
z"/>
<path fill="#E4E1C4" opacity="1.000000" stroke="none" 
	d="
M390.026703,686.786682 
	C389.739685,686.936340 389.417023,686.719727 389.044678,686.206787 
	C389.524384,685.694824 389.867126,685.843811 390.026703,686.786682 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M538.267761,266.257874 
	C537.981934,259.918640 537.859863,253.836273 538.796387,247.381561 
	C538.926575,246.974335 550.157715,247.430435 550.157715,247.430435 
	C554.117371,247.391129 558.069580,247.727386 561.999817,248.054138 
	C564.521667,248.263779 566.441223,248.100937 568.146301,245.980927 
	C570.089844,243.564514 572.401062,243.774048 574.598816,245.846619 
	C576.581665,247.716461 578.331482,247.993622 581.211548,246.837570 
	C584.979370,245.325195 589.203613,247.438583 593.268738,247.331711 
	C593.721375,247.319809 594.379822,248.249756 594.409119,247.675674 
	C594.699402,241.983246 597.515564,245.306198 599.583801,246.182449 
	C602.266663,247.319138 605.047913,245.778656 608.017944,246.796051 
	C608.783325,247.637405 609.038330,248.342087 609.250366,249.466827 
	C609.369568,251.104630 609.350464,252.358337 608.957031,253.931244 
	C609.417908,255.172668 606.783264,254.505432 608.333252,256.031982 
	C609.028076,257.174561 609.054138,258.101990 608.646118,259.385803 
	C608.301758,259.881104 608.117310,260.044128 607.570557,260.136292 
	C605.153931,263.887543 604.104370,267.890015 605.016602,272.642151 
	C603.114380,270.419250 600.406677,270.666626 597.807251,271.263458 
	C593.198608,272.321564 588.708374,272.080444 584.062439,271.288605 
	C578.744019,270.382172 573.103027,270.746246 567.950867,271.393250 
	C560.008789,272.390625 552.070984,271.055359 544.194214,272.550446 
	C539.950989,273.355896 538.751587,270.121857 538.267761,266.257874 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M384.801941,580.343079 
	C385.467957,579.741089 385.889526,579.404968 386.472137,578.844849 
	C387.052124,578.328674 387.471100,578.036499 388.028381,577.529175 
	C388.512177,584.248291 379.412384,590.989563 373.088989,588.430481 
	C371.571228,587.816223 370.170532,586.912781 368.079742,586.009644 
	C366.910065,585.647217 366.456726,585.297852 365.804291,584.735535 
	C365.310486,584.284302 365.038635,584.015015 364.569641,583.534058 
	C364.101746,583.045044 363.850861,582.749939 363.448608,582.201294 
	C363.021912,581.439270 362.856110,580.872681 362.378906,580.133301 
	C358.673004,573.818665 356.160797,567.298767 353.744568,560.312256 
	C353.862030,559.837585 354.087494,559.740356 354.622803,559.842163 
	C358.684814,566.448792 361.844208,573.254639 367.206177,578.589661 
	C372.851532,584.206665 377.489319,584.725403 384.801941,580.343079 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M334.499481,541.872314 
	C338.307861,552.563538 340.049500,563.427246 342.411621,574.593323 
	C340.897034,573.947021 339.880096,573.472229 339.955566,576.344421 
	C340.142944,583.475403 340.090576,590.615479 339.983429,597.749573 
	C339.958069,599.436340 340.803680,601.453552 338.478424,602.818787 
	C338.383911,587.781982 338.150177,572.720398 335.731781,557.426025 
	C334.943146,552.315125 334.294861,547.537476 333.546448,542.327026 
	C333.693146,541.808044 333.939972,541.721863 334.499481,541.872314 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M354.387085,584.268799 
	C353.886444,579.746338 353.245850,575.578613 352.773315,570.953613 
	C356.503418,576.343994 359.540161,591.716553 358.025116,596.515015 
	C356.194183,595.205322 357.551697,593.002991 356.286072,591.263550 
	C354.356903,589.169739 353.870880,587.017090 354.387085,584.268799 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M354.155762,584.018372 
	C355.013580,586.021362 355.500153,588.128662 356.006622,590.613892 
	C354.702972,592.624146 353.053741,593.406616 350.506500,592.852783 
	C349.708405,590.774292 349.331726,588.788574 348.953766,586.417297 
	C350.563141,585.395447 352.173798,584.759094 354.155762,584.018372 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M362.158325,580.267517 
	C363.049683,580.037354 363.698303,580.400452 363.955139,581.567383 
	C364.228271,582.208618 364.523926,582.509827 365.151489,582.895874 
	C365.636963,583.058228 365.786469,583.160461 365.946045,583.452881 
	C366.297180,584.409119 366.656219,585.192627 367.767853,585.803589 
	C368.036957,585.986755 367.995361,585.987000 368.003967,585.967773 
	C369.500702,589.796570 370.783936,590.958740 376.381348,593.527832 
	C371.851013,596.005005 363.657379,588.626282 362.158325,580.267517 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M354.929810,559.694336 
	C354.717499,560.028992 354.502350,560.016663 353.961884,559.969604 
	C350.522736,559.888794 352.148468,562.254578 352.207489,563.326233 
	C352.322235,565.407410 353.309326,567.418274 352.994324,570.044189 
	C349.773956,565.344360 350.650696,559.457275 349.905579,553.417603 
	C350.305389,552.619812 350.768616,552.453857 351.659668,552.589355 
	C352.158844,552.926331 352.295197,553.142395 352.217682,553.676575 
	C351.930664,556.350952 354.539124,557.242798 354.929810,559.694336 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M343.210571,575.278809 
	C346.758392,575.112854 346.907806,577.671875 346.962067,580.680054 
	C343.631714,580.687744 344.047028,577.726440 343.210571,575.278809 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M350.118164,592.898132 
	C350.049591,594.378479 349.925354,595.837769 349.774689,597.607178 
	C348.523010,595.968079 349.074768,594.600159 349.784668,592.998535 
	C350.085083,592.760071 350.062439,592.877014 350.118164,592.898132 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M347.117859,583.272217 
	C348.031677,583.092102 348.772522,583.432068 348.882416,584.820068 
	C348.007599,584.948608 347.251251,584.622131 347.117859,583.272217 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M324.168152,539.680054 
	C322.355743,540.972900 323.517334,542.853210 322.202881,544.540466 
	C318.946838,535.538940 319.569000,525.971252 315.583130,517.252075 
	C314.930542,516.883667 314.648102,516.626343 314.437561,515.941772 
	C314.442810,515.433716 314.481506,515.230713 314.650604,514.742798 
	C314.892639,514.276245 315.004211,514.094727 315.488831,513.367859 
	C316.139832,512.449829 316.457886,512.114319 317.146729,511.661621 
	C317.741516,511.517853 317.995544,511.519257 318.607300,511.674561 
	C322.489319,520.676941 323.801880,529.966064 324.168152,539.680054 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M324.169525,540.138550 
	C322.591492,531.373718 321.353729,522.764832 319.088257,514.346313 
	C318.833923,513.401123 318.860168,512.338928 317.244873,512.076050 
	C315.851135,510.564636 316.710388,509.382294 317.827576,507.824921 
	C318.022461,507.437408 318.014404,507.511444 317.977203,507.509949 
	C318.405304,506.515594 319.154205,505.895477 320.626740,505.852905 
	C319.412201,512.216003 322.584076,517.832336 323.440491,523.755737 
	C324.333527,529.932678 325.641113,536.049683 326.811951,542.586792 
	C325.083801,542.960144 325.208038,541.239929 324.169525,540.138550 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M312.447876,518.148560 
	C309.836029,522.231384 307.312256,525.973633 304.806091,530.107300 
	C302.057648,530.441589 301.856110,528.829163 302.783569,526.315918 
	C303.050842,525.937744 303.002472,525.990540 302.977600,526.016235 
	C303.506622,525.489807 304.066528,524.943665 304.825989,524.182373 
	C305.035400,523.977051 305.006927,524.006226 304.996033,524.023438 
	C305.428009,523.595154 305.503845,522.994568 305.836792,522.187683 
	C306.008026,521.945129 305.982544,521.984619 305.965027,522.000305 
	C306.576447,521.555725 307.316223,521.216125 307.836487,520.207458 
	C308.014374,519.971008 307.997986,519.995728 307.985596,520.003784 
	C309.188782,519.415710 309.877563,518.109131 311.527740,517.601685 
	C312.094391,517.649780 312.315155,517.728882 312.447876,518.148560 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M302.631683,526.011597 
	C303.350555,527.504456 302.080444,529.379395 304.398315,530.565979 
	C304.823761,530.498657 304.851288,530.429443 304.837280,530.393738 
	C302.921844,531.272644 304.551697,532.877808 304.164520,534.483948 
	C303.750458,535.553406 303.062927,535.766296 301.929321,535.723938 
	C300.329559,535.176758 300.051117,533.993958 299.463013,532.642090 
	C299.093811,531.995544 298.877777,531.633179 298.536713,530.990845 
	C298.161133,530.170105 297.989838,529.598083 297.721619,528.751709 
	C297.607361,528.281921 297.577881,528.090637 297.591797,527.613708 
	C297.753693,527.177124 297.872223,527.026184 298.266998,526.955994 
	C300.200531,528.394348 300.888519,526.013367 302.631683,526.011597 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M314.665649,514.841431 
	C315.150360,515.319153 315.298706,515.767334 315.393066,516.605103 
	C315.153748,517.027893 314.968445,517.061218 314.511536,517.171875 
	C314.025055,517.181152 313.810211,517.113037 313.453430,516.737305 
	C313.344818,515.697815 313.665222,515.146729 314.665649,514.841431 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M313.990967,516.998291 
	C313.797363,517.613281 313.354797,517.977356 312.635986,518.415222 
	C312.359802,518.489075 312.111969,518.162170 311.975342,518.009216 
	C311.768982,517.692749 311.699280,517.529297 311.716583,517.112915 
	C312.071136,516.618469 312.374969,516.438110 312.979126,516.282471 
	C313.409607,516.413391 313.575806,516.580383 313.990967,516.998291 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M184.630508,876.024414 
	C182.875534,879.517456 181.170532,883.422241 176.697174,885.223877 
	C176.159988,885.337219 175.966507,885.390076 175.789917,885.142517 
	C176.491486,883.451050 177.176178,882.059937 177.938629,880.342468 
	C180.972382,880.038879 181.689758,876.695679 184.630508,876.024414 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M182.729218,870.215332 
	C182.483627,873.850281 178.782059,875.723694 178.021027,879.658813 
	C178.016403,880.016113 178.000000,880.000000 178.007721,880.009277 
	C176.485550,879.813538 176.191833,879.101868 176.655701,877.598877 
	C177.636505,874.420959 179.778534,872.200378 182.729218,870.215332 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M191.659546,881.029663 
	C191.107620,884.321533 188.501617,886.163452 185.729645,888.227234 
	C185.196518,888.364685 184.985764,888.414978 184.781647,888.140381 
	C186.223877,884.870117 188.505447,882.717102 191.659546,881.029663 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M185.524002,866.456421 
	C185.366150,865.148804 185.852859,864.435486 187.007385,864.416565 
	C187.196640,864.413513 187.562347,864.802063 187.556763,865.001526 
	C187.524582,866.150513 186.817184,866.643250 185.524002,866.456421 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M185.093109,891.453735 
	C184.325653,891.956360 183.651047,891.737610 183.028107,890.673096 
	C183.374649,889.581726 183.853989,888.858032 184.560806,887.974915 
	C184.788269,887.815430 185.090012,888.069702 185.248627,888.192078 
	C185.285980,889.243530 185.164688,890.172546 185.093109,891.453735 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M189.307739,861.963684 
	C189.323715,861.273804 189.638290,860.543884 190.012573,859.845947 
	C190.037750,859.799011 190.710648,859.941895 190.747971,860.084167 
	C191.000961,861.048157 190.514420,861.629883 189.307739,861.963684 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M182.896881,869.910156 
	C183.048965,869.101379 183.371063,867.996887 184.169464,868.396790 
	C185.173615,868.899658 184.383545,869.586487 183.506546,870.157837 
	C183.248062,870.277161 183.017685,870.028809 182.896881,869.910156 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M198.229980,873.997314 
	C198.343994,873.776794 198.667236,873.538574 198.990479,873.300293 
	C199.070236,873.418213 199.150009,873.536194 199.229767,873.654114 
	C198.966248,873.762634 198.702728,873.871094 198.229980,873.997314 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M184.884460,875.895508 
	C185.019241,875.402710 185.234406,874.979309 185.449554,874.555847 
	C186.057938,874.925964 185.862366,875.353088 185.332397,875.945190 
	C185.127686,876.100952 184.964828,875.964783 184.884460,875.895508 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M193.256485,879.841431 
	C193.130920,879.406128 193.308044,878.854187 193.753052,878.160095 
	C193.867020,878.586914 193.713104,879.155823 193.256485,879.841431 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M176.215576,885.175415 
	C176.101547,885.733215 176.212311,886.526001 175.366074,886.367920 
	C175.311859,886.357849 175.394135,885.616882 175.609879,885.029053 
	C175.806839,884.842163 176.077667,885.066345 176.215576,885.175415 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M189.458832,890.515991 
	C189.436447,890.476196 189.481216,890.555725 189.458832,890.515991 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M197.991272,873.988342 
	C197.899582,874.025208 197.816376,874.072388 197.876953,874.067383 
	C198.020737,874.015076 197.999725,873.998718 197.991272,873.988342 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M189.002197,862.002441 
	C188.902390,862.040039 188.800385,862.075134 188.846680,862.053223 
	C188.994995,861.996155 189.000000,862.000000 189.002197,862.002441 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M193.995926,877.994385 
	C194.120041,878.055725 194.137573,877.083313 194.187988,877.982178 
	C194.020950,878.017944 194.002823,878.002502 193.995926,877.994385 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M196.422180,876.404358 
	C196.489792,876.357239 196.354584,876.451477 196.422180,876.404358 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M191.943176,880.937317 
	C192.079025,880.609741 192.268127,880.338379 192.705505,880.012573 
	C192.953796,879.958069 192.996780,879.997681 193.017853,880.020447 
	C192.884109,880.331604 192.729279,880.619995 192.342026,881.003967 
	C192.109604,881.099487 191.996414,880.993591 191.943176,880.937317 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M327.876770,494.785278 
	C328.331604,494.004150 328.680756,493.557068 329.238647,493.046387 
	C330.123260,492.776733 330.784424,492.518158 331.750183,492.174469 
	C332.012177,491.937195 332.003113,492.004700 331.969452,491.999512 
	C332.201111,491.789795 332.449829,491.566742 332.841370,491.131409 
	C333.000824,490.937683 333.003326,491.003265 332.970581,491.001526 
	C333.201508,490.791931 333.449036,490.566193 333.844604,490.132629 
	C334.006683,489.940216 334.003265,490.004181 333.971741,489.998535 
	C334.189423,489.884644 334.438629,489.776428 335.055664,489.843567 
	C335.423492,490.018921 335.818909,489.971039 335.977661,490.096985 
	C333.351257,493.894897 330.282898,497.295715 326.294861,500.043854 
	C325.647888,499.532349 325.513824,499.072113 325.749268,498.248474 
	C325.949219,497.934479 326.004791,497.991119 325.972351,497.969299 
	C326.219757,497.784058 326.464203,497.578461 326.812378,497.134644 
	C326.951508,496.938538 326.995911,496.994324 326.961914,496.983643 
	C327.563538,496.516357 327.502594,495.742889 327.876770,494.785278 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M325.627472,497.730286 
	C325.936462,498.378693 325.923706,498.822876 325.931335,499.605103 
	C325.951691,499.943115 325.979767,499.968750 325.974609,499.971375 
	C325.699219,500.292358 325.394165,500.572266 324.752502,500.905273 
	C324.456177,501.002869 324.098907,501.250763 324.050415,501.349945 
	C323.546478,503.050140 322.347717,504.185516 321.208527,505.753632 
	C320.961090,505.994049 321.000427,506.000702 320.997253,505.981445 
	C320.200287,506.417542 319.406494,506.872955 318.276367,507.418396 
	C318.742584,502.961548 322.390930,500.514465 325.627472,497.730286 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M348.214355,529.991943 
	C349.123993,532.150146 350.480133,534.162170 349.347595,536.710022 
	C348.369141,534.840027 347.681549,532.782898 347.018982,530.357483 
	C347.304108,529.985596 347.564240,529.982056 348.214355,529.991943 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M334.751099,541.748291 
	C334.584564,542.085083 334.356903,542.061279 333.787811,541.965820 
	C332.206482,539.757568 331.571228,537.530823 332.427490,534.714111 
	C333.255920,537.157654 333.972992,539.272644 334.751099,541.748291 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M336.495056,490.190613 
	C336.179565,488.600159 336.962067,486.903809 338.204163,486.721069 
	C339.579834,486.518707 339.492249,488.477875 339.799835,489.947906 
	C338.777557,490.272766 337.816559,490.245605 336.495056,490.190613 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M321.339478,505.997864 
	C321.027649,504.157837 322.617767,503.274597 323.747864,501.696960 
	C324.611267,503.654358 323.054993,504.773041 321.339478,505.997864 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M352.118042,552.878113 
	C351.409973,553.128418 350.983398,553.060486 350.232483,552.980713 
	C348.555145,550.955505 350.234894,551.182800 351.685638,551.005371 
	C352.009735,551.009216 351.998535,550.997375 351.994751,550.991455 
	C352.379059,551.444885 352.515289,551.969727 352.118042,552.878113 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M339.720306,492.150146 
	C340.571411,492.391327 340.833618,492.984253 340.617554,494.072784 
	C339.803741,493.874298 339.142883,493.334839 339.720306,492.150146 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M324.839539,501.089050 
	C324.746918,500.686462 325.037689,500.370056 325.648956,500.013824 
	C325.720612,500.374390 325.471741,500.774811 324.839539,501.089050 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M603.783081,299.138367 
	C604.005432,299.437103 604.005371,299.886017 604.005127,300.671631 
	C603.313721,300.575317 602.987793,300.048004 603.783081,299.138367 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M474.125214,257.117645 
	C473.817841,255.253922 475.908875,255.065323 476.010742,253.319305 
	C477.496582,250.980621 480.482605,252.482742 482.151672,250.194550 
	C482.993561,249.369827 483.776733,249.056427 484.758362,248.524078 
	C485.754730,247.272232 484.607941,246.540207 484.412384,245.295807 
	C483.302368,241.957306 481.972900,243.700241 480.400879,244.999664 
	C476.478760,246.646194 474.988159,245.588104 476.110931,241.252945 
	C476.880249,239.531021 477.744904,238.476044 479.795685,238.578918 
	C483.050079,240.437164 486.200348,239.044479 489.546539,239.736664 
	C489.632202,244.901749 489.678619,249.859665 491.315399,254.663467 
	C491.638275,255.611038 491.228149,256.226196 490.233154,256.887207 
	C488.285156,258.314789 486.258270,257.364258 484.656097,257.949219 
	C485.891296,258.076538 487.423218,257.571503 488.844543,258.932129 
	C489.002991,260.235321 488.999664,261.246155 488.999084,262.636139 
	C486.682556,264.919159 484.194183,264.612305 481.319214,263.216156 
	C479.507904,261.321716 478.150482,263.403534 476.080139,262.853699 
	C474.594269,261.733582 473.513336,260.965240 472.757263,259.523254 
	C472.856659,258.310242 473.714691,257.995575 474.125214,257.117645 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M495.003815,263.055969 
	C495.061920,261.954102 495.454559,260.991119 495.141144,260.407074 
	C494.695190,259.576172 491.940613,259.499756 494.443329,257.924408 
	C495.801117,257.069702 496.778076,257.964752 496.863190,259.300049 
	C497.103577,263.071259 499.528290,261.100922 501.134003,260.959320 
	C503.070312,260.788605 505.219940,259.831604 505.925934,262.712677 
	C506.566803,265.328033 506.557983,267.643860 502.739136,266.895203 
	C502.947632,268.583160 504.759766,267.367035 504.896881,268.868927 
	C501.317841,268.868927 497.767609,268.868927 494.126190,268.868927 
	C493.984833,267.664154 496.849304,267.646942 495.169281,265.711609 
	C494.722046,264.769684 495.881287,264.081879 495.003815,263.055969 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M480.371826,239.234619 
	C478.794891,238.916092 478.149231,239.764786 477.255585,240.816589 
	C476.685669,241.336380 476.302155,241.533813 475.527985,241.529312 
	C474.796509,241.269592 474.409363,241.053726 473.827820,240.546356 
	C473.284302,239.707581 473.150848,239.073257 473.198792,238.091278 
	C473.321716,237.582733 473.399933,237.388824 473.676697,236.958893 
	C474.154785,236.634308 474.437317,236.557373 474.723846,236.497009 
	C475.033264,236.431778 474.941620,236.410858 474.170715,236.330856 
	C473.814941,236.051575 473.736237,235.871155 473.793457,235.428589 
	C473.944397,234.982956 473.959412,234.799423 474.277771,234.196991 
	C475.422363,233.852493 476.263611,233.926926 477.527588,234.008926 
	C478.689941,233.389145 479.509460,233.272903 480.688782,233.967041 
	C480.980713,234.659256 480.987335,235.017471 480.991211,235.644363 
	C480.966461,236.131210 480.944427,236.349380 480.950317,236.895248 
	C480.980499,237.558044 480.982788,237.893127 480.983643,238.479523 
	C480.886139,238.969620 480.790131,239.208420 480.371826,239.234619 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M463.106049,241.645096 
	C462.484802,241.756989 461.960266,241.488708 461.153503,241.137085 
	C460.217041,241.746201 459.403229,241.967682 458.160583,241.778732 
	C457.656616,241.574768 457.471375,241.456223 457.161804,241.032135 
	C457.913025,239.591705 455.964081,237.746078 458.085541,236.634491 
	C458.518707,236.282349 458.859161,236.308228 459.392090,236.599838 
	C461.041687,236.855392 462.492950,236.939972 464.380432,237.038330 
	C465.155334,236.779358 465.499054,236.513077 466.137878,236.104065 
	C466.427887,235.954819 466.459381,235.992416 466.483307,235.997833 
	C467.197815,235.806824 467.639221,236.159836 468.102386,236.957825 
	C468.177338,237.422974 468.153839,237.612335 467.963318,238.023956 
	C467.471039,238.492477 466.638702,238.528412 467.319580,239.487885 
	C467.020447,240.055344 466.737091,240.290924 466.136597,240.553986 
	C464.839722,240.256927 463.838287,239.985168 463.106049,241.645096 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M481.130524,266.036926 
	C480.974487,265.726471 480.978668,265.460785 480.982117,265.328003 
	C483.229156,262.604095 486.123352,264.117828 489.129852,263.933014 
	C489.728363,265.801758 490.952087,268.046722 489.025513,269.426178 
	C487.638519,270.419312 485.584015,270.716400 484.087219,268.440857 
	C483.622650,266.648468 482.056885,267.124176 481.130524,266.036926 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M489.344818,259.089386 
	C485.997101,259.280304 483.070374,258.856018 480.225281,257.731262 
	C483.217194,257.225098 486.088745,255.513351 489.563477,257.076752 
	C490.007874,257.685120 490.517181,258.411011 489.344818,259.089386 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M500.943909,273.828125 
	C501.084869,272.594116 501.890564,270.976898 502.013397,271.207306 
	C503.337280,273.690308 506.675262,269.865570 507.147797,272.629059 
	C507.931763,277.213684 504.103577,274.097076 502.161316,274.915833 
	C501.439209,274.642853 501.158173,274.386780 500.943909,273.828125 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M474.751648,233.388718 
	C474.581085,233.778076 474.246643,233.826996 474.126404,233.945709 
	C470.892334,234.064438 467.778473,234.064438 464.664642,234.064438 
	C468.012054,231.734528 471.413757,231.255310 474.751648,233.388718 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M481.322510,234.230591 
	C480.220154,234.217880 479.466187,234.134705 478.331299,234.034012 
	C478.433960,229.644241 481.812653,231.348999 484.642822,231.065887 
	C485.415833,231.543762 485.547577,232.042007 485.240540,232.939133 
	C483.907471,233.572540 482.789185,233.866333 481.322510,234.230591 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M499.303162,255.096008 
	C496.911316,255.156219 493.748779,256.875702 495.124573,251.920624 
	C495.689362,251.198700 496.161865,250.753143 497.067352,250.370087 
	C497.815826,250.173584 498.257202,250.153900 499.026672,250.278458 
	C499.539917,250.490524 499.728027,250.614426 499.966736,251.072388 
	C500.012360,252.063965 500.007385,252.721512 500.009216,253.707764 
	C500.172180,254.515366 500.045044,254.900787 499.303162,255.096008 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M500.347778,251.301483 
	C499.868286,251.310074 499.719269,251.213730 499.334229,250.994324 
	C497.875305,249.679855 497.681244,248.268433 498.438721,246.312332 
	C499.420197,245.285156 500.283295,245.149033 501.620117,245.556488 
	C502.921661,246.403259 504.701996,245.161865 504.880066,247.515106 
	C504.259705,249.007401 502.911774,249.385666 502.214722,250.762115 
	C501.593048,251.074554 501.135620,251.135544 500.347778,251.301483 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M489.667664,263.887207 
	C487.243073,266.442383 484.030548,262.698456 481.363953,265.134827 
	C480.289581,264.663086 479.552155,264.142303 480.712280,263.017151 
	C483.362335,262.882202 485.736420,262.909790 488.556152,262.976318 
	C489.340332,263.312592 489.678894,263.609924 490.232025,263.942139 
	C490.446564,263.977081 490.153198,263.833435 490.153198,263.833435 
	C490.153198,263.833435 489.828918,263.872498 489.667664,263.887207 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M468.296906,238.678238 
	C468.299988,237.184341 467.313995,237.106812 466.689697,236.322113 
	C468.536713,234.536652 470.906128,235.478516 473.507507,235.120605 
	C473.929413,235.166473 474.064301,235.590408 474.169861,235.786194 
	C474.353180,236.182816 474.430939,236.383652 474.266479,236.798157 
	C474.024200,237.011826 474.001068,236.997559 474.005920,237.009857 
	C473.532227,237.459671 473.045898,237.886826 472.191284,238.338867 
	C471.562805,238.690247 471.204651,238.885437 469.993225,239.245453 
	C468.966522,239.331467 468.790070,239.247147 468.296906,238.678238 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M498.883301,245.963654 
	C499.145142,247.551468 499.122803,248.828293 499.099335,250.488190 
	C498.659607,250.938232 498.221008,251.005188 497.449951,251.060608 
	C497.117462,251.049072 496.748505,250.821121 496.686890,250.609406 
	C496.625305,250.397675 496.551208,249.952454 496.313354,249.864044 
	C495.915894,249.695923 495.756226,249.616241 495.387268,249.369690 
	C494.157135,247.637909 493.574219,246.223343 496.635681,245.854370 
	C497.500214,245.499435 498.041809,245.462021 498.883301,245.963654 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M485.532227,275.355347 
	C484.702911,276.068115 483.683716,276.507141 482.259338,277.004883 
	C480.984894,276.230408 480.115631,275.397217 479.134949,274.280396 
	C479.573822,273.701050 480.124115,273.405304 480.961395,272.984924 
	C482.955414,272.969666 483.988525,274.321136 485.532227,275.355347 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M499.982361,281.906494 
	C498.798035,281.411041 497.680359,280.447388 499.358002,280.146515 
	C501.762238,279.715302 504.301453,280.036560 507.411865,280.036560 
	C505.063110,283.194916 502.268433,280.357880 499.982361,281.906494 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M502.427673,251.012817 
	C501.119171,248.926361 501.155365,247.451263 504.435181,247.841858 
	C507.448883,251.027649 504.820496,250.825760 502.427673,251.012817 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M499.522980,246.206345 
	C498.684113,246.143875 498.200714,246.013107 497.345886,245.823639 
	C498.234497,242.671753 499.747406,241.357056 501.995850,245.411865 
	C501.305450,245.892227 500.591949,246.015137 499.522980,246.206345 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M481.384186,237.144470 
	C480.871643,236.875702 480.765045,236.528427 480.823486,236.047119 
	C483.500397,236.564850 486.158783,235.254257 489.091461,236.572250 
	C486.563477,239.200317 484.011688,236.195663 481.384186,237.144470 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M472.216644,266.004639 
	C471.861786,266.010925 471.405609,266.002319 471.177826,265.989990 
	C470.236389,265.162628 469.568604,264.331055 470.190979,262.826599 
	C471.980591,261.620453 473.548096,261.611847 475.469360,262.538696 
	C475.788788,262.791199 475.906769,262.907837 475.966003,262.966461 
	C476.006592,263.495850 475.987946,263.966583 475.947327,264.790222 
	C474.954712,266.005951 473.760345,265.991272 472.216644,266.004639 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M493.291199,232.594940 
	C491.933350,232.775101 490.774872,232.682297 489.297760,232.442337 
	C488.799835,232.054047 488.620514,231.812897 488.716187,231.214584 
	C490.037048,229.921982 491.225983,229.934021 492.846985,230.374374 
	C493.674957,231.000275 493.727325,231.640640 493.291199,232.594940 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M493.459961,232.916229 
	C493.100983,232.253159 493.110107,231.638412 493.170044,230.720215 
	C494.347656,230.995148 496.359802,228.986252 496.685394,231.208420 
	C496.889954,232.604279 495.137787,232.904312 493.459961,232.916229 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M480.657166,265.930237 
	C482.199799,265.875275 483.483398,265.844116 484.636017,266.217377 
	C486.161316,266.711334 484.811646,267.198822 484.232422,267.863159 
	C482.877777,267.219788 480.160492,269.416107 480.657166,265.930237 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M480.250885,239.392227 
	C480.049591,239.022003 480.526825,238.911362 480.754517,238.821106 
	C483.620483,238.834869 486.258789,238.938919 489.334534,239.070557 
	C490.015991,239.196228 490.260010,239.294281 490.213348,239.659027 
	C489.922668,239.925705 489.932892,239.951263 489.929199,239.932465 
	C486.767761,239.863266 483.609955,239.812866 480.250885,239.392227 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M497.368134,240.374969 
	C496.042236,240.462784 495.030487,240.632034 493.703247,240.819794 
	C492.779358,240.692825 492.505310,240.308762 492.775177,239.340851 
	C495.200500,239.323517 497.668640,237.680557 499.302734,240.064636 
	C498.543121,240.420624 498.117798,240.475464 497.368134,240.374969 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M500.574524,273.633270 
	C501.209137,273.820038 501.425842,274.094452 501.690796,274.623596 
	C499.453522,274.878296 497.168060,274.878296 494.513855,274.878296 
	C496.397858,272.854645 498.392090,273.961334 500.574524,273.633270 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M472.030029,266.300659 
	C472.714325,264.807892 473.902191,264.759613 475.556183,265.094238 
	C475.367493,267.388245 473.417633,266.048706 472.030029,266.300659 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M469.445007,262.726166 
	C470.294098,263.762756 470.615814,264.549744 470.943787,265.657227 
	C470.531433,265.982819 470.112793,265.987946 469.380676,265.979614 
	C468.663361,265.253510 467.363129,265.058746 467.958893,263.519226 
	C468.210327,262.786499 468.497162,262.554169 469.445007,262.726166 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M459.677551,236.399628 
	C459.290436,236.605560 458.990448,236.440308 458.430969,236.320465 
	C457.290039,236.337585 456.408569,236.309296 455.201904,236.192780 
	C454.857208,235.886230 454.837738,235.667923 454.917542,235.136200 
	C456.646332,235.040085 458.670837,233.701767 459.677551,236.399628 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M501.490387,231.631470 
	C500.225006,231.908569 499.194489,232.026382 498.707214,230.860138 
	C498.642059,230.704163 498.889069,230.225204 499.036865,230.203384 
	C500.184479,230.034088 501.397278,229.822830 501.490387,231.631470 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M494.661865,262.803680 
	C495.471191,263.475586 497.356293,263.933899 495.217041,265.301453 
	C494.788391,265.481201 494.585083,265.483704 494.081726,265.540558 
	C492.977020,265.214691 492.498840,264.629089 492.810303,263.349609 
	C493.471527,262.959534 493.905365,262.909515 494.661865,262.803680 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M505.277527,239.782196 
	C504.194183,239.893539 503.295135,240.026810 502.631927,239.692352 
	C502.192566,239.470779 502.721100,238.893967 503.183441,238.846786 
	C504.063812,238.756912 505.441193,237.285187 505.277527,239.782196 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M488.597046,230.823425 
	C489.001129,231.096878 489.011139,231.336349 489.000183,231.935516 
	C487.891693,232.629669 486.804199,232.964142 485.371246,233.288681 
	C485.014801,232.794632 485.003876,232.310532 485.026367,231.465637 
	C486.107544,230.999725 487.155243,230.894592 488.597046,230.823425 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M500.739563,255.877899 
	C500.859314,257.013062 501.317047,258.319458 500.009125,258.436401 
	C498.930786,258.532776 499.139221,257.370972 499.013184,256.299866 
	C499.442474,255.614502 499.926605,255.494568 500.739563,255.877899 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M495.111023,249.499344 
	C495.745178,249.136078 496.312347,249.069336 497.318665,249.170410 
	C497.644623,249.621002 497.531525,249.903809 497.267944,250.617828 
	C496.626160,251.163055 496.134888,251.277054 495.413422,251.494019 
	C495.136871,250.996613 495.090485,250.396255 495.111023,249.499344 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M501.291260,256.019287 
	C500.567871,256.118866 500.123138,256.081573 499.346313,256.001984 
	C499.014191,255.959656 498.978088,255.480057 498.974915,255.239655 
	C499.279297,254.879883 499.538300,254.693146 499.882385,254.237762 
	C500.803528,254.151215 501.796783,254.019638 502.317078,254.454285 
	C502.779572,254.840668 502.128510,255.537506 501.291260,256.019287 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M492.583344,238.998337 
	C493.034271,239.413025 493.083801,239.830475 493.260559,240.543106 
	C492.454346,240.636185 491.520905,240.434113 490.255066,240.078857 
	C489.922668,239.925705 489.895874,239.503098 489.833923,239.300629 
	C490.575287,239.065811 491.378632,239.033447 492.583344,238.998337 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M466.562866,228.144775 
	C467.647186,228.113876 468.420166,228.113876 469.579254,228.113876 
	C468.380005,229.296539 467.402313,228.833679 466.484955,228.817093 
	C466.333435,228.814377 466.183563,228.719452 466.032959,228.667145 
	C466.105804,228.503311 466.178650,228.339493 466.562866,228.144775 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M492.719727,263.137573 
	C493.177612,263.667999 493.317474,264.326477 493.619507,265.289917 
	C492.352844,266.298615 491.748962,265.062073 490.679077,264.175903 
	C490.446564,263.977081 490.495941,264.037720 490.486237,264.002472 
	C491.118256,263.733368 491.759949,263.499481 492.719727,263.137573 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M504.914368,231.909485 
	C503.799469,231.496368 503.928833,230.959778 504.570526,230.617722 
	C504.853912,230.466660 505.356079,230.726044 505.758911,230.799103 
	C505.589996,231.161621 505.421112,231.524124 504.914368,231.909485 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M492.066040,272.692383 
	C491.528320,272.724426 491.146423,272.597595 490.764526,272.470764 
	C490.867981,272.364288 490.995605,272.151886 491.070801,272.169037 
	C491.461823,272.258301 491.839539,272.406067 492.066040,272.692383 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M497.211365,240.461212 
	C497.477356,240.248886 497.900757,240.204224 498.640381,240.220001 
	C498.524017,240.837204 498.014679,241.044342 497.211365,240.461212 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M466.058350,235.974854 
	C466.127106,236.299057 465.826355,236.643295 465.171112,237.019836 
	C465.107330,236.699707 465.398071,236.347305 466.058350,235.974854 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M468.823029,268.644470 
	C468.644318,268.771179 468.318634,268.703796 467.876678,268.399719 
	C468.100189,268.148743 468.405426,268.244507 468.823029,268.644470 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M494.700958,702.142883 
	C495.065979,702.190857 495.561279,702.139771 495.795013,702.054077 
	C496.748322,701.295654 497.691803,701.623474 498.795593,701.245728 
	C499.076599,701.079346 499.008789,701.024231 499.018585,701.066772 
	C508.725311,699.011658 518.138000,695.553345 528.580383,695.038452 
	C529.450256,695.041931 529.902039,695.029968 530.685425,694.945557 
	C537.108337,691.760193 543.825500,692.414368 550.310181,691.652466 
	C557.146606,690.849182 563.971252,689.947144 571.203247,689.293579 
	C573.425171,691.816284 571.674744,692.648987 569.825378,693.164429 
	C567.098938,693.924316 564.295288,694.312256 561.450562,694.428589 
	C551.764221,694.824707 542.358521,697.113403 532.857788,698.755615 
	C532.056458,698.894043 531.233582,699.150024 530.844177,700.016968 
	C530.672791,700.873901 531.362244,701.117188 531.884460,701.487671 
	C535.516724,704.065247 535.784851,706.273010 532.085388,708.658813 
	C529.003967,710.646179 527.425415,713.003723 526.864502,716.578857 
	C526.490723,718.961060 525.595093,721.795776 521.710266,719.751831 
	C521.429810,719.207642 521.366150,718.970032 521.325745,718.369263 
	C521.577209,717.416382 522.013428,716.985107 522.604980,716.344116 
	C522.672607,716.346985 522.534546,716.520508 522.176147,716.823853 
	C521.630920,717.360168 521.265686,717.738281 520.681152,718.304077 
	C520.297668,718.598328 520.138855,718.710083 519.736328,718.982910 
	C518.645203,719.639954 517.888855,720.258972 516.904663,721.067810 
	C516.348816,721.476318 516.016418,721.687256 515.425903,722.041992 
	C515.010803,722.307678 514.845154,722.415833 514.431885,722.694885 
	C514.016479,722.981445 513.848572,723.097168 513.416016,723.377991 
	C512.963135,723.639587 512.774902,723.736023 512.292603,723.959839 
	C510.970551,724.447021 510.005463,724.919800 508.940918,725.881897 
	C508.516449,726.243164 508.338257,726.378174 507.868469,726.678589 
	C505.967194,727.531860 504.240753,728.028503 502.912567,729.805237 
	C502.511322,730.210022 502.338898,730.361755 501.877136,730.704102 
	C497.551056,733.117493 493.886871,735.867249 490.315613,738.762634 
	C488.669922,740.096741 487.023956,741.521484 484.391541,741.615845 
	C480.565430,740.271545 480.852905,738.008484 482.332214,735.295837 
	C484.183105,731.901733 487.013275,729.087769 488.074219,725.033508 
	C487.717407,724.390076 487.544952,724.007446 487.383728,723.291382 
	C487.384674,722.772888 487.419525,722.567383 487.596130,722.085144 
	C488.022003,721.516296 488.330414,721.252991 488.911652,720.859802 
	C489.313507,720.584656 489.472870,720.475403 489.860779,720.193298 
	C490.542145,719.652222 490.959991,719.248535 491.525879,718.548828 
	C492.283447,717.635437 492.907410,717.027161 493.694733,716.145874 
	C494.152313,715.604797 494.404083,715.297913 494.813660,714.760620 
	C495.090698,714.391968 495.205872,714.250488 495.523987,713.936646 
	C495.879120,713.683228 496.031311,713.602295 496.412323,713.416321 
	C496.209534,712.803223 496.977661,713.413879 496.419128,713.049927 
	C496.374878,713.020996 496.352783,713.037231 496.352966,713.098328 
	C496.353668,713.321045 496.379578,713.432373 496.154297,713.505127 
	C495.696716,713.664795 495.515503,713.751709 495.050903,713.972412 
	C488.681091,716.416382 484.330109,721.400757 478.413757,724.555054 
	C475.242767,724.003967 472.206635,725.975403 469.228516,723.714722 
	C468.689331,723.147095 468.504303,722.751892 468.476685,721.986450 
	C468.746735,721.312500 469.008179,720.986023 469.523254,720.477783 
	C469.709930,719.886902 470.423004,720.232849 470.055389,719.935425 
	C469.566071,720.428772 469.282410,720.710815 468.784119,721.213013 
	C467.762329,722.399841 466.919891,723.330872 465.637421,724.260010 
	C465.191101,724.532410 465.004578,724.624939 464.525513,724.816772 
	C463.469574,725.114258 462.676422,725.193359 461.699493,725.632751 
	C461.009308,726.134949 460.727631,726.602966 460.490967,727.446411 
	C460.043518,728.568970 459.438019,729.128418 458.225830,729.421631 
	C454.722137,729.590881 451.191071,728.787842 450.803009,733.860962 
	C450.670746,735.589966 448.884277,735.328979 447.862549,733.965149 
	C446.656799,732.355530 445.745575,730.587830 445.385620,728.227539 
	C445.924103,725.771851 447.959564,724.571655 448.810211,722.255554 
	C449.019073,721.977234 448.986176,721.989868 448.982300,722.007019 
	C449.214264,721.796448 449.447418,721.566101 449.849762,721.157227 
	C450.021606,720.981384 449.990143,720.987122 449.984009,721.001953 
	C450.420471,720.584351 451.019470,720.527710 451.797882,720.172119 
	C452.025879,719.989807 451.992859,719.989075 451.986206,720.004150 
	C452.416199,719.589722 453.005127,719.527527 453.776062,719.183533 
	C453.998779,719.000000 454.000000,719.000000 454.000000,718.999634 
	C454.469879,718.423401 454.812378,717.726685 455.744934,717.203979 
	C459.540802,715.958374 461.977417,713.202393 464.906769,710.638489 
	C472.147858,707.193665 479.855011,706.152832 487.637390,703.907227 
	C490.016357,702.827637 492.086700,702.127991 494.700958,702.142883 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M448.722626,722.132202 
	C449.483093,724.456238 447.832367,725.846497 446.083191,727.564331 
	C443.474335,733.407715 438.794006,737.273438 435.164734,741.914856 
	C433.186218,744.445068 432.026947,747.817200 428.373962,749.124207 
	C427.882050,748.490173 427.737640,747.936829 427.338318,747.247070 
	C428.158691,744.936279 430.062927,743.124023 429.976624,740.056091 
	C431.160156,736.168518 434.365204,734.409973 436.925201,732.307190 
	C440.862152,729.073181 444.646576,725.688904 448.722626,722.132202 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M399.233948,755.602966 
	C398.166962,757.156006 397.158325,758.382751 396.149719,759.609497 
	C397.223663,751.599060 403.739838,746.665161 406.937866,739.538757 
	C408.300598,738.084656 409.632843,736.958496 411.281250,735.756104 
	C411.803101,735.634399 412.008728,735.588745 412.208435,735.859009 
	C407.899109,742.542175 403.595703,748.909485 399.233948,755.602966 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M395.106201,737.051086 
	C394.923981,733.673584 392.360870,734.159302 389.854553,733.957153 
	C393.073029,731.653198 397.146088,730.319153 401.474609,728.647583 
	C401.262909,732.548950 398.191101,734.642212 395.106201,737.051086 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M384.450623,747.970947 
	C384.130981,747.875549 384.086853,747.599304 383.996643,746.900513 
	C385.594757,742.527405 388.929749,740.265198 392.689392,738.050049 
	C391.487518,742.316223 387.386871,744.440369 384.450623,747.970947 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M440.247833,716.961792 
	C439.562744,715.762451 437.663422,716.394104 437.399902,714.645203 
	C439.091370,713.990540 440.034790,714.948730 440.959381,716.460449 
	C440.858612,716.834106 440.689178,716.898438 440.247833,716.961792 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M422.013672,747.980591 
	C421.518097,748.019104 421.077148,748.003479 420.304810,748.007324 
	C420.027924,747.101746 420.142883,746.101562 421.186615,745.857056 
	C422.120026,745.638367 421.827911,746.598450 422.044586,747.425903 
	C422.073700,747.772827 422.068298,747.926453 422.013672,747.980591 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M422.425964,722.184937 
	C422.524231,721.127563 423.445831,721.018433 424.792450,721.068420 
	C424.355408,721.450989 423.558533,721.804688 422.425964,722.184937 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M455.656311,717.089355 
	C455.466492,717.580383 454.973907,718.139648 454.240662,718.849121 
	C454.107727,718.132935 454.398041,717.400818 455.656311,717.089355 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M411.750610,735.801392 
	C411.848083,735.166138 412.098755,734.652344 412.819275,734.208252 
	C413.078674,734.796509 412.868164,735.315063 412.430115,736.004272 
	C412.202515,736.174927 411.903778,735.922791 411.750610,735.801392 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M451.719238,719.989990 
	C451.554504,720.354797 451.083130,720.719849 450.294800,721.050781 
	C450.456085,720.674561 450.934326,720.332336 451.719238,719.989990 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M453.695618,719.025330 
	C453.522278,719.321960 453.045807,719.643921 452.274414,719.992554 
	C452.450500,719.696411 452.921478,719.373535 453.695618,719.025330 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M393.316589,737.970581 
	C393.292725,737.730591 393.577423,737.429443 394.182068,737.073486 
	C394.209717,737.315674 393.917419,737.612549 393.316589,737.970581 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M415.432861,731.448608 
	C415.524139,731.384644 415.556549,731.634338 415.556549,731.634338 
	C415.556549,731.634338 415.341614,731.512573 415.432861,731.448608 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M412.950439,733.938232 
	C413.059540,733.638245 413.279968,733.453125 413.500366,733.267944 
	C413.546692,733.509949 413.593048,733.752014 413.464294,734.135986 
	C413.289154,734.277954 413.061768,734.052979 412.950439,733.938232 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M437.288208,717.828125 
	C437.308350,717.625610 437.602356,717.419312 438.176697,717.216919 
	C438.158691,717.421936 437.860413,717.623169 437.288208,717.828125 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M435.316895,718.353394 
	C435.317932,718.171021 435.483643,718.087158 435.805359,718.012390 
	C435.856964,718.213867 435.696991,718.357361 435.316895,718.353394 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M449.779724,721.076538 
	C449.863312,721.305603 449.705078,721.629822 449.262634,721.989136 
	C449.164917,721.739990 449.351410,721.455811 449.779724,721.076538 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M42.861755,967.906067 
	C42.145233,967.862732 41.819031,967.830872 41.501163,967.761108 
	C41.356548,967.729431 41.228432,967.622498 41.092831,967.549744 
	C42.109550,966.691528 43.315136,967.131592 44.429379,967.119263 
	C51.052444,967.045898 57.676735,966.969421 64.299194,967.035706 
	C65.984261,967.052551 67.983307,966.371277 69.046967,967.902039 
	C60.573063,967.902039 51.914272,967.902039 42.861755,967.906067 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M48.409771,956.221436 
	C51.262787,956.213196 53.695274,956.213196 56.127762,956.213196 
	C52.453217,957.168335 48.779297,957.203613 45.093002,956.363831 
	C46.058414,956.319092 47.023827,956.274353 48.409771,956.221436 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M349.340454,1003.005981 
	C347.262817,1000.135315 347.814117,997.339355 349.055634,994.160095 
	C350.578369,993.506287 351.900818,993.231079 353.573914,992.946289 
	C354.034027,995.413391 353.653259,997.958984 354.955444,1000.615479 
	C354.240845,1004.164124 351.788483,1003.135742 349.340454,1003.005981 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M344.807404,993.715454 
	C344.353027,994.994934 343.451385,995.098816 342.165833,994.420410 
	C342.785187,993.822144 343.498016,992.916321 344.807404,993.715454 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M62.484776,949.575806 
	C54.210262,949.034546 46.246399,947.833252 38.186142,947.603027 
	C46.238777,946.203857 54.223633,947.836731 62.677170,948.239502 
	C63.169453,948.792175 63.046268,949.146362 62.484776,949.575806 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M51.735405,935.652344 
	C46.984283,934.978088 42.609005,934.368713 38.233730,933.759277 
	C42.994831,932.633545 47.698906,932.828064 52.306671,933.976562 
	C54.212666,934.451660 53.963951,935.325806 51.735405,935.652344 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M62.626431,949.788940 
	C62.442822,949.377319 62.666355,949.043518 63.004852,948.543762 
	C66.650887,948.780762 70.181961,949.183655 73.713036,949.586548 
	C70.028175,952.332092 66.570000,949.777771 62.626431,949.788940 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M49.440033,921.112793 
	C48.843777,921.106873 48.659565,921.086060 48.548199,920.984985 
	C48.359715,920.813965 48.217373,920.592163 48.055641,920.391663 
	C50.882851,919.740601 53.708561,919.733826 56.811092,920.714722 
	C54.687939,921.032837 52.286392,921.047302 49.440033,921.112793 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M79.626915,951.986145 
	C79.987442,952.477234 80.010620,952.919617 80.030632,953.694824 
	C78.452507,953.899475 76.184456,954.116577 76.440071,951.931458 
	C76.616318,950.424866 78.286179,951.912537 79.626915,951.986145 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M103.952728,1007.609497 
	C103.831436,1008.558228 103.688576,1009.092896 103.315170,1009.781982 
	C100.197403,1001.855042 98.228889,993.618835 98.944138,984.484436 
	C99.402870,983.671509 99.846474,983.538757 100.534271,983.990845 
	C100.103546,992.181519 103.430916,999.489441 103.952728,1007.609497 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M100.941574,984.006531 
	C100.341393,984.191101 99.973907,984.062500 99.313019,983.980103 
	C99.218689,983.046936 95.457970,982.089844 98.798050,981.284973 
	C100.726639,980.820190 100.620995,978.658203 102.494598,978.237427 
	C103.751923,980.514587 102.579483,982.128479 100.941574,984.006531 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M116.790848,1015.535522 
	C116.035019,1017.320618 114.728279,1016.680359 113.429504,1017.070435 
	C113.027351,1016.287842 113.019241,1015.471497 113.027313,1014.247559 
	C114.468163,1013.993652 116.197830,1013.196228 116.790848,1015.535522 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M95.959389,966.947510 
	C95.739326,967.767761 95.375603,968.488831 94.510933,967.766541 
	C94.447578,967.713623 94.840881,967.114014 95.247070,966.593872 
	C95.472267,966.419250 95.804459,966.764709 95.959389,966.947510 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M113.989624,986.990234 
	C114.052620,986.468811 113.757210,985.808777 114.541344,985.583008 
	C114.536118,985.988525 114.530899,986.394043 114.274445,986.908569 
	C114.023216,987.017578 114.000137,987.000000 113.989624,986.990234 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M109.362808,975.040527 
	C109.238640,975.010132 109.078636,975.005920 109.117279,974.995483 
	C109.315926,974.989258 109.326973,975.066711 109.362808,975.040527 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M171.059937,578.005432 
	C170.454727,570.158142 176.540771,565.963318 180.133865,560.666748 
	C184.163040,554.727356 187.807388,548.815430 190.226868,542.000610 
	C193.344315,533.219910 198.416656,525.451660 204.700287,518.139526 
	C205.198273,523.460266 203.866119,529.266052 208.665283,533.934082 
	C210.237000,535.525330 209.305756,536.888489 208.481186,538.034668 
	C204.086273,544.143555 202.291885,551.440491 199.010010,558.456665 
	C195.058792,563.429504 190.439728,567.163391 185.318146,570.848022 
	C180.163589,574.482300 176.804443,579.430420 172.295914,584.065186 
	C171.598190,581.898193 172.307663,579.856995 171.059937,578.005432 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M173.285660,638.265747 
	C170.263367,628.280212 169.025864,618.241333 166.970215,608.369873 
	C166.458908,605.914490 167.665207,603.863464 169.011902,601.908142 
	C171.519806,598.266846 173.995132,594.603088 176.357010,591.135132 
	C177.697998,591.463196 177.921738,592.045715 177.905243,592.747925 
	C177.386002,614.864014 181.083984,636.341980 187.644150,657.392700 
	C187.832016,657.995544 187.714478,658.693542 187.580017,659.718262 
	C184.976440,660.846130 184.238983,658.880737 183.305222,657.402405 
	C181.780441,654.988403 181.016937,652.278809 180.362671,649.505432 
	C179.327209,645.116211 178.063583,640.791748 173.285660,638.265747 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M173.035828,638.415771 
	C180.810226,638.423584 180.331528,645.144653 181.837067,650.041809 
	C182.961288,653.698669 184.040131,657.187012 187.129440,660.000610 
	C188.242477,661.822083 189.064270,663.554810 190.067749,665.593384 
	C188.102829,667.421509 189.990845,668.784058 190.584290,669.986267 
	C191.568008,671.979187 192.282745,673.786255 190.228790,675.862793 
	C186.545380,671.475098 183.210602,666.831177 178.539993,662.962891 
	C175.800537,655.000610 174.466690,646.903381 173.035828,638.415771 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M185.226105,571.146057 
	C188.585007,566.603943 193.134781,563.273193 197.677002,559.463501 
	C204.763855,551.089661 213.043152,545.216858 224.077545,543.369873 
	C224.777618,543.607849 225.128525,543.715027 226.015961,543.946777 
	C222.120956,546.777039 217.689423,549.482727 213.063629,552.463867 
	C202.532822,557.285278 194.551208,564.954041 186.245697,572.724609 
	C185.784653,572.338989 185.623032,571.818909 185.226105,571.146057 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M176.691315,541.145996 
	C176.990555,542.081604 176.972260,543.159302 176.988220,544.640991 
	C177.022476,545.044922 176.998184,545.016235 177.014221,545.013428 
	C176.768066,545.191895 176.537247,545.406860 176.183167,545.835327 
	C176.028564,546.015259 176.000427,546.002441 176.012421,546.013184 
	C175.360474,546.811768 175.316010,547.828979 175.055496,549.043945 
	C175.039597,549.522461 174.982513,549.707886 174.812149,550.161377 
	C174.055817,551.009033 173.721863,551.785278 173.168594,552.795044 
	C172.981674,553.049194 172.960144,552.995483 172.978806,552.973999 
	C172.125488,554.454590 171.253525,555.956604 170.210510,557.745117 
	C169.740814,551.538696 173.369629,546.531555 176.691315,541.145996 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M186.929077,641.417114 
	C189.894714,641.603638 189.352371,644.269653 189.998428,646.609619 
	C189.587540,646.989197 189.173248,646.989014 188.453308,646.935852 
	C187.749588,645.186096 187.351532,643.489319 186.929077,641.417114 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M199.190582,566.100403 
	C199.990921,564.197144 201.754211,563.235046 203.657425,562.017944 
	C204.366470,564.623962 201.833191,565.208557 200.305634,566.863708 
	C199.882492,566.679382 199.686996,566.417297 199.190582,566.100403 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M175.461685,587.013367 
	C175.239334,585.411133 175.878204,584.194336 177.776321,583.850220 
	C178.214310,585.680176 177.076538,586.372803 175.461685,587.013367 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M165.847260,612.708740 
	C165.405029,613.014587 165.029037,613.010681 164.370819,613.007263 
	C164.129120,612.019653 164.057144,610.931091 165.383789,610.765686 
	C165.490829,610.752319 165.733734,611.828918 165.847260,612.708740 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M165.292969,600.959839 
	C164.886169,602.146667 165.205353,604.062744 163.651810,603.454529 
	C162.457108,602.986694 163.852966,601.927917 164.473480,600.960449 
	C164.911911,600.724976 165.105911,600.695312 165.292969,600.959839 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M169.317902,594.955688 
	C168.973694,594.054749 169.252075,593.319031 170.626770,593.033630 
	C170.964127,593.962769 170.604309,594.667114 169.317902,594.955688 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M167.665100,597.051147 
	C167.743591,597.778564 167.318710,598.421265 166.362823,598.963684 
	C166.275131,598.231079 166.718430,597.598755 167.665100,597.051147 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M168.708649,576.728271 
	C168.783478,577.395569 169.249939,578.272400 168.367645,578.092590 
	C167.990723,578.015869 167.999649,577.006897 168.708649,576.728271 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M172.572876,590.805298 
	C172.496552,591.564758 172.070129,592.192749 171.401566,592.978149 
	C171.159439,593.135559 170.926758,592.939331 170.803314,592.843262 
	C170.843475,592.273804 171.007065,591.800415 171.354919,591.152222 
	C171.767059,590.876221 171.994919,590.775024 172.572876,590.805298 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M167.842697,596.863770 
	C167.963455,596.262939 168.192947,595.752625 168.649384,595.072266 
	C168.876312,594.902283 169.017715,595.020203 169.088943,595.082886 
	C168.970901,595.679321 168.781631,596.213074 168.380432,596.941345 
	C168.168472,597.135864 167.951447,596.954285 167.842697,596.863770 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M164.860733,600.878662 
	C164.950089,600.249146 165.182266,599.743713 165.623123,599.050781 
	C165.831818,598.863403 166.073532,599.063538 166.200104,599.163086 
	C166.122147,599.796143 165.917603,600.329773 165.499542,601.058716 
	C165.286026,601.254150 165.003540,601.002625 164.860733,600.878662 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M175.244003,587.196106 
	C175.106598,587.795349 174.850250,588.302307 174.155853,588.754272 
	C173.953583,588.204956 174.189377,587.710632 174.658936,587.064331 
	C174.892685,586.912292 175.125076,587.103760 175.244003,587.196106 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M174.003571,589.006409 
	C174.023315,589.445862 173.844681,589.715454 173.184967,589.867065 
	C172.965927,589.528748 173.125351,589.240356 173.501282,588.825684 
	C173.717773,588.699280 173.907822,588.904480 174.003571,589.006409 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M172.988831,590.731506 
	C172.693497,590.947937 172.463974,590.959167 171.886826,590.973877 
	C171.791077,590.680176 172.042953,590.382935 172.550674,589.951355 
	C172.806503,589.817078 172.953964,589.957031 173.028687,590.027466 
	C173.103424,590.097839 173.054672,590.526245 172.988831,590.731506 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M201.758728,638.376831 
	C197.890091,624.451660 193.695206,610.903442 191.823776,595.590088 
	C195.045120,598.148926 194.374100,601.409668 196.686462,603.303101 
	C198.008911,605.737549 198.868439,608.030151 199.745178,610.703613 
	C199.938019,611.017334 199.995956,611.014648 199.968918,611.008545 
	C204.385132,624.162842 211.685486,635.978699 217.788330,648.760803 
	C218.007111,649.060608 218.022476,648.986755 217.986450,648.975525 
	C218.255035,649.250122 218.531647,649.560852 218.909317,650.181396 
	C218.703400,653.707397 221.172668,655.507568 222.825287,657.688904 
	C227.190811,663.451172 230.904541,669.796692 237.434692,673.994751 
	C238.305359,674.362122 238.907516,674.504395 239.744644,674.843872 
	C239.976669,675.049622 239.976318,674.999756 239.967102,675.024414 
	C241.391907,675.956360 242.905670,676.779724 243.652283,678.797729 
	C252.052963,686.932251 261.757416,692.789734 271.757690,698.815674 
	C272.109467,701.886047 271.827759,703.900940 268.641388,700.938660 
	C268.116516,700.450806 267.176788,700.409180 266.060211,700.194153 
	C264.846283,700.908081 263.848358,701.005920 262.895294,700.685547 
	C254.512955,697.866882 245.942841,695.443909 238.673615,689.388672 
	C228.003677,678.590637 218.739792,667.184265 211.802734,654.003967 
	C211.151505,652.766663 210.418976,651.072144 208.160431,652.674011 
	C207.688141,653.004517 207.488007,653.123291 206.945068,653.318542 
	C206.374374,653.338379 206.146500,653.281738 205.673767,652.970947 
	C205.196503,652.309937 205.002777,651.885498 204.751282,651.110535 
	C203.799164,647.726257 202.731964,644.724426 202.247894,641.253662 
	C202.063568,640.968811 202.001511,640.997559 202.029938,640.978027 
	C201.389557,640.325867 201.528061,639.513733 201.758728,638.376831 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M206.737457,653.440979 
	C208.363815,649.950562 209.602402,647.355591 212.328766,652.442810 
	C219.301788,665.454163 227.987106,677.217529 238.820892,687.741150 
	C238.834198,690.543945 241.151474,691.931396 241.707123,694.142090 
	C242.155243,695.924927 242.517441,697.652588 241.259766,699.652466 
	C236.545425,699.532532 232.080261,699.047180 227.454468,697.650269 
	C224.031967,692.088074 220.886078,686.709412 217.448334,681.163513 
	C213.077850,673.879761 210.262573,666.195862 206.925064,658.345825 
	C206.614868,657.811890 206.504395,657.589111 206.273590,657.010498 
	C205.929184,655.640503 205.951874,654.655396 206.737457,653.440979 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M241.451736,699.971924 
	C242.648911,695.569397 237.864655,692.637146 238.685913,688.273438 
	C246.500519,694.488953 255.976334,696.792358 265.333984,700.174561 
	C266.377899,703.179993 264.699341,702.454285 262.896057,702.235474 
	C255.903687,701.386963 248.888794,700.724304 241.451736,699.971924 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M607.275269,260.526550 
	C607.208191,260.065491 607.578430,259.979462 607.736450,259.873901 
	C608.785461,259.937683 609.555786,260.512970 610.839966,260.535980 
	C613.816406,260.700073 616.500732,260.263947 619.057861,261.092590 
	C620.874146,261.681122 622.479309,262.807404 622.315491,264.923920 
	C622.147461,267.094849 620.125183,267.044006 618.533203,267.317200 
	C616.814880,267.612091 614.991150,267.191101 613.324463,268.216675 
	C619.728699,266.876892 625.693970,268.216827 631.724243,271.214294 
	C632.347473,271.873932 632.533020,272.343445 632.507751,273.254028 
	C632.196472,274.115845 631.816711,274.427673 630.924561,274.587158 
	C629.398621,274.783051 628.903503,273.026978 627.295959,273.745422 
	C623.807373,274.671783 620.762207,273.023254 617.613708,273.388000 
	C615.754639,273.603363 613.574158,272.863831 612.110291,275.346802 
	C627.875061,274.823944 641.582764,280.635223 655.226318,287.924744 
	C656.117676,288.701508 656.483093,289.358765 656.395508,290.554382 
	C656.096619,291.092743 655.903381,291.258026 655.349976,291.532379 
	C649.100891,290.920746 644.040649,287.829498 638.574158,285.900482 
	C630.698547,283.121338 622.763000,280.675323 614.238953,281.564728 
	C613.171997,281.676056 613.093994,281.749939 613.095703,282.702393 
	C613.096069,282.914062 613.951843,283.081390 614.697449,283.505859 
	C615.098450,283.933563 615.204773,284.149811 615.250183,284.721466 
	C614.361328,286.342102 612.307800,285.895996 611.639465,287.671082 
	C618.526367,288.172577 625.445251,288.209320 631.542114,292.591003 
	C631.762451,293.402710 631.758789,293.879578 631.500671,294.675995 
	C629.233459,296.528809 627.215393,295.220459 625.234375,294.696411 
	C621.546936,293.720886 617.842773,292.982391 614.031677,293.503143 
	C612.764526,293.676300 610.360779,293.670929 612.888306,296.233337 
	C613.718567,296.906342 614.099792,297.482941 614.278320,298.528809 
	C612.985779,300.457397 610.058167,300.672821 610.370911,303.912354 
	C610.386841,304.710510 610.402527,305.170410 610.462769,305.982544 
	C611.370728,309.196625 613.847412,308.378998 615.802490,308.558716 
	C619.343872,308.884277 622.968384,308.755615 626.145935,311.404175 
	C625.990479,312.884796 625.180725,313.478943 623.846924,314.016174 
	C620.351440,314.572540 617.183899,314.194702 614.035889,314.388977 
	C612.702393,314.471313 610.873291,313.867737 610.656128,316.466217 
	C610.788208,317.231018 610.830627,317.674927 610.832886,318.462677 
	C610.168823,321.123993 610.911682,322.639954 613.635315,323.368439 
	C614.059814,323.743500 614.194092,323.931274 614.331604,324.466431 
	C613.564087,327.090607 608.501465,326.650391 610.706909,331.066864 
	C610.947754,331.861084 611.043091,332.328552 611.175049,333.156799 
	C611.871582,336.066162 613.887817,335.143311 615.306030,334.878265 
	C620.363037,333.933197 625.242676,335.320343 630.189148,335.753265 
	C631.652039,335.881287 633.532532,336.207703 633.251404,338.219025 
	C632.984192,340.130096 631.105957,340.125671 629.628113,339.960114 
	C624.151855,339.346588 618.691284,339.185638 613.219788,340.237122 
	C617.507080,340.516296 621.800415,340.530548 626.094543,340.541840 
	C627.758484,340.546234 629.432007,340.488007 631.065125,340.901825 
	C632.917358,341.371155 634.011230,342.462494 633.716797,344.485413 
	C633.436279,346.413513 631.980591,346.805847 630.374390,346.681030 
	C625.386108,346.293396 620.380737,346.647705 615.392334,346.263062 
	C613.441650,346.112671 611.410156,345.642609 609.480103,347.359314 
	C609.197693,347.941681 609.073853,348.171722 608.693298,348.702576 
	C607.996155,349.335785 607.501099,349.476868 606.606567,349.229126 
	C605.593933,328.468567 606.872803,307.926331 606.901489,287.370483 
	C606.913757,278.576019 607.187439,269.781921 607.275269,260.526550 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M606.206665,349.432495 
	C606.637207,349.016235 607.013000,349.001770 607.670471,349.008301 
	C609.513306,348.558289 609.180542,349.795715 609.338013,350.922913 
	C609.275696,351.953491 609.164185,352.631500 608.919800,353.634949 
	C608.703369,354.164795 608.588257,354.364441 608.195923,354.770813 
	C607.653259,355.043945 607.387756,355.110352 606.731506,355.306335 
	C606.277832,353.568695 606.214844,351.701508 606.206665,349.432495 
z"/>
<path fill="#551D67" opacity="1.000000" stroke="none" 
	d="
M535.278870,485.338745 
	C535.078369,482.985107 535.054565,480.923859 535.096680,478.423187 
	C538.085815,477.158356 537.013184,474.704102 536.928894,472.971741 
	C536.601257,466.234375 537.736267,459.860138 539.838501,453.422028 
	C541.238647,449.134033 545.739258,446.479523 545.342041,441.246124 
	C545.200928,439.387939 547.937988,440.718384 549.162476,440.740967 
	C551.414734,440.782471 551.758789,443.061279 551.780212,444.838379 
	C551.801697,446.626068 551.405579,448.450226 550.978699,450.206482 
	C548.932373,458.625275 551.771423,467.052307 550.936951,475.427521 
	C549.785828,486.979767 550.261047,498.548035 550.005188,510.108307 
	C549.966858,511.841705 549.725830,513.610291 548.227112,514.552063 
	C546.544006,515.609558 545.281982,514.006958 543.778076,513.434448 
	C537.728516,511.131622 536.126099,506.751892 536.955811,500.827393 
	C537.127258,499.603271 537.399414,498.106934 535.566345,497.132141 
	C535.155945,495.293701 535.113525,493.559875 535.099854,491.393738 
	C536.219055,489.244904 535.271301,487.403259 535.278870,485.338745 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M529.014160,460.082703 
	C529.650208,458.099518 528.132568,455.638885 530.589355,453.969269 
	C532.412292,455.449036 532.535522,455.490448 532.947021,454.266388 
	C533.288269,453.251495 532.870239,451.513306 534.716431,452.136902 
	C536.278625,452.664551 536.085999,454.167480 535.561523,455.476379 
	C535.315857,456.089355 535.064331,457.047241 534.617554,457.179321 
	C529.299438,458.751740 531.304443,463.175751 530.343018,466.768494 
	C529.979309,464.572693 529.615601,462.376862 529.014160,460.082703 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M538.987793,441.011353 
	C539.411255,441.133698 539.845337,441.245728 540.279480,441.357727 
	C539.953064,441.989319 539.576111,441.718719 539.106506,441.197815 
	C539.015564,440.977325 538.998413,441.001007 538.987793,441.011353 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M523.794006,469.912354 
	C523.724854,470.170135 523.292542,470.097595 523.101685,469.989807 
	C522.954773,469.528595 522.998718,469.175201 523.128174,468.568604 
	C523.430237,468.761810 523.646729,469.208191 523.794006,469.912354 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M414.255890,694.684082 
	C414.036957,692.500916 411.969910,693.652283 410.913727,691.938721 
	C412.555023,692.404053 413.864349,690.318848 414.748322,691.895264 
	C415.105591,692.532410 417.029114,694.188599 415.198029,695.569824 
	C415.083099,695.656616 414.825562,695.714661 414.740601,695.648865 
	C414.537262,695.491394 414.397247,695.252075 414.255890,694.684082 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M407.419586,677.518188 
	C408.121613,676.567810 408.755737,675.952332 409.626221,675.184692 
	C411.049988,675.885071 411.000885,677.020142 410.541992,678.588867 
	C410.456360,679.175903 410.423492,679.410767 410.086060,679.829346 
	C408.462769,679.865356 406.796173,680.108948 407.419586,677.518188 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M403.121582,676.308594 
	C405.432922,676.376221 405.640381,674.150696 406.977570,672.393494 
	C406.977570,673.972473 406.977570,675.034363 406.941437,676.441772 
	C405.629883,677.686523 404.358032,678.510132 403.121582,676.308594 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M402.085571,666.912720 
	C402.748444,666.929138 402.951965,667.138489 403.006104,667.765869 
	C403.132721,668.193481 403.222809,668.383911 403.048218,668.746887 
	C402.783600,668.919495 402.851562,668.880432 402.820435,668.856079 
	C402.407654,668.892944 402.026031,668.954163 401.357880,669.063171 
	C400.910553,669.272766 400.749725,669.434631 400.303650,669.785522 
	C398.811737,669.853516 396.885895,670.790039 397.674744,668.002563 
	C398.735382,667.231323 399.552734,666.801270 400.916809,666.963867 
	C401.449493,666.965759 401.630829,666.945251 402.085571,666.912720 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M399.974792,670.316528 
	C400.196930,669.701538 400.375488,669.428528 400.812683,669.133301 
	C401.114868,671.190979 400.607178,673.083008 399.081573,674.903748 
	C398.364105,673.126221 399.656464,671.988159 399.974792,670.316528 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M411.007477,703.495605 
	C411.060791,702.344971 410.595734,701.995605 409.891815,701.855408 
	C410.077728,701.157227 410.741608,701.200623 410.994843,701.499023 
	C411.703491,702.334229 412.460938,703.235413 412.796539,704.244446 
	C413.049622,705.005493 412.049866,705.214539 411.441803,705.182068 
	C411.270630,705.172852 411.144684,704.318054 411.007477,703.495605 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M401.223572,666.638794 
	C400.663361,667.958069 399.763550,668.223145 398.330933,667.946167 
	C397.975342,667.828674 397.975189,667.508789 397.980774,667.348999 
	C398.015503,666.527771 398.199280,665.921204 398.864960,665.186951 
	C399.424866,665.063843 399.747070,665.103455 400.317993,665.067749 
	C400.766724,665.458435 400.972839,665.874878 401.223572,666.638794 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M407.354340,692.127991 
	C409.453400,693.710449 406.291321,692.800476 406.817719,693.777344 
	C406.246582,693.675598 405.675415,693.573853 405.104279,693.472107 
	C405.746277,693.035095 406.388275,692.598083 407.354340,692.127991 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M402.341187,678.599304 
	C400.952118,678.910095 399.774170,678.969299 397.740417,679.071411 
	C399.841919,677.916443 401.132446,677.489075 402.341187,678.599304 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M422.556580,710.759705 
	C421.655243,710.869751 421.052521,710.811890 420.449829,710.754089 
	C420.869110,710.437134 421.281616,710.110718 421.708923,709.804993 
	C422.801483,709.023376 423.011780,709.544373 422.556580,710.759705 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M415.932556,710.994995 
	C416.674469,711.553650 417.151245,712.012756 416.648499,712.641663 
	C416.535217,712.783386 416.094299,712.840881 415.934174,712.736877 
	C415.206696,712.264587 414.957489,711.643555 415.932556,710.994995 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M398.785522,664.922974 
	C399.795135,665.813599 399.076019,666.273926 398.301239,666.996582 
	C396.243103,666.833862 397.505005,665.598633 397.624329,664.622559 
	C398.129211,664.589233 398.295776,664.730225 398.785522,664.922974 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M415.548401,702.949585 
	C414.380829,703.062805 413.812866,702.617126 414.138336,701.599976 
	C414.197357,701.415405 414.698700,701.182129 414.715363,701.202393 
	C415.100647,701.670227 415.447144,702.170105 415.548401,702.949585 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M410.776794,679.753540 
	C411.017334,680.854126 411.073059,681.719543 409.843140,682.152100 
	C409.541138,681.572449 409.640930,681.134399 409.761108,680.354736 
	C409.781433,680.013062 409.954865,680.047729 409.976196,679.961914 
	C410.182678,679.752563 410.367889,679.629150 410.776794,679.753540 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M416.270264,690.477051 
	C416.686066,690.548279 418.229095,688.968628 417.328857,691.203857 
	C416.811218,691.044128 416.605713,690.840027 416.270264,690.477051 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M402.969604,672.436157 
	C403.091003,672.068787 403.561310,671.973145 403.801086,671.981689 
	C404.337891,672.730774 404.135376,673.347656 403.269836,674.049683 
	C402.926514,673.750305 402.887390,673.276917 402.969604,672.436157 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M423.309387,704.337524 
	C423.546295,704.348694 423.596436,704.545410 423.646545,704.742126 
	C423.471893,704.669128 423.297272,704.596130 423.309387,704.337524 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M414.250000,709.748901 
	C414.272644,709.223816 414.563568,708.849854 414.872955,709.413818 
	C414.926270,709.511108 414.633118,709.798340 414.250000,709.748901 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M422.258789,706.214478 
	C422.579132,706.212585 422.660400,706.442749 422.741669,706.672974 
	C422.501007,706.597534 422.260376,706.522095 422.258789,706.214478 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M407.740021,689.722778 
	C407.364594,689.764343 407.236816,689.575134 407.109009,689.385986 
	C407.401886,689.421326 407.694763,689.456665 407.740021,689.722778 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M404.745850,690.719971 
	C404.367798,690.763306 404.083466,690.480103 404.135193,690.390259 
	C404.444733,689.852356 404.728516,690.210632 404.745850,690.719971 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M408.698730,682.673584 
	C409.175629,682.686584 409.356964,682.931519 409.394531,683.610107 
	C408.000336,684.385010 408.089691,683.728699 408.698730,682.673584 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M374.062195,546.843567 
	C372.479309,545.677856 372.736481,543.930176 373.739288,541.831299 
	C376.708069,543.145386 372.775543,544.841248 374.062195,546.843567 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M403.997742,509.659821 
	C402.686401,509.162750 403.100677,507.789642 402.459045,506.388367 
	C404.603302,506.984589 403.726532,508.372894 403.997742,509.659821 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M404.005310,509.996643 
	C404.902954,510.529602 405.004852,511.404907 405.005188,512.659790 
	C405.001221,512.997559 405.000000,513.000000 404.999390,513.001221 
	C404.836182,513.173584 404.673584,513.344666 404.260864,513.265137 
	C404.010712,513.014648 404.000000,513.000610 403.992401,512.992981 
	C403.987549,512.242126 403.990265,511.498871 403.990051,510.384155 
	C403.987152,510.012695 403.999115,510.000854 404.005310,509.996643 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M381.984772,538.762756 
	C381.745270,538.659180 381.497467,538.310547 381.269867,537.949158 
	C381.265442,537.942139 381.499084,537.785156 381.621643,537.698120 
	C381.740631,537.970825 381.859650,538.243591 381.984772,538.762756 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M400.006165,528.995483 
	C400.130463,529.142395 400.248199,529.294617 400.365936,529.446838 
	C400.276276,529.397156 400.186615,529.347412 400.042694,529.156189 
	C399.988434,529.014648 399.999573,529.000732 400.006165,528.995483 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M407.005676,532.995972 
	C406.804413,532.854736 406.595245,532.719727 406.386108,532.584778 
	C406.576263,532.598694 406.766388,532.612610 406.969849,532.822632 
	C406.983154,533.018677 406.997833,533.002197 407.005676,532.995972 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M382.004120,538.996826 
	C382.124908,539.271790 382.241180,539.549927 382.199646,539.929688 
	C382.041809,540.031189 382.000183,539.998169 381.980408,539.979614 
	C381.960602,539.960999 381.986908,539.485352 381.988892,539.247314 
	C381.990906,539.009216 381.999603,539.000061 382.004120,538.996826 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M202.032898,641.363220 
	C204.568481,643.583801 204.724335,647.175232 205.943726,650.699951 
	C205.454102,651.517334 205.479813,652.043335 205.867065,652.802917 
	C206.058517,653.007263 205.996338,652.995178 206.008926,652.966187 
	C206.877380,654.000183 206.280869,655.289978 206.794418,656.725891 
	C207.020157,657.010071 206.993073,657.002869 206.998505,656.990051 
	C209.276245,662.733582 211.527847,668.497620 213.189697,674.685547 
	C209.381119,677.086914 208.704590,680.427612 208.991211,684.594971 
	C204.995697,677.432800 200.187622,670.225037 197.566574,662.002625 
	C196.186310,657.672607 193.650955,653.964905 191.914429,649.472290 
	C193.379562,647.542480 194.580704,645.519165 197.381149,645.964905 
	C200.522491,646.464905 201.760941,644.590332 202.032898,641.363220 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M213.210114,675.192871 
	C210.815964,669.292175 208.065170,663.818665 206.977036,657.376587 
	C211.191132,661.828918 211.666595,668.380249 214.678879,673.788025 
	C215.779022,675.763062 216.266129,678.079590 217.094696,680.618286 
	C214.568115,680.026672 214.578094,677.350952 213.210114,675.192871 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M477.485565,951.573425 
	C477.140839,951.649719 476.694092,951.500122 476.098633,951.162964 
	C476.427795,951.099487 476.905670,951.223511 477.485565,951.573425 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M429.695312,931.355774 
	C429.872681,931.235779 430.235718,931.335876 430.783691,931.652222 
	C430.606079,931.770935 430.243500,931.673401 429.695312,931.355774 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M426.703796,946.016602 
	C427.618561,946.639343 422.964996,948.990356 427.923645,948.424438 
	C428.899017,948.313171 427.327545,949.680298 426.881287,950.934265 
	C426.153351,951.461731 425.767029,951.568604 425.199219,951.958496 
	C422.933502,954.336487 420.476318,955.888550 417.352234,956.973694 
	C417.286163,956.527954 417.560730,956.047180 417.958344,955.317322 
	C418.081390,955.068298 418.324982,954.661255 418.121094,954.782410 
	C416.833435,955.230896 415.749695,955.558228 414.341919,955.951538 
	C413.832245,955.417908 413.646606,954.818237 413.221558,954.003418 
	C417.457916,951.248047 421.413483,947.810730 426.703796,946.016602 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M374.339966,948.033691 
	C374.506500,947.061462 375.424133,947.020081 376.689209,946.995667 
	C376.528870,947.983154 375.580811,947.955750 374.339966,948.033691 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M380.331116,946.045166 
	C380.519104,945.108887 381.419800,945.019104 382.689636,944.996399 
	C382.524658,945.976990 381.587311,945.989319 380.331116,946.045166 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M377.332092,947.048584 
	C377.510010,946.085815 378.429504,946.045166 379.689880,946.001221 
	C379.526428,946.976013 378.596130,947.008240 377.332092,947.048584 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M383.302185,945.028320 
	C383.464203,944.698303 383.938751,944.364624 384.720062,944.019836 
	C384.556152,944.347351 384.085449,944.685974 383.302185,945.028320 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M387.999969,957.007690 
	C388.375000,956.792908 388.737793,956.559631 389.100586,956.326355 
	C389.169922,956.460876 389.239288,956.595398 389.308655,956.729858 
	C389.020142,956.828674 388.731628,956.927551 388.200256,956.991455 
	C387.957428,956.956421 387.987732,956.989258 387.999969,957.007690 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M380.016632,955.021118 
	C380.114471,954.984497 380.197662,954.931641 380.124451,954.928223 
	C379.968079,954.977600 380.001984,955.004883 380.016632,955.021118 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M383.998169,955.997803 
	C384.127258,956.024231 384.009399,954.964355 384.176941,955.958496 
	C384.002960,956.002441 384.000000,956.000000 383.998169,955.997803 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M164.131821,891.401489 
	C163.880203,891.119751 163.433090,890.993469 163.200775,890.998962 
	C164.020660,888.899048 165.906326,889.825928 167.246109,890.168701 
	C176.930466,892.645569 186.567871,895.305969 196.577026,898.055786 
	C197.052002,898.484192 197.170105,898.765076 197.069489,899.447144 
	C191.509125,899.028381 186.480240,896.591064 180.524261,896.829834 
	C179.593719,893.717285 176.625534,895.203430 174.918076,894.302124 
	C172.828949,893.199280 170.271881,892.982971 167.554108,892.382385 
	C166.128250,892.659119 165.205124,892.375061 164.131821,891.401489 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M197.062561,900.108643 
	C196.865204,899.574280 196.879684,899.300110 196.914032,898.614685 
	C203.674423,899.932922 210.714661,900.348633 217.627838,903.017578 
	C217.975250,903.190735 217.968109,903.677551 217.956726,903.921509 
	C216.286209,904.056335 214.627090,903.947205 212.558990,903.759644 
	C207.191452,902.577209 202.232910,901.473083 197.062561,900.108643 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M161.907349,871.277954 
	C162.491776,871.894287 162.982117,872.788635 163.744431,873.843262 
	C163.060852,876.797913 161.885834,879.541565 161.223831,882.403870 
	C160.751068,884.447876 159.866577,885.163757 157.874985,884.962341 
	C156.575623,884.830994 155.038773,885.157959 154.405457,883.693604 
	C153.608978,881.851990 155.506592,881.218872 156.650879,879.924988 
	C159.947510,878.658630 159.827301,875.427979 161.477356,873.027832 
	C161.662308,872.322388 161.737778,871.939087 161.907349,871.277954 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M168.433533,878.464600 
	C167.016190,881.164307 166.771286,884.636292 163.272186,886.119629 
	C162.305313,882.543579 164.815689,880.347290 165.921265,877.369141 
	C166.661087,876.595703 167.110428,876.879822 167.690430,877.567261 
	C167.985168,877.949158 168.116821,878.093323 168.433533,878.464600 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M161.278793,872.807983 
	C162.670731,876.265198 159.957245,878.544617 158.585098,881.240540 
	C158.361694,881.679443 157.505859,880.898621 157.053772,880.027344 
	C157.225006,876.823669 158.816360,874.700623 161.278793,872.807983 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M167.927673,877.463989 
	C167.416306,877.597412 166.979095,877.389893 166.305176,877.113403 
	C167.178284,874.460083 168.288086,871.875793 169.716705,869.150208 
	C171.340134,872.210449 168.762268,874.438965 167.927673,877.463989 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M172.829285,863.201294 
	C174.760056,865.137573 173.640594,866.196777 171.288055,866.942139 
	C171.038498,865.572754 171.711304,864.437866 172.829285,863.201294 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M694.526550,781.575378 
	C695.141235,783.820251 697.970947,785.304626 696.175415,787.958740 
	C693.405151,789.554626 693.518127,792.243652 693.035156,794.616211 
	C691.508667,802.115601 691.749390,809.817749 690.522522,817.354797 
	C690.260376,818.965332 690.351196,820.719788 688.518433,821.900391 
	C687.796082,821.913818 687.452637,821.939819 686.593994,822.002441 
	C684.845703,817.132141 685.670166,812.073975 684.980713,807.120422 
	C684.644043,804.701843 684.733887,802.231262 684.131470,799.489868 
	C683.839661,798.957092 683.717102,798.748230 683.455688,798.206055 
	C683.123718,797.188049 683.097046,796.496582 683.336914,795.493103 
	C683.800049,794.516357 684.468323,793.982422 684.299683,792.823242 
	C684.113281,791.943542 684.114197,791.345581 684.296326,790.450073 
	C684.560608,789.630676 684.879333,789.122070 684.298218,788.411133 
	C683.513123,788.051941 682.984802,787.810547 682.311157,787.239868 
	C679.819519,785.510437 681.909485,783.039795 680.736328,780.801514 
	C679.066406,782.372437 677.034485,783.011353 677.902893,786.111267 
	C678.729553,789.061890 675.595581,791.519714 672.317505,791.720337 
	C669.873108,791.869934 666.950134,789.518982 664.869385,793.155884 
	C662.326660,794.540771 659.928528,794.535583 657.330017,792.774414 
	C657.551270,788.680725 653.312744,789.770142 652.060242,787.352905 
	C651.852905,786.817749 651.719543,786.642578 651.679871,786.149658 
	C652.209778,785.311829 652.772522,784.976196 653.705688,784.636780 
	C654.235962,784.554260 654.451294,784.556580 654.971436,784.655396 
	C656.181885,785.250427 657.088135,785.747192 658.452026,785.940002 
	C658.976685,786.051208 659.186279,786.106201 659.702881,786.280396 
	C660.204224,786.505676 660.398560,786.611755 660.866333,786.906921 
	C664.859680,789.190735 668.703064,789.336426 672.881958,787.593567 
	C674.562683,785.093079 672.941467,783.456238 671.648376,782.161011 
	C665.945435,776.447998 660.766541,770.240784 654.734314,764.367249 
	C652.629761,760.507996 652.018860,756.288208 648.897095,752.953491 
	C645.490784,751.201599 643.498718,752.251343 642.639282,755.815857 
	C643.343933,757.524414 643.796204,758.971741 644.141052,760.779602 
	C644.321411,761.693542 644.397217,762.310120 644.874390,763.121704 
	C645.277466,763.737793 645.482666,764.108582 645.771851,764.802124 
	C646.033020,765.764893 646.056885,766.426636 645.947266,767.426636 
	C645.687012,768.432922 645.320435,768.986023 644.395020,769.472290 
	C643.846741,769.577087 643.621033,769.576355 643.071655,769.477783 
	C642.356445,769.161926 641.995544,768.901184 641.435913,768.362915 
	C640.506409,767.267090 640.170471,766.242126 639.766052,764.900635 
	C639.507202,764.200806 639.336426,763.808105 638.983765,763.135010 
	C637.462952,761.086609 637.809937,757.635498 635.086975,757.489624 
	C632.293274,757.340027 631.456787,760.451843 630.059570,762.422729 
	C629.578491,763.101440 629.085754,763.755493 628.076538,764.387695 
	C626.994080,764.645264 626.330200,764.461243 625.582397,763.629395 
	C624.864685,761.627869 625.512756,760.129944 626.333252,758.356934 
	C626.769348,757.576355 627.073242,757.082153 627.205566,756.246094 
	C627.206970,755.663696 627.221130,755.341248 627.288330,754.810974 
	C626.682251,754.090637 626.868713,755.141968 626.169312,755.249023 
	C623.514282,756.652283 620.921936,757.725708 619.216858,759.724182 
	C612.412231,767.699524 602.857849,769.365234 593.421204,771.149231 
	C587.433167,772.281250 581.435059,773.453247 575.185974,772.691467 
	C569.935303,772.051392 565.378723,775.361572 559.959961,776.371094 
	C556.765747,776.599365 553.977295,776.519592 550.778870,776.385559 
	C549.836609,776.267639 549.320618,776.135620 548.490601,775.749512 
	C546.100525,772.665222 547.952271,771.434143 550.347290,770.440857 
	C552.582520,769.513977 554.924377,770.223206 557.205566,769.979736 
	C555.357849,770.103821 553.524353,769.834595 551.325317,769.845337 
	C549.715454,770.022827 548.528442,769.602783 546.928650,769.439270 
	C545.778198,769.401733 545.006775,769.381958 543.837280,769.387573 
	C540.894775,769.543518 538.484070,768.842163 536.097534,768.129333 
	C534.694641,767.710327 532.809448,767.126099 533.212830,765.335266 
	C533.596008,763.634460 535.593079,763.655334 537.026245,763.847046 
	C541.664551,764.467468 546.316650,764.447510 550.976624,764.570435 
	C556.379395,764.712952 561.470703,763.627197 566.664917,762.187012 
	C573.863037,760.191162 580.774414,757.020996 588.898010,758.709778 
	C592.485962,759.455688 596.751587,756.476990 600.858887,755.739807 
	C601.677612,755.592773 602.515747,755.584412 603.739014,755.575439 
	C605.141357,755.605713 606.136414,755.478760 607.471924,755.150635 
	C611.572388,754.179871 615.042175,752.531067 618.942444,751.028076 
	C620.146973,750.538391 621.040710,750.240479 622.295898,749.942444 
	C623.516724,749.702576 624.426392,749.678772 625.598694,749.268005 
	C627.621094,748.648743 629.184265,747.827271 630.992981,746.728638 
	C631.663940,746.258423 632.039429,745.966980 632.685425,745.406982 
	C635.074219,743.796448 635.971741,742.003174 634.624817,739.677551 
	C633.101501,737.047607 630.955261,735.355469 627.671326,736.011963 
	C620.655579,737.414734 613.791199,739.443665 606.837463,741.098938 
	C586.747498,745.881104 566.531067,747.253723 546.147522,743.017517 
	C545.170654,742.814514 544.198059,742.590881 543.251160,742.269287 
	C540.290222,741.263611 540.450928,739.725647 542.732544,738.189758 
	C546.189392,735.862671 549.863220,733.938477 554.462341,733.323486 
	C562.881287,734.777649 570.769470,736.971985 579.340698,737.299072 
	C583.631958,739.799683 587.840271,738.456543 592.303345,738.173889 
	C595.321106,737.526611 598.188660,737.686523 601.021912,735.870972 
	C597.331360,733.740906 593.523621,732.924683 589.482178,731.658203 
	C588.224304,731.089722 587.228333,730.640015 586.706421,729.834290 
	C582.717957,723.677185 576.729675,723.203735 570.162109,723.382812 
	C563.921387,723.552979 557.601685,724.167175 551.023254,722.546631 
	C541.107971,724.605042 531.784668,727.436707 522.648560,730.819092 
	C519.508362,731.981750 517.533508,734.960144 515.147522,737.247803 
	C505.580139,746.421082 494.895844,753.793030 482.103760,757.778748 
	C480.990845,758.125488 479.895325,758.497131 478.360779,758.169312 
	C477.690277,755.076416 479.908051,754.700562 481.924133,753.815552 
	C484.244385,752.796997 487.412689,753.606323 488.934448,750.343872 
	C491.633209,746.139465 496.662537,745.519348 499.863281,741.867615 
	C500.273071,741.474426 500.440277,741.319519 500.869141,740.941895 
	C501.313141,740.578613 501.495392,740.438171 501.961700,740.100708 
	C508.798096,735.121338 514.620972,729.483276 521.015991,723.942261 
	C528.689331,721.800964 535.985962,719.671997 543.204041,717.196777 
	C547.279968,715.799072 551.904541,715.915161 556.026184,717.013428 
	C563.060669,718.888062 569.075745,717.835266 574.775391,712.779236 
	C576.311035,712.557739 577.011841,713.316956 577.951599,714.319092 
	C578.207336,716.633667 578.699646,718.122192 581.572449,717.231201 
	C582.581604,717.488037 583.193665,717.809082 584.053589,718.403931 
	C585.830078,720.340149 587.165283,722.249084 589.712036,723.294922 
	C590.677490,724.061035 591.138062,724.829285 591.987793,725.659546 
	C592.419189,725.947693 592.588745,726.064148 593.001160,726.364624 
	C593.842896,727.058838 594.412292,727.609985 595.431580,728.031860 
	C596.480164,728.417175 597.250305,728.692261 598.353333,728.977478 
	C601.842468,729.823792 605.192993,730.200745 607.716675,733.150146 
	C608.327881,733.734619 608.726929,734.109924 609.549316,734.236206 
	C609.992554,734.194031 610.170776,734.157898 610.618774,734.049438 
	C611.831238,733.727295 612.767944,733.453003 614.030273,733.233276 
	C615.602234,733.210938 616.717834,732.658020 618.153198,732.108276 
	C620.850464,729.744324 618.649048,727.631165 618.130005,725.171753 
	C617.458618,723.752991 617.089294,722.521851 615.673706,721.729126 
	C614.563599,721.753784 613.879395,722.177490 612.896545,722.712524 
	C611.598816,723.294067 610.538635,723.589661 609.155945,723.988159 
	C607.267212,724.360535 605.654358,724.310425 603.801636,724.905029 
	C602.145630,725.275696 600.868713,725.696533 599.368469,726.519409 
	C598.379089,726.909790 597.682556,727.001587 596.613403,726.931763 
	C595.792908,726.739990 595.374878,726.510742 594.788940,725.909668 
	C594.523071,725.377136 594.465210,725.141663 594.437012,724.542297 
	C594.626770,723.714478 594.850830,723.283691 595.376343,722.608032 
	C595.796631,722.167786 595.978516,722.005188 596.460938,721.636719 
	C596.977356,721.322998 597.193176,721.215210 597.746277,720.982910 
	C606.459534,718.792603 614.928650,716.995911 622.407959,712.360352 
	C624.336121,711.165344 626.374207,710.769226 627.394836,713.253174 
	C628.463562,715.854126 626.967651,717.239319 624.002747,717.634216 
	C625.926331,717.534363 627.768555,716.559692 628.501587,719.293091 
	C626.774719,721.721130 625.763428,724.098022 625.416931,727.011902 
	C627.619324,728.229553 629.478943,726.535217 631.812134,726.135132 
	C637.672913,727.196594 641.582947,722.697327 646.607727,721.879639 
	C648.575073,721.559631 646.881775,719.320984 647.052246,717.619995 
	C647.143250,717.040649 647.210022,716.814392 647.462402,716.286621 
	C650.335388,714.526917 653.112305,713.401733 656.577942,713.820557 
	C658.300049,714.716492 659.784058,715.140259 661.784546,715.071045 
	C661.434143,719.035522 656.896423,717.173767 655.557190,719.605408 
	C658.911499,718.005310 662.747681,716.636292 666.594849,714.449097 
	C670.238708,713.138855 673.382568,711.605530 676.587158,709.393921 
	C677.885437,708.314453 679.025024,707.969727 680.664673,708.486084 
	C682.482666,711.095459 680.576538,712.249207 679.076843,713.413879 
	C676.765503,715.208679 674.156189,716.610046 671.771729,718.908813 
	C665.760071,723.092773 660.010559,727.025452 653.616943,730.598267 
	C652.139282,731.877014 650.765625,732.661682 649.020630,733.392334 
	C648.620911,733.632324 648.478760,733.741455 648.102051,733.942078 
	C647.867493,734.033569 648.016174,734.499573 647.846313,734.327637 
	C648.021851,734.077454 648.312378,733.900696 648.819824,733.521240 
	C650.438721,732.841064 651.757019,732.217102 653.094604,730.971680 
	C659.296265,727.608032 664.777222,723.716736 670.694397,719.862305 
	C677.179565,716.141113 682.327881,711.137939 688.704224,707.294861 
	C689.824463,707.208313 690.504883,707.419983 691.255615,708.260498 
	C691.756531,710.733521 690.283691,712.110291 688.994507,713.923950 
	C688.151123,714.809753 687.430237,715.331543 686.697754,716.284424 
	C685.826538,717.471191 684.791443,718.307312 685.776245,719.949158 
	C687.525085,722.528198 687.965820,725.282166 688.865417,728.641052 
	C690.289185,726.238220 688.577393,724.669678 688.958984,722.732422 
	C689.071777,722.145813 689.148621,721.917236 689.428955,721.387756 
	C690.281128,720.559875 690.973022,720.686218 691.993591,721.117798 
	C693.289673,721.961487 694.187927,722.732056 695.231445,723.863647 
	C696.125305,725.524536 695.771667,726.898682 695.380554,728.614868 
	C695.226257,729.406372 695.103333,729.847778 694.829468,730.596313 
	C694.095764,732.072449 693.139832,732.996460 692.378784,734.417725 
	C692.180359,734.882141 692.098816,735.062805 691.885742,735.500671 
	C690.951843,736.641357 691.793335,736.724487 692.511108,737.212524 
	C692.755493,737.677124 692.824829,737.882202 692.934448,738.418030 
	C692.949463,739.705688 692.686279,740.560120 691.599243,741.341370 
	C688.793762,741.738281 687.857788,739.343689 685.733154,738.303101 
	C681.419922,736.482422 684.979980,733.838623 684.530396,731.351929 
	C684.263367,730.389832 683.965088,729.786621 684.074402,729.100586 
	C683.853027,729.739563 684.194153,730.301636 684.404297,731.235229 
	C684.302917,734.142029 682.647034,733.874634 680.604736,733.296082 
	C679.767151,732.857300 679.238831,732.534973 678.316284,732.747803 
	C676.959961,733.589050 676.317688,734.648682 675.616516,736.062012 
	C674.597351,737.571045 674.244019,739.011841 673.634277,740.692993 
	C672.896973,741.861267 671.767090,742.247620 671.231812,743.603760 
	C670.911987,744.324402 670.673828,744.710449 670.137146,745.307617 
	C669.039490,746.030701 668.110291,746.175171 666.822876,746.313416 
	C663.501343,746.656250 660.591614,747.092285 658.913269,750.470215 
	C658.469543,751.292053 658.071594,751.740356 657.357422,752.238403 
	C657.135986,752.372375 656.696533,752.544800 656.340820,752.655396 
	C655.985046,752.766052 656.108765,753.111267 656.212646,753.280273 
	C656.316589,753.449341 656.522400,753.816406 656.620667,754.010925 
	C656.850342,754.478699 656.995300,754.744690 657.297852,755.200562 
	C657.546387,755.528198 657.650879,755.658691 657.916504,755.988892 
	C658.182678,756.327637 658.287781,756.466553 658.543823,756.823364 
	C658.793701,757.190002 658.892456,757.338684 659.143921,757.708557 
	C659.621216,758.368591 659.978088,758.776123 660.684937,759.224854 
	C661.866272,759.799683 662.887024,759.949463 664.143555,760.438354 
	C671.892090,766.289551 678.906860,772.500122 685.946899,779.187622 
	C688.461792,781.690430 691.262024,781.851929 694.526550,781.575378 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M620.144409,751.490601 
	C616.396545,753.798584 612.545471,755.006897 608.326233,756.341064 
	C606.568970,755.507507 606.642151,753.591980 605.409546,752.350037 
	C604.816772,753.864258 605.894226,755.100342 605.052856,756.523438 
	C601.232483,756.879211 597.912964,757.985413 594.534973,758.866882 
	C586.211304,761.038940 577.249878,759.112183 569.147095,762.897217 
	C557.895935,768.152832 545.993408,765.212280 533.512939,765.427734 
	C537.033875,767.082886 539.909485,768.060547 543.635376,768.476990 
	C544.023254,769.095825 543.850220,769.302979 543.323486,769.706848 
	C539.329285,770.739136 535.538086,770.260620 531.511230,771.186829 
	C525.237183,772.194153 519.275513,772.327515 512.977539,772.990723 
	C512.092285,773.156250 511.583984,773.219421 510.695312,773.284790 
	C509.823883,773.329590 509.329590,773.337708 508.475647,773.341064 
	C500.617371,774.046631 492.824066,773.328979 485.808563,778.062622 
	C485.249146,778.247437 485.013306,778.282959 484.478424,778.122192 
	C483.117645,775.438477 482.055939,772.950928 480.843323,770.186035 
	C480.166656,767.845276 479.640961,765.781921 479.149353,763.325378 
	C479.359741,760.877197 479.862976,759.143372 482.206451,758.441040 
	C497.680786,753.803589 511.570679,746.537170 522.296875,734.070374 
	C522.609314,733.707214 523.157410,733.596680 524.014709,733.460022 
	C528.177612,736.301270 528.235413,736.519592 526.728333,742.346680 
	C528.079468,741.707947 527.565552,740.268494 528.090332,739.290039 
	C529.422363,736.806274 531.732422,736.406250 533.742249,738.427429 
	C534.921997,739.613770 535.396973,741.307251 536.451050,742.593628 
	C538.688477,745.324097 541.002747,747.614563 544.755676,744.679077 
	C546.099548,743.627869 547.932129,743.396851 549.545715,743.743530 
	C556.741516,745.289856 564.096741,745.294312 571.333740,745.283203 
	C580.544861,745.269104 589.783325,744.245789 598.885864,742.543945 
	C603.115234,741.753113 607.404053,741.382202 611.659790,740.972351 
	C614.550171,740.694092 617.721069,741.275391 619.425171,744.864868 
	C619.780945,747.225708 620.290222,749.212708 620.144409,751.490601 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M524.320435,733.845703 
	C513.245972,747.090942 499.132172,754.792236 483.124756,759.443787 
	C481.485687,759.920105 479.961212,760.439392 479.411774,762.674805 
	C478.748169,761.535889 478.312805,760.139709 477.946930,758.378540 
	C494.122620,753.393982 507.090729,743.822449 518.739075,732.179626 
	C520.400635,730.518860 522.135010,728.772644 524.423523,728.297607 
	C532.881775,726.541687 540.936829,723.440063 549.611816,721.195923 
	C551.471252,723.385376 551.471252,723.385376 547.821167,726.232849 
	C547.179016,726.659729 546.799316,726.879639 546.122131,727.232910 
	C545.638855,727.473999 545.443054,727.564209 544.948120,727.773804 
	C543.412964,728.267029 542.288513,728.873596 540.897095,729.697632 
	C540.172974,730.014038 539.741028,730.158386 538.958984,730.359619 
	C534.082214,732.039551 529.152161,731.949829 524.320435,733.845703 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M435.550171,821.506592 
	C434.443878,817.857300 437.662323,816.643738 439.441132,814.799866 
	C441.480408,812.685913 442.105896,810.844421 440.190918,808.166626 
	C444.742981,800.498230 450.230164,793.568970 456.794098,787.101013 
	C458.082947,789.167664 459.067749,791.391846 460.246368,793.870239 
	C462.157196,798.627625 462.637878,802.774536 457.070068,805.521851 
	C452.863586,811.176758 447.246765,814.465698 441.172058,817.714233 
	C440.852295,817.854919 440.907501,817.957336 440.910309,817.899231 
	C440.741486,818.201843 440.495056,818.498779 439.874084,818.787109 
	C439.586548,818.852905 439.250183,818.913635 439.123596,819.028442 
	C438.820496,819.269104 438.644043,819.395020 438.259674,819.770996 
	C438.051788,820.020996 438.001556,819.998962 438.014862,820.022949 
	C437.432465,820.726990 436.975464,821.599426 435.550171,821.506592 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M501.190430,742.065918 
	C497.921173,745.729370 493.659332,747.524902 489.300293,749.817505 
	C487.913055,750.236145 486.830994,750.487732 485.213165,750.863892 
	C485.853973,748.317566 488.669128,747.832458 488.989532,745.344788 
	C486.993622,745.042297 486.054657,746.885864 484.500122,747.684570 
	C483.144318,748.381104 481.684235,749.797913 480.262573,747.207825 
	C479.552704,746.374573 479.694885,745.713135 480.031372,744.733948 
	C480.708954,743.405884 481.517853,742.627686 482.678955,741.729370 
	C483.160156,741.452698 483.363953,741.362976 483.892883,741.197144 
	C489.170837,739.142517 492.472961,734.788574 497.023529,732.216003 
	C498.428986,731.421448 499.476746,729.994385 501.618408,729.913940 
	C502.313232,730.270020 502.505829,730.638428 502.422852,731.389954 
	C501.836060,732.151855 501.279144,732.453125 500.400208,732.727661 
	C500.173645,732.883728 499.908203,733.103577 499.904419,733.154419 
	C499.900665,733.205261 500.061340,732.938110 500.231934,732.841553 
	C500.801605,732.473145 501.317810,732.487732 501.927673,732.032715 
	C502.556519,731.410339 502.685333,730.916626 502.180176,730.166382 
	C502.531891,727.068542 504.995056,726.575806 507.619598,725.896362 
	C508.640350,727.197144 507.803680,727.786865 506.703400,728.516479 
	C506.249817,728.888489 506.006256,729.023804 505.722229,729.069214 
	C505.449860,729.112854 505.549957,729.109802 506.246094,728.860901 
	C506.861542,728.512756 507.266083,728.476685 507.956848,728.700684 
	C508.335876,729.071960 508.438354,729.269226 508.588623,729.801331 
	C508.220520,734.564758 505.696625,737.747925 502.269379,740.791687 
	C502.043304,741.052368 502.000000,741.000000 502.024292,741.023499 
	C501.700104,741.326355 501.188568,741.342590 500.894226,741.663879 
	C500.445709,742.153442 500.859222,742.528625 500.758331,741.869629 
	C500.657440,741.210632 501.854645,741.681458 501.190430,742.065918 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M480.725281,744.658203 
	C480.634491,745.452271 480.411102,745.960205 480.098206,746.735352 
	C479.712646,747.143799 479.442535,747.324036 479.030823,747.720825 
	C478.565887,748.418457 478.130646,748.772583 477.284729,749.024658 
	C471.260529,751.017883 465.520050,752.960388 459.406311,754.984497 
	C458.572632,755.273254 458.165039,755.184021 457.641052,754.535583 
	C457.458771,753.991394 457.437164,753.758118 457.497803,753.182129 
	C457.802734,752.426453 458.074615,752.049072 458.653961,751.478394 
	C462.077148,749.103577 464.566864,746.240723 467.343018,743.219482 
	C467.649689,742.780334 467.766144,742.601624 468.073669,742.169922 
	C468.402130,741.758301 468.539551,741.599731 468.900818,741.222778 
	C469.286377,740.874512 469.448120,740.744629 469.869263,740.446167 
	C470.484772,740.072876 470.842682,739.871338 471.463470,739.507202 
	C471.897552,739.225769 472.070709,739.110413 472.504944,738.820435 
	C474.655975,737.477844 475.808411,735.697449 476.973694,733.504944 
	C477.279266,733.052002 477.413239,732.879395 477.779907,732.478027 
	C479.558319,731.131226 481.029663,729.931702 482.390472,728.166992 
	C482.679474,727.748901 482.791748,727.581055 483.084656,727.173706 
	C483.516266,726.631165 483.778137,726.337891 484.249329,725.846191 
	C484.714783,725.366943 484.987152,725.101196 485.465851,724.640503 
	C485.811218,724.316833 485.954529,724.192566 486.599731,723.805664 
	C487.290833,723.550354 487.479980,723.557556 487.848328,723.785095 
	C491.538879,723.930359 491.282745,725.873901 489.414398,727.448547 
	C486.413239,729.977905 485.425842,733.762512 482.956573,736.563416 
	C481.490784,738.226074 482.093781,739.510742 483.983795,740.846436 
	C484.218048,741.120972 484.128418,741.116821 484.094696,741.087219 
	C483.077545,742.343140 480.743988,742.215881 480.725281,744.658203 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M459.201843,752.114136 
	C459.022095,752.645569 458.914276,752.817871 458.575958,752.986572 
	C458.110687,753.134827 457.830292,753.297180 457.734375,753.714722 
	C458.102295,754.205200 458.321442,754.502014 458.786804,754.932434 
	C455.355743,759.065613 452.047211,763.530396 446.033539,765.074646 
	C445.250702,764.487305 445.013245,763.836243 444.965393,762.781006 
	C445.095001,761.380737 445.426880,760.383423 446.013916,759.235352 
	C446.122284,759.038879 446.323975,758.771179 446.354980,758.577393 
	C446.385956,758.383545 446.211945,758.705444 446.027344,758.833130 
	C445.513611,759.103027 445.167938,759.175781 444.513428,759.132568 
	C443.970123,758.757690 443.725647,758.456726 443.209961,758.041016 
	C442.804260,757.729065 442.669800,757.531921 442.519836,756.977234 
	C444.688873,751.811829 449.620178,749.908508 453.209656,746.592712 
	C456.946106,743.141113 460.645874,739.608704 465.222321,736.670105 
	C468.137451,737.500427 469.434387,734.868713 471.874573,734.425903 
	C472.440857,734.483765 472.662476,734.552612 473.144348,734.856262 
	C473.629120,735.507446 473.766022,735.951721 473.820129,736.771484 
	C473.696533,738.102661 473.133545,738.837036 472.270844,739.793396 
	C472.047791,740.057434 472.001221,740.023499 472.024170,740.034546 
	C471.571411,740.413086 470.979492,740.472656 470.227875,740.858521 
	C470.022156,741.062744 469.996765,741.007751 470.024719,741.019409 
	C469.782898,741.211487 469.540955,741.423645 469.179504,741.859375 
	C469.032227,742.051270 469.031799,741.994141 469.045105,742.019897 
	C465.731445,745.207092 462.438568,748.402466 459.201843,752.114136 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M476.299347,778.095337 
	C475.965912,776.983826 475.828735,776.173523 475.527344,775.102295 
	C474.898560,768.862305 471.680450,763.210938 473.333984,756.065491 
	C475.031189,761.110779 476.461700,765.363281 478.074646,769.884277 
	C479.203125,773.184326 480.149109,776.215881 481.160400,779.633118 
	C481.333160,780.204712 481.440552,780.390625 481.764801,780.814514 
	C482.253937,782.107300 482.526215,783.162109 482.805786,784.546082 
	C482.506195,785.281738 482.109100,785.547058 481.238037,785.627441 
	C477.923096,784.107239 478.636078,780.386414 476.299347,778.095337 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M463.591064,784.763184 
	C464.000793,786.124268 464.144196,787.221558 464.379272,788.723145 
	C462.869568,789.796387 462.259613,788.535645 461.215851,787.336670 
	C458.194244,781.140381 457.501190,774.682556 456.247437,768.367432 
	C456.048523,767.365540 455.996613,766.239258 457.376953,766.093384 
	C458.360107,765.989441 458.740326,766.820923 458.936737,767.681213 
	C460.226654,773.332275 462.687714,778.677856 463.591064,784.763184 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M471.353333,772.144531 
	C470.237793,775.008728 467.604187,774.372925 465.578217,774.965515 
	C464.408478,775.307678 464.102600,773.944885 464.059875,772.908569 
	C464.020142,771.944702 463.710083,770.437134 464.862396,770.359436 
	C467.037811,770.212830 469.858154,768.095093 471.353333,772.144531 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M472.632355,778.702576 
	C474.322205,780.126465 473.462067,781.102661 471.912079,782.147461 
	C471.686523,783.692871 470.670502,783.785828 469.334991,783.932251 
	C468.223206,784.020142 467.477539,784.112305 466.370239,784.092346 
	C464.737793,778.218506 470.327423,780.739319 472.632355,778.702576 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M460.959045,787.447021 
	C462.367279,786.889160 462.929138,788.106628 464.134521,788.974243 
	C466.784607,790.979492 465.674133,794.024536 466.963104,796.630310 
	C466.496887,796.758179 466.016327,796.494324 465.292847,796.100708 
	C466.075806,792.059814 460.827454,791.285217 460.959045,787.447021 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M443.468323,767.804932 
	C443.101135,767.146118 443.053131,766.427490 442.994934,765.346680 
	C443.455933,764.626160 443.984283,764.490417 444.933472,764.794067 
	C445.073090,766.076416 445.091766,767.276001 443.468323,767.804932 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M445.384155,765.033691 
	C444.781433,765.017944 444.265747,765.025085 443.367401,765.008301 
	C442.984741,764.984436 442.998840,764.998901 443.005341,765.005371 
	C442.455963,762.983032 443.773804,762.178772 445.694275,761.520081 
	C446.027100,762.423889 445.965546,763.318176 445.776733,764.647156 
	C445.649475,765.081787 445.471222,765.056580 445.384155,765.033691 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M477.190796,749.282959 
	C477.428741,748.707642 477.856476,748.339966 478.573730,747.935303 
	C478.853943,748.880615 478.905334,749.919434 477.190796,749.282959 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M109.861969,785.720886 
	C109.725113,787.154907 109.443855,788.279480 109.069984,789.744690 
	C108.035217,790.804321 107.035301,790.615601 106.192665,790.030273 
	C98.147537,784.441589 89.888039,779.099915 83.711182,770.815308 
	C83.584190,770.229980 83.572205,769.988403 83.765045,769.447388 
	C84.985741,767.637329 86.249077,767.817261 87.321541,768.911926 
	C93.899208,775.625854 102.325409,779.814758 109.861969,785.720886 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M116.861794,788.578247 
	C115.603134,789.920776 118.093506,790.689636 117.168388,791.809326 
	C115.422356,791.415405 113.939034,790.620483 113.014389,788.604126 
	C114.205086,784.378174 115.452927,787.417358 116.861794,788.578247 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M125.987930,792.667175 
	C123.743454,792.227112 121.503510,791.433899 119.086304,790.387939 
	C121.460663,788.274780 123.565239,789.436768 125.749245,791.384888 
	C125.935028,791.868835 125.963745,792.091492 125.987930,792.667175 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M83.686829,768.961548 
	C83.940842,769.315857 83.911804,769.483826 83.826263,769.901123 
	C83.567032,770.246826 83.364319,770.343262 82.905869,770.220581 
	C80.130692,769.627441 79.775024,767.488220 79.052803,765.280884 
	C81.412193,765.158203 81.640823,767.841675 83.686829,768.961548 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M104.071655,766.258301 
	C105.916092,765.653503 106.705261,767.667908 108.650131,768.051453 
	C106.714592,769.626404 105.022789,769.304443 104.071655,766.258301 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M79.065689,764.679504 
	C78.722641,764.494141 78.386749,763.986816 78.033356,763.155029 
	C78.368187,763.339539 78.720512,763.848572 79.065689,764.679504 
z"/>
<path fill="#6A7594" opacity="1.000000" stroke="none" 
	d="
M228.594788,910.025269 
	C230.513062,911.223694 233.335220,910.525574 233.752518,913.680664 
	C232.667542,918.248840 228.788193,920.057373 225.989044,922.714172 
	C219.176758,929.179993 213.296692,936.594849 205.865738,942.424072 
	C204.833145,943.234192 203.995102,944.309937 202.291168,944.716736 
	C195.193207,943.547058 189.492538,939.095947 182.208252,938.198120 
	C193.366882,930.528137 203.268967,920.757141 215.455124,914.205505 
	C216.040192,913.890930 216.713593,913.652161 217.169556,913.200195 
	C220.280914,910.116211 223.779373,908.472107 228.594788,910.025269 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M251.086929,936.643616 
	C250.390427,937.114014 249.821075,937.275391 249.059265,937.665527 
	C244.126251,940.678467 239.385666,943.462708 234.423279,946.440063 
	C229.798462,947.146790 226.332840,950.005615 222.281052,951.401794 
	C220.541611,952.001099 218.543961,952.949097 217.273041,951.119812 
	C215.908127,949.155396 218.195541,948.218140 219.258789,947.199707 
	C226.918427,939.862366 234.663071,932.613647 242.635071,925.052551 
	C242.782700,924.627441 242.676010,924.486572 242.507446,924.091309 
	C242.325150,923.492004 242.141754,923.182678 241.711121,922.677673 
	C239.642502,920.106079 239.670868,918.078247 242.776001,916.321899 
	C244.148148,915.845764 245.264114,915.580017 246.692093,915.165649 
	C247.738800,913.966980 248.749649,913.326660 250.334015,912.925476 
	C251.635818,912.658203 252.613190,912.631104 253.884918,912.185303 
	C254.975754,911.905212 255.723236,911.813232 256.863892,911.746826 
	C258.044006,911.756653 258.813232,911.903992 259.923523,912.327271 
	C265.598846,917.063904 261.317932,921.069824 259.247284,925.489990 
	C257.300842,929.962219 254.254761,933.146423 251.086929,936.643616 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M242.638596,916.041748 
	C242.485397,918.045654 239.440338,919.775696 242.773010,922.234131 
	C243.123383,922.806458 243.251022,923.153381 243.189240,924.021362 
	C242.999771,924.542419 242.930237,924.711792 242.909821,924.740051 
	C241.149506,924.588379 239.687546,925.171631 238.261856,926.172729 
	C229.063843,932.630981 219.633316,938.781616 211.296783,946.380432 
	C207.840866,949.530640 205.301819,946.824402 202.248291,945.028809 
	C212.369171,934.648132 222.784576,924.483765 233.479095,914.173584 
	C236.587143,914.675903 239.416092,915.323975 242.638596,916.041748 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M125.162590,950.715027 
	C124.669968,950.511230 124.319168,949.998108 123.887932,949.165283 
	C127.645531,941.547363 131.557007,934.286560 135.297714,926.938904 
	C138.144440,921.347168 138.048706,921.296509 143.796600,924.182129 
	C144.820343,924.696106 145.942413,925.087646 146.515030,926.620605 
	C146.279724,927.031372 146.015686,927.055054 145.356873,927.127686 
	C138.960144,923.912048 138.982849,923.921875 136.370804,929.941772 
	C133.273285,937.080566 129.991379,944.124329 125.162590,950.715027 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M184.190369,942.794922 
	C171.146606,939.126343 158.645477,934.307251 146.718597,927.239319 
	C152.595978,927.700623 157.823013,931.027954 163.489731,933.072937 
	C170.266617,935.518555 176.735870,938.816528 183.647583,941.924194 
	C184.089447,942.250793 184.222107,942.398621 184.190369,942.794922 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M204.907074,950.664917 
	C197.782089,950.262390 191.631531,946.539001 185.081909,943.318909 
	C192.069397,944.139343 198.322235,947.510071 204.907074,950.664917 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M184.279831,943.073120 
	C184.025986,943.043396 183.996323,942.572510 183.976562,942.337769 
	C184.265366,942.231262 184.573929,942.359558 184.957001,942.737366 
	C184.865585,943.025513 184.699631,943.064209 184.279831,943.073120 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M217.619202,865.508606 
	C220.234528,865.147217 220.324661,866.587280 219.181091,868.796936 
	C218.495026,867.968018 218.092133,866.906311 217.619202,865.508606 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M190.678528,786.387085 
	C192.009125,786.627075 192.161926,787.494568 191.315887,788.764893 
	C190.887772,788.215698 190.697617,787.475220 190.678528,786.387085 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M394.548462,761.465942 
	C394.580872,761.521545 394.516052,761.410400 394.548462,761.465942 
z"/>
<path fill="#8395B3" opacity="1.000000" stroke="none" 
	d="
M224.689880,543.264771 
	C214.669449,546.746521 206.468491,552.609070 198.199326,559.057861 
	C200.355316,550.496948 203.838745,542.235657 208.977051,534.348633 
	C214.764389,530.315613 217.577042,524.034485 222.075638,519.231506 
	C227.908325,513.004089 233.152878,506.266449 238.275360,499.408203 
	C241.492142,495.101471 240.026733,491.277191 239.388763,486.660858 
	C239.857056,485.971466 240.158920,485.729309 240.627670,485.417053 
	C241.247253,484.809723 241.838638,484.521088 242.754333,484.149658 
	C242.992676,483.912811 242.993134,483.983948 242.961899,483.966919 
	C243.778214,483.271179 244.902939,483.713043 246.107697,483.022736 
	C250.300385,479.880219 255.009338,478.838226 259.473785,477.358887 
	C269.327942,474.093689 279.291748,471.159363 289.578979,468.005005 
	C292.036865,465.386963 296.053986,466.511963 298.212738,463.385925 
	C301.343475,459.810516 305.326935,460.329437 308.473328,461.542297 
	C312.461243,463.079620 316.349670,463.326019 320.758545,463.451111 
	C324.100281,467.835327 324.485504,472.907684 325.683746,477.713776 
	C326.206085,479.808929 326.888458,481.853516 327.658875,483.927429 
	C326.962585,473.883728 324.369446,463.737640 329.475220,453.698029 
	C329.526337,451.987579 329.701569,450.693024 330.640106,449.191956 
	C330.856201,448.853546 330.929779,448.852936 330.940735,448.888062 
	C333.092224,448.075897 335.123718,446.929688 337.756744,446.776184 
	C338.349670,447.253540 338.623260,447.511719 339.115173,447.952698 
	C337.636810,458.540100 337.759003,469.013245 338.241913,479.489868 
	C338.356567,481.977203 337.902618,483.560883 335.522125,485.184418 
	C329.213257,489.487152 323.919861,494.971466 318.538208,500.444275 
	C313.912170,505.148651 313.354340,512.191040 307.587280,516.142578 
	C307.052246,516.182434 306.837463,516.093201 306.388916,515.747314 
	C303.812988,512.158997 301.834717,508.402435 296.949890,508.038025 
	C296.607086,508.471100 296.478027,508.656342 296.157104,509.128754 
	C294.992523,512.265503 296.452911,514.879761 296.821655,517.588928 
	C297.156311,520.047913 297.679108,522.447876 296.301971,525.127625 
	C292.304108,527.485657 288.537811,525.524353 284.785034,525.471619 
	C278.764954,525.387085 273.097961,523.352661 268.027039,522.717041 
	C273.112885,523.663330 279.002045,524.945190 284.711090,526.948059 
	C287.957367,528.086853 290.391144,529.688232 290.806458,533.768494 
	C288.998077,538.887024 287.102234,543.554382 281.931580,545.917603 
	C279.537048,543.636841 278.308716,540.788635 275.499054,538.844482 
	C274.059387,539.951050 273.849060,542.503357 271.230347,542.753784 
	C262.497070,541.531128 254.321487,539.168701 245.488297,538.709473 
	C238.011581,538.363647 231.211197,539.378174 224.689880,543.264771 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M330.496765,448.839722 
	C330.913849,450.231323 330.971497,451.609131 331.038269,453.397797 
	C327.371735,456.281921 323.638824,458.646820 319.377808,460.011047 
	C319.129150,460.048035 319.266418,460.014160 319.781067,459.941162 
	C321.475616,459.700806 323.654114,457.396210 324.647858,459.180481 
	C325.923187,461.470306 323.198059,462.693634 321.141418,463.964081 
	C316.653809,464.831848 312.776917,465.652588 308.585663,463.011230 
	C306.284485,461.560974 302.547974,461.326935 299.438965,463.717529 
	C295.946075,466.029022 292.352966,465.799835 288.362671,465.272308 
	C287.536469,465.036621 287.097504,465.033325 286.333191,465.084106 
	C285.304443,465.547333 284.533508,465.483795 283.393311,465.374451 
	C270.853516,466.422089 258.884338,468.868439 246.746353,470.473999 
	C264.248138,466.032257 280.978760,458.741852 299.561676,456.774780 
	C303.619720,456.796936 307.258728,456.888123 310.894318,457.054382 
	C315.822235,457.279724 319.792664,455.179443 323.604645,452.303467 
	C325.549652,450.835999 327.945343,449.965942 330.496765,448.839722 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M338.088013,446.668152 
	C335.952209,447.655975 333.828308,448.316559 331.328033,448.950195 
	C332.940796,446.972870 335.114532,445.533508 338.088013,446.668152 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M307.306458,449.005859 
	C307.449829,448.185059 308.156433,447.922485 309.021545,448.150879 
	C309.089905,448.168915 309.106750,448.773865 309.056458,448.788300 
	C308.601685,448.918640 308.126556,448.978119 307.306458,449.005859 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M313.668945,446.942535 
	C313.644562,447.842438 312.991211,448.117493 312.162567,447.909821 
	C311.952179,447.857056 311.808868,447.536682 311.634735,447.339233 
	C312.200653,447.180908 312.766571,447.022552 313.668945,446.942535 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M307.010742,449.018158 
	C306.557098,449.794342 305.869171,450.027893 305.037872,449.813171 
	C304.971344,449.796021 304.953156,449.222534 304.995148,449.211121 
	C305.436584,449.090912 305.894836,449.032532 306.651978,448.955200 
	C306.955536,448.953339 306.993652,448.995453 307.010742,449.018158 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M297.301544,452.012207 
	C297.450409,451.269623 298.108185,450.994476 298.933929,451.201569 
	C298.989410,451.215485 298.999115,451.774445 298.949493,451.788177 
	C298.515869,451.908081 298.063904,451.961548 297.301544,452.012207 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M301.688812,450.339966 
	C301.993225,450.354614 302.155548,450.496185 302.317871,450.637756 
	C302.060822,450.580811 301.803802,450.523834 301.688812,450.339966 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M313.985931,446.995544 
	C314.471588,446.701416 314.971405,446.406494 315.471222,446.111511 
	C315.494080,446.327057 315.590271,446.701477 315.527100,446.730621 
	C315.254303,446.856567 314.934814,446.881409 314.318878,446.981934 
	C314.005402,447.020874 314.000092,446.994720 313.985931,446.995544 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M297.007812,452.009979 
	C296.911407,452.049896 296.808502,452.081573 296.845642,452.051514 
	C296.985718,451.989716 297.001343,452.001770 297.007812,452.009979 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M370.514343,993.655884 
	C371.586182,993.371033 372.260590,993.036682 372.872223,993.127075 
	C375.634277,993.535278 380.144806,990.581726 380.068909,996.766174 
	C380.064606,997.116821 381.710663,997.103027 381.313904,998.684631 
	C379.139832,998.746277 376.936584,1000.122253 375.652496,996.396484 
	C374.764069,993.818726 370.253571,994.511108 369.156677,997.335205 
	C368.667236,998.595215 368.748505,1000.022095 366.905487,999.955200 
	C365.096466,999.889648 365.775177,998.464722 365.433441,997.469482 
	C364.964661,996.104248 363.963043,994.563110 362.131927,995.877808 
	C360.924347,996.744873 359.833008,997.072327 359.608673,995.397461 
	C359.368530,993.604492 361.098450,994.067078 362.135468,994.018005 
	C364.783813,993.892700 367.436859,993.867371 370.514343,993.655884 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M348.954559,1003.260071 
	C350.434357,1001.130432 352.771240,1002.578247 354.701202,1001.220093 
	C356.457184,1002.085938 357.968750,1001.267212 359.534363,1001.125671 
	C361.827789,1000.918274 364.499878,1000.229004 365.842957,1003.669922 
	C365.555786,1004.016907 365.116730,1004.023438 364.348267,1004.026672 
	C363.248077,1004.678162 363.606140,1005.641418 363.091888,1006.625610 
	C362.825043,1006.812073 362.465363,1006.775085 362.287262,1006.745239 
	C361.060730,1004.368225 359.200867,1003.632935 356.384918,1004.037231 
	C355.399933,1004.030334 354.858826,1004.190979 354.170624,1004.759399 
	C352.578186,1004.964661 351.202332,1004.977356 349.413879,1005.000793 
	C348.991760,1004.544495 348.982269,1004.077454 348.954559,1003.260071 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M383.935913,994.202759 
	C384.881012,991.314209 386.785675,991.657349 388.394501,992.629028 
	C389.707397,993.421936 390.115387,995.078979 389.793915,996.640808 
	C389.477051,998.180237 388.119385,997.924011 386.975922,998.028076 
	C384.394928,998.263000 383.879364,996.704468 383.935913,994.202759 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M397.692322,992.685486 
	C399.509674,990.274231 400.296204,991.738464 400.871216,993.206848 
	C401.226166,994.113220 401.243286,995.446960 399.956116,995.501648 
	C398.519440,995.562805 396.876770,995.208801 397.692322,992.685486 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M393.311554,997.827209 
	C391.878235,996.453552 392.849304,996.236023 393.874420,996.133728 
	C394.492676,996.072021 395.297211,996.158386 395.337891,996.894592 
	C395.403412,998.079102 394.344177,997.785767 393.311554,997.827209 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M371.688995,1002.979797 
	C371.534515,1004.044373 370.815613,1004.778015 369.305054,1004.951416 
	C368.801331,1003.130737 369.358521,1002.174194 371.688995,1002.979797 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M366.666107,1005.962402 
	C366.605530,1006.228760 366.338501,1006.509033 366.071472,1006.789307 
	C365.956116,1006.605713 365.840729,1006.422119 365.885651,1006.114868 
	C366.045929,1005.991272 366.459625,1005.976257 366.666107,1005.962402 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M245.519470,538.955078 
	C254.028778,537.886108 262.568726,539.901794 271.480347,542.072510 
	C274.664581,541.510071 276.574402,543.466553 279.096741,544.680054 
	C280.920990,545.782166 282.439423,546.736633 284.204712,547.929688 
	C285.016785,548.538086 285.540588,548.967407 286.320312,549.624084 
	C289.044312,552.529724 291.546021,555.176819 294.169067,558.164551 
	C295.034515,559.274475 295.535278,560.251221 296.645020,561.133301 
	C297.310730,561.786011 297.682251,562.277588 298.237732,563.002136 
	C298.663513,563.540527 298.905334,563.846008 299.336243,564.367615 
	C299.768616,564.874939 300.000916,565.174683 300.386261,565.710022 
	C300.751923,566.246887 300.951355,566.557861 301.306824,567.092651 
	C301.685028,567.604187 301.909119,567.889832 302.327454,568.369568 
	C302.768829,568.833862 303.019928,569.101379 303.460693,569.572632 
	C303.898285,570.053101 304.132721,570.341125 304.519318,570.864014 
	C304.998108,571.544922 305.288696,572.017212 305.781586,572.687622 
	C306.053284,573.063354 306.157837,573.217163 306.398895,573.615234 
	C306.684784,574.203064 306.802307,574.557007 306.855743,575.477356 
	C307.823669,578.127380 308.818878,580.223022 309.905334,582.651855 
	C309.482208,583.301514 308.967834,583.617920 308.167206,584.031982 
	C307.880951,584.129578 307.456726,583.983459 307.242859,583.915100 
	C307.028992,583.846741 306.997498,583.926575 307.037354,583.942444 
	C306.475586,583.475769 305.949188,582.915710 305.264618,582.114014 
	C305.104462,581.874329 305.044373,581.954834 305.093414,581.944031 
	C304.572388,581.593323 304.532135,580.979919 304.211060,580.182739 
	C304.055176,579.934509 304.004517,579.995789 304.040192,579.978271 
	C303.798615,579.780945 303.551697,579.566284 303.188721,579.119019 
	C303.042389,578.921265 303.036743,579.003662 303.053619,578.965759 
	C302.789398,578.769226 302.545319,578.566101 302.201202,578.122559 
	C302.064209,577.926514 302.144989,577.904419 302.142487,577.862671 
	C300.773865,576.826294 299.480164,575.755554 298.349487,574.078979 
	C298.202637,573.799255 298.075043,573.828064 298.084656,573.892761 
	C297.576538,573.584656 297.529388,572.989624 297.186859,572.228882 
	C296.957458,571.699890 296.833282,571.424500 296.424652,571.071533 
	C295.818298,570.749512 295.485748,570.455688 295.127319,569.759888 
	C294.242950,568.036438 293.450562,566.638184 292.397034,565.074463 
	C291.745148,564.935852 291.469330,564.778137 291.199127,564.168823 
	C291.071228,563.931885 290.998779,563.997559 291.037109,563.967896 
	C289.316193,562.461304 288.041138,560.655701 287.240265,558.134766 
	C280.811951,548.445129 271.107391,544.761597 260.398315,542.128296 
	C255.314926,541.099243 250.613556,540.064880 245.519470,538.955078 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M287.005371,558.078491 
	C288.447632,559.628540 289.767273,561.439697 291.081177,563.594604 
	C287.990356,564.160645 287.988739,560.930847 286.120483,559.327881 
	C286.282349,558.793030 286.582550,558.566345 287.005371,558.078491 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M298.137695,574.175720 
	C300.015625,574.325500 300.885803,575.938293 302.113464,577.495300 
	C299.918976,577.807983 298.188599,577.184570 298.137695,574.175720 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M305.046387,582.228088 
	C306.410156,581.449890 306.468109,582.631470 307.003754,583.625610 
	C305.912231,584.210754 305.292664,583.635498 305.046387,582.228088 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M290.973999,564.191101 
	C291.360992,564.088013 291.650787,564.244080 292.038208,564.654602 
	C291.324524,565.831238 291.038239,565.312134 290.973999,564.191101 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M297.022034,572.316406 
	C297.386597,572.459656 297.778625,572.904724 298.132446,573.653687 
	C297.746002,573.511108 297.397766,573.064697 297.022034,572.316406 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M303.979279,580.269226 
	C304.538635,580.397339 305.022095,580.860168 305.324005,581.628113 
	C304.277496,581.911377 304.023193,581.320374 303.979279,580.269226 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M303.057861,579.218994 
	C303.367035,579.076172 303.691681,579.231079 304.046082,579.673401 
	C303.741699,579.812744 303.407532,579.664734 303.057861,579.218994 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M302.126709,578.182617 
	C302.417755,578.050415 302.771301,578.174377 303.097656,578.613098 
	C302.776733,578.764832 302.483002,578.601746 302.126709,578.182617 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M288.083557,575.140625 
	C288.218262,575.085510 288.325684,575.301270 288.433105,575.517029 
	C288.307495,575.481812 288.181885,575.446655 288.083557,575.140625 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M295.128906,569.764282 
	C295.347076,569.739502 295.658813,570.044373 296.098938,570.651978 
	C295.892365,570.667725 295.557404,570.380798 295.128906,569.764282 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M289.466156,577.436340 
	C289.530090,577.393982 289.402222,577.478699 289.466156,577.436340 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M287.941528,575.044800 
	C287.779022,574.891113 287.675934,574.682007 287.572845,574.473022 
	C287.690826,574.510071 287.808807,574.547180 288.018799,574.727051 
	C288.110809,574.869751 288.000946,574.989441 287.941528,575.044800 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M453.003174,993.004883 
	C452.462189,993.299072 451.921967,993.599060 451.358673,993.846436 
	C451.321625,993.862732 451.108368,993.477661 450.977051,993.279297 
	C451.451233,993.164368 451.925415,993.049438 452.692749,992.959595 
	C452.985901,992.984741 452.998535,992.998352 453.003174,993.004883 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M540.997070,215.117508 
	C540.694946,214.481171 540.668274,214.053329 540.772949,213.326111 
	C541.456604,212.611008 541.523804,212.051956 541.169189,211.210632 
	C540.522949,204.595352 541.739197,198.291595 542.104675,191.493835 
	C545.165100,191.536362 543.272095,194.017166 544.017700,194.988129 
	C544.077454,193.671021 544.798401,192.140121 546.687805,192.156158 
	C549.625244,192.181091 550.958862,190.470490 552.489075,188.312683 
	C556.265503,182.987320 559.720337,183.617249 562.824219,189.944916 
	C565.156128,190.324295 566.987854,184.328094 569.676086,189.664825 
	C569.663818,189.924194 569.481995,190.322861 569.481995,190.322861 
	C569.481995,190.322861 569.553284,190.413788 569.694519,190.250961 
	C571.361450,187.495712 573.273071,186.525681 575.825623,188.777130 
	C577.199707,189.989059 578.673950,190.319031 580.394470,189.708221 
	C581.966980,189.149979 583.459900,189.546097 584.470642,190.726379 
	C586.443115,193.029678 588.823975,192.557358 591.580688,192.155243 
	C592.299255,192.307663 592.355225,192.948883 592.746399,192.895477 
	C593.046936,192.854401 592.968201,192.505798 592.569092,191.986023 
	C595.939575,190.251801 598.942993,187.087677 603.127197,190.340332 
	C604.397827,191.328018 606.630371,189.994644 608.470398,190.035690 
	C611.023804,190.092621 613.728027,186.212128 616.178101,190.403488 
	C616.356628,190.708923 617.359070,190.030884 617.835266,189.587952 
	C619.566528,187.977493 621.363586,188.018707 623.298706,189.206406 
	C623.855774,189.548264 623.107117,189.433868 623.731079,189.421127 
	C633.201599,189.227814 642.280396,193.405579 651.711548,192.268356 
	C654.992615,191.872726 657.853882,188.929169 661.781250,189.695511 
	C663.156799,189.963898 664.871094,190.498184 665.881287,190.372223 
	C670.183594,189.835861 674.666687,191.669769 678.135803,191.158340 
	C682.606506,190.499283 686.221252,190.680084 690.630249,191.206406 
	C695.114258,191.741714 700.011414,189.317657 704.801270,191.958740 
	C705.752930,192.483459 707.220520,191.129730 708.272949,190.301483 
	C709.673645,189.199081 711.141418,189.292404 712.371338,190.390808 
	C714.523926,192.313156 716.010071,192.024948 718.792419,190.717026 
	C721.986694,189.215500 726.259521,186.752182 730.044922,190.462265 
	C731.151978,191.547241 732.304688,191.775558 733.546875,190.649506 
	C734.562195,189.729034 735.766541,188.845856 737.123901,189.380112 
	C738.808533,190.043137 739.643738,190.232285 739.518799,187.913284 
	C739.459778,186.818573 740.983459,185.939957 741.669556,186.454956 
	C745.089539,189.022217 750.184814,186.381088 753.107483,190.289078 
	C753.719666,191.107681 754.511658,191.672287 755.526062,190.501495 
	C757.625854,188.077820 759.331604,189.750839 761.266663,191.422638 
	C762.769653,193.398605 764.640991,194.744583 766.576355,194.258606 
	C774.270752,192.326492 781.415222,196.505295 788.887451,195.960999 
	C793.235107,195.644287 797.631104,196.960083 801.918091,195.453659 
	C804.621033,194.503891 806.178284,196.647186 808.372009,197.976471 
	C809.645142,198.905640 810.659180,199.515060 812.129028,198.334625 
	C818.635925,192.677902 825.946838,195.627823 832.870422,195.535400 
	C833.507751,195.526901 834.548828,196.076340 834.554810,195.963470 
	C834.912720,189.176575 838.255310,194.184830 840.282471,194.557144 
	C842.368591,194.940292 843.680664,193.519928 845.333862,192.852585 
	C847.666809,191.910782 849.775269,191.684402 849.435120,195.320358 
	C849.401917,195.675888 849.105896,195.872101 848.729675,195.926086 
	C849.150940,196.267914 849.589417,196.064209 850.033752,195.982880 
	C852.822205,195.472534 855.563416,195.394836 858.434753,195.759247 
	C861.365479,196.131195 864.060364,195.166641 864.797791,191.605072 
	C865.134705,189.977646 865.465759,188.164230 868.185181,188.897308 
	C869.489990,190.703583 869.366333,192.435822 869.050598,194.528122 
	C868.781860,195.464828 868.043274,195.912155 868.629333,196.990280 
	C868.939514,198.026031 868.968994,198.743958 868.852661,199.835571 
	C868.434509,201.400131 868.252136,202.637985 867.888916,204.230804 
	C867.085083,207.128708 866.349731,208.177963 862.971436,207.303894 
	C859.880127,206.504105 855.740723,206.960571 852.829407,208.682236 
	C845.476685,213.030380 837.694763,212.011780 830.563171,209.852707 
	C822.254456,207.337265 814.084412,207.857620 805.911194,208.424408 
	C799.740051,208.852341 793.611389,208.323914 787.638855,207.797791 
	C782.119202,207.311554 776.667053,207.280701 771.280151,207.706696 
	C764.776611,208.221008 758.365845,208.177582 751.906494,207.557404 
	C745.748596,206.966187 739.617065,208.087982 733.458374,207.973663 
	C725.485596,207.825699 717.526855,208.014771 709.626770,209.312607 
	C708.153442,209.554626 706.646179,209.215912 705.164490,208.943466 
	C696.295349,207.312637 687.478455,207.141159 678.702759,209.670181 
	C673.593262,211.142685 668.393494,210.255219 663.405029,209.181473 
	C660.600159,208.577744 657.951904,207.974304 655.098450,208.342056 
	C648.793701,209.154602 642.492920,209.109924 636.178650,208.311783 
	C629.907837,207.519135 623.899841,208.491364 617.922607,211.588684 
	C617.391296,211.886230 617.191956,212.020691 616.684631,212.328857 
	C614.410034,213.408112 611.953735,212.934540 610.061890,214.916229 
	C609.690186,215.328812 609.537415,215.492386 609.138367,215.888947 
	C607.665833,216.933258 606.464661,217.787674 605.085266,218.334686 
	C606.191101,218.755188 606.833557,217.604584 608.157471,217.573822 
	C608.975891,217.825470 609.341919,218.147720 609.796387,218.902924 
	C610.624939,221.616394 609.975403,223.829269 609.016113,226.361572 
	C607.211243,227.832870 607.584717,231.702713 604.815125,230.761887 
	C602.112244,229.843719 603.331543,227.267548 604.185059,225.228012 
	C604.896729,223.527374 603.377563,223.152817 602.369263,222.956757 
	C598.182495,222.142685 595.029297,220.801010 597.499695,215.612061 
	C597.614990,215.369766 597.300110,215.003433 597.087585,214.741318 
	C596.878296,214.483139 596.649292,214.248596 595.917358,213.717667 
	C596.635254,215.760361 596.745850,217.454819 594.872925,218.375946 
	C593.144287,219.226105 591.621277,218.536377 590.308594,217.415771 
	C588.618896,215.973297 587.152771,214.701187 584.704773,216.368652 
	C582.954041,217.561157 581.334961,216.037277 579.734192,215.149994 
	C575.265137,212.672760 572.137146,212.999756 569.913452,216.300903 
	C569.625183,216.815231 569.488586,217.008469 569.080200,217.428955 
	C566.706543,218.646378 564.727478,219.836670 562.824707,221.173950 
	C561.774780,221.911880 560.618774,223.068039 559.264954,222.101700 
	C557.680603,220.970886 558.972473,219.793991 559.548828,218.674423 
	C559.974121,217.848251 559.816589,217.083969 559.199097,216.403854 
	C559.112061,215.742859 558.149353,216.478897 558.790161,216.295013 
	C558.890991,216.266083 558.920044,216.336960 558.966125,216.478851 
	C560.115051,220.019638 558.148010,220.280258 555.706543,219.267151 
	C552.827332,218.072388 551.381653,215.522766 550.642212,212.277466 
	C549.762756,216.831253 548.379578,221.392441 543.300171,221.410629 
	C539.448853,221.424454 542.568909,217.226578 540.997070,215.117508 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M593.053223,192.674576 
	C591.867920,193.161972 590.705750,193.217331 589.615967,193.527481 
	C589.033752,193.693176 588.180847,194.706467 588.119568,194.646973 
	C584.724670,191.354691 579.169250,192.657242 576.417908,190.537247 
	C572.948669,187.864044 571.823120,189.741364 569.339539,190.962158 
	C568.861511,189.309341 569.038635,187.095749 566.359802,189.189926 
	C564.720825,190.471191 563.612244,192.474670 561.290649,193.121902 
	C560.009521,191.402710 563.413269,189.746170 560.737854,187.981339 
	C556.780884,185.371048 555.245667,185.490479 552.824585,190.303726 
	C551.717712,192.504379 550.914246,194.466385 547.727722,193.202896 
	C545.987000,192.512680 545.093689,193.773148 544.984314,195.636398 
	C544.892822,197.194687 545.557678,198.915268 543.972168,200.643387 
	C541.962891,197.724167 543.767883,194.438248 542.431641,191.361053 
	C542.715759,184.316833 543.251099,177.581970 543.889526,170.423355 
	C547.909912,170.740616 545.109192,174.544235 546.952271,176.423691 
	C547.104797,171.527115 551.011963,168.260254 552.120605,163.471390 
	C552.497986,162.991623 552.674377,162.818039 553.188416,162.482513 
	C557.815979,162.359421 559.342590,165.473526 560.629028,169.126373 
	C558.770264,172.977600 560.748291,175.094635 565.873901,174.677704 
	C568.862183,173.638046 570.131775,175.395599 571.565796,177.535812 
	C572.862793,178.737122 573.815430,179.846924 575.439026,180.284637 
	C574.612610,178.923401 572.972839,179.168259 571.900513,177.885300 
	C571.912720,173.869308 575.116272,174.973343 577.576965,174.258224 
	C578.179749,174.320633 578.415710,174.375504 578.969788,174.595825 
	C580.129272,175.334259 580.721863,176.783630 582.068665,175.370819 
	C583.321228,174.056900 584.383972,172.614288 585.637451,170.867142 
	C586.514954,170.245270 587.194824,170.121262 588.251282,170.275558 
	C590.380615,171.442123 590.679565,173.832031 592.802856,175.066833 
	C593.245972,175.426361 593.418213,175.577774 593.829224,175.978241 
	C596.680908,179.111069 599.145386,180.458450 602.904602,177.372818 
	C604.707397,175.893082 608.031372,173.218414 610.138794,178.028275 
	C610.510010,178.875473 612.527405,178.800400 613.697937,179.839966 
	C612.865906,178.427048 611.759521,177.162445 613.186035,175.822754 
	C614.130005,174.936218 615.387939,175.115814 616.489258,175.613525 
	C618.189392,176.381805 619.790588,177.228653 621.559998,175.677795 
	C622.843689,174.552643 624.431702,173.505112 625.987305,174.997253 
	C627.737366,176.675919 626.071411,178.277771 625.544006,179.531860 
	C627.803894,177.821060 628.482605,172.898712 633.608704,175.461044 
	C635.061951,177.444641 636.919861,178.388245 638.584839,179.570053 
	C638.723938,179.668777 638.944519,179.781982 638.982056,179.743546 
	C639.512939,179.200531 638.701111,179.045822 638.575134,178.375504 
	C638.406067,177.669113 639.006836,177.510330 638.917114,177.199371 
	C638.833923,176.911179 638.541016,177.031403 638.147949,177.587891 
	C636.421814,178.014191 635.336609,177.352890 634.144043,176.113800 
	C637.386841,170.615356 638.702393,170.300430 642.476562,174.298172 
	C644.079041,175.995590 645.398560,176.044724 647.149292,174.781601 
	C648.602844,173.732864 650.013916,172.534119 652.286499,172.474213 
	C655.354797,173.262665 656.300049,177.262756 660.078247,176.208008 
	C660.455078,175.794968 660.610718,175.632797 661.018860,175.246338 
	C661.790833,174.614655 662.333069,174.213608 662.694763,173.660294 
	C665.750854,168.984695 666.871704,169.036743 669.426025,173.972382 
	C670.249268,175.563171 671.598816,173.464432 672.830566,174.548035 
	C674.286438,175.798935 672.972839,178.953247 676.433044,178.515961 
	C677.189880,179.148163 676.540527,178.596039 677.035156,179.042953 
	C677.274048,179.258804 677.511414,179.474365 677.776672,179.657166 
	C677.606567,179.545334 677.455566,179.408646 677.069397,179.058640 
	C675.757019,176.450027 676.891052,174.651077 679.039246,175.790482 
	C683.080505,177.934021 685.432556,175.920898 688.235474,173.699570 
	C692.589294,170.249161 692.675537,170.349808 696.650879,174.596832 
	C698.353088,176.415436 700.197083,178.029800 702.364014,179.311081 
	C703.828064,180.176743 704.819153,179.907043 705.928223,178.332977 
	C706.316772,177.903946 706.483765,177.742874 706.929077,177.373993 
	C707.908264,176.726379 708.650696,176.353821 709.287292,175.811432 
	C714.480408,171.386642 714.548340,171.281113 720.181702,174.801453 
	C724.184021,177.302490 726.178772,174.932541 728.277527,171.700806 
	C728.565552,171.178162 728.711548,170.983765 729.192139,170.632645 
	C734.235413,172.123367 734.560181,173.112488 731.501587,177.485001 
	C731.028320,177.962250 730.801392,178.189499 730.578918,178.421143 
	C730.356445,178.652969 730.138367,178.888519 729.922852,179.126053 
	C730.215881,178.979233 730.325500,178.656326 730.794678,178.216675 
	C733.412415,176.122284 735.813049,172.897858 738.027222,178.225891 
	C738.216492,178.681335 739.606201,178.371979 740.388184,179.194901 
	C740.606384,179.469467 740.651245,179.581467 740.633057,179.429413 
	C740.100647,176.276108 741.731750,174.551620 744.152710,175.901840 
	C748.688782,178.431747 752.190918,169.950027 756.574341,175.154953 
	C761.063232,173.839096 764.064880,170.528290 767.336365,167.005798 
	C770.208862,164.306717 772.455444,160.892059 777.245605,163.028778 
	C777.762573,163.331207 777.952087,163.475525 778.339844,163.910675 
	C778.951965,165.146210 778.701599,166.094971 778.536133,167.116821 
	C780.488647,166.332413 780.870911,163.593689 783.574463,163.523346 
	C786.442444,165.767197 788.425232,168.596420 791.807129,170.282272 
	C792.992737,170.695450 793.414673,173.390579 795.115234,170.845047 
	C797.665527,170.412933 799.743958,172.454071 802.327759,170.782623 
	C803.930786,169.745636 805.665039,171.323380 805.645325,173.130066 
	C805.613586,176.033752 807.574158,173.506210 808.526001,174.422958 
	C810.640747,175.998535 809.231384,177.900940 809.721313,179.823059 
	C810.016479,180.252350 810.138062,180.420395 810.419800,180.852600 
	C810.813049,181.650177 810.955322,182.204620 810.969788,182.990692 
	C810.973633,183.191940 810.958740,183.496887 810.958740,183.496887 
	C810.958740,183.496887 811.275024,183.439636 811.394897,183.237030 
	C811.634583,182.901611 811.754333,182.768799 812.115479,182.474258 
	C812.734497,182.138733 813.124878,182.000427 813.853516,181.815125 
	C815.343201,181.540176 816.441162,181.197784 817.373840,180.427811 
	C818.775146,179.271027 820.110168,177.753708 822.191589,178.474075 
	C824.790649,179.373596 822.157898,181.862213 823.738831,183.488403 
	C826.704773,182.125351 830.316467,182.195908 832.997864,179.610077 
	C835.018677,177.661346 836.885803,178.241669 838.548340,180.607391 
	C838.622375,181.186676 838.613831,181.344604 838.613831,181.344604 
	C838.906494,181.767960 839.098267,181.719482 839.431946,180.987000 
	C841.530823,179.890030 842.992920,180.140823 843.884033,182.595398 
	C841.970886,189.757263 841.421448,190.183929 835.353271,189.291931 
	C834.099854,188.998993 833.213257,188.701859 831.938354,188.980530 
	C828.117126,190.673813 823.944885,188.265198 820.610107,190.944107 
	C820.128357,191.331131 819.191101,191.223495 818.827332,191.739746 
	C816.255127,195.390656 814.838928,195.062454 812.864319,190.948334 
	C812.164307,189.489899 808.416260,189.948425 806.179016,190.843491 
	C804.656616,191.452606 803.458496,191.445816 801.952332,190.796951 
	C798.626526,189.364227 795.357971,188.649139 792.804504,192.446655 
	C792.076843,193.528793 790.010071,194.252518 789.328613,193.087921 
	C787.574280,190.089981 784.397339,190.202438 781.869019,188.960083 
	C780.777405,188.423706 779.985413,188.024994 779.639404,186.658859 
	C778.493164,182.133148 776.508301,183.438370 774.261292,186.377655 
	C773.904358,186.848145 773.747009,187.025208 773.317749,187.431244 
	C772.037598,188.298416 770.983521,188.756409 769.485413,188.345795 
	C768.927612,187.996231 768.724304,187.779312 768.613403,187.541946 
	C768.643066,187.618607 768.796753,187.805328 769.256958,188.346313 
	C769.521240,190.484406 768.218018,190.739700 766.828552,190.629990 
	C764.949707,190.481689 763.267151,190.945648 761.330627,191.920807 
	C759.610046,192.757980 756.347412,186.167221 756.292725,193.304733 
	C756.282104,194.688385 753.546448,193.383270 752.865540,192.173721 
	C751.187012,189.192230 748.996277,188.287277 745.820435,189.538177 
	C745.248413,189.763504 744.475647,189.828537 743.905518,189.638168 
	C742.643005,189.216553 742.575684,185.535980 740.468262,187.901276 
	C738.952820,189.602127 742.187805,190.636215 742.628479,192.200500 
	C741.214722,193.201630 740.058350,193.154816 739.233154,192.112793 
	C737.052063,189.358749 735.568665,189.274765 733.794006,192.679993 
	C732.333130,195.483276 730.709900,193.133255 729.572815,191.986343 
	C727.964966,190.364685 726.806396,187.749588 724.517578,191.366562 
	C723.883179,192.369080 722.744141,191.823883 721.977722,190.993179 
	C721.309387,190.268768 720.294800,190.062775 719.837585,190.865631 
	C717.082764,195.702682 714.406128,194.867157 711.435425,191.057312 
	C710.495789,189.852203 709.864746,190.858795 708.797119,191.597244 
	C706.116638,193.451202 702.987183,195.944122 700.044434,191.629349 
	C698.531921,189.411621 696.894043,190.457138 695.457581,191.769379 
	C692.829468,194.170166 690.271057,194.399612 687.633301,191.812576 
	C683.990173,188.239578 681.105164,191.495499 678.604980,193.337219 
	C676.658752,194.770798 676.158569,194.834320 675.004211,192.795532 
	C673.286072,189.760803 671.149963,188.340210 668.977051,192.515442 
	C667.905701,194.574051 666.116577,194.246231 665.639404,192.711929 
	C664.279419,188.339233 662.083130,192.056808 660.337341,191.836395 
	C658.599976,191.617050 656.980286,188.959244 655.189575,192.403763 
	C654.427979,193.868866 651.863159,195.750000 649.343201,193.395859 
	C648.820923,192.907974 647.452942,193.247620 646.484924,193.328186 
	C642.645813,193.647736 638.925476,195.006180 635.341675,191.589554 
	C632.969910,189.328369 629.400452,192.607513 626.372070,191.383087 
	C626.145020,191.291275 625.586914,191.783279 625.472839,191.680847 
	C621.863037,188.438843 618.638000,190.639893 615.362305,192.333069 
	C614.786621,192.630646 614.128418,192.865005 613.609314,192.204071 
	C612.849182,191.236237 616.222656,189.918045 613.479065,189.259369 
	C611.953735,188.893204 611.196960,191.930664 610.615417,191.474228 
	C607.461487,188.998627 602.850525,196.178421 600.511902,189.844971 
	C600.452271,189.683685 599.690918,189.598495 599.680420,189.628143 
	C598.489990,192.982529 594.862549,190.425034 593.053223,192.674576 
z"/>
<path fill="#C4CCC0" opacity="1.000000" stroke="none" 
	d="
M569.079834,217.079178 
	C569.152405,213.212112 569.124939,210.042404 574.867554,212.381821 
	C577.198853,213.331543 580.091919,212.972229 582.012390,215.319229 
	C582.547485,215.973221 583.787842,216.239029 584.247375,215.565338 
	C587.275146,211.126099 589.029419,214.708710 591.053101,216.552216 
	C592.219177,217.614487 593.500183,218.626083 594.935547,217.282074 
	C596.767273,215.566895 594.607239,215.379944 593.785278,214.575531 
	C592.751587,213.563980 593.791626,212.785156 594.460510,212.133102 
	C595.209839,211.402557 595.790955,211.270599 596.917297,212.086502 
	C600.537231,214.708740 599.331055,217.341248 597.026001,220.089157 
	C599.903931,220.964432 602.787903,220.687592 604.967285,222.482956 
	C608.016663,224.994980 601.992676,227.546371 605.025146,230.199982 
	C606.765869,229.945068 605.454102,227.224136 607.695801,227.056976 
	C610.268738,229.594864 609.190918,232.712326 609.400208,235.999603 
	C609.444336,237.514130 609.248657,238.683792 609.973877,240.043396 
	C610.213379,240.524139 610.291504,240.723114 610.387390,241.236130 
	C610.672668,242.033783 609.244507,241.994720 610.212280,242.917160 
	C610.366821,243.389343 610.375366,243.593628 610.281128,244.087524 
	C609.877625,244.912735 609.469421,245.375870 608.968506,246.147583 
	C608.635803,246.536591 608.486023,246.677917 608.036621,246.893936 
	C605.565002,246.556442 603.558899,247.703842 601.454346,247.927048 
	C599.781982,248.104401 598.863708,248.519836 597.963440,246.948212 
	C597.463257,246.075104 596.770874,244.975632 595.707947,245.585663 
	C594.664185,246.184601 595.175964,247.299774 595.753113,248.189941 
	C596.430603,249.234924 597.873474,250.558395 596.071533,251.437683 
	C594.791443,252.062286 594.310242,250.394714 593.891113,249.320251 
	C593.346252,247.923782 592.086609,247.808960 590.976013,248.085510 
	C588.380432,248.731918 585.886902,249.476456 583.600769,247.237823 
	C583.319519,246.962433 581.995178,247.140762 581.801575,247.479187 
	C578.889771,252.568985 575.876099,248.997574 573.967041,247.027313 
	C571.289368,244.263885 569.623291,244.912048 568.371826,247.684418 
	C567.382446,249.876312 565.849243,250.644989 564.127014,249.753479 
	C560.121826,247.680267 555.611084,251.003815 551.697144,248.230530 
	C550.736511,247.549835 549.623718,248.939453 548.709900,249.613541 
	C542.875000,253.917816 542.879272,253.923599 539.216797,247.177765 
	C538.886597,246.529266 538.846619,246.084183 538.918762,245.318878 
	C539.505371,244.584335 539.702087,244.087921 539.305908,243.239166 
	C539.554077,233.911301 539.979309,224.812927 540.563110,215.311783 
	C541.106628,215.416656 541.566162,215.884583 541.861816,216.439743 
	C542.598145,217.822617 540.829834,220.350494 543.822571,220.710510 
	C543.360718,217.660110 550.242554,219.728485 547.770630,214.743576 
	C546.869568,212.926468 549.970093,211.225555 551.394348,209.607712 
	C551.868347,209.069305 552.673889,209.596710 552.808533,210.346161 
	C552.921448,210.974335 552.968262,211.714569 552.743347,212.286911 
	C551.335266,215.869736 554.466125,217.054535 556.367737,218.410294 
	C557.959778,219.545303 559.636902,218.948166 557.827209,216.590469 
	C557.095093,215.636627 555.359070,215.505630 555.422668,213.773148 
	C561.155334,215.246429 561.634705,216.126495 559.291077,221.460876 
	C562.896118,220.816879 564.545898,216.710052 568.618652,217.000641 
	C569.000000,216.999390 569.159729,217.157745 569.079834,217.079178 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M552.747803,162.767548 
	C552.894775,163.810333 553.067627,164.836044 552.635742,165.392090 
	C550.841675,167.702103 550.133301,169.700424 554.243835,171.432037 
	C549.781006,170.697067 547.721802,171.504074 548.701294,175.968445 
	C548.958679,177.141571 548.074646,179.640442 545.991577,179.339905 
	C544.339905,179.101593 545.179382,177.136658 545.028687,175.929092 
	C544.806641,174.150177 544.718750,172.354523 544.283081,170.282806 
	C543.976990,169.242004 543.961426,168.484421 544.034424,167.356049 
	C544.748352,166.277786 545.058167,165.506348 544.434326,164.302109 
	C544.535217,159.603821 544.811951,155.184708 545.146423,150.397736 
	C548.424866,151.425964 548.685059,146.941513 551.866821,147.137527 
	C553.092041,147.816666 553.525696,148.520340 554.500000,149.078186 
	C554.903076,149.370682 555.057373,149.496353 555.409424,149.843170 
	C556.096619,150.651978 556.378601,151.418121 557.350830,151.963974 
	C557.759827,152.242020 557.921509,152.359238 558.311523,152.675140 
	C559.121643,153.458572 559.692627,154.053772 560.430176,154.934113 
	C560.699036,155.406036 560.784546,155.608917 560.949097,156.136002 
	C561.086304,156.906982 561.102844,157.355515 561.045715,158.144714 
	C560.469910,159.927551 559.817688,160.807251 562.150085,161.920044 
	C567.595886,164.518234 567.613831,166.198044 562.955078,170.475006 
	C562.168274,170.747498 561.695129,170.777451 560.609375,170.366028 
	C558.861389,166.833221 557.247864,164.088303 553.380066,163.009277 
	C552.202515,162.072647 550.803589,161.735870 550.380676,160.148193 
	C550.324341,159.909943 550.342834,159.550659 550.342834,159.550659 
	C550.342834,159.550659 549.995667,159.568008 550.013733,159.806030 
	C550.022278,161.696045 551.473572,161.902878 552.747803,162.767548 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M523.719055,288.117096 
	C521.743530,287.691620 520.229126,287.249512 518.230835,286.666168 
	C521.000000,285.198975 522.780273,286.540588 524.862671,287.618286 
	C524.781250,287.969910 524.480652,288.035217 523.719055,288.117096 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M539.684448,190.911835 
	C538.138000,190.394470 537.272644,189.483917 539.468994,188.095978 
	C539.799133,188.881027 539.793274,189.742386 539.684448,190.911835 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M544.159241,164.384827 
	C546.315002,164.652679 546.695374,165.569641 544.435913,166.935303 
	C544.101990,166.239105 544.080994,165.492920 544.159241,164.384827 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M539.033569,243.334259 
	C539.769165,243.108200 540.523743,243.188782 540.516724,244.002487 
	C540.513977,244.313095 539.928772,244.618683 539.319946,244.962616 
	C539.000061,244.552063 538.969238,244.105453 539.033569,243.334259 
z"/>
<path fill="#C4CCC0" opacity="1.000000" stroke="none" 
	d="
M540.850708,211.322632 
	C541.688782,211.434631 542.015808,211.972519 541.141113,212.883331 
	C540.849304,212.568985 540.794250,212.111237 540.850708,211.322632 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M366.024231,553.054443 
	C363.714172,554.462585 363.007904,553.662598 363.024261,551.674316 
	C363.040283,549.729675 363.024506,547.784729 363.082092,545.390869 
	C363.773834,544.933167 364.406158,544.924438 365.353668,544.875977 
	C368.346954,547.257324 365.808167,550.155884 366.024231,553.054443 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M360.910828,534.753967 
	C359.696716,530.735596 359.010834,526.318604 359.008728,521.354187 
	C361.948364,523.790588 360.850281,527.851807 361.947754,531.670044 
	C360.985687,532.618713 361.030945,533.541870 360.910828,534.753967 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M365.937683,553.555908 
	C365.712585,550.803650 365.771362,548.266846 365.749512,545.283142 
	C366.189941,543.763306 365.733978,542.292419 367.300171,541.198181 
	C368.429901,543.217163 367.983093,545.225525 367.982910,547.581665 
	C367.640625,549.765930 367.301086,551.524841 366.916199,553.674805 
	C366.654449,553.967712 366.438019,553.869568 365.937683,553.555908 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M347.304657,518.793945 
	C346.784576,518.193237 346.495209,517.394409 346.244812,516.275452 
	C347.825592,516.302429 348.308960,517.151245 347.304657,518.793945 
z"/>
<path fill="#8395B3" opacity="1.000000" stroke="none" 
	d="
M307.201538,516.205566 
	C304.769196,519.133850 302.271362,521.996033 299.485077,525.034668 
	C296.838623,520.126892 295.905853,514.688782 295.399353,508.809448 
	C295.581146,508.428955 295.784302,508.221008 295.885620,508.116821 
	C298.397186,506.150848 299.553802,508.234680 300.684967,509.677185 
	C302.392181,511.854370 303.957977,514.124146 306.725830,515.760132 
	C307.006622,516.006226 307.136108,516.139587 307.201538,516.205566 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M295.248108,508.404907 
	C296.410034,513.812927 299.324921,518.723389 299.193237,524.768555 
	C299.131958,525.655273 299.067322,526.099609 298.772980,526.790344 
	C298.543274,527.036804 298.528564,527.002136 298.518402,526.986328 
	C296.798279,528.046143 296.625366,526.567688 296.204346,525.112854 
	C296.291046,520.657776 295.248932,516.811707 294.529480,512.917786 
	C294.244507,511.375519 293.243286,509.761108 295.248108,508.404907 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M313.395172,515.990234 
	C312.949402,516.388489 312.679138,516.566528 312.217834,516.894897 
	C311.522308,517.203735 311.133057,517.077393 310.905945,516.332031 
	C313.011383,513.141052 314.490784,509.879791 317.665894,507.534180 
	C317.740021,508.743164 317.457581,510.048950 317.017578,511.735657 
	C316.860077,512.116638 316.917694,512.112183 316.946198,512.107544 
	C316.468079,512.478455 316.504303,513.099548 316.113281,513.828979 
	C315.932983,514.048950 316.033997,514.023926 316.027222,513.972290 
	C315.802063,514.179565 315.565735,514.420837 315.115601,514.805664 
	C314.919647,514.966675 315.005432,514.956970 315.003723,514.913940 
	C314.516998,515.158630 314.031982,515.446289 313.395172,515.990234 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M310.712219,516.160706 
	C311.173767,516.264526 311.358856,516.537537 311.773560,516.909851 
	C312.003113,517.009094 311.934235,517.435242 311.886475,517.645752 
	C310.722687,518.757751 309.606659,519.659180 308.231934,520.286255 
	C308.075134,518.303711 309.679443,517.600403 310.712219,516.160706 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M304.707245,523.783386 
	C305.239288,525.125610 304.436554,525.626526 303.299652,526.088806 
	C302.795837,524.856750 303.562836,524.208923 304.707245,523.783386 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M307.696106,519.976929 
	C309.005341,521.612610 307.371429,521.903564 306.290344,522.335693 
	C306.424286,521.338318 306.901062,520.660583 307.696106,519.976929 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M327.669403,494.712402 
	C328.666412,495.290833 328.325745,496.017944 327.330719,496.845154 
	C326.016205,496.080505 326.940643,495.581573 327.669403,494.712402 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M331.658386,491.749512 
	C331.714264,492.803497 331.041748,493.175201 329.820374,493.148743 
	C330.066467,492.509155 330.685547,492.035492 331.658386,491.749512 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M305.667755,522.096313 
	C307.307892,522.735229 306.202881,523.279541 305.396851,523.968567 
	C304.039490,523.240601 305.048004,522.813599 305.667755,522.096313 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M335.357666,489.676331 
	C335.176086,490.024872 334.928711,490.030792 334.310791,490.014832 
	C334.064911,489.104980 334.477020,488.806458 335.357666,489.676331 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M332.647217,490.881714 
	C332.831940,491.256714 332.663055,491.575775 332.214966,491.944550 
	C332.055054,491.604797 332.174316,491.215271 332.647217,490.881714 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M333.681641,489.936157 
	C333.837952,490.261414 333.669189,490.582611 333.219116,490.951782 
	C333.077423,490.643921 333.217010,490.287994 333.681641,489.936157 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M326.580505,496.787720 
	C326.819824,497.289612 326.688141,497.640686 326.248169,497.969604 
	C325.572479,497.416534 325.664398,496.980103 326.580505,496.787720 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M210.552063,956.518188 
	C212.766174,955.671021 213.761871,958.056458 215.583160,958.057068 
	C213.407700,959.574097 211.734848,958.789185 210.552063,956.518188 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M199.217285,953.152100 
	C200.446930,951.428345 201.426208,952.863892 202.505020,953.717407 
	C202.559341,953.760376 202.214783,954.626160 201.914185,954.742615 
	C200.756165,955.190857 200.139572,954.398315 199.217285,953.152100 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M181.368057,945.398560 
	C181.492844,946.587952 181.052933,947.174744 180.063416,946.804932 
	C179.790115,946.702698 179.480316,945.979675 179.592255,945.709351 
	C179.854477,945.076477 180.470169,944.870972 181.368057,945.398560 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M207.099030,955.978516 
	C207.497955,955.568359 207.984070,955.276001 208.261368,955.411377 
	C208.784210,955.666626 208.702393,956.265747 208.237503,956.498962 
	C207.960419,956.637939 207.480621,956.372864 207.099030,955.978516 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M199.039642,953.054688 
	C198.675629,953.546082 198.297958,954.249023 197.612244,953.453125 
	C197.858917,953.275818 198.105591,953.098511 198.581238,952.854736 
	C198.810211,952.788330 198.964096,952.965088 199.039642,953.054688 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M428.013824,749.026550 
	C433.944550,742.225464 438.903107,734.610779 445.603119,728.024658 
	C446.999298,729.988647 448.116272,732.138184 449.263672,734.346252 
	C452.081604,732.858704 447.345123,728.302612 451.602448,728.320007 
	C453.637512,728.328308 455.919556,726.869263 457.980957,728.800354 
	C458.461304,731.518555 456.630493,732.770630 455.207794,733.970642 
	C450.279755,738.127258 445.913879,742.833313 441.185486,747.674438 
	C440.898346,747.876831 440.917511,747.945496 440.949036,747.928833 
	C440.766022,748.049316 440.551483,748.186401 440.062012,748.058411 
	C435.634705,750.296753 432.597900,753.966553 429.276428,757.814514 
	C428.223694,757.377258 427.424103,756.729004 426.314148,756.041809 
	C426.335480,754.601929 426.667084,753.201111 426.999268,751.436096 
	C427.434723,750.620972 427.499542,750.018677 427.850769,749.228577 
	C428.041107,749.001465 428.001190,749.009644 428.013824,749.026550 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M441.203979,748.054077 
	C442.272369,743.452576 446.151428,741.036316 449.063141,737.878296 
	C451.749329,734.964844 454.819000,732.404907 457.873627,729.400635 
	C458.700165,728.647461 459.372833,728.183044 460.232849,727.473511 
	C460.743683,726.822449 461.155304,726.656494 461.953064,726.997681 
	C463.173767,729.473389 461.788269,731.050781 460.570740,732.587036 
	C454.410492,740.359863 447.986694,747.930420 442.446167,756.604614 
	C441.252289,757.901184 440.272247,759.003662 438.394836,759.162109 
	C437.500977,756.095520 439.932434,754.567078 441.389374,752.716064 
	C442.724640,751.019653 443.579498,749.802063 441.203979,748.054077 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M438.028137,759.041870 
	C438.991913,758.385437 439.939362,757.707458 441.175842,756.986511 
	C441.714874,756.792114 441.964874,756.640747 442.583069,756.727173 
	C442.951324,756.965027 442.960358,757.446106 442.949524,757.686157 
	C441.079620,758.871094 440.898010,761.505737 438.370300,762.086060 
	C438.042236,761.611084 438.056305,761.172058 438.063171,760.403625 
	C437.921539,759.895264 437.787079,759.716309 437.857208,759.271118 
	C438.061768,759.004883 438.011810,759.020447 438.028137,759.041870 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M437.786072,762.162354 
	C438.359222,762.705261 438.146881,763.297607 437.352142,763.933533 
	C437.195740,763.460876 437.358795,762.890198 437.786072,762.162354 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M435.771667,765.161255 
	C435.883179,765.586060 435.722412,766.161133 435.289795,766.896606 
	C435.178406,766.475220 435.338928,765.893311 435.771667,765.161255 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M439.908936,747.982666 
	C439.993530,747.735840 440.199951,747.678345 440.693481,747.766541 
	C440.758240,748.343689 440.514038,748.695068 439.908936,747.982666 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M437.886047,759.094177 
	C438.069092,759.182861 438.076416,759.360840 438.069855,759.806580 
	C437.940765,759.777344 437.825562,759.480408 437.886047,759.094177 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M436.795227,764.107178 
	C436.883179,764.343018 436.731323,764.666382 436.298096,765.014038 
	C436.196259,764.757080 436.375854,764.475891 436.795227,764.107178 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M434.801453,767.105835 
	C434.862366,767.297241 434.669464,767.596741 434.236237,768.024170 
	C434.179810,767.839417 434.363708,767.526672 434.801453,767.105835 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M363.131256,1006.684448 
	C363.044250,1006.000732 363.263458,1005.189331 363.750763,1004.200684 
	C363.825043,1004.867859 363.631256,1005.712341 363.131256,1006.684448 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M372.910950,1005.635864 
	C373.175140,1005.367004 373.566528,1005.257141 373.965424,1005.202148 
	C374.033112,1005.192871 374.133270,1005.419678 374.218445,1005.537476 
	C373.825806,1005.629395 373.433228,1005.721375 372.910950,1005.635864 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M365.460510,1009.530029 
	C365.432953,1009.481201 365.488068,1009.578796 365.460510,1009.530029 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M400.476685,1004.444336 
	C400.535126,1004.407410 400.418243,1004.481262 400.476685,1004.444336 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M386.996887,1004.002441 
	C387.112823,1004.146179 387.231873,1004.287476 387.350952,1004.428833 
	C387.267029,1004.377441 387.183105,1004.326050 387.052094,1004.134033 
	C387.005005,1003.993469 387.000000,1004.000000 386.996887,1004.002441 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M437.301453,462.962463 
	C437.343506,462.015533 437.901611,461.269653 439.054199,461.287689 
	C439.127472,461.288849 439.315277,461.941772 439.243073,461.991547 
	C438.727295,462.347168 438.157776,462.624878 437.301453,462.962463 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M437.000366,463.000671 
	C436.519531,463.678040 435.885406,464.009888 435.051544,463.811035 
	C434.951202,463.787109 434.898407,463.563843 434.823578,463.432922 
	C435.348450,463.268127 435.873352,463.103333 436.697906,462.968018 
	C436.997559,462.997559 437.000000,463.000000 437.000366,463.000671 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M431.880493,446.873810 
	C432.081024,446.544312 432.474365,446.409119 432.867706,446.273895 
	C432.886230,446.534210 432.904755,446.794556 432.698120,447.248474 
	C432.339783,447.317383 432.206543,447.192749 431.880493,446.873810 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M128.315140,743.173584 
	C123.092659,731.998352 117.687317,721.247375 114.751976,709.498901 
	C113.756790,705.515808 112.291397,701.644958 112.018738,697.042480 
	C114.053955,701.965942 116.110031,707.342163 118.319565,713.039551 
	C121.847527,725.479614 128.547897,736.154297 133.356613,747.650269 
	C133.994232,749.174561 134.535461,750.739136 135.058075,752.665894 
	C131.977478,750.422180 130.158646,746.993774 128.315140,743.173584 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M107.985214,752.655029 
	C103.540070,749.686951 101.831604,744.687134 99.784698,739.474731 
	C104.224930,742.390320 105.636520,747.641296 107.985214,752.655029 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M309.842773,895.801392 
	C308.406738,896.057556 307.007904,896.330872 305.300598,896.790466 
	C304.722473,897.296875 304.408508,897.565002 303.739777,897.812622 
	C299.521545,896.911743 296.335968,899.606445 292.309235,900.136230 
	C291.748077,900.381042 291.566498,900.472961 291.123047,900.721802 
	C290.861206,900.878723 290.821472,900.802246 290.780884,900.783813 
	C290.237915,900.851929 289.735474,900.938477 289.043457,901.204224 
	C288.875488,902.193848 288.488434,902.524597 287.321228,902.061646 
	C285.765717,901.968872 284.580322,902.188721 283.130127,902.654541 
	C282.565277,903.307190 282.158325,903.477417 281.345642,903.279175 
	C280.852600,903.112793 280.673889,903.112671 280.247131,903.214233 
	C279.533203,903.610962 279.072296,903.917542 278.222168,903.919922 
	C277.776550,903.902283 277.605072,903.917542 277.196564,904.035461 
	C276.489990,904.479797 275.905701,904.471924 275.130737,904.772217 
	C274.877380,904.889282 274.930603,904.834045 274.896240,904.817017 
	C273.202515,906.670898 271.029419,906.834961 268.377747,906.448975 
	C267.493500,906.443237 266.979828,906.628662 266.221313,906.950500 
	C265.295532,907.562805 264.471436,907.798218 263.565674,908.517212 
	C262.718719,908.967773 262.128448,909.219910 261.240479,909.614746 
	C260.725739,909.816772 260.514618,909.888794 259.978424,910.050354 
	C258.762390,910.355042 257.865753,910.550293 256.675049,911.035889 
	C253.438843,911.872986 250.759140,913.890381 247.260559,912.361633 
	C245.855362,912.050903 244.725967,912.010254 243.171616,911.915039 
	C240.282776,904.879517 235.587997,899.137024 232.010193,892.384155 
	C233.069077,892.440430 234.236801,892.826599 235.673309,893.301697 
	C235.336090,891.581787 235.046997,889.848694 236.566620,888.203247 
	C239.082062,889.830750 238.631042,892.829895 239.772781,895.184265 
	C241.953171,899.680786 243.952972,900.949463 248.830109,900.076538 
	C256.520721,898.700195 264.015808,896.518677 271.850555,894.207886 
	C273.648438,894.122559 274.951080,893.533630 276.627625,893.103882 
	C277.586365,893.058899 278.217163,893.062683 279.111938,892.807007 
	C279.568176,892.599243 279.749573,892.514160 280.210083,892.319641 
	C281.238861,891.973938 282.014313,891.817200 282.987091,891.329773 
	C283.594818,890.982727 283.968506,890.845520 284.643646,890.873779 
	C286.825073,892.452393 288.934753,891.529175 290.488251,890.764771 
	C292.875641,889.590149 292.108154,888.380310 289.370544,888.004944 
	C288.749420,887.511414 288.498810,887.022766 288.142517,886.279480 
	C288.221954,885.793274 288.377319,885.516357 288.341187,885.497009 
	C287.753448,885.183167 288.878632,885.701111 288.084900,885.830078 
	C286.802704,885.791260 284.546997,886.053833 285.757690,884.149231 
	C287.049133,882.117554 287.557648,878.365967 291.789612,879.739258 
	C293.110657,879.861816 293.894318,879.388733 293.905457,877.757935 
	C294.448730,876.298706 295.391724,876.207153 296.764160,876.534912 
	C298.353516,877.914551 297.805328,879.673523 298.308044,881.575317 
	C299.849792,879.935486 299.525543,878.033264 300.436249,876.276123 
	C300.962921,875.691406 301.355713,875.493652 302.131683,875.441772 
	C304.118225,875.685120 302.154449,878.192444 304.328064,878.460815 
	C304.559662,880.244202 304.396332,881.754883 304.695435,883.509766 
	C304.995911,883.943848 305.074768,884.036438 305.074768,884.036438 
	C305.364563,884.403809 305.376678,884.417725 304.941772,883.864197 
	C303.921570,881.861572 305.268799,879.792664 303.818970,877.800171 
	C303.473267,877.085327 303.453979,876.615479 303.538818,875.774597 
	C304.334351,874.154297 305.520020,873.973389 307.181580,874.212402 
	C308.898865,875.117737 309.670746,876.618408 311.553528,876.912292 
	C316.231232,877.642273 318.904938,881.474670 322.521484,884.388062 
	C323.082794,884.493469 323.304474,884.557312 323.808563,884.824463 
	C325.137054,887.938232 322.942474,887.307922 321.544556,887.522156 
	C322.813324,887.506714 323.906830,887.605164 324.635925,885.819397 
	C325.924988,882.661926 328.656281,881.718506 331.870178,882.616516 
	C333.781830,883.150696 335.406921,883.355774 336.691345,880.974304 
	C338.699615,879.993652 339.905579,880.872314 341.181610,882.443054 
	C341.398224,883.051514 341.426086,883.313232 341.260681,883.919128 
	C338.237366,886.192261 335.007477,887.107788 331.365723,887.926331 
	C330.636993,887.763794 330.854218,887.261780 330.615417,887.174622 
	C330.368378,887.084412 330.242676,887.378784 330.203491,887.948608 
	C324.798492,891.023987 318.917328,892.100830 313.118958,894.390991 
	C312.573273,896.155884 311.326111,895.264465 310.230804,895.724854 
	C309.909454,895.894958 309.880035,895.818420 309.842773,895.801392 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M259.231445,925.870422 
	C259.213501,924.192261 258.452881,922.377197 259.927063,921.108398 
	C262.675446,918.743103 261.979889,916.249512 260.164246,913.359619 
	C259.892670,912.804993 259.772797,912.571472 259.834778,911.987122 
	C261.324677,910.602478 262.753723,910.072510 264.719299,910.844482 
	C267.073547,910.244263 268.888885,911.634583 271.459686,911.253174 
	C267.622192,916.931763 264.261627,922.015564 260.733185,926.979980 
	C260.310547,927.574646 259.992096,926.266174 259.231445,925.870422 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M268.011353,906.592407 
	C270.031647,905.770081 272.056122,905.282349 274.471252,904.797363 
	C275.610077,908.644043 272.138916,908.318970 270.209259,909.195984 
	C268.427551,910.005676 268.162994,908.279724 268.011353,906.592407 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M265.007599,910.757690 
	C263.609528,911.479736 262.211426,911.847229 260.447937,912.214111 
	C259.321014,911.468750 259.223358,910.579773 259.747009,909.194092 
	C259.977997,908.782288 260.239532,908.655701 260.354095,908.744995 
	C261.161621,908.753601 261.821503,908.520874 262.733948,908.131348 
	C263.753143,907.579956 264.542328,907.288757 265.653992,907.042236 
	C265.653503,908.192322 265.330536,909.297791 265.007599,910.757690 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M277.997742,904.195618 
	C278.444000,903.669800 278.940002,903.452576 279.717529,903.275635 
	C279.778961,904.041687 279.770813,905.029785 279.282837,905.424011 
	C278.726044,905.873901 278.230530,905.156860 277.997742,904.195618 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M287.002136,902.089844 
	C287.369385,901.639954 287.787689,901.530884 288.529907,901.402649 
	C288.838989,902.108459 289.107574,902.987854 288.247955,903.371826 
	C287.434479,903.735229 287.287781,902.961121 287.002136,902.089844 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M281.196350,903.321899 
	C281.435425,903.030212 281.839539,902.947632 282.554504,902.882812 
	C282.978058,903.175354 283.232361,903.658691 283.181824,903.693115 
	C282.554230,904.119202 281.936859,903.961487 281.196350,903.321899 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M275.173645,904.907959 
	C275.371338,904.618713 275.865295,904.348145 276.659393,904.107788 
	C276.463013,904.400879 275.966431,904.663757 275.173645,904.907959 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M270.706787,916.908936 
	C270.896759,916.131409 270.944122,915.317688 271.818481,915.661804 
	C271.936218,915.708130 271.769043,916.478088 271.512085,917.100708 
	C271.115845,917.249084 270.941284,917.209778 270.706787,916.908936 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M269.225769,919.855164 
	C268.923035,919.208862 269.109283,918.661316 269.529663,917.935425 
	C269.934448,917.804504 270.105072,917.851807 270.350250,918.153931 
	C270.188141,918.923889 269.951447,919.438904 269.225769,919.855164 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M269.085388,920.099121 
	C268.979614,920.411987 268.759613,920.608704 268.539581,920.805359 
	C268.492645,920.557251 268.445709,920.309082 268.567780,919.908691 
	C268.736786,919.756409 268.971130,919.982910 269.085388,920.099121 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M269.926636,917.922546 
	C269.888214,917.458618 270.057831,917.188477 270.459747,916.796936 
	C270.646912,916.647278 270.966705,916.966980 271.128540,917.127686 
	C271.167206,917.586975 271.002594,917.860657 270.610718,918.259155 
	C270.424866,918.408875 270.089478,918.087952 269.926636,917.922546 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M267.416351,922.512634 
	C267.364746,922.426880 267.577820,922.393616 267.577820,922.393616 
	C267.577820,922.393616 267.467957,922.598389 267.416351,922.512634 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M129.835419,657.403687 
	C130.666840,658.200378 131.288422,658.750793 131.847717,659.358582 
	C132.728943,660.316162 133.254135,661.250244 131.655441,662.095825 
	C130.306870,662.809082 129.703690,661.855408 129.501785,660.951355 
	C129.190796,659.558899 127.073822,658.436340 128.764511,656.722473 
	C128.812195,656.674194 129.066299,656.801392 129.205643,656.879639 
	C129.348175,656.959717 129.467926,657.080261 129.835419,657.403687 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M389.162933,310.950867 
	C388.695404,312.124817 388.391632,313.877045 387.185944,313.244934 
	C386.262054,312.760529 387.552795,311.617859 388.285339,310.616333 
	C388.713013,310.481567 388.900269,310.566620 389.162933,310.950867 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M388.694336,310.617889 
	C388.654846,310.179840 388.837280,310.026550 389.255920,309.945251 
	C389.622986,309.894470 389.807190,309.835083 390.053223,310.059387 
	C390.123291,310.686768 389.974701,310.937408 389.453735,311.172546 
	C389.113190,311.113129 388.988068,310.976166 388.694336,310.617889 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M389.654083,309.970795 
	C389.690643,309.627991 389.942535,309.302124 390.486694,308.870361 
	C390.778961,308.764435 391.101288,309.095917 391.261047,309.264313 
	C391.151428,309.664001 390.881989,309.895294 390.363770,310.234802 
	C390.114990,310.343048 389.869385,309.987732 389.654083,309.970795 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M129.970123,955.965942 
	C128.190384,955.856262 126.593323,955.877808 127.955742,953.260498 
	C131.994003,945.502441 135.860550,937.655273 139.871078,929.882568 
	C140.391205,928.874512 140.854218,926.805237 142.562531,928.030884 
	C143.875198,928.972656 142.680450,930.365051 142.062195,931.530518 
	C137.894272,939.387756 133.245743,946.995728 129.839203,955.571899 
	C129.930664,955.942566 129.998840,956.000000 129.970123,955.965942 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M126.566872,957.568054 
	C126.475670,957.640747 126.446449,957.368103 126.446449,957.368103 
	C126.446449,957.368103 126.658073,957.495361 126.566872,957.568054 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M257.021179,381.464355 
	C258.729950,381.143768 259.728485,377.972076 261.819641,380.274506 
	C263.240692,381.839081 264.344757,383.125763 263.390350,385.501465 
	C262.417816,387.922302 263.297668,390.522247 265.585602,391.438873 
	C267.638885,392.261536 268.437592,389.775177 269.369629,388.255798 
	C269.957123,387.298035 270.297638,385.983948 271.828339,386.196686 
	C273.399017,386.414978 273.894409,387.739349 274.421051,388.954956 
	C275.527283,391.508362 274.783722,394.220520 275.029449,396.850250 
	C275.162384,398.273071 275.555969,399.628448 277.204651,399.701019 
	C279.235596,399.790436 278.919037,398.094208 278.983307,396.830444 
	C279.240387,391.773712 278.521027,386.666809 279.497711,381.047668 
	C282.372009,383.216888 282.880798,385.723846 282.415039,388.838989 
	C283.739899,388.064423 284.565796,387.581604 285.708191,387.063110 
	C287.839813,388.895538 287.406006,391.265686 287.421417,393.509644 
	C287.449402,397.577667 287.479584,401.644836 287.628784,406.187103 
	C287.355652,407.925415 287.600922,409.206238 287.458618,410.952698 
	C287.431152,420.251953 287.433807,429.070709 287.445068,437.889465 
	C287.447815,440.017456 287.838074,442.243622 286.282654,444.600464 
	C285.980560,444.981232 285.856018,445.374268 285.863403,445.580566 
	C282.243774,449.009644 277.400330,449.266449 273.143799,450.941559 
	C266.995270,453.361176 260.725983,455.473907 253.884903,457.942566 
	C254.902298,432.485107 255.912659,407.203064 257.021179,381.464355 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M296.263550,442.616608 
	C295.850861,442.921844 295.672974,442.946106 295.226318,442.987122 
	C294.749451,443.138855 294.541382,443.273804 293.999451,443.246826 
	C292.491241,442.054199 292.135010,440.647308 291.827087,438.857758 
	C291.729095,438.084015 291.680450,437.647827 291.556335,436.914093 
	C290.456299,435.085480 288.640869,436.304535 287.145874,435.219849 
	C286.055603,427.945862 286.726807,420.877472 286.521637,413.823456 
	C286.488922,412.699249 286.889038,411.918182 288.408691,411.581909 
	C289.186035,411.347931 289.618408,411.211945 290.335876,410.956879 
	C291.146881,410.524017 291.572815,410.120636 291.924988,409.250427 
	C292.084839,408.733276 292.145630,408.519653 292.291687,407.973511 
	C292.885651,405.857269 292.534882,403.981537 292.947357,402.193573 
	C293.166595,401.243225 293.377655,400.105377 294.608276,400.033630 
	C295.733917,399.967987 296.379974,400.829071 296.791321,401.785339 
	C297.469574,403.362061 297.380524,405.053558 297.365204,406.708252 
	C297.292969,414.518860 297.897827,422.307770 298.164185,430.470245 
	C297.981201,434.712402 297.808807,438.611328 296.263550,442.616608 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M296.348999,442.911499 
	C295.966278,439.066620 295.971069,435.244812 297.924683,431.092346 
	C301.456787,429.052795 304.790497,427.983093 308.354065,426.533997 
	C309.109589,426.199432 309.557770,426.053711 310.359375,425.865234 
	C312.113983,425.695190 313.416718,425.275421 314.921509,424.343628 
	C316.409393,423.822388 317.594696,423.786896 319.141296,424.034973 
	C321.580994,424.784546 322.501923,426.094238 321.793213,428.632874 
	C321.859711,429.180420 321.895599,429.399353 321.972107,429.950989 
	C322.054077,430.965271 321.974731,431.632294 321.619049,432.587799 
	C321.137512,433.205811 320.760864,433.442230 319.996399,433.596924 
	C319.457947,433.543335 319.250793,433.478851 318.785339,433.230103 
	C318.086029,432.656525 317.667236,432.228119 316.734497,432.259735 
	C314.163300,433.027710 313.046783,435.825714 309.994171,435.646484 
	C308.160400,435.762360 309.362671,431.884827 307.045654,433.671570 
	C304.994995,435.252838 300.533112,433.654907 300.828308,438.288086 
	C300.882324,439.136139 300.906830,439.927612 300.226440,440.932709 
	C298.906036,441.777405 297.787628,442.351410 296.348999,442.911499 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M289.966400,411.425293 
	C286.453644,412.692383 286.843445,415.510040 286.958771,418.149109 
	C287.196960,423.600342 286.379333,429.082336 287.758728,434.791534 
	C289.405762,436.350952 291.065704,434.390717 292.659973,435.731812 
	C292.933807,436.410553 292.953430,436.879150 292.956329,437.699341 
	C289.654205,439.873047 292.241028,441.097565 293.613159,442.706787 
	C294.023743,442.958984 294.210388,442.972900 294.677307,442.995361 
	C292.359070,444.324615 289.987549,446.573547 286.334167,445.003357 
	C286.003754,433.985504 286.026917,422.989777 286.097168,411.531494 
	C287.376526,409.960724 288.625153,409.875885 289.966400,411.425293 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M300.401581,441.129028 
	C300.952911,439.259552 298.169861,437.429596 299.724213,435.576721 
	C301.739349,433.174652 304.999542,433.300598 307.635284,432.139343 
	C310.669556,430.802521 309.621490,433.326141 309.846130,434.903687 
	C310.535522,435.558655 311.032257,436.003052 311.341492,436.953857 
	C308.182343,439.488037 304.255005,439.637573 300.401581,441.129028 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M320.679749,433.267456 
	C320.855469,432.226929 320.944031,431.523407 321.078888,430.468353 
	C322.181763,428.340790 324.621063,429.286011 326.006012,427.479187 
	C326.382507,427.065857 326.549255,426.916748 327.020721,426.631592 
	C329.026947,426.405518 330.632538,427.452271 332.698608,426.913147 
	C334.121857,426.888702 335.180695,427.286133 336.604980,427.131836 
	C337.150543,427.061096 337.374298,427.055298 337.932770,427.023804 
	C338.204041,427.994324 340.999451,429.672577 337.505585,429.853027 
	C331.985016,430.138123 326.867584,432.036469 321.413208,434.089783 
	C320.888458,433.962158 320.740509,433.783325 320.679749,433.267456 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M311.727875,437.234009 
	C310.965240,436.772858 310.552185,436.262604 310.111389,435.415588 
	C313.058594,435.232910 313.294617,431.082703 316.574463,431.166412 
	C317.637360,431.398224 318.031982,431.984680 318.648407,432.837280 
	C318.852936,433.122375 318.991211,433.062408 318.929718,433.106110 
	C319.289490,433.441833 319.446320,433.845551 319.093628,434.565857 
	C316.568176,435.585327 314.322815,436.385132 311.727875,437.234009 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M319.123749,434.826355 
	C318.832245,434.421326 318.850983,434.057190 318.868958,433.421387 
	C319.292145,433.101898 319.716064,433.053986 320.453430,432.968262 
	C320.824982,433.129181 320.883118,433.327911 320.988831,433.833801 
	C320.502228,434.383057 319.968109,434.625122 319.123749,434.826355 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M135.997314,754.732117 
	C135.658646,754.573425 135.300034,754.089355 134.948608,753.294495 
	C135.744385,753.136414 135.895828,753.746521 135.997314,754.732117 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M136.263092,755.677246 
	C136.146622,755.766174 136.064529,755.362061 136.008118,755.163452 
	C136.312637,755.074707 136.455261,755.282532 136.263092,755.677246 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M243.923492,678.834717 
	C242.126999,678.377502 240.839844,677.318054 240.029114,675.364136 
	C242.161591,675.292358 243.494720,673.900574 244.997971,672.594849 
	C246.895233,670.946838 248.720459,668.911743 251.675034,671.445190 
	C253.287628,672.827942 254.929504,670.817749 256.847229,670.022949 
	C260.271545,668.908386 261.977966,671.243652 264.222748,673.052124 
	C265.175995,675.359863 265.640350,677.401001 265.135071,679.892212 
	C264.900574,680.861206 264.626495,681.441223 263.956909,682.048035 
	C263.761017,682.184326 263.302399,682.075317 263.302399,682.075317 
	C263.302399,682.075317 263.235077,682.258484 263.349274,682.427002 
	C263.736267,683.680908 263.172760,684.400940 262.098480,685.163452 
	C261.576111,685.307983 261.355225,685.318604 260.825470,685.206482 
	C259.487915,684.392883 258.521057,683.617188 257.236023,682.907104 
	C257.270813,682.990479 257.446716,683.188660 257.507172,683.787842 
	C257.481140,684.241638 257.431335,684.422791 257.190155,684.811035 
	C253.852020,684.318970 251.466446,682.249207 248.833405,680.592590 
	C247.403534,679.692993 246.234924,677.950928 243.923492,678.834717 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M264.383179,680.482422 
	C264.026184,678.210876 263.854401,676.215393 263.933838,674.050293 
	C264.473267,673.574585 264.816101,673.359497 265.525574,673.233459 
	C266.017456,673.243652 266.209839,673.276794 266.658508,673.431519 
	C267.316132,673.902588 267.709290,674.328918 268.513641,673.624329 
	C270.635040,673.680847 272.300171,674.174927 273.689545,675.904114 
	C273.756439,676.490540 273.709991,676.756775 273.621277,677.426270 
	C274.084076,678.668335 273.993958,679.539734 273.565796,680.714600 
	C273.249939,681.156433 273.089203,681.304871 272.632782,681.588440 
	C271.928192,681.811890 271.515900,681.859985 270.825134,681.775391 
	C270.157013,681.624817 269.626556,681.185608 269.317657,682.543152 
	C267.253845,682.842285 266.726898,684.268066 266.303894,685.427307 
	C264.653870,689.948914 262.179138,689.977356 258.919678,686.303223 
	C258.976410,685.438904 259.111115,685.252136 259.531067,684.870728 
	C260.044037,684.643555 260.271698,684.611084 260.772522,684.789246 
	C261.045654,684.999939 260.996613,685.008484 260.999634,684.983765 
	C264.280975,685.332764 264.120575,682.787476 264.383179,680.482422 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M273.222900,681.216675 
	C273.127197,680.112122 273.252380,679.200745 273.478302,678.059387 
	C274.938629,676.922668 275.911560,677.659851 276.929260,678.954712 
	C276.953613,684.586792 272.982147,687.995361 270.819397,692.267151 
	C270.536194,692.826538 269.866547,693.544861 269.408844,693.018127 
	C268.982849,692.527893 269.162170,691.511719 269.066162,690.386108 
	C269.057343,690.045105 269.239532,689.726501 269.094116,689.838440 
	C268.210297,690.325012 267.471863,690.699585 266.319183,690.997070 
	C266.919434,688.517456 267.933960,686.114990 268.981384,683.355957 
	C269.014282,682.999451 268.997589,682.999817 268.999817,683.007935 
	C269.537415,682.521057 269.495789,681.817017 269.986267,681.099243 
	C270.775940,681.040100 271.243500,681.070740 272.058655,681.153931 
	C273.076965,681.251160 272.234436,683.301331 273.967834,682.041016 
	C274.312836,681.740601 274.442871,681.621704 274.291077,681.535034 
	C273.820740,681.514832 273.632263,681.462341 273.222900,681.216675 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M283.646698,682.176514 
	C284.261505,684.643982 283.385559,686.844421 281.325623,688.869263 
	C280.585419,686.346619 282.615509,684.559998 283.646698,682.176514 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M276.268311,690.821411 
	C275.979797,688.779785 276.003052,686.569031 278.688782,684.898438 
	C278.861237,687.564697 277.421875,688.999207 276.268311,690.821411 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M278.955872,679.772400 
	C279.994293,677.932922 280.537506,678.663513 280.983154,680.227783 
	C280.964142,681.390442 280.535370,682.297485 279.808807,682.241760 
	C278.467133,682.139160 279.321381,680.781006 278.955872,679.772400 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M276.003296,691.013916 
	C275.898743,692.052734 275.641907,692.961670 274.345551,692.873169 
	C274.097839,692.856201 273.649536,692.554565 273.664429,692.427856 
	C273.775848,691.478516 274.524048,691.196350 275.646606,691.004456 
	C275.963562,690.993713 276.002380,690.994751 276.003296,691.013916 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M257.123169,685.275513 
	C256.998779,685.018005 256.962219,684.560547 256.958618,684.331055 
	C257.523865,683.386169 258.199707,683.405945 259.162170,684.112915 
	C259.406586,684.662964 259.420898,684.914062 259.274292,685.506348 
	C259.113342,685.847473 258.932587,686.075378 258.840729,686.192566 
	C258.248444,686.050842 257.748016,685.791870 257.123169,685.275513 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M279.770203,690.174805 
	C279.838074,690.579407 279.665924,691.190430 279.225159,691.993774 
	C279.147766,691.584473 279.338959,690.982849 279.770203,690.174805 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M266.061646,691.073975 
	C265.943970,691.219971 265.726471,691.944824 265.769623,691.005005 
	C265.904938,690.919922 266.012054,691.020020 266.061646,691.073975 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M272.435364,694.406250 
	C272.517853,694.343628 272.549408,694.579041 272.549408,694.579041 
	C272.549408,694.579041 272.352844,694.468933 272.435364,694.406250 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M280.721558,689.042725 
	C280.829437,689.310730 280.674469,689.626648 280.245972,689.979370 
	C280.134521,689.707642 280.296600,689.399109 280.721558,689.042725 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M345.226807,363.793671 
	C341.660736,362.889282 340.716492,360.206085 343.393585,359.753387 
	C344.729889,359.527466 346.275085,360.517212 347.484406,359.023468 
	C346.371155,356.914825 343.490540,359.113556 342.465149,356.940216 
	C343.858826,354.751801 345.858734,357.220764 347.486755,356.199036 
	C346.532043,353.787811 343.594879,356.105530 342.600433,354.078308 
	C347.777588,351.762268 347.866150,351.846893 350.334625,361.532715 
	C348.501312,362.562805 346.967163,360.660858 345.173737,360.989594 
	C343.791016,361.243073 343.310699,361.524506 344.732422,362.825684 
	C345.159760,363.163239 345.331207,363.348663 345.226807,363.793671 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M352.681641,364.011627 
	C352.974274,365.243652 352.849243,366.491058 352.489685,368.037109 
	C349.759064,368.379486 350.407959,365.076569 348.228699,364.255219 
	C349.496796,363.909058 350.880371,363.968048 352.681641,364.011627 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M343.041931,367.205322 
	C343.945618,367.689117 344.541168,368.155914 345.136719,368.622711 
	C344.180847,368.698853 343.048828,369.133820 342.308746,368.770447 
	C341.070831,368.162720 342.043396,367.592957 343.041931,367.205322 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M345.319763,364.053589 
	C344.958649,363.874146 344.966278,363.695007 344.981140,363.246887 
	C345.879913,363.099457 346.771454,363.221100 347.888123,363.596405 
	C348.113251,363.850067 348.004211,363.987823 347.946411,364.055725 
	C347.155243,364.100403 346.421875,364.077148 345.319763,364.053589 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M339.578644,371.837158 
	C339.355377,371.696350 339.402649,371.399048 339.702637,370.933960 
	C339.928467,371.067078 339.893097,371.371948 339.578644,371.837158 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M339.661682,375.884247 
	C339.520508,375.829468 339.475464,375.663940 339.486450,375.247253 
	C339.797699,375.207794 339.869476,375.466919 339.661682,375.884247 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M519.145386,488.864807 
	C518.244263,489.503113 517.305725,489.762878 515.993530,490.048218 
	C515.645813,489.893677 515.671814,489.713623 515.549133,489.762390 
	C515.504639,489.647369 515.608765,489.303436 515.839172,488.435486 
	C515.965454,487.911469 516.063660,487.579681 516.079224,487.407593 
	C516.279175,487.192200 516.463501,487.148895 516.910034,486.996765 
	C517.172363,486.887909 517.404968,487.238007 517.313965,487.048584 
	C517.222961,486.859131 517.290710,486.717194 517.369385,486.718079 
	C517.711182,486.770325 517.974365,486.821716 518.637512,486.919342 
	C519.061035,487.472473 519.084534,487.979401 519.145386,488.864807 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M517.224731,486.893005 
	C517.222961,486.859131 517.336243,487.241058 517.336243,487.241058 
	C517.336243,487.241058 517.404724,487.061523 517.288574,486.974731 
	C517.172363,486.887909 517.226501,486.926849 517.224731,486.893005 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M513.002441,478.998138 
	C513.122375,479.135681 513.239868,479.275085 513.357361,479.414490 
	C513.272034,479.367950 513.186707,479.321411 513.049194,479.139587 
	C512.996948,479.004272 513.000000,479.000000 513.002441,478.998138 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M421.007050,683.640869 
	C418.615570,683.642090 419.066193,681.825195 419.135773,679.806030 
	C419.788116,680.683105 420.392731,681.981567 421.007050,683.640869 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M418.173401,676.605896 
	C417.156464,676.516357 417.004486,675.630249 417.000275,674.324585 
	C417.395996,674.742615 417.777802,675.509033 418.173401,676.605896 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M431.820068,951.192444 
	C432.869537,951.104187 433.572083,951.010803 434.628021,950.947876 
	C432.242706,955.763245 426.918427,957.051575 422.467407,960.060547 
	C421.961426,959.999573 421.795319,959.858459 421.541687,959.402344 
	C421.495270,958.873413 421.536285,958.659424 421.803833,958.209839 
	C422.030365,957.974304 422.000702,958.001953 421.986572,958.016479 
	C422.211853,957.799255 422.448669,957.564819 422.857483,957.149048 
	C423.032074,956.970215 423.000366,956.998535 422.983887,957.011963 
	C425.793488,955.065979 428.306610,952.650696 431.820068,951.192444 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M435.340393,951.024780 
	C435.009125,950.550781 435.038483,950.122437 435.063904,949.376038 
	C435.789703,949.034363 436.519470,949.010620 437.615662,948.982910 
	C438.069885,950.601196 437.041473,951.005981 435.340393,951.024780 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M438.348175,949.029236 
	C438.373901,947.827515 439.302673,947.327209 440.694641,946.929871 
	C441.038391,948.419739 440.112518,948.995361 438.348175,949.029236 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M431.282104,958.964233 
	C431.077179,958.362915 431.121979,957.670776 431.922241,957.529053 
	C432.091614,957.499084 432.328857,957.852417 432.534851,958.029114 
	C432.209351,958.327026 431.883850,958.624939 431.282104,958.964233 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M421.539124,958.586670 
	C421.934723,958.880920 421.967438,959.133240 422.063843,959.763123 
	C421.983887,960.440308 421.771515,960.678589 421.264374,960.941406 
	C420.865204,961.015198 420.692047,961.003235 420.258514,960.996704 
	C420.000854,960.602844 420.003510,960.203430 419.981873,959.505554 
	C420.261932,958.798889 420.668182,958.578125 421.539124,958.586670 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M429.298340,959.991455 
	C429.438812,959.645691 429.918762,959.326416 430.702301,959.006470 
	C431.005890,959.005676 431.000000,959.000000 430.998230,958.997437 
	C430.543549,959.335876 430.090698,959.676941 429.298340,959.991455 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M453.706451,953.004150 
	C453.553009,953.369812 453.093201,953.728882 452.321045,954.051270 
	C452.472504,953.675598 452.936279,953.336609 453.706451,953.004150 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M427.964355,960.957458 
	C428.005981,960.578918 428.193481,960.316956 428.726990,960.050903 
	C428.958862,959.964966 429.000824,960.002625 429.020386,960.024597 
	C428.990784,960.397278 428.816681,960.667480 428.291656,960.956543 
	C428.065643,961.055847 427.996063,960.992310 427.964355,960.957458 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M459.288910,516.459839 
	C457.969299,513.176636 458.365234,509.245544 455.083862,506.321106 
	C455.766418,504.929230 456.596130,503.874756 457.389404,502.169556 
	C457.840790,500.264923 458.781708,499.292206 459.608368,497.861053 
	C459.882141,497.384338 459.993011,497.194031 460.270630,496.715637 
	C460.548828,496.233032 460.660339,496.038452 460.949158,495.551544 
	C461.260834,495.070068 461.395172,494.880920 461.770874,494.434692 
	C462.566895,493.701752 463.197998,493.367340 464.260925,493.093018 
	C465.931702,492.945557 467.068756,493.343353 468.264862,494.514465 
	C469.219757,497.558502 470.979034,499.690765 472.890656,502.125336 
	C473.267120,503.546783 473.280945,504.681152 473.607910,506.101807 
	C473.878906,507.068329 473.990601,507.723450 473.898529,508.725464 
	C474.649567,511.991882 475.163910,515.066345 472.785156,517.398743 
	C471.222992,518.930420 469.020966,519.659851 466.880676,517.514404 
	C466.327026,517.622375 466.053680,517.589539 465.749268,517.144836 
	C464.521271,514.676697 464.213745,517.132202 463.419434,517.216431 
	C462.639343,517.299072 462.353607,519.658569 461.105194,517.432739 
	C461.503021,516.483704 461.229340,516.068237 460.363098,515.915283 
	C459.928467,516.154480 459.752014,516.255310 459.288910,516.459839 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M474.221924,509.072968 
	C473.491547,508.602753 473.139465,508.152069 472.740417,507.408356 
	C475.042603,503.681122 478.194885,504.994843 481.049408,505.952087 
	C483.684540,506.835724 485.957977,508.537445 488.204559,510.784424 
	C488.192841,511.675415 487.993591,512.229858 487.547607,512.947144 
	C482.056824,514.965393 478.997070,509.915314 474.221924,509.072968 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M460.326172,516.180481 
	C460.729126,515.199036 461.218506,513.543579 462.466187,514.344788 
	C463.421722,514.958374 461.982697,515.946350 461.394348,516.963074 
	C460.934052,516.862610 460.740723,516.584961 460.326172,516.180481 
z"/>
<path fill="#DFAC93" opacity="1.000000" stroke="none" 
	d="
M466.384857,517.419922 
	C466.138031,518.013489 465.675751,518.371704 465.213501,518.729919 
	C465.204407,518.170166 465.195343,517.610413 465.452271,516.891846 
	C465.868652,516.883545 466.019043,517.034058 466.384857,517.419922 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M351.870239,553.397583 
	C351.887451,552.705750 351.938385,552.215271 351.990112,551.355103 
	C353.035736,551.696838 353.186127,552.580872 352.252289,553.810425 
	C352.003784,553.994629 351.903961,553.598877 351.870239,553.397583 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M449.364746,961.010498 
	C449.400452,958.455933 451.631104,958.360901 453.297760,957.493164 
	C453.111877,959.842773 451.909637,960.989197 449.364746,961.010498 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M446.901123,962.907959 
	C446.985657,961.939270 447.335022,961.204834 448.699158,961.045288 
	C449.023621,961.021973 448.999237,960.998840 448.987061,960.986816 
	C449.069061,961.952515 448.815460,962.714661 447.418518,963.032349 
	C447.097321,963.097717 446.967407,962.970276 446.901123,962.907959 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M454.233856,962.929321 
	C454.251007,962.199219 454.797760,961.251282 455.510498,961.892944 
	C456.083038,962.408386 455.250916,962.868896 454.233856,962.929321 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M451.933899,963.916016 
	C452.337341,963.539124 452.798706,963.231384 453.534210,962.853943 
	C453.808380,962.784241 453.963928,962.963562 454.041779,963.055542 
	C453.639923,963.442871 453.160217,963.738281 452.396240,964.076660 
	C452.112000,964.119690 451.991760,963.985229 451.933899,963.916016 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M293.679840,352.162109 
	C294.720581,342.117218 295.590942,332.386505 296.336212,322.646210 
	C296.642853,318.638855 297.683960,316.585724 301.658173,319.911896 
	C302.143616,320.318176 302.777405,320.547211 303.661743,321.036011 
	C305.816467,322.658813 303.951630,324.900024 305.261261,326.789368 
	C306.133850,330.121918 306.003693,333.207886 306.255737,336.421600 
	C307.617218,336.804291 308.746155,336.896698 309.976044,337.745880 
	C310.250824,338.233398 310.276398,338.468872 310.123169,339.012054 
	C309.128540,339.965820 308.172119,339.974396 306.936035,339.908478 
	C309.996765,340.233917 312.778198,339.225372 315.571259,339.833527 
	C316.524261,340.041046 317.774933,340.198944 317.885437,341.316589 
	C318.040009,342.879730 316.553253,342.972198 315.485474,343.156403 
	C313.858002,343.437103 312.201874,343.481567 310.616455,342.834015 
	C310.468018,342.773346 310.338531,342.666199 310.200256,342.580627 
	C310.182892,342.671173 310.165527,342.761719 310.372620,342.911255 
	C312.471191,343.917328 314.099884,345.289581 316.178070,345.904877 
	C318.120728,346.480011 319.259369,347.580963 318.205261,349.900330 
	C317.567810,351.302979 320.641357,351.287964 319.595154,353.351837 
	C319.417114,353.794952 319.355865,353.972229 319.231567,354.058594 
	C318.869324,354.310120 318.778534,354.749969 319.046722,354.771362 
	C321.462524,354.964050 323.891754,354.944672 326.639160,355.282898 
	C328.326935,356.607330 332.382538,355.129059 330.543274,359.369324 
	C327.466766,360.002808 324.767853,359.329285 322.778778,359.188782 
	C324.278229,358.995148 326.413422,360.311096 329.017792,359.543396 
	C330.363159,359.714996 331.314819,359.626678 331.440277,358.379913 
	C331.597656,356.816223 332.448486,356.219635 334.222626,356.307678 
	C336.379059,357.360260 334.747894,359.183350 335.606140,360.729553 
	C335.691711,361.035828 335.826935,360.963409 335.902405,360.976807 
	C335.890717,362.697021 335.803589,364.403809 335.657227,366.533142 
	C335.259460,367.449097 335.329712,367.957031 335.637299,368.722717 
	C335.723846,372.489197 335.717224,376.003021 335.357849,379.745239 
	C331.635590,380.403107 328.282043,380.344788 324.617554,379.535339 
	C323.869293,379.180328 323.724487,378.461334 323.471863,378.413452 
	C322.785553,378.283325 323.611176,379.130463 322.779663,379.463867 
	C321.738708,379.951202 320.974640,380.012634 319.791016,379.907196 
	C314.074219,379.493469 308.803955,378.717834 303.072754,378.212036 
	C298.942444,376.785797 299.756134,373.554688 299.571167,370.333801 
	C298.974274,365.983765 301.310699,362.089569 299.769958,357.736694 
	C299.802155,357.079712 299.836639,356.816345 299.988129,356.170349 
	C300.232727,355.553802 300.360321,355.319885 300.770477,354.804474 
	C302.446991,353.653290 304.017303,353.701355 305.928619,353.649231 
	C307.699005,353.691742 309.111725,353.724884 310.459473,354.239960 
	C310.485840,354.250031 311.073181,354.986633 310.839478,354.118988 
	C310.772217,353.869293 310.426422,353.669128 310.112885,353.107483 
	C309.642212,352.017578 309.217834,351.312042 308.031128,350.915405 
	C306.051727,350.097168 304.319366,350.483734 302.256866,350.526184 
	C301.212433,350.313354 300.593262,349.979980 299.820007,349.229187 
	C299.442413,348.482086 299.387665,348.012024 299.600891,347.208130 
	C300.273560,346.419647 300.903595,346.347229 301.568268,346.405853 
	C299.157928,341.551666 300.782837,336.437195 300.521851,331.444366 
	C300.622742,330.772766 299.745178,331.506714 300.394287,331.354797 
	C300.588165,332.785309 300.566528,334.200165 300.007935,335.887573 
	C299.873779,337.058136 298.656799,336.933044 298.860199,337.819061 
	C299.224640,338.038727 299.307709,338.217316 299.130249,339.290741 
	C297.793976,345.544495 298.675293,351.142242 296.748535,356.717590 
	C295.986389,358.191040 295.729492,359.448639 295.645935,361.099060 
	C295.471008,361.640198 295.362244,361.845764 294.954529,362.244049 
	C294.415527,362.463501 294.175476,362.490234 293.583618,362.410614 
	C292.072998,361.494385 291.906372,360.241821 291.730377,358.602966 
	C291.714325,357.966400 291.718414,357.711334 291.755585,357.074432 
	C292.054291,355.170624 292.449860,353.700104 293.679840,352.162109 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M332.696533,382.372803 
	C338.366211,382.696960 335.145630,386.805450 335.908203,389.472046 
	C334.176666,391.375977 332.487488,389.622925 331.042542,389.907257 
	C332.345856,390.002991 333.803314,390.659027 335.613464,390.845154 
	C335.879486,392.451721 335.901520,393.796112 335.909363,395.543823 
	C335.678986,396.343384 335.464050,396.740265 334.964478,397.322235 
	C334.235016,397.618988 333.786926,397.642975 333.013611,397.475281 
	C331.289124,396.299225 329.753418,396.914490 327.915955,397.034302 
	C322.697937,395.740967 317.749268,395.033783 312.365112,395.128754 
	C311.414185,394.784119 312.220673,395.030792 311.585571,394.828735 
	C310.093201,394.353973 308.220886,392.810455 307.127625,394.349915 
	C305.985596,395.958099 308.594604,396.903320 309.272980,398.673706 
	C309.585876,399.413086 309.640747,399.863098 309.473083,400.642120 
	C309.034760,401.287537 308.662354,401.523346 307.895264,401.685974 
	C306.710358,401.705658 305.850067,401.599609 304.669342,401.851074 
	C298.469238,402.102783 301.148071,398.084747 300.924194,395.192108 
	C300.655884,394.800781 300.596313,394.609497 300.526184,394.111816 
	C300.179840,391.606812 301.176056,389.071289 298.706146,387.071442 
	C298.402435,386.312103 298.399628,385.845306 298.669434,385.055573 
	C299.631866,384.060486 300.596558,383.886932 301.933777,383.727081 
	C302.523865,383.689056 302.757294,383.681519 303.334839,383.674561 
	C304.554962,383.690613 305.428528,383.787018 306.611084,383.721954 
	C307.312805,383.630035 307.703491,383.543030 308.356232,383.297089 
	C309.156982,382.883698 309.695435,382.611237 310.524231,382.227478 
	C311.399445,381.885376 312.004883,381.714081 312.930725,381.486450 
	C313.466370,381.413910 313.683960,381.405121 314.227600,381.423950 
	C316.076233,381.773895 317.578186,381.659851 319.391052,381.177795 
	C320.153870,381.074982 320.591675,381.069550 321.351044,381.143219 
	C322.298187,381.298523 322.914093,381.470764 323.870239,381.479156 
	C326.969238,381.292969 329.823242,380.340576 332.696533,382.372803 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M308.958557,400.856171 
	C308.905090,400.264191 308.888184,400.010956 308.918182,399.565430 
	C309.835083,397.585480 311.558105,397.771759 313.522522,397.623260 
	C317.927368,397.004089 321.141449,400.546112 325.498596,399.668518 
	C326.252563,399.372833 326.706879,399.309509 327.507751,399.400238 
	C329.109619,399.692688 330.367798,402.439453 331.760620,399.165649 
	C332.068176,398.710052 332.259094,398.576691 332.791565,398.350037 
	C334.560577,398.219177 335.401611,398.858368 335.594727,400.681885 
	C334.660675,403.310394 339.009338,407.773010 332.426422,407.998474 
	C327.155487,410.640076 322.041382,409.317230 317.033966,408.914398 
	C315.237915,408.769928 313.472656,408.363159 311.235138,408.692841 
	C310.536133,408.704498 310.259033,408.668854 309.606567,408.457703 
	C308.827759,407.909943 308.583771,407.455078 308.576355,406.541687 
	C309.219391,405.269196 310.193329,404.773682 311.118439,404.955444 
	C313.709778,405.464447 311.012543,402.266144 312.967560,402.457336 
	C312.534760,401.476349 311.758453,402.288849 311.154572,402.135437 
	C310.359772,401.933502 309.595398,401.743408 308.958557,400.856171 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M331.788696,409.494690 
	C335.283173,409.129578 336.472076,410.456573 336.086304,413.704010 
	C335.836639,415.805786 336.026123,417.959747 336.005646,420.553925 
	C335.103149,421.804291 334.219910,421.541046 333.077698,420.760406 
	C332.274017,419.923462 332.303040,418.906006 331.491760,418.565125 
	C331.270355,418.472046 331.080505,418.991302 331.224243,419.676331 
	C330.386169,421.135254 329.014221,421.426483 327.592163,422.264130 
	C327.038666,422.427490 326.806793,422.461792 326.224731,422.435089 
	C325.440277,422.161713 325.052979,421.882782 324.477173,421.262878 
	C323.611328,419.895874 323.191711,418.762695 323.554382,417.135193 
	C324.329681,416.026825 325.348480,415.759033 326.298157,414.808533 
	C328.615143,414.488007 330.633789,414.393372 332.622620,414.662170 
	C330.719177,414.305176 328.753601,414.526825 326.491699,414.718567 
	C322.768524,416.510864 319.140228,415.210999 315.330505,415.527100 
	C314.700714,415.015350 314.489136,414.613525 314.419525,413.815308 
	C315.338379,412.083893 314.148193,410.606567 314.789307,408.922455 
	C320.515259,408.465088 326.007965,409.322723 331.788696,409.494690 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M339.281433,389.369812 
	C339.670776,388.921844 340.006775,388.939026 340.593597,388.944427 
	C341.196869,389.736450 340.178040,391.434540 342.284943,391.098114 
	C343.201843,390.951691 343.893921,388.096344 345.030518,390.805725 
	C345.485748,391.890961 346.973572,393.703400 343.910400,393.358826 
	C345.840729,396.657532 341.465729,396.782379 341.137817,399.326050 
	C340.898407,400.598694 340.277344,400.969147 339.095215,400.885986 
	C338.942169,397.154388 339.085144,393.494690 339.281433,389.369812 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M322.291412,381.964966 
	C321.563965,381.871307 321.156281,381.831177 320.448669,381.858521 
	C319.700806,381.618103 319.411194,381.200317 319.269775,380.280396 
	C319.342560,379.638397 319.424408,379.389374 319.785065,378.863037 
	C320.668579,378.552765 321.273285,378.519745 322.157593,378.616333 
	C322.747711,378.643219 323.058289,378.540497 323.802612,378.667297 
	C327.652588,378.559113 331.055725,378.452026 334.699951,379.723602 
	C334.368683,380.651672 333.732208,381.329773 333.032776,382.280334 
	C330.279663,382.522430 327.589569,382.492004 324.634460,382.647797 
	C323.754181,382.625061 323.239136,382.200043 322.291412,381.964966 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M332.032318,409.444794 
	C326.597198,411.209808 321.272217,409.281708 315.503540,409.217651 
	C314.323578,409.780823 313.530975,410.292816 312.212738,410.454010 
	C310.812836,410.325439 310.111481,409.772675 309.952698,408.395599 
	C315.563782,406.329254 321.103821,408.520264 326.618347,407.857941 
	C328.074493,407.683075 329.584839,407.958984 331.538818,408.042419 
	C332.012177,408.427338 332.016968,408.797729 332.032318,409.444794 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M333.445190,427.576965 
	C331.183838,428.275879 329.224884,428.611603 327.207520,426.922058 
	C326.618591,426.439850 326.485809,426.004730 326.629852,425.200592 
	C327.588684,424.002167 328.763000,423.857422 330.108887,423.290222 
	C331.394928,422.621521 332.354279,422.045563 333.735474,421.587982 
	C334.517975,421.511688 334.968506,421.527466 335.672119,421.790039 
	C335.970337,423.064087 336.014709,424.113495 336.055359,425.557434 
	C335.570984,426.907684 334.534912,426.952850 333.445190,427.576965 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M335.964478,421.766846 
	C335.455414,422.029053 334.984863,422.043427 334.161499,422.083923 
	C331.837738,422.712402 329.888458,423.674591 327.533813,422.118408 
	C327.846069,420.403381 329.059662,420.197540 330.641418,420.033203 
	C331.351776,419.588898 331.822174,419.454834 332.670471,419.795837 
	C333.770569,420.342285 334.562042,420.656952 335.673035,420.994568 
	C335.996002,421.184723 335.999481,421.351898 335.964478,421.766846 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M333.492920,427.821899 
	C333.026947,426.132538 334.144653,425.987091 335.704437,425.953674 
	C336.271637,426.179138 336.467957,426.425262 336.783752,426.878540 
	C336.683167,430.429413 334.839630,427.529449 333.492920,427.821899 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M335.876465,390.802307 
	C334.100189,390.670288 331.889557,391.819366 330.567322,389.596283 
	C332.255554,388.301971 333.578766,390.553040 335.494690,389.937256 
	C335.868103,390.090698 335.881775,390.294006 335.876465,390.802307 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M335.755859,400.618469 
	C334.936890,400.422363 334.785614,399.174042 333.259521,399.053375 
	C332.486206,397.664520 333.484955,397.640778 334.609619,397.334869 
	C335.106384,396.909119 335.309509,396.617126 335.703888,396.136139 
	C335.878448,397.365173 335.861755,398.783203 335.755859,400.618469 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M335.781311,368.637024 
	C335.227081,368.420349 333.720520,368.166534 335.372498,366.993896 
	C335.676056,367.403351 335.754120,367.851013 335.781311,368.637024 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M339.417419,384.183289 
	C339.604279,384.079987 339.748749,384.287384 339.830200,384.517181 
	C339.863434,384.610962 339.760101,384.753143 339.587830,385.010620 
	C339.421051,384.932983 339.385345,384.718018 339.417419,384.183289 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M82.761024,770.355713 
	C82.837723,770.020813 83.025314,770.040100 83.491325,770.104858 
	C91.157257,777.730469 99.435699,784.209778 108.628723,790.037598 
	C108.977371,790.085327 109.005898,790.047363 108.985466,790.038513 
	C109.408936,790.458374 110.007980,790.499695 110.776314,790.857910 
	C110.996071,791.048767 110.999344,790.996277 110.976135,791.008606 
	C111.826447,791.952393 113.144882,792.426453 113.842911,793.976196 
	C115.375244,796.070496 116.760094,797.878723 119.659622,798.088013 
	C120.801933,799.700745 122.244698,800.562195 123.651184,801.939453 
	C122.702179,803.051270 120.978729,802.814087 121.339104,804.987793 
	C121.477196,805.486267 121.532631,805.685486 121.741035,806.485718 
	C121.173454,807.946777 123.804474,811.417847 119.521210,809.636108 
	C119.015541,809.421936 118.815315,809.312073 118.422577,808.918457 
	C118.046104,808.215393 117.887772,807.786682 117.651291,807.022705 
	C115.518761,801.822876 112.571205,797.889343 107.469765,795.742798 
	C104.881958,794.654053 102.537834,792.963501 100.197159,791.377808 
	C98.982956,790.555237 96.821487,789.884338 98.851990,787.600464 
	C99.620689,787.750000 99.991333,788.062012 100.415894,788.276001 
	C100.663223,788.400635 100.856705,788.439270 100.863579,788.430420 
	C101.184578,788.017029 101.240196,787.931396 101.033455,788.175598 
	C100.830399,788.415527 100.564232,788.414856 99.965988,787.983643 
	C96.415031,786.105225 92.944984,784.727478 90.080467,781.761414 
	C89.426704,781.048889 89.035995,780.544922 88.360580,779.502197 
	C87.709602,775.346497 83.052063,774.442993 82.761024,770.355713 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M113.988098,793.894043 
	C112.993256,793.401672 111.996796,792.540161 110.976639,791.349731 
	C112.616905,791.064758 113.690483,791.823792 113.988098,793.894043 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M110.862427,790.759521 
	C110.405342,790.903809 109.814606,790.758789 109.094452,790.321777 
	C109.552948,790.176575 110.140862,790.323425 110.862427,790.759521 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M130.566162,795.468994 
	C130.606110,795.535034 130.526199,795.402893 130.566162,795.468994 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M126.007309,792.994385 
	C126.133064,793.141846 126.250099,793.296509 126.367126,793.451233 
	C126.269440,793.405762 126.171761,793.360352 126.028740,793.167603 
	C125.983391,793.020264 125.998589,793.001709 126.007309,792.994385 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M195.005646,665.995361 
	C195.146545,666.153015 195.282181,666.315002 195.417816,666.476990 
	C195.314865,666.426453 195.211945,666.375916 195.051056,666.167175 
	C194.993103,666.008972 195.000397,665.999695 195.005646,665.995361 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M462.201447,494.734009 
	C462.180756,495.075287 462.053192,495.535797 461.966675,495.758514 
	C461.710571,496.245819 461.511566,496.485992 461.212097,496.924927 
	C461.141113,497.148071 461.020966,496.994141 461.085052,497.069641 
	C460.997314,497.248871 460.845520,497.352600 460.432892,497.419830 
	C459.800842,497.546417 459.931030,496.310669 459.214813,497.334808 
	C458.557495,498.291870 457.308350,498.398865 457.310242,499.922729 
	C456.866882,500.793976 456.326996,501.108215 455.385986,501.190857 
	C454.213074,500.967896 453.330017,500.867767 453.338501,499.375427 
	C453.388702,499.058136 453.574860,499.036163 453.668091,499.026611 
	C454.069061,498.835236 454.354309,498.623108 454.805481,498.190948 
	C456.082855,492.743652 462.265625,487.239197 466.795166,488.077759 
	C467.283783,488.225677 467.538544,488.473694 467.771851,488.233215 
	C476.232086,487.996399 484.411469,484.127594 492.696747,487.729004 
	C493.759674,488.190979 495.195618,488.252625 495.943176,487.241730 
	C498.935577,483.195129 501.359100,485.397552 503.432373,487.997681 
	C506.665833,492.052734 510.717499,489.395355 514.900757,489.573364 
	C515.221741,489.648163 515.048401,489.833771 515.255127,490.045746 
	C513.777832,491.846069 510.755981,490.027863 508.984863,492.886169 
	C508.882080,493.746948 508.826294,493.934387 508.351471,494.511841 
	C507.464966,495.406494 506.997467,495.911133 506.598389,496.777588 
	C504.899628,499.252075 503.132416,501.364777 501.182007,503.762238 
	C500.998840,504.046997 500.658875,504.323120 500.453064,504.248322 
	C500.252106,503.358307 499.906372,502.169952 500.315765,501.785370 
	C504.657684,497.706146 499.789642,494.280396 499.551270,490.558655 
	C499.494141,489.665771 498.014191,488.697662 497.383118,489.940338 
	C495.522522,493.604034 493.286255,491.462677 491.169647,490.579102 
	C488.373962,489.412170 485.432922,489.585876 482.526459,489.395935 
	C481.048767,489.299347 481.114197,490.432831 480.988953,491.760498 
	C479.321991,493.756866 477.180847,493.248352 474.775513,493.443756 
	C472.213470,493.568573 470.073303,493.483826 467.570618,493.258423 
	C465.447357,493.180359 463.445160,492.189117 462.201447,494.734009 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M472.278992,503.248779 
	C470.945038,500.554138 467.336456,499.593933 467.954407,495.775085 
	C469.176117,493.241089 471.106750,494.212952 472.747955,494.469788 
	C479.476196,495.522705 485.546967,498.294128 491.655884,502.037903 
	C493.440613,503.191193 494.626251,504.302124 494.219543,506.582794 
	C493.906250,507.546051 493.822357,508.163940 493.439972,508.902954 
	C492.426575,509.014252 491.711639,509.004425 490.639343,509.012848 
	C484.263245,507.529968 478.442566,505.395935 472.278992,503.248779 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M492.200165,502.851868 
	C490.717834,503.483582 489.517303,503.236298 488.610352,502.496490 
	C482.814911,497.769318 475.801178,496.482117 468.342957,495.351257 
	C466.850250,495.023376 465.754486,494.638702 464.325989,494.130585 
	C463.529480,492.576172 464.648193,492.640656 465.769073,492.255554 
	C468.496582,492.073395 470.934875,492.069641 473.831055,492.115051 
	C480.115509,493.279083 486.053375,493.913696 491.671417,495.940186 
	C493.526154,496.609161 495.378235,497.437744 496.808350,499.447449 
	C496.748871,500.685516 496.124237,501.540802 496.887146,502.743011 
	C495.475433,504.335205 494.007050,503.314301 492.200165,502.851868 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M497.242157,499.651672 
	C489.972168,496.136627 482.422333,494.225739 474.520905,492.426147 
	C476.237518,492.164032 478.186127,492.163849 480.556854,492.140930 
	C485.455841,493.628632 490.386810,493.381195 494.667358,495.641571 
	C496.224915,496.464050 498.320679,496.920013 497.242157,499.651672 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M500.238037,504.165100 
	C500.247284,504.173523 500.626282,504.126251 500.812561,504.086609 
	C502.473114,505.386627 501.821259,507.509613 502.802979,509.355347 
	C500.738373,510.100647 498.701965,510.510956 496.260010,510.915070 
	C496.128693,508.464020 498.122437,507.214417 499.659637,505.268188 
	C499.747467,504.773773 499.735626,504.589355 499.969086,504.275940 
	C500.214417,504.146912 500.228821,504.156647 500.238037,504.165100 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M492.005493,503.088898 
	C493.446686,500.484772 494.779388,503.368591 496.624512,502.992493 
	C497.431976,505.004730 496.777496,506.364227 494.358246,506.922546 
	C494.132965,505.354553 492.748260,504.584076 492.005493,503.088898 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M500.031982,504.155670 
	C500.214417,504.146912 500.084686,504.607422 499.922028,504.782837 
	C499.684143,504.749146 499.594635,504.543060 499.549347,504.327728 
	C499.542603,504.295746 499.744293,504.219971 500.031982,504.155670 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M478.654053,621.748840 
	C478.723480,621.904968 478.344910,621.962708 478.156189,621.994995 
	C477.978333,621.605652 478.102631,621.345154 478.654053,621.748840 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M390.237396,402.136536 
	C390.038971,398.123322 391.895538,394.891571 393.846741,391.321014 
	C394.010986,390.838806 394.107788,390.702423 394.217987,390.577850 
	C401.790405,382.014587 406.425903,382.817261 411.015686,393.514130 
	C411.979340,395.760040 412.833099,398.053101 413.893646,400.659912 
	C414.214447,403.965485 413.134338,406.428467 411.021210,408.480225 
	C408.640991,410.791412 407.419922,413.206604 409.135620,416.651367 
	C410.053070,418.493408 410.160187,420.786804 409.591553,423.343964 
	C407.508240,428.025146 404.424774,425.712250 401.247833,424.860718 
	C398.014893,422.584106 396.315948,420.026764 396.851257,416.231201 
	C397.413544,412.244080 398.834717,409.237427 403.737549,408.832214 
	C404.844971,408.328583 405.238739,407.575684 405.717712,406.908875 
	C405.007233,407.178192 405.161560,408.217163 404.123871,408.646240 
	C402.689392,409.078430 401.559814,409.310791 400.446564,409.590515 
	C398.297363,410.130646 396.424713,409.873901 395.450104,407.685272 
	C394.488892,405.526581 395.340393,403.865814 397.691223,402.583069 
	C399.984344,401.635925 402.161041,401.685547 404.112396,400.695404 
	C402.980255,400.575623 401.852448,401.124054 400.446777,400.516663 
	C398.993378,398.349548 400.734467,397.396790 401.695068,396.199707 
	C402.706512,394.939148 404.097961,393.847687 402.879883,391.603851 
	C398.181580,394.563904 395.973389,400.350525 390.237396,402.136536 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M92.653915,1019.846069 
	C92.734261,1020.175171 92.399345,1020.476624 91.723541,1020.838745 
	C91.274788,1020.227783 91.557823,1019.865601 92.653915,1019.846069 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M405.980865,523.980164 
	C406.241882,523.113953 405.602478,521.854797 407.008362,521.530212 
	C407.204254,521.484985 407.636658,521.794800 407.714417,522.023621 
	C408.038544,522.977356 407.622559,523.594543 406.354004,523.952881 
	C406.030670,524.026794 405.996948,523.996277 405.980865,523.980164 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M403.921448,513.256470 
	C404.010712,513.014648 404.504852,513.015930 404.751831,513.009155 
	C404.879700,513.695007 404.994354,514.546875 403.943207,514.580872 
	C403.917908,514.581726 403.869720,513.875061 403.921448,513.256470 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M534.474854,1012.457031 
	C534.524719,1012.428162 534.425049,1012.485962 534.474854,1012.457031 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M534.823669,1007.052856 
	C534.904297,1007.173340 534.780090,1008.016541 534.823669,1007.052856 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M536.025146,1006.030273 
	C535.989624,1006.404846 535.811523,1006.674500 535.283997,1006.955505 
	C535.052979,1007.044983 534.999756,1006.997314 534.974731,1006.969604 
	C535.007202,1006.592529 535.186157,1006.324158 535.716797,1006.046021 
	C535.947205,1005.955200 536.000854,1006.003540 536.025146,1006.030273 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M426.131958,480.025940 
	C426.401764,478.548889 426.959229,477.537964 428.068115,479.327301 
	C429.120453,481.025452 429.761688,482.698242 426.382050,482.993866 
	C426.134155,482.543121 426.251373,482.082275 426.198792,481.306854 
	C426.028961,480.992249 425.983246,481.001495 425.989685,481.024261 
	C426.362122,480.863739 426.460114,480.585968 426.131958,480.025940 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M450.827271,500.034851 
	C451.219330,499.848114 451.397308,499.819794 451.804321,499.645966 
	C451.890961,500.275635 451.513550,500.845093 450.330994,501.024475 
	C450.182007,500.744415 450.397552,500.468811 450.827271,500.034851 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M430.983765,497.984131 
	C431.104431,497.544342 431.236542,497.115814 431.368652,496.687286 
	C432.076385,497.006622 431.685242,497.386749 431.223999,497.886841 
	C431.020050,498.014191 430.995270,497.995392 430.983765,497.984131 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M448.731018,502.013550 
	C448.863678,502.295807 448.704742,502.615173 448.260986,502.980408 
	C448.130554,502.701080 448.284973,502.375854 448.731018,502.013550 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M440.295349,502.320465 
	C440.162079,502.666046 439.827057,502.793884 439.492065,502.921753 
	C439.440338,502.652802 439.388611,502.383881 439.503754,501.900513 
	C439.811615,501.824982 439.952606,501.963837 440.295349,502.320465 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M449.748657,501.028473 
	C449.874725,501.309753 449.725067,501.647797 449.275635,502.004211 
	C449.141541,501.710175 449.307251,501.397705 449.748657,501.028473 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M300.795715,535.200623 
	C301.884338,534.975403 302.670959,534.995483 303.845062,534.954102 
	C307.127380,535.876404 307.001740,538.760559 307.747589,540.917603 
	C309.518036,546.038025 310.902191,551.291931 312.490662,556.923950 
	C311.341217,557.657227 310.142700,557.895691 308.607910,557.219116 
	C304.260620,550.831970 301.555603,544.087646 300.039001,536.511353 
	C300.250885,535.904419 300.372284,535.675171 300.795715,535.200623 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M316.667419,590.265869 
	C313.851868,587.908020 313.940002,583.965576 312.586304,580.668579 
	C311.500397,578.023804 310.161316,576.614014 307.214722,576.020508 
	C306.828491,576.031738 306.915710,575.992126 306.938538,576.034180 
	C306.602905,575.581726 306.526276,574.980408 306.124207,574.213501 
	C305.913605,574.004517 305.985352,574.011108 305.976044,574.045898 
	C305.484131,573.235779 304.959686,572.411743 304.716858,571.118530 
	C307.263367,569.041077 308.777283,566.552734 310.455902,563.840698 
	C313.556458,565.537659 313.332062,568.738525 314.620911,571.608093 
	C315.775635,577.874756 316.540375,583.870483 316.667419,590.265869 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M314.848206,571.484741 
	C311.737701,570.485718 312.447906,567.084473 311.042236,564.394287 
	C308.370728,562.652771 307.554535,560.537048 308.663391,557.418213 
	C309.918579,556.522339 310.914673,556.310547 312.233948,557.197388 
	C313.942719,561.821472 314.524170,566.426270 314.848206,571.484741 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M400.850586,423.743042 
	C403.725281,423.881165 406.268433,426.049347 409.213928,423.959167 
	C415.921387,424.318054 413.059967,427.945892 411.772461,431.334229 
	C408.479431,432.811829 404.964264,431.558990 401.446136,433.012482 
	C400.868134,432.739227 400.669922,432.470032 400.239410,432.096924 
	C399.908936,431.667328 399.723297,431.403198 399.226685,431.098999 
	C399.763458,429.175720 397.064484,428.158112 398.007965,426.012939 
	C398.322876,425.101624 398.315186,424.413483 399.013153,423.692566 
	C399.725250,423.399506 400.157227,423.410553 400.850586,423.743042 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M427.776184,749.161804 
	C427.870758,749.580017 427.700348,750.158508 427.264893,750.904480 
	C427.170319,750.488708 427.340790,749.905396 427.776184,749.161804 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M419.585907,763.441345 
	C419.643463,763.530640 419.417542,763.571167 419.417542,763.571167 
	C419.417542,763.571167 419.528351,763.352051 419.585907,763.441345 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M425.998535,755.998108 
	C425.907440,756.032776 425.817841,756.069336 425.866028,756.054321 
	C426.003845,756.002808 426.000000,756.000000 425.998535,755.998108 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M420.434937,761.555786 
	C420.397064,761.492004 420.472839,761.619507 420.434937,761.555786 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M509.204102,370.994934 
	C509.099548,370.645325 509.270111,370.310394 509.643738,369.772949 
	C510.450104,370.235565 510.598236,370.784424 509.204102,370.994934 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M401.045044,423.583130 
	C400.564941,423.972198 400.014648,424.003296 399.051453,424.051849 
	C392.691376,420.329895 392.298920,413.633789 390.077637,407.918457 
	C389.847076,407.325134 389.950134,406.601532 389.521820,405.669189 
	C388.969116,404.408173 388.890167,403.450134 389.639893,402.252502 
	C394.004669,399.366882 396.752167,395.356812 400.162506,392.023743 
	C401.257416,390.953644 402.051605,387.942017 404.158783,390.031921 
	C405.603058,391.464386 405.837311,393.959747 403.969666,395.868805 
	C402.463074,397.408783 400.997742,398.989075 399.681885,400.980957 
	C399.994568,401.858795 399.888550,402.246979 399.284790,402.750000 
	C397.429047,403.862915 395.307648,404.389740 396.129517,407.046387 
	C396.974365,409.777344 399.158325,408.935211 400.967560,408.842804 
	C402.072205,408.786407 403.154663,408.296631 404.617615,407.998962 
	C403.417206,410.716003 398.826416,409.867615 398.415588,414.616180 
	C398.102386,418.236115 397.924377,420.974121 401.045044,423.583130 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M389.298889,405.766846 
	C391.903931,405.806305 391.167725,408.265747 391.698242,409.737183 
	C393.445465,414.583282 394.961212,419.493286 398.377869,423.873535 
	C398.595581,424.535400 398.552673,425.001495 398.305450,425.589020 
	C392.619904,420.341187 389.452881,413.927368 389.298889,405.766846 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M119.603836,953.468872 
	C119.664467,953.560547 119.427597,953.600647 119.427597,953.600647 
	C119.427597,953.600647 119.543213,953.377136 119.603836,953.468872 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M123.990746,802.011780 
	C125.594307,802.327637 127.174622,802.636353 127.978577,804.630554 
	C128.035324,804.960449 127.966888,805.044067 127.933105,805.086304 
	C125.634445,806.136414 124.139778,805.513611 123.636383,802.654114 
	C123.761116,802.252075 123.913994,802.091675 123.990746,802.011780 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M141.468140,801.535645 
	C141.434830,801.477478 141.501450,801.593811 141.468140,801.535645 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M432.123138,951.145386 
	C429.725250,953.688599 426.608002,955.177429 423.316864,956.976074 
	C424.089020,955.015747 425.890015,953.735229 427.965942,952.271851 
	C428.473297,951.455994 429.077179,951.543884 429.764099,951.188965 
	C429.970703,951.017334 429.997070,951.000061 430.009247,950.990051 
	C430.413300,950.641235 430.866699,950.500305 431.685852,950.773865 
	C431.990143,950.990234 432.079285,951.093262 432.123138,951.145386 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M429.599731,950.993286 
	C429.549042,951.333740 429.127380,951.650146 428.431183,951.982666 
	C427.952881,951.984192 427.749084,951.969666 427.240936,951.919250 
	C426.795105,951.724487 426.653656,951.565735 426.756989,951.202576 
	C427.001740,950.998108 427.000000,951.000000 426.999084,951.001038 
	C427.741699,950.991150 428.485229,950.980164 429.599731,950.993286 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M421.912048,958.460693 
	C421.471375,958.758728 421.040802,958.888855 420.283875,959.113037 
	C420.433655,958.817566 420.909790,958.428101 421.708130,958.006470 
	C422.030365,957.974304 421.922119,958.292786 421.912048,958.460693 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M413.996094,955.993164 
	C413.543549,956.327637 413.096863,956.670837 412.289124,956.977051 
	C412.421051,956.635742 412.914001,956.331299 413.712463,956.022217 
	C414.017914,956.017517 414.001984,956.001892 413.996094,955.993164 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M426.684509,951.017212 
	C427.001740,950.998108 426.982178,951.442566 426.959381,951.662964 
	C426.507050,951.948975 426.077545,952.014709 425.325714,952.134399 
	C425.458008,951.804382 425.912628,951.420349 426.684509,951.017212 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M422.780884,957.061768 
	C422.831696,957.243225 422.631317,957.516296 422.201721,957.910156 
	C422.158234,957.738525 422.343964,957.445984 422.780884,957.061768 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M416.994873,956.993835 
	C416.902008,957.028625 416.813995,957.069580 416.868774,957.059631 
	C417.011566,957.008789 416.999695,956.999939 416.994873,956.993835 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M412.032104,957.041138 
	C411.923065,957.135010 411.800323,957.922913 411.781921,957.014038 
	C411.928101,956.940186 411.999573,957.005371 412.032104,957.041138 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M300.001984,592.998657 
	C300.726776,593.305115 300.906128,593.911011 300.794128,594.602356 
	C300.767792,594.764893 300.427673,594.876648 300.231934,595.011780 
	C300.138214,594.537415 300.044495,594.063110 299.973358,593.296265 
	C299.995941,593.003723 300.000000,593.000000 300.001984,592.998657 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M305.015686,598.987854 
	C304.898987,598.934448 304.769592,598.891663 304.640198,598.848816 
	C304.724243,598.803894 304.808289,598.758972 304.937439,598.869141 
	C304.982544,599.024231 305.002960,598.998474 305.015686,598.987854 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M355.005707,348.182281 
	C355.267487,349.320282 354.647705,350.058838 353.636963,350.888672 
	C352.043640,350.503265 351.511292,349.364075 352.179108,348.108612 
	C352.773468,346.991272 353.806885,348.077515 355.005707,348.182281 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M469.886902,987.098694 
	C469.642456,986.991577 469.488464,986.797913 469.334442,986.604126 
	C469.534027,986.573975 469.733643,986.543823 470.042053,986.672546 
	C470.150818,986.831421 469.977356,987.012085 469.886902,987.098694 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M94.987076,741.732117 
	C94.141106,741.826294 94.022034,741.278381 94.597107,740.399658 
	C94.855789,740.669067 94.890327,741.057495 94.987076,741.732117 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M471.577759,630.069214 
	C472.249573,633.244507 472.640686,636.592407 473.046722,640.346313 
	C473.042969,641.172119 472.886444,641.532104 472.310181,641.948975 
	C470.500336,642.021179 468.969543,641.931824 468.985107,639.836426 
	C469.010101,636.464417 465.999634,632.346008 471.577759,630.069214 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M468.035767,639.011841 
	C467.857697,640.015503 468.318634,641.462952 467.173859,641.079407 
	C465.659912,640.572144 465.670776,638.861816 466.508148,637.821045 
	C467.345337,636.780396 467.753143,637.913086 468.035767,639.011841 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M471.912079,642.315674 
	C472.241028,641.762207 472.454224,641.458801 472.864563,640.953857 
	C473.328918,640.788147 473.596191,640.824036 474.251465,640.976379 
	C475.485168,642.123352 474.848022,642.890503 474.001160,643.779907 
	C473.338104,643.948975 472.858643,643.991028 471.656921,644.005981 
	C471.221893,643.507751 471.509125,643.036682 471.912079,642.315674 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M474.694702,628.832397 
	C474.761200,629.303589 474.513641,629.644653 473.907440,629.013916 
	C473.977173,628.811279 474.184631,628.777588 474.694702,628.832397 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M396.486267,448.124817 
	C396.768341,448.224030 396.872345,448.640076 396.929047,448.847168 
	C396.871063,449.858795 396.756378,450.663361 396.418457,451.670013 
	C396.322723,450.036499 394.312683,449.379730 394.019226,447.357239 
	C394.789856,447.277283 395.497009,447.651428 396.486267,448.124817 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M145.961624,564.418579 
	C147.482269,565.346069 147.147491,566.923096 146.259552,568.770630 
	C145.984116,567.615295 145.974609,566.225342 145.961624,564.418579 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M230.634537,890.338135 
	C231.223328,890.220886 231.742096,890.617188 231.924255,891.742798 
	C231.560806,891.602417 231.170609,891.113770 230.634537,890.338135 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M550.581482,305.908173 
	C550.298462,305.247772 550.344482,304.741760 550.637573,304.143005 
	C551.292480,304.457062 551.700439,304.863861 552.098511,305.562195 
	C551.695923,305.923340 551.303223,305.992950 550.581482,305.908173 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M458.830170,669.986023 
	C460.677368,675.956665 463.708130,681.575867 463.189178,688.216919 
	C462.796844,688.809204 462.664673,689.171509 462.014343,689.276367 
	C461.273987,688.860107 461.123108,688.649902 461.017944,688.193176 
	C463.333618,687.266174 462.003906,685.497620 461.744202,684.403259 
	C460.656464,679.819763 459.292389,675.301880 458.001160,670.369873 
	C458.163330,669.982605 458.353851,669.985413 458.830170,669.986023 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M463.446167,696.983643 
	C463.759064,697.627686 463.859741,697.995056 463.919312,698.646057 
	C459.497650,697.728516 460.566681,693.100891 458.245270,690.218567 
	C457.872070,689.604553 457.784698,689.197205 457.639465,688.483093 
	C457.365234,687.658630 457.242889,687.119629 457.261047,686.144836 
	C457.594788,685.673340 457.882080,685.616211 458.594666,685.667542 
	C459.271790,689.864014 461.486755,693.195251 463.446167,696.983643 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M453.009888,669.676392 
	C451.781219,668.860107 451.107361,667.402039 450.939941,665.356750 
	C452.801910,665.890198 453.037262,667.534912 453.009888,669.676392 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M461.609924,689.331726 
	C461.721100,688.889221 461.945953,688.759460 462.549927,688.538330 
	C462.827637,689.154114 462.726166,689.861267 462.318268,690.755188 
	C461.915741,690.509460 461.819641,690.076965 461.609924,689.331726 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M453.985504,671.732483 
	C454.008606,672.044861 453.546570,671.996094 453.318573,671.955078 
	C453.065582,671.482544 453.040588,671.051025 452.988190,670.295532 
	C453.294647,670.454407 453.628510,670.937256 453.985504,671.732483 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M456.775452,684.396118 
	C456.821442,683.995972 457.042938,683.985962 457.594849,684.012451 
	C457.980804,684.234497 458.036346,684.420166 458.277374,684.830017 
	C457.888977,685.359497 457.385040,685.270020 456.775452,684.396118 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M432.707397,482.006500 
	C432.992401,482.414032 432.976898,482.836151 432.925964,483.571289 
	C432.394012,483.661377 431.620819,483.556793 431.463501,483.188873 
	C431.204193,482.582520 431.802551,482.192719 432.707397,482.006500 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M434.074646,480.070007 
	C433.914581,480.648712 433.712982,481.186096 433.252441,481.867004 
	C432.998749,481.573578 433.003998,481.136688 433.029938,480.372620 
	C433.050598,480.045471 433.019684,480.024567 433.023193,480.033539 
	C433.162811,479.854950 433.298920,479.667358 433.694794,479.710846 
	C433.954529,479.941956 434.033081,480.028748 434.074646,480.070007 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M425.964600,480.140686 
	C426.487946,480.088379 427.016479,480.331482 426.282227,481.049866 
	C425.982513,480.845734 425.968903,480.644440 425.964600,480.140686 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M444.623657,965.991699 
	C443.943085,967.315674 442.543549,967.912903 440.369965,967.983704 
	C441.304840,965.953918 442.830994,966.113586 444.623657,965.991699 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M444.895935,965.875977 
	C445.307129,965.491943 445.799377,965.201233 446.583191,964.885132 
	C446.874695,964.859741 446.973602,964.973145 447.022583,965.031982 
	C446.616608,965.409424 446.161652,965.728027 445.424316,966.100098 
	C445.141907,966.153503 444.976990,965.969238 444.895935,965.875977 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M431.959778,950.687256 
	C431.552490,950.998291 431.114838,951.006287 430.349304,950.997192 
	C430.255402,950.460632 430.356934,949.686584 430.753693,949.480103 
	C431.389069,949.149597 431.792999,949.730591 431.959778,950.687256 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M435.027588,949.032471 
	C434.598938,948.909973 434.143372,948.772644 433.687805,948.635376 
	C434.048553,947.917847 434.426392,948.290222 434.931763,948.838013 
	C435.059937,949.058105 435.000641,949.017578 435.027588,949.032471 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M354.253418,1004.948914 
	C354.196869,1004.083496 354.192352,1002.905029 355.833740,1003.814636 
	C355.516327,1004.346069 355.034576,1004.645996 354.253418,1004.948914 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M452.402954,357.749939 
	C451.120422,357.338684 450.253326,356.941193 449.226074,356.302826 
	C450.136292,356.000641 451.206726,355.939331 452.677917,355.825531 
	C456.750366,355.508148 460.422058,355.243286 464.539551,355.004120 
	C464.992554,355.437195 464.999756,355.844543 464.983093,356.556519 
	C460.912231,357.162018 456.865295,357.462860 452.402954,357.749939 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M392.501740,444.461121 
	C392.556213,444.422180 392.447266,444.500092 392.501740,444.461121 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M393.910522,447.077454 
	C393.682678,446.960022 393.514526,446.786804 393.346375,446.613586 
	C393.534821,446.596252 393.723328,446.578918 393.997253,446.732361 
	C394.082672,446.903137 393.970184,447.021667 393.910522,447.077454 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M437.203613,263.236481 
	C438.354492,262.914032 439.387299,262.548645 440.435181,262.177948 
	C441.224365,263.737366 439.956207,263.988007 439.233734,264.468536 
	C438.480713,264.969360 437.707825,265.096893 437.330261,263.639282 
	C437.283325,263.348602 437.085571,263.193573 437.203613,263.236481 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M446.215637,761.268433 
	C445.144196,762.487793 444.199738,763.446045 443.133545,764.708008 
	C442.529724,765.290466 442.047577,765.569092 441.216705,765.862244 
	C440.480774,763.136353 443.013672,761.808533 444.042480,759.364258 
	C444.905396,758.685181 445.596191,758.311768 446.703674,758.020874 
	C446.861053,759.071350 446.601837,760.039368 446.215637,761.268433 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M441.003357,766.010132 
	C440.886993,766.239685 440.726959,766.423279 440.566925,766.606873 
	C440.549103,766.407532 440.531281,766.208191 440.690674,765.942749 
	C440.867950,765.876709 440.959717,765.964233 441.003357,766.010132 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M246.882721,912.331970 
	C250.045227,911.321777 253.105682,910.552124 256.552277,909.747864 
	C257.664459,910.408447 257.760010,911.245056 257.238892,912.532349 
	C256.359192,913.005310 255.729019,913.109924 254.779572,913.192017 
	C253.503082,913.446655 252.514160,913.491882 251.253448,913.816895 
	C249.882263,914.387268 248.787415,914.711060 247.348328,915.025879 
	C246.704407,914.222717 246.140030,913.452637 246.882721,912.331970 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M454.903931,501.363708 
	C455.540680,500.836395 456.004486,500.580261 456.728790,500.276550 
	C457.319489,500.587097 457.466858,501.012726 457.269623,501.793945 
	C457.082092,502.091522 457.162750,502.101624 457.182983,502.135925 
	C454.974243,502.090820 454.385101,505.665527 451.666199,504.676910 
	C452.028351,502.928253 453.938934,502.842987 454.903931,501.363708 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M361.010925,355.949341 
	C360.407654,355.769684 359.827057,355.502747 359.901184,354.721252 
	C359.923737,354.483612 360.234100,354.273315 360.412659,354.050507 
	C360.561005,354.473053 360.709351,354.895599 360.906616,355.667725 
	C360.955505,356.017273 360.978882,355.956146 361.010925,355.949341 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M454.179901,510.955109 
	C454.112579,510.747681 454.375793,509.977509 454.179901,510.955109 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M454.065887,511.075439 
	C454.017639,511.461761 453.820892,511.719482 453.287292,511.972382 
	C453.050568,512.044067 453.008972,512.007080 452.989777,511.985931 
	C453.049957,511.636292 453.222015,511.367004 453.700134,511.041565 
	C453.913574,510.926208 454.017578,511.023254 454.065887,511.075439 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M89.824608,779.878174 
	C92.537300,783.493469 97.090752,784.144043 99.857971,787.688416 
	C97.535637,788.576538 98.826164,789.323425 99.858994,789.950562 
	C103.099945,791.918274 106.157661,794.454407 109.667931,795.650146 
	C115.069183,797.490112 116.620178,802.092896 118.971893,806.639832 
	C118.450531,807.497009 118.478355,808.105408 118.927917,809.011841 
	C119.122757,809.273987 119.198814,809.397949 119.207291,809.464844 
	C118.529190,811.076660 117.152054,811.005310 115.405777,810.989624 
	C114.852890,809.742188 116.347939,808.275391 114.242767,807.127563 
	C113.808502,806.865967 113.644119,806.730835 113.229889,806.794373 
	C112.980057,806.993103 112.499947,806.994995 112.260132,806.993835 
	C110.541573,800.270691 104.574265,797.327759 100.147881,793.168274 
	C95.731499,789.018372 90.856682,785.357788 86.207214,781.453552 
	C85.100983,780.524719 84.682388,779.331726 85.305954,777.917847 
	C86.021820,778.249817 86.737694,778.581787 87.768700,778.935303 
	C88.083832,778.956909 88.043221,778.993835 88.027924,778.971252 
	C88.405334,779.476868 89.039253,779.495972 89.824608,779.878174 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M123.424393,802.189575 
	C124.282211,803.958862 125.356689,804.986145 127.553734,805.093933 
	C128.193649,805.586060 128.487991,806.043701 128.889801,806.752441 
	C126.861183,808.583862 124.714813,805.724609 122.236038,807.052612 
	C121.893997,807.086670 121.923668,807.041870 121.948593,807.050903 
	C121.830849,806.907593 121.688179,806.755249 121.288300,806.781433 
	C120.304977,806.469482 120.272873,805.658020 119.976524,804.929138 
	C118.363876,800.962769 120.268166,801.075623 123.424393,802.189575 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M411.045013,679.653564 
	C410.835022,679.966736 410.669617,679.931946 410.250854,679.886597 
	C409.981720,678.530273 409.965912,677.184509 409.906342,675.435669 
	C410.323761,675.029724 410.785004,675.026794 411.591736,675.020020 
	C411.937256,675.016174 412.394409,675.183716 412.633606,675.229004 
	C413.017609,675.932800 413.162445,676.591309 413.263428,677.595703 
	C412.264618,678.013794 411.322174,678.105591 411.045013,679.653564 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M404.259521,672.054565 
	C404.123993,671.730103 404.266357,671.419678 404.670502,671.091431 
	C404.800659,671.405273 404.669006,671.736938 404.259521,672.054565 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M457.088806,685.833252 
	C457.491852,686.267151 457.676208,686.803833 457.721069,687.758423 
	C456.532654,687.687378 455.739685,687.117126 457.088806,685.833252 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M475.801300,262.469330 
	C474.130249,262.847687 472.471710,262.904175 470.392792,262.968201 
	C469.972412,262.975739 469.996521,262.998932 470.006409,263.012115 
	C471.071747,261.033417 469.335815,261.718170 468.285645,261.311279 
	C467.846497,261.133514 467.669586,261.138397 467.233337,261.200439 
	C465.446564,261.020477 464.161530,260.689636 466.454468,259.057129 
	C468.538055,257.124329 470.501587,256.940704 472.822510,258.717255 
	C473.616730,260.404388 476.142090,259.961670 475.801300,262.469330 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M459.017151,262.221436 
	C460.107178,261.905365 461.520020,261.227051 461.688141,263.471191 
	C460.502045,263.858765 459.397003,263.952179 459.017151,262.221436 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M468.018066,261.473267 
	C469.096680,261.292419 470.310425,260.517578 471.203705,261.632843 
	C471.215912,261.648071 470.588440,262.175720 470.137878,262.744751 
	C469.584167,263.043335 469.152039,263.061371 468.399933,263.139709 
	C468.057495,262.739288 468.035095,262.278564 468.018066,261.473267 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M573.155518,340.776459 
	C572.584473,341.336548 572.233093,341.265747 572.017334,340.408691 
	C572.035706,340.059387 572.511169,340.027344 572.749451,340.025024 
	C573.083679,340.187469 573.179626,340.352203 573.155518,340.776459 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M471.999359,503.376221 
	C474.830780,502.124939 477.060242,503.949402 479.507111,504.710358 
	C482.935608,505.776581 486.169769,507.558563 489.983612,506.974945 
	C491.087921,506.805969 490.589050,507.750641 490.378204,508.671204 
	C489.816559,509.632294 489.351227,510.233551 488.638977,510.977844 
	C483.907074,510.462128 481.146820,505.518646 476.144714,506.179565 
	C475.204559,506.303802 474.289642,506.618805 473.028259,506.980530 
	C471.629761,506.162079 471.968597,504.917938 471.999359,503.376221 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M113.228256,806.995728 
	C113.154305,806.634338 113.328354,806.275085 113.888428,806.829834 
	C113.972893,807.001160 113.476463,806.998413 113.228256,806.995728 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M403.001465,668.881714 
	C402.783600,668.919495 402.832489,668.438660 402.937561,668.220825 
	C403.220398,668.200012 403.398132,668.396973 403.575867,668.593933 
	C403.457031,668.677246 403.338196,668.760559 403.001465,668.881714 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M664.847046,76.944885 
	C665.048828,75.171211 666.267456,75.329712 667.685059,75.391685 
	C679.196289,75.894928 690.719177,74.301582 702.639648,75.710648 
	C702.422791,76.781982 701.487000,76.957832 700.460449,76.999191 
	C690.127502,77.415489 679.745972,76.978592 669.505676,79.112717 
	C668.261719,79.371971 666.635498,77.797195 664.847046,76.944885 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M616.820007,84.762894 
	C617.590454,85.287849 617.949890,85.814980 617.331299,86.414192 
	C617.193909,86.547256 616.664246,86.509163 616.517578,86.356026 
	C616.018005,85.834549 615.941650,85.239349 616.820007,84.762894 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M644.705688,83.956871 
	C645.576355,83.484978 645.864685,83.870766 645.658875,84.432098 
	C645.517578,84.817383 644.909973,85.380684 644.667419,85.311935 
	C644.033264,85.132240 644.258667,84.574081 644.705688,83.956871 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M552.809326,93.128319 
	C552.899536,93.446014 552.761780,93.864258 552.624084,94.282501 
	C551.954834,93.957809 552.316223,93.591385 552.809326,93.128319 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M548.402588,95.732971 
	C548.557068,95.855614 548.578857,96.066391 548.600708,96.277161 
	C548.490417,96.125145 548.380188,95.973129 548.402588,95.732971 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M711.469788,81.452431 
	C711.522644,81.421738 711.416931,81.483124 711.469788,81.452431 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M552.987793,92.982132 
	C553.097290,92.657379 553.293152,92.405968 553.776794,92.102280 
	C553.992676,91.993958 554.000000,92.000000 554.002930,92.003784 
	C553.898010,92.321075 553.714355,92.580994 553.246094,92.907547 
	C553.037231,93.027779 553.002258,92.999413 552.987793,92.982132 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M551.546997,91.469666 
	C551.578308,91.522736 551.515686,91.416595 551.546997,91.469666 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M607.009155,86.012192 
	C606.917847,86.050278 606.817871,86.077515 606.848511,86.044403 
	C606.979187,85.984062 607.000488,86.001343 607.009155,86.012192 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M638.452759,86.529007 
	C638.422119,86.476379 638.483459,86.581627 638.452759,86.529007 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M67.606476,345.255951 
	C69.063568,345.670654 69.277954,346.538086 68.195786,347.814758 
	C66.980492,347.283173 66.866753,346.431152 67.606476,345.255951 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M83.123062,323.301941 
	C83.822449,322.471405 83.852020,323.149689 83.881355,323.499969 
	C83.900635,323.730103 83.646202,323.983093 83.514328,324.225861 
	C83.372002,323.990570 83.229668,323.755310 83.123062,323.301941 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M269.724121,198.893951 
	C269.380890,198.326782 269.375244,197.934830 269.507690,197.280167 
	C270.423126,196.747040 270.613098,196.189850 270.167297,195.216125 
	C270.011169,192.519287 270.102448,190.049332 270.312378,187.195831 
	C272.407715,185.938095 274.149292,184.571671 276.643127,184.001114 
	C277.448334,183.981766 277.890106,183.980576 278.663147,183.978226 
	C279.843536,184.063370 280.636169,184.329330 281.598572,184.841156 
	C281.810364,184.953506 282.203705,185.081894 282.212341,184.838791 
	C282.220978,184.222687 282.283081,183.858902 282.538300,183.219147 
	C283.028442,182.643753 283.418121,182.460938 284.188416,182.369690 
	C284.742371,182.428162 284.960022,182.485214 285.479248,182.692978 
	C287.031525,184.401962 289.973572,183.401016 290.517914,186.317215 
	C290.310089,187.632446 288.966034,187.891037 289.147583,189.220856 
	C289.543732,189.653580 289.799438,189.874985 290.274506,190.225189 
	C290.974579,190.587173 291.471954,190.595108 292.252014,190.342499 
	C293.121521,190.119598 293.717926,190.124435 294.610840,190.324982 
	C295.806122,190.912003 296.713379,191.282288 297.979156,190.436996 
	C299.154419,189.991486 300.049530,189.929764 301.292877,190.240585 
	C302.029449,190.610168 302.336029,190.947937 302.578796,191.725586 
	C302.600342,192.283508 302.569092,192.503662 302.404846,193.021851 
	C301.698303,194.153793 300.923431,194.857483 300.596558,196.165924 
	C300.628296,196.852859 300.802887,197.173935 301.406067,197.454956 
	C302.284058,197.504700 302.762268,197.232346 303.402649,196.632263 
	C303.914612,196.135269 304.233032,195.873276 304.844452,195.466675 
	C305.911316,194.968964 306.843262,195.035477 307.771545,194.213486 
	C308.548615,193.111282 309.417633,193.005234 310.666687,193.000214 
	C311.387573,192.619171 311.843781,192.485519 312.683075,192.807220 
	C312.995636,193.762451 312.996674,194.506470 312.996399,195.622498 
	C311.842224,197.134003 310.631927,198.215515 309.303955,199.673950 
	C308.270721,200.802460 307.274689,201.347824 305.895020,201.850037 
	C305.383606,202.153625 305.121918,202.179123 304.859406,202.212982 
	C304.657990,202.238983 304.595459,202.301041 304.648560,202.218643 
	C305.009583,201.658203 305.545074,202.816544 305.253876,202.384918 
	C306.068481,202.326706 306.559631,202.499435 307.125763,203.061493 
	C307.419037,203.333008 306.979828,203.798737 307.517944,203.350616 
	C307.536407,202.040924 307.907501,201.145370 308.838928,200.164276 
	C310.331268,198.882980 311.594879,197.814987 312.785706,196.229187 
	C318.297180,199.890411 323.389191,195.783844 328.580841,195.647766 
	C330.273499,195.603409 330.305023,193.098419 332.150482,193.502060 
	C332.967072,198.839447 335.423767,199.890808 340.952545,197.186478 
	C342.739563,198.393646 337.426331,201.712051 342.634338,201.989273 
	C343.839600,201.782303 344.110901,200.992722 344.792969,200.203247 
	C346.463959,198.486053 346.850739,194.402679 350.377808,198.402771 
	C352.060669,200.311371 353.470062,196.725937 355.417114,196.659210 
	C356.879211,196.609085 357.361359,192.512619 359.463257,195.383453 
	C361.273773,197.856262 357.382080,197.660217 357.059631,199.659134 
	C357.000000,200.003052 356.999969,200.502441 356.998779,200.752136 
	C356.316925,201.699921 355.474701,202.024658 354.184418,202.069000 
	C352.824005,201.924820 351.825073,201.530167 350.440857,201.722015 
	C349.488068,201.852798 348.830292,201.885498 348.190216,202.722519 
	C345.557983,208.396561 341.982269,210.127853 336.276215,205.227203 
	C336.934509,209.094879 340.551544,209.375732 340.587463,213.017761 
	C335.811218,210.390152 332.737701,206.784729 330.039185,202.360870 
	C329.573700,201.495270 329.056305,201.328720 328.213287,201.793137 
	C328.056244,202.662323 328.100494,203.320328 328.167175,203.976044 
	C328.329407,205.571701 331.453094,207.040649 329.010315,208.552017 
	C327.028107,209.778458 327.261139,206.824844 326.265442,205.977661 
	C324.805420,204.735443 324.319733,205.664032 323.872559,206.940353 
	C323.531433,207.914093 322.918793,208.927414 321.759064,208.411545 
	C320.722015,207.950241 321.075439,206.694778 320.999908,205.369904 
	C320.248535,204.181931 319.416962,203.867783 318.210175,204.793243 
	C317.189514,207.955383 316.110107,208.901199 312.374542,208.340088 
	C309.437225,207.898865 305.139740,207.075317 302.343506,210.184021 
	C300.275360,212.483276 298.512451,212.194489 296.504059,210.073242 
	C295.382050,208.888168 293.866882,208.082870 292.573944,207.050034 
	C291.146729,205.909897 287.440552,205.888000 291.088898,202.507111 
	C292.970215,200.763702 289.505463,198.938980 288.513367,198.041840 
	C286.355286,196.090317 284.048767,194.237930 282.008240,192.115509 
	C281.230377,191.306442 280.440613,190.717636 279.532318,191.703201 
	C278.870941,192.420853 279.151733,193.278748 279.923492,193.830170 
	C283.905640,196.675507 279.665833,197.254379 278.297852,198.852463 
	C278.001221,198.999390 277.764191,198.931824 277.881470,198.966217 
	C278.151001,200.763123 278.303253,202.525650 278.499603,204.798721 
	C275.310089,203.075363 272.493866,201.379944 269.724121,198.893951 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M302.412689,191.208145 
	C300.937073,191.000015 299.871704,191.000046 298.406830,190.999725 
	C297.328644,191.575317 296.564270,191.738708 295.370728,191.243317 
	C294.275848,191.007172 293.521729,191.004013 292.390503,191.000122 
	C291.625671,191.380005 291.163513,191.527603 290.315308,191.221375 
	C289.683258,190.893570 289.422760,190.704147 289.111084,190.214325 
	C288.371887,188.993912 288.913605,188.233612 289.759094,187.230957 
	C289.850220,183.699799 285.861053,186.156662 285.078979,183.367859 
	C285.673737,182.344849 286.456909,182.253098 287.661469,182.763458 
	C290.494720,182.510727 291.859131,183.969559 293.342377,185.689041 
	C294.409058,186.925598 295.715424,189.495056 297.942139,186.340729 
	C297.998779,186.000610 298.000000,186.000000 298.000610,185.999695 
	C298.687592,185.422958 299.458130,185.261566 300.658539,185.765259 
	C301.001221,186.000610 301.000000,186.000000 300.999390,185.999695 
	C301.640137,186.873779 302.766266,186.957870 303.783600,187.787659 
	C304.001221,188.001221 304.000000,188.000000 303.999390,187.999390 
	C304.924347,189.591263 305.034119,190.903046 302.412689,191.208145 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M277.012146,183.601013 
	C275.713806,186.207108 273.670288,186.946304 270.831055,186.857574 
	C270.576477,185.438675 270.721893,184.065048 271.045654,182.396332 
	C272.991364,182.038086 272.324646,180.610443 272.786896,179.349289 
	C278.253387,177.702789 278.253387,177.702789 277.012146,183.601013 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M287.997131,182.626099 
	C287.257050,182.999954 286.508026,183.001114 285.384888,183.006561 
	C285.010773,183.010834 285.001038,183.001053 285.001129,183.001129 
	C284.492096,182.376419 283.764099,182.062607 282.877594,181.458740 
	C282.285645,180.765274 282.075745,180.212982 282.012421,179.299377 
	C282.650726,176.718094 277.445465,176.817261 279.700592,174.779449 
	C281.943665,172.752533 283.465851,176.466949 284.202179,177.622208 
	C285.312866,179.364944 288.031006,179.748398 287.997131,182.626099 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M271.782806,160.413818 
	C273.545502,159.483841 275.404938,158.783646 277.631592,158.042328 
	C278.218475,159.744186 273.915894,161.037125 277.489990,163.113907 
	C276.480438,164.727020 274.919861,164.987686 272.801025,164.803802 
	C272.421387,164.370422 272.442322,163.994385 272.589111,163.362335 
	C273.137115,162.942093 273.295135,162.630173 272.963684,162.040619 
	C272.427063,161.474335 272.153320,161.058960 271.782806,160.413818 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M282.998474,185.627426 
	C281.574951,186.037582 280.192657,185.969116 279.153015,184.284821 
	C279.102264,183.666321 279.287415,183.411926 279.761536,183.102905 
	C280.256683,182.708344 280.554810,182.441071 281.119843,182.021408 
	C281.556488,181.766403 281.740723,181.679855 282.231262,181.596848 
	C282.923035,181.782822 283.174469,182.082489 283.155853,182.748871 
	C283.001434,183.759644 283.001099,184.505112 282.998474,185.627426 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M301.000000,179.999695 
	C301.099762,178.893982 300.764496,177.453003 302.341858,177.213821 
	C303.808472,176.991455 304.084930,178.458572 304.590179,179.947876 
	C303.494995,181.003876 302.533752,181.009567 301.291321,180.237762 
	C301.000000,180.000610 301.000000,180.000000 301.000000,179.999695 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M272.998169,178.620346 
	C272.954926,180.052475 273.067322,181.157639 271.612732,181.975067 
	C271.286621,179.985077 271.349243,177.868881 271.590851,175.330353 
	C273.151550,175.659698 272.968201,176.987366 272.998169,178.620346 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M348.916748,162.367752 
	C350.150421,163.437363 349.441101,164.063370 348.564270,164.492920 
	C348.309143,164.617905 347.536438,164.324585 347.476440,164.097412 
	C347.237457,163.192780 347.884766,162.710785 348.916748,162.367752 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M292.813232,160.206909 
	C293.759247,160.839722 293.693146,161.424408 292.934937,161.715424 
	C292.586823,161.848999 291.821991,161.666870 291.669312,161.392487 
	C291.243774,160.627609 291.792938,160.269135 292.813232,160.206909 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M322.794922,146.308990 
	C324.133148,146.076767 325.382935,145.808823 325.926270,147.594666 
	C325.236542,147.946625 324.489258,147.968262 323.367615,147.991608 
	C322.993256,147.993301 323.000580,148.000565 323.003784,148.003784 
	C322.625702,147.616165 322.475616,147.150772 322.794922,146.308990 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M334.008484,147.290634 
	C334.883240,147.163116 336.096893,146.616364 336.451691,147.957626 
	C336.512299,148.186783 335.899719,148.594009 335.286926,148.974854 
	C334.659180,148.550980 334.342651,148.071182 334.008484,147.290634 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M301.355103,154.021042 
	C301.062103,152.561935 301.895355,151.969360 303.642731,152.004669 
	C303.919128,153.448975 303.079590,154.033066 301.355103,154.021042 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M330.998779,150.001465 
	C331.883850,150.083862 332.938019,149.750671 333.450378,150.792969 
	C333.541382,150.978088 333.117920,151.651199 332.817383,151.749847 
	C331.902283,152.050247 331.386017,151.484695 331.053772,150.328156 
	C331.002441,149.997116 331.000000,150.000000 330.998779,150.001465 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M305.000610,179.999680 
	C307.187408,180.515747 307.616058,181.434418 305.332336,182.948944 
	C304.421814,182.314499 304.270386,181.542282 304.764343,180.343887 
	C304.998779,180.001221 305.000000,180.000000 305.000610,179.999680 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M376.524109,175.011292 
	C376.029938,175.888947 375.414459,175.988831 374.815033,175.582504 
	C374.326569,175.251404 374.329742,174.718018 374.830750,174.399567 
	C375.438873,174.013000 376.053619,174.116135 376.524109,175.011292 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M360.193817,174.781677 
	C359.246155,174.151138 359.322876,173.569214 360.074249,173.280014 
	C360.420044,173.146896 361.181213,173.329941 361.333923,173.603821 
	C361.759857,174.367966 361.212250,174.722382 360.193817,174.781677 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M281.756073,179.169754 
	C282.317017,179.459396 282.637665,179.918991 282.983887,180.671478 
	C282.964539,181.325012 282.784760,181.586868 282.226318,181.864807 
	C282.005890,181.996765 282.000000,182.000000 281.997681,182.001053 
	C281.497345,182.231003 281.088837,182.110031 280.877045,181.337006 
	C281.169281,180.438934 281.342529,179.889313 281.756073,179.169754 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M352.388336,175.455078 
	C351.592834,175.678329 351.302246,175.400406 351.423401,174.781647 
	C351.448517,174.653336 351.631104,174.480530 351.761139,174.460892 
	C352.386261,174.366562 352.647614,174.671494 352.388336,175.455078 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M355.542175,178.373291 
	C355.313904,177.572861 355.598145,177.289551 356.215271,177.410248 
	C356.344391,177.435486 356.519745,177.616898 356.538666,177.746155 
	C356.630096,178.369629 356.328583,178.635452 355.542175,178.373291 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M298.320679,156.955368 
	C298.090515,156.084564 298.349365,155.292358 299.730011,155.045013 
	C299.954285,155.916656 299.672729,156.692398 298.320679,156.955368 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M280.751648,181.158249 
	C281.102814,181.309402 281.291229,181.571548 281.778320,181.888550 
	C281.521454,182.319931 281.047546,182.637741 280.273438,182.973740 
	C280.151215,182.437286 280.329224,181.882614 280.751648,181.158249 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M281.597412,219.001434 
	C281.666199,220.741516 281.333618,222.483643 281.000519,224.613190 
	C281.000000,225.000610 281.000000,225.000000 281.000000,224.999695 
	C280.007446,225.817215 278.926331,226.056122 277.361267,225.249939 
	C276.998779,224.999390 277.000000,225.000000 277.000610,225.000305 
	C276.983673,222.011246 276.469208,218.674332 281.597412,219.001434 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M355.759125,202.737183 
	C355.077728,204.490799 354.851776,206.715698 352.557678,206.838776 
	C350.300781,206.959869 350.278015,204.815506 349.263550,203.219131 
	C348.807404,202.521439 348.893738,202.103210 349.597961,201.641983 
	C350.904694,201.441574 351.804138,201.791306 353.086426,201.981628 
	C354.160339,202.039902 354.873810,202.095581 355.759125,202.737183 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M356.243774,202.831329 
	C355.253357,203.001480 354.503815,203.000320 353.379578,202.999573 
	C352.625519,202.612488 352.473297,202.150162 352.777100,201.307037 
	C354.070526,201.001068 355.134979,201.001144 356.598450,201.001526 
	C356.826599,201.554565 356.655670,202.107300 356.243774,202.831329 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M368.999390,213.999695 
	C368.907562,215.148453 368.643646,216.228622 367.347626,216.531891 
	C367.110413,216.587402 366.469666,216.063934 366.476135,215.819931 
	C366.506409,214.676559 367.405792,214.315201 368.677185,214.034454 
	C369.001221,214.000610 369.000000,214.000000 368.999390,213.999695 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M350.222626,201.749542 
	C349.680176,202.105911 349.420929,202.294144 349.109863,202.780533 
	C348.998718,202.996948 348.499390,202.998596 348.249695,202.998627 
	C347.829224,202.159821 346.701874,201.339767 347.741516,200.510681 
	C348.046570,200.267410 348.864044,200.666718 349.722717,200.885757 
	C350.148010,201.166565 350.297241,201.333130 350.222626,201.749542 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M318.375916,205.002640 
	C318.513611,202.818130 319.429871,202.387634 320.946411,204.668381 
	C320.249390,205.000809 319.500000,205.001617 318.375916,205.002640 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M282.000366,219.000305 
	C282.139191,218.052399 282.307098,217.105438 283.579437,217.170319 
	C283.817139,217.182434 284.249023,217.476669 284.238342,217.613098 
	C284.163116,218.574814 283.374878,218.757294 282.308594,218.972168 
	C281.998779,218.999390 282.000000,219.000000 282.000366,219.000305 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M328.334229,202.005142 
	C328.235870,201.491486 328.340088,200.724350 328.734070,200.522308 
	C329.345825,200.208603 329.748047,200.799301 329.957733,201.712280 
	C329.553131,202.007858 329.109894,202.006393 328.334229,202.005142 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M268.218323,216.869751 
	C267.975708,216.557526 267.959045,216.112442 268.034393,215.344315 
	C268.784027,215.490921 269.027893,216.037247 268.218323,216.869751 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M253.872345,384.997986 
	C254.024292,392.737061 253.753464,400.475830 253.305679,408.603638 
	C249.607605,412.353851 245.653152,410.204712 241.451691,409.676147 
	C240.852890,409.260559 240.644577,409.049011 240.223755,408.442078 
	C239.811569,407.474762 239.696106,406.886261 239.641129,405.828674 
	C240.247147,400.897552 240.768463,396.411469 240.759949,391.464111 
	C242.630066,388.187500 241.747803,384.191406 245.315216,382.074982 
	C247.488922,380.785370 249.437714,377.826263 250.058578,383.046722 
	C250.317581,385.224396 251.988434,384.922852 253.872345,384.997986 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M222.324234,410.336639 
	C222.639969,408.590698 222.814255,407.215302 222.921341,405.425232 
	C222.575500,404.587494 222.472839,404.122528 222.711700,403.304382 
	C223.224594,401.560394 223.548737,400.133118 223.967743,398.350616 
	C224.388306,397.941925 224.722443,397.918610 225.038467,397.830444 
	C228.213913,396.944244 229.261307,391.359406 232.694839,392.889374 
	C235.268433,394.036102 236.609085,397.949890 238.774948,400.824768 
	C240.154556,402.203888 239.939651,403.691498 239.986969,405.547028 
	C239.624664,408.181763 240.806320,410.494568 239.250214,412.940369 
	C234.223282,413.562225 229.956955,417.622192 224.480789,414.903870 
	C223.681519,414.437927 223.283234,414.092957 222.709290,413.362183 
	C222.134811,412.289734 222.026321,411.515717 222.324234,410.336639 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M239.427856,406.350616 
	C239.143311,404.766998 239.083557,403.326691 239.037506,401.452087 
	C240.908356,398.098999 239.365723,394.676178 240.697449,391.347534 
	C240.863770,395.928925 240.773941,400.804199 240.432465,406.122955 
	C240.004776,406.542267 239.828705,406.518097 239.427856,406.350616 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M243.270538,308.270935 
	C243.710129,307.770813 244.033417,307.788544 244.595581,307.917755 
	C244.785431,311.499023 244.731552,315.057373 244.714203,319.023682 
	C243.644608,315.939880 243.182892,312.352539 243.270538,308.270935 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M231.014603,323.483826 
	C231.884918,323.974640 231.982361,324.585876 231.579712,325.180450 
	C231.251221,325.665527 230.722000,325.662415 230.406021,325.165100 
	C230.022171,324.561005 230.127701,323.951324 231.014603,323.483826 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M223.840057,397.697754 
	C223.293991,397.993347 222.863708,397.916199 222.113678,397.763428 
	C221.386230,397.245758 221.320190,396.714844 221.501251,395.893066 
	C222.116867,395.482208 222.624588,395.325989 223.522308,395.083710 
	C223.926804,395.773407 223.941330,396.549194 223.840057,397.697754 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M373.471588,255.453400 
	C373.522888,255.424026 373.420288,255.482788 373.471588,255.453400 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M333.297058,232.131531 
	C332.592407,232.385208 332.139191,232.430069 331.685944,232.474915 
	C331.657562,229.120743 334.418549,227.494492 336.645721,226.579163 
	C338.750519,225.714127 340.252930,228.521561 341.341797,230.227631 
	C342.392212,231.873398 340.410095,231.870529 339.484680,232.269806 
	C335.552063,233.966553 338.766602,229.602554 336.854736,229.367447 
	C335.365479,229.505661 334.707520,231.061935 333.297058,232.131531 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M276.960083,225.351532 
	C278.065796,224.999390 279.132782,224.999390 280.599915,224.999390 
	C280.535431,229.003525 275.450928,232.894608 271.233185,232.152847 
	C273.578369,230.225296 275.809631,228.424316 276.960083,225.351532 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M341.001221,246.999084 
	C339.827576,246.848038 338.247772,247.297348 338.265533,245.314148 
	C338.268616,244.968796 338.727509,244.405685 339.068115,244.322998 
	C340.687744,243.929779 340.870697,245.090668 340.988068,246.634186 
	C340.997589,247.001831 341.000000,247.000000 341.001221,246.999084 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M286.089264,242.749603 
	C285.160156,242.059448 284.854858,241.348511 285.562836,240.671738 
	C286.091492,240.166428 286.737457,240.389618 287.157074,240.931702 
	C287.949493,241.955353 287.661316,242.606125 286.089264,242.749603 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M266.217041,243.807831 
	C265.977966,242.299438 266.015808,240.579926 266.124847,238.435852 
	C269.446106,239.705032 266.339874,241.737823 266.217041,243.807831 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M308.517426,230.706650 
	C308.889954,231.589447 308.873718,232.227570 308.108429,232.470932 
	C307.901062,232.536896 307.401825,232.293060 307.337036,232.093735 
	C307.061188,231.244751 307.095306,230.481827 308.517426,230.706650 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M290.340576,246.995392 
	C290.137299,246.034515 290.369263,245.094391 291.616333,245.214417 
	C291.934082,245.245010 292.478333,245.763824 292.454193,246.013428 
	C292.350708,247.083679 291.395233,246.867477 290.340576,246.995392 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M311.207397,234.215759 
	C312.219971,234.276352 312.771393,234.626785 312.347321,235.389893 
	C312.195496,235.663116 311.437347,235.845886 311.091370,235.714218 
	C310.339722,235.428131 310.264740,234.848221 311.207397,234.215759 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M345.036560,229.280823 
	C345.627960,229.091858 346.341461,229.096252 346.482727,229.904694 
	C346.512482,230.074951 346.156189,230.312668 345.977753,230.519287 
	C345.676208,230.200073 345.374664,229.880859 345.036560,229.280823 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M287.000000,230.999695 
	C286.906738,231.626358 286.903534,232.340332 286.095856,232.482300 
	C285.925842,232.512177 285.688049,232.156219 285.481476,231.978027 
	C285.800507,231.676437 286.119537,231.374847 286.719299,231.036926 
	C287.000000,231.000610 287.000000,231.000000 287.000000,230.999695 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M368.000610,233.999695 
	C367.373383,233.907135 366.658875,233.904465 366.516541,233.095749 
	C366.486603,232.925644 366.842987,232.687561 367.021393,232.480804 
	C367.323212,232.800064 367.625031,233.119324 367.962830,233.719604 
	C367.998779,234.000610 368.000000,234.000000 368.000610,233.999695 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M303.380737,249.454773 
	C302.588226,249.679108 302.302765,249.400620 302.423370,248.786514 
	C302.448456,248.658768 302.629303,248.486404 302.758301,248.466995 
	C303.379028,248.373657 303.639862,248.675247 303.380737,249.454773 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M278.001221,244.999054 
	C277.374237,244.907333 276.660370,244.904678 276.517273,244.096283 
	C276.487183,243.926361 276.843384,243.688065 277.021545,243.481262 
	C277.322906,243.800797 277.624268,244.120346 277.961792,244.720886 
	C277.997925,245.001892 278.000000,245.000000 278.001221,244.999054 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M280.001221,245.001221 
	C280.095001,244.375275 280.095673,243.660278 280.904205,243.517212 
	C281.073944,243.487167 281.312103,243.843582 281.518738,244.021912 
	C281.199005,244.322983 280.879242,244.624039 280.278534,244.961365 
	C279.997559,244.997620 280.000000,245.000000 280.001221,245.001221 
z"/>
<path fill="#ECE9CD" opacity="1.000000" stroke="none" 
	d="
M89.490021,315.951721 
	C89.147911,315.246307 89.113838,314.482513 89.190765,313.350800 
	C91.298622,313.640747 91.651382,314.578949 89.490021,315.951721 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M730.802856,115.205025 
	C735.496460,115.380714 736.517517,120.025307 739.638428,122.135559 
	C740.453674,122.686829 739.154175,123.790955 738.361206,124.372391 
	C735.445251,126.510544 735.095581,128.807083 737.970520,131.634064 
	C741.487915,134.626816 740.604248,137.379898 738.011047,140.451035 
	C737.370422,141.466095 736.724976,142.060364 736.096802,143.062973 
	C735.679993,143.666565 735.405518,143.980225 734.869690,144.469406 
	C733.961304,145.126785 733.343262,145.641464 732.744812,146.623840 
	C732.408936,147.043961 732.254639,147.199356 731.802124,147.504700 
	C730.826233,147.838165 730.158264,147.799789 729.199402,147.393021 
	C725.065979,142.449631 725.055603,142.436752 720.359802,146.228928 
	C718.602051,147.648407 716.312622,148.472565 715.124878,151.010986 
	C714.857422,151.499496 714.739868,151.687302 714.406738,152.123505 
	C713.118958,153.091354 712.233032,153.962112 711.699341,155.536560 
	C711.388550,155.987793 711.234497,156.148865 710.767090,156.435349 
	C708.062988,156.654892 706.955017,154.700394 705.185547,153.177887 
	C704.251770,152.081558 704.405029,151.302826 705.409058,150.413666 
	C705.843140,150.009506 706.238831,150.016815 706.348328,149.878998 
	C706.759521,149.361511 705.778564,149.152344 706.258728,149.614792 
	C706.260498,149.616501 706.197632,149.738297 705.836304,150.122864 
	C704.636292,150.802597 703.879517,151.422958 704.883789,152.886841 
	C705.743225,153.837021 706.014526,154.668610 705.858765,155.959854 
	C705.703979,156.516266 705.613647,156.730591 705.315552,157.225372 
	C703.680115,158.668701 702.340759,159.964218 700.183777,160.568802 
	C699.614624,160.518860 699.392212,160.452393 698.914551,160.147293 
	C697.142883,157.690247 701.440918,156.075439 699.036133,153.575607 
	C695.322510,149.919617 694.775818,155.168579 692.226196,155.496979 
	C689.504211,155.211121 688.341553,152.922134 686.111084,151.918320 
	C685.926941,151.796738 685.547852,151.883102 685.763733,151.912247 
	C687.298889,152.724655 688.021301,153.781189 687.392273,155.670776 
	C684.064148,157.874405 682.267151,155.550385 680.561096,153.604492 
	C679.040771,151.870438 677.926086,149.782516 675.766418,148.151596 
	C675.298584,147.822037 675.116821,147.680267 674.695679,147.286102 
	C672.977783,145.865875 673.057007,142.295654 669.456970,144.170975 
	C668.763489,144.551544 668.329956,144.658722 667.547974,144.626099 
	C666.009033,144.131744 665.228638,142.942520 663.607666,142.567993 
	C663.108582,142.355896 662.921936,142.241699 662.546021,141.859299 
	C662.001038,140.785110 661.965881,139.958481 662.307495,138.897339 
	C662.417786,138.679993 662.659912,138.349747 662.547485,138.403412 
	C662.435120,138.457092 662.089111,138.573959 661.868958,138.606461 
	C661.648804,138.638962 661.152649,138.597153 660.894104,138.540695 
	C660.274353,138.389969 659.911682,138.301910 659.249634,138.166016 
	C658.328003,137.998978 657.724609,137.820206 656.876587,137.357483 
	C656.129578,136.659698 655.793762,136.068695 655.434082,135.094452 
	C655.289185,134.282288 655.333618,133.816391 655.637756,133.051117 
	C656.191589,132.454651 656.599731,132.230881 657.389282,132.024445 
	C658.174744,131.944595 658.616638,131.980682 659.348755,132.194733 
	C660.497070,132.530212 661.209412,132.332260 661.830078,131.358444 
	C661.916504,130.933319 661.924561,130.763855 661.897583,130.357147 
	C661.862671,130.119888 661.703613,129.701416 661.467102,129.605331 
	C661.230591,129.509247 661.562500,129.794388 661.646729,130.007538 
	C661.783936,130.550110 661.762207,130.874680 661.559570,131.440979 
	C661.229431,131.996567 660.928894,132.197586 660.278564,132.304779 
	C659.065857,131.938660 658.182617,131.491577 656.980774,131.033539 
	C656.522644,130.846863 656.342834,130.766541 655.905334,130.552612 
	C655.152893,130.175659 654.671021,129.873398 653.819580,130.224899 
	C653.384155,130.482056 653.208252,130.592407 652.754272,130.864502 
	C651.875610,131.343323 651.245605,131.587753 650.251343,131.887909 
	C647.186462,132.438324 645.502197,133.898056 644.656921,136.627777 
	C641.204163,147.778961 641.158447,147.764297 629.336304,146.510406 
	C628.176392,146.387375 627.008301,146.405777 625.468262,146.286118 
	C622.591675,145.659164 620.883301,144.491943 621.766785,141.237274 
	C621.939331,140.784042 621.987305,140.617752 621.979309,140.251434 
	C621.420593,141.006531 620.656799,141.553101 619.216553,141.489365 
	C618.475952,141.187469 618.124634,140.897507 617.668396,140.238007 
	C617.403503,139.454453 617.244934,138.820557 617.539001,138.521469 
	C620.901428,135.101196 619.441284,131.899811 617.070557,128.382278 
	C616.744690,126.403145 615.982483,124.918991 615.565674,122.973389 
	C615.947815,121.838974 616.554382,121.517593 617.689819,121.786179 
	C618.873413,123.130997 619.256775,124.794785 621.122375,122.491348 
	C623.572083,119.466721 625.544800,115.807198 629.965454,114.225906 
	C630.603149,114.347595 630.739014,114.453262 631.080566,114.695374 
	C631.612976,114.991661 631.923889,114.964394 632.430054,114.589340 
	C633.196899,113.926857 633.659485,113.344246 634.551270,112.372742 
	C635.749390,111.997353 636.498779,111.993790 637.899536,112.037704 
	C639.117493,112.170082 639.686646,112.200836 640.565186,112.151749 
	C641.300110,112.141380 641.719727,112.209282 642.434387,112.474930 
	C644.824219,116.980446 639.948364,117.089569 638.401855,119.597519 
	C637.746704,120.285225 637.266602,120.646904 636.346558,120.633522 
	C635.965881,120.429855 635.851501,120.288391 635.885864,120.379677 
	C636.948120,121.012314 637.532349,120.458038 638.354004,119.656731 
	C639.591187,118.304115 640.973938,117.687775 642.083618,116.730690 
	C643.624756,115.401550 644.952576,112.954659 647.323669,115.103409 
	C649.672791,117.232231 651.012756,119.816681 648.173462,122.907204 
	C648.007019,123.049469 647.838440,123.275467 647.952332,123.165161 
	C649.547668,121.534531 652.948853,121.841965 652.652588,118.172417 
	C653.370544,117.466171 653.980103,117.269951 654.956726,117.271416 
	C655.988770,117.445557 656.721191,117.650688 657.602295,116.924011 
	C658.524475,116.066551 659.436218,115.608208 660.086670,114.446640 
	C660.396973,114.037369 660.531982,113.880829 660.903625,113.522957 
	C662.033569,112.778778 662.817505,112.115608 663.647034,111.022751 
	C664.421997,110.400688 665.037598,110.221237 666.031555,110.248367 
	C666.561768,110.377602 666.765808,110.461769 667.227417,110.742859 
	C667.925171,111.258919 668.266113,111.889565 669.181519,111.191177 
	C669.555542,110.824677 669.708984,110.677536 670.121094,110.336823 
	C670.568848,109.483879 672.366211,110.032715 671.240051,108.628860 
	C670.746216,108.621758 670.546631,108.592216 670.063354,108.446762 
	C669.099670,107.881210 668.476257,107.352783 667.395508,106.450470 
	C666.998901,105.248459 667.002014,104.500679 667.002563,103.378998 
	C667.950073,101.792824 669.561035,103.062271 670.802368,101.846329 
	C671.426575,101.441879 671.838257,101.332985 672.600342,101.315598 
	C673.552185,101.471748 674.145447,101.683205 674.887878,102.075584 
	C675.556702,102.566086 675.607971,102.316750 675.602417,101.593582 
	C679.595642,98.920738 680.417236,102.056244 681.530762,104.938087 
	C681.074280,106.313805 679.223999,106.884216 680.676880,108.687920 
	C681.247681,109.310852 681.374695,109.752579 681.183716,110.260796 
	C681.623291,109.781296 681.218994,109.417999 680.794556,108.773956 
	C680.244751,107.869331 680.254150,107.214607 680.770874,106.285782 
	C681.504333,105.495056 682.126038,105.251205 683.189148,105.423187 
	C684.308899,106.278999 685.048096,107.073357 685.932007,107.944489 
	C686.041077,108.057137 686.238220,108.112701 686.126831,108.073608 
	C685.483398,107.447983 684.907410,106.904427 684.141174,106.105270 
	C683.232483,104.500504 682.240723,103.221306 682.769775,101.265701 
	C683.433594,101.001205 683.885498,101.000694 684.676270,101.003548 
	C687.328979,103.830528 689.898132,100.625496 692.611450,101.454414 
	C694.786987,103.502533 696.473206,100.572823 698.601196,101.529861 
	C700.150391,102.609306 700.555176,104.242828 702.010620,105.427032 
	C702.960754,106.655754 703.636414,107.702904 704.957153,108.575394 
	C706.000122,109.708862 706.703674,110.742859 708.034668,111.599960 
	C709.796265,113.614525 710.852356,112.277794 711.822388,111.201401 
	C712.837830,110.074509 711.648499,109.481514 711.027588,108.835655 
	C710.231628,108.007645 709.172668,107.484230 708.147644,106.387199 
	C707.503662,105.106262 707.834290,104.273521 708.763733,103.260315 
	C709.011047,103.000916 708.999939,102.999313 709.000000,103.005249 
	C710.840210,101.518089 712.221924,102.622345 713.830627,104.083588 
	C714.885681,105.003113 714.558777,108.789993 716.848206,105.372520 
	C717.846252,103.882729 718.636719,102.179764 721.427979,102.658325 
	C721.971252,104.136147 722.050598,105.278633 720.865784,106.025452 
	C720.250366,106.413391 719.066040,107.371384 720.028320,107.765060 
	C725.714966,110.091408 719.458740,112.149216 719.986694,114.653992 
	C719.559082,115.445236 719.052795,115.667717 718.195435,115.667046 
	C717.766174,115.593452 717.603027,115.555878 717.667297,115.677856 
	C718.543518,116.109772 718.776611,116.974205 719.582581,117.022865 
	C719.554932,116.534576 719.466003,116.046989 719.776062,115.293015 
	C722.925842,115.765831 725.621338,115.683952 727.888000,113.217865 
	C729.570496,111.387306 730.346252,112.756790 730.958130,114.660904 
	C730.482666,115.554924 729.836731,115.894325 728.950378,116.249908 
	C728.772217,116.368019 728.494507,116.677887 728.640015,116.508514 
	C729.362915,115.974953 730.072021,115.866127 730.802856,115.205025 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M617.720703,127.777451 
	C618.219238,128.443237 618.322876,129.052887 618.680298,129.310577 
	C623.757935,132.971085 620.780945,136.130386 618.048706,139.658295 
	C617.990051,140.968430 617.388123,142.012482 618.576172,143.087280 
	C618.938171,143.481293 619.072693,143.651550 619.311768,144.134293 
	C619.490479,145.355896 619.255310,146.213394 618.848389,147.375275 
	C618.595337,147.874756 618.473267,148.063080 618.111328,148.485565 
	C616.498840,149.740082 614.729858,150.323654 613.920044,152.439575 
	C613.611572,152.906006 613.472412,153.083923 613.074768,153.484634 
	C610.728577,154.724060 609.842041,156.280136 610.621826,158.931320 
	C610.553772,159.494873 610.489319,159.713226 610.227905,160.206635 
	C609.010742,161.501038 607.249817,161.740219 606.828613,163.768890 
	C606.698120,164.278198 606.633301,164.478287 606.409302,164.949326 
	C605.575439,165.956146 604.520386,166.345032 604.124512,167.735062 
	C603.131042,170.248245 601.707336,172.075729 599.552734,173.060318 
	C597.609802,173.948166 595.757446,173.185333 596.879456,170.975159 
	C598.617371,167.551804 596.713379,165.776520 594.548584,163.540192 
	C593.865051,162.863037 594.516541,163.542297 594.060547,163.056000 
	C593.736450,162.710388 593.736633,162.701508 594.232788,163.270859 
	C595.259644,167.482849 591.973389,168.832748 589.363281,170.921783 
	C588.251343,171.005783 587.502747,171.014496 586.379761,171.026886 
	C586.520874,168.023438 586.811462,165.061584 583.929565,162.768097 
	C581.492493,163.730133 579.691040,166.392288 576.582520,167.504333 
	C575.896301,167.337234 575.686279,167.512482 575.544067,168.214600 
	C574.296814,170.936935 572.458557,171.213104 570.869873,169.258057 
	C568.807983,166.720810 565.839294,165.054230 564.212158,161.749512 
	C564.226746,160.646484 564.485718,159.989532 565.209717,159.194519 
	C566.366272,158.223648 567.486145,158.862152 568.590942,158.368103 
	C568.735901,158.236496 568.952209,158.033844 568.952209,158.033844 
	C568.952209,158.033844 568.840637,158.155655 568.643555,158.285339 
	C567.894226,158.591766 567.329285,158.492523 566.434448,158.496796 
	C565.871460,158.496872 565.642822,158.492538 565.124512,158.293671 
	C564.430115,157.076340 564.809875,156.258301 565.753540,155.261261 
	C566.000000,154.999390 566.000000,155.000000 566.000000,155.000000 
	C567.097839,153.292114 568.829590,152.392258 570.749023,151.210663 
	C570.971130,150.972763 571.000000,151.000000 570.986389,150.985184 
	C571.881714,150.150223 572.737427,149.276382 573.780029,148.157684 
	C577.024658,143.718384 571.937378,143.521851 570.572449,141.897354 
	C568.908997,139.917618 566.346619,139.127594 570.633423,137.520218 
	C571.676758,137.128983 571.985046,136.107712 571.105713,135.085281 
	C569.657166,133.400848 571.366943,132.314178 572.238464,131.956711 
	C575.032043,130.810776 577.009094,128.722778 578.821167,126.573898 
	C579.923157,125.267052 580.326355,126.195221 581.166748,126.485031 
	C582.635864,126.991646 583.075623,129.458755 585.304993,128.610046 
	C586.030396,126.913490 583.415527,126.316856 584.000977,124.353592 
	C584.216125,123.741600 584.498718,123.633171 584.783264,123.518791 
	C585.426025,123.260445 585.858154,123.987976 586.463623,123.834984 
	C585.894836,123.052681 585.224243,122.972809 584.231201,123.773849 
	C582.684509,123.929329 581.163147,124.093788 581.095154,122.150002 
	C581.007568,119.642654 583.973999,119.813858 584.862549,117.973862 
	C585.400391,116.860008 586.504517,117.374687 587.018494,118.555672 
	C587.789001,120.325905 588.862549,120.186378 590.058411,118.958618 
	C590.173523,118.840416 590.384705,118.624420 590.422180,118.649178 
	C594.266663,121.189560 598.039062,122.416504 601.620056,118.184418 
	C601.639465,118.161484 602.467651,118.625984 602.669922,118.997864 
	C603.031677,119.663078 602.737000,120.497734 602.114746,120.675140 
	C599.196350,121.507263 598.455872,124.942116 595.347961,125.954674 
	C594.598083,125.588440 594.194763,125.178932 593.730347,124.780563 
	C594.040833,124.973610 594.275513,125.307800 594.784058,125.788895 
	C594.897095,128.173447 597.811279,128.299698 597.967957,130.662994 
	C597.675537,131.780334 596.137085,131.417648 596.527100,133.046173 
	C597.575500,137.424316 595.707214,139.635544 590.344055,140.270035 
	C588.360352,137.789825 586.963074,137.666428 585.921082,140.837982 
	C585.822144,141.017746 585.750366,141.265686 585.851074,141.136017 
	C586.875916,139.963501 587.939697,139.257645 589.691895,139.761383 
	C592.773499,142.944992 590.285156,144.773132 588.280273,146.845215 
	C588.089844,146.941483 588.059631,147.306168 588.268921,147.223694 
	C588.806274,147.000061 589.135681,146.862091 589.782104,146.651535 
	C590.515625,146.608093 590.905212,146.722946 591.466797,147.131287 
	C591.679932,147.301117 592.086853,147.579208 592.224365,147.759460 
	C592.361877,147.939697 592.455627,148.338791 592.548584,148.136993 
	C592.459167,147.635696 592.202637,147.414322 591.705078,147.003326 
	C591.306702,146.390106 591.211548,145.983704 591.250366,145.231140 
	C593.448242,141.980774 597.437988,145.249481 599.949890,142.415070 
	C600.501526,142.452499 600.716980,142.504532 601.220093,142.706665 
	C604.558899,142.871780 605.128967,140.358124 605.062256,138.391647 
	C604.990967,136.289581 603.520996,134.369934 600.917786,134.437347 
	C598.787354,134.492538 596.718384,134.748260 597.773438,131.253296 
	C601.172424,131.830475 602.319214,127.744164 605.803406,128.274658 
	C606.584961,129.352203 606.409424,130.262543 607.177185,131.236908 
	C607.489563,131.679810 607.613037,131.859985 607.911133,132.320709 
	C608.679932,132.974060 609.014709,134.752075 609.321472,134.025711 
	C610.577576,131.051666 613.483337,129.973999 615.755798,127.709930 
	C616.523438,127.426987 616.984375,127.433273 617.720703,127.777451 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M606.002441,128.003021 
	C606.147705,126.340408 605.398010,124.174088 608.925903,124.186211 
	C610.642639,125.606537 612.266541,126.382072 612.741821,128.501007 
	C612.068909,131.526672 610.520569,132.960892 607.306152,132.224640 
	C606.986023,131.985840 607.000000,132.000076 607.006897,132.007385 
	C605.484619,131.045761 607.097229,129.537476 606.203003,128.218857 
	C606.008240,128.011597 606.002441,128.003006 606.002441,128.003021 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M618.000854,121.666214 
	C617.443176,122.177078 616.886292,122.354477 616.157104,122.775871 
	C614.679626,123.539772 613.872437,122.520248 612.443848,121.517197 
	C612.036499,119.625687 611.907410,118.435356 610.273193,117.846001 
	C608.799377,117.314453 608.811035,116.076180 609.728210,115.062004 
	C610.983521,113.673859 611.326904,115.114708 612.250916,115.776085 
	C614.045349,117.060440 614.694641,119.690315 617.625916,119.993141 
	C618.000061,120.443474 618.000916,120.888107 618.000854,121.666214 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M559.435791,141.333801 
	C562.634338,141.474487 562.028931,142.797104 561.058228,144.479614 
	C560.107544,146.127518 558.028687,147.051270 557.750305,149.874908 
	C556.838440,150.770264 556.178650,150.772903 555.265015,150.232239 
	C555.007324,150.007324 555.000000,150.000000 554.996338,149.996155 
	C553.377808,148.141403 554.148621,146.484497 555.626404,144.595245 
	C555.999390,144.154709 556.155396,143.986359 556.563965,143.589050 
	C557.502991,142.798126 558.280762,142.347061 559.435791,141.333801 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M554.585449,144.358505 
	C554.532776,142.441528 552.465942,140.674026 553.809509,139.494522 
	C555.830688,137.720123 558.391052,135.980362 559.863037,140.691467 
	C560.000000,140.998779 560.000000,141.000000 559.999634,141.000610 
	C559.116150,141.835831 558.119934,142.557068 557.205139,143.791840 
	C556.991150,144.009155 557.000000,144.000000 557.004639,143.995636 
	C556.511169,144.532867 555.895142,144.771088 554.585449,144.358505 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M565.651489,154.960815 
	C565.753052,155.808517 565.506104,156.617661 565.136902,157.724274 
	C564.663635,158.318344 564.261536,158.487946 563.471375,158.444351 
	C562.107056,157.937958 561.281128,157.206421 560.234619,156.226349 
	C559.999146,155.829010 559.998291,155.660706 559.994995,155.239944 
	C559.451904,154.466766 558.936523,153.920547 558.199219,153.198242 
	C558.000000,152.999390 558.000000,153.000000 558.000000,153.000305 
	C557.421387,152.312729 557.270691,151.538559 557.768616,150.338684 
	C558.004883,149.996109 558.000000,149.999496 557.997925,150.002243 
	C561.031006,150.753342 562.390015,153.992462 565.651489,154.960815 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M618.000366,120.000610 
	C618.321289,116.752815 621.010925,115.586433 623.627441,114.014618 
	C623.695557,117.284828 621.325500,118.718689 618.349609,119.961304 
	C617.999207,119.998833 618.000000,120.000000 618.000366,120.000610 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M641.739868,106.214493 
	C643.796814,106.138367 643.879639,101.136314 646.740967,105.005829 
	C645.412415,107.015358 644.304382,108.716202 641.625488,109.128204 
	C641.161804,108.142853 641.323242,107.284485 641.739868,106.214493 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M570.619873,151.004196 
	C570.607483,153.445480 567.920776,153.375610 566.341309,154.945557 
	C566.098022,152.252014 568.343201,151.815948 570.619873,151.004196 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M642.136108,112.680275 
	C641.588318,112.977493 641.150146,112.986595 640.383362,112.996521 
	C639.448792,112.977989 638.897156,112.806030 638.211975,112.210266 
	C638.001282,112.003448 638.000000,112.000000 637.998779,111.999390 
	C637.950073,110.396889 638.156372,108.987862 640.630493,109.011246 
	C641.000427,109.001221 641.000000,109.000000 641.000000,108.999619 
	C641.446472,110.118752 641.854736,111.252296 642.136108,112.680275 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M609.001221,124.001083 
	C608.983948,122.429169 609.120178,120.973228 611.621704,121.020386 
	C611.990662,121.013451 611.997314,121.000282 611.992004,121.004440 
	C612.599182,121.709038 612.801086,122.513466 612.390808,123.801987 
	C611.416626,124.733109 610.590759,124.802490 609.358887,124.241104 
	C609.000000,123.998901 609.000000,124.000000 609.001221,124.001083 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M632.574585,112.349571 
	C632.133179,110.903244 631.752502,109.433083 633.395874,109.244667 
	C634.745483,109.089935 634.898499,110.234863 634.991516,111.633606 
	C635.000000,112.000916 635.000000,112.000000 635.000000,111.999710 
	C634.497864,112.536217 633.877747,112.761398 632.574585,112.349571 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M580.168091,119.480850 
	C579.726685,120.354469 579.195801,120.888191 578.598694,120.405174 
	C577.858521,119.806412 578.031067,118.865578 578.755432,118.393646 
	C579.448425,117.942101 580.299683,117.937630 580.168091,119.480850 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M573.641479,147.971283 
	C573.960999,149.507462 573.298950,150.590134 571.318726,150.944916 
	C571.037415,149.424866 571.723938,148.369125 573.641479,147.971283 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M551.987061,146.987442 
	C552.048340,145.844498 551.794678,144.560059 553.663696,144.058990 
	C554.008545,144.007965 553.999084,143.998871 553.995117,143.994919 
	C554.866333,145.552872 555.008179,146.869370 552.435242,147.219086 
	C552.025024,147.023392 551.999878,146.999741 551.987061,146.987442 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M629.998779,113.998856 
	C630.079285,113.094284 630.315002,112.300392 631.679688,112.040207 
	C632.000000,111.999084 632.000000,112.000000 632.000000,112.000458 
	C632.532776,112.523659 632.784546,113.155350 632.628418,114.239304 
	C632.402405,114.780304 632.285278,114.984940 631.825928,115.280487 
	C630.998474,115.277679 630.639343,115.018707 630.215332,114.284744 
	C630.002441,114.003769 630.000000,114.000160 629.998779,113.998856 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M631.852234,106.385712 
	C631.573792,106.961189 631.269897,107.268936 630.966003,107.576683 
	C630.783203,107.215530 630.367981,106.765831 630.464966,106.511261 
	C630.680725,105.944916 631.101440,105.283180 631.852234,106.385712 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M623.998779,113.998169 
	C624.088440,113.360863 624.085449,112.635010 624.912354,112.500298 
	C625.087402,112.471771 625.326233,112.834419 625.535706,113.016800 
	C625.214233,113.323364 624.892761,113.629944 624.287109,113.969978 
	C624.002869,114.003426 624.000000,114.000000 623.998779,113.998169 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M215.442062,472.719543 
	C214.586273,472.979523 214.088730,472.980072 213.218018,472.984436 
	C211.228867,472.312256 209.347855,473.179016 207.629776,471.828796 
	C207.149612,470.330444 207.570999,469.288574 208.386383,468.032104 
	C209.577682,465.220093 207.377243,466.649811 206.963364,466.689972 
	C197.876297,467.571838 188.760727,467.106781 179.303589,467.372498 
	C172.616257,467.268372 166.309998,468.199738 159.981781,467.408173 
	C159.425003,466.231537 158.862244,465.427551 158.166946,464.358276 
	C157.886627,463.969208 157.738861,463.845428 157.587616,463.435303 
	C158.033539,461.997620 157.334152,461.932709 156.189941,462.062805 
	C154.956879,462.259460 154.051422,461.954926 153.133118,461.987946 
	C152.468262,462.011871 152.276230,462.358307 152.906006,462.139618 
	C153.535782,461.920929 152.745087,462.997742 153.063324,462.799011 
	C151.542236,464.368744 150.286926,463.311768 148.919815,462.957458 
	C145.940475,462.185333 142.882217,461.442932 140.308807,464.691101 
	C139.907288,464.962372 139.724945,464.973053 139.268646,464.986633 
	C138.112061,464.065887 137.307495,463.023590 135.544800,462.935608 
	C132.389740,463.767273 129.380966,462.953766 126.363205,464.151733 
	C125.819321,464.922119 125.479897,465.437439 124.782547,466.250793 
	C124.424614,466.548798 124.645103,466.121368 124.571014,466.350159 
	C124.166786,466.170044 123.836647,465.761200 123.172333,465.139740 
	C121.848732,463.692810 120.388519,464.389740 118.843979,464.010254 
	C116.617325,463.541321 114.730949,463.851898 112.459656,463.988098 
	C108.550713,463.626495 105.075836,464.572083 101.270012,464.089874 
	C100.983154,462.860687 100.984879,461.928162 100.981369,460.645905 
	C101.690880,458.623352 103.366287,459.032318 105.350212,458.340912 
	C103.608170,458.232880 102.470444,458.149567 101.264740,457.332123 
	C101.023216,456.004211 101.013351,454.910339 101.002762,453.406250 
	C102.689598,451.322968 104.845917,451.729340 106.963127,451.628784 
	C105.478912,451.026093 103.750107,451.528534 102.218201,450.207550 
	C102.303566,448.974091 102.620033,447.990662 103.176590,446.903442 
	C103.975113,446.027283 104.693916,445.531738 106.006920,445.418152 
	C106.926201,445.069824 107.549271,445.431458 108.142746,445.247345 
	C107.655602,445.021332 107.145508,445.214905 106.322815,445.244293 
	C105.054604,445.458527 104.219582,445.254669 103.292519,444.326172 
	C102.929115,442.985474 103.261421,441.678802 101.446182,441.069122 
	C101.079140,440.553711 101.054771,440.101929 101.128387,439.321716 
	C101.753098,438.439636 102.405197,438.221405 103.483162,438.389465 
	C105.050949,439.090698 106.379860,438.991943 107.958694,438.999084 
	C108.496521,439.032623 108.939102,438.938110 108.919464,438.808075 
	C108.820480,438.152924 109.290260,438.881989 108.366150,438.915161 
	C107.087303,438.980865 106.065109,439.032562 104.741486,438.687683 
	C104.230286,438.441437 104.031670,438.326996 103.668945,437.906647 
	C103.245483,436.219910 102.963806,434.839844 103.534515,433.129181 
	C103.879402,432.673584 104.056618,432.525879 104.550507,432.249908 
	C106.147125,432.018463 107.361740,431.523834 108.654022,431.495850 
	C107.557663,431.387146 106.539101,431.905182 105.110062,431.835419 
	C104.069206,431.536072 103.530571,431.103668 102.934937,430.184448 
	C102.754524,429.059845 102.834442,428.185333 103.036354,427.001038 
	C103.429550,426.676422 103.700745,426.661591 104.324463,426.443726 
	C106.168327,425.469757 107.801910,425.680603 109.765121,425.562622 
	C112.803444,425.645416 115.317497,424.947388 118.107941,423.956116 
	C118.621902,423.720154 118.835510,423.650269 119.379158,423.571350 
	C120.713371,423.925049 121.691223,424.128143 122.721436,422.887634 
	C124.693947,421.573914 126.569954,421.606720 128.817261,421.984406 
	C131.081436,423.027069 132.958725,424.340851 135.530518,422.804749 
	C136.057434,422.624542 136.279800,422.585907 136.838379,422.593445 
	C139.328964,423.741272 141.531647,423.329224 144.079910,422.795837 
	C147.675247,422.072296 151.003265,423.018127 154.594162,422.187073 
	C161.660446,421.162262 168.545883,422.345978 175.501953,420.377869 
	C175.995483,420.088074 176.191101,419.969543 176.702850,419.727966 
	C177.240768,419.589691 177.462570,419.574493 178.003555,419.632874 
	C179.859299,420.728638 181.005875,420.120758 182.199692,418.587463 
	C182.734848,418.051270 183.111145,417.851593 183.851013,417.791992 
	C185.338715,419.237427 186.792877,419.916046 188.960938,419.637207 
	C190.959091,419.585205 192.510544,418.926361 194.511444,418.714447 
	C195.118301,418.661560 195.361862,418.648438 195.971191,418.627472 
	C198.513947,418.635071 200.690826,418.671051 203.213699,418.639557 
	C203.786057,418.614929 204.012680,418.603027 204.572876,418.557037 
	C205.580597,418.408020 206.146164,418.031586 207.085968,417.662598 
	C207.650604,417.584534 207.882782,417.599640 208.445465,417.730957 
	C212.478104,418.998566 216.159500,419.248322 220.182312,417.515533 
	C220.836212,417.472961 221.104919,417.508667 221.735779,417.751495 
	C224.293594,421.435120 222.723557,425.137299 222.363907,428.598206 
	C220.962982,442.078888 219.005585,455.499390 217.401184,468.960663 
	C217.242874,470.288818 216.961044,471.580872 215.442062,472.719543 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M105.317131,426.748322 
	C104.753471,426.947510 104.432068,426.912109 103.634506,426.783966 
	C103.832535,422.175690 104.506721,417.660126 105.493011,412.877838 
	C106.666786,412.004913 107.444374,412.269226 108.585548,413.018311 
	C108.653275,414.407806 108.327644,415.620605 107.994843,417.151733 
	C107.959732,418.144989 108.162003,418.785950 108.309402,419.771606 
	C108.397247,421.215424 108.587463,422.314636 108.627365,423.763672 
	C108.263779,425.760162 106.652466,425.810364 105.317131,426.748322 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M103.697594,432.793579 
	C104.120506,434.185120 104.254517,435.380524 104.193535,436.790009 
	C103.463272,437.399780 102.869194,437.532623 101.831543,437.126099 
	C101.603088,435.813568 101.759476,434.777893 102.036285,433.366638 
	C102.506577,432.645294 102.927002,432.523956 103.697594,432.793579 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M104.214355,432.986664 
	C103.579956,432.991180 103.173424,432.992615 102.461800,432.992554 
	C102.207924,432.148285 102.259140,431.305481 102.492477,430.198486 
	C103.269714,430.227386 103.864815,430.520416 104.774231,430.924133 
	C105.422722,431.456696 105.530052,431.930054 105.153671,432.735352 
	C104.896805,433.015900 104.442207,432.983551 104.214355,432.986664 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M101.307495,437.090454 
	C102.013405,436.895813 102.580101,436.942383 103.572670,436.996521 
	C103.998543,437.004120 103.989517,437.491852 103.988106,437.735748 
	C104.080643,438.225922 104.174591,438.472168 103.897629,438.855164 
	C102.951622,438.993439 102.376541,438.994934 101.513916,438.994843 
	C101.207016,438.439423 101.187653,437.885559 101.307495,437.090454 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M310.988220,118.628036 
	C310.527344,119.321037 310.055450,119.635826 309.286194,119.970108 
	C308.639587,119.684265 308.529144,119.275208 308.487976,118.836067 
	C308.400513,119.062767 308.465302,119.307655 308.197815,119.764465 
	C304.904236,121.073914 305.456512,122.720604 307.550446,124.174957 
	C309.747437,125.700905 311.811401,127.222794 312.821808,129.870132 
	C308.854584,132.044739 305.997406,127.743340 302.213287,128.740356 
	C301.764862,129.125580 301.520264,129.218582 301.262878,129.271103 
	C301.000427,129.324646 301.087311,129.326141 301.762970,129.141098 
	C303.956238,131.591751 302.347992,132.601181 300.060547,132.918335 
	C298.117706,133.187729 296.160461,133.102631 294.211456,133.680222 
	C292.031769,134.326202 291.997559,133.616440 291.047150,131.332733 
	C290.219421,129.343979 288.363800,127.706291 286.050079,126.645103 
	C284.422089,128.512939 285.707672,130.279129 286.632080,131.487320 
	C289.255524,134.916122 286.906647,134.900635 284.485260,134.989960 
	C283.330048,135.032562 282.054474,135.319244 281.035400,134.945114 
	C276.375092,133.234085 272.235474,137.294235 267.333313,136.003540 
	C267.636810,132.128662 270.409943,129.636124 273.292053,127.659637 
	C275.286041,126.292198 277.005463,125.002693 277.906982,122.794800 
	C278.335724,121.744827 278.657898,121.287636 280.041382,121.581421 
	C282.096680,122.017876 282.408173,121.703690 281.827850,119.926353 
	C281.306030,118.328140 281.679810,118.177887 283.019653,118.515778 
	C283.963287,118.753754 284.736877,118.780258 284.351044,117.453583 
	C284.141022,116.731560 282.572388,115.309502 284.434448,115.633057 
	C285.833862,115.876228 288.276337,114.262520 288.965271,117.001358 
	C289.796143,120.304405 292.094055,118.689178 293.821198,118.351280 
	C297.329803,117.664848 298.838684,113.857666 303.131927,113.357399 
	C308.006073,112.789452 309.726410,114.414940 310.988220,118.628036 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M367.176514,118.726387 
	C365.178314,119.463539 363.054108,119.547188 363.043640,122.577820 
	C361.371124,126.471130 356.638214,126.059196 355.301086,125.535545 
	C350.636139,123.708572 345.592804,129.783890 341.564606,124.490997 
	C333.674042,126.376587 336.487640,120.424393 335.998077,116.439407 
	C335.450836,115.082680 335.701233,114.052849 335.776489,112.539673 
	C338.093170,112.069000 341.385956,111.125153 338.331268,116.039391 
	C339.899139,112.422043 344.353333,112.428719 344.371307,108.576950 
	C344.373169,108.180878 345.237396,107.569626 345.788544,107.445831 
	C346.652740,107.251732 346.858337,108.038864 346.863251,108.724358 
	C346.892487,112.804466 349.750031,111.666771 352.040100,111.535263 
	C354.051270,111.419769 356.380951,109.719322 357.342102,113.380478 
	C357.889801,115.466858 359.930420,113.758362 361.606445,113.989807 
	C364.678894,114.355675 366.553467,115.761093 367.176514,118.726387 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M367.043488,119.351044 
	C365.240540,117.697098 364.614410,115.233612 362.135406,114.242897 
	C363.756897,112.996338 366.194733,113.084633 367.359955,110.760063 
	C366.481232,108.818100 364.401489,109.253174 362.518829,108.636238 
	C365.892120,106.249229 369.466827,105.472748 373.151215,104.729973 
	C374.677246,104.422318 375.945312,102.846283 377.345673,101.868607 
	C377.411011,101.822998 377.662079,101.954887 377.756958,102.064468 
	C377.856445,102.179443 377.871948,102.367172 377.959869,102.797089 
	C376.931183,104.963791 376.569885,106.908791 377.812561,108.977936 
	C378.067047,109.001701 378.368988,109.311234 378.453247,109.509949 
	C378.537537,109.708672 378.926300,109.915298 379.094330,110.061142 
	C379.262360,110.206985 379.274445,110.654083 379.141693,110.834045 
	C379.013275,111.181030 379.017609,111.348045 379.021118,111.765663 
	C378.879211,112.425781 378.936401,112.811607 379.144440,113.496826 
	C376.169495,116.220169 371.467010,114.859482 369.031799,118.734680 
	C370.271271,118.996620 371.545074,118.996620 372.818909,118.996620 
	C370.908081,119.361893 369.238617,122.437279 367.043488,119.351044 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M209.362335,126.158775 
	C209.031418,125.981155 209.009689,125.762466 208.929703,125.218918 
	C208.397827,119.852486 212.949036,120.576508 215.223389,120.455643 
	C217.558456,120.331566 219.968567,119.602203 223.143845,119.945312 
	C226.449921,118.175255 229.341187,118.153450 232.616730,118.014572 
	C232.558853,120.455986 231.331329,121.333542 228.845291,120.410370 
	C226.441071,119.517578 225.090988,120.523094 225.008484,123.498383 
	C225.143341,124.087921 225.277390,124.300461 225.275208,124.865173 
	C223.461349,126.592445 221.355438,126.240135 219.079651,126.748138 
	C215.802994,125.456528 212.487167,128.819000 209.362335,126.158775 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M333.134644,115.686790 
	C332.062347,116.889328 331.124207,117.773239 330.226135,118.619362 
	C327.930573,117.504944 330.372925,115.749260 329.001953,114.134720 
	C328.446808,116.444351 325.837402,115.448509 325.054688,116.960114 
	C323.556335,119.853905 321.386902,119.216286 319.047455,118.301178 
	C319.346313,117.463936 319.825592,116.961670 319.996277,116.370338 
	C320.604218,114.263924 320.034607,111.120193 322.704041,110.597580 
	C326.782959,109.799011 330.878052,107.745766 335.179596,109.497849 
	C335.601471,109.669678 335.713470,110.602242 335.988159,111.587494 
	C336.007019,111.993286 336.000214,111.999931 335.997864,112.002151 
	C334.579010,112.714157 333.050476,113.333145 333.134644,115.686790 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M219.026489,126.976761 
	C220.247681,125.180992 222.265091,125.241745 224.627121,125.096886 
	C225.809128,124.431274 226.586349,124.985893 227.698303,125.097275 
	C228.176239,125.174286 228.346924,125.191322 228.749878,125.097633 
	C234.028961,124.741371 237.674393,128.294159 242.280411,130.070648 
	C243.113022,131.263794 243.869385,132.116760 244.276413,133.190277 
	C244.347672,133.378220 244.425339,133.452545 244.425995,133.451080 
	C244.492188,133.303955 244.558777,133.157013 244.864548,132.799652 
	C245.311218,132.525284 245.518692,132.461319 246.056793,132.414398 
	C246.590851,132.523193 246.794327,132.614960 247.189972,132.983459 
	C247.323776,133.477585 247.265411,133.694962 247.093994,134.230499 
	C246.536713,135.320267 248.337784,138.092422 245.224380,136.487869 
	C240.980148,134.300491 235.280914,135.058548 232.387115,130.105942 
	C231.937286,129.336075 231.099976,129.303818 230.199646,129.335144 
	C226.406235,129.467102 222.829788,128.431656 219.026489,126.976761 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M242.443420,131.060455 
	C237.924805,128.959854 233.425415,127.902412 229.319519,125.123901 
	C230.781479,120.610947 233.806915,125.109825 236.450150,123.966980 
	C237.465714,123.976151 238.090530,123.990280 239.027542,123.926704 
	C239.338943,123.897171 239.573486,123.873528 239.690186,123.890129 
	C240.399765,124.222794 240.470932,124.798454 240.659302,125.639160 
	C241.064148,125.980919 241.347717,126.059654 242.062225,126.234116 
	C242.723190,126.366348 242.953247,126.402863 243.476868,126.628906 
	C244.730835,128.064209 246.323624,127.326729 247.770981,128.019974 
	C252.700562,128.378677 251.701279,130.374741 249.184509,133.010406 
	C248.458862,133.644348 248.008621,134.005234 247.269653,134.457382 
	C246.946426,134.329803 246.911911,134.110992 246.845032,133.561478 
	C246.783707,132.873749 246.598724,132.623810 246.110794,132.644272 
	C245.936432,132.826447 245.478409,132.939850 245.243134,132.922363 
	C244.670822,132.701767 244.345184,132.481964 243.798218,132.095947 
	C243.289062,131.733505 243.059158,131.478622 242.443420,131.060455 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M362.159729,97.540298 
	C369.715118,95.556885 377.692780,97.020607 385.515198,94.276833 
	C385.953613,94.650955 385.997559,94.992920 386.058594,95.596390 
	C385.517090,99.463898 382.906433,98.441574 380.329102,98.138031 
	C379.793884,97.736458 379.681274,97.256477 379.093384,97.837547 
	C378.763428,98.202339 378.537933,98.416252 378.185974,98.831581 
	C375.524567,99.905174 373.126526,98.047371 370.311768,98.776367 
	C369.835815,98.859581 369.666199,98.854958 369.245239,98.890015 
	C367.001404,98.988159 365.008972,99.046631 362.597687,99.114143 
	C362.177887,98.700890 362.176941,98.278587 362.159729,97.540298 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M248.863800,133.624420 
	C248.417206,131.737793 253.084946,129.703903 248.267822,128.295959 
	C249.808929,124.163338 251.077240,129.578659 252.931259,128.321609 
	C253.533981,127.912956 254.783081,129.323242 254.574829,130.275757 
	C254.190689,132.032608 252.385681,131.894714 250.895218,132.276611 
	C252.490891,133.838959 254.659882,134.836029 254.987579,137.654663 
	C251.876144,138.283798 250.649521,135.663803 248.863800,133.624420 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M380.115540,98.284058 
	C381.639099,96.527855 384.205017,98.283104 385.908142,96.126167 
	C386.492889,95.888023 386.910065,95.918167 387.641479,95.930344 
	C388.638641,96.601532 388.756714,97.412498 388.229218,98.669418 
	C386.285431,98.671204 385.998291,100.623634 384.428223,101.092644 
	C383.188873,101.669418 382.676392,102.688370 381.370361,103.168442 
	C380.874603,103.326317 380.668518,103.364632 380.228699,103.192574 
	C379.994995,102.982201 379.969025,102.574425 379.966095,102.370148 
	C379.858154,101.960846 379.753174,101.755814 379.840942,101.264038 
	C381.190552,100.259819 380.738708,99.405945 380.115540,98.284058 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M262.169617,130.859314 
	C261.017853,133.764343 257.690216,131.988907 256.348907,135.052399 
	C255.455505,130.060669 258.854340,129.235077 261.288879,128.295456 
	C262.951080,127.653938 262.684418,129.423157 262.169617,130.859314 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M269.765991,117.977936 
	C273.832306,118.033638 272.885712,122.013016 274.799744,123.647064 
	C274.486481,123.955589 274.207397,124.476112 273.853638,124.533073 
	C272.771362,124.707375 269.130493,119.281631 269.765991,117.977936 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M314.060181,118.670410 
	C313.569366,119.687706 313.043335,120.014114 312.147278,119.220047 
	C311.350983,116.134537 313.318665,115.069839 315.696259,114.038986 
	C316.447418,115.915039 314.775330,116.898758 314.060181,118.670410 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M267.852661,126.744728 
	C264.619690,125.826202 267.319550,123.396935 266.595337,121.659683 
	C268.797302,122.777527 267.650452,124.810341 267.852661,126.744728 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M358.365173,106.488434 
	C359.560730,106.227730 360.604645,106.610374 360.359680,107.469093 
	C360.105927,108.358643 358.772766,108.939293 357.869080,108.526413 
	C356.783966,108.030663 357.443390,107.214073 358.365173,106.488434 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M345.167572,100.852646 
	C346.443756,99.586189 348.394989,100.239281 350.614075,100.025909 
	C349.524048,102.473061 347.337250,100.344772 345.167572,100.852646 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M227.962738,124.871201 
	C227.125595,126.032532 226.329987,125.531288 225.255783,124.955643 
	C224.975861,124.733780 224.976013,124.562202 224.992737,124.132996 
	C225.897079,124.450043 227.335190,122.767906 227.962738,124.871201 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M243.823624,126.439453 
	C243.419998,126.737877 243.069565,126.657333 242.606155,126.453308 
	C242.807068,125.316887 243.120972,124.303932 243.710938,123.140091 
	C243.950272,124.012962 243.913544,125.036728 243.823624,126.439453 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M235.220688,117.876205 
	C235.040894,117.126305 235.154510,116.375313 235.268127,115.624321 
	C235.755508,115.920509 236.242859,116.216690 236.878876,116.778908 
	C236.523056,117.321663 236.018585,117.598389 235.220688,117.876205 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M357.215515,99.790344 
	C357.612213,97.816513 358.710876,99.129265 359.901001,99.663719 
	C359.262177,99.860672 358.442169,99.856247 357.215515,99.790344 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M315.996582,113.996552 
	C316.140869,113.104622 315.674988,112.024246 316.777771,111.441551 
	C316.866852,111.394485 317.174316,111.564209 317.172638,111.569725 
	C316.956879,112.275833 316.721588,112.975975 316.246674,113.840210 
	C316.006073,114.003998 315.999878,113.999817 315.996582,113.996552 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M337.404114,108.960030 
	C337.802002,108.229370 338.203583,108.222710 338.558990,108.742233 
	C338.633667,108.851349 338.632385,109.103790 338.555389,109.209747 
	C338.185760,109.718239 337.784180,109.699287 337.404114,108.960030 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M239.136597,123.663086 
	C238.739578,124.533897 238.157257,125.234863 237.013626,124.196457 
	C237.383789,123.103821 238.101761,123.024689 239.136597,123.663086 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M329.281250,102.934128 
	C329.531525,102.008537 330.468109,102.145416 331.689941,102.140244 
	C331.222626,102.415497 330.417725,102.676514 329.281250,102.934128 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M316.697723,118.030418 
	C316.951324,118.991501 316.749451,119.766037 315.243195,119.086700 
	C315.464874,118.679382 315.933411,118.364449 316.697723,118.030418 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M369.089661,99.098602 
	C369.263519,98.810944 369.533234,98.692200 369.904175,98.718834 
	C369.840637,99.219223 369.700104,99.623619 369.089661,99.098602 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M379.986694,103.229187 
	C380.161377,102.941086 380.327759,102.899979 380.745117,102.803436 
	C381.491852,102.689957 381.872314,102.880547 382.134033,103.631348 
	C381.641235,103.987633 381.168365,103.997017 380.340515,103.988388 
	C379.985504,103.970383 379.978363,103.476173 379.986694,103.229187 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M317.755127,116.170883 
	C317.828400,116.553284 317.659241,117.102715 317.250061,117.820808 
	C317.177582,117.438950 317.345154,116.888428 317.755127,116.170883 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M240.855835,125.606537 
	C240.523590,125.417160 240.266586,124.932144 239.908234,124.176926 
	C239.806870,123.906731 240.287109,123.796021 240.701324,123.949509 
	C241.054047,124.505630 240.992569,124.908257 240.855835,125.606537 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M378.258606,98.906570 
	C378.143311,98.700958 378.324097,98.442207 378.795410,98.122581 
	C378.911865,98.325386 378.734802,98.589294 378.258606,98.906570 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M379.827942,101.056732 
	C380.027496,101.175156 380.021301,101.373032 379.989136,101.868393 
	C379.773499,101.948326 379.561890,101.744530 379.410645,101.502922 
	C379.375488,101.446823 379.546204,101.261864 379.827942,101.056732 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M275.468506,118.453308 
	C275.522278,118.421532 275.414734,118.485092 275.468506,118.453308 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M265.455078,118.532211 
	C265.425781,118.481178 265.484344,118.583252 265.455078,118.532211 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M359.453857,112.529160 
	C359.422516,112.476044 359.485168,112.582268 359.453857,112.529160 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M240.862518,123.855972 
	C240.997162,123.572594 241.214920,123.372780 241.432678,123.172958 
	C241.465851,123.415543 241.499023,123.658127 241.323868,124.001862 
	C241.115524,124.102997 240.945648,123.939529 240.862518,123.855972 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M259.549438,119.473511 
	C259.579590,119.525146 259.519287,119.421867 259.549438,119.473511 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M362.412903,106.571388 
	C362.350739,106.485886 362.586395,106.450783 362.586395,106.450783 
	C362.586395,106.450783 362.475067,106.656891 362.412903,106.571388 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M262.545532,122.471451 
	C262.575287,122.522934 262.515778,122.419975 262.545532,122.471451 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M250.369843,122.570320 
	C250.277725,122.451347 250.607437,122.385437 250.607437,122.385437 
	C250.607437,122.385437 250.461945,122.689293 250.369843,122.570320 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M244.004013,123.005310 
	C244.105316,122.984146 244.201981,122.957146 244.142822,122.959671 
	C243.986984,122.989197 243.999374,122.999474 244.004013,123.005310 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M342.962524,151.667053 
	C339.609985,151.096085 340.293243,155.707596 337.355957,155.952057 
	C336.997406,155.997284 337.000000,156.000000 337.001312,156.001465 
	C336.400848,153.110275 338.046631,151.337418 340.160919,149.880112 
	C341.880035,148.695175 342.451355,149.992828 342.962524,151.667053 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M322.809448,145.897446 
	C323.026550,146.451492 323.020111,146.895813 323.010315,147.673584 
	C319.820801,148.113770 318.815186,146.088806 318.741455,143.190308 
	C319.539642,143.159439 320.092468,143.330994 320.817200,143.742035 
	C321.229889,144.192780 321.447968,144.425369 321.820435,144.840240 
	C322.110229,145.325790 322.306366,145.587967 322.809448,145.897446 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M328.812164,143.331406 
	C330.161560,143.246719 332.026031,142.367630 332.273254,143.880646 
	C332.533112,145.471024 330.710907,144.750214 329.411377,144.990341 
	C328.643433,144.628891 328.495117,144.179047 328.812164,143.331406 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M348.963959,151.660919 
	C348.250610,151.997177 347.500000,151.995575 346.375305,151.997589 
	C346.176971,151.025833 345.611969,149.559906 347.209473,149.442230 
	C348.241516,149.366196 348.705017,150.364639 348.963959,151.660919 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M345.999390,151.999390 
	C345.921387,153.138519 345.658844,154.314743 344.404144,154.542831 
	C343.051666,154.788681 343.119293,153.583908 343.007568,152.341080 
	C343.002441,151.997559 343.000000,152.000000 342.998779,152.001221 
	C343.748474,151.999603 344.499390,151.996780 345.625763,151.997589 
	C346.001221,152.001221 346.000000,152.000000 345.999390,151.999390 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M340.209595,162.717239 
	C340.478516,161.279388 341.163574,160.822021 342.208405,161.465042 
	C342.448486,161.612808 342.581512,162.360031 342.425415,162.647766 
	C341.916290,163.586105 341.185516,164.052414 340.209595,162.717239 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M329.012085,142.766998 
	C329.022186,143.457123 329.022247,143.896439 329.034668,144.665161 
	C328.587860,144.996597 328.128693,144.998627 327.325684,144.999496 
	C326.819061,144.831055 326.656219,144.663757 326.743225,144.251083 
	C326.996521,143.560455 326.999969,143.115234 327.003052,142.336121 
	C327.446350,142.002029 327.890015,142.001801 328.666321,142.007904 
	C329.000031,142.181534 329.001038,142.348862 329.012085,142.766998 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M334.000610,146.000305 
	C334.069550,144.856354 333.805450,143.556793 335.702759,143.056671 
	C336.370575,143.394455 336.509094,143.836456 336.272583,144.641205 
	C335.590759,145.281998 335.103149,145.616714 334.307190,145.975403 
	C333.998779,145.999390 334.000000,146.000000 334.000610,146.000305 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M336.413391,144.955994 
	C336.066620,144.516800 336.054871,144.086288 336.047150,143.332474 
	C336.927216,143.140976 338.212616,142.688919 338.440735,143.905136 
	C338.652435,145.033951 337.472076,144.834946 336.413391,144.955994 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M348.999390,152.000610 
	C349.637268,152.082611 350.355957,152.085648 350.498871,152.905792 
	C350.529114,153.079422 350.169586,153.320953 349.989655,153.531204 
	C349.684875,153.209183 349.380096,152.887161 349.038269,152.281967 
	C349.001221,151.998779 349.000000,152.000000 348.999390,152.000610 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M326.752747,143.917038 
	C326.993042,144.005692 326.993103,144.502106 326.987488,144.750229 
	C326.297882,144.874817 325.451721,144.980179 325.437042,143.936951 
	C325.436584,143.905823 326.138153,143.864792 326.752747,143.917038 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M358.985474,169.010895 
	C358.858582,168.872452 358.744995,168.723236 358.631439,168.574005 
	C358.720276,168.618713 358.809082,168.663422 358.959137,168.840942 
	C359.020355,168.973740 358.998749,169.000137 358.985474,169.010895 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M321.887238,144.780121 
	C321.665100,144.905029 321.397339,144.716827 321.091705,144.209045 
	C321.312073,144.091705 321.574677,144.284225 321.887238,144.780121 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M530.234253,93.939888 
	C527.234558,92.931305 530.775208,92.263649 530.142029,91.223640 
	C530.003784,90.996635 530.818054,90.828293 531.080017,91.305077 
	C531.630676,92.307220 532.310059,93.384956 530.234253,93.939888 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M527.758057,90.984055 
	C527.589966,91.094513 527.421021,91.040604 527.252075,90.986710 
	C527.420471,90.931046 527.588806,90.875374 527.758057,90.984055 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M502.050446,90.632248 
	C501.930023,90.920181 501.738922,90.933258 501.261047,90.965439 
	C501.072784,90.396065 501.208252,89.866837 502.050446,90.632248 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M151.258286,406.305206 
	C151.020950,405.383636 151.015945,404.690857 151.014999,403.651672 
	C153.070892,401.627106 155.534515,402.119415 158.261688,402.002502 
	C160.071274,401.989777 161.529755,402.119537 163.074509,401.001770 
	C163.583328,400.727356 163.796738,400.638245 164.350418,400.491852 
	C166.090515,400.355804 167.314651,400.964050 168.906509,401.438904 
	C170.386856,401.251099 171.328278,400.524994 172.792206,400.129639 
	C174.962280,400.105072 176.811996,399.657196 178.757767,400.912415 
	C178.991180,401.630188 178.995377,402.021851 179.000687,402.707275 
	C179.913513,407.295624 176.240814,405.702545 174.090652,406.667847 
	C173.471405,406.858643 173.220688,406.919800 172.590210,407.038910 
	C171.459686,407.164825 170.713791,407.119354 169.623871,406.927094 
	C165.039215,404.771667 161.684280,408.609070 157.427994,408.667999 
	C156.666870,408.883423 156.222107,408.961548 155.430328,408.989594 
	C154.639282,408.956665 154.191147,408.906799 153.434799,408.700256 
	C152.272079,408.139679 152.030350,407.217621 151.258286,406.305206 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M159.368927,394.724548 
	C153.317139,397.667877 147.268402,394.687439 141.315826,396.013733 
	C146.810959,393.892151 152.444305,393.899017 158.546722,394.010315 
	C159.176407,394.142273 159.347031,394.284363 159.368927,394.724548 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M192.428650,393.200195 
	C189.821381,394.180359 187.189224,394.717865 184.908768,392.960449 
	C183.101013,391.567261 182.174240,394.900085 180.175995,393.471252 
	C179.035889,393.046600 178.161209,392.845367 177.587128,391.800842 
	C181.786301,391.292206 185.982224,391.113892 190.520081,390.831482 
	C191.013504,390.841431 191.164993,390.955505 191.410522,391.331116 
	C191.645126,392.169495 192.070572,392.535583 192.428650,393.200195 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M202.943329,405.092285 
	C202.622635,405.129639 202.351395,405.216980 202.227219,405.147095 
	C201.894867,404.916687 201.686676,404.756104 201.721695,404.285095 
	C205.890472,403.022003 209.814957,402.050018 213.935364,403.658875 
	C214.461884,404.216766 214.808594,404.532074 215.072540,405.330444 
	C212.667465,406.038757 210.238708,406.295807 207.497894,405.228271 
	C205.845322,404.976410 204.554901,404.976105 202.943329,405.092285 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M218.248871,390.101929 
	C216.238083,390.661072 214.455170,390.802704 212.669815,390.899292 
	C211.223129,390.977600 209.926025,390.671295 210.065765,388.855225 
	C210.207108,387.018127 211.455963,387.140228 212.931137,387.270966 
	C214.530884,387.412750 216.179276,387.055939 217.575119,388.771301 
	C218.074326,389.145508 218.275009,389.405212 218.248871,390.101929 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M171.787109,406.471985 
	C172.177124,406.146576 172.340240,406.067596 172.761551,405.903625 
	C176.067047,405.286560 179.131577,405.392822 182.601471,405.795654 
	C183.161987,406.149841 183.319061,406.279236 183.758179,406.510376 
	C182.910980,408.072632 181.356445,408.216675 179.348267,408.072266 
	C177.330017,408.381073 175.592804,408.434967 173.898499,409.717285 
	C173.595764,409.825287 173.480835,409.764252 173.426102,409.799438 
	C172.435654,409.569366 171.909912,408.888885 171.495667,407.707855 
	C171.479584,407.157715 171.519897,406.938049 171.787109,406.471985 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M123.235123,398.287354 
	C125.873817,394.194214 129.329132,396.595917 132.568924,396.717865 
	C129.768433,398.909943 126.525078,398.263580 123.235123,398.287354 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M160.225586,402.452301 
	C157.310104,402.834412 154.603271,402.961670 151.457733,403.197083 
	C150.251678,403.242767 149.484314,403.180298 148.347992,403.007690 
	C147.979050,402.897552 148.015442,402.463867 148.018768,402.246246 
	C151.698349,401.160400 155.419815,401.005096 159.587280,401.180328 
	C160.347794,401.350403 160.482025,401.740082 160.225586,402.452301 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M202.052734,389.004150 
	C204.506226,389.097778 206.779861,387.999878 208.598572,390.442902 
	C204.690323,393.234131 201.469681,388.309570 197.838669,389.246185 
	C199.101761,389.162201 200.364868,389.078217 202.052734,389.004150 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M180.762146,399.447144 
	C182.288727,397.027466 184.464371,398.521301 186.599915,398.029572 
	C187.481873,398.411713 188.029037,398.712799 188.142151,399.615875 
	C186.066132,401.276184 183.818893,400.771393 181.232452,400.794037 
	C180.567139,400.432831 180.473694,400.067261 180.762146,399.447144 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M188.482574,399.936035 
	C187.736038,399.456909 187.429718,399.010834 187.071350,398.297852 
	C190.118988,398.165436 193.345856,396.970917 197.096039,398.947479 
	C193.987564,400.420410 191.414169,399.908356 188.482574,399.936035 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M159.673431,394.253662 
	C163.108414,392.725952 166.425156,393.462860 169.771484,393.867584 
	C166.942673,396.009796 163.691254,394.698273 160.242432,395.171143 
	C159.712021,394.883881 159.638931,394.704041 159.673431,394.253662 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M180.535339,399.105896 
	C180.910583,399.570190 180.852493,399.906921 180.803528,400.503296 
	C180.402481,400.852081 179.992310,400.941162 179.284546,401.134369 
	C176.977798,401.141785 174.968628,401.045074 172.530396,400.890442 
	C171.755188,400.496155 171.601242,400.087341 171.830368,399.317261 
	C174.714859,399.011688 177.408432,398.994995 180.535339,399.105896 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M215.472046,405.799561 
	C214.805573,405.287201 214.511047,404.882324 214.110596,404.250214 
	C214.788040,403.670990 215.571426,403.318970 216.679230,403.063110 
	C217.446075,403.096405 217.890671,403.058136 218.671997,403.047852 
	C219.743927,403.017944 220.481003,402.981476 221.587967,402.982788 
	C222.378998,403.406036 222.533218,403.878967 222.098328,404.666687 
	C219.720886,404.783722 217.972046,406.456146 215.472046,405.799561 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M205.487579,395.689056 
	C207.400543,394.504578 208.611923,395.708221 208.406052,397.452576 
	C208.011230,400.798065 205.510437,398.403015 204.012756,398.918365 
	C203.652527,397.224915 206.704865,397.768372 205.487579,395.689056 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M199.242126,405.434296 
	C198.434204,406.603851 197.579269,406.865875 196.225906,406.782471 
	C195.297119,406.225739 194.608261,405.830261 193.922089,405.033386 
	C194.810364,402.380127 196.722473,403.072479 198.761078,403.558472 
	C199.364838,404.171448 199.501617,404.622925 199.242126,405.434296 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M171.770432,398.776947 
	C172.027466,399.427856 172.033646,399.827362 172.070587,400.529694 
	C171.495438,402.021545 170.685425,402.908051 168.830338,402.711243 
	C168.049545,401.855438 167.980789,401.022186 168.128906,399.857971 
	C169.290588,399.141418 170.134079,397.957367 171.770432,398.776947 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M182.809753,405.764343 
	C179.973785,406.012360 176.942657,406.004303 173.465637,405.907410 
	C174.542908,403.949249 177.572021,406.258270 178.927292,403.358673 
	C180.206070,403.836761 181.410324,404.672485 182.809753,405.764343 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M139.429001,395.348877 
	C137.217361,397.572021 137.144836,397.574280 134.077805,395.627045 
	C135.786331,394.549377 137.472168,394.908356 139.429001,395.348877 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M184.258438,406.853241 
	C184.040222,406.612152 184.049164,406.621063 184.045410,406.629852 
	C184.184021,406.494141 184.326416,406.349609 184.729355,406.047852 
	C185.938950,405.049713 187.050674,404.590790 188.679565,404.513458 
	C189.505981,404.765320 189.890182,405.072571 190.341507,405.810242 
	C188.722137,408.076355 186.503860,406.971497 184.258438,406.853241 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M168.084778,399.531647 
	C168.836334,400.276093 169.020950,401.090027 168.577667,402.318329 
	C166.958206,403.236237 166.210419,401.299103 164.682114,401.298615 
	C164.608292,399.575897 165.832352,399.609833 167.193329,399.260437 
	C167.645096,399.392334 167.770477,399.494019 168.084778,399.531647 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M221.313446,395.526825 
	C221.702179,396.146301 221.795212,396.654205 221.841080,397.424957 
	C220.578110,397.704987 219.362289,397.722198 217.948868,397.424133 
	C217.655563,396.894775 217.559860,396.680634 217.716095,396.220886 
	C218.934860,395.517792 219.908890,395.099304 221.313446,395.526825 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M167.153564,399.158386 
	C166.734482,399.638855 165.882797,400.069550 164.791168,400.775879 
	C164.551239,401.051544 164.339218,401.063354 164.238251,401.030518 
	C163.306580,401.611664 162.419754,401.743591 161.227402,400.899292 
	C162.377701,397.866119 164.769623,399.401672 167.153564,399.158386 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M190.491455,406.165924 
	C190.104050,406.072144 189.737640,405.982788 189.176147,405.691956 
	C188.809952,405.065704 188.537796,404.724060 187.915070,404.236023 
	C189.288193,402.777588 190.872025,401.785797 192.036743,404.738892 
	C191.811829,405.442963 191.517380,405.711517 190.806076,405.970978 
	C190.528000,406.122162 190.512466,406.170349 190.491455,406.165924 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M191.299210,392.200623 
	C190.986618,391.768005 190.987656,391.558380 190.925339,391.038086 
	C191.990265,389.854279 193.156860,388.978546 194.664093,389.565735 
	C194.839035,389.633881 194.615631,390.724548 194.585449,391.707153 
	C193.662674,392.720734 192.622147,392.439484 191.299210,392.200623 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M218.441650,390.508484 
	C217.998413,390.263306 217.974792,389.987732 217.912399,389.298981 
	C219.473892,387.561707 221.130096,387.793457 223.048615,388.689850 
	C222.168533,390.802582 220.130569,389.782745 218.441650,390.508484 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M177.235962,393.599426 
	C175.446198,394.069305 173.834656,394.573669 172.178268,393.303375 
	C173.146225,391.290527 174.759003,392.026733 176.620514,392.148926 
	C177.352310,392.407501 177.502365,392.828003 177.235962,393.599426 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M211.875381,398.328430 
	C209.822800,397.656250 209.907806,396.585693 211.242966,395.562531 
	C211.643890,395.255249 212.745346,395.156555 212.943832,395.412933 
	C213.802094,396.521545 213.228027,397.459961 211.875381,398.328430 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M190.808731,406.285522 
	C190.835571,405.855927 191.143173,405.589691 191.719238,405.180481 
	C192.405640,405.017609 192.823563,404.997772 193.536362,404.864807 
	C194.765167,404.809570 195.740875,404.802277 195.883606,406.421600 
	C194.277267,406.661652 192.683365,406.555237 190.808731,406.285522 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M160.702499,400.556732 
	C161.768402,400.668976 162.548920,400.848053 163.733353,401.012421 
	C163.763336,402.982208 162.277374,403.005341 160.375488,402.817200 
	C160.014389,402.336395 160.011841,401.965668 160.006348,401.316895 
	C160.141296,400.900452 160.279205,400.762024 160.702499,400.556732 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M198.418060,390.993256 
	C199.706528,391.093475 201.379059,391.223145 200.777664,392.284180 
	C199.917542,393.801666 197.795609,392.696594 197.038757,392.055786 
	C195.886703,391.080292 197.388077,391.085541 198.418060,390.993256 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M187.403229,403.955505 
	C188.050125,404.266602 188.418640,404.539917 188.884125,405.151855 
	C187.712143,404.376923 186.822220,405.963867 185.348770,405.920288 
	C184.917007,404.384003 185.039200,403.088501 187.403229,403.955505 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M177.378876,393.987640 
	C177.033417,393.473999 177.041656,393.066193 177.036835,392.352386 
	C177.023788,392.046417 177.210709,391.662964 177.400543,391.566711 
	C178.268219,391.925781 178.946091,392.381104 179.716858,393.129059 
	C179.117355,393.645630 178.424942,393.869537 177.378876,393.987640 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M190.845383,392.191467 
	C191.948486,391.996033 192.911377,392.014435 194.234131,392.052979 
	C194.924911,393.468842 193.891541,393.401855 192.706360,393.506775 
	C191.819260,393.126801 191.262222,392.766022 190.845383,392.191467 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M199.854736,397.236572 
	C200.974197,397.455627 201.642349,397.882782 201.045120,398.801941 
	C200.873825,399.065521 200.177597,399.210876 199.827774,399.093994 
	C198.750092,398.733917 198.994537,398.015717 199.854736,397.236572 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M217.148376,396.699219 
	C216.344147,397.220612 215.827820,397.561768 215.311478,397.902893 
	C215.082809,397.526672 214.624619,397.121582 214.667679,396.779572 
	C214.807220,395.670898 215.393509,394.974792 216.845642,395.687347 
	C217.160553,396.159637 217.298401,396.339294 217.148376,396.699219 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M199.349915,405.808014 
	C199.028748,405.303101 199.031509,404.870667 199.027222,404.112946 
	C199.764816,403.759094 200.509430,403.730530 201.609467,403.838318 
	C201.973511,404.160126 201.982147,404.345612 202.046906,404.804199 
	C201.293320,405.345001 200.483597,405.612732 199.349915,405.808014 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M218.901886,402.797729 
	C218.690247,403.992065 218.091568,404.103882 217.149750,403.399048 
	C217.429123,402.453461 217.967850,402.076141 218.901886,402.797729 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M222.042877,404.935455 
	C221.841415,404.480438 221.908676,404.066132 221.966888,403.336243 
	C221.957840,403.020599 222.428802,402.994598 222.664642,402.991119 
	C222.958221,403.441589 223.015976,403.895508 222.963943,404.679993 
	C222.673309,404.999054 222.492462,404.987610 222.042877,404.935455 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M217.081299,396.944092 
	C216.860474,396.879486 216.856934,396.414673 216.939819,396.197327 
	C217.022705,395.980011 217.495529,396.001190 217.731766,395.988220 
	C217.946045,396.166901 217.924103,396.358551 217.826691,396.829529 
	C217.751251,397.108887 217.302124,397.008698 217.081299,396.944092 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M159.587097,393.982635 
	C159.826767,394.162903 159.872513,394.342773 159.851685,394.793182 
	C159.785126,395.063751 159.501587,395.038910 159.360901,395.030762 
	C159.152603,394.858826 159.085007,394.695099 159.011597,394.265778 
	C159.005768,394.000153 159.393188,393.982208 159.587097,393.982635 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M264.569702,221.088669 
	C264.901428,222.823517 264.859894,224.647400 264.717957,226.844727 
	C262.221649,225.361969 262.376343,223.327896 264.569702,221.088669 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M265.076477,217.036636 
	C265.337219,217.132309 265.397827,217.318863 265.337280,217.773621 
	C265.013947,217.850800 264.801483,217.668320 264.624023,217.456528 
	C264.604736,217.433472 264.787354,217.241257 265.076477,217.036636 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M71.050735,438.090271 
	C71.122681,437.378723 71.387032,436.995148 71.753372,436.397095 
	C74.852249,436.213440 74.096191,438.839630 74.788361,440.822754 
	C74.477257,441.292328 74.181732,441.378784 73.711151,441.296631 
	C71.978638,440.903625 72.344025,439.042297 71.050735,438.090271 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M76.705200,445.150391 
	C76.879196,446.557465 76.879196,448.175781 76.879196,449.973907 
	C75.482147,449.098480 75.264229,447.826447 75.030136,446.265259 
	C75.578270,445.738617 76.054741,445.550110 76.705200,445.150391 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M333.218323,115.894470 
	C332.034119,113.596329 330.431702,110.830971 335.692566,111.872391 
	C336.559814,113.109352 337.182678,114.210091 336.120087,115.706322 
	C335.677094,115.887222 335.417267,115.701546 335.107605,115.215225 
	C334.623108,114.698700 334.517151,114.285423 334.505737,113.832291 
	C334.425385,114.063293 334.471680,114.308701 334.211182,114.771301 
	C333.895172,115.321236 333.708008,115.582710 333.218323,115.894470 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M326.464203,124.396408 
	C330.239075,126.267853 325.989777,126.922829 326.346893,128.284332 
	C325.051147,126.950813 324.089294,125.655731 326.464203,124.396408 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M330.720886,128.515747 
	C330.254730,127.064194 330.711945,126.028664 331.820007,125.596909 
	C332.507782,125.328918 332.872925,126.132423 332.897949,126.790016 
	C332.947052,128.080887 332.527740,128.987381 330.720886,128.515747 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M334.267334,121.415932 
	C334.625977,121.935051 334.748230,122.385765 334.870483,122.836487 
	C334.621979,122.893990 334.174622,123.039268 334.155365,122.995628 
	C333.923950,122.471161 333.167511,121.952042 334.267334,121.415932 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M321.744934,125.988998 
	C321.586151,126.093170 321.426117,126.041801 321.266083,125.990433 
	C321.425293,125.938110 321.584473,125.885788 321.744934,125.988998 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M323.404755,120.738197 
	C323.556854,120.859322 323.578094,121.066666 323.599335,121.274002 
	C323.490845,121.124146 323.382355,120.974281 323.404755,120.738197 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M308.240814,119.992844 
	C308.158264,119.567566 308.325073,119.143700 308.491882,118.719833 
	C308.648529,118.978714 308.805176,119.237595 308.975342,119.743042 
	C308.988892,119.989601 308.490173,119.994255 308.240814,119.992844 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M334.247559,114.999359 
	C334.162842,114.572144 334.328125,114.145195 334.493378,113.718246 
	C334.651276,113.979492 334.809143,114.240746 334.982300,114.750389 
	C334.830902,114.999062 334.664215,114.999352 334.247559,114.999359 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M335.454651,127.528381 
	C335.425323,127.477585 335.483948,127.579185 335.454651,127.528381 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M316.544922,123.471466 
	C316.574127,123.522102 316.515747,123.420822 316.544922,123.471466 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M329.528625,122.545090 
	C329.478058,122.574249 329.579224,122.515923 329.528625,122.545090 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M260.473206,235.764023 
	C262.516388,235.742996 261.903290,236.971985 261.666473,237.984390 
	C261.623749,238.166962 261.114594,238.429214 260.933105,238.360031 
	C259.702911,237.891098 260.122772,236.891464 260.473206,235.764023 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M343.343933,186.963135 
	C343.042694,185.403778 342.857971,183.978226 340.370544,184.008057 
	C341.725220,179.729233 345.210815,184.744141 347.845978,181.210419 
	C347.250885,185.002838 345.646301,186.114548 343.343933,186.963135 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M305.220154,195.697342 
	C304.889893,196.320831 304.701782,196.577530 304.220276,196.887939 
	C303.478210,197.540787 302.926422,198.057648 302.193909,198.794876 
	C300.402710,199.038376 298.981018,198.855682 299.011108,196.374725 
	C300.094147,195.386444 300.877197,194.458939 301.786224,193.224121 
	C302.003021,193.007721 302.000000,193.000000 301.999390,193.003265 
	C302.681213,192.425049 303.450836,192.261398 304.654785,192.755585 
	C305.001312,193.156509 305.002502,193.326340 305.006714,193.750916 
	C305.384766,194.394470 305.528656,194.855469 305.220154,195.697342 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M305.046967,192.665741 
	C304.249786,192.992630 303.499481,192.998596 302.373962,193.005524 
	C301.998749,192.560593 301.998688,192.114685 302.000549,191.334381 
	C303.454803,190.918640 304.024963,190.073792 303.993896,188.351608 
	C308.101807,188.505600 306.305817,190.498779 305.046967,192.665741 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M313.305206,192.967133 
	C312.552032,193.011993 312.109406,193.005554 311.334839,192.998032 
	C310.690918,191.894470 310.378998,190.791992 310.033508,189.344757 
	C311.332062,190.188187 314.540741,189.643539 313.305206,192.967133 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M304.598938,180.001968 
	C304.998779,180.750900 304.998779,181.500595 304.999390,182.625137 
	C303.340363,182.849442 301.165619,183.615219 301.011902,180.382660 
	C302.066345,180.001312 303.132721,180.002014 304.598938,180.001968 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M362.999390,198.000916 
	C363.091614,196.851196 363.353973,195.767242 364.653595,195.464066 
	C364.891846,195.408493 365.534119,195.932892 365.527893,196.177856 
	C365.498779,197.324966 364.594940,197.684113 363.322113,197.966797 
	C362.997559,198.001221 363.000000,198.000000 362.999390,198.000916 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M303.944489,187.658661 
	C302.867340,187.937622 301.590668,188.187592 301.055481,186.342316 
	C302.131439,186.066055 303.406555,185.820099 303.944489,187.658661 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M344.680969,200.043304 
	C344.743835,201.002045 345.616730,202.744308 343.192322,202.226776 
	C343.080475,201.095810 343.326782,200.309067 344.680969,200.043304 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M305.352753,195.998291 
	C305.000061,195.561462 305.001343,195.116837 305.006195,194.338928 
	C305.757843,194.002075 306.505890,193.998505 307.628204,193.989410 
	C307.929199,195.444473 307.083588,196.021393 305.352753,195.998291 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M340.000000,183.999695 
	C339.859802,184.961548 339.631531,185.903854 338.384491,185.782654 
	C338.066833,185.751785 337.522919,185.234344 337.547272,184.986069 
	C337.652130,183.918167 338.606598,184.134491 339.659729,184.005402 
	C340.000000,184.000610 340.000000,184.000000 340.000000,183.999695 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M300.949219,185.667908 
	C300.251190,186.000122 299.501190,185.999634 298.376190,185.999268 
	C298.515198,183.809921 299.432312,183.378174 300.949219,185.667908 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M360.999390,189.000763 
	C361.624298,189.097031 362.339630,189.097672 362.481201,189.905701 
	C362.510925,190.075241 362.154449,190.312424 361.975922,190.518433 
	C361.675018,190.198929 361.374146,189.879410 361.037231,189.279053 
	C361.001221,188.998199 361.000000,189.000000 360.999390,189.000763 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M342.999390,186.999695 
	C342.909576,187.630890 342.907623,188.347794 342.093719,188.489349 
	C341.922241,188.519165 341.683380,188.161209 341.475555,187.981903 
	C341.796082,187.678818 342.116608,187.375732 342.719177,187.036621 
	C343.001221,187.000610 343.000000,187.000000 342.999390,186.999695 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M309.964111,188.718781 
	C309.371643,188.907440 308.656860,188.903641 308.516174,188.093704 
	C308.486542,187.923218 308.843536,187.685562 309.022430,187.478851 
	C309.324341,187.798431 309.626282,188.117996 309.964111,188.718781 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M368.359131,205.248505 
	C368.373779,205.007629 368.504272,204.876236 368.634766,204.744843 
	C368.581482,204.949219 368.528229,205.153595 368.359131,205.248505 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M350.529663,184.547119 
	C350.477631,184.577530 350.581726,184.516724 350.529663,184.547119 
z"/>
<path fill="#F8D2D8" opacity="1.000000" stroke="none" 
	d="
M87.134010,305.115356 
	C87.399353,306.824188 87.275017,308.504517 87.031097,310.590485 
	C83.872643,308.015564 83.828209,306.444977 87.134010,305.115356 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M218.184265,279.474121 
	C217.499191,280.231171 218.389740,281.634613 216.871521,281.302917 
	C215.521271,281.007904 215.167831,279.819855 215.110001,278.781555 
	C215.031937,277.380463 216.447159,277.863495 217.612503,277.622955 
	C218.352020,278.120392 218.492752,278.607422 218.184265,279.474121 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M217.932053,266.119141 
	C218.951157,266.095215 219.590134,266.055603 220.229126,266.015991 
	C218.508240,267.161743 216.864365,268.507446 214.553253,267.699310 
	C214.839905,265.493927 216.514679,266.441223 217.932053,266.119141 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M218.353180,279.775635 
	C217.946655,279.325867 217.943451,278.860016 217.968292,278.044800 
	C219.103760,277.103851 220.558304,275.881134 221.178635,277.774567 
	C221.605301,279.076904 220.568527,280.296844 218.353180,279.775635 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M215.633392,260.431580 
	C214.285812,260.739960 213.969620,260.078247 214.190475,259.174530 
	C214.274414,258.830933 214.814301,258.317963 215.090591,258.350861 
	C216.261612,258.490234 215.978195,259.403442 215.633392,260.431580 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M217.266998,259.306091 
	C218.125885,258.527893 218.887817,257.677551 219.787308,258.582001 
	C219.981308,258.777100 219.935852,259.542877 219.717667,259.755890 
	C218.910706,260.543732 218.024719,260.208008 217.266998,259.306091 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M207.248047,274.117737 
	C206.270615,272.292542 207.614273,272.776917 208.362885,272.807617 
	C208.696259,272.821320 209.010834,273.293671 209.333939,273.557861 
	C208.751694,273.778168 208.169464,273.998505 207.248047,274.117737 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M203.979492,289.798431 
	C202.811905,289.107483 203.231995,288.532471 203.924133,288.071198 
	C204.083603,287.964966 204.532150,288.034607 204.660095,288.183960 
	C205.187088,288.799164 204.743942,289.281555 203.979492,289.798431 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M219.753128,273.039673 
	C219.748032,273.323822 219.416504,273.588745 219.046371,273.778259 
	C218.989731,273.807251 218.754715,273.487854 218.602188,273.329559 
	C218.872833,273.218323 219.143463,273.107086 219.753128,273.039673 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M219.980774,272.974548 
	C220.100830,272.744843 220.256607,272.552887 220.412384,272.360931 
	C220.429214,272.562012 220.446030,272.763123 220.277512,273.023865 
	C220.092163,273.083557 220.016479,273.012329 219.980774,272.974548 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M208.453156,277.529114 
	C208.422989,277.477600 208.483307,277.580597 208.453156,277.529114 
z"/>
<path fill="#FAF4D5" opacity="1.000000" stroke="none" 
	d="
M90.694824,301.688599 
	C90.393295,301.040863 90.500511,300.248444 90.967857,299.308228 
	C91.852493,300.011353 91.938118,300.820953 90.694824,301.688599 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M387.989441,99.015083 
	C387.978729,98.249489 387.971771,97.470291 387.960266,96.301735 
	C390.458984,94.200798 393.441559,94.601135 396.207886,94.148438 
	C398.891724,93.709221 401.655792,93.760529 404.733948,93.678154 
	C402.149078,97.608070 396.829315,95.747566 393.162323,98.832199 
	C391.817322,99.033203 390.792358,99.009811 389.380127,98.996887 
	C388.823608,99.118881 388.654266,99.230423 388.229614,99.176559 
	C387.974335,99.011154 387.993195,99.001488 387.989441,99.015083 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M303.633728,145.017746 
	C304.003326,145.755371 303.998505,146.503296 303.997437,147.625183 
	C304.001221,147.999130 304.000000,148.000000 303.999390,148.000427 
	C302.900757,147.879868 301.435059,148.266739 301.241791,146.620850 
	C301.083252,145.270676 302.231049,145.119247 303.633728,145.017746 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M297.987335,147.632675 
	C296.835297,147.825958 295.239136,148.290848 295.263275,146.304916 
	C295.267487,145.959244 295.726685,145.396790 296.066895,145.315369 
	C297.685120,144.928146 297.866058,146.090683 297.987335,147.632675 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M303.995758,144.995850 
	C304.288055,143.987137 302.770538,142.692444 304.438965,141.943466 
	C304.784882,141.788162 305.607849,141.888016 305.690765,142.086990 
	C306.187531,143.279190 306.079437,144.360214 304.329956,144.949554 
	C304.008148,145.007446 304.000000,144.999893 303.995758,144.995850 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M298.000610,147.999481 
	C299.036591,148.174957 300.027893,148.422638 299.757599,149.817780 
	C299.707703,150.075287 299.368408,150.473495 299.164764,150.472229 
	C297.930664,150.464600 298.157410,149.439056 298.006226,148.340317 
	C297.998779,148.001175 298.000000,148.000000 298.000610,147.999481 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M293.456177,143.615738 
	C293.682373,144.411179 293.401886,144.695694 292.786835,144.575043 
	C292.658783,144.549911 292.485931,144.368744 292.466431,144.239456 
	C292.372498,143.617188 292.674561,143.355621 293.456177,143.615738 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M57.000305,163.989594 
	C54.440968,163.654831 51.915520,163.648132 49.295151,164.939896 
	C48.078316,165.000488 47.090439,164.875687 46.111721,164.926666 
	C44.372940,165.017288 43.177376,164.401230 43.016560,162.573624 
	C42.853199,160.717087 44.605289,160.538742 45.685402,160.264404 
	C47.424477,159.822693 49.189884,159.565857 50.853481,158.221436 
	C53.988514,154.433960 58.483604,155.729599 62.193386,154.688705 
	C79.221275,149.910995 96.364098,145.462479 113.767677,142.208023 
	C114.534729,142.064575 115.263962,139.320007 116.687096,141.843994 
	C116.793602,143.738876 119.412056,144.235443 118.937561,146.526611 
	C118.565811,146.966003 118.279053,147.119675 117.898285,147.547821 
	C117.713821,147.945557 117.658371,148.134140 117.352249,148.480209 
	C116.907181,148.673874 116.712769,148.710037 116.223717,148.712952 
	C115.755066,148.586716 115.581055,148.493729 115.226807,148.166016 
	C111.798782,147.708038 108.865242,149.360764 106.995155,151.312500 
	C104.948677,153.448334 104.689178,150.523605 103.257477,150.953842 
	C94.084007,154.660645 84.137596,154.867523 75.361664,159.744873 
	C74.549843,159.920013 74.065086,159.632828 73.334053,159.256561 
	C71.326462,158.977234 69.616875,159.014740 69.005630,161.568192 
	C67.215309,160.756409 65.328499,160.873749 63.137871,161.669891 
	C62.073868,162.049576 61.274651,162.181595 60.241066,162.517456 
	C59.427212,163.747528 58.371437,163.378967 57.231628,163.788483 
	C56.954998,164.002518 56.998718,164.011566 57.000305,163.989594 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M80.120354,172.940399 
	C79.497391,173.651749 78.586449,174.263428 77.360489,174.975540 
	C75.639397,173.954407 73.279518,172.775955 76.733116,171.417648 
	C78.563957,170.697586 77.231979,170.238617 76.959610,169.488434 
	C76.514473,168.262451 74.533173,167.262100 75.891319,165.756393 
	C77.528023,163.941864 79.349228,164.757812 81.030289,165.973129 
	C81.276405,166.151062 81.634933,166.173492 82.301933,166.378860 
	C79.093590,167.775101 78.796204,170.093964 80.120354,172.940399 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M86.636559,172.018555 
	C85.450050,173.533859 83.365326,172.789734 81.069794,173.128418 
	C82.232597,171.389267 84.336868,172.308548 86.636559,172.018555 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M73.195961,159.334244 
	C73.660240,159.220627 74.207138,159.352539 74.938721,159.709045 
	C74.232361,161.254974 73.817017,160.096542 73.195961,159.334244 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M103.319000,161.091965 
	C103.295059,160.510956 103.415054,160.105331 103.535042,159.699707 
	C103.630844,159.816681 103.824066,159.952667 103.805580,160.047302 
	C103.724907,160.460526 103.582764,160.861771 103.319000,161.091965 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M90.737274,168.132965 
	C91.587692,169.265076 90.538841,168.727020 90.223549,168.867584 
	C90.129677,168.909439 89.876755,168.594559 89.696701,168.443130 
	C89.957985,168.332443 90.219269,168.221741 90.737274,168.132965 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M96.158661,167.675583 
	C95.549538,167.705887 95.125069,167.586334 94.700592,167.466766 
	C94.826500,167.371658 94.969032,167.180023 95.075394,167.198364 
	C95.504105,167.272247 95.921638,167.410950 96.158661,167.675583 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M103.000671,152.000641 
	C102.954765,152.797150 102.908195,153.593033 102.852203,154.550003 
	C101.787079,153.762497 102.100594,153.038208 102.729843,152.154144 
	C102.998352,151.998779 103.000000,152.000000 103.000671,152.000641 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M99.771683,163.965210 
	C99.596855,164.087692 99.424660,164.029831 99.252457,163.971970 
	C99.426407,163.909607 99.600365,163.847229 99.771683,163.965210 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M74.565788,163.615997 
	C74.471672,163.692108 74.429825,163.415924 74.429825,163.415924 
	C74.429825,163.415924 74.659904,163.539886 74.565788,163.615997 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M81.572021,168.451324 
	C81.633072,168.538696 81.394783,168.569977 81.394783,168.569977 
	C81.394783,168.569977 81.510979,168.363953 81.572021,168.451324 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M98.416870,166.576172 
	C98.340546,166.479080 98.622643,166.439529 98.622643,166.439529 
	C98.622643,166.439529 98.493202,166.673279 98.416870,166.576172 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M269.780884,195.310837 
	C270.455139,195.259872 271.316528,195.420242 271.453461,195.825485 
	C271.692749,196.533386 270.955475,196.831650 269.974609,196.988556 
	C269.644531,196.555786 269.643188,196.094101 269.780884,195.310837 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M272.642303,162.194580 
	C273.069458,162.123810 273.679321,162.251404 272.927917,162.996216 
	C272.671265,162.904022 272.627563,162.701752 272.642303,162.194580 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M261.945343,292.251648 
	C262.197327,292.184723 262.369049,292.350159 262.495697,292.544891 
	C262.520050,292.582306 262.367310,292.734894 262.131042,292.918457 
	C261.927032,292.833099 261.888214,292.663605 261.945343,292.251648 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M261.394867,296.149017 
	C261.733124,296.105286 261.979767,296.287079 262.226410,296.468903 
	C262.108490,296.572968 261.990540,296.677002 261.634705,296.816742 
	C261.396820,296.852417 261.303253,296.374573 261.394867,296.149017 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M127.776505,417.486633 
	C133.504288,417.398163 138.805069,414.989105 144.823837,415.082123 
	C145.810120,415.888397 145.829605,416.723999 145.336960,417.963684 
	C140.505875,421.169128 135.247589,420.207336 129.856796,420.775879 
	C128.275238,420.116425 127.815239,419.116913 127.776505,417.486633 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M150.228867,415.275940 
	C154.905685,413.520355 159.755615,415.214050 164.471405,413.403015 
	C165.505737,413.563538 166.357391,414.092560 167.672150,413.742126 
	C168.719116,413.830505 169.480408,413.856415 170.619873,413.930817 
	C171.249100,413.863739 171.500137,413.748138 172.044708,413.923553 
	C172.383072,414.485291 172.427933,414.755951 172.356537,415.420288 
	C169.055679,418.574280 164.961700,416.874817 161.061218,417.998352 
	C158.533203,417.604980 156.395630,416.847076 153.892395,418.051575 
	C152.200470,418.700806 151.036789,418.608673 150.197723,416.800629 
	C150.107330,416.166962 150.116486,415.908478 150.228867,415.275940 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M135.694092,410.140564 
	C139.592499,409.471497 143.316315,408.988678 147.048645,408.909729 
	C147.868408,408.892395 149.509323,407.519073 149.865402,409.440369 
	C150.217194,411.338745 148.526047,410.860413 147.512665,410.962158 
	C143.973831,411.317474 140.428635,411.609650 136.473389,411.852020 
	C135.681244,411.425354 135.491394,410.994232 135.694092,410.140564 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M156.868042,408.057922 
	C160.911255,407.738098 164.183838,403.222900 168.858078,405.822144 
	C168.658920,407.132660 167.663284,407.627777 167.085663,408.793243 
	C164.756592,410.835907 162.150742,409.678192 159.288177,409.953125 
	C158.568375,409.626740 158.257004,409.356812 157.645599,408.966553 
	C157.228470,408.664093 157.084183,408.513336 156.868042,408.057922 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M127.500259,417.073090 
	C128.166809,417.772461 128.465988,418.478851 128.690094,419.476562 
	C126.303940,422.199249 123.559349,421.543915 120.413071,420.622101 
	C119.336502,419.611938 119.224136,418.736298 119.776764,417.397461 
	C122.398689,417.034760 124.765793,417.057404 127.500259,417.073090 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M178.253143,413.397644 
	C180.037750,409.473267 183.495590,411.530975 186.764069,411.093994 
	C187.509171,411.801300 187.798019,412.469757 187.551468,413.574524 
	C187.253281,414.100159 187.085739,414.281128 186.592911,414.639709 
	C186.031784,414.891174 185.795944,414.965088 185.194458,415.099487 
	C184.336853,415.196198 183.844452,415.205170 182.984558,415.154846 
	C181.157532,414.888245 179.759827,414.473480 178.253143,413.397644 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M211.629700,409.874268 
	C212.420380,409.933441 212.865189,409.951660 213.639984,410.020752 
	C214.803360,409.929077 215.563629,409.408142 216.727859,409.768097 
	C217.163162,409.984955 217.330399,410.024323 217.749969,410.011047 
	C218.717941,409.420593 219.534760,409.515869 220.642365,409.866699 
	C220.937500,410.149506 220.941605,410.054688 220.904327,410.084045 
	C221.319901,410.479065 221.510422,410.951324 221.271393,411.898682 
	C220.678818,412.622742 220.205780,412.883972 219.284882,413.146545 
	C217.816299,413.370941 216.736984,413.338348 215.261978,413.415955 
	C213.269516,413.442352 211.677963,413.422791 209.767883,412.833649 
	C208.957962,412.407654 208.645844,412.023010 208.454712,411.154663 
	C208.910400,409.068329 210.134384,409.562195 211.629700,409.874268 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M195.725555,410.195740 
	C197.421646,410.041565 198.742645,410.012848 200.458893,410.028137 
	C201.047470,410.221771 201.240784,410.371368 201.684052,410.791992 
	C202.305511,411.748108 202.447983,412.451752 201.809311,413.429749 
	C198.736145,414.643158 195.996140,414.217194 192.976379,413.192200 
	C192.131577,410.585327 193.480194,410.186951 195.725555,410.195740 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M107.325630,420.416718 
	C106.704430,419.348755 106.720276,418.571960 107.636185,417.673096 
	C108.739853,417.621368 109.492027,417.772644 110.625534,417.878113 
	C111.006874,417.832245 111.459099,417.631836 111.706024,417.617676 
	C112.714973,417.776001 113.476997,417.948486 114.634804,418.103821 
	C115.375435,418.618713 115.469650,419.192505 115.024506,420.156464 
	C112.416924,421.727631 110.073128,421.735687 107.325630,420.416718 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M167.266312,409.079895 
	C165.277191,407.120483 166.530411,406.541382 168.658813,406.171387 
	C169.742767,406.131256 170.500961,406.136841 171.636581,406.183960 
	C172.013992,406.225525 171.996109,406.652435 171.971405,406.864655 
	C171.382889,407.726654 171.515259,408.769531 170.378815,409.281494 
	C169.873978,409.256622 169.693558,409.229401 169.242249,409.241486 
	C168.971375,409.280792 168.494019,409.378510 168.259796,409.311462 
	C167.859879,409.188873 167.694168,409.133331 167.266312,409.079895 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M195.764374,409.917603 
	C195.588791,411.402557 193.505875,410.397858 193.154633,412.337585 
	C193.767151,413.859955 193.579163,414.807983 191.830429,415.390625 
	C189.818405,414.322174 190.048447,413.091522 191.426971,411.566284 
	C192.196030,408.961700 193.519302,408.690155 195.764374,409.917603 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M191.493622,411.267639 
	C191.495590,412.311493 191.199463,413.276611 190.825378,414.544525 
	C189.447281,416.066284 188.239349,415.406006 186.779449,414.343689 
	C186.712646,413.306000 186.901779,412.589722 187.149323,411.504578 
	C188.520950,412.354553 189.872650,410.692200 191.493622,411.267639 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M135.496521,409.832642 
	C135.920837,410.246002 135.976044,410.682861 136.046097,411.448975 
	C134.019669,411.892151 131.978424,412.006104 129.499985,412.090881 
	C128.784851,411.559998 128.506882,411.058319 128.128296,410.281952 
	C130.400848,410.267090 132.782684,410.933136 135.496521,409.832642 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M145.298737,418.221924 
	C145.022400,417.252502 144.997131,416.528168 145.106155,415.464355 
	C146.665085,415.099884 148.089691,415.074921 149.939926,414.977020 
	C150.399124,415.128265 150.432693,415.352448 150.474792,415.915466 
	C150.474335,416.917725 150.532959,417.602356 149.602051,418.159363 
	C148.861450,418.095581 148.703613,417.444305 148.488892,417.408234 
	C147.753082,417.284576 148.638275,418.118774 147.828934,418.416260 
	C146.865662,418.803375 146.199753,418.762482 145.298737,418.221924 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M172.103668,414.853729 
	C171.982376,414.460968 172.020233,414.472382 172.022461,414.492035 
	C171.868195,414.234436 171.711700,413.957214 171.945740,413.405151 
	C173.229294,413.170471 174.122314,413.210663 175.348206,413.195282 
	C176.196411,413.273224 176.674210,413.489777 177.288239,414.148926 
	C177.456406,414.779175 177.451538,415.048218 177.264679,415.680634 
	C175.204468,417.355804 173.540756,417.360748 172.103668,414.853729 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M202.329788,413.122375 
	C201.702393,412.464050 201.385986,411.986847 201.036697,411.224060 
	C201.221802,410.706390 201.455597,410.491455 201.910950,410.173370 
	C202.116699,410.053040 202.579178,409.964478 202.803421,409.892761 
	C203.754684,409.465027 204.528107,409.510590 205.645905,409.736023 
	C205.990021,409.913879 206.464996,410.047974 206.935486,410.321106 
	C207.516724,411.071625 207.478455,411.539185 207.063232,412.259216 
	C205.512131,413.257782 204.117340,413.498383 202.329788,413.122375 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M177.306015,414.995483 
	C177.039078,414.608734 177.196686,414.524445 177.179260,414.436829 
	C176.975464,414.058533 176.789078,413.767914 177.106094,413.355560 
	C177.609467,413.233856 177.837326,413.291534 177.921448,413.209595 
	C179.338821,413.434601 180.672089,413.741608 182.354263,414.074829 
	C181.654068,417.174988 179.596893,416.212036 177.306015,414.995483 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M173.946808,409.856201 
	C174.560730,407.583740 176.367249,407.424377 178.712997,408.001282 
	C178.145920,410.612183 175.649902,408.719543 173.946808,409.856201 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M119.588646,417.008606 
	C120.000603,417.747620 119.969604,418.483185 120.024979,419.580048 
	C119.505356,420.657501 118.712799,420.798401 117.445221,420.523071 
	C116.362495,419.758148 116.148438,418.979065 116.375885,417.691986 
	C117.388336,417.197571 118.267014,417.101318 119.588646,417.008606 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M152.734604,407.889954 
	C153.455734,407.953522 153.908951,407.970978 154.702515,407.984100 
	C155.397781,408.407410 155.529892,408.895386 155.239990,409.784363 
	C153.548492,410.162567 151.463379,412.149170 151.027115,408.545166 
	C151.406738,407.559052 151.936447,407.700409 152.734604,407.889954 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M202.834335,405.442932 
	C203.802444,403.852844 205.165710,403.816925 206.887848,404.806488 
	C205.953094,406.393799 204.488342,406.007446 202.834335,405.442932 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M170.329041,409.494629 
	C171.751801,409.237762 169.622665,406.970306 171.672333,407.023132 
	C172.338593,407.804230 172.730469,408.531586 173.246857,409.546753 
	C172.448807,409.791504 171.526245,409.748444 170.329041,409.494629 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M116.291351,417.355103 
	C116.693726,417.952118 116.877800,418.610413 116.981323,419.612396 
	C116.470474,420.313568 115.985184,420.419739 115.227753,419.948364 
	C115.020828,419.280884 115.031059,418.939819 115.035942,418.342651 
	C115.378082,417.863220 115.725571,417.639801 116.291351,417.355103 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M155.209290,410.333405 
	C155.080200,409.646790 155.119659,409.168579 155.100983,408.335022 
	C155.434341,407.939117 155.825836,407.898468 156.506744,407.805542 
	C156.796158,407.753265 156.879105,407.863953 156.925659,407.915070 
	C157.332550,408.317749 157.494995,408.744629 157.257553,409.546387 
	C156.691498,410.548340 156.220337,410.992737 155.209290,410.333405 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M220.778961,412.128479 
	C220.937698,411.484863 220.927933,411.092651 220.892609,410.406921 
	C221.221420,410.068237 221.575806,410.023041 222.197937,409.971985 
	C222.486572,410.670929 222.507462,411.375824 222.512619,412.683655 
	C222.302338,413.339874 222.107788,413.393097 221.617126,413.382263 
	C220.980927,413.083588 220.739014,412.774628 220.778961,412.128479 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M211.730377,409.664398 
	C211.346527,410.809875 210.503250,410.025818 209.539795,410.201660 
	C208.777695,410.480347 208.226440,410.578491 207.254135,410.326080 
	C206.864075,410.149506 206.862930,410.052124 206.910629,410.042969 
	C208.295349,408.572266 209.870239,408.846802 211.730377,409.664398 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M152.951981,407.628967 
	C152.647171,408.750763 152.082855,408.452606 151.304596,408.207397 
	C151.060974,407.729248 151.042221,407.256317 151.024719,406.429871 
	C151.906342,406.107269 152.639069,406.360504 152.951981,407.628967 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M167.694366,413.574371 
	C166.915390,414.658325 165.876541,415.380402 164.766235,413.441162 
	C165.563904,413.221649 166.497406,413.282898 167.694366,413.574371 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M157.355377,409.855347 
	C156.962509,409.425140 156.869370,409.004395 156.874237,408.274902 
	C157.911804,407.962860 159.114212,407.517944 158.950714,409.565430 
	C158.453125,409.907257 158.054108,409.886017 157.355377,409.855347 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M216.796021,409.709290 
	C216.082397,410.153625 215.168884,410.361633 214.112671,410.320648 
	C214.650131,409.015656 215.527359,408.824188 216.796021,409.709290 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M205.801636,409.689880 
	C205.244827,409.943207 204.499619,409.972534 203.391052,409.911438 
	C203.787842,408.962219 204.653244,408.869537 205.801636,409.689880 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M220.792755,409.874207 
	C220.200043,410.135406 219.462585,410.121307 218.363708,410.032837 
	C218.767975,408.983521 219.638748,408.781708 220.792755,409.874207 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M111.833778,417.500488 
	C111.806168,417.686676 111.659393,417.769867 111.259743,417.842651 
	C111.131981,417.476044 111.367897,417.331116 111.833778,417.500488 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M150.355927,415.743286 
	C150.515076,415.828003 150.551392,415.636505 150.476624,415.174561 
	C150.365540,414.904083 150.350800,414.941071 150.341431,414.921478 
	C150.299072,415.090271 150.266083,415.278687 150.355927,415.743286 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M172.059799,413.174835 
	C172.267776,413.356262 172.199265,413.582214 172.077728,414.159912 
	C171.826843,414.474609 171.628967,414.437561 171.214569,414.189880 
	C171.259796,413.726013 171.521561,413.472687 172.059799,413.174835 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M177.128738,413.182404 
	C177.562546,413.430664 177.515610,413.627441 177.315247,414.086731 
	C176.807251,414.109711 176.452667,413.870270 175.889587,413.385254 
	C176.003403,413.136780 176.325699,413.133850 177.128738,413.182404 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M201.800827,410.043335 
	C201.918213,410.324463 201.719742,410.595886 201.262527,410.902893 
	C201.003799,410.938507 200.935089,410.503845 200.894623,410.287994 
	C201.064423,410.059265 201.274689,410.046417 201.800827,410.043335 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M168.117142,409.369324 
	C168.025589,409.244415 168.500732,409.205475 168.736053,409.243134 
	C168.971375,409.280792 168.628876,409.573547 168.628876,409.573547 
	C168.628876,409.573547 168.208694,409.494232 168.117142,409.369324 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M109.603127,201.034332 
	C109.203201,201.772095 108.800171,201.785019 108.441544,201.258972 
	C108.366936,201.149506 108.370941,200.895645 108.448891,200.788483 
	C108.817940,200.281158 109.221733,200.282822 109.603127,201.034332 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M97.929260,221.990875 
	C97.684746,221.886780 97.647331,221.693634 97.732864,221.232239 
	C98.050171,221.168350 98.253479,221.365891 98.423500,221.588837 
	C98.438599,221.608658 98.237198,221.793594 97.929260,221.990875 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M526.026123,107.023170 
	C526.065735,106.630150 526.089172,106.223938 526.112610,105.817726 
	C526.307739,105.878212 526.502930,105.938705 526.698059,105.999191 
	C526.604248,106.244743 526.510437,106.490295 526.196045,106.861565 
	C525.975525,106.987282 526.010010,107.009979 526.026123,107.023170 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M516.568848,95.439667 
	C516.287231,95.241035 516.217896,94.869186 516.148621,94.497337 
	C516.768921,94.416969 516.867554,94.765594 516.568848,95.439667 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M518.990112,92.989609 
	C519.038452,93.473686 518.922974,93.811584 518.331665,93.648064 
	C518.311218,93.642403 518.402588,93.232170 518.728638,93.012650 
	C519.015503,93.014801 518.998657,92.998360 518.990112,92.989609 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M528.914185,107.798340 
	C528.836670,107.996727 528.661133,107.983513 528.223389,108.003349 
	C528.078491,107.567657 528.165527,107.041443 528.914185,107.798340 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M173.332184,290.488464 
	C171.301224,290.146423 171.907120,289.259857 173.026917,288.988403 
	C173.834747,288.792572 175.248505,288.113586 175.751068,289.740356 
	C175.034851,289.923431 174.318619,290.106476 173.332184,290.488464 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M164.952866,289.522095 
	C165.094391,289.179352 165.267700,289.123474 165.711212,289.028503 
	C166.057571,289.572968 166.374252,290.541962 166.166931,290.671326 
	C165.394821,291.153229 165.106842,290.495941 164.952866,289.522095 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M719.451416,89.523605 
	C719.342529,87.755676 717.368835,86.435730 718.888916,85.390732 
	C720.049927,84.592522 721.021362,85.577171 721.771057,86.538353 
	C724.683777,90.273071 725.591919,86.146820 727.647217,85.064301 
	C728.002441,85.002922 728.000000,84.999695 727.997559,84.998337 
	C729.293274,85.752449 730.091736,86.729546 729.239014,88.666466 
	C729.002441,88.998695 729.000000,89.000000 728.998779,89.000610 
	C728.121277,89.838615 727.120911,90.551643 726.210754,91.785934 
	C725.997559,92.003052 726.000000,92.000000 726.001221,91.998566 
	C723.079712,94.156425 721.919434,90.779854 719.451416,89.523605 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M714.000793,91.998886 
	C716.323059,92.227966 714.615601,86.674843 718.677795,88.972733 
	C718.989075,88.988556 719.000793,89.000793 719.005920,89.005905 
	C719.500854,89.462227 719.761536,90.021027 719.765381,91.002434 
	C719.664795,91.520607 719.596313,91.721779 719.365234,92.196152 
	C718.672729,93.132065 718.180969,93.821014 717.563843,94.830063 
	C717.182800,95.237175 717.000427,95.374657 716.487793,95.622818 
	C715.421875,95.824951 714.736694,95.685738 713.858215,95.013664 
	C713.253906,94.035843 713.225525,93.319763 713.768066,92.297211 
	C713.998108,92.001846 714.000000,92.000000 714.000793,91.998886 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M738.341675,85.266052 
	C737.999573,83.934669 738.001526,82.867210 738.001709,81.399414 
	C738.104492,80.682076 738.289734,80.422699 738.769409,80.107620 
	C739.794250,79.668274 740.581787,79.204308 741.756104,79.782471 
	C742.002441,80.001892 742.000000,80.000000 741.998779,79.999069 
	C744.403137,83.617706 743.584778,84.984566 738.341675,85.266052 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M741.946716,79.657692 
	C741.118347,80.127068 740.234314,80.252228 739.166748,80.185837 
	C738.988098,79.551460 738.992981,79.108643 738.995239,78.333679 
	C740.130615,78.059082 741.412964,77.797791 741.946716,79.657692 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M723.207153,83.788376 
	C723.263672,82.763191 723.618591,82.209877 724.388855,82.641472 
	C724.666870,82.797272 724.856018,83.560478 724.723328,83.908363 
	C724.433105,84.669716 723.845703,84.735466 723.207153,83.788376 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M382.338531,103.982300 
	C381.890381,103.682144 381.666656,103.386024 381.219543,102.918961 
	C381.601471,101.870934 382.297638,101.131561 383.787903,101.146584 
	C384.062164,101.842735 384.019287,102.507469 383.960541,103.507004 
	C383.811279,104.005478 383.677917,104.169159 383.278198,104.161453 
	C383.011902,103.990067 382.562958,103.986328 382.338531,103.982300 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M385.785858,108.917168 
	C385.025604,108.297554 384.662018,107.419342 384.873474,106.291000 
	C386.158691,106.833183 385.918091,107.824478 385.785858,108.917168 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M390.123718,103.685768 
	C389.946503,104.301247 389.868286,104.621162 389.841492,105.170258 
	C388.026184,104.545181 389.076630,103.193062 389.309448,101.980484 
	C389.613861,102.450386 389.918304,102.920296 390.123718,103.685768 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M379.340454,113.697769 
	C379.461975,113.047256 376.611206,113.411560 378.766846,112.050125 
	C379.710388,112.363190 380.022034,112.838539 379.340454,113.697769 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M378.219177,110.112099 
	C378.039062,109.837608 378.073669,109.672234 378.087646,109.254280 
	C378.067047,109.001701 378.511322,108.999832 378.732422,109.021759 
	C379.152771,108.853531 379.352051,108.663391 379.756226,108.832062 
	C379.802094,109.707390 379.643127,110.223892 379.246552,110.877197 
	C378.869263,110.712029 378.677612,110.447762 378.219177,110.112099 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M379.956604,108.918388 
	C379.792206,109.173897 379.623322,109.156914 379.203979,109.091805 
	C379.086243,108.652580 379.218964,108.261482 379.351685,107.870377 
	C379.551819,108.128883 379.751984,108.387383 379.956604,108.918388 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M388.069763,99.178635 
	C388.144104,99.004166 388.313904,98.997169 388.738281,98.998756 
	C388.789795,99.298126 388.662292,99.773666 388.069763,99.178635 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M388.112244,109.118393 
	C387.709045,109.847168 387.182556,110.296486 387.430389,108.790909 
	C387.623291,108.634743 387.951416,108.955009 388.112244,109.118393 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M383.098511,104.174622 
	C383.011902,103.990067 383.479065,103.919167 383.711853,103.880486 
	C383.835785,104.226143 383.799805,104.717468 383.098511,104.174622 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M417.931763,239.144348 
	C417.582947,238.590378 417.674835,238.122299 417.841919,237.304520 
	C418.718323,236.773453 419.725800,236.527664 420.023834,237.476334 
	C420.415741,238.723663 419.395294,239.078232 417.931763,239.144348 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M386.998047,239.385117 
	C387.134766,239.150894 387.305237,239.142044 387.729126,239.169540 
	C387.811920,239.581894 387.641266,239.957916 387.470642,240.333923 
	C387.324341,240.092789 387.178040,239.851639 386.998047,239.385117 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M115.092995,148.269104 
	C115.046555,147.931290 115.388542,147.870224 115.562248,147.870010 
	C116.004883,148.193115 116.345268,148.351196 116.971771,148.094543 
	C117.174545,147.872559 117.478828,147.844650 117.624054,147.800812 
	C117.851860,148.559509 117.958801,149.402145 116.919983,149.673691 
	C116.005867,149.912628 115.396194,149.524948 115.092995,148.269104 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M313.998169,151.001892 
	C313.368378,150.904190 312.649902,150.898376 312.514374,150.085052 
	C312.485809,149.913757 312.845428,149.677734 313.026154,149.471527 
	C313.329926,149.791412 313.633698,150.111313 313.970581,150.713470 
	C314.003662,150.995728 314.000000,151.000000 313.998169,151.001892 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M314.158081,141.914780 
	C313.994965,141.836639 313.996277,141.667953 313.999207,141.246170 
	C314.169983,141.162659 314.355804,141.320129 314.494904,141.511581 
	C314.524597,141.552460 314.384460,141.716766 314.158081,141.914780 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M311.466980,142.448853 
	C311.523529,142.415359 311.410461,142.482330 311.466980,142.448853 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M693.050415,70.711517 
	C692.451599,69.481758 693.191101,69.257469 694.480896,69.232788 
	C694.753235,70.131912 694.351868,70.712135 693.050415,70.711517 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M713.567627,95.491600 
	C714.746948,95.002449 715.496338,95.003395 716.620422,95.002609 
	C718.393982,95.689621 719.057800,96.902176 719.355530,98.697601 
	C718.218811,101.366539 714.392517,101.231895 714.175537,104.801147 
	C712.220215,105.107346 711.637878,102.668549 709.357727,103.013458 
	C709.230225,100.789139 708.889404,98.845016 705.963806,98.030746 
	C708.258240,97.206078 709.102478,95.025620 711.840698,95.269516 
	C712.648132,96.016724 712.397522,96.540024 712.519348,97.038971 
	C712.964600,96.826416 712.994507,96.370949 713.567627,95.491600 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M702.563843,105.691711 
	C699.958862,105.867142 698.962463,104.775963 699.164246,102.097412 
	C699.880249,100.883080 700.559265,100.415215 701.517029,99.374298 
	C705.272400,98.463066 705.473572,102.774437 708.643433,102.990822 
	C708.751099,103.804291 708.491150,104.607681 707.838257,105.913422 
	C705.771301,107.054520 704.766968,104.867203 702.563843,105.691711 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M693.354858,101.419426 
	C692.033997,102.070007 690.356018,101.863045 690.193420,102.266670 
	C687.682922,108.497238 686.720581,102.378693 685.067993,101.345512 
	C685.015198,101.006920 684.999512,101.002747 685.003052,101.008698 
	C685.877747,99.891190 687.197754,99.709450 688.705322,99.185089 
	C690.044800,98.994949 691.124451,98.995712 692.609009,99.000854 
	C693.585632,99.490761 693.759705,100.125084 693.354858,101.419426 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M699.001953,101.998016 
	C697.320557,101.797379 696.389709,102.754372 695.291321,103.919273 
	C693.801086,105.499786 693.058472,104.458015 692.995483,102.348053 
	C693.007080,101.992935 692.999084,102.000778 692.995972,102.004341 
	C693.604004,101.519218 693.911255,100.774200 694.741089,100.126389 
	C696.101196,99.673424 697.197510,99.341515 698.884766,99.249847 
	C699.770691,100.159081 699.773926,100.824928 699.225098,101.745766 
	C698.996094,102.004250 699.000000,102.000198 699.001953,101.998016 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M698.996216,98.996872 
	C698.607666,94.908043 701.344238,94.589439 704.374023,94.132423 
	C704.560547,96.433762 701.388245,96.170158 702.006042,98.640892 
	C701.997559,99.002480 702.000000,99.000000 702.000000,98.999542 
	C701.311584,99.578804 700.536682,99.729134 699.335938,99.229980 
	C698.993225,98.993118 698.999939,98.999519 698.996216,98.996872 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M683.043457,97.400932 
	C684.896118,97.083298 686.217590,94.606064 688.647461,95.997276 
	C688.798584,96.582626 688.635254,97.129265 688.232666,97.844833 
	C687.358765,98.844414 686.681274,99.621284 685.306274,99.953415 
	C683.560852,99.934769 682.959595,99.136292 683.043457,97.400932 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M685.000854,100.254578 
	C685.458069,98.958626 686.173889,98.227936 687.672974,98.035645 
	C688.100586,98.322990 688.284546,98.576332 688.755310,98.883987 
	C688.834534,101.167641 687.211975,100.950844 685.380493,101.006470 
	C685.004883,100.845741 685.003296,100.676842 685.000854,100.254578 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M695.002563,99.758583 
	C694.928528,100.915710 694.685669,101.707199 693.314270,101.965126 
	C692.993896,101.257095 692.995056,100.506279 693.005005,99.380356 
	C693.013855,99.005241 692.998718,99.001801 693.001221,99.007919 
	C693.387207,98.627419 693.847656,98.478226 694.692871,98.792404 
	C695.000671,99.018364 695.000183,99.511848 695.002563,99.758583 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M713.651550,92.049637 
	C713.998779,92.751732 713.999390,93.501610 713.998779,94.626495 
	C713.997559,95.001503 714.000000,95.000000 714.001221,94.999237 
	C713.617188,95.377480 713.157654,95.524918 712.313110,95.222153 
	C712.002441,95.003632 712.000000,95.000099 711.998779,94.998238 
	C712.051086,93.857658 711.769653,92.567856 713.651550,92.049637 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M694.962646,98.717010 
	C694.556824,99.016876 694.113037,99.015381 693.336426,99.013962 
	C693.235046,98.491127 693.333069,97.707275 693.728394,97.505287 
	C694.350586,97.187439 694.755981,97.788353 694.962646,98.717010 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M223.233719,120.873215 
	C222.910965,120.933594 222.966660,120.532784 223.016052,120.336472 
	C223.065430,120.140167 223.481857,119.948082 223.704346,119.895370 
	C223.803391,120.166046 223.679932,120.489441 223.233719,120.873215 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M653.001221,102.998978 
	C653.907532,102.866760 655.687866,103.160606 655.425598,102.152374 
	C654.629944,99.094460 656.456299,99.503441 657.496277,100.692039 
	C659.058350,102.477257 660.834961,101.142174 662.620178,101.716324 
	C661.618042,104.691925 657.034180,104.642540 657.101074,108.626106 
	C656.746521,109.036278 656.551636,109.152275 656.027466,109.177963 
	C654.614502,108.243217 653.715271,107.213943 652.626648,105.895782 
	C652.212952,104.898064 652.224182,104.214302 652.770996,103.273338 
	C652.997559,103.002014 653.000000,103.000000 653.001221,102.998978 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M670.935791,101.698288 
	C671.207947,102.781639 671.777527,104.063560 671.520447,104.259209 
	C669.840515,105.537743 669.152405,102.945992 667.334717,103.042648 
	C667.166138,100.750420 664.488037,100.920700 663.800537,99.427490 
	C664.905090,98.001472 666.164185,98.680557 667.688416,98.971878 
	C668.000000,99.000610 668.000000,99.000000 667.998779,98.999161 
	C668.793030,99.982452 670.242676,100.187523 670.935791,101.698288 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M663.774414,106.251617 
	C664.745361,105.998512 665.495605,105.996910 666.620850,105.995773 
	C666.995789,105.996246 667.011719,106.011391 667.019531,106.018700 
	C667.662537,106.892830 668.784485,106.961205 669.787354,107.789497 
	C670.002441,108.001221 670.000000,108.000000 669.998779,107.999390 
	C670.578186,108.686165 670.729065,109.460648 670.231445,110.661545 
	C669.995117,111.004410 670.000000,111.000000 670.002441,110.997787 
	C669.320801,111.576675 668.548523,111.729370 667.348328,111.237953 
	C667.004883,111.004280 667.000000,111.000305 667.000000,111.000153 
	C666.212891,109.924347 664.866516,109.707039 663.676270,108.691925 
	C663.245728,107.775581 663.259094,107.134399 663.774414,106.251617 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M663.644775,106.006378 
	C663.994873,106.750214 663.994568,107.500328 663.827515,108.872322 
	C663.058716,110.021667 662.350220,110.409470 661.505737,111.139297 
	C661.063416,111.427757 660.870911,111.523460 660.358643,111.690338 
	C658.655884,111.556488 656.961426,111.564171 658.705566,109.210617 
	C660.337524,107.897224 661.159058,106.009636 663.644775,106.006378 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M658.639404,109.001892 
	C658.249023,110.530113 658.786560,111.149254 660.696533,111.000031 
	C661.659424,111.661354 661.749939,112.447563 661.235962,113.654984 
	C661.000000,114.000748 661.000000,114.000000 661.000000,113.999619 
	C660.356750,114.564713 659.608093,114.761566 658.388916,114.493195 
	C656.491638,113.117043 655.250793,111.742928 655.795044,109.242760 
	C656.026855,108.912498 656.484680,108.924599 656.713074,108.922440 
	C657.394348,108.944237 657.847168,108.968201 658.639404,109.001892 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M193.908813,274.451233 
	C193.523148,274.811249 193.081390,274.872711 192.300400,274.956696 
	C191.410980,274.571838 191.016403,273.954102 191.622040,273.484192 
	C192.519867,272.787506 193.357376,273.092682 193.908813,274.451233 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M187.990845,274.987915 
	C188.083694,274.950195 188.185410,274.923615 188.154419,274.956940 
	C188.021729,275.016846 187.999710,274.999054 187.990845,274.987915 
z"/>
<path fill="#95A8AE" opacity="1.000000" stroke="none" 
	d="
M336.720520,137.129578 
	C337.052490,138.603302 336.846313,140.013550 334.370483,139.993958 
	C334.813263,139.086929 335.626526,138.173859 336.720520,137.129578 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M196.979034,256.087708 
	C197.009201,257.329315 196.843338,258.281403 195.784546,257.686188 
	C195.283356,257.404419 194.847336,256.147980 195.070999,255.631714 
	C195.429306,254.804611 196.328018,254.896851 196.979034,256.087708 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M474.926086,241.146332 
	C475.559448,240.990219 475.969025,240.992050 476.685638,240.995117 
	C476.771606,242.896149 474.971588,245.783157 479.662933,244.647995 
	C481.108459,242.420609 482.677399,243.188202 484.541443,244.152374 
	C484.744019,246.306396 487.710388,246.648239 486.783875,248.891571 
	C485.016174,249.658524 483.379120,248.596771 481.859131,249.287292 
	C481.513458,249.444321 481.267609,249.329926 481.121429,248.943665 
	C481.341705,249.744629 482.102417,249.342072 482.780884,249.838181 
	C482.806671,254.934021 479.051392,252.309082 476.454102,252.994339 
	C475.863586,252.960114 475.698669,252.932526 475.284058,252.881271 
	C474.662384,252.528091 474.519257,252.113174 474.804443,251.358856 
	C475.034729,251.093338 475.097198,250.668762 475.096924,250.454239 
	C475.711487,248.942474 475.698700,247.980560 473.558533,247.919708 
	C473.398743,245.980042 475.635651,244.784454 474.938904,242.217178 
	C474.843353,241.641174 474.772797,241.472717 474.926086,241.146332 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M473.256592,258.898560 
	C471.209320,258.074249 469.381104,257.754120 467.123535,258.897705 
	C466.697235,258.560333 466.624237,258.103760 466.625854,257.307800 
	C468.844269,256.937988 470.988007,256.907562 473.584290,256.865326 
	C474.572235,257.116943 475.107635,257.380432 475.643005,257.643890 
	C474.933685,257.998047 474.224396,258.352203 473.256592,258.898560 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M469.124023,254.143646 
	C470.470581,252.982437 471.705566,252.797943 473.246613,254.367462 
	C471.622162,255.047043 470.357819,254.872253 469.124023,254.143646 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M474.804199,251.218506 
	C475.026398,251.485947 475.018097,251.878540 475.022095,252.564362 
	C474.173920,252.568069 473.984894,252.074219 474.804199,251.218506 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M274.382751,156.453949 
	C273.590118,156.676498 273.300812,156.399994 273.422333,155.783371 
	C273.447540,155.655365 273.628906,155.482895 273.758301,155.463379 
	C274.381317,155.369415 274.640594,155.674210 274.382751,156.453949 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M57.334183,164.005600 
	C57.328903,162.817551 58.509727,163.168533 59.652206,162.746521 
	C59.876686,164.280579 58.577976,163.757980 57.334183,164.005600 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M62.649353,164.417297 
	C62.667423,164.638336 62.575825,164.716232 62.484226,164.794144 
	C62.411453,164.698822 62.274456,164.596481 62.283894,164.510162 
	C62.293404,164.423218 62.448414,164.352188 62.649353,164.417297 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M475.022949,240.730743 
	C475.149872,240.988373 474.959595,241.378387 474.936737,241.593994 
	C471.762817,241.768127 468.541351,242.834991 465.678741,240.923737 
	C466.565094,240.245544 467.263611,239.854370 467.825378,239.065506 
	C467.415405,238.595566 467.142151,238.523331 467.291687,238.482605 
	C467.714508,238.514130 467.910889,238.407654 467.945557,238.300659 
	C467.980194,238.193665 467.997894,238.115372 467.971954,238.084763 
	C468.159790,238.288956 468.398193,238.495270 468.802887,238.863174 
	C468.944519,239.053223 468.979065,239.039749 468.984802,239.057373 
	C469.288391,239.377411 469.556213,239.352676 469.929993,238.768585 
	C470.290222,238.648010 470.451111,238.588394 470.511230,238.216705 
	C471.766479,237.780396 472.641296,238.503571 473.750763,239.520676 
	C474.311737,239.978577 474.603882,240.225845 475.022949,240.730743 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M647.004456,104.995438 
	C647.460449,105.001503 647.912476,105.011528 648.703796,105.020050 
	C650.009521,104.188690 650.993713,104.151871 652.146790,105.341202 
	C651.992554,106.889580 651.213501,107.680748 649.869324,108.503738 
	C647.327698,108.845505 646.099976,108.110886 646.761475,105.361832 
	C646.997559,105.001831 647.000549,104.999390 647.004456,104.995438 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M652.487793,105.609680 
	C651.447571,105.107224 650.595764,105.007973 649.371277,105.016891 
	C649.167358,102.845566 650.776550,103.034248 652.622681,103.002792 
	C652.996338,103.751900 652.995178,104.501785 652.487793,105.609680 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M402.649475,260.899658 
	C402.990265,261.009003 403.080627,261.498169 403.001526,261.733917 
	C402.359497,261.780548 401.796570,261.591431 401.057068,261.149231 
	C401.356537,260.860870 401.832581,260.825592 402.649475,260.899658 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M457.228394,242.836761 
	C456.541077,243.376724 456.077271,243.656830 455.326172,243.948334 
	C455.027496,243.533325 455.016113,243.106918 455.005920,242.360138 
	C455.226868,241.794708 455.462494,241.566071 455.891663,241.183136 
	C456.235291,240.981491 456.401245,240.950577 456.802307,240.823120 
	C457.037445,240.726578 457.147705,241.002075 457.145203,241.150421 
	C457.415741,241.683716 457.527679,242.107620 457.228394,242.836761 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M455.834595,241.116608 
	C455.868195,241.281143 455.667114,241.549896 455.236572,241.929199 
	C455.204742,241.766785 455.402344,241.493805 455.834595,241.116608 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M671.351685,102.001114 
	C669.922424,101.364571 668.498413,101.131874 668.042114,99.319763 
	C670.442810,99.037849 672.903564,99.200348 675.601440,98.046463 
	C675.997559,97.998169 676.000000,98.000000 676.001221,98.000916 
	C677.282532,100.471954 675.084717,100.912407 673.379639,101.927048 
	C672.565613,101.997581 672.124084,101.998848 671.351685,102.001114 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M192.326172,240.550812 
	C192.682098,239.714249 193.445923,239.484558 194.249496,239.957458 
	C194.413788,240.054138 194.421219,240.417297 194.500946,240.657623 
	C193.893570,240.728256 193.286209,240.798889 192.326172,240.550812 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M191.837280,240.152008 
	C191.973495,240.232086 191.956116,240.382538 191.969040,240.457153 
	C191.981964,240.531754 191.573578,240.419434 191.573578,240.419434 
	C191.573578,240.419434 191.701080,240.071915 191.837280,240.152008 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M673.215332,102.255028 
	C673.975830,100.878929 674.944519,99.761536 675.957886,98.322983 
	C679.015564,97.041908 679.680908,101.006569 682.615356,100.990829 
	C682.510376,102.724815 685.187195,103.582054 684.104858,105.719910 
	C683.253601,105.991142 682.501587,105.988373 681.375977,105.994034 
	C679.938354,104.025032 680.313477,100.132973 676.056702,102.663940 
	C675.141174,102.838318 674.282349,102.676025 673.215332,102.255028 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M457.278198,243.173157 
	C457.063263,242.698135 457.121643,242.299652 457.161377,241.599976 
	C458.133148,241.213043 459.123566,241.127319 460.492615,241.047668 
	C460.591492,243.035675 459.252319,243.416000 457.278198,243.173157 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M216.678116,62.068741 
	C222.248962,63.596184 224.123688,58.860935 227.403961,56.640133 
	C230.657623,54.437351 226.741302,52.725479 227.275787,50.791348 
	C229.080795,49.985256 229.707016,52.556026 231.643951,51.996849 
	C233.331146,53.621048 234.675201,55.228302 235.987381,56.861176 
	C236.874725,57.965393 237.998444,58.417305 238.715225,56.998482 
	C239.475403,55.493736 240.211395,54.850018 241.670624,55.931648 
	C242.153427,56.289509 242.738907,56.905132 242.758011,57.422096 
	C242.831329,59.406929 240.723816,58.562054 239.905273,59.415207 
	C241.131821,61.814590 244.350891,62.330509 245.244247,64.448051 
	C245.607361,65.308807 242.753937,67.526543 240.714722,69.874504 
	C240.714722,68.217323 240.548798,67.681366 240.745392,67.390236 
	C241.371628,66.462898 242.638885,65.512405 241.241028,64.505127 
	C239.832916,63.490452 239.287460,64.832458 238.808868,65.922546 
	C238.415543,66.818504 237.584686,66.921631 236.373184,66.990128 
	C236.000610,66.999695 235.840530,66.838585 235.919952,66.919449 
	C236.039536,68.596146 235.859329,70.025299 233.368958,69.994560 
	C232.783325,69.791893 232.578552,69.572762 232.383865,69.344437 
	C232.189194,69.116119 232.252899,69.193245 232.788422,69.787048 
	C231.682770,74.023056 228.373932,75.699112 224.061935,76.946259 
	C222.980423,76.808846 222.575760,76.773468 221.569336,76.913788 
	C220.230270,77.021126 219.487991,77.015327 218.374695,77.006744 
	C218.003662,77.003967 218.000000,77.000053 217.999390,76.999420 
	C217.473633,76.463364 217.259537,75.816772 217.398331,74.748734 
	C217.830887,73.459808 219.612854,72.725060 217.729004,71.215302 
	C216.670425,69.695137 215.746231,69.238312 214.247513,70.178207 
	C213.065186,70.919685 211.606567,71.036209 210.728577,69.653984 
	C209.765274,68.137421 210.628403,66.828873 211.598221,65.620659 
	C212.870789,64.035248 214.466476,62.900089 216.678116,62.068741 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M274.167419,29.242111 
	C275.983124,26.076761 278.873535,24.647556 282.620667,23.999777 
	C283.000092,24.748486 282.997742,25.499056 282.917114,26.880131 
	C282.801697,27.677773 282.764526,27.844913 282.863068,28.505241 
	C282.998047,29.442997 282.997345,29.887562 282.998840,30.665527 
	C282.893372,31.317694 282.704376,31.577187 282.216980,31.888573 
	C279.607666,33.449593 278.368622,30.937908 276.276062,30.210052 
	C275.446472,29.833090 274.891846,29.659468 274.167419,29.242111 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M424.650482,33.038788 
	C425.215363,34.754818 422.296021,37.134224 426.091431,38.195858 
	C427.065033,38.468182 428.068542,39.342628 427.321442,40.371532 
	C426.598022,41.367821 424.956177,41.363518 424.147034,40.672268 
	C422.645905,39.389824 422.374725,37.037613 420.498901,35.949135 
	C421.389221,34.493317 422.757446,33.669865 424.650482,33.038788 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M437.360870,27.002953 
	C438.033966,22.933912 440.557465,26.649632 442.622375,25.994732 
	C442.901978,28.988171 445.690155,26.587090 446.667328,27.997478 
	C445.229553,29.862530 443.869843,31.001629 441.638885,28.883244 
	C440.596069,27.893017 439.409149,26.839226 437.360870,27.002953 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M360.995087,28.616032 
	C357.858429,29.225264 356.749329,27.425379 356.301453,24.323839 
	C359.007507,24.725586 361.307220,24.902988 360.995087,28.616032 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M426.267365,49.444065 
	C429.360840,51.306946 427.942444,54.067490 426.889893,57.003780 
	C425.862579,54.817638 426.058960,52.330452 426.267365,49.444065 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M360.622955,33.007114 
	C360.953583,33.332180 360.961243,33.683537 360.843231,33.985840 
	C360.369049,35.200603 360.107025,36.677311 358.440338,36.796364 
	C357.738342,36.846512 357.158142,36.293255 357.184570,35.537575 
	C357.252380,33.597763 358.591309,33.091232 360.622955,33.007114 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M300.399231,29.002787 
	C300.127197,26.944244 301.268066,26.002352 303.636230,26.005190 
	C303.998169,26.747660 303.998779,27.497587 303.998444,28.625431 
	C302.932800,29.005634 301.868073,29.007923 300.399231,29.002787 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M304.001221,26.001139 
	C304.067505,24.545050 303.838348,22.628244 305.802826,22.535435 
	C307.437286,22.458214 306.808533,24.228493 306.998383,25.630939 
	C306.246674,26.001396 305.497040,25.998827 304.372467,25.996994 
	C303.997559,25.997730 304.000000,26.000000 304.001221,26.001139 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M360.998169,32.998173 
	C360.996765,31.930323 360.997223,30.864302 360.999451,29.398397 
	C361.001221,28.998516 361.000000,29.000000 360.999390,29.000744 
	C361.748779,29.000648 362.498810,28.999809 363.625000,29.000374 
	C364.052826,30.782446 363.849945,32.414528 361.359070,32.960777 
	C361.003662,33.003368 361.000000,33.000000 360.998169,32.998173 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M296.998779,29.001095 
	C297.747040,29.001083 298.496521,28.999977 299.620544,28.997116 
	C299.995117,28.995363 300.000000,29.000000 300.002441,29.002388 
	C299.935669,30.461454 300.157104,32.376835 298.192047,32.462097 
	C296.557373,32.533028 297.194794,30.764675 297.002319,29.367128 
	C297.002441,28.997801 297.000000,29.000000 296.998779,29.001095 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M363.999390,28.999121 
	C364.072266,27.810987 364.415222,26.641876 365.671936,26.386221 
	C367.025513,26.110859 367.629333,27.142181 367.961487,28.664867 
	C366.930939,29.004028 365.865570,29.004038 364.400696,29.002913 
	C364.001221,29.001778 364.000000,29.000000 363.999390,28.999121 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M321.519104,23.890171 
	C322.641052,22.806192 323.724548,22.772772 324.587189,23.775465 
	C325.018524,24.276798 324.949158,25.210655 324.302917,25.451427 
	C323.089569,25.903482 322.167358,25.192989 321.519104,23.890171 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M396.420532,22.593716 
	C396.937927,23.939556 396.666168,24.740625 395.401428,24.769794 
	C394.700287,24.785967 394.199432,24.271305 394.227570,23.575079 
	C394.278595,22.314461 395.082764,22.050669 396.420532,22.593716 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M410.042358,25.348003 
	C411.438507,25.254089 412.916687,25.441229 413.694641,27.348652 
	C411.696167,28.271992 410.655304,27.557287 410.042358,25.348003 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M405.341278,28.937004 
	C405.102417,27.897976 404.686096,26.683084 405.576050,25.771669 
	C405.713776,25.630617 406.612030,25.869009 406.696167,26.100214 
	C407.113892,27.248005 407.088989,28.343279 405.341278,28.937004 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M434.269226,32.536827 
	C432.924500,32.904968 432.118866,32.608662 432.242615,31.327955 
	C432.274231,31.000563 432.796661,30.455486 433.079834,30.464083 
	C434.217590,30.498617 434.700989,31.196177 434.269226,32.536827 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M424.999390,32.999542 
	C425.104370,31.938540 424.734955,30.621078 426.220490,30.235542 
	C426.831116,30.077068 427.596283,30.242899 427.567993,31.113777 
	C427.530792,32.257748 426.650513,32.672447 425.341125,32.962570 
	C425.001221,33.000824 425.000000,33.000000 424.999390,32.999542 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M369.304688,36.477798 
	C369.704102,37.830688 369.211304,38.528934 368.064789,38.539555 
	C367.780457,38.542191 367.268188,37.981617 367.242798,37.650650 
	C367.143921,36.359982 367.962677,36.082626 369.304688,36.477798 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M223.999084,76.998947 
	C223.909790,78.130959 223.654099,79.309158 222.406754,79.548477 
	C221.061768,79.806534 221.107880,78.608307 220.982376,77.368073 
	C220.972549,77.026924 220.999451,77.000847 221.012726,76.988266 
	C221.713150,76.415855 222.478256,76.259560 223.664185,76.766747 
	C224.002304,77.002037 224.000000,77.000000 223.999084,76.998947 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M396.647400,37.526150 
	C395.252808,37.587204 395.072266,36.903553 395.641144,36.147018 
	C395.939087,35.750828 396.896118,35.340851 397.158875,35.519726 
	C398.074921,36.143295 397.456482,36.816696 396.647400,37.526150 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M372.001404,22.002001 
	C371.303467,23.207886 371.021027,24.833296 368.775787,24.965639 
	C368.775513,23.044178 370.003540,22.507759 371.667572,22.026344 
	C371.995605,21.995861 372.000000,21.999962 372.001404,22.002001 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M371.678589,27.501122 
	C371.493805,26.060532 372.266541,26.046696 373.116211,26.345736 
	C373.314697,26.415585 373.546631,26.928051 373.473755,27.134916 
	C373.205048,27.897482 372.561829,27.903261 371.678589,27.501122 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M307.001831,25.997988 
	C307.752167,25.994858 308.500671,25.993740 309.625793,25.997299 
	C309.487457,28.194044 308.568390,28.626684 307.048279,26.336246 
	C306.996338,26.003967 307.000000,26.000000 307.001831,25.997988 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M415.794312,42.786850 
	C414.780090,42.726006 414.226227,42.375797 414.651520,41.610703 
	C414.803864,41.336666 415.563995,41.153622 415.911316,41.285522 
	C416.666290,41.572243 416.737488,42.153664 415.794312,42.786850 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M416.658997,29.003700 
	C416.864685,29.968979 416.632385,30.910030 415.381378,30.784681 
	C415.061920,30.752666 414.516968,30.235008 414.541077,29.985439 
	C414.644623,28.913555 415.602600,29.131767 416.658997,29.003700 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M405.001068,29.001030 
	C404.859650,29.966318 404.622833,30.904644 403.377747,30.781839 
	C403.060242,30.750525 402.516998,30.232487 402.541931,29.984810 
	C402.649139,28.919470 403.600647,29.127527 404.657074,29.002171 
	C404.997559,28.997940 405.000000,29.000000 405.001068,29.001030 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M423.206787,27.212830 
	C424.224396,27.273457 424.773712,27.628666 424.349487,28.392700 
	C424.197296,28.666819 423.436615,28.850922 423.090271,28.718596 
	C422.336517,28.430573 422.263397,27.847816 423.206787,27.212830 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M283.000000,27.000072 
	C283.750305,26.998526 284.500610,26.996908 285.624847,26.996933 
	C285.912079,28.443336 285.082306,29.032431 283.351746,28.994564 
	C282.998779,28.998430 283.000000,29.000000 283.000610,29.000786 
	C282.622162,28.615366 282.475250,28.155066 282.780212,27.310257 
	C283.000000,26.999847 283.000000,27.000000 283.000000,27.000072 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M466.003113,28.003273 
	C465.861389,28.968328 465.627441,29.908823 464.382416,29.785179 
	C464.063812,29.753540 463.519958,29.237755 463.543610,28.988400 
	C463.644958,27.919487 464.601166,28.134933 465.652893,28.000351 
	C465.992676,27.993221 466.000000,27.999901 466.003113,28.003273 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M400.627197,32.139679 
	C401.725433,32.876316 401.080719,33.303986 400.514130,33.525047 
	C400.262573,33.623199 399.812775,33.213169 399.452942,33.033806 
	C399.755859,32.727966 400.058807,32.422131 400.627197,32.139679 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M420.042053,24.353951 
	C420.633423,24.647598 420.951996,24.976208 421.270569,25.304825 
	C420.895935,25.477486 420.466492,25.861124 420.157562,25.780861 
	C419.410492,25.586763 419.100555,25.075989 420.042053,24.353951 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M378.721375,26.140219 
	C378.873627,26.872078 379.299469,27.938795 378.204773,28.463987 
	C378.031830,28.546957 377.523224,28.352633 377.466675,28.185863 
	C377.152344,27.258785 377.840363,26.778587 378.721375,26.140219 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M377.998901,24.000954 
	C378.896484,24.167841 380.105988,23.620308 380.479309,24.954519 
	C380.541382,25.176342 379.927216,25.587379 379.312744,25.955452 
	C379.000000,25.999924 379.000000,26.000000 379.000000,26.000038 
	C378.738251,25.505600 378.476501,25.011120 378.107971,24.257401 
	C378.001221,23.998158 378.000000,24.000000 377.998901,24.000954 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M419.349792,33.558136 
	C418.706177,33.688282 418.257111,33.627750 417.808075,33.567215 
	C418.003174,33.195641 418.110840,32.622623 418.410706,32.492542 
	C419.134857,32.178383 419.665863,32.426968 419.349792,33.558136 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M462.013336,36.964760 
	C461.425293,36.824509 460.615631,36.874798 461.172211,36.294701 
	C461.455475,35.999454 462.525299,35.989494 462.824860,36.279297 
	C463.407043,36.842491 462.604980,36.822235 462.013336,36.964760 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M455.958038,37.591446 
	C455.229675,37.195087 455.224365,36.795269 455.741211,36.441429 
	C455.849762,36.367119 456.101105,36.368698 456.206787,36.445358 
	C456.714020,36.813438 456.693573,37.213249 455.958038,37.591446 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M422.035583,42.280800 
	C422.624268,42.097839 423.341003,42.096176 423.482361,42.904739 
	C423.512054,43.074306 423.155151,43.311470 422.976379,43.517471 
	C422.674744,43.198570 422.373138,42.879673 422.035583,42.280800 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M438.953552,31.594734 
	C438.227203,31.198254 438.217651,30.797913 438.734497,30.442789 
	C438.842468,30.368616 439.094116,30.371788 439.200012,30.448759 
	C439.705536,30.816036 439.689850,31.216072 438.953552,31.594734 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M371.036560,33.282188 
	C371.634796,33.086506 372.352112,33.090820 372.491058,33.907455 
	C372.520447,34.080326 372.161377,34.319294 371.981293,34.527798 
	C371.678162,34.207111 371.375000,33.886433 371.036560,33.282188 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M286.000610,27.000769 
	C286.088562,26.368252 286.077759,25.644018 286.897552,25.497232 
	C287.070496,25.466261 287.313293,25.825384 287.523926,26.004761 
	C287.203827,26.310799 286.883728,26.616837 286.281189,26.960724 
	C285.998779,26.998575 286.000000,27.000000 286.000610,27.000769 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M449.043549,24.404726 
	C449.775238,24.802975 449.782990,25.205259 449.262756,25.561689 
	C449.153839,25.636332 448.901031,25.633865 448.794556,25.556629 
	C448.285156,25.187195 448.301666,24.785330 449.043549,24.404726 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M443.001160,26.001156 
	C443.092712,25.373507 443.094208,24.658577 443.904297,24.516008 
	C444.074738,24.486008 444.313232,24.842630 444.520355,25.021109 
	C444.200195,25.322174 443.880066,25.623236 443.278748,25.961065 
	C442.997559,25.997833 443.000000,26.000000 443.001160,26.001156 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M401.998779,23.000998 
	C402.630310,23.094158 403.348267,23.099628 403.490845,23.913530 
	C403.520691,24.083862 403.161194,24.322395 402.981110,24.529499 
	C402.678345,24.207487 402.375549,23.885475 402.037476,23.280670 
	C402.002197,22.997877 402.000000,23.000000 401.998779,23.000998 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M437.003174,27.003410 
	C436.910431,27.635862 436.905518,28.353603 436.091675,28.489704 
	C435.919128,28.518566 435.681854,28.160273 435.474426,27.980345 
	C435.792908,27.675617 436.111359,27.370892 436.711243,27.029751 
	C436.992676,26.993336 437.000000,26.999945 437.003174,27.003410 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M430.044861,27.399578 
	C430.779938,27.799610 430.786865,28.203768 430.265289,28.561989 
	C430.156067,28.637028 429.902100,28.634518 429.795074,28.556971 
	C429.282990,28.185898 429.301147,27.782139 430.044861,27.399578 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M416.999390,28.999352 
	C417.091064,28.369535 417.098663,27.656467 417.906097,27.513515 
	C418.075867,27.483461 418.314087,27.839836 418.520752,28.018147 
	C418.201416,28.320715 417.882111,28.623283 417.281982,28.963541 
	C417.001221,29.001230 417.000000,29.000000 416.999390,28.999352 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M368.001831,28.998142 
	C368.634369,29.091999 369.353943,29.096380 369.490692,29.912485 
	C369.519531,30.084782 369.159363,30.322243 368.978455,30.529673 
	C368.674255,30.209478 368.370026,29.889286 368.031067,29.286556 
	C367.996338,29.004019 368.000000,29.000000 368.001831,28.998142 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M441.329468,33.797997 
	C440.908173,34.314671 440.399475,34.645267 440.375946,33.859867 
	C440.360535,33.345673 440.889252,33.132545 441.329468,33.797997 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M409.995667,25.004107 
	C409.566437,24.882294 409.141266,24.756668 408.716125,24.631046 
	C409.034882,23.941505 409.399628,24.307142 409.882935,24.788948 
	C410.005310,24.992373 409.999756,25.000296 409.995667,25.004107 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M422.000610,41.999557 
	C421.580261,41.881027 421.159271,41.762936 420.738312,41.644844 
	C421.048798,40.944420 421.404175,41.345383 421.876678,41.802139 
	C421.999634,42.000824 422.000000,42.000000 422.000610,41.999557 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M393.467590,40.449299 
	C393.521210,40.417645 393.414001,40.480953 393.467590,40.449299 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M420.455475,30.529781 
	C420.425171,30.477924 420.485779,30.581636 420.455475,30.529781 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M304.001831,28.998718 
	C304.121246,29.138277 304.238861,29.279114 304.356445,29.419949 
	C304.272400,29.371492 304.188324,29.323038 304.050903,29.138966 
	C303.997498,29.003347 304.000000,29.000000 304.001831,28.998718 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M370.999390,33.000511 
	C370.882294,32.862511 370.765778,32.724003 370.649292,32.585495 
	C370.731720,32.633793 370.814148,32.682095 370.948914,32.864510 
	C371.001221,32.998627 371.000000,33.000000 370.999390,33.000511 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M305.451569,31.527378 
	C305.419647,31.472996 305.483490,31.581762 305.451569,31.527378 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M309.998901,25.998688 
	C310.087952,25.962885 310.178131,25.928392 310.135376,25.947937 
	C310.002441,26.001976 310.000000,26.000000 309.998901,25.998688 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M82.254814,97.244980 
	C82.982536,94.136284 78.740654,94.220352 79.009583,91.372162 
	C81.468597,91.296944 82.399048,89.755089 82.962112,87.358917 
	C85.297897,87.102310 86.963348,86.437111 86.998169,83.380745 
	C88.356552,81.344856 90.408607,80.744957 92.421501,79.480576 
	C95.087387,78.953598 96.415382,77.228821 97.940506,75.227142 
	C98.308075,74.810341 98.462616,74.649788 98.864906,74.264694 
	C100.044647,73.375969 100.892746,72.594749 101.571281,71.695091 
	C102.392082,70.606812 104.451408,69.967476 103.695221,68.280403 
	C103.064835,66.874008 101.273582,66.868408 99.466293,66.786957 
	C98.923798,66.733284 98.709854,66.694153 98.194336,66.538284 
	C97.024734,65.839401 96.169685,65.232361 94.827515,64.868759 
	C94.336922,64.647820 94.147728,64.540016 93.718910,64.205734 
	C92.593575,62.454411 91.283249,61.129116 91.298004,58.872292 
	C91.463943,58.331760 91.569420,58.128407 91.944000,57.710484 
	C92.866844,57.215981 93.533142,57.192226 94.487106,57.583347 
	C95.443733,58.696289 96.569008,58.937141 97.697205,59.724915 
	C98.121819,60.115208 98.287949,60.461124 98.489853,60.489990 
	C98.857056,60.542488 98.849220,60.418110 98.219971,60.211174 
	C97.364967,59.158199 96.246910,59.034466 95.200516,58.190296 
	C94.465454,57.458885 94.247322,56.852242 94.652634,55.572411 
	C96.391861,55.030174 97.268600,54.572231 98.231255,53.305740 
	C99.554085,51.565380 101.531036,49.957142 103.934700,52.650414 
	C101.486237,53.112419 99.588379,53.519901 102.447968,56.201164 
	C103.513206,57.199982 104.556252,58.241299 105.726089,59.105278 
	C107.450592,60.378902 108.762917,60.286423 108.998337,57.363167 
	C110.134514,56.369965 114.236488,58.493855 111.420609,54.274235 
	C110.525490,52.932903 111.839622,52.265392 112.771797,51.551003 
	C114.544289,50.192604 116.676720,49.455769 117.986107,47.275185 
	C118.974487,45.629208 121.010292,46.002563 122.117249,47.732487 
	C124.193047,50.976498 126.293777,50.347382 128.532745,47.999638 
	C130.411774,46.029339 132.082870,43.786751 134.219116,42.152412 
	C137.786591,39.423115 137.652649,44.267818 139.507324,45.208160 
	C140.840240,45.883965 142.177429,48.018749 139.399155,48.842857 
	C136.509567,49.699986 136.054871,52.113846 135.004929,54.619362 
	C132.963516,56.628689 131.709488,55.215389 130.396179,53.970558 
	C131.518127,55.102493 132.380920,56.888134 134.767227,55.240402 
	C139.103180,52.180424 143.869583,50.162167 146.381577,45.430843 
	C146.866180,44.518074 147.754593,43.860806 148.843613,44.276237 
	C150.272583,44.821354 149.365356,45.876305 149.224152,46.769188 
	C149.095947,47.579773 149.071930,48.406837 148.794983,49.893074 
	C146.298981,51.808533 144.686539,54.055367 141.618546,54.984291 
	C143.132904,55.361408 144.231384,54.800987 145.527039,55.405937 
	C149.828400,59.039742 149.919846,53.737141 152.479965,52.415569 
	C154.654694,52.160553 156.839264,51.377277 156.940796,54.942150 
	C156.203888,57.693043 158.331802,58.772293 158.568970,60.843803 
	C158.514526,61.403603 158.447906,61.620735 158.150146,62.085609 
	C156.474747,62.966923 155.391953,62.231331 154.270615,61.332817 
	C154.297256,62.306244 155.241226,62.716095 155.546967,63.834099 
	C155.720551,64.482193 155.865463,64.893097 155.707306,65.127983 
	C153.078262,69.032547 152.719131,72.921684 155.344345,77.414162 
	C153.879196,77.492439 152.760834,76.982132 151.561951,76.435081 
	C149.975861,80.223717 155.362488,80.276390 154.991486,83.634789 
	C152.543381,83.791748 150.201981,87.561340 147.654404,84.212753 
	C145.906998,85.793404 144.208603,87.433609 142.391525,88.929642 
	C141.480881,89.679390 140.751663,92.086037 139.073883,88.994186 
	C139.442978,87.236176 140.374405,85.931229 137.815079,85.684937 
	C137.307373,85.502853 137.115936,85.400681 136.722198,85.052437 
	C134.445221,81.922661 133.885406,84.598793 132.960861,86.394363 
	C132.270477,89.703239 135.564514,90.191200 135.957886,92.648544 
	C134.934219,92.997971 133.867233,92.997162 132.085297,92.875763 
	C128.401764,92.440460 125.244682,92.988121 123.324211,89.542595 
	C122.395126,87.875710 120.616722,89.764229 119.733063,89.686554 
	C123.266548,88.030045 124.523430,91.539902 126.576385,94.013474 
	C126.506958,95.628944 125.681061,96.529198 124.790527,97.784012 
	C124.363220,98.191917 124.172997,98.332245 123.652931,98.595078 
	C120.068733,97.031952 115.672081,100.461548 112.659653,96.236710 
	C112.180244,95.961563 111.989326,95.850433 111.505280,95.591263 
	C107.488861,95.764374 103.437241,94.107254 100.179764,97.284401 
	C99.965286,97.493576 99.455032,97.643997 99.252007,97.503044 
	C93.667107,93.625938 88.079140,99.442986 82.254814,97.244980 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M208.572357,78.570724 
	C203.325958,83.040802 200.896469,79.286415 198.185623,76.235443 
	C195.060638,72.718399 192.317871,74.702713 190.202148,77.323715 
	C188.907349,78.927719 187.509857,80.081520 185.355652,80.954941 
	C185.881470,76.811699 185.881470,76.811699 181.316895,77.483467 
	C182.126282,75.668961 183.184784,74.288330 184.666931,73.312988 
	C185.689102,72.640335 187.725861,72.519623 186.413071,70.696220 
	C185.422363,69.320190 184.431473,70.668373 183.578873,71.414291 
	C183.041107,71.884758 182.419876,72.033669 181.666122,71.425903 
	C181.489120,67.730858 186.473831,67.947784 186.988373,64.376068 
	C184.134079,60.468685 179.666000,60.545258 175.440399,58.541405 
	C176.740356,51.159931 183.068726,48.547821 187.669174,44.355804 
	C187.953964,44.096298 188.975967,44.327324 189.427673,44.649143 
	C190.008362,45.062840 189.981033,45.841614 189.451584,46.388680 
	C188.600983,47.267570 185.983047,47.592457 188.257980,49.446362 
	C189.764008,50.673668 191.225494,51.149971 193.552948,49.773663 
	C195.969772,48.344505 197.571198,44.072678 201.933929,46.456692 
	C202.885101,46.976467 203.034393,45.004692 201.855499,44.138191 
	C198.048691,41.340137 200.692444,40.687782 203.622040,40.006912 
	C204.983490,43.003323 205.077530,43.105419 206.990936,41.342953 
	C207.665802,40.721306 208.076263,40.131004 208.916367,40.716408 
	C209.651489,41.228657 210.015289,42.107300 209.354645,42.828358 
	C206.180893,46.292412 203.591064,50.453529 198.373734,51.993828 
	C198.314926,54.670757 194.975510,56.328667 196.006989,59.601101 
	C195.403503,60.651241 194.566711,60.703625 193.525085,60.961876 
	C193.134018,61.139111 192.995010,61.231258 192.700684,61.499294 
	C192.387558,61.968563 192.364548,62.272511 192.588394,62.819473 
	C192.963257,63.537811 193.203262,64.034760 193.522049,64.825470 
	C193.646439,65.311554 193.673874,65.512726 193.674728,66.022263 
	C193.578918,66.528557 193.509689,66.726494 193.260849,67.184280 
	C192.694977,67.893265 192.217911,68.277359 192.074890,69.133743 
	C192.099243,69.384247 192.438675,69.705421 192.682098,69.621468 
	C193.092255,69.454201 193.259003,69.370888 193.704788,69.192474 
	C194.822510,68.906670 195.665405,68.898254 196.842010,69.128860 
	C197.593353,69.408546 197.976379,69.657082 198.551300,70.220840 
	C199.566528,71.747902 200.604721,72.831909 201.449585,74.051666 
	C202.891937,76.134026 204.351883,75.818100 206.178955,74.026001 
	C206.644287,73.668121 206.844650,73.540794 207.381119,73.285980 
	C209.234100,72.925774 210.841232,72.875618 211.341507,74.650452 
	C211.832718,76.393066 209.940903,77.002304 208.572357,78.570724 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M174.993622,75.639481 
	C173.576797,75.833763 172.153580,75.667221 169.741898,75.385002 
	C174.734482,79.213402 167.885117,80.313301 168.999329,83.612549 
	C167.612320,83.998207 166.223434,83.997337 164.416656,83.997696 
	C164.097580,80.372986 161.533066,79.089592 158.064697,77.826981 
	C157.045029,77.294899 156.782196,76.883224 156.504181,76.479568 
	C152.024384,69.974998 152.159546,69.061989 158.519073,63.547344 
	C159.035217,63.099777 159.431122,62.637962 159.505051,61.612907 
	C159.507782,58.920399 156.433487,58.077354 156.847534,55.292439 
	C157.000000,55.000305 157.000000,55.000000 157.000000,54.999847 
	C158.125351,55.156612 159.458847,54.989338 160.327087,55.546753 
	C161.615921,56.374176 162.557617,57.449406 164.201263,56.234959 
	C166.592941,54.467804 164.028473,54.141571 163.484116,53.150547 
	C163.312012,52.837250 163.807465,51.902351 164.241013,51.564838 
	C165.116989,50.882900 165.947052,51.502850 166.907288,51.775536 
	C170.349014,52.752884 171.069901,56.827503 174.649185,57.961464 
	C175.000610,58.000610 175.000000,58.000000 174.999695,57.999695 
	C175.952393,59.491402 178.607346,59.132305 178.762833,61.804417 
	C178.683502,62.340652 178.620178,62.546776 178.385742,63.020348 
	C177.608780,64.018135 176.464630,64.301094 176.389297,65.761932 
	C176.388290,66.851479 176.637924,67.540001 177.660477,68.510826 
	C178.000931,71.745949 177.032974,72.906654 174.518585,70.925423 
	C173.239212,69.917336 172.119827,68.684219 171.038040,67.456017 
	C170.439056,66.775940 169.559036,65.774406 171.301605,65.353477 
	C172.127289,65.154022 174.251297,66.527885 173.331161,64.358665 
	C172.303757,61.936581 170.143082,63.926842 168.633789,64.391861 
	C167.311523,64.799255 166.444443,66.158638 167.703278,67.465042 
	C168.551804,68.345612 170.166245,68.525223 169.989777,70.626617 
	C169.999390,70.999695 169.671997,71.319313 169.671997,71.319313 
	C169.671997,71.319313 169.721207,71.279938 169.860901,71.140121 
	C172.300278,71.683434 174.561066,72.411865 174.993622,75.639481 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M93.261139,79.791962 
	C91.434883,81.338005 90.012596,82.932426 87.363144,83.000153 
	C87.005165,83.005165 86.999702,82.999702 86.997406,82.997406 
	C86.421005,82.308907 86.266273,81.538361 86.765114,80.341797 
	C87.870743,79.141319 88.744240,78.285408 89.816963,77.189789 
	C90.785507,76.239433 91.503395,75.477112 92.458252,74.548462 
	C93.161003,73.907211 92.417572,74.493706 92.932693,74.070511 
	C92.818451,74.047379 92.812607,74.176010 92.457703,74.352066 
	C88.694405,72.891113 91.307968,76.462952 89.910461,77.095932 
	C88.975227,77.737236 88.282585,77.745842 87.286682,77.226082 
	C86.139183,76.151894 85.153297,75.428726 84.223129,74.221954 
	C84.008263,74.008636 83.999969,73.999985 83.995682,73.995674 
	C82.365326,71.937218 80.988731,69.634354 78.239571,68.231163 
	C78.000641,68.000641 78.000000,68.000000 77.999542,67.999680 
	C76.139481,66.855179 74.188454,65.849663 72.266373,64.197784 
	C71.999695,63.999847 72.000000,64.000000 71.999847,63.999779 
	C71.999489,60.176308 72.811394,59.817005 77.429245,61.894974 
	C79.013496,62.688454 80.493599,63.445881 80.457390,61.070099 
	C80.427505,59.108547 81.437393,58.464111 82.860512,58.068695 
	C82.680702,57.988861 82.232735,57.896370 82.232735,57.896370 
	C82.232735,57.896370 81.780266,57.970253 81.535248,58.099808 
	C80.958023,58.438274 80.630898,58.654888 80.045570,59.058296 
	C78.579758,60.018539 77.278748,61.313782 75.932106,59.878880 
	C74.842354,58.717712 74.221298,59.139542 73.087891,59.706211 
	C69.401001,61.549545 68.701294,59.807140 69.774750,56.246784 
	C70.002159,55.997803 70.000000,56.000000 69.998924,56.001144 
	C70.750145,55.254639 71.582993,54.521313 70.225845,53.218414 
	C69.997864,52.997849 70.000000,53.000000 70.001144,53.001072 
	C69.711372,50.271824 66.495872,50.215309 65.212006,47.508926 
	C68.930862,47.300327 71.415359,49.256386 73.941788,50.979679 
	C75.404800,51.977604 76.745918,52.928448 76.428917,49.977055 
	C76.295769,48.737450 76.591644,48.359386 77.669792,48.903111 
	C79.366371,49.758713 80.068665,49.362156 81.579262,47.879139 
	C83.754654,45.743465 84.150063,48.872776 84.960037,50.642014 
	C84.276306,51.900665 83.206581,51.950165 82.015060,52.223488 
	C81.836525,52.307224 81.839592,52.636806 81.916794,52.449444 
	C82.816544,51.883629 83.820946,52.062107 84.778549,51.211311 
	C85.867538,50.841854 86.736916,50.685692 87.821198,50.271656 
	C88.036118,50.013783 88.345688,49.661278 88.514374,49.498375 
	C88.683060,49.335472 89.014542,49.003895 89.177940,48.835884 
	C89.341339,48.667870 89.666252,48.330120 89.834045,48.166546 
	C90.446693,48.005131 90.891548,48.007294 91.670059,48.009106 
	C93.224586,47.709629 94.394020,47.754673 95.724594,48.763954 
	C98.679436,51.323669 94.290901,52.325588 95.003403,54.639469 
	C94.996239,54.999237 95.000000,54.999962 94.999641,54.998096 
	C94.728134,56.424908 91.044220,54.327408 92.219315,57.737709 
	C92.001221,57.999695 92.000000,58.000000 91.999847,58.000610 
	C90.900597,59.413929 88.534431,60.335930 90.300575,63.080765 
	C90.830391,64.305496 90.756264,65.449318 91.958237,66.334763 
	C92.355904,66.703072 92.509590,66.860085 92.872421,67.277008 
	C94.118317,69.080215 95.527138,70.103455 97.266266,70.778267 
	C98.896889,71.410965 100.191490,72.374954 99.220642,74.734604 
	C98.995811,74.997025 99.000000,75.000000 98.998566,74.997932 
	C96.689796,75.950798 95.784111,78.578331 93.261139,79.791962 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M217.006805,61.995583 
	C216.664688,64.706421 213.209305,64.241791 212.347168,66.596466 
	C211.993378,67.562737 210.456390,68.258820 211.680023,69.435387 
	C212.606247,70.325996 213.380127,69.555702 214.095291,68.762321 
	C216.628723,65.951797 217.569366,67.472572 217.807404,70.915123 
	C214.763901,74.933899 210.871597,72.897522 207.244720,73.755074 
	C207.002441,73.997566 207.000000,74.000000 206.998779,74.001266 
	C205.739792,74.902199 204.293442,76.577316 202.912277,74.831215 
	C201.069275,72.501289 203.267639,70.746071 204.717697,68.659233 
	C205.082687,68.174164 205.242310,67.994934 205.672791,67.590012 
	C207.248108,66.651985 208.658722,65.985001 206.429977,64.614418 
	C205.580963,64.092316 205.231735,63.211903 205.165894,61.892860 
	C205.316315,60.643951 205.657410,59.802280 206.532745,58.491531 
	C209.067993,57.666771 211.135361,57.334003 213.601074,57.000313 
	C214.000519,57.441708 214.001648,57.884022 214.005020,58.658073 
	C214.007263,58.989811 213.870300,59.404011 213.823547,59.618999 
	C213.776810,59.833988 214.067154,60.213455 214.277374,60.362175 
	C215.128510,60.949482 215.921631,61.091793 216.774902,61.777756 
	C217.006226,61.988258 217.001022,61.998394 217.006805,61.995583 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M96.045334,48.675095 
	C94.821442,48.848698 93.648758,48.694248 92.239883,48.274277 
	C91.724739,47.079205 90.916946,45.728973 91.261703,45.295586 
	C92.511253,43.724796 93.581360,46.863987 95.385139,45.394043 
	C96.230980,44.551132 94.765007,44.080627 94.414833,43.313927 
	C93.816566,42.004047 94.326347,41.048954 95.480858,40.421543 
	C96.516304,39.858845 97.315552,40.255314 98.039848,41.150639 
	C98.759003,42.039608 99.557487,42.904064 100.463898,43.590923 
	C101.404587,44.303761 103.544403,44.230549 102.560783,46.127373 
	C101.789299,47.615093 100.728317,46.254494 99.688530,45.879120 
	C97.620041,45.132374 97.003372,47.074585 96.045334,48.675095 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M169.402008,47.378006 
	C172.770844,44.895630 174.568573,46.864925 176.109314,49.202904 
	C177.435593,51.215439 175.239807,51.639610 174.331955,52.586552 
	C171.941666,55.079823 171.625412,51.374779 170.088272,51.094486 
	C167.744232,50.667057 167.566345,49.282127 169.402008,47.378006 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M196.753632,60.307793 
	C200.887741,60.457180 201.191238,58.863327 199.003937,56.217590 
	C200.692749,54.249828 202.582413,59.096745 203.956757,55.338608 
	C204.188904,54.860981 204.366806,54.720356 204.878571,54.523270 
	C205.430145,54.520569 205.647858,54.574333 206.114166,54.852177 
	C206.670227,55.702984 206.517593,56.359859 206.466599,57.326351 
	C206.113403,58.653709 205.398453,59.448032 204.745819,60.643597 
	C204.430023,61.075241 204.284790,61.236015 203.870850,61.584957 
	C202.388458,62.339348 201.220001,62.995441 199.670624,63.671658 
	C198.293243,63.865673 197.376068,63.646683 196.527893,62.458862 
	C196.281296,61.599026 196.334198,61.100731 196.753632,60.307793 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M221.617004,49.996857 
	C221.920883,54.727112 218.344147,55.858150 214.386292,56.997276 
	C213.999390,56.999390 214.000000,57.000000 214.000305,57.000305 
	C215.497772,53.726299 217.540573,51.015526 221.617004,49.996857 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M52.007187,33.356766 
	C57.148060,34.545448 57.148060,34.545448 61.643898,33.002293 
	C61.414116,36.420059 57.679585,36.583393 55.957214,38.831642 
	C54.831745,36.980145 52.413700,36.124146 52.007187,33.356766 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M232.368652,37.010551 
	C232.228760,35.537609 232.611435,33.318745 234.115692,33.738213 
	C235.788010,34.204540 237.340530,35.974831 238.376053,37.551292 
	C239.098175,38.650612 237.478134,39.543190 236.612808,40.160374 
	C235.588089,40.891239 235.153091,39.920238 235.036041,39.079266 
	C234.842758,37.690563 234.127609,37.010773 232.368652,37.010551 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M206.271805,58.205307 
	C206.017517,57.271389 206.008804,56.521610 205.999344,55.396912 
	C205.832001,54.887524 205.665405,54.753056 205.243347,54.813164 
	C204.987869,55.007744 204.499283,55.006641 204.255127,55.004120 
	C202.988281,54.817593 201.874146,54.568768 202.603943,53.188072 
	C203.129395,52.193996 204.255066,50.798401 205.226318,51.619144 
	C206.621674,52.798286 209.024841,52.373531 209.662872,54.228527 
	C210.344742,56.211033 207.298676,55.686832 207.060547,57.650978 
	C207.000610,57.999542 206.999405,58.000305 206.997482,58.002396 
	C206.836166,58.132805 206.676773,58.261124 206.271805,58.205307 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M160.941315,30.340679 
	C161.937714,30.090502 163.162949,29.747868 163.544159,30.920561 
	C163.873795,31.934574 163.189407,32.907902 162.384384,33.440891 
	C161.598297,33.961334 160.473206,33.965332 159.677841,34.477165 
	C158.567307,35.191811 157.427444,36.499851 156.592575,34.517738 
	C155.953125,32.999638 157.677429,32.778660 158.604034,32.285469 
	C159.440872,31.840057 160.575806,31.871723 160.941315,30.340679 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M76.047066,27.324951 
	C76.895149,26.921137 77.681114,26.679146 77.968918,25.338043 
	C78.760719,25.016491 79.501015,25.011175 80.611206,25.005810 
	C81.549500,26.952982 82.187805,29.080698 79.722450,30.083344 
	C77.665367,30.919947 77.004288,28.930243 76.047066,27.324951 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M275.862122,30.321888 
	C278.805054,27.791889 279.335541,31.900049 281.667206,31.962067 
	C280.710785,35.353714 277.838074,32.380543 275.793701,33.410118 
	C275.069794,33.774685 275.257233,31.660269 275.862122,30.321888 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M48.655830,33.039627 
	C48.823265,34.112232 48.278530,35.312954 48.545761,36.292072 
	C48.851124,37.410912 50.535854,38.322910 48.630470,39.441692 
	C47.955853,39.837807 47.336056,39.479473 47.016453,38.844154 
	C46.407906,37.634457 44.560173,36.812950 45.629105,35.057556 
	C46.225121,34.078777 47.093304,33.303886 48.655830,33.039627 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M254.631226,33.007992 
	C255.075256,36.119175 252.527786,37.262207 250.527130,38.740025 
	C250.112625,39.046219 248.974319,38.263138 249.281479,37.705231 
	C250.415726,35.645119 251.603729,33.508282 254.631226,33.007992 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M260.038696,36.345657 
	C262.137787,36.855885 263.118286,33.634483 265.794067,34.539577 
	C264.297424,36.154945 264.861603,38.891075 262.543823,39.411308 
	C261.404266,39.667095 260.427124,38.066864 260.038696,36.345657 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M267.998169,40.998398 
	C268.159241,39.776665 267.809265,37.769947 269.810272,38.370403 
	C271.383270,38.842419 273.157318,40.032360 273.473419,41.921978 
	C273.659058,43.031818 272.358734,43.015892 271.679321,42.563972 
	C270.738953,41.938473 270.063080,40.886623 268.367554,41.010052 
	C268.003662,41.003204 268.000000,41.000000 267.998169,40.998398 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M48.961533,28.651524 
	C45.449368,29.876135 44.872780,26.840389 42.567795,24.124489 
	C46.108593,24.758318 48.014072,25.755112 48.961533,28.651524 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M162.810669,48.965393 
	C162.587448,49.571804 162.464630,49.888229 162.249405,50.118130 
	C161.384705,51.041733 160.604355,52.309189 159.050247,51.302135 
	C158.471283,50.926964 158.173920,49.776901 158.516312,49.719124 
	C160.002899,49.468266 160.786057,46.199268 162.810669,48.965393 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M145.999695,24.000353 
	C147.140045,24.261332 149.423950,23.553883 149.170944,24.853271 
	C148.875458,26.370707 146.913635,27.563675 145.334045,28.945629 
	C145.326736,27.574961 145.660172,26.156084 145.997101,24.368252 
	C146.000610,23.999296 146.000000,24.000000 145.999695,24.000353 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M160.999695,30.000439 
	C159.502533,29.586939 157.480576,29.737242 157.519760,27.447840 
	C157.532944,26.677504 158.488617,26.104918 159.398758,26.199247 
	C161.381165,26.404713 160.844757,28.016863 160.999863,29.615376 
	C161.000610,29.999084 161.000000,30.000000 160.999695,30.000439 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M249.514648,30.242748 
	C250.813095,29.040506 251.353989,27.122786 253.926163,27.659439 
	C252.556519,29.309216 252.677948,32.325844 249.514648,30.242748 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M48.999771,29.000252 
	C51.389046,28.781364 52.207970,30.022999 51.998024,32.611732 
	C51.999424,33.000587 52.000000,33.000000 52.000298,32.999702 
	C51.252628,33.001228 50.504665,33.003048 49.383003,33.007137 
	C49.009308,33.009403 49.000080,33.000080 48.995361,32.995384 
	C48.993904,31.926483 48.997166,30.862272 49.000443,29.398766 
	C49.000458,28.999470 49.000000,29.000000 48.999771,29.000252 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M175.999207,25.999214 
	C176.001831,27.615049 175.828583,29.117638 173.628967,28.889881 
	C172.960388,28.820654 172.257507,28.501902 172.277710,27.694572 
	C172.330322,25.593084 174.011841,26.180756 175.610367,26.002239 
	C176.001663,26.001568 176.000000,26.000000 175.999207,25.999214 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M222.004639,49.996849 
	C221.978790,48.355408 222.197006,46.890656 224.380188,47.114090 
	C225.049652,47.182606 225.751114,47.505829 225.730240,48.310074 
	C225.675659,50.413059 223.994675,49.818062 222.397202,49.991493 
	C222.006332,49.990765 222.000000,50.000008 222.004639,49.996849 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M270.000000,30.000038 
	C269.638000,31.202763 271.663147,32.571140 270.018280,33.506592 
	C269.098602,34.029610 268.199402,32.852890 267.727631,32.019409 
	C266.728577,30.254406 268.084045,30.137476 269.655243,30.005322 
	C270.000000,29.999924 270.000000,30.000000 270.000000,30.000038 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M99.141129,38.636364 
	C99.162048,37.345726 99.038536,36.071125 100.606400,36.582901 
	C101.064079,36.732288 101.653496,37.637173 101.567764,38.075535 
	C101.307655,39.405533 100.602798,40.278481 99.141129,38.636364 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M196.735901,60.000217 
	C196.997253,60.446533 197.016006,60.894897 197.041290,61.679741 
	C195.426544,63.310539 193.926132,62.855656 192.240265,61.349998 
	C192.318497,58.130592 194.070923,59.797504 195.673920,59.973061 
	C196.008148,60.004856 196.493317,60.002266 196.735901,60.000217 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M148.999695,50.000381 
	C150.367508,50.189877 152.054962,49.419060 152.932053,51.643623 
	C152.999390,52.000610 153.000000,52.000000 153.000305,51.999680 
	C152.030670,52.971481 151.028564,53.862732 149.155685,53.166279 
	C148.329788,52.225334 148.249161,51.461567 148.766266,50.325241 
	C149.000610,49.999237 149.000000,50.000000 148.999695,50.000381 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M268.000183,25.000305 
	C268.021332,26.369595 268.002563,27.917042 266.316071,28.138935 
	C264.253632,28.410294 265.321899,26.591169 265.000244,25.347767 
	C265.000000,25.000534 265.000000,25.000000 265.000000,24.999733 
	C265.686096,24.421631 266.458679,24.270304 267.657288,24.764915 
	C268.000000,24.999619 268.000000,25.000000 268.000183,25.000305 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M41.999695,30.000305 
	C43.105263,30.108501 44.569679,29.754597 44.758980,31.378716 
	C44.911743,32.689369 43.830238,33.016697 42.751659,32.908909 
	C41.002506,32.734100 41.975254,31.493073 41.973579,30.324718 
	C42.000610,29.999390 42.000000,30.000000 41.999695,30.000305 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M132.000916,19.999168 
	C133.399994,19.822695 134.798172,19.647053 136.196335,19.471409 
	C135.137741,21.031357 134.312820,23.401083 132.055542,20.336678 
	C131.998444,20.001671 132.000000,20.000000 132.000916,19.999168 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M81.372772,24.978760 
	C81.004448,24.235806 81.003166,23.490728 81.000946,22.372787 
	C82.101685,22.117397 83.565536,21.738245 83.757034,23.386923 
	C83.913963,24.737997 82.778152,24.900539 81.372772,24.978760 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M138.269806,37.162773 
	C139.156982,35.992954 140.038055,35.892876 140.619919,36.948254 
	C140.822006,37.314789 140.551422,38.336395 140.197983,38.539871 
	C139.186859,39.121975 138.424042,38.693226 138.269806,37.162773 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M34.000000,30.999962 
	C35.172676,31.159636 36.759960,30.705952 36.741001,32.691452 
	C36.737701,33.037029 36.277622,33.600475 35.936672,33.682770 
	C34.317642,34.073566 34.130356,32.913410 34.010452,31.367868 
	C34.000000,31.000076 34.000000,31.000000 34.000000,30.999962 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M62.001465,32.998631 
	C62.164989,31.829493 61.706406,30.242754 63.690128,30.264212 
	C64.034943,30.267939 64.596016,30.726404 64.678368,31.066553 
	C65.069801,32.683392 63.911533,32.867523 62.369682,32.986046 
	C62.002743,32.997074 62.000000,33.000000 62.001465,32.998631 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M260.000610,28.999428 
	C261.172943,29.155333 262.755493,28.704641 262.735657,30.686699 
	C262.732178,31.031965 262.273804,31.594223 261.933411,31.676861 
	C260.317291,32.069225 260.130219,30.910540 260.009094,29.368361 
	C259.998779,29.001144 260.000000,29.000000 260.000610,28.999428 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M139.388885,26.952448 
	C139.920822,25.538519 140.673294,24.744860 141.998306,25.399252 
	C142.183838,25.490883 142.209854,26.289051 142.046005,26.635429 
	C141.463837,27.866165 140.611664,28.373871 139.388885,26.952448 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M99.054222,26.336548 
	C100.208038,26.300070 101.359947,24.559433 102.533981,25.877602 
	C102.689507,26.052221 102.431213,26.860781 102.138290,27.122478 
	C101.006409,28.133711 99.881256,28.406805 99.054222,26.336548 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M212.794739,59.309959 
	C213.022003,59.003265 213.514587,58.999443 213.760925,58.994629 
	C215.094421,59.633713 216.495514,59.889610 216.964600,61.668579 
	C215.886993,61.753307 214.767761,61.518356 213.330170,61.141140 
	C212.626343,60.614433 212.478271,60.153675 212.794739,59.309959 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M243.037323,26.335472 
	C243.750732,25.993717 244.499756,25.991663 245.623169,25.982193 
	C245.833633,26.957451 246.406647,28.422018 244.803253,28.552027 
	C243.765030,28.636211 243.294556,27.639429 243.037323,26.335472 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M276.354187,37.470978 
	C277.742401,37.411182 277.925690,38.090931 277.356903,38.846539 
	C277.059082,39.242153 276.104889,39.653076 275.844299,39.475216 
	C274.932220,38.852684 275.550354,38.180763 276.354187,37.470978 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M259.998169,36.001900 
	C258.468842,35.924091 257.403870,35.262817 257.036438,33.339188 
	C258.530090,33.072876 259.593384,33.735413 259.965607,35.657288 
	C260.003662,35.996086 260.000000,36.000000 259.998169,36.001900 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M98.998779,26.001202 
	C97.846802,25.743629 96.190804,26.672369 95.649757,25.091528 
	C95.288628,24.036383 96.581779,24.160673 97.640114,23.994665 
	C97.986290,23.986206 98.000481,24.000294 98.008896,24.006601 
	C98.274300,24.503536 98.531288,24.994162 98.895004,25.741245 
	C99.001732,25.997702 99.000000,26.000000 98.998779,26.001202 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M117.518906,41.704929 
	C117.891617,42.590637 117.877884,43.231953 117.109253,43.476612 
	C116.901321,43.542797 116.400063,43.297642 116.335396,43.097729 
	C116.060249,42.247089 116.090065,41.478775 117.518906,41.704929 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M39.805374,35.208347 
	C40.753738,35.840752 40.681908,36.423859 39.925140,36.713173 
	C39.576653,36.846401 38.812202,36.664997 38.660183,36.391060 
	C38.235176,35.625221 38.786572,35.270008 39.805374,35.208347 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M255.000000,32.999924 
	C255.134628,32.111595 254.669037,30.802145 255.911301,30.578777 
	C257.048828,30.374243 256.840973,31.583439 256.994324,32.656521 
	C257.000000,32.999695 257.000000,33.000000 257.000000,33.000153 
	C256.555542,33.000221 256.111115,33.000137 255.333328,33.000107 
	C255.000000,33.000153 255.000000,33.000000 255.000000,32.999924 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M66.803146,27.210157 
	C67.750023,27.843033 67.678993,28.426191 66.921928,28.715406 
	C66.573349,28.848562 65.808762,28.667538 65.657310,28.393965 
	C65.233337,27.628159 65.786041,27.273354 66.803146,27.210157 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M242.987106,38.519386 
	C242.111923,38.026600 242.013794,37.412529 242.418289,36.815029 
	C242.748672,36.326988 243.280441,36.332668 243.597900,36.831139 
	C243.984314,37.437866 243.879456,38.050301 242.987106,38.519386 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M231.803757,21.210775 
	C232.748688,21.840960 232.681168,22.422792 231.924240,22.711399 
	C231.576279,22.844070 230.814133,22.662653 230.661835,22.388891 
	C230.236588,21.624422 230.787048,21.271038 231.803757,21.210775 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M63.135284,22.280190 
	C63.877289,21.876265 64.760612,21.751387 65.827713,21.816916 
	C65.562782,24.485172 64.512947,23.984295 63.135284,22.280190 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M203.996826,39.996651 
	C204.088577,39.365673 204.097397,38.652512 204.905701,38.514553 
	C205.077042,38.485306 205.314194,38.841576 205.521042,39.020210 
	C205.203064,39.323128 204.885086,39.626049 204.286911,39.967545 
	C204.006714,40.006123 204.000000,39.999996 203.996826,39.996651 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M148.959305,31.593872 
	C148.232452,31.198038 148.224503,30.798712 148.741898,30.445055 
	C148.850403,30.370888 149.101425,30.372601 149.206955,30.449249 
	C149.712616,30.816551 149.694962,31.216013 148.959305,31.593872 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M104.005173,52.995094 
	C104.638084,53.086906 105.352455,53.096344 105.489021,53.905869 
	C105.518044,54.077885 105.161247,54.314991 104.982193,54.522102 
	C104.677933,54.204807 104.373665,53.887516 104.030014,53.290070 
	C103.990639,53.009914 104.000092,52.999924 104.005173,52.995094 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M40.999771,52.000229 
	C41.625210,52.096714 42.340965,52.098156 42.481083,52.907021 
	C42.510597,53.077389 42.154404,53.314568 41.975933,53.520958 
	C41.675793,53.200954 41.375648,52.880955 41.037979,52.280251 
	C41.000458,51.999542 41.000000,52.000000 40.999771,52.000229 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M108.988907,57.010521 
	C108.353592,56.915001 107.636154,56.904705 107.507240,56.093708 
	C107.479507,55.919189 107.836128,55.683578 108.015709,55.476109 
	C108.323227,55.790306 108.630745,56.104504 108.980240,56.697697 
	C109.022209,56.976692 109.000298,56.999577 108.988907,57.010521 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M136.544128,25.379436 
	C136.315613,24.577213 136.602051,24.294306 137.219452,24.413925 
	C137.348389,24.438904 137.522873,24.621618 137.542389,24.751734 
	C137.636429,25.378908 137.331100,25.641258 136.544128,25.379436 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M67.959595,25.593430 
	C67.233162,25.196213 67.215675,24.795309 67.739601,24.439636 
	C67.848732,24.365549 68.100304,24.368584 68.206703,24.445745 
	C68.714012,24.813643 68.700653,25.214428 67.959595,25.593430 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M56.618378,29.548599 
	C57.413452,29.323561 57.698536,29.604031 57.578423,30.219030 
	C57.553429,30.346998 57.371758,30.519823 57.242447,30.539145 
	C56.620518,30.632072 56.358273,30.330210 56.618378,29.548599 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M143.317871,30.955534 
	C143.073486,30.091423 143.324295,29.309467 144.674713,29.038567 
	C144.993301,28.993835 145.000000,28.999949 145.003052,29.003220 
	C144.920624,29.907143 144.669769,30.689493 143.317871,30.955534 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M151.544647,28.387362 
	C151.315384,27.583227 151.600281,27.297327 152.220932,27.418556 
	C152.350159,27.443798 152.524338,27.627277 152.544189,27.758116 
	C152.639709,28.387211 152.335052,28.651373 151.544647,28.387362 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M54.045021,27.404465 
	C54.775063,27.801767 54.782089,28.202984 54.263557,28.558405 
	C54.154896,28.632885 53.902836,28.630566 53.796543,28.553593 
	C53.287529,28.184982 53.306705,27.784100 54.045021,27.404465 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M89.145012,49.823914 
	C88.990356,50.003586 88.512787,50.006779 88.274452,50.010281 
	C88.076073,49.095127 88.317429,48.314930 89.681488,48.044643 
	C90.000954,48.169689 90.000084,48.336407 89.998383,48.753204 
	C89.748650,49.199215 89.516022,49.412865 89.145012,49.823914 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M221.001465,22.002083 
	C220.658997,22.249323 220.315063,22.494432 219.971115,22.739534 
	C219.885925,22.618101 219.800735,22.496674 219.715546,22.375248 
	C219.984787,22.257494 220.254028,22.139736 220.759338,22.008743 
	C220.995422,21.995506 221.000000,21.999949 221.001465,22.002083 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M156.247437,48.638588 
	C156.008102,48.623917 155.877686,48.494709 155.747284,48.365498 
	C155.950317,48.418350 156.153336,48.471203 156.247437,48.638588 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M217.451477,20.530010 
	C217.420120,20.476910 217.482834,20.583109 217.451477,20.530010 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M231.867706,37.053291 
	C231.911804,37.035530 231.823593,37.071056 231.867706,37.053291 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M143.001984,31.002535 
	C142.912384,31.037868 142.820801,31.070671 142.862137,31.049755 
	C142.995071,30.996037 143.000000,31.000004 143.001984,31.002535 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M160.529007,45.548477 
	C160.476471,45.579288 160.581543,45.517670 160.529007,45.548477 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M719.529785,41.581314 
	C716.875183,41.618946 715.251099,42.634930 713.356262,43.945045 
	C713.002441,44.005585 713.000000,43.999931 712.997559,43.999214 
	C711.805420,42.687809 712.154480,41.300552 712.971680,39.597992 
	C714.175842,37.865070 716.396851,37.720890 717.105835,35.481934 
	C717.402954,35.008244 717.535645,34.826321 717.909790,34.405739 
	C720.636475,32.597698 723.040955,30.905300 725.859192,29.255821 
	C726.660950,29.168837 727.115662,29.227547 727.864258,29.517563 
	C729.108337,31.010651 730.269592,30.736523 731.653625,30.409527 
	C733.715820,29.922312 735.188354,30.779020 735.546631,33.353123 
	C735.244507,34.310524 734.772339,34.755566 734.056824,35.377632 
	C733.501465,36.006363 733.181885,36.437046 733.838135,37.208809 
	C734.172791,37.602726 734.301941,37.770958 734.560181,38.239498 
	C734.842896,39.217297 734.784119,39.868877 734.225830,40.743008 
	C734.000000,40.998932 734.000000,41.000000 734.000000,41.000534 
	C733.422485,41.524467 732.761658,41.870705 731.602783,41.940121 
	C730.992126,41.866951 730.755188,41.806236 730.197754,41.579357 
	C724.578857,36.354572 724.405701,36.350090 719.529785,41.581314 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M619.996765,54.357491 
	C622.292480,54.294987 622.444946,50.054359 625.325500,51.482895 
	C625.984375,53.212177 622.761719,54.016922 624.610657,56.093315 
	C627.453857,50.439705 631.039673,58.659206 633.918030,55.164005 
	C634.861206,56.288193 634.405457,57.265488 633.986145,57.212849 
	C629.870911,56.696220 626.100891,59.113537 621.798462,58.190598 
	C618.893921,57.567528 620.045349,56.131386 619.996765,54.357491 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M777.000000,40.000000 
	C779.304199,39.850811 781.336426,40.041363 780.996094,43.594032 
	C779.272766,45.080421 778.657410,47.037174 777.225098,48.765675 
	C776.832520,49.000954 776.665039,49.002056 776.246338,49.006622 
	C775.552795,49.009094 775.110413,49.008095 774.336304,49.007557 
	C773.782776,49.124268 773.561096,49.240520 772.998047,49.199444 
	C770.762085,46.599274 771.142639,44.445244 773.741028,42.270386 
	C774.000000,42.000885 774.000000,42.000000 774.000000,41.999588 
	C774.650085,41.134727 775.777588,41.055004 776.788696,40.215599 
	C777.002441,39.998650 777.000000,40.000000 777.000000,40.000000 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M633.364746,48.991829 
	C632.980774,51.174911 632.456909,52.896961 629.911438,51.217915 
	C628.492188,50.281693 626.483765,49.810589 626.041565,47.351250 
	C629.170532,48.289722 629.793396,44.237267 632.622864,44.010796 
	C633.095947,45.068504 633.801392,45.525982 634.638550,46.137505 
	C636.752441,47.681721 636.022461,48.653454 633.364746,48.991829 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M667.000183,60.331276 
	C668.241577,59.985100 669.298706,59.461166 669.943726,58.470715 
	C671.920227,55.435959 673.394165,55.330082 674.674683,58.987560 
	C675.078308,60.140549 676.713745,61.255100 675.334839,62.388672 
	C673.638855,63.782936 673.495789,61.536419 672.606995,60.863796 
	C670.738342,59.449596 669.443848,61.899044 667.355835,61.960209 
	C666.991028,61.549091 666.994385,61.107731 667.000183,60.331276 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M720.069824,45.656116 
	C719.812744,46.608120 719.820618,47.477104 719.404846,47.799282 
	C717.778259,49.059513 716.387573,50.944935 714.021729,50.707794 
	C713.198425,50.625275 712.436157,49.165157 712.800598,48.924599 
	C714.667297,47.692360 715.113831,44.443962 718.606689,44.999271 
	C719.454407,44.819035 719.841919,44.912472 720.069824,45.656116 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M737.998779,85.001068 
	C740.627625,84.712418 743.353760,84.515862 742.127808,80.304626 
	C743.064880,80.000885 744.132263,80.003639 745.864624,80.270996 
	C747.004028,81.506142 747.009460,82.467621 746.236450,83.709656 
	C745.998718,84.000641 746.000000,84.000000 746.001221,83.999329 
	C744.672791,85.417046 743.236572,86.698875 741.231445,87.771889 
	C741.002441,87.998169 741.000000,88.000000 740.998779,88.000916 
	C740.311829,88.578796 739.539917,88.729797 738.342407,88.235603 
	C738.000000,88.001221 738.000000,88.000000 738.000000,87.999390 
	C737.421326,87.312256 737.270752,86.539108 737.766907,85.340317 
	C738.002441,84.997864 738.000000,85.000000 737.998779,85.001068 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M789.336670,75.230583 
	C789.007812,73.950706 789.007324,72.878159 789.209717,71.148193 
	C790.131165,69.982117 790.953918,69.691795 792.380554,69.184822 
	C794.600281,69.258347 795.727966,70.301636 794.330383,71.523415 
	C791.852661,73.689400 794.255554,74.821999 794.938049,76.707695 
	C792.487549,78.901939 791.306641,76.412537 789.336670,75.230583 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M626.000000,47.000229 
	C624.430786,46.924316 623.225037,47.400650 622.072510,48.637489 
	C620.281616,50.559349 618.163330,50.837631 616.078674,48.366581 
	C618.963867,48.077881 621.112610,46.088367 623.542847,44.894279 
	C625.424133,43.969910 625.887390,44.582672 625.994080,46.648529 
	C626.000000,46.999542 626.000000,47.000000 626.000000,47.000229 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M720.318848,46.017807 
	C719.889709,45.672169 719.698608,45.414391 719.208130,45.107010 
	C718.992432,44.248615 718.994629,43.500221 718.997192,42.377678 
	C718.997559,42.003529 719.000000,41.999874 719.001221,41.998077 
	C720.808960,40.213310 721.972900,36.717960 725.625488,39.895912 
	C725.747375,40.471096 725.756165,40.703880 725.686646,41.268532 
	C724.871887,42.780380 723.434753,43.608376 723.706909,45.631203 
	C723.596008,46.150158 723.521301,46.351162 723.222046,46.782543 
	C722.211121,46.690369 721.424683,46.367821 720.318848,46.017807 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M789.115479,75.275223 
	C791.285706,74.282265 792.196899,77.153717 794.618469,77.031006 
	C794.987793,77.788528 794.988770,78.520576 794.992432,79.619087 
	C793.075745,79.494308 792.121765,81.224693 790.346375,81.899963 
	C789.903503,81.639877 789.725647,81.392754 789.262817,81.096283 
	C788.141785,79.520561 790.134644,78.846306 790.012085,77.270866 
	C789.765137,76.479073 789.493835,76.003136 789.115479,75.275223 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M658.782959,46.731224 
	C660.004578,45.537884 660.993469,44.675896 663.006348,45.827454 
	C660.105408,47.454433 660.214905,52.114029 655.200195,51.292896 
	C656.413696,49.722488 657.472351,48.352467 658.782959,46.731224 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M801.000000,77.000153 
	C798.497742,77.125504 796.728210,75.675194 796.349976,73.550476 
	C796.017578,71.682922 798.771790,71.837631 799.762207,70.555000 
	C800.146545,70.057358 800.988647,70.640129 801.360657,71.209770 
	C801.803467,71.887856 801.575806,72.590202 800.847961,72.758621 
	C796.155701,73.844482 800.586487,75.205162 800.856812,76.712387 
	C801.000000,76.999695 801.000000,77.000000 801.000000,77.000153 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M768.626465,81.008789 
	C769.167297,84.271866 766.335266,84.635529 764.309631,85.738434 
	C764.160522,85.819588 763.279053,85.097832 763.330322,84.923203 
	C764.043640,82.493141 766.222839,81.837830 768.626465,81.008789 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M794.001221,49.001274 
	C793.982300,49.496605 794.031921,50.005646 793.929565,50.482059 
	C793.552368,52.238987 792.534363,53.454033 790.725830,53.803806 
	C790.045410,53.935398 789.391357,53.612926 789.267822,52.831284 
	C788.925049,50.662521 791.453491,51.210804 792.103821,49.916805 
	C792.291260,49.543884 792.891602,49.378475 793.650085,49.057777 
	C793.997559,48.997639 794.000000,49.000000 794.001221,49.001274 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M723.046936,47.337490 
	C722.998535,46.844006 722.999512,46.675083 723.000244,46.252777 
	C725.700439,44.341106 727.460449,44.969719 728.089844,48.564198 
	C727.534546,49.317936 727.069031,49.636787 726.309082,49.981201 
	C725.419678,48.754864 723.408142,49.266163 723.046936,47.337490 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M735.254883,46.205574 
	C735.469543,45.681728 735.939026,45.363602 736.705505,45.022659 
	C738.200012,45.102451 739.361877,45.389023 739.579712,46.767624 
	C739.738586,47.772736 738.760376,48.089062 738.048096,48.415253 
	C735.953979,49.374279 736.231750,47.242992 735.254883,46.205574 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M754.670654,77.036690 
	C754.789246,78.440933 756.429016,79.645470 755.557312,81.186638 
	C751.933777,79.439102 751.933777,79.439102 754.670654,77.036690 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M748.592041,80.620193 
	C751.270996,80.719872 752.438293,82.690765 753.950745,84.662949 
	C754.002441,84.996643 754.000000,85.000000 753.998779,85.001129 
	C752.421326,85.773781 750.977661,85.397942 749.296326,84.246002 
	C748.997559,83.998405 749.000000,84.000000 749.000610,84.000435 
	C748.244934,83.223068 747.980286,82.300262 748.592041,80.620193 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M653.699463,45.854042 
	C655.772339,45.021046 656.160706,45.764526 655.163635,47.155102 
	C654.370056,48.261932 653.039185,49.863941 651.726624,48.343433 
	C650.739441,47.199802 652.878723,46.879383 653.699463,45.854042 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M789.762085,77.153198 
	C791.874817,78.559608 789.718018,79.303902 789.173462,80.705376 
	C788.141357,80.666672 785.676086,81.716995 787.305115,79.136108 
	C787.780945,78.382355 788.746521,77.937721 789.762085,77.153198 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M664.611450,53.530151 
	C663.239380,53.681435 662.339294,53.208347 662.490967,52.087162 
	C662.666138,50.792316 663.886169,50.920170 664.737244,51.233677 
	C666.100952,51.736027 665.610168,52.602646 664.611450,53.530151 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M772.684326,48.779121 
	C773.161316,49.000500 773.329895,49.001301 773.751465,49.005062 
	C773.829163,50.609661 773.244202,51.991024 771.368469,51.796921 
	C769.817322,51.636414 770.375366,50.506306 770.873962,49.300354 
	C771.000000,49.000565 771.000000,49.000000 771.000000,48.999924 
	C771.384644,48.621803 771.843323,48.474743 772.684326,48.779121 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M786.375000,70.998924 
	C786.000610,70.250839 786.001221,69.500763 786.000916,68.375031 
	C787.066711,68.001007 788.133362,68.002632 789.741089,68.320602 
	C790.273743,69.367912 790.008484,69.988892 789.243164,70.749001 
	C789.001465,70.998779 789.000000,71.000000 789.000000,71.000610 
	C788.250000,70.999794 787.500000,70.998360 786.375000,70.998924 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M652.997559,56.002090 
	C651.406921,56.032578 649.976013,55.854176 650.008423,53.370018 
	C651.596191,52.955986 653.019592,53.140259 652.993408,55.625824 
	C653.004883,55.995754 653.000000,56.000000 652.997559,56.002090 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M758.001221,49.000916 
	C757.876038,50.021740 758.270508,51.369820 756.848450,51.707565 
	C755.297485,52.075932 755.116699,50.873524 755.008545,49.366669 
	C755.001465,48.998688 755.000000,49.000000 754.998779,49.000656 
	C755.682983,48.422981 756.454529,48.266674 757.654541,48.763596 
	C757.997559,48.998077 758.000000,49.000000 758.001221,49.000916 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M616.000000,48.000229 
	C614.826965,47.843109 613.242920,48.292694 613.262817,46.309425 
	C613.266296,45.964039 613.725708,45.401234 614.066284,45.319016 
	C615.683838,44.928543 615.871033,46.087566 615.990234,47.631920 
	C616.000000,47.999542 616.000000,48.000000 616.000000,48.000229 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M805.645081,77.757729 
	C806.750000,77.002800 807.500000,77.006454 808.625000,77.005508 
	C809.000000,77.000916 809.000000,77.000000 809.000000,76.999695 
	C810.182556,78.986778 809.733887,80.264000 806.955688,80.646805 
	C805.574158,80.217133 805.324402,79.431374 805.645081,77.757729 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M790.000000,67.999542 
	C790.114624,67.074898 789.709656,65.656441 790.954651,65.524773 
	C792.774536,65.332306 792.841248,66.946617 792.992310,68.637810 
	C793.000000,69.000916 793.000000,69.000000 793.000000,68.999687 
	C792.014465,69.593620 791.225342,69.143982 790.234253,68.261894 
	C790.000000,68.000816 790.000000,68.000000 790.000000,67.999542 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M777.630615,83.010773 
	C778.008057,83.757965 778.001404,84.501503 778.003418,85.616501 
	C778.012024,85.987961 777.998352,86.001663 777.991943,86.007645 
	C777.299255,86.581604 776.530884,86.734261 775.339966,86.234070 
	C775.000000,85.999084 775.000000,86.000000 775.000000,86.000458 
	C774.960388,84.411255 775.143005,82.988411 777.630615,83.010773 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M786.000000,68.000305 
	C784.831177,67.839455 783.244934,68.299431 783.259705,66.317078 
	C783.262207,65.972549 783.720459,65.410439 784.060852,65.326950 
	C785.678833,64.930191 785.863586,66.092239 785.988770,67.632507 
	C786.000000,67.999390 786.000000,68.000000 786.000000,68.000305 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M713.006714,55.343006 
	C713.750000,55.000275 714.500000,55.000698 715.625000,55.000637 
	C715.920166,56.138191 715.654236,57.311764 714.403564,57.540344 
	C713.053101,57.787174 713.119385,56.584591 713.006714,55.343006 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M787.911804,55.248238 
	C788.843933,55.938572 789.148071,56.650303 788.438538,57.327751 
	C787.909180,57.833088 787.261292,57.611202 786.840881,57.068710 
	C786.045532,56.042412 786.339600,55.392441 787.911804,55.248238 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M786.000000,70.999542 
	C785.899414,72.162949 785.612000,73.286217 784.321655,73.581367 
	C783.635925,73.738205 783.132080,73.185616 783.199951,72.437019 
	C783.315308,71.165146 784.319946,71.090553 785.645142,71.008408 
	C786.000000,71.000916 786.000000,71.000000 786.000000,70.999542 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M647.000000,43.999435 
	C648.057495,44.111393 649.376282,43.739265 649.763306,45.220810 
	C649.922791,45.831264 649.754089,46.594913 648.885559,46.566483 
	C647.742737,46.529079 647.329895,45.648251 647.039124,44.340710 
	C647.000000,44.001125 647.000000,44.000000 647.000000,43.999435 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M803.000000,76.999695 
	C803.177246,76.025635 802.599426,74.556618 804.203003,74.439362 
	C805.235596,74.363861 805.697388,75.364403 805.960022,76.660675 
	C806.000000,76.999146 806.000000,77.000000 806.000000,77.000427 
	C805.313843,77.578415 804.541321,77.729774 803.342712,77.235252 
	C803.000000,77.000610 803.000000,77.000000 803.000000,76.999695 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M749.340393,77.934158 
	C749.114014,76.902565 748.683899,75.686897 749.570923,74.772400 
	C749.709045,74.630104 750.609192,74.863892 750.692200,75.092514 
	C751.109314,76.240921 751.082520,77.335464 749.340393,77.934158 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M639.806152,48.199379 
	C641.133301,49.729546 639.980408,49.839516 639.022888,49.911068 
	C638.624817,49.940819 637.841309,49.593578 637.844482,49.429394 
	C637.863708,48.416691 638.669495,48.213848 639.806152,48.199379 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M644.676147,50.034790 
	C644.908508,51.149647 644.645569,52.231010 643.348145,52.533638 
	C643.110168,52.589153 642.468872,52.066181 642.474976,51.821781 
	C642.503662,50.676628 643.405518,50.317425 644.676147,50.034790 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M809.672485,62.561920 
	C809.202393,61.443054 809.577454,60.727322 810.464478,60.668610 
	C810.835510,60.644051 811.593323,61.419655 811.594238,61.832764 
	C811.596619,62.885147 810.737427,62.923508 809.672485,62.561920 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M721.736206,57.841957 
	C720.883789,57.745552 719.855957,57.566521 719.855225,57.383423 
	C719.851257,56.372604 720.717590,56.065643 721.524475,56.174507 
	C722.529297,56.310074 722.875244,56.902763 721.736206,57.841957 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M677.499695,57.319344 
	C676.068359,57.502953 676.057922,56.733868 676.353027,55.891266 
	C676.421997,55.694397 676.930847,55.463478 677.135681,55.535877 
	C677.891968,55.803242 677.897949,56.442089 677.499695,57.319344 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M680.196655,54.785728 
	C679.252747,54.156315 679.319824,53.575523 680.076233,53.287483 
	C680.423828,53.155121 681.184814,53.336292 681.336792,53.609634 
	C681.760864,54.372562 681.212708,54.726574 680.196655,54.785728 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M713.000000,55.000076 
	C712.120605,54.908218 711.072021,55.233074 710.560425,54.205692 
	C710.470581,54.025238 710.893188,53.356571 711.191833,53.259247 
	C712.098877,52.963665 712.616272,53.520103 712.948303,54.670464 
	C713.000000,54.999847 713.000000,55.000000 713.000000,55.000076 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M716.000000,54.999924 
	C716.142883,54.037930 716.374023,53.096081 717.619751,53.216938 
	C717.936829,53.247704 718.479919,53.767006 718.455200,54.015537 
	C718.348633,55.083374 717.394470,54.866337 716.340454,54.994728 
	C716.000000,55.000153 716.000000,55.000000 716.000000,54.999924 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M726.003662,53.003647 
	C725.866577,53.973545 725.629211,54.911999 724.382324,54.787605 
	C724.062805,54.755737 723.518066,54.239712 723.541382,53.989422 
	C723.641235,52.918232 724.598694,53.131939 725.652527,52.998901 
	C725.992676,52.992699 726.000000,53.000000 726.003662,53.003647 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M748.998779,77.999237 
	C748.995850,78.443657 748.994141,78.888840 748.994995,79.667923 
	C748.997559,80.001831 749.000000,80.000000 749.000610,79.999519 
	C748.315308,80.577972 747.542419,80.729599 746.342957,80.235184 
	C746.000000,80.000496 746.000000,80.000000 746.000000,79.999542 
	C746.089294,78.555779 746.914734,77.961906 748.649170,78.005402 
	C749.002319,78.001503 749.000000,78.000000 748.998779,77.999237 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M769.001221,81.001068 
	C769.094971,80.121750 768.770325,79.072647 769.795471,78.557922 
	C769.974854,78.467865 770.644897,78.890778 770.742920,79.189957 
	C771.041382,80.101089 770.478821,80.613754 769.327148,80.944855 
	C768.997559,80.998047 769.000000,81.000000 769.001221,81.001068 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M797.635254,79.994568 
	C797.504517,82.214050 796.585571,82.638649 795.064026,80.338196 
	C795.763306,79.999130 796.511902,79.993370 797.635254,79.994568 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M784.789795,82.216339 
	C784.732483,83.235664 784.375732,83.781143 783.613037,83.357323 
	C783.338501,83.204781 783.153137,82.445618 783.284851,82.099396 
	C783.572632,81.343048 784.155457,81.276962 784.789795,82.216339 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M659.000000,41.000153 
	C658.906677,41.878872 659.231812,42.927334 658.204834,43.438274 
	C658.024719,43.527905 657.356873,43.105049 657.259644,42.806408 
	C656.964417,41.899643 657.520386,41.382828 658.670776,41.051613 
	C659.000000,40.999695 659.000000,41.000000 659.000000,41.000153 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M682.000000,47.000458 
	C681.859314,47.963104 681.631165,48.905819 680.383118,48.782337 
	C680.065186,48.750881 679.521545,48.233471 679.546143,47.985340 
	C679.651917,46.917114 680.606262,47.134640 681.659668,47.005264 
	C682.000000,46.999084 682.000000,47.000000 682.000000,47.000458 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M653.001221,40.000839 
	C652.907043,40.880341 653.235229,41.930809 652.206360,42.441460 
	C652.024658,42.531666 651.355652,42.110340 651.257996,41.811897 
	C650.960815,40.903637 651.522339,40.389076 652.668823,40.052258 
	C652.997559,39.998463 653.000000,40.000000 653.001221,40.000839 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M642.790771,46.783844 
	C641.779053,46.723015 641.228943,46.371925 641.652039,45.610031 
	C641.803589,45.337105 642.560852,45.154259 642.906311,45.285839 
	C643.657043,45.571835 643.731934,46.151394 642.790771,46.783844 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M673.946960,52.672340 
	C673.115479,52.911400 672.066101,53.232452 671.557739,52.205692 
	C671.468262,52.024910 671.890930,51.358669 672.189697,51.260986 
	C673.093811,50.965389 673.614441,51.518616 673.946960,52.672340 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M650.000000,52.999924 
	C649.182617,52.884628 648.272217,52.781883 648.391602,51.670273 
	C648.427673,51.334026 649.014587,51.056931 649.349121,50.752739 
	C649.565063,51.297314 649.781006,51.841892 649.998474,52.693314 
	C650.000000,53.000153 650.000000,53.000000 650.000000,52.999924 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M650.403076,58.421280 
	C649.469116,58.766235 648.937805,58.481041 648.774109,57.737484 
	C648.741760,57.590431 649.118225,57.200714 649.330933,57.180256 
	C650.041565,57.111916 650.619751,57.329582 650.403076,58.421280 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M768.000000,88.999573 
	C767.365540,88.912743 766.642883,88.918442 766.501709,88.096542 
	C766.471863,87.922829 766.831360,87.682251 767.011475,87.472481 
	C767.317932,87.793159 767.624329,88.113846 767.965332,88.717728 
	C768.000000,89.000916 768.000000,89.000000 768.000000,88.999573 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M668.000000,40.999847 
	C668.628723,41.092113 669.344543,41.094452 669.486145,41.905094 
	C669.515930,42.075768 669.158875,42.313992 668.980103,42.521091 
	C668.677246,42.201710 668.374390,41.882332 668.035767,41.281631 
	C668.000000,41.000305 668.000000,41.000000 668.000000,40.999847 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M619.998291,54.001720 
	C619.372131,53.906147 618.658936,53.900906 618.519043,53.095371 
	C618.489502,52.925316 618.844666,52.688427 619.022522,52.482315 
	C619.323975,52.800434 619.625427,53.118561 619.964905,53.716515 
	C620.002930,53.996342 620.000000,54.000000 619.998291,54.001720 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M646.380859,55.451252 
	C645.588013,55.675949 645.303040,55.396996 645.423889,54.782990 
	C645.449036,54.655231 645.629944,54.483070 645.758972,54.463585 
	C646.380127,54.369839 646.640442,54.671734 646.380859,55.451252 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M645.000000,49.999847 
	C645.094299,49.372948 645.096863,48.658096 645.905640,48.517311 
	C646.075745,48.487709 646.313049,48.844227 646.519409,49.022804 
	C646.200195,49.324478 645.880981,49.626163 645.280884,49.964077 
	C645.000000,50.000305 645.000000,50.000000 645.000000,49.999847 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M610.000000,47.999924 
	C610.628662,48.092461 611.344604,48.095058 611.485107,48.906231 
	C611.514709,49.077030 611.157227,49.314888 610.978088,49.521835 
	C610.675781,49.202244 610.373474,48.882656 610.035583,48.281609 
	C610.000000,48.000153 610.000000,48.000000 610.000000,47.999924 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M700.455566,50.618153 
	C700.680237,51.411709 700.401428,51.697659 699.786377,51.576668 
	C699.658386,51.551479 699.485840,51.370514 699.466370,51.241360 
	C699.372742,50.619587 699.674927,50.358677 700.455566,50.618153 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M677.590698,51.043819 
	C677.196289,51.768063 676.798218,51.774197 676.445740,51.260212 
	C676.371826,51.152485 676.374329,50.902393 676.450745,50.796974 
	C676.816589,50.292587 677.214233,50.310776 677.590698,51.043819 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M807.000000,57.999924 
	C807.628906,58.093834 808.344238,58.099335 808.484985,58.909386 
	C808.514587,59.079723 808.157288,59.317337 807.978333,59.523972 
	C807.676392,59.203682 807.374390,58.883381 807.036255,58.281616 
	C807.000000,58.000153 807.000000,58.000000 807.000000,57.999924 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M755.001221,77.001022 
	C755.091980,76.373001 755.097778,75.660965 755.904663,75.516953 
	C756.074097,75.486717 756.312500,75.842873 756.519165,76.021004 
	C756.199219,76.321869 755.879211,76.622719 755.278442,76.960831 
	C754.997559,76.998093 755.000000,77.000000 755.001221,77.001022 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M777.992676,82.991859 
	C778.080322,82.354073 778.094360,81.640724 778.905640,81.507172 
	C779.079102,81.478630 779.316040,81.835831 779.523743,82.015327 
	C779.207397,82.321503 778.891052,82.627678 778.294678,82.974136 
	C778.014648,83.014420 777.999939,82.999611 777.992676,82.991859 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M666.997559,60.002197 
	C666.246948,60.002987 665.498779,60.001659 664.376526,60.001766 
	C664.002441,60.003197 664.000000,60.000000 663.999023,59.998581 
	C664.713318,58.970287 665.589783,58.808430 666.814636,59.751839 
	C667.002625,59.996178 667.000000,60.000076 666.997559,60.002197 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M612.736572,52.595810 
	C612.858215,52.442799 613.066772,52.421314 613.275269,52.399834 
	C613.124634,52.509007 612.973999,52.618172 612.736572,52.595810 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M674.004822,52.996490 
	C674.124756,53.133114 674.239868,53.273129 674.354980,53.413139 
	C674.271667,53.366295 674.188293,53.319450 674.049194,53.140652 
	C673.993469,53.008698 674.000000,52.999874 674.004822,52.996490 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M667.005005,62.006523 
	C666.914917,62.043400 666.819946,62.073997 666.856262,62.047523 
	C666.987610,61.990452 667.000000,62.000248 667.005005,62.006523 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M643.469910,57.453995 
	C643.521545,57.424068 643.418274,57.483917 643.469910,57.453995 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M739.998779,50.000839 
	C739.880127,49.864105 739.762634,49.726540 739.645142,49.588970 
	C739.728149,49.636421 739.811096,49.683872 739.948242,49.864594 
	C740.002441,49.997864 740.000000,50.000000 739.998779,50.000839 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M633.000000,43.999817 
	C633.107422,43.681511 633.295898,43.422356 633.781494,43.110306 
	C633.997559,42.998440 634.000000,43.000000 634.000977,43.001045 
	C633.893494,43.320194 633.704285,43.579300 633.217163,43.889839 
	C633.000000,44.000278 633.000000,44.000000 633.000000,43.999817 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M665.000488,48.000801 
	C664.911865,48.036396 664.822693,48.071198 664.865601,48.052399 
	C664.997559,47.998802 665.000000,48.000000 665.000488,48.000801 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M503.426880,29.650341 
	C504.004272,30.164797 504.064026,30.355186 504.001862,30.488878 
	C503.073883,32.484211 507.621124,34.071728 505.056488,35.241898 
	C503.398895,35.998211 501.631714,33.002552 501.006805,30.365929 
	C500.998779,30.001297 501.000000,30.000000 501.000610,29.999352 
	C501.504272,29.463575 502.124268,29.238358 503.426880,29.650341 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M579.001221,25.998779 
	C581.745728,25.793556 584.820068,24.298553 586.551941,28.156170 
	C584.185730,26.941198 581.323975,28.729897 579.053467,26.341501 
	C578.997559,26.002474 579.000000,26.000000 579.001221,25.998779 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M531.617615,29.011322 
	C531.997742,30.066679 531.995483,31.134207 531.997681,32.599739 
	C531.250977,32.996273 530.499817,32.994801 529.375610,32.997780 
	C529.142029,31.336634 528.383911,29.167315 531.617615,29.011322 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M542.997559,43.998093 
	C543.252136,42.655663 542.312439,40.803524 544.435120,40.263290 
	C545.077820,40.099709 545.679504,40.589043 545.828613,41.365364 
	C546.149109,43.034023 545.472473,43.911247 543.385376,43.990318 
	C543.004883,44.003742 543.000000,44.000000 542.997559,43.998093 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M528.998779,32.998894 
	C528.843201,34.601692 528.232239,35.837921 526.388245,35.808025 
	C525.713013,35.797077 525.146423,35.275360 525.237610,34.538853 
	C525.473938,32.630665 527.048523,33.161907 528.617432,33.001705 
	C529.002441,33.002224 529.000000,33.000000 528.998779,32.998894 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M520.962280,21.662277 
	C519.828186,21.780197 518.367615,22.564835 517.545959,21.150688 
	C517.155823,20.479267 517.681641,19.855169 518.247559,19.603661 
	C519.930603,18.855621 520.500916,20.014851 520.962280,21.662277 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M525.135254,26.329758 
	C526.450378,24.663612 527.190125,25.588781 527.593140,26.693810 
	C527.885925,27.496683 527.341125,28.322073 526.483459,28.477163 
	C525.043579,28.737537 525.140747,27.581179 525.135254,26.329758 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M533.713867,21.546658 
	C533.439575,19.755169 534.706421,19.638655 535.763428,19.400774 
	C536.291809,19.281851 536.720032,19.720757 536.569031,20.289415 
	C536.212830,21.631458 535.242371,22.010748 533.713867,21.546658 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M555.001221,40.999313 
	C556.599792,40.955727 558.017151,41.150253 557.990845,43.629944 
	C557.249329,44.002075 556.501099,44.002777 555.378906,44.004791 
	C555.004883,44.006104 555.000000,43.999413 554.997559,43.996536 
	C554.421021,43.308594 554.266235,42.538918 554.763428,41.343155 
	C554.997559,41.001373 555.000000,41.000000 555.001221,40.999313 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M532.000000,29.000423 
	C532.136353,27.959078 531.735413,26.652294 533.233643,26.254555 
	C533.921204,26.072014 534.543274,26.363960 534.703491,27.069281 
	C535.074280,28.701130 533.917480,28.881020 532.368652,28.992130 
	C532.000000,28.999149 532.000000,29.000000 532.000000,29.000423 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M558.001221,43.999321 
	C559.043762,44.130993 560.344177,43.738026 560.743530,45.229805 
	C560.927246,45.916023 560.640137,46.537449 559.935791,46.697151 
	C558.312500,47.065174 558.123901,45.915367 558.007202,44.368999 
	C557.997559,44.001373 558.000000,44.000000 558.001221,43.999321 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M644.910461,26.244579 
	C645.849121,26.935875 646.142700,27.651396 645.434448,28.328552 
	C644.904724,28.835070 644.254822,28.617298 643.833557,28.070570 
	C643.040588,27.041386 643.330750,26.388002 644.910461,26.244579 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M538.660583,23.036606 
	C539.000061,23.749409 539.000122,24.498665 538.998840,25.625404 
	C538.015198,25.839207 536.552673,26.392765 536.435364,24.793024 
	C536.359497,23.758480 537.363342,23.297911 538.660583,23.036606 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M641.827515,22.766253 
	C643.004456,22.174822 643.823242,22.311943 643.544067,23.480787 
	C643.301636,24.495775 642.223999,25.253239 641.255920,24.789619 
	C640.032898,24.203871 641.192871,23.539154 641.827515,22.766253 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M504.002441,26.997969 
	C504.981323,27.165701 506.444092,26.604155 506.557831,28.205168 
	C506.631134,29.236635 505.635468,29.700171 504.339630,29.961769 
	C504.001221,30.000780 504.000000,30.000000 503.999390,29.999592 
	C503.421875,29.314899 503.270020,28.544043 503.761749,27.347099 
	C503.995117,27.004564 504.000000,27.000324 504.002441,26.997969 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M518.981567,28.922459 
	C517.900940,28.670237 516.954285,28.390526 517.891235,27.423594 
	C518.461792,26.834703 519.479370,26.839422 520.052246,27.415747 
	C520.996277,28.365505 520.068848,28.665504 518.981567,28.922459 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M531.998779,33.001183 
	C533.086914,33.108978 534.433716,32.753273 534.777649,34.305912 
	C534.850647,34.635674 534.453735,35.381031 534.195129,35.420368 
	C532.874146,35.621250 532.860107,34.273018 532.132202,33.297775 
	C532.002075,32.997742 532.000000,33.000000 531.998779,33.001183 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M522.606628,30.313438 
	C523.540344,30.096268 524.356812,30.116486 524.442688,30.818073 
	C524.581604,31.953730 523.546936,31.981491 522.794312,31.921091 
	C521.647095,31.829023 521.525146,31.242090 522.606628,30.313438 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M515.350769,23.472576 
	C516.752808,23.409624 516.922424,24.100039 516.356018,24.854223 
	C516.058105,25.250950 515.099548,25.661835 514.837463,25.482992 
	C513.921082,24.857435 514.538757,24.183214 515.350769,23.472576 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M522.832214,53.410908 
	C522.344360,53.737473 521.994629,53.748398 521.385498,53.706806 
	C521.294617,53.051868 521.397827,52.420834 521.646606,51.853691 
	C522.024292,50.992836 522.587891,49.826832 523.659180,50.565468 
	C525.344788,51.727745 523.167725,52.221661 522.832214,53.410908 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M539.001221,25.998589 
	C539.882446,26.096102 540.937073,25.766718 541.445923,26.800375 
	C541.535828,26.982803 541.110229,27.651903 540.809631,27.750141 
	C539.898132,28.048023 539.383728,27.483162 539.049072,26.333136 
	C538.997559,26.002890 539.000000,26.000000 539.001221,25.998589 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M643.995117,39.994827 
	C644.088318,39.112724 643.765808,38.062313 644.796997,37.558468 
	C644.979553,37.469227 645.643677,37.892738 645.741699,38.192104 
	C646.038208,39.096649 645.484558,39.615822 644.337952,39.954330 
	C644.009766,40.009239 644.000000,39.999863 643.995117,39.994827 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M510.000000,20.999809 
	C510.882294,21.095034 511.938202,20.759882 512.450806,21.796301 
	C512.540771,21.978230 512.114685,22.648792 511.813843,22.746941 
	C510.903809,23.043821 510.380249,22.489716 510.049469,21.331440 
	C510.000000,21.000381 510.000000,21.000000 510.000000,20.999809 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M520.998779,22.000710 
	C521.960815,22.139244 522.906067,22.363548 522.786133,23.613535 
	C522.755676,23.931732 522.237488,24.477211 521.988770,24.452940 
	C520.920166,24.348654 521.135071,23.393299 521.006348,22.339005 
	C521.002441,21.998453 521.000000,22.000000 520.998779,22.000710 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M588.427429,25.562740 
	C587.833130,25.110428 587.416809,24.667345 587.981262,24.301907 
	C588.578430,23.915274 589.281250,24.082674 589.513184,24.820293 
	C589.691772,25.387945 589.241455,25.662960 588.427429,25.562740 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M537.385498,30.461441 
	C536.587524,30.686859 536.299011,30.406610 536.420044,29.787769 
	C536.445190,29.659117 536.627502,29.485535 536.757507,29.465900 
	C537.383423,29.371382 537.645020,29.676781 537.385498,30.461441 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M595.000000,24.000381 
	C594.908447,24.631376 594.910278,25.351471 594.092529,25.489197 
	C593.919800,25.518290 593.681641,25.159002 593.473633,24.978668 
	C593.794189,24.675903 594.114746,24.373138 594.717651,24.034832 
	C595.000000,23.999290 595.000000,24.000000 595.000000,24.000381 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M530.455017,23.617481 
	C530.681702,24.412449 530.400452,24.694935 529.786682,24.573996 
	C529.658508,24.548742 529.485474,24.368511 529.465942,24.239613 
	C529.371826,23.617395 529.674866,23.357859 530.455017,23.617481 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M539.000000,22.999924 
	C539.088806,22.369968 539.095825,21.657938 539.904480,21.516266 
	C540.075073,21.486378 540.313171,21.842016 540.520203,22.020025 
	C540.200684,22.322073 539.881165,22.624117 539.280823,22.963158 
	C539.000000,23.000153 539.000000,23.000000 539.000000,22.999924 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M561.249512,22.010822 
	C561.411682,21.904356 561.574829,21.956594 561.737976,22.008831 
	C561.575500,22.062393 561.413025,22.115961 561.249512,22.010822 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M615.455383,24.529888 
	C615.424561,24.477028 615.486206,24.582748 615.455383,24.529888 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M806.592163,44.378113 
	C805.168823,46.319363 804.287720,50.036354 801.149414,46.361355 
	C800.558044,45.668861 798.205994,45.432011 800.129333,44.120720 
	C802.059814,42.804604 801.767395,39.236210 804.750549,39.441055 
	C806.778748,39.580326 804.821289,41.785435 805.859314,42.719124 
	C806.198914,43.024529 806.289124,43.607082 806.592163,44.378113 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M777.373535,49.005867 
	C777.175964,46.743965 777.174561,44.372410 780.625854,44.000221 
	C781.139526,45.459942 779.039429,47.353516 782.051941,48.316463 
	C783.151123,48.667816 784.383240,50.250378 783.262695,51.381031 
	C781.845276,52.811134 781.166321,50.899399 780.371155,50.031078 
	C779.658264,49.252697 778.747925,49.026264 777.373535,49.005867 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M807.001221,35.999096 
	C808.666016,36.033337 809.554077,34.742741 810.720947,33.886513 
	C812.481079,32.594868 813.762695,32.767056 813.990967,35.636139 
	C812.297119,35.785267 811.379456,36.801678 810.275452,37.938728 
	C808.702393,39.558922 807.304626,39.305965 807.005798,36.368759 
	C806.997559,36.001774 807.000000,36.000000 807.001221,35.999096 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M811.656982,52.474266 
	C812.608582,51.831829 813.370789,51.507248 813.974854,50.995796 
	C814.789124,50.306408 815.708435,49.666359 816.451599,50.705284 
	C817.445557,52.094795 816.338135,52.992867 815.133850,52.997211 
	C813.913513,53.001629 812.232605,56.976925 811.656982,52.474266 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M814.418457,41.496174 
	C813.388977,43.930920 813.388977,43.930920 809.285278,40.832203 
	C811.166016,39.435661 812.676575,40.290070 814.418457,41.496174 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M814.001221,35.998703 
	C815.611877,36.083111 817.467957,35.872475 817.593201,38.205437 
	C817.616882,38.646095 816.881775,39.474445 816.420105,39.534523 
	C814.341980,39.804935 814.142334,38.252064 814.002319,36.366123 
	C813.997559,36.002594 814.000000,36.000000 814.001221,35.998703 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M822.505615,48.645412 
	C823.193848,49.749683 824.969849,50.049435 824.262451,51.422562 
	C823.899597,52.126945 822.739624,52.173336 822.110657,51.670559 
	C820.843384,50.657524 820.234558,49.467396 822.505615,48.645412 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M824.628052,26.003525 
	C825.121399,26.877520 825.247681,27.761297 825.183838,28.829542 
	C823.895142,28.883062 822.429199,29.254522 822.242554,27.608728 
	C822.089539,26.259003 823.226868,26.098459 824.628052,26.003525 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M818.266113,54.162361 
	C819.154785,52.997429 820.037598,52.896599 820.621887,53.947124 
	C820.823975,54.310406 820.550476,55.331917 820.196350,55.536072 
	C819.186768,56.118080 818.421753,55.693222 818.266113,54.162361 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M836.002441,40.997383 
	C836.631775,41.091015 837.346252,41.097572 837.484314,41.906498 
	C837.513489,42.077579 837.156982,42.314476 836.978088,42.521046 
	C836.674744,42.203037 836.371399,41.885033 836.031616,41.286385 
	C835.995117,41.005741 836.000000,41.000019 836.002441,40.997383 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M810.316467,23.956158 
	C810.076416,23.096649 810.311768,22.301201 811.678894,22.039043 
	C811.932068,22.912401 811.663513,23.682285 810.316467,23.956158 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M808.320007,25.956455 
	C808.074524,25.091492 808.314270,24.299793 809.681335,24.038046 
	C809.931519,24.908308 809.679443,25.690510 808.320007,25.956455 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M825.754150,24.157240 
	C826.163086,24.724466 827.041382,25.634392 825.257324,25.981506 
	C825.166077,25.440069 825.338379,24.884241 825.754150,24.157240 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M734.979370,34.392677 
	C734.293640,30.857185 732.893738,30.136810 730.283386,32.418808 
	C727.380188,34.956833 728.272278,31.998856 728.020142,30.393982 
	C728.200867,28.966373 728.849976,28.178555 729.791077,27.219036 
	C730.007996,27.002630 730.000000,26.999771 730.001221,27.004097 
	C731.329773,25.862885 732.353088,26.836237 733.706665,27.754711 
	C733.992310,28.010511 734.000000,27.999924 733.994812,28.004080 
	C734.407288,28.444290 734.867371,28.815275 735.764771,29.003216 
	C737.648682,29.006594 738.092163,27.705984 738.874634,26.339666 
	C739.375916,25.643633 739.824829,25.497572 740.666870,25.827017 
	C741.964966,29.720348 737.154846,30.217134 737.003235,33.638000 
	C736.937988,35.850204 736.030884,35.517159 734.979370,34.392677 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M728.303650,48.842552 
	C727.249573,47.046509 726.123352,45.627979 723.368713,45.999603 
	C722.694946,44.392559 721.073547,42.319897 724.707092,42.001816 
	C726.841370,41.741661 728.925476,43.968616 730.774658,41.230942 
	C731.751831,41.003109 732.501221,41.003014 733.625305,41.001991 
	C734.319580,45.048382 729.843567,45.730499 728.303650,48.842552 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M758.034912,48.649567 
	C757.247620,48.998711 756.497620,48.999344 755.372620,49.000641 
	C755.048096,45.496693 758.651062,44.087135 759.666870,41.122345 
	C759.895447,40.455486 760.731689,40.411293 761.296204,41.044621 
	C761.784424,41.592281 761.853577,42.211384 761.456787,42.851402 
	C760.330139,44.668865 759.200623,46.484631 758.034912,48.649567 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M787.375671,31.009121 
	C786.927307,29.868916 786.854553,28.737528 786.781616,27.603146 
	C787.730286,26.945251 788.665283,27.631927 788.941772,28.137800 
	C789.955078,29.991568 794.593506,30.074072 792.504272,32.978256 
	C790.278381,36.072411 790.153381,29.921171 787.375671,31.009121 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M772.961060,48.655960 
	C772.549866,48.999401 772.107117,48.999107 771.332153,48.999332 
	C769.290588,45.865513 768.929199,43.180363 773.653809,42.037697 
	C773.989136,44.163349 771.063599,45.831429 772.961060,48.655960 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M734.693298,34.017715 
	C735.417969,34.674709 735.939270,35.011917 736.847290,34.224285 
	C737.441528,34.003754 737.887756,34.004360 738.668579,34.005970 
	C739.561890,34.996361 738.941589,35.736225 738.238159,36.759018 
	C738.002441,37.009663 738.001709,37.505211 738.000854,37.752987 
	C737.007751,38.819664 735.927429,39.063908 734.360657,38.252640 
	C733.997559,38.002647 734.000000,38.000000 733.998779,38.001671 
	C733.333130,37.332916 732.645569,36.675270 732.838867,35.302097 
	C733.463135,34.671448 733.931030,34.356823 734.693298,34.017715 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M761.999512,19.000626 
	C764.171814,19.249722 766.344666,19.498194 768.852295,19.784956 
	C766.281311,22.750488 764.242249,22.279419 762.156067,19.308079 
	C762.000000,18.998829 762.000000,19.000000 761.999512,19.000626 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M738.341675,36.952572 
	C738.250061,36.204285 738.497620,35.398907 738.874268,34.300251 
	C740.041687,33.609428 740.571533,31.219332 742.081787,32.882660 
	C743.789612,34.763580 741.409729,34.753418 740.585754,35.423756 
	C739.963501,35.929962 739.316772,36.405998 738.341675,36.952572 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M733.941711,27.664497 
	C732.892212,27.696049 731.792175,27.381578 730.347290,27.037766 
	C730.188538,25.637730 729.421936,23.951012 731.643311,23.068203 
	C731.526550,24.922361 733.225464,25.894199 733.941711,27.664497 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M733.998291,38.377163 
	C735.064880,38.002243 736.132263,38.001842 737.599792,38.001099 
	C737.864075,40.042831 736.735107,40.997524 734.363525,40.994263 
	C733.999695,40.249847 733.999390,39.500763 733.998291,38.377163 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M742.398987,23.995117 
	C742.127869,22.949879 741.724182,21.569662 743.217285,21.247652 
	C744.765381,20.913799 745.522034,21.929207 745.955383,23.643848 
	C744.931030,24.001465 743.866943,23.998304 742.398987,23.995117 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M794.002441,25.997591 
	C795.413879,26.165691 796.758179,26.525045 796.573792,28.309156 
	C796.525513,28.776295 795.640259,29.574350 795.243958,29.515551 
	C793.566040,29.266586 794.171387,27.783785 793.997253,26.366175 
	C793.995117,26.005093 794.000000,26.000008 794.002441,25.997591 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M801.008057,26.370012 
	C802.593567,25.960634 804.025452,26.135189 803.990356,28.627964 
	C802.403015,29.038855 800.978760,28.854465 801.008057,26.370012 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M787.000000,30.999847 
	C786.862488,32.039631 787.259399,33.342827 785.766907,33.742138 
	C785.080627,33.925747 784.458374,33.639446 784.299194,32.934189 
	C783.932129,31.307549 785.088623,31.126995 786.632080,31.009266 
	C787.000000,31.000305 787.000000,31.000000 787.000000,30.999847 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M788.654663,22.042885 
	C788.694458,23.105324 788.382751,24.206701 788.045288,25.653296 
	C786.998779,25.876831 786.072327,25.577093 786.156555,24.315216 
	C786.242676,23.025368 787.108459,22.366934 788.654663,22.042885 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M776.648926,40.003204 
	C776.925781,41.455906 776.080505,42.028648 774.353455,41.996277 
	C774.075500,40.540474 774.922119,39.970631 776.648926,40.003204 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M741.218994,25.865126 
	C740.539062,26.039480 740.102539,26.035656 739.338623,26.040394 
	C739.048645,24.566196 739.890137,23.980246 741.639771,24.002935 
	C741.995117,23.995090 742.000000,24.000000 742.002441,24.002491 
	C741.824036,24.565636 741.643188,25.126291 741.218994,25.865126 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M754.955322,23.590771 
	C754.227966,23.195337 754.223450,22.796253 754.739502,22.443365 
	C754.847900,22.369221 755.098511,22.370867 755.204285,22.447296 
	C755.712463,22.814695 755.689514,23.213337 754.955322,23.590771 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M746.002441,23.997772 
	C746.633545,24.086552 747.347656,24.090916 747.486511,24.901558 
	C747.515930,25.073296 747.159302,25.311161 746.980530,25.518570 
	C746.676880,25.200970 746.373291,24.883366 746.032349,24.285194 
	C745.995117,24.004629 746.000000,24.000000 746.002441,23.997772 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M735.881592,28.787033 
	C735.133545,30.069588 734.482239,29.853954 734.026245,28.300116 
	C734.560181,28.185156 735.130676,28.362070 735.881592,28.787033 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M713.743896,33.125717 
	C715.105591,32.669262 716.204834,32.335602 717.893433,32.247665 
	C718.775391,33.160786 718.779297,33.824242 718.227783,34.741310 
	C718.000000,34.999390 718.000000,35.000000 718.000000,35.000153 
	C716.741333,35.973778 716.146423,37.605934 714.333496,38.486259 
	C712.771545,39.796925 711.700684,41.357693 709.300171,40.233574 
	C709.002441,40.005138 709.000000,40.000153 708.997559,39.999435 
	C708.420959,39.310566 708.266907,38.538559 708.770081,37.341705 
	C710.152954,36.992790 711.074524,36.557358 711.857910,35.296921 
	C712.605896,34.516365 712.911560,33.771576 713.743896,33.125717 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M708.997742,40.364998 
	C710.768555,40.238617 712.134583,39.436420 713.686279,38.162079 
	C714.171204,38.173019 714.347229,38.337086 714.264038,38.752380 
	C713.671143,40.422665 713.337402,41.841709 712.999390,43.629627 
	C710.942078,43.409573 709.636047,45.537724 707.646545,45.569389 
	C706.939270,43.549393 709.520996,42.555981 708.997742,40.364998 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M706.386108,29.991922 
	C705.988525,29.053389 703.911133,27.011742 706.796448,27.567360 
	C708.899902,27.972422 709.719482,26.201496 711.658325,26.036095 
	C712.140015,29.803623 708.981201,29.269787 706.386108,29.991922 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M683.002258,25.998148 
	C684.402100,25.810518 685.799622,25.624741 687.542908,25.393007 
	C687.636230,27.389053 686.498840,28.370213 684.946960,28.766153 
	C683.415955,29.156736 683.083008,27.965649 683.005005,26.367111 
	C682.995300,26.003744 683.000000,26.000000 683.002258,25.998148 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M716.841248,25.255690 
	C718.148438,25.058262 719.411926,24.811731 719.942627,26.652706 
	C718.418091,25.539682 716.372559,31.678972 715.004150,26.345207 
	C715.554382,25.833509 716.110657,25.664814 716.841248,25.255690 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M705.998779,29.998924 
	C705.846924,31.607162 705.224792,32.833244 703.383972,32.804016 
	C702.706238,32.793251 702.142456,32.269836 702.235474,31.534204 
	C702.476013,29.632122 704.040161,30.143709 705.617126,30.000368 
	C706.002441,30.002174 706.000000,30.000000 705.998779,29.998924 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M705.662659,39.999893 
	C705.906799,41.240055 706.303406,42.842373 704.661621,43.188511 
	C704.224060,43.280758 703.027039,41.919884 702.949280,41.148426 
	C702.749695,39.169865 704.483582,40.341377 705.662659,39.999893 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M719.710571,29.137566 
	C720.166443,28.995972 720.335388,28.998852 720.757568,29.006687 
	C722.225525,31.402821 721.678284,32.677250 718.405762,32.237946 
	C718.000000,31.994354 718.000000,31.999939 718.002441,31.997627 
	C718.011780,30.847214 718.438721,29.918730 719.710571,29.137566 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M708.666992,37.035881 
	C709.004089,37.750210 709.000854,38.499729 708.996338,39.623985 
	C708.246399,39.998341 707.497620,39.997959 706.374451,39.998714 
	C706.000000,39.999847 706.000000,40.000000 706.000000,40.000076 
	C706.075500,38.467709 706.735046,37.399200 708.666992,37.035881 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M671.522888,27.014851 
	C671.029053,27.898582 670.413391,28.001633 669.811401,27.588888 
	C669.324890,27.255325 669.323425,26.718826 669.825134,26.397644 
	C670.436035,26.006550 671.051941,26.116768 671.522888,27.014851 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M713.807983,32.772610 
	C713.918579,33.903423 713.671265,34.689835 712.320801,34.963196 
	C712.254517,34.003643 711.376831,32.260544 713.807983,32.772610 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M715.001221,25.998825 
	C714.252380,26.000456 713.502380,26.003260 712.377380,26.004330 
	C712.002441,26.002594 712.000000,26.000000 711.998779,25.998676 
	C712.434509,23.509790 713.478699,23.994072 714.858887,25.721684 
	C714.998108,26.002205 715.000000,26.000000 715.001221,25.998825 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M695.045532,41.408028 
	C695.770264,41.802982 695.777039,42.201611 695.262268,42.554588 
	C695.154297,42.628563 694.903809,42.626434 694.798401,42.549980 
	C694.293213,42.183533 694.312927,41.785160 695.045532,41.408028 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M689.957092,23.680954 
	C689.098877,23.919350 688.313416,23.674603 688.037842,22.326748 
	C687.992676,22.008612 688.000000,21.999939 688.004517,21.995848 
	C688.913940,22.072880 689.692078,22.330412 689.957092,23.680954 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M690.000000,23.999733 
	C690.422485,24.119020 690.845032,24.238577 691.267517,24.358135 
	C690.955505,25.057323 690.597412,24.666086 690.122314,24.200956 
	C690.000000,24.000519 690.000000,24.000000 690.000000,23.999733 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M705.472046,47.454834 
	C705.522644,47.425751 705.421387,47.483917 705.472046,47.454834 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M691.472290,45.454601 
	C691.522827,45.425488 691.421753,45.483715 691.472290,45.454601 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M491.635254,33.010033 
	C491.367981,36.789349 488.370422,36.264679 485.500000,36.008888 
	C487.421448,35.010738 489.342926,34.012585 491.635254,33.010033 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M491.996948,32.996937 
	C492.035706,32.012554 491.829041,30.786160 492.810486,30.292852 
	C494.002106,29.693930 495.228882,27.356552 496.416595,28.842802 
	C497.994446,30.817251 495.022430,30.737490 494.232422,31.709885 
	C493.836487,32.197189 493.214874,32.501141 492.350708,32.946819 
	C492.006104,33.005627 492.000000,32.999977 491.996948,32.996937 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M503.625610,27.012833 
	C503.995972,27.753191 503.996857,28.501820 503.998230,29.624817 
	C503.249390,29.999769 502.500000,30.000353 501.375916,29.999821 
	C500.960266,28.405958 501.144196,26.983526 503.625610,27.012833 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M469.453918,22.528074 
	C469.424042,22.476353 469.483826,22.579796 469.453918,22.528074 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M267.990448,24.629398 
	C267.250000,24.998446 266.500000,24.997271 265.375000,24.997780 
	C264.998138,24.250742 264.996246,23.502016 264.999573,22.379063 
	C266.613525,21.942135 268.015717,22.152103 267.990448,24.629398 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M829.950562,25.335581 
	C830.445557,25.007008 830.890320,25.004965 831.668823,25.000725 
	C831.641296,26.928040 831.301880,28.875444 828.363342,28.987181 
	C827.864807,27.443495 829.589600,26.955866 829.950562,25.335581 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M800.776123,21.314863 
	C801.699890,20.151264 802.775330,19.559132 803.377258,20.657330 
	C804.160156,22.085871 802.767639,22.547085 801.334229,22.963882 
	C801.002441,23.002512 801.000000,23.000046 801.001221,23.001644 
	C800.623047,22.618547 800.474609,22.159218 800.776123,21.314863 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M800.659119,21.002010 
	C800.997131,21.448586 800.999207,21.892708 801.001831,22.670036 
	C800.098999,22.918646 799.307251,22.675943 799.026367,21.322132 
	C799.426392,21.001644 799.874756,21.000601 800.659119,21.002010 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M718.000000,32.370060 
	C719.580444,32.023331 721.020264,31.864851 721.001465,29.380602 
	C721.010925,29.011642 721.000916,29.001823 721.005615,29.006264 
	C721.649719,28.135271 722.781860,28.054810 723.788574,27.208313 
	C724.004883,26.993650 724.008423,26.518515 724.008667,26.280941 
	C724.382385,25.640272 724.840271,25.483170 725.688599,25.803017 
	C725.994629,26.034025 725.998718,26.518665 726.001831,26.760973 
	C726.580200,27.688612 726.731262,28.459770 726.239868,29.656977 
	C723.823792,32.012245 721.499512,33.815517 718.352417,34.960098 
	C717.999939,34.248180 717.999939,33.496975 718.000000,32.370060 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M726.343445,30.001534 
	C726.005554,29.250830 726.003723,28.501581 726.003418,27.377808 
	C727.072205,27.001820 728.139465,27.000359 729.607422,27.000765 
	C729.938416,28.133816 730.196777,29.411974 728.365845,29.971371 
	C727.576477,30.025059 727.128052,30.014027 726.343445,30.001534 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M723.650879,27.001633 
	C723.926941,28.443319 723.096741,29.037088 721.363403,29.007862 
	C721.066772,27.537317 721.926208,26.981447 723.650879,27.001633 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M725.959473,25.731033 
	C725.553284,26.033119 725.111938,26.032213 724.339722,26.037334 
	C724.235962,25.515244 724.326538,24.724491 724.721436,24.519314 
	C725.345764,24.194948 725.753601,24.798500 725.959473,25.731033 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M843.244690,24.746479 
	C842.200623,24.751940 841.394958,24.501728 840.294617,24.123383 
	C840.316650,21.157867 842.051941,22.784916 843.650024,22.977299 
	C843.980469,23.014248 843.973145,23.499559 843.969299,23.742212 
	C843.804626,24.153511 843.643860,24.322159 843.244690,24.746479 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M853.997559,25.997139 
	C854.086731,25.961046 854.178345,25.927750 854.137451,25.949341 
	C854.004883,26.004230 854.000000,25.999935 853.997559,25.997139 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M843.220825,24.889902 
	C843.108337,24.687424 843.289124,24.427572 843.757080,24.103729 
	C843.879883,24.310070 843.703186,24.574333 843.220825,24.889902 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M81.892410,97.225021 
	C85.960846,95.593307 90.828201,97.420914 94.148766,93.614464 
	C94.345947,93.388420 95.342224,93.422958 95.458710,93.626671 
	C98.637100,99.185608 101.209778,95.125732 103.928787,93.147675 
	C104.295525,92.880875 104.770866,92.763336 105.195915,92.576691 
	C106.731148,96.177116 108.927658,93.869301 110.975487,93.290161 
	C111.167671,93.235809 111.578743,93.955460 111.945320,94.659042 
	C112.002457,95.002335 111.701324,95.294411 111.849442,95.145973 
	C113.370277,94.984863 114.638954,95.091156 115.125114,96.744072 
	C115.401527,97.683868 116.743362,98.195381 116.995300,97.665169 
	C119.444550,92.510674 121.177307,98.618141 123.637329,97.991158 
	C125.136566,98.581772 125.612236,99.819412 126.783371,100.796173 
	C126.760574,102.125565 126.521149,103.240685 126.141022,104.673935 
	C125.110413,105.652145 125.029533,106.815392 124.146820,107.844383 
	C123.181160,108.876320 122.207756,109.329376 121.005493,110.027527 
	C119.930222,110.951721 118.964127,110.640617 117.992592,110.598053 
	C118.737587,111.016975 119.450737,110.920555 120.437126,110.482025 
	C121.615509,109.405128 123.010574,109.223740 124.045975,107.953079 
	C124.663239,107.508728 125.077332,107.465210 125.754707,107.782181 
	C126.106934,108.316620 126.296089,108.576302 126.784607,108.887070 
	C128.076141,111.970024 125.219849,113.433395 124.267090,116.033539 
	C122.339043,116.802620 120.576515,117.229210 118.419312,117.655914 
	C117.462799,117.180458 116.913879,117.184731 116.218140,117.986588 
	C112.966202,119.130638 109.874855,119.988464 106.406067,120.841133 
	C106.028610,120.835976 105.974174,120.437790 105.962372,120.237198 
	C104.606621,118.761650 103.701553,117.318634 104.308884,115.023880 
	C104.998650,113.914803 105.727173,113.313171 106.608353,112.398346 
	C107.456512,111.548256 108.075348,110.940323 108.903229,110.089661 
	C109.431267,109.626488 109.756523,109.427841 110.341110,109.284348 
	C110.556023,109.258553 110.887772,109.327919 110.813919,109.162704 
	C110.224869,108.938034 109.840454,109.194801 109.276581,109.722382 
	C108.507042,110.489693 107.938278,111.046021 107.164566,111.831421 
	C106.357155,112.637306 105.761429,113.220886 104.950172,114.046379 
	C104.071518,114.919312 103.332977,115.343452 102.081413,115.069374 
	C100.967758,113.800385 99.749390,113.545876 98.226059,113.202690 
	C97.813789,111.206543 99.647362,110.292641 99.943863,108.332336 
	C100.585350,107.424210 101.171356,106.842476 102.269768,106.721230 
	C102.498993,106.725601 102.681519,107.030144 102.681519,107.030144 
	C102.681519,107.030144 102.889633,106.743340 102.679855,106.740410 
	C101.575157,106.408272 101.063988,107.049683 100.247971,107.766197 
	C98.202858,107.874336 97.619728,110.346344 95.051140,109.924316 
	C93.569221,109.472794 92.720505,109.217567 91.628143,108.663818 
	C90.364105,105.014900 88.903114,108.121918 87.334045,108.106323 
	C86.998817,107.828354 86.996437,107.661575 86.991348,107.244614 
	C86.125854,106.348244 86.057518,105.220543 85.217293,104.217300 
	C84.834511,103.448997 84.668404,102.892754 84.268143,102.155655 
	C83.426933,102.002747 82.879486,102.187996 82.204605,102.798065 
	C81.890282,103.322762 81.703758,103.578979 81.221436,103.885361 
	C80.624138,104.377480 80.165245,104.527596 79.316071,104.230797 
	C79.000862,102.688774 78.753365,101.722099 77.388184,100.849304 
	C75.173576,99.433456 75.956406,98.356049 78.629166,98.009598 
	C79.427116,98.518776 79.951836,98.682610 80.806198,98.220291 
	C81.336250,97.898682 81.589806,97.708801 81.892410,97.225021 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M124.511299,116.352570 
	C123.482735,113.519127 124.259148,111.242607 126.934540,109.362885 
	C127.411568,108.826576 127.821091,108.655327 128.230606,108.484070 
	C128.974167,111.156693 130.341705,112.558372 133.380707,111.446198 
	C134.047043,111.202347 134.645035,112.312447 134.954300,113.461967 
	C131.646561,114.639778 128.283798,115.484444 124.511299,116.352570 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M178.250549,63.204544 
	C178.795731,60.389626 175.831314,60.295208 175.058533,58.346977 
	C179.050888,59.581547 184.598648,57.796082 186.955215,63.650700 
	C185.072372,63.521477 184.097137,65.189407 182.357971,65.964935 
	C179.753159,66.615685 181.074707,62.397064 178.250549,63.204544 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M177.999695,63.000381 
	C178.159836,62.983150 178.328003,62.925179 178.479538,62.954147 
	C180.063690,63.256996 181.013412,60.169285 182.646713,61.921646 
	C183.936264,63.305222 180.734253,63.998810 181.785110,65.822495 
	C181.853378,68.049820 180.723373,69.000488 178.362411,68.993805 
	C177.999390,68.999191 178.000000,69.000000 178.000305,69.000443 
	C177.463043,68.359947 177.032516,67.662888 176.822952,66.415466 
	C176.798981,65.151634 177.014877,64.362419 177.746674,63.325798 
	C178.000610,62.999340 178.000000,63.000000 177.999695,63.000381 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M214.002762,79.625610 
	C212.817795,79.983955 211.823288,80.215126 210.842987,81.092201 
	C209.097824,82.653610 208.215485,81.741249 208.007507,79.366013 
	C207.999619,79.000305 208.000000,79.000000 208.000214,78.999847 
	C209.389725,77.720657 210.670242,76.248367 213.405762,76.650192 
	C214.005447,77.754700 214.004944,78.503502 214.002762,79.625610 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M178.938095,83.654099 
	C176.876938,83.334969 174.744339,82.792793 172.271896,83.817131 
	C174.010178,79.430275 174.010178,79.430275 178.938095,83.654099 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M138.997437,89.002487 
	C136.828278,89.477417 135.510910,87.620575 133.357468,87.041206 
	C133.001495,87.001602 133.000000,87.000000 132.999298,86.999191 
	C132.081436,83.631104 134.216339,84.140144 136.603180,84.732964 
	C136.996338,84.996101 137.000000,85.000000 137.002029,85.001816 
	C137.916321,86.055580 139.797760,86.411980 139.217163,88.687775 
	C139.005020,88.992508 139.000443,88.999207 138.997437,89.002487 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M132.000000,93.000153 
	C131.663239,95.494392 130.240250,96.827690 127.363380,97.001190 
	C126.633232,96.588860 126.468880,96.104530 126.633453,95.176193 
	C127.870506,93.185768 129.133484,91.885956 131.678467,92.764191 
	C132.000000,92.999695 132.000000,93.000000 132.000000,93.000153 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M217.250458,73.580048 
	C217.998688,74.749489 217.997986,75.499275 217.998032,76.623924 
	C216.933914,76.999664 215.869049,77.000557 214.405060,77.003670 
	C214.005951,77.005898 213.999664,76.999565 213.997086,76.996887 
	C212.554016,74.227844 213.877518,73.268913 217.250458,73.580048 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M127.001312,100.634094 
	C125.407166,101.039497 123.984406,100.845810 124.012924,98.367661 
	C124.002296,97.997688 124.000000,98.000000 123.998779,98.001152 
	C124.683655,97.422966 125.456039,97.266930 126.656937,97.765388 
	C127.000877,98.752983 127.001747,99.505356 127.001312,100.634094 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M175.000000,75.999847 
	C176.043976,76.129753 177.347458,75.726959 177.754105,77.222282 
	C177.941574,77.911606 177.649628,78.531746 176.945129,78.693092 
	C175.324249,79.064331 175.114639,77.928680 175.007248,76.368378 
	C175.000000,76.000305 175.000000,76.000000 175.000000,75.999847 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M147.905518,106.950523 
	C146.478287,106.602158 145.530960,105.597527 146.523514,104.909233 
	C148.060837,103.843147 148.723831,106.104424 149.950607,106.572296 
	C149.378464,106.707626 148.806335,106.842957 147.905518,106.950523 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M135.985992,104.633347 
	C134.832565,104.833107 133.243134,105.290779 133.267212,103.310249 
	C133.271408,102.965027 133.729233,102.404213 134.069336,102.321815 
	C135.686417,101.930046 135.864990,103.092438 135.985992,104.633347 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M167.632507,87.010025 
	C167.840714,88.170540 168.293991,89.755913 166.310196,89.734642 
	C165.964539,89.730934 165.402039,89.271805 165.319427,88.930984 
	C164.926544,87.309959 166.094040,87.133568 167.632507,87.010025 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M164.000610,84.000534 
	C163.872498,84.921150 164.314484,86.106216 163.051178,86.532623 
	C162.311005,86.782471 161.714584,86.254471 161.536041,85.598969 
	C161.104172,84.013275 162.384201,84.175621 163.654633,84.006241 
	C163.998779,83.998924 164.000000,84.000000 164.000610,84.000534 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M136.001892,104.998199 
	C137.177628,105.083839 138.285934,105.395508 138.579254,106.682648 
	C138.736404,107.372185 138.179306,107.868980 137.432602,107.803207 
	C136.156067,107.690765 136.085098,106.685257 136.005051,105.358749 
	C135.996323,105.003723 136.000000,105.000000 136.001892,104.998199 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M179.002747,83.997406 
	C179.754074,83.996010 180.502655,83.997200 181.625626,83.999191 
	C182.000259,84.749466 182.000504,85.498932 181.999451,86.625267 
	C180.471481,86.923843 179.401276,86.267761 179.029343,84.344681 
	C178.994690,84.005386 179.000000,84.000000 179.002747,83.997406 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M126.999741,97.751678 
	C126.249420,98.002403 125.498848,98.004196 124.372910,98.004150 
	C124.012177,96.855927 124.429611,95.920265 125.707138,95.140434 
	C126.170197,94.871902 126.345657,94.747032 126.777115,94.819176 
	C127.023003,95.458031 127.012886,95.899887 127.000534,96.673309 
	C126.998283,97.004883 126.999481,97.502747 126.999741,97.751678 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M151.051300,109.384109 
	C150.714859,109.949005 150.226517,110.149956 149.471161,110.359795 
	C148.464508,109.677841 147.724869,108.986992 146.914490,108.230087 
	C148.442734,107.921265 149.820236,107.732330 151.051300,109.384109 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M178.727051,73.006226 
	C179.904236,72.388626 180.486938,72.893593 180.636948,73.747513 
	C180.764740,74.475067 180.158157,74.900879 179.470352,74.848816 
	C178.474991,74.773491 178.154037,74.167755 178.727051,73.006226 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M182.338821,83.964432 
	C182.060272,82.466171 182.732407,81.412445 184.640564,81.021225 
	C184.977493,80.978218 184.999054,80.999153 185.009705,81.010101 
	C184.912277,82.532394 184.261703,83.606667 182.338821,83.964432 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M168.000000,87.000153 
	C168.248215,86.195724 168.496414,85.391144 168.872925,84.292824 
	C169.001221,83.999084 169.000000,84.000000 168.999420,84.000351 
	C169.833405,84.454147 170.781982,84.912788 170.582657,86.053841 
	C170.404678,87.072647 169.421753,86.896667 168.335815,86.996765 
	C168.000000,86.999695 168.000000,87.000000 168.000000,87.000153 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M132.660248,99.006470 
	C132.823700,100.037773 132.571533,101.026932 131.176559,100.754372 
	C130.918976,100.704041 130.521057,100.364075 130.522644,100.160393 
	C130.532272,98.923134 131.562225,99.159035 132.660248,99.006470 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M157.999786,77.999847 
	C157.488358,80.198135 156.568405,80.626099 155.047760,78.336166 
	C154.997559,78.002747 155.000000,78.000000 155.001221,77.998627 
	C155.688812,77.420937 156.461014,77.270164 157.658386,77.765442 
	C158.000610,78.000305 158.000000,78.000000 157.999786,77.999847 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M213.999390,80.000549 
	C214.884491,80.088898 215.938522,79.761963 216.453659,80.796799 
	C216.544510,80.979309 216.121353,81.653290 215.822037,81.750404 
	C214.909241,82.046555 214.389221,81.485451 214.053955,80.329498 
	C214.001099,79.998924 214.000000,80.000000 213.999390,80.000549 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M183.667160,86.999908 
	C183.872360,87.890793 184.328903,89.195412 183.089340,89.419014 
	C181.953995,89.623817 182.159058,88.415863 182.003265,87.344818 
	C181.998169,87.002136 182.000000,87.000000 182.000916,86.998932 
	C182.445587,86.998009 182.889343,86.998146 183.667160,86.999908 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M160.297775,82.526703 
	C159.406784,82.900658 158.762253,82.882973 158.515549,82.112091 
	C158.448685,81.903122 158.694244,81.398720 158.895065,81.333458 
	C159.753525,81.054466 160.521271,81.094261 160.297775,82.526703 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M193.682465,78.498566 
	C193.498581,77.061775 194.264816,77.038696 195.117020,77.343498 
	C195.316040,77.414680 195.546875,77.925713 195.474197,78.133156 
	C195.206863,78.896164 194.564728,78.902534 193.682465,78.498566 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M155.050110,84.330933 
	C155.884140,84.085724 156.937714,83.754486 157.448364,84.794197 
	C157.538605,84.977921 157.113449,85.648094 156.812393,85.747063 
	C155.900558,86.046783 155.380890,85.487968 155.050110,84.330933 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M183.999390,86.999237 
	C184.145020,86.036469 184.373993,85.089371 185.623245,85.211296 
	C185.941162,85.242325 186.484863,85.763527 186.460281,86.013901 
	C186.355148,87.085083 185.397919,86.867050 184.342194,86.996346 
	C184.001221,87.001526 184.000000,87.000000 183.999390,86.999237 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M153.809219,87.204964 
	C154.755753,87.840027 154.686691,88.425949 153.929428,88.717590 
	C153.581573,88.851555 152.815506,88.668877 152.663177,88.394432 
	C152.238098,87.628487 152.789749,87.269814 153.809219,87.204964 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M132.999847,98.999847 
	C133.089020,98.117775 132.761444,97.066490 133.794189,96.554749 
	C133.977097,96.464119 134.648163,96.885292 134.745483,97.183716 
	C135.042435,98.094444 134.478561,98.609283 133.329590,98.946259 
	C133.000290,99.000305 133.000000,99.000000 132.999847,98.999847 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M124.333565,107.999969 
	C124.068764,106.868881 123.817535,105.591682 125.657562,105.050095 
	C126.000908,105.743469 126.001503,106.494873 126.000900,107.621765 
	C125.555000,107.997635 125.110298,107.998016 124.333565,107.999969 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M199.095734,81.735580 
	C198.238144,81.870827 197.319092,81.837364 197.487274,80.736855 
	C197.527023,80.476700 198.225632,80.128952 198.605713,80.146980 
	C199.486206,80.188744 199.449203,80.821152 199.095734,81.735580 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M199.001221,81.998825 
	C199.907104,82.123619 200.914215,82.099220 201.220047,83.236748 
	C201.260300,83.386467 200.940735,83.786308 200.744797,83.819969 
	C199.824951,83.978035 199.325974,83.456375 199.041931,82.311752 
	C198.997681,82.002441 199.000000,82.000000 199.001221,81.998825 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M135.999390,93.000565 
	C136.630157,93.094910 137.353867,93.090248 137.493698,93.910011 
	C137.523163,94.082642 137.162811,94.321777 136.982071,94.530266 
	C136.678711,94.208504 136.375366,93.886749 136.036621,93.281883 
	C136.001221,92.998779 136.000000,93.000000 135.999390,93.000565 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M131.458115,105.620255 
	C131.682327,106.413475 131.404938,106.701096 130.788803,106.579315 
	C130.660660,106.554001 130.487854,106.373131 130.468430,106.243973 
	C130.374847,105.622086 130.677017,105.360725 131.458115,105.620255 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M140.619064,108.547440 
	C141.408600,108.325249 141.696289,108.600479 141.575165,109.214424 
	C141.550018,109.341843 141.369400,109.513527 141.240631,109.532829 
	C140.621643,109.625610 140.360916,109.324814 140.619064,108.547440 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M129.520218,102.507957 
	C129.544205,102.896629 129.418198,103.131798 129.292191,103.366966 
	C129.080505,103.149841 128.868820,102.932724 128.657135,102.715591 
	C128.894821,102.595207 129.132507,102.474823 129.520218,102.507957 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M453.790405,45.832764 
	C446.481873,46.800201 439.613861,47.672646 432.752258,48.592941 
	C431.473267,48.764484 429.827545,49.556564 429.377533,47.809429 
	C428.844269,45.739113 430.900726,46.018143 432.034088,45.860596 
	C441.664948,44.521790 451.296906,43.176514 460.952454,42.035892 
	C465.115051,41.544167 469.250702,40.359234 474.208160,41.105434 
	C471.160980,43.377331 468.565033,44.978474 465.095093,45.034977 
	C461.471436,45.093983 457.777344,44.414268 453.790405,45.832764 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M476.411957,55.006748 
	C476.724213,55.115826 476.764557,55.300709 476.750305,55.763962 
	C476.280457,55.855614 475.480743,55.891499 476.411957,55.006748 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M119.457466,123.279816 
	C122.446884,120.537804 126.675400,119.931015 130.772339,119.004066 
	C139.519531,117.024986 148.223648,114.892189 156.899155,111.658424 
	C159.140945,110.842949 161.219757,110.410217 163.672409,110.018021 
	C166.744965,112.367889 169.354156,110.107773 171.934860,109.749138 
	C174.177734,109.437454 176.314713,108.452118 178.849701,109.818405 
	C159.365860,114.487206 139.618469,118.847641 119.457466,123.279816 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M180.491241,109.603745 
	C183.258408,105.899040 188.025909,106.994118 192.013565,106.053223 
	C199.342117,104.324036 206.655823,101.926971 214.651215,102.610199 
	C203.611496,105.189888 192.404358,108.058319 180.491241,109.603745 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M104.877151,125.470901 
	C108.514168,124.001755 112.483772,123.627068 116.725739,123.692055 
	C113.108154,125.150185 109.349510,127.012810 104.877151,125.470901 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M116.323807,118.283516 
	C116.078438,116.919991 116.231567,115.476059 117.911728,115.428497 
	C118.651970,115.407532 118.221153,116.435371 118.077728,117.334236 
	C117.546455,117.868752 117.068268,118.081482 116.323807,118.283516 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M269.421448,92.838806 
	C269.045563,92.069260 269.037567,91.367836 269.011078,90.315880 
	C271.220337,87.766205 272.658447,88.969727 274.195984,91.403229 
	C272.617523,91.941841 271.203430,92.424385 269.421448,92.838806 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M297.959076,84.944473 
	C299.588837,84.860222 300.857941,85.389008 301.015747,87.220673 
	C301.098022,88.175346 300.193848,87.979736 299.624329,88.075195 
	C297.747345,88.389786 297.398041,87.401733 297.826599,85.389832 
	C297.893646,84.943619 297.969818,84.986931 297.959076,84.944473 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M553.000000,52.999985 
	C552.637085,51.750477 551.089844,50.375278 553.053040,49.307423 
	C554.087463,48.744770 554.767395,49.692951 555.242798,50.592766 
	C556.151428,52.312477 555.367859,52.925930 553.353455,52.993149 
	C553.000000,53.000103 553.000000,53.000000 553.000000,52.999985 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M554.654663,41.006382 
	C554.997559,41.749531 554.997559,42.497692 554.996338,43.619759 
	C553.856750,43.916451 552.685242,43.646690 552.457886,42.399071 
	C552.212524,41.052830 553.412659,41.115108 554.654663,41.006382 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M574.146362,51.622635 
	C572.396240,52.064438 571.165466,51.904282 571.101196,50.023777 
	C571.078918,49.369431 571.184204,48.469940 571.989807,48.533859 
	C573.653137,48.665836 574.689331,49.559223 574.146362,51.622635 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M567.000000,51.999886 
	C567.627747,52.092617 568.343933,52.092964 568.485901,52.903225 
	C568.515808,53.073891 568.158997,53.312283 567.980408,53.519455 
	C567.677917,53.200424 567.375427,52.881397 567.036499,52.281342 
	C567.000000,52.000305 567.000000,52.000000 567.000000,51.999886 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M244.609131,92.594650 
	C244.594086,92.940384 244.486069,93.116768 244.378052,93.293152 
	C244.424072,93.003876 244.470108,92.714592 244.609131,92.594650 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M513.604431,65.321854 
	C513.882019,65.126556 514.343933,65.261581 514.885376,65.753868 
	C514.412292,66.369637 514.020020,66.217110 513.604431,65.321854 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M327.964691,79.285782 
	C328.412689,79.434135 328.872986,79.910873 329.431458,80.711296 
	C329.086334,81.373886 328.566071,83.392365 328.247833,80.973190 
	C328.187714,80.516212 328.068756,80.066978 327.964691,79.285782 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M342.981720,77.356445 
	C345.063110,77.066284 345.675720,78.565422 345.977814,80.598824 
	C345.420959,81.232300 344.969879,81.524117 344.269165,81.937912 
	C342.210632,80.977882 342.885223,79.299736 342.981720,77.356445 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M342.267029,77.036095 
	C341.976044,76.864143 341.944580,76.678261 341.955414,76.212570 
	C342.309540,76.117188 342.621368,76.301598 342.989746,76.754364 
	C342.873108,77.022530 342.699829,77.022346 342.267029,77.036095 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M892.060669,936.605713 
	C892.046936,959.365723 891.957764,981.683777 891.494507,1004.471313 
	C887.415955,1004.239502 883.711426,1003.538330 879.594116,1002.832703 
	C879.223389,989.904602 879.265503,976.980896 879.367493,963.602234 
	C882.249634,962.280396 881.416687,964.541687 881.448181,965.706116 
	C881.662537,973.634155 881.372070,981.566406 881.514282,989.096741 
	C881.634827,990.158752 882.707703,989.402710 882.054749,989.536865 
	C882.036926,989.540466 881.570007,989.340393 881.565552,989.105530 
	C881.423462,981.633423 881.936401,974.138306 881.422241,966.693298 
	C880.943542,959.761414 880.200928,952.846252 880.034058,945.447388 
	C880.036499,944.559814 880.024048,944.116638 880.013428,943.340881 
	C880.143982,942.838074 880.272705,942.667786 880.195679,942.252197 
	C879.982666,939.539001 879.805664,937.056335 880.019226,934.607788 
	C880.206360,932.462158 878.592529,929.351807 881.195068,928.379150 
	C884.023743,927.321838 887.563904,927.298828 890.381958,928.594116 
	C893.720703,930.128662 891.299377,933.635010 892.060669,936.605713 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M878.551697,893.250732 
	C865.495667,895.596008 852.725647,894.709595 839.537842,895.025146 
	C838.766052,895.371460 838.399231,895.566833 837.659485,895.652466 
	C836.505493,895.432495 835.687866,895.539124 834.540527,895.871094 
	C832.019592,895.812378 829.697449,896.675781 827.609741,894.617737 
	C827.461975,893.642151 827.638000,893.115662 828.362915,892.392700 
	C836.291443,890.930420 843.910767,891.453613 851.470947,891.679993 
	C860.224426,891.942139 868.891296,890.384338 878.060303,891.164429 
	C879.114258,891.775330 879.267029,892.314636 878.551697,893.250732 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M879.797913,945.003113 
	C881.895203,947.236145 881.630615,950.195801 881.700256,952.600159 
	C882.069336,965.339355 881.873596,978.094910 880.976196,990.850098 
	C880.976196,983.420837 881.036072,975.990662 880.931641,968.562866 
	C880.907349,966.833557 881.725952,964.887207 879.784912,963.255554 
	C878.490112,957.430115 879.214233,951.672302 879.025818,945.469788 
	C879.212158,945.002563 879.379517,945.002930 879.797913,945.003113 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M896.923828,899.937988 
	C897.344971,899.939941 897.616211,899.916016 897.750732,899.921326 
	C896.739136,915.501343 897.053528,931.115051 896.494690,946.722351 
	C896.922852,937.786926 894.013184,929.046692 895.626465,919.971436 
	C896.517700,914.958069 895.923462,909.676270 895.951477,904.515259 
	C895.972717,900.608826 892.609436,900.574768 889.816772,899.485718 
	C892.341431,898.339233 894.406006,899.395630 896.923828,899.937988 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M887.291016,908.862793 
	C886.432312,908.100647 885.816162,907.509094 885.503418,906.786255 
	C884.800720,905.161743 884.734558,903.468933 886.398743,902.402222 
	C887.723145,901.553162 889.393860,901.504272 890.455261,902.755188 
	C891.625916,904.134827 891.195557,905.882996 890.492432,907.405945 
	C889.972168,908.532898 888.952820,909.063843 887.291016,908.862793 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M836.687134,895.325073 
	C837.436523,894.990662 837.907166,894.964966 838.726685,895.003906 
	C840.438049,897.365845 842.868347,895.637146 844.815430,896.755676 
	C845.201660,897.129761 845.374634,897.282471 845.252563,897.615967 
	C840.115112,897.168762 837.842407,899.336182 837.986511,904.574951 
	C837.221558,904.990662 836.492615,905.003296 835.399109,905.000244 
	C832.872192,901.482544 836.012512,898.759766 836.687134,895.325073 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M845.425049,897.861938 
	C844.957520,897.796814 844.988708,897.386841 845.008667,897.181946 
	C852.287964,896.888916 859.547180,896.800781 867.107178,896.985901 
	C863.835449,899.201721 860.028259,897.716858 856.340210,897.960083 
	C852.873474,898.188660 849.376282,897.956543 845.425049,897.861938 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M878.506958,893.610840 
	C878.376892,893.200928 878.602112,892.886902 878.912048,892.397095 
	C880.035095,890.753235 881.466370,890.766602 883.387085,891.378540 
	C883.936279,891.846252 884.096924,892.095642 884.118408,892.767822 
	C882.273682,893.362549 880.567993,893.534607 878.506958,893.610840 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M884.271606,893.356323 
	C883.979370,893.190552 883.981995,892.694824 883.990479,892.447021 
	C884.930908,891.028381 886.075317,891.010498 887.657166,891.914673 
	C887.968262,892.517334 887.954590,892.791382 887.944763,893.269287 
	C886.818115,893.489258 885.690979,893.505615 884.271606,893.356323 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M879.961304,942.258057 
	C880.101196,942.278687 880.212402,942.550476 880.169434,942.915283 
	C879.987671,942.841919 879.960083,942.675598 879.961304,942.258057 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M711.548584,1008.925049 
	C711.035278,1007.239136 710.943054,1005.550842 710.790283,1003.444092 
	C710.478394,1002.595642 710.369019,1002.132202 710.553955,1001.303101 
	C710.882935,974.661011 711.059143,948.351074 711.253052,921.582825 
	C713.763306,921.649292 712.998047,923.699829 712.961609,925.165833 
	C712.800415,931.642334 713.819214,938.016541 714.696411,944.713013 
	C715.267151,956.514954 714.377319,968.041260 715.617432,979.798950 
	C715.979736,980.455322 715.987183,980.866089 715.994873,981.585205 
	C715.581299,982.415161 715.331116,983.021545 714.969177,983.927795 
	C714.356995,985.230164 714.473999,986.258667 714.798096,987.631714 
	C714.876099,988.454834 714.862427,988.937317 714.744385,989.802002 
	C714.248352,996.499451 714.904663,1002.970581 711.548584,1008.925049 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M764.234253,913.444458 
	C759.645508,914.265686 756.014954,913.864319 756.558044,907.615967 
	C754.453857,900.340515 754.453857,900.340515 746.660034,900.418579 
	C745.987549,900.436279 745.716553,900.442688 745.035522,900.460449 
	C741.005432,901.325317 737.391541,900.632935 733.407349,900.222290 
	C732.342834,899.801208 731.483337,899.843506 731.225952,898.602051 
	C733.901062,895.307190 737.497070,897.106140 741.109070,896.571533 
	C745.017456,896.498474 748.518188,896.940247 752.335693,895.753906 
	C755.100647,895.585754 757.411865,895.593018 759.800293,897.200317 
	C762.595459,901.309692 761.091858,906.356445 764.155823,910.428589 
	C764.724670,911.537048 764.772461,912.323547 764.234253,913.444458 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M712.127563,897.843628 
	C710.700500,891.580811 715.638306,894.607239 718.564575,893.868652 
	C720.987427,892.223938 723.367737,892.622375 725.645325,892.583069 
	C737.004089,892.387329 748.372498,892.973206 760.171875,892.330322 
	C761.171875,892.895935 761.463989,893.429321 761.377197,894.564697 
	C759.128906,897.065796 756.514099,895.608093 753.700684,896.001343 
	C749.701477,896.131897 746.246887,897.242493 742.223145,896.997131 
	C735.619690,896.991882 729.458069,897.009827 722.881836,896.979858 
	C721.936462,896.959167 721.407898,896.918152 720.520874,896.760376 
	C717.743591,896.172852 715.611389,897.339111 713.021912,897.879028 
	C712.679321,897.925842 712.294739,897.693604 712.127563,897.843628 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M720.982422,895.627808 
	C727.896667,895.654663 734.474121,895.646729 741.502930,895.765320 
	C742.319458,896.248047 742.494934,896.681030 742.299622,897.510803 
	C738.805359,898.675049 735.428711,898.186951 731.636230,898.315308 
	C727.012146,897.433350 722.793762,898.183838 718.109375,898.018433 
	C716.551941,899.148926 715.302368,899.123169 713.682617,898.321960 
	C713.391479,898.051697 713.043884,897.940613 712.861572,897.933228 
	C713.651550,894.051025 716.964417,895.979980 719.607605,895.346802 
	C720.211853,895.468140 720.428772,895.530518 720.982422,895.627808 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M733.286011,900.295776 
	C736.777039,899.898926 740.552429,900.238708 744.619751,899.038818 
	C745.186523,899.116821 745.340698,899.258057 745.722168,899.183228 
	C746.765442,899.000549 747.581177,899.054016 748.397461,899.064209 
	C755.655762,899.155029 755.655762,899.152832 756.567627,906.799683 
	C756.142761,907.111267 755.795349,907.016418 755.178833,906.888489 
	C754.771179,905.072876 754.632568,903.290222 754.164429,901.324280 
	C748.614685,901.884583 743.368713,901.331665 737.692993,901.318420 
	C736.010864,900.980652 734.772034,900.778320 733.286011,900.295776 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M717.994446,908.961731 
	C719.185913,907.135742 720.380676,905.231018 722.355286,906.703857 
	C723.679871,907.691895 723.190735,909.783569 722.942322,911.368164 
	C722.620361,913.422180 720.900635,913.233337 719.462341,912.978882 
	C717.243103,912.586304 717.046082,911.127075 717.994446,908.961731 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M728.975220,907.500122 
	C729.140320,906.610596 729.146973,905.850342 729.442017,905.713928 
	C730.663147,905.149292 730.765381,906.215515 730.827942,906.966064 
	C731.186523,911.268982 730.151245,915.404602 728.353821,919.574280 
	C728.552307,915.688293 728.750854,911.802246 728.975220,907.500122 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M713.271362,898.434204 
	C714.573181,898.063232 715.754944,898.074768 717.278931,898.053955 
	C718.085876,900.632629 716.709839,902.498352 714.407593,902.544739 
	C711.659119,902.600159 713.266052,900.204407 713.271362,898.434204 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M737.535645,901.444275 
	C742.476746,901.137329 747.703674,901.091736 753.382751,901.093506 
	C748.552490,902.900513 743.168945,901.790100 737.535645,901.444275 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M783.369812,943.826660 
	C783.476379,943.340027 784.035156,942.965332 784.736206,942.382812 
	C793.667297,942.033752 802.337891,943.529358 811.504333,944.151001 
	C812.311584,944.477661 812.451660,944.826477 812.147827,945.467529 
	C802.547546,945.092163 793.184753,944.515381 783.369812,943.826660 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M782.759033,949.797241 
	C783.151794,951.433777 782.397644,952.143005 781.019470,952.220764 
	C779.449951,952.309387 779.041748,951.338989 779.102539,949.607788 
	C780.276978,948.863953 781.398926,948.979431 782.759033,949.797241 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M812.276733,945.778442 
	C811.916748,945.350098 811.925903,945.031372 811.934387,944.473755 
	C812.378540,944.207092 812.826050,944.179443 813.609863,944.148438 
	C814.740601,944.560059 815.534912,944.974854 816.478943,945.467834 
	C815.125854,946.475464 813.855469,945.881592 812.276733,945.778442 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M735.043762,941.985901 
	C735.137573,941.765015 735.318115,941.735229 735.759155,941.791870 
	C735.808838,942.232605 735.629456,942.680298 735.043762,941.985901 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M752.914795,915.702271 
	C747.460938,915.456421 742.126953,916.736511 736.292480,916.770630 
	C736.578857,914.195984 734.653931,910.408447 739.547729,910.012146 
	C745.947876,909.493774 751.841003,911.652954 752.914795,915.702271 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M764.442139,913.855042 
	C763.980042,913.185730 763.979126,912.608093 763.978394,911.741455 
	C764.388672,910.419800 765.281250,909.829102 766.253967,909.772400 
	C773.941528,909.324524 781.652832,908.322571 789.617188,910.773560 
	C790.259277,912.104309 790.556702,913.065735 790.888489,914.327759 
	C782.249634,914.401184 773.576477,914.173950 764.442139,913.855042 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M734.530029,914.546631 
	C734.482788,914.575500 734.577209,914.517761 734.530029,914.546631 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M857.798340,911.780640 
	C857.296692,912.185303 856.907898,912.113953 856.223755,911.994690 
	C852.335999,910.035706 848.477905,911.184082 844.762817,911.144165 
	C841.509338,911.109070 840.162903,910.860901 840.856140,906.833740 
	C842.026855,900.032959 841.627808,899.837219 848.504517,900.002563 
	C859.225220,900.260315 857.938354,897.696289 858.007080,909.819153 
	C858.009888,910.314148 857.944580,910.809448 857.798340,911.780640 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M790.422363,911.029114 
	C781.598389,911.140198 773.235046,911.137634 764.425171,911.293701 
	C762.403076,911.251831 761.242981,910.802979 761.081848,908.823364 
	C760.817566,905.575684 760.262207,902.351807 759.763367,898.703857 
	C760.040894,895.686584 761.513184,896.506348 763.265747,897.532104 
	C764.941284,901.480774 767.610474,902.644470 771.380432,902.495483 
	C779.499878,902.174805 787.621704,902.692932 795.751953,901.651367 
	C805.359253,900.420654 814.951782,902.579895 824.588257,902.557373 
	C828.989197,902.547119 831.946411,901.325562 833.611816,896.718567 
	C834.035217,896.136536 834.220886,895.915710 834.704834,895.381348 
	C835.529053,895.010620 836.054993,894.953430 836.773438,894.956299 
	C837.684326,898.364563 835.782166,901.167664 835.043640,904.599609 
	C834.806824,910.949707 831.077881,911.302612 826.210205,911.155823 
	C814.442688,910.800964 802.659668,910.962158 790.422363,911.029114 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M826.991150,951.067749 
	C823.196472,952.075867 825.407349,949.547058 825.520264,948.450195 
	C825.606018,947.617676 825.587158,945.460388 827.207764,946.391907 
	C829.078552,947.467041 827.606323,949.233459 826.991150,951.067749 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M824.513000,954.220459 
	C825.286255,952.932495 826.079285,952.576660 826.810181,953.689331 
	C827.272034,954.392761 827.136719,955.349182 826.327637,955.713379 
	C825.344971,956.155640 824.466980,955.902710 824.513000,954.220459 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M837.690918,936.214233 
	C837.856567,936.651855 837.776611,937.288208 837.397705,938.078735 
	C837.214355,937.626282 837.329834,937.019653 837.690918,936.214233 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M721.916748,979.632324 
	C720.472717,980.061768 719.082764,980.014526 717.276489,979.889648 
	C718.251404,974.079529 717.701294,968.387268 717.302673,962.543335 
	C716.612854,952.429260 717.130432,942.236145 717.006165,932.077820 
	C716.974548,929.496765 718.450684,928.924377 720.424744,928.900757 
	C723.121582,928.868408 721.894043,931.073059 721.900940,932.184814 
	C721.998535,947.841248 721.969299,963.498474 721.916748,979.632324 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M834.314087,955.778809 
	C834.017761,954.557434 834.006897,953.144348 834.055054,951.306763 
	C838.811401,949.153625 843.502747,951.953430 848.660034,950.873779 
	C850.178284,951.811584 849.921997,953.108459 850.004028,954.691650 
	C849.847534,955.943054 849.685974,956.823853 849.268555,957.931519 
	C848.981018,956.431335 847.728821,955.888000 846.373413,955.712036 
	C842.460571,955.204102 838.541931,953.642883 834.314087,955.778809 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M850.336670,954.829590 
	C848.651367,954.190186 849.091431,952.855591 849.122864,951.236145 
	C848.974548,949.507629 849.485107,947.895020 847.280212,947.247559 
	C846.566467,946.780823 846.456543,946.278503 846.866272,945.415283 
	C847.956177,944.612000 848.780334,944.113953 849.712036,943.348633 
	C848.819519,941.750793 848.443970,940.164612 847.942261,938.266357 
	C850.032898,936.419373 852.162903,935.718323 854.604736,937.959106 
	C852.912170,943.333923 851.043579,948.774109 850.336670,954.829590 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M847.555237,937.933472 
	C850.613342,938.414307 849.961975,940.494141 849.882751,942.677979 
	C847.842590,941.787354 844.866028,942.080322 843.911987,938.981262 
	C845.072388,938.420837 846.143738,938.182922 847.555237,937.933472 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M846.739136,945.204956 
	C847.088196,945.578674 847.044373,946.047363 846.965332,946.871826 
	C843.156006,948.258545 843.156006,948.258545 838.625732,946.749573 
	C841.791321,946.155212 844.068787,945.727600 846.739136,945.204956 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M714.044312,984.306396 
	C714.066467,983.067139 714.113464,982.152222 715.655029,981.917480 
	C718.674683,983.695312 721.748230,983.112061 724.617859,983.012817 
	C728.236145,982.887756 729.499756,984.474670 730.076843,987.814758 
	C731.125305,993.882812 730.649048,999.990784 731.051514,1006.534546 
	C731.039490,1007.001709 730.989990,1006.938171 730.949829,1006.935547 
	C727.442200,1008.140808 727.578552,1005.102356 727.094788,1003.375061 
	C726.154297,1000.016846 726.545105,996.486206 726.599182,993.036438 
	C726.631409,990.981689 726.330811,989.137024 725.316040,987.384644 
	C726.399109,992.132751 726.098938,992.369934 718.760254,992.217529 
	C716.795959,991.791870 715.354614,991.177734 714.309326,989.352783 
	C714.203308,988.529663 714.202637,988.096741 714.197937,987.339050 
	C714.044983,986.218689 714.005127,985.415710 714.044312,984.306396 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M890.866638,1005.249634 
	C891.120483,1004.940674 891.385071,1004.895630 891.519165,1004.899841 
	C891.755615,1007.615173 891.858032,1010.326355 891.934509,1013.485596 
	C887.927734,1013.584900 883.946777,1013.236023 879.537354,1012.836304 
	C879.062317,1011.518250 878.564819,1009.475830 880.038452,1009.390259 
	C884.026123,1009.158630 886.528076,1005.200012 890.866638,1005.249634 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M860.207031,918.693054 
	C859.346191,918.846619 858.027588,919.527283 857.829163,918.247559 
	C857.688782,917.342590 858.819702,917.203247 859.906494,916.903748 
	C860.245544,917.320740 860.247070,917.820801 860.207031,918.693054 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M717.916260,991.042786 
	C720.543884,990.848694 722.837097,990.848694 725.494202,990.848694 
	C724.665039,989.482849 723.812744,988.456482 723.389893,987.276306 
	C722.967224,986.096680 722.510010,984.516785 724.451111,984.092163 
	C726.138977,983.722900 726.741394,984.729065 726.960938,986.310486 
	C727.574585,990.730225 728.196045,995.129089 728.078918,999.623169 
	C728.012451,1002.176331 727.839905,1004.914124 730.533875,1006.891479 
	C730.898010,1007.159668 730.886353,1007.386353 730.803467,1007.948608 
	C729.708679,1008.456604 728.684998,1008.629089 727.343750,1008.810974 
	C725.831482,1006.644348 723.691223,1007.195312 721.425171,1007.010742 
	C717.682495,1007.118408 717.184753,1004.432922 716.274963,1001.772522 
	C716.158142,999.315796 718.990845,997.418518 716.516113,994.848694 
	C716.042664,993.157043 716.299500,992.005188 717.916260,991.042786 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M901.272461,813.006958 
	C901.012695,811.966736 901.741516,811.657532 902.859253,811.346191 
	C905.963379,808.531067 909.302490,809.561340 912.963379,810.104553 
	C913.606323,810.484558 913.833740,810.683228 913.990479,811.329346 
	C913.661377,811.843811 913.408691,811.927734 913.026978,812.176636 
	C909.867188,814.954529 906.291565,812.795288 902.577026,813.331299 
	C901.930176,813.143860 901.746521,813.082092 901.272461,813.006958 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M902.341431,813.422852 
	C905.405762,812.916931 908.697693,812.628235 912.441040,812.332031 
	C912.903503,812.573608 912.914612,812.822632 912.911377,813.445312 
	C910.576782,813.892944 908.256470,813.966919 905.501099,814.040405 
	C904.233643,813.906677 903.401367,813.773376 902.341431,813.422852 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M984.738220,855.239136 
	C985.162903,855.700989 985.117981,856.030701 985.083740,856.609863 
	C978.873596,857.662720 972.834900,855.816040 966.407104,855.320068 
	C972.176086,855.067322 978.222473,855.087219 984.738220,855.239136 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M888.217285,816.598389 
	C888.011719,818.605286 887.991394,820.306885 887.954468,822.432983 
	C888.745789,823.799438 889.678589,824.630798 890.590942,825.984192 
	C891.403625,827.803345 891.452515,829.418701 891.905518,831.362915 
	C892.181335,836.076294 891.684814,840.393982 892.359192,845.116577 
	C892.330994,855.457703 892.862244,865.374756 892.092896,875.692627 
	C891.485657,877.481873 890.218445,877.985718 888.807617,878.883484 
	C886.804810,881.679626 887.535706,884.866028 886.223389,887.918701 
	C885.988037,888.530029 885.870972,888.769409 885.516418,889.338989 
	C884.897339,890.074402 884.457520,890.401489 883.557434,890.767334 
	C879.526489,891.077271 875.898804,891.033081 871.891235,890.831177 
	C869.277405,887.853027 863.797546,886.817505 866.197083,881.253601 
	C865.578247,882.351868 865.158508,883.610596 863.648254,883.281982 
	C862.531555,883.038879 862.063416,882.070740 862.082825,881.008911 
	C862.124207,878.739014 861.505737,876.500610 861.459106,874.235107 
	C861.449158,876.953857 862.272461,879.650757 862.010132,882.385010 
	C861.875854,883.784485 861.717712,885.271240 860.008911,885.300964 
	C858.313965,885.330444 858.079285,883.758118 857.804138,882.447449 
	C857.272339,879.914001 858.095154,877.527405 858.648376,875.086304 
	C858.334839,875.856018 858.615601,876.988342 857.194946,876.983521 
	C856.984436,876.982849 855.684570,873.780090 856.092468,877.222107 
	C856.351257,879.405823 856.865479,882.126221 852.956421,882.201477 
	C850.737244,878.746948 852.264404,874.854980 850.644653,871.168579 
	C850.379822,869.742676 849.590515,869.301086 848.315979,868.899353 
	C839.925537,866.808960 831.633362,866.346924 823.529663,864.746094 
	C819.953308,864.039612 819.286194,865.617310 819.856750,868.904968 
	C820.644165,873.442139 821.303711,878.085938 818.722717,882.772217 
	C818.011108,883.386047 817.515991,883.547729 816.587219,883.452881 
	C813.680176,879.826050 814.881348,875.769104 814.652039,871.936768 
	C814.267517,865.509277 812.850708,863.339294 806.911621,861.304504 
	C799.830627,859.680115 793.174500,857.757263 785.820190,858.718750 
	C785.270081,858.977600 785.062439,859.102966 784.525513,859.375854 
	C781.062927,859.758789 777.773621,858.656494 774.602905,860.846191 
	C773.929443,861.477173 773.445862,861.819824 773.018372,862.430664 
	C773.283325,861.694397 774.312378,861.499451 775.078125,860.591309 
	C779.216980,858.604370 782.620850,859.222473 785.792114,862.624084 
	C786.197021,863.083984 786.350464,863.278076 786.707947,863.786377 
	C787.290466,864.764709 787.588684,865.464783 787.960327,866.556152 
	C789.140320,871.781494 787.474854,876.269714 786.117615,881.188721 
	C784.685974,884.418213 782.673950,886.694092 779.812866,888.717773 
	C778.287231,889.309875 777.131897,889.792725 775.759888,890.720703 
	C773.595886,891.509460 771.710754,891.318237 769.441040,891.408630 
	C768.200134,891.431396 767.368713,891.434631 766.113953,891.516357 
	C758.752136,892.487610 751.789185,892.602661 744.408325,892.092102 
	C743.769592,891.846252 743.532898,891.715149 743.030212,891.289917 
	C743.673523,887.894104 744.261841,884.837036 741.348022,881.892822 
	C741.051880,881.289246 740.954285,881.032288 740.762573,880.364136 
	C740.002380,869.058105 742.036011,858.185974 741.112366,846.888428 
	C741.581421,845.989441 742.007019,845.654907 742.967407,845.499512 
	C746.680420,848.136292 748.667297,850.670044 745.858154,855.346130 
	C744.514160,857.583313 744.243835,861.368774 747.052490,864.279724 
	C749.814209,870.754578 749.110046,877.491699 750.622375,884.617065 
	C750.155823,877.765198 750.899597,871.660828 751.001831,865.136230 
	C751.371948,859.256104 749.885254,853.794983 750.374573,850.626221 
	C749.999390,854.322937 751.391663,860.316833 750.992310,866.769775 
	C750.834290,868.634827 751.295288,870.311340 749.229248,871.104919 
	C747.877258,868.924500 748.946533,866.200623 747.669922,863.566284 
	C746.448181,858.300415 747.637329,853.386963 746.927307,848.561523 
	C746.723999,847.179688 747.350586,846.004578 748.333984,844.546631 
	C752.311523,842.841858 756.081848,842.382141 759.941711,842.584839 
	C773.584351,843.301147 787.097473,841.219360 800.681458,840.736694 
	C813.621521,840.276917 826.506897,839.033875 839.437744,838.421631 
	C854.208618,837.722229 868.997803,837.324036 883.749329,836.218811 
	C844.437317,837.568298 805.224304,840.652222 765.544312,842.895508 
	C762.415344,841.426270 763.495728,839.984802 765.266479,838.872742 
	C767.372192,837.550476 769.409302,836.114197 771.937927,834.757568 
	C772.532410,834.564453 772.774109,834.516602 773.374146,834.509277 
	C774.401550,834.848450 774.740479,835.436279 775.202759,836.311523 
	C775.598328,836.885559 775.885620,837.148743 776.514771,837.435791 
	C779.501587,837.796204 782.041382,836.669067 785.041138,836.625977 
	C790.522095,835.566650 794.578064,832.567688 798.424011,829.258362 
	C800.276550,827.664368 801.875183,825.771667 804.394348,824.482422 
	C805.069885,824.121216 805.454285,823.919617 806.108398,823.549683 
	C806.909241,823.039185 807.452698,822.716370 808.240845,822.188965 
	C808.854248,821.765991 809.204285,821.518616 809.808960,821.058044 
	C811.555298,819.818420 812.742676,818.240173 815.157715,818.302612 
	C816.763306,818.863892 817.510803,819.754517 817.611389,821.479431 
	C813.808960,826.289368 808.924927,829.450623 804.539429,833.182495 
	C803.184143,834.335693 801.674500,835.307556 800.376770,836.512634 
	C802.193848,835.114014 804.323914,835.927612 806.634216,835.605713 
	C814.744385,835.907471 822.399963,834.731567 830.099304,834.435364 
	C832.470703,834.344177 834.604797,833.622925 836.840820,831.988159 
	C837.642395,831.540405 838.131592,831.394104 839.011963,831.384399 
	C840.934509,832.227783 842.506409,836.105957 843.856323,831.149780 
	C841.940369,828.951050 839.901123,827.958130 836.922729,828.857544 
	C835.085754,829.071167 833.816895,828.626465 832.642578,827.192688 
	C831.981384,826.015259 831.924805,824.978516 831.425964,823.806641 
	C831.026794,823.353516 830.750977,823.145996 830.233643,822.870911 
	C829.388489,822.695557 829.148010,823.270386 828.429382,823.637939 
	C826.698608,824.048950 825.442200,823.579468 823.982544,822.599609 
	C822.465576,820.466858 820.686707,818.721375 821.917908,815.804688 
	C822.251587,815.245300 822.469971,815.007996 822.752319,814.857239 
	C823.081909,814.681335 823.325562,814.598999 823.459351,814.565247 
	C823.459229,814.565552 823.305664,814.520020 822.698547,814.377319 
	C821.791016,814.104065 821.260071,813.759155 820.585815,813.050049 
	C820.190247,812.360718 820.048401,811.926453 819.922729,811.126465 
	C819.933594,808.922668 820.638672,807.652039 822.622742,807.193481 
	C826.275757,806.349243 828.488708,803.671509 830.714600,800.459900 
	C832.496338,798.854248 834.253296,798.616882 836.522339,799.256042 
	C840.960876,804.719666 841.122864,807.671692 837.254639,811.507202 
	C836.819397,811.825989 836.669189,811.971008 836.187500,812.579224 
	C835.768677,813.189636 835.681152,813.336853 835.569336,813.717529 
	C836.344604,814.895630 837.338440,814.243225 838.592773,814.264282 
	C839.169006,814.278870 839.400818,814.309143 839.967163,814.458740 
	C841.166809,815.055176 841.820068,815.752747 842.527100,816.891052 
	C842.902649,817.935547 842.906616,818.658020 842.644287,819.723145 
	C842.272156,820.762573 841.343689,821.380676 841.905945,822.140381 
	C842.111694,822.418274 842.511230,821.651123 842.762451,820.905396 
	C843.039978,819.678345 842.994507,818.753296 843.210693,817.512573 
	C843.604492,816.421692 844.393494,815.474915 844.006531,814.893982 
	C841.328247,810.872253 843.349304,807.151550 844.697144,803.045044 
	C845.246887,802.414734 845.668640,802.171021 846.483521,801.867920 
	C848.603333,801.506226 850.215088,800.401550 852.357788,801.143555 
	C854.113159,804.930725 851.867188,808.271545 852.153564,812.099365 
	C850.981018,816.018738 850.947632,819.853516 848.916138,823.452271 
	C848.150269,824.342224 847.410034,824.543945 846.505615,824.813232 
	C846.440796,825.216980 846.472168,825.385803 846.426208,825.801392 
	C846.108215,826.297424 845.824646,826.475220 845.738342,826.619873 
	C846.144409,826.752625 846.300171,826.830017 846.715820,826.964417 
	C847.145264,827.083374 847.314697,827.145264 847.730591,827.328857 
	C848.134705,827.548096 848.292419,827.645630 848.678955,827.904053 
	C849.516846,828.512329 850.147522,828.926208 851.051880,829.452759 
	C851.918152,830.073730 852.488892,830.610535 853.478027,831.030151 
	C856.338501,830.002197 853.893982,828.542664 853.932007,827.269592 
	C854.011841,824.597961 853.835693,822.023071 858.130127,823.036987 
	C860.978394,823.909363 863.517883,823.782898 866.407104,823.228760 
	C867.209778,823.010681 867.675842,822.919128 868.497681,822.800232 
	C870.001831,822.623535 871.182190,822.714600 872.635986,822.222534 
	C876.359253,821.185059 880.436890,821.758179 882.490723,817.481079 
	C882.536743,816.462036 882.343750,815.813538 882.067505,814.826294 
	C880.451111,809.953064 880.536011,804.929443 877.597656,800.452820 
	C877.180237,799.705261 876.998352,799.253967 876.768066,798.441101 
	C875.124939,793.302002 874.340149,793.070190 867.486145,793.316650 
	C864.033630,793.440796 863.225647,795.202515 863.249512,798.437195 
	C863.172668,799.043579 863.130920,799.287354 863.000244,799.896301 
	C861.395081,804.645203 860.536743,809.158875 860.165833,814.173828 
	C859.995239,814.813049 859.899414,815.062012 859.570435,815.638000 
	C859.099426,816.089233 858.861755,816.213440 858.223511,816.292725 
	C854.681152,814.154663 856.360840,810.850342 855.739624,807.709595 
	C855.556396,800.970093 857.929138,794.918213 857.891724,788.187073 
	C858.128601,787.275879 858.315552,786.775879 858.703369,785.937378 
	C860.501648,781.068665 861.018982,776.254761 862.667847,771.347290 
	C863.127136,770.003296 863.632385,769.125732 864.739868,768.207642 
	C868.727295,765.209167 870.423035,769.550476 873.130737,770.295532 
	C873.295776,770.341003 873.465332,771.369812 873.289307,771.510010 
	C868.142212,775.611328 875.114807,777.878479 874.735596,781.230896 
	C875.052429,781.174805 875.369263,781.118774 875.990356,780.959229 
	C876.743347,781.003357 877.145142,781.234314 877.751953,781.788147 
	C877.997681,782.038757 878.015808,781.980652 877.987122,781.970459 
	C882.754456,791.725220 884.702515,802.404724 887.889709,813.073608 
	C887.981201,813.929688 888.018982,814.417175 888.138428,815.254272 
	C888.276855,815.833984 888.339722,816.063599 888.217285,816.598389 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M852.145874,800.729553 
	C850.586609,801.666687 849.690063,803.119446 847.667969,803.046082 
	C846.617371,802.502686 845.835205,802.032776 844.633240,801.607056 
	C839.581299,797.177979 834.240112,796.713013 828.589844,799.204712 
	C825.426636,800.599548 822.265198,802.014893 818.942383,803.543518 
	C823.261780,803.820923 826.323547,800.124268 830.737915,800.821350 
	C829.715698,805.024414 827.037170,807.802124 822.980103,808.393982 
	C820.908447,808.696228 821.119019,809.774414 820.703857,811.335938 
	C819.935608,811.987915 819.236511,811.996887 818.195679,811.781128 
	C815.570435,810.564697 814.069702,807.994080 810.849731,807.928406 
	C809.807678,807.587097 809.074463,807.253357 807.997681,807.781921 
	C802.859436,810.182861 799.348633,814.539612 793.947998,816.478394 
	C792.831238,816.129578 792.381104,815.542969 791.957886,814.452515 
	C791.744690,813.577820 791.684509,813.069153 791.645996,812.178833 
	C792.156738,806.458557 791.828857,801.102356 791.773438,795.451172 
	C791.502014,794.837280 791.264893,794.683838 790.974854,794.752686 
	C790.326355,794.906677 790.647034,795.477478 790.814331,794.832153 
	C790.981628,794.186829 791.892517,795.124695 791.417725,795.199463 
	C791.712952,795.865601 791.765686,796.281982 791.722595,797.031616 
	C791.274170,798.690735 791.507690,799.994690 791.911011,801.651062 
	C791.961975,803.522278 792.127136,805.043396 791.492554,806.868347 
	C788.622192,809.057556 785.305664,809.016235 782.426086,809.284546 
	C778.248230,809.674011 779.237244,805.861450 779.214966,802.830078 
	C779.110840,801.952759 779.119324,801.455139 779.273682,800.612488 
	C780.899414,798.018555 781.858398,795.574951 781.939941,792.497681 
	C782.066895,791.981445 782.135803,791.782166 782.365173,791.321533 
	C782.798767,790.679993 783.530945,790.817566 783.581238,790.394348 
	C783.622009,790.051392 782.906128,790.445435 782.565125,789.768066 
	C782.334290,789.076416 782.335571,788.657410 782.525024,787.933105 
	C783.857666,786.122192 785.234985,784.668335 784.232544,782.144043 
	C784.039490,781.146179 784.048401,780.476013 784.279175,779.490723 
	C785.128296,777.712524 786.607605,776.598206 786.440186,774.419067 
	C786.307434,773.696106 786.268677,773.276917 786.290894,772.535400 
	C786.404358,771.796936 786.506714,771.381653 786.706787,770.659058 
	C786.901550,769.932007 787.022949,769.518677 787.247192,768.796265 
	C788.133301,766.001038 789.482544,763.714111 790.024719,760.795166 
	C790.249146,760.064087 790.415161,759.661377 790.750549,758.981506 
	C791.006897,758.514221 791.117126,758.333557 791.409546,757.898315 
	C791.955139,757.160400 792.377930,756.715698 792.648438,755.833740 
	C792.835449,754.941223 792.964844,754.344727 793.167603,753.445496 
	C793.363892,752.744019 793.494812,752.347961 793.731201,751.654175 
	C793.973572,750.954285 794.139709,750.563782 794.482666,749.901245 
	C795.359070,748.764771 795.675598,747.743469 795.907959,746.314270 
	C795.833069,743.767761 796.723633,742.016602 798.691040,740.430054 
	C799.612976,740.220764 800.144409,740.279846 800.997925,740.697693 
	C802.463928,742.945740 801.825745,745.137756 801.943726,747.635498 
	C801.334351,749.878540 800.656494,751.738037 802.060181,753.968872 
	C802.806458,762.214111 801.800903,770.180786 803.770508,778.368530 
	C804.754395,781.686096 804.114746,784.728455 804.747498,788.033569 
	C805.690369,791.505493 804.910217,794.836853 806.282471,798.054565 
	C806.973083,792.030029 806.995789,785.902161 804.338623,779.724304 
	C803.976562,778.499207 803.863098,777.588257 804.070435,776.333496 
	C805.410645,774.993225 804.293945,774.342896 803.623657,773.312073 
	C803.334473,772.602234 803.274536,772.169250 803.331970,771.399109 
	C803.607361,770.424561 804.020325,769.915894 804.762207,769.242249 
	C805.162170,769.006653 805.329285,769.004700 805.746948,769.000183 
	C809.140686,769.546814 807.991882,772.818787 809.598694,774.796143 
	C810.338196,778.367676 809.625793,781.637695 810.407959,784.845703 
	C809.811584,782.098816 810.042725,779.332458 809.990173,776.171387 
	C809.739563,773.850342 809.299255,771.935852 809.920959,769.593689 
	C811.149780,767.278809 812.410461,766.935547 813.742859,768.940491 
	C814.474243,770.041077 814.289001,771.528137 815.374512,772.897705 
	C819.160889,778.514648 818.700745,784.910828 820.635803,790.694275 
	C818.910889,782.119019 817.776550,773.437927 816.213257,764.824890 
	C816.126831,764.348877 815.659119,764.029114 814.827759,763.797302 
	C811.723572,762.991577 811.326904,761.042358 812.047974,758.289307 
	C812.932373,757.021545 813.736023,756.151489 814.873718,755.144897 
	C816.281250,755.641479 817.366699,756.284973 818.776123,756.968262 
	C820.369629,757.090881 821.564087,757.735352 823.289001,757.452026 
	C837.903992,755.484192 852.171204,756.638489 866.409241,756.487000 
	C868.396973,756.465820 870.388428,756.771240 872.438965,758.313782 
	C873.275818,759.085388 873.741394,759.582642 874.243225,760.427673 
	C872.083679,760.859680 869.887939,760.943909 867.229248,761.069092 
	C862.080811,762.584106 857.430298,762.569214 852.550659,761.727539 
	C846.482849,760.681030 840.399048,763.137085 833.807251,762.441284 
	C831.085632,762.614624 828.802979,762.545837 826.123474,762.505798 
	C823.519409,762.318420 822.198547,763.062866 822.574219,765.552368 
	C822.623291,765.877380 822.745544,766.188416 822.793457,766.507690 
	C824.249878,776.211731 824.247986,776.212036 835.540894,776.821777 
	C837.020813,777.152832 837.991943,777.639771 839.042236,778.763550 
	C839.260803,779.391235 839.248413,779.668030 838.956238,780.247681 
	C836.035278,781.951965 833.160400,781.366333 830.375427,781.504578 
	C827.949341,781.625183 825.563293,781.567383 826.076172,785.209900 
	C826.508545,788.281250 827.181335,790.909119 831.169739,790.202148 
	C836.268677,789.298218 841.410950,789.505554 846.546570,789.514221 
	C848.038757,789.516724 849.533630,789.549011 851.324585,790.224976 
	C852.386353,790.930298 852.548645,791.644348 852.204468,792.790161 
	C850.571411,794.702881 848.216309,793.625916 846.582336,794.873474 
	C847.549194,796.292358 849.165894,796.338501 850.742126,797.191406 
	C851.467224,797.628540 851.819275,797.960571 852.301086,798.668030 
	C852.579895,799.490356 852.549316,799.977356 852.145874,800.729553 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M900.584167,833.784668 
	C901.017395,844.867126 901.215027,855.645020 901.168884,866.421814 
	C901.154846,869.677124 902.924377,872.909729 901.064819,876.483276 
	C900.734802,876.981079 900.643860,877.169067 899.789673,877.059082 
	C897.765442,873.036438 898.350342,869.179138 898.212036,865.374329 
	C897.843872,855.245239 897.483887,845.115784 897.053772,834.535583 
	C897.917847,833.027405 899.040283,833.004272 900.584167,833.784668 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M887.206116,814.919495 
	C884.696777,803.868408 881.776917,793.182922 877.985901,782.349365 
	C879.130615,782.412354 879.709839,783.303589 880.171997,784.463074 
	C884.088379,794.288330 886.585571,804.530334 889.129272,814.757568 
	C889.270203,815.324158 888.917419,816.013550 888.413208,816.774658 
	C888.032104,816.903625 887.886108,816.437988 887.784241,816.216309 
	C887.638123,815.667175 887.500305,815.385620 887.206116,814.919495 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M832.794434,761.410156 
	C843.960815,760.319702 854.916443,760.442566 866.317993,761.139526 
	C866.658447,761.871277 866.045532,761.834656 865.230347,761.994019 
	C864.473267,762.502747 863.860291,762.482178 863.019226,762.414795 
	C862.761353,762.264893 862.415344,762.178467 862.268066,762.278992 
	C862.105591,765.095764 859.935303,764.977173 857.752808,765.281555 
	C851.312317,762.422852 845.017090,763.651672 838.781677,763.904541 
	C836.468079,763.998413 833.703003,765.247742 832.794434,761.410156 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M857.654297,765.160400 
	C859.190125,764.176392 860.358154,763.331543 861.823364,762.433105 
	C862.367371,762.908325 862.614075,763.437073 862.913147,764.404236 
	C862.975891,765.448547 862.978210,766.054321 862.911865,766.965149 
	C862.822449,767.469177 862.766663,767.667725 862.593811,768.153931 
	C862.297424,768.818726 862.106262,769.189697 861.749146,769.834839 
	C861.480286,770.298462 861.365784,770.481934 861.065125,770.933960 
	C859.458496,773.486389 859.680969,776.614319 856.859375,778.475464 
	C856.005310,778.644836 855.518677,778.559265 854.767456,778.082336 
	C853.069275,775.197083 853.949036,772.641357 854.804199,769.700806 
	C855.510254,767.864807 855.959595,766.323242 857.654297,765.160400 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M890.766113,877.130005 
	C892.918152,868.682678 891.407654,860.474426 891.735229,852.324951 
	C891.820923,850.192505 891.780579,848.054932 891.810364,845.450073 
	C892.014465,844.871948 892.206238,844.763428 892.649780,844.869141 
	C892.971069,854.208435 893.181458,863.335938 893.027832,872.457214 
	C892.979431,875.332275 894.009216,876.321838 896.802002,876.651489 
	C897.100098,877.246338 897.202087,877.488770 897.086304,878.062500 
	C895.961121,879.050232 894.911194,879.181396 893.433472,879.198242 
	C892.496216,879.103821 891.984619,878.948975 891.177856,878.471558 
	C890.763367,877.979004 890.667908,877.729736 890.766113,877.130005 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M893.001709,844.619385 
	C892.721741,845.066162 892.541931,845.048889 892.092407,845.005981 
	C890.373962,840.691772 891.080933,836.269348 891.027283,831.430298 
	C891.322510,830.689270 891.660645,830.554016 892.309814,830.655762 
	C892.746887,835.232239 892.924377,839.693848 893.001709,844.619385 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M864.797241,767.846191 
	C864.833313,768.757568 864.631104,769.550781 864.244385,770.600769 
	C861.312744,774.090637 862.240723,778.747925 859.330017,781.980225 
	C858.318176,781.330627 858.023193,780.602539 857.891846,779.387451 
	C858.732605,776.171143 859.202515,773.243774 860.742859,770.256775 
	C860.996765,769.944885 861.006226,770.005615 860.975464,770.006470 
	C861.423706,769.602600 861.503540,769.019043 861.789185,768.211914 
	C861.940308,767.963806 862.000000,767.991394 861.970337,767.973511 
	C862.393494,767.537109 862.711670,766.966248 863.629944,766.807373 
	C864.141907,767.165100 864.350403,767.446594 864.797241,767.846191 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M892.640930,830.393311 
	C892.230103,830.809753 891.890747,830.848816 891.297668,830.926636 
	C890.655579,829.580872 890.267334,828.196289 889.841553,826.445496 
	C889.245605,824.653625 889.606262,823.741760 891.646912,823.697632 
	C892.282104,825.912537 892.497314,827.964233 892.640930,830.393311 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M901.208862,834.077026 
	C899.863953,834.048401 898.814514,834.007080 897.375977,834.025269 
	C896.712708,831.933716 896.712708,831.933716 901.586304,831.585388 
	C902.239319,832.081482 902.510742,832.693237 902.733948,833.656006 
	C902.291931,834.026123 901.898193,834.045288 901.208862,834.077026 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M892.029541,823.564697 
	C890.974670,823.812927 890.126404,824.098877 889.901611,825.725586 
	C888.390930,825.831299 887.970398,824.847473 887.941162,823.214294 
	C889.229492,823.584717 890.975220,819.833130 892.029541,823.564697 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M896.482666,878.980774 
	C896.695129,878.353271 896.773987,878.087769 896.925537,877.413086 
	C897.458069,877.004028 897.917908,877.004089 898.702087,876.882690 
	C899.026367,876.761108 898.780640,876.991699 898.844116,877.147827 
	C899.093445,877.484131 899.279358,877.664307 899.620972,878.201294 
	C899.929993,880.000488 899.603699,881.147827 897.589417,881.423340 
	C896.493164,880.867249 896.294434,880.158997 896.482666,878.980774 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M878.037231,781.686401 
	C877.537659,781.795654 877.077698,781.552490 876.456177,781.082520 
	C875.917480,779.859375 875.540283,778.863037 874.881042,777.121704 
	C877.066833,778.344849 877.853516,779.620667 878.037231,781.686401 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M863.972168,766.550659 
	C863.470215,767.265137 863.006958,767.646606 862.242188,767.991882 
	C861.187988,766.865723 862.135071,766.228760 862.785034,765.153564 
	C863.817749,764.918030 864.045410,765.468262 863.972168,766.550659 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M863.022827,762.466003 
	C863.314941,762.130493 863.868469,761.996033 864.689819,761.970093 
	C864.531494,762.649170 863.989746,762.890991 863.022827,762.466003 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M984.667358,866.540527 
	C984.999268,866.967651 985.015625,867.135254 985.048950,867.554443 
	C978.794128,867.505188 972.522339,867.204285 966.250610,866.903381 
	C972.277954,865.773254 978.306702,865.648132 984.667358,866.540527 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M932.777893,847.733765 
	C932.973267,847.745300 933.175354,847.817444 933.693787,847.949585 
	C934.325134,848.272461 934.690247,848.400574 935.395020,848.459839 
	C936.662720,848.747681 937.642395,848.957397 938.842285,849.455322 
	C939.716431,850.055115 940.128174,850.742859 941.090881,851.202759 
	C941.531067,851.374207 941.705261,851.448425 942.115356,851.676636 
	C942.591553,852.295349 942.759277,852.196350 943.138794,851.614380 
	C943.790955,851.384094 944.179504,851.419373 944.794678,851.743896 
	C945.028687,851.934265 945.048950,851.960938 945.060059,851.973511 
	C945.353577,852.356445 945.492737,852.771973 945.291382,853.531189 
	C945.359131,855.234680 945.601807,856.646729 945.838806,858.490601 
	C943.689514,862.114319 941.084778,862.797363 938.029236,860.217957 
	C936.563049,858.980225 934.780579,858.776123 932.854736,858.031067 
	C931.680542,855.230347 933.331543,852.717834 932.360840,850.164978 
	C931.911255,849.925537 931.750122,849.727295 931.722412,849.169739 
	C931.855835,848.810486 931.890808,848.921021 931.832886,848.919861 
	C932.134094,848.821472 932.429199,848.624817 932.781921,848.093994 
	C932.895020,847.845764 932.784546,847.794312 932.777893,847.733765 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M932.468384,858.124878 
	C934.559998,857.236389 936.551697,856.386414 938.024292,858.546997 
	C940.206055,861.747925 942.626770,860.963745 945.492737,858.993286 
	C947.372375,862.641357 946.559021,865.435242 942.506531,866.661926 
	C937.076843,868.305542 933.919189,866.923462 932.641113,862.401245 
	C932.292664,861.168274 932.391541,859.809021 932.468384,858.124878 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M945.548828,853.896667 
	C944.939392,853.309814 944.762329,852.796936 944.828186,852.135071 
	C946.115540,851.932007 946.275452,852.901978 946.818970,853.769470 
	C946.562012,854.038391 946.271606,854.004578 945.548828,853.896667 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M931.627808,848.938110 
	C931.902893,849.027649 931.950012,849.244751 932.034729,849.792847 
	C931.858704,850.255981 931.509583,850.544983 931.452454,850.495789 
	C930.951538,850.063232 931.019043,849.559082 931.627808,848.938110 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M932.570007,847.764404 
	C932.712097,848.167175 932.529175,848.488525 932.060608,848.864319 
	C931.931641,848.506836 932.088318,848.094971 932.570007,847.764404 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M930.438965,870.792053 
	C930.187317,870.941223 929.933777,870.626648 929.900085,870.535400 
	C930.141174,870.510376 930.415894,870.576599 930.438965,870.792053 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M893.978149,796.639404 
	C894.251953,797.475220 894.492615,797.970520 894.864990,798.709412 
	C895.754883,801.386780 896.498718,803.825195 897.277100,806.252441 
	C897.701233,807.574768 897.988586,808.799744 895.633545,808.890503 
	C895.166809,808.610901 894.897278,808.414062 894.888428,808.247437 
	C894.782654,807.919250 894.685730,807.757751 894.505554,807.326172 
	C894.269287,806.662598 894.116272,806.269043 893.915161,805.561707 
	C893.773132,805.039246 893.679138,804.830505 893.425537,804.317749 
	C893.140564,803.641663 893.015076,803.269653 892.834717,802.609375 
	C894.381409,798.760193 890.580872,795.874146 891.830078,792.178467 
	C892.728699,793.408508 893.336853,794.853638 893.978149,796.639404 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M923.893311,868.602173 
	C923.536743,869.255554 923.059509,869.553101 922.304321,869.897522 
	C922.016968,869.002563 921.173462,867.858582 922.097046,867.175293 
	C922.989563,866.514954 923.460388,867.474487 923.893311,868.602173 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M937.756165,835.999390 
	C938.338318,836.246460 939.687500,836.102356 938.527405,836.793762 
	C938.033752,837.087952 936.595825,837.653259 936.075623,836.229858 
	C936.533020,836.147217 936.990356,836.064636 937.756165,835.999390 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M926.851196,869.775757 
	C926.620422,869.900085 926.273438,869.756897 925.809387,869.323853 
	C926.039856,869.192078 926.387390,869.350159 926.851196,869.775757 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M966.487549,877.892212 
	C966.098328,877.483826 966.092529,877.103394 966.106262,876.437927 
	C967.127197,876.129517 968.128601,876.106201 969.506592,876.101196 
	C970.296326,876.443726 970.464111,876.871582 970.185425,877.676392 
	C968.924866,877.949097 967.897949,877.934692 966.487549,877.892212 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M970.345581,878.058716 
	C969.941284,877.553894 969.930725,877.144165 969.901672,876.427002 
	C971.715149,875.486633 973.275574,875.790405 974.621948,877.573669 
	C973.419434,878.771240 972.005859,878.080139 970.345581,878.058716 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M946.306030,884.057129 
	C946.393860,883.613525 946.764832,883.218079 947.374634,882.684692 
	C947.613403,882.546814 947.893677,882.872314 948.033936,883.036133 
	C947.645874,883.501648 947.117554,883.803467 946.306030,884.057129 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M929.933655,877.712036 
	C930.464905,877.729858 930.848450,878.027405 931.399353,878.646973 
	C930.787659,878.981140 929.781250,879.407654 929.933655,877.712036 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M945.982361,883.977905 
	C945.904053,884.035095 945.837402,884.105469 945.896851,884.092407 
	C946.022888,884.009033 945.993958,883.991028 945.982361,883.977905 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M914.412415,810.854431 
	C910.680176,811.050598 907.355774,811.213806 903.590454,811.309814 
	C902.487427,810.777405 901.812073,810.329834 901.165588,809.843933 
	C898.436218,807.792358 898.032227,804.550842 898.480713,801.813904 
	C898.924255,799.107117 902.029663,800.101868 904.064819,800.048096 
	C908.391296,799.933655 912.722473,800.001770 917.518433,799.995117 
	C923.273804,799.756958 928.762512,799.038940 933.810486,799.438721 
	C942.830078,800.153137 951.825745,799.328796 960.775818,800.218689 
	C962.165771,800.356812 964.775940,800.413635 964.595276,802.534607 
	C964.397034,804.862000 961.964172,803.769592 960.472717,803.979370 
	C955.476196,804.681946 950.231995,802.580139 945.209351,805.647644 
	C940.572021,809.378357 935.028381,807.320251 929.822693,808.992554 
	C924.545227,809.624573 919.637573,809.861694 914.412415,810.854431 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M928.807312,808.619080 
	C934.048767,807.586121 939.133240,806.900208 944.613647,806.101868 
	C946.728271,805.984558 948.446960,805.979614 950.590332,806.042725 
	C951.025696,806.441772 951.043213,806.772400 951.082153,807.349426 
	C944.698792,808.534851 938.135681,808.161743 931.441895,810.059570 
	C930.570923,809.991272 930.112427,809.886353 929.305298,809.722412 
	C928.854614,809.430969 928.752441,809.198547 928.807312,808.619080 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M995.083252,796.651062 
	C993.754456,796.220642 993.977173,794.921997 993.975952,793.337036 
	C995.364563,793.738220 994.933105,795.115112 995.083252,796.651062 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M930.757080,811.022278 
	C943.719360,810.288879 956.415527,809.650024 969.554993,809.003540 
	C969.317383,810.526672 967.688293,810.516174 966.556763,810.533752 
	C954.612000,810.719177 942.732422,812.588623 930.759277,811.916687 
	C930.609131,811.908203 930.435303,811.879089 930.318848,811.795288 
	C929.953674,811.532349 930.021301,811.291992 930.757080,811.022278 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M928.553528,808.233459 
	C928.966492,808.581970 928.966248,808.891907 928.960144,809.432556 
	C924.223206,810.403381 919.489563,811.143433 914.337891,811.830078 
	C913.919739,811.776794 913.947632,811.330994 913.976074,811.109192 
	C915.678406,808.209229 918.446472,809.308655 920.775940,808.971252 
	C923.217773,808.617554 925.686035,808.445984 928.553528,808.233459 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M896.785706,881.215698 
	C899.038513,881.188293 898.872742,879.843933 898.851807,878.195007 
	C899.100708,877.700989 899.298889,877.579773 899.752197,877.221375 
	C900.007446,876.984131 900.414490,876.877686 900.620117,876.835449 
	C901.235596,878.075562 900.555115,879.666931 902.245483,880.779419 
	C902.735046,883.312683 902.905396,885.743347 903.038574,888.629395 
	C902.662720,889.378052 902.267883,889.541870 901.499878,889.540771 
	C900.562866,889.217834 900.063416,888.788879 899.304443,888.155762 
	C898.874634,887.808533 898.703979,887.665894 898.283569,887.297913 
	C897.377075,886.426941 896.784729,885.732056 896.254456,884.565552 
	C895.945496,883.262146 896.010376,882.328430 896.785706,881.215698 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M906.784912,880.584473 
	C906.935059,879.863708 906.956055,879.444824 906.961914,878.711182 
	C908.968567,878.763184 910.990417,879.129822 913.283020,879.754883 
	C912.576294,880.908936 908.660583,878.159302 910.463257,882.556213 
	C911.147888,884.226013 911.746033,886.807861 910.296204,887.530151 
	C908.776123,888.287537 907.169006,886.248474 906.042969,884.361084 
	C906.866516,883.091187 906.398560,881.911987 906.784912,880.584473 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M955.524963,876.546143 
	C955.474304,876.575806 955.575623,876.516541 955.524963,876.546143 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M951.728882,880.258789 
	C951.833008,880.472961 951.650940,880.713684 951.167908,880.962280 
	C951.109863,880.777954 951.301758,880.549683 951.728882,880.258789 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M895.100708,809.744873 
	C895.741272,809.169373 896.237793,809.398621 896.342651,810.501160 
	C895.821228,810.651794 895.491882,810.372192 895.100708,809.744873 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M894.393555,807.264893 
	C894.660095,807.202759 894.811646,807.411865 894.878174,807.882141 
	C894.567017,807.997803 894.395447,807.795410 894.393555,807.264893 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M893.256714,804.263550 
	C893.559387,804.185364 893.754517,804.434265 893.859253,805.004089 
	C893.660583,805.003052 893.453979,804.758240 893.256714,804.263550 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M997.028931,900.899231 
	C1001.706970,898.972595 1006.892456,900.744202 1012.014893,900.915161 
	C1007.147278,900.915161 1002.279663,900.915161 997.028931,900.899231 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M990.269165,888.647339 
	C986.664551,888.969421 983.291199,889.041992 979.460815,889.159180 
	C978.544739,887.576965 976.031921,888.459351 975.823853,887.033325 
	C979.707092,887.033325 983.624756,886.948914 987.534180,887.090759 
	C988.552734,887.127747 990.354614,886.113037 990.269165,888.647339 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M972.712769,899.380127 
	C972.990784,899.019531 973.360962,898.879333 973.558594,898.868896 
	C973.989258,900.396912 974.222351,901.935364 974.718384,903.752808 
	C975.179626,911.216125 975.378052,918.400330 975.325562,926.051270 
	C974.718079,925.598328 974.361572,924.678589 973.978577,923.380005 
	C973.162903,922.087158 972.732910,921.023193 972.613159,919.390503 
	C972.434143,916.108948 973.008911,913.213684 971.941528,909.986877 
	C971.689880,906.263611 970.978943,902.935730 972.712769,899.380127 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M935.447998,849.286133 
	C934.735168,848.947510 934.400330,848.766174 934.037842,848.297180 
	C936.328064,846.570190 938.662903,846.579590 941.282959,848.174683 
	C941.518433,848.696106 941.484314,848.971008 941.085999,849.444702 
	C939.083191,849.741333 937.464050,849.361328 935.447998,849.286133 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M945.070801,851.595703 
	C944.636963,851.984985 944.245239,852.035645 943.537109,851.951416 
	C943.033630,851.986694 942.846497,852.156921 942.341431,852.120239 
	C942.023438,851.913269 942.023315,851.991760 942.048706,851.961914 
	C941.580872,851.633911 941.150269,851.270752 940.745850,850.497864 
	C940.608887,850.042969 940.586182,849.852173 940.702881,849.409058 
	C940.957214,849.032043 941.072021,848.907288 941.369629,848.601868 
	C942.990967,849.050537 944.364990,849.760803 945.070801,851.595703 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M905.003052,834.313354 
	C904.994385,834.075806 905.293579,834.411072 905.359009,834.625854 
	C905.424438,834.840576 905.180115,834.938782 905.124634,834.980835 
	C905.069092,835.022888 905.011719,834.550903 905.003052,834.313354 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M906.565430,880.240295 
	C907.738159,881.587463 909.873169,882.947083 906.377258,884.037476 
	C905.989075,883.674927 905.862610,883.419189 905.433472,883.105164 
	C905.138611,881.909058 904.424133,880.617920 906.565430,880.240295 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M872.803894,758.186646 
	C856.215088,757.795959 839.624634,757.859863 822.616089,758.871460 
	C820.944336,757.960327 820.757751,756.605530 820.703979,754.788574 
	C820.866272,752.696350 821.319763,751.137329 822.873535,749.681030 
	C826.060059,748.400024 829.003967,748.159424 832.000244,748.142334 
	C845.717651,748.064148 859.434937,747.951294 873.573486,748.069458 
	C873.595642,751.453674 873.196594,754.619446 872.803894,758.186646 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M929.276001,828.590210 
	C927.766418,829.714661 926.256958,828.975525 925.916931,827.821960 
	C925.642273,826.890076 927.179138,826.168335 928.762207,826.004150 
	C929.178406,826.720215 929.220459,827.467651 929.276001,828.590210 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M900.493286,888.787659 
	C901.336731,889.088013 901.810059,889.112610 902.642334,889.110962 
	C902.925110,889.974243 902.848877,890.863770 902.570068,892.169556 
	C898.170105,891.822815 893.817566,892.730469 889.648376,890.884705 
	C891.730469,887.748169 894.777161,888.968750 897.854065,888.377441 
	C898.932190,888.215515 899.536743,888.286194 900.493286,888.787659 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M850.226440,123.225555 
	C849.998169,122.837013 849.943542,122.651237 850.002502,122.514465 
	C850.871094,120.500717 846.554199,119.265587 848.851257,117.541588 
	C851.041931,115.897385 850.857483,120.712791 853.627686,119.988754 
	C853.825928,122.404533 856.618713,123.181427 856.958435,125.670364 
	C855.984375,126.841049 854.805176,127.650528 856.965210,128.967422 
	C857.585999,129.707611 857.754211,130.289536 857.586792,131.178436 
	C857.319214,131.627884 857.210693,131.757523 857.313904,131.672821 
	C858.324463,130.536545 857.732483,129.774979 856.811279,128.775848 
	C856.243164,127.867867 856.246094,127.208023 856.765686,126.275597 
	C860.807556,125.583939 861.354980,130.034210 864.642029,130.967728 
	C864.987793,131.012833 865.187134,131.182632 865.099670,131.084915 
	C865.141052,124.630035 868.758545,131.092407 870.362793,129.408020 
	C871.020020,127.911430 868.436340,127.300728 869.175476,125.098053 
	C869.798950,124.064049 870.320557,123.738953 871.429443,123.221848 
	C873.229797,123.150269 875.705872,123.350075 874.597656,124.734085 
	C870.631165,129.687683 875.495300,130.660675 877.717896,132.874802 
	C878.067261,133.222870 878.467224,133.520065 879.013916,134.169678 
	C879.793823,136.824570 877.644409,137.463120 876.561462,138.732193 
	C873.960083,141.780579 870.144409,143.839493 868.899048,148.411774 
	C867.982361,151.388229 868.637512,154.130569 868.104309,157.140808 
	C867.693054,158.259384 867.280090,159.263824 866.402466,159.107635 
	C863.721985,158.630569 861.660767,159.474808 859.778381,161.356339 
	C858.594177,162.539917 854.655090,160.223129 855.752075,164.631775 
	C855.929382,165.344421 854.037048,165.899567 852.480835,165.520782 
	C850.914673,164.567612 850.449951,163.088272 849.376465,162.099625 
	C849.301147,162.864090 849.686340,163.605576 849.286011,164.666870 
	C846.878479,166.418091 845.818848,164.385971 844.172241,163.150803 
	C843.335876,162.360733 842.843750,161.695053 842.027832,160.959442 
	C841.488770,160.615677 841.150269,160.531921 840.521057,160.630890 
	C840.086304,160.771347 839.915894,160.845901 839.499939,161.063370 
	C838.443604,161.586746 838.265503,162.404709 837.784302,163.415863 
	C837.493103,163.894821 837.351379,164.074295 836.912964,164.437531 
	C835.928101,164.866806 835.232239,164.877960 834.208618,164.535950 
	C831.676575,161.322357 829.058350,160.037201 825.400391,162.111496 
	C823.763977,163.039429 821.295532,162.584564 821.229431,160.985214 
	C821.072021,157.177124 818.140442,155.828720 816.106140,153.633087 
	C815.542480,153.024734 815.067383,152.332336 814.747925,151.568588 
	C813.088135,147.599854 812.289246,147.084305 806.699890,146.562195 
	C804.939270,145.509903 805.862854,143.951477 805.157837,142.585999 
	C804.558655,142.242584 804.192932,142.084930 803.540344,141.819580 
	C803.074219,141.608719 802.891846,141.512741 802.449585,141.247040 
	C801.366394,140.378723 800.313477,140.135956 799.098389,139.470337 
	C798.682739,139.094711 798.545898,138.910202 798.281311,138.400421 
	C797.989929,137.369095 798.002563,136.663040 798.279602,135.616943 
	C798.549500,135.083282 798.693665,134.889648 799.145142,134.505890 
	C800.385437,133.968323 801.308350,133.998596 802.498352,134.586929 
	C804.608887,136.305267 806.392273,137.896011 808.857666,139.074371 
	C809.747009,139.415451 810.320923,139.672821 810.878540,139.966095 
	C811.158142,140.113113 811.547363,140.499969 811.651733,140.440247 
	C812.366577,140.031097 811.330322,139.830002 811.451416,139.146988 
	C811.455444,138.643372 811.493896,138.441040 811.673401,137.975021 
	C812.122253,137.219452 812.991760,136.709656 811.467773,136.214447 
	C808.801880,134.928085 806.332764,135.089325 803.550964,135.447006 
	C802.296875,133.964371 800.824402,133.394638 799.179626,132.469788 
	C798.823486,132.040634 798.732300,131.829910 798.819336,131.324432 
	C799.490662,129.095642 797.787292,128.116028 797.233398,126.056519 
	C797.692322,125.085899 798.087769,124.825500 798.473633,124.548882 
	C799.064148,124.125458 799.835449,123.937141 800.211975,123.231781 
	C799.541077,123.548355 798.862854,123.831306 797.539551,123.339462 
	C797.531921,118.363029 802.212952,117.213081 804.574585,114.094231 
	C805.152588,113.330803 805.974365,112.828743 806.000366,111.375854 
	C809.079102,110.567909 809.479614,114.667328 812.596375,114.870354 
	C813.509766,115.514008 814.041565,116.065475 814.786011,116.809265 
	C814.983643,117.017517 815.000000,117.000000 814.991333,117.008713 
	C815.640869,117.865425 816.753235,117.957542 817.778259,118.771545 
	C818.009949,119.153671 818.019958,119.328293 818.045471,119.764824 
	C818.466248,120.513680 818.942810,120.735878 819.758667,120.216568 
	C820.413025,119.996597 820.870178,119.991432 821.670044,119.981522 
	C822.542664,119.446945 823.083435,118.928093 823.803833,118.191505 
	C824.109192,117.682297 824.293823,117.427452 824.772461,117.123154 
	C825.513245,116.465134 826.069946,115.944107 826.802002,115.194595 
	C827.004761,114.827812 827.002869,114.660500 827.000488,114.242203 
	C827.675415,113.209877 828.540527,112.723633 829.733398,112.195305 
	C829.966614,112.006241 829.984924,111.513062 829.993652,111.266464 
	C830.541504,110.476112 831.077576,109.929504 831.814575,109.177917 
	C832.020630,108.977943 832.012634,108.491364 832.006348,108.248123 
	C832.685608,107.399208 833.459778,107.247803 834.654297,107.805557 
	C835.101562,108.359055 835.289429,108.603516 835.757080,108.899742 
	C836.537048,109.652359 837.289673,109.963600 838.551514,110.580299 
	C840.031738,114.125748 840.031738,114.125748 845.079590,112.287521 
	C841.318298,116.879631 846.594421,118.898201 846.994934,122.638168 
	C847.000000,123.006264 846.844055,123.155029 846.918823,123.077972 
	C847.745239,122.998207 848.496826,122.995491 849.624207,122.996391 
	C850.461365,123.456192 850.702820,124.005142 850.666138,124.871277 
	C850.633179,125.085045 850.602661,125.484779 850.675903,125.349380 
	C851.177979,124.537712 850.949402,123.971909 850.226440,123.225555 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M736.779785,141.238007 
	C736.759521,138.185928 740.797485,135.853378 738.013428,132.322876 
	C741.130066,131.998230 743.003296,130.523804 744.174255,127.580711 
	C744.920105,125.706154 746.158813,123.884201 748.641602,123.045929 
	C750.548889,125.238319 747.987671,128.802704 751.631897,130.651306 
	C753.074219,131.759842 753.339844,133.319092 754.508240,134.510040 
	C754.964539,135.263840 754.224792,134.719193 754.833679,134.990677 
	C755.081726,135.101257 755.192200,135.065201 755.165161,134.882462 
	C755.162292,134.863144 755.041504,134.853485 754.654907,134.656235 
	C754.056641,133.818909 754.033875,133.104294 754.217651,132.125092 
	C754.441223,131.597153 754.651978,131.368271 754.924866,131.196747 
	C754.545532,130.648514 755.188721,131.433304 754.298462,131.545959 
	C753.502625,131.774124 752.966187,131.669327 752.215942,131.185593 
	C750.286499,129.253769 751.686951,127.192787 751.820496,125.511948 
	C752.018311,123.022713 750.428772,123.917694 749.266846,123.219696 
	C749.008240,122.244339 749.009521,121.495773 749.164185,120.109711 
	C749.874390,118.889633 750.556885,118.422928 751.128601,117.440231 
	C751.434326,117.028366 751.567078,116.871017 751.933899,116.512856 
	C752.825562,115.835594 753.541687,115.428436 754.510498,114.372787 
	C755.749146,114.008369 756.500244,114.014801 757.861938,114.226929 
	C758.873169,115.161903 758.961548,115.934792 758.736023,116.924568 
	C758.676819,117.105881 758.497314,117.323120 758.497314,117.323120 
	C758.497314,117.323120 758.654785,117.559082 758.780396,117.451782 
	C759.349060,117.212463 759.798340,117.210030 760.540588,117.370705 
	C761.006226,117.577568 761.182495,117.692284 761.575684,118.046234 
	C762.572754,119.831749 764.138184,121.089043 763.494019,123.458862 
	C763.141907,124.370430 762.721191,124.804077 761.961426,125.200363 
	C761.787231,125.326843 761.622192,125.675613 761.705811,125.500229 
	C762.327454,124.964607 763.008301,124.797424 763.455688,123.889740 
	C763.948181,122.306068 765.187256,121.719292 766.483765,120.371399 
	C769.733704,119.982033 771.082153,121.099419 768.820801,123.359352 
	C765.640015,126.538185 768.685852,125.734543 770.941711,126.070480 
	C772.390198,126.550514 773.147400,126.974724 774.121277,127.671616 
	C777.168213,129.919922 778.413635,125.522697 781.456787,126.665695 
	C782.012451,127.457161 782.005554,127.896355 781.996948,128.664978 
	C781.995117,128.994400 781.840454,129.236267 781.923828,129.120911 
	C783.072693,129.008667 784.138123,129.011780 785.600586,129.005920 
	C785.998413,129.750626 785.999207,130.504318 786.000000,131.634827 
	C786.142578,132.174026 786.285217,132.336395 786.363892,132.814438 
	C785.163574,134.317459 785.875061,135.976852 785.051697,137.563995 
	C784.701233,137.982895 784.535828,138.129227 784.066650,138.409378 
	C783.323914,138.606140 782.895264,138.569519 782.233154,138.206451 
	C781.127075,137.090927 780.236816,136.210541 779.122498,135.118195 
	C778.146729,134.003632 777.334656,133.611084 776.144409,134.850876 
	C775.267212,135.789261 774.381531,136.193268 773.453247,136.945694 
	C774.387817,136.298279 775.145142,135.822342 776.035400,134.965637 
	C776.852844,134.271851 777.505249,134.217896 778.478882,134.572388 
	C779.699524,135.716278 780.645813,136.665115 781.834961,137.840607 
	C782.539124,138.594711 782.760803,139.197464 782.545166,140.212112 
	C782.152100,140.816147 781.871826,141.089508 781.348022,141.395447 
	C781.150574,141.478836 780.830566,141.667557 781.017944,141.602386 
	C781.470215,141.386536 781.719238,141.212875 782.155151,140.836853 
	C782.655212,140.413513 782.984375,140.222717 783.625061,139.967682 
	C784.706665,139.637436 785.513123,139.431641 786.144287,138.362518 
	C786.493469,137.953201 786.646423,137.800339 787.075378,137.476288 
	C788.540771,136.800293 789.839111,136.662155 791.353149,136.109039 
	C792.579590,135.808197 793.128967,135.042084 794.193481,134.431488 
	C795.234009,134.113678 795.933960,134.167877 796.901001,134.681152 
	C797.322388,138.476669 795.379578,140.629944 792.052795,142.103271 
	C791.435364,142.231644 791.160767,142.393524 791.010620,142.887344 
	C791.245483,143.409561 791.408630,143.714630 791.659180,144.307159 
	C791.868958,145.224594 791.809143,145.846115 791.469360,146.757874 
	C790.866882,148.804245 786.773987,148.642273 789.118286,151.949036 
	C790.224609,154.177628 792.477539,155.326019 792.710449,158.022339 
	C792.566284,158.562439 792.468872,158.768158 792.113525,159.202118 
	C788.531799,159.624542 786.787109,162.200226 784.326538,164.105835 
	C781.514221,164.279007 781.633118,167.260239 779.617004,168.166672 
	C778.612000,168.618500 778.126587,170.718048 776.611633,169.347641 
	C775.399353,168.250977 776.783630,167.424774 777.413269,166.541534 
	C777.761108,166.053482 777.803223,165.347504 777.990356,164.368347 
	C778.234314,163.774780 778.468018,163.548737 778.674744,163.299057 
	C778.994995,162.912216 779.180481,162.476593 779.016052,161.971313 
	C778.960388,161.800293 778.754639,161.675049 778.695740,161.734589 
	C778.179199,162.256714 778.713074,162.948364 778.215820,163.760010 
	C774.028870,162.218430 771.314087,164.396790 768.371948,167.001526 
	C767.569763,167.236908 767.167175,167.146271 766.658875,166.518692 
	C766.494080,165.996613 766.479797,165.775909 766.557739,165.240997 
	C767.056274,164.210541 767.827576,163.767654 768.099365,162.678680 
	C767.473206,161.467285 766.571716,161.117249 765.238953,161.176666 
	C764.798706,161.378876 764.632690,161.477051 764.246338,161.759186 
	C763.447083,162.465744 763.071655,163.140991 762.462219,164.011810 
	C762.117981,164.363449 761.959595,164.483383 761.536804,164.739792 
	C760.365051,165.246872 759.406494,165.543793 758.714478,166.759735 
	C758.350525,167.148727 758.185852,167.290298 757.717957,167.569000 
	C757.193054,167.748566 756.971375,167.790955 756.407043,167.827271 
	C752.450195,164.349899 746.810181,165.257629 743.118408,161.723541 
	C741.589355,160.259705 739.638855,161.226654 738.376709,162.829819 
	C737.127380,164.416809 735.641602,165.736404 733.951538,166.777817 
	C731.883240,168.052277 730.506897,167.677673 730.354675,164.934753 
	C730.003113,158.602554 726.930420,155.943344 720.730103,156.729233 
	C720.186401,156.466614 719.988708,156.319321 719.633362,155.833313 
	C719.987915,152.230652 721.695129,149.977936 725.316528,149.040588 
	C725.924866,149.107361 726.161804,149.164337 726.720581,149.385071 
	C727.920898,149.939575 728.673523,151.766876 728.839966,151.362228 
	C729.475464,149.817078 732.355896,149.891373 731.780518,147.248199 
	C732.000122,146.822052 732.000244,146.654984 732.005005,146.237381 
	C732.556091,145.458817 733.091003,144.919205 733.840637,144.191574 
	C734.344727,143.884369 734.588562,143.701508 734.886108,143.241638 
	C735.516846,142.497742 736.047180,141.965805 736.779785,141.238007 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M805.669312,79.955917 
	C807.599426,80.042152 809.009766,79.839874 808.988892,77.368881 
	C809.750000,76.999969 810.500000,77.000557 811.625000,77.000153 
	C811.962830,78.592194 812.137695,80.024803 814.629456,79.992889 
	C814.961121,80.971344 815.186035,82.222816 814.230896,82.695122 
	C811.370605,84.109535 810.936951,86.372391 812.163513,89.842705 
	C807.596375,87.713478 805.771606,83.808586 802.785889,81.118866 
	C803.630493,80.346466 804.363525,79.825867 805.669312,79.955917 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M781.503540,117.304352 
	C783.386719,117.746910 785.110046,118.187630 784.831055,120.926346 
	C784.064331,122.150764 783.379517,122.681229 782.748047,123.710732 
	C782.372192,124.124023 782.201416,124.272774 781.715515,124.557938 
	C780.704102,124.846733 780.026611,124.781296 779.071411,124.339844 
	C775.670898,120.850060 775.636292,125.032288 774.001709,126.219864 
	C773.016479,126.751877 772.311279,126.767113 771.307556,126.237663 
	C771.012939,126.012047 771.001404,126.001251 770.994629,125.994370 
	C771.738281,121.646233 774.815125,119.195045 778.894958,117.159470 
	C779.981995,117.583748 780.402466,118.018173 781.503540,117.304352 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M817.645264,83.999283 
	C818.035217,85.154167 817.900452,86.469566 819.226990,87.004997 
	C826.333374,89.873367 820.904541,91.770142 818.350098,93.952553 
	C819.923035,89.576874 816.644958,87.999146 813.616028,86.484863 
	C814.415649,84.626846 815.659729,84.005592 817.645264,83.999283 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M719.108215,92.330048 
	C719.001282,91.259377 719.002625,90.509781 719.007507,89.385590 
	C722.026489,88.043289 722.680603,92.043251 725.633423,91.990280 
	C725.996399,92.748177 725.990356,93.499222 725.992188,94.624580 
	C724.625488,95.195992 722.907349,94.405327 722.065674,96.702179 
	C717.611572,97.767227 720.575562,93.848434 719.108215,92.330048 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M832.657837,91.002243 
	C833.082764,92.440598 833.916260,93.022842 835.634460,93.004562 
	C835.990295,93.761330 835.995178,94.507774 836.000244,95.627716 
	C834.412109,95.969490 832.977600,96.141121 833.005493,98.629852 
	C831.408325,99.032173 829.962280,98.873894 830.005371,96.371033 
	C832.167297,95.591850 832.372314,94.635330 831.006714,92.958855 
	C829.535706,91.153160 831.197021,91.206795 832.657837,91.002243 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M719.000122,92.003983 
	C720.708740,92.129005 722.860779,91.943977 720.888306,94.666458 
	C720.199036,95.617882 719.972900,96.434555 721.671509,97.005081 
	C721.995544,97.796341 721.997986,98.530792 721.717529,99.875267 
	C720.396545,100.821869 719.489075,100.715782 718.916992,99.358337 
	C718.339050,97.882088 717.687683,96.768715 717.015747,95.328110 
	C716.995117,95.000877 717.000000,94.999817 717.000000,94.997025 
	C717.883667,94.360794 717.955505,93.226196 718.794922,92.216309 
	C719.009094,91.999359 719.000305,91.998993 719.000122,92.003983 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M797.324097,135.241013 
	C796.263855,135.013702 795.510864,135.006393 794.381348,134.997833 
	C793.755493,135.323441 793.422729,135.502991 792.513672,135.282333 
	C792.628845,131.363770 796.414062,132.737228 798.635620,131.043793 
	C798.997559,131.029694 798.997437,131.519150 799.001160,131.763855 
	C799.581299,132.693985 799.727661,133.464859 799.224182,134.655273 
	C798.984680,134.993225 799.000000,135.000610 798.996521,134.992645 
	C798.617737,135.368088 798.163818,135.526855 797.324097,135.241013 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M760.591309,114.622375 
	C764.240967,114.328400 765.416626,117.015137 766.994812,119.624146 
	C767.002441,119.997253 767.000000,120.000000 766.998779,120.001335 
	C764.590942,121.712708 763.135803,119.924614 761.285278,118.261864 
	C760.996277,117.996185 761.000000,117.999695 761.001221,118.000908 
	C760.245117,117.225189 759.980530,116.302582 760.591309,114.622375 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M749.001221,119.999321 
	C747.591919,119.874130 745.947815,119.267754 746.314758,117.832565 
	C746.893555,115.568520 749.186707,114.769325 751.864380,114.252197 
	C752.770935,115.158920 752.773743,115.823997 752.226074,116.743866 
	C751.997559,117.002258 752.000000,117.000000 752.001221,116.998871 
	C751.135803,117.847855 750.276001,118.704834 749.209351,119.784180 
	C748.997559,120.001526 749.000000,120.000000 749.001221,119.999321 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M826.951660,99.643532 
	C826.342041,100.089920 825.689880,100.129204 825.053162,100.249802 
	C823.622498,100.520737 823.802368,104.306969 821.684631,102.303780 
	C819.885681,100.602158 822.639526,99.055359 823.477295,97.935944 
	C824.927856,95.997757 826.226624,97.531769 826.951660,99.643532 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M795.692627,86.396194 
	C796.292419,85.851837 796.688354,85.571503 797.076538,85.280876 
	C798.093140,84.519814 798.390259,82.241302 800.381104,83.558594 
	C801.201538,84.101471 800.987976,85.350159 800.283264,85.591019 
	C798.749207,86.115387 797.761719,89.590904 795.692627,86.396194 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M748.996887,84.373444 
	C750.478210,83.993813 751.983215,83.840240 753.659546,84.854088 
	C754.301331,89.327896 751.386658,86.828232 749.367310,87.004929 
	C748.997070,86.248520 748.996643,85.498497 748.996887,84.373444 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M735.502625,93.382065 
	C738.138428,91.100037 738.447876,94.086700 739.651123,94.959930 
	C739.812866,95.077347 739.438232,96.506699 739.166809,96.557793 
	C736.932251,96.978355 736.162170,95.284012 735.502625,93.382065 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M782.001221,87.001068 
	C783.838135,90.629440 780.396790,90.698654 778.339783,91.967331 
	C778.414490,89.900909 778.907776,87.850357 781.651001,87.036911 
	C781.997559,86.997894 782.000000,87.000000 782.001221,87.001068 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M840.819214,106.315521 
	C841.060364,106.009041 841.530212,106.009201 841.765137,106.004753 
	C842.383667,105.621437 842.840210,105.483276 843.687012,105.789474 
	C844.248535,109.096329 841.770081,109.828621 839.354614,110.961838 
	C838.999634,110.998848 839.000000,111.000000 838.998779,110.998291 
	C838.620361,110.610237 838.474976,110.150543 838.781860,109.308777 
	C839.557190,108.834251 840.111877,108.668510 840.845581,108.268005 
	C840.628174,107.641159 840.479248,107.170769 840.819214,106.315521 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M786.001221,129.001526 
	C786.141174,128.531769 786.140747,127.789940 786.442200,127.634918 
	C787.944763,126.862228 787.574524,124.362427 789.625671,124.239418 
	C789.930115,124.221153 790.602234,124.943382 790.543701,125.076286 
	C789.766724,126.841339 789.193298,128.864120 786.361694,128.993958 
	C785.997559,128.996948 786.000000,129.000000 786.001221,129.001526 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M789.998779,84.000908 
	C790.482788,83.901260 790.975830,83.828445 791.451599,83.694336 
	C792.427429,83.419258 793.333313,81.635201 794.377258,83.214630 
	C795.389282,84.745644 793.571838,85.048790 792.802368,85.726158 
	C791.289978,87.057701 790.129211,87.224228 790.005005,84.345459 
	C790.002441,83.998207 790.000000,84.000000 789.998779,84.000908 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M729.362915,88.952003 
	C728.762085,87.877487 728.521667,86.756279 728.138184,85.316025 
	C729.297607,85.242989 731.110107,84.348282 731.705322,86.209084 
	C732.184570,87.707291 731.090149,88.517517 729.362915,88.952003 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M741.367310,87.995361 
	C741.471008,85.627968 743.510803,84.981339 745.656372,84.034866 
	C745.649475,86.474472 744.264954,87.847343 741.367310,87.995361 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M746.002197,80.400696 
	C746.750305,80.001122 747.500549,80.001755 748.626099,80.000717 
	C749.001221,81.066032 749.001221,82.133034 749.001221,83.600449 
	C748.250671,84.000092 747.500000,83.999306 746.374023,83.999588 
	C746.000549,82.934059 746.002441,81.867470 746.002197,80.400696 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M759.998779,85.998962 
	C759.806519,88.685791 757.836243,89.182701 755.287292,89.878830 
	C755.590881,86.963036 757.702087,86.789124 759.650635,86.037537 
	C760.002441,86.001961 760.000000,86.000000 759.998779,85.998962 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M792.179993,136.695251 
	C790.642090,137.787369 789.239441,138.127472 787.353882,137.980438 
	C786.599609,137.299377 786.725464,136.633850 787.504822,135.487961 
	C789.065369,135.008774 790.135681,135.012466 791.607605,135.012634 
	C792.009277,135.009125 791.999146,134.998917 791.994751,134.994598 
	C792.376038,135.383804 792.519531,135.851669 792.179993,136.695251 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M806.002563,79.623390 
	C805.433899,80.903282 804.547302,81.012100 803.248291,80.917183 
	C802.932373,79.842712 802.964417,78.810921 802.998230,77.389870 
	C803.750000,76.998955 804.500000,76.997299 805.625000,76.998253 
	C806.001038,77.750160 806.002075,78.499458 806.002563,79.623390 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M805.956238,89.646164 
	C805.838440,89.978500 805.670898,89.972641 805.508423,89.941101 
	C803.917542,89.632332 802.780823,88.763191 802.410645,87.155380 
	C802.354858,86.913055 802.963928,86.240692 803.271973,86.236435 
	C805.298828,86.208405 805.349854,87.989273 805.956238,89.646164 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M721.998779,100.000755 
	C723.098022,100.128159 724.568054,99.756866 724.759094,101.393974 
	C724.915771,102.737320 723.769287,102.900871 722.367432,102.992020 
	C722.000000,102.999084 722.000000,103.000000 722.000000,103.000458 
	C721.421570,102.313911 721.270630,101.540443 721.766846,100.341095 
	C722.002441,99.998474 722.000000,100.000000 721.998779,100.000755 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M797.001587,125.998314 
	C795.910950,125.865005 794.437561,126.285545 794.242615,124.620255 
	C794.083923,123.264641 795.220520,123.104187 796.619995,122.999161 
	C796.986145,122.986252 797.000610,123.000778 797.006653,123.007004 
	C797.582214,123.700806 797.730469,124.471420 797.232361,125.663284 
	C796.996887,126.003593 797.000000,126.000153 797.001587,125.998314 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M737.634277,85.007217 
	C738.002869,85.748131 738.003296,86.498390 738.001831,87.623718 
	C736.976624,87.880501 735.629150,88.272926 735.289429,86.850861 
	C734.917847,85.295807 736.130676,85.122902 737.634277,85.007217 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M738.010010,88.369484 
	C738.749451,88.003265 739.498840,88.005310 740.622925,88.004593 
	C740.880676,89.026733 741.268921,90.373924 739.848083,90.714333 
	C738.290588,91.087509 738.117126,89.878181 738.010010,88.369484 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M806.000000,111.000443 
	C804.432068,111.004082 802.968323,110.870041 803.010254,108.369820 
	C804.611816,107.937592 806.005798,108.162216 805.990845,110.629105 
	C806.000000,110.999146 806.000000,111.000000 806.000000,111.000443 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M826.989197,93.631439 
	C825.954529,93.865234 824.648804,94.259964 824.243530,92.766304 
	C824.056274,92.076126 824.352417,91.455330 825.056824,91.294624 
	C826.691162,90.921799 826.872498,92.081131 826.989197,93.631439 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M818.002441,83.999527 
	C818.130310,82.832466 817.746033,81.264297 819.594177,81.224571 
	C820.790344,81.198845 820.906860,82.304718 821.000244,83.620186 
	C821.012573,83.987030 821.000000,83.999771 820.993896,84.006287 
	C820.240967,84.003952 819.494141,83.995110 818.373657,83.990860 
	C818.000000,83.995461 818.000000,84.000076 818.002441,83.999527 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M726.000000,95.000565 
	C727.038208,95.150879 728.352661,94.739929 728.749817,96.240723 
	C728.932129,96.929733 728.640808,97.550362 727.930542,97.705193 
	C726.318176,98.056702 726.093140,96.939392 726.003540,95.368057 
	C726.000000,94.998886 726.000000,95.000000 726.000000,95.000565 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M823.343262,110.992996 
	C822.999390,110.249367 822.998779,109.499336 822.999146,108.375114 
	C824.136902,108.083092 825.317200,108.339928 825.544983,109.595108 
	C825.790100,110.945717 824.585876,110.879944 823.343262,110.992996 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M803.000000,107.999695 
	C802.089539,107.848404 800.902832,108.294815 800.474121,107.047668 
	C800.221191,106.311676 800.745789,105.720863 801.402588,105.544563 
	C802.977844,105.121712 802.820618,106.393456 802.992920,107.657784 
	C803.000000,108.000610 803.000000,108.000000 803.000000,107.999695 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M826.036926,105.338234 
	C826.751465,104.995476 827.498413,104.997345 828.626831,105.003792 
	C828.825012,105.978531 829.387085,107.442932 827.788574,107.553261 
	C826.759277,107.624298 826.288452,106.642357 826.036926,105.338234 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M818.008545,94.008392 
	C817.874023,94.932327 818.305969,96.120628 817.041077,96.533669 
	C816.302185,96.774948 815.710022,96.249969 815.531189,95.594925 
	C815.102234,94.023209 816.368835,94.163269 817.640015,93.990524 
	C817.982910,93.981842 818.000000,93.999664 818.008545,94.008392 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M777.997559,92.000259 
	C777.901184,93.061646 778.301636,94.384918 776.783691,94.757713 
	C776.169800,94.908478 775.401672,94.753922 775.425720,93.879738 
	C775.457520,92.727394 776.344849,92.319084 777.658691,92.037231 
	C778.000000,92.004288 778.000000,91.999916 777.997559,92.000259 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M773.896179,97.442215 
	C773.623230,98.735443 773.213135,99.660980 771.976807,99.544067 
	C771.763245,99.523865 771.355774,98.649139 771.480713,98.457268 
	C772.017822,97.631706 772.310608,96.135193 773.896179,97.442215 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M805.998169,90.001801 
	C807.163818,90.104515 808.294373,90.385109 808.581909,91.689758 
	C808.734497,92.381752 808.179932,92.880348 807.427429,92.807289 
	C806.159058,92.684158 806.057495,91.697289 806.005249,90.352905 
	C806.003601,89.996262 806.000000,90.000000 805.998169,90.001801 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M726.337585,91.967346 
	C725.934692,90.390823 726.142090,88.982925 728.626709,89.009033 
	C728.915405,90.525192 728.279480,91.610764 726.337585,91.967346 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M775.002930,86.342773 
	C775.746643,85.996887 776.493225,85.994682 777.612732,86.003052 
	C777.945923,87.170738 777.651733,88.320732 776.397583,88.543007 
	C775.056763,88.780617 775.093689,87.599190 775.002930,86.342773 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M833.000671,98.999374 
	C834.017578,99.168327 835.003235,99.435661 834.779663,100.771301 
	C834.606567,101.805405 833.761841,102.064392 832.949158,101.686172 
	C831.898743,101.197250 832.456116,100.340019 832.872742,99.302582 
	C832.997559,99.001297 833.000000,99.000000 833.000671,98.999374 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M731.015015,100.350845 
	C732.165466,100.111198 733.296997,100.390778 733.586670,101.677536 
	C733.740356,102.359848 733.188049,102.864349 732.443665,102.803139 
	C731.168518,102.698296 731.110596,101.680031 731.015015,100.350845 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M751.997559,113.997604 
	C752.206055,113.037201 751.609070,111.557564 753.209595,111.445679 
	C754.244934,111.373299 754.694397,112.372787 754.955688,113.664429 
	C754.997986,114.001938 755.000000,114.000000 755.001221,113.999039 
	C754.318787,114.577179 753.547546,114.729706 752.348999,114.239197 
	C752.005920,114.006126 752.000000,114.000717 751.997559,113.997604 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M829.670532,111.875008 
	C829.920959,113.473648 829.092773,114.051308 827.353149,113.992737 
	C827.121765,112.534523 826.714722,110.519127 829.670532,111.875008 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M784.429077,123.652374 
	C784.932983,125.532280 784.275024,126.597565 782.356567,126.976257 
	C782.019348,127.017975 781.998840,126.998817 781.989502,126.989609 
	C781.415894,126.292503 781.268799,125.523552 781.767639,124.335754 
	C782.002930,123.996666 782.000000,124.000000 781.998535,124.001671 
	C782.500183,123.463814 783.122253,123.238205 784.429077,123.652374 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M738.873352,102.624756 
	C737.803894,102.240753 737.149902,101.740082 737.527466,100.752571 
	C737.602234,100.556946 738.158875,100.338371 738.350647,100.429749 
	C739.277161,100.871338 740.171021,101.409317 738.873352,102.624756 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M758.001221,114.001694 
	C758.558533,113.082237 758.695557,111.648331 759.970459,111.528908 
	C761.078613,111.425095 760.847595,112.606300 760.990540,113.672577 
	C760.996338,114.003815 761.000000,114.000031 761.001221,113.998947 
	C760.315613,114.577888 759.541748,114.729332 758.341064,114.233475 
	C757.997925,113.998024 758.000000,114.000000 758.001221,114.001694 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M838.998474,100.340485 
	C839.755249,99.999802 840.508057,99.996956 841.637756,99.997360 
	C841.930054,101.451195 841.094238,102.042137 839.360962,102.020889 
	C839.003052,101.580101 838.998779,101.129211 838.998474,100.340485 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M746.661621,89.007156 
	C746.844604,90.067314 746.574402,91.046745 745.185120,90.764969 
	C744.924622,90.712135 744.526367,90.379646 744.523804,90.172073 
	C744.508484,88.939697 745.528503,89.131508 746.661621,89.007156 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M827.000000,94.000153 
	C828.136475,94.056137 829.415833,93.797760 829.944031,95.657585 
	C830.000000,96.001221 830.000000,96.000000 830.000000,95.999390 
	C828.866577,95.934723 827.582031,96.204323 827.053223,94.343857 
	C827.000000,93.999695 827.000000,94.000000 827.000000,94.000153 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M803.682373,95.496307 
	C803.502625,94.062965 804.263550,94.020866 805.124512,94.328346 
	C805.322693,94.399117 805.550781,94.913109 805.477417,95.122185 
	C805.210205,95.883797 804.570618,95.907120 803.682373,95.496307 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M742.207397,92.204514 
	C743.233643,92.265411 743.787598,92.624199 743.360229,93.394920 
	C743.206909,93.671349 742.440125,93.857353 742.090881,93.724083 
	C741.330566,93.433929 741.254517,92.846428 742.207397,92.204514 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M760.810120,91.791718 
	C759.785339,91.728676 759.225891,91.374771 759.657959,90.601784 
	C759.812866,90.324783 760.580383,90.139503 760.929871,90.273476 
	C761.689697,90.564758 761.763428,91.152939 760.810120,91.791718 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M813.808105,91.202675 
	C814.756836,91.839745 814.689392,92.427559 813.929321,92.720230 
	C813.580811,92.854424 812.813049,92.670052 812.659973,92.394371 
	C812.233887,91.627197 812.783386,91.265091 813.808105,91.202675 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M820.531799,105.013885 
	C820.037964,105.899994 819.420410,105.995552 818.819275,105.585754 
	C818.331055,105.252960 818.329590,104.717537 818.832703,104.395935 
	C819.444336,104.004890 820.059998,104.114075 820.531799,105.013885 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M813.810059,109.209213 
	C814.758057,109.844566 814.693665,110.431992 813.932312,110.724518 
	C813.583557,110.858498 812.816650,110.674248 812.662781,110.398262 
	C812.234558,109.630089 812.785889,109.270805 813.810059,109.209213 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M779.001587,117.001755 
	C779.514954,114.824379 780.422302,114.363350 781.943787,116.671265 
	C781.996826,117.003708 782.000000,116.999794 782.001831,116.998016 
	C781.316406,117.577614 780.541687,117.729103 779.339844,117.232269 
	C778.996521,116.996277 779.000000,116.999809 779.001587,117.001755 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M819.639954,120.005905 
	C819.911926,120.917526 820.377869,122.212646 819.121399,122.457581 
	C817.969421,122.682144 818.169800,121.459526 818.050781,120.370239 
	C818.481995,120.021172 818.903015,120.015610 819.639954,120.005905 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M834.945801,107.719208 
	C834.239380,108.045654 833.492981,108.032036 832.373291,108.011658 
	C832.535767,105.785843 833.461609,105.378578 834.945801,107.719208 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M785.001221,120.999100 
	C787.220703,121.503616 787.625610,122.427109 785.337585,123.949760 
	C785.004883,124.004730 785.000000,123.999542 784.997559,123.997086 
	C784.420532,123.309425 784.269836,122.538780 784.763550,121.343613 
	C784.997559,121.001831 785.000000,121.000000 785.001221,120.999100 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M840.717407,106.002846 
	C841.058289,106.458679 841.056213,106.908325 841.039307,107.695610 
	C840.021729,107.750977 838.252747,108.622948 838.775391,106.187202 
	C839.461426,105.989754 839.918030,105.993202 840.717407,106.002846 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M817.940918,118.638130 
	C816.832642,119.010017 815.581604,119.232437 815.038025,117.363243 
	C816.120178,117.056503 817.384644,116.807732 817.940918,118.638130 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M838.623108,108.997711 
	C839.002625,109.443718 839.002869,109.887444 839.000305,110.663864 
	C837.847168,110.960403 836.544739,111.269920 836.015381,109.356964 
	C836.724548,109.003036 837.484192,108.999229 838.623108,108.997711 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M828.996155,104.995872 
	C829.142761,104.034187 829.364380,103.081581 830.615723,103.205444 
	C830.935181,103.237076 831.480042,103.752563 831.457214,104.003395 
	C831.359253,105.076920 830.401855,104.861862 829.348022,104.997528 
	C829.008362,105.008377 829.000000,105.000046 828.996155,104.995872 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M838.657471,103.002151 
	C839.000549,103.440628 838.998718,103.883690 838.994629,104.658844 
	C838.097778,104.872414 836.787109,105.346855 836.565552,104.086510 
	C836.365112,102.946503 837.575867,103.149696 838.657471,103.002151 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M820.659302,114.004333 
	C820.854797,114.960434 820.631470,115.909691 819.380615,115.786018 
	C819.062744,115.754601 818.519836,115.234657 818.544312,114.984604 
	C818.649048,113.914978 819.602539,114.128090 820.659302,114.004333 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M821.000000,113.999847 
	C821.049194,112.860138 820.814636,111.591522 822.656860,111.055466 
	C823.000000,110.999390 823.000000,111.000000 823.000000,111.000305 
	C822.942322,112.135033 823.192627,113.410004 821.342407,113.941483 
	C821.000000,114.000305 821.000000,114.000000 821.000000,113.999847 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M785.778931,133.402252 
	C785.991028,132.845367 785.994202,132.678589 785.998718,132.261749 
	C787.060730,132.454117 787.778381,133.181976 787.974731,134.682831 
	C787.995117,135.005081 788.000000,134.999634 788.002441,134.997559 
	C786.583801,135.827850 785.797302,135.376007 785.778931,133.402252 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M827.007324,99.993385 
	C827.645081,100.083405 828.365479,100.087509 828.498413,100.905754 
	C828.526794,101.080605 828.167480,101.318443 827.986816,101.527298 
	C827.678894,101.210373 827.370972,100.893433 827.025146,100.295105 
	C826.987183,100.013733 827.000000,99.999748 827.007324,99.993385 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M823.684937,118.036041 
	C823.926453,118.896942 823.685730,119.683380 822.331665,119.941551 
	C822.069336,119.062958 822.317200,118.285316 823.684937,118.036041 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M826.682617,115.036324 
	C826.949219,115.923935 826.695129,116.714081 825.311523,116.976364 
	C825.060669,116.098122 825.296387,115.295044 826.682617,115.036324 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M814.944092,116.690033 
	C814.073792,116.941925 813.293945,116.679001 812.975098,115.347488 
	C813.855103,115.060417 814.663391,115.288078 814.944092,116.690033 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M750.398804,90.946793 
	C750.798889,90.211945 751.203918,90.206062 751.562988,90.725914 
	C751.638123,90.834679 751.634766,91.088890 751.557129,91.196365 
	C751.185974,91.710342 750.782227,91.689445 750.398804,90.946793 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M801.033691,91.286224 
	C801.630249,91.107811 802.361145,91.108238 802.495728,91.936340 
	C802.523865,92.109299 802.158203,92.346230 801.973999,92.553680 
	C801.673462,92.224724 801.372986,91.895760 801.033691,91.286224 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M746.985596,88.984879 
	C747.073547,88.075310 747.337830,87.299690 748.679749,87.041412 
	C748.997559,86.998543 749.000000,87.000000 749.001221,87.000763 
	C748.927795,87.902023 748.691711,88.689995 747.345459,88.975937 
	C747.029053,89.027344 746.999878,88.999321 746.985596,88.984879 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M801.002563,90.997314 
	C800.360840,90.917007 799.633179,90.922829 799.493408,90.088501 
	C799.463989,89.912689 799.829834,89.670708 800.013550,89.459259 
	C800.319336,89.783768 800.625122,90.108261 800.962891,90.719193 
	C800.994934,91.005646 801.000000,91.000000 801.002563,90.997314 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M734.041138,97.278625 
	C734.656128,97.070755 735.382202,97.076759 735.513062,97.901527 
	C735.541443,98.080673 735.179993,98.321648 734.998047,98.534119 
	C734.685669,98.217583 734.373352,97.901077 734.041138,97.278625 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M730.391968,105.442528 
	C729.569641,105.675125 729.277588,105.381729 729.399109,104.748024 
	C729.424377,104.616440 729.613892,104.438530 729.747803,104.418854 
	C730.388977,104.324654 730.665710,104.630753 730.391968,105.442528 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M831.695557,109.024185 
	C831.965210,109.909470 831.716309,110.705521 830.327576,110.975372 
	C830.067200,110.095436 830.307129,109.293968 831.695557,109.024185 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M825.996338,105.003448 
	C825.568787,104.881790 825.144897,104.756882 824.721008,104.631973 
	C825.039001,103.939644 825.400574,104.314140 825.881287,104.791626 
	C826.004517,104.993614 826.000000,105.000191 825.996338,105.003448 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M736.018311,104.753632 
	C735.907898,104.586533 735.961975,104.418144 736.015991,104.249763 
	C736.071594,104.417290 736.127197,104.584808 736.018311,104.753632 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M790.287598,131.389404 
	C790.158386,131.555069 789.935059,131.580154 789.711792,131.605240 
	C789.872375,131.486435 790.033020,131.367615 790.287598,131.389404 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M730.988892,100.008591 
	C730.859497,99.864403 730.740967,99.711540 730.622375,99.558685 
	C730.714905,99.605171 730.807434,99.651649 730.958557,99.838181 
	C731.017151,99.978218 730.999756,99.999916 730.988892,100.008591 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M733.987549,97.009216 
	C733.858765,96.867165 733.742615,96.714432 733.626465,96.561707 
	C733.718018,96.607239 733.809631,96.652771 733.961182,96.835495 
	C734.021240,96.972672 734.000183,96.998535 733.987549,97.009216 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M823.000000,107.999649 
	C822.882446,107.863144 822.764893,107.726997 822.647400,107.590843 
	C822.729248,107.638847 822.811157,107.686859 822.946533,107.867889 
	C823.000000,108.000916 823.000000,108.000000 823.000000,107.999649 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M816.466003,112.447037 
	C816.523743,112.412193 816.408264,112.481873 816.466003,112.447037 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M868.113525,147.942047 
	C868.288818,143.163437 872.202942,141.718994 874.580139,139.121567 
	C875.917236,137.660431 877.481140,136.406860 879.063416,134.779205 
	C880.854126,133.373093 882.524353,132.247574 884.503967,131.008728 
	C885.298157,130.913925 885.782959,130.932434 886.892578,131.160660 
	C888.524658,133.286652 888.207764,135.417999 888.496582,137.778763 
	C888.652344,138.637451 887.480225,138.949890 888.398438,139.856018 
	C888.667847,140.539688 888.736328,140.953354 888.723511,141.689682 
	C888.473694,143.023453 888.423645,144.039154 888.871033,145.353378 
	C889.233398,146.967072 889.240662,148.280029 889.044067,149.926117 
	C888.833679,151.111389 888.603149,151.959747 888.629150,153.182312 
	C888.587585,153.745041 888.553162,153.970306 888.414429,154.523468 
	C886.446594,162.559128 886.457397,170.426346 886.311340,178.280838 
	C886.280823,179.922119 886.360596,181.575699 885.740601,183.507614 
	C885.229065,184.461136 884.694336,184.931580 883.849426,185.588898 
	C881.557495,187.364105 878.759521,187.905853 877.433411,190.486176 
	C878.701050,191.670227 879.870056,190.106155 881.374268,190.569061 
	C881.877930,190.826950 882.050537,190.980301 882.361816,191.450623 
	C882.612549,194.648560 880.093506,195.197372 878.339478,196.725372 
	C878.322083,197.205139 878.323425,197.400375 878.246277,197.866379 
	C877.441162,200.908737 879.990845,198.389053 880.586914,199.650146 
	C882.023376,203.405975 877.042664,204.189957 877.490112,207.743683 
	C878.107727,209.119415 876.422546,209.793793 877.224731,211.145142 
	C876.074768,216.151459 878.847595,213.829895 880.936523,213.262329 
	C882.019958,213.269226 882.650208,213.532837 883.219971,214.464844 
	C882.955627,216.706070 881.535645,217.854050 880.148682,218.912903 
	C877.844971,220.671585 876.877319,222.807053 877.685120,226.001282 
	C875.953979,229.809464 875.439758,233.395020 876.444153,237.524750 
	C874.464111,239.717743 872.415710,240.417801 869.666626,238.820251 
	C867.635315,230.668564 869.013916,222.755798 868.554810,214.428253 
	C868.269775,206.499786 869.824768,198.974899 868.820190,191.647369 
	C867.576294,182.574326 867.629028,173.543579 867.570007,164.471237 
	C867.557068,162.484726 867.518188,160.494812 867.955566,158.065063 
	C868.051208,154.531158 867.927490,151.463440 868.113525,147.942047 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M869.081299,118.918243 
	C867.791504,118.846664 865.570312,119.000366 866.443481,117.295357 
	C867.193665,115.830559 868.665039,113.408058 870.673950,113.775673 
	C872.119934,114.040276 873.501099,115.897079 874.451904,117.345200 
	C875.960876,119.643311 873.103088,119.691574 872.326477,120.842682 
	C872.075623,121.214455 872.111694,121.779724 872.007080,122.629166 
	C871.997559,123.001831 872.000000,123.000000 872.001221,122.999084 
	C871.349548,123.859688 870.224915,123.946503 869.211487,124.784485 
	C868.997559,125.001648 869.000000,125.000000 869.001221,124.999176 
	C866.606140,124.927605 864.852844,124.416069 867.589905,122.053307 
	C868.400574,121.353531 868.942688,120.780258 868.989990,119.374390 
	C869.001831,119.001541 869.164062,118.838028 869.081299,118.918243 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M886.645935,93.516541 
	C887.977112,92.929817 889.268982,93.232391 889.885925,92.720856 
	C893.679749,89.574913 894.858765,92.264580 895.838989,95.892929 
	C895.127808,97.115082 894.444641,97.580353 893.485962,98.623550 
	C892.252441,98.995811 891.500122,98.995743 890.122192,98.846634 
	C888.936157,98.174004 888.523071,97.496262 887.585083,96.938934 
	C887.180786,96.638443 887.025208,96.506470 886.687134,96.123856 
	C886.243286,95.280426 886.186096,94.664413 886.645935,93.516541 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M908.991760,113.628448 
	C907.468994,114.073174 906.400696,114.728706 906.037659,116.660133 
	C905.038879,116.941895 903.771362,117.208305 903.378540,116.131340 
	C902.382935,113.402016 906.317078,114.506538 906.356018,112.402840 
	C906.146606,111.572716 905.428955,111.238464 904.614319,110.992996 
	C903.404785,110.628601 902.941284,109.905922 903.884094,108.872070 
	C904.608521,108.077812 905.904724,107.665352 906.399475,108.670135 
	C907.180298,110.256035 909.002930,111.252922 908.991760,113.628448 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M898.612488,96.011536 
	C899.074890,96.914993 899.324951,97.698410 900.674316,97.963020 
	C901.134583,100.782806 897.592590,99.241402 897.063232,101.653412 
	C895.932251,102.002678 894.865051,102.003822 893.400146,102.003632 
	C893.004761,101.250748 893.007019,100.499191 893.006958,99.371765 
	C893.004700,98.995888 893.000000,99.000244 892.997559,99.002197 
	C893.484802,98.585724 894.022888,98.053673 894.666382,98.190460 
	C896.837708,98.652054 895.138489,97.043121 895.781067,96.297150 
	C895.997559,96.001831 896.000000,96.000000 896.001221,95.999084 
	C896.748230,96.001122 897.494019,96.004074 898.612488,96.011536 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M949.352783,98.036438 
	C949.084290,95.921165 949.284180,94.057678 952.028748,96.030167 
	C953.716492,97.243141 955.823303,98.035103 956.262695,100.582329 
	C953.393982,101.496872 951.985962,98.590172 949.352783,98.036438 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M878.000305,90.365860 
	C878.748962,89.999611 879.500061,90.001152 880.626831,90.000473 
	C880.954407,91.599335 881.135254,93.027664 883.869507,93.244400 
	C884.656311,93.931190 884.724915,94.380196 884.351929,95.420815 
	C880.415771,96.053062 879.023010,93.605759 878.000305,90.365860 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M866.676758,92.961090 
	C866.388367,99.277107 863.239746,92.346481 861.366455,93.998367 
	C860.834229,91.655785 861.977722,90.727570 864.610962,90.995804 
	C865.056763,91.913414 865.313416,92.697083 866.676758,92.961090 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M957.620483,94.000168 
	C958.074768,94.909142 958.323120,95.692863 959.676270,95.960213 
	C959.943176,97.753212 959.911133,99.696167 957.480347,97.694176 
	C956.512939,96.897362 955.883118,95.690742 955.048584,94.334412 
	C955.747009,93.997124 956.496460,93.996132 957.620483,94.000168 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M917.000366,99.625916 
	C915.932678,99.998680 914.865295,99.997963 913.400208,99.999542 
	C912.808960,98.128471 913.534668,96.678078 915.436523,96.480118 
	C917.591736,96.255791 916.741577,98.162621 917.000366,99.625916 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M855.004150,90.402313 
	C856.069031,90.001968 857.135681,90.001541 858.602356,89.999344 
	C859.283630,92.458389 857.760010,93.408638 855.356934,93.963028 
	C855.000305,92.935722 855.003113,91.868980 855.004150,90.402313 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M878.660706,87.945961 
	C878.738708,88.495277 878.477417,88.989761 878.108643,89.743088 
	C877.682434,89.956177 877.311951,89.999474 877.053467,89.849670 
	C875.743225,89.090141 873.437988,88.338692 874.803467,86.545731 
	C876.074219,84.877144 876.965942,87.761055 878.660706,87.945961 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M878.760498,102.567101 
	C879.004578,100.264496 881.215332,100.686165 882.355042,99.494614 
	C882.759888,102.314796 881.016479,102.693474 878.760498,102.567101 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M959.636780,102.006042 
	C960.200562,104.362114 958.990967,105.215111 956.387207,104.995888 
	C956.128357,102.941841 957.281677,102.013824 959.636780,102.006042 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M887.336548,102.946754 
	C887.002502,101.935371 887.000183,100.866478 887.250122,99.158165 
	C888.169556,98.228195 888.832825,98.226212 889.748291,98.775253 
	C890.004883,99.004272 890.000000,99.000259 889.997803,98.997993 
	C889.799500,100.640060 889.390076,102.156891 887.336548,102.946754 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M917.000000,100.000305 
	C918.178711,100.218010 919.642273,99.428703 920.470825,100.844017 
	C920.866577,101.519966 920.334412,102.139809 919.767090,102.393677 
	C918.081543,103.147888 917.502197,101.992416 917.038452,100.337204 
	C917.000000,99.999390 917.000000,100.000000 917.000000,100.000305 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M887.002197,98.998062 
	C885.482422,98.788429 883.254883,99.518166 883.897583,96.286926 
	C884.004089,95.997032 884.000000,95.999992 883.999878,96.000092 
	C884.685730,95.421761 885.458435,95.270462 886.657288,95.765167 
	C887.578674,96.687668 887.729309,97.461708 887.231812,98.661499 
	C886.995667,99.004112 887.000000,99.000214 887.002197,98.998062 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M852.000610,100.375580 
	C852.750488,100.000557 853.500244,100.000343 854.624939,100.000092 
	C855.000000,100.749649 855.000122,101.499237 855.001343,102.623245 
	C855.002441,102.997658 855.000000,103.000015 854.998779,103.001228 
	C854.248352,103.001617 853.499207,103.000793 852.375000,102.999374 
	C852.000000,102.998779 852.000000,103.000000 852.000000,103.000587 
	C852.000122,102.250916 852.000244,101.500648 852.000610,100.375580 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M857.010010,105.367645 
	C858.043457,105.142998 859.352966,104.740723 859.748291,106.234871 
	C859.929993,106.921585 859.638245,107.541954 858.935059,107.701279 
	C857.314392,108.068443 857.119263,106.923157 857.010010,105.367645 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M855.375000,100.000183 
	C855.001648,99.248604 855.000854,98.498428 854.998779,97.373085 
	C856.578430,96.969551 858.025940,97.119316 857.989258,99.630463 
	C857.237793,100.012627 856.492615,100.007111 855.375000,100.000183 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M844.260864,105.774178 
	C843.558960,105.992683 843.113525,105.992302 842.334045,105.996109 
	C842.146057,104.773781 841.712585,103.005035 843.801575,103.264359 
	C845.130249,103.429276 845.010864,104.552620 844.260864,105.774178 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M949.001221,104.001305 
	C949.155640,102.826782 948.699707,101.239906 950.690430,101.259949 
	C951.036865,101.263443 951.600464,101.723717 951.683838,102.065712 
	C952.081665,103.695900 950.908447,103.865639 949.365723,103.985870 
	C948.997559,103.997414 949.000000,104.000000 949.001221,104.001305 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M883.629517,105.006241 
	C883.919678,106.527969 883.257812,107.591225 881.338257,107.960648 
	C880.967957,106.413200 881.132629,104.973732 883.629517,105.006241 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M943.000000,108.999542 
	C941.951172,108.871582 940.627686,109.258812 940.244385,107.776711 
	C940.086914,107.167908 940.253418,106.406075 941.121521,106.438263 
	C942.258057,106.480408 942.674255,107.355431 942.962402,108.661453 
	C943.000000,109.000916 943.000000,109.000000 943.000000,108.999542 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M845.069275,100.348671 
	C846.069458,100.001198 847.134033,99.998131 848.597778,99.999176 
	C848.154541,102.727623 846.823425,102.714806 845.069275,100.348671 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M936.998779,100.000801 
	C938.170715,100.087646 939.284973,100.388496 939.579834,101.680099 
	C939.737122,102.369148 939.184631,102.872437 938.435181,102.802376 
	C937.166870,102.683823 937.076965,101.688065 937.008179,100.353775 
	C937.002441,99.998322 937.000000,100.000000 936.998779,100.000801 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M892.998779,101.998779 
	C892.882446,103.059189 893.271545,104.389740 891.777161,104.779976 
	C891.164795,104.939873 890.393738,104.768845 890.420227,103.895927 
	C890.455078,102.741859 891.352112,102.338486 892.661499,102.041443 
	C893.002441,102.002296 893.000000,102.000000 892.998779,101.998779 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M940.034790,97.337265 
	C940.745911,97.000862 941.494202,97.004227 942.616394,97.008820 
	C942.832397,97.990250 943.405334,99.453156 941.790039,99.564232 
	C940.756470,99.635315 940.290283,98.639740 940.034790,97.337265 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M921.997559,112.002136 
	C921.082520,111.852898 919.888977,112.303749 919.469482,111.040108 
	C919.224182,110.301331 919.752258,109.707039 920.408936,109.531616 
	C921.985718,109.110344 921.836426,110.376442 921.997803,111.651764 
	C922.004089,111.995934 922.000000,112.000000 921.997559,112.002136 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M867.000977,93.001457 
	C867.505493,92.152313 867.969116,91.115768 869.198486,91.458038 
	C869.921875,91.659424 870.097351,92.477394 869.741516,93.079819 
	C869.170532,94.046432 868.341248,93.575005 867.294556,93.111740 
	C866.997131,92.996170 867.000000,93.000000 867.000977,93.001457 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M912.998779,99.999084 
	C912.862183,100.964043 912.643188,101.915062 911.386780,101.794426 
	C911.067993,101.763809 910.522949,101.243126 910.546204,100.990379 
	C910.645264,99.914238 911.601746,100.127235 912.661255,100.005447 
	C913.002441,100.001831 913.000000,100.000000 912.998779,99.999084 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M949.001221,98.001068 
	C948.869751,98.970810 948.640076,99.912636 947.388977,99.792053 
	C947.069824,99.761284 946.524536,99.243172 946.547241,98.990807 
	C946.643921,97.918259 947.598999,98.123909 948.656982,98.000214 
	C948.997559,97.997864 949.000000,98.000000 949.001221,98.001068 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M956.004211,105.004364 
	C955.861145,105.975937 955.618286,106.915901 954.369751,106.784454 
	C954.049927,106.750786 953.508240,106.229576 953.532227,105.976357 
	C953.633972,104.903717 954.589905,105.114861 955.648926,104.992676 
	C955.990234,104.990570 956.000000,104.999779 956.004211,105.004364 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M913.967529,104.628403 
	C914.811157,103.833588 915.705261,103.858147 916.445435,104.679306 
	C916.552734,104.798355 916.402344,105.396294 916.230164,105.478996 
	C915.378601,105.887939 914.734680,105.289795 913.967529,104.628403 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M852.000000,102.999390 
	C851.866089,103.979118 851.630554,104.928719 850.366760,104.806091 
	C850.045227,104.774902 849.495422,104.249741 849.519470,103.995918 
	C849.622070,102.911522 850.586426,103.124146 851.656128,103.003258 
	C852.000000,103.001175 852.000000,103.000000 852.000000,102.999390 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M886.998047,102.997864 
	C886.911377,104.437531 886.081604,105.025955 884.356934,104.998444 
	C884.004883,105.004272 884.000000,105.000000 883.997559,104.997772 
	C884.062866,103.523972 884.916992,102.962395 886.650146,103.005920 
	C887.004822,103.004272 887.000000,103.000000 886.998047,102.997864 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M945.339111,101.488693 
	C945.525330,102.935303 944.752075,102.957771 943.894592,102.654922 
	C943.694641,102.584305 943.461426,102.069138 943.534546,101.860420 
	C943.803101,101.093407 944.449524,101.083878 945.339111,101.488693 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M962.998779,102.001190 
	C962.247620,102.002510 961.497620,102.002647 960.372620,102.000290 
	C959.997559,101.997795 960.000000,102.000000 960.001221,102.001099 
	C960.508911,99.796135 961.423645,99.346413 962.952881,101.662865 
	C963.002441,101.997742 963.000000,102.000000 962.998779,102.001190 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M942.645264,111.071381 
	C942.939392,112.147049 943.193848,113.414192 941.349854,113.942520 
	C941.039124,112.855988 940.813721,111.602951 942.645264,111.071381 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M858.545166,120.650108 
	C858.677734,121.293365 858.618713,121.742493 858.559692,122.191620 
	C858.187317,121.994446 857.615234,121.884979 857.482422,121.582558 
	C857.164246,120.858337 857.404846,120.323753 858.545166,120.650108 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M861.004883,94.004990 
	C860.936035,94.660774 860.921509,95.383240 860.079834,95.504013 
	C859.898315,95.530052 859.660217,95.162140 859.448120,94.975685 
	C859.770569,94.666092 860.093079,94.356514 860.702881,94.018661 
	C860.990234,93.990395 861.000000,94.000046 861.004883,94.004990 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M848.405640,112.956390 
	C848.805786,112.218521 849.210266,112.216293 849.568848,112.735573 
	C849.643921,112.844292 849.640564,113.098976 849.562744,113.205925 
	C849.191895,113.715584 848.788086,113.704224 848.405640,112.956390 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M858.008911,99.991348 
	C858.649841,100.077614 859.373962,100.077339 859.505615,100.900635 
	C859.533936,101.077850 859.173889,101.317162 858.992798,101.527840 
	C858.682007,101.212250 858.371216,100.896683 858.021729,100.299637 
	C857.982910,100.018143 858.000000,100.000084 858.008911,99.991348 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M854.001221,120.000854 
	C854.090759,119.368240 854.091492,118.649139 854.908020,118.506859 
	C855.080139,118.476868 855.320190,118.836639 855.528870,119.016861 
	C855.206848,119.319084 854.884766,119.621284 854.280151,119.960922 
	C853.997559,119.998367 854.000000,120.000000 854.001221,120.000854 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M852.945984,116.600281 
	C852.216797,116.201508 852.206787,115.798759 852.726440,115.441681 
	C852.835266,115.366913 853.087952,115.369171 853.194580,115.446304 
	C853.705872,115.816391 853.681030,116.218910 852.945984,116.600281 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M881.000000,107.999542 
	C880.911743,108.638672 880.914795,109.367195 880.083130,109.502357 
	C879.907288,109.530930 879.667542,109.165787 879.457275,108.982040 
	C879.780823,108.675102 880.104370,108.368164 880.713989,108.031075 
	C881.000000,108.000916 881.000000,108.000000 881.000000,107.999542 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M855.001221,102.998825 
	C855.905029,103.078079 856.697876,103.313881 856.964844,104.673698 
	C857.007263,104.993286 857.000000,105.000000 856.996338,105.003342 
	C856.081482,104.936195 855.307617,104.673920 855.041748,103.321655 
	C854.997559,103.002441 855.000000,103.000000 855.001221,102.998825 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M929.045654,98.385727 
	C929.791992,98.790405 929.797791,99.199860 929.270508,99.563210 
	C929.160095,99.639259 928.902527,99.636360 928.794128,99.557770 
	C928.277344,99.182755 928.289185,98.773788 929.045654,98.385727 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M961.042236,106.401863 
	C961.784607,106.804993 961.799194,107.211845 961.266602,107.573059 
	C961.155640,107.648354 960.900269,107.644821 960.791626,107.566429 
	C960.274536,107.193260 960.286682,106.786514 961.042236,106.401863 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M931.001221,103.001068 
	C930.905457,103.639412 930.910400,104.371376 930.082825,104.513687 
	C929.908447,104.543686 929.666443,104.181084 929.455627,103.999374 
	C929.779663,103.690315 930.103760,103.381264 930.712646,103.035049 
	C930.997559,102.997887 931.000000,103.000000 931.001221,103.001068 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M865.003296,91.003456 
	C865.227600,90.480774 865.430847,89.944962 865.701538,89.445786 
	C865.724792,89.402924 866.371643,89.539978 866.429993,89.701485 
	C866.700500,90.449699 866.186096,90.741165 865.280273,90.954506 
	C864.993103,90.993599 865.000000,91.000000 865.003296,91.003456 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M900.245117,104.650520 
	C899.996582,104.635628 899.861145,104.501961 899.725647,104.368317 
	C899.936523,104.422798 900.147339,104.477272 900.245117,104.650520 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M912.001221,131.001465 
	C911.912781,131.036819 911.823120,131.070709 911.865479,131.051178 
	C911.997559,130.997787 912.000000,131.000000 912.001221,131.001465 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M897.001221,101.999428 
	C897.122375,102.141129 897.242310,102.283409 897.362183,102.425690 
	C897.276306,102.376656 897.190430,102.327621 897.052002,102.140060 
	C896.999451,102.001526 897.000000,102.000000 897.001221,101.999428 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M956.528442,108.541214 
	C956.477173,108.570534 956.579651,108.511902 956.528442,108.541214 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M953.277344,113.007080 
	C953.095764,112.648811 953.269897,112.377243 953.759521,112.049492 
	C953.986389,112.109756 953.998108,112.290619 954.027344,112.742996 
	C953.874084,113.019463 953.703308,113.024422 953.277344,113.007080 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M884.001221,93.001175 
	C884.508484,90.778862 885.431274,90.353020 886.953857,92.665894 
	C886.997192,93.003563 887.000000,93.000008 887.000122,92.999908 
	C886.314209,93.578209 885.541504,93.729576 884.342590,93.234734 
	C883.999878,92.999863 884.000000,93.000000 884.001221,93.001175 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M1013.000061,67.625023 
	C1012.250000,68.000008 1011.500000,67.999992 1010.375000,67.999985 
	C1010.000000,67.250000 1010.000000,66.499992 1010.000000,65.374985 
	C1010.749939,64.999825 1011.499939,64.999687 1012.624634,65.000061 
	C1012.999634,65.750381 1012.999878,66.500198 1013.000061,67.625023 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M827.204346,725.766235 
	C824.246216,725.732544 821.475037,725.489563 821.186768,721.410217 
	C823.274597,719.631653 825.419067,720.439270 827.491272,720.816467 
	C830.108032,721.292725 832.712158,721.679260 835.381592,721.629761 
	C841.957764,721.507751 844.998108,718.423584 844.164368,712.013611 
	C843.473816,706.704468 843.559448,701.125183 839.962646,696.228821 
	C839.217468,695.409424 838.997925,694.715393 838.864380,693.610107 
	C838.866211,691.748657 839.399109,690.372070 839.934448,688.630920 
	C840.806274,686.595703 841.651001,684.931702 842.075562,682.736511 
	C842.280945,682.183105 842.379211,681.967163 842.664673,681.448242 
	C844.840271,677.853271 845.857361,674.123840 847.553528,670.698547 
	C848.283875,669.223755 848.653137,667.514221 850.750183,666.810364 
	C851.910583,667.509033 852.221619,668.433838 852.564453,669.732056 
	C853.772888,673.603638 855.261719,674.146057 857.344177,671.489502 
	C860.117310,667.951782 861.151917,663.845520 860.203674,659.330322 
	C859.458008,655.780090 858.158142,652.322021 858.466370,648.262085 
	C859.017639,647.259399 859.621521,646.853210 860.758057,646.716309 
	C863.634033,648.733276 862.557861,651.889893 863.733765,654.568054 
	C863.417175,653.342651 863.040222,652.373779 863.046326,651.352295 
	C863.054199,650.027649 862.508362,648.790649 862.705200,647.135132 
	C863.365356,646.521729 863.870605,646.415955 864.785034,646.624207 
	C866.700500,648.350891 866.121948,650.336548 866.152344,652.594971 
	C866.371887,657.610657 867.294067,662.181091 866.270569,666.853088 
	C864.532471,674.787598 860.812866,678.593079 852.791138,678.946167 
	C848.793396,679.122131 849.519531,681.549622 849.693481,683.612305 
	C850.403137,692.026978 851.335083,700.422913 852.435913,709.186768 
	C852.213318,721.258789 849.257751,725.987915 840.559204,728.402100 
	C839.737366,727.384216 838.850708,727.045959 837.407715,726.981750 
	C836.851501,726.838135 836.672058,726.717957 836.237793,726.797607 
	C833.543213,726.684692 831.103516,726.371765 828.333130,726.029419 
	C827.644104,725.691711 827.528992,725.282532 827.517212,724.830444 
	C827.422607,725.055420 827.462341,725.301208 827.204346,725.766235 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M926.280029,700.132080 
	C926.739807,700.229919 926.980530,700.367249 927.221313,700.504517 
	C926.980774,700.641602 926.734558,700.898987 926.501099,700.887939 
	C926.136230,700.870667 925.466431,700.856506 926.280029,700.132080 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M897.566956,679.479736 
	C895.078369,675.690369 892.224121,673.116455 888.135254,671.010986 
	C880.455627,667.056519 875.083557,660.435913 871.409485,652.158264 
	C867.853394,648.401123 867.735352,643.755676 867.000183,639.419373 
	C866.338562,635.516602 865.796326,631.580933 865.242432,627.274292 
	C866.814026,624.259399 867.386414,621.551758 866.153503,618.592896 
	C865.423279,616.840637 865.368774,615.104980 867.410522,613.638062 
	C868.795227,613.407837 869.533020,613.920898 870.260864,615.040833 
	C870.493103,616.871094 870.590393,618.389160 871.666016,619.989014 
	C872.593079,623.284668 873.645813,626.183105 875.206665,629.241272 
	C875.513733,629.713440 875.625183,629.910339 875.877808,630.416565 
	C876.453430,632.013916 876.957336,633.273193 877.720459,634.797729 
	C880.347473,640.402771 882.907776,646.289551 887.223633,649.646973 
	C892.293945,653.591370 894.670593,658.711914 897.905396,663.998779 
	C898.713684,666.033203 899.642334,667.632446 900.363525,669.689514 
	C899.199463,672.622070 900.711243,675.074829 900.659790,677.964478 
	C899.991516,679.383118 899.145142,679.803711 897.566956,679.479736 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M865.477295,625.771729 
	C868.463074,634.235413 867.910522,643.080994 871.161255,651.517273 
	C869.515198,651.593689 867.847961,651.215088 866.291321,652.842896 
	C865.704590,651.248108 865.313599,649.499451 864.814941,647.375244 
	C861.450745,641.281616 860.901184,634.942444 860.800720,628.590942 
	C860.762451,626.169067 862.325928,624.626892 865.477295,625.771729 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M897.320679,679.870300 
	C898.145691,679.091187 899.326172,678.986816 899.899292,677.404419 
	C902.250122,675.094666 903.130798,671.823303 906.550720,670.755798 
	C907.383789,672.880249 905.458923,675.024475 907.186401,677.472473 
	C906.658020,678.644775 905.992981,679.427246 905.072632,680.268738 
	C903.270081,680.079163 902.267700,681.036133 901.197754,682.351074 
	C899.174255,683.011841 898.431213,681.465515 897.320679,679.870300 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M901.532349,682.723389 
	C900.926208,680.703979 901.920166,679.917725 904.348633,680.231628 
	C903.848816,681.114441 902.880371,681.901123 901.532349,682.723389 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M974.876587,622.175110 
	C974.993469,622.498596 974.906799,622.587097 974.911499,622.648926 
	C975.757751,623.289917 976.069885,624.143616 976.128662,625.461060 
	C976.692627,628.449341 980.019897,631.129272 975.457153,634.002563 
	C977.709351,634.002563 979.444397,634.002563 981.590942,634.000977 
	C981.651733,634.623169 982.662292,636.446045 980.914795,635.721558 
	C979.784851,635.253174 978.677063,634.735657 977.638794,635.104919 
	C975.192139,635.974792 974.179810,635.470215 973.682861,632.736633 
	C973.348328,630.896057 971.841125,629.268677 970.687256,627.266724 
	C970.356384,626.890503 970.196716,626.793579 970.016052,626.976074 
	C969.767822,627.785461 969.540588,628.315491 969.055542,628.993896 
	C966.459473,628.615540 966.485535,626.502563 965.794189,624.498657 
	C965.404541,623.821716 965.827148,623.281006 965.399841,622.944458 
	C965.449036,623.225708 965.403076,623.494690 964.991211,623.821350 
	C962.995300,623.571777 961.183350,623.427734 960.091736,621.326904 
	C959.867004,620.815125 959.731506,620.622864 959.676514,620.086060 
	C960.542053,618.554504 961.482239,617.514526 962.973206,616.553406 
	C967.024109,618.426025 972.573669,616.591675 974.876587,622.175110 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M964.117920,628.040649 
	C964.034973,626.860107 963.778503,625.995789 964.746887,625.104675 
	C965.230164,624.834290 965.429260,624.714233 965.926514,624.773926 
	C966.933411,626.656006 967.377869,628.456421 968.123230,630.479980 
	C967.572144,631.191284 967.046997,631.558105 966.182861,631.935303 
	C965.031372,630.868408 964.210754,629.795166 964.117920,628.040649 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M974.864746,643.469727 
	C974.865845,644.735901 975.344910,645.967102 974.106201,646.351501 
	C973.210022,646.629700 972.979919,645.584778 973.115601,645.053650 
	C973.328003,644.221924 971.989502,641.751343 974.864746,643.469727 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M968.327576,630.712158 
	C967.268311,629.190125 965.862366,627.793884 965.990234,625.402161 
	C965.826599,624.852051 965.679138,624.657837 965.788086,624.202881 
	C966.804993,625.518799 967.565369,627.095581 968.561768,628.907349 
	C968.717773,629.628174 968.637817,630.114014 968.327576,630.712158 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M991.739685,642.616699 
	C991.588989,641.818787 991.373291,641.262390 991.551331,640.898560 
	C991.868652,640.250000 992.582397,640.592163 992.642456,641.007446 
	C992.874512,642.611389 992.931091,644.240723 993.076538,646.172485 
	C991.426819,645.178711 992.290283,643.873230 991.739685,642.616699 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M963.815979,627.772461 
	C964.734558,628.897522 965.328064,630.090271 965.882690,631.614380 
	C963.884155,631.735840 963.740295,629.924683 962.902832,628.337158 
	C963.060913,627.946289 963.275879,627.893311 963.815979,627.772461 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M978.355469,658.109253 
	C978.912842,659.094666 979.133606,659.899109 978.299194,660.447998 
	C978.136902,660.554688 977.314636,660.122131 977.277283,659.867798 
	C977.164795,659.102356 976.379822,657.881836 978.355469,658.109253 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M973.301697,679.500916 
	C971.494629,679.480591 971.105286,678.472107 971.173828,676.413391 
	C972.130859,677.734375 973.458313,677.909241 973.301697,679.500916 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M976.038574,652.754517 
	C977.787537,652.478699 977.364502,653.947083 977.567200,654.881348 
	C977.675964,655.382812 976.799622,655.751465 976.586182,655.377808 
	C976.205627,654.711792 976.189514,653.837646 976.038574,652.754517 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M997.709229,665.023071 
	C997.721497,665.851440 998.946411,666.849426 997.795959,667.582520 
	C997.641846,667.680664 997.140503,667.446411 996.947144,667.232849 
	C996.134888,666.335327 996.016663,665.521912 997.709229,665.023071 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M973.994873,676.004578 
	C974.987244,676.121094 976.007507,676.231934 975.922607,677.607422 
	C975.912109,677.776855 975.535583,677.923645 975.328735,678.081055 
	C974.960510,677.567383 974.592285,677.053711 974.114929,676.265991 
	C974.005737,675.992065 973.999451,676.000549 973.994873,676.004578 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M983.489746,666.400269 
	C983.544006,665.933594 983.773254,665.650085 984.002563,665.366577 
	C984.182373,665.553528 984.362183,665.740479 984.542114,665.927490 
	C984.249634,666.146179 983.957214,666.364807 983.489746,666.400269 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M973.128906,653.716370 
	C973.226440,653.248108 973.363037,653.002075 973.499634,652.755981 
	C973.634399,653.001587 973.888489,653.253540 973.875854,653.491150 
	C973.857300,653.838623 973.871460,654.546021 973.128906,653.716370 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M976.089844,665.295410 
	C976.853943,664.391357 976.904480,665.113037 976.936707,665.511658 
	C976.956848,665.759827 976.672119,666.032654 976.524292,666.294434 
	C976.364563,666.040222 976.204834,665.786011 976.089844,665.295410 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M979.338135,664.269775 
	C979.352478,664.006165 979.494202,663.861877 979.635925,663.717590 
	C979.579102,663.941406 979.522339,664.165222 979.338135,664.269775 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M977.042603,674.055420 
	C976.930542,674.159302 976.752686,674.985657 976.766357,674.005798 
	C976.906067,673.923157 976.999817,674.008606 977.042603,674.055420 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M998.000488,664.986938 
	C998.100037,664.945618 998.198914,664.916077 998.159851,664.942383 
	C998.021973,664.998291 997.999695,664.998718 998.000488,664.986938 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M866.189087,626.015686 
	C862.403198,625.479126 861.316895,627.099426 861.873596,630.256409 
	C862.811035,635.572205 863.756042,640.886719 864.702576,646.600708 
	C864.398132,646.995483 864.088989,646.993652 863.547974,646.994568 
	C859.680847,644.209778 860.809998,639.189331 858.213135,635.917114 
	C857.802063,635.376221 857.781555,636.524048 858.171936,635.983643 
	C860.180298,639.181396 860.868652,642.785767 861.151001,646.719727 
	C860.469971,647.255005 860.031189,647.511108 859.364685,647.881104 
	C856.840332,649.846069 857.710144,652.536255 857.374390,654.878723 
	C856.620483,660.138855 856.160339,665.467285 852.234253,669.905273 
	C851.027405,669.293091 850.995056,668.278442 850.824463,666.922241 
	C848.881775,663.410706 851.530396,660.646301 851.527832,657.368286 
	C851.589722,656.740112 851.551758,656.412659 851.229065,656.037964 
	C851.020081,655.981384 850.583069,656.221069 850.365234,656.390991 
	C848.371094,657.960876 846.338623,658.916626 844.013611,660.049438 
	C843.268616,660.347595 842.836670,660.499573 842.073975,660.744385 
	C841.082764,661.025940 840.403870,661.117554 839.381836,661.221069 
	C837.916565,661.319641 836.780090,661.283325 835.341309,661.675110 
	C834.534973,661.793457 834.070129,661.780640 833.269409,661.609680 
	C830.720337,659.627747 828.824890,657.606445 829.773071,654.026123 
	C830.004211,653.520020 830.110046,653.326782 830.399780,652.866211 
	C831.318604,651.818054 831.776001,650.908447 831.914795,649.507080 
	C832.340820,647.417725 832.955750,645.692139 833.235107,643.923828 
	C833.458313,642.511108 832.452332,643.832886 831.736450,643.679810 
	C828.274231,643.464172 828.015320,646.082642 826.940979,648.343994 
	C826.665710,648.847290 826.537781,649.037598 826.165039,649.466736 
	C824.022888,650.802795 821.940735,651.750854 821.983154,654.815918 
	C821.678711,655.827148 821.315247,656.418091 820.544189,657.143921 
	C817.444519,658.305725 816.090637,656.088257 814.432129,654.606384 
	C813.084229,653.402100 811.884888,652.035095 810.240906,650.675964 
	C809.807800,650.370850 809.632141,650.256714 809.210815,649.958496 
	C808.811584,649.646362 808.658142,649.518311 808.083130,648.991455 
	C807.529846,648.458252 807.398071,648.323853 806.883362,647.788025 
	C806.377502,647.250793 806.254578,647.115051 805.956177,646.768188 
	C805.672913,646.409302 805.565002,646.261475 805.306702,645.882690 
	C805.056824,645.495850 804.957336,645.339966 804.700684,644.950195 
	C804.430359,644.561157 804.317322,644.406006 804.025879,644.018433 
	C803.598633,643.464172 803.354248,643.138977 802.920044,642.551270 
	C800.062012,638.061768 796.565247,634.388306 794.314331,629.510620 
	C793.950562,628.157471 794.969971,626.747009 793.051758,625.969543 
	C792.158447,625.534485 791.740784,625.039551 791.175659,624.221924 
	C790.967896,623.960327 790.994751,623.992126 791.008911,624.007324 
	C789.270935,622.278809 788.980591,619.951782 788.523132,617.700317 
	C786.852600,609.479736 785.615417,601.189941 784.608765,592.864624 
	C784.434143,591.420349 784.677917,589.838501 782.878662,588.573120 
	C782.192322,587.468445 782.083679,586.637146 782.260010,585.359741 
	C784.352173,581.009338 785.047302,576.827026 784.244995,572.506409 
	C783.576538,568.906494 783.457153,565.310059 783.581604,561.285767 
	C783.560852,559.867432 783.635254,558.835388 783.221558,557.472534 
	C782.994019,556.369202 782.970154,555.626282 783.060547,554.520752 
	C783.063965,550.369385 785.813171,547.371338 786.143921,543.316223 
	C790.027222,535.488342 795.604797,529.791138 803.583862,526.230286 
	C804.488159,526.218323 804.567383,527.076660 804.948486,526.800110 
	C804.688660,526.442444 804.666321,526.247375 804.818726,525.809204 
	C805.601807,525.020569 806.374817,524.708618 807.230957,523.966858 
	C807.657410,523.656433 807.835754,523.542053 808.302368,523.292969 
	C809.671875,522.654358 811.134216,522.754883 811.679688,520.968933 
	C811.831543,520.479553 811.897217,520.285950 812.084595,519.813660 
	C812.316162,519.367859 812.426025,519.200745 812.767700,518.849976 
	C813.301025,518.531982 813.580811,518.619934 813.856445,518.750000 
	C813.669189,518.493347 813.403076,518.392151 812.760010,518.438232 
	C811.633850,518.406616 810.830261,518.556641 809.718018,518.855835 
	C808.277832,519.164246 807.156433,519.197021 805.714050,518.808105 
	C804.999329,518.451050 804.677734,518.141663 804.330322,517.434143 
	C804.189941,516.907349 804.160889,516.692383 804.203491,515.850952 
	C804.381653,514.828430 804.476990,514.429810 804.575317,513.724854 
	C804.546875,512.585815 804.353455,511.762207 804.456787,510.588379 
	C804.658081,510.062164 804.784790,509.867645 805.207153,509.477112 
	C806.181274,508.992096 806.894409,508.882721 807.997314,508.899353 
	C808.852173,509.027100 809.316956,509.183929 810.045776,509.631744 
	C813.192078,514.855835 819.084534,515.511353 822.593262,511.202484 
	C823.357605,510.263794 824.357056,509.756317 825.815125,509.295227 
	C828.209229,509.101074 830.114685,509.512634 832.053345,510.923157 
	C832.447754,511.651855 832.496460,512.119263 832.367798,512.594849 
	C832.254150,513.014771 831.885132,513.345093 831.932983,513.823059 
	C832.321655,513.525391 832.542847,513.091187 833.110718,512.506958 
	C835.520020,511.377594 837.748535,511.654022 840.328796,511.847473 
	C840.921570,511.992737 841.150818,512.071594 841.690552,512.331055 
	C842.705261,513.132019 843.066833,513.994751 843.811157,514.978333 
	C844.950134,516.061646 846.344116,516.490601 846.442749,518.280396 
	C846.264038,518.904907 846.034607,519.029907 845.699097,518.927368 
	C845.853210,519.345825 846.006287,519.315552 846.382690,518.655151 
	C847.851135,517.762390 849.103821,518.052307 850.668335,518.555054 
	C851.976929,519.106018 852.957336,519.583618 854.275330,520.092224 
	C854.748047,520.341309 854.927246,520.456848 855.336182,520.787659 
	C856.254272,521.876587 857.262512,522.122864 858.567261,522.535889 
	C859.438171,523.165039 859.746704,523.785339 859.909302,524.869080 
	C859.806885,526.288147 859.346985,527.118958 858.052490,527.748230 
	C855.036377,528.782654 853.040222,525.096191 850.036865,526.964111 
	C849.672607,527.513184 849.064941,527.436157 849.082214,527.774902 
	C849.095093,528.028503 849.440063,527.938049 849.839966,527.377502 
	C852.535217,526.590210 854.279236,528.650635 856.839111,528.941528 
	C857.403809,529.114075 857.625977,529.200012 858.155151,529.475586 
	C858.632690,529.837036 858.803223,530.008911 859.156738,530.495972 
	C859.378357,531.051025 859.417053,531.291016 859.368408,531.885010 
	C858.897156,532.876831 858.349670,533.330017 857.355347,533.765991 
	C856.348206,534.017151 855.671875,534.004578 854.685059,533.807251 
	C853.388550,533.239136 852.417969,533.293091 851.139832,533.923218 
	C849.122253,534.404724 847.440186,534.427856 845.460693,533.640625 
	C844.561707,532.900146 844.437561,532.229004 844.807312,531.195862 
	C845.548096,530.369080 846.287170,530.393188 846.788696,530.243896 
	C846.299622,530.074951 846.037109,529.919250 845.602234,529.554077 
	C845.148254,529.135132 844.902527,528.873047 844.473877,528.394043 
	C843.890503,527.768066 843.477173,527.377380 842.678467,527.023071 
	C841.082642,526.696289 839.971436,527.162781 838.675232,528.104614 
	C838.023621,528.478149 837.622253,528.610596 836.890137,528.662720 
	C836.202820,528.569336 835.842896,528.433655 835.313965,528.064575 
	C835.116089,527.903198 834.832458,527.529846 834.714050,527.348389 
	C834.595642,527.166870 834.406921,526.818665 834.266846,526.962036 
	C834.475037,527.614807 834.245544,528.025391 833.640503,528.587830 
	C832.966125,528.928711 832.538513,529.043701 831.741638,529.150330 
	C824.280273,527.842834 817.228088,527.291260 810.090332,530.666260 
	C805.798035,531.077881 808.470032,533.780640 808.119873,535.377380 
	C808.660950,534.275574 807.832214,532.938965 808.950562,531.656494 
	C810.521240,530.671143 811.933899,530.687378 813.701538,530.942871 
	C815.016968,531.335938 815.975281,531.930969 817.347412,531.132690 
	C819.669739,530.154114 821.724365,529.559753 824.287842,530.163208 
	C825.986328,530.946838 826.703796,532.336487 828.181030,533.422607 
	C828.914490,534.280334 829.253540,534.943298 829.546143,536.033203 
	C829.240906,538.664551 828.014038,539.937012 825.310669,539.803101 
	C824.418640,539.409363 825.139709,539.944824 824.631592,539.515930 
	C824.242676,539.187622 824.213745,539.145325 824.608032,539.729370 
	C825.706604,542.201477 827.430481,541.133789 828.978210,540.993103 
	C833.443359,540.587219 837.774475,541.085999 842.067139,543.375488 
	C842.133118,545.425903 841.281433,547.400330 844.674805,547.065735 
	C846.515808,546.884155 848.456848,547.950745 850.685425,548.539856 
	C852.350891,549.702759 853.009277,551.283508 854.342407,552.772217 
	C855.549927,555.002991 856.391357,556.991516 856.363281,559.564941 
	C853.718384,561.581848 852.057800,559.366394 849.889404,558.243530 
	C849.338013,557.792603 849.484619,557.294312 849.164856,557.079956 
	C849.081543,557.024048 848.968384,557.154602 848.957214,557.275208 
	C848.895203,557.938965 848.858276,557.046753 849.413757,557.790405 
	C847.548584,560.634338 846.754272,557.926941 845.285583,556.994812 
	C843.138550,554.050110 840.239624,552.461792 837.590698,550.109253 
	C836.774109,549.224915 836.098267,549.004211 834.995972,549.601196 
	C830.419922,550.492737 826.409302,551.717651 823.950500,556.218811 
	C822.767456,557.533142 821.765137,558.533936 820.250061,559.472778 
	C818.537720,559.813293 816.136902,559.133789 818.031311,562.028076 
	C818.453857,562.673645 818.241089,563.656372 818.201416,564.845398 
	C818.099792,565.677307 817.980896,566.142822 817.667969,566.930969 
	C816.403992,568.500183 815.830566,570.346497 813.446411,570.470764 
	C808.936401,568.254883 805.335327,569.701660 803.003601,574.439880 
	C802.282959,575.904114 802.338257,577.648743 801.030579,579.206787 
	C799.620361,579.679993 798.856079,579.223694 798.247620,577.905334 
	C798.529175,567.132202 802.323425,557.659851 806.322571,548.245667 
	C806.463989,547.912720 806.580139,547.563782 806.368408,547.352966 
	C806.120178,547.105774 805.761841,547.185974 805.150208,547.530640 
	C804.388733,547.703613 803.943848,547.688599 803.195007,547.449707 
	C801.231873,545.039246 801.374634,541.019104 796.738525,541.345459 
	C794.629456,541.277405 793.432434,541.688232 794.441406,544.159424 
	C794.610718,544.689392 794.668213,544.904724 794.768188,545.448608 
	C794.808716,545.994324 794.806763,546.211609 794.767212,546.747070 
	C794.594666,548.035339 794.128418,549.053406 795.390930,550.032837 
	C796.398254,550.660889 797.232849,550.921387 798.362305,551.395264 
	C800.659424,552.581177 801.194153,554.487976 801.708130,556.813965 
	C801.115479,560.556335 800.105286,563.833801 798.956543,567.427795 
	C798.089600,569.326355 795.785034,570.432983 797.489136,572.982178 
	C798.098999,574.127808 798.026428,575.049500 797.994202,576.314453 
	C798.056580,579.154541 797.460510,581.784607 799.678101,584.190186 
	C801.312195,593.454590 802.537659,602.449707 806.577515,611.087646 
	C806.210327,612.511658 805.281799,612.916443 804.158325,613.601013 
	C801.655273,614.993408 801.894043,617.440674 800.976196,619.667114 
	C800.727356,620.724976 800.125061,621.948242 800.699707,622.131958 
	C802.026733,622.556030 801.816833,621.079529 802.252930,619.988403 
	C802.595459,618.704895 802.960083,617.809448 803.814697,616.752808 
	C806.118958,615.359680 808.107483,616.317932 810.489136,616.637817 
	C811.878540,616.861450 812.818420,617.229248 814.025757,617.914978 
	C816.077942,619.837219 818.341309,620.502563 820.889771,621.368652 
	C821.841187,621.758423 822.871338,623.602417 823.067261,621.694946 
	C823.322021,619.214722 823.573669,617.531128 826.473145,616.812561 
	C828.036011,616.425232 826.064453,615.471313 825.798340,614.393066 
	C825.346680,611.979614 826.310303,610.397705 828.029053,608.850952 
	C828.640381,608.057617 829.722168,609.690247 829.616028,607.952637 
	C828.897278,605.599670 830.797119,604.525146 831.595886,602.629150 
	C832.033630,601.966370 832.277344,601.585388 832.656494,600.895081 
	C833.215210,599.825989 834.480225,599.313049 833.644226,598.164856 
	C833.361938,597.777161 832.748413,597.545288 832.352051,597.829041 
	C831.454712,598.471375 832.203735,599.236206 832.424377,600.279419 
	C832.465393,600.832947 832.439514,601.057556 832.245117,601.578918 
	C831.354248,602.726990 831.050110,603.975342 829.440552,604.311279 
	C827.435974,603.386047 826.007629,603.438354 824.845947,605.598511 
	C824.514709,606.042175 824.367065,606.210938 823.948975,606.586182 
	C823.281433,607.025024 822.862732,607.209167 822.083130,607.407410 
	C821.512756,607.420105 821.285339,607.378723 820.773804,607.139893 
	C819.558899,605.855286 819.088745,604.618103 819.356506,602.860779 
	C819.573730,602.375305 819.695068,602.200623 820.070190,601.843018 
	C821.062256,601.367737 821.819885,601.106079 822.464111,600.140381 
	C823.022339,599.168945 823.446838,598.482544 823.839355,597.778503 
	C824.529968,596.539795 825.683655,595.287292 824.355469,593.855408 
	C822.882446,592.267273 821.467041,593.085205 820.110535,594.164246 
	C819.733093,594.464539 819.258667,594.613403 818.440552,594.783081 
	C814.251953,595.565247 810.679016,593.817200 806.925354,593.577148 
	C804.581604,593.427246 803.512268,591.208618 803.972473,589.201477 
	C804.695801,586.046448 803.583557,583.488037 802.441528,580.474365 
	C803.322327,578.353760 805.032715,578.011414 806.988953,577.432983 
	C807.771179,577.256042 808.219177,577.196899 808.993042,577.170654 
	C809.933594,577.181396 810.548035,577.160767 811.407654,576.761475 
	C811.876221,576.509888 812.068237,576.411011 812.571289,576.202148 
	C814.545227,575.812866 816.299744,575.648743 817.282410,577.313538 
	C818.375061,579.164673 816.989868,580.326477 815.695312,581.408508 
	C814.854919,582.110962 814.451599,582.947205 815.232117,583.928040 
	C815.759644,584.591003 816.513245,584.987366 817.355774,585.004150 
	C818.558105,585.028137 819.058899,584.241455 819.185059,583.148010 
	C819.296875,582.179016 819.162537,581.180725 819.740417,579.950806 
	C824.058411,579.132446 825.598511,582.874756 828.478699,585.002258 
	C828.427429,588.411987 829.823792,587.182068 831.452637,586.119507 
	C833.248779,585.655273 834.697205,585.643738 836.462524,586.247620 
	C838.277161,587.376404 837.916565,589.404297 839.289307,590.926270 
	C840.180115,588.983521 839.475586,587.171875 839.973877,585.179443 
	C842.998108,580.706909 845.491882,576.311279 848.212524,571.713013 
	C849.426697,571.391052 850.061829,572.020142 850.857300,572.308594 
	C851.130493,570.539246 849.239685,570.973389 848.464172,569.796875 
	C847.692322,568.270996 847.633362,566.979858 847.765137,565.272766 
	C848.171875,563.498291 848.878906,562.472778 850.770752,562.279114 
	C853.195435,562.320068 852.373352,565.466431 854.798828,565.274292 
	C856.123901,564.625732 857.180664,564.195190 858.708740,564.176392 
	C861.963257,565.121887 862.767517,567.654724 863.692383,570.455811 
	C863.802124,571.362976 863.778625,571.964478 864.213318,572.736816 
	C864.680603,573.213135 864.964600,573.477112 865.430908,573.987427 
	C866.327515,575.380310 866.230469,577.160767 868.409363,577.516602 
	C872.731873,580.961853 874.332642,585.836914 876.873291,590.493530 
	C877.175659,591.182312 877.349670,591.572998 877.735107,592.202026 
	C879.174377,593.522705 881.109314,592.742310 882.430664,594.357422 
	C882.753479,595.076965 882.827209,595.518433 882.789917,596.301025 
	C882.588135,597.271118 882.311096,597.864990 881.856812,598.732178 
	C881.470947,599.373352 881.220703,599.718079 880.751404,600.293091 
	C879.843262,601.309570 879.222412,602.155701 878.269470,603.130920 
	C877.806396,603.376953 877.598633,603.429077 877.070312,603.456482 
	C875.662048,603.226196 874.917175,602.405518 873.685181,601.907043 
	C871.523987,603.210388 871.425537,605.284058 871.005127,607.602295 
	C871.412537,609.266785 870.442322,609.487000 869.281006,609.842651 
	C868.588318,609.853821 868.041016,609.710449 867.931091,610.073303 
	C867.742004,610.697144 867.710266,609.984680 868.543579,610.411621 
	C869.054016,611.576782 869.046387,612.466431 868.497681,613.633362 
	C866.287415,615.128906 866.976013,616.457581 867.379333,618.426514 
	C867.854614,620.747253 870.895203,623.986206 866.189087,626.015686 
z"/>
<path fill="#C1ADDF" opacity="1.000000" stroke="none" 
	d="
M933.972900,646.763062 
	C929.116150,651.090515 923.383972,653.667480 918.030823,656.855652 
	C916.753967,657.616211 915.863342,658.221375 915.982178,660.175903 
	C913.241577,660.089478 913.634216,657.125427 912.025818,655.350830 
	C912.230835,654.835083 912.332397,654.655762 912.271790,654.458557 
	C912.208618,654.252625 912.137878,654.149536 911.795776,654.249634 
	C911.532532,654.349731 911.644897,654.250549 911.646240,654.325439 
	C908.930725,648.016479 906.225525,641.626770 902.220337,635.899170 
	C897.554932,629.227234 894.559021,621.595398 890.092896,614.805054 
	C889.069641,613.249329 888.692505,611.452271 889.018494,609.209717 
	C889.389709,607.911194 890.025635,607.204834 890.938416,606.278015 
	C891.352600,605.887451 891.527771,605.743408 891.992676,605.426758 
	C893.701599,604.675964 895.139709,604.147827 896.904541,603.564880 
	C898.137512,603.480896 898.948486,603.788574 899.971924,604.439331 
	C900.807983,605.249573 901.158447,606.048279 902.093140,606.768982 
	C906.065552,610.725830 910.043091,607.766846 914.206543,607.609741 
	C917.860046,612.926270 920.164001,618.515076 921.813354,624.680664 
	C922.929443,626.364258 922.690491,628.325928 924.215576,629.848022 
	C924.737854,630.361938 924.922974,630.716492 925.078247,631.277588 
	C924.719604,633.097656 925.124756,634.306763 927.154297,634.890259 
	C929.619751,638.790466 933.029419,641.876282 933.972900,646.763062 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M900.358154,670.218323 
	C898.481384,668.870422 897.862671,667.245361 897.141235,665.296753 
	C897.951111,662.357727 895.986145,660.661621 894.942200,658.710449 
	C889.308838,648.181519 881.620483,638.910645 876.085571,627.907837 
	C875.586304,626.701660 875.322632,625.800964 875.673401,624.519531 
	C875.971741,624.122131 876.185547,623.927917 876.239197,623.965027 
	C880.417114,626.854736 882.475769,624.477173 884.359863,620.740967 
	C885.116089,622.170654 885.548523,623.705322 885.981995,625.640564 
	C884.144043,628.437439 885.889343,630.419739 886.834839,632.393860 
	C891.765015,642.687927 899.095764,651.525269 904.808105,661.752075 
	C905.029968,662.020325 904.984314,662.012756 904.987732,661.989868 
	C907.073975,667.141113 905.786804,669.718994 900.358154,670.218323 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M890.564148,607.606506 
	C889.632507,610.331116 890.048462,612.643127 891.506165,614.887329 
	C897.341187,623.870850 901.893066,633.602905 907.815613,642.573425 
	C909.817505,645.605591 911.554138,649.532654 911.746094,653.993347 
	C904.942444,646.010681 899.747925,636.641663 894.183533,627.510376 
	C891.698792,623.432861 889.102417,619.423279 886.276123,615.189331 
	C884.291443,614.077820 883.631653,612.574402 884.521606,610.931458 
	C886.511597,607.257629 888.440552,603.401611 893.548157,602.699402 
	C894.997437,604.496399 894.238342,605.233398 892.289429,605.770386 
	C891.965027,605.986328 892.004028,605.999023 891.994873,605.980652 
	C891.613770,606.464172 891.300476,607.012390 890.564148,607.606506 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M884.706909,620.352051 
	C883.381531,623.252991 883.190247,626.440735 880.654480,628.489868 
	C879.309692,627.039917 877.981567,625.607788 876.066528,623.963745 
	C874.981812,623.428528 874.535034,623.040710 873.867065,622.434937 
	C873.521667,622.045715 873.397766,621.874084 873.115723,621.421509 
	C872.475952,619.383606 870.803101,618.314941 870.316040,616.225891 
	C869.800659,615.333069 869.281738,614.777588 868.526062,614.067749 
	C868.339600,612.883789 868.389954,611.854065 868.448730,610.428223 
	C868.195557,609.837280 867.933960,609.642456 868.150085,609.342285 
	C869.554016,609.672302 870.172058,609.184326 870.866943,608.260376 
	C874.315552,608.360168 874.945435,611.618713 876.780273,613.536560 
	C879.190186,616.055542 880.752747,619.485046 884.706909,620.352051 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M905.056152,661.640503 
	C897.555664,654.061829 892.194824,644.657593 886.980896,635.194458 
	C885.506592,632.518555 881.820435,629.895874 885.616394,626.090698 
	C888.882568,635.011230 894.875916,642.251587 899.529114,650.240295 
	C901.605103,653.804321 904.234619,657.080750 905.056152,661.640503 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M894.595337,602.772156 
	C888.463318,605.846680 885.106262,610.635132 885.937622,614.649292 
	C885.185120,614.928345 884.374817,614.860901 883.301697,614.636841 
	C882.447510,612.678345 881.176147,611.236267 880.192017,609.253662 
	C879.967102,608.984009 880.013611,608.989380 880.009766,609.012451 
	C878.612976,607.425659 876.666809,606.208008 876.406189,603.496948 
	C876.735779,603.116516 876.988708,603.088867 877.622070,603.029358 
	C878.683289,602.351379 879.332947,601.659058 880.644226,601.426270 
	C883.095886,600.976562 883.077515,605.601501 886.114258,603.232910 
	C886.487122,602.833618 886.646484,602.681458 887.077759,602.338013 
	C890.152161,599.897339 894.903015,600.468811 896.362915,595.712769 
	C897.858337,593.969666 899.139587,594.427490 900.221924,595.635559 
	C901.685974,597.269714 901.793518,599.067017 900.185181,601.138550 
	C899.485718,601.650085 899.041199,601.854736 898.229187,602.083618 
	C897.006897,602.345825 896.101746,602.416626 894.595337,602.772156 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M899.695801,670.129272 
	C905.006775,669.908325 904.933167,666.286926 905.010254,662.376099 
	C905.154175,661.962402 905.362244,661.889771 905.473572,661.963379 
	C907.543396,663.330994 910.193176,659.401794 911.617920,662.153442 
	C913.193420,665.195984 909.383606,666.380066 908.233215,668.544312 
	C907.927795,669.119019 907.554749,669.657776 907.054382,670.504028 
	C903.978088,672.057800 904.264282,676.447510 900.363953,677.060791 
	C899.368958,674.818970 896.263672,672.845825 899.695801,670.129272 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M927.931519,668.694153 
	C927.977600,670.335876 928.145813,672.052734 926.269104,671.792053 
	C923.565918,671.416443 923.799622,668.662109 923.270386,666.805359 
	C922.796753,665.143494 923.889771,664.865295 925.493286,665.982788 
	C927.045715,666.353455 927.724792,667.135010 927.931519,668.694153 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M920.022705,662.216309 
	C922.375793,660.230042 924.785095,658.590759 927.529053,656.884521 
	C926.332947,661.155334 922.705994,663.832336 920.022705,662.216309 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M876.324463,602.925293 
	C877.659546,604.875061 878.836304,606.605957 880.009460,608.686279 
	C876.486633,608.183350 875.670532,604.789795 873.574646,602.162842 
	C874.857239,600.223755 875.307800,602.185669 876.324463,602.925293 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M928.268738,669.015259 
	C927.302185,668.242920 926.700562,667.457642 925.934937,666.419250 
	C926.916687,665.469482 928.062439,664.772827 929.530640,664.036377 
	C930.256775,665.046875 930.660461,666.097229 931.088806,667.482727 
	C930.568665,668.802795 929.643311,668.990723 928.268738,669.015259 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M879.797852,609.324341 
	C881.854370,609.989136 882.861755,611.570496 883.043762,614.084717 
	C881.494812,613.163513 880.146240,611.708374 879.797852,609.324341 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M911.583252,654.550232 
	C911.810120,654.426270 912.400574,653.916443 912.121216,654.871643 
	C911.966553,654.996765 911.633972,654.750732 911.583252,654.550232 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M928.086304,656.838623 
	C928.050842,656.637878 928.263855,656.373047 928.738037,656.063843 
	C928.777710,656.271179 928.556274,656.522827 928.086304,656.838623 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M933.947021,673.866089 
	C933.882385,673.862549 933.764832,673.725037 933.647278,673.587524 
	C933.729553,673.635742 933.811829,673.683960 933.947021,673.866089 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M984.757324,595.828857 
	C985.289917,597.012329 984.135864,598.633240 985.419983,598.688660 
	C988.678345,598.829224 989.205444,600.789795 988.921997,603.260925 
	C988.548157,606.520447 985.576294,605.002380 983.823486,605.731445 
	C983.240784,605.973816 982.513123,605.867310 981.437988,605.985840 
	C978.861084,607.853210 976.264954,607.438538 973.360962,607.452759 
	C970.984802,607.377625 969.003723,607.312439 966.683472,607.558044 
	C965.458740,607.679199 964.578186,607.552551 963.379395,607.587463 
	C962.857727,607.545349 962.652405,607.500427 962.199585,607.260132 
	C959.148315,605.190430 955.945740,605.958191 952.468201,605.806580 
	C950.305054,606.139954 949.583923,605.055359 948.995483,603.323303 
	C949.067383,602.091431 949.253174,601.187988 949.731079,600.094177 
	C952.950562,596.537231 956.985229,597.111267 960.783325,596.530273 
	C957.644104,596.955872 954.469177,597.207336 951.300293,595.256958 
	C948.525574,593.091675 949.306824,591.871216 951.844238,590.916077 
	C960.641418,587.604553 969.840820,586.999207 979.104858,586.753174 
	C981.087952,586.700500 981.205627,587.945618 981.073364,589.342529 
	C980.850769,591.695251 982.340820,595.042786 977.549805,595.315552 
	C976.348572,597.695801 974.756470,595.578491 973.684143,596.156311 
	C974.923279,596.293396 976.190613,596.591492 977.756409,596.771240 
	C979.768372,596.726379 981.515137,596.482727 983.617188,596.112183 
	C984.173096,595.817566 984.373657,595.649719 984.757324,595.828857 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M951.025574,595.384766 
	C954.733154,595.371948 958.456421,595.721558 963.665283,596.210693 
	C958.451660,597.729797 954.615356,598.847656 950.401123,599.934570 
	C950.362488,598.518188 950.701843,597.132629 951.025574,595.384766 
z"/>
<path fill="#0F050A" opacity="1.000000" stroke="none" 
	d="
M944.141113,594.084351 
	C941.237915,593.546509 938.257141,592.876831 936.009766,590.291626 
	C938.942871,590.728455 942.825317,589.464600 944.141113,594.084351 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M977.813599,596.615234 
	C975.899292,597.097961 973.776062,597.214294 971.654846,597.359009 
	C970.696167,597.424438 969.955688,597.133362 970.013306,596.075989 
	C970.090454,594.661621 971.044800,595.527344 971.729553,595.420898 
	C973.450684,595.153381 975.072083,595.124329 976.924194,595.731689 
	C977.331970,595.785156 977.468811,596.022827 977.813599,596.615234 
z"/>
<path fill="#F0DAC0" opacity="1.000000" stroke="none" 
	d="
M984.975342,595.934692 
	C984.772766,596.176697 984.605164,596.177551 984.205078,596.081909 
	C983.972534,595.985413 983.965881,595.541382 983.928223,595.323547 
	C983.890625,595.105713 983.995056,595.004578 984.046875,594.953552 
	C984.294067,594.834229 984.489502,594.765991 984.862366,594.952515 
	C985.039856,595.207214 985.010315,595.693604 984.975342,595.934692 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M950.112915,708.641968 
	C950.079651,710.276550 950.160767,711.596863 949.013977,713.059204 
	C946.189331,710.373718 945.382690,707.380005 947.172974,704.000854 
	C948.820923,700.890503 950.302917,703.534729 951.902771,704.714966 
	C951.209656,706.013428 950.005249,706.778687 950.112915,708.641968 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M950.267334,708.972229 
	C948.994995,708.194397 947.760010,707.248413 948.213074,705.852234 
	C948.670410,704.442810 950.173767,705.178101 951.637329,705.085388 
	C952.017822,705.022644 952.002686,704.976685 951.978821,704.982117 
	C953.000854,706.321960 952.965454,707.529907 951.181519,708.801514 
	C950.827881,709.028442 950.455627,708.970642 950.267334,708.972229 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M951.255127,708.990356 
	C951.856018,708.135376 952.306213,707.067932 951.890503,705.353638 
	C954.018066,704.980652 955.222900,706.285706 954.982056,708.057739 
	C954.713806,710.032532 952.780701,708.521118 951.255127,708.990356 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M956.066528,701.316711 
	C958.369812,700.759766 958.966431,702.307617 959.021240,704.683594 
	C957.298523,704.486755 957.325989,702.601440 956.066528,701.316711 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M950.776489,714.884644 
	C951.391052,713.771606 952.161987,713.848999 952.754272,714.565308 
	C952.927612,714.774902 952.778687,715.553589 952.526001,715.753479 
	C951.894592,716.252747 951.349609,715.791443 950.776489,714.884644 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M954.510864,717.986023 
	C955.388977,718.126587 955.955383,718.327637 956.521851,718.528748 
	C955.737732,719.335815 954.904480,719.285950 953.977417,718.753540 
	C953.403320,718.423889 953.317688,718.006470 953.874329,718.372375 
	C953.900085,718.389343 954.087219,718.160767 954.510864,717.986023 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M954.521729,699.346191 
	C955.260986,699.087769 955.867981,699.418762 955.982910,700.710388 
	C955.519348,700.616394 955.067017,700.140503 954.521729,699.346191 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M952.280029,698.039062 
	C952.340454,697.599304 952.627808,697.253174 952.917114,698.164429 
	C952.810913,698.296143 952.658569,698.224060 952.280029,698.039062 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M898.825806,601.347107 
	C900.743896,599.662903 900.904602,598.045593 899.537659,596.383911 
	C898.388184,594.986572 897.320679,595.355469 896.336426,597.197266 
	C892.350220,596.157715 891.273254,592.421753 889.226440,589.114746 
	C889.093384,586.994507 890.361511,585.467346 890.099243,583.338257 
	C890.061890,582.164978 890.234497,581.334106 890.416382,580.194092 
	C890.501770,578.614624 889.948425,577.510864 889.330200,576.097290 
	C888.864441,574.792358 888.678406,573.724060 887.939514,572.506226 
	C885.338074,568.694885 884.186890,564.560730 882.193237,560.440125 
	C881.477417,557.056091 884.072693,556.124146 885.975952,554.326172 
	C886.601440,553.780151 887.012207,553.556458 887.820007,553.406372 
	C888.389954,553.453857 888.610779,553.517700 889.093994,553.799316 
	C889.578796,554.399414 889.745850,554.803589 889.890259,555.539734 
	C890.016174,556.681580 890.430420,557.281677 891.468262,557.806030 
	C893.801270,559.940796 894.505737,562.636414 895.741760,565.432251 
	C896.643372,567.626038 897.666382,569.409424 898.101440,571.758789 
	C898.249329,572.705566 898.312073,573.335510 898.564575,574.239380 
	C898.741333,574.716003 898.817261,574.904114 899.015076,575.370361 
	C899.303650,576.017456 899.473328,576.385010 899.797485,577.015137 
	C900.460693,578.198364 901.234680,578.870544 902.273804,579.746033 
	C903.469177,581.637939 903.757080,583.362366 902.924377,585.488037 
	C902.295471,586.684448 901.892883,587.588623 902.891235,588.793335 
	C904.899292,590.743713 905.131714,593.580688 907.551086,595.210999 
	C909.063171,593.474304 908.563965,591.759399 907.641296,590.215149 
	C905.970825,587.419067 905.928345,585.205566 909.370728,583.888611 
	C910.866516,583.316406 911.341431,582.233337 911.054321,580.384766 
	C910.949829,578.375366 911.180481,576.953796 913.738586,577.060791 
	C914.502502,577.531494 915.036804,577.503540 915.823730,577.525757 
	C916.257996,577.586792 916.427551,577.636597 916.813477,577.839600 
	C917.029846,577.992859 916.996948,578.002441 917.000793,577.985779 
	C917.520935,578.829163 917.888733,579.753418 918.245239,581.059204 
	C917.368225,586.885742 921.246765,585.850098 924.665833,585.938965 
	C926.464783,585.987854 927.926025,585.992065 928.004456,588.400146 
	C927.575073,588.836426 927.131897,588.918762 926.357300,589.068604 
	C925.170654,590.404114 921.682922,589.674988 923.411011,593.069824 
	C924.117188,594.501526 924.666077,595.651062 925.408936,597.053955 
	C925.558838,597.552612 925.592651,597.758423 925.405762,598.185791 
	C926.398865,600.748169 927.482483,602.658203 930.910461,602.721313 
	C933.699951,602.772705 934.591125,606.159851 935.901611,608.409790 
	C936.979370,610.260010 937.962585,612.165283 939.064270,614.381592 
	C939.530762,615.425781 939.189941,616.052307 938.696411,616.945068 
	C937.764832,617.627625 937.050110,617.937744 936.097473,617.169006 
	C937.192810,618.445007 938.272766,619.402161 939.567383,620.640320 
	C940.621338,621.899048 940.976685,623.025146 940.568481,624.668945 
	C939.963501,625.665588 939.336914,626.102844 938.272705,626.581055 
	C937.121277,626.877930 936.371460,626.727539 935.290405,626.283325 
	C934.796753,626.021240 934.648438,625.928955 934.244995,625.895874 
	C933.989746,625.955078 934.001038,626.009827 934.027954,626.001770 
	C933.811829,625.763672 933.566956,625.535583 933.147217,625.127625 
	C932.974121,624.945801 932.985168,624.999634 933.008789,624.985596 
	C932.565918,624.564453 932.529053,623.970093 932.193604,623.201050 
	C932.025574,622.969543 932.000000,623.001099 932.019409,622.994751 
	C931.572083,622.572327 931.528748,621.971069 931.183105,621.193359 
	C931.010681,620.960022 930.991699,621.005188 931.015991,621.008545 
	C930.720398,620.727112 930.440552,620.406921 930.086609,619.755371 
	C929.748657,619.180786 929.519043,618.907288 929.180298,618.492554 
	C928.702393,617.783447 928.524902,617.147156 928.206360,616.224243 
	C928.007568,615.958252 927.992065,616.005371 928.016846,616.006592 
	C927.579773,615.580566 927.528503,614.974182 927.172729,614.189392 
	C926.994812,613.955750 926.987366,614.010559 927.014954,614.012329 
	C926.800293,613.797119 926.571655,613.566589 926.179443,613.155396 
	C924.556946,609.401855 924.752563,604.181519 918.231995,605.700806 
	C916.786743,605.981689 915.379456,605.388062 914.608276,607.427612 
	C910.352661,608.987488 906.246948,612.751953 901.668945,607.927612 
	C899.674622,606.111389 901.204102,605.391296 902.441345,605.454346 
	C907.671143,605.721252 911.778687,602.758728 917.434814,600.682678 
	C911.530823,602.535645 907.086365,605.455200 901.393677,604.285950 
	C900.457886,603.772278 899.890137,603.344299 899.117249,602.601135 
	C898.798157,602.105774 898.717712,601.879700 898.825806,601.347107 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M937.801147,617.079102 
	C938.336243,616.234009 938.626831,615.739868 939.029175,614.981323 
	C944.204468,622.746338 947.508240,631.631409 951.653259,640.477234 
	C950.895935,640.699707 950.005188,640.617310 948.887817,640.273132 
	C945.289795,635.460876 942.899414,630.337891 940.068604,625.080444 
	C939.766174,623.763000 939.543823,622.790100 939.180237,621.545654 
	C938.258606,620.103088 937.221375,619.031128 937.801147,617.079102 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M923.156067,594.352539 
	C921.849609,592.796082 920.835571,591.355774 919.399170,589.315369 
	C921.713806,589.182800 923.455200,589.083008 925.611206,589.059631 
	C926.074219,591.256226 928.530518,591.504150 929.187500,593.290649 
	C929.835266,595.052063 930.565552,597.007080 929.743225,598.483032 
	C929.006165,599.805969 927.365295,597.206482 925.571472,598.311523 
	C925.185120,598.407471 925.211121,598.362854 925.223145,598.383423 
	C925.240112,596.819641 924.391602,595.622742 923.156067,594.352539 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M971.911804,606.419434 
	C974.810913,606.166504 977.472412,606.025208 980.579102,605.967651 
	C981.377136,607.463135 981.730042,608.874939 982.054688,610.655212 
	C981.822144,611.196228 981.627747,611.378967 981.443054,611.571838 
	C981.259277,611.763794 981.318298,611.696533 981.802185,611.173584 
	C984.722473,609.810364 987.396545,611.642578 990.448303,611.241455 
	C990.776184,611.331604 991.246155,611.453308 991.333984,611.676880 
	C991.421814,611.900452 991.651733,612.317078 991.599487,612.082886 
	C991.547302,611.848633 991.703979,611.392456 991.893188,611.242798 
	C994.268982,610.783264 997.121155,611.744873 997.731262,607.823853 
	C999.709351,607.524170 1000.250793,609.324158 1001.661133,610.511597 
	C1001.842468,610.798950 1001.980042,610.964539 1002.053345,611.046326 
	C1001.625427,613.360962 1000.793274,614.830505 997.933044,614.582825 
	C995.859558,614.403137 992.108032,613.373840 993.958130,618.175049 
	C994.537354,619.678284 992.018127,619.813904 992.020874,621.633301 
	C989.491638,619.731445 986.956116,617.492554 984.458923,615.211792 
	C983.564209,614.394714 982.758301,613.406128 982.046631,615.664429 
	C979.931030,616.428101 978.475769,619.017761 975.493774,617.792603 
	C974.972290,617.954895 974.844360,618.131165 974.414062,618.190186 
	C973.549011,617.463684 973.206543,616.644226 972.173706,616.086914 
	C971.739014,615.611633 971.586426,615.296387 971.521729,614.712280 
	C971.506775,614.487854 971.070923,614.432251 970.868713,614.508057 
	C970.666504,614.583801 970.653870,615.014893 970.779175,614.833923 
	C970.904419,614.652954 971.292542,614.897095 971.422974,615.093018 
	C971.671204,615.602051 971.858643,615.865723 972.320068,616.239014 
	C972.995911,616.671570 973.352295,617.058777 973.807251,617.735291 
	C974.264160,618.192688 974.510742,618.468323 974.810242,619.039062 
	C974.947449,620.101807 975.001526,620.896851 975.024536,622.095215 
	C973.617676,620.014465 971.451538,620.071777 968.905701,619.952881 
	C967.082092,619.867798 965.340881,618.018127 963.194031,616.975586 
	C962.594543,617.084473 962.363953,617.173462 961.853760,617.017578 
	C961.212402,616.071228 961.182861,615.356201 961.687012,614.314575 
	C963.308044,612.971741 965.221130,617.181885 966.281677,613.338562 
	C964.271057,611.293213 965.327087,609.514771 966.288818,607.805298 
	C966.899841,606.719299 967.708496,606.766541 968.713928,607.518372 
	C968.866028,607.632141 968.489380,610.492676 970.074341,607.866333 
	C970.652283,607.556152 971.006348,607.487671 971.418579,607.264160 
	C971.532898,606.851196 971.603577,606.691162 971.911804,606.419434 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M971.757568,606.166504 
	C972.166687,606.635742 972.183289,606.963806 972.020508,607.733398 
	C968.484009,608.111877 971.001038,611.541992 968.978943,612.632629 
	C967.243347,611.441833 970.208130,608.666931 967.245422,607.902893 
	C966.842712,609.235413 965.552368,610.474426 966.053772,612.726562 
	C964.584473,613.269043 964.201050,612.186401 963.846436,610.310425 
	C963.747620,608.728821 964.019653,607.906921 964.885620,607.027588 
	C967.082886,605.435059 969.283142,606.163574 971.757568,606.166504 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M960.194336,619.487793 
	C959.950745,619.913147 959.944641,620.132507 959.970459,620.679565 
	C956.943604,620.347717 957.383179,618.927795 959.523560,617.160156 
	C960.039001,617.230469 960.208801,617.353882 960.500488,617.767944 
	C960.663269,618.482605 960.604858,618.891174 960.194336,619.487793 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M960.296387,618.251770 
	C959.938782,617.994873 959.901550,617.819275 959.866760,617.375305 
	C959.869202,617.106995 960.014587,616.824219 960.015137,616.665222 
	C959.966309,616.075012 960.783997,615.634460 959.760071,615.088623 
	C959.559265,614.763000 959.486084,614.616882 959.167725,614.520447 
	C958.922119,614.249695 958.807495,613.986389 959.088989,613.892395 
	C960.086243,614.040161 960.687500,614.018555 961.588257,613.999268 
	C961.973389,614.744751 962.059021,615.487854 962.034973,616.596252 
	C961.706238,617.625732 961.275818,618.088501 960.296387,618.251770 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M961.966919,607.406372 
	C961.952148,607.064819 962.395630,606.913757 962.627380,606.947876 
	C964.970154,606.545288 964.262512,608.163696 964.242065,609.532837 
	C964.050537,609.924316 963.903015,610.110840 963.824585,610.207520 
	C962.458252,609.935181 962.073181,608.942871 961.966919,607.406372 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M966.047913,623.629761 
	C966.032776,624.125977 966.021057,624.309937 965.991699,624.770081 
	C965.974121,625.046265 965.492615,625.103516 965.261841,625.028931 
	C964.983276,624.776306 964.935547,624.598145 964.804199,624.155640 
	C964.846619,623.408386 964.960754,622.921936 965.101440,622.443237 
	C965.451660,621.251343 966.206970,620.888794 967.358398,621.367493 
	C966.922729,622.017517 966.487000,622.667542 966.047913,623.629761 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M959.144287,614.395752 
	C958.301086,613.569275 957.123840,612.026123 957.996643,611.468933 
	C958.954529,610.857300 958.872498,612.648560 959.326050,613.750183 
	C959.485046,614.061768 959.251892,614.278442 959.144287,614.395752 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M959.856079,608.592712 
	C960.305176,609.213257 960.499939,609.722778 960.694702,610.232300 
	C960.442200,610.265442 960.079407,610.421387 959.956116,610.310608 
	C959.403564,609.814392 958.774780,609.268494 959.856079,608.592712 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M954.369141,610.337524 
	C954.331909,609.949707 954.450928,609.715332 954.569946,609.480957 
	C954.676453,609.581665 954.889832,609.714783 954.870911,609.777466 
	C954.795044,610.027283 954.646851,610.255005 954.369141,610.337524 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M959.675598,615.340576 
	C960.132385,615.062622 960.706421,615.192139 960.211731,616.274414 
	C959.954834,616.242493 959.893860,615.978699 959.675598,615.340576 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M957.348938,624.611755 
	C957.245178,624.489441 957.598694,624.411011 957.598694,624.411011 
	C957.598694,624.411011 957.452698,624.734070 957.348938,624.611755 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M817.632568,743.958618 
	C817.045776,740.999207 816.395142,738.102051 817.539001,733.186096 
	C819.298584,735.567932 820.389282,737.044312 821.738831,738.760376 
	C823.766296,743.126526 820.473755,743.239807 817.632568,743.958618 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M819.487061,754.111938 
	C819.054504,752.591553 818.984375,751.340881 818.905518,749.870483 
	C819.254639,749.519897 819.612549,749.389099 820.186279,749.292114 
	C820.688110,749.186279 820.653992,748.186096 821.284790,748.979980 
	C822.241943,750.184631 821.727539,751.489075 821.445984,753.219238 
	C821.015198,754.208252 820.502563,754.446228 819.487061,754.111938 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M820.664429,754.056396 
	C820.578003,752.535461 821.101318,751.270752 820.447205,749.633423 
	C821.037109,748.122009 821.516479,746.268799 823.130127,749.093933 
	C823.359924,750.905884 822.892090,752.166321 822.077271,753.683105 
	C821.643555,754.095642 821.351440,754.197937 820.664429,754.056396 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M819.545837,746.470703 
	C819.575378,746.521790 819.516296,746.419617 819.545837,746.470703 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M927.285217,634.683105 
	C923.809204,634.827698 923.345703,634.332581 924.709656,631.601379 
	C925.741211,632.444580 926.434021,633.405090 927.285217,634.683105 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M924.443787,629.655029 
	C921.749329,629.747681 922.271973,627.523743 921.961304,625.344116 
	C923.276306,626.072510 923.587463,627.810120 924.443787,629.655029 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M926.943237,614.289429 
	C927.368408,614.424622 927.741943,614.893494 928.078552,615.685181 
	C927.177979,615.945190 927.024780,615.292480 926.943237,614.289429 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M927.949219,616.309937 
	C928.910461,616.148376 929.036865,616.865601 929.099121,617.979370 
	C928.677734,617.788086 928.284302,617.224854 927.949219,616.309937 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M931.926758,623.300537 
	C932.795837,623.100830 933.064087,623.673462 933.130371,624.654541 
	C932.128601,624.976379 931.938477,624.339722 931.926758,623.300537 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M930.874756,621.293091 
	C931.394653,621.423889 931.778625,621.887756 932.100647,622.670044 
	C931.070129,623.045166 930.941711,622.300171 930.874756,621.293091 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M926.068359,613.260620 
	C926.310364,613.148987 926.618591,613.309631 926.984741,613.742249 
	C926.739868,613.853699 926.437256,613.693298 926.068359,613.260620 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M930.015137,619.814392 
	C930.279358,619.760864 930.580444,620.067566 930.960876,620.693054 
	C930.710815,620.732788 930.381470,620.453674 930.015137,619.814392 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M932.991333,625.289917 
	C933.318237,625.092529 933.662292,625.239258 934.030640,625.689819 
	C933.706116,625.873779 933.357361,625.753906 932.991333,625.289917 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M897.204651,573.160400 
	C896.406067,570.858887 895.763245,568.787964 895.070679,566.359192 
	C894.604431,564.638855 895.533264,563.519897 895.740234,562.263611 
	C896.740479,556.191589 897.820129,555.309692 904.663086,554.868652 
	C905.165710,561.244995 904.310242,567.434631 906.442078,573.729736 
	C906.843628,575.407349 906.380737,576.501221 905.028198,577.536011 
	C904.336731,578.646851 903.715698,579.358948 902.331543,579.595215 
	C900.284973,580.062073 899.111511,579.745117 898.922363,577.361206 
	C898.699463,576.825378 898.585266,576.637756 898.254639,576.201782 
	C898.038330,575.953369 897.933960,575.469604 897.863647,575.232361 
	C897.531677,574.492004 897.524963,573.920105 897.204651,573.160400 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M901.985352,579.940186 
	C902.726257,579.020813 903.484253,578.464172 904.526489,577.836792 
	C905.349792,581.562927 907.693359,581.138428 910.662109,580.074463 
	C914.074524,581.947998 914.298706,584.000793 910.581787,584.832336 
	C906.781311,585.682678 906.395569,586.882996 908.940186,589.601807 
	C909.462646,590.160095 909.851685,591.051331 909.893555,591.811584 
	C910.009766,593.919067 910.462708,596.666504 907.982544,597.376709 
	C905.891418,597.975586 905.142822,595.482666 904.510803,593.852478 
	C903.959961,592.431946 903.317078,591.172424 902.088501,589.871338 
	C901.528381,588.585083 901.287781,587.571411 901.782532,586.012695 
	C902.864685,583.791748 902.094849,582.049133 901.985352,579.940186 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M924.945618,585.653320 
	C924.333069,586.938232 923.241089,586.703918 922.356995,587.031189 
	C917.914673,588.675720 916.284546,587.145508 917.102661,582.184204 
	C917.722778,581.008179 917.404236,580.082458 917.908813,579.095703 
	C922.488892,578.875671 923.143311,582.670288 924.945618,585.653320 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M918.052612,578.689453 
	C918.017639,579.759949 917.851135,580.596497 917.406860,581.590759 
	C916.990356,580.729614 916.851685,579.710754 916.858826,578.330566 
	C917.310120,578.131287 917.615662,578.293396 918.052612,578.689453 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M916.061401,577.856445 
	C915.345459,577.879639 914.863892,577.697205 914.250366,577.292969 
	C914.554810,577.067200 914.991211,577.063171 915.756104,577.061707 
	C916.155029,577.259705 916.225342,577.455261 916.061401,577.856445 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M916.135864,578.184570 
	C915.871216,577.896057 915.915405,577.730042 916.022095,577.314087 
	C916.383301,577.201294 916.681946,577.338440 917.005188,577.734192 
	C916.834717,578.097595 916.639648,578.202332 916.135864,578.184570 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M939.670898,624.818542 
	C944.393738,628.703064 946.366272,634.139954 948.725525,639.657837 
	C948.361816,640.015869 948.062378,640.021179 947.538330,640.033813 
	C946.989075,639.852112 946.684143,639.636169 946.193726,639.200562 
	C945.988342,639.008972 946.000000,639.000000 945.994141,639.006836 
	C942.749695,635.265930 940.054138,631.164551 937.920227,626.323059 
	C938.375793,625.614014 938.864563,625.257629 939.670898,624.818542 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M937.520325,626.014526 
	C941.615906,629.398804 943.181335,634.234070 945.950378,638.662476 
	C940.809937,636.308411 939.039978,630.617310 935.082764,626.417664 
	C935.681274,626.095276 936.417419,626.076965 937.520325,626.014526 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M946.082031,639.308533 
	C946.302246,639.209167 946.616089,639.409424 947.121826,639.824951 
	C946.934387,639.896179 946.554993,639.752136 946.082031,639.308533 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M877.793457,42.792892 
	C876.768555,42.729538 876.214905,42.369495 876.640686,41.599804 
	C876.793457,41.323639 877.560913,41.137321 877.909302,41.271046 
	C878.667847,41.562141 878.743530,42.150639 877.793457,42.792892 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M215.450714,473.068329 
	C217.074631,457.261047 219.067627,441.543365 221.053940,425.824890 
	C221.364243,423.369324 221.644135,420.909912 221.864838,418.072144 
	C220.928543,417.863647 220.585999,417.454346 220.729507,416.329834 
	C221.374649,415.321808 222.118362,414.901947 223.434326,414.237701 
	C227.367264,414.758698 230.662811,415.464355 233.653534,412.763275 
	C234.973755,411.570892 236.456894,412.884399 238.258209,413.131653 
	C239.445206,414.340210 238.980453,415.616455 239.000366,416.845947 
	C239.004913,417.126251 238.995392,417.283112 238.997116,417.316071 
	C239.022049,417.790955 239.224213,417.645599 238.992004,417.195831 
	C238.703995,416.638031 239.709488,416.534851 239.100891,416.361908 
	C239.427841,414.865051 239.759186,413.717529 239.975861,412.164062 
	C240.030884,411.029388 240.076614,410.270996 240.670502,409.281372 
	C244.745590,408.386597 248.544724,410.100067 252.744904,409.030945 
	C252.670837,424.606537 252.182571,440.219666 251.787231,455.835144 
	C251.726624,458.228455 250.644424,459.376923 248.465698,460.078918 
	C245.015381,461.190613 241.641006,462.538055 237.602219,464.017365 
	C238.301239,450.577393 238.980042,437.526093 239.658859,424.474792 
	C237.020187,427.321899 237.337753,430.750000 237.087250,433.999237 
	C236.384644,443.112396 235.711044,452.231720 235.299393,461.360962 
	C235.167984,464.275330 234.182312,465.761353 231.419617,466.764069 
	C226.140793,468.679993 221.009888,471.003418 215.450714,473.068329 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M133.148178,522.605469 
	C132.611176,523.042297 132.357529,523.280334 131.942078,523.725281 
	C130.123062,523.906372 129.010605,525.811462 127.027618,524.986816 
	C126.380516,524.230957 126.227921,523.606262 126.322906,522.596741 
	C126.542961,521.860413 126.729950,521.463806 127.114021,520.801758 
	C127.615059,519.966248 127.968575,519.421814 128.443665,518.568359 
	C130.165634,515.616699 131.207840,512.668701 133.197266,509.849609 
	C137.392929,504.270935 141.001755,498.690399 145.090851,493.027802 
	C148.219742,488.870575 152.310440,486.243225 156.052200,482.744446 
	C157.137558,481.791809 158.088058,481.239807 159.342590,480.575745 
	C160.543762,479.955536 161.678574,480.152161 162.772675,479.302002 
	C168.730103,476.080933 174.764694,475.922577 180.843292,477.525696 
	C185.863983,478.849854 190.765610,480.621155 196.664474,481.242584 
	C194.649353,483.599396 193.063675,484.064484 190.976303,483.231506 
	C189.755569,482.744354 188.386078,482.626221 187.171951,482.126984 
	C175.180206,477.195831 165.390472,481.744354 156.091675,489.512634 
	C155.833740,489.982330 155.749802,490.168976 155.568481,490.649597 
	C155.374344,491.128723 155.277573,491.313843 154.980408,491.742554 
	C154.335419,492.449188 153.871750,492.892822 153.161682,493.560669 
	C150.781799,495.149628 149.360764,497.304047 147.069427,499.004150 
	C146.788467,499.203064 146.768936,499.389069 146.858231,499.416809 
	C145.686569,501.937408 144.402679,504.415619 142.202759,506.708862 
	C141.941742,506.941589 142.000290,506.996735 141.968781,506.972534 
	C141.841415,507.111420 141.745560,507.274506 141.522888,508.000427 
	C141.239990,509.138153 141.038345,509.698425 140.734314,510.557556 
	C140.514221,511.041626 140.409058,511.230835 140.108017,511.685730 
	C137.055573,515.004883 136.530838,519.503662 133.148178,522.605469 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M162.547241,479.084045 
	C162.942322,480.325592 162.331467,480.990936 160.776855,481.012573 
	C158.622314,481.606415 156.750000,482.084625 154.409592,482.301270 
	C153.731949,482.270752 153.463394,482.245117 152.801300,482.144775 
	C151.404953,481.817291 150.442322,481.379913 148.994263,481.412842 
	C148.281601,481.420044 147.933868,481.484253 147.626617,481.397736 
	C135.508133,477.985443 125.541496,483.631256 115.191780,489.204468 
	C113.107796,490.185638 111.293907,490.887756 109.550797,492.463196 
	C108.361351,493.190186 107.424507,493.540131 106.011490,493.531830 
	C104.868568,493.133423 104.456596,492.528107 104.316711,491.343719 
	C107.160027,486.806946 111.909515,485.550232 115.983971,483.280304 
	C118.131393,482.083984 120.428932,481.201111 123.059402,480.192139 
	C125.155876,480.325653 126.360825,478.797424 128.189682,478.588623 
	C126.601204,478.517426 125.683350,479.945587 123.929688,479.772400 
	C120.213440,478.898224 116.921120,480.730255 113.244057,479.886475 
	C111.234962,480.193115 113.346550,477.170227 110.949738,478.028656 
	C109.952309,478.211700 109.269699,478.209534 108.228020,478.119019 
	C107.140007,477.886902 106.501945,477.557190 106.048935,476.557220 
	C120.297279,476.059082 134.595551,474.867432 148.703323,478.048096 
	C153.114349,479.042572 157.604309,478.998260 162.547241,479.084045 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M62.699005,499.342712 
	C63.342548,497.137390 63.856026,495.224335 66.141632,494.094666 
	C71.340599,489.573364 76.490440,485.464447 82.139030,481.991638 
	C84.830063,480.337158 87.477875,478.648651 91.122673,478.569244 
	C93.129852,481.133270 90.835800,482.040558 89.461685,483.059906 
	C86.600006,485.182739 83.659821,487.201416 80.619293,489.628723 
	C80.210159,489.972321 80.045586,490.103058 79.630493,490.412720 
	C78.742790,491.032654 78.035461,491.377625 77.336861,492.187744 
	C77.058289,492.562866 76.945938,492.712402 76.658661,493.082153 
	C76.357971,493.442200 76.232193,493.581970 75.900223,493.915527 
	C75.543999,494.224304 75.393974,494.339294 75.003326,494.603821 
	C74.433044,494.937500 74.102455,495.119965 73.523415,495.456116 
	C73.105995,495.722839 72.935928,495.833923 72.503677,496.119019 
	C71.494331,496.756378 70.817490,497.314331 69.881851,498.063965 
	C68.981018,498.758636 68.322578,499.241119 67.599327,500.105347 
	C67.125679,500.645782 66.826172,500.931763 66.247971,501.386963 
	C65.219177,502.022156 64.407005,502.323120 63.179863,502.224976 
	C62.245155,501.777344 61.845524,501.264801 61.860199,500.265930 
	C62.018215,499.968018 62.010143,500.014984 61.988541,500.025024 
	C62.126610,499.877991 62.286285,499.720886 62.699005,499.342712 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M178.844391,467.032776 
	C185.723160,466.151215 192.338852,465.731110 199.053635,466.432098 
	C202.511978,466.793091 206.119247,465.693054 209.662994,465.285797 
	C211.227203,465.106079 212.370728,466.112701 212.300995,467.392792 
	C212.251617,468.299530 210.692123,468.144409 209.349915,468.145630 
	C203.634918,470.257538 197.998489,470.451538 192.386368,470.543427 
	C189.399780,470.592316 186.395676,470.464325 182.933167,470.330048 
	C181.838562,470.194092 181.247986,469.991516 180.348633,469.360596 
	C179.836777,469.003082 179.669998,468.967865 179.263016,468.844971 
	C178.642578,468.357208 178.507538,467.886749 178.844391,467.032776 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M147.115112,499.264954 
	C147.608765,496.368103 149.752426,494.612213 152.270142,492.861237 
	C153.738388,493.088654 154.037109,492.174347 154.708923,491.208984 
	C154.923416,490.936035 154.970596,490.942291 154.965088,490.919128 
	C155.179062,490.815033 155.398544,490.734100 155.732178,490.984924 
	C157.505219,490.391418 158.563370,492.325195 160.429184,492.170197 
	C161.208115,492.344849 161.503708,492.650330 161.720978,493.398254 
	C161.738922,495.070496 160.879837,496.096130 160.270767,497.554047 
	C160.065018,498.030212 159.975891,498.217224 159.722305,498.667358 
	C159.157394,499.419403 158.641479,499.742584 157.462311,500.046906 
	C154.805115,499.226196 152.915894,495.723633 150.625854,500.167786 
	C149.750870,501.865845 148.561722,499.544769 147.115112,499.264954 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M79.216270,490.229004 
	C82.766571,485.699097 87.808701,483.003448 92.458603,479.111420 
	C93.097610,478.153168 93.729134,478.049469 94.713654,478.075317 
	C98.440308,477.439392 101.842613,476.786896 105.645111,476.160706 
	C106.718536,476.533661 107.391769,476.880341 108.432220,477.347534 
	C107.781227,479.258942 105.943031,479.704773 104.178009,480.025848 
	C97.164368,481.301941 91.109055,484.584412 85.380257,488.645569 
	C83.652939,489.870117 81.928001,491.357941 79.216270,490.229004 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M92.037491,478.990021 
	C84.562386,480.473114 78.902023,485.303711 72.964439,489.613892 
	C70.984520,491.051147 69.130402,492.661713 66.837158,494.113342 
	C69.173622,489.826691 72.983658,486.804108 77.039330,483.979797 
	C78.250244,483.136536 80.245575,483.083344 80.254456,480.918640 
	C79.818886,480.561401 79.654762,480.370392 79.682220,479.853760 
	C83.636040,479.071869 87.297073,477.847260 91.572250,478.018005 
	C92.134026,478.171021 92.268806,478.349518 92.203491,478.797272 
	C92.003410,479.066559 92.000130,478.991821 92.037491,478.990021 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M178.735107,466.599335 
	C179.050766,467.228546 179.030563,467.737396 179.016571,468.501770 
	C177.948318,468.850677 176.873825,468.944061 175.397858,469.098999 
	C174.830963,469.233276 174.665527,469.305969 174.252640,469.268127 
	C173.563690,469.144287 173.122208,469.131042 172.351532,469.172607 
	C170.345291,470.372559 168.592728,470.588165 166.366318,469.389954 
	C165.547195,469.104401 165.108643,469.085083 164.342743,469.104126 
	C159.035080,469.904236 154.048462,471.193542 149.057343,468.484497 
	C149.449860,467.991302 149.888748,467.978485 150.657501,467.967712 
	C151.149857,467.854279 151.312363,467.738800 151.738861,467.763794 
	C154.398438,467.626709 156.794037,467.349121 159.588684,467.053528 
	C166.126190,466.892120 172.235092,465.771759 178.735107,466.599335 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M179.809158,469.309509 
	C180.447586,468.991669 180.891602,468.944977 181.665009,468.976624 
	C184.410904,471.226624 188.296494,468.317291 190.472748,471.805054 
	C190.231873,472.835541 189.995895,473.557068 190.272598,474.617157 
	C186.626892,475.786316 183.110611,473.326599 179.496399,474.784180 
	C178.741348,475.088654 177.783478,474.456299 177.526566,473.623627 
	C176.924759,471.673096 178.316879,470.622498 179.809158,469.309509 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M137.752533,468.708954 
	C138.753876,468.806885 139.517181,468.818146 140.660980,468.791748 
	C142.095566,468.490051 143.160095,468.279724 144.644440,468.162231 
	C145.270462,468.213074 145.489380,468.236694 146.001297,468.412781 
	C146.152863,469.216003 145.853882,469.783813 144.994568,470.545166 
	C141.990540,470.601379 139.389282,470.381134 136.384323,470.201813 
	C135.817307,470.287933 135.653976,470.333099 135.252335,470.289917 
	C125.644531,470.201569 116.275047,470.201569 106.905571,470.201569 
	C106.895142,469.587097 106.884720,468.972626 106.874290,468.358154 
	C113.931641,468.358154 120.988991,468.358154 128.472595,468.321472 
	C129.454285,468.142883 130.001205,468.135956 130.780396,468.515991 
	C132.740753,468.692719 134.452530,468.741119 136.592682,468.763306 
	C137.185532,468.698822 137.350021,468.660553 137.752533,468.708954 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M145.034424,470.891754 
	C144.871094,470.262939 145.150406,469.704254 145.862015,468.855408 
	C146.600555,467.046753 147.342560,466.574860 148.852386,467.785156 
	C153.589920,469.874512 158.391174,468.739014 163.550613,469.093719 
	C163.817932,469.579987 163.624512,470.397644 163.422363,470.399811 
	C157.436249,470.463959 151.519928,472.949219 145.034424,470.891754 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M140.395493,464.949768 
	C140.371307,461.125061 144.811752,459.302856 148.917160,461.430389 
	C150.010864,461.997192 150.689514,463.475250 152.549942,462.545715 
	C152.924744,461.484161 153.598175,461.591125 154.463745,461.517242 
	C155.158020,461.496674 155.541824,461.564941 156.138840,461.893860 
	C156.670929,462.394440 156.977921,462.705475 157.659668,463.554749 
	C155.018585,463.737549 152.054855,465.472656 148.664047,464.252441 
	C146.991058,463.302856 145.506104,464.075104 143.802307,463.920074 
	C142.743317,464.978546 141.668045,464.790924 140.395493,464.949768 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M207.652145,471.531006 
	C209.410034,472.500153 211.312881,470.309875 212.688202,472.723785 
	C210.518005,475.055023 207.579010,474.781555 204.386566,475.150391 
	C203.282501,475.526794 202.540939,475.484497 201.434448,475.445312 
	C200.860016,475.374390 200.654205,475.330566 200.155853,475.168152 
	C199.015945,473.673218 199.140152,472.456055 200.822540,471.256683 
	C201.960464,470.831573 202.757599,470.748474 203.952133,470.693176 
	C204.602249,470.687225 204.861496,470.695038 205.505890,470.747437 
	C206.400848,470.888306 206.881256,471.064514 207.652145,471.531006 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M62.510796,502.277344 
	C63.711048,501.583588 64.359497,501.039612 65.283539,500.329590 
	C65.714020,500.296417 65.868912,500.429230 66.193283,500.817932 
	C66.444748,501.708130 66.253471,502.281799 65.822144,503.098816 
	C65.354286,503.872375 65.012215,504.367310 64.550117,505.142456 
	C63.730888,506.408173 63.037685,507.396820 62.215851,508.669006 
	C61.913128,509.082977 61.784962,509.243988 61.448753,509.634338 
	C60.948437,510.156799 60.644924,510.437805 60.084984,510.897461 
	C59.664425,511.195862 59.487354,511.301575 59.019508,511.509705 
	C57.913460,511.766357 57.120903,511.574646 56.027756,511.429810 
	C54.927006,511.382874 54.128159,511.515747 53.016129,511.427795 
	C52.543396,511.224091 52.378052,511.090851 52.265648,510.643494 
	C52.797409,509.730713 53.276226,509.132050 53.884888,508.274719 
	C55.090603,507.184113 56.166470,506.352142 57.565155,505.658813 
	C58.509747,506.213623 59.131458,506.615662 59.886703,505.538727 
	C60.195122,504.943665 60.377838,504.606598 60.714989,504.024231 
	C60.959980,503.608215 61.063438,503.444519 61.346088,503.050507 
	C61.669849,502.689209 61.814419,502.558167 62.510796,502.277344 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M126.505249,464.501526 
	C125.568695,463.922516 124.419655,463.322083 124.491692,462.975372 
	C124.722755,461.863434 125.967369,461.632843 126.807625,461.948486 
	C129.618652,463.004547 132.145569,461.592346 134.990875,461.529083 
	C135.620132,462.504578 135.755264,463.277863 135.180191,464.399780 
	C132.218704,464.664337 129.535233,464.630310 126.505249,464.501526 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M101.843201,450.248352 
	C104.265526,449.971649 106.544479,449.961456 108.822144,450.011017 
	C109.823631,450.032806 111.006058,450.169342 110.963921,451.467499 
	C110.924767,452.673920 109.803719,452.933594 108.772835,452.972534 
	C106.484322,453.058990 104.194191,453.102478 101.453369,453.079773 
	C101.234459,452.177063 101.466881,451.358124 101.843201,450.248352 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M100.644196,464.005096 
	C104.689476,463.530823 108.397530,463.268402 112.555939,463.071350 
	C113.133240,463.290131 113.260185,463.443573 113.312370,463.885986 
	C112.716751,464.509491 112.088692,464.402252 111.362167,464.828979 
	C108.309593,465.331116 105.430428,465.657135 102.542053,465.820801 
	C101.524529,465.878448 99.545517,466.821014 100.644196,464.005096 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M100.897659,457.379578 
	C102.184837,457.126068 103.594292,456.744598 104.431854,457.271759 
	C105.929306,458.214233 108.737953,455.256989 108.794571,458.253052 
	C108.829834,460.119354 105.985489,459.800934 104.196449,459.794434 
	C103.413734,459.791595 102.630295,459.985535 101.411652,460.193176 
	C99.855431,459.502991 99.958855,458.610413 100.897659,457.379578 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M61.147041,505.104248 
	C60.914032,506.735626 59.789680,507.319000 59.016796,508.137878 
	C58.492985,508.692810 57.762177,509.595551 57.047340,508.637299 
	C56.480759,507.877716 57.486206,507.214691 57.868355,506.164062 
	C57.887974,505.797424 57.948177,505.869873 57.917442,505.905548 
	C58.070847,505.817566 58.254982,505.693909 58.699783,505.363434 
	C59.360622,503.274506 59.608452,501.323181 61.654747,499.995728 
	C62.251991,500.519684 62.485760,501.071381 62.891060,501.875305 
	C63.062595,502.127563 63.003284,502.064758 63.037476,502.038391 
	C62.789936,502.199890 62.539913,502.423676 62.161766,502.877838 
	C62.006424,503.077362 61.985851,502.994019 62.026970,502.981689 
	C61.488079,503.437927 61.494930,504.163391 61.147041,505.104248 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M161.382141,504.946533 
	C160.560181,504.840363 159.918961,504.696777 159.111603,504.267975 
	C159.044983,503.843964 159.144470,503.705170 159.360519,503.338196 
	C159.594376,502.504303 159.958969,502.030243 160.480286,501.298340 
	C161.242783,500.192261 161.827988,499.331726 162.773071,498.334534 
	C164.250626,497.103180 165.422668,495.918640 167.557144,496.647369 
	C168.339355,499.531921 166.052551,500.293335 164.283890,501.841522 
	C164.031799,502.091003 164.011658,502.018005 164.046539,502.032745 
	C163.788315,502.208832 163.534760,502.418121 163.177704,502.877563 
	C163.034683,503.079803 163.011047,503.012817 163.045929,503.019592 
	C162.759003,503.247314 162.478668,503.511566 162.115570,504.085938 
	C161.964569,504.623901 161.823914,504.811615 161.382141,504.946533 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M79.456787,479.498383 
	C79.889328,479.732452 79.904846,479.936737 79.951691,480.446716 
	C77.081474,481.850281 74.179947,482.948212 70.361229,484.393158 
	C72.104874,479.425568 76.178123,480.502563 79.456787,479.498383 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M165.961792,469.448853 
	C167.713455,469.109406 169.441147,469.095123 171.595581,469.154114 
	C171.584579,472.136505 169.410507,471.996552 167.250534,472.016602 
	C165.378281,472.034027 165.664200,470.935120 165.961792,469.448853 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M190.621246,474.946655 
	C189.997925,474.280151 189.057510,473.872864 189.829742,472.831177 
	C191.796097,471.424011 193.750000,471.568390 196.132828,471.952332 
	C197.626450,472.443848 198.547028,473.031219 198.921906,474.542297 
	C196.227585,474.956360 193.639053,474.969727 190.621246,474.946655 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M164.337738,502.341919 
	C164.706879,500.091736 166.646469,499.197540 168.070618,497.014526 
	C169.367462,494.791687 170.812439,494.112457 172.952057,494.891907 
	C170.340363,497.644318 167.492035,500.118561 164.337738,502.341919 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M168.070862,497.033936 
	C165.409958,495.231171 165.552673,499.187164 163.363312,499.180420 
	C162.113815,498.680267 161.811264,497.855408 161.760361,496.586731 
	C162.188950,495.621552 162.764420,495.351990 163.726410,495.114197 
	C165.075439,494.603790 166.177063,494.313904 167.633667,494.015259 
	C168.649994,494.674286 168.756317,495.450867 168.237213,496.675079 
	C168.034027,497.039917 168.058273,497.013611 168.070862,497.033936 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M113.038773,464.983459 
	C112.667900,464.527618 112.740456,464.250702 112.909653,463.555267 
	C114.735275,462.220245 116.511589,462.784058 118.620667,462.960846 
	C119.338806,463.161896 119.483795,463.482941 119.272461,464.146240 
	C117.235352,464.648712 115.358780,464.905548 113.038773,464.983459 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M135.301208,464.799255 
	C134.960999,463.966370 135.019836,463.234375 135.133209,462.134033 
	C137.245575,461.407135 139.822784,460.216736 139.070465,464.613464 
	C137.896530,464.959747 136.798386,464.929962 135.301208,464.799255 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M168.394104,496.990631 
	C168.050766,496.293518 168.067490,495.547150 168.036438,494.403625 
	C169.223145,492.171112 170.694275,492.972870 172.460846,493.773010 
	C172.990982,494.061890 173.212936,494.210632 173.253143,494.716522 
	C173.071381,495.073700 173.158890,495.088013 173.173798,495.129028 
	C171.066742,494.148712 170.224106,496.330261 168.394104,496.990631 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M199.077148,474.977356 
	C198.227158,474.462524 197.638168,473.982056 197.031265,473.201385 
	C197.886490,469.270599 199.577225,468.540314 202.168533,471.788940 
	C200.730392,472.277344 199.694031,472.679749 199.874512,474.683441 
	C199.688263,475.037018 199.513214,475.024384 199.077148,474.977356 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M119.309639,464.579956 
	C119.106567,464.069580 119.074509,463.750000 118.990654,463.193268 
	C120.493271,462.689789 122.478615,460.706787 122.943504,464.483734 
	C121.727882,464.874115 120.617622,464.821075 119.309639,464.579956 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M70.553085,437.847473 
	C72.549408,437.825897 72.937584,439.092651 73.414001,440.766724 
	C73.454704,441.850800 73.369926,442.562012 73.296471,443.631531 
	C73.122131,443.944824 72.936462,443.899750 72.464409,443.865204 
	C71.730156,442.055664 72.328384,439.715118 69.360718,438.916504 
	C68.987595,438.869934 68.993492,438.481842 68.993034,438.287750 
	C69.410995,438.039978 69.829414,437.986328 70.553085,437.847473 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M180.233429,490.994873 
	C179.372665,492.912659 177.510193,493.088226 175.889893,494.135254 
	C175.253647,494.220154 174.924088,494.246094 174.699402,493.787354 
	C175.705170,491.653229 177.749893,491.850037 179.267822,490.599091 
	C179.771698,490.542023 179.980530,490.606110 180.233429,490.994873 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M105.779419,445.235657 
	C105.407814,445.966278 104.701706,446.326416 103.706139,446.743164 
	C103.229240,446.136200 103.041809,445.472717 102.947906,444.456970 
	C103.842590,444.358215 104.643745,444.611694 105.779419,445.235657 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M179.937286,484.034302 
	C179.630402,485.067169 179.262390,486.007874 178.282059,485.569031 
	C177.832687,485.367859 177.286331,484.360352 177.442032,484.016418 
	C177.975586,482.837921 178.953049,483.128113 179.937286,484.034302 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M143.759247,464.297577 
	C144.781036,462.738434 146.248627,462.710602 148.065308,463.863098 
	C146.887329,464.298584 145.465683,464.409821 143.759247,464.297577 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M144.917084,467.991272 
	C144.183258,469.277679 142.966568,468.803436 141.459015,468.825745 
	C142.208130,468.120819 143.131409,466.540009 144.917084,467.991272 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M92.263672,479.345642 
	C91.966438,478.887665 91.929474,478.708801 91.945877,478.261230 
	C92.744942,476.913940 93.645325,476.822784 94.857758,477.832397 
	C94.199982,478.602814 93.361954,479.113739 92.263672,479.345642 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M143.869308,473.780090 
	C142.865524,473.925934 142.013107,474.156219 141.523819,473.257477 
	C141.474197,473.166321 141.555786,472.883667 141.612442,472.872528 
	C142.573380,472.683380 143.468658,472.746185 143.869308,473.780090 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M161.134277,494.728149 
	C160.772018,494.104309 160.768768,493.542786 160.784943,492.560425 
	C161.636673,492.039917 162.435471,492.038818 163.002289,493.169373 
	C162.953766,493.691528 162.855011,493.913177 162.476776,494.368469 
	C161.962601,494.664917 161.727936,494.727692 161.134277,494.728149 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M130.958740,468.374115 
	C130.479324,468.620270 129.929703,468.596283 129.139465,468.428558 
	C129.474411,467.260223 130.105118,466.842102 130.958740,468.374115 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M100.912994,470.592346 
	C101.681030,469.480743 102.677254,469.364166 103.715157,470.282623 
	C103.028511,471.397522 102.040611,470.933990 100.912994,470.592346 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M161.742371,494.468262 
	C162.108765,494.040192 162.291351,493.916168 162.763229,493.631012 
	C163.221375,493.813019 163.390213,494.156158 163.766449,494.696503 
	C163.497726,495.271271 163.021606,495.648804 162.033508,495.754150 
	C161.533875,495.245422 161.546204,495.008881 161.742371,494.468262 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M201.287842,475.582306 
	C201.793121,475.326813 202.520416,475.235413 203.613739,475.175293 
	C203.295547,476.022797 202.454544,476.121735 201.287842,475.582306 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M173.395859,495.277710 
	C172.955994,494.897217 172.840607,494.720703 172.747116,494.228668 
	C173.216125,493.754822 173.663254,493.596466 174.457336,493.370422 
	C174.907837,493.473907 175.011398,493.645111 175.349091,494.005249 
	C174.962250,494.623383 174.341293,495.052551 173.395859,495.277710 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M179.738037,490.691315 
	C180.256592,490.040771 180.948151,489.579773 181.744858,490.280426 
	C181.465546,490.571869 181.186234,490.863342 180.592209,491.237152 
	C180.156082,491.181274 180.034637,491.042999 179.738037,490.691315 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M112.380554,464.750275 
	C112.595345,464.804535 112.606743,464.971466 112.562775,465.042938 
	C112.224716,465.090973 111.930191,465.076233 111.413811,465.069611 
	C111.338875,464.480286 111.691353,464.429077 112.380554,464.750275 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M184.843384,488.035767 
	C185.311676,487.443604 185.865036,487.124634 186.691376,486.892242 
	C186.636475,487.410950 186.308563,487.843140 185.720703,488.397278 
	C185.283340,488.449127 185.105881,488.379059 184.843384,488.035767 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M185.289566,488.325989 
	C185.054047,488.627686 184.647324,488.736145 184.240601,488.844635 
	C184.232635,488.573608 184.224655,488.302582 184.487503,487.897034 
	C184.878342,487.885925 184.998337,488.009338 185.289566,488.325989 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M58.643627,505.107025 
	C58.899666,505.511017 58.706409,505.764404 58.133705,505.928986 
	C58.033413,505.646606 58.180107,505.352020 58.643627,505.107025 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M155.884964,490.937439 
	C155.650482,491.347931 155.454651,491.379120 155.109222,491.153137 
	C155.096451,490.574677 155.233292,490.253418 155.643906,489.863922 
	C155.919647,490.049866 155.921631,490.304016 155.884964,490.937439 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M187.032288,487.033508 
	C187.225677,487.114136 186.715302,486.180817 187.141541,486.925049 
	C186.964401,486.978790 187.010620,487.014099 187.032288,487.033508 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M163.410126,503.162506 
	C163.170731,502.718750 163.306793,502.357697 163.762131,502.022064 
	C164.461761,502.565033 164.367630,502.965393 163.410126,503.162506 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M62.711388,499.187622 
	C62.865467,499.439362 62.679859,499.681000 62.181084,499.940857 
	C61.931019,499.643127 62.098946,499.382629 62.711388,499.187622 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M162.320648,504.245941 
	C162.115326,503.918182 162.245804,503.490387 162.728546,503.044464 
	C162.939346,503.399536 162.797882,503.772705 162.320648,504.245941 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M174.101715,469.296661 
	C174.170425,469.132690 174.335678,469.107849 174.748657,469.121765 
	C174.730347,469.252319 174.464294,469.344055 174.101715,469.296661 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M137.897675,468.667572 
	C137.990555,468.795654 137.499756,468.867157 137.260406,468.802124 
	C137.234924,468.417511 137.496170,468.351624 137.897675,468.667572 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M135.108612,470.328186 
	C135.014008,470.201569 135.500717,470.142212 135.740662,470.192474 
	C135.980621,470.242737 135.630325,470.538849 135.630325,470.538849 
	C135.630325,470.538849 135.203232,470.454834 135.108612,470.328186 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M124.494339,466.552948 
	C124.496918,466.578918 124.464066,466.554077 124.444336,466.551453 
	C124.424614,466.548798 124.491760,466.526978 124.494339,466.552948 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M151.903336,467.753967 
	C151.839172,468.000580 151.675507,468.096893 151.249588,468.081482 
	C151.259506,467.847748 151.531662,467.725677 151.903336,467.753967 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M1019.152100,193.910797 
	C1018.951660,194.674774 1018.950562,195.126450 1018.876160,195.793045 
	C1018.002625,196.203583 1017.362793,197.128281 1016.533936,196.878983 
	C1007.440979,194.144196 997.805908,196.219833 988.698364,193.704926 
	C987.072083,193.255844 985.479126,192.966644 983.805176,193.516907 
	C976.804260,195.818298 969.832336,194.387146 962.875122,193.244049 
	C961.766235,193.061844 960.518494,191.875198 959.588745,192.672134 
	C955.824097,195.898972 952.407288,193.913940 948.505859,192.839020 
	C945.021667,191.879013 941.137634,193.671631 937.378784,193.315536 
	C933.204224,192.920044 928.688599,193.962845 925.061646,190.098511 
	C924.685364,178.354019 923.682190,166.985092 925.792725,155.339447 
	C927.888123,159.680420 926.598083,164.523666 927.006592,169.264771 
	C927.183105,171.314316 926.529724,173.483688 927.878235,176.074600 
	C929.641357,173.076157 931.137451,170.576843 932.645386,168.145370 
	C934.886230,164.532242 936.525452,165.380890 938.579773,167.776154 
	C937.928528,170.023727 935.370544,167.489105 934.969727,169.644470 
	C934.719421,170.990036 931.959656,171.666534 933.635254,173.305115 
	C934.748230,174.393631 936.032471,172.906784 937.105774,172.258545 
	C937.806152,171.835526 938.334412,171.137085 939.004944,170.652252 
	C939.695679,170.152878 940.547485,169.799118 941.268188,170.484329 
	C942.116882,171.291046 941.386353,172.002548 940.854736,172.595917 
	C939.967712,173.585876 938.971375,174.478149 938.089905,175.472610 
	C937.297241,176.366974 936.460999,177.558273 937.699463,178.472916 
	C938.978210,179.417252 940.599426,180.401672 942.078918,180.414230 
	C943.309021,180.424683 942.784302,179.032654 942.184204,178.141510 
	C939.571472,174.261551 943.966125,173.283707 945.147766,173.652908 
	C948.516785,174.705536 950.924011,173.802109 953.323975,171.804459 
	C953.951904,171.281830 954.832825,171.262833 955.030518,171.813004 
	C955.904846,174.246170 956.282593,177.107391 960.069214,175.845688 
	C957.743225,181.533585 961.866394,179.116302 964.337646,179.678406 
	C966.016052,180.060181 967.977783,183.892395 969.272461,182.074844 
	C971.049866,179.579437 966.408203,179.379868 965.528625,177.039810 
	C966.965332,176.099197 968.495667,175.056625 970.070190,174.085739 
	C970.735107,173.675705 971.515808,172.902084 972.287720,173.584961 
	C973.283630,174.466095 972.038269,175.383438 972.035645,176.664673 
	C975.452759,174.188034 979.697754,177.380859 983.498596,175.421173 
	C984.963867,174.665726 985.019165,176.855621 983.952881,178.013840 
	C983.355530,178.662750 982.828674,179.364441 983.421570,180.173996 
	C984.136902,181.150742 984.924316,180.450699 985.522400,179.948334 
	C987.199280,178.539795 988.185730,179.808563 989.332397,180.779739 
	C990.506226,181.773788 991.772034,182.846039 993.138733,180.064453 
	C995.022949,178.370575 996.669434,177.298065 998.443115,175.356995 
	C1000.759277,175.396210 1005.352112,174.134735 1000.853882,178.187866 
	C1000.196533,178.780151 999.742920,179.612076 1000.518250,180.290680 
	C1001.585999,181.225266 1002.287415,180.114655 1002.958191,179.503052 
	C1005.773315,176.936234 1007.720337,173.146622 1012.614990,172.999680 
	C1013.701538,176.219955 1016.330566,174.553955 1018.523071,175.026825 
	C1018.929504,175.465088 1018.934570,175.892166 1018.930908,176.639893 
	C1018.494263,177.421738 1018.096191,177.890488 1018.731445,178.796326 
	C1018.952271,181.082077 1018.957581,183.137650 1018.942444,185.633820 
	C1018.048157,187.817337 1018.624695,189.656830 1018.777100,191.723175 
	C1018.990479,191.992477 1019.016052,192.465637 1019.014404,192.702560 
	C1019.125610,193.159164 1019.238525,193.378830 1019.152100,193.910797 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M926.372437,142.144073 
	C926.596436,142.471252 926.481323,142.736038 926.323853,143.214722 
	C926.092041,143.950500 925.913147,144.477005 925.723267,145.283844 
	C925.647400,145.808502 925.582458,146.052795 925.151245,146.210190 
	C923.606384,145.234451 922.731140,143.944565 921.285095,143.411987 
	C911.235840,139.710800 901.476074,135.242188 890.860413,132.082748 
	C889.485413,132.100601 888.499146,132.012955 887.376038,131.144531 
	C887.120361,130.867859 887.045166,130.850159 887.019287,130.878433 
	C888.269470,128.201202 889.912415,127.617828 892.906128,128.868439 
	C903.870850,133.448883 914.972595,137.701202 926.372437,142.144073 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M924.706055,146.332916 
	C925.053711,145.981033 925.328918,145.686142 925.520630,145.625183 
	C925.828552,148.408234 925.944702,151.252258 926.105591,154.557587 
	C926.088379,166.693283 926.026489,178.367661 925.994385,190.508331 
	C930.443726,196.023743 927.171265,201.340683 926.226929,206.894043 
	C925.567810,207.200607 925.248718,207.177811 924.613037,206.787598 
	C923.234619,204.432846 923.324280,202.257080 923.320068,200.114410 
	C923.288879,184.400330 923.287903,168.686203 923.320618,152.972122 
	C923.325073,150.829849 923.233093,148.651321 924.706055,146.332916 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M977.720093,148.819366 
	C977.944092,149.359604 977.992615,149.967087 977.921936,149.981277 
	C974.617737,150.644958 970.763306,152.575500 968.142334,151.502396 
	C965.546448,150.439575 969.900208,148.633087 970.138000,146.574005 
	C970.351807,144.722290 971.721802,144.794952 973.007568,145.993683 
	C974.080750,146.994232 975.215759,147.928467 976.664307,148.947845 
	C977.166504,148.872375 977.327759,148.741104 977.720093,148.819366 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M951.996826,155.372681 
	C953.065491,154.999573 954.133484,155.002182 955.601929,155.001175 
	C955.449524,157.689941 957.746094,158.640747 959.120178,160.182297 
	C959.899292,161.056442 961.877197,161.874969 960.383240,163.270599 
	C959.174988,164.399353 958.629150,162.531937 957.813293,161.871643 
	C956.164490,160.537216 954.409363,159.334152 952.350220,158.039597 
	C952.000305,157.250992 951.998169,156.499695 951.996826,155.372681 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M964.371216,158.008972 
	C964.578979,156.204727 961.112976,155.039810 962.989319,153.364258 
	C964.236023,152.250977 965.072388,154.387985 966.175049,154.908752 
	C967.908081,155.727310 970.481323,157.077057 969.513733,158.908279 
	C968.000244,161.772232 966.626953,157.196533 964.371216,158.008972 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M988.010925,155.382568 
	C989.930603,155.489059 990.888977,153.766891 992.659058,153.056244 
	C993.004456,153.003632 993.000000,153.000000 992.997803,152.998047 
	C992.991760,153.742371 992.987915,154.488647 993.001038,155.628754 
	C993.952637,156.262100 995.431030,156.725266 994.049316,157.711380 
	C991.494385,159.534805 988.800537,160.192490 988.010925,155.382568 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M942.989868,147.361938 
	C944.641663,147.176178 946.856567,146.340256 946.988892,149.614807 
	C946.502747,150.023209 946.008057,150.066010 945.513123,150.070099 
	C943.740601,150.084732 943.408325,153.633026 941.726746,152.308044 
	C939.680176,150.695374 943.670410,149.627457 942.989868,147.361938 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M993.616211,177.277344 
	C993.615417,174.132843 995.291565,172.384842 998.634644,172.005936 
	C998.997559,172.748993 998.997559,173.500107 998.997559,174.626831 
	C998.997559,175.002441 999.000000,175.000000 999.001221,174.998779 
	C997.625427,176.248245 996.136597,177.290039 993.616211,177.277344 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M934.998169,150.001968 
	C936.414856,149.442719 937.833313,148.881500 939.437988,148.246613 
	C937.806396,153.258621 937.616760,153.352676 935.041626,150.329803 
	C935.003418,149.996231 935.000000,150.000000 934.998169,150.001968 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M998.659668,159.035995 
	C999.084473,161.846024 998.005127,163.388184 994.747681,162.753128 
	C995.193909,160.655090 996.600342,159.713837 998.659668,159.035995 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M993.001221,179.998657 
	C991.105042,179.729828 989.234253,178.916763 989.558105,176.839920 
	C989.778381,175.427078 991.379517,176.280899 992.691711,176.867661 
	C993.002441,177.003632 993.000000,177.000000 992.998779,176.998657 
	C993.577820,177.684387 993.729309,178.458588 993.233154,179.659698 
	C992.997559,180.002899 993.000000,180.000000 993.001221,179.998657 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1005.364075,163.993698 
	C1005.008118,163.252060 1005.011292,162.499893 1005.005005,161.376221 
	C1006.064636,161.004562 1007.133667,161.004395 1008.598999,160.999985 
	C1008.867798,163.046509 1007.729492,163.990173 1005.364075,163.993698 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1008.994507,152.624207 
	C1007.727722,152.895218 1005.941223,153.278992 1005.735291,151.579102 
	C1005.555664,150.096436 1007.163757,150.108765 1008.655212,150.007401 
	C1009.002441,150.002777 1009.000000,150.000000 1008.998779,149.998611 
	C1008.993774,150.748764 1008.989929,151.500305 1008.994507,152.624207 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1009.002258,161.002167 
	C1009.006348,160.252594 1009.008179,159.500885 1009.003784,158.375824 
	C1010.016907,158.133499 1011.373047,157.728546 1011.713806,159.147690 
	C1012.088501,160.708221 1010.861145,160.864731 1009.363464,160.984314 
	C1008.995300,160.995728 1009.000000,161.000000 1009.002258,161.002167 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M945.726196,168.836914 
	C944.842163,170.007019 943.963745,170.106140 943.382996,169.053101 
	C943.181396,168.687546 943.451965,167.667633 943.804688,167.465118 
	C944.809570,166.888077 945.577759,167.301529 945.726196,168.836914 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M938.658447,159.772736 
	C938.855652,161.587173 939.135986,163.605713 936.194458,162.237167 
	C935.608887,161.590134 935.471191,161.132370 935.786499,160.302826 
	C936.009888,160.000198 935.999695,159.999283 935.999878,160.004639 
	C936.684326,159.422943 937.458435,159.273346 938.658447,159.772736 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M938.989563,159.642334 
	C938.250000,160.008118 937.500000,160.005325 936.375000,160.006271 
	C936.115417,158.983337 935.735840,157.636261 937.151123,157.295425 
	C938.709351,156.920181 938.876160,158.138382 938.989563,159.642334 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M947.014648,150.370865 
	C947.752563,149.997482 948.502625,149.993134 949.627930,149.992676 
	C950.003479,150.748138 950.003906,151.499725 950.003357,152.627106 
	C948.416931,153.029144 946.990234,152.846542 947.014648,150.370865 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M998.998535,156.376114 
	C999.983826,156.159958 1001.452759,155.582840 1001.572754,157.200333 
	C1001.649841,158.239868 1000.646179,158.707321 999.336060,158.959030 
	C998.995117,158.995407 999.000000,159.000000 999.002441,159.002426 
	C999.003113,158.252762 999.001343,157.500687 998.998535,156.376114 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M999.001282,155.998322 
	C997.480042,155.912369 996.388367,155.283264 996.036499,153.336594 
	C996.003662,152.996063 996.000000,153.000000 995.997925,153.001984 
	C997.612244,152.934433 999.018982,153.142410 998.989990,155.632080 
	C998.997375,156.003632 999.000000,156.000000 999.001282,155.998322 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M990.052856,147.341522 
	C991.136047,147.058594 992.431213,146.773453 992.953369,148.657898 
	C991.860046,148.958725 990.589905,149.187927 990.052856,147.341522 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M951.998779,157.998779 
	C951.908447,158.880142 952.247131,159.935883 951.204590,160.444977 
	C951.017639,160.536270 950.344971,160.115051 950.246216,159.815247 
	C949.943298,158.896072 950.529480,158.395035 951.672241,158.055511 
	C952.002441,158.002289 952.000000,158.000000 951.998779,157.998779 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M948.780029,165.803070 
	C948.153259,166.747330 947.575623,166.674927 947.289490,165.922592 
	C947.157593,165.575851 947.337585,164.817337 947.609802,164.666122 
	C948.370789,164.243362 948.722351,164.789780 948.780029,165.803070 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M987.998779,155.000916 
	C987.104553,154.925430 986.045288,155.247910 985.539612,154.191772 
	C985.450012,154.004578 985.879578,153.335236 986.182129,153.237579 
	C987.097107,152.942276 987.628174,153.493423 987.955078,154.664551 
	C988.002441,154.998169 988.000000,155.000000 987.998779,155.000916 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M999.001221,172.001190 
	C999.002686,171.243393 999.002930,170.484406 999.004028,169.345947 
	C999.407349,168.642395 999.860962,168.510208 1000.677979,168.817719 
	C1000.939697,170.164917 1001.174255,171.422058 999.338257,171.943970 
	C998.997559,171.997894 999.000000,172.000000 999.001221,172.001190 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1001.211426,168.838989 
	C1000.542480,169.021561 1000.103088,169.009109 999.334290,168.981567 
	C999.160400,167.914398 999.482422,166.958557 1000.814514,167.196014 
	C1001.575684,167.331696 1001.841492,167.896408 1001.211426,168.838989 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M932.999878,153.000381 
	C933.817932,153.454880 934.733093,153.857956 934.568176,155.032837 
	C934.540649,155.228928 934.128601,155.550934 933.951904,155.516769 
	C932.884705,155.310333 933.132202,154.375275 933.004578,153.324310 
	C933.000305,152.998779 933.000000,153.000000 932.999878,153.000381 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M964.002441,158.002228 
	C963.879883,158.969437 963.686157,159.899567 962.416443,159.837738 
	C962.177002,159.826065 961.741333,159.532715 961.751770,159.396698 
	C961.826050,158.432556 962.613403,158.241623 963.684814,158.024078 
	C963.995117,157.995728 964.000000,158.000000 964.002441,158.002228 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M989.460327,150.615692 
	C989.687683,151.418839 989.409485,151.712250 988.783813,151.587204 
	C988.654053,151.561264 988.479736,151.378098 988.459778,151.246994 
	C988.363708,150.616806 988.669250,150.352081 989.460327,150.615692 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1006.038635,144.305801 
	C1006.448242,144.001266 1006.891541,143.998337 1007.667480,143.997711 
	C1007.767883,144.524551 1007.669800,145.308746 1007.272766,145.513733 
	C1006.652344,145.834015 1006.239502,145.239502 1006.038635,144.305801 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M1013.001221,173.001221 
	C1013.091797,172.373993 1013.095947,171.661728 1013.903198,171.518250 
	C1014.072937,171.488083 1014.311218,171.843765 1014.517944,172.021698 
	C1014.198303,172.322433 1013.878662,172.623123 1013.278320,172.960754 
	C1012.997559,172.997681 1013.000000,173.000000 1013.001221,173.001221 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1004.997925,163.997726 
	C1004.904541,164.628357 1004.911011,165.352585 1004.091064,165.496124 
	C1003.918762,165.526291 1003.678101,165.166061 1003.468994,164.985718 
	C1003.792053,164.682755 1004.115051,164.379807 1004.721497,164.040558 
	C1005.004883,164.004242 1005.000000,164.000000 1004.997925,163.997726 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1008.998535,153.001617 
	C1009.629517,153.097473 1010.353882,153.093979 1010.495300,153.913773 
	C1010.524902,154.085388 1010.162659,154.324615 1009.980957,154.532684 
	C1009.676941,154.209976 1009.372925,153.887268 1009.035889,153.280563 
	C1009.002930,152.996567 1009.000000,153.000000 1008.998535,153.001617 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M941.457764,164.614456 
	C941.685303,165.416901 941.404297,165.706726 940.781799,165.583878 
	C940.652344,165.558319 940.477966,165.375366 940.458191,165.244659 
	C940.362854,164.615692 940.668457,164.352020 941.457764,164.614456 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M935.711426,160.037842 
	C936.003662,160.440063 935.997375,160.879929 935.983887,161.649200 
	C935.463501,161.745895 934.688904,161.641464 934.497375,161.250992 
	C934.195251,160.635132 934.795166,160.240234 935.711426,160.037842 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1009.001221,157.998810 
	C1008.378357,157.895706 1007.659912,157.896240 1007.516785,157.088776 
	C1007.486877,156.919708 1007.843567,156.682144 1008.022095,156.476151 
	C1008.321472,156.797714 1008.620850,157.119293 1008.958862,157.721680 
	C1008.997559,158.002502 1009.000000,158.000000 1009.001221,157.998810 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1005.002441,160.997787 
	C1004.374512,160.901993 1003.652588,160.906158 1003.511597,160.088821 
	C1003.482056,159.917694 1003.842346,159.679352 1004.022949,159.471985 
	C1004.325134,159.794083 1004.627319,160.116196 1004.962524,160.721512 
	C1004.995544,161.004715 1005.000000,161.000000 1005.002441,160.997787 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M950.036255,153.318665 
	C950.915039,153.060135 951.701355,153.308212 951.960144,154.681213 
	C951.092468,154.927246 950.299927,154.685333 950.036255,153.318665 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M950.358887,169.248566 
	C950.373596,169.007385 950.504395,168.875793 950.635132,168.744202 
	C950.581726,168.948853 950.528320,169.153503 950.358887,169.248566 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1015.001282,156.001831 
	C1014.657349,156.250946 1014.312134,156.498260 1013.966858,156.745560 
	C1013.880310,156.623550 1013.793823,156.501572 1013.707275,156.379578 
	C1013.978149,156.260345 1014.249023,156.141098 1014.757568,156.009033 
	C1014.995300,155.996201 1015.000000,156.000000 1015.001282,156.001831 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M1013.268311,151.400330 
	C1013.145203,151.555649 1012.933716,151.577866 1012.722168,151.600067 
	C1012.874756,151.489090 1013.027344,151.378143 1013.268311,151.400330 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M947.468140,171.451355 
	C947.522400,171.419327 947.413940,171.483368 947.468140,171.451355 
z"/>
<path fill="#90A4B0" opacity="1.000000" stroke="none" 
	d="
M977.970886,148.770966 
	C977.951172,149.028900 977.478210,149.013351 977.241699,149.008514 
	C977.105042,148.680038 977.292603,148.419601 977.786133,148.112686 
	C978.004395,148.003036 978.000000,148.000000 977.997559,147.997833 
	C977.993591,148.168106 977.992126,148.340561 977.970886,148.770966 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M94.206657,522.058716 
	C93.508987,522.185730 93.121880,522.182251 92.447258,522.222412 
	C91.311226,522.028259 90.743568,521.401001 89.934494,520.572388 
	C89.614197,520.143127 89.506226,519.955627 89.302498,519.455811 
	C88.871498,516.675720 90.423042,515.058228 91.999924,513.111206 
	C92.970879,511.875214 93.686363,510.862946 93.833374,509.233276 
	C93.961426,508.479431 94.082420,508.056580 94.397537,507.343994 
	C94.725006,506.888702 94.890305,506.732086 95.370651,506.441010 
	C96.323517,505.464142 99.471336,508.887177 98.256973,504.753510 
	C97.932358,503.648468 98.772331,502.551178 99.577919,501.286194 
	C99.817558,500.782593 99.920662,500.584900 100.201859,500.105469 
	C100.515907,499.649475 100.651863,499.475159 101.014542,499.062469 
	C101.402977,498.679321 101.564697,498.534485 101.975250,498.185425 
	C102.918701,497.480591 103.523125,496.910553 103.834450,495.725433 
	C104.195763,494.800385 104.545921,494.252472 105.415565,493.763977 
	C106.604958,493.868286 107.432457,494.183044 108.586060,494.569794 
	C111.793884,495.166077 113.408058,496.278107 110.727829,499.349426 
	C114.679886,499.134796 116.239960,493.379242 121.005630,495.890503 
	C121.843872,497.349609 121.451714,498.432556 120.692162,499.349487 
	C115.248032,505.921570 109.651283,512.375916 105.398537,519.839478 
	C105.165764,520.248047 104.612762,520.409668 103.777634,520.514160 
	C100.142944,519.024170 97.428711,521.088196 94.206657,522.058716 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M62.192032,521.724976 
	C61.088802,522.653137 61.135849,523.328674 61.546001,524.436035 
	C61.934830,525.485718 63.178501,529.094910 59.758587,525.790649 
	C59.601616,525.638977 59.179684,525.506836 59.071312,525.596191 
	C54.888298,529.044617 55.263245,524.203308 53.956947,522.075195 
	C54.108406,521.436951 54.329014,521.001404 54.471451,520.804993 
	C54.819027,520.363525 55.027542,520.121338 55.379913,519.692505 
	C55.698990,519.243591 55.868912,518.978638 56.145592,518.499084 
	C56.261017,518.289978 56.513626,517.881470 56.656815,517.687622 
	C56.799999,517.493713 57.112919,517.124634 57.445827,516.770142 
	C57.778736,516.415649 58.120804,516.065308 58.463509,515.711792 
	C58.806210,515.358276 59.137768,514.991394 59.434650,514.593140 
	C59.816635,514.050659 59.901733,513.906372 60.110561,513.541504 
	C60.321751,513.175781 60.409206,513.030640 60.643959,512.678223 
	C60.897987,512.339783 61.004723,512.208679 61.449989,511.704041 
	C61.905121,511.211060 62.021721,511.091614 62.316170,510.797302 
	C62.732288,510.391998 62.973377,510.164612 63.392975,509.764893 
	C63.805984,509.356903 64.045898,509.126923 64.464439,508.719788 
	C64.879501,508.299011 65.119507,508.059082 65.537643,507.630219 
	C65.956230,507.184692 66.198875,506.930206 66.622070,506.474426 
	C67.046936,505.998840 67.292305,505.725586 67.717148,505.232391 
	C68.390465,504.414124 68.873924,503.807434 69.559753,502.974487 
	C70.506058,502.039398 71.370995,501.471252 72.322617,500.514954 
	C72.859818,499.984619 73.181900,499.692230 73.776108,499.199585 
	C76.781052,498.182739 78.962097,495.745422 82.295990,496.508118 
	C82.341362,500.095734 79.477821,501.440643 77.673370,503.503479 
	C75.376076,506.129700 72.555794,508.275879 70.420593,511.456238 
	C70.224449,511.930756 70.140907,512.114380 69.918274,512.554932 
	C69.675926,512.967407 69.572670,513.122925 69.102829,513.649780 
	C68.736252,514.021179 68.308266,514.238831 68.089249,514.293457 
	C67.870232,514.348083 67.994141,514.783875 68.183151,514.639832 
	C68.537941,514.520447 68.703712,514.545044 69.080612,514.730225 
	C69.378242,515.054321 69.464729,515.217773 69.598999,515.663574 
	C69.625275,516.345886 69.518356,516.723206 69.140862,517.316406 
	C68.046631,518.171265 67.001640,518.294922 65.663864,518.491211 
	C63.764671,518.918396 63.641670,520.751221 62.192032,521.724976 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M83.517288,525.903259 
	C86.462860,525.556824 89.047058,528.027405 92.079094,526.461853 
	C89.768181,529.353699 96.071609,533.295105 90.594131,535.605408 
	C91.820724,536.821167 93.652077,535.609009 94.985985,536.444580 
	C95.584526,538.000000 92.869370,537.388184 93.341209,539.378967 
	C93.897827,541.727478 92.494324,541.563904 90.914978,540.382568 
	C86.351562,536.969421 82.043762,533.089905 76.207794,531.866455 
	C76.325371,531.406616 76.442955,530.946838 76.712784,530.216248 
	C78.528984,528.720642 79.060181,526.334656 81.595901,525.553345 
	C82.405853,525.425598 82.870598,525.481445 83.517288,525.903259 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M82.092140,526.248474 
	C79.803398,526.777344 79.479683,529.413513 77.194016,529.945801 
	C77.347824,528.168762 77.830627,526.392029 78.502670,524.258667 
	C77.826866,522.282776 78.853531,520.972534 79.532600,519.299805 
	C79.767021,518.835693 79.866112,518.655151 80.128410,518.218872 
	C80.409836,517.803589 80.528061,517.644043 81.011230,517.031128 
	C81.604095,516.268250 81.821335,515.951416 82.168472,515.369141 
	C82.414185,514.942017 82.517883,514.772034 82.797409,514.356262 
	C83.232368,513.783447 83.499802,513.463379 83.991486,512.901367 
	C85.938454,510.381622 89.315178,509.298889 89.276215,505.370178 
	C90.057365,502.118347 92.395599,500.148834 93.800583,497.248474 
	C93.989494,496.711945 94.070213,496.497772 94.296860,495.969910 
	C95.113396,494.763153 95.573570,493.505707 97.349564,494.363037 
	C98.131363,495.942047 98.948364,496.813904 100.889130,496.386566 
	C101.447586,496.479584 101.664001,496.557404 102.120773,496.884613 
	C102.520287,497.580719 102.530266,498.033112 102.167725,498.737427 
	C101.922447,498.984497 101.984711,499.004028 101.982697,498.971466 
	C101.784859,499.199554 101.566360,499.439606 101.137604,499.814636 
	C100.950005,499.970215 100.994583,499.949249 100.970367,499.943726 
	C99.031792,502.072113 98.152328,505.071289 95.175262,506.748108 
	C94.917435,506.963928 94.977676,506.999817 94.973190,506.965027 
	C94.778160,507.210052 94.630203,507.511108 94.498169,508.083191 
	C94.453972,508.503876 94.430267,508.671783 94.312393,509.076538 
	C94.136620,509.462555 94.055000,509.611694 93.642654,510.144226 
	C93.191849,510.643860 93.071777,510.760071 92.766510,511.041809 
	C92.581329,511.207306 92.203453,511.521606 92.015419,511.675659 
	C91.580620,512.034607 91.344696,512.251221 90.966095,512.662964 
	C90.812569,512.846313 90.511986,513.218628 90.360382,513.403442 
	C90.208786,513.588257 89.904144,513.955261 89.618027,514.335205 
	C89.331902,514.715149 89.079773,515.124512 88.694557,515.768066 
	C88.206841,516.549316 88.104332,516.687134 87.691925,517.238770 
	C87.290482,517.798157 87.198929,517.943665 86.980682,518.313171 
	C86.771553,518.686890 86.689110,518.836609 86.481995,519.208862 
	C86.194534,519.729431 86.034729,520.028870 85.768242,520.561523 
	C85.574425,520.942566 85.490746,521.092346 85.262772,521.456116 
	C85.016670,521.809509 84.914856,521.948914 84.496971,522.503174 
	C83.927452,523.157532 83.679085,523.402283 83.291275,523.870239 
	C83.013084,524.267822 82.878777,524.446655 82.511871,524.867188 
	C82.515137,525.321594 82.586311,525.523865 82.492188,525.715454 
	C82.400589,525.901855 82.311150,525.994873 82.092140,526.248474 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M69.424606,515.482666 
	C69.134048,515.153381 68.905472,515.118713 68.334282,515.030396 
	C67.864311,514.812317 67.736961,514.647766 67.785316,514.225403 
	C67.961029,513.967529 67.996201,514.000000 67.982193,513.981934 
	C68.241982,513.796021 68.477196,513.585022 68.825226,513.147339 
	C68.976616,512.963684 68.996307,513.003235 68.979126,512.988770 
	C69.236420,512.684143 69.563713,512.482361 70.245850,512.389893 
	C70.727005,512.449768 70.914398,512.502625 71.366425,512.671997 
	C72.304482,513.117432 73.060265,513.257446 73.872910,513.828003 
	C74.108444,514.280396 74.239113,514.474121 74.447800,514.550659 
	C74.340851,514.301270 74.179008,514.091248 73.769516,513.706421 
	C73.131882,510.848114 75.407440,509.770813 76.902100,507.867035 
	C77.285957,507.459717 77.442436,507.298187 78.088966,506.661438 
	C79.271927,505.565491 79.987701,504.976746 81.181091,504.487885 
	C82.905899,504.355255 83.700806,505.179077 84.442558,506.602051 
	C84.885986,508.339996 84.350548,509.436707 83.238327,510.251129 
	C81.829994,511.282379 82.890312,512.182495 83.399948,513.461243 
	C83.446014,514.022766 83.417633,514.249695 83.196213,514.760376 
	C83.003189,515.044128 82.988617,514.992554 83.015152,514.988770 
	C82.569733,515.403015 82.496895,515.997986 82.178299,516.799988 
	C82.012070,517.042236 81.995880,516.996765 82.019913,516.999146 
	C81.787682,517.204224 81.548676,517.425598 81.170151,517.853271 
	C81.013359,518.040894 80.996925,517.991150 81.023148,517.990601 
	C79.443367,519.239380 79.168404,521.439270 77.334213,522.844910 
	C72.821716,523.200806 70.059067,518.918884 65.434875,519.459473 
	C64.942307,519.245300 64.808960,518.966492 64.952667,518.315918 
	C66.322685,517.625000 67.415657,517.305908 68.852211,516.953186 
	C69.399971,516.566101 69.502159,516.186707 69.424606,515.482666 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M102.769676,520.516602 
	C107.289520,515.651062 110.014282,509.865875 114.176910,505.033447 
	C116.484032,502.355164 119.577850,500.162994 121.232758,496.223511 
	C122.112671,495.748199 122.395531,495.350830 122.705101,494.531982 
	C124.225716,492.351288 126.488144,491.826599 128.679199,490.571838 
	C129.233124,490.426208 129.463715,490.401184 130.038116,490.441040 
	C133.070236,492.903625 130.377701,494.055359 128.968628,495.797607 
	C127.898842,496.756165 126.961304,497.337067 125.904251,498.282166 
	C125.349289,498.772491 125.023720,499.038696 124.446487,499.484314 
	C123.565193,500.156494 122.865005,500.564453 122.178802,501.442505 
	C121.866104,501.824799 121.737350,501.974213 121.405182,502.336426 
	C120.924858,502.823029 120.650391,503.099243 120.193710,503.604156 
	C119.892189,503.988373 119.775429,504.146393 119.495071,504.552643 
	C119.013000,505.319519 118.693138,505.837372 118.212807,506.629395 
	C116.338707,508.853729 114.713539,510.861267 113.669754,513.633423 
	C112.926643,514.792419 112.256622,515.618530 111.739143,516.909302 
	C110.942719,518.301636 110.281631,519.404175 109.523071,520.830078 
	C108.335236,522.387451 106.865280,522.946289 105.168434,523.767212 
	C103.492561,523.851379 103.537834,522.572083 103.001251,521.432861 
	C102.802383,520.978149 102.650253,520.830322 102.769676,520.516602 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M32.580223,534.403320 
	C28.534079,535.569763 24.457983,535.083008 19.982878,534.296997 
	C25.084921,530.901184 30.186964,527.505310 35.639046,524.105164 
	C37.100445,525.005859 37.637012,526.327759 38.617393,527.757812 
	C38.987091,528.140625 39.168034,528.230225 39.620110,528.367065 
	C38.684746,530.739990 35.960861,531.429871 34.240387,533.695312 
	C33.789967,534.247681 33.504650,534.475098 32.920364,534.506226 
	C32.674900,534.375488 32.608250,534.384705 32.580223,534.403320 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M56.119736,520.088684 
	C55.919376,520.573425 55.816589,520.723267 55.549057,520.911072 
	C55.051998,521.120544 54.708397,521.319763 54.206856,521.808716 
	C54.014660,522.039429 53.979527,521.972290 54.007149,521.946899 
	C52.577587,522.875854 51.289093,521.139465 49.420433,521.745483 
	C48.397251,521.942749 47.827415,522.100403 47.007538,522.450806 
	C45.397987,523.140869 43.624268,522.528625 42.292656,523.876099 
	C41.830006,523.558350 41.707355,523.404419 41.598801,522.670044 
	C41.725677,521.927429 41.838455,521.765381 42.173882,521.410095 
	C42.711346,520.984497 43.025509,520.751282 43.556854,520.319458 
	C43.916225,519.982849 44.057835,519.844116 44.642670,519.295898 
	C45.721218,518.359924 46.219704,517.701965 47.006195,516.883789 
	C47.519337,516.350708 47.831104,516.062805 48.391533,515.567505 
	C49.120136,514.912292 49.603863,514.468384 50.685280,513.720276 
	C51.512428,513.405701 51.737350,513.390259 52.292603,513.437988 
	C55.494915,515.375366 56.764027,512.630737 58.805450,511.208252 
	C59.039581,510.979553 58.980328,510.979797 58.975140,511.008972 
	C59.569668,510.545715 60.322666,510.216064 60.844341,509.214508 
	C61.028130,508.983337 60.985989,508.986877 60.987015,509.007996 
	C61.335247,508.707703 61.741638,508.496582 62.547028,508.329590 
	C63.126438,508.328308 63.357250,508.376770 63.885887,508.618530 
	C64.273880,509.031067 64.364044,509.250366 64.228584,509.744568 
	C63.885830,510.327484 63.697598,510.583099 63.225227,510.897766 
	C62.784420,511.238495 62.550842,511.461792 62.153000,511.862396 
	C61.994541,512.045776 61.989597,511.990356 62.017395,511.990997 
	C61.787823,512.203918 61.544758,512.431519 61.146107,512.857544 
	C60.976227,513.040771 60.972984,512.978027 61.003838,512.972229 
	C60.574715,513.399841 60.496540,513.999817 60.163963,514.805420 
	C59.990654,515.046387 59.984692,514.987976 60.013931,514.985413 
	C59.791573,515.198914 59.551785,515.427368 59.162201,515.856934 
	C59.000587,516.045654 58.994511,515.993958 59.020149,515.998291 
	C58.785896,516.206482 58.543861,516.429626 58.157898,516.858887 
	C57.996124,517.045715 57.990871,516.991394 58.018135,516.992798 
	C57.788303,517.203369 57.546619,517.429138 57.157181,517.858337 
	C56.994011,518.045349 56.984840,517.988770 57.013268,517.984985 
	C56.479622,518.451904 56.496284,519.172485 56.119736,520.088684 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M105.235443,523.936523 
	C105.868507,522.911255 106.856667,521.888489 108.119476,520.716431 
	C108.651451,520.553711 108.908760,520.540405 109.529137,520.656128 
	C115.195396,522.315796 120.556564,521.620056 126.303207,521.273682 
	C126.932869,521.469482 127.169823,521.593872 127.505508,522.107422 
	C127.398079,523.053223 127.191917,523.609863 126.922806,524.457275 
	C125.239807,524.918518 123.621742,525.210083 121.999321,525.236755 
	C117.232574,525.315369 112.031639,523.798645 108.434738,529.054321 
	C107.709702,529.014404 107.428123,528.860474 107.093002,528.346436 
	C107.423477,527.675476 107.794510,527.156555 107.943977,526.175354 
	C107.910416,524.295532 106.885551,523.950317 105.235443,523.936523 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M28.325645,558.115112 
	C23.373678,552.467773 18.650803,546.978149 15.149688,540.225159 
	C15.785414,538.310303 16.703787,539.130737 17.419136,540.136047 
	C18.457479,541.595337 19.350273,543.158142 20.590168,544.842468 
	C23.557858,548.732666 26.240530,552.457275 29.073687,556.484741 
	C29.401096,557.367615 29.235159,557.822266 28.325645,558.115112 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M92.396141,512.633179 
	C92.479301,515.304077 89.713211,516.511108 89.915756,519.550110 
	C89.906326,519.917480 89.712189,520.251709 89.582664,520.395020 
	C89.453140,520.538330 89.193565,520.824402 89.327759,520.684204 
	C89.461960,520.544006 89.754944,520.289001 89.927887,520.200684 
	C91.045311,520.218750 91.890205,520.456299 92.105774,521.929932 
	C89.986992,524.336792 87.145859,523.808533 84.256592,524.096436 
	C83.606438,523.574158 83.479736,523.114929 83.785217,522.274170 
	C83.985260,521.956848 84.003647,522.002441 83.979187,522.000000 
	C84.214836,521.792664 84.457458,521.568848 84.847527,521.141296 
	C85.012451,520.956421 85.019081,521.014832 84.990021,521.019287 
	C85.426155,520.599548 85.503448,520.005188 85.820518,519.200073 
	C85.986542,518.956970 86.006302,519.002991 85.981255,519.004395 
	C86.437157,518.592896 86.502411,517.993286 86.831421,517.195679 
	C87.001244,516.955444 87.010513,517.008545 86.983574,517.009644 
	C87.210068,516.798950 87.449837,516.572632 87.836334,516.143494 
	C87.996727,515.955139 88.004601,516.006775 87.978760,516.003113 
	C88.082047,515.842712 88.211174,515.685974 88.417938,515.249512 
	C88.559525,514.791992 88.623459,514.614197 88.842087,514.198853 
	C88.996765,513.961365 89.007484,514.005981 88.984535,514.005127 
	C89.214027,513.794678 89.452553,513.570251 89.838715,513.145996 
	C90.000252,512.960815 90.004936,513.006104 89.982780,513.000854 
	C90.470215,512.473450 91.084244,512.224365 92.396141,512.633179 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M61.364746,580.094727 
	C61.143166,578.851440 61.243603,577.723328 61.572670,576.342529 
	C62.123920,576.335449 62.482418,576.396667 63.155167,576.239746 
	C67.637695,575.202148 64.084076,571.767700 65.318680,569.470947 
	C65.167900,568.614685 65.130569,568.173035 65.125854,567.398193 
	C65.488014,566.683411 65.903107,566.522278 66.674149,566.815857 
	C67.404167,571.207520 67.863831,575.364929 68.424026,579.937744 
	C68.738510,580.404846 68.952438,580.456482 68.836655,580.524536 
	C67.883797,580.811401 67.260651,581.081848 66.313248,581.206482 
	C64.669701,580.196777 63.379204,579.187134 61.364746,580.094727 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M59.812965,544.764954 
	C64.681999,549.308350 66.180298,554.949585 66.267868,561.495911 
	C65.949974,562.058472 65.772789,562.197266 65.323303,562.136475 
	C64.177795,556.350403 63.079151,550.842346 59.379944,545.873047 
	C59.259846,545.296021 59.324688,545.020996 59.812965,544.764954 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M97.354187,571.962524 
	C98.270287,573.973206 98.797974,575.757141 97.012848,577.614441 
	C96.978783,577.927673 96.866966,578.101440 96.799385,578.179565 
	C96.394135,578.557007 96.018410,578.795105 95.266220,579.011719 
	C94.933609,579.060730 94.596931,578.821777 94.411728,578.730530 
	C94.206711,578.265137 94.186905,577.891052 93.996933,577.289917 
	C93.064713,575.978516 92.941780,574.850891 93.930710,573.365295 
	C94.944664,572.030701 94.965080,569.556580 97.354187,571.962524 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M41.662468,521.702393 
	C42.055290,522.331604 42.053486,522.728333 42.002174,523.418640 
	C40.960594,524.938660 39.968521,526.165039 38.891296,527.721191 
	C36.288857,528.370361 35.904591,526.828796 36.003014,524.477417 
	C36.656925,523.389526 37.324772,522.678223 38.290897,521.915222 
	C39.455399,521.550842 40.326748,521.273071 41.662468,521.702393 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M102.974922,520.028137 
	C103.041222,520.350708 103.049751,520.744019 103.002136,520.935059 
	C100.080429,521.674072 97.206345,522.222107 94.114182,522.479736 
	C96.184029,519.216736 100.320122,518.076904 102.974922,520.028137 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M64.947586,538.646606 
	C62.986755,538.921326 61.936020,538.228638 61.907955,536.741516 
	C61.872055,534.839050 63.357262,533.633789 64.266129,532.169312 
	C64.873665,533.175171 66.305962,533.719666 66.034714,535.581421 
	C66.060760,536.244385 66.009323,536.565552 65.834831,537.101929 
	C65.740700,537.321899 65.501427,537.725342 65.371735,537.913513 
	C65.242043,538.101685 64.815804,538.223328 64.947586,538.646606 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M81.591133,576.887512 
	C85.518631,575.719543 84.927719,580.281311 87.549805,580.598938 
	C88.175293,580.674683 86.916054,581.175659 86.595932,581.544373 
	C85.220490,583.128540 84.042984,582.248291 83.719193,580.899719 
	C83.262749,578.998596 82.071449,578.588257 80.242905,578.631409 
	C79.656586,577.891235 80.351181,577.459290 81.591133,576.887512 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M23.566357,539.985718 
	C22.339687,539.260254 21.445057,538.652954 19.789598,537.529297 
	C25.170774,537.214294 27.087072,537.690063 28.312799,540.129395 
	C26.644968,540.672974 25.271679,540.388489 23.566357,539.985718 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M28.988964,540.024475 
	C30.596439,540.401123 31.355534,538.933472 32.781967,538.121216 
	C34.615181,539.520752 33.005310,540.845520 32.219471,541.738281 
	C31.033537,543.085693 29.312963,542.712219 27.946239,541.301270 
	C28.018259,540.957458 27.959230,540.991760 27.966549,541.025085 
	C28.214001,540.822754 28.453121,540.586060 28.878120,540.178711 
	C29.065168,540.009338 28.999435,539.992188 28.988964,540.024475 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M28.082146,558.374146 
	C28.262115,557.836975 28.599066,557.595337 29.080093,557.070679 
	C31.372099,558.568542 32.992752,560.750793 34.093216,563.625488 
	C30.515799,563.928406 30.561573,560.008301 28.082146,558.374146 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M78.902725,576.402527 
	C79.144081,574.545349 79.370163,573.099731 79.647316,571.327576 
	C82.230309,572.187256 82.269653,574.153015 82.315964,576.395203 
	C82.169304,576.765869 82.058662,576.984436 81.979813,577.078125 
	C80.838486,577.541016 79.784668,577.837280 78.902725,576.402527 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M59.465206,545.387329 
	C57.226051,543.262939 55.118454,541.021912 55.094334,536.439697 
	C57.144192,539.643860 58.579334,541.887207 60.125443,544.457214 
	C60.069405,544.923828 59.902405,545.063721 59.465206,545.387329 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M78.575684,576.131409 
	C79.705307,576.308350 80.492622,576.625793 81.590454,577.057495 
	C81.308846,577.565552 80.716728,577.959290 80.049347,578.618530 
	C79.755302,579.960449 80.973846,581.828674 78.858398,581.876038 
	C76.388458,581.931458 78.003166,580.097168 77.965958,579.096069 
	C77.931152,578.159302 78.134712,577.213623 78.575684,576.131409 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M61.028118,580.259583 
	C62.828915,578.227478 64.586243,576.858276 65.983055,580.706055 
	C64.582382,582.691345 63.131737,580.339844 61.369041,581.104187 
	C61.019508,580.913452 61.016506,580.726562 61.028118,580.259583 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M93.866287,573.050293 
	C94.182022,574.129089 94.100838,575.198486 93.923210,576.665405 
	C92.574699,576.967163 91.180359,577.062256 91.097389,575.241150 
	C91.022423,573.595642 91.993126,573.035522 93.866287,573.050293 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M71.723579,587.473755 
	C71.369514,587.911926 70.999565,587.957336 70.350235,587.982056 
	C70.033775,587.637512 69.954498,587.312012 69.966774,586.989929 
	C70.027084,585.407349 68.358551,584.037964 69.362961,582.386841 
	C69.521805,582.125732 70.381065,581.954834 70.625961,582.135681 
	C72.390800,583.438965 71.365120,585.418335 71.723579,587.473755 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M55.031174,580.569336 
	C55.240589,579.297546 54.313171,577.392883 55.703640,577.478882 
	C58.084152,577.626099 56.852654,579.874207 57.083115,581.642700 
	C56.012409,582.346069 55.374557,581.950439 55.031174,580.569336 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M77.246681,523.185120 
	C78.173576,521.315857 78.513092,519.140930 80.708618,517.990845 
	C80.382561,519.789368 79.715767,521.588623 78.870438,523.644958 
	C78.286034,523.745056 77.880165,523.588074 77.246681,523.185120 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M65.025223,562.366211 
	C65.230240,561.939392 65.409470,561.941833 65.857925,561.932007 
	C67.153366,563.224609 67.103348,564.750732 66.984390,566.666504 
	C66.547600,567.033508 66.150688,567.016907 65.456123,567.032654 
	C65.105461,565.641846 65.052460,564.218689 65.025223,562.366211 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M64.861176,517.866943 
	C65.191925,518.206238 65.154137,518.468445 65.095993,519.127380 
	C64.521645,520.621948 63.683819,521.420044 62.256287,521.917969 
	C61.961098,520.030762 62.888866,518.703125 64.861176,517.866943 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M87.200912,543.920410 
	C87.886055,544.802185 88.849075,545.774963 87.532150,545.950623 
	C86.165779,546.132996 84.832451,544.907837 84.986191,543.545471 
	C85.104286,542.498901 86.235863,543.250305 87.200912,543.920410 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M113.740143,533.125122 
	C114.154037,533.669861 114.289505,534.341370 114.728409,535.193359 
	C114.719521,536.580750 114.143295,537.179565 113.108421,536.014404 
	C112.230423,535.025818 112.029305,534.003540 113.740143,533.125122 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M38.730156,542.801636 
	C38.667027,541.481934 39.328255,540.620544 40.517254,540.355591 
	C40.712677,540.312134 41.272709,540.919678 41.294792,541.250916 
	C41.401367,542.849487 40.285168,542.999268 38.730156,542.801636 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M65.264511,538.220093 
	C65.168037,537.419983 65.345932,536.829590 65.803543,536.078857 
	C66.872955,536.414734 67.510300,536.964233 66.483170,538.055908 
	C65.953140,538.228821 65.746010,538.329224 65.264511,538.220093 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M117.593842,540.024658 
	C118.023361,540.473389 118.107559,540.925049 118.074661,541.703735 
	C117.957573,542.030823 117.991371,542.004333 118.006279,541.989014 
	C117.874199,542.105957 117.727211,542.238098 117.284294,542.352051 
	C115.736160,541.414124 115.422676,540.600159 117.593842,540.024658 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M43.502022,574.082153 
	C43.750679,574.939575 43.883400,575.857666 42.726566,575.771240 
	C41.861191,575.706604 42.074287,574.912476 41.988724,573.989258 
	C42.406158,573.737061 42.808746,573.851379 43.502022,574.082153 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M34.524212,565.984619 
	C34.109100,565.504822 33.997498,565.071167 33.956139,564.307739 
	C35.197029,563.652283 35.579121,564.509399 36.021309,565.633789 
	C35.633160,565.989929 35.230438,566.010376 34.524212,565.984619 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M47.035713,522.600708 
	C47.123821,521.661255 47.624493,520.957764 48.871254,521.582642 
	C48.437424,522.109985 47.893108,522.388855 47.035713,522.600708 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M107.627106,526.045288 
	C109.459724,526.816711 109.305809,527.542053 107.297684,528.093140 
	C106.136604,527.336487 106.891289,526.818848 107.627106,526.045288 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M72.325859,577.359131 
	C72.027031,578.076904 71.158752,578.160583 71.040100,577.675659 
	C70.823799,576.791565 71.687645,577.178528 72.325859,577.359131 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M37.116638,567.688354 
	C36.675209,567.539368 36.304451,567.068787 35.981369,566.283081 
	C36.415131,566.434265 36.801220,566.900513 37.116638,567.688354 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M83.717728,522.126221 
	C84.049225,522.405212 84.113182,522.853638 84.071480,523.635498 
	C83.965820,523.969055 83.582512,524.206299 83.364952,524.147644 
	C83.248329,523.491150 83.349258,522.893372 83.717728,522.126221 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M82.263062,526.516968 
	C81.934753,526.154846 81.909775,525.807617 82.082031,525.284668 
	C82.625343,525.306396 82.971413,525.503845 83.512131,525.951538 
	C83.326653,526.311829 82.946518,526.421814 82.263062,526.516968 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M40.151310,528.590637 
	C39.891247,528.414368 39.939648,528.465698 39.928650,528.496948 
	C40.440994,528.513306 40.964344,528.498352 41.487690,528.483398 
	C41.128918,528.577881 40.770145,528.672424 40.151310,528.590637 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M68.748840,580.653137 
	C68.506935,580.540955 68.516968,580.444275 68.520767,580.398682 
	C68.762268,580.350281 68.999969,580.347351 69.237671,580.344421 
	C69.155365,580.484741 69.073051,580.625000 68.748840,580.653137 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M117.083176,542.489380 
	C117.155525,542.259949 117.322701,542.185852 117.755524,542.042725 
	C118.023308,542.157837 118.025429,542.341980 117.909561,542.776245 
	C117.553757,542.952637 117.349236,542.825439 117.083176,542.489380 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M119.115936,534.973450 
	C119.759377,535.176697 119.828316,535.447327 119.624802,535.913574 
	C119.219360,536.029358 118.900146,535.994080 118.279861,535.582764 
	C118.228409,535.136536 118.478035,535.066345 119.115936,534.973450 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M32.927612,534.471069 
	C32.953831,534.205872 33.232765,534.036255 33.762627,533.905640 
	C33.735809,534.152039 33.458069,534.359375 32.927612,534.471069 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M64.996277,538.004150 
	C65.188660,537.997559 65.387161,537.984619 65.872971,538.050110 
	C65.864571,538.267456 65.597824,538.448975 65.219696,538.871460 
	C65.079369,539.069946 64.929390,538.904846 64.856323,538.820557 
	C64.783264,538.736328 64.801231,538.331787 64.907700,538.159546 
	C65.014160,537.987244 65.002396,537.997864 64.996277,538.004150 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M38.010963,568.719055 
	C37.768898,568.811401 37.494606,568.616455 37.106277,568.189880 
	C37.321075,568.116089 37.649910,568.273926 38.010963,568.719055 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M39.065323,569.771362 
	C38.889858,569.831421 38.573044,569.642029 38.123367,569.206543 
	C38.301666,569.147522 38.612820,569.334717 39.065323,569.771362 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M288.021942,465.341736 
	C291.322998,463.903900 294.800476,463.983551 298.727875,463.938873 
	C297.676422,468.023987 293.536407,466.571075 290.341675,467.932495 
	C289.320892,467.161194 288.694672,466.402374 288.021942,465.341736 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M222.542603,491.682678 
	C220.273605,494.154846 217.234726,495.636688 213.274323,495.891785 
	C215.236206,492.812927 218.909515,492.644165 222.542603,491.682678 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M229.502167,488.786896 
	C229.103394,492.357880 226.103714,491.570251 223.304916,491.914154 
	C224.428802,489.726807 226.925430,489.540344 229.502167,488.786896 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M234.705658,486.796875 
	C234.704361,489.620819 232.510605,488.883362 230.322754,488.939453 
	C230.991714,487.378082 232.726608,487.236511 234.705658,486.796875 
z"/>
<path fill="#C4CCC0" opacity="1.000000" stroke="none" 
	d="
M243.601776,471.916595 
	C242.871597,471.845642 242.416260,471.722931 241.960922,471.600220 
	C242.450760,470.628113 243.238083,470.999146 243.966232,471.176575 
	C244.077957,471.203796 244.241669,471.430450 244.216110,471.514862 
	C244.174255,471.653107 243.996857,471.750336 243.601776,471.916595 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M283.236145,465.477448 
	C283.765289,465.205048 284.511993,465.119690 285.633270,465.086243 
	C285.296082,465.991302 284.436981,466.129120 283.236145,465.477448 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M246.016754,482.764343 
	C245.686646,483.611359 244.808868,484.069885 243.312805,483.966431 
	C243.518585,482.865173 244.641434,482.952789 246.016754,482.764343 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M242.613327,483.908508 
	C242.468948,484.300476 241.945221,484.688171 241.108032,485.211426 
	C240.770752,484.363586 241.459473,484.091095 242.613327,483.908508 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M23.605442,571.002686 
	C23.671408,570.191589 23.804602,569.662964 23.981232,568.728638 
	C26.067177,568.273254 28.109686,568.223572 30.557816,567.992310 
	C34.008755,567.747192 34.681713,570.149597 35.242401,572.301514 
	C35.548782,573.477478 33.924671,573.392761 33.150089,573.829285 
	C32.750996,574.054199 31.876680,574.264099 31.849150,574.201721 
	C30.139074,570.327454 26.765038,571.202393 23.605442,571.002686 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M23.774811,578.182739 
	C24.181116,577.121521 24.692181,576.794434 25.289280,577.346008 
	C25.568874,577.604309 25.819561,578.331238 25.666031,578.542419 
	C25.112766,579.303467 24.376810,579.322144 23.774811,578.182739 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M63.030693,576.129517 
	C63.069225,576.599976 62.675880,576.926941 61.947136,576.313477 
	C62.075218,576.085815 62.349136,576.081787 63.030693,576.129517 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M55.899651,611.115967 
	C56.879215,610.972046 57.612980,611.027771 58.713043,611.032349 
	C59.460724,610.637634 59.908272,610.515503 60.733322,610.760437 
	C61.054207,610.937988 61.003151,611.000000 61.026566,610.968750 
	C61.524334,611.537415 62.073765,612.065857 62.844978,612.775146 
	C63.064896,612.957825 63.010433,613.002136 63.023254,612.969482 
	C63.438126,613.595093 63.781105,614.305969 64.801559,614.784607 
	C65.053253,614.931213 65.017250,614.986267 65.045967,614.970215 
	C65.900620,615.690063 66.084831,616.765747 66.651703,617.993225 
	C66.999901,619.392090 68.630112,620.537109 66.420288,621.670288 
	C63.503613,620.022461 61.289101,617.801270 58.848236,615.341980 
	C58.422321,615.003601 58.256092,614.865479 57.893650,614.476074 
	C57.191914,614.116943 58.242352,613.043884 56.820290,613.330627 
	C56.101597,613.202148 55.802952,612.929688 55.543701,612.239990 
	C55.545509,611.723877 55.599678,611.519775 55.899651,611.115967 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M69.128357,628.701660 
	C66.647453,629.036316 67.782448,626.901306 67.028732,625.640991 
	C67.710876,624.051514 68.880119,623.527832 70.680725,623.812744 
	C71.009911,624.054749 71.011597,623.994446 70.981499,623.996399 
	C71.645256,624.694458 72.566895,624.438904 73.676636,624.738892 
	C74.974236,629.532166 70.331451,626.591431 69.128357,628.701660 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M71.901642,614.300720 
	C73.579056,613.914062 75.178177,613.803589 75.072235,611.270386 
	C77.345314,610.715637 77.507706,612.606873 78.029800,614.506470 
	C78.500885,615.484314 79.044792,616.038574 79.809845,616.783447 
	C80.026108,616.978516 80.016808,616.996460 80.032242,616.988220 
	C78.111748,619.426697 77.008781,617.086548 75.325333,616.110107 
	C74.823700,615.883850 74.647034,615.762268 74.223862,615.847351 
	C73.977348,616.054016 73.987267,615.984192 74.022453,615.986328 
	C73.842216,616.142822 73.626793,616.297119 73.019363,616.517761 
	C72.370995,616.516785 72.114616,616.449524 71.604889,616.075806 
	C71.518600,615.384949 71.685677,615.000549 71.901642,614.300720 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M57.856812,614.320862 
	C61.710770,615.140930 64.018654,617.971924 66.123604,621.410095 
	C65.655212,622.144470 65.157745,622.538269 64.330444,622.966064 
	C64.007248,622.563171 64.013885,622.126282 64.018021,621.361816 
	C63.164131,620.234253 61.966106,620.020386 60.769073,619.130310 
	C60.418289,618.770142 60.337101,618.587280 60.136917,618.295349 
	C59.424831,616.912781 58.280624,615.991211 57.856812,614.320862 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M71.363434,615.771118 
	C71.642448,615.835266 71.933372,615.901245 72.663651,616.052124 
	C73.375908,616.484253 73.485092,616.877136 73.211288,617.547546 
	C71.957527,617.862488 72.966339,620.810059 70.914986,619.335938 
	C69.278030,618.159546 71.330124,617.464600 71.412140,616.142212 
	C71.349953,615.783081 71.375351,615.772949 71.363434,615.771118 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M71.043068,623.772888 
	C69.334557,623.106262 69.023338,625.396423 67.363663,625.399536 
	C66.935760,624.001465 67.562645,623.262817 69.394333,623.197693 
	C69.989571,622.739868 70.291840,622.555176 70.905945,622.726379 
	C71.101898,623.113525 71.089066,623.302246 71.043068,623.772888 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M66.852829,617.899475 
	C65.666809,617.673523 64.662560,616.982666 64.838135,615.249084 
	C65.523132,615.042419 65.971581,615.130737 66.747818,615.106567 
	C67.075623,614.994080 67.005318,614.999878 67.004456,614.964600 
	C67.347000,615.271545 67.492599,615.687622 67.273781,616.456909 
	C67.031372,617.002563 66.981857,617.259155 66.852829,617.899475 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M60.601616,619.286255 
	C62.159142,617.909119 62.805153,619.485168 63.889053,620.655823 
	C63.272182,621.018066 62.528839,621.002014 61.411079,620.966919 
	C60.936775,620.500183 60.836887,620.052490 60.601616,619.286255 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M57.301529,620.993408 
	C56.447262,620.130005 55.064117,619.083801 56.774021,618.368835 
	C57.840279,617.922852 58.118507,619.369263 58.115726,620.692932 
	C58.014832,621.038574 57.538647,621.017456 57.301529,620.993408 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M58.163452,621.223206 
	C58.685131,621.033630 59.419365,621.085327 60.515499,621.114258 
	C60.644394,621.654968 60.550293,622.549255 60.151066,622.716858 
	C59.147514,623.138306 58.939034,621.955261 58.163452,621.223206 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M67.281586,616.864014 
	C67.000229,616.340881 66.919563,615.935669 66.921249,615.229980 
	C68.011116,614.940491 68.576576,615.567139 69.021652,616.702515 
	C68.853149,617.135864 68.676346,617.239563 68.213959,617.229492 
	C67.928368,617.115601 67.482269,616.982056 67.281586,616.864014 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M71.113213,622.597534 
	C70.815292,622.918335 70.518326,622.942322 70.016083,623.053101 
	C69.333115,622.549133 69.160896,621.821838 69.784920,621.430359 
	C70.479706,620.994507 70.934700,621.555969 71.113213,622.597534 
z"/>
<path fill="#F8F3D8" opacity="1.000000" stroke="none" 
	d="
M68.995354,629.002808 
	C70.048447,629.711365 70.149788,630.600525 69.246460,631.816528 
	C68.997101,631.998047 69.000000,632.000000 69.001831,632.001587 
	C69.001930,631.249573 69.000198,630.496033 69.005058,629.365356 
	C69.011650,628.988342 69.000900,628.999084 68.995354,629.002808 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M63.999817,623.000000 
	C63.607754,623.433472 63.215874,623.866882 62.823994,624.300354 
	C62.679462,624.119568 62.534931,623.938721 62.390396,623.757935 
	C62.747524,623.522461 63.104652,623.286926 63.731194,623.025757 
	C64.000610,623.000000 64.000000,623.000000 63.999817,623.000000 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M74.600983,622.457886 
	C74.077316,622.271179 73.717003,621.842102 73.378220,621.396667 
	C73.368652,621.384094 73.584641,621.110535 73.702446,621.104919 
	C74.459702,621.068665 74.768593,621.500793 74.600983,622.457886 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M73.740288,624.657043 
	C73.040382,625.068237 72.097336,625.480957 71.113434,624.317322 
	C71.807678,624.138550 72.663956,624.278809 73.740288,624.657043 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M73.334679,617.780579 
	C72.978981,617.410095 72.966331,617.040527 73.028343,616.403931 
	C73.102997,616.136963 73.582504,616.076721 73.820068,616.032593 
	C74.506271,616.708069 74.230110,617.274048 73.334679,617.780579 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M74.240753,616.202637 
	C74.193436,615.738159 74.162743,614.980408 74.937622,615.779053 
	C74.834961,616.120667 74.669556,616.235901 74.240753,616.202637 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M68.064705,617.281128 
	C68.110237,617.079224 68.292114,617.042847 68.751968,617.019287 
	C69.046112,617.755249 68.641533,617.636902 68.064705,617.281128 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M140.008575,510.813873 
	C139.964539,510.459686 140.009628,510.499603 139.986816,510.519257 
	C140.225037,509.881073 140.517792,509.233490 140.813950,508.229126 
	C141.012970,507.935516 141.010498,507.995483 140.982300,507.985229 
	C141.144989,507.852203 141.335892,507.729401 141.791656,507.820557 
	C144.261658,509.661346 146.782318,510.713348 144.857773,514.606323 
	C143.180847,517.998413 142.090134,516.709534 140.091690,515.110107 
	C138.754776,513.724365 139.152206,512.427429 140.008575,510.813873 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M139.604691,510.555267 
	C141.396179,511.888855 139.417313,513.055542 139.709457,514.759521 
	C139.757172,515.125793 139.818390,515.456665 139.868378,515.617371 
	C139.131378,517.372986 138.480453,519.040710 137.230957,520.765747 
	C136.742554,523.234863 135.170837,523.013428 133.245392,522.823792 
	C134.875717,518.692322 136.423477,514.337280 139.604691,510.555267 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M142.285553,506.971130 
	C142.198608,503.811462 144.061722,501.611633 146.577667,499.510132 
	C149.400528,506.179199 148.549118,507.669037 142.285553,506.971130 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M137.378387,520.980591 
	C136.846436,518.921875 137.400818,517.108948 139.569763,515.798462 
	C140.267975,516.974854 140.617615,518.171692 141.024216,519.664185 
	C139.893143,520.062622 139.265701,522.164185 137.378387,520.980591 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M161.244904,501.681824 
	C160.790497,502.368805 160.384644,502.690765 159.727936,503.061401 
	C158.930923,503.081055 158.384781,503.052002 157.401459,502.993713 
	C156.955734,502.251068 156.947189,501.537659 156.901108,500.472443 
	C156.863571,500.120636 156.990707,500.017975 157.055908,499.968750 
	C157.536240,499.640594 157.995850,499.512817 158.861389,499.505188 
	C160.336105,499.627411 160.972244,500.293701 161.244904,501.681824 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M154.659698,505.016022 
	C154.766418,506.929230 153.482773,507.507568 151.452774,507.648346 
	C151.593826,505.639740 153.259171,505.647644 154.659698,505.016022 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M149.241730,511.965759 
	C147.358749,512.033203 148.278152,510.842194 148.224503,510.077026 
	C148.217896,509.982544 148.775696,509.691559 148.910889,509.769836 
	C149.719162,510.237732 149.888321,510.939026 149.241730,511.965759 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M157.008636,503.012146 
	C156.524170,503.603882 156.025925,504.178925 155.262726,504.876160 
	C154.997772,504.998383 155.000000,505.000000 155.001312,505.001221 
	C155.061081,504.091461 155.271042,503.281769 156.641907,502.998566 
	C156.964279,502.964478 156.994843,502.995453 157.008636,503.012146 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M142.042053,507.761292 
	C141.871918,508.040710 141.687317,508.046936 141.228424,508.014038 
	C141.090164,507.629364 141.226242,507.283722 141.649780,506.943237 
	C141.967361,507.128204 141.997482,507.308105 142.042053,507.761292 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M18.996750,781.653137 
	C17.618919,782.000671 17.065825,780.969360 16.040524,780.045532 
	C15.456774,779.137268 15.231995,778.386841 15.800453,777.290894 
	C17.016273,776.994812 17.966228,776.992737 19.272394,776.989319 
	C19.453501,778.426575 19.278399,779.865173 18.996750,781.653137 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M16.049780,776.585388 
	C15.984253,777.717896 15.902191,778.438843 15.789422,779.520020 
	C15.758714,779.880127 15.408888,779.975281 15.229984,780.004272 
	C14.871959,779.868164 14.713508,779.685242 14.422713,779.388672 
	C14.231902,778.811829 14.194106,778.330566 14.189001,777.489014 
	C15.704469,775.330078 14.264950,772.916077 15.514985,770.929565 
	C16.443890,772.687683 15.882746,774.468018 16.049780,776.585388 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M17.481514,759.001587 
	C17.145615,757.398804 17.419231,756.037781 19.807610,756.758789 
	C19.570290,757.998779 18.878603,758.703247 17.481514,759.001587 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M42.955338,615.641418 
	C41.608021,615.439575 39.978348,617.485962 38.921799,615.042847 
	C39.211357,612.730164 41.352589,612.529236 42.690380,611.090698 
	C42.986538,610.959473 43.248055,611.235779 43.434490,611.273438 
	C44.894466,611.366211 45.448784,612.084106 45.266247,613.641663 
	C44.402676,614.433899 43.730740,614.888916 42.955338,615.641418 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M57.978439,613.988464 
	C58.179264,615.434143 60.455612,615.624512 60.069107,617.809326 
	C58.972286,617.407654 57.893410,616.643677 56.481464,615.810181 
	C55.476990,614.595764 54.805588,613.450928 54.080795,611.966675 
	C53.958420,611.426025 53.889435,611.224792 54.090214,610.852661 
	C55.041622,610.805115 55.489105,611.213928 55.885559,612.128296 
	C55.968407,612.636414 56.030052,612.814636 56.331772,613.003845 
	C56.960327,612.903992 57.340881,613.035339 57.795780,613.772339 
	C57.996063,614.055908 58.008446,613.995422 57.978439,613.988464 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M46.934391,621.171631 
	C46.013973,620.591125 45.315884,619.882385 44.355022,619.029297 
	C43.763580,618.375977 43.434902,617.867004 43.044106,617.057861 
	C44.718716,616.519958 45.543438,617.725342 46.689148,619.090393 
	C47.255981,619.844666 47.876183,620.382874 46.934391,621.171631 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M45.046173,613.990356 
	C45.399509,612.960205 45.032398,612.246338 43.863213,611.545166 
	C43.884350,611.256348 44.147778,611.201538 44.805504,611.058289 
	C46.888813,611.353760 47.602364,612.202271 46.250229,613.976685 
	C45.749748,614.157410 45.582893,614.237244 45.211945,614.129150 
	C45.007843,613.941223 45.017731,614.001770 45.046173,613.990356 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M54.283440,610.731567 
	C54.040588,610.927307 53.981712,611.277954 54.004559,611.452576 
	C53.243546,611.869446 52.468052,611.990051 52.307350,610.892151 
	C52.185661,610.060730 52.887749,609.958313 53.791916,609.971985 
	C54.107494,610.136841 54.087627,610.105774 54.094421,610.092529 
	C54.242908,610.231445 54.384602,610.383606 54.283440,610.731567 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M45.062859,614.141846 
	C45.170780,613.887512 45.333721,613.833740 45.706627,613.928772 
	C45.757526,614.489075 45.605213,614.920898 45.062859,614.141846 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M66.642365,609.952454 
	C67.057686,610.727173 67.081268,611.501099 67.059204,612.662537 
	C65.726486,612.843018 64.903610,612.065369 64.799622,610.807434 
	C64.722046,609.869019 65.730408,610.195984 66.642365,609.952454 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M63.096748,612.622986 
	C61.849396,613.364624 61.119461,612.944580 60.968201,611.307983 
	C62.034912,610.938293 62.771603,611.321045 63.096748,612.622986 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M65.056694,614.616943 
	C63.611916,615.782898 63.325840,614.673950 62.998573,613.317627 
	C63.710766,613.392029 64.385452,613.847290 65.056694,614.616943 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M54.278107,611.127991 
	C54.040588,610.927307 54.054188,610.502258 54.077702,610.290771 
	C54.671673,610.192200 55.242134,610.305115 55.979023,610.667114 
	C56.129581,611.167664 56.113705,611.419128 56.052444,612.046997 
	C55.509911,612.058533 55.012768,611.693604 54.278107,611.127991 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M61.023727,610.603760 
	C60.621639,610.995789 60.189072,611.053589 59.417923,611.046265 
	C59.350002,609.756104 60.045231,609.672913 61.023727,610.603760 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M94.960297,579.331421 
	C95.352806,578.770813 95.771996,578.480896 96.461494,578.224365 
	C96.756371,578.595398 96.780930,578.933044 96.811333,579.527771 
	C96.163452,580.161194 95.433975,581.296265 94.960297,579.331421 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M95.293549,586.954468 
	C95.208580,586.170715 95.293541,585.582825 95.378494,584.994873 
	C95.488853,585.013855 95.671410,584.998962 95.698601,585.056946 
	C96.045815,585.797119 96.194313,586.526917 95.293549,586.954468 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M31.093773,834.295410 
	C31.159403,834.063416 31.321726,834.015381 31.736761,833.991699 
	C32.001186,834.186646 32.012897,834.357300 31.924522,834.764282 
	C31.558929,834.892700 31.347607,834.718994 31.093773,834.295410 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M22.522850,617.554749 
	C22.497227,618.174194 22.247934,618.387146 21.944164,618.899841 
	C21.181263,618.735291 20.542192,618.352234 19.621782,617.973633 
	C19.050182,617.339355 18.759924,616.700745 18.101860,616.029114 
	C17.975941,614.984131 17.737225,613.663025 19.630379,613.648743 
	C20.346498,615.121216 21.108488,616.219666 22.522850,617.554749 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M12.220852,620.069458 
	C11.991990,619.936768 12.005628,619.531982 12.007421,619.329651 
	C13.033240,619.138733 14.057264,619.150146 15.471659,619.182495 
	C15.713577,619.749146 15.565125,620.294922 15.156023,620.996704 
	C14.475538,621.115356 14.055704,621.077942 13.319994,621.055908 
	C12.819316,620.781616 12.634515,620.491882 12.220852,620.069458 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M14.494485,613.254822 
	C14.827436,613.772705 14.912218,614.489563 15.111856,615.550598 
	C14.785857,617.092651 14.039348,616.767090 13.486300,616.106873 
	C12.508746,614.940063 13.042886,614.068298 14.494485,613.254822 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M10.030372,618.648071 
	C9.008199,619.038147 7.906417,619.313965 8.437468,617.328064 
	C9.415712,617.109985 10.169275,617.274780 10.030372,618.648071 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M42.995567,610.989136 
	C43.510838,613.966858 41.127846,613.762634 39.111809,614.486877 
	C36.879108,613.337463 34.037632,617.139038 32.216003,613.369629 
	C31.357794,612.988953 31.949755,611.966919 30.919331,611.955261 
	C30.432131,611.605286 30.220600,611.240356 29.834187,610.611084 
	C30.093342,609.800659 30.527380,609.254395 30.973108,608.344482 
	C31.169456,607.851990 31.354115,607.723083 31.806103,607.800659 
	C32.073429,608.007141 32.008751,607.988342 32.013626,607.954956 
	C33.178841,611.888550 36.156429,611.591736 39.642021,610.996948 
	C40.722740,610.391785 41.502884,610.234131 42.718544,610.771667 
	C43.065586,611.008301 43.004601,611.018738 42.995567,610.989136 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M28.017841,614.982666 
	C27.268349,615.422974 27.884777,617.378052 25.809109,616.638184 
	C24.969526,616.717468 24.660503,616.543213 24.770605,615.621887 
	C25.105894,614.323181 24.702105,612.816589 26.812214,613.700806 
	C27.235857,614.196655 27.455158,614.442505 27.859100,614.849182 
	C28.054451,615.000488 28.001999,615.003418 28.017841,614.982666 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M32.004906,607.692261 
	C31.892416,607.987244 31.711405,607.967346 31.257595,607.964111 
	C29.979744,607.501709 29.208208,606.828186 29.028191,605.330688 
	C29.910334,605.185913 30.808071,605.359680 31.902012,605.819092 
	C32.044273,606.528931 31.990330,606.953125 32.004906,607.692261 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M24.720194,615.195190 
	C24.916445,615.618774 25.024508,615.905823 25.378456,616.341309 
	C25.511488,616.532288 25.232662,616.799011 25.088249,616.926880 
	C24.542385,617.377441 24.085688,617.510986 23.261497,617.251831 
	C22.949348,617.048584 22.911465,617.095520 22.884201,617.109375 
	C23.075481,616.479614 23.294024,615.835938 23.819809,615.042847 
	C24.127052,614.893311 24.519152,615.101257 24.720194,615.195190 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M27.943144,614.767822 
	C27.734835,614.848083 27.415215,614.695618 27.050718,614.251770 
	C27.281172,614.151978 27.556503,614.343567 27.943144,614.767822 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M80.122025,616.592285 
	C79.074280,616.906494 78.225632,616.692200 78.038940,615.207153 
	C78.459541,614.835449 78.893272,614.803650 79.645920,614.703247 
	C80.049210,615.158447 80.133575,615.682251 80.122025,616.592285 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M80.034286,609.787720 
	C80.158653,609.556824 80.308632,609.681946 80.737732,609.896118 
	C81.149040,610.454773 81.281235,610.924377 81.229874,611.716431 
	C80.867096,611.985718 80.687874,611.932495 80.275543,611.723267 
	C80.048264,611.092651 80.054085,610.618164 80.034286,609.787720 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M74.978828,610.837036 
	C74.771408,610.953003 74.555618,610.804932 74.309639,610.409851 
	C74.531105,610.253662 74.761444,610.390381 74.978828,610.837036 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M42.999474,610.725586 
	C42.304848,611.036377 41.544109,611.064453 40.405235,611.039917 
	C40.072662,610.529846 40.118229,610.072266 40.058029,609.285828 
	C40.133514,608.993530 40.314766,609.030151 40.763512,608.993408 
	C41.202961,608.822266 41.374912,608.724365 41.777153,608.813721 
	C42.316078,609.481567 42.624718,609.962219 42.999474,610.725586 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M81.075691,612.248047 
	C81.402840,611.953308 81.849564,611.951477 82.664688,611.948486 
	C82.901299,612.532715 82.769516,613.118225 82.637726,613.703735 
	C82.156906,613.316162 81.676086,612.928589 81.075691,612.248047 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M41.925026,608.829468 
	C42.007442,609.000916 41.513367,609.031616 41.272186,608.975830 
	C41.228443,608.606384 41.392609,608.189697 41.925026,608.829468 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M904.861694,554.871460 
	C899.597351,555.779541 896.104187,558.019226 897.011658,564.156738 
	C897.179749,565.293701 896.222595,565.406067 895.226440,565.802246 
	C893.762634,563.546875 892.504272,561.092346 891.036987,558.355896 
	C890.704468,557.897522 890.580811,557.721008 890.357910,557.235657 
	C890.086426,556.082214 890.033203,555.197327 889.186279,554.283813 
	C888.937317,554.070740 888.987854,554.011230 888.965088,554.038513 
	C888.445740,553.371582 887.712830,552.908020 886.883728,551.685242 
	C886.580322,550.901978 886.567627,550.687988 886.660278,550.170044 
	C887.207336,549.368713 887.765320,549.085632 888.730469,548.937012 
	C889.960327,550.224609 891.213623,551.429382 891.720520,552.892761 
	C892.888794,556.264954 894.880005,556.431274 897.905518,554.788330 
	C899.921387,554.123962 901.623901,553.605469 903.708862,553.126038 
	C904.326477,553.646545 904.561523,554.128052 904.861694,554.871460 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M896.060059,529.215942 
	C896.244446,529.127136 896.435852,529.277771 896.585571,529.686157 
	C896.397217,529.751282 896.238342,529.588440 896.060059,529.215942 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M895.120117,528.278198 
	C895.340576,528.134399 895.608826,528.292297 895.887451,528.778564 
	C895.662231,528.901855 895.418884,528.726257 895.120117,528.278198 
z"/>
<path fill="#F3C9D4" opacity="1.000000" stroke="none" 
	d="
M919.093140,555.512634 
	C919.376038,554.986389 919.690430,554.827454 919.858582,554.572144 
	C920.536865,553.542236 919.335449,551.226257 921.179382,551.332397 
	C923.171387,551.447021 923.082520,553.594727 923.025879,555.649658 
	C921.564880,558.790283 920.267700,558.141846 919.093140,555.512634 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M88.041161,127.085381 
	C85.115990,128.433426 87.139633,123.437584 84.037582,124.653687 
	C83.448166,124.971954 83.066078,124.995888 82.396927,125.012497 
	C81.643509,124.588196 81.045197,124.499252 80.260345,124.136032 
	C80.048157,123.925529 80.000496,123.994835 80.033653,123.969017 
	C79.940170,123.700005 79.813538,123.456810 79.864456,122.842651 
	C79.963081,121.108620 79.884132,119.745560 79.638626,117.996902 
	C79.839973,113.390472 83.095558,112.327217 86.686951,111.090675 
	C87.559090,110.450874 88.183777,110.173012 89.253983,110.189217 
	C90.276360,110.375694 90.904915,110.655380 91.827515,111.109924 
	C92.721252,111.612892 93.148811,112.132774 93.766754,112.924530 
	C97.459221,116.980225 92.245125,117.949524 91.387589,120.629120 
	C89.156441,121.717407 90.344055,124.276215 88.546440,125.621132 
	C88.252686,126.155579 88.156647,126.413963 88.041161,127.085381 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M61.335449,109.932892 
	C60.914505,107.330688 60.410412,105.731102 57.769291,108.418968 
	C56.757778,109.448380 55.763039,110.619652 54.520924,111.264511 
	C53.055138,112.025482 53.179955,110.549103 53.002735,109.339951 
	C51.896870,108.889137 50.158417,109.209122 50.300957,107.631325 
	C50.482021,105.627037 53.301170,104.243568 54.091877,104.558731 
	C60.167953,106.980568 60.184555,100.852188 62.965511,98.347092 
	C65.979912,97.414024 67.543274,99.239464 68.620186,101.539864 
	C69.414085,103.235741 68.303917,103.883682 66.368889,103.989914 
	C65.619194,103.629257 65.282364,103.200737 64.561516,103.039703 
	C64.383301,103.036308 64.309601,103.342239 64.508209,103.308350 
	C65.035065,103.304367 65.332344,103.416977 65.799484,103.806000 
	C66.169144,107.127327 63.345566,108.085571 61.335449,109.932892 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M69.632111,56.005653 
	C70.244041,57.189659 69.322037,58.880951 70.969208,59.448437 
	C72.248779,59.889271 72.840614,58.446304 73.638878,57.674309 
	C75.527405,55.847931 75.539940,55.860905 76.416092,58.264660 
	C76.792152,59.296406 77.209854,59.273201 79.674622,58.057407 
	C81.155075,60.004524 80.408493,61.485313 78.367218,62.862461 
	C76.100479,64.504433 73.796097,58.545967 72.037186,63.663673 
	C71.269547,63.799339 70.401169,63.206585 70.013237,64.383469 
	C69.655563,65.468582 69.021049,66.296440 67.943314,65.657906 
	C66.699730,64.921127 67.636780,63.984097 68.204491,63.247547 
	C69.318405,61.802353 68.844940,60.592216 67.876640,59.282646 
	C66.581444,57.530956 66.768829,56.241585 69.632111,56.005653 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M90.174561,111.067436 
	C89.224342,111.125084 88.475380,111.095406 87.360580,110.976257 
	C86.996231,110.164070 86.997704,109.441368 87.000183,108.356895 
	C87.690308,107.311462 88.307693,106.527580 89.086922,105.969803 
	C90.033714,105.292076 90.615433,103.284164 92.173431,104.445847 
	C93.671928,105.563156 90.421730,106.331459 91.826614,107.883362 
	C92.332443,108.318130 92.517838,108.615234 92.583443,109.236786 
	C92.507042,109.655930 92.444481,109.813919 92.211578,110.149719 
	C92.041237,110.327522 91.606628,110.510010 91.382523,110.503418 
	C91.158409,110.496819 90.822006,110.234695 90.729721,110.431305 
	C90.637444,110.627907 90.375801,110.980110 90.174561,111.067436 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M63.001106,97.998901 
	C60.723591,97.326973 59.177586,100.949165 56.347519,99.037994 
	C56.001526,99.001587 56.000000,99.000000 55.999237,98.999237 
	C56.282913,97.857414 55.357388,96.379257 56.944927,95.601234 
	C58.222309,98.801819 62.294804,91.992126 62.992409,97.645271 
	C62.997784,98.002205 63.000000,98.000000 63.001106,97.998901 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M61.048134,58.636116 
	C57.845100,58.121689 59.133686,56.625988 60.431717,55.086029 
	C61.695198,53.587059 63.222488,52.758121 65.615891,53.001915 
	C66.002136,53.002144 66.000000,53.000000 65.998932,52.998924 
	C66.014160,54.533070 65.847382,55.902950 63.830471,56.017181 
	C62.413109,56.097466 61.443523,56.821522 61.048134,58.636116 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M78.009918,68.374023 
	C81.516739,68.018051 83.363159,69.938309 83.988808,73.622070 
	C80.730644,73.689774 79.573036,70.992966 78.009918,68.374023 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M60.123432,64.880333 
	C61.408859,63.926315 62.695129,63.559769 63.395432,64.747322 
	C64.014587,65.797264 62.901432,66.524124 61.991932,66.946854 
	C60.994648,67.410385 59.845768,68.526360 58.849987,67.457741 
	C57.819370,66.351753 59.501694,65.922203 60.123432,64.880333 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M58.005569,91.350098 
	C59.788464,91.531281 60.787952,89.695969 62.587559,89.424011 
	C63.263813,92.196625 60.911694,92.752663 59.483097,93.480606 
	C58.239681,94.114197 58.126915,92.645485 58.005569,91.350098 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M61.005112,58.995110 
	C61.171524,59.009930 61.354237,58.987103 61.490932,59.055817 
	C62.978588,59.803635 65.202942,59.333267 65.769333,61.555191 
	C65.844826,61.851315 65.343567,62.599327 65.045906,62.637047 
	C62.840950,62.916435 62.160568,61.039772 61.051682,59.351810 
	C60.990540,59.010155 61.000042,58.999969 61.005112,58.995110 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M72.140709,64.316040 
	C74.622787,63.923859 76.191811,65.722565 77.940231,67.653122 
	C75.370972,68.103485 73.393570,67.102715 72.140709,64.316040 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M57.997787,91.002060 
	C55.802486,90.396935 54.381851,88.886597 53.190525,87.073372 
	C55.264050,87.500801 57.595493,87.498253 57.993629,90.632477 
	C58.004425,90.995422 58.000000,91.000000 57.997787,91.002060 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M50.144611,99.707977 
	C48.545052,99.921371 47.971340,99.078270 48.185539,97.062599 
	C49.055515,95.784508 49.867405,95.432236 51.408180,95.708054 
	C52.086159,97.466827 51.049702,98.371742 50.144611,99.707977 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M76.986603,88.628387 
	C75.547134,88.892944 73.847115,89.190102 73.508606,87.132164 
	C73.464478,86.863876 74.034294,86.281639 74.402115,86.195137 
	C76.057579,85.805870 76.927345,86.551697 76.986603,88.628387 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M79.998581,84.638748 
	C78.923698,84.761398 77.080864,85.502579 77.517708,83.279060 
	C77.645485,82.628700 78.481247,81.567696 78.879692,81.616478 
	C80.506462,81.815628 79.784103,83.296844 79.998581,84.638748 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M69.997009,53.373402 
	C71.151947,53.229015 72.970627,52.337986 73.309654,53.855736 
	C73.647263,55.367104 71.775558,55.447662 70.346222,55.962830 
	C69.997284,55.251179 69.996712,54.500065 69.997009,53.373402 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M54.625172,54.999680 
	C54.887863,56.105412 55.256084,57.565823 53.609398,57.757160 
	C52.255680,57.914452 52.101349,56.769840 52.008446,55.367554 
	C52.751030,54.998871 53.500687,54.999115 54.625172,54.999680 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M86.999702,77.375000 
	C87.749504,76.999290 88.499001,76.998581 89.625168,76.999847 
	C90.047829,78.602150 89.849838,80.017334 87.370193,79.991028 
	C86.999802,79.250000 86.999603,78.500000 86.999702,77.375000 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M51.655800,93.564545 
	C53.034477,93.112259 54.381847,92.734001 54.716671,94.153397 
	C55.083366,95.707924 53.874439,95.882698 52.367653,95.991386 
	C51.999390,95.999390 52.000000,96.000000 52.000000,96.000000 
	C51.463295,95.493919 51.237938,94.870888 51.655800,93.564545 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M49.559669,93.343033 
	C48.994423,92.241730 49.000004,91.494682 49.003021,90.374123 
	C50.605778,89.941566 52.017834,90.139694 52.001812,92.619614 
	C52.010426,92.989616 51.997929,93.002060 51.992661,93.007339 
	C51.478043,93.538147 50.857502,93.762093 49.559669,93.343033 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M82.997559,87.002533 
	C81.869247,86.826286 79.899139,88.488121 80.000839,85.315796 
	C80.000305,84.999695 80.000000,85.000000 79.999847,85.000153 
	C81.530983,84.237267 82.978058,83.664192 82.997864,86.660736 
	C83.004883,86.995110 83.000000,87.000000 82.997559,87.002533 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M51.999313,55.000664 
	C50.821331,54.919510 49.722870,54.592155 49.424915,53.314438 
	C49.264297,52.625675 49.822166,52.127506 50.568264,52.196804 
	C51.837555,52.314701 51.915375,53.316662 51.993740,54.643646 
	C52.001373,54.998627 52.000000,55.000000 51.999313,55.000664 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M86.660812,80.037537 
	C86.999802,80.748856 86.999611,81.497704 86.997269,82.620834 
	C86.015297,82.832489 84.552261,83.398140 84.436394,81.793449 
	C84.361877,80.761414 85.363083,80.298073 86.660812,80.037537 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M84.013618,74.378220 
	C85.540268,74.074463 86.598396,74.738464 86.964081,76.660919 
	C85.409698,77.038979 83.978668,76.867126 84.013618,74.378220 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M48.996544,89.651138 
	C47.558365,89.366982 46.942307,88.235512 46.999458,86.347038 
	C48.430653,86.636246 49.050781,87.765053 48.996544,89.651138 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M65.011124,92.475937 
	C65.895927,92.970551 65.997345,93.586990 65.587852,94.188843 
	C65.254166,94.679276 64.718018,94.671143 64.398239,94.172188 
	C64.007446,93.562424 64.112869,92.946175 65.011124,92.475937 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M85.005020,104.356812 
	C86.454544,104.077431 87.041122,104.905434 86.989555,106.641586 
	C85.541557,106.914078 84.973503,106.072678 85.005020,104.356812 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M47.138626,81.371078 
	C47.876839,80.270111 48.305489,80.914520 48.526329,81.483604 
	C48.624420,81.736382 48.213795,82.186569 48.034081,82.547150 
	C47.727562,82.243767 47.421043,81.940376 47.138626,81.371078 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M75.718445,110.036285 
	C75.907097,110.629707 75.902641,111.345726 75.090851,111.484879 
	C74.919754,111.514206 74.682343,111.156670 74.475494,110.977402 
	C74.795753,110.675591 75.116013,110.373779 75.718445,110.036285 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M61.019394,110.020432 
	C60.917160,110.667122 60.888367,111.388428 60.073132,111.504074 
	C59.895145,111.529335 59.662434,111.168839 59.454926,110.986000 
	C59.768787,110.673912 60.082645,110.361824 60.675709,110.003052 
	C60.954910,109.956360 60.998219,109.998756 61.019394,110.020432 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M75.999695,109.999695 
	C76.092896,109.372513 76.091713,108.655914 76.902031,108.514336 
	C77.072762,108.484497 77.311050,108.841278 77.518211,109.019920 
	C77.199577,109.322365 76.880951,109.624809 76.281464,109.963936 
	C76.000610,110.000610 76.000000,110.000000 75.999695,109.999695 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M79.955551,111.590729 
	C79.232559,111.196724 79.225174,110.799240 79.739098,110.447159 
	C79.846748,110.373413 80.096603,110.375786 80.201736,110.452126 
	C80.704788,110.817451 80.687492,111.214821 79.955551,111.590729 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M82.297958,102.982834 
	C82.167305,102.079948 82.154076,100.942429 83.849854,101.755661 
	C83.556129,102.302650 83.078278,102.630486 82.297958,102.982834 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M80.685776,98.005554 
	C80.784286,98.524696 80.674286,99.294495 80.276237,99.496399 
	C79.663063,99.807404 79.253746,99.216202 79.039314,98.298149 
	C79.448380,98.000793 79.898285,98.001289 80.685776,98.005554 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M79.042786,104.311806 
	C79.447365,104.009369 79.892822,104.002167 80.672607,103.994843 
	C80.773651,104.509590 80.671829,105.272057 80.276588,105.481918 
	C79.667511,105.805305 79.258369,105.223686 79.042786,104.311806 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M78.999825,91.000168 
	C78.096901,90.921112 77.309723,90.678520 77.038147,89.325439 
	C76.993591,89.006714 76.999985,89.000031 77.003288,88.996887 
	C77.909180,89.077316 78.692352,89.327148 78.955986,90.680847 
	C79.000320,90.999634 79.000000,91.000000 78.999825,91.000168 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M54.999306,48.999268 
	C54.905998,49.628147 54.907124,50.346947 54.093704,50.489273 
	C53.922298,50.519268 53.683056,50.161575 53.475071,49.982517 
	C53.796093,49.680733 54.117111,49.378948 54.719803,49.039268 
	C55.001476,49.001377 55.000000,49.000000 54.999306,48.999268 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M46.459854,72.616081 
	C46.686886,73.417213 46.407028,73.707565 45.784611,73.584145 
	C45.655182,73.558479 45.480900,73.375938 45.461124,73.245415 
	C45.365932,72.617157 45.670769,72.353348 46.459854,72.616081 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M81.638130,107.757339 
	C81.623489,107.994049 81.495262,108.122993 81.367035,108.251930 
	C81.419540,108.051147 81.472046,107.850365 81.638130,107.757339 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M44.274338,67.977585 
	C44.446804,67.670380 44.922466,67.344528 45.699081,66.997627 
	C45.525867,67.304031 45.051697,67.631485 44.274338,67.977585 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M83.469162,109.453323 
	C83.521629,109.422569 83.416702,109.484070 83.469162,109.453323 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M916.942993,495.511414 
	C916.222290,495.889496 915.497681,495.960602 914.411438,495.979004 
	C913.618347,492.464783 912.281982,496.123474 911.225342,495.838043 
	C909.562073,496.368713 908.150696,496.660645 906.382324,496.899445 
	C905.481995,496.356049 904.871399,495.932953 904.321655,494.961121 
	C903.793518,493.438904 903.795044,492.237946 904.143250,490.689728 
	C905.233337,488.482086 905.545837,486.566040 904.497681,484.258972 
	C904.027588,483.088837 903.932922,482.201569 904.176270,480.973572 
	C904.193054,480.144257 905.538025,480.099701 904.557373,479.047424 
	C904.293823,478.328918 904.237366,477.894135 904.268494,477.121033 
	C904.550354,475.717102 904.741455,474.637695 904.612793,473.191101 
	C903.399048,462.318634 904.588440,451.721039 903.756592,441.172577 
	C903.602051,439.212006 903.633667,437.175293 905.153992,435.156616 
	C907.992065,432.271942 909.874878,429.089355 909.272827,425.500885 
	C907.369812,414.157318 910.312134,402.861877 909.422791,391.625031 
	C907.764893,370.677521 908.467834,349.708435 908.572998,328.774170 
	C908.615723,320.253876 907.482178,311.568207 909.468018,302.669556 
	C909.959106,301.810089 910.299622,301.364624 910.972290,300.661743 
	C919.344482,295.293488 928.533081,293.003510 937.829590,290.001801 
	C940.488525,290.383911 941.065613,291.995667 941.118530,294.344971 
	C940.992432,295.621368 940.725037,296.514404 940.820923,297.773804 
	C940.930054,298.760590 940.921082,299.416595 940.692017,300.375763 
	C940.803467,301.154358 939.350403,300.943359 940.382812,301.926178 
	C940.769775,302.587494 940.898743,303.007385 941.008484,303.774902 
	C941.028625,304.549408 940.988831,304.988678 940.847656,305.743896 
	C940.570129,306.886169 940.300232,307.698029 940.309998,308.879333 
	C940.313660,310.517548 940.711121,311.710175 941.618591,313.100159 
	C942.090576,314.341217 942.113342,315.296600 941.984375,316.631378 
	C941.629395,318.465973 941.382080,319.938385 941.391968,321.823242 
	C941.472168,323.487701 941.401550,324.771698 941.414917,326.441040 
	C941.400879,327.850189 941.437439,328.873596 941.389221,330.273987 
	C941.402405,332.140259 941.568787,333.615936 941.795166,335.453217 
	C941.816223,337.242004 941.402405,338.626160 941.405029,340.393250 
	C941.302063,342.370483 942.575378,343.643860 942.541260,345.579590 
	C941.988464,347.121796 941.329712,348.283844 941.351990,349.992188 
	C941.394104,351.718445 941.270691,353.122162 941.869080,354.812195 
	C942.224487,356.374725 942.240234,357.596649 942.063110,359.185059 
	C941.605530,361.193817 941.774658,362.827942 942.189209,364.814026 
	C942.357666,366.374664 942.308167,367.578278 942.199951,369.137146 
	C941.928894,370.867859 941.715515,372.244171 942.071289,373.990112 
	C942.285400,375.538452 942.232910,376.735931 942.090088,378.293274 
	C941.779724,380.347992 942.096497,382.016235 942.312012,384.064514 
	C942.432190,385.715271 942.403870,386.993286 942.399170,388.664307 
	C942.482300,390.117859 942.458191,391.178802 942.424438,392.643494 
	C942.480530,394.401459 942.471008,395.755463 942.414734,397.518036 
	C942.471741,399.019714 942.492371,400.112793 942.433472,401.617493 
	C942.484192,403.401489 942.489319,404.774414 942.440002,406.559967 
	C942.478333,408.347656 942.499023,409.723022 942.443176,411.510712 
	C942.468628,413.293396 942.490295,414.664124 942.441223,416.443756 
	C942.430176,417.935883 942.496643,419.019165 942.433594,420.503601 
	C942.451782,422.223450 942.442932,423.542725 942.416931,425.248169 
	C942.450684,427.143555 942.331543,428.664459 942.817017,430.514648 
	C943.116089,431.871857 943.143005,432.867981 942.887573,434.224182 
	C942.250183,435.969818 940.993652,436.769501 939.848816,438.108215 
	C937.894409,440.232269 935.581360,439.917053 933.097900,440.176483 
	C932.609009,440.392731 932.411133,440.479889 931.909302,440.686005 
	C931.221436,440.937347 930.842651,441.082703 930.269653,441.414215 
	C929.967651,442.156372 930.253052,442.632446 930.538269,443.428650 
	C930.613770,444.173859 930.509399,444.593536 930.085938,445.253082 
	C929.424927,445.755035 928.978638,445.931030 928.141846,446.101349 
	C927.023804,446.173096 926.299194,446.043732 925.277527,445.610718 
	C922.276550,441.343567 922.147766,445.828491 920.619385,446.883575 
	C918.268250,447.919128 918.694153,449.752716 918.471008,451.358887 
	C916.765198,463.639679 917.853088,475.979462 917.656616,488.291412 
	C917.630188,489.945160 918.068054,491.612885 917.241821,493.612640 
	C916.979309,494.386871 916.959290,494.795654 916.942993,495.511414 
z"/>
<path fill="#F9FAF4" opacity="1.000000" stroke="none" 
	d="
M917.453003,494.013550 
	C915.887268,478.609192 916.650696,463.237061 916.890930,447.864838 
	C916.927856,445.502075 918.460571,445.807495 920.376221,445.799011 
	C921.334473,445.496765 921.886292,445.426086 922.830566,445.742096 
	C923.535706,446.522125 923.557861,447.421051 924.050659,447.712067 
	C929.741882,451.072815 929.706543,456.529266 929.407471,462.083588 
	C928.979370,470.036957 931.045166,477.881256 930.418274,485.843689 
	C930.263977,487.803589 930.691223,489.841064 929.411255,492.042664 
	C925.809265,495.322449 921.674438,493.399628 917.453003,494.013550 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M935.120483,487.240417 
	C934.268555,488.749481 933.496155,489.934631 932.449463,491.268372 
	C930.655151,490.366028 930.041382,488.695374 930.238831,487.090546 
	C931.701355,475.208313 928.827820,463.420349 929.579346,451.563416 
	C929.683228,449.923981 929.478516,448.255341 930.320923,446.295166 
	C930.701965,445.695099 930.876648,445.475494 931.385986,445.021423 
	C932.222534,444.229797 932.982483,445.778687 933.627930,444.249878 
	C935.467468,442.539124 937.360107,442.631836 939.685364,443.024628 
	C940.597717,443.384338 941.038574,443.718231 941.621155,444.507141 
	C942.363586,446.181488 942.366699,447.570343 942.405884,449.361206 
	C942.398682,450.852112 942.429932,451.934662 942.404663,453.423676 
	C942.393066,454.375397 942.398621,454.920776 942.446411,455.879486 
	C942.507568,456.851349 942.507446,457.409851 942.461548,458.392517 
	C942.374634,463.402496 942.443848,467.988708 942.379395,472.995697 
	C942.015808,477.434235 939.142700,480.301086 937.768188,484.175781 
	C937.896912,484.560272 937.730042,484.621918 937.641113,484.625793 
	C936.424072,484.042297 936.612976,485.086578 936.275757,485.926758 
	C936.187378,486.264862 936.043701,486.154938 936.101501,486.085358 
	C935.769226,486.241180 935.452637,486.544830 935.120483,487.240417 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M938.170532,484.417847 
	C934.935547,480.126312 940.407043,478.393738 940.973267,474.741028 
	C943.604797,470.728577 947.547119,470.933228 951.768188,470.868042 
	C954.689331,471.725311 956.794922,473.208588 958.988342,475.239441 
	C959.454041,476.021484 959.524536,476.519257 959.231445,477.365601 
	C957.824463,477.857391 956.618591,478.023468 955.073975,478.344269 
	C954.725891,478.801300 954.716736,479.103668 954.456787,479.027832 
	C948.454346,479.130219 943.270935,481.203217 938.170532,484.417847 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M959.243774,477.794922 
	C959.038330,477.310150 959.046387,476.928986 959.035645,476.260468 
	C960.678650,472.896912 963.688416,473.650940 966.333557,473.432709 
	C968.270630,473.272888 970.210571,473.561951 972.617554,473.535767 
	C980.879578,472.998566 988.558960,474.062469 996.591797,475.520142 
	C996.980469,476.552429 997.008789,477.285095 997.052246,478.384277 
	C995.418152,480.921570 992.983215,480.466492 990.762817,480.552368 
	C985.382874,480.760284 979.983093,480.265656 974.229675,481.170624 
	C970.489929,482.235809 968.307739,479.650208 965.289307,478.338135 
	C963.832947,477.950470 962.704773,477.798248 961.235535,477.915039 
	C961.602661,478.868347 961.458252,479.256317 960.400757,478.820801 
	C960.076721,478.049866 959.790894,477.921082 959.243774,477.794922 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M960.748901,485.943817 
	C963.323792,486.623322 963.760010,488.212982 963.228943,490.494537 
	C962.664856,492.918060 960.945740,492.893646 959.087524,493.005768 
	C955.496094,493.222473 951.913696,493.649567 948.320679,493.755219 
	C946.520264,493.808105 943.811523,495.055908 943.163208,492.611084 
	C942.596313,490.473297 942.103027,487.678436 944.416565,485.744812 
	C945.038818,485.224792 945.604675,484.637329 946.537964,483.959198 
	C948.928711,482.547211 950.169495,483.660980 951.388306,485.233521 
	C953.552124,488.025208 957.277771,488.351776 960.748901,485.943817 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M929.554565,492.472168 
	C928.835571,481.238739 928.329712,470.050720 928.022522,458.857269 
	C927.808777,451.068726 927.890564,451.013916 920.596191,449.400208 
	C920.306458,447.593811 922.883972,448.248444 922.941162,446.396118 
	C923.178955,445.316223 923.683777,444.899048 924.718262,444.842163 
	C925.773560,444.991150 926.510193,445.003998 927.616028,445.004761 
	C930.003723,447.106018 929.995972,449.783264 929.982910,452.426056 
	C929.925903,463.945801 932.014465,475.425781 930.593201,486.976013 
	C930.413147,488.439117 931.420532,489.815582 931.198059,491.727264 
	C930.590210,492.260590 930.221313,492.387909 929.554565,492.472168 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M931.226624,492.189758 
	C929.885132,488.773865 929.921936,485.312073 929.982666,481.842407 
	C930.193542,469.796692 929.712891,457.787811 927.994751,445.419861 
	C928.340210,444.535309 928.695312,444.077911 929.498901,443.590698 
	C930.504211,443.582367 931.022827,443.734131 931.800415,444.299164 
	C929.844299,451.756744 930.850708,459.151978 931.324829,466.350708 
	C931.762634,472.997742 932.150635,479.557526 931.521240,486.190430 
	C931.385315,487.623047 931.876526,489.115173 932.127075,490.998413 
	C931.948181,491.693359 931.721191,491.969788 931.226624,492.189758 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M961.056030,485.556152 
	C960.889648,489.638580 959.568909,488.866669 955.995361,489.024536 
	C951.805237,489.209686 951.343567,487.635803 950.067688,485.312134 
	C949.528625,484.330322 948.688416,483.986816 947.264587,483.888855 
	C948.293091,480.963379 951.998901,481.564331 954.001953,478.962006 
	C954.206116,478.649658 954.430237,478.432068 954.582642,478.465515 
	C954.831787,482.022949 958.484192,479.771576 959.855469,481.792328 
	C959.971008,482.916534 960.208923,483.713898 960.790405,484.717651 
	C960.999817,484.953552 961.069824,485.353577 961.056030,485.556152 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M965.064331,478.429321 
	C968.021973,477.330566 970.033936,479.266052 972.527588,480.873657 
	C975.612061,480.936279 976.191406,482.863403 976.317932,485.384888 
	C975.462097,486.446991 975.534790,487.229370 976.065552,488.437134 
	C970.420166,487.776062 967.580322,483.499817 965.064331,478.429321 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M960.997803,484.630676 
	C960.085205,484.310059 958.736511,483.908844 959.786133,482.182129 
	C960.837585,482.602875 960.988647,483.425049 960.997803,484.630676 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M936.447815,486.139313 
	C936.041565,485.517487 936.050720,484.824707 937.197205,484.518738 
	C937.270874,485.091034 936.989563,485.552399 936.447815,486.139313 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M960.303650,478.638550 
	C960.314819,478.284851 960.724609,478.253204 960.809509,478.218628 
	C961.061707,478.580536 961.229004,478.977051 961.396301,479.373566 
	C961.028381,479.246490 960.660400,479.119385 960.303650,478.638550 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M935.323853,487.381958 
	C935.229797,487.167206 935.418518,486.770081 935.883301,486.194366 
	C935.975098,486.410370 935.790894,486.804962 935.323853,487.381958 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M904.859863,494.793579 
	C905.407349,495.442047 905.699280,495.873169 906.008301,496.575287 
	C895.716492,498.476379 885.271973,497.323273 874.466431,498.298279 
	C877.847595,495.632507 882.326721,497.835358 886.663879,496.348389 
	C887.584045,495.162201 888.560852,494.946167 889.900940,494.700104 
	C892.902771,494.784241 893.216675,492.209839 894.915894,490.708252 
	C895.679138,490.411621 896.142944,490.395996 896.918457,490.656921 
	C898.165100,495.060333 901.896301,493.813354 904.859863,494.793579 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M911.355225,496.174957 
	C912.029602,496.005402 912.220337,492.279877 914.035645,495.640594 
	C913.278809,496.041901 912.507874,496.157532 911.355225,496.174957 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M973.680786,918.737305 
	C973.922607,920.062744 973.955933,921.131104 973.970642,922.600342 
	C972.520508,923.175415 971.698608,924.150330 972.069275,925.400635 
	C973.834656,931.355957 971.975891,937.136719 971.581116,943.009583 
	C970.862122,953.705872 969.685181,964.387451 969.892883,975.136597 
	C969.900452,975.531067 969.512939,975.933228 968.877319,977.178589 
	C967.490967,971.535950 966.647095,966.658936 967.033325,961.652039 
	C967.321289,957.918030 966.554504,954.724426 963.158569,952.157043 
	C962.218079,950.616211 961.433533,949.318237 960.979248,947.913513 
	C959.207458,942.434692 955.323181,940.428589 949.424805,940.810303 
	C948.918457,938.520569 949.989136,937.646362 952.084595,938.205933 
	C954.624573,938.884338 957.144104,939.646545 959.648865,940.446533 
	C960.535339,940.729614 961.219910,942.016418 962.252563,941.380920 
	C963.427246,940.658020 963.119812,939.269592 962.833923,938.219666 
	C961.519104,933.391479 961.910034,928.305359 958.733215,923.702026 
	C955.662537,919.252380 959.573914,908.011414 964.692871,904.146729 
	C965.216187,903.882874 965.437256,903.770569 965.981934,903.842651 
	C966.747925,904.660217 966.887878,905.374878 966.830078,906.491943 
	C966.578430,907.782227 966.193909,908.641846 965.565796,909.743896 
	C965.142090,910.376282 964.552856,910.807678 964.814148,911.137939 
	C965.305054,911.758423 965.836670,911.075500 966.635254,910.737488 
	C967.346436,910.436951 967.777832,910.346680 968.556335,910.336060 
	C971.957214,910.482605 973.962341,911.441223 973.047485,915.135254 
	C972.785522,916.193237 972.833496,917.429077 973.680786,918.737305 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M973.921936,918.557800 
	C972.136292,918.788513 971.815552,917.503601 972.041870,916.151489 
	C972.471985,913.581421 972.328186,911.502014 968.990479,910.902344 
	C969.142273,908.208374 970.661560,905.357056 966.459045,904.203918 
	C965.970093,904.039368 965.775146,904.029602 965.287659,904.007446 
	C965.330261,902.302368 965.665344,900.609619 966.003906,898.542358 
	C967.451233,898.469055 968.895020,898.770386 970.715881,899.122192 
	C973.675354,902.271484 971.958435,905.985291 972.799805,909.689697 
	C974.910950,912.539856 973.579407,915.425903 973.921936,918.557800 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M913.953857,909.677979 
	C910.801331,904.562683 911.242004,903.369263 916.528320,903.158691 
	C916.931702,903.245911 916.967102,903.669861 917.057617,903.862305 
	C917.389648,904.359985 917.615601,904.676331 917.892700,905.286682 
	C916.842285,907.039429 917.254639,909.905518 913.953857,909.677979 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M917.897949,905.279358 
	C917.697998,905.271973 917.438965,904.972717 917.164062,904.364136 
	C917.378418,904.365723 917.608643,904.676575 917.897949,905.279358 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M919.541321,903.472168 
	C919.569153,903.520020 919.513489,903.424255 919.541321,903.472168 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M948.675415,954.711792 
	C948.973267,963.184814 948.906616,971.343506 948.985229,979.500732 
	C949.006531,981.710205 948.519409,983.775696 947.990601,986.271545 
	C946.843018,988.502197 945.088318,988.259216 942.953735,987.953735 
	C940.278687,985.566406 937.466309,984.352478 934.054321,983.463013 
	C932.715454,981.884827 932.676941,980.349426 932.992310,978.406128 
	C933.219910,977.443665 934.130127,977.041565 933.427063,975.915527 
	C933.210876,975.090576 933.171753,974.602051 933.225098,973.736694 
	C933.833923,969.879089 933.806763,966.391052 933.257629,962.520996 
	C933.161072,961.622559 933.204956,961.110535 933.482788,960.248230 
	C935.675171,958.301025 937.385193,956.383301 939.454529,954.262390 
	C942.703735,953.299683 945.563477,953.097778 948.675415,954.711792 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M941.740479,986.557007 
	C943.732605,986.759583 945.431885,986.786804 947.550659,986.743652 
	C952.760742,987.959778 954.034485,986.144653 953.562256,981.350464 
	C952.977295,975.412537 953.230469,969.389526 953.181702,963.402771 
	C953.166870,961.579224 953.384277,959.763855 954.609924,958.251953 
	C954.935913,958.403259 955.471069,958.533020 955.472839,958.669373 
	C955.596252,968.458374 955.663757,978.248108 955.772888,988.037354 
	C955.795288,990.040405 955.127441,991.079224 952.904175,991.080383 
	C946.432800,991.083740 939.960754,991.111145 933.568176,992.443848 
	C930.824036,993.015869 931.156921,990.690491 931.152954,989.215027 
	C931.120728,977.409912 931.195312,965.604553 931.291870,953.323242 
	C932.240051,952.017334 933.279358,951.991699 934.732056,952.494629 
	C935.434082,953.113831 935.656189,953.594055 935.770874,954.530151 
	C935.596741,956.480957 935.405640,958.036438 934.286865,959.703735 
	C934.026123,960.457458 933.998657,960.901672 934.041992,961.674438 
	C934.899963,965.669128 934.318665,969.378479 934.365845,973.518372 
	C934.235779,974.424316 934.201965,974.876770 934.223145,975.666260 
	C934.311584,976.166565 934.345032,976.329895 934.344299,976.740967 
	C934.299072,978.696960 934.288025,980.405334 934.363159,982.532043 
	C935.850769,985.993835 939.123779,985.219543 941.740479,986.557007 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M935.346802,955.209473 
	C935.001770,954.512512 934.978149,954.125549 934.924011,953.448853 
	C936.990051,950.101685 940.460083,950.243774 943.392456,950.215637 
	C948.331543,950.168274 953.269714,949.721924 958.629761,949.946655 
	C960.842957,951.305359 960.904602,953.353149 960.912842,955.300293 
	C960.959900,966.456421 960.945435,977.612976 960.899109,988.769226 
	C960.891052,990.709961 960.923584,992.774109 959.045837,993.804810 
	C959.045837,982.353088 958.908325,970.853455 959.125122,959.360535 
	C959.194885,955.660156 958.155701,954.120605 954.377930,954.711853 
	C952.912354,954.941284 951.386414,954.784851 949.436646,954.915405 
	C945.960449,954.998596 942.935547,954.970459 939.472534,955.062988 
	C937.977783,955.952148 936.855835,956.065857 935.346802,955.209473 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M958.721924,949.656494 
	C954.847473,952.241638 950.111145,951.169434 945.703735,951.530518 
	C942.294189,951.809937 938.998291,952.301086 935.289429,953.072266 
	C933.949402,953.064636 933.005310,952.970093 931.703857,952.861450 
	C930.137573,949.020996 933.346436,949.577393 935.081055,949.530640 
	C942.848450,949.320984 950.623901,949.409424 958.721924,949.656494 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M927.107422,949.291748 
	C927.023132,963.989502 927.053650,978.413269 926.948792,993.507385 
	C925.131653,988.079895 925.073120,981.635254 925.452820,975.600342 
	C926.001221,966.882385 923.877380,958.129395 926.343323,949.253540 
	C926.826294,949.008789 927.024292,949.013306 927.107422,949.291748 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M931.916443,995.417358 
	C940.099121,993.387146 948.174988,993.924866 956.218384,993.651001 
	C948.598511,995.992065 940.602234,995.405273 932.449219,996.724243 
	C931.726379,996.453125 931.591248,996.056946 931.916443,995.417358 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M944.259888,946.291626 
	C948.253418,943.571716 952.466492,943.974792 956.689087,945.818787 
	C952.683105,947.188049 948.583984,946.906250 944.259888,946.291626 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M935.065063,946.474426 
	C933.026978,947.294006 930.774597,946.375183 928.667725,948.160034 
	C928.116150,948.243103 927.918884,948.177307 927.607178,947.821472 
	C928.703979,945.060303 930.860046,944.708618 933.662964,945.048767 
	C934.497742,945.361694 934.860474,945.677551 935.065063,946.474426 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M935.467651,946.892822 
	C934.750793,946.425842 934.490845,946.012085 934.137939,945.372314 
	C936.569580,945.115784 939.134460,944.588013 942.466614,945.604980 
	C939.994690,947.629211 937.839478,946.718750 935.467651,946.892822 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M931.818176,995.177002 
	C932.177856,995.583496 932.162048,995.930542 932.095459,996.532227 
	C929.372375,998.646057 928.414673,996.148926 926.908691,994.490356 
	C926.813416,994.177795 927.028442,993.960999 927.132812,993.844604 
	C928.638977,994.191345 930.040894,994.654419 931.818176,995.177002 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M926.799927,949.092346 
	C926.785522,948.653809 926.942810,948.303345 927.296387,947.742126 
	C927.630981,947.659241 927.769287,947.787170 928.110474,948.111938 
	C928.061951,948.636169 927.810547,948.963562 927.275879,949.428406 
	C926.992615,949.565796 926.971619,949.180420 926.799927,949.092346 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M104.680695,114.025429 
	C104.800087,115.840851 105.290474,117.564758 105.927589,119.651993 
	C103.705482,119.526131 101.044708,121.202560 99.099548,118.364182 
	C99.759880,117.285965 100.454887,116.559944 101.515686,115.365952 
	C102.786446,114.685341 103.574722,114.368858 104.680695,114.025429 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M97.722122,113.208641 
	C99.368149,113.259842 102.219597,108.953285 101.997345,114.645767 
	C101.998169,115.001831 102.000000,115.000000 102.000916,114.999084 
	C101.355476,115.682640 100.602592,116.136192 99.284500,116.065834 
	C97.286728,115.817184 96.607941,115.047714 97.722122,113.208641 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M88.695099,125.842880 
	C88.608772,124.021965 88.739708,122.116554 89.168587,120.280762 
	C89.529961,118.733917 90.318329,119.208519 91.060028,120.525116 
	C90.772346,122.640320 91.643654,124.954613 88.695099,125.842880 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M98.961517,116.359711 
	C99.500664,115.148857 100.376427,115.001579 101.659424,115.000641 
	C102.025826,116.569733 101.887451,118.019409 99.397026,117.980019 
	C99.011894,117.548477 98.993950,117.116158 98.961517,116.359711 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M93.983292,112.859634 
	C93.425972,112.954346 92.897194,112.709755 92.183044,112.236694 
	C91.618179,111.618477 91.473488,111.155357 91.787704,110.309448 
	C92.011879,110.000000 91.998734,109.998581 91.999367,110.005165 
	C92.677544,109.426399 93.444420,109.263268 94.644554,109.756805 
	C94.987953,109.988693 94.998055,109.998283 95.003418,110.004913 
	C94.676460,110.847809 94.344147,111.684067 93.983292,112.859634 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M84.310898,130.953369 
	C83.672279,130.230728 83.357391,129.424759 83.118362,128.298035 
	C83.372932,127.984726 83.551643,127.992172 83.980492,127.899521 
	C85.269547,128.703995 84.823135,129.803986 84.310898,130.953369 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M80.087029,124.300964 
	C80.873169,122.894279 81.306244,123.796082 81.966415,124.645279 
	C81.341171,125.543488 80.708618,125.260307 80.087029,124.300964 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M79.762711,122.624069 
	C80.231400,122.713799 80.420776,122.955925 80.338486,123.570625 
	C79.179146,123.900909 79.040482,123.484093 79.762711,122.624069 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M41.032310,96.652557 
	C40.247257,96.995644 39.497208,96.994034 38.372036,96.997772 
	C37.895702,94.707016 38.550987,93.027039 41.625443,93.004234 
	C41.690556,94.101234 41.378937,95.204544 41.032310,96.652557 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M48.001293,96.998657 
	C46.806526,96.870972 45.161129,97.243408 45.219048,95.330490 
	C45.272972,93.549675 46.677853,93.070236 48.612900,92.996674 
	C48.988838,92.988777 49.000748,93.000839 49.005470,93.005760 
	C50.068199,94.327133 49.408783,95.396790 48.257782,96.718048 
	C47.997189,97.002838 47.999901,97.000000 48.001293,96.998657 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M37.999969,99.624939 
	C37.249950,99.999893 36.499973,99.999863 35.375004,99.999924 
	C34.999893,99.249992 34.999779,98.499977 34.999763,97.374916 
	C35.749924,96.999695 36.499981,96.999535 37.625107,96.999603 
	C38.000118,97.749878 38.000069,98.499916 37.999969,99.624939 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M915.128052,527.197388 
	C916.166870,527.020142 917.026855,526.805786 917.545593,527.639404 
	C917.641968,527.794250 917.408997,528.394287 917.249084,528.429443 
	C916.212280,528.657349 915.372620,528.329529 915.128052,527.197388 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M989.179321,523.300171 
	C990.363892,523.148682 991.295105,523.148682 992.699463,523.148682 
	C991.125549,524.437500 990.027283,524.067932 989.179321,523.300171 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M1011.256958,522.273682 
	C1011.532715,521.982300 1011.938293,521.910950 1012.650757,521.891968 
	C1012.628113,522.682251 1012.156555,523.014282 1011.256958,522.273682 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M980.760498,525.067383 
	C981.003906,525.062927 980.655029,525.369568 980.655029,525.369568 
	C980.655029,525.369568 980.225952,525.309509 980.128052,525.186646 
	C980.030212,525.063843 980.517090,525.071838 980.760498,525.067383 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M1009.942017,632.624207 
	C1009.536926,633.003540 1009.087036,633.009583 1008.299072,633.025879 
	C1005.920288,630.575012 1008.029175,627.889832 1007.288574,625.158875 
	C1007.009888,624.796936 1006.988647,624.620789 1006.941162,624.179688 
	C1006.607117,623.519287 1006.488464,623.073486 1006.776794,622.288696 
	C1006.994873,622.000000 1007.000000,622.000000 1007.000000,621.996338 
	C1007.328674,621.667419 1007.703125,621.406433 1008.454529,621.120972 
	C1009.260132,621.015381 1009.722839,621.048462 1010.512329,621.256836 
	C1011.036987,621.505066 1011.230713,621.636658 1011.706177,622.395752 
	C1012.267090,624.544434 1015.186401,626.665466 1010.342651,626.671753 
	C1008.062744,626.674683 1009.286194,630.231018 1009.942017,632.624207 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1009.214966,621.753296 
	C1008.510132,621.912964 1008.077148,621.911072 1007.322083,621.950928 
	C1007.008179,621.205688 1007.016357,620.418762 1007.003723,619.238525 
	C1006.508667,618.429016 1006.018372,618.031067 1005.360840,617.352295 
	C1005.117981,616.320862 1005.072571,615.535706 1005.038635,614.356628 
	C1006.200745,614.358276 1007.351379,614.753967 1008.867188,615.202271 
	C1009.385376,615.375549 1009.538391,615.496155 1009.872803,615.849670 
	C1010.158630,616.251953 1010.263123,616.421265 1010.500427,616.862915 
	C1010.697327,617.329773 1010.761292,617.524353 1010.870789,618.025635 
	C1010.999023,619.664062 1010.784302,620.865234 1009.214966,621.753296 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M1003.793945,629.126465 
	C1005.203674,629.787781 1005.549072,631.056641 1005.905884,632.658813 
	C1003.501526,631.577332 999.932739,633.757080 998.081848,630.147461 
	C998.588989,628.998901 999.388306,628.726685 1000.599976,628.762573 
	C1001.578857,630.386169 1002.385254,631.018921 1003.793945,629.126465 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1000.858887,628.536743 
	C1000.164673,629.201172 999.420837,629.533508 998.370117,629.834229 
	C997.149231,628.164856 995.951904,626.612671 996.147766,623.796936 
	C998.051514,625.597046 999.430420,626.900818 1000.858887,628.536743 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M976.352783,625.643250 
	C975.719971,625.007324 975.343506,624.204407 974.941528,623.056091 
	C976.041321,622.619263 976.645874,620.287292 978.062256,621.789429 
	C980.002197,623.846680 976.622437,624.046753 976.352783,625.643250 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1004.978638,617.359741 
	C1006.049622,617.031250 1006.680298,617.337646 1006.938354,618.555786 
	C1006.523560,618.977966 1006.015564,619.027161 1005.614929,619.260498 
	C1004.768494,619.753845 1004.077148,621.641174 1002.990601,620.141846 
	C1001.659851,618.305542 1004.086182,618.414246 1004.978638,617.359741 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M984.006592,619.322876 
	C984.908386,619.032166 986.112732,618.613403 986.523438,619.692078 
	C986.913208,620.715759 985.742737,621.021179 985.066956,621.176880 
	C983.720032,621.487549 984.197937,620.284241 984.006592,619.322876 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1000.784424,618.247070 
	C1000.766235,619.257996 1000.390991,619.875061 999.699402,619.542603 
	C999.359558,619.379272 999.101257,618.390381 999.274231,617.965576 
	C999.551392,617.284729 1000.218811,617.328125 1000.784424,618.247070 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M991.993530,622.006348 
	C992.878357,622.000610 993.769531,621.988525 994.660767,621.976440 
	C994.482483,622.386780 994.411133,622.922119 994.105530,623.183655 
	C993.222595,623.939148 992.404541,624.036987 992.045532,622.299438 
	C992.012085,621.986816 992.000000,622.000000 991.993530,622.006348 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1001.971191,623.656616 
	C1001.092163,623.893616 1000.013794,624.324036 999.448853,623.245972 
	C999.358398,623.073364 999.555664,622.571228 999.755676,622.455017 
	C1000.795105,621.850769 1001.556946,622.145020 1001.971191,623.656616 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1002.010498,623.989624 
	C1003.553589,623.985229 1003.972900,624.953491 1004.013062,626.617065 
	C1004.031616,626.968506 1003.997192,627.002808 1003.979370,627.020508 
	C1002.404541,627.029968 1001.979736,626.076111 1002.007568,624.370361 
	C1001.985046,624.015259 1002.001709,623.998291 1002.010498,623.989624 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M981.987915,616.009521 
	C983.276367,616.226624 984.232239,616.753052 984.051636,618.648010 
	C983.997559,619.002441 984.000000,619.000000 984.000183,619.000000 
	C982.885803,618.596008 982.108948,617.916321 982.046631,616.305908 
	C982.023926,615.977051 981.998535,615.997314 981.987915,616.009521 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1006.676147,622.004028 
	C1006.988647,622.426758 1006.982422,622.853577 1006.945496,623.597534 
	C1006.376831,623.673584 1005.555786,623.566345 1005.364319,623.161377 
	C1005.044373,622.484863 1005.672424,622.105286 1006.676147,622.004028 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M981.532471,624.449097 
	C981.538025,623.920593 981.743713,623.597473 981.949402,623.274353 
	C982.209351,623.544617 982.469299,623.814941 982.729187,624.085266 
	C982.396973,624.275024 982.064758,624.464783 981.532471,624.449097 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M996.591431,632.046143 
	C996.196899,632.761597 995.798706,632.775879 995.445374,632.263428 
	C995.371704,632.156677 995.375122,631.906311 995.451660,631.801880 
	C995.817017,631.304077 996.214966,631.317749 996.591431,632.046143 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M996.989868,620.769714 
	C996.775757,620.556274 996.774048,620.346069 996.772339,620.135925 
	C996.913879,620.138916 997.173157,620.120667 997.178101,620.148315 
	C997.214722,620.351379 997.200500,620.563660 996.989868,620.769714 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M980.301819,620.502747 
	C980.091003,619.898560 980.135254,619.351501 980.703857,619.679199 
	C981.126160,619.922546 980.987244,620.421448 980.301819,620.502747 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M974.948547,618.925232 
	C974.604248,619.100830 974.315125,618.894836 973.878540,618.465698 
	C973.731750,618.014832 973.732361,617.787048 974.071228,617.608337 
	C974.409424,617.657410 974.766235,617.651733 974.933228,617.715210 
	C975.068115,618.033630 975.035950,618.288635 974.948547,618.925232 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M981.469238,630.454590 
	C981.519165,630.426147 981.419312,630.482971 981.469238,630.454590 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1011.766052,621.497314 
	C1012.940674,621.057495 1013.820007,621.170715 1014.011230,622.658936 
	C1013.548584,622.997620 1013.102844,623.000977 1012.322510,623.013794 
	C1011.987976,623.023193 1011.994995,623.004456 1011.986572,623.004089 
	C1011.730835,622.702209 1011.578369,622.358521 1011.766052,621.497314 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1012.380005,629.762817 
	C1012.000793,629.808411 1011.762817,629.677063 1011.524841,629.545715 
	C1011.621033,629.431396 1011.755737,629.204346 1011.806824,629.221802 
	C1012.057251,629.307312 1012.285339,629.458069 1012.380005,629.762817 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M658.460815,507.361938 
	C657.890137,508.176392 657.588440,508.783112 657.141174,509.697021 
	C652.411072,513.726929 648.439392,518.334167 642.095276,520.011597 
	C641.197693,519.875549 640.730835,519.674011 640.147095,519.005005 
	C639.979736,518.654907 639.992615,518.429260 640.018616,518.319336 
	C641.104980,516.790955 640.731812,515.232361 640.421753,513.267761 
	C639.644592,511.475830 639.581604,509.984619 639.586487,508.487671 
	C639.631042,494.731018 639.406738,480.973602 639.771973,466.810364 
	C640.620056,464.050415 644.783875,462.053009 640.400269,458.854370 
	C639.168701,454.948669 639.636169,451.293976 639.707031,447.303650 
	C639.888062,446.084076 640.187073,445.230957 639.771301,444.056946 
	C639.555481,443.578857 639.465515,443.388336 639.251465,442.905823 
	C638.826782,441.823425 638.599304,441.002960 637.982117,439.996521 
	C635.013428,437.657837 634.378723,435.601044 635.330322,431.743164 
	C636.906799,425.352203 635.473022,418.584320 635.078613,411.982117 
	C634.943115,409.713531 634.194153,407.192902 638.263794,406.657227 
	C636.274841,405.700073 634.379639,405.622803 632.920044,404.046143 
	C633.559998,400.939240 636.001587,401.020538 638.533447,400.598511 
	C642.918030,396.491516 643.577515,391.805267 641.563660,386.268494 
	C643.777039,383.338287 647.544434,384.163513 650.166504,381.773132 
	C650.716980,381.481903 650.949524,381.385132 651.556641,381.215210 
	C652.187439,381.148163 652.443604,381.154297 653.069946,381.263489 
	C653.651855,381.509338 653.863403,381.652161 654.201782,382.155090 
	C653.835999,385.529053 651.956604,387.923218 650.648254,390.558533 
	C646.174072,399.570557 644.455750,409.245972 643.526123,419.461914 
	C643.640564,420.030273 643.690979,420.254211 643.784424,420.817902 
	C643.825928,421.376740 643.824463,421.595856 643.772217,422.132080 
	C643.250610,423.346558 643.942566,423.914154 644.356323,424.884216 
	C644.132263,426.323792 644.700439,427.136475 645.575195,428.179077 
	C646.650696,433.838501 645.876160,439.404297 647.566833,445.040833 
	C646.808716,446.776794 646.088623,448.163849 647.588623,449.926666 
	C648.890747,456.274994 653.035095,461.096252 654.624084,467.316467 
	C654.791138,468.091034 655.970825,468.473419 654.843262,469.013458 
	C655.997437,468.519379 654.851196,468.112152 654.652832,467.343506 
	C653.351135,463.138489 651.598877,459.498505 649.776917,455.899963 
	C649.042542,454.449677 648.079529,453.131561 648.577148,451.072266 
	C650.106079,449.611603 651.805054,449.722809 653.665283,449.349670 
	C654.773926,447.408936 650.745056,447.756653 652.290222,445.769897 
	C653.758789,443.881683 655.682251,442.630859 658.623413,443.348450 
	C660.001282,444.159241 660.615479,445.207855 661.471863,446.518524 
	C661.846802,447.275055 662.012390,447.726471 662.234497,448.534119 
	C662.732056,450.692749 663.182739,452.496490 663.749695,454.615295 
	C664.117798,456.020477 664.181274,457.129303 664.242126,458.240692 
	C664.278564,458.905701 664.095398,458.072937 664.270386,458.711914 
	C664.377075,459.101410 664.566467,459.012268 664.560059,458.212036 
	C664.668701,455.487640 663.194153,453.149902 664.378723,450.356384 
	C665.065491,449.448486 665.729919,449.140717 666.789307,448.844299 
	C669.700928,448.857971 670.226074,446.844666 671.127319,444.751862 
	C671.865234,443.657288 672.656311,443.269196 673.959351,443.236938 
	C675.148743,443.449249 675.861511,444.012482 677.040527,444.219482 
	C677.560181,444.328949 677.765259,444.386505 678.252686,444.592102 
	C679.672546,445.719086 681.184265,446.013031 682.664917,447.028259 
	C684.936401,448.836517 687.173157,448.998138 689.855347,448.139893 
	C690.758179,447.829865 691.371338,447.678680 692.301636,447.574646 
	C693.348511,447.641479 694.053284,448.080841 695.106567,447.703674 
	C695.569092,447.534119 695.760498,447.466339 696.227356,447.339935 
	C696.872192,447.103607 697.485596,447.693298 697.628967,446.647461 
	C697.642700,446.196503 697.690674,446.010406 697.893494,445.567780 
	C698.895508,444.399902 698.649719,443.388550 698.260132,442.039368 
	C698.227478,441.263184 698.302307,440.825836 698.567383,440.098145 
	C699.570129,438.875000 699.646545,437.899261 699.066162,436.759460 
	C697.888184,434.446198 698.885071,433.168488 701.525513,432.599976 
	C705.023865,434.343842 705.379700,437.978119 707.256836,440.583313 
	C708.490540,442.295715 709.244019,444.359589 711.286377,445.873016 
	C711.741943,446.205658 711.914673,446.351654 712.302368,446.759949 
	C712.741638,447.412476 712.933533,447.818237 713.211792,448.549255 
	C713.648254,450.786346 716.219055,450.984100 716.446594,453.312653 
	C715.480347,455.719086 713.817200,457.309296 712.856873,459.368103 
	C711.956787,461.297546 710.365051,462.252289 707.811523,461.745667 
	C705.727417,460.195404 707.137329,458.694550 707.447571,456.894806 
	C707.551086,456.159637 707.551453,455.749725 707.353760,455.125122 
	C707.047058,454.890015 706.880310,454.870758 706.500183,455.014221 
	C705.638184,455.939545 705.076904,456.794464 703.789795,457.262451 
	C701.234070,456.656799 701.552795,453.897186 699.528748,452.678040 
	C695.997742,455.962433 698.498047,459.781799 698.844910,463.194214 
	C699.038025,465.094055 699.695496,467.013397 699.757996,469.324829 
	C700.289001,470.878052 699.817017,472.261200 700.673828,473.707031 
	C702.477356,475.330841 702.486511,477.127686 700.948425,478.133484 
	C698.839417,479.512573 699.255615,477.045410 698.758606,476.121490 
	C698.050903,474.806000 696.842224,475.102509 695.345825,475.008667 
	C694.783936,475.138092 694.613159,475.263977 694.145630,475.276855 
	C693.595032,474.825928 693.433594,474.450317 693.429199,473.729370 
	C693.249878,472.945496 694.662659,473.182190 693.703613,472.234711 
	C693.408203,471.834991 693.310181,471.659210 693.096863,471.202271 
	C692.775269,470.339478 692.601807,469.747375 692.346008,468.847412 
	C692.221680,468.109558 692.217590,467.681580 692.313965,466.934387 
	C692.695435,465.236816 693.520935,463.815247 691.816528,462.332031 
	C691.419800,461.668488 691.291077,461.247925 691.222290,460.481323 
	C691.243713,458.793762 691.566284,457.367737 690.106567,456.311279 
	C688.850220,457.121796 688.904785,458.525360 687.826599,459.629089 
	C686.834106,460.498993 686.519104,461.345581 686.233459,462.284088 
	C685.834595,463.594360 685.215820,464.833038 687.726807,464.657288 
	C688.609253,468.397003 687.711670,471.822144 687.903503,475.617859 
	C687.690613,478.126556 683.976562,476.433777 684.251709,479.516052 
	C682.822693,482.453491 683.378296,485.191162 683.693359,488.238678 
	C684.036499,489.689240 683.982544,490.766296 683.339966,491.760254 
	C684.403259,490.553131 684.735657,488.954498 685.754150,487.301880 
	C688.842651,481.549530 687.345276,475.518097 688.506775,469.465393 
	C690.170898,468.360596 690.739197,469.523621 691.654053,470.735352 
	C692.826050,477.721771 693.195435,484.390472 693.950623,491.416962 
	C694.222839,493.388489 693.050903,494.709259 693.265869,496.615723 
	C693.467896,497.449127 693.507568,497.931641 693.235840,498.703430 
	C692.764404,500.256348 692.520874,501.526154 692.022949,502.934143 
	C691.292603,503.393158 690.738403,503.529297 689.953247,503.857544 
	C688.991516,504.344666 688.303711,504.734497 687.301758,505.188049 
	C686.391235,505.439667 685.766479,505.397858 684.827759,505.325989 
	C684.094543,505.283081 683.674805,505.267853 682.937134,505.284363 
	C681.533447,505.340851 680.494385,505.617462 679.138062,506.000427 
	C677.509644,506.352142 676.164307,506.432434 674.575928,506.983582 
	C671.147827,508.662445 667.748413,507.520935 664.196777,508.106262 
	C660.200317,507.307617 659.798096,504.975342 660.876465,501.996765 
	C659.853149,503.520752 660.337463,505.775574 658.460815,507.361938 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M668.752441,579.798950 
	C668.921875,580.568542 668.959778,580.982361 669.006348,581.707703 
	C669.590149,582.714417 669.698242,583.502197 669.436218,584.341431 
	C665.149231,598.074097 663.232361,612.389832 659.141907,626.169128 
	C658.462708,628.456909 658.749817,630.767151 658.547852,633.451660 
	C657.137939,635.177673 655.617615,635.057495 654.397583,634.039551 
	C648.985291,629.523560 642.076660,628.585083 635.815430,626.123596 
	C626.908508,622.621826 617.630188,620.062622 608.861694,615.252075 
	C607.706909,613.340149 608.130981,611.680908 608.534607,610.099060 
	C611.513794,598.420898 614.040039,586.598877 618.932861,575.503296 
	C619.897461,573.315918 620.525940,570.638550 623.974487,570.263062 
	C624.508606,570.353027 624.678040,570.386841 624.819214,570.469238 
	C627.132751,571.819153 629.092651,574.860657 632.261780,572.729126 
	C635.365784,570.641357 634.470154,567.524658 633.679932,564.573669 
	C633.504517,563.918396 633.593018,563.256958 634.077271,562.315918 
	C639.711121,559.196655 645.322021,558.723999 651.450928,560.727295 
	C652.515076,561.610474 652.795837,562.507935 653.111755,563.416687 
	C653.438782,564.357483 653.002869,566.044739 654.608704,565.909973 
	C655.846436,565.806030 655.695862,564.123840 656.627136,563.013123 
	C658.797546,561.764587 660.214050,563.174133 662.132141,563.978271 
	C665.791748,568.744812 667.560181,573.951416 668.752441,579.798950 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M774.066589,648.979492 
	C770.154968,661.979065 762.679932,672.094360 751.186584,679.186646 
	C749.647156,680.136597 748.765625,679.406860 747.591980,678.922424 
	C741.300659,676.325806 735.002502,673.745850 728.389893,670.990356 
	C726.249634,668.799866 727.362244,666.624084 727.824951,664.136230 
	C728.169250,662.876770 728.537598,662.006165 728.945496,660.785767 
	C729.153015,660.255005 729.245056,660.047913 729.499878,659.546448 
	C731.008789,657.266174 732.163574,655.194397 732.714783,652.496216 
	C733.543274,651.523132 733.509216,650.630981 733.729248,649.471130 
	C734.717468,648.068604 734.690063,646.662048 735.254944,645.239685 
	C735.318787,645.039185 735.472046,644.840759 735.472046,644.840759 
	C735.472046,644.840759 735.257935,644.758545 735.258484,644.941650 
	C734.918823,646.177856 734.567566,647.228088 734.231079,648.613403 
	C733.363525,649.637085 733.547546,650.621399 733.141479,651.801453 
	C732.190796,653.302979 732.278992,655.241211 729.850769,654.979004 
	C727.949951,651.982727 728.905640,649.269226 729.902344,646.690308 
	C731.201843,643.328186 732.333862,639.905823 733.839722,636.207275 
	C734.437317,635.193176 735.003235,634.710449 736.144348,634.512207 
	C737.698608,633.929688 737.480164,637.912415 739.471191,635.117065 
	C740.023438,634.615356 740.410339,634.448547 741.144897,634.408936 
	C741.935059,634.503113 742.336670,635.186035 743.090637,634.407959 
	C743.665344,633.727478 744.082947,633.295166 744.773682,632.691284 
	C745.418579,632.319214 745.828674,632.205322 746.576904,632.156616 
	C747.103394,632.218689 747.308167,632.272522 747.781372,632.489014 
	C748.318298,633.047729 748.599548,633.441406 748.292419,633.945374 
	C748.559998,633.796143 748.661865,633.556885 748.736816,632.986328 
	C749.183228,632.520752 749.506653,632.322388 750.073242,631.975647 
	C751.274292,629.232483 750.420044,626.617004 750.591309,623.668579 
	C752.543274,620.637878 755.329407,620.306458 758.613708,620.502502 
	C760.328430,623.933838 758.312256,626.471863 757.456116,629.291809 
	C758.291870,626.796753 759.608154,624.444519 759.518311,621.270386 
	C759.703491,620.112000 760.207520,619.660400 761.342651,619.542664 
	C764.202087,621.245850 761.778076,623.722839 762.626770,625.616638 
	C762.239746,624.287231 762.754883,623.028137 763.271851,621.464600 
	C763.598694,621.035400 763.763489,620.893555 764.238403,620.695190 
	C764.988464,620.399719 765.034729,621.554993 765.442993,620.940735 
	C765.562317,620.761169 765.193237,620.140686 765.211426,619.343323 
	C769.259888,614.730652 774.931335,615.257996 780.310791,613.935913 
	C780.914612,614.075012 781.146423,614.157410 781.675781,614.448608 
	C782.709290,617.713806 779.959290,619.151917 778.830139,621.334229 
	C778.017334,622.905090 776.821350,624.269409 776.016846,626.249878 
	C775.750549,626.750549 775.630798,626.942810 775.292053,627.392090 
	C772.623840,629.640564 771.065674,632.229980 769.893311,635.479858 
	C769.645325,635.989075 769.531677,636.186829 769.211792,636.659241 
	C764.687195,642.706238 762.201904,649.396484 759.373169,656.292725 
	C758.504639,657.621704 757.997925,658.753784 757.597229,659.939331 
	C757.955444,659.138672 758.262695,658.315979 758.836548,657.235352 
	C760.683105,652.465149 762.703186,648.160828 765.530457,643.923950 
	C768.695618,644.328125 767.802368,646.327332 767.288574,647.951843 
	C766.303711,651.065796 764.976868,654.059631 763.592407,657.016907 
	C764.379761,655.252686 765.430847,653.731323 767.548096,652.792480 
	C768.273926,653.049255 768.564575,653.392883 768.814331,654.151245 
	C768.898926,655.133240 768.724060,655.755005 768.526428,656.676270 
	C768.453491,657.290771 768.220703,657.505066 768.110474,657.755615 
	C767.843262,658.362793 768.328552,657.453003 768.050537,658.058960 
	C767.772583,658.664917 768.908325,658.088562 768.252747,658.209656 
	C768.251648,658.209839 768.193054,658.071716 768.257385,657.568848 
	C768.628235,656.154968 769.085266,655.011536 769.050171,653.471802 
	C769.120667,652.956604 769.167419,652.752563 769.350159,652.264038 
	C769.969482,651.287842 770.616882,650.744446 771.384277,649.881836 
	C771.907837,649.352295 772.249878,649.100647 772.924316,648.783386 
	C773.442688,648.695251 773.656433,648.710144 774.066589,648.979492 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M726.265503,458.399139 
	C726.798523,462.641510 724.651001,464.279999 720.789429,464.858398 
	C718.579163,468.217834 719.633850,472.343079 717.133301,475.798767 
	C715.346375,476.517029 713.420959,478.099243 714.029053,474.546356 
	C714.327881,472.800293 716.184998,470.954773 713.630127,469.121216 
	C712.948547,469.140778 712.567322,468.044739 712.071167,469.278290 
	C711.589172,469.760895 711.270142,470.001282 710.613892,470.262054 
	C710.088745,470.211060 709.886353,470.120544 709.471313,469.767517 
	C707.960388,466.913910 708.763550,464.925201 711.216614,463.708679 
	C714.002014,462.327332 715.715637,459.837372 717.913513,457.843048 
	C719.360046,456.530457 719.262817,455.360138 718.289490,453.609436 
	C717.565552,451.940063 716.773071,450.761383 715.385254,450.118469 
	C713.128357,449.073059 713.491821,447.506348 714.555664,445.480103 
	C714.638123,444.943909 714.657715,444.726105 714.688538,444.177673 
	C714.718689,442.718750 714.660156,441.609070 713.758667,440.376831 
	C712.741333,439.433685 713.688477,437.538849 711.545532,437.666748 
	C710.586792,437.880310 709.942322,437.807617 709.021729,437.383484 
	C708.278625,436.618195 708.079041,435.952209 708.002808,434.888855 
	C708.750183,432.447266 708.736938,430.653076 705.894531,429.649902 
	C704.901001,428.810181 704.465454,428.014740 704.242310,426.741180 
	C704.533020,423.518890 703.372620,421.260284 701.111816,419.053528 
	C700.132812,410.210236 700.270935,401.805084 702.415527,393.442383 
	C703.902832,387.642609 707.261658,383.224091 711.701233,379.594452 
	C717.239990,375.066101 723.417053,374.363068 730.266479,377.746094 
	C736.384583,382.226929 742.015503,386.647644 745.031372,393.909851 
	C745.624207,394.773712 745.957764,395.383789 746.437378,396.306763 
	C746.680725,396.827026 746.769409,397.039368 746.974609,397.576782 
	C747.237244,398.343262 747.377563,398.786499 747.697876,399.925598 
	C747.910889,400.862640 747.937622,401.105804 747.961182,401.719299 
	C747.391479,404.271698 747.446899,406.547943 746.807495,409.089600 
	C746.099609,410.380676 745.235840,410.754822 743.831970,410.687866 
	C742.773132,410.416626 741.802612,408.258423 741.207092,411.126312 
	C740.519409,411.546600 740.059509,411.605255 739.242676,411.441010 
	C737.405640,409.525543 737.255859,407.271576 736.666992,404.794495 
	C736.510620,403.694885 736.366272,402.961029 735.957886,402.279541 
	C735.898560,402.909088 736.451172,403.326385 736.518433,404.265015 
	C737.072327,407.316559 738.017151,409.918793 738.281860,413.045746 
	C738.194214,414.696655 737.841919,415.893555 737.048645,417.328979 
	C736.672363,417.804108 736.498169,417.971954 735.987549,418.266296 
	C734.893372,418.403809 734.319519,418.017853 733.552063,417.291748 
	C732.851318,416.563477 732.403442,416.062805 731.705322,415.334961 
	C731.358459,414.894684 731.235901,414.706024 730.965759,414.213989 
	C730.251709,412.237183 729.652649,410.569214 729.997131,408.410217 
	C728.110352,410.115692 726.032349,410.771759 723.428589,410.811676 
	C720.963867,409.876556 721.026367,408.050629 721.228271,406.225372 
	C721.385986,404.799805 722.154663,403.374756 720.851990,401.759369 
	C718.091370,399.754486 717.423828,396.975769 716.395325,394.177673 
	C715.939880,394.108246 715.758240,394.105560 715.323425,394.145996 
	C713.858826,394.760681 714.828125,395.071808 715.474976,395.649353 
	C717.491516,397.991974 718.531677,400.628723 720.573242,403.021454 
	C721.528381,405.896179 720.569580,408.745819 722.122559,411.515442 
	C722.340881,412.993439 721.662537,414.270538 722.961792,415.443298 
	C723.712891,415.974609 724.115356,416.431000 724.572571,417.242249 
	C724.893311,418.128967 724.953125,418.748047 724.908325,419.681946 
	C724.828430,420.183899 724.778992,420.380432 724.609741,420.851807 
	C724.381042,421.290558 724.272156,421.454498 723.973083,421.836975 
	C723.646240,422.187042 723.509705,422.318512 723.165161,422.636169 
	C722.687744,423.069214 722.428650,423.326294 722.024170,423.817108 
	C721.777649,424.199982 721.687317,424.360077 721.484009,424.775391 
	C721.090698,425.754547 720.890076,426.501129 720.674805,427.567719 
	C720.403992,430.360138 719.503845,432.759277 719.935852,435.307953 
	C720.736206,435.174713 721.288147,435.065826 722.166687,435.022430 
	C722.693115,435.064423 722.904297,435.102875 723.684814,435.457550 
	C724.375977,435.956848 724.497803,436.139954 724.729492,436.633789 
	C724.916504,437.368866 724.950317,437.796265 724.884399,438.534515 
	C724.721130,439.223846 724.557617,439.584290 724.144165,440.111694 
	C723.488525,440.679535 723.414673,441.104279 723.936157,441.844177 
	C727.370239,448.448730 728.631470,449.266174 734.101318,448.325989 
	C735.470154,448.242035 736.529419,448.321533 737.798096,447.759399 
	C738.431763,447.480560 738.789673,447.322449 739.398315,447.034546 
	C739.811218,446.813599 739.973694,446.723145 740.372803,446.488586 
	C740.764404,446.244476 740.919312,446.144470 741.571167,445.805298 
	C742.251587,445.569183 742.435242,445.572235 742.804810,445.778748 
	C743.786438,449.072876 739.974792,450.216919 740.022644,453.347137 
	C738.356018,456.015778 735.863281,455.226959 733.215454,455.404297 
	C731.193176,455.358215 729.619568,455.141510 727.768005,454.432434 
	C726.509094,454.240448 725.621399,453.079224 724.733032,454.057709 
	C724.267944,454.569916 724.680603,455.294312 725.427246,456.020599 
	C726.140808,456.776825 726.448059,457.367065 726.265503,458.399139 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M745.161377,395.221863 
	C742.413635,394.756866 742.668335,392.338196 742.002136,390.858734 
	C739.726257,385.803772 734.896362,383.456238 731.050720,379.669495 
	C728.901123,376.565338 725.816162,376.256836 722.719421,376.003815 
	C720.928345,375.857513 719.098389,376.263367 717.033691,375.398865 
	C716.275208,374.503937 716.147461,373.766052 716.376038,372.618652 
	C716.809753,371.854034 717.200623,371.576965 718.054932,371.487244 
	C719.766968,371.947418 721.166626,372.271912 722.517212,372.747894 
	C721.507202,372.269714 720.340027,372.169525 719.003113,371.571167 
	C716.384583,370.895081 714.365479,369.429138 711.525146,369.381744 
	C706.256226,367.761536 701.060242,367.372894 695.948608,365.209015 
	C695.468140,364.322632 695.470764,363.751160 695.944275,362.834656 
	C696.517639,362.321045 696.806641,362.039917 697.102478,362.038055 
	C711.195862,361.949493 725.303528,359.808411 739.765320,362.498260 
	C741.400818,363.388123 742.051147,364.600708 742.989258,366.067505 
	C743.560059,367.073822 743.646057,367.789978 743.203369,368.825500 
	C742.802490,369.234497 742.604126,369.354401 741.733398,369.494141 
	C740.853638,369.434814 740.646362,369.355682 739.861816,368.972778 
	C738.520020,368.265442 737.712158,367.976135 736.557068,367.663330 
	C733.654358,366.974548 730.221375,364.134094 728.693970,367.158539 
	C727.320862,369.877502 731.119385,371.535034 733.466736,372.946106 
	C737.042114,375.095398 739.415649,378.624451 743.027466,381.254761 
	C746.515320,385.273834 748.900146,389.652588 751.966003,393.960632 
	C752.275879,394.412872 752.391113,394.597992 752.649170,395.073608 
	C753.037292,395.947357 753.241760,396.547607 753.676147,397.387451 
	C754.154541,398.197357 754.445679,398.753754 754.850891,399.608887 
	C755.218689,400.492920 755.417236,401.101013 755.744202,402.007385 
	C756.260498,403.998199 756.627808,405.696533 757.584839,407.553680 
	C757.867859,408.285645 757.996948,408.716949 758.187927,409.486267 
	C758.391541,410.496704 758.573181,411.160248 758.863647,412.158447 
	C759.316162,414.105408 759.319946,415.772125 759.842407,417.713196 
	C760.181213,419.224426 760.224426,420.400818 760.051147,421.923767 
	C759.766357,423.323730 759.455017,424.377991 759.753296,425.805847 
	C759.933716,426.778381 759.953918,427.434570 759.858032,428.419312 
	C759.723755,429.169098 759.621765,429.590302 759.451294,430.323395 
	C759.261108,431.689301 759.192688,432.743774 759.207214,434.119354 
	C759.192993,435.063080 759.127502,435.686340 758.993103,436.609558 
	C758.879395,437.102905 758.819336,437.294983 758.626831,437.753113 
	C758.380493,438.176788 758.266724,438.334381 757.979980,438.718750 
	C757.458130,439.407379 757.280579,439.933380 757.223145,440.803101 
	C757.240479,441.727173 757.252869,442.352844 757.309692,443.313477 
	C757.366577,445.038971 757.324585,446.429108 757.358643,448.169220 
	C757.363342,448.982758 757.365295,449.445831 757.381836,450.251160 
	C757.415771,451.735626 757.754272,452.818512 758.096680,454.243225 
	C758.362244,455.446472 758.550842,456.321106 758.883301,457.506531 
	C759.058716,458.268158 759.135742,458.707306 759.253418,459.476685 
	C759.413208,460.683075 759.639893,461.535065 759.965454,462.705872 
	C760.316284,464.106049 760.543762,465.193817 760.954834,466.580688 
	C761.374512,468.653534 761.847412,470.362213 762.662720,472.317719 
	C763.063477,473.241089 763.304504,473.867737 763.684448,474.801208 
	C764.217957,476.387817 764.406494,477.721497 764.979797,479.300598 
	C765.790100,482.473785 768.209473,483.350677 770.801270,484.543213 
	C772.730957,487.182404 774.990234,488.691681 778.236023,489.168030 
	C778.772766,489.153320 778.988098,489.149475 779.526184,489.165192 
	C780.059387,489.228668 780.269958,489.272644 780.774658,489.444550 
	C781.237366,489.700897 781.405945,489.829315 781.797974,490.178802 
	C782.796387,491.454559 783.955688,491.888794 785.417297,492.451630 
	C789.660339,495.207245 793.469543,498.032562 797.894897,500.488831 
	C798.896240,500.635406 799.568115,500.685059 800.581848,500.683411 
	C801.369568,500.674469 801.818665,500.675415 802.601501,500.667328 
	C805.903137,500.674988 807.957092,498.123688 811.126587,497.709961 
	C811.645386,497.495605 811.858765,497.423553 812.403198,497.290466 
	C812.956665,497.221588 813.179077,497.213715 813.731445,497.231262 
	C815.522339,497.785980 817.071350,497.018860 818.767456,497.780151 
	C820.134094,499.069336 819.639893,499.673615 818.387512,499.933167 
	C817.438965,500.129730 816.272034,500.002930 816.942871,501.865875 
	C817.081055,503.488403 816.033264,503.780884 814.746582,504.267822 
	C814.014648,504.580597 813.348206,504.159332 813.191284,504.886292 
	C815.946960,505.376740 818.704651,505.777222 821.523438,505.665527 
	C827.770996,505.417877 833.432129,507.885223 839.248474,509.605255 
	C840.529663,509.984161 841.653015,510.701599 842.159851,512.421509 
	C839.416992,512.839844 836.671997,512.907837 833.471436,512.965881 
	C832.798706,512.846375 832.581665,512.736877 832.193115,512.305359 
	C830.568542,510.496368 828.375183,511.043091 826.375122,510.014496 
	C820.937073,510.986084 815.890930,512.792053 810.352234,510.256287 
	C809.567749,509.985687 809.128174,509.982330 808.358948,509.978760 
	C807.906982,509.862488 807.784668,509.746399 807.457581,509.479797 
	C807.094910,509.265381 806.936951,509.201416 806.521973,509.136230 
	C805.934509,509.244415 805.634399,509.409058 805.179565,509.812805 
	C804.983643,510.201477 804.972168,510.405396 804.929871,510.914185 
	C804.899109,511.218994 804.526917,511.481964 804.347534,511.621582 
	C804.168213,511.761169 804.544495,512.045166 804.661865,512.257874 
	C804.907715,512.781799 805.021484,513.098328 805.209839,513.670654 
	C805.327942,514.097900 805.357971,514.274170 805.255676,514.683716 
	C805.123352,514.917053 805.059448,515.017212 805.020508,515.062012 
	C804.855225,515.257446 804.728882,515.408081 804.801270,515.776733 
	C805.006592,516.466492 805.013184,516.938354 805.028076,517.764038 
	C805.097412,518.379395 805.158447,518.640869 804.969238,519.217590 
	C800.463440,521.835449 795.811584,521.473022 791.248413,521.382324 
	C787.750671,521.312744 784.771973,522.124390 782.256104,525.212952 
	C779.066895,528.652100 775.530518,531.110229 772.356323,533.979553 
	C769.150635,536.877441 764.985901,536.452637 760.807800,537.347412 
	C760.172241,537.400452 759.918091,537.414856 759.284485,537.462646 
	C757.143860,537.527405 755.393677,538.220886 753.315552,537.354675 
	C754.175110,534.796448 752.897827,531.314514 756.716431,530.024780 
	C762.881470,532.993286 766.965271,529.816711 771.170410,525.926697 
	C773.536011,524.264099 775.253418,522.383728 777.397095,520.469910 
	C782.819275,520.730469 785.607544,515.097351 790.991577,515.007935 
	C791.929260,514.087341 792.627930,513.493713 793.862671,513.061096 
	C797.124023,512.157104 797.736694,510.548431 795.512207,508.399170 
	C793.612976,506.564087 791.580750,504.858917 789.426025,502.786499 
	C787.785461,501.138336 786.396973,499.722321 784.690002,498.652985 
	C781.624390,501.351990 783.156799,506.001160 780.041992,508.926819 
	C778.473877,508.413483 774.696716,515.132568 775.721680,507.601929 
	C775.971619,505.765839 772.058594,505.278076 773.092407,502.129456 
	C773.872437,501.002380 774.837891,500.874359 776.144104,500.678955 
	C779.493530,498.467377 779.506775,497.278931 775.935120,495.286102 
	C770.579712,492.298096 765.285950,489.196564 759.865601,486.323456 
	C758.128052,485.402496 756.146973,484.817261 754.945557,482.678650 
	C754.866455,480.735413 755.265930,479.336609 756.900574,478.093353 
	C757.477722,477.752197 757.822754,477.806091 758.165527,478.243256 
	C758.217102,478.430237 758.593201,478.270721 758.433105,478.096191 
	C756.436096,471.873749 754.630554,465.817566 753.226807,459.307434 
	C751.320862,458.768188 750.604065,458.002747 751.861084,456.135742 
	C753.162231,453.027527 750.706177,450.407898 751.199097,447.239166 
	C750.975159,446.955414 751.030884,446.973633 751.026733,447.002625 
	C750.389832,446.505951 750.525269,445.779968 750.531921,444.749359 
	C751.214661,442.849640 752.561096,441.493683 751.971558,439.229401 
	C752.003174,437.502472 752.482849,436.212341 752.968140,434.572693 
	C753.199524,433.806091 753.335999,433.368744 753.526001,432.588959 
	C753.612610,431.774384 753.635681,431.302216 753.644226,430.461548 
	C753.636902,428.829803 753.640320,427.565979 753.600342,425.910614 
	C753.685242,422.879974 753.386536,420.228363 753.901794,417.233582 
	C754.445007,414.027130 753.331421,411.352020 752.914551,408.411652 
	C752.906616,411.444946 755.168579,414.259460 752.962280,417.380402 
	C751.613831,418.059174 750.571716,418.021759 749.183838,417.354218 
	C746.581055,412.636505 746.806274,407.885742 747.386108,402.700348 
	C747.509949,401.745911 747.505554,401.197144 747.219360,400.317841 
	C746.978088,399.987000 747.005310,399.996613 747.005371,400.011047 
	C746.551819,399.550262 746.525574,398.901367 746.138428,398.072571 
	C745.961365,397.817963 745.980896,397.500763 745.998657,397.342865 
	C745.618164,396.677063 745.529724,396.052460 745.161377,395.221863 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M608.674927,614.813110 
	C621.822205,619.789612 634.891663,624.753174 648.245850,628.818176 
	C651.911987,629.934143 653.690735,633.377808 657.636230,634.081787 
	C658.339111,633.671326 658.738892,633.495056 659.525146,633.657104 
	C659.939819,641.364136 662.062866,648.594727 663.592102,655.891296 
	C664.423279,659.857056 663.574707,662.047485 659.932861,663.766663 
	C653.181091,666.953918 646.994568,671.251526 639.992126,673.994690 
	C638.127197,674.725220 636.629700,675.146301 635.010742,673.583313 
	C632.137878,670.809631 628.731567,668.369141 626.997253,664.751404 
	C619.887512,649.920166 612.845703,635.046997 607.361877,619.047180 
	C612.091553,618.435242 612.772827,623.462158 615.435059,625.227356 
	C613.732788,622.182556 610.211914,620.035461 608.346802,616.140991 
	C608.367371,615.559875 608.418335,615.330017 608.674927,614.813110 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M794.782227,628.692261 
	C797.359863,633.697571 801.158630,637.422485 804.041687,642.111938 
	C804.102600,642.866821 804.285034,643.243530 804.816101,643.772217 
	C805.068176,643.969482 804.996521,643.981323 805.028076,643.962952 
	C805.414673,644.431763 805.471924,645.030029 805.882446,645.775391 
	C806.096558,645.974365 806.022888,645.987305 806.035278,645.952026 
	C806.206421,646.209412 806.414185,646.461792 806.875732,646.810669 
	C807.080566,646.947571 807.007812,646.992615 807.029785,646.955872 
	C807.209045,647.211609 807.415894,647.463562 807.876404,647.811401 
	C808.080688,647.947876 808.006775,647.991089 808.029785,647.954956 
	C808.209290,648.211914 808.415833,648.463989 808.876953,648.811157 
	C809.081421,648.947266 808.997742,648.968872 809.028931,648.938904 
	C810.496399,650.804443 812.577881,652.137817 813.873047,654.604248 
	C815.534424,662.473816 811.925476,670.368835 805.439087,672.885193 
	C804.278625,672.630798 803.613525,672.161865 802.986572,671.622559 
	C800.858582,669.791931 798.539673,668.367126 796.052979,670.781250 
	C793.706055,673.059631 793.025208,675.797485 795.038452,678.767639 
	C795.589905,679.581299 796.066162,680.446899 796.642334,681.651978 
	C797.321838,685.259705 799.376709,688.027527 800.001465,691.646973 
	C798.650269,693.971252 797.278748,695.941223 795.646118,698.111084 
	C795.188904,698.346436 794.992798,698.381958 794.558960,698.235107 
	C793.897766,697.624878 793.507751,697.165833 792.885376,696.501221 
	C792.567078,696.096313 792.454895,695.921265 792.214233,695.460449 
	C791.643616,693.552917 790.844055,692.059448 790.231445,690.169128 
	C787.088867,686.159790 784.104065,682.423767 781.076660,678.345093 
	C782.092041,672.540100 784.992554,667.842346 787.484436,663.015381 
	C790.462463,657.246826 793.245300,651.420288 795.532349,644.801819 
	C790.613464,654.460266 785.942993,663.673157 782.301270,673.363647 
	C781.767944,674.782776 781.171509,676.148865 779.342896,676.921997 
	C778.144104,676.541077 778.015930,675.704651 777.856750,674.555603 
	C776.218445,671.851196 776.270264,669.095520 776.970459,666.616272 
	C778.784363,660.193604 780.002014,653.546204 783.341125,647.617798 
	C783.479370,647.372375 782.646729,647.652771 782.044922,647.216431 
	C784.815186,641.317993 787.883545,635.650574 790.025757,629.539856 
	C790.571167,627.984253 791.402893,626.512512 791.001709,624.366577 
	C791.374146,624.258545 791.780396,624.556763 792.400269,625.003174 
	C794.245911,625.660095 794.494324,626.990540 794.782227,628.692261 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M702.664185,594.834167 
	C702.185913,607.628540 698.768372,619.755737 696.982788,632.557983 
	C696.674377,633.523804 696.337036,634.027893 695.515747,634.707153 
	C686.511780,636.126038 677.864075,635.291016 669.235107,635.347595 
	C666.248840,635.367188 664.608215,633.722351 665.354980,630.441650 
	C667.781494,619.782166 669.865845,609.049011 672.509583,598.015442 
	C675.316040,595.996704 678.175781,596.477539 680.931274,596.412354 
	C688.088623,596.242981 695.335266,597.171021 702.664185,594.834167 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M630.662231,969.078003 
	C634.090027,969.433350 637.132690,969.758545 640.598267,970.063843 
	C642.324707,968.803162 643.927368,968.439880 645.638672,968.633057 
	C660.828247,970.347839 676.089661,970.537598 691.806641,970.888245 
	C694.940125,971.211487 697.900146,970.419434 699.949280,973.496338 
	C687.738037,974.152832 675.864075,975.692810 664.951904,981.928833 
	C662.621643,983.260437 659.540222,983.277710 656.411865,983.968994 
	C655.861267,984.171326 655.703674,984.305054 655.453857,984.734741 
	C655.139465,985.414856 654.917175,985.798950 654.447083,986.409973 
	C643.919373,988.255981 633.553650,986.980652 622.800537,987.520630 
	C617.170593,987.238464 612.090515,988.785339 606.488281,988.416748 
	C604.538513,988.438110 602.959045,988.270752 601.271973,989.477722 
	C600.175049,989.888000 599.416565,989.919556 598.298462,989.612305 
	C595.689636,987.272278 593.017090,986.499268 589.845032,986.495056 
	C585.570557,986.489380 581.456543,984.570740 576.854675,984.811157 
	C577.948975,978.755920 580.264648,977.427307 589.083557,977.607544 
	C592.313293,978.163208 595.136108,978.158264 597.926086,977.932983 
	C609.954834,976.962036 621.945129,977.897949 634.387207,978.516357 
	C642.114868,978.618164 649.361755,980.443115 656.543762,979.248901 
	C652.483276,979.772461 648.243652,979.368225 643.586670,979.422668 
	C633.047791,977.898621 622.917908,976.367554 612.688538,977.082886 
	C606.757507,977.497681 600.805359,977.278931 594.891418,977.958252 
	C593.608643,978.105652 592.227234,978.125366 590.885864,976.804077 
	C590.857056,973.584778 593.197266,973.907410 595.010681,973.506104 
	C599.831970,972.439087 604.811218,972.810669 610.020569,971.721558 
	C610.891602,971.275085 611.417358,971.101379 612.365601,970.937805 
	C616.803467,971.764038 620.603333,970.649292 624.393005,969.490540 
	C626.326233,968.899475 628.300415,968.988770 630.662231,969.078003 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M708.363892,878.781616 
	C705.284790,889.016418 703.429749,899.432251 701.756348,909.898010 
	C700.955811,914.904724 694.130981,919.276184 689.194946,918.040344 
	C682.614197,916.392700 676.066162,914.614502 669.492859,912.936646 
	C662.472412,911.144714 662.321777,910.941895 663.546448,902.895081 
	C664.473572,902.138977 665.213013,902.052856 666.347656,902.099182 
	C670.428223,903.011353 673.996765,904.358582 677.701172,905.255615 
	C683.687561,906.705261 683.728271,906.778870 685.368225,900.580505 
	C687.738098,891.622742 689.844666,882.598938 691.971863,873.580750 
	C692.806519,870.042114 693.500549,866.453186 695.598938,862.946533 
	C696.599487,862.243225 697.377808,862.143188 698.570984,862.438293 
	C699.591370,863.115784 699.944580,863.825073 700.307983,864.962524 
	C700.457764,865.663086 700.439331,866.148010 700.654724,866.273865 
	C708.318604,870.756165 705.246704,876.955383 703.494568,883.062317 
	C702.648499,886.011108 701.098328,888.851135 701.475342,892.079041 
	C701.562012,892.759277 702.417908,892.195190 701.765564,892.332581 
	C701.545166,892.378967 701.442261,892.249146 701.455750,891.943237 
	C701.633667,887.911560 702.915710,884.212585 705.077698,880.400879 
	C706.055664,879.320496 706.829285,878.605408 708.363892,878.781616 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M666.559570,935.201904 
	C665.821777,930.380310 665.578125,925.861572 664.547546,921.530029 
	C663.613098,917.602478 665.377014,917.623352 668.135742,918.187683 
	C675.285828,919.650330 682.442322,921.082092 689.585327,922.578003 
	C693.132324,923.320801 696.519287,923.492798 699.844849,919.722961 
	C698.847290,925.639099 698.933044,930.648132 699.655212,935.713074 
	C700.370850,930.101257 701.086548,924.489380 701.802185,918.877563 
	C702.325989,925.313599 703.116638,931.844238 700.882996,938.048401 
	C699.486511,941.927246 696.417358,943.735352 691.864380,943.277954 
	C684.378235,942.525757 677.215027,940.354126 669.878784,938.973572 
	C667.937256,938.608276 667.093750,937.344238 666.559570,935.201904 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M588.999878,978.527222 
	C583.870911,978.548218 579.425171,979.254578 576.929199,984.901733 
	C576.761597,985.809448 576.678589,986.027649 576.407837,986.540161 
	C574.579468,988.746155 572.683960,990.412415 570.755859,992.524231 
	C570.045776,993.242615 570.659790,992.656189 570.182434,993.121582 
	C564.746155,998.422913 564.746216,998.422974 571.165588,1002.082581 
	C571.256531,1002.664368 571.195496,1002.909119 570.830139,1003.389465 
	C566.249573,1003.920410 562.182129,1002.846497 557.806885,1001.484253 
	C556.933533,1001.168396 556.374023,1001.101746 555.392212,1001.010010 
	C565.859741,991.250793 575.841675,980.729004 583.563721,968.224121 
	C584.606018,966.536316 585.918579,965.013000 586.141846,962.583557 
	C590.421204,957.371033 591.519165,950.991455 594.449951,945.143250 
	C595.805847,944.952026 596.885559,944.972412 598.369629,944.988770 
	C599.012146,948.061584 600.130981,949.702942 603.515015,948.101807 
	C604.522156,947.625366 605.707642,947.532837 607.148315,947.124390 
	C608.499207,946.884888 609.475830,946.921814 610.684204,947.635864 
	C609.795593,949.677795 607.502258,949.776794 606.072144,951.104004 
	C605.006653,952.092834 603.220032,953.801270 603.496399,954.508972 
	C606.432800,962.028809 599.010315,959.549561 596.384338,961.827332 
	C598.433594,964.440796 602.175476,961.398865 603.933777,964.723877 
	C603.216125,968.143005 600.345154,967.390686 598.341003,968.114136 
	C596.023926,968.950500 593.526184,969.206604 591.137878,969.945862 
	C600.695984,969.309631 610.157715,967.967712 619.605469,966.507568 
	C621.878418,966.156250 624.142700,965.298096 626.704468,966.662354 
	C627.759155,968.429138 629.572083,967.637695 630.834473,968.832275 
	C625.355225,970.376099 619.990112,973.223755 613.587402,972.495361 
	C612.861511,971.805969 612.348877,971.520264 611.670410,971.495178 
	C611.351135,971.483398 611.045837,971.437500 610.748596,971.524292 
	C610.943604,971.818359 611.330200,971.713745 611.632446,972.217957 
	C606.788391,975.504944 601.085510,973.294861 595.949585,974.912964 
	C594.570618,975.347351 593.038757,975.296509 591.246094,975.698975 
	C590.669556,976.949280 588.000122,976.411926 588.999878,978.527222 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M625.220581,833.676514 
	C613.255371,837.742615 602.087219,842.857910 590.639282,848.208984 
	C588.608093,846.373352 588.399719,844.239624 589.730469,842.143921 
	C590.707458,840.605164 590.134155,839.414917 589.539429,837.821960 
	C593.271667,832.709595 596.871765,827.905334 600.688416,822.823975 
	C610.658936,821.139709 620.401855,819.472229 630.690063,821.574219 
	C631.031189,823.299072 630.754272,824.786255 630.959839,826.203552 
	C631.591736,830.559937 629.626587,832.781738 625.220581,833.676514 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M580.668030,841.508789 
	C574.214417,847.742615 569.460815,854.965942 563.797729,861.413757 
	C557.720520,868.333252 560.950256,867.843811 552.544250,863.726318 
	C549.742615,862.354004 547.405457,859.988525 543.664673,859.891724 
	C542.792480,858.389893 543.754517,857.690002 544.641418,856.608032 
	C551.808289,847.864441 561.823059,842.797363 570.627747,836.178772 
	C572.869324,834.493774 575.198914,832.925781 577.799194,831.167358 
	C581.968567,829.903870 582.954895,832.792908 584.258667,835.743652 
	C584.035461,838.404907 581.811768,839.371887 580.668030,841.508789 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M701.786987,632.895874 
	C700.156250,626.471558 702.314941,620.596313 703.270508,614.858704 
	C704.903931,605.051575 706.253174,595.191895 707.985657,585.397949 
	C708.762512,581.005981 710.456421,577.191467 713.530518,573.946045 
	C719.362732,567.788757 725.192200,561.627258 730.917358,555.371033 
	C733.314514,552.751526 736.098816,551.411194 739.650757,551.265320 
	C746.467712,550.985229 753.277344,550.524963 760.531250,550.191528 
	C763.107666,550.771912 765.269836,550.449402 767.732178,550.265991 
	C768.788635,549.996155 769.534607,549.909485 770.638184,549.704773 
	C771.619263,549.220642 772.287109,549.102539 773.319824,549.350342 
	C774.839783,550.165405 773.344238,552.057922 775.247803,552.795410 
	C775.593689,553.259766 775.700134,553.472961 775.895874,554.040161 
	C776.132935,556.269409 775.608826,557.875366 773.760010,559.229919 
	C769.373047,558.103821 765.327698,556.667725 760.985901,559.517700 
	C756.570068,556.218323 752.194580,557.904724 747.870789,558.670349 
	C744.812134,559.212097 745.958740,563.149048 743.125366,563.964722 
	C741.263550,561.102112 739.804016,558.047546 736.130737,562.269531 
	C726.429382,568.429504 718.331360,575.775269 712.275696,585.221252 
	C711.548584,586.355347 711.380493,587.714355 711.234924,589.031738 
	C710.181152,598.572388 707.479980,607.872009 707.197205,617.533997 
	C707.052979,622.460938 703.672241,626.893555 704.643799,632.412354 
	C704.345093,632.953857 704.178955,633.143799 703.657227,633.468628 
	C702.780518,633.652222 702.295410,633.541992 701.786987,632.895874 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M666.905884,854.775513 
	C667.041748,854.449829 667.067871,854.487915 667.060181,854.509705 
	C666.475647,853.619019 665.919495,852.699768 666.165710,851.190186 
	C667.965271,850.486694 667.965271,850.486694 668.558411,852.621094 
	C668.511108,851.454041 668.451843,850.287964 668.319458,848.820068 
	C668.920044,846.753479 671.152222,848.292969 671.978760,846.501587 
	C672.592834,845.637207 673.430420,845.311768 673.509216,844.449219 
	C673.569763,843.786194 673.001465,843.478516 673.281555,844.083496 
	C673.561646,844.688477 672.314636,844.074219 672.627441,844.453857 
	C669.918335,844.542297 669.719666,841.689941 667.545654,840.796265 
	C666.745911,840.021912 666.485840,839.380554 666.808960,838.303284 
	C668.270569,838.058960 668.887085,837.126404 669.865112,836.159424 
	C672.692932,836.315796 671.858826,838.242371 672.108215,839.715149 
	C672.113464,835.165344 669.737488,831.038147 669.802856,826.211670 
	C670.831787,823.867920 670.561646,821.832642 669.994507,819.439331 
	C670.064941,818.264099 670.349976,817.465698 670.302124,816.644836 
	C669.845581,808.808167 670.732239,801.381287 676.976074,795.195679 
	C678.427368,794.957336 679.568115,794.990295 681.136047,795.050903 
	C682.463684,795.779175 682.783813,796.743835 682.791992,798.232361 
	C681.896362,808.660156 683.418152,818.660889 683.142944,829.076660 
	C682.945679,831.517761 683.115051,833.623413 682.053833,835.912964 
	C681.977051,837.525818 681.935974,838.754150 681.834839,840.439697 
	C681.552063,841.346130 681.535278,841.919739 681.251404,842.289612 
	C675.320801,850.016602 671.466064,858.722656 668.678589,868.227417 
	C664.964294,868.428772 666.089600,865.802063 666.108704,864.186035 
	C666.130859,862.312134 667.051086,860.447388 666.079712,858.174316 
	C666.748047,856.995178 666.347595,855.944397 666.905884,854.775513 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M701.597290,633.005188 
	C702.022034,632.351624 702.303101,632.371521 702.743530,632.718018 
	C705.835632,632.912170 708.777222,633.550293 712.007385,632.381226 
	C712.612549,632.175659 712.866333,632.115601 713.517578,632.021423 
	C719.867310,632.997314 726.037292,632.701660 732.071655,635.268677 
	C734.112915,640.367615 731.395081,644.043335 728.918335,648.040283 
	C727.643250,648.049805 727.399536,647.369019 727.352051,646.233276 
	C727.552368,645.593384 727.733337,645.318665 727.941589,645.062622 
	C728.259949,644.670898 728.665405,644.132812 728.462219,643.753296 
	C728.276245,643.405823 728.039001,643.477844 728.237000,643.747192 
	C728.583557,644.218506 728.241455,644.617493 727.755981,645.247559 
	C725.295654,651.810730 726.023499,658.857910 723.109314,665.314026 
	C719.805969,661.668335 719.656921,660.262390 721.665466,653.279907 
	C720.541687,655.499512 721.032898,658.285095 718.067871,659.144348 
	C716.562195,655.584595 718.496155,652.291809 718.544800,649.391724 
	C718.080017,652.939941 716.421570,656.915588 718.590027,660.986816 
	C719.050903,661.852051 718.427612,663.024536 717.273010,663.277039 
	C716.104675,663.532593 715.453613,662.670593 715.023376,661.727905 
	C713.640991,658.699158 713.560181,655.632935 714.937195,652.547241 
	C714.611389,653.168579 715.459412,652.614929 714.804382,652.491089 
	C711.989563,651.958801 711.989563,651.958801 711.729919,649.855408 
	C711.489075,649.639099 711.658813,649.756470 711.703308,650.255310 
	C711.854431,651.949646 712.816772,654.658325 710.405823,654.690735 
	C708.415771,654.717590 708.782104,652.031677 708.925354,650.905396 
	C710.027771,655.416565 703.956726,654.036194 702.359680,657.053833 
	C701.663940,649.157532 700.532837,641.348450 701.597290,633.005188 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M748.902100,417.231445 
	C750.233887,417.021576 751.256836,417.003448 752.663330,416.976318 
	C753.229919,416.849518 753.412842,416.731720 753.895752,416.741516 
	C754.381348,417.265106 754.479126,417.680634 754.444336,418.438843 
	C754.144775,419.376984 754.120728,419.989075 754.476868,420.926270 
	C754.484924,422.652893 754.489258,424.044800 754.487976,425.798279 
	C754.486572,427.388519 754.491150,428.617218 754.466675,430.220367 
	C753.046875,433.795654 752.266296,437.335541 749.093994,439.894287 
	C747.295044,439.889252 745.625732,438.279907 744.326904,440.845459 
	C741.486877,441.131409 741.994019,439.006958 741.752502,437.593231 
	C741.453369,435.842133 741.728027,434.005005 740.894775,431.987183 
	C740.638428,431.485779 740.529602,431.291962 740.055786,430.564117 
	C739.562683,429.863861 739.434509,429.697601 739.114136,429.289551 
	C738.795837,428.890320 738.669739,428.732849 738.353333,428.346985 
	C737.772949,427.686768 737.384827,427.252655 736.659180,426.791290 
	C736.249451,426.756165 735.319214,426.197601 735.947388,426.935913 
	C736.913757,428.071869 736.804688,429.176270 736.419800,430.719269 
	C736.245422,431.230865 736.169006,431.432159 735.973999,431.930481 
	C735.426819,433.207367 735.240540,434.209381 735.669067,435.562805 
	C735.816467,436.070129 735.872986,436.273926 736.001709,436.786102 
	C736.246399,437.909210 736.348999,438.741791 736.839844,439.786743 
	C738.119080,442.315277 741.453308,441.677673 742.444702,444.509979 
	C742.468140,445.061951 742.443726,445.283875 742.214050,445.770569 
	C742.008850,446.035278 741.996216,445.994171 742.017578,445.996826 
	C741.782532,446.209106 741.541138,446.434753 741.148560,446.860474 
	C740.982422,447.044586 740.987122,446.983490 741.017700,446.985199 
	C740.699585,447.279358 740.301331,447.450134 739.513794,447.502808 
	C738.128113,447.829468 737.181335,448.427856 735.780396,448.600830 
	C734.862366,448.339050 734.307861,448.051971 733.677979,447.344971 
	C733.375122,446.953644 733.263062,446.793549 732.832153,446.162903 
	C732.401306,445.544495 732.289368,445.396606 731.816040,444.830383 
	C731.326843,444.277405 731.198975,444.142761 730.670410,443.606201 
	C730.130920,443.067627 729.991943,442.930969 729.435791,442.355072 
	C728.888977,441.751862 728.759216,441.587891 728.456055,441.153687 
	C728.183838,440.688416 728.085022,440.493469 727.859741,439.990906 
	C726.842529,436.179718 725.270081,432.782715 726.244568,429.005188 
	C727.332336,424.788055 729.376282,421.352020 733.859924,419.415344 
	C734.282043,419.093079 734.449524,418.967072 734.898438,418.716553 
	C735.765442,418.511780 736.353943,418.510651 737.210144,418.588684 
	C737.624390,418.751678 737.771667,418.853241 738.108643,419.137787 
	C738.449097,419.403015 738.599854,419.485229 738.520935,419.453918 
	C738.175415,419.209625 738.059509,419.078888 737.723145,418.798950 
	C736.995544,418.449554 736.417908,418.462097 735.970703,417.854309 
	C736.289978,416.679657 736.590881,415.787140 736.915405,414.610687 
	C737.617981,413.362915 737.803040,412.131836 738.941284,411.109894 
	C739.670532,410.987518 740.069214,410.992981 740.766968,411.003632 
	C741.729370,411.664276 741.310913,412.691711 741.880127,413.380432 
	C741.414978,412.288147 741.445007,411.260529 742.556458,410.174866 
	C743.804871,409.783997 744.767517,409.553040 745.954590,409.016479 
	C748.638489,410.412292 747.714417,413.041321 747.996826,415.721771 
	C748.042664,418.763062 747.808289,421.448059 748.573730,424.040741 
	C747.851501,422.352325 747.991516,420.552856 748.152283,418.405426 
	C748.348572,417.841675 748.470886,417.632446 748.902100,417.231445 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M598.657593,796.695312 
	C598.128357,799.769043 594.244751,800.229858 593.674438,803.699341 
	C593.111084,804.093933 592.744507,804.294006 592.200928,804.800354 
	C591.984131,805.031921 591.990845,804.987671 592.012573,804.992798 
	C588.288208,807.567627 583.685791,808.882202 580.518982,812.962646 
	C573.331787,820.600525 564.805725,821.048279 555.313721,818.774780 
	C540.090942,809.936707 524.419434,803.945923 506.909698,803.996094 
	C506.062958,803.998474 505.253296,803.882385 504.244446,803.168335 
	C504.479401,800.510864 506.379547,801.117493 507.929260,801.012634 
	C509.555786,800.902527 511.186707,800.850037 512.809753,800.705505 
	C512.993896,800.689148 513.139771,800.241577 513.347778,799.926636 
	C512.223267,797.841309 508.919678,800.273193 508.104370,797.104675 
	C510.341827,795.024902 512.781250,795.958618 515.205200,796.243103 
	C523.740540,797.244934 531.816528,800.374084 540.695435,801.632080 
	C542.386047,801.709900 543.624207,802.075989 545.247864,802.386841 
	C545.853760,802.487610 546.094727,802.528503 546.698608,802.608154 
	C547.542358,802.703247 548.021667,802.769897 548.855103,802.900696 
	C549.443298,803.005615 549.676086,803.055786 550.250977,803.200684 
	C553.696960,804.404053 556.833801,805.371765 560.076172,806.028748 
	C561.617737,806.341125 563.767639,806.567566 563.870850,808.508179 
	C563.959229,810.170898 561.890381,810.423523 560.625244,811.106140 
	C559.911682,811.491211 559.012939,811.439819 558.380554,812.051025 
	C559.859192,812.319580 561.112122,813.184753 562.901367,813.535095 
	C568.692810,814.607788 572.607300,811.645081 576.742432,808.307007 
	C583.067688,804.043945 589.522644,800.658691 595.904785,796.480225 
	C596.476501,796.298523 596.713745,796.252258 597.313843,796.223145 
	C597.904053,796.323120 598.131531,796.405884 598.657593,796.695312 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M473.138458,824.040771 
	C472.953583,823.815552 472.984924,823.585022 473.005920,823.470581 
	C471.402618,819.501160 469.508636,815.758667 468.197937,811.377197 
	C468.682220,808.688843 470.627960,808.005127 472.406464,807.130432 
	C477.461548,804.644470 482.940765,803.193481 487.998230,800.698303 
	C490.274384,799.575317 491.999481,800.172363 493.295441,802.591980 
	C495.181763,806.113892 496.503540,809.846008 498.169800,813.873291 
	C498.807037,816.384827 499.097565,818.436890 496.545532,819.696899 
	C490.073334,822.892456 483.652100,826.195068 476.109161,827.205017 
	C475.279724,826.524475 474.774750,826.082336 474.154419,825.413086 
	C473.804413,824.876221 473.565857,824.569580 473.138458,824.040771 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M612.472168,779.712891 
	C612.603455,782.159973 611.443359,783.788269 609.237732,784.980591 
	C608.744568,785.206909 608.592346,785.379395 608.211792,785.810547 
	C607.983459,786.069275 607.984314,785.989014 608.024414,785.986816 
	C604.554382,788.330383 600.522705,789.912231 597.314453,793.349365 
	C589.094910,795.955750 582.016724,800.000671 574.910034,804.837646 
	C570.170471,805.931641 566.027832,805.159607 561.912048,803.537415 
	C556.054626,801.228760 550.175415,798.920715 543.405029,798.413452 
	C542.757690,798.364502 542.500854,798.335571 541.862915,798.249634 
	C540.735352,798.037170 540.013977,797.798950 538.948486,797.408936 
	C537.898499,797.002319 537.264954,796.617310 536.475708,795.818726 
	C535.846680,794.887939 535.628723,794.194153 535.798035,793.094604 
	C536.898315,791.908997 538.124451,791.757996 539.649048,791.376770 
	C540.244812,791.260315 540.486633,791.230286 541.094666,791.198486 
	C542.907654,791.352722 544.331299,791.736023 546.176270,791.632935 
	C548.317871,791.629944 550.086975,791.648743 552.240051,791.628052 
	C553.393250,791.630249 554.161133,791.669861 555.309570,791.753174 
	C555.940125,791.826599 556.189636,791.866516 556.805725,791.987732 
	C559.221069,792.708130 561.510620,792.633179 563.391602,793.638794 
	C569.809387,797.070190 575.131287,794.868958 580.472168,790.506958 
	C586.801697,787.546631 593.091675,785.561157 599.778687,783.659485 
	C601.737854,782.900513 603.534485,782.824280 605.420044,781.943604 
	C605.889954,781.721680 606.076843,781.633911 606.543152,781.418823 
	C607.192566,781.126587 607.562744,780.961853 608.471924,780.523010 
	C609.194580,780.161804 609.378296,780.074890 609.845032,779.870239 
	C610.713867,779.539246 611.314575,779.408264 612.472168,779.712891 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M668.323730,868.777527 
	C670.123291,858.082825 673.665405,848.669739 681.659546,841.136230 
	C683.218445,840.130981 684.934143,838.822266 686.256653,840.324829 
	C687.754883,842.026855 685.445679,843.157837 684.766663,844.486511 
	C683.644653,846.682251 682.291016,848.759033 681.052795,850.896240 
	C680.333069,852.138428 680.401123,853.073486 682.504517,853.287354 
	C691.247131,852.568665 699.373474,853.858337 707.750671,856.048767 
	C709.210693,858.188965 708.326111,859.622070 706.822754,861.278564 
	C704.395142,862.844360 702.316040,864.241333 699.258545,863.625610 
	C698.293457,863.523987 697.707458,863.574402 696.841736,863.728027 
	C690.749084,863.279114 685.225159,861.317505 679.495667,860.320740 
	C676.280212,859.761292 674.747131,860.565979 673.700989,863.816406 
	C670.158203,874.824829 668.766052,886.185486 667.593384,897.596863 
	C667.423767,899.247925 667.665527,900.937012 666.234863,902.612183 
	C665.413879,902.745972 664.877380,902.613892 664.060669,902.478088 
	C661.843628,898.821777 663.820984,895.263184 664.289612,891.762390 
	C665.302490,884.195801 666.920227,876.710144 668.323730,868.777527 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M747.523743,843.494812 
	C747.102356,842.113403 746.676575,840.829468 748.508057,840.054382 
	C750.136230,839.598206 750.307495,838.369202 750.892212,837.083740 
	C750.992432,835.951660 751.036438,835.152954 751.148499,833.960083 
	C753.581909,831.341797 753.690125,828.408203 753.794739,825.060303 
	C754.660034,812.929016 756.579346,801.314270 757.484131,789.594116 
	C757.636536,787.618835 757.538757,785.593994 759.477661,783.904785 
	C760.865845,784.960327 762.918823,785.228638 762.436462,783.760010 
	C760.794067,778.758484 765.035583,781.095276 766.799072,780.048584 
	C768.329468,781.380066 768.390747,783.023010 768.471497,785.068359 
	C769.251526,789.555481 766.757446,792.994019 766.200256,796.831665 
	C765.897095,798.919922 765.431946,800.993286 765.100708,803.479370 
	C763.574951,812.909363 761.400818,821.865234 761.769409,831.467102 
	C762.364319,833.601196 762.796326,835.388855 763.347778,837.625977 
	C763.232483,839.859192 762.398926,841.312622 760.694702,842.641235 
	C756.936951,842.812561 753.599121,843.464172 749.845825,843.975037 
	C748.907104,843.959351 748.381714,843.870056 747.523743,843.494812 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M839.868530,696.839233 
	C840.645813,695.880981 841.114685,695.065491 841.899841,693.699829 
	C843.782104,700.638184 845.526672,707.026123 845.612976,713.654114 
	C845.697266,720.136658 842.599487,722.881348 836.155396,722.933289 
	C831.296936,722.972412 826.602112,721.964783 821.562012,720.985840 
	C821.228577,720.996460 820.928162,720.836670 820.834534,720.756714 
	C819.480957,720.674316 818.462402,719.877136 816.990723,719.388123 
	C815.974915,717.828674 815.940063,716.183716 817.278992,715.685181 
	C822.241333,713.837341 824.705994,708.675171 829.857178,706.586487 
	C834.415588,704.383728 836.973083,700.668152 839.868530,696.839233 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M637.607056,535.045166 
	C638.455505,535.054932 638.884644,535.045654 639.632080,534.984985 
	C642.661438,533.143188 644.592651,534.227844 646.313354,537.005005 
	C646.457642,537.389587 646.543335,537.438721 646.563538,537.483826 
	C649.484314,539.903870 651.543823,543.134521 654.861328,545.549683 
	C655.151306,545.718994 655.151672,545.869507 655.226013,545.857788 
	C655.806274,546.960999 655.579468,547.916931 654.304138,548.877869 
	C645.954102,549.179443 637.975037,549.328918 629.541016,549.573792 
	C628.135010,549.973389 627.060669,549.885925 625.932495,550.630127 
	C622.715210,549.800964 616.385559,540.566833 616.913513,537.693542 
	C617.350037,535.318115 619.204651,535.929260 621.043823,536.554749 
	C622.647888,538.622070 623.645935,540.558716 624.383789,542.977051 
	C624.755249,543.487671 624.852417,543.766418 624.806885,544.095276 
	C624.932129,543.787292 624.843750,543.515686 624.415833,542.984680 
	C624.009460,540.960083 622.524170,539.413147 623.698364,537.208923 
	C624.030090,536.817871 624.169006,536.711670 624.552734,536.511597 
	C628.766602,534.520203 633.011658,535.080017 637.607056,535.045166 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M622.162598,849.684448 
	C619.896606,850.290466 617.902100,850.800354 615.516418,851.318359 
	C611.898132,851.796509 608.718933,852.756836 605.411255,851.495483 
	C603.566895,850.792175 601.942810,851.992859 600.281555,852.698486 
	C594.421448,855.187622 588.841003,858.422974 582.107178,859.280945 
	C581.509216,858.625977 581.441040,858.135925 581.779785,857.292603 
	C596.043091,848.463989 611.213135,842.424927 626.840393,836.577026 
	C630.813354,834.800293 633.223877,837.975586 636.626221,838.876953 
	C641.135376,838.843201 644.118408,840.787354 646.096802,844.630005 
	C645.239319,845.016235 644.491577,845.039062 643.378601,845.143250 
	C636.554138,844.565552 630.636963,846.663086 624.366394,848.901978 
	C623.583191,849.456482 622.989502,849.472778 622.162598,849.684448 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M673.464844,597.573975 
	C671.046692,608.774963 668.887390,619.644836 666.547424,630.475769 
	C666.083618,632.622986 665.783081,634.110352 668.656677,634.060059 
	C677.447571,633.906006 686.238831,633.766174 695.499023,633.608154 
	C696.695801,634.432251 696.458801,635.418457 696.222412,636.675781 
	C694.159668,640.227966 696.308838,643.989197 694.554932,647.591675 
	C694.348633,650.615295 695.094604,653.383667 693.480225,657.068726 
	C693.151917,655.045349 692.973083,653.943237 692.724243,652.478638 
	C691.415161,648.460327 691.062317,644.695496 691.347900,640.852051 
	C691.260620,640.195190 690.493958,640.820862 691.140625,640.658691 
	C691.244202,640.632690 691.342285,640.801086 691.279236,641.134338 
	C690.627380,644.581360 692.303589,647.995911 691.168701,651.687561 
	C690.922302,651.931763 691.007874,651.978821 690.968506,651.948242 
	C688.120483,653.112488 688.050842,650.825378 687.839539,649.251282 
	C687.495361,646.686951 687.507141,644.078857 687.865723,641.490967 
	C687.956909,640.833557 687.866516,640.342346 687.828064,641.007385 
	C687.826294,641.038208 687.527039,641.051941 687.139771,641.237244 
	C686.548828,641.536987 686.173401,641.611877 685.501953,641.546997 
	C683.295288,642.593872 684.800720,644.566101 684.083801,646.000977 
	C683.647461,646.874207 683.476685,648.101379 682.247437,647.914795 
	C681.424194,647.789795 681.132996,646.802368 681.071289,645.938477 
	C680.936401,644.050537 681.047729,642.158447 680.984497,640.269165 
	C680.999451,640.927551 681.106506,641.609680 680.975098,642.240173 
	C680.509949,644.471497 682.259888,648.424377 679.453857,648.521790 
	C677.239929,648.598694 677.605042,644.287292 677.131958,641.831970 
	C676.951111,640.893250 677.941589,640.000427 677.132690,639.056763 
	C675.536377,639.433838 676.904236,639.887024 676.940552,640.599976 
	C676.918152,645.095947 679.556641,649.144470 677.334351,653.729370 
	C676.406311,654.694824 678.414185,656.333191 676.125305,656.198730 
	C674.046631,650.245972 673.248840,644.299194 672.918396,639.233765 
	C671.974121,644.404663 676.085938,650.127319 674.134766,656.623413 
	C670.522217,653.971436 672.498962,648.887817 669.281189,645.448181 
	C668.359497,649.500366 670.627747,653.119629 669.504150,657.391968 
	C667.605164,648.915588 665.648315,640.997192 664.121704,632.996765 
	C663.434265,629.394043 664.924500,625.809387 665.574158,622.243530 
	C666.938171,614.755676 669.493896,607.519348 670.152344,599.863159 
	C670.289307,598.270752 670.307434,596.124512 672.671936,595.094727 
	C673.651184,595.661804 673.799622,596.405334 673.464844,597.573975 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M618.214844,658.772827 
	C622.056702,671.469910 626.445068,683.582642 632.212524,695.167053 
	C632.786926,696.320862 633.810303,698.064453 632.452637,698.710999 
	C630.578674,699.603394 630.214600,697.346802 629.538086,696.161072 
	C627.653564,692.857849 625.677856,689.588013 624.070068,686.149780 
	C621.122803,679.846863 616.802734,675.198059 609.685913,673.048523 
	C606.208313,668.241333 606.983765,662.909973 606.740723,657.395142 
	C607.242493,653.041443 603.583313,648.688904 608.403076,644.949463 
	C610.949890,647.089661 610.877991,651.462952 615.428955,652.292236 
	C616.259216,653.611816 616.760315,654.756165 617.277954,656.218628 
	C617.369812,657.253479 617.847473,657.801453 618.214844,658.772827 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M685.996704,780.261658 
	C679.704895,775.094299 673.732605,770.023682 667.781860,764.927795 
	C666.529968,763.855713 665.357117,762.691345 663.962036,761.278320 
	C664.755920,759.650940 666.370056,759.579712 668.009155,758.885742 
	C668.464172,758.680969 668.640991,758.594055 669.056702,758.342102 
	C669.585754,757.921692 669.854919,757.645874 670.272217,757.105347 
	C670.555054,756.694153 670.669128,756.527649 670.957275,756.109131 
	C671.801697,755.016785 671.946411,753.887634 672.948608,752.886963 
	C674.719604,752.625427 675.750061,753.514709 676.671265,754.463928 
	C681.554688,759.495789 687.329224,763.462219 692.682251,767.931396 
	C694.476929,769.429749 696.287292,770.896301 697.015869,773.633423 
	C697.121277,774.482056 697.171204,774.979919 697.069763,775.821411 
	C696.613892,776.491028 696.510925,776.877930 696.542603,777.638916 
	C696.416016,778.160522 696.318298,778.357422 695.992310,778.795776 
	C692.858459,781.210205 689.779724,782.136353 685.996704,780.261658 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M708.242126,775.756287 
	C705.034729,776.480652 704.430786,774.023743 703.426025,772.343933 
	C702.097839,770.123413 700.992737,767.785706 698.473999,766.096619 
	C695.908386,764.742981 693.126099,764.183777 692.390015,760.732422 
	C692.936218,758.089172 693.616028,755.874634 693.654541,753.526917 
	C693.701660,750.651611 695.094299,748.866943 698.403320,748.315430 
	C706.072205,749.400940 711.512878,753.956543 716.129578,759.036926 
	C719.620544,762.878540 714.459351,773.226562 708.242126,775.756287 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M592.492737,726.654968 
	C590.761780,727.002991 590.053101,726.271484 590.012939,724.425415 
	C589.857239,723.898865 589.714172,723.737000 589.627930,723.255005 
	C589.812378,722.759399 589.940125,722.583862 590.306824,722.188049 
	C591.592468,721.201477 592.565552,720.349915 593.734375,719.207825 
	C597.780029,716.474731 602.788208,715.741699 605.464233,711.026550 
	C606.448364,710.031006 607.332275,709.407166 608.135254,708.257507 
	C608.473145,707.848999 608.617371,707.692627 609.005127,707.329529 
	C610.498596,706.330994 611.661499,705.338806 613.578125,705.443604 
	C614.644653,705.832886 615.239685,706.416809 616.207520,706.979492 
	C616.622192,707.277405 616.780884,707.411560 617.110596,707.814453 
	C617.313843,708.490112 617.248535,708.876099 616.875610,709.435669 
	C616.715515,709.640930 616.424377,710.007690 616.219727,710.073181 
	C616.015137,710.138672 616.344421,710.416199 616.434753,710.202759 
	C616.802490,709.769043 617.080872,709.550049 617.614990,709.145996 
	C625.941162,706.023499 633.185486,701.219482 641.680420,698.753052 
	C642.018860,699.243469 642.053284,699.534241 642.129395,700.262207 
	C643.865479,705.709839 647.641785,709.840637 648.185425,715.595032 
	C648.045349,716.084290 648.049683,716.254761 648.041443,716.680664 
	C647.853699,717.100342 647.678528,717.264526 647.153992,717.522156 
	C645.794678,717.624878 644.933899,717.215088 643.862793,716.418152 
	C642.265381,714.803650 642.290039,710.449402 638.470825,714.184814 
	C637.206970,715.248352 634.859924,715.305664 636.523926,717.916565 
	C636.895874,718.952332 636.925842,719.676453 636.681152,720.774475 
	C635.479065,723.088989 633.706726,724.135376 631.298950,724.943604 
	C629.133301,724.797791 626.154480,725.875061 627.868347,721.772705 
	C629.398621,719.102661 628.196350,712.343811 626.292175,711.282104 
	C624.801819,710.451172 623.760681,711.642700 622.638550,712.187317 
	C614.546143,716.114502 606.159180,719.239136 597.215271,721.822571 
	C596.946167,722.042480 596.969238,721.959595 597.012024,721.964172 
	C596.900696,722.081360 596.746521,722.194031 596.328064,722.415161 
	C595.564575,722.873718 595.413330,723.438049 595.084229,724.222534 
	C594.985352,724.491333 595.027344,724.723572 595.027100,724.841553 
	C594.907104,725.107056 594.787354,725.254456 594.456482,725.593201 
	C593.763062,726.084839 593.180847,726.159912 592.492737,726.654968 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M484.762177,778.219910 
	C487.076721,774.218140 491.062469,774.021057 494.454193,773.279846 
	C498.590576,772.375916 502.934235,772.420410 507.576904,772.054260 
	C508.420105,772.513306 508.941620,772.717407 509.825256,772.302612 
	C510.489929,772.110291 510.908997,772.092529 511.642609,772.076294 
	C512.075317,772.193115 512.290222,772.302490 512.297852,772.424622 
	C512.716492,779.174133 512.709717,779.117737 519.839355,778.485840 
	C523.228638,778.185547 526.228394,779.771179 529.608704,781.046265 
	C530.410339,781.211731 530.551270,782.635315 531.661255,781.451660 
	C533.140381,781.256287 534.019104,781.610046 534.355591,783.202148 
	C531.932251,786.924194 528.288025,786.144653 524.567017,786.450562 
	C519.322571,785.989014 514.508911,784.465820 509.261780,786.295898 
	C506.318451,786.644897 503.776154,786.755188 500.952209,785.845581 
	C499.802521,785.479126 499.760284,783.779846 498.207306,784.545898 
	C498.003143,784.562805 497.600800,784.609253 497.717773,784.679077 
	C498.182037,785.015869 498.578033,785.221130 499.023987,785.815369 
	C499.214142,786.265625 499.246674,786.463501 499.131592,786.923462 
	C498.632294,787.261108 498.280548,787.336670 497.658722,787.373718 
	C491.379974,788.669373 488.468781,784.623657 485.308044,780.264526 
	C485.034912,779.992004 484.999969,780.005249 485.004150,779.987122 
	C484.633453,779.565247 484.478027,779.089600 484.762177,778.219910 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M606.294617,817.299561 
	C608.942078,807.509644 615.642334,802.718384 625.320251,802.106934 
	C632.132080,801.676636 638.976196,801.779785 645.801086,801.518127 
	C647.711487,801.444946 648.595093,802.052917 648.681335,803.971008 
	C648.761292,805.749268 648.210876,806.798706 646.251465,806.977966 
	C644.105347,807.174316 641.979187,807.589417 639.459961,808.023438 
	C631.625549,808.744080 624.268616,807.724426 617.645081,807.331665 
	C623.458496,808.691284 630.384521,807.132507 636.920288,809.498047 
	C634.785400,811.268005 633.593506,813.384888 632.094849,815.673950 
	C630.516296,817.390930 628.692993,817.356934 626.455627,817.443970 
	C620.152588,818.737610 614.227783,818.511902 607.863586,818.134399 
	C607.158386,817.886292 606.890808,817.748047 606.294617,817.299561 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M759.770935,536.216919 
	C769.369873,537.183960 774.510498,530.550415 780.582031,524.927734 
	C781.391418,524.783264 781.897278,524.734863 782.317017,524.459839 
	C788.169617,520.625183 790.044922,521.108582 793.908020,527.860474 
	C789.068176,535.272461 783.702209,541.161865 774.416565,542.693298 
	C768.622620,543.648926 762.884766,543.023987 757.147766,543.760132 
	C754.002502,544.163757 751.177551,542.908020 751.796387,538.426025 
	C752.239746,537.856079 752.467834,537.653137 752.873474,537.311035 
	C754.742188,536.808533 756.474609,536.491638 758.585571,536.164673 
	C759.152405,536.240112 759.340759,536.325623 759.770935,536.216919 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M702.116943,657.309631 
	C703.155884,656.185181 702.951172,654.962463 703.037170,653.813904 
	C703.120361,652.702515 702.873291,651.220947 704.629883,651.288391 
	C706.247009,651.350464 705.735229,653.075134 706.472595,654.451843 
	C707.165039,652.051636 707.729370,650.095337 708.350403,647.942688 
	C710.760254,649.366089 709.481689,652.072937 710.528259,654.370056 
	C711.570312,651.193115 710.204285,648.138672 712.214783,644.256470 
	C712.572937,648.291382 712.818359,651.056152 713.143677,654.721619 
	C714.673767,652.079590 713.146240,649.466003 715.674072,647.259155 
	C716.521362,652.656677 713.179138,658.045288 717.526001,662.444824 
	C715.932068,656.834045 717.343811,651.489624 718.405701,645.783447 
	C720.205505,650.091309 717.694519,654.043213 718.300598,658.584106 
	C720.406250,656.094971 720.266174,653.240906 721.778381,650.510925 
	C722.410645,655.321167 720.643494,659.776611 722.540222,664.093445 
	C724.644104,657.848145 723.226074,650.804443 727.638428,645.075500 
	C728.004761,645.870911 728.021179,646.748901 728.075317,648.064575 
	C730.075806,650.463989 727.968079,652.983765 729.221436,655.345154 
	C729.861938,656.166504 730.174011,656.780701 730.519287,657.761475 
	C730.618286,658.561279 730.551636,659.015564 730.222900,659.744507 
	C730.025940,660.028320 729.996887,660.003662 730.015686,660.005127 
	C729.223206,660.707520 729.612244,661.717651 729.192261,662.857300 
	C728.684875,665.448486 728.360291,667.748901 728.054443,670.434937 
	C719.154846,667.015259 709.412109,664.826294 702.116943,657.309631 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M804.657349,672.249084 
	C808.958923,670.687927 810.917114,667.660522 811.729370,663.677917 
	C812.269592,661.028748 814.757141,658.710144 813.085083,655.313904 
	C815.941284,654.194336 816.440674,658.259949 819.419678,657.788879 
	C819.932556,657.642090 820.136047,657.578308 820.659546,657.507690 
	C821.824646,657.688965 822.519104,658.167358 823.459473,658.829468 
	C824.714417,659.780884 825.919678,659.887329 827.428101,660.072388 
	C827.950134,660.164062 828.159607,660.208374 828.684082,660.330933 
	C831.377258,660.579590 833.629028,662.333435 836.445923,660.856934 
	C837.406067,660.494324 838.108398,660.536560 839.087402,660.233093 
	C840.095032,660.117798 840.771790,660.088867 841.759705,659.916443 
	C842.366455,659.594299 842.657349,659.408081 843.198608,659.169556 
	C845.781067,657.884949 848.108276,656.645081 850.763672,655.400879 
	C852.108948,656.603516 852.075989,657.778076 850.587158,658.914917 
	C849.868530,658.854492 849.415833,658.632141 849.242065,658.767639 
	C841.555542,664.760254 832.629883,664.511292 823.665710,663.734741 
	C820.266174,663.440186 818.006836,664.674927 816.222961,667.445679 
	C811.031494,675.509094 805.758179,683.519775 800.269409,691.776184 
	C797.733215,689.141602 795.985474,686.055603 795.916077,681.828003 
	C800.683289,680.293396 802.523865,676.367676 804.657349,672.249084 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M620.994019,487.472046 
	C620.991943,486.660492 621.017700,486.255920 621.043579,485.547241 
	C621.416626,484.482178 622.105225,484.174286 623.238892,483.917603 
	C625.756592,483.984680 627.901306,484.176880 630.398193,484.014557 
	C631.368347,484.036194 632.001831,483.937500 632.619202,484.118622 
	C632.108521,483.823212 631.551453,484.077545 630.658508,483.971985 
	C625.649963,482.661469 627.373962,480.657288 630.063049,478.409851 
	C632.283630,477.617859 634.195984,478.228577 636.490051,477.935242 
	C638.109619,477.882751 639.252563,478.040741 640.321594,479.347290 
	C640.470642,490.581818 640.561035,501.380737 640.179810,512.590759 
	C636.882996,518.854492 634.664001,519.627563 630.983643,515.733398 
	C631.306519,513.787231 632.967407,514.020264 633.889099,513.235779 
	C635.099182,512.205811 634.701721,511.732117 632.993835,511.789795 
	C631.920410,512.201416 631.396851,512.771118 630.950195,513.833862 
	C630.662903,514.268860 630.526917,514.428955 630.159424,514.802856 
	C628.168579,512.949036 627.020569,510.822540 629.575378,508.179321 
	C630.981384,507.751190 632.113525,507.654205 633.271484,507.647003 
	C632.475647,506.726410 631.384155,507.192963 630.111938,507.018250 
	C624.970642,505.577850 626.774963,503.529633 629.490601,501.195831 
	C630.839478,500.980164 631.930054,501.615234 633.303040,501.192535 
	C632.808899,499.902344 631.328918,500.253174 630.371399,499.294495 
	C629.581238,498.784271 628.721741,498.582397 628.584045,498.150452 
	C628.360107,497.448090 629.125916,497.122253 630.098755,496.884094 
	C630.863892,496.006989 632.244812,496.337006 632.378540,495.358002 
	C632.417114,495.076019 631.352966,494.929626 630.593872,494.371643 
	C626.833252,493.331146 628.229004,491.813446 630.000244,489.982910 
	C631.321350,489.408020 632.470215,489.757050 633.613892,489.430237 
	C632.749451,488.695892 631.811401,489.240967 630.606567,489.115356 
	C629.425049,488.708405 628.568848,488.361023 627.366943,487.972717 
	C626.817993,487.813019 626.614624,487.694183 626.215576,487.281219 
	C625.442139,487.195770 624.864441,487.404449 624.110840,487.877380 
	C622.892578,488.846405 621.916077,488.819611 620.994019,487.472046 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M761.316956,893.615784 
	C747.224670,893.576416 733.569824,893.759521 719.449097,893.873779 
	C718.989868,893.356750 718.996399,892.908508 719.053345,892.127686 
	C726.058655,889.282227 733.314880,890.273315 740.293152,890.873047 
	C748.283020,891.559692 756.196533,891.398376 764.620911,891.184082 
	C766.347412,890.959961 767.628662,891.059998 769.328735,890.616943 
	C779.856995,889.238220 789.973755,889.643921 800.552612,889.554688 
	C810.000305,889.591064 818.970215,889.540894 828.421509,889.554565 
	C835.332397,889.577393 841.761841,889.578369 848.680603,889.553589 
	C860.742676,888.780884 872.240112,890.933838 884.294678,890.305847 
	C886.163879,889.825317 887.502808,889.839111 889.251465,890.484741 
	C890.149414,891.326843 889.791199,891.888489 888.381287,892.163452 
	C886.920288,892.183777 885.855347,892.124146 884.394653,892.131897 
	C882.606750,892.157349 881.214661,892.115356 879.409607,892.147400 
	C862.330566,892.513306 845.664429,892.805115 828.536865,893.147705 
	C826.211121,894.645386 824.004395,894.412842 821.865967,894.421082 
	C812.584656,894.456909 803.303162,894.418579 793.531860,894.447998 
	C782.616455,894.055664 772.161072,895.189148 761.316956,893.615784 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M751.700317,538.123901 
	C751.644592,542.306702 754.468201,542.757812 757.504761,542.561401 
	C763.942688,542.145081 770.362305,541.430542 776.802490,541.074280 
	C779.003052,540.952637 780.501343,540.055359 782.028870,538.648071 
	C785.570801,535.385071 789.241028,532.261414 792.967590,528.786377 
	C795.797729,524.009705 799.691772,521.036194 804.768799,519.152710 
	C804.856567,518.833496 804.976746,518.483337 805.006592,518.300598 
	C806.383118,518.147583 807.729919,518.177307 809.478516,518.280151 
	C810.763550,518.098022 811.638611,517.979248 812.731323,518.726807 
	C813.025574,519.111572 813.063232,519.278748 813.038147,519.695190 
	C811.728882,521.662842 810.119446,522.877075 807.767517,523.319702 
	C807.466858,523.161621 807.349426,523.290100 807.279785,523.342285 
	C807.600098,525.579773 805.351868,524.658447 804.383240,525.756958 
	C804.060425,526.163879 804.009521,526.377991 804.204041,526.801392 
	C799.034302,528.065857 796.113098,532.609131 792.296875,535.850342 
	C790.294678,537.550842 788.780823,539.826294 786.928040,542.132812 
	C785.128052,545.420044 782.629578,545.637512 779.367981,544.219727 
	C773.360596,542.985779 767.822266,544.676392 762.214661,544.591797 
	C756.533508,544.506165 750.725098,545.625732 745.307556,542.584167 
	C746.404724,540.057007 749.179504,539.490356 751.700317,538.123901 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M691.256775,735.228821 
	C690.594482,732.968689 692.147644,732.156677 693.702881,730.979736 
	C698.598083,729.655579 702.605347,731.517090 706.122559,733.928101 
	C710.569824,736.976807 715.426514,738.868164 720.679199,740.884460 
	C725.076111,744.499878 728.388855,748.249268 727.669495,754.506592 
	C727.855225,756.706238 728.260193,758.590027 725.784851,759.671997 
	C721.295349,757.536255 724.272156,753.149658 722.327026,750.776306 
	C722.091553,752.052856 721.039062,753.277649 718.842773,753.795837 
	C717.238342,753.798279 716.258423,753.156006 715.062378,752.181763 
	C714.637329,751.791870 714.475952,751.628540 714.098267,751.204224 
	C713.757446,750.759705 713.632935,750.576233 713.352783,750.104980 
	C712.738953,748.898438 712.525696,747.827454 711.347595,747.012390 
	C710.973938,746.668945 710.831421,746.525513 710.497498,746.152405 
	C709.934326,745.469482 709.557617,745.022034 708.713379,744.673706 
	C708.244812,744.465088 708.061096,744.367310 707.655518,744.038940 
	C707.319336,743.622437 707.204956,743.436646 706.946655,742.952698 
	C705.872131,740.183655 703.659363,740.144043 701.471191,739.813721 
	C702.276306,741.314697 703.920471,741.525024 705.220886,742.776917 
	C705.806213,743.749268 705.871460,744.477966 705.555969,745.582886 
	C705.213379,746.108215 705.026245,746.283142 704.481323,746.599976 
	C699.625854,746.103149 696.096497,743.931396 693.522583,739.759277 
	C693.837646,737.579834 693.620789,736.048035 691.256775,735.228821 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M779.346680,802.012451 
	C782.943115,803.259155 777.545715,808.555969 782.066040,808.172180 
	C784.547363,807.961548 787.285889,807.135559 790.408325,806.980530 
	C792.078247,807.699585 791.916016,808.939331 791.971985,810.424927 
	C792.003113,811.731873 791.653015,812.794067 792.784729,813.791748 
	C793.230103,814.585327 793.464417,815.173096 793.974487,815.934814 
	C793.533875,819.744080 789.788940,820.659302 787.593872,823.434204 
	C784.387146,825.447205 781.666931,827.497986 779.222595,829.933228 
	C777.834961,831.315674 776.291687,832.564026 773.809448,832.367065 
	C768.873901,829.815125 770.248901,826.138306 771.700317,822.249146 
	C773.180481,822.980957 772.438232,824.253662 772.465576,825.194031 
	C773.440735,820.774048 774.510193,816.158936 775.667542,811.169434 
	C776.920166,807.932922 776.951172,804.640686 779.346680,802.012451 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M695.514893,723.646912 
	C693.807556,723.998230 692.900208,723.507874 692.130371,722.217346 
	C691.745117,721.287415 691.418701,720.731995 690.356934,720.735229 
	C689.959351,721.189453 689.868652,721.518433 689.614929,722.332764 
	C687.560913,722.207092 686.519104,720.716553 685.505859,718.785034 
	C685.234009,717.583435 685.885559,716.889343 685.985840,715.760864 
	C686.370911,714.986145 686.744324,714.514343 687.356812,714.006958 
	C689.509460,714.337524 691.214050,713.505737 692.671997,712.588257 
	C695.429871,710.852783 693.490601,710.210205 691.456421,709.510742 
	C690.650452,708.922363 690.141296,708.499878 689.288452,708.029724 
	C688.075867,707.296326 687.417603,706.421448 686.564087,705.274658 
	C685.591187,703.611450 684.945068,702.151489 684.073486,700.808105 
	C682.978760,699.120789 681.844238,699.297424 680.335815,700.810974 
	C677.973877,700.866516 678.030273,699.324341 677.962646,697.492432 
	C678.404846,696.659851 678.501160,696.050049 678.817871,695.207764 
	C678.991821,694.956055 679.009033,695.005676 678.983032,695.008911 
	C679.428345,694.597961 679.503296,694.008362 679.809814,693.206421 
	C679.971130,692.963013 680.002441,692.997620 679.979492,692.993530 
	C680.446106,692.586548 680.501892,691.986816 680.829651,691.194885 
	C680.997192,690.955261 681.010559,691.007202 680.983887,691.010132 
	C681.104309,690.881653 681.251404,690.750305 681.583008,690.387695 
	C682.863586,690.075867 683.959717,689.995239 685.581665,690.011658 
	C686.090149,690.598694 686.072876,691.088684 686.085815,691.945068 
	C687.646301,693.633240 688.321350,695.625916 690.006287,697.242554 
	C690.470337,697.837830 690.686035,698.205261 690.999023,698.868835 
	C691.434998,699.874573 691.764893,700.589905 692.500854,701.399414 
	C693.217102,701.977173 693.744385,702.094116 694.587341,701.605591 
	C695.419434,701.150696 696.025024,701.026123 696.961731,700.974609 
	C699.457336,700.032349 700.906738,703.027466 703.402832,702.042114 
	C707.143433,701.968323 706.149963,704.591553 705.666077,706.032715 
	C704.435547,709.697571 703.526245,713.604614 700.262573,716.743164 
	C699.970520,717.041931 699.972473,716.956543 700.014771,716.950562 
	C699.919922,717.082947 699.782837,717.221375 699.459473,717.586792 
	C699.063293,718.162170 698.830505,718.494446 698.349976,719.038574 
	C697.488770,719.981506 696.003174,719.961243 696.305542,721.749878 
	C696.364868,722.505920 696.257080,722.917603 695.514893,723.646912 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M555.041748,817.249023 
	C564.289307,819.799072 572.650879,819.903687 579.715942,812.183899 
	C581.559753,811.232727 582.942566,809.848145 585.289368,810.772705 
	C577.457275,826.350769 564.240173,821.884766 551.460083,819.976562 
	C535.028320,817.523193 519.054443,813.271790 503.157349,808.622559 
	C502.362579,808.390076 501.494568,808.286865 500.791718,807.890930 
	C499.843231,807.356506 498.168335,807.300964 498.209778,805.953003 
	C498.268402,804.047668 500.100922,804.623108 501.645386,804.425049 
	C506.241974,804.558777 510.104401,806.254150 514.062500,807.422546 
	C524.907837,810.623840 535.841003,813.347656 547.082397,814.742981 
	C549.737915,815.072632 552.145447,816.292480 555.041748,817.249023 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M555.217773,817.087097 
	C548.371155,817.024963 541.517395,815.334900 534.594543,814.095825 
	C523.495667,812.109131 512.779297,808.725525 502.058044,804.829224 
	C502.449280,804.030518 502.894257,803.569397 503.662170,802.988892 
	C519.390686,800.770203 532.941650,807.052551 546.664856,812.424316 
	C549.573792,813.562988 552.225403,815.358826 555.217773,817.087097 
z"/>
<path fill="#8395B3" opacity="1.000000" stroke="none" 
	d="
M605.189209,875.655884 
	C599.519470,878.291504 594.090515,880.727539 588.621216,883.069458 
	C586.443909,884.001892 581.144836,881.600098 580.352661,879.533020 
	C579.909180,878.375916 580.705139,878.066895 581.414368,877.701965 
	C590.244629,873.158264 599.082520,868.629578 607.918457,864.097107 
	C609.327087,863.374634 609.955322,863.982117 610.441406,865.347229 
	C611.160889,867.367920 612.089478,869.314087 613.000854,871.657593 
	C612.781921,872.162842 612.515564,872.339355 612.127441,872.743347 
	C611.551086,873.459961 610.898254,873.475037 610.030640,873.773438 
	C608.299561,874.398438 606.856750,874.908508 605.189209,875.655884 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M831.229492,706.901978 
	C825.862366,709.536682 822.834717,714.309204 818.952515,718.391113 
	C818.183533,719.235535 817.337036,719.592773 815.680908,719.228394 
	C814.382385,718.300354 813.745483,717.621765 813.037842,716.667236 
	C812.883423,716.013489 812.984558,715.707031 813.527283,715.335144 
	C814.014954,714.978638 814.301941,714.793579 814.835205,714.565552 
	C815.071106,714.506653 815.332031,714.125183 815.168274,714.313782 
	C814.650696,714.563782 814.341675,714.719971 813.829285,715.104736 
	C813.238464,715.422058 812.872559,715.547546 812.262329,715.824707 
	C812.028870,716.007874 812.000000,715.997070 812.015808,715.995178 
	C811.586975,716.408508 811.000305,716.472412 810.236267,716.822388 
	C810.020325,717.013062 810.001892,717.003906 810.004517,717.014282 
	C809.729431,717.238892 809.423035,717.397400 808.875671,717.651001 
	C808.555481,717.938049 808.447327,718.074280 808.144592,718.385010 
	C807.654968,718.742737 807.350708,718.909058 806.802368,719.165039 
	C806.403137,719.317688 806.238464,719.363220 805.821167,719.439758 
	C805.231018,719.478149 804.895691,719.509583 804.382324,719.737427 
	C804.015259,719.929749 803.828125,719.946777 803.359497,719.975342 
	C802.341125,720.696106 801.367188,720.384216 800.254395,720.801575 
	C799.996948,721.020203 800.000305,720.996826 800.009766,721.003906 
	C799.804749,721.151123 799.590149,721.291138 799.172058,721.105225 
	C800.165161,718.758606 795.370422,717.959167 797.965210,715.369995 
	C797.693726,714.841248 797.457947,714.546570 797.282898,713.898621 
	C797.328918,713.305237 797.443298,712.811218 797.082397,712.797729 
	C796.430298,712.773193 797.122498,712.508484 796.518616,713.196167 
	C795.789246,713.058899 795.646484,712.900452 795.387451,712.436768 
	C795.038330,710.660461 795.623657,709.502747 796.819458,708.221558 
	C799.452026,705.047546 798.902649,707.866150 798.971130,709.042603 
	C799.128113,711.741577 798.733215,714.867065 803.515381,713.033142 
	C806.860413,712.564697 808.986755,710.740417 811.210938,708.439941 
	C812.453918,707.710754 813.448242,707.212769 814.585327,706.300964 
	C816.322815,704.953430 817.780579,703.783813 820.156128,704.103638 
	C822.486511,705.079346 823.604614,704.392517 824.034546,701.958496 
	C824.226379,701.454895 824.317322,701.258728 824.586914,700.792236 
	C826.021301,699.373535 826.672913,697.673462 828.514343,696.747314 
	C829.240845,698.137695 828.372803,700.003906 830.693176,700.942871 
	C832.181580,702.830811 830.729065,704.784607 831.229492,706.901978 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M625.101562,570.718750 
	C620.032471,571.371033 620.265808,575.901733 619.161621,578.690857 
	C614.668884,590.039978 611.873474,601.942871 608.927002,614.158081 
	C608.880554,614.526001 608.750061,614.898804 608.880615,615.046997 
	C608.165649,615.759338 607.296204,615.771912 606.375183,614.849243 
	C606.390869,609.364136 608.194397,604.697388 609.429626,599.933655 
	C612.086548,589.687012 615.194824,579.559509 617.251709,569.155762 
	C617.927551,565.737488 619.454956,562.627625 621.056335,559.496338 
	C622.491577,556.689880 624.185303,555.495361 627.593079,556.094849 
	C631.273376,558.103760 631.432129,559.977417 627.614624,561.928833 
	C627.159912,562.173279 626.982788,562.272644 626.619507,562.608154 
	C626.306335,563.470764 626.275269,564.104065 626.316284,565.092651 
	C626.321533,567.184204 626.450989,568.950134 625.101562,570.718750 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M821.632263,704.700806 
	C819.062744,704.487854 817.366150,705.587830 815.371826,706.933105 
	C813.098389,704.865051 814.352600,702.994934 815.515137,701.147705 
	C817.382080,698.181030 818.656738,694.996094 819.143494,691.163452 
	C818.779236,688.730225 820.998230,686.460754 818.100586,684.480042 
	C817.008789,683.733765 816.949097,681.029846 818.393860,679.996338 
	C820.837341,678.248169 818.420105,678.312805 817.799622,677.309753 
	C817.810120,676.941528 817.876831,676.895142 817.908203,676.869385 
	C818.566895,676.431824 819.111023,675.913635 819.974670,675.377808 
	C822.550415,675.204346 824.858215,675.114197 827.597046,675.092346 
	C826.858521,677.603455 830.473816,679.542419 828.655273,682.255737 
	C827.981140,683.261597 829.502930,683.141296 830.174988,682.992493 
	C831.454346,682.709351 832.448059,682.752686 832.755127,684.673645 
	C832.959534,685.132202 832.973328,685.305176 832.996338,685.738281 
	C832.986633,686.556213 832.860229,687.083191 832.419250,687.796814 
	C831.204712,689.753052 831.467163,692.151306 829.312378,693.682739 
	C827.427002,695.879333 827.140137,698.579224 825.262573,700.797241 
	C825.041443,701.062134 825.003906,701.005737 825.036499,701.014771 
	C823.886902,702.120544 824.049988,704.342102 821.632263,704.700806 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M692.800293,760.659485 
	C694.663574,762.375610 696.317932,763.820618 698.083862,765.584778 
	C695.989502,766.232849 691.715942,765.353821 696.285156,769.471436 
	C697.279114,770.367126 697.872925,771.947815 697.302063,773.760254 
	C689.241638,767.108154 681.411926,760.232117 673.300049,753.183777 
	C672.188599,752.807739 671.485962,752.320251 670.420654,751.839539 
	C667.995300,750.319092 666.057739,748.771912 665.268066,745.866760 
	C666.566406,745.351929 667.862122,745.180542 669.649414,744.986572 
	C670.468201,744.651733 670.597168,744.267212 670.370117,743.559875 
	C669.949036,741.703064 670.763916,741.049500 672.621582,740.987061 
	C674.753174,741.415894 675.548767,742.967102 676.557251,744.204773 
	C678.830383,746.994751 681.593933,748.824768 685.528564,749.372070 
	C684.385986,753.118896 686.010681,755.293213 689.010864,757.060303 
	C690.394348,757.875122 691.591309,759.069458 692.800293,760.659485 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M757.884277,690.180908 
	C756.929688,689.219910 756.297546,688.442200 755.571228,687.765564 
	C751.929565,684.372742 753.426025,682.091736 756.896179,679.649109 
	C766.215210,673.089600 766.149963,672.996887 774.401550,680.852905 
	C774.642822,681.082581 774.881653,681.314941 775.119690,681.547974 
	C781.676270,687.967773 780.554993,693.889526 772.101746,697.894104 
	C769.778198,698.994812 768.043274,698.428406 766.257507,696.633911 
	C767.937500,695.316406 770.088867,696.605347 771.438660,695.049683 
	C773.138062,693.091125 776.160461,691.339478 774.478943,688.379639 
	C772.666382,685.189148 771.212830,680.603882 766.909241,680.507568 
	C763.470215,680.430542 761.539124,683.857117 759.989624,686.960144 
	C759.418152,688.104675 761.253906,690.643677 757.884277,690.180908 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M656.637695,792.573730 
	C659.355225,792.870911 661.674622,793.262024 664.391968,793.591064 
	C660.763672,797.238708 656.026245,799.731689 650.590454,799.963989 
	C642.687988,800.301697 634.760315,800.050537 625.414368,800.050537 
	C631.830261,795.840149 636.171936,790.909973 643.848755,792.603333 
	C647.791870,793.473083 652.097717,792.698975 656.637695,792.573730 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M773.442383,832.440552 
	C778.629395,830.253479 781.674622,825.544312 786.380493,822.432922 
	C789.526550,822.896729 791.002930,820.449585 793.082031,819.405823 
	C794.448669,818.719788 795.401367,816.591003 797.264648,818.107727 
	C798.933533,819.466187 798.818726,821.246399 797.654602,822.987305 
	C797.380432,823.397278 797.217651,823.874329 796.973267,824.665100 
	C796.813660,825.190674 796.742249,825.396606 796.519165,825.887817 
	C795.869934,826.845825 795.152222,827.293457 794.423462,828.145630 
	C794.133240,828.540955 794.015076,828.696472 793.714478,829.077637 
	C793.404236,829.446167 793.276428,829.588989 792.947266,829.932251 
	C792.606995,830.258118 792.468079,830.383423 792.119324,830.690430 
	C791.635620,831.112915 791.363342,831.355408 790.892334,831.795044 
	C790.547546,832.109070 790.403320,832.227966 790.019165,832.492310 
	C789.387329,832.786316 789.241760,833.094543 789.158936,833.799805 
	C788.381165,835.292969 787.370239,836.213440 786.125671,837.365540 
	C782.521179,837.933105 779.218262,838.327759 775.496216,838.709778 
	C774.878174,838.622498 774.679260,838.547913 774.274536,838.229980 
	C774.299500,837.153198 774.530151,836.319702 774.747192,835.049316 
	C774.560669,834.690796 774.387695,834.769165 773.949341,834.742188 
	C773.420593,834.348511 773.258179,834.010010 773.221069,833.343628 
	C773.260254,833.058594 773.400208,832.651550 773.442383,832.440552 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M783.121094,588.052612 
	C786.340698,587.385986 785.859863,589.664795 785.960571,591.062561 
	C786.743164,601.919250 789.092590,612.521301 791.027771,623.606445 
	C787.725281,624.615234 786.215515,627.184570 784.768738,629.767578 
	C782.752380,633.367432 780.813538,637.010681 778.604797,640.868042 
	C778.169006,641.244629 777.970032,641.388550 777.413818,641.444946 
	C776.215027,640.690918 776.034607,639.770020 776.131653,638.434448 
	C776.411133,637.707458 776.617493,637.281250 777.022095,637.085449 
	C777.430176,636.888000 777.407349,636.934998 776.633850,637.214355 
	C776.211914,637.294739 776.027344,637.216919 775.678223,636.875977 
	C775.157715,634.847290 776.155396,633.808350 777.760864,632.842041 
	C778.430237,632.554932 778.617981,633.146973 778.792053,633.048218 
	C779.030884,632.912720 778.871582,632.591736 778.383911,632.145081 
	C777.941895,628.848877 780.153320,627.016541 781.708740,624.513367 
	C783.406189,621.506531 784.684998,618.768555 782.438110,615.454224 
	C782.277649,615.168579 782.008850,614.973145 781.867310,614.885986 
	C784.722046,608.044922 781.843567,601.163147 782.126282,594.346863 
	C782.212708,592.264099 781.326477,590.122986 783.121094,588.052612 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M680.247009,955.765991 
	C676.999023,959.484619 677.266235,961.609497 681.406311,963.496155 
	C684.131104,964.737976 686.846375,965.835449 689.008057,968.410095 
	C688.549866,969.433472 687.817566,969.672485 686.931030,969.673706 
	C674.832092,969.690857 662.765076,968.832092 650.683960,968.364990 
	C649.510010,968.319641 648.368835,968.142883 647.150818,966.984802 
	C647.465454,963.780640 648.208557,961.115479 651.646545,960.010986 
	C658.507324,962.134766 665.246826,961.840088 671.897705,961.441589 
	C676.648865,961.156921 672.333069,957.482971 673.681458,955.402710 
	C674.446350,954.935608 675.017151,954.773621 675.764893,954.368774 
	C676.101990,953.944397 676.262146,953.762878 676.727051,953.778687 
	C677.031738,953.976013 677.001770,954.003540 677.001404,953.983154 
	C677.671387,954.751892 678.638428,954.406799 679.741699,954.785156 
	C680.020569,954.963379 680.013306,954.997559 680.023560,954.980713 
	C680.193970,955.147888 680.354126,955.331970 680.247009,955.765991 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M347.799622,860.014099 
	C353.419067,860.391418 358.003723,857.852356 362.958496,855.928345 
	C363.128845,855.395325 363.200317,855.185242 363.509247,854.741272 
	C364.469788,853.953308 365.346863,853.763184 366.497437,853.373413 
	C367.668304,853.018066 368.546936,853.034912 369.752563,853.076538 
	C384.933777,848.577454 399.271790,842.747070 413.632019,836.037842 
	C414.269897,836.899841 414.550354,837.790344 414.943024,839.017212 
	C415.050629,840.411133 414.269928,840.889099 413.232056,841.550049 
	C412.522400,841.863464 412.101837,841.998901 411.356750,842.191589 
	C408.897583,842.669556 407.013184,843.782837 404.665436,844.580017 
	C404.151520,844.776489 403.943512,844.851685 403.419739,845.034180 
	C402.458374,845.344971 401.822571,845.574585 400.889771,846.011597 
	C394.046112,848.824219 387.512207,851.464539 380.600922,854.178345 
	C368.663666,858.033447 357.083313,861.771179 345.250183,866.045166 
	C342.419495,867.136658 339.952240,867.818481 337.040955,866.352051 
	C336.604919,865.791992 336.506470,865.514404 336.633148,864.856689 
	C340.214325,863.423645 343.570435,862.370667 347.060913,861.000854 
	C347.285187,860.295410 347.375031,859.906921 347.799622,860.014099 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M536.596924,794.927307 
	C537.418701,795.527832 537.931946,795.809875 538.742371,796.155640 
	C539.595276,796.932373 540.114319,797.666809 540.422363,798.847534 
	C540.305969,799.443420 540.235352,799.587280 540.235352,799.587280 
	C539.892212,800.068848 539.872864,800.114075 540.312500,799.489197 
	C540.569763,798.525574 540.255188,797.755920 540.870117,796.869202 
	C541.092163,796.687805 541.485779,796.494446 541.684448,796.587158 
	C543.325256,798.447510 543.695923,800.332520 542.218323,802.812378 
	C532.515259,802.375366 523.728821,798.426208 514.296753,797.635193 
	C512.491394,797.483826 510.707428,797.077209 508.487122,796.753540 
	C507.584564,796.537903 507.108398,796.356995 506.403046,796.064331 
	C505.196625,795.489014 504.384735,794.912170 504.833252,793.342407 
	C505.505402,793.012512 505.932404,792.979492 506.676086,792.887573 
	C508.043823,792.312866 509.135101,791.964600 510.671783,792.035767 
	C511.458160,792.018982 511.898071,791.994446 512.666321,791.933228 
	C521.043518,790.359131 528.804321,791.295715 536.596924,794.927307 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M611.458435,575.039062 
	C610.863708,574.486206 610.688843,573.920288 610.271667,573.176331 
	C604.217468,572.987000 602.937683,574.355164 603.548096,580.104309 
	C603.946289,583.855225 607.027344,583.349915 609.777161,583.975098 
	C611.629578,587.710205 610.984924,590.572815 607.353882,592.839233 
	C601.651978,593.361023 600.372681,588.898743 598.032898,585.109741 
	C596.738525,581.104126 596.514099,577.353516 596.801880,573.226440 
	C598.235046,567.103210 603.044189,564.915588 610.814941,566.945190 
	C612.996582,569.613159 612.868103,572.281494 611.458435,575.039062 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M626.940308,562.891174 
	C625.903503,560.467773 631.922058,559.896057 628.054077,556.486206 
	C638.317566,555.802002 648.640747,555.430725 659.417725,555.141479 
	C660.783813,555.786804 660.975098,556.832764 661.660645,557.993286 
	C662.192383,560.291199 662.841248,562.209534 662.562744,564.592407 
	C660.445129,565.276855 659.331543,563.233337 657.123901,563.151123 
	C655.239929,563.664978 653.871460,563.337280 652.314941,562.236450 
	C646.178467,559.806213 640.449890,561.305298 634.370605,562.832764 
	C631.782776,563.980164 629.541077,563.215759 626.940308,562.891174 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M584.597900,835.924072 
	C582.232849,834.734558 581.516785,831.795227 578.444580,831.062927 
	C585.021851,824.161011 591.848999,817.221985 598.163574,809.776428 
	C599.650024,808.023743 601.857666,806.265381 605.267212,807.641968 
	C598.536560,817.201294 592.517517,827.043945 584.597900,835.924072 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M693.816284,738.749756 
	C696.391907,742.258362 699.713928,744.279114 703.687378,745.942871 
	C709.014465,748.463806 713.422241,751.787842 718.075073,755.374695 
	C719.387878,756.944153 720.178406,758.387024 720.152649,760.473083 
	C718.554871,763.028870 717.258972,765.356506 717.056641,768.063904 
	C716.939453,769.632568 716.518311,771.550598 718.949951,771.982971 
	C720.001160,772.169983 720.922424,772.564880 720.740417,773.863770 
	C720.549805,775.224304 719.557007,775.875427 718.300354,775.911316 
	C715.148010,776.001343 711.992371,775.976868 708.371277,775.980347 
	C709.398132,773.415405 712.884888,773.064819 713.942078,769.747742 
	C716.934265,760.360046 717.117676,760.387573 708.909180,754.696167 
	C705.934387,752.633484 702.853394,750.724121 699.491638,748.600586 
	C695.302490,747.585449 692.625061,745.162231 690.547180,741.563965 
	C691.650146,740.647217 691.979492,739.632080 692.103760,738.059204 
	C692.829346,737.611084 693.318848,737.919800 693.816284,738.749756 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M741.673767,881.596191 
	C745.837830,884.668823 746.148987,886.929260 742.637024,889.110352 
	C739.043457,890.323853 738.783936,890.171509 737.156982,886.196289 
	C736.988159,885.551331 736.651245,886.656860 737.229614,886.325256 
	C737.687195,887.210144 737.640015,888.191956 737.692871,889.483459 
	C737.407471,890.265320 737.110840,890.634705 736.412109,891.105957 
	C735.840454,891.303589 735.599609,891.343994 735.030273,891.222290 
	C734.231750,890.481812 734.008301,889.802307 733.855591,888.733582 
	C734.673401,886.083008 732.555176,886.038391 731.147705,885.063721 
	C730.317688,884.513855 729.806580,884.094299 729.196777,883.311890 
	C729.220276,882.761841 729.448425,882.548218 729.867310,882.196655 
	C730.026428,878.890991 728.842651,875.728210 730.575317,872.294189 
	C731.023499,863.201050 731.236450,854.472595 731.465942,845.259644 
	C732.007812,844.458984 732.576111,844.326904 733.595947,844.556152 
	C734.213135,844.945862 734.421265,845.157043 734.832031,845.762817 
	C736.199158,855.233154 735.489990,864.350525 735.490845,873.443665 
	C735.491272,877.840332 736.391235,880.901123 741.673767,881.596191 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M627.197632,966.676331 
	C616.050598,968.413391 605.130493,969.897949 594.211548,971.391052 
	C593.074463,971.546570 591.948120,971.869995 590.809937,971.907593 
	C589.338806,971.956116 587.492554,972.060974 587.446533,969.979919 
	C587.408508,968.255981 589.038574,968.056885 590.374146,968.054138 
	C594.894043,968.044983 599.054565,966.158203 603.742615,965.371948 
	C608.155762,964.603333 612.296875,964.096619 616.746948,963.340942 
	C619.156494,961.153992 621.674255,961.451721 624.601013,961.857849 
	C625.333984,961.948242 625.704773,961.835327 625.978638,961.951355 
	C627.594727,962.635986 629.892212,960.041382 630.736267,962.245911 
	C631.588257,964.471497 628.902344,965.277344 627.197632,966.676331 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M688.200439,822.188538 
	C690.676575,818.822144 689.251892,815.073242 689.791992,811.672302 
	C690.799438,805.329163 691.242310,798.896790 691.940735,792.503784 
	C692.181152,790.302551 692.586792,788.183472 695.605835,787.897705 
	C695.219727,803.006836 693.419861,817.878418 690.247070,832.922058 
	C689.639771,833.462280 689.259460,833.462830 688.815430,832.960754 
	C687.541687,829.319702 689.860168,825.808960 688.200439,822.188538 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M759.954834,783.389771 
	C758.422058,796.622375 756.937439,809.442444 755.449097,822.262146 
	C755.335083,823.243958 755.194336,824.222656 754.939209,825.600830 
	C753.325073,826.346313 752.474487,825.453369 751.555664,824.061279 
	C751.413696,822.731750 751.541199,821.750305 751.626587,820.404968 
	C754.056152,804.357910 755.315247,788.476685 759.988037,772.241211 
	C760.934326,776.462219 760.091736,779.719482 759.954834,783.389771 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M563.299133,575.195068 
	C562.900818,573.902893 562.740906,572.679810 562.295776,571.220825 
	C560.715454,569.313965 561.756104,567.805786 562.439697,566.361206 
	C565.636963,559.605164 568.973022,552.846985 574.362976,547.569702 
	C578.834717,543.191345 581.628174,537.320007 587.061401,533.811707 
	C588.731079,532.733582 590.078430,531.209106 592.644653,531.522034 
	C593.846252,532.350159 594.138550,533.276184 594.122314,534.712891 
	C591.793945,537.963928 588.475037,539.639038 585.311401,541.976685 
	C584.791382,541.896057 584.616089,541.772827 584.205078,541.868225 
	C583.969360,542.086792 583.981750,541.977112 584.036865,541.979248 
	C583.951477,542.143677 583.810974,542.305908 583.866455,542.723633 
	C581.167969,546.832520 578.273438,550.686035 575.186584,554.815674 
	C574.832214,555.222656 574.670105,555.353577 574.308105,555.724854 
	C574.108154,555.965210 573.979980,555.985657 573.986816,556.050171 
	C572.910828,557.445618 572.619812,559.229431 571.254761,560.757446 
	C571.037903,560.992004 570.985291,560.998901 570.992554,561.024414 
	C569.615845,563.085876 569.462402,565.795776 567.222412,567.729675 
	C566.976257,567.961670 566.993408,567.990540 566.977051,567.986938 
	C566.167297,569.374817 566.165466,571.041321 565.209167,572.721375 
	C564.703735,573.463135 564.398621,573.929321 564.015625,574.682739 
	C563.937622,574.969910 563.537598,575.264160 563.299133,575.195068 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M556.094971,670.921021 
	C554.971497,670.950623 554.222107,670.842957 553.246948,670.561035 
	C551.813904,668.445618 552.740662,666.542969 553.208313,664.679871 
	C555.454773,655.730469 558.627625,647.077148 561.811646,638.031982 
	C562.963257,634.672424 564.000488,631.670349 565.773926,628.592041 
	C566.208801,628.163513 566.407471,628.018250 566.966003,627.790100 
	C567.622253,627.769409 567.918762,627.831543 568.661133,627.980591 
	C571.639465,631.435852 572.213562,635.311401 569.996948,638.714661 
	C567.675110,642.279419 569.838684,647.213440 565.582520,650.139526 
	C564.120850,649.466858 564.058105,648.425232 564.387512,646.917725 
	C565.258362,644.613281 565.616577,642.578186 565.576599,641.089539 
	C565.074219,642.122925 565.715515,644.106567 564.576294,646.019958 
	C563.983337,653.718140 560.742126,660.348511 559.113953,667.389343 
	C558.763855,668.903503 557.896057,670.077271 556.094971,670.921021 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M440.814392,836.574768 
	C438.935181,837.499573 437.297791,838.186646 435.320679,838.906555 
	C433.130920,838.515015 431.592438,840.890625 429.369171,839.300659 
	C429.622223,836.058899 432.069611,835.271667 434.724731,834.189575 
	C435.332306,832.458923 436.508301,831.864929 437.800537,831.463867 
	C446.502197,828.762878 454.797272,825.023804 463.193848,821.543945 
	C464.596039,820.962830 465.990936,820.573181 468.119537,821.587341 
	C461.379486,827.927551 452.669830,829.940674 445.004883,834.530029 
	C443.511292,835.342957 442.283783,835.840027 440.814392,836.574768 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M403.757141,844.113647 
	C406.099731,843.020325 408.241241,842.196899 410.734192,841.412231 
	C411.569214,842.259521 411.818756,843.150085 412.018555,844.063599 
	C412.407837,843.277283 411.869537,842.285950 412.771118,841.311890 
	C413.552979,840.626404 414.106262,840.185303 414.857391,839.548828 
	C416.776672,838.867188 418.498077,838.380920 420.605286,837.923401 
	C422.133942,839.025574 422.631256,840.595093 423.982422,841.945435 
	C423.730591,845.623901 420.464691,845.571045 418.432281,846.980652 
	C416.817383,848.100586 414.991364,848.882080 413.171021,850.236328 
	C408.829071,853.055786 404.841370,855.970093 399.609070,857.113403 
	C398.574402,857.472351 397.827209,857.485779 396.724121,857.485535 
	C394.977234,856.073608 396.440857,855.312622 397.255737,854.114075 
	C398.405090,853.117432 399.497192,852.682556 400.729248,851.832458 
	C405.340546,850.443420 402.703613,846.804810 403.757141,844.113647 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M653.751709,987.224854 
	C654.087219,988.792419 653.959595,990.269104 653.764160,992.186035 
	C649.447815,996.114685 644.234680,996.412109 638.710815,997.004883 
	C635.035706,995.898560 631.189209,997.168396 628.036621,994.234131 
	C626.001770,991.435974 626.773804,990.348572 630.025879,990.452881 
	C630.600586,990.247314 630.815430,990.099548 630.971130,989.963684 
	C630.759399,990.128052 630.520142,990.275513 629.904236,990.446350 
	C628.768799,990.445801 627.996704,990.376648 627.628967,989.075012 
	C628.400269,986.905701 629.992981,987.022339 631.455627,987.032959 
	C638.733215,987.085754 646.012634,986.784668 653.751709,987.224854 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M699.147827,981.007507 
	C693.272888,980.246033 687.678101,980.626709 682.250183,982.489868 
	C675.364258,984.853455 668.481750,987.227173 661.289551,989.788025 
	C659.960327,991.068665 658.877441,992.007629 656.851624,991.290283 
	C656.791687,988.840088 658.512817,988.277527 660.273865,987.607361 
	C666.466370,985.250793 672.653076,982.874268 678.788696,980.374451 
	C687.672852,976.754761 697.015686,977.336182 706.285034,977.182556 
	C707.523315,977.161987 708.040466,977.888123 707.988647,979.482910 
	C707.364929,980.512817 706.687439,980.982788 705.446167,981.281616 
	C703.138550,981.383911 701.244507,982.533997 699.147827,981.007507 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M659.891724,633.423706 
	C659.431580,633.916077 659.031189,634.017395 658.324951,634.073547 
	C655.600952,628.919617 658.617615,624.309448 659.467712,619.541321 
	C661.119690,610.275940 664.898865,601.490967 665.275391,591.875000 
	C665.396179,588.791992 667.676758,585.793579 668.992065,582.387878 
	C671.964783,583.525208 670.158630,585.867249 669.745850,587.659668 
	C666.273010,602.740051 662.683350,617.792786 659.891724,633.423706 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M499.656860,785.158691 
	C502.459076,785.022461 504.922150,785.040710 507.745850,785.055908 
	C513.178467,785.309326 518.273438,784.799133 523.609802,785.298096 
	C527.128418,784.857605 530.475708,785.310730 533.755127,783.327271 
	C534.795715,782.170715 535.729065,782.217834 537.016174,782.801392 
	C538.611145,784.604980 539.839661,786.246765 540.583191,789.149292 
	C540.591858,790.408997 540.428589,790.733398 540.160522,791.259399 
	C540.265076,791.639038 540.380310,791.765625 540.394897,792.128418 
	C539.189209,793.204468 537.904297,792.647095 536.347534,792.882935 
	C529.745728,793.346863 524.102661,791.277954 518.241272,788.541016 
	C517.503479,788.246521 517.088013,788.185181 516.357544,788.151001 
	C515.853943,788.305298 515.665344,788.432495 515.229614,788.324463 
	C509.922119,787.042664 504.767181,788.765686 499.348022,787.376587 
	C498.986237,786.986694 498.988434,786.787964 499.039246,786.104492 
	C499.087860,785.619812 499.317719,785.313232 499.656860,785.158691 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M700.241333,673.620850 
	C692.558167,674.915039 685.078308,674.814575 677.604187,674.855774 
	C676.438843,674.862183 675.239868,675.004333 674.115662,674.783142 
	C672.380737,674.441772 670.050537,674.309082 670.199890,671.846558 
	C670.343994,669.471069 672.578796,669.253601 674.379700,669.315063 
	C682.693298,669.598877 691.002075,670.022034 699.691895,670.552063 
	C700.587708,671.493042 700.799561,672.326843 700.241333,673.620850 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M603.620239,922.561340 
	C602.360229,919.673096 603.889099,917.839417 605.985962,917.231323 
	C617.120605,914.001892 627.449463,908.208252 639.575317,906.817261 
	C641.383484,909.436707 639.155640,909.945374 637.646057,910.598267 
	C633.317261,912.470276 628.996582,914.365173 624.260254,916.279785 
	C618.992920,918.312622 613.946838,919.840637 609.197876,922.114380 
	C607.485474,922.934326 605.780273,923.206421 603.620239,922.561340 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M675.923584,519.629272 
	C678.960815,519.839661 679.337219,514.940186 682.775513,516.738831 
	C681.964661,519.782654 682.720947,522.646973 682.487976,525.888550 
	C682.115356,531.250549 683.499817,536.355530 680.597656,541.220581 
	C678.000732,541.185913 678.733032,539.396973 678.444458,538.149048 
	C679.599182,545.477112 680.082703,552.806946 678.486328,560.468445 
	C677.585449,560.775635 676.931641,560.774109 675.797363,560.670532 
	C673.710632,551.710449 674.507874,542.823181 674.996338,533.503052 
	C675.371094,528.705994 674.529541,524.282532 675.923584,519.629272 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M726.196899,517.389648 
	C727.851868,507.105499 728.635925,496.985107 733.076233,487.736664 
	C733.157715,487.798035 733.257324,487.873016 733.356934,487.947998 
	C733.226013,488.016449 732.976501,488.093933 732.980957,488.152069 
	C733.942383,500.769257 730.346863,512.856628 728.673096,525.165344 
	C728.404602,527.140137 727.963440,529.091370 727.469849,531.444153 
	C724.397644,532.182007 725.033936,530.004883 724.998108,528.417664 
	C724.916809,524.816467 726.400635,521.388000 726.196899,517.389648 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M694.003662,572.990479 
	C699.827881,573.212585 705.226868,572.236694 711.138306,573.414124 
	C705.473572,577.973999 677.373596,578.430054 674.274658,574.304749 
	C680.723328,573.032471 687.112915,572.992859 694.003662,572.990479 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M778.910034,757.997925 
	C777.568665,761.899353 782.592834,764.663452 780.138062,768.673340 
	C777.846497,772.449097 777.909485,776.520691 776.850952,780.572937 
	C775.942017,783.836304 774.891113,786.753845 773.947327,789.705627 
	C773.405396,791.400696 772.259766,792.016113 770.211853,791.976440 
	C767.984009,789.380920 769.651733,786.969299 770.214417,784.501709 
	C770.758301,782.116455 771.547241,779.784607 771.844055,776.955444 
	C773.111938,772.495300 775.166565,768.528992 773.656494,763.718445 
	C774.303345,761.850769 775.726196,762.059204 776.969238,761.864014 
	C775.704163,761.938110 774.436401,762.008240 772.827759,761.971619 
	C772.277832,761.821106 772.066711,761.729309 771.606689,761.398193 
	C769.203552,759.341797 769.674927,757.416016 771.407837,755.236511 
	C771.859985,754.863892 772.025513,754.704590 772.534424,754.575562 
	C774.105957,755.512573 775.054016,756.922302 777.188843,756.896240 
	C777.982483,757.137024 778.394653,757.367798 778.910034,757.997925 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M596.739136,652.270752 
	C596.978271,651.992432 597.254272,651.890930 597.400635,651.877197 
	C598.419189,651.350525 599.270996,651.264954 600.267517,652.253540 
	C600.746216,653.273071 600.713501,654.114319 601.264526,655.064331 
	C601.836121,655.688232 602.163330,656.151123 602.724426,656.785278 
	C603.072510,657.378235 603.233276,657.759888 603.396851,658.452637 
	C603.349854,659.207458 603.240601,659.635559 602.912842,660.336975 
	C600.906799,663.291809 603.363220,663.704285 605.114685,664.880676 
	C606.554688,667.154480 606.641724,669.221497 605.442932,671.683472 
	C605.020630,672.471558 604.905457,673.212891 604.611023,673.292725 
	C604.036133,673.448486 603.345032,673.303467 602.729858,673.162048 
	C598.820801,672.263367 594.919373,671.331665 591.015442,670.410828 
	C592.380859,666.542419 593.746277,662.674072 595.156799,658.432678 
	C594.666931,655.994812 595.234314,654.189697 596.739136,652.270752 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M648.346558,716.096558 
	C646.304138,711.393616 644.156311,707.083374 641.123962,703.290405 
	C640.238708,702.183105 640.440857,701.609863 641.827271,700.841309 
	C648.179504,696.606995 650.750366,700.398132 653.172485,705.303162 
	C653.729309,705.128784 653.932190,704.993408 653.905640,705.143066 
	C653.243774,708.612366 656.007263,710.553650 656.812683,713.629761 
	C654.206604,714.958923 651.603699,716.241577 648.346558,716.096558 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M675.964294,639.439819 
	C677.261230,638.410217 676.658875,636.895874 677.597778,635.786682 
	C680.724670,639.476562 676.260559,644.332581 680.007202,647.717285 
	C680.007202,644.202942 680.007202,640.594727 680.007202,635.567627 
	C682.841492,639.930359 681.325867,643.622925 682.873718,646.848999 
	C683.029114,643.775940 683.184509,640.702881 683.351990,637.390564 
	C685.330811,637.835693 684.866455,639.186279 685.119690,640.530090 
	C687.460938,645.573120 688.228394,650.390503 686.226807,655.763367 
	C682.827942,656.866699 679.763428,657.706360 677.425049,654.105347 
	C676.718201,649.327454 676.332520,644.591003 675.964294,639.439819 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M781.542603,647.153809 
	C783.902527,647.492920 784.059509,644.208374 786.151733,644.615723 
	C781.507141,653.675476 778.078003,663.015991 777.889038,673.773499 
	C769.768311,669.601562 769.615295,669.209961 773.694641,661.419189 
	C776.174072,656.683960 778.769470,652.009460 781.542603,647.153809 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M673.580322,954.915283 
	C677.266663,963.141357 677.262939,963.263123 668.320068,962.991150 
	C662.848328,962.824707 657.149963,963.948486 652.032166,960.392700 
	C657.353394,958.401428 662.681335,956.697876 668.081726,955.267639 
	C669.725464,954.832336 671.428162,953.595276 673.580322,954.915283 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M572.325806,584.518311 
	C571.476501,587.768738 570.190369,590.473755 569.870972,593.512634 
	C569.654541,595.571472 570.225281,598.624329 566.964478,598.907715 
	C564.619812,599.111450 561.800354,594.469360 562.260803,591.709778 
	C563.530640,584.099426 566.178345,581.096924 574.816528,577.698059 
	C575.015564,580.314453 573.051208,582.013611 572.325806,584.518311 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M673.717651,597.937805 
	C673.311279,597.180115 673.353271,596.441589 673.222412,595.373962 
	C673.421631,593.903198 674.365601,593.735046 675.382263,593.632874 
	C684.233459,592.744019 693.115417,592.763855 701.995300,592.707520 
	C702.997803,592.701172 703.489380,593.162231 703.261963,594.624573 
	C693.884521,600.735901 683.784424,596.922546 673.717651,597.937805 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M754.565918,482.268311 
	C763.834839,487.253967 772.770630,492.176514 782.047485,497.286896 
	C780.350647,499.153351 779.050110,500.583801 777.393250,501.990417 
	C770.610413,497.910919 764.339417,493.620636 758.014526,489.411255 
	C755.912170,488.012115 754.016296,486.493713 752.659607,483.946899 
	C751.630432,481.364899 753.261047,482.174042 754.565918,482.268311 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M681.957520,947.050049 
	C686.964050,947.734558 691.529602,948.444641 696.117188,948.958496 
	C697.877502,949.155762 698.927307,949.666504 698.884888,951.609985 
	C698.839111,953.708679 697.470886,954.071106 695.848572,953.884583 
	C687.970154,952.978516 680.128418,951.837402 672.628235,949.118896 
	C671.116272,948.570862 669.020264,947.595886 669.741821,945.784180 
	C670.413757,944.096985 672.335449,945.528687 673.706360,945.748047 
	C676.312622,946.165100 678.919067,946.580994 681.957520,947.050049 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M708.344604,857.100952 
	C699.858032,855.896545 691.706360,854.824524 683.236938,853.519409 
	C684.691833,850.780090 687.284546,850.894714 689.882019,851.178040 
	C691.053101,851.305847 692.384399,852.450195 693.084595,850.060242 
	C695.389771,848.059204 697.905212,848.481995 700.308655,848.923340 
	C703.939941,849.590027 707.513794,849.557922 711.511719,848.885315 
	C712.150085,849.004700 712.380066,849.030334 712.954041,849.103271 
	C713.994141,850.380005 713.446838,851.490173 712.800781,852.928467 
	C711.501221,854.761353 710.783386,856.685486 708.344604,857.100952 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M611.313843,947.699097 
	C609.920166,947.945618 608.873901,948.004028 607.432617,948.069824 
	C605.592834,947.713013 604.100403,947.530579 602.691895,947.038025 
	C600.975769,946.438110 600.144836,945.453796 601.771851,943.464966 
	C603.462646,942.853760 604.882629,942.496948 606.670166,942.145996 
	C607.465759,942.525208 607.921021,942.855591 608.718506,943.172607 
	C609.138733,943.391418 609.302185,943.488098 609.717224,943.710693 
	C611.129822,944.274963 611.794678,943.274902 613.016724,942.759644 
	C620.637756,941.020447 628.013428,941.339783 635.374878,941.603638 
	C637.849854,941.692383 640.364441,942.030579 641.676819,945.149780 
	C641.692749,945.859741 641.646606,946.142944 641.387329,946.799927 
	C638.153503,948.527405 635.045410,947.097595 631.578247,947.448547 
	C629.520447,947.477234 627.877930,947.465698 625.828857,947.432861 
	C623.809937,947.325500 622.165649,947.499817 620.242249,946.700073 
	C617.129089,946.876892 614.395142,947.193909 611.313843,947.699097 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M714.340759,565.977966 
	C714.695129,566.980652 714.430176,567.657715 713.674194,567.701477 
	C704.857544,568.211975 696.134338,571.044373 687.197144,568.765991 
	C686.163635,568.502502 685.206055,568.319397 685.265381,567.032288 
	C685.311707,566.028198 686.088013,565.676392 686.976868,565.643799 
	C696.006165,565.312683 705.038452,564.152100 714.340759,565.977966 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M676.907837,794.921265 
	C677.312927,797.502625 676.554443,799.346924 674.228882,801.102051 
	C669.893188,804.374146 671.988831,809.490112 671.759277,813.860352 
	C671.669617,815.567627 672.865356,817.408569 670.323914,818.827393 
	C669.584900,818.462097 669.175110,817.843445 668.553223,817.034546 
	C667.288208,816.667908 667.575745,815.695679 667.362061,814.689087 
	C666.994629,810.048523 665.398315,805.481323 666.420776,801.604797 
	C667.510254,797.474365 673.792358,798.283203 676.907837,794.921265 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M779.171997,677.241699 
	C783.715820,666.911987 788.421204,656.825500 793.154724,646.752258 
	C793.988281,644.978333 794.939270,643.259705 796.505310,641.815491 
	C794.801270,655.094727 786.783936,665.776062 781.311951,677.804565 
	C780.470459,677.831543 779.906799,677.660522 779.171997,677.241699 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M637.710205,995.986206 
	C643.069519,995.054932 648.021790,993.957153 653.335205,992.742859 
	C654.532288,995.777405 650.683960,994.257629 650.154663,996.450806 
	C647.365784,998.951294 644.013611,997.970337 641.031982,998.935852 
	C641.035889,999.695374 640.993347,1000.128906 640.901001,1000.885254 
	C639.234314,1002.424988 637.339966,1002.039978 635.574524,1001.962280 
	C628.458069,1001.648621 621.446960,1002.571045 614.157349,1003.798157 
	C612.845947,1004.044373 611.810303,1004.025879 610.386108,1004.004883 
	C609.978943,1003.007568 609.960327,1002.012756 609.936279,1000.644836 
	C611.256836,998.317688 613.375610,998.686829 615.285645,998.444946 
	C622.618408,997.516174 630.011597,997.094421 637.710205,995.986206 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M620.555542,487.061768 
	C621.470703,488.054993 622.450623,487.838959 623.612244,488.061157 
	C623.863403,488.804199 623.791748,489.466766 623.610779,490.447357 
	C622.159973,492.302155 620.173279,491.068817 618.637817,491.894592 
	C618.076904,492.196198 617.521118,492.091736 618.175049,491.962280 
	C618.235474,491.950317 618.302917,491.974304 618.644287,491.955505 
	C619.339355,491.851593 619.750000,491.744781 620.524170,491.568848 
	C625.526367,492.589691 622.951111,494.517334 621.110413,496.554565 
	C616.932495,498.276245 613.022583,498.919434 608.581177,497.764709 
	C607.277954,496.849091 607.039368,495.835052 607.072266,494.369720 
	C609.276184,492.167664 605.778259,491.139526 606.607605,489.217834 
	C606.964783,486.742157 608.533081,487.123779 610.007202,487.134735 
	C613.386047,487.159882 616.765625,487.089874 620.555542,487.061768 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M652.256714,785.431396 
	C652.057678,785.933838 652.052795,786.146240 652.017029,786.675720 
	C651.543274,787.016785 651.100342,787.040649 650.324829,787.078247 
	C649.820496,787.186951 649.648621,787.281921 649.239807,787.202087 
	C648.250854,787.023315 647.498962,787.019348 646.371582,787.035767 
	C645.830994,787.163635 645.665955,787.271179 645.252686,787.218445 
	C643.610901,787.060913 642.217346,787.063660 640.407104,787.029663 
	C639.535278,786.462524 638.855164,786.582336 638.086182,786.154907 
	C638.694458,785.393433 640.097595,784.950378 640.169983,784.347534 
	C640.314331,783.145630 638.874268,783.343811 638.026978,782.991333 
	C631.901917,780.443115 625.417908,779.685425 618.482544,779.000427 
	C617.121704,777.972290 617.536682,777.043457 618.483276,775.866455 
	C619.254456,775.375427 619.752075,775.235596 620.657166,775.195557 
	C629.899536,776.626709 638.493469,779.680542 647.933411,779.728394 
	C648.450745,780.018921 648.642456,780.155457 649.062256,780.553711 
	C649.949707,781.531738 648.257019,783.953186 651.314880,783.277100 
	C651.820190,783.529236 652.003662,783.668274 652.327881,784.125427 
	C652.462708,784.676208 652.456726,784.908813 652.256714,785.431396 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M641.196472,945.892456 
	C640.623535,943.863525 639.194214,943.281067 638.006470,943.279358 
	C629.569885,943.267334 621.070740,941.405762 612.301636,944.079651 
	C611.667297,944.216248 611.440857,944.259216 610.944519,944.085815 
	C610.494446,943.433533 610.456787,942.985657 610.784912,942.261963 
	C622.871948,939.752930 634.724854,938.940369 646.504211,942.458557 
	C648.863586,943.163269 651.391541,943.765320 652.588989,946.826904 
	C648.800293,948.741028 645.096191,947.643677 641.196472,945.892456 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M639.532776,813.465942 
	C642.105286,812.237488 644.335266,811.126953 646.660278,810.276123 
	C647.728455,809.885132 649.388428,808.751892 649.955078,810.722900 
	C650.323120,812.002930 650.659424,813.950989 648.697510,814.539795 
	C638.826233,817.502563 635.766846,825.010681 636.064636,835.456604 
	C632.682007,830.322754 634.974243,818.260742 639.532776,813.465942 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M749.529175,712.540466 
	C747.479553,707.570068 748.514648,702.791687 748.496033,698.018127 
	C751.739136,704.239868 753.362671,710.956970 754.462158,718.150757 
	C753.713501,724.524841 754.934692,730.426880 755.233521,736.795959 
	C755.038635,737.768677 754.799194,738.277100 754.109741,738.981079 
	C750.845703,739.068420 751.329956,736.779846 751.021545,734.580811 
	C750.036255,727.148010 750.679749,719.997620 749.529175,712.540466 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M564.681458,650.499817 
	C567.149719,643.276306 570.936157,636.621887 569.075195,628.474121 
	C570.110168,628.090637 571.113281,628.113770 572.488770,628.218262 
	C574.152588,628.599243 575.123718,629.525269 576.574829,630.230225 
	C577.178040,630.704834 577.424622,631.059875 577.792847,631.729065 
	C581.258850,634.520142 583.118652,637.471313 580.539062,641.716064 
	C578.291931,640.726868 577.582153,638.531006 575.907837,637.248901 
	C575.038879,636.583374 574.308838,635.273682 573.083740,635.753967 
	C571.816956,636.250549 572.363403,637.721985 572.170044,638.776306 
	C572.053833,639.409851 571.997375,640.055725 571.766724,641.033203 
	C569.171204,646.549622 569.494873,652.629333 566.126099,657.831238 
	C565.549500,658.007141 565.295288,657.976990 564.762207,657.681885 
	C564.363098,657.190247 564.242859,656.963684 564.013000,656.368469 
	C563.684998,654.731262 563.726868,653.461853 563.981140,651.820984 
	C564.182068,651.221191 564.293884,650.992554 564.681458,650.499817 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M604.052673,557.958923 
	C597.890442,559.418396 594.067322,564.781738 587.321960,566.627319 
	C589.248169,562.409302 590.619263,559.133118 592.220886,555.973816 
	C593.964050,552.535156 597.191040,553.623779 599.682068,554.371460 
	C601.385925,554.882812 605.089233,553.731873 604.052673,557.958923 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M702.295898,1002.373657 
	C699.167786,1002.074951 696.391479,1001.825134 693.643555,1002.005859 
	C689.343628,1002.288635 687.917297,1000.635742 689.712036,996.282104 
	C695.793518,994.755371 701.601196,993.153625 707.537720,996.831177 
	C707.837097,998.192871 707.867249,999.216187 707.945129,1000.620605 
	C708.084106,1001.275940 708.175293,1001.550110 707.955444,1002.128296 
	C706.020203,1003.501648 704.355042,1003.459045 702.295898,1002.373657 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M817.482178,676.996277 
	C818.097290,678.123291 822.190674,677.765137 819.115601,680.361267 
	C817.498169,681.726746 818.737061,684.384277 819.271973,684.724792 
	C822.026306,686.477844 820.054016,688.443054 819.918457,690.958984 
	C819.723938,691.797607 819.599243,691.972412 819.226379,692.355286 
	C818.789185,692.670105 818.600220,692.776794 818.111511,693.012695 
	C816.356934,693.627747 814.899109,694.104065 813.095764,694.609558 
	C811.774475,694.728027 810.952881,694.438904 810.236816,693.252197 
	C810.046631,692.536926 810.045349,692.112061 810.046509,691.368408 
	C811.520325,689.874634 811.381287,687.826294 812.747437,686.228882 
	C809.721497,680.828613 814.504883,679.440247 817.482178,676.996277 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M589.390015,837.696777 
	C591.492554,838.837952 592.955200,840.314148 590.933533,842.533081 
	C589.488220,844.119507 590.446960,845.969666 590.209717,847.976257 
	C590.292175,848.283508 590.203125,848.241028 590.191406,848.193115 
	C589.592163,848.377991 588.957458,848.468811 588.249390,849.028198 
	C588.115295,849.314026 588.047424,849.188110 588.116455,849.169434 
	C587.554810,849.425964 586.815491,849.438904 586.160522,850.268555 
	C582.255188,852.730225 578.467896,854.864014 574.358887,857.008179 
	C576.327515,852.170349 580.738770,848.962769 583.741272,844.277161 
	C585.592224,841.933716 587.350281,839.906677 589.390015,837.696777 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M651.730164,860.796631 
	C652.606567,863.764893 656.900879,867.162842 655.552124,867.753174 
	C652.702820,869.000366 648.742432,867.975464 645.295288,867.481262 
	C643.476135,867.220398 641.138245,866.811584 640.972961,864.204651 
	C640.817810,861.756653 641.406311,859.596375 644.633484,858.877686 
	C645.188660,858.706665 645.363831,858.591553 645.744812,858.238647 
	C646.765381,858.229858 647.580139,858.458862 648.693970,858.806274 
	C650.448792,858.485840 650.961975,859.557922 651.730164,860.796631 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M661.236572,805.730957 
	C661.744995,806.346436 661.900208,806.821289 662.144043,807.664551 
	C662.519714,808.715759 662.482117,809.437500 662.513916,810.512207 
	C662.738892,813.122192 662.537292,815.504944 663.221863,817.597839 
	C664.528198,821.591736 663.445679,824.185669 659.308472,825.841187 
	C654.069458,821.994324 656.461853,816.128906 655.433044,811.251221 
	C655.081238,809.583069 657.885559,806.420410 661.236572,805.730957 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M567.431519,627.348206 
	C567.325806,627.707275 567.098938,627.782654 566.997803,627.846313 
	C564.546875,625.728333 561.360413,625.112793 558.784790,623.202759 
	C558.931274,622.505981 558.985291,622.133484 559.053711,621.479248 
	C561.500793,620.023438 561.999207,617.312927 563.766113,615.191345 
	C566.293274,611.306519 567.289551,611.229919 572.242798,614.651978 
	C570.800598,619.016357 569.168945,623.002747 567.431519,627.348206 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M750.705933,754.340454 
	C751.229675,759.393494 751.757751,764.009155 752.173767,768.634888 
	C752.297668,770.012878 753.118896,772.106323 751.209351,772.484985 
	C749.192688,772.884705 748.516052,770.955811 748.383240,769.175293 
	C747.817993,761.596558 746.882751,754.014832 748.376709,746.157166 
	C749.991516,748.670166 749.996704,751.389893 750.705933,754.340454 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M607.668213,492.670105 
	C607.775391,494.037842 607.117188,495.068573 607.878113,496.542358 
	C608.362549,497.337433 608.655884,497.775330 609.042114,498.608643 
	C609.448486,500.526703 609.348450,502.085419 609.362061,504.020386 
	C609.370483,504.653015 609.372192,504.904999 609.378174,505.533264 
	C609.354309,506.901520 609.228577,507.882812 608.980347,509.213593 
	C608.697021,510.252197 608.399902,510.898865 607.959290,511.856812 
	C607.028320,513.517212 606.572815,514.994507 606.099609,516.810669 
	C605.451233,519.386353 603.623535,519.617737 601.402222,519.673279 
	C601.056641,518.439331 600.959351,517.339844 601.694580,516.265686 
	C605.780884,510.295288 605.020996,503.480438 605.018066,496.787231 
	C605.016724,493.682983 602.875000,494.015625 600.462219,493.976562 
	C599.149780,493.446625 598.265625,492.920135 597.239502,492.121887 
	C599.435303,490.597809 602.189819,491.185822 604.959106,490.207703 
	C606.403442,490.599304 606.748840,491.660919 607.668213,492.670105 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M794.372070,513.308716 
	C793.513489,514.012268 792.751953,514.390930 791.678833,514.813477 
	C788.583069,511.242218 784.140808,511.000549 780.028625,509.241455 
	C780.206116,507.478699 781.280212,505.835602 781.078735,504.367554 
	C780.635376,501.137695 782.452759,498.845612 784.591003,497.877563 
	C786.506165,497.010468 788.173035,499.705872 789.880188,501.419708 
	C791.632080,504.767883 788.197021,504.997284 787.196289,506.517822 
	C789.156494,509.325348 793.325195,509.442841 794.372070,513.308716 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M693.162964,971.630737 
	C675.863647,972.718872 658.904114,970.954285 641.466187,970.088867 
	C641.128235,968.058167 642.200623,967.052551 644.519531,966.945923 
	C645.992004,967.799561 647.296570,968.027954 648.646179,967.978394 
	C659.435425,967.582336 670.144836,969.716125 680.941345,968.995178 
	C684.446777,968.761169 687.881470,969.646057 691.787659,969.786926 
	C692.202332,970.006958 692.553772,969.922974 692.734131,969.932739 
	C693.344299,970.309998 693.510437,970.772217 693.162964,971.630737 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M642.205200,698.673889 
	C634.170898,703.098633 626.182739,706.863342 617.545532,710.072144 
	C616.850586,710.242371 616.508545,710.321655 615.689453,710.178162 
	C615.712646,709.514954 616.212891,709.074829 616.884460,708.347961 
	C618.868530,705.555664 621.583191,704.866943 624.760132,704.473389 
	C633.097168,701.426147 640.581970,697.138062 647.691162,692.574890 
	C652.329102,689.598022 651.248962,693.260010 653.125305,695.166138 
	C648.453186,694.343079 645.629272,696.892761 642.205200,698.673889 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M620.420776,887.059937 
	C620.338501,884.031555 619.684448,881.466858 618.801392,878.543579 
	C618.453979,877.710449 618.346985,877.225952 618.509888,876.352966 
	C619.440552,875.380005 620.213806,874.703613 621.660034,874.861328 
	C626.958374,874.612671 629.257507,877.222412 629.882568,884.527222 
	C627.023926,886.942383 624.132690,888.208252 620.420776,887.059937 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M700.949890,497.417053 
	C701.286560,497.122406 701.651367,497.065735 701.835815,497.057281 
	C702.202332,497.145325 702.384521,497.241821 702.721680,497.070679 
	C702.876587,496.803009 702.960083,496.847900 702.938599,496.890137 
	C703.427246,496.649872 703.957092,496.398834 704.582153,495.781006 
	C704.876709,495.397095 704.987183,495.238098 705.318604,494.891754 
	C705.892639,494.554779 706.245667,494.405121 706.760986,494.020325 
	C706.923279,493.785309 706.948242,493.887909 706.895508,493.884949 
	C707.451416,493.635010 708.039551,493.353821 708.743591,492.647034 
	C711.805786,491.077789 713.977173,488.917786 716.330566,486.465820 
	C716.709473,486.073730 716.862915,485.919312 717.248718,485.536865 
	C717.635376,485.157593 717.789673,485.006256 718.407959,484.404663 
	C719.766296,483.064606 721.150452,482.705322 721.796387,481.104614 
	C722.084290,479.619080 722.253479,478.432373 723.772522,477.935486 
	C725.875122,480.305328 724.561584,482.318268 723.144653,484.680908 
	C722.601318,485.249695 722.484924,485.544891 722.644226,486.115143 
	C722.780457,487.155670 722.242615,487.438568 721.288208,487.771027 
	C715.475281,493.427856 709.676514,498.511322 701.595093,500.779480 
	C700.111938,500.019836 700.047668,498.929596 700.949890,497.417053 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M762.100586,831.497253 
	C758.393005,832.223450 759.731567,829.453125 759.907837,828.158569 
	C760.979675,820.288574 762.309692,812.453613 763.792114,804.301819 
	C764.557678,803.165527 765.096130,802.352722 766.596313,802.770020 
	C766.819519,810.111755 764.539307,816.929626 763.630676,824.384521 
	C763.530701,825.379028 763.565369,825.963745 763.225586,826.769958 
	C762.803467,828.404114 762.536194,829.792603 762.100586,831.497253 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M498.175171,814.127930 
	C496.179993,810.754028 494.454224,806.997620 492.682068,803.263245 
	C491.949066,801.718567 491.211243,800.203857 488.970825,801.388000 
	C482.517242,804.799133 475.247467,806.369629 468.726929,810.469788 
	C468.315979,811.199036 467.989899,811.433105 467.230286,811.235596 
	C464.967072,809.100525 466.257660,808.317383 468.092438,807.572632 
	C475.146301,804.709778 482.221222,801.891235 489.193695,798.840027 
	C491.279755,797.927185 492.095581,798.531982 493.049164,800.287170 
	C495.111694,804.083557 497.050781,807.911377 498.170959,812.501587 
	C498.296173,813.168701 498.361023,813.461548 498.175171,814.127930 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M613.775635,952.230713 
	C615.733032,950.191406 618.829346,951.611572 620.695801,949.167236 
	C621.399963,948.615601 621.853699,948.338379 622.777832,948.131226 
	C623.999023,948.145874 624.720825,948.444763 625.601318,949.271362 
	C626.427124,950.900330 627.369385,951.524475 628.893982,951.611023 
	C630.493774,951.701721 632.269104,951.692688 633.124756,953.772339 
	C631.800659,955.366943 630.241821,954.878296 628.805603,954.990112 
	C625.564941,955.242371 622.068481,952.930176 619.487976,957.708984 
	C617.999573,960.465393 612.521423,959.195190 611.874817,956.327637 
	C612.224426,955.725769 612.490601,955.518860 613.052246,955.343750 
	C613.281189,955.285400 613.682251,955.106812 613.682251,955.106812 
	C613.682251,955.106812 613.425781,954.723877 613.336060,954.456299 
	C613.157532,953.577271 613.253662,952.999756 613.775635,952.230713 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M742.213013,445.091705 
	C741.069824,441.709320 736.650269,444.553925 735.980347,440.810883 
	C736.181396,439.391388 735.335876,438.451355 735.694458,437.080078 
	C736.433228,435.970032 737.655640,435.899902 738.101562,434.646362 
	C737.861450,433.900940 737.564087,433.485870 736.831299,433.099548 
	C736.429077,432.856445 736.270142,432.751770 735.899048,432.450806 
	C735.597961,432.083069 735.508972,431.911621 735.269287,431.492767 
	C735.552368,429.547180 735.585510,429.493652 734.045166,428.539673 
	C733.548523,428.232086 733.206848,427.898499 733.465271,427.465759 
	C734.189270,426.253448 734.815674,424.684509 736.925293,426.006378 
	C737.592224,426.692719 738.090576,427.110321 738.801392,427.778748 
	C739.038879,428.000824 738.992554,428.009308 738.992920,427.985718 
	C739.200134,428.209229 739.421204,428.442993 739.843384,428.816101 
	C740.030396,428.968750 740.000000,429.000000 740.015137,428.983948 
	C740.272095,429.282837 740.555298,429.554657 741.157837,429.885925 
	C744.666443,433.001068 741.932861,437.158081 743.766235,440.762634 
	C743.966248,442.177521 743.852539,443.328766 743.495239,444.727112 
	C742.998169,445.129333 742.744812,445.284424 742.213013,445.091705 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M687.497620,586.572754 
	C686.678284,583.402466 688.154419,582.758606 690.590332,582.759521 
	C695.029358,582.761169 699.695557,580.353516 703.749451,583.424805 
	C704.557922,584.037231 704.921692,587.823547 701.845337,587.875183 
	C697.126160,587.954285 692.286560,588.952515 687.497620,586.572754 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M640.030640,513.311829 
	C639.875854,501.958618 639.814697,490.915039 639.630615,479.415222 
	C637.487671,473.335968 638.899414,467.509369 638.497559,461.789795 
	C638.244995,458.195892 639.622314,454.064850 634.515137,452.368103 
	C632.993469,451.862610 633.460083,450.105896 634.265930,448.943176 
	C635.400146,447.306549 636.812866,445.915588 638.920898,444.701355 
	C639.615295,444.560638 639.903259,444.564423 640.557495,444.797180 
	C642.075134,449.344757 640.812195,453.713562 641.280212,458.503998 
	C642.435303,460.637085 642.624451,462.392059 641.610962,464.637024 
	C641.261902,481.393585 641.133362,497.746735 641.048950,514.569580 
	C640.905579,515.147522 640.718201,515.255798 640.301025,515.134705 
	C640.088867,514.477356 640.106567,514.049438 640.030640,513.311829 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M773.927612,762.891968 
	C777.209045,767.349670 774.614624,771.380615 773.304321,775.754211 
	C771.947998,776.780945 772.101440,778.254272 770.963318,779.379272 
	C769.899292,779.846863 769.164612,779.825134 768.132568,779.256836 
	C768.082153,773.157654 768.469849,767.296082 771.235474,761.513000 
	C771.357910,761.158752 771.732361,761.163879 771.917969,761.188782 
	C772.384888,761.393555 772.551025,761.648743 772.626465,762.198792 
	C772.651001,762.418335 772.884827,762.778809 773.099304,762.700928 
	C773.313782,762.623108 773.775330,762.712891 773.927612,762.891968 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M831.411011,707.102539 
	C828.672913,705.391052 829.884216,703.542725 831.030151,701.358459 
	C831.474731,698.050171 834.189087,696.310852 835.092651,693.218262 
	C835.833923,691.931763 835.890076,690.672180 837.058228,689.680908 
	C839.515503,689.281982 839.591919,690.695923 839.682983,692.536011 
	C839.917053,693.814209 840.002075,694.774109 840.132019,696.215271 
	C839.052124,701.513062 835.516113,704.361389 831.411011,707.102539 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M570.995972,641.619507 
	C571.708130,638.503967 569.403015,633.902039 572.392822,633.798340 
	C575.802917,633.680115 578.956726,637.096680 580.156067,641.440308 
	C579.017334,645.024841 577.831909,648.264221 576.393677,651.749329 
	C575.962280,652.172974 575.783752,652.350830 575.316772,652.284424 
	C575.147095,650.133484 575.266052,648.226746 575.114380,646.099426 
	C574.326904,645.509949 573.764282,645.298096 572.800171,645.373535 
	C572.280518,645.307373 572.078003,645.243652 571.663696,644.941406 
	C571.003906,643.938110 570.968018,643.097839 570.995972,641.619507 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M703.633484,671.446594 
	C706.426392,667.770752 701.989868,668.651367 701.101929,666.104187 
	C711.497131,666.754395 719.964844,671.517456 728.850037,675.678772 
	C723.435547,674.669434 717.824829,673.523560 712.360535,671.888489 
	C708.815308,670.827637 707.155518,671.021667 708.784668,675.192810 
	C706.913208,675.925232 706.263794,673.428772 704.330505,674.028198 
	C703.430298,673.344666 703.242188,672.610291 703.633484,671.446594 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M712.007019,848.634277 
	C710.833008,850.862549 709.295288,851.499146 707.087830,851.191711 
	C702.752869,850.587769 698.385742,850.214844 693.595093,849.719971 
	C692.627441,849.024109 691.051819,849.182556 691.554260,847.698669 
	C691.974182,846.458313 692.909912,845.824890 694.171326,845.865723 
	C700.176270,846.059753 706.183228,846.244690 712.178589,846.610779 
	C712.902832,846.654846 712.207092,847.707886 712.007019,848.634277 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M661.747559,805.661377 
	C655.786194,810.086792 654.761475,816.742432 658.784668,825.567566 
	C657.030273,827.971069 656.376831,826.232056 656.156494,824.752808 
	C655.234314,818.561401 654.322754,812.359558 653.737976,806.130493 
	C653.449646,803.058716 659.203491,800.689026 662.822571,802.556274 
	C662.899109,803.503052 662.838684,804.050293 662.371948,804.792603 
	C662.115967,805.171448 662.010620,805.311340 661.747559,805.661377 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M684.074829,798.155762 
	C687.447449,799.841553 685.947876,802.867126 686.073547,805.228027 
	C686.355896,810.533081 688.163391,815.893616 686.100281,821.625610 
	C685.945923,823.205078 686.092957,824.521484 684.174316,824.964111 
	C680.971802,822.559814 682.624329,819.172668 682.355713,816.333557 
	C681.789307,810.346741 681.237671,804.184570 684.074829,798.155762 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M640.946167,945.736694 
	C644.582031,946.048767 648.179382,946.647583 652.241821,947.224731 
	C654.135376,951.869934 651.687500,955.009460 648.490479,957.834045 
	C647.400757,958.796814 646.078613,960.267700 644.732178,959.518250 
	C643.314575,958.729187 644.119873,956.897705 644.665771,955.244019 
	C646.214050,953.194519 644.465820,950.170898 647.039978,949.528687 
	C646.597229,950.246155 645.404907,950.018982 643.881226,949.904663 
	C642.147583,949.462280 641.020386,948.812256 640.764526,946.975098 
	C640.925659,946.408691 640.916626,946.216064 640.946167,945.736694 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M691.970581,969.748291 
	C677.908875,970.435059 663.649414,969.531982 649.382385,968.920227 
	C647.893860,968.856384 646.346985,969.036621 645.071960,967.301147 
	C645.330750,966.877686 645.784912,966.813721 646.572205,966.659180 
	C658.574951,967.008118 670.203247,968.328125 681.904358,968.155273 
	C684.020325,968.124084 686.143188,968.556152 688.684692,968.752075 
	C689.984009,968.983093 690.861389,969.236389 691.970581,969.748291 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M605.674744,817.181030 
	C605.966064,816.989441 606.352295,816.941956 606.546753,816.936157 
	C612.820190,818.326477 618.911133,817.443848 625.426392,817.018311 
	C627.556458,817.106323 629.307495,816.724731 631.229858,817.839478 
	C631.429504,818.978394 631.340881,819.794739 631.172119,820.911987 
	C621.437561,821.710022 611.747742,821.360840 601.655029,822.281555 
	C602.589600,820.547241 603.986511,818.959900 605.674744,817.181030 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M655.372986,521.058716 
	C651.559937,520.382080 651.660522,520.474243 652.255920,523.259827 
	C652.624451,524.984314 650.327026,525.454590 649.342773,526.593323 
	C648.565491,527.492615 647.686401,528.823486 646.160889,527.226440 
	C645.136658,526.154114 643.713867,525.430786 644.021057,523.267944 
	C647.897949,518.708313 652.469360,515.526611 657.810181,512.897644 
	C662.736206,517.206360 657.974548,518.796631 655.372986,521.058716 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M667.178162,698.270935 
	C665.240601,695.749207 664.822266,693.353027 667.683289,691.908691 
	C670.657471,690.407227 671.213257,693.493835 672.051697,695.127747 
	C673.905396,698.740051 675.386597,702.543518 677.039307,706.602661 
	C674.829712,706.924316 672.254822,708.043030 670.706787,704.822632 
	C670.167419,702.205994 669.480530,700.015991 667.178162,698.270935 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M666.872070,837.633911 
	C667.044006,838.541077 667.079529,839.085754 667.260437,839.866272 
	C670.276672,841.846497 669.898193,844.544189 669.245239,847.621521 
	C668.988403,849.793884 668.988403,851.591797 668.988403,853.389771 
	C667.679932,852.246582 668.040771,850.301147 666.267334,849.039062 
	C661.844543,843.888062 660.437256,838.341614 661.821533,831.761108 
	C661.524597,831.020081 661.539368,830.588440 661.950623,830.216736 
	C662.668335,829.567688 663.425415,828.962097 664.624817,827.951843 
	C665.392944,831.343323 666.064331,834.307434 666.872070,837.633911 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M770.534790,779.347290 
	C771.165039,778.039124 770.617920,776.462463 772.698242,776.068420 
	C772.952332,781.277832 770.680054,786.066895 769.837708,791.569641 
	C768.103149,795.213867 768.275574,798.896240 767.142883,802.642700 
	C766.137634,803.223145 765.370483,803.488281 764.316956,803.875000 
	C765.001526,798.230347 765.972351,792.464111 767.008423,786.364075 
	C768.060120,785.059143 768.200867,783.658997 768.985962,782.218140 
	C769.471313,781.119324 769.848938,780.334045 770.534790,779.347290 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M564.612183,658.425049 
	C567.569763,654.425049 567.487427,649.993591 568.730652,645.984192 
	C569.214478,644.423645 569.376038,642.777649 570.693604,641.207153 
	C570.990234,640.994141 571.000000,640.999695 570.997559,640.995728 
	C572.089783,644.771606 570.250122,648.654114 571.205627,652.722534 
	C571.015869,653.012878 571.000000,653.000000 571.009583,653.003906 
	C568.445190,658.764709 567.230408,665.023010 564.248169,671.013245 
	C564.009705,671.309204 564.054443,671.580872 564.056763,671.718506 
	C562.091919,672.904480 560.362854,672.217285 559.521118,670.491089 
	C558.485413,668.367249 558.615295,666.062317 560.736755,663.971191 
	C561.169739,663.604492 561.343567,663.467529 561.732666,663.092163 
	C562.221008,662.548096 562.482178,662.232727 562.876587,661.655518 
	C563.113342,661.236206 563.203064,661.067383 563.416870,660.642822 
	C563.772339,659.870728 564.001404,659.353271 564.612183,658.425049 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M686.988525,704.785217 
	C688.687012,705.116699 689.350708,705.829590 689.003052,707.637817 
	C683.404907,712.123413 678.326599,716.896667 671.848511,720.204590 
	C671.167725,719.970642 670.828369,719.753113 670.729370,718.980835 
	C672.259094,715.460876 675.501343,714.839294 677.617126,712.873047 
	C678.863770,711.714478 681.140381,711.454834 680.963501,708.683105 
	C680.615234,707.954834 680.520386,707.574097 680.793945,706.899170 
	C681.154846,706.459045 681.328674,706.267883 681.802734,705.831543 
	C683.541931,704.796814 684.969666,703.956421 686.988525,704.785217 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M693.306641,971.964111 
	C692.940002,971.490234 692.966919,971.048340 692.954163,970.274414 
	C697.871521,969.971069 702.484436,969.232117 705.407898,964.530212 
	C705.840393,963.834595 706.551941,963.118286 707.416626,963.733093 
	C707.831909,964.028381 707.971680,964.840576 708.061401,965.444641 
	C709.096130,972.413757 707.748474,974.008972 700.406372,974.003479 
	C698.138367,972.468506 695.962830,972.093018 693.306641,971.964111 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M779.792969,801.610291 
	C778.875244,804.710388 778.017029,807.483276 777.069641,810.617432 
	C776.731628,811.076721 776.482727,811.174561 775.913452,811.029663 
	C774.981934,809.773499 775.062500,808.748230 775.730469,807.362793 
	C775.920471,807.009399 776.169617,806.580933 776.194092,806.334351 
	C775.945618,799.183411 778.802124,792.871338 780.097656,786.267456 
	C780.947937,781.932800 782.457214,777.666138 784.592773,773.296143 
	C784.935974,772.647766 785.062805,772.317200 785.179688,771.719727 
	C785.294434,770.771057 785.533936,770.110413 785.720459,769.105103 
	C786.326111,768.592712 786.776001,768.552673 787.487549,768.906311 
	C787.618530,769.579163 787.503357,770.003845 787.290894,770.744019 
	C787.273071,771.248413 787.352417,771.437378 787.218994,771.848267 
	C786.931152,772.477905 786.856201,772.885620 786.749023,773.603088 
	C787.215881,775.628479 786.226562,776.988037 785.448914,778.730530 
	C785.069580,779.721802 784.874451,780.424866 784.668274,781.493530 
	C785.390869,783.919189 784.510315,785.631958 783.350098,787.648804 
	C783.106812,788.428162 782.997131,788.871948 782.881042,789.658813 
	C783.092163,790.175781 783.309814,790.349854 783.123535,790.631470 
	C782.719727,790.739136 782.719543,790.839722 782.765686,790.859741 
	C782.173157,793.736938 782.098145,796.735413 780.488159,799.713379 
	C780.150879,800.447998 780.001709,800.865540 779.792969,801.610291 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M675.653076,531.787720 
	C676.276611,541.246643 676.117432,550.474731 675.367065,560.130554 
	C672.655701,560.168274 673.691345,557.997314 673.683289,556.645508 
	C673.635803,548.709595 673.789001,540.772461 673.976807,532.423096 
	C674.440125,531.662964 674.866577,531.505188 675.653076,531.787720 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M752.518494,483.963379 
	C759.330811,489.261261 766.822021,493.853424 774.196838,498.609161 
	C775.310120,499.327057 776.625610,499.755829 776.979736,501.620575 
	C775.993530,501.917175 774.950134,501.867798 773.518677,501.771515 
	C768.436462,497.289185 762.955750,493.924408 757.505005,490.571625 
	C754.967346,489.010681 752.927551,487.392212 752.518494,483.963379 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M740.409302,525.319092 
	C740.430786,527.820618 741.499390,531.154663 739.554749,531.617188 
	C737.027100,532.218323 737.073364,528.584534 736.440186,526.840027 
	C734.459167,521.382812 735.250366,515.929260 738.161865,510.634521 
	C736.567749,515.835754 740.169861,520.064087 740.409302,525.319092 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M694.154053,472.722351 
	C693.916626,473.455963 693.890442,473.896851 693.933716,474.662598 
	C695.002502,476.464844 694.159912,478.187561 694.671875,480.140076 
	C694.777466,482.438629 694.846802,484.331726 695.032349,486.618835 
	C695.223877,487.165771 695.299255,487.318726 695.321655,487.721924 
	C695.089539,489.295227 694.910461,490.618317 694.659668,492.336700 
	C694.422180,493.208557 694.087402,493.431519 693.324524,493.175720 
	C692.351868,485.929169 691.638550,478.908264 690.851379,471.436401 
	C689.910889,467.443024 688.477356,463.898224 691.278137,460.307434 
	C691.737976,460.642212 691.740967,461.038544 691.841187,461.717468 
	C693.323425,463.233154 693.017700,464.816223 692.752808,466.751923 
	C692.765564,467.555634 692.868896,467.979553 693.086304,468.710846 
	C693.492310,469.602783 693.476135,470.274780 693.755371,471.192444 
	C693.784180,471.513824 693.645142,471.756287 693.716187,471.876648 
	C693.979858,472.141235 694.172607,472.285400 694.154053,472.722351 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M562.946777,662.661926 
	C562.971924,664.066833 562.237854,664.453613 561.435913,665.094604 
	C558.690796,667.288757 559.508667,669.895691 563.690063,671.775818 
	C564.044312,674.429565 563.416016,675.923157 560.567871,674.016968 
	C559.194519,673.097778 557.698059,672.362549 555.989136,671.301147 
	C559.729675,663.377319 561.140991,654.843018 563.887695,646.350586 
	C564.207764,645.882690 564.364380,645.758118 564.759277,645.816284 
	C564.976685,647.124451 564.955811,648.250000 564.946045,649.805664 
	C564.957214,650.235779 564.987793,650.489868 565.001465,650.617065 
	C564.078247,654.567932 563.976379,658.545593 562.946777,662.661926 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M619.199707,875.794189 
	C618.948669,876.519226 618.897156,876.991760 618.774536,877.813904 
	C611.007690,879.261536 604.080200,882.662231 596.941406,885.427979 
	C593.871277,886.617371 590.809937,887.829773 587.361816,889.070923 
	C588.746948,885.444580 592.937805,885.892151 595.786804,883.992126 
	C599.163757,881.740295 603.459290,881.168701 607.043396,878.436768 
	C610.916565,877.146851 614.557068,876.125427 618.586426,875.080688 
	C619.116638,875.218872 619.257996,875.380249 619.199707,875.794189 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M723.777405,788.690613 
	C726.595459,789.230286 728.056030,790.961914 729.300293,792.996399 
	C731.370117,796.381287 733.434448,799.769836 735.545410,803.129028 
	C736.132812,804.063904 736.515808,804.997498 735.417480,805.670654 
	C734.512085,806.225525 733.892517,805.430054 733.453308,804.726807 
	C729.679871,798.684143 724.111389,793.972473 720.669128,787.252258 
	C722.156799,786.196899 722.874023,787.255371 723.777405,788.690613 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M720.887817,740.801880 
	C711.402405,739.843262 704.101440,732.779724 694.374146,730.888550 
	C694.010986,730.355225 694.023621,729.913574 694.059021,729.141357 
	C694.944397,728.131104 695.933411,727.790588 697.413452,727.702393 
	C698.582947,727.694519 699.343140,727.815674 700.441772,728.147217 
	C702.010864,729.032898 703.352234,729.592224 704.734985,730.754883 
	C707.536255,730.763062 709.818726,729.903992 710.280273,734.233337 
	C710.683228,738.013733 715.740845,736.753296 718.129578,738.893188 
	C718.809814,739.502502 720.434692,738.946777 720.887817,740.801880 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M800.666260,749.411377 
	C800.861450,746.649414 800.897644,744.272034 800.929565,741.449097 
	C800.558105,739.785461 801.274841,739.260559 802.571289,739.096985 
	C802.937683,743.565613 802.997009,747.847290 803.118774,752.590942 
	C803.883789,756.176392 803.241882,759.352722 803.695557,762.898132 
	C803.862610,764.634399 803.887024,765.963989 803.869507,767.690552 
	C802.880859,771.528625 804.732971,775.043945 803.247681,778.796631 
	C800.439087,770.857971 801.393311,762.334534 800.937805,753.449097 
	C800.333435,751.969666 800.057983,750.925049 800.666260,749.411377 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M656.326782,991.234497 
	C657.731873,990.720215 658.972412,990.392822 660.597107,990.022400 
	C661.165039,994.660889 663.971741,997.779663 667.376709,1000.466064 
	C668.921204,1001.684692 670.636047,1002.681458 671.867676,1004.705933 
	C672.124512,1005.242126 672.222046,1005.479309 672.117065,1006.045349 
	C671.495544,1006.684998 671.034912,1006.910767 670.153137,1007.128784 
	C668.485046,1007.340332 667.209229,1007.261597 665.584717,1006.855896 
	C664.770264,1006.511475 664.371521,1006.214905 663.826111,1005.539429 
	C662.809448,1004.312561 664.689026,1002.787354 662.658508,1001.963257 
	C658.935059,1000.452209 657.546814,997.082886 656.484009,993.169678 
	C656.235474,992.405334 656.198853,991.913330 656.326782,991.234497 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M654.200562,987.203369 
	C647.197144,988.792236 640.091614,987.685669 633.038330,988.061096 
	C631.356384,988.150635 629.347046,987.119019 627.992004,989.577576 
	C622.852417,991.989746 621.879456,991.520264 621.830811,986.521729 
	C632.579651,985.909790 643.022156,985.512695 653.829895,986.443848 
	C654.199219,986.636902 654.186279,987.090942 654.200562,987.203369 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M754.526672,502.990662 
	C749.663513,493.208557 744.978210,483.536530 742.687866,472.887146 
	C747.979248,481.742065 751.057312,491.597931 755.100525,501.399780 
	C755.486145,502.264587 755.405518,502.684082 754.526672,502.990662 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M784.468506,773.063477 
	C782.089294,783.814087 779.369385,794.649902 776.434082,805.786743 
	C773.335938,803.529480 775.586731,800.639282 776.139282,798.214111 
	C778.089111,789.656982 779.265076,780.794189 784.468506,773.063477 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M777.261536,520.408081 
	C777.622681,523.583008 774.136841,524.047791 772.367432,526.390625 
	C768.288086,526.487122 764.503418,529.882751 760.737671,526.217041 
	C764.749023,519.778442 771.042480,520.879700 777.261536,520.408081 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M779.027954,544.286133 
	C781.340820,543.449768 783.679443,542.963562 786.413940,542.450500 
	C789.122253,546.770142 783.923279,549.550598 784.206787,553.786865 
	C783.712158,554.137085 783.504028,554.234253 782.979492,554.199951 
	C781.104431,551.509460 779.617676,548.814087 775.497803,550.501282 
	C774.933655,550.494507 774.708740,550.457092 774.246460,550.173279 
	C773.251892,549.872742 772.494629,549.818542 771.366516,549.675537 
	C771.055176,545.928589 773.863464,547.351318 775.740173,546.981995 
	C777.159546,546.702637 779.926819,548.192017 779.027954,544.286133 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M658.052307,512.601807 
	C653.717957,516.228821 649.273254,519.563904 644.460938,522.906250 
	C643.493469,522.473572 642.893555,522.033691 642.187744,521.133118 
	C642.081726,520.672485 642.116638,520.300049 641.951599,520.200073 
	C641.786560,520.100098 641.760193,519.706360 641.943237,519.632690 
	C643.194580,520.714722 643.755981,519.769897 644.442627,519.047119 
	C647.903076,515.404480 652.008362,512.602966 656.645874,510.024750 
	C657.311096,510.772766 657.626526,511.541321 658.052307,512.601807 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M850.066223,659.269043 
	C851.198547,658.165039 850.992126,657.046570 851.086304,655.707764 
	C851.091797,655.396545 851.058594,655.210388 851.148438,655.180969 
	C851.678284,654.926270 852.076416,654.996094 852.527344,655.648193 
	C852.932922,659.413208 851.376160,662.519836 850.819458,666.182434 
	C848.489197,671.738220 846.213745,676.924683 843.581543,682.133057 
	C842.104065,681.440186 842.089661,680.396240 842.430176,678.865845 
	C842.439697,677.095032 842.653748,675.789978 843.674561,674.302856 
	C843.917175,673.983154 843.989990,673.980530 844.019592,674.001831 
	C844.345703,673.797852 844.643799,673.574829 844.824707,673.101807 
	C846.451050,668.442505 848.196228,664.035339 850.066223,659.269043 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M760.464111,525.906006 
	C762.605530,528.022156 764.713684,525.894592 766.650879,526.203552 
	C768.424622,526.486511 770.021057,524.575256 771.949463,526.241821 
	C769.584473,529.694641 766.501892,531.915588 762.577332,532.803833 
	C760.343201,533.309509 758.328308,533.199829 757.382874,530.193726 
	C758.112671,528.656372 759.136169,527.325134 760.464111,525.906006 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M601.272461,640.249756 
	C601.008240,639.829407 600.960632,639.638733 601.058716,639.191895 
	C601.982727,638.317566 602.969971,637.812439 602.322144,636.284912 
	C602.773132,632.965942 603.410522,629.886108 604.055664,626.415894 
	C604.197510,625.887695 604.331543,625.749878 604.733887,625.718140 
	C606.680664,628.618530 607.210754,631.869385 608.605408,634.821777 
	C609.974609,637.720398 606.410828,639.391907 604.859497,641.846313 
	C602.875793,642.904663 601.786743,642.483765 601.272461,640.249756 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M753.793762,739.671387 
	C753.847839,738.674683 753.937500,738.126343 754.101562,737.167664 
	C755.225830,733.144043 753.360596,729.543518 754.249756,725.518677 
	C754.813293,724.297363 755.489319,723.800476 756.814087,723.668457 
	C757.507690,724.628235 757.771667,725.515747 757.954468,726.749695 
	C756.134033,731.653137 758.277405,736.452026 757.006104,741.451599 
	C757.861328,745.934998 756.848083,750.084534 757.677368,754.547241 
	C757.767639,756.317200 758.444641,758.559875 756.692871,758.637939 
	C754.638306,758.729370 755.789856,756.401489 755.436829,755.162659 
	C754.034485,750.241150 754.418213,745.128479 753.793762,739.671387 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M790.035706,690.162964 
	C791.999146,690.998596 793.400024,692.386230 792.693909,695.209656 
	C791.859741,698.359802 789.211975,700.075623 788.217224,703.135254 
	C787.916565,703.603638 787.783508,703.782471 787.412598,704.192017 
	C786.993958,704.543640 786.813110,704.664612 786.348328,704.936768 
	C785.087158,705.463440 784.216675,705.990356 783.406738,707.100159 
	C783.115723,707.523132 782.995117,707.690125 782.677795,708.097229 
	C782.332947,708.482788 782.184875,708.628174 781.491333,709.064026 
	C780.739502,709.336304 780.533203,709.318237 780.121582,709.066895 
	C779.738770,708.290649 779.561340,707.747620 779.136963,707.042603 
	C778.890564,702.160583 783.577515,700.416870 785.344788,696.790283 
	C785.895142,695.660950 787.104858,694.842529 787.779175,693.276123 
	C787.974365,692.979675 788.000000,693.000000 787.986694,692.988770 
	C788.537231,692.469788 789.070496,691.930908 789.789551,691.175659 
	C789.989502,690.789612 789.993652,690.609802 790.035706,690.162964 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M723.894897,540.884399 
	C725.633789,542.919678 725.304382,544.746033 724.757263,546.907227 
	C723.655518,551.258972 723.564453,555.905090 720.269714,560.917725 
	C720.118164,553.533264 720.482483,547.542725 722.222168,541.267090 
	C722.759460,540.623718 723.187988,540.550232 723.894897,540.884399 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M806.284119,745.591370 
	C806.072327,744.113525 806.060364,742.967957 805.999695,741.824951 
	C805.874084,739.459595 806.945007,737.984131 809.319641,737.864441 
	C812.383606,737.710022 810.579407,740.150696 810.960083,741.383728 
	C811.242554,742.298523 811.052124,743.363525 812.810303,743.946167 
	C813.414734,744.087463 813.649963,744.525818 813.835083,744.692017 
	C814.277527,746.078735 814.534912,747.299255 814.876099,748.803101 
	C814.579834,749.379700 814.153381,749.556091 813.326904,749.524780 
	C812.241821,749.054871 811.857605,748.424500 811.603821,747.627380 
	C811.404907,747.002747 811.883423,747.709167 811.478516,747.179565 
	C811.342041,747.451721 811.572876,747.720947 811.437988,748.349609 
	C810.558533,750.504639 810.012634,752.616943 807.035034,752.177673 
	C806.260437,749.961914 806.668335,747.929810 806.284119,745.591370 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M661.559082,831.244812 
	C661.725098,837.381287 664.210693,842.777466 665.761719,848.576294 
	C666.197998,850.297668 666.458740,851.851685 666.885986,853.968567 
	C665.948608,855.569824 665.404846,854.933105 664.907715,853.870789 
	C662.006653,847.671204 660.588623,841.021362 659.004333,834.425659 
	C658.587036,832.688660 659.432556,831.566528 661.559082,831.244812 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M604.925537,801.436768 
	C611.637695,798.127686 618.351990,795.243835 625.434692,792.223999 
	C625.984375,792.271118 626.165710,792.454285 626.406311,793.020020 
	C626.385620,793.953491 626.091431,794.342346 625.239014,794.745605 
	C624.895020,794.922119 624.984009,794.992065 624.953125,794.944641 
	C624.181213,796.347290 623.495605,797.867737 621.116089,797.768799 
	C617.046326,799.132141 613.701294,801.455200 609.314026,802.060547 
	C607.556641,802.620117 606.208801,802.834717 604.925537,801.436768 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M819.999756,691.000000 
	C820.842285,695.006042 818.683533,698.204529 816.939209,701.402893 
	C816.082703,702.973389 814.647644,704.197449 814.986816,706.607788 
	C814.572998,708.036011 813.857666,708.742432 812.401855,708.984985 
	C811.471069,708.552246 811.167908,707.910706 811.041260,706.808594 
	C811.539856,704.474426 812.170105,702.527100 812.742065,700.243408 
	C812.799866,699.424561 812.648010,698.874268 812.255371,698.156311 
	C810.691101,696.165771 812.318359,695.426758 813.543701,694.181030 
	C815.300903,693.300537 816.992737,693.219849 818.736084,692.210266 
	C819.011902,691.992249 819.000000,692.000000 818.994751,692.005493 
	C819.210205,691.780212 819.444885,691.564819 819.847534,691.181702 
	C820.001343,690.998779 820.000000,691.000000 819.999756,691.000000 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M734.560913,890.586670 
	C735.024231,890.838501 735.272766,890.863708 735.894287,890.851685 
	C736.507690,890.708801 736.748169,890.603333 737.347656,890.334106 
	C739.290894,889.780823 740.829407,889.982300 742.688599,890.715271 
	C750.341248,890.797424 757.646179,890.694458 765.342041,890.552795 
	C766.195496,890.628296 766.412292,890.923340 766.132202,891.598022 
	C750.584229,891.889832 735.287292,891.982544 719.547058,891.935242 
	C719.452698,890.784058 718.894165,889.547119 720.006714,888.389587 
	C720.310913,887.940430 720.483887,887.794922 720.972229,887.770508 
	C722.302917,889.084473 723.430786,890.005127 725.470581,889.429321 
	C726.002808,889.341187 726.216919,889.312256 726.751221,889.246094 
	C729.030029,888.990784 728.534302,887.453308 728.638428,885.913208 
	C728.553162,884.899780 728.502686,884.224060 728.797852,883.257935 
	C728.970093,882.966553 729.024109,882.969360 729.029907,882.995728 
	C729.667480,883.221985 730.299255,883.421753 731.077576,883.931763 
	C731.849060,884.940613 731.997559,885.830872 732.275208,887.011230 
	C732.409302,888.734619 733.590393,889.406616 734.560913,890.586670 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M562.237366,637.034302 
	C562.475647,643.005249 559.118164,648.138245 557.779541,653.919067 
	C556.553955,659.211975 554.794189,664.381165 553.145508,669.995728 
	C552.573975,670.306396 552.126648,670.226074 551.351562,670.053101 
	C550.654236,669.574646 550.419250,669.119446 550.315430,668.204956 
	C552.960632,659.187195 555.428650,650.502197 558.441772,641.989441 
	C559.097717,640.136292 559.676270,638.216980 562.237366,637.034302 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M660.791260,697.291992 
	C661.025513,697.036560 661.080383,696.542786 661.143738,696.302612 
	C661.543579,695.679626 661.965942,695.507874 662.776611,695.748779 
	C665.292664,699.441772 665.414368,703.663513 667.084656,707.360901 
	C668.718628,710.977844 664.880859,709.417358 663.493042,710.658203 
	C661.234680,709.201111 661.063171,706.857117 660.338013,704.375610 
	C660.369080,702.578674 660.438110,701.154724 660.560425,699.306519 
	C660.423462,698.444702 660.404724,697.999756 660.791260,697.291992 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M640.545227,946.520630 
	C641.320923,947.798035 642.508240,948.055969 643.668701,948.845093 
	C644.326965,949.352722 644.502380,949.783813 644.349487,950.613831 
	C643.029236,951.075500 641.673035,950.762390 641.061890,952.645081 
	C640.384460,953.534363 639.706299,953.916809 638.472290,953.950684 
	C635.001343,953.546570 632.649719,951.916870 630.524780,949.235229 
	C630.119141,948.061584 630.153992,947.271179 630.765259,946.180176 
	C634.095642,945.419434 637.145081,945.627319 640.545227,946.520630 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M747.159302,843.649658 
	C747.556091,843.144165 747.934448,843.000244 748.614563,842.894531 
	C749.295471,843.235901 749.487244,843.630249 749.333435,844.425659 
	C747.004028,850.368225 748.788940,856.131958 748.612915,862.234558 
	C747.968384,863.660217 747.330627,863.308044 746.614380,862.218994 
	C746.528992,859.407349 746.435791,856.995605 746.549744,855.398621 
	C746.144775,856.692505 746.644226,858.849731 746.492065,861.380981 
	C746.512878,862.614746 746.774414,863.439331 746.171631,864.560852 
	C744.678528,865.139893 743.616943,864.643372 744.102661,863.443298 
	C745.577515,859.799500 742.653259,855.492432 746.507996,851.995789 
	C748.490295,850.197571 743.362244,849.326843 744.026062,846.440186 
	C744.051086,845.967407 744.188477,845.832520 744.574036,845.845215 
	C746.227722,846.072388 747.145508,845.581421 747.159302,843.649658 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M725.936646,517.332397 
	C729.139771,519.502075 726.475952,522.326599 726.458801,524.951538 
	C726.444214,527.188171 725.292175,529.419006 727.001343,531.730713 
	C727.122559,534.112732 726.907410,536.390747 726.342407,538.826965 
	C724.798645,538.603333 724.069885,537.716064 723.315247,536.369873 
	C723.431030,529.847473 724.510132,523.742126 725.936646,517.332397 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M811.744263,705.898315 
	C811.969360,706.901062 812.012634,707.606506 812.071655,708.665405 
	C809.728943,710.898071 808.553833,714.815186 804.108765,713.248413 
	C803.872131,712.547607 803.874695,712.111267 803.827515,711.350708 
	C803.145508,709.980896 802.886108,708.890320 803.607178,707.338562 
	C804.179199,705.862915 804.521057,704.757690 804.922485,703.310425 
	C806.482117,701.759827 807.547668,703.098145 809.072571,703.751892 
	C810.225159,704.321716 811.021606,704.799011 811.744263,705.898315 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M605.577393,672.073608 
	C605.033081,669.846985 604.849243,667.664795 604.352112,665.231567 
	C603.665100,664.574524 603.349976,664.127136 602.976868,663.241333 
	C602.701782,661.711060 602.888733,660.646973 603.739258,659.337158 
	C604.374329,657.918396 605.194580,657.338562 606.588379,657.025269 
	C608.814453,661.786621 608.580139,666.941284 609.407715,672.365906 
	C608.279297,672.575317 607.108582,672.346619 605.577393,672.073608 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M517.924927,788.663574 
	C523.715393,789.738037 529.511963,791.168152 535.644653,792.769287 
	C536.245667,793.504700 536.510498,794.069031 536.840393,794.939575 
	C529.251160,794.032593 521.734802,791.829163 513.438477,791.967041 
	C514.096191,790.004089 517.703857,792.411682 517.924927,788.663574 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M608.339722,505.110168 
	C607.530640,503.254486 607.648682,501.642273 608.026001,499.624512 
	C612.207764,496.820068 616.990540,499.010132 621.584900,497.361572 
	C622.457214,497.543579 622.850464,497.834656 623.118042,498.647034 
	C623.017822,499.741211 622.937500,500.457428 622.763062,501.522095 
	C621.203125,504.089539 618.846008,504.090057 616.586426,504.274872 
	C614.649719,504.433258 612.660217,504.170868 610.098328,505.259216 
	C609.117615,505.418121 608.867126,505.392609 608.339722,505.110168 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M720.371826,760.890259 
	C719.319336,759.558594 718.593384,758.302551 717.693726,756.785156 
	C717.389404,755.693726 717.065369,754.877075 717.563721,753.654236 
	C720.407349,753.044739 721.438049,750.947327 722.405090,749.232910 
	C724.657654,752.039185 724.481262,755.569275 725.581543,758.916992 
	C726.448120,759.775208 725.970947,760.234680 725.037720,760.765381 
	C724.708313,760.877991 724.355469,760.804749 724.185791,760.865295 
	C723.663940,761.303589 723.229980,761.478821 722.366211,761.325806 
	C721.578247,761.121826 721.138306,761.043823 720.371826,760.890259 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M614.238831,1004.152344 
	C614.238708,1003.431702 611.409058,1002.067505 614.354858,1002.028625 
	C622.892883,1001.915894 631.371765,1000.175293 640.399353,1001.153198 
	C641.372437,1001.481018 641.893738,1001.753845 642.716187,1002.082214 
	C643.155212,1002.274597 643.293152,1002.411438 643.219238,1002.748535 
	C633.512939,1002.852112 624.039551,1003.218750 614.238831,1004.152344 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M712.236450,781.656128 
	C710.924927,780.874695 709.404785,781.292786 708.994324,779.357422 
	C717.006470,778.283875 724.801086,778.993896 732.780884,780.301270 
	C731.967346,782.508240 730.373657,780.940857 729.293823,781.937134 
	C723.536926,784.565063 718.095032,783.750916 712.236450,781.656128 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M715.314209,835.754761 
	C715.978333,836.048523 716.273193,836.200073 716.585327,836.294006 
	C718.275635,836.802795 718.600403,837.747131 717.455505,839.103882 
	C714.860657,842.178894 712.010864,839.422607 709.302307,839.350708 
	C707.108521,839.292603 707.026184,837.436890 707.094543,835.697266 
	C707.170349,833.770508 708.401489,833.606750 709.810730,833.968994 
	C711.548523,834.415771 713.240967,835.039001 715.314209,835.754761 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M705.036987,730.565430 
	C704.001709,729.763794 701.932190,731.788147 701.305359,729.393250 
	C699.801697,726.826416 698.830017,724.142212 696.260010,722.223633 
	C694.955872,721.642334 693.548889,721.403931 694.079895,719.880737 
	C694.646118,718.256287 696.228821,719.066040 697.741333,718.823242 
	C698.099060,718.110901 698.364624,717.625122 699.310669,717.183716 
	C699.737610,717.089539 699.948425,717.129028 700.002686,717.036743 
	C698.147888,717.561768 698.227478,718.954590 699.544861,719.730591 
	C703.597168,722.117493 704.761047,725.859375 705.036987,730.565430 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M674.281799,1005.179688 
	C676.244812,1005.728638 676.464661,1004.311462 676.915344,1003.329590 
	C677.881714,1001.224304 679.059021,1000.533142 681.084778,1002.254272 
	C682.996338,1003.878479 682.872742,1004.935730 680.738098,1006.283997 
	C679.906738,1006.809082 679.668884,1008.273926 679.121887,1009.661987 
	C678.192139,1011.141052 678.030334,1013.057800 675.629333,1012.870850 
	C674.426025,1012.544434 673.899109,1011.895691 673.446533,1010.782471 
	C673.259094,1009.655457 673.464539,1008.858765 673.588013,1007.763245 
	C673.607666,1007.086487 673.608398,1006.700134 673.627686,1006.024414 
	C673.770203,1005.585999 673.892029,1005.436829 674.281799,1005.179688 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M441.249146,817.896545 
	C445.987061,813.919434 451.121826,809.984009 456.577942,805.932251 
	C457.351654,806.687317 457.785767,807.445129 459.016083,807.466370 
	C461.696045,807.512573 461.344696,808.928772 459.955383,810.686646 
	C455.076996,811.074280 451.789276,814.578796 447.246399,815.806763 
	C446.976410,816.027283 446.982025,815.979248 447.006226,815.979126 
	C446.885101,816.114990 446.739777,816.250854 446.411438,816.622559 
	C444.700958,817.218323 443.173462,817.578247 441.249146,817.896545 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M596.561646,793.026855 
	C599.223755,788.694092 603.645081,787.702454 607.711365,785.809326 
	C606.173706,790.010193 603.870728,793.694702 599.510376,796.054260 
	C599.005127,796.274414 598.817017,796.379395 598.314453,796.559265 
	C598.000000,796.634155 597.542847,796.770264 597.314941,796.700073 
	C596.019897,795.745911 595.987671,794.636353 596.561646,793.026855 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M708.366455,700.249878 
	C709.564087,699.996399 710.350281,700.112549 710.937622,701.232605 
	C711.424927,704.698608 709.391418,707.240417 708.860718,710.493469 
	C708.716736,714.087097 705.937012,716.023560 704.758545,718.834717 
	C703.962463,720.733887 702.773621,719.208618 702.063843,717.750916 
	C701.713257,717.051697 701.345215,716.549622 701.560425,716.126404 
	C704.132812,711.067871 705.381470,705.465820 708.366455,700.249878 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M708.713257,699.657043 
	C707.334534,705.909546 704.925171,711.361511 702.162109,717.083130 
	C701.564758,717.375732 701.102356,717.314758 700.305237,717.147827 
	C701.359375,713.619568 702.759888,710.201904 704.131592,706.772644 
	C704.711060,705.323975 705.860352,703.893311 704.069946,702.164062 
	C704.943481,700.152039 706.184509,698.275208 707.672302,696.177490 
	C708.246155,695.865417 708.573242,695.774231 709.329712,695.957153 
	C709.413208,697.239563 709.067383,698.247742 708.713257,699.657043 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M711.869934,781.793518 
	C717.245361,781.566589 722.684021,781.663269 728.570618,781.898499 
	C728.774170,784.004639 727.088379,784.284790 725.342651,784.945923 
	C724.597595,785.411194 724.492554,785.947205 724.191589,786.676025 
	C723.999451,787.343262 724.000000,787.816345 723.999023,788.644165 
	C723.070801,788.386719 722.144104,787.774536 720.891724,787.028381 
	C720.230408,786.746460 720.055969,786.489014 720.079590,785.877197 
	C719.949646,783.565308 719.112488,785.517761 718.384949,785.577454 
	C715.526672,785.486328 713.689758,783.869934 711.869934,781.793518 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M684.373169,797.894653 
	C681.928589,802.774170 683.065369,807.983643 682.939697,813.030090 
	C682.845581,816.807861 683.159668,820.595825 683.555237,824.694580 
	C683.909180,826.564148 683.999817,828.118347 683.837158,829.866760 
	C683.361816,830.171448 683.139893,830.282043 682.559387,830.293457 
	C681.895874,819.608765 680.603699,809.043762 681.771851,798.219299 
	C682.377563,797.653748 682.816589,797.503174 683.623291,797.768555 
	C683.921509,797.982239 684.222229,797.809326 684.373169,797.894653 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M833.038696,684.710205 
	C832.067932,684.875793 831.802124,682.935059 830.643005,684.018188 
	C829.317017,685.257141 828.270447,686.281982 826.753723,684.243896 
	C824.928040,681.790527 827.250366,681.038757 828.779907,680.274902 
	C827.588318,678.596497 825.889038,680.631226 825.464172,679.215576 
	C824.956665,677.524292 826.939148,676.891418 827.857056,675.429321 
	C828.464478,675.136353 828.900818,675.112061 829.665161,675.096008 
	C834.437500,675.640198 834.437500,675.640198 833.358765,682.261841 
	C833.440186,682.828491 833.449341,683.058105 833.386597,683.624878 
	C833.253662,684.128357 833.192627,684.294739 833.038696,684.710205 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M662.636963,565.208008 
	C661.382935,563.054626 660.998657,561.008362 660.799927,558.499512 
	C660.584167,557.537720 660.782593,557.105042 661.671997,556.873047 
	C662.058044,556.933838 662.007324,556.987793 662.031128,556.963867 
	C662.411438,557.426086 662.471008,558.022644 662.871460,558.773315 
	C663.081848,558.975830 663.010986,558.999268 663.032959,558.969116 
	C663.411316,559.427551 663.472534,560.025940 663.871460,560.782837 
	C664.079285,560.989685 664.010071,560.989990 664.023071,560.957886 
	C664.405396,561.555664 664.661987,562.255920 665.395752,563.094482 
	C667.064392,568.359741 669.682495,572.935730 670.296204,578.470093 
	C669.846313,579.086731 669.536682,579.358032 669.055481,579.892090 
	C665.998718,575.621948 664.746643,570.418701 662.636963,565.208008 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M628.836426,679.134460 
	C628.045898,677.180542 627.443909,675.548828 626.569153,673.177734 
	C631.471924,676.436279 635.424255,685.098877 636.859436,694.960388 
	C632.322754,690.239441 632.149170,684.074280 628.836426,679.134460 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M713.207520,829.835449 
	C711.348572,828.774231 708.085571,829.071228 709.318909,826.105469 
	C710.296570,823.754578 712.512878,825.424438 714.134888,825.833496 
	C716.699036,826.480164 719.213623,827.323486 721.804443,828.100159 
	C719.583435,831.907166 716.439453,830.168274 713.207520,829.835449 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M710.054810,696.037476 
	C709.453674,696.176453 709.148376,696.121521 708.381104,696.011658 
	C709.151978,692.830200 711.281433,691.994263 714.106873,693.830933 
	C716.363647,695.297974 719.013062,695.099060 721.577576,695.638916 
	C717.649292,702.594543 714.006531,698.549622 710.054810,696.037476 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M497.916504,814.844971 
	C497.961609,814.228088 497.998718,813.954651 498.133606,813.278564 
	C501.143280,817.218750 500.090027,819.854858 495.073090,821.581909 
	C489.906525,823.360413 484.985931,825.842834 479.880310,827.817139 
	C478.744904,828.256165 477.163605,829.732361 475.887329,827.297241 
	C482.700928,825.413513 489.076965,822.476501 495.405090,819.390198 
	C497.246521,818.492126 498.314392,817.330017 497.916504,814.844971 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M608.538086,510.101379 
	C608.173157,508.862396 608.130127,507.921875 608.093506,506.627045 
	C608.205994,505.918030 608.377014,505.597961 608.817749,505.129120 
	C609.022888,504.945862 609.001526,505.027435 608.960083,505.019958 
	C613.213379,504.094757 617.586121,502.255127 621.382385,506.554962 
	C621.137634,507.434387 620.990662,507.833832 620.725708,508.529846 
	C617.004150,511.683136 612.822021,510.219330 608.538086,510.101379 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M708.150757,548.276489 
	C707.906433,548.018921 707.532654,548.027466 707.363403,547.948059 
	C706.378662,547.325378 705.600342,546.743347 704.914795,545.554932 
	C701.268005,542.464966 702.199707,538.006042 700.740112,534.164917 
	C703.579041,531.266357 705.096680,532.426270 705.913879,535.494812 
	C706.954224,539.401184 707.933350,543.323914 708.917969,547.635742 
	C708.729797,548.199402 708.562439,548.366760 708.150757,548.276489 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M797.743408,712.733765 
	C797.974304,713.307373 798.008911,713.812256 798.024170,714.697632 
	C797.222839,715.357300 796.440796,715.636414 795.346558,715.938477 
	C793.106812,715.364075 791.360718,716.379883 789.294617,716.801514 
	C789.032898,717.505127 789.154541,718.077881 788.937500,718.456299 
	C788.251404,719.652283 788.118469,718.737854 788.004150,718.133911 
	C787.217407,713.977722 790.124756,710.398804 796.609863,707.953491 
	C798.110168,709.728638 795.286499,710.629883 795.990723,712.667480 
	C796.193237,712.966003 796.384033,712.929504 796.858459,712.826416 
	C797.142090,712.759766 797.547119,712.665100 797.743408,712.733765 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M624.074097,916.106384 
	C628.832520,912.148132 635.472473,911.983704 639.972046,907.209106 
	C640.003662,906.838135 640.271118,906.695740 640.422180,906.684204 
	C642.372925,906.577454 644.597412,905.124084 645.202515,908.634155 
	C638.519958,911.601135 632.044861,914.119324 625.208984,916.676941 
	C624.627502,916.626221 624.406677,916.536133 624.074097,916.106384 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M738.688049,730.286377 
	C738.675049,731.358643 740.432129,731.138855 740.597595,732.081177 
	C740.703430,732.683716 740.786072,733.498535 740.475769,733.924072 
	C739.757141,734.909851 739.150146,734.160767 738.529968,733.572998 
	C737.909363,732.984802 737.651428,731.315552 736.434265,732.208801 
	C735.215027,733.103577 736.439819,734.292786 736.823120,735.692566 
	C737.570801,736.678284 737.708740,737.433289 737.229126,738.602173 
	C733.290710,736.880066 732.415649,732.783020 734.498718,727.215515 
	C736.549194,727.470032 736.344604,730.363098 738.688049,730.286377 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M644.831909,677.026978 
	C652.318054,671.108765 662.965942,666.138367 667.430664,666.445129 
	C660.590637,671.086609 653.173828,673.877747 645.668457,677.256714 
	C645.312622,677.323059 644.870056,677.248169 644.831909,677.026978 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M600.937256,640.380188 
	C602.939575,639.402649 602.344849,642.354187 604.304382,642.051697 
	C599.320496,646.220642 602.701599,651.351562 602.987854,656.574341 
	C602.344299,656.790405 601.776917,656.584229 601.043945,656.115967 
	C600.484070,655.452454 600.147827,655.017456 600.052490,654.161011 
	C599.865540,652.855286 599.356445,652.134705 597.901184,651.915710 
	C598.637573,648.155823 599.728149,644.448059 600.937256,640.380188 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M632.217041,855.571899 
	C631.440430,855.867920 630.952515,856.046997 630.475403,856.021851 
	C628.923401,855.940063 627.646729,859.309631 626.497803,857.198547 
	C625.131042,854.687073 628.385437,854.693909 629.742676,854.186096 
	C633.859924,852.645691 638.116455,851.477478 642.669189,850.000916 
	C644.429382,849.609558 645.839111,849.381592 647.248840,849.153625 
	C647.374329,849.505676 647.499756,849.857666 647.625183,850.209717 
	C642.586975,851.927002 637.548828,853.644226 632.217041,855.571899 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M630.574036,885.573242 
	C633.885315,886.766418 633.752991,888.390442 631.315979,889.678467 
	C628.575684,891.126831 625.595947,892.122192 622.323853,893.292603 
	C620.026917,890.314514 621.241943,888.360046 624.064392,887.123047 
	C625.983215,886.282104 627.948730,885.431702 630.574036,885.573242 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M788.023438,768.910461 
	C787.733704,769.154419 787.268250,769.179260 787.268250,769.179260 
	C787.268250,769.179260 786.802124,769.178467 786.568848,769.154541 
	C785.410828,765.902161 787.254578,763.341125 788.620117,760.296631 
	C789.568176,758.262573 790.286194,756.541321 791.033936,754.470825 
	C791.183960,753.958252 791.304199,753.794983 791.534424,753.348206 
	C791.810974,752.641052 791.977417,752.217468 792.221436,751.461182 
	C791.884521,749.535217 792.567688,748.293823 793.891968,746.979736 
	C794.454346,746.793701 794.697388,746.783447 795.201050,747.029175 
	C795.798096,747.979309 795.822632,748.682739 795.332214,749.705078 
	C795.044861,750.366760 794.949829,750.719238 794.859131,751.346130 
	C794.799255,751.982056 794.647644,752.303528 794.243652,752.795776 
	C793.919373,753.606445 793.771667,754.211609 793.682739,755.126221 
	C793.687195,756.379822 792.959412,756.909363 792.201477,757.785583 
	C791.970581,758.008728 791.834106,758.306763 791.848267,758.470093 
	C791.844849,758.976746 791.716248,759.271606 791.368896,759.738586 
	C790.278442,762.861572 789.295776,765.764038 788.023438,768.910461 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M711.263550,489.972290 
	C710.986938,489.254456 711.026489,488.757782 710.992310,488.266266 
	C710.452759,480.509064 710.449585,480.514526 717.716980,481.977478 
	C718.192505,482.073212 718.703125,481.994934 719.592957,481.999420 
	C720.603821,483.027527 719.702087,483.675568 719.123291,484.700806 
	C718.872864,484.935028 718.949646,484.988403 718.936829,484.943420 
	C718.778442,485.199615 718.575134,485.454773 718.105835,485.795227 
	C717.897461,485.926453 717.981018,485.919434 717.954956,485.886597 
	C715.579590,486.975555 714.282471,489.644165 711.263550,489.972290 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M550.895874,667.805603 
	C551.054443,668.539490 551.043579,668.945618 551.028259,669.656006 
	C548.117188,668.881897 544.841370,669.445740 541.666504,667.855286 
	C540.438416,664.998291 541.878784,662.750305 543.221436,660.187866 
	C544.212158,659.714233 544.663269,658.987793 545.791138,658.844971 
	C547.882568,661.671997 546.778381,665.923096 550.895874,667.805603 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M772.964844,755.194092 
	C772.679382,755.022156 772.188965,755.056396 771.941650,755.039795 
	C771.880127,753.044617 772.705933,751.487854 774.774536,750.344971 
	C776.701538,748.424377 778.569519,748.461243 780.794922,750.073181 
	C782.466125,751.869141 781.405090,752.853760 780.261230,753.936707 
	C779.519226,754.485474 777.773865,754.702759 779.869263,755.918335 
	C779.901611,756.747864 779.704224,757.321472 779.278748,758.112427 
	C778.602905,758.246704 778.155151,758.163635 777.366516,758.051025 
	C775.802673,757.085815 774.187927,756.707214 772.964844,755.194092 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M610.278198,583.940430 
	C607.790955,584.885437 605.421814,585.645081 603.815369,583.213745 
	C601.848999,580.237732 602.327087,576.671387 603.308228,573.759888 
	C604.052979,571.549805 607.089966,572.025574 609.679688,572.827026 
	C609.214478,574.673340 607.650146,573.179199 606.540771,573.817322 
	C605.880798,574.196960 604.877075,574.029663 604.714539,575.103088 
	C604.470398,576.716370 606.956482,578.349182 604.328369,580.162048 
	C603.624146,580.647827 605.783691,581.690430 607.068604,582.049561 
	C608.272095,582.386108 610.565308,580.651794 610.278198,583.940430 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M708.757629,455.707031 
	C709.260437,457.724243 707.783997,458.835449 707.075684,460.657776 
	C707.176270,462.392059 706.441711,463.526825 705.819885,465.031097 
	C705.083252,466.509064 704.576172,467.709808 704.817261,469.436279 
	C704.809021,470.277924 704.703186,470.749542 704.300659,471.505676 
	C703.823853,471.733551 703.581055,471.663635 703.208984,471.237305 
	C701.557800,470.962128 701.376892,472.209412 700.935608,473.617981 
	C697.676758,474.408783 699.272461,472.186005 699.272339,470.517059 
	C699.185791,465.713104 702.153076,462.623840 704.218384,458.761292 
	C705.583008,457.240662 706.249878,455.345459 708.757629,455.707031 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M745.315430,839.610718 
	C744.765869,840.248962 744.388611,840.540833 743.981201,840.781738 
	C742.266724,841.795654 740.517517,844.519165 738.641846,842.812744 
	C736.957520,841.280396 738.639587,838.063171 737.360718,835.717957 
	C737.044983,835.138794 738.490173,834.953125 739.291931,834.869629 
	C741.319519,834.658630 742.465637,836.588806 744.655762,836.925659 
	C745.582397,837.664124 745.730347,838.412415 745.315430,839.610718 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M717.657593,846.769165 
	C718.997253,846.410095 720.153870,846.306274 721.312805,846.254822 
	C723.540894,846.155823 723.943909,847.000122 722.808533,848.915283 
	C720.442810,852.905884 718.181702,856.958496 715.557129,861.098633 
	C715.033142,861.094910 714.829651,860.978210 714.448425,860.557251 
	C713.951355,859.336670 714.008667,858.416138 714.350342,857.171631 
	C715.817749,854.376404 717.391113,851.985413 717.391113,848.688477 
	C717.319336,847.917297 717.363892,847.479309 717.657593,846.769165 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M652.176453,860.790039 
	C650.731873,861.008545 650.124573,860.142395 649.238037,859.124207 
	C649.616516,855.591675 652.277466,856.560486 654.503540,856.519958 
	C655.190918,853.949463 648.574707,851.506592 654.772888,849.082764 
	C656.167542,850.010315 655.764648,851.549622 656.816223,852.809937 
	C657.047119,853.035156 656.972534,853.021545 656.974487,852.983704 
	C657.360718,853.379944 657.476746,853.918762 657.759644,854.667725 
	C657.974243,855.290039 657.999390,855.711060 658.039429,856.447998 
	C657.861511,857.788269 657.311218,858.632263 656.464111,859.636597 
	C654.963928,860.052612 653.701111,860.278198 652.176453,860.790039 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M678.623901,560.842651 
	C678.239258,552.176758 678.239258,543.576355 678.239258,534.975952 
	C678.380676,534.968445 678.522095,534.960938 678.663574,534.953430 
	C679.020325,537.161743 679.377136,539.370117 679.995300,541.970215 
	C680.369995,542.533569 680.483276,542.705139 680.679443,543.175903 
	C680.775635,543.682800 680.789001,543.890442 680.777222,544.411499 
	C680.717773,544.932983 680.683350,545.141113 680.586792,545.659790 
	C680.228333,547.281494 680.668213,548.526123 680.899536,550.124756 
	C680.924500,551.261841 680.695129,552.003418 680.361694,552.732056 
	C680.209656,553.064209 679.927673,553.413208 680.163147,553.831726 
	C680.536987,553.548767 680.837463,553.173157 681.580566,553.064697 
	C680.940186,555.752441 684.513794,560.024109 678.623901,560.842651 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M572.713135,615.027344 
	C569.796936,614.888855 567.386169,611.033264 564.227417,614.725708 
	C563.925049,614.898987 563.864136,614.479553 563.854919,614.267822 
	C563.550049,613.614197 563.452148,613.132202 563.776306,612.301331 
	C564.978455,610.877319 565.822693,609.592102 566.967163,608.686401 
	C568.684265,607.327454 571.059875,607.849487 571.900635,609.226929 
	C572.836731,610.760498 574.486511,612.775635 572.713135,615.027344 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M485.056641,780.371338 
	C486.073761,780.394409 487.838104,780.579346 488.034363,781.234192 
	C489.359650,785.657166 493.308746,785.774353 497.024902,787.121948 
	C490.096039,791.012085 488.561798,790.191467 485.056641,780.371338 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M703.197632,806.844055 
	C699.695557,807.466492 701.022156,805.071106 701.294861,803.852234 
	C701.619629,802.400452 702.865601,800.988647 704.457642,801.202637 
	C706.576965,801.487610 709.052979,801.913513 710.497009,803.237366 
	C711.208923,803.890015 711.588989,807.456726 709.353638,808.374390 
	C706.759094,809.439697 707.626953,805.675415 705.573730,805.088989 
	C704.218079,805.063599 703.933411,805.970764 703.197632,806.844055 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M674.163757,656.848145 
	C673.887756,649.963196 670.796326,643.232666 672.732605,636.081787 
	C674.230591,642.348328 675.969299,648.569763 676.063232,655.548462 
	C675.496277,656.248657 674.971985,656.510376 674.163757,656.848145 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M686.601929,641.282288 
	C687.162415,639.513306 686.380310,637.889343 687.895508,636.450134 
	C690.587463,641.367798 687.570190,647.020447 690.554810,651.828003 
	C691.809631,654.981140 690.695312,656.604614 687.237305,656.851685 
	C686.927490,651.881042 686.031738,646.797058 686.601929,641.282288 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M623.578735,915.822449 
	C624.194031,915.943726 624.407837,916.140381 624.726013,916.536377 
	C618.435120,919.223816 612.005493,921.690796 605.620789,924.268799 
	C604.130310,924.870667 603.101685,925.247375 603.271606,922.683105 
	C610.345642,921.475830 616.384399,917.488220 623.578735,915.822449 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M731.722656,454.213531 
	C734.383484,453.927307 736.756653,453.863190 739.573364,453.749695 
	C740.448608,454.111542 740.880188,454.522766 741.592651,455.024475 
	C741.263611,460.632477 736.697449,458.137604 733.429016,458.934326 
	C732.579224,458.398529 732.140015,457.996002 731.194336,458.182098 
	C730.508850,458.330017 730.107483,458.387329 729.429077,458.307434 
	C728.744934,457.864655 728.506653,457.456116 728.447266,456.592712 
	C729.002014,454.863556 730.217651,454.648102 731.722656,454.213531 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M779.783325,715.880310 
	C779.008179,716.000366 778.495789,716.063599 778.059021,715.910706 
	C776.332703,715.306335 775.372986,713.787964 775.425171,712.220703 
	C775.499756,709.977722 778.009888,713.597778 778.621094,711.098511 
	C779.720581,710.791260 780.039185,709.972168 780.797974,709.204956 
	C781.010315,708.989990 780.999451,709.000488 780.993652,709.005859 
	C781.219177,708.791199 781.446960,708.567383 781.837646,708.167725 
	C782.004211,707.995605 782.000000,708.000000 781.998047,708.001892 
	C782.897339,707.074280 783.872070,706.227661 785.134521,705.217773 
	C785.736267,704.763550 786.114746,704.558350 786.765747,704.187195 
	C787.020203,703.988037 787.000427,704.000000 786.992554,704.008423 
	C788.450256,703.136597 789.170349,703.733398 789.223206,705.643860 
	C789.019897,706.038452 788.995850,706.000732 789.018188,706.001953 
	C788.561279,706.409485 788.497559,707.001526 788.183594,707.795288 
	C788.020081,708.035767 787.998047,707.999084 788.018555,708.005249 
	C787.784119,708.208130 787.547913,708.425110 787.177490,708.848389 
	C787.024536,709.034424 787.005493,708.997559 787.019775,709.014526 
	C786.005066,710.119385 784.527283,710.573486 783.225098,711.809448 
	C783.011780,712.041931 782.996155,711.998291 783.018799,712.002930 
	C782.788025,712.204041 782.552979,712.420532 782.186768,712.844360 
	C782.037109,713.031799 782.000000,713.000000 782.019531,713.015869 
	C781.235229,713.819336 781.029663,715.041992 779.783325,715.880310 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M687.275696,704.632751 
	C685.572632,704.452332 684.440918,706.744690 682.399963,705.740601 
	C681.565491,704.249023 681.027954,702.911743 680.269897,701.283264 
	C680.302124,699.438171 681.221252,698.295349 682.637085,696.957825 
	C684.598145,699.174377 686.045776,701.645691 687.275696,704.632751 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M707.889282,996.777771 
	C702.299561,994.606079 696.426636,997.443787 690.418945,996.012146 
	C689.997986,994.393311 691.295044,993.907593 692.688354,993.116699 
	C696.713196,994.165771 700.140198,991.913696 704.171204,992.082153 
	C705.657776,992.264099 706.564514,992.795105 707.697815,993.739380 
	C707.990540,994.793152 707.981079,995.589539 707.889282,996.777771 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M772.884399,833.058289 
	C773.482727,832.956543 773.684753,832.987732 773.935913,833.297974 
	C773.860046,833.837830 773.687622,834.219910 773.251099,834.796875 
	C769.925842,837.088623 766.837646,839.173157 763.959106,841.580688 
	C763.378052,842.685608 762.452148,842.791870 761.062866,842.127319 
	C761.356079,840.608459 761.831055,839.268799 763.298340,838.310669 
	C766.480957,836.402954 769.494751,834.730469 772.884399,833.058289 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M615.826721,652.192383 
	C610.091431,652.806091 609.178772,651.870361 608.855103,645.138916 
	C608.699463,644.728027 608.711975,644.763916 608.713501,644.750244 
	C609.614624,644.398438 610.338379,643.618042 611.724609,643.827637 
	C614.044983,646.285339 614.732300,649.216492 615.826721,652.192383 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M598.637756,584.741089 
	C601.279114,587.698669 602.741394,591.302063 606.722961,592.885742 
	C603.199951,595.695618 600.932922,592.477661 598.717163,590.421570 
	C596.820312,588.661316 595.619629,586.169861 595.530762,583.176270 
	C597.422180,582.038818 597.602478,583.795654 598.637756,584.741089 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M606.431396,517.060181 
	C603.524414,515.375732 605.880005,514.249817 606.607300,512.585938 
	C610.321228,509.861847 614.243652,510.705719 618.461365,511.797913 
	C619.390991,514.198975 617.918396,513.955994 616.599854,514.297974 
	C613.327820,515.146667 609.572021,514.288513 606.431396,517.060181 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M606.261475,614.718933 
	C607.017517,614.567200 607.690735,614.744263 608.687561,615.058228 
	C611.139282,620.277344 616.607666,622.900146 618.805786,628.844543 
	C613.482971,626.829285 612.201294,621.225403 607.631714,618.780640 
	C606.884094,617.441040 606.531311,616.244385 606.261475,614.718933 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M659.778442,1010.311646 
	C659.996765,1010.000000 660.102844,1009.603271 660.101562,1009.397949 
	C661.082947,1007.924866 662.484314,1007.720337 664.382263,1007.697876 
	C666.297424,1007.845093 667.649902,1008.349426 669.260498,1009.390137 
	C670.897766,1011.111938 671.393738,1012.681152 669.900635,1014.603333 
	C667.674011,1013.911316 665.753418,1013.821411 663.442688,1013.830750 
	C661.125854,1013.607117 659.601257,1012.926392 659.778442,1010.311646 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M601.716858,943.146606 
	C601.750793,944.648010 601.038635,946.298462 603.705505,946.039917 
	C604.937866,945.920410 605.982849,946.386047 606.870605,947.762817 
	C604.091919,949.629028 600.851135,949.889343 597.599609,950.474304 
	C597.020630,948.486023 598.267883,947.167480 598.721497,945.320435 
	C599.500977,944.150513 600.183105,943.254822 601.716858,943.146606 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M621.582397,507.065796 
	C620.892700,504.841461 619.439941,504.791290 617.608765,504.994843 
	C615.012390,505.283508 612.386108,505.302643 609.345581,505.224731 
	C610.193909,503.423798 611.959167,503.110443 613.824768,503.254730 
	C616.642395,503.472656 619.314453,503.032745 622.260864,501.829987 
	C624.118774,502.571564 625.245361,503.479401 624.708618,505.332489 
	C624.299988,506.742920 623.594177,507.746063 621.582397,507.065796 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M616.914307,903.293213 
	C617.796509,907.979309 615.486328,911.262817 611.498291,911.596130 
	C610.362671,911.691101 610.048218,911.113464 609.956665,910.206055 
	C609.777039,908.427246 614.620667,903.314331 616.914307,903.293213 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M689.923584,698.485291 
	C688.089355,696.925049 686.318604,695.451172 686.092041,692.654663 
	C692.195496,690.718994 693.621399,695.855530 696.287720,699.657776 
	C696.202332,700.136597 696.047913,700.255737 695.606079,700.409302 
	C694.611755,700.192932 693.877075,700.147400 692.870728,700.034241 
	C691.764099,699.490479 691.297668,698.457947 689.923584,698.485291 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M619.079224,511.979431 
	C615.017944,512.103943 611.275146,512.099854 607.074097,512.178406 
	C606.926758,511.568695 607.237549,510.876373 607.882263,509.993500 
	C611.998230,508.748962 615.902283,508.972504 620.183350,508.763794 
	C622.994568,510.950958 620.095886,510.960693 619.079224,511.979431 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M680.181763,542.773682 
	C680.063049,542.436707 680.183838,542.378052 680.220215,542.369995 
	C682.489502,537.512329 681.644104,532.256714 682.280151,526.754028 
	C682.332825,526.082031 682.362366,525.849487 682.568115,525.921143 
	C682.773499,534.448914 682.802551,542.672424 682.454346,551.161926 
	C681.501160,551.430603 681.050781,551.194336 680.625244,550.329956 
	C680.145813,548.381653 679.889893,546.801208 679.899902,544.847900 
	C680.079468,544.489746 680.012024,544.504761 680.035767,544.529846 
	C678.751038,543.841797 683.156982,544.082031 680.181763,542.773682 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M630.827026,885.439270 
	C627.667542,887.481018 621.883423,886.079956 621.910767,892.851440 
	C621.660583,893.490112 621.393860,893.709717 620.872925,893.998779 
	C619.961548,894.233704 619.567322,893.864441 619.012085,893.201050 
	C617.872192,890.897583 615.489685,888.523743 619.983765,887.020752 
	C623.289246,886.973877 625.956665,885.164490 629.319397,884.860229 
	C630.010437,885.008423 630.326233,885.134583 630.827026,885.439270 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M797.547241,739.301636 
	C795.528809,733.358826 799.589355,729.643372 802.844360,725.701355 
	C805.306580,728.236206 805.306580,728.236206 802.581421,730.902405 
	C801.259277,731.649658 801.468384,732.858521 800.988464,734.122070 
	C800.866272,734.643677 800.805359,734.849731 800.611206,735.349365 
	C799.689392,736.903931 799.228394,738.402405 797.547241,739.301636 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M601.078857,822.135132 
	C610.796143,820.372925 620.467712,820.807373 630.615479,821.224609 
	C631.091919,821.212952 631.195312,821.529175 631.141357,821.686523 
	C621.340149,822.074707 611.592896,822.305603 601.375305,822.541748 
	C600.905029,822.546936 600.965027,822.135742 601.078857,822.135132 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M630.698120,948.985352 
	C633.116821,950.452332 635.191589,951.694702 637.601440,952.989990 
	C638.510498,953.396057 639.067261,953.765137 639.146973,954.796143 
	C638.284973,955.088806 637.525635,955.062195 636.386902,955.015259 
	C635.864929,954.846375 635.722473,954.697876 635.299866,954.419556 
	C634.573242,954.225891 634.126770,954.162109 633.341858,954.111572 
	C631.754639,952.599426 630.001648,953.146179 628.423218,953.041992 
	C626.785461,952.933838 624.973083,953.185669 624.936646,950.309753 
	C626.524231,948.411987 628.397644,948.388611 630.698120,948.985352 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M623.469727,498.916840 
	C622.875305,498.809875 622.653564,498.593628 622.222107,498.279114 
	C621.400146,497.760681 620.844177,497.293518 620.766235,496.189941 
	C618.589722,494.616760 627.090698,493.199585 620.447998,492.038696 
	C619.898193,492.174438 619.727417,492.311035 619.238831,492.528992 
	C616.748352,492.758636 614.540588,493.346954 611.539490,492.047180 
	C615.676697,490.171143 619.260193,491.318359 623.068970,490.791901 
	C625.850952,493.351929 625.545532,496.050720 623.469727,498.916840 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M659.979126,704.233276 
	C662.817078,705.215759 662.742004,707.678406 663.134583,710.335571 
	C662.209106,712.216492 660.216003,713.843506 659.466980,712.280273 
	C658.400940,710.055359 656.405396,706.940674 659.979126,704.233276 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M656.216064,993.278748 
	C657.067383,993.403687 659.263794,991.605225 658.750671,993.706726 
	C657.665894,998.149597 660.785156,999.573608 663.500854,1001.110046 
	C665.402710,1002.186096 665.066467,1003.031982 664.090942,1004.613831 
	C660.657715,1006.426941 659.594299,1003.868042 658.224487,1001.258789 
	C657.451233,998.485168 656.805664,996.072632 656.216064,993.278748 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M762.347168,742.155273 
	C760.909851,735.576172 760.680054,729.241577 761.904541,722.909729 
	C762.452515,722.898254 763.000427,722.886841 763.548340,722.875366 
	C763.548340,728.898682 763.548340,734.921936 763.551270,741.338074 
	C763.399231,742.199097 763.083557,742.433289 762.347168,742.155273 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M667.259399,714.990906 
	C663.421204,718.154602 658.373047,718.291382 655.026733,721.674805 
	C654.273376,722.436584 653.483826,722.079590 652.978210,721.344604 
	C652.627808,720.835327 652.368530,720.160156 652.347900,719.549744 
	C652.311096,718.464661 653.121948,718.649170 653.947510,718.424622 
	C656.612976,717.699890 659.176636,716.600891 661.978271,715.372681 
	C663.589783,714.489746 665.002625,713.880188 666.745972,713.225708 
	C667.411621,713.618286 667.542297,714.110046 667.259399,714.990906 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M658.532959,507.688293 
	C660.012268,504.419281 658.834045,500.282928 661.293030,497.083527 
	C663.632629,500.435364 658.663574,504.788635 663.747925,507.480957 
	C664.198669,507.829437 664.300232,508.003204 664.394836,508.478577 
	C664.201111,509.141327 663.938843,509.431732 663.605530,509.933655 
	C662.064514,510.876312 662.064514,510.876312 658.532959,507.688293 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M735.329468,720.237183 
	C734.041260,718.888062 733.806824,717.656189 734.614136,716.034790 
	C735.023621,715.721008 735.178162,715.631775 735.546997,715.382568 
	C736.211121,714.935486 736.679993,714.678650 737.331909,714.204834 
	C737.868958,713.864990 738.205078,713.728882 738.795410,713.770874 
	C740.856018,715.727112 744.218384,717.082458 740.935486,720.733887 
	C740.405090,721.403381 739.885620,721.502014 739.017883,721.052856 
	C738.856262,718.641235 737.969116,718.670349 736.300537,719.880615 
	C735.854736,720.187195 735.691528,720.360413 735.329468,720.237183 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M637.227051,809.918884 
	C631.423462,808.185852 625.617188,809.449402 620.072937,808.163025 
	C618.821411,807.872498 617.501099,807.879028 616.239563,807.537659 
	C623.610474,806.294922 630.899353,807.534485 638.641602,808.050049 
	C638.948608,809.058716 638.497070,809.697266 637.227051,809.918884 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M646.334412,844.955444 
	C643.985657,841.891663 640.487305,841.018799 637.265991,839.108032 
	C639.730774,836.328491 642.734009,837.687744 644.850464,839.306335 
	C646.041809,840.217468 649.466858,842.012756 646.334412,844.955444 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M434.577667,833.936218 
	C433.344788,835.725220 432.032166,837.900085 429.029724,839.049561 
	C427.684204,840.509094 426.551147,840.887207 424.900482,840.744629 
	C424.322296,840.546509 424.106110,840.426636 423.671234,840.007263 
	C423.179932,838.982544 423.185730,838.267761 423.764648,837.280762 
	C427.331085,835.782471 430.461273,833.896667 434.577667,833.936218 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M754.213745,503.311890 
	C754.402344,502.719666 754.655029,502.479919 755.027710,502.002014 
	C757.995972,506.886780 760.347229,512.216003 761.718628,517.985229 
	C758.042725,513.834656 756.868103,508.373322 754.213745,503.311890 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M756.233398,742.191772 
	C756.176392,737.094421 754.636230,732.150391 757.575928,727.328247 
	C758.735779,732.104492 758.892639,737.130371 758.181580,742.586914 
	C757.371826,743.397766 756.848816,743.068298 756.233398,742.191772 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M729.796631,756.356079 
	C732.603088,754.644836 736.600098,756.225403 736.400757,757.121887 
	C735.716492,760.201111 733.008362,761.993164 729.220825,761.247131 
	C728.220764,759.417969 728.632690,757.990356 729.796631,756.356079 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M787.653809,693.085449 
	C788.139954,696.758911 784.905151,698.582703 783.159241,701.249634 
	C781.993591,703.030273 780.532471,704.617493 779.046753,706.585938 
	C775.506958,707.487610 777.384583,705.465088 777.934204,704.663147 
	C780.735413,700.576477 783.792725,696.680969 787.653809,693.085449 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M731.613831,473.315979 
	C733.414490,470.140686 732.266052,466.508423 735.044067,463.835785 
	C734.138794,469.781342 733.233459,475.726868 732.328186,481.672424 
	C732.008789,481.657196 731.689392,481.641968 731.369995,481.626740 
	C731.129211,479.309113 730.888428,476.991516 730.824707,474.404175 
	C731.140686,473.954681 731.279602,473.774933 731.613831,473.315979 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M700.554199,534.077271 
	C702.335022,535.207092 703.333679,536.808838 703.033508,538.934265 
	C702.687622,541.383484 704.444824,542.786682 705.801270,544.794067 
	C705.566467,545.492188 705.160889,545.691650 704.349243,545.688599 
	C702.376038,545.613464 701.132568,545.313599 701.037170,543.215515 
	C700.902466,540.249573 700.520752,537.294983 700.554199,534.077271 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M710.137329,470.375000 
	C710.833679,469.995789 711.172546,469.561279 711.752502,468.990845 
	C712.142151,469.049561 712.290710,469.244202 712.283813,469.771545 
	C710.137390,475.516235 707.359253,480.527557 704.150757,485.700623 
	C703.796692,486.142426 703.627136,486.297211 703.198425,486.225250 
	C703.004517,485.568695 703.069763,485.138885 703.209717,484.390198 
	C702.945801,482.937805 703.391968,482.104980 704.483337,481.213074 
	C705.107605,480.215485 705.539185,479.450409 706.040161,478.362488 
	C706.070068,477.418030 706.239563,476.864990 706.900635,476.228210 
	C707.493591,475.605530 707.836426,475.145752 708.269897,474.406494 
	C707.960815,472.532532 708.423706,471.259644 710.137329,470.375000 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M751.672485,823.917969 
	C752.790161,824.574524 753.553894,825.140442 754.564941,825.852600 
	C754.543152,828.773926 755.822510,832.154236 751.549744,833.530457 
	C751.241089,830.926392 751.265564,828.286926 751.278809,825.309937 
	C750.976807,824.704590 750.887573,824.445679 750.999451,824.195618 
	C751.109131,823.950134 751.215332,823.827332 751.672485,823.917969 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M564.308960,671.330811 
	C565.824768,665.205872 567.172607,658.937195 570.697388,653.166504 
	C570.245178,659.598999 568.132690,665.722412 564.308960,671.330811 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M657.947266,1001.215942 
	C660.093567,1001.928040 661.040100,1004.340027 663.724731,1004.910339 
	C664.328979,1005.001465 664.580933,1005.119324 664.964844,1005.411987 
	C665.562073,1006.406067 665.823547,1007.274658 665.243896,1008.622253 
	C663.632202,1009.017395 662.266174,1009.019104 660.500244,1009.106689 
	C660.913086,1006.164673 655.815674,1004.913696 657.947266,1001.215942 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M710.885071,787.827087 
	C715.081482,790.084229 716.883606,794.089905 719.144226,797.820618 
	C715.126160,796.204285 712.895081,792.637268 709.898193,789.480103 
	C709.902710,788.691162 710.163330,788.288513 710.885071,787.827087 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M645.367920,909.096191 
	C644.832581,906.645020 642.883179,907.142944 640.982178,906.781128 
	C643.835022,904.196228 648.075806,904.899475 651.764221,903.243530 
	C648.774780,904.344727 650.472656,909.957581 645.367920,909.096191 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M749.287109,712.579224 
	C751.519897,712.647705 750.835510,714.450012 750.864990,715.804077 
	C750.991272,721.615662 751.013855,727.429504 751.020447,733.724731 
	C749.867065,734.115112 748.890991,733.734741 749.132996,732.431152 
	C750.334229,725.960693 749.150879,719.486877 749.287109,712.579224 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M691.212891,651.957275 
	C689.608337,646.876099 690.298279,641.866211 690.557983,636.846436 
	C690.977844,636.831726 691.397766,636.816956 691.817627,636.802185 
	C692.164795,641.609741 692.511902,646.417358 692.756653,651.670532 
	C692.270630,652.071655 691.887024,652.027161 691.212891,651.957275 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M585.947266,811.023438 
	C584.031250,811.380615 582.418579,811.715759 580.396240,812.015991 
	C582.616943,807.810181 586.935120,806.319275 591.656738,804.933777 
	C590.627197,807.500793 588.427612,809.240173 585.947266,811.023438 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M670.467041,578.620911 
	C668.389038,573.966370 666.622070,569.117371 664.916016,563.908813 
	C664.838196,563.215515 664.699463,562.881775 664.921021,562.142944 
	C667.948486,567.025696 670.836792,572.240784 670.467041,578.620911 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M755.344299,724.503784 
	C755.026855,728.643799 755.581299,732.452026 754.449829,736.479614 
	C753.620300,730.748108 752.064148,724.768738 753.952881,718.608704 
	C754.484436,719.433411 754.700989,720.345642 754.993042,721.602112 
	C755.577087,722.607178 755.753479,723.332520 755.344299,724.503784 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M723.637268,819.830322 
	C724.305359,820.763794 724.298279,821.801147 723.657715,821.699341 
	C719.626953,821.058777 715.216309,821.227966 712.706177,817.075195 
	C717.016052,815.395142 720.367065,816.779785 723.637268,819.830322 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M663.880859,509.040833 
	C664.166077,508.457123 664.198181,508.226715 664.142578,507.823029 
	C667.003418,506.220276 670.178284,506.547485 673.614441,506.302246 
	C674.308655,506.653839 674.497131,507.037445 674.480164,507.823547 
	C673.993896,509.234589 673.160034,509.935547 671.870850,510.459229 
	C671.243347,510.546387 670.938965,510.685822 670.384155,510.845306 
	C668.570801,510.148834 666.987305,511.604706 665.093506,510.719971 
	C664.555725,510.572449 664.349304,510.525818 663.851929,510.352509 
	C663.597168,509.950562 663.633545,509.675293 663.880859,509.040833 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M640.639893,520.770142 
	C640.818176,522.275024 640.264526,523.661316 640.560425,524.833069 
	C642.021484,530.618225 639.061890,530.013794 635.289185,528.255371 
	C635.471375,525.321472 636.615479,523.149780 638.695923,521.073914 
	C638.866821,520.778687 638.841797,520.888855 638.795898,520.855957 
	C639.233276,520.542175 639.749817,520.452148 640.639893,520.770142 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M759.059387,480.192749 
	C757.757812,479.894287 757.938660,478.876068 757.355225,477.974731 
	C756.828430,476.713074 756.546936,475.645508 756.088257,474.294769 
	C755.815491,473.850464 755.719910,473.689331 755.720215,473.264038 
	C756.040710,471.782318 755.614929,470.715851 754.924683,469.356567 
	C754.486511,468.554504 754.159973,468.082458 754.231750,467.198608 
	C753.857971,464.555542 753.410645,462.189423 752.989990,459.419189 
	C756.250122,465.286987 757.432312,472.202118 759.294189,479.306274 
	C759.326416,479.867035 759.320679,480.037567 759.059387,480.192749 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M812.072388,705.877197 
	C811.142761,705.881409 810.359314,705.567200 809.289185,705.114868 
	C808.002014,703.630249 807.045837,702.239258 805.248779,701.242920 
	C806.801208,696.605408 809.946655,701.546204 812.547913,699.979797 
	C813.491943,701.939148 814.213501,703.927246 812.072388,705.877197 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M733.039673,830.991760 
	C730.450867,830.991150 728.321411,830.991150 726.191895,830.991150 
	C731.611450,830.214355 736.821167,827.918823 743.612427,828.227783 
	C740.001831,831.945435 736.554016,830.652527 733.039673,830.991760 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M476.068359,778.206909 
	C479.599365,778.760315 479.556427,781.966553 480.680298,784.842773 
	C481.318420,785.430176 481.490387,785.858215 481.259094,786.668701 
	C478.400757,787.251404 474.707001,788.965454 476.814240,783.347839 
	C477.300415,782.051819 476.332397,780.210266 476.068359,778.206909 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M643.260620,889.422974 
	C641.654236,887.808533 641.784729,886.253357 642.700256,884.074707 
	C646.032959,889.959167 650.135193,883.600708 654.716736,885.611633 
	C650.593933,887.091614 647.088257,888.350098 643.260620,889.422974 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M717.385742,518.287048 
	C716.900085,519.582947 716.676636,520.597046 714.732727,521.157166 
	C716.416870,515.372681 717.979614,510.005310 719.689758,504.131744 
	C719.591919,509.166443 719.279419,513.647461 717.385742,518.287048 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M737.891052,801.148682 
	C736.879944,798.557068 735.303528,796.484009 736.474976,793.307373 
	C738.208069,796.850342 739.770203,800.020996 741.307800,803.203613 
	C741.679932,803.974060 743.239441,804.589355 742.099548,805.576050 
	C740.967163,806.556091 740.024170,805.453064 739.202576,804.644287 
	C738.331787,803.787048 737.982849,802.724365 737.891052,801.148682 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M571.314941,652.845703 
	C568.040039,649.281799 570.738647,645.538879 570.993774,641.396362 
	C572.235168,641.807739 571.932556,643.087646 571.984863,644.628479 
	C571.201660,645.713257 571.673523,646.725342 571.411987,647.565063 
	C571.651245,646.910583 571.430176,646.204529 571.816101,645.277893 
	C572.998413,644.775391 574.276794,640.953369 574.870361,645.561951 
	C573.767151,648.145447 572.690613,650.411987 571.314941,652.845703 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M683.977722,797.607544 
	C683.496826,797.998840 683.072205,798.015381 682.327637,798.019165 
	C681.947571,797.210266 681.887329,796.414185 681.695190,795.348267 
	C681.693481,792.670776 681.823730,790.263062 682.026489,787.444336 
	C682.779114,787.032471 683.459290,787.031494 684.479492,787.052368 
	C685.597961,787.662659 685.708618,788.439636 685.207397,789.660156 
	C684.861938,790.742554 684.762573,791.484558 684.756348,792.594238 
	C684.939270,793.434387 684.925659,793.904968 684.683716,794.702393 
	C684.374390,795.764893 684.204163,796.498779 683.977722,797.607544 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M594.460815,534.944885 
	C593.146362,534.470459 593.110596,533.518921 593.313843,532.142334 
	C593.497620,531.623962 593.616394,531.470276 593.965576,531.130981 
	C594.370117,530.846375 594.544189,530.747375 595.015747,530.571777 
	C595.515625,530.439270 595.718140,530.383179 596.206787,530.179565 
	C599.025574,529.077332 601.365723,527.598694 604.458618,527.310669 
	C605.000122,527.518250 605.197754,527.647888 605.382874,528.131836 
	C602.028748,530.909058 597.823425,531.883240 594.460815,534.944885 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M705.518677,993.285156 
	C701.274414,992.700012 697.483398,995.078918 693.266418,993.279968 
	C693.282166,992.862305 693.537720,992.682190 693.882324,992.250244 
	C696.987671,992.920532 699.616638,990.757141 702.492493,991.047363 
	C704.296143,991.229309 706.450500,990.013611 707.910461,992.574097 
	C707.388184,993.624268 706.611694,993.467773 705.518677,993.285156 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M676.023315,531.614624 
	C675.524414,531.995361 675.111267,531.981506 674.388550,531.989075 
	C674.010559,527.573853 673.878723,523.131531 675.185791,518.811523 
	C675.221497,518.693298 675.399048,518.522400 675.484314,518.536316 
	C675.628845,518.559998 675.752380,518.711487 676.025391,519.052490 
	C676.147034,523.270508 676.128052,527.245300 676.023315,531.614624 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M637.708923,534.806641 
	C633.865479,535.677185 629.704590,536.290222 625.170654,536.660522 
	C625.262268,533.914001 627.234558,534.070251 629.033997,534.117493 
	C631.821716,534.190735 634.605835,534.398438 637.708923,534.806641 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M578.075928,631.643372 
	C577.697083,631.762024 577.400452,631.535828 576.959290,631.066589 
	C575.672729,629.211060 576.272583,627.814880 577.691040,626.263672 
	C579.632385,623.133301 581.237244,620.217834 582.842163,617.302307 
	C582.971802,622.618347 580.329529,626.874023 578.075928,631.643372 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M810.772217,768.781372 
	C810.942993,771.213989 810.906555,773.397400 810.789246,776.044983 
	C810.281128,776.424744 809.940552,776.202026 809.554504,775.568481 
	C805.781494,774.715393 807.682617,771.368896 806.277710,769.268738 
	C806.008545,768.521362 806.019592,768.045105 806.057617,767.212646 
	C806.270813,766.742615 806.457092,766.628845 806.970703,766.493652 
	C808.597046,766.825623 809.634827,767.593445 810.772217,768.781372 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M789.352661,706.071228 
	C788.814392,705.213623 789.186462,704.006592 787.338989,704.025391 
	C787.494385,700.572144 789.249634,697.885376 792.299194,695.671021 
	C792.723511,695.670044 792.835449,695.793945 793.118591,696.100708 
	C793.796143,697.106262 793.588318,697.940552 793.224609,699.052490 
	C793.037903,699.497559 792.956970,699.665894 792.752747,700.066162 
	C792.464294,700.581116 792.376770,700.886292 792.447021,701.424316 
	C792.527039,701.635254 792.669189,702.061707 792.570496,702.263611 
	C791.784851,703.863525 791.099854,705.263062 789.352661,706.071228 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M733.795166,843.880493 
	C733.208923,844.592407 732.636841,844.661743 731.773560,844.753174 
	C730.618774,842.483093 731.303589,840.221802 731.611633,837.951233 
	C731.753662,836.904297 732.026489,835.906311 733.342773,836.041077 
	C735.056885,836.216614 734.149170,837.450562 734.111511,838.288940 
	C734.037415,839.939758 733.912903,841.588318 733.795166,843.880493 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M725.481873,814.756470 
	C725.308716,815.479126 725.195740,815.744019 724.813110,815.998352 
	C720.769348,817.610657 717.451294,816.029785 713.958801,813.925293 
	C713.719421,813.159424 713.671265,812.812134 713.794922,812.247925 
	C717.429932,809.876953 720.826904,811.534668 724.628845,812.435791 
	C725.405151,813.146790 725.597412,813.699585 725.481873,814.756470 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M725.106201,812.602173 
	C721.522339,812.583374 718.174072,812.286072 714.396240,812.009888 
	C713.587585,810.879333 711.238647,808.887939 715.036377,809.514954 
	C718.031372,810.009338 721.025208,810.510010 724.407837,811.073975 
	C725.252686,811.407959 725.434509,811.802551 725.106201,812.602173 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M685.871582,780.485718 
	C689.037537,780.281860 692.359558,780.152893 695.633667,778.200806 
	C696.365784,778.440063 696.539917,778.879883 696.227844,779.739136 
	C695.666504,780.424500 695.321960,780.797241 694.913086,781.419006 
	C691.643066,784.206055 688.724426,783.851074 685.871582,780.485718 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M774.932678,811.187256 
	C775.552246,811.035400 775.838135,811.031860 776.552246,811.003540 
	C776.226318,815.955750 774.410339,820.604187 772.909668,825.511658 
	C771.550049,824.583496 772.152283,823.561401 771.984314,822.352051 
	C771.967773,821.996582 772.106873,821.650757 772.107422,821.464355 
	C772.182251,820.962097 772.329224,820.684753 772.662964,820.237793 
	C772.857910,819.595581 772.938782,819.161560 773.027527,818.396057 
	C774.376282,816.012085 772.024780,813.101501 774.932678,811.187256 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M756.038208,742.354736 
	C756.561523,742.206909 757.058167,742.515259 757.834106,742.910645 
	C759.197937,746.711975 757.899170,750.397766 757.901306,754.516479 
	C755.827698,751.099976 755.977356,746.946838 756.038208,742.354736 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M741.265320,745.627075 
	C738.955017,748.245789 736.045410,747.016968 733.672119,746.377380 
	C732.204285,745.981750 732.855957,743.649353 733.835876,742.314392 
	C735.332153,742.551025 735.441772,743.582703 735.771729,744.505371 
	C736.609863,746.848755 737.023254,746.940369 737.916931,744.390381 
	C738.216553,743.535400 740.325012,743.903015 741.265320,745.627075 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M624.993042,961.579590 
	C622.903992,964.007935 620.253418,962.582275 617.479797,963.081787 
	C616.530884,959.301270 619.681885,960.348328 621.539368,959.662842 
	C623.223938,959.041077 624.762146,958.609619 624.993042,961.579590 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M702.497131,791.062134 
	C707.655518,793.805054 707.766113,794.541138 703.281494,797.538574 
	C702.955688,795.372559 702.653320,793.362732 702.497131,791.062134 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M802.934814,779.550171 
	C803.067810,775.641785 803.192749,772.169189 803.572632,768.391968 
	C803.827637,768.087402 804.001465,768.537659 804.096680,768.759399 
	C804.413208,769.382996 804.496277,769.813599 804.388184,770.597900 
	C804.302612,771.404724 804.288086,771.882751 804.338013,772.714417 
	C804.479187,773.516479 804.599365,773.953003 804.820618,774.713440 
	C804.955322,776.127014 805.032410,777.204712 805.194824,778.678772 
	C805.436951,779.601440 805.489197,780.138000 805.364807,781.087097 
	C805.234436,783.938904 805.865845,786.465088 804.151855,789.019897 
	C802.782166,786.248962 803.159180,783.088074 802.934814,779.550171 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M748.850891,440.257629 
	C750.228271,437.085175 751.720703,434.149231 753.399719,430.905243 
	C753.844666,430.517334 754.102966,430.437500 754.539917,430.721771 
	C754.718201,431.513885 754.717773,431.941833 754.593750,432.666992 
	C754.461426,433.173370 754.452759,433.382599 754.282227,433.860992 
	C753.737244,435.401581 753.354187,436.672974 752.915771,438.272247 
	C752.348450,440.174164 751.743042,441.643066 749.325134,441.235016 
	C748.983154,440.844330 748.974487,440.669220 748.850891,440.257629 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M662.676453,872.783081 
	C665.300659,876.597229 662.198914,879.809448 662.317078,883.298096 
	C660.275146,880.473022 661.404602,877.169373 660.841675,873.712280 
	C661.197083,872.726685 661.674072,872.489929 662.676453,872.783081 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M737.108887,739.240417 
	C736.943420,738.205322 736.904846,737.484375 736.900330,736.403809 
	C742.374756,735.250977 741.655701,739.318481 742.363708,743.204834 
	C740.299316,741.735352 738.767517,740.644958 737.108887,739.240417 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M667.415527,715.242432 
	C667.053833,714.848633 667.057373,714.371582 667.068604,713.537720 
	C669.759155,711.759399 672.441833,710.338013 675.480164,708.868896 
	C676.289124,708.931824 676.671326,709.158142 677.076660,709.844849 
	C674.261047,712.233459 671.364807,714.344482 667.415527,715.242432 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M447.361298,816.078369 
	C450.529022,812.932678 454.875793,811.233826 459.041504,809.225403 
	C459.123230,809.185974 459.535400,809.831909 459.716919,810.480591 
	C455.860260,812.990845 451.933807,814.851746 447.361298,816.078369 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M766.948425,736.060425 
	C766.955994,740.642517 766.955994,744.740417 766.955994,748.838318 
	C766.632874,748.836487 766.309692,748.834595 765.986572,748.832764 
	C765.986572,741.475403 765.986572,734.117981 765.986572,726.760620 
	C766.304688,726.738220 766.622742,726.715820 766.940857,726.693420 
	C766.940857,729.654358 766.940857,732.615295 766.948425,736.060425 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M711.071594,787.399597 
	C710.942566,788.064514 710.658386,788.437988 710.067871,788.991333 
	C707.296631,786.729675 703.947998,784.972961 702.800049,780.427979 
	C706.653381,782.161804 708.521240,784.958435 711.071594,787.399597 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M751.188354,786.176880 
	C751.302917,789.938904 751.055420,793.521179 750.807922,797.103394 
	C751.537231,793.413330 748.066406,789.599854 751.188354,786.176880 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M669.671021,826.129211 
	C670.693787,830.651306 673.181335,835.052979 672.933594,840.175903 
	C671.033203,839.404358 671.318237,837.634155 670.374023,836.223450 
	C670.533813,832.726257 667.988098,829.702515 669.671021,826.129211 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M833.451172,683.221497 
	C832.490784,681.774231 831.606018,680.383423 832.718079,678.672913 
	C834.606262,675.768433 831.850220,676.137817 830.225464,675.331909 
	C831.687805,674.932251 833.602844,673.127869 835.020203,674.894775 
	C837.034790,677.406128 834.337524,679.751953 834.054321,682.594849 
	C833.984192,682.959717 833.659424,683.220520 833.451172,683.221497 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M671.990479,510.537720 
	C672.155762,509.574799 672.763794,508.742737 673.659790,507.790100 
	C675.595947,506.661316 677.425110,506.281250 679.674927,506.157715 
	C680.257324,506.275146 680.482727,506.357330 681.075439,507.366394 
	C678.822937,510.538940 675.968018,511.892914 671.990479,510.537720 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M630.175415,515.120972 
	C629.939514,514.837952 629.950989,514.659424 630.013428,514.217529 
	C630.784302,513.315369 630.990845,512.373413 631.668457,511.309387 
	C633.639709,510.355408 636.233093,508.840698 636.705261,511.589661 
	C637.250366,514.763367 633.727722,514.333679 631.309814,515.191772 
	C630.769653,515.314697 630.596252,515.270020 630.175415,515.120972 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M775.391235,810.645508 
	C774.680237,813.206909 774.094238,815.374878 773.271851,817.803711 
	C772.716492,814.255493 770.036682,809.952087 775.603882,807.159241 
	C775.785706,808.090332 775.650940,809.171204 775.391235,810.645508 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M686.534363,640.927368 
	C686.734985,645.995972 688.048340,651.074463 686.994751,656.589111 
	C686.708374,656.843079 686.414551,656.688599 686.000000,656.308411 
	C686.612610,651.259460 685.450317,646.543945 685.111694,641.344910 
	C685.524353,640.921509 685.891846,640.937439 686.534363,640.927368 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M649.490112,551.004150 
	C650.886658,551.046082 651.853455,551.089966 652.820312,551.133911 
	C652.817688,551.320129 652.815063,551.506348 652.812439,551.692566 
	C645.546753,551.692566 638.281128,551.692566 631.015442,551.692566 
	C631.009766,551.463745 631.004028,551.234924 630.998291,551.006104 
	C637.019043,551.006104 643.039734,551.006104 649.490112,551.004150 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M630.029968,499.398987 
	C630.597107,499.151764 631.134521,499.096954 631.547852,499.297607 
	C633.026428,500.015442 635.265991,498.169373 636.159546,500.620026 
	C636.352844,501.150238 636.190247,502.348663 635.969238,502.407806 
	C633.904907,502.959900 631.762939,503.584320 629.809204,501.380005 
	C629.780762,500.551239 629.862000,500.129913 630.029968,499.398987 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M655.145874,545.380127 
	C650.509949,545.250366 648.962097,541.282043 646.610352,537.860962 
	C650.860657,538.410217 652.455322,542.346680 655.145874,545.380127 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M660.595947,525.189453 
	C658.967041,528.547180 656.580322,530.840576 654.200012,533.140381 
	C653.564270,533.754578 652.996277,535.096558 652.002991,533.768433 
	C651.207886,532.705139 652.239197,532.200439 653.014038,531.490479 
	C655.196655,529.490295 657.189087,527.282593 659.559692,525.010620 
	C660.122803,524.843445 660.382690,524.822327 660.595947,525.189453 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M705.553711,558.963623 
	C703.016174,562.414978 699.601501,561.055664 696.427063,560.943115 
	C695.513550,560.910828 694.931030,560.246216 694.973267,559.308289 
	C695.040588,557.811890 696.097473,557.993286 697.087036,558.220764 
	C699.338928,558.738464 701.603577,559.031006 704.309326,558.594849 
	C704.958069,558.497681 705.212219,558.542114 705.553711,558.963623 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M660.157959,685.332458 
	C657.854309,684.712341 658.665344,681.141296 655.415833,681.231201 
	C654.532532,681.255615 654.960083,679.248474 656.111084,678.563232 
	C657.041443,678.009460 658.244568,677.752441 658.198914,679.298523 
	C658.137268,681.391602 660.315552,681.741516 660.874573,683.651489 
	C660.881042,684.457520 660.720947,684.844177 660.157959,685.332458 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M702.688232,551.696777 
	C701.299316,556.949829 698.175537,555.289551 695.150574,553.314209 
	C697.142883,550.045898 699.698669,550.303833 702.688232,551.696777 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M577.896973,625.777039 
	C577.656982,627.409729 577.286499,628.770752 576.865356,630.477661 
	C575.055298,631.188293 573.691833,630.756104 572.939209,628.618408 
	C574.746033,627.806580 574.285095,623.195740 577.896973,625.777039 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M467.017609,811.394775 
	C467.302063,810.974060 467.643677,810.915833 468.231812,810.797241 
	C470.253296,814.563660 472.117828,818.355713 473.036499,822.933594 
	C469.870483,820.091553 468.823120,815.744568 467.017609,811.394775 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M725.153442,808.214355 
	C721.008545,808.021851 716.846436,808.375000 712.264160,805.765808 
	C717.040649,805.037903 720.598511,806.271179 724.599609,806.943176 
	C725.109497,807.292480 725.228638,807.557983 725.153442,808.214355 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M694.861328,637.394409 
	C695.957825,636.319031 695.960449,635.332947 695.970459,633.972656 
	C696.076172,633.332458 696.265808,633.158325 696.728882,633.015991 
	C696.972290,639.689941 697.023865,646.420959 697.134705,653.622803 
	C696.976624,654.178467 696.759399,654.263245 696.342896,654.060547 
	C696.104614,652.130249 696.065613,650.487427 695.978760,648.436035 
	C694.101807,644.778992 695.572510,641.101501 694.861328,637.394409 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M727.206970,889.774048 
	C726.621094,890.059448 726.350891,890.033997 725.682129,889.926147 
	C724.007935,889.692139 722.865417,889.261902 721.790833,888.033691 
	C721.440796,887.653931 721.290405,887.511841 720.984497,887.101135 
	C721.194214,885.912537 721.559448,884.992554 722.225098,884.028564 
	C724.478943,882.940735 725.839966,883.959290 727.353760,885.668335 
	C728.079590,887.189514 728.095215,888.332886 727.206970,889.774048 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M607.712036,547.609619 
	C610.331360,547.071838 612.774719,546.714111 615.231018,546.543701 
	C616.001648,546.490295 616.982849,546.860840 617.052246,547.863098 
	C617.134277,549.047791 616.122253,548.994507 615.325745,549.009827 
	C613.171936,549.051147 611.017395,549.051514 608.414429,548.997437 
	C607.650940,548.640869 607.500549,548.289490 607.712036,547.609619 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M669.890625,1014.799927 
	C669.830383,1013.350037 670.197083,1011.973938 669.038818,1010.380127 
	C670.382996,1008.137390 672.066101,1008.133240 674.213501,1009.907227 
	C674.788208,1010.855957 675.023987,1011.564636 675.281738,1012.555725 
	C673.357605,1012.832825 672.487854,1015.471375 669.890625,1014.799927 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M704.731934,980.467651 
	C705.723877,980.186646 706.469360,980.114319 707.583923,979.970642 
	C707.956787,981.027527 707.960510,982.155823 707.943359,983.706726 
	C707.091492,984.838196 706.345337,985.638672 705.286987,986.583679 
	C705.093079,987.388611 705.328918,988.382263 705.140015,988.470947 
	C703.970642,989.019775 703.635193,987.896179 702.973267,986.930725 
	C702.776794,986.437805 702.697083,986.235901 702.619385,985.708374 
	C702.966248,983.704468 703.000183,981.903076 704.731934,980.467651 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M716.093567,705.366272 
	C717.584229,709.539551 714.807373,712.624817 713.414917,716.116760 
	C713.725403,712.434448 713.817566,708.716797 716.093567,705.366272 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M761.996216,742.364380 
	C762.432617,741.863037 762.751282,741.801208 763.310913,741.729004 
	C764.618286,745.269958 763.949890,748.773560 763.425781,753.429504 
	C761.370789,749.352417 761.976562,746.030273 761.996216,742.364380 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M643.335327,1003.119019 
	C643.007446,1002.948730 643.009705,1002.542908 643.013550,1002.340332 
	C646.226685,1000.601685 649.493591,1000.794983 652.819946,1001.845459 
	C649.902466,1003.270203 646.880432,1003.883240 643.335327,1003.119019 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M710.826782,490.006348 
	C713.089783,488.302704 715.197876,486.856628 717.617432,485.632141 
	C716.072144,489.238953 713.116882,491.341431 709.356689,492.978394 
	C708.868896,492.918762 708.722290,492.783173 708.555298,492.348694 
	C708.576660,491.854279 708.618408,491.658844 708.872925,491.252167 
	C709.614380,490.781952 710.143066,490.522949 710.826782,490.006348 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M778.306763,739.722839 
	C774.810120,739.383057 776.069336,737.533081 777.156311,736.137878 
	C778.187500,734.814209 779.929199,732.587708 781.296692,733.773987 
	C783.348755,735.554199 781.238770,736.728271 779.246216,737.677490 
	C779.020813,738.535889 778.889221,739.079712 778.306763,739.722839 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M807.279297,766.619019 
	C806.934021,766.967163 806.504211,766.946472 806.294312,766.901367 
	C806.092529,759.951233 806.100525,753.046082 806.107422,745.699463 
	C807.694214,747.018127 806.748535,749.236694 807.240417,751.613647 
	C809.447632,756.724609 809.050110,761.486023 807.279297,766.619019 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M629.858398,507.272034 
	C631.707947,504.181915 634.324585,505.745850 636.354736,506.485931 
	C637.518677,506.910248 636.834717,508.557648 635.285278,508.655792 
	C633.659180,508.758759 632.018250,508.628357 630.124146,508.295990 
	C629.864380,507.992004 629.936035,507.505371 629.858398,507.272034 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M659.654297,1010.055237 
	C660.144592,1011.741028 661.895752,1012.134766 662.910522,1013.555359 
	C661.387085,1015.393677 659.306274,1016.449646 657.644714,1014.405151 
	C656.302124,1012.753235 657.669250,1011.143066 659.654297,1010.055237 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M694.855835,636.868774 
	C695.926697,640.367065 696.146423,643.740784 695.994019,647.585205 
	C695.670044,648.014709 695.409180,648.001892 694.754883,647.944336 
	C693.717346,644.149170 693.623474,640.409729 694.855835,636.868774 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M723.923096,819.819336 
	C720.510681,819.072693 717.120178,818.002441 713.334473,816.896484 
	C712.992737,816.395813 713.046204,815.930908 713.140747,815.117371 
	C716.635254,814.342407 719.617676,816.282288 722.984131,817.116943 
	C724.519531,817.666321 723.932068,818.715332 723.923096,819.819336 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M605.990112,679.527954 
	C603.796387,679.197937 601.588501,678.494080 599.144592,677.540649 
	C600.710083,674.883118 603.192871,675.537537 605.990112,679.527954 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M630.337769,489.221497 
	C632.043762,485.931091 634.220825,488.244385 636.217896,488.667694 
	C636.497925,488.727051 636.771912,489.467529 636.802734,489.909912 
	C636.861389,490.752228 636.191223,491.016479 635.507202,490.958984 
	C633.900085,490.823914 632.193115,491.355072 630.468567,489.993774 
	C630.222717,489.692474 630.394287,489.387238 630.337769,489.221497 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M708.933350,878.734863 
	C707.670166,879.065125 707.115417,879.837219 706.275208,880.803467 
	C702.648743,879.374878 705.189148,877.345398 705.614807,875.460388 
	C708.968201,876.600708 707.591370,872.137024 710.474792,872.018066 
	C710.981140,874.404114 710.108154,876.475342 708.933350,878.734863 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M729.779541,755.946899 
	C729.817566,757.503235 729.555481,758.911987 729.147766,760.653076 
	C727.856873,760.976257 726.711609,760.967224 725.137329,760.918091 
	C725.037781,760.420410 725.367310,759.962891 725.804810,759.244934 
	C727.603210,758.215332 726.643860,756.423706 727.523621,755.089722 
	C728.294678,755.204163 728.887085,755.501709 729.779541,755.946899 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M797.167969,739.645874 
	C797.970215,738.006042 798.711060,736.655640 799.734619,735.141113 
	C801.633301,736.932800 801.095398,738.691406 799.216919,740.658081 
	C797.584778,742.330994 797.129944,744.065063 796.833496,746.218079 
	C796.785583,747.044128 796.529907,747.346069 795.750916,747.449829 
	C795.423096,747.405640 795.141846,747.151306 794.998718,747.027039 
	C794.715698,746.765076 794.575867,746.627380 794.568481,746.226746 
	C794.819885,745.546875 794.938965,745.130005 795.104248,744.390991 
	C795.083130,743.465332 795.202393,742.910583 795.789673,742.218872 
	C795.998474,742.013977 796.005066,742.002563 796.008789,741.997314 
	C796.155579,741.856140 796.298645,741.720215 796.561890,741.313721 
	C796.823547,740.673889 796.965027,740.304565 797.167969,739.645874 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M610.660889,559.523560 
	C609.513550,562.143066 607.843628,562.448975 605.143555,561.357483 
	C607.720215,559.982666 609.679016,558.431091 609.363281,555.205383 
	C611.678162,556.324402 610.856873,557.857849 610.660889,559.523560 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M777.103760,780.677246 
	C776.474976,776.600830 776.415833,772.380432 779.687195,768.890625 
	C779.986877,769.011902 779.998901,769.001648 779.998230,769.002075 
	C780.340759,770.220520 780.195679,771.370667 779.298462,772.733765 
	C779.045532,773.447327 779.012451,773.873718 778.971252,774.620850 
	C778.566345,775.389343 778.494080,775.953308 778.253662,776.751770 
	C777.938171,778.173706 778.861938,779.621033 777.103760,780.677246 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M788.510010,760.059875 
	C788.062805,762.796936 787.275330,765.610046 786.411743,768.776855 
	C786.097351,769.741821 785.859009,770.353088 785.395264,771.208618 
	C783.704285,767.027039 785.613708,763.495789 788.510010,760.059875 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M618.866211,893.427368 
	C619.258545,893.271179 619.720642,893.524597 620.400757,893.923096 
	C620.788330,898.437073 622.847290,902.633362 621.367554,907.212708 
	C620.557007,902.754089 619.746399,898.295471 618.866211,893.427368 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M614.183716,955.758850 
	C613.548157,956.005981 613.108459,956.004517 612.339294,956.002808 
	C611.257263,956.001587 610.504700,956.000793 609.376099,956.000000 
	C608.789001,952.968811 610.344360,951.796875 613.597961,952.001038 
	C613.992065,952.750000 613.996338,953.500000 614.002747,954.625000 
	C614.129761,955.170105 614.254700,955.340149 614.183716,955.758850 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M641.517883,999.216614 
	C640.926086,999.195068 640.741577,999.161926 640.628418,999.054016 
	C640.427612,998.862427 640.270081,998.625488 640.094421,998.407532 
	C643.144409,997.925354 646.194336,997.443115 649.666748,996.874939 
	C650.523499,996.822388 650.957764,996.855835 651.719116,996.871948 
	C652.162781,997.049561 652.279358,997.244629 652.224854,997.734375 
	C648.821594,999.588440 645.331482,998.867004 641.517883,999.216614 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M723.177734,484.894165 
	C722.150269,482.777740 723.935059,480.925720 723.909180,478.393799 
	C726.481750,478.127289 726.012634,481.716522 728.810181,481.818787 
	C726.632690,482.501373 724.861145,483.298920 723.177734,484.894165 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M598.825745,584.622803 
	C597.598938,584.974304 597.074646,583.923279 596.033203,583.037964 
	C595.267273,579.731995 595.414185,576.587524 596.740234,573.198486 
	C597.147644,576.737244 597.272766,580.591675 598.825745,584.622803 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M839.945557,692.544312 
	C838.571472,692.378479 839.322205,690.371765 837.448608,690.140381 
	C836.950317,689.915649 836.760254,689.678467 836.716187,689.009521 
	C836.727173,687.131348 837.488586,686.089478 838.689941,684.938843 
	C839.894348,685.043579 840.476624,685.753784 841.184937,686.803528 
	C841.324524,687.340332 841.311707,687.568909 841.202332,688.126953 
	C840.756897,689.715820 840.408020,690.975037 839.945557,692.544312 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M659.874878,685.863159 
	C660.055176,685.119934 660.238831,684.759888 660.663696,684.208496 
	C661.819275,685.900330 663.156189,687.699524 663.551270,689.685974 
	C664.182312,692.858887 662.551819,690.765930 661.331177,690.119751 
	C660.810120,690.115662 660.642151,690.254395 660.216370,690.192261 
	C660.530334,688.730164 660.107971,687.490356 659.874878,685.863159 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M725.286499,808.767090 
	C724.966431,808.342163 724.973633,808.079163 724.985596,807.421631 
	C728.369385,807.161438 731.652161,807.652954 734.495789,810.072021 
	C731.535156,809.690979 728.574524,809.309998 725.286499,808.767090 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M752.942261,521.696716 
	C754.270386,522.925293 753.585388,523.635681 752.638245,524.098633 
	C751.726562,524.544250 750.890564,524.039856 750.728394,523.160889 
	C750.448853,521.645752 750.443787,520.080017 750.311035,518.374146 
	C752.680603,518.808472 751.261780,520.993042 752.942261,521.696716 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M730.545166,871.936523 
	C730.962769,875.145508 731.409363,878.363586 730.378723,881.792969 
	C729.776550,881.708496 729.538879,881.404907 729.043579,880.961426 
	C728.249634,878.089661 728.555176,875.339050 728.910217,872.252686 
	C729.572021,871.921997 729.925903,871.932800 730.545166,871.936523 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M638.525513,520.819946 
	C638.423157,523.319885 637.144897,525.480591 635.467651,527.759521 
	C633.032471,524.231628 635.701721,522.586182 638.525513,520.819946 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M646.621460,537.054199 
	C644.593994,536.486450 643.252930,534.252502 640.321045,535.029419 
	C643.237427,531.354614 644.092773,531.578064 646.621460,537.054199 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M630.334351,494.467682 
	C631.156799,494.020294 631.971130,493.816986 632.784119,493.822357 
	C634.186646,493.831573 636.020874,493.374725 636.000122,495.703949 
	C635.974976,498.509247 633.848083,496.655273 632.732178,497.038940 
	C632.305725,497.185577 631.759216,496.982605 630.847900,496.884399 
	C630.394043,496.155121 630.359802,495.480408 630.334351,494.467682 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M619.247192,775.835754 
	C618.942444,776.899109 618.504089,777.610962 618.062256,778.641846 
	C616.621094,779.299744 615.183350,779.638550 613.374146,779.989990 
	C613.002625,780.002563 612.921753,779.922485 612.881348,779.882446 
	C612.547180,779.432617 612.410645,778.972961 612.492798,778.110352 
	C613.453430,776.161011 614.701538,775.011902 616.824585,774.422607 
	C617.976990,774.513428 618.607361,774.889526 619.247192,775.835754 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M709.053833,710.509827 
	C707.066162,707.494385 710.067871,705.011353 710.748657,701.799194 
	C713.401245,705.052002 710.231567,707.393372 709.053833,710.509827 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M625.074219,704.127625 
	C622.661682,705.702881 620.215759,706.868225 617.412781,708.047424 
	C617.055725,708.061279 617.033325,708.036804 617.042236,708.040833 
	C616.415894,707.504883 616.428650,706.846924 616.908264,705.852539 
	C618.362549,704.470459 619.744873,703.640808 621.770508,703.467407 
	C622.820618,703.350464 623.527100,703.178101 624.593506,702.952759 
	C624.982605,703.172485 625.011658,703.445068 625.074219,704.127625 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M664.543152,681.762756 
	C663.917969,679.132385 664.788940,679.978271 666.084229,680.592590 
	C668.957886,681.955505 668.354431,683.723022 666.892761,686.151672 
	C666.076904,684.623718 665.389832,683.337036 664.543152,681.762756 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M812.727661,749.383057 
	C813.471313,749.037598 813.899048,748.992310 814.643372,749.016663 
	C814.992065,750.778503 815.024109,752.470764 815.125977,754.580444 
	C814.951233,756.043457 815.112793,757.305969 813.399048,757.793701 
	C812.044861,757.077393 811.830261,755.935303 811.618774,754.343262 
	C811.664551,752.461731 811.615479,750.990112 812.727661,749.383057 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M717.532959,846.444092 
	C717.899170,846.831055 717.958801,847.171936 718.023926,847.773193 
	C717.985291,848.705261 717.896484,849.366089 717.359985,850.238281 
	C715.915710,851.452515 714.999573,852.800964 713.182251,853.491028 
	C712.626160,853.465942 712.408264,853.402832 711.985474,853.067932 
	C712.230957,851.795471 712.681335,850.794861 713.214844,849.472412 
	C714.461426,848.024597 715.276123,846.400940 717.532959,846.444092 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M716.988037,476.340942 
	C717.827332,472.511780 718.869507,469.011292 720.168945,465.201172 
	C719.990173,468.200256 719.574463,471.511810 719.106628,474.815979 
	C718.956116,475.878326 719.035339,477.303192 716.988037,476.340942 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M703.144043,551.874390 
	C700.484192,551.298096 698.055725,550.891418 695.566895,552.858032 
	C695.002991,546.343567 699.893433,550.950195 702.557861,549.889526 
	C703.179749,550.154175 703.368713,550.280273 703.645508,550.735596 
	C703.798523,551.409729 703.668762,551.648804 703.144043,551.874390 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M633.868408,860.789978 
	C635.277161,861.919434 637.084839,862.643433 636.336670,864.302368 
	C635.745422,865.613525 633.994202,864.810974 632.386108,864.993530 
	C631.020813,864.016296 630.971436,862.903137 631.766663,861.336792 
	C632.025513,860.972229 631.997070,860.998474 631.981873,861.010498 
	C632.417603,860.641418 632.936462,860.483215 633.868408,860.789978 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M747.220947,466.939819 
	C748.819763,468.424591 750.541687,469.684601 749.601318,472.553436 
	C748.626587,470.340790 744.369385,471.973114 745.856201,468.002747 
	C746.324402,467.554047 746.578674,467.204681 747.220947,466.939819 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M596.603088,652.008911 
	C596.555359,653.847412 596.132446,655.702393 595.455688,657.808533 
	C592.376953,655.509766 593.140198,653.569946 596.603088,652.008911 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M748.984009,441.382141 
	C750.556641,441.078308 751.240906,439.726776 752.575317,438.780029 
	C752.984741,440.588898 755.197998,443.153625 750.817871,444.082886 
	C749.260559,443.646240 749.028381,442.744934 748.984009,441.382141 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M656.449890,860.081787 
	C656.087097,858.661987 656.041992,857.535950 657.725586,856.875305 
	C659.698120,858.938416 658.761108,861.430054 659.148254,865.217163 
	C657.924072,862.803345 657.298523,861.569946 656.449890,860.081787 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M623.562866,536.935303 
	C623.569519,539.101624 625.216553,540.753052 625.514893,543.154907 
	C625.516052,543.688110 625.458801,543.847046 625.153259,544.056885 
	C622.846680,542.372253 621.651855,540.117126 621.122437,537.215454 
	C621.932129,536.898132 622.583313,536.922302 623.562866,536.935303 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M799.245300,740.971558 
	C799.337830,739.220093 799.766602,737.479553 800.106323,735.357971 
	C800.017334,734.976990 799.998718,735.000610 799.988281,735.011475 
	C800.382690,734.572754 800.665771,734.006531 801.538208,733.725586 
	C802.191772,735.312378 802.539490,736.885193 802.882751,738.871033 
	C802.324646,739.702759 801.770996,740.121582 801.071289,740.771973 
	C800.477356,740.996582 800.029419,740.989563 799.245300,740.971558 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M680.565247,549.719421 
	C681.025085,550.363586 681.249878,550.739258 681.775818,551.271484 
	C682.041687,551.814758 682.006470,552.201538 681.933411,552.879517 
	C680.269470,554.203552 681.788940,556.462097 679.931030,557.727539 
	C678.307129,555.372498 679.096375,553.088623 679.874573,550.416382 
	C680.048157,549.834106 680.189148,549.642578 680.565247,549.719421 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M781.517944,745.841003 
	C781.822327,746.738403 781.789856,747.597717 781.605591,748.741943 
	C779.087708,749.425964 776.780396,749.059448 774.114563,748.246643 
	C772.838196,746.746033 773.506836,746.172913 774.993530,745.892151 
	C777.226685,744.640625 779.245239,746.737305 781.517944,745.841003 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M531.325073,678.199585 
	C531.085266,674.974365 532.485962,672.517456 534.775513,670.146851 
	C534.695068,671.710144 534.304321,673.445190 533.858826,675.560059 
	C533.895874,676.549561 533.775391,677.105103 533.156189,677.779785 
	C532.494141,678.102051 532.058655,678.235718 531.325073,678.199585 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M666.933533,698.399658 
	C670.805664,698.164917 671.538025,700.455200 670.646851,704.163574 
	C668.458618,703.150757 667.867798,700.856018 666.933533,698.399658 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M703.175415,985.706970 
	C702.912842,986.065247 702.828308,986.349243 702.842407,986.494507 
	C701.556335,986.567810 700.152039,987.353149 698.826660,985.871704 
	C698.752747,984.923035 698.838989,984.272461 698.979858,983.371765 
	C701.599365,981.694824 702.921143,982.726074 703.175415,985.706970 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M721.989502,689.015381 
	C720.564026,688.839294 718.793579,689.552002 718.714233,688.190369 
	C718.601379,686.255493 720.566528,686.973511 721.690430,686.890991 
	C722.793762,686.810059 724.536072,685.595093 724.843750,687.645752 
	C725.084595,689.251099 723.505249,689.058655 721.989502,689.015381 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M663.050171,872.584656 
	C662.568665,873.119873 662.089355,873.236755 661.241943,873.313477 
	C660.823914,873.117249 660.764099,872.963623 660.725525,872.804871 
	C660.229309,870.760681 659.497620,867.578064 661.692688,867.375610 
	C663.976440,867.164917 662.724548,870.430176 663.050171,872.584656 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M723.534119,817.597351 
	C720.016357,816.676758 716.966858,815.823120 713.549683,814.869141 
	C713.165222,814.435852 713.245605,814.128357 713.595337,813.676453 
	C717.084656,814.348572 720.401672,815.190430 724.156738,816.020996 
	C724.397339,816.561218 724.199890,817.112793 723.534119,817.597351 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M643.002319,917.007324 
	C642.804382,918.413940 643.528076,920.258362 642.066833,920.194153 
	C640.284912,920.115906 641.078552,918.141846 641.036438,917.016541 
	C640.994324,915.891785 640.239868,913.942444 642.022034,913.841797 
	C643.509033,913.757812 642.793091,915.604736 643.002319,917.007324 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M710.603882,506.571167 
	C711.675415,505.760529 712.319092,503.756287 713.625977,505.332031 
	C714.295410,506.139282 713.933105,507.657410 712.807068,508.291016 
	C711.393188,509.086548 710.263916,508.929169 710.603882,506.571167 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M638.821411,786.928711 
	C637.627075,790.246887 635.072571,791.129517 631.612427,791.060425 
	C631.047058,790.921631 630.862854,790.769043 630.830566,790.291382 
	C630.982483,789.966309 631.001526,790.003601 630.981079,789.999023 
	C631.734436,789.470337 632.548035,789.009216 633.632263,788.312866 
	C635.420532,787.389709 636.828979,786.408630 638.821411,786.928711 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M567.337769,567.935303 
	C567.487244,565.431824 568.756348,563.293274 570.696106,561.197021 
	C570.999146,563.865356 570.841858,566.605347 567.337769,567.935303 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M812.611206,685.987854 
	C812.956055,687.951233 813.404419,690.123962 810.408936,690.988159 
	C810.958008,689.440002 807.423157,685.889709 812.611206,685.987854 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M813.799194,693.809998 
	C814.119873,695.599365 812.371460,696.047302 812.057617,697.665771 
	C807.656311,698.290161 810.193054,695.358276 810.026733,693.332947 
	C810.853027,693.283325 811.658142,693.604797 812.791321,693.931152 
	C813.285828,693.808105 813.452209,693.680054 813.799194,693.809998 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M820.076172,753.794189 
	C820.546997,753.844727 820.824463,753.876953 821.518738,753.951294 
	C821.953247,755.356812 821.970886,756.720215 822.090698,758.482910 
	C821.050232,758.869934 819.799377,759.124939 819.167358,757.346436 
	C819.093506,756.216187 819.086853,755.424255 819.102417,754.237305 
	C819.386414,753.923523 819.639160,753.901367 820.076172,753.794189 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M812.979126,743.973450 
	C813.102356,740.210388 813.077820,736.486694 812.185974,732.788147 
	C812.788818,732.734192 813.391602,732.680176 813.994385,732.626221 
	C813.994385,736.122742 813.994385,739.619202 813.983276,743.577393 
	C813.830994,744.141602 813.689758,744.244263 813.325684,744.209534 
	C813.102722,744.072205 813.019470,744.007385 812.979126,743.973450 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M738.184692,541.233398 
	C737.890808,540.461304 737.896240,539.925537 737.669617,539.519104 
	C736.925049,538.183838 735.129150,537.180176 736.384399,535.288147 
	C736.483276,535.139038 737.543762,535.318787 737.586060,535.488220 
	C738.079407,537.465698 741.328308,539.120361 738.184692,541.233398 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M723.042725,536.407837 
	C724.245422,536.614380 725.618835,536.833984 725.945068,538.674072 
	C725.315002,539.517761 726.357117,541.002563 724.490723,541.093201 
	C723.750000,541.034729 723.356812,540.952393 722.662354,540.871338 
	C722.553101,539.498901 722.745178,538.125183 723.042725,536.407837 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M710.362183,470.313965 
	C709.915405,471.507538 709.336060,472.584778 708.558594,473.894501 
	C707.192810,472.417542 704.994751,472.635010 703.291809,471.205475 
	C703.079773,470.880951 703.112427,470.865906 703.120117,470.850281 
	C705.180237,470.497040 706.735413,468.033661 709.577515,469.690613 
	C709.964722,469.964661 710.229614,470.197632 710.362183,470.313965 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M700.914673,497.114868 
	C701.205811,498.131683 701.125122,499.140930 701.151123,500.520508 
	C700.244629,500.932007 699.231506,500.973236 697.840942,501.014954 
	C696.871765,500.920288 696.583191,500.573059 696.750549,499.618500 
	C697.719116,497.873901 699.059570,497.370117 700.914673,497.114868 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M557.489136,592.948242 
	C557.169800,590.003845 559.259521,587.852051 560.628540,585.052673 
	C561.279968,588.035706 560.267700,590.726074 557.489136,592.948242 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M739.019531,730.071777 
	C738.333801,728.259583 737.468689,726.429016 739.678223,724.148438 
	C740.931213,726.365479 741.978760,728.042542 739.375610,729.998413 
	C738.963257,729.993286 738.985657,730.060913 739.019531,730.071777 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M654.163452,549.301514 
	C654.280029,548.175293 654.627014,547.320679 655.137146,546.156006 
	C657.032898,546.304810 658.724670,547.564636 658.283630,549.118958 
	C657.792175,550.850891 655.793518,549.915710 654.163452,549.301514 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M704.908875,558.705994 
	C705.542358,556.749084 706.380920,555.044922 707.479614,553.148438 
	C707.959290,552.789307 708.178772,552.622559 708.706238,552.731689 
	C709.091675,555.489502 707.697937,557.296265 705.936401,559.205200 
	C705.465271,559.213379 705.289551,559.086060 704.908875,558.705994 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M781.704956,745.545776 
	C779.919739,747.774963 777.954529,746.688538 775.647095,745.950928 
	C774.590454,744.187744 775.741577,744.044067 776.955566,744.225037 
	C778.503479,744.455750 780.023254,744.874695 781.704956,745.545776 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M693.124512,524.568359 
	C694.726440,527.033142 695.979614,529.447510 697.232788,531.861877 
	C694.676086,530.549194 693.645508,528.321960 692.812256,525.578430 
	C692.766113,524.987671 692.770935,524.752808 693.124512,524.568359 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M769.686829,781.389404 
	C770.116089,783.620544 769.288269,784.925842 767.424438,785.974976 
	C767.103577,784.324646 767.133484,782.618958 767.148315,780.486084 
	C767.133179,780.058838 767.434937,779.966614 767.575500,779.895020 
	C768.962646,779.274536 769.328491,780.160400 769.686829,781.389404 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M825.372986,701.037476 
	C825.753418,698.538208 826.273071,695.922729 828.730042,693.993835 
	C829.028320,694.629578 828.971069,695.331787 828.874268,696.380615 
	C827.791321,698.155823 826.747925,699.584351 825.372986,701.037476 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M468.451782,790.880859 
	C466.283783,788.882812 468.368622,788.343506 469.376770,787.577637 
	C469.988464,787.112915 470.649445,787.611694 470.804901,788.349365 
	C471.142883,789.953491 470.539948,790.906616 468.451782,790.880859 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M661.413452,676.688293 
	C660.054810,674.142273 662.296875,674.383972 663.366699,674.126404 
	C664.193909,673.927246 664.638062,674.844360 664.430359,675.859009 
	C664.036377,677.784058 663.060852,677.782776 661.413452,676.688293 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M773.723389,748.336853 
	C776.112671,747.575195 778.371826,748.171448 781.042786,748.893677 
	C781.449768,749.288452 781.445862,749.550171 781.254211,750.156616 
	C779.317749,750.281616 777.569031,750.061768 775.389526,749.951660 
	C774.204712,749.902527 773.849670,749.383362 773.723389,748.336853 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M766.013672,688.770508 
	C766.309265,687.072388 766.897827,685.526611 768.465149,686.423035 
	C769.672180,687.113342 769.394653,688.882690 768.546570,689.930847 
	C767.343750,691.417603 766.679260,690.096985 766.013672,688.770508 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M611.005737,1008.565796 
	C611.027100,1008.998413 610.919800,1009.036865 610.929749,1009.074158 
	C607.220337,1008.543457 607.166870,1006.714966 609.618347,1004.077515 
	C610.328613,1005.376648 610.656433,1006.754883 611.005737,1008.565796 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M611.077271,575.352905 
	C612.898621,572.686584 611.843750,570.274109 611.166382,567.492249 
	C614.787048,569.930969 613.505859,573.057739 611.743896,576.204407 
	C611.729004,576.231140 611.447266,576.163208 611.349365,576.074219 
	C611.237061,575.972168 611.190857,575.797180 611.077271,575.352905 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M682.196533,830.569580 
	C682.518311,830.214233 682.835388,830.238586 683.367920,830.164185 
	C683.492615,832.047607 684.021484,834.131348 682.342651,836.108948 
	C679.536377,834.430664 682.894165,832.753723 682.196533,830.569580 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M738.839111,713.626038 
	C738.743713,714.045044 738.495850,714.235718 738.181152,714.689697 
	C737.646118,715.309204 737.115356,715.479370 736.318237,715.728516 
	C735.886353,715.887878 735.682373,715.879700 735.173767,715.840820 
	C735.567322,714.627747 733.370972,713.356201 734.781311,712.395264 
	C736.186279,711.437866 737.426819,712.692932 738.839111,713.626038 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M703.474976,670.983032 
	C703.872620,671.829773 703.901428,672.549377 703.954163,673.628784 
	C702.911377,674.064575 701.844727,674.140564 700.388306,674.105957 
	C700.009460,673.174011 700.020325,672.352844 700.051270,671.120239 
	C701.105530,670.290527 702.113403,670.417297 703.474976,670.983032 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M644.421265,951.203979 
	C644.123230,950.512085 644.058472,950.083130 643.976562,949.329224 
	C645.247803,949.004211 646.536133,949.004211 648.634644,949.004211 
	C646.569824,950.788879 646.044800,952.684448 645.203857,954.779297 
	C644.835144,953.818909 644.744873,952.643005 644.421265,951.203979 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M623.291199,948.780945 
	C622.547791,949.006958 622.109924,949.007263 621.344116,949.007446 
	C620.704590,948.406616 620.393127,947.805847 619.972351,946.882446 
	C621.327087,946.331787 622.791077,946.103699 624.628784,945.938110 
	C626.030090,947.675354 625.079407,948.261597 623.291199,948.780945 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M659.864258,690.378784 
	C660.215393,690.011292 660.472534,690.028442 660.854004,690.009888 
	C661.604492,691.679565 662.230835,693.382080 662.968201,695.517456 
	C662.663391,695.971802 662.247681,695.993286 661.519531,696.038574 
	C660.728088,694.297058 660.249023,692.531738 659.864258,690.378784 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M631.664368,817.808472 
	C629.963196,818.161377 628.408325,818.160767 626.465088,818.110596 
	C625.700500,817.761047 625.511169,817.370422 625.665405,816.582275 
	C627.557068,816.168701 629.291870,816.061890 631.461792,815.946472 
	C631.868103,816.443542 631.839355,816.949280 631.664368,817.808472 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M630.710327,789.711792 
	C631.097168,790.134460 631.211792,790.302673 631.278870,790.772522 
	C631.231262,791.074219 631.122131,791.000916 631.087036,791.056519 
	C629.892212,792.684692 629.005005,794.630798 626.258789,794.157715 
	C625.964233,793.603210 625.945923,793.298828 625.865356,792.541199 
	C627.090881,790.757812 628.518555,789.674133 630.710327,789.711792 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M713.461670,864.730469 
	C713.688843,867.334351 712.608276,869.467590 711.406006,871.878296 
	C711.146301,872.111084 711.075012,872.058350 711.040100,872.031006 
	C709.063293,869.550171 709.766785,867.300171 711.889526,864.906616 
	C712.522766,864.640381 712.800232,864.599487 713.461670,864.730469 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M744.861572,845.622314 
	C744.822266,845.992798 744.349182,845.891785 744.131409,845.997009 
	C743.543945,846.134521 743.174194,846.166748 742.527893,846.230225 
	C741.635132,846.528992 741.035034,846.850647 739.998840,846.771484 
	C739.461182,846.611389 739.258179,846.510315 738.834595,846.150513 
	C738.469971,845.454651 738.447266,845.013000 738.790894,844.314636 
	C741.090271,843.903625 743.140076,843.862488 744.861572,845.622314 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M794.354614,745.986572 
	C794.700867,745.963806 794.804321,746.429504 794.829956,746.666138 
	C794.145142,748.160645 793.434753,749.418579 792.511719,750.902466 
	C789.819092,748.403748 791.502441,747.069214 794.354614,745.986572 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M563.037109,575.089111 
	C563.060669,575.125977 563.489746,574.995117 563.713684,574.982544 
	C565.341125,576.926880 566.132629,578.777771 562.720520,579.969482 
	C562.368225,579.977478 562.121033,579.942444 561.997253,579.958374 
	C560.927185,578.319092 562.657043,577.106873 562.840454,575.298706 
	C563.082947,574.998901 563.013611,575.052246 563.037109,575.089111 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M579.194763,580.933411 
	C579.051025,581.598267 579.051392,581.945496 578.921082,582.233459 
	C578.781311,582.542236 578.343689,583.387878 578.184631,582.639771 
	C577.764404,580.663391 577.203003,578.542175 578.867554,576.342590 
	C580.707520,577.749207 579.826355,579.192627 579.194763,580.933411 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M602.902466,543.785095 
	C601.760132,543.860718 600.961426,543.860718 599.359314,543.860718 
	C602.108276,542.427246 604.075134,541.248535 606.661377,541.401794 
	C606.271301,543.609314 604.235657,542.839111 602.902466,543.785095 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M746.424316,537.533325 
	C745.504761,538.855713 744.735535,540.237488 743.250244,539.333130 
	C742.533447,538.896667 742.904236,537.793091 743.470520,537.115051 
	C744.508423,535.872253 745.598206,534.556152 746.424316,537.533325 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M684.559082,504.442413 
	C685.257446,504.334442 685.728943,504.468994 686.446411,504.640869 
	C686.900635,504.750000 687.109070,504.821869 687.485474,505.179565 
	C687.837341,506.129669 687.793030,506.771179 687.237732,507.626556 
	C686.525635,508.202179 686.038086,508.535431 685.248779,508.920685 
	C684.270508,508.980804 683.594971,508.970032 682.610168,508.724884 
	C682.125854,508.442780 681.956909,508.290192 681.690857,507.810303 
	C681.649597,507.262482 681.705505,507.041901 681.990356,506.569702 
	C682.900574,505.743805 683.747070,505.383392 684.559082,504.442413 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M664.835083,510.923401 
	C666.473145,509.828217 668.182922,509.022034 670.097900,510.510803 
	C668.399414,511.095215 666.893127,514.614014 664.835083,510.923401 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M607.497498,547.309692 
	C607.917419,547.704285 607.951782,548.051270 607.975952,548.662476 
	C606.196472,549.104431 604.427246,549.282166 602.213867,549.417114 
	C601.667480,549.093750 601.565247,548.813232 601.628418,548.116455 
	C603.566467,547.554260 605.339233,547.408264 607.497498,547.309692 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M751.960327,823.616211 
	C751.832947,824.215332 751.691406,824.452942 751.434631,824.846924 
	C750.754822,824.976685 750.242188,824.980957 749.345215,824.980225 
	C748.706909,824.741943 748.422424,824.554749 748.042053,824.163452 
	C747.970154,823.551880 747.964294,823.189575 747.948242,822.555664 
	C748.185303,821.721802 748.613037,821.482544 749.583435,821.753235 
	C751.718445,822.609924 750.616150,820.684265 751.522705,820.224243 
	C751.772339,821.105835 751.833313,822.164795 751.960327,823.616211 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M696.609863,499.138641 
	C697.018738,499.655273 697.134155,500.047394 697.356567,500.727478 
	C694.947327,503.198669 694.879517,499.877136 693.300781,499.140350 
	C693.009033,498.548737 693.010132,498.110992 693.050537,497.346741 
	C693.226990,496.902771 693.364075,496.785339 693.645752,496.896790 
	C694.632385,497.755157 695.474426,498.384613 696.609863,499.138641 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M743.068848,812.280029 
	C745.220703,811.619507 746.801941,812.175537 748.924561,813.780884 
	C746.224670,813.904236 744.177002,814.938904 743.068848,812.280029 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M625.726196,793.983154 
	C628.023193,793.935669 629.094543,792.386963 630.719910,791.155701 
	C631.167297,795.016479 628.559631,795.156555 625.305908,794.946777 
	C625.086670,794.634338 625.278320,794.346558 625.726196,793.983154 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M613.342590,525.104370 
	C612.910156,524.651917 612.841064,524.276306 612.776123,523.612793 
	C614.566101,523.054443 616.351990,522.783997 618.137878,522.513550 
	C618.215637,522.800598 618.293396,523.087646 618.371155,523.374634 
	C616.816040,523.976868 615.260986,524.579041 613.342590,525.104370 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M631.687012,861.021301 
	C632.025391,862.043335 632.025269,863.114441 632.015015,864.586792 
	C632.004822,864.988098 631.996399,864.998352 631.991882,865.001221 
	C631.615540,865.345642 631.178162,865.539185 630.321655,865.477539 
	C629.711792,865.085205 629.455505,864.799927 629.062988,864.259949 
	C629.159058,862.552551 629.757446,861.401917 631.687012,861.021301 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M840.999878,686.580444 
	C839.710266,686.757629 839.154175,686.303345 838.990540,685.062012 
	C838.876648,683.379944 839.315430,682.203491 840.555664,681.036865 
	C841.320129,681.169861 841.653687,681.616760 841.879883,682.610596 
	C841.998474,684.187317 841.908142,685.313599 840.999878,686.580444 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M728.812073,455.890900 
	C728.907104,456.708313 728.930664,457.133820 729.053101,457.864746 
	C729.151978,458.170197 729.089661,458.130646 729.070801,458.098938 
	C728.685608,458.305054 728.285828,458.451782 727.545166,458.607849 
	C727.049072,458.725037 726.860229,458.741394 726.389038,458.731323 
	C725.852600,458.165253 725.598572,457.625671 725.067017,456.934875 
	C724.270691,455.511353 724.854309,454.785706 726.399292,454.301636 
	C727.635742,454.374969 728.286255,454.782654 728.812073,455.890900 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M677.473145,709.967285 
	C676.850769,709.901001 676.518799,709.631470 676.011292,709.091614 
	C676.171631,708.368591 676.507507,707.915955 676.951111,707.199829 
	C677.058838,706.936279 676.999207,706.976807 676.975708,707.003784 
	C678.023376,706.907349 679.094421,706.783813 680.573242,706.655273 
	C680.957886,707.014404 680.934692,707.378662 680.901611,708.016541 
	C679.848938,708.781494 678.806213,709.272766 677.473145,709.967285 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M734.981323,720.260437 
	C735.130554,719.940796 735.576355,719.951416 735.797119,719.982727 
	C735.907654,720.632996 735.962769,721.357605 735.649963,721.847046 
	C735.130493,722.659363 735.262146,724.291382 733.517090,723.828979 
	C732.795776,723.637756 732.416382,723.146790 732.417542,722.466309 
	C732.420288,720.861511 734.045532,721.239258 734.981323,720.260437 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M743.145508,497.186523 
	C744.009277,498.616119 744.564514,499.751740 743.709290,501.320160 
	C741.816711,500.122101 742.167297,497.998260 741.546143,496.361755 
	C741.375977,495.913330 741.814392,495.343109 742.398132,495.681885 
	C742.736572,495.878296 742.857056,496.450226 743.145508,497.186523 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M587.836792,573.500977 
	C584.870239,572.442200 587.105164,571.578796 587.790344,570.768250 
	C588.346252,570.110718 589.364258,569.946472 589.721741,570.895569 
	C590.210510,572.193176 589.283997,572.936768 587.836792,573.500977 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M727.309204,885.802185 
	C725.195129,886.536194 725.046570,883.803040 722.910583,884.022339 
	C723.490356,882.899719 724.469604,881.842346 726.489746,882.147705 
	C727.506958,882.653442 727.706665,883.359192 727.842407,884.459534 
	C727.735046,885.063904 727.648987,885.296692 727.309204,885.802185 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M778.375488,740.072998 
	C778.248047,739.364014 778.417419,738.834717 778.815857,738.131531 
	C779.951477,738.840698 782.366455,738.681274 781.596558,740.597229 
	C781.153625,741.699585 779.631287,740.832336 778.375488,740.072998 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M750.963135,447.380371 
	C751.651917,449.770599 753.874939,452.272034 752.414062,455.700867 
	C751.516541,453.259399 750.696472,450.610016 750.963135,447.380371 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M803.889282,762.833862 
	C802.307373,760.281982 803.371216,757.053528 803.138184,753.492126 
	C804.787903,756.045898 803.684265,759.259827 803.889282,762.833862 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M639.261475,787.160767 
	C637.235046,786.863098 636.054932,788.226562 634.252197,788.833374 
	C633.602783,788.728394 633.298462,788.561340 632.938843,788.130249 
	C634.023193,786.569824 635.613098,786.268372 637.547485,785.936401 
	C638.482422,786.094910 639.071716,786.280945 639.825684,786.729980 
	C639.990417,786.992981 639.501526,787.092834 639.261475,787.160767 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M805.009033,701.347534 
	C806.944763,701.364563 808.860046,701.717102 808.996338,704.618164 
	C807.379395,705.241455 806.949707,703.383545 805.312073,703.027832 
	C804.987366,702.536133 804.992554,702.103943 805.009033,701.347534 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M803.507446,706.985229 
	C803.863220,708.052795 803.889099,709.137573 803.846313,710.624390 
	C802.176880,710.785156 801.537598,709.585266 801.392334,708.231079 
	C801.272278,707.112183 802.371277,707.123718 803.507446,706.985229 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M783.371460,712.092712 
	C783.070068,709.899536 784.422241,709.091248 786.674011,708.935303 
	C786.948975,711.146973 785.484863,711.798950 783.371460,712.092712 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M680.326294,956.124939 
	C679.968445,955.839600 679.957153,955.663208 679.989868,955.225342 
	C681.996704,954.693787 683.919006,954.563721 685.340637,956.454834 
	C683.655884,957.697083 682.172729,956.807190 680.326294,956.124939 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M815.105225,719.377197 
	C815.894531,718.907776 816.769653,718.836670 818.302673,718.711060 
	C819.485657,719.187927 820.010864,719.719238 820.638489,720.463623 
	C818.827148,720.769287 816.741089,721.922913 815.105225,719.377197 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M686.771790,504.761292 
	C687.535950,504.114594 688.379578,503.551025 689.528198,502.939636 
	C690.522522,503.333710 690.880005,503.987854 691.056335,505.155762 
	C690.590271,506.002991 690.102417,506.466125 689.354492,506.990662 
	C688.161987,506.923370 687.790100,506.190125 687.203796,505.245148 
	C687.009949,505.011169 686.851318,504.844452 686.771790,504.761292 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M750.611328,836.865601 
	C752.369080,838.882507 751.979797,840.189941 749.062866,840.204102 
	C749.030029,838.830872 748.843140,837.522400 750.611328,836.865601 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M604.608887,801.020508 
	C605.673096,802.557068 607.084900,801.719238 608.564819,802.005249 
	C606.740417,802.978271 604.503967,803.314148 602.115112,802.799500 
	C602.344910,801.509888 603.558899,801.564514 604.608887,801.020508 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M619.313965,875.988770 
	C619.000122,876.046692 619.023254,875.550903 618.999268,875.304199 
	C619.177368,874.080017 618.585754,872.592285 620.187073,872.453430 
	C621.235779,872.362427 621.697754,873.373596 621.966370,874.677734 
	C621.213440,875.322449 620.420593,875.626648 619.313965,875.988770 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M623.245422,866.780823 
	C621.404968,864.815735 622.725830,863.306946 624.594727,861.957031 
	C624.897156,863.704346 624.509460,865.229492 623.245422,866.780823 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M682.851807,525.768921 
	C682.744385,526.225403 682.523132,526.269958 682.413208,526.292236 
	C681.922424,523.404236 681.770996,520.497009 682.704285,517.312256 
	C682.978516,519.786804 682.968872,522.549622 682.851807,525.768921 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M728.773071,871.956238 
	C729.085449,874.587830 728.952820,877.264526 728.803101,880.381348 
	C727.677185,877.931091 727.486755,874.992981 728.773071,871.956238 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M693.908325,496.762573 
	C693.790405,497.125671 693.434753,497.106323 693.262329,497.063293 
	C691.399841,496.012177 692.345825,494.759766 692.916931,493.252930 
	C693.403320,492.904633 693.741455,492.859253 694.333740,492.772949 
	C695.075684,494.057892 694.381958,495.202820 693.908325,496.762573 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M705.405518,986.839600 
	C704.843201,985.178223 704.989685,983.821899 707.558167,984.100952 
	C708.073120,985.731750 707.731873,986.944946 705.405518,986.839600 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M571.379272,560.935608 
	C571.152161,559.107300 572.120728,557.651123 573.683228,556.225952 
	C574.013794,558.073975 573.683655,559.866028 571.379272,560.935608 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M714.035706,544.169434 
	C714.800842,542.815308 715.674133,542.611145 716.466736,543.527405 
	C717.362793,544.563110 716.578369,545.317322 715.708191,545.783020 
	C714.462769,546.449585 713.993713,545.756836 714.035706,544.169434 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M704.333130,480.991211 
	C704.355286,481.882446 704.034424,482.784302 703.498962,483.878723 
	C702.401733,483.899506 701.201233,483.906952 701.454529,482.590576 
	C701.693970,481.346222 702.844604,481.062103 704.333130,480.991211 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M791.035278,723.771790 
	C792.378357,722.447937 794.115173,721.859924 797.284851,722.054138 
	C794.795166,723.671631 793.219238,724.308105 791.035278,723.771790 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M481.278687,787.159241 
	C481.034119,786.551025 481.013763,786.130798 480.970520,785.396301 
	C481.363159,785.035889 481.778748,784.989624 482.503662,784.909302 
	C483.193085,786.003784 483.573151,787.132263 483.953247,788.620789 
	C483.806396,789.119507 483.659485,789.258240 483.237823,789.269043 
	C482.476349,788.543152 481.989624,787.945129 481.278687,787.159241 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M779.412170,773.006104 
	C778.941162,771.829773 779.013794,770.677795 779.852173,769.321777 
	C780.802917,770.388245 783.566345,771.897644 779.412170,773.006104 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M748.504150,827.620850 
	C748.167603,829.554871 746.960327,829.053162 745.953735,828.663574 
	C745.186829,828.366760 745.279297,827.621399 745.775574,827.090454 
	C746.705811,826.095215 747.520508,826.933167 748.504150,827.620850 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M660.581665,697.134155 
	C661.014709,697.535156 661.003906,698.033752 660.803406,698.707397 
	C660.192688,698.648071 659.744141,698.451843 659.355835,698.172119 
	C658.243042,697.370300 656.299377,698.906250 655.687439,696.879150 
	C655.605408,696.607483 655.997742,696.077637 656.301086,695.823181 
	C658.366028,694.090759 658.716736,697.130615 660.581665,697.134155 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M621.119812,798.036560 
	C621.972839,796.979492 623.148926,796.063232 624.623596,795.022095 
	C624.875000,797.170776 624.965332,799.590210 621.119812,798.036560 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M789.452637,717.013123 
	C790.568481,715.344360 792.295166,714.453857 794.797791,715.707397 
	C793.438110,716.983704 791.658142,717.091675 789.452637,717.013123 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M724.875977,813.280029 
	C724.890991,812.493774 724.911316,812.106873 724.863892,811.429993 
	C727.872192,811.564941 727.191284,813.161194 725.673096,815.058167 
	C725.207336,814.687988 725.044373,814.183716 724.875977,813.280029 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M424.280151,841.567627 
	C421.615387,842.207947 420.678619,841.048889 420.993835,838.349121 
	C421.139587,837.865356 421.288147,837.778564 421.693115,837.662842 
	C422.780212,837.987488 423.000671,838.853271 423.715637,839.704834 
	C423.929352,839.926331 424.010406,840.010620 424.051361,840.052368 
	C424.372345,840.367920 424.527039,840.700256 424.280151,841.567627 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M435.066833,821.632019 
	C435.954773,821.028931 436.693817,820.637695 437.730530,820.146667 
	C438.216003,822.559753 436.779938,823.189819 434.222626,822.955566 
	C434.187561,822.566223 434.552734,822.205078 435.066833,821.632019 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M628.393311,525.609619 
	C629.868835,524.754272 630.415833,525.327515 630.235779,526.579285 
	C630.134644,527.282471 630.027283,528.383728 628.846680,527.988831 
	C627.847351,527.654724 628.162170,526.697021 628.393311,525.609619 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M705.192932,530.400269 
	C704.083923,529.833679 703.663025,529.244751 704.593018,528.550537 
	C705.368042,527.971985 706.168823,528.271118 706.574463,529.025574 
	C707.129456,530.057739 706.355530,530.362610 705.192932,530.400269 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M681.737000,507.753235 
	C682.954956,507.770447 683.874146,507.619934 684.828491,508.639465 
	C683.807434,509.678070 682.667664,511.081879 681.485596,508.632721 
	C681.442749,508.293304 681.293274,508.134827 681.187744,508.161743 
	C681.204834,507.948578 681.327393,507.708466 681.737000,507.753235 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M704.060913,546.002380 
	C704.464539,545.431946 704.920593,545.250610 705.636780,545.107544 
	C706.307312,545.850037 706.717773,546.554199 707.161133,547.563538 
	C705.897888,547.937866 704.497925,548.223450 704.060913,546.002380 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M601.239990,549.244385 
	C599.773010,550.120117 598.020569,550.872620 597.666565,549.037354 
	C597.433044,547.826294 599.179932,547.873352 600.656494,548.057007 
	C601.148743,548.297302 601.281372,548.564636 601.239990,549.244385 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M656.938660,852.670959 
	C654.963257,852.879028 654.265015,851.808289 655.034363,849.448792 
	C657.738403,849.078125 656.738953,850.977600 656.938660,852.670959 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M738.445679,720.899475 
	C739.197876,720.825684 739.676880,720.887390 740.515747,720.997559 
	C741.339050,722.450745 740.848572,723.393188 739.362793,723.282654 
	C738.116760,723.189941 737.104187,722.556824 738.445679,720.899475 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M822.460571,731.820312 
	C822.290771,732.083008 822.081177,732.343262 821.843506,732.574707 
	C820.988953,733.406982 820.106567,734.329773 818.912476,733.139343 
	C818.620972,732.848694 818.354553,732.069275 818.517761,731.862122 
	C819.503784,730.610535 820.617981,732.136169 822.047852,731.761719 
	C822.406433,731.694946 822.408020,731.804688 822.460571,731.820312 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M603.848389,658.932617 
	C603.961975,660.061157 603.934692,661.112671 603.838623,662.553345 
	C601.569153,663.823730 601.460144,662.464233 601.742920,660.500610 
	C602.215332,659.776672 602.505493,659.432190 603.097656,658.925659 
	C603.399597,658.763611 603.707397,658.855591 603.848389,658.932617 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M639.177002,955.369263 
	C638.765930,954.598633 638.487671,954.081909 638.072876,953.303955 
	C638.701477,953.027344 639.466553,953.011841 640.613342,952.998169 
	C640.269653,953.769226 642.486877,956.429016 639.177002,955.369263 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M605.912231,526.132874 
	C607.263000,524.908875 608.933044,525.033325 610.998596,525.279053 
	C611.202026,526.389954 610.435913,526.719727 609.312927,527.006531 
	C608.390625,526.992676 607.782349,526.977600 606.882751,526.815186 
	C606.414612,526.618774 606.241394,526.508545 605.912231,526.132874 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M808.850342,717.935303 
	C808.915955,719.952759 808.800598,721.590149 806.198608,720.253906 
	C805.816345,719.829834 805.639954,719.654175 805.741577,719.229309 
	C806.019592,718.980042 805.998596,719.000427 805.986450,719.008606 
	C806.418884,718.586121 807.015991,718.527222 807.794067,718.175598 
	C808.018494,717.988892 808.000305,717.999817 807.991150,718.004883 
	C808.212952,717.860596 808.443909,717.711304 808.850342,717.935303 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M660.938477,859.842651 
	C662.131287,858.817139 662.525696,859.351440 662.376038,860.352539 
	C662.269470,861.065186 662.053467,862.141724 660.965820,861.764282 
	C660.265442,861.521179 660.600769,860.704529 660.938477,859.842651 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M626.022644,550.833618 
	C625.585449,547.982788 627.159729,548.618713 628.896484,549.434082 
	C628.616394,550.970276 627.542236,551.033142 626.022644,550.833618 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M769.985901,781.630066 
	C769.200134,781.174988 768.724670,780.611206 767.982666,779.935425 
	C767.716064,779.823425 767.698547,779.424255 767.758179,779.233582 
	C768.545593,779.047668 769.273376,779.052429 770.362854,779.069946 
	C770.843079,779.941467 771.114441,780.827087 769.985901,781.630066 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M749.335022,446.714783 
	C749.016907,447.907898 749.559509,449.061462 748.263672,449.489624 
	C748.014221,449.572052 747.523499,449.481842 747.399902,449.298706 
	C746.502991,447.969177 747.910400,447.327881 748.612549,446.217285 
	C749.094543,446.167084 749.298401,446.285248 749.335022,446.714783 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M718.568298,535.471191 
	C717.830566,536.537354 717.124084,536.691101 716.516235,535.817017 
	C716.103699,535.223694 716.229614,534.494019 716.933655,534.216736 
	C717.779846,533.883484 718.518372,534.099792 718.568298,535.471191 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M504.724335,793.075378 
	C505.360504,793.817871 505.642578,794.590149 506.049255,795.657471 
	C505.101379,795.890503 503.807953,796.313782 503.290863,794.890381 
	C502.950806,793.954285 503.508942,793.398987 504.724335,793.075378 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M510.824463,791.796631 
	C510.131348,793.129211 508.873962,792.901489 507.347687,792.903748 
	C507.900299,791.534424 508.908569,790.526855 510.824463,791.796631 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M608.656616,956.005005 
	C608.932129,957.297791 608.261841,958.074219 606.976135,958.271362 
	C606.325073,958.371216 606.137085,957.908020 606.188232,957.400269 
	C606.319641,956.095764 607.349548,956.086426 608.656616,956.005005 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M841.437134,683.190430 
	C841.086731,682.624023 841.035400,682.112976 840.903381,681.223511 
	C840.822693,680.845215 840.932007,680.432861 840.989014,680.227295 
	C841.267700,679.800781 841.469788,679.563232 841.714905,679.083740 
	C841.777527,678.858398 841.897217,678.432617 841.971924,678.224487 
	C842.216187,677.843018 842.385620,677.669556 842.812744,677.752808 
	C843.051514,679.121094 843.032593,680.232605 843.119263,681.749573 
	C843.224792,682.154968 843.136536,682.135254 843.112427,682.096985 
	C842.611389,682.424500 842.325317,683.007690 841.437134,683.190430 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M747.462769,466.560181 
	C747.248596,467.218018 746.950378,467.455902 746.397949,467.824829 
	C745.884033,465.760254 745.222351,463.546997 746.259216,461.138580 
	C747.599487,462.820312 746.737915,464.630798 747.462769,466.560181 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M683.008667,683.855957 
	C683.176208,682.373169 683.517395,681.325378 684.578064,680.562744 
	C685.736084,682.289856 684.930664,683.521301 683.672363,684.646118 
	C683.616577,684.695984 683.417664,684.654419 683.335999,684.590698 
	C683.213135,684.494812 683.134888,684.341736 683.008667,683.855957 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M612.061768,643.643799 
	C611.168701,644.324097 610.281860,644.663757 609.054993,644.870056 
	C609.661560,643.858765 609.704773,640.867493 612.061768,643.643799 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M776.115540,644.971741 
	C775.789490,646.456116 775.268127,647.630371 774.504883,649.019287 
	C774.262939,649.234009 774.108948,649.097595 774.031250,649.030151 
	C773.144043,648.210754 772.992065,647.266541 773.278442,645.878906 
	C773.677917,645.106628 774.039612,644.782227 774.852905,644.505737 
	C775.451294,644.524353 775.685791,644.592957 776.115540,644.971741 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M718.474548,785.765076 
	C718.333130,783.459351 720.089050,784.120056 721.436462,784.065063 
	C721.917236,784.045471 722.383850,784.334412 721.880432,784.820251 
	C721.572632,785.117371 720.984375,785.123901 720.319336,785.446533 
	C719.678528,785.674255 719.240601,785.716370 718.474548,785.765076 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M565.328125,572.830200 
	C564.808044,571.255005 565.743591,569.842102 566.659668,568.159912 
	C567.000732,569.677490 567.320740,571.450134 565.328125,572.830200 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M688.498108,687.129883 
	C688.973389,688.711609 688.134644,689.564392 686.420776,690.036011 
	C686.107483,690.108765 685.995667,689.996826 685.937622,689.940308 
	C686.079041,688.556519 686.588013,687.464844 688.498108,687.129883 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M795.217407,698.177979 
	C794.585693,699.572632 793.786377,700.834290 792.729431,702.280762 
	C792.345642,702.349731 792.219421,702.234009 791.905334,701.943237 
	C791.528564,701.357239 791.495178,700.931519 791.805420,700.237732 
	C792.014587,699.982483 792.000000,700.000061 791.993530,700.009583 
	C792.634094,699.218933 793.076660,698.227478 794.402832,697.773865 
	C794.715454,697.777649 795.049805,698.044922 795.217407,698.177979 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M767.608337,549.978149 
	C766.011353,551.623718 763.773804,550.970093 761.271973,550.467529 
	C763.039734,550.120178 765.106873,549.996765 767.608337,549.978149 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M784.652954,724.957703 
	C783.574402,726.406982 782.216187,726.787292 781.023499,724.361328 
	C782.083130,724.306702 783.186218,724.592651 784.652954,724.957703 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M423.951172,839.561279 
	C422.867493,839.914429 422.140656,839.494324 421.979065,837.991821 
	C422.444214,837.421570 422.938904,837.209167 423.715393,836.996338 
	C423.989136,837.729370 423.981079,838.462830 423.951172,839.561279 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M738.593872,844.029663 
	C738.996155,844.490906 738.975647,844.918701 738.977112,845.667114 
	C737.425781,846.799438 735.990540,846.370972 734.304321,845.254150 
	C734.004028,845.009399 733.909485,844.758789 733.845276,844.640869 
	C733.781067,844.523010 733.762329,844.249756 733.862793,844.156616 
	C735.365906,844.041138 736.768494,844.018738 738.593872,844.029663 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M836.637512,688.682983 
	C836.898804,688.841675 836.935425,689.105530 837.056152,689.761047 
	C837.016907,691.186279 836.561584,692.022888 835.415527,692.733765 
	C835.125549,692.253967 835.103088,691.648743 835.113403,690.738586 
	C835.186218,690.049622 835.337280,689.715759 835.782104,689.216614 
	C835.964783,689.001038 836.412903,688.788269 836.637512,688.682983 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M696.086792,654.127319 
	C696.319031,653.823792 696.494446,653.874451 696.931885,654.009399 
	C697.995667,654.869141 698.431458,656.051880 697.262207,656.415833 
	C695.825928,656.862976 696.140625,655.352112 696.086792,654.127319 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M731.108521,458.479553 
	C731.260620,457.224426 731.712891,455.960663 732.989075,456.252167 
	C734.050476,456.494629 733.061951,457.524445 733.063232,458.491394 
	C732.453430,458.750641 731.880127,458.718536 731.108521,458.479553 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M776.442261,640.936523 
	C777.091187,640.897705 777.347656,640.929199 777.986084,641.030640 
	C777.830139,642.327881 777.292236,643.555054 776.532593,645.032043 
	C776.310791,645.281860 775.954041,644.953247 775.776123,644.788452 
	C774.855713,643.306641 774.924561,642.090820 776.442261,640.936523 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M727.678589,885.387756 
	C727.274597,884.447815 727.160767,883.692444 726.945618,882.567139 
	C727.370361,882.380920 727.896362,882.564636 728.696167,882.857422 
	C729.230530,883.481750 729.491028,883.996887 729.814941,884.804199 
	C729.322388,885.578003 728.684265,885.730652 727.678589,885.387756 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M843.139587,677.669373 
	C842.899658,678.013855 842.728943,678.018250 842.302490,678.019531 
	C842.098145,676.622192 841.632141,675.069336 843.574707,674.066528 
	C843.681030,675.098511 843.444885,676.213867 843.139587,677.669373 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M573.218567,659.726318 
	C572.844360,660.790283 572.688660,661.570435 572.533020,662.350586 
	C572.152222,662.247070 571.771423,662.143555 571.390625,662.040039 
	C571.733459,661.151367 572.076294,660.262634 572.662109,659.168396 
	C573.082397,659.122742 573.259766,659.282654 573.218567,659.726318 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M753.981445,466.968750 
	C754.499634,467.435516 754.693970,467.949402 754.846069,468.746826 
	C753.963562,468.902283 752.853821,469.208252 752.528198,468.110443 
	C752.313904,467.388000 753.087708,467.194275 753.981445,466.968750 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M719.200806,484.838196 
	C718.114563,483.778656 719.267883,483.344513 719.862061,482.326294 
	C720.454651,481.663940 720.920837,481.326660 721.664307,480.904846 
	C721.937683,482.619843 720.824829,483.737000 719.200806,484.838196 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M602.009277,636.324402 
	C602.630798,636.356812 603.500000,636.616272 603.551270,636.988403 
	C603.709167,638.133362 602.822449,638.615417 601.510620,638.892090 
	C601.430603,638.158142 601.656738,637.380615 602.009277,636.324402 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M763.382385,827.013000 
	C762.718811,826.336243 761.505554,825.665039 763.310791,824.885010 
	C764.289917,825.136963 765.185425,825.393616 765.206604,826.311768 
	C765.211670,826.532898 764.224731,826.776855 763.382385,827.013000 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M707.728882,1002.181763 
	C707.847046,1001.823669 707.892151,1001.407715 707.942505,1001.204712 
	C708.671814,1000.995789 709.350708,1000.989868 710.368164,1000.977417 
	C710.764404,1001.428772 710.822266,1001.886658 710.804871,1002.685059 
	C710.087524,1003.023621 709.445435,1003.021667 708.482300,1003.037537 
	C707.977783,1002.883484 707.794189,1002.711670 707.728882,1002.181763 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M744.994263,527.724609 
	C744.908264,528.379883 744.824829,528.688110 744.741333,528.996399 
	C744.544922,528.942810 744.178650,528.893616 744.177124,528.834900 
	C744.144348,527.559448 744.152100,526.282898 744.152100,524.809082 
	C745.414978,525.565552 744.802612,526.581970 744.994263,527.724609 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M641.281616,520.758911 
	C640.484009,520.976990 639.987915,520.966248 639.120911,520.889282 
	C639.027405,520.268799 639.304810,519.714661 639.781006,518.907715 
	C640.497925,518.771851 641.016174,518.888794 641.830322,519.282349 
	C642.126282,519.559021 642.063049,519.496216 642.038269,519.459167 
	C642.114990,519.697998 642.216553,519.973816 642.173950,520.666260 
	C642.029907,521.082886 642.061096,521.003479 642.097290,521.026611 
	C641.950073,520.876587 641.766602,520.703369 641.281616,520.758911 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M750.772705,776.191223 
	C751.779602,776.253601 752.450806,776.527710 752.250549,777.310669 
	C752.077148,777.988770 751.374817,778.204956 750.708252,778.011047 
	C749.448425,777.644592 749.911072,776.941467 750.772705,776.191223 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M717.479858,538.454346 
	C718.078735,539.582947 717.979797,540.342712 716.879639,540.433350 
	C716.577576,540.458130 716.016724,539.955017 715.941101,539.613037 
	C715.735474,538.684265 716.071960,538.035095 717.479858,538.454346 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M606.623291,526.238708 
	C607.467529,526.179504 608.061096,526.332886 608.826660,526.748779 
	C608.002563,527.452148 607.006409,527.892944 605.690308,528.409912 
	C605.370422,528.486145 605.188904,528.242920 605.095581,528.123230 
	C604.485718,526.626892 605.565063,526.659058 606.623291,526.238708 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M469.197174,784.200378 
	C469.667114,783.455627 470.365326,782.983276 471.372559,782.423584 
	C471.929291,784.104187 471.716980,785.386353 469.197174,784.200378 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M708.954956,549.260132 
	C711.199036,549.566650 711.361938,550.584229 709.676208,552.006226 
	C708.193115,551.531189 708.593811,550.498718 708.954956,549.260132 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M704.287842,495.168640 
	C704.287109,493.972595 703.333191,491.790894 705.908508,493.320190 
	C706.127258,493.835205 706.278381,494.071198 706.163208,494.632385 
	C705.896912,494.957642 705.977844,494.957550 705.971680,494.917542 
	C705.616150,495.335480 705.157227,495.518433 704.287842,495.168640 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M688.439453,832.805298 
	C689.088989,832.628967 689.386292,832.716492 689.831543,833.076050 
	C689.825317,834.281738 689.356201,835.164612 688.144653,834.716370 
	C686.985046,834.287292 687.477539,833.555908 688.439453,832.805298 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M703.328674,807.089600 
	C703.638245,806.139954 701.898560,803.501221 705.109009,804.644470 
	C704.898987,805.841553 704.858765,806.901306 703.328674,807.089600 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M712.354736,469.963928 
	C712.070740,469.900085 712.013123,469.695923 711.974487,469.173340 
	C711.970764,467.780884 712.354614,466.678436 713.466003,466.805725 
	C714.192261,466.888885 713.567749,467.891785 713.343018,468.751404 
	C713.054871,469.292755 712.817993,469.558167 712.354736,469.963928 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M713.977234,864.598511 
	C713.845581,864.902405 713.526917,864.901062 713.369019,864.921997 
	C712.444519,864.500488 712.235046,863.784729 712.330017,862.580322 
	C712.799988,861.449829 713.410217,860.999451 714.598999,860.894287 
	C714.981140,860.986389 715.108093,861.099670 715.172363,861.155640 
	C714.860718,862.239258 714.484802,863.266907 713.977234,864.598511 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M529.347168,681.366333 
	C528.901733,680.192688 529.373291,679.112305 530.687378,678.132324 
	C531.634949,679.518677 531.060425,680.531738 529.347168,681.366333 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M686.960571,505.367401 
	C688.072510,504.921936 688.412964,505.770538 688.988037,506.752228 
	C688.601868,507.361877 688.109497,507.671722 687.315125,507.925232 
	C686.979187,507.153809 686.945190,506.438721 686.960571,505.367401 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M696.287354,779.909424 
	C696.015747,779.616760 696.020447,779.181763 695.973450,778.427063 
	C695.965149,777.936035 696.008606,777.764771 696.080566,777.329956 
	C696.222961,776.922913 696.336853,776.779358 696.695679,776.760742 
	C698.472229,778.062866 697.499817,778.912659 696.287354,779.909424 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M693.369873,987.934692 
	C693.275818,987.123230 692.442200,985.941345 693.708191,985.704651 
	C694.004578,985.649170 694.526062,986.797485 695.006348,987.709229 
	C694.614380,988.017212 694.160034,988.008057 693.369873,987.934692 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M694.792786,480.085144 
	C693.724487,479.085052 693.990295,477.404083 693.936035,475.389465 
	C694.003174,474.987488 694.479431,475.001617 694.717102,475.006897 
	C694.929016,476.549713 694.903259,478.087280 694.792786,480.085144 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M725.029297,709.677551 
	C724.030151,709.664062 723.372681,709.047607 723.459595,707.983459 
	C723.475220,707.792358 723.870178,707.459290 724.051636,707.483154 
	C725.082336,707.618835 725.006897,708.515259 725.029297,709.677551 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M780.735535,708.959717 
	C780.929321,710.166809 780.933777,711.409058 779.017944,711.130615 
	C779.025024,710.357666 779.230774,709.787354 779.676392,709.025391 
	C780.097717,708.865601 780.279236,708.897583 780.735535,708.959717 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M754.356079,517.274170 
	C753.944641,516.458984 753.816650,515.787537 754.567139,515.561035 
	C754.778381,515.497314 755.361816,516.083679 755.494812,516.468506 
	C755.749207,517.204834 755.428284,517.656250 754.356079,517.274170 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M639.995361,515.311035 
	C640.234192,514.984436 640.397034,515.063538 640.826416,515.090881 
	C642.618652,516.294922 641.336426,517.048523 640.313354,518.052917 
	C640.002930,517.378479 639.961182,516.547546 639.995361,515.311035 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M691.390381,505.351013 
	C690.699280,504.911652 690.320496,504.283447 689.887451,503.273499 
	C690.341064,501.952209 690.822510,502.390411 691.535400,502.996155 
	C691.746643,503.768951 691.724670,504.465576 691.390381,505.351013 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M745.368042,683.535522 
	C744.814880,683.084900 744.244385,682.691040 744.869141,682.302124 
	C745.455017,681.937439 746.216370,682.075378 746.472900,682.809387 
	C746.676575,683.392151 746.188354,683.651978 745.368042,683.535522 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M801.875671,733.388306 
	C801.425110,734.178833 801.006165,734.618164 800.282471,735.039917 
	C799.765747,733.440002 800.764771,732.369690 801.913086,731.079712 
	C802.130676,731.636475 802.019043,732.336853 801.875671,733.388306 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M755.466309,724.762207 
	C755.094604,724.132568 754.996399,723.399780 754.983398,722.306763 
	C755.743347,722.346008 756.418091,722.745605 757.168213,723.442993 
	C756.742371,724.046936 756.241150,724.353027 755.466309,724.762207 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M662.194458,556.583374 
	C661.747742,557.187866 661.437439,557.441833 660.908875,557.903076 
	C659.847961,557.567566 659.993347,556.658447 659.862915,555.539185 
	C660.954285,554.919189 661.843872,555.085449 662.194458,556.583374 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M745.418091,839.828430 
	C745.158325,839.232178 745.159546,838.483826 745.094482,837.365967 
	C747.402466,837.365662 747.001587,838.408997 745.418091,839.828430 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M780.271484,755.823364 
	C779.001099,756.038879 777.908936,755.867310 777.692383,754.524719 
	C777.683777,754.471558 778.770203,754.241821 779.663330,754.049316 
	C780.134827,754.493652 780.289368,754.983032 780.271484,755.823364 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M779.893188,716.037598 
	C780.109497,715.079956 780.733154,714.123474 781.697876,713.099304 
	C782.655579,714.725586 781.745972,715.537048 779.893188,716.037598 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M709.204712,548.706177 
	C709.260193,549.721863 709.217529,550.510925 709.278625,551.683105 
	C709.319702,552.222656 709.257080,552.379028 709.104309,552.771484 
	C708.801208,553.012573 708.588257,553.017700 708.057617,552.989380 
	C707.772583,551.584167 707.805298,550.212341 707.872192,548.429688 
	C707.906433,548.018921 708.401489,548.047241 708.649292,548.039612 
	C708.897156,548.031982 709.106567,548.479431 709.204712,548.706177 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M832.542236,687.978455 
	C832.369751,687.474426 832.458252,686.914673 832.776123,686.176636 
	C833.970093,686.748352 833.944946,687.394226 832.542236,687.978455 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M691.809204,683.005493 
	C691.958130,681.949951 692.225220,680.837769 693.229431,681.309814 
	C694.283936,681.805603 693.642944,682.639404 692.725220,683.363403 
	C692.265747,683.425720 692.084290,683.354187 691.809204,683.005493 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M795.700562,742.044128 
	C795.859192,742.569153 795.719910,743.124329 795.365479,743.874146 
	C794.039368,743.252869 794.028625,742.575989 795.700562,742.044128 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M662.506775,804.984741 
	C662.246582,804.445557 662.271851,803.859558 662.549683,803.101074 
	C663.885559,803.603821 664.038025,804.274292 662.506775,804.984741 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M744.805054,452.760437 
	C744.019836,452.213013 743.892334,451.614868 744.601440,451.170258 
	C744.758057,451.072052 745.398438,451.357147 745.398560,451.466248 
	C745.399109,451.886566 745.230408,452.307068 744.805054,452.760437 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M721.130859,703.442261 
	C721.813660,703.974731 722.415833,704.668640 722.263306,704.943054 
	C721.819824,705.740845 721.296265,705.208008 720.823730,704.484985 
	C720.734680,703.979980 720.720032,703.696045 721.130859,703.442261 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M694.791199,700.383667 
	C695.218994,699.950684 695.447266,699.916504 696.016113,699.949890 
	C696.741211,699.976379 696.979980,700.143616 697.171387,700.738037 
	C696.877380,701.346619 696.484924,701.736389 695.810181,702.099487 
	C694.873840,701.890930 694.561829,701.460815 694.791199,700.383667 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M720.953369,704.068359 
	C719.988403,703.949524 719.087280,703.368469 719.492798,702.610229 
	C719.997009,701.667725 720.781555,702.221924 721.415283,703.213806 
	C721.423279,703.605896 721.290344,703.739319 720.953369,704.068359 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M784.989258,724.991089 
	C785.760681,723.822266 786.814453,723.833130 788.044373,724.308716 
	C787.520996,725.509033 786.458740,724.800476 785.358398,725.038696 
	C785.016541,725.036804 785.008667,724.996826 784.989258,724.991089 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M483.014893,789.408386 
	C483.127136,789.107300 483.291168,789.073486 483.704224,789.010254 
	C484.492706,789.350525 485.010712,789.886719 484.351562,790.401794 
	C483.701141,790.910034 483.289642,790.300110 483.014893,789.408386 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M630.039795,865.631104 
	C630.414062,865.270081 630.859985,865.169678 631.646667,865.036621 
	C631.809937,866.246216 631.566833,867.349670 630.039795,865.631104 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M632.563965,787.994080 
	C633.188904,788.007874 633.462708,788.193909 633.806152,788.659790 
	C633.141479,789.333679 632.369934,789.782532 631.279541,790.112915 
	C630.413696,788.697937 631.686462,788.647644 632.563965,787.994080 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M789.650024,690.978577 
	C789.913879,691.892212 789.653992,692.686218 788.300415,692.966919 
	C787.985352,692.020935 788.186829,691.192078 789.650024,690.978577 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M692.595093,688.850220 
	C691.679871,689.174744 690.998474,689.258911 690.972046,688.415100 
	C690.950195,687.717407 691.493652,687.273132 692.159485,687.289917 
	C692.997498,687.310913 692.903687,688.026611 692.595093,688.850220 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M703.861938,495.181702 
	C704.455872,494.735168 704.924683,494.559357 705.679443,494.630554 
	C705.579224,496.036011 704.804504,496.752777 703.252869,496.950165 
	C703.190369,496.439087 703.463623,495.945770 703.861938,495.181702 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M703.985107,550.952637 
	C703.344177,551.077515 703.107910,550.893677 703.007690,550.270630 
	C703.324585,549.392090 703.833069,549.090820 704.382263,549.657715 
	C704.555847,549.836853 704.297546,550.434387 703.985107,550.952637 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M563.709106,612.033691 
	C563.995239,612.453796 563.990601,612.914978 563.915833,613.716125 
	C563.222290,613.905884 562.459961,613.799194 562.496033,612.991150 
	C562.510254,612.672607 563.093933,612.379517 563.709106,612.033691 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M604.963745,625.552979 
	C605.002075,625.824097 604.530518,625.914612 604.296997,625.970032 
	C603.510620,625.668640 602.992493,625.141296 603.626221,624.607544 
	C604.257019,624.076294 604.693420,624.650146 604.963745,625.552979 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M706.843323,476.074402 
	C706.965942,476.615295 706.781128,477.165314 706.352966,477.877502 
	C704.931396,477.099823 705.172302,476.469299 706.843323,476.074402 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M533.234680,677.944946 
	C533.081055,677.421753 533.232422,676.875183 533.593933,676.134277 
	C534.989380,676.770264 534.942017,677.436279 533.234680,677.944946 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M610.666443,941.930359 
	C610.980469,942.462036 610.952576,942.925781 610.882202,943.735474 
	C610.507507,944.349060 610.127930,944.480896 609.434326,944.317078 
	C609.167358,944.156921 609.088623,944.083008 609.048950,944.046387 
	C608.654053,943.651001 608.511108,943.216736 608.758545,942.423096 
	C609.419556,942.039673 609.872070,941.951111 610.666443,941.930359 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M608.646362,942.074890 
	C608.982056,942.546326 608.997070,942.964233 609.010620,943.696045 
	C608.157654,943.929688 607.381775,943.734314 607.075439,942.458801 
	C607.466980,942.108398 607.896362,942.064880 608.646362,942.074890 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M751.829224,510.940369 
	C752.274109,511.400940 752.432190,511.793945 752.485962,512.200745 
	C752.492920,512.252808 751.856995,512.540344 751.690125,512.438416 
	C751.031067,512.036011 750.935791,511.471252 751.829224,510.940369 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M618.418396,658.811768 
	C617.376831,658.794922 617.042603,658.094727 617.195190,656.842712 
	C617.697449,657.198853 618.100281,657.861145 618.418396,658.811768 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M747.563110,512.995056 
	C747.939392,512.587524 748.329651,512.491638 748.719849,512.395752 
	C748.717834,512.840881 748.715759,513.286011 748.713684,513.731140 
	C748.334778,513.589661 747.955933,513.448120 747.563110,512.995056 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M617.466614,518.473999 
	C617.526978,517.985962 617.767395,517.689148 618.007812,517.392273 
	C618.191711,517.583862 618.375549,517.775513 618.559448,517.967102 
	C618.255188,518.199829 617.950928,518.432495 617.466614,518.473999 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M652.330811,997.998657 
	C652.046753,997.833801 652.039795,997.638367 652.039551,997.148743 
	C652.478455,996.296997 653.072021,995.984802 653.471191,996.714905 
	C653.846436,997.401062 653.235840,997.775391 652.330811,997.998657 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M819.913757,675.236328 
	C819.942688,676.096436 819.527039,676.775879 818.252625,676.860474 
	C818.098755,675.903992 818.492615,675.196167 819.913757,675.236328 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M749.125000,507.908508 
	C749.352783,507.085266 749.815918,507.011169 750.116699,507.387817 
	C750.315979,507.637390 750.191040,508.145844 750.211243,508.538452 
	C749.854126,508.428925 749.497070,508.319366 749.125000,507.908508 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M660.029663,525.047607 
	C660.003601,523.826111 660.889709,523.750549 661.818970,523.247192 
	C661.665527,523.724854 661.328003,524.448059 660.769958,525.374573 
	C660.549438,525.577820 660.196411,525.230591 660.029663,525.047607 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M722.078735,799.726440 
	C722.895081,800.284607 724.253601,800.769409 723.535278,801.702698 
	C722.915649,802.507629 722.254944,801.560852 721.845642,800.522705 
	C721.776367,800.210327 721.854248,799.762329 722.078735,799.726440 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M679.888672,954.631958 
	C679.132996,954.825745 678.245422,954.688110 677.179443,954.256653 
	C677.919617,954.075378 678.838257,954.187988 679.888672,954.631958 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M749.799316,821.693665 
	C749.498291,822.007141 749.051147,822.074280 748.271118,822.212769 
	C747.610046,821.911987 747.320923,821.349243 747.894958,821.175720 
	C748.406860,821.020996 749.061584,821.338257 749.799316,821.693665 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M662.694824,810.651917 
	C662.372437,810.161865 662.204651,809.453430 662.134766,808.388977 
	C663.063477,808.672546 663.135742,809.506958 662.694824,810.651917 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M747.725403,823.974854 
	C748.292053,824.045044 748.550720,824.248718 748.856445,824.750305 
	C748.268005,824.849060 747.575195,824.722778 746.882324,824.596436 
	C747.079834,824.409485 747.277283,824.222534 747.725403,823.974854 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M705.360901,993.370972 
	C705.873718,993.093262 706.574951,993.058472 707.628052,992.993774 
	C707.987000,993.135925 707.994202,993.308044 708.000671,993.738403 
	C707.183105,993.869202 706.366272,993.741577 705.360901,993.370972 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M750.195801,444.426636 
	C750.277954,444.116547 750.434937,444.201630 750.523071,444.199158 
	C750.729004,444.903046 750.846802,445.609436 750.993530,446.673706 
	C750.831665,447.095947 750.640747,447.160278 750.160645,447.136841 
	C749.770569,446.877747 749.669739,446.706390 749.638184,446.244904 
	C749.842834,445.548767 749.978210,445.142731 750.195801,444.426636 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M708.696716,491.781982 
	C708.950378,492.089844 708.965271,492.282410 708.997803,492.764709 
	C708.502075,493.351807 707.988770,493.649231 707.159058,493.914307 
	C707.101929,493.387238 707.361084,492.892456 707.808838,492.163757 
	C708.151062,491.842102 708.304504,491.754364 708.696716,491.781982 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M800.347351,721.074036 
	C800.503357,720.018555 801.432190,719.985291 802.726196,719.984985 
	C802.617432,721.061646 801.621033,721.018555 800.347351,721.074036 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M666.570679,854.381226 
	C666.921143,855.412720 666.800476,856.375671 666.387024,857.559265 
	C666.382019,856.624634 664.992004,855.466675 666.570679,854.381226 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M779.094604,718.254639 
	C779.842529,717.371216 779.877930,718.083069 779.905518,718.469360 
	C779.923462,718.720703 779.654846,718.992493 779.514526,719.255127 
	C779.362610,719.000061 779.210632,718.744995 779.094604,718.254639 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M573.262573,659.807007 
	C572.992065,659.834961 572.984131,659.659912 572.940613,659.223877 
	C573.081970,658.394653 573.258972,657.826416 573.743225,657.149414 
	C573.875427,657.895142 573.700317,658.749573 573.262573,659.807007 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M575.017090,652.343628 
	C575.212952,652.029541 575.397766,652.018799 575.861694,652.001587 
	C575.945740,652.712646 575.750610,653.430115 575.555481,654.147644 
	C575.372314,653.647400 575.189148,653.147217 575.017090,652.343628 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M781.008057,723.995544 
	C780.371765,723.656982 780.053650,723.121887 780.168762,722.409302 
	C780.194031,722.252991 780.527161,722.146362 780.718506,722.016907 
	C780.801453,722.490051 780.884399,722.963135 780.973633,723.728516 
	C780.979980,724.020752 780.997803,724.002441 781.008057,723.995544 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M634.175171,860.738159 
	C633.713684,861.041016 633.213867,861.049805 632.340393,861.040527 
	C632.264221,860.546692 632.561768,860.070862 632.994507,859.347290 
	C633.465454,859.547791 633.801208,859.995972 634.175171,860.738159 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M725.976929,711.292358 
	C726.310364,711.505737 726.608093,712.039062 726.842957,712.598755 
	C726.865234,712.651917 726.493896,712.870178 726.305298,713.011780 
	C726.178162,712.547729 726.051025,712.083618 725.976929,711.292358 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M807.306274,735.069336 
	C807.273743,734.520691 807.403625,734.130493 807.533447,733.740295 
	C807.641846,733.846130 807.858032,733.976562 807.840454,734.053650 
	C807.749390,734.452515 807.598633,734.837708 807.306274,735.069336 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M698.878784,486.278015 
	C698.779480,486.743561 698.638855,486.987152 698.498291,487.230774 
	C698.358276,486.987366 698.091553,486.734985 698.107971,486.502655 
	C698.132935,486.150085 698.133667,485.434296 698.878784,486.278015 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M702.697510,486.146057 
	C703.110413,486.002991 703.281677,486.007507 703.709595,485.999817 
	C703.587646,486.637695 703.208984,487.287781 702.618103,488.132141 
	C702.199158,488.377991 701.992493,488.429565 701.801147,488.162048 
	C702.029541,487.326508 702.242676,486.810089 702.697510,486.146057 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M688.755615,687.029175 
	C689.035767,686.397400 689.399475,685.725220 689.835632,685.103882 
	C689.885132,685.033447 690.342346,685.249390 690.610535,685.332581 
	C690.258240,685.847290 689.905945,686.362061 689.265747,687.030884 
	C688.977905,687.185059 688.860535,687.003723 688.755615,687.029175 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M616.312256,868.740845 
	C616.054321,868.358337 615.909912,868.095459 615.560913,867.683289 
	C615.520264,867.304382 615.593567,867.124573 615.945862,866.861084 
	C616.511353,867.298706 616.797852,867.820007 617.003662,868.648193 
	C616.923035,868.955078 616.516418,868.810669 616.312256,868.740845 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M610.072449,873.908630 
	C610.276367,873.577942 610.810303,873.267517 611.662720,872.945496 
	C611.454956,873.265564 610.928711,873.597229 610.072449,873.908630 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M676.989746,953.724121 
	C676.850525,954.003723 676.669373,954.031433 676.214966,954.092529 
	C675.837708,953.845093 675.733521,953.564270 675.629395,953.283569 
	C676.068848,953.346436 676.508240,953.409302 676.989746,953.724121 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M667.305847,814.750000 
	C667.738647,814.921875 668.038696,815.531982 668.339966,816.493164 
	C668.117920,816.877136 667.894714,816.909973 667.337708,816.973022 
	C667.060242,816.398132 667.116638,815.793152 667.305847,814.750000 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M707.762573,988.361572 
	C707.999573,988.376465 708.128540,988.504639 708.257507,988.632751 
	C708.056519,988.580139 707.855591,988.527527 707.762573,988.361572 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M657.958313,854.566101 
	C657.596497,854.431396 657.244019,853.993713 656.933960,853.250977 
	C657.632568,853.139893 657.951904,853.587280 657.958313,854.566101 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M665.164917,561.435059 
	C665.212219,562.036682 665.143188,562.335449 665.025574,563.091675 
	C664.626038,562.919678 664.275146,562.290161 663.980103,561.293213 
	C664.373474,560.994629 664.710999,561.063416 665.164917,561.435059 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M727.539368,458.824738 
	C727.671631,458.445679 728.105408,458.182678 728.795593,457.993439 
	C729.124573,459.018677 728.525635,459.039246 727.539368,458.824738 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M678.625977,694.975891 
	C678.832336,695.566772 678.672913,696.177429 678.235046,696.956177 
	C678.057800,696.414734 678.158997,695.705261 678.625977,694.975891 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M663.318359,558.655762 
	C662.167358,558.977600 661.939148,558.354736 661.948120,557.276489 
	C663.166199,556.748230 663.238708,557.672852 663.318359,558.655762 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M788.317139,707.909180 
	C788.154907,707.432983 788.289734,706.830200 788.732544,706.115356 
	C788.898438,706.596313 788.756409,707.189453 788.317139,707.909180 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M664.300537,560.660522 
	C663.240906,560.903931 663.017883,560.297729 662.979248,559.269287 
	C664.188232,558.724304 664.225220,559.664551 664.300537,560.660522 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M742.359131,681.662842 
	C741.993042,681.695312 741.771240,681.583191 741.549438,681.471069 
	C741.889526,681.040527 742.206604,681.073669 742.359131,681.662842 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M737.984985,679.767212 
	C737.869934,679.599121 737.925232,679.431580 737.980469,679.264038 
	C738.038696,679.431946 738.096985,679.599854 737.984985,679.767212 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M679.591919,692.960693 
	C679.819336,693.545288 679.667603,694.127563 679.236389,694.860962 
	C678.410034,694.248840 678.751038,693.596130 679.591919,692.960693 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M680.649780,691.002686 
	C680.847351,691.552124 680.697510,692.148926 680.252197,692.867615 
	C679.597473,692.258423 679.879028,691.641663 680.649780,691.002686 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M827.250610,726.000122 
	C827.165039,725.573120 827.330017,725.146179 827.494995,724.719238 
	C827.653931,724.980286 827.812927,725.241333 827.987183,725.751221 
	C827.835388,726.000122 827.668274,726.000244 827.250610,726.000122 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M798.775391,720.961670 
	C799.144043,720.815979 799.319580,720.852722 799.757202,720.950256 
	C799.622864,721.946777 799.204590,722.645996 798.775391,720.961670 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M810.336914,717.045410 
	C810.127075,716.212463 810.728210,716.043823 811.708130,715.969604 
	C811.572266,716.354797 811.112854,716.716248 810.336914,717.045410 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M812.258484,716.115967 
	C812.450256,715.642944 812.871643,715.278015 813.711548,715.025269 
	C813.892517,715.433044 813.654968,715.728638 813.192322,716.207764 
	C812.807434,716.335510 812.647766,716.279724 812.258484,716.115967 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M805.742920,718.976562 
	C806.028198,719.151245 806.036743,719.322510 806.019043,719.749634 
	C805.593628,719.982971 805.194580,719.960510 804.498901,719.925354 
	C804.623657,719.599487 805.044983,719.286255 805.742920,718.976562 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M809.267761,718.151001 
	C808.848328,718.271179 808.670837,718.233582 808.237671,718.103027 
	C808.107178,717.221558 808.700928,716.991272 809.687012,716.935913 
	C809.841309,717.347534 809.675537,717.670410 809.267761,718.151001 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M730.582886,485.231812 
	C730.539368,485.255310 729.930359,484.383820 730.582886,485.231812 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M642.159790,678.090210 
	C643.114319,678.638367 642.588135,678.896851 642.147583,678.902100 
	C641.654602,678.907959 641.209351,678.637634 642.159790,678.090210 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M732.697998,677.340088 
	C732.991760,677.357117 733.151794,677.507019 733.311829,677.656982 
	C733.062622,677.595581 732.813416,677.534241 732.697998,677.340088 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M729.014038,675.985840 
	C729.462036,676.102295 729.898682,676.230225 730.335388,676.358154 
	C730.016235,677.036682 729.623169,676.718323 729.108643,676.231323 
	C728.984131,676.022827 729.002808,675.997314 729.014038,675.985840 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M596.765259,676.611206 
	C596.363342,676.760925 595.734680,676.683594 594.889404,676.365723 
	C595.294678,676.211609 595.916626,676.297913 596.765259,676.611206 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M844.489441,672.973511 
	C845.587280,673.374634 845.409668,673.739136 844.290649,674.010376 
	C843.938049,673.669739 844.012634,673.361084 844.489441,672.973511 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M721.369141,487.930237 
	C721.402588,487.492310 721.776855,487.009918 722.458374,486.428436 
	C722.775635,487.093567 722.470032,487.643799 721.369141,487.930237 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M626.023376,487.219421 
	C626.332520,487.083832 626.589050,487.261475 626.905457,487.725922 
	C626.200256,488.785919 626.136292,488.071716 626.023376,487.219421 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M702.257141,488.207153 
	C702.079346,488.817505 701.752869,489.308624 701.426392,489.799713 
	C700.789795,489.311188 700.995483,488.755432 701.557251,488.017456 
	C701.816406,487.842926 702.108459,488.087891 702.257141,488.207153 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M692.135864,523.140137 
	C691.103943,522.715149 690.613098,522.002563 691.195007,521.324219 
	C691.926147,520.471863 691.973694,521.703735 692.532349,522.229614 
	C692.611328,522.727051 692.531189,522.921936 692.135864,523.140137 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M722.192627,761.394409 
	C722.456543,761.047668 722.894897,760.895508 723.674683,760.834595 
	C723.659424,761.626892 723.173218,762.005798 722.192627,761.394409 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M515.008240,788.322388 
	C515.161804,788.071289 515.341248,788.053345 515.781555,788.106689 
	C515.849182,788.558044 515.655884,788.938049 515.462524,789.317993 
	C515.319702,789.063843 515.176880,788.809692 515.008240,788.322388 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M692.937927,525.069946 
	C692.465759,524.736633 692.170166,524.250732 691.847656,523.464233 
	C691.958008,523.049011 692.095337,522.934509 692.462097,522.676025 
	C692.894104,523.049805 693.096680,523.567444 693.386292,524.351929 
	C693.473267,524.618774 693.114502,524.917358 692.937927,525.069946 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M724.283936,786.784424 
	C724.163025,786.334290 724.327209,785.798401 724.748535,785.132446 
	C724.860107,785.567871 724.714539,786.133240 724.283936,786.784424 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M804.497803,770.734863 
	C804.258057,770.495789 804.199036,770.065002 804.165894,769.307617 
	C804.191833,768.981140 804.593445,768.995728 804.794312,769.002136 
	C804.889587,769.520081 804.784058,770.031555 804.497803,770.734863 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M484.781982,777.901306 
	C484.998718,778.358154 485.014465,778.818909 485.019226,779.624329 
	C484.258087,779.786072 484.079132,779.225464 484.125336,778.238831 
	C484.179382,777.925964 484.580933,777.905212 484.781982,777.901306 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M775.365601,514.244202 
	C775.380127,514.008118 775.507202,513.879700 775.634277,513.751221 
	C775.582214,513.951416 775.530212,514.151611 775.365601,514.244202 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M778.328857,776.805542 
	C778.238770,776.434204 778.371887,775.874817 778.734131,775.128540 
	C778.826172,775.500244 778.689087,776.058899 778.328857,776.805542 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M467.007935,796.994629 
	C467.477203,797.346802 468.250732,797.626465 467.363007,798.331421 
	C467.236877,798.056152 467.110748,797.780884 466.981018,797.263794 
	C466.977478,797.022034 466.997253,797.002625 467.007935,796.994629 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M635.145630,954.454468 
	C635.333984,954.263550 635.588440,954.374451 635.895325,954.808716 
	C635.725220,954.941895 635.479858,954.816711 635.145630,954.454468 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M663.832397,508.860413 
	C664.052429,508.955780 664.013000,509.229828 663.767212,509.864868 
	C663.560852,510.225861 663.598877,510.163116 663.612000,510.196533 
	C663.607727,509.833008 663.590393,509.436096 663.832397,508.860413 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M695.391724,487.865234 
	C695.268616,487.972168 695.102600,487.505737 695.125610,487.259277 
	C695.521423,487.161255 695.643494,487.409760 695.391724,487.865234 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M584.222168,542.734131 
	C583.863953,542.808594 583.665283,542.638245 583.466675,542.467834 
	C583.564026,542.379211 583.661438,542.290649 583.925415,542.091736 
	C584.188599,542.150635 584.285156,542.319946 584.222168,542.734131 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M702.641296,496.790649 
	C702.857483,497.216949 702.981934,497.779633 702.123291,497.239807 
	C702.020203,497.048828 702.406006,496.778259 702.641296,496.790649 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M698.601685,524.407715 
	C698.685974,524.531982 698.374695,524.604614 698.374695,524.604614 
	C698.374695,524.604614 698.517334,524.283508 698.601685,524.407715 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M655.510132,984.894531 
	C655.138306,984.683899 655.199463,984.397766 655.782104,984.104980 
	C655.950195,984.303528 655.830017,984.543701 655.510132,984.894531 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M584.228882,542.221069 
	C584.218750,541.984070 584.468140,541.881348 584.842163,541.899048 
	C584.807312,542.131287 584.647888,542.243286 584.228882,542.221069 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M661.999023,522.998352 
	C662.003479,522.989319 662.167725,522.920959 662.167725,522.920959 
	C662.167725,522.920959 661.954529,522.876099 661.978760,522.938843 
	C662.003052,523.001587 661.994629,523.007385 661.999023,522.998352 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M699.588623,526.400940 
	C699.647095,526.486389 699.425720,526.528381 699.425720,526.528381 
	C699.425720,526.528381 699.530151,526.315491 699.588623,526.400940 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M601.274414,549.666870 
	C601.062439,549.385498 601.058777,549.114258 601.035583,548.436462 
	C601.016052,548.029968 601.321289,547.667908 601.557495,547.684082 
	C601.781067,547.979065 601.768494,548.257935 601.762817,548.955566 
	C601.769775,549.374329 601.482727,549.677002 601.274414,549.666870 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M701.360291,528.381470 
	C701.480957,528.291016 701.559265,528.607422 701.559265,528.607422 
	C701.559265,528.607422 701.239624,528.471863 701.360291,528.381470 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M762.710449,519.282715 
	C762.702820,519.578491 762.496094,519.647156 762.289368,519.715820 
	C762.363342,519.495728 762.437378,519.275696 762.710449,519.282715 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M700.133057,492.944153 
	C700.083801,492.958832 700.182251,492.929443 700.133057,492.944153 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M708.984863,491.685272 
	C708.935486,491.897278 708.467834,491.957611 708.232666,491.943726 
	C708.121521,491.613708 708.330078,491.369843 708.854370,491.119598 
	C709.085632,491.040924 709.034180,491.473267 708.984863,491.685272 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M744.595947,503.432831 
	C744.651550,503.518494 744.435547,503.559204 744.435547,503.559204 
	C744.435547,503.559204 744.540405,503.347168 744.595947,503.432831 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M655.026550,521.026001 
	C654.916138,521.280090 654.769409,521.735046 654.671448,521.724731 
	C654.195068,521.674866 654.156433,521.414917 654.761475,521.050537 
	C654.985107,520.987610 655.012634,521.012390 655.026550,521.026001 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M706.156372,494.853882 
	C705.779724,494.723694 705.662537,494.489746 705.760742,493.927490 
	C705.976135,493.599182 706.461670,493.634125 706.692505,493.709717 
	C706.754150,494.106934 706.585022,494.428558 706.156372,494.853882 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M574.306763,555.878906 
	C574.066406,555.603149 574.200989,555.327026 574.753174,555.114319 
	C574.911316,555.381226 574.748291,555.614807 574.306763,555.878906 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M700.005737,493.007385 
	C699.914185,493.043945 699.816956,493.073181 699.852539,493.045319 
	C699.985352,492.988251 700.000000,493.000000 700.005737,493.007385 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M791.487183,753.201477 
	C791.721313,753.375122 791.649841,753.646667 791.246948,754.000366 
	C791.060120,753.829041 791.148865,753.567932 791.487183,753.201477 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M764.543701,831.471436 
	C764.573181,831.522278 764.514282,831.420532 764.543701,831.471436 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M796.523315,741.163696 
	C796.720825,741.348511 796.621948,741.599609 796.198975,741.894287 
	C796.057007,741.719788 796.174377,741.483887 796.523315,741.163696 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M813.194702,744.264709 
	C813.102722,744.072205 813.537476,744.045410 813.754822,744.042236 
	C813.972168,744.039001 814.001343,744.449890 814.010742,744.654053 
	C813.717834,744.830200 813.473328,744.696533 813.194702,744.264709 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M444.857239,834.830200 
	C444.971039,834.943909 445.109802,835.130737 445.248596,835.317566 
	C445.149841,835.257019 445.051056,835.196472 444.845520,834.990845 
	C444.738770,834.845825 444.882202,834.903259 444.857239,834.830200 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M645.757874,858.093018 
	C645.878479,858.306824 645.707703,858.540527 645.225830,858.761963 
	C645.138794,858.558838 645.322632,858.346558 645.757874,858.093018 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M624.005127,859.691589 
	C624.390564,859.780579 624.707275,859.890625 624.866882,859.942017 
	C625.026489,859.993347 624.895935,860.416504 624.913269,860.636719 
	C624.930603,860.856873 624.479248,860.887939 624.479248,860.887939 
	C624.479248,860.887939 624.057190,860.724976 623.909546,860.552856 
	C623.714539,860.121399 623.667175,859.862000 624.005127,859.691589 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M836.245239,726.996094 
	C836.264526,726.877991 836.546143,726.758423 836.929321,726.798584 
	C836.856384,726.970459 836.681946,726.982605 836.245239,726.996094 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M748.473999,831.455322 
	C748.525146,831.426147 748.422852,831.484497 748.473999,831.455322 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M608.199585,785.957153 
	C608.083862,785.763428 608.184265,785.457581 608.590698,785.093140 
	C608.877197,785.388245 608.716858,785.658447 608.199585,785.957153 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M696.971313,776.704346 
	C696.940552,776.885620 696.512085,776.924500 696.310547,776.995483 
	C696.192444,776.791199 696.335876,776.551880 696.728882,776.256836 
	C696.918457,776.165039 697.002075,776.523132 696.971313,776.704346 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M763.469604,777.454590 
	C763.522644,777.423279 763.416504,777.485901 763.469604,777.454590 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M481.910889,780.843689 
	C481.632629,781.003052 481.383301,780.818726 481.229706,780.259216 
	C481.491241,780.163635 481.696045,780.368958 481.910889,780.843689 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M598.230347,796.732178 
	C598.163513,796.346191 598.408936,796.177368 598.964783,796.148560 
	C599.193298,796.169434 599.086426,796.539490 599.021301,796.720764 
	C598.791016,796.878052 598.625854,796.854126 598.230347,796.732178 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M471.472168,795.454712 
	C471.521881,795.425964 471.422424,795.483398 471.472168,795.454712 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M721.908691,800.081055 
	C721.618286,799.887268 721.460266,799.564148 721.302185,799.241089 
	C721.531372,799.246521 721.760620,799.251953 722.146545,799.473999 
	C722.303284,799.690552 722.041077,799.951721 721.908691,800.081055 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M645.097168,787.209351 
	C645.004395,787.058105 645.500244,787.014282 645.748169,787.035156 
	C645.727417,787.157593 645.458679,787.259094 645.097168,787.209351 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M649.088867,787.183105 
	C649.002808,787.027283 649.501709,786.997559 649.747009,787.044800 
	C649.719849,787.174316 649.447449,787.256592 649.088867,787.183105 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M592.304077,804.971313 
	C592.259338,804.691589 592.534546,804.351318 593.166687,803.995605 
	C593.223755,804.290405 592.923889,804.600586 592.304077,804.971313 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M749.502258,445.969666 
	C749.755920,446.134003 749.804382,446.313171 749.862061,446.770691 
	C749.871399,447.049072 749.519775,447.030457 749.343811,447.028320 
	C749.096558,446.870361 749.025330,446.714539 748.922424,446.303802 
	C748.890686,446.048889 749.297058,445.984528 749.502258,445.969666 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M741.779297,445.076752 
	C742.159058,444.753418 742.383545,444.762939 742.929810,444.873352 
	C743.203308,445.140961 743.154968,445.307709 743.048645,445.728333 
	C742.990662,445.982239 742.504089,446.091370 742.256470,446.063324 
	C741.880554,445.826721 741.752258,445.618164 741.779297,445.076752 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M772.587524,820.187378 
	C772.686768,820.341003 772.596436,820.652344 772.307007,821.120850 
	C772.085266,820.929810 772.181946,820.618835 772.587524,820.187378 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M438.254700,819.928833 
	C438.094360,819.686951 438.255920,819.426941 438.766724,819.192017 
	C438.893005,819.433411 438.713196,819.664551 438.254700,819.928833 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M439.884216,818.801880 
	C439.843170,818.570007 440.099792,818.287109 440.634766,817.922607 
	C440.669342,818.144348 440.425568,818.447571 439.884216,818.801880 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M666.998413,816.998108 
	C666.913025,817.034546 666.829224,817.072876 666.874634,817.057129 
	C667.003845,817.003113 667.000000,817.000000 666.998413,816.998108 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M446.435547,816.784546 
	C446.238068,816.547729 446.370270,816.303467 446.827728,816.052368 
	C447.078888,816.317200 446.949615,816.561096 446.435547,816.784546 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M473.065613,824.093018 
	C473.248962,824.080872 473.544342,824.346130 473.939392,824.898682 
	C473.751923,824.914062 473.464783,824.642212 473.065613,824.093018 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M573.972839,656.965942 
	C574.084167,656.959290 574.111572,656.017029 574.196899,656.967773 
	C574.050537,657.040710 573.996887,656.992676 573.972839,656.965942 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M755.680054,473.109070 
	C755.869629,473.164856 755.923218,473.329895 755.943970,473.753265 
	C755.788757,473.747162 755.666382,473.482727 755.680054,473.109070 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M731.619080,473.172424 
	C731.818848,473.387970 731.706665,473.694550 731.237183,474.045532 
	C731.062744,473.816864 731.205139,473.541412 731.619080,473.172424 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M652.260315,696.237793 
	C652.535950,696.236755 652.605591,696.454712 652.675171,696.672607 
	C652.468201,696.600647 652.261230,696.528748 652.260315,696.237793 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M681.540894,690.207642 
	C681.754578,690.465271 681.618835,690.704285 681.158752,690.943237 
	C680.827515,690.643677 680.946533,690.392334 681.540894,690.207642 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M619.453735,870.530151 
	C619.423706,870.478394 619.483826,870.581970 619.453735,870.530151 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M725.067505,709.940063 
	C725.469055,709.973083 725.724609,710.172974 725.960815,710.725586 
	C726.029968,710.965149 725.995544,711.003601 725.975098,711.022339 
	C725.673279,710.882568 725.391907,710.724182 725.006836,710.337158 
	C724.903137,710.108643 725.010132,709.993652 725.067505,709.940063 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M741.932983,455.055573 
	C741.983521,455.072296 742.086304,455.026825 742.031311,455.048157 
	C741.873596,455.114960 741.985107,454.993408 741.932983,455.055573 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M782.347656,713.079529 
	C782.186829,712.712769 782.336609,712.393677 782.763916,712.041077 
	C782.913757,712.380737 782.786011,712.754028 782.347656,713.079529 
z"/>
<path fill="#190A12" opacity="1.000000" stroke="none" 
	d="
M653.583862,705.286804 
	C653.708740,705.062622 653.890991,704.861084 654.073242,704.659485 
	C654.067078,704.844727 654.060852,705.029907 653.865479,705.321594 
	C653.676270,705.428040 653.641357,705.309448 653.583862,705.286804 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M787.303345,709.005859 
	C787.163391,708.692383 787.302185,708.350403 787.739990,708.009888 
	C787.886780,708.333374 787.734497,708.655334 787.303345,709.005859 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M645.183838,677.192871 
	C644.965881,677.448792 644.619202,677.574524 644.272461,677.700256 
	C644.291260,677.485474 644.310059,677.270752 644.561279,676.930908 
	C644.793701,676.805847 645.054993,677.062622 645.183838,677.192871 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M735.450684,678.446289 
	C735.514709,678.409546 735.386597,678.483093 735.450684,678.446289 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M721.143433,887.995911 
	C720.940979,888.029480 720.540894,888.078369 720.339478,888.082153 
	C720.213318,887.760010 720.288635,887.434082 720.596436,886.970337 
	C720.962830,886.971375 721.096741,887.110229 721.430786,887.458130 
	C721.630859,887.667114 721.345825,887.962341 721.143433,887.995911 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M835.732788,689.174805 
	C835.842651,689.358215 835.720520,689.715393 835.372192,690.253174 
	C835.264282,690.072021 835.382507,689.710266 835.732788,689.174805 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M841.580750,678.998413 
	C841.838257,679.216064 841.734619,679.517090 841.256348,679.891602 
	C841.031921,679.678772 841.144592,679.384399 841.580750,678.998413 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M692.269409,683.300171 
	C692.079346,683.657593 691.711426,683.817993 691.343567,683.978394 
	C691.318054,683.691284 691.292603,683.404175 691.491333,682.922668 
	C691.840820,682.853210 691.966187,682.978149 692.269409,683.300171 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M833.238403,683.409546 
	C833.242920,683.222473 833.602112,683.058838 833.793152,683.009277 
	C833.940369,683.241211 833.823547,683.488098 833.474243,683.831238 
	C833.314758,683.962036 833.233826,683.596680 833.238403,683.409546 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M637.848389,995.843811 
	C631.057495,999.657349 623.244751,998.666748 615.798096,999.857056 
	C614.174683,1000.116577 612.487061,999.975037 610.379944,1000.144958 
	C604.964905,995.569275 599.877991,999.470215 594.444214,1000.130859 
	C590.471008,1000.708130 586.902893,1001.248291 583.257690,1000.779480 
	C582.315674,1000.658325 580.973206,1000.680847 580.485779,1001.525818 
	C577.833740,1006.123413 574.628235,1004.472412 571.024902,1002.366211 
	C568.083313,1001.552734 563.918030,1001.373962 563.744324,998.951965 
	C563.550720,996.251160 567.243408,994.343994 569.843018,992.215393 
	C571.317688,991.066040 572.386414,991.143066 573.446655,992.716980 
	C573.542969,993.524109 573.458374,993.969116 573.045410,994.621155 
	C572.574219,995.048340 572.276672,995.177979 571.954590,995.247070 
	C572.554382,995.466309 572.991333,994.999817 573.829590,994.714355 
	C577.590698,993.073181 581.209534,993.766052 585.150635,993.722900 
	C587.557739,994.384094 589.540344,994.622864 591.745239,993.027710 
	C598.351807,992.206116 604.588623,992.792480 611.260620,992.490601 
	C616.867371,991.322937 622.020935,990.613220 627.566528,992.742615 
	C630.582764,996.035339 634.483582,994.276367 637.848389,995.843811 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M570.778687,1002.461853 
	C573.474243,1002.315796 576.151245,1003.557434 579.070557,1002.769531 
	C579.358032,1001.916565 575.728943,1000.406189 579.729919,999.858765 
	C584.390686,999.221008 588.979431,999.857483 593.819946,999.895020 
	C592.099121,1001.782959 590.147522,1003.363770 587.885254,1004.976562 
	C581.923401,1007.549927 576.531677,1005.639282 571.061279,1003.628418 
	C570.949219,1003.042419 570.896973,1002.877563 570.778687,1002.461853 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M570.598511,1003.107300 
	C576.123169,1004.819580 581.282104,1006.090271 587.140747,1004.960938 
	C585.627502,1007.989441 582.671936,1007.376282 579.944153,1006.933777 
	C573.593445,1005.903564 567.276978,1004.662354 560.516724,1003.475220 
	C559.521667,1003.769531 558.962341,1003.754028 558.208008,1003.194214 
	C557.838989,1002.549072 557.670349,1002.125305 557.497437,1001.468262 
	C561.727234,1001.825806 565.961365,1002.416626 570.598511,1003.107300 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M599.129028,1005.733093 
	C598.845276,1006.019287 598.668762,1006.005493 598.236450,1006.062744 
	C597.670227,1006.217285 597.359802,1006.300842 596.963501,1006.622070 
	C596.303101,1007.008728 595.728699,1007.157654 595.012573,1007.569946 
	C594.245605,1008.019165 593.620361,1008.204956 592.802368,1008.669373 
	C591.621582,1008.907349 590.633362,1008.866699 589.268677,1008.841919 
	C588.970703,1007.980774 589.429504,1007.376404 590.520386,1007.014282 
	C591.116516,1006.812744 591.396851,1006.588623 591.838806,1006.142700 
	C592.014099,1005.937988 592.002441,1006.001587 591.971802,1005.991211 
	C592.415100,1005.595947 593.014526,1005.528320 593.757690,1005.115723 
	C593.950073,1004.893738 593.986938,1004.981201 593.948853,1004.952942 
	C596.791748,1003.007324 599.741333,1001.283203 603.709351,1001.812866 
	C603.956970,1002.732727 605.358521,1003.505249 603.625732,1004.046509 
	C602.767944,1004.312500 602.120483,1004.477417 601.222046,1004.841553 
	C600.981079,1005.073608 600.997192,1004.999268 601.034851,1005.002808 
	C600.460449,1005.148621 599.848389,1005.290833 599.129028,1005.733093 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M604.364136,1002.023682 
	C600.901306,1003.081482 597.784363,1004.098083 594.289062,1005.019653 
	C595.769897,1001.997437 602.300598,998.967102 605.056458,1000.031738 
	C606.819214,1000.712646 607.304443,1001.766663 604.364136,1002.023682 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M558.007629,1003.378052 
	C558.540100,1003.046631 559.072571,1003.120483 559.845947,1003.319092 
	C560.066345,1004.577942 560.045959,1005.712036 560.044800,1007.267822 
	C559.536682,1007.557983 559.009338,1007.426575 558.239624,1007.161682 
	C558.000671,1005.946594 558.004211,1004.864990 558.007629,1003.378052 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M588.559814,1008.932129 
	C588.604431,1010.058594 587.625366,1009.982422 586.416382,1010.099548 
	C586.534973,1009.219849 587.418213,1009.153809 588.559814,1008.932129 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M567.748535,1009.677612 
	C567.074707,1009.836975 566.166626,1009.735168 564.995850,1009.404175 
	C565.660217,1009.255371 566.587280,1009.335876 567.748535,1009.677612 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M562.766296,1008.545227 
	C562.414307,1008.646301 561.869141,1008.557190 561.164551,1008.231934 
	C561.527771,1008.115479 562.050415,1008.235229 562.766296,1008.545227 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M601.338013,1005.159912 
	C601.224243,1004.238953 601.884766,1003.978516 603.012939,1003.941467 
	C602.816162,1004.429993 602.255554,1004.838135 601.338013,1005.159912 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M593.670105,1004.656006 
	C594.109863,1005.923401 593.409485,1006.148315 592.286987,1006.141357 
	C592.424194,1005.459961 592.907166,1004.939148 593.670105,1004.656006 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M591.772949,1006.064880 
	C591.792297,1006.201050 591.570496,1006.464111 591.085571,1006.873535 
	C591.058960,1006.743835 591.295410,1006.467834 591.772949,1006.064880 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M548.947205,1016.350403 
	C548.274963,1015.964233 547.875000,1015.770935 547.222900,1015.799438 
	C546.970764,1016.021301 547.008179,1016.001648 547.004028,1016.023010 
	C546.756958,1015.756775 546.511353,1015.471436 546.093018,1014.963074 
	C548.230225,1007.668457 550.162964,1015.254822 552.651978,1014.950439 
	C552.164978,1016.549683 551.084412,1017.509033 548.947205,1016.350403 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M545.996948,1015.035278 
	C546.314636,1014.947266 546.705627,1015.157288 547.048340,1015.705811 
	C546.690063,1015.807373 546.380249,1015.570312 545.996948,1015.035278 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M641.742065,1016.074585 
	C641.871399,1016.476624 641.651794,1016.622559 641.206909,1016.371216 
	C641.111084,1016.239380 641.522400,1016.083984 641.742065,1016.074585 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M1006.472534,965.835205 
	C1007.460815,963.942871 1008.485901,962.233521 1010.364807,963.713562 
	C1012.210022,965.167053 1012.012634,967.583740 1011.720459,969.722107 
	C1011.498474,971.346069 1010.557678,972.489624 1008.684387,972.195557 
	C1006.674927,971.880188 1006.029785,970.423767 1006.000732,968.614624 
	C1005.987671,967.802124 1006.172363,966.986389 1006.472534,965.835205 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M781.171021,490.846985 
	C780.969666,490.500031 781.005127,490.496460 780.999512,490.513367 
	C780.714844,490.227753 780.864563,489.319031 779.752258,489.936218 
	C779.496521,490.039490 779.504456,490.000000 779.507080,490.020691 
	C777.332642,489.955139 776.184082,489.100128 777.223267,486.442078 
	C778.157837,485.017059 779.926697,485.576691 780.606689,483.938934 
	C780.713867,483.008209 780.759521,482.380585 780.792480,481.427032 
	C780.847717,480.671539 780.911438,480.243591 781.059387,479.502075 
	C781.403503,478.146606 781.499207,477.102966 781.124207,475.727234 
	C780.510132,472.933502 781.413452,470.433868 780.854736,467.631409 
	C780.743225,466.653748 780.729370,466.002747 780.628662,465.047302 
	C780.419617,463.438721 779.216614,462.738892 778.783264,461.286743 
	C779.396851,459.904572 781.036804,459.714569 781.132874,457.898865 
	C781.272278,455.895813 781.584778,454.206238 781.055908,452.195496 
	C780.954712,451.425201 780.942078,450.980652 780.990356,450.200623 
	C781.240601,448.565918 781.659729,447.297943 781.640747,445.635681 
	C781.700928,444.119141 781.095947,443.249542 780.096619,442.178040 
	C781.397278,437.660675 781.923950,433.320831 781.586792,428.486938 
	C781.591980,427.330963 781.543701,426.557709 781.585205,425.392700 
	C781.586365,423.960358 781.538879,422.919312 781.594971,421.494171 
	C781.570435,419.854675 781.597778,418.599487 781.607422,416.983398 
	C781.670349,415.203522 781.410645,413.854279 780.591553,412.268005 
	C780.339233,411.468262 780.202515,410.960541 780.349060,410.513245 
	C781.071899,408.308197 780.843994,407.666077 778.874634,406.745636 
	C778.787537,405.365723 779.536560,404.766785 780.493896,403.915192 
	C782.652527,401.554749 780.947449,399.482025 780.671509,397.031067 
	C781.611206,394.900269 781.767578,393.007294 781.553955,390.672821 
	C781.560852,388.655701 781.576965,387.024323 782.735046,385.268768 
	C783.478638,385.009644 783.921448,385.034515 784.697021,385.054260 
	C786.749512,386.707092 786.263184,388.906372 786.500000,391.300262 
	C788.129333,396.359680 792.729919,394.409912 796.157837,395.854614 
	C797.246277,395.898163 797.949524,396.053558 798.905029,396.595032 
	C800.135986,399.437744 798.164917,399.742218 796.464355,400.264252 
	C794.635132,400.825836 792.585815,400.294403 790.545898,401.541931 
	C789.347717,402.088470 788.329834,402.011749 787.383057,402.541046 
	C788.533447,403.646698 789.990784,403.406586 791.694336,403.604797 
	C799.015564,404.890167 806.197815,404.704559 813.351440,407.114624 
	C815.242310,409.828003 816.761414,412.240601 812.061157,413.163422 
	C811.185669,413.335358 811.250244,415.176361 810.162109,416.282959 
	C803.348999,417.428558 797.208252,415.052002 790.505615,414.305908 
	C788.829773,414.249634 787.134827,412.403442 786.340698,415.328918 
	C786.292542,416.042999 786.274963,416.446106 786.280029,417.136719 
	C786.362671,417.978607 786.428284,418.533234 787.047058,419.158813 
	C789.220825,420.484039 791.822693,421.188934 790.423584,424.618347 
	C788.999756,425.747742 787.252563,425.579468 786.206665,427.096375 
	C786.326782,428.095062 786.457031,427.459625 786.823059,427.054413 
	C790.382690,425.705048 793.414917,426.937347 796.787903,428.292297 
	C798.120789,429.452026 798.646545,430.607025 798.538574,432.366638 
	C796.903076,434.740387 794.779480,433.483368 792.564026,433.710541 
	C790.669861,433.382263 789.078308,433.356201 787.594055,432.789551 
	C787.455078,432.736511 787.333923,432.636658 787.204529,432.558502 
	C787.222229,432.714600 787.239868,432.870667 787.391663,433.262299 
	C786.536499,438.198029 786.536499,438.198029 793.704041,438.532898 
	C794.474854,438.871643 794.825439,439.199310 795.233154,439.944397 
	C795.310791,441.062195 794.981873,441.696594 794.165161,442.440216 
	C792.500305,443.189331 791.066528,442.940491 789.650391,442.965576 
	C791.034485,443.077393 792.513306,442.940674 793.569153,444.661865 
	C793.990601,446.246307 793.630493,447.375916 792.783936,448.731934 
	C791.586304,449.909515 790.478210,449.854248 789.323059,449.444153 
	C788.681519,449.263000 789.028625,450.319397 789.092468,449.655792 
	C789.156250,448.992188 788.897522,449.936371 789.458130,449.575592 
	C789.525330,449.532379 789.673828,449.606201 789.938049,449.706146 
	C790.557373,449.940430 791.218567,450.043213 792.139404,450.468903 
	C793.690857,451.848206 794.919312,453.053772 794.643188,455.350220 
	C794.404663,455.888489 794.265503,456.079407 793.798401,456.387451 
	C792.791992,456.437347 792.863708,455.807587 792.641113,455.398529 
	C792.421570,455.825623 792.537170,456.291534 792.306641,457.023895 
	C790.383301,458.704651 788.173340,457.730896 786.153442,458.708527 
	C788.287659,462.183105 791.094360,460.327148 794.123779,459.702332 
	C794.714783,459.711426 794.948059,459.786194 795.413940,460.148987 
	C796.209900,461.616608 796.199158,462.824341 795.669434,464.369568 
	C793.120789,467.564575 789.770569,465.209015 786.966553,466.527374 
	C786.432739,469.163727 786.414612,471.516144 786.792480,474.200958 
	C786.087585,476.806793 787.220886,478.050171 789.416260,479.084137 
	C790.053345,480.244141 790.074585,481.163971 789.700806,482.428772 
	C788.943604,484.026886 785.679565,483.753510 787.646362,486.639526 
	C789.408875,487.956268 790.917542,489.240143 793.155884,487.511810 
	C794.629700,486.383606 795.567078,487.155426 796.813599,488.018860 
	C798.185120,489.279724 799.574524,489.563324 800.987244,489.895081 
	C802.434937,490.235107 803.826111,490.804779 803.011658,493.089447 
	C802.571594,493.504639 802.363342,493.634827 801.807373,493.888611 
	C800.980469,494.115906 800.496277,494.184235 799.645020,494.232330 
	C799.043274,494.242859 798.803528,494.237640 798.207642,494.202118 
	C795.583252,493.585358 793.204651,493.643219 790.597900,492.910217 
	C788.582092,492.360809 786.828186,492.477600 784.769287,492.032776 
	C783.312683,491.985138 782.301025,491.744568 781.171021,490.846985 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M887.663940,391.185974 
	C887.168579,390.263733 887.071167,389.439667 886.986145,388.301575 
	C884.638611,383.793762 885.013916,379.145844 884.854980,374.141968 
	C885.851501,362.293365 885.106323,350.882233 885.353638,339.483337 
	C885.457642,334.691803 885.067749,329.889435 885.778320,324.668213 
	C886.531494,322.350922 888.158569,321.619873 890.187134,320.746216 
	C890.883545,320.597290 891.170044,320.581207 891.860229,320.713440 
	C893.292480,321.876556 894.056763,323.084625 894.947144,324.731537 
	C895.856873,338.529449 897.006592,351.831604 895.701050,365.333771 
	C894.751953,375.149658 894.859497,385.186523 896.231445,395.130402 
	C897.121033,401.578400 895.461304,407.978271 894.089417,414.760559 
	C892.612183,417.461823 892.696228,419.981812 892.633545,422.470337 
	C892.574951,424.797485 892.755310,427.137207 892.437134,429.449127 
	C892.213623,431.073181 892.076599,433.272186 890.004456,433.240082 
	C887.714111,433.204620 888.066040,430.935669 888.029602,429.342590 
	C887.820618,420.200012 888.315735,411.050262 887.581665,401.483643 
	C887.317993,400.220215 887.234192,399.383484 887.257324,398.245544 
	C889.513428,395.925018 888.381836,393.562042 887.663940,391.185974 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M752.228577,394.632080 
	C747.667664,391.604401 746.275818,386.514679 743.134033,382.418915 
	C744.376282,380.875122 745.829590,381.609680 747.521973,381.544373 
	C756.324646,377.909546 764.167725,372.969666 772.840881,369.784790 
	C773.476868,369.551270 773.491516,368.697784 773.552124,367.647156 
	C772.434387,359.258514 772.516296,351.208710 772.570435,342.719757 
	C772.623291,340.135956 772.333435,337.944733 772.858459,335.862213 
	C773.495300,333.335724 774.733398,331.477997 778.015198,333.711182 
	C778.573486,334.493530 778.790100,334.981659 778.996460,335.864777 
	C779.003113,338.331238 778.427795,340.631348 781.338562,341.959503 
	C781.829163,342.873352 781.884399,343.541565 781.629639,344.542450 
	C780.354553,346.220642 778.046692,346.742645 778.361694,349.501282 
	C778.388916,350.723358 778.532349,351.601257 778.828003,352.808167 
	C779.129028,354.070160 779.205200,355.010712 779.266846,356.309570 
	C779.266418,357.132965 779.235718,357.599670 779.138428,358.405212 
	C778.819946,360.054504 778.650391,361.366455 779.046387,363.022064 
	C779.232544,364.016785 779.310974,364.688416 779.458984,365.693451 
	C779.912842,367.498718 781.005066,367.619019 782.198425,367.297272 
	C785.709778,366.350464 789.297791,366.723938 793.212341,366.597931 
	C793.803467,366.599731 794.039062,366.599609 794.626465,366.601379 
	C801.235657,367.057648 807.350098,368.448486 813.528503,369.421326 
	C814.625549,369.594086 815.976257,370.132172 816.672607,368.854645 
	C817.374756,367.566467 816.145020,366.792877 815.192383,365.689362 
	C814.868591,365.231323 814.770813,365.029541 814.684692,364.496155 
	C815.536743,362.820770 817.729614,362.559418 817.650269,360.153870 
	C817.649170,359.385742 817.644043,358.941101 817.620605,358.147980 
	C817.625488,356.360931 817.036499,354.945862 817.611328,353.166656 
	C822.431335,350.794159 821.308533,355.432159 822.893311,357.442200 
	C824.236328,360.464691 823.946045,363.289215 823.514038,366.035187 
	C822.887329,370.018250 824.202454,372.050690 828.419250,371.792664 
	C829.072205,371.752716 829.709167,372.018555 830.635010,372.485931 
	C831.068237,372.930847 831.186768,373.161072 831.217896,373.776001 
	C830.531128,374.740204 829.788940,375.026855 828.590698,375.263306 
	C827.919312,375.342560 827.650269,375.362152 826.978516,375.388641 
	C824.730103,375.388550 822.884399,375.361511 820.660950,375.395447 
	C816.189819,375.010895 813.847900,376.353180 814.625793,380.967102 
	C814.794800,381.969391 814.469482,383.115753 813.350281,383.356506 
	C811.962097,383.655029 811.322632,382.577881 810.909668,381.422577 
	C810.743347,380.957031 810.649780,380.471252 810.551453,379.986633 
	C809.263550,373.636719 809.262451,373.636932 802.128174,373.123901 
	C801.080139,372.917755 800.401489,372.711884 799.378174,372.455139 
	C798.341370,372.341675 797.650024,372.275116 796.608276,372.226746 
	C796.029236,372.193756 795.797913,372.174286 795.223022,372.106323 
	C794.653870,372.013031 794.428284,371.968231 793.870178,371.841064 
	C792.241028,371.289948 790.896362,371.284363 789.205322,371.368561 
	C785.299805,371.423584 785.322571,373.996735 785.200439,376.512817 
	C785.051453,379.582184 787.569763,378.455017 789.019653,378.926483 
	C789.932678,379.223389 790.897400,379.454529 792.236023,379.552063 
	C794.340637,379.658722 796.088501,379.569977 798.214355,379.725159 
	C798.850891,379.799286 799.104431,379.840179 799.732605,379.972229 
	C804.042297,381.988312 808.739502,381.248352 812.840820,383.872864 
	C813.328857,384.671631 813.200439,385.128174 812.389343,385.638336 
	C802.737793,383.900909 793.424194,382.221497 783.911560,381.980469 
	C781.240967,381.912811 778.656006,382.213440 775.912476,383.545135 
	C772.166321,386.976624 767.419800,387.563110 763.251587,390.073059 
	C762.764221,390.366577 762.563171,390.473145 762.047180,390.708405 
	C758.307129,391.243713 755.886169,394.043671 752.228577,394.632080 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M887.334106,401.517059 
	C889.952454,401.898071 888.959595,404.065155 888.976257,405.688721 
	C889.067139,414.542145 889.019531,423.397034 889.019531,432.251404 
	C889.673767,432.285583 890.327942,432.319733 890.982178,432.353882 
	C890.982178,428.310272 890.962646,424.266571 890.989929,420.223175 
	C891.005188,417.949860 890.562927,415.463562 893.796875,414.018677 
	C896.432922,415.122742 896.391296,417.360718 896.396790,419.518066 
	C896.452026,441.124420 896.448425,462.730835 896.414307,484.337280 
	C896.411072,486.371582 895.994873,488.290070 894.973938,490.566071 
	C893.820557,492.617767 895.545044,495.883240 891.412354,495.705444 
	C889.884644,494.759003 888.297546,495.243835 886.868896,494.189423 
	C886.431274,493.478027 886.395264,493.020447 886.721558,492.264343 
	C887.011841,491.549561 887.087708,491.118835 887.242432,490.367798 
	C887.656555,489.886414 887.777832,489.625824 887.513550,489.107727 
	C887.316711,459.958923 887.291626,430.968048 887.334106,401.517059 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M885.901428,374.018677 
	C886.096252,378.653107 887.450134,382.796478 886.982666,387.539215 
	C881.545166,387.540253 877.278381,384.149323 872.498230,382.057098 
	C868.230713,380.189362 864.511963,379.866211 859.843994,381.794312 
	C850.076904,385.828491 840.500793,391.474030 829.127014,389.130829 
	C826.552124,388.600342 823.934448,388.276978 821.031616,387.605896 
	C820.840271,387.116333 820.953735,386.879181 821.394958,386.422546 
	C824.311646,385.281433 826.847900,385.825195 829.754639,386.506653 
	C830.862427,386.529358 831.595032,386.553711 832.676392,386.598267 
	C836.539734,386.982758 837.893799,385.550629 836.956299,382.042328 
	C836.619690,380.782928 836.674561,379.449005 836.632080,377.801880 
	C836.602844,376.067261 836.475159,374.696014 835.616455,373.111328 
	C835.361694,372.271179 835.348938,371.771606 835.582764,370.907776 
	C843.582520,365.210999 852.491821,362.718964 861.667786,360.972534 
	C862.648438,360.785919 863.686768,361.031555 864.595337,361.460938 
	C870.615662,364.305847 876.666931,367.086456 882.654846,369.997955 
	C884.154297,370.727020 885.426514,371.863770 885.901428,374.018677 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M798.053589,433.023621 
	C797.653381,431.754242 797.349426,430.806824 797.004028,429.561005 
	C798.080383,427.588715 799.801270,427.665466 801.414673,427.955994 
	C811.608154,429.791473 821.896973,431.105682 832.394775,433.636017 
	C833.881958,434.171661 834.798645,434.831055 835.883301,435.943451 
	C836.067566,440.352570 836.020020,444.408386 835.891357,448.861755 
	C834.630920,450.048767 833.400757,449.493774 831.817017,449.363220 
	C820.567261,446.881897 809.422791,446.009094 798.193665,443.570923 
	C795.670776,439.908417 798.247803,438.469543 800.814087,436.649170 
	C801.216675,436.210907 801.395142,436.055206 801.890137,435.748413 
	C803.510437,435.331970 804.801086,435.708954 806.232849,435.672028 
	C805.516357,434.947540 804.643799,435.351349 803.615845,435.072754 
	C803.101135,434.957397 802.902283,434.894104 802.436890,434.692810 
	C801.846313,434.289825 801.483582,434.250427 800.778748,434.411072 
	C799.553162,434.374664 798.773010,434.024261 798.053589,433.023621 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M786.245300,475.254974 
	C785.306641,472.272491 784.394348,469.600067 785.927612,466.524231 
	C788.752075,464.693665 791.489563,466.521118 794.621704,466.339600 
	C797.642273,466.525238 800.121887,467.895782 803.190063,467.439606 
	C803.767090,467.383362 803.997437,467.382568 804.562378,467.446930 
	C806.215088,468.269928 807.572083,468.893280 809.475830,468.728394 
	C810.231018,468.697388 810.663513,468.681122 811.423767,468.643738 
	C813.367798,468.307037 814.712830,469.275146 816.523071,469.587738 
	C818.579041,469.463226 820.254150,469.831848 822.257202,470.216614 
	C822.806213,470.248688 823.027649,470.262421 823.583740,470.305603 
	C827.796936,470.793304 831.639648,471.442200 835.683594,472.703064 
	C835.964478,474.683380 835.968811,476.453369 835.927612,478.664612 
	C834.823425,479.936829 833.404663,479.025391 832.161438,479.876801 
	C831.690674,479.979584 832.561829,480.674622 832.357910,480.049347 
	C832.235535,479.673950 832.570190,479.512848 832.959167,479.517700 
	C833.769226,479.527771 834.579529,479.506378 835.688599,479.777100 
	C836.016907,480.741943 836.045044,481.503571 836.027466,482.643982 
	C834.208923,484.504883 832.360779,483.593353 830.140015,483.079803 
	C821.113586,479.824677 811.947876,479.807098 803.012878,478.416718 
	C797.496399,477.558289 791.831299,477.531738 786.245300,475.254974 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M785.319153,393.306854 
	C785.021790,390.686646 785.026428,388.309784 785.030396,385.491028 
	C791.203003,383.808929 796.835571,386.683319 802.728088,387.517853 
	C811.684570,388.786316 820.254272,392.300171 829.733704,392.737549 
	C830.927673,393.665527 831.877686,394.260345 832.401855,395.698914 
	C832.532471,396.256714 832.553589,396.488525 832.530823,397.070740 
	C832.312012,398.126343 832.023438,398.782776 831.393982,399.676453 
	C827.389893,400.832642 823.869019,398.806488 819.803711,398.945068 
	C819.000488,398.633026 818.590149,398.374023 817.991943,397.782043 
	C815.986938,394.387695 815.764099,394.265533 814.354980,396.023560 
	C813.989685,396.426178 813.806824,396.556305 813.308411,396.816986 
	C807.222046,398.178375 801.706360,395.150177 795.595520,395.906921 
	C792.183167,394.461731 788.506531,395.632599 785.319153,393.306854 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M835.675110,423.720123 
	C835.958496,427.074066 835.931702,430.179352 835.876709,433.705811 
	C834.800598,434.282227 833.966248,433.140411 832.502808,433.632935 
	C821.294922,430.902161 810.198242,429.476440 799.232483,427.363983 
	C798.091003,427.144135 796.951416,426.997253 795.772339,425.913452 
	C795.324524,425.113434 795.232361,424.609283 795.354126,423.723724 
	C796.442993,421.531616 798.396057,422.560486 800.008179,421.871094 
	C797.649231,419.869690 796.586121,418.159729 801.287842,418.219757 
	C802.987183,419.975189 803.473083,416.196808 805.058044,418.012451 
	C805.550232,418.572327 805.207886,419.261200 805.697632,419.340790 
	C806.030212,419.394806 805.795288,418.586823 806.566223,418.282837 
	C808.621765,417.654236 810.258789,417.816345 811.943604,419.274841 
	C812.774353,421.363373 812.353882,423.303528 812.623047,425.156097 
	C812.269775,423.473755 812.502991,421.789276 812.924072,419.820496 
	C820.895081,418.947021 828.259399,420.479095 835.675110,423.720123 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M831.981323,396.853638 
	C831.976013,396.534576 831.977722,396.490417 831.999756,396.488892 
	C831.505493,395.401550 831.152527,394.110748 832.644287,393.763000 
	C834.605042,393.305908 834.359924,395.050079 834.803162,396.606293 
	C836.631653,398.314484 835.734924,399.805420 835.211304,401.586731 
	C834.724365,402.052643 834.604187,402.315765 834.939453,402.835144 
	C836.962646,405.152405 834.845886,406.858215 834.118774,408.923859 
	C827.770691,410.166595 822.145813,407.665405 816.326355,406.972046 
	C808.137390,405.996399 799.932434,404.854156 791.483582,402.985657 
	C790.648193,402.640961 790.269592,402.307861 789.983398,401.482056 
	C790.647644,399.027100 792.405212,399.675659 793.885193,399.279816 
	C795.499512,398.848083 797.576538,399.835541 798.860229,397.611877 
	C803.028625,395.856598 807.051636,397.321167 811.463989,397.520569 
	C812.538391,397.564972 813.246887,397.581451 814.299438,397.491882 
	C815.298950,397.450684 815.954712,397.550507 816.875732,397.312958 
	C817.315735,397.087250 817.489075,396.993256 817.953979,396.850220 
	C818.436584,396.912170 818.610596,397.045227 818.870361,397.329041 
	C822.172119,400.260437 826.520081,398.551971 830.338501,400.282654 
	C832.546570,399.855164 831.950989,398.382111 831.981323,396.853638 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M805.117249,468.200745 
	C804.875610,467.988464 804.684265,468.019806 804.587402,468.016785 
	C803.184509,468.077301 804.198608,467.144135 803.949158,466.753754 
	C801.234985,469.285858 798.804260,467.073517 796.004028,466.094116 
	C795.564270,465.719910 795.408203,465.547668 795.161865,465.038605 
	C795.013306,463.482788 794.954956,462.263733 794.927124,460.679260 
	C798.216187,457.288574 801.831726,460.430939 805.612305,459.766602 
	C813.684082,461.736298 821.636230,461.867950 829.399536,463.296478 
	C831.422668,463.668701 833.236145,464.125763 834.999146,465.801208 
	C836.170227,467.768555 837.107788,469.519714 836.138855,471.812012 
	C831.756897,472.311340 827.823730,469.422638 823.267090,471.127930 
	C822.938293,470.992065 823.004272,470.977936 823.019531,471.008057 
	C821.541504,470.308044 820.315308,468.900513 818.089844,469.244781 
	C815.905762,470.030945 813.738159,466.981842 811.752747,469.882629 
	C811.259583,470.056519 811.046753,470.065857 810.673828,470.052368 
	C809.159302,468.351105 806.800659,469.831207 805.117249,468.200745 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M810.168457,416.122559 
	C810.390442,414.149475 809.330994,411.396545 813.217285,412.374542 
	C814.392517,412.670319 813.755249,410.160522 813.989502,408.578461 
	C814.869873,406.847687 816.259766,406.918152 817.545349,407.166809 
	C823.041321,408.229858 828.635437,408.920654 834.129517,411.495667 
	C835.056335,411.906464 835.684021,412.024597 836.788818,412.187225 
	C837.489319,412.618256 837.548157,413.028412 837.224060,413.701111 
	C836.236633,416.341797 835.933350,418.805420 835.968628,421.747742 
	C828.862183,421.418365 822.040222,419.433990 814.718262,418.231720 
	C813.330688,417.865326 812.481567,417.156616 811.185486,416.700867 
	C810.717041,416.526642 810.534912,416.443268 810.168457,416.122559 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M828.653503,499.963318 
	C831.377686,501.822815 834.240601,501.478271 836.499146,500.518555 
	C840.609985,498.771729 844.909973,499.177765 849.095032,498.565430 
	C852.506592,498.066162 854.646423,500.023163 855.131226,503.960541 
	C856.743713,506.580933 856.855225,510.031372 860.739746,510.682739 
	C861.647705,512.195740 862.309692,513.482910 863.625427,514.385437 
	C865.251404,515.500732 864.585510,516.569275 863.151978,517.800171 
	C859.222473,518.866943 857.630066,514.849426 854.171021,514.170715 
	C853.657715,513.933716 853.460022,513.824707 853.001404,513.506226 
	C852.606018,513.122986 852.471619,512.949280 852.174683,512.495361 
	C851.637085,511.473053 851.319946,510.683105 850.164673,510.212219 
	C849.455078,509.908295 849.046692,509.723694 848.323486,509.373596 
	C843.097046,506.343750 837.429688,505.977325 832.116821,504.447296 
	C830.554749,503.997498 828.887756,503.919922 827.218506,502.678833 
	C826.634583,501.973450 826.515747,501.484894 826.781860,500.621216 
	C827.426819,500.170715 827.867981,500.051117 828.653503,499.963318 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M801.813477,493.584503 
	C802.938904,492.157684 802.968994,491.275177 801.159729,491.084106 
	C799.392517,490.897491 797.515564,491.163727 796.116089,489.048157 
	C795.857239,487.550446 796.808289,487.331055 798.155640,487.152954 
	C808.804138,487.914948 818.885986,490.436188 829.554321,490.720734 
	C831.145508,490.592072 831.912842,491.328827 832.711792,492.568268 
	C830.451660,496.724915 826.372925,495.508514 822.441284,496.044128 
	C821.013550,495.471985 820.137939,495.553009 819.224976,496.737885 
	C819.015991,497.127258 819.020935,497.301849 819.014771,497.738220 
	C817.443542,497.843262 816.177979,499.370850 814.268066,498.604248 
	C813.749146,498.046783 813.592590,497.632935 813.584839,496.851471 
	C813.877808,496.172333 814.160095,495.879181 814.537964,495.638733 
	C814.872253,495.426025 814.794678,495.324921 814.269531,495.756165 
	C813.687744,496.361450 813.483093,496.871826 813.251831,497.688293 
	C813.071350,497.929169 812.657837,498.008728 812.136658,497.900635 
	C810.504150,496.138000 808.860413,495.612854 806.964600,495.406769 
	C805.208069,495.215820 803.270996,495.472473 801.813477,493.584503 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M809.568604,415.960876 
	C810.149780,415.929138 810.315430,415.973083 810.738220,416.017029 
	C811.465088,416.048248 811.917969,416.152557 812.658997,416.503784 
	C818.938416,417.747192 824.893188,418.956360 830.899170,419.802551 
	C832.732605,420.060883 833.675903,421.426880 835.542847,422.079346 
	C835.939758,422.572540 835.967957,422.971161 835.990723,423.669312 
	C828.594177,422.622620 821.203003,421.276398 813.418091,420.039856 
	C812.845642,420.287140 812.666992,420.424713 812.232727,420.340698 
	C810.604797,418.276276 808.508728,419.321991 806.396240,418.854065 
	C805.764526,419.059753 805.536621,419.233307 805.244507,418.981934 
	C804.238770,417.928223 803.344055,417.739746 802.419861,418.894653 
	C801.410095,418.411011 800.550964,417.905609 799.198914,417.896454 
	C798.212097,417.725586 797.628906,416.941528 796.520874,417.613525 
	C792.824768,418.039612 789.556030,417.780518 786.477661,415.327087 
	C785.201416,412.634827 786.609375,412.408112 788.822266,412.576508 
	C795.857422,413.747833 802.505249,414.892212 809.568604,415.960876 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M834.550293,411.497559 
	C827.883362,410.527252 821.338196,409.266174 814.387207,408.107422 
	C806.592407,407.157440 799.203308,406.105103 791.433472,404.854980 
	C790.408325,404.170166 790.357422,403.526215 790.808472,402.567383 
	C798.255737,402.295532 805.184937,404.325165 812.269531,405.216766 
	C819.284668,406.099609 826.221680,407.604340 833.494141,408.957275 
	C833.884399,409.871460 835.205566,410.157227 834.550293,411.497559 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M782.978638,384.652954 
	C782.987671,386.752594 782.939575,388.520386 782.824280,390.726166 
	C782.150208,397.224030 777.287537,395.185089 773.499084,395.956268 
	C771.987000,396.391022 770.836426,396.831390 769.263550,396.411438 
	C767.950562,391.968170 772.187622,392.609314 774.212891,390.725403 
	C774.727783,390.054993 775.266907,389.965424 775.647461,389.658997 
	C775.217407,389.674957 775.021057,390.056061 774.447327,390.441833 
	C773.046265,391.074341 771.997070,390.957764 770.894348,389.829163 
	C771.729065,386.264740 774.876587,386.468140 777.377808,385.207611 
	C777.541809,384.776398 777.601990,384.600189 777.902954,384.282593 
	C779.699646,385.177612 781.421448,381.806366 782.978638,384.652954 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M837.288757,414.042114 
	C837.083130,413.562866 837.160461,413.185638 837.251831,412.520081 
	C844.709778,413.533386 852.177429,414.720520 859.572815,416.255798 
	C860.729858,416.495941 863.615845,415.784729 863.041626,418.561737 
	C862.483337,421.262177 860.535706,419.089752 859.461548,418.948578 
	C854.079956,418.241486 848.744141,417.185211 842.981445,416.243011 
	C841.376526,416.679749 840.518616,415.855652 839.331177,415.190186 
	C838.596313,414.677887 838.084045,414.411011 837.288757,414.042114 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M835.261719,465.676819 
	C826.176514,463.892365 816.843933,463.185028 807.257080,461.663513 
	C806.601929,461.033691 806.435730,460.520813 806.520020,459.572205 
	C812.595947,457.447449 818.526733,458.947021 824.461670,459.399384 
	C826.892090,459.584686 829.244873,460.525818 832.121521,460.300537 
	C833.809692,460.944489 834.325928,462.127441 834.946838,463.681824 
	C835.119141,464.477814 835.172791,464.913300 835.261719,465.676819 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M852.244019,449.580261 
	C848.577637,449.608368 845.135681,449.305847 841.687317,449.127533 
	C840.211609,449.051208 838.879333,448.832336 839.145996,447.010590 
	C839.393066,445.322540 840.874634,445.916473 841.891663,446.022034 
	C844.988586,446.343445 848.073975,446.776337 851.602539,447.254364 
	C852.621399,447.900055 852.695801,448.566986 852.244019,449.580261 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M847.876404,440.327515 
	C853.005493,439.611603 857.880859,440.910522 862.909790,441.632935 
	C862.512085,442.480286 862.026917,442.953918 861.281250,443.645996 
	C857.636536,442.949219 853.954834,443.587433 850.285522,441.856689 
	C849.162659,441.393707 848.155090,441.613953 847.876404,440.327515 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M823.122131,471.270325 
	C827.202271,468.112915 831.238708,469.600281 835.567139,471.831512 
	C835.887573,472.029480 835.947815,472.469696 835.953979,472.691528 
	C831.604248,473.736877 827.553650,471.729218 823.122131,471.270325 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M835.896362,485.122864 
	C836.052185,486.443085 836.027283,487.399933 835.977905,488.719299 
	C834.548706,490.291748 832.914062,490.412476 830.773499,490.015137 
	C828.443359,489.515106 826.614807,488.888245 824.858582,487.233429 
	C824.879150,482.454559 827.981201,484.601807 830.524414,484.516418 
	C832.527039,484.581543 834.160583,483.894409 835.896362,485.122864 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M777.727295,384.099518 
	C778.143799,384.141205 778.072754,384.542603 778.021851,384.739960 
	C774.600281,386.893890 770.783264,387.926117 767.510986,390.130676 
	C766.011169,391.141083 764.155334,391.421722 762.110413,390.150696 
	C765.646912,386.640106 770.444397,385.638458 775.280273,383.880524 
	C776.203613,383.922089 776.757202,383.989960 777.727295,384.099518 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M846.632080,472.247498 
	C852.264404,472.439026 857.757263,472.923431 863.250061,473.407806 
	C863.187988,473.894318 863.125854,474.380859 863.063782,474.867401 
	C857.458008,474.899902 851.987183,473.602478 846.632080,472.247498 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M826.604065,500.279968 
	C827.018860,500.825226 827.052002,501.360107 827.168823,502.288696 
	C824.323914,505.361359 820.463745,504.346863 816.666321,505.213867 
	C815.390442,505.017822 814.631470,504.684509 814.080444,503.535095 
	C814.910400,502.953522 815.756226,502.794617 816.819153,502.394562 
	C820.098328,501.525482 823.160339,500.897552 826.604065,500.279968 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M847.235596,441.577026 
	C844.857361,442.419891 842.858826,441.284668 840.757751,441.139374 
	C839.651123,441.062836 838.840881,440.459534 839.208435,439.218170 
	C839.543274,438.087402 840.463135,437.567749 841.446960,438.381927 
	C842.888733,439.575073 845.208191,438.072754 846.676514,440.216522 
	C847.355957,440.618286 847.473755,440.964325 847.235596,441.577026 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M829.753052,489.515839 
	C831.626343,488.368073 833.361755,489.164703 835.517334,489.085236 
	C837.197754,492.177795 836.027832,493.030640 832.967773,492.523865 
	C831.612061,493.227356 831.061157,492.442902 830.371094,491.312134 
	C829.742249,490.803833 829.568542,490.363647 829.753052,489.515839 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M835.580322,449.677185 
	C835.874268,451.668884 835.889343,453.534729 835.836426,455.863861 
	C833.718079,457.159912 831.801147,456.268005 829.516968,455.690765 
	C829.020569,455.332001 828.853333,455.151581 828.588501,454.620026 
	C828.732605,452.034119 830.572388,452.069061 832.450806,451.678711 
	C833.054077,451.414917 833.754211,452.341492 833.682739,451.011963 
	C833.644470,450.524139 833.674377,450.325409 833.898438,449.893066 
	C834.490234,449.563263 834.893311,449.530151 835.580322,449.677185 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M852.400513,449.975769 
	C852.036377,449.231232 852.050598,448.601868 852.052979,447.657715 
	C854.104126,447.602692 856.167053,447.862457 858.629150,448.190369 
	C859.600586,448.816772 859.696106,449.483704 859.252441,450.502991 
	C856.945496,450.552551 854.862183,450.321716 852.400513,449.975769 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M835.366882,463.759277 
	C833.702515,464.057159 833.228455,463.166656 832.932617,461.705322 
	C832.510925,460.679382 832.136841,459.975861 832.282349,458.757690 
	C832.885620,457.268921 833.890137,456.975616 835.350586,456.729370 
	C835.816284,458.939514 836.486206,461.215851 835.366882,463.759277 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M836.189697,485.080933 
	C834.817749,485.427063 833.558350,485.367859 831.999146,485.419586 
	C830.501343,485.732544 830.079895,484.842316 829.526245,483.686035 
	C829.493896,483.099915 829.533508,482.864502 829.792969,482.346436 
	C831.751709,482.325043 833.490601,482.586365 835.605591,482.935242 
	C836.088562,483.573700 836.195435,484.124664 836.189697,485.080933 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M855.368164,434.479279 
	C857.896790,434.388763 860.856873,434.235138 863.573853,435.687012 
	C860.799438,436.578827 858.193726,436.260712 855.368164,434.479279 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M835.744080,456.583618 
	C835.015320,456.936249 834.289673,457.202972 833.275391,457.575867 
	C832.900818,457.903107 832.814758,458.124176 832.378601,458.418579 
	C830.801086,458.361115 829.700195,457.960052 828.715210,456.679260 
	C828.581726,456.113922 828.590942,455.876251 828.796265,455.340454 
	C831.197327,454.269653 833.154663,454.905792 835.391052,456.213989 
	C835.768372,456.327118 835.747131,456.497711 835.744080,456.583618 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M839.185913,433.525635 
	C841.164917,430.725586 842.832825,433.946106 844.755737,433.441742 
	C842.958801,434.819977 841.097107,434.471527 839.185913,433.525635 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M859.392761,450.886200 
	C859.028137,450.152191 859.027466,449.521027 859.027588,448.574188 
	C859.500061,448.330017 859.974670,448.387024 860.443176,448.475769 
	C861.672058,448.708557 863.594788,448.603546 863.153809,450.408752 
	C862.718262,452.191467 860.895020,450.611298 859.392761,450.886200 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M844.104980,489.197876 
	C842.791138,489.440491 841.430847,491.088104 840.625916,488.909821 
	C840.384216,488.255829 840.242676,487.494263 840.949219,487.178528 
	C842.770752,486.364594 843.228333,488.283966 844.104980,489.197876 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M812.419373,385.895538 
	C812.314941,385.521790 812.603577,385.262390 813.162354,384.887634 
	C814.122620,384.074799 815.025574,383.962036 816.270142,383.840942 
	C817.055786,383.817230 817.503479,383.837830 818.282349,383.919342 
	C818.831238,384.011444 819.048157,384.062897 819.575806,384.237946 
	C820.486145,384.694183 820.939331,385.168915 821.338684,386.095520 
	C821.304077,386.572845 821.188599,386.728973 820.899963,387.119324 
	C818.088623,386.905609 815.450562,386.457733 812.419373,385.895538 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M846.549927,471.688354 
	C846.771606,471.954651 846.439026,471.820923 846.262207,471.847168 
	C844.100525,471.836090 842.054382,472.441071 839.723389,471.259644 
	C842.268311,469.022186 844.286804,470.846161 846.549927,471.688354 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M886.766724,493.803497 
	C888.302246,494.210785 889.818176,493.668762 890.930542,495.348633 
	C889.960571,495.758392 888.872620,495.852936 887.377686,496.014252 
	C886.096924,495.867401 885.886719,495.265350 886.077148,494.252625 
	C886.267578,493.902100 886.402954,493.759888 886.766724,493.803497 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M835.101562,396.556946 
	C833.571899,397.798889 834.612305,392.354401 832.051819,396.134338 
	C830.731628,395.966522 831.182678,394.413116 830.176025,393.330139 
	C832.369324,393.012177 835.570190,391.588745 835.101562,396.556946 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M819.339661,496.916504 
	C819.020508,495.657043 818.671631,494.066498 820.414062,493.702545 
	C821.284485,493.520691 821.735352,494.504639 821.927063,495.705292 
	C821.458679,496.916534 820.494690,496.712769 819.339661,496.916504 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M833.791870,432.877869 
	C835.479797,431.915771 834.774231,433.607239 835.618774,434.016418 
	C836.044006,434.746094 837.127686,435.026611 836.328186,436.120300 
	C835.232971,436.043701 834.350891,435.790680 833.224609,435.284180 
	C832.552185,434.198334 833.052063,433.686035 833.791870,432.877869 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M887.053284,493.654572 
	C886.995117,493.989349 886.562378,493.995422 886.347290,494.019867 
	C884.934753,493.858246 883.762268,493.503082 884.317627,491.962952 
	C884.701538,490.898010 885.618408,491.448273 886.640137,491.858429 
	C886.994446,492.426788 887.052979,492.873291 887.053284,493.654572 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M852.890259,411.828308 
	C851.586731,411.794373 850.536377,411.055206 851.054016,410.510162 
	C851.978638,409.536804 853.764954,409.707764 854.579712,410.591614 
	C855.291565,411.363800 854.118408,411.779297 852.890259,411.828308 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M887.201233,391.512482 
	C890.243896,392.903442 889.212769,395.257263 887.753296,397.780334 
	C887.288269,395.941895 887.212402,393.939545 887.201233,391.512482 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M840.157837,410.091980 
	C839.042297,410.020386 838.193298,410.462402 837.401367,409.511536 
	C838.837463,408.404022 840.363220,409.203979 841.772156,409.264252 
	C842.337524,409.288391 842.394470,410.008881 841.848877,410.257202 
	C841.493286,410.419006 840.958435,410.187073 840.157837,410.091980 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M839.117432,415.347809 
	C840.139465,415.200195 841.170288,415.455688 842.385864,415.972748 
	C841.306824,416.896881 840.052063,417.495972 839.117432,415.347809 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M835.843079,449.667419 
	C835.491638,450.031494 835.124023,450.260010 834.471802,450.644958 
	C833.702637,450.919342 833.219666,450.912903 832.414734,450.605804 
	C831.754944,450.051300 831.573425,449.613434 831.728882,448.771973 
	C833.085815,448.016052 834.140625,448.413300 835.484192,449.139984 
	C835.810242,449.259277 835.826904,449.531830 835.843079,449.667419 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M846.953491,434.655334 
	C846.708313,433.104187 847.483154,432.807556 848.536987,433.215393 
	C848.863159,433.341583 849.274109,434.053680 849.175171,434.326965 
	C848.834106,435.268707 847.966614,434.977539 846.953491,434.655334 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M860.687378,411.076263 
	C861.578491,410.212646 862.294983,410.071533 862.750549,411.002045 
	C862.874756,411.255890 862.626526,411.943604 862.360779,412.089996 
	C861.545654,412.538910 860.890808,412.200653 860.687378,411.076263 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M835.987183,479.758636 
	C834.691345,479.980316 833.393921,479.980316 831.893433,479.980316 
	C832.761292,478.309296 834.112915,479.275696 835.511169,479.077087 
	C835.882141,479.105865 835.985596,479.536957 835.987183,479.758636 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M847.386047,441.905151 
	C847.078796,441.465881 847.107239,441.143707 847.088745,440.579407 
	C847.195374,440.235199 847.332947,440.131744 847.728516,440.029694 
	C848.518555,440.455872 849.050476,440.880585 849.738647,441.508698 
	C849.175903,441.815918 848.456848,441.919769 847.386047,441.905151 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M854.592834,434.146118 
	C854.966370,434.349579 854.926392,434.518280 854.944031,434.603119 
	C853.622070,435.440308 852.334045,435.441345 851.063782,434.463135 
	C852.019958,433.422668 853.151672,433.889130 854.592834,434.146118 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M861.414551,443.958893 
	C861.056519,442.963806 861.257690,442.174103 862.663940,441.997253 
	C863.288940,443.083557 863.486938,444.111420 861.414551,443.958893 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M861.942139,404.265747 
	C861.461731,405.029449 860.886963,405.150208 860.382812,404.615082 
	C860.243896,404.467621 860.239929,403.992706 860.372559,403.825226 
	C860.887695,403.174866 861.410828,403.465088 861.942139,404.265747 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M847.758423,489.558136 
	C847.500244,489.646027 847.136047,489.655487 846.771790,489.664917 
	C847.065308,489.603180 847.358887,489.541443 847.758423,489.558136 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M882.133667,492.306915 
	C882.818909,491.495056 882.840088,492.161774 882.867126,492.501190 
	C882.885254,492.728668 882.640747,492.977081 882.513733,493.216125 
	C882.375854,492.984344 882.237976,492.752594 882.133667,492.306915 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M858.238525,411.689819 
	C858.071106,411.032013 857.842590,410.052795 858.787537,410.571594 
	C859.466309,410.944214 859.241394,411.552856 858.238525,411.689819 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M887.252808,489.222626 
	C887.670532,489.135406 887.999329,489.321075 888.328064,489.506714 
	C888.130554,489.674072 887.933044,489.841431 887.528442,490.028137 
	C887.268860,489.863495 887.216370,489.679474 887.252808,489.222626 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M835.167480,402.705902 
	C834.842529,402.771881 834.247375,402.707855 834.927856,402.022644 
	C835.134094,402.084045 835.165955,402.260986 835.167480,402.705902 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M813.693726,503.056213 
	C814.569214,503.423859 815.073853,503.735291 815.891724,504.112183 
	C819.449280,505.093323 822.644775,503.896606 825.876770,503.874542 
	C829.656433,503.848816 833.316772,504.178711 837.294434,505.171265 
	C838.832520,505.279449 838.978455,506.681915 840.211975,507.090515 
	C840.670227,507.216339 840.853943,507.268433 841.311768,507.406006 
	C842.321533,507.730408 843.069519,507.918213 844.130737,508.090210 
	C844.622375,508.194672 844.817932,508.244354 845.303711,508.380066 
	C846.167236,508.633942 846.740723,508.800934 847.607666,508.976868 
	C848.063354,509.096100 848.238586,509.156067 848.658936,509.328796 
	C849.211914,509.600830 849.533813,509.720367 850.105896,509.703674 
	C850.337219,509.620392 850.716797,509.311981 850.888672,509.138000 
	C852.200500,509.307922 852.910828,510.021149 853.040588,511.572021 
	C852.855286,512.165527 852.609009,512.355713 852.308411,512.408691 
	C851.770020,512.503662 851.227234,512.575195 850.842041,512.041260 
	C851.217163,512.781189 851.946411,512.416870 852.793274,512.768066 
	C853.078613,512.960632 853.014282,512.989746 853.016174,512.954468 
	C856.137756,514.329529 858.558044,516.846436 861.900024,518.543091 
	C862.659363,519.239868 863.232239,519.587830 864.227661,519.872559 
	C864.791504,519.844421 864.970398,519.902466 865.065063,520.296997 
	C869.175354,526.004456 875.021301,530.123779 878.323120,536.717529 
	C877.812988,538.056763 876.998474,538.560303 875.595215,538.764771 
	C872.549805,537.995544 870.908630,535.792236 868.591980,533.919006 
	C865.781982,530.280151 861.505127,528.660278 859.343750,524.553345 
	C859.079529,523.845459 858.778870,523.486877 858.248047,523.059448 
	C857.260803,522.278564 856.124634,522.156311 855.306641,521.053833 
	C855.174011,520.774719 855.039124,520.883301 855.120422,520.853516 
	C853.746826,520.300415 852.345032,519.661804 850.723389,518.706787 
	C848.447021,517.454102 846.621399,516.091064 844.261658,514.968140 
	C843.361084,514.448914 842.917908,513.930237 842.310547,513.105835 
	C842.127930,512.819214 842.140991,512.794556 842.151489,512.783203 
	C837.688477,509.284912 832.111877,508.663055 826.909729,507.537476 
	C820.999573,506.258698 814.816101,506.243561 808.533875,505.658875 
	C809.345642,503.211395 811.853210,503.988464 813.693726,503.056213 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M878.035767,537.333862 
	C874.217163,531.027100 868.378967,526.812256 864.707336,520.739014 
	C874.575317,528.340942 882.139709,537.912964 888.918823,548.583252 
	C888.686768,549.225342 888.327576,549.548340 887.719727,549.920288 
	C882.871643,546.996521 880.530945,542.286560 878.035767,537.333862 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M861.156494,510.782227 
	C856.686401,511.532013 855.052856,509.908142 855.241333,504.729645 
	C858.500244,502.253754 860.394470,504.981079 862.868652,506.768585 
	C863.266418,508.309967 862.310913,509.040619 861.574829,510.241394 
	C861.712097,510.637970 861.883728,510.695221 861.783997,510.749695 
	C861.512634,510.746857 861.270142,510.739990 861.156494,510.782227 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M861.882080,519.221863 
	C858.204224,517.935852 855.914551,515.402283 853.083496,513.255371 
	C857.138977,512.627441 859.171082,516.289001 862.640625,517.962219 
	C862.960022,518.089844 863.049805,518.506042 863.110596,518.710083 
	C862.892029,519.075134 862.612549,519.236145 861.882080,519.221863 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M861.756226,519.405273 
	C861.721375,519.027344 862.011658,519.008179 862.736694,518.951538 
	C863.497864,519.121094 863.824219,519.328125 864.352417,519.751099 
	C863.626343,521.160095 862.876526,520.186646 861.756226,519.405273 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M861.603760,510.996887 
	C861.512634,510.746857 861.520996,510.677612 861.530762,510.629150 
	C861.715454,510.841400 861.890442,511.102142 862.065369,511.362854 
	C861.941895,511.324188 861.818359,511.285553 861.603760,510.996887 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M44.087936,521.147705 
	C43.599792,521.492310 43.239098,521.559753 42.614281,521.527710 
	C42.171860,521.378235 41.993561,521.328186 41.582207,521.124390 
	C41.242931,520.817383 41.136715,520.664062 40.969566,520.237793 
	C41.873783,519.117188 42.838932,518.269714 44.103287,517.297546 
	C44.652786,517.216187 44.903084,517.259521 45.326889,517.637817 
	C45.578552,518.469360 45.558945,518.960876 45.209534,519.746582 
	C44.995003,520.046753 44.984734,519.988403 45.013962,519.983643 
	C44.734154,520.245422 44.459824,520.544128 44.087936,521.147705 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M49.129234,516.112183 
	C48.978081,516.470581 48.687428,516.854614 48.583488,516.917297 
	C47.589119,517.266418 46.809158,517.780334 45.633575,518.223389 
	C45.131783,518.079163 44.976883,517.905334 44.612244,517.452271 
	C45.582756,516.046265 46.763000,514.919617 48.203499,513.622192 
	C48.723186,513.474243 48.982632,513.497070 49.401001,513.876465 
	C49.569950,514.758911 49.476845,515.265869 49.129234,516.112183 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M48.687416,513.683228 
	C49.558670,512.492981 50.653599,511.534576 52.033569,510.452759 
	C52.451065,510.453186 52.583527,510.576965 53.004623,511.459290 
	C53.187740,512.390442 53.082218,512.563049 52.484222,513.074707 
	C51.808270,513.493103 51.624798,513.572449 51.213394,513.846680 
	C50.985466,514.041504 50.988998,513.985474 51.016922,513.988403 
	C50.736488,514.271545 50.375912,514.440002 49.663452,514.434814 
	C49.212978,514.220520 49.062031,514.067810 48.687416,513.683228 
z"/>
<path fill="#F3CBD6" opacity="1.000000" stroke="none" 
	d="
M40.613338,520.053833 
	C41.309418,520.308228 41.710190,520.651794 42.281727,521.247925 
	C42.452492,521.500488 42.254440,521.718628 42.155769,521.826782 
	C41.188396,521.941101 40.319698,521.947327 39.020081,521.908569 
	C39.165455,521.289978 39.741745,520.716431 40.613338,520.053833 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M42.700348,618.985229 
	C43.051495,619.442810 43.051960,619.876831 43.050606,620.636475 
	C42.118195,620.947449 40.832237,621.436218 40.595104,620.092041 
	C40.388821,618.922791 41.567104,619.058838 42.700348,618.985229 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M22.910160,617.296265 
	C23.393293,617.028198 23.837238,617.007751 24.612513,617.021118 
	C24.786686,617.654602 24.629530,618.254456 24.173759,618.981995 
	C23.614367,618.897339 23.353586,618.684875 22.954342,618.257446 
	C22.834238,617.876221 22.852604,617.710083 22.910160,617.296265 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M30.613174,612.238403 
	C31.554882,611.140259 32.047668,611.287048 32.042656,612.823975 
	C31.549677,612.885010 31.066185,612.695740 30.613174,612.238403 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M50.992706,617.003296 
	C51.698723,617.570984 52.734230,617.897766 52.626289,619.033875 
	C52.603531,619.273376 51.924816,619.705994 51.696907,619.626038 
	C50.745949,619.292480 51.012493,618.414429 51.029076,617.327393 
	C51.034992,616.981628 50.995113,616.983765 50.992706,617.003296 
z"/>
<path fill="#EDE0CC" opacity="1.000000" stroke="none" 
	d="
M52.945000,622.768555 
	C52.468735,622.821533 51.990780,622.567871 51.255859,622.217285 
	C51.897820,620.807007 52.522179,621.056213 52.945000,622.768555 
z"/>
<path fill="#551D67" opacity="1.000000" stroke="none" 
	d="
M66.052620,433.574158 
	C58.419682,435.719330 50.745617,435.735596 42.938087,433.466675 
	C42.495564,432.605103 42.497219,432.101044 42.658283,431.582489 
	C42.513699,431.878143 42.436691,432.192322 42.270817,432.774048 
	C41.282925,433.336639 40.451473,433.650146 39.285473,433.982452 
	C38.605560,433.615906 38.312305,432.881104 38.596832,432.704163 
	C40.806572,431.330139 38.588001,431.688416 37.845501,431.134705 
	C37.235435,430.198120 37.216595,429.491974 37.717308,428.474182 
	C46.250893,427.379822 54.504860,428.476013 62.779964,428.946625 
	C65.580559,429.105865 65.645226,431.222656 66.052620,433.574158 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M37.523281,428.112122 
	C37.943851,428.857819 37.951008,429.541351 37.950172,430.568237 
	C33.834641,432.684967 29.849323,431.292114 25.442928,430.252258 
	C25.016785,429.602936 24.990675,429.145874 24.971996,428.345154 
	C25.412445,428.002777 25.845459,428.004059 26.601072,427.958191 
	C28.275808,426.877045 29.753119,426.908081 31.687187,427.619202 
	C33.763256,427.909882 35.436562,427.979919 37.523281,428.112122 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M31.986805,427.507019 
	C30.654869,427.893097 29.219782,427.946381 27.354183,427.955322 
	C27.522606,425.503723 28.686756,425.330780 31.986805,427.507019 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M25.072350,430.319153 
	C29.079107,430.213715 33.185371,429.295746 37.536095,430.880859 
	C40.714054,430.684631 39.833073,432.067780 38.997314,433.705902 
	C34.420681,433.878967 29.733036,434.473328 25.581951,431.106812 
	C25.203999,430.910767 25.152901,430.744568 25.072350,430.319153 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M42.284790,433.033936 
	C42.250034,432.601410 42.385693,432.179657 42.521355,431.757935 
	C42.640347,432.035156 42.759335,432.312347 42.836517,432.835693 
	C42.794708,433.081787 42.455208,433.044739 42.284790,433.033936 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M1011.405212,240.788910 
	C1011.135925,242.097672 1011.035767,243.124542 1010.916260,244.538116 
	C1009.879883,246.192093 1009.229919,248.074280 1006.683594,246.963379 
	C1004.414795,240.442642 1004.433411,240.756729 997.804199,241.149078 
	C984.702637,241.924469 971.583679,242.404877 958.500244,243.501266 
	C957.341797,243.598358 956.169434,243.535126 955.012024,243.673447 
	C950.260193,244.241394 949.569580,245.116394 950.268921,249.737122 
	C950.443054,250.887390 950.733826,252.020248 950.665161,253.621643 
	C950.103271,255.386703 949.129639,255.780884 947.430054,255.198700 
	C947.064331,254.941910 947.039185,254.964233 947.045288,254.958405 
	C946.764404,254.746796 946.520264,254.499420 946.311768,253.941528 
	C945.844482,250.300171 945.199585,246.966568 943.829102,243.405365 
	C943.290161,242.443924 942.753174,241.949478 942.222351,240.998657 
	C941.424377,239.069946 940.997314,237.409348 940.623291,235.347015 
	C939.559875,230.723221 938.668396,226.439545 937.056152,221.919617 
	C936.832764,220.954178 936.785461,220.383270 936.839600,219.357361 
	C937.393250,216.530457 939.125244,215.838669 941.283081,215.620224 
	C950.189514,214.718567 959.100708,213.976700 968.040588,213.394485 
	C980.103882,212.608856 992.228882,212.610367 1004.235718,210.828552 
	C1007.798889,210.299789 1011.532288,209.951294 1015.536011,211.481995 
	C1014.892883,219.694382 1013.798401,227.787109 1012.668335,236.310089 
	C1011.927490,237.896835 1012.143372,239.312180 1011.405212,240.788910 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M1019.430664,205.734604 
	C1019.819031,207.747391 1019.865906,209.444580 1019.929565,211.566467 
	C1019.946350,211.991135 1019.570862,211.896118 1019.377441,211.886047 
	C1019.589844,208.174377 1017.259644,208.476608 1014.434570,209.051620 
	C1009.616760,212.483276 1004.392456,210.871109 999.577637,211.386414 
	C979.962158,213.485687 960.179993,213.536118 940.575012,215.924164 
	C938.254395,216.206833 936.013245,216.740662 933.285767,217.269928 
	C930.180969,215.554916 931.412231,214.033844 933.243286,212.755524 
	C935.183105,211.401337 937.441956,210.774750 939.790833,210.558594 
	C953.836304,209.266052 967.921143,208.495758 981.986755,207.478180 
	C992.414856,206.723740 1002.799561,205.462265 1013.246704,204.956665 
	C1015.231201,204.860641 1017.210999,204.357285 1019.430664,205.734604 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M933.512573,217.518784 
	C933.790649,216.107376 933.808594,215.097321 936.109436,214.941666 
	C953.190369,213.786026 970.255554,212.398087 987.326355,211.092178 
	C995.946411,210.432755 1004.567993,209.792252 1013.608398,209.169098 
	C1014.581238,209.867004 1015.134399,210.539047 1015.837524,211.406372 
	C997.945374,212.822952 979.937744,214.519211 961.849426,215.112122 
	C954.571838,215.350662 947.320801,216.367355 940.053589,216.981842 
	C938.604248,217.104385 937.983093,217.809753 937.920410,219.606812 
	C937.263794,220.576080 936.554688,220.789963 935.380798,220.596985 
	C933.929626,219.712906 933.015625,218.844284 933.512573,217.518784 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M1006.913208,247.244293 
	C1008.753113,247.180206 1009.007812,245.348557 1010.592041,244.997025 
	C1011.235657,254.646500 1009.610596,255.332199 999.826477,255.424408 
	C992.605469,255.492447 985.218811,255.157120 978.062988,256.304840 
	C968.382446,257.857574 958.631714,256.262054 948.984436,257.631653 
	C947.926025,257.781921 947.282837,256.759644 947.071411,255.310028 
	C947.895813,254.886871 948.727356,254.831848 949.768616,254.541504 
	C951.852844,251.877213 954.491516,252.710678 957.322998,252.722168 
	C958.720276,252.919785 959.713684,253.160126 961.109009,253.000183 
	C962.717773,252.776794 963.958618,252.766083 965.565918,252.984344 
	C968.543762,253.717926 971.145508,254.228729 973.957886,252.391602 
	C976.443848,251.548767 978.524231,252.168091 981.021790,252.525146 
	C985.525635,252.528091 989.630127,252.838242 994.101440,252.211365 
	C995.244568,251.877457 996.024231,251.779053 997.179077,251.677155 
	C999.824829,251.399567 1002.221130,252.269836 1004.553467,250.617859 
	C1005.347778,249.347031 1005.795349,248.260574 1006.913208,247.244293 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M1002.874146,274.416382 
	C1004.327087,274.402588 1005.324219,274.387573 1006.321350,274.377380 
	C1007.820862,274.362061 1009.067932,274.796234 1008.915405,276.571625 
	C1008.764771,278.324799 1007.366455,277.816467 1006.241638,277.815155 
	C988.793091,277.795105 971.352722,277.982635 953.984558,279.951508 
	C952.923828,280.071777 951.362854,280.627167 951.255005,278.929108 
	C951.137268,277.076172 952.846680,277.134003 954.150391,277.050232 
	C964.593933,276.378784 975.036377,275.682587 985.484497,275.089172 
	C991.123657,274.768890 996.773376,274.635193 1002.874146,274.416382 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M940.343018,243.142303 
	C940.063538,247.250458 942.642212,250.990158 942.781677,255.174988 
	C942.872070,257.885254 941.586548,260.248810 941.955872,262.904633 
	C942.272095,265.178467 942.174988,267.354614 945.619507,266.311218 
	C947.549744,265.726532 949.130005,266.622162 950.044128,268.922974 
	C950.672852,269.885895 950.736328,270.576965 950.315491,271.634094 
	C949.504822,272.204956 948.889771,272.465851 947.942993,272.764221 
	C946.791382,271.299591 945.910400,270.093201 943.890747,271.196747 
	C942.648621,271.875427 941.371887,272.604767 939.500977,272.476715 
	C938.936218,272.225891 938.733582,272.066833 938.328064,271.567261 
	C936.772339,266.637482 938.311279,261.830933 936.965332,256.830597 
	C936.619385,255.064117 936.588989,253.688187 936.649780,251.906235 
	C936.727356,250.978073 936.825317,250.461807 937.106812,249.598755 
	C938.795837,247.560654 938.472961,245.106812 940.343018,243.142303 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M950.536194,271.967407 
	C950.083191,271.281036 950.046448,270.618011 950.062683,269.622894 
	C953.192017,269.113159 956.268311,268.935486 959.723389,268.614014 
	C962.110840,265.926239 964.901611,267.137787 967.342957,267.132294 
	C969.430969,267.127594 971.524231,267.716919 974.107666,267.274475 
	C975.489807,267.239410 976.414062,267.320343 977.676819,267.295258 
	C981.248718,265.084869 984.741943,266.118042 988.591064,266.572052 
	C989.768616,266.740417 990.523865,266.684998 991.633423,266.488831 
	C992.209045,266.363251 992.430359,266.378387 992.921997,266.587738 
	C993.406860,267.182739 993.481750,267.608093 993.216370,268.323059 
	C981.451660,269.409668 969.886230,270.207825 958.325684,271.071503 
	C955.858826,271.255798 953.409729,271.678101 950.536194,271.967407 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M948.491943,280.419312 
	C949.069031,282.835907 950.637146,283.046356 952.422485,283.015839 
	C954.249329,282.984619 956.168030,282.850555 956.948242,285.541748 
	C956.219910,287.260406 954.414490,287.427216 953.396545,289.019379 
	C952.917786,289.284485 952.698914,289.340210 952.143555,289.335388 
	C949.488159,287.388611 947.279663,288.326050 945.052368,289.502747 
	C943.346191,290.404083 941.634033,291.588074 939.498291,289.681519 
	C939.018921,288.723541 938.897644,288.025208 938.822571,286.955261 
	C938.816833,286.358215 938.826965,286.118835 938.884766,285.521484 
	C938.987488,284.928070 939.042664,284.692596 939.217651,284.113281 
	C939.539124,283.323853 939.776855,282.898254 940.272827,282.199524 
	C940.689575,281.751617 940.878479,281.593658 941.395630,281.267273 
	C943.830933,280.472931 945.905884,279.611023 948.491943,280.419312 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M937.639343,255.770584 
	C939.373291,260.903107 938.710693,265.969360 939.165894,271.412842 
	C939.563171,272.347687 939.721863,272.876892 939.653259,273.855713 
	C939.577393,276.362671 938.302979,278.576904 940.538757,280.568024 
	C941.284790,280.877930 941.446106,281.213531 941.236084,281.850159 
	C941.034729,282.069366 941.210083,282.158264 941.182495,282.252625 
	C940.506653,282.665924 939.963257,283.111908 939.314453,283.996765 
	C938.872253,284.422760 938.645325,284.542633 938.030640,284.729492 
	C936.786316,284.768646 936.045105,284.481995 935.254150,283.447510 
	C933.736877,274.980743 935.331360,266.860870 934.790039,258.758514 
	C934.691162,257.278198 935.276367,255.753922 937.639343,255.770584 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M953.087585,289.359924 
	C952.327393,286.156982 954.553101,286.461975 956.636353,286.028900 
	C963.709717,285.574554 970.406128,285.230469 977.562378,284.946716 
	C978.405334,285.539978 978.521179,286.125977 978.110962,287.152405 
	C977.101257,288.205139 976.224609,288.807892 975.266418,288.868774 
	C967.995972,289.330658 960.770081,291.123016 953.087585,289.359924 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M993.458984,268.666077 
	C993.009033,268.211578 993.002747,267.835022 992.992065,267.176025 
	C995.362976,264.262482 998.462219,265.904053 1001.213867,265.559387 
	C1003.124023,265.320068 1005.089783,265.498047 1007.481934,265.584595 
	C1008.672058,265.715607 1009.410889,265.788940 1010.509460,265.957825 
	C1011.334839,266.466339 1011.489319,266.974060 1010.921814,267.691956 
	C1010.139099,267.922729 1009.767456,268.037933 1009.141724,268.299438 
	C1007.896973,268.502991 1006.904907,268.479584 1005.543457,268.529846 
	C1001.416565,268.625549 997.659607,268.684784 993.458984,268.666077 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M982.044495,293.453186 
	C981.666138,293.893738 981.144409,293.913116 980.231445,293.903503 
	C978.408936,292.196411 978.559204,290.218750 978.882629,287.826782 
	C979.253052,285.924713 980.588257,285.246033 981.806396,284.007690 
	C984.584412,283.989594 987.004456,284.168945 989.770020,284.535522 
	C990.406494,285.099213 990.530762,285.527191 990.339111,286.300079 
	C989.216858,286.729370 988.247925,287.046356 987.318665,286.955811 
	C982.675171,286.503265 980.731750,288.353058 982.044495,293.453186 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M990.621643,286.643372 
	C990.120667,286.182556 990.073792,285.764832 990.071289,285.034912 
	C990.468567,284.680908 990.821472,284.639099 991.439819,284.634277 
	C992.039490,284.772369 992.336060,284.705566 992.828735,284.511475 
	C994.691101,284.543091 996.319702,284.534119 998.296753,284.571869 
	C998.927002,284.619476 999.208740,284.620331 999.912720,284.638763 
	C1002.331299,284.619049 1004.327698,284.556152 1006.324097,284.556580 
	C1007.182312,284.556732 1008.026489,284.742157 1007.909302,285.906555 
	C1007.787659,287.116028 1006.877014,286.906342 1006.054810,286.893372 
	C1001.062012,286.814545 996.068787,286.753479 990.621643,286.643372 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M939.721069,272.291870 
	C941.379761,271.184204 942.979492,270.614166 944.332275,269.684662 
	C947.803955,267.299316 948.243896,268.930481 947.664185,272.435699 
	C945.226624,273.278259 942.841858,273.754791 940.031006,274.269531 
	C939.542969,273.761871 939.524780,273.214569 939.721069,272.291870 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M941.431152,282.128326 
	C941.019165,281.747742 940.996704,281.426636 940.960205,280.865173 
	C942.658936,278.953827 945.027100,278.700684 947.099731,277.851257 
	C949.126465,277.020660 949.194641,278.491760 948.898254,280.285370 
	C946.477966,281.139130 944.152771,281.663208 941.431152,282.128326 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M974.093262,267.118408 
	C970.161987,268.782227 965.491150,267.613953 960.557434,268.462982 
	C960.020264,266.046204 961.697815,265.890717 963.419067,266.034668 
	C966.824951,266.319397 970.220886,266.723572 974.093262,267.118408 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M988.897949,266.425720 
	C985.651245,266.962555 982.289062,267.129303 978.471069,267.242676 
	C981.203064,263.000092 985.047974,265.052307 988.897949,266.425720 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M1007.589478,265.430450 
	C1003.209961,265.968445 998.486694,266.294617 993.375610,266.757172 
	C992.814148,266.815460 992.640564,266.737335 992.227417,266.503662 
	C996.895569,263.563721 1002.152710,265.498962 1007.589478,265.430450 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M1014.282104,276.887238 
	C1016.183960,277.766571 1017.873535,278.440826 1017.921204,281.571259 
	C1015.742737,280.359253 1013.792786,279.750031 1012.563110,278.456268 
	C1011.336243,277.165314 1011.709595,275.922607 1014.282104,276.887238 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M982.158569,283.493042 
	C981.975403,284.944916 981.691772,286.018738 980.221802,286.722595 
	C979.623047,287.364685 979.173706,287.502014 978.344788,287.155762 
	C978.021912,286.503540 977.999390,286.075928 977.999512,285.327698 
	C979.673279,284.775024 979.959351,283.110901 980.970520,282.229614 
	C982.540405,280.861359 981.792419,282.796539 982.158569,283.493042 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M1011.575317,240.956680 
	C1011.072876,239.651321 1010.611450,238.173920 1012.323975,236.899506 
	C1012.889404,238.194580 1013.474731,239.706375 1011.575317,240.956680 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1013.200439,268.400330 
	C1015.767212,267.512970 1016.242554,269.490265 1017.885620,272.010895 
	C1015.082214,271.206665 1014.317322,269.795746 1013.200439,268.400330 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M942.572510,240.804047 
	C943.234192,241.491638 943.516846,241.971436 943.748535,242.744385 
	C943.024109,243.023849 942.350586,243.010132 941.338562,242.998505 
	C941.000000,243.000610 941.000000,243.000000 941.000000,242.999817 
	C940.217468,241.612320 940.709106,240.857773 942.572510,240.804047 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M1005.415466,268.709045 
	C1006.164795,268.474274 1007.156067,268.382263 1008.517578,268.367981 
	C1007.894714,269.246857 1006.780396,269.083710 1005.415466,268.709045 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M1010.939819,267.863098 
	C1010.612976,267.421570 1010.715088,267.035645 1010.843140,266.351532 
	C1011.850891,266.089874 1012.682434,266.352509 1013.015808,267.786682 
	C1013.068481,268.128998 1012.993347,268.066284 1013.041931,268.068359 
	C1012.516602,268.019867 1011.942749,267.969269 1010.939819,267.863098 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M939.740295,271.867249 
	C939.863892,272.452667 939.835266,272.987366 939.705811,273.914886 
	C939.604919,274.307709 939.595642,274.267883 939.578125,274.266418 
	C939.435730,273.735107 939.310852,273.205261 939.228027,272.267090 
	C939.270020,271.858795 939.588074,271.816528 939.740295,271.867249 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M946.305420,253.947845 
	C946.518555,253.935455 946.739075,254.191986 947.005493,254.700562 
	C946.805176,254.707306 946.558960,254.462036 946.305420,253.947845 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M992.840881,284.414307 
	C992.759949,284.678375 992.457336,284.804688 991.929932,284.801117 
	C992.009888,284.539673 992.314514,284.408112 992.840881,284.414307 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M1000.156616,284.488892 
	C1000.051941,284.719696 999.768982,284.783112 999.065674,284.732574 
	C999.089600,284.519592 999.533936,284.420563 1000.156616,284.488892 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1004.745850,325.689636 
	C1007.338501,329.413086 1006.088501,330.996277 1002.147705,331.009308 
	C1000.061768,331.016235 997.964417,331.274811 996.072021,329.794525 
	C994.604248,328.646362 993.298157,328.928528 993.017456,331.471283 
	C992.002380,333.208618 990.496460,333.507324 989.012085,333.429749 
	C981.889343,333.057678 974.841309,334.235809 967.342407,334.320068 
	C965.259155,334.151733 963.816895,332.728699 961.613586,333.367462 
	C961.003235,333.247192 960.771545,333.132263 960.268799,332.729584 
	C958.955933,330.401764 958.163940,328.381165 960.862366,326.647705 
	C962.150513,326.594788 963.029053,326.494690 964.239929,326.396179 
	C965.176025,326.724030 965.796936,326.503357 966.698120,326.323334 
	C977.031372,325.915680 987.078918,325.640137 997.593262,325.426025 
	C998.060181,325.487427 998.511475,325.450745 998.736938,325.470764 
	C999.423828,325.447937 999.885254,325.405121 1000.693970,325.392487 
	C1001.622253,325.485992 1002.204224,325.521759 1003.076172,325.420837 
	C1003.760803,325.307953 1004.146423,325.355103 1004.745850,325.689636 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M977.638794,287.056763 
	C978.477417,286.962524 978.910339,286.993927 979.668213,286.996765 
	C980.910217,288.984161 979.951965,291.004791 979.924255,293.448669 
	C978.210266,294.058197 976.580139,294.241943 974.564758,294.560547 
	C968.398499,297.153290 962.066284,295.954712 955.700806,297.422485 
	C950.380981,296.990082 945.794983,300.255035 940.474121,298.325806 
	C939.297485,297.496857 939.088013,296.845276 940.111877,295.896973 
	C942.552490,291.076172 946.903687,289.917633 951.704956,288.956940 
	C952.058411,288.999634 952.401794,289.021942 952.573303,289.034363 
	C960.907593,288.425293 969.070374,287.803833 977.638794,287.056763 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M973.623535,296.745300 
	C976.253479,297.700562 980.777527,294.986481 979.703613,300.725128 
	C979.341614,302.659698 978.480225,303.791229 976.111877,303.879547 
	C970.999512,304.070190 965.902954,304.683868 960.450928,305.240234 
	C959.149902,307.532654 957.659363,306.389862 955.902100,305.718567 
	C953.795349,303.732910 953.498901,301.733704 954.659790,299.141052 
	C960.759644,295.787994 967.040344,296.446533 973.623535,296.745300 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M959.551331,306.873169 
	C964.792725,306.866364 969.598694,306.772827 974.404419,306.788361 
	C976.542542,306.795288 979.059692,305.877197 979.065308,309.879883 
	C979.070435,313.585815 977.202209,313.933258 974.423706,313.765930 
	C973.596558,313.716095 972.763733,313.760529 971.503296,313.719330 
	C967.475769,313.332672 963.842529,313.205658 960.285095,313.684021 
	C957.395630,314.072632 955.917969,313.049500 955.210815,309.974243 
	C955.559082,307.261627 957.254883,306.926300 959.551331,306.873169 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M959.547852,316.544220 
	C964.890198,316.520172 969.835693,316.418915 974.779236,316.256592 
	C977.081970,316.181000 979.019653,316.161957 979.065796,319.427704 
	C979.106934,322.329865 977.845398,323.021088 975.239441,323.068817 
	C970.785522,323.150452 966.337341,323.542480 961.453247,323.784485 
	C958.484558,323.444580 957.244263,321.922546 957.038696,319.046783 
	C957.304871,317.477081 957.862671,316.611389 959.547852,316.544220 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M961.115967,326.481384 
	C958.895935,328.415466 960.450928,330.396454 960.970825,332.685181 
	C955.047729,336.409821 948.509949,336.889984 941.505859,336.441620 
	C940.524841,334.796204 939.901672,333.418945 940.051025,331.466064 
	C941.522827,328.931091 943.873230,328.645905 946.130127,328.247803 
	C950.494995,327.477905 954.750732,326.142334 959.579712,325.833649 
	C960.302734,326.040131 960.631348,326.154022 961.115967,326.481384 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M955.342773,308.356140 
	C956.293701,312.162811 958.326294,313.500427 961.978455,313.124847 
	C964.745544,312.840332 967.575623,313.167725 970.725342,313.449860 
	C967.597290,313.934937 964.121521,314.192932 960.310730,314.678986 
	C954.067627,316.967316 948.044006,318.257904 941.394653,317.347748 
	C941.058533,315.989166 941.062378,314.926056 941.048706,313.463989 
	C941.050110,310.340546 943.390015,310.265106 945.083984,309.834442 
	C948.322815,309.010986 951.426208,307.168091 955.342773,308.356140 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M957.271484,318.411072 
	C958.104431,320.361664 958.643127,322.234589 960.760742,323.530151 
	C960.578491,323.812469 960.137085,323.860077 959.357910,323.913696 
	C953.345459,326.585632 947.311584,327.573181 940.745544,327.527100 
	C940.270630,325.841919 940.155212,324.383270 940.061462,322.484528 
	C943.552307,318.466003 948.130188,318.193512 953.018311,317.865295 
	C953.991882,318.039581 954.595215,318.275726 955.526001,318.367737 
	C956.210388,318.307922 956.601196,318.299377 957.271484,318.411072 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M955.929077,308.318176 
	C950.783813,309.213135 946.110046,310.754517 941.260864,312.778992 
	C938.610718,313.294586 939.293701,311.622803 939.333130,309.990082 
	C939.185303,307.979004 940.396851,307.218903 941.898560,306.214813 
	C946.562744,304.869476 950.847900,303.684021 955.700928,304.820740 
	C957.169739,305.112640 958.301331,305.160370 959.767456,305.282043 
	C960.072876,305.615173 960.043823,305.874390 960.000793,306.524567 
	C958.708679,307.298676 957.430481,307.681824 955.929077,308.318176 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M955.150269,319.008057 
	C949.861755,318.763214 945.394836,320.578522 940.460815,322.035431 
	C939.949890,320.540710 939.860291,319.042206 940.831177,317.347839 
	C947.149902,317.052185 952.869629,314.002380 959.521545,314.870789 
	C959.961182,315.293427 959.946594,315.679840 959.938721,316.356323 
	C959.095764,316.848633 958.100708,316.778748 957.630188,318.169464 
	C957.550110,318.498352 957.148987,318.296356 957.148987,318.296356 
	C957.148987,318.296356 956.701172,318.331512 956.524963,318.470581 
	C956.085693,318.864685 955.822632,319.119781 955.150269,319.008057 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M940.223694,327.661743 
	C946.313721,326.113037 952.241455,324.925476 958.594666,323.828796 
	C959.269348,324.416290 959.518555,324.912872 959.870972,325.667847 
	C956.444946,328.799377 951.932434,328.026245 947.933411,329.160645 
	C945.587585,329.826111 943.204346,330.359924 940.455078,331.020203 
	C939.569885,330.067719 939.702454,329.045715 940.223694,327.661743 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M1004.620972,303.960632 
	C1005.070251,304.406738 1005.106262,304.782806 1005.135010,305.442261 
	C997.337219,306.021210 989.546509,306.316742 981.332764,306.688873 
	C980.981689,305.961823 981.053772,305.158173 981.193787,303.955811 
	C988.909424,303.738892 996.579407,302.378662 1004.620972,303.960632 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M973.996033,296.696106 
	C967.941223,297.628754 961.882324,298.272858 955.175781,298.812378 
	C954.233521,298.068390 954.221985,297.422546 954.690613,296.508545 
	C960.989868,295.052490 967.161133,294.630707 973.764160,294.533081 
	C974.116943,295.266113 974.054443,295.836823 973.996033,296.696106 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1005.370117,325.854462 
	C1004.771545,325.647644 1004.521606,325.495636 1003.998230,325.427917 
	C1003.417847,325.515991 1003.060425,325.602631 1002.902832,325.175110 
	C1003.114990,324.311554 1003.127380,323.962158 1003.105835,323.350586 
	C1007.643555,322.244507 1011.912964,323.361328 1016.467407,325.153656 
	C1017.041138,326.573822 1018.724792,327.633728 1017.456116,329.580658 
	C1013.652466,328.269714 1009.945190,326.233337 1005.370117,325.854462 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1002.745728,324.749695 
	C1003.234619,324.771667 1003.366577,324.882355 1003.636841,325.211182 
	C1003.074646,325.544128 1002.374146,325.658905 1001.357422,325.598206 
	C1001.490479,325.227936 1001.939697,325.033173 1002.745728,324.749695 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M966.680725,326.123718 
	C966.378662,326.359497 965.773499,326.527740 964.870239,326.546875 
	C965.174011,326.283905 965.775818,326.170044 966.680725,326.123718 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M998.737183,325.412750 
	C998.962463,325.490723 998.645813,325.765381 998.645813,325.765381 
	C998.645813,325.765381 998.228638,325.723145 998.144409,325.605286 
	C998.060181,325.487427 998.511902,325.334778 998.737183,325.412750 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1002.689331,412.673584 
	C1002.054871,414.622406 997.453186,413.275238 999.798218,417.575256 
	C999.720825,418.124939 999.508606,418.357117 998.877197,418.805176 
	C990.403503,420.077301 982.324097,419.373047 973.788330,419.247681 
	C973.024170,419.009674 972.726318,418.885529 972.042908,418.463196 
	C970.652222,416.712250 970.580566,415.124176 971.157593,413.017975 
	C972.768921,410.507446 974.953247,410.528320 977.101074,410.519135 
	C983.186340,410.493134 989.271729,410.490692 995.825806,410.535645 
	C998.498962,410.568634 1000.693665,410.621338 1002.689331,412.673584 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M997.871094,421.592712 
	C998.734192,423.313995 1001.498291,423.465698 1000.448975,425.689240 
	C999.719849,427.234222 997.896851,426.976807 996.443909,426.995819 
	C988.869934,427.094971 981.295349,427.142120 973.215149,427.708618 
	C972.451477,428.194763 972.193665,428.179718 971.661621,427.885803 
	C970.537659,425.908569 970.020020,424.158630 970.791748,421.914673 
	C971.474060,421.257446 971.959473,421.010376 972.887329,420.747284 
	C980.657898,418.557831 988.155701,420.371063 995.989075,420.025024 
	C996.936707,420.368134 997.377380,420.719025 997.871094,421.592712 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M998.251526,421.939087 
	C997.769165,421.792511 997.498291,421.622101 997.081055,421.279968 
	C995.993103,419.447906 996.760803,418.740021 998.695190,418.314575 
	C999.047668,418.164307 999.496216,418.045593 999.714600,417.969177 
	C1005.167358,418.666992 1010.440552,419.257050 1015.608643,420.345795 
	C1016.889954,420.615692 1019.757385,421.076996 1018.773438,423.683380 
	C1017.894714,426.010986 1016.094604,424.345337 1014.582581,424.088074 
	C1010.019470,423.311523 1005.426208,422.712402 1000.431763,421.975006 
	C999.849670,421.798492 999.680420,421.691071 999.234619,421.701935 
	C998.958130,421.820251 998.483826,421.882294 998.251526,421.939087 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1019.147522,431.446838 
	C1018.980103,432.575775 1018.749878,433.285248 1018.208923,434.212006 
	C1015.771423,435.747284 1013.605713,435.088287 1011.029541,434.505859 
	C1006.531311,433.606537 1002.221863,433.787323 998.064697,431.506165 
	C997.257446,430.429504 997.197449,429.600647 997.771851,428.383179 
	C1005.278503,427.368195 1012.204712,429.035614 1019.147522,431.446838 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M1003.372070,413.013916 
	C1001.241943,412.703308 999.539978,412.341797 997.486755,411.841034 
	C996.327148,411.020905 996.297241,410.166931 996.872681,408.887878 
	C1003.196777,406.571503 1008.965210,407.257843 1014.725525,410.697357 
	C1016.029968,412.533417 1019.348816,411.410034 1018.934814,414.942993 
	C1013.890198,414.539734 1008.845215,413.751343 1003.372070,413.013916 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M997.551208,428.059601 
	C998.010193,428.724548 997.999451,429.420441 998.044189,430.461945 
	C997.817627,431.295807 997.418945,431.654633 996.515503,432.016418 
	C995.591125,432.252472 995.051086,432.322327 994.101685,432.372955 
	C992.088501,432.378632 990.480225,432.343536 988.469727,432.424591 
	C987.258606,432.496521 986.449280,432.471741 985.232666,432.466064 
	C981.548218,432.267303 978.261169,432.526886 974.578918,432.144531 
	C973.915161,431.942413 973.659058,431.831390 973.076050,431.458038 
	C972.267578,430.436737 972.203552,429.636810 972.762085,428.466064 
	C973.009766,428.131958 972.717712,427.833038 972.830200,427.656738 
	C980.964111,428.667877 989.046387,427.446777 997.551208,428.059601 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M999.217773,421.910400 
	C999.193420,421.513672 999.479675,421.453674 999.917908,421.773132 
	C999.838440,421.937439 999.657959,421.968964 999.217773,421.910400 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M998.572510,392.096558 
	C1001.656921,394.429535 1005.135742,393.841888 1008.591431,394.973450 
	C1011.619873,396.792908 1012.749695,398.575989 1008.901794,400.795013 
	C1005.049866,401.746704 1001.703247,400.308624 997.835938,400.457123 
	C989.429688,400.450073 981.466675,400.626648 973.043518,400.315948 
	C972.282898,400.115204 971.983215,400.013214 971.278870,399.657562 
	C969.380615,397.518616 968.857544,395.443604 969.977661,392.766815 
	C979.607117,390.267944 988.935791,389.360504 998.572510,392.096558 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M998.839600,392.091217 
	C989.487427,392.205719 980.184265,392.171478 970.477844,393.103271 
	C960.892944,396.261566 951.514771,398.117523 941.583130,398.024658 
	C941.223755,396.440552 941.126038,395.194641 941.125854,393.581726 
	C941.841370,392.371094 942.700378,391.847168 943.704346,391.738281 
	C952.047668,390.833221 960.176270,388.241760 969.109436,388.549805 
	C970.698853,388.411682 971.856628,388.496155 973.443726,388.485779 
	C974.732544,388.566254 975.591248,388.592590 976.880371,388.508911 
	C982.219177,388.786194 987.001892,387.259125 992.342529,387.469208 
	C994.797791,387.768158 997.008911,387.385864 998.798767,389.557465 
	C998.962219,390.525452 998.923279,391.095276 998.839600,392.091217 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1015.409790,411.031708 
	C1009.412537,409.412903 1003.765991,408.574585 997.514954,409.148987 
	C996.588196,409.512146 996.076416,409.599854 995.181030,409.311829 
	C993.921204,405.659271 997.507874,404.924133 999.051086,402.505768 
	C1005.776306,401.466522 1011.875732,402.393738 1017.868408,405.578064 
	C1017.371948,407.657104 1020.753052,411.133881 1015.409790,411.031708 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M999.454529,389.932953 
	C997.315369,389.121704 995.505432,389.332062 993.348999,389.209808 
	C992.715210,386.545410 994.910095,386.857697 996.214600,386.635010 
	C998.515930,386.242126 999.458984,384.905029 1000.137695,382.628357 
	C1006.179993,382.249115 1011.742798,382.825775 1016.755127,386.745087 
	C1014.689453,388.857849 1011.511780,387.960510 1009.084351,390.117523 
	C1005.898438,389.990601 1002.935852,389.389618 999.454529,389.932953 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1018.325806,405.722839 
	C1012.132446,404.200317 1005.990906,403.702393 999.471191,402.908142 
	C998.532898,403.200714 998.080322,403.127869 997.494995,402.368134 
	C997.099487,401.252441 997.179016,400.508698 997.880859,399.562073 
	C1001.592773,398.287384 1004.783569,400.292725 1008.559692,400.026367 
	C1012.256226,399.421173 1015.403870,399.696716 1018.659790,401.645142 
	C1018.851318,403.086090 1018.721558,404.282898 1018.325806,405.722839 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1018.993408,401.492981 
	C1015.866028,401.401337 1012.750916,400.913422 1009.308105,400.215454 
	C1011.242065,398.630646 1010.374817,397.177338 1009.024292,395.408325 
	C1010.879761,395.404480 1012.790710,395.872589 1014.720337,395.970306 
	C1018.109497,396.141846 1019.290283,397.956696 1018.993408,401.492981 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M940.994507,336.459229 
	C947.516541,335.179535 953.868896,334.189850 960.631226,333.133179 
	C961.041260,333.066162 961.504639,333.197174 961.735596,333.129211 
	C962.621216,332.399048 963.399109,332.259888 964.665039,332.658569 
	C974.057495,332.509796 983.055603,332.221222 992.519165,331.881439 
	C995.681946,332.434753 998.542236,331.339844 1001.553223,332.742737 
	C1002.088806,333.133820 1002.246277,333.398041 1002.399597,334.124023 
	C1002.237671,334.850403 1002.079834,335.114960 1001.537109,335.635681 
	C995.918640,337.288055 990.580627,336.380737 985.293945,336.592255 
	C978.170898,336.877228 971.008057,336.031769 963.485352,337.411682 
	C957.641052,338.230316 952.390076,339.702362 947.092468,340.970306 
	C945.039856,341.461578 942.977722,342.388184 940.573181,341.020691 
	C940.183899,339.326813 940.143494,337.992706 940.994507,336.459229 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M1002.166992,334.029480 
	C1001.992859,333.681946 1002.037109,333.270203 1001.984253,333.069885 
	C1006.362732,331.374329 1016.111450,333.937225 1018.509338,337.618042 
	C1017.374268,339.134949 1016.132263,338.367645 1014.522400,338.162292 
	C1014.189209,339.446716 1013.293213,339.237610 1012.130127,339.112793 
	C1008.888489,336.901550 1004.203064,338.503418 1002.166992,334.029480 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1004.737122,364.741638 
	C1003.727173,366.723419 1004.790039,368.302399 1005.152710,370.260010 
	C1003.814453,371.932007 1002.071228,372.144531 999.823608,372.147034 
	C992.300293,371.334137 985.231140,371.253204 978.152222,372.206787 
	C974.877686,372.647888 971.575256,372.736359 967.865112,371.955292 
	C965.328125,370.453918 964.783325,368.475159 965.285522,365.698181 
	C965.647522,365.021027 965.844910,364.781219 966.437988,364.298523 
	C977.279846,361.187592 987.948975,363.004517 998.961304,362.583862 
	C1001.248352,362.772766 1002.984192,363.213257 1004.737122,364.741638 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M999.806763,371.515137 
	C1001.545959,371.022552 1003.012329,370.856049 1004.847900,370.657532 
	C1009.215393,371.254791 1013.292236,371.452393 1017.518677,372.931091 
	C1018.251099,374.245667 1018.623779,375.431915 1019.033447,376.995972 
	C1018.331482,377.796021 1017.537292,378.004700 1016.272949,377.945465 
	C1010.905396,376.310699 1005.539490,376.686707 1000.325562,374.473419 
	C999.397156,373.511780 999.271973,372.713531 999.806763,371.515137 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1005.411987,365.047913 
	C1003.634277,364.649078 1002.261902,364.193665 1000.586060,363.542053 
	C999.382324,362.802002 999.383789,362.002777 999.937988,360.808197 
	C1006.877808,359.128448 1013.065308,360.007416 1018.771606,364.671570 
	C1018.997681,365.509888 1018.987000,365.995728 1019.012390,366.845642 
	C1014.522156,367.161560 1010.230835,365.712158 1005.411987,365.047913 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1018.918457,459.024261 
	C1012.003357,458.080139 1005.024658,456.923676 997.459351,456.991882 
	C996.063660,457.628357 995.076538,458.026947 993.578247,457.552429 
	C992.792114,453.857147 997.007263,453.520508 998.066284,450.549133 
	C1005.448914,449.432434 1011.984741,451.620880 1018.781982,454.014618 
	C1018.971558,455.785522 1018.925964,457.192322 1018.918457,459.024261 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1018.090759,444.457123 
	C1018.286560,446.453552 1018.414185,448.046356 1018.307739,449.889221 
	C1016.530396,451.560822 1014.689026,451.199005 1012.994019,450.749390 
	C1008.748657,449.623230 1004.246643,449.963379 999.735962,448.187134 
	C997.791870,446.668915 997.353882,444.850983 997.162415,442.539856 
	C997.271301,441.894379 997.352844,441.644409 997.674805,441.084412 
	C998.158386,440.681580 998.401428,440.588776 999.031738,440.471497 
	C1000.940430,440.660797 1002.470581,440.702240 1004.399597,440.691376 
	C1009.215515,441.774933 1014.056519,441.187714 1018.090759,444.457123 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M998.675537,446.815857 
	C1005.067749,448.068176 1011.144714,449.056854 1017.647644,450.092377 
	C1018.815796,451.187500 1019.206360,452.345764 1019.092773,454.008423 
	C1012.296631,453.213989 1005.576050,452.049255 998.435791,450.927246 
	C997.603455,451.365356 997.112305,451.535004 996.167725,451.321198 
	C995.235229,450.497284 995.026367,449.716248 995.063232,448.458069 
	C995.221985,447.789368 995.325867,447.532532 995.704712,446.964478 
	C996.757568,446.251007 997.550903,446.213135 998.675537,446.815857 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M999.351196,441.188812 
	C998.870911,440.912506 998.684387,440.869049 998.245483,440.688293 
	C996.840942,440.143707 995.502869,439.437317 996.129883,438.162231 
	C996.966431,436.461029 998.966187,436.763519 1001.028137,436.613831 
	C1006.908447,436.463104 1012.177185,437.411621 1017.616211,439.598328 
	C1019.525696,441.158173 1019.236206,442.773621 1018.442505,444.643494 
	C1013.879028,443.141357 1009.230347,443.188812 1004.426575,441.997314 
	C1002.644287,441.077789 1001.093018,441.705597 999.351196,441.188812 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M1018.011963,439.469971 
	C1012.504822,440.268127 1007.450806,437.497345 1001.575500,437.873901 
	C1000.985901,437.680023 1000.825745,437.476654 1000.698181,436.885925 
	C1002.826111,431.850861 1007.198425,434.833862 1010.653076,433.440918 
	C1013.030151,433.572113 1015.077454,433.898529 1017.511475,434.327087 
	C1017.954712,435.980865 1018.011230,437.532440 1018.011963,439.469971 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1017.275391,386.977142 
	C1011.784851,384.841583 1006.201538,384.290710 1000.385132,383.113342 
	C999.719543,383.202789 999.455994,383.244904 998.888000,383.025696 
	C998.197693,382.014923 998.156189,381.237457 998.597778,380.095428 
	C999.644531,379.046539 1000.666565,378.856598 1002.091980,378.725769 
	C1003.202454,378.702606 1003.929321,378.781586 1004.992676,378.969238 
	C1005.765259,379.145752 1006.195007,379.265747 1006.930908,379.465576 
	C1007.644409,379.611328 1008.051086,379.673370 1008.759888,379.710693 
	C1010.112854,379.724457 1010.968933,379.223114 1012.097046,378.547546 
	C1012.816162,378.358459 1013.239136,378.375824 1013.950989,378.611420 
	C1015.398682,380.331665 1017.186096,381.200531 1018.729614,382.820740 
	C1019.265076,384.594208 1019.124573,385.957825 1017.275391,386.977142 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M1018.959717,382.656647 
	C1017.055969,382.432129 1015.174988,381.797913 1013.243713,380.850464 
	C1014.018677,379.504059 1013.281128,377.593567 1015.618042,376.969727 
	C1016.861206,376.952576 1017.596069,377.089142 1018.700684,377.299744 
	C1019.041138,378.998169 1019.011841,380.622559 1018.959717,382.656647 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M1011.789062,337.459900 
	C1012.599182,337.457184 1013.130005,337.655060 1013.897766,338.013916 
	C1014.139648,340.654572 1012.580505,341.092712 1010.522278,341.055237 
	C1008.228271,341.013428 1005.931763,341.108612 1003.291504,341.367706 
	C1002.812317,341.852264 1002.677917,342.113251 1002.178955,342.619385 
	C997.001709,343.911041 992.143066,343.294891 986.912231,343.186523 
	C985.845764,342.895569 985.237793,342.389252 984.110352,342.724854 
	C982.560242,343.161896 981.347473,343.234619 979.781372,342.823853 
	C978.878662,342.983643 979.089844,341.169647 977.935059,342.461121 
	C976.699158,343.076141 975.718933,343.091705 974.356567,342.945068 
	C972.275635,342.313446 970.572083,342.316589 968.484863,343.053589 
	C966.095154,343.454498 964.118530,343.540894 961.896912,342.300476 
	C960.528503,340.280182 960.467773,338.531158 961.726440,336.391357 
	C973.281982,334.142914 984.665833,335.237244 995.994934,334.805786 
	C997.636108,334.743256 999.278381,334.711456 1001.343872,334.493713 
	C1004.518433,336.883911 1007.645447,338.347870 1011.789062,337.459900 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1001.886963,342.355988 
	C1002.042358,341.988434 1002.495239,341.790771 1002.720947,341.691010 
	C1008.149170,342.419525 1013.513916,342.716217 1017.993286,346.510254 
	C1016.945251,348.683655 1015.570312,346.950012 1013.977173,347.173462 
	C1009.803467,348.576111 1006.589905,346.361908 1002.856079,345.180786 
	C1002.040894,344.277771 1001.750671,343.551514 1001.886963,342.355988 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M1002.579346,343.837463 
	C1006.271606,345.115967 1009.580994,346.124298 1013.257080,347.177002 
	C1014.030212,347.526215 1014.436768,347.830963 1015.039673,348.305634 
	C1014.440735,351.622681 1011.546448,350.681305 1009.226624,351.656433 
	C1006.469727,353.758453 1003.851990,351.385529 1000.929565,352.230255 
	C989.241150,352.115631 978.008789,353.270844 966.286987,353.344788 
	C965.526367,353.268951 965.221680,353.224823 964.472290,353.043579 
	C961.567322,351.710083 959.949463,349.985596 960.517944,346.574951 
	C961.836487,344.745880 963.473572,344.211273 965.098694,344.090698 
	C977.451355,343.174133 989.810303,342.256226 1002.579346,343.837463 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M1001.749756,351.338257 
	C1004.268005,350.070312 1006.142151,351.762299 1008.594482,351.916534 
	C1011.884521,353.738129 1015.688965,353.623688 1018.691223,356.245148 
	C1018.726990,357.292358 1018.271057,357.967865 1016.961548,358.143616 
	C1011.465210,359.557526 1007.151306,356.303131 1002.051575,355.237610 
	C1001.039978,353.911316 1000.976013,352.822815 1001.749756,351.338257 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M1001.722412,354.116150 
	C1006.917725,354.657471 1011.330139,356.678833 1016.273254,358.198212 
	C1019.627441,359.329163 1019.042664,361.896271 1019.048767,364.615021 
	C1013.364075,362.011902 1007.216431,361.303253 1000.535278,361.144470 
	C999.165955,361.849945 998.145508,362.113251 996.643188,361.701904 
	C993.317627,356.898926 997.673523,356.565857 1000.399902,354.859497 
	C1000.922668,354.494843 1001.138611,354.358612 1001.722412,354.116150 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M18.572392,563.863586 
	C16.525000,563.765564 16.225409,562.656555 16.849737,561.553589 
	C17.400154,560.581177 18.422516,561.143555 19.405127,561.367615 
	C20.547537,561.628052 21.333744,562.020874 21.220207,563.111450 
	C21.063036,564.621155 19.795019,563.776550 18.572392,563.863586 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M26.690334,562.442627 
	C24.457500,564.173096 24.457500,564.173096 22.969204,560.108521 
	C24.843920,559.681580 25.471151,561.311584 26.690334,562.442627 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M707.705750,1004.693848 
	C707.863342,1005.885620 707.709290,1006.781616 707.278625,1007.891602 
	C703.144531,1005.951416 698.941895,1007.504944 694.939758,1006.963196 
	C692.959229,1006.695129 690.607727,1008.037109 688.995667,1005.305237 
	C689.485840,1004.458557 690.019592,1004.011780 690.907715,1003.465210 
	C694.538330,1003.069214 697.866150,1002.709229 701.520630,1003.828552 
	C703.872864,1002.708801 705.712830,1002.736084 707.705750,1004.693848 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M674.751953,1009.864624 
	C672.894409,1009.923096 671.254822,1009.176697 669.209106,1010.022827 
	C667.783691,1009.792725 666.709778,1009.509521 665.317017,1009.121033 
	C665.013000,1008.155640 665.027771,1007.295532 665.074707,1006.000366 
	C666.465820,1005.757507 667.824768,1005.949707 669.572998,1006.276123 
	C670.532532,1006.703918 671.087769,1006.724548 671.754272,1006.052002 
	C671.889038,1005.785034 671.895325,1005.383911 671.961182,1005.194458 
	C672.586975,1005.014343 673.146912,1005.023743 674.128296,1005.052368 
	C674.549744,1005.071655 674.477478,1005.260254 674.403809,1005.329346 
	C674.212708,1005.901611 674.345581,1006.335449 675.043762,1006.810791 
	C675.847351,1007.901550 675.302673,1008.725647 674.751953,1009.864624 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M703.126831,1010.143677 
	C698.907349,1012.881287 693.760681,1011.778564 688.319336,1012.057373 
	C687.477783,1009.507690 689.342224,1009.966675 690.739258,1009.969910 
	C694.723389,1009.979126 698.707275,1010.065613 703.126831,1010.143677 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M703.188110,985.844177 
	C702.690186,984.168762 701.401917,983.396484 699.377380,983.080444 
	C699.016785,982.570862 698.999023,982.020203 698.966797,981.055176 
	C700.711060,980.466187 702.469910,980.291504 704.603516,980.187866 
	C704.473328,982.046936 703.968323,983.835022 703.188110,985.844177 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M683.119019,996.786987 
	C686.742310,1000.391907 684.508118,1004.579590 685.414734,1008.342651 
	C682.335083,1005.346069 685.789001,1000.629517 682.105469,997.471802 
	C682.162659,996.966309 682.421936,996.783386 683.119019,996.786987 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M673.153687,993.547729 
	C670.408936,993.018616 667.861877,994.174622 664.988220,993.950928 
	C667.113281,990.728638 669.739624,991.660217 672.583130,992.082031 
	C673.308228,992.465515 673.473877,992.844727 673.153687,993.547729 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M673.271729,993.915710 
	C672.917847,993.418518 672.929260,993.061523 672.939331,992.436523 
	C676.046204,992.796936 679.291992,993.004089 682.101685,995.412231 
	C682.239746,995.978760 682.197266,996.233704 681.785156,996.605469 
	C678.922302,995.542786 676.429565,994.362000 673.271729,993.915710 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M708.036133,1004.666504 
	C706.246155,1004.651733 704.474976,1004.313904 702.310913,1003.921387 
	C701.934998,1003.481018 701.952026,1003.095337 701.950195,1002.420776 
	C703.627197,1002.062683 705.323059,1001.993530 707.432983,1001.874023 
	C707.903625,1002.027588 707.960266,1002.231567 708.089050,1002.745422 
	C708.125793,1003.484741 708.090332,1003.914062 708.036133,1004.666504 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M679.225952,987.952881 
	C680.731934,987.831482 681.075867,985.165894 682.713684,986.750427 
	C682.995361,987.022766 683.157959,987.798645 682.976318,988.105957 
	C681.995483,989.765259 680.405273,988.864197 679.037231,988.888184 
	C678.959839,988.889587 678.821411,988.705933 678.813660,988.600891 
	C678.802307,988.444519 678.882202,988.281494 679.225952,987.952881 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M689.865784,984.107422 
	C690.461121,985.156494 690.757812,986.053772 691.335144,987.799866 
	C689.625916,986.280457 687.665466,986.216309 688.174622,984.042297 
	C688.205200,983.911865 689.083374,983.979919 689.865784,984.107422 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M690.888855,1003.252136 
	C690.919617,1004.099304 690.486755,1004.748718 689.246216,1004.876892 
	C689.092712,1003.951965 689.467285,1003.229065 690.888855,1003.252136 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M683.413818,996.702271 
	C683.281738,997.007568 683.006592,997.041504 682.317444,997.112305 
	C681.903442,997.149170 681.627258,996.971069 681.521362,996.846680 
	C681.552246,996.549194 681.688965,996.376099 682.053955,995.963379 
	C682.611755,995.959473 682.941284,996.195190 683.413818,996.702271 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M717.937561,990.747925 
	C717.833557,991.947571 717.416382,993.046448 716.963928,994.497314 
	C717.576599,996.733093 716.892090,998.624939 716.945435,1000.867798 
	C717.590393,1003.382812 718.939941,1005.104370 720.741821,1006.870728 
	C721.044128,1007.011292 721.094727,1007.501770 721.043884,1007.795532 
	C720.627625,1008.160278 720.262207,1008.231140 719.617065,1008.306580 
	C717.555725,1009.403381 715.381775,1008.566223 713.271118,1009.713135 
	C712.977295,1009.941467 712.991455,1010.142395 713.027405,1010.237183 
	C712.433655,1010.097839 711.803894,1009.863647 711.150818,1009.278442 
	C713.184570,1002.607971 712.579529,995.956360 713.877808,989.232056 
	C715.344177,989.524170 716.484314,990.085693 717.937561,990.747925 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M713.384521,1009.945190 
	C713.883118,1006.562256 716.558044,1008.469604 718.904663,1008.206909 
	C718.109253,1010.957886 715.688416,1009.566101 713.384521,1009.945190 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M721.025635,1008.000122 
	C721.192200,1008.170105 721.317322,1008.346130 721.442444,1008.522156 
	C721.317932,1008.489380 721.193481,1008.456604 721.031006,1008.256592 
	C720.993042,1008.089294 720.984253,1008.006104 721.025635,1008.000122 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M973.037476,909.551758 
	C970.839844,906.950867 972.918701,903.101562 971.144531,899.562500 
	C971.513000,899.098389 971.933105,899.024048 972.671997,898.984619 
	C973.002808,902.377258 973.014771,905.735046 973.037476,909.551758 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M889.727295,890.334961 
	C888.191345,890.547729 886.631836,890.753418 884.492188,890.885376 
	C883.771545,890.662964 883.630920,890.514221 883.743896,890.192383 
	C884.141907,889.715881 884.377136,889.523315 884.883362,889.290771 
	C888.194397,886.155090 892.573792,888.737427 896.309937,886.572021 
	C897.257141,886.352905 897.802307,886.397095 898.692017,886.785339 
	C899.046997,887.000122 898.990784,887.012024 898.987000,886.983521 
	C899.359070,887.373474 899.666077,887.837463 900.002686,888.754395 
	C897.109314,890.627136 893.854187,889.622375 890.193726,890.259521 
	C889.624512,890.362671 889.703674,890.327820 889.727295,890.334961 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M56.760750,979.731812 
	C56.333618,979.901184 55.678955,979.806519 54.761261,979.504028 
	C55.176559,979.353394 55.854885,979.410583 56.760750,979.731812 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M50.901520,978.759644 
	C50.987934,978.907166 50.498627,978.996338 50.259903,978.926636 
	C50.285820,978.775269 50.550465,978.693665 50.901520,978.759644 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1001.829712,610.494385 
	C1000.306824,610.282959 998.966248,609.543579 998.155273,607.648438 
	C997.851379,607.166443 997.867371,606.883911 997.935059,606.390320 
	C998.398926,606.191406 998.825134,606.204407 999.565308,606.294800 
	C999.696045,608.065552 1001.464600,608.768311 1001.829712,610.494385 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M985.261414,595.144897 
	C985.039856,595.207214 984.590149,594.990356 984.344421,594.946411 
	C984.042236,593.971069 983.952881,592.956421 985.277344,592.925232 
	C986.091736,592.906067 986.063354,593.635010 986.006714,594.606567 
	C985.932556,594.983826 985.482971,595.082520 985.261414,595.144897 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M991.751770,611.130371 
	C992.095825,611.485291 992.109192,611.877380 991.982178,612.723450 
	C991.528992,612.741028 991.216187,612.304688 990.839722,611.599976 
	C990.991150,611.276978 991.206116,611.222290 991.751770,611.130371 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M1018.962646,178.682251 
	C1017.822510,178.677322 1015.898193,179.741348 1015.732849,177.859238 
	C1015.635803,176.755508 1017.291504,177.132141 1018.564575,176.972565 
	C1018.940857,177.419693 1018.959595,177.878845 1018.962646,178.682251 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1018.998779,191.568161 
	C1017.414124,190.331818 1017.923401,188.447128 1018.664734,186.319794 
	C1018.950378,187.764236 1018.978760,189.454041 1018.998779,191.568161 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M1019.221313,194.107117 
	C1018.966125,194.009644 1018.979431,193.796188 1019.002686,193.261108 
	C1019.012695,192.939484 1019.479675,192.980896 1019.713806,192.987320 
	C1019.795227,193.326202 1019.642517,193.658661 1019.221313,194.107117 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M938.374756,248.597397 
	C938.076477,249.416702 938.009827,249.849426 937.902466,250.609360 
	C937.062866,251.791153 936.059326,252.006409 934.568909,251.772415 
	C931.231812,250.265182 930.895264,247.598602 930.626160,244.734467 
	C930.446960,242.827713 931.756042,240.425629 928.823730,239.016785 
	C926.772949,238.542053 926.015320,237.211884 925.144531,235.462265 
	C924.524475,234.111282 924.176331,233.082825 923.801636,231.616455 
	C923.350952,227.724380 923.386780,224.249207 923.816284,220.337036 
	C925.420837,215.930176 923.667847,211.567474 925.603271,207.244995 
	C925.019226,201.828278 927.811646,196.832016 926.040161,191.374573 
	C931.414185,192.625809 937.789429,192.900787 942.361084,191.874512 
	C947.382629,190.747253 950.286255,192.117874 954.042542,193.722427 
	C954.735413,194.018402 956.401001,193.557892 956.716736,192.965973 
	C958.591003,189.452255 960.473816,191.067535 963.352478,191.819336 
	C966.802124,192.720276 970.737061,194.401321 974.546997,192.488220 
	C975.602966,191.957993 976.451111,192.221329 977.291504,192.853424 
	C978.097290,193.459534 979.039124,194.292084 979.979614,193.763657 
	C987.655762,189.451004 994.885620,194.143494 1002.308472,194.760788 
	C1002.473022,194.774475 1002.658752,194.857346 1002.797791,194.806824 
	C1008.005310,192.915421 1012.987793,193.845200 1018.339661,195.998688 
	C1021.050537,198.833740 1019.518311,202.128021 1019.855957,205.615158 
	C1009.558411,206.953476 999.349548,207.918320 989.128845,208.734711 
	C983.844543,209.156799 978.551025,209.350510 973.260132,209.841553 
	C962.043274,210.882523 950.773682,211.364746 939.521973,212.010803 
	C937.262573,212.140533 935.401123,213.272293 933.423462,214.085968 
	C931.610718,214.831772 932.057434,216.057663 933.517883,217.441208 
	C934.125916,218.344254 934.395752,218.999130 934.806213,219.825562 
	C937.939514,229.171722 939.240356,238.565781 938.374756,248.597397 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M1009.141724,615.858643 
	C1009.038574,615.583496 1009.152466,615.428345 1009.192444,615.341675 
	C1009.877197,614.584106 1010.291931,613.283020 1011.715637,614.665283 
	C1011.843689,614.935303 1011.896851,614.980286 1011.927917,614.964600 
	C1011.570007,615.383118 1011.487488,615.918518 1011.368164,616.732300 
	C1011.119080,617.083801 1010.958435,617.173889 1010.577393,617.097412 
	C1010.356995,616.930786 1010.190063,616.871582 1010.121338,616.927368 
	C1009.754028,616.727905 1009.484863,616.444763 1009.141724,615.858643 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M1009.698853,612.031799 
	C1009.223877,612.928467 1008.592957,613.049866 1007.993713,612.699219 
	C1007.367310,612.332642 1007.790588,611.838989 1008.116516,611.544434 
	C1008.669128,611.045044 1009.253235,611.051331 1009.698853,612.031799 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M976.551819,485.784729 
	C975.220520,484.263824 974.293274,482.791595 973.128052,481.086517 
	C972.851685,478.495667 974.507202,478.971680 975.955566,478.966675 
	C982.677856,478.943512 989.399902,478.880585 996.594727,478.791321 
	C997.067444,478.750763 997.502502,478.975677 997.722534,479.083130 
	C999.703491,481.221130 997.856140,482.849426 997.153564,484.898834 
	C990.305359,485.582825 983.598022,484.721680 976.551819,485.784729 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M997.369324,485.297729 
	C995.063599,482.993500 998.128845,481.729797 997.944397,479.529602 
	C1003.980103,480.127777 1010.017700,481.065002 1016.464478,482.073792 
	C1016.898987,483.439392 1016.924194,484.733429 1016.888367,486.412292 
	C1010.474243,486.339233 1004.121094,485.881378 997.369324,485.297729 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M997.118286,475.584534 
	C989.227661,475.657898 981.503174,475.496033 973.387451,475.058807 
	C968.628052,473.612396 972.110352,471.385376 972.534546,469.268524 
	C973.179871,468.536560 973.650085,468.228119 974.601440,467.864502 
	C982.110046,467.771942 989.244629,466.475769 996.573730,468.892151 
	C997.384949,469.488770 997.869751,469.749573 998.630371,470.109253 
	C999.694397,471.573517 999.874146,473.011871 999.197266,474.751648 
	C998.408264,475.101410 997.846375,475.225342 997.118286,475.584534 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M999.355225,475.124969 
	C999.158447,473.553833 997.586914,472.264038 998.778442,470.490997 
	C1005.077026,470.409729 1011.124207,471.451050 1017.479675,473.029663 
	C1017.916260,474.570862 1017.986206,475.971405 1018.174561,477.779053 
	C1012.108704,477.214966 1005.924561,476.243744 999.355225,475.124969 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M999.198853,465.661957 
	C998.953064,465.889069 998.479858,466.010254 998.248291,466.087952 
	C993.492493,468.538574 988.614563,467.192932 983.896912,467.458862 
	C981.103699,467.616302 978.288391,467.583405 975.012329,467.296387 
	C974.232910,467.088928 973.927124,466.979797 973.215454,466.596771 
	C971.488464,464.576447 971.513306,462.676056 972.416138,460.279144 
	C972.924133,459.654510 973.182922,459.454498 973.891479,459.063293 
	C981.972290,458.527893 989.619446,457.639740 997.627808,459.729797 
	C999.151184,460.194427 1000.229858,460.482239 1001.621033,460.893005 
	C1002.200439,463.106476 1000.204590,463.922607 999.198853,465.661957 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M999.165161,465.978699 
	C998.871094,463.890442 999.061829,462.054047 1001.728394,461.292236 
	C1006.905823,460.892548 1011.639893,462.466125 1016.511047,463.060791 
	C1019.125366,463.379913 1018.316833,465.363464 1018.317261,466.858887 
	C1018.317932,469.210388 1016.679321,468.153046 1015.543030,468.063629 
	C1010.975037,467.704254 1006.489014,466.295532 1001.382446,466.916077 
	C1000.753174,466.698425 1000.579712,466.560608 1000.121948,466.250885 
	C999.837646,466.078949 999.377258,466.068359 999.165161,465.978699 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M973.751648,466.402374 
	C981.678772,466.086090 989.379211,466.082275 997.548218,466.122040 
	C997.679810,466.968689 997.342773,467.771759 996.953003,468.901367 
	C989.570129,469.137177 982.240112,469.046448 974.442139,468.898041 
	C973.373413,468.227234 973.282166,467.506348 973.751648,466.402374 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M997.921143,459.688995 
	C990.348145,459.859070 982.623779,459.811523 974.429810,459.733765 
	C973.291504,458.970459 973.263611,458.134491 973.838379,456.899902 
	C976.520203,455.093994 979.218506,455.679474 982.240845,455.454041 
	C982.969299,455.456146 983.260620,455.470184 983.989990,455.452148 
	C987.060547,455.565338 989.748657,455.161194 992.634399,456.494507 
	C994.054321,456.843567 995.129028,456.913635 996.607788,457.018646 
	C996.046509,458.241302 996.769592,458.899780 997.921143,459.688995 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M999.944458,466.304749 
	C1000.136902,466.158752 1000.417053,466.281952 1000.802368,466.642395 
	C1000.634827,466.734314 1000.343018,466.632416 999.944458,466.304749 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M1010.261353,617.299927 
	C1010.356995,616.930786 1010.432190,616.941162 1010.460693,616.966187 
	C1010.782654,616.801941 1011.075989,616.612610 1011.665283,616.855469 
	C1011.989258,618.283264 1012.017273,619.278870 1012.028320,620.648193 
	C1012.011353,621.021790 1012.002563,620.997803 1012.013672,620.999146 
	C1011.730042,621.332764 1011.468994,621.689636 1010.907227,622.078003 
	C1010.210693,622.056580 1009.847778,622.027710 1009.213989,621.956787 
	C1009.902344,620.658447 1009.989868,619.151062 1010.261353,617.299927 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1011.990601,616.896973 
	C1011.715027,617.244812 1011.468811,617.202087 1010.855957,617.075317 
	C1010.798218,616.425537 1011.107117,615.859802 1011.687500,615.121460 
	C1011.979309,615.468079 1011.999634,615.987183 1011.990601,616.896973 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M336.446381,864.530029 
	C336.929932,864.832031 337.001587,865.187378 337.185791,866.074829 
	C337.002502,867.220337 336.603882,867.811584 335.967407,868.027283 
	C327.030121,871.056396 318.049194,873.929749 308.314453,875.102661 
	C306.803894,875.114746 305.646576,875.316467 304.246826,875.775513 
	C303.860443,876.200195 303.716522,876.367554 303.276520,876.386719 
	C302.522919,876.189636 302.065338,876.140869 301.275635,876.185791 
	C300.003784,877.086243 299.046326,877.845703 297.358002,877.327576 
	C296.181946,877.130249 295.324066,877.111877 294.180115,877.236694 
	C288.507172,878.441956 283.237762,877.867188 277.880615,876.542358 
	C278.815613,874.401306 280.811218,875.773987 282.207977,874.431274 
	C272.516815,871.558777 262.716858,870.259033 252.467819,868.434814 
	C259.601349,866.666748 266.374542,867.125977 273.562378,866.875488 
	C275.078461,866.799377 276.130890,866.805481 277.568115,866.720947 
	C278.663605,866.223877 279.405457,866.144348 280.562286,866.485718 
	C281.810822,866.561951 282.678070,866.570190 283.819336,866.400635 
	C284.212158,865.972534 284.330994,865.722290 284.714172,865.792725 
	C291.299438,865.983643 297.620331,865.854004 304.383118,865.604370 
	C305.033112,865.434265 305.241272,865.384216 305.712250,865.518677 
	C306.234711,865.708984 306.494354,865.714722 307.126831,865.607300 
	C307.336060,864.962769 307.509857,864.640991 308.038086,864.920776 
	C308.200226,865.237793 308.401642,865.197876 308.719940,864.873047 
	C308.840210,864.349976 308.843567,864.111816 308.899658,864.227051 
	C309.141541,864.833740 309.330658,865.087097 309.791138,865.259277 
	C310.218536,865.006104 310.374603,864.834106 310.665771,864.983276 
	C311.490082,866.214905 312.337433,866.063477 313.519196,865.500000 
	C316.717316,864.667053 319.583344,865.549194 322.784607,865.642822 
	C323.512146,865.777649 323.924591,865.797180 324.645142,865.786377 
	C326.594574,865.459717 328.297302,865.419128 330.167786,864.510071 
	C330.769409,864.435913 331.013794,864.441284 331.597626,864.585205 
	C333.302887,864.677002 334.668701,864.630249 336.446381,864.530029 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M273.149109,894.602234 
	C266.270905,897.468384 259.441925,899.452820 252.498184,900.958801 
	C241.619949,903.318176 237.643433,900.089111 236.919220,888.371155 
	C236.823013,887.741638 236.859634,887.507629 236.938446,886.920837 
	C236.980637,886.568054 237.466873,886.665649 237.627533,886.476746 
	C238.252655,886.519104 238.717133,886.750427 239.552032,887.101562 
	C240.146545,887.281799 240.370636,887.342102 240.799713,887.683777 
	C241.004684,887.965149 240.994644,888.003296 241.013992,887.999512 
	C242.764023,889.344238 245.212860,889.562927 246.769653,891.770447 
	C255.124741,897.593262 263.642303,895.003601 272.518738,893.146606 
	C273.309052,893.438965 273.461304,893.852295 273.149109,894.602234 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M233.754639,842.378784 
	C236.971909,842.267883 235.554474,844.708496 236.158783,846.520752 
	C236.518234,849.647583 237.425903,852.362061 236.870728,855.145386 
	C236.573395,856.635986 236.514664,858.858093 233.596222,857.055908 
	C230.923996,855.192688 230.212753,852.541870 229.807007,849.955017 
	C229.172012,845.906433 227.920990,841.910950 228.565125,837.371460 
	C228.853104,836.568176 228.913864,836.124939 228.998077,835.346680 
	C231.434128,835.679443 231.157547,838.267212 232.545898,840.098022 
	C232.743835,840.666260 232.808624,840.897827 232.917038,841.485718 
	C233.196426,845.330566 234.751511,848.620850 234.461090,851.677307 
	C234.583313,852.843506 235.421402,851.752563 234.877548,852.138123 
	C234.238449,849.477661 233.954666,846.751892 233.354004,843.715332 
	C233.378754,843.120300 233.445953,842.886414 233.754639,842.378784 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M228.441193,837.018311 
	C229.752579,843.498047 230.971298,849.925964 233.209442,856.522461 
	C229.599304,856.409912 227.628815,854.509644 227.994293,850.594421 
	C228.337814,846.914368 227.770401,843.313110 226.760406,839.791138 
	C226.347733,838.352112 225.955322,837.141174 228.441193,837.018311 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M273.265503,894.861267 
	C272.932037,894.468750 272.966949,894.083313 272.956848,893.410645 
	C276.864868,891.813171 280.777313,890.354309 284.789032,889.259216 
	C286.628265,888.757080 286.052338,889.743530 285.038025,890.729980 
	C284.637970,891.050598 284.389465,891.186951 284.081909,891.584595 
	C283.069244,893.025696 281.685486,892.230896 280.245972,892.757202 
	C279.932587,892.953430 280.006653,892.964844 279.980072,892.938416 
	C279.599823,893.433350 279.124115,893.770325 278.194061,893.865967 
	C276.472778,894.192749 275.053345,894.530518 273.265503,894.861267 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M247.103210,891.716736 
	C244.696518,891.525269 243.099335,889.883240 241.157120,888.302612 
	C243.100494,889.128540 246.869034,887.167114 247.103210,891.716736 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M232.288452,840.672363 
	C231.169830,839.177490 230.337448,837.333252 229.263290,835.250366 
	C228.841110,835.016907 228.660690,835.022217 228.209412,835.010742 
	C228.179443,834.703369 228.420334,834.412781 228.918182,833.995789 
	C229.418716,833.773682 229.662323,833.677856 230.237564,833.792297 
	C230.905563,834.894531 231.241959,835.786560 231.813049,836.842896 
	C232.047775,837.007141 231.996811,836.991089 232.006287,836.965881 
	C232.821960,837.965698 233.058075,839.084961 232.288452,840.672363 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M288.790100,888.120789 
	C288.880371,888.435974 288.760681,888.872009 288.640991,889.307983 
	C287.929932,888.991943 288.291687,888.614685 288.790100,888.120789 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M240.996140,887.729370 
	C240.684189,887.944763 240.403488,887.828369 240.042511,887.418701 
	C240.531174,886.319336 240.808456,886.714355 240.996140,887.729370 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M237.674713,886.255127 
	C237.788177,886.287842 237.425400,886.548767 237.203018,886.558411 
	C237.119705,886.352661 237.313232,886.237488 237.674713,886.255127 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M215.545410,789.717407 
	C215.862991,788.174377 214.295044,786.375610 216.115387,785.934143 
	C217.731964,785.542053 216.516937,787.825806 217.608139,788.754150 
	C219.638290,794.671753 220.222305,800.699585 222.448166,806.295837 
	C222.923050,807.489807 222.450134,808.520508 221.302307,809.659119 
	C221.028824,810.124390 221.023453,810.314270 221.013550,810.789124 
	C221.322372,812.616333 221.144165,814.231873 221.855606,816.040222 
	C221.992813,816.675781 221.977737,817.008667 221.960251,817.591553 
	C222.643707,818.561096 222.455856,819.448059 222.179169,820.657410 
	C221.483826,821.000854 221.039108,820.990845 220.260834,820.972412 
	C219.558136,820.469177 219.335663,819.897766 219.063934,819.038269 
	C219.047775,818.732849 219.040909,818.402222 219.030289,818.237183 
	C218.189102,808.683777 215.626770,799.524414 215.545410,789.717407 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M221.399078,809.975830 
	C221.294647,808.258057 221.626389,806.897034 220.849747,804.917053 
	C218.968124,800.120056 217.387817,795.043335 217.897827,789.322388 
	C221.206787,791.784485 219.801346,796.564209 222.643524,799.877075 
	C222.530899,803.694702 223.676254,807.132629 225.003113,810.774292 
	C225.634644,811.468567 225.772659,812.020691 225.649170,813.021973 
	C223.638519,812.994202 223.404877,810.731384 221.399078,809.975830 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M215.439697,789.383789 
	C216.749115,798.730347 219.338867,807.892395 219.138672,817.729248 
	C216.578003,811.555176 216.224258,804.628784 215.302719,797.842834 
	C214.932678,795.117859 212.656937,792.243347 215.439697,789.383789 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M225.620850,813.619507 
	C225.458939,812.884338 225.391281,812.332214 225.340637,811.365662 
	C225.697556,810.062317 226.037430,809.173462 226.498688,807.967102 
	C227.457291,813.266052 228.378128,818.356262 229.567749,823.702148 
	C230.014206,827.007874 230.191910,830.057983 230.469406,833.555298 
	C230.336777,833.978271 230.104355,833.954102 229.523529,833.899658 
	C228.716751,831.457703 228.258362,829.046021 227.617645,826.319519 
	C226.202576,822.733704 225.473541,819.369934 225.766693,815.454041 
	C225.882660,814.636414 225.798874,814.219421 225.620850,813.619507 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M201.113892,803.806763 
	C202.723053,804.273682 204.283630,805.164551 202.820847,806.905640 
	C202.143173,807.712158 200.412979,808.982788 199.507126,808.002747 
	C197.966751,806.336365 200.053024,805.250854 201.113892,803.806763 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M215.004456,823.549438 
	C213.055542,820.481079 213.067413,816.493042 212.838333,812.535522 
	C214.339264,815.844666 214.857574,819.370850 215.004456,823.549438 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M225.671356,815.299744 
	C226.384033,818.422363 226.801636,821.791321 227.327255,825.582520 
	C225.376236,822.788818 224.625931,819.315186 225.671356,815.299744 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M222.003479,815.925964 
	C220.430496,814.988647 220.461624,813.189148 220.817673,811.213379 
	C222.451523,812.304016 221.631119,814.039185 222.003479,815.925964 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M218.813599,818.848145 
	C219.350693,819.261841 219.653625,819.790771 219.941925,820.641846 
	C219.451736,820.314758 217.335236,820.771240 218.813599,818.848145 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M215.160248,823.872437 
	C216.027100,824.771667 215.977539,825.877319 215.926315,827.122559 
	C214.304810,826.717407 215.189194,825.542419 214.855713,824.489258 
	C214.822891,824.158081 215.046814,823.966492 215.160248,823.872437 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M209.183243,789.842773 
	C209.225403,789.224182 208.969299,788.358704 209.809296,788.955994 
	C210.138031,789.189819 210.433838,789.960754 210.287292,790.271057 
	C209.971161,790.940369 209.529037,790.560791 209.183243,789.842773 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M213.649094,805.200562 
	C212.944916,804.885071 212.770203,804.032776 213.331345,803.890137 
	C214.230515,803.661621 213.842133,804.555786 213.649094,805.200562 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M222.192490,820.828491 
	C221.937714,820.220825 221.946854,819.430786 221.956909,818.241211 
	C222.958740,818.627991 223.163239,819.556091 222.192490,820.828491 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M222.588806,793.080566 
	C222.343170,792.816833 222.241714,792.414978 222.197250,792.006897 
	C222.188477,791.926147 222.398834,791.821594 222.508118,791.727966 
	C222.589737,792.132019 222.671371,792.536133 222.588806,793.080566 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M214.812698,808.268311 
	C214.727295,808.772339 214.607254,809.042358 214.487198,809.312317 
	C214.372925,808.884033 214.236496,808.459595 214.162308,808.024475 
	C214.146667,807.932678 214.359146,807.801880 214.466492,807.689026 
	C214.570343,807.804138 214.674194,807.919250 214.812698,808.268311 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M225.010651,829.748169 
	C224.905167,829.587402 224.957199,829.425232 225.009216,829.263062 
	C225.062180,829.424316 225.115158,829.585510 225.010651,829.748169 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M219.653381,823.417480 
	C219.474380,823.283508 219.442642,823.030334 219.410919,822.777161 
	C219.540833,822.950867 219.670746,823.124512 219.653381,823.417480 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M222.992493,799.991821 
	C223.111313,799.581421 223.235397,799.177307 223.359482,798.773132 
	C223.977142,799.089111 223.627151,799.422974 223.193665,799.880249 
	C223.009705,800.005493 222.997742,799.998108 222.992493,799.991821 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M210.388397,797.655273 
	C210.571243,797.799072 210.600983,798.059143 210.630707,798.319275 
	C210.498901,798.136658 210.367081,797.954102 210.388397,797.655273 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M222.524994,796.547180 
	C222.471573,796.582092 222.578430,796.512268 222.524994,796.547180 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M348.120239,860.144470 
	C348.134338,860.509766 347.680389,860.693359 347.437866,860.688599 
	C346.482880,858.712158 345.387878,859.343628 344.207794,860.214355 
	C343.389984,860.817627 342.442993,861.250366 341.570129,860.414124 
	C340.669342,859.551025 341.233063,858.579834 341.716949,857.753540 
	C342.207825,856.915405 342.080902,855.388062 343.882111,855.876282 
	C345.670227,856.361145 347.522278,856.610107 349.671173,856.978638 
	C349.479919,858.000183 347.948181,858.316223 348.120239,860.144470 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M364.268707,854.984741 
	C363.975800,855.366760 363.809296,855.469177 363.350037,855.588501 
	C363.539856,853.868042 360.882751,851.880859 362.755920,850.638550 
	C365.379211,848.898621 367.335510,851.970154 369.888794,852.831909 
	C369.331512,853.433472 368.583832,853.769165 367.518921,854.130493 
	C366.329315,854.661926 365.146484,853.580688 364.268707,854.984741 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M331.938904,864.354004 
	C331.937073,864.723694 331.525421,864.982483 331.292419,865.051819 
	C329.262543,865.156128 329.378082,863.980530 329.781219,862.381714 
	C329.997742,862.003479 330.000000,862.000000 330.000793,861.999268 
	C330.189606,861.720398 330.426056,861.492554 330.907074,861.164124 
	C331.103180,861.013184 331.543304,861.006287 331.786560,861.015503 
	C332.000122,862.011292 331.970459,862.997803 331.938904,864.354004 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M350.002197,857.002441 
	C350.023529,855.588562 350.694550,855.307800 351.825684,856.020996 
	C352.833435,856.656372 352.349243,857.574829 351.813324,858.028015 
	C351.013519,858.704285 350.978638,857.428894 350.234253,857.107178 
	C349.996033,856.994812 350.000000,857.000000 350.002197,857.002441 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M370.424683,848.732239 
	C370.842468,848.861938 371.111237,849.144714 371.380005,849.427551 
	C371.265961,849.512756 371.070740,849.688049 371.050171,849.669495 
	C370.777649,849.424011 370.529724,849.151306 370.424683,848.732239 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M330.829224,861.002258 
	C330.917480,861.323242 330.731842,861.633301 330.273926,861.970947 
	C330.001617,861.998596 329.958679,861.502319 329.982971,861.254578 
	C330.189941,861.001648 330.372620,860.996521 330.829224,861.002258 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M331.993225,860.990723 
	C332.112793,861.002625 332.112213,860.111633 332.192444,860.974854 
	C332.029785,861.024780 332.003876,861.003235 331.993225,860.990723 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M368.567627,850.428223 
	C368.620972,850.510193 368.409790,850.543701 368.409790,850.543701 
	C368.409790,850.543701 368.514282,850.346252 368.567627,850.428223 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M280.784912,866.312256 
	C280.195099,866.633362 279.446655,866.713013 278.325562,866.711548 
	C278.176605,865.909668 278.209564,864.748779 278.660767,864.553345 
	C279.864563,864.031860 279.998627,865.486755 280.784912,866.312256 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M284.998047,865.765320 
	C284.978516,866.113281 284.547363,866.261536 284.320312,866.242188 
	C284.229309,865.611572 284.365356,865.000366 284.765686,864.207520 
	C285.025879,864.489746 285.021759,864.953552 284.998047,865.765320 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M288.002838,858.997803 
	C287.878357,858.852722 287.751038,858.709839 287.623779,858.566895 
	C287.711975,858.617493 287.800171,858.668152 287.942108,858.862122 
	C287.995819,859.005493 288.000000,859.000000 288.002838,858.997803 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M285.738708,863.151245 
	C285.876862,863.365906 285.715454,863.628052 285.244720,863.925781 
	C285.109100,863.706787 285.277008,863.452576 285.738708,863.151245 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M281.456970,864.538757 
	C281.424683,864.482971 281.489288,864.594543 281.456970,864.538757 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M274.530090,864.553345 
	C274.475922,864.585938 274.584229,864.520813 274.530090,864.553345 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M323.071045,865.481445 
	C320.218872,867.325928 317.332306,866.447754 314.131531,865.556824 
	C314.548279,863.779297 315.279755,862.223328 316.008911,860.330566 
	C316.006561,859.993713 315.999451,860.000916 315.996735,860.005005 
	C316.457581,859.597290 316.499817,859.006958 316.823029,858.233398 
	C316.996735,858.004700 317.000000,858.000000 317.001892,857.998169 
	C317.003754,857.996338 317.494568,858.037170 317.763000,858.032410 
	C315.890869,862.612549 320.100830,862.564087 322.635803,864.025635 
	C322.962006,864.471375 323.002197,864.838074 323.071045,865.481445 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M308.038055,858.059082 
	C308.530853,857.086426 308.908447,856.407837 309.421356,855.486145 
	C310.341034,857.525208 309.050812,858.752991 308.516479,860.117371 
	C308.361328,860.513550 307.540771,860.655701 307.432068,860.100525 
	C307.328278,859.570374 307.738556,858.939636 308.038055,858.059082 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M305.996399,865.403198 
	C305.975037,865.703247 305.575012,865.907959 305.575012,865.907959 
	C305.575012,865.907959 305.134583,865.817688 304.979797,865.651001 
	C305.073669,864.968933 305.322357,864.453613 305.571014,863.938232 
	C305.719940,864.326538 305.868866,864.714783 305.996399,865.403198 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M308.863159,864.281799 
	C308.952393,864.580322 308.888580,864.569153 308.862732,864.578613 
	C308.698517,864.058289 308.560150,863.528503 308.421783,862.998718 
	C308.490662,863.049316 308.604858,863.088867 308.620514,863.152588 
	C308.687500,863.425537 308.725372,863.705750 308.863159,864.281799 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M312.216553,858.895142 
	C312.097839,858.638428 312.285431,858.356140 312.730469,858.031494 
	C312.987915,857.989197 312.999146,857.999146 313.002502,858.003113 
	C312.844818,858.294556 312.683838,858.582031 312.216553,858.895142 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M312.027954,859.034424 
	C311.976135,859.399353 311.810547,859.679016 311.220337,859.901672 
	C310.979797,859.564331 311.175232,859.304871 311.684387,859.016235 
	C311.910217,858.920715 311.990753,858.994507 312.027954,859.034424 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M311.074097,860.087463 
	C310.933136,860.298401 310.650360,861.059814 310.728149,859.988403 
	C310.872253,859.890015 311.009552,860.018921 311.074097,860.087463 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M293.573303,863.600342 
	C293.481140,863.676453 293.443970,863.399353 293.443970,863.399353 
	C293.443970,863.399353 293.665436,863.524170 293.573303,863.600342 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M290.430664,863.559875 
	C290.390320,863.489929 290.471008,863.629822 290.430664,863.559875 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M310.827332,865.074829 
	C310.800873,865.304382 310.424500,865.282715 310.243469,865.230408 
	C310.215668,864.804199 310.239746,864.123352 310.827332,865.074829 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M307.949280,865.002197 
	C307.998840,865.277771 307.685272,865.451477 307.592438,865.472778 
	C307.632965,865.238220 307.766357,864.982422 307.949280,865.002197 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M324.938507,861.617798 
	C324.507751,862.324097 324.003387,862.660767 323.246552,863.188904 
	C322.713654,860.653503 323.519318,858.287292 325.691559,856.128967 
	C325.639069,857.745544 325.251984,859.496887 324.938507,861.617798 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M325.977966,853.316162 
	C327.320374,853.606567 327.153809,854.584045 326.272644,855.838257 
	C325.991028,855.251587 325.976379,854.477966 325.977966,853.316162 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M317.994690,857.992676 
	C318.121887,857.769104 318.259979,857.557983 318.398102,857.346802 
	C318.405701,857.548218 318.413300,857.749695 318.226166,857.989380 
	C318.031403,858.027649 318.005615,858.005005 317.994690,857.992676 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M232.002930,841.005310 
	C232.019470,839.933594 232.036728,838.845520 232.034882,837.348999 
	C234.634262,837.484558 233.594543,839.753662 234.035339,841.705566 
	C233.996155,842.105042 234.080856,842.328003 234.072144,842.446899 
	C233.230331,843.439209 232.957397,843.275513 232.205353,841.291016 
	C231.969650,840.989075 232.003647,840.988892 232.002930,841.005310 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M329.682617,862.112183 
	C330.174896,862.894043 330.352051,863.784668 330.794312,864.898193 
	C329.444611,866.389648 327.492920,865.630981 325.341553,865.881470 
	C326.896515,865.166809 328.277405,863.875366 329.682617,862.112183 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M324.991547,862.012695 
	C325.601685,861.617859 326.218079,861.213501 326.834473,860.809143 
	C326.851074,861.276672 327.057037,861.876099 326.843170,862.183044 
	C326.450165,862.747070 326.077332,864.466125 325.039337,862.282593 
	C325.012085,861.987366 324.997772,862.003235 324.991547,862.012695 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M330.000610,854.973877 
	C329.725861,854.634216 329.456055,854.322083 329.186249,854.009949 
	C329.357605,853.867493 329.528961,853.725037 329.700317,853.582581 
	C329.783569,853.869263 329.866821,854.156006 329.950073,854.718628 
	C329.950073,854.994507 330.005585,855.001465 330.000610,854.973877 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M316.720367,858.137451 
	C316.845398,858.580750 316.694061,859.156738 316.268372,859.870972 
	C316.144012,859.429443 316.294006,858.849854 316.720367,858.137451 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M481.247284,432.239899 
	C479.015228,430.383240 479.650665,429.049530 481.738525,428.562988 
	C485.016663,427.798981 488.389069,427.439484 492.810669,426.735260 
	C489.329376,430.638489 486.671906,433.788574 489.225586,438.538696 
	C489.175507,439.248352 488.794708,439.465790 487.950836,439.479584 
	C486.326874,439.705475 485.351440,439.155579 484.245972,438.053070 
	C483.835541,437.660309 483.682831,437.492981 483.358093,437.035950 
	C482.567963,435.347870 482.120880,433.878296 481.247284,432.239899 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M476.987854,427.889099 
	C475.008789,427.515594 472.958893,427.098419 475.674408,425.188049 
	C476.656464,424.497162 478.095642,424.456085 479.689209,424.166077 
	C481.230743,427.043915 478.843567,427.137177 476.987854,427.889099 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M486.825714,439.170563 
	C487.549438,438.954956 488.095490,438.935181 489.050049,438.882019 
	C491.655914,439.115265 493.533813,438.365051 495.575745,436.973877 
	C495.921936,436.912476 496.340424,437.012238 496.394897,437.220337 
	C494.458954,441.209778 490.934021,439.794434 487.469879,439.826660 
	C486.925201,439.584259 486.786621,439.475311 486.825714,439.170563 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M491.055786,433.203491 
	C491.990723,431.469421 493.351227,431.587128 494.926758,431.417236 
	C493.061157,435.271362 493.061157,435.271362 491.055786,433.203491 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M491.335510,422.809570 
	C491.203461,422.363525 491.447754,421.997009 491.781067,421.429382 
	C493.397949,420.986328 494.810608,421.117615 495.956421,422.502106 
	C494.545258,423.314362 493.100311,422.831238 491.335510,422.809570 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M481.045837,432.330688 
	C483.300537,432.520355 483.425690,434.643341 484.206085,436.597412 
	C482.112793,437.615204 481.841156,436.117767 481.283997,434.448395 
	C481.075806,433.663849 481.048157,433.179169 481.045837,432.330688 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M481.090546,434.456635 
	C481.907318,435.078461 482.711151,436.008423 483.834717,436.947021 
	C484.154449,436.955688 484.080139,436.995270 484.063354,436.956665 
	C484.387421,437.383026 484.508392,437.899536 484.124664,438.765106 
	C482.443726,439.183533 482.428070,437.829010 481.577881,436.917877 
	C481.368378,436.693207 481.289185,436.313873 481.177673,436.155243 
	C481.069977,435.585999 481.073822,435.175385 481.090546,434.456635 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M498.976379,435.002960 
	C498.898865,435.933929 498.812195,436.534943 498.682587,437.433655 
	C497.505463,435.718872 498.296265,434.319092 498.634888,432.892426 
	C498.745667,433.485962 498.856445,434.079498 498.976379,435.002960 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M483.870850,439.061401 
	C483.892548,438.591064 483.945374,438.119476 484.022400,437.282959 
	C485.319031,436.911743 485.492645,438.310516 486.704712,438.868988 
	C487.003357,438.974731 487.070618,439.331238 487.067200,439.512207 
	C487.053558,439.918274 487.043304,440.143372 486.984802,440.703003 
	C486.771729,441.134613 486.606873,441.231659 486.197876,441.178040 
	C485.953705,441.027344 486.000549,441.000641 485.989990,441.025513 
	C485.810852,440.772064 485.597473,440.533875 485.148071,440.189270 
	C484.956787,440.042755 485.000000,440.000000 484.978699,440.021912 
	C484.779449,439.782715 484.576691,439.542572 484.156342,439.187195 
	C483.963562,439.050995 483.901947,439.060150 483.870850,439.061401 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M488.599274,442.031464 
	C488.760559,442.358246 488.596863,442.656525 488.192017,443.076996 
	C487.639496,442.975281 487.328186,442.751312 486.994110,442.239685 
	C487.405670,441.968964 487.839996,441.985962 488.599274,442.031464 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M496.051392,437.043976 
	C496.109680,436.675293 496.297363,436.438080 496.485077,436.200867 
	C496.560333,436.480438 496.635590,436.760071 496.580109,437.234070 
	C496.449341,437.428467 496.180786,437.175446 496.051392,437.043976 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M485.926208,441.348083 
	C485.953705,441.027344 486.446136,440.977600 486.691345,441.007568 
	C486.936554,441.037567 487.031799,441.526154 487.039917,441.774841 
	C486.664917,441.905304 486.281799,441.787079 485.926208,441.348083 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M490.499146,482.001038 
	C491.153046,482.296539 492.472717,482.126007 491.594666,482.783356 
	C490.735535,483.426636 489.043091,483.657318 488.468201,482.179718 
	C488.277100,481.688446 489.543152,481.995148 490.499146,482.001038 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M472.984558,484.998047 
	C472.749146,485.823364 472.061462,486.034332 471.488708,485.679626 
	C470.853790,485.286407 471.582184,484.965057 472.016846,484.476715 
	C472.418488,484.467407 472.585968,484.612976 472.984558,484.998047 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M515.621704,490.053375 
	C515.635193,490.072113 515.645447,489.708374 515.520264,489.585449 
	C515.395142,489.462524 515.123413,489.475128 515.123413,489.475128 
	C515.123413,489.475128 515.242737,489.801178 515.321594,489.896240 
	C515.400452,489.991272 515.513306,490.021332 515.566528,490.047546 
	C515.619751,490.073761 515.608215,490.034637 515.621704,490.053375 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M466.999481,487.999390 
	C467.273346,487.888458 467.547760,487.778137 467.913666,487.830261 
	C468.005188,487.992737 467.999146,488.000854 467.995911,488.004089 
	C467.826355,488.176178 467.660065,488.345062 467.247498,488.257568 
	C467.001221,488.001221 467.000000,488.000000 466.999481,487.999390 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M454.745819,498.110504 
	C454.768402,498.290527 454.542786,498.579834 454.039246,498.943115 
	C454.006744,498.751312 454.252197,498.485535 454.745819,498.110504 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M434.093323,479.648163 
	C433.954529,479.941956 433.490601,479.993103 433.258636,480.017822 
	C432.981720,478.836487 433.497925,477.921936 434.766968,477.079956 
	C434.781311,477.725861 434.506744,478.540100 434.093323,479.648163 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M483.870422,439.406738 
	C484.290833,439.183838 484.618073,439.316711 484.951355,439.746674 
	C484.564026,439.950043 484.170624,439.856293 483.870422,439.406738 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M484.827637,440.395691 
	C485.301208,440.181122 485.645599,440.319489 485.984741,440.754089 
	C485.552460,440.949768 485.125488,440.849182 484.827637,440.395691 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M581.642212,859.112244 
	C588.349182,856.264526 594.661865,853.391418 601.038086,850.666992 
	C602.759705,849.931396 604.425537,849.128479 606.563171,850.537292 
	C609.029114,852.162598 612.001404,849.634644 614.937317,850.992065 
	C615.227661,852.664307 614.019348,852.755066 613.035156,853.463623 
	C612.750427,854.109436 612.512146,854.446899 611.829895,854.507690 
	C610.511780,854.696716 609.476990,855.054749 608.156494,855.578613 
	C607.768555,856.175232 607.517578,856.485718 606.835205,856.532471 
	C606.194824,856.483765 605.836975,856.578430 605.218628,856.770630 
	C603.097412,859.134644 599.924683,859.050415 597.521301,861.026733 
	C597.040527,861.294434 596.846680,861.394287 596.360107,861.627563 
	C595.297424,862.088684 594.532959,862.424255 593.841370,863.418640 
	C592.343994,865.192139 590.832764,866.145630 588.442078,865.342285 
	C587.441833,864.057251 588.290100,863.322021 588.926697,862.177368 
	C583.858643,863.266357 579.916687,866.131592 575.691101,868.374451 
	C573.421082,869.579407 571.328857,871.431213 568.131836,870.353027 
	C566.894592,868.377075 568.036560,867.364075 569.283997,866.539978 
	C573.202515,863.951294 576.765442,860.778931 581.642212,859.112244 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M587.352539,864.764648 
	C589.878357,864.990723 591.683289,864.708801 592.901062,862.567749 
	C593.578857,861.283142 594.617920,861.612732 595.768372,861.208130 
	C596.047546,860.998108 595.990051,860.981323 595.981201,861.010010 
	C596.859741,860.303772 597.976074,860.442688 599.397949,860.331299 
	C600.562500,860.803650 601.023804,861.429443 601.117798,862.647705 
	C592.960999,867.082703 584.892151,871.091919 576.873901,875.199768 
	C574.921021,876.200195 573.412170,875.750732 571.863464,874.092041 
	C571.073120,871.940796 571.592773,870.646729 573.333862,869.642151 
	C576.636963,867.736511 579.743774,865.466370 583.824768,864.341064 
	C585.055847,864.166321 585.913635,864.345093 587.352539,864.764648 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M586.341919,865.240906 
	C580.607361,866.384460 575.664429,868.571899 571.875122,873.374512 
	C569.763000,873.476929 568.326050,872.366882 567.398682,870.241760 
	C574.000793,869.851624 578.265381,864.746033 583.753540,862.310852 
	C586.316772,861.173462 588.566589,860.790161 591.194275,861.121460 
	C591.199036,863.479187 588.858032,863.042969 588.075195,864.644897 
	C587.940002,864.952698 587.976807,864.988220 587.986328,864.965576 
	C587.635071,865.337524 587.189148,865.503662 586.341919,865.240906 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M567.577942,869.560547 
	C567.427185,869.892212 567.431702,869.917847 567.439148,869.907043 
	C566.376465,869.709045 564.879517,870.445251 564.307922,869.329346 
	C563.619080,867.984497 565.149658,867.367126 566.016113,866.806274 
	C571.080322,863.528625 576.201782,860.339661 581.645630,857.044067 
	C581.993103,857.436890 581.998901,857.906433 582.008606,858.728821 
	C577.251282,862.464111 572.489990,865.846558 567.577942,869.560547 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M614.632385,859.839294 
	C618.936279,854.401001 621.406067,854.275269 624.354492,859.430908 
	C624.390564,859.780579 624.037476,860.037537 623.899658,860.209167 
	C621.262329,858.210144 618.665649,858.174500 615.616089,860.142822 
	C615.073425,860.205811 614.897705,860.152710 614.632385,859.839294 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M600.433594,861.199463 
	C598.951538,861.175598 597.868958,861.146362 596.379395,861.077881 
	C598.082153,858.399902 601.213074,857.759460 604.578491,856.851501 
	C604.980164,857.575684 605.002075,858.283081 605.051941,859.343140 
	C604.051758,861.293518 602.455566,861.281189 600.433594,861.199463 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M615.436890,863.539612 
	C615.204773,863.616516 615.357178,863.555969 615.492065,863.468445 
	C617.158630,862.386902 618.782471,860.989685 620.930786,862.094238 
	C621.210449,862.238098 621.306213,863.604797 621.017883,863.847595 
	C619.201416,865.376587 617.522766,863.973877 615.436890,863.539612 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M600.134888,861.444092 
	C601.128113,859.541321 602.935608,860.510315 604.715698,859.865234 
	C605.525940,860.079102 607.653748,859.593506 606.011475,861.022766 
	C604.874451,862.012268 603.171326,862.351196 601.366211,863.008972 
	C600.752747,862.585938 600.494202,862.134644 600.134888,861.444092 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M640.452087,848.026794 
	C639.650879,849.094360 638.758362,849.146240 637.882935,848.570312 
	C637.423157,848.267761 637.428589,847.719116 637.897827,847.426453 
	C638.784790,846.873413 639.675964,846.926453 640.452087,848.026794 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M614.804443,863.454346 
	C615.060486,863.689575 615.018066,863.643188 615.012939,863.611816 
	C615.088074,864.021423 615.168396,864.462402 615.377319,865.215332 
	C615.434204,865.716064 615.362488,865.904846 615.002075,866.185547 
	C613.881592,865.299866 613.478943,864.299255 614.804443,863.454346 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M622.186646,849.890259 
	C622.392456,849.462524 622.893677,849.144348 623.698242,848.905518 
	C623.495056,849.323181 622.988586,849.661499 622.186646,849.890259 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M586.375549,850.505188 
	C586.238281,849.847534 586.590759,849.248108 587.815063,849.138916 
	C587.693237,849.571838 587.200928,849.992920 586.375549,850.505188 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M588.433105,849.298950 
	C588.255127,848.546265 588.713928,848.135010 589.836182,848.113403 
	C589.703369,848.524658 589.227112,848.904236 588.433105,849.298950 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M573.979736,856.968384 
	C573.886780,856.999329 573.810730,857.049377 573.885925,857.059021 
	C574.037231,857.018555 573.996643,856.987549 573.979736,856.968384 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M606.833008,856.464600 
	C606.823364,856.193420 607.094055,855.997620 607.617798,855.773132 
	C607.618347,856.009644 607.365906,856.274780 606.833008,856.464600 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M615.075439,860.085815 
	C614.947571,860.416382 614.645996,860.573914 614.344482,860.731506 
	C614.305420,860.483521 614.266296,860.235535 614.385010,859.783203 
	C614.542847,859.578918 614.901794,859.912842 615.075439,860.085815 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M611.828735,854.415771 
	C611.742004,854.060730 611.999695,853.864380 612.561523,853.698669 
	C612.572632,853.929382 612.341797,854.211121 611.828735,854.415771 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M615.647644,867.314453 
	C615.163269,867.305237 614.964722,867.057922 614.782349,866.509766 
	C614.842773,866.150757 614.972046,866.024170 615.303589,865.712463 
	C615.809448,865.701782 616.010803,865.956848 616.167480,866.535034 
	C616.099365,866.899780 615.973877,867.022217 615.647644,867.314453 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M344.839111,865.161377 
	C356.293274,860.983032 367.782074,857.081787 379.645233,853.188721 
	C380.171509,853.334473 380.323395,853.472046 380.596771,853.892822 
	C380.782623,854.581665 380.789581,854.987732 380.643677,855.684326 
	C380.391418,856.329346 380.204346,856.673950 379.855774,857.249695 
	C379.560425,857.819275 379.427032,858.154175 379.297913,858.761658 
	C379.286255,859.196899 379.299377,859.370972 379.372437,859.798828 
	C379.616608,860.596313 380.044647,860.916992 380.763611,861.357178 
	C382.883942,863.512085 384.915314,860.412048 387.035675,861.947937 
	C387.476624,862.631470 387.526031,863.085205 387.248230,863.844604 
	C374.715851,870.933716 361.631622,876.065186 348.324158,881.518921 
	C346.715332,880.815002 346.512726,879.641541 346.597717,878.386719 
	C346.916534,881.870605 344.533142,882.627747 341.399963,882.912537 
	C339.931702,882.281067 338.796326,881.674194 337.336731,881.041626 
	C335.748352,880.097595 335.370331,878.975281 336.437256,877.327515 
	C336.818176,876.944580 336.980835,876.804565 337.405762,876.484375 
	C338.210114,875.998901 338.781067,875.787109 339.672668,875.851562 
	C340.309479,875.898987 339.911499,876.705139 340.545959,876.171692 
	C340.683105,875.521179 340.676300,875.143250 340.531616,874.464661 
	C340.406738,873.274048 340.769745,872.553284 341.623657,871.750488 
	C342.252930,871.417053 342.644196,871.314270 343.336823,871.263428 
	C344.511658,871.206787 344.796143,870.745422 344.438293,869.642212 
	C344.182709,869.004822 344.038483,868.637207 343.796417,867.984314 
	C343.651550,867.505249 343.609131,867.309570 343.581604,866.815186 
	C343.830933,865.930298 344.312042,865.636597 344.839111,865.161377 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M413.402893,850.459351 
	C415.105438,845.915894 420.596954,845.889771 423.866699,842.357910 
	C424.003082,842.044556 424.016449,842.020203 424.026001,842.011292 
	C425.290894,840.729004 427.300690,840.799255 428.767181,839.255432 
	C429.004578,839.031860 429.013733,839.013184 429.026794,839.015686 
	C430.872406,838.825195 432.704895,838.632141 434.759155,838.689209 
	C427.911194,842.741760 420.841461,846.544189 413.402893,850.459351 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M387.404022,864.080505 
	C387.028320,863.666077 387.009857,863.197754 387.127777,862.083130 
	C388.421021,860.105896 390.027344,859.424438 391.717194,858.310303 
	C392.121124,857.969666 392.287018,857.838562 392.716125,857.530212 
	C393.346680,857.141785 393.726776,856.956848 394.423492,856.706970 
	C394.938721,856.612305 395.150177,856.608887 395.615479,856.795837 
	C396.710358,857.004211 397.551453,857.022278 398.814148,857.054749 
	C396.277893,860.818176 391.647644,861.808960 387.404022,864.080505 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M341.057831,883.231689 
	C342.865845,881.271240 346.698792,881.849121 346.614746,877.858459 
	C347.033295,878.890686 347.451843,879.922913 347.924438,881.262634 
	C346.186066,883.055298 343.904480,883.396423 341.444550,884.232910 
	C341.061127,884.034058 341.054840,883.804810 341.057831,883.231689 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M310.227570,895.951904 
	C310.325073,894.818787 311.361786,895.011902 312.521851,894.706055 
	C312.986786,895.238220 313.429596,896.173218 313.198334,896.390198 
	C312.290253,897.242737 311.479309,895.963196 310.227570,895.951904 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M330.294739,888.161011 
	C330.134857,887.419312 330.224426,886.661438 330.313965,885.903564 
	C331.129669,886.084351 330.908478,886.765137 330.987061,887.606323 
	C330.986267,887.911560 330.544159,888.144897 330.294739,888.161011 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M594.799561,924.466797 
	C593.774109,923.910645 594.063110,922.684998 593.976990,921.174683 
	C594.088623,920.537415 594.278870,920.326660 594.727783,920.073608 
	C594.906555,921.335205 594.895264,922.700806 594.799561,924.466797 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M575.743225,928.981689 
	C576.062012,928.229004 576.682800,927.487610 577.201050,926.391968 
	C577.098572,926.037659 577.039307,926.001648 577.023438,926.032471 
	C577.373779,925.696106 577.815857,925.527527 578.646423,925.759949 
	C581.712891,925.907349 583.582703,923.697754 586.435303,923.000854 
	C587.042480,922.761963 587.308594,922.568359 587.772217,922.227539 
	C587.963989,922.072205 588.442017,921.955444 588.686401,921.930786 
	C589.322815,922.539062 589.714783,923.171997 590.106812,923.804871 
	C585.889526,926.042969 583.376404,931.217529 577.344360,930.973877 
	C577.323486,929.992310 577.677612,929.029907 575.743225,928.981689 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M578.826660,925.737549 
	C578.517883,926.096436 578.076416,926.229797 577.321289,926.213257 
	C577.387817,925.323181 577.930481,925.079773 578.826660,925.737549 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M587.715698,922.044800 
	C587.736084,922.319336 587.508179,922.566406 587.031250,922.888550 
	C586.824097,922.799316 586.865967,922.635071 586.939087,922.218384 
	C586.970459,921.965881 587.467407,922.017395 587.715698,922.044800 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M266.240601,673.637207 
	C265.624481,673.948975 265.215393,673.991943 264.495697,673.957764 
	C262.064606,672.605713 259.944153,671.330688 257.502136,669.962463 
	C256.493286,669.532410 255.805969,669.195557 254.822937,668.901001 
	C253.638397,668.724121 252.834976,668.351257 252.091278,667.341309 
	C246.608826,662.507629 240.078842,659.271667 236.565201,652.588989 
	C243.289108,657.995117 250.829468,661.964783 258.812805,665.818970 
	C259.329315,665.813965 259.492310,665.771606 259.839722,665.901855 
	C260.024170,666.074463 260.011414,665.985596 259.966675,665.989380 
	C260.392059,666.409668 260.995453,666.504333 261.796356,666.870483 
	C262.025208,667.066162 262.004303,666.990417 261.966064,666.999390 
	C262.482422,667.398743 263.067932,667.745850 263.799866,668.453735 
	C264.817963,670.271240 266.769257,671.226257 266.240601,673.637207 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M218.003204,648.677124 
	C211.195694,640.119629 206.749573,629.901367 202.273376,619.713745 
	C201.157684,617.174500 200.516312,614.426819 199.799408,611.388733 
	C203.587509,618.168640 207.324249,625.290344 210.848145,632.515869 
	C213.378265,637.703674 216.660080,642.563049 218.003204,648.677124 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M263.274445,669.089355 
	C262.755066,668.358032 262.455811,667.928589 262.042175,667.253784 
	C267.519440,667.757629 272.381256,670.241089 276.979980,673.704468 
	C276.530945,674.082092 276.084656,674.098511 275.299927,674.118896 
	C270.277435,674.634094 267.201508,671.248047 263.274445,669.089355 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M200.023056,610.638306 
	C197.468216,609.476501 197.501190,606.768616 196.885757,603.956177 
	C198.874207,605.353943 200.086700,607.525085 200.023056,610.638306 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M251.745087,667.250732 
	C252.690109,667.488464 253.407593,667.951172 254.326141,668.678589 
	C253.496750,668.509888 251.514481,670.028748 251.745087,667.250732 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M279.799683,675.546326 
	C278.957611,675.449707 278.042786,675.031799 277.034363,674.320984 
	C278.029724,674.054138 279.234161,673.811462 279.799683,675.546326 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M201.713974,638.214600 
	C202.000076,638.760681 202.044479,639.492615 202.073608,640.591553 
	C200.945648,640.316040 200.821472,639.447021 201.713974,638.214600 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M261.864929,666.799194 
	C261.451080,666.869263 260.876984,666.672363 260.112427,666.234314 
	C260.516144,666.172852 261.110382,666.352478 261.864929,666.799194 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M239.801315,674.776855 
	C239.379639,674.878174 238.782623,674.706665 237.975800,674.286255 
	C238.386002,674.192810 239.005981,674.348450 239.801315,674.776855 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M204.278748,562.006836 
	C204.126770,561.675354 204.282867,561.358032 204.718323,561.004639 
	C204.860718,561.319336 204.723770,561.670166 204.278748,562.006836 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M218.918655,650.170044 
	C218.750793,650.160583 218.463089,649.855042 218.062927,649.256897 
	C218.233231,649.267517 218.516022,649.570801 218.918655,650.170044 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M259.931519,665.943970 
	C260.024170,666.074463 259.589172,665.988037 259.377747,665.922241 
	C259.166290,665.856384 259.511810,665.587097 259.511810,665.587097 
	C259.511810,665.587097 259.838898,665.813477 259.931519,665.943970 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M282.023560,604.255493 
	C282.009766,604.009766 282.500122,604.006592 282.745178,604.008179 
	C282.828125,604.432007 282.665985,604.854187 282.503845,605.276428 
	C282.348328,605.018066 282.192810,604.759644 282.023560,604.255493 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M263.044922,669.137695 
	C267.217010,669.539429 270.468048,672.404785 274.682556,673.903015 
	C274.735168,674.687500 274.508850,675.252014 274.042725,676.020447 
	C272.184998,675.711426 270.567078,675.198547 268.678467,674.524170 
	C268.142181,674.442749 267.876648,674.522888 267.338074,674.289062 
	C266.892029,673.978821 266.719116,673.982361 266.289856,673.945984 
	C266.401550,671.505432 263.485992,671.333069 263.044922,669.137695 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M536.645630,624.330933 
	C537.054016,624.176086 537.541138,624.088806 538.397339,623.978638 
	C539.532593,625.507263 541.257446,625.488892 542.534424,626.098816 
	C549.348755,629.354187 549.606506,629.377563 546.860962,636.715759 
	C543.785217,644.936340 541.392029,653.358337 538.946167,661.760132 
	C537.875732,665.437256 536.118042,666.618591 532.287842,665.123535 
	C528.684448,661.868774 531.010742,658.186707 530.905823,654.438965 
	C531.302063,652.783264 532.438904,651.891357 532.855713,650.293579 
	C533.007629,649.809570 533.070496,649.619019 533.236938,649.151123 
	C533.551270,648.340942 533.777710,647.814026 534.031372,647.004395 
	C534.171204,646.571594 534.232239,646.401794 534.404663,645.988403 
	C534.684204,645.441833 534.879822,645.157837 535.269470,644.712158 
	C535.247498,643.850159 534.842224,644.752258 534.317505,644.285889 
	C533.872131,643.989624 533.718201,643.822510 533.417786,643.329163 
	C533.176086,636.825439 535.474121,631.111084 536.824219,624.807983 
	C536.930359,624.423218 536.724304,624.398560 536.645630,624.330933 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M536.578735,624.592468 
	C537.596069,630.981201 534.586060,637.069336 534.751831,643.776550 
	C535.395752,644.412598 535.527039,644.873047 535.182312,645.707703 
	C534.954346,646.011047 535.010071,646.007874 535.004883,645.980469 
	C534.281982,646.666809 534.585938,647.632385 534.163635,648.728027 
	C533.948608,648.984009 534.003601,648.986633 533.980591,648.971313 
	C532.858337,649.815247 533.176208,651.274841 532.333862,652.568604 
	C532.508911,656.612488 530.938110,660.366821 531.917358,664.549988 
	C529.734314,665.073669 527.870483,663.660339 525.801514,663.368774 
	C522.729797,662.936035 522.569824,661.655334 523.408020,659.017700 
	C527.106628,647.379211 531.784180,636.116089 536.578735,624.592468 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M524.296997,647.784424 
	C522.797424,647.907593 519.916687,648.800964 521.246399,646.692810 
	C522.284546,645.046875 516.144897,643.170227 521.715637,642.746033 
	C523.179321,642.634521 521.892700,640.922913 521.578857,639.960754 
	C518.819824,641.913208 517.989258,637.715637 515.370544,638.083618 
	C514.599670,637.950073 514.232300,637.747803 513.768555,637.158325 
	C513.398987,636.061157 513.500183,635.206116 513.257080,634.076782 
	C513.133301,633.355774 513.102234,632.940125 513.127197,632.212524 
	C513.295227,631.096802 513.622009,630.357666 514.110229,629.377930 
	C514.498413,628.648743 514.707703,628.160095 514.512207,627.329773 
	C514.349670,626.877808 514.281433,626.692871 514.134094,626.213440 
	C513.863647,624.842346 513.882751,623.778076 514.402039,622.435791 
	C514.739441,621.992615 514.914734,621.847107 515.431030,621.654358 
	C516.222778,621.717957 516.633423,621.913452 517.250000,622.432861 
	C518.193481,623.556946 518.732910,624.544678 519.496826,625.773010 
	C520.205139,627.149475 520.483276,628.398132 521.754517,629.348022 
	C522.640137,629.557434 523.241638,629.466797 524.165649,629.325439 
	C524.710510,629.280823 524.932556,629.281616 525.487549,629.342163 
	C527.139343,629.869629 528.362976,630.492310 529.511353,631.841431 
	C527.997986,637.273743 526.290527,642.417542 524.296997,647.784424 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M558.592529,623.049133 
	C559.351562,623.605347 560.044800,624.146484 560.875671,623.827332 
	C564.466797,622.447937 565.854248,624.268127 566.634521,627.686768 
	C565.765564,630.784119 564.634583,633.658203 563.242676,636.762085 
	C562.981689,636.991943 563.008240,637.006592 563.020630,637.015198 
	C562.781250,636.817566 562.515686,636.602478 562.394714,636.312561 
	C560.278625,631.241821 560.281494,631.240601 556.191406,635.165894 
	C553.961975,634.926819 553.895386,633.332397 553.554077,631.534912 
	C553.549194,630.915894 553.568359,630.668457 553.714050,630.071045 
	C554.055603,626.678528 556.473511,625.149719 558.592529,623.049133 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M553.549316,629.947510 
	C553.878601,629.920837 553.916565,630.120667 553.977295,630.624695 
	C555.015991,632.261414 554.165466,633.687378 554.238586,635.428711 
	C554.289795,636.521179 554.194641,637.243408 554.013062,638.327454 
	C553.885620,638.930603 553.824097,639.170227 553.638672,639.759766 
	C551.022339,646.315063 550.187927,653.102600 546.499390,659.043213 
	C545.470703,659.320557 544.817017,659.574341 543.813354,659.889526 
	C546.509521,649.953369 549.306458,639.873840 553.549316,629.947510 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M529.889160,631.815308 
	C527.994812,632.231873 526.780762,631.243896 525.221191,630.085327 
	C522.045227,627.471802 525.357971,625.285400 525.179932,622.600342 
	C525.217407,622.022888 525.248779,621.792664 525.387085,621.229614 
	C525.926025,620.041077 526.579834,619.393005 527.703857,618.755249 
	C528.258240,618.641174 528.489197,618.654358 528.980591,618.896729 
	C529.296936,619.922363 529.352905,620.718628 529.657349,621.685852 
	C530.042969,622.004150 530.180176,622.151611 530.356567,622.596924 
	C530.290161,623.489380 530.259338,624.066650 531.058838,624.606201 
	C532.133606,627.189941 530.757446,629.280579 529.889160,631.815308 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M543.292236,621.104980 
	C542.931335,619.024902 544.667358,619.252380 545.809692,618.326782 
	C549.162476,619.250305 552.322632,620.429871 556.625427,622.036011 
	C551.117554,625.096130 547.413635,622.272644 543.292236,621.104980 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M521.306519,676.703735 
	C520.392456,677.008423 519.626099,677.006226 518.478027,676.997925 
	C519.018555,671.823059 519.391663,666.617249 519.389221,661.108154 
	C523.186279,664.278687 520.140503,668.785095 521.821777,672.821655 
	C521.891785,674.181213 521.673035,675.289062 521.306519,676.703735 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M530.139038,623.170532 
	C530.084412,622.764343 530.012756,622.307922 529.959290,622.082336 
	C530.421814,620.901123 531.289551,620.832458 532.558655,621.000977 
	C532.518616,622.128967 532.145813,623.192688 531.534668,624.503418 
	C530.809998,624.470642 530.442627,624.079285 530.139038,623.170532 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M529.783325,622.820862 
	C530.426941,623.166626 530.769531,623.568970 531.204163,624.360840 
	C531.296265,624.750427 531.272095,624.681702 531.308655,624.688110 
	C530.554199,624.858765 529.723145,625.189331 529.084290,624.387451 
	C528.570312,623.742371 528.746460,623.222046 529.783325,622.820862 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M593.764526,531.873901 
	C593.465027,531.956116 593.444824,531.851440 593.411804,531.814575 
	C588.898987,532.413391 585.863953,535.658386 583.351929,538.690369 
	C575.235168,548.487366 566.605957,558.030457 562.036926,570.626953 
	C559.931885,574.108826 559.392761,577.820923 557.939209,581.579590 
	C554.011047,578.490784 553.427734,575.880798 555.736694,571.275635 
	C555.996826,570.968262 556.006348,571.002136 555.989258,571.006409 
	C556.947205,569.989685 556.278503,568.661865 556.859497,567.242554 
	C557.376465,566.520264 557.657104,566.078552 557.958984,565.363770 
	C557.704041,562.414001 559.950928,560.352112 559.868530,557.389160 
	C562.982910,550.839905 568.553955,546.414124 572.000732,540.039551 
	C573.045227,539.077637 574.081665,539.421448 575.045471,539.274536 
	C578.834473,538.696716 579.396484,537.597046 578.005005,533.143982 
	C578.941895,532.010193 580.816223,530.701721 581.268677,531.537231 
	C584.362122,537.249634 586.138794,532.163818 588.316589,530.850647 
	C590.317993,529.643799 592.075317,527.537659 594.894653,529.722290 
	C595.206665,530.178223 595.364990,530.355957 595.230835,530.738525 
	C594.938477,530.943298 594.942871,530.984314 594.955444,530.968506 
	C594.713196,531.282471 594.409790,531.559875 593.764526,531.873901 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M555.639587,571.030884 
	C553.633423,574.794067 557.230591,577.863831 557.551697,581.647949 
	C557.265076,586.052734 556.216919,589.489319 550.447021,587.154785 
	C550.306763,581.307373 551.976929,575.934875 555.639587,571.030884 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M577.544922,532.885254 
	C580.442932,533.506042 581.686829,535.192688 580.250549,537.490173 
	C578.609619,540.115051 576.302551,542.144531 572.496826,539.827393 
	C572.393982,538.236816 572.403870,536.662598 574.184631,535.837280 
	C574.798157,536.030273 575.090698,536.144470 575.368469,536.294189 
	C575.302734,536.191956 575.176392,536.190186 574.816895,536.027100 
	C574.207397,533.862305 575.727600,533.441833 577.544922,532.885254 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M595.316406,530.951782 
	C594.938477,530.943298 594.905945,530.462097 594.977173,530.231323 
	C598.205566,528.225830 601.515991,526.824158 605.389648,525.884216 
	C605.942017,525.900513 606.127808,525.933716 606.593872,525.996521 
	C606.345825,526.522705 605.817627,527.019287 605.145813,527.759644 
	C601.631165,528.144104 598.906067,530.318298 595.316406,530.951782 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M559.700562,557.299194 
	C561.905334,560.057251 558.205200,561.938110 558.236755,564.842896 
	C556.531494,562.192810 559.065552,560.065613 559.700562,557.299194 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M556.797668,567.180969 
	C556.904358,568.154053 556.712830,569.346069 556.246704,570.774414 
	C556.147949,569.807129 556.323669,568.603516 556.797668,567.180969 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M584.454590,529.531921 
	C584.423767,529.478638 584.485474,529.585205 584.454590,529.531921 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M506.705505,497.519287 
	C506.666809,497.139343 506.666809,497.181915 506.642181,497.160095 
	C506.783203,497.129242 507.027954,497.044037 507.103149,497.122131 
	C511.034302,501.205292 516.393250,499.545746 521.214478,500.837280 
	C517.335144,501.315765 513.194946,500.089539 509.464996,503.264465 
	C512.399231,503.622467 515.030823,502.131622 517.734070,503.724670 
	C514.285645,503.317719 510.816498,506.104736 507.030914,504.706390 
	C507.486908,503.757172 507.948181,502.796906 508.437988,501.777283 
	C506.862488,501.098175 506.394623,503.728760 504.717712,502.478363 
	C505.365021,501.015686 506.054596,499.457428 506.705505,497.519287 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M508.917999,492.993469 
	C511.963013,493.218506 514.839783,491.234009 519.067871,492.520050 
	C514.844910,493.538361 511.888092,495.415497 508.123596,495.207153 
	C507.932465,494.901886 507.990112,494.955231 507.961365,494.981995 
	C508.465973,494.623383 508.495697,494.006226 508.808258,493.195190 
	C508.965149,492.943329 508.948242,493.010712 508.917999,492.993469 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M518.019409,503.980896 
	C518.704651,504.171661 519.886108,503.566986 519.942383,504.565674 
	C519.972473,505.098480 518.887085,504.862793 518.153687,504.258606 
	C517.982361,504.028564 518.005493,503.995636 518.019409,503.980896 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M519.017761,506.748230 
	C518.907959,506.586670 518.962158,506.421570 519.016296,506.256439 
	C519.071411,506.419189 519.126587,506.581940 519.017761,506.748230 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M548.008667,565.012329 
	C547.795654,565.278259 547.524170,565.482483 547.252686,565.686646 
	C547.269592,565.450012 547.286438,565.213318 547.568237,564.901978 
	C547.833130,564.827332 547.950256,564.950562 548.008667,565.012329 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M562.786072,575.153687 
	C563.415955,576.588379 562.358459,577.825195 561.940186,579.607727 
	C560.121521,578.160828 561.751099,576.793518 562.786072,575.153687 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M499.321228,600.862549 
	C496.977631,601.126160 494.778625,600.586548 492.455566,601.776611 
	C491.770752,600.825012 491.468689,599.814819 491.103149,598.490906 
	C493.457336,598.107117 495.904297,598.782593 498.675110,597.952637 
	C499.587891,598.590942 500.303833,598.520752 501.227844,598.325073 
	C501.996155,598.003784 502.520721,597.930420 503.306946,597.908875 
	C503.707581,598.438843 504.009918,598.635132 504.722412,598.254150 
	C506.684570,597.987671 508.427399,597.968750 510.606384,597.959534 
	C511.296234,598.327332 511.636780,598.493042 512.326172,598.251221 
	C513.380249,598.644409 513.670227,599.338623 512.546814,600.622314 
	C511.568207,601.474792 511.018555,601.764526 510.050293,601.837524 
	C508.945038,601.754028 508.162079,601.536438 507.054901,601.668701 
	C505.949310,601.776062 505.158600,601.629395 504.067719,601.475647 
	C503.168121,601.411682 502.566620,601.424683 501.660248,601.449768 
	C500.741211,601.402344 500.154083,601.255005 499.321228,600.862549 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M501.210144,597.875427 
	C500.918518,598.595520 500.290436,598.758850 499.314636,598.246216 
	C499.689911,597.899963 500.319305,597.786804 501.210144,597.875427 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M504.725586,597.864807 
	C504.607330,598.143372 504.272949,598.280090 503.753540,598.188721 
	C503.882202,597.881470 504.195801,597.802246 504.725586,597.864807 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M512.561035,598.030151 
	C512.208252,598.179016 511.841827,598.291809 511.258972,598.186890 
	C511.281586,597.862732 511.520660,597.756348 512.116821,597.810547 
	C512.473999,597.971008 512.547424,597.994141 512.561035,598.030151 
z"/>
<path fill="#4B2766" opacity="1.000000" stroke="none" 
	d="
M535.046021,485.465637 
	C536.142151,486.836517 537.094055,488.635254 535.390564,490.814880 
	C535.082275,489.269287 535.036072,487.577087 535.046021,485.465637 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M526.112671,621.060852 
	C525.966675,621.355774 526.001160,621.559265 526.010498,621.662048 
	C525.296936,622.920044 526.298279,624.802429 524.099976,625.529297 
	C522.750793,625.479309 522.106812,624.790771 521.167969,623.957336 
	C520.765564,623.573547 520.610046,623.415161 520.228516,623.013672 
	C519.552612,622.277588 519.114136,621.775146 518.586060,620.923462 
	C518.375854,620.164124 518.392456,619.718689 518.694092,618.993774 
	C519.607910,618.124756 520.458496,617.994202 521.658997,618.143005 
	C522.345947,618.352417 522.511963,618.934814 522.946716,618.864624 
	C523.599731,618.759277 523.163391,618.019226 523.135010,618.685303 
	C523.106506,619.351379 522.014954,618.648499 522.520447,618.429810 
	C522.184326,617.075623 522.484009,615.736511 520.659790,615.113037 
	C518.668030,612.090027 514.136475,609.860046 518.835510,605.874878 
	C519.585022,606.885620 517.987793,610.198669 521.257874,607.646240 
	C522.603027,606.596252 522.683350,608.407654 523.967773,608.932739 
	C524.663086,609.183105 524.809448,609.265503 525.243530,609.747742 
	C525.531189,610.147644 525.676086,610.623901 525.833130,610.817017 
	C527.099243,612.182129 523.228027,614.926208 527.645691,615.078125 
	C527.931030,615.468872 527.871643,615.944031 527.723328,616.771118 
	C527.646729,617.343933 527.659058,617.565002 527.551453,618.095032 
	C526.965637,619.154114 526.624207,619.966003 526.112671,621.060852 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M519.449341,605.982910 
	C515.488586,609.614380 520.721802,611.441650 520.678467,614.908813 
	C519.835754,615.885681 519.137512,616.031616 518.053101,616.089783 
	C517.212585,616.060608 516.737854,615.990173 515.920349,615.796753 
	C514.255188,615.162598 512.845154,614.729553 512.467041,612.738159 
	C512.720520,611.333374 513.648438,610.533752 513.655640,609.049072 
	C513.703003,607.851746 513.719788,606.978455 513.616577,605.769470 
	C513.512756,604.748779 513.478271,604.066895 513.918335,603.131836 
	C514.760742,602.870728 515.383911,602.876709 516.305908,602.789062 
	C517.210327,604.281738 520.648315,602.076294 520.136108,605.612305 
	C520.048584,605.967102 519.877563,605.980530 519.449341,605.982910 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M530.677429,610.711121 
	C530.969971,610.864197 531.133240,611.308838 531.027832,611.698853 
	C529.047607,612.479492 528.087952,610.758057 526.275146,610.153015 
	C525.763855,610.173889 525.591858,610.264099 525.196533,610.167358 
	C524.973145,609.980469 524.999756,610.001831 525.011841,610.013855 
	C524.790955,609.790527 524.563171,609.550232 524.155640,609.139221 
	C523.970703,608.973511 523.996338,608.998840 524.007263,609.013062 
	C524.660034,608.394409 523.332642,605.210388 526.151489,607.391602 
	C527.544983,608.469910 528.972656,609.503967 530.677429,610.711121 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M529.442200,618.925964 
	C529.062866,619.095215 528.884766,619.064453 528.437256,619.004089 
	C528.004822,618.875854 527.841797,618.777222 527.672363,618.392578 
	C527.882446,617.783936 528.166382,617.543762 528.770386,617.247559 
	C530.216858,617.253174 529.895691,618.002869 529.442200,618.925964 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M528.667786,617.128784 
	C528.959839,617.324463 528.867249,617.536072 528.620911,617.862976 
	C528.188416,618.124756 527.868774,618.253235 527.276917,617.942383 
	C527.134399,617.396057 527.270447,617.298157 527.523743,617.166077 
	C527.864319,617.136108 528.094177,617.149353 528.667786,617.128784 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M528.004456,615.004272 
	C528.083557,614.523438 527.660156,613.860718 528.494568,613.646545 
	C528.482666,614.012634 528.470764,614.378662 528.224609,614.869202 
	C527.990417,614.993652 528.000000,615.000000 528.004456,615.004272 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M525.010559,610.254272 
	C525.139648,609.941895 525.306152,609.903320 525.704224,609.974243 
	C525.935791,610.083618 525.974243,610.546021 525.982178,610.778076 
	C525.676086,610.849426 525.362061,610.688782 525.010559,610.254272 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M531.156494,611.849854 
	C531.425659,612.003967 531.802795,612.269897 531.768555,612.462891 
	C531.685974,612.928406 531.377075,612.932922 531.017090,612.306641 
	C530.922363,612.088928 531.077332,611.928467 531.156494,611.849854 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M513.808838,602.804565 
	C514.427612,603.395264 514.717651,603.925781 515.019775,604.759277 
	C514.677856,605.367249 514.269592,605.563965 513.467773,605.673157 
	C512.421387,605.584839 511.748444,605.381531 510.721924,605.120789 
	C509.679993,604.767151 509.080811,604.376282 508.503876,603.422974 
	C508.311127,602.582886 508.381042,602.102051 508.818298,601.371887 
	C509.816254,601.079651 510.554321,601.050903 511.661743,601.015991 
	C511.873016,602.123596 512.394470,602.669617 513.808838,602.804565 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M521.081787,602.111084 
	C521.526123,601.997131 522.064880,602.176697 522.732178,602.611938 
	C522.299255,602.713379 521.737732,602.559021 521.081787,602.111084 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M589.276978,484.993439 
	C589.149902,484.470367 589.316223,483.901245 589.724487,483.149689 
	C591.057739,483.872040 590.845947,484.516144 589.276978,484.993439 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M588.003479,487.997345 
	C588.114075,488.125061 588.221191,488.255402 588.328308,488.385803 
	C588.254028,488.340240 588.179749,488.294678 588.049866,488.128326 
	C587.994263,488.007507 588.000000,488.000000 588.003479,487.997345 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M653.093018,381.776917 
	C652.794739,381.923218 652.500732,381.823547 652.354004,381.874023 
	C650.121155,380.734009 651.732422,378.091919 650.161316,376.700012 
	C651.053772,378.131866 650.978149,379.737610 650.985474,381.666534 
	C649.381775,385.865234 645.484802,384.552582 642.336914,385.870209 
	C640.103210,387.749115 637.868286,388.673096 634.998535,388.966797 
	C632.263306,388.588470 630.170654,389.078186 628.258667,391.174072 
	C625.287781,392.662476 623.899109,394.671387 624.469482,397.749878 
	C624.663208,398.795502 625.078796,399.714661 626.342468,399.626862 
	C627.605835,399.539062 627.939575,398.614685 627.889160,397.517090 
	C627.806885,395.725891 626.848938,393.978394 627.892212,391.884949 
	C630.357117,390.974365 631.502747,392.361176 632.726074,394.244690 
	C633.278381,397.058563 634.109558,398.923431 637.194519,398.898376 
	C638.739380,398.885803 640.699829,399.150543 639.929688,401.767944 
	C637.461670,402.216187 635.230286,402.116150 633.261536,403.643127 
	C633.255981,404.258667 633.274780,404.518005 633.009888,405.045898 
	C628.678650,405.153320 624.567749,406.203064 620.283936,404.446350 
	C616.841248,404.229492 613.705994,404.260559 610.570923,404.253510 
	C609.643250,404.251404 608.389160,404.513214 608.412903,403.035095 
	C608.430298,401.958618 609.185486,401.218597 610.319092,401.141052 
	C612.457153,400.994781 614.600159,400.921753 616.740784,400.812042 
	C618.105774,400.742157 620.007996,401.426971 619.746643,398.895508 
	C619.485413,396.365417 617.768860,396.783112 616.084839,397.199432 
	C615.125854,397.436554 614.166565,397.777039 613.193970,397.831360 
	C611.587036,397.921112 609.459961,399.044647 608.478271,397.641876 
	C607.197266,395.811340 609.568542,395.122314 610.520996,393.911743 
	C611.805359,392.279449 609.938721,392.291534 608.579590,391.947754 
	C608.164673,389.868256 608.108398,387.851166 607.989868,385.403656 
	C610.035767,383.033295 605.884277,379.316742 609.563293,378.192993 
	C611.835144,377.499023 614.502197,378.028351 616.987549,378.122864 
	C619.921204,378.234436 622.992188,377.324097 625.883789,379.549316 
	C626.372925,380.283936 626.497070,380.713593 626.184631,381.459045 
	C624.135620,382.346283 621.902771,381.742676 620.527588,383.631866 
	C621.682678,385.014496 623.424744,384.996643 625.009521,385.404907 
	C627.844055,386.135040 630.816589,385.912811 633.312012,384.879089 
	C637.044189,383.333130 633.037415,380.354462 633.876038,377.971222 
	C634.385010,376.525177 633.804871,374.695892 633.613770,372.606506 
	C633.309753,371.667542 633.281494,371.151154 633.619507,370.277649 
	C633.851807,369.199554 633.892822,368.468994 633.848755,367.379272 
	C633.240845,366.283966 633.131531,365.475067 633.528870,364.235931 
	C634.617920,363.060638 635.675659,362.917633 637.186951,363.256592 
	C637.759033,363.552399 637.960266,363.711761 638.272888,364.231262 
	C637.092102,367.866669 638.073120,369.154907 641.673889,368.765198 
	C645.491211,368.352081 649.322083,368.196533 652.886475,365.678131 
	C653.824280,364.774872 654.479675,364.070618 655.808044,363.929443 
	C658.288879,366.414856 661.937012,366.175385 664.171387,368.912964 
	C663.657166,371.265228 661.862854,371.251007 660.319763,371.288330 
	C657.951660,371.345612 657.212891,372.562988 657.310425,375.018799 
	C657.169800,376.761353 656.752991,378.087708 656.197632,379.733521 
	C655.971619,380.259949 655.864258,380.462097 655.538269,380.926636 
	C654.746704,381.641418 654.040894,381.513245 653.093018,381.776917 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M640.217529,444.590179 
	C637.918457,446.787598 635.835876,448.722656 633.753296,450.657715 
	C633.673279,451.100250 633.593323,451.542786 633.513306,451.985321 
	C640.233887,449.940247 640.279419,453.465942 640.071228,457.729828 
	C639.741089,464.490875 639.787964,471.270325 639.591553,478.500488 
	C638.625305,478.971924 637.742798,478.984924 636.529175,478.991028 
	C634.612854,475.912415 632.872498,476.286438 630.747437,478.893982 
	C630.132080,480.338806 625.979675,481.288177 630.400391,482.988647 
	C631.266846,483.255737 631.503906,483.703644 631.184570,484.665161 
	C628.765015,484.863800 626.571411,486.434967 624.020142,484.904297 
	C623.212524,484.261292 623.110718,483.601746 623.215576,482.581024 
	C623.706604,480.948792 624.867310,479.697845 623.453491,477.958984 
	C623.111084,477.012146 623.074768,476.351868 623.370361,475.375366 
	C624.663513,474.360260 626.588196,475.000580 626.960999,472.975281 
	C627.211304,471.615784 626.029785,472.022461 625.183777,471.477142 
	C624.609070,470.942078 624.412170,470.541809 624.296570,469.761047 
	C624.386292,468.357300 624.650269,467.285065 624.172974,465.892273 
	C623.878540,464.670990 623.805725,463.756348 623.717651,462.485107 
	C623.696167,461.889252 623.694092,461.649445 623.704956,461.047729 
	C623.826294,459.219421 624.225281,457.807678 624.552002,456.006653 
	C624.578064,454.878143 624.618835,454.122467 624.703735,452.977997 
	C624.842712,451.792297 625.108276,451.059998 625.948608,450.205505 
	C627.291870,449.786652 629.073303,450.399597 627.918396,448.022095 
	C626.721680,446.518433 626.968811,445.074097 627.399658,443.275146 
	C627.595520,442.458191 627.701965,441.990875 627.919189,441.183044 
	C628.501709,439.453064 629.386230,438.368927 630.798462,437.248657 
	C631.057983,437.011261 631.537109,437.022614 631.776672,437.017151 
	C634.433716,436.249817 635.839172,438.772888 638.175171,439.136719 
	C638.456421,439.817169 638.558411,440.215332 638.650208,440.858276 
	C638.421448,441.358704 638.376221,441.642426 638.729736,441.886230 
	C639.245117,442.025391 639.480652,442.285492 639.858643,442.816254 
	C640.036987,443.052582 640.051758,443.062378 640.055786,443.070801 
	C640.360840,443.442596 640.477478,443.861237 640.217529,444.590179 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M638.414673,440.297424 
	C636.817383,438.322968 633.924194,439.331757 632.331543,437.172729 
	C632.000854,436.541443 631.985413,436.071167 631.964966,435.248199 
	C631.253235,433.591980 631.784973,432.210999 631.702759,430.531921 
	C631.696045,429.973175 631.694336,429.750641 631.693848,429.196350 
	C631.737244,427.565186 631.765320,426.266693 631.359314,424.678223 
	C631.185486,423.945892 631.117065,423.522827 631.060425,422.779358 
	C631.059937,422.255280 631.073608,422.047363 631.133179,421.534607 
	C631.417358,420.243347 631.377136,419.243835 631.359863,417.942993 
	C631.499023,417.465759 631.597046,417.289001 631.882324,416.873901 
	C632.069641,416.635590 632.129883,416.493835 632.085144,416.431152 
	C631.756226,414.936798 631.616272,413.493011 631.666504,411.665833 
	C631.655457,411.053314 631.652710,410.807465 631.649902,410.191101 
	C631.636169,409.071167 631.685364,408.324341 631.788757,407.199402 
	C631.940613,406.316833 632.128906,405.845642 632.652344,405.119720 
	C632.905273,404.832092 632.986084,404.381836 633.111633,404.190582 
	C634.681519,404.316650 636.115540,404.697479 637.572876,404.934845 
	C639.298035,405.215820 641.383972,405.649323 640.614990,407.785339 
	C639.833679,409.955963 637.963013,408.891083 635.605591,407.038300 
	C637.480225,414.704529 636.595825,421.516083 637.254456,428.272369 
	C637.332825,429.076599 637.585754,429.884888 637.532593,430.676178 
	C637.442749,432.015228 638.461914,438.527985 638.992065,439.480835 
	C638.902161,439.975616 638.805969,440.147858 638.414673,440.297424 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M624.649292,460.452454 
	C624.899536,460.986603 624.926514,461.216583 624.942261,461.793671 
	C621.958069,464.235291 618.553833,463.081146 615.347046,463.409149 
	C612.964294,463.652832 610.295227,463.116669 608.839050,466.213745 
	C608.758179,467.269714 608.651367,467.967041 608.476440,469.010254 
	C608.342834,470.298157 608.172607,471.223419 607.869385,472.484314 
	C607.497925,473.501648 607.035400,474.031097 606.237976,474.744263 
	C605.615967,474.290039 604.850952,473.533844 604.939453,472.896118 
	C605.523132,468.689484 603.583862,467.393494 599.694702,467.871582 
	C598.756470,467.986877 598.220154,467.293549 599.037842,466.048645 
	C599.547058,465.609283 599.828735,465.450745 600.093201,465.268555 
	C600.273987,465.143982 600.685059,465.303894 600.625854,464.868469 
	C600.621582,464.837036 600.452271,464.801636 599.909241,464.609009 
	C598.547180,463.877991 597.545532,463.209564 596.186279,464.192444 
	C594.494812,465.415558 593.605347,464.330902 593.067688,462.394379 
	C592.844116,461.878784 592.651855,461.697144 592.756104,461.251831 
	C593.052551,460.988220 592.988770,460.989227 592.989380,461.021118 
	C595.621155,459.727722 598.423462,461.369446 600.434875,460.502197 
	C598.590027,460.580078 596.093384,460.615784 593.322876,460.236389 
	C592.060791,457.826050 593.581543,457.975128 594.981995,457.980438 
	C598.114014,457.992279 601.230957,457.928589 603.895508,455.406555 
	C604.872986,455.331085 605.776367,455.618317 607.013611,456.042297 
	C608.584900,458.512329 610.442261,458.988495 613.057983,458.839722 
	C616.863647,458.623260 620.910278,457.454926 624.649292,460.452454 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M632.558228,429.874634 
	C633.327332,431.634918 633.485596,433.050964 632.180420,434.606812 
	C624.886963,434.903442 617.799194,434.722931 610.781860,435.802063 
	C608.900330,436.091370 608.014648,435.911530 608.089905,433.724762 
	C608.153015,431.891083 608.208191,430.436829 610.635986,430.596191 
	C612.441284,430.714722 614.258545,430.650696 616.484558,430.598572 
	C621.914673,428.757690 627.089905,429.510406 632.558228,429.874634 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M631.653503,423.436829 
	C633.430542,424.899750 633.141724,426.510651 633.015381,428.443298 
	C627.856201,429.452545 622.791260,430.056702 617.337036,428.685638 
	C614.916565,428.594116 612.879761,428.688507 610.406006,428.755005 
	C609.561401,428.585510 609.144348,428.481628 608.476013,428.200806 
	C607.574219,425.341492 608.427246,423.981903 611.332520,424.108917 
	C613.582520,424.207245 615.841064,424.109741 618.531860,423.980408 
	C622.949524,421.687714 627.089844,422.449921 631.653503,423.436829 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M632.436035,411.012573 
	C632.635376,412.837524 632.540833,414.294586 632.243347,416.060059 
	C625.044922,415.484375 618.003723,415.477325 610.990845,415.735992 
	C607.898804,415.850037 607.568604,414.821655 608.667480,412.134613 
	C611.308533,410.023621 614.075439,410.604279 616.687195,410.609802 
	C621.838684,410.620636 626.991699,410.366547 632.436035,411.012573 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M632.089050,417.832794 
	C632.505127,418.863770 632.674133,419.825928 632.698608,421.050781 
	C631.991577,421.301331 631.583191,421.545532 631.048645,422.306946 
	C628.590454,423.349609 626.334045,422.856720 623.773071,422.971924 
	C621.911499,422.921997 620.631165,422.004608 618.555786,421.867950 
	C617.521484,421.903656 617.088135,421.875122 616.328613,421.807831 
	C614.555481,420.785675 613.050232,421.145264 611.266846,421.765442 
	C609.159790,422.364838 607.723877,422.344727 607.900391,419.769012 
	C608.017334,418.062073 608.369934,417.051880 610.444885,417.092743 
	C616.984497,417.221649 623.527588,417.175446 630.536255,417.191559 
	C631.317139,417.328796 631.598511,417.518890 632.089050,417.832794 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M632.641357,406.697906 
	C632.928589,407.624207 632.855408,408.275970 632.750854,409.254578 
	C631.573425,411.176849 629.795532,410.963226 628.225525,410.947357 
	C622.096130,410.885498 615.956421,411.377686 609.400513,410.455536 
	C607.213196,407.966309 607.818848,406.529541 610.605652,406.290588 
	C613.420227,406.049286 616.261475,406.117584 619.535828,405.949951 
	C624.142700,404.712128 628.256775,404.604370 632.641357,406.697906 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M625.854675,449.881958 
	C626.215698,450.708130 626.155396,451.434845 626.020630,452.523926 
	C625.340088,453.551300 624.583984,453.758972 623.346069,453.430176 
	C618.789429,452.614929 614.702515,453.822662 610.556580,453.913208 
	C609.455627,453.937286 607.579712,455.135468 607.542358,452.798126 
	C607.518372,451.295074 607.459229,449.228363 610.047607,449.434082 
	C615.169739,449.841187 620.334961,448.337341 625.854675,449.881958 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M630.593872,436.944092 
	C631.109436,438.472565 630.218628,439.381500 629.040405,440.494446 
	C626.424744,443.125244 623.677979,442.583740 620.446594,441.358521 
	C616.851624,440.991791 613.701782,440.921356 610.577393,441.582611 
	C609.349915,441.842438 607.832153,442.592072 607.663025,440.347809 
	C607.528015,438.557373 608.179199,437.637238 610.196289,437.590912 
	C616.842773,437.438293 623.485535,437.127197 630.593872,436.944092 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M624.903320,460.415497 
	C620.128540,459.320465 615.290527,459.781097 610.603333,460.663422 
	C606.788513,461.381531 606.814453,459.655212 607.332153,456.593353 
	C612.247559,456.009369 617.147583,455.839722 622.504395,455.588287 
	C623.768250,455.111084 624.558105,455.178131 625.612793,455.904358 
	C625.571960,457.500031 625.252991,458.787170 624.903320,460.415497 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M625.317139,446.748047 
	C620.182007,447.063110 615.400452,447.260071 610.621521,447.507751 
	C609.440308,447.568970 607.826904,448.700439 607.833435,446.275757 
	C607.837708,444.705139 608.151672,443.239166 610.209229,443.216705 
	C613.504700,443.180695 616.800232,443.160797 620.558594,443.190125 
	C622.774231,443.640137 624.719482,443.403961 626.261353,444.446167 
	C627.819275,445.499237 627.212891,446.269714 625.317139,446.748047 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M608.964844,410.512604 
	C616.581665,410.030640 624.199646,409.822052 632.268555,409.597412 
	C632.745056,409.881073 632.770569,410.180756 632.763062,410.930420 
	C625.125366,411.569824 617.520874,411.759247 609.447693,411.913666 
	C608.974731,411.514435 608.970398,411.150208 608.964844,410.512604 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M616.943848,428.838135 
	C622.017517,427.821381 627.081787,427.498871 632.533813,428.660187 
	C632.934814,429.052521 632.948425,429.279572 632.928772,429.846375 
	C627.888062,430.891754 622.858704,431.016174 617.356689,430.640717 
	C616.910522,430.078308 616.922485,429.627380 616.943848,428.838135 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M633.054810,406.615845 
	C628.959106,406.619781 624.916321,406.267090 620.427124,405.882050 
	C619.976074,405.485962 619.971497,405.122284 619.971680,404.485779 
	C624.019958,405.206848 628.150452,402.768005 632.540039,404.677002 
	C632.972778,405.307800 633.040283,405.783539 633.054810,406.615845 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M621.549927,421.513489 
	C624.688049,421.525574 627.411072,421.534607 630.588745,421.539185 
	C631.265808,421.647705 631.488220,421.760681 631.866699,422.213745 
	C632.227112,422.766418 632.294128,423.015869 632.150757,423.488708 
	C628.017517,423.772064 623.957397,423.868896 619.432617,423.913635 
	C618.700195,423.386536 618.432434,422.911499 618.059814,422.184326 
	C617.954895,421.932190 617.820068,421.717926 617.839050,421.592773 
	C618.956299,421.023926 620.043518,421.423004 621.549927,421.513489 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M625.201904,447.020203 
	C624.274719,446.110321 628.130981,445.925934 625.209961,444.974396 
	C623.893311,444.545502 622.175842,445.629486 621.094055,443.588562 
	C621.021362,443.246216 620.812500,443.077393 620.862305,442.952698 
	C623.297607,441.590515 625.734985,441.794556 628.523193,442.901611 
	C627.686401,444.326019 628.096130,445.846344 627.721069,447.514282 
	C626.922852,447.638245 626.182007,447.415649 625.201904,447.020203 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M628.917725,442.830780 
	C626.499878,443.157410 624.146118,443.077789 621.352295,442.913086 
	C620.684875,442.414978 620.457703,442.001953 620.119873,441.379242 
	C622.675720,441.055267 625.342285,440.940918 628.452393,440.804413 
	C628.924622,441.329681 628.953247,441.877075 628.917725,442.830780 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M611.408691,422.018158 
	C612.524780,421.440979 613.512817,417.304077 615.859131,421.507019 
	C614.610107,421.872986 613.217834,421.976929 611.408691,422.018158 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M625.936768,455.798523 
	C625.155029,456.052277 624.419250,455.891724 623.322266,455.618835 
	C622.969971,454.940308 622.978943,454.374115 622.983154,453.524689 
	C623.719177,453.147125 624.459839,453.052795 625.573364,452.922363 
	C625.958374,453.718933 625.970520,454.551575 625.936768,455.798523 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M608.257996,428.287628 
	C608.704285,428.108887 609.174561,428.231506 609.806885,428.540649 
	C609.406677,428.681091 608.844299,428.635040 608.257996,428.287628 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M632.346069,417.568970 
	C632.005737,417.799164 631.675293,417.696747 631.173950,417.390198 
	C631.162415,417.058380 631.321655,416.930725 631.775269,416.719360 
	C632.165039,416.835876 632.260498,417.036133 632.346069,417.568970 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M622.822815,474.962769 
	C623.267334,475.991547 623.458801,476.627289 623.700439,477.597778 
	C623.873840,479.971344 622.648010,480.539001 620.925354,480.412384 
	C617.802551,480.182831 614.627991,480.866547 611.167603,479.737305 
	C606.087280,479.941498 601.388794,480.290497 596.690369,480.639526 
	C599.015625,478.386566 601.758545,478.502686 604.290588,478.944305 
	C607.002502,479.417267 606.869080,477.745758 607.387207,475.799011 
	C612.415771,472.167847 617.495300,473.413239 622.822815,474.962769 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M623.575195,481.723511 
	C623.707397,482.798553 623.735718,483.479767 623.704468,484.499115 
	C622.991272,484.920776 622.337585,485.004333 621.363770,485.165527 
	C617.911682,485.176239 614.758728,485.296814 611.657776,484.950836 
	C610.404175,484.810944 608.807556,487.225281 607.957092,484.686676 
	C607.314331,482.767975 608.450378,481.578766 610.627197,480.893860 
	C615.177063,480.629883 619.415344,478.776276 623.575195,481.723511 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M623.432373,475.333130 
	C618.196472,474.719452 613.324341,475.227997 608.025024,475.445435 
	C607.336670,475.346375 607.073608,475.250336 606.398438,475.072876 
	C606.135376,474.452637 606.284607,473.913849 606.655396,473.196045 
	C612.361023,470.326630 618.414490,472.442627 624.441772,471.003845 
	C625.963684,471.346100 627.753235,470.287323 628.119019,471.930054 
	C628.359924,473.011658 627.699097,474.458252 627.078430,475.531219 
	C625.990601,477.412170 624.936035,474.911377 623.432373,475.333130 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M624.009399,481.960754 
	C619.887695,479.942383 615.607605,482.841461 611.397339,480.893097 
	C610.987183,480.607635 610.966431,480.401215 610.865723,479.893616 
	C614.856995,478.343506 619.268799,480.350098 623.502808,478.110291 
	C627.028381,478.754242 626.157837,480.207123 624.009399,481.960754 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M606.075317,490.588379 
	C603.235168,490.923187 600.719055,492.508789 597.509033,491.889648 
	C598.680054,488.972321 601.893005,490.523560 604.430908,489.215942 
	C605.415222,489.334869 605.947754,489.640259 606.075317,490.588379 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M599.531006,464.668579 
	C601.306213,464.397217 603.072632,463.360321 604.860596,465.009735 
	C603.271057,466.655762 601.587646,465.853546 599.695923,465.889099 
	C599.216064,465.507751 599.244080,465.186554 599.531006,464.668579 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M606.003784,491.200500 
	C605.655579,490.456146 605.358582,490.030182 604.922913,489.377655 
	C605.219116,489.090485 605.653992,489.029846 606.417603,488.948975 
	C607.208923,490.204803 607.080566,492.095856 609.415894,491.364990 
	C610.285950,491.092682 611.711426,490.666656 611.556152,492.094910 
	C611.370178,493.804901 609.737732,492.627441 608.322571,492.900635 
	C606.946533,492.901855 606.247009,492.528229 606.003784,491.200500 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M592.692749,460.926758 
	C593.142151,461.168365 593.231750,461.348541 593.178833,461.794556 
	C591.969604,462.009003 590.902954,461.957611 589.436218,461.919495 
	C589.882385,460.796478 591.155884,460.979828 592.692749,460.926758 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M617.378967,364.152710 
	C615.754028,362.388214 613.965576,362.917816 612.526733,363.153015 
	C608.908081,363.744476 607.388000,362.547150 608.031128,358.495361 
	C611.673218,355.342346 615.870850,357.078888 620.231201,356.559753 
	C624.022705,356.140320 626.795593,357.584381 629.476746,359.253418 
	C630.768921,360.057861 633.069458,360.459900 632.057617,362.674561 
	C631.230042,364.485779 629.394409,364.226440 627.379089,363.283997 
	C626.182129,362.527252 625.335083,362.157745 624.166992,362.767700 
	C622.169373,364.682587 620.191956,365.671875 617.378967,364.152710 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M627.014648,363.394043 
	C628.708130,363.018982 630.456665,363.177368 632.904480,360.737122 
	C627.456116,362.511871 625.992920,356.731659 621.428162,357.612671 
	C619.942444,357.452332 618.754578,357.461426 618.589661,355.586456 
	C618.832458,354.946228 619.011292,354.723511 619.565674,354.284729 
	C624.834167,353.656128 629.858704,352.052307 634.541748,356.035065 
	C635.377197,357.817261 635.344910,359.299164 635.279541,361.219604 
	C635.132751,362.243195 634.920776,362.786377 634.341614,363.640442 
	C634.023499,364.751709 633.966980,365.510834 633.837036,366.645050 
	C630.414490,368.224182 627.362915,368.810364 627.014648,363.394043 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M610.299316,370.401367 
	C607.746399,369.671753 608.114746,367.914490 608.327637,366.555420 
	C608.575806,364.971222 610.098450,365.378143 611.179871,365.394501 
	C612.838623,365.419525 614.494995,365.606415 616.544556,365.688568 
	C619.393005,365.187866 622.171387,363.446777 623.709961,367.722290 
	C624.461914,368.274841 625.259521,368.236786 625.569031,368.606903 
	C626.276672,369.453156 625.526489,369.679108 624.807251,369.737488 
	C623.155396,369.871674 621.501953,369.984741 619.485229,370.286285 
	C616.339661,371.757843 613.519531,371.721100 610.299316,370.401367 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M608.513611,376.085510 
	C608.102783,375.003876 608.130737,374.045776 608.143066,372.728149 
	C611.293457,370.100586 614.789185,371.100800 618.636536,371.570190 
	C620.052551,371.902313 621.049377,371.969666 622.028198,372.140533 
	C623.428345,372.384979 624.856262,373.106659 624.806641,374.544495 
	C624.738159,376.529724 622.879333,376.545288 621.388489,376.524750 
	C617.242493,376.467743 613.097656,376.320587 608.513611,376.085510 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M619.098755,371.568909 
	C615.702881,371.872742 612.342041,371.956726 608.554260,372.204651 
	C608.616699,371.776642 609.106018,371.184723 609.761353,370.342224 
	C612.698059,370.117310 615.468750,370.142975 618.680420,370.317444 
	C619.207336,370.759338 619.211487,371.053619 619.098755,371.568909 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M623.927124,367.699463 
	C622.781555,364.817383 619.882935,366.382996 617.343140,365.760925 
	C616.981201,365.254486 617.025635,364.856476 617.066040,364.157837 
	C619.255127,364.745361 621.121460,363.120483 623.584961,363.018005 
	C623.975220,364.407745 623.971802,365.839539 623.927124,367.699463 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M633.458130,369.973145 
	C633.799622,370.438843 633.788513,370.947540 633.645447,371.815247 
	C631.695312,371.973694 632.565125,374.545837 629.623169,374.707428 
	C631.404236,372.940918 629.981201,370.437378 633.458130,369.973145 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M626.329956,381.850098 
	C625.930359,381.312927 625.916626,380.907684 625.977905,380.206665 
	C627.107056,380.070801 628.841064,379.012848 628.852539,381.109344 
	C628.859741,382.419556 627.594238,382.057251 626.329956,381.850098 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M592.967773,460.293396 
	C596.957214,459.871124 600.870056,459.697510 604.782898,459.523926 
	C604.826721,459.929047 604.870483,460.334198 604.914307,460.739319 
	C601.176636,460.955200 597.439026,461.171051 593.345703,461.219971 
	C592.957031,460.882690 592.924072,460.712402 592.967773,460.293396 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M618.654907,355.682037 
	C619.508301,356.352386 620.063354,356.798096 620.813965,357.435944 
	C616.996704,357.722473 612.984070,357.816895 608.522217,358.013733 
	C608.092346,357.595093 608.111572,357.074005 608.138550,356.161835 
	C608.323792,355.646423 608.501282,355.522156 608.979431,355.267334 
	C609.494324,355.086304 609.708618,355.035767 610.253540,354.938965 
	C610.808289,354.871735 611.032410,354.850739 611.596191,354.805756 
	C612.399048,354.755127 612.862488,354.734406 613.685913,354.703369 
	C615.525024,354.706787 617.024780,354.612061 618.654907,355.682037 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M609.213196,355.590942 
	C609.007874,355.852814 608.567749,355.909424 608.357056,355.840088 
	C608.146362,355.770721 608.098450,355.355194 608.008667,355.166382 
	C607.966553,354.815491 608.014282,354.653473 608.183472,354.269226 
	C609.153992,354.059326 609.392883,354.601593 609.213196,355.590942 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M303.742920,897.806702 
	C303.741608,897.579407 304.053741,897.314575 304.678955,897.013306 
	C304.680176,897.240906 304.368286,897.505005 303.742920,897.806702 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M291.073914,900.851807 
	C290.902832,900.514771 291.103882,900.300537 291.697021,900.262573 
	C291.783234,900.549255 291.568909,900.727844 291.073914,900.851807 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M88.187637,652.741333 
	C88.079796,650.792603 88.316452,649.230835 90.389870,649.457458 
	C91.425369,649.570618 92.086166,650.664978 91.802818,651.714722 
	C91.295227,653.595276 90.262535,654.689758 88.187637,652.741333 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M82.127991,695.722595 
	C82.225075,695.261230 82.361969,695.019348 82.498856,694.777466 
	C82.635269,695.019104 82.891403,695.266418 82.880302,695.501038 
	C82.863266,695.861267 82.849899,696.528503 82.127991,695.722595 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M100.230103,831.275635 
	C96.144455,831.715576 93.226730,828.950256 89.293762,828.807190 
	C87.053696,828.464722 85.776970,827.309875 84.332298,825.820374 
	C83.889008,825.528687 83.691086,825.445496 83.233841,825.171265 
	C82.974510,824.980347 83.004211,824.997437 83.018066,825.007568 
	C82.376717,824.290833 81.847984,823.355469 81.046722,822.869263 
	C73.354591,818.201538 71.305908,810.930542 71.453171,801.722656 
	C80.609528,812.765137 90.498657,821.969177 103.088623,828.418640 
	C103.625145,830.740662 101.963982,830.849548 100.230103,831.275635 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M80.952614,828.659668 
	C77.185509,827.450378 73.396706,825.862488 69.274216,824.113037 
	C68.672028,823.462585 68.947334,822.785889 68.184479,822.199707 
	C67.966850,822.006775 68.004036,821.993652 68.003998,822.013306 
	C67.787773,821.788452 67.567497,821.547668 67.155182,821.153870 
	C66.967239,820.997070 67.001205,820.990051 67.006531,821.005859 
	C64.179359,819.105347 61.346870,817.189026 58.514381,815.272766 
	C58.686440,814.894958 58.858494,814.517151 59.030548,814.139282 
	C64.584518,816.868530 70.138489,819.597778 75.909973,822.593628 
	C75.905525,826.282593 80.024391,825.858582 80.952614,828.659668 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M83.844261,825.371826 
	C85.733757,825.792297 87.447525,826.592896 88.768417,828.423828 
	C88.889069,829.871216 88.574471,830.925476 87.294296,831.835815 
	C87.654022,829.416077 84.886841,828.884949 84.070213,826.842896 
	C83.894630,826.269043 83.780678,826.011841 83.844261,825.371826 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M100.062042,831.452881 
	C100.831711,830.577820 101.861290,829.921509 103.114090,828.964478 
	C103.718796,828.754944 104.100281,828.846130 104.763245,829.029175 
	C105.395508,829.552673 105.490105,830.034729 105.080658,830.866089 
	C103.426796,832.205872 101.918396,832.330750 100.062042,831.452881 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M109.364784,831.422852 
	C109.644356,832.855469 108.861710,832.957947 108.029915,832.664368 
	C107.718040,832.554260 107.579216,831.953857 107.361481,831.577026 
	C107.949738,831.450867 108.537987,831.324646 109.364784,831.422852 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M64.166519,846.171326 
	C64.721962,845.904175 65.452362,845.876587 66.551254,845.949097 
	C66.174805,846.985718 65.298729,846.987671 64.166519,846.171326 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M105.131027,831.072144 
	C104.888657,830.710693 104.944923,830.256287 105.022957,829.461426 
	C105.899376,829.589966 106.220459,830.169373 105.131027,831.072144 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M67.960884,822.301636 
	C69.064743,821.908813 69.946236,822.001465 69.100586,823.713257 
	C68.612007,823.499817 68.283463,823.048157 67.960884,822.301636 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M83.789383,829.750977 
	C83.113724,829.872986 82.256737,829.708984 81.187027,829.291687 
	C80.974304,829.038330 81.008743,828.992554 81.028854,828.970764 
	C81.901993,829.120972 82.755028,829.292969 83.789383,829.750977 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M83.760132,824.967407 
	C84.030830,825.244873 84.039879,825.500732 84.028740,826.141479 
	C83.695244,826.225952 83.381935,825.925659 83.021576,825.302856 
	C83.149162,824.968872 83.323814,824.957397 83.760132,824.967407 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M84.016968,829.987671 
	C84.148003,830.131042 84.261879,830.289062 84.375771,830.447083 
	C84.281837,830.402283 84.187897,830.357483 84.032333,830.174805 
	C83.970703,830.036926 83.999817,830.002319 84.016968,829.987671 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M67.005188,821.273438 
	C67.276268,821.164917 67.585304,821.332764 67.949150,821.766785 
	C67.683678,821.871948 67.363411,821.710938 67.005188,821.273438 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M290.635712,325.084473 
	C290.365875,324.819550 290.255554,324.428650 290.200073,324.030090 
	C290.190765,323.963074 290.418365,323.863068 290.536469,323.778320 
	C290.628876,324.170837 290.721283,324.563385 290.635712,325.084473 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M293.778168,319.142914 
	C294.000580,319.440521 294.001190,319.887115 294.000885,320.668701 
	C293.309265,320.573792 292.985718,320.048737 293.778168,319.142914 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M262.160828,320.909546 
	C261.997559,320.832550 261.997559,320.665070 261.998169,320.246368 
	C262.107239,320.269775 262.215668,320.544464 262.160828,320.909546 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M299.152252,384.972534 
	C299.082672,385.615753 299.072723,385.948456 299.101074,386.531219 
	C299.920410,388.465027 300.828278,390.649811 299.639252,391.952118 
	C297.166718,394.660187 300.584259,392.985138 300.902252,393.941803 
	C301.112671,394.242737 301.084808,394.551117 301.070557,394.705261 
	C297.264099,397.895721 300.589386,401.614319 300.234497,405.254211 
	C300.472076,405.738586 300.562531,405.934845 300.740234,406.443298 
	C300.878937,407.179443 300.877533,407.602722 300.709656,408.314545 
	C300.490845,408.999054 299.881897,408.897736 299.863800,409.153229 
	C299.848785,409.364502 300.320251,409.476776 300.914581,409.599915 
	C301.278839,409.919189 301.387543,410.084686 301.570618,410.536316 
	C301.682861,411.404266 301.573944,411.971130 301.442444,412.810059 
	C301.393860,413.623444 301.475677,414.140686 301.982117,414.796753 
	C302.866028,415.563385 303.699188,415.372833 304.812531,415.495239 
	C306.041077,415.856171 306.785797,416.350281 307.225372,417.584167 
	C306.640350,419.000732 305.626617,419.400269 304.182007,419.591370 
	C303.317078,419.481781 302.776917,419.269409 301.942871,419.342712 
	C301.341614,419.340820 301.102905,419.482330 301.120361,420.002502 
	C301.941681,420.684875 302.750763,420.672363 303.850159,420.841919 
	C304.611755,420.955414 305.032166,421.073578 305.714905,421.408630 
	C306.284241,421.885834 306.504883,422.239380 306.690674,422.944458 
	C306.793793,424.031555 307.000214,424.758179 307.782715,425.570007 
	C308.221802,426.182434 308.281555,426.592957 307.966919,427.264893 
	C304.548431,428.076813 301.837311,430.043915 298.348907,430.750977 
	C298.062378,430.957062 297.968018,431.039124 297.921875,431.083099 
	C296.153656,430.727570 296.349182,429.668854 296.356384,428.139374 
	C296.395874,419.770905 296.155518,411.401001 295.995422,403.031891 
	C295.979523,402.201813 295.851166,401.376343 294.765076,400.795959 
	C292.450531,403.047272 295.835510,406.576050 292.989258,408.965393 
	C290.473389,409.626801 288.211884,409.677094 286.367676,407.265259 
	C286.234009,400.583130 286.224579,394.263458 286.119934,387.485596 
	C286.024750,387.027405 286.364380,386.953430 286.538055,386.959961 
	C287.786407,386.664886 287.287537,384.431946 288.964539,385.005981 
	C290.245422,385.444427 290.397675,386.537445 290.143494,387.819000 
	C289.581024,390.655029 289.964447,393.537323 289.873199,396.398224 
	C289.869202,396.523315 289.559814,396.690979 289.587494,396.756409 
	C289.792267,397.240509 289.973755,396.682098 290.437561,396.528137 
	C291.665863,395.748505 292.481781,395.121185 291.100525,393.729919 
	C290.815125,393.289978 290.725464,393.101501 290.605408,392.607910 
	C290.744324,391.535339 290.838348,390.769836 290.442261,389.718536 
	C290.346100,389.000580 290.412445,388.593140 290.749146,387.942596 
	C291.358337,387.475311 291.797363,387.473297 292.249054,387.485992 
	C292.565033,387.494904 292.847168,387.501923 293.092194,387.623688 
	C292.976776,386.965515 292.448334,387.725464 291.971802,387.220947 
	C291.499054,386.679169 291.400909,386.266876 291.465942,385.509583 
	C293.185730,384.105011 294.020416,382.794952 292.702576,380.569153 
	C293.115692,379.017731 293.596863,377.791534 293.074707,376.116394 
	C293.014740,375.320190 293.042480,374.841492 292.904449,374.401672 
	C292.688324,373.712982 292.274628,374.071503 291.862823,374.232391 
	C291.380646,374.420837 291.304474,374.479218 291.672302,374.584290 
	C291.966614,374.668365 292.215912,374.853455 292.615479,375.395813 
	C293.097473,376.953003 293.316132,378.197815 292.675262,379.830444 
	C292.651855,381.402405 292.365997,382.448364 291.078552,383.502686 
	C289.234711,384.181427 287.781769,384.199860 286.035339,383.260284 
	C284.509247,377.830444 285.649536,372.677582 285.534882,367.153107 
	C285.975250,365.481750 287.185486,365.207367 288.222107,364.868958 
	C289.654053,364.401489 288.720459,364.011932 288.476746,363.263458 
	C287.308624,359.676270 288.258911,358.422424 292.740234,357.804565 
	C293.136230,359.196289 293.278687,360.355194 293.667725,361.762695 
	C294.272339,362.210083 294.510864,362.887604 295.078003,362.061951 
	C295.090424,361.825134 295.083588,361.497589 295.068878,361.334473 
	C295.476318,359.952240 295.441406,358.692505 295.200378,357.171875 
	C297.577454,353.438202 296.156799,349.240448 297.091034,345.470093 
	C297.598999,343.420044 295.661926,340.793121 298.939148,339.326904 
	C299.510406,339.688507 299.607849,340.047058 299.535645,340.702332 
	C298.547668,342.106750 299.926239,341.814270 300.398407,342.457764 
	C300.773193,344.068146 300.457184,345.393555 300.209351,346.995819 
	C300.026978,347.592682 300.037231,347.923828 300.009247,348.504120 
	C300.135376,348.930237 300.274170,349.108032 300.581879,349.579102 
	C300.912354,350.292419 301.033478,350.723724 301.142395,351.498535 
	C301.185883,352.490265 301.124939,353.143738 300.913483,354.097839 
	C300.640961,354.793732 300.578094,355.200104 300.847290,355.871765 
	C301.041870,356.118256 301.016022,356.569397 300.999390,356.794739 
	C299.664398,360.814850 299.118561,364.690552 299.753967,369.033203 
	C299.653198,370.063690 299.400513,370.695343 298.872986,371.575439 
	C298.425934,372.160339 297.839294,372.316772 297.834534,372.637238 
	C297.824768,373.288788 297.621063,372.625885 298.582123,372.731567 
	C299.096924,373.159790 299.330261,373.503540 299.218536,373.774872 
	C297.407318,378.173889 299.546631,378.812042 303.594604,378.016754 
	C305.723877,378.027954 307.384430,378.249786 307.777039,380.384979 
	C308.197479,382.671539 306.823761,383.728271 304.576172,384.594177 
	C304.022003,384.871033 303.786041,384.897339 303.193909,384.920166 
	C301.651215,384.404968 300.551056,382.658691 299.152252,384.972534 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M291.411194,387.715576 
	C291.110016,388.401337 291.107300,388.905121 291.133820,389.786011 
	C291.310364,390.557007 291.328156,390.956573 291.119781,391.653748 
	C291.049835,392.145874 291.076263,392.346191 291.128906,392.848450 
	C291.871124,394.007050 292.067200,394.978271 291.610168,396.393982 
	C290.386108,398.001038 289.005341,398.298462 288.023376,398.244110 
	C288.420929,394.151306 289.006683,390.090637 289.052246,386.023895 
	C289.061615,385.190002 287.962433,386.631653 286.996826,386.879272 
	C286.604126,386.447357 286.496552,385.928223 286.233032,385.194458 
	C285.631989,384.502228 285.490479,383.947144 286.083862,383.172424 
	C287.769775,383.025757 289.023895,383.021301 290.654785,383.015503 
	C291.804230,383.310944 292.256378,383.868317 292.134216,384.966003 
	C291.882751,385.604675 291.887024,385.962036 291.885315,386.587372 
	C291.822784,387.081451 291.766205,387.307526 291.411194,387.715576 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M286.493530,382.560913 
	C286.442505,383.468781 286.369324,383.907349 286.186646,384.662842 
	C283.062134,381.835388 283.996490,377.679321 284.377899,374.283478 
	C284.842743,370.144379 284.753357,366.042236 285.008362,361.470947 
	C285.364716,361.012177 285.719025,361.013916 286.339111,361.007050 
	C288.520142,362.165100 287.547119,363.828766 287.087769,365.587402 
	C286.704132,371.241730 286.587738,376.666656 286.493530,382.560913 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M319.182495,354.070007 
	C319.474823,350.010345 315.129242,352.334839 314.416992,350.050659 
	C314.907166,348.096008 317.627350,350.949402 317.724792,348.705322 
	C317.827301,346.344696 315.527740,347.498108 314.430420,346.852722 
	C312.934326,345.972839 311.558746,344.888031 310.039734,343.551880 
	C313.381531,341.633667 316.736237,343.289825 319.921356,343.945374 
	C323.040863,344.587372 326.240997,345.407318 329.625061,346.775879 
	C332.021820,348.639801 337.356598,346.550964 335.704956,352.640900 
	C333.638275,355.301758 330.368073,353.041260 328.044800,355.309235 
	C327.493042,355.494293 327.250916,355.507843 326.637939,355.499023 
	C324.004700,354.947357 321.585876,355.415466 319.182495,354.070007 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M329.909180,346.619507 
	C323.181396,347.555756 317.209381,344.140808 310.346497,343.183807 
	C309.005280,343.066498 308.062592,342.920288 307.119904,342.774078 
	C307.109772,342.572571 307.099670,342.371033 307.089539,342.169495 
	C310.318756,342.169495 313.547974,342.169495 316.777191,342.169495 
	C312.927094,340.296692 308.461212,342.325317 304.665375,339.589600 
	C306.271484,338.620087 307.765259,339.033264 309.611755,339.072632 
	C313.020538,338.303436 316.081787,338.735107 319.505096,338.809082 
	C320.127869,338.902313 320.373901,338.951752 320.979431,339.102905 
	C323.770447,340.403351 326.536865,340.434387 329.286102,341.675354 
	C329.650024,343.356934 329.759918,344.774200 329.909180,346.619507 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M304.945190,327.278229 
	C299.806824,325.997284 305.912201,323.379791 303.973663,321.551025 
	C304.380920,321.205811 304.780792,321.197998 305.482025,321.220428 
	C306.022034,321.470337 306.260712,321.690002 306.751587,321.887024 
	C314.032440,324.913239 321.774750,326.369263 328.063232,331.603149 
	C327.413879,332.887238 326.394897,333.032349 324.926239,332.878967 
	C321.540619,331.020416 318.790527,328.415985 314.458191,329.779236 
	C313.173004,330.074921 312.225769,330.122070 310.926361,329.936554 
	C310.145447,329.722534 309.722870,329.545319 309.024933,329.171967 
	C307.985870,328.570496 307.182373,328.267639 306.035645,327.953186 
	C305.553619,327.722321 305.375946,327.600647 304.945190,327.278229 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M323.696838,331.629761 
	C325.154236,331.860291 326.242523,331.906433 327.739929,331.948669 
	C328.149078,331.944702 328.086700,331.982697 328.066010,331.952576 
	C328.168549,332.116364 328.291779,332.310211 328.295471,332.827209 
	C326.863739,333.852509 325.421722,334.013824 323.567078,334.198822 
	C325.087708,334.153961 326.168243,333.948608 327.569397,333.574524 
	C328.358673,333.387360 328.809784,333.402313 329.524780,333.748352 
	C329.794403,335.718140 329.797882,337.467834 329.681396,339.638855 
	C327.049500,341.979980 324.370911,340.389923 321.378357,340.211304 
	C320.987000,339.992371 321.000000,340.000000 321.006470,340.003845 
	C317.738861,338.111053 313.970612,339.717407 310.247498,338.319153 
	C308.542755,338.064941 307.185791,338.029755 305.421661,337.983032 
	C304.826569,336.862976 305.587372,336.367950 306.416443,336.405212 
	C312.850037,336.694244 319.299591,336.351685 323.050751,336.480865 
	C319.533600,336.457458 313.315125,336.530151 306.322845,336.443420 
	C310.140900,331.365753 314.390594,335.520966 317.889526,334.407135 
	C316.644989,334.471161 315.382751,334.659088 314.152557,333.994415 
	C316.452271,331.455872 316.452271,331.455872 323.696838,331.629761 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M328.262817,355.233093 
	C328.199097,353.995056 327.540222,352.530640 329.556976,352.766327 
	C331.299622,352.969971 333.066711,352.964386 335.214539,353.048767 
	C335.683868,353.479889 335.761688,353.913544 335.773621,354.675171 
	C335.614227,355.500732 335.389893,355.926880 334.656555,356.366699 
	C332.294861,356.588928 330.373962,356.212128 328.262817,355.233093 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M321.214905,340.281342 
	C323.566956,340.019806 326.146881,340.047211 329.144135,340.067444 
	C329.597778,340.479523 329.634155,340.898804 329.605347,341.628906 
	C326.748169,342.032410 324.002563,341.850922 321.214905,340.281342 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M334.727722,356.076843 
	C335.109436,355.474640 335.242737,355.301514 335.562744,355.081787 
	C335.758698,356.731293 335.809601,358.459473 335.776123,360.611725 
	C334.161011,360.263275 334.346954,359.088104 334.976868,357.543518 
	C334.823639,357.003906 334.630707,356.738892 334.727722,356.076843 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M327.689911,333.202820 
	C327.946198,332.765442 327.973419,332.597778 328.022980,332.176300 
	C329.116669,331.785339 329.699280,332.311401 329.861328,333.640564 
	C329.400818,333.946686 329.010742,333.924927 328.327423,333.895325 
	C327.843109,333.749176 327.652008,333.610870 327.689911,333.202820 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M287.031891,366.051880 
	C286.812317,364.404327 286.804108,362.991882 286.700348,361.288940 
	C287.759491,358.143005 285.827576,354.652039 288.775299,352.136414 
	C290.244537,353.557465 290.707336,355.462982 292.691956,356.596222 
	C292.977905,357.007355 292.988953,357.213043 292.996887,357.728088 
	C289.487732,358.771576 287.520111,360.190704 290.270447,363.879181 
	C291.000885,364.858734 290.909393,364.926971 287.031891,366.051880 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M293.032715,356.449890 
	C289.732422,357.497894 288.594299,356.056793 289.089081,352.575745 
	C290.459900,352.188446 291.807068,352.200348 293.527405,352.032043 
	C294.205872,353.375427 293.645172,354.735443 293.032715,356.449890 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M290.999390,337.000610 
	C293.463806,339.365692 293.598663,340.378540 291.748138,345.979706 
	C290.531189,342.812744 291.204712,340.278412 291.000854,337.436890 
	C291.001221,336.998779 291.000000,337.000000 290.999390,337.000610 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M73.983810,859.611572 
	C73.849747,860.191223 73.765831,860.653198 73.100769,860.176147 
	C73.136284,859.579285 73.274483,859.148804 73.412674,858.718384 
	C73.595718,858.938049 73.778770,859.157776 73.983810,859.611572 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M187.888641,906.905151 
	C187.943497,905.782959 187.747849,904.563843 189.055161,904.074890 
	C189.257599,903.999207 189.776031,904.192444 189.813385,904.343933 
	C190.073761,905.400024 189.329269,906.064148 188.444397,906.952759 
	C188.146423,907.125854 187.975250,906.977905 187.888641,906.905151 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M185.837250,904.413086 
	C184.853973,903.682983 185.305740,903.036194 185.982269,902.495789 
	C186.117188,902.388123 186.479416,902.565063 186.736786,902.610657 
	C186.526642,903.171753 186.316498,903.732910 185.837250,904.413086 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M207.246887,905.241455 
	C207.975311,904.248901 208.383255,904.876648 208.625366,905.410645 
	C208.727539,905.635986 208.361710,906.073547 208.208557,906.414612 
	C207.886276,906.109985 207.563995,905.805359 207.246887,905.241455 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M180.814758,901.201782 
	C180.990646,901.727173 180.815750,902.270203 180.389252,902.965088 
	C180.137665,903.116882 179.854416,902.881592 179.707520,902.763550 
	C179.861755,902.170166 180.162857,901.694885 180.814758,901.201782 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M177.312088,900.919312 
	C176.571747,900.309814 176.816101,899.718140 177.683380,899.078247 
	C178.477188,899.702820 178.142334,900.271423 177.312088,900.919312 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M178.294159,899.058228 
	C178.131042,898.684387 178.287537,898.348389 178.734344,897.992859 
	C178.887711,898.347595 178.750732,898.721924 178.294159,899.058228 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M179.254303,897.990479 
	C179.149994,897.722900 179.327377,897.420227 179.772293,897.038574 
	C179.871887,897.291626 179.703949,897.623474 179.254303,897.990479 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M190.341125,902.365417 
	C190.592529,902.325806 190.786987,902.491882 190.757080,902.561157 
	C190.560059,903.017517 190.346481,902.996704 190.341125,902.365417 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M176.264404,902.000244 
	C176.119263,901.666443 176.261337,901.308105 176.716125,900.962891 
	C176.869781,901.309265 176.710709,901.642517 176.264404,902.000244 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M181.026031,901.027161 
	C181.219177,900.784363 181.459335,900.593445 181.699493,900.402527 
	C181.680878,900.627930 181.662277,900.853271 181.404633,901.131348 
	C181.165558,901.184082 181.073044,901.079041 181.026031,901.027161 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M163.786957,891.429443 
	C164.788071,891.396118 165.695953,891.672424 166.897430,892.165161 
	C167.153290,893.747742 166.918854,895.023071 165.297562,895.912048 
	C165.597031,894.280518 161.846176,893.853821 163.786957,891.429443 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M168.270905,898.072266 
	C167.958984,898.753479 167.381760,899.639709 167.286301,899.590454 
	C166.527145,899.199524 166.892990,898.624756 167.506531,897.933594 
	C167.771454,897.762756 168.228790,897.843872 168.270905,898.072266 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M174.001663,898.005249 
	C174.375946,897.767700 174.737747,897.513184 175.099518,897.258667 
	C175.558929,898.062317 174.798645,897.922363 174.205170,898.027832 
	C173.961609,897.955872 173.989182,897.988281 174.001663,898.005249 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M167.906128,897.897949 
	C168.061096,897.567993 168.350769,897.373230 168.640442,897.178528 
	C168.661713,897.430847 168.682968,897.683105 168.508606,898.118042 
	C168.312973,898.300659 168.040802,898.033142 167.906128,897.897949 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M169.431625,895.449829 
	C169.547653,895.344971 169.582703,895.723572 169.582703,895.723572 
	C169.582703,895.723572 169.315598,895.554749 169.431625,895.449829 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M158.299561,893.094238 
	C158.016434,893.500427 157.647476,893.638428 157.278534,893.776367 
	C157.259598,893.520996 157.240677,893.265625 157.448273,892.835938 
	C157.854431,892.716370 158.034088,892.771179 158.299561,893.094238 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M157.850555,892.838745 
	C158.175110,892.282654 158.763702,891.638855 158.535110,893.180298 
	C158.385376,893.362488 158.026337,893.015869 157.850555,892.838745 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M161.952774,895.946655 
	C162.052261,895.712952 162.184006,895.513611 162.315750,895.314270 
	C162.342728,895.503906 162.369690,895.693481 162.225433,895.964111 
	C162.054199,896.045044 161.985016,895.981018 161.952774,895.946655 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M538.037720,1002.145264 
	C538.109070,1002.151306 538.227844,1002.290222 538.346619,1002.429138 
	C538.259460,1002.378784 538.172363,1002.328430 538.037720,1002.145264 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M538.007080,1001.994263 
	C537.883667,1001.853455 537.753723,1001.718079 537.623840,1001.582703 
	C537.714111,1001.629761 537.804382,1001.676819 537.942505,1001.868164 
	C537.990295,1002.012390 538.000549,1001.999756 538.007080,1001.994263 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M548.543457,992.575073 
	C548.467957,992.620117 548.438232,992.434021 548.438232,992.434021 
	C548.438232,992.434021 548.618958,992.530029 548.543457,992.575073 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M546.546204,993.571533 
	C546.470337,993.616028 546.439575,993.431580 546.439575,993.431580 
	C546.439575,993.431580 546.622070,993.527039 546.546204,993.571533 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M556.998779,972.001221 
	C557.119080,972.139832 557.240601,972.277222 557.362122,972.414551 
	C557.278748,972.365845 557.195435,972.317078 557.057129,972.132935 
	C557.002197,971.997559 557.000000,972.000000 556.998779,972.001221 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M561.369385,945.342651 
	C564.805847,938.978088 570.347473,934.861206 576.645630,931.097046 
	C576.889404,934.284546 578.299072,936.120056 582.009644,936.103149 
	C581.009521,939.565796 577.463440,938.844421 575.354370,940.529968 
	C573.831421,941.747253 571.841919,942.273560 570.075867,943.795166 
	C569.634827,944.167786 569.446960,944.305115 568.945740,944.600952 
	C567.968750,945.009827 567.276917,945.148010 566.231934,945.332947 
	C564.472046,945.533203 563.084656,946.174072 561.369385,945.342651 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M558.315796,952.950562 
	C558.758484,949.174011 563.453552,950.731140 565.013916,947.545776 
	C565.205261,946.348633 565.731201,945.726501 566.541626,944.946777 
	C567.347778,944.502563 567.973633,944.538025 568.801147,944.200073 
	C569.046814,944.024841 568.998901,944.001038 569.009277,944.025757 
	C570.920776,942.756104 572.793762,941.393066 575.588745,941.707520 
	C578.255554,944.222290 575.975403,945.486084 574.665894,946.738831 
	C573.120850,948.217041 571.301270,949.408264 569.290161,950.857239 
	C568.556641,950.875977 567.929321,950.522217 567.741455,950.682800 
	C565.075317,952.960999 561.858459,952.899780 558.315796,952.950562 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M576.133301,941.648743 
	C573.858276,942.691406 571.805237,943.463501 569.385986,944.143066 
	C569.396484,940.531616 572.887695,941.154541 574.863892,939.811218 
	C576.873474,938.445190 579.342407,937.754944 581.896484,936.578857 
	C583.584290,935.640869 584.985840,934.892822 586.708557,934.021484 
	C587.178345,933.806396 587.327026,933.714722 587.713196,933.733521 
	C587.950745,933.844055 588.418884,933.864014 588.848755,934.103882 
	C585.486877,937.636658 580.788818,939.264404 576.133301,941.648743 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M566.073853,956.027710 
	C564.038757,954.982117 564.076111,954.869690 567.723633,952.996582 
	C568.320984,953.311218 568.330994,953.524841 568.081055,953.926392 
	C567.654358,954.237305 567.495850,954.369995 567.228516,954.614746 
	C566.878235,955.017700 566.635986,955.311096 566.201294,955.815552 
	C566.017578,956.033997 566.058899,956.007874 566.073853,956.027710 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M567.883301,952.880615 
	C567.865295,952.567444 567.988953,952.393616 568.264893,952.158020 
	C568.967712,952.046997 569.544678,952.016602 570.582703,952.015442 
	C570.851501,952.587952 570.659180,953.131165 570.202148,953.812134 
	C569.622375,953.655884 569.252808,953.485840 568.523438,953.352173 
	C568.226746,953.244751 567.998718,953.001099 567.883301,952.880615 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M588.986572,933.983582 
	C589.389160,933.564209 589.890930,933.263306 590.692139,932.976807 
	C590.606445,933.382751 590.221436,933.774292 589.557495,934.254761 
	C589.278625,934.343689 589.085815,934.102112 588.986572,933.983582 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M570.992554,951.987549 
	C571.338440,951.576111 571.588806,950.767456 572.282104,951.619202 
	C572.023438,951.752075 571.764709,951.885010 571.274902,952.031250 
	C571.043823,952.044678 571.008423,952.007629 570.992554,951.987549 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M568.132568,953.465515 
	C568.703918,953.338013 569.181152,953.431335 569.797974,953.737183 
	C569.470825,954.027222 569.004028,954.104675 568.179199,954.148193 
	C567.821106,954.114319 568.038330,953.686279 568.132568,953.465515 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M591.002197,933.003174 
	C591.318665,932.779175 591.632446,932.551514 591.946228,932.323853 
	C592.027283,932.437073 592.108276,932.550354 592.189331,932.663696 
	C591.937866,932.781677 591.686401,932.899658 591.213135,933.004395 
	C590.991455,932.991211 590.999573,932.999390 591.002197,933.003174 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M587.861328,933.701355 
	C587.950745,933.844055 587.496277,933.975098 587.263000,933.936646 
	C587.277100,933.784973 587.524536,933.671814 587.861328,933.701355 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M566.332031,955.960205 
	C566.232239,955.721069 566.446960,955.408142 566.886597,954.906128 
	C566.956543,955.106812 566.801514,955.496582 566.332031,955.960205 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M552.072510,955.697388 
	C552.588989,955.301147 552.991028,955.212830 553.701294,955.098328 
	C554.338440,955.854309 554.667419,956.636475 555.043457,957.735718 
	C555.201294,958.251770 555.312134,958.450623 555.096924,958.751221 
	C553.075806,959.895935 551.265015,962.885193 549.585083,961.190857 
	C547.658081,959.247253 551.399780,957.935181 552.072510,955.697388 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M554.941833,959.026367 
	C554.770935,958.852905 554.921265,958.449036 555.005859,958.250977 
	C555.090515,958.052856 555.549072,958.042175 555.768311,958.015015 
	C555.815369,958.478088 556.332275,959.465759 554.941833,959.026367 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M556.002686,958.004761 
	C556.477356,957.695251 556.948120,957.379822 557.702881,957.027222 
	C557.519104,957.313049 557.051514,957.636108 556.285767,957.973511 
	C555.987610,957.987915 555.998840,957.998779 556.002686,958.004761 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M560.472961,954.458740 
	C560.531494,954.423950 560.414429,954.493469 560.472961,954.458740 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M558.005005,957.006592 
	C558.095703,956.971130 558.181396,956.929077 558.126892,956.938477 
	C557.986755,956.989990 558.000000,957.000000 558.005005,957.006592 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M567.256165,945.078979 
	C566.763489,945.924866 566.211426,946.454468 565.383301,947.098999 
	C563.376770,946.949158 562.105652,948.164673 560.594971,948.600159 
	C559.006531,949.057983 557.300720,949.540527 557.164062,946.581848 
	C558.305786,946.003601 559.432495,945.776550 560.827881,945.328125 
	C562.513489,944.792969 563.930542,944.479065 565.712341,944.154907 
	C566.448730,944.353516 566.822144,944.559204 567.256165,945.078979 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M554.060059,947.116821 
	C554.110413,946.945557 554.291931,946.924683 554.740112,946.838257 
	C554.828369,947.091858 554.766479,947.602966 554.060059,947.116821 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M173.273773,553.026489 
	C173.086365,552.077209 172.911392,550.979919 174.410736,550.466675 
	C174.321213,551.287537 173.943542,552.145630 173.273773,553.026489 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M175.356720,549.077515 
	C173.848007,548.138672 174.879532,547.235291 175.758453,546.150879 
	C175.888535,546.955322 175.752640,547.886597 175.356720,549.077515 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M176.290039,545.973145 
	C176.196701,545.726196 176.364838,545.437134 176.781601,545.079346 
	C176.870667,545.317444 176.711090,545.624268 176.290039,545.973145 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M177.976471,540.064819 
	C178.009521,540.268311 177.762039,540.538269 177.259277,540.907715 
	C177.234634,540.715210 177.465271,540.423157 177.976471,540.064819 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M576.294434,712.808472 
	C570.442993,719.438232 563.684387,720.842529 555.519592,718.474548 
	C551.252014,717.236938 546.574219,717.188477 542.275940,718.900696 
	C535.652222,721.539185 528.898804,723.642212 521.510803,724.984253 
	C517.131653,723.895203 517.515564,721.473877 519.707764,718.330933 
	C519.999146,718.015625 520.003723,718.003906 520.009827,718.002197 
	C520.421326,717.633606 520.895508,717.483032 521.723572,717.811523 
	C522.542175,720.216370 523.596008,720.714600 524.845459,718.687317 
	C525.510681,717.607971 526.057678,716.121033 525.890198,714.925598 
	C525.370300,711.214111 527.302917,709.490601 530.366577,708.264465 
	C532.067017,707.583862 533.911316,706.565002 533.755920,704.445312 
	C533.604797,702.383179 531.302673,703.321594 530.143188,702.546448 
	C529.098267,701.847778 527.073914,701.583740 527.569946,700.033508 
	C528.223572,697.990967 530.543945,697.495483 532.418884,697.147766 
	C538.723511,695.978943 545.136414,695.330994 551.381653,693.923645 
	C557.232666,692.604980 563.262085,693.608887 569.052185,692.037842 
	C570.148926,691.740295 571.414795,691.996765 571.948486,690.170654 
	C572.579102,689.027771 573.460571,688.950134 574.577332,688.712524 
	C580.025146,687.884277 584.725525,685.742737 589.422546,683.694824 
	C592.965271,682.150208 595.535522,682.365417 597.971741,685.755066 
	C602.762451,692.420715 610.090942,695.947815 617.027466,700.452026 
	C617.142944,700.920105 617.048889,701.120422 616.670410,701.490723 
	C614.730225,702.049561 612.922485,701.786072 611.105957,702.945312 
	C607.487366,703.044556 607.106384,705.701111 606.264954,707.969238 
	C605.806946,709.203735 605.269836,710.746826 603.605652,710.237183 
	C601.821045,709.690735 601.751709,707.992737 602.352661,706.549438 
	C603.298157,704.278748 604.466980,702.101318 605.246277,699.397949 
	C605.478699,698.805054 605.642212,698.559143 605.783752,698.303467 
	C606.106567,697.720459 605.878906,698.591736 606.041260,697.955627 
	C606.145752,697.546509 606.059448,698.042664 605.833191,698.230347 
	C604.450745,700.955078 604.051880,703.768433 601.925171,706.095276 
	C601.386169,706.228455 601.156311,706.201965 600.692078,705.920654 
	C599.474487,703.537537 600.962036,701.142700 599.365601,699.524597 
	C599.125610,699.911011 599.163696,701.117432 597.997559,702.035400 
	C597.464844,702.204773 597.232788,702.200012 596.751343,701.951538 
	C595.710205,700.161987 596.043518,698.682312 596.663452,697.163940 
	C597.213867,695.815552 595.931641,696.795410 595.373291,696.322388 
	C594.531128,695.715210 594.529724,695.065918 594.535522,694.105164 
	C594.746887,693.395630 595.026001,693.049988 595.233765,692.665100 
	C595.360840,692.429749 595.485535,692.209961 595.695679,692.044128 
	C595.432312,692.175049 595.273071,692.400818 595.038269,692.968506 
	C594.304199,693.960388 594.554565,694.844849 594.365112,695.992188 
	C592.361389,698.809143 591.812195,702.263123 588.557373,704.095459 
	C586.386230,702.968140 585.360413,703.996277 584.179504,705.347229 
	C581.855530,708.005493 579.859741,711.028625 576.294434,712.808472 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M574.587524,688.500732 
	C574.130920,689.013916 573.367004,689.303833 572.310791,689.684387 
	C558.625732,691.490112 545.232971,693.205261 531.428589,694.896729 
	C532.854004,691.863708 536.342896,691.236023 539.017090,691.231628 
	C549.763000,691.214050 560.292969,689.645020 570.850281,688.055481 
	C571.957336,687.888794 573.135193,688.192200 574.587524,688.500732 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M528.725830,694.759033 
	C519.375916,697.465820 509.720306,699.719116 499.458984,701.121765 
	C508.548676,697.619080 517.995056,693.801575 528.725830,694.759033 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M621.994812,703.169556 
	C621.436157,705.046082 619.922363,705.284668 618.287598,705.846680 
	C616.719788,704.745605 616.502625,703.284790 616.833862,701.356750 
	C616.991943,701.011230 617.115479,700.868713 617.176208,700.794250 
	C619.047974,700.832581 620.474426,701.796387 621.994812,703.169556 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M494.851318,701.899109 
	C492.964600,702.741333 490.863251,703.291870 488.389313,703.816528 
	C489.561584,701.056458 492.053345,701.193176 494.851318,701.899109 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M498.736206,701.050659 
	C498.504608,701.953308 497.584137,701.938293 496.363525,701.989990 
	C496.589294,701.081421 497.468475,700.991455 498.736206,701.050659 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M476.561737,641.832520 
	C476.651611,641.466858 476.937988,641.333923 477.692871,641.132202 
	C477.693695,641.397339 477.225952,641.731262 476.561737,641.832520 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M513.794556,631.800598 
	C513.995239,632.394348 513.989624,632.727112 513.982910,633.309570 
	C514.094971,634.565308 513.819153,635.527039 513.815063,636.744690 
	C514.253113,637.189453 514.522217,637.390015 514.908691,637.817871 
	C515.026062,638.045227 515.008667,638.530823 515.001404,638.773682 
	C514.560425,639.390991 514.060364,639.534302 513.154663,639.223450 
	C511.898743,638.925354 511.213501,638.574402 511.068420,637.241638 
	C511.049469,636.928345 511.150909,636.692566 511.095459,636.818665 
	C509.286774,636.960571 507.533508,636.976379 505.342407,636.970398 
	C503.488007,634.681396 500.561951,632.692932 503.906128,629.546692 
	C505.066345,629.512512 505.994507,630.128113 506.652557,629.446228 
	C510.375916,625.587952 511.924744,628.708191 513.794556,631.800598 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M494.096375,633.938599 
	C493.919159,633.717896 493.921143,633.609192 493.963806,633.575562 
	C493.905823,633.130066 493.720673,632.760498 493.213196,632.227844 
	C492.975189,632.022522 492.977234,632.014282 492.962585,632.024780 
	C493.021149,631.634705 493.094330,631.234009 493.151154,630.520020 
	C495.082428,630.212341 495.857300,628.915833 496.673096,627.155579 
	C496.993622,627.002319 496.988068,626.978271 496.975037,626.980591 
	C498.057922,627.947327 499.367249,628.397461 501.049072,628.807617 
	C500.369354,632.290833 504.361511,633.396301 504.243774,636.504395 
	C503.598358,637.208069 503.130890,637.617676 502.340454,638.068970 
	C501.857788,638.014038 501.698059,637.917480 501.345215,637.629333 
	C500.908783,637.188782 500.639404,636.973816 500.083862,636.879150 
	C499.201630,637.674683 498.741608,638.679138 497.230682,638.222778 
	C496.972382,638.039368 496.496033,638.026489 496.258057,638.024170 
	C495.765137,637.569153 495.510162,637.116516 495.110046,636.446960 
	C495.046356,635.435669 494.808075,634.748108 494.096375,633.938599 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M497.113831,638.336609 
	C499.377472,638.399048 497.365051,634.869751 499.896729,635.063904 
	C500.707581,635.675842 501.222717,636.281433 501.881958,637.150269 
	C502.034851,637.406128 501.988342,637.756104 502.002930,637.933350 
	C502.254211,640.110962 501.229645,641.085815 499.354736,641.268433 
	C497.361481,641.462463 498.195526,639.324707 497.113831,638.336609 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M504.274597,636.840820 
	C503.896088,634.834229 502.561401,632.879517 501.287750,632.375854 
	C497.971649,631.064392 502.116913,630.372253 501.701904,628.982788 
	C502.335693,628.390686 502.542908,628.308533 503.082886,628.187012 
	C503.864868,628.179199 504.294220,628.288391 504.952820,628.697021 
	C505.241699,629.136536 505.281494,629.354675 505.158447,629.862793 
	C503.395325,630.344360 502.417542,630.910522 503.485718,632.687439 
	C504.151428,633.794922 505.177155,634.745911 504.952332,636.581665 
	C504.904572,636.948669 504.483429,636.883240 504.274597,636.840820 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M512.858765,639.337036 
	C513.300293,638.998169 513.785522,638.996338 514.632446,639.005554 
	C514.779602,640.784058 514.218079,642.351257 512.603271,643.374146 
	C511.460968,641.951477 512.896606,640.885315 512.858765,639.337036 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M506.741516,644.949829 
	C505.810364,644.499756 505.671417,643.578979 505.706207,642.623047 
	C505.708557,642.558105 506.235504,642.512207 506.518463,642.457458 
	C506.640900,643.211914 506.763306,643.966431 506.741516,644.949829 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M506.925171,639.640259 
	C505.897339,640.790405 505.499847,639.981873 505.182220,639.237671 
	C505.101013,639.047546 505.355469,638.510620 505.563477,638.436890 
	C506.345093,638.159607 506.723572,638.672180 506.925171,639.640259 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M517.582397,679.117554 
	C518.792847,679.542664 519.165466,680.191162 517.540527,680.935791 
	C517.302002,680.433594 517.346680,679.879028 517.582397,679.117554 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M510.530518,647.473694 
	C511.006378,647.531250 511.295990,647.767334 511.585632,648.003357 
	C511.398132,648.185486 511.210602,648.367554 511.023071,648.549622 
	C510.796814,648.250488 510.570557,647.951294 510.530518,647.473694 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M516.608154,640.495117 
	C517.089111,640.555725 517.382874,640.796570 517.676575,641.037476 
	C517.486694,641.222412 517.296753,641.407288 517.106812,641.592163 
	C516.878174,641.286560 516.649536,640.980957 516.608154,640.495117 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M509.917572,644.706055 
	C509.520752,644.286804 509.393280,643.886414 509.360504,643.478333 
	C509.356232,643.425171 509.932861,643.188538 510.080475,643.284119 
	C510.674988,643.668762 510.841980,644.180298 509.917572,644.706055 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M510.070496,653.508545 
	C511.639404,652.880920 510.697144,654.076721 510.883362,654.539307 
	C510.920776,654.632324 510.574341,654.879883 510.404907,655.056213 
	C510.280609,654.626587 510.156281,654.197021 510.070496,653.508545 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M503.131531,642.756348 
	C502.896454,642.226318 502.780304,641.465515 503.640717,641.625427 
	C503.685883,641.633789 503.590912,642.395996 503.131531,642.756348 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M503.051086,643.062012 
	C502.938110,643.371460 502.709595,643.561218 502.481079,643.750977 
	C502.430817,643.497681 502.380554,643.244324 502.516083,642.848267 
	C502.701874,642.705566 502.935577,642.942322 503.051086,643.062012 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M509.143677,650.931580 
	C509.067535,650.885803 509.222137,649.999146 509.143677,650.931580 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M509.036804,651.048767 
	C508.930603,651.114868 508.792816,651.942078 508.778381,651.012573 
	C508.914978,650.931030 508.998901,651.006836 509.036804,651.048767 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M501.242218,623.126953 
	C500.915314,622.409546 500.735138,622.000549 500.463379,621.269043 
	C500.687653,620.433105 500.760437,619.912170 500.230225,619.169922 
	C500.040222,618.961304 499.997009,618.992676 500.021606,618.984253 
	C499.917816,618.780823 499.789398,618.585876 499.884552,618.121399 
	C499.766144,617.106995 499.424133,616.362183 499.413605,615.025452 
	C499.745056,614.433594 499.380219,614.429077 499.159912,614.182678 
	C498.901550,613.165894 499.168579,612.119324 498.768158,611.677002 
	C497.574219,610.358093 497.471924,610.450684 499.213684,609.025269 
	C500.233948,607.835388 501.348877,607.542725 502.860718,607.366699 
	C503.431580,607.452515 503.652893,607.526978 504.134033,607.837036 
	C505.203278,608.749084 504.071136,610.255127 505.438477,610.602478 
	C505.690186,610.666443 505.932617,609.891968 506.160950,609.114563 
	C506.372223,608.585571 506.483856,608.384644 506.871521,607.974976 
	C508.208130,607.730347 508.787689,608.484253 509.645538,609.409424 
	C511.087769,612.809753 515.885620,614.297241 513.948547,619.135986 
	C513.653931,619.627869 513.511841,619.809387 513.074097,620.169434 
	C511.612885,620.574890 510.539795,620.241638 509.215698,619.661926 
	C508.564056,619.444885 507.875824,618.135803 507.948639,620.081421 
	C506.487915,624.437500 504.037262,625.570068 501.242218,623.126953 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M503.395294,607.700195 
	C502.249573,608.559937 501.283234,609.198914 499.721802,608.836853 
	C498.864471,607.444092 495.632446,606.806030 498.483948,604.345093 
	C498.722626,603.151428 498.864960,602.293213 499.021759,601.096802 
	C499.565216,599.865662 500.196136,599.977356 501.054474,601.067566 
	C501.232910,601.563171 501.646606,601.798279 501.885529,601.746948 
	C502.572174,601.436462 502.940765,601.080200 503.505066,600.543213 
	C504.572968,600.557251 505.447693,600.755188 506.661163,600.970032 
	C507.890259,601.120483 508.222321,601.839478 508.794067,602.725830 
	C509.524445,603.314758 510.059662,603.689697 510.929169,604.125549 
	C512.085266,605.334534 512.284729,606.591614 511.773956,608.300232 
	C511.335358,609.059753 510.966156,609.363586 510.148010,609.555237 
	C508.554718,609.517456 508.670807,607.803467 507.227417,607.813599 
	C506.968872,607.970581 506.840698,608.291382 506.840881,608.464111 
	C506.400360,608.753906 505.957397,608.770874 505.216919,608.516602 
	C504.180542,607.484741 503.980316,606.328003 503.384064,605.315125 
	C503.239380,604.718506 502.499390,605.381653 503.135895,605.219666 
	C503.331024,605.169983 503.529785,605.674438 503.599609,606.002869 
	C503.701813,606.483521 503.743164,606.956604 503.395294,607.700195 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M499.998413,619.306152 
	C501.085663,619.182800 502.657623,619.107910 500.725342,620.876465 
	C500.371796,620.946472 500.366119,620.965881 500.359863,620.969971 
	C500.221252,620.533081 500.088928,620.091980 499.998413,619.306152 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M498.997925,615.001221 
	C498.486450,614.833618 497.695312,615.239319 497.558502,614.345764 
	C497.542633,614.242065 498.073120,614.054749 498.644958,613.921265 
	C498.939606,613.936279 499.057617,614.052368 499.117493,614.109497 
	C499.257172,614.335388 499.337006,614.504211 499.196808,614.846313 
	C498.976746,615.019531 498.991180,615.007385 498.997925,615.001221 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M499.914642,617.959778 
	C500.135834,618.041260 500.163574,618.230591 500.118774,618.697876 
	C499.850555,618.789307 499.642212,618.612976 499.474274,618.404114 
	C499.451813,618.376221 499.633820,618.183899 499.914642,617.959778 
z"/>
<path fill="#6C7795" opacity="1.000000" stroke="none" 
	d="
M484.001221,626.001221 
	C483.881622,626.422607 483.760803,626.842773 483.640015,627.262939 
	C482.946777,626.949829 483.338684,626.594055 483.798767,626.120483 
	C483.997559,625.997559 484.000000,626.000000 484.001221,626.001221 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M508.647461,619.123291 
	C510.174408,618.918640 511.405823,618.726440 512.369019,620.440430 
	C513.130737,620.767456 513.485046,621.032227 513.823975,621.797119 
	C514.001465,623.513123 514.588623,624.940918 513.266968,626.450012 
	C511.185272,627.783508 508.862854,627.350647 506.762207,628.618652 
	C505.388306,628.156921 504.358368,627.889893 503.056122,628.805786 
	C502.570648,628.946960 502.374786,628.940125 501.885620,628.953125 
	C500.957245,627.961060 501.010437,626.826965 501.014282,625.364990 
	C501.022034,624.536621 501.027283,624.045349 501.064026,623.186279 
	C501.930969,623.510437 502.766418,624.202454 503.584198,624.879761 
	C504.899414,623.582153 503.256744,622.770142 503.194214,622.013794 
	C504.037872,619.557556 507.106018,626.243652 506.995056,620.390869 
	C507.342255,619.540955 507.779480,619.208191 508.647461,619.123291 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M500.750366,625.187256 
	C502.645233,625.822205 501.891113,627.070984 501.609558,628.599731 
	C501.592316,628.973022 501.619476,628.955566 501.631042,628.942749 
	C500.136566,628.662903 498.316803,629.532837 497.100464,627.348816 
	C498.482574,627.183411 500.329498,628.086365 500.750366,625.187256 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M493.925232,634.115601 
	C495.108032,633.945740 496.343323,634.138306 495.257812,636.049561 
	C494.716705,636.192627 494.468506,636.155151 493.845612,636.072510 
	C493.624390,635.522705 493.777832,635.018005 493.925232,634.115601 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M493.014954,632.344971 
	C493.354919,632.278687 493.734619,632.534912 494.060425,633.166504 
	C493.689240,633.250427 493.371979,632.958862 493.014954,632.344971 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M610.076172,261.797272 
	C608.858948,261.862610 608.165771,261.437408 607.954407,260.091553 
	C607.827637,258.738892 607.760864,257.709381 607.593872,256.304077 
	C607.493774,255.928253 607.445923,255.497314 607.485596,255.284180 
	C607.639526,253.658249 607.753845,252.245453 607.994141,250.423584 
	C608.496704,249.670792 608.936218,249.497742 609.794312,249.647141 
	C611.390808,251.305725 613.048767,251.693985 614.961060,251.702667 
	C616.889587,251.711411 618.968628,251.483582 620.493530,253.662781 
	C620.542419,254.260864 620.492859,254.502869 620.234375,255.051758 
	C618.946655,256.198151 617.639404,256.551086 616.355225,256.623352 
	C613.083496,256.807434 611.469666,258.845184 610.076172,261.797272 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M610.106323,250.065948 
	C609.326294,250.009399 608.981689,250.013550 608.378601,250.016113 
	C608.043762,249.250031 607.967407,248.485565 607.813965,247.344879 
	C607.736877,246.968643 607.939575,247.072815 608.053467,247.073853 
	C608.567566,246.653931 609.011353,246.285431 609.902832,245.803497 
	C612.212219,245.144501 614.329712,244.327911 615.423828,246.754440 
	C616.181091,248.433990 615.049561,249.510712 613.445557,250.035507 
	C612.490967,250.347809 611.518311,250.369858 610.106323,250.065948 
z"/>
<path fill="#F4F5DB" opacity="1.000000" stroke="none" 
	d="
M607.346680,255.117752 
	C607.525208,255.071045 607.654358,255.505203 607.574097,255.716736 
	C607.224121,255.827530 606.954407,255.726822 606.684753,255.626099 
	C606.845825,255.472214 607.006958,255.318329 607.346680,255.117752 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M367.944336,585.681519 
	C366.851227,586.072998 366.140594,585.568481 366.000732,583.966248 
	C366.616089,584.179626 367.233917,584.777954 367.944336,585.681519 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M365.220886,582.798401 
	C365.065216,582.821106 364.685150,582.624573 364.141052,582.146240 
	C364.316803,582.102722 364.656616,582.340942 365.220886,582.798401 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M316.172638,513.889160 
	C315.110565,513.260986 316.088776,512.899109 316.653290,512.233093 
	C316.787231,512.645081 316.599762,513.187195 316.172638,513.889160 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M315.243591,515.084656 
	C315.067841,514.547913 315.216034,514.129211 315.692322,513.815552 
	C315.869446,514.348022 315.718506,514.775330 315.243591,515.084656 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M295.788605,524.782166 
	C296.754608,525.423889 297.268463,526.184082 298.145294,526.957397 
	C298.508240,526.970459 298.382904,527.254883 298.278137,527.369629 
	C296.738953,531.101135 294.176880,533.621765 290.312744,535.073364 
	C289.742310,530.533325 287.025452,528.967896 283.068481,527.835205 
	C277.382782,526.207642 271.823914,524.098389 266.064270,522.454407 
	C275.881317,522.881531 285.545349,524.678955 295.788605,524.782166 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M289.800018,535.227295 
	C292.546326,532.638611 295.127075,530.344727 297.940582,527.767700 
	C299.501160,527.510742 298.968811,528.526489 299.037292,529.591675 
	C298.444183,530.984558 298.504303,532.170166 297.856110,533.492493 
	C297.578827,533.992065 297.449646,534.182129 297.080811,534.620728 
	C292.866577,537.520874 290.745789,541.681763 288.207794,545.498718 
	C287.219208,546.985474 286.596313,548.792236 284.279602,549.338013 
	C282.561157,548.240479 281.186188,547.161255 279.523743,545.928345 
	C279.226532,544.001160 280.381287,544.451904 281.621887,544.967407 
	C283.413605,546.507446 283.691223,545.020325 284.245300,544.137207 
	C286.045563,541.267944 287.838623,538.394165 289.800018,535.227295 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M301.101807,534.572021 
	C301.097748,534.955322 300.751495,535.216980 300.668152,535.417358 
	C298.570740,539.417603 295.377533,542.355103 293.068359,545.968079 
	C291.167938,548.941528 290.046204,551.425110 293.239136,554.154602 
	C294.243530,555.013306 294.842896,556.247620 294.737183,558.016724 
	C294.556213,558.571167 294.441101,558.777649 294.004211,559.132935 
	C290.970581,556.399414 288.258759,553.516968 285.316376,550.348877 
	C288.973206,544.929993 291.599854,538.873108 296.742249,534.214844 
	C296.984070,533.947510 296.999817,534.000427 296.973206,533.993103 
	C297.835022,533.142700 298.015228,531.641357 299.716370,531.145142 
	C301.792694,531.557129 300.945801,533.048645 301.101807,534.572021 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M299.770142,530.883789 
	C299.193481,532.005554 298.397369,533.020386 297.273926,534.010498 
	C295.538269,532.030151 297.907501,531.595215 298.689911,530.193237 
	C299.113831,530.294250 299.300720,530.557983 299.770142,530.883789 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M485.128235,244.259918 
	C483.462463,244.524170 482.061615,243.667770 480.322083,244.498230 
	C481.018280,240.484009 484.060577,242.003189 486.388885,242.508636 
	C487.178528,242.680069 486.035980,243.681290 485.128235,244.259918 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M483.385010,250.055328 
	C482.063873,249.942993 481.135284,249.803436 479.806183,249.603714 
	C481.985840,248.498428 483.885498,248.497223 486.176697,248.846802 
	C485.929840,250.145523 484.813904,249.982559 483.385010,250.055328 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M474.014648,239.392624 
	C472.666321,239.971542 471.228394,240.610199 470.377594,238.506744 
	C471.040863,236.785492 472.252808,237.261475 473.616455,237.047577 
	C474.010376,237.699432 474.010040,238.376678 474.014648,239.392624 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M474.259216,236.996902 
	C474.069275,236.841034 474.114380,236.670227 474.217438,236.240723 
	C474.615967,236.198334 474.956543,236.414673 475.297089,236.631042 
	C475.029480,236.748032 474.761871,236.865005 474.259216,236.996902 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M467.482849,238.411194 
	C467.714508,238.514130 467.673370,238.593399 467.681030,238.630615 
	C467.528870,238.713165 467.359619,238.813538 467.211853,238.788315 
	C467.066132,238.763412 466.942108,238.611374 466.808563,238.515137 
	C466.956085,238.446167 467.103638,238.377197 467.482849,238.411194 
z"/>
<path fill="#130613" opacity="1.000000" stroke="none" 
	d="
M469.730896,238.538559 
	C470.905396,239.682693 470.041229,239.716110 469.117432,239.434250 
	C469.125580,238.896988 469.260651,238.719009 469.730896,238.538559 
z"/>
<path fill="#1C0C17" opacity="1.000000" stroke="none" 
	d="
M469.008301,238.726028 
	C468.410217,239.452576 467.967651,239.364624 467.780151,238.428497 
	C468.321381,238.169052 468.696747,238.283951 469.008301,238.726028 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M497.740173,249.366776 
	C497.757751,249.338196 497.711029,249.410156 497.692841,249.372742 
	C497.674652,249.335327 497.722565,249.395355 497.740173,249.366776 
z"/>
<path fill="#707A9A" opacity="1.000000" stroke="none" 
	d="
M443.172974,756.714111 
	C442.704224,756.961060 442.457092,756.957031 441.837463,756.948303 
	C445.682617,747.833679 452.697174,740.723145 458.662262,732.861206 
	C459.952881,731.160217 461.131592,729.374329 462.307281,727.078003 
	C462.506775,726.294922 462.772247,726.075256 463.251648,725.704163 
	C463.593048,725.430176 463.731842,725.321411 464.097900,725.073853 
	C464.808105,724.681824 465.252472,724.377686 465.809387,723.761353 
	C466.654144,723.136047 467.331482,722.795654 468.407562,722.879028 
	C471.469849,725.059753 474.679779,722.029724 477.775299,723.869690 
	C476.252197,730.062866 470.933655,732.959534 466.346741,736.867249 
	C458.461914,743.432007 450.928253,749.947571 443.172974,756.714111 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M466.035217,737.237549 
	C469.902008,732.814758 473.808472,728.713196 477.882812,724.325317 
	C483.567413,720.031311 488.326477,714.850037 495.593445,712.969543 
	C496.115906,713.151672 496.256104,713.325867 496.213226,713.780945 
	C496.030151,714.061890 495.995697,714.011353 496.025574,714.004883 
	C495.446991,714.470093 495.497955,715.230896 495.132202,716.187256 
	C494.331573,717.273865 493.639496,718.029846 492.717957,718.903442 
	C491.674011,719.364807 491.067474,719.981140 490.233459,720.821899 
	C490.020233,721.065063 490.002625,721.004028 490.032043,721.015869 
	C489.583130,721.404297 488.986359,721.472839 488.223022,721.859009 
	C488.013153,722.064026 488.003174,722.000977 488.034729,722.005676 
	C487.556030,722.411194 487.493164,723.004272 487.209106,723.813293 
	C487.026825,724.045898 486.992889,724.013123 487.016205,724.009277 
	C486.714325,724.270996 486.429840,724.574158 486.099915,725.220337 
	C486.007446,725.519836 485.748962,725.922058 485.634674,725.965454 
	C485.111115,726.108215 484.743042,726.288940 484.220276,726.802124 
	C484.017426,727.039490 484.011505,726.994812 484.025513,727.012939 
	C481.903534,728.592896 480.749969,731.129150 478.281281,732.822937 
	C478.043365,733.048828 478.001221,733.000000 478.026306,733.020447 
	C476.587189,734.461365 476.039703,736.805176 473.363159,737.296265 
	C473.022522,736.758057 473.027435,736.276367 473.063171,735.434326 
	C473.546021,734.156189 474.173676,733.343445 474.856232,732.213867 
	C475.894714,731.433350 476.683990,730.828125 477.366089,729.688965 
	C477.729279,729.178467 477.963348,729.037292 478.256897,729.038757 
	C478.555206,729.040283 478.459045,729.028381 477.765686,729.215637 
	C476.898712,730.163879 476.426758,731.077637 475.295959,731.785767 
	C474.411469,732.763489 473.893250,733.640747 473.098328,734.680664 
	C470.861237,735.028076 469.943451,736.727112 468.606934,737.828064 
	C467.675415,738.595459 466.736420,739.361267 466.035217,737.237549 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M519.676514,718.032532 
	C519.436462,720.313049 518.412415,722.649658 520.861755,724.925964 
	C515.232788,730.697876 509.354797,736.310730 502.392334,741.063110 
	C503.830841,737.205139 506.878448,734.037903 508.130737,729.542358 
	C508.572754,728.437378 509.394867,728.177490 510.168396,727.589722 
	C510.326111,727.506592 510.464905,727.442383 510.302368,727.494385 
	C509.584351,727.918579 509.035767,728.301819 508.172760,728.748657 
	C507.507660,728.945862 507.112488,729.008728 506.275146,728.961792 
	C506.481232,728.080322 507.129456,727.308594 507.880737,726.252258 
	C507.983765,725.967651 507.996735,725.998047 507.982849,725.989136 
	C509.361603,724.905090 510.640778,723.630310 512.763306,723.181152 
	C513.014099,722.963928 513.010803,723.013794 512.986023,723.010620 
	C513.213928,722.795044 513.453491,722.568726 513.843628,722.143066 
	C514.007324,721.957703 514.006592,722.007812 513.982300,722.001587 
	C514.427429,721.576965 515.057190,721.531250 515.811035,721.071045 
	C516.827271,719.557678 517.737122,718.383362 519.676514,718.032532 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M468.820099,722.703247 
	C468.135223,723.306885 467.585846,723.644653 466.789764,724.006104 
	C466.243744,724.165527 465.944489,724.301208 465.246979,724.146484 
	C465.958923,722.888306 467.069122,721.920532 468.487091,720.867432 
	C468.794861,720.782104 469.247101,720.852600 469.278259,721.079346 
	C469.191467,721.683105 469.073547,722.060181 468.820099,722.703247 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M512.644653,722.936279 
	C511.557800,723.954468 510.101501,724.945007 508.307098,725.957947 
	C508.352386,723.481628 510.428619,723.356201 512.644653,722.936279 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M461.175476,725.455688 
	C461.574921,724.078979 462.487518,724.010254 463.787048,724.047729 
	C464.405457,724.482544 464.494965,724.942261 464.197205,725.713989 
	C463.964447,725.993042 464.003784,726.004761 464.000488,725.984497 
	C463.774353,726.216919 463.498413,726.379517 462.924927,726.462097 
	C462.680511,726.472107 462.192291,726.414368 461.963196,726.321411 
	C461.734070,726.228394 461.350983,725.911377 461.175476,725.455688 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M461.986023,726.978882 
	C461.627197,726.997375 461.278137,727.030701 460.674622,727.146240 
	C459.323456,726.539734 458.669006,725.840698 460.685242,725.043518 
	C461.140808,725.147461 461.281616,725.294922 461.643616,725.653687 
	C461.864838,725.864868 461.931396,725.931274 461.964539,725.964600 
	C462.166962,726.163940 462.336273,726.329834 462.240509,726.732727 
	C461.975464,726.969727 461.995819,726.993774 461.986023,726.978882 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M522.316040,716.948608 
	C522.070374,716.078552 522.354248,715.318787 523.681580,715.046631 
	C523.920471,715.896790 523.661316,716.668579 522.316040,716.948608 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M490.337158,720.975037 
	C489.979675,719.881897 490.452820,719.122009 492.100708,719.015747 
	C491.877045,719.642334 491.265564,720.263672 490.337158,720.975037 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M464.295715,725.943481 
	C463.946960,725.566223 463.929474,725.139404 464.024567,724.386719 
	C464.137146,724.060913 464.499756,723.981689 464.674255,723.918884 
	C465.131195,723.882263 465.413666,723.908508 466.119568,723.982178 
	C465.904327,724.651123 465.265625,725.272522 464.295715,725.943481 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M487.277405,724.046387 
	C487.184296,723.463562 487.341827,722.881226 487.782837,722.154663 
	C488.179688,722.291382 488.323181,722.565125 488.393311,722.856567 
	C488.426575,722.994629 488.319641,723.166321 488.151855,723.664062 
	C487.861023,724.019165 487.694519,724.033020 487.277405,724.046387 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M495.294037,716.259216 
	C495.163879,715.814514 495.304047,715.111084 495.749847,714.203064 
	C496.444824,714.801453 496.078766,715.419189 495.294037,716.259216 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M470.364624,720.027588 
	C470.219513,719.308960 470.731873,718.714294 471.361572,719.213379 
	C471.881866,719.625732 471.263031,719.959351 470.364624,720.027588 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M515.713013,720.902527 
	C515.549500,721.232910 515.078857,721.611816 514.283142,721.993042 
	C514.440674,721.647217 514.923340,721.299133 515.713013,720.902527 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M488.319458,722.218018 
	C488.484344,721.695312 488.955566,721.326660 489.744141,720.992859 
	C489.582916,721.475830 489.104370,721.923889 488.319458,722.218018 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M522.013611,717.809875 
	C521.565308,718.071045 521.121765,718.067200 520.347046,718.031921 
	C520.473145,717.670471 520.930298,717.340515 521.685974,716.997437 
	C521.984436,716.984253 521.999451,716.999451 522.007080,717.007080 
	C522.015869,717.191345 522.017090,717.368103 522.013611,717.809875 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M473.387268,717.546265 
	C473.319458,717.455688 473.573151,717.417236 473.573151,717.417236 
	C473.573151,717.417236 473.455048,717.636841 473.387268,717.546265 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M496.315247,714.137268 
	C496.027618,713.880859 496.025116,713.699829 495.999146,713.248169 
	C495.975739,712.977539 496.409271,712.853027 496.869812,713.094727 
	C497.087006,713.628479 496.843658,713.920532 496.315247,714.137268 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M524.003662,715.004883 
	C524.091431,714.971680 524.175415,714.933655 524.124817,714.944092 
	C523.990234,714.992554 524.000000,715.000000 524.003662,715.004883 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M475.506226,715.550171 
	C475.478699,715.563293 475.533722,715.537048 475.506226,715.550171 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M513.745605,722.036072 
	C513.822449,722.243042 513.637634,722.528320 513.207031,722.910583 
	C513.135498,722.709839 513.309692,722.412170 513.745605,722.036072 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M470.201477,720.200806 
	C470.162781,720.597351 469.955994,720.836426 469.503479,721.168457 
	C469.309387,721.306030 469.052246,721.046326 468.923553,720.914185 
	C468.950043,720.497986 469.161957,720.265564 469.640533,719.974365 
	C469.850464,719.863831 470.084991,720.087952 470.201477,720.200806 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M500.166809,710.935669 
	C500.125244,710.968018 500.208344,710.903259 500.166809,710.935669 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M499.999512,710.988159 
	C499.879852,711.000305 499.771576,711.029541 499.852722,711.045776 
	C500.042145,711.032837 500.010925,711.005249 499.999512,710.988159 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M496.977478,712.970215 
	C497.099365,712.645081 497.338470,712.442444 497.577545,712.239746 
	C497.631836,712.508545 497.686127,712.777283 497.535400,713.191284 
	C497.330383,713.336426 497.094696,713.092712 496.977478,712.970215 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M207.044724,656.622314 
	C205.735779,656.194214 206.008301,654.893433 206.003052,653.311035 
	C206.021515,652.937134 206.513596,652.977783 206.745209,653.063843 
	C207.007629,654.178162 207.038452,655.206360 207.044724,656.622314 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M206.065582,652.684265 
	C205.325912,652.642151 204.976349,652.144531 205.710724,651.214172 
	C205.981827,651.506042 206.027237,651.933655 206.065582,652.684265 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M609.259888,355.923767 
	C608.893860,355.368103 608.779785,354.883423 608.485413,354.222839 
	C608.252869,353.331696 608.200684,352.616425 608.149658,351.542358 
	C611.001038,348.684845 614.404358,349.442169 617.600525,349.838409 
	C621.376587,350.306488 625.135132,350.641205 627.996887,350.570068 
	C622.216125,349.421967 615.289673,350.273468 608.333008,348.214600 
	C607.947144,345.643555 607.890015,343.946136 611.465210,344.357269 
	C617.867371,345.093506 624.359802,345.032257 630.811523,345.362457 
	C631.706055,345.408234 632.744080,346.289337 633.007690,344.610992 
	C633.237000,343.151093 632.676147,342.610260 631.153870,342.440125 
	C624.889771,341.740082 618.626282,341.977234 612.355164,342.152069 
	C611.243469,342.183105 609.644348,343.870453 609.075134,341.670532 
	C608.475708,339.354004 610.639709,338.758118 612.091919,338.520630 
	C617.860413,337.577240 623.680420,338.250397 629.482727,338.381134 
	C630.562317,338.405457 631.726685,339.305176 634.025269,336.733673 
	C627.229309,337.596588 621.903442,335.413513 616.226257,336.364777 
	C614.427673,336.666168 612.617249,336.930634 610.801575,337.089294 
	C606.990295,337.422394 608.603210,335.508575 609.820007,333.589691 
	C611.777832,330.808624 614.270569,330.664520 616.738953,331.290955 
	C620.413574,332.223541 624.212524,332.252869 626.953369,332.998199 
	C622.119385,332.640015 616.533203,330.381500 610.295837,331.274170 
	C607.008179,327.333954 607.381104,326.662994 613.629028,325.100098 
	C619.064270,323.580292 623.776428,325.900757 628.147888,326.298615 
	C624.208801,325.309174 619.635132,324.773529 614.958130,323.412567 
	C614.104004,323.147827 613.382935,322.957184 612.841675,323.188110 
	C607.808411,325.335541 608.282654,322.483398 609.555176,318.958649 
	C616.238831,316.377991 622.197571,318.907257 628.955078,320.092194 
	C623.913635,318.629669 619.487549,317.717102 614.561157,317.759583 
	C613.480225,317.960846 612.744446,317.965179 611.633179,317.862610 
	C611.031616,317.688995 610.803955,317.577850 610.286926,317.220398 
	C608.182556,316.762756 608.051819,315.464722 608.219727,314.080475 
	C608.421265,312.419159 609.886780,312.639374 610.894409,312.670654 
	C614.500122,312.782593 618.100159,313.078552 622.143311,313.302429 
	C625.823669,313.506744 629.307251,312.605804 631.995239,315.493073 
	C631.964966,314.405975 631.757019,313.436951 632.149902,312.114929 
	C632.424255,311.539551 632.571960,311.323883 633.048584,310.879761 
	C633.922302,310.495605 634.457947,310.526093 635.284607,311.033661 
	C636.750244,313.476135 636.411865,315.814423 636.463501,318.526184 
	C636.558289,323.446777 636.225830,327.954468 636.981506,332.836884 
	C637.141296,333.516235 637.193420,333.790131 637.288330,334.478424 
	C637.465271,336.533386 637.414856,338.177612 637.416687,340.223694 
	C637.399109,341.158386 637.393738,341.689972 637.391968,342.613770 
	C637.438965,344.293365 637.368469,345.580444 637.380981,347.246338 
	C637.373657,348.123810 637.367737,348.622620 637.359375,349.489197 
	C637.352173,351.065765 637.284546,352.272980 637.255127,353.841675 
	C637.206604,354.681122 637.133789,355.155121 636.921326,355.966034 
	C636.693604,356.514130 636.574707,356.720673 636.183228,357.156250 
	C635.455078,357.538086 634.994141,357.566223 634.255005,357.223877 
	C629.765625,353.653290 624.936951,355.447296 619.906494,355.267456 
	C617.672607,355.773682 615.803528,355.380219 613.568115,355.424255 
	C612.679382,355.432556 612.184998,355.491241 611.317505,355.573425 
	C610.777283,355.591675 610.610291,355.586487 610.226685,355.707520 
	C609.844116,355.887360 609.678040,355.941071 609.259888,355.923767 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M610.254639,262.070038 
	C609.995850,255.749008 609.995850,255.749008 619.563416,254.983398 
	C626.204834,253.855545 631.225830,256.878601 636.121399,259.928009 
	C641.726990,263.419708 647.101501,267.286438 653.630249,269.752075 
	C655.531982,266.932434 654.553650,263.832825 654.267883,260.838287 
	C654.038269,258.432098 653.174866,256.087555 653.280396,253.265274 
	C655.519775,250.608734 656.540527,252.752197 657.421509,254.131699 
	C658.880493,256.416565 659.487671,259.050598 659.378601,261.765259 
	C659.244934,265.091217 660.596008,267.491699 663.708679,269.430542 
	C665.006592,276.388550 664.147461,283.028656 664.441650,290.094208 
	C664.444641,291.459961 664.613831,292.368011 664.473816,293.735046 
	C664.277771,298.409821 664.791809,302.653442 663.846313,307.260681 
	C661.851929,309.747711 659.572754,309.429352 656.891663,308.736450 
	C655.570190,307.869720 655.568176,306.779419 655.256836,305.432465 
	C654.923767,303.939880 654.749207,302.784271 654.487610,301.292328 
	C654.437012,300.248352 654.589722,299.575195 654.871155,298.579681 
	C655.904968,296.136108 655.485291,293.809357 656.069214,291.297241 
	C655.984863,290.315033 655.824829,289.662354 655.330811,288.885254 
	C654.655701,288.402557 654.426270,287.985168 654.319702,287.137268 
	C654.369690,286.281830 654.505127,285.795380 654.544495,285.301361 
	C655.215881,276.895172 655.198059,276.929871 647.424377,273.561768 
	C643.772156,271.979370 640.097961,270.436523 637.892456,269.325928 
	C640.833923,270.670990 644.894714,273.160370 649.310974,274.961365 
	C651.059692,275.674500 653.710754,276.525391 652.691589,278.896698 
	C651.851685,280.851074 649.491882,279.777771 647.774536,279.150360 
	C646.995972,278.865906 646.239929,278.510529 645.040039,278.378693 
	C640.390320,276.948395 636.189636,275.367157 632.227600,272.448669 
	C625.587463,269.573547 618.982727,268.836456 612.154846,269.850800 
	C611.165283,269.997803 609.657532,270.763153 609.304260,269.076752 
	C608.946594,267.369598 610.329468,266.733826 611.719177,266.544464 
	C613.856018,266.253265 616.017517,266.145386 618.166992,265.943634 
	C619.378418,265.829956 621.290039,266.755402 621.487061,264.884430 
	C621.687073,262.986053 620.056335,262.006561 618.203247,261.975952 
	C615.709900,261.934723 613.213806,262.060730 610.254639,262.070038 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M635.389648,310.694458 
	C634.668335,311.007568 634.219055,311.018951 633.082275,310.889038 
	C627.679932,306.505341 621.631958,306.360413 615.859009,305.427979 
	C613.773987,305.091187 611.565979,305.704163 609.212402,304.484863 
	C608.358337,300.963806 609.100525,298.665222 613.551453,298.996307 
	C617.800171,296.650238 621.228455,299.243256 624.822449,299.858521 
	C626.552002,300.154572 627.979065,301.311188 629.492859,301.687347 
	C624.667419,298.969452 619.087952,298.374939 613.292053,297.270386 
	C611.680847,296.313446 608.981262,298.456146 608.866028,295.221252 
	C608.764160,292.361481 611.057373,292.213654 612.962646,292.126587 
	C618.880493,291.856171 624.714355,292.358002 630.596680,294.858063 
	C633.620789,294.630676 636.085266,294.758636 637.196533,298.222168 
	C637.408447,300.451630 637.389160,302.295349 637.103394,304.532288 
	C636.571106,306.747528 636.524597,308.673370 635.389648,310.694458 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M655.278198,286.377258 
	C655.075256,287.181000 655.036499,287.631592 654.997314,288.421509 
	C645.317810,284.382385 635.659851,280.051910 625.176270,277.720734 
	C619.986267,276.566681 615.120239,276.315735 610.208435,278.486542 
	C608.830383,274.000092 610.439209,272.161652 614.827209,271.937592 
	C619.018677,271.723541 623.003357,272.746765 627.487061,273.407074 
	C628.465088,273.238556 629.006775,273.430969 629.778198,273.780487 
	C630.425720,274.088715 630.844055,274.225891 631.594482,274.332550 
	C634.774353,273.496002 636.997437,275.192261 639.298767,276.295685 
	C641.219543,277.216644 643.103760,278.151947 645.549561,278.754028 
	C648.195740,279.759613 650.353394,280.977936 652.725037,281.611572 
	C655.096985,282.245361 655.806274,283.771790 655.278198,286.377258 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M655.853027,298.667084 
	C655.760681,299.450409 655.511902,299.859589 655.136414,300.473145 
	C654.541199,301.233429 653.889282,301.460144 653.259338,301.215668 
	C646.110291,298.440948 638.605408,296.667236 631.294922,293.256165 
	C625.131042,290.761475 619.267639,288.580078 612.775757,289.615356 
	C611.384094,289.837311 609.348877,291.363525 608.925598,288.433044 
	C608.578125,286.026855 609.938660,285.142487 612.161438,285.169403 
	C612.823914,285.177399 613.487793,285.076752 614.568970,284.977905 
	C616.519653,283.602844 618.338440,283.487183 620.139404,283.995819 
	C630.576233,286.943451 641.520935,288.333466 651.047241,294.097870 
	C652.890930,295.213501 654.916077,296.037689 655.853027,298.667084 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M615.301514,283.433533 
	C614.777039,283.226013 614.577148,283.271118 614.449890,283.194916 
	C612.789856,282.200531 609.680542,285.214111 609.477661,282.582092 
	C609.250122,279.630798 612.832031,280.225525 614.981140,280.013367 
	C622.914429,279.230194 630.364380,281.418091 637.667969,284.113312 
	C643.248413,286.172699 648.726379,288.509796 654.568481,290.889893 
	C656.410156,293.317444 655.424011,294.403992 653.092590,294.754303 
	C652.069031,294.908081 651.057434,294.439667 650.244934,293.964600 
	C641.495239,288.848663 631.579712,287.268341 622.057251,284.480103 
	C619.925720,283.855957 617.724121,284.381195 615.301514,283.433533 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M614.948242,283.660614 
	C626.901245,282.958435 637.677246,287.275452 648.384827,291.849457 
	C650.038574,292.555878 651.626221,293.435486 653.314880,294.037354 
	C655.604919,294.853607 655.276855,293.264496 654.989014,291.477448 
	C655.097107,291.048218 655.307190,291.040039 655.831116,290.999786 
	C657.107788,293.408295 656.369263,295.858612 656.098267,298.673462 
	C644.076294,290.170959 630.114136,287.172241 615.400635,285.040314 
	C614.975830,284.647919 614.964600,284.365936 614.948242,283.660614 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M607.974548,348.257172 
	C615.399841,348.420624 622.781250,348.816437 630.158508,349.280060 
	C631.343933,349.354553 633.234497,348.850372 633.094116,350.923920 
	C632.913025,353.599915 630.891418,352.087189 629.681030,352.029938 
	C622.790833,351.704132 615.905579,351.272858 608.584839,351.030457 
	C608.209656,350.567261 608.268372,349.951050 608.139648,349.182037 
	C607.944519,348.856873 607.936951,348.684448 607.974548,348.257172 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M633.043762,311.046631 
	C633.061401,311.294006 633.023560,311.487366 632.930237,311.970917 
	C631.019531,313.586853 629.118225,313.522186 626.932007,312.098022 
	C621.821472,310.272858 616.798401,310.060608 611.794067,310.116028 
	C608.806885,310.149109 607.971436,309.000671 608.705322,305.799957 
	C617.049377,304.860657 625.084839,305.615662 632.588379,310.572815 
	C632.876770,310.885071 632.988281,310.992584 633.043762,311.046631 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M631.002075,293.314758 
	C639.044739,294.725403 646.858765,297.157104 654.655273,300.695404 
	C656.360779,301.558868 656.074097,303.022278 655.789673,304.768982 
	C650.812988,302.931732 646.279846,300.781952 641.152344,299.208405 
	C640.263123,298.924927 639.688599,298.708588 638.259644,298.328369 
	C636.713684,294.528870 632.843384,297.604340 631.264771,295.068787 
	C630.987976,294.456818 630.998047,294.041534 631.002075,293.314758 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M613.779907,316.936279 
	C619.813293,315.942902 625.334045,317.635803 630.888123,319.187683 
	C632.204590,319.555542 633.222168,320.243683 632.733154,321.545532 
	C632.129456,323.152557 630.702637,322.092621 629.751648,321.813843 
	C623.572754,320.002686 617.317871,318.754303 610.391052,318.759766 
	C609.972595,318.319458 610.010864,317.935333 610.023376,317.262634 
	C609.997559,316.974060 610.436218,316.753906 610.677490,316.799011 
	C611.718079,317.770264 612.655823,317.642151 613.779907,316.936279 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M632.836304,310.524384 
	C625.586243,307.220032 617.398438,307.182983 609.233032,305.225037 
	C608.678833,305.070435 608.670166,304.841888 608.804688,304.450562 
	C616.284668,302.600494 623.098206,305.570679 630.097656,307.048950 
	C631.684448,307.384033 632.672852,308.452759 632.836304,310.524384 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M613.107727,297.333435 
	C623.199829,296.322174 633.141602,300.176605 632.772949,305.505920 
	C627.264282,301.457794 621.283447,299.453430 614.372070,298.999176 
	C613.714966,298.469208 613.472534,298.015503 613.107727,297.333435 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M610.000244,331.497803 
	C617.970032,328.606384 625.190979,332.020966 632.634399,333.922302 
	C625.293945,335.218689 618.248352,330.683167 610.504822,333.214844 
	C610.085266,332.801147 610.057617,332.326965 610.000244,331.497803 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M614.531921,323.597351 
	C620.527466,322.538086 625.812073,324.929535 631.335571,325.895905 
	C632.523193,326.103668 633.157288,326.605530 633.021240,327.833984 
	C632.880737,329.102448 632.157532,328.861359 631.295227,328.518890 
	C625.987183,326.410736 620.247437,326.456116 614.372620,325.119995 
	C614.098938,324.680725 614.210571,324.366241 614.531921,323.597351 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M645.244690,279.573730 
	C640.571167,278.775879 637.032898,275.513519 632.208252,274.503296 
	C631.946289,273.824982 631.966003,273.347961 631.986816,272.512787 
	C636.432129,272.985016 640.139160,275.685425 644.715515,277.220886 
	C645.614746,277.947540 645.687317,278.599548 645.244690,279.573730 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M626.268616,311.899780 
	C628.492798,311.837891 630.305054,311.929810 632.496033,312.141449 
	C632.874695,313.875732 632.874695,315.490326 632.874695,317.598999 
	C630.087585,314.312134 626.398621,314.734375 622.882996,313.550781 
	C623.675171,312.884491 624.765930,312.469055 626.268616,311.899780 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M629.873291,273.706848 
	C629.448608,273.932343 628.889771,273.913147 628.115967,273.713684 
	C628.455444,272.006500 629.098206,272.756592 629.873291,273.706848 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M417.956543,954.946411 
	C418.071869,954.850464 418.235260,953.972717 418.230469,954.988403 
	C418.081390,955.068298 417.995911,954.989319 417.956543,954.946411 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M617.226013,774.795898 
	C615.201965,775.488892 614.841064,777.375793 613.264282,778.543274 
	C611.907349,777.973999 611.981506,776.799683 612.027161,775.674988 
	C610.178101,778.814453 606.807800,780.042786 603.654541,782.094727 
	C603.155273,782.360107 602.952637,782.460571 602.434570,782.686646 
	C601.643677,782.926025 601.163330,783.024841 600.681396,783.097839 
	C600.179626,783.173828 600.048157,783.251892 600.301697,783.428284 
	C600.311890,783.372498 600.472229,783.362671 601.055481,783.496826 
	C601.464172,783.743591 601.600159,783.892395 601.569885,784.293762 
	C594.713806,786.443115 587.982422,788.219971 581.364014,791.515381 
	C578.110657,790.591675 574.754822,792.925293 571.832947,790.169006 
	C571.113770,788.028076 572.317627,787.185425 574.013000,786.296448 
	C575.683289,785.490173 578.070435,786.959106 578.256531,783.877258 
	C578.390076,781.663513 577.668945,780.791321 575.246643,780.707764 
	C573.686218,780.377258 572.809204,779.549255 571.597412,778.589233 
	C569.560425,776.232788 567.466125,776.632141 565.142334,777.297546 
	C563.138550,777.871216 560.644165,779.260132 559.799927,775.509766 
	C572.803101,768.798340 587.375183,772.705322 600.614075,768.204529 
	C606.640564,766.155701 612.572388,764.726868 617.072449,759.743774 
	C619.487366,757.069763 622.492432,754.815796 626.648071,754.077881 
	C627.155518,753.846130 627.311035,753.705505 627.630188,753.833496 
	C627.928406,754.525269 628.063049,754.948425 628.255249,755.701294 
	C628.445557,756.512207 628.452271,756.996765 628.036377,757.676025 
	C627.116882,759.236267 626.512939,760.604675 625.848877,762.299805 
	C624.896118,767.903198 621.789368,771.665588 617.226013,774.795898 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M524.288696,734.141113 
	C525.043884,731.842224 526.724670,730.882996 529.145264,730.993530 
	C532.310303,731.138000 535.232727,729.920715 538.617065,729.095215 
	C539.466370,729.544312 539.994019,729.666260 540.777588,729.124756 
	C541.649292,727.544189 542.797852,726.978027 544.598633,726.937134 
	C545.904175,729.495972 547.457825,730.764282 550.447266,730.098999 
	C552.592896,729.621460 554.999084,729.232422 556.600098,732.033386 
	C556.632996,733.236206 556.295166,733.893066 555.159668,734.254089 
	C549.827148,735.218567 545.623901,737.767395 540.838623,740.656616 
	C560.229126,745.127686 579.017517,745.468750 597.819946,741.530396 
	C607.188049,739.568176 616.479309,737.212036 625.744568,734.800659 
	C628.951416,733.966003 631.487061,734.420471 634.053162,736.474731 
	C638.783020,740.261292 638.662537,742.745056 633.034546,746.393921 
	C632.739624,747.053772 632.553528,747.418762 631.859619,747.693542 
	C629.875061,748.442505 628.217285,749.189453 626.239502,750.074341 
	C624.622253,749.093140 624.879089,747.577271 624.856445,746.127563 
	C624.856323,746.117920 624.556824,746.113037 624.397156,746.105896 
	C624.792725,746.642517 623.427246,746.158508 623.738403,746.606201 
	C622.223145,747.217163 621.018738,747.207642 619.539429,746.401978 
	C617.258545,742.750549 613.988647,741.769226 610.453247,742.158386 
	C604.290527,742.836792 598.198547,744.231995 592.028381,744.753418 
	C578.414978,745.903687 564.793579,747.528809 551.110779,745.138367 
	C548.515015,744.684875 545.366150,744.037109 543.668579,747.484375 
	C542.918823,749.007019 541.725159,748.902832 540.363220,747.925110 
	C537.666809,745.989258 534.760376,744.345581 533.763916,740.793823 
	C533.363342,739.365845 532.661438,737.830750 530.692139,738.162659 
	C528.511475,738.530273 529.164612,740.368225 529.003784,741.757202 
	C528.965698,742.086609 528.990234,742.422852 528.977234,742.755676 
	C528.921265,744.189148 528.502808,745.394653 526.929749,745.788635 
	C526.032959,746.013245 525.260010,745.670227 524.715393,744.987183 
	C523.778931,743.812622 524.565796,742.711792 525.140991,741.772888 
	C526.774536,739.106567 527.466248,736.597046 524.288696,734.141113 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M556.376282,732.372681 
	C553.877625,730.044006 551.558350,731.319824 549.171570,731.734619 
	C546.157959,732.258301 543.126465,732.319946 544.817322,727.279236 
	C544.938416,726.929016 544.961914,726.953979 544.964478,726.947266 
	C545.444458,726.576111 546.050354,726.531555 546.752075,726.059326 
	C547.301025,723.885071 550.871643,724.530334 550.106323,721.503845 
	C559.178589,722.464539 568.403381,722.527405 577.621216,721.957520 
	C581.514893,721.716797 583.680725,723.999695 585.830322,726.542175 
	C587.078003,728.017944 587.702393,730.068298 589.908569,731.089539 
	C590.099915,731.599182 590.173279,731.771179 590.179199,732.215515 
	C590.030640,732.654968 589.949646,732.822021 590.155396,732.953003 
	C590.628479,732.992065 590.814880,733.067139 591.256042,733.319885 
	C592.500244,734.388184 593.345520,735.379883 593.792114,737.023560 
	C593.820190,737.825745 593.698853,738.261475 593.319092,738.975586 
	C589.747009,740.575134 586.095642,739.919800 582.606384,740.570557 
	C580.448792,740.972961 580.901733,739.189392 580.308716,737.792358 
	C578.015259,737.463501 575.917053,737.483582 573.863892,736.648132 
	C568.354919,734.406677 562.499268,733.566833 556.376282,732.372681 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M649.169312,780.651123 
	C639.627686,780.740417 630.509155,778.685181 621.135620,776.232239 
	C621.033813,770.984802 624.698547,768.022034 627.639404,764.243652 
	C629.306763,761.810059 630.521851,759.454956 632.213684,757.515869 
	C635.242004,754.045044 636.483582,754.390686 638.218750,758.772339 
	C638.696716,759.979309 639.179932,761.184326 639.860291,762.693359 
	C640.314941,763.275757 640.543823,763.574890 640.763428,764.179199 
	C641.107605,765.454407 641.431030,766.447083 641.907104,767.718506 
	C642.210999,768.174744 642.362366,768.352356 642.656616,768.849609 
	C642.799438,769.169189 642.748230,769.212585 642.750610,769.246094 
	C645.562012,772.584839 648.155457,776.018005 649.169312,780.651123 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M645.343018,767.909790 
	C645.266541,766.884094 645.207703,766.212280 645.257812,765.221191 
	C648.310120,763.022339 651.454895,762.584595 655.213806,763.761841 
	C662.441345,770.079773 668.576904,776.868530 674.355286,783.965515 
	C675.026855,784.790283 676.531006,786.283813 674.793091,787.961792 
	C673.808777,788.365112 673.111450,788.387939 672.101440,787.893860 
	C671.429199,787.393433 671.148132,786.995056 670.802368,786.671082 
	C669.863953,785.792053 670.137634,783.472595 667.999939,784.057312 
	C665.546082,784.728455 667.537720,786.833435 666.581848,788.353394 
	C664.158508,789.425415 662.339355,788.444885 660.186646,787.339294 
	C659.869873,787.121216 659.951599,787.087280 659.949341,787.131470 
	C659.732300,786.742432 659.420227,786.627808 658.810669,787.142090 
	C657.444336,786.852173 656.262024,786.304810 654.958679,785.458130 
	C654.479248,784.558838 653.947937,784.128723 653.173706,783.448975 
	C649.488098,778.685059 646.143188,774.124634 645.343018,767.909790 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M537.256714,784.225708 
	C536.484009,783.055664 535.599609,783.037720 534.361694,783.068726 
	C533.506226,782.101379 532.586914,782.049622 531.304321,782.032043 
	C530.804932,782.144775 530.652100,782.261719 530.270142,782.203125 
	C525.490723,780.983337 521.118469,778.615845 516.195312,780.333374 
	C515.512573,780.571594 514.574280,780.173645 513.778259,779.974365 
	C509.903503,779.004517 509.394684,776.963074 511.955566,772.417114 
	C513.397827,771.192566 514.994995,770.784546 516.636108,771.045715 
	C521.351746,771.796082 525.788025,769.828674 530.736450,769.891479 
	C536.684875,771.270813 542.491699,771.812256 548.134033,774.478333 
	C548.886475,774.549988 549.242126,774.608948 549.819214,774.824707 
	C551.670776,777.560974 549.875488,778.540771 547.948364,779.453003 
	C545.972473,780.388245 543.673706,780.129150 541.512817,781.370483 
	C541.140564,784.020264 540.404480,785.675903 537.256714,784.225708 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M690.257935,741.015259 
	C693.278564,743.457703 696.037781,745.702698 698.979736,748.202026 
	C695.868591,750.082031 694.259766,752.542969 695.017029,756.348389 
	C695.329651,757.919250 694.263916,759.101074 693.183472,760.594482 
	C688.989380,759.578796 686.198181,756.363098 683.387024,753.604980 
	C680.489502,750.762268 685.916382,751.806580 686.140320,749.559448 
	C686.091919,748.145935 686.648682,747.287354 687.096313,746.110352 
	C687.361755,745.322388 687.539734,744.802002 687.459290,743.974854 
	C687.365173,743.532410 687.323547,743.356079 687.213135,742.916748 
	C687.050598,742.303955 686.950500,741.956116 686.734985,741.358765 
	C686.543274,740.942993 686.459351,740.778931 686.234131,740.373657 
	C685.894958,739.807922 685.716370,739.473083 685.472656,738.848999 
	C685.355652,738.174561 685.419861,737.796326 685.791260,737.230225 
	C689.061035,736.468628 688.339966,739.895935 690.257935,741.015259 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M540.236938,781.413086 
	C541.003479,778.658386 543.344604,779.481812 545.112671,778.906860 
	C546.995117,778.294617 549.646851,778.769470 550.017212,775.366333 
	C553.062622,774.988647 556.084473,774.995789 559.549561,775.104492 
	C561.267883,778.514709 563.381958,776.673218 565.106567,775.894104 
	C567.769775,774.690857 570.044739,774.592529 571.941162,777.579712 
	C568.307861,780.206238 564.484314,782.264160 560.302612,784.458374 
	C559.723755,784.712524 559.480103,784.789490 558.854248,784.920776 
	C553.858948,784.479248 549.214478,784.266663 544.249023,783.415527 
	C543.604004,783.344177 543.346802,783.305786 542.712769,783.166016 
	C541.606262,782.764526 540.966492,782.335938 540.236938,781.413086 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M688.241211,745.551392 
	C688.036316,747.086975 687.559082,748.046326 686.436768,748.977051 
	C680.519592,750.684021 676.970337,748.550110 673.225952,741.231201 
	C673.267334,739.251221 672.028870,737.155518 674.618652,735.781982 
	C678.616821,733.701416 681.583923,735.084045 684.672974,737.689392 
	C685.417175,738.496277 685.654175,739.247681 686.673706,739.824585 
	C686.970886,740.042786 687.004456,740.007019 686.980164,740.009766 
	C687.709412,740.701172 687.380493,741.662781 687.772034,742.759521 
	C687.963379,743.028076 688.000000,743.000000 687.978516,743.007751 
	C688.590942,743.644043 688.476929,744.435303 688.241211,745.551392 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M664.949219,745.476501 
	C666.901001,747.273438 668.531189,749.023621 670.396240,750.995972 
	C672.448059,752.733704 673.081238,754.461792 671.273254,756.799683 
	C670.954468,757.028564 670.989136,756.992615 671.004517,756.972900 
	C670.577515,757.400024 670.496155,758.000183 670.157104,758.805176 
	C669.979858,759.044189 670.010071,759.009705 670.028015,758.995422 
	C666.811584,759.574463 663.562927,761.298218 660.073853,758.595947 
	C658.739746,756.247070 657.391724,754.251770 657.989624,751.371216 
	C657.558289,745.962402 661.572388,746.252502 664.949219,745.476501 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M597.349731,722.146423 
	C604.291321,717.497131 612.791626,715.653870 620.516357,711.959778 
	C626.834045,708.938599 627.048340,709.152222 629.572083,715.722595 
	C630.274780,717.552124 633.125122,719.621643 629.362854,721.733887 
	C628.310486,721.671936 627.918701,721.232117 627.898804,720.307861 
	C627.494080,715.940613 625.493408,717.641907 623.870483,719.141052 
	C622.977417,719.966003 622.382507,720.363403 621.460510,719.439941 
	C621.119080,719.097961 620.561401,718.623718 620.616089,718.295410 
	C620.838196,716.963379 622.066711,717.220520 622.983643,717.075378 
	C623.796448,716.946655 624.669739,717.084473 625.445251,716.859497 
	C627.164062,716.360901 627.116943,714.901123 626.737732,713.616577 
	C626.232849,711.906616 625.077209,711.786987 623.685974,712.795471 
	C615.941345,718.408813 606.677856,719.866577 597.349731,722.146423 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M655.564819,763.550903 
	C652.430542,763.800720 649.454407,765.686707 645.780640,764.934204 
	C645.114197,764.692749 644.890686,764.456116 644.497559,764.049500 
	C644.153870,763.823914 644.008850,763.740784 643.765686,763.428467 
	C643.667542,763.199280 643.901001,762.767273 644.093994,762.623901 
	C644.286987,762.480530 644.655396,762.782898 644.506348,762.597290 
	C644.357239,762.411743 643.879456,762.478271 643.644409,762.415833 
	C643.409424,762.353394 643.297119,761.879028 643.282104,761.635742 
	C642.921997,759.817810 642.576904,758.243042 642.096313,756.345154 
	C641.033508,754.683472 641.615051,753.849121 642.974731,753.585510 
	C644.920532,753.208191 646.440430,751.878296 648.675415,751.412537 
	C652.901855,754.392334 653.479492,759.175842 655.564819,763.550903 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M598.675598,726.489746 
	C599.465210,724.607300 600.710022,723.998718 602.735229,724.028198 
	C608.831238,726.954956 609.497314,726.808899 614.894653,721.488037 
	C616.698303,721.597595 617.281311,722.824402 618.293579,724.089172 
	C619.035828,727.036987 619.734924,729.620728 619.129761,732.670288 
	C617.288696,732.737732 616.627136,735.837219 614.328125,734.137695 
	C611.066956,732.310242 614.721375,730.946777 614.544678,729.284973 
	C611.368835,729.869934 611.700500,732.778687 610.233521,734.776245 
	C610.007324,735.031494 609.995667,734.998718 610.012451,735.002808 
	C609.640259,735.318054 609.199829,735.470581 608.404297,735.227661 
	C605.676392,731.694580 601.855469,731.129578 597.918945,729.883179 
	C597.411316,728.570374 597.793274,727.603271 598.675598,726.489746 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M548.405579,774.148804 
	C542.433777,775.020630 537.023193,772.523560 531.270142,770.328247 
	C535.020630,769.019409 539.073669,769.199097 543.553406,769.030762 
	C546.180542,768.827271 548.316956,769.262024 550.726013,769.160034 
	C554.739136,768.293457 558.443359,768.983398 562.874146,769.144470 
	C559.799316,772.168701 556.463013,770.373291 553.684998,771.182373 
	C551.743652,771.747681 548.862854,770.432495 548.405579,774.148804 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M556.009888,732.456787 
	C562.438232,730.826721 568.107544,733.636475 573.986938,735.186157 
	C575.986816,735.713257 577.964600,736.323914 580.047852,737.174805 
	C578.533142,738.934448 576.638062,738.954102 574.637146,738.575256 
	C568.119507,737.341248 561.597534,736.130554 554.921387,734.552979 
	C555.159851,733.718689 555.554138,733.242249 556.009888,732.456787 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M590.074341,722.982483 
	C590.094238,723.222351 590.063782,723.642944 590.032043,723.851807 
	C586.987427,724.300720 585.528259,722.207336 584.018372,719.789429 
	C583.207520,718.490479 583.575684,717.539673 584.249390,716.274231 
	C584.657227,715.787354 584.846802,715.617126 585.363647,715.255432 
	C589.078491,714.124634 589.803345,711.118164 590.999084,708.403015 
	C591.593262,707.053833 591.788513,704.526428 593.935791,705.303345 
	C595.626587,705.915039 595.329102,708.185669 594.825928,709.749756 
	C593.793884,712.958008 593.361938,716.160950 594.075500,719.849426 
	C593.259094,721.079285 592.423096,721.940308 591.306763,722.911377 
	C590.660828,723.073792 590.677368,721.793396 590.074341,722.982483 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M646.593262,717.230042 
	C647.078003,717.042053 647.268982,717.030823 647.744385,716.977783 
	C651.591370,722.894226 647.837891,723.613342 643.118896,724.198547 
	C639.561096,724.639771 637.104675,729.409546 632.325439,727.002930 
	C631.607544,725.832825 632.428650,725.247620 633.329712,724.354980 
	C637.456848,721.182007 641.887695,719.312317 646.593262,717.230042 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M587.207031,704.703125 
	C590.773987,702.065552 590.990967,698.454529 593.218018,695.720581 
	C593.696350,695.475769 593.955383,695.494202 594.384521,695.860596 
	C595.123230,697.476196 594.812744,698.701172 594.238647,700.264893 
	C591.102234,705.498962 589.121887,710.979431 585.230835,715.755981 
	C584.983887,716.016174 585.000488,715.999512 585.008789,715.990967 
	C584.120667,716.717102 583.666016,717.917053 582.197266,718.193970 
	C580.126526,717.446167 578.965149,719.075134 577.397583,719.327820 
	C576.598633,717.939026 577.093018,716.787842 578.028809,715.374207 
	C578.543518,714.488342 579.108276,714.194763 579.979492,713.791870 
	C581.134949,713.352661 581.580505,712.653320 582.082153,711.573853 
	C582.345703,711.090637 582.461853,710.902405 582.784668,710.453796 
	C584.396973,708.773560 585.566895,707.179810 587.207031,704.703125 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M589.863647,731.887573 
	C590.052307,731.506653 590.083313,731.451904 590.054932,731.439575 
	C594.799988,730.699158 598.565857,733.690491 602.800354,734.942444 
	C603.289001,735.086853 604.001648,736.177124 603.888977,736.345154 
	C603.486328,736.945740 602.834106,737.611206 602.166077,737.761169 
	C599.459534,738.368591 596.711914,738.793213 593.570007,739.283569 
	C593.152283,738.644348 593.143921,738.006958 593.197754,736.894531 
	C593.476318,734.378784 591.438416,734.376831 590.247131,733.160156 
	C589.987854,732.945557 589.981018,733.016968 590.016235,733.023926 
	C589.925964,732.776733 589.800476,732.522583 589.863647,731.887573 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M580.738098,714.888428 
	C579.915222,715.020020 579.344421,715.023132 578.492310,715.052979 
	C577.248108,714.910095 576.337952,714.668335 576.018188,713.179932 
	C579.138916,709.349670 582.290161,705.833313 585.526550,702.397217 
	C587.341675,700.470154 587.493408,701.899109 587.683838,703.731750 
	C587.902832,703.986511 587.963318,704.005371 587.967346,703.973999 
	C587.823181,704.108459 587.674927,704.274353 587.297485,704.683044 
	C585.771729,706.732483 584.497498,708.553650 583.198853,710.748779 
	C582.957947,710.982056 582.998535,711.002686 582.988647,710.982300 
	C582.756226,711.268250 582.563049,711.591675 582.247864,712.173950 
	C581.775085,712.618347 581.592834,712.912781 581.528259,713.549072 
	C581.466980,714.199768 581.287415,714.515015 580.738098,714.888428 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M645.099731,767.887756 
	C648.141968,772.462708 649.987488,777.926941 653.944092,782.567932 
	C654.219604,783.087830 654.325867,783.316345 654.246338,783.873230 
	C653.609619,784.467041 653.128479,784.544983 652.324646,784.198608 
	C652.032349,783.962524 651.998169,783.997559 652.016541,783.983215 
	C650.985352,783.305603 649.819397,782.765076 649.195312,781.205566 
	C649.006531,780.956787 648.997986,780.997131 649.018127,780.994263 
	C647.267090,777.150635 643.980530,774.164307 642.790283,769.627319 
	C643.460144,768.926270 644.167175,768.572937 645.099731,767.887756 
z"/>
<path fill="#61617F" opacity="1.000000" stroke="none" 
	d="
M633.775146,724.766846 
	C633.416382,725.489807 632.848877,725.986938 632.119263,726.721558 
	C630.624084,727.563660 629.342529,728.410828 627.944214,728.707336 
	C626.443604,729.025513 624.466064,729.899902 623.389648,728.387512 
	C622.417236,727.021301 623.650513,725.808167 624.792114,724.694824 
	C626.035583,723.482117 623.976013,720.225098 627.747620,720.103882 
	C628.321106,720.468567 628.579895,720.899048 628.919312,721.567322 
	C628.597412,722.456848 627.705933,723.347229 627.885498,723.714966 
	C628.395203,724.759644 629.562378,724.121582 630.823425,724.182129 
	C631.960938,724.410950 632.820129,724.077454 633.775146,724.766846 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M627.545898,763.940308 
	C626.630615,768.340271 623.239380,771.446167 621.037842,775.648438 
	C620.529785,775.991333 620.196960,776.037415 619.622437,776.135376 
	C618.761414,775.862122 618.142090,775.536987 617.207886,775.072021 
	C619.796326,771.063232 623.129333,767.497620 625.525269,762.855225 
	C626.264160,763.052002 626.739563,763.477539 627.545898,763.940308 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M685.359863,739.217407 
	C682.487183,736.343018 679.343689,735.528687 675.412598,735.707153 
	C674.944763,733.874268 675.418152,732.444763 677.768188,731.998413 
	C678.455872,731.636414 678.856567,731.490601 679.595703,731.743286 
	C681.241577,732.313660 682.712708,734.088928 683.950745,731.331482 
	C684.005493,730.995911 684.139465,730.548645 684.324524,730.406372 
	C687.545837,732.127441 683.215393,734.927002 685.677246,736.965149 
	C686.090454,737.495850 686.179993,737.965759 686.424500,738.760071 
	C686.305603,739.192505 686.031799,739.300537 685.359863,739.217407 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M685.389771,718.117310 
	C687.043640,719.362732 688.598694,720.379639 689.266663,722.531006 
	C689.258240,725.531006 694.537109,728.958130 688.011169,730.944092 
	C687.925781,727.405212 687.572693,723.874390 684.841858,720.776978 
	C684.358948,719.623047 684.348206,718.838623 685.389771,718.117310 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M670.660889,718.627930 
	C671.054382,718.721191 671.138977,719.016357 671.365356,719.749878 
	C666.055603,724.422241 660.296692,728.177979 653.864014,731.528442 
	C653.275452,731.676575 652.980225,731.638000 652.717712,731.154114 
	C658.617615,726.749084 664.484802,722.789429 670.660889,718.627930 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M597.748413,761.899048 
	C600.031982,761.457825 602.451843,758.443359 603.613464,760.978333 
	C604.915466,763.819580 601.189941,764.055359 599.333435,765.081970 
	C599.046692,765.240601 598.764038,765.445129 598.453674,765.516479 
	C596.605957,765.941040 593.960266,767.251282 593.299500,764.846008 
	C592.533569,762.058044 595.810303,762.762024 597.748413,761.899048 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M691.054443,709.650146 
	C692.981079,708.527222 695.086365,707.174622 695.831665,710.361755 
	C696.372070,712.672729 695.316162,714.388184 692.666077,714.168701 
	C690.966064,714.027771 689.596741,716.841309 687.679993,714.303101 
	C688.713745,712.632812 689.831543,711.294189 691.054443,709.650146 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M615.212524,721.748474 
	C614.590149,722.737854 614.232971,723.455811 613.809082,724.131897 
	C612.415710,726.354004 609.915588,727.227966 607.832458,728.333435 
	C604.288147,730.214355 605.808533,724.832642 603.248413,724.347595 
	C604.703918,723.133484 606.414368,722.747986 608.625366,722.953857 
	C610.450378,724.001770 611.437317,722.759827 612.788696,722.033569 
	C613.497498,721.246643 613.999878,720.715759 614.776733,720.134766 
	C615.370972,720.488220 615.511963,720.943420 615.212524,721.748474 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M610.357788,735.017639 
	C609.871521,732.551697 609.505127,729.938538 612.213257,728.488281 
	C613.391235,727.857483 614.831360,726.196472 616.059143,727.958008 
	C616.917603,729.189575 616.275818,730.835876 615.016479,731.811890 
	C614.411621,732.280579 613.372437,732.273010 613.970459,733.738403 
	C612.927917,734.348999 611.818115,734.676392 610.357788,735.017639 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M619.143311,746.460266 
	C620.427490,745.990479 621.609741,745.826233 623.131836,745.798584 
	C625.711731,747.334839 625.203125,748.880432 623.307495,750.706055 
	C622.110168,751.203125 621.318420,751.472351 620.212219,751.733337 
	C619.665955,750.062744 617.248718,748.777710 619.143311,746.460266 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M648.931519,751.122742 
	C647.436401,754.008484 644.681152,754.524597 642.024414,755.675537 
	C640.943115,755.802795 639.650879,755.243347 640.645142,754.201416 
	C642.801025,751.942200 645.038330,749.330139 648.931519,751.122742 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M605.080811,756.822632 
	C604.726501,754.232117 601.660400,751.751953 605.031677,749.087280 
	C606.892212,750.879395 607.628723,753.119934 607.857178,756.036133 
	C607.236145,757.289673 606.306091,757.041077 605.080811,756.822632 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M659.778442,787.511597 
	C661.967346,787.438293 664.064819,787.755371 666.817871,787.989624 
	C667.787109,787.766235 668.106262,787.639465 668.676392,787.438354 
	C669.090454,787.302917 669.258057,787.253113 669.682068,787.142578 
	C670.285278,787.015320 670.635376,786.980042 671.516541,786.993347 
	C672.623718,787.358459 673.202576,787.701965 674.141174,788.044922 
	C669.523499,792.096313 664.604736,790.048218 659.778442,787.511597 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M619.186035,733.261292 
	C617.412598,730.530029 618.186523,727.752014 617.905945,724.695374 
	C617.994934,724.069092 618.087830,723.855896 618.512451,723.750977 
	C620.231689,726.580994 621.295166,729.377075 621.028809,732.524719 
	C620.934265,733.641907 620.387878,733.841187 619.186035,733.261292 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M647.247559,747.267212 
	C645.961121,747.878418 644.863708,748.205444 644.365662,747.021851 
	C643.852783,745.803223 644.739197,745.282471 645.885132,745.118469 
	C648.271362,744.777100 650.652161,744.397522 653.417297,743.975281 
	C651.816345,746.382751 649.270020,745.890137 647.247559,747.267212 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M660.278503,757.194641 
	C663.070740,760.417480 666.320679,758.696533 669.658447,758.854553 
	C668.610046,760.720154 666.514709,760.670959 664.168274,760.995667 
	C662.657715,760.784790 661.539185,760.582458 660.212524,760.105042 
	C659.674194,759.457458 659.479980,759.021301 659.455017,758.162537 
	C659.642395,757.572693 659.771851,757.353455 660.278503,757.194641 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M623.232788,750.959473 
	C623.629456,749.586853 624.343445,748.236816 623.635986,746.280029 
	C623.379456,744.376648 623.962646,743.183350 625.545532,742.208984 
	C626.717163,744.632629 625.980774,746.997498 625.915222,749.760925 
	C625.338562,751.092957 624.432312,750.981628 623.232788,750.959473 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M657.834351,751.148621 
	C658.896118,752.899109 659.646118,754.784363 660.525879,756.962402 
	C660.535706,757.405762 660.415710,757.556396 660.090698,757.910522 
	C659.460022,758.395630 658.993835,758.482788 658.217529,758.158020 
	C657.941956,757.911743 657.880920,757.711731 657.932373,757.620728 
	C657.892944,757.115845 657.710449,756.747314 657.199219,756.219177 
	C656.961914,756.014282 657.003906,756.008301 656.986633,756.021362 
	C656.584961,755.571411 656.527283,754.982300 656.155945,754.228027 
	C655.958862,754.017761 656.001587,754.002563 655.982910,754.016174 
	C655.707642,753.708862 655.572021,753.343018 655.684326,752.659912 
	C656.381958,752.019409 656.952271,751.651428 657.834351,751.148621 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M697.862000,728.395996 
	C696.540955,728.608582 695.648438,728.696777 694.418945,728.797852 
	C694.369202,727.440063 694.656555,726.069397 694.964722,724.345398 
	C694.985474,723.992065 694.980652,724.063477 695.015137,724.072998 
	C698.990417,723.265869 698.741699,725.690491 697.862000,728.395996 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M585.330566,767.013428 
	C586.844360,765.102112 588.662231,765.200745 591.896423,765.457886 
	C589.158447,767.435974 587.650024,768.691711 585.330566,767.013428 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M694.151855,738.723877 
	C693.524780,738.659729 693.087891,738.298401 692.401611,737.790283 
	C692.152283,737.643616 691.970642,737.265564 691.804321,737.137817 
	C691.512268,736.849304 691.386536,736.688477 691.072144,736.286377 
	C690.879333,735.868774 690.875183,735.692505 690.945435,735.262573 
	C692.585022,735.500000 694.719971,734.117920 695.738525,736.224609 
	C696.266846,737.317444 695.010620,737.806641 694.151855,738.723877 
z"/>
<path fill="#96A1A9" opacity="1.000000" stroke="none" 
	d="
M598.600403,726.264282 
	C598.581055,727.241577 598.268677,728.225647 597.755249,729.453247 
	C596.861450,729.517029 596.168701,729.337219 595.210815,729.091309 
	C594.169312,727.822327 594.588318,726.956665 596.132874,726.296753 
	C597.134949,726.291870 597.721191,726.281494 598.600403,726.264282 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M684.507935,729.959167 
	C684.509583,730.264160 684.241821,730.619385 684.123657,730.807617 
	C682.511597,729.449280 682.259094,727.642700 682.237244,724.507019 
	C684.346069,726.613831 684.595642,728.065430 684.507935,729.959167 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M649.286499,726.017944 
	C647.813538,727.881104 645.856689,728.503113 643.567566,729.200684 
	C642.987305,729.233032 642.747681,729.206055 642.531067,728.817993 
	C644.001648,726.884766 646.119873,726.554016 648.227966,725.497070 
	C648.796021,725.498352 649.024048,725.577820 649.286499,726.017944 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M656.634766,734.999329 
	C655.842773,736.896301 653.999023,737.751709 651.347534,737.968750 
	C652.224670,736.176086 654.071350,735.345947 656.634766,734.999329 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M647.914307,734.108154 
	C648.924438,732.365723 650.513428,731.590027 652.417603,730.749084 
	C652.892090,730.872131 653.033813,731.035583 653.373169,731.457031 
	C652.075256,732.627502 650.579773,733.539856 648.786621,734.605469 
	C648.329041,734.637207 648.169128,734.515625 647.914307,734.108154 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M618.761719,723.536133 
	C618.675476,723.903687 618.506897,723.948242 618.120117,724.137573 
	C617.117920,723.612000 616.333923,722.941650 615.263855,722.155151 
	C614.960938,721.603027 614.944031,721.166992 614.989136,720.407837 
	C617.648132,719.518372 618.001709,721.553711 618.761719,723.536133 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M550.657593,768.852905 
	C548.979675,770.682495 546.712341,769.868042 544.251465,769.280457 
	C544.004700,768.990906 543.997437,769.002747 543.992859,769.007446 
	C544.680847,768.250671 545.624634,768.620850 546.776245,768.419861 
	C548.178894,768.516968 549.256897,768.659729 550.657593,768.852905 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M685.866089,717.795288 
	C685.486816,718.663696 685.169312,719.230957 684.761414,720.122742 
	C681.665344,718.408813 684.133240,717.193298 685.684082,715.625366 
	C686.785461,716.164429 686.543091,716.835693 685.866089,717.795288 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M670.433533,730.223022 
	C669.126953,729.294495 667.063965,728.555847 668.727173,727.297791 
	C670.251526,726.144836 670.726807,728.260498 671.600281,729.594604 
	C671.499939,730.062439 671.205017,730.213257 670.433533,730.223022 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M596.238037,726.144775 
	C596.006653,726.984863 595.464600,727.667419 594.934082,728.687622 
	C593.906189,728.917542 593.186401,728.442627 592.957275,726.992249 
	C592.868347,725.892700 593.284729,725.464600 594.236450,725.090576 
	C594.540894,724.979858 594.783569,724.973694 594.905151,724.966675 
	C595.326965,725.302185 595.627075,725.644714 596.238037,726.144775 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M612.648254,721.841797 
	C611.988770,723.029602 611.932312,726.234253 609.042297,723.352661 
	C610.106018,722.649719 611.203735,722.277954 612.648254,721.841797 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M690.293335,720.997559 
	C690.136108,719.838623 690.438538,718.926575 691.705017,719.199280 
	C693.172424,719.515259 692.611511,720.492188 692.119019,721.637085 
	C691.507019,721.660278 691.021851,721.397522 690.293335,720.997559 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M637.793640,730.987183 
	C638.788940,729.362488 640.373230,729.040527 642.237244,728.550049 
	C642.666077,728.590454 642.778015,728.723877 643.058472,729.058716 
	C641.831116,729.911743 640.435242,730.563538 638.721436,731.322388 
	C638.226379,731.371460 638.049255,731.313477 637.793640,730.987183 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M573.364136,767.026123 
	C574.063477,765.642883 575.594666,765.207397 577.653625,765.011841 
	C577.129761,766.820129 575.509705,767.101624 573.364136,767.026123 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M641.900513,744.915222 
	C641.919189,746.501709 641.262756,747.994812 639.870422,747.475586 
	C638.569275,746.990295 639.839111,745.982239 640.564880,745.102417 
	C641.071838,744.828491 641.332886,744.729065 641.900513,744.915222 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M582.036865,718.319458 
	C582.719604,717.357483 583.546814,716.696899 584.695557,716.009399 
	C584.731873,716.902710 584.446716,717.822998 584.064026,719.104980 
	C583.371460,719.184753 582.776367,718.902832 582.036865,718.319458 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M685.301392,789.947998 
	C684.949158,789.268982 684.937012,788.537476 684.872192,787.440063 
	C687.141479,787.418030 687.609619,788.301880 685.301392,789.947998 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M684.847961,795.018799 
	C684.511841,794.473999 684.479126,793.917053 684.647949,793.161011 
	C685.585266,793.095642 686.567139,793.046814 686.511414,794.086609 
	C686.493713,794.416626 685.628662,794.701172 684.847961,795.018799 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M670.084106,730.367798 
	C670.263733,730.058655 670.570496,730.035339 671.336060,729.961792 
	C672.523254,730.333679 673.402100,731.122742 672.654297,731.714722 
	C671.741943,732.437073 670.971313,731.200623 670.084106,730.367798 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M634.860107,731.962708 
	C636.523926,733.178467 635.021851,733.437317 634.468689,733.761414 
	C633.960388,734.059265 633.235413,733.818787 633.212769,732.983276 
	C633.189636,732.129578 633.944153,732.147156 634.860107,731.962708 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M648.747131,725.665894 
	C649.594666,724.923279 650.600708,723.196899 651.698364,724.555237 
	C652.319153,725.323364 650.854980,725.915649 649.648987,726.298462 
	C649.189453,726.223267 649.057861,726.068054 648.747131,725.665894 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M659.608765,741.488525 
	C660.397095,741.116943 661.070923,740.925720 661.249329,741.718811 
	C661.302979,741.957092 660.751343,742.517090 660.387207,742.623901 
	C659.708679,742.822998 659.197632,742.560120 659.608765,741.488525 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M670.202026,743.576355 
	C671.522095,743.474121 672.261047,744.106140 671.906128,745.568787 
	C671.502441,745.467651 671.098816,745.366577 670.418091,745.114746 
	C670.167969,744.594055 670.194885,744.224182 670.202026,743.576355 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M649.339417,739.032837 
	C648.631531,740.032349 648.011414,740.803650 646.924438,740.650208 
	C646.709595,740.619873 646.360352,740.241394 646.381165,740.058533 
	C646.499573,739.018433 647.420044,739.053894 648.472412,738.806641 
	C648.995483,738.749512 649.201172,738.740479 649.339417,739.032837 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M642.339233,744.952271 
	C641.974670,745.155823 641.742249,745.110779 641.160278,744.996765 
	C641.213013,744.343384 641.044006,743.154968 642.248535,743.461975 
	C642.417358,743.505005 642.401611,744.271912 642.339233,744.952271 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M651.923035,784.247559 
	C652.464661,784.013855 652.896973,784.065125 653.639709,784.231079 
	C654.155151,784.426514 654.360107,784.507324 654.682983,784.897034 
	C654.329407,785.968872 653.651611,786.192627 652.432861,785.846008 
	C651.979675,785.325195 651.896667,784.928833 651.923035,784.247559 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M679.880066,731.573364 
	C679.477234,731.949829 679.087708,731.956299 678.406006,731.958740 
	C678.107300,731.219666 677.487305,730.206543 678.670959,729.945312 
	C679.402710,729.783875 679.788330,730.479919 679.880066,731.573364 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M570.709778,767.999329 
	C570.466553,768.285950 569.940918,768.585999 569.392273,768.835571 
	C569.356628,768.851746 569.144165,768.479187 569.013977,768.287476 
	C569.483337,768.192017 569.952637,768.096558 570.709778,767.999329 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M546.719482,768.221680 
	C546.281616,768.569214 545.462341,768.764099 544.315674,768.985596 
	C543.988281,769.012207 543.990234,768.569824 543.941406,768.353943 
	C544.707703,768.115051 545.522888,768.092041 546.719482,768.221680 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M658.069702,758.179626 
	C658.375671,757.948853 658.809326,757.986023 659.564331,758.068542 
	C659.918091,758.495056 659.950623,758.876099 659.993652,759.543579 
	C659.401978,759.369141 658.799683,758.908325 658.069702,758.179626 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M594.176636,724.757629 
	C594.134338,725.396851 593.727844,725.813782 593.112183,726.436768 
	C592.903137,726.642822 592.592712,726.741943 592.437683,726.791138 
	C591.818359,725.425476 592.448547,724.737000 594.176636,724.757629 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M657.234375,743.698914 
	C656.633118,743.740051 656.211487,743.615906 655.789917,743.491821 
	C655.909119,743.384460 656.047974,743.170410 656.144287,743.188110 
	C656.574158,743.267090 656.991943,743.412354 657.234375,743.698914 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M661.754639,731.995972 
	C661.647156,732.455811 661.384583,733.280396 660.660095,732.366333 
	C660.939880,732.239014 661.219727,732.111633 661.754639,731.995972 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M595.142944,724.241211 
	C594.711182,723.708069 594.734619,722.965332 595.656616,722.178406 
	C596.146118,722.231384 596.263794,722.400330 596.199097,722.818481 
	C595.778076,723.375488 595.539307,723.683289 595.142944,724.241211 
z"/>
<path fill="#230B0C" opacity="1.000000" stroke="none" 
	d="
M690.748657,736.170898 
	C691.173279,736.140503 691.394287,736.320435 691.592285,736.797485 
	C691.218689,736.884155 690.531067,737.143433 690.748657,736.170898 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M647.078613,734.920776 
	C646.665588,735.829651 646.113159,736.271240 645.262756,735.729309 
	C645.500122,735.420349 645.737427,735.111389 646.254150,734.675598 
	C646.533447,734.548767 647.008972,734.683655 647.078613,734.920776 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M608.232544,735.247192 
	C608.535400,735.002808 608.961609,734.988892 609.708496,734.990906 
	C609.637939,735.755432 609.104431,735.998413 608.232544,735.247192 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M627.973511,757.807861 
	C627.827332,757.450806 627.933777,757.033813 628.176514,756.323853 
	C628.863098,756.632507 628.949890,757.210632 627.973511,757.807861 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M654.806763,785.190918 
	C654.621582,785.098938 654.442261,784.992004 654.106567,784.615356 
	C653.975952,784.097778 654.001709,783.849976 654.070374,783.230713 
	C654.444946,783.414673 654.776550,783.970032 654.972900,784.842163 
	C654.837646,785.158875 654.812744,785.176025 654.806763,785.190918 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M655.882935,754.333374 
	C656.297668,754.485107 656.636536,754.952454 656.972412,755.727051 
	C656.581909,755.572571 656.194458,755.110840 655.882935,754.333374 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M654.995178,751.742188 
	C654.703064,751.756958 654.401794,751.517090 654.146301,751.235779 
	C654.126282,751.213684 654.425354,750.901733 654.576050,750.724487 
	C654.716553,750.975342 654.857117,751.226196 654.995178,751.742188 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M655.621399,752.265503 
	C655.864990,752.750122 655.918335,753.112915 655.967957,753.752686 
	C655.126892,753.948364 654.957947,753.351379 654.950806,752.334595 
	C654.992676,752.007324 654.999695,752.000305 655.001709,751.998657 
	C655.003662,751.997009 655.431152,752.143616 655.621399,752.265503 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M627.980347,754.002808 
	C627.793823,754.102112 627.378540,754.170776 627.189270,754.078796 
	C627.326660,753.743591 627.653320,753.500366 627.979858,753.257202 
	C628.042236,753.472595 628.104614,753.688110 627.980347,754.002808 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M648.912231,738.900879 
	C649.269714,738.470093 649.749573,738.181641 650.504700,737.819092 
	C650.779968,737.744995 650.995239,737.996155 651.105713,738.122314 
	C650.747375,738.551941 650.278503,738.855408 649.540833,739.246582 
	C649.272034,739.334229 649.034668,739.043213 648.912231,738.900879 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M571.001099,768.001221 
	C571.462830,767.679504 571.923584,767.356567 572.679993,767.004883 
	C572.975708,766.976196 572.999634,767.000549 573.010193,767.014771 
	C572.548340,767.348022 572.075989,767.667053 571.300537,767.991821 
	C570.997559,767.997559 571.000000,768.000000 571.001099,768.001221 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M643.212830,761.770752 
	C643.267090,761.392517 643.682495,761.643738 643.851257,761.818176 
	C644.160828,762.133301 644.301697,762.273926 644.420227,762.712341 
	C644.397888,763.010071 644.405029,763.464783 644.351929,763.685913 
	C643.529785,763.573303 643.157532,762.982239 643.212830,761.770752 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M581.701782,763.005981 
	C581.591736,763.374207 581.121704,763.696655 580.280518,763.960938 
	C580.386780,763.588623 580.864258,763.274475 581.701782,763.005981 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M580.022583,764.032227 
	C579.600403,764.389648 579.141846,764.702759 578.401611,765.071533 
	C578.119934,765.127136 578.001892,764.996094 577.944092,764.926514 
	C578.367737,764.558167 578.849182,764.259338 579.619995,763.931702 
	C579.909302,763.902832 579.986084,763.987915 580.022583,764.032227 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M501.416931,742.191956 
	C500.449554,741.699890 500.341217,741.183777 501.769287,740.992798 
	C501.915161,741.375549 501.781738,741.704041 501.416931,742.191956 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M648.337158,734.513550 
	C648.245056,734.984070 647.959167,735.123535 647.389771,735.167542 
	C647.148254,735.157959 646.841736,734.855774 646.687622,734.702271 
	C646.796448,734.345276 647.059448,734.141785 647.570923,733.880188 
	C647.941345,733.970825 648.063293,734.119507 648.337158,734.513550 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M656.882996,734.866089 
	C657.068787,734.575439 657.438660,733.975525 657.315430,735.034363 
	C657.169556,735.148560 656.975830,734.962952 656.882996,734.866089 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M664.816040,730.087524 
	C664.974609,730.334839 664.767212,730.509888 664.559814,730.684937 
	C664.523254,730.461670 664.486633,730.238403 664.816040,730.087524 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M638.233521,731.249756 
	C637.995178,731.534424 637.586914,731.639465 637.178589,731.744507 
	C637.185059,731.498657 637.191467,731.252747 637.456543,730.862915 
	C637.715210,730.718872 638.063477,731.070068 638.233521,731.249756 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M661.994873,731.993774 
	C662.139893,732.074158 661.987793,731.080994 662.174744,731.949097 
	C662.009766,732.007751 661.999451,731.999390 661.994873,731.993774 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M631.841309,747.657471 
	C631.742676,747.371948 631.952393,747.048279 632.453186,746.660522 
	C632.546021,746.937317 632.347900,747.278259 631.841309,747.657471 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M664.910522,729.892944 
	C665.079041,729.632019 665.429565,729.011047 665.319946,730.046692 
	C665.182068,730.159851 664.998047,729.984863 664.910522,729.892944 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M596.317993,723.005432 
	C596.009583,722.900024 596.002380,722.732300 596.011841,722.313477 
	C596.195862,722.006042 596.363220,721.949768 596.792664,721.931152 
	C596.909607,722.293579 596.764404,722.618408 596.317993,723.005432 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M658.992737,787.555786 
	C658.869446,786.959595 658.984375,786.323181 659.844360,786.924927 
	C659.750977,787.354431 659.554932,787.533264 658.992737,787.555786 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M581.968079,762.960266 
	C582.083923,762.877625 582.203125,762.018005 582.220276,762.982727 
	C582.061768,763.051697 581.997437,762.992615 581.968079,762.960266 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M640.774902,764.170593 
	C640.555115,764.163513 640.326111,763.865295 640.078430,763.281860 
	C640.295044,763.290894 640.530334,763.585205 640.774902,764.170593 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M657.005859,756.335388 
	C657.273315,756.298462 657.584656,756.582703 657.939941,757.198303 
	C657.672485,757.238647 657.361145,756.947571 657.005859,756.335388 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M642.768677,768.925049 
	C642.561218,768.947571 642.323059,768.725952 642.072266,768.250732 
	C642.375366,768.136169 642.601440,768.364075 642.768677,768.925049 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M543.524292,758.315430 
	C546.323547,757.654907 548.649109,758.212158 550.948120,755.763794 
	C552.796387,753.795349 556.865112,754.549744 559.864807,755.659729 
	C560.907532,756.045532 561.983582,757.063416 561.580750,758.351685 
	C561.119141,759.827881 559.876038,761.198425 558.272156,760.785278 
	C551.606384,759.067993 544.792480,760.699707 536.886841,759.599060 
	C539.747314,759.073242 541.435730,758.762939 543.524292,758.315430 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M509.722229,772.073608 
	C509.924469,772.761414 509.814728,773.525391 509.013000,773.524597 
	C508.696381,773.524231 508.380341,772.946960 508.014771,772.343140 
	C508.434906,772.042297 508.904266,772.030762 509.722229,772.073608 
z"/>
<path fill="#DDAC96" opacity="1.000000" stroke="none" 
	d="
M540.628784,728.911499 
	C540.757385,729.418091 540.713501,730.190735 540.331421,730.435730 
	C539.738403,730.816040 539.290649,730.270691 539.051025,729.354004 
	C539.440125,729.021545 539.872375,728.981323 540.628784,728.911499 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M546.635132,725.884521 
	C546.479431,726.192383 546.033142,726.559448 545.276978,726.933594 
	C545.426208,726.608337 545.885376,726.276062 546.635132,725.884521 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M481.047424,744.667725 
	C478.428375,742.765686 478.428375,742.765686 483.691528,741.073730 
	C484.376343,743.233459 482.256927,743.346619 481.047424,744.667725 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M501.984863,729.990601 
	C502.518616,730.195862 503.344543,730.266296 503.551727,730.661377 
	C503.872589,731.273193 503.242004,731.703552 502.288971,731.930603 
	C501.963013,731.503662 501.980347,731.065796 501.989960,730.299011 
	C501.982269,729.970154 501.999725,730.001221 501.984863,729.990601 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M497.750671,734.110962 
	C497.762299,734.515198 497.549530,735.055420 497.336761,735.595703 
	C497.119110,735.499390 496.901489,735.403076 496.683838,735.306763 
	C496.964630,734.953491 497.245483,734.600220 497.750671,734.110962 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M500.296326,732.992310 
	C500.410553,732.609985 500.878723,732.278259 501.646301,731.944031 
	C501.945740,731.941589 501.988495,731.988647 502.008972,732.013794 
	C501.569733,732.373596 501.109985,732.708191 500.296326,732.992310 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M498.003418,734.007446 
	C498.464111,733.687805 498.917053,733.356445 499.656189,732.983398 
	C499.942413,732.941772 499.999146,733.002441 500.026062,733.035889 
	C499.565186,733.378479 499.077393,733.687561 498.282318,733.985840 
	C497.975067,733.974915 497.995667,733.995605 498.003418,734.007446 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M495.416748,737.496277 
	C495.381195,737.436401 495.452271,737.556152 495.416748,737.496277 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M491.482361,743.522522 
	C491.424133,743.554565 491.540558,743.490479 491.482361,743.522522 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M489.004456,745.005981 
	C489.138550,745.079895 489.048462,744.236938 489.156464,744.961426 
	C488.983978,744.986328 488.998840,744.998901 489.004456,745.005981 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M506.050659,729.063965 
	C505.901642,729.276123 505.592163,730.046692 505.684296,728.952759 
	C505.833038,728.852051 505.980743,728.990662 506.050659,729.063965 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M459.372620,752.271484 
	C460.443909,747.436768 464.556091,744.899536 468.710510,742.066284 
	C467.343475,746.710205 463.123108,749.046570 459.372620,752.271484 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M472.885925,737.512817 
	C474.484314,735.897156 475.951019,734.554504 477.734589,733.126343 
	C477.930054,736.622009 474.935730,737.999634 472.388184,740.019287 
	C472.283264,739.300232 472.518768,738.543091 472.885925,737.512817 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M478.382080,733.187012 
	C479.508789,730.762573 480.556091,728.111206 483.691406,727.005005 
	C483.113495,729.844666 480.884918,731.557678 478.382080,733.187012 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M470.335632,741.206055 
	C470.490448,740.715393 470.958740,740.368103 471.737091,740.033142 
	C471.892273,740.813782 471.353546,741.170410 470.335632,741.206055 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M469.355682,742.088257 
	C469.214417,741.774048 469.396606,741.496887 469.815796,741.125366 
	C469.928192,741.395813 469.803680,741.760498 469.355682,742.088257 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M458.008881,753.683350 
	C457.791565,753.680542 457.699951,753.452820 457.608337,753.225037 
	C457.736664,753.175537 457.864990,753.125977 458.210022,753.055176 
	C458.329376,753.175415 458.231995,753.316895 458.008881,753.683350 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M484.325470,726.972839 
	C484.289001,726.708130 484.560516,726.376709 485.176239,726.027100 
	C485.224762,726.307983 484.929138,726.607117 484.325470,726.972839 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M486.234436,725.302979 
	C486.140839,725.098022 486.274261,724.676208 486.723602,724.129944 
	C486.846802,724.365662 486.654114,724.725891 486.234436,725.302979 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M448.194489,756.861450 
	C448.088196,756.519653 448.232361,756.087402 448.376526,755.655212 
	C449.059235,755.986694 448.732330,756.380127 448.194489,756.861450 
z"/>
<path fill="#575677" opacity="1.000000" stroke="none" 
	d="
M446.936646,757.925110 
	C446.997742,757.545532 447.199188,757.294800 447.713470,757.031006 
	C447.944000,756.951843 447.991760,756.994019 448.013855,757.018311 
	C447.960938,757.370361 447.794586,757.642334 447.328583,757.980896 
	C447.120270,758.103394 446.994598,757.987793 446.936646,757.925110 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M257.367432,912.932129 
	C256.985199,912.104980 256.981018,911.309265 256.957642,910.113403 
	C257.732330,909.407410 258.526245,909.101562 259.649109,908.789001 
	C259.994476,909.640442 260.010925,910.498535 260.054993,911.785034 
	C260.082581,912.213440 260.047729,912.625732 260.030121,912.832153 
	C259.256836,913.013550 258.501129,912.988586 257.367432,912.932129 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M245.190842,921.144409 
	C245.076721,919.495117 245.691071,918.388611 247.255661,918.155823 
	C247.565628,918.109741 248.267624,918.617798 248.255493,918.841553 
	C248.197052,919.918823 247.593399,920.675171 246.168732,920.998718 
	C245.691040,921.131775 245.541382,921.222717 245.190842,921.144409 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M251.346252,914.074524 
	C251.631424,913.058777 252.626526,912.993591 254.069138,913.126709 
	C253.545334,913.474915 252.630356,913.780273 251.346252,914.074524 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M243.216766,924.305115 
	C242.954620,924.195618 242.909454,923.848755 242.930008,922.980774 
	C243.627213,922.863403 243.798050,923.392761 243.216766,924.305115 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M245.050247,921.139893 
	C244.989975,920.975098 245.412918,921.055359 245.626801,921.048096 
	C245.597305,921.128784 245.353912,921.216675 245.050247,921.139893 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M320.880127,464.441895 
	C320.907532,461.793793 323.806580,461.626038 324.359894,459.424774 
	C321.697540,459.409058 319.594757,462.229919 315.602173,459.743713 
	C322.181183,459.980713 324.741089,453.961212 330.644775,453.882202 
	C326.408875,462.306610 327.579865,471.264069 328.921570,480.247162 
	C329.186615,482.021759 329.177185,483.837128 329.437012,485.612823 
	C329.559296,486.448517 329.938416,487.365997 328.964172,487.737122 
	C327.784363,488.186493 327.083405,487.283936 326.758789,486.309448 
	C325.872498,483.648987 325.002533,480.977020 324.287140,478.267120 
	C323.108978,473.804504 322.057648,469.308441 320.880127,464.441895 
z"/>
<path fill="#717B9D" opacity="1.000000" stroke="none" 
	d="
M281.859711,544.929382 
	C281.106812,545.318298 280.369476,545.343933 279.434204,545.572144 
	C276.938416,544.728149 274.640594,543.681641 272.102600,542.387695 
	C273.968811,540.744873 273.480469,538.552734 273.384308,536.041565 
	C277.649353,537.869385 279.828339,541.149475 281.859711,544.929382 
z"/>
<path fill="#6A7594" opacity="1.000000" stroke="none" 
	d="
M306.987427,515.639648 
	C304.466187,516.373901 302.823975,515.542664 301.408539,513.158386 
	C300.276520,511.251617 299.628235,508.490082 296.352356,508.042297 
	C296.112701,506.607056 296.001007,504.186523 298.208099,505.823639 
	C301.654358,508.379822 305.839935,510.483276 306.987427,515.639648 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M334.548035,450.569336 
	C334.494324,450.603119 334.601776,450.535553 334.548035,450.569336 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M333.405029,452.392273 
	C333.488739,452.330017 333.529388,452.559326 333.529388,452.559326 
	C333.529388,452.559326 333.321350,452.454559 333.405029,452.392273 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M296.702667,533.657959 
	C293.572113,539.492004 290.027161,544.944458 285.485291,550.023315 
	C284.732483,549.947083 284.379181,549.830994 283.981018,549.517273 
	C288.267639,544.135498 290.918396,537.635803 296.702667,533.657959 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M296.835602,562.822754 
	C295.593414,561.879578 294.742981,560.891052 293.787476,559.592224 
	C293.845184,559.131226 294.007935,558.980591 294.413940,558.603210 
	C296.512726,558.471375 297.444336,559.524902 297.635437,561.684814 
	C297.466125,562.308960 297.346771,562.543213 296.835602,562.822754 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M304.710846,570.922485 
	C305.208160,571.893311 305.549713,572.669495 305.928986,573.763184 
	C304.711670,573.985535 304.498352,572.756714 303.634460,571.799377 
	C303.485779,571.524658 303.720795,571.084778 303.888672,570.900269 
	C304.056519,570.715820 304.555054,570.727783 304.710846,570.922485 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M298.034790,564.092407 
	C297.411224,563.904236 297.064209,563.587036 296.580505,563.068909 
	C296.553131,562.695068 296.662445,562.522095 296.965088,562.110779 
	C297.883148,561.770935 298.267578,562.173218 298.522491,563.090393 
	C298.460266,563.584717 298.385803,563.774048 298.034790,564.092407 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M305.829712,574.325439 
	C306.265869,574.482056 306.618103,574.959595 306.965881,575.756714 
	C306.556183,575.599670 306.150970,575.122986 305.829712,574.325439 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M301.184357,567.553711 
	C300.464203,567.747009 300.044586,567.377869 299.489838,566.751099 
	C299.397156,566.261658 299.439636,566.029846 299.822693,565.720093 
	C300.920013,565.782104 301.352844,566.239380 301.184357,567.553711 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M301.789124,568.490051 
	C301.616913,568.933777 301.326813,568.771057 300.960266,568.362183 
	C300.883789,568.116150 300.933868,568.073547 300.953064,568.046875 
	C301.205261,567.974670 301.438293,567.929138 301.789124,568.490051 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M302.921814,569.677002 
	C302.534424,569.995239 302.278625,569.794128 301.964905,569.344788 
	C301.906982,569.096558 301.944550,569.058960 301.962158,569.039062 
	C302.374023,568.783203 302.730164,568.842896 302.921814,569.677002 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M303.611023,571.402588 
	C303.286560,571.249878 303.087311,570.975037 302.839142,570.448364 
	C302.790192,570.196411 302.887146,570.107971 302.934631,570.062744 
	C303.455536,569.842346 303.849915,569.941162 304.065491,570.691406 
	C303.977692,571.027527 303.736237,571.280579 303.611023,571.402588 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M298.967010,565.346252 
	C298.402313,565.163513 298.154816,564.936829 297.832764,564.465820 
	C297.758240,564.221497 297.868042,564.123535 297.920898,564.072388 
	C298.359985,563.745605 298.727386,563.783936 299.215759,564.376465 
	C299.329834,564.877747 299.307037,565.090027 298.967010,565.346252 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M299.568604,566.334167 
	C299.102142,566.319946 298.905426,566.097107 298.707153,565.607605 
	C298.649811,565.390198 298.951233,565.078674 299.125793,564.950195 
	C299.521820,564.924805 299.743225,565.027954 300.076599,565.479858 
	C300.053223,565.944031 299.917847,566.059387 299.568604,566.334167 
z"/>
<path fill="#C4CCC0" opacity="1.000000" stroke="none" 
	d="
M609.256104,215.263855 
	C609.951782,211.668198 612.686035,212.064148 615.599792,211.999939 
	C618.667603,208.370346 622.795410,207.825760 626.747742,207.028717 
	C633.128113,205.742004 639.484924,207.266037 645.828796,207.626755 
	C648.247681,207.764297 650.468628,207.230728 652.632080,206.856812 
	C658.731628,205.802582 664.323608,208.408768 670.206787,208.586700 
	C671.857910,208.636627 673.784485,209.479935 675.105103,208.888489 
	C681.802856,205.888977 688.972168,207.206787 695.871704,206.231873 
	C697.500793,206.001694 699.429443,205.617111 700.802734,206.233566 
	C707.866638,209.404404 714.789490,206.817108 721.813782,206.343948 
	C726.664734,206.017181 731.558960,206.750107 736.506897,206.447159 
	C744.498962,205.957855 752.564087,205.932541 760.557556,206.403564 
	C768.243774,206.856491 776.266235,203.732391 783.174072,205.716980 
	C788.895203,207.360641 794.365295,204.661789 799.969055,207.416214 
	C803.258301,209.032974 808.275391,207.031326 812.392456,206.610916 
	C820.284668,205.805023 827.356873,208.368103 834.807312,209.180450 
	C840.471863,209.798080 846.590271,211.946884 852.232239,207.161575 
	C855.137817,204.697281 860.293335,207.104599 863.825256,204.433853 
	C863.906738,204.372253 864.516113,204.946655 864.832947,205.269791 
	C865.829712,206.286438 865.821167,206.294830 866.749878,204.193054 
	C867.555115,204.121170 868.024780,204.401749 868.597290,205.204224 
	C869.059875,206.976410 868.986572,208.383469 868.828674,210.215454 
	C868.161133,213.685760 868.529724,216.768234 868.395874,219.831299 
	C868.311829,221.752625 868.522339,223.763367 866.433472,225.413269 
	C854.818726,222.806641 843.637024,226.193192 832.405518,225.751221 
	C821.312927,225.314728 810.165833,225.830307 799.038635,226.191254 
	C788.315674,226.539093 777.559998,227.183136 766.756226,226.772324 
	C749.159851,226.103241 731.519592,226.583725 713.897888,226.599380 
	C710.380066,226.602509 707.041138,225.398178 703.687622,224.983231 
	C697.266907,224.188797 690.986267,221.209091 683.934021,223.289368 
	C680.440857,225.064331 677.427734,223.582184 673.997925,223.072540 
	C671.046936,221.211624 668.793701,219.923325 666.031433,223.183563 
	C664.172546,225.377487 660.717834,226.130173 658.189148,224.837601 
	C654.113098,222.754013 649.549622,222.617508 645.497131,220.796860 
	C642.496033,219.448532 639.414001,218.743958 636.374756,220.019379 
	C631.974487,221.866013 627.703430,221.744659 622.973145,220.083481 
	C618.173889,218.725830 614.089722,216.426010 609.256104,215.263855 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M761.012756,192.385345 
	C761.627625,189.236450 763.721558,188.973923 765.987915,189.158920 
	C767.026123,189.243652 768.178101,190.410187 768.943115,188.333252 
	C770.103394,187.689575 771.206787,187.378555 772.655090,187.033768 
	C773.715942,187.871262 774.604004,187.874435 775.692627,187.452118 
	C774.870178,187.473831 774.160217,187.879974 773.239502,187.218796 
	C772.984558,185.515717 773.941040,184.585419 774.876038,183.615555 
	C777.311340,181.089508 780.034485,181.505859 781.492432,184.655228 
	C782.730286,187.329117 785.390442,189.092010 788.223267,189.116196 
	C789.159119,189.124191 790.347900,188.750122 790.404053,190.284576 
	C790.432190,191.053818 788.530396,191.850479 790.213013,192.530991 
	C791.090454,192.885849 792.342346,192.092300 792.652710,191.174286 
	C794.968872,184.324066 799.274231,189.484894 802.690552,189.494278 
	C803.200745,189.495682 803.709045,190.178452 804.218262,190.546021 
	C806.530396,186.541229 811.735474,191.584122 813.771790,186.938431 
	C816.000732,189.046555 812.693909,192.081238 815.640137,193.375931 
	C817.028015,190.155167 822.748047,187.866791 826.897766,188.635223 
	C828.258972,188.887283 829.785583,188.246216 831.617065,188.006805 
	C832.443604,188.002274 832.889709,188.003433 833.670288,188.002747 
	C838.259216,189.254654 841.403259,188.212204 842.937134,183.357819 
	C843.579590,182.456497 844.267029,182.218689 845.417114,182.397797 
	C845.964233,182.661575 846.155151,182.814560 846.518677,183.285843 
	C846.809692,184.049622 846.877869,184.501526 846.827026,185.259201 
	C846.950562,185.753677 846.163879,186.361832 847.248901,186.000336 
	C847.790283,185.321991 848.191711,184.891251 848.113770,183.956650 
	C847.701233,182.728485 847.771484,181.937698 849.099854,181.379578 
	C851.815186,181.814835 854.838806,178.012619 856.693359,182.558121 
	C856.697083,182.782654 856.554382,183.152664 856.554382,183.152664 
	C856.554382,183.152664 856.812378,183.453506 857.034424,183.380981 
	C858.798950,183.006226 859.749878,184.681580 861.533508,184.390869 
	C863.381714,183.274872 862.407654,182.337662 861.548096,181.128998 
	C858.811096,177.868408 860.360535,175.703033 862.650635,173.452667 
	C864.561157,171.575119 866.294556,171.433456 868.370850,173.493210 
	C868.506714,176.999756 868.479797,180.151459 868.482788,183.690460 
	C869.370605,184.857239 866.002502,184.877869 868.359619,186.211411 
	C868.816528,187.338440 868.718079,188.089539 867.877625,188.900879 
	C866.644287,189.308533 866.173462,189.854355 866.022827,190.792038 
	C865.150574,196.221802 862.007141,197.838989 856.571228,196.831039 
	C853.491821,196.260056 850.139771,197.159592 846.803711,197.404663 
	C846.039368,196.337067 847.162109,196.226669 847.780701,195.885880 
	C848.853455,195.294754 849.230530,194.472763 848.335632,193.533264 
	C847.671448,192.835968 846.614258,192.996399 846.098511,193.626724 
	C842.580383,197.926331 839.157593,196.679657 835.729126,193.080826 
	C834.934204,195.654800 837.040588,196.624283 838.009949,198.760239 
	C829.171082,196.589508 820.844910,193.995316 812.109863,198.856247 
	C811.018860,198.420303 810.597534,197.984833 809.494446,198.699081 
	C807.438843,199.069412 806.034424,198.805145 805.132263,197.323914 
	C804.236145,195.852798 803.044495,195.852112 801.784058,196.796570 
	C799.671143,198.379761 797.493225,198.566650 795.419556,196.901199 
	C793.236145,195.147614 791.882996,198.038467 789.591675,198.007889 
	C784.537415,197.940460 779.973755,195.619766 774.764282,195.764633 
	C771.357239,195.859375 766.821533,197.606293 763.066711,195.094177 
	C762.061401,194.421555 761.047791,194.156113 761.012756,192.385345 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M608.990601,214.991623 
	C613.902100,214.419067 617.718689,217.348801 622.278809,219.075836 
	C628.387573,220.775330 632.055664,225.491577 637.000610,228.943878 
	C638.296875,230.056976 639.211609,231.065750 640.320007,232.357178 
	C640.926697,233.171066 641.281555,233.747757 641.907593,234.550537 
	C645.967834,240.814697 651.514221,245.719742 653.708252,253.140076 
	C656.242859,259.390656 655.862305,265.665314 656.044250,271.862915 
	C656.054993,272.228912 656.269775,273.389069 655.182617,272.661011 
	C654.820007,272.418121 654.688782,271.829742 654.237549,271.166443 
	C653.625732,270.420410 653.501770,269.805878 653.261658,268.887939 
	C651.178833,265.286957 653.761230,260.676849 649.918945,257.597168 
	C649.733276,257.119659 649.685669,256.925507 649.665405,256.447815 
	C649.895203,255.872131 650.154541,255.667923 650.626587,255.430511 
	C650.732483,255.231888 650.303101,254.994156 650.098755,254.828552 
	C649.763184,254.532745 649.631958,254.402512 649.304993,254.054199 
	C648.978821,253.677582 648.848450,253.519043 648.529724,253.104492 
	C638.940063,245.385864 629.216187,238.565628 617.347351,235.401291 
	C614.074951,234.528854 611.824829,234.543137 610.569946,238.471924 
	C609.778015,239.430313 609.168579,239.306549 608.500122,238.337341 
	C608.336060,234.625565 608.261108,231.267838 608.108215,227.456757 
	C608.265991,224.603012 608.501709,222.202637 608.826599,219.401917 
	C609.284668,218.634705 609.732178,218.484711 610.573364,218.701035 
	C611.078003,219.059235 611.255737,219.235443 611.625122,219.736115 
	C611.982117,220.536591 612.111511,221.022202 612.240601,221.892700 
	C612.319763,223.266357 612.202881,224.253510 612.016968,225.596466 
	C611.411438,228.167709 612.117432,229.505447 614.541199,229.617798 
	C624.570007,230.082718 632.756714,234.835724 640.728027,240.925888 
	C641.333984,241.390060 641.578186,241.782532 641.919678,242.005386 
	C642.472412,242.366074 641.640381,242.064072 642.251465,241.797989 
	C642.391785,241.736877 642.237915,241.732300 641.613770,241.664948 
	C636.369385,236.028412 629.907654,232.654236 623.630371,228.539307 
	C624.499634,224.618332 621.793091,224.044525 619.082458,223.119568 
	C617.075745,222.444321 615.474854,221.654160 613.560181,220.793884 
	C612.671021,220.178085 612.388977,219.290314 611.197510,219.095093 
	C610.372192,218.296646 609.637451,217.864792 608.751953,217.105225 
	C608.439331,216.410431 608.457275,215.975327 608.769226,215.268387 
	C608.959167,214.993713 608.988159,215.007721 608.990601,214.991623 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M867.400635,185.261230 
	C867.357849,181.326294 867.351929,177.631165 867.188721,173.509201 
	C865.252197,168.509735 865.866150,163.957138 867.285645,159.025543 
	C867.459839,158.083466 867.639343,157.577408 868.372864,157.106598 
	C869.185364,175.762772 869.588989,194.435196 869.915771,213.573120 
	C869.408752,214.398743 868.919800,214.518051 868.048828,214.169479 
	C867.402100,212.912598 867.527710,211.858154 867.693909,210.440918 
	C867.870117,208.660706 867.905457,207.248795 867.871216,205.417877 
	C867.304016,203.641251 867.571167,202.236191 867.653992,200.445007 
	C867.778259,199.277084 867.792786,198.513504 867.759705,197.370514 
	C867.712158,196.991089 867.621338,196.503586 867.657593,196.258286 
	C867.676453,193.966400 867.659058,191.919815 867.566528,189.440720 
	C867.518372,188.244431 867.545227,187.480637 867.466797,186.348618 
	C867.361572,185.980377 867.437500,185.501068 867.400635,185.261230 
z"/>
<path fill="#C4CCC0" opacity="1.000000" stroke="none" 
	d="
M608.684082,215.131653 
	C608.896423,215.442062 608.833679,215.890396 608.870667,216.665085 
	C608.942627,217.156296 608.914917,217.321152 608.720337,217.673203 
	C605.685608,220.050156 603.563477,220.422485 603.463013,214.992508 
	C605.359619,217.762787 606.842224,216.116089 608.684082,215.131653 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M812.000000,198.999695 
	C811.484131,201.180237 810.567505,201.611328 809.052856,199.330811 
	C809.000000,198.999390 809.000000,199.000000 809.000000,199.000305 
	C809.685913,198.421753 810.458618,198.270645 811.657410,198.765610 
	C812.000000,199.000610 812.000000,199.000000 812.000000,198.999695 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M556.709839,189.481750 
	C557.592712,189.108978 558.230652,189.125565 558.474426,189.890488 
	C558.540466,190.097610 558.296509,190.597046 558.097290,190.661636 
	C557.249023,190.936752 556.484741,190.904922 556.709839,189.481750 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M569.000000,191.000305 
	C568.864380,191.952377 568.694580,192.898865 567.419556,192.832718 
	C567.180786,192.820328 566.747314,192.526779 566.757874,192.390366 
	C566.832336,191.426529 567.623047,191.244675 568.689941,191.027145 
	C569.000000,190.999390 569.000000,191.000000 569.000000,191.000305 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M867.544800,200.304642 
	C867.810669,201.418686 867.857666,202.796738 867.853210,204.586823 
	C867.533630,204.858124 867.322449,204.657532 867.082397,204.193481 
	C867.106384,202.849457 867.216125,201.709045 867.544800,200.304642 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M608.624268,218.049225 
	C608.711060,217.694656 608.793701,217.497528 608.885925,217.130219 
	C609.867310,217.081573 610.667358,217.311005 610.947876,218.678009 
	C610.525391,219.009933 610.065552,219.004883 609.260742,219.000702 
	C608.749817,218.773788 608.676270,218.519287 608.624268,218.049225 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M634.042725,193.406921 
	C634.766724,193.801636 634.775513,194.199982 634.260071,194.552948 
	C634.152161,194.626831 633.901672,194.624496 633.796448,194.547943 
	C633.293762,194.182083 633.307861,193.783798 634.042725,193.406921 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M593.000000,192.999695 
	C593.117676,193.137009 593.235413,193.274643 593.353088,193.412277 
	C593.270569,193.364365 593.188049,193.316437 593.052734,193.134567 
	C593.000000,193.000610 593.000000,193.000000 593.000000,192.999695 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M867.574707,196.114960 
	C867.693787,196.012985 867.801086,196.500153 867.756592,196.745621 
	C867.390198,196.796600 867.304688,196.538559 867.574707,196.114960 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M719.966370,156.117096 
	C722.205933,156.113083 724.379761,156.159210 724.652832,151.620834 
	C726.645325,155.919891 728.604126,157.808533 730.884949,159.493958 
	C732.471741,160.666550 734.092468,162.226944 731.697876,164.311798 
	C731.012085,164.908844 730.842468,165.829605 731.678650,166.429886 
	C732.265869,166.851410 733.093994,166.519501 733.352661,165.903397 
	C734.147461,164.010651 736.495056,163.889481 737.391418,161.788300 
	C738.314941,159.623398 741.286377,158.302689 743.138306,159.945190 
	C747.037415,163.403458 752.989807,162.653351 756.649780,166.962524 
	C757.163086,167.125320 757.330688,167.254013 757.743835,167.182419 
	C757.989441,166.982117 757.997559,167.000610 757.989502,166.991577 
	C760.859680,165.384659 760.021667,168.680862 761.169312,169.489929 
	C762.347473,167.596848 759.767456,166.259872 760.781860,164.258423 
	C761.171326,164.000000 761.342590,164.000000 761.770874,163.999695 
	C762.301147,163.676910 762.645569,163.475952 763.367676,163.419296 
	C763.866150,163.514648 764.057434,163.586243 764.505981,163.820343 
	C765.389160,164.480438 765.995056,165.000702 766.769287,165.777298 
	C767.178955,166.257462 767.378601,166.528503 767.801514,166.925354 
	C766.220154,172.278076 761.295593,174.098694 757.263428,176.890411 
	C757.150513,176.968613 756.866882,176.977371 756.783569,176.895569 
	C753.110596,173.289413 750.471741,175.128403 747.851135,178.376984 
	C747.046692,179.374191 745.842896,178.889603 744.912109,177.805634 
	C742.417358,174.900375 741.435120,176.426697 741.007202,179.634186 
	C739.047485,178.031250 737.459167,180.722733 735.779480,180.616882 
	C734.439575,178.882080 737.625000,178.087738 736.268005,176.466385 
	C734.496826,176.114822 733.323303,177.762817 731.349121,177.964142 
	C731.572815,175.500061 734.680847,172.519547 729.343018,171.037308 
	C728.614685,172.267975 730.085449,175.251678 728.807678,174.586884 
	C725.216431,172.718430 725.600891,182.968613 721.148193,176.638748 
	C720.180237,175.262741 717.196899,175.600266 716.359131,172.775696 
	C715.908325,171.255981 714.239624,172.567978 713.241699,173.507019 
	C711.519653,175.127411 710.769104,177.966156 707.372437,177.994995 
	C706.069336,177.177505 705.400330,175.948807 703.752014,175.989212 
	C704.013794,177.772705 705.726074,176.877457 706.746155,177.777756 
	C706.142700,181.680130 704.406860,182.735397 701.173706,180.122971 
	C699.648804,178.890808 697.976379,177.904541 696.598877,176.418716 
	C692.052490,171.514679 691.507568,171.348862 686.960449,176.425705 
	C684.460205,179.217194 682.472656,179.291229 679.843018,177.257919 
	C678.298218,176.063416 677.159119,175.780762 677.005859,178.650436 
	C675.281555,179.267090 673.565552,179.532349 671.845642,179.798203 
	C671.023804,177.915009 673.527222,177.280060 672.989990,175.361740 
	C672.561340,172.946426 670.604675,172.386093 669.254517,171.236893 
	C666.761719,169.115021 667.246704,166.942276 669.080994,164.734238 
	C670.978760,162.449814 672.775574,163.363342 674.685181,164.821259 
	C675.922424,165.765808 676.590881,167.720123 678.952393,167.109879 
	C680.040527,166.262024 680.934143,165.679886 682.024597,164.821442 
	C682.448486,164.486923 682.620117,164.354691 683.054382,164.029526 
	C685.930908,161.800751 688.127747,159.390198 690.063843,156.292831 
	C690.593384,155.699722 690.975647,155.472183 691.705200,155.164490 
	C693.037292,153.802658 694.024902,152.559082 695.124268,151.423767 
	C696.832153,149.660065 698.154053,149.928558 698.795776,152.916718 
	C697.938721,154.244980 696.833435,154.535522 696.252563,155.816360 
	C696.046387,156.249405 695.964478,156.418808 695.767822,156.833038 
	C695.531677,157.399170 695.466736,157.730225 695.591492,158.300064 
	C695.929749,158.791321 696.183411,159.029907 696.693604,159.401733 
	C697.781250,159.919861 698.432251,160.890274 699.768127,160.207520 
	C701.428101,159.016586 702.877563,158.039444 704.667969,157.026627 
	C705.006836,155.927017 705.004761,154.863083 705.001343,153.398956 
	C707.700378,152.266083 708.188416,155.569809 710.654419,155.949829 
	C711.217712,156.215622 711.432373,156.434464 711.649658,156.650833 
	C711.867065,156.867416 711.795410,156.794678 711.214539,156.219131 
	C711.186523,154.361053 710.346619,152.133316 713.631592,152.009186 
	C714.544434,152.525970 715.018799,153.163101 716.046143,152.851761 
	C716.173462,152.776245 716.145691,152.600540 715.973877,152.655899 
	C715.312378,152.749634 714.853699,152.649887 714.214233,152.209045 
	C713.997620,150.220139 713.857666,148.588409 716.148499,147.657745 
	C717.869629,146.958572 719.330688,145.478333 720.732178,144.159531 
	C725.024170,140.120605 726.580322,140.486862 728.837341,146.900909 
	C727.984009,148.283905 727.101135,148.824692 726.177368,149.778900 
	C722.493652,150.090302 722.041870,153.531052 720.036255,155.643951 
	C720.000000,155.999390 719.932739,156.233597 719.966370,156.117096 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M593.996094,163.366302 
	C599.665955,164.726471 600.663147,167.354538 597.116760,172.730789 
	C600.342224,171.945679 601.780640,169.996262 602.965454,167.352173 
	C603.668884,166.208969 604.623352,165.854462 605.744385,165.206085 
	C605.982239,164.847214 605.986511,164.677658 605.995361,164.253754 
	C607.059753,162.686981 608.468872,161.724945 609.785156,160.223801 
	C610.007690,160.001038 610.000000,160.000000 610.001221,160.003983 
	C611.055786,158.836609 612.250244,157.965851 614.311523,158.236069 
	C615.136658,158.516479 615.544495,158.789627 616.088196,159.453934 
	C616.328552,159.992157 616.373474,160.225952 616.356567,160.804352 
	C615.825562,162.332260 615.702881,163.666824 617.105286,164.044815 
	C618.994080,164.553940 619.839539,162.562851 621.456421,161.531311 
	C623.853516,159.936478 624.557556,157.480255 626.032959,155.610184 
	C627.125916,154.224884 628.064087,152.673126 630.405518,152.573715 
	C632.023926,153.679214 633.293457,155.094666 635.054688,152.682556 
	C638.797180,152.376114 642.324097,152.102814 645.406860,154.025665 
	C648.424011,155.907639 648.355530,157.533813 645.089844,159.615784 
	C644.023254,159.146240 643.566284,158.387924 642.589355,158.052933 
	C642.398254,158.034409 642.294373,158.353210 642.507812,158.319672 
	C643.072021,158.346619 643.384766,158.496445 643.907837,158.917847 
	C644.675537,159.741760 645.184021,160.364227 645.655090,161.017197 
	C646.126160,161.670227 646.753113,162.190720 647.433716,163.144012 
	C646.815613,160.169266 647.133301,157.958145 650.856750,157.922028 
	C652.309998,159.623764 653.650024,160.654388 655.771118,160.421051 
	C656.922852,160.294342 658.418945,160.503235 657.993286,162.204483 
	C657.538696,164.021896 657.974060,163.820892 659.489380,163.543045 
	C662.476929,162.995239 663.300293,164.544510 661.749023,166.970657 
	C660.263550,169.294022 659.521606,172.280167 656.270996,173.539902 
	C655.317383,173.597427 654.728027,173.407349 653.580139,173.091370 
	C650.432922,173.464844 648.593262,175.194733 646.723694,176.795593 
	C645.127136,178.162704 643.452087,178.376465 642.614563,176.449203 
	C640.333252,171.199982 637.492065,172.994888 634.212646,175.742554 
	C630.269653,174.166962 628.923584,177.589096 627.169556,179.411743 
	C625.803223,180.831451 624.674377,182.184097 622.598145,182.715286 
	C622.150757,180.300339 624.154480,179.732422 625.004333,178.471344 
	C625.679138,177.470047 626.492065,176.425323 625.233521,175.464615 
	C624.243896,174.709183 623.398804,175.489624 622.748840,176.309296 
	C620.829529,178.729630 618.858521,179.619492 616.427673,176.834030 
	C615.830322,176.149567 614.511292,175.620285 613.766235,176.544983 
	C612.693420,177.876465 614.224304,178.525162 614.936462,179.307693 
	C615.732849,180.182861 617.815796,180.670258 616.419128,182.259552 
	C615.343384,183.483566 614.316589,181.867371 613.572021,181.222839 
	C611.709167,179.610306 609.951294,178.408798 608.102905,180.999222 
	C606.406372,178.911911 609.570679,178.111160 608.064880,176.248749 
	C605.992920,178.008530 603.377625,178.414993 601.019226,180.452484 
	C597.598877,183.407501 595.440613,178.785370 593.042847,176.352997 
	C593.002441,176.001221 593.258423,175.965866 593.258423,175.965866 
	C593.258423,175.965866 593.110779,175.764160 593.055237,175.881470 
	C590.507935,175.660324 589.160095,174.253677 589.005615,171.362289 
	C589.939270,168.080399 593.704956,167.105423 593.996094,163.366302 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M867.699219,157.861237 
	C867.622192,162.920044 867.497131,167.621246 867.201782,172.702393 
	C865.902283,173.638199 862.747192,171.282318 864.179993,175.639847 
	C864.904724,177.843933 861.856018,174.831390 860.976685,176.781631 
	C861.232422,177.668365 861.611694,178.983673 861.943359,180.936981 
	C861.616211,182.324646 861.623047,183.075226 861.944336,184.412704 
	C861.665833,187.039566 860.668335,187.149002 859.469727,185.714844 
	C858.702698,184.796982 858.043823,183.924866 856.357910,184.006027 
	C855.938354,182.016205 855.668640,180.044052 853.114868,181.992386 
	C851.843506,182.962326 850.873230,182.987656 849.325439,182.139740 
	C847.753052,181.119797 847.423401,182.692596 846.290283,182.957809 
	C845.248169,183.009216 844.498779,183.006821 843.374695,183.004349 
	C842.646179,180.511169 841.212402,180.912460 839.307129,181.883331 
	C838.828979,182.191162 838.662354,182.358307 838.249268,182.271423 
	C836.843750,179.975647 836.187012,177.373749 833.506714,181.202744 
	C831.364014,184.263870 826.748962,182.881912 823.752075,185.040283 
	C823.311218,185.357803 821.116211,184.173065 820.576172,183.210312 
	C819.667114,181.589569 822.660522,181.365723 822.441956,179.460434 
	C818.707703,178.057602 818.301697,184.141235 814.397217,182.993668 
	C813.615417,182.557907 813.148132,182.214569 812.326233,181.865768 
	C811.887451,181.633881 811.720337,181.524628 811.324036,181.223145 
	C810.640991,180.543488 810.082214,180.463776 809.232422,180.805450 
	C804.692688,179.257248 810.490479,177.489777 808.990967,175.382294 
	C808.322266,170.973892 811.299744,170.789108 813.995911,170.228394 
	C814.465393,170.130753 815.054749,171.345825 815.526367,169.739151 
	C817.400818,163.353287 819.539917,162.944458 824.326416,167.747131 
	C824.795837,168.218170 825.262695,168.673828 825.887146,168.932312 
	C825.435913,168.441925 825.847168,169.585526 826.338257,169.134689 
	C822.225647,165.164856 823.887024,163.695602 829.044739,163.691589 
	C829.947021,163.944046 830.540283,164.078445 831.444458,163.840027 
	C832.318176,163.505066 832.916565,163.391144 833.769653,163.785919 
	C834.746094,163.990311 835.494629,163.979752 836.617432,163.964706 
	C837.976685,167.824615 837.976685,167.824615 841.756592,165.599655 
	C841.643127,165.103455 841.599548,164.899506 841.578369,164.375214 
	C841.901855,163.165649 842.528992,162.574005 843.669006,162.082947 
	C846.170349,161.907333 846.299377,164.824738 848.893677,165.190887 
	C849.840942,166.176849 850.103027,167.367676 851.522522,165.416687 
	C854.475342,164.592667 858.345581,164.804291 853.527039,161.321640 
	C852.824829,160.814117 852.855042,159.687714 853.338318,159.039764 
	C854.235718,157.836563 855.042175,158.704376 855.687561,159.464844 
	C857.352356,161.426422 858.596863,161.663971 860.217957,159.167892 
	C861.811584,156.714096 864.322937,157.185425 866.856445,158.105713 
	C867.245483,157.762360 867.448303,157.632996 867.699219,157.861237 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M830.293701,165.217041 
	C828.854980,164.785660 827.706360,164.306946 826.625610,164.429184 
	C825.607605,164.544327 825.029602,165.557022 825.206543,166.682281 
	C825.368591,167.712234 826.159546,167.892426 827.057678,167.820068 
	C827.915283,167.751007 829.022827,166.620987 829.516174,168.058197 
	C829.714966,168.637375 829.180725,169.676254 828.681458,170.242828 
	C827.708130,171.347305 826.624878,170.849808 825.632874,170.077255 
	C824.596436,169.270004 823.261108,168.682159 822.547668,167.656662 
	C820.760376,165.087723 818.878906,165.568054 817.003723,167.248489 
	C814.756348,169.262436 817.258667,170.313217 818.106873,171.670807 
	C818.454712,172.227585 818.911926,172.738922 818.061157,173.707275 
	C815.010437,171.272705 811.745728,169.697311 809.051758,174.678955 
	C808.337769,175.098267 807.660095,175.095688 807.027161,175.262634 
	C805.668457,175.621017 805.952148,178.807693 803.945923,177.542343 
	C802.238892,176.465698 804.596802,175.404892 804.781982,174.234268 
	C804.918762,173.369476 804.868225,172.578690 804.199890,171.935760 
	C803.682495,171.438049 802.891602,171.055679 802.480591,171.688416 
	C799.792480,175.825714 797.845032,172.335938 795.106934,170.812500 
	C794.012329,169.638412 794.505127,168.731033 794.490662,167.829758 
	C793.542969,168.298599 793.446106,169.332443 792.464050,170.538086 
	C788.223633,170.327042 785.791870,167.963303 784.034241,164.354935 
	C785.960144,161.638458 786.617798,157.376419 791.657166,158.965836 
	C792.864685,156.027664 787.938538,155.845566 789.197327,152.119415 
	C790.661560,150.602234 791.997864,149.866119 793.800049,149.382446 
	C794.338135,149.385498 794.551025,149.416626 795.062805,149.551758 
	C795.917236,149.878540 796.467834,150.140030 797.367432,149.753845 
	C797.843750,149.557205 798.038513,149.484665 798.533813,149.346222 
	C800.687073,148.029968 801.913818,145.447327 805.414307,146.232208 
	C808.115662,146.208557 810.435852,143.135834 812.481995,146.747147 
	C813.064087,147.774658 814.730896,146.207581 815.589233,145.136032 
	C816.124573,144.467819 816.964111,143.933426 817.604370,144.904968 
	C817.875183,145.315964 817.794678,146.418503 817.453430,146.703751 
	C812.382446,150.942520 817.192017,152.730835 819.549377,154.968155 
	C820.998535,156.343414 824.440674,156.319702 821.952576,159.880966 
	C821.156006,161.021118 823.055420,161.886063 825.239075,160.703552 
	C829.054993,158.637238 832.145264,158.729706 833.990601,163.632599 
	C833.451172,164.165405 832.904785,164.329987 832.178711,164.723389 
	C831.619446,165.349731 831.157471,165.509491 830.293701,165.217041 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M654.688477,172.778702 
	C659.074585,172.197159 658.622253,167.428360 661.476257,165.530670 
	C661.577576,165.463303 661.244446,164.363464 661.089966,164.357452 
	C660.491577,164.334183 659.740051,164.380051 659.306885,164.726715 
	C658.187195,165.622879 656.906067,167.488953 655.678162,166.288788 
	C653.766968,164.420792 656.989441,163.422607 657.241394,161.623199 
	C655.070068,160.917831 650.909912,164.289490 651.097412,158.122589 
	C651.525024,156.969284 651.908386,156.526871 652.452942,155.824188 
	C652.775208,155.425934 652.911255,155.268768 653.270142,154.886337 
	C654.977417,152.863251 656.863403,151.839005 659.538696,151.643188 
	C662.013489,151.138046 664.052551,149.437866 666.633301,151.231461 
	C667.624817,151.933212 668.267273,152.899811 669.497681,151.636734 
	C671.367676,150.141541 673.183716,149.046555 674.717896,147.150894 
	C678.884766,146.029709 680.008057,150.069565 680.968750,151.728241 
	C682.383728,154.171417 684.233337,154.907135 686.866943,156.239471 
	C688.553772,160.366333 684.495544,161.653473 683.244263,164.735443 
	C683.002441,165.001404 683.000000,165.000000 683.000183,165.000916 
	C682.232788,165.666336 681.171753,165.849213 680.218933,166.775299 
	C679.842773,170.225143 678.695679,171.008072 676.279358,168.449661 
	C675.724060,167.861740 675.427429,166.883728 674.776306,166.562469 
	C673.411682,165.889236 672.648254,163.288986 670.831360,164.550888 
	C669.712585,165.327866 668.112793,166.931580 668.580811,168.504929 
	C669.057495,170.107544 670.339783,171.528900 672.477661,171.704376 
	C674.556885,171.875031 674.545044,172.019073 673.137939,174.716400 
	C672.341553,175.078979 671.668274,175.083496 671.031982,175.239105 
	C669.664368,175.573517 669.435120,178.469803 667.653870,177.268906 
	C666.154480,176.258072 667.946533,175.013794 668.390503,173.872208 
	C669.157349,171.900162 667.359863,171.680206 666.267761,171.266296 
	C664.995056,170.783951 664.573792,171.431473 664.803589,172.806335 
	C665.194519,175.145218 663.189148,175.323944 661.352295,175.963959 
	C660.997559,176.001831 660.847961,175.847839 660.925171,175.923004 
	C661.000244,178.629776 660.097229,179.927582 657.589905,177.967560 
	C655.970703,176.701813 654.597229,175.121674 653.062622,173.345139 
	C653.011597,173.007843 653.000000,173.001526 653.003357,173.006317 
	C653.387268,172.626953 653.844727,172.476105 654.688477,172.778702 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M574.965088,167.334045 
	C578.612488,166.300095 580.332397,162.718872 583.553589,161.365936 
	C584.393677,161.013077 584.903748,160.016495 586.103699,160.278381 
	C588.286255,160.754684 582.952454,164.929947 588.742920,164.785080 
	C591.182861,164.724045 586.646301,168.149719 586.055054,170.686157 
	C586.607483,174.197784 583.620178,175.421265 582.218323,177.354385 
	C581.136597,178.846191 579.253906,178.069641 579.011230,175.379410 
	C576.843933,176.142715 573.952637,175.076340 572.072998,177.639557 
	C569.471741,178.357208 569.206665,174.721848 566.037903,174.868134 
	C564.084656,173.427124 562.235779,172.641235 561.866333,170.329697 
	C563.685242,168.969559 564.818420,167.492188 565.455261,165.622742 
	C563.082336,165.876694 562.914673,160.761765 559.590393,163.230576 
	C558.926025,163.723999 558.418030,163.264404 558.176697,162.527588 
	C557.588989,160.732986 559.471741,160.050339 559.936646,158.366608 
	C560.164856,157.884781 560.334656,157.742264 560.823669,157.691010 
	C561.821472,158.310089 562.172607,159.164993 563.240601,159.722275 
	C563.914368,160.034134 564.264404,160.268463 564.792114,160.787445 
	C566.672668,164.609192 570.536011,166.174255 572.720459,169.376083 
	C573.400452,170.372757 574.586304,168.838715 574.965088,167.334045 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M565.998779,174.999084 
	C565.485779,176.700256 565.364868,179.020935 562.739990,176.560471 
	C561.360291,175.267212 559.608154,174.374725 558.205566,173.101456 
	C556.377075,171.441559 556.843750,170.328735 559.639038,170.010712 
	C560.002441,170.000610 560.000000,170.000000 560.000000,169.999084 
	C561.738647,171.643860 563.844543,172.842255 565.769653,174.773102 
	C566.002441,175.001831 566.000000,175.000000 565.998779,174.999084 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M692.993591,178.638184 
	C691.131104,179.046494 690.086182,180.301987 689.137573,181.672928 
	C688.537170,182.540695 687.783997,183.329712 686.779114,182.523468 
	C685.723694,181.676697 686.672180,180.698517 687.101135,179.920959 
	C688.960022,176.551666 691.326294,175.924026 692.993591,178.638184 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M572.001221,177.999390 
	C572.166138,177.998810 572.331177,177.985291 572.493408,178.000900 
	C574.489807,178.192932 576.991821,177.264526 577.804993,180.183411 
	C578.098816,181.238342 577.480713,182.454819 576.518005,182.503021 
	C574.007568,182.628769 572.965820,180.665359 572.035767,178.347351 
	C571.997559,178.001221 572.000000,178.000000 572.001221,177.999390 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M638.632324,176.995728 
	C639.273987,177.576736 639.396057,178.379852 639.849854,178.677902 
	C640.664551,179.213013 641.835327,179.357498 641.038818,180.750366 
	C640.373169,181.914352 639.530090,181.828125 638.601074,181.071350 
	C636.969055,179.741913 634.640076,179.137604 634.025879,176.362244 
	C633.985352,176.016205 633.999939,176.000534 634.007324,175.992722 
	C635.430542,176.320023 636.846375,176.655136 638.632324,176.995728 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M731.000000,177.999695 
	C730.855591,178.780807 730.940063,179.729706 730.517273,180.307343 
	C729.740295,181.368896 728.554138,182.032516 727.150452,181.720779 
	C726.837097,181.651199 726.378845,180.968384 726.445923,180.671585 
	C726.730957,179.410812 727.926331,179.065689 728.925964,178.566437 
	C729.355042,178.352173 729.833618,178.237061 730.644836,178.038773 
	C731.000000,178.000610 731.000000,178.000000 731.000000,177.999695 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M692.998779,179.000717 
	C694.222534,179.370316 696.249207,178.095627 696.452087,180.408142 
	C696.507507,181.040253 695.340332,182.280640 694.610596,182.386078 
	C692.474243,182.694702 693.229797,180.831238 693.003052,179.364044 
	C693.002441,178.998535 693.000000,179.000000 692.998779,179.000717 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M677.001221,178.999084 
	C678.807251,179.077240 680.653076,179.073608 681.645203,181.386612 
	C679.454163,182.250320 678.120361,181.427750 677.052917,179.343307 
	C676.997559,179.001831 677.000000,179.000000 677.001221,178.999084 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M794.998779,170.998657 
	C795.207336,172.059937 795.417114,173.122574 795.718323,174.648148 
	C793.790100,174.088593 792.786194,173.074081 792.047974,171.323181 
	C792.687012,170.421463 793.460449,170.270569 794.659790,170.767090 
	C795.002441,171.002701 795.000000,171.000000 794.998779,170.998657 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M586.368286,178.992310 
	C586.128601,177.952682 585.743103,176.652176 587.236145,176.254181 
	C587.923523,176.070938 588.544861,176.357330 588.703613,177.064728 
	C589.067871,178.687454 587.921387,178.881744 586.368286,178.992310 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M741.001221,179.999390 
	C742.156433,180.238358 743.586975,179.416428 744.408630,180.854889 
	C744.503479,181.020996 744.320129,181.553772 744.138245,181.636642 
	C742.887451,182.206573 742.041870,181.532928 741.157227,180.299561 
	C741.000000,180.001221 741.000000,180.000000 741.001221,179.999390 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M811.690186,183.780182 
	C811.848511,185.316116 811.549805,186.780014 809.903931,186.523697 
	C808.888123,186.365494 809.472351,185.264542 809.883789,184.279572 
	C810.386780,183.620743 810.846863,183.474854 811.690186,183.780182 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M804.013184,184.481659 
	C804.888855,184.973969 804.987122,185.587677 804.581909,186.185028 
	C804.251648,186.671860 803.719727,186.668304 803.401978,186.169464 
	C803.015442,185.562683 803.121094,184.950516 804.013184,184.481659 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M769.000000,187.999695 
	C767.563416,187.838211 766.813965,187.239212 767.695435,185.766464 
	C767.904358,185.417465 768.363098,185.218002 768.706909,184.949768 
	C768.804626,185.745911 768.902344,186.542038 769.000000,187.669388 
	C769.000000,188.000610 769.000000,188.000000 769.000000,187.999695 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M591.522888,181.011597 
	C591.030457,181.889069 590.416016,181.987564 589.817932,181.581573 
	C589.330444,181.250732 589.334778,180.717819 589.833435,180.399368 
	C590.440857,180.011520 591.053650,180.117462 591.522888,181.011597 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M586.001221,179.001709 
	C585.911621,179.882401 586.232239,180.930084 585.203979,181.438293 
	C585.022400,181.528061 584.355286,181.105942 584.257935,180.807541 
	C583.962158,179.900192 584.522949,179.386276 585.668823,179.050476 
	C585.997559,178.996948 586.000000,179.000000 586.001221,179.001709 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M812.000000,183.749542 
	C811.555542,183.999649 811.111084,183.999283 810.333374,183.998474 
	C810.000977,183.251190 810.001892,182.504364 810.005127,181.384064 
	C810.390564,180.632889 810.848145,180.484863 811.690002,180.783173 
	C812.000000,180.999542 812.000000,181.000000 812.000000,181.000305 
	C812.374512,181.387238 812.520630,181.846527 812.220398,182.688324 
	C812.001648,183.165146 812.000793,183.332108 812.000000,183.749542 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M811.962158,180.696228 
	C811.557129,181.001328 811.114258,181.003128 810.339355,181.007767 
	C809.839417,181.008163 809.671570,181.005722 809.251831,181.001343 
	C809.814941,180.026596 810.389526,177.894974 811.962158,180.696228 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M838.007019,182.338852 
	C838.002808,182.017426 838.499207,182.015717 838.747375,182.019867 
	C839.151611,182.868439 840.453735,183.964706 839.037231,184.467331 
	C838.124023,184.791351 838.096252,183.446259 838.007019,182.338852 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M812.338135,182.998993 
	C812.001465,182.554276 812.000427,182.110367 811.999695,181.333542 
	C812.906616,181.075333 813.688660,181.326416 813.968750,182.675354 
	C813.569275,182.995865 813.121521,182.997833 812.338135,182.998993 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M833.856018,187.780411 
	C833.573975,188.688629 833.049255,189.011139 832.146240,188.221146 
	C832.427734,187.311630 832.951721,186.986786 833.856018,187.780411 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M835.754272,184.360245 
	C835.992554,184.374771 836.122498,184.503860 836.252380,184.632965 
	C836.050232,184.580246 835.848022,184.527527 835.754272,184.360245 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M638.999634,176.999390 
	C639.090210,176.963776 639.181152,176.928772 639.137207,176.947495 
	C639.002441,177.001221 639.000000,177.000000 638.999634,176.999390 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M649.271912,255.830597 
	C652.929871,258.224091 655.267944,260.766388 653.503113,265.257141 
	C653.017883,266.491699 654.111023,267.339142 654.840759,268.583130 
	C651.638184,270.377716 649.298157,267.904694 646.853821,266.603455 
	C641.143005,263.563263 635.811096,259.856537 630.094421,256.780975 
	C627.111877,255.176315 623.326843,256.143768 621.160034,253.248383 
	C618.436829,253.016937 615.372253,252.842453 612.328369,253.021240 
	C610.413696,253.133698 609.613708,252.581726 609.739136,250.343567 
	C609.988098,249.216263 610.529236,248.760025 611.387817,248.531982 
	C612.567444,248.218689 614.928040,249.894379 614.763672,247.527832 
	C614.565918,244.682205 612.245850,247.379547 610.658691,246.821869 
	C609.378906,246.231125 609.282654,245.358994 609.824829,243.988190 
	C610.092346,243.602112 610.166199,243.491287 610.131470,243.434448 
	C609.938782,243.064102 609.780518,242.750641 609.840088,241.957489 
	C610.057617,241.477859 610.027344,241.495834 610.035645,241.487335 
	C608.975464,239.725357 610.524902,239.741730 611.887939,239.261230 
	C614.433533,239.382736 616.567505,239.638428 619.110229,239.638351 
	C630.731506,242.398514 640.357056,248.163452 649.271912,255.830597 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M613.100525,240.256149 
	C612.091125,240.701248 611.321228,240.929886 610.297668,241.318695 
	C606.990601,242.292633 608.633911,239.845535 608.309692,238.409073 
	C609.308289,238.136490 610.205505,238.289703 611.556763,238.348801 
	C612.439758,238.338898 612.824219,238.516266 613.282104,239.099487 
	C613.384644,239.611588 613.362305,239.825638 613.100525,240.256149 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M587.716797,219.785156 
	C586.281128,219.519760 585.830566,218.836044 586.471558,217.796707 
	C586.619385,217.557129 587.363220,217.423523 587.649170,217.578934 
	C588.582825,218.086273 589.048462,218.813889 587.716797,219.785156 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M609.691528,243.293121 
	C610.085876,244.423019 610.079468,245.243942 610.191040,246.457428 
	C609.833313,246.901672 609.357483,246.953354 608.524536,247.039963 
	C608.011292,245.565598 607.144714,243.861221 609.691528,243.293121 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M569.000000,217.000305 
	C569.878479,217.092911 570.925598,216.769287 571.438232,217.793182 
	C571.528076,217.972610 571.106323,218.641342 570.808411,218.738281 
	C569.902222,219.033066 569.386169,218.475754 569.052429,217.328278 
	C569.000000,216.999390 569.000000,217.000000 569.000000,217.000305 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M550.207825,219.216904 
	C551.218445,219.277618 551.768494,219.627808 551.345093,220.389206 
	C551.193420,220.662018 550.436768,220.844589 550.091553,220.713089 
	C549.340942,220.427200 549.267944,219.848099 550.207825,219.216904 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M576.409912,219.954956 
	C576.803528,219.232605 577.200745,219.225861 577.552429,219.738983 
	C577.626160,219.846542 577.623840,220.096146 577.547607,220.201187 
	C577.182495,220.704102 576.785583,220.686005 576.409912,219.954956 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M547.381592,246.454941 
	C546.587769,246.680084 546.302673,246.400696 546.423706,245.785995 
	C546.448914,245.657959 546.629700,245.485214 546.758789,245.465759 
	C547.380737,245.371918 547.640991,245.674652 547.381592,246.454941 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M556.544312,244.381805 
	C556.318970,243.587311 556.598267,243.301575 557.213806,243.422821 
	C557.341919,243.448044 557.514709,243.629105 557.534241,243.758362 
	C557.628296,244.380905 557.325439,244.641617 556.544312,244.381805 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M609.512451,241.472931 
	C610.062195,241.794113 610.066833,242.110367 610.084106,242.902130 
	C608.314392,243.572708 608.352173,242.691086 609.512451,241.472931 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M552.032104,147.390472 
	C553.492737,146.938034 554.051392,146.079071 553.995972,144.346313 
	C554.745605,143.990997 555.500122,143.991028 556.631958,143.991165 
	C556.869324,145.948486 554.360046,146.992432 554.988525,149.618286 
	C553.419373,150.025574 551.978027,149.884384 552.032104,147.390472 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M565.964478,174.665726 
	C563.320557,174.531006 561.774597,172.512604 560.049988,170.333862 
	C560.443054,170.000259 560.886047,170.002350 561.661255,170.005096 
	C562.636230,172.054871 565.619080,171.975449 565.964478,174.665726 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M550.674316,158.830170 
	C550.878662,160.582184 552.604553,161.050369 552.950500,162.674561 
	C553.000000,162.999390 553.000000,163.000000 553.000000,163.000305 
	C550.708435,163.140839 548.655762,162.981705 549.001038,159.416931 
	C549.377747,158.630966 549.833984,158.494003 550.674316,158.830170 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M557.630005,149.999390 
	C557.995117,150.747314 557.985352,151.498535 557.987793,152.625183 
	C556.429810,153.011917 554.941345,152.914566 555.008057,150.378494 
	C555.756592,150.005783 556.505920,150.004227 557.630005,149.999390 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M551.217651,158.845520 
	C550.541504,159.036560 550.100525,159.022995 549.328613,159.015289 
	C549.228516,158.028091 548.544800,156.378174 550.360718,156.459396 
	C551.425537,156.507004 551.996704,157.452042 551.217651,158.845520 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M561.200439,158.244263 
	C560.982788,158.046753 560.489136,158.031387 560.242188,158.029343 
	C559.994446,157.576096 559.993713,157.124878 559.996521,156.335495 
	C561.153503,156.018494 562.414062,155.806503 562.723755,157.867798 
	C562.185303,158.546371 561.803101,158.555206 561.200439,158.244263 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M558.034180,153.323624 
	C558.890869,153.091736 559.683167,153.322952 559.950317,154.670563 
	C559.076904,154.934998 558.264648,154.733780 558.034180,153.323624 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M344.424683,864.916809 
	C346.194214,865.958130 344.433411,866.000916 344.128784,866.782104 
	C344.321564,867.469360 344.641113,867.936340 344.973145,868.977783 
	C344.967041,870.110962 344.922211,870.665405 344.357056,871.605103 
	C343.528809,872.019043 343.067444,872.023376 342.260437,872.044495 
	C340.527130,872.952271 338.743866,873.036560 337.502014,874.223816 
	C335.754944,875.894043 333.967438,875.871826 332.281311,874.205200 
	C330.905182,872.845032 329.611694,872.641113 328.514679,874.331726 
	C330.499786,878.267273 334.695740,874.732422 337.792419,876.710083 
	C337.061676,877.959839 336.142212,878.931519 336.990143,880.720032 
	C337.614685,885.619751 333.809814,884.839600 332.202087,883.912048 
	C329.102814,882.124023 326.791046,884.011169 325.790710,885.523010 
	C323.904236,888.373962 321.399750,888.160522 318.841461,888.892578 
	C319.432129,886.070374 323.328400,888.536621 323.237610,885.205688 
	C322.321716,883.490845 324.155151,883.398315 324.456543,882.439392 
	C323.505371,882.775452 322.836212,883.360291 322.846985,884.704529 
	C322.085236,886.230713 320.830292,886.284912 320.192810,885.058044 
	C317.812042,880.476013 314.079803,878.424377 309.024445,878.176758 
	C308.023651,878.127747 308.103149,876.585571 307.985535,875.260620 
	C317.522034,872.252869 327.082825,869.592651 336.970978,866.769653 
	C339.547150,866.054321 341.795990,865.501831 344.424683,864.916809 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M297.021118,877.529175 
	C298.118073,876.861328 299.196350,876.574097 300.609009,876.283142 
	C300.965668,876.776611 301.030121,877.276245 301.002960,877.770813 
	C300.870209,880.189331 300.951691,883.799011 298.089935,883.554199 
	C294.245972,883.225464 297.788391,879.797913 297.021118,877.529175 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M300.546387,889.901611 
	C298.445984,891.174866 295.867706,895.790649 294.373413,889.581604 
	C294.035889,888.179260 294.635986,886.894592 295.932190,886.335388 
	C297.491455,885.662842 297.805145,887.037415 298.184235,888.120789 
	C298.555542,889.181519 299.350311,889.622192 300.546387,889.901611 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M310.832336,884.269165 
	C315.163300,887.040955 309.755646,887.798096 309.905975,888.728394 
	C310.499481,888.160706 308.128571,885.859253 310.832336,884.269165 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M305.006989,884.372559 
	C306.012787,884.191101 307.384552,883.606445 307.756317,885.217468 
	C307.913727,885.899658 307.735626,886.560486 306.979492,886.718445 
	C305.380829,887.052490 305.062592,886.006348 305.006989,884.372559 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M305.002808,883.998169 
	C303.263245,882.577454 304.254974,880.597473 304.009583,878.410400 
	C306.722961,879.298584 304.184479,881.567627 304.992798,883.628906 
	C304.993805,884.006104 304.999939,884.000000 305.002808,883.998169 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M296.126709,895.629211 
	C295.736725,892.643372 297.798920,894.540894 299.087463,893.991028 
	C298.535370,895.510681 297.180695,895.061035 296.126709,895.629211 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M287.976746,885.976562 
	C288.185760,884.777405 287.488922,883.336609 289.040192,882.359985 
	C290.333496,883.728516 288.979431,884.624451 288.290527,885.828857 
	C288.036835,886.024780 287.995636,885.994019 287.976746,885.976562 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M302.867828,876.479797 
	C303.141083,876.153992 303.301666,876.069641 303.733337,876.009033 
	C304.011597,876.457092 304.018829,876.881409 304.044434,877.622070 
	C304.062836,877.938477 303.998901,878.006714 303.969482,878.045044 
	C303.398743,878.167053 302.857422,878.250732 302.316040,878.334412 
	C302.462402,877.796692 302.608795,877.258972 302.867828,876.479797 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M280.312469,892.977478 
	C280.746368,891.722961 282.039825,891.904785 283.615112,891.802246 
	C283.258789,893.183044 281.940887,892.999146 280.312469,892.977478 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M278.062347,894.108704 
	C278.382904,893.561035 278.873566,893.267212 279.658875,892.942688 
	C279.852020,893.955750 279.890045,895.164978 278.062347,894.108704 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M292.642487,896.107910 
	C292.365570,895.837891 292.252075,895.436035 292.195129,895.026367 
	C292.185547,894.957275 292.419861,894.854187 292.541504,894.766846 
	C292.635925,895.169006 292.730408,895.571228 292.642487,896.107910 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M292.001770,880.001831 
	C291.893768,880.538696 292.062317,881.265747 291.237244,881.336182 
	C291.054047,881.351807 290.839508,881.000610 290.639404,880.818359 
	C290.918945,880.557739 291.198547,880.297180 291.737305,880.016602 
	C291.996490,879.996582 292.000000,880.000000 292.001770,880.001831 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M292.710419,892.352234 
	C292.947174,892.365906 293.077759,892.497314 293.208344,892.628784 
	C293.006958,892.575867 292.805573,892.522949 292.710419,892.352234 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M262.620239,907.886841 
	C262.587158,908.572388 261.989624,908.891418 260.836914,908.860596 
	C261.071259,908.523743 261.673889,908.213074 262.620239,907.886841 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M300.431427,885.535828 
	C300.387543,885.471924 300.475311,885.599731 300.431427,885.535828 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M311.000610,884.000000 
	C310.873322,883.849060 310.745392,883.698120 310.617462,883.547241 
	C310.709839,883.598999 310.802246,883.650818 310.946777,883.851318 
	C310.998932,884.000000 311.000000,884.000000 311.000610,884.000000 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M291.474701,883.448853 
	C291.538452,883.411133 291.410950,883.486511 291.474701,883.448853 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M301.534668,887.551270 
	C301.472961,887.589905 301.596405,887.512634 301.534668,887.551270 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M302.455750,881.420410 
	C302.527527,881.372253 302.551300,881.564392 302.551300,881.564392 
	C302.551300,881.564392 302.384003,881.468506 302.455750,881.420410 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M286.090576,407.299255 
	C287.682983,409.355286 290.650085,406.865479 292.539001,409.010956 
	C292.816772,409.259186 292.811371,409.518433 292.841553,409.644531 
	C292.602905,410.351501 292.504883,410.991272 291.964905,411.721619 
	C291.316010,411.853088 290.951508,411.839691 290.313293,411.833862 
	C289.178711,410.793304 288.001831,410.911499 286.492065,411.021759 
	C286.075378,409.944519 286.006531,408.820129 286.090576,407.299255 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M293.839172,442.588745 
	C292.777374,442.994171 291.848663,442.634308 291.270721,441.764984 
	C290.548950,440.679260 288.117462,441.471588 288.471527,439.643646 
	C288.822266,437.833008 290.762634,438.187927 292.566040,438.046814 
	C293.240173,439.444733 293.540741,440.838593 293.839172,442.588745 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M292.869446,435.615356 
	C291.328613,435.538788 289.641968,436.989227 288.093323,435.376892 
	C289.651001,435.390930 291.357422,432.696686 292.869446,435.615356 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M292.656006,432.025665 
	C291.829498,433.129089 290.920013,432.830963 290.583618,432.844696 
	C291.237183,433.250519 291.021515,429.675446 292.656006,432.025665 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M292.010040,411.765503 
	C291.945282,411.321930 292.210052,410.777313 292.673248,410.001648 
	C292.694305,410.401917 292.516937,411.033203 292.010040,411.765503 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M306.139648,424.079010 
	C305.969788,423.480286 305.966888,423.130920 305.958984,422.519592 
	C306.061707,422.050964 306.169434,421.844360 306.568390,421.446198 
	C309.162201,420.251892 311.868652,421.711792 314.360901,419.901550 
	C314.868469,419.654938 315.082092,419.579498 315.632996,419.471893 
	C317.084198,419.523651 318.158630,419.795044 319.521423,420.248718 
	C320.382294,420.683594 320.889618,421.075317 321.723724,421.533508 
	C322.630005,421.865662 323.226013,422.115265 324.037903,422.658691 
	C324.495514,423.280731 324.587219,423.708801 324.473877,424.478271 
	C323.184967,426.113953 321.857971,424.821747 320.280579,424.998535 
	C318.724182,425.013336 317.498566,425.031464 315.906067,425.028076 
	C314.095551,424.884674 312.906616,425.487396 311.555542,426.556824 
	C310.799927,426.853668 310.287689,426.915070 309.388611,426.992767 
	C308.799286,427.154297 308.596832,427.299561 308.178345,427.139771 
	C307.821991,426.526581 307.607147,426.284576 307.095184,426.004700 
	C306.424866,425.469818 308.225952,424.229553 306.139648,424.079010 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M320.157104,425.182312 
	C320.887146,423.523071 322.055756,424.051178 323.539612,424.664368 
	C324.628387,424.267029 325.437531,424.160919 326.613037,424.757324 
	C326.867279,425.431152 326.795074,425.835205 326.801971,426.538574 
	C326.881073,426.837921 326.910095,426.901093 326.930054,426.929565 
	C325.523743,428.521851 323.944672,429.759644 321.318176,429.236084 
	C320.510193,428.372162 318.430389,427.995575 320.848541,426.921478 
	C322.343781,426.257324 320.659576,425.869232 320.157104,425.182312 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M307.595154,426.961121 
	C308.135925,426.861542 308.309509,426.888336 308.742432,426.962097 
	C306.101440,429.540009 302.722168,430.865753 298.471985,430.993927 
	C300.492096,428.185699 304.038025,428.058258 307.595154,426.961121 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M321.025909,429.298584 
	C323.414764,429.786102 324.088684,426.606232 326.583954,426.836853 
	C327.166718,431.062439 324.076233,429.776886 321.529358,430.076416 
	C321.101562,429.935150 321.078003,429.753510 321.025909,429.298584 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M311.661865,426.803864 
	C311.184326,423.860199 312.694153,423.626953 315.236084,424.800842 
	C314.890381,426.637299 313.529236,426.878967 311.661865,426.803864 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M315.953308,429.419250 
	C314.517120,430.021301 313.444214,430.082397 312.614502,428.553864 
	C313.926666,427.571960 315.302032,427.948334 316.663879,428.272339 
	C316.750214,428.292877 316.879395,428.517212 316.859161,428.542328 
	C316.659546,428.789917 316.432495,429.015381 315.953308,429.419250 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M318.879700,432.783325 
	C317.982117,433.032959 317.234497,432.779022 316.986298,431.467773 
	C319.006866,429.385651 318.750336,431.234497 318.879700,432.783325 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M264.132202,680.489014 
	C267.556580,680.926086 265.118011,683.123169 264.640747,683.780151 
	C263.963928,684.711792 263.669708,687.966553 261.044586,685.269775 
	C262.044617,684.519775 262.770691,683.803467 263.019043,682.341431 
	C263.370880,681.602722 263.718658,681.187134 264.132202,680.489014 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M259.278717,685.195801 
	C258.529816,684.698608 258.041321,684.398743 257.253937,684.100220 
	C256.659271,683.628296 256.363495,683.154968 256.100586,682.274536 
	C258.143768,681.871643 259.956238,682.266663 260.992340,684.650146 
	C261.045654,684.999939 260.582458,685.061768 260.349121,685.073792 
	C259.923553,685.188171 259.731354,685.290588 259.278717,685.195801 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M263.008942,682.011963 
	C261.721680,681.878113 260.701019,681.475586 261.221985,679.857117 
	C261.424194,679.228943 262.059204,678.484375 262.545227,679.001343 
	C262.993652,679.478333 262.826630,680.533936 262.976898,681.676514 
	C263.023102,682.018372 263.000000,682.000000 263.008942,682.011963 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M255.921875,682.087891 
	C254.964600,682.012268 253.906784,682.245789 253.404495,681.202148 
	C253.318893,681.024170 253.503067,680.546509 253.695801,680.432678 
	C254.726013,679.823792 255.458664,680.224792 256.040894,681.549316 
	C256.133453,681.867371 255.990875,682.012939 255.921875,682.087891 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M274.666656,680.988037 
	C274.637573,683.021179 274.063965,684.870850 271.829987,685.773621 
	C270.480316,684.272888 272.364990,683.139771 272.311646,681.540161 
	C272.406219,681.206482 272.706757,681.123474 272.854370,681.073486 
	C273.382141,680.955444 273.762268,680.887268 274.666656,680.988037 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M270.072388,680.858398 
	C270.052979,681.575623 269.797577,682.141724 269.272125,682.861938 
	C268.990784,682.141846 268.457611,681.079102 270.072388,680.858398 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M266.992249,674.264893 
	C267.301392,673.993042 267.537781,674.010864 268.090942,674.195618 
	C268.193085,674.747070 267.978424,675.131653 267.763763,675.516174 
	C267.482361,675.195618 267.200928,674.875122 266.992249,674.264893 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M259.033081,685.211792 
	C259.201294,685.007935 259.384277,685.017334 259.841553,685.056274 
	C259.961853,685.336182 259.760345,685.539429 259.312317,685.771484 
	C259.113342,685.847473 259.047913,685.424988 259.033081,685.211792 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M268.975189,689.974854 
	C269.111633,689.064941 268.752747,687.975647 269.844604,687.458923 
	C270.010315,687.380493 270.515900,687.601929 270.570282,687.776306 
	C270.855713,688.692200 270.204437,689.230469 269.342041,689.911621 
	C269.057343,690.045105 269.001678,689.999268 268.975189,689.974854 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M274.836884,680.856689 
	C274.963928,680.380188 275.209045,680.003601 275.454163,679.627014 
	C275.486908,680.028625 275.519684,680.430176 275.371674,680.994385 
	C275.190887,681.156921 274.954987,680.956665 274.836884,680.856689 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M457.418335,502.220612 
	C457.024048,501.677368 456.965973,501.263214 456.948608,500.539001 
	C456.108765,498.558685 457.193390,497.828857 458.718079,497.068695 
	C459.165558,496.784332 459.343079,496.611725 459.757416,496.725189 
	C460.187195,497.029816 460.380096,497.048370 460.861053,497.106018 
	C460.453400,499.164215 459.317444,500.896179 457.418335,502.220612 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M465.677582,492.052979 
	C465.480713,492.564575 464.903168,493.051971 464.159485,493.773254 
	C463.561768,494.310425 463.130188,494.613708 462.439697,494.996155 
	C460.497620,491.275665 463.554718,492.324768 465.677582,492.052979 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M461.386475,497.044189 
	C461.096100,496.793121 461.205353,496.494720 461.674500,496.117004 
	C461.797333,496.300903 461.714600,496.620575 461.386475,497.044189 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M323.977844,331.480072 
	C321.280487,333.054230 318.307220,333.129913 314.802185,332.961426 
	C316.543335,334.713959 318.485565,333.313202 320.458771,334.872620 
	C315.955627,334.872620 312.060516,334.872620 308.165436,334.872620 
	C308.167633,335.155609 308.169861,335.438629 308.172089,335.721619 
	C314.919586,335.721619 321.667084,335.721619 328.414612,335.721619 
	C328.424072,336.269318 328.433563,336.816986 328.443054,337.364685 
	C320.822876,337.364685 313.202667,337.364685 305.298462,337.668091 
	C301.669800,337.105530 306.417297,334.156677 303.763855,333.112793 
	C305.647430,331.556122 303.293488,329.349152 304.643097,327.390228 
	C304.692139,327.077454 305.164124,326.991364 305.403687,326.978699 
	C306.523865,327.614044 307.585724,327.452484 308.905731,327.809082 
	C309.469727,328.063324 309.662323,328.189972 309.905670,328.526306 
	C310.457489,329.537506 311.277496,329.503998 312.362610,329.504089 
	C312.825562,329.517792 313.007172,329.538727 313.559814,329.404480 
	C317.892029,326.512878 320.934875,328.598450 323.977844,331.480072 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M329.524658,368.360596 
	C324.936768,370.051483 320.564514,367.102356 316.156616,368.646942 
	C315.169342,368.992859 314.683807,368.086792 314.430756,367.295349 
	C314.119965,366.323181 314.798706,365.697113 315.540283,365.358521 
	C317.107758,364.642761 318.926178,364.520447 320.364319,365.244568 
	C322.513245,366.326599 324.099518,365.428741 326.001343,364.506653 
	C324.082245,363.680328 322.003418,364.791290 320.072998,363.350098 
	C323.411926,361.424103 326.837097,362.146057 330.181580,362.244995 
	C330.908539,362.266479 331.491058,362.583130 331.633453,363.303131 
	C331.771240,363.999817 331.486694,364.748871 330.727478,364.790039 
	C327.306305,364.975708 329.765320,366.880737 329.524658,368.360596 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M304.625244,384.864136 
	C304.165192,383.945679 304.335144,383.278534 305.408234,383.070465 
	C306.836212,382.793610 307.306305,381.554596 307.029297,380.446533 
	C306.594757,378.708160 305.037323,379.144409 303.354309,379.172180 
	C302.639404,378.661102 302.508118,378.220123 302.813538,377.446228 
	C308.561066,376.194702 313.829071,378.841949 319.688080,378.419800 
	C320.030273,378.856140 319.996704,379.126526 319.925415,379.803833 
	C318.363159,381.565735 316.461334,381.962494 314.244446,382.105316 
	C313.946594,381.895203 313.605072,381.670288 313.400665,381.666138 
	C312.468048,381.629883 311.946991,382.007660 311.276306,382.774902 
	C310.524902,383.313629 309.992065,383.599304 309.209045,384.065735 
	C308.776672,384.349182 308.594543,384.451843 308.174500,384.758911 
	C306.955261,384.936707 305.973907,384.910095 304.625244,384.864136 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M302.684875,377.016602 
	C303.035309,377.587952 303.018677,378.003540 302.985535,378.731079 
	C300.959808,378.290558 298.360382,382.951721 296.703766,378.249847 
	C295.817139,375.733337 299.193298,375.206055 298.472137,372.628052 
	C298.335876,371.613739 298.451721,371.021515 298.786804,370.216949 
	C299.393799,369.507233 299.734344,368.957794 300.672058,368.893311 
	C302.214813,371.503632 299.713684,374.625946 302.684875,377.016602 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M300.302856,347.243958 
	C299.906128,345.641998 299.821136,344.021698 299.526184,342.064941 
	C299.068695,341.609924 298.821167,341.491394 298.872498,341.089722 
	C299.263428,340.488220 299.310364,340.163361 299.322144,339.591064 
	C299.332123,339.350098 299.320190,339.195923 299.287445,339.125885 
	C299.306946,338.861786 299.359222,338.667694 299.294678,338.195679 
	C299.177795,337.917725 299.189484,337.854401 299.175293,337.825531 
	C298.937195,337.671204 298.713348,337.545776 298.843689,337.269684 
	C300.399231,334.056946 299.629272,330.821411 300.141754,327.647614 
	C300.680511,334.119690 302.331055,340.471222 301.546051,347.009369 
	C301.533142,347.117188 300.938019,347.155090 300.302856,347.243958 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M301.014893,368.616028 
	C300.477234,369.292358 299.997040,369.550140 299.261475,369.906281 
	C297.297028,365.508423 298.321472,361.268311 300.598511,357.064819 
	C301.985901,360.738068 301.100220,364.471191 301.014893,368.616028 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M318.647949,353.778015 
	C321.386169,354.083984 323.807007,354.428131 326.619751,354.861176 
	C327.116547,355.253052 327.221466,355.556030 327.065460,356.263031 
	C323.897217,356.437622 320.988708,356.221741 318.083130,355.971558 
	C317.039978,355.881714 315.270935,356.481903 315.281128,354.990204 
	C315.294037,353.101379 317.113953,353.773346 318.647949,353.778015 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M330.164795,359.721069 
	C326.215668,360.906860 322.454010,360.809357 318.283752,359.770020 
	C322.000000,356.671936 325.710663,359.511688 329.577057,358.970245 
	C330.101593,359.208862 330.213104,359.353607 330.164795,359.721069 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M309.936646,338.348541 
	C313.497742,338.163147 317.228638,337.125305 320.787262,339.696960 
	C317.549591,339.876282 314.086243,339.744873 310.313477,339.355927 
	C309.993927,338.931213 309.983734,338.764099 309.936646,338.348541 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M330.240112,360.137512 
	C330.005005,359.943726 330.007843,359.503693 329.998962,359.283936 
	C331.677460,357.082764 330.354156,356.949921 328.728485,357.019592 
	C328.162109,357.043915 327.597443,357.107208 326.918274,356.909851 
	C326.846161,356.381775 326.887726,356.096527 326.970459,355.380676 
	C327.179688,354.945251 327.347748,354.940430 327.768005,354.943420 
	C330.092529,355.228882 332.164856,355.506531 334.627441,355.731964 
	C335.098969,355.944641 335.180206,356.209473 335.139038,356.871613 
	C331.537720,355.375671 332.889099,360.645355 330.240112,360.137512 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M302.916443,367.313080 
	C305.969727,364.294861 308.949585,364.777863 312.421600,366.770355 
	C309.658569,369.210541 306.621643,367.220123 303.586792,367.927429 
	C303.000061,367.726105 302.851318,367.611328 302.916443,367.313080 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M300.466705,352.116272 
	C300.255707,351.449524 300.240479,351.051971 300.195679,350.357300 
	C300.480896,349.664948 300.893066,349.511475 301.692932,349.752045 
	C303.835052,349.296326 305.640869,348.367126 307.877594,349.594910 
	C308.130249,350.593781 307.974335,351.241089 307.382904,352.086121 
	C305.483704,353.399567 303.677002,352.511566 301.612610,352.663635 
	C301.074829,352.549652 300.868652,352.467560 300.466705,352.116272 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M322.114685,374.856018 
	C322.902191,370.716919 324.572052,370.734619 326.979553,374.208130 
	C325.542297,375.533112 323.894440,374.866302 322.114685,374.856018 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M310.485901,351.836121 
	C310.431244,354.250122 312.606323,353.636658 313.646545,354.425140 
	C311.892120,356.764252 309.626923,354.431183 307.394592,355.050171 
	C306.881683,354.780273 306.729889,354.631897 306.514648,354.171356 
	C306.521301,353.186340 306.931885,352.708252 307.570831,352.002045 
	C308.572540,351.351929 309.390717,351.426941 310.485901,351.836121 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M306.786560,353.679688 
	C306.985168,353.999329 307.010437,354.464142 307.021973,354.696411 
	C305.386017,354.997833 303.738525,355.067017 301.682312,355.183838 
	C301.039825,355.292572 300.806061,355.353668 300.268005,355.217896 
	C300.002777,354.223267 300.041840,353.425476 300.175934,352.237366 
	C300.270966,351.847076 300.616638,351.880066 300.782135,351.932434 
	C302.788574,352.603821 304.975037,351.805634 306.786560,353.679688 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M309.717712,361.084045 
	C307.805511,363.233551 306.652435,360.885742 304.113892,360.664307 
	C306.647705,359.953217 308.172699,359.783905 309.717712,361.084045 
z"/>
<path fill="#E0CEF7" opacity="1.000000" stroke="none" 
	d="
M310.946594,351.622192 
	C309.984711,352.340759 309.211639,352.686890 308.127075,352.115387 
	C307.649170,352.173828 307.424683,352.262024 307.120361,351.997375 
	C307.245392,351.163300 307.450195,350.682159 307.876068,350.049957 
	C309.343445,349.827606 310.977600,348.887115 310.946594,351.622192 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M294.798248,361.883301 
	C296.196472,363.035980 296.749725,364.801575 295.082092,365.329285 
	C293.686127,365.770966 294.268188,363.698303 293.938110,362.377808 
	C294.111572,361.988007 294.308838,361.964752 294.798248,361.883301 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M294.984741,357.228516 
	C296.286621,358.009888 296.258270,359.295746 295.307281,360.925049 
	C294.282806,359.982452 294.562958,358.764862 294.984741,357.228516 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M301.806976,349.700867 
	C301.588745,349.954376 301.181152,349.971924 300.469849,350.024841 
	C300.103210,349.847229 300.040283,349.634216 299.987000,349.086853 
	C300.536957,348.989960 301.077301,349.227448 301.806976,349.700867 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M298.927612,337.097198 
	C299.197876,337.119019 299.191101,337.460693 299.176086,337.628662 
	C298.685669,337.794403 298.064514,338.188324 297.912506,337.358704 
	C297.903809,337.311371 298.397491,337.171936 298.927612,337.097198 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M324.098114,378.714233 
	C323.935455,378.893158 323.634552,378.889404 322.885437,378.815796 
	C322.916565,378.474304 323.235870,377.065613 324.098114,378.714233 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M302.922577,367.153442 
	C303.130280,367.129578 303.117004,367.486237 303.132874,367.663574 
	C302.819244,367.740601 302.168823,367.850098 302.922577,367.153442 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M299.162415,338.204590 
	C299.313965,338.227448 299.450134,338.537170 299.420471,338.951355 
	C299.218811,338.867706 299.182922,338.679596 299.162415,338.204590 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M300.067810,355.267944 
	C300.183441,355.042419 300.403198,355.063782 300.948303,355.158325 
	C301.273590,355.231476 301.144775,355.670532 301.093323,355.894409 
	C300.751892,355.917114 300.461914,355.715973 300.067810,355.267944 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M299.897339,406.201996 
	C297.534485,403.111603 299.450867,399.598022 298.460449,396.883545 
	C297.217957,393.478180 299.817261,395.550171 300.718750,394.888489 
	C303.306458,395.474426 299.863251,397.714691 302.051910,398.347260 
	C300.264069,401.361053 302.735626,400.752075 304.614655,400.924805 
	C305.384979,400.960052 305.796906,401.047211 306.497437,401.282104 
	C309.109192,401.915009 310.170654,403.162354 309.197052,405.894531 
	C309.180878,406.548798 309.197632,406.886444 309.232697,407.477020 
	C309.108368,407.943817 308.965729,408.157684 308.472046,408.531311 
	C305.324890,408.489777 302.809967,407.323364 299.897339,406.201996 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M334.591553,397.067139 
	C334.370880,397.660583 333.838440,398.119995 333.135437,398.787476 
	C332.964813,398.995544 332.521454,399.025177 332.309082,399.090424 
	C331.063141,400.191345 329.895874,400.074982 328.383759,399.333313 
	C327.647217,399.368713 327.208282,399.622925 326.393188,399.933350 
	C322.494415,398.904907 318.950623,397.934296 314.800568,397.972107 
	C312.905884,397.846039 311.379089,397.629883 310.380188,396.482025 
	C309.142944,395.060425 309.184631,393.827881 311.887268,393.634766 
	C317.511871,394.281952 322.704315,394.849762 328.307983,395.546387 
	C329.792419,397.350403 331.242615,395.451660 332.809326,396.093719 
	C333.553925,396.391724 333.916840,396.662415 334.591553,397.067139 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M312.039368,393.453796 
	C311.622650,394.025421 310.264374,394.045410 310.638733,395.046692 
	C311.216980,396.593475 313.133820,396.280060 314.738434,397.025574 
	C315.397247,397.484314 315.514069,397.927277 315.232544,398.707825 
	C313.258148,398.989471 311.496918,398.982422 309.334167,399.175323 
	C306.967560,399.375824 307.490326,396.360809 304.976135,396.413483 
	C303.431915,396.445862 304.946381,394.638550 305.005554,393.652161 
	C305.109375,391.921173 306.396179,391.973785 307.494476,392.129669 
	C308.937347,392.334381 310.339600,392.825500 312.039368,393.453796 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M309.545105,406.107910 
	C308.332886,404.848114 309.380737,402.348297 306.374023,402.027802 
	C305.847870,401.356232 306.000305,400.889465 306.928375,400.570496 
	C307.697174,400.566498 308.055389,400.533203 308.684021,400.507568 
	C310.740173,401.680695 313.342804,399.982178 314.830811,402.191406 
	C310.930969,403.604736 315.353027,404.337372 315.190277,405.504456 
	C313.454712,406.394989 311.648163,405.803802 309.545105,406.107910 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M301.400970,394.125122 
	C299.586853,393.953461 297.100098,394.650543 298.868134,391.426239 
	C299.435211,390.392090 298.759949,388.676666 298.884491,387.026764 
	C303.594574,387.900238 301.046234,391.522034 301.400970,394.125122 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M314.180267,382.181824 
	C315.710327,381.389587 317.034821,379.539215 319.531555,380.198975 
	C319.971069,380.588501 320.054413,380.966217 320.143250,381.634949 
	C318.312256,382.900665 316.440582,383.503540 314.180267,382.181824 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M299.484131,385.201172 
	C297.771545,384.266724 298.233398,383.247925 299.331238,382.565125 
	C301.288513,381.347748 301.762268,383.234192 302.709930,384.620422 
	C301.842590,384.984039 300.847412,385.051331 299.484131,385.201172 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M318.755310,389.001068 
	C320.401093,388.958252 321.705963,388.958252 323.010803,388.958252 
	C321.302277,389.795746 319.773285,392.524170 317.845673,389.681519 
	C317.798828,389.612457 317.900177,389.389893 317.990753,389.294189 
	C318.099091,389.179688 318.270355,389.124664 318.755310,389.001068 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M333.037842,395.888214 
	C331.720093,397.050446 330.191833,397.169159 328.661591,396.060455 
	C330.108551,395.847717 331.489441,394.248138 333.037842,395.888214 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M311.393890,382.992126 
	C311.289612,381.906586 310.135254,379.367371 313.145630,381.349121 
	C312.707520,382.093445 312.218781,382.524902 311.393890,382.992126 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M306.680908,388.962555 
	C305.591858,388.948242 304.832550,388.904083 303.570801,388.830719 
	C305.100220,387.852142 306.187408,387.883057 307.305695,388.352570 
	C307.361023,388.375824 307.408722,388.579498 307.369629,388.632477 
	C307.279602,388.754425 307.133820,388.835236 306.680908,388.962555 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M311.549103,390.493103 
	C310.525726,390.543427 309.961060,390.086914 310.254364,389.453461 
	C310.404236,389.129730 311.431732,388.931305 311.912231,389.101288 
	C312.856659,389.435364 312.307190,389.973785 311.549103,390.493103 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M326.005981,391.697510 
	C325.056152,391.096771 324.558014,390.128754 325.945923,389.227386 
	C326.228363,389.043945 326.810333,389.321747 327.254242,389.386932 
	C326.836945,390.054138 326.419647,390.721313 326.005981,391.697510 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M322.178650,382.189697 
	C322.925507,380.859619 323.531372,381.416168 324.211243,382.597900 
	C323.708160,382.711975 323.046906,382.589996 322.178650,382.189697 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M307.105621,400.434021 
	C307.024231,400.872772 306.709473,401.145752 306.228882,401.680542 
	C305.781555,401.748627 305.500031,401.554932 305.092590,401.132202 
	C305.370361,399.996582 306.094482,400.051910 307.105621,400.434021 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M326.002563,392.005737 
	C326.239105,392.368652 326.475098,392.724548 326.691132,393.092224 
	C326.695190,393.099121 326.462555,393.245117 326.340332,393.326202 
	C326.256378,393.041656 326.172394,392.757141 326.049011,392.239563 
	C326.009644,392.006561 326.000000,392.000000 326.002563,392.005737 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M308.142761,384.900391 
	C308.045563,384.663330 308.233215,384.425476 308.729187,384.248138 
	C308.820068,384.510101 308.616760,384.707092 308.142761,384.900391 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M315.414612,398.978882 
	C315.031708,398.572540 315.044067,398.148590 315.075867,397.407379 
	C318.766968,397.334869 322.743591,396.082977 325.915955,399.632019 
	C324.868774,401.621185 324.393921,405.318359 321.645752,400.916473 
	C320.571533,399.195831 317.837280,399.450623 315.414612,398.978882 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M328.056091,399.523254 
	C329.166016,398.365540 330.282867,398.631317 331.749969,399.074707 
	C332.446625,400.083954 335.122925,400.636383 332.773651,401.975494 
	C330.555298,403.239990 328.683685,402.761749 328.056091,399.523254 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M301.075043,411.075256 
	C300.876740,410.786682 300.837769,410.477325 300.859314,410.322937 
	C302.878357,407.418335 305.983246,409.668732 308.650330,408.274414 
	C308.965759,408.030975 309.109436,407.883026 309.180237,407.806458 
	C309.251007,407.729919 309.662354,407.893921 309.868286,407.976288 
	C310.553436,408.682648 311.032623,409.306641 311.787994,410.049255 
	C312.120758,410.382874 312.177277,410.597839 312.052155,411.092865 
	C310.603363,412.308105 308.884003,412.143280 307.323730,413.261475 
	C306.788727,413.447357 306.562042,413.487091 305.988831,413.497986 
	C304.089050,412.968475 302.512970,412.515289 301.075043,411.075256 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M324.625305,405.131531 
	C327.826172,404.794403 330.871246,404.794403 334.809479,404.794403 
	C331.394562,407.460052 328.550568,406.276245 325.416351,405.999939 
	C324.843536,405.793121 324.656525,405.630890 324.625305,405.131531 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M324.483185,404.694885 
	C324.820770,404.988373 324.860382,405.182343 324.965302,405.665863 
	C323.534241,406.051239 322.124176,405.855194 320.824036,404.624237 
	C321.990967,403.573303 323.088379,404.089783 324.483185,404.694885 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M305.267273,412.677979 
	C305.929718,412.841248 306.196503,412.859314 306.864380,412.873932 
	C308.445099,413.101379 309.442749,414.015594 311.068848,413.795471 
	C312.305023,413.830444 313.193390,413.958466 314.258484,414.640137 
	C318.130280,414.710632 321.762115,413.503845 325.700378,414.960999 
	C325.872192,416.071899 325.319000,416.845703 323.757874,417.126221 
	C321.192841,418.283142 319.956329,421.299194 316.532410,420.245422 
	C316.053314,420.051758 315.847565,420.034119 315.332092,420.008362 
	C312.446899,420.600433 310.010376,422.002380 306.912598,421.133118 
	C306.238159,420.192871 306.213745,419.457764 306.738464,418.395325 
	C306.418518,417.562317 305.873138,417.042816 305.160583,416.287506 
	C303.964539,415.112915 302.564453,416.295593 301.300140,415.229431 
	C300.737213,414.535919 300.394409,414.056946 300.037354,413.267761 
	C301.556610,411.872559 303.201172,412.055237 305.267273,412.677979 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M316.368988,420.395325 
	C319.461761,421.506775 319.484100,415.681000 323.056244,417.212433 
	C323.865753,418.229126 324.355988,419.266296 324.916382,420.642761 
	C325.564880,421.671783 325.169861,422.150238 324.314148,422.678406 
	C323.316040,422.770447 322.639404,422.782562 321.624786,422.774475 
	C320.590546,422.617706 320.547272,422.007721 320.143311,421.327423 
	C318.769104,421.014923 317.624023,420.868134 316.368988,420.395325 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M311.768616,411.267548 
	C311.985382,411.036041 312.028870,410.601044 312.046539,410.384460 
	C312.580872,409.193329 313.450928,409.035736 314.779297,409.213593 
	C313.837616,410.483551 318.091980,412.040436 314.565918,413.163330 
	C313.713043,413.623535 313.105560,413.702057 312.172729,413.414246 
	C311.769867,413.091949 311.649811,412.916870 311.470398,412.429626 
	C311.457977,411.911316 311.504913,411.705170 311.768616,411.267548 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M326.960327,421.843597 
	C329.171539,421.844238 331.084167,421.923157 333.402710,422.056091 
	C333.003326,422.705566 332.197937,423.301086 331.110260,424.030518 
	C328.964874,424.223083 326.721832,425.763153 325.841797,422.439972 
	C326.258972,422.007050 326.460327,421.964447 326.960327,421.843597 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M332.989807,419.694031 
	C332.528687,420.005798 332.078308,419.984009 331.289398,419.964355 
	C330.068878,419.364044 329.186890,418.761597 327.697510,417.744354 
	C330.243408,417.297363 332.512695,415.117584 332.989807,419.694031 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M325.937317,421.818024 
	C326.140320,425.188354 328.601318,423.654602 330.444641,424.125977 
	C329.977234,425.269073 328.727478,424.781586 327.292297,424.994629 
	C326.167969,424.949768 325.396484,424.872437 324.237823,424.753845 
	C323.890717,424.280701 323.930786,423.848816 323.981750,423.087616 
	C324.257965,422.324921 324.523285,421.891510 324.887573,421.220093 
	C325.263397,421.183502 325.540222,421.384949 325.937317,421.818024 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M326.044220,414.996002 
	C328.146484,412.431305 330.607910,414.920471 332.870667,414.788727 
	C330.869568,414.891266 328.868469,414.993835 326.448914,415.020752 
	C326.030457,414.945160 326.013092,415.010345 326.044220,414.996002 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M311.728973,412.861267 
	C312.558350,412.916504 313.124817,413.067322 313.973633,413.215210 
	C314.384125,413.578156 314.512207,413.944000 314.573944,414.595459 
	C313.563202,414.881531 312.618866,414.881958 311.317749,414.836945 
	C310.851135,414.641693 310.741272,414.491913 310.683411,414.067383 
	C310.923248,413.465332 311.169464,413.189056 311.728973,412.861267 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M119.147079,808.889038 
	C118.533752,808.736389 117.933182,808.202271 118.773499,807.145142 
	C119.065636,807.489319 119.118515,807.996765 119.147079,808.889038 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M100.047173,787.952515 
	C100.514549,788.075623 100.947960,788.235474 101.381378,788.395325 
	C101.038483,789.047058 100.636139,788.736633 100.093155,788.266663 
	C99.950058,788.067261 100.013214,787.989380 100.047173,787.952515 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M89.903824,779.779602 
	C89.485497,779.867126 88.909714,779.672852 88.173264,779.213684 
	C88.590523,779.131775 89.168442,779.314819 89.903824,779.779602 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M121.260895,807.039795 
	C121.228630,806.642639 121.411095,806.276123 121.906494,806.886108 
	C121.973526,807.059937 121.490677,807.119690 121.260895,807.039795 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M466.913910,488.245056 
	C467.001221,488.001221 467.497040,488.003265 467.744873,488.005310 
	C467.877686,488.700378 468.003357,489.559479 466.939240,489.578522 
	C466.908203,489.579071 466.864441,488.868103 466.913910,488.245056 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M508.655792,493.059937 
	C508.811829,493.533508 508.658508,494.123688 508.218933,494.861328 
	C508.070587,494.398010 508.208496,493.787292 508.655792,493.059937 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M459.981140,496.763855 
	C459.826233,497.009705 459.658173,497.008179 459.239044,496.981781 
	C459.166779,496.543610 459.345551,496.130280 459.524323,495.716949 
	C459.672211,495.983429 459.820129,496.249939 459.981140,496.763855 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M399.395416,402.983704 
	C399.247589,402.516663 399.493713,402.116974 399.794739,401.563873 
	C401.907227,398.867767 404.487823,398.778442 408.087036,399.762115 
	C405.448212,402.399261 402.627014,402.744232 399.395416,402.983704 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M405.043549,408.035767 
	C404.700165,407.291992 404.744995,406.581451 405.336182,405.956451 
	C405.365417,405.925537 405.695953,406.077820 405.692749,406.133759 
	C405.661377,406.684387 405.588989,407.232697 405.258179,407.889038 
	C404.988098,407.996399 405.025299,408.022034 405.043549,408.035767 
z"/>
<path fill="#6C7394" opacity="1.000000" stroke="none" 
	d="
M300.445343,566.019653 
	C300.102722,565.518066 299.945404,565.249329 299.508514,564.922119 
	C299.049591,564.534912 298.798828,564.248169 298.260925,563.991333 
	C297.873474,563.431641 297.773193,562.841980 297.415710,562.062378 
	C296.466370,560.856018 295.774261,559.839539 294.869690,558.599731 
	C293.506927,555.068970 288.291260,553.265625 289.177704,550.220398 
	C290.346100,546.206726 293.863586,542.848267 296.502502,539.306030 
	C297.465363,538.013611 298.804871,537.001892 300.278656,535.739868 
	C302.441040,542.877136 305.934265,549.501160 308.795227,556.759827 
	C308.751556,559.404053 309.588989,561.420044 310.853027,563.690552 
	C309.664642,566.666870 310.182495,570.775513 305.221191,570.946960 
	C304.866638,571.117126 304.424927,571.044983 304.201294,571.036255 
	C303.812378,570.735352 303.647064,570.443237 303.231934,570.084229 
	C302.822723,569.713684 302.663300,569.409912 302.241821,569.062622 
	C301.829041,568.702881 301.678345,568.386658 301.249939,568.045288 
	C300.882202,567.416992 300.792175,566.813843 300.445343,566.019653 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M313.002472,196.002747 
	C313.145599,198.309982 312.940216,200.336060 309.396484,199.997833 
	C308.900848,197.710037 309.556152,196.033340 312.619446,196.002136 
	C312.995056,195.994507 313.000000,196.000000 313.002472,196.002747 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M304.736237,202.252716 
	C305.184265,199.878281 306.761841,200.014206 308.623749,200.000977 
	C308.998779,199.999390 309.000000,200.000000 309.000610,200.000305 
	C308.760864,201.120865 308.520508,202.241135 308.140045,203.681427 
	C307.833008,204.112991 307.666138,204.224533 307.250854,204.165894 
	C306.533020,203.678452 306.063629,203.361145 305.297729,203.021317 
	C304.826385,202.833633 304.651581,202.668472 304.736237,202.252716 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M300.271301,206.636795 
	C300.921539,208.766541 300.210236,209.182617 298.776947,208.115555 
	C297.790802,207.381332 296.266510,206.221405 297.520508,204.979462 
	C298.455933,204.053040 299.483643,205.385620 300.271301,206.636795 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M289.653931,187.017426 
	C289.750488,187.785187 289.502197,188.595032 289.126953,189.700607 
	C288.114685,189.882965 286.686340,190.284866 286.603027,189.151657 
	C286.486084,187.561493 288.227936,187.560913 289.653931,187.017426 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M277.999390,199.000305 
	C277.080566,198.867050 275.894989,199.305557 275.470306,198.046387 
	C275.221100,197.307541 275.750916,196.711685 276.405853,196.535202 
	C277.986908,196.109222 277.828094,197.384277 277.994751,198.655151 
	C278.001221,198.999390 278.000000,199.000000 277.999390,199.000305 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M306.771362,204.179962 
	C307.002441,203.995743 307.501160,203.998978 307.750549,204.000214 
	C308.182983,204.863388 309.420319,206.065109 308.094849,206.495483 
	C306.862213,206.895721 305.963531,205.897263 306.771362,204.179962 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M311.508362,204.305664 
	C312.105072,203.548462 312.688751,203.057465 313.304565,203.577515 
	C313.962006,204.132675 313.590668,204.821106 313.016724,205.223495 
	C312.222107,205.780563 311.485229,205.870758 311.508362,204.305664 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M350.293427,202.126190 
	C349.998779,201.999390 350.000031,201.499695 349.999390,201.249847 
	C350.814087,200.674484 351.615509,200.167770 352.755432,200.904572 
	C353.005280,201.445206 353.004425,201.889435 353.004242,202.666824 
	C352.199280,202.750992 351.393677,202.501999 350.293427,202.126190 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M301.682434,193.048340 
	C301.927917,194.537445 301.261597,195.597458 299.341644,195.968033 
	C299.632935,194.906860 299.891937,193.508118 301.682434,193.048340 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M295.075409,191.340729 
	C295.773956,191.006866 296.517944,191.003387 297.634613,190.999649 
	C297.497009,193.164886 296.586853,193.612350 295.075409,191.340729 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M304.713745,201.884232 
	C304.995697,202.002106 304.998779,202.500458 305.000000,202.749619 
	C304.099670,202.830475 302.572205,203.368240 302.567169,202.052063 
	C302.562561,200.830750 303.723938,201.511154 304.713745,201.884232 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M297.088501,200.423203 
	C297.911896,200.942963 298.088379,201.523849 297.578979,202.118027 
	C297.479980,202.233475 296.949005,202.164993 296.788910,202.007217 
	C296.276642,201.502289 296.080811,200.922150 297.088501,200.423203 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M282.222656,182.111008 
	C282.112152,181.672409 282.302002,181.408035 282.792419,181.084015 
	C283.909210,181.069183 284.706787,181.314117 284.961365,182.679871 
	C284.556885,183.004456 284.112549,183.007706 283.335022,183.012573 
	C282.895935,182.693024 282.708466,182.430054 282.222656,182.111008 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M283.001953,185.998016 
	C283.630615,186.092392 284.346100,186.096817 284.484833,186.906219 
	C284.514160,187.077194 284.157379,187.314377 283.978485,187.521042 
	C283.675812,187.202576 283.373169,186.884094 283.033356,186.284943 
	C282.996216,186.004272 283.000000,186.000000 283.001953,185.998016 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M315.954742,201.591095 
	C315.230713,201.196671 315.224091,200.798645 315.738312,200.446182 
	C315.846100,200.372299 316.096252,200.374527 316.201538,200.450928 
	C316.705811,200.816818 316.687134,201.214630 315.954742,201.591095 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M326.454590,197.619415 
	C326.678925,198.411545 326.400543,198.696686 325.786743,198.575806 
	C325.659027,198.550659 325.486786,198.370041 325.467377,198.241150 
	C325.373932,197.620590 325.675537,197.360245 326.454590,197.619415 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M302.314392,198.953674 
	C302.078461,198.091492 302.328796,197.306076 303.686035,197.042511 
	C303.920319,197.903442 303.671967,198.690521 302.314392,198.953674 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M294.454376,203.619568 
	C294.678925,204.412048 294.400513,204.697296 293.786438,204.576324 
	C293.658691,204.551163 293.486359,204.370483 293.466919,204.241516 
	C293.373260,203.620651 293.675079,203.360306 294.454376,203.619568 
z"/>
<path fill="#A5B2B5" opacity="1.000000" stroke="none" 
	d="
M290.042755,191.296570 
	C290.450134,191.000381 290.896606,191.000168 291.678284,190.999664 
	C291.775238,191.511734 291.665924,192.273254 291.268921,192.478546 
	C290.659027,192.793961 290.254150,192.208038 290.042755,191.296570 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M240.340179,415.617126 
	C240.069260,418.540283 239.909653,421.097931 239.750061,423.655548 
	C237.198074,420.538544 238.791367,417.267120 238.695740,413.635498 
	C238.831100,411.121307 239.010330,409.058258 239.196320,406.601257 
	C239.439377,406.247009 239.651550,406.341125 240.010193,406.528076 
	C240.165237,406.826630 240.149460,407.086884 240.148193,407.543213 
	C240.841431,408.923401 240.331940,410.211761 240.487976,411.821960 
	C240.481735,413.218781 240.507172,414.235687 240.340179,415.617126 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M240.420105,412.218933 
	C240.049637,410.858521 239.948395,409.631683 240.005005,408.072113 
	C240.322678,407.929779 240.482468,408.120209 240.787079,408.654114 
	C240.897903,409.694061 240.863922,410.390503 240.856171,411.435181 
	C240.818054,411.973083 240.753693,412.162842 240.420105,412.218933 
z"/>
<path fill="#F9F9EA" opacity="1.000000" stroke="none" 
	d="
M222.781372,412.761139 
	C223.083572,412.992126 223.395020,413.235321 223.856064,413.735321 
	C224.005661,413.992096 223.999100,414.000580 223.995270,414.003174 
	C223.441971,414.172668 223.007874,414.017273 222.727264,413.159485 
	C222.765366,412.779388 222.790604,412.773346 222.781372,412.761139 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M675.000000,146.998688 
	C674.875916,149.795319 673.043701,151.018280 670.048950,151.676361 
	C668.627563,151.084869 668.768555,149.592056 667.487793,149.577103 
	C667.323486,149.575180 667.471558,150.408295 667.245483,151.432770 
	C664.672546,150.855881 662.640137,151.643509 660.335327,152.965302 
	C659.418823,152.515488 658.697754,152.163818 658.489624,151.149490 
	C658.466248,150.962936 658.594971,150.712479 658.594971,150.712479 
	C658.594971,150.712479 658.321167,150.590759 658.191650,150.745850 
	C656.518066,152.437912 653.956421,152.956818 653.213684,155.754242 
	C652.988098,155.987122 653.000000,156.000000 652.993530,155.994476 
	C652.467834,156.533997 651.926208,157.056763 651.191528,157.785492 
	C650.989868,157.982971 650.996948,157.995026 650.989624,157.994003 
	C645.557983,160.022522 649.159485,162.746887 651.528931,166.297638 
	C647.461548,164.398727 644.244263,163.805908 643.994995,159.379089 
	C645.256470,158.907150 646.969177,159.226898 646.781311,157.194351 
	C646.548157,154.671051 643.569214,155.275894 642.407288,153.725235 
	C639.902832,156.059601 637.976990,152.936722 635.061768,152.896149 
	C633.705933,152.274429 632.963806,152.193161 631.597290,152.800690 
	C627.560669,153.888947 626.723267,157.180374 625.053711,159.641373 
	C624.392822,160.615616 623.992126,161.639816 622.360596,161.934769 
	C620.559692,160.502701 621.360596,158.915070 621.898010,157.024963 
	C622.131287,156.502670 622.238953,156.302200 622.548706,155.831482 
	C623.923706,154.575119 624.791321,153.312759 626.041504,151.953537 
	C626.598938,151.434021 626.871094,151.086319 627.261475,150.876175 
	C626.580322,151.038376 626.387268,151.750519 625.575439,152.314636 
	C623.370544,153.071411 622.022522,152.293259 621.469666,150.530853 
	C620.646545,147.906631 622.770447,146.836594 624.704834,145.293732 
	C627.277100,145.156006 629.620483,145.048508 631.852905,145.495407 
	C639.503540,147.026993 641.853149,145.437347 643.004333,137.608826 
	C643.811707,132.118790 645.625732,130.450500 650.618896,130.964020 
	C651.572266,130.989182 652.119629,130.813736 652.795044,130.208862 
	C653.002441,129.999649 653.000000,130.000000 653.000000,130.000916 
	C653.683899,129.401291 654.456604,129.237579 655.665894,129.765854 
	C656.009766,130.001831 656.495117,130.001328 656.737793,130.001190 
	C657.651367,130.654465 658.298950,131.321060 658.162537,132.666962 
	C657.567139,132.991074 657.114868,132.997543 656.323364,133.008026 
	C655.399963,133.569351 654.893616,134.181808 654.557495,135.260254 
	C654.502991,135.974838 654.574463,136.366257 654.916382,136.971008 
	C655.219116,137.343369 655.348022,137.482803 655.684570,137.809647 
	C656.313843,138.382355 656.814575,138.599609 657.663330,138.728882 
	C658.766663,138.847336 659.575317,138.955658 660.652344,139.334457 
	C661.764465,139.912674 661.982849,140.818771 662.722473,141.731506 
	C663.114990,141.974136 663.286316,141.979996 663.714722,141.992126 
	C664.673828,142.773193 664.115112,145.069962 666.682617,143.989578 
	C667.450684,143.998825 667.898926,143.997650 668.683350,143.993500 
	C670.643433,142.838226 671.550232,143.857834 672.462280,145.416687 
	C672.552246,146.083954 672.403809,146.348648 672.216003,146.611832 
	C672.076660,146.807068 672.088074,146.974030 672.092834,147.000427 
	C672.211365,147.656464 672.862610,147.452530 672.229248,147.244492 
	C672.229187,147.244461 672.229919,147.081955 672.485596,146.585938 
	C673.361450,146.217377 673.963013,146.255753 674.771729,146.784790 
	C675.002441,147.000610 675.000000,147.000000 675.000000,146.998688 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M646.659485,105.040047 
	C646.973450,106.572548 647.115479,108.018410 649.602783,107.982613 
	C651.048218,107.826088 651.856689,107.213562 652.786255,106.219742 
	C653.002441,105.998360 653.000000,106.000000 652.998779,106.000809 
	C654.509033,106.057884 655.563416,106.710670 655.981445,108.582870 
	C655.755005,110.771751 657.680298,111.675232 657.699158,113.854996 
	C656.392029,114.844658 655.366638,113.726776 654.088501,114.536270 
	C653.751404,114.898735 653.619324,115.041908 653.294189,115.389297 
	C652.780579,116.003464 652.443298,116.407982 652.823486,117.494446 
	C653.017883,119.824585 652.681396,121.755219 654.905579,123.235619 
	C652.067688,122.079407 649.875977,122.930191 647.353821,123.989777 
	C646.866760,122.330956 648.651550,121.452942 648.758240,119.999725 
	C648.901672,118.045830 647.342102,116.544006 646.139038,115.528526 
	C644.574585,114.208015 644.374084,116.695900 643.448669,117.342018 
	C641.983154,118.365204 640.299622,119.076218 638.349121,119.967972 
	C637.908936,116.741089 642.513855,116.629593 642.248779,113.174164 
	C641.708252,111.787582 639.828979,111.164253 640.898315,109.261765 
	C643.418213,108.566795 644.037842,105.693428 646.659485,105.040047 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M625.621216,151.992523 
	C626.054077,153.780960 625.857971,155.416245 623.361572,155.957230 
	C622.164978,155.239700 621.646790,154.144653 620.509705,153.653610 
	C620.912476,154.600983 622.032715,154.740036 622.761902,155.772034 
	C622.667175,157.741577 622.339661,159.478165 622.007507,161.596710 
	C621.965759,164.295456 619.592590,164.952728 618.398682,166.107361 
	C615.887573,168.535889 616.016296,164.318954 614.492920,163.546112 
	C612.559875,162.565506 612.971680,161.236115 615.647705,161.006622 
	C616.378906,160.881943 616.501770,160.635681 616.171997,160.136536 
	C615.663391,159.900391 615.409241,159.709610 615.107300,159.223419 
	C613.631470,157.465759 611.695435,156.184586 612.767822,153.314453 
	C613.002441,152.998169 613.000000,153.000000 612.998779,153.000916 
	C614.515869,151.489227 616.022522,149.965027 617.773193,148.229843 
	C617.999512,148.001221 618.000000,148.000000 618.000000,147.999390 
	C619.026428,147.079865 619.893188,146.097336 619.187988,144.284271 
	C619.005066,144.007660 619.000000,143.999603 618.996338,143.996094 
	C618.242737,143.047012 617.088257,142.192856 618.635376,140.899231 
	C621.160828,141.244614 620.679504,138.438309 622.672302,138.052368 
	C623.381531,138.382843 623.529663,138.839523 623.248535,139.684357 
	C622.927063,141.780716 620.877441,144.057388 624.645569,144.969299 
	C624.957275,145.981171 625.115845,147.067856 624.169067,147.694946 
	C620.417542,150.179901 622.028931,151.271042 625.621216,151.992523 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M721.663818,99.997047 
	C722.002991,100.749084 722.003601,101.499695 722.002075,102.625610 
	C719.237244,102.719398 718.153076,104.644691 717.579041,106.749207 
	C717.216797,108.077400 716.947632,108.992447 715.407288,108.631630 
	C713.786987,108.252083 713.320923,107.209908 713.965393,105.373360 
	C711.274231,100.010994 716.169861,100.673927 718.665894,99.142044 
	C719.530334,99.885193 720.402710,99.999023 721.663818,99.997047 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M731.624329,146.987137 
	C731.315979,148.773224 734.373230,151.536163 733.353149,151.103912 
	C727.955566,148.817001 731.408142,153.856308 730.163818,154.679565 
	C727.989990,154.107544 727.093079,152.747681 727.014648,150.372437 
	C727.270569,148.988388 727.824829,148.148071 728.793030,147.212051 
	C729.005920,146.993866 729.000000,146.999344 728.997009,147.002625 
	C729.745544,146.998978 730.497131,146.992050 731.624329,146.987137 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M707.996460,106.003342 
	C709.970093,106.107506 711.352295,107.202713 712.600891,108.629463 
	C713.357361,109.493874 715.706360,110.435349 713.643127,111.343376 
	C711.762451,112.171074 711.500549,116.245056 708.312134,114.138504 
	C708.026550,113.949829 708.105469,113.209274 708.144287,112.056305 
	C710.162048,109.461922 706.843933,108.291885 707.788208,106.263794 
	C708.007263,105.992554 708.000671,105.999397 707.996460,106.003342 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M612.133789,124.267616 
	C611.982727,123.250366 611.982483,122.502960 611.984497,121.382072 
	C613.461975,120.846024 614.680603,121.238541 615.716064,122.814247 
	C617.208801,124.173264 618.394653,125.344719 617.998108,127.631813 
	C617.531189,127.996010 617.064880,127.994759 616.248779,128.001099 
	C615.711548,128.113541 615.524048,128.218414 615.044189,128.191315 
	C613.865112,126.930420 613.401001,125.505508 612.133789,124.267616 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M699.005737,152.993881 
	C701.689087,153.021988 702.870544,153.881516 700.971985,156.489716 
	C700.310364,157.398788 699.701904,158.346619 699.016602,159.629181 
	C698.603088,160.387619 698.155334,160.547211 697.269775,160.322815 
	C696.224182,159.197998 695.363892,158.275986 695.559937,156.572479 
	C696.186035,154.893631 697.669067,154.523300 698.756226,153.247971 
	C698.988342,153.011505 698.999207,153.000626 699.005737,152.993881 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M674.994629,146.637329 
	C674.254639,147.005051 673.506836,147.009491 672.372192,147.001587 
	C671.927063,145.461685 671.269165,144.405685 669.355591,144.031799 
	C669.099426,142.765259 669.562866,141.185913 670.769714,141.459518 
	C673.107422,141.989502 674.398010,143.943878 674.994629,146.637329 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M691.694336,154.840179 
	C691.891113,155.320145 691.699280,155.581345 691.203918,155.891556 
	C690.003540,156.811264 688.931946,157.044067 687.380127,156.268250 
	C687.020508,156.020401 687.001465,156.001526 686.990967,155.991394 
	C687.502502,154.050491 685.765808,153.110291 685.058533,151.342743 
	C687.692444,151.264374 689.781555,152.558273 691.694336,154.840179 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M666.880249,143.716385 
	C665.574402,144.890060 664.146301,145.780106 662.727295,146.664505 
	C661.231384,144.492691 663.762878,144.020630 663.927490,142.336792 
	C666.072083,140.200668 665.928101,142.762726 666.880249,143.716385 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M670.361206,110.993530 
	C669.997620,110.252998 670.000122,109.501595 670.000122,108.374481 
	C671.779724,108.592865 673.493042,104.933487 674.472534,107.045731 
	C675.414001,109.075928 672.898560,110.466301 670.361206,110.993530 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M638.364502,134.100159 
	C636.234253,135.012360 635.787048,134.247314 636.854004,132.814697 
	C637.642700,131.755737 637.989380,129.719284 640.027649,130.310242 
	C640.972534,130.584198 641.101990,131.572525 640.515442,132.317566 
	C640.019958,132.947083 639.266907,133.373825 638.364502,134.100159 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M719.992249,115.014969 
	C719.650696,116.759621 722.667480,117.233620 721.407104,119.602921 
	C719.509583,118.769516 717.834351,117.804771 717.035034,115.345520 
	C717.737366,115.009048 718.482483,115.010429 719.599487,115.014008 
	C719.971375,115.016197 719.998352,115.001160 719.992249,115.014969 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M683.932861,113.156647 
	C685.026001,112.675659 686.261658,111.574341 686.496948,113.081093 
	C686.719299,114.504654 685.240723,116.381454 684.178284,116.306114 
	C682.372314,116.178070 683.039246,114.525864 683.932861,113.156647 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M717.007568,136.356537 
	C719.011475,136.187943 720.289856,137.178833 720.720398,139.614868 
	C718.635620,139.457245 717.096985,139.101700 717.007568,136.356537 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M661.166382,139.670990 
	C659.904297,139.981369 658.862915,139.988586 657.430908,139.997589 
	C656.688293,139.688507 656.448303,139.305145 656.300171,138.513336 
	C656.374023,137.948380 656.451172,137.730270 656.776367,137.269440 
	C657.794495,137.023804 658.564575,137.020874 659.719360,137.035034 
	C660.247070,137.216766 660.390015,137.381378 660.763000,137.778412 
	C660.993042,138.010818 660.997559,138.000000 660.991211,138.005981 
	C661.338135,138.398895 661.472107,138.850876 661.166382,139.670990 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M666.988831,123.637726 
	C665.931519,124.002403 664.865479,124.002090 663.399719,124.001198 
	C663.116699,122.638687 663.568359,121.464340 665.081787,121.214943 
	C666.645020,120.957314 666.908875,122.065376 666.988831,123.637726 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M710.421021,122.570404 
	C714.151733,121.957672 711.628418,123.653717 711.291809,124.372978 
	C710.798767,125.426575 709.848755,126.733467 708.750732,125.428154 
	C707.686340,124.162682 709.881165,123.799049 710.421021,122.570404 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M727.379395,123.997498 
	C727.803711,122.902214 727.826355,120.885834 729.931091,121.304939 
	C730.269287,121.372276 730.749084,121.994698 730.737122,122.346077 
	C730.667419,124.405785 728.988342,123.819550 727.379395,123.997498 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M702.351562,146.958176 
	C702.073181,145.566971 701.869751,143.964554 703.734863,143.461716 
	C704.003357,143.389328 704.683838,143.867874 704.748047,144.179199 
	C705.080078,145.790985 704.084961,146.524261 702.351562,146.958176 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M618.885376,140.773193 
	C618.004211,141.790665 619.010559,142.622742 618.976685,143.715805 
	C615.861816,143.910873 614.969849,142.845474 617.688599,140.163116 
	C618.312500,140.103699 618.572083,140.290283 618.885376,140.773193 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M680.878052,109.292778 
	C685.004639,111.539627 681.469666,111.770279 680.136841,113.331223 
	C679.341919,111.351707 680.416687,110.570152 680.878052,109.292778 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M679.015503,117.365906 
	C680.171021,117.146400 681.741516,116.694252 681.748352,118.665886 
	C681.749512,119.007103 681.287781,119.569595 680.946228,119.654861 
	C679.329102,120.058609 679.133667,118.911774 679.015503,117.365906 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M680.998779,105.998772 
	C680.992615,106.749588 680.987732,107.501625 680.988525,108.629761 
	C680.994202,109.005844 681.000000,109.000000 681.002930,108.997162 
	C679.849243,108.840057 678.250854,109.269928 678.220276,107.393471 
	C678.200439,106.179245 679.302734,106.076302 680.632568,106.012711 
	C681.002441,106.002457 681.000000,106.000000 680.998779,105.998772 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M656.322510,117.272873 
	C655.232300,118.017914 654.488220,118.010765 653.372070,118.001961 
	C653.000000,118.000305 653.000000,118.000000 653.000000,117.999825 
	C652.423035,117.316856 652.266479,116.547844 652.759827,115.350746 
	C652.992676,115.008202 653.000000,115.000000 653.003662,114.996033 
	C654.916748,113.851311 656.216675,114.170517 656.322510,117.272873 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M665.833679,117.722908 
	C664.299866,117.562103 663.862244,116.801071 664.457703,115.784073 
	C664.665955,115.428497 665.692139,115.158630 666.058044,115.363007 
	C667.111877,115.951469 667.015808,116.836357 665.833679,117.722908 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M700.195557,119.915863 
	C701.394958,120.505219 702.517761,121.354744 700.622864,121.581039 
	C699.263062,121.743439 697.938538,120.547752 697.677002,118.785164 
	C699.001343,117.857849 699.070312,119.701843 700.195557,119.915863 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M720.337769,126.949211 
	C719.932739,125.203255 720.160767,123.580338 722.654724,123.032776 
	C722.734863,124.589561 722.435486,126.179153 720.337769,126.949211 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M661.370972,113.996391 
	C661.000305,113.248695 661.000549,112.496651 660.999146,111.368362 
	C660.997559,110.992134 661.000000,111.000389 660.996338,110.999176 
	C661.502014,110.465271 662.122314,110.225792 663.434082,110.650528 
	C664.034485,112.596809 663.873535,114.043442 661.370972,113.996391 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M667.018311,111.373123 
	C667.754761,111.007568 668.504700,111.010857 669.629761,111.004868 
	C669.871582,112.164879 670.268433,113.750000 668.407532,113.786873 
	C667.204041,113.810715 667.083008,112.706581 667.018311,111.373123 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M632.221436,115.172440 
	C631.996094,114.239372 632.000854,113.493202 632.002808,112.373970 
	C632.750000,111.998039 633.500000,111.995178 634.625000,111.995865 
	C634.949829,113.157555 635.170227,114.443550 633.282715,114.957123 
	C632.773926,115.130798 632.612732,115.245064 632.221436,115.172440 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M658.001221,113.998932 
	C658.751831,113.999405 659.501160,114.000946 660.625244,114.000862 
	C661.061035,115.610550 660.843994,117.010826 658.128906,116.741096 
	C657.220093,115.838043 657.217651,115.176071 657.770508,114.260071 
	C657.997559,114.001923 658.000000,114.000000 658.001221,113.998932 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M705.241821,108.279709 
	C703.436157,109.000763 701.940247,108.908920 702.007446,106.365196 
	C702.007446,105.992584 701.999146,106.000603 701.995728,106.003899 
	C703.916748,104.822212 704.813354,105.933662 705.241821,108.279709 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M661.002808,140.290710 
	C660.953064,139.538116 660.960327,139.102097 660.976257,138.339020 
	C661.431641,138.007492 661.878357,138.003006 662.665039,138.001984 
	C662.999390,139.063141 662.993835,140.120819 662.966003,141.573395 
	C662.040955,141.895050 661.276306,141.630569 661.002808,140.290710 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M662.997559,137.997360 
	C663.122742,136.937271 662.743896,135.605087 664.237305,135.226517 
	C664.851318,135.070862 665.615417,135.250473 665.583923,136.119034 
	C665.542297,137.264206 664.661133,137.682816 663.346313,137.970215 
	C663.004883,138.005463 663.000000,138.000000 662.997559,137.997360 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M701.997559,146.997925 
	C701.856812,147.915039 702.322205,149.109833 701.049988,149.538727 
	C700.308777,149.788605 699.708069,149.263672 699.531433,148.600769 
	C699.111145,147.023254 700.367065,147.151703 701.659302,147.005264 
	C702.004883,147.004257 702.000000,147.000000 701.997559,146.997925 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M708.001831,111.998352 
	C706.437012,111.997986 704.922180,111.930664 705.007019,109.366165 
	C705.007080,108.992798 704.999329,109.000549 704.996216,109.003769 
	C707.318726,107.946442 708.176758,109.142303 708.219116,111.626831 
	C707.996460,112.003578 708.000000,112.000153 708.001831,111.998352 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M667.001221,123.998779 
	C667.922729,124.133713 669.113831,123.695045 669.532898,124.963913 
	C669.777832,125.705673 669.246948,126.300842 668.588135,126.475716 
	C667.009583,126.894730 667.152039,125.631630 666.999512,124.348099 
	C666.997559,124.002724 667.000000,124.000000 667.001221,123.998779 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M730.017151,135.127136 
	C730.891724,136.259430 730.476013,136.830811 729.479370,136.845245 
	C728.554321,136.858643 727.958801,136.201416 728.220947,135.264404 
	C728.456970,134.420517 729.169434,134.718842 730.017151,135.127136 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M663.997559,109.000313 
	C665.593750,108.166748 666.631653,108.524963 666.979309,110.697296 
	C666.252319,111.004662 665.504639,111.009323 664.383362,111.011490 
	C664.009766,111.008995 663.999146,110.998993 663.994690,110.995087 
	C663.616943,110.603310 663.473694,110.143692 663.780151,109.304070 
	C664.000000,108.995728 664.000000,109.000076 663.997559,109.000313 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M653.237183,136.176727 
	C653.098389,134.434814 653.766357,133.397430 655.650879,133.043732 
	C655.993958,133.455246 656.003784,133.898468 656.013428,134.674301 
	C655.926086,135.462189 655.713135,135.851105 655.095276,136.347717 
	C654.347290,136.605713 653.905518,136.574905 653.237183,136.176727 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M705.000000,153.000610 
	C704.003296,152.893646 703.076233,152.593033 703.186707,151.378571 
	C703.295410,150.183105 704.315308,150.073395 705.641113,150.006165 
	C705.693604,150.795486 705.375000,151.579330 705.028198,152.680984 
	C705.000000,152.998779 705.000000,153.000000 705.000000,153.000610 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M683.997070,106.002914 
	C685.533936,106.056946 686.606812,106.710686 686.968872,108.658783 
	C685.475220,108.903557 684.357178,108.303246 684.033447,106.335358 
	C684.005676,105.993912 684.000000,106.000000 683.997070,106.002914 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M690.651855,107.560982 
	C690.160217,106.422989 690.552979,105.707397 691.450562,105.650993 
	C691.829895,105.627151 692.598877,106.406868 692.600525,106.823692 
	C692.604797,107.896461 691.729126,107.922043 690.651855,107.560982 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M697.107788,146.238861 
	C696.287659,146.542526 695.172607,146.779984 695.151367,146.705429 
	C694.818298,145.537827 695.908569,144.871475 696.561035,144.658218 
	C697.827026,144.244370 697.742371,145.171127 697.107788,146.238861 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M658.343750,132.987015 
	C657.693970,132.202179 657.368591,131.419769 657.011841,130.319199 
	C658.146851,129.991287 659.071777,130.451508 659.886597,131.704758 
	C660.198608,132.167953 660.361084,132.343674 660.244751,132.745529 
	C659.533264,132.977570 659.100708,132.983490 658.343750,132.987015 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M654.778870,136.271881 
	C655.113770,135.645462 655.307556,135.397797 655.797302,135.109863 
	C656.330505,135.480988 656.647766,135.955032 656.994751,136.727905 
	C657.024414,137.026749 657.013000,137.507477 657.010132,137.747894 
	C656.624756,138.372726 656.165527,138.523682 655.317261,138.222824 
	C655.005005,138.004761 655.000000,138.000000 654.997620,137.997375 
	C654.618408,137.597656 654.472412,137.128784 654.778870,136.271881 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M717.000000,136.000458 
	C715.977051,135.807068 714.964417,135.574997 715.244202,134.171860 
	C715.295715,133.913681 715.634094,133.514893 715.836548,133.517014 
	C717.071350,133.529968 716.831238,134.565964 716.994873,135.659103 
	C717.000000,135.998779 717.000000,136.000000 717.000000,136.000458 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M696.783020,159.782410 
	C697.482910,159.967056 697.906555,159.969742 698.647095,159.977020 
	C699.133240,159.985336 699.302429,159.989059 699.725098,159.993256 
	C699.263489,163.482269 697.651917,160.941010 696.170532,160.268921 
	C696.158020,159.870621 696.332336,159.735519 696.783020,159.782410 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M684.992920,151.006287 
	C684.022888,150.862366 683.079590,150.624512 683.205261,149.377594 
	C683.237427,149.057922 683.754333,148.514587 684.007385,148.537094 
	C685.080688,148.632584 684.871521,149.591171 685.006592,150.646210 
	C685.014404,150.986206 685.000000,150.999710 684.992920,151.006287 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M709.800354,139.206985 
	C710.736328,139.840088 710.680969,140.426086 709.920959,140.717514 
	C709.573730,140.850601 708.809998,140.666260 708.657837,140.391617 
	C708.235107,139.628922 708.782349,139.269241 709.800354,139.206985 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M669.938293,107.662651 
	C668.874268,107.944008 667.598267,108.216644 667.073486,106.367805 
	C668.156250,106.064079 669.407715,105.833260 669.938293,107.662651 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M679.002441,116.997780 
	C678.118958,116.906212 677.050171,117.261681 676.557922,116.184845 
	C676.469421,115.991318 676.906189,115.327492 677.214050,115.226112 
	C678.139282,114.921509 678.650024,115.493942 678.956299,116.668289 
	C678.995117,117.004639 679.000000,117.000000 679.002441,116.997780 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M671.817200,115.182693 
	C672.684631,115.749863 672.763550,116.414062 672.100342,116.697716 
	C671.691772,116.872452 670.713867,116.615334 670.553894,116.282158 
	C670.236328,115.620781 670.839661,115.229149 671.817200,115.182693 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M631.743652,114.985962 
	C631.991394,114.985542 632.463867,115.005005 632.699463,115.010773 
	C632.487000,117.259842 631.588379,117.651840 630.078308,115.368149 
	C630.192200,114.892670 630.347351,114.750870 630.751587,114.802521 
	C631.000671,114.995979 631.495972,114.986374 631.743652,114.985962 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M728.353210,116.996613 
	C728.071960,115.538292 728.911133,114.959053 730.639893,114.995956 
	C730.992676,114.993034 731.000000,114.999977 731.003662,115.003448 
	C730.929260,116.459312 730.093140,117.041328 728.353210,116.996613 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M639.475830,125.296387 
	C639.064209,124.398285 639.104675,123.724121 639.888855,123.553932 
	C640.134705,123.500572 640.736084,124.040199 640.791870,124.372650 
	C640.911255,125.084053 640.562012,125.618408 639.475830,125.296387 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M635.049072,120.336418 
	C635.747620,120.002556 636.495300,120.004066 637.616455,120.011108 
	C637.989929,120.016632 638.000000,119.999901 637.991333,120.004837 
	C637.480957,122.233810 636.578003,122.709808 635.049072,120.336418 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M660.676147,120.064453 
	C660.836670,120.921768 661.369446,122.141670 659.986572,122.475410 
	C659.789551,122.522957 659.349976,122.214836 659.270081,121.985222 
	C658.932678,121.015610 659.419861,120.424019 660.676147,120.064453 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M723.007812,122.996384 
	C723.099792,122.104088 722.735474,121.042778 723.781494,120.516464 
	C723.966492,120.423386 724.649597,120.845604 724.749512,121.146935 
	C725.051941,122.059464 724.503479,122.595367 723.337769,122.932877 
	C723.007324,122.983932 723.000000,123.000191 723.007812,122.996384 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M728.004883,117.004913 
	C727.909302,117.887787 728.239075,118.944115 727.197266,119.443130 
	C727.009399,119.533104 726.343506,119.110191 726.244629,118.810013 
	C725.943542,117.895828 726.524841,117.392830 727.661621,117.047089 
	C727.990234,116.990837 728.000000,117.000076 728.004883,117.004913 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M717.489136,121.674133 
	C718.739807,121.474968 719.070312,122.066780 718.745544,122.932220 
	C718.639282,123.215218 718.058899,123.320259 717.695374,123.506668 
	C717.551880,122.965805 717.408325,122.424942 717.489136,121.674133 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M712.193115,117.830643 
	C711.321899,117.263947 711.257690,116.609306 711.923462,116.330872 
	C712.336914,116.157921 713.315735,116.401176 713.462402,116.721970 
	C713.760864,117.375206 713.163818,117.774315 712.193115,117.830643 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M643.339050,127.490021 
	C643.526733,128.937531 642.744385,128.939667 641.897461,128.651001 
	C641.700378,128.583832 641.467102,128.068787 641.540161,127.862282 
	C641.809265,127.101501 642.452637,127.088951 643.339050,127.490021 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M696.344788,114.997231 
	C696.144836,114.025818 696.350037,113.043945 697.631226,113.157143 
	C697.955200,113.185768 698.512573,113.713791 698.490356,113.971642 
	C698.396362,115.063858 697.416504,114.855423 696.344788,114.997231 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M720.000000,127.000305 
	C719.912781,127.885185 720.253052,128.944672 719.199402,129.447815 
	C719.009705,129.538361 718.339478,129.112640 718.239990,128.810455 
	C717.937378,127.890991 718.516235,127.383316 719.668213,127.049965 
	C720.000000,126.999680 720.000000,127.000000 720.000000,127.000305 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M724.197632,128.783386 
	C723.253052,128.148819 723.317200,127.562943 724.076721,127.271324 
	C724.424316,127.137856 725.189270,127.322144 725.341858,127.597130 
	C725.765991,128.361481 725.220825,128.723648 724.197632,128.783386 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M717.003906,114.996513 
	C716.039917,114.850594 715.061584,114.650581 715.171265,113.378059 
	C715.198669,113.059464 715.735107,112.512589 715.999939,112.534149 
	C717.098267,112.623520 716.882935,113.589142 716.990845,114.663528 
	C716.992310,115.007660 717.000000,115.000053 717.003906,114.996513 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M663.000000,123.999664 
	C662.910706,124.880836 663.227844,125.927986 662.205872,126.443382 
	C662.026123,126.534042 661.353149,126.112961 661.256409,125.815025 
	C660.961121,124.905846 661.527222,124.392601 662.670959,124.053467 
	C663.000000,124.000626 663.000000,124.000000 663.000000,123.999664 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M647.002075,124.002068 
	C646.868774,124.975357 646.643555,125.925598 645.382690,125.799500 
	C645.060425,125.767273 644.511536,125.251251 644.534180,124.999405 
	C644.630920,123.920197 645.595398,124.135475 646.653687,124.000641 
	C646.995117,123.995728 647.000000,124.000000 647.002075,124.002068 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M655.959717,129.666718 
	C655.257263,130.001358 654.504700,130.000870 653.376099,130.001099 
	C653.515686,127.806625 654.435242,127.364937 655.959717,129.666718 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M687.009399,108.990646 
	C687.941467,109.104622 688.969055,109.078209 689.256348,110.255936 
	C689.295227,110.415436 688.971130,110.817627 688.768066,110.855652 
	C687.824890,111.032288 687.328247,110.486176 687.030396,109.330246 
	C686.982910,109.017624 687.000366,108.999542 687.009399,108.990646 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M705.995117,149.993896 
	C706.292725,149.122177 706.595276,148.256851 706.897827,147.391541 
	C707.164490,147.502731 707.585510,147.544327 707.672180,147.736633 
	C708.164551,148.828934 707.757629,149.560150 706.323364,149.965271 
	C706.012207,150.011627 706.000000,150.000290 705.995117,149.993896 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M657.999207,116.999390 
	C657.844788,117.899162 658.390503,119.102844 657.058228,119.478973 
	C656.829773,119.543457 656.412659,118.939438 656.029541,118.334648 
	C655.976379,118.025063 656.001343,117.996208 656.012939,117.981438 
	C656.419556,117.470222 656.770996,116.924767 657.713379,116.860588 
	C658.001038,117.000977 658.000000,117.000000 657.999207,116.999390 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M656.733765,124.989433 
	C658.039978,124.560883 657.956360,125.342911 657.751770,125.928741 
	C657.656555,126.201538 657.056458,126.298035 656.685181,126.474457 
	C656.635437,126.043510 656.585754,125.612564 656.733765,124.989433 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M660.321655,132.976486 
	C659.965881,132.971649 660.001282,132.482162 660.018677,132.237198 
	C660.344971,131.883011 660.595032,131.695480 660.893188,131.217255 
	C661.385864,130.623596 661.846558,130.476227 662.691467,130.785156 
	C662.911560,132.472000 662.052734,133.030655 660.321655,132.976486 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M635.000000,119.999481 
	C634.488098,119.762634 633.964417,119.545959 633.482605,119.259071 
	C633.435364,119.230942 633.585815,118.595863 633.745178,118.542389 
	C634.495178,118.290688 634.765320,118.814552 634.963196,119.713966 
	C635.000000,120.001053 635.000000,120.000000 635.000000,119.999481 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M676.000000,102.999695 
	C676.506775,103.250000 677.026733,103.479805 677.500977,103.781502 
	C677.551636,103.813744 677.389709,104.445221 677.233948,104.492172 
	C676.483398,104.718491 676.212524,104.198074 676.030212,103.290337 
	C676.000000,103.000610 676.000000,103.000000 676.000000,102.999695 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M736.663452,141.076706 
	C736.896118,141.936142 736.635132,142.702850 735.308838,142.981842 
	C735.063721,142.128952 735.283752,141.325867 736.663452,141.076706 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M662.960266,130.687286 
	C662.556213,131.006851 662.111572,131.006256 661.333496,131.005264 
	C660.999756,130.559677 660.999512,130.114487 661.000854,129.333710 
	C661.904358,129.086365 662.692993,129.333252 662.960266,130.687286 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M714.605652,119.517990 
	C715.074097,119.573875 715.358887,119.805191 715.643738,120.036514 
	C715.455444,120.216698 715.267151,120.396889 715.078857,120.577080 
	C714.859924,120.282532 714.640991,119.987984 714.605652,119.517990 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M703.481750,112.604919 
	C703.716187,113.428673 703.429810,113.729034 702.788452,113.602112 
	C702.655212,113.575752 702.475769,113.388252 702.455261,113.253937 
	C702.356262,112.607735 702.669128,112.335434 703.481750,112.604919 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M638.030151,112.298325 
	C638.565796,112.172684 639.130371,112.341911 639.874756,112.754242 
	C639.150269,114.043777 638.485596,113.906372 638.030151,112.298325 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M673.623718,112.545609 
	C674.088379,112.605629 674.371033,112.836250 674.653625,113.066872 
	C674.468262,113.242325 674.282898,113.417778 674.097534,113.593216 
	C673.878906,113.300880 673.660278,113.008553 673.623718,112.545609 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M660.984802,119.983780 
	C661.086792,119.340141 661.113708,118.620071 661.928955,118.503212 
	C662.106384,118.477783 662.338867,118.837128 662.546021,119.019241 
	C662.230103,119.328667 661.914185,119.638100 661.318604,119.992294 
	C661.038879,120.037064 661.002502,120.001877 660.984802,119.983780 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M692.381348,118.950729 
	C692.745483,118.656418 693.107605,118.616310 693.469788,118.576210 
	C693.466736,118.833992 693.463745,119.091766 693.460693,119.349548 
	C693.100281,119.301346 692.739868,119.253143 692.381348,118.950729 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M652.701599,130.019745 
	C652.832703,130.932510 652.858704,132.090729 651.146545,131.229095 
	C651.444519,130.681671 651.922668,130.360764 652.701599,130.019745 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M726.054321,137.410858 
	C726.796875,137.813568 726.803345,138.219894 726.279663,138.581436 
	C726.170776,138.656570 725.914551,138.651031 725.806763,138.572388 
	C725.297241,138.200729 725.300049,137.794601 726.054321,137.410858 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M623.333374,139.957275 
	C623.031067,139.555359 623.019531,139.110703 623.008911,138.332397 
	C623.657959,138.090012 624.433411,138.133057 624.491699,138.943939 
	C624.513428,139.245117 623.931091,139.589737 623.333374,139.957275 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M696.000000,114.999695 
	C695.934570,115.650024 695.932739,116.371437 695.105164,116.524506 
	C694.928955,116.557076 694.680176,116.196915 694.464844,116.017693 
	C694.786926,115.705360 695.109070,115.393028 695.715576,115.040657 
	C696.000000,115.000610 696.000000,115.000000 696.000000,114.999695 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M733.721191,144.028656 
	C733.924438,144.883102 733.686890,145.687119 732.329102,145.946091 
	C732.102966,145.079758 732.341125,144.277069 733.721191,144.028656 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M636.396118,115.950081 
	C636.796692,115.212173 637.202026,115.210724 637.560913,115.730141 
	C637.636353,115.839279 637.634277,116.094116 637.556763,116.201241 
	C637.184570,116.715065 636.780029,116.694237 636.396118,115.950081 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M718.584106,109.552437 
	C719.049011,109.607903 719.331604,109.837418 719.614197,110.066917 
	C719.425598,110.245193 719.237061,110.423477 719.048584,110.601761 
	C718.832947,110.310005 718.617371,110.018242 718.584106,109.552437 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M676.049072,110.781525 
	C675.926147,110.595367 675.986267,110.406067 676.046387,110.216759 
	C676.108276,110.403954 676.170166,110.591156 676.049072,110.781525 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M709.752075,150.989243 
	C709.588684,151.096375 709.423889,151.043442 709.259155,150.990494 
	C709.422974,150.936722 709.586853,150.882950 709.752075,150.989243 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M664.994629,128.246613 
	C665.101990,128.410126 665.049072,128.574997 664.996216,128.739868 
	C664.942261,128.575928 664.888306,128.411957 664.994629,128.246613 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M651.531616,125.551834 
	C651.474487,125.586418 651.588745,125.517258 651.531616,125.551834 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M660.113037,128.211517 
	C660.341064,128.085022 660.596191,128.281494 660.896118,128.777969 
	C661.002441,128.998154 661.000000,129.000000 660.998779,129.000793 
	C660.675476,128.901901 660.410156,128.719589 660.113037,128.211517 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M659.982971,128.012543 
	C659.855530,127.875107 659.743652,127.724686 659.631836,127.574249 
	C659.720764,127.618179 659.809692,127.662117 659.961548,127.837227 
	C660.024414,127.968399 659.998535,127.999542 659.982971,128.012543 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M715.461487,139.447815 
	C715.517029,139.413788 715.405945,139.481827 715.461487,139.447815 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M660.899902,137.804398 
	C660.679565,137.930313 660.436951,137.752991 660.184692,137.265472 
	C660.395264,137.160797 660.629517,137.342743 660.899902,137.804398 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M630.886230,114.783279 
	C631.000671,114.995979 630.518494,115.015808 630.277710,115.025131 
	C630.029724,114.862709 630.022522,114.690956 630.008850,114.261490 
	C630.313599,114.118523 630.570068,114.307457 630.886230,114.783279 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M727.015442,124.021004 
	C726.921204,124.060028 726.811890,124.081085 726.833618,124.037422 
	C726.964661,123.972702 727.000366,124.003044 727.015442,124.021004 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M586.305969,148.243240 
	C586.703247,145.217590 591.307861,144.532364 590.020020,140.320724 
	C593.121460,140.277237 594.684082,137.558350 596.100830,135.839355 
	C597.891113,133.667252 593.059448,133.438904 593.486267,130.799622 
	C594.695679,129.405853 595.999329,131.518478 597.647217,131.005005 
	C598.004883,131.004501 598.000000,131.000000 597.997559,130.997711 
	C598.245483,132.221222 597.582092,134.806335 600.167114,133.147888 
	C603.917969,130.741547 604.272156,134.704605 605.665100,136.047760 
	C606.784790,137.127472 608.909546,139.217987 605.748962,141.101959 
	C604.799622,141.667877 604.650757,143.449829 603.909180,144.517700 
	C602.368408,146.736252 601.417664,146.150604 601.016663,143.365280 
	C598.305542,144.515274 595.725769,146.667679 592.191040,144.687897 
	C591.455322,145.494690 590.989380,146.112198 590.205933,146.827667 
	C589.510071,147.333923 589.040710,147.660461 588.273315,148.020142 
	C587.576172,148.374664 587.122009,148.507431 586.305969,148.243240 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M612.642578,153.003052 
	C612.328613,155.256256 615.154053,156.197678 614.992310,158.636658 
	C613.577759,159.315048 612.155518,159.622787 610.367859,159.969238 
	C608.576599,156.962585 607.233765,153.944244 612.642578,153.003052 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M614.659851,127.763763 
	C614.997559,127.996513 615.449402,128.008850 615.674194,128.008759 
	C615.977356,130.312729 613.793213,130.840744 612.509216,131.772446 
	C610.519714,133.216049 609.962891,134.616547 612.113037,137.539978 
	C608.896301,136.165558 607.315857,135.068298 606.999268,132.348572 
	C609.516968,132.267334 611.089294,131.054230 612.038208,128.430511 
	C612.713379,127.394615 613.475037,127.289238 614.659851,127.763763 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M585.338867,141.954010 
	C585.078125,140.846497 585.005249,139.664825 585.334961,138.608902 
	C585.711914,137.401718 586.264771,136.083130 587.909241,136.092346 
	C590.109863,136.104691 589.902832,137.766663 589.989319,139.609299 
	C589.997559,140.003052 590.000000,140.000000 590.001221,139.998474 
	C588.206848,139.838364 587.294495,141.637970 585.338867,141.954010 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M601.657471,149.710022 
	C602.167725,151.686142 600.624084,150.861755 599.975159,151.202881 
	C598.878723,151.779282 597.736755,154.139542 596.484497,152.121948 
	C595.367188,150.321884 597.621765,148.775238 598.631836,147.752518 
	C600.482361,145.878876 600.723145,148.455902 601.657471,149.710022 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M575.570618,162.009735 
	C573.408936,161.585434 572.823853,164.410126 570.481567,163.530243 
	C570.292542,161.175354 572.295410,159.757355 573.710999,158.762177 
	C574.819153,157.983109 576.190613,159.942703 577.041504,161.021072 
	C577.576355,161.698868 576.533020,161.908691 575.570618,162.009735 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M584.001587,124.001556 
	C584.044189,121.407623 584.749878,119.735077 586.942383,122.692345 
	C587.687195,123.696938 589.611206,123.575897 589.383911,125.357506 
	C587.231934,127.093651 586.217773,124.645882 584.345459,124.051605 
	C583.996887,123.996674 584.000000,124.000000 584.001587,124.001556 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M577.505249,154.694336 
	C578.053589,154.465088 578.518738,154.354904 578.665527,154.522858 
	C579.823364,155.847809 582.315125,155.414963 582.767029,157.553970 
	C582.908997,158.225815 582.072510,159.050613 581.596558,158.746552 
	C579.980774,157.714417 577.482422,157.581436 577.505249,154.694336 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M617.639038,148.035782 
	C617.345276,150.326248 616.555054,152.534332 613.357300,152.991760 
	C612.664856,149.830399 614.820190,148.818817 617.639038,148.035782 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M609.657654,160.037476 
	C609.598450,161.893723 609.304260,163.881454 606.361023,163.989532 
	C604.001221,160.077713 607.941223,161.160110 609.657654,160.037476 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M585.507690,133.930237 
	C584.285034,135.461060 583.037842,136.700439 580.951050,136.593018 
	C581.924133,134.873413 581.992676,131.965363 585.507690,133.930237 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M612.622681,144.736618 
	C614.534119,144.042175 615.220703,144.770599 614.608032,146.200684 
	C614.170166,147.222916 612.789429,148.086441 611.808289,147.485397 
	C610.457581,146.657928 611.202454,145.591293 612.622681,144.736618 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M606.760132,148.805283 
	C607.918152,149.427551 609.547424,147.512955 609.785156,149.545593 
	C610.003906,151.416031 608.362000,151.911545 606.361084,151.988007 
	C605.989868,151.236908 605.996826,150.490494 606.003113,149.370865 
	C606.170898,148.868820 606.339417,148.740005 606.760132,148.805283 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M618.864624,144.326767 
	C620.272583,144.142395 620.993225,144.755600 620.928589,146.121887 
	C620.861511,147.538620 619.960022,147.931244 618.373535,147.988861 
	C618.241455,146.881149 618.482849,145.763504 618.864624,144.326767 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M575.664673,133.007980 
	C576.220276,134.052048 576.445435,135.109360 576.670593,136.166687 
	C575.818665,135.255402 571.168762,135.798584 575.664673,133.007980 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M605.873596,128.326141 
	C611.045837,127.704269 605.516418,130.578949 607.011963,131.676727 
	C604.468079,131.691330 604.910461,130.238983 605.873596,128.326141 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M595.000000,126.000305 
	C593.413757,126.032402 591.986328,125.853706 592.011353,123.369095 
	C593.602417,122.956696 595.051819,123.110710 594.991882,125.627945 
	C595.000000,125.999390 595.000000,126.000000 595.000000,126.000305 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M603.369324,154.988525 
	C602.960999,153.411118 603.127808,151.976837 605.613770,151.993347 
	C605.982910,151.983322 605.999939,151.999420 606.008545,152.007645 
	C606.052490,153.614594 605.828735,155.013931 603.369324,154.988525 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M569.344360,157.994949 
	C569.141418,157.085587 568.692749,155.896042 569.953491,155.471344 
	C570.690552,155.223053 571.290588,155.747620 571.466797,156.404999 
	C571.890442,157.985489 570.615417,157.827515 569.344360,157.994949 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M593.997559,163.002411 
	C592.895874,162.892975 591.677917,163.326569 590.766846,162.430115 
	C590.624329,162.289917 590.862366,161.389999 591.092468,161.306976 
	C592.239258,160.893204 593.337646,160.913177 593.941040,162.654236 
	C594.004883,162.995178 594.000000,163.000000 593.997559,163.002411 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M565.110718,160.767166 
	C564.563416,161.012802 564.126892,160.999084 563.362915,160.979706 
	C562.426453,160.305573 562.270691,159.537872 562.768921,158.336929 
	C563.004883,157.995178 562.999268,158.000443 562.994934,158.004852 
	C563.440247,158.015457 563.889954,158.021667 564.677124,158.024841 
	C565.014648,158.021774 565.487610,158.016022 565.724121,158.011993 
	C566.153137,158.168640 566.345642,158.329285 566.264221,158.747650 
	C565.734009,159.506180 565.477783,160.006989 565.110718,160.767166 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M602.995300,157.630615 
	C602.175964,157.819183 600.881714,158.479797 600.742126,157.101425 
	C600.644043,156.132401 601.337097,155.370728 602.683960,155.045700 
	C603.000000,154.999557 603.000000,155.000000 603.000000,155.000305 
	C603.003357,155.747238 603.006775,156.493851 602.995300,157.630615 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M586.752930,130.381500 
	C587.871094,130.043365 588.635315,130.223679 588.805847,131.201050 
	C588.862244,131.524338 588.426208,132.255875 588.260437,132.242477 
	C587.286438,132.163727 586.348938,131.896591 586.752930,130.381500 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M581.945618,130.667816 
	C581.102783,130.934601 580.046875,131.251358 579.533203,130.200714 
	C579.441406,130.012939 579.865234,129.335419 580.165833,129.237839 
	C581.085266,128.939285 581.609192,129.503235 581.945618,130.667816 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M592.344116,148.999237 
	C592.005432,148.835800 592.006775,148.668961 592.005310,148.251862 
	C591.845886,147.836288 591.689270,147.670944 591.786499,147.277008 
	C592.932007,147.143188 594.234802,146.639175 594.442749,147.932373 
	C594.624329,149.062088 593.427856,148.869232 592.344116,148.999237 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M585.010620,142.011230 
	C584.870544,142.998947 584.633484,143.956619 583.365540,143.819366 
	C583.038574,143.783966 582.488342,143.268188 582.508545,143.009628 
	C582.593445,141.923340 583.563782,142.117401 584.631104,141.978333 
	C584.973206,141.972610 584.998291,141.998322 585.010620,142.011230 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M592.026794,146.695465 
	C592.040344,147.048431 592.017151,147.524826 592.009766,147.763214 
	C591.502991,147.740356 591.003479,147.479095 590.241699,147.112610 
	C590.033936,146.078903 590.332520,145.322754 591.662354,145.000031 
	C591.990051,145.399948 592.001648,145.871216 592.026794,146.695465 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M605.626892,165.015900 
	C605.520203,166.051346 604.793945,166.760239 603.318359,166.977219 
	C603.075867,165.564255 603.896973,164.971283 605.626892,165.015900 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M586.043152,148.325882 
	C586.438599,148.033081 586.878052,148.031143 587.646301,148.041260 
	C587.905273,148.706345 587.853760,149.469406 587.035217,149.506424 
	C586.733215,149.520065 586.403931,148.930954 586.043152,148.325882 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M581.622253,151.545837 
	C582.411377,151.324722 582.698425,151.601669 582.578918,152.214569 
	C582.554077,152.341904 582.373047,152.514084 582.244446,152.533035 
	C581.626038,152.624268 581.364441,152.323700 581.622253,151.545837 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M606.973450,148.714600 
	C606.843933,148.998840 606.675598,148.998306 606.254883,148.997711 
	C605.452515,148.600906 604.931396,148.026352 605.679016,147.545547 
	C606.382812,147.092926 606.752991,147.780106 606.973450,148.714600 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M591.046387,133.374786 
	C591.344910,133.742386 591.385071,134.109695 591.425171,134.476990 
	C591.162598,134.474777 590.900024,134.472565 590.637451,134.470352 
	C590.687622,134.105057 590.737854,133.739761 591.046387,133.374786 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M591.995117,123.004410 
	C591.476807,122.761215 590.950989,122.533707 590.469238,122.234924 
	C590.420959,122.204994 590.582397,121.565620 590.746338,121.511543 
	C591.501099,121.262581 591.789429,121.778725 591.979980,122.698944 
	C592.009766,122.990799 592.000000,122.999969 591.995117,123.004410 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M574.963867,166.718719 
	C574.371094,166.907913 573.656189,166.903854 573.515198,166.093597 
	C573.485535,165.922928 573.842407,165.684998 574.021240,165.478088 
	C574.323364,165.797867 574.625549,166.117645 574.963867,166.718719 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M566.285950,159.024353 
	C565.990234,159.005386 565.979187,158.506500 565.969849,158.257233 
	C566.720764,158.005722 567.480896,158.003479 568.620544,158.001221 
	C569.000000,158.001221 569.000000,158.000000 569.000000,157.999390 
	C568.944458,160.084656 567.581482,159.143661 566.285950,159.024353 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M579.480957,149.492294 
	C579.456543,149.104507 579.582520,148.869736 579.708496,148.634979 
	C579.920349,148.851959 580.132263,149.068954 580.344116,149.285950 
	C580.106506,149.405731 579.868896,149.525528 579.480957,149.492294 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M591.997559,148.997864 
	C591.876282,149.431244 591.757446,149.866745 591.638611,150.302246 
	C590.915222,149.983841 591.317383,149.614365 591.797485,149.126678 
	C592.004089,149.002640 592.000000,149.000000 591.997559,148.997864 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M576.001648,133.002472 
	C576.365295,132.746216 576.727234,132.487473 577.089233,132.228714 
	C577.178162,132.358429 577.267029,132.488129 577.355896,132.617859 
	C577.068298,132.736008 576.780640,132.854126 576.244080,132.983490 
	C575.995117,132.994736 576.000000,132.999985 576.001648,133.002472 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M603.008301,157.994537 
	C603.398804,158.346649 604.260437,158.570709 603.383545,159.284241 
	C603.260742,159.019119 603.138000,158.753998 602.997864,158.254822 
	C602.980469,158.020752 602.998230,158.001999 603.008301,157.994537 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M582.000000,131.000305 
	C582.117188,131.140930 582.234375,131.281250 582.351562,131.421570 
	C582.267944,131.372101 582.184326,131.322632 582.050354,131.136124 
	C582.000000,130.999084 582.000000,131.000000 582.000000,131.000305 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M614.998535,127.608017 
	C614.270142,128.007080 613.542725,128.017654 612.454895,128.053909 
	C611.289978,126.753716 608.658142,127.104729 609.004883,124.358444 
	C609.745972,123.998528 610.491943,123.998161 611.610413,123.997787 
	C614.358093,123.789215 615.208679,125.008278 614.998535,127.608017 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M557.333496,143.975555 
	C556.920349,142.387772 557.139465,140.987015 559.628296,141.016098 
	C559.933105,142.541031 559.295471,143.629379 557.333496,143.975555 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M222.396759,415.697418 
	C222.134796,416.475159 222.045380,416.885498 221.873764,417.493896 
	C221.487381,417.752960 221.183182,417.813995 220.418640,417.943481 
	C217.662430,418.851471 215.357239,419.356323 212.751511,418.048523 
	C212.211441,417.646057 212.004623,417.351227 211.698410,417.096558 
	C211.321899,417.312103 211.174835,417.406708 210.796967,417.630127 
	C210.406937,417.837341 210.247726,417.915649 209.842133,418.098999 
	C209.423218,418.253021 209.250687,418.301971 208.809998,418.329895 
	C208.315079,418.244659 208.088364,418.180389 207.516464,418.039948 
	C206.125732,418.986053 204.728882,418.181396 203.265503,418.727478 
	C202.311829,418.916626 201.665146,418.925934 200.693146,418.857147 
	C199.538681,418.660736 198.723785,418.358978 197.546051,418.598663 
	C197.030655,418.694275 196.824234,418.726929 195.708206,418.699585 
	C194.034317,418.465881 193.267487,418.362762 192.196533,418.616333 
	C191.498566,418.727417 191.094543,418.719696 190.397583,418.567017 
	C189.752899,418.251617 189.454483,417.977509 189.169098,417.941040 
	C188.950653,418.380402 188.784210,418.513336 188.315216,418.767151 
	C186.890686,419.136383 185.795517,419.115448 184.494232,418.346863 
	C183.911072,418.282684 183.586868,418.435425 183.116699,418.820282 
	C182.815826,419.182037 182.660950,419.311737 182.209152,419.496460 
	C181.517242,419.563690 181.122604,419.583008 180.441010,419.653137 
	C179.775238,419.753723 179.394699,419.783630 178.735672,419.747314 
	C178.105148,419.586639 177.750076,419.577271 177.180664,419.871735 
	C176.967270,420.040710 177.028534,420.032043 177.029785,420.001129 
	C175.046692,421.330139 172.734604,420.619476 170.270844,420.975525 
	C169.126266,420.842041 168.323517,420.587067 167.170090,420.624512 
	C166.650375,420.633118 166.441605,420.629272 165.921066,420.596252 
	C164.785629,420.459381 163.961929,420.351440 162.935059,421.013489 
	C162.479919,421.311493 162.291580,421.424713 161.796204,421.666412 
	C161.270599,421.837921 161.052063,421.880920 160.499725,421.946899 
	C158.828354,422.005249 157.490616,421.983307 155.822418,421.989807 
	C155.053680,422.012604 154.619217,422.061371 153.868774,422.205078 
	C153.335190,422.295959 153.121429,422.325806 152.587982,422.395966 
	C151.426697,422.577087 150.591797,422.780762 149.427277,422.624268 
	C148.135086,422.093506 147.160904,422.275391 145.923218,422.766174 
	C145.288437,423.087982 144.907089,423.229736 144.205444,423.309052 
	C142.676453,422.816925 141.420563,423.316040 139.874390,423.130463 
	C139.138611,423.177368 138.733353,423.296417 138.019348,423.496063 
	C137.492126,423.462585 137.286926,423.395142 136.820328,423.136353 
	C136.558914,422.945007 136.375488,422.932251 136.283936,422.940491 
	C135.885178,423.304199 135.504654,423.531830 134.701370,423.561279 
	C133.870621,423.782776 134.025238,422.205536 133.012817,423.323151 
	C132.042084,423.644043 131.363220,423.558167 130.404572,423.261139 
	C127.918991,423.119629 125.675423,422.560791 123.249573,423.764435 
	C122.296104,424.586548 121.546883,424.745575 120.387650,424.250824 
	C119.794571,424.059723 119.532448,424.098114 118.880585,424.214050 
	C116.492928,425.437531 114.200279,424.851379 111.683182,425.382996 
	C110.435356,425.344452 109.619812,425.208099 108.480835,424.698547 
	C107.747490,423.293335 107.367859,422.104919 106.967621,420.540100 
	C109.335838,420.020966 111.724670,419.878235 114.562042,419.678772 
	C115.421478,419.735657 115.832375,419.849304 116.572014,419.959473 
	C117.703575,419.964050 118.506393,419.972076 119.710281,419.960724 
	C122.670128,419.824921 125.228920,419.708466 128.201355,419.679993 
	C133.806992,419.180603 138.998978,418.593292 144.619324,417.991394 
	C145.665268,417.895386 146.282883,417.813904 147.211121,417.766602 
	C147.824982,417.679993 148.128204,417.559143 148.873169,417.649536 
	C149.604065,417.401062 149.893234,416.941345 150.330582,416.250580 
	C150.478775,416.019531 150.440201,416.005859 150.420212,416.010925 
	C150.921082,416.717682 151.373444,417.531708 152.685654,417.138550 
	C155.054886,416.038177 157.312851,416.668915 159.988739,416.711731 
	C163.974991,415.426147 167.954147,416.809906 171.702515,414.758820 
	C173.324020,416.098450 174.935211,416.171234 176.876129,414.942322 
	C178.774017,415.561127 180.541855,415.283203 182.509857,414.425476 
	C183.116348,414.072906 183.529510,414.044708 184.252670,413.995605 
	C185.039658,414.101562 185.464615,414.649963 186.280609,414.072937 
	C186.542740,413.991486 186.558975,414.013702 186.541260,414.017975 
	C187.512421,415.030487 188.874146,414.503448 190.383026,414.859131 
	C191.852158,414.922668 192.719254,414.631256 193.047607,413.025757 
	C195.818222,412.782654 198.519653,412.915466 201.619934,412.994781 
	C203.444626,412.701416 204.870483,412.461548 206.665192,412.207977 
	C207.469376,412.062561 207.911362,411.959534 208.700775,411.895111 
	C210.764725,412.032776 212.487946,412.160492 214.642639,412.317444 
	C216.170441,412.601959 217.278305,412.516052 218.681091,412.306519 
	C219.412537,412.078308 219.848099,412.002014 220.615570,411.901428 
	C221.160339,412.171600 221.373215,412.466125 221.828354,412.891602 
	C222.521561,413.730164 222.743912,414.487183 222.396759,415.697418 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M202.422791,472.118835 
	C200.329758,469.383942 198.862762,471.270020 197.184372,472.660767 
	C194.980011,472.858887 192.946686,472.816620 190.473145,472.710754 
	C188.479385,468.722107 184.067352,472.535675 182.049454,469.386780 
	C190.690308,468.758240 199.386215,468.461487 208.535309,468.186615 
	C208.682083,469.182373 208.375702,470.156250 208.020813,471.435303 
	C207.541245,471.837677 207.110184,471.934875 206.348633,472.005951 
	C205.862488,471.850647 205.706848,471.721436 205.275543,471.719055 
	C204.264175,471.922272 203.528488,471.998688 202.422791,472.118835 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M148.369034,436.702148 
	C146.335251,436.621552 144.771622,438.840637 142.974655,437.273743 
	C142.764267,437.090271 142.916672,436.305939 143.099564,435.886841 
	C144.147018,433.486572 146.324875,433.932831 148.240448,434.053650 
	C152.891174,434.347076 157.409592,433.187988 162.005478,432.975861 
	C163.707932,432.897278 166.335480,432.259827 166.678711,434.363647 
	C167.142944,437.208923 163.745224,435.384766 162.246735,436.742065 
	C161.400391,436.556610 160.931610,436.315948 160.269547,435.986511 
	C160.076599,435.897125 159.704071,435.854401 159.598618,436.013062 
	C159.493164,436.171753 159.389694,436.549133 159.241852,436.677246 
	C156.648163,436.572662 154.100433,438.266602 151.459808,436.233459 
	C150.400711,436.540314 149.436890,436.070679 148.369034,436.702148 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M168.756821,420.131104 
	C171.495789,420.018188 173.875137,418.767853 176.706375,419.784851 
	C176.999695,421.810059 175.871048,422.551910 174.226456,422.589874 
	C168.132721,422.730499 162.037781,422.818970 155.478073,422.966736 
	C154.910614,422.809143 154.808380,422.611847 154.813660,422.099060 
	C156.648407,421.504822 158.375626,421.226074 160.540192,420.984558 
	C161.159164,421.146576 161.340775,421.271393 161.843750,421.318695 
	C162.165100,421.241150 162.154373,421.125031 162.189453,421.171600 
	C162.989197,420.016296 164.096512,419.512207 165.772888,419.884644 
	C166.046356,420.159271 166.341522,420.441437 166.541534,420.482361 
	C167.342819,420.557556 167.920013,420.457062 168.756821,420.131104 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M206.317368,460.544983 
	C200.951920,460.968384 195.856583,461.165344 190.759369,461.274048 
	C189.712143,461.296387 188.074615,461.608978 188.276978,459.816986 
	C188.414688,458.597412 189.803040,458.736694 190.711227,458.901978 
	C195.827194,459.833191 200.951859,456.801483 206.048096,459.370361 
	C206.226089,459.945099 206.406464,460.116180 206.317368,460.544983 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M204.990845,438.430969 
	C208.592499,436.094849 212.215500,437.640045 215.677734,437.349121 
	C216.052017,437.317688 216.808929,438.149231 216.829712,438.605896 
	C216.851944,439.094757 216.234879,440.034637 215.859100,440.054260 
	C212.158951,440.247345 208.449539,440.366455 204.746567,440.298828 
	C204.133942,440.287659 204.248566,439.251984 204.990845,438.430969 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M179.660980,435.106079 
	C176.487167,436.522736 173.533020,436.995941 170.398056,436.166534 
	C169.401611,435.902924 168.356949,435.830017 168.350266,434.502014 
	C168.342972,433.049866 169.563583,433.001892 170.474930,433.064575 
	C173.416199,433.266968 176.346100,433.634399 179.629395,433.927002 
	C180.194580,434.293060 180.198944,434.666718 179.660980,435.106079 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M171.129440,455.609131 
	C167.952530,456.041016 164.939499,456.129425 161.473938,456.196655 
	C160.431839,456.076630 159.875870,456.157227 159.112793,456.624847 
	C158.504089,456.726959 158.148788,456.689423 157.547516,456.536865 
	C156.434113,456.015533 156.371262,455.291382 156.757935,454.160095 
	C161.396240,453.994232 165.856674,452.869324 170.497711,454.516632 
	C170.945572,454.896210 171.119461,455.080963 171.129440,455.609131 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M185.058685,440.789001 
	C181.791306,442.047882 178.790405,442.977203 175.299835,442.444824 
	C174.625183,441.737640 174.467270,441.197784 174.779938,440.209747 
	C178.101303,439.510712 181.145721,438.618530 184.730621,439.048920 
	C185.453018,439.551025 185.513657,440.028168 185.058685,440.789001 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M209.981506,417.206604 
	C210.221115,417.082245 210.619629,417.057312 210.806366,416.986694 
	C211.154785,416.757080 211.316452,416.598114 211.743729,416.651550 
	C214.333359,418.216553 216.918335,417.298065 219.654510,417.859772 
	C216.458099,421.325531 212.565811,420.090424 208.613190,418.646301 
	C208.541809,418.308899 208.813110,418.301025 208.895767,418.193390 
	C209.195328,417.796112 209.449860,417.544556 209.981506,417.206604 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M180.351776,446.904480 
	C182.519928,443.944122 185.464630,446.818695 187.949448,445.501617 
	C188.751740,445.076324 189.455307,447.214813 188.590469,447.576111 
	C185.884018,448.706726 182.966782,449.583313 180.351776,446.904480 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M198.158295,445.462036 
	C199.681793,444.981964 200.809677,444.895966 201.196487,446.486603 
	C201.550735,447.943329 200.446609,448.104523 199.401169,448.084595 
	C197.083221,448.040466 194.766754,447.905884 192.448837,447.878082 
	C191.590393,447.867767 190.698792,448.064636 190.913940,446.733551 
	C191.063187,445.810089 191.930542,444.843811 192.522537,445.276489 
	C194.388214,446.639923 196.115601,444.532074 198.158295,445.462036 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M166.953217,460.717041 
	C169.387344,462.729919 172.396881,458.349396 174.450195,461.489685 
	C171.931824,462.744476 169.286697,463.242920 166.594803,463.051788 
	C165.268967,462.957642 162.805542,463.728302 162.781128,462.190643 
	C162.739441,459.563568 165.265335,461.240143 166.953217,460.717041 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M156.720200,453.631592 
	C157.064301,454.487946 157.146545,455.133942 157.265167,456.100891 
	C154.215988,457.692810 151.011337,456.705414 147.406189,456.878418 
	C146.683609,455.458923 147.915054,455.652893 148.803925,455.007324 
	C151.492432,454.304565 153.975372,453.862885 156.720200,453.631592 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M122.730278,456.605042 
	C125.455986,457.143341 127.799896,456.688385 130.516113,456.172363 
	C131.812439,456.009491 132.671021,456.253510 133.830780,456.672363 
	C134.206406,457.027344 134.277878,457.239716 134.081879,457.655701 
	C129.552811,458.215912 125.293037,458.597626 121.028099,458.908752 
	C120.139656,458.973572 118.762932,459.249512 119.049995,457.663086 
	C119.215317,456.749512 120.271759,456.741272 121.558952,456.915649 
	C122.137848,456.791748 122.284637,456.626099 122.730278,456.605042 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M141.960419,451.536194 
	C140.553833,451.337372 138.800812,452.405365 138.571411,451.020660 
	C138.246490,449.059326 140.817917,449.012634 141.380112,449.356079 
	C144.093628,451.013611 147.459335,447.144745 150.032959,450.459808 
	C147.488693,452.252563 144.732910,450.372467 141.960419,451.536194 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M128.984543,449.537231 
	C130.841919,449.384674 132.636490,448.829865 133.858170,449.433838 
	C134.827484,449.912994 137.573761,448.708740 136.793350,451.334656 
	C136.380020,452.725464 134.682724,453.621368 133.209030,452.707336 
	C131.791824,451.828369 130.365372,452.220581 128.555740,451.921387 
	C127.486694,450.925690 128.009064,450.263580 128.984543,449.537231 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M163.157532,428.385864 
	C164.612961,424.142883 168.066589,427.340210 170.735229,426.142303 
	C171.818542,426.909180 172.964920,427.230103 173.126984,428.683105 
	C169.823318,428.873260 166.620499,428.561462 163.184235,429.607422 
	C162.835480,429.494415 162.716446,429.101593 162.815094,428.924377 
	C162.913727,428.747131 163.311310,428.742249 163.157532,428.385864 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M179.693008,435.380981 
	C179.547821,434.875946 179.732925,434.575958 179.948212,434.095886 
	C183.265762,433.645844 186.553116,433.375946 191.245941,432.990601 
	C187.081360,436.314087 183.416763,435.355652 179.693008,435.380981 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M173.401382,429.081116 
	C172.832825,427.821411 170.942001,428.216339 171.074051,426.489502 
	C175.490036,425.834015 179.872971,425.791870 184.669495,426.353333 
	C185.213684,426.612762 185.334442,426.896881 185.234619,427.588196 
	C181.261765,428.279633 177.254898,426.162476 173.401382,429.081116 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M206.476257,460.912842 
	C206.053528,460.631317 206.059143,460.459930 206.055237,460.031311 
	C209.183044,457.104431 211.604431,457.234344 215.191299,461.023010 
	C211.955856,461.023010 209.430237,461.023010 206.476257,460.912842 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M154.661118,421.550232 
	C154.920563,422.056580 154.937561,422.328491 154.992538,422.802887 
	C151.822556,425.318085 148.082901,422.617950 144.406967,423.637085 
	C144.245605,422.902954 144.481720,422.657166 144.857193,422.196869 
	C145.962509,421.242004 147.081360,421.592010 148.540161,421.637146 
	C149.735901,421.554871 150.535461,421.376465 151.638550,421.115601 
	C152.126358,421.152069 152.310654,421.270966 152.768005,421.206360 
	C153.494385,421.120850 153.947708,421.218872 154.661118,421.550232 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M133.968689,429.096313 
	C136.483185,429.936279 139.091232,427.924042 141.545166,430.093353 
	C138.813065,432.178528 135.937759,431.696594 133.435135,431.429260 
	C131.429031,431.214905 131.908707,429.852386 133.968689,429.096313 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M148.826157,428.313049 
	C150.606094,428.485260 152.242401,428.933075 154.743896,429.617676 
	C150.333145,432.018219 146.785172,430.280884 142.054428,431.231445 
	C144.702988,428.324646 147.433731,430.947266 148.826157,428.313049 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M215.829315,425.849915 
	C213.383743,425.012360 209.865524,428.502411 209.471024,424.851776 
	C209.271622,423.006653 213.408661,424.397736 215.547516,424.024231 
	C216.500549,423.857819 217.506805,423.996094 218.514420,423.996094 
	C218.634445,425.972839 217.316498,425.767670 215.829315,425.849915 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M201.088364,453.373932 
	C203.650940,452.465607 205.806381,449.912750 208.853668,451.825623 
	C209.389923,452.491516 209.534576,452.950134 209.236389,453.793579 
	C206.361771,454.236389 203.679062,455.128387 201.088364,453.373932 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M180.711243,461.849548 
	C181.236618,460.913300 176.944977,459.389252 180.804535,459.179688 
	C182.536896,459.085663 184.278625,459.163788 186.384659,459.163788 
	C185.050674,461.604065 183.130646,462.039520 180.711243,461.849548 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M207.294556,432.897522 
	C205.172546,433.286804 203.315170,432.642975 201.497330,433.959961 
	C200.507843,434.676788 199.677475,433.526550 199.386749,432.540253 
	C198.877365,430.812256 200.195435,431.220306 201.097580,431.223358 
	C202.908035,431.229462 204.718414,431.257782 206.775482,431.595886 
	C207.201096,432.132477 207.380020,432.350128 207.294556,432.897522 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M207.486237,433.177368 
	C207.037003,433.008453 207.043839,432.789642 207.036423,432.242828 
	C210.609009,431.820679 214.244308,429.945282 217.781433,431.680237 
	C217.789566,432.162689 217.797714,432.645111 217.805862,433.127533 
	C214.518005,433.127533 211.230164,433.127533 207.486237,433.177368 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M209.549820,445.429749 
	C210.107971,444.807983 210.664795,444.235596 210.887085,444.344696 
	C212.453339,445.113647 214.492126,443.419067 215.776031,445.274719 
	C216.178757,445.856812 216.096237,446.762848 215.315521,446.754486 
	C213.313522,446.733002 210.973038,448.435791 209.549820,445.429749 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M110.877716,425.309265 
	C113.268166,424.780548 115.457779,424.467377 118.069122,424.222900 
	C117.157417,427.530914 114.294540,426.706909 111.414238,426.684204 
	C110.725502,426.280304 110.611740,425.934631 110.877716,425.309265 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M163.138580,429.134216 
	C162.957016,429.519073 162.895554,429.512573 162.865509,429.503479 
	C160.492966,429.560486 157.506287,431.513519 156.531235,427.292694 
	C158.528275,427.048462 160.474838,426.387268 162.654022,427.866760 
	C163.003738,428.029510 163.006104,427.982422 162.982330,427.980652 
	C163.079086,428.235687 163.199631,428.492523 163.138580,429.134216 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M185.468170,428.060272 
	C185.016296,427.718994 185.018555,427.442627 185.056885,426.747437 
	C187.531891,425.386139 189.991760,424.101410 192.563629,426.811432 
	C190.790390,428.415131 188.378235,428.391113 185.468170,428.060272 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M123.995804,431.866089 
	C122.639648,431.910004 121.347923,432.584412 121.024536,431.358459 
	C120.622040,429.832703 122.027252,430.073090 122.920097,430.237885 
	C125.130295,430.645874 127.679871,428.310516 129.811798,431.195129 
	C128.106659,432.644592 126.257118,432.217957 123.995804,431.866089 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M199.788025,417.954834 
	C200.786896,418.108215 201.510071,417.930847 202.612152,417.744293 
	C203.731094,417.467590 204.435654,417.505676 205.297195,418.288086 
	C205.551987,418.841675 205.599289,419.085938 205.545563,419.689514 
	C202.651749,420.043671 199.858948,420.038544 196.612717,419.970581 
	C195.684845,419.590393 195.513458,419.154022 195.962128,418.381866 
	C196.279083,418.165100 196.664566,418.092834 196.837891,418.001129 
	C197.797638,417.399902 198.655334,417.515167 199.788025,417.954834 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M128.918365,449.313660 
	C128.976196,450.078857 128.657867,450.718201 128.246765,451.611481 
	C127.968178,451.874146 127.782356,451.882874 127.318054,451.873932 
	C126.419708,451.958984 125.842834,452.168427 125.064919,452.700500 
	C123.695396,452.792297 122.593681,452.727234 121.199081,452.504913 
	C120.912094,451.509705 121.125214,450.747467 122.114243,450.032715 
	C124.520790,449.690216 126.531479,449.438995 128.918365,449.313660 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M159.722443,440.720093 
	C160.979233,441.098999 161.957977,441.233917 163.187668,441.647522 
	C163.624817,442.410645 163.645111,442.901917 163.305206,443.723206 
	C161.327469,444.057281 159.543991,444.068268 157.310959,444.068176 
	C156.610138,443.708344 156.351212,443.365326 155.967392,442.402496 
	C156.675735,440.304871 157.771072,441.671173 158.907104,441.315857 
	C159.210434,440.910370 159.327408,440.693268 159.722443,440.720093 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M196.787628,439.319336 
	C198.331268,438.215393 199.403229,436.486664 201.264435,437.634644 
	C201.692444,437.898621 202.056915,438.873505 201.909897,439.356720 
	C201.271774,441.453979 199.359711,440.935547 197.406006,441.057251 
	C196.623978,440.612579 196.477020,440.156158 196.787628,439.319336 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M143.774414,422.882172 
	C144.009460,423.148712 144.093689,423.470215 144.092285,423.636169 
	C141.620590,424.042847 139.104889,426.116364 136.630676,423.282043 
	C136.805115,422.899902 137.051300,422.854797 137.668335,422.750977 
	C138.246384,422.598175 138.453629,422.504059 138.969025,422.263000 
	C140.697937,422.282593 142.118652,422.449127 143.774414,422.882172 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M114.873131,445.303223 
	C116.506386,441.117249 119.211479,443.757477 121.965210,443.551056 
	C120.040863,447.054016 117.126770,444.781403 114.873131,445.303223 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M193.239532,426.961792 
	C192.916702,426.859467 192.973831,426.955414 192.969086,426.985229 
	C194.466919,423.724365 196.947479,425.521301 199.477020,425.773071 
	C199.960190,425.903076 200.107819,426.087646 200.141693,426.608032 
	C197.885681,427.678467 195.732651,427.835083 193.239532,426.961792 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M184.986420,441.181824 
	C184.825668,440.604004 184.872635,440.165222 185.038147,439.415161 
	C187.162491,439.152893 189.168274,439.201965 191.598236,439.151733 
	C192.352264,439.371674 192.497314,439.759979 192.263077,440.481995 
	C190.984085,440.904419 189.900024,441.062134 188.406982,441.264832 
	C187.666992,441.382080 187.370087,441.525146 186.858978,441.759003 
	C186.138474,441.626282 185.666290,441.473572 184.986420,441.181824 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M197.415726,432.945557 
	C196.062637,435.767151 194.335831,434.438324 192.193283,433.766693 
	C193.855896,431.698395 195.585007,432.127747 197.415726,432.945557 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M110.693550,425.150330 
	C111.069458,425.458344 111.060364,425.822906 111.048355,426.369720 
	C109.337646,426.746124 107.629852,426.940277 105.498474,427.058655 
	C105.226173,425.507477 106.155472,424.833710 107.823929,424.545441 
	C108.854256,424.723480 109.581398,424.965210 110.693550,425.150330 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M184.146301,418.516083 
	C185.592972,418.138275 186.950668,418.146637 188.715576,418.205994 
	C189.646301,418.803162 189.721313,419.449310 189.339447,420.424805 
	C187.280746,420.554260 184.683044,422.515289 184.146301,418.516083 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M135.146454,435.636597 
	C136.639801,436.097748 137.542191,436.973816 136.285583,438.125427 
	C134.946259,439.352875 133.124374,438.719208 131.504028,438.639343 
	C131.306107,438.629608 130.902985,437.796753 131.006027,437.478363 
	C131.656021,435.469604 133.201004,436.995422 134.509171,436.500793 
	C134.764893,436.098022 134.820892,435.915527 135.146454,435.636597 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M189.490341,420.796570 
	C189.129532,420.088043 189.125275,419.477936 189.121918,418.562439 
	C189.122803,418.257019 189.131836,418.108551 189.072403,418.063812 
	C189.165146,417.899872 189.317307,417.780670 189.732529,417.783417 
	C190.429703,417.979034 190.863815,418.052765 191.628418,418.111847 
	C192.814575,417.938171 193.603928,417.346405 194.706238,417.991760 
	C194.873993,418.281708 194.684189,418.238495 194.666168,418.334137 
	C195.298447,418.451233 195.558060,418.781494 195.114609,419.653442 
	C193.148712,420.223907 191.497803,420.559418 189.490341,420.796570 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M133.315033,444.566803 
	C132.890869,444.898438 132.677933,444.900818 132.148254,444.861816 
	C131.450806,444.588989 131.040161,444.457153 130.336899,444.650482 
	C129.290680,444.888397 128.500137,444.924103 127.314575,444.929504 
	C126.576653,444.470337 126.454483,443.985840 126.773972,443.124329 
	C128.574814,441.438812 130.493835,442.056458 132.676483,441.971008 
	C133.586746,442.699799 133.746231,443.429443 133.315033,444.566803 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M203.668976,445.512329 
	C205.169357,445.174530 206.608093,443.644196 207.759460,445.400665 
	C208.363663,446.322449 207.719696,447.148682 206.805008,446.961273 
	C205.684143,446.731689 203.374664,449.463257 203.668976,445.512329 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M105.285507,433.040009 
	C104.906281,432.571808 104.915756,432.127716 105.006897,431.359192 
	C107.678497,431.371368 112.569199,430.249420 112.466064,431.478241 
	C112.189957,434.767670 108.307747,430.413452 106.590141,432.799225 
	C106.444061,433.002136 105.986877,432.981110 105.285507,433.040009 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M117.273148,450.812317 
	C116.645920,453.917999 114.334435,452.260773 112.740913,452.611938 
	C112.077843,452.758026 111.742004,451.776642 111.964638,451.182953 
	C112.533585,449.665649 113.902924,449.793915 115.591843,449.896698 
	C116.425743,450.024811 116.800690,450.220886 117.273148,450.812317 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M181.664337,418.713104 
	C182.142563,418.920258 182.304016,418.969818 182.718094,419.035889 
	C181.850479,421.451630 180.606567,423.309967 178.070221,419.831512 
	C178.396149,419.398651 178.864761,419.274567 179.674194,419.021088 
	C180.419998,418.624207 180.866150,418.519958 181.664337,418.713104 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M144.601898,455.753540 
	C144.707535,456.169708 144.450012,456.369202 144.164719,456.513916 
	C142.980972,457.114349 142.072662,458.816376 140.425888,457.556854 
	C140.155716,457.350220 139.996078,456.599701 140.155975,456.295197 
	C141.154251,454.394135 142.658875,454.700653 144.601898,455.753540 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M142.784607,442.103363 
	C144.048737,440.742157 145.300980,441.174072 146.846603,441.166687 
	C147.735535,441.918884 147.759277,442.692322 147.134430,443.791595 
	C145.909729,444.129395 144.969742,444.174011 143.675720,444.175781 
	C142.738876,443.752411 142.484787,443.216187 142.784607,442.103363 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M174.672348,439.811951 
	C175.060379,440.360046 175.115295,440.886810 175.099152,441.809753 
	C173.032364,442.402008 171.036636,442.598175 168.670013,442.821045 
	C167.758621,442.638184 167.502319,442.243927 167.696930,441.315002 
	C167.863571,440.965088 167.969360,440.976715 167.971191,440.923523 
	C169.307175,439.894562 170.795731,439.671997 172.715881,440.034302 
	C173.474304,439.999359 173.906769,439.895020 174.672348,439.811951 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M147.265045,444.154205 
	C146.940689,443.361786 147.031662,442.638824 147.167297,441.553101 
	C148.140884,441.274078 149.069824,441.357849 150.340973,441.348236 
	C151.612885,441.726166 151.718491,442.511688 151.269440,443.771057 
	C149.914154,444.157440 148.797256,444.190552 147.265045,444.154205 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M133.450317,444.923462 
	C133.063034,444.182068 133.022278,443.468048 133.027145,442.398743 
	C134.100571,442.044525 135.128372,442.045624 136.536469,442.116028 
	C137.269073,442.532166 137.437637,442.952667 137.196640,443.722778 
	C136.130814,445.042694 134.894806,444.766632 133.450317,444.923462 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M171.356827,456.035278 
	C170.941879,455.744202 170.918228,455.535828 170.833130,455.019470 
	C170.899597,452.285675 172.562912,453.046173 173.903702,453.236237 
	C174.632507,453.339600 175.056076,453.927673 174.882919,454.595398 
	C174.453156,456.252563 172.909561,455.837067 171.356827,456.035278 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M180.233398,454.408875 
	C179.270294,456.160309 177.940155,455.935272 176.732742,455.453247 
	C176.391815,455.317078 176.068893,454.156708 176.285309,453.784637 
	C176.974747,452.599487 178.259552,453.137390 179.736053,453.144653 
	C180.410934,453.489899 180.497314,453.826752 180.233398,454.408875 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M180.360199,454.892334 
	C180.231644,454.324310 180.285156,454.015442 180.171677,453.443787 
	C182.046051,452.728088 183.779800,453.110352 186.054367,454.168640 
	C184.041229,455.750732 182.320938,455.265533 180.360199,454.892334 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M172.080139,447.823425 
	C173.914490,447.820740 173.964981,445.607117 175.168823,445.886383 
	C176.462433,446.186462 178.789185,444.695923 178.912323,446.765808 
	C179.073166,449.470001 177.155273,447.029633 176.215012,447.288055 
	C174.899628,447.649597 174.895447,450.640991 172.310822,449.011047 
	C171.881790,448.670197 171.783432,448.373322 172.080139,447.823425 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M122.242111,449.703369 
	C122.163612,450.577423 121.817123,451.213440 121.188416,452.098572 
	C119.950546,452.489075 119.057747,452.451416 118.297768,450.891907 
	C119.276230,449.440552 120.459137,448.670593 122.242111,449.703369 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M134.183624,457.896545 
	C133.814423,457.859253 133.824402,457.567047 133.877151,457.430725 
	C133.757721,457.068237 133.585526,456.842072 133.694824,456.295654 
	C135.537964,454.545319 137.126938,455.715179 139.259476,455.364166 
	C137.729782,457.439453 136.020081,457.435944 134.183624,457.896545 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M130.073578,423.350891 
	C130.850342,423.021759 131.576172,422.981506 132.660202,422.838898 
	C133.018417,422.736572 133.480713,422.624084 133.718445,422.615326 
	C134.451614,422.689270 134.947067,422.771973 135.817444,422.901733 
	C134.522247,426.629486 132.197601,424.466431 130.073578,423.350891 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M200.290466,427.134460 
	C200.007660,426.737030 199.987366,426.530182 199.889801,426.020935 
	C201.215988,424.732330 203.209946,423.966370 203.663452,425.985657 
	C204.075623,427.820892 201.953217,427.588379 200.290466,427.134460 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M167.260498,447.772705 
	C165.377609,449.104004 163.668442,449.151245 161.575409,448.307922 
	C160.981003,448.249268 160.708511,448.274078 160.499512,447.893372 
	C162.392563,446.655731 164.324081,447.137970 166.624359,447.054688 
	C167.196732,447.221893 167.356064,447.384064 167.260498,447.772705 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M156.910385,462.224213 
	C156.363937,462.083405 156.041077,461.756226 155.990555,461.457092 
	C156.579117,461.044189 157.214340,460.873016 157.858170,460.829559 
	C158.920425,460.757874 160.712646,460.297272 160.524582,461.816711 
	C160.289505,463.715851 158.553253,462.363434 156.910385,462.224213 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M192.024597,452.105957 
	C192.451279,454.845032 192.451279,454.845032 187.430756,454.575195 
	C189.259598,454.408539 190.795563,453.783173 192.024597,452.105957 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M103.837296,439.273926 
	C103.610680,438.826538 103.694656,438.661133 103.882668,438.237671 
	C105.390419,438.029083 106.794151,438.078552 108.627594,438.128052 
	C109.336136,438.477692 109.465134,438.875793 109.248894,439.582611 
	C107.426216,439.611206 105.728386,440.586517 103.837296,439.273926 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M151.209381,444.331024 
	C150.937836,443.407501 150.844620,442.690674 150.717285,441.614349 
	C151.639099,441.236389 152.595001,441.217926 153.844482,441.179810 
	C154.520767,441.850189 154.780167,442.559021 154.243271,443.664703 
	C153.148941,444.212036 152.399734,444.988220 151.209381,444.331024 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M116.289780,430.084137 
	C117.608070,430.063232 119.036560,429.760010 118.974869,431.041870 
	C118.890175,432.801788 116.905563,432.673126 115.974312,432.459778 
	C114.504044,432.122986 114.567627,430.975555 116.289780,430.084137 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M172.812408,439.825073 
	C171.564941,440.344177 170.088058,440.584656 168.292084,440.847717 
	C168.841919,438.103912 170.751938,438.962677 172.812408,439.825073 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M197.466370,455.071472 
	C196.263245,454.661285 194.508514,455.930603 194.717102,453.807434 
	C194.791809,453.046875 195.339569,451.828857 196.068909,452.302795 
	C196.891861,452.837585 199.872528,452.548553 197.466370,455.071472 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M109.420288,439.990540 
	C109.056999,439.461792 109.060539,439.080841 109.060699,438.414001 
	C110.054176,436.986267 111.371964,436.484497 112.014374,438.116089 
	C112.717087,439.900848 111.094009,440.056732 109.420288,439.990540 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M192.423080,440.876007 
	C192.066498,440.369965 192.064835,439.993195 192.042816,439.334473 
	C193.160553,438.937134 194.298660,438.821808 195.665039,438.866028 
	C196.377228,439.366882 196.555878,439.827118 196.111526,440.648438 
	C194.787216,440.929321 193.782608,440.967316 192.423080,440.876007 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M116.374268,439.205444 
	C116.122490,436.639832 116.122490,436.639832 120.853645,438.497711 
	C119.592331,439.793671 118.061249,438.932190 116.374268,439.205444 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M106.489769,445.772949 
	C106.113930,445.606140 106.133057,445.338623 106.093826,445.210632 
	C107.401466,442.560638 109.537331,446.104218 111.017418,444.284302 
	C110.369484,447.006409 108.381882,445.824127 106.489769,445.772949 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M167.279297,448.196594 
	C167.005585,447.999207 166.990387,447.528442 167.013885,447.294067 
	C168.692749,446.994110 170.348099,446.928467 172.239349,447.216644 
	C172.367493,447.794250 172.259735,448.018066 172.066071,448.604492 
	C170.693298,447.317017 168.785385,450.464661 167.279297,448.196594 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M115.480499,457.734955 
	C115.000816,458.378510 114.427078,459.070984 114.023048,458.983093 
	C112.983894,458.757050 111.019920,460.284027 111.026489,458.107697 
	C111.032089,456.251831 112.956558,457.055481 114.553459,456.991760 
	C115.142708,457.174377 115.303230,457.301392 115.480499,457.734955 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M137.325195,443.997131 
	C136.919739,443.596039 136.868607,443.193359 136.867142,442.487976 
	C137.560760,440.654572 138.571762,441.525787 139.776962,441.922638 
	C140.416412,442.502167 140.524811,443.003937 140.093857,443.832703 
	C139.092346,444.069763 138.385941,444.032654 137.325195,443.997131 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M126.202950,437.539581 
	C126.055763,440.022552 124.442101,438.637268 123.340385,438.779449 
	C123.247581,438.791382 122.837868,437.975098 122.959023,437.750824 
	C123.695160,436.388092 124.838570,436.984100 126.202950,437.539581 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M209.365112,454.216614 
	C209.023941,453.661377 209.024826,453.216736 209.020706,452.438690 
	C209.950348,451.923492 211.046722,451.640472 211.391922,452.851135 
	C211.785751,454.232208 210.650009,454.258698 209.365112,454.216614 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M158.956421,435.748047 
	C160.614563,433.606842 160.752838,435.762238 161.720825,436.564636 
	C161.169067,436.861115 160.471237,436.920532 159.433716,436.892700 
	C159.094009,436.805389 159.034607,436.327911 158.956421,435.748047 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M120.050934,424.356567 
	C120.786453,424.010193 121.516212,423.999023 122.611366,424.023682 
	C122.453514,426.375183 121.494888,426.671997 120.050934,424.356567 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M205.956268,419.797852 
	C205.046158,419.250885 204.388977,418.719818 203.361420,417.961914 
	C204.171951,416.648010 205.363846,417.220856 206.863251,417.837585 
	C206.850586,418.580444 206.529892,419.197113 205.956268,419.797852 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M145.194809,456.326233 
	C144.977814,455.995392 144.987946,455.929718 144.981293,455.920166 
	C145.686951,454.587097 147.023605,454.984802 148.572662,454.755066 
	C149.001495,455.881653 148.017471,455.954346 147.120926,456.577179 
	C146.432159,456.777435 145.921982,456.717255 145.194809,456.326233 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M126.602539,442.799652 
	C126.990128,443.269806 126.985336,443.736603 126.950043,444.551300 
	C125.978180,444.826050 125.036812,444.752869 123.833366,444.430237 
	C123.595703,443.960388 123.620117,443.739990 123.751694,443.204773 
	C124.642624,442.858734 125.426392,442.827515 126.602539,442.799652 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M140.241547,444.125641 
	C139.877396,443.652618 139.956024,443.198364 140.049133,442.398682 
	C140.796967,441.923798 141.530304,441.794403 142.636719,441.673767 
	C143.051941,442.231079 143.094070,442.779572 143.228943,443.730499 
	C142.442566,444.136719 141.563461,444.140564 140.241547,444.125641 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M154.290436,448.125580 
	C155.654236,448.110413 156.510162,448.749664 156.220917,449.553772 
	C155.839417,450.614349 154.533829,450.549591 153.697998,450.139069 
	C152.560791,449.580444 153.264084,448.845703 154.290436,448.125580 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M133.687592,455.860107 
	C133.971786,456.194916 133.967209,456.414398 133.946259,456.964111 
	C133.080566,457.107819 132.231232,456.921265 131.143829,456.511749 
	C131.476639,454.915222 132.398254,455.149109 133.687592,455.860107 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M154.318085,444.023621 
	C154.047989,443.271790 154.082291,442.568481 154.127319,441.512695 
	C154.562714,441.317291 154.987366,441.474426 155.631073,441.704254 
	C155.850098,441.776947 155.952545,441.929352 156.006577,442.003601 
	C156.365097,442.486847 156.477264,442.946808 156.134216,443.679169 
	C155.436920,443.962616 155.029694,444.017395 154.318085,444.023621 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M161.078217,448.042786 
	C161.145187,449.392273 160.816620,450.938721 159.487289,450.421783 
	C158.520081,450.045654 158.650543,448.472931 160.249725,447.606873 
	C160.676315,447.612274 160.789627,447.736725 161.078217,448.042786 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M118.026596,449.988831 
	C118.109253,450.285583 118.292046,450.599670 118.205093,450.758179 
	C118.118141,450.916656 117.797661,451.105713 117.613029,451.101501 
	C117.066238,450.886871 116.704079,450.676453 116.167473,450.202637 
	C116.565430,449.242157 117.179268,448.871887 118.026596,449.988831 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M163.392761,444.010223 
	C163.152908,443.569427 163.194901,443.092499 163.337753,442.270905 
	C164.836838,442.456787 165.443542,443.078583 163.392761,444.010223 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M155.614746,460.972717 
	C155.940033,461.157959 155.874390,461.365906 155.906967,461.469177 
	C155.170853,461.820435 154.402161,462.068451 153.226059,462.322144 
	C152.224274,459.540009 154.380981,461.164795 155.614746,460.972717 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M130.371429,444.903625 
	C129.936508,444.297852 128.935974,443.703491 129.695602,443.243835 
	C130.553833,442.724548 131.095764,443.697266 131.725647,444.557983 
	C131.441559,444.865173 131.051590,444.909882 130.371429,444.903625 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M167.554840,441.012360 
	C167.924896,441.389740 167.986206,441.814362 168.173309,442.543396 
	C167.708893,442.722900 166.889725,442.791962 166.581604,442.428223 
	C166.107391,441.868317 166.581604,441.314911 167.554840,441.012360 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M125.132095,452.879395 
	C125.145905,452.019440 125.266754,450.882568 126.855209,451.642548 
	C126.515411,452.204681 125.991241,452.553070 125.132095,452.879395 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M159.152512,456.797302 
	C159.229172,455.953064 159.482056,454.933380 160.881653,455.941711 
	C160.496140,456.393677 159.970886,456.611908 159.152512,456.797302 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M115.659058,458.061890 
	C115.384789,457.889648 115.272331,457.737732 115.071030,457.316620 
	C115.566505,456.772308 116.150826,456.497223 117.070786,456.302246 
	C117.474236,456.931122 117.434967,457.472351 116.879303,458.010803 
	C116.255936,458.078094 116.040489,458.100342 115.659058,458.061890 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M148.433472,437.016754 
	C148.604340,435.654297 149.423141,435.239685 150.913300,435.978638 
	C150.732025,437.177307 149.941025,437.566528 148.433472,437.016754 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M116.569099,458.363403 
	C116.681610,457.655457 116.895996,457.295410 117.258408,456.658875 
	C117.881920,456.977417 118.453346,457.566010 118.144058,458.412964 
	C117.841652,459.241058 117.238060,458.978058 116.569099,458.363403 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M140.854156,435.053253 
	C141.980026,436.130676 140.874710,435.920471 140.495316,436.031403 
	C140.270065,436.097260 139.945496,435.823456 139.665588,435.702393 
	C139.959946,435.469208 140.254288,435.236053 140.854156,435.053253 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M195.139374,419.905090 
	C194.735367,419.564941 194.673279,419.241058 194.630753,418.673279 
	C194.914352,418.351868 195.180527,418.273987 195.862885,418.180603 
	C196.259232,418.552979 196.239365,418.940826 196.189407,419.618225 
	C195.932571,419.912415 195.705856,419.917114 195.139374,419.905090 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M159.976898,440.721161 
	C160.000504,440.964081 159.555161,441.092804 159.324310,441.110168 
	C159.200134,440.679626 159.306793,440.231750 159.413452,439.783875 
	C159.593399,440.015320 159.773331,440.246796 159.976898,440.721161 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M196.094437,440.925293 
	C195.762268,440.470978 195.732712,440.050659 195.798218,439.327972 
	C196.079514,439.015106 196.265732,439.004608 196.731491,439.004211 
	C197.002686,439.453552 196.994308,439.892761 196.995514,440.662781 
	C196.802429,440.982147 196.599731,440.970734 196.094437,440.925293 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M122.996956,456.520233 
	C122.865944,456.833282 122.702751,456.916901 122.265312,456.978943 
	C122.123085,456.534119 122.255112,456.110809 122.387138,455.687500 
	C122.579689,455.888580 122.772232,456.089691 122.996956,456.520233 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M156.096207,443.960419 
	C155.928070,443.503143 156.012009,443.098419 156.078278,442.385803 
	C156.726364,442.298492 156.961807,442.791687 156.896515,443.755127 
	C156.690369,444.042419 156.519318,444.027710 156.096207,443.960419 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M134.888947,436.098511 
	C134.165604,435.753937 133.632812,435.230438 135.211670,435.405273 
	C135.300354,435.665558 135.184677,435.791046 134.888947,436.098511 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M200.781372,453.213074 
	C200.509872,453.070251 200.196823,452.791687 200.228546,452.560394 
	C200.291168,452.103577 200.605316,452.078918 201.010742,452.657715 
	C201.120224,452.865936 200.895691,453.098694 200.781372,453.213074 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M186.866943,441.793030 
	C186.899750,441.590393 187.188858,441.401825 187.737991,441.261536 
	C187.706421,441.475586 187.414841,441.641327 186.866943,441.793030 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M123.637177,442.959839 
	C123.822594,443.107422 123.786331,443.324890 123.660675,443.861572 
	C123.428238,443.921997 123.254242,443.673706 123.160721,443.398132 
	C123.132111,443.313873 123.324394,443.154633 123.637177,442.959839 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M177.682968,419.430969 
	C177.927521,419.522705 177.960205,419.487274 177.961639,419.462433 
	C177.805847,419.552582 177.648621,419.667572 177.229340,419.911621 
	C177.124313,419.806885 177.281372,419.573090 177.682968,419.430969 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M205.593124,419.804474 
	C205.703354,419.781921 205.562729,419.876801 205.535492,419.921082 
	C205.508270,419.965363 205.462753,419.997009 205.453659,420.022888 
	C205.444565,420.048798 205.482895,419.827026 205.593124,419.804474 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M149.009125,427.998962 
	C148.904526,427.927887 148.785065,427.867279 148.665588,427.806641 
	C148.758072,427.779633 148.850555,427.752625 148.956421,427.881531 
	C148.969803,428.037445 148.994232,428.009430 149.009125,427.998962 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M302.000732,129.001160 
	C301.495911,129.767395 300.760681,130.225845 299.957977,129.691757 
	C299.257874,129.225967 299.702606,128.400406 300.125641,128.020523 
	C300.958221,127.272827 301.051453,128.503143 301.773285,128.858032 
	C301.997559,128.996490 302.000000,129.000000 302.000732,129.001160 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M377.998535,109.998093 
	C377.997101,109.996185 377.773895,110.436417 377.773895,110.436417 
	C377.773895,110.436417 377.788879,110.143448 377.896667,110.073219 
	C378.004456,110.002991 378.000000,110.000000 377.998535,109.998093 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M367.431824,113.544380 
	C367.381317,113.467560 367.584442,113.441750 367.584442,113.441750 
	C367.584442,113.441750 367.482300,113.621201 367.431824,113.544380 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M368.998718,118.998306 
	C368.906860,119.035782 368.816254,119.074936 368.864471,119.058289 
	C369.003296,119.002487 369.000000,119.000000 368.998718,118.998306 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M223.076965,121.072815 
	C222.955948,121.533699 222.780899,121.946632 222.605850,122.359558 
	C221.989487,122.023277 222.240601,121.625107 222.717926,121.079086 
	C222.910965,120.933594 223.022949,121.024864 223.076965,121.072815 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M242.799316,130.825729 
	C244.056000,130.897919 244.910156,130.979568 245.011032,132.568481 
	C244.876511,133.351974 244.745148,133.799057 244.613770,134.246140 
	C244.330338,132.879883 241.605148,133.804932 242.081543,131.297379 
	C241.992722,130.952454 241.996094,131.009018 241.968094,131.004028 
	C242.130890,130.884216 242.321686,130.769409 242.799316,130.825729 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M246.138000,132.965424 
	C245.987991,132.186783 246.050751,131.317047 246.797195,131.366180 
	C247.908707,131.439362 247.187607,132.212540 246.939255,132.976288 
	C246.812668,133.230774 246.339569,133.104401 246.138000,132.965424 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M242.948196,130.823853 
	C242.895203,131.028732 242.704254,131.060593 242.226700,131.045746 
	C242.183746,130.766998 242.203934,129.976501 242.948196,130.823853 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M116.815002,147.815002 
	C116.898125,148.300201 116.634850,148.762863 115.880753,148.086914 
	C115.975792,147.832352 116.215630,147.794907 116.815002,147.815002 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M160.103409,416.626160 
	C158.244385,416.896759 156.037109,416.950928 153.363098,417.000488 
	C155.064346,415.416626 157.448624,416.367889 160.103409,416.626160 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M186.048523,413.894104 
	C186.102081,414.500946 185.660187,415.006805 184.726624,414.266998 
	C184.893188,413.915314 185.223740,413.856018 186.048523,413.894104 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M209.070847,411.620422 
	C208.682526,412.624359 208.151352,412.926331 207.197235,412.396545 
	C207.018509,411.737335 207.002945,411.280426 206.925720,410.486511 
	C207.405716,410.130310 207.947357,410.111115 208.893478,410.150024 
	C209.232040,410.584015 209.166122,410.959900 209.070847,411.620422 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M218.586472,412.092529 
	C217.990753,413.251678 216.798401,413.113403 215.319122,412.535339 
	C216.114716,412.241272 217.155350,412.135834 218.586472,412.092529 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M149.234818,417.606506 
	C149.016281,417.867218 148.717667,417.873688 147.970398,417.840515 
	C147.945969,417.214111 148.141342,415.794312 149.234818,417.606506 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M222.521774,415.999817 
	C222.200699,415.304901 222.177170,414.544922 222.112122,413.403748 
	C222.070618,413.022552 222.405807,412.865845 222.585587,412.822632 
	C223.006561,413.087128 223.247757,413.394867 223.740204,413.854187 
	C223.934250,414.851379 223.710663,415.595947 222.521774,415.999817 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M718.665039,92.055901 
	C718.978516,93.148323 719.222290,94.422600 717.345215,94.940002 
	C717.047485,93.853577 716.802612,92.578888 718.665039,92.055901 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M711.962646,95.351318 
	C712.446838,95.003410 712.891296,95.003181 713.669067,95.000717 
	C713.987488,95.489220 714.077759,96.012444 713.938232,96.464752 
	C713.473633,97.970642 713.031006,100.510574 711.164856,99.624863 
	C708.692444,98.451447 712.269348,97.192322 711.962646,95.351318 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M708.362122,112.002274 
	C707.915771,110.478279 707.303528,109.374657 705.334045,109.042091 
	C704.942322,107.459641 704.305359,106.375122 702.334656,106.040237 
	C703.638611,98.448822 705.547913,107.190102 707.651489,105.957092 
	C707.911987,107.567833 709.411194,107.940834 710.149292,108.892456 
	C711.550903,110.699486 711.007874,111.789772 708.362122,112.002274 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M698.989868,99.369537 
	C699.744995,98.998520 700.496704,99.003922 701.624268,99.004211 
	C702.008789,100.573959 701.896362,102.057823 699.368530,102.006088 
	C698.992920,101.251488 698.989746,100.498726 698.989868,99.369537 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M663.645386,108.995117 
	C663.997009,109.439262 663.994019,109.882797 663.990601,110.658760 
	C663.241028,110.996712 662.491760,111.002228 661.367554,111.002853 
	C661.084534,109.556908 661.886475,108.930237 663.645386,108.995117 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M652.747192,105.993805 
	C652.859497,107.578659 653.134766,109.591347 650.191345,108.245285 
	C650.078064,107.095322 650.331421,106.309387 651.665527,106.021164 
	C652.151733,105.974876 652.321777,105.982063 652.747192,105.993805 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M218.004288,70.995728 
	C219.113693,71.109024 220.575043,70.752449 220.759216,72.393623 
	C220.910400,73.740921 219.768478,73.899109 218.366821,73.990143 
	C217.999390,73.999695 218.000000,74.000000 218.000305,74.000153 
	C217.422791,73.318497 217.270081,72.549164 217.757965,71.352936 
	C217.989822,71.010193 217.998810,71.001213 218.004288,70.995728 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M233.000916,69.999153 
	C231.819611,69.923431 230.715286,69.603668 230.423325,68.313141 
	C230.267654,67.625153 230.824539,67.116882 231.573151,67.188576 
	C232.841812,67.310089 232.929779,68.308502 232.993683,69.645538 
	C232.998169,70.001831 233.000000,70.000000 233.000916,69.999153 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M223.949829,76.669800 
	C223.257767,76.999153 222.513214,76.996262 221.397339,76.984528 
	C221.533905,74.741661 222.464035,74.407547 223.949829,76.669800 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M235.999695,67.000153 
	C235.033020,66.863258 234.090195,66.633102 234.208618,65.384125 
	C234.238770,65.066078 234.759033,64.521179 235.010361,64.544861 
	C236.083359,64.645935 235.868637,65.602333 235.995514,66.658905 
	C236.000610,66.999695 236.000000,67.000000 235.999695,67.000153 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M226.042267,67.397446 
	C226.780106,67.798409 226.785568,68.203438 226.262833,68.562256 
	C226.153122,68.637558 225.898499,68.635689 225.791397,68.558029 
	C225.278061,68.185829 225.296738,67.780968 226.042267,67.397446 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M229.043610,64.398338 
	C229.785736,64.800720 229.791382,65.207367 229.265915,65.567894 
	C229.155792,65.643440 228.900085,65.640961 228.792297,65.562874 
	C228.277100,65.189651 228.292206,64.783325 229.043610,64.398338 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M223.042648,69.395432 
	C223.785965,69.798737 223.791565,70.206383 223.263962,70.567253 
	C223.153030,70.643120 222.897003,70.642052 222.789017,70.564056 
	C222.269775,70.189034 222.292450,69.781639 223.042648,69.395432 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M236.995270,62.246284 
	C237.103470,62.410892 237.050308,62.576641 236.997162,62.742386 
	C236.942734,62.577400 236.888321,62.412415 236.995270,62.246284 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M282.655762,27.005199 
	C282.999756,27.444664 282.999481,27.889479 283.000244,28.667934 
	C282.107880,28.872383 280.795135,29.337540 280.570221,28.090460 
	C280.364014,26.947256 281.578796,27.158052 282.655762,27.005199 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M99.340775,74.958511 
	C99.038948,73.396896 98.720787,72.313637 96.759254,71.892601 
	C94.576614,71.424088 92.391296,70.495926 92.007866,67.373459 
	C93.562988,65.223656 95.719139,67.280235 97.690796,66.083405 
	C99.100700,65.722427 100.334740,64.991676 101.278473,65.264641 
	C103.065918,65.781639 105.367325,66.459396 106.205231,67.832909 
	C107.261253,69.563957 104.579361,70.269470 103.558495,71.343369 
	C102.367912,72.595810 101.685844,74.522415 99.340775,74.958511 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M127.373688,94.955582 
	C126.860092,95.011864 126.687073,95.007538 126.254395,94.999992 
	C123.770943,93.639969 123.617607,88.550316 118.975479,91.284050 
	C118.283966,91.691269 116.052162,90.008080 116.286064,88.430069 
	C116.599831,86.313217 118.096947,88.339378 118.770195,88.113457 
	C122.517609,86.855942 124.820961,88.191574 126.659424,91.454628 
	C127.210464,92.432648 128.333374,91.557037 129.151306,90.882072 
	C130.974899,89.377251 131.776352,90.295174 131.992889,92.633667 
	C130.095490,92.555260 129.108093,94.184624 127.373688,94.955582 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M157.993912,77.635765 
	C157.251022,77.998444 156.501450,77.996590 155.377151,77.995995 
	C154.988037,77.665283 155.112122,77.180687 154.939026,77.023628 
	C150.418839,72.922493 151.380920,68.841202 154.971832,64.386337 
	C155.523376,62.949402 156.801987,63.105556 157.780075,62.216431 
	C157.998779,62.000782 158.003693,61.511410 158.005096,61.266716 
	C158.667587,60.360146 159.446960,60.249462 160.654785,60.762829 
	C161.847260,65.161751 157.213287,65.284561 155.696915,67.922813 
	C154.150085,70.614044 153.649918,71.999100 156.040833,74.033180 
	C156.985046,74.836464 158.163620,75.702934 157.993912,77.635765 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M123.676392,53.144852 
	C124.731430,58.690075 119.804985,59.861664 116.999626,62.707462 
	C116.803520,60.280331 117.722466,58.369160 119.372978,56.859528 
	C120.541832,55.790447 121.200958,54.948906 119.546318,53.740437 
	C118.443703,52.935135 117.239265,51.649963 118.778908,50.538799 
	C120.527695,49.276703 120.690102,51.529736 121.535492,52.321815 
	C121.973320,52.732037 122.718094,52.814659 123.676392,53.144852 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M148.605530,49.998753 
	C149.001007,50.749508 149.001389,51.499783 148.843445,52.890137 
	C148.122986,54.117683 147.441116,54.585770 146.481079,55.629402 
	C144.704056,56.189087 143.386642,56.284184 142.122101,56.594654 
	C141.165070,56.829620 140.287079,58.642155 139.307983,56.902092 
	C138.714706,55.847729 139.761887,54.850052 140.607788,54.547005 
	C143.462524,53.524281 144.818665,50.052204 148.605530,49.998753 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M90.294907,64.243095 
	C86.505676,61.577820 86.750282,60.419743 91.638992,58.011009 
	C91.330910,60.253838 94.126045,61.200073 93.986908,63.624115 
	C93.668449,64.399086 93.257324,64.676392 92.383743,64.875443 
	C91.494255,64.900558 91.015472,64.759087 90.294907,64.243095 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M135.002441,55.002441 
	C134.943756,57.119324 134.729828,58.750717 131.951096,57.015514 
	C129.823959,55.687206 128.367722,53.987133 127.392273,51.609512 
	C131.213303,49.961922 131.293472,55.364685 134.629852,54.988846 
	C134.995117,54.995045 135.000000,55.000000 135.002441,55.002441 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M148.999695,53.000153 
	C150.103256,52.689892 151.207108,52.379478 152.655792,52.034210 
	C153.116837,55.296970 150.198380,56.625153 148.398346,58.497662 
	C147.208130,59.735790 146.092636,58.362534 146.005875,56.367081 
	C145.998749,56.001415 146.000000,56.000000 146.000641,55.999283 
	C146.870361,55.153938 147.723007,54.292774 148.789261,53.216793 
	C149.000610,52.999695 149.000000,53.000000 148.999695,53.000153 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M157.643707,61.959759 
	C157.922333,63.445824 157.092331,64.035484 155.367599,64.017044 
	C154.612137,61.940804 149.828415,62.178204 151.683594,59.832268 
	C153.669189,57.321400 155.070480,61.890331 157.643707,61.959759 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M137.025848,84.660049 
	C135.629547,85.183495 133.944000,84.418343 133.069153,86.642540 
	C131.419220,86.737572 130.303192,85.860886 131.680527,84.483376 
	C133.110596,83.053093 134.818649,81.165375 136.973175,81.508148 
	C138.634827,81.772507 136.939880,83.341553 137.025848,84.660049 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M160.962250,60.659607 
	C160.251343,61.004726 159.502945,61.011608 158.380524,61.020256 
	C157.856628,58.934860 153.068787,58.159489 156.666687,55.053452 
	C157.444839,57.410835 160.289886,58.050999 160.962250,60.659607 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M92.376129,58.000637 
	C91.983612,57.834198 91.938324,57.666267 91.952614,57.503571 
	C92.136551,55.407799 88.156364,54.277092 89.866974,52.618080 
	C91.973602,50.575005 91.799767,55.847702 94.630478,54.987534 
	C94.999481,55.747368 94.999680,56.498501 95.000244,57.624496 
	C94.250755,58.000092 93.500893,58.000835 92.376129,58.000637 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M91.759979,64.338608 
	C92.437111,63.992695 92.881645,63.991516 93.659424,63.991734 
	C93.992676,63.993126 94.486389,64.000366 94.733269,64.001663 
	C95.630188,64.872803 96.760574,64.953941 97.781067,65.788811 
	C98.000198,66.002274 98.000000,66.000000 97.998863,66.000000 
	C97.190216,71.369804 94.324883,65.933273 92.350433,67.005066 
	C92.001221,67.001221 92.000000,67.000000 92.000000,67.000000 
	C91.422379,66.313484 91.265327,65.541161 91.759979,64.338608 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M93.386101,79.998222 
	C94.650352,78.220528 94.963089,75.031815 98.634796,75.001846 
	C97.700089,77.128426 97.329262,80.228813 93.386101,79.998222 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M139.302155,88.845146 
	C139.130905,87.445137 137.407547,86.956367 137.050415,85.331299 
	C138.479599,85.192230 140.201645,83.127037 141.400604,85.224983 
	C142.419357,87.007591 140.582962,87.725540 139.302155,88.845146 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M134.360352,47.999466 
	C133.809341,47.044460 132.397476,45.818439 134.236099,45.254837 
	C135.528793,44.858582 137.202789,45.572414 137.324417,46.832741 
	C137.482285,48.468719 135.708344,47.788166 134.360352,47.999466 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M98.005630,60.344818 
	C99.205109,60.368874 100.572807,58.333683 101.509514,59.975948 
	C102.031837,60.891689 100.849747,61.793877 100.018646,62.268852 
	C98.248238,63.280632 98.140671,61.912628 98.005630,60.344818 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M133.999695,47.999771 
	C133.861343,48.916897 134.304916,50.106518 133.041519,50.528004 
	C132.303772,50.774120 131.703842,50.244953 131.528900,49.589012 
	C131.106216,48.004177 132.384964,48.171299 133.655762,48.006519 
	C134.000610,48.000458 134.000000,48.000000 133.999695,47.999771 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M103.676529,62.503601 
	C103.492661,61.065620 104.264603,61.051704 105.113014,61.349308 
	C105.310997,61.418755 105.542847,61.930618 105.470009,62.136803 
	C105.201317,62.897396 104.558914,62.904118 103.676529,62.503601 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M97.999695,60.000305 
	C96.863556,59.943462 95.593300,60.180984 95.057343,58.341888 
	C95.000610,57.999348 95.000000,58.000000 94.999695,58.000328 
	C96.129814,58.070023 97.405983,57.819111 97.943954,59.657127 
	C98.000610,59.999390 98.000000,60.000000 97.999695,60.000305 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M111.803207,61.209412 
	C112.751762,61.841904 112.681541,62.425404 111.923271,62.714771 
	C111.574287,62.847950 110.809380,62.666225 110.657112,62.391914 
	C110.231560,61.625275 110.783447,61.270302 111.803207,61.209412 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M142.995865,81.659805 
	C142.036255,81.858429 141.092194,81.629654 141.217056,80.382439 
	C141.248917,80.064423 141.765594,79.522125 142.015121,79.546051 
	C143.082733,79.648376 142.872406,80.601517 142.995865,81.659805 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M97.943344,65.657959 
	C96.864677,65.938019 95.582970,66.196579 95.040504,64.346161 
	C96.120567,64.059250 97.404610,63.797085 97.943344,65.657959 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M143.002136,81.998032 
	C143.634705,82.087189 144.352432,82.088257 144.493622,82.901772 
	C144.523499,83.073814 144.165329,83.313202 143.985947,83.521561 
	C143.681442,83.203156 143.376938,82.884750 143.034332,82.285156 
	C142.996246,82.003967 143.000000,82.000000 143.002136,81.998032 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M129.455688,82.613022 
	C129.682373,83.411224 129.400101,83.695930 128.783661,83.575729 
	C128.655136,83.550667 128.481339,83.369019 128.461884,83.239494 
	C128.368149,82.615089 128.672653,82.353607 129.455688,82.613022 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M205.676514,60.816162 
	C206.091492,62.126404 205.866821,63.399002 207.311493,63.836483 
	C208.498764,64.196022 210.155945,64.115463 209.738983,66.058693 
	C209.415833,67.564827 208.143814,67.955132 206.367569,67.987869 
	C205.986618,67.993362 205.947891,67.746292 205.947891,67.746292 
	C205.947891,67.746292 205.752365,67.903908 205.872894,67.944931 
	C206.050613,69.673843 204.794434,70.604477 203.858841,71.730682 
	C203.201523,72.521896 202.660370,73.489784 203.557068,74.344521 
	C204.442749,75.188782 205.375061,74.109436 206.652924,74.035172 
	C203.837387,78.699898 203.502625,78.738869 200.392670,74.713638 
	C199.607208,73.697006 198.858276,72.652161 198.049698,71.276947 
	C201.734680,69.996284 198.563492,68.269142 198.516083,66.572281 
	C199.042633,65.218460 200.109848,64.806740 201.077332,63.833374 
	C201.953171,62.781933 202.759537,62.113262 203.782776,61.218697 
	C204.003372,60.996750 204.000000,61.000000 203.998352,61.001656 
	C204.381287,60.623734 204.837875,60.489902 205.676514,60.816162 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M217.608734,71.013641 
	C217.991165,71.757637 217.992508,72.505074 217.997223,73.626411 
	C216.340530,74.147919 214.169266,73.384247 214.008972,76.612747 
	C211.736588,76.323441 210.797852,79.131470 208.369949,78.993332 
	C208.052231,78.026726 208.002136,77.094971 208.821655,76.273102 
	C210.444809,74.645294 210.390991,74.591629 207.369141,73.999023 
	C207.161072,72.777527 207.428665,70.305244 208.704575,71.421410 
	C212.021088,74.322639 214.443619,71.431343 217.608734,71.013641 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M201.873672,63.698856 
	C201.918991,65.464836 201.052887,66.014816 199.334793,65.991348 
	C198.456451,66.512421 197.852951,66.884705 196.764465,67.069389 
	C195.922729,67.095169 195.447372,67.032433 194.648987,66.773643 
	C193.925018,66.356636 193.620850,66.002579 193.205200,65.280914 
	C192.673996,64.533791 192.358200,64.067520 192.020294,63.306549 
	C191.618896,62.624615 191.472733,62.163479 191.779510,61.317463 
	C191.999390,61.006462 192.000000,61.000340 192.003204,61.000015 
	C193.437134,61.333187 194.867844,61.666683 196.673172,62.008198 
	C197.577637,62.905418 198.447601,62.999229 199.692169,63.005310 
	C200.718826,62.619637 201.252182,62.924339 201.873672,63.698856 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M195.774139,66.318840 
	C196.745056,66.000946 197.490723,66.001892 198.608673,66.000504 
	C199.260696,66.558769 199.420517,67.243660 199.845535,67.653648 
	C200.686600,68.464935 203.285294,67.391052 202.392792,70.070534 
	C201.639908,72.330841 199.951752,70.787666 198.348587,70.956779 
	C197.899338,70.636597 197.720291,70.391945 197.266327,70.091347 
	C196.085571,69.081863 195.161545,68.156525 195.774139,66.318840 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M195.668701,66.006012 
	C196.319839,67.099152 196.640274,68.198311 197.011841,69.640251 
	C195.976685,69.988472 194.890411,69.993904 193.398102,69.998520 
	C192.338547,69.328690 192.243835,68.547012 192.762390,67.345520 
	C192.998169,67.001831 192.999832,66.507088 192.999908,66.259720 
	C193.169662,65.878716 193.339340,65.745079 193.762054,65.813774 
	C194.456055,66.014740 194.897049,66.013390 195.668701,66.006012 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M192.664276,67.009331 
	C193.000443,67.750824 193.002701,68.499825 192.998505,69.623260 
	C192.992065,69.997704 193.000549,69.999565 192.999146,69.995789 
	C192.615402,70.374512 192.157043,70.524216 191.311310,70.223526 
	C190.255341,68.480766 189.673111,67.027885 192.664276,67.009331 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M191.006271,70.349258 
	C191.443970,70.003716 191.887924,70.001488 192.664825,69.995636 
	C192.866501,70.883789 193.335175,72.194984 192.094528,72.425354 
	C190.951141,72.637665 191.158691,71.424667 191.006271,70.349258 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M193.539520,53.388065 
	C193.315399,52.592331 193.593155,52.302414 194.211792,52.423878 
	C194.340256,52.449097 194.513535,52.630959 194.533081,52.760685 
	C194.627136,53.385052 194.322723,53.646866 193.539520,53.388065 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M191.701660,61.045280 
	C191.999237,61.451965 191.999100,61.897469 191.998566,62.677414 
	C191.481812,62.775963 190.711731,62.670559 190.507797,62.274002 
	C190.191528,61.659031 190.783478,61.254333 191.701660,61.045280 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M198.000000,52.000153 
	C197.373566,51.905045 196.657913,51.903316 196.517075,51.094284 
	C196.487457,50.924145 196.844238,50.686745 197.022995,50.480339 
	C197.324951,50.799450 197.626907,51.118565 197.964417,51.718689 
	C198.000000,51.999695 198.000000,52.000000 198.000000,52.000153 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M193.900543,65.795258 
	C193.845901,66.016090 193.676712,66.016090 193.253754,66.014214 
	C192.998352,65.843636 192.996735,65.674919 192.992462,65.253128 
	C193.316483,65.106552 193.581894,65.298004 193.900543,65.795258 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M177.657959,65.766418 
	C178.000229,66.751579 178.001083,67.501335 178.001282,68.625977 
	C176.397171,69.043373 174.981705,68.839050 175.009125,66.358139 
	C175.690735,65.419289 176.462936,65.268593 177.657959,65.766418 
z"/>
<path fill="#7D96AA" opacity="1.000000" stroke="none" 
	d="
M170.000305,71.000153 
	C169.831726,72.166679 170.295624,73.759972 168.308655,73.737816 
	C167.963089,73.733963 167.400879,73.274712 167.318512,72.933983 
	C166.927078,71.315086 168.091003,71.132706 169.631821,71.009613 
	C169.999390,70.999695 170.000000,71.000000 170.000305,71.000153 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M177.999451,65.626511 
	C177.249695,65.999016 176.500015,65.996201 175.375519,65.990303 
	C174.946136,64.382370 175.158188,62.980267 177.630493,63.007305 
	C178.000244,63.749954 177.999893,64.500572 177.999451,65.626511 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M78.054604,63.340832 
	C77.905411,61.228420 80.313660,60.610306 79.986557,58.368744 
	C80.307983,57.904793 80.568954,57.715744 80.884171,57.229462 
	C81.390404,56.639481 81.855873,56.491646 82.713318,56.777794 
	C84.039391,57.928696 85.944977,57.481323 86.521828,59.100883 
	C85.793694,60.292801 84.756523,60.036705 83.856277,59.795807 
	C82.177742,59.346645 80.833931,58.370964 82.073326,61.540222 
	C82.623466,62.946960 81.309769,66.335480 78.054604,63.340832 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M92.657440,73.943420 
	C93.041115,75.610703 92.838150,77.028107 90.370667,76.992432 
	C90.001831,77.001831 90.000000,77.000000 89.999008,76.999084 
	C89.923599,76.681053 89.916084,76.326660 89.763603,76.053055 
	C88.955078,74.602264 86.701553,73.044746 88.826889,71.515556 
	C90.943184,69.992859 90.662224,73.693314 92.657440,73.943420 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M86.146034,64.353561 
	C86.505608,66.528793 84.804947,66.599915 83.574753,67.176285 
	C83.406090,66.760941 83.074905,66.336861 83.096680,65.931755 
	C83.194939,64.103996 84.418701,63.922661 86.146034,64.353561 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M91.663452,63.994156 
	C91.994850,64.745453 91.997124,65.497040 91.999695,66.624313 
	C90.519608,66.879219 88.494034,67.266289 89.887115,64.288544 
	C90.457001,63.988888 90.895660,63.991669 91.663452,63.994156 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M81.374725,52.998516 
	C81.188316,50.872814 82.760529,51.001858 84.626801,51.000172 
	C85.002014,51.001999 85.000000,51.000000 84.999084,50.999008 
	C84.819710,53.124763 83.246414,52.997128 81.374725,52.998516 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M81.003189,53.003380 
	C80.871490,53.980927 80.631798,54.920258 79.377678,54.792274 
	C79.056145,54.759460 78.509270,54.242245 78.532501,53.990650 
	C78.631897,52.913940 79.592369,53.127148 80.651749,52.997852 
	C80.993187,52.993160 80.999992,52.999973 81.003189,53.003380 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M85.617218,69.540375 
	C86.415741,69.313225 86.702568,69.593575 86.580460,70.212135 
	C86.555023,70.340950 86.373482,70.514694 86.243713,70.534302 
	C85.618790,70.628754 85.355919,70.325562 85.617218,69.540375 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M92.994202,73.990982 
	C93.347954,73.599899 93.577835,72.743591 94.287956,73.618286 
	C94.022308,73.740143 93.756660,73.861992 93.257095,74.003365 
	C93.023186,74.022888 93.002579,74.002426 92.994202,73.990982 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M82.880234,56.761703 
	C82.581032,56.994862 82.128197,57.002621 81.335922,57.011375 
	C81.414391,56.276569 81.950417,55.970066 82.880234,56.761703 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M89.209885,49.894573 
	C89.099892,49.684517 89.290276,49.424702 89.779533,49.113716 
	C89.892914,49.325584 89.703529,49.586342 89.209885,49.894573 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M206.244171,60.815529 
	C205.544403,61.026150 205.102264,61.021729 204.328430,61.010307 
	C204.020950,59.849430 203.819275,58.590130 205.681274,58.077038 
	C206.026245,58.021168 206.510971,58.013901 206.753265,58.009193 
	C206.830978,58.869820 206.666397,59.735153 206.244171,60.815529 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M212.721924,59.039787 
	C213.020203,59.446735 213.018387,59.890202 213.014191,60.666275 
	C212.492966,60.764584 211.715927,60.661491 211.514816,60.265743 
	C211.200211,59.646660 211.799530,59.245056 212.721924,59.039787 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M202.286804,63.855598 
	C201.512100,63.741302 201.024200,63.482296 200.282333,63.115356 
	C200.629044,61.536686 201.758102,60.924988 203.654053,60.994473 
	C203.994659,62.147926 203.549820,63.069363 202.286804,63.855598 
z"/>
<path fill="#6F879F" opacity="1.000000" stroke="none" 
	d="
M205.240570,55.010376 
	C205.266434,54.899914 205.545013,54.792088 205.911087,54.853130 
	C205.830154,55.018997 205.661697,55.016003 205.240570,55.010376 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M725.421387,41.225277 
	C722.488586,36.819698 721.496155,41.803886 719.336975,41.945915 
	C719.108459,38.506283 721.852539,36.338009 724.313293,35.842236 
	C725.858398,35.530933 729.008728,37.516834 729.983643,40.619232 
	C728.724731,42.294544 727.296448,42.159927 725.421387,41.225277 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M725.023804,41.237125 
	C726.413269,40.988110 727.789490,40.993340 729.579224,40.998520 
	C730.160950,40.999111 730.329285,40.999744 730.750000,41.001793 
	C729.254150,45.934826 728.745361,46.065643 725.272339,42.203461 
	C725.003601,41.830738 725.007141,41.661053 725.023804,41.237125 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M714.380432,38.996040 
	C714.004883,39.003620 714.000000,38.506168 713.997559,38.257561 
	C715.267578,37.201904 714.969116,34.666573 717.645264,35.006966 
	C718.096313,37.287632 717.444641,38.966499 714.380432,38.996040 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M732.654541,35.047058 
	C733.312256,35.778240 733.629272,36.570408 733.971924,37.682961 
	C731.915100,37.922859 730.011780,37.738224 732.654541,35.047058 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M632.996338,49.003410 
	C632.367493,48.908005 631.652954,48.901501 631.515747,48.093681 
	C631.486633,47.922630 631.842834,47.686153 632.021484,47.479813 
	C632.324524,47.797356 632.627563,48.114910 632.968994,48.712494 
	C633.007324,48.992523 633.000000,48.999954 632.996338,49.003410 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M789.873352,68.294662 
	C790.804443,68.247887 791.608948,68.494972 792.706665,68.870712 
	C792.826965,71.142929 791.240845,70.991699 789.376953,70.999016 
	C789.249878,70.195366 789.498291,69.391945 789.873352,68.294662 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M120.636185,109.995903 
	C117.937660,114.519958 117.094910,110.305443 115.204292,108.831169 
	C117.725739,107.156502 118.400208,110.625572 120.636185,109.995903 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M86.650284,98.505951 
	C87.883026,99.838348 88.812263,101.030182 90.122429,102.710602 
	C85.548431,101.468887 85.214340,101.004921 86.650284,98.505951 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M102.541138,98.708519 
	C102.896133,101.250053 101.349823,101.423843 99.314102,101.696518 
	C99.627960,99.595100 100.338699,98.449532 102.541138,98.708519 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M109.375122,109.997253 
	C109.092995,108.868294 109.342270,107.684372 110.599884,107.458488 
	C111.948738,107.216217 111.890739,108.410538 111.994568,109.656715 
	C111.251053,109.997360 110.500793,109.996086 109.375122,109.997253 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M102.989685,107.328903 
	C103.957764,107.181084 105.395348,106.607430 105.547562,108.241623 
	C105.585365,108.647430 104.881966,109.435692 104.425858,109.515709 
	C103.021248,109.762108 103.118767,108.582718 102.989685,107.328903 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M100.005005,108.005264 
	C100.703209,105.213928 101.207924,104.924004 102.931625,106.669121 
	C102.975060,106.981071 102.998611,106.999870 102.990166,106.991135 
	C102.196121,107.296921 101.410522,107.611443 100.307251,107.958092 
	C99.989586,107.990219 100.000000,108.000061 100.005005,108.005264 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M121.000374,110.000412 
	C121.089478,108.556602 121.929344,107.980164 123.649200,108.007416 
	C124.001526,108.001526 124.000000,108.000000 123.999283,107.999237 
	C123.782402,109.399826 123.714043,110.965302 121.274582,110.101326 
	C120.999237,109.999084 121.000000,110.000000 121.000374,110.000412 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M111.998779,94.998764 
	C111.842300,95.995613 112.418663,97.374321 110.784561,97.610626 
	C110.467216,97.656517 109.833939,97.183701 109.744499,96.845016 
	C109.397758,95.531883 110.479927,95.352516 111.684418,95.032639 
	C112.002457,95.002335 112.000000,95.000000 111.998779,94.998764 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M107.985725,100.511902 
	C107.102203,100.022156 106.998199,99.410332 107.412933,98.810463 
	C107.747444,98.326630 108.281128,98.329369 108.602806,98.825592 
	C108.998024,99.435249 108.884331,100.045837 107.985725,100.511902 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M94.937202,109.648727 
	C94.241081,109.994881 93.494209,110.001068 92.373665,110.009499 
	C92.008591,109.580292 92.017181,109.148834 92.042130,108.395660 
	C93.183739,108.067383 94.429321,107.785248 94.937202,109.648727 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M108.173950,117.465271 
	C107.487602,116.818092 107.019196,116.251862 107.649109,115.651169 
	C107.805656,115.501877 108.652115,115.726295 108.801331,115.992226 
	C109.107674,116.538193 110.134689,117.493774 108.173950,117.465271 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M114.408882,113.957840 
	C114.803955,113.231705 115.202583,113.223488 115.556488,113.738525 
	C115.630264,113.845894 115.626038,114.096672 115.549171,114.202469 
	C115.183937,114.705017 114.785599,114.695259 114.408882,113.957840 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M109.000153,110.000153 
	C108.912071,110.897453 108.675575,111.689285 107.318283,111.955017 
	C107.073189,111.089729 107.328720,110.311348 108.681183,110.045731 
	C108.999695,109.999695 109.000000,110.000000 109.000153,110.000153 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M107.001984,112.002106 
	C106.920769,112.906609 106.685890,113.700439 105.318260,113.955460 
	C104.998398,113.998482 105.000000,114.000000 105.000763,114.000809 
	C105.078926,113.097649 105.314034,112.305038 106.676125,112.039215 
	C106.995728,111.995941 107.000000,112.000000 107.001984,112.002106 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M111.999313,110.000656 
	C112.630547,110.097847 113.352715,110.098305 113.500389,110.911865 
	C113.531250,111.081924 113.172462,111.322701 112.993225,111.530884 
	C112.688087,111.208496 112.382950,110.886116 112.039558,110.281181 
	C112.001305,109.998627 112.000000,110.000000 111.999313,110.000656 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M96.403625,98.960220 
	C96.805405,98.224762 97.210800,98.210091 97.570549,98.737808 
	C97.645546,98.847832 97.642487,99.102577 97.564415,99.209885 
	C97.192291,99.721352 96.786850,99.709145 96.403625,98.960220 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M110.639488,113.753601 
	C110.624702,113.994003 110.494392,114.125076 110.364090,114.256149 
	C110.417381,114.052193 110.470680,113.848228 110.639488,113.753601 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M792.773438,893.669128 
	C804.348267,893.144287 815.745728,893.080688 827.609375,893.107788 
	C828.088440,893.526001 828.109131,893.853088 828.110962,894.424316 
	C827.218018,896.208801 825.692078,896.358582 824.204651,896.354919 
	C814.293884,896.330200 804.378357,896.801880 794.015259,895.919800 
	C792.945862,895.374451 792.625488,894.839539 792.773438,893.669128 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M792.435547,894.375488 
	C804.302856,895.559204 815.737671,894.718872 827.623169,894.785400 
	C830.170959,894.745728 832.257385,894.822510 834.673523,894.983582 
	C834.951294,895.315063 834.899414,895.562256 834.742798,896.173523 
	C833.013184,897.543213 831.194031,897.654968 829.360352,897.659668 
	C810.798401,897.707336 792.236450,897.713196 773.674500,897.655212 
	C772.180359,897.650513 770.690674,897.550476 768.837585,896.772522 
	C768.194458,896.283997 767.984375,896.032288 767.883545,895.302490 
	C775.951782,893.142151 783.981995,894.219727 792.435547,894.375488 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M713.806885,984.194580 
	C715.006470,984.711548 714.825806,985.656616 714.399719,986.812256 
	C713.022522,986.369934 712.940002,985.461914 713.806885,984.194580 
z"/>
<path fill="#532257" opacity="1.000000" stroke="none" 
	d="
M767.687744,894.736694 
	C768.042419,895.049927 768.029907,895.468140 768.067139,895.674011 
	C766.926941,897.427551 765.104004,897.545471 763.058044,898.047546 
	C761.820251,897.782410 761.088074,896.466431 759.850708,898.015015 
	C757.911499,896.998718 755.876709,897.138184 753.459351,897.209839 
	C752.682495,896.852112 752.504028,896.457642 752.724976,895.670227 
	C755.294739,895.259277 757.679382,895.144348 760.508667,894.977661 
	C762.991028,893.629150 765.150085,893.874390 767.687744,894.736694 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M752.491272,895.335815 
	C752.956299,895.767151 753.002441,896.160156 753.062073,896.851257 
	C749.710571,897.384644 746.345642,897.619873 742.549438,897.842896 
	C742.067322,897.400940 742.016357,896.971191 741.959900,896.216675 
	C745.327026,895.693787 748.699646,895.495605 752.491272,895.335815 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M745.720154,898.963989 
	C745.949463,898.967102 745.629456,899.276733 745.629456,899.276733 
	C745.629456,899.276733 745.200134,899.234009 745.116272,899.104736 
	C745.032410,898.975525 745.490845,898.960876 745.720154,898.963989 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M768.503418,894.984009 
	C765.972900,895.052917 763.903442,895.055969 761.393677,894.992371 
	C760.930176,894.586243 760.906982,894.246704 760.881653,893.650269 
	C771.254150,892.516541 781.644287,893.241516 792.488342,893.150269 
	C792.935303,893.506470 792.906616,893.803772 792.875977,894.323608 
	C784.912903,894.671021 776.938660,894.794556 768.503418,894.984009 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M721.130127,895.506470 
	C721.319214,895.662598 720.851135,895.814758 720.851135,895.814758 
	C720.851135,895.814758 720.367126,895.725525 720.181030,895.565613 
	C720.300598,895.222412 720.615967,895.203979 721.130127,895.506470 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M762.833008,898.492126 
	C762.867554,894.481995 765.673523,896.602783 767.674255,895.950562 
	C789.999268,896.011230 811.894165,896.142639 834.213501,896.405762 
	C832.181580,903.951050 832.177490,904.063232 824.687439,903.791687 
	C806.027283,903.115540 787.373230,903.742737 768.720093,904.022583 
	C764.781433,904.081665 762.708191,903.043213 762.833008,898.492126 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M718.268188,988.347168 
	C715.211182,988.663391 715.896973,986.903137 716.620728,985.713928 
	C717.289673,984.614807 718.612854,984.714600 719.520752,985.666199 
	C720.815002,987.023010 720.356934,987.903564 718.268188,988.347168 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M717.209045,1000.984985 
	C715.094299,999.434021 715.531311,997.401489 716.612671,995.091553 
	C723.908813,996.167603 716.660095,998.842102 717.209045,1000.984985 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M719.520874,993.533020 
	C719.470520,993.560974 719.571289,993.505066 719.520874,993.533020 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M817.714294,883.293823 
	C819.566956,877.572754 819.516663,872.113708 817.967590,866.753479 
	C817.072937,863.657959 817.596924,862.419617 820.998657,863.009888 
	C830.133423,864.594971 839.431519,865.179993 848.731934,867.742432 
	C851.470581,872.812012 850.591919,877.744507 849.320129,883.032776 
	C844.210876,885.400330 839.021790,886.152893 833.818726,885.972839 
	C830.594788,885.861328 827.324097,886.213989 824.094360,885.491760 
	C822.655090,885.169861 821.106689,885.514404 819.674561,886.953552 
	C819.122253,887.231079 818.878967,887.298218 818.265137,887.273071 
	C817.324280,886.598694 817.102722,885.878113 817.112488,884.700073 
	C817.270935,884.079529 817.379456,883.844482 817.714294,883.293823 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M784.080811,858.985107 
	C783.999817,858.635254 784.016541,858.273499 784.034546,858.093262 
	C789.765137,856.540039 795.173523,858.664978 800.675110,859.491394 
	C802.293213,859.734375 803.954041,859.841614 805.954468,860.344238 
	C812.343018,861.644775 814.530640,865.568176 815.130249,871.381042 
	C815.775818,877.638672 814.865051,883.184143 810.527405,888.391968 
	C810.087646,889.259094 809.749451,889.693176 808.949646,890.246948 
	C806.324097,890.547058 804.073547,890.460999 801.404602,890.488037 
	C798.496826,890.487000 796.008362,890.489197 793.122864,890.480347 
	C790.590210,889.391235 791.597168,888.299927 792.747314,887.262329 
	C793.553040,886.535339 794.889587,886.513245 795.478760,884.971924 
	C795.913269,883.424194 796.341370,882.259583 796.647949,880.673523 
	C798.017334,876.628296 797.734253,872.892761 797.173157,868.780640 
	C799.694824,866.768677 800.492249,867.033875 801.072327,870.025208 
	C801.703247,873.278809 801.053467,876.624878 801.517517,880.018677 
	C804.223816,873.051575 801.965210,867.761230 794.394653,863.659180 
	C793.891052,863.408325 793.687927,863.314819 793.187378,863.075439 
	C792.296387,862.654602 791.695984,862.399597 790.713013,862.258179 
	C789.706299,862.143372 789.038391,862.019470 788.039978,861.760681 
	C786.384521,861.095764 785.093506,860.489014 784.080811,858.985107 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M760.272095,841.805298 
	C761.560425,841.884399 762.431763,841.964539 763.735962,841.974182 
	C791.061646,840.075562 817.949097,838.162415 844.849915,836.459961 
	C856.149902,835.744751 867.479736,835.511963 878.792175,834.977295 
	C881.611023,834.844055 884.412109,834.361694 887.227112,834.101929 
	C888.051697,834.025879 888.948730,834.140503 888.954468,835.299622 
	C888.958801,836.173096 888.701904,836.986389 887.662476,837.088562 
	C885.508423,837.300415 883.351257,837.533447 881.190125,837.612244 
	C837.411804,839.208923 793.739014,842.711670 749.583374,844.799927 
	C749.076843,844.339233 748.978577,843.942932 748.898315,843.239624 
	C752.562622,842.557251 756.208923,842.181824 760.272095,841.805298 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M877.688293,799.388306 
	C881.634888,801.336060 880.554749,805.075867 881.647034,807.847351 
	C882.428711,809.830933 882.609863,812.051147 883.023682,814.572083 
	C879.484863,817.606506 875.483276,815.994080 871.279907,816.258240 
	C868.209045,815.424011 865.543213,815.030151 862.415039,815.857666 
	C861.188049,816.090088 860.371277,816.057068 859.198120,815.612427 
	C859.099731,810.279480 859.728210,805.183411 861.614380,799.984680 
	C866.957336,797.760742 872.103638,798.429199 877.688293,799.388306 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M838.306763,831.739014 
	C836.822937,835.383362 833.898865,835.636047 830.940491,835.777527 
	C822.970276,836.158813 814.999084,836.518677 806.567627,836.883911 
	C804.567078,833.757019 807.333313,832.505676 808.899231,830.941956 
	C812.387207,827.459106 816.996033,825.352905 820.804565,821.627197 
	C821.839722,821.095764 822.585999,821.004761 823.722046,821.292725 
	C825.426880,822.177185 826.769714,822.932861 828.494934,823.757690 
	C830.820557,823.081543 831.595886,824.625549 832.729065,826.024963 
	C833.915894,827.162476 834.971741,828.000183 836.365112,828.899048 
	C838.191895,829.141907 838.618225,830.088623 838.306763,831.739014 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M847.718750,884.256470 
	C849.676758,879.036072 848.822815,873.944092 849.009155,868.460632 
	C849.872375,868.128418 850.729919,868.261047 851.813232,868.632507 
	C851.086792,874.384888 852.817932,879.934265 851.549377,885.443542 
	C851.902588,886.108398 852.677429,885.479858 852.031799,885.646118 
	C851.832764,885.697327 851.753967,885.567261 851.690125,885.279236 
	C851.436768,884.135864 851.284241,883.012573 852.512207,881.998901 
	C855.417603,881.693604 854.945862,879.765808 854.977661,878.173157 
	C855.026123,875.749268 854.990417,873.323669 854.990417,870.517578 
	C858.032898,871.920715 856.256836,874.513184 857.442993,875.995850 
	C858.778625,875.003845 857.150452,873.026855 859.218018,871.760132 
	C859.218018,876.169067 859.218018,880.226685 859.218018,884.284241 
	C861.971680,880.459412 860.295105,876.133728 861.460449,871.169006 
	C862.235657,875.520813 862.846985,878.952393 863.514221,882.698181 
	C866.226929,881.134277 863.854309,878.009033 866.492859,876.141418 
	C867.793335,880.741089 866.306396,886.178650 870.995300,889.485535 
	C869.687622,891.082336 868.055908,890.232727 866.217041,890.486328 
	C864.418152,890.133118 863.080078,889.555786 861.529236,889.526672 
	C858.474548,889.469177 856.935303,887.909485 857.583679,884.835449 
	C857.589294,884.029114 857.291748,884.551208 857.296814,884.571716 
	C858.023926,887.523132 857.385010,889.645447 853.559937,890.014771 
	C852.839905,890.382263 852.394104,890.471558 851.584229,890.439758 
	C850.381714,890.027405 849.626465,889.459351 848.461609,888.878906 
	C847.972778,888.512573 847.796082,888.338440 847.439087,887.834229 
	C846.930786,886.492371 846.955383,885.509338 847.718750,884.256470 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M733.855835,845.459045 
	C735.453552,845.127869 737.058899,844.421265 738.633301,845.901123 
	C738.999023,845.987732 738.945068,846.006287 738.948242,846.034668 
	C741.113953,848.575073 740.882141,851.600708 740.744507,854.588440 
	C740.407104,861.907776 740.526306,869.231323 740.502991,876.553406 
	C740.498779,877.869873 740.335022,879.243469 741.674194,880.644897 
	C741.973389,880.962158 742.024841,881.400635 742.027832,881.621216 
	C733.768738,882.094238 733.809021,882.094299 733.815796,873.714966 
	C733.823303,864.446228 733.747253,855.177429 733.855835,845.459045 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M786.168152,837.680908 
	C785.709717,835.391357 787.327209,834.590149 789.010010,833.422180 
	C789.267944,832.908142 789.331787,832.660706 789.741394,832.247803 
	C790.087097,832.082336 790.019165,832.108643 790.055420,832.113281 
	C790.506775,831.464355 791.086792,830.960632 791.860840,830.252563 
	C792.090820,830.080933 792.082642,830.024109 792.064575,830.046387 
	C792.223267,829.794739 792.434692,829.550964 792.874878,829.191772 
	C793.068970,829.046204 793.040283,829.098083 793.069214,829.104492 
	C793.810547,828.106873 794.734863,827.303345 795.857056,826.273132 
	C796.102234,826.091187 796.096069,826.129944 796.115723,826.129883 
	C802.064758,819.470520 809.335144,814.697876 817.735474,810.951965 
	C818.725891,811.054932 819.368042,811.231140 820.312744,811.562561 
	C820.741272,812.003235 820.887695,812.277832 821.190552,812.731812 
	C821.902039,817.341797 818.747986,818.006287 815.193848,818.757751 
	C813.377319,819.784973 811.933105,820.697388 810.255859,821.834229 
	C809.774963,822.276306 809.517517,822.481995 809.034302,822.795715 
	C808.352661,823.174377 807.887146,823.433167 807.218506,823.868347 
	C806.763123,824.276123 806.497986,824.491699 805.978210,824.779968 
	C801.276367,828.309692 796.845459,831.789856 792.336243,835.165466 
	C790.613770,836.454895 788.738525,837.563843 786.168152,837.680908 
z"/>
<path fill="#B6BAB3" opacity="1.000000" stroke="none" 
	d="
M883.630127,816.728638 
	C884.724609,818.832764 884.289429,820.143494 882.314880,820.824768 
	C879.536499,821.783264 876.829895,822.991333 873.426636,823.091064 
	C871.833008,823.054626 870.612366,822.786316 869.261597,823.628418 
	C868.581665,823.920044 868.138489,824.027100 867.354248,824.085449 
	C866.018066,824.007019 865.016296,824.078857 864.028625,824.003174 
	C862.070251,823.852905 859.609924,825.795349 858.283447,822.919617 
	C857.116638,820.390259 857.806946,818.069946 860.072021,815.828613 
	C868.097168,814.581421 875.679626,815.366821 883.630127,816.728638 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M741.994507,880.498474 
	C738.557068,881.489441 738.773926,879.213562 738.799805,876.954163 
	C738.914673,866.926575 738.981628,856.898438 739.008606,846.466736 
	C739.777100,846.096619 740.602905,846.130188 741.839966,846.212585 
	C742.962158,857.524719 742.166504,868.777527 741.994507,880.498474 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M845.067749,802.298950 
	C845.085388,804.415527 847.950562,806.348572 844.108154,807.855225 
	C842.093811,808.645203 843.802673,811.154846 844.673584,812.551636 
	C845.700745,814.198914 846.988281,815.525330 844.174316,817.006226 
	C843.593567,817.190002 843.373474,817.298950 842.797729,817.311646 
	C841.724670,816.662537 841.007141,816.109680 840.136108,815.246948 
	C839.642456,814.579468 840.085632,814.041809 839.697266,813.695251 
	C839.643127,814.002991 839.536804,814.292908 839.187561,814.781311 
	C837.093750,816.127380 835.276672,816.352417 833.768188,814.262390 
	C834.141663,813.809814 834.402588,813.582336 834.840088,813.163818 
	C835.019104,812.975769 835.006104,813.003052 834.991943,813.008301 
	C835.283081,812.662292 835.675903,812.530334 836.130676,812.554016 
	C835.921387,812.432617 835.679504,812.455811 835.226196,812.197021 
	C840.553711,809.187073 838.847351,805.014099 837.048828,800.457336 
	C838.872437,798.219971 840.817749,799.097168 843.107056,800.104492 
	C844.148010,800.661499 844.615417,801.265625 845.067749,802.298950 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M862.364380,799.288757 
	C862.652893,796.726746 859.726440,792.799194 864.680237,792.173645 
	C874.685730,790.910095 876.449280,791.615417 877.969971,797.521179 
	C873.115479,800.615967 867.859863,799.105225 862.364380,799.288757 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M844.285034,801.309448 
	C841.758240,800.779724 839.756653,800.329834 837.376709,799.980652 
	C835.149780,799.619507 833.385742,799.976624 831.327454,800.843750 
	C825.847961,801.625793 821.661682,805.942505 815.913269,805.119995 
	C822.789062,796.963806 836.792786,794.735291 845.474731,800.554077 
	C845.415527,801.021484 845.112854,801.205261 844.285034,801.309448 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M820.853760,822.093811 
	C819.350891,825.946350 815.545044,826.870972 812.916565,829.239502 
	C810.485413,831.430115 807.593445,833.128967 806.085693,836.539673 
	C803.665466,837.223145 801.225830,837.374939 797.418030,836.649475 
	C804.925110,832.327209 809.984375,826.527039 816.714233,822.239136 
	C818.119263,821.139954 819.322144,820.951660 820.853760,822.093811 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M853.390259,831.735901 
	C852.147461,832.047424 851.072083,832.242249 851.011108,830.402100 
	C849.391113,828.186768 849.606384,826.076660 850.081421,823.937744 
	C852.362061,813.669312 853.810669,803.252930 855.639771,792.511292 
	C855.707397,791.874390 855.743896,791.624817 855.871399,791.016724 
	C856.176697,789.982544 856.460571,789.333069 856.832092,788.359741 
	C857.048828,787.850647 857.146606,787.653625 857.443481,787.197998 
	C857.829956,786.833496 858.017334,786.727539 858.525269,786.612610 
	C859.031189,786.709106 859.216614,786.814636 859.589600,787.179443 
	C858.778381,793.881470 857.779541,800.324402 856.757629,807.175171 
	C857.108154,815.705139 854.262756,823.416077 853.390259,831.735901 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M746.250671,865.056824 
	C745.925049,864.138672 745.962341,863.410217 746.046143,862.319580 
	C746.274902,861.816956 746.457153,861.676392 746.857178,861.803589 
	C747.443970,862.282227 747.812927,862.493042 748.399597,862.671204 
	C748.856201,865.032898 749.095215,867.427307 749.347107,869.950745 
	C749.179626,870.446838 750.216675,869.914856 749.901672,869.527161 
	C749.599548,869.155457 749.929016,868.270447 750.021240,867.263672 
	C750.692871,866.364746 750.367065,865.279297 751.520874,864.893921 
	C751.891479,871.252319 751.962097,877.565308 752.016174,883.878479 
	C752.027832,885.233582 752.013855,886.929993 750.364075,887.057983 
	C748.172607,887.228088 749.241028,885.245422 749.001404,884.177612 
	C747.866882,879.121033 747.912354,873.974731 747.924255,868.834473 
	C747.927368,867.468994 747.807312,866.166321 746.250671,865.056824 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M772.872314,866.282104 
	C776.759521,862.328491 779.396667,862.584045 781.910828,866.845886 
	C784.643127,871.477539 781.956177,878.367615 776.839050,879.796143 
	C775.717224,880.109375 774.873047,879.846924 774.862549,878.058350 
	C777.065308,875.161255 779.013245,872.614136 776.090698,869.034058 
	C775.037476,867.760620 773.543335,867.663330 772.872314,866.282104 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M772.664185,866.133972 
	C773.686646,867.252808 775.440857,865.174011 775.996948,867.194824 
	C776.179932,868.396851 775.969788,869.227783 775.086426,870.147217 
	C774.647400,870.437622 774.458069,870.524780 773.986938,870.708496 
	C772.643250,871.343140 772.497925,872.138733 773.187378,873.418213 
	C773.459534,874.123413 773.483948,874.549316 773.241272,875.261169 
	C770.281860,876.741028 771.919861,878.534790 772.654297,879.941772 
	C773.545837,881.649719 774.716309,883.459839 777.158264,882.644897 
	C778.205078,882.295532 779.125854,881.568604 780.433899,880.887817 
	C780.980713,880.804016 781.197510,880.845642 781.580322,881.173828 
	C776.508179,886.361755 772.143738,885.486450 769.859863,878.880066 
	C768.278625,874.305847 767.973083,869.784912 772.664185,866.133972 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M856.652344,789.928833 
	C856.161804,801.406067 853.782715,812.599243 851.531738,823.808533 
	C851.168945,825.615295 850.934753,827.373047 851.011902,829.622925 
	C849.883423,829.982727 848.757080,830.136230 848.066040,828.675659 
	C847.742981,823.150330 850.992310,818.700195 851.345581,813.201050 
	C851.642578,807.886169 853.295410,803.110046 852.958252,797.717041 
	C853.923889,794.765076 853.680725,791.709595 856.652344,789.928833 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M865.129272,783.143982 
	C865.030334,780.671082 865.785522,778.485413 868.181519,778.013489 
	C870.631042,777.531006 871.299683,780.058167 872.353088,781.622314 
	C873.081177,782.703552 873.454163,784.023926 874.026611,785.597839 
	C872.551941,789.472351 869.436951,789.242126 866.535583,788.878967 
	C864.087524,788.572510 864.281067,786.500854 864.621155,784.169434 
	C864.683411,783.700867 864.611511,783.755005 864.598389,783.711914 
	C864.969055,783.825806 865.228088,783.719666 865.129272,783.143982 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M897.131592,886.811279 
	C893.975952,890.721191 889.639709,888.274841 885.510132,889.186768 
	C885.059998,888.903015 885.056458,888.666077 885.114136,888.079163 
	C888.124634,886.015381 886.376709,882.867371 887.559692,880.240601 
	C887.967285,879.802979 888.181152,879.679932 888.764648,879.530396 
	C890.239990,879.746338 890.701843,880.582397 891.103027,881.894897 
	C891.271423,882.775818 891.299072,883.317505 891.336914,883.858276 
	C891.619324,883.736206 891.730652,883.509338 891.672852,882.856079 
	C891.674622,881.846069 891.723328,881.160706 891.877991,880.113892 
	C892.104675,879.265259 892.358032,878.839478 893.079041,878.387085 
	C894.292664,878.422485 895.136902,878.542847 896.298828,878.640991 
	C896.713928,879.210327 896.811523,879.801758 896.982727,880.685181 
	C897.109558,882.019714 897.162781,883.062439 897.240356,884.497742 
	C897.148438,885.432739 897.100037,885.981201 897.131592,886.811279 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M853.345581,832.248962 
	C851.379822,824.948059 855.726990,818.590515 855.628113,811.672974 
	C855.611877,810.534241 856.033081,809.389221 856.493286,807.915039 
	C858.326294,810.052856 855.789978,813.083252 857.942810,815.855408 
	C858.979919,818.668396 858.381958,821.173462 857.901367,823.846558 
	C854.572754,824.344055 854.090210,825.568359 856.056335,828.955688 
	C856.901306,830.411499 857.276306,831.600952 856.273132,832.916138 
	C855.195374,834.329041 854.358948,833.373657 853.345581,832.248962 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M809.312805,888.203247 
	C814.039307,882.733643 815.520508,876.629578 814.066467,869.564514 
	C813.252258,865.608398 811.582153,862.749634 807.200317,861.587219 
	C806.806580,861.131104 806.639465,860.926758 806.710327,860.405884 
	C812.075867,860.138794 814.487427,862.997131 815.498169,867.801514 
	C816.532715,872.719116 816.386414,877.565247 815.557800,882.812256 
	C815.722595,883.190063 815.975098,883.213623 816.285889,883.614197 
	C815.602966,885.963623 814.299072,887.473572 812.180298,888.735291 
	C811.030640,888.980957 810.287292,888.873413 809.312805,888.203247 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M865.128418,828.036377 
	C866.647583,827.696716 867.761719,827.427795 868.874817,827.154358 
	C872.868164,826.173462 873.195923,828.486389 872.088074,831.195740 
	C870.632324,834.756104 866.900146,832.622009 864.361450,833.683228 
	C863.396667,834.086487 862.024536,833.581543 861.876343,832.043823 
	C861.671509,829.918396 862.682373,828.629028 865.128418,828.036377 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M754.982727,854.378967 
	C755.143066,865.223877 755.044373,875.608032 753.281189,885.918274 
	C753.136841,873.959961 752.284851,861.981995 754.782898,850.082336 
	C754.848755,851.364990 754.914673,852.647705 754.982727,854.378967 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M783.633667,858.629333 
	C785.172668,859.318848 786.345459,860.002502 787.821045,860.838684 
	C792.742554,863.500122 793.869141,867.450256 792.573364,872.654480 
	C791.640808,873.533508 790.886841,873.572266 789.815308,872.929932 
	C788.812805,871.593567 788.731079,870.329346 788.354858,868.780640 
	C788.222229,866.757812 787.351440,865.288879 787.036377,863.679077 
	C787.023193,863.611755 786.779358,863.516541 786.693726,863.553101 
	C786.559570,863.610413 786.468750,863.769165 786.118286,864.023926 
	C783.001770,861.550537 780.310120,858.381653 775.407959,860.947815 
	C774.767334,861.173157 774.484741,861.277405 773.804810,861.166565 
	C776.161926,857.921265 779.612305,857.838318 783.633667,858.629333 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M821.487183,822.457092 
	C820.001526,822.376160 818.912781,822.231018 817.406372,822.061401 
	C816.981567,820.808411 816.528381,819.824646 815.125366,819.034058 
	C816.354858,816.445068 820.098450,816.660583 821.219482,813.266968 
	C821.801819,813.128235 822.277039,813.334351 822.888062,813.770264 
	C823.203308,814.162048 823.382751,814.324158 823.306519,814.743530 
	C821.834778,817.187866 823.006287,818.972961 824.054321,821.102600 
	C823.350647,821.745178 822.617371,822.069031 821.487183,822.457092 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M864.418884,783.984497 
	C865.763428,788.950256 867.011292,789.317993 873.717163,786.109070 
	C875.915710,788.384033 876.819336,790.380676 872.292847,790.123779 
	C871.141357,790.058411 869.977356,790.194641 868.819946,790.253784 
	C862.346741,790.584473 862.346802,790.586121 864.418884,783.984497 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M773.927490,870.404724 
	C774.683167,869.374939 775.107788,868.650513 775.770630,867.694336 
	C780.590393,870.006226 780.411621,874.681213 775.241821,877.744873 
	C774.870972,877.665588 774.870789,877.510132 774.944336,877.485168 
	C774.129272,875.297485 772.525146,873.285461 773.927490,870.404724 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M806.572815,859.990356 
	C806.956970,860.296875 806.965759,860.504395 806.974121,861.023682 
	C799.501587,860.745056 792.414917,857.866943 784.469116,857.764221 
	C791.630005,856.379639 798.906128,858.220398 806.572815,859.990356 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M778.697144,888.235596 
	C780.742249,886.173462 782.477234,884.317749 784.427246,882.226440 
	C785.231689,881.684631 785.584839,881.056702 786.558777,880.877319 
	C787.703796,881.497131 787.881287,882.354248 787.933594,883.590698 
	C787.884277,884.132874 787.846924,884.346985 787.719482,884.872192 
	C787.485413,885.587585 787.331360,885.987976 787.046326,886.681274 
	C786.572144,887.792603 785.982239,888.404663 785.002808,889.097778 
	C784.159302,889.609253 783.627014,890.008118 782.699890,890.387451 
	C781.195190,890.493652 780.022156,890.500305 778.492798,890.386047 
	C777.539124,889.595825 777.740601,888.989136 778.697144,888.235596 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M864.568726,889.604553 
	C866.712219,889.883484 868.436890,889.938904 870.586670,889.916016 
	C875.031921,889.888977 879.052124,889.940308 883.534912,890.005493 
	C883.997559,890.019409 883.920044,890.411804 883.916077,890.611694 
	C872.591980,890.842712 861.271851,890.873779 849.488403,890.842163 
	C848.937439,890.577209 848.849792,890.374939 848.956543,889.904663 
	C849.567139,889.461121 849.996765,889.427002 850.716187,889.693237 
	C851.443604,889.920105 851.892883,889.968018 852.674011,889.936401 
	C856.669189,888.494202 860.424133,889.279907 864.568726,889.604553 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M883.604614,830.843994 
	C883.841736,830.988892 883.745056,830.827393 883.604797,830.767212 
	C881.887573,830.029297 878.844666,833.157349 878.332825,829.407471 
	C877.774048,825.314209 881.356628,826.238464 883.591736,825.598999 
	C884.592102,827.519409 883.171143,828.981018 883.604614,830.843994 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M777.676758,889.627197 
	C779.398010,889.892456 780.793518,889.974548 782.602173,889.978577 
	C783.474915,889.555847 783.978882,889.297668 784.950073,889.058716 
	C787.366028,888.538696 789.349854,888.312927 791.657959,889.451660 
	C794.708862,889.777832 797.388733,889.884766 800.513977,890.040466 
	C801.142334,890.217651 801.325317,890.346130 801.213989,890.635498 
	C790.581116,890.911255 780.242676,891.026306 769.434570,891.175110 
	C768.864990,891.015320 768.765015,890.821655 768.885925,890.386841 
	C771.091736,890.031006 773.076782,889.916260 775.485107,889.753967 
	C776.365784,889.489563 776.845459,889.395447 777.676758,889.627197 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M787.500305,880.409241 
	C786.424438,881.289673 785.851501,881.576782 784.960449,881.927307 
	C785.562134,877.149048 787.995300,872.524353 786.852600,866.968994 
	C786.779480,865.880676 786.517334,865.213867 786.154602,864.260254 
	C785.895325,864.015991 785.954529,864.097961 785.915771,864.130493 
	C786.146057,863.118164 786.518127,862.009644 787.585693,863.529846 
	C788.427917,864.729370 789.164124,866.066284 789.056396,868.032104 
	C789.540894,872.293213 789.367065,876.107971 787.500305,880.409241 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M884.013428,816.680298 
	C876.348938,815.859619 868.628967,816.082153 860.454956,816.033691 
	C859.730286,816.138550 859.473267,816.202026 859.079102,815.892822 
	C858.941895,815.520203 858.867371,815.497498 858.846680,815.465698 
	C859.639221,815.310425 860.452576,815.186951 861.665588,814.965515 
	C864.371887,814.145630 866.735229,814.651428 869.496216,814.659485 
	C873.968445,814.827454 878.014709,814.879456 882.524658,814.954956 
	C883.331055,815.442871 883.673645,815.907349 884.013428,816.680298 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M838.527344,832.068054 
	C838.570374,830.848633 838.164368,830.015564 836.874756,829.221802 
	C839.757080,824.682007 842.026672,828.087524 844.804871,829.925293 
	C844.830566,832.519836 843.121338,832.736328 840.858032,832.415039 
	C839.992065,832.181152 839.459595,832.138428 838.527344,832.068054 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M751.848877,864.496338 
	C751.392273,865.506836 750.957703,866.074402 750.292358,866.779053 
	C750.061523,860.311401 750.061523,853.706482 750.061523,847.101624 
	C750.328491,847.088013 750.595459,847.074463 750.862427,847.060852 
	C751.198608,852.725037 751.534790,858.389160 751.848877,864.496338 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M851.573486,812.725464 
	C851.430359,818.058411 849.958618,822.865173 848.116333,827.987610 
	C847.763123,828.393799 847.522888,828.420959 846.975525,828.255249 
	C846.619202,827.869202 846.570007,827.676086 846.690186,827.236572 
	C846.886108,826.799316 846.912720,826.608337 846.746338,826.201965 
	C846.356384,825.953064 846.159485,825.919434 846.262207,825.884399 
	C846.767090,825.812988 846.972351,825.742920 847.272583,825.361816 
	C846.583252,825.191528 846.433167,824.939026 847.317261,824.294983 
	C849.637695,820.943481 849.647339,817.152100 850.518066,813.217407 
	C850.950867,812.774353 851.136414,812.619202 851.573486,812.725464 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M852.933105,881.543823 
	C851.493042,882.919983 852.621948,884.832642 851.109558,886.279419 
	C851.053711,880.400085 850.440552,874.943420 851.731812,869.178284 
	C852.285217,872.949768 853.417480,876.962891 852.933105,881.543823 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M851.911377,812.582031 
	C851.648682,812.973877 851.472229,812.960876 851.030518,812.938599 
	C851.163391,809.236633 851.561401,805.543762 851.924927,801.425781 
	C852.083008,800.615601 852.275513,800.230652 852.517944,799.526367 
	C852.122009,798.224365 851.987671,797.242859 852.879272,796.020874 
	C853.741821,795.765625 854.158325,796.006897 854.338501,796.876221 
	C853.497986,802.227112 852.747864,807.202148 851.911377,812.582031 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M858.720215,815.687378 
	C859.114929,815.614868 859.288025,815.709595 859.724243,815.939697 
	C859.778870,816.863281 859.530762,817.643433 859.368774,818.441162 
	C858.655151,821.954651 858.353760,825.037476 863.672485,823.099670 
	C864.471436,822.808594 865.562561,823.319458 866.765869,823.748108 
	C864.011719,824.915039 861.014221,825.837830 857.655518,824.452026 
	C857.675720,821.716858 857.885315,819.399719 858.085754,816.649170 
	C858.217224,816.095337 858.357849,815.974976 858.720215,815.687378 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M858.687134,782.506470 
	C861.365112,778.678894 860.496277,774.084656 863.677368,770.885254 
	C862.840332,775.682739 861.620789,780.507935 860.187622,785.646118 
	C859.426208,785.682129 859.074829,785.216431 858.642090,784.438721 
	C858.400146,783.788086 858.360901,783.396851 858.687134,782.506470 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M840.336731,832.545776 
	C841.951477,831.704224 843.378418,831.184448 844.970581,830.380737 
	C846.538147,831.498047 846.094299,832.863586 844.709961,833.763977 
	C843.188232,834.753662 841.318298,835.621643 839.556824,834.792847 
	C838.530640,834.310059 840.032288,833.569885 840.336731,832.545776 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M861.883179,799.276001 
	C866.993469,798.752869 872.049744,798.375610 877.525513,797.956299 
	C877.992310,798.290161 878.039734,798.666016 878.105591,799.326050 
	C873.028564,799.710083 867.932983,799.809937 862.371948,799.816528 
	C861.906433,799.723267 861.829285,799.421936 861.883179,799.276001 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M888.337646,880.045044 
	C886.829956,882.679077 890.338135,886.443176 885.575806,887.814453 
	C885.735596,884.692078 886.295776,881.655029 887.069336,878.278259 
	C887.752380,877.899414 888.118835,878.082214 888.491333,878.774292 
	C888.552002,879.310425 888.517700,879.528809 888.337646,880.045044 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M843.808228,820.772278 
	C843.649170,822.272278 844.883850,824.366516 842.501648,824.504028 
	C841.513306,824.561157 839.905701,823.897034 839.577393,823.132446 
	C839.025940,821.848511 839.979858,820.660278 841.711243,820.037964 
	C842.773193,819.587769 843.214233,819.993713 843.808228,820.772278 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M888.141357,878.827759 
	C888.033447,878.274475 887.898376,878.075500 887.469360,877.943909 
	C888.307007,877.654053 889.331299,877.369568 890.657715,876.932312 
	C890.921814,876.973206 890.883850,877.166809 890.892456,877.652832 
	C891.522278,878.438660 891.986084,879.035889 892.533264,879.918091 
	C892.631958,880.827820 892.620911,881.475342 892.561646,882.446045 
	C892.168579,883.572510 891.536011,883.557434 890.653870,883.072632 
	C890.180908,881.939331 889.892700,881.091125 889.352905,880.018372 
	C888.705505,879.697571 888.412170,879.469482 888.141357,878.827759 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M742.859497,890.463562 
	C741.294983,890.937744 739.553711,890.975098 737.392517,890.894287 
	C736.862488,890.622131 736.752380,890.468201 736.801147,890.078979 
	C737.075378,888.266724 737.190674,886.689636 737.306030,885.112610 
	C737.804810,887.529480 738.677246,889.466492 741.974365,889.104126 
	C742.396423,889.467651 742.539612,889.747192 742.859497,890.463562 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M832.901672,825.937378 
	C831.650330,825.649475 830.440552,824.974182 829.053955,824.062805 
	C829.090271,823.146790 829.303284,822.466797 829.764282,821.893433 
	C830.448792,822.471252 830.987732,822.526550 831.795105,822.200684 
	C833.227600,822.956909 832.918701,824.297180 832.901672,825.937378 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M839.243408,814.984863 
	C838.322815,813.463867 838.127747,812.072937 840.204163,811.522705 
	C841.045715,811.299744 842.083618,811.394592 842.362366,812.236145 
	C842.925964,813.937500 841.112305,813.763977 840.158447,814.676514 
	C839.982544,814.937134 839.489990,814.972229 839.243408,814.984863 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M773.964661,870.069580 
	C773.735535,872.395630 774.722717,874.475708 775.105591,877.044922 
	C774.437683,877.054443 773.857483,876.648621 773.171570,875.891602 
	C773.055603,875.312744 773.048279,875.085022 773.039551,874.686218 
	C772.216858,873.370667 772.000549,872.146790 772.815063,870.411865 
	C773.277588,870.014282 773.474121,870.026978 773.964661,870.069580 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M869.368347,823.844116 
	C869.524414,821.484802 870.987976,821.781860 872.813171,822.768005 
	C871.917847,823.317017 870.814880,823.596191 869.368347,823.844116 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M773.130249,861.071716 
	C773.682190,860.957031 773.956970,860.962646 774.640869,861.018555 
	C773.917114,862.343628 772.784180,863.618469 771.307556,864.931030 
	C770.666504,863.246094 772.090210,862.384338 773.130249,861.071716 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M868.154663,772.576538 
	C868.669373,774.875061 866.525085,774.303345 865.620544,775.123535 
	C866.242432,774.075439 865.086182,771.703308 868.154663,772.576538 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M844.076416,820.628418 
	C843.523376,820.759216 843.043030,820.496582 842.308594,820.108276 
	C842.092590,819.280151 842.130676,818.577576 842.305420,817.545227 
	C842.752075,817.267517 843.057190,817.247314 843.585632,817.117798 
	C843.925537,818.132324 844.037354,819.183594 844.076416,820.628418 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M768.679443,890.059692 
	C769.094604,890.324463 769.082397,890.503174 769.017578,890.945374 
	C768.354736,892.102356 767.415955,891.935303 766.209106,891.879272 
	C765.873596,891.505432 765.820862,891.222168 765.727905,890.730713 
	C766.572632,890.333923 767.412354,890.153748 768.679443,890.059692 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M883.926636,831.194580 
	C884.987915,830.849426 885.843079,829.190613 887.234192,830.550293 
	C887.490479,830.800720 887.659851,831.618347 887.567139,831.674377 
	C886.520630,832.307312 885.422729,832.137695 884.151367,831.393677 
	C883.958679,831.103333 883.956970,831.175293 883.926636,831.194580 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M843.867554,801.458496 
	C844.088562,801.175842 844.417175,801.122131 845.231995,800.952942 
	C846.731567,800.903870 847.228821,801.544800 847.422729,802.755066 
	C846.843445,803.007019 846.340820,802.941895 845.470276,802.778564 
	C844.726624,802.349365 844.350891,802.018311 843.867554,801.458496 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M778.130127,889.588013 
	C777.531860,889.839966 777.061279,889.869446 776.249573,889.802673 
	C776.115662,888.278381 777.117554,887.999268 778.670288,888.029175 
	C778.757446,888.474548 778.507629,888.920044 778.130127,889.588013 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M858.858154,784.357788 
	C859.372131,784.517212 859.604126,784.972168 859.905029,785.693115 
	C859.967590,786.295166 859.961182,786.631226 859.866028,787.202942 
	C859.777222,787.438599 859.337463,787.229004 859.139893,787.086670 
	C858.401794,786.247498 858.281555,785.483582 858.858154,784.357788 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M815.752686,884.026672 
	C815.449158,883.713562 815.366089,883.432129 815.418091,883.299316 
	C816.020569,883.114990 816.571106,883.063416 817.531128,882.995056 
	C817.919678,883.161865 817.898865,883.345581 817.793823,883.793396 
	C817.200867,884.400269 816.649719,884.494385 815.752686,884.026672 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M849.404358,804.737427 
	C849.556763,804.858765 849.578064,805.066650 849.599365,805.274475 
	C849.490662,805.124329 849.381958,804.974121 849.404358,804.737427 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M834.962769,812.246765 
	C835.549438,812.167908 836.101440,812.343811 836.653503,812.519653 
	C836.307922,812.726440 835.962341,812.933228 835.297241,813.076782 
	C834.961182,812.842896 834.944702,812.672241 834.962769,812.246765 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M785.763550,864.384827 
	C786.710083,864.342468 786.925354,865.023315 786.962280,866.190002 
	C786.522095,865.962891 786.076965,865.358276 785.763550,864.384827 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M823.291504,814.981750 
	C823.039429,814.834106 823.028076,814.667480 823.020264,814.250488 
	C823.441956,814.160522 823.860046,814.321045 824.278198,814.481567 
	C824.029541,814.641968 823.780884,814.802368 823.291504,814.981750 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M847.392456,824.231445 
	C847.775208,824.506653 847.721680,824.697449 847.469177,824.955566 
	C846.934570,824.967407 846.501465,824.884094 846.068359,824.800903 
	C846.396851,824.592224 846.725281,824.383545 847.392456,824.231445 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M831.681030,822.010437 
	C831.580444,822.710083 831.049561,823.026733 830.152161,822.228271 
	C830.457153,822.001526 830.902161,822.003052 831.681030,822.010437 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M774.034912,838.290405 
	C774.357666,838.039185 774.620728,838.152161 774.967407,838.511353 
	C774.718384,838.662842 774.359680,838.628479 774.034912,838.290405 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M858.869751,833.051392 
	C858.908813,833.031067 858.830627,833.071777 858.869751,833.051392 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M859.004883,833.006470 
	C859.090149,832.971619 859.170593,832.930298 859.119019,832.939697 
	C858.987000,832.990356 859.000000,833.000000 859.004883,833.006470 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M773.451050,834.937683 
	C773.206787,834.643127 773.399658,834.282227 773.799072,833.682556 
	C774.251465,833.561340 774.497314,833.679016 774.738403,834.204468 
	C774.451843,834.698669 774.170044,834.784973 773.451050,834.937683 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M864.774048,783.122803 
	C865.072571,783.180176 865.229553,783.382019 865.386536,783.583862 
	C865.258484,783.631592 865.130371,783.679321 864.793823,783.697998 
	C864.585266,783.668884 864.632568,783.267273 864.774048,783.122803 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M834.762451,813.065186 
	C834.819153,813.270752 834.619263,813.565735 834.148804,813.947693 
	C834.087524,813.741333 834.296692,813.447998 834.762451,813.065186 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M887.140991,814.938171 
	C887.334656,814.956177 887.526062,815.223145 887.699951,815.742310 
	C887.392212,815.798767 887.210938,815.529663 887.140991,814.938171 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M846.686157,827.122681 
	C846.976196,827.238770 846.994263,827.494202 846.791016,827.909546 
	C846.423706,827.830261 846.371826,827.561157 846.686157,827.122681 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M846.340820,825.992798 
	C846.561768,825.883057 846.548218,825.945068 846.550720,825.965820 
	C846.372192,825.888367 846.475708,826.854614 846.340820,825.992798 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M806.005371,824.832397 
	C805.984314,824.615784 806.230164,824.360413 806.745728,824.074951 
	C806.767761,824.294434 806.520020,824.544067 806.005371,824.832397 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M809.072754,822.861450 
	C809.040771,822.644958 809.263489,822.374390 809.754517,822.081177 
	C809.791077,822.308167 809.559204,822.557739 809.072754,822.861450 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M815.558228,862.466309 
	C815.592834,862.521606 815.523621,862.411072 815.558228,862.466309 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M771.005371,865.007446 
	C770.884460,865.288757 770.750916,865.556274 770.617432,865.823853 
	C770.583618,865.576172 770.549805,865.328491 770.739868,865.024780 
	C770.963806,864.968811 770.992798,864.993713 771.005371,865.007446 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M780.998657,880.952148 
	C781.084045,880.542236 781.404297,880.322083 781.724548,880.101929 
	C781.820923,880.378723 781.917297,880.655457 781.880005,881.196289 
	C781.575317,881.354187 781.404419,881.247986 780.998657,880.952148 
z"/>
<path fill="#E7E4C9" opacity="1.000000" stroke="none" 
	d="
M857.950562,764.644104 
	C857.516785,766.209045 857.011353,767.396729 856.256714,768.792114 
	C854.793701,770.188538 853.962769,771.609436 854.025879,773.323486 
	C854.120178,775.884888 852.323853,777.033020 850.277344,778.492188 
	C849.211609,779.022583 848.440491,779.200073 847.242065,779.322266 
	C844.403015,779.233215 841.893860,779.814575 839.236633,778.352783 
	C838.116516,778.064087 837.336548,778.007385 836.272339,777.873413 
	C833.868347,776.627136 831.651489,776.486633 829.276001,776.872803 
	C825.859619,777.428040 823.556152,775.671448 823.336853,772.425903 
	C823.092468,768.809387 820.393555,764.735535 824.761841,761.279907 
	C827.367432,760.964478 829.745056,760.924011 832.562256,760.960938 
	C833.814575,764.086060 836.007812,762.912842 837.839233,762.547913 
	C843.280457,761.463257 848.764954,762.148010 854.227722,762.097412 
	C855.719116,762.083557 857.157349,762.711548 857.950562,764.644104 
z"/>
<path fill="#DFDFC9" opacity="1.000000" stroke="none" 
	d="
M852.306824,790.699707 
	C844.183044,791.255798 836.379639,791.454102 828.593079,791.927917 
	C826.283142,792.068542 825.365540,791.520813 824.967041,789.187195 
	C823.406982,780.051514 823.334839,780.072815 832.613831,780.307922 
	C834.439880,780.354187 836.268372,780.300476 838.547974,780.167358 
	C840.758423,778.493469 842.908508,779.173767 845.347412,779.002563 
	C848.080872,779.249146 850.451843,778.437256 853.014038,779.790100 
	C853.675720,780.560425 853.926270,781.079773 854.179260,782.058472 
	C854.291992,782.757080 854.315613,783.038086 854.354004,783.739075 
	C854.319885,786.401245 854.001343,788.569031 852.306824,790.699707 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M817.802002,810.677368 
	C817.996582,811.820923 817.340088,812.342468 816.591736,812.699341 
	C809.274719,816.188354 803.101501,821.329407 796.483154,826.230652 
	C796.203186,824.638855 793.918030,822.881104 796.955383,821.697327 
	C798.524597,821.085754 797.438293,819.530090 796.688843,818.886780 
	C795.399109,817.779541 795.393677,819.663635 794.743347,819.976868 
	C792.263550,821.171692 790.376038,824.049194 786.860718,822.601196 
	C789.095337,820.420776 791.484741,818.548828 794.062195,816.392822 
	C799.074646,813.722290 802.197937,808.911865 807.652710,806.809326 
	C808.429260,806.467590 808.888306,806.397827 809.684937,806.633667 
	C812.507507,808.024597 815.013855,809.250244 817.802002,810.677368 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M812.627197,753.664917 
	C812.810120,755.002502 812.900085,756.035278 813.029541,757.456421 
	C812.216980,759.880615 812.398376,761.641602 814.748596,762.958008 
	C817.343628,766.183899 816.590698,769.698730 815.992065,773.605713 
	C813.589661,774.098267 812.994629,772.833557 812.963684,770.879944 
	C812.948486,769.919617 813.498962,768.316223 811.219360,768.791626 
	C809.490051,769.158508 808.290710,768.682861 807.216797,767.162598 
	C807.017029,762.293274 807.099976,757.619324 807.240601,752.483521 
	C809.375488,751.686646 809.363220,749.536682 810.735352,748.175293 
	C812.374451,749.529785 811.727295,751.653198 812.627197,753.664917 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M815.907959,774.371277 
	C815.567627,770.664795 815.353943,767.291443 815.110107,763.460144 
	C815.792480,762.664062 816.665771,760.410767 817.136963,763.136292 
	C818.769165,772.579346 820.405701,782.022034 821.946167,791.480164 
	C822.139343,792.666565 822.411255,794.546082 820.520630,794.559631 
	C818.990417,794.570557 819.401917,792.830688 819.202454,791.763733 
	C818.139587,786.078674 817.089355,780.391113 815.907959,774.371277 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M824.555908,760.916748 
	C823.230225,764.343872 823.653687,767.883911 824.008362,771.425354 
	C824.354797,774.884460 826.092346,776.655945 829.606628,775.596375 
	C832.111389,774.841125 834.035156,775.461304 835.907837,777.456665 
	C831.908203,777.939575 826.019836,779.877930 824.186279,777.336304 
	C821.568420,773.707520 821.879456,767.951294 820.991638,763.094177 
	C820.473206,760.257751 822.583496,760.903381 824.555908,760.916748 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M853.307922,783.265808 
	C853.204590,782.556458 853.217590,782.096863 853.369324,781.318237 
	C853.903931,779.698914 854.532104,778.642212 856.460571,778.605103 
	C857.029846,778.840881 857.216858,779.019836 857.541992,779.563110 
	C857.832520,785.501709 855.514282,790.460693 853.500122,795.828369 
	C853.094849,796.937134 852.975220,797.784058 852.711731,798.919067 
	C852.094177,798.860413 851.620544,798.513733 850.910217,797.791260 
	C849.817993,796.239319 849.815735,794.996155 850.606201,793.387573 
	C851.197998,792.576355 851.566040,792.085876 851.957092,791.273804 
	C852.312805,788.889954 852.645569,786.827698 853.057434,784.375610 
	C853.232483,783.829041 853.328369,783.672302 853.307922,783.265808 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M804.775879,781.534546 
	C805.044617,780.661560 805.104736,780.207092 805.222534,779.413879 
	C808.844421,786.395203 808.722717,794.012939 806.756165,801.907349 
	C804.881897,799.268005 805.157166,796.156189 805.072205,793.177612 
	C804.965393,789.431030 804.796265,785.692017 804.775879,781.534546 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M796.622559,775.039185 
	C797.449097,781.615845 798.117371,787.822510 798.840820,794.425171 
	C798.646973,795.449524 798.309204,795.996826 797.335083,796.050171 
	C796.663452,793.852051 796.274719,791.825195 795.826172,789.413208 
	C795.512451,788.609375 795.358032,788.156799 795.375610,787.314392 
	C795.342346,783.341431 795.236328,779.724365 795.126648,775.670532 
	C795.429199,774.710999 795.876343,774.522888 796.622559,775.039185 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M791.363647,812.189087 
	C791.040100,810.577454 791.012878,809.187805 790.908325,807.386719 
	C790.831604,805.262817 790.832214,803.550354 790.786133,801.411316 
	C790.401123,799.939758 790.533813,798.865417 790.628296,797.407227 
	C790.757385,796.570129 790.798889,796.124756 790.828796,795.343872 
	C790.753540,794.828186 790.689819,794.648010 790.790100,794.232605 
	C793.280823,794.545349 792.710083,796.578430 792.798584,798.036255 
	C793.064758,802.420044 793.079102,806.819092 793.128113,811.686829 
	C792.628174,812.423645 792.159912,812.506775 791.363647,812.189087 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M804.685913,781.376526 
	C805.412354,787.786194 805.840210,794.456421 806.334717,801.595215 
	C803.557190,798.512634 804.177979,794.207214 803.811829,789.696106 
	C804.010803,786.727844 804.199036,784.182434 804.685913,781.376526 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M850.428467,793.103577 
	C850.786499,794.273804 850.743042,795.480774 850.686646,797.051575 
	C847.248657,798.683472 845.652588,795.773071 843.122559,794.397644 
	C845.471802,792.881775 847.795227,793.282043 850.428467,793.103577 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M814.255066,799.646973 
	C812.215881,798.576355 815.554321,795.783081 812.310303,795.013672 
	C811.683594,794.864990 811.844788,793.170227 812.628357,792.443848 
	C813.048157,792.054626 813.887207,791.697693 814.347351,791.860962 
	C815.256836,792.183716 815.003296,793.215637 814.989136,793.965881 
	C814.953430,795.856201 817.381897,797.936646 814.255066,799.646973 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M809.355652,775.697144 
	C809.729980,775.611084 810.025208,775.945923 810.514404,776.394958 
	C811.021729,779.075562 811.085815,781.630493 810.320435,784.187866 
	C808.144348,781.720947 808.916626,778.891785 809.355652,775.697144 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M796.846436,774.940247 
	C796.414307,775.338440 796.047729,775.267578 795.402100,775.215271 
	C795.078064,772.703796 794.550293,770.126282 795.906738,766.723755 
	C797.508545,769.774841 796.820007,772.183838 796.846436,774.940247 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M846.251038,779.767456 
	C843.957153,780.037781 841.909485,780.132202 839.431030,780.134216 
	C838.981018,779.721741 838.961792,779.401672 838.919434,778.601196 
	C841.319153,778.058655 843.741943,777.996521 846.574707,778.020752 
	C847.383789,778.786377 847.007629,779.210999 846.251038,779.767456 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M780.639343,799.926514 
	C780.959167,797.143372 781.618225,794.256226 782.544556,791.124390 
	C783.157471,794.056824 783.272766,797.186646 780.639343,799.926514 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M783.520996,787.814453 
	C782.809509,785.992249 784.099365,784.325012 784.467102,782.151978 
	C787.008301,784.165466 786.434753,786.051331 783.520996,787.814453 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M797.031189,796.286255 
	C797.522095,795.633484 797.991943,795.388062 798.678833,794.981934 
	C798.803345,796.673340 799.587219,798.634644 798.173889,800.561462 
	C796.446411,799.566589 797.232788,797.963379 797.031189,796.286255 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M785.581787,778.941772 
	C785.599976,777.483887 785.935303,775.949097 786.493713,774.163574 
	C790.781311,776.279846 785.946777,777.177063 785.581787,778.941772 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M790.824585,812.158325 
	C791.511108,812.005981 791.954895,812.044800 792.731689,812.122559 
	C793.052734,812.569336 793.040894,812.977295 793.012451,813.691406 
	C791.972473,813.768494 790.207275,814.626038 790.824585,812.158325 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M800.570312,749.177917 
	C800.874268,750.082458 800.923218,751.138062 800.925415,752.588257 
	C799.180054,751.997864 798.497437,750.856201 800.570312,749.177917 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M795.338867,747.720703 
	C795.726135,747.211548 796.029175,747.017395 796.572754,746.692871 
	C796.898865,747.775635 797.350098,749.097107 795.491943,749.927002 
	C795.178162,749.354797 795.216431,748.695312 795.338867,747.720703 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M809.958923,806.529053 
	C809.551758,806.810303 809.102356,806.821777 808.322266,806.755493 
	C808.359924,805.280701 808.889648,804.625916 809.958923,806.529053 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M790.520935,797.258423 
	C790.775024,798.077209 790.834229,799.138916 790.816406,800.592651 
	C789.774048,799.921814 789.878540,798.731873 790.520935,797.258423 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M792.331970,757.939697 
	C791.996643,757.063354 792.308838,756.263916 793.437988,755.580933 
	C793.901184,756.466492 793.909363,757.432068 792.331970,757.939697 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M795.214478,787.045166 
	C795.568176,787.412842 795.688049,787.867188 795.787109,788.674744 
	C794.684448,788.735779 793.592102,788.447754 795.214478,787.045166 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M805.074097,774.938293 
	C804.687195,774.566345 804.496094,774.083435 804.353638,773.334229 
	C804.909119,773.547180 805.840515,773.816956 805.074097,774.938293 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M782.986572,790.803162 
	C782.719727,790.739136 782.676880,790.345154 782.775757,790.173462 
	C783.269592,790.119995 783.664612,790.238220 784.059631,790.356384 
	C783.790894,790.526672 783.522156,790.696899 782.986572,790.803162 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M794.292480,752.835693 
	C794.192749,752.662598 794.318420,752.323975 794.653809,751.802979 
	C794.748291,751.970398 794.633057,752.320251 794.292480,752.835693 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M797.454529,811.528625 
	C797.425354,811.478088 797.483704,811.579163 797.454529,811.528625 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M805.537598,803.546631 
	C805.477966,803.583740 805.597229,803.509583 805.537598,803.546631 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M790.798462,794.077881 
	C790.962402,794.170105 790.970703,794.342834 790.898132,794.761963 
	C790.695618,794.821838 790.552185,794.644714 790.466187,794.443054 
	C790.441040,794.384033 790.579407,794.255249 790.798462,794.077881 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M791.445007,759.785156 
	C791.335327,759.634399 791.409485,759.309692 791.673096,758.809204 
	C791.784607,758.959351 791.706726,759.285278 791.445007,759.785156 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M787.142700,771.926758 
	C786.929565,771.833862 786.932800,771.598572 787.104736,771.211914 
	C787.413086,771.277893 787.441650,771.519165 787.142700,771.926758 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M899.716858,877.010376 
	C899.904297,877.317688 899.698364,877.566101 899.146118,877.775757 
	C898.902466,877.822205 898.913940,877.563049 898.910767,877.433472 
	C899.080505,877.214783 899.253418,877.125671 899.716858,877.010376 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M850.273682,778.073486 
	C853.677124,776.013611 851.780090,770.925354 855.630981,769.050049 
	C855.493164,771.638489 854.978882,774.277222 854.408569,777.319885 
	C853.316833,779.256531 851.962341,779.046326 850.273682,778.073486 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M849.642944,777.819824 
	C851.237183,777.826538 852.459351,777.928406 854.017090,777.877075 
	C854.928955,777.800842 855.505249,777.877808 856.517090,777.978516 
	C857.043884,778.194519 857.135071,778.386902 857.006714,778.811035 
	C855.394958,778.917908 855.060486,780.391541 853.781433,780.924927 
	C851.489746,779.200439 849.061646,780.514404 846.431396,780.033447 
	C846.258362,779.489075 846.511963,779.034790 846.875122,778.343811 
	C847.746704,778.043091 848.508789,777.979004 849.642944,777.819824 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M856.904907,779.059570 
	C856.845825,778.874329 856.904602,778.705872 856.958069,778.269775 
	C858.803711,775.666016 858.153442,772.277649 860.644653,770.003784 
	C860.295471,772.738525 859.594177,775.532166 858.765015,778.706421 
	C858.345154,779.358276 858.004333,779.474976 857.422241,779.192993 
	C857.237610,778.974243 857.022644,779.076233 856.904907,779.059570 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M861.576294,767.955688 
	C861.827026,768.589355 861.713745,769.214844 861.272644,769.923828 
	C861.033936,769.320740 861.123108,768.634155 861.576294,767.955688 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M892.725891,879.847351 
	C891.680420,880.075317 891.061401,879.604797 890.945801,878.268311 
	C891.498962,878.007507 892.058899,878.069885 893.033569,878.217285 
	C893.235168,878.706299 893.021912,879.110352 892.725891,879.847351 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M857.117065,779.361389 
	C857.546326,779.025574 857.856934,779.059265 858.403320,779.081177 
	C858.639343,779.838684 858.641541,780.590454 858.816162,781.678223 
	C858.988586,782.014282 859.028198,781.993958 859.019897,781.972900 
	C857.988586,783.334229 858.731689,784.942261 858.227905,786.739746 
	C858.014526,787.061218 857.994324,786.995300 858.027100,786.984680 
	C857.248840,787.657654 857.595154,788.651794 857.199341,789.781494 
	C857.015564,790.066772 857.003113,789.999756 857.034607,789.987427 
	C855.175781,791.824341 855.684937,794.510864 854.486572,796.968445 
	C854.045105,796.967163 853.842102,796.682251 853.426758,796.243774 
	C854.475098,790.642944 855.735779,785.195740 857.117065,779.361389 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M940.641296,849.771790 
	C941.499512,850.436890 941.958496,850.891968 942.245850,851.639526 
	C940.583191,852.786438 939.169617,853.405762 938.730347,850.526855 
	C939.071228,849.698547 939.598450,849.485901 940.641296,849.771790 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M940.980835,849.777954 
	C940.511780,850.008179 939.983093,850.034668 939.057373,850.130493 
	C937.587585,850.029175 936.514893,849.858643 935.256104,849.408447 
	C936.723083,849.080383 938.376221,849.031982 940.435791,849.070190 
	C940.842346,849.156799 940.921204,849.574158 940.980835,849.777954 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M942.114319,852.131470 
	C942.212769,851.773987 942.402161,851.634644 942.906128,851.655884 
	C942.977600,852.175964 942.863098,852.780396 942.114319,852.131470 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M897.464050,887.126648 
	C896.329834,886.601196 895.951294,886.017456 896.991455,885.033936 
	C897.827515,885.404297 898.390442,885.918213 899.000122,886.716064 
	C898.625488,887.055481 898.203979,887.110840 897.464050,887.126648 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M900.226013,889.142151 
	C899.766113,888.706421 899.430908,888.251099 899.039429,887.375366 
	C900.080688,886.828247 900.691284,887.380432 900.920410,888.724243 
	C900.693176,889.088623 900.522217,889.108337 900.226013,889.142151 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M796.865356,135.334930 
	C797.455933,135.008041 797.894958,134.995071 798.663574,134.983383 
	C798.997070,135.740921 799.001160,136.497177 799.001343,137.631332 
	C796.724976,140.571548 801.281433,141.357010 800.326904,143.872757 
	C797.471558,149.233810 794.482666,146.557022 791.250244,144.230148 
	C790.684143,143.884613 790.437683,143.705368 790.137329,143.244263 
	C789.630493,142.654343 789.475098,142.187698 789.781006,141.322021 
	C794.218994,141.700165 794.713379,137.730515 796.865356,135.334930 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M809.279663,139.935165 
	C805.953430,140.002045 804.427368,137.970673 803.037476,135.349609 
	C803.319214,134.985565 803.686035,135.070465 803.950562,134.943054 
	C807.721436,133.126022 807.718079,133.119110 811.647339,134.999359 
	C812.581238,135.693756 812.728394,136.464355 812.222900,137.652451 
	C811.982727,137.989426 812.000000,138.000000 811.993896,137.991486 
	C811.251831,138.699707 810.675720,139.617249 809.279663,139.935165 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M841.750732,164.762878 
	C843.186096,165.117386 844.501892,165.402328 844.504456,166.807983 
	C844.506836,168.138214 843.161072,167.897110 842.223511,168.003723 
	C841.251343,168.114273 840.251648,168.147232 839.320374,168.412216 
	C838.052734,168.772934 836.635620,169.535217 835.630493,168.394760 
	C834.137939,166.701141 836.697144,166.013229 836.937561,164.316711 
	C836.991699,163.960220 836.991333,163.481613 836.994446,163.242340 
	C837.326843,162.672287 837.722900,162.477112 838.522827,162.465622 
	C839.921631,162.951843 840.698608,163.766479 841.750732,164.762878 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M867.910400,158.019806 
	C867.747253,158.218857 867.382629,158.082153 867.212646,157.986938 
	C867.512451,154.676865 866.458618,151.371872 867.885254,147.841705 
	C869.982666,150.247818 868.480774,153.317810 868.871033,156.647461 
	C868.545654,157.333786 868.309631,157.577271 867.910400,158.019806 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M797.364380,125.995499 
	C796.997742,125.255753 796.998535,124.507919 797.006042,123.386650 
	C797.988403,122.967102 798.990784,123.056946 799.752625,122.220345 
	C800.537292,121.358742 801.252380,119.356407 802.608093,121.000824 
	C803.626892,122.236465 802.090027,123.293175 800.994934,124.063881 
	C799.957886,124.793694 799.310364,126.176781 797.364380,125.995499 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M849.003418,165.002777 
	C849.497681,162.934967 845.339661,160.786377 847.907654,159.654465 
	C850.501282,158.511307 850.931763,162.329926 851.998962,164.621796 
	C852.004883,164.995102 852.000000,165.000412 851.997559,165.002655 
	C851.306458,165.580215 850.532898,165.729736 849.335449,165.230286 
	C848.993774,164.993683 849.000000,164.999359 849.003418,165.002777 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M800.543457,144.267059 
	C800.508667,141.716583 794.146057,141.440262 798.645264,138.070526 
	C798.999634,138.176636 799.001709,138.344025 799.008057,138.762512 
	C799.978210,139.999451 801.467407,139.794891 802.760254,140.789246 
	C802.990173,141.018417 803.000000,140.998978 802.990723,141.005280 
	C803.317932,141.294174 803.521729,141.655136 803.587891,142.404907 
	C803.476990,142.927399 803.392029,143.127075 803.096680,143.576599 
	C802.370178,144.257767 801.783325,144.515839 800.543457,144.267059 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M809.192383,140.242218 
	C809.459778,138.959991 810.161560,138.202255 811.666992,138.008926 
	C811.852417,139.918732 815.189758,140.870468 813.306519,143.498566 
	C811.700989,142.965164 811.312439,140.617279 809.192383,140.242218 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M804.831665,141.201630 
	C809.220520,141.530930 807.186462,143.556198 806.042664,145.678955 
	C805.997559,146.001831 805.999390,146.001053 805.996033,146.004028 
	C803.649109,147.160614 802.278076,146.786758 802.783081,143.404205 
	C803.008301,142.988297 803.000122,142.999222 802.995728,143.004242 
	C803.531128,142.468109 804.078979,141.935104 804.831665,141.201630 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M824.979004,128.594360 
	C823.320618,127.546219 821.991760,126.458359 820.662903,125.370491 
	C821.065735,125.000832 821.468567,124.631165 821.871399,124.261505 
	C824.001465,124.750351 826.143311,125.227921 824.979004,128.594360 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M843.878052,161.731812 
	C843.512390,162.598007 843.025818,163.179337 842.276489,163.883438 
	C841.263672,163.971451 840.541565,163.846909 839.737915,163.041077 
	C839.192261,162.013809 839.201843,161.301163 839.767334,160.298264 
	C840.000000,160.009155 840.000000,160.000000 840.004272,160.001251 
	C840.484985,159.648514 841.154846,159.833160 841.808655,159.210236 
	C842.588989,159.811569 843.173157,160.629257 843.878052,161.731812 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M799.386475,134.991577 
	C798.991455,134.246994 798.998230,133.500748 799.004944,132.381531 
	C800.668091,132.146042 802.839355,131.376617 802.989258,134.617004 
	C803.000000,134.999390 803.000000,135.000000 803.000000,135.000305 
	C801.929443,134.997055 800.858887,134.993500 799.386475,134.991577 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M871.177368,132.264435 
	C873.964905,131.509796 873.169189,134.310425 874.413696,135.260483 
	C872.355408,135.460175 871.536499,134.254471 871.177368,132.264435 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M837.999756,128.364380 
	C838.743774,128.003983 839.491821,128.003632 840.626221,128.008041 
	C841.001343,129.078003 840.990173,130.143219 840.993042,131.600372 
	C838.957581,131.866486 838.001404,130.735947 837.999756,128.364380 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M856.991333,128.625214 
	C855.733459,128.885284 853.939819,129.292206 853.729370,127.586357 
	C853.547302,126.110321 855.144897,126.095917 856.645264,126.014183 
	C856.991760,126.015854 857.000000,125.999916 856.992004,126.004044 
	C856.981689,126.757462 856.979370,127.506760 856.991333,128.625214 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M839.630249,160.019608 
	C840.001526,160.759079 840.003052,161.509003 840.005981,162.634033 
	C839.844604,163.132477 839.681824,163.255798 839.270508,163.200012 
	C838.572144,163.015015 838.122314,163.009140 837.335022,163.003159 
	C836.970459,161.417282 837.136658,159.978683 839.630249,160.019608 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M839.366150,119.978828 
	C838.996643,119.262047 838.993286,118.523224 839.019531,117.367401 
	C840.145630,117.102242 841.621643,116.761620 841.785278,118.396858 
	C841.920471,119.747734 840.754578,119.869789 839.366150,119.978828 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M812.351624,137.984009 
	C811.995483,137.243515 812.008301,136.497604 812.016663,135.378601 
	C813.109619,135.137482 814.580017,134.767776 814.756592,136.413498 
	C814.901794,137.766312 813.752563,137.905396 812.351624,137.984009 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M813.154602,122.758728 
	C811.962769,121.861916 811.865234,120.974045 812.935608,120.386703 
	C813.307739,120.182510 814.341675,120.452797 814.542908,120.807396 
	C815.117432,121.819786 814.715393,122.609116 813.154602,122.758728 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M836.012878,120.372032 
	C836.743347,120.015121 837.495667,120.020721 838.624023,120.013588 
	C839.000000,120.000862 839.000000,120.000000 839.000000,119.999596 
	C839.001404,120.749924 839.002808,121.500664 839.003296,122.624496 
	C837.369690,123.087166 835.977783,122.860794 836.012878,120.372032 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M850.370117,125.988739 
	C850.002197,125.247368 850.004395,124.498238 850.003296,123.374557 
	C851.027161,123.114296 852.381958,122.707634 852.725342,124.137863 
	C853.099854,125.697479 851.879211,125.872093 850.370117,125.988739 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M856.658936,132.038467 
	C856.891785,133.055466 857.282593,134.380524 855.777710,134.761444 
	C855.165344,134.916458 854.394958,134.750702 854.420349,133.879852 
	C854.454163,132.723206 855.353088,132.328781 856.658936,132.038467 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M857.003296,132.003387 
	C857.002747,131.253662 856.998962,130.500565 857.000366,129.370911 
	C857.005676,128.994354 857.000000,129.000000 856.997070,129.002701 
	C858.120056,129.106949 859.328369,129.324356 859.552673,130.592712 
	C859.791931,131.945786 858.583618,131.874405 857.337402,131.984467 
	C856.993347,131.993378 857.000000,132.000000 857.003296,132.003387 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M846.520630,131.290131 
	C845.178101,131.672577 844.435974,131.230499 844.438660,130.053741 
	C844.439331,129.765381 845.005859,129.256531 845.342224,129.230026 
	C846.633057,129.128281 846.931274,129.935257 846.520630,131.290131 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M802.928040,140.658875 
	C801.567505,141.078674 800.212036,140.961975 799.166138,139.319153 
	C800.388794,139.166412 802.070923,138.403320 802.928040,140.658875 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M809.803955,130.788467 
	C810.646301,129.823441 811.544250,129.803070 812.355896,130.577820 
	C812.501221,130.716476 812.498047,131.273605 812.350891,131.412720 
	C811.424316,132.288986 810.607361,131.847763 809.803955,130.788467 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M851.201965,130.176941 
	C851.843445,129.223862 852.436707,129.296417 852.733948,130.054596 
	C852.870178,130.401962 852.683167,131.174103 852.405945,131.328506 
	C851.636597,131.756943 851.267151,131.209595 851.201965,130.176941 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M865.006104,130.993591 
	C865.893372,131.083176 866.952820,130.743805 867.454285,131.793045 
	C867.544373,131.981400 867.117859,132.648117 866.814636,132.749542 
	C865.903809,133.054169 865.382202,132.495850 865.042053,131.342590 
	C864.987793,131.012833 865.000000,131.000000 865.006104,130.993591 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M849.012085,132.476044 
	C849.942749,133.098145 850.140137,133.763092 849.384949,134.397583 
	C849.224121,134.532654 848.744446,134.526230 848.587219,134.386948 
	C847.849365,133.733032 848.062195,133.074326 849.012085,132.476044 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M846.996826,123.000381 
	C846.896729,123.996323 846.677795,124.945000 845.394653,124.811539 
	C845.067017,124.777458 844.513672,124.259926 844.533447,124.000221 
	C844.616760,122.904778 845.583374,123.108498 846.656372,122.999924 
	C847.000000,123.006264 847.000000,122.999840 846.996826,123.000381 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M869.351562,125.000168 
	C869.058472,123.526901 869.912659,122.962990 871.647583,123.000511 
	C871.921997,124.451729 871.086243,125.038055 869.351562,125.000168 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M831.210022,115.165131 
	C832.201904,115.203392 832.808472,115.597618 832.492615,116.267471 
	C832.335510,116.600784 831.351929,116.856697 830.934204,116.683838 
	C830.258362,116.404144 830.322205,115.739983 831.210022,115.165131 
z"/>
<path fill="#6A7594" opacity="1.000000" stroke="none" 
	d="
M808.348022,116.536102 
	C807.579956,116.599899 807.030273,116.436325 806.480469,116.272736 
	C806.682861,115.906258 806.806519,115.320183 807.102234,115.214302 
	C808.008057,114.889801 808.588745,115.259163 808.348022,116.536102 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M836.004700,119.995270 
	C835.122009,119.905334 834.053528,120.260727 833.560913,119.181511 
	C833.473267,118.989487 833.913940,118.327248 834.223083,118.226158 
	C835.147644,117.923889 835.665527,118.481827 835.955200,119.671997 
	C835.991028,120.009529 836.000000,119.999939 836.004700,119.995270 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M825.784058,122.799736 
	C824.808899,122.756859 824.215698,122.361908 824.525452,121.705925 
	C824.680908,121.376839 825.650024,121.120071 826.055481,121.292007 
	C826.711121,121.570061 826.651428,122.230049 825.784058,122.799736 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M834.173889,113.833015 
	C833.268250,113.263458 833.219055,112.593452 833.891174,112.311035 
	C834.310913,112.134621 835.303162,112.386818 835.462830,112.721367 
	C835.786865,113.400566 835.171143,113.788879 834.173889,113.833015 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M815.944580,128.672440 
	C815.078491,128.944153 814.009766,129.268967 813.526917,128.190521 
	C813.438171,127.992279 813.869568,127.330818 814.175598,127.229340 
	C815.093018,126.925240 815.615906,127.499161 815.944580,128.672440 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M840.994019,127.994186 
	C841.117126,127.002602 841.360596,126.058998 842.623657,126.182999 
	C842.947449,126.214790 843.497620,126.734688 843.477173,126.993484 
	C843.391357,128.080414 842.423096,127.883835 841.354980,128.012634 
	C841.012512,128.012802 841.000061,128.000214 840.994019,127.994186 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M850.001221,126.000000 
	C849.900269,126.985466 849.683655,127.931290 848.413574,127.811111 
	C848.088135,127.780312 847.533691,127.266754 847.552246,127.008499 
	C847.630310,125.919098 848.595886,126.123337 849.658630,125.997940 
	C850.000000,125.996498 850.000000,126.000000 850.001221,126.000000 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M840.996094,132.003647 
	C841.898376,132.137833 842.914551,132.104126 843.220947,133.249878 
	C843.260803,133.398682 842.936279,133.797134 842.737244,133.831772 
	C841.806030,133.993942 841.317505,133.457886 841.046753,132.304413 
	C841.007019,131.992325 841.000000,132.000000 840.996094,132.003647 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M838.002441,127.997917 
	C837.368652,127.919632 836.657043,127.916351 836.503906,127.107109 
	C836.471802,126.937546 836.827454,126.694588 837.004395,126.485443 
	C837.310974,126.804146 837.617554,127.122856 837.959900,127.722946 
	C837.995667,128.004333 838.000000,128.000000 838.002441,127.997917 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M854.520386,139.428574 
	C854.287231,138.605743 854.581848,138.313263 855.215820,138.433289 
	C855.348145,138.458359 855.527893,138.645676 855.548340,138.779236 
	C855.647339,139.426224 855.325562,139.689041 854.520386,139.428574 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M820.286072,130.968323 
	C820.075500,130.341095 820.088379,129.613556 820.926636,129.499893 
	C821.108643,129.475220 821.343628,129.841827 821.554138,130.028229 
	C821.233276,130.337128 820.912476,130.646027 820.286072,130.968323 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M838.977478,117.022141 
	C838.443420,116.786118 837.919800,116.547218 837.443542,116.235764 
	C837.393066,116.202751 837.560608,115.572197 837.730347,115.512459 
	C838.469849,115.252167 838.794312,115.740791 839.012573,116.661209 
	C839.049194,116.950394 839.001526,116.998337 838.977478,117.022141 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M863.395142,135.448273 
	C862.580994,135.680389 862.287415,135.396317 862.413452,134.764526 
	C862.439636,134.633652 862.625732,134.458771 862.758911,134.438065 
	C863.397705,134.338730 863.665100,134.646652 863.395142,135.448273 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M869.965210,135.714798 
	C869.356750,135.911636 868.632324,135.903290 868.495544,135.076797 
	C868.466797,134.902496 868.830933,134.663193 869.013977,134.453857 
	C869.320251,134.778488 869.626526,135.103134 869.965210,135.714798 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M851.600220,136.507172 
	C852.063782,136.563568 852.345459,136.792038 852.627075,137.020508 
	C852.442566,137.197647 852.258057,137.374786 852.073547,137.551941 
	C851.855103,137.261047 851.636719,136.970154 851.600220,136.507172 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M820.009827,131.010223 
	C819.919312,131.661255 819.877991,132.376038 819.052185,132.487198 
	C818.873657,132.511246 818.642517,132.144852 818.435547,131.958313 
	C818.760681,131.656830 819.085815,131.355316 819.695679,131.017761 
	C819.980469,130.981689 820.000122,131.000504 820.009827,131.010223 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M816.357788,124.950958 
	C816.724365,124.652786 817.089050,124.611214 817.453674,124.569633 
	C817.450195,124.829697 817.446777,125.089767 817.443298,125.349838 
	C817.080811,125.302414 816.718262,125.254990 816.357788,124.950958 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M870.001221,135.999237 
	C870.629272,136.099686 871.352295,136.097992 871.484802,136.916199 
	C871.512756,137.089325 871.152100,137.325424 870.970581,137.532532 
	C870.670715,137.210541 870.370911,136.888519 870.034302,136.284164 
	C869.997559,136.001831 870.000000,136.000000 870.001221,135.999237 
z"/>
<path fill="#7B8D9C" opacity="1.000000" stroke="none" 
	d="
M838.998779,123.001060 
	C839.511780,123.244026 840.037659,123.466614 840.521423,123.758949 
	C840.567871,123.787003 840.409485,124.427185 840.247925,124.479424 
	C839.493591,124.723389 839.217407,124.199890 839.030396,123.288490 
	C839.002441,122.997604 839.000000,123.000000 838.998779,123.001060 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M804.695801,141.000153 
	C804.965881,141.930130 804.726501,142.736938 803.318726,142.973877 
	C802.986328,142.565216 802.981445,142.121185 802.979004,141.344360 
	C803.438538,141.006638 803.895691,141.001694 804.695801,141.000153 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M841.706848,159.015137 
	C841.951294,159.954773 841.786560,160.775452 840.255737,160.093323 
	C840.475281,159.680450 840.942017,159.358414 841.706848,159.015137 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M816.013916,128.990677 
	C816.440186,129.339157 817.268799,129.583542 816.396912,130.300110 
	C816.267395,130.034409 816.137878,129.768707 815.988770,129.266953 
	C815.969177,129.030914 815.997925,129.002762 816.013916,128.990677 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M749.003540,122.996460 
	C749.495544,122.974777 749.991638,122.893028 750.471252,122.949944 
	C752.193970,123.154350 752.263245,119.326775 754.199280,121.085800 
	C755.940857,122.668091 752.661499,124.121353 752.816833,124.294075 
	C754.994751,126.716072 753.002136,128.409058 752.005066,130.638214 
	C746.980713,129.567764 746.637207,128.738739 748.993225,123.374649 
	C748.992981,123.007027 749.000000,123.000000 749.003540,122.996460 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M760.629395,164.004944 
	C760.981628,165.242874 761.637817,166.139694 762.464233,166.980408 
	C763.403137,167.935501 764.441833,169.006973 762.993042,170.258347 
	C761.894592,171.207153 760.410706,172.421021 759.072815,171.663757 
	C757.155823,170.578766 759.468079,169.582764 759.632019,168.485367 
	C759.746582,167.718506 759.319092,167.294571 758.302490,167.035095 
	C757.936523,165.375717 758.159668,163.974228 760.629395,164.004944 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M777.355713,150.003571 
	C776.991394,148.678177 776.682739,147.771973 775.409119,146.824295 
	C773.364563,145.303055 773.560242,145.040085 776.789001,143.754791 
	C777.543396,144.527847 778.067566,145.079636 778.819031,145.807312 
	C779.816223,147.778137 781.762390,148.999588 781.781677,151.238876 
	C779.887024,151.939011 779.292297,149.478622 777.355713,150.003571 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M790.997925,144.362488 
	C792.103149,144.126083 793.889648,143.883408 794.224731,144.469925 
	C796.359131,148.205872 797.716125,144.956863 799.657349,144.034698 
	C799.980469,143.981003 800.001709,144.001450 800.011597,144.011276 
	C801.703674,146.429657 799.784729,147.839966 798.257080,149.719681 
	C797.992554,150.007309 798.000000,150.000000 798.003784,149.996216 
	C797.325195,150.573944 796.555847,150.738083 795.353149,150.241302 
	C795.009033,150.008392 795.002319,150.001587 795.002380,150.001526 
	C794.202332,148.959808 793.033752,148.454681 791.457764,147.440628 
	C791.004333,146.247620 791.006226,145.493622 790.997925,144.362488 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M781.627563,123.992088 
	C781.997681,124.742920 781.992493,125.489174 781.983765,126.607910 
	C779.492249,126.573799 778.402100,128.791931 776.729919,129.863785 
	C775.014954,130.963028 774.110168,130.979645 774.117554,128.057724 
	C774.452942,127.083237 774.701538,126.758507 775.167664,126.216919 
	C775.516113,125.849716 775.666260,125.714096 776.066223,125.409439 
	C776.830627,124.938240 777.369690,124.682625 778.449463,124.204758 
	C779.750732,123.996605 780.501404,123.992058 781.627563,123.992088 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M761.000244,118.363091 
	C763.271545,117.280807 764.191528,120.147903 766.627380,119.994553 
	C767.358826,122.031769 766.194336,122.945160 764.250305,123.710205 
	C763.835571,124.097260 763.645264,124.226730 763.193604,124.130692 
	C763.724915,121.645393 760.787903,120.775055 761.000244,118.363091 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M765.005371,152.644943 
	C763.802551,152.743195 761.509399,153.535721 761.698975,152.006805 
	C761.900696,150.380280 763.529663,148.678070 764.963135,147.554718 
	C765.781860,146.913101 766.847656,148.188156 766.466553,149.270706 
	C766.106873,150.292236 764.856812,150.947800 765.005371,152.644943 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M789.000977,151.999084 
	C788.133972,152.220444 787.221436,153.261658 786.396301,152.145157 
	C785.767456,151.294266 785.846252,150.143982 786.648132,149.469238 
	C787.749817,148.542191 789.064148,147.867905 790.644897,147.043488 
	C791.002441,147.001633 791.000000,147.000000 790.998779,146.999084 
	C792.543396,149.128662 791.290527,150.372543 789.289001,151.736404 
	C788.997559,152.001221 789.000000,152.000000 789.000977,151.999084 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M767.363281,153.008331 
	C768.830444,148.329041 770.641174,151.013687 772.380371,153.050217 
	C772.923340,153.686096 773.212708,154.585953 772.496582,155.269562 
	C771.660522,156.067566 770.936890,155.373871 770.482544,154.725327 
	C769.784851,153.729462 769.063110,152.917831 767.363281,153.008331 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M778.001221,164.001526 
	C777.855774,163.531586 777.810547,162.989944 777.542542,162.602371 
	C776.857117,161.611038 775.008667,160.609634 776.909668,159.505432 
	C778.004333,158.869614 779.529053,159.991425 780.289673,161.074417 
	C781.514404,162.818314 780.812683,163.849213 778.365601,163.995697 
	C777.997559,163.996948 778.000000,164.000000 778.001221,164.001526 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M769.666138,161.788956 
	C769.940918,163.542358 769.255920,164.585602 767.347656,164.966248 
	C766.132324,164.977356 765.241516,165.009415 764.239807,164.226440 
	C763.422974,163.312119 763.260193,162.539963 763.761719,161.335266 
	C763.995300,160.990356 764.000000,161.000000 763.995117,160.997711 
	C765.934875,159.652664 767.513062,161.702820 769.666138,161.788956 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M777.000183,150.000549 
	C777.245239,150.585007 777.365479,151.278168 777.761414,151.729645 
	C778.541504,152.619385 779.576721,153.579208 778.224731,154.520386 
	C776.853882,155.474731 776.250549,154.221741 775.865540,153.084808 
	C775.496948,151.996185 772.484253,150.499130 776.655029,150.005524 
	C777.000000,149.998947 777.000000,150.000000 777.000183,150.000549 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M785.657043,133.009125 
	C786.073730,133.915695 786.337158,134.689529 787.686829,134.948837 
	C787.757202,135.795959 787.509521,136.596436 787.122803,137.684814 
	C786.983826,137.972717 786.989014,137.990463 786.982300,137.985352 
	C786.307861,138.575043 785.540649,138.733139 784.350098,138.259628 
	C784.384705,136.979919 785.069153,136.105652 784.013550,134.882324 
	C782.541199,133.176010 784.178284,133.152527 785.657043,133.009125 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M775.629517,135.002228 
	C775.722229,137.686386 773.539185,138.409286 771.190369,140.034958 
	C771.187866,136.512421 772.698364,135.306885 775.629517,135.002228 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M769.686218,142.809906 
	C770.382568,144.395615 772.218140,146.295471 769.450378,146.735535 
	C767.613037,147.027664 766.665649,145.472061 767.706787,143.245911 
	C768.352661,142.625595 768.825439,142.477341 769.686218,142.809906 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M757.998047,114.398468 
	C758.749023,113.999016 759.500122,114.000008 760.626831,113.999435 
	C761.003784,115.065491 761.005188,116.133110 761.004517,117.601425 
	C760.251831,118.000633 759.501221,117.999146 758.375305,117.998520 
	C757.999451,116.932564 757.998840,115.865730 757.998047,114.398468 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M754.625000,131.004822 
	C755.001526,132.067154 755.003052,133.134918 755.003784,134.599609 
	C752.646301,135.187759 751.750061,134.017502 752.000916,131.388031 
	C752.000366,130.998779 752.000000,131.000000 751.999756,131.000610 
	C752.749695,131.004227 753.499817,131.007233 754.625000,131.004822 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M769.809448,161.733765 
	C768.168701,162.185013 766.440674,161.744690 764.370850,161.039536 
	C766.193787,157.178589 767.728821,161.429504 769.809448,161.733765 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M749.368164,119.989540 
	C748.963379,118.407578 749.145081,116.976967 751.631653,117.003448 
	C752.062805,118.610123 751.848022,120.013466 749.368164,119.989540 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M776.000244,135.000610 
	C776.103699,133.817368 775.756775,132.262924 777.604736,132.228058 
	C778.804565,132.205414 778.932983,133.301010 778.997253,134.630539 
	C778.251831,134.996964 777.501221,134.995758 776.375305,134.996674 
	C776.000000,134.998779 776.000000,135.000000 776.000244,135.000610 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M781.995239,137.628387 
	C780.374878,138.078751 778.992676,137.837769 779.012207,135.368759 
	C779.002441,134.998169 779.000000,135.000000 778.998779,135.000916 
	C780.583862,134.971405 782.045410,135.106812 781.995239,137.628387 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M754.998535,135.001740 
	C756.053772,135.113663 757.356750,134.712616 757.774231,136.215485 
	C757.966553,136.907822 757.674561,137.539474 756.970642,137.704025 
	C755.333801,138.086685 755.135193,136.927185 755.014160,135.365494 
	C755.002869,134.996521 755.000000,135.000000 754.998535,135.001740 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M728.634460,146.999283 
	C728.968384,148.140289 729.202759,149.409500 727.353271,149.950134 
	C726.833923,150.004150 726.658142,150.000793 726.217957,149.991730 
	C725.982849,148.418625 726.137451,146.948303 728.634460,146.999283 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M784.008484,138.010345 
	C784.755554,138.006226 785.495789,137.995087 786.605835,137.982101 
	C787.065979,139.595612 786.872498,141.000397 784.382324,140.987305 
	C783.425232,140.317764 783.264771,139.547562 783.768555,138.346619 
	C784.005432,138.004715 784.001587,138.003357 784.008484,138.010345 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M752.004639,114.380577 
	C752.754944,114.004707 753.504028,114.003296 754.627747,113.999985 
	C755.050598,115.600616 754.900024,117.053329 752.370728,116.998291 
	C751.999512,116.253181 752.001404,115.504105 752.004639,114.380577 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M784.187073,146.807861 
	C784.292847,145.551331 784.478394,144.510284 785.776611,144.728775 
	C786.428772,144.838547 786.871704,145.505295 786.640869,146.184158 
	C786.246948,147.342819 785.616150,148.247253 784.187073,146.807861 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M782.003662,129.002838 
	C782.171631,129.843430 783.308044,130.655975 782.172668,131.501999 
	C781.950073,131.667862 781.219482,131.446655 780.933838,131.179077 
	C779.998169,130.302643 780.178040,129.551575 781.691956,129.037537 
	C781.995117,128.994400 782.000000,129.000137 782.003662,129.002838 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M761.683777,132.026550 
	C761.906677,133.137405 761.662964,134.240128 760.347534,134.543839 
	C760.105103,134.599792 759.456238,134.071320 759.461182,133.821793 
	C759.484253,132.654587 760.421692,132.327072 761.683777,132.026550 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M745.572998,130.536713 
	C746.883972,130.352020 747.588806,130.834381 747.578918,131.999969 
	C747.577209,132.197845 747.196350,132.562134 746.992737,132.560593 
	C745.827393,132.551849 745.348022,131.849655 745.572998,130.536713 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M755.000000,131.000305 
	C755.156128,130.038345 755.380127,129.077454 756.640991,129.210281 
	C756.960754,129.243988 757.502930,129.772736 757.477234,130.026978 
	C757.367981,131.109634 756.406006,130.876297 755.343201,130.995331 
	C755.000000,130.999390 755.000000,131.000000 755.000000,131.000305 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M763.651123,161.047363 
	C763.995728,161.742844 763.996155,162.495316 763.998291,163.623901 
	C763.561462,163.998505 763.122986,163.997009 762.356079,163.997437 
	C762.021851,162.843384 761.794739,161.589630 763.651123,161.047363 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M764.056091,164.341705 
	C764.862793,164.162781 765.725586,164.325592 766.799011,164.747772 
	C767.009644,165.007156 766.994690,165.496964 766.987000,165.741699 
	C765.843201,165.949066 764.585632,166.178879 764.056091,164.341705 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M783.671082,138.000259 
	C784.006836,138.753250 784.008240,139.501801 784.010864,140.624817 
	C783.564819,140.999374 783.117554,140.999451 782.335144,140.999451 
	C781.998291,140.249802 781.996521,139.500229 781.996826,138.376007 
	C781.998901,138.001373 782.000000,138.000000 782.000549,137.999313 
	C782.446289,137.997696 782.891479,137.996750 783.671082,138.000259 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M754.942871,140.666107 
	C754.247314,141.000763 753.497009,140.998459 752.375366,140.999908 
	C752.489685,138.744843 753.410522,138.346466 754.942871,140.666107 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M755.001221,140.998596 
	C755.964905,141.136429 756.919067,141.352081 756.799805,142.607742 
	C756.769470,142.926636 756.250183,143.471298 755.995605,143.449234 
	C754.925781,143.356583 755.113525,142.405609 754.996521,141.343475 
	C754.997559,141.003052 755.000000,141.000000 755.001221,140.998596 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M758.000000,118.000305 
	C757.879578,118.980042 757.652710,119.925163 756.389465,119.800323 
	C756.067566,119.768509 755.520081,119.248093 755.541809,118.991730 
	C755.633667,117.911110 756.590271,118.108734 757.657837,117.997154 
	C758.000000,117.999390 758.000000,118.000000 758.000000,118.000305 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M762.624023,123.982002 
	C763.114075,123.921417 763.295959,123.937653 763.751831,123.960846 
	C763.967224,125.462852 763.091736,126.018890 761.357239,125.997894 
	C761.099426,125.127304 761.323547,124.335754 762.624023,123.982002 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M760.995117,125.995056 
	C760.932983,126.891556 761.293518,127.959900 760.216187,128.476517 
	C760.017639,128.571716 759.329590,128.150528 759.226013,127.845749 
	C758.905701,126.904274 759.514404,126.406494 760.676025,126.065521 
	C761.009705,126.008858 761.000000,125.999870 760.995117,125.995056 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M765.453186,127.976402 
	C766.074036,127.035751 766.740784,126.847061 767.374878,127.605255 
	C767.511230,127.768333 767.508545,128.248383 767.369690,128.406616 
	C766.713135,129.154648 766.054688,128.927826 765.453186,127.976402 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M771.067261,126.353928 
	C771.756348,126.002327 772.499695,125.992607 773.823669,126.199455 
	C774.532166,126.802505 774.543274,127.190506 774.208435,127.791794 
	C773.997559,128.003326 774.000000,128.000000 774.001221,127.998383 
	C772.865601,127.954094 771.599976,128.196426 771.067261,126.353928 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M782.000000,141.000305 
	C781.737305,141.491760 781.474670,141.982925 781.097473,142.732224 
	C780.470642,142.686050 779.526672,142.386536 779.523254,142.076523 
	C779.510437,140.928741 780.578125,141.136932 781.668274,141.002930 
	C782.000000,140.999390 782.000000,141.000000 782.000000,141.000305 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M751.998230,140.998032 
	C751.899109,141.631134 751.909912,142.364120 751.082092,142.506683 
	C750.908264,142.536636 750.666809,142.174393 750.456543,141.992859 
	C750.782288,141.686661 751.107971,141.380463 751.718872,141.038956 
	C752.003967,141.003647 752.000000,141.000000 751.998230,140.998032 
z"/>
<path fill="#788FA3" opacity="1.000000" stroke="none" 
	d="
M762.007935,131.998703 
	C762.253357,131.482193 762.471680,130.956604 762.758484,130.471512 
	C762.784668,130.427124 763.425110,130.582870 763.479614,130.746063 
	C763.732788,131.504486 763.209229,131.775681 762.293091,131.954315 
	C762.002808,131.983582 761.999390,132.000641 762.007935,131.998703 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M769.963745,142.738144 
	C769.544373,143.039612 769.091248,143.032867 768.297302,143.022186 
	C768.203125,142.487671 768.317383,141.692001 768.726868,141.487579 
	C769.368164,141.167435 769.770996,141.785355 769.963745,142.738144 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M750.475586,135.601364 
	C750.418091,136.064346 750.186035,136.346756 749.953918,136.629181 
	C749.775879,136.444168 749.597778,136.259171 749.419739,136.074158 
	C749.713501,135.856354 750.007263,135.638565 750.475586,135.601364 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M778.977051,145.685669 
	C778.094666,145.950699 777.285706,145.725235 777.033569,144.323990 
	C777.920654,144.058060 778.721741,144.291565 778.977051,145.685669 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M746.407959,137.969543 
	C746.813232,137.227890 747.221375,137.220947 747.583313,137.747147 
	C747.659058,137.857315 747.656189,138.114365 747.577637,138.222092 
	C747.201843,138.737244 746.793335,138.719955 746.407959,137.969543 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M748.609985,145.042267 
	C748.202698,145.792587 747.790344,145.798218 747.424561,145.267838 
	C747.347900,145.156738 747.350586,144.897308 747.429749,144.788391 
	C747.807678,144.268875 748.219421,144.280792 748.609985,145.042267 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M792.268860,136.965439 
	C791.952698,136.551010 791.966553,136.105240 791.985413,135.324890 
	C792.438049,134.990555 792.885742,134.990829 793.669128,134.993835 
	C793.925049,135.924561 793.678406,136.731491 792.268860,136.965439 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M789.704041,141.042786 
	C790.012817,141.455460 790.023743,141.907867 790.030518,142.700623 
	C788.908508,142.676620 787.192932,142.501572 789.704041,141.042786 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M765.003662,152.995758 
	C765.450134,152.993896 765.892883,152.996262 766.667847,152.999008 
	C767.000000,152.999390 767.000000,153.000000 767.000000,153.000305 
	C766.767639,153.517487 766.666809,154.287811 766.272400,154.492645 
	C765.659729,154.810715 765.250793,154.221176 765.033630,153.305756 
	C764.992676,153.008499 765.000000,153.000000 765.003662,152.995758 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M780.994629,142.993057 
	C781.417847,143.112122 781.846252,143.238113 782.274658,143.364105 
	C781.950439,144.069626 781.589172,143.673157 781.107422,143.194763 
	C780.982910,142.990372 780.999817,143.000000 780.994629,142.993057 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M757.740906,166.981659 
	C757.719177,167.096207 757.448975,167.210312 757.087158,167.160522 
	C756.995544,166.996628 757.492371,166.981201 757.740906,166.981659 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M809.281738,82.964478 
	C809.085693,82.362541 809.097412,81.647118 809.907898,81.511864 
	C810.081055,81.482956 810.318604,81.839684 810.526489,82.018753 
	C810.209839,82.325142 809.893188,82.631538 809.281738,82.964478 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M809.007874,83.008026 
	C808.888184,83.433746 808.761658,83.852661 808.635193,84.271584 
	C807.951965,83.956764 808.325623,83.597145 808.789185,83.116554 
	C808.986877,82.991013 809.001099,83.001228 809.007874,83.008026 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M773.993896,125.994041 
	C774.025085,123.966957 774.229492,121.917007 776.482483,121.182755 
	C778.053040,120.670952 778.944092,121.581596 778.987915,123.621506 
	C779.000000,124.001152 779.000000,124.000000 779.000610,123.999390 
	C778.355042,124.855988 777.237976,124.941284 776.230713,125.771599 
	C776.016357,125.985077 776.000000,125.999809 775.992065,126.007385 
	C775.594177,126.360153 775.137634,126.493431 774.317749,126.227348 
	C774.012207,126.011642 774.000793,126.000755 773.993896,125.994041 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M779.007690,117.366196 
	C779.748291,116.998924 780.500061,117.001579 781.627747,117.000229 
	C781.883545,118.024216 782.300049,119.386749 780.862549,119.729599 
	C779.298401,120.102654 779.121643,118.881950 779.007690,117.366196 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M784.626099,121.006081 
	C784.996948,121.750092 784.996399,122.498352 784.995483,123.620613 
	C784.245667,123.995598 783.496277,123.996574 782.371948,124.000443 
	C781.955505,122.406715 782.118469,120.964348 784.626099,121.006081 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M869.394165,239.188583 
	C872.184753,239.954422 873.688477,238.137909 875.750061,237.241043 
	C877.589050,235.049835 879.727905,233.978821 882.017212,233.173340 
	C883.650146,232.598724 885.193909,232.464111 886.127686,234.914413 
	C886.677734,252.734100 886.303650,270.120697 886.448853,287.966431 
	C886.611267,291.715576 886.776855,295.003998 886.042969,298.672455 
	C884.580261,301.332825 882.752441,300.161438 881.125427,299.683655 
	C877.508911,298.621613 873.893372,297.654907 869.669800,297.947388 
	C868.716003,298.014557 868.172852,297.957825 867.247803,297.683044 
	C866.380859,297.243500 865.968262,296.877716 865.413879,296.079926 
	C863.719360,291.483093 864.809265,287.125458 864.603027,282.423584 
	C864.584656,281.214417 864.586243,280.408997 864.587524,279.203552 
	C864.436218,273.537109 865.001953,268.255768 864.065369,262.671265 
	C863.565918,261.944000 863.266968,261.538727 862.792480,260.801331 
	C862.420837,260.017334 862.299805,259.541168 862.256897,258.685181 
	C862.327576,257.608368 862.348328,256.896149 862.003906,255.838058 
	C861.194031,250.085403 861.382568,244.791748 863.838257,239.411835 
	C864.469727,238.771729 864.902161,238.531433 865.739014,238.381805 
	C867.118469,238.381470 867.703735,239.638901 869.394165,239.188583 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M884.725952,184.384369 
	C884.957520,174.768753 885.175171,165.529129 886.256287,156.326096 
	C886.364136,155.407990 886.749512,154.783813 887.732117,154.128479 
	C891.728882,155.551987 890.718567,159.129028 891.290833,161.959030 
	C891.738281,164.171265 891.025024,166.604828 892.747314,169.030304 
	C894.031067,173.645432 893.527039,177.928497 893.501099,182.651749 
	C893.447937,196.706131 892.894348,210.296738 893.582214,223.889847 
	C893.713013,226.474411 894.020203,229.281540 891.309814,231.542725 
	C889.566162,232.028397 888.370422,231.639954 886.785034,230.915070 
	C884.974304,229.579056 884.257080,228.008209 884.244629,226.339340 
	C884.143494,212.777832 882.863342,199.220459 884.059387,185.654953 
	C884.087158,185.340012 884.310669,185.045517 884.725952,184.384369 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M884.680237,184.040741 
	C885.001709,192.553696 884.476501,201.131561 885.192566,209.604523 
	C885.753906,216.246368 884.923096,222.975342 886.776123,229.771576 
	C887.766602,230.854919 888.069580,231.810577 887.703369,233.275787 
	C887.265564,234.116104 886.835449,234.353973 885.927429,234.177338 
	C881.805908,232.508972 879.859863,236.543152 876.348022,236.949219 
	C872.762939,233.217102 873.956543,229.856262 876.931641,226.289734 
	C877.487122,221.822281 882.426514,220.144516 882.728516,215.517365 
	C882.523254,214.848328 882.125000,214.476837 881.434937,214.074326 
	C879.973999,212.433945 881.781494,211.250015 881.831665,209.511139 
	C881.981567,208.925583 882.119568,208.647202 882.161682,208.359665 
	C882.171814,208.290161 881.938721,208.458725 881.756714,208.790741 
	C881.388611,209.462006 880.710449,209.846146 879.815918,210.469910 
	C878.940369,211.005173 878.314209,211.243652 877.321289,211.141052 
	C873.876587,210.203262 877.809143,209.202423 876.997803,208.036423 
	C878.949463,205.295120 882.001343,203.587051 882.009277,199.611328 
	C882.053040,198.551651 883.128601,198.092285 882.441650,196.945923 
	C881.781250,195.417892 881.922424,194.145691 882.153198,192.551361 
	C881.985107,191.935577 881.880188,191.638763 881.579285,190.912247 
	C881.383362,190.482559 881.617310,190.108963 881.731262,189.919571 
	C881.985413,189.435394 882.084412,189.127274 882.183960,188.524536 
	C882.318054,187.403168 882.553101,186.592453 882.844849,185.450104 
	C883.426331,184.773163 883.897400,184.416809 884.680237,184.040741 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M892.262268,168.565430 
	C889.695923,168.738983 889.933105,167.030960 890.002319,165.628082 
	C890.189392,161.832458 889.343750,158.191666 888.294312,154.258179 
	C888.018677,153.984161 888.001099,153.499023 887.986572,153.256729 
	C887.983521,152.564087 887.979553,152.113846 887.934570,151.327057 
	C887.913757,149.293533 887.920715,147.596664 887.917358,145.475861 
	C887.435486,144.319946 887.517639,143.504333 887.694458,142.315887 
	C887.799561,141.526749 887.761780,141.117737 887.703491,140.401230 
	C887.662659,139.893768 887.642273,139.693787 887.705688,139.204178 
	C887.004150,136.568741 886.995544,134.144531 887.091309,131.290283 
	C888.099121,130.855835 889.077942,130.843826 890.411011,130.728455 
	C891.805603,131.337616 892.275879,132.401367 892.395142,133.584671 
	C893.460571,144.162964 894.149353,154.756866 893.506226,165.394623 
	C893.445740,166.394775 893.145691,167.352310 892.262268,168.565430 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M871.765808,146.172699 
	C876.028748,142.528854 880.023926,139.162582 884.271545,135.583527 
	C884.698547,139.871002 879.131165,145.800018 871.254578,150.100113 
	C870.280151,148.809402 871.049194,147.639236 871.765808,146.172699 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M875.711060,174.874207 
	C878.043701,173.110397 879.703064,170.874680 882.586609,170.743103 
	C883.039490,173.961121 879.340332,179.583740 876.670166,179.289917 
	C873.843262,178.978821 875.198059,176.761444 875.711060,174.874207 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M883.039429,157.079895 
	C881.257690,160.676132 878.494629,162.878677 875.505493,165.178162 
	C875.112183,161.061829 879.848999,153.933258 882.936340,154.178711 
	C885.099121,154.350677 883.121948,155.821732 883.039429,157.079895 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M882.622559,185.212296 
	C882.924011,186.421555 882.892761,187.713562 882.873901,189.287018 
	C882.799133,190.016861 882.581055,190.383865 881.885010,190.587784 
	C881.559448,190.519333 881.480957,190.455490 881.432129,190.469025 
	C881.126404,190.686249 880.868896,190.889267 880.612610,191.093811 
	C879.018799,192.365921 877.074036,194.781952 875.406433,192.191330 
	C873.952026,189.931961 876.747986,188.569168 878.418701,187.383133 
	C879.605286,186.540833 880.992371,185.980972 882.622559,185.212296 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M882.618713,215.339096 
	C884.968506,220.787643 880.388489,222.637299 877.122192,225.618561 
	C874.449219,223.359833 875.704224,221.157761 877.769287,219.182053 
	C879.180542,217.831848 880.793274,216.692215 882.618713,215.339096 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M881.918457,192.530457 
	C884.146545,193.159500 882.608582,194.861023 882.864624,196.533966 
	C882.732300,197.738144 882.171692,198.370911 881.482544,199.529907 
	C878.364380,198.059555 877.769226,202.608292 875.184204,201.763077 
	C874.959961,199.665451 875.965088,198.453415 877.990356,197.450287 
	C878.127747,196.927948 878.121765,196.729309 877.819336,196.498840 
	C876.903381,196.635971 876.042725,197.142166 875.712830,196.906219 
	C874.939392,196.352982 875.797546,195.590927 876.173096,195.499847 
	C878.235474,194.999786 880.297485,194.582245 881.918457,192.530457 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M882.681946,198.972443 
	C883.845337,203.629028 881.377014,206.057083 877.413940,207.768860 
	C875.180115,207.573410 874.172180,206.979996 875.952942,205.254303 
	C877.589905,203.667984 879.308777,202.166229 881.020935,200.281525 
	C881.050293,199.935822 880.979553,199.982437 880.998047,200.020538 
	C881.389160,199.521011 881.739014,198.958649 882.681946,198.972443 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M882.437622,208.946045 
	C882.860657,210.637573 882.806030,212.228546 881.299438,213.739746 
	C880.736267,214.316772 880.358093,214.654129 879.917236,214.851974 
	C878.505249,215.485794 877.032288,217.698364 875.726990,216.430984 
	C874.206238,214.954498 875.716064,213.089310 877.006104,211.350403 
	C877.505432,210.728165 877.991455,210.458313 878.749695,210.112717 
	C880.213928,210.093658 881.089233,209.298843 882.437622,208.946045 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M868.017456,214.293518 
	C868.721313,214.115234 869.040222,214.113144 869.598877,214.044388 
	C869.901489,222.052444 869.963989,230.066269 869.984497,238.545654 
	C869.942566,239.011230 869.986694,238.956680 870.019714,238.968475 
	C869.440125,239.154160 868.928589,238.995377 868.293762,238.134613 
	C867.742615,236.922867 867.675476,236.038437 867.511902,234.718231 
	C867.592102,227.693573 867.840149,221.114105 868.017456,214.293518 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M877.166626,185.058487 
	C874.199463,186.243378 874.186768,184.465347 875.348206,183.344635 
	C877.077698,181.675812 879.377625,180.566223 881.521179,179.373947 
	C882.390259,178.890533 883.166992,179.399506 883.132690,180.475952 
	C883.100891,181.475479 884.045044,182.808701 882.192688,183.299301 
	C880.602234,183.720505 879.062744,184.334244 877.166626,185.058487 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M883.090759,163.448792 
	C883.324524,169.200851 878.166321,168.715973 875.186707,170.757767 
	C876.228699,166.696289 879.578613,164.939896 883.090759,163.448792 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M887.700073,151.148636 
	C888.634033,151.395630 888.969849,151.917038 888.193726,152.858627 
	C887.296143,152.590027 887.012390,152.055649 887.700073,151.148636 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M887.643799,142.161545 
	C887.891846,142.714920 887.946167,143.494110 887.953857,144.662628 
	C887.050110,144.284607 886.939514,143.389252 887.643799,142.161545 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M887.661377,139.037125 
	C887.805908,139.114044 887.822388,139.313538 887.760925,139.803391 
	C887.582397,139.888123 887.457581,139.689667 887.393616,139.473267 
	C887.368958,139.389786 887.482666,139.265427 887.661377,139.037125 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M868.999268,118.999229 
	C869.144531,118.029709 869.370178,117.072594 870.631897,117.198158 
	C870.952454,117.230072 871.498718,117.754951 871.474731,118.009193 
	C871.372314,119.092278 870.410339,118.873886 869.344727,118.996201 
	C869.001831,119.001541 869.000000,119.000000 868.999268,118.999229 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M895.628540,96.011040 
	C896.575623,98.043892 896.376770,99.486588 893.338440,99.003830 
	C892.996887,97.438103 893.141907,95.980743 895.628540,96.011040 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M883.999634,93.374893 
	C884.749939,92.999916 885.500000,92.999962 886.625122,92.999908 
	C887.000244,93.749878 887.000183,94.499939 887.000061,95.625000 
	C886.250000,96.000145 885.499939,96.000282 884.374878,96.000305 
	C883.999573,95.250099 883.999451,94.500015 883.999634,93.374893 
z"/>
<path fill="#869DAD" opacity="1.000000" stroke="none" 
	d="
M887.371826,99.006554 
	C886.998718,98.253052 887.001770,97.501991 887.002441,96.375465 
	C888.619263,95.929482 890.033569,96.130623 889.999390,98.631561 
	C889.252563,99.005844 888.500244,99.007416 887.371826,99.006554 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M851.836914,670.372192 
	C855.299438,663.288696 856.083130,655.963684 856.954163,648.646423 
	C857.028503,648.022156 856.044556,644.684387 858.908081,647.750610 
	C859.879517,651.724121 860.641724,655.449402 861.359680,659.183228 
	C862.281921,663.979492 861.376160,668.489258 858.617188,672.452209 
	C857.075745,674.666199 854.536682,675.462524 851.961365,674.440979 
	C849.722290,673.552795 851.289062,672.018066 851.836914,670.372192 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M861.054443,647.350586 
	C860.551758,642.813354 857.821960,639.099731 858.329651,633.903076 
	C861.267395,638.049927 861.088318,642.597107 863.232483,646.614136 
	C862.988342,649.655273 864.841309,652.244141 863.433594,655.438660 
	C862.607239,652.576416 861.903625,650.139282 861.054443,647.350586 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M848.933838,701.180908 
	C849.268616,706.028870 850.838013,710.363892 849.508423,714.890747 
	C849.240479,705.448914 845.174194,696.486755 846.467224,686.828613 
	C846.921631,691.538452 847.583069,696.201477 848.933838,701.180908 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M841.072510,683.499084 
	C841.604675,682.818115 842.071228,682.501099 842.813110,682.121399 
	C843.793518,684.299194 842.210632,685.968689 841.369507,688.172852 
	C841.049255,688.174255 840.992859,687.891907 840.784607,687.203857 
	C840.757507,685.819824 840.882202,684.841431 841.072510,683.499084 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M848.075195,719.614746 
	C848.156067,719.111633 848.350769,718.626648 848.399353,718.640808 
	C849.166687,718.865479 848.950195,719.424988 848.763489,719.940552 
	C848.726685,720.042053 848.536499,720.171509 848.448792,720.151184 
	C848.324097,720.122375 848.228821,719.966675 848.075195,719.614746 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M876.505737,627.103516 
	C883.021240,637.138184 889.340393,647.006470 895.269653,657.103760 
	C896.601929,659.372681 899.888000,661.463745 897.371704,664.981201 
	C894.823914,661.104126 893.553955,655.607849 890.224670,653.693787 
	C883.820984,650.012695 882.347290,643.295288 878.049194,638.487732 
	C877.334167,637.688049 877.010010,636.833862 876.920532,635.453003 
	C876.640381,633.795227 876.793213,632.342163 875.196777,631.260010 
	C874.922119,630.871399 874.905029,630.704956 874.895142,630.287598 
	C874.794800,628.808899 875.026978,627.723694 876.505737,627.103516 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M888.793152,665.653381 
	C881.217834,660.597839 876.904419,653.293152 874.394409,644.316040 
	C874.523376,643.838806 874.791992,643.748413 875.429077,643.870239 
	C880.235229,650.747375 884.672974,657.412354 889.175110,664.419678 
	C889.168823,664.977234 889.098145,665.192322 888.793152,665.653381 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M876.795166,626.850220 
	C876.370178,628.028809 875.897278,628.870544 875.163452,629.874512 
	C871.920898,627.662720 871.793213,624.081543 870.989258,620.389526 
	C872.468018,619.409058 873.002808,620.483154 873.811401,621.725464 
	C874.036377,621.979187 873.999878,622.000000 874.013916,621.983887 
	C874.529663,622.536194 875.067444,623.069824 875.820007,623.789795 
	C876.032410,623.978577 876.002502,623.984497 876.014160,623.969849 
	C876.266357,624.807922 876.506836,625.660645 876.795166,626.850220 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M874.142944,621.634277 
	C873.208130,621.399353 872.379944,620.819519 871.270386,620.116211 
	C869.465515,619.113403 868.372131,618.088501 870.018799,616.063232 
	C871.979614,617.434082 873.772644,618.882812 874.142944,621.634277 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M874.952026,631.369751 
	C877.215576,631.190918 878.374512,632.075928 877.044189,634.789124 
	C876.247192,633.959839 875.606018,632.830811 874.952026,631.369751 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M875.840698,643.760620 
	C875.537842,644.082642 875.278198,644.082764 874.636719,644.006042 
	C874.044434,643.122986 873.834106,642.316833 873.811279,641.255981 
	C875.263367,641.321777 875.396179,642.517578 875.840698,643.760620 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M874.003174,640.997314 
	C873.019104,641.012878 873.161804,640.282715 873.195374,639.691589 
	C873.206970,639.486145 873.466064,639.294739 873.612183,639.096985 
	C873.726807,639.551392 873.841309,640.005737 873.977295,640.730713 
	C873.998779,641.001282 874.000000,641.000000 874.003174,640.997314 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M889.047119,665.033081 
	C890.091003,665.413513 890.585571,666.020508 888.798950,666.136414 
	C888.657471,665.700928 888.756104,665.502563 889.047119,665.033081 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M890.289612,667.722168 
	C890.297119,667.404541 890.525696,667.330383 890.754211,667.256287 
	C890.672974,667.492737 890.591797,667.729187 890.289612,667.722168 
z"/>
<path fill="#DAD8BE" opacity="1.000000" stroke="none" 
	d="
M866.452637,648.438965 
	C866.516357,648.395996 866.388916,648.481873 866.452637,648.438965 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M959.988647,618.425293 
	C960.450500,617.844543 960.924927,617.518677 961.662354,617.077148 
	C961.925354,616.961487 962.374878,616.997131 962.599976,616.996338 
	C962.573120,618.324890 962.156433,619.524780 960.277771,619.760742 
	C959.971741,619.355896 959.986511,619.018005 959.988647,618.425293 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M973.824463,627.622559 
	C973.427917,627.209656 973.301514,626.814758 973.261902,626.411377 
	C973.257446,626.366394 973.831116,626.131287 973.991699,626.227112 
	C974.617249,626.601013 974.740540,627.107483 973.824463,627.622559 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M970.110779,627.160156 
	C969.495911,626.730286 968.547302,626.320801 969.522034,625.416565 
	C969.797363,625.731689 970.072693,626.046875 970.432007,626.674744 
	C970.516052,626.987427 970.226501,627.064941 970.110779,627.160156 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M783.636108,587.594666 
	C783.959045,594.629395 784.392273,601.327148 784.853210,608.023132 
	C785.032898,610.633972 785.305420,613.254272 781.872681,614.540161 
	C776.525391,616.115173 771.325073,617.431396 766.043091,619.085327 
	C765.831238,619.979675 765.612488,620.499084 764.882080,620.942749 
	C764.457947,620.903931 764.494202,620.970032 764.515808,620.939148 
	C763.874329,621.043274 763.233582,621.021973 762.390015,620.428467 
	C761.557922,620.252075 760.980591,620.284851 760.189575,620.512329 
	C759.873169,620.954102 759.770508,621.201050 759.334351,621.224854 
	C756.409668,621.782227 753.818542,622.562744 751.145752,623.701599 
	C751.177612,624.216492 751.291016,624.372986 751.329590,624.807129 
	C751.096619,625.189453 750.938477,625.294250 750.503784,625.450562 
	C749.682678,625.506775 749.136902,625.468262 748.333496,625.610229 
	C747.898315,625.717468 747.723999,625.761414 747.284851,625.859680 
	C746.842041,625.940796 746.664062,625.967651 746.219666,626.027588 
	C745.599670,626.107788 745.250549,626.177124 744.659546,626.379883 
	C744.109009,626.703491 743.814026,626.928528 743.310059,627.362549 
	C742.625427,627.942139 742.136719,628.297607 741.467529,628.929443 
	C739.641724,630.685974 738.628235,632.637756 737.174805,634.659302 
	C736.380798,635.114258 735.863892,635.383118 735.176880,635.888550 
	C734.320862,636.607117 733.575500,636.775391 732.418091,636.341064 
	C725.807556,635.124329 719.534790,634.117737 712.825317,633.033691 
	C712.231995,632.218445 712.413513,631.383728 711.826660,630.611633 
	C711.035645,631.562561 711.937927,633.053406 710.203918,633.642700 
	C708.008606,633.354736 706.118774,633.636841 704.093994,632.947693 
	C702.475403,628.770935 704.081970,625.368042 704.854919,621.681274 
	C706.609436,613.312378 708.244141,604.710022 708.587219,596.296509 
	C709.096008,583.821106 716.434143,576.513977 724.559082,569.111145 
	C727.510620,566.421997 730.351074,563.610779 733.238647,560.851501 
	C734.988403,559.179382 734.245728,562.701843 735.823242,561.942810 
	C738.107788,562.114258 739.941040,563.877075 742.437866,562.614990 
	C743.045044,562.745544 743.570801,562.969849 743.574646,562.961121 
	C744.424805,561.057007 743.086792,557.834412 746.367493,557.432495 
	C750.591125,556.915039 754.760620,555.077820 759.081055,556.417236 
	C759.814819,556.644775 760.216736,557.942688 761.098633,558.980835 
	C762.663330,560.977173 762.068115,563.059570 762.440063,564.971375 
	C762.989319,567.794739 764.295044,570.178040 767.540161,569.931580 
	C770.548950,569.703064 772.080322,567.534912 772.484741,564.599609 
	C772.710876,562.958069 772.040527,561.320801 772.637573,559.377747 
	C774.332275,557.960876 774.789429,556.322998 775.113708,554.211670 
	C775.969055,553.226746 776.832214,553.191406 778.124023,553.693604 
	C782.679871,561.779541 784.005676,570.314514 784.283081,579.045837 
	C784.339294,580.813782 783.901794,582.621643 784.323853,584.844055 
	C784.218567,585.927307 783.988037,586.592163 783.636108,587.594666 
z"/>
<path fill="#EFE5D7" opacity="1.000000" stroke="none" 
	d="
M853.681580,532.684326 
	C854.694458,532.943237 855.388550,533.027649 856.434204,533.109863 
	C857.205139,533.233826 857.609924,533.396362 858.181885,533.871948 
	C858.383057,534.371155 858.402893,534.592896 858.325684,535.136047 
	C857.566467,536.654968 856.524109,537.536682 855.420898,538.817505 
	C853.558044,540.719055 851.790161,542.251526 850.357605,544.064026 
	C847.817688,547.277527 845.259033,547.328186 842.242432,544.197937 
	C835.799683,541.648315 829.584290,541.108826 822.778809,544.451965 
	C823.760071,542.461243 824.369202,541.225342 824.633606,539.714050 
	C824.151917,539.249634 824.014954,539.060669 824.155518,539.085144 
	C827.229065,540.936279 827.793030,537.472839 829.929810,536.720215 
	C833.984070,531.975098 838.792480,530.942688 844.650757,532.469666 
	C847.049927,532.802612 849.093628,532.919312 851.567993,532.947266 
	C852.411316,532.577454 852.868103,532.469421 853.681580,532.684326 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M819.700745,559.307983 
	C820.762817,558.010803 821.527466,557.021606 822.551636,555.854736 
	C823.056213,555.619507 823.301331,555.562012 823.871887,555.692871 
	C824.351501,560.795471 822.598389,565.615417 823.476868,570.566223 
	C824.242188,574.879211 825.942993,578.491211 830.550354,579.858948 
	C834.537598,581.042542 838.067017,579.593079 841.254272,575.515625 
	C841.662048,574.993958 842.042175,574.450684 842.725952,573.702759 
	C844.200806,572.645142 844.789856,571.526001 844.619202,569.687805 
	C844.758545,566.807495 843.775513,564.424011 843.677917,561.541626 
	C843.749634,560.093994 843.988708,559.091187 845.007812,558.030090 
	C846.287354,557.681458 846.605408,558.461853 847.291016,559.330078 
	C847.740112,560.060608 847.920105,560.511169 848.116943,561.329712 
	C848.186096,562.827454 848.218445,563.972351 848.763489,565.361633 
	C848.728088,566.899048 848.712463,568.097107 848.779358,569.649048 
	C849.336304,570.449219 849.484436,570.985779 848.865112,571.683105 
	C846.667908,576.253296 845.550720,581.121094 841.073608,584.425903 
	C840.206543,586.118835 839.123474,586.851013 837.184692,586.520752 
	C835.229248,586.454651 833.594177,586.536499 831.547791,586.611267 
	C830.171204,586.892151 829.224243,587.020935 828.261169,585.939636 
	C825.434021,583.611694 822.804688,581.553345 821.081665,578.107422 
	C820.899841,578.934814 820.429504,579.528625 819.595276,578.579712 
	C818.034180,576.803833 817.807251,574.485718 817.573364,571.776428 
	C817.447205,568.995239 818.146606,566.712463 818.011719,563.947266 
	C818.017517,562.052551 818.166626,560.640930 819.700745,559.307983 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M890.302612,582.153564 
	C892.059814,584.263000 891.754456,586.060913 889.943787,588.078247 
	C888.778381,589.230103 887.673279,589.923279 886.732544,591.285767 
	C885.361145,592.942627 884.627930,594.802551 882.277832,595.088379 
	C880.817261,592.577698 878.173950,596.179688 877.021790,593.100342 
	C876.928223,592.336731 876.870850,592.159241 876.662720,591.734558 
	C876.505249,591.287048 876.498535,591.086609 876.447388,590.579834 
	C875.515564,588.043701 873.669250,586.125183 874.276123,583.095520 
	C877.110535,576.778259 881.671387,573.029846 888.405884,571.728394 
	C890.063904,572.557800 889.982849,573.795349 890.016724,575.348633 
	C889.142395,577.821716 886.950623,578.379028 885.354675,579.639282 
	C884.833862,580.050537 885.327637,579.354980 884.961731,579.864868 
	C884.641113,580.311523 885.362244,580.104736 885.857666,580.408264 
	C887.328064,581.312378 888.631226,581.723389 890.302612,582.153564 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M802.815674,579.683960 
	C803.010132,581.377502 803.767639,582.342163 805.033875,583.044678 
	C806.319824,583.758057 806.701111,584.448669 805.977539,586.184204 
	C803.952271,591.042053 804.526123,591.445862 809.610168,592.231873 
	C812.257141,592.641113 814.692383,594.379150 817.787720,593.758179 
	C818.140747,594.172852 818.276611,594.340942 818.319336,594.819458 
	C817.926697,595.437073 817.591248,595.696289 816.934082,596.036133 
	C816.106262,596.427307 815.586487,596.728333 814.933655,597.355225 
	C814.370667,598.050903 814.028198,598.539368 813.589172,599.323181 
	C812.947815,600.444153 812.471863,601.303345 813.297241,602.567871 
	C813.507751,603.050598 813.574280,603.253723 813.681580,603.778931 
	C813.583496,605.633179 813.502991,607.168823 813.339722,609.032898 
	C812.968201,609.748718 812.637512,610.068054 811.909668,610.421143 
	C808.234924,609.664551 807.005920,606.826782 805.753479,604.134277 
	C802.796631,597.778076 800.676575,591.142212 799.235962,584.104492 
	C794.458374,582.506470 797.130005,579.415527 797.465210,576.467651 
	C797.791931,576.080139 797.985413,576.101807 798.433350,576.266907 
	C798.953552,577.415710 799.130554,578.480957 800.717041,578.928711 
	C801.675476,578.957214 802.180176,579.145630 802.815674,579.683960 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M799.021484,584.426270 
	C798.990845,583.849792 799.018799,583.654724 799.131287,583.555786 
	C799.331665,583.379578 799.583191,583.261414 799.813293,583.119019 
	C800.557434,585.643860 801.263000,588.180908 802.053101,590.691284 
	C804.235352,597.624634 806.297424,604.617920 811.282043,610.653381 
	C814.564392,612.078369 814.745483,614.999390 815.548462,617.884521 
	C815.315063,618.749878 814.986755,619.113708 814.145569,619.291626 
	C813.159180,618.812012 812.545837,618.392090 811.658691,617.915649 
	C808.682861,617.076904 806.951172,615.341919 806.263062,612.260620 
	C801.170044,603.614075 799.646545,594.364441 799.021484,584.426270 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M818.674316,570.767822 
	C818.910461,573.326660 819.569458,575.434814 820.822144,577.595215 
	C820.296936,579.268921 820.176453,580.663818 820.577881,582.181396 
	C821.134766,584.286804 820.733154,586.423645 818.316711,586.807617 
	C815.863770,587.197571 813.762390,585.447937 812.649780,583.588928 
	C811.567932,581.781067 813.654358,580.810791 815.117676,580.115784 
	C816.037170,579.678894 817.149475,579.375549 816.686218,578.114990 
	C816.073547,576.447876 814.463501,577.199036 812.880981,576.996948 
	C812.061951,577.161987 811.635254,577.121948 810.974060,576.647827 
	C810.454407,576.056458 810.237732,575.663269 809.944580,574.934448 
	C809.755676,574.411377 809.686096,574.200073 809.477417,573.334961 
	C809.346985,572.457520 809.355652,572.233887 809.463684,571.689148 
	C810.217407,570.299377 811.233215,569.951965 812.748291,569.964966 
	C815.189209,570.184265 814.676147,567.395386 816.696228,567.057983 
	C818.318726,567.844849 817.708923,569.462036 818.674316,570.767822 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M825.188904,556.191833 
	C824.548340,555.976624 824.203491,555.902222 823.334900,555.752441 
	C825.351440,551.316162 829.061340,549.010620 834.595642,549.172119 
	C835.745911,548.380432 836.612854,548.286682 837.684631,549.132629 
	C840.556396,551.252441 843.751465,552.380798 845.443604,555.859497 
	C846.280090,556.337891 846.521667,556.787354 846.142578,557.763550 
	C844.805420,558.575928 844.996948,559.623840 844.669067,560.821777 
	C840.563599,560.271790 838.980896,556.245239 835.432983,554.249390 
	C833.962036,553.235291 832.669373,553.167542 831.024780,553.707520 
	C829.018738,554.762085 827.643066,556.380005 825.188904,556.191833 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M815.313171,532.141235 
	C813.268616,531.922852 811.538879,531.967651 809.387573,532.115784 
	C808.630676,531.749329 808.522888,531.231995 808.956909,530.402344 
	C816.095642,525.332336 823.366089,526.172607 831.089478,528.553833 
	C831.958496,528.336731 832.476318,528.355225 833.216675,529.073975 
	C833.568298,530.011780 833.496765,530.569214 832.909668,531.389038 
	C830.312317,532.623901 828.030212,532.653381 825.337280,531.603760 
	C822.535156,530.791077 820.158569,531.434204 817.383484,531.678711 
	C816.683777,532.293396 816.227478,532.504089 815.313171,532.141235 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M857.724121,534.985535 
	C857.837708,534.659973 857.684082,534.386719 857.692505,534.230225 
	C858.122925,533.585388 858.782959,533.302979 858.981201,532.281982 
	C858.975464,531.752380 858.956421,531.550354 858.903076,531.046021 
	C858.706238,530.619934 858.543762,530.496338 858.167480,530.153442 
	C857.953674,529.934082 858.019348,529.974609 858.035278,530.009766 
	C857.412476,529.409790 856.715515,528.813782 856.605835,527.506897 
	C857.877197,526.953613 858.818665,526.387695 859.244751,524.631653 
	C862.906372,526.443115 865.818298,529.389160 868.879517,532.631531 
	C870.497925,535.290955 871.244202,537.535095 867.691650,539.274902 
	C865.800293,539.672607 864.627930,538.705017 862.996094,538.065918 
	C861.016174,537.006531 858.221497,538.257202 857.724121,534.985535 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M815.258728,618.190613 
	C813.962097,615.745300 812.791809,613.627869 811.574219,611.215271 
	C811.880005,610.403625 812.233154,609.887085 812.989746,609.132690 
	C815.283203,608.144287 816.707153,612.162598 818.924194,609.117554 
	C819.354248,608.182068 819.770386,607.648865 820.676880,607.135498 
	C821.008240,607.024597 821.505188,607.015503 821.753540,607.006470 
	C822.193542,606.740845 822.426453,606.529724 822.857666,606.187012 
	C823.014709,606.009888 823.504883,606.014099 823.750000,606.014282 
	C825.057556,606.244568 825.924194,606.858032 827.023071,607.685791 
	C827.620117,609.590454 826.381592,610.748535 825.772156,612.442871 
	C825.534546,612.930298 825.435120,613.123535 825.032959,613.899536 
	C824.489563,614.854004 824.237793,615.218140 823.772705,615.846680 
	C823.415833,616.287109 823.261536,616.455811 822.848267,616.852783 
	C820.328186,618.263672 818.493591,621.583435 815.258728,618.190613 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M784.647217,585.009399 
	C782.427673,584.061462 783.106873,582.030090 783.069153,580.325439 
	C782.874573,571.520264 781.195740,563.019104 778.059326,554.397949 
	C777.480835,553.472595 777.334045,552.765137 777.893494,552.317200 
	C779.027283,551.409363 779.599915,552.500061 780.173889,553.201477 
	C781.604126,554.949524 781.346008,557.640198 783.716675,559.169434 
	C784.212158,559.409790 784.397827,559.529846 784.740112,559.942322 
	C784.670410,568.408142 786.997620,576.586914 784.647217,585.009399 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M798.702820,576.045532 
	C798.438721,576.352966 798.195251,576.277527 797.777893,576.121216 
	C797.545654,575.238159 797.492859,574.417786 797.353943,573.293030 
	C795.446777,571.511292 797.283325,570.121033 797.573853,568.345886 
	C798.884399,564.607605 799.991272,561.212463 801.162964,557.454834 
	C800.742249,553.171570 802.598938,550.148560 805.357666,547.348572 
	C806.793579,546.634033 806.606689,544.790771 808.959900,544.418091 
	C804.244568,554.690552 801.379456,565.154541 798.702820,576.045532 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M810.563354,573.557495 
	C810.858459,574.193237 810.944275,574.639709 811.077820,575.423706 
	C810.727417,577.116760 809.197571,576.842896 808.218018,577.924988 
	C806.554688,578.687805 805.087891,579.169800 803.304077,579.775696 
	C802.463562,579.751465 801.940125,579.603271 801.258545,579.228638 
	C801.087036,572.413818 804.562134,568.175781 810.398865,567.324768 
	C812.192932,567.063232 812.833557,567.660156 813.043945,569.619446 
	C812.117920,570.535461 811.155579,571.079346 809.998779,571.901978 
	C809.184021,572.529785 808.509705,572.482483 807.837219,572.448425 
	C808.384583,572.653381 808.968567,572.446533 809.790894,572.796875 
	C810.061035,572.995728 809.995178,573.008667 809.988892,572.975708 
	C810.106384,573.084595 810.230164,573.226379 810.563354,573.557495 
z"/>
<path fill="#575D7C" opacity="1.000000" stroke="none" 
	d="
M821.148254,658.172729 
	C820.840088,657.960815 820.361755,657.990784 820.164307,657.859497 
	C820.213074,657.069336 820.459290,656.410400 820.880737,655.439819 
	C821.986084,652.775940 823.665466,651.032227 825.903625,649.339722 
	C826.189148,649.168945 826.184875,649.144897 826.173523,649.145508 
	C827.094788,646.832092 828.476074,644.890503 831.047119,643.655884 
	C832.830078,643.234253 832.843506,641.070679 834.729309,640.965393 
	C834.760010,643.803955 834.036133,646.421814 832.943726,649.341797 
	C832.516357,650.711792 832.129944,651.702148 831.022461,652.563477 
	C830.720581,652.668823 830.705811,652.757812 830.673584,652.726257 
	C828.130066,655.479797 825.602234,658.238159 821.148254,658.172729 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M810.005859,510.419525 
	C815.166443,509.805206 820.325623,509.621399 825.748291,509.703064 
	C825.331848,510.403809 824.145325,510.747406 824.047424,511.288116 
	C822.441772,520.157776 816.144470,513.762024 812.209778,514.784241 
	C809.612549,515.459045 810.168030,512.539673 810.005859,510.419525 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M841.959839,544.255127 
	C848.843262,547.743713 850.451477,540.552002 854.607605,537.922241 
	C857.581909,538.085022 856.881042,539.943542 856.646423,541.914673 
	C856.422607,543.596924 855.629944,544.659485 854.649048,545.980469 
	C853.671753,546.946228 852.701172,547.431213 851.589172,548.705444 
	C847.618530,550.079285 844.466309,548.286743 841.358643,547.430298 
	C837.411377,546.342346 843.024414,545.845886 841.959839,544.255127 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M832.735596,531.116577 
	C832.823181,530.456665 832.716980,530.064819 832.490051,529.391663 
	C834.509583,527.771790 835.884216,529.946838 837.664185,530.283569 
	C840.636292,530.845764 837.401245,528.653870 838.666382,528.117188 
	C839.951355,526.880005 841.412720,526.671204 843.042480,526.016174 
	C844.209717,526.134033 844.790527,526.526123 844.966919,527.675659 
	C845.214905,528.193176 845.437805,528.424805 845.831787,528.826355 
	C846.317749,529.105408 846.576843,529.292786 846.888550,529.776978 
	C846.866272,530.187195 846.732605,530.381653 846.310913,530.781982 
	C845.705566,531.378784 845.388245,531.769714 845.038574,532.423218 
	C839.877075,532.330444 835.286438,534.086426 830.502319,536.369385 
	C829.314026,536.158508 828.550903,535.744019 828.096313,534.387390 
	C828.276672,530.918091 831.667664,533.379028 832.735596,531.116577 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M845.933838,558.393127 
	C845.873962,557.646729 845.869934,557.194397 845.774536,556.410645 
	C847.218811,555.580566 846.808899,559.379944 848.972290,557.277832 
	C851.153809,557.968689 853.307678,558.937378 855.823242,559.918457 
	C856.610718,559.636902 857.079651,559.549133 857.910217,559.824585 
	C859.284180,561.195984 859.755127,562.579407 859.528931,564.505432 
	C858.123169,565.211914 856.854370,565.569153 855.190674,565.963257 
	C853.485718,565.702881 852.946594,564.654907 852.230225,563.294556 
	C850.611023,563.007874 849.263794,563.111816 848.841125,565.296387 
	C848.187378,564.699219 847.631104,563.697510 847.144897,562.347168 
	C847.650635,561.493835 847.734863,560.962769 847.083618,560.227966 
	C846.106567,559.875854 846.031006,559.292053 845.933838,558.393127 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M818.076416,595.381104 
	C818.033997,594.869812 818.024475,594.696960 818.009888,594.264404 
	C820.179199,594.229736 819.754822,591.332092 821.566711,591.064331 
	C823.708252,590.747864 824.961609,592.288879 826.228149,593.451721 
	C827.578247,594.691223 826.912170,596.054382 825.729492,597.301636 
	C824.836609,598.243347 824.235718,599.461914 823.239258,600.769165 
	C822.598633,601.524292 822.218628,602.062378 821.288208,602.166931 
	C820.831421,602.015930 820.662720,602.026367 819.985718,601.839172 
	C818.499207,599.788147 818.821716,597.634338 818.076416,595.381104 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M821.014282,658.166382 
	C824.534973,657.308960 826.772949,654.152893 830.306519,652.671387 
	C830.057739,655.520508 830.933105,657.952637 832.827148,660.433655 
	C831.790344,662.149292 830.189880,661.265869 828.385864,661.172729 
	C828.006775,660.921265 828.002319,660.990723 828.028198,660.967468 
	C826.608337,659.955017 824.827271,660.952820 823.182251,659.780640 
	C822.405884,659.064331 821.797119,658.718201 821.014282,658.166382 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M874.714966,582.331665 
	C874.123352,586.118591 877.428223,588.209351 877.054932,591.622437 
	C876.834534,592.130798 876.650940,592.242493 876.265137,592.103088 
	C874.119812,587.044861 871.363831,582.690857 868.292908,578.146973 
	C866.231934,577.640503 865.719238,576.326172 865.487427,574.400208 
	C865.302979,573.571960 865.271484,573.100769 865.561401,572.311768 
	C868.574036,571.282288 869.369324,573.676941 870.610474,575.283508 
	C872.136963,577.259521 873.084106,579.603760 874.714966,582.331665 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M825.659302,614.131104 
	C827.347351,614.947388 829.996887,615.007263 829.502319,617.409668 
	C829.063721,619.540161 827.115784,618.175171 825.752197,618.228271 
	C823.625244,618.311218 824.146118,619.775757 824.528381,621.108398 
	C824.935974,622.529358 825.605530,624.217529 823.479858,624.752930 
	C821.407959,625.274841 821.050720,623.627197 820.701538,621.659546 
	C820.347168,619.276184 821.563049,617.918457 822.793396,616.238586 
	C823.029846,616.007385 822.997559,615.997559 823.003662,616.013306 
	C823.146118,615.884277 823.282471,615.739502 823.657166,615.415588 
	C824.426453,614.959534 824.905640,614.604370 825.659302,614.131104 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M805.275146,547.247437 
	C804.396423,550.442810 803.049133,553.511780 801.464844,556.836548 
	C799.317688,556.326904 800.730652,553.476013 798.292725,552.697205 
	C796.967285,551.051086 798.139954,550.000549 798.924561,548.557007 
	C799.284790,548.111206 799.444214,547.944580 799.891602,547.583557 
	C800.816833,547.085266 801.490540,546.929810 802.537903,546.947876 
	C803.523376,547.039856 804.164978,547.080505 805.275146,547.247437 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M866.335999,571.476013 
	C866.116760,572.299561 866.066284,572.796204 866.002441,573.667114 
	C865.771790,574.183960 865.554504,574.326538 865.181396,574.111816 
	C864.701111,573.666565 864.376648,573.578674 863.844543,573.653748 
	C862.834229,573.757202 862.488892,573.328369 862.989746,572.223267 
	C862.996094,569.290222 861.169373,567.425781 859.637207,565.065735 
	C858.806396,563.623840 858.220947,562.393066 857.547729,560.834534 
	C857.503113,560.261963 857.546326,560.017212 857.950684,559.681396 
	C862.760742,562.225586 864.949707,566.462708 866.335999,571.476013 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M802.873718,546.609375 
	C802.232056,547.140991 801.582275,547.282715 800.695190,547.535156 
	C798.862793,545.191895 795.297058,544.088928 795.800049,540.223145 
	C800.480469,539.778687 802.737671,541.834351 802.873718,546.609375 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M795.722046,540.030640 
	C796.192627,540.670288 794.846741,541.751526 796.239807,541.868408 
	C799.611084,542.151245 799.640625,544.681824 800.300354,547.314880 
	C800.457764,547.645874 800.135803,547.889587 799.973816,548.010010 
	C798.948669,548.409485 798.291382,547.950378 797.389160,547.351685 
	C796.996765,547.069641 796.841125,546.956726 796.444702,546.688293 
	C795.867981,546.348633 795.530029,546.168152 794.940796,545.843262 
	C794.538025,545.577515 794.384460,545.459900 794.014648,545.148743 
	C792.437866,542.725403 789.924805,540.135803 795.722046,540.030640 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M836.897217,586.841187 
	C838.002380,585.871155 839.140503,585.369446 840.580566,584.779602 
	C840.950745,586.314453 841.011230,587.937744 841.089417,589.560242 
	C841.149780,590.813354 842.652649,592.549927 840.060791,592.925354 
	C837.657349,593.273438 836.876404,591.930908 836.993164,589.745422 
	C837.036377,588.936890 836.954773,588.121704 836.897217,586.841187 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M856.317871,527.062744 
	C857.148193,527.905090 857.659546,528.640991 858.111084,529.710815 
	C854.970093,530.679993 852.824585,527.431396 849.304199,528.042236 
	C849.752441,523.137329 849.933289,523.109863 856.317871,527.062744 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M819.662842,657.518982 
	C819.966919,657.728210 819.881653,657.855713 819.882263,657.932251 
	C816.044189,661.137939 815.835754,655.998718 813.390015,655.114136 
	C812.048340,652.933899 809.646362,651.950012 809.057739,649.252808 
	C812.313110,649.047180 813.084290,652.280945 815.195801,653.848999 
	C816.642334,654.923218 817.975098,656.150696 819.662842,657.518982 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M881.903320,595.267212 
	C883.743896,594.254578 884.324585,592.575623 885.441956,590.940918 
	C888.059631,593.343079 891.498779,595.660400 887.772217,600.001221 
	C885.046631,600.762878 883.761658,599.015564 882.089539,597.364380 
	C881.885315,596.559570 881.860168,596.088135 881.903320,595.267212 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M805.857056,611.948181 
	C807.861084,613.706238 809.428833,615.503357 811.190796,617.579712 
	C809.309021,617.574524 807.233154,617.290039 804.769409,617.004456 
	C802.883545,616.765747 802.680237,615.586121 802.570374,614.055420 
	C803.191467,612.519226 804.179749,612.050293 805.857056,611.948181 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M854.313293,617.137817 
	C853.267395,616.848572 851.115906,616.732483 852.667786,615.976929 
	C855.219116,614.734680 858.390381,614.726440 861.319458,614.345764 
	C861.712952,614.294678 862.478943,615.030701 862.617126,615.528625 
	C862.904968,616.566040 862.126099,616.982300 861.199646,617.010620 
	C859.050720,617.076538 856.900452,617.099243 854.313293,617.137817 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M822.673340,615.944885 
	C823.297485,618.020020 821.744690,619.202087 820.746399,620.969604 
	C818.078064,622.477295 816.104309,621.266296 813.981384,619.511353 
	C814.120972,618.968689 814.469299,618.705505 814.974976,618.152527 
	C818.571777,620.992310 820.002197,616.833496 822.673340,615.944885 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M826.066101,613.703735 
	C825.776733,614.860962 825.487183,615.603149 824.193481,615.829712 
	C823.615356,615.470947 823.527893,615.028625 823.788818,614.258423 
	C823.980774,613.964539 824.006042,613.994507 823.986511,613.995789 
	C824.250427,613.757263 824.511902,613.495728 824.879517,612.964050 
	C825.599182,611.348206 826.187012,609.977051 826.896973,608.305420 
	C826.266235,606.335449 827.506592,605.440002 828.728394,604.262573 
	C829.849548,603.496216 830.655396,602.882202 831.723022,602.128357 
	C832.462036,604.164795 830.652893,605.495056 829.953735,607.615234 
	C829.781555,608.180908 829.687683,608.396362 829.285889,608.783569 
	C828.051819,610.435608 827.125671,611.915955 826.066101,613.703735 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M832.297119,601.214966 
	C831.820801,600.803223 831.656250,600.502625 831.408691,600.307251 
	C829.721680,598.975342 829.199402,596.490845 830.705566,595.865723 
	C832.116455,595.280151 835.124146,596.339844 836.179260,597.668213 
	C837.439331,599.254639 835.210571,600.235718 833.412109,600.948181 
	C832.903015,601.114868 832.736694,601.244873 832.297119,601.214966 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M829.003845,603.780151 
	C829.084900,605.534485 828.093628,606.430359 827.177917,607.725464 
	C825.890198,607.924683 824.599487,608.204834 824.052551,606.356934 
	C825.257629,601.647156 826.524109,600.993530 829.003845,603.780151 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M808.871094,530.085754 
	C809.192871,530.597534 809.114197,531.057739 809.000854,531.868530 
	C808.966125,534.458679 808.966125,536.698181 808.966125,539.723572 
	C806.397522,537.095520 807.116089,534.046326 805.427979,531.762756 
	C804.315613,530.258179 807.060852,530.112610 808.871094,530.085754 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M843.847351,513.786011 
	C846.635742,514.293030 848.581726,515.933655 850.840332,517.639893 
	C851.388855,518.332214 851.526917,518.812927 851.214478,519.670288 
	C849.669556,519.247437 848.278198,518.841675 846.384277,518.985962 
	C846.084900,517.178650 844.469482,517.140137 843.211182,516.257751 
	C843.026489,515.285339 843.101990,514.583374 843.847351,513.786011 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M802.364441,613.688171 
	C803.124878,614.621948 803.595825,615.532471 804.224121,616.723145 
	C804.091187,617.859314 803.800903,618.715332 803.256531,619.802490 
	C802.333984,620.582214 801.590454,620.701660 800.486816,620.150269 
	C800.250549,617.633606 800.355957,615.405334 802.364441,613.688171 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M820.967041,606.661743 
	C820.631836,607.715149 820.255493,608.405762 819.724243,609.458374 
	C818.107849,609.605713 817.080322,608.776001 816.179504,607.155273 
	C815.656982,605.362122 815.714844,603.984497 816.562256,602.297791 
	C817.504761,601.345642 818.312927,601.183228 819.577026,601.545166 
	C819.951660,601.750122 819.966309,601.923767 819.978516,602.011108 
	C820.302429,603.498657 820.614075,604.898743 820.967041,606.661743 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M838.800354,527.829163 
	C838.334839,529.192749 841.287781,529.886108 839.483337,531.178040 
	C838.358521,531.983337 837.107849,532.229065 835.868835,531.253845 
	C834.979065,530.553467 834.050537,529.902527 832.754272,529.169922 
	C832.114441,529.142090 831.880310,529.086487 831.548218,528.806091 
	C831.974670,528.454651 832.519775,528.240784 833.494141,527.935181 
	C834.093750,527.730652 834.264038,527.617859 834.740784,527.512146 
	C835.244751,527.571472 835.442261,527.623779 835.893921,527.847534 
	C836.594055,527.994385 837.040100,527.969849 837.821045,527.945557 
	C838.303528,527.850708 838.450928,527.755737 838.800354,527.829163 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M819.626099,558.990845 
	C819.816833,560.122498 819.635437,561.244934 819.302124,562.677917 
	C818.294617,563.472351 818.649719,564.743591 817.386841,565.120239 
	C816.688904,563.406311 817.806885,561.336121 815.775452,560.166016 
	C814.727661,559.562561 813.477234,558.965027 814.609863,557.668579 
	C815.709045,556.410400 816.549072,557.744080 817.444336,558.383789 
	C817.937988,558.736511 818.643860,558.792175 819.626099,558.990845 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M832.488037,530.895386 
	C833.067749,534.564331 830.336792,533.347717 828.192871,533.720825 
	C826.593323,533.946289 825.585327,533.351746 825.007935,531.711914 
	C827.259155,530.480347 829.689941,531.270508 832.488037,530.895386 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M823.522827,521.805176 
	C821.820557,520.605591 822.132141,519.069519 823.567810,518.909973 
	C826.244751,518.612488 826.875000,520.753296 827.149170,523.075806 
	C825.613831,523.367126 825.265198,521.121887 823.522827,521.805176 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M831.176392,643.307495 
	C830.287354,645.792358 828.424316,647.258545 826.467285,649.027954 
	C826.778137,646.316589 825.808228,642.252502 831.176392,643.307495 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M799.908386,620.101135 
	C800.895386,619.938477 801.594360,619.999573 802.647949,620.047119 
	C802.928528,621.341003 804.380676,623.049744 802.151978,623.784668 
	C801.287537,624.069702 799.813721,624.381836 799.457764,623.964661 
	C798.568726,622.922729 798.859680,621.518372 799.908386,620.101135 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M881.685486,597.185303 
	C883.988098,596.972595 885.129822,598.366394 886.513245,599.999146 
	C887.475159,600.491028 887.671875,601.088745 887.671021,602.091675 
	C887.612061,602.414856 887.298523,602.714600 887.141357,602.864014 
	C884.674011,604.472778 884.026917,601.688354 882.151917,601.101318 
	C881.638428,600.850586 881.436523,600.740356 880.989990,600.384033 
	C880.700500,599.910828 880.655579,599.683533 880.804443,599.167725 
	C881.152283,598.365967 881.306396,597.852783 881.685486,597.185303 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M848.754395,571.943787 
	C848.462463,571.347046 848.501465,570.940308 848.701172,570.268188 
	C853.237732,569.756592 853.237732,569.756592 851.303528,575.401794 
	C849.266968,575.189148 850.447571,572.783203 848.754395,571.943787 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M825.792664,649.150879 
	C825.542358,651.748413 823.148743,652.920898 821.350647,654.969238 
	C820.356506,651.575928 821.754211,649.542053 825.792664,649.150879 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M852.478210,582.824341 
	C851.730347,580.299744 852.502808,578.304260 854.796814,576.780334 
	C854.927002,579.169189 855.875793,581.596802 852.478210,582.824341 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M796.787964,546.195862 
	C798.237671,545.984131 798.415649,547.320374 799.542480,547.979614 
	C799.386047,549.438538 798.960266,550.746643 798.272644,552.292114 
	C796.969482,552.791687 796.042786,552.488098 794.893433,551.694031 
	C794.538574,551.232239 794.453369,551.028992 794.423340,550.501770 
	C795.296936,548.996399 796.404541,547.977966 796.787964,546.195862 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M807.853394,523.399780 
	C808.576538,521.340820 810.667786,520.959534 812.628540,519.911377 
	C813.121887,523.387268 811.422791,524.463806 807.853394,523.399780 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M857.663574,560.333374 
	C857.170166,560.386414 856.896362,560.237000 856.411743,559.994629 
	C855.323914,557.992493 854.462830,556.054260 853.496033,553.777466 
	C853.483704,553.207764 853.576965,552.976624 854.037476,552.669495 
	C857.434509,553.716919 858.278503,556.237488 858.414429,559.453125 
	C858.128174,559.916809 857.997681,560.038391 857.663574,560.333374 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M831.817627,512.238098 
	C832.330688,512.093811 832.585693,512.278748 832.901245,512.747009 
	C832.747131,514.150940 833.666748,515.859131 832.049988,516.435608 
	C830.767212,516.893005 829.879700,515.643921 829.526245,514.598145 
	C828.923096,512.813599 830.949524,513.249451 831.817627,512.238098 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M817.045227,565.383545 
	C817.570557,564.458435 818.091125,563.858093 818.880859,563.123108 
	C819.118286,565.374207 819.086487,567.760071 818.964172,570.584717 
	C816.807068,570.745361 817.062927,569.163208 817.031250,567.376099 
	C817.034302,566.575989 817.037354,566.142151 817.045227,565.383545 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M797.455383,568.074585 
	C797.696777,569.441040 797.615967,570.879456 797.401489,572.653198 
	C794.083801,572.361084 794.083801,572.361084 797.455383,568.074585 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M852.033325,563.401917 
	C853.281677,563.412048 853.796082,564.536682 854.627930,565.757996 
	C854.772522,566.818726 854.695984,568.023376 853.737610,567.806396 
	C851.576599,567.317139 852.459290,565.214355 852.033325,563.401917 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M796.996033,545.971069 
	C795.364075,546.936157 800.560547,550.009094 795.384399,549.894531 
	C793.744934,549.352661 793.396606,548.456543 793.874390,546.834290 
	C794.022583,546.452148 794.008484,546.501526 793.990967,546.520325 
	C794.080261,546.318115 794.187073,546.097168 794.625366,545.715942 
	C795.448120,545.522827 795.938110,545.536072 796.731445,545.802856 
	C797.036011,546.010498 797.004028,545.988647 796.996033,545.971069 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M839.348389,527.856750 
	C839.002441,527.997620 838.584961,527.875793 838.370483,527.910767 
	C838.726196,525.166687 840.994141,525.686401 843.151123,525.747559 
	C842.908630,528.162903 840.739319,526.730957 839.348389,527.856750 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M828.109558,585.994873 
	C828.964600,585.814697 829.783569,586.036377 830.869507,586.431091 
	C830.391357,587.906982 829.646301,589.209778 828.876404,590.555969 
	C827.445129,589.325256 828.204773,587.777527 828.109558,585.994873 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M829.175171,609.228638 
	C829.066406,608.650024 829.232788,608.395874 829.676208,608.079102 
	C830.927490,608.132629 832.268494,607.696411 832.723877,609.149536 
	C832.839172,609.517273 832.656372,610.285461 832.391235,610.412842 
	C831.176392,610.996277 830.303772,610.082458 829.175171,609.228638 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M828.247559,661.242859 
	C829.394531,660.891296 830.782227,660.861389 832.584839,660.771240 
	C833.460205,660.767029 833.920776,660.823120 834.724670,660.811279 
	C835.520935,660.578064 835.987122,660.531738 836.728271,660.827515 
	C834.252380,662.859497 831.364014,662.102600 828.247559,661.242859 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M865.017212,574.149597 
	C865.189331,573.791199 865.353210,573.827942 865.753113,573.953003 
	C866.050659,575.431152 867.010803,576.333618 867.908142,577.632202 
	C864.275818,579.264771 865.279663,576.333435 865.017212,574.149597 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M795.046631,628.647095 
	C794.288818,627.892761 793.574036,626.830200 792.736511,625.459473 
	C795.040833,624.969788 797.518677,624.748657 795.046631,628.647095 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M794.380493,612.471802 
	C795.106995,611.649353 795.913147,610.786072 796.444092,611.790649 
	C797.020447,612.880920 796.267090,614.164062 795.160034,614.432068 
	C794.037048,614.704102 794.158691,613.553894 794.380493,612.471802 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M858.716187,532.095337 
	C859.856812,532.534485 861.158142,533.023804 860.403931,534.343262 
	C859.927246,535.177368 859.023193,534.373047 858.008911,534.146484 
	C857.350098,534.045349 857.101074,533.871338 856.869751,533.329712 
	C857.336426,532.817200 857.887146,532.526794 858.716187,532.095337 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M853.646484,553.269165 
	C852.257202,552.440430 851.236267,551.369995 851.076782,549.440552 
	C851.111755,549.110596 851.069641,549.126587 851.091553,549.128174 
	C854.022522,547.870972 854.147644,550.101074 854.487488,552.308350 
	C854.214539,552.833923 854.058533,552.966614 853.646484,553.269165 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M852.145874,582.948975 
	C852.067993,584.673218 851.188904,585.968384 849.625000,587.185181 
	C849.310730,587.313538 848.834412,587.234680 848.790405,586.997314 
	C849.393982,585.340942 849.773560,583.735596 851.701599,582.881592 
	C852.028198,582.783325 852.074036,582.926697 852.145874,582.948975 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M808.340454,578.215942 
	C807.921509,576.523071 809.007019,576.083313 810.755615,575.856140 
	C811.435852,576.030334 811.746155,576.299500 812.282349,576.781250 
	C812.461426,577.195801 812.414551,577.397827 812.193604,577.857544 
	C811.594604,578.361084 811.136841,578.476196 810.286987,578.419983 
	C809.505005,578.328491 809.082275,578.277222 808.340454,578.215942 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M804.575439,525.980530 
	C804.514893,524.644348 805.720886,524.193787 806.959717,523.452942 
	C808.314148,525.782593 806.673218,525.893921 804.575439,525.980530 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M881.180298,601.695984 
	C880.163330,602.308594 879.396301,602.631470 878.315796,602.975952 
	C877.997742,601.885376 878.411743,600.980957 879.599121,600.171631 
	C880.054321,599.884399 880.238770,599.751709 880.701355,599.816040 
	C880.979492,600.013123 881.000000,600.000000 880.993286,600.010254 
	C881.372314,600.406250 881.520386,600.868103 881.180298,601.695984 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M851.317383,520.133423 
	C850.991638,519.524109 851.000671,519.064270 851.020630,518.259460 
	C852.316467,518.695557 853.601318,519.476624 855.043945,520.540649 
	C853.953186,521.072449 852.757324,520.975586 851.317383,520.133423 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M855.125488,521.105713 
	C856.043030,521.320129 856.912109,521.865479 857.899475,522.700745 
	C856.823059,522.878540 854.742126,524.443848 855.125488,521.105713 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M782.677612,554.200439 
	C783.010559,553.963989 783.466553,553.992554 783.693420,554.016235 
	C783.999878,554.811279 784.079468,555.582764 784.241943,556.733582 
	C784.308838,557.382263 784.292786,557.651550 783.948608,558.159058 
	C780.158264,558.055542 781.468628,556.176270 782.677612,554.200439 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M812.964844,518.963013 
	C812.128174,518.875793 811.268433,518.807129 810.144470,518.545898 
	C810.560120,517.076721 811.480103,516.764771 812.891602,517.940247 
	C813.207336,518.387024 813.330017,518.545288 813.203613,518.871460 
	C812.954529,519.039368 812.941772,518.981567 812.964844,518.963013 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M793.754517,546.713623 
	C793.826172,547.457397 793.950378,548.374939 794.886841,549.442139 
	C794.968323,550.054871 794.911682,550.333801 794.739380,551.024048 
	C793.058167,550.251160 792.631775,548.776489 793.754517,546.713623 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M837.826782,549.203125 
	C837.100891,549.479004 836.400269,549.372131 835.349609,549.204163 
	C835.119202,548.182617 835.306458,547.205505 836.542664,547.228394 
	C837.482605,547.245789 837.797180,547.972961 837.826782,549.203125 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M843.942932,513.396118 
	C843.943298,514.247925 843.741455,514.904907 843.273315,515.782227 
	C842.083191,515.411499 841.996826,514.497803 842.090942,513.174072 
	C842.665527,512.946655 843.203125,513.074036 843.942932,513.396118 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M807.824951,508.855164 
	C808.005615,509.007019 808.013245,509.493134 808.021240,509.735840 
	C807.270569,509.985077 806.511902,509.991577 805.374146,509.997803 
	C805.070129,509.088196 805.323425,508.306793 806.683960,508.049561 
	C807.220032,508.238220 807.433411,508.469604 807.824951,508.855164 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M852.697998,655.663940 
	C852.276306,655.760132 851.936462,655.545349 851.417480,655.241089 
	C851.109131,654.463257 851.284668,653.666321 851.946045,653.628113 
	C853.250183,653.552673 852.635254,654.696960 852.697998,655.663940 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M831.104492,652.730103 
	C830.635925,651.420410 831.559753,650.793396 832.594849,649.884399 
	C832.882446,650.943176 833.370239,652.395569 831.104492,652.730103 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M803.837036,511.353027 
	C803.980042,511.030609 804.445557,511.096100 804.672363,511.157532 
	C805.277344,511.973572 805.655518,512.728149 806.028320,513.801331 
	C805.863037,514.199646 805.703003,514.279480 805.286438,514.437622 
	C803.991455,513.848145 803.752930,512.804016 803.837036,511.353027 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M834.941650,527.744812 
	C834.471436,528.023254 834.200684,527.928650 834.062012,527.886047 
	C834.025208,526.870422 831.422119,526.325378 833.745117,525.023254 
	C834.306458,525.297852 834.574280,525.616211 834.916382,526.253906 
	C835.019226,526.549255 834.993408,526.508118 834.988647,526.484375 
	C835.126587,526.795837 835.269226,527.131104 834.941650,527.744812 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M809.621582,561.900879 
	C811.156982,561.482727 811.010925,562.359070 810.762207,563.069153 
	C810.656250,563.371643 809.959961,563.768311 809.726257,563.668274 
	C809.039490,563.374268 809.103149,562.724060 809.621582,561.900879 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M837.305298,660.969604 
	C836.560486,661.014465 836.129089,660.961426 835.382935,660.825867 
	C836.109619,659.736816 837.400146,660.043274 839.027588,660.106628 
	C838.818420,660.388367 838.218567,660.630066 837.305298,660.969604 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M846.352295,530.988586 
	C846.121460,530.669800 846.305054,530.412598 846.786865,530.104370 
	C847.704041,530.140442 848.614380,529.670471 849.033264,530.671875 
	C848.249451,530.777710 847.465576,530.883545 846.352295,530.988586 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M853.955200,532.578491 
	C853.553711,532.908752 853.107056,532.958801 852.329590,532.933716 
	C852.096313,532.230530 852.177551,531.493774 852.958191,531.465942 
	C853.265198,531.455078 853.592163,532.004089 853.955200,532.578491 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M815.035400,532.192627 
	C815.441528,531.802673 815.884583,531.727173 816.662292,531.712036 
	C816.784119,532.337524 816.727844,533.168884 816.322937,533.406799 
	C815.670410,533.790039 815.250427,533.162903 815.035400,532.192627 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M824.303223,539.381409 
	C823.733154,539.055664 822.688904,539.224854 822.770386,538.151428 
	C822.781799,538.000977 823.359741,537.717041 823.429871,537.777832 
	C823.737061,538.044434 823.953857,538.415161 824.318176,539.023315 
	C824.432922,539.298584 824.317688,539.324219 824.303223,539.381409 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M783.680786,558.439880 
	C783.937561,557.972839 784.028259,557.806885 784.221924,557.376953 
	C784.537537,557.928650 784.750244,558.744324 784.929871,559.897339 
	C784.896729,560.234680 784.450317,560.075500 784.217957,560.029114 
	C783.674500,559.627258 783.517517,559.213379 783.680786,558.439880 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M846.008179,518.994873 
	C845.474915,519.281738 844.938416,519.584839 844.379333,519.837952 
	C844.345520,519.853271 844.131470,519.470398 844.001343,519.272827 
	C844.475159,519.181335 844.948914,519.089844 845.717041,518.993408 
	C846.011414,518.988403 846.000000,519.000000 846.008179,518.994873 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M795.876953,618.697021 
	C795.179932,619.524536 795.148499,618.850647 795.119324,618.499512 
	C795.100281,618.269897 795.354431,618.017700 795.486145,617.775574 
	C795.628296,618.010254 795.770508,618.244873 795.876953,618.697021 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M821.176147,602.229248 
	C821.487976,601.738342 821.975830,601.471191 822.718689,601.092529 
	C822.814575,601.891907 822.892822,603.064209 821.176147,602.229248 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M863.084351,572.061523 
	C863.466125,572.335022 863.551758,572.755188 863.637146,573.496094 
	C862.616821,573.669434 861.920593,573.351379 863.084351,572.061523 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M810.125977,578.529297 
	C810.389648,578.291687 810.851501,578.203674 811.666443,578.115479 
	C811.593506,578.721436 811.064392,579.017639 810.125977,578.529297 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M846.255249,584.011353 
	C846.413879,583.907043 846.573853,583.958374 846.733887,584.009705 
	C846.574768,584.062134 846.415710,584.114563 846.255249,584.011353 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M794.638000,591.756592 
	C794.623352,591.992920 794.495361,592.121582 794.367371,592.250244 
	C794.419800,592.049805 794.472229,591.849365 794.638000,591.756592 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M806.349731,645.682129 
	C805.726135,645.509033 805.355713,645.043701 805.022461,644.261475 
	C805.986511,643.985962 806.296997,644.685547 806.349731,645.682129 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M843.755005,522.361084 
	C843.994690,522.375732 844.125427,522.505615 844.256104,522.635498 
	C844.052734,522.582397 843.849426,522.529358 843.755005,522.361084 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M813.171631,519.060669 
	C812.954529,519.039368 813.092224,518.645752 813.088501,518.437256 
	C813.435242,518.399719 813.785828,518.570557 814.136353,518.741333 
	C813.887085,518.854919 813.637878,518.968506 813.171631,519.060669 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M804.493408,527.037964 
	C804.933228,527.039490 805.387695,527.080261 805.842224,527.121094 
	C805.812073,527.300659 805.781921,527.480225 805.751770,527.659790 
	C805.472778,527.547424 805.193848,527.435120 804.682129,527.166748 
	C804.449402,527.010742 804.508179,527.077148 804.493408,527.037964 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M805.050659,514.616943 
	C805.199158,514.459351 805.368469,514.402588 805.780396,514.232910 
	C805.912476,514.384338 805.740051,514.599121 805.314575,514.840698 
	C805.123352,514.917053 805.071472,514.717773 805.050659,514.616943 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M848.261230,588.064331 
	C848.063293,588.427063 847.840088,588.569641 847.616882,588.712219 
	C847.568176,588.489380 847.519409,588.266479 847.633667,587.914185 
	C847.796753,587.784729 848.235962,587.844177 848.261230,588.064331 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M849.170044,587.174683 
	C849.144775,587.588562 848.934570,587.824097 848.483337,588.152344 
	C848.286499,588.284485 848.042419,588.036743 847.919556,587.910767 
	C847.941895,587.501892 848.133362,587.254883 848.558716,586.901794 
	C848.746338,586.759888 849.029419,587.035828 849.170044,587.174683 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M804.996948,515.772644 
	C804.885193,515.742310 804.770447,515.489929 804.818604,515.172241 
	C804.981506,515.106812 804.993958,515.550659 804.996948,515.772644 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M868.378052,609.223511 
	C868.627869,609.236938 868.611023,609.651001 868.534058,609.841553 
	C868.209778,609.845764 867.962463,609.659485 867.715088,609.473145 
	C867.852783,609.385437 867.990479,609.297791 868.378052,609.223511 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M832.016479,601.295044 
	C832.197571,601.040283 832.371399,601.025513 832.807251,600.997803 
	C832.867615,601.257935 832.665833,601.531006 832.224426,601.896301 
	C831.984802,601.988525 832.000366,602.000671 832.007690,602.007935 
	C832.015015,602.015137 832.009216,601.535034 832.016479,601.295044 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M822.794678,606.116089 
	C822.901123,606.325684 822.709106,606.582947 822.220276,606.889648 
	C822.109802,606.677734 822.300720,606.419312 822.794678,606.116089 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M876.132202,592.099365 
	C876.062866,591.851990 876.538696,591.945190 876.778442,591.982117 
	C877.018188,592.019043 876.997437,591.996155 876.987549,591.984497 
	C877.081604,592.129761 877.185486,592.286682 877.164429,592.696838 
	C877.039490,592.950012 876.982239,593.008301 876.950562,593.035339 
	C876.679810,592.823792 876.440674,592.585266 876.132202,592.099365 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M880.997314,599.729858 
	C880.795044,600.019104 880.610596,600.025085 880.148071,600.024048 
	C880.087646,599.728516 880.305420,599.439880 880.760742,599.015198 
	C881.003784,599.068359 881.009460,599.257446 880.997314,599.729858 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M835.039185,526.191406 
	C834.738281,526.236633 834.457336,525.924011 834.093140,525.307495 
	C834.359619,525.280334 834.709351,525.556946 835.039185,526.191406 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M795.232544,545.789062 
	C794.806213,546.171692 794.652771,546.272827 794.236450,546.456543 
	C793.933044,546.276428 793.892639,546.013733 793.825317,545.353149 
	C793.992310,544.945496 794.186157,544.935730 794.671021,544.934021 
	C795.143127,545.130554 795.324280,545.319031 795.232544,545.789062 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M857.867676,530.206421 
	C858.298157,529.887085 858.539307,530.023193 858.772888,530.542969 
	C858.506409,530.655334 858.143982,530.567017 857.867676,530.206421 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M848.932251,528.009521 
	C848.959656,528.010559 848.806335,528.114502 848.806335,528.114502 
	C848.806335,528.114502 849.053040,528.072937 848.956421,528.056396 
	C848.859802,528.039795 848.904846,528.008423 848.932251,528.009521 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M834.890747,528.071533 
	C834.514648,527.748962 834.557800,527.474670 834.792419,526.830444 
	C835.349670,526.732788 835.715332,527.005005 836.114563,527.648071 
	C835.868774,528.052490 835.589417,528.086121 834.890747,528.071533 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M845.888794,528.777222 
	C845.734192,528.804810 845.468384,528.610535 845.098755,528.187500 
	C845.312805,528.082764 845.573730,528.281616 845.888794,528.777222 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M816.452393,519.442688 
	C816.515564,519.403870 816.389221,519.481506 816.452393,519.442688 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M848.947021,556.867126 
	C848.882996,556.863464 848.765991,556.726990 848.648926,556.590515 
	C848.730591,556.638428 848.812317,556.686340 848.947021,556.867126 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M804.545105,565.471130 
	C804.574280,565.521790 804.515930,565.420471 804.545105,565.471130 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M805.076660,643.619751 
	C804.756348,643.681580 804.444519,643.393616 804.082031,642.771851 
	C804.382629,642.715332 804.733887,642.992676 805.076660,643.619751 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M843.185242,659.145508 
	C843.169067,659.330811 842.884277,659.536804 842.335205,659.757935 
	C842.352783,659.570740 842.634705,659.368469 843.185242,659.145508 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M807.196533,646.576416 
	C806.781799,646.777649 806.483032,646.607727 806.115967,646.177246 
	C806.571045,645.566895 806.992615,645.663208 807.196533,646.576416 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M808.195435,647.586914 
	C807.780273,647.778687 807.479797,647.609497 807.115540,647.179688 
	C807.569702,646.617126 807.988892,646.720459 808.195435,647.586914 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M809.207031,648.582947 
	C808.776855,648.781311 808.472290,648.615295 808.110229,648.184082 
	C808.576477,647.604126 809.002747,647.705566 809.207031,648.582947 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M802.471069,635.454224 
	C802.522217,635.424500 802.419922,635.483948 802.471069,635.454224 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M859.452637,632.531128 
	C859.421692,632.478027 859.483643,632.584290 859.452637,632.531128 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M799.454834,626.528809 
	C799.425354,626.477844 799.484253,626.579834 799.454834,626.528809 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M900.553345,603.027710 
	C906.028076,604.741760 910.121948,601.568237 914.599976,600.471985 
	C916.709534,599.955566 918.581177,598.028870 921.901062,599.669250 
	C914.895630,603.226807 908.580627,606.468628 901.307739,607.508911 
	C900.398132,607.681152 900.064453,607.022461 899.990479,605.859497 
	C899.268311,604.692261 899.399780,603.856567 900.553345,603.027710 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M900.969788,602.753906 
	C900.219849,603.450684 900.397095,604.220215 900.186035,605.238037 
	C899.242737,604.987549 898.483093,604.418640 897.426331,603.647339 
	C896.978577,603.282776 896.827942,603.120544 896.662720,602.626343 
	C896.768066,602.108215 896.888062,601.921936 897.325928,601.638245 
	C898.090027,601.513733 898.525269,601.573120 899.249268,601.853333 
	C900.004333,602.163635 900.461182,602.327515 900.969788,602.753906 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M896.597412,602.760132 
	C896.932495,602.994568 897.161377,603.165039 897.145264,603.304993 
	C896.259766,605.321960 894.575073,605.834900 892.346313,606.030884 
	C892.715271,605.143677 893.465515,604.301025 894.077820,603.132080 
	C893.939941,602.805786 893.999390,602.872803 893.961792,602.897095 
	C894.653931,602.496277 895.420166,602.286804 896.597412,602.760132 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M890.606079,607.794800 
	C890.691772,607.216492 891.079895,606.652283 891.726929,606.025146 
	C892.106201,606.857544 891.922913,607.575623 890.606079,607.794800 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M876.016235,623.642700 
	C875.038574,624.021973 874.358154,623.616272 874.058350,622.294800 
	C875.142761,621.740295 875.668701,622.380188 876.016235,623.642700 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M887.913330,602.538696 
	C887.396362,601.860291 887.180725,601.305664 886.878479,600.465820 
	C891.110718,596.782410 885.763245,594.437012 885.769409,591.120605 
	C886.318481,589.202271 886.980591,587.712769 889.449768,588.336060 
	C891.749756,591.282593 893.716492,594.139526 895.926880,597.280273 
	C896.497864,598.422180 898.110413,599.337769 895.876892,600.005920 
	C893.289429,600.780029 890.765869,601.767578 887.913330,602.538696 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M881.208801,602.179565 
	C880.935608,601.548706 880.940735,601.111755 880.966187,600.347656 
	C883.765259,599.083130 884.749390,601.484985 886.633057,602.940002 
	C886.823608,604.475037 886.534302,606.401550 885.017273,606.458740 
	C882.644958,606.548157 882.833069,603.636597 881.208801,602.179565 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M896.945129,602.751526 
	C896.165039,603.077454 895.397522,603.160339 894.277100,603.082336 
	C894.311462,601.808167 895.336792,601.552246 896.579468,601.142212 
	C897.104065,601.231567 897.320557,601.353271 897.287720,601.751709 
	C897.038452,602.028503 896.957764,602.508484 896.945129,602.751526 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M897.456055,602.002625 
	C897.038452,602.028503 896.828735,601.591064 896.858154,601.350464 
	C897.244812,600.563965 897.690735,600.474854 898.620483,600.945251 
	C899.089233,601.207825 899.164185,601.375183 899.393311,601.771118 
	C898.989563,601.992065 898.431641,601.984375 897.456055,602.002625 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M964.359314,609.755005 
	C963.851562,609.050720 963.652649,608.177124 963.156372,607.142761 
	C963.226685,605.889832 963.922180,605.773438 965.007568,606.591187 
	C965.006592,607.772522 964.837341,608.679138 964.359314,609.755005 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M866.600647,540.035034 
	C868.014709,537.895081 870.442139,536.522949 869.020752,533.294189 
	C870.686646,534.560120 872.347595,536.188782 874.291260,537.950684 
	C879.888184,540.942566 882.524902,546.358093 886.690186,550.794434 
	C886.918701,551.056641 887.000000,551.000000 886.956177,551.023071 
	C887.538757,551.580200 887.657043,552.275757 887.347351,553.354614 
	C888.241333,557.359131 882.806885,556.265381 882.991028,559.699951 
	C881.988159,560.573975 881.091370,560.209351 879.892700,559.619873 
	C875.418274,552.952698 869.718994,547.525208 866.600647,540.035034 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M880.043579,558.934204 
	C881.066895,559.125183 881.753296,559.471619 882.705505,559.955933 
	C884.843506,563.815430 886.715637,567.537170 888.658569,571.584839 
	C883.223938,574.137756 878.331238,577.106934 875.310669,582.847839 
	C874.992249,582.966919 874.999207,583.016968 875.024353,583.015869 
	C873.282104,580.703918 871.580933,578.374329 873.040833,574.877930 
	C878.143616,570.546875 880.192688,565.348877 880.043579,558.934204 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M887.096680,580.966064 
	C885.748596,580.976013 884.461670,581.831482 883.823914,580.510132 
	C883.350403,579.529175 884.446594,578.764893 885.173950,578.271606 
	C886.482788,577.383911 887.936340,576.709778 889.675171,575.828552 
	C890.827087,576.844727 891.939392,577.812134 891.966919,579.698608 
	C890.566467,581.006104 889.058167,581.338135 887.096680,580.966064 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M886.752197,581.196716 
	C888.085388,579.635864 889.692383,579.982178 891.582275,580.017822 
	C892.173828,580.964966 891.442078,581.340515 890.776855,582.069458 
	C889.320679,582.060791 887.480347,584.616943 886.752197,581.196716 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M929.047485,607.034912 
	C932.045715,605.281067 932.096069,608.228760 933.178711,609.527222 
	C933.286194,609.656067 932.435486,610.786133 931.860779,611.236084 
	C930.899658,611.988708 930.956604,610.772217 930.711731,610.414856 
	C930.059631,609.463501 929.556641,608.409973 929.047485,607.034912 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M922.941650,594.539856 
	C926.018066,593.658142 925.280396,596.180420 925.463684,598.095581 
	C924.496765,597.217102 923.758240,596.030273 922.941650,594.539856 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M937.689575,616.723206 
	C937.702881,618.200073 938.924438,619.199158 939.110657,620.881775 
	C936.671204,620.999268 936.266663,618.989197 935.514343,617.286499 
	C936.120728,617.097046 936.727051,616.907654 937.689575,616.723206 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M890.868408,556.978394 
	C890.912109,557.325073 890.864075,557.698059 890.846069,557.886047 
	C890.099854,558.225769 889.157227,558.732910 888.690247,558.451355 
	C887.851379,557.945618 888.560913,557.087891 888.961792,556.114014 
	C889.878723,555.616028 890.387390,556.046204 890.868408,556.978394 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M891.207092,557.141296 
	C890.481384,556.910889 890.050720,556.496704 889.347534,555.955811 
	C888.906799,555.425232 888.738647,555.021301 888.753906,554.344055 
	C891.252563,553.735535 891.520325,555.219482 891.207092,557.141296 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M901.668640,585.669128 
	C902.072266,586.549866 902.114990,587.557129 902.083130,589.063110 
	C902.051941,588.254944 897.968201,587.715881 901.668640,585.669128 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M887.449829,553.792114 
	C886.855530,552.949097 886.563843,552.232727 886.592285,551.281250 
	C888.828552,550.697632 888.825500,552.396484 889.196411,553.745605 
	C888.545715,554.016785 888.149048,553.967773 887.449829,553.792114 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M897.045166,573.218994 
	C897.312256,573.424805 897.575562,573.919678 897.816040,574.704834 
	C897.542603,574.499451 897.291992,574.003784 897.045166,573.218994 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M898.528198,592.546509 
	C898.477051,592.576416 898.579407,592.516663 898.528198,592.546509 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M898.104004,576.171265 
	C898.350586,576.059021 898.576599,576.261047 898.764954,576.786255 
	C898.534607,576.871460 898.319946,576.663574 898.104004,576.171265 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M988.098572,615.299866 
	C988.584839,614.507263 989.237793,613.703308 989.552979,613.819092 
	C990.501953,614.167480 990.203491,615.243530 989.935059,615.837708 
	C989.382629,617.060547 988.701904,616.178955 988.098572,615.299866 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M977.834595,613.876099 
	C979.576050,613.507690 978.856445,614.594238 978.838135,615.229919 
	C978.833923,615.379700 978.298279,615.690125 978.102051,615.627686 
	C977.291870,615.370056 977.293396,614.768005 977.834595,613.876099 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M981.986450,610.995972 
	C981.742310,611.525146 981.500427,612.073364 981.258545,612.621521 
	C980.982849,612.480103 980.537659,612.399231 980.461609,612.186523 
	C980.175049,611.384399 980.620911,611.018066 981.711914,610.992615 
	C982.026428,611.023743 981.988831,611.014954 981.986450,610.995972 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M970.685730,614.318542 
	C971.119324,613.731262 971.414856,613.319214 971.710327,612.907104 
	C971.899414,613.619385 972.088562,614.331726 972.063354,615.611694 
	C971.561096,615.928528 971.273132,615.677612 970.876526,615.154297 
	C970.767822,614.881836 970.547607,614.493774 970.685730,614.318542 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M987.912109,615.091187 
	C986.927185,614.941040 986.000671,614.718323 985.596375,613.709167 
	C985.566223,613.633972 985.740662,613.384521 985.852112,613.359619 
	C986.786560,613.150024 987.193726,613.917480 987.914856,614.655212 
	C988.086365,614.890808 987.971741,615.025818 987.912109,615.091187 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M974.704895,611.191772 
	C974.234314,610.842590 973.450439,610.674744 974.162903,610.271240 
	C974.491333,610.085205 975.338501,610.352417 975.624023,610.690125 
	C975.881714,610.994873 975.546753,611.508606 974.704895,611.191772 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M972.175476,615.799377 
	C972.905884,616.151550 973.528198,616.630981 974.279907,617.383911 
	C974.409424,617.657410 974.069702,617.946350 973.900391,618.094482 
	C973.227478,617.694092 972.723877,617.145569 972.034607,616.388245 
	C971.848999,616.179443 972.067322,615.926697 972.175476,615.799377 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M970.615723,614.198608 
	C970.823792,614.143250 970.833008,614.515503 970.800415,614.698669 
	C970.767822,614.881836 970.411560,614.997314 970.172485,614.970947 
	C969.978760,614.636902 970.136841,614.406677 970.615723,614.198608 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M970.015320,615.022156 
	C969.909424,615.085205 969.813538,615.895569 969.788086,615.006348 
	C969.933411,614.944580 969.989868,614.994385 970.015320,615.022156 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M972.128601,607.882263 
	C972.393494,607.992310 972.560913,608.198181 972.728394,608.403992 
	C972.507629,608.443848 972.286865,608.483704 971.953979,608.349243 
	C971.841858,608.174927 972.031189,607.978027 972.128601,607.882263 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M992.078369,612.935730 
	C992.260620,613.098083 992.361328,613.338257 992.462097,613.578491 
	C992.325623,613.547485 992.189087,613.516479 991.947266,613.331421 
	C991.841858,613.177429 991.996826,613.013611 992.078369,612.935730 
z"/>
<path fill="#F3E5E1" opacity="1.000000" stroke="none" 
	d="
M240.124786,412.475220 
	C240.150894,412.085327 240.516968,411.934692 240.699692,411.859009 
	C240.816284,412.996368 240.750168,414.209412 240.456451,415.702515 
	C240.185471,414.943451 240.142075,413.904297 240.124786,412.475220 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M123.821709,498.770935 
	C123.854744,498.237213 123.919334,498.076080 124.292343,497.993866 
	C125.045395,497.844543 125.599449,497.535522 126.498528,497.284119 
	C127.577049,497.159760 128.354675,497.381409 129.400986,497.135406 
	C130.012802,496.855774 130.353394,496.670502 130.937866,496.303711 
	C132.827316,495.174347 134.035110,493.664276 135.936279,492.524933 
	C136.681274,492.315826 137.122421,492.319153 137.878479,492.518860 
	C139.990417,494.964539 141.797882,494.405670 143.938110,492.549713 
	C144.738281,492.393402 145.190247,492.472565 145.836945,492.934601 
	C142.275925,498.732788 138.503571,504.251373 134.474365,509.987885 
	C131.038239,512.018677 130.119675,515.183777 129.375458,518.736328 
	C129.279129,519.581360 129.115601,520.103027 128.736755,520.794312 
	C128.313980,521.046082 128.106522,521.128235 127.577087,521.303833 
	C123.919693,521.567749 120.680832,522.362488 117.272949,522.381653 
	C114.191643,522.398926 112.584663,521.785095 112.115692,518.422791 
	C112.156303,517.860962 112.196831,517.640015 112.359467,517.108398 
	C113.176918,515.476135 114.677010,514.771362 115.256874,512.992432 
	C115.421104,512.496704 115.496544,512.301819 115.751625,511.850922 
	C116.896729,510.761078 117.977531,510.280396 119.542191,510.614746 
	C120.058311,510.994385 120.185936,511.303650 119.928329,511.820618 
	C119.732826,511.962982 120.129555,512.232971 120.098297,511.981903 
	C120.183685,511.595337 120.300323,511.459839 120.509888,511.061279 
	C121.348808,508.671387 118.778198,508.190674 118.477737,506.227264 
	C118.489632,505.426300 118.543381,504.969971 118.798271,504.224060 
	C118.984184,503.932739 118.994949,503.997375 118.962509,503.992737 
	C119.523239,503.488007 120.062378,502.932251 120.782364,502.148193 
	C120.968155,501.924988 120.993523,501.989197 120.959923,501.981262 
	C121.944130,501.100494 122.886253,500.155426 123.821709,498.770935 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M138.236481,493.668915 
	C137.437500,493.654449 136.990723,493.617371 136.209793,493.655518 
	C134.942825,492.332306 135.508377,490.981720 136.221237,489.261078 
	C142.459137,484.686768 148.963226,481.970642 156.798859,482.702209 
	C154.454971,487.171112 149.653702,489.043396 146.302429,492.984650 
	C145.612656,493.147888 145.177002,493.081543 144.419952,493.094116 
	C142.334549,494.176056 140.473419,494.048431 138.236481,493.668915 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M157.420105,482.882751 
	C150.160370,483.350464 143.856644,485.759155 137.478897,489.142944 
	C136.148178,490.341431 135.049850,491.129456 133.101456,490.372711 
	C131.877304,488.038788 133.303284,486.926270 134.791916,486.224609 
	C140.488922,483.539368 146.161148,480.645508 153.158020,481.117981 
	C155.543259,480.942383 157.552948,480.932617 160.014786,480.965332 
	C159.555389,481.600372 158.643845,482.192993 157.420105,482.882751 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M129.674133,518.837097 
	C127.248657,514.488464 130.279755,512.274048 133.843658,510.168579 
	C132.780228,513.008728 131.342911,515.811646 129.674133,518.837097 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M154.610092,490.974243 
	C155.260696,492.487579 154.779419,493.394318 152.825974,493.074829 
	C153.168045,492.226227 153.732407,491.619354 154.610092,490.974243 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M140.674774,508.136169 
	C140.816650,508.618256 140.620331,509.301025 140.194000,510.261353 
	C139.607620,509.723572 139.879669,509.014557 140.674774,508.136169 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M126.892227,521.346802 
	C127.369225,521.203979 127.609184,521.215454 128.185287,521.095459 
	C128.306580,521.293518 128.091721,521.623169 127.740555,522.224670 
	C127.604233,522.496521 127.276466,522.247253 127.124405,522.108459 
	C126.866623,521.813477 126.760910,521.657349 126.892227,521.346802 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M153.145782,480.939026 
	C146.264847,483.582184 138.625351,485.246216 131.542358,489.495636 
	C131.999603,490.764893 130.895309,490.369629 130.253998,490.520691 
	C129.798782,490.598450 129.663803,490.716858 129.274399,490.923706 
	C124.671669,492.744568 120.534378,495.293823 115.531036,494.486084 
	C111.782387,493.880890 111.484932,493.152466 113.644905,489.156647 
	C124.264748,482.456116 134.633652,475.679535 148.285004,480.200134 
	C149.559082,480.524292 150.462036,480.510559 151.683167,480.637207 
	C152.258469,480.791260 152.508224,480.858582 153.145782,480.939026 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M97.285500,496.731293 
	C97.107063,496.452362 97.293007,496.124908 97.478966,495.797485 
	C97.036469,496.073273 96.593964,496.349060 95.830513,496.622070 
	C95.284714,496.659180 95.059860,496.699097 94.568466,496.525635 
	C93.995758,495.975677 93.721535,495.615051 93.329308,494.925598 
	C92.751923,493.570312 92.438042,492.488342 92.363800,491.006592 
	C95.347130,486.122162 100.467598,484.776550 105.088234,482.115479 
	C105.565895,481.872589 105.755196,481.779938 106.225708,481.559570 
	C106.871925,481.275787 107.238098,481.122528 107.859261,480.850128 
	C108.278633,480.646484 108.444366,480.565186 108.855606,480.363800 
	C109.424492,480.086517 109.748444,479.930573 110.309830,479.654541 
	C110.710716,479.466675 110.874840,479.400330 111.299835,479.291931 
	C111.725159,479.310608 111.889618,479.371277 112.160141,479.672546 
	C115.923439,478.843475 119.552177,477.571960 123.780441,478.572235 
	C124.422714,479.259888 124.540627,479.757538 124.221283,480.632233 
	C117.773804,484.117737 111.551903,487.276337 105.151154,490.733948 
	C104.086899,491.849274 103.735458,493.095978 102.443008,494.040222 
	C100.695244,495.147644 99.292999,496.139679 97.285500,496.731293 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M78.950691,489.951660 
	C81.630020,490.955414 82.916344,488.508118 84.526215,487.359283 
	C91.639931,482.282745 99.347153,478.863953 108.429993,477.648682 
	C109.247726,477.432312 109.696014,477.396484 110.350220,477.263336 
	C110.995850,477.217621 111.306831,477.438843 111.467224,478.167328 
	C111.393013,478.668213 111.319374,478.859558 111.011703,479.247437 
	C110.286781,479.800201 109.818947,480.183716 109.181244,480.829987 
	C108.970627,481.044525 109.027405,481.019806 109.044571,480.994019 
	C108.596664,481.401642 107.978775,481.472565 107.178764,481.856812 
	C106.945862,482.049652 107.014046,482.031464 107.040009,482.007568 
	C97.668663,485.708313 89.043671,490.950684 80.191879,495.739685 
	C78.447739,496.683350 76.857674,497.883942 74.523453,498.444061 
	C73.683243,498.720795 73.184052,498.719971 72.348373,498.425232 
	C71.339058,497.182800 71.843857,496.334869 72.777786,495.245056 
	C73.038910,494.972107 72.972244,494.965393 72.962845,494.997559 
	C73.408463,494.593872 74.017532,494.526886 74.821487,494.173950 
	C75.062263,493.997864 74.990273,493.988770 74.983688,494.024445 
	C75.207123,493.810486 75.443275,493.566742 75.869949,493.153534 
	C76.055275,492.979034 75.989883,492.985077 75.991745,493.017883 
	C76.841469,492.145355 77.735054,491.285126 78.819687,490.177979 
	C79.034073,489.954071 78.976517,489.936096 78.950691,489.951660 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M113.448029,488.815857 
	C115.556641,490.772949 112.051453,491.215515 112.738152,492.990112 
	C118.218880,494.873871 123.137604,492.090912 128.634766,490.895569 
	C128.012115,493.585938 124.957397,492.791016 123.108398,494.640564 
	C122.661301,495.585815 122.030289,495.565155 121.235374,495.838715 
	C120.997284,496.010315 120.999107,496.000488 121.004555,495.999939 
	C118.900108,495.941467 116.988480,495.946808 115.554367,498.130646 
	C114.773125,499.320343 113.549660,500.589813 111.624557,500.628113 
	C110.711449,500.646271 109.893837,502.434052 108.775009,500.988617 
	C107.622795,499.500092 109.389412,499.149109 109.932999,498.305756 
	C110.385124,497.604248 111.958801,497.302063 111.061356,496.158447 
	C110.747116,495.758026 109.542076,496.056732 108.386017,496.037109 
	C107.770699,495.744690 107.583229,495.412842 107.459366,494.748047 
	C107.609116,493.875854 108.016388,493.495453 108.769638,493.086548 
	C109.188400,492.908844 109.355042,492.839508 109.760315,492.648468 
	C110.188255,492.385345 110.282936,492.314667 110.282936,492.314667 
	C110.374054,492.236847 110.266739,492.287445 109.698006,492.513184 
	C109.271904,492.487305 109.108833,492.414856 108.819672,492.106293 
	C109.833801,490.373993 111.117561,489.083435 113.448029,488.815857 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M101.771240,493.286987 
	C102.781113,492.304474 103.577278,491.710876 104.672882,491.075073 
	C105.201241,491.596375 105.430176,492.159821 105.926559,492.885284 
	C106.228531,493.234497 106.263054,493.421692 106.047577,493.746826 
	C105.511024,494.299469 105.224495,494.714142 104.957321,495.393921 
	C104.547569,496.541809 103.866463,497.102692 102.551086,497.236420 
	C102.209114,497.182648 102.099113,497.086517 102.044281,497.038239 
	C101.151054,495.975769 101.018646,494.869568 101.771240,493.286987 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M124.342056,480.934753 
	C124.023682,480.482330 124.051659,480.005554 124.086411,479.170532 
	C125.840034,478.580597 127.517403,477.514587 129.536575,478.452148 
	C127.846611,479.309021 126.267502,480.109711 124.342056,480.934753 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M105.895866,494.199219 
	C105.797585,493.884796 106.009926,493.472748 106.101967,493.260010 
	C106.844925,492.691071 107.495842,492.334839 108.420174,491.924377 
	C108.912788,491.913147 109.131981,491.956085 109.682922,492.045898 
	C110.106750,492.246399 110.198837,492.400024 110.137360,492.774048 
	C109.983795,492.994446 110.000687,493.001343 109.998886,492.992554 
	C109.581200,493.409760 109.016335,493.472412 108.260368,493.776550 
	C108.034317,494.411713 108.028336,494.876068 108.025276,495.689240 
	C107.350189,495.529907 106.672173,495.021790 105.895866,494.199219 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M111.190231,479.212830 
	C110.849052,478.538544 110.837852,478.133972 110.691406,477.447693 
	C112.210556,476.955902 113.988358,476.643219 112.269836,479.572937 
	C112.266212,479.913147 112.229027,479.866730 112.244713,479.885986 
	C112.013680,479.764343 111.766953,479.623474 111.190231,479.212830 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M151.737244,480.503296 
	C151.107025,480.661865 150.205368,480.599731 149.004028,480.362000 
	C149.624832,480.218445 150.545303,480.250519 151.737244,480.503296 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M72.706268,494.906921 
	C74.126472,496.488525 72.202881,496.468719 71.599396,497.542419 
	C71.136055,498.214386 70.825356,498.461761 70.099274,498.588135 
	C69.592918,498.513458 69.399239,498.436371 69.029221,498.101013 
	C70.026474,496.842438 71.200058,495.842102 72.706268,494.906921 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M78.663849,489.980865 
	C79.857780,492.155396 77.687042,492.180725 76.370537,493.075684 
	C75.201836,490.858398 77.446121,490.960907 78.663849,489.980865 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M66.515686,499.886719 
	C67.095749,499.014374 67.688164,498.505280 68.566727,497.919495 
	C68.970329,497.969177 69.087776,498.095581 69.381271,498.411743 
	C69.572701,499.734039 68.984337,500.368866 67.546715,500.581360 
	C66.966087,500.457397 66.747063,500.353699 66.515686,499.886719 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M74.786499,493.693420 
	C74.543724,494.532135 74.025185,495.066437 73.230042,495.315186 
	C73.004150,494.038208 73.848305,493.799805 74.786499,493.693420 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M65.716911,500.448975 
	C65.708359,499.944214 65.900223,499.772461 66.319031,499.585876 
	C66.503342,499.523438 66.858681,499.868347 67.033035,500.044189 
	C67.219917,500.600220 67.080673,500.912842 66.522972,501.210632 
	C66.129028,501.087036 66.001869,500.910706 65.716911,500.448975 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M75.640381,492.794678 
	C75.905174,493.328400 75.755066,493.677795 75.291031,494.043640 
	C74.496094,493.480255 74.576988,492.996674 75.640381,492.794678 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M161.405060,501.857361 
	C161.064240,501.032898 160.247726,500.684784 159.191620,500.149902 
	C158.762756,499.807800 158.625610,499.601746 158.776855,499.161804 
	C159.065247,498.927979 159.138840,498.724060 159.090393,498.627106 
	C159.571747,497.447205 160.156662,496.410522 161.635406,495.968536 
	C161.972382,496.095978 161.956451,496.037628 161.931915,496.058167 
	C162.244232,496.893707 162.581070,497.708771 162.944305,498.860718 
	C162.518402,500.021088 162.066101,500.844513 161.405060,501.857361 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M161.976196,495.773346 
	C161.205063,496.830658 160.437744,497.565338 159.356171,498.415070 
	C158.827057,497.122986 159.504761,496.078308 160.598846,494.898468 
	C160.949356,494.541107 161.123428,494.416412 161.611847,494.227966 
	C161.944138,494.593079 161.962067,495.021881 161.976196,495.773346 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M158.772171,498.955017 
	C159.040756,499.109375 159.016251,499.290771 158.945831,499.743042 
	C158.503113,500.003326 158.106339,499.992767 157.415329,499.950867 
	C157.573761,499.607025 158.026428,499.294525 158.772171,498.955017 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M205.241089,471.980835 
	C205.286118,471.781281 205.572342,471.716705 205.938354,471.815979 
	C205.839523,472.025146 205.660904,472.070496 205.241089,471.980835 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M66.113419,501.495239 
	C66.599525,501.183075 66.863487,500.992737 67.127731,500.456177 
	C67.842369,499.802582 68.477341,499.385132 69.334824,498.784607 
	C69.982040,498.351562 70.406754,498.101685 71.079552,497.837830 
	C71.928276,497.904480 72.528923,497.985138 73.584091,498.044556 
	C74.388214,498.395538 74.529953,498.834808 74.331558,499.682159 
	C74.013916,500.324921 73.828522,500.626648 73.381454,501.005310 
	C72.718300,501.320129 72.296326,501.513275 71.522034,501.776611 
	C69.033867,502.171204 68.077843,505.002960 65.234680,504.390472 
	C64.787689,504.030548 64.675568,503.814545 64.745102,503.281830 
	C65.274719,502.552490 65.622681,502.139832 66.113419,501.495239 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M58.743855,511.033081 
	C59.017658,512.961243 57.435982,513.975952 56.347183,515.286499 
	C54.325272,517.720154 53.312790,516.455078 52.283203,514.091919 
	C51.872181,513.791809 51.768768,513.623901 51.810726,513.198425 
	C51.956093,512.940796 52.004139,512.978882 51.973503,512.979675 
	C52.215763,512.790527 52.462555,512.571228 52.834892,512.126221 
	C52.986542,511.929932 52.980637,511.997345 52.951874,511.979523 
	C53.839409,511.273865 55.022099,511.057220 56.185860,510.111572 
	C57.014217,510.531952 57.519241,511.172424 58.743855,511.033081 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M62.945957,508.787415 
	C62.272778,509.005798 61.905437,509.072632 61.263069,509.084259 
	C61.733276,507.745819 62.478523,506.462555 63.460442,504.961700 
	C63.904724,504.839722 64.112335,504.935303 64.454910,505.347107 
	C64.760262,506.931610 64.219437,507.879822 62.945957,508.787415 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M56.126106,509.782166 
	C55.975945,511.205444 55.213181,512.124939 53.304054,511.986755 
	C52.923107,511.961700 53.003529,511.522919 53.051052,511.305176 
	C53.989288,510.600067 54.880001,510.112732 56.126106,509.782166 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M60.753670,509.106934 
	C61.023499,509.972076 60.830097,510.837402 59.317650,511.052856 
	C59.473042,510.435577 59.976128,509.833038 60.753670,509.106934 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M61.261955,505.170593 
	C61.188103,504.749298 61.353962,504.078369 61.793961,503.188416 
	C61.879284,503.619904 61.690475,504.270416 61.261955,505.170593 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M64.693985,503.118713 
	C64.936478,503.282013 64.946213,503.598846 64.983459,504.390411 
	C65.010963,504.865112 64.915253,505.248688 64.788841,505.400635 
	C64.502075,505.417938 64.341721,505.283264 63.939240,504.946350 
	C63.951824,504.253510 64.206535,503.762878 64.693985,503.118713 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M62.302948,503.076263 
	C62.168873,502.738403 62.331318,502.399475 62.782715,502.036255 
	C62.914268,502.366394 62.756870,502.720764 62.302948,503.076263 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M993.363281,179.997070 
	C992.998474,179.251511 992.999329,178.500137 992.998901,177.373032 
	C995.051147,177.117508 996.149170,174.702835 998.637573,175.003098 
	C998.388245,177.869858 996.715210,179.623962 993.363281,179.997070 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M976.263916,179.163269 
	C977.152161,177.996399 978.033691,177.892502 978.616943,178.947189 
	C978.818909,179.312347 978.546387,180.334122 978.192627,180.537399 
	C977.184570,181.116638 976.416565,180.697235 976.263916,179.163269 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M972.007324,177.008240 
	C971.923218,177.650238 971.903809,178.362946 971.088196,178.491989 
	C970.913269,178.519669 970.677185,178.160675 970.469299,177.979813 
	C970.787109,177.673752 971.104919,177.367676 971.703979,177.023392 
	C971.985352,176.985184 972.000000,177.000351 972.007324,177.008240 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M891.959290,169.380127 
	C892.110291,156.454849 891.730469,144.013290 890.912598,131.101700 
	C893.068176,129.157089 894.348877,131.550781 896.025635,132.166092 
	C904.536621,135.289490 912.954712,138.667633 921.389648,141.996094 
	C922.957825,142.614899 925.202515,142.575165 925.037231,145.596710 
	C924.989563,154.565750 924.861084,163.150589 924.877319,171.735153 
	C924.898865,183.158340 925.033020,194.581329 925.156006,206.467041 
	C925.809387,210.960266 925.378418,215.012238 925.262878,219.487015 
	C925.056885,223.635468 925.028748,227.351028 924.985291,231.527679 
	C921.737671,234.573792 918.911133,233.522522 915.942139,230.793701 
	C911.610596,227.197678 906.143555,227.551666 901.348511,225.060852 
	C899.257996,224.161301 897.845886,223.063202 896.980286,221.345871 
	C895.777710,218.959915 895.504211,216.519104 896.506592,213.993546 
	C892.970093,212.654190 894.242615,209.784012 894.249329,207.218582 
	C894.269958,199.318115 895.845520,191.298523 892.357788,183.294540 
	C892.071655,178.595062 892.040955,174.222839 891.959290,169.380127 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M925.359314,219.625534 
	C925.057007,215.897308 925.028992,211.874710 925.097046,207.390900 
	C925.193115,206.929688 925.524536,206.904099 925.688599,206.888733 
	C925.961060,211.029175 926.335632,215.189636 925.359314,219.625534 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M993.008484,156.011230 
	C992.911865,156.047592 992.805725,156.072601 992.837769,156.039337 
	C992.976013,155.981079 992.998962,155.999878 993.008484,156.011230 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M107.617928,505.234924 
	C109.385262,507.387482 107.710121,507.493378 106.479408,507.939758 
	C105.205635,508.401794 103.753967,508.939880 102.862587,507.704132 
	C101.583534,505.930939 103.568497,504.493469 103.297554,502.039703 
	C105.133690,503.385071 106.251114,504.203827 107.617928,505.234924 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M95.269089,506.982300 
	C96.432411,504.431915 97.919716,501.878845 100.593246,499.948608 
	C101.512978,502.670227 99.524284,504.849823 99.196526,507.537567 
	C98.682625,511.751709 97.306244,504.704437 95.269089,506.982300 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M94.745232,508.758179 
	C95.106453,510.471130 94.897446,511.802216 93.300003,512.861084 
	C92.975296,512.980652 92.931335,512.944275 92.909225,512.926270 
	C92.368500,512.550659 91.834373,512.206726 91.819778,511.250732 
	C91.963943,510.969116 92.000534,510.992828 91.982048,510.985596 
	C92.221443,510.785583 92.458710,510.570129 92.829521,510.147156 
	C92.983673,509.962341 93.003212,509.999634 92.983276,509.992981 
	C93.215469,509.781494 93.458206,509.566071 93.844254,509.150513 
	C93.996964,508.960938 94.000084,509.005371 93.980309,508.995148 
	C94.138962,508.821442 94.317383,508.657928 94.745232,508.758179 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M102.142227,497.479614 
	C102.916588,496.708862 103.624054,496.235077 104.654099,495.710144 
	C105.159828,497.430206 104.222588,498.411316 102.289528,498.966797 
	C101.973412,498.581879 102.024368,498.179230 102.142227,497.479614 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M95.000732,508.673340 
	C94.821793,509.030151 94.648926,509.038391 94.218300,509.015747 
	C94.104851,508.395813 94.249168,507.806671 94.681099,507.073914 
	C94.981415,507.395081 94.994110,507.859924 95.000732,508.673340 
z"/>
<path fill="#AF5D6B" opacity="1.000000" stroke="none" 
	d="
M106.426254,498.335388 
	C106.643608,498.311218 106.719849,498.409973 106.796097,498.508698 
	C106.625778,498.491882 106.455467,498.475067 106.426254,498.335388 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M101.198822,499.891907 
	C101.120499,499.675415 101.291008,499.380585 101.721100,499.012329 
	C101.803009,499.230469 101.625328,499.522003 101.198822,499.891907 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M78.095451,508.247681 
	C76.557251,510.125580 74.376968,511.050598 73.897156,513.674194 
	C73.120674,512.907349 71.751678,516.122253 70.993301,513.321167 
	C70.536942,512.995422 70.088524,513.003967 69.301025,512.993408 
	C68.353958,510.057281 70.951904,508.953369 72.373177,507.320374 
	C75.315712,503.939484 78.567116,500.827484 81.871338,497.325012 
	C82.409767,496.243896 82.874481,495.565308 84.163773,495.532288 
	C84.642067,495.689270 84.812431,495.797913 85.173592,496.435242 
	C85.312210,497.298065 85.237030,497.626495 85.061745,498.124512 
	C85.006050,498.305328 85.157425,498.597839 85.157425,498.597839 
	C85.157425,498.597839 85.402145,498.318848 85.624779,498.165405 
	C88.022911,497.092041 89.799316,495.179504 92.756836,495.465820 
	C93.695259,495.939240 94.250778,496.373383 94.903915,497.212646 
	C93.477333,499.822418 91.877556,502.119629 89.958267,504.368286 
	C89.107872,505.182831 88.485657,505.412781 87.617691,504.382507 
	C87.522705,504.167358 87.560112,503.747253 87.560112,503.747253 
	C87.560112,503.747253 87.164734,503.598511 86.959610,503.708344 
	C85.951385,504.665009 85.826538,506.034760 84.315674,506.685760 
	C83.251457,506.252350 82.499344,505.709717 81.454086,505.155975 
	C80.053413,504.941620 79.733307,505.757446 79.202080,506.791809 
	C79.028648,507.059113 78.997612,507.007507 79.027649,507.005432 
	C78.716003,507.267944 78.426735,507.581573 78.095451,508.247681 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M85.661606,496.041565 
	C84.022102,495.571503 83.345581,496.203979 82.345055,496.890503 
	C79.633904,497.924561 77.216644,498.803986 74.499352,499.853271 
	C74.195099,499.576630 74.190880,499.130066 74.112633,498.353424 
	C82.620399,492.483368 91.664253,487.803497 100.961441,483.601257 
	C102.770836,482.783447 104.637199,482.091644 106.771622,481.662659 
	C102.489700,484.762665 97.913445,487.541718 93.122925,490.579620 
	C91.933952,492.685089 90.306992,493.891937 88.423859,495.294800 
	C87.944031,495.555847 87.745781,495.645813 87.239273,495.834900 
	C86.720795,495.976288 86.510559,496.018555 85.661606,496.041565 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M70.768356,503.190552 
	C70.074593,504.346436 69.384468,505.115509 68.151810,505.729248 
	C67.200699,504.045013 68.205635,503.322144 69.662201,502.593781 
	C70.285400,502.632843 70.528702,502.718292 70.768356,503.190552 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M71.220840,501.093079 
	C71.908600,500.962067 72.257446,500.955841 72.863045,501.015930 
	C72.478104,501.789154 71.836411,502.496063 70.979721,503.390167 
	C70.608200,503.471527 70.451675,503.365723 70.087540,503.067078 
	C69.691383,502.005951 70.181664,501.548401 71.220840,501.093079 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M60.275330,514.893555 
	C60.155605,514.459351 60.320553,513.872314 60.760094,513.125854 
	C60.876457,513.557861 60.718227,514.149292 60.275330,514.893555 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M69.276672,515.469604 
	C69.858192,515.626892 70.106743,516.099854 69.382050,516.800354 
	C69.194107,516.530151 69.192421,516.140686 69.276672,515.469604 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M56.213177,520.130127 
	C55.646893,519.609192 55.864685,518.923035 56.696072,518.132812 
	C56.844330,518.610107 56.646957,519.238953 56.213177,520.130127 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M68.651558,512.926086 
	C68.830841,513.290405 68.685074,513.617188 68.253738,513.953918 
	C68.087624,513.605469 68.207062,513.246948 68.651558,512.926086 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M66.554382,507.055206 
	C66.896622,507.350861 66.733986,507.646820 66.186905,507.752808 
	C65.884804,507.393707 65.967155,507.224640 66.554382,507.055206 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M67.682739,513.884766 
	C67.996811,514.134827 68.032593,514.302185 68.030029,514.723145 
	C67.991669,514.976807 67.549385,515.049805 67.118362,514.866211 
	C66.926376,514.389099 67.165413,514.095520 67.682739,513.884766 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M58.298363,517.052795 
	C58.139400,516.679932 58.282677,516.314209 58.735878,515.975586 
	C58.897404,516.355103 58.749001,516.707458 58.298363,517.052795 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M67.001801,515.008179 
	C66.835739,515.296326 66.565292,515.475586 66.294846,515.654846 
	C66.289314,515.429810 66.283775,515.204712 66.482788,514.831177 
	C66.687332,514.682617 66.897408,514.899231 67.001801,515.008179 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M67.920486,505.945557 
	C67.928513,506.384003 67.742912,506.660370 67.308281,506.995819 
	C67.059242,507.054871 66.811729,506.822083 66.688095,506.705566 
	C66.654259,506.374603 66.744057,506.160126 67.085403,505.704132 
	C67.466927,505.569550 67.596901,505.676544 67.920486,505.945557 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M59.275478,515.997559 
	C59.144650,515.700989 59.288708,515.356384 59.737968,514.997314 
	C59.878902,515.305054 59.714630,515.627197 59.275478,515.997559 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M62.296066,512.063110 
	C62.145317,511.723053 62.296085,511.400330 62.729523,511.043396 
	C62.873985,511.366241 62.735786,511.723358 62.296066,512.063110 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M64.270569,509.966522 
	C63.935047,509.847229 63.867130,509.674927 63.825043,509.226074 
	C63.850864,508.949493 64.211960,508.676819 64.604919,508.837555 
	C64.844635,509.303375 64.691406,509.608459 64.270569,509.966522 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M61.294861,513.066406 
	C61.148930,512.723572 61.321648,512.406311 61.769779,512.040405 
	C61.901299,512.358459 61.757404,512.725220 61.294861,513.066406 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M65.910980,507.918823 
	C65.878769,508.349243 65.696632,508.634918 65.256180,508.959442 
	C64.997871,508.998291 65.002846,509.003174 65.006668,509.007568 
	C64.745262,508.643890 64.734482,508.268433 65.218887,507.685669 
	C65.460068,507.485779 65.761055,507.774078 65.910980,507.918823 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M57.307312,518.067749 
	C57.152878,517.718689 57.311752,517.392029 57.758007,517.029785 
	C57.903801,517.359497 57.762211,517.724792 57.307312,518.067749 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M54.317085,521.975891 
	C54.228676,521.629639 54.442684,521.219849 55.043205,520.895081 
	C55.159645,521.290833 54.889576,521.601624 54.317085,521.975891 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M83.983627,507.150879 
	C83.393753,505.531433 85.543495,505.346313 85.030563,503.884308 
	C84.633308,502.752045 85.265076,502.488037 87.688873,503.002991 
	C88.105186,504.044098 88.032356,504.870209 89.484711,504.281952 
	C92.790237,509.786743 86.391396,510.477142 84.717422,513.849487 
	C84.225266,514.140808 83.984741,514.239136 83.386459,514.182678 
	C80.541519,511.889923 80.541519,511.889923 83.983627,507.150879 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M101.572586,492.973083 
	C101.983208,493.989380 101.981468,495.080658 101.984596,496.580963 
	C100.237801,495.693817 98.861412,501.056641 96.945343,497.026306 
	C96.926582,493.936920 100.006638,494.586731 101.572586,492.973083 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M91.629150,510.920715 
	C92.228844,511.441315 92.493744,511.913483 92.822884,512.646973 
	C92.156319,512.936646 91.425522,512.965149 90.327675,512.994629 
	C89.949203,512.001404 90.353577,511.268372 91.629150,510.920715 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M95.289589,497.348572 
	C94.507309,497.198303 93.937515,496.871338 93.398712,496.052002 
	C93.818855,495.514587 94.199768,495.549713 94.811661,495.840027 
	C95.052094,496.003143 95.354195,496.254089 95.431885,496.436707 
	C95.507072,496.803497 95.504570,496.987701 95.289589,497.348572 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M82.320374,516.927673 
	C81.613136,516.322693 81.857880,515.736755 82.716835,515.097839 
	C82.904015,515.594299 82.766342,516.203735 82.320374,516.927673 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M86.713318,517.095459 
	C86.857224,517.563904 86.713219,518.172302 86.262711,518.893250 
	C86.112602,518.415649 86.269005,517.825562 86.713318,517.095459 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M85.642212,519.010376 
	C85.833961,519.547363 85.681374,520.137817 85.244873,520.875977 
	C85.073265,520.370361 85.185570,519.717102 85.642212,519.010376 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M88.740753,514.039917 
	C89.015587,514.145264 89.034401,514.329102 88.982338,514.781128 
	C88.741814,515.149231 88.572159,515.249329 88.161469,515.178467 
	C88.108536,514.711243 88.296638,514.414856 88.740753,514.039917 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M89.718124,512.990662 
	C89.845116,513.289124 89.689957,513.617432 89.248184,513.974976 
	C89.119705,513.676331 89.277840,513.348450 89.718124,512.990662 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M82.985565,514.281067 
	C83.267944,514.010559 83.507172,513.993103 84.106094,514.009033 
	C84.195190,514.379578 83.924583,514.716736 83.328583,515.049011 
	C82.982925,514.874084 82.962669,514.704102 82.985565,514.281067 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M87.704155,515.954102 
	C87.844131,516.295166 87.691536,516.635254 87.247787,516.993042 
	C87.108292,516.658203 87.259941,516.305603 87.704155,515.954102 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M87.788773,515.260132 
	C87.920441,515.007629 88.416733,515.019714 88.664093,515.034424 
	C88.758415,515.338684 88.605370,515.628113 88.202621,515.958496 
	C87.854309,515.837158 87.755707,515.674927 87.788773,515.260132 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M92.674408,509.951721 
	C92.832283,510.283234 92.680901,510.604126 92.246536,510.951691 
	C92.097420,510.632629 92.231293,510.286865 92.674408,509.951721 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M93.701141,508.963104 
	C93.829239,509.266113 93.661522,509.571320 93.228561,509.931396 
	C93.110657,509.645966 93.257996,509.305634 93.701141,508.963104 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M81.303574,518.036621 
	C81.143524,517.668762 81.273697,517.296692 81.723923,516.963013 
	C81.893906,517.345154 81.743851,517.688721 81.303574,518.036621 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M84.707611,520.929565 
	C84.863861,521.330139 84.715263,521.703857 84.260704,522.037537 
	C84.104088,521.632568 84.253426,521.267700 84.707611,520.929565 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M73.992691,514.011902 
	C74.606415,514.235901 75.917488,512.260193 75.791397,514.383301 
	C75.727005,515.467407 74.505608,516.482849 73.760788,517.598755 
	C72.364227,516.383667 73.463486,515.523804 73.923744,514.298401 
	C74.022400,513.984436 74.000938,514.001099 73.992691,514.011902 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M79.312134,506.974426 
	C79.305634,505.777527 78.462914,504.102173 80.296745,503.407104 
	C80.395004,503.369843 80.779175,504.087006 81.095589,504.798920 
	C80.639160,505.726471 80.117386,506.308105 79.312134,506.974426 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M78.280701,508.370392 
	C78.145126,508.124023 78.282318,507.690521 78.738594,507.130188 
	C78.889610,507.396667 78.721535,507.789948 78.280701,508.370392 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M78.150543,516.860291 
	C77.957443,516.583618 78.179062,516.410583 78.400681,516.237549 
	C78.455551,516.479675 78.510406,516.721802 78.150543,516.860291 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M78.095093,517.113159 
	C78.000664,517.379639 77.788712,517.525146 77.576752,517.670593 
	C77.533676,517.457397 77.490608,517.244141 77.591675,516.893799 
	C77.735825,516.756653 77.977577,516.992065 78.095093,517.113159 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M130.368256,490.526306 
	C130.243942,490.206207 130.554138,489.932404 131.030548,489.694702 
	C132.976883,492.000854 134.466583,489.820251 136.596359,489.315613 
	C136.788712,490.468689 136.456711,491.718811 136.000153,493.349823 
	C134.525803,494.872101 133.175995,496.013458 131.510040,497.208801 
	C131.003967,497.217438 130.814056,497.172028 130.333252,497.074341 
	C129.438660,496.928070 128.838516,496.815155 127.937210,496.568634 
	C127.463737,496.313904 127.295204,496.172791 127.240723,495.722351 
	C127.976006,493.423370 132.169189,493.978119 130.368256,490.526306 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M116.108154,511.959473 
	C115.858719,512.218445 115.789093,512.457886 115.799767,512.582153 
	C115.563988,513.820618 114.696411,514.211792 113.366356,514.497803 
	C112.772438,514.415710 112.544838,514.326843 112.312912,513.871460 
	C113.582947,510.831970 115.053925,508.286133 117.356369,505.901703 
	C117.854591,505.756348 118.089577,505.817078 118.410339,506.230896 
	C118.916618,508.763184 117.683464,510.251251 116.108154,511.959473 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M123.620178,498.591278 
	C124.018829,500.152588 123.498138,501.449860 121.299957,501.924622 
	C120.981842,500.358124 121.916603,499.380554 123.620178,498.591278 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M110.888107,516.769775 
	C110.711792,515.363403 111.246811,514.592224 112.099998,513.681885 
	C112.492485,513.626038 112.676384,513.747009 113.115761,514.077271 
	C113.760117,514.985962 113.680389,515.694885 113.177383,516.689087 
	C112.940529,516.970581 113.002594,516.992310 112.976318,516.972107 
	C112.580803,517.601501 112.187248,518.220642 111.012466,518.052002 
	C110.723457,517.608276 110.745354,517.363281 110.888107,516.769775 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M110.774429,516.688416 
	C110.959457,516.688171 110.909935,516.955139 110.970352,517.614380 
	C112.022079,519.637390 111.181198,520.524719 109.364166,521.073486 
	C108.967560,520.976685 108.682266,520.770447 108.538193,520.668701 
	C109.109375,519.363220 109.824631,518.159424 110.774429,516.688416 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M128.251373,497.370544 
	C127.121292,497.955109 126.225609,497.920074 124.883614,497.946198 
	C125.243828,497.277710 126.050362,496.548126 127.105835,495.615784 
	C127.492203,495.531250 127.629631,495.649445 127.959946,495.959229 
	C128.263809,496.350922 128.374802,496.550934 128.251373,497.370544 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M120.648178,501.955688 
	C120.958878,502.895172 120.772415,503.746674 119.271881,503.967468 
	C119.148308,503.147736 119.383591,502.319336 120.648178,501.955688 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M121.252960,496.101044 
	C121.414253,495.645966 121.831215,495.281616 122.539917,494.881226 
	C122.860153,495.755371 123.011246,496.785980 121.252960,496.101044 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M118.731689,504.074036 
	C118.995529,504.393402 119.006874,504.854034 119.000748,505.659790 
	C118.817680,506.175293 118.652092,506.345703 118.242027,506.256744 
	C117.997559,505.997375 117.813797,505.844666 117.716705,505.770142 
	C117.906143,505.202148 118.192665,504.708740 118.731689,504.074036 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M65.616470,507.303711 
	C65.255264,507.809448 65.050453,508.133118 64.928070,508.734344 
	C64.820801,508.934906 64.631104,508.857910 64.146141,508.865234 
	C63.650162,508.947174 63.449455,508.944824 62.944435,508.940704 
	C63.212845,508.002686 63.785568,507.066376 64.510361,505.841309 
	C64.798141,505.431702 64.911270,505.292480 65.006386,505.000000 
	C66.962784,503.396881 68.914627,501.928680 71.213104,500.714355 
	C71.102242,501.415802 70.644745,501.863342 70.033592,502.592529 
	C69.153816,503.572540 68.427696,504.270874 67.519272,505.215912 
	C67.102310,505.665710 66.907608,505.901794 66.658653,506.379944 
	C66.265602,506.714600 66.001740,506.892090 65.616470,507.303711 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M45.175362,518.548340 
	C46.111645,517.768188 46.936611,517.283508 48.120564,516.889404 
	C47.519760,517.913452 46.559975,518.846863 45.297600,519.913574 
	C45.018017,519.645752 45.041027,519.244751 45.175362,518.548340 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M49.202904,514.705994 
	C49.728344,514.224854 50.092770,514.076477 50.751022,513.959717 
	C50.506516,514.654419 49.968182,515.317627 49.203964,516.225708 
	C48.999352,515.993286 49.020618,515.516052 49.202904,514.705994 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M51.672073,512.995728 
	C51.972435,513.110413 51.988777,513.280090 51.990356,513.704773 
	C51.813633,514.010620 51.651669,514.061523 51.237579,514.076904 
	C51.119656,513.711243 51.253853,513.380920 51.672073,512.995728 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M44.248917,521.277893 
	C44.084824,520.975098 44.209156,520.525269 44.688339,520.027222 
	C44.874573,520.362915 44.705956,520.746948 44.248917,521.277893 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M42.413040,521.502075 
	C42.452492,521.500488 42.390915,521.634766 42.462761,521.653564 
	C42.534607,521.672363 42.493980,521.449524 42.422070,521.438843 
	C42.350159,521.428223 42.373585,521.503662 42.413040,521.502075 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M108.966705,521.454956 
	C110.036942,520.536560 110.436111,519.553955 110.981598,518.308289 
	C111.535027,517.722656 111.989761,517.438721 112.697281,517.053345 
	C113.866928,521.886841 118.429756,523.529663 124.021667,521.082581 
	C124.887604,520.703613 125.672371,518.428284 127.075424,520.887390 
	C127.129257,521.192505 127.046394,521.580200 127.009369,521.774902 
	C121.394135,523.932068 115.540703,522.754639 109.846474,523.427673 
	C109.186974,523.505615 108.892494,522.659363 108.966705,521.454956 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M90.053970,520.061890 
	C90.010071,520.438477 89.829254,520.703186 89.185593,520.869751 
	C88.950096,520.522522 89.166306,520.283325 89.683884,520.016541 
	C89.906326,519.917480 90.007095,520.011414 90.053970,520.061890 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M89.056595,521.071167 
	C88.956894,521.319214 88.778564,521.485291 88.600243,521.651367 
	C88.568192,521.451721 88.536133,521.252136 88.658447,520.942749 
	C88.812820,520.833069 88.977982,520.989197 89.056595,521.071167 
z"/>
<path fill="#D9D0C0" opacity="1.000000" stroke="none" 
	d="
M64.823257,538.004883 
	C65.014160,537.987244 64.901360,538.363220 64.842316,538.549805 
	C64.640327,538.582031 64.497391,538.427795 64.354454,538.273499 
	C64.447083,538.189819 64.539719,538.106201 64.823257,538.004883 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M28.718678,539.854858 
	C28.878317,540.288940 28.691467,540.568542 28.239246,540.953247 
	C28.106644,540.605713 28.239414,540.153015 28.718678,539.854858 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M58.030136,613.711914 
	C57.625465,613.878967 57.254856,613.702087 56.677902,613.287354 
	C57.342300,611.455688 57.710464,612.375671 58.030136,613.711914 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M887.255005,550.885437 
	C883.749817,551.110168 883.380066,547.997070 881.738831,546.362061 
	C879.321899,543.954285 877.202148,541.248169 874.764893,538.376587 
	C875.492676,537.775085 876.411255,537.466187 877.684448,537.063538 
	C881.016052,541.128235 883.993042,545.286743 887.220581,549.707214 
	C887.511169,550.217590 887.551208,550.465942 887.255005,550.885437 
z"/>
<path fill="#6A8194" opacity="1.000000" stroke="none" 
	d="
M91.686546,110.004868 
	C92.010368,110.446274 92.008858,110.892548 92.002510,111.673523 
	C91.460297,111.852417 90.922928,111.696609 90.179428,111.347778 
	C89.981842,110.972183 89.990372,110.789597 90.029556,110.316391 
	C90.493866,110.020432 90.927544,110.015083 91.686546,110.004868 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M63.375195,103.997879 
	C63.082264,102.857994 63.351040,101.677979 64.605515,101.448837 
	C65.962967,101.200890 65.899261,102.402222 65.995102,103.655594 
	C65.999695,104.000305 66.000000,104.000000 66.000153,103.999847 
	C65.249962,103.998032 64.499619,103.996361 63.375195,103.997879 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M53.000908,109.000946 
	C53.087402,108.364601 53.088631,107.643547 53.909542,107.501114 
	C54.082817,107.471046 54.323761,107.831032 54.533524,108.011299 
	C54.210800,108.316299 53.888081,108.621307 53.281723,108.962265 
	C52.998089,108.998215 53.000000,109.000000 53.000908,109.000946 
z"/>
<path fill="#7A92A7" opacity="1.000000" stroke="none" 
	d="
M62.999466,103.999390 
	C62.906990,104.631111 62.909126,105.352844 62.091782,105.495628 
	C61.920029,105.525635 61.680195,105.165894 61.471733,104.985748 
	C61.792912,104.680954 62.114090,104.376160 62.718193,104.036217 
	C63.001114,104.001068 63.000000,104.000000 62.999466,103.999390 
z"/>
<path fill="#8399AA" opacity="1.000000" stroke="none" 
	d="
M90.017395,110.033630 
	C89.903961,109.904762 89.782188,109.750206 89.660423,109.595657 
	C89.749390,109.646202 89.838348,109.696747 89.993759,109.886536 
	C90.060196,110.025780 90.009071,110.007942 90.017395,110.033630 
z"/>
<path fill="#7890A5" opacity="1.000000" stroke="none" 
	d="
M48.342438,96.968307 
	C48.308826,95.901085 48.620464,94.799332 48.971146,93.354126 
	C49.754608,93.007057 50.499023,93.003441 51.615414,93.006226 
	C51.993263,93.759354 51.999134,94.506081 52.002502,95.626404 
	C50.895893,96.311264 49.791790,96.622528 48.342438,96.968307 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M905.155640,494.601013 
	C903.691589,495.212677 902.260986,495.375702 900.845337,495.623993 
	C897.804688,496.157349 896.216614,495.130127 896.541260,491.434753 
	C895.349976,488.962372 896.029419,486.763092 896.025696,484.633423 
	C895.987305,462.806915 896.349121,440.971924 895.824280,419.157959 
	C895.624023,410.835205 896.201172,402.563599 896.058533,393.815613 
	C897.298523,390.244843 899.155945,391.042114 901.041321,392.605560 
	C902.444946,393.769562 903.068115,395.579681 904.630493,397.136230 
	C905.219238,397.817780 905.431763,398.268585 905.535706,399.119720 
	C904.728882,400.829498 905.395935,401.986786 906.157837,403.529480 
	C907.038208,413.271454 906.595459,422.643097 906.535583,432.010620 
	C906.528198,433.168793 906.244263,434.293243 905.329834,435.673798 
	C905.176025,447.198700 905.367065,458.344788 905.310303,469.489624 
	C905.304749,470.583710 905.945435,471.268768 905.905762,472.530823 
	C905.427856,473.928345 905.213196,475.057892 905.264038,476.560242 
	C905.299500,477.358582 905.245972,477.821503 905.161987,478.633270 
	C905.212341,479.145355 905.293030,479.308624 905.337585,479.742676 
	C905.276062,481.055725 905.250732,482.097931 905.297485,483.524353 
	C905.982117,485.654724 905.359375,487.472443 905.544556,489.665527 
	C905.339233,491.460632 905.267578,492.825836 905.155640,494.601013 
z"/>
<path fill="#4B225C" opacity="1.000000" stroke="none" 
	d="
M905.424316,435.997742 
	C904.993347,424.997650 904.932312,413.942352 904.802246,402.419373 
	C904.477661,401.562744 904.365051,401.133942 904.521851,400.362366 
	C904.742981,399.583496 904.818604,399.112885 905.012329,397.988708 
	C908.546265,390.704010 908.006042,384.235168 904.188354,377.552368 
	C903.443420,374.904633 903.437988,372.592194 904.097778,369.920898 
	C905.183472,368.769318 905.765808,367.979706 904.007568,366.861328 
	C902.832825,360.557129 903.413025,354.590027 903.365540,348.647125 
	C903.267822,336.403625 903.320190,324.158783 903.348206,311.914551 
	C903.353882,309.442413 903.194397,306.932648 904.583862,304.241211 
	C905.894714,302.897736 907.244263,302.445007 908.884277,301.707489 
	C909.536255,301.598785 909.803162,301.606415 910.404785,301.833923 
	C909.565308,304.577515 909.936584,307.271545 909.934021,309.907013 
	C909.912292,331.925079 909.864502,353.943481 909.969849,375.961029 
	C909.997070,381.650726 910.716614,387.335205 910.804382,393.026886 
	C910.975098,404.101654 909.251038,415.155884 910.758606,426.269745 
	C911.300781,430.266754 909.817749,433.934723 905.424316,435.997742 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M999.674561,371.075165 
	C1000.094177,371.817596 1000.108704,372.446106 999.788147,373.764343 
	C997.028931,375.977417 994.304932,375.528992 991.672913,375.600281 
	C984.192566,375.802917 976.699036,375.233307 968.782227,376.052002 
	C961.036865,376.676178 953.889038,378.170868 946.733643,379.617371 
	C944.943909,379.979187 943.159851,380.455109 941.007263,379.414185 
	C940.747253,377.800323 940.837646,376.457794 941.155396,374.778259 
	C941.725037,373.325134 942.665527,372.952637 943.649780,372.773285 
	C949.851196,371.643158 956.010254,370.257172 962.283997,369.559143 
	C963.746948,369.396362 965.285645,369.181030 966.791504,370.679810 
	C975.325317,370.727966 983.603516,370.409515 991.883850,370.157776 
	C994.370361,370.082153 996.865967,370.160492 999.674561,371.075165 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M994.582703,408.533020 
	C995.428284,408.888275 995.898804,408.975861 996.718628,409.151001 
	C997.095825,409.853668 997.123596,410.468750 997.143433,411.392822 
	C988.895935,411.861664 980.656372,412.021576 972.055969,412.428955 
	C971.510986,412.955841 971.339600,413.381165 971.080872,413.430847 
	C961.383911,415.293121 951.745544,417.585693 941.427734,417.300293 
	C941.090698,415.698975 941.108826,414.360504 941.221863,412.631378 
	C942.792480,410.254242 945.113708,410.326355 947.187744,409.950378 
	C954.069458,408.702850 960.995117,407.739288 968.396851,407.041260 
	C970.322449,406.778748 971.782532,406.988190 973.682251,407.330627 
	C980.814758,407.845947 987.585938,406.445312 994.582703,408.533020 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M1002.859436,343.835083 
	C989.111450,344.616974 975.175903,343.476929 961.075073,346.404358 
	C959.339233,349.256927 956.352783,347.924011 953.987732,349.200623 
	C952.802795,349.422028 952.016602,349.585999 950.865479,349.980835 
	C947.231567,350.166565 944.082031,352.323395 940.441162,350.250580 
	C940.142456,348.534912 938.791321,346.759308 941.499023,345.765656 
	C948.033325,342.637604 954.541504,341.321869 961.719849,341.752594 
	C964.072693,342.772736 966.109680,341.955322 968.557739,342.045868 
	C970.328125,341.153259 971.796021,341.626648 973.611938,341.715942 
	C975.075012,341.888733 976.135986,341.901703 977.590759,341.853363 
	C978.154419,341.735229 978.324219,341.678345 978.753601,341.690857 
	C980.396606,341.776031 981.780151,341.791840 983.575684,341.754883 
	C984.156616,341.675262 984.325500,341.648407 984.750122,341.640076 
	C990.372437,341.721466 995.739014,341.784271 1001.573975,341.917755 
	C1002.280457,342.513123 1002.518555,343.037811 1002.859436,343.835083 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M941.257996,398.134766 
	C950.665161,396.465698 959.788574,393.874969 969.640930,393.225189 
	C970.364868,394.894928 970.667969,396.539642 970.972534,398.550781 
	C970.345215,399.779694 969.423584,400.170349 968.433044,400.326080 
	C961.396301,401.432343 954.376587,402.663879 947.296204,403.463226 
	C945.492432,403.666870 943.645020,403.594788 941.584839,402.483337 
	C941.221008,400.991608 941.207764,399.787323 941.257996,398.134766 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M970.148499,389.431091 
	C960.495117,389.431946 951.505981,393.108459 941.652161,393.198486 
	C941.142517,392.075073 941.061707,390.935425 941.009949,389.367065 
	C942.815796,386.701172 945.411255,386.187042 947.989075,385.627258 
	C954.238220,384.270264 960.595703,383.466461 967.226624,381.966858 
	C967.909912,382.077271 968.177124,382.156128 968.801575,382.453125 
	C970.600098,384.606537 970.522644,386.818787 970.148499,389.431091 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M941.019470,417.462219 
	C950.989624,415.545990 960.792480,413.278809 971.266357,412.667145 
	C971.817017,414.135742 971.938782,415.594971 972.093506,417.492249 
	C971.732788,418.477478 971.257446,419.044159 970.616333,419.157257 
	C961.228394,420.813934 951.898438,423.135193 941.868469,421.540436 
	C941.325806,420.140717 941.146118,419.013824 941.019470,417.462219 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M969.229980,408.210236 
	C960.094849,409.814270 951.116516,411.027069 941.727417,412.240295 
	C941.222839,410.783691 941.128906,409.326691 941.074158,407.430573 
	C942.869629,405.197083 945.210205,404.917267 947.505493,404.580383 
	C953.575745,403.689514 959.602600,402.493622 966.150391,402.012451 
	C971.729309,404.156219 972.118530,404.954681 969.229980,408.210236 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M940.482544,379.404358 
	C949.373413,377.722321 957.911743,375.291382 967.164673,374.508545 
	C969.505737,375.558685 969.547729,377.387604 969.338989,379.687073 
	C966.805542,381.937988 963.861206,381.979919 961.122437,382.252167 
	C954.697510,382.890747 948.473389,385.054260 941.576477,384.475403 
	C940.915527,382.703644 940.611938,381.184753 940.482544,379.404358 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M939.779419,285.748291 
	C939.992432,286.708221 939.907776,287.454041 939.794373,288.578461 
	C939.472168,289.502167 939.039429,289.899078 938.206604,290.281372 
	C929.872131,294.700348 920.640747,296.127228 912.358765,300.811401 
	C909.570435,297.646423 910.230957,295.099274 914.250488,292.971466 
	C918.200806,290.880341 922.671692,290.227081 927.162720,288.478027 
	C928.002197,288.164642 928.492432,288.029816 929.356384,287.853546 
	C932.686829,287.657257 935.259399,286.163086 938.406433,285.372864 
	C939.008911,285.410797 939.245361,285.472504 939.779419,285.748291 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M941.382935,421.634338 
	C951.431702,420.230743 961.357849,419.193878 971.705200,418.043640 
	C972.293030,418.014954 972.459656,418.099609 972.800659,418.403748 
	C973.812012,419.281952 973.800049,420.112427 973.213013,421.235107 
	C972.558167,421.685181 972.147827,421.909882 971.377747,422.201355 
	C968.370789,424.288513 965.185608,424.197632 962.105957,424.600037 
	C956.737244,425.301544 951.384888,426.126678 945.597046,426.967499 
	C943.984436,427.179199 942.834961,427.118652 941.493347,426.124146 
	C941.214722,424.537903 941.237488,423.269470 941.382935,421.634338 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M966.989502,370.638672 
	C958.558838,370.667175 950.502441,373.418854 941.796204,374.454620 
	C940.719543,373.333008 939.929138,372.252533 940.750061,370.574646 
	C941.590759,369.329926 942.458008,368.478882 943.604248,368.236755 
	C950.797791,366.717224 957.760315,363.862915 965.640564,364.690582 
	C965.899292,366.805939 966.131409,368.583405 966.989502,370.638672 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M967.388184,403.299683 
	C958.664856,404.444580 950.296814,405.735657 941.521057,407.009094 
	C941.111145,405.657257 941.109009,404.323059 941.170532,402.592346 
	C950.992432,402.357941 960.408447,399.405121 970.540405,398.970306 
	C971.120117,399.048920 971.266357,399.180634 971.621826,399.520477 
	C972.876892,400.431946 972.886353,401.432190 972.430054,402.847412 
	C972.012207,403.324310 971.791870,403.463043 971.190796,403.682434 
	C969.795471,403.583801 968.775330,403.458191 967.388184,403.299683 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M941.426147,365.351715 
	C941.100952,363.540710 939.691223,362.244537 940.441406,360.322937 
	C947.623108,356.471466 955.117981,355.124146 963.305786,355.170868 
	C964.828735,355.951385 965.359192,356.991821 965.800171,358.586761 
	C965.869019,359.626007 965.748718,360.199493 965.233643,361.088593 
	C957.376648,363.635345 949.812439,365.947021 941.426147,365.351715 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M972.857422,427.867126 
	C973.003235,428.789948 972.996765,429.447937 973.009216,430.434204 
	C972.705261,432.277954 971.560425,433.041656 970.221741,433.155029 
	C961.566650,433.887878 952.992065,435.270691 944.367249,436.237732 
	C943.723450,436.309906 943.087402,435.978271 942.146606,435.383057 
	C941.847290,433.999146 941.894836,432.916809 941.992432,431.431122 
	C942.247070,430.809875 942.451782,430.591980 943.050354,430.160950 
	C952.693237,428.369720 961.892456,426.320862 971.806946,427.102417 
	C972.391296,427.342529 972.548157,427.472412 972.857422,427.867126 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M962.046753,341.566772 
	C955.610413,343.255707 949.152588,344.517700 942.294067,345.727600 
	C941.854614,344.017792 939.481873,343.310303 940.235962,341.021667 
	C947.295837,339.158173 954.259644,337.641876 961.614136,336.073517 
	C962.011597,337.727600 962.018433,339.433716 962.046753,341.566772 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M940.952637,365.520020 
	C948.887573,364.438721 956.294983,361.424469 964.594238,361.159790 
	C965.653198,360.992249 966.285522,361.005707 967.201050,361.342468 
	C969.039001,363.138092 967.487488,363.630280 966.143799,364.450073 
	C965.855530,364.591644 965.921753,364.779327 965.942871,364.876709 
	C957.776367,366.236298 949.677002,367.905609 941.310669,370.264038 
	C940.875122,368.843689 940.849121,367.391266 940.952637,365.520020 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M941.116699,384.608398 
	C950.128601,382.714783 958.893921,380.174835 968.479309,380.407166 
	C969.018921,380.488037 969.135132,380.638489 969.232300,381.074036 
	C969.041504,381.917755 968.702087,382.366852 968.117126,382.991364 
	C959.339661,385.618408 950.248901,385.739166 941.411621,388.866455 
	C941.030701,387.623688 941.022400,386.308990 941.116699,384.608398 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M941.515564,435.200500 
	C951.980408,433.809204 962.161011,432.536926 972.684875,431.013550 
	C973.028137,430.762512 972.981628,430.993439 972.963745,431.109863 
	C974.444580,432.713776 974.422668,434.465851 973.608276,436.705994 
	C970.845947,438.918579 967.915039,438.699982 964.644897,438.563843 
	C964.130371,436.009460 964.130371,436.009460 966.843201,435.681641 
	C959.243469,436.828613 951.399658,436.693237 944.020264,440.550659 
	C942.216797,442.078827 941.028137,441.499756 939.840637,439.739716 
	C939.588257,439.182373 939.510193,438.950012 939.364502,438.356323 
	C938.898865,436.349091 940.294861,436.000427 941.515564,435.200500 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M964.305847,355.880798 
	C956.262207,356.334564 948.865356,358.311584 941.055786,360.191650 
	C940.737427,358.660400 940.838379,357.259766 941.081177,355.463257 
	C946.157837,352.362885 951.726379,352.548370 957.448730,351.568665 
	C958.387634,351.493011 958.912903,351.391357 959.824585,351.171631 
	C961.308777,351.007629 962.302612,351.534058 963.691162,351.807129 
	C964.171997,352.124847 964.330017,352.211395 964.741638,352.391479 
	C966.650940,352.535736 968.026917,352.756866 966.146057,355.030640 
	C965.502014,355.519287 965.091675,355.725433 964.305847,355.880798 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M963.793701,351.765503 
	C962.961487,352.140411 961.908997,352.242554 960.465820,352.410767 
	C960.075195,352.476807 959.610413,352.434113 959.610413,352.434113 
	C959.610413,352.434113 959.207458,352.669739 958.976440,352.706360 
	C953.182373,353.544189 947.619324,354.345367 941.639648,355.106964 
	C939.581909,353.974640 940.136902,352.291290 940.095459,350.379822 
	C943.518188,350.269196 946.711548,349.039551 950.430298,348.602905 
	C952.401733,349.403870 953.924622,350.395935 955.767212,349.928497 
	C954.698242,349.924774 953.559509,349.887146 952.959717,348.379578 
	C955.325073,347.552185 957.624390,347.051544 960.316345,346.558350 
	C961.294250,348.422913 961.758118,350.350647 963.793701,351.765503 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M955.874146,304.722229 
	C951.689758,305.809082 947.341370,306.553253 942.581482,307.330383 
	C941.555176,307.140320 940.916504,306.968658 940.225952,306.257568 
	C940.017273,305.534454 939.981567,305.090942 939.983521,304.315826 
	C943.604370,299.175232 949.006653,298.877960 954.629395,298.417114 
	C954.987793,298.595367 954.928467,298.889526 954.963989,299.035278 
	C955.001404,300.946014 954.721008,302.749573 955.874146,304.722229 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M954.945068,298.303833 
	C950.202515,300.259888 945.079285,300.994171 940.361938,303.884094 
	C939.970886,303.541595 939.920593,303.098999 939.809937,302.327942 
	C939.707031,301.828827 939.664551,301.658173 939.716919,301.241333 
	C939.907471,300.261444 940.003235,299.527710 940.118103,298.423950 
	C944.785339,297.395233 949.433533,296.736572 954.489380,296.162231 
	C954.898804,296.835175 954.900574,297.423737 954.945068,298.303833 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M938.286743,290.580505 
	C938.375488,289.945068 938.820129,289.491150 939.515137,288.997131 
	C942.985901,291.729462 944.501099,287.454651 947.016907,287.168396 
	C948.860535,286.958618 951.048462,284.411530 951.988159,288.641052 
	C948.301392,291.191681 943.942322,292.251526 940.466309,295.432434 
	C939.998047,294.015900 940.552734,291.957428 938.286743,290.580505 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M938.922363,438.111511 
	C939.296814,437.994934 939.780518,438.038788 940.020386,438.076416 
	C940.395996,439.831299 941.111389,441.511780 940.300842,443.602966 
	C938.167664,443.905090 936.320374,443.875092 934.188538,444.124512 
	C933.736633,444.721741 933.569336,445.039551 933.061401,444.939941 
	C932.720764,444.522583 932.392944,444.381042 932.245239,444.481689 
	C931.524719,444.494446 930.951965,444.406494 930.163330,443.939697 
	C929.947449,443.560852 929.968262,443.558899 929.996155,443.556030 
	C929.676941,442.816254 929.169861,442.197998 928.375549,441.423889 
	C928.467773,439.109283 930.078186,440.064636 931.615723,439.962891 
	C932.008972,440.006500 932.100647,440.057404 932.054321,440.035889 
	C931.920471,438.676727 932.631287,438.110046 933.797974,438.587830 
	C935.495117,439.282806 937.013245,438.976959 938.922363,438.111511 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M929.194946,289.215240 
	C924.799683,291.008789 920.287476,292.514221 915.701843,293.746368 
	C912.112549,294.710785 910.901611,296.857574 911.847534,300.637604 
	C911.779663,301.223694 911.532898,301.520447 911.012878,301.935486 
	C910.514587,302.049591 910.289490,302.045380 909.726929,302.032196 
	C908.594482,300.824188 908.690002,299.462463 908.690430,297.719391 
	C908.833984,295.698364 909.346008,294.187775 910.222351,292.381714 
	C910.613281,291.851776 910.796875,291.662018 911.309204,291.255554 
	C913.286682,290.262909 915.032715,289.862823 917.214844,289.653412 
	C919.150208,289.558075 920.469299,288.752136 922.260315,288.118042 
	C924.269958,287.615967 925.900452,287.592468 927.927979,288.174438 
	C928.567078,288.489349 928.806763,288.649353 929.194946,289.215240 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M925.001465,444.567322 
	C924.519104,445.242828 924.001404,445.507324 923.228149,445.911072 
	C922.485657,446.014862 921.998718,445.979462 921.158691,445.845337 
	C921.436157,444.118378 919.904236,441.378357 923.108032,441.079193 
	C925.705750,440.836639 924.898804,442.793060 925.001465,444.567322 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M943.354309,430.665009 
	C943.016907,430.831421 942.535095,430.955902 942.288757,430.991821 
	C940.532104,429.813202 941.098999,428.140869 941.129333,426.203430 
	C942.198425,425.826080 943.204834,425.845886 944.593201,425.864014 
	C945.842834,427.766418 945.220825,429.258057 943.354309,430.665009 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M905.688721,490.005493 
	C905.322021,488.322052 905.233093,486.548676 905.256836,484.341919 
	C907.857666,485.683441 906.067627,487.883392 905.688721,490.005493 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M939.760620,306.247681 
	C940.647827,306.242584 941.242676,306.507233 942.003784,307.067627 
	C941.375366,307.989288 940.580811,308.615143 939.548096,309.445007 
	C939.079285,308.590820 938.881714,307.534302 939.760620,306.247681 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M905.574951,476.625671 
	C903.530762,475.665771 905.531799,474.388092 905.597168,472.994507 
	C905.857910,474.019073 905.827454,475.187347 905.574951,476.625671 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M920.486816,314.785187 
	C919.992920,315.614624 919.522217,316.114014 918.856079,315.735870 
	C918.630127,315.607544 918.499390,314.846191 918.662476,314.583405 
	C919.202820,313.712677 919.928345,313.889191 920.486816,314.785187 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M928.173950,441.635284 
	C929.520142,440.883240 929.940247,441.603943 929.976746,443.179688 
	C928.078552,444.681793 928.250000,443.227448 928.173950,441.635284 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M925.084351,437.724182 
	C924.396851,437.880951 923.482422,438.242218 923.764587,437.317383 
	C923.913757,436.828552 924.836670,436.894165 925.084351,437.724182 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M931.415894,345.311523 
	C932.213501,345.114197 933.143982,345.028748 932.602783,345.929962 
	C932.125061,346.725677 931.596252,345.949219 931.415894,345.311523 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M921.690735,438.420166 
	C921.798279,438.533264 921.439331,438.604401 921.439331,438.604401 
	C921.439331,438.604401 921.583191,438.307098 921.690735,438.420166 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M905.424805,479.895569 
	C905.182983,479.856445 905.064575,479.699402 905.038879,479.262238 
	C905.270447,479.247314 905.409302,479.512482 905.424805,479.895569 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M939.671021,301.088257 
	C939.844788,301.165192 939.877869,301.335236 939.830139,301.752411 
	C939.623352,301.825226 939.476074,301.661133 939.383911,301.470428 
	C939.355469,301.411407 939.477295,301.279785 939.671021,301.088257 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M933.589233,348.364563 
	C933.645203,348.464386 933.431519,348.530365 933.431519,348.530365 
	C933.431519,348.530365 933.533264,348.264771 933.589233,348.364563 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M940.249756,444.081543 
	C940.070984,442.275909 940.127014,440.616730 940.221680,438.535828 
	C941.591492,438.673737 940.052185,441.179474 942.635742,441.017578 
	C949.473877,438.158600 956.209839,436.720978 963.679077,437.505493 
	C966.736206,437.567139 969.417236,437.403748 972.514648,437.245789 
	C981.979065,436.198883 991.002014,434.271576 1000.442749,436.819275 
	C1000.741821,437.170776 1000.940552,437.529144 1001.043274,437.706299 
	C1000.171692,437.945282 999.197754,438.015381 998.222961,438.067444 
	C995.299316,438.223572 997.688599,439.290680 997.942749,440.266907 
	C997.993164,440.550934 998.034668,440.866730 998.028992,441.025879 
	C994.626953,443.324585 990.913452,442.451477 987.312988,442.185272 
	C984.821716,442.001068 982.359985,441.503845 979.451416,442.151245 
	C978.758728,442.260742 978.480408,442.296387 977.782776,442.358429 
	C976.805359,442.426788 976.246582,442.441681 975.269653,442.420380 
	C974.294067,442.410126 973.736084,442.416016 972.758301,442.460297 
	C962.176636,443.543610 952.132629,445.747467 941.500977,445.359894 
	C940.930115,444.815186 940.707336,444.521576 940.249756,444.081543 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M941.145020,445.525085 
	C951.428284,443.314178 961.778015,442.113312 972.589294,441.244263 
	C974.550110,442.845398 974.414246,444.654144 973.440552,446.921692 
	C962.903442,449.937378 952.501465,451.342834 941.531738,450.373688 
	C941.170532,448.697601 941.153870,447.319458 941.145020,445.525085 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M941.349426,458.367828 
	C941.212097,457.536743 941.203979,457.100128 941.212708,456.336426 
	C941.567993,455.241241 941.440491,454.315643 942.378784,453.382996 
	C951.606323,451.089355 960.575867,449.772156 970.135803,449.973450 
	C973.500549,451.743408 974.385742,453.729706 971.208984,456.543579 
	C962.158020,458.622040 953.265259,459.070557 944.140747,460.761353 
	C942.471680,460.663391 941.626709,460.101746 941.349426,458.367828 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M971.282593,451.246643 
	C961.502625,450.897125 952.251160,453.098938 942.436951,454.011627 
	C941.831787,454.200073 941.652832,454.368103 941.279175,454.223572 
	C941.063843,452.879089 941.043213,451.847198 941.104919,450.445496 
	C951.489502,449.100159 961.791687,448.124573 972.524048,447.058655 
	C973.404541,447.040619 973.798096,447.233734 974.341003,447.802673 
	C974.812683,448.720490 974.872864,449.388306 974.666504,450.400360 
	C974.426514,450.910004 974.291870,451.094299 973.859131,451.446747 
	C972.871643,451.819519 972.214905,451.663879 971.282593,451.246643 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M941.108521,458.429749 
	C941.662292,458.600769 942.104370,459.228180 942.814087,459.972168 
	C943.689392,460.583557 943.888794,461.270325 943.991821,462.358826 
	C943.832764,464.253571 943.277771,465.766510 943.724121,467.663055 
	C945.456421,471.475861 948.189819,469.010101 950.800415,469.159088 
	C951.901062,469.202057 952.563232,469.457092 953.253174,470.345795 
	C953.398987,470.937042 953.387024,471.187592 953.155762,471.743958 
	C949.031616,471.794739 945.352844,472.713409 941.397705,474.302032 
	C941.006958,469.231812 941.001953,464.058990 941.108521,458.429749 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M941.040161,454.265472 
	C941.084412,453.911011 941.562622,453.856995 941.786682,453.944519 
	C941.867004,454.553406 941.723267,455.074768 941.404541,455.802765 
	C941.151672,455.546234 941.073792,455.083069 941.040161,454.265472 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M932.865845,444.747803 
	C932.913635,444.458496 933.106506,444.394409 933.601685,444.367157 
	C933.708130,444.753510 933.804443,445.561462 932.865845,444.747803 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M953.135437,472.315186 
	C952.948608,471.865784 952.960693,471.681824 952.980042,471.221436 
	C954.795471,468.937836 957.179932,468.775421 960.034851,468.910736 
	C961.689087,469.226837 962.952881,469.405426 964.617554,468.912231 
	C967.517578,468.524689 970.026428,468.190582 972.720215,469.700317 
	C974.082825,471.523560 970.499573,472.708252 972.849609,474.555176 
	C968.601013,475.180725 964.128235,474.451630 959.403992,475.833130 
	C957.122681,474.842285 955.228455,473.711456 953.135437,472.315186 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M948.380737,491.133972 
	C945.950012,490.586060 946.768250,488.468781 945.540039,486.003204 
	C948.174805,487.601654 948.806335,488.977173 948.380737,491.133972 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M953.713684,483.171753 
	C953.946533,484.310333 953.770874,485.487671 953.329712,486.904205 
	C952.871277,487.210297 952.678284,487.277191 952.263672,487.132324 
	C951.749329,485.440918 953.003601,484.487854 953.713684,483.171753 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M953.895020,482.872803 
	C954.219055,482.282867 954.837097,481.887848 955.274963,482.408875 
	C955.707458,482.923584 954.953552,482.916138 954.381409,483.096100 
	C954.122253,483.133026 953.969849,482.960327 953.895020,482.872803 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M952.102905,487.101868 
	C952.209839,486.969360 952.377563,487.018066 952.804810,487.105103 
	C952.764160,487.190002 952.463928,487.236542 952.102905,487.101868 
z"/>
<path fill="#311835" opacity="1.000000" stroke="none" 
	d="
M897.100159,391.795959 
	C896.809998,418.923615 896.832947,445.806091 896.827271,472.688538 
	C896.826050,478.496582 896.721802,484.304626 896.549561,490.571991 
	C896.055359,491.019440 895.676636,491.007568 895.012573,490.988678 
	C894.690552,469.019562 894.659302,447.057495 894.611206,425.095398 
	C894.603516,421.602020 894.520020,418.108856 894.355530,414.185486 
	C895.268860,400.951538 894.107544,388.143250 894.316528,375.338348 
	C894.591187,358.514252 895.033264,341.690521 894.031372,324.416626 
	C892.841370,322.631653 893.083923,320.928680 892.573120,318.942688 
	C891.407227,312.220978 891.271912,305.923218 891.291382,299.599609 
	C891.350098,280.496124 891.286926,261.392303 891.338135,242.288757 
	C891.345581,239.514008 890.864258,236.587997 893.302246,233.982330 
	C895.922180,235.503052 895.574341,237.973938 895.602417,240.244400 
	C895.703186,248.397888 895.809509,256.557159 895.604370,264.706146 
	C895.264526,278.202148 896.221375,291.635895 897.203491,305.535950 
	C897.828003,310.917816 897.490845,315.860870 897.611633,321.258881 
	C897.465637,322.645386 897.441223,323.571655 897.562805,324.963806 
	C897.679138,342.885101 897.648438,360.343750 897.628418,377.802277 
	C897.625916,379.968903 897.736389,382.116028 897.961670,384.703735 
	C898.084839,386.523102 897.508057,387.861328 897.755432,389.645752 
	C897.780518,390.575195 897.653015,391.078613 897.100159,391.795959 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M966.101440,904.421997 
	C967.606018,903.102905 969.112610,902.302917 970.128479,904.471619 
	C971.056396,906.452393 972.317200,908.596375 969.181763,910.411682 
	C968.538086,910.649109 968.183289,910.671997 967.207275,910.752258 
	C966.380859,910.688843 966.175720,910.567993 965.774536,910.149048 
	C965.498962,909.140930 965.507263,908.429810 965.672607,907.384521 
	C965.875854,906.298950 965.956909,905.546936 966.101440,904.421997 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M967.273071,910.757996 
	C966.816345,912.819275 965.379578,913.195740 963.537354,912.887878 
	C962.796875,912.764160 962.269958,912.316345 962.239624,911.630615 
	C962.180786,910.300781 963.199219,910.099976 964.886963,910.110413 
	C965.879822,910.405640 966.242371,910.557800 966.913757,910.728027 
	C967.202698,910.793274 967.248596,910.767639 967.273071,910.757996 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M965.576050,907.278198 
	C965.881775,907.770935 965.968750,908.490906 966.131714,909.566223 
	C966.022339,910.090637 965.836914,910.259705 965.337402,910.221436 
	C965.023315,910.014160 965.004639,910.002441 964.995605,909.994385 
	C965.110107,909.159363 965.233704,908.332458 965.576050,907.278198 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M941.967407,986.390503 
	C939.288940,986.168945 934.922607,989.828796 934.370972,983.355042 
	C937.312256,983.072021 940.496704,982.419922 941.967407,986.390503 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M934.726318,955.150269 
	C936.102905,954.910645 937.180298,954.921753 938.646118,955.058289 
	C938.888977,957.916016 937.257263,959.326660 934.412476,959.995544 
	C933.778320,958.443481 933.666809,956.886902 934.726318,955.150269 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M934.499939,973.643066 
	C934.165039,970.285583 934.060608,966.599304 934.034485,962.458008 
	C935.792175,965.692993 934.884277,969.524231 934.499939,973.643066 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M934.434082,976.887024 
	C934.262695,976.825806 934.215332,976.662964 934.223022,976.251709 
	C934.615295,976.191589 934.708618,976.452271 934.434082,976.887024 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M1010.742310,622.331665 
	C1010.864990,621.795898 1011.156372,621.506287 1011.736206,621.108643 
	C1012.056274,621.448364 1012.087830,621.896118 1012.048828,622.673828 
	C1011.622437,622.861755 1011.266724,622.719788 1010.742310,622.331665 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M1009.098328,615.888428 
	C1009.326965,615.857483 1009.615295,616.131470 1009.978149,616.694336 
	C1009.754395,616.719910 1009.456238,616.456604 1009.098328,615.888428 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M675.311829,444.219055 
	C674.134338,444.144836 673.268005,444.298859 672.195801,444.717712 
	C670.408691,446.192444 670.708557,448.816986 668.287842,449.798523 
	C667.362244,450.008118 666.681274,449.998749 665.660583,450.014221 
	C664.103088,450.174469 662.880798,450.348969 661.468872,449.408020 
	C661.106689,448.686340 661.038086,448.183350 660.977539,447.299744 
	C666.333801,445.839539 665.813843,441.519257 666.225220,437.317078 
	C669.659973,431.700867 668.211792,425.506653 669.572754,419.495178 
	C669.544678,418.890472 669.555054,418.645905 669.703796,418.057587 
	C670.330200,417.131317 670.946106,416.714508 671.941895,416.187317 
	C675.593567,415.007019 678.775085,413.366852 682.761963,413.931885 
	C685.028748,414.591217 686.585754,416.082581 689.007690,416.279053 
	C689.541504,416.400024 689.749390,416.469116 690.221313,416.731659 
	C691.596741,417.641083 692.371033,418.694000 693.377197,419.955627 
	C693.637634,420.674683 693.669128,421.111176 693.585327,421.880005 
	C694.521606,426.552094 694.353638,431.013794 694.808105,435.774841 
	C691.891907,440.870026 686.859375,441.730927 682.173035,443.164581 
	C680.767334,443.594604 679.197327,443.259338 677.463623,444.082214 
	C676.643127,444.491699 676.143555,444.553680 675.311829,444.219055 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M695.664490,364.609802 
	C701.219971,365.004333 706.106018,366.889587 711.569885,367.949829 
	C710.855713,371.444427 706.696106,369.976715 704.671814,372.595276 
	C702.147034,373.452820 699.918701,372.413879 697.353210,372.937561 
	C696.482605,372.960938 695.991455,372.898956 695.158447,372.669800 
	C691.424622,369.804260 687.563416,371.409760 683.533569,371.373474 
	C679.728088,371.084503 676.814209,372.810791 673.634521,373.876282 
	C674.506531,374.674805 675.768799,375.124084 675.299683,376.912018 
	C673.314697,378.682312 671.024292,378.212311 668.961243,378.695007 
	C663.792297,379.904327 659.427307,382.365509 655.959473,386.924316 
	C652.033386,391.020508 650.707092,396.076050 648.683594,400.768036 
	C648.102234,402.116028 648.192505,403.332489 649.401855,404.346222 
	C650.774475,405.496826 650.364197,407.043427 650.208252,408.864227 
	C648.389893,413.174286 645.186707,416.259918 643.140625,420.412659 
	C639.875793,417.392456 642.655273,414.227020 643.107788,411.197235 
	C644.633972,400.977295 647.447693,391.132202 653.887390,382.327515 
	C654.106995,381.657379 654.310059,381.405884 654.863892,381.128052 
	C655.078369,380.985382 655.000000,380.999878 654.995972,381.039551 
	C656.813171,377.115051 660.765198,375.443604 664.152954,372.615479 
	C664.663879,372.245850 664.875916,372.104187 665.427368,371.776886 
	C673.048645,367.055725 680.936584,364.293610 689.506042,363.639374 
	C691.462646,363.490051 693.488770,363.384399 695.664490,364.609802 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M642.872620,420.951111 
	C643.920288,416.495514 645.443176,412.651337 649.049927,409.633362 
	C651.494873,405.351288 656.261902,406.787201 659.799805,404.546814 
	C662.729980,403.443390 664.822388,405.987122 667.427612,405.409546 
	C668.001892,405.529785 667.343262,404.708344 667.308655,405.374115 
	C667.297791,405.584137 667.146362,405.508667 666.823853,405.478607 
	C664.999695,405.308746 663.930115,404.664032 666.020752,403.331299 
	C667.850952,402.164520 670.350464,401.349762 672.192139,402.491486 
	C676.818359,405.359467 682.495911,404.715576 687.465881,407.503601 
	C688.342407,407.678558 688.830078,407.828186 689.636230,408.227905 
	C691.019836,409.288147 691.529785,410.435822 691.706726,412.132812 
	C691.580444,413.261230 691.269104,413.930481 690.583618,414.808014 
	C689.019287,415.717682 688.106750,414.876709 686.890503,413.990784 
	C686.319275,413.468140 686.012268,413.157043 685.485962,412.625458 
	C684.448914,411.569641 683.554016,411.503937 682.285583,412.226074 
	C680.905029,412.448517 679.906982,411.894440 678.516846,411.939148 
	C677.785278,411.927887 677.373413,411.889343 676.677734,411.750549 
	C675.846802,411.518311 675.304504,411.412354 674.515930,411.890869 
	C671.927002,413.305634 669.619568,413.645111 667.127563,411.662964 
	C666.267883,410.949158 665.664490,410.407959 664.465637,410.683960 
	C663.968872,410.810822 663.770020,410.866119 663.269775,411.000427 
	C662.271057,411.608704 660.729248,410.700806 660.926392,412.607330 
	C661.214539,413.001831 661.296082,413.189636 661.361206,413.694183 
	C660.805603,415.516449 659.051208,416.058624 658.461548,417.917786 
	C658.195740,419.234528 657.941162,420.187500 657.100525,421.304993 
	C655.850037,422.168060 654.773682,422.299286 653.263184,422.383484 
	C649.792175,421.876556 646.785278,424.162384 643.369385,422.306793 
	C642.992249,421.812317 642.959534,421.566040 642.872620,420.951111 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M691.061890,413.357361 
	C690.684509,411.924866 690.372681,410.830261 690.023560,409.393127 
	C690.181824,408.892426 690.377380,408.734283 690.938843,408.499725 
	C691.548767,408.457031 691.792603,408.490723 692.360840,408.669830 
	C695.843445,410.406433 694.610535,407.516968 694.582214,406.679382 
	C694.360901,400.123047 696.048523,393.931702 697.992004,387.795258 
	C699.101440,384.292114 700.668823,381.021545 704.665405,379.277161 
	C705.518311,379.178772 706.000305,379.244812 706.777100,379.592712 
	C707.738647,381.166840 707.159546,382.394775 706.502991,383.530457 
	C699.813232,395.103516 699.305420,407.532074 701.481445,420.190125 
	C706.482483,419.533936 704.775024,423.366913 705.081665,425.881470 
	C702.760864,427.766022 703.034058,430.327057 702.160889,432.775391 
	C700.500122,433.862335 698.362488,434.120972 700.507507,436.728088 
	C702.256714,438.854004 700.997742,440.277283 697.940308,440.445435 
	C695.638428,439.946014 694.980896,438.325989 694.197021,436.392761 
	C692.264832,431.550568 693.462463,426.668762 692.836426,421.968750 
	C693.966614,421.633789 695.594360,422.426941 694.956238,420.278259 
	C694.202393,417.739990 692.304626,415.942841 691.061890,413.357361 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M652.864136,421.313721 
	C653.992554,421.036224 655.053772,421.021576 656.512573,420.990234 
	C657.076477,421.159180 657.242737,421.344849 657.498047,421.893982 
	C657.584167,423.292999 657.179810,424.177460 656.298706,425.223022 
	C654.061035,426.887726 650.908020,425.449585 649.379639,428.495850 
	C648.648315,430.796021 648.280579,432.809326 648.432129,435.241852 
	C649.722107,442.491150 650.987366,443.050842 657.559692,439.281860 
	C658.245239,438.372253 658.667603,437.678467 659.026062,436.619781 
	C659.355591,435.590210 659.454407,434.832428 659.163208,433.759430 
	C658.956238,433.044891 658.849304,432.624451 658.685181,431.859314 
	C658.418945,430.306000 658.102661,429.082489 659.331543,427.797516 
	C662.735840,427.854248 662.904663,430.301453 663.271179,432.483398 
	C663.617249,434.543365 663.396973,436.651947 663.585388,439.139404 
	C663.511108,441.888641 662.850281,443.865112 659.800537,444.279419 
	C656.688049,443.341095 654.855164,444.976257 652.981567,446.500610 
	C657.312317,448.057953 657.426453,448.205231 655.333618,449.944824 
	C652.400146,448.858246 648.954956,450.223083 646.920166,446.862488 
	C644.374268,440.677826 645.163757,434.515411 644.926575,428.037231 
	C644.186523,426.643677 644.728271,425.765015 645.263245,424.557892 
	C647.320496,421.817505 649.899536,421.829803 652.587402,422.194916 
	C652.706604,422.211090 652.905762,422.072479 652.963745,421.954773 
	C653.002808,421.875305 652.858948,421.705811 652.864136,421.313721 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M633.776306,388.339050 
	C637.000061,389.075317 638.299500,385.047546 641.608887,386.003479 
	C645.277283,390.916901 644.763672,395.928162 639.985168,401.846558 
	C640.204346,399.103424 638.208252,399.588776 636.974915,400.085754 
	C632.202209,402.008881 631.775208,399.255737 631.944092,395.265869 
	C633.064270,392.823608 635.283325,394.484558 636.699097,393.435059 
	C631.733215,393.359192 631.287659,392.671021 633.776306,388.339050 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M709.973694,469.636139 
	C708.003174,470.289276 706.041565,470.613861 703.603943,470.886566 
	C703.039612,470.450836 702.951355,470.066986 702.978149,469.394592 
	C703.982605,468.120758 704.432434,466.946869 704.789551,465.321106 
	C705.505127,463.809113 706.010193,462.618927 706.761169,461.215271 
	C709.406372,461.066559 711.651489,461.086243 712.101318,457.808472 
	C712.387756,455.721161 714.452759,454.763367 715.906555,452.990906 
	C716.692505,452.236969 717.360474,452.193573 718.346436,452.597595 
	C719.402893,454.771057 723.811829,456.182343 718.622314,458.920929 
	C715.885925,460.364990 714.147522,463.996002 710.786377,465.399506 
	C708.913147,466.181702 710.057007,467.953583 709.973694,469.636139 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M705.407471,458.768188 
	C703.617371,462.587219 701.694946,466.091705 699.570068,469.861816 
	C697.124023,465.314697 696.882629,460.058411 696.327698,454.931274 
	C696.128784,453.093689 697.596558,450.757080 699.663208,450.452728 
	C702.397400,450.050049 701.656006,452.833771 702.261169,454.359100 
	C702.563354,455.120697 703.009888,455.825012 703.669678,456.769745 
	C704.626099,457.261414 705.030396,457.785583 705.407471,458.768188 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M693.848694,436.413269 
	C696.759705,436.158936 695.986206,438.907806 697.341431,440.360168 
	C697.764282,440.730164 697.917480,440.955658 698.110291,441.404388 
	C698.921265,442.706146 698.201904,443.463928 697.212463,444.448212 
	C696.187866,444.983337 695.438782,445.141296 694.295410,445.284454 
	C692.643738,445.375183 691.371521,445.422058 689.770508,445.942505 
	C685.678650,445.979858 681.989380,445.655151 678.203369,444.892395 
	C678.103210,444.503296 677.806885,444.238922 677.608398,444.231873 
	C677.134521,444.257812 676.859131,444.290833 676.921082,444.080322 
	C677.954590,441.538055 680.003479,442.475677 681.470520,442.146332 
	C685.916382,441.148193 689.969299,439.329193 693.848694,436.413269 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M702.144531,433.281250 
	C700.812622,428.691315 700.979614,428.175446 704.545044,425.912231 
	C705.092224,426.877014 705.369812,427.678986 705.862549,428.723633 
	C707.370117,430.350677 708.596802,431.770569 708.705444,434.152313 
	C708.834534,435.120056 708.950745,435.737549 709.174866,436.650909 
	C709.244873,440.515228 712.756165,442.946564 712.143066,446.874054 
	C709.872681,448.488464 709.554810,446.718597 708.895142,445.504150 
	C706.728943,441.516083 704.541504,437.539581 702.144531,433.281250 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M686.521606,477.288208 
	C686.878540,472.943512 687.033997,468.922882 687.117676,464.441833 
	C685.522278,462.535065 685.363098,461.005737 687.129333,459.288391 
	C687.771606,457.678833 688.050659,456.162231 688.532043,454.384949 
	C692.139832,458.621552 689.312500,463.516296 689.379150,468.627197 
	C688.973999,473.662018 688.929565,478.287292 688.614258,482.894073 
	C688.499878,484.565948 688.942200,486.619781 686.266968,487.546753 
	C684.634460,485.938629 684.747986,484.363892 684.981079,482.396790 
	C685.504395,480.556763 685.551575,478.979675 686.521606,477.288208 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M693.775757,444.126831 
	C694.689514,443.684418 695.397949,443.508484 696.472656,443.317810 
	C697.555664,443.759644 698.042847,444.380829 698.109863,445.619568 
	C698.002197,446.013031 698.015686,446.480194 698.024902,446.713684 
	C697.672668,447.548737 697.011353,447.451172 696.238281,447.815674 
	C696.012085,448.010834 696.000000,448.001068 696.003052,448.008362 
	C695.293274,448.513824 694.523376,448.717804 693.323730,448.235352 
	C692.476868,448.263550 691.971985,448.525909 691.199158,448.884644 
	C688.264526,448.782898 685.550903,449.312744 682.539612,448.346130 
	C681.427429,446.397156 678.410645,447.731720 678.109253,444.904724 
	C681.721252,443.261566 685.388550,444.996185 689.412720,444.306824 
	C691.042419,445.086273 692.292664,445.246124 693.775757,444.126831 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M711.932434,447.090515 
	C711.643738,443.569550 707.410461,441.327362 708.964844,437.111664 
	C709.923889,437.196442 710.564941,437.446106 711.545776,437.602051 
	C712.055725,437.618042 712.225891,437.727722 712.555237,438.095673 
	C712.847900,438.733063 712.943848,439.121185 713.057983,439.808746 
	C713.303284,440.662018 713.568359,441.184875 714.083740,441.914551 
	C714.364197,442.331238 714.473572,442.501160 714.722900,442.941986 
	C715.030823,443.802368 715.241882,444.374420 715.529541,445.213318 
	C713.328125,449.317841 719.273132,449.124023 718.688721,452.454285 
	C717.991943,452.791260 717.353455,452.783203 716.396912,452.723145 
	C714.949219,451.381042 712.584351,451.829987 711.952148,449.445618 
	C712.419067,448.648285 712.532776,448.071869 712.123901,447.209137 
	C711.889526,446.999695 711.961304,447.055450 711.932434,447.090515 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M659.373474,444.435303 
	C661.235535,443.635590 661.958069,442.002808 663.026489,440.351379 
	C663.357483,438.026978 663.141296,435.535736 666.455811,436.908020 
	C666.461975,438.402313 666.203491,439.666321 666.605774,440.663910 
	C668.652283,445.738800 666.296326,447.028687 661.364380,446.762573 
	C660.369507,446.237213 659.140747,446.017792 659.373474,444.435303 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M674.797852,492.646362 
	C675.726685,493.617645 676.362122,494.392120 677.790100,494.660156 
	C680.819092,496.214478 679.224426,498.566864 679.235168,500.856750 
	C675.611755,501.726868 672.165405,502.243164 668.338501,502.784790 
	C667.155701,501.676636 667.651001,500.793304 668.881714,499.831421 
	C674.740845,500.325195 675.590820,499.062622 673.667114,492.919495 
	C674.027100,492.497803 674.262085,492.479218 674.797852,492.646362 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M689.340942,469.188263 
	C689.070374,464.367432 689.015198,459.690826 688.847168,454.569275 
	C693.126526,453.968201 692.920410,456.737885 692.027283,460.002319 
	C690.543579,463.449677 691.318909,466.826294 690.823486,470.540375 
	C690.370361,470.434479 689.963318,469.883484 689.340942,469.188263 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M648.468018,449.990295 
	C648.868469,454.719818 652.475586,457.820282 653.474182,462.005859 
	C653.889954,463.748657 654.519897,465.440338 654.815369,467.731384 
	C652.393738,462.337769 648.225342,457.196686 647.225342,450.339661 
	C647.546387,449.711945 647.908936,449.644287 648.468018,449.990295 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M649.041199,450.343781 
	C648.282837,450.142639 647.933105,450.053070 647.399597,449.957397 
	C645.996277,449.213409 644.370361,448.693085 644.315979,447.033722 
	C644.279907,445.931305 645.415161,446.199921 646.525757,446.417145 
	C648.916687,449.251678 652.856201,446.372467 654.958130,449.562195 
	C653.260925,451.195648 651.348389,450.750366 649.041199,450.343781 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M659.359863,460.351990 
	C659.681091,461.681030 660.250305,462.593506 659.504944,463.893860 
	C655.915710,461.135193 656.787354,456.803894 655.585999,453.317841 
	C655.381714,452.725067 656.249695,452.256317 656.974182,452.242615 
	C657.858154,452.225891 658.028809,452.957947 658.151123,453.580231 
	C658.567993,455.700348 658.919495,457.833374 659.359863,460.351990 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M661.180359,449.521423 
	C662.365906,449.320435 663.556580,449.451599 665.033997,449.810913 
	C664.303955,452.894409 666.006348,455.562469 665.775024,458.761780 
	C662.158264,459.629242 664.279846,456.416046 662.782227,455.159058 
	C662.006592,453.276276 661.596008,451.564911 661.180359,449.521423 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M651.288818,381.986511 
	C650.023865,379.770325 649.041992,377.545013 648.118652,375.295654 
	C647.778381,374.466888 647.850891,373.584351 648.807739,373.244171 
	C649.607971,372.959656 650.521240,373.051392 650.819824,374.067932 
	C651.491150,376.352753 653.131775,378.466644 652.168335,381.495239 
	C652.003235,381.938934 651.799133,381.953369 651.288818,381.986511 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M666.708374,489.269958 
	C665.706970,485.275726 664.119629,481.614471 664.131897,476.713898 
	C667.555969,480.531799 666.629272,484.709503 667.735596,488.645508 
	C667.504761,489.177795 667.281250,489.310791 666.708374,489.269958 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M652.516907,421.011932 
	C652.856995,421.719757 655.693237,422.362335 652.983032,423.031921 
	C650.926331,423.540009 648.330933,421.690094 646.551208,424.740601 
	C646.118042,425.130554 645.919250,425.238037 645.382446,425.321899 
	C644.412842,424.723572 644.326538,423.599274 642.902039,423.424194 
	C642.654175,423.138092 642.731812,422.923248 642.917236,422.383484 
	C646.050842,421.696747 649.076599,421.334900 652.516907,421.011932 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M674.950928,458.726196 
	C675.501526,455.697662 675.981628,453.056152 676.461670,450.414642 
	C676.912415,450.474304 677.363098,450.533936 677.813843,450.593567 
	C678.133179,454.128448 676.713928,457.511017 675.835815,460.918793 
	C675.710571,461.404999 674.987732,461.092865 674.871399,460.583435 
	C674.765137,460.118286 674.869019,459.605194 674.950928,458.726196 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M682.507568,471.800751 
	C682.491333,473.241974 682.133850,474.270721 680.839050,473.621277 
	C679.446655,472.922913 679.809998,471.396210 679.947449,470.124390 
	C680.073730,468.956177 680.488098,467.357117 681.528809,467.318329 
	C683.796509,467.233856 682.306763,469.111664 682.518677,470.500610 
	C682.511780,471.089539 682.541443,471.293701 682.507568,471.800751 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M677.319946,489.670471 
	C676.936401,485.930115 675.103760,481.980743 676.427551,477.296753 
	C678.489441,481.488281 678.488892,485.372101 677.319946,489.670471 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M669.494507,455.628906 
	C669.345276,457.840424 670.390869,459.814270 668.361084,462.249542 
	C668.361084,458.663361 668.361084,455.806641 668.361084,452.940857 
	C669.726318,453.186432 669.198059,454.411621 669.494507,455.628906 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M641.753540,465.009155 
	C641.320007,463.298431 641.249573,461.556427 641.272583,459.387146 
	C644.747498,460.724945 644.912292,462.046051 641.753540,465.009155 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M686.439209,476.921692 
	C686.711975,478.459747 686.700867,479.955292 686.509888,481.774414 
	C685.906128,482.398285 685.435181,482.569122 684.544189,482.526672 
	C683.138550,481.875244 683.024963,480.834045 682.864502,479.458740 
	C684.688416,479.382080 682.680237,474.080170 686.439209,476.921692 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M705.752930,458.865570 
	C705.051514,458.617889 704.563354,458.153015 704.011719,457.336212 
	C704.447388,456.092041 704.946411,455.199829 705.696411,454.132812 
	C706.344727,453.602478 706.806946,453.464935 707.647827,453.754913 
	C708.326782,454.406219 708.692078,454.847839 709.071411,455.588989 
	C707.235596,455.892853 706.934937,457.648285 705.752930,458.865570 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M682.343079,448.522949 
	C684.926941,448.016632 687.702942,447.621735 690.699463,448.647400 
	C688.091492,450.997742 685.314331,449.807434 682.343079,448.522949 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M681.029480,506.619873 
	C678.848083,507.295166 676.765747,507.654266 674.315552,507.841461 
	C673.933716,507.375183 673.928955,507.080658 673.951416,506.565247 
	C675.379700,505.922974 676.790039,505.501404 678.573853,505.071228 
	C679.634705,505.546082 680.768860,505.244293 681.029480,506.619873 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M662.407104,455.434906 
	C664.502136,455.486176 663.520691,458.013306 665.333008,459.037079 
	C665.730957,460.726868 665.400208,462.111237 663.796570,463.216492 
	C661.589355,461.065979 662.986206,458.252472 662.407104,455.434906 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M682.584717,479.320129 
	C683.224976,479.843567 683.546265,480.606964 683.912537,481.681244 
	C685.366394,483.564392 684.314880,485.200867 683.950806,487.157837 
	C683.679565,487.701477 683.540833,487.903198 683.078308,488.278137 
	C681.854553,485.528137 681.561768,482.571503 682.584717,479.320129 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M669.123474,499.379944 
	C668.869690,500.503021 668.479858,501.322113 668.024048,502.475647 
	C665.084106,503.141937 665.748230,501.034454 666.091370,499.691711 
	C666.501038,498.088715 667.762146,498.104614 669.123474,499.379944 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M679.403748,501.035400 
	C678.688904,499.326508 679.363098,497.297333 678.181396,495.192444 
	C681.286438,495.311554 681.478760,496.008392 679.403748,501.035400 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M692.973145,466.937500 
	C691.557495,465.827881 692.254333,464.198822 691.906189,462.382111 
	C697.044312,462.259918 693.686890,464.920624 692.973145,466.937500 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M687.081055,459.196655 
	C687.396606,460.595001 687.300659,461.994537 687.125366,463.687744 
	C686.479126,464.637268 685.912231,465.293091 684.634094,466.771790 
	C685.715515,463.642212 683.477234,460.844879 687.081055,459.196655 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M682.829712,488.841858 
	C682.754578,488.451385 682.714905,488.245453 682.770264,488.156372 
	C683.568848,487.416626 684.416748,487.209839 685.784424,487.668884 
	C686.194885,487.871033 686.193054,487.829468 686.211670,487.817047 
	C686.078552,488.602814 686.057556,489.457458 685.743408,490.185547 
	C685.307312,491.196320 684.709473,492.530579 683.383606,491.971680 
	C682.921204,491.776794 683.047485,490.185760 682.829712,488.841858 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M666.466553,489.485199 
	C666.587646,489.096497 666.816162,489.096863 667.386475,489.071014 
	C668.161926,491.256836 669.697998,493.297668 668.793640,495.916962 
	C666.088745,494.502014 667.397705,491.788513 666.466553,489.485199 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M698.344604,445.975677 
	C697.675659,445.350037 697.349182,444.687012 696.930786,443.663544 
	C697.341675,442.957733 698.057922,442.791504 698.096497,441.765930 
	C699.392151,442.923706 702.927368,444.014984 698.344604,445.975677 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M668.407227,450.002838 
	C669.420837,448.566040 669.430542,446.203888 671.655518,445.038239 
	C671.259827,446.871490 671.849304,449.608856 668.407227,450.002838 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M666.478027,474.586273 
	C664.471741,476.750275 664.305603,474.961700 663.975708,473.722717 
	C663.812500,473.109589 663.774597,472.218506 664.557617,472.081390 
	C666.172913,471.798462 666.432617,473.025360 666.478027,474.586273 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M658.905212,475.709900 
	C656.486084,477.699066 656.904907,475.120392 656.289490,474.283752 
	C655.942993,473.812805 656.126770,472.933990 657.020264,473.020172 
	C658.349426,473.148285 658.753662,474.210052 658.905212,475.709900 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M644.608154,424.639099 
	C645.091431,424.848755 645.337891,424.871216 645.950562,424.958405 
	C645.840637,425.679016 645.364502,426.334900 644.880249,427.305725 
	C643.957947,427.693787 642.842773,428.390533 642.265625,427.184540 
	C641.792847,426.196503 642.785339,425.788971 643.693115,425.103394 
	C644.103516,424.752319 644.237427,424.602112 644.608154,424.639099 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M684.514221,504.160461 
	C684.942139,505.762299 684.844604,507.147003 682.386475,507.044250 
	C681.173950,505.958649 681.450867,505.140442 682.796875,504.288208 
	C683.510742,504.130981 683.876648,504.126038 684.514221,504.160461 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M660.406860,480.299744 
	C659.476501,479.590729 658.915710,478.978729 659.939880,478.331146 
	C660.475464,477.992493 661.267578,478.031433 661.576294,478.700165 
	C661.925415,479.456360 662.461060,480.367035 661.366272,481.036194 
	C661.298157,481.077789 661.087830,480.928192 660.969604,480.834869 
	C660.847839,480.738800 660.757812,480.602661 660.406860,480.299744 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M682.783081,504.071106 
	C682.723450,504.866547 682.302063,505.597229 681.957886,506.645691 
	C682.035156,506.963470 681.877502,507.124420 681.570801,507.193970 
	C681.264099,507.263519 681.097717,507.099365 681.014038,507.017700 
	C680.911194,505.893066 679.874634,505.967987 679.144287,505.276276 
	C680.105286,504.710571 681.263367,504.358459 682.783081,504.071106 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M682.030396,462.096924 
	C682.097900,461.122650 682.167786,460.507202 682.319214,459.174805 
	C683.403870,461.381897 683.058716,462.832214 682.157043,464.293488 
	C682.115662,463.680908 682.074219,463.068359 682.030396,462.096924 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M689.289062,496.631287 
	C687.917236,496.544128 687.637451,495.754425 688.258667,494.794403 
	C688.419312,494.546082 689.030396,494.589172 689.434570,494.498413 
	C689.483276,495.085663 689.531921,495.672913 689.289062,496.631287 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M688.957764,497.353699 
	C688.997559,497.002441 689.277039,496.910278 689.417236,496.928589 
	C690.460388,497.123352 691.128357,497.578278 690.947632,498.582886 
	C690.883789,498.937744 690.379150,499.481079 690.080017,499.478241 
	C688.941528,499.467682 688.974976,498.522583 688.957764,497.353699 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M693.020508,448.304199 
	C693.737976,447.999176 694.494202,447.997131 695.628296,448.005371 
	C695.177673,448.978943 694.579773,451.091278 693.020508,448.304199 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M638.100220,440.577515 
	C638.278015,440.218445 638.436340,440.162109 638.796570,439.954559 
	C640.268677,440.218842 640.094055,441.337372 640.127563,442.681519 
	C639.532715,442.746277 639.028381,442.440002 638.273438,442.105957 
	C638.042114,441.678894 638.061462,441.279541 638.100220,440.577515 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M676.884277,443.893982 
	C677.258423,443.836823 677.402832,444.007843 677.406372,444.116333 
	C676.806946,445.235596 676.267334,446.581940 675.055542,444.324829 
	C675.503784,443.977570 676.006897,443.964386 676.884277,443.893982 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M707.964966,453.602631 
	C707.514099,453.970734 707.066711,453.976868 706.283325,453.970520 
	C706.023804,453.215179 705.668579,452.213470 706.784363,452.011017 
	C707.607483,451.861633 707.809937,452.596527 707.964966,453.602631 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M674.955444,489.720642 
	C674.394409,489.837799 673.892944,489.585327 673.447449,489.257019 
	C673.394226,489.217834 673.580627,488.609894 673.767090,488.532257 
	C674.492981,488.229950 674.830933,488.705719 674.955444,489.720642 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M672.056763,483.998993 
	C672.171875,483.468597 672.290100,483.199524 672.408264,482.930450 
	C673.192444,483.628265 673.149780,484.337189 672.436768,485.055115 
	C672.311096,484.790192 672.185486,484.525238 672.056763,483.998993 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M644.840820,424.482819 
	C644.844971,424.826263 644.412292,424.921021 644.190918,424.911774 
	C643.488525,424.486908 643.007446,424.071289 642.551392,423.504303 
	C643.574463,422.912262 644.406128,422.949463 644.840820,424.482819 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M640.224487,444.934174 
	C639.994995,444.457397 639.988953,444.062225 640.021362,443.373169 
	C640.966187,443.276459 641.597351,443.681335 641.127075,444.894897 
	C640.923828,445.026154 640.447998,445.015808 640.224487,444.934174 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M696.292175,448.012390 
	C696.484558,447.681366 696.957031,447.351898 697.731812,446.984833 
	C698.576233,448.713470 697.091553,447.702240 696.292175,448.012390 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M683.386841,455.908875 
	C683.646912,456.184326 683.752197,456.608826 683.795105,457.039520 
	C683.803955,457.128693 683.580811,457.240936 683.464478,457.342529 
	C683.379639,456.915070 683.294800,456.487610 683.386841,455.908875 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M675.039673,489.957947 
	C675.529785,489.929413 675.967285,489.953552 676.734680,489.981323 
	C677.064575,489.984955 677.001770,490.000397 677.010986,489.969238 
	C676.953125,490.847473 676.951660,491.831116 675.253479,491.098602 
	C674.953430,490.963135 674.932678,490.535339 674.905823,490.324219 
	C674.878967,490.113098 674.987000,490.010620 675.039673,489.957947 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M654.797668,380.705505 
	C654.901733,381.287201 654.725159,381.589050 654.284180,381.949341 
	C653.815491,381.994781 653.611267,381.981720 653.100830,381.945923 
	C653.368774,381.424011 653.942871,380.924835 654.797668,380.705505 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M675.091797,492.534241 
	C674.879395,492.787231 674.660034,492.742310 674.116455,492.606873 
	C674.020569,492.066925 674.248962,491.617493 674.715393,491.065582 
	C674.953430,490.963135 675.002014,491.003174 675.026123,491.024963 
	C675.061829,491.443237 675.073364,491.839783 675.091797,492.534241 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M673.743896,454.989227 
	C673.585815,455.093292 673.426575,455.041870 673.267273,454.990479 
	C673.425720,454.938263 673.584167,454.886017 673.743896,454.989227 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M671.667603,480.319855 
	C671.025757,480.161621 670.792847,479.641327 671.296387,479.402924 
	C671.895691,479.119171 671.941956,479.694092 671.667603,480.319855 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M654.953430,468.031525 
	C655.847412,468.154633 656.152893,468.755676 655.678345,469.318298 
	C655.225464,469.855347 655.036621,469.060547 654.662354,468.565735 
	C654.578247,468.307556 654.831055,468.127136 654.953430,468.031525 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M693.837585,471.174622 
	C693.550232,470.902222 693.316345,470.290619 693.141418,469.348633 
	C693.430603,469.623993 693.660767,470.229706 693.837585,471.174622 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M711.574219,447.287598 
	C712.702759,447.427094 712.978516,448.005615 712.153748,448.970825 
	C711.689636,448.603790 711.474304,448.089630 711.574219,447.287598 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M683.547852,453.475586 
	C683.579468,453.530151 683.516235,453.421051 683.547852,453.475586 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M682.546509,471.801971 
	C682.358093,471.897400 682.252319,471.696442 682.195129,471.482483 
	C682.168884,471.384521 682.238342,471.260956 682.373291,471.017181 
	C682.537720,471.090363 682.593384,471.295349 682.546509,471.801971 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M694.119141,472.911987 
	C693.877747,472.851471 693.812683,472.687836 693.767456,472.260620 
	C694.176025,472.130280 694.623108,472.226990 694.119141,472.911987 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M626.560669,562.766418 
	C628.813843,561.605347 631.061951,561.608826 633.675476,562.847290 
	C634.533691,564.046631 635.158997,565.024414 635.526611,566.090942 
	C636.623901,569.274841 635.706299,572.091187 633.048950,573.901245 
	C629.726074,576.164673 627.207031,574.268555 624.956055,571.248413 
	C624.880676,568.963745 624.974548,566.994690 625.061584,564.602539 
	C625.399597,563.645020 625.490051,562.975037 626.230408,562.654175 
	C626.512146,562.807190 626.539429,562.772461 626.560669,562.766418 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M651.971191,562.402832 
	C653.469482,562.038391 655.003418,561.287170 656.501831,562.848267 
	C656.833862,565.292969 656.835510,567.976257 654.083008,567.874023 
	C650.992920,567.759277 652.472290,564.612610 651.971191,562.402832 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M778.980957,632.620728 
	C777.375305,633.640198 776.511963,635.004395 775.670715,636.831848 
	C775.694824,637.538330 775.754883,637.928528 775.683105,638.627686 
	C775.435547,639.505127 775.174438,640.056335 774.810059,640.903320 
	C774.599365,641.383728 774.510986,641.576111 774.282776,642.057434 
	C772.822144,644.649353 772.082642,647.191162 771.030762,649.968811 
	C770.813721,650.487244 770.708618,650.687500 770.364014,651.128540 
	C769.580261,651.776184 769.191772,652.362122 768.252319,652.749268 
	C765.916077,655.470337 763.918091,658.145691 761.920105,660.821045 
	C762.175293,654.837097 766.387085,650.285706 766.285400,644.248169 
	C764.742188,640.848755 767.709229,639.053650 768.706482,636.240051 
	C768.944946,635.942505 769.004822,635.982483 768.970215,635.973816 
	C770.679688,633.055603 772.156311,629.970703 774.727539,627.198120 
	C774.946899,626.936951 775.004517,626.979248 774.969421,626.972900 
	C776.868652,624.109680 778.500732,621.004944 781.790344,618.868042 
	C782.340454,618.735901 782.569031,618.731201 783.074585,618.925537 
	C784.554321,620.988892 782.850098,622.494141 782.768555,624.520508 
	C781.836853,627.481201 778.904053,629.098816 778.980957,632.620728 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M782.979797,624.514893 
	C780.833374,623.058350 783.393188,621.502563 783.084778,619.439697 
	C783.099060,619.080139 783.341736,618.648193 783.125488,618.769043 
	C780.461060,621.494751 778.012817,624.099609 775.249451,626.835510 
	C775.668091,622.243713 779.067688,619.163513 782.072876,615.441284 
	C785.566345,614.597290 784.903259,617.004944 785.009644,618.811035 
	C785.129944,620.852661 784.084778,622.501831 782.979797,624.514893 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M732.144714,636.531555 
	C732.812866,636.097412 733.545288,636.063965 734.642334,636.077881 
	C733.747314,642.398071 729.585693,647.859009 729.903870,655.009644 
	C730.017090,655.636169 730.076172,655.811340 729.927002,656.170898 
	C729.533203,656.343384 729.347717,656.331604 728.996948,656.095459 
	C724.757385,654.049255 729.419861,651.315674 728.124329,648.852478 
	C730.319519,644.943237 732.047302,641.214905 732.144714,636.531555 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M768.590149,635.928711 
	C768.784363,638.709839 767.123657,640.890381 766.043213,643.668335 
	C763.891541,648.281189 761.761353,652.532043 759.108765,656.891235 
	C761.106934,649.652954 763.321838,642.166443 768.590149,635.928711 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M736.943604,635.242737 
	C736.624878,631.911133 739.409851,630.557556 740.649536,628.132019 
	C742.772034,630.033508 742.348511,632.033813 740.701294,634.337646 
	C739.919128,636.328613 739.855896,638.220642 738.234314,639.471191 
	C736.287598,638.639526 737.342285,636.907776 736.943604,635.242737 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M774.592041,626.894104 
	C774.022766,630.393250 771.633667,632.950439 769.250610,635.834900 
	C768.925476,631.893311 771.656860,629.416260 774.592041,626.894104 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M747.683716,625.359985 
	C748.450989,624.307861 749.028870,623.958252 749.979126,624.684265 
	C751.362915,627.370667 751.478149,629.781006 749.654175,632.475708 
	C748.877686,632.913269 749.387634,635.146057 747.961975,633.191772 
	C746.203186,630.640320 746.322571,628.225098 747.683716,625.359985 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M742.495972,627.280884 
	C742.877380,626.421082 743.081726,625.930420 743.526611,625.326294 
	C746.694031,628.141724 744.936951,631.359131 743.911987,634.753296 
	C742.944580,635.288513 743.158447,636.406860 742.223755,636.187500 
	C742.064819,636.150208 742.024536,635.607483 741.848022,635.061523 
	C740.858398,632.349243 741.781860,630.014526 742.495972,627.280884 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M753.816650,631.206421 
	C752.477905,628.374573 753.695190,625.990234 755.311951,622.614807 
	C756.305725,626.367004 755.057678,628.734558 753.816650,631.206421 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M762.141968,620.634888 
	C762.888855,619.755493 763.650818,619.403076 764.512085,620.476013 
	C762.181702,623.261047 763.945679,626.958923 761.292358,630.618164 
	C761.653259,626.586426 761.901001,623.818481 762.141968,620.634888 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M743.839966,634.838196 
	C744.264282,632.058716 744.070923,629.073425 743.820435,625.650391 
	C744.293762,625.175415 744.820496,625.138062 745.743103,625.106262 
	C747.571594,627.479553 747.083984,629.774780 745.614929,632.354004 
	C744.966736,633.335083 744.581055,634.005005 743.839966,634.838196 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M729.798096,655.874512 
	C729.992981,655.482361 729.978210,655.463562 729.968140,655.462280 
	C730.773132,654.419495 731.588257,653.377930 732.779419,652.228516 
	C733.119019,654.912598 732.805115,657.613708 730.347046,659.873169 
	C730.010010,659.562683 729.994141,659.096985 729.959961,658.282349 
	C729.612915,657.421692 729.500305,656.866089 729.798096,655.874512 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M758.979980,621.390381 
	C759.150757,620.911072 759.300720,620.820374 759.713318,620.718384 
	C760.318237,624.243958 759.549133,627.480896 757.377686,630.750854 
	C756.410461,627.209778 758.834229,624.706848 758.979980,621.390381 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M742.402771,626.946167 
	C742.392212,629.283081 742.111389,631.654480 741.798584,634.425415 
	C741.766602,634.824890 741.309814,634.844238 741.309814,634.844238 
	C741.309814,634.844238 740.856873,634.782532 740.640991,634.712280 
	C740.618713,632.694763 740.812439,630.747498 740.994507,628.415771 
	C741.366089,627.681030 741.749329,627.330872 742.402771,626.946167 
z"/>
<path fill="#100622" opacity="1.000000" stroke="none" 
	d="
M745.608154,632.770081 
	C745.595032,630.408752 745.837585,628.152344 746.109619,625.503906 
	C746.139038,625.111877 746.504578,625.021484 746.688538,625.061829 
	C748.156738,627.382690 747.237061,629.835449 747.187866,632.588745 
	C746.586792,632.942444 746.225281,632.908752 745.608154,632.770081 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M758.985596,657.131531 
	C759.107849,659.317871 758.040710,660.880066 756.554016,662.953125 
	C755.749817,660.250916 757.168518,658.861389 758.334290,657.164551 
	C758.586487,656.999634 758.882751,657.024231 758.985596,657.131531 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M750.685425,625.348816 
	C750.825378,624.920166 750.942261,624.489319 751.003235,624.274658 
	C752.704651,627.027954 752.058533,630.070862 751.084717,633.004639 
	C749.986267,630.548889 750.735596,628.145813 750.685425,625.348816 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M750.647461,624.917725 
	C750.856201,627.286926 750.887024,629.653748 750.863403,632.457153 
	C750.490112,632.895752 750.171753,632.885193 749.618286,632.832825 
	C749.568665,630.449463 749.754578,628.095337 750.027100,625.335938 
	C750.113770,624.930786 750.469482,624.915222 750.647461,624.917725 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M747.188293,632.993896 
	C746.941101,630.641968 746.933960,628.307861 746.899658,625.537964 
	C747.052979,625.068054 747.233521,625.033997 747.689392,624.988403 
	C747.959045,627.334961 747.953308,629.693054 747.925049,632.490112 
	C747.902466,632.929077 747.428345,633.011780 747.188293,632.993896 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M734.318665,648.817688 
	C734.049316,647.486450 733.722107,645.958740 734.875549,644.357666 
	C735.214661,643.902649 735.383728,643.770691 735.819458,643.818604 
	C736.226929,645.738220 735.503296,647.230957 734.318665,648.817688 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M773.998779,644.998352 
	C774.144470,646.233826 774.050171,647.226013 773.954773,648.590393 
	C773.515076,649.263916 773.076538,649.565186 772.126709,649.809265 
	C770.868713,648.036987 771.862366,646.687988 772.818481,645.055847 
	C773.306396,644.808716 773.532654,644.781860 773.998779,644.998352 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M768.291382,657.759766 
	C768.023621,657.315247 768.023804,656.611084 768.052368,655.555054 
	C768.611084,654.408264 768.391052,653.256775 769.651184,652.552612 
	C770.367554,654.385315 769.540894,655.964844 768.291382,657.759766 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M736.309326,643.812988 
	C735.912415,644.000488 735.738708,644.002441 735.305359,644.019531 
	C735.121643,643.070374 735.193054,641.734070 736.276917,641.774109 
	C737.271057,641.810852 736.895081,642.916748 736.309326,643.812988 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M769.987915,652.378174 
	C769.511841,653.213684 769.019714,653.963074 768.304077,654.957886 
	C768.044861,654.668335 768.009033,654.133362 767.943604,653.196716 
	C768.408691,652.207458 768.903259,651.619934 769.693665,651.006836 
	C770.130188,651.173706 770.270874,651.366211 770.188232,651.837891 
	C769.964905,652.117126 769.971802,652.292114 769.987915,652.378174 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M770.291870,652.069336 
	C769.990967,651.928284 770.016968,651.739441 770.016296,651.265930 
	C769.989563,650.981262 769.999573,651.001404 769.989014,650.999268 
	C770.383118,650.595886 770.628052,650.038574 771.460999,649.791382 
	C771.749512,649.809143 771.961243,649.977417 772.067383,650.064209 
	C771.945251,651.015564 771.669434,651.840515 770.291870,652.069336 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M734.134766,649.116333 
	C734.032166,650.024414 733.850647,650.867615 733.412354,651.915771 
	C733.155518,652.120667 733.026184,652.017212 732.962524,651.962219 
	C733.071899,651.062073 733.244873,650.216858 733.657410,649.147278 
	C733.897034,648.922852 734.055786,649.051453 734.134766,649.116333 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M764.643372,621.204956 
	C764.663818,620.404358 764.869690,619.904785 765.518433,619.414185 
	C765.922913,620.370667 765.884460,621.318176 765.846069,622.265747 
	C765.506958,622.012512 765.167908,621.759277 764.643372,621.204956 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M729.268127,662.914124 
	C729.166077,662.238953 729.322632,661.329895 729.756836,660.213684 
	C729.865234,660.897766 729.695984,661.789001 729.268127,662.914124 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M765.890930,660.279297 
	C766.698364,660.648499 766.342468,660.984863 766.017212,661.294739 
	C765.921509,661.385986 765.673584,661.469788 765.609497,661.417419 
	C765.147644,661.039978 765.292603,660.663452 765.890930,660.279297 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M764.228149,624.974487 
	C764.459290,624.309265 764.706909,624.296082 764.917603,624.729614 
	C764.976562,624.851013 764.942017,625.053589 764.883118,625.189880 
	C764.688049,625.641296 764.452698,625.641785 764.228149,624.974487 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M767.993286,657.990479 
	C767.887634,658.011841 767.790466,658.044189 767.858398,658.047974 
	C768.023438,658.019470 768.001770,658.001404 767.993286,657.990479 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M760.542480,662.556946 
	C760.464539,662.613037 760.445129,662.391296 760.445129,662.391296 
	C760.445129,662.391296 760.620361,662.500854 760.542480,662.556946 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M755.441772,664.503418 
	C755.414307,664.451904 755.469299,664.554993 755.441772,664.503418 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M701.544189,419.588593 
	C701.529602,421.336243 701.442200,422.614868 701.354858,423.893463 
	C698.590637,408.862610 697.174866,394.008881 707.328186,380.466370 
	C709.227478,376.341522 712.500916,375.002045 716.701294,374.653320 
	C722.416260,374.639709 727.829102,374.350830 731.365295,379.225616 
	C719.245422,373.951385 706.790466,380.375305 703.559753,393.422150 
	C701.464722,401.882629 701.619385,410.509583 701.544189,419.588593 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M733.817749,415.912170 
	C734.273254,416.446564 734.504089,416.779785 734.853821,417.280090 
	C735.150330,417.714813 735.327820,417.982452 735.236572,418.649963 
	C734.967834,419.049774 734.990967,418.984680 735.024048,418.974854 
	C728.587524,421.644653 723.666809,425.481293 724.186890,433.806213 
	C723.981262,434.681976 723.743591,435.130676 723.124207,435.788513 
	C722.181641,436.032837 721.524353,436.017029 720.538452,436.013733 
	C718.038696,433.374451 720.031860,430.676971 720.242493,427.596313 
	C720.558655,426.364319 720.489136,425.515106 720.771729,424.310852 
	C720.978455,423.944153 721.001587,423.997559 720.972900,423.992920 
	C721.527039,423.481201 722.068176,422.931091 722.800171,422.162903 
	C722.994507,421.948486 723.003357,422.003387 722.976013,421.998505 
	C723.207031,421.799988 723.444763,421.583618 723.811279,421.155029 
	C723.960754,420.965546 723.997375,421.002747 723.975098,420.987793 
	C724.870300,419.519958 726.125977,418.643707 728.178650,418.664612 
	C726.838806,418.419800 725.762268,419.266632 724.408630,418.435852 
	C723.788696,417.565552 723.463196,416.878113 723.018616,415.829529 
	C723.490051,413.554077 725.448059,413.091156 727.013245,411.724792 
	C729.725159,411.090637 730.711792,412.692444 731.802856,414.744141 
	C732.026367,415.019409 731.982666,415.018829 731.979614,414.997192 
	C732.413269,415.445160 733.038391,415.500610 733.817749,415.912170 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M723.294189,434.039886 
	C723.262939,432.793243 723.426758,431.821960 723.517395,430.843872 
	C724.274292,422.678619 725.839600,420.926605 734.670227,418.899597 
	C735.023010,419.573242 735.208191,420.572601 734.922668,420.732727 
	C726.954712,425.201019 725.359680,429.473694 728.606140,437.932434 
	C728.901062,438.701019 729.189453,439.472198 729.285400,440.614075 
	C727.082764,441.796478 725.530823,441.215729 724.308960,439.054504 
	C724.125671,438.245300 724.002930,437.822906 723.874756,437.070618 
	C724.277161,436.588165 724.704285,436.528625 725.133301,436.478119 
	C724.902649,436.414948 724.666260,436.489227 724.136353,436.392609 
	C723.838013,436.336426 723.812927,436.145020 723.716675,436.152588 
	C723.546143,435.545868 723.783630,434.903687 723.294189,434.039886 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M724.081177,438.934967 
	C725.628967,439.433624 727.009644,440.199524 728.740112,440.975708 
	C729.089905,440.985992 729.018005,440.996887 729.014038,440.960724 
	C729.201660,441.207764 729.423828,441.464020 729.874390,441.856873 
	C730.066956,442.024902 729.998657,442.008972 730.005737,441.974609 
	C730.203369,442.209808 730.421814,442.454407 730.862610,442.825378 
	C731.057068,442.976715 731.001892,442.998810 731.012207,442.970917 
	C731.208557,443.214447 731.424866,443.459259 731.864258,443.829285 
	C732.057129,443.981140 732.000916,443.999054 732.009521,443.970886 
	C732.208923,444.214661 732.428040,444.461517 732.863770,444.844543 
	C733.052185,445.005768 732.987915,445.009735 732.985840,444.977631 
	C733.113159,445.092834 733.242493,445.240173 733.598450,445.574768 
	C734.132507,446.326416 734.439880,446.890747 734.879456,447.748108 
	C735.125977,448.213135 735.240356,448.385132 735.149902,448.789612 
	C728.966003,452.109467 725.234070,448.823395 722.926147,441.377197 
	C722.806274,440.830750 722.732544,440.654541 722.809692,440.234680 
	C723.278320,439.728119 723.596191,439.465179 724.081177,438.934967 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M707.332764,407.611450 
	C706.893494,407.276154 706.752014,407.173187 706.673035,407.034607 
	C705.212646,404.473785 703.128235,400.807770 706.005310,399.300201 
	C708.726990,397.874115 711.938965,401.033081 714.276001,403.269745 
	C715.171570,404.126831 715.290894,405.592499 714.070190,406.777710 
	C712.137634,408.654175 710.158936,409.676880 707.332764,407.611450 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M720.012268,390.705200 
	C718.764282,390.485229 717.756470,390.198547 716.431030,389.877838 
	C715.633606,389.603638 715.121887,389.487549 714.326050,389.428345 
	C713.508118,388.828949 713.421021,388.233582 714.218567,387.862854 
	C718.244324,385.991638 727.051453,387.722626 730.145325,391.020782 
	C730.826904,391.747345 731.519897,392.705627 729.383789,393.011658 
	C728.873535,392.832489 728.716553,392.684448 728.279663,392.373901 
	C725.999756,391.742004 723.999695,391.272614 721.612671,390.801758 
	C720.917236,390.650360 720.592834,390.596405 720.012268,390.705200 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M732.095581,414.603027 
	C730.575073,414.053223 729.123840,413.087067 727.011841,412.105316 
	C725.438599,412.216766 724.563782,412.058350 723.418701,411.568176 
	C722.997681,411.210815 722.868042,411.026123 722.808838,410.510376 
	C726.050964,409.373016 730.103821,409.614777 729.686279,404.182404 
	C732.065918,407.311890 730.254822,411.232727 732.095581,414.603027 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M715.897461,393.273926 
	C718.801819,390.822968 719.353943,393.716705 718.816101,394.847412 
	C717.403442,397.816986 719.205078,398.757751 721.206787,400.256256 
	C721.271240,401.495483 721.034546,402.338776 719.990723,403.214417 
	C717.105652,401.623138 716.286499,398.899139 715.281555,395.855957 
	C715.013184,395.356537 714.923279,395.180389 714.948120,394.731873 
	C715.320435,394.164917 715.566467,393.861145 715.897461,393.273926 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M719.629822,403.796265 
	C719.943787,402.638062 720.302917,401.877258 720.993408,400.849579 
	C723.763550,400.852966 723.465881,402.278351 723.015198,404.078186 
	C722.562988,405.884735 721.075684,407.629150 722.600220,409.920837 
	C722.879272,410.179291 722.871704,410.589050 722.929565,410.785614 
	C723.132690,411.136749 723.277954,411.291290 723.378967,411.762177 
	C722.984253,412.657593 722.467346,412.996399 721.505615,413.036926 
	C720.691772,410.024597 720.183411,407.109161 719.629822,403.796265 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M747.819519,417.264954 
	C747.185852,414.582092 746.910278,412.004883 746.406860,409.069244 
	C745.884949,406.337372 746.085327,404.018036 746.983521,401.378021 
	C747.179321,400.875061 747.330444,400.764282 747.704468,400.824738 
	C747.571960,406.108429 748.649536,411.115753 749.125854,416.606567 
	C749.210999,417.039703 749.008179,417.057861 748.912842,417.021973 
	C748.604248,417.114258 748.390930,417.242432 747.819519,417.264954 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M742.827271,409.615601 
	C741.206665,412.397400 744.330750,415.159393 742.100586,417.733490 
	C740.006592,416.017578 741.163269,413.802277 741.051086,411.435364 
	C741.151917,409.167725 741.237793,407.326660 741.333801,405.269135 
	C743.594055,406.291656 742.607910,407.934692 742.827271,409.615601 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M715.261719,425.570618 
	C714.874634,426.557861 714.479675,427.118134 713.725708,427.004639 
	C712.600037,426.835236 712.458374,425.742371 712.882812,425.188354 
	C714.594971,422.953430 715.267334,419.952484 718.179199,417.702484 
	C718.369202,421.139435 715.599365,422.704132 715.261719,425.570618 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M720.568604,426.706238 
	C720.612732,429.669098 720.381470,432.422791 720.180054,435.601379 
	C720.004150,436.934570 720.430542,438.040314 718.984558,438.927216 
	C717.339111,434.993530 719.200867,431.259033 719.523438,427.259155 
	C719.958862,426.814758 720.126038,426.655945 720.568604,426.706238 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M721.231567,413.301636 
	C721.526123,412.713745 721.852051,412.487457 722.340088,412.143372 
	C723.626831,411.238373 724.895325,411.578674 726.543335,411.754822 
	C726.968201,411.945709 726.965881,411.994141 726.989868,411.999634 
	C726.833008,414.223938 724.703003,414.179230 723.155273,415.288025 
	C722.130798,416.002533 721.362000,416.536621 720.537537,417.109375 
	C719.884888,415.589020 721.220642,414.787964 721.231567,413.301636 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M739.167847,410.632141 
	C738.724487,412.024719 738.177185,413.067413 737.284546,414.218384 
	C736.678162,411.217255 736.417175,408.107788 736.139832,404.591400 
	C736.300842,403.969696 736.478210,403.754944 736.750977,403.947021 
	C737.585510,406.329956 738.324768,408.306091 739.167847,410.632141 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M727.239868,454.349030 
	C725.867554,454.291077 725.219604,454.913208 724.833130,456.408875 
	C720.835693,456.381348 723.078674,453.124359 723.516113,452.332428 
	C724.474487,450.597351 725.398132,452.886383 726.763184,453.336060 
	C727.183350,453.630493 727.270508,453.834290 727.239868,454.349030 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M708.882690,434.165100 
	C707.836304,432.889771 706.954163,431.276947 706.074951,429.315186 
	C708.054993,429.983582 713.037537,429.165314 708.882690,434.165100 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M736.890869,403.946167 
	C736.846252,404.353821 736.487915,404.249756 736.305664,404.217102 
	C735.786377,402.693329 732.438110,403.488800 733.602783,400.900970 
	C733.912659,400.212524 734.282959,399.187347 735.282654,399.490173 
	C737.385010,400.126984 736.901611,401.971039 736.890869,403.946167 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M713.813782,411.414307 
	C715.066101,414.039520 712.846985,414.348419 711.408630,415.579773 
	C710.588867,413.081970 712.080872,412.275269 713.813782,411.414307 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M724.020325,418.632568 
	C725.578735,418.114227 727.043274,417.975494 729.516174,417.741211 
	C727.334473,419.232758 725.989136,420.152466 724.298340,421.022491 
	C722.845581,420.334076 723.773621,419.667877 724.020325,418.632568 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M718.201172,414.052002 
	C716.257751,415.012726 715.965637,414.054291 716.305603,412.727844 
	C716.494141,411.991760 717.120544,411.166565 718.025208,411.492249 
	C719.284302,411.945496 718.852112,412.937012 718.201172,414.052002 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M715.253235,395.151398 
	C715.011108,395.546600 715.057312,395.544952 715.080200,395.538818 
	C713.738892,396.215332 712.398926,396.287354 712.058411,394.516907 
	C711.807678,393.213470 712.991943,393.032227 714.426636,393.102173 
	C715.304810,393.557190 715.534973,394.099304 715.253235,395.151398 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M727.338379,454.870300 
	C727.200745,454.388153 727.234009,454.110870 727.158936,453.627380 
	C728.589722,452.615265 729.802063,454.481781 731.642700,453.928406 
	C731.833252,455.470795 730.203369,455.165802 729.200684,456.151794 
	C728.440552,455.882111 727.997681,455.481354 727.338379,454.870300 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M706.897705,412.181793 
	C708.114929,413.020935 708.400513,413.874054 707.187805,414.457886 
	C706.784851,414.651886 705.804138,414.362823 705.534119,413.979767 
	C704.756897,412.877228 705.362427,412.264099 706.897705,412.181793 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M735.180298,449.204956 
	C734.945007,449.022034 734.968750,448.530975 734.990173,448.286072 
	C736.066162,447.822754 737.120667,447.604370 738.501648,447.384399 
	C739.082825,447.431732 739.337585,447.480621 739.430542,447.883362 
	C738.199280,449.340485 736.887085,449.631042 735.180298,449.204956 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M713.970337,439.905884 
	C716.167053,440.334808 715.849670,441.999756 716.060303,443.769623 
	C715.292175,444.480804 714.831238,444.035004 714.172485,443.277405 
	C713.948181,443.035767 714.000000,443.001221 713.973877,443.019775 
	C713.541992,442.509796 713.379395,441.887909 713.309448,440.927734 
	C713.462952,440.416809 713.567993,440.227234 713.970337,439.905884 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M731.355103,397.953125 
	C731.566711,396.735779 730.207458,395.216248 731.934204,394.021729 
	C732.418640,394.205719 732.480896,394.391022 732.766968,394.765808 
	C733.064880,396.157715 733.334717,397.447083 731.355103,397.953125 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M712.080322,437.794373 
	C711.949707,437.487122 711.914368,437.481537 711.899963,437.494934 
	C712.098999,436.857239 711.639404,435.472809 712.746277,435.760529 
	C714.269226,436.156403 713.867859,437.866943 714.192566,439.428467 
	C714.267517,439.774139 714.099426,439.913025 714.018311,439.985840 
	C713.736145,440.157166 713.535217,440.255737 713.043945,440.185913 
	C712.483093,439.404266 712.552551,438.694733 712.080322,437.794373 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M729.376282,399.277588 
	C728.686646,399.579163 728.061951,399.485016 727.450989,399.334900 
	C726.460327,399.091431 724.647461,399.178833 725.184998,397.751862 
	C725.851257,395.983459 727.252869,397.529053 728.703369,397.965240 
	C729.201294,398.343658 729.324341,398.600189 729.376282,399.277588 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M729.538452,399.796570 
	C729.252075,399.431824 729.198975,399.165192 729.112061,398.492798 
	C729.508911,398.057312 729.939514,398.027527 730.696045,398.009888 
	C731.021973,398.022034 730.997803,397.998138 730.985168,397.986389 
	C731.108398,398.949951 730.937500,399.733429 729.538452,399.796570 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M722.688049,421.704529 
	C723.283264,423.243225 722.412292,423.889496 721.245239,424.263428 
	C720.806396,422.794922 721.585632,422.122986 722.688049,421.704529 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M715.321777,395.488342 
	C714.957642,395.009857 714.904236,394.473114 714.827332,393.533264 
	C715.000977,393.099121 715.197998,393.068115 715.693665,393.017822 
	C717.130188,393.995239 716.606628,394.746002 715.321777,395.488342 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M713.892944,443.357666 
	C714.463196,443.327698 714.978149,443.619659 715.771118,444.027405 
	C715.983521,444.380890 715.917969,444.618622 715.681030,445.187836 
	C714.952271,444.906067 714.394958,444.292816 713.892944,443.357666 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M735.295532,419.042542 
	C734.900452,418.782440 734.833130,418.515106 734.869324,417.847473 
	C735.146301,417.434814 735.319763,417.422485 735.741211,417.491150 
	C736.584961,417.826294 737.180847,418.080444 737.939392,418.617188 
	C738.063965,419.075348 738.025879,419.250885 737.736084,419.522461 
	C736.863953,419.424103 736.243591,419.229706 735.295532,419.042542 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M720.955200,426.502808 
	C720.668152,426.917053 720.492310,426.918701 720.054077,426.946960 
	C719.962280,426.042358 720.132874,425.111115 720.640991,424.062012 
	C722.307800,424.606323 721.018005,425.375671 720.955200,426.502808 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M723.083984,434.147583 
	C724.247925,434.061829 724.645325,434.635132 723.745728,435.912292 
	C723.620422,436.160187 723.221924,436.165161 723.030396,436.106934 
	C722.904236,435.541626 722.969604,435.034546 723.083984,434.147583 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M744.984436,395.308350 
	C745.295593,395.500793 745.633972,396.014313 745.994385,396.856384 
	C745.681519,396.666443 745.346619,396.147949 744.984436,395.308350 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M745.979858,398.146545 
	C746.293091,398.338898 746.624817,398.859833 746.980957,399.703125 
	C746.669800,399.508667 746.334106,398.991913 745.979858,398.146545 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M714.280945,389.565552 
	C714.613403,389.415955 715.164307,389.426331 715.914307,389.640259 
	C715.575378,389.804382 715.037354,389.764954 714.280945,389.565552 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M733.925171,415.804504 
	C733.457703,415.913147 732.872986,415.712952 732.132385,415.244171 
	C732.586975,415.148926 733.197449,415.322296 733.925171,415.804504 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M723.795837,436.441376 
	C724.345032,436.256958 724.900024,435.871002 725.286255,436.563171 
	C725.000183,436.659424 724.714172,436.755676 724.148682,436.796326 
	C723.869324,436.740753 723.753662,436.546326 723.795837,436.441376 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M739.569580,448.230896 
	C739.146118,448.120270 739.023376,448.003265 738.864319,447.634521 
	C739.311890,447.190826 739.795776,446.998840 740.664001,446.896912 
	C740.655701,447.399475 740.263062,447.811981 739.569580,448.230896 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M728.126404,392.392365 
	C728.334900,392.187195 728.603088,392.309631 728.917419,392.779602 
	C728.728455,392.926514 728.469360,392.790802 728.126404,392.392365 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M720.134644,390.819275 
	C720.153687,390.677368 720.535400,390.582794 721.071411,390.644226 
	C720.982910,390.822327 720.740112,390.844452 720.134644,390.819275 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M732.924316,394.774719 
	C732.719177,394.861420 732.525391,394.683014 732.382935,394.220276 
	C732.565979,394.174561 732.733154,394.365784 732.924316,394.774719 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M747.844299,400.767761 
	C747.927429,400.995972 747.477783,400.980133 747.252991,400.982971 
	C747.006592,400.820068 746.985046,400.654297 746.970825,400.237762 
	C747.304626,400.078339 747.565674,400.262512 747.844299,400.767761 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M711.431030,433.379089 
	C711.538757,433.285339 711.589294,433.616669 711.589294,433.616669 
	C711.589294,433.616669 711.323364,433.472809 711.431030,433.379089 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M722.799500,440.077026 
	C722.954712,440.160980 722.948975,440.330933 722.911621,440.753967 
	C722.735229,440.827209 722.570740,440.658508 722.459534,440.459961 
	C722.431580,440.410034 722.574219,440.264557 722.799500,440.077026 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M741.282227,447.032166 
	C741.097290,446.619629 741.212158,446.194702 741.682983,445.884613 
	C741.886597,446.339569 741.734314,446.679657 741.282227,447.032166 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M723.572998,420.790710 
	C723.838867,421.331757 723.716919,421.697937 723.271851,422.028870 
	C722.518433,421.446991 722.601990,420.988556 723.572998,420.790710 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M696.009521,364.473694 
	C685.121094,364.393433 675.202698,367.457397 665.633423,373.121460 
	C663.538330,372.353943 664.639160,370.808258 664.323486,369.244202 
	C661.782532,367.040314 657.256836,369.238983 656.083984,364.103821 
	C655.723511,363.086975 655.563477,362.699341 655.507324,361.946167 
	C655.687927,361.189117 655.944275,360.828491 656.575623,360.345337 
	C660.156616,359.256500 663.583313,359.556976 666.303162,358.974884 
	C663.204529,358.917999 659.399902,360.390320 655.578125,357.983704 
	C654.551086,356.132599 654.571899,354.532074 655.224365,352.548309 
	C657.876099,349.797607 661.013611,350.781708 663.905640,350.537750 
	C665.863770,350.372559 667.865662,350.825378 670.198669,350.037689 
	C665.752686,348.712830 661.357605,350.350464 657.043823,348.424988 
	C656.067139,347.300568 655.933167,346.290741 656.190674,344.860291 
	C660.103394,341.028046 664.682068,343.332642 668.339844,342.769287 
	C665.251160,342.293579 661.615601,342.192902 657.646973,342.760010 
	C657.107239,342.746765 656.896057,342.713135 656.401733,342.550110 
	C655.614319,342.215302 656.000183,341.247253 654.584106,341.292236 
	C653.840820,341.125427 653.687195,340.984192 653.388550,340.558899 
	C652.973572,339.409271 653.018616,338.543396 653.367432,337.356445 
	C653.623169,336.840027 653.752136,336.644470 654.116638,336.182251 
	C654.869629,335.391235 655.399902,334.881500 656.354248,334.281555 
	C657.202820,333.913361 657.719910,333.779572 658.666199,333.664001 
	C663.371521,333.735748 667.681824,333.172577 672.321655,334.221680 
	C673.135864,334.753754 673.417542,335.193024 673.494751,336.117188 
	C671.366577,338.584412 668.853333,337.048370 666.730469,337.290283 
	C668.757568,337.666840 670.987427,337.544006 673.566162,337.358276 
	C675.976257,337.640106 676.782532,339.150208 677.348877,340.376038 
	C675.377808,337.484650 675.576599,334.244141 678.482300,330.969482 
	C680.766724,329.527405 682.584961,330.518127 684.466553,331.185120 
	C686.325745,331.844147 688.158325,332.816467 690.615479,332.081879 
	C692.691711,331.691559 694.425598,331.509888 696.478516,331.002075 
	C699.089722,330.489105 701.199097,331.380554 703.731201,331.618713 
	C704.316895,331.649841 704.549072,331.663940 705.124695,331.711121 
	C706.581848,331.894531 707.648560,332.217316 708.990845,332.739258 
	C709.482239,332.939087 709.675537,333.021973 710.156006,333.223633 
	C710.832642,333.477875 711.228149,333.591675 711.941284,333.712891 
	C714.177368,333.859741 716.072693,334.125305 718.161377,334.995941 
	C719.006775,335.389496 719.566223,335.629456 720.536987,335.287598 
	C721.120117,335.191467 721.364746,335.181152 721.983276,335.243713 
	C722.870605,335.511078 723.284912,335.835144 723.805908,336.655853 
	C725.040771,342.049225 724.514954,347.102142 724.325684,352.593201 
	C722.075562,361.978729 722.075439,361.956451 712.443909,362.006775 
	C707.329590,362.033508 702.235718,362.754730 696.662109,362.581482 
	C696.150574,363.140961 696.087769,363.624451 696.009521,364.473694 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M782.566284,427.756897 
	C782.365906,432.526733 784.310913,437.444885 780.885010,441.728577 
	C781.100525,442.472412 781.139038,443.142395 780.661560,443.294678 
	C772.976868,445.745331 765.490295,448.925781 757.004517,449.516541 
	C755.487244,447.604248 756.011169,445.692474 756.070496,443.392395 
	C757.672852,441.619629 759.842590,441.998535 761.461121,440.825317 
	C759.778931,440.811218 758.062073,442.659058 756.298706,440.401001 
	C756.201416,439.495972 756.289246,438.887573 756.625732,438.082977 
	C757.060852,438.201050 757.329590,438.339325 757.826172,438.052887 
	C757.957214,437.835449 757.967224,437.975159 757.897217,437.974487 
	C764.866882,431.907227 773.170532,428.793518 782.566284,427.756897 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M748.253296,382.610229 
	C746.614197,382.718689 745.235657,382.493500 743.518005,382.171631 
	C741.517456,382.067200 740.252930,381.130493 739.455261,379.894012 
	C736.593994,375.458313 730.981934,374.314880 727.973083,370.116089 
	C727.152161,368.970520 725.533325,368.106201 726.239075,366.305206 
	C727.065369,364.196747 729.131531,365.156128 730.602112,364.776001 
	C732.829651,364.200195 734.616516,365.905151 736.838135,366.810974 
	C737.771729,367.721100 738.697693,367.406342 739.769226,367.812714 
	C740.031616,367.999969 739.992615,368.008881 739.991455,367.988861 
	C740.203064,368.212097 740.426086,368.445496 740.838257,368.832428 
	C741.017029,368.995850 740.997131,369.000183 741.000427,368.990234 
	C741.184326,369.362366 741.460938,369.453735 742.028320,369.102112 
	C742.468079,368.484253 742.713074,368.018707 742.974182,367.280823 
	C743.170837,366.837341 743.351501,366.666199 743.890320,366.377228 
	C744.501709,366.279083 744.754944,366.298737 745.368652,366.450287 
	C746.432007,366.940552 747.040527,367.414764 747.708069,368.394409 
	C748.860168,371.558136 747.885071,374.588318 748.957886,377.801514 
	C749.276611,379.613495 749.310425,381.000336 748.253296,382.610229 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M696.653198,362.784332 
	C703.205139,361.698669 710.241699,360.814209 717.279541,361.138489 
	C721.660278,361.340363 723.278748,360.037598 722.478943,355.751984 
	C722.362305,355.126923 722.564270,354.442383 722.765137,353.402527 
	C725.102173,351.803223 725.650452,353.316681 725.630676,354.916992 
	C725.590088,358.209564 727.603088,358.700439 730.181152,358.676941 
	C731.173096,358.667908 732.163513,358.749786 733.153442,358.831909 
	C738.279236,359.257416 738.343872,359.242981 737.494812,353.904572 
	C737.232117,352.253052 737.506165,350.966583 738.759033,349.906250 
	C740.815247,348.166046 742.089722,345.811066 743.911438,343.418640 
	C744.326660,342.965179 744.512268,342.798920 745.028320,342.449097 
	C746.602661,341.813171 747.843628,341.809357 749.391235,342.490112 
	C750.667603,344.118042 749.454285,344.820496 748.640808,345.498108 
	C745.821716,347.846039 744.987915,350.832581 745.577209,354.695984 
	C745.581116,355.300110 745.558655,355.542847 745.439697,356.139709 
	C744.153320,358.721313 744.624023,361.348724 743.389648,363.921936 
	C742.689453,364.476471 742.196350,364.563843 741.333313,364.303284 
	C735.366516,362.600281 729.514526,361.788147 723.839783,362.444580 
	C714.895569,363.479187 706.002014,362.681152 696.653198,362.784332 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M781.746460,466.786377 
	C783.317627,469.581543 781.712769,472.184570 782.100830,475.128784 
	C775.934326,479.011719 769.738708,478.423035 763.142212,475.340881 
	C762.487305,474.580780 762.214783,474.134216 761.892456,473.420349 
	C763.744995,470.500580 767.030396,471.392151 770.015198,469.960968 
	C768.097717,468.431305 766.364014,467.564301 764.208069,468.528381 
	C762.301208,469.380981 760.995178,469.289856 760.620605,466.577942 
	C765.812378,461.777252 772.200012,461.427155 778.772766,461.024170 
	C779.768494,462.417633 782.153381,461.067963 782.002563,463.697266 
	C781.085938,466.833557 777.366760,466.368774 776.023682,469.445679 
	C778.265686,468.604919 778.870667,465.433411 781.746460,466.786377 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M778.767029,405.839111 
	C782.714722,406.817017 782.381775,408.919006 780.947571,411.765015 
	C780.510986,412.855621 779.881470,413.558075 779.083191,413.671509 
	C772.363037,414.626495 766.380615,418.607513 759.062256,418.216217 
	C757.446289,416.449860 758.056885,414.573425 757.787659,412.467957 
	C764.285217,408.671387 771.139404,406.383575 778.767029,405.839111 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M782.472595,444.684509 
	C782.683350,446.396332 782.581055,447.852722 782.270203,449.614716 
	C774.246521,452.503998 766.605896,455.822479 757.799805,455.387512 
	C757.105530,453.918549 756.737061,452.666870 756.525146,451.056000 
	C765.087097,448.252899 773.145874,444.399933 782.472595,444.684509 
z"/>
<path fill="#738CA3" opacity="1.000000" stroke="none" 
	d="
M758.551025,435.330780 
	C758.147949,433.733521 758.091187,432.312683 758.124878,430.469818 
	C758.359680,429.905579 758.504089,429.763428 758.946106,429.674744 
	C760.236328,427.530029 761.924988,426.146027 764.187439,425.358612 
	C769.282227,423.585419 774.168396,420.982086 780.118652,421.761932 
	C780.828857,422.670044 780.980713,423.407776 780.894348,424.572968 
	C780.497498,425.960754 779.808594,426.692047 778.876587,427.087799 
	C772.224609,429.912598 765.709290,433.062653 758.551025,435.330780 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M758.759766,418.398529 
	C765.965454,416.406982 772.825989,413.375763 780.588501,412.255310 
	C783.173218,412.133484 782.832581,413.893066 783.022278,415.606995 
	C781.215881,417.743622 778.739014,417.812897 776.253418,418.838715 
	C770.107605,419.344391 765.132324,422.654724 759.150940,423.215271 
	C758.820007,421.595184 758.806702,420.205322 758.759766,418.398529 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M784.891479,491.205658 
	C787.028564,491.248657 789.060181,490.396118 790.957764,492.109589 
	C794.445679,493.808289 797.969543,494.345825 801.684204,495.496307 
	C803.811340,495.611572 805.596497,495.534058 807.587158,496.471558 
	C807.217102,499.180756 805.823059,501.009766 802.875916,501.881042 
	C802.526611,502.044037 802.048096,502.163940 802.048096,502.163940 
	C802.048096,502.163940 801.556946,502.118164 801.313354,502.081635 
	C800.303040,501.298523 799.381653,501.487610 798.197449,501.828003 
	C793.743408,499.222961 789.562378,496.405243 785.188599,493.312073 
	C784.611206,492.590698 784.480530,492.079803 784.891479,491.205658 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M781.388306,451.549316 
	C782.924194,453.431732 782.738525,455.208008 782.171997,457.359802 
	C781.004944,459.844147 778.814514,459.772247 776.468506,460.164734 
	C774.043274,459.972992 771.988037,459.655334 769.596436,460.122925 
	C769.055908,460.282349 768.834717,460.331299 768.274048,460.360901 
	C764.811462,459.182587 761.742615,461.487244 758.350464,460.283508 
	C758.031372,459.586853 757.983765,459.094147 758.003540,458.235657 
	C763.360046,454.045685 770.092896,454.638885 775.820557,452.094666 
	C777.388733,451.398041 779.140991,450.405792 781.388306,451.549316 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M804.438599,518.844910 
	C801.887390,522.829468 797.015930,524.548889 793.394470,528.318481 
	C789.421326,522.110291 788.519165,521.823853 783.063904,525.335022 
	C782.457153,525.725525 781.876465,525.785706 781.086792,525.065063 
	C783.255554,521.246155 786.412659,519.758789 790.810059,519.884399 
	C795.200256,520.009705 799.616089,519.235901 804.438599,518.844910 
z"/>
<path fill="#6A7594" opacity="1.000000" stroke="none" 
	d="
M780.628052,396.687073 
	C783.571045,399.039429 783.016296,401.865906 782.330444,404.804474 
	C781.365479,404.243500 780.441589,403.989746 779.448486,403.228210 
	C778.941711,402.784058 778.704895,402.385040 778.444946,402.370117 
	C771.393372,401.965057 764.429138,402.026154 758.210938,406.840240 
	C757.867981,407.312988 757.715515,407.491760 757.264709,407.858032 
	C755.689758,406.526459 754.832642,404.860352 755.034485,402.430420 
	C760.166199,398.884521 766.364929,398.549591 772.280701,396.205200 
	C775.213135,396.721344 777.824707,395.236298 780.628052,396.687073 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M794.619385,513.805664 
	C791.788025,510.057922 786.723083,509.751282 784.350647,505.979156 
	C786.140747,504.557251 789.008972,505.068146 789.927673,502.072968 
	C792.323303,503.768768 794.674500,505.786072 796.952454,507.882843 
	C798.234741,509.063171 798.724609,510.435944 798.213257,512.305115 
	C797.671570,514.285400 796.654602,514.600037 794.619385,513.805664 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M761.861572,389.880249 
	C765.636597,390.625366 768.361755,387.921051 771.590515,386.867554 
	C773.460266,386.257355 775.334167,385.659454 777.588501,384.996674 
	C776.758728,387.712799 773.739746,387.413635 771.326904,388.833679 
	C767.906189,393.443085 763.863403,396.759399 758.633423,399.171143 
	C757.928467,399.531982 757.496399,399.641144 756.720459,399.629150 
	C755.374573,399.324524 754.684875,398.366058 753.316040,398.109222 
	C752.756531,397.546600 752.474121,397.118988 752.143982,396.428284 
	C754.440613,392.968628 758.131714,391.970551 761.723389,390.160553 
	C761.964783,389.905090 761.876709,389.922546 761.861572,389.880249 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M774.720520,459.205322 
	C777.192627,458.694305 779.291565,458.302765 781.783997,457.807129 
	C783.919373,460.644714 781.634949,460.731689 779.411133,461.207825 
	C773.065186,462.733948 766.983093,463.854889 761.101624,466.644073 
	C760.803650,467.148346 760.685181,467.331055 760.348022,467.271149 
	C759.465576,466.059235 758.741150,465.109497 759.173462,463.467712 
	C761.888916,460.969116 764.812256,459.728851 768.650757,460.137787 
	C769.004517,460.010834 769.000000,460.000000 769.004272,460.003296 
	C770.694885,459.049652 772.579773,459.646667 774.720520,459.205322 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M758.049316,435.527283 
	C765.039001,431.496429 772.087524,428.328766 779.745483,425.705505 
	C780.274353,424.172516 781.258423,424.403290 782.587769,424.776764 
	C783.025635,425.774048 783.067505,426.521149 782.990967,427.633057 
	C774.185547,429.846100 766.273132,433.614624 758.180908,437.894165 
	C756.801331,437.248901 757.693726,436.585724 758.049316,435.527283 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M762.736267,475.396179 
	C768.830261,477.018616 775.028687,475.931915 781.641357,475.645081 
	C783.176636,476.431335 783.180237,477.530273 782.326538,478.963318 
	C777.263367,481.837921 772.010254,480.502838 766.578247,480.914856 
	C765.692932,480.855988 765.219482,480.695770 764.529907,480.148926 
	C763.756836,478.498627 763.234741,477.131775 762.736267,475.396179 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M781.874878,451.474426 
	C774.101929,453.787323 766.475586,455.803802 758.460083,457.845032 
	C757.825806,457.159393 757.580627,456.448975 757.404724,455.454407 
	C764.727051,453.635071 772.042358,452.350708 778.955261,449.493835 
	C779.593018,449.230286 780.547119,449.731964 781.708008,449.899292 
	C782.048279,450.339539 782.034851,450.758789 781.874878,451.474426 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M782.880981,444.568695 
	C774.320374,446.857269 765.855103,448.774628 757.035828,450.694397 
	C756.575745,450.395355 756.537476,450.085510 756.612305,449.535767 
	C764.636292,447.071289 772.614807,444.838379 780.816528,442.288574 
	C783.021545,441.550812 783.059631,442.821350 782.880981,444.568695 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M758.626221,423.182678 
	C764.067200,420.890808 769.087524,418.134918 775.291138,417.769043 
	C776.854797,417.479675 777.974243,417.334076 778.425537,419.242249 
	C772.721558,423.555389 766.004517,424.587097 759.249817,426.234375 
	C758.050659,425.263397 758.259033,424.317352 758.626221,423.182678 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M760.040894,467.390076 
	C760.129333,467.028564 760.525208,466.987061 760.723694,466.976318 
	C761.423035,467.533142 762.132446,468.877106 762.644409,468.182861 
	C765.773315,463.939972 768.532166,468.765289 771.461914,468.427948 
	C771.773071,468.392151 772.494385,469.351410 772.514954,469.869354 
	C772.565308,471.131409 771.391602,471.440155 770.463257,471.635315 
	C767.881958,472.177826 765.271118,472.580200 762.257324,473.095459 
	C760.981262,471.433472 759.917236,469.784851 760.040894,467.390076 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M758.827393,426.357544 
	C764.979309,423.987427 771.049622,421.964081 777.487061,419.833954 
	C778.585083,419.349976 779.281250,419.412689 780.138855,420.211304 
	C780.330017,420.779144 780.326843,421.027985 780.078308,421.558228 
	C774.179749,423.058624 768.694824,424.799347 763.386902,427.101685 
	C761.677917,427.842987 760.012085,428.584167 759.848389,430.794220 
	C759.839294,430.917419 759.722534,431.032654 759.655945,431.151611 
	C759.462219,430.944061 759.268494,430.736542 759.022461,430.253845 
	C758.837463,429.810944 758.704773,429.643280 758.614502,429.157654 
	C758.686584,428.127899 758.716187,427.416107 758.827393,426.357544 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M779.783081,402.688934 
	C781.087708,402.882751 781.948669,403.081573 781.997681,404.629517 
	C781.193420,405.250092 780.414062,405.531219 779.355530,405.960510 
	C772.252686,408.053894 765.428955,409.999115 758.194458,412.011810 
	C757.557556,411.623047 757.331421,411.166870 757.202148,410.451904 
	C758.562744,408.287079 760.878418,408.589417 762.921570,407.536255 
	C763.445496,407.328949 763.656982,407.249023 764.190369,407.058319 
	C766.270508,406.452271 768.017395,405.922028 770.043457,405.109650 
	C773.399353,404.192413 776.199036,402.550507 779.783081,402.688934 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M703.820190,372.253052 
	C705.676208,369.009430 708.659302,369.005737 711.712524,368.333679 
	C714.454285,368.122437 716.655518,368.916168 718.800842,370.801300 
	C719.208130,371.146667 719.300171,371.337219 719.185059,371.768311 
	C718.545227,371.986450 718.112549,371.964081 717.358276,371.993286 
	C715.736206,373.291504 714.047974,373.374634 712.059570,373.614197 
	C709.629456,373.091522 707.861511,374.373016 705.577515,374.603668 
	C704.797913,374.393494 704.415894,374.139771 703.890625,373.517212 
	C703.665833,372.989685 703.631775,372.757629 703.820190,372.253052 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M755.930542,399.104004 
	C756.624084,399.095306 757.025452,399.054047 757.728455,398.988281 
	C761.329224,397.411957 764.496582,395.463898 768.713501,395.649048 
	C770.178162,395.525757 771.265137,395.288605 772.680908,394.975830 
	C774.902405,394.925842 774.027283,395.905151 773.319641,396.898743 
	C767.299927,398.865112 761.816467,401.423279 755.355042,402.025909 
	C754.676941,401.602692 754.408264,401.136108 754.236816,400.389740 
	C754.567871,399.511444 755.027283,399.196198 755.930542,399.104004 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M710.750122,373.306885 
	C712.716309,372.449371 714.386963,371.780457 716.651978,371.953766 
	C717.029602,372.723083 717.022583,373.401306 717.034912,374.418335 
	C714.012085,376.345154 710.706482,377.478333 707.873108,380.062439 
	C706.935547,380.120392 706.278015,380.026489 705.126831,379.865967 
	C705.333923,376.549255 707.759338,374.831787 710.750122,373.306885 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M768.721558,459.824524 
	C766.008057,461.035583 763.011658,462.060333 759.634705,463.103821 
	C758.692993,462.411682 757.817200,461.871063 758.029541,460.423950 
	C761.536865,460.041809 764.878906,457.284821 768.721558,459.824524 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M777.985840,485.999939 
	C777.920227,487.588806 777.263306,488.996399 779.319214,489.808624 
	C775.558960,491.160828 772.851929,489.413239 770.864380,485.905945 
	C770.858276,485.341003 770.748535,485.116211 770.929443,484.656525 
	C771.897766,484.095490 772.621643,483.963623 773.728210,483.906067 
	C774.575195,483.935577 775.051697,484.013000 775.864990,484.239746 
	C776.874268,484.652893 777.450256,485.071777 777.985840,485.999939 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M756.057251,440.457031 
	C759.073303,441.641571 761.786560,438.085114 765.177551,439.843140 
	C762.778259,442.272644 760.110779,443.185699 756.560913,442.931641 
	C756.110413,442.226044 756.055725,441.517914 756.057251,440.457031 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M764.218506,480.232544 
	C764.651184,479.871918 765.023376,479.878387 765.673218,479.921997 
	C767.029297,480.708008 768.368958,479.821136 769.807861,480.648743 
	C771.231873,481.655579 771.683350,482.773621 771.250854,484.463562 
	C771.031372,484.777222 771.045776,485.175110 771.006958,485.370453 
	C767.395691,485.696350 765.423279,483.632812 764.218506,480.232544 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M802.926758,502.127441 
	C804.754883,501.266541 804.754395,497.979187 807.676453,497.479370 
	C809.059692,495.838928 810.148865,496.495239 811.497803,497.606567 
	C811.760864,497.887787 812.004639,497.976776 812.123901,498.029205 
	C809.909546,500.836639 806.181519,500.580719 802.926758,502.127441 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M761.678101,389.595398 
	C759.920105,393.488068 755.174255,392.894592 752.417175,396.018799 
	C752.048523,395.902649 752.000916,395.640106 751.925293,394.978119 
	C754.551270,391.898102 758.032593,390.701752 761.678101,389.595398 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M754.074829,417.074524 
	C753.811646,417.141083 753.422607,417.083954 753.234741,417.025635 
	C752.685913,413.459198 752.324951,409.951141 751.900452,405.825928 
	C754.212097,408.974152 754.899963,412.034088 754.974487,415.678833 
	C754.672607,416.369904 754.488770,416.679077 754.074829,417.074524 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M763.825073,407.743378 
	C762.245911,409.223877 760.276245,410.102173 757.671509,410.226501 
	C757.266541,409.717499 757.234070,409.241852 757.083984,408.405823 
	C756.987122,407.854065 757.007996,407.662628 757.058533,407.183838 
	C759.322571,406.085083 761.457031,406.466827 763.825073,407.743378 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M753.814087,417.429932 
	C754.013855,416.859894 754.216064,416.578674 754.654297,416.189178 
	C754.929626,419.075226 754.969055,422.069611 754.933472,425.507996 
	C754.734741,426.136658 754.610962,426.321289 754.290527,426.236664 
	C753.305481,424.327972 753.819397,422.636871 753.883667,420.540222 
	C753.788330,419.910797 753.704834,419.704254 753.739990,419.185303 
	C753.844604,418.488190 753.830566,418.103485 753.814087,417.429932 
z"/>
<path fill="#100622" opacity="1.000000" stroke="none" 
	d="
M741.003296,364.464355 
	C741.401550,364.075684 741.810120,364.029663 742.527954,364.007874 
	C743.907959,364.138702 744.430176,364.862976 744.831726,366.113220 
	C744.559998,366.556976 744.248474,366.655365 743.463623,366.881134 
	C741.604431,366.927338 740.986511,366.156738 741.003296,364.464355 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M784.746460,490.880676 
	C785.128418,491.379822 785.077454,491.852295 785.011230,492.680664 
	C783.473267,492.880066 781.861877,492.927338 780.977539,490.894226 
	C782.044495,490.993530 783.153076,491.168457 784.746460,490.880676 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M719.199646,372.271301 
	C719.033142,371.837555 719.088440,371.666321 719.129883,371.225586 
	C720.484924,371.392700 721.853699,371.829285 723.548218,372.369781 
	C721.850952,373.359894 720.633118,373.144287 719.199646,372.271301 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M756.166870,398.808899 
	C755.772461,399.436615 755.322205,399.736633 754.602905,400.073303 
	C753.960510,399.605743 753.587097,399.101532 753.126343,398.285767 
	C754.167297,397.511139 755.417114,396.312073 756.166870,398.808899 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M754.004028,426.348297 
	C754.093933,425.967407 754.476379,425.968781 754.667419,425.960388 
	C754.887756,427.385468 754.917114,428.818939 754.832520,430.669128 
	C754.513672,431.042358 754.308716,430.998779 753.845093,430.776184 
	C753.695557,429.307861 753.804871,428.018524 754.004028,426.348297 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M798.316040,502.086243 
	C798.693420,501.056213 799.598389,500.824249 800.872437,501.794373 
	C800.282349,502.074005 799.495056,502.102875 798.316040,502.086243 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M739.817505,367.745636 
	C739.175415,367.865295 738.319214,367.730621 737.258057,367.342255 
	C737.903137,367.222809 738.753296,367.357056 739.817505,367.745636 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M813.294189,498.068481 
	C813.071228,497.285431 813.071106,496.641693 813.292358,495.757935 
	C813.792358,495.495483 814.071045,495.473083 814.305847,495.867706 
	C814.238220,496.766296 814.214417,497.247864 814.092346,498.078979 
	C813.835083,498.354919 813.676025,498.281342 813.294189,498.068481 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M759.200256,479.816833 
	C759.790405,480.280212 760.307251,480.854553 759.638977,481.618103 
	C759.393982,481.333130 759.148926,481.048157 758.853882,480.470276 
	C758.803894,480.177338 759.068298,479.937164 759.200256,479.816833 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M779.852844,490.217224 
	C779.948425,489.637146 780.386719,489.090912 780.973816,490.215729 
	C780.732361,490.485168 780.470764,490.440063 779.852844,490.217224 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M803.577271,504.555969 
	C803.364990,504.572052 803.296021,504.468231 803.227051,504.364380 
	C803.391541,504.388306 803.556030,504.412231 803.577271,504.555969 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M804.034058,510.957092 
	C803.816833,510.903290 803.389343,510.907196 803.377747,510.839966 
	C803.295532,510.358765 803.483154,510.280426 803.904541,510.827332 
	C803.980042,511.030609 804.016296,510.981812 804.034058,510.957092 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M740.940430,368.747681 
	C740.732910,368.814484 740.448730,368.633148 740.077454,368.210327 
	C740.281494,368.145752 740.572693,368.322662 740.940430,368.747681 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M741.917358,368.920715 
	C741.951782,369.268097 741.795410,369.851898 741.096558,369.188904 
	C741.206299,368.950775 741.408936,368.921234 741.917358,368.920715 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M807.897705,508.787689 
	C807.687927,508.898590 807.428284,508.710144 807.115479,508.225433 
	C807.326538,508.110626 807.588379,508.297028 807.897705,508.787689 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M759.738037,535.955444 
	C759.736389,536.162048 759.460022,536.301392 759.073853,536.297729 
	C759.130493,536.065918 759.296875,535.977112 759.738037,535.955444 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M754.265747,433.964844 
	C753.980957,433.838074 753.986877,433.548920 754.304077,433.113464 
	C754.626160,433.255035 754.606506,433.533478 754.265747,433.964844 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M757.676758,437.642090 
	C757.816956,438.196136 757.912537,438.986938 757.026001,438.074860 
	C757.048340,437.740753 757.222290,437.594757 757.676758,437.642090 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M758.470764,428.984741 
	C758.761230,429.015350 758.865479,429.190948 758.969910,429.672607 
	C758.970154,429.978638 758.591370,430.006195 758.403320,430.026978 
	C758.099670,429.731293 758.122742,429.425293 758.470764,428.984741 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M633.665527,637.508423 
	C638.878723,632.512634 642.843506,633.286011 645.244446,639.578979 
	C648.249023,647.453979 651.206604,655.363708 652.098083,664.029968 
	C649.745667,663.917297 650.721191,659.450806 647.036926,660.764099 
	C645.800903,659.527649 645.702393,658.212402 644.817688,656.912720 
	C644.571777,656.468506 644.481079,656.287842 644.279724,655.828125 
	C644.044250,655.176270 643.922668,654.802551 643.696472,654.159790 
	C643.505066,653.717285 643.422363,653.542664 643.193848,653.116516 
	C642.713257,652.363953 642.341980,651.890442 641.776306,651.155823 
	C641.002075,649.942505 640.955200,648.800537 640.110962,647.111389 
	C640.894287,649.041321 641.173828,650.298340 641.087219,651.866943 
	C640.477234,652.112061 640.079346,652.079041 639.382019,652.034912 
	C636.911926,652.523071 635.804138,650.969604 635.491638,649.440857 
	C634.705933,645.598328 633.040955,641.893311 633.665527,637.508423 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M633.688049,636.941650 
	C635.909302,641.861267 634.821716,647.500916 638.749390,651.857727 
	C638.718384,656.579590 642.839355,659.749207 642.845581,664.574341 
	C642.488464,665.292297 642.063171,665.451294 641.283081,665.227417 
	C640.993896,665.020447 641.000366,665.000549 640.990723,665.003052 
	C638.423645,662.462952 638.526794,658.530334 636.010010,655.573364 
	C635.696289,655.079468 635.577759,654.876709 635.297607,654.359619 
	C634.940979,653.611755 634.744141,653.179138 634.404175,652.412476 
	C634.194092,651.843567 634.125732,651.609192 633.972290,651.016602 
	C633.237610,647.121704 632.439880,643.622986 631.101318,640.273438 
	C630.488525,638.740051 629.856018,637.227844 630.816284,635.265808 
	C632.544739,634.597656 632.864685,635.839539 633.688049,636.941650 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M644.869141,655.138062 
	C644.994202,655.451782 644.918091,655.558777 644.922119,655.624329 
	C645.817139,657.163452 646.274536,658.786011 646.783325,660.756348 
	C647.000000,661.047302 647.001709,661.002625 646.978760,661.005005 
	C647.429260,662.818604 648.880432,664.391418 648.169189,667.605896 
	C644.252930,662.790833 642.912598,657.666626 640.916504,652.509399 
	C640.298218,649.448059 638.994507,647.096375 637.347839,644.813721 
	C640.969360,645.080811 641.379150,648.039307 642.594971,650.740479 
	C643.359680,651.372192 643.473083,651.972717 643.810791,652.792725 
	C643.993103,653.033264 644.008301,652.995483 643.988159,652.992859 
	C644.491150,653.489746 644.473816,654.217896 644.869141,655.138062 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M631.037354,634.986084 
	C631.780762,640.525208 635.232178,645.399109 635.035034,651.588989 
	C632.000122,650.875793 632.394348,647.854797 631.205078,645.304321 
	C630.973694,645.023682 630.997131,645.000000 630.981323,645.006836 
	C630.087891,642.949341 628.637390,641.106506 628.764771,638.435669 
	C629.230347,637.302490 629.470215,636.474365 629.841003,635.345703 
	C630.134766,634.863464 630.297607,634.681702 630.742310,634.733459 
	C631.024170,634.966980 631.021301,634.995667 631.037354,634.986084 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M635.750793,654.333862 
	C638.820496,656.844543 640.069885,660.464905 640.986694,664.625122 
	C638.853088,664.812012 637.665344,663.554443 637.093750,661.234619 
	C637.552673,660.456909 637.518921,659.942932 637.143921,659.199585 
	C636.960632,658.996643 637.004639,658.995605 636.996338,659.015991 
	C636.585999,658.576233 636.527466,657.979370 636.155518,657.212158 
	C635.961975,656.994019 636.007080,656.998657 635.996643,657.018738 
	C635.474670,656.321899 635.258606,655.545227 635.750793,654.333862 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M628.735962,637.910400 
	C629.667664,640.177795 630.344727,642.224854 630.993713,644.642822 
	C627.628662,642.072021 626.777832,637.844055 624.215088,633.130249 
	C627.183838,634.463928 627.458618,636.401550 628.735962,637.910400 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M635.997192,653.997192 
	C635.994812,654.754700 635.996094,655.515930 635.991821,656.658020 
	C632.616150,654.052246 631.889404,649.851074 630.899109,645.414490 
	C633.085022,646.709290 633.278931,649.412415 634.732239,651.800293 
	C635.004944,652.008545 634.999451,651.999207 634.996704,651.995239 
	C635.418640,652.432739 635.475037,653.022278 635.817627,653.791138 
	C636.006226,654.009827 636.000732,654.000916 635.997192,653.997192 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M641.039917,665.342285 
	C641.406860,665.003906 641.819824,664.987366 642.540405,664.964111 
	C643.459167,665.340088 643.975281,665.976318 643.348022,666.503479 
	C642.314758,667.371826 641.545593,666.754517 641.039917,665.342285 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M631.068726,634.693604 
	C630.849304,634.986328 630.674500,635.005615 630.235840,635.035095 
	C630.071106,634.623535 630.170227,634.201904 630.269348,633.780212 
	C630.550659,633.993530 630.831970,634.206848 631.068726,634.693604 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M635.954651,657.306152 
	C636.292786,657.471558 636.623596,657.949036 636.971252,658.731445 
	C636.641174,658.563721 636.294250,658.091003 635.954651,657.306152 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M636.938599,659.313477 
	C637.661377,659.363281 637.972839,659.861206 637.293762,660.753418 
	C637.025024,660.467468 636.970825,660.048889 636.938599,659.313477 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M804.640259,671.816284 
	C804.199524,678.108398 801.434998,681.325012 796.268066,681.521301 
	C793.965637,679.417480 791.469788,677.594421 792.493103,674.336304 
	C793.327515,671.679260 794.390198,668.818542 797.454102,668.050049 
	C800.575867,667.266968 802.746338,669.081116 804.640259,671.816284 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M794.753906,697.492981 
	C793.998535,698.467957 793.281677,699.158325 792.275879,699.933899 
	C791.671021,698.744873 792.718140,697.952576 793.186401,696.601318 
	C794.149658,696.008484 794.784729,696.098694 794.753906,697.492981 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M695.443237,629.086365 
	C696.108643,629.618652 696.080688,630.986938 695.707886,630.969788 
	C694.718079,630.924133 695.323364,629.896362 695.443237,629.086365 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M573.313049,994.243286 
	C572.925842,992.608154 572.179260,991.985718 570.482178,992.055542 
	C571.290588,989.661926 573.505249,988.190857 575.474792,986.110596 
	C576.084534,985.801270 576.385986,985.602966 576.816772,985.142151 
	C576.971802,984.918884 576.895996,984.954834 576.868469,984.922119 
	C583.231262,981.755737 589.210083,985.935303 595.425537,985.945068 
	C596.916321,985.947449 597.988464,986.556091 597.977234,988.672302 
	C596.937134,991.467896 594.700195,991.132324 592.339478,991.388428 
	C590.938354,991.383667 590.120300,991.906799 588.975586,992.617188 
	C587.933167,993.092468 587.189636,993.267456 586.033447,993.411499 
	C581.728821,994.843872 577.667664,994.502014 573.313049,994.243286 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M589.178101,978.724365 
	C588.974365,977.571411 587.783081,975.635559 590.611328,975.927124 
	C593.468811,977.882874 596.254211,976.879211 598.956970,976.498901 
	C613.409485,974.465637 627.791565,975.630737 642.160828,977.398926 
	C642.412720,977.429871 642.618164,977.838318 642.994995,978.435852 
	C640.837708,980.304993 638.248962,979.046448 635.468323,979.740479 
	C619.953186,979.564819 604.809082,979.194580 589.178101,978.724365 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M589.169189,992.035400 
	C589.132141,990.810730 589.569214,990.188232 590.830078,990.070190 
	C595.340942,991.471863 599.500977,989.311340 603.699219,989.906311 
	C604.349854,989.998474 604.852539,989.874084 604.186340,989.881042 
	C604.173340,989.881165 604.157227,989.579407 603.970764,989.192017 
	C603.648132,988.279114 603.955200,987.789978 604.750366,987.217285 
	C610.422424,986.701599 615.820312,986.361694 621.677979,986.079407 
	C621.235046,990.716675 624.480957,989.921631 627.496094,989.971313 
	C628.678467,989.984131 629.450928,989.982239 630.617798,989.996277 
	C630.729553,991.881104 627.427551,989.697327 627.874634,992.695435 
	C622.905090,993.299316 617.756531,992.230713 612.354614,993.917847 
	C606.826355,991.736938 601.455444,994.171082 596.259949,993.043823 
	C594.030029,992.560059 591.610352,993.492493 589.169189,992.035400 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M603.634766,988.615723 
	C605.427795,989.280823 607.244507,988.272400 608.991943,990.614624 
	C602.857605,991.106567 597.297363,991.307373 591.419495,990.348572 
	C593.199524,989.949158 595.310669,990.285217 597.635132,989.227417 
	C598.734436,989.036011 599.484680,989.005310 600.605713,988.916077 
	C601.683167,988.386047 602.442810,988.186279 603.634766,988.615723 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M635.555176,979.976440 
	C637.267883,978.024658 639.901917,979.432129 642.707275,978.867065 
	C648.071533,978.800964 652.998230,978.800964 657.924988,978.800964 
	C657.926270,979.206604 657.927551,979.612305 657.928833,980.017944 
	C650.623596,980.017944 643.318298,980.017944 635.555176,979.976440 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M624.862183,981.128540 
	C628.837830,981.111267 632.418030,981.111267 635.998291,981.111267 
	C631.849609,982.291382 627.682983,982.167480 623.511292,981.810913 
	C623.368286,981.798706 623.238159,981.636414 623.101990,981.544067 
	C623.556946,981.411377 624.011902,981.278625 624.862183,981.128540 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M665.760803,977.499329 
	C665.964539,978.617249 666.099609,979.579712 664.966431,979.594299 
	C663.874329,979.608459 663.851074,978.606018 663.888794,977.835815 
	C663.956909,976.445129 664.560669,976.150146 665.760803,977.499329 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M604.113403,988.600159 
	C603.232361,988.858582 602.479797,988.893860 601.351807,988.893311 
	C601.282715,986.815308 602.846558,987.030640 604.653442,987.028809 
	C604.763672,987.486694 604.502808,987.931824 604.113403,988.600159 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M611.957825,972.562927 
	C611.281799,971.993469 609.663818,972.363098 610.277710,971.350037 
	C610.765381,970.545288 612.031311,971.078186 613.040649,972.043701 
	C612.911194,972.427795 612.565186,972.517944 611.957825,972.562927 
z"/>
<path fill="#C1ADDF" opacity="1.000000" stroke="none" 
	d="
M666.271667,903.073364 
	C665.605469,891.869446 668.479126,881.271301 670.051453,870.505676 
	C670.604004,866.722046 672.914062,863.454651 673.065491,859.556519 
	C673.112366,858.351379 674.161804,857.839966 675.240784,858.090637 
	C682.148743,859.695312 689.393555,859.953735 696.226318,863.520813 
	C691.989075,875.315369 690.511047,887.611938 687.254456,899.445801 
	C684.735535,908.599060 684.984863,908.698975 676.092346,906.216003 
	C672.900452,905.324707 669.758057,904.256287 666.271667,903.073364 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M713.280640,861.774658 
	C713.198853,862.836914 713.154724,863.541199 713.160828,864.594177 
	C711.034668,866.521301 710.977356,868.854431 710.992371,871.606140 
	C709.614746,875.137085 705.288208,876.395264 705.762695,880.787537 
	C704.282288,882.767517 704.124634,885.177795 703.352905,887.334900 
	C702.645081,889.313721 701.894409,891.277100 700.805969,893.152405 
	C700.451782,887.588928 702.287476,882.328613 703.732788,877.216736 
	C704.946655,872.923706 705.331848,870.270081 700.581787,868.691895 
	C699.960144,868.485413 699.610107,867.461670 699.088013,866.470703 
	C699.147400,866.000977 699.238159,865.786560 699.360779,865.766418 
	C701.893677,865.350342 709.308350,862.343201 711.818970,860.754272 
	C712.648560,860.766785 713.027954,861.022034 713.280640,861.774658 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M712.251465,860.735779 
	C708.873657,864.882202 705.737366,868.916687 699.413330,866.147827 
	C699.006897,865.460388 698.971924,864.795776 698.908203,863.802429 
	C700.988342,862.674194 703.097229,861.874817 705.560242,860.973267 
	C707.907043,860.539246 709.271790,858.007812 711.951599,859.475159 
	C712.267639,859.959534 712.336731,860.186951 712.251465,860.735779 
z"/>
<path fill="#515D78" opacity="1.000000" stroke="none" 
	d="
M576.706665,985.005005 
	C576.745300,985.206238 576.518860,985.493591 576.024780,985.870605 
	C575.985352,985.670593 576.213440,985.380920 576.706665,985.005005 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M772.534546,558.876099 
	C773.028931,559.696655 773.252869,560.311279 773.447998,560.934937 
	C774.531555,564.398499 773.738464,567.541870 771.223816,569.982727 
	C769.487366,571.668091 766.994446,572.097839 764.788269,570.919617 
	C761.708984,569.275085 760.745422,566.335876 760.912354,562.984619 
	C760.961121,562.005249 761.120056,561.031250 761.326904,559.635254 
	C765.773804,555.041809 767.543030,554.953308 772.534546,558.876099 
z"/>
<path fill="#A984A9" opacity="1.000000" stroke="none" 
	d="
M783.543945,558.052795 
	C783.877563,558.548645 783.908203,558.958557 783.962280,559.675598 
	C782.364563,561.604248 781.703613,560.194580 781.181580,558.987915 
	C780.342163,557.047729 779.668762,555.035889 778.912292,553.059265 
	C778.870728,552.950623 778.628479,552.805054 778.619080,552.814575 
	C778.421936,553.014038 778.244934,553.233398 778.021240,553.734985 
	C777.281433,553.940369 776.584167,553.859619 775.539551,553.810608 
	C775.192139,553.842407 775.276428,553.407959 775.339966,553.195984 
	C775.117371,552.125793 774.964661,551.237244 774.728149,550.021362 
	C778.596985,548.185974 781.729980,548.507263 782.937012,553.649536 
	C783.189087,555.292419 781.255615,556.742493 783.543945,558.052795 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M742.778564,562.274597 
	C740.584534,565.754211 738.522461,566.112366 736.365845,562.151184 
	C736.009644,559.560791 737.478638,558.144409 739.505432,558.157654 
	C741.481506,558.170532 743.143127,559.401306 742.778564,562.274597 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M703.665344,632.648560 
	C706.159790,632.679443 708.405518,632.783264 711.140381,632.873535 
	C711.879333,634.439880 711.180359,635.014771 709.661133,634.714111 
	C707.579529,634.302185 705.498474,633.887146 703.166687,633.165283 
	C703.082886,632.812012 703.249695,632.766724 703.665344,632.648560 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M774.463562,549.672485 
	C775.596313,550.511230 777.783508,550.811890 775.673889,552.887268 
	C774.156189,552.926086 772.530273,553.481140 771.904663,552.079346 
	C771.279602,550.678833 773.240295,551.213135 773.833801,550.188354 
	C774.009216,549.926941 774.274048,549.652893 774.463562,549.672485 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M669.283325,848.033508 
	C668.492249,845.635681 667.996094,843.275391 667.452881,840.508606 
	C670.618225,839.314819 670.485779,842.784851 672.564331,843.962524 
	C673.607971,844.639404 673.713318,845.386108 673.288574,846.587158 
	C672.168823,848.063110 671.490967,850.016602 669.283325,848.033508 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M673.376343,846.800842 
	C673.070496,846.223694 673.027710,845.495789 672.948120,844.405273 
	C673.160400,843.632263 672.999146,842.359192 673.784790,843.039978 
	C674.966125,844.063599 675.269287,845.510864 673.376343,846.800842 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M667.468140,865.452515 
	C667.523804,865.419006 667.412476,865.485962 667.468140,865.452515 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M711.831238,632.789734 
	C711.629517,632.860046 711.569214,632.870911 711.596558,632.879761 
	C711.339478,630.937317 708.668579,631.493408 707.688904,628.361511 
	C710.108948,629.947754 713.971680,626.797180 712.566772,632.636719 
	C712.388611,632.956299 712.032959,632.719421 711.831238,632.789734 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M728.007324,645.007324 
	C728.080505,644.373291 728.147705,643.733032 728.214905,643.092834 
	C728.421509,643.162720 728.812622,643.268127 728.807007,643.297241 
	C728.718384,643.757263 728.578979,644.207397 728.219727,644.826355 
	C727.988342,644.992859 728.001221,645.001160 728.007324,645.007324 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M747.396118,417.566925 
	C747.763184,417.126099 748.063721,417.084137 748.590271,417.009766 
	C748.817505,419.772034 748.817505,422.558014 748.817505,425.343964 
	C746.880615,423.158081 747.312683,420.526276 747.396118,417.566925 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M738.335083,433.712524 
	C740.741882,436.081573 740.627808,436.234741 736.176758,437.047791 
	C735.675842,437.229553 735.528870,437.368530 735.197876,437.266296 
	C735.013916,437.025055 734.984619,436.631317 734.978333,436.433960 
	C734.995789,435.639832 735.039795,435.046539 735.438721,434.240143 
	C735.761902,433.878876 735.920105,433.763458 736.360657,433.573792 
	C737.027710,433.485504 737.409973,433.508636 738.335083,433.712524 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M746.016357,431.395203 
	C746.043091,430.363586 746.082092,429.726440 746.150574,428.606903 
	C747.223999,432.432159 747.239929,433.027557 746.492432,437.136993 
	C745.514465,435.392731 746.212402,433.551758 746.016357,431.395203 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M736.250366,433.515167 
	C735.853638,434.452362 735.662476,435.100494 735.221680,435.992615 
	C733.772949,435.116791 733.828369,433.804901 734.658936,432.207825 
	C735.118774,431.869415 735.306824,431.739197 735.763672,431.822235 
	C736.032532,432.035461 736.001526,432.005127 735.985352,431.990631 
	C736.324890,432.317474 736.496521,432.730469 736.250366,433.515167 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M739.050781,427.682556 
	C738.277588,427.849457 737.265625,428.132996 737.108948,426.589691 
	C737.985779,426.207642 738.788147,426.305786 739.050781,427.682556 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M734.974487,437.401001 
	C735.013916,437.025055 735.412842,437.127319 735.617798,437.108948 
	C735.772766,438.264832 737.491943,438.967316 736.323242,440.402954 
	C735.176025,439.735504 734.726746,438.881226 734.974487,437.401001 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M739.294556,419.603302 
	C739.922546,419.899567 740.350342,420.266998 740.778198,420.634460 
	C740.238586,421.089478 739.707336,420.991821 739.056152,420.338531 
	C738.931885,420.066956 739.094421,419.674500 739.294556,419.603302 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M736.059937,431.776886 
	C735.848755,432.036285 735.664917,432.037140 735.205933,432.018799 
	C734.930664,431.999664 735.075317,431.634705 735.096924,431.440033 
	C735.441406,431.336365 735.764343,431.427338 736.059937,431.776886 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M732.995361,444.737640 
	C732.652344,444.873810 732.252502,444.741852 731.935425,444.276306 
	C732.324890,444.118286 732.631714,444.293915 732.995361,444.737640 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M732.005859,443.708038 
	C731.668457,443.868561 731.279785,443.755951 730.956787,443.293152 
	C731.333130,443.106995 731.643860,443.270966 732.005859,443.708038 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M730.035767,441.676514 
	C729.718445,441.862396 729.369995,441.699921 729.015808,441.231018 
	C729.494812,440.681519 729.835388,440.793762 730.035767,441.676514 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M731.026062,442.684937 
	C730.700195,442.852844 730.343262,442.728973 729.999634,442.272705 
	C730.340210,442.091248 730.667664,442.242218 731.026062,442.684937 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M733.734131,445.582458 
	C733.510986,445.753662 733.258484,445.624603 733.025757,445.160217 
	C733.233887,445.054291 733.453674,445.206726 733.734131,445.582458 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M753.724487,419.001556 
	C753.916321,419.079712 753.974060,419.286499 753.951782,419.805298 
	C753.778015,419.788300 753.684204,419.459229 753.724487,419.001556 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M739.074158,419.934875 
	C738.591125,420.016327 738.250427,419.965698 737.697021,419.766785 
	C737.484375,419.618469 737.776978,419.245209 737.939575,419.072510 
	C738.445801,418.980225 738.789551,419.060669 739.313965,419.336609 
	C739.494690,419.532104 739.216431,419.802826 739.074158,419.934875 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M741.310669,429.673767 
	C741.013367,429.872589 740.591003,429.756653 740.099426,429.304291 
	C740.415344,429.098267 740.800476,429.228668 741.310669,429.673767 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M740.051147,428.661407 
	C739.725830,428.808441 739.421326,428.648102 739.054993,428.224976 
	C739.352783,428.092773 739.712280,428.223419 740.051147,428.661407 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M542.266602,803.327271 
	C541.941467,801.365845 541.954773,799.495117 541.925598,797.152161 
	C549.408386,797.400391 556.537598,799.585754 563.417786,802.618652 
	C566.862976,804.137329 570.356262,804.896362 574.540039,803.985535 
	C575.316589,804.290344 575.513977,804.702759 575.492798,805.530579 
	C574.717896,807.152039 573.439453,807.746216 571.996704,808.659180 
	C570.923645,809.226318 570.151855,809.642883 569.259521,810.477234 
	C567.312927,812.062561 564.785156,812.134705 563.328735,814.455322 
	C560.291565,814.733154 558.171631,813.110596 555.616455,811.515869 
	C558.323792,810.506104 560.774902,809.591919 563.869141,808.437805 
	C558.844727,807.187500 554.501343,806.106628 549.825500,804.837524 
	C549.558228,804.319336 549.795227,803.902588 549.445251,803.686951 
	C548.882019,803.339905 549.718872,803.587219 549.148438,804.243958 
	C548.643677,804.455566 548.162231,804.391357 547.338867,804.198059 
	C546.868469,803.920593 546.740051,803.772156 546.319946,803.664062 
	C544.887268,803.608887 543.746155,803.513428 542.266602,803.327271 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M574.772400,806.014587 
	C574.999939,805.286133 574.997620,804.900940 574.991943,804.226562 
	C581.090820,798.524841 588.093872,794.813843 596.367798,792.717163 
	C596.877319,793.689575 597.021240,794.757507 597.126099,796.227661 
	C590.921631,800.673462 584.756226,804.716858 578.253479,808.817139 
	C576.311707,808.678589 574.384766,808.915771 574.772400,806.014587 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M574.689575,805.789856 
	C574.898071,807.440491 576.228638,807.874084 577.710022,808.616516 
	C573.770630,812.071838 570.176758,816.541504 563.532227,814.822021 
	C563.270203,813.730713 561.362183,812.345825 563.875305,811.793701 
	C565.404480,811.457764 566.804260,810.532776 568.608643,809.769287 
	C569.524475,809.311462 570.071960,808.926575 570.851440,808.290771 
	C572.206299,807.364014 573.291626,806.636169 574.689575,805.789856 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M549.215393,804.557007 
	C549.222290,804.272156 548.980591,803.460938 549.580078,804.421631 
	C549.492981,804.649231 549.305603,804.594299 549.215393,804.557007 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M546.246216,803.859863 
	C546.318420,803.704529 546.608521,803.704773 546.947754,803.886963 
	C546.819397,804.051086 546.641785,804.033264 546.246216,803.859863 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M558.767517,784.453857 
	C559.223022,784.227173 559.396667,784.184570 559.821167,784.046997 
	C562.312378,782.567810 563.896179,784.123291 565.391785,785.325256 
	C567.214783,786.790344 569.001648,788.258972 571.456604,789.406372 
	C574.554199,791.996521 578.204163,788.549683 581.006042,791.314697 
	C575.538757,796.197510 569.840759,799.057434 562.745361,794.935486 
	C561.258118,794.071472 559.291321,794.033020 557.220520,793.428955 
	C556.734741,790.247437 553.567139,786.695679 558.767517,784.453857 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M558.647949,784.139404 
	C555.426270,786.371277 558.614563,790.014648 557.028809,792.925659 
	C556.895508,793.243713 556.426514,793.284424 556.206360,793.201172 
	C555.572937,792.507141 555.202698,791.801208 553.950684,792.281616 
	C551.436890,792.548645 549.205261,791.914001 546.686340,792.475891 
	C545.919556,792.474487 545.500122,792.394470 544.841980,792.048828 
	C544.312622,791.580566 544.069397,791.263123 543.727844,790.680664 
	C542.548279,789.337891 541.483398,791.160217 540.213013,790.203613 
	C539.021423,788.214050 538.055908,786.440979 537.045227,784.330322 
	C538.588013,783.939392 540.788513,784.600952 539.928528,781.328369 
	C540.523987,781.309814 541.017517,781.534058 541.759888,781.871460 
	C542.172180,782.123108 542.335510,782.261719 542.746643,782.195679 
	C548.078369,782.663696 553.162415,783.336304 558.647949,784.139404 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M602.318420,782.301880 
	C603.640503,780.768799 605.157288,779.087646 607.041809,778.362915 
	C609.762024,777.316833 611.102600,775.449036 611.713928,772.210815 
	C613.838928,774.346375 613.007874,776.175232 612.828613,778.359314 
	C613.067627,779.027771 613.047424,779.265869 612.893738,779.669739 
	C612.126160,780.177124 611.411377,780.511841 610.408875,780.927124 
	C609.931335,780.899963 609.741516,780.792297 609.286072,780.875732 
	C609.020386,781.066833 609.004150,781.004333 609.035034,781.013672 
	C608.584534,781.404236 607.981750,781.472717 607.211426,781.864929 
	C606.997803,782.069763 607.002869,782.004211 607.033569,782.016052 
	C605.656799,782.647461 604.219666,783.031250 602.318420,782.301880 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M544.825684,790.861755 
	C545.075806,791.314819 545.221802,791.561829 545.632812,792.178345 
	C544.404419,793.061157 543.023254,792.741028 541.317017,792.215454 
	C540.767334,791.816650 540.498596,791.615295 540.104553,791.225159 
	C540.019531,790.984070 539.985596,790.486267 539.986206,790.236694 
	C541.438232,790.038269 542.114624,788.924805 543.130249,788.183716 
	C544.529541,787.162598 544.446777,788.511719 544.086792,789.746704 
	C544.244324,790.208191 544.460510,790.441406 544.825684,790.861755 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M546.258789,792.759949 
	C545.830627,792.587646 545.796570,792.303772 545.793701,792.161011 
	C548.345337,791.174133 550.981567,791.597839 553.779907,791.759644 
	C553.846497,792.194336 553.718384,792.385376 553.303589,792.768433 
	C550.906860,792.951050 548.796875,792.941650 546.258789,792.759949 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M601.977295,782.010315 
	C603.392578,781.902954 604.825745,781.783203 606.661499,781.845703 
	C605.797485,783.635193 603.846985,783.809692 601.749207,784.473022 
	C601.403687,784.546326 601.185059,784.247620 601.074158,784.099365 
	C600.590393,783.222351 600.998413,782.776062 601.779724,782.171692 
	C602.026184,781.967712 601.995117,781.997986 601.977295,782.010315 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M540.271362,799.765625 
	C539.673035,798.940735 539.380249,797.905273 539.063477,796.544678 
	C539.551575,796.325317 540.063660,796.431213 540.833862,796.612427 
	C540.920349,797.643616 540.748596,798.599365 540.271362,799.765625 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M553.382812,793.036377 
	C553.121582,792.656433 553.302490,792.407959 553.767151,792.109131 
	C554.738953,791.837341 555.707275,790.952209 555.976074,792.843140 
	C555.240356,793.116028 554.494568,793.114197 553.382812,793.036377 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M607.329041,782.101624 
	C606.842651,780.989014 607.758057,781.046997 608.717285,780.901978 
	C608.962708,781.855652 608.305298,781.986694 607.329041,782.101624 
z"/>
<path fill="#DCA691" opacity="1.000000" stroke="none" 
	d="
M609.299561,781.126343 
	C608.757690,780.003845 609.453796,780.390015 610.030396,780.733093 
	C609.940308,781.067017 609.759521,781.126465 609.299561,781.126343 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M540.010925,790.991272 
	C540.303162,791.176758 540.586792,791.369446 540.929199,791.821289 
	C540.987915,792.080566 540.661560,792.275208 540.477905,792.319946 
	C540.294250,792.364624 540.077759,792.088379 539.968872,791.950745 
	C539.860046,791.813110 539.748596,791.368958 539.877930,791.179993 
	C540.007263,790.991028 540.002319,790.998474 540.010925,790.991272 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M712.226135,859.729736 
	C709.951294,858.979736 708.659241,861.998352 706.270508,860.901733 
	C706.590088,859.786194 707.265686,858.701294 707.975586,857.292480 
	C709.522034,856.063538 710.327332,854.556274 711.519226,852.975891 
	C711.780579,852.796143 711.879517,852.888672 711.929443,852.934509 
	C713.369934,854.272156 712.666138,855.961304 712.843750,857.829712 
	C712.821411,858.640381 712.697571,859.080811 712.226135,859.729736 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M625.398682,543.665161 
	C625.700439,543.977844 626.387268,544.682556 625.017578,544.302856 
	C624.905029,544.107849 625.223999,543.801025 625.398682,543.665161 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M608.383240,848.663940 
	C607.961121,848.700928 607.708191,848.584412 607.455261,848.467896 
	C607.837708,848.050293 608.206299,847.991394 608.383240,848.663940 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M670.987793,639.332336 
	C671.013733,640.429749 671.013733,641.199829 671.013733,642.962830 
	C669.838806,640.702087 669.719849,639.391846 670.352051,638.038025 
	C670.360596,638.019714 670.610840,638.054626 670.637695,638.114441 
	C670.766602,638.401978 670.857422,638.706543 670.987793,639.332336 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M667.078125,639.809387 
	C667.070862,639.165649 667.031616,638.828430 667.104431,638.517395 
	C667.164124,638.262329 667.357178,638.038574 667.491089,637.800964 
	C667.882019,638.870483 668.194580,639.945679 667.676331,641.063171 
	C667.663269,641.091370 667.423645,641.074341 667.405640,641.030640 
	C667.284485,640.736694 667.194702,640.429871 667.078125,639.809387 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M676.014160,638.989868 
	C675.904236,638.852844 675.781921,638.725952 675.659546,638.599060 
	C675.736877,638.650269 675.814270,638.701477 675.936768,638.888916 
	C675.981812,639.025146 676.001648,639.000000 676.014160,638.989868 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M671.323486,757.003296 
	C672.841064,755.270508 671.446411,753.594543 670.728638,751.558716 
	C671.603821,751.145386 672.527283,751.175110 672.968018,752.663330 
	C673.000610,754.475525 673.346497,756.060974 671.323486,757.003296 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M670.285278,758.911743 
	C669.604309,758.315247 670.051758,757.815674 670.742004,757.129761 
	C670.876770,757.561951 670.733704,758.170593 670.285278,758.911743 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M585.393188,716.020752 
	C586.587769,710.352783 590.079285,705.634888 592.942871,700.206665 
	C594.275024,699.343750 594.611267,698.371826 594.727539,696.576904 
	C601.608643,695.400208 595.185181,699.888550 596.960693,701.591553 
	C596.863892,702.288086 596.452515,702.453857 596.533203,702.837891 
	C596.551575,702.925171 596.715759,702.903931 596.803284,702.820923 
	C597.286987,702.362183 596.717163,703.108887 596.855957,702.243347 
	C598.836975,700.835876 598.596802,698.610046 599.534363,696.837646 
	C600.283203,699.703735 602.191650,702.213501 600.956909,705.613770 
	C600.972412,705.981323 600.971375,706.207825 600.999023,706.116943 
	C603.470459,704.021545 603.153076,700.451965 605.694519,698.164795 
	C606.339966,701.985229 602.328674,705.178223 603.585144,709.870544 
	C606.451233,707.251221 604.672913,701.305237 610.735718,702.006958 
	C611.590027,702.533997 611.822266,703.210083 611.770569,704.339600 
	C611.298340,705.895508 610.274841,706.614746 609.277100,707.809265 
	C609.048096,708.085754 609.001099,708.022644 609.038940,708.033447 
	C608.101440,708.707031 607.758362,709.838806 606.821472,710.934875 
	C604.629395,716.804138 599.065735,717.503052 594.396484,720.025879 
	C591.754089,718.045471 591.518311,715.565735 592.562927,712.603027 
	C593.297363,710.519836 594.619873,708.413147 593.717773,706.043884 
	C590.488220,708.910156 592.829895,716.139587 585.393188,716.020752 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M636.435669,721.248047 
	C636.033997,720.494202 636.011353,719.846375 636.004822,718.874817 
	C634.338318,715.964783 636.757263,715.321411 638.038940,713.815063 
	C638.415649,711.813171 639.369019,710.107300 641.053650,710.323486 
	C643.272217,710.608215 643.493042,712.968628 644.019409,715.128296 
	C643.708984,719.988220 639.874390,720.197327 636.435669,721.248047 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M635.787109,721.319214 
	C638.531372,719.427002 642.027344,719.162476 643.729431,715.703857 
	C644.798889,715.853394 645.580994,716.241150 646.625061,716.841187 
	C645.066345,720.759094 640.774048,720.663696 637.912964,722.807800 
	C636.956909,723.524292 635.528259,723.705017 634.295776,724.834961 
	C633.175598,724.887817 632.367310,724.782898 631.368713,724.440491 
	C632.624756,723.300781 634.071167,722.398621 635.787109,721.319214 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M610.771484,705.205750 
	C610.695984,704.253052 610.838135,703.502319 611.007446,702.369141 
	C612.385315,699.522461 614.430115,700.761230 616.639893,701.006592 
	C617.678345,702.307495 618.154175,703.654114 617.981201,705.518555 
	C617.519897,706.416260 617.060913,706.950928 616.826538,707.765259 
	C616.184265,707.137512 614.378906,708.699036 613.832520,706.464111 
	C613.790283,706.090759 613.838379,705.707275 613.852234,705.514648 
	C613.866089,705.322083 613.516418,705.098572 613.297485,705.168457 
	C612.396790,705.476746 611.713013,705.689270 610.771484,705.205750 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M637.572754,713.560791 
	C639.549438,714.418030 638.830200,715.227783 637.718140,715.776001 
	C636.806458,716.225342 636.097717,716.677246 636.062134,718.170288 
	C634.229553,718.762939 633.820618,717.553162 633.793030,716.197815 
	C633.746155,713.891113 635.696106,714.054138 637.572754,713.560791 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M610.314758,705.174561 
	C611.788086,704.695068 613.022400,704.386353 614.628296,704.038818 
	C614.780151,704.586243 614.560303,705.172424 614.065369,705.924683 
	C611.656738,705.541260 611.452820,708.338745 609.373901,708.267395 
	C608.896912,706.987122 609.249023,706.077271 610.314758,705.174561 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M634.223938,706.151978 
	C635.863647,708.399841 633.434387,708.345154 632.518860,709.167786 
	C632.144775,709.503784 631.188049,709.025696 631.127808,708.305847 
	C630.962402,706.330933 632.990295,707.010071 634.223938,706.151978 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M590.325684,723.164429 
	C589.068542,722.322815 588.318665,721.285767 588.391235,719.465088 
	C590.324402,719.573608 590.520996,721.086914 591.001587,722.677612 
	C591.026550,723.021423 590.557129,723.106567 590.325684,723.164429 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M636.166138,704.614807 
	C637.415039,703.992798 638.487122,703.481567 638.857300,704.861328 
	C638.951294,705.211792 638.258850,706.022705 637.763428,706.230835 
	C636.665588,706.692078 635.398438,707.000793 636.166138,704.614807 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M606.952881,711.150757 
	C607.127625,710.120789 606.800476,708.569336 608.707886,708.080627 
	C609.555664,709.667297 608.166077,710.254028 606.952881,711.150757 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M615.106384,710.942932 
	C614.784241,711.787476 614.183228,712.237976 613.583862,711.791504 
	C613.020020,711.371460 613.675720,711.063110 614.273865,710.678772 
	C614.699829,710.598083 614.868408,710.644104 615.106384,710.942932 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M615.052856,709.990417 
	C615.543335,709.981140 615.874268,710.007141 616.698853,710.097961 
	C616.715881,710.482178 616.239136,710.801575 615.469116,711.158325 
	C615.175720,711.195740 614.856079,710.873291 614.693665,710.712708 
	C614.581604,710.328247 614.702332,710.152771 615.052856,709.990417 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M523.477356,785.010620 
	C524.082153,787.195984 522.477661,786.396301 521.599487,786.360718 
	C517.284973,786.186157 512.975403,785.886536 508.385315,785.342041 
	C513.082642,783.664673 518.067383,783.363770 523.477356,785.010620 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M497.030579,784.326538 
	C497.923431,784.485413 499.204834,782.538452 499.967590,784.717346 
	C499.996033,785.004211 500.000000,785.000000 500.002380,784.997559 
	C499.763611,785.204468 499.532593,785.424561 499.150879,785.832642 
	C498.990021,786.009888 498.998199,786.001892 499.002808,785.997498 
	C498.086578,785.939026 497.265930,785.741333 497.030579,784.326538 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M497.004639,783.995605 
	C496.253082,783.871094 495.324310,783.870422 495.488678,782.756470 
	C495.527100,782.496216 496.224854,782.144165 496.604736,782.161011 
	C497.519196,782.201782 497.406952,782.845520 497.067932,783.740601 
	C496.987274,784.009827 496.999390,784.000366 497.004639,783.995605 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M530.113892,782.199951 
	C530.041016,782.027527 530.499756,781.986511 530.728760,782.007202 
	C530.796631,782.357178 530.677551,782.780640 530.113892,782.199951 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M625.417419,816.277039 
	C625.896423,816.669800 625.970642,817.064148 626.060791,817.759766 
	C619.617065,817.624146 613.122925,819.454529 606.711792,817.348389 
	C612.852173,817.285583 618.937195,816.917297 625.417419,816.277039 
z"/>
<path fill="#9DA3A8" opacity="1.000000" stroke="none" 
	d="
M620.816833,815.024658 
	C616.587952,814.815735 612.928406,816.865845 607.831604,815.390198 
	C614.151062,813.024109 619.585571,814.504700 625.467834,813.949707 
	C623.809692,815.425903 622.454956,814.790344 620.816833,815.024658 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M713.963867,659.772095 
	C713.782349,660.452148 713.784180,661.711670 713.170715,660.390930 
	C712.902161,659.812866 712.469177,658.629944 713.672119,658.108765 
	C713.771545,658.565308 713.871033,659.021851 713.963867,659.772095 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M729.703186,655.581238 
	C730.002747,656.028137 730.012512,656.573975 729.981995,657.526611 
	C729.618408,657.448669 729.295105,656.963867 728.901672,656.175049 
	C729.025452,655.807373 729.219421,655.743774 729.703186,655.581238 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M823.156982,659.796631 
	C824.580627,659.684937 826.146667,659.959351 827.883423,660.588989 
	C826.441956,660.860840 824.696777,661.607910 823.156982,659.796631 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M630.844727,479.079285 
	C630.593628,476.994934 630.105103,474.802246 633.516663,474.757935 
	C636.525513,474.718872 635.973450,476.550873 636.133545,478.617310 
	C634.587585,480.640778 632.876770,478.685150 630.844727,479.079285 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M631.336548,484.953064 
	C630.874756,484.559540 630.800781,484.109924 630.718140,483.318817 
	C631.030640,482.895447 631.398621,482.669189 631.665283,482.755646 
	C633.175781,483.245361 636.180969,481.817993 635.873535,484.502106 
	C635.620117,486.714508 633.129456,484.205627 631.336548,484.953064 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M631.510620,511.029633 
	C632.154236,512.243103 632.220032,513.372253 630.411011,513.931091 
	C630.178955,512.887756 629.182922,511.410645 631.510620,511.029633 
z"/>
<path fill="#8F7F91" opacity="1.000000" stroke="none" 
	d="
M801.386353,890.883423 
	C800.919617,890.796265 800.917114,890.441467 800.938232,890.265381 
	C803.334290,889.955933 805.709290,889.822571 808.520264,889.608398 
	C809.642517,889.229919 810.356750,889.052124 811.469482,889.010132 
	C814.018372,888.886414 815.935669,887.971252 818.189331,887.030884 
	C818.544800,887.063232 818.501038,887.002502 818.509888,887.038879 
	C818.713562,886.921265 818.908447,886.767212 819.475708,886.593872 
	C822.254150,888.512573 825.244446,888.589844 828.409424,889.335876 
	C828.898438,889.704102 829.058350,889.895508 829.141602,890.453247 
	C819.994385,890.869812 810.923767,890.920166 801.386353,890.883423 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M829.527710,890.859497 
	C829.065063,890.819458 829.048645,890.450562 829.042297,890.266052 
	C831.708435,887.769409 834.953430,888.621887 838.000916,888.521973 
	C840.622986,888.435974 843.275757,888.998596 846.211548,887.904114 
	C846.838684,887.725708 847.101868,887.702881 847.622925,887.980835 
	C847.880798,888.281616 847.818848,888.553589 847.893372,888.671509 
	C848.653748,888.290588 849.118591,888.446960 849.163635,889.723877 
	C848.965271,890.188110 849.020447,890.481262 849.022766,890.630371 
	C842.680176,890.819519 836.335205,890.859558 829.527710,890.859497 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M717.582031,753.105774 
	C717.784729,754.105164 717.787781,754.920227 717.655457,756.129578 
	C713.109558,753.221985 708.699097,749.920044 704.164124,746.306091 
	C704.039612,745.994019 704.272400,745.846069 704.397156,745.904846 
	C705.913147,745.620239 706.092896,743.686157 708.032837,743.738342 
	C708.405762,743.903015 708.443542,743.743469 708.524475,743.730652 
	C709.707153,743.815430 709.968384,744.829529 710.803955,745.725586 
	C711.061401,745.953064 711.002686,746.002197 711.027466,745.973389 
	C712.131958,746.977600 712.845215,748.268250 713.822144,749.746826 
	C714.062988,749.950928 714.038208,750.000000 714.042114,749.975586 
	C714.286987,750.290039 714.577209,750.578125 715.223938,750.888184 
	C716.142517,751.620117 716.762451,752.270813 717.582031,753.105774 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M705.613220,743.282593 
	C702.079041,743.238770 700.388489,740.939758 698.534790,738.689758 
	C701.934631,739.029053 705.916199,737.220337 708.064270,742.127563 
	C707.723999,743.585266 706.840820,743.517822 705.613220,743.282593 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M714.240845,749.602478 
	C711.883179,749.927307 711.542786,748.225647 711.054810,746.300415 
	C713.552307,745.646057 713.832092,747.606140 714.240845,749.602478 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M705.179077,743.434265 
	C705.946594,742.934937 706.647522,742.802124 707.695190,742.581238 
	C708.144287,742.717346 708.246582,742.941589 708.377319,743.534424 
	C707.367676,744.576965 706.329651,745.250977 704.906738,745.944336 
	C704.718750,745.242676 704.915527,744.521790 705.179077,743.434265 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M711.217041,745.602661 
	C709.934509,745.989319 709.288391,745.384338 708.777466,744.043701 
	C710.758789,742.009399 711.000305,743.748779 711.217041,745.602661 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M715.360474,750.666870 
	C715.125671,750.821899 714.728821,750.674255 714.188965,750.238892 
	C714.430176,750.088867 714.814270,750.226562 715.360474,750.666870 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M781.066406,813.255310 
	C781.848694,811.610291 782.603455,810.414490 784.363708,810.388428 
	C785.117371,814.916199 781.031799,816.857727 779.867126,821.346558 
	C778.270569,817.630554 780.594055,815.798645 781.066406,813.255310 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M697.900513,728.723572 
	C699.833191,725.946716 696.835999,725.411560 695.414795,724.112854 
	C695.290649,723.568298 695.531738,723.054077 695.881042,722.274414 
	C700.515503,721.954651 700.465149,725.985535 701.668274,728.853516 
	C700.393677,729.004272 699.380676,728.965515 697.900513,728.723572 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M694.850952,699.804993 
	C695.082031,700.455139 695.173340,700.925537 695.396240,701.734375 
	C694.758118,704.291016 693.691589,705.090759 691.924255,702.430359 
	C691.912415,701.638367 692.001831,701.240173 692.560791,700.429077 
	C693.565369,699.880371 694.138245,699.752747 694.850952,699.804993 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M689.689819,698.791382 
	C691.347900,696.158997 692.176575,697.538391 692.953491,699.657227 
	C692.992554,700.007935 693.000854,699.999207 693.004395,699.995667 
	C692.358582,700.574951 691.621521,700.717651 690.469360,700.206421 
	C690.006287,699.667664 689.873108,699.354797 689.689819,698.791382 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M690.143677,700.271790 
	C690.856567,699.980042 691.573608,699.979431 692.649292,699.985474 
	C692.808960,700.572327 692.609985,701.152588 692.138916,701.889526 
	C691.293762,701.551758 690.720764,701.057373 690.143677,700.271790 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M699.331665,717.208252 
	C699.910278,717.807861 699.687927,718.375366 698.586182,718.766479 
	C698.366577,718.265869 698.646179,717.796448 699.331665,717.208252 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M821.310669,705.030701 
	C822.339539,703.543152 823.405457,702.390442 824.770264,701.130737 
	C824.656982,705.798401 823.876099,706.709412 821.310669,705.030701 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M813.953308,714.936829 
	C814.399719,714.585693 814.903259,714.303040 815.698914,714.006653 
	C815.555969,714.332031 815.120972,714.671082 814.407959,715.073792 
	C814.130005,715.137451 814.010437,715.005249 813.953308,714.936829 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M807.698730,717.950378 
	C807.548889,718.339844 807.079346,718.690796 806.291992,719.029236 
	C806.442505,718.648438 806.910767,718.280151 807.698730,717.950378 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M816.004150,714.005005 
	C816.113403,713.969910 816.218567,713.929810 816.157349,713.941345 
	C815.990967,713.992920 816.000000,714.000061 816.004150,714.005005 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M797.859863,712.689514 
	C797.939697,712.802490 797.537415,712.814758 797.339722,712.787231 
	C797.298157,712.455139 797.510803,712.394043 797.859863,712.689514 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M626.204956,562.702759 
	C626.190735,563.209412 625.869263,563.611572 625.301270,564.096558 
	C625.086914,563.519775 625.132385,562.867188 626.204956,562.702759 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M675.625977,748.981934 
	C675.498108,749.075073 675.355713,749.012146 675.213318,748.949219 
	C675.346008,748.908081 675.478699,748.866943 675.625977,748.981934 
z"/>
<path fill="#E0AC95" opacity="1.000000" stroke="none" 
	d="
M673.498779,747.528687 
	C673.422607,747.432373 673.717957,747.418640 673.717957,747.418640 
	C673.717957,747.418640 673.574890,747.624939 673.498779,747.528687 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M795.747192,826.089600 
	C796.481506,827.974243 795.014954,828.493347 793.451050,829.156128 
	C793.000916,827.449280 793.722229,826.408752 795.747192,826.089600 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M791.750000,830.089844 
	C792.292358,831.180054 791.592529,831.677917 790.423218,832.100830 
	C790.035828,831.121887 790.266846,830.312988 791.750000,830.089844 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M789.832153,832.062622 
	C790.123291,832.458862 789.976318,832.739319 789.425110,833.039673 
	C788.321411,832.446838 788.654358,832.145874 789.832153,832.062622 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M792.830933,829.139160 
	C792.934570,829.398621 792.800110,829.751099 792.356079,830.086060 
	C792.228577,829.789734 792.410706,829.510925 792.830933,829.139160 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M774.884644,638.863770 
	C775.102966,638.169189 775.189575,637.788635 775.411743,637.285400 
	C775.791199,637.135498 776.035095,637.108276 776.630737,637.033691 
	C776.967712,638.023743 776.952820,639.061157 776.886353,640.482422 
	C776.480103,641.909485 776.125488,642.952820 775.684570,644.309875 
	C775.309082,644.788330 775.012756,644.938782 774.473938,645.158325 
	C774.238708,645.241699 774.033447,645.049622 773.925171,644.959961 
	C773.011597,643.862854 773.500122,642.754944 773.786865,641.326538 
	C774.004761,640.973572 774.013062,641.007874 773.996216,641.013062 
	C774.535156,640.529968 774.502991,639.794556 774.884644,638.863770 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M778.988647,633.004333 
	C779.112244,633.160706 779.250488,633.315979 779.388733,633.471252 
	C779.292725,633.413269 779.196777,633.355286 779.052979,633.135620 
	C779.005249,632.973999 779.003235,633.003235 778.988647,633.004333 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M777.005615,637.008240 
	C777.105591,636.980408 777.199036,636.944336 777.137512,636.947266 
	C776.982605,636.986267 776.999023,637.000000 777.005615,637.008240 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M396.055511,856.722412 
	C395.869263,856.986145 395.501312,856.986938 395.317383,856.990356 
	C394.653931,857.396606 394.053162,857.472168 393.241943,857.795410 
	C393.009094,857.982666 392.995880,857.992676 392.988037,857.995789 
	C391.280426,859.734131 390.170349,855.755676 388.181824,857.608948 
	C387.711273,857.735291 387.525055,857.785645 387.086792,857.891541 
	C386.834747,857.947144 386.399933,858.027710 386.224548,858.091553 
	C386.049194,858.155457 385.902069,858.437744 386.090881,858.427612 
	C386.279694,858.417419 386.702240,858.514648 386.916443,858.631409 
	C387.247803,858.882385 387.364990,859.016663 387.590393,859.413452 
	C387.823792,860.290710 387.750092,860.879700 387.275513,861.694519 
	C387.081146,861.947144 387.032379,861.984497 387.009460,862.005432 
	C384.767639,861.703430 382.880920,865.361694 380.257446,862.336182 
	C379.885406,861.088562 379.386017,860.209351 378.799347,859.030396 
	C378.568604,858.337463 378.540863,857.925476 378.798462,857.258667 
	C379.183929,856.739624 379.375641,856.469910 379.795532,856.092468 
	C380.479614,855.534912 380.528259,854.995972 380.183502,854.191406 
	C379.999054,853.971558 380.012604,853.584167 380.016113,853.390625 
	C386.767822,850.502075 393.516022,847.807068 400.635986,845.057922 
	C401.372314,844.312378 402.403351,845.552979 402.831512,844.272278 
	C403.038513,844.098572 403.474792,843.885681 403.716492,843.864685 
	C404.242493,845.738586 405.201538,847.470886 405.032257,849.498291 
	C404.842560,851.769775 403.822876,852.667358 400.982056,852.093506 
	C399.535553,851.992859 398.788300,852.200012 398.134155,853.452759 
	C398.062195,855.285645 397.072449,855.815063 396.055511,856.722412 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M412.672211,841.091309 
	C412.999695,842.688965 412.999695,844.310425 412.999695,845.931885 
	C412.199585,844.656433 409.929718,844.143188 411.043579,841.733521 
	C411.505280,841.338928 411.925018,841.226990 412.672211,841.091309 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M364.484802,855.256653 
	C364.220337,854.331116 363.947723,852.951477 364.449249,852.557617 
	C365.495422,851.736145 365.965881,853.152527 366.908691,853.952698 
	C366.699768,855.149475 365.692352,855.044617 364.484802,855.256653 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M402.737793,844.105103 
	C402.935242,845.027832 403.314392,846.296875 402.187988,846.661316 
	C401.102814,847.012329 401.754974,845.733154 401.190826,845.167969 
	C401.484192,844.706360 401.960632,844.408997 402.737793,844.105103 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M540.022034,800.022339 
	C539.899536,800.457458 539.759583,800.875732 539.619568,801.294067 
	C538.965515,800.972168 539.272339,800.599915 539.764771,800.102295 
	C539.965820,799.976135 540.004517,800.005493 540.022034,800.022339 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M731.423706,888.262756 
	C731.083374,887.006226 731.080078,885.996460 731.150452,884.614258 
	C732.497437,885.245972 736.087036,883.459717 734.906250,887.695435 
	C733.919250,888.869141 732.892273,889.035095 731.423706,888.262756 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M730.970581,888.386169 
	C732.089783,888.017395 733.092834,888.018738 734.471069,888.031494 
	C734.884216,888.740173 734.922058,889.437439 734.867798,890.474060 
	C733.688599,889.708313 730.786682,892.062683 730.970581,888.386169 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M736.830933,889.997009 
	C736.960083,889.843750 736.957214,890.310059 736.964905,890.543091 
	C736.972595,890.776062 736.620239,890.806824 736.443726,890.810547 
	C736.364990,890.562195 736.509888,890.340881 736.830933,889.997009 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M743.429993,888.337280 
	C743.670410,888.303894 743.851990,888.468872 743.820801,888.538330 
	C743.622070,888.980774 743.418640,888.955872 743.429993,888.337280 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M565.258789,645.730591 
	C564.997559,645.998962 564.523865,646.001404 564.287476,646.004395 
	C564.483154,643.984314 564.915283,641.961365 565.527222,639.096069 
	C566.232788,641.806763 566.029846,643.634033 565.258789,645.730591 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M400.996216,851.995728 
	C400.989960,853.509827 400.145477,854.092712 398.363007,854.018433 
	C398.003662,854.003845 398.000000,854.000000 397.999084,853.997986 
	C397.795471,852.236267 398.762482,851.602295 400.677277,851.784668 
	C401.011139,852.010132 401.001373,852.001160 400.996216,851.995728 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M630.997009,989.995605 
	C631.336731,989.748840 631.679077,989.505493 632.033936,989.282043 
	C632.041077,989.277588 632.194580,989.505737 632.279907,989.625366 
	C632.013062,989.743530 631.746277,989.861572 631.245850,989.995911 
	C631.012207,990.012207 631.000977,990.001038 630.997009,989.995605 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M530.196533,786.667114 
	C530.714783,787.126831 530.972656,787.414856 531.230530,787.702881 
	C529.959106,788.361023 529.070190,787.410400 528.070618,786.941406 
	C527.929504,786.875183 527.830872,786.718506 527.699951,786.591431 
	C528.432678,786.000610 529.179993,786.151123 530.196533,786.667114 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M499.217224,785.905334 
	C499.089142,785.679626 499.277466,785.412170 499.779877,785.101318 
	C499.921600,785.335693 499.734833,785.604248 499.217224,785.905334 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M539.854858,791.058838 
	C540.007263,790.991028 539.944031,791.405640 539.902039,791.609375 
	C539.860046,791.813110 539.527771,791.518738 539.527771,791.518738 
	C539.527771,791.518738 539.702393,791.126648 539.854858,791.058838 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M678.956543,530.796509 
	C679.225342,529.929749 679.530640,528.996094 679.862610,530.343140 
	C680.029175,531.018860 680.510498,532.405396 678.846497,532.444153 
	C678.861328,531.992737 678.876099,531.541382 678.956543,530.796509 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M679.351379,525.060303 
	C680.075012,525.580994 680.083130,526.904602 679.629944,526.912354 
	C678.578674,526.930481 679.192505,525.867126 679.351379,525.060303 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M772.230103,763.097595 
	C772.116089,762.396973 772.135681,762.058838 772.129395,761.467224 
	C773.871033,761.213684 775.638550,761.213684 777.459839,761.213684 
	C777.503052,763.196899 776.035217,762.986084 774.454285,763.102539 
	C773.901184,763.010986 773.722473,762.950928 773.267212,762.949585 
	C772.781616,763.158936 772.572632,763.309509 772.230103,763.097595 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M772.692505,755.443359 
	C774.655151,754.745361 775.650208,756.135925 776.873047,757.710205 
	C775.310547,757.853516 772.822998,759.232544 772.692505,755.443359 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M596.045471,666.847778 
	C593.918213,664.210327 597.055176,663.953308 597.955688,661.828308 
	C598.892151,663.908386 599.514954,665.291748 600.112122,666.618225 
	C598.805420,668.697021 597.545410,665.479126 596.045471,666.847778 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M601.650024,660.288940 
	C602.095825,661.118042 601.590149,662.418701 603.449524,662.871643 
	C603.827759,663.391113 603.885559,663.839722 603.991089,664.634521 
	C600.161743,665.232788 599.463379,663.613159 601.650024,660.288940 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M599.817993,654.062256 
	C600.331543,654.351135 600.616394,654.819702 600.889771,655.570984 
	C599.787537,655.845215 598.918579,655.659302 599.817993,654.062256 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M598.696777,657.905151 
	C598.727600,658.452332 598.598206,658.840881 598.468872,659.229431 
	C598.362549,659.123474 598.150208,658.993347 598.167908,658.915588 
	C598.258118,658.518494 598.407715,658.134888 598.696777,657.905151 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M646.971924,705.409058 
	C648.447205,705.926147 649.404114,707.117859 648.961853,709.098511 
	C647.369873,708.437622 647.127258,707.164246 646.971924,705.409058 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M646.882019,705.111572 
	C645.856812,704.580017 645.032898,703.877686 645.128845,702.620483 
	C645.137024,702.513306 645.671753,702.317261 645.904602,702.378845 
	C646.821899,702.621460 646.904053,703.466614 647.113525,704.547852 
	C647.134216,704.878235 646.965576,705.033264 646.882019,705.111572 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M649.980469,710.768188 
	C650.895752,711.305115 651.517639,712.105042 650.861633,712.813538 
	C650.063232,713.675781 649.959412,712.413757 649.394165,711.760132 
	C649.383484,711.225403 649.514465,711.036804 649.980469,710.768188 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M649.532654,711.253601 
	C649.156067,710.759216 648.292358,709.640564 650.180176,710.395935 
	C650.147949,710.823181 649.980347,710.958130 649.532654,711.253601 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M696.441589,852.537354 
	C696.402832,852.476501 696.480347,852.598145 696.441589,852.537354 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M623.272217,949.025513 
	C623.631348,948.212952 624.277100,947.419189 624.962646,946.312988 
	C626.722290,945.885620 628.442200,945.770630 630.583496,945.754761 
	C631.008118,946.690552 631.011292,947.527405 631.028198,948.787048 
	C629.275208,949.436096 627.508484,949.662354 625.349609,949.891846 
	C624.491333,949.611511 624.025024,949.327942 623.272217,949.025513 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M609.182739,944.462646 
	C609.539429,944.131470 609.911499,944.106079 610.561646,944.080994 
	C611.016602,944.088135 611.193359,944.094971 611.631958,944.137573 
	C611.403137,946.219299 610.568542,946.707581 609.182739,944.462646 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M620.490051,495.946655 
	C621.171387,496.429474 621.449463,497.013153 621.869446,497.889374 
	C617.737732,500.056305 613.313354,499.749573 608.476929,499.156982 
	C608.058777,498.711365 608.028381,498.199707 608.018311,497.304047 
	C612.063110,496.745575 616.131165,497.172516 620.490051,495.946655 
z"/>
<path fill="#4F4D6F" opacity="1.000000" stroke="none" 
	d="
M619.147461,492.606445 
	C619.000244,492.247772 619.221619,492.029053 619.827026,491.996033 
	C619.897278,492.300049 619.665588,492.488281 619.147461,492.606445 
z"/>
<path fill="#AC5D65" opacity="1.000000" stroke="none" 
	d="
M648.944214,781.262695 
	C649.967590,781.755615 650.928589,782.554504 651.962280,783.661133 
	C651.110840,783.002075 646.780640,786.509644 648.944214,781.262695 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M563.007935,662.994751 
	C561.393311,662.925781 561.155212,662.165588 561.641663,660.705200 
	C562.672974,657.609558 563.552429,654.463318 564.754639,651.041077 
	C565.004883,652.193481 564.994629,653.642639 564.986023,655.520142 
	C564.876343,656.138245 564.765137,656.328064 564.812134,656.807373 
	C564.970459,657.096924 564.963318,657.554199 564.974976,657.782654 
	C564.986633,658.011108 565.004761,657.990356 565.011963,657.978943 
	C564.252136,658.663025 564.595520,659.639709 564.186829,660.747009 
	C563.989685,661.018188 564.000000,661.000000 564.005615,660.990967 
	C563.563049,661.412170 563.497742,662.007019 563.157593,662.792603 
	C562.982239,663.026062 562.998230,663.004639 563.007935,662.994751 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M564.978760,656.809875 
	C564.817932,656.902832 564.642639,656.721069 564.526917,656.507080 
	C564.492737,656.443848 564.626587,656.289734 564.835510,656.062866 
	C564.987488,656.139954 564.987305,656.331360 564.978760,656.809875 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M814.350098,694.042114 
	C813.979797,694.067932 813.550415,693.989502 813.334961,693.962769 
	C814.583374,692.610046 816.443054,692.343323 818.644714,692.000610 
	C818.141052,693.853516 816.490540,694.061768 814.350098,694.042114 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M819.763428,691.088623 
	C819.819397,691.273010 819.637573,691.547241 819.222595,691.916199 
	C819.168213,691.733459 819.346863,691.455994 819.763428,691.088623 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M815.543884,688.467041 
	C815.573792,688.517334 815.513977,688.416809 815.543884,688.467041 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M608.782227,504.929413 
	C609.340759,505.399139 609.280579,505.762726 608.434082,506.145935 
	C608.085938,506.036346 608.072021,505.799896 608.060486,505.208374 
	C608.062866,504.853241 608.541565,504.912964 608.782227,504.929413 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M718.153809,485.857178 
	C717.570557,485.405304 717.670044,484.983490 718.558228,484.779327 
	C718.752747,485.194916 718.581482,485.491394 718.153809,485.857178 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M614.154358,956.222290 
	C613.991150,955.839600 613.994446,955.671692 614.001343,955.251831 
	C614.751892,955.138428 615.690063,955.096191 615.476196,956.264648 
	C615.453491,956.388489 614.723022,956.382690 614.154358,956.222290 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M736.286987,433.815918 
	C735.969360,433.396545 735.893921,432.988892 735.893860,432.278687 
	C737.320312,431.407898 738.509827,431.286652 738.944702,433.461884 
	C738.880981,433.848297 738.925171,433.908417 738.928528,433.872620 
	C738.528503,434.421631 738.022095,434.153778 737.268127,433.961243 
	C737.006042,433.916260 736.529175,433.827606 736.286987,433.815918 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M771.795105,762.851562 
	C772.096558,762.735046 772.512817,762.972290 772.751709,762.990356 
	C773.068481,763.775513 772.759277,764.238037 771.974792,763.967896 
	C771.728760,763.883179 771.649353,763.314941 771.795105,762.851562 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M576.466248,643.453064 
	C576.518799,643.421143 576.413696,643.484985 576.466248,643.453064 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M564.262695,660.817200 
	C564.161682,660.147766 564.333618,659.277405 564.762329,658.187256 
	C564.857971,658.850403 564.696838,659.733337 564.262695,660.817200 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M563.248779,662.868896 
	C563.143066,662.441956 563.303833,661.857910 563.737915,661.127930 
	C563.845947,661.558594 563.680603,662.135193 563.248779,662.868896 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M671.560669,1005.864807 
	C671.897095,1007.088257 671.800476,1008.230286 670.041504,1006.671448 
	C670.385559,1006.255127 670.808899,1006.099854 671.560669,1005.864807 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M785.527954,545.546753 
	C785.477234,545.575867 785.578735,545.517578 785.527954,545.546753 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M642.475708,520.996094 
	C641.902771,520.807251 641.775574,520.531677 641.830933,519.839111 
	C643.376648,519.270325 643.742981,519.727173 642.475708,520.996094 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M786.221069,704.965210 
	C785.671509,707.192810 784.009766,707.397949 782.328369,708.002991 
	C782.165771,705.937866 783.418640,704.753906 785.568176,703.963867 
	C786.066040,704.127441 786.229248,704.354736 786.221069,704.965210 
z"/>
<path fill="#62497D" opacity="1.000000" stroke="none" 
	d="
M786.282959,705.173340 
	C786.028564,705.106934 786.007446,704.865479 785.944580,704.262085 
	C786.092712,703.867126 786.282654,703.834045 786.746399,703.894531 
	C786.852173,704.324768 786.684204,704.661560 786.282959,705.173340 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M781.758972,708.073669 
	C781.835510,708.289978 781.666931,708.584412 781.243042,708.945007 
	C781.163147,708.724731 781.338440,708.438293 781.758972,708.073669 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M812.805786,753.569824 
	C811.180908,752.506226 810.257568,750.843384 810.995300,748.314697 
	C811.166504,747.590454 811.337952,747.194153 811.509399,746.797852 
	C811.944702,747.382385 812.379944,747.966919 812.929382,748.817139 
	C812.992798,750.445251 812.942078,751.807617 812.805786,753.569824 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M727.304077,885.420654 
	C728.011047,885.139221 728.633728,885.075256 729.567383,885.053833 
	C728.319519,886.641907 733.282715,891.085449 727.139099,890.394531 
	C726.967041,889.016663 727.042664,887.948303 727.086975,886.477417 
	C727.055603,886.074829 727.219727,885.638184 727.304077,885.420654 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M720.929077,888.410645 
	C720.940979,888.029480 721.300049,887.876770 721.465454,887.771973 
	C722.867676,888.035095 724.117004,888.379883 725.124146,889.655884 
	C723.482178,891.517700 722.380127,891.252197 720.929077,888.410645 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M546.112427,659.499390 
	C548.228394,652.515015 550.332336,645.963318 552.719055,639.185669 
	C554.820007,643.219666 553.165405,647.373230 552.405701,651.477600 
	C551.715149,655.208252 550.862122,658.943665 550.118835,660.807068 
	C552.021851,654.502441 553.986206,646.366699 554.052307,637.889832 
	C554.060364,636.851501 554.393494,635.929260 555.605835,635.098267 
	C556.001099,634.763306 556.074524,634.618896 556.140442,634.471252 
	C557.116150,632.284851 557.783081,629.419739 561.063171,630.370300 
	C564.140747,631.262207 562.768738,634.084290 562.994568,636.603882 
	C560.557251,638.093079 560.255554,640.556580 559.554199,642.676453 
	C556.816711,650.950806 554.183228,659.259644 551.288147,667.844482 
	C545.540710,667.742188 545.544617,664.004150 546.112427,659.499390 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M747.090820,861.633423 
	C747.075012,862.071411 746.583008,862.020264 746.337830,861.988892 
	C745.819031,859.555359 745.780823,857.168091 746.680115,854.001404 
	C746.854614,856.944336 746.980591,859.069885 747.090820,861.633423 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M675.372131,1006.570923 
	C675.043152,1006.640991 674.692200,1006.369934 674.335693,1005.748657 
	C674.670166,1005.675537 675.010193,1005.952698 675.372131,1006.570923 
z"/>
<path fill="#1A0616" opacity="1.000000" stroke="none" 
	d="
M796.001221,713.001221 
	C795.906921,713.032471 795.811462,713.062439 795.856750,713.045044 
	C795.997559,712.997559 796.000000,713.000000 796.001221,713.001221 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M704.761597,465.182434 
	C704.906311,466.364410 705.332642,467.875061 703.505127,468.988220 
	C702.815918,467.571014 704.038879,466.609467 704.761597,465.182434 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M716.533569,850.145264 
	C717.003845,849.326599 717.276123,848.831970 717.789001,848.185425 
	C719.903625,851.623474 717.179382,854.016479 715.180664,856.734497 
	C713.459106,854.158813 715.160156,852.387024 716.533569,850.145264 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M712.005920,860.236450 
	C712.144348,859.559326 712.319458,859.155029 712.636230,858.451721 
	C712.914490,857.453369 713.380554,857.047363 714.323669,856.755798 
	C714.646179,856.732605 714.927551,856.953247 715.069458,857.065735 
	C715.100586,858.192993 714.989807,859.207764 714.930115,860.604492 
	C714.540100,861.260864 714.098999,861.535339 713.450500,861.971252 
	C713.019287,861.854797 712.795532,861.576965 712.334351,861.178101 
	C712.078796,860.874512 712.060669,860.691895 712.005920,860.236450 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M680.938354,549.583008 
	C680.800293,549.987854 680.354492,550.003601 680.130798,550.014648 
	C679.164490,548.411926 678.706543,546.780762 679.841309,544.778137 
	C682.043884,545.705505 681.353699,547.485718 680.938354,549.583008 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M679.992920,542.966187 
	C682.027344,542.578430 681.772034,543.444397 680.407593,544.556885 
	C680.013977,544.201843 679.968323,543.848694 679.992920,542.966187 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M736.784851,456.063965 
	C737.927490,456.519562 737.816467,457.072906 737.250732,457.567505 
	C737.079773,457.716919 736.556702,457.738922 736.416870,457.598419 
	C735.942932,457.122162 735.663879,456.549438 736.784851,456.063965 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M739.118347,717.388062 
	C738.921936,716.932129 738.961853,716.686523 739.001831,716.440796 
	C739.251709,716.501099 739.501648,716.561401 739.751587,716.621704 
	C739.619324,716.947266 739.487000,717.272827 739.118347,717.388062 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M736.457275,716.041382 
	C736.294922,715.218506 736.790588,714.953674 737.765259,714.915405 
	C738.164185,715.820679 737.955688,716.451355 736.457275,716.041382 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M428.641418,839.055298 
	C428.695038,841.592468 426.543121,841.553406 424.398987,842.020264 
	C424.035461,841.576965 424.035400,841.151550 424.063812,840.410156 
	C425.487640,839.755615 426.882965,839.417114 428.641418,839.055298 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M572.005859,645.005737 
	C571.848389,646.332886 572.407593,647.750671 571.482300,649.095947 
	C570.655151,647.801270 570.913513,646.625061 571.729309,645.220825 
	C571.990906,644.994324 572.000732,645.000671 572.005859,645.005737 
z"/>
<path fill="#96609A" opacity="1.000000" stroke="none" 
	d="
M593.787842,531.907776 
	C593.743164,531.633789 594.021301,531.311462 594.633728,530.970825 
	C594.682190,531.254883 594.396423,531.557129 593.787842,531.907776 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M791.700745,700.029541 
	C791.972046,700.383545 791.929443,700.784546 791.802124,701.476929 
	C791.186401,701.968018 790.655334,702.167847 790.124329,702.367676 
	C789.702148,701.139404 790.745422,700.718750 791.700745,700.029541 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M681.191956,507.489563 
	C681.264099,507.263519 681.494141,507.229095 681.606934,507.257172 
	C681.719666,507.285248 681.845886,507.672119 681.934937,507.855103 
	C681.886353,508.182983 681.748657,508.327942 681.346558,508.330750 
	C681.082214,508.188660 681.119812,507.715576 681.191956,507.489563 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M714.736816,856.386719 
	C714.166565,857.157288 713.686951,857.582031 712.992554,858.079712 
	C709.589966,857.196106 712.527405,855.162964 711.990601,853.359375 
	C714.113159,853.058594 714.317932,850.426453 716.424561,849.928223 
	C717.182190,852.226746 715.049133,853.841248 714.736816,856.386719 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M588.594910,991.744141 
	C595.049744,991.783997 601.122498,993.003723 607.277588,992.110168 
	C608.767700,991.893799 610.664429,991.301514 611.866089,993.560059 
	C605.276367,993.992432 598.618225,994.046753 591.493713,994.120483 
	C589.747070,995.055786 588.367188,995.059998 586.528687,994.450317 
	C585.700928,993.876892 585.530029,993.357849 585.884888,992.428467 
	C586.856567,992.004639 587.553223,991.908752 588.594910,991.744141 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M585.750244,992.080933 
	C586.127075,992.489929 586.094238,992.879333 586.047729,993.562134 
	C586.206116,994.048767 586.378113,994.242004 586.263611,994.697144 
	C581.934021,995.239990 577.816406,994.438110 573.439331,995.828491 
	C572.813599,995.763306 572.595703,995.662476 572.160889,995.274109 
	C572.062439,994.664612 572.262939,994.406494 572.768188,994.102051 
	C577.210266,994.006775 581.507751,994.520508 585.750244,992.080933 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M586.301025,995.109497 
	C585.985352,994.775391 585.993530,994.591797 586.017944,994.131836 
	C587.423096,993.907166 588.812073,993.958923 590.614197,994.075256 
	C590.184326,996.967529 588.355530,995.920959 586.301025,995.109497 
z"/>
<path fill="#4B4E6A" opacity="1.000000" stroke="none" 
	d="
M571.688782,995.016907 
	C572.259644,995.075745 572.529663,995.239990 572.892761,995.671631 
	C572.317444,995.791809 571.603333,995.719543 570.889282,995.647339 
	C571.070679,995.447266 571.252075,995.247253 571.688782,995.016907 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M831.639526,449.689209 
	C832.490173,450.047485 833.013062,450.177979 833.861572,450.554932 
	C834.187134,450.801392 834.314026,451.191681 834.359619,451.371277 
	C833.290466,453.607544 830.864563,452.465637 829.130066,453.927032 
	C825.045288,455.873596 821.417786,454.288452 817.384033,453.475403 
	C816.794006,453.426025 816.557190,453.413086 815.964600,453.386200 
	C814.658325,453.335297 813.708313,453.289185 812.400879,453.231506 
	C811.101318,453.105286 810.187927,452.864197 808.938843,452.544159 
	C804.986267,452.000214 801.394348,451.354767 797.779236,450.877533 
	C798.707214,451.035248 799.662476,450.969635 800.877930,451.448669 
	C802.113525,452.516998 802.783447,454.078949 804.259094,453.899139 
	C810.288574,453.164581 816.038879,455.937195 822.395386,455.207886 
	C823.887573,455.405457 825.001892,455.715302 826.448608,456.111511 
	C828.298218,457.201324 829.822449,458.175934 832.105225,457.744507 
	C832.433899,457.818939 832.679626,457.625366 832.833252,457.653687 
	C832.968994,458.610260 832.951172,459.538513 832.896362,460.928650 
	C824.465088,461.128815 816.112366,460.413696 807.396423,459.105713 
	C802.613159,460.454559 798.539856,459.693054 794.475830,457.061249 
	C794.342896,454.804352 793.486145,453.319611 792.068665,451.684387 
	C791.968384,450.715057 791.825378,450.105438 791.937561,449.182770 
	C792.310364,447.760376 792.650696,446.644073 793.043091,445.178101 
	C795.512878,442.884064 798.251953,444.587219 801.126465,444.242432 
	C802.466980,444.650299 802.328979,445.524750 802.515198,446.313660 
	C802.660767,446.930573 803.409912,446.552094 802.805176,446.271515 
	C802.200439,445.990936 803.373535,445.422974 803.081299,445.621826 
	C803.940063,445.153625 804.582825,445.112732 805.568726,445.297729 
	C809.007568,447.206696 812.418274,447.206573 816.213318,447.062317 
	C816.806274,447.131683 817.043335,447.172577 817.628967,447.314575 
	C820.842224,448.144623 823.700806,448.918152 827.093201,448.624268 
	C828.770813,448.834991 830.087158,448.940216 831.639526,449.689209 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M833.591064,432.645691 
	C833.725708,433.175049 833.481079,433.789307 833.108398,434.717133 
	C821.301819,432.729980 809.606140,430.529327 797.376831,429.145447 
	C793.781433,428.612762 790.600220,427.962891 787.156067,427.560974 
	C786.577087,428.304718 786.134033,428.480774 785.385071,427.986969 
	C784.030151,423.730988 788.001282,425.638702 789.396484,424.236633 
	C791.004761,424.666260 792.101135,423.649078 793.700195,423.872559 
	C794.555054,424.019562 795.007507,424.209534 795.717285,424.711121 
	C801.466187,427.168121 807.337830,427.705566 813.044922,428.557556 
	C819.870544,429.576630 826.541931,431.089325 833.591064,432.645691 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M829.906860,481.672424 
	C830.012756,482.063721 830.033081,482.312714 830.035400,482.437592 
	C826.389893,486.006683 822.325012,483.458588 818.056702,483.352173 
	C817.195984,483.295105 816.713257,483.231720 815.893188,483.062012 
	C814.688965,482.761261 813.857117,482.416901 812.642578,482.287354 
	C811.899719,482.229889 811.476562,482.199585 810.738281,482.155334 
	C810.213989,482.124725 810.005005,482.107208 809.484314,482.043671 
	C808.967529,481.951630 808.762451,481.905670 808.255249,481.775635 
	C807.335815,481.514282 806.708130,481.449493 805.725464,481.534485 
	C800.108337,480.890778 794.717834,481.125061 789.281128,479.267578 
	C786.677002,478.993988 783.732300,479.549561 785.789795,475.222595 
	C795.640442,476.110168 805.312195,477.159546 814.946472,478.481262 
	C819.932190,479.165283 824.851624,480.332306 829.906860,481.672424 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M809.868408,481.344604 
	C810.483154,481.174072 810.941895,481.189941 811.668945,481.447784 
	C812.722656,481.964569 813.512024,482.215363 814.674561,482.097961 
	C815.429626,482.044006 815.873413,481.993286 816.646423,482.009094 
	C818.650879,483.100281 821.196167,483.778320 818.412598,486.622467 
	C811.606140,486.940948 805.121155,486.595612 798.284607,486.161987 
	C795.116516,485.081238 791.976501,485.155884 789.159302,483.151031 
	C788.966003,481.826538 788.988037,480.813904 789.001221,479.421448 
	C794.855225,478.870636 800.611694,479.643402 806.697266,481.012329 
	C807.239014,480.893555 807.386353,480.757446 807.767700,480.810516 
	C808.169312,481.035187 808.336914,481.070709 808.737061,481.215881 
	C808.969543,481.325531 809.261963,481.714417 809.261963,481.714417 
	C809.261963,481.714417 809.712280,481.531006 809.868408,481.344604 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M794.278687,424.609955 
	C792.791199,424.830353 791.537048,424.801056 790.015808,424.502991 
	C790.870972,420.948578 788.074219,421.398956 786.214417,420.530029 
	C785.682922,419.751251 785.521851,419.144165 785.221558,418.275452 
	C784.991821,417.619415 784.965881,417.204315 784.925354,416.477600 
	C785.328918,415.620544 785.668884,414.995026 786.703308,414.841309 
	C789.700134,417.558777 793.441650,415.413849 796.682434,417.063416 
	C797.457275,417.159332 797.875610,417.250488 798.609009,417.313538 
	C800.062073,417.296783 801.317688,416.958557 802.135498,418.627075 
	C801.155029,419.032898 800.055603,419.108917 798.351624,419.226715 
	C799.324585,419.739197 799.747986,419.928741 800.136841,420.173370 
	C801.258972,420.879272 803.536438,420.950836 802.595581,422.994843 
	C801.803467,424.715546 800.084778,423.792725 798.699646,423.360168 
	C798.086975,423.168854 797.428223,423.125214 796.395752,423.013977 
	C795.319397,423.257507 794.933044,423.828033 794.278687,424.609955 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M802.259644,445.869507 
	C799.293396,445.570709 796.586487,445.218170 793.487427,444.847046 
	C791.011230,444.593536 788.931702,444.272858 786.841187,444.165436 
	C785.993042,444.121887 785.138306,444.357666 785.035156,443.220276 
	C784.927368,442.031860 785.878662,442.008728 786.699036,442.002014 
	C788.841614,441.984467 790.984436,442.005615 793.563843,441.857117 
	C795.187073,441.496887 796.338806,441.519653 797.691406,442.394714 
	C806.708984,443.765869 815.432129,444.897522 824.130005,446.198151 
	C826.524292,446.556183 828.843201,447.418762 831.540894,448.244507 
	C831.837952,448.769653 831.849792,449.098053 831.943970,449.670685 
	C830.596069,449.946259 829.224915,449.975494 827.440552,449.995972 
	C823.919250,449.344421 820.841492,448.520874 817.330811,448.158844 
	C817.017883,447.905396 817.010925,447.978699 817.045044,447.964722 
	C813.666992,447.166412 810.163513,447.067841 806.353027,446.378723 
	C805.251526,446.131683 804.510193,446.076233 803.395020,446.002716 
	C802.853821,445.928345 802.686401,445.872070 802.259644,445.869507 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M793.963257,456.835693 
	C798.046936,458.479675 802.251099,457.940491 806.573608,459.026062 
	C806.968201,459.653229 806.959534,460.181274 806.927551,461.106018 
	C803.203247,461.083527 799.502258,460.664368 795.379517,460.279480 
	C794.957703,460.313782 794.517517,460.091278 794.276733,460.144592 
	C790.585815,461.045715 787.235229,461.329803 784.303955,458.092468 
	C786.325195,455.710236 788.909912,457.498901 791.593994,456.842773 
	C792.220337,456.526703 792.530457,456.393219 792.944458,456.708313 
	C793.201538,456.973083 793.426636,456.969543 793.963257,456.835693 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M788.590942,482.913452 
	C792.086731,483.490509 795.229431,484.141876 798.705444,485.018982 
	C799.538513,485.931030 799.766418,486.668488 799.203369,487.814362 
	C798.022827,488.163300 797.102783,488.203552 795.990967,488.538574 
	C794.930725,488.879059 795.355164,487.214172 794.111694,487.841553 
	C791.849915,489.159424 789.624939,487.187103 787.291626,487.881409 
	C785.212280,487.033783 784.377930,486.157257 785.021057,483.869568 
	C785.746094,481.290741 786.939880,482.411438 788.590942,482.913452 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M794.295837,438.681946 
	C792.572510,440.217438 790.830383,439.508392 789.264404,439.636200 
	C787.931274,439.745056 785.876343,439.545532 785.308411,438.699066 
	C784.165771,436.995941 785.527649,435.336731 786.879517,433.652588 
	C787.629517,431.961121 788.880188,432.720490 790.281738,432.579590 
	C791.742859,433.617798 793.435059,433.151062 794.631165,434.650635 
	C795.214844,436.172729 795.156250,437.289093 794.295837,438.681946 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M813.234558,398.500549 
	C808.527710,398.779663 804.107971,398.246582 799.357300,397.196411 
	C798.218384,397.188629 797.484070,397.093475 796.397644,396.879059 
	C795.690979,396.427277 795.532349,396.018616 795.802612,395.275574 
	C801.511475,394.381378 806.797852,396.165894 812.626831,396.429138 
	C813.552917,397.051544 813.635864,397.630402 813.234558,398.500549 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M811.831238,497.521729 
	C810.705078,497.657532 809.649231,497.427277 808.262085,497.229584 
	C805.879089,497.047638 803.827454,496.833160 801.329590,496.607391 
	C800.271118,495.791779 800.005005,494.928284 800.661865,493.676514 
	C800.893127,493.406403 801.316162,493.344025 801.523132,493.297302 
	C804.386780,494.770020 807.461304,494.215027 810.251099,494.470825 
	C813.062988,494.728729 811.793335,496.031494 811.831238,497.521729 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M773.233093,397.358459 
	C773.113586,396.469421 773.223938,395.859070 773.171997,395.074463 
	C774.411072,393.086304 776.064758,395.150452 777.454468,394.632660 
	C779.234009,393.969543 781.919189,394.624542 782.536499,391.413696 
	C782.924377,393.161591 783.962646,395.321472 781.302002,396.910950 
	C778.427612,397.183868 775.945312,397.410522 773.233093,397.358459 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M782.056152,466.646515 
	C779.949463,466.810669 779.109253,467.806122 778.799622,469.794189 
	C778.605835,471.038910 777.353943,471.562469 776.124634,471.359161 
	C775.165466,471.200500 774.248230,470.745880 774.049927,469.564026 
	C773.781860,467.966492 774.688477,467.115540 775.971375,466.524017 
	C777.714844,465.720184 779.960388,466.158295 781.624878,464.206451 
	C781.997009,464.787567 782.052734,465.531677 782.056152,466.646515 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M797.993408,442.204590 
	C796.759644,443.065521 795.630981,442.994171 794.343811,441.823975 
	C794.263916,441.298950 794.527405,440.895050 794.874512,440.264648 
	C795.069580,438.068695 794.769897,435.909882 797.682739,434.933411 
	C799.287292,434.723358 800.403198,434.961578 801.746948,435.818359 
	C802.062378,437.718994 801.676575,438.907990 799.778992,439.053772 
	C798.056274,439.186157 798.016602,440.540894 797.993408,442.204590 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M770.486084,481.474976 
	C768.905823,481.030792 767.650024,480.808716 766.172485,480.272888 
	C771.011475,478.631226 776.244751,480.058716 781.694763,479.101135 
	C781.998657,479.647888 781.929810,480.089447 781.834595,480.865631 
	C781.271179,482.208160 780.459167,482.834015 778.915283,483.029480 
	C775.979248,482.432770 773.289551,482.659454 770.486084,481.474976 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M800.663452,493.282745 
	C800.887268,494.256989 800.881348,495.107544 800.879395,496.277130 
	C797.642761,495.469879 794.042419,495.355499 791.174255,492.804108 
	C793.250854,492.567627 795.339600,492.674927 797.754028,492.874695 
	C798.255127,493.305176 798.529175,493.406921 799.141479,493.273560 
	C799.740967,493.214691 800.087402,493.186890 800.663452,493.282745 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M780.541382,421.382446 
	C779.972473,420.372253 779.458130,419.903625 778.229126,419.787781 
	C777.875061,418.692291 777.438965,418.022003 776.028564,417.797607 
	C777.787781,416.893280 779.814880,415.811401 782.562744,415.929169 
	C783.001709,417.380310 783.050110,418.790192 783.066528,420.623047 
	C782.397339,421.564911 781.679138,421.763031 780.541382,421.382446 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M795.691772,394.782593 
	C796.034363,395.404266 796.032715,395.791443 796.038330,396.469177 
	C792.221802,396.251282 788.230103,396.384521 784.976440,393.458130 
	C788.368713,394.197754 792.067627,392.915100 795.691772,394.782593 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M784.150269,458.082947 
	C786.781433,460.043610 790.243286,459.091125 793.628662,460.106384 
	C789.351013,463.390717 786.135132,462.834412 784.150269,458.082947 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M790.753174,402.261475 
	C791.059143,402.905060 791.066467,403.489166 791.063293,404.365234 
	C789.829773,404.539307 788.588013,404.516144 787.389160,404.277222 
	C786.165710,404.033386 784.088928,404.935364 784.306458,402.396027 
	C784.517212,399.934906 786.372375,401.022278 787.667419,400.963348 
	C788.151306,400.941345 788.639954,401.021332 789.554321,401.075470 
	C790.139587,401.464783 790.297058,401.833405 790.753174,402.261475 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M801.998169,436.077271 
	C801.060242,435.947998 800.088562,435.750122 798.768677,435.695526 
	C797.185303,435.179047 795.764221,435.999054 794.329773,435.002502 
	C792.961487,434.360748 791.791016,434.066498 790.361694,433.500122 
	C790.425903,433.033539 790.748901,432.839081 791.624878,432.763000 
	C793.901184,430.794342 795.572083,433.401520 797.617249,432.820007 
	C798.726501,433.132660 799.495728,433.563629 800.601379,433.980316 
	C801.135132,433.865051 801.332520,433.764130 801.858215,433.716248 
	C802.186523,433.769226 802.227295,433.873352 802.232178,433.817688 
	C802.489380,434.236389 802.560974,434.736664 802.200806,435.559570 
	C801.949707,435.856354 801.964294,436.008636 801.998169,436.077271 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M795.200928,467.474854 
	C792.224365,467.164978 789.493469,466.585327 786.367554,466.078430 
	C784.422974,464.647858 784.670837,463.644836 786.862061,464.180939 
	C789.320923,464.782501 791.767700,464.768036 794.653015,464.792419 
	C795.071716,464.701813 794.896362,464.962921 794.891846,465.120117 
	C795.575378,465.774414 795.655762,466.447754 795.200928,467.474854 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M787.227722,487.952484 
	C789.288147,485.977234 791.285767,487.609222 793.683716,487.976166 
	C791.941284,492.003723 789.581909,488.834686 787.227722,487.952484 
z"/>
<path fill="#6F879E" opacity="1.000000" stroke="none" 
	d="
M778.645996,482.220886 
	C779.756470,481.780548 780.503784,481.575378 781.529663,481.285278 
	C781.851440,481.912140 781.894714,482.624023 781.917053,483.697815 
	C780.232910,485.564087 778.181580,484.791534 775.883301,485.029846 
	C775.466858,485.046112 775.049316,485.198883 775.049316,485.198883 
	C775.049316,485.198883 774.605042,485.182831 774.387695,485.137329 
	C773.927551,482.064056 773.927551,482.064056 778.645996,482.220886 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M791.577881,448.896973 
	C792.578491,449.459290 793.626648,449.921326 792.253235,451.148682 
	C789.845337,450.295410 787.582458,449.821198 785.137390,449.785675 
	C787.013306,447.410919 789.265686,449.636658 791.577881,448.896973 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M775.732178,485.306335 
	C777.055359,483.159576 779.214661,484.540710 781.473389,484.065277 
	C782.941895,487.742859 780.565186,486.588745 778.422974,486.307312 
	C777.378479,486.087616 776.687988,485.827087 775.732178,485.306335 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M780.105835,421.331238 
	C780.922058,421.170898 781.629456,421.169769 782.685730,421.107361 
	C783.015381,422.106903 782.996155,423.167786 782.980408,424.627808 
	C782.247314,425.133362 781.510864,425.239746 780.409424,425.443054 
	C780.002136,424.614502 779.959778,423.689056 779.875122,422.301605 
	C779.832947,421.839630 779.996948,421.490448 780.105835,421.331238 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M794.092712,435.088715 
	C795.381287,434.868317 796.630554,435.081604 798.150269,435.566833 
	C795.875305,435.843597 796.242493,438.123840 795.238770,439.795197 
	C794.651611,439.906921 794.403198,439.704407 794.104736,439.212830 
	C794.015625,437.837494 794.034546,436.679932 794.092712,435.088715 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M786.947876,414.660461 
	C786.532959,415.307190 786.030212,415.671936 785.219116,416.101318 
	C784.025085,412.867493 785.516113,411.738770 788.919922,412.347656 
	C788.500305,413.292908 786.462524,412.223724 786.947876,414.660461 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M785.527344,452.574127 
	C786.541992,452.252594 787.505005,451.969025 787.588562,453.136871 
	C787.652649,454.032440 786.915833,454.616333 786.062866,454.560608 
	C784.905457,454.484955 785.068237,453.601990 785.527344,452.574127 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M785.425415,398.055908 
	C786.877625,396.202454 787.869934,397.577454 789.205139,398.234955 
	C787.817200,399.400696 786.639221,399.183411 785.425415,398.055908 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M791.905334,432.598816 
	C791.831421,432.932037 791.484924,432.982666 790.620667,433.130646 
	C789.263184,433.191193 788.423523,433.154419 787.272949,433.222717 
	C786.412903,432.985809 784.355042,432.770386 786.472656,432.018433 
	C787.968750,431.487122 789.897278,432.173462 791.905334,432.598816 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M785.174011,427.984619 
	C785.583252,427.658203 785.960205,427.679382 786.615112,427.754730 
	C786.799316,428.665741 787.612793,429.988647 786.236633,430.201965 
	C785.299255,430.347198 785.211975,429.152893 785.174011,427.984619 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M792.994141,456.661377 
	C792.976501,456.976593 792.640869,457.214630 792.640869,457.214630 
	C792.640869,457.214630 792.238403,457.128815 792.105225,456.971985 
	C792.210876,456.244324 791.549805,455.235443 792.755798,455.185669 
	C792.825012,455.182800 792.925720,455.941742 792.994141,456.661377 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M785.000000,418.365204 
	C785.917725,418.186676 786.080872,418.813507 786.008728,419.947327 
	C785.660767,419.770844 785.321533,419.233368 785.000000,418.365204 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M790.204224,454.644165 
	C789.935059,454.626648 789.790161,454.486908 789.645203,454.347168 
	C789.872925,454.405426 790.100708,454.463654 790.204224,454.644165 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M799.072693,493.141174 
	C799.051575,493.702026 798.655334,493.857727 798.120789,493.212830 
	C798.303345,492.991394 798.527039,493.015625 799.072693,493.141174 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M886.298584,374.147278 
	C881.495422,369.564911 874.774475,368.833862 869.613770,365.348663 
	C863.708862,361.361023 857.925415,362.262695 851.869446,364.893524 
	C846.878723,367.061493 841.719177,368.840790 836.319458,370.967712 
	C834.744507,372.334351 833.399963,373.287537 831.196777,372.584015 
	C822.109619,373.696045 822.323242,373.693665 822.223145,364.689575 
	C822.201538,362.750214 822.873047,360.571259 821.900146,358.283447 
	C821.229004,348.712677 819.842590,339.520844 821.228943,330.218597 
	C821.483948,328.507355 820.605774,326.659363 820.344849,324.853943 
	C820.098999,323.153259 819.851196,321.522461 821.891846,320.256073 
	C823.177368,319.987305 824.135620,320.016418 825.447998,320.003967 
	C831.660828,319.933899 837.065796,318.061951 842.414307,315.963776 
	C837.240784,318.061707 831.930847,319.633392 825.930176,319.995056 
	C824.490234,319.986420 823.427612,320.008331 821.964722,319.740662 
	C820.109863,318.699249 819.867920,317.354950 820.390015,315.410461 
	C823.054749,312.573517 826.845459,314.550812 829.802368,312.214447 
	C840.235413,309.568939 850.459595,308.711517 860.757996,308.465240 
	C865.340332,308.355682 869.657471,309.287903 874.020874,311.763794 
	C876.649597,314.501221 876.248169,316.152344 872.450134,316.780273 
	C871.568604,316.844727 871.107117,316.239288 870.836853,316.638428 
	C871.324524,316.750336 871.520691,316.815277 872.018799,316.988831 
	C875.506836,318.477936 878.768433,319.602234 882.582214,320.090942 
	C883.831665,320.409668 884.727234,320.688843 885.941833,321.140320 
	C886.674805,321.562439 886.977295,321.925140 887.057983,322.699829 
	C886.840576,339.984650 886.756653,356.933350 886.298584,374.147278 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M894.068115,233.248230 
	C892.066162,234.041229 892.707336,235.562546 892.716675,236.811111 
	C892.919800,263.944336 892.173340,291.090820 893.783325,318.640869 
	C893.408875,319.893524 893.562439,320.966675 892.157471,321.200348 
	C891.847656,321.050446 891.478210,321.124268 891.289795,321.126343 
	C886.913025,320.089661 885.303955,317.448883 885.588379,313.146820 
	C885.858521,309.059692 885.263794,304.962555 884.936279,300.527588 
	C885.172913,296.716461 885.291016,293.263306 885.565063,289.368835 
	C886.365112,273.020081 885.813171,257.105530 886.015442,241.195709 
	C886.042664,239.056473 885.691162,236.879730 886.726318,234.393341 
	C887.002991,232.934692 887.013733,231.870621 887.040039,230.408173 
	C887.843689,230.259918 888.631775,230.510025 889.708374,230.888702 
	C890.766296,232.041046 891.990601,231.831329 893.329590,232.283020 
	C893.792542,232.591797 893.951599,232.752029 894.068115,233.248230 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M884.686890,300.088135 
	C888.209412,302.540466 886.185364,306.043121 886.813416,308.962830 
	C887.689026,313.033722 885.661987,317.982971 891.056213,320.760040 
	C890.405090,322.605682 889.180603,323.094208 887.279480,323.008240 
	C886.655579,322.846893 886.386597,322.657806 885.977173,322.260529 
	C884.618835,320.577301 884.248169,318.774414 883.808044,316.596985 
	C883.713562,315.889709 883.678406,315.559265 883.670410,315.227936 
	C883.387634,303.578003 883.121399,303.245178 871.301270,300.131592 
	C870.460449,299.864319 870.012878,299.635376 869.320801,299.083130 
	C868.915283,298.601746 868.784668,298.383850 868.611816,297.787231 
	C874.247009,295.682587 879.397583,297.150330 884.686890,300.088135 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M891.878418,321.396820 
	C892.342834,320.523773 892.838013,319.997131 893.527588,319.274231 
	C893.802673,320.434296 893.883362,321.790558 893.940552,323.554688 
	C892.409485,323.981079 891.951355,323.050323 891.878418,321.396820 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M891.449463,401.537048 
	C891.415405,401.479736 891.483459,401.594360 891.449463,401.537048 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M781.203613,345.200867 
	C780.988770,344.206573 780.993347,343.481293 780.994507,342.393311 
	C782.195068,339.352020 784.691589,339.643219 786.927490,339.570953 
	C792.546753,339.389343 792.548401,339.440216 792.560974,333.239227 
	C792.336670,329.435547 792.703613,326.042542 792.636230,322.226379 
	C792.805847,320.694458 793.199097,319.647858 793.491882,318.161530 
	C793.477905,316.931427 793.520569,316.111908 793.586060,314.879639 
	C793.575562,311.962189 793.485840,309.458069 793.579956,306.534454 
	C793.516174,304.435303 793.511108,302.755737 793.584351,300.659363 
	C793.551147,298.863800 793.472717,297.485199 793.583313,295.702087 
	C793.584167,294.767487 793.582703,294.237518 793.564941,293.322296 
	C793.474670,290.036652 791.565002,289.596405 789.175720,289.413147 
	C785.872925,289.159821 782.606934,290.450867 778.996338,289.296753 
	C778.244202,288.348450 778.143372,287.579163 778.435486,286.405243 
	C780.629395,284.091461 783.224121,284.729156 785.640686,284.559540 
	C787.887207,284.401886 790.251099,284.776184 792.978455,282.563110 
	C787.692993,280.491699 782.652771,283.972534 777.930664,281.290222 
	C777.223389,280.273346 777.151123,279.479065 777.504272,278.277405 
	C780.778809,275.656006 784.348938,276.749573 787.721375,276.530853 
	C790.204407,276.369843 792.763977,276.599976 794.153687,273.316315 
	C794.934998,272.263397 795.646240,271.840179 796.934265,271.914185 
	C798.917114,274.902557 801.453369,275.481262 804.493164,275.527710 
	C809.121155,275.598450 813.812378,274.805634 818.724243,276.485596 
	C819.395874,277.217438 819.539551,277.750946 819.361755,278.724365 
	C814.663757,281.577820 809.500854,280.225800 804.728210,281.394073 
	C803.219727,281.763306 801.517456,281.323730 799.472656,282.619568 
	C806.150879,284.609619 812.538635,282.310699 818.845703,284.526428 
	C819.712097,285.481781 819.837341,286.285309 819.565430,287.530365 
	C814.873474,290.865173 809.788513,288.891479 804.985535,289.498077 
	C802.842712,289.768707 800.195068,288.680420 798.977844,291.977173 
	C798.986572,292.819794 798.981262,293.298248 798.934448,294.125732 
	C798.397156,296.751160 799.236816,297.850922 802.008057,297.568634 
	C806.828186,297.460236 811.268799,297.397980 816.139771,297.627136 
	C816.855225,297.750732 817.139771,297.815369 817.827820,298.054199 
	C819.014771,298.730164 819.488770,299.405151 819.288452,300.765869 
	C817.059021,302.827698 814.743835,301.933350 812.472473,301.810669 
	C808.135498,301.576385 803.738464,300.750977 798.600647,302.785919 
	C805.451111,304.455872 811.660645,302.390778 817.848999,304.583374 
	C818.449890,305.334473 818.552002,305.868073 818.318970,306.820770 
	C813.193542,309.751221 807.858215,307.986176 802.725891,308.550934 
	C800.326843,308.815002 797.529358,308.480988 797.495544,312.568329 
	C797.715942,316.254639 800.121704,316.299530 802.529419,316.452881 
	C807.812866,316.789459 813.169983,315.690247 818.734741,317.514221 
	C819.571533,318.583466 819.527222,319.376862 818.656372,320.412170 
	C812.387085,322.562256 806.205566,320.810486 799.310791,321.938629 
	C805.492310,323.199219 811.048767,321.568970 816.650757,323.438263 
	C818.292297,326.275208 816.291321,326.808594 814.562378,327.285919 
	C811.238892,328.203400 807.822998,328.465118 804.372375,328.517029 
	C802.143127,328.550598 799.763428,328.101929 797.699402,330.109680 
	C797.502747,330.937286 797.446960,331.415375 797.412781,332.242615 
	C797.237366,334.276062 798.014221,335.558807 799.327393,336.986938 
	C799.603210,337.748718 799.623230,338.211212 799.454346,339.009155 
	C798.742615,342.355225 801.107239,341.404755 802.438904,341.527405 
	C807.538452,341.997131 812.747864,340.711426 818.045837,342.754639 
	C818.519287,343.518921 818.567749,344.027069 818.290649,344.899902 
	C815.101196,347.225220 811.704712,346.254608 808.469055,346.501801 
	C805.384216,346.737457 802.224304,345.996552 799.142822,347.556946 
	C802.635193,349.144409 806.605896,347.870209 810.489868,349.279236 
	C812.513000,353.364868 809.267578,352.978424 807.276733,353.298981 
	C804.050720,353.818390 800.536560,353.010712 797.654785,355.934357 
	C797.385864,356.779419 797.249146,357.272247 796.929932,358.115356 
	C796.614685,358.681976 796.458191,358.891785 795.957275,359.292328 
	C795.085632,359.592255 794.571899,359.547241 793.781860,359.087860 
	C793.363220,358.606018 793.234436,358.384460 792.978088,357.805115 
	C792.787231,354.862640 791.755859,353.725037 788.911804,354.077972 
	C785.555542,354.494415 782.104492,354.987915 778.530396,353.333679 
	C777.114136,352.449188 777.032715,351.396179 777.283691,349.864563 
	C781.542297,347.509064 786.315918,349.577179 790.951477,347.155396 
	C787.662231,345.675385 784.184448,347.224457 781.203613,345.200867 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M793.520996,320.693237 
	C793.854370,324.700653 793.870178,328.391876 793.790771,332.534180 
	C793.500122,333.175385 793.304688,333.365570 792.751221,333.754150 
	C787.846619,334.240326 783.414917,335.767426 778.395508,335.127930 
	C776.739563,335.060913 776.959900,332.711945 775.472290,333.336731 
	C774.314209,333.823059 774.140137,335.097931 774.090820,336.238098 
	C774.020508,337.863342 774.052856,339.493042 773.992554,341.547119 
	C773.692566,342.127045 773.441345,342.280670 772.748230,342.405365 
	C772.062256,342.209259 771.818115,342.042084 771.337036,341.498718 
	C770.112488,332.065643 770.600281,323.007812 771.293701,313.572876 
	C771.898804,312.773499 772.380005,312.524628 773.346191,312.526733 
	C776.733032,316.057312 774.818298,320.250122 775.448120,324.066956 
	C775.720703,325.718811 774.318176,328.547852 778.310547,328.133698 
	C781.944763,328.271057 785.030701,326.736206 788.327698,326.999664 
	C785.064636,326.650177 782.010559,328.325928 778.356934,327.856140 
	C775.392090,326.247864 775.510559,324.193329 777.192139,321.625824 
	C782.118286,320.098846 786.896606,320.635284 791.960205,319.890198 
	C792.666443,320.115265 792.934998,320.246155 793.520996,320.693237 
z"/>
<path fill="#100622" opacity="1.000000" stroke="none" 
	d="
M747.225098,368.364655 
	C746.389404,367.691650 745.781738,367.383759 745.031494,366.752289 
	C745.119385,365.276215 745.906189,364.474640 746.879150,363.404053 
	C747.288147,363.027527 747.463806,362.890320 747.943665,362.618896 
	C748.466309,362.460602 748.684814,362.436493 749.224487,362.477905 
	C750.854065,363.268463 751.511230,364.789948 753.256348,365.498810 
	C753.940308,365.900909 754.321655,366.158234 754.985901,366.640167 
	C761.514160,368.001007 767.840698,368.148651 774.448792,368.777679 
	C774.995178,370.037170 775.108887,371.250397 773.903320,371.513885 
	C764.640442,373.538391 756.935181,378.897644 748.349121,383.038208 
	C748.006226,381.593353 748.019653,380.242859 748.028503,378.487091 
	C746.927979,375.019745 747.831299,371.835632 747.225098,368.364655 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M817.749451,345.297363 
	C817.998413,344.613617 818.013672,344.200958 818.033997,343.478668 
	C817.346130,342.463318 816.919006,341.624115 816.712463,340.297058 
	C816.540039,338.804901 816.439819,337.659912 816.587402,336.178772 
	C816.720886,334.773529 816.724304,333.700928 816.504883,332.308350 
	C816.473145,331.319916 816.638000,330.683746 816.870972,329.723022 
	C816.963989,327.583954 817.591614,325.822571 817.289978,323.652405 
	C816.910645,322.306244 816.995361,321.350555 817.889587,320.226562 
	C818.396362,319.385590 818.618591,318.794464 818.778931,317.878418 
	C817.539062,316.385590 817.172791,314.964630 817.563110,312.998840 
	C818.422241,311.753143 819.312561,311.305878 820.824951,311.657959 
	C821.694946,312.518311 821.806824,313.279266 821.388306,314.432831 
	C821.190674,316.200806 821.213562,317.634338 821.638794,319.236572 
	C822.139465,319.612976 822.237732,319.820679 822.187012,320.339111 
	C820.383484,320.770691 819.921204,322.605835 820.492126,323.059265 
	C822.541443,324.686768 821.165283,327.701843 823.296936,329.119873 
	C823.428589,329.207428 823.507629,329.374054 823.611206,329.503845 
	C818.981934,331.916473 823.804199,336.053009 821.885193,338.957977 
	C821.650330,339.313507 821.100525,339.743286 821.178223,339.981781 
	C823.058289,345.753204 821.205444,351.808929 822.261230,357.772552 
	C818.927490,357.553070 822.368774,353.219788 818.666443,353.030914 
	C816.086426,353.342255 813.788025,353.793518 812.445374,350.768585 
	C813.916138,348.551483 816.720642,348.123260 817.749451,345.297363 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M817.122314,384.638794 
	C816.019592,384.904694 815.077820,384.875580 813.784302,384.809357 
	C809.143127,382.857758 804.385376,383.038361 799.688110,381.438995 
	C798.301880,378.125732 798.124512,375.223633 800.637085,372.302124 
	C802.492432,372.014709 803.976196,371.826996 805.432739,371.953003 
	C809.521851,372.306793 813.626648,372.706085 811.345642,378.747498 
	C811.037170,379.564606 811.627075,380.682220 811.586426,381.651672 
	C811.554993,382.400360 811.542175,382.948364 812.435120,382.971832 
	C813.493347,382.999634 813.898682,382.480194 813.629822,381.431641 
	C813.466248,380.793732 813.306519,380.147247 813.234070,379.494720 
	C812.748108,375.113617 814.306030,372.875488 819.460388,374.114746 
	C820.281372,374.492676 820.484802,374.886017 820.442261,375.713257 
	C820.236450,376.247375 820.108093,376.440186 819.739136,376.879211 
	C816.572205,378.860046 817.629211,381.817200 817.122314,384.638794 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M814.635437,364.536713 
	C818.958496,364.074036 818.722107,366.808838 818.730286,369.280426 
	C818.741577,372.699371 816.238220,371.255371 814.868591,370.955322 
	C808.642212,369.591217 802.341858,368.806183 795.629028,367.984833 
	C792.908752,364.330353 794.974365,363.050537 798.099792,362.717621 
	C803.560181,362.135956 808.909851,363.175842 814.635437,364.536713 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M812.136963,350.499115 
	C812.332642,354.053741 815.827820,351.371368 817.985229,352.769775 
	C818.374207,354.260529 818.403320,355.504120 818.452026,357.055542 
	C818.392761,357.687958 818.299255,358.248199 818.179871,358.249878 
	C811.029419,358.349854 803.843872,359.313385 796.419678,357.151672 
	C795.583252,353.738708 796.751404,352.647949 800.009644,352.418182 
	C804.147705,352.126373 808.584106,353.907684 812.136963,350.499115 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M792.596741,333.336243 
	C792.875000,333.054840 793.283752,333.001953 793.489624,332.993591 
	C793.695496,335.623016 793.695496,338.260803 793.695496,341.122650 
	C789.681946,340.855988 785.658569,340.601410 781.352112,341.828918 
	C776.903015,342.872894 776.383911,341.043243 777.902954,337.390686 
	C780.809692,334.519318 784.404297,335.119354 787.696350,334.560120 
	C789.249634,334.296265 790.978577,334.932037 792.596741,333.336243 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M818.476440,359.962677 
	C818.669312,362.279358 819.318542,364.832367 815.407349,364.078735 
	C808.917236,364.001709 802.824768,363.727509 796.392700,362.631744 
	C795.360535,361.653137 795.284668,360.818390 796.019531,359.672302 
	C796.389893,359.425201 796.056152,359.280090 796.230225,359.333069 
	C796.694458,359.004120 796.879395,358.427429 797.417175,358.397430 
	C804.383118,358.009277 811.337646,357.872955 818.476440,359.962677 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M780.663025,345.057495 
	C784.583008,344.946991 788.184570,345.051849 791.779297,344.938354 
	C793.504761,344.883820 794.080688,345.413086 794.034180,347.143219 
	C793.990234,348.774750 793.490173,349.342712 791.784119,349.391479 
	C787.213379,349.522217 782.685425,350.559601 777.740112,349.774536 
	C777.375671,347.350128 777.412354,345.274414 780.663025,345.057495 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M796.143677,361.616089 
	C800.167908,363.642853 804.068481,362.693481 807.832031,363.012939 
	C809.969299,363.194305 812.089233,363.579865 814.618530,363.999390 
	C815.020081,364.125336 815.028320,364.467407 815.032349,364.638428 
	C809.415955,364.588562 803.791504,364.436859 798.177063,364.112701 
	C795.920837,363.982483 794.557129,364.384125 795.198486,367.447937 
	C794.986877,367.862885 794.739075,367.857513 794.119751,367.841125 
	C791.526062,365.576782 788.822205,366.636597 786.259521,366.746704 
	C783.679321,366.857544 781.057617,368.088837 778.254272,366.178040 
	C777.949463,365.161316 777.935791,364.414886 777.978516,363.298645 
	C782.756714,360.006866 788.093567,362.207886 793.491821,361.090546 
	C794.565247,361.067535 795.151978,361.210938 796.143677,361.616089 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M774.805908,368.580536 
	C767.799927,370.269440 760.973022,369.453461 754.079712,367.394775 
	C754.478760,366.357697 755.195923,366.047821 756.357117,365.780457 
	C760.520630,365.349426 764.222839,366.187286 767.963013,366.466064 
	C769.613586,366.589050 771.402283,366.871246 771.487793,363.945404 
	C771.752197,356.656281 770.590759,349.723938 772.517944,342.535400 
	C772.991699,342.151947 773.184082,342.127167 773.660156,342.037903 
	C774.249268,350.696442 774.554626,359.419434 774.805908,368.580536 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M792.208496,380.608948 
	C791.038269,380.676270 790.061218,380.644379 789.162354,380.362793 
	C787.159485,379.735352 783.752258,381.073730 783.339722,379.376892 
	C782.849670,377.360748 783.819092,374.701721 784.051147,372.288208 
	C784.251099,370.208588 786.499023,370.274872 788.555908,370.007080 
	C789.362000,370.351746 789.856689,370.481934 790.240417,370.758789 
	C791.516846,371.679657 792.742004,372.444275 794.237671,370.606018 
	C794.568054,370.578094 794.894104,370.626312 794.945068,370.783081 
	C795.503235,371.461121 795.804565,372.077972 795.850830,373.149841 
	C795.563293,375.535858 794.226746,377.031006 793.062988,378.964935 
	C792.838806,379.664276 792.661011,380.041077 792.208496,380.608948 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M794.522522,361.651794 
	C789.297424,363.376068 784.058472,362.388428 778.490234,363.032959 
	C777.698486,361.882782 776.134644,360.906647 777.965698,359.448364 
	C780.911377,356.488617 784.444763,358.048584 788.033752,357.563782 
	C789.432068,357.618774 790.436951,357.672150 791.807983,357.596191 
	C792.414001,357.618500 792.655579,357.646027 793.210571,357.860016 
	C793.691101,358.185516 793.858215,358.324554 794.225830,358.720764 
	C794.758545,359.720490 794.906616,360.483215 794.522522,361.651794 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M793.581116,357.614594 
	C793.523987,358.046448 793.556152,358.032928 793.546021,358.028015 
	C792.298645,358.069092 791.189453,357.277313 789.541809,357.481079 
	C785.654846,357.933075 782.156067,358.476593 778.305786,357.314148 
	C777.987244,356.015686 778.013428,354.941650 778.150635,353.478333 
	C782.021057,352.905182 785.823608,353.011444 789.528564,352.461182 
	C793.788147,351.828522 794.943176,353.277771 793.581116,357.614594 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M818.782837,359.829651 
	C811.592529,359.973938 804.414795,359.618805 796.820679,359.324829 
	C796.290222,358.822021 796.176147,358.258026 796.068359,357.261688 
	C803.293335,357.742218 810.602295,356.524811 818.139771,357.555969 
	C818.579529,358.018982 818.687500,358.674622 818.782837,359.829651 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M777.983093,366.325226 
	C782.007446,365.536041 786.048706,365.122742 790.097778,364.812622 
	C791.786377,364.683289 793.949280,363.988190 793.817505,367.415344 
	C789.606384,367.947601 785.451721,367.725555 781.354858,368.701569 
	C779.812256,369.069153 777.863464,369.529205 777.983093,366.325226 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M792.440552,333.081970 
	C793.880066,335.766632 791.937439,335.634583 790.255737,335.790375 
	C786.450623,336.142853 782.647522,336.515686 778.425476,336.947815 
	C778.001709,336.576965 777.995972,336.138489 777.995483,335.371155 
	C782.486633,333.075378 787.345947,333.813629 792.440552,333.081970 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M753.754761,384.117065 
	C755.692932,382.095551 755.692932,382.095551 758.524780,385.426208 
	C758.649414,385.128906 758.776733,384.832550 758.890381,384.531006 
	C759.524841,382.846191 755.678833,380.923431 759.199280,379.358032 
	C760.597290,378.736389 760.974365,379.436493 761.068359,380.566895 
	C761.294495,383.285675 763.349060,386.603882 758.863953,387.867920 
	C757.949097,388.125732 756.949585,388.083252 755.630554,388.349945 
	C753.779663,387.589691 753.402649,386.187317 753.754761,384.117065 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M792.442078,380.907562 
	C792.005737,380.426147 792.031616,380.030853 792.063354,379.338440 
	C793.247559,377.856140 795.022400,377.027283 794.718628,374.574402 
	C794.895508,373.448822 794.918213,372.613434 794.968445,371.358948 
	C795.171448,370.956696 795.346985,370.973602 795.783081,371.035828 
	C797.328735,371.909515 798.959595,372.349243 799.457031,374.483765 
	C799.487427,376.699158 799.494568,378.524628 799.484863,380.741364 
	C797.295837,381.086304 795.100037,381.039978 792.442078,380.907562 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M835.972290,372.780212 
	C838.168030,373.384705 837.929871,374.967804 837.903564,376.821014 
	C835.588318,379.082764 832.861206,378.224426 829.869019,378.395294 
	C827.156494,378.364960 825.012207,377.721008 822.566284,376.677673 
	C821.993347,372.997742 824.742676,375.189117 826.314697,374.306061 
	C826.944275,374.123138 827.212830,374.107086 827.884521,374.106567 
	C829.270142,374.740509 830.288696,374.576721 831.576050,374.101074 
	C832.005432,373.826752 832.173096,373.713562 832.613403,373.475708 
	C833.438660,373.159302 834.009705,373.036469 834.853516,372.843231 
	C835.317017,372.781769 835.504272,372.777954 835.972290,372.780212 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M770.221252,382.770081 
	C768.868347,385.117035 766.420288,384.714722 764.389343,386.565491 
	C764.218201,382.435059 761.241882,378.595001 766.475281,376.353668 
	C768.092773,378.359741 764.479248,382.039490 769.227783,382.696533 
	C769.822205,382.489441 770.050049,382.459778 770.221252,382.770081 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M777.043701,372.509338 
	C780.792847,369.793915 782.675110,370.466888 781.981995,375.074219 
	C781.740540,376.679565 783.061096,378.699982 780.476990,379.883362 
	C778.378113,378.818512 778.479187,376.841125 777.563965,375.012329 
	C777.119019,374.116943 776.910522,373.492462 777.043701,372.509338 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M777.932800,357.435150 
	C781.694641,356.757721 785.428284,356.425720 789.571899,356.163818 
	C790.585266,356.774292 790.678101,357.439789 790.218872,358.448792 
	C786.314331,358.832733 782.649963,358.949554 778.531738,359.109741 
	C778.020203,358.695618 777.962402,358.238129 777.932800,357.435150 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M776.891113,372.219299 
	C777.394226,372.635193 777.610596,373.064819 777.948853,373.702362 
	C777.771179,375.714539 778.198059,377.504150 778.139343,379.640076 
	C777.571838,380.912079 776.643921,380.840668 775.453613,381.009674 
	C773.565674,379.104034 773.568237,376.764771 774.062744,374.090149 
	C775.129822,373.270142 775.867065,372.751617 776.891113,372.219299 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M769.718262,382.684875 
	C769.230347,380.430725 768.929993,378.328308 768.471924,376.260834 
	C768.281555,375.401855 768.480530,375.028625 769.289551,374.961884 
	C769.860474,374.914795 770.915222,374.435883 770.844788,375.366180 
	C770.650024,377.937073 773.336792,380.459961 770.566528,383.071167 
	C770.164673,383.110046 769.842102,382.850708 769.718262,382.684875 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M778.426880,380.002899 
	C777.038391,378.058716 776.155212,376.118286 777.714478,373.916382 
	C779.996155,375.255920 778.933960,377.619476 779.979126,379.589417 
	C779.621033,379.934937 779.187805,379.981659 778.426880,380.002899 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M753.549316,383.786560 
	C754.308105,385.023560 754.698364,386.358643 755.180298,388.107208 
	C753.798767,389.719330 752.820129,388.764465 752.200562,387.595062 
	C751.456604,386.190857 751.596741,384.788422 753.549316,383.786560 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M799.478333,381.104614 
	C798.642578,379.095398 798.427979,376.983337 798.754028,374.350098 
	C798.470886,373.155396 798.222717,372.414764 798.778931,371.307068 
	C799.591003,371.164917 800.163086,371.334290 800.878174,371.781494 
	C799.866760,374.703094 800.079773,377.550964 799.605164,380.721344 
	C799.422119,381.119171 799.465088,381.076599 799.478333,381.104614 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M773.957703,373.916931 
	C773.462463,376.052551 775.224670,378.098602 775.028809,380.713135 
	C773.622437,382.489349 773.102905,381.241669 773.127991,380.116211 
	C773.172974,378.096008 772.117859,375.974701 773.957703,373.916931 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M794.234741,370.333557 
	C792.833557,373.658112 791.089905,372.721405 789.153381,370.329193 
	C790.609314,370.075256 792.255310,370.082123 794.234741,370.333557 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M830.894287,372.791077 
	C832.358643,371.993805 833.844604,371.555725 835.667480,371.130310 
	C836.044373,371.511078 836.084351,371.879089 836.188721,372.516663 
	C836.253113,372.786224 836.141663,372.868622 836.095154,372.919983 
	C835.324341,373.686371 834.354919,373.386932 833.245117,373.796814 
	C832.984253,374.007812 832.999878,374.000061 833.007324,373.996094 
	C832.593445,374.375336 832.103088,374.513184 831.246948,374.137451 
	C830.938599,373.629364 830.927246,373.389771 830.894287,372.791077 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M826.258972,374.133514 
	C825.432007,375.567596 823.489685,374.448700 821.931824,375.709412 
	C821.591919,376.151886 821.432739,376.275726 820.973267,376.435760 
	C820.483337,376.402771 820.293884,376.333588 820.011108,375.976624 
	C819.869141,375.361084 819.859619,375.032257 819.884521,374.455261 
	C821.867310,374.181458 823.854797,374.154633 826.258972,374.133514 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M798.640808,370.978638 
	C798.963013,371.715302 798.907166,372.435089 798.807129,373.523254 
	C797.956116,373.113617 797.149231,372.335541 796.192993,371.319336 
	C796.783325,371.041321 797.523071,371.001526 798.640808,370.978638 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M830.619934,373.930969 
	C831.410889,373.871918 831.871826,373.874817 832.673706,373.934937 
	C831.785828,375.632111 830.196106,374.855225 828.488831,374.379944 
	C828.955139,374.079041 829.622498,374.035980 830.619934,373.930969 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M849.844849,368.420349 
	C852.838318,367.220490 854.163940,367.734985 854.037598,370.940247 
	C853.851807,375.654877 854.881897,380.776459 847.906555,383.066528 
	C848.754883,377.982361 844.464172,373.042725 849.844849,368.420349 
z"/>
<path fill="#120B0E" opacity="1.000000" stroke="none" 
	d="
M845.972534,379.764893 
	C845.729126,381.615540 846.630371,383.213501 845.152954,384.407166 
	C844.253357,385.134033 843.525879,386.109497 842.188477,386.009613 
	C840.319702,385.869995 840.990112,384.312500 840.781433,383.340759 
	C840.399414,381.561279 840.454346,379.665131 839.916077,377.946320 
	C838.229492,372.560394 841.066772,371.294495 845.971924,371.383392 
	C845.971924,374.031433 845.971924,376.672455 845.972534,379.764893 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M860.986267,369.289673 
	C861.038818,371.871307 861.281860,374.036591 861.022339,376.139862 
	C860.753784,378.316406 858.843140,378.973633 856.972717,378.957947 
	C854.620789,378.938263 855.966370,377.033844 855.780090,375.973663 
	C855.351013,373.531250 855.652588,371.078064 855.753235,368.614014 
	C855.847534,366.305420 856.765747,365.180878 858.886292,365.174072 
	C861.524414,365.165558 860.625366,367.408966 860.986267,369.289673 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M821.115967,376.152100 
	C821.494080,375.989929 821.615051,376.071991 821.683044,376.050049 
	C823.937378,376.281250 826.123718,376.534393 828.697876,376.903717 
	C835.972412,379.386078 837.329346,382.399109 833.406738,387.513672 
	C832.328491,387.807312 831.546082,387.858826 830.375854,387.832397 
	C829.816528,387.566437 829.645020,387.378387 829.280029,386.862366 
	C829.549866,380.513702 824.508850,380.701111 820.675964,378.948425 
	C820.195618,377.809418 820.258728,377.036163 821.115967,376.152100 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M833.520691,387.799255 
	C835.414124,382.102417 834.912170,380.767731 829.200439,377.341187 
	C831.729614,377.019012 834.373535,377.018188 837.449341,377.107727 
	C838.080872,379.169464 838.085327,381.185028 838.520264,383.102966 
	C839.446106,387.185547 837.847595,388.574615 833.520691,387.799255 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M872.806641,374.943542 
	C872.663269,376.136536 873.637573,377.603455 872.076660,377.502075 
	C870.839111,377.421753 869.097595,377.496918 868.600281,375.490356 
	C868.004272,373.085358 867.788452,370.701996 868.033936,367.972565 
	C871.258728,369.168335 873.100525,371.069977 872.806641,374.943542 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M880.542419,381.701355 
	C876.476379,379.651917 876.999878,376.390411 877.644775,373.064758 
	C879.778748,375.594818 884.291992,377.170349 880.542419,381.701355 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M829.761108,386.633118 
	C830.007751,386.995270 830.015198,387.375427 830.001587,387.564941 
	C827.379272,387.390991 824.770569,387.027466 821.790649,386.540314 
	C820.868042,386.149353 820.316528,385.882019 819.565735,385.380310 
	C819.554993,384.920380 819.743591,384.694794 820.319214,384.256195 
	C824.003662,383.357147 827.161255,383.223755 829.761108,386.633118 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M802.349915,435.967590 
	C801.999512,435.389496 802.049255,434.922668 802.168030,434.108887 
	C802.724182,433.816101 803.231812,433.800354 803.694946,433.936279 
	C805.777588,434.547394 808.331055,433.518188 809.939087,435.674225 
	C810.127563,435.926910 809.863159,436.928467 809.740295,436.941559 
	C807.352600,437.195984 804.961609,437.302948 802.349915,435.967590 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M818.796509,436.699249 
	C817.441284,438.951172 811.767273,438.997406 810.932983,437.080841 
	C810.764587,436.694000 810.936768,435.732483 811.032593,435.721191 
	C812.463623,435.552704 815.105774,435.211731 815.166138,435.463104 
	C815.851501,438.315704 817.836121,435.140198 818.796509,436.699249 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M824.140137,440.060638 
	C822.729370,438.952789 822.456360,437.333557 824.261475,437.614014 
	C825.973022,437.879944 828.496643,437.937592 829.471741,440.859833 
	C827.605469,440.831329 825.983154,441.440247 824.140137,440.060638 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M831.331055,441.591492 
	C831.043518,439.291687 832.155334,439.926636 833.154236,440.581726 
	C833.537109,440.832825 834.666992,441.049774 833.876038,441.735413 
	C833.436768,442.116180 832.393005,441.799530 831.331055,441.591492 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M820.231689,438.763733 
	C819.956055,437.775482 819.939453,437.065308 820.761047,437.000214 
	C821.093811,436.973877 821.709412,437.387878 821.774780,437.692047 
	C821.982849,438.660950 821.441345,439.144257 820.231689,438.763733 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M802.060059,433.579895 
	C801.980408,433.814819 801.774231,433.860443 801.252930,433.936035 
	C801.120850,433.516541 801.336365,433.123199 802.060059,433.579895 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M795.371277,467.818054 
	C794.942505,467.127655 794.929626,466.510681 794.902100,465.585510 
	C798.108276,465.278229 801.146667,467.038666 804.447449,466.268738 
	C804.374512,466.716248 804.301575,467.163727 804.359619,467.812500 
	C801.555054,470.412628 798.686279,468.075104 795.371277,467.818054 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M811.808472,470.148895 
	C811.898926,464.511414 815.313354,468.870361 817.643311,468.394226 
	C818.547913,469.216736 818.371155,469.835907 817.437256,470.532684 
	C815.345581,471.812042 813.932007,468.770844 811.808472,470.148895 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M817.377563,470.833984 
	C817.411499,470.109833 817.719788,469.546753 818.040039,468.740784 
	C819.990234,468.413361 822.124207,467.767639 823.096313,470.658020 
	C821.225220,472.929413 819.455200,469.881714 817.377563,470.833984 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M804.878296,468.415161 
	C806.127075,467.499542 807.110046,469.558502 808.946167,467.597107 
	C811.300720,465.081970 810.227844,468.526306 810.594299,469.702362 
	C808.624634,469.698822 806.430603,470.780304 804.878296,468.415161 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M832.285950,400.705078 
	C827.684937,400.420868 822.863342,401.712921 818.986450,397.908569 
	C822.777710,398.294373 826.810669,397.788757 830.762817,399.255249 
	C832.157043,398.788452 832.399048,399.467896 832.285950,400.705078 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M814.055847,396.157349 
	C813.971924,394.818390 813.971924,393.845947 813.971924,392.873535 
	C814.879517,394.746704 817.929871,393.817047 818.176758,396.513306 
	C818.245667,396.801208 818.137817,396.880249 818.086426,396.922974 
	C817.473816,397.542084 816.804871,397.777802 815.639771,397.529541 
	C814.779541,397.283264 814.402100,396.973724 814.055847,396.157349 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M832.463379,401.079834 
	C831.919617,400.510590 831.731567,399.958679 831.294189,399.250732 
	C831.215637,398.432007 831.386475,397.769318 831.766602,396.820618 
	C832.249817,398.056763 835.369019,399.053192 832.463379,401.079834 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M813.727417,395.974030 
	C814.263184,396.016388 814.554382,396.241943 814.924316,396.744659 
	C815.183960,397.217499 815.364990,397.413177 815.337158,397.949799 
	C814.910583,399.127594 814.393616,399.456146 813.282349,398.974548 
	C813.030457,398.188873 813.041870,397.651001 813.046143,396.845093 
	C813.187012,396.437134 813.334961,396.297180 813.727417,395.974030 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M808.127686,422.590149 
	C809.166870,422.815338 810.513184,422.809845 810.559814,423.053284 
	C810.750244,424.047333 810.187073,425.240723 809.206238,425.265656 
	C808.211060,425.290924 806.735107,425.261566 806.288635,423.964966 
	C805.852356,422.697998 806.538452,422.163422 808.127686,422.590149 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M811.981262,420.509460 
	C812.151428,420.130920 812.325745,420.142761 812.762085,420.152039 
	C812.728210,422.213257 813.543640,424.404877 811.985352,427.223267 
	C811.985352,424.555847 811.985352,422.727844 811.981262,420.509460 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M794.364868,424.984894 
	C794.197021,423.825653 793.239441,422.044922 795.812622,422.763733 
	C795.992981,423.440308 795.984985,423.867188 795.994995,424.613892 
	C795.570068,424.992554 795.127258,425.051361 794.364868,424.984894 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M805.139893,418.838715 
	C805.180298,418.557007 805.630737,418.612335 805.811646,418.749268 
	C805.852966,419.276642 805.713501,419.667084 805.573975,420.057556 
	C805.415833,419.745178 805.257690,419.432800 805.139893,418.838715 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M815.396851,398.462463 
	C815.097290,398.080170 815.066284,397.869629 815.019165,397.340454 
	C815.761047,396.958679 816.519165,396.895569 817.656128,396.899078 
	C818.143677,397.918793 818.487671,399.015106 817.490479,399.627350 
	C816.528931,400.217712 816.060791,399.370850 815.396851,398.462463 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M812.914062,416.407104 
	C812.431335,416.597565 811.898804,416.517609 811.180786,416.227356 
	C811.682251,415.057678 812.322266,414.830872 812.914062,416.407104 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M839.269531,507.095642 
	C831.940735,503.420898 824.237000,505.348724 816.486755,504.459839 
	C819.630493,503.731720 823.055969,503.285797 826.866943,502.761108 
	C834.739868,503.534576 842.088928,504.959229 849.365967,508.149567 
	C849.702393,508.632599 849.731628,508.918976 849.351990,509.318115 
	C847.842712,509.499939 846.742615,509.520599 845.324402,509.163666 
	C845.005676,508.912079 844.998291,508.985046 845.026367,508.961426 
	C843.983948,508.142029 842.703125,508.678925 841.279236,508.148010 
	C841.005066,507.910950 841.008606,507.983124 841.038574,507.963013 
	C840.572876,507.563934 839.973511,507.489624 839.269531,507.095642 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M853.263672,512.690735 
	C852.210999,513.104553 851.344055,513.245361 850.702637,512.411194 
	C851.267029,512.261963 851.831482,512.112732 852.726685,511.929810 
	C853.187988,512.071045 853.318359,512.245972 853.263672,512.690735 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M850.823730,508.871460 
	C851.066956,509.168213 851.073425,509.372437 851.017700,509.876770 
	C850.512817,510.392609 850.048584,510.472473 849.285461,510.159790 
	C849.011047,509.923126 849.015015,509.992249 849.045715,509.976257 
	C848.902649,509.853699 848.728943,509.747192 848.720581,509.383636 
	C849.011658,508.991669 849.137390,508.856720 849.468140,508.533997 
	C849.977783,508.490448 850.282410,508.634674 850.823730,508.871460 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M852.546997,505.470459 
	C852.576111,505.520172 852.517822,505.420746 852.546997,505.470459 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M799.080688,488.367065 
	C798.970032,487.403381 798.997253,486.683746 799.031616,485.604401 
	C805.074768,485.477356 811.110718,485.710022 817.505249,486.016602 
	C820.060608,486.503174 822.387939,485.033936 824.753418,486.794708 
	C826.480286,487.585327 827.961670,488.132690 829.681824,488.931793 
	C829.955627,489.625092 829.990723,490.066681 830.066406,490.838409 
	C824.507446,492.453674 818.716675,491.894440 813.470154,490.534271 
	C808.683899,489.293396 803.883667,489.738037 799.080688,488.367065 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M813.697266,495.713074 
	C814.590088,493.886749 816.200500,494.574890 817.648315,494.605591 
	C817.668945,494.606018 817.769287,495.212524 817.676636,495.482697 
	C817.075684,497.234924 815.800842,495.932617 814.550903,496.182068 
	C814.134949,496.159210 814.007874,496.033722 813.697266,495.713074 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M798.754456,417.130249 
	C798.448059,417.833862 797.925720,418.076935 797.163635,417.287598 
	C797.508606,416.341980 798.054382,416.818817 798.754456,417.130249 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M769.139038,395.437897 
	C765.662048,396.832550 762.232910,397.902222 758.416870,398.967865 
	C762.151672,395.734650 766.273254,392.505493 770.708923,389.140320 
	C771.826538,390.240570 773.108948,389.942596 774.633179,390.005646 
	C774.844360,393.725433 770.675354,392.899841 769.139038,395.437897 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M775.002441,390.003479 
	C775.339478,389.770477 775.674133,389.533600 776.008789,389.296722 
	C776.089172,389.414581 776.169556,389.532410 776.249939,389.650269 
	C775.983704,389.754700 775.717529,389.859131 775.221619,389.977844 
	C774.991943,389.992157 775.000000,389.999603 775.002441,390.003479 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M825.044556,486.665710 
	C822.678162,486.935638 820.357544,486.833344 817.950317,486.410797 
	C820.726013,484.187561 817.492126,483.735901 817.006897,482.349060 
	C821.194458,481.898254 825.233032,483.807281 829.765137,482.859863 
	C830.480164,483.356812 830.922668,484.151184 831.532227,485.238037 
	C829.670166,487.291290 826.993164,483.439575 825.044556,486.665710 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M827.098511,456.665405 
	C825.610291,456.702820 824.409302,457.297119 822.971558,456.289795 
	C821.475891,454.971863 819.980957,455.852875 818.593811,455.497681 
	C816.905029,455.065186 815.939026,454.462280 816.705444,452.276489 
	C820.649170,452.684967 824.394897,453.393372 828.512085,454.171875 
	C828.883484,454.242004 828.973938,454.637238 828.983154,454.839813 
	C828.998291,455.213104 829.004150,455.383820 828.987854,455.809753 
	C828.550598,456.550201 828.030945,456.796783 827.098511,456.665405 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M834.401978,451.575928 
	C834.405273,451.550873 834.411499,451.548096 834.432007,451.563049 
	C834.452515,451.578033 834.398682,451.601013 834.401978,451.575928 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M826.928467,456.867798 
	C827.342590,456.347565 827.873901,456.121185 828.685486,455.979919 
	C829.525818,457.585144 831.078247,456.622192 832.210022,457.545532 
	C830.530151,458.482941 828.588257,459.459564 826.928467,456.867798 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M817.361816,385.051086 
	C815.492249,381.710480 815.108704,378.685577 818.865234,376.210510 
	C820.328674,378.748505 820.788269,381.482788 819.628296,384.752930 
	C818.871887,385.176697 818.317078,385.172546 817.361816,385.051086 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M819.421082,385.157410 
	C818.587036,382.473816 819.095764,379.704895 819.125366,376.513245 
	C819.201233,376.065033 819.567688,375.895538 819.742737,375.792175 
	C820.182556,375.726685 820.447327,375.764587 821.103149,375.896210 
	C821.391907,376.658051 821.289734,377.326141 821.158936,378.337097 
	C822.262573,380.383942 822.624817,382.164948 821.355469,384.434448 
	C820.762512,384.852509 820.484192,384.913849 819.786133,385.060547 
	C819.366394,385.145935 819.415405,385.133972 819.421082,385.157410 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M848.482666,509.106567 
	C848.885986,509.126587 849.048279,509.528107 849.062378,509.744202 
	C847.862000,509.810486 846.647644,509.660736 845.219482,509.211517 
	C846.083679,508.029327 847.050354,509.106720 848.482666,509.106567 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M841.203674,508.223877 
	C842.339355,506.956482 843.490356,508.178467 844.897339,508.581665 
	C843.837036,508.804138 842.619629,508.670471 841.203674,508.223877 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M838.968018,507.019958 
	C839.778625,506.977417 840.407288,507.134918 841.052307,507.617676 
	C840.299561,507.727875 839.162537,508.674652 838.968018,507.019958 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M849.090332,510.168579 
	C849.446472,509.955414 849.881958,509.987671 850.636475,510.098419 
	C850.431458,510.791748 849.837158,510.878265 849.090332,510.168579 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M52.721153,512.003906 
	C52.807877,512.224365 52.629215,512.518860 52.196712,512.896851 
	C52.113838,512.679565 52.284809,512.378723 52.721153,512.003906 
z"/>
<path fill="#F7EBDA" opacity="1.000000" stroke="none" 
	d="
M997.883057,252.355469 
	C996.864197,252.432373 996.234314,252.429886 995.302246,252.521759 
	C990.474060,253.521103 985.873169,252.592896 980.937012,253.246368 
	C978.595886,253.266754 976.651428,253.214523 974.350220,253.287888 
	C971.697205,254.428894 969.267456,253.827942 966.502625,254.000275 
	C964.632202,253.992188 963.160583,253.983093 961.264404,254.099274 
	C960.482971,254.400253 960.107117,254.482224 959.428467,254.367889 
	C956.397278,254.289856 953.646790,254.299057 950.437317,254.307220 
	C946.223083,243.099426 946.459229,242.745453 958.139648,242.008209 
	C972.707031,241.088760 987.274109,240.162186 1001.841797,239.247055 
	C1007.274170,238.905792 1007.274841,238.916611 1007.099243,246.648743 
	C1006.901062,248.211227 1006.573608,249.334290 1006.121460,250.789093 
	C1003.613892,252.789810 1000.784729,251.474930 997.883057,252.355469 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M938.493896,248.900055 
	C937.055298,239.614471 935.967346,230.244949 934.913147,220.436264 
	C935.676514,220.000702 936.406067,220.004303 937.498657,220.014740 
	C937.941101,220.447144 938.020508,220.872711 938.109131,221.623276 
	C938.371582,226.302795 939.202332,230.515411 941.364624,234.740540 
	C942.012268,236.770859 942.484497,238.504578 942.954102,240.625092 
	C942.049805,241.080093 941.302979,241.360580 941.044312,242.685318 
	C938.865845,244.413864 941.241516,247.499237 938.493896,248.900055 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M941.609985,234.659225 
	C937.126770,231.817719 937.611511,227.038025 937.822693,222.193939 
	C940.311157,225.768845 940.437622,230.186203 941.609985,234.659225 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M980.981323,253.572327 
	C984.978210,250.888260 989.742798,252.024872 994.702881,252.332581 
	C990.678467,255.311584 985.965881,253.619034 980.981323,253.572327 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M966.322388,254.316025 
	C968.279663,252.233688 970.843872,253.257111 973.612366,253.211517 
	C971.928162,256.383575 969.110413,254.746887 966.322388,254.316025 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M997.921021,252.657867 
	C999.682068,250.093414 1002.613464,251.394241 1005.584351,250.994263 
	C1004.132263,254.684784 1000.955566,252.546402 997.921021,252.657867 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M959.238281,254.510162 
	C959.535034,254.132736 959.922180,253.984818 960.574585,254.030716 
	C960.598572,255.166412 960.003906,255.071228 959.238281,254.510162 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M934.133301,251.116943 
	C935.440552,250.985443 936.320923,250.990723 937.531555,250.966293 
	C937.978516,252.337585 938.095215,253.738571 938.128540,255.555695 
	C935.910522,256.189301 936.054321,257.787964 936.050293,259.282349 
	C936.028137,267.462891 936.012268,275.643402 936.033936,284.345123 
	C935.489319,285.252472 934.970703,285.177887 934.290405,284.255981 
	C932.828796,278.013336 933.595398,272.086700 933.480713,266.195435 
	C933.394470,261.763519 933.333374,257.333923 933.166016,252.470276 
	C933.409546,251.772568 933.557983,251.513153 934.133301,251.116943 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M939.191772,284.367310 
	C939.195374,283.440491 938.804382,281.981537 940.790161,282.181580 
	C941.013550,282.784637 940.872131,283.222321 940.578491,283.836548 
	C940.162903,284.161346 939.899475,284.309631 939.191772,284.367310 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M938.770020,284.276062 
	C939.022095,284.201630 939.296753,284.126617 939.998840,284.032349 
	C940.426331,284.013092 940.487549,284.457947 940.386230,284.658264 
	C940.110962,284.968781 939.937012,285.078949 939.463379,285.263062 
	C939.019287,285.190277 938.875000,285.043579 938.783081,284.592773 
	C938.835510,284.288605 938.792664,284.275513 938.770020,284.276062 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M938.835876,285.296692 
	C939.223389,285.025513 939.438354,285.014252 939.969055,284.930817 
	C940.332520,285.058105 940.380127,285.257568 940.252380,285.709717 
	C939.915405,286.006683 939.753723,286.050995 939.344666,286.050049 
	C938.952698,285.855377 938.808044,285.705963 938.835876,285.296692 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M938.876099,284.870361 
	C939.008423,285.036804 938.970459,285.528656 939.033936,285.766724 
	C936.515869,287.579559 933.690247,288.497192 930.365417,289.141357 
	C929.841003,288.989807 929.700867,288.802155 929.486816,288.271362 
	C929.457764,287.699097 929.502563,287.469971 929.744080,286.951477 
	C931.314148,285.752563 932.887085,285.422272 934.806335,285.120544 
	C935.376465,285.189697 935.598633,285.171967 935.944458,284.975525 
	C936.768188,284.738129 937.462708,284.609955 938.496338,284.385193 
	C938.835510,284.288605 938.743774,284.703918 938.876099,284.870361 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M964.872681,332.564636 
	C964.288513,332.927368 963.517639,333.056335 962.356567,333.123291 
	C962.351318,330.875580 963.370728,331.052765 964.872681,332.564636 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M954.910034,318.858154 
	C955.006714,318.561737 955.272400,318.482269 955.943359,318.506195 
	C955.997375,318.960785 955.741516,319.572540 954.910034,318.858154 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M973.392822,421.453613 
	C972.970520,420.703308 972.972656,419.946136 972.974915,418.906067 
	C981.356445,418.404694 989.737854,418.186157 998.583496,418.065979 
	C998.421509,418.947968 997.122986,419.163666 997.031006,420.768799 
	C989.242615,421.199036 981.529907,421.322876 973.392822,421.453613 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M943.432312,430.938232 
	C943.596680,429.388519 944.176514,427.945618 944.865723,426.182556 
	C953.255981,423.755463 961.771484,423.212616 970.608093,422.173096 
	C971.376709,423.709839 971.735413,425.151520 972.164307,426.902924 
	C962.772217,428.490143 953.309937,429.767609 943.432312,430.938232 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M1001.069092,436.938934 
	C991.677795,437.375793 982.613831,437.580811 973.240356,437.518555 
	C972.947388,435.527710 972.963745,433.804230 972.963013,431.653503 
	C976.668213,431.063202 980.390564,430.900085 984.566895,430.840759 
	C984.480713,434.484283 981.343323,432.581360 979.281555,433.809082 
	C984.861084,432.722595 990.592102,435.465332 995.734863,431.317108 
	C996.446167,431.022003 996.919250,430.973297 997.746033,430.866089 
	C1002.123230,431.559601 1006.146790,432.311615 1010.576660,433.154663 
	C1010.319397,435.840790 1008.180664,434.847443 1006.586426,434.959015 
	C1004.671692,435.093048 1002.665039,434.734436 1001.069092,436.938934 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M995.655762,430.966125 
	C996.209229,434.034088 994.194519,434.861450 991.898499,434.938721 
	C987.248840,435.095184 982.590454,435.013458 977.935974,434.984650 
	C977.002930,434.978882 975.638733,435.201385 975.579346,433.854950 
	C975.513977,432.374634 976.876892,432.167236 978.057251,432.024567 
	C980.183899,431.767517 982.381958,432.419495 984.739990,431.234100 
	C985.764343,430.894470 986.507690,430.844391 987.616150,430.879150 
	C989.730835,432.071655 991.638062,431.325165 993.745605,431.204651 
	C994.458435,430.939545 994.898438,430.900543 995.655762,430.966125 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M993.596130,430.875366 
	C992.309814,432.577637 990.404053,432.117889 988.232544,431.236237 
	C989.712097,430.900055 991.442932,430.836090 993.596130,430.875366 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M972.212097,403.002106 
	C971.916992,401.829834 971.889587,401.064911 971.846680,400.014282 
	C980.277649,398.709625 988.752930,399.067932 997.701660,399.257935 
	C998.176636,399.957275 998.173462,400.595245 998.128235,401.550171 
	C997.612610,402.333466 997.101562,402.922394 996.481750,402.983154 
	C988.494568,403.766052 980.500549,404.439758 972.212097,403.002106 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M970.372314,389.865448 
	C968.747986,388.038330 969.022400,386.033661 969.093628,383.684723 
	C969.636536,382.352295 970.525635,381.818878 971.532471,381.794708 
	C980.426392,381.581085 989.331055,380.815155 998.628418,382.429749 
	C999.202881,382.776947 999.351807,382.867767 999.741943,383.059601 
	C1001.995239,385.746735 1001.525269,387.175446 998.107788,387.497070 
	C996.544922,387.644135 995.016724,388.160919 993.224976,388.800812 
	C987.959229,389.275879 982.941406,389.460175 977.482422,389.619263 
	C976.210632,389.495880 975.379089,389.446655 974.255859,389.668396 
	C972.901367,389.833008 971.835693,389.877563 970.372314,389.865448 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M974.350952,389.869659 
	C974.698669,388.938232 975.600952,388.893188 976.813110,389.414001 
	C976.272522,389.713013 975.503723,389.831940 974.350952,389.869659 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M971.696289,402.680176 
	C980.343628,402.391022 988.742737,402.187286 997.614014,401.925323 
	C998.270935,402.125336 998.484558,402.356995 998.884094,402.740021 
	C999.797241,406.201630 996.261353,406.272949 995.043823,408.472290 
	C987.966614,408.855652 980.975403,408.910614 973.522217,408.911865 
	C971.927063,407.279114 971.497803,405.386047 970.846558,403.299438 
	C971.122253,402.892914 971.285217,402.829224 971.696289,402.680176 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M1011.736084,337.148254 
	C1011.629456,338.733826 1010.930054,340.363892 1009.141418,339.382050 
	C1006.702454,338.043121 1003.490723,337.930298 1001.852173,334.713745 
	C1001.767639,334.321960 1001.814087,333.978638 1001.903442,333.830292 
	C1004.496704,336.576111 1008.352783,335.677490 1011.736084,337.148254 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M966.300049,364.585327 
	C966.302368,363.800323 966.749207,363.008972 967.036255,362.044312 
	C967.771301,359.037689 970.236633,359.671356 972.218689,359.628693 
	C978.614990,359.491089 985.015015,359.573395 991.887756,359.588531 
	C993.314514,359.632080 994.262817,359.690704 995.534302,360.397278 
	C997.053528,360.764648 998.171570,360.878510 999.698730,361.100494 
	C1000.165710,361.740936 1000.223511,362.273224 1000.281860,363.075684 
	C994.248413,364.589508 988.135071,363.665558 982.065796,364.001495 
	C976.963745,364.283905 971.851990,364.393127 966.300049,364.585327 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M1015.809814,376.595581 
	C1015.321716,377.744202 1014.517151,378.672455 1013.453003,380.068970 
	C1013.029663,380.750305 1012.831726,380.924622 1012.379578,381.053040 
	C1011.431213,380.011902 1010.495972,379.923309 1009.158203,380.611206 
	C1008.455872,380.743958 1008.022034,380.713684 1007.295105,380.536499 
	C1006.784119,380.397339 1006.566101,380.404999 1006.061523,380.255035 
	C1005.068115,380.072632 1004.361328,380.047852 1003.313721,379.925720 
	C1001.599854,378.392853 1000.440247,376.825073 999.992432,374.556549 
	C1000.084045,374.240234 1000.217590,373.932861 1000.103027,373.811218 
	C1005.156799,374.584778 1010.325012,375.479980 1015.809814,376.595581 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M993.240906,456.542786 
	C990.290955,456.791931 987.602173,456.810364 984.467529,456.780151 
	C983.848816,456.678162 983.675964,456.624756 983.241333,456.642761 
	C980.307739,456.747772 977.635803,456.781311 974.520630,456.855835 
	C973.882935,456.708069 973.688477,456.519287 973.344238,455.952759 
	C973.245483,454.239899 973.203369,452.898010 973.690979,451.233154 
	C973.898132,450.886780 973.862488,450.670288 973.842773,450.562378 
	C980.959167,448.787964 988.134705,449.296753 995.775513,450.245117 
	C996.639099,450.522705 997.042053,450.621155 997.730530,450.844818 
	C998.914001,454.780823 995.721375,455.135193 993.240906,456.542786 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M977.887573,441.053833 
	C984.393738,439.920166 990.774231,440.671661 997.588989,441.012146 
	C998.348755,442.896240 998.674255,444.607483 998.995300,446.699097 
	C998.434265,447.266174 997.877625,447.452850 997.049316,447.518921 
	C995.447083,447.222198 994.729553,448.436554 993.211914,448.932404 
	C988.119751,449.763855 983.436707,449.584473 978.335754,449.122559 
	C975.202087,447.224762 973.190491,445.105438 974.673950,441.232971 
	C975.445435,440.908051 975.885559,440.832550 976.655273,440.825012 
	C977.099854,441.316559 977.358826,441.441864 977.887573,441.053833 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M999.301392,441.241028 
	C1000.522522,441.125946 1001.987671,441.295929 1003.741089,441.691895 
	C1002.505066,442.126862 1000.996887,442.151031 999.301392,441.241028 
z"/>
<path fill="#8A97B7" opacity="1.000000" stroke="none" 
	d="
M976.640381,447.399139 
	C982.130005,447.513092 987.227356,447.488770 992.795044,447.352448 
	C993.945251,447.566620 994.682983,447.503174 995.706787,447.760315 
	C996.071594,448.575806 996.132690,449.189392 996.214966,450.113617 
	C989.073547,450.528015 981.911011,450.631805 974.285645,450.595032 
	C973.869507,449.846375 973.916077,449.238312 973.978638,448.325195 
	C974.605103,447.349457 975.376404,447.156189 976.640381,447.399139 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M996.236572,447.867920 
	C995.313965,447.814453 994.617371,447.666748 993.593140,447.379761 
	C994.204956,447.210083 995.144409,447.179718 996.430786,447.273865 
	C996.777649,447.398346 996.462646,447.773621 996.236572,447.867920 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M999.662109,374.002930 
	C1000.920105,375.954559 1003.192749,376.823700 1002.974792,379.492676 
	C1001.906738,379.893707 1000.840637,379.959015 999.417480,380.208862 
	C997.302551,381.633545 995.280457,381.546051 993.288025,381.484131 
	C985.499146,381.242126 977.712646,381.886597 969.583130,381.193420 
	C969.241821,380.862457 969.109985,380.574554 969.006348,380.456055 
	C968.518921,378.672180 968.135071,377.006836 967.667053,374.908783 
	C971.905640,372.833588 976.409180,373.789856 980.820801,373.660095 
	C986.954224,373.479584 993.099792,373.710724 999.662109,374.002930 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M968.952698,381.070251 
	C978.849609,379.652069 988.481323,380.065796 998.586365,380.415588 
	C999.065247,380.966553 999.070190,381.539764 999.064575,382.399536 
	C989.368896,382.812866 979.683777,382.939575 969.553955,383.186279 
	C968.916077,383.276794 968.722839,383.247314 968.236389,383.215729 
	C968.183289,382.568451 968.423462,381.923279 968.952698,381.070251 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M1009.168579,380.894806 
	C1009.630737,378.945435 1010.672546,378.615265 1012.122498,380.589233 
	C1011.255615,381.035675 1010.351501,381.025543 1009.168579,380.894806 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M1005.942078,380.262268 
	C1006.067932,379.920074 1006.369385,379.904480 1006.840637,380.220184 
	C1007.002075,380.389648 1006.561646,380.549408 1006.561646,380.549408 
	C1006.561646,380.549408 1006.109314,380.427124 1005.942078,380.262268 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M973.754395,341.647034 
	C972.615295,341.964081 971.216492,342.052399 969.403198,342.057678 
	C970.347778,340.631653 971.908264,340.920197 973.754395,341.647034 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M978.910034,341.623871 
	C978.843323,341.815918 978.673462,341.871643 978.244019,341.859680 
	C978.258667,341.690552 978.532776,341.589020 978.910034,341.623871 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M984.903809,341.526917 
	C984.838440,341.717682 984.670959,341.776703 984.245605,341.768921 
	C984.174133,341.352417 984.445435,341.250092 984.903809,341.526917 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M965.305054,355.276459 
	C964.427490,354.160797 967.808899,353.915894 965.141235,352.667511 
	C976.988098,351.202576 989.010803,350.714447 1001.532471,351.057678 
	C1002.038391,351.790741 1002.079224,352.597626 1002.105164,353.707214 
	C1002.090271,354.009918 1002.162231,354.463959 1002.069214,354.674133 
	C1000.907776,355.834778 999.584412,356.094879 998.260071,355.937866 
	C989.972107,354.955322 981.750000,356.209595 973.054199,356.582916 
	C971.719788,356.477997 970.831238,356.417206 969.493164,356.441895 
	C967.834778,356.446106 966.674500,356.224731 965.305054,355.276459 
z"/>
<path fill="#0B0410" opacity="1.000000" stroke="none" 
	d="
M971.759216,355.214661 
	C981.728149,354.146667 991.456116,354.122620 1001.583618,354.696838 
	C1001.338684,358.178802 995.944885,355.840973 995.961731,360.296021 
	C995.218811,360.657349 994.502014,360.663879 993.432068,360.604004 
	C986.346741,359.515472 979.598999,359.952667 972.850342,360.304504 
	C970.416382,360.431427 967.924194,361.095490 965.291138,359.382996 
	C964.658630,358.258423 964.360657,357.410675 964.012085,356.227966 
	C964.131165,355.622070 964.356934,355.411072 964.816650,355.107422 
	C966.059937,354.980042 967.125427,355.005280 968.590820,355.058899 
	C969.763306,355.689423 970.641235,355.497925 971.759216,355.214661 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M894.031799,233.137756 
	C892.513184,232.676590 890.858765,233.582764 890.062378,231.358185 
	C892.084351,230.716476 892.054016,229.140610 891.974548,227.617096 
	C891.620789,220.833725 891.927979,214.061874 891.323975,207.238388 
	C890.643433,199.551254 892.367371,191.718689 892.068970,183.437653 
	C895.851135,183.752655 895.876892,187.050873 895.866516,189.618408 
	C895.839294,196.355637 895.365295,203.232742 895.731201,209.809860 
	C895.975464,214.198624 895.222961,220.964828 901.763916,223.900833 
	C904.020630,227.260239 907.515137,227.537186 910.601440,228.524689 
	C912.326416,229.076584 914.134766,229.366318 916.185425,230.004242 
	C918.930664,231.274689 921.273438,232.765213 924.589111,231.993530 
	C925.272827,232.780182 925.575623,233.571640 925.915833,234.680023 
	C926.606079,237.214737 927.555786,239.387192 926.824646,242.183960 
	C925.234741,244.384827 923.354919,243.768356 921.667908,243.329239 
	C914.520874,241.469009 907.330811,239.760574 899.953186,237.335007 
	C899.419922,237.010788 899.221802,236.866119 898.771484,236.468048 
	C897.942749,235.566177 897.599243,234.676727 896.337158,234.330048 
	C895.377258,234.075638 894.784607,233.800461 894.031799,233.137756 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M925.927063,243.264923 
	C925.964417,240.582214 925.949646,238.231201 925.944092,235.438568 
	C927.244446,235.567535 926.739075,237.636017 928.714172,237.958557 
	C932.717957,241.208755 930.151184,245.591034 931.229126,249.709122 
	C931.293396,250.670639 931.256348,251.214310 931.076721,252.139618 
	C930.486633,253.978394 929.790894,255.329895 928.622314,256.829224 
	C925.984009,258.024445 924.280579,256.203949 922.270508,255.623672 
	C921.874146,255.509277 921.393494,254.622604 921.141113,255.339050 
	C920.995361,255.752960 921.560852,256.528290 921.390076,257.541931 
	C920.705017,258.683228 919.844238,259.036163 918.629150,259.449585 
	C918.068054,259.569122 917.840149,259.595490 917.270569,259.599213 
	C915.829407,259.334991 914.795532,258.959656 913.832153,257.866364 
	C913.555847,257.032959 913.605835,256.472198 913.791992,255.687347 
	C913.837402,255.459732 913.699585,255.063690 913.699585,255.063690 
	C913.699585,255.063690 913.274109,255.135834 913.042664,255.243225 
	C912.635620,255.356979 912.460083,255.363327 912.035156,255.270782 
	C911.385254,254.830215 911.057678,254.414520 910.436035,253.969391 
	C909.691467,253.935867 909.203430,254.111267 908.429443,254.256699 
	C907.412170,253.900085 907.183411,253.151459 906.659668,252.268723 
	C906.379578,251.878418 906.256104,251.727722 905.920715,251.366516 
	C905.241211,250.731110 904.801025,250.283997 904.462158,249.370316 
	C906.719788,245.501724 909.789124,244.990250 914.215332,248.603394 
	C915.917175,249.992630 916.174072,248.254562 917.415649,248.543961 
	C919.985474,249.340302 922.142090,250.761581 924.667114,249.003876 
	C925.596619,247.105011 925.618530,245.324463 925.927063,243.264923 
z"/>
<path fill="#200C1A" opacity="1.000000" stroke="none" 
	d="
M930.338013,251.037781 
	C929.778381,246.729294 929.489929,242.767944 929.123108,238.405838 
	C930.766357,236.573532 931.458374,237.584167 931.538940,239.217636 
	C931.644836,241.364822 931.707825,243.554565 931.403931,245.670685 
	C931.066711,248.018982 931.710205,249.541595 934.263062,250.651825 
	C934.430176,251.098404 934.300171,251.216675 934.062927,251.575851 
	C932.768433,252.229248 931.643555,252.157974 930.338013,251.037781 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M961.324158,470.364502 
	C958.545044,470.439362 956.155273,470.605621 953.376465,470.858459 
	C952.499390,470.726654 952.011475,470.508270 951.249756,470.227417 
	C950.129517,469.660126 949.674561,468.953094 950.122192,467.595825 
	C957.547119,464.698700 964.827026,463.738556 972.740662,465.342010 
	C973.296204,465.607910 973.445984,465.684448 973.787109,465.925476 
	C973.968994,466.777588 973.959717,467.465210 973.962341,468.496643 
	C973.771179,469.100525 973.568054,469.360626 973.196533,469.805878 
	C970.335083,470.025696 967.642090,470.060394 964.502808,470.124207 
	C963.313049,470.544434 962.511292,470.484711 961.324158,470.364502 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M973.120605,465.156738 
	C965.687073,466.236694 958.227722,466.942047 950.373047,467.774658 
	C948.188416,469.630615 946.127869,469.595306 943.581482,468.556030 
	C941.426086,466.996765 941.664246,465.445557 942.815247,463.491699 
	C943.368713,462.837708 943.678162,462.342072 944.141479,462.222900 
	C953.475464,459.822693 962.932495,458.678741 972.859131,459.907196 
	C973.126343,461.776184 973.110535,463.279175 973.120605,465.156738 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M973.356323,460.144775 
	C963.335388,460.729706 953.586243,461.772675 943.439575,463.164978 
	C943.013794,462.409973 943.018066,461.636780 943.052063,460.476196 
	C951.881165,457.295807 961.028687,456.905823 970.562744,456.107513 
	C971.725281,455.449615 972.516724,455.266327 973.618652,456.032562 
	C973.837158,456.404114 973.929443,456.663788 974.003418,456.780304 
	C974.048523,457.598206 974.019714,458.299622 973.975464,459.352264 
	C973.960144,459.703522 973.570618,460.016296 973.356323,460.144775 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M983.239258,456.771545 
	C983.201050,456.394348 983.476685,456.317749 983.914062,456.607971 
	C983.847412,456.764008 983.673157,456.796478 983.239258,456.771545 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M306.630920,870.002319 
	C305.802185,871.305664 304.442993,871.188354 302.279114,870.267212 
	C304.085999,870.151794 305.177826,870.082092 306.630920,870.002319 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M307.001770,870.003174 
	C307.934143,868.919739 308.976135,868.556702 310.290619,869.452942 
	C309.539032,870.467651 308.546570,869.871704 307.346710,870.002441 
	C306.992218,869.992249 306.999603,869.999756 307.001770,870.003174 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M231.964401,841.396484 
	C232.481873,841.510864 232.994095,842.032593 233.784866,842.560120 
	C234.138199,846.025513 235.570877,849.393921 234.626526,853.823059 
	C233.614517,849.262939 232.786835,845.533447 231.964401,841.396484 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M595.688965,860.955933 
	C595.559265,862.051270 594.510559,861.869385 593.296265,862.159973 
	C593.402100,861.176392 594.351990,861.019287 595.688965,860.955933 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M586.176025,865.252930 
	C586.462524,864.996460 586.899536,864.953186 587.666138,864.926514 
	C587.602478,865.637817 587.097229,865.975342 586.176025,865.252930 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M337.996094,876.995789 
	C337.028015,876.865540 335.481995,876.294739 335.186768,876.680725 
	C331.375336,881.663757 329.671967,874.457336 326.659149,875.291931 
	C326.620361,874.867676 326.456604,874.408447 326.563812,874.025024 
	C327.101166,872.102234 330.040283,874.103333 330.354828,871.743164 
	C333.704071,875.807678 336.991577,872.650696 340.310120,871.685852 
	C340.575714,871.608704 340.935883,871.856689 341.583435,872.007446 
	C341.621765,872.832886 341.328766,873.604370 340.847992,874.906982 
	C340.482300,875.490967 340.304382,875.543823 339.849915,875.600952 
	C338.985504,875.697754 338.593262,876.046082 338.159729,876.776855 
	C337.992828,876.994934 337.999542,877.000000 337.996094,876.995789 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M378.648682,859.340698 
	C380.753479,859.158020 381.388733,859.973145 380.306915,861.878052 
	C379.194183,861.958862 378.363251,861.769043 378.076721,860.421265 
	C378.118378,859.962280 378.211761,859.818115 378.648682,859.340698 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M345.001038,868.999390 
	C346.192535,869.988953 346.453369,871.271179 346.007568,872.673035 
	C345.974243,872.777893 344.928650,872.560791 344.171875,872.254028 
	C343.990143,872.014771 344.009827,871.982117 344.019501,871.965759 
	C344.756531,871.269958 344.397766,870.327393 344.807190,869.263550 
	C344.997894,869.002441 345.000000,869.000000 345.001038,868.999390 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M338.248749,876.887329 
	C338.065063,876.083008 338.283600,875.273743 339.666138,875.539307 
	C339.489288,876.272339 338.996979,876.526001 338.248749,876.887329 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M371.901428,861.634888 
	C372.174469,861.360291 372.580658,861.245850 372.994781,861.188171 
	C373.066132,861.178284 373.171021,861.409180 373.260437,861.528870 
	C372.852692,861.624023 372.444977,861.719116 371.901428,861.634888 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M340.504517,876.007812 
	C340.845398,876.439575 340.676575,876.868713 340.507721,877.297852 
	C340.348206,877.036499 340.188690,876.775085 340.005371,876.266174 
	C339.981598,876.018677 339.994812,876.005249 340.504517,876.007812 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M376.599609,860.277466 
	C376.433167,860.145630 376.409271,859.916626 376.385376,859.687683 
	C376.504272,859.851929 376.623199,860.016113 376.599609,860.277466 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M379.995392,854.307434 
	C380.930756,854.327087 380.982422,854.941956 380.267578,855.847778 
	C380.013031,855.537598 380.002380,855.090454 379.995392,854.307434 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M378.734924,857.170837 
	C379.006256,857.453369 379.020355,857.897461 379.013367,858.674438 
	C378.992279,859.007446 379.001038,858.999023 379.005066,858.995972 
	C378.847778,859.107605 378.686523,859.222229 378.265442,859.193420 
	C378.162964,858.477417 378.320312,857.904907 378.734924,857.170837 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M378.005768,859.314209 
	C378.172607,859.037048 378.339600,859.024048 378.757812,859.001953 
	C378.827484,859.275635 378.645935,859.558289 378.244720,859.973755 
	C378.018646,859.930481 378.012299,859.754456 378.005768,859.314209 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M346.551392,874.465088 
	C346.585297,874.522095 346.517517,874.408142 346.551392,874.465088 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M341.005615,875.001099 
	C341.118866,875.275208 341.227173,875.548157 341.174805,875.915771 
	C341.014191,876.010376 341.002380,876.001892 341.000946,876.000732 
	C340.867981,875.832886 340.736450,875.666260 340.802490,875.250000 
	C341.000000,875.000305 341.000641,875.000000 341.005615,875.001099 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M386.934692,857.328979 
	C389.071289,855.620728 391.029785,855.081604 392.698853,857.956970 
	C392.256195,860.649658 389.500671,860.589050 387.427124,861.923706 
	C387.063202,861.212708 387.045258,860.478333 387.026459,859.375488 
	C386.947113,858.562988 386.904419,858.115540 386.934692,857.328979 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M393.322266,857.983887 
	C393.504578,857.650635 394.000092,857.318665 394.814514,856.990234 
	C394.634064,857.324158 394.134735,857.654602 393.322266,857.983887 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M532.514160,652.838806 
	C531.997681,651.342346 531.890564,649.882629 533.598633,648.890747 
	C534.072144,650.387878 534.927917,652.021973 532.514160,652.838806 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M534.251343,648.821350 
	C533.522461,647.997375 534.089966,647.182434 534.703857,646.138672 
	C534.851074,646.854919 534.702576,647.756775 534.251343,648.821350 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M535.254028,645.925476 
	C534.948486,645.569153 534.942688,645.127319 534.976135,644.354370 
	C535.015442,644.023376 535.478638,643.969482 535.813293,644.055542 
	C535.949890,644.707642 535.751831,645.273804 535.254028,645.925476 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M535.993896,643.987915 
	C536.109131,643.729675 536.274597,643.523621 536.440063,643.317627 
	C536.471741,643.543884 536.503418,643.770142 536.341553,644.068970 
	C536.147949,644.141541 536.044128,644.040161 535.993896,643.987915 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M505.623779,627.909790 
	C508.086060,627.357544 510.235138,626.722107 512.760498,626.041870 
	C513.834412,625.643250 514.268005,626.021606 514.850647,626.775513 
	C515.051331,627.008118 514.992432,627.006165 514.997681,626.977173 
	C515.334351,627.207947 515.482544,627.547668 515.283020,628.216309 
	C514.845642,629.429871 514.573120,630.394287 514.150879,631.710083 
	C513.836548,632.059570 513.595886,632.128540 513.518494,632.045471 
	C510.756348,629.079712 508.128204,628.158875 505.800995,632.499817 
	C505.544220,631.934326 505.287445,631.368835 505.013123,630.478088 
	C504.984497,629.940491 504.973389,629.728210 504.890015,629.205322 
	C504.755646,628.434326 504.919861,628.078247 505.623779,627.909790 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M522.394592,624.764465 
	C524.915771,625.508911 524.802307,623.499268 525.731201,622.020142 
	C528.720642,624.731628 523.179504,626.473877 524.886292,629.609741 
	C524.871521,629.924255 524.427490,630.044189 524.198730,630.068237 
	C523.641968,630.054932 523.352295,629.930420 522.966553,629.567505 
	C522.832214,629.416260 522.728943,629.063049 522.728943,629.063049 
	C522.728943,629.063049 522.497559,629.358521 522.568787,629.563477 
	C522.671265,630.092651 522.592102,630.387573 522.244019,630.843933 
	C519.711792,630.689697 519.416443,628.714172 518.904785,626.277466 
	C519.270325,625.059387 519.757263,624.685730 520.655029,624.365112 
	C521.385803,624.285461 521.792358,624.365356 522.394592,624.764465 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M518.378906,630.947998 
	C518.879761,632.289368 520.334412,633.200012 519.071594,634.800537 
	C517.942261,633.594849 517.121216,632.417786 517.349121,630.744568 
	C517.359314,630.670166 517.577332,630.575439 517.697510,630.576843 
	C517.849487,630.578674 518.000427,630.669434 518.378906,630.947998 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M515.077820,626.589966 
	C514.568909,626.763123 514.086548,626.518066 513.370483,626.135071 
	C513.746033,624.851501 513.735535,623.721252 513.034180,622.306885 
	C513.398499,621.625488 513.854736,621.488037 514.699097,621.800781 
	C515.044128,623.396057 515.074219,624.783936 515.077820,626.589966 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M518.918213,626.071716 
	C517.857788,625.631836 517.205505,624.842407 516.995728,623.409851 
	C516.842224,622.869324 516.704041,622.645813 516.777710,622.090210 
	C517.473877,621.512207 517.980713,621.450134 518.850464,621.766907 
	C519.916626,622.856873 520.029114,623.837830 519.448914,625.254272 
	C519.299438,625.614258 519.047424,625.921021 518.918213,626.071716 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M515.262451,622.017883 
	C514.569885,622.012329 514.125610,622.016479 513.348511,622.013306 
	C512.942688,621.707275 512.863464,621.410156 512.709717,620.904053 
	C512.759399,620.531128 512.877319,620.368896 513.225098,620.012634 
	C513.760803,619.538452 514.120483,619.366943 515.127319,619.375854 
	C515.896179,619.581604 516.063660,619.699524 516.378540,620.086670 
	C516.607605,620.763489 516.577332,621.162415 516.220032,621.770081 
	C516.006470,621.987610 515.510864,622.027527 515.262451,622.017883 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M514.142334,636.698853 
	C512.758911,636.190308 512.962952,635.163879 513.750977,633.820190 
	C515.206787,634.383789 515.061157,635.361877 514.142334,636.698853 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M515.373474,628.563538 
	C515.100342,628.129761 515.082520,627.794128 515.033813,627.203308 
	C515.675781,626.942932 516.305664,627.113708 516.465088,627.835449 
	C516.587891,628.391235 516.180847,628.659180 515.373474,628.563538 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M522.362793,631.005493 
	C522.037354,630.626648 521.989197,630.218567 521.903442,629.504639 
	C522.045654,629.016663 522.225464,628.834534 522.750732,628.820068 
	C523.408813,629.118591 523.645691,629.333069 523.888428,629.861816 
	C523.526611,630.386963 523.083313,630.681641 522.362793,631.005493 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M521.779358,634.232300 
	C522.099060,635.128113 522.020264,636.097473 521.932007,637.184631 
	C520.579834,636.276367 521.077881,635.277954 521.779358,634.232300 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M516.151001,622.186401 
	C516.025940,621.519775 516.045410,621.051941 516.099854,620.234619 
	C517.039978,619.890259 517.390808,620.428284 517.270325,621.568604 
	C517.065857,622.087280 517.037903,622.287109 516.995239,622.789917 
	C516.750488,622.858521 516.522156,622.622620 516.151001,622.186401 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M521.946411,633.932922 
	C522.119751,633.603455 522.420715,633.027954 522.326538,634.056396 
	C522.177734,634.158752 522.020813,634.010864 521.946411,633.932922 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M555.674438,634.706055 
	C553.933411,644.547241 553.787659,654.564331 550.007385,663.839172 
	C549.774231,664.411194 549.908264,665.181091 548.182007,665.580566 
	C549.733093,656.771790 553.206177,648.597534 552.992188,639.408264 
	C553.001892,638.959839 553.008240,639.013000 552.982300,639.019531 
	C553.664124,638.399658 553.490417,637.572327 553.319458,636.516541 
	C553.442322,634.740967 553.714355,633.228333 553.993164,631.322388 
	C555.418335,631.745056 554.691406,633.412170 555.674438,634.706055 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M553.136658,636.597656 
	C554.115784,636.976013 553.924377,637.809509 553.181641,638.850464 
	C553.005188,638.331299 553.054077,637.636536 553.136658,636.597656 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M526.723633,617.807007 
	C527.257874,617.576172 527.510925,617.649353 528.136108,617.859436 
	C528.435913,618.154053 528.363647,618.311768 528.229614,618.721985 
	C527.611755,619.637634 527.055725,620.300781 526.233215,621.159851 
	C526.125305,620.274170 526.283936,619.192566 526.723633,617.807007 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M574.550110,535.972290 
	C575.739624,535.771606 576.933533,535.614136 578.584900,535.396301 
	C577.387573,537.047852 576.390625,537.566956 574.723206,536.236572 
	C574.490906,535.951660 574.554565,536.015442 574.550110,535.972290 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M503.416290,600.320068 
	C503.878296,601.523560 503.453094,602.434265 502.216003,603.196716 
	C500.883911,603.185425 500.567352,602.545715 500.836731,601.329224 
	C501.096252,601.019165 501.028870,601.052551 501.047607,601.085815 
	C501.755676,600.839661 502.445038,600.560242 503.416290,600.320068 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M509.007935,602.634460 
	C508.405884,602.463318 507.822540,601.986755 507.119537,601.248535 
	C507.470245,600.259460 508.035187,600.012329 508.925079,600.873291 
	C509.061005,601.515259 509.043793,601.922180 509.007935,602.634460 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M515.942749,615.232544 
	C516.500793,614.947327 516.864136,614.948486 517.499939,614.942261 
	C518.650940,615.479370 519.513000,616.122192 520.809448,615.177002 
	C521.016968,614.946472 521.012329,614.997986 520.986450,614.995972 
	C524.179077,614.536377 522.949585,616.793945 522.951050,618.681274 
	C521.848511,619.144897 520.766174,619.214966 519.298828,619.423157 
	C517.299072,619.359192 516.707153,618.056396 515.897339,616.537720 
	C515.770996,615.980225 515.759521,615.749634 515.942749,615.232544 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M515.582581,616.627930 
	C517.512634,616.458862 517.708008,617.963379 518.661499,619.314087 
	C518.946289,619.893677 518.978699,620.226196 519.017395,621.284424 
	C518.595093,621.966858 518.166504,621.923523 517.415771,621.883789 
	C516.933228,621.331909 516.772644,620.776306 516.373535,620.052917 
	C516.134888,619.885071 516.091980,619.908203 516.081299,619.929932 
	C515.236816,619.226501 514.987427,618.308899 515.582581,616.627930 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M519.522766,625.581482 
	C519.220703,624.660645 519.141907,623.707031 519.043457,622.381836 
	C519.023743,622.010254 518.991943,622.001465 518.993286,622.018311 
	C519.470520,621.598938 520.005554,621.507324 520.799438,622.151367 
	C520.999268,622.542969 520.989868,622.489258 520.966309,622.503052 
	C521.413879,622.984253 521.588135,623.543945 521.239197,624.600708 
	C520.591003,625.186523 520.168579,625.367615 519.522766,625.581482 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M521.280640,625.004150 
	C520.969788,624.455444 520.926147,623.905579 520.912598,622.936279 
	C521.747803,622.905212 522.806946,623.039368 522.670410,624.650452 
	C522.254578,624.997070 521.901184,625.000061 521.280640,625.004150 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M520.936523,622.184814 
	C520.554749,622.426392 520.110168,622.309753 519.330139,622.114197 
	C518.994629,622.035217 518.997681,621.548950 519.020020,621.307068 
	C519.802307,620.959595 520.480774,621.049988 520.936523,622.184814 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M524.008423,609.260864 
	C524.320251,609.119629 524.669739,609.265808 525.021606,609.718872 
	C524.697998,609.866699 524.372009,609.707458 524.008423,609.260864 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M523.012756,618.991699 
	C523.236572,619.126587 523.432007,619.287964 523.627380,619.449341 
	C523.423157,619.455017 523.218872,619.460693 522.972778,619.270569 
	C522.930908,619.074768 522.984314,619.018250 523.012756,618.991699 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M515.902710,614.675781 
	C516.114563,615.123779 516.091614,615.301392 516.027100,615.744507 
	C515.985657,616.010010 516.022644,615.992432 516.020386,615.971924 
	C515.077393,616.983398 515.678528,618.275757 515.199097,619.705750 
	C514.628418,619.962708 514.290161,619.938782 513.703430,619.866760 
	C514.587585,615.536072 511.372223,613.314514 508.899109,610.363586 
	C508.661713,609.769409 508.630829,609.454834 508.867004,608.748474 
	C509.519226,608.449280 509.904358,608.541809 510.584656,608.592773 
	C511.310150,608.641968 511.695099,608.829163 512.274109,609.327026 
	C512.917114,610.080872 513.187561,610.664673 513.111572,611.626587 
	C512.466675,614.269592 514.641113,613.714417 515.902710,614.675781 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M512.761292,605.298706 
	C513.496521,605.010193 513.934937,605.027893 514.702637,605.053955 
	C514.979614,606.232361 514.927307,607.402466 514.878967,609.013306 
	C514.325867,609.636292 513.771606,609.627625 512.891968,609.156799 
	C511.977112,607.807556 511.991302,606.713135 512.761292,605.298706 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M512.773560,608.943115 
	C513.444763,608.970459 513.864685,609.082458 514.583740,609.324219 
	C514.754028,610.423889 515.391968,611.783081 513.298767,611.921509 
	C512.700317,611.424316 512.432373,610.929504 512.068604,610.169434 
	C512.063660,609.554199 512.247009,609.262146 512.773560,608.943115 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M520.608276,614.954468 
	C520.624756,617.925781 519.490295,617.183472 517.971680,615.224487 
	C518.581482,614.944031 519.390503,614.953247 520.608276,614.954468 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M517.636108,612.848877 
	C516.710876,613.048279 516.109314,612.822693 516.240723,611.961731 
	C516.278931,611.711365 516.582397,611.331909 516.797913,611.307495 
	C517.711609,611.203613 517.770813,611.922241 517.636108,612.848877 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M513.033813,608.468323 
	C512.826660,609.129333 512.628357,609.400146 512.201416,609.787598 
	C511.676544,609.643005 511.380371,609.381836 510.981995,608.835938 
	C510.945740,607.334351 511.011627,606.117554 511.170502,604.543579 
	C511.747589,604.327454 512.231689,604.468384 512.886841,604.800903 
	C513.052917,606.020996 513.047791,607.049622 513.033813,608.468323 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M654.371887,365.557220 
	C654.262634,368.314545 652.282227,368.473053 650.808228,368.738129 
	C647.239990,369.379700 643.623047,369.779724 640.011841,370.137482 
	C638.669617,370.270508 636.839905,371.659302 636.035339,369.756775 
	C635.382568,368.213074 635.220520,366.224121 637.408447,364.849091 
	C641.245483,362.615601 645.200073,364.181213 648.703308,363.330139 
	C645.508423,363.452484 642.200012,363.403717 638.530334,363.460938 
	C637.424683,363.473145 636.680054,363.505615 635.711182,362.870544 
	C634.426880,360.927765 634.242981,359.246643 635.737915,357.288635 
	C635.986938,356.992950 636.051208,357.127472 636.123108,357.107727 
	C641.066040,354.113190 646.392029,356.081604 651.958313,355.744873 
	C652.710083,355.904999 653.003296,355.999634 653.687988,356.338257 
	C654.956116,357.540680 655.119385,358.737640 655.162964,360.399231 
	C655.040344,362.292603 654.732788,363.711182 654.371887,365.557220 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M636.931519,377.177246 
	C636.542297,374.095032 637.905029,373.288635 640.328491,373.075470 
	C642.719666,372.865173 643.961853,373.675964 644.740051,375.947571 
	C646.698425,381.664429 645.250549,383.875397 639.909912,383.332672 
	C635.769653,382.911896 637.624573,379.674927 636.931519,377.177246 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M628.154785,391.781189 
	C628.421082,393.744415 628.927612,395.478577 629.297974,397.241333 
	C629.553284,398.456116 630.409424,400.046844 628.737732,400.722046 
	C627.280945,401.310394 625.594910,402.127716 623.994141,401.341522 
	C622.506165,400.610748 622.712463,398.777557 623.157104,397.804810 
	C624.202332,395.518036 621.230103,390.697296 627.397339,391.407745 
	C627.959351,391.556702 628.148193,391.560486 628.154785,391.781189 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M628.294922,392.023926 
	C627.972595,391.998077 627.731750,391.838989 627.751160,391.695984 
	C627.876160,387.383820 630.789062,387.540649 633.912598,387.995789 
	C632.568604,389.364532 631.636475,390.876709 632.936951,392.469147 
	C634.530762,394.420898 634.802795,391.119202 635.706360,391.413635 
	C637.457336,391.984161 639.057800,393.016571 641.455139,394.229126 
	C637.847778,395.747711 635.154358,394.714020 632.201782,394.566193 
	C631.153687,393.529755 630.232910,392.377289 628.294922,392.023926 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M637.717224,363.203033 
	C642.841187,361.020630 647.798828,362.396454 652.791626,362.730286 
	C648.388550,365.550659 643.470825,364.647583 638.275391,364.881897 
	C637.807922,364.790741 637.679260,364.364502 637.584778,364.162933 
	C637.494995,363.771667 637.499756,363.581970 637.717224,363.203033 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M664.046387,369.356354 
	C667.068359,369.484528 664.737793,371.377960 665.217102,372.903900 
	C665.306274,373.235046 665.303162,373.195618 665.288208,373.206360 
	C664.589233,373.357574 663.940063,373.621094 662.920898,373.811462 
	C661.051147,373.562958 659.499512,373.224365 658.617310,375.517273 
	C657.873718,376.333130 657.236877,376.565155 656.196960,376.201416 
	C656.171387,369.733154 656.171387,369.733154 664.046387,369.356354 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M655.853027,376.371307 
	C656.454224,375.951538 656.994324,375.925507 657.747681,375.730988 
	C658.651672,374.147888 659.627625,373.074493 661.629822,372.897339 
	C662.816162,373.002747 663.641357,373.007202 664.869873,373.114380 
	C662.056885,375.757263 658.840515,378.297455 655.307983,380.958435 
	C653.754272,379.362244 656.262329,378.339813 655.853027,376.371307 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M614.000671,384.113037 
	C612.783691,383.810944 611.182983,383.446045 612.798218,382.531738 
	C614.045227,381.825836 615.906189,382.204590 617.578796,382.095581 
	C617.042236,383.958649 615.773743,384.139282 614.000671,384.113037 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M654.490479,365.808197 
	C654.167419,364.571289 654.058777,363.164368 654.066589,361.346985 
	C654.355713,360.801666 654.528442,360.666809 655.026611,360.485046 
	C655.562866,360.498840 655.773682,360.559509 656.202087,360.866943 
	C656.391418,361.490906 656.363159,361.868134 656.308838,362.527954 
	C656.304382,363.029663 656.325867,363.248779 656.308228,363.795837 
	C656.269104,364.123810 656.122681,364.177460 656.080627,364.112213 
	C655.594055,364.577362 655.149475,365.107758 654.490479,365.808197 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M616.085876,392.406067 
	C618.394470,394.808014 615.911194,393.922821 615.365479,393.914948 
	C614.521606,393.902740 612.998962,394.098572 613.281311,392.730438 
	C613.490723,391.715729 614.848633,391.949127 616.085876,392.406067 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M637.625732,362.981445 
	C637.894409,363.188629 637.858887,363.363434 637.656860,363.749817 
	C636.584290,363.975739 635.678345,363.990112 634.426147,363.998535 
	C634.047363,363.549408 634.014648,363.106171 634.053162,362.334808 
	C634.463684,361.658142 634.874634,361.515045 635.627686,361.794800 
	C636.372681,362.324738 636.847107,362.636871 637.625732,362.981445 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M608.365234,467.535645 
	C605.932495,464.258118 607.098572,462.683868 610.338928,462.474365 
	C614.886597,462.180389 619.451721,462.155518 624.470093,462.078156 
	C624.898499,463.158081 624.866028,464.175354 624.847595,465.575562 
	C624.322815,467.619110 622.978699,468.220947 621.439453,468.256622 
	C617.203857,468.354950 612.943665,468.934113 608.365234,467.535645 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M624.726685,470.740967 
	C624.338501,473.181549 622.723206,473.022125 621.026489,472.996643 
	C616.467041,472.928192 611.891724,472.674500 607.125122,473.306946 
	C606.965088,472.168457 607.053162,471.319916 607.193481,470.155701 
	C607.242310,468.134338 608.669800,468.151154 609.666016,468.142670 
	C614.356506,468.102631 619.071045,467.484558 624.055481,468.896851 
	C624.457397,469.660828 624.535828,470.059052 624.726685,470.740967 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M624.702026,469.097168 
	C618.951111,469.053406 613.520752,468.706329 607.678650,469.695618 
	C607.389587,469.180359 607.533447,468.520691 607.830078,467.554871 
	C613.330200,466.305786 618.826111,468.013489 624.497070,466.150879 
	C626.102844,466.884277 626.111694,467.877899 624.702026,469.097168 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M635.591736,468.812500 
	C635.492493,470.315155 638.185974,472.289734 635.457642,472.852631 
	C633.667786,473.221893 630.998474,473.559723 631.147095,469.809631 
	C632.167603,467.479919 633.776550,468.446259 635.591736,468.812500 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M633.061768,458.968506 
	C632.508911,458.367798 632.602112,457.747955 632.866882,457.213074 
	C633.369324,456.198242 632.242981,454.343048 634.372131,454.178009 
	C635.312317,454.105164 635.982849,454.647675 636.071594,455.548462 
	C636.240173,457.258118 636.144836,458.907715 633.061768,458.968506 
z"/>
<path fill="#C4C9C0" opacity="1.000000" stroke="none" 
	d="
M632.383057,459.372742 
	C632.338196,458.949280 632.668640,458.910431 632.830322,458.950317 
	C633.096497,460.821228 637.093567,459.234894 635.843018,462.209747 
	C635.305603,463.488098 634.156311,462.900726 633.270996,462.784973 
	C630.779297,462.459229 632.649597,460.816071 632.383057,459.372742 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M632.231201,467.247650 
	C631.918884,464.743286 632.877502,463.430420 635.197449,464.624695 
	C636.845276,465.472992 636.054565,466.390137 634.375549,467.049255 
	C633.583618,467.484314 633.091492,467.578033 632.231201,467.247650 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M631.645142,467.253693 
	C632.377014,467.065765 632.850464,467.094727 633.679443,467.150391 
	C634.603699,467.635803 635.172302,468.094421 635.860596,468.802673 
	C634.632629,469.069855 633.284973,469.087402 631.565918,469.273926 
	C631.258545,468.785431 631.322571,468.128021 631.645142,467.253693 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M637.938843,442.009949 
	C638.316223,443.307495 637.645386,444.137238 636.562622,444.721100 
	C636.467651,444.772308 635.975403,444.421631 635.967163,444.243744 
	C635.919128,443.206970 636.216858,442.317749 637.668335,441.999695 
	C638.022705,442.078217 637.953674,442.045227 637.938843,442.009949 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M632.273438,422.294189 
	C631.846924,422.396210 631.670959,422.238525 631.269165,421.807770 
	C631.374084,421.406494 631.704712,421.278259 632.294739,421.231750 
	C632.544067,421.553802 632.534058,421.794159 632.273438,422.294189 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M621.743164,421.334778 
	C620.869812,421.549042 619.774658,421.581512 618.268799,421.540771 
	C618.869873,418.926056 620.275513,420.970428 621.743164,421.334778 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M635.960693,361.707153 
	C635.504028,362.007233 635.109802,362.001862 634.419983,362.001587 
	C634.029114,360.613525 633.933899,359.220398 633.911133,357.413940 
	C634.428772,357.002869 634.873962,357.005157 635.653076,357.000183 
	C635.999023,358.462524 636.011047,359.932098 635.960693,361.707153 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M613.570190,355.497314 
	C615.000610,355.268311 616.827576,355.162781 619.068970,355.106812 
	C619.483459,355.156372 619.227478,355.538086 619.090332,355.722412 
	C617.291016,355.811401 615.628845,355.716095 613.570190,355.497314 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M610.259155,355.835449 
	C610.133911,355.483887 610.366394,355.337982 610.825928,355.496460 
	C610.944336,355.596863 610.508118,355.837219 610.259155,355.835449 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M98.012993,828.742615 
	C97.908806,828.585999 97.960052,828.428101 98.011299,828.270203 
	C98.063675,828.427246 98.116051,828.584290 98.012993,828.742615 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M308.564453,407.983490 
	C307.406494,411.695312 304.167603,409.394318 301.322266,410.113678 
	C300.463074,409.859375 299.539398,410.249573 299.780701,409.100952 
	C300.435913,408.560425 300.835358,408.144501 300.160034,407.292542 
	C299.821320,406.942596 299.732483,406.768646 299.605682,406.303955 
	C302.662750,405.626617 305.543335,406.198517 308.564453,407.983490 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M292.186340,385.195251 
	C291.670380,384.686188 291.462250,384.125061 291.142883,383.289062 
	C291.366699,382.184143 291.701782,381.354126 292.087799,380.190430 
	C292.320831,379.799042 292.502960,379.741333 292.866608,379.905426 
	C293.645844,381.614716 294.150421,383.163513 296.631836,383.886017 
	C294.614746,384.498901 293.554474,384.821045 292.186340,385.195251 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M306.629272,418.107239 
	C307.037384,418.709656 307.110840,419.337524 307.212860,420.280396 
	C307.352722,420.845917 307.464050,421.096344 307.280121,421.632874 
	C306.817627,421.989136 306.650391,422.059265 306.218536,422.193481 
	C305.527100,422.022461 305.100220,421.787384 304.351288,421.379089 
	C303.840485,421.137634 303.651703,421.069336 303.227783,420.811981 
	C302.890472,420.449371 302.788361,420.275848 302.895477,419.596436 
	C304.168030,418.771271 305.231293,418.451965 306.629272,418.107239 
z"/>
<path fill="#C1ADDF" opacity="1.000000" stroke="none" 
	d="
M293.288452,379.956482 
	C293.048126,380.127197 292.589233,380.005371 292.363953,379.931091 
	C292.147827,378.530182 292.156982,377.203552 292.189117,375.475220 
	C292.756256,374.926788 293.210449,375.068634 293.665497,375.872131 
	C294.666992,377.489227 294.873138,378.687256 293.288452,379.956482 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M291.738403,396.808746 
	C291.296448,395.779236 291.167236,394.823303 291.096588,393.508881 
	C292.607239,393.126892 293.654755,393.673279 293.803284,395.240417 
	C293.918793,396.459473 293.190674,396.926483 291.738403,396.808746 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M293.818542,375.865021 
	C293.373993,375.946594 292.991882,375.647278 292.410950,375.210693 
	C288.878601,373.561432 293.418365,372.964111 292.166565,371.488068 
	C294.501434,372.485138 293.746643,374.137024 293.818542,375.865021 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M305.466309,412.572968 
	C304.053772,412.897522 302.444580,412.971924 300.429260,413.001953 
	C300.195160,412.398773 300.367188,411.839996 300.708008,411.033936 
	C302.556885,410.681427 303.935577,411.438293 305.466309,412.572968 
z"/>
<path fill="#3C3167" opacity="1.000000" stroke="none" 
	d="
M288.419128,399.927063 
	C289.532776,399.382874 290.367889,398.720001 291.275299,399.573975 
	C291.430817,399.720337 291.469238,400.287445 291.342896,400.389648 
	C290.388641,401.161560 289.277588,400.965515 288.186707,400.759491 
	C288.084564,400.740204 287.931122,400.577301 287.937622,400.491394 
	C287.948639,400.345978 288.068420,400.208832 288.419128,399.927063 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M291.499084,387.932129 
	C291.140930,387.582794 291.278870,387.327240 291.702942,386.993103 
	C293.396545,386.855347 294.913757,386.855347 296.737183,386.855347 
	C295.157776,388.627289 293.390167,387.642822 291.499084,387.932129 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M302.183075,419.534973 
	C302.883759,419.950592 303.336304,420.315399 303.909058,420.943054 
	C302.646851,422.147369 301.281555,422.921722 300.193848,420.434631 
	C300.327606,419.729858 300.575714,419.526337 301.175598,419.451233 
	C301.597595,419.467651 301.766266,419.475891 302.183075,419.534973 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M301.121490,415.318359 
	C302.313507,415.713470 303.858459,413.618988 304.979675,415.749908 
	C303.676331,416.267487 302.238220,417.561432 301.121490,415.318359 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M299.925598,407.421387 
	C301.183411,407.252350 302.539856,406.632782 303.761688,407.553101 
	C303.502045,409.591583 301.892151,408.840302 300.340546,408.979492 
	C299.942963,408.540192 299.942017,408.133179 299.925598,407.421387 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M305.768860,424.028687 
	C306.751495,423.936371 307.847290,423.770569 308.231201,424.216980 
	C308.743439,424.812592 307.723389,425.091064 307.071716,425.666565 
	C305.867859,425.787689 304.921234,425.629272 305.768860,424.028687 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M301.876953,425.988953 
	C300.948486,425.976013 300.160034,426.004822 300.338257,425.108978 
	C300.530151,424.144684 301.401611,423.936676 302.138000,424.204529 
	C303.185638,424.585602 302.971619,425.279449 301.876953,425.988953 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M301.756836,418.983398 
	C301.729614,419.490356 301.303955,419.699280 300.527924,419.980682 
	C299.474792,419.701263 298.302704,419.234314 298.766907,418.487274 
	C299.389496,417.485382 300.499084,418.244568 301.756836,418.983398 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M291.317688,391.925903 
	C290.293457,391.519287 290.610657,391.025482 291.047638,390.347290 
	C291.821381,390.148468 292.574158,390.136414 292.558655,391.014099 
	C292.553314,391.316925 291.944916,391.609131 291.317688,391.925903 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M298.941772,340.952271 
	C299.171295,340.806549 299.234619,341.269653 299.275452,341.499054 
	C299.002533,341.871582 298.688812,342.014679 298.375061,342.157776 
	C298.487457,341.804504 298.599823,341.451233 298.941772,340.952271 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M298.033875,372.218079 
	C298.220001,372.205994 298.257507,372.365601 298.285217,372.439209 
	C298.064728,372.571930 297.594788,372.995911 298.033875,372.218079 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M301.995178,418.985199 
	C302.258820,418.862427 302.585144,418.801361 303.008118,418.915405 
	C303.104736,419.090576 303.058350,419.077820 303.059937,419.054871 
	C302.928070,419.134918 302.794617,419.237946 302.423737,419.253998 
	C302.186279,419.167053 302.057861,419.046875 301.995178,418.985199 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M322.533752,350.999084 
	C321.292358,350.545197 320.868011,349.295715 321.862610,349.525879 
	C323.916687,350.001282 326.034760,349.828491 328.652496,350.177185 
	C326.435547,351.553772 324.621948,350.791351 322.533752,350.999084 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M326.579102,344.973755 
	C324.179565,343.572662 321.416016,344.208588 318.999298,343.429169 
	C321.634796,343.710968 324.686829,341.481903 326.579102,344.973755 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M313.984375,329.814941 
	C312.736694,329.956909 311.421417,330.255920 310.149170,329.032349 
	C311.047363,328.817139 312.099182,328.957855 313.540894,329.173889 
	C313.930817,329.249268 313.976135,329.619690 313.984375,329.814941 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M308.953003,327.737976 
	C308.239197,327.822449 307.240448,327.648682 305.942444,327.220459 
	C306.651489,327.137207 307.659760,327.308441 308.953003,327.737976 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M308.214966,325.202820 
	C308.903198,325.006317 309.601105,325.258148 310.299011,325.509979 
	C309.654877,326.252472 308.937347,325.916565 308.214966,325.202820 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M307.887695,325.122864 
	C307.383667,325.006195 306.985931,324.767090 306.588165,324.527954 
	C307.006775,324.487274 307.425415,324.446594 308.024658,324.580200 
	C308.205292,324.754486 307.993988,325.000427 307.887695,325.122864 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M327.550842,332.970215 
	C327.918945,332.933105 327.974762,333.411285 328.004486,333.649384 
	C326.430664,334.919647 324.738342,335.295654 322.812012,334.617432 
	C323.893311,332.878326 325.621307,333.169403 327.550842,332.970215 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M326.516205,338.934174 
	C325.205719,338.940369 324.235138,338.940369 323.264557,338.940369 
	C323.243073,338.658234 323.221558,338.376129 323.200043,338.093994 
	C324.623718,338.093994 326.047455,338.086578 327.470886,338.106079 
	C327.605560,338.107910 327.737976,338.278595 327.871429,338.370880 
	C327.532990,338.556580 327.194550,338.742279 326.516205,338.934174 
z"/>
<path fill="#DAE5F3" opacity="1.000000" stroke="none" 
	d="
M567.602539,945.307739 
	C567.006775,945.145691 566.697998,944.896057 566.233154,944.395630 
	C566.826599,944.020203 567.576111,943.895630 568.686279,943.897949 
	C568.661072,944.423340 568.275269,944.821777 567.602539,945.307739 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M594.740479,693.151367 
	C595.061829,693.776184 595.071228,694.509521 595.008667,695.607422 
	C594.936707,695.971924 594.990051,695.988770 594.988586,695.961487 
	C594.987122,695.934204 594.724426,696.270813 594.510986,696.274292 
	C594.151611,696.145874 594.005737,696.013916 593.648560,695.669678 
	C593.767761,694.724854 594.098206,693.992432 594.740479,693.151367 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M594.994629,692.992920 
	C595.133057,692.594299 595.289917,692.213135 595.446777,691.832031 
	C595.460632,692.197205 595.474548,692.562317 595.270386,692.985107 
	C595.052368,693.042786 595.013123,693.010376 594.994629,692.992920 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M603.445618,697.441284 
	C603.494568,697.410217 603.396667,697.472412 603.445618,697.441284 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M606.152344,697.959412 
	C606.135803,698.101562 606.009888,697.220886 606.152344,697.959412 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M511.026978,636.960449 
	C510.779449,636.235962 510.518921,635.527161 510.258392,634.818359 
	C510.520203,634.755066 510.873260,634.551392 511.028320,634.652161 
	C511.768616,635.133850 512.067810,635.791565 511.287781,636.777893 
	C511.049469,636.928345 511.013916,636.976135 511.026978,636.960449 
z"/>
<path fill="#8B8A92" opacity="1.000000" stroke="none" 
	d="
M501.988220,637.059814 
	C501.419556,636.798645 499.924835,637.262024 500.122192,635.412964 
	C501.236359,635.136353 501.860016,635.640503 501.988220,637.059814 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M505.957275,627.646484 
	C505.645142,628.147766 505.353333,628.302551 504.939606,628.676025 
	C504.363647,628.919128 503.909546,628.943542 503.110992,628.960938 
	C504.359711,629.417786 503.240265,624.614868 505.957275,627.646484 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M504.769043,607.806641 
	C505.380280,608.139038 505.802460,608.263245 506.532837,608.512085 
	C507.190430,609.851257 507.539825,611.065735 508.009766,612.699219 
	C506.048431,612.444458 504.257568,612.342834 502.581177,613.037598 
	C501.545135,610.719604 504.891663,610.602966 504.209473,608.364258 
	C504.309662,607.858276 504.444855,607.728394 504.769043,607.806641 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M508.892883,618.810669 
	C508.473267,619.427551 508.016876,619.703552 507.281219,619.998352 
	C506.197540,618.931335 505.215454,617.514465 506.671478,616.632141 
	C507.947510,615.858826 508.578644,617.278625 508.892883,618.810669 
z"/>
<path fill="#C0BFBA" opacity="1.000000" stroke="none" 
	d="
M504.910461,607.676453 
	C504.958099,608.014893 504.563904,608.030640 504.369202,608.009399 
	C504.174469,607.988220 503.702820,607.998108 503.467255,607.986084 
	C503.155396,606.861389 503.079102,605.748840 502.992554,604.486938 
	C504.483582,605.102417 504.458588,606.348999 504.910461,607.676453 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M509.074280,608.085327 
	C509.050385,608.641968 508.966644,608.927124 508.787781,609.648193 
	C508.275208,609.480103 507.857788,608.876160 507.204651,608.121399 
	C507.065155,607.513000 507.055267,606.726318 507.276123,606.655029 
	C508.215454,606.352051 508.621460,607.130310 509.074280,608.085327 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M501.107788,614.641174 
	C501.909332,615.094177 502.150543,615.619446 501.618805,616.266846 
	C501.411224,616.051270 501.203674,615.835693 500.920532,615.393799 
	C500.849060,614.999878 500.853149,614.832153 501.107788,614.641174 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M499.290283,614.996399 
	C498.976746,615.019531 499.116486,614.601990 499.146912,614.384277 
	C499.767212,614.163818 500.357086,614.160950 501.152618,614.388000 
	C501.358276,614.617859 501.102203,614.892639 500.973572,615.030090 
	C500.431244,615.102783 500.017548,615.038025 499.290283,614.996399 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M500.835083,601.172791 
	C501.202454,601.629944 501.308655,602.240662 501.656311,603.053345 
	C501.417633,603.736633 500.821838,603.931152 500.366577,603.371033 
	C499.821503,602.700378 500.030029,601.961914 500.835083,601.172791 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M511.214020,623.004761 
	C509.827362,624.601562 509.882751,623.020874 509.558563,622.402039 
	C509.452850,622.200195 509.840576,621.739807 510.002625,621.397705 
	C510.398132,621.819092 510.793640,622.240540 511.214020,623.004761 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M507.331177,624.223999 
	C507.887146,624.221802 508.240295,624.446045 508.593506,624.670227 
	C508.316284,624.947144 508.039093,625.223999 507.761841,625.500854 
	C507.550690,625.150696 507.339539,624.800598 507.331177,624.223999 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M621.049438,253.455261 
	C631.911438,255.315125 640.255981,261.778717 649.322083,266.789673 
	C650.901367,267.662537 652.599365,268.320801 654.600281,268.990479 
	C654.731140,269.410034 654.504211,269.917328 654.150391,270.679108 
	C648.590942,269.687836 644.018677,266.619720 639.540527,263.593689 
	C633.713074,259.655975 627.594604,256.612457 620.348083,255.020844 
	C620.189514,254.560822 620.397888,254.214676 621.049438,253.455261 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M462.278748,727.169434 
	C461.975464,726.969727 461.893707,726.481750 461.945679,726.239868 
	C462.454651,725.875366 462.911652,725.752808 463.682922,725.797241 
	C463.878357,726.787964 463.328979,727.178101 462.278748,727.169434 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M475.346985,731.954773 
	C475.636932,730.904724 475.934326,729.513428 477.689911,729.048828 
	C477.948151,730.518616 477.210571,731.512634 475.346985,731.954773 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M475.094910,732.088989 
	C475.001770,733.223694 474.530243,734.114380 473.360718,734.912109 
	C473.094025,735.074097 472.973328,734.972046 472.912476,734.917847 
	C472.970154,733.770508 473.455505,732.887573 474.618958,732.074524 
	C474.884064,731.907837 475.025482,732.027649 475.094910,732.088989 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M477.975647,728.966919 
	C478.082489,728.986145 478.132324,728.090271 478.195862,728.976074 
	C478.059662,729.047791 478.001465,728.996094 477.975647,728.966919 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M511.289673,726.954163 
	C511.575470,726.213684 511.969177,724.616455 513.263306,725.698059 
	C513.575745,725.959106 512.463562,726.804626 511.289673,726.954163 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M507.973358,728.965088 
	C508.691254,728.253357 509.479675,727.623779 510.568085,726.927429 
	C510.868073,726.860657 510.998627,727.002686 511.064148,727.076782 
	C510.606812,728.107788 509.873352,728.811768 508.487885,729.154419 
	C508.184448,729.211975 508.043884,729.047302 507.973358,728.965088 
z"/>
<path fill="#7E8FAD" opacity="1.000000" stroke="none" 
	d="
M461.784241,725.667297 
	C461.567352,725.806335 461.337708,725.648865 461.087921,725.196289 
	C461.286377,725.079102 461.520905,725.235657 461.784241,725.667297 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M636.403198,334.104919 
	C634.933289,329.402863 635.457581,324.815887 635.848389,320.032013 
	C636.616760,319.419098 637.080688,319.133392 638.012573,318.860657 
	C642.222351,318.541992 646.031250,318.520599 650.244324,318.859039 
	C652.412170,319.451019 653.178467,321.010712 654.402710,322.668884 
	C654.898254,323.862000 654.909790,324.689819 654.419067,325.881897 
	C653.762329,326.594025 653.264221,326.814880 652.304260,326.933228 
	C647.627441,326.956940 643.348694,327.198914 639.081360,326.722626 
	C638.415283,326.722198 639.178772,327.479919 638.998535,326.838074 
	C642.781433,327.041962 646.567871,327.006317 650.740479,327.004150 
	C651.639343,327.005615 652.151489,327.011047 653.042603,327.039124 
	C653.670654,327.093964 653.919678,327.130585 654.507935,327.330383 
	C655.219482,327.835968 655.484131,328.245422 655.650269,329.100891 
	C655.623535,330.195740 655.434265,330.899994 655.204895,331.970184 
	C655.063782,332.568451 654.995667,332.806946 654.772583,333.390259 
	C654.460571,333.936951 654.303467,334.138763 653.821960,334.552734 
	C653.015747,334.977203 652.515564,335.129089 651.601013,335.270844 
	C646.346680,335.601776 641.619873,334.050446 636.403198,334.104919 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M654.053223,322.842041 
	C651.950500,322.927887 652.214905,321.088867 651.039673,320.065186 
	C646.388367,319.054932 641.979248,319.630280 637.247192,319.790283 
	C636.907654,320.027191 636.616394,320.057373 636.616394,320.057373 
	C636.616394,320.057373 636.330811,319.979004 636.275574,319.896606 
	C634.735168,317.328064 635.542969,314.580261 635.220337,311.472961 
	C635.184326,309.182251 635.251038,307.368317 635.403809,305.179199 
	C635.725464,304.716980 635.961060,304.629944 636.560303,304.439941 
	C639.973206,304.891876 642.318115,306.857941 645.173340,308.594147 
	C645.691101,309.284943 645.895081,309.730072 646.104736,310.554657 
	C646.196289,313.074219 646.149658,315.205078 643.371704,315.879150 
	C645.785767,316.143066 647.293579,315.131989 648.106445,312.515137 
	C648.475952,311.750854 648.773621,311.365509 649.430542,310.797913 
	C650.215027,310.368774 650.712708,310.262268 651.619995,310.302551 
	C652.777100,310.572266 653.454590,310.962677 654.334595,311.763275 
	C655.534363,313.699036 656.037292,315.449005 655.882324,317.745483 
	C655.307129,319.625336 655.460815,321.327240 654.053223,322.842041 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M654.257935,337.192810 
	C654.033508,338.375092 654.066345,339.173431 654.049438,340.268280 
	C648.465515,343.932007 642.650513,342.514069 636.482788,341.248352 
	C635.279480,339.282227 635.599731,337.552979 635.855225,335.427643 
	C639.130737,333.159027 642.310303,334.748688 645.472290,334.927246 
	C647.258911,335.028137 649.045288,334.974701 651.282227,335.025146 
	C652.343445,335.058746 652.937683,335.168365 653.882629,335.643799 
	C654.337830,336.218658 654.426575,336.513763 654.257935,337.192810 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M636.505615,348.225220 
	C636.086792,346.575714 636.000244,345.226379 635.978088,343.474152 
	C641.430359,340.817871 647.048462,342.470917 653.008301,342.199005 
	C653.736938,342.468506 654.004395,342.637146 654.528870,343.206238 
	C655.275024,344.845032 655.246765,346.085815 654.567871,347.736603 
	C653.360779,349.036926 652.166992,349.303589 650.448792,349.383881 
	C647.044434,349.424713 644.091309,349.395203 640.693726,349.400330 
	C639.049500,349.350922 637.860107,349.265533 636.505615,348.225220 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M636.638306,355.110901 
	C636.306580,353.492218 636.190735,352.171173 636.162781,350.458038 
	C637.345215,348.836365 638.827881,349.066956 640.657593,349.005463 
	C643.609924,349.005585 646.138123,348.994507 649.087280,349.026093 
	C650.935547,349.118286 652.289062,349.463837 653.875244,350.430725 
	C654.745056,351.420166 654.885620,352.235260 654.632019,353.508850 
	C654.032715,354.627594 653.372986,355.119629 652.254272,355.659790 
	C648.776062,356.417572 645.727478,355.537781 642.275879,355.462097 
	C641.165833,355.444122 640.430908,355.453583 639.349854,355.710693 
	C638.240295,355.874084 637.521606,355.785767 636.638306,355.110901 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M636.378662,355.194702 
	C637.044800,354.808167 637.667175,354.803101 638.602173,354.800690 
	C639.435669,354.560364 640.004578,354.520569 640.820984,354.311768 
	C644.436401,354.440979 647.788635,354.672852 651.567627,354.928894 
	C652.687012,355.173828 653.074097,355.665405 653.092041,356.653137 
	C647.661133,356.937225 642.375977,356.923309 636.642944,356.998657 
	C636.241577,356.584015 636.288147,356.080078 636.378662,355.194702 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M654.038086,342.834839 
	C648.148438,343.086243 642.558716,343.028900 636.505737,343.021393 
	C636.051880,342.596344 636.061218,342.121460 636.086365,341.286377 
	C641.781189,340.941345 647.460205,340.956512 653.569458,340.768250 
	C653.999634,340.564819 654.135620,340.741333 654.070496,340.831726 
	C654.389587,341.400116 654.500488,341.934784 654.038086,342.834839 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M652.185425,335.674469 
	C646.890381,336.062866 641.851196,335.791229 636.412842,335.049164 
	C635.967346,334.833069 635.946838,334.649292 635.983765,334.193970 
	C641.036682,332.276489 646.020264,334.065399 651.440308,334.023926 
	C652.320557,334.395416 652.503845,334.829590 652.185425,335.674469 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M641.132385,349.693115 
	C639.684021,350.006104 638.363037,350.022888 636.646362,350.052826 
	C636.186829,349.590454 636.122925,349.114990 636.116211,348.282257 
	C637.187378,347.935181 638.201416,347.945343 639.594849,347.982300 
	C640.471436,348.408051 641.038086,348.742737 641.132385,349.693115 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M613.549805,316.591583 
	C613.438904,318.315613 612.400146,318.078522 611.083740,317.151184 
	C611.670654,316.733124 612.422546,316.622162 613.549805,316.591583 
z"/>
<path fill="#100622" opacity="1.000000" stroke="none" 
	d="
M672.625244,221.521576 
	C676.048645,222.152939 679.108582,222.597549 682.586914,222.977951 
	C686.968933,221.007294 689.753601,223.314407 692.092896,225.873764 
	C696.323303,230.502090 700.080139,235.551239 704.359497,240.151260 
	C706.454285,242.403091 706.387817,245.281433 706.402527,248.527893 
	C705.522461,254.436127 705.546631,259.976715 705.463440,265.964172 
	C705.249451,275.106049 705.865417,283.790833 705.552185,292.934479 
	C705.325012,295.478302 705.623108,297.566681 705.490723,300.094788 
	C705.411438,301.693390 705.394592,302.854004 705.408569,304.446899 
	C705.417786,305.454803 705.420166,306.030853 705.434387,307.039490 
	C705.512268,310.650787 705.814819,313.841248 704.788940,317.360107 
	C703.012085,319.501038 701.149719,319.142181 698.909546,318.262573 
	C696.808167,317.260193 696.932739,314.067657 693.801514,314.573761 
	C693.246643,314.623566 693.022888,314.631866 692.463501,314.609558 
	C691.688110,314.484070 691.254944,314.365601 690.506592,314.123566 
	C689.971313,313.954712 689.757690,313.885681 689.223877,313.713623 
	C687.528564,312.983917 685.130676,313.440308 685.107483,311.387451 
	C685.090271,309.857330 687.044067,310.143921 687.987244,310.017273 
	C685.680359,309.575958 683.552429,310.569153 681.340393,312.445068 
	C680.543823,312.766602 680.050720,312.823303 679.166748,312.768829 
	C673.873657,310.463562 668.415955,312.298157 663.106201,310.415466 
	C662.521606,309.679749 662.431824,309.161285 662.704956,308.252258 
	C662.949524,303.585144 663.008545,299.277710 663.106201,294.510956 
	C667.459900,293.267578 666.042053,297.331940 667.273743,298.674438 
	C667.563538,299.704926 668.430908,298.726044 667.880432,299.102112 
	C667.804810,299.153778 667.732971,299.038849 667.625916,298.772980 
	C666.235413,295.320099 666.085144,291.669586 665.815308,287.678101 
	C665.459595,286.654877 665.425354,285.952484 665.515991,284.888611 
	C665.749634,283.640320 666.006104,282.742279 665.507751,281.496643 
	C665.571838,277.639740 665.471741,274.129517 665.555847,269.423553 
	C665.402100,274.154510 665.668091,277.680695 665.341309,281.559265 
	C665.561340,282.331665 665.659790,282.780151 665.628174,283.583374 
	C665.681580,285.053040 664.823914,286.159515 665.625732,287.639282 
	C665.960632,289.612335 665.978638,291.145203 663.458984,291.170715 
	C663.033630,283.951935 662.932800,276.952209 662.750977,269.492310 
	C662.387634,268.577911 662.145203,268.103241 661.847046,267.219116 
	C661.722473,266.565125 661.692932,266.300476 661.643066,265.638184 
	C660.668030,256.880890 663.103027,248.543732 661.819336,239.787689 
	C661.902588,239.136887 661.955566,238.880051 662.134949,238.252502 
	C663.258362,236.355957 663.783264,234.651474 664.262939,232.506912 
	C665.256592,229.860123 665.909058,227.524017 666.413086,225.150360 
	C667.101196,221.909470 668.774536,220.250397 672.625244,221.521576 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M663.570740,238.096451 
	C663.468445,238.922073 663.135132,239.433884 663.213379,239.872284 
	C664.716125,248.294846 662.026794,256.652435 662.755798,265.516083 
	C662.661438,265.973541 662.242188,266.171387 662.242188,266.171387 
	C662.242188,266.171387 662.317810,266.628845 662.477722,266.798553 
	C662.710449,267.429138 662.783203,267.890045 662.763000,268.691559 
	C658.126587,269.354553 658.083801,265.886322 658.111145,263.032990 
	C658.140320,259.995911 657.424255,257.227081 656.453247,254.471725 
	C656.113892,253.508743 655.649536,252.125870 653.873779,253.233154 
	C649.559570,247.540421 645.392212,241.593735 641.112793,235.325165 
	C644.250671,233.666855 646.865784,233.713135 648.495300,237.580841 
	C649.813904,240.710556 652.092163,240.488297 654.414612,238.476791 
	C656.409912,236.748642 658.394897,234.970215 660.279236,238.592926 
	C661.277893,237.982620 662.136108,236.831589 663.570740,238.096451 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M645.324219,280.035431 
	C645.020996,279.225800 645.029480,278.618439 645.045776,277.707428 
	C647.929382,276.520477 649.922241,280.223389 653.683228,278.640656 
	C646.152344,274.860260 639.129272,271.334747 631.700012,267.605347 
	C633.898438,266.417206 635.407532,267.039093 637.034424,267.749908 
	C640.657837,269.333160 644.362000,270.730438 648.011353,272.255951 
	C657.179504,276.088501 657.174622,276.100159 655.508179,286.588928 
	C655.216858,284.434082 655.063843,282.767609 651.854980,282.676941 
	C649.760681,282.617676 647.707458,281.101349 645.324219,280.035431 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M665.735474,286.789612 
	C667.778564,291.000702 667.910400,295.243561 667.887268,299.532990 
	C664.850891,298.914032 665.733337,295.511414 663.512634,294.073486 
	C663.085022,293.273651 663.025269,292.495697 663.049988,291.334717 
	C665.531006,290.882172 664.505676,288.892395 664.988892,287.359039 
	C665.190002,286.852997 665.347595,286.712616 665.735474,286.789612 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M662.478271,307.955536 
	C662.943787,308.316284 662.997009,308.740021 663.090820,309.481445 
	C661.182434,312.078064 658.721924,311.226227 655.970825,310.793396 
	C655.354309,310.578461 655.115540,310.477386 654.529785,310.208984 
	C653.303711,309.532166 652.502869,308.933990 651.846375,307.710480 
	C651.858032,307.140503 651.966064,306.923340 652.379028,306.510315 
	C653.377869,306.061310 654.087219,306.026062 655.403564,306.532867 
	C657.711975,308.952881 660.050232,307.609436 662.478271,307.955536 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M655.970947,305.016541 
	C656.987244,305.376831 656.554993,305.900574 656.058716,306.663391 
	C655.998230,306.902069 655.996582,306.978149 656.034607,306.980164 
	C655.654541,306.608368 655.483398,306.143555 655.796387,305.275909 
	C656.033569,304.963989 655.992859,305.000275 655.970947,305.016541 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M653.439819,306.549683 
	C653.241638,306.933685 652.965271,306.946136 652.284973,307.054077 
	C649.833801,308.823303 647.794983,307.683746 645.794189,307.073486 
	C643.130493,306.260986 640.692749,304.716339 637.489868,304.773682 
	C636.891663,304.913818 636.610657,304.900696 635.909790,304.845825 
	C635.862366,302.706085 636.234863,300.608154 637.020874,298.288635 
	C637.434265,298.067047 637.424500,298.098145 637.450623,298.067505 
	C641.243225,299.923828 645.131042,301.535736 649.013977,303.161530 
	C650.665588,303.853027 652.372437,304.511139 653.439819,306.549683 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M653.839355,306.935120 
	C648.999146,304.924927 644.512390,302.849548 639.939087,300.986725 
	C638.763794,300.508026 637.842957,300.121155 637.549072,298.417236 
	C637.476746,298.036896 637.480225,297.787201 637.595886,297.740112 
	C638.279358,297.587708 638.851868,297.545654 639.820923,297.747528 
	C645.696350,299.283264 651.166626,300.666931 655.687866,304.917847 
	C656.126587,305.418671 656.219604,305.873322 656.192627,306.655090 
	C655.435303,306.971161 654.797974,306.960114 653.839355,306.935120 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M639.992188,297.722107 
	C639.653687,297.916290 639.094421,297.904327 638.123413,297.792725 
	C638.319946,296.723511 639.056824,297.248474 639.992188,297.722107 
z"/>
<path fill="#F7EBCF" opacity="1.000000" stroke="none" 
	d="
M571.876709,789.351807 
	C569.175720,790.285278 567.260437,789.190796 565.617065,787.353394 
	C564.274719,785.852295 562.727234,784.655151 560.409790,784.030273 
	C563.544434,781.505432 566.466675,778.030029 571.617798,777.959839 
	C573.176697,778.023621 573.868591,778.835938 574.858704,779.767273 
	C576.811218,781.904175 576.642883,784.041992 575.366821,786.638062 
	C574.060913,787.712463 573.035461,788.395142 571.876709,789.351807 
z"/>
<path fill="#E0AE98" opacity="1.000000" stroke="none" 
	d="
M575.433228,787.023132 
	C575.085449,784.956421 575.084534,782.882996 575.111084,780.361877 
	C577.373352,778.766357 579.587952,778.498596 579.859619,781.672913 
	C580.085754,784.314575 580.118958,787.531921 575.433228,787.023132 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M601.712219,781.937500 
	C602.454590,782.865479 601.610779,782.977661 601.070068,783.647095 
	C600.318359,783.735291 599.673401,783.519409 599.028503,783.303467 
	C599.818420,782.838074 600.608337,782.372742 601.712219,781.937500 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M632.667786,739.578918 
	C633.386230,741.577881 634.421692,743.272217 632.291992,745.504211 
	C631.413940,742.707642 630.649231,740.272034 629.856262,737.746460 
	C631.672302,737.421448 631.918579,738.556458 632.667786,739.578918 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M589.967163,733.262329 
	C592.979553,732.729797 594.407410,735.391296 596.963379,736.323303 
	C595.758484,737.257202 594.846069,736.922241 593.597290,736.526001 
	C592.155334,735.472717 591.050842,734.525940 589.967163,733.262329 
z"/>
<path fill="#341019" opacity="1.000000" stroke="none" 
	d="
M589.732910,731.579163 
	C590.202881,731.760803 590.353394,732.014893 590.277710,732.649902 
	C589.170776,732.880066 589.118896,732.346008 589.732910,731.579163 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M669.873535,787.877991 
	C669.573181,788.005798 669.471130,788.025391 669.419922,788.016479 
	C668.873047,788.313110 668.334167,788.454712 667.380493,788.225891 
	C667.008667,788.019165 666.992493,788.010193 666.982300,788.009155 
	C664.866150,785.623108 665.605774,781.902161 668.500305,781.662048 
	C671.500122,781.413269 670.238586,785.050049 671.904907,786.686829 
	C672.044800,787.015015 672.011414,787.043396 671.989990,787.038330 
	C671.457092,787.489563 670.757324,787.474365 669.873535,787.877991 
z"/>
<path fill="#DB988A" opacity="1.000000" stroke="none" 
	d="
M665.426025,782.537842 
	C665.385437,782.474670 665.466675,782.601013 665.426025,782.537842 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M688.080933,742.688538 
	C686.698242,742.712097 686.879028,741.584595 686.802734,740.349854 
	C688.021057,740.445129 688.169312,741.365417 688.080933,742.688538 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M688.318176,745.724976 
	C687.965820,745.170349 687.883850,744.448914 687.879517,743.371460 
	C689.499512,743.532166 689.080139,744.536133 688.318176,745.724976 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M685.093628,739.333984 
	C685.231567,739.024170 685.501343,739.022095 686.175293,739.052246 
	C686.840454,739.191162 686.989868,739.384277 686.999268,739.853271 
	C686.242920,740.545227 685.739441,740.070435 685.093628,739.333984 
z"/>
<path fill="#CE877F" opacity="1.000000" stroke="none" 
	d="
M542.747986,781.988281 
	C542.823303,782.348022 542.668213,782.742859 542.092041,782.160522 
	C542.008850,781.984558 542.501587,781.985596 542.747986,781.988281 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M644.553040,762.878540 
	C644.291870,762.856506 644.185913,762.702942 644.049927,762.270996 
	C644.020020,761.992615 644.515442,762.026611 644.749634,762.006958 
	C644.953003,762.262756 644.861145,762.515991 644.553040,762.878540 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M645.005737,762.007812 
	C645.102417,761.977722 645.192993,761.939758 645.133667,761.944580 
	C644.983765,761.987366 644.999573,762.000000 645.005737,762.007812 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M583.305176,711.012329 
	C582.714844,708.056396 585.081299,706.419312 586.588379,704.030396 
	C587.115906,704.104004 587.367432,704.348999 587.804443,704.780029 
	C586.946655,707.293823 585.915344,709.607483 583.305176,711.012329 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M580.865906,714.919312 
	C580.603760,714.564270 580.721497,714.111694 580.820679,713.307251 
	C580.949890,712.637390 581.190186,712.422607 581.593750,712.075195 
	C581.926880,711.591858 582.188965,711.344604 582.714905,711.029602 
	C583.270691,712.638916 582.870300,714.005127 580.865906,714.919312 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M594.231323,696.589966 
	C594.297546,696.277832 594.644470,696.110535 594.815796,696.022339 
	C594.827026,697.299133 595.660522,698.955933 593.487671,699.869995 
	C593.477478,698.905029 593.821289,697.903503 594.231323,696.589966 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M588.048584,704.719849 
	C587.693054,704.764221 587.409241,704.549011 587.001465,704.089722 
	C587.070435,703.740662 587.263550,703.635681 587.713989,703.736633 
	C588.020996,704.115112 588.070679,704.287659 588.048584,704.719849 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M581.464050,711.879028 
	C581.554749,712.164185 581.444763,712.489197 581.068359,712.884888 
	C580.096680,712.227600 580.774658,712.115417 581.464050,711.879028 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M667.151978,788.274048 
	C667.529297,788.004272 668.049988,787.989319 668.969727,787.991028 
	C668.793030,788.640625 668.158691,789.040344 667.151978,788.274048 
z"/>
<path fill="#C06E6D" opacity="1.000000" stroke="none" 
	d="
M669.942383,788.045715 
	C670.147339,787.681641 670.721497,787.357544 671.632080,787.033325 
	C671.755493,787.918213 671.054321,788.034607 669.942383,788.045715 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M705.234619,248.234314 
	C705.685425,240.169067 698.622559,236.991837 695.089233,231.779053 
	C692.380005,227.782028 689.550293,223.322922 683.368896,223.024902 
	C685.079041,219.854843 688.168274,219.389511 691.054382,220.841446 
	C694.037292,222.342072 696.750671,223.132553 700.007996,222.101700 
	C701.019714,221.781525 702.733765,221.803162 703.353271,222.431046 
	C706.929382,226.055542 711.388977,224.951111 715.584717,224.969238 
	C732.710327,225.043243 749.860657,224.453979 766.953125,225.210663 
	C776.812561,225.647110 786.643433,225.122131 796.372620,224.683456 
	C813.477295,223.912216 830.588135,224.854828 847.622681,223.737335 
	C853.710083,223.337997 859.523315,221.914810 865.657837,224.852112 
	C868.720398,228.935623 865.697693,231.406342 863.634583,234.060287 
	C861.860657,236.342331 859.698608,237.562134 856.769592,235.980255 
	C853.880066,234.419693 851.748352,236.126068 849.601501,237.721008 
	C847.804382,239.056076 846.166687,240.928299 843.209961,239.778351 
	C837.256897,240.913864 831.844910,238.957504 826.313293,238.794647 
	C823.888062,238.723236 820.628845,236.679947 819.466919,241.349487 
	C819.218811,245.850769 819.844360,249.967819 818.797852,254.407333 
	C817.118347,256.524872 815.039734,256.607849 813.133118,256.227081 
	C809.710510,255.543518 806.274292,255.439987 802.823914,255.369400 
	C799.408447,255.299561 797.658447,253.681458 797.619324,250.204712 
	C797.587830,247.403336 797.648804,244.601273 797.511597,241.612213 
	C797.086853,244.233566 798.014221,247.202515 796.147400,250.120865 
	C790.248169,248.988525 784.505798,247.978012 779.557800,244.739441 
	C777.083862,243.120224 774.468018,242.364014 771.513062,242.712143 
	C762.582520,243.764267 753.492676,243.290237 744.655884,244.760803 
	C736.321777,246.147675 728.076782,245.527588 719.784424,245.514648 
	C715.783569,245.508408 711.761108,245.194717 708.446228,248.186630 
	C707.688599,248.870468 706.593201,248.849701 705.234619,248.234314 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M663.592651,238.427368 
	C661.987854,237.572525 659.842285,241.773621 658.218018,237.665329 
	C657.768005,236.527161 655.959045,238.745651 655.067871,239.803268 
	C653.939392,241.142548 652.463806,242.439682 650.879517,241.668594 
	C649.321350,240.910278 647.547729,240.175903 647.228455,237.551620 
	C646.907227,234.911453 643.681824,235.771683 641.383057,235.009674 
	C640.569458,234.604568 640.138367,234.205872 639.574463,233.540543 
	C640.161377,231.035141 638.240173,230.893127 636.681519,230.176254 
	C631.915588,226.664719 627.473877,223.182770 622.831421,219.411926 
	C624.723083,219.162979 627.078613,218.231613 628.635986,220.425858 
	C629.710632,221.940033 630.261292,220.473572 630.984131,220.149231 
	C636.087646,217.859283 641.150024,216.760834 646.467407,219.705185 
	C650.163940,221.752045 654.717285,220.989670 658.493103,223.680298 
	C660.580444,225.167770 664.416443,224.126694 666.016846,221.560944 
	C668.342651,217.832031 670.416016,219.312531 672.900146,221.379501 
	C670.265076,221.502106 668.221436,221.808014 667.988037,225.408890 
	C667.831604,227.822052 666.651001,230.168823 665.726685,232.839813 
	C663.256958,233.895325 664.359680,236.235367 663.489258,237.992828 
	C663.555481,238.365662 663.575134,238.410278 663.592651,238.427368 
z"/>
<path fill="#D7D9C6" opacity="1.000000" stroke="none" 
	d="
M843.436646,239.907791 
	C845.950317,238.919128 847.640808,237.456970 849.490234,236.154938 
	C852.029053,234.367599 854.665161,231.520859 858.003540,235.279114 
	C859.105713,236.519943 860.377197,235.759735 861.362671,234.598801 
	C863.564697,232.004700 866.648438,229.895538 866.002197,225.404770 
	C868.355347,220.413132 866.082214,215.394592 867.578369,210.386353 
	C867.941223,211.143463 868.047668,212.214325 868.278015,213.670807 
	C868.523376,220.619644 868.644836,227.182861 868.765381,234.187500 
	C868.584045,235.756714 868.033691,236.704803 867.074402,237.785431 
	C866.433044,238.197906 866.038940,238.383392 865.413086,238.785645 
	C862.669128,244.471680 863.379456,250.302032 863.200745,256.483704 
	C863.264648,257.126038 863.321655,257.311890 863.307983,257.780579 
	C863.261963,258.494476 863.286560,258.925537 863.234619,259.671295 
	C860.519653,261.987091 857.838257,260.278992 855.234070,259.941833 
	C852.524353,259.591064 849.928589,258.485962 846.697388,258.312561 
	C843.931763,257.852020 842.761353,256.355438 842.720337,254.124741 
	C842.635681,249.509964 842.072754,244.871506 843.436646,239.907791 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M616.052856,212.133072 
	C616.117249,212.136429 616.234436,212.272858 616.351685,212.409271 
	C616.269714,212.361557 616.187683,212.313843 616.052856,212.133072 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M773.058960,187.336349 
	C773.488281,186.972549 773.977417,186.910736 774.464600,186.924057 
	C775.958679,186.964890 776.621704,183.900711 778.555359,185.816360 
	C778.794006,186.052795 778.759277,187.058578 778.600708,187.126968 
	C776.847168,187.883301 775.136902,189.560593 773.058960,187.336349 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M862.000000,181.000397 
	C863.787659,181.169647 864.553345,182.370880 864.565796,183.947052 
	C864.574219,185.009155 863.465332,184.880096 862.347351,184.991837 
	C862.000000,184.998779 862.000000,185.000000 862.000000,185.000610 
	C861.330444,183.982529 860.986572,182.914734 861.752441,181.357864 
	C862.000000,180.998779 862.000000,181.000000 862.000000,181.000397 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M847.690796,185.800385 
	C847.725464,187.825211 847.004150,189.521530 844.872925,188.566666 
	C843.532043,187.965912 844.762634,186.966492 845.717529,186.146606 
	C846.391663,185.620285 846.848145,185.484772 847.690796,185.800385 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M811.991272,198.633255 
	C811.250000,199.000610 810.500000,199.000610 809.375000,199.000610 
	C809.118103,197.898636 808.744995,196.434860 810.390320,196.245331 
	C811.738525,196.090027 811.898682,197.231750 811.991272,198.633255 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M848.237122,185.906754 
	C847.560913,186.005539 847.116882,186.002502 846.340149,185.999130 
	C846.005737,185.554749 846.004089,185.110718 846.001221,184.333649 
	C846.682495,183.416534 847.450195,183.280258 848.650024,183.779419 
	C850.090027,184.971085 849.021851,185.312073 848.237122,185.906754 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M848.917603,183.774780 
	C848.251831,183.996948 847.501160,183.998795 846.375244,184.000610 
	C846.000000,184.000610 845.997986,183.505966 845.997803,183.258789 
	C846.600647,182.010590 847.065979,180.762146 848.828369,181.764618 
	C848.212341,182.436279 848.534180,182.996628 848.917603,183.774780 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M855.999756,183.999390 
	C855.862488,184.963379 855.632690,185.904129 854.385132,185.783615 
	C854.067078,185.752914 853.522095,185.235428 853.546387,184.987183 
	C853.651184,183.917587 854.606995,184.136826 855.660156,184.006744 
	C856.000549,184.001221 856.000000,184.000000 855.999756,183.999390 
z"/>
<path fill="#A7B7B9" opacity="1.000000" stroke="none" 
	d="
M857.381470,188.454239 
	C856.589722,188.678085 856.304321,188.399780 856.424744,187.786148 
	C856.449768,187.658493 856.630432,187.486237 856.759277,187.466873 
	C857.379639,187.373627 857.640076,187.675385 857.381470,188.454239 
z"/>
<path fill="#BCC4BC" opacity="1.000000" stroke="none" 
	d="
M867.190186,185.053314 
	C867.414673,185.181366 867.465576,185.341309 867.439026,185.740814 
	C866.959106,185.792816 865.993408,185.822372 867.190186,185.053314 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M613.124451,238.411987 
	C612.805786,238.215591 612.500366,238.080780 612.500366,238.080780 
	C612.500366,238.080780 612.175598,238.170395 612.093201,238.212540 
	C609.326050,237.955627 609.812622,235.803223 610.426941,234.547424 
	C611.309387,232.743332 613.856873,232.702927 615.201660,233.120789 
	C628.446045,237.236237 640.351929,243.825790 650.381958,253.526245 
	C648.296204,255.495392 647.171753,253.752808 645.914124,252.902588 
	C640.064514,248.948074 633.849060,245.606628 627.694092,242.181091 
	C625.606506,241.019196 623.361328,239.720093 620.357910,239.986069 
	C617.760132,239.732834 615.512939,239.593460 613.124451,238.411987 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M623.646484,227.807526 
	C630.819336,231.265503 637.291626,234.972336 642.296143,241.273285 
	C642.395447,241.735641 642.345276,241.898758 642.049561,242.134369 
	C637.292297,241.234039 634.338989,237.540054 630.316956,235.649872 
	C624.768188,233.042206 619.345825,230.240540 612.940369,230.936493 
	C608.606628,231.407364 610.243103,228.499527 610.671631,226.181183 
	C615.499146,223.324982 619.476074,225.014069 623.646484,227.807526 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M619.805176,239.101700 
	C623.587585,238.312683 626.437988,240.096756 629.248779,241.781036 
	C636.021423,245.839310 642.722900,250.016174 649.792664,253.987305 
	C650.132202,253.829422 650.116943,253.905472 650.080933,253.919739 
	C650.207458,254.226624 650.416016,254.481659 650.872559,254.843201 
	C651.074524,254.987320 651.007507,254.993378 651.019653,254.962021 
	C651.120300,255.114548 651.208801,255.298416 651.139038,255.744339 
	C650.715759,256.048279 650.450562,256.090149 649.783752,256.162903 
	C640.688538,250.848312 632.258484,245.023254 622.593628,241.444641 
	C621.979614,241.217300 621.318176,241.117767 620.311035,240.833511 
	C619.616333,240.321823 619.502380,239.875793 619.805176,239.101700 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M624.108826,227.864365 
	C619.884827,227.554993 616.107727,225.424469 611.417480,225.954788 
	C610.983582,224.902054 610.983032,223.883575 610.974854,222.483276 
	C613.346191,219.698898 615.609741,221.760513 618.248169,222.220856 
	C620.695374,221.314621 622.282715,223.036163 624.032166,223.553604 
	C626.032410,224.145203 626.390747,226.084122 624.108826,227.864365 
z"/>
<path fill="#DACAEC" opacity="1.000000" stroke="none" 
	d="
M618.338257,221.923187 
	C618.246704,223.134186 617.657837,224.116272 616.630737,223.159409 
	C615.131775,221.762970 613.424622,222.132187 611.348572,222.090729 
	C610.933411,221.648941 610.899536,221.196426 610.945435,220.410599 
	C611.391968,219.650909 611.852905,219.482254 612.699097,219.831772 
	C614.499512,221.236755 616.851746,219.682510 618.338257,221.923187 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M636.518188,230.424698 
	C638.200012,230.248154 640.873230,229.220276 639.765991,233.082916 
	C638.520874,232.416840 637.599976,231.559784 636.518188,230.424698 
z"/>
<path fill="#262542" opacity="1.000000" stroke="none" 
	d="
M613.092529,219.811829 
	C612.553528,220.088593 612.117065,220.085068 611.352966,220.079407 
	C611.019226,219.900162 611.013123,219.723038 610.996155,219.280457 
	C610.985229,219.014999 611.001099,218.998489 611.007568,218.988220 
	C611.892334,218.686234 612.119385,217.101379 613.185791,217.531479 
	C614.153992,217.921967 613.461975,218.845474 613.092529,219.811829 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M651.235962,254.600525 
	C650.696960,254.854355 650.319458,254.721405 649.993408,254.261215 
	C650.599304,253.526245 651.050354,253.618332 651.235962,254.600525 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M651.330933,255.961151 
	C650.933350,255.824448 650.885742,255.642502 650.934998,255.195618 
	C651.280701,254.892578 651.529541,254.854462 651.778381,254.816345 
	C651.745911,255.182861 651.713440,255.549377 651.330933,255.961151 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M642.282959,241.728821 
	C642.721497,242.070404 643.439636,242.733612 641.930664,242.409195 
	C641.804077,242.206863 642.120361,241.885132 642.282959,241.728821 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M687.013916,156.387543 
	C688.077454,156.014297 689.134338,156.008179 690.587524,156.001953 
	C689.908936,160.082306 686.936340,162.609680 683.346558,164.957550 
	C682.210754,161.219681 687.169556,160.230667 687.013916,156.387543 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M707.000000,177.999390 
	C706.677307,178.044540 706.331543,178.030685 706.035706,178.145615 
	C704.013977,178.930923 702.075989,179.084488 701.251038,176.624161 
	C700.832947,175.377304 701.859009,174.429321 703.087463,174.187912 
	C705.470642,173.719559 706.869080,174.700851 706.992676,177.615906 
	C707.000000,178.001221 707.000000,178.000000 707.000000,177.999390 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M698.626221,153.016174 
	C699.051819,154.629440 698.846313,156.041534 696.343384,155.987518 
	C695.811829,156.176086 695.652893,156.357513 695.251831,156.270081 
	C695.121338,153.945099 696.267395,153.018585 698.626221,153.016174 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M713.999451,152.007690 
	C714.752075,152.013947 715.504150,152.011673 716.623596,152.000153 
	C716.865784,153.154190 717.278564,154.732773 715.415527,154.769577 
	C714.217224,154.793274 714.097656,153.692535 714.027344,152.367096 
	C714.016174,151.999390 713.998901,151.999146 713.999451,152.007690 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M720.000000,156.000305 
	C719.871399,156.922791 720.315247,158.110580 719.050110,158.538742 
	C718.309387,158.789429 717.709229,158.260223 717.530579,157.603638 
	C717.098572,156.015762 718.384644,156.178757 719.655273,156.005341 
	C720.000000,155.999390 720.000000,156.000000 720.000000,156.000305 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M710.997192,156.002823 
	C711.981079,156.171936 713.410645,155.547150 713.575745,157.207687 
	C713.616211,157.614670 712.924500,158.402328 712.465698,158.493744 
	C711.047424,158.776276 711.144531,157.590546 711.016357,156.339340 
	C711.005615,155.994232 711.000000,156.000000 710.997192,156.002823 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M690.479492,162.377716 
	C691.208801,161.559723 691.848145,160.918747 692.570557,161.805817 
	C692.994812,162.326797 692.970703,163.063736 692.369995,163.467331 
	C691.399902,164.119064 690.610413,163.980103 690.479492,162.377716 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M720.609009,148.708923 
	C719.503052,147.752808 719.658020,147.172714 720.810852,147.071594 
	C721.585571,147.003647 722.621155,147.029739 722.470032,148.191406 
	C722.377563,148.902634 721.559998,148.941498 720.609009,148.708923 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M695.003235,156.244598 
	C695.009766,156.001221 695.490601,155.999573 695.730713,155.997101 
	C696.295593,157.091431 696.620422,158.188217 697.002319,159.624695 
	C696.880249,159.973343 696.701111,159.982330 696.252808,159.998535 
	C695.671753,159.892960 695.416809,159.703552 695.106995,159.223999 
	C694.617310,158.616348 694.470337,158.149475 694.770874,157.292404 
	C694.987793,156.974838 694.996704,156.487991 695.003235,156.244598 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M717.004150,152.004410 
	C717.152039,151.034958 717.382751,150.078842 718.643127,150.189835 
	C718.958191,150.217575 719.503174,150.749115 719.476807,151.000229 
	C719.364441,152.070816 718.417419,151.895020 717.335205,151.993668 
	C716.990967,151.990891 717.000000,151.999847 717.004150,152.004410 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M750.214294,169.794785 
	C750.273743,168.781525 750.621826,168.227432 751.386719,168.654022 
	C751.660767,168.806870 751.843567,169.565552 751.711975,169.912857 
	C751.425964,170.667938 750.845764,170.737839 750.214294,169.794785 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M680.322388,166.961517 
	C680.081787,165.532364 680.926453,164.966843 682.647827,165.005508 
	C682.534485,166.037048 681.811157,166.758621 680.322388,166.961517 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M755.610718,172.537003 
	C756.411133,172.311447 756.703369,172.590195 756.581177,173.212769 
	C756.555908,173.342010 756.372925,173.516464 756.242554,173.536072 
	C755.614990,173.630417 755.351074,173.324463 755.610718,172.537003 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M694.689514,157.016205 
	C694.991150,157.427216 694.994568,157.879608 694.996582,158.671234 
	C693.756592,158.680267 692.258362,158.430328 694.689514,157.016205 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M705.776672,157.286163 
	C707.214539,157.319992 708.731628,157.570648 706.297974,158.964447 
	C705.638123,158.598587 705.488647,158.130981 705.776672,157.286163 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M705.754028,156.975830 
	C706.001648,157.426056 706.000854,157.875397 706.000000,158.661453 
	C705.679138,158.532135 705.358276,158.066086 705.015015,157.304230 
	C704.992676,157.008423 705.000000,156.999863 705.004456,156.995407 
	C705.008911,156.990952 705.505554,156.974945 705.754028,156.975830 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M728.998779,171.001038 
	C728.880188,170.864258 728.762878,170.726471 728.645569,170.588669 
	C728.728638,170.636032 728.811768,170.683411 728.948608,170.864166 
	C729.002441,170.997559 729.000000,171.000000 728.998779,171.001038 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M634.992065,153.007187 
	C634.881897,154.305130 635.125977,155.825165 633.143250,155.921234 
	C631.644836,155.993835 631.071167,155.147751 631.034607,153.392990 
	C631.013428,153.015701 631.001648,153.002213 631.007385,153.007263 
	C631.996277,152.179642 633.068481,151.917145 634.631836,152.759003 
	C634.990479,153.014969 634.999512,153.003067 634.992065,153.007187 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M641.125610,163.476990 
	C644.043091,164.791367 641.426514,165.082138 640.838867,165.464203 
	C640.122681,165.929764 638.765137,166.429886 638.624023,164.969421 
	C638.506409,163.753235 640.093140,164.095825 641.125610,163.476990 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M635.195557,162.653198 
	C633.092102,163.251434 633.368896,161.386154 632.979431,160.652176 
	C632.566589,159.874130 633.803284,160.035767 634.323059,160.108841 
	C635.835571,160.321472 636.211243,161.173843 635.195557,162.653198 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M641.375488,158.993561 
	C641.187744,158.035950 640.538147,156.549667 642.181091,156.434280 
	C643.214172,156.361740 643.692627,157.353470 643.949219,158.659698 
	C643.984436,158.998978 644.000305,159.000702 643.999817,158.992615 
	C643.248718,158.984360 642.498047,158.984177 641.375488,158.993561 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M592.999878,175.999390 
	C593.584229,175.089890 593.685791,173.748337 595.032349,173.542801 
	C595.237427,173.511490 595.773438,174.173508 595.770386,174.511414 
	C595.758545,175.854080 594.682861,175.892105 593.352173,175.993103 
	C593.002441,176.001221 593.000000,176.000000 592.999878,175.999390 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M636.802429,158.805176 
	C635.827759,158.767853 635.227783,158.380814 635.545898,157.721878 
	C635.706665,157.388824 636.675903,157.132751 637.086182,157.304337 
	C637.760498,157.586380 637.661865,158.241211 636.802429,158.805176 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M619.478760,168.988525 
	C619.970886,168.109833 620.585388,168.012711 621.183289,168.419373 
	C621.670471,168.750656 621.666138,169.283371 621.167725,169.602432 
	C620.559448,169.991882 619.947632,169.882751 619.478760,168.988525 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M628.794861,173.788116 
	C627.779358,173.726318 627.227844,173.373505 627.652283,172.609116 
	C627.804138,172.335495 628.564514,172.152252 628.910461,172.284683 
	C629.660889,172.571915 629.741394,173.153381 628.794861,173.788116 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M626.869385,169.638367 
	C626.798218,168.699753 627.263550,168.319962 628.000305,168.419281 
	C628.203491,168.446655 628.534119,168.853836 628.506042,169.042114 
	C628.382751,169.871918 627.750488,169.931183 626.869385,169.638367 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M640.998413,158.998276 
	C640.882446,159.624420 640.880188,160.353256 640.066040,160.498077 
	C639.896545,160.528244 639.657959,160.170029 639.451172,159.990814 
	C639.779968,159.690170 640.108765,159.389511 640.720520,159.045990 
	C641.003479,159.003128 641.000000,159.000000 640.998413,158.998276 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M615.983582,160.258865 
	C616.376343,159.474838 616.949402,158.960571 617.427856,159.690750 
	C617.887512,160.392212 617.206665,160.751938 616.280823,160.965027 
	C615.998291,161.000000 615.990112,160.505875 615.983582,160.258865 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M654.958557,172.702301 
	C654.555237,173.001785 654.112793,173.004776 653.338501,173.009430 
	C653.236877,172.495468 653.335205,171.727829 653.727722,171.522461 
	C654.337524,171.203445 654.745667,171.788696 654.958557,172.702301 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M631.718811,165.033661 
	C631.933411,165.650894 631.900330,166.355377 631.082703,166.478745 
	C630.906006,166.505402 630.671082,166.146011 630.462952,165.964417 
	C630.783752,165.662247 631.104553,165.360077 631.718811,165.033661 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M631.995483,164.994247 
	C632.090820,164.959473 632.190674,164.930573 632.151367,164.955536 
	C632.012207,165.009415 632.000000,165.000107 631.995483,164.994247 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M848.995056,165.338974 
	C849.744202,164.997116 850.494690,165.000549 851.620117,165.004425 
	C852.005920,166.727921 851.878357,168.802643 849.763245,168.744415 
	C847.456848,168.680923 849.499878,166.682632 848.995056,165.338974 
z"/>
<path fill="#B5BEBC" opacity="1.000000" stroke="none" 
	d="
M861.670837,181.048462 
	C862.001160,182.066086 862.002258,183.133408 862.001709,184.600967 
	C860.467834,183.921616 858.851868,182.856140 861.670837,181.048462 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M839.071045,163.362000 
	C839.021973,163.020905 839.514526,163.012451 839.760925,163.010803 
	C840.560852,163.180862 841.114380,163.352554 841.840820,163.765228 
	C842.013794,164.006195 841.999939,164.502197 841.992676,164.750183 
	C840.862427,164.937866 839.589844,165.208603 839.071045,163.362000 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M860.537048,163.382126 
	C860.307800,162.576889 860.591370,162.288483 861.214722,162.411530 
	C861.344604,162.437180 861.519775,162.620117 861.539734,162.751022 
	C861.635986,163.382538 861.328125,163.645065 860.537048,163.382126 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M863.414062,159.968262 
	C863.813416,159.230087 864.214966,159.245728 864.567566,159.758606 
	C864.643372,159.868881 864.648132,160.122177 864.571899,160.226837 
	C864.197144,160.741623 863.794617,160.699417 863.414062,159.968262 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M857.380432,165.955719 
	C857.784241,165.211777 858.192566,165.204514 858.555542,165.730301 
	C858.631409,165.840286 858.628540,166.097397 858.550049,166.205353 
	C858.176270,166.719452 857.767883,166.709656 857.380432,165.955719 
z"/>
<path fill="#90A6B3" opacity="1.000000" stroke="none" 
	d="
M830.126587,165.231064 
	C830.424316,164.995819 830.874634,164.989685 831.661987,164.967896 
	C831.600342,165.712631 831.074158,166.041580 830.126587,165.231064 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M798.332153,150.033463 
	C797.279480,147.729919 800.161316,146.825653 800.009521,144.389587 
	C800.823059,143.767548 801.624695,143.513992 802.717285,143.124359 
	C802.940063,144.598053 803.096985,146.040344 805.620239,146.003540 
	C806.201904,151.256989 803.044617,146.783447 801.671875,147.420898 
	C802.227661,151.022964 802.227661,151.022964 798.332153,150.033463 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M789.363281,152.001221 
	C788.907166,150.222565 791.323914,149.605591 790.991333,147.354980 
	C792.649353,147.167938 794.842896,146.373138 794.992310,149.618744 
	C792.937500,149.858185 791.866028,152.334717 789.363281,152.001221 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M795.009644,170.637482 
	C794.251831,171.000305 793.501160,170.997910 792.375244,170.997772 
	C791.206787,167.324234 794.118042,166.747726 796.307800,165.338196 
	C797.721252,167.759460 794.412964,168.406006 795.009644,170.637482 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M803.220581,153.712875 
	C803.493103,152.272812 804.179932,151.813370 805.227844,152.458237 
	C805.468689,152.606506 805.604187,153.356934 805.446960,153.641953 
	C804.932678,154.574066 804.198425,155.046906 803.220581,153.712875 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M795.064392,150.339661 
	C795.758484,150.002365 796.507874,149.996338 797.632446,149.991379 
	C797.505005,152.176636 796.601440,152.654144 795.064392,150.339661 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M792.001221,158.998505 
	C792.632019,159.091415 793.354431,159.086441 793.494080,159.904022 
	C793.523499,160.076584 793.163452,160.315674 792.982910,160.524155 
	C792.677612,160.205338 792.372314,159.886490 792.032288,159.285355 
	C791.997559,159.003052 792.000000,159.000000 792.001221,158.998505 
z"/>
<path fill="#889AA5" opacity="1.000000" stroke="none" 
	d="
M799.036865,153.379959 
	C799.778992,153.785828 799.810547,154.196411 799.271118,154.564056 
	C799.160583,154.639343 798.901978,154.631790 798.792908,154.551727 
	C798.285889,154.179367 798.262817,153.768982 799.036865,153.379959 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M675.304443,154.480469 
	C675.233032,151.767303 676.373352,151.574112 677.908020,152.972778 
	C679.181702,154.133560 681.231689,155.738327 679.246338,157.355713 
	C677.875122,158.472824 676.426636,160.894714 673.794800,159.591797 
	C673.772400,157.780533 676.675842,156.994492 675.304443,154.480469 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M653.339417,155.934753 
	C652.486511,152.015869 655.541504,151.165787 658.624817,150.005798 
	C659.253662,150.810257 659.497620,151.611588 659.865906,152.706451 
	C657.121521,152.280334 655.527039,154.345703 653.339417,155.934753 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M670.003174,152.003296 
	C669.931946,153.148392 669.651062,154.307449 668.403992,154.538284 
	C667.058044,154.787445 667.110046,153.594254 666.994202,152.353180 
	C666.988159,152.011230 667.000610,151.999313 667.005188,151.994171 
	C667.693481,151.419449 668.461243,151.269104 669.651855,151.759979 
	C669.992676,151.992355 669.999084,151.999268 670.003174,152.003296 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M661.001221,175.999084 
	C660.087402,175.886139 659.080627,175.904739 658.775635,174.758133 
	C658.735168,174.605972 659.055969,174.203156 659.253540,174.168594 
	C660.183044,174.005936 660.676208,174.540054 660.955933,175.690460 
	C660.997559,176.001831 661.000000,176.000000 661.001221,175.999084 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M651.311279,157.947128 
	C651.064026,157.076599 651.321594,156.301025 652.668640,156.032120 
	C652.918030,156.899124 652.677429,157.688431 651.311279,157.947128 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M562.667847,158.000610 
	C563.009827,158.740280 563.014771,159.485397 563.027588,160.602264 
	C561.579956,160.939621 560.993042,160.115295 560.995117,158.395477 
	C561.432129,158.033188 561.881470,158.019623 562.667847,158.000610 
z"/>
<path fill="#AEBBBB" opacity="1.000000" stroke="none" 
	d="
M579.000000,174.999390 
	C579.091187,174.368698 579.096619,173.653870 579.907715,173.513321 
	C580.078430,173.483734 580.316345,173.841446 580.523254,174.020691 
	C580.203186,174.323273 579.883179,174.625870 579.281555,174.964691 
	C579.000000,175.000931 579.000000,175.000000 579.000000,174.999390 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M639.183167,256.265350 
	C633.152588,254.105865 627.908020,250.384323 621.321167,250.649231 
	C620.555298,250.680023 619.767151,250.145248 618.988770,249.874268 
	C617.365051,249.309021 616.439331,248.375107 617.091125,246.504105 
	C617.797119,244.477737 619.170044,245.505371 620.374023,245.743347 
	C627.495422,247.150986 633.760254,250.510544 640.023560,254.589630 
	C640.097046,255.363831 639.867615,255.770981 639.183167,256.265350 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M639.097290,256.664154 
	C639.124634,256.053070 639.384338,255.673752 639.925781,255.090912 
	C643.794128,255.970505 646.039062,258.733154 648.015442,262.053650 
	C645.120178,260.334412 642.224915,258.615173 639.097290,256.664154 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M619.650757,238.793793 
	C620.016724,239.243210 619.994080,239.661667 619.957275,240.394180 
	C617.835754,240.659500 615.728210,240.610764 613.240845,240.517319 
	C612.841003,240.097137 612.821045,239.721649 612.803406,238.780884 
	C615.056274,237.237106 617.167419,237.902954 619.650757,238.793793 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M650.769043,263.413300 
	C649.812500,263.227692 648.678894,262.878723 648.914734,262.141510 
	C649.278931,261.002777 650.110596,261.941925 650.919434,262.561920 
	C651.108032,262.898468 650.990662,263.346375 650.769043,263.413300 
z"/>
<path fill="#3E3E5C" opacity="1.000000" stroke="none" 
	d="
M650.964233,263.040344 
	C651.352356,263.150787 651.596680,263.403137 651.841003,263.655457 
	C651.566406,263.703735 651.291748,263.752014 650.782227,263.640259 
	C650.547363,263.480225 650.820374,263.182251 650.964233,263.040344 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M323.001221,884.998779 
	C320.382935,882.937805 322.702454,881.976318 324.022919,881.052612 
	C325.037231,880.343018 326.657684,879.485229 327.361908,881.257080 
	C328.232239,883.446655 325.864929,883.231750 324.802948,883.944946 
	C324.407501,884.210510 323.899963,884.309143 323.219940,884.743164 
	C322.996368,885.002441 323.000000,885.000000 323.001221,884.998779 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M344.738495,869.204590 
	C344.849884,869.854858 344.701874,870.707336 344.291504,871.754578 
	C344.179138,871.101868 344.329132,870.254333 344.738495,869.204590 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M344.000977,867.001221 
	C343.652954,867.250244 343.303925,867.498108 342.954926,867.745911 
	C342.867889,867.622192 342.780853,867.498474 342.693848,867.374756 
	C342.968018,867.255920 343.242188,867.137024 343.756348,867.007812 
	C343.996338,866.997559 344.000000,867.000000 344.000977,867.001221 
z"/>
<path fill="#AEC3E2" opacity="1.000000" stroke="none" 
	d="
M307.373108,421.937988 
	C307.015869,421.696991 307.046814,421.475006 307.159607,420.924255 
	C308.674072,421.062378 310.023468,421.378021 311.123932,419.836700 
	C312.048950,418.541138 313.275940,418.632629 314.768005,419.729156 
	C313.749817,424.911560 310.148010,421.179749 307.373108,421.937988 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M319.973633,421.450562 
	C320.312103,421.513519 320.709991,421.865295 321.197327,422.485687 
	C320.868866,422.415985 320.450928,422.077667 319.973633,421.450562 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M314.004395,329.995728 
	C314.455627,330.122284 314.902405,330.253143 315.349213,330.384033 
	C315.008972,331.045349 314.612122,330.743011 314.104218,330.230408 
	C313.992584,330.010223 314.000000,330.000000 314.004395,329.995728 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M318.706055,330.367615 
	C318.975525,330.383179 319.121216,330.520264 319.266876,330.657349 
	C319.038666,330.601288 318.810486,330.545227 318.706055,330.367615 
z"/>
<path fill="#4B2766" opacity="1.000000" stroke="none" 
	d="
M306.683044,351.610840 
	C307.040588,351.644470 307.405548,351.961914 307.639618,352.023773 
	C307.692780,352.579010 307.511871,353.072388 307.158081,353.782532 
	C305.381714,352.483612 303.130951,353.529480 301.165527,352.284302 
	C302.631409,350.412872 304.571014,352.216461 306.683044,351.610840 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M311.163452,413.566742 
	C311.080658,413.819641 311.016205,414.305573 310.988617,414.548523 
	C309.858826,414.300873 307.313751,416.983765 307.465851,413.081970 
	C307.533325,410.045929 309.810638,411.412018 311.603882,411.004547 
	C311.985382,411.036041 311.998077,411.503662 311.995117,411.737549 
	C311.578827,412.327393 311.277161,412.745392 311.163452,413.566742 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M311.301575,413.718384 
	C310.898712,413.159515 309.924103,412.308044 311.747192,412.022095 
	C311.992126,411.971436 312.010284,412.369965 312.001099,412.567841 
	C311.913483,413.092590 311.757019,413.376404 311.301575,413.718384 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M669.991089,151.616989 
	C669.246887,151.990356 668.501038,151.988358 667.382507,151.987671 
	C666.870117,151.530350 666.831299,151.001877 666.571289,150.626617 
	C665.895020,149.650909 664.195251,148.780807 665.764893,147.496246 
	C667.053345,146.441833 668.229248,147.606308 668.989380,148.622833 
	C669.527588,149.342590 669.670227,150.358139 669.991089,151.616989 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M626.347168,151.996979 
	C626.370483,150.758759 625.064392,148.774261 627.391724,148.456131 
	C627.973022,148.376678 629.218384,149.226562 629.238708,149.689758 
	C629.306885,151.239670 628.280701,152.032181 626.347168,151.996979 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M634.989258,152.665527 
	C633.929749,153.021759 632.869019,153.028549 631.410706,153.023834 
	C631.034607,151.392441 632.150208,150.676880 633.474426,150.418839 
	C634.910950,150.138931 634.877014,151.359741 634.989258,152.665527 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M658.995117,149.995087 
	C659.094116,149.113098 658.783020,148.062271 659.809814,147.559845 
	C659.990662,147.471313 660.654602,147.899323 660.752502,148.200348 
	C661.048035,149.108658 660.486572,149.621811 659.339111,149.955780 
	C659.009766,150.008911 659.000000,149.999908 658.995117,149.995087 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M654.666870,135.960983 
	C655.004517,136.409149 655.009033,136.862503 655.004395,137.655304 
	C654.044312,137.955414 653.268555,137.675461 653.037964,136.265778 
	C653.445740,135.945343 653.889771,135.955765 654.666870,135.960983 
z"/>
<path fill="#A2B3B8" opacity="1.000000" stroke="none" 
	d="
M655.044678,138.327911 
	C655.449890,138.001144 655.894714,137.997543 656.673462,137.991119 
	C657.011108,138.435303 657.014832,138.882324 657.029541,139.664337 
	C656.119751,139.939606 655.322937,139.700211 655.044678,138.327911 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M672.005615,147.007431 
	C671.914368,147.044479 671.817444,147.074310 671.852905,147.046692 
	C671.985352,146.989243 672.000000,147.000229 672.005615,147.007431 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M658.002808,116.626060 
	C657.512146,117.254501 657.023254,117.508026 656.279419,117.864113 
	C656.052307,116.373940 655.823486,114.979424 653.375732,115.003098 
	C653.186646,109.729309 655.582458,113.120148 657.652344,113.946342 
	C657.999878,114.751663 658.002197,115.501411 658.002808,116.626060 
z"/>
<path fill="#8DA1AF" opacity="1.000000" stroke="none" 
	d="
M652.649902,115.012466 
	C652.994385,115.756004 652.996033,116.503799 652.998840,117.625626 
	C651.862183,117.920776 650.685486,117.664215 650.455200,116.407791 
	C650.207153,115.054626 651.404114,115.116219 652.649902,115.012466 
z"/>
<path fill="#90A2AE" opacity="1.000000" stroke="none" 
	d="
M622.997314,156.002487 
	C622.052063,155.729431 621.095703,155.493088 620.170654,155.167618 
	C619.186707,154.821442 617.552612,155.401169 617.479919,153.738815 
	C617.452881,153.118896 618.265747,152.338516 618.868408,151.840164 
	C620.195374,150.742752 620.853943,152.061279 621.711731,152.745697 
	C622.548889,153.413666 622.997498,154.212860 622.996460,155.635483 
	C623.005249,155.994812 623.000000,156.000000 622.997314,156.002487 
z"/>
<path fill="#99ABB4" opacity="1.000000" stroke="none" 
	d="
M600.995911,142.994659 
	C601.091248,142.959198 601.190857,142.929321 601.151306,142.954239 
	C601.012146,143.009033 601.000183,143.000229 600.995911,142.994659 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M168.847321,419.799866 
	C168.648911,420.964508 168.833450,423.053802 166.872421,420.787598 
	C167.132355,419.714996 167.554611,418.968536 168.847321,419.799866 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M165.832733,419.865173 
	C164.986938,420.472412 163.927536,420.785522 162.546326,421.158417 
	C162.265778,418.422150 163.844345,418.794373 165.832733,419.865173 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M194.760986,417.973938 
	C194.026932,418.342407 193.179871,418.403137 192.145859,418.280518 
	C192.707031,417.028870 193.578354,416.729065 194.760986,417.973938 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M148.693771,421.525177 
	C147.889114,421.805511 146.841888,421.877747 145.395599,421.966156 
	C145.947235,420.717590 147.167099,420.850525 148.693771,421.525177 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M199.910034,417.996399 
	C199.297592,418.209259 198.531464,418.132935 197.388275,417.983032 
	C197.857758,416.911835 198.770035,416.806732 199.910034,417.996399 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M211.983856,416.630188 
	C211.842133,416.914520 211.674927,416.965118 211.250397,416.965881 
	C211.150375,416.507507 211.307632,416.098969 211.464905,415.690399 
	C211.629395,415.925751 211.793869,416.161072 211.983856,416.630188 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M181.825378,418.675537 
	C181.544067,418.894897 181.107010,418.919128 180.342484,418.917511 
	C180.442566,418.255676 180.954544,417.959381 181.825378,418.675537 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M189.890503,417.758759 
	C189.995590,417.905334 189.511917,418.028687 189.262451,418.023865 
	C189.270462,417.883453 189.527954,417.747833 189.890503,417.758759 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M152.766190,421.013916 
	C152.742264,421.139801 152.443466,421.256775 152.043365,421.203430 
	C152.125137,421.023773 152.308228,421.014374 152.766190,421.013916 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M161.873230,421.159180 
	C161.939621,421.808655 161.634811,422.019531 161.068634,421.243256 
	C161.178818,421.040222 161.380081,421.058716 161.873230,421.159180 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M209.952545,417.161621 
	C209.999374,417.392365 209.777634,417.702515 209.267151,418.049194 
	C209.213608,417.804169 209.448792,417.522583 209.952545,417.161621 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M133.847260,422.502350 
	C133.956161,422.606567 133.507858,422.819885 133.263138,422.778229 
	C133.174286,422.413544 133.414276,422.300751 133.847260,422.502350 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M139.040131,422.136688 
	C139.103088,422.413391 138.853546,422.619263 138.283875,422.712952 
	C138.230850,422.424103 138.485489,422.245758 139.040131,422.136688 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M158.673096,435.189941 
	C158.878235,435.168213 158.894394,435.516998 158.897400,435.691406 
	C158.329514,435.929871 158.102036,435.766907 158.673096,435.189941 
z"/>
<path fill="#240E28" opacity="1.000000" stroke="none" 
	d="
M163.126373,429.333588 
	C162.879791,429.262360 162.802582,429.005646 162.841949,428.363892 
	C163.151230,428.223419 163.374725,428.451721 163.517639,428.722504 
	C163.560089,428.802917 163.376007,429.002899 163.126373,429.333588 
z"/>
<path fill="#758EA4" opacity="1.000000" stroke="none" 
	d="
M148.630188,53.007790 
	C149.042603,54.596191 148.856201,56.019875 146.371582,55.991673 
	C145.953735,54.398315 146.146667,52.980129 148.630188,53.007790 
z"/>
<path fill="#69839C" opacity="1.000000" stroke="none" 
	d="
M205.996826,67.993042 
	C204.959946,67.816200 203.896820,67.596703 204.553604,66.175774 
	C204.813629,65.613213 205.517685,65.013649 206.088821,65.595924 
	C206.382538,65.895363 206.072281,66.787216 206.010773,67.702362 
	C205.986618,67.993362 206.000214,68.000130 205.996826,67.993042 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M847.900574,887.845520 
	C847.880798,888.281616 847.761780,888.229980 847.717896,888.182251 
	C838.485413,889.632996 829.345337,889.207092 819.822693,887.237061 
	C819.264343,887.146057 819.122131,887.261780 818.749390,887.226379 
	C819.350647,884.753296 821.044800,883.381714 823.422363,884.079041 
	C827.024902,885.135803 830.684998,883.156006 834.339783,884.844543 
	C836.374329,885.784546 838.908264,884.737549 841.012146,883.833496 
	C843.153809,882.913269 845.131714,882.992859 847.560547,883.910706 
	C847.932739,885.099426 847.926514,886.254395 847.900574,887.845520 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M818.297974,886.748169 
	C818.777649,892.184875 814.795227,889.107910 812.431335,889.927734 
	C811.656738,889.505127 811.506470,889.074280 811.778931,888.281250 
	C813.013428,886.713623 814.031372,885.436157 815.249268,883.936157 
	C815.952454,883.799988 816.455688,883.886475 817.334229,884.015259 
	C817.823425,884.849365 817.937317,885.641235 818.297974,886.748169 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M797.760254,880.620972 
	C797.662537,882.055664 797.349731,883.138000 796.984802,884.559021 
	C792.476990,886.505127 789.789429,885.135864 791.013977,881.614746 
	C793.196045,875.339966 793.070740,869.057495 792.788940,862.313599 
	C803.554504,864.499329 805.339539,873.605896 803.458862,880.767822 
	C803.158142,881.912903 802.741638,883.721191 801.027710,883.379150 
	C799.520996,883.078552 800.283447,881.445190 800.085327,880.388245 
	C799.297302,876.185364 801.591980,871.588501 798.208130,867.868469 
	C797.603882,872.116943 798.486938,876.223328 797.760254,880.620972 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M793.034668,861.959473 
	C794.406799,868.099548 795.207336,874.368408 792.680542,880.251709 
	C790.775024,884.688599 792.924805,884.969055 796.563049,884.935242 
	C797.310913,888.499390 793.445984,887.259155 792.123779,889.349792 
	C789.983032,889.759094 787.937134,889.847290 785.455505,889.877808 
	C784.388977,889.584534 783.939270,889.187622 784.144348,888.421021 
	C785.188354,888.180847 785.839722,887.903748 786.039673,886.818420 
	C786.113831,886.126221 786.310425,885.752747 786.824219,885.204102 
	C787.061035,884.987732 786.997803,885.004639 787.011047,885.034546 
	C788.803833,881.336182 789.740479,877.288086 791.605835,873.210571 
	C792.593445,868.559509 791.203918,864.876099 788.249878,861.310791 
	C788.846802,860.993591 789.569763,860.995972 790.654358,861.001587 
	C791.413147,861.465027 791.988831,861.499084 792.747925,861.800171 
	C792.974304,861.964661 793.015198,861.950623 793.034668,861.959473 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M798.054016,880.575562 
	C795.999756,876.944397 796.950317,872.775452 797.669922,868.341553 
	C799.061707,872.078491 799.294495,876.117920 798.054016,880.575562 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M811.623352,887.993469 
	C811.999146,888.407410 812.002808,888.823730 812.010010,889.552002 
	C811.233154,889.863525 810.452759,889.863220 809.314331,889.695190 
	C808.964355,889.177063 808.972412,888.826660 809.003296,888.212341 
	C809.767822,887.964294 810.509583,887.980103 811.623352,887.993469 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M792.860535,861.682068 
	C792.422485,861.818420 791.870728,861.672119 791.167480,861.265381 
	C791.592896,861.136414 792.169861,861.267883 792.860535,861.682068 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M869.621460,814.556641 
	C867.593201,814.832153 865.264221,814.888855 862.500244,814.906555 
	C864.391846,813.431885 866.870117,814.075317 869.621460,814.556641 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M864.924438,889.500977 
	C861.298096,889.879944 857.608643,889.931702 853.462585,889.920166 
	C853.086426,889.203796 853.166870,888.550781 853.247314,887.897705 
	C858.747681,888.962158 856.386902,884.345520 857.824463,881.565247 
	C855.761353,888.888306 861.462891,887.804565 864.924438,889.500977 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M849.301758,890.120056 
	C848.631409,889.923157 848.297546,889.658264 847.965820,889.091370 
	C849.004028,888.046265 849.980347,887.832275 850.891296,889.490234 
	C850.542358,889.932129 850.090332,889.992065 849.301758,890.120056 
z"/>
<path fill="#CFCBC1" opacity="1.000000" stroke="none" 
	d="
M865.989746,821.255920 
	C866.093140,821.410889 866.042297,821.567444 865.991516,821.723999 
	C865.939514,821.568481 865.887512,821.412964 865.989746,821.255920 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M858.246460,787.032349 
	C857.339050,785.428406 857.783020,783.857971 858.645996,782.121155 
	C859.021484,782.421692 859.031311,782.891541 859.090637,783.711914 
	C859.086243,784.782349 859.032471,785.502380 858.960449,786.583374 
	C858.942322,786.944275 858.478455,787.003479 858.246460,787.032349 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M857.365845,789.966187 
	C857.129333,789.106567 857.243103,788.146362 857.708374,787.080078 
	C857.945312,787.937866 857.830688,788.901733 857.365845,789.966187 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M772.911072,869.729858 
	C773.058167,871.204102 773.035400,872.406677 773.023926,874.062256 
	C770.257812,873.904785 770.214355,873.157776 772.911072,869.729858 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M890.327454,883.214111 
	C890.977051,882.791565 891.484924,882.795532 892.253174,882.784302 
	C892.741760,884.260376 894.703796,886.391174 892.005310,886.977905 
	C889.590820,887.502991 889.944031,885.255554 890.327454,883.214111 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M888.067139,878.997314 
	C888.379944,878.762451 888.698730,878.978760 889.059448,879.494507 
	C888.947632,879.881775 888.793945,879.969666 888.416077,880.200195 
	C888.152344,880.044678 888.112793,879.746521 888.067139,878.997314 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M791.496582,872.907837 
	C791.885376,877.363220 790.384033,881.263489 787.329163,884.893677 
	C787.023804,883.982056 787.023315,882.899536 787.010132,881.409851 
	C786.997437,881.002625 787.000000,881.000000 787.001404,880.998047 
	C788.928284,878.300049 787.983704,874.967834 789.363770,871.990906 
	C790.225708,872.247192 790.706055,872.578857 791.496582,872.907837 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M789.783081,871.574829 
	C788.098572,874.628967 790.234924,878.214172 787.359009,880.861328 
	C787.688416,877.046570 788.373962,873.096924 789.043213,868.781982 
	C790.587585,868.990662 789.680786,870.259888 789.783081,871.574829 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M784.142151,888.355591 
	C784.599182,888.717163 784.741394,889.078308 784.951660,889.629761 
	C784.575134,889.886780 784.130432,889.953491 783.350586,889.960388 
	C783.285950,889.385498 783.556641,888.870361 784.142151,888.355591 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M786.761719,885.142334 
	C786.888428,885.382263 786.715881,885.776733 786.276550,886.359192 
	C786.160706,886.130432 786.311584,885.713684 786.761719,885.142334 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M853.101318,783.254089 
	C853.324524,783.184509 853.476990,783.342529 853.577759,783.528503 
	C853.605713,783.580017 853.479797,783.714783 853.280518,783.898560 
	C853.094727,783.821228 853.052856,783.656677 853.101318,783.254089 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M797.458252,816.533813 
	C797.429260,816.483215 797.487305,816.584473 797.458252,816.533813 
z"/>
<path fill="#9EB0B7" opacity="1.000000" stroke="none" 
	d="
M795.234131,142.012222 
	C795.406311,141.899551 795.580933,141.955093 795.755493,142.010651 
	C795.582520,142.067245 795.409546,142.123856 795.234131,142.012222 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M776.367798,125.993698 
	C776.078308,124.520226 776.942139,123.980598 778.649353,124.003448 
	C778.900085,125.417885 778.108276,126.050232 776.367798,125.993698 
z"/>
<path fill="#93A7B2" opacity="1.000000" stroke="none" 
	d="
M774.008911,126.343491 
	C774.450500,126.006950 774.888733,126.002258 775.655518,126.006264 
	C775.945740,126.940346 775.676453,127.703171 774.318359,127.964294 
	C774.000244,127.560669 774.002869,127.118004 774.008911,126.343491 
z"/>
<path fill="#E00CD3" opacity="1.000000" stroke="none" 
	d="
M869.733276,298.561066 
	C871.500183,298.879059 873.004272,298.951935 874.435852,299.312561 
	C883.984192,301.717621 885.080139,303.382568 885.013428,315.638245 
	C881.232056,317.588440 878.350586,315.684814 875.223145,313.443909 
	C860.295959,307.153961 845.612183,311.218201 830.513062,313.128967 
	C829.033264,313.632385 827.933289,313.920685 826.770935,314.050751 
	C823.710022,314.393280 821.930542,313.484406 822.410889,309.990082 
	C822.679321,308.037354 822.433960,306.032715 823.028564,303.694885 
	C824.914490,299.516998 828.943237,299.804443 832.376953,298.224487 
	C835.539551,296.815277 838.814087,297.226288 841.863525,295.413269 
	C843.267090,294.853699 844.347107,294.805420 845.855164,294.975525 
	C849.647278,296.037964 853.114990,295.561554 856.539978,295.565735 
	C859.855896,295.569763 863.083984,295.840240 866.594238,297.174316 
	C867.355835,297.274933 867.710693,297.269531 868.317627,297.336334 
	C868.569580,297.408508 868.828796,297.660980 868.935791,297.806915 
	C869.174133,298.118256 869.305481,298.283661 869.733276,298.561066 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M818.562256,279.595337 
	C818.900696,278.765533 818.963684,278.267395 819.000244,277.393341 
	C818.880981,276.772430 818.787964,276.527435 818.929077,275.965759 
	C819.625122,275.394348 820.118652,275.244141 821.027100,275.201508 
	C826.623962,276.015656 831.917969,275.214447 837.135193,275.979706 
	C839.505432,276.327362 840.350342,274.885040 840.819580,272.522919 
	C841.035645,271.914581 841.145752,271.677643 841.505249,271.133362 
	C842.221130,270.540070 842.727356,270.417786 843.649658,270.596130 
	C845.419739,273.213501 845.288025,275.843964 844.621399,278.870422 
	C843.921265,279.879639 843.236511,280.255219 842.075012,280.569122 
	C837.619690,282.137756 833.520508,281.299561 829.419067,280.751160 
	C827.774536,280.531311 826.116211,280.304352 824.484863,280.820831 
	C823.840698,281.024811 823.218384,281.351929 823.321716,282.185608 
	C823.387146,282.714111 823.812927,283.164154 824.283325,283.161194 
	C829.918701,283.126038 835.784729,285.309662 841.319092,281.236145 
	C841.819153,280.873993 842.038757,280.759338 842.625977,280.683380 
	C844.656433,282.212494 844.229736,285.393677 847.202881,285.842438 
	C851.613892,286.508270 855.969482,287.727753 860.487671,287.300598 
	C861.845093,287.172241 862.303833,286.008148 862.640747,284.451172 
	C862.810547,283.575775 862.978821,283.091522 863.438477,282.302185 
	C864.116638,281.640717 864.618408,281.502686 865.514893,281.777222 
	C865.962341,286.385986 866.069275,290.777496 866.127808,295.588837 
	C865.620361,298.410187 864.287170,296.612091 863.004639,296.397461 
	C858.078064,291.997620 852.078369,292.664642 846.563782,291.722992 
	C844.745544,291.412506 844.398682,293.384735 843.428833,294.888092 
	C842.215515,295.537140 841.242737,295.893402 840.048096,296.708923 
	C837.745117,296.879913 835.823181,297.435638 833.557739,296.597717 
	C832.315918,294.502289 833.959961,294.199554 835.330200,293.358826 
	C836.834106,292.526764 839.101257,292.941315 838.800720,290.820465 
	C838.570251,289.194122 836.779358,289.435822 835.518677,289.401672 
	C832.396545,289.317078 829.268921,289.275269 826.149109,289.420990 
	C824.499207,289.498077 822.585571,289.549530 823.505493,292.506012 
	C823.844666,293.491608 823.918945,294.171570 823.798584,295.195496 
	C823.057800,297.033997 822.061279,298.498627 823.185303,300.548584 
	C823.503235,301.799500 822.949646,302.527679 822.516418,303.636932 
	C822.242859,304.854828 822.039673,305.746704 821.456665,306.882507 
	C820.855347,307.470764 820.410400,307.650116 819.556396,307.715637 
	C818.957214,307.601257 818.727966,307.507751 818.264404,307.126099 
	C818.032471,306.458527 818.034790,306.079041 818.032288,305.415009 
	C817.825684,303.961212 817.750793,302.807159 818.657043,301.476135 
	C818.823486,300.627899 818.764587,300.046906 818.507080,299.244019 
	C817.886169,298.809479 817.548279,298.501465 817.157104,297.784119 
	C816.986084,297.225769 816.939941,296.995789 816.862305,296.415619 
	C816.828552,295.831299 816.826233,295.597168 816.844849,295.012848 
	C816.919861,294.199738 816.994934,293.740234 817.162659,292.944885 
	C817.629578,291.289948 817.710754,289.873993 818.705688,288.413391 
	C818.941833,287.301300 818.958374,286.455261 818.918030,285.189392 
	C817.538330,283.289551 817.634094,281.641327 818.562256,279.595337 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M886.757019,234.000549 
	C886.998108,250.759018 887.018311,267.519287 886.984558,284.279449 
	C886.981689,285.715027 887.493530,287.282440 886.039368,288.751099 
	C885.063110,270.920868 884.963501,252.909698 885.431030,234.447876 
	C885.894409,234.015961 886.208069,234.016525 886.757019,234.000549 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M865.977661,281.631775 
	C865.440369,281.996613 865.025269,281.998718 864.298828,282.002075 
	C860.345886,283.022705 856.554504,281.798218 852.519897,282.861969 
	C849.399658,283.388306 846.664917,283.816711 843.945068,281.693298 
	C843.385010,281.301270 843.080933,281.232483 842.316895,281.080078 
	C841.856812,280.996429 841.567566,280.654480 841.581787,280.431000 
	C842.141235,279.920410 842.686340,279.633301 843.501587,279.195801 
	C844.312256,278.617493 844.664124,278.009430 845.492432,277.423218 
	C846.230652,277.192169 846.666260,277.159943 847.413574,277.266907 
	C848.481262,277.639771 849.252441,277.770050 850.360718,277.404236 
	C851.114563,277.307007 851.551392,277.348053 852.308899,277.558899 
	C856.042603,279.164490 859.587830,278.645264 863.480225,278.326965 
	C864.348145,278.257172 864.831726,278.352692 865.591431,278.772064 
	C865.955994,279.761322 866.027893,280.515167 865.977661,281.631775 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M866.005127,278.552246 
	C865.449524,279.006561 865.015015,279.005676 864.254517,279.002380 
	C863.725220,278.781342 863.521729,278.562683 863.125977,277.939087 
	C862.526794,272.530914 862.095276,267.527557 863.522461,261.826202 
	C866.651184,261.235992 866.093201,263.247528 866.116333,264.751953 
	C866.184631,269.199310 866.131653,273.648560 866.005127,278.552246 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M863.147217,295.794769 
	C864.287354,296.117737 865.022156,296.228912 865.918213,296.174377 
	C866.277161,296.295349 866.474915,296.582031 866.836792,297.074493 
	C860.188477,297.051544 853.375977,296.822815 846.200562,296.383911 
	C845.981323,295.554047 846.285889,295.027191 847.149414,294.355438 
	C852.780823,292.862335 857.834900,293.459839 863.147217,295.794769 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M846.769165,257.554688 
	C852.213623,257.335815 857.166809,259.231262 862.742493,259.994080 
	C863.399475,260.207092 863.640808,260.428162 863.966858,260.886078 
	C864.051514,261.122925 864.293762,261.408478 864.250549,261.590668 
	C863.940186,261.843628 863.673096,261.914429 863.008667,262.107056 
	C857.273743,262.516998 852.125854,261.767059 847.011353,259.093018 
	C846.701172,258.486786 846.648804,258.211945 846.769165,257.554688 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M868.637268,237.886536 
	C869.081604,238.464142 869.289490,238.763733 869.775085,239.021790 
	C869.501648,240.307083 868.595886,241.245346 867.133911,241.453003 
	C867.081421,241.460449 866.868225,240.336533 866.730835,239.386078 
	C866.681335,238.793945 866.630920,238.555664 866.788086,238.016663 
	C867.450256,237.499130 867.919312,237.471573 868.637268,237.886536 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M866.789734,237.767517 
	C867.036804,238.186340 867.001038,238.363922 866.848572,238.786880 
	C866.389160,239.033157 866.046448,239.034073 865.446899,239.027786 
	C865.073914,238.668533 865.163330,238.380142 865.670654,238.043152 
	C866.091125,237.796051 866.299011,237.661179 866.789734,237.767517 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M863.355957,257.943909 
	C863.164307,257.877930 863.091248,257.692413 863.112915,257.223541 
	C863.296692,257.234955 863.385681,257.529663 863.355957,257.943909 
z"/>
<path fill="#170C0F" opacity="1.000000" stroke="none" 
	d="
M882.857300,208.691101 
	C881.567261,209.359589 881.077271,211.342575 879.186523,210.265747 
	C880.340942,209.509384 880.632629,206.549347 882.857300,208.691101 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M883.030273,198.923676 
	C882.480957,199.473679 882.024963,199.767242 881.292786,200.059723 
	C879.619934,198.417725 881.735718,198.174606 882.463989,197.077866 
	C883.672485,197.349472 883.486145,197.991806 883.030273,198.923676 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M881.872925,190.537598 
	C881.829529,190.272079 882.099609,190.024811 882.627930,189.673004 
	C882.652893,189.897568 882.419678,190.226715 881.872925,190.537598 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M877.670349,196.636826 
	C877.927002,196.407883 878.331116,196.348740 878.735229,196.289581 
	C878.711060,196.508362 878.686829,196.727127 878.398193,197.036255 
	C878.133789,197.126602 877.817810,196.806625 877.670349,196.636826 
z"/>
<path fill="#3A3751" opacity="1.000000" stroke="none" 
	d="
M867.375671,237.993958 
	C866.874573,237.992035 866.676575,237.975342 866.180908,237.944763 
	C866.676208,236.963501 867.469238,235.996094 868.513306,234.828796 
	C868.824219,235.512466 868.883972,236.396011 868.908691,237.722076 
	C868.475403,238.102768 868.077087,238.040970 867.375671,237.993958 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M856.569275,542.526550 
	C854.742249,541.366089 857.158936,539.255981 855.033142,538.015137 
	C855.698364,536.821289 856.487610,535.879272 857.557251,534.798584 
	C858.497009,537.690796 861.221191,535.393494 862.817932,536.765991 
	C862.771667,540.000488 860.041809,540.644104 857.894409,542.271240 
	C857.357849,542.463989 857.134338,542.515503 856.569275,542.526550 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M824.622681,556.376892 
	C826.414368,555.124146 827.935608,554.197266 829.736328,553.126099 
	C831.695740,552.094482 833.488770,552.646179 835.615601,552.795410 
	C839.073486,555.198486 841.589539,557.953003 844.277222,560.976318 
	C844.827454,563.825562 846.338684,566.293396 845.894226,569.507080 
	C844.826172,570.921936 845.186584,572.454102 844.377502,573.905945 
	C841.675476,577.942200 839.023499,581.669373 833.896973,581.729797 
	C830.325500,581.771912 827.041382,580.906067 824.753479,577.688232 
	C820.842041,572.186829 820.574280,561.682678 824.622681,556.376892 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M844.583008,574.113464 
	C844.066895,572.744812 843.696716,571.233032 845.559692,570.056152 
	C846.079773,571.405273 846.294495,572.897217 844.583008,574.113464 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M846.905701,560.382812 
	C847.746277,560.122437 848.994446,559.664673 849.388611,560.754456 
	C849.813171,561.928406 848.596680,561.803650 847.549316,561.988708 
	C847.136230,561.567444 847.057556,561.136292 846.905701,560.382812 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M880.708374,590.076782 
	C880.824097,590.776917 880.664978,591.947693 879.698303,591.353027 
	C879.021484,590.936646 879.734375,590.331177 880.708374,590.076782 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M882.727173,587.916016 
	C883.091187,587.397034 883.588196,586.755676 883.354980,588.074219 
	C883.202332,588.206238 882.749512,588.143494 882.727173,587.916016 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M883.076904,588.077820 
	C883.098572,588.517151 882.934448,588.792114 882.519531,589.180420 
	C882.149048,589.281616 881.969055,589.233521 881.718994,588.914795 
	C881.798035,588.348938 882.009399,588.108093 882.493774,587.805176 
	C882.704773,587.688538 882.951416,587.949402 883.076904,588.077820 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M882.158813,589.158569 
	C882.169800,589.627563 881.942627,589.858643 881.416260,590.103027 
	C881.184875,590.182983 880.954773,589.956909 880.834900,589.844482 
	C880.802124,589.403442 880.976440,589.130493 881.443359,588.778748 
	C881.648804,588.644287 881.988586,588.987427 882.158813,589.158569 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M877.217773,592.865479 
	C877.039490,592.950012 877.022827,592.460632 877.000244,592.216797 
	C877.378967,592.106689 877.755554,592.253235 877.217773,592.865479 
z"/>
<path fill="#756177" opacity="1.000000" stroke="none" 
	d="
M816.747559,606.817383 
	C817.683105,607.868591 818.432190,608.589294 819.375366,609.565186 
	C819.782471,611.043701 819.572327,612.555969 818.359375,612.622864 
	C816.149780,612.744507 815.338196,610.464905 813.674927,609.032715 
	C812.063660,607.651367 811.340881,606.300476 812.817871,604.296509 
	C815.714661,602.649231 815.769409,605.094910 816.747559,606.817383 
z"/>
<path fill="#581B57" opacity="1.000000" stroke="none" 
	d="
M819.958496,601.352661 
	C819.212280,601.859314 818.472961,601.968445 817.057739,602.083923 
	C816.184937,602.044067 815.988098,601.997925 815.506836,601.839905 
	C815.041992,601.630066 814.861572,601.532043 814.430786,601.251770 
	C813.705261,600.656921 813.308533,600.181274 812.940491,599.318848 
	C813.054443,598.414368 813.243774,597.812988 813.718750,597.056763 
	C814.929504,596.879883 815.296448,596.179443 815.950073,595.376709 
	C816.616150,595.197571 817.023804,595.155151 817.737488,595.077698 
	C821.538879,596.085571 819.351440,598.975586 819.958496,601.352661 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M814.641846,600.745483 
	C815.054504,600.918945 815.522217,600.978455 815.752808,601.027710 
	C816.157837,601.223877 816.332397,601.370911 816.762268,601.745972 
	C817.017639,601.973999 817.019104,602.039917 817.001709,602.068848 
	C816.980103,603.498230 816.975952,604.898743 816.952942,606.723633 
	C815.836243,606.144287 814.738403,605.140564 813.322815,604.068542 
	C813.005066,604.000244 812.989746,603.524658 812.992432,603.286743 
	C812.173096,601.608704 812.639954,600.810791 814.641846,600.745483 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M814.912109,600.658386 
	C814.156372,601.084290 813.296692,601.301392 813.037964,602.716980 
	C809.945190,602.344666 810.902039,600.891846 812.585083,599.185730 
	C813.500000,599.476440 814.134827,599.937134 814.912109,600.658386 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M815.913940,595.265808 
	C815.806213,596.143494 816.552063,598.031372 814.181091,597.150146 
	C814.542664,596.365112 815.081055,595.828369 815.913940,595.265808 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M810.007446,572.788696 
	C808.985657,572.983887 807.854858,573.360168 806.863342,572.554993 
	C807.518372,571.749878 808.372009,572.116394 809.476807,572.138794 
	C809.804382,572.180725 809.953857,572.581604 810.007446,572.788696 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M810.700684,573.565308 
	C810.503235,573.684326 810.293152,573.537109 810.062439,573.123962 
	C810.231201,573.041077 810.446594,573.188110 810.700684,573.565308 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M835.751160,552.746948 
	C834.288940,553.022217 832.579224,553.025146 830.442749,553.005005 
	C831.705383,551.300171 833.616028,552.011902 835.751160,552.746948 
z"/>
<path fill="#A395B9" opacity="1.000000" stroke="none" 
	d="
M857.155884,542.470520 
	C859.060852,540.614685 860.864075,539.095337 862.841064,537.297119 
	C864.558350,537.074646 865.249390,538.317627 866.413208,539.479858 
	C871.093872,545.874451 875.510559,552.059143 880.153931,558.511230 
	C882.650818,565.905396 879.660217,571.019409 873.780029,575.351501 
	C870.237976,573.743042 868.834229,570.541504 867.116577,567.194336 
	C866.740784,565.894287 866.783997,564.801636 865.865173,563.715149 
	C865.549438,563.295532 865.425903,563.123352 865.128906,562.679016 
	C864.846924,562.217651 864.738525,562.028320 864.477356,561.543579 
	C864.230164,561.043518 864.135742,560.839050 863.913208,560.318115 
	C862.258179,556.324890 860.802979,552.603760 858.399597,549.381348 
	C856.901550,547.372803 856.453369,545.213257 857.155884,542.470520 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M823.671814,614.081787 
	C823.973755,614.389832 823.966736,614.815063 823.921875,615.557129 
	C823.884094,615.873901 823.460022,616.025574 823.234863,616.027344 
	C823.127441,615.419067 823.245117,614.809021 823.671814,614.081787 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M824.762939,612.867249 
	C824.841675,613.067139 824.671936,613.414917 824.234558,613.879883 
	C824.149475,613.669739 824.331909,613.342468 824.762939,612.867249 
z"/>
<path fill="#170621" opacity="1.000000" stroke="none" 
	d="
M867.805908,565.864075 
	C869.160583,569.396118 871.412170,572.021057 873.353699,575.217651 
	C872.655090,578.073853 874.447510,580.055115 874.963257,582.669556 
	C871.741699,582.272034 871.975281,578.784119 870.254272,576.802979 
	C868.988220,575.345642 867.877197,573.753601 866.432129,572.012207 
	C863.696411,567.947937 861.225708,564.093018 858.506836,560.016663 
	C857.123718,557.586731 855.988831,555.378174 854.612183,552.935425 
	C853.888428,551.232483 853.552307,549.657349 851.442383,549.132629 
	C850.924561,547.451477 851.099487,546.027832 853.671875,546.004883 
	C856.729736,545.994995 857.376770,548.480164 858.385254,550.056458 
	C860.566223,553.465515 863.056824,556.729065 864.731079,560.860229 
	C864.872864,561.187012 864.959473,561.091125 864.907227,561.053223 
	C865.233154,561.258911 865.546936,561.567932 865.884277,562.264648 
	C865.972290,562.586975 865.808228,562.786255 865.889038,562.886902 
	C866.819824,563.670410 867.167786,564.674377 867.805908,565.864075 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M864.920776,560.795410 
	C861.036255,556.522278 857.698181,551.515076 854.351685,546.150269 
	C853.792175,544.475220 854.985596,543.821716 856.038330,542.729004 
	C856.402100,542.435669 856.576599,542.385254 857.004395,542.234375 
	C858.042297,548.977600 863.954407,553.657104 864.920776,560.795410 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M795.353516,546.188416 
	C794.949402,545.882507 794.939270,545.694397 794.945557,545.224121 
	C795.609802,545.069885 796.257690,545.197754 796.970764,545.668091 
	C796.723938,546.620850 796.295410,546.723572 795.353516,546.188416 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M117.973282,506.360504 
	C117.997559,505.997375 118.490555,506.010712 118.736916,506.007812 
	C120.019356,507.851288 124.446243,508.825226 120.260178,511.977783 
	C118.819466,510.195526 117.692848,512.039307 116.197220,512.140991 
	C115.771095,510.088440 117.595749,508.685913 117.973282,506.360504 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M137.924866,493.980530 
	C139.420135,490.776520 141.555984,493.900940 143.702850,493.162933 
	C142.365463,495.279663 140.741669,497.997620 137.924866,493.980530 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M136.001343,498.363220 
	C137.171524,498.359985 139.190659,497.058380 139.472244,499.094574 
	C139.652206,500.395813 138.166183,501.098633 136.367767,501.018250 
	C136.025940,500.253082 136.033783,499.488525 136.001343,498.363220 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M113.247513,516.853210 
	C113.025192,516.294006 113.109856,515.617432 113.282883,514.613647 
	C113.999649,513.828613 114.628044,513.370667 115.533440,512.809570 
	C117.909813,515.645874 114.071541,515.261169 113.247513,516.853210 
z"/>
<path fill="#945F96" opacity="1.000000" stroke="none" 
	d="
M135.985046,500.989685 
	C137.060242,502.341400 136.304367,503.406952 135.374146,504.396729 
	C135.246506,504.532593 134.660294,504.499817 134.555862,504.353180 
	C133.817383,503.316162 135.232040,502.605682 134.992767,501.314880 
	C135.134628,501.015228 135.311234,501.023132 135.752975,501.024292 
	C136.018112,501.017609 135.996994,500.998169 135.985046,500.989685 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M135.007370,500.982208 
	C134.071075,500.958252 133.015854,501.253052 132.449722,500.169922 
	C132.129547,499.557373 132.664398,499.304565 133.117630,499.183807 
	C134.089188,498.924957 134.614883,499.457733 134.929138,500.664825 
	C134.958023,501.007294 135.007370,501.006897 135.007370,500.982208 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M129.482620,497.723022 
	C129.647995,498.960052 129.025604,498.992035 128.134552,498.249756 
	C128.016968,497.990112 128.004532,498.024323 127.986336,498.025696 
	C128.220337,497.694031 128.557877,497.508575 129.482620,497.723022 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M120.062431,513.133423 
	C120.149048,513.121216 120.258400,513.280579 120.367737,513.439941 
	C120.273537,513.394958 120.179344,513.349976 120.062431,513.133423 
z"/>
<path fill="#D2ADC5" opacity="1.000000" stroke="none" 
	d="
M119.995895,511.996094 
	C119.992027,511.992340 120.029892,512.476929 120.034790,512.719360 
	C120.039688,512.961853 120.002739,512.996399 119.982758,513.012878 
	C119.788452,512.852600 119.598915,512.687073 119.453766,512.488892 
	C119.427498,512.453064 119.583336,512.283875 119.831230,512.090820 
	C120.007362,512.005371 119.999756,511.999817 119.995895,511.996094 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M131.080017,497.162048 
	C130.967743,497.513947 130.741592,497.765076 130.256256,498.006653 
	C129.997086,497.997101 130.000000,498.000000 130.000534,498.000671 
	C129.751007,497.634613 129.783020,497.294434 130.394623,496.954895 
	C130.692200,496.929047 130.966125,497.061249 131.080017,497.162048 
z"/>
<path fill="#785684" opacity="1.000000" stroke="none" 
	d="
M136.004166,497.982605 
	C135.737778,497.829742 135.231171,497.625336 135.245010,497.579987 
	C135.386627,497.116669 135.638733,497.111298 135.927109,497.766602 
	C135.961075,498.002441 136.005524,498.004822 136.004166,497.982605 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M86.542969,495.248474 
	C88.570473,493.632996 90.399605,492.292358 92.568695,490.895081 
	C93.273918,491.897736 93.639175,492.957001 94.037704,494.353333 
	C94.085884,495.144440 93.894630,495.464233 93.217606,495.823639 
	C92.973930,496.020966 92.999710,495.999359 93.012398,495.988281 
	C90.216904,495.928314 88.814629,498.963562 85.796089,499.305115 
	C85.250740,499.514221 85.014603,499.549805 84.670990,499.248993 
	C84.526749,498.447083 84.542885,497.983795 84.856560,497.270874 
	C85.091759,497.018646 85.018654,497.016602 85.030869,497.051086 
	C85.471786,496.560516 85.935440,496.064606 86.542969,495.248474 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M109.318481,481.079163 
	C108.008598,480.239075 109.048851,479.922211 109.708878,479.339691 
	C110.435783,479.386505 110.811981,479.538940 111.338821,479.969635 
	C110.886154,480.525635 110.276245,480.819733 109.318481,481.079163 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M93.319885,496.067444 
	C93.141556,495.654968 93.309181,495.289001 93.773895,494.806702 
	C94.375237,494.933014 94.679489,495.175690 95.017914,495.710754 
	C94.590012,496.040100 94.127930,496.077026 93.319885,496.067444 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M107.288925,482.079468 
	C106.601799,480.788300 107.859032,481.026367 108.706665,480.758362 
	C108.998405,481.866425 108.312309,481.984222 107.288925,482.079468 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M111.644287,480.239258 
	C111.145943,480.052185 110.795830,479.872803 110.249275,479.472076 
	C110.052834,479.250732 110.421173,479.003937 110.640717,478.973511 
	C111.117851,479.067474 111.375450,479.191803 111.946724,479.610718 
	C112.153023,480.085632 111.997063,480.199554 111.644287,480.239258 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M108.352646,493.985046 
	C108.490707,493.588440 108.941116,493.229584 109.694305,492.927246 
	C109.867508,493.733276 109.329750,493.959473 108.352646,493.985046 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M110.204857,492.973236 
	C109.983795,492.994446 109.868675,492.538330 109.941666,492.315552 
	C110.238312,492.259705 110.466904,492.421173 110.672882,492.607605 
	C110.684723,492.618347 110.512482,492.832520 110.204857,492.973236 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M900.485107,146.397034 
	C900.903381,145.457047 901.170593,144.630402 901.976440,144.957764 
	C906.103027,146.634125 910.168884,148.462418 914.313232,150.091690 
	C916.161987,150.818481 916.403442,152.192856 915.991211,153.686584 
	C915.330933,156.078735 913.752136,154.242905 912.843628,153.979675 
	C909.351562,152.967896 905.970276,151.580780 902.501465,150.479156 
	C900.530945,149.853363 899.808594,148.728806 900.485107,146.397034 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M908.897827,186.209747 
	C909.902588,186.496490 911.197632,186.739044 911.559937,187.454163 
	C912.541199,189.390884 917.346130,188.019440 915.689331,191.369370 
	C914.520508,193.732483 911.679199,191.227615 909.661804,190.954895 
	C902.648804,190.006989 901.805237,188.914551 902.293335,183.333740 
	C904.427979,184.087433 906.547302,184.835709 908.897766,185.863770 
	C909.128845,186.143524 908.762634,186.381088 908.897827,186.209747 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M910.574463,178.320251 
	C912.301758,180.205246 917.473755,178.917557 915.621582,182.877136 
	C914.905457,184.408188 911.273926,182.986115 909.196777,181.961380 
	C907.265808,181.008743 904.946838,181.385498 903.175232,179.898636 
	C901.983887,178.898788 901.462891,177.615311 902.045776,176.414108 
	C902.776123,174.909027 903.974854,176.132660 904.956665,176.481552 
	C906.690735,177.097763 908.421204,177.724289 910.574463,178.320251 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M902.683167,199.724182 
	C905.622375,203.324158 909.607056,203.925568 913.507629,204.442291 
	C915.370056,204.689011 916.480957,205.223648 915.952454,207.139954 
	C915.384827,209.198059 913.843445,207.976318 912.711243,207.742493 
	C910.606567,207.307861 908.531189,206.733475 906.436707,206.247192 
	C902.930847,205.433243 901.310791,203.428741 902.683167,199.724182 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M902.154907,158.688065 
	C906.447205,159.746994 909.955994,162.664200 914.521118,162.850357 
	C916.106262,162.914978 916.074707,164.267990 915.930786,165.489975 
	C915.813904,166.482178 915.171204,167.176483 914.297363,166.820267 
	C910.555542,165.295044 906.378540,164.923370 902.948914,162.610245 
	C901.667664,161.746078 901.692749,160.373245 902.154907,158.688065 
z"/>
<path fill="#260F1D" opacity="1.000000" stroke="none" 
	d="
M912.637085,212.970840 
	C915.816162,211.225189 915.816162,211.225189 916.099365,215.726120 
	C912.081726,215.935333 908.411804,214.391602 904.637695,213.215836 
	C902.787537,212.639450 901.380127,211.383484 902.105835,209.665543 
	C902.984375,207.586136 904.683472,209.194122 905.662354,209.929153 
	C907.724365,211.477493 910.532654,210.250809 912.577271,212.403503 
	C912.703247,212.798386 912.713684,213.101990 912.637085,212.970840 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M905.606567,168.318146 
	C908.485352,169.121338 910.966431,170.337021 913.588074,170.919189 
	C916.008118,171.456573 916.664673,172.836960 915.991760,174.756363 
	C915.147705,177.163803 913.200012,175.238556 912.478149,174.804352 
	C911.201904,174.036667 909.371643,175.000778 908.291260,173.106171 
	C906.850220,171.550003 902.959961,171.942856 905.606567,168.318146 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M916.333984,229.660034 
	C912.640869,232.101532 909.584839,228.915070 906.134094,228.273926 
	C904.254822,227.924759 901.583130,228.057556 901.999695,224.430359 
	C906.517395,226.491379 912.143311,225.740143 916.333984,229.660034 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M905.292603,197.037003 
	C902.896362,196.897141 901.669556,195.302658 902.267578,193.746872 
	C902.951294,191.967896 904.678284,193.373871 906.016968,193.751678 
	C908.715210,194.513214 911.453796,195.153458 914.204590,195.697998 
	C915.638550,195.981857 916.410522,196.644302 915.841370,198.028961 
	C915.211609,199.560852 914.205750,198.230835 913.381409,198.093155 
	C912.077698,197.875381 910.787781,197.574600 908.911194,197.651062 
	C907.937744,197.964462 907.553040,197.893402 906.904541,197.670166 
	C906.298828,197.361038 905.948242,197.196838 905.292603,197.037003 
z"/>
<path fill="#2D162B" opacity="1.000000" stroke="none" 
	d="
M908.091553,221.623077 
	C903.521057,222.145782 901.648987,220.005753 902.151733,215.602875 
	C903.990784,215.014954 904.662109,216.834930 906.139160,217.607391 
	C906.594055,219.239197 908.123352,219.881943 908.091553,221.623077 
z"/>
<path fill="#1B1016" opacity="1.000000" stroke="none" 
	d="
M905.601135,167.997498 
	C903.097595,171.155838 907.230896,170.860260 907.929932,172.537506 
	C906.065857,173.409058 904.424622,172.657776 902.977356,171.471420 
	C901.658386,170.390076 901.445129,168.694763 902.239929,167.465881 
	C902.970276,166.336548 904.289429,167.161469 905.601135,167.997498 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M905.236145,197.262634 
	C905.380188,196.311707 905.883301,195.993454 906.806702,196.651978 
	C907.371521,197.376556 907.977112,197.506424 908.815247,197.849304 
	C909.064636,198.029160 908.981995,198.062759 908.950195,198.032379 
	C910.644897,200.024643 913.459595,199.602264 916.626526,200.822876 
	C911.361877,202.119827 908.276123,200.228088 905.236145,197.262634 
z"/>
<path fill="#3C1829" opacity="1.000000" stroke="none" 
	d="
M916.221985,224.663361 
	C914.541931,224.207855 913.109192,223.426590 911.316162,222.663544 
	C910.359070,222.056412 910.280884,221.328934 910.781677,220.237701 
	C912.697205,220.390137 914.364258,220.841171 916.193848,221.635620 
	C916.725464,222.749359 916.816711,223.532974 916.221985,224.663361 
z"/>
<path fill="#634F63" opacity="1.000000" stroke="none" 
	d="
M908.153320,222.076935 
	C908.150940,220.136124 904.220581,220.751907 906.048584,218.029022 
	C907.140747,218.045471 907.940491,218.194382 908.875671,218.625641 
	C909.606567,219.706009 909.787292,220.570969 909.119995,221.864349 
	C908.807007,222.206390 908.338318,222.220993 908.153320,222.076935 
z"/>
<path fill="#0E0710" opacity="1.000000" stroke="none" 
	d="
M908.995300,222.463608 
	C908.866028,221.383102 908.925049,220.559830 908.997559,219.322266 
	C909.627686,219.044022 910.244263,219.180054 910.945435,219.627594 
	C910.998352,220.624649 910.966553,221.310211 910.945312,222.338776 
	C910.365112,222.694778 909.774353,222.707809 908.995300,222.463608 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M916.098816,216.074036 
	C917.183044,216.110077 918.218506,216.290588 918.339111,217.465302 
	C918.376282,217.827103 917.589905,218.602371 917.159424,218.618393 
	C916.090271,218.658203 916.094299,217.681000 916.051758,216.572922 
	C916.081055,216.258881 916.015747,216.098495 916.098816,216.074036 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M916.295776,224.954834 
	C916.055176,224.234726 916.135681,223.480362 916.286255,222.352509 
	C918.398193,222.786407 918.657288,223.751663 916.295776,224.954834 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M912.601074,212.846497 
	C913.083679,213.094879 913.606995,213.350067 914.130249,213.605240 
	C913.886108,213.746689 913.657532,213.956589 913.394897,214.016357 
	C912.694031,214.175842 912.193359,213.945740 912.392944,212.979279 
	C912.703247,212.798386 912.641724,212.853317 912.601074,212.846497 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M918.541504,213.472687 
	C918.569519,213.522110 918.513428,213.423248 918.541504,213.472687 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M104.423141,506.557404 
	C104.359245,506.467255 104.605347,506.432159 104.605347,506.432159 
	C104.605347,506.432159 104.487045,506.647552 104.423141,506.557404 
z"/>
<path fill="#472043" opacity="1.000000" stroke="none" 
	d="
M85.244690,499.238525 
	C84.974167,500.049744 84.590660,501.090668 83.660660,500.681519 
	C82.877579,500.337036 83.345428,499.649689 84.154701,498.851959 
	C84.670937,498.687317 84.836723,498.842896 85.244690,499.238525 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M86.691086,494.998352 
	C87.406723,496.162506 86.612152,496.713654 85.397995,497.161072 
	C85.040070,496.908325 85.037048,496.731079 85.028458,496.288055 
	C85.022881,496.022247 85.002312,496.002472 85.010727,496.009857 
	C85.305939,495.720886 85.620949,495.458374 86.248642,495.110687 
	C86.533257,494.991852 86.640831,495.023071 86.691086,494.998352 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M84.704117,498.291870 
	C84.505157,498.531738 84.324913,498.554779 84.250717,498.606750 
	C84.305496,498.162964 84.434479,497.667236 84.827606,497.095093 
	C85.028870,497.363098 84.965973,497.707550 84.704117,498.291870 
z"/>
<path fill="#EFC3D2" opacity="1.000000" stroke="none" 
	d="
M70.991669,512.992554 
	C70.963516,512.471008 70.679100,511.865143 71.453415,511.622498 
	C71.455200,511.995209 71.456985,512.367920 71.232475,512.872375 
	C71.006180,513.004150 70.997986,512.998291 70.991669,512.992554 
z"/>
<path fill="#CF95AB" opacity="1.000000" stroke="none" 
	d="
M87.896423,502.877930 
	C88.079056,502.611237 88.491974,501.923370 88.348068,503.063660 
	C88.209038,503.185120 87.997887,502.983063 87.896423,502.877930 
z"/>
<path fill="#AD7D8F" opacity="1.000000" stroke="none" 
	d="
M86.157562,494.939941 
	C86.235008,495.290222 85.936768,495.588562 85.328842,495.952087 
	C85.273392,495.640839 85.527634,495.264435 86.157562,494.939941 
z"/>
<path fill="#CB89B5" opacity="1.000000" stroke="none" 
	d="
M130.797958,496.615845 
	C130.397034,497.050293 130.208923,497.265259 130.064453,497.787659 
	C129.549652,497.998993 129.098236,497.996643 128.307480,498.010681 
	C128.012314,497.610168 128.056488,497.193237 128.126755,496.463593 
	C129.018005,497.140137 130.128571,493.681610 130.797958,496.615845 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M896.674683,387.196808 
	C896.439819,366.557800 896.321350,346.226318 896.237793,325.424866 
	C896.589844,324.183472 896.515259,323.381439 896.339050,322.303986 
	C895.977661,317.057220 895.735168,312.087189 895.553894,306.665771 
	C896.684448,303.210388 897.780029,300.238770 901.851562,300.466492 
	C901.897827,300.469086 901.562744,300.378571 901.490356,300.238525 
	C900.892456,299.082855 900.894287,299.081909 904.205811,298.233276 
	C904.778259,298.462250 904.989746,298.590515 905.431519,299.005249 
	C906.262329,300.586975 906.836670,301.892456 907.104797,303.617676 
	C903.658447,304.657715 905.029236,307.399353 905.019775,309.193726 
	C904.917358,328.482208 904.979370,347.771545 905.019958,367.529358 
	C905.216248,368.170197 905.388977,368.342316 905.278564,368.745911 
	C904.965149,371.679260 904.934998,374.381134 904.949097,377.531067 
	C907.390869,384.322998 906.996704,390.763306 905.367126,397.633911 
	C905.075806,398.031586 904.933960,397.954315 904.854004,397.941345 
	C902.952026,398.235168 902.368530,397.167175 901.635376,395.678680 
	C900.836670,394.057098 900.073425,391.941589 897.182922,392.036316 
	C896.742065,391.610046 896.686768,391.178925 896.667969,390.422668 
	C896.947998,389.240295 897.030029,388.377655 896.674683,387.196808 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M904.354736,400.049469 
	C904.732361,400.477142 904.797424,400.900146 904.797852,401.637451 
	C903.861938,401.809784 902.529419,402.371613 902.497498,400.850891 
	C902.482483,400.135101 903.384033,400.066101 904.354736,400.049469 
z"/>
<path fill="#551D67" opacity="1.000000" stroke="none" 
	d="
M905.466187,398.010986 
	C905.022888,391.661011 904.970032,385.290436 904.955200,378.449463 
	C908.400024,380.676025 909.263733,384.689697 908.517517,388.352509 
	C907.867493,391.543121 910.177734,395.800781 905.466187,398.010986 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M907.301147,303.944183 
	C906.253357,302.916473 904.601746,302.415314 905.037781,300.319641 
	C905.667480,299.356384 906.322571,298.766357 906.801697,297.619019 
	C907.592346,296.352295 908.167236,295.180542 909.766235,296.689667 
	C909.886719,298.388702 909.811707,299.802856 909.562988,301.620117 
	C908.755859,302.624512 909.009338,304.058685 907.301147,303.944183 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M908.268799,373.381042 
	C908.136169,373.542389 907.897705,373.563934 907.659302,373.585449 
	C907.827209,373.470703 907.995178,373.355957 908.268799,373.381042 
z"/>
<path fill="#664178" opacity="1.000000" stroke="none" 
	d="
M905.246399,368.958954 
	C904.995300,368.977386 904.940430,368.483673 904.991943,368.240845 
	C905.474304,368.178650 905.905151,368.359253 906.335999,368.539856 
	C906.056519,368.673431 905.776978,368.806976 905.246399,368.958954 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M970.573975,402.856812 
	C971.884888,404.585754 973.341370,406.006165 973.027527,408.496765 
	C971.951782,408.806030 970.843262,408.753906 969.404053,408.651611 
	C970.621887,406.264282 970.724609,404.395874 967.245483,403.386719 
	C968.084839,403.021362 969.136780,402.889160 970.573975,402.856812 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M952.737488,348.031067 
	C954.928894,350.463165 957.288818,347.359344 960.442749,349.129425 
	C956.791077,351.099731 954.173645,352.326263 951.007568,348.924561 
	C951.377686,348.366913 951.913452,348.188110 952.737488,348.031067 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M929.721863,287.814056 
	C930.007568,288.240204 930.000366,288.427582 929.987122,288.896179 
	C929.960083,289.400726 929.839539,289.533264 929.481506,289.598114 
	C929.005737,289.423187 928.667908,289.225220 927.873047,288.658386 
	C927.953003,287.674042 928.616516,287.414978 929.721863,287.814056 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M964.953064,359.442444 
	C972.324524,360.900879 979.678040,358.012817 987.042786,359.038208 
	C988.947937,359.303497 991.027344,358.335175 992.917969,360.190308 
	C984.592590,360.860596 976.106262,361.183655 967.248291,361.688843 
	C966.391602,361.721405 965.906677,361.571808 965.218384,361.274170 
	C964.993225,360.676971 964.971375,360.227844 964.953064,359.442444 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M964.135986,437.401062 
	C957.309204,438.829834 950.563232,439.929169 943.395569,440.972168 
	C942.799561,438.940399 943.788086,437.550049 945.619568,437.347473 
	C953.013733,436.529602 960.234985,433.693695 967.931885,435.362061 
	C967.024109,436.731384 964.839600,435.259827 964.135986,437.401062 
z"/>
<path fill="#7B87A6" opacity="1.000000" stroke="none" 
	d="
M958.979980,352.803802 
	C958.965515,352.465759 959.252563,352.327728 959.840881,352.402832 
	C959.845947,352.733826 959.559082,352.863068 958.979980,352.803802 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M945.282959,351.002502 
	C946.764465,350.991852 947.881592,350.991852 949.508423,350.991852 
	C947.795715,352.495392 946.282227,352.906586 944.689331,352.951660 
	C944.040710,352.970062 942.822998,353.358032 942.961365,352.078918 
	C943.061523,351.153748 944.118042,351.120331 945.282959,351.002502 
z"/>
<path fill="#EDBED0" opacity="1.000000" stroke="none" 
	d="
M932.004028,440.007751 
	C933.085876,440.685944 932.549805,441.573639 932.249023,442.419159 
	C932.249023,441.816284 932.249023,441.213379 932.129028,440.308502 
	C932.008972,440.006500 932.000000,440.001160 932.004028,440.007751 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M910.096436,296.634521 
	C909.295349,297.044067 908.320801,295.896423 908.016846,297.719666 
	C907.368713,298.722778 906.528625,299.091217 905.288940,299.141235 
	C901.477783,300.501465 898.299622,302.430634 895.936768,306.013000 
	C893.115173,282.367493 894.384338,258.449249 894.141418,234.070831 
	C894.025513,233.584198 893.880066,233.258652 893.835022,233.084961 
	C894.552246,232.998642 895.314575,233.086014 896.456055,233.199112 
	C897.543335,233.526566 898.042847,234.098740 898.816833,234.774628 
	C899.029114,234.959015 899.084229,235.421097 899.040405,235.649597 
	C900.174683,237.119919 900.347168,238.641129 900.169678,240.610840 
	C900.067261,242.256012 899.031311,243.329575 899.344116,244.868500 
	C900.479248,243.051620 902.397766,243.766235 904.246399,243.132263 
	C909.097595,243.497696 913.548462,244.121689 917.878784,246.563324 
	C918.233337,247.090988 918.332825,247.329041 918.216125,248.283249 
	C915.895691,250.261597 914.073486,249.735306 911.901794,248.728775 
	C909.862244,247.783524 907.201172,245.147675 905.085693,249.333099 
	C903.760010,252.718018 906.292358,249.912796 906.789551,250.829346 
	C907.050964,251.015991 906.988953,251.016006 906.988647,250.985016 
	C907.737854,251.718735 907.261719,252.874466 908.184204,253.860153 
	C908.767761,253.461746 909.027527,252.890472 909.429260,252.131439 
	C910.660095,252.410873 910.900024,253.505951 911.583862,254.664673 
	C911.971069,254.933029 912.170654,254.948135 912.669922,254.981293 
	C913.299744,254.661057 913.700378,254.472122 914.492798,254.555939 
	C914.676147,255.332855 914.538147,255.986267 914.124512,256.845947 
	C913.134583,257.939178 912.018066,257.149475 911.218811,257.685944 
	C911.473633,257.552429 911.733887,257.485291 912.026855,257.542114 
	C913.611450,257.849579 914.927307,259.012939 916.963623,258.976959 
	C917.309753,258.972931 917.460754,258.946564 917.536987,258.954376 
	C918.109558,259.050446 918.503418,259.300476 918.975098,260.028564 
	C919.522400,261.248260 919.804932,262.170746 919.786377,263.513000 
	C919.179016,265.659393 917.888733,265.781555 916.039429,265.208252 
	C915.534668,264.968567 915.343689,264.856750 914.900269,264.537781 
	C914.210449,263.868591 913.933655,263.303314 913.454834,262.519318 
	C912.947205,262.122223 912.952576,261.590607 912.838867,261.537781 
	C912.241150,261.260010 912.949768,261.276459 912.953979,262.055847 
	C913.266113,262.396301 913.335449,262.579895 913.330994,263.053131 
	C913.051514,263.697388 912.801514,264.018158 912.281250,264.522400 
	C911.545227,265.135651 911.014221,265.495819 910.169250,265.972168 
	C907.612671,265.682587 908.207703,263.949371 908.300659,262.182922 
	C908.449463,261.616425 908.492859,261.353516 908.526123,261.089020 
	C908.565491,260.776306 908.503235,260.832733 908.318054,261.563477 
	C908.308228,265.559692 908.944885,269.207916 909.112122,273.215332 
	C909.325012,274.624298 909.530518,275.689056 910.410400,276.871002 
	C911.669983,280.280121 910.653015,283.402893 910.580933,286.518005 
	C910.543152,288.151276 909.861816,289.789978 910.924622,291.687561 
	C910.794434,293.426788 910.512695,294.860626 910.096436,296.634521 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M911.792480,264.216736 
	C912.240540,263.685760 912.461731,263.413696 912.926636,263.032959 
	C913.867676,262.637573 914.277710,263.031281 914.809326,263.790222 
	C914.981201,264.036316 915.002747,264.001282 914.984070,264.009705 
	C916.247009,265.164185 917.647705,265.903381 919.465576,265.625519 
	C922.949097,265.093109 924.762085,266.802155 925.395264,270.464050 
	C925.489563,271.039734 925.496765,271.273743 925.402893,271.841675 
	C923.562927,274.094727 924.009277,276.029175 925.221191,277.969635 
	C924.288940,276.333344 923.803955,274.660248 925.172852,272.639099 
	C926.678711,271.627380 927.934937,271.271759 929.614868,272.273560 
	C932.008240,277.260712 932.363708,281.985229 930.245911,287.220154 
	C930.081116,287.649933 930.127136,287.864349 930.070984,287.958588 
	C929.344727,288.016296 928.674683,287.979767 927.710266,288.116394 
	C925.841980,288.635315 924.268066,288.981049 922.293701,289.406494 
	C920.013062,285.531891 919.308960,281.150391 917.389771,277.194611 
	C916.828918,276.038666 916.941162,274.429047 918.446350,273.835480 
	C919.994629,273.225037 920.388184,274.408295 920.560669,276.059845 
	C921.695129,277.863861 922.205444,279.505554 922.704102,281.517822 
	C923.402527,282.440155 924.026367,282.955292 924.782837,283.452850 
	C924.280334,282.989471 923.734741,282.720428 923.094604,282.048279 
	C922.248657,280.351562 922.143494,278.714539 921.070374,277.077942 
	C920.603638,276.373505 920.611389,275.878448 920.504517,275.407745 
	C920.125854,273.739899 921.689209,271.483612 919.805908,270.460297 
	C918.131409,269.550385 917.659607,272.741547 915.469971,272.499329 
	C912.100281,271.232635 913.508240,267.631042 911.506531,265.488647 
	C911.480225,264.926605 911.522888,264.701141 911.792480,264.216736 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M918.052551,290.561646 
	C915.865906,290.345001 914.493774,291.834290 912.423035,292.012695 
	C909.540710,287.680298 910.451782,283.169922 911.142822,278.306335 
	C911.344788,277.714203 911.469238,277.497528 911.882690,277.052032 
	C912.997314,276.479279 913.531860,277.188843 914.207947,277.386078 
	C913.954163,276.977386 913.725037,276.554352 913.410645,275.784851 
	C913.350586,274.932098 913.485168,274.465668 914.022095,273.799683 
	C915.404663,273.285675 916.567749,273.549347 916.871704,274.511505 
	C918.106262,278.418701 920.346069,281.932770 921.248474,285.960480 
	C921.578369,287.433380 921.366150,288.708649 919.728577,289.018097 
	C918.614319,289.228699 918.619629,288.118744 918.456970,286.982361 
	C918.168457,286.252228 917.883240,285.898346 917.691650,285.487061 
	C917.787964,285.789978 917.995911,286.025665 918.317627,286.582428 
	C918.345642,288.039734 918.931580,289.218231 918.052551,290.561646 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M918.069458,290.803650 
	C918.371399,289.539398 917.827209,288.355804 917.545959,286.799744 
	C917.528748,286.240906 917.591064,286.042847 917.962036,285.803162 
	C919.342712,286.384064 918.533752,288.616211 921.313171,288.382507 
	C919.295471,283.369629 918.609314,278.080933 914.389038,274.090118 
	C913.473267,273.326935 913.523132,272.595276 914.642944,271.928955 
	C915.854736,272.347626 917.176697,272.331024 917.043274,271.558014 
	C916.434082,268.027374 918.345581,268.424500 920.653137,268.788361 
	C923.883484,269.297729 921.076904,271.480316 921.787109,272.777679 
	C922.180847,273.496948 921.375427,274.872711 921.214600,276.323120 
	C921.316162,276.914673 921.313599,277.135681 920.982422,277.312988 
	C919.532104,276.532440 920.768005,274.457428 918.277527,274.021973 
	C918.039673,279.325256 923.050720,283.333282 921.824951,289.040619 
	C920.725586,289.938934 919.557922,290.391663 918.069458,290.803650 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M911.452515,276.747559 
	C910.343201,281.730286 912.154663,286.408203 911.958069,291.506531 
	C912.054626,291.934967 911.564575,291.949585 911.320374,291.971252 
	C910.159058,291.869141 907.808472,294.392426 908.751526,290.825439 
	C909.864624,286.615540 909.252563,282.277863 909.823486,277.664825 
	C909.784119,277.098450 909.836182,276.911865 910.148499,276.595154 
	C910.602600,276.453308 910.796448,276.441589 911.452515,276.747559 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M976.965942,447.236084 
	C976.273315,447.653839 975.514038,447.770264 974.374634,447.953430 
	C973.801697,447.749023 973.569031,447.517914 973.125366,447.147552 
	C972.972534,445.335327 972.990906,443.702393 973.010132,441.663513 
	C973.447754,441.102417 973.884399,440.947235 974.663208,440.887817 
	C973.537292,443.635315 976.084045,445.009521 976.965942,447.236084 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M977.750977,440.753906 
	C977.851624,441.221283 977.703369,441.630829 977.076538,441.074158 
	C977.152832,440.818420 977.320740,440.743774 977.750977,440.753906 
z"/>
<path fill="#141359" opacity="1.000000" stroke="none" 
	d="
M973.872925,455.944366 
	C973.123230,456.342133 972.409363,456.280151 971.347290,456.130615 
	C971.853699,454.602753 973.366516,453.202209 971.134399,451.321106 
	C971.726440,450.954742 972.452393,450.850983 973.538269,450.817017 
	C973.901672,452.419403 973.905151,453.951996 973.872925,455.944366 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M943.125244,468.617432 
	C945.182983,468.107452 947.157654,467.931549 949.554993,467.828796 
	C950.248840,468.457458 950.520081,469.013031 950.883667,469.866699 
	C948.690125,470.485443 946.411621,470.882812 944.116028,471.103241 
	C942.149597,471.291992 942.435486,470.154175 943.125244,468.617432 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M961.165771,470.442688 
	C961.716492,470.174194 962.498169,470.075256 963.668213,470.064850 
	C963.265747,470.861145 962.368958,470.955109 961.165771,470.442688 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M896.442627,387.144836 
	C897.943481,387.530273 898.245361,388.460510 897.009399,389.908752 
	C896.578674,389.198486 896.452820,388.299408 896.442627,387.144836 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M896.155884,322.391541 
	C897.016235,322.754425 897.109497,323.602417 896.462891,324.749939 
	C896.212402,324.221924 896.151978,323.488892 896.155884,322.391541 
z"/>
<path fill="#97689B" opacity="1.000000" stroke="none" 
	d="
M965.211792,910.263367 
	C965.220825,910.000366 965.418335,909.986633 965.911743,909.947266 
	C966.523926,909.987000 966.796875,910.133179 967.114624,910.576660 
	C966.601868,910.699707 966.001099,910.606140 965.211792,910.263367 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M666.833923,437.166626 
	C664.191772,436.526794 664.699951,439.133362 663.287781,439.839539 
	C661.152771,438.360657 662.125916,436.113586 661.970215,434.119781 
	C661.795410,431.881653 662.127930,429.536560 659.115967,427.907532 
	C658.043518,427.211792 657.689453,426.681244 656.973877,426.055969 
	C656.590820,425.697754 656.447876,425.543152 656.201538,425.090149 
	C656.319031,424.048370 656.539917,423.304993 656.884033,422.290283 
	C657.692322,421.280640 658.567139,420.942230 659.887329,420.777740 
	C661.766235,420.702148 663.325989,420.764557 664.822632,419.397034 
	C665.242371,419.025970 665.416443,418.882233 665.884277,418.564667 
	C666.606445,418.225372 667.047791,418.111053 667.848145,418.054962 
	C668.649414,418.128174 669.073120,418.289001 669.710815,418.774048 
	C670.119995,419.039246 670.424194,419.087189 670.423096,419.095032 
	C669.630432,425.133667 671.729736,431.686646 666.833923,437.166626 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M674.851501,421.884796 
	C678.821350,419.485901 682.725098,417.577789 686.271423,421.473175 
	C688.973450,424.441162 689.708618,428.116791 688.418762,432.167877 
	C687.187073,436.036377 683.648987,435.859222 680.825623,436.775513 
	C678.330078,437.585388 676.633606,435.688599 675.616211,433.813507 
	C673.632080,430.156982 671.688110,426.326385 674.851501,421.884796 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M669.962158,418.878143 
	C669.541870,419.015167 669.125305,419.020325 668.395996,419.026245 
	C666.531311,416.549835 665.775574,412.942078 661.224609,414.125366 
	C660.967163,413.667572 660.957520,413.456085 660.930176,412.927551 
	C660.874939,410.801758 662.260620,410.662598 663.773804,410.176910 
	C664.021545,409.971283 664.010437,410.017792 663.987183,410.012451 
	C664.666260,409.350983 665.526367,409.546631 666.708496,409.788208 
	C669.078247,412.893494 671.650330,412.075775 674.864624,411.270142 
	C675.578918,411.644714 675.675720,411.843048 675.836243,412.368164 
	C675.914246,413.142181 675.877014,413.584808 675.662109,414.335754 
	C674.905945,415.682007 673.829407,415.971405 672.453064,416.317932 
	C671.497070,416.308990 670.965942,416.016663 670.248291,415.489960 
	C669.998596,414.996002 669.822632,414.807922 669.494934,414.781860 
	C669.789124,415.200714 670.059082,415.637939 670.524414,416.321014 
	C670.637695,417.091675 670.538086,417.517578 670.148438,418.199829 
	C669.970947,418.482452 669.965942,418.746277 669.962158,418.878143 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M690.706116,413.122955 
	C695.601013,415.668518 696.617126,420.078247 697.309570,424.899200 
	C694.856689,425.124695 695.033081,422.868164 693.460205,422.102875 
	C693.112061,421.496216 693.082275,421.066620 692.974243,420.322784 
	C691.761047,419.337341 691.487183,417.946350 690.507080,416.832855 
	C690.509583,416.517853 690.644043,416.340332 690.613892,416.233154 
	C690.009155,416.677979 689.680725,416.559753 689.762329,415.368835 
	C690.087830,414.390656 690.251892,413.808533 690.706116,413.122955 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M671.907898,416.148682 
	C672.940613,415.421936 673.804077,415.014221 674.878235,414.412170 
	C675.492188,413.537231 676.109741,413.141602 677.206909,412.806305 
	C678.809875,412.556366 680.028015,412.139008 681.683350,412.410095 
	C682.551147,412.192657 683.057434,412.115997 683.966797,412.273224 
	C685.132385,412.801605 685.490356,413.462708 685.303894,414.719757 
	C684.892578,415.190002 684.637329,415.283875 684.115356,415.068939 
	C680.056824,414.925842 676.408936,415.805450 672.435425,417.051788 
	C671.945984,416.902405 671.842346,416.685059 671.907898,416.148682 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M684.005615,415.089355 
	C683.848694,414.760132 684.159912,414.665039 684.313843,414.717896 
	C685.590027,414.693420 685.747986,413.372314 687.046265,413.015259 
	C688.093506,413.553802 688.777344,414.130432 689.692505,414.839905 
	C690.235352,415.118073 690.458557,415.348480 690.588684,415.894958 
	C688.158997,418.471222 686.115723,417.353882 684.005615,415.089355 
z"/>
<path fill="#976B97" opacity="1.000000" stroke="none" 
	d="
M671.878540,415.696686 
	C672.071899,416.044556 672.066772,416.259521 672.055542,416.797089 
	C671.567444,417.532593 671.085266,417.945435 670.287048,418.420349 
	C669.944214,417.927856 669.917419,417.373291 669.936951,416.403687 
	C669.843140,415.794617 669.703125,415.600586 669.911499,415.492798 
	C670.733337,415.573914 671.206665,415.568848 671.878540,415.696686 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M690.415649,416.868347 
	C692.250305,416.657257 692.025391,418.422638 692.866272,419.669769 
	C691.133972,419.912720 690.695068,418.595978 690.415649,416.868347 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M669.007629,441.769470 
	C668.895996,441.597168 668.950378,441.424225 669.004761,441.251312 
	C669.061035,441.423828 669.117310,441.596344 669.007629,441.769470 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M682.723633,370.223297 
	C686.887817,370.918213 691.212708,367.266968 694.927917,371.473083 
	C695.170654,371.949982 695.310059,372.089966 695.468384,372.525299 
	C695.265686,373.587067 694.748413,374.153107 694.025391,374.886475 
	C693.513977,375.260925 693.256470,375.639221 693.455017,375.870087 
	C693.884155,376.369080 693.242310,375.761932 694.181030,375.854797 
	C696.342590,378.248627 698.967651,375.712494 701.226196,377.232971 
	C701.862976,378.919281 701.423157,380.212524 700.601868,381.247406 
	C696.113647,386.903198 694.611938,393.646057 693.351562,400.899902 
	C693.004822,402.607910 692.517151,403.838898 691.378784,405.189636 
	C689.622742,406.351196 688.026794,406.329834 686.028931,406.102661 
	C683.479126,405.498260 681.531982,404.401062 679.117859,403.517700 
	C677.527710,403.368195 676.302002,403.502441 674.692261,403.487305 
	C674.092590,403.280640 673.874939,403.136230 673.442932,402.658875 
	C672.163025,399.743073 672.669006,397.026245 672.554749,393.967987 
	C672.705078,390.984070 673.555786,388.572052 674.528687,385.819824 
	C675.209595,383.748108 676.170898,382.182251 676.842041,380.147766 
	C677.029358,379.651001 677.108154,379.456543 677.298523,378.976440 
	C677.588440,378.091522 677.573730,377.488861 677.398926,376.560974 
	C678.142822,373.501801 679.551514,371.311798 682.723633,370.223297 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M678.179077,402.573303 
	C680.916138,401.682343 682.359131,404.105347 684.758301,404.718445 
	C686.002136,406.362579 690.336609,404.345367 688.247192,408.631226 
	C682.746704,406.574158 676.872009,406.882294 671.908264,403.751465 
	C670.586243,402.917633 667.967834,404.139099 665.065918,404.537628 
	C666.782166,404.999451 667.629944,405.227570 669.641418,405.768799 
	C665.803528,405.502594 663.184753,405.320923 660.166138,405.048676 
	C658.881958,405.872955 657.803772,405.985687 656.263794,405.522156 
	C653.730774,398.662659 655.739319,394.506134 662.268250,393.271881 
	C666.507202,392.470520 668.901550,390.328766 670.444336,386.388458 
	C671.635864,383.345123 672.541992,380.106934 674.790405,377.092712 
	C674.644043,374.046570 671.938904,375.697601 670.422546,374.246735 
	C674.229248,372.179962 677.879822,370.247284 682.594238,370.008698 
	C681.408569,372.216400 679.168152,373.928741 678.124512,376.897125 
	C678.409424,377.628723 678.508667,378.039795 678.199707,378.738312 
	C677.972717,378.981995 678.003540,378.998108 677.995361,378.982483 
	C676.943054,380.730316 676.127319,382.595947 675.395813,384.872894 
	C674.578430,387.614136 673.165894,389.864136 673.793945,392.826538 
	C674.061340,396.278625 674.129456,399.446198 674.324707,403.085052 
	C674.823608,403.609802 675.197449,403.631195 675.875854,403.592041 
	C676.832947,403.465912 677.421265,403.218414 678.179077,402.573303 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M674.605408,376.823669 
	C674.727783,382.532806 671.190002,387.113739 669.337585,392.309174 
	C668.839600,393.705658 667.275330,393.722382 665.958923,393.992737 
	C657.534058,395.723053 657.538086,395.742706 656.031982,404.591675 
	C653.670471,406.376556 653.765381,404.014435 653.697144,403.066193 
	C653.330811,397.973114 652.660156,392.835785 654.586548,387.402344 
	C657.359802,380.679657 663.115112,379.102051 668.825623,377.557190 
	C670.544250,377.092255 672.387085,377.086517 674.605408,376.823669 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M654.490784,387.036072 
	C654.813721,391.696564 654.706970,396.411469 654.836792,401.119904 
	C654.877136,402.583069 653.714294,404.340149 655.802856,405.275085 
	C657.060547,404.983063 658.046631,404.968231 659.399536,404.955750 
	C657.274963,408.264893 652.985474,407.228851 649.516235,409.184662 
	C648.647949,407.639313 650.577148,404.866913 646.847473,404.586945 
	C645.982605,404.522034 646.395081,403.209900 646.705261,402.454834 
	C648.871826,397.179749 650.290894,391.541748 654.490784,387.036072 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M701.634155,376.671875 
	C698.558960,377.747406 696.028931,380.598358 693.763062,376.151306 
	C693.272766,375.738281 692.957886,375.583893 693.054565,375.101959 
	C693.879272,374.169342 694.292358,373.564331 694.864014,372.731201 
	C695.518372,372.717438 696.023438,373.259094 696.586914,372.165436 
	C698.870667,370.650513 701.106018,371.575226 703.683350,371.851013 
	C704.052490,372.159271 704.062256,372.337982 704.116699,372.781433 
	C704.493469,374.709290 703.453186,375.632141 701.634155,376.671875 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M696.410217,371.820984 
	C696.346558,373.194061 699.144287,374.563354 697.049927,375.548645 
	C695.662048,376.201599 695.905762,374.023804 695.186768,372.831909 
	C695.022461,372.503143 694.980408,372.156891 695.005798,371.983429 
	C695.399963,371.797577 695.768677,371.785187 696.410217,371.820984 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M646.016174,407.440857 
	C646.938416,408.077545 647.094910,408.757660 646.376282,409.397919 
	C646.222595,409.534882 645.730713,409.535583 645.585876,409.397888 
	C644.885132,408.731628 645.085205,408.057892 646.016174,407.440857 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M660.692749,414.037262 
	C667.496765,411.373749 667.574524,411.421356 668.064087,418.616760 
	C667.655823,419.109406 667.228516,419.191833 666.481140,419.209167 
	C663.714661,416.475220 660.210388,419.168335 657.320862,417.209503 
	C657.489807,415.212128 659.131592,414.923615 660.692749,414.037262 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M657.022400,417.367920 
	C658.848022,417.112183 660.582275,417.036346 662.308716,416.408447 
	C664.171082,415.731171 665.431885,416.488007 666.071899,418.770691 
	C666.161133,419.144135 666.101013,419.120422 666.080505,419.095398 
	C664.436157,419.700012 662.681152,420.083221 661.245422,421.744690 
	C659.942627,422.000214 658.875244,422.019318 657.407593,422.028717 
	C656.996277,421.844299 656.985168,421.669647 656.942200,421.234283 
	C656.933289,419.904816 656.956360,418.836090 657.022400,417.367920 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M688.252686,408.733398 
	C689.343994,405.698425 686.270508,406.492981 685.102905,405.282623 
	C686.673523,404.979187 688.355896,404.969635 690.457153,404.919861 
	C691.973083,405.812164 692.024048,406.941772 691.222900,408.543701 
	C690.947998,408.907318 690.465881,408.969452 690.226074,409.010010 
	C689.527405,408.943268 689.068481,408.835907 688.252686,408.733398 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M663.626892,409.934204 
	C663.115662,410.705963 662.209778,411.440643 661.108215,412.392914 
	C659.811523,412.742401 658.689392,413.325592 657.338379,412.244812 
	C658.978088,410.459778 660.991821,409.930603 663.626892,409.934204 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M683.153931,412.630005 
	C681.937561,413.213684 680.450073,413.494690 678.509033,413.776031 
	C677.401855,413.162292 677.299438,412.422424 677.806274,411.286438 
	C679.490051,409.994354 680.682007,410.192749 681.867432,411.860016 
	C682.384033,412.116333 682.633484,412.221863 683.153931,412.630005 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M683.410400,412.939087 
	C683.208679,412.780731 682.992249,412.628815 682.455200,412.243835 
	C682.832520,408.021210 684.509827,410.591248 686.078979,411.762054 
	C685.661560,412.687012 684.888855,412.652985 683.806885,412.876831 
	C683.455933,413.005280 683.395752,412.945557 683.410400,412.939087 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M677.711487,410.972229 
	C678.042603,411.674438 678.031555,412.376007 678.037964,413.426941 
	C677.316223,413.907837 676.576965,414.039307 675.463379,414.194305 
	C675.067505,413.741241 675.046082,413.264648 675.018188,412.431000 
	C675.111206,411.934601 675.210571,411.795258 675.656250,411.328735 
	C676.458069,410.991577 676.913635,410.981567 677.711487,410.972229 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M683.814331,413.034241 
	C684.118835,412.678375 684.781677,412.351501 685.835938,412.052368 
	C686.508545,412.250610 686.789856,412.421143 687.240417,412.784454 
	C686.673218,413.572144 685.936646,414.167084 684.833984,414.766418 
	C684.796387,414.127838 685.160278,413.478760 683.814331,413.034241 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M649.675903,415.088989 
	C649.836609,416.393341 648.768555,417.144165 647.568420,418.144287 
	C647.080200,418.220917 646.877808,418.155853 646.531433,417.806122 
	C646.930054,416.156525 648.074646,415.566925 649.675903,415.088989 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M666.885864,409.748291 
	C666.288208,410.028503 665.512878,410.045288 664.350708,410.034607 
	C664.689209,408.837402 665.674622,409.034210 666.885864,409.748291 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M650.013672,415.027954 
	C650.093323,414.992096 650.160217,414.938416 650.096191,414.934998 
	C649.965271,414.985229 650.000916,415.010193 650.013672,415.027954 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M675.000000,410.999512 
	C675.275513,410.889313 675.551025,410.779572 675.914490,410.835724 
	C676.002441,411.001587 676.000000,411.000000 676.001221,411.000610 
	C675.835388,411.115356 675.668274,411.229462 675.250610,411.172363 
	C675.000000,411.001190 675.000000,411.000000 675.000000,410.999512 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M647.066895,418.085480 
	C646.981140,418.556091 646.679626,418.826202 646.378113,419.096313 
	C646.257141,418.739929 646.136230,418.383514 646.201416,417.774292 
	C646.542053,417.642639 646.696594,417.763794 647.066895,418.085480 
z"/>
<path fill="#99799F" opacity="1.000000" stroke="none" 
	d="
M692.210571,401.273285 
	C692.695129,392.256165 696.251587,384.660980 701.052856,377.218140 
	C700.967102,376.848938 701.010620,376.915039 700.975342,376.932922 
	C702.345825,376.272308 703.659729,375.463989 705.033936,374.204102 
	C707.285889,374.120575 708.275146,370.586609 710.930603,372.997345 
	C709.061218,375.279572 707.024170,377.252716 704.810181,379.512634 
	C698.206726,385.573914 697.341919,393.564178 696.301514,401.373322 
	C695.828003,404.927063 696.221069,408.596252 696.221069,412.215363 
	C693.670715,412.774658 693.123657,410.916046 691.926636,409.512299 
	C690.821228,406.561310 692.316772,404.132843 692.210571,401.273285 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M691.905518,401.296631 
	C694.321716,403.471252 691.572571,405.904846 691.818359,408.794617 
	C691.768555,409.206512 691.344604,409.094788 691.146301,409.001038 
	C690.929993,407.834106 690.911987,406.760895 690.885010,405.283691 
	C691.195618,403.796356 691.515198,402.713013 691.905518,401.296631 
z"/>
<path fill="#E00CD3" opacity="1.000000" stroke="none" 
	d="
M659.371704,431.981873 
	C659.553528,432.705933 659.625854,433.087128 659.770203,433.750305 
	C659.899048,434.462006 659.922546,434.893524 659.876282,435.649445 
	C659.624878,436.782928 659.409912,437.593842 658.990234,438.645447 
	C658.316956,439.532837 657.660706,439.727051 656.564392,439.558838 
	C654.446472,437.863342 654.080261,435.550171 653.460083,433.164429 
	C652.069458,434.621948 652.376160,436.303528 651.331177,437.805054 
	C649.199402,439.126984 648.477234,437.820801 647.672241,436.077576 
	C647.087280,433.350769 647.191589,431.004028 648.058105,428.311707 
	C649.942261,426.026093 652.253662,425.872986 655.035400,426.037659 
	C655.667297,426.088104 655.917053,426.122467 656.512085,426.303528 
	C658.349121,427.860077 658.120056,430.067261 659.371704,431.981873 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M655.269592,438.831177 
	C656.278320,439.028229 657.114441,438.970673 658.368042,438.899628 
	C657.333008,443.117554 653.637817,443.204742 650.290283,442.887543 
	C646.389404,442.517944 648.678650,438.494873 647.411987,436.126526 
	C648.474609,436.491730 649.405579,437.251556 650.946655,438.005219 
	C651.756531,437.969025 651.956360,437.938995 652.460754,437.908875 
	C653.587769,437.973267 654.386719,438.119904 655.269592,438.831177 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M656.097473,426.827515 
	C653.481018,427.231476 651.091248,426.934631 648.516418,427.949707 
	C649.321777,424.045319 652.661499,425.404907 655.683472,424.889465 
	C656.098145,424.791718 656.552795,424.880951 656.777832,424.935791 
	C657.436951,425.776794 657.026306,426.258972 656.097473,426.827515 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M659.613647,431.974670 
	C657.652954,431.506317 657.185669,429.840057 656.879150,427.757965 
	C657.411438,426.266785 657.979614,426.869446 658.758484,427.664612 
	C658.973694,427.971771 658.978699,428.008209 658.994629,428.018341 
	C659.255737,429.227173 659.500916,430.425903 659.613647,431.974670 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M660.102783,435.864014 
	C659.102478,435.564636 659.068970,434.980042 659.630432,434.165649 
	C660.742554,434.386414 660.922668,434.959320 660.102783,435.864014 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M649.463013,445.456299 
	C649.527832,445.418182 649.398254,445.494385 649.463013,445.456299 
z"/>
<path fill="#7F3D61" opacity="1.000000" stroke="none" 
	d="
M698.125183,457.822693 
	C698.189331,456.832703 698.270569,456.044373 699.177979,456.276917 
	C699.894775,456.460632 700.119019,457.149445 699.883667,457.831665 
	C699.538025,458.833466 698.955811,459.093048 698.125183,457.822693 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M693.624756,443.833466 
	C693.400452,446.554596 691.950989,446.400055 689.970825,444.662445 
	C690.962524,444.129333 692.115540,443.967957 693.624756,443.833466 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M686.125366,487.463287 
	C685.353577,487.920410 684.512268,487.969788 683.248291,488.043274 
	C683.138733,486.289093 683.451904,484.510864 683.861267,482.362366 
	C684.484741,482.008087 685.012085,482.024017 685.934692,482.068970 
	C686.238647,483.750519 686.147217,485.403015 686.125366,487.463287 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M712.742188,439.739990 
	C713.140015,439.966919 713.541626,439.991791 713.739380,440.025208 
	C713.953430,440.803284 713.969666,441.547913 713.966919,442.665466 
	C712.579773,442.912537 712.284180,441.772125 711.750610,440.466980 
	C711.901611,439.933472 712.123047,439.723267 712.742188,439.739990 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M713.060181,439.625854 
	C712.897156,439.993103 712.654358,440.019287 712.045837,440.094574 
	C711.605225,439.525543 711.530273,438.907410 711.702515,437.888184 
	C712.293213,438.086334 712.636780,438.685547 713.060181,439.625854 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M629.473206,566.167603 
	C630.001648,565.267517 629.825439,563.988220 631.047791,564.350891 
	C631.543579,564.497986 632.299683,565.454895 632.192078,565.669067 
	C631.592896,566.861755 630.557251,567.136169 629.473206,566.167603 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M653.929688,564.852905 
	C653.804260,564.225037 653.832764,563.813354 653.861328,563.401672 
	C654.203186,563.605652 654.760925,563.749084 654.838867,564.027100 
	C654.972229,564.502686 655.240906,565.394287 653.929688,564.852905 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M773.713867,641.168823 
	C773.972839,642.015198 773.940918,643.056763 773.862976,644.484375 
	C772.763184,646.110779 772.155518,647.554749 771.808350,649.476807 
	C771.334167,650.156433 770.918762,650.503662 770.240906,650.924072 
	C769.808533,647.314819 772.028503,644.487000 773.713867,641.168823 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M774.775635,638.804810 
	C774.874817,639.250671 774.733215,639.951599 774.285522,640.835327 
	C774.164551,640.365479 774.349670,639.712646 774.775635,638.804810 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M782.954346,618.939819 
	C783.055725,618.874634 783.236511,618.091248 783.222351,618.994812 
	C783.099060,619.080139 782.999451,618.989746 782.954346,618.939819 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M726.741272,411.677307 
	C725.772095,412.053955 724.575928,412.162201 722.941040,412.148010 
	C722.608093,411.863281 722.713928,411.700989 722.903564,411.260437 
	C724.163086,411.124420 725.338684,411.266663 726.741272,411.677307 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M704.892334,318.217407 
	C704.576599,314.563049 704.518066,311.231598 704.599976,307.465271 
	C709.135132,303.867218 713.353516,303.414429 718.593750,305.915588 
	C730.394348,311.548004 742.519165,311.367737 754.596924,306.152832 
	C759.642578,303.974213 764.928467,304.509735 770.429199,306.063263 
	C772.288086,310.483917 770.726135,314.634827 770.942932,318.759460 
	C771.248291,324.567322 770.856323,330.404266 771.031494,336.222015 
	C771.142334,339.902496 769.422668,341.246460 765.975220,341.412720 
	C761.509949,341.628021 756.994385,340.801636 752.190674,342.248138 
	C751.550537,342.632050 751.297363,342.790222 750.637268,343.135010 
	C748.781738,343.217010 747.333191,343.112366 745.447388,342.998474 
	C745.010071,342.989227 744.674622,342.642426 744.674622,342.642426 
	C744.674622,342.642426 744.724792,342.732697 744.857117,342.871643 
	C744.904907,345.181274 743.360840,346.662262 742.182739,348.161530 
	C740.225403,350.652496 737.517395,352.223969 739.731323,356.448334 
	C740.906799,358.691132 739.084045,361.757843 735.174561,360.590820 
	C734.540161,360.401459 733.905579,360.173828 733.254639,360.084991 
	C725.382446,359.010559 725.381653,359.016479 723.253906,353.070251 
	C722.962585,347.667572 723.013672,342.315460 723.007202,336.501221 
	C720.635010,332.923157 721.788269,329.321747 721.661743,325.939178 
	C721.559265,323.198273 720.674622,321.761566 717.845642,321.150085 
	C714.130798,320.347076 710.349487,320.015442 706.253784,319.083557 
	C705.624451,318.818512 705.387024,318.679413 704.892334,318.217407 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M678.965820,312.072266 
	C679.879944,312.117004 680.396240,312.217010 681.307007,312.296143 
	C684.320923,310.601440 686.766479,313.440063 689.693726,312.801331 
	C690.032471,313.032501 690.465210,312.990051 690.680420,313.020691 
	C691.171570,313.257935 691.447083,313.464966 691.950317,313.794312 
	C692.178162,313.916229 692.537048,313.853546 692.716064,313.819733 
	C693.351135,314.089111 693.686401,314.492676 694.023438,315.376404 
	C694.244751,316.275330 694.304810,316.798859 694.343628,317.716095 
	C694.373169,320.157013 694.487366,322.201294 694.830566,324.621643 
	C694.318726,327.773804 694.810242,330.982849 691.228638,332.770447 
	C686.730408,335.004547 683.682312,330.736450 679.446960,331.056213 
	C678.304443,331.442047 677.903076,331.002075 677.526245,330.103088 
	C677.557434,329.398346 677.700500,329.030304 677.755310,328.465668 
	C677.470886,328.041931 677.373108,327.856171 677.169067,327.364868 
	C676.957031,326.626190 676.879639,326.187897 676.787109,325.399139 
	C676.672852,323.626831 676.708618,322.198364 676.645935,320.404053 
	C676.636047,319.537506 676.635559,319.038940 676.636230,318.156952 
	C676.610352,316.461609 676.706360,315.162567 677.210205,313.521606 
	C677.664490,312.690704 678.065063,312.349152 678.965820,312.072266 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M678.207397,328.975464 
	C678.248901,329.800873 678.426941,330.292664 678.835327,330.939392 
	C677.334961,334.545227 676.878784,338.160431 677.604370,341.992920 
	C676.590393,340.795593 675.576477,339.598267 674.297974,338.207611 
	C673.752747,337.770233 673.443970,337.569305 673.037292,337.141296 
	C672.975769,336.491028 672.984558,336.110046 672.990845,335.443268 
	C668.105408,332.881134 663.135376,333.880402 657.859741,334.910706 
	C657.316406,335.082916 657.081116,335.091888 656.670898,335.056427 
	C653.672180,333.376709 655.622620,330.958801 655.510925,328.437866 
	C655.570740,327.718109 655.628113,327.432739 656.025269,326.869873 
	C656.651672,326.529449 656.938171,326.466522 657.663269,326.435852 
	C664.493774,327.143280 670.995544,325.611603 677.689575,327.682312 
	C678.048340,327.939331 678.020142,327.966034 678.038086,327.973419 
	C678.151978,328.201141 678.247925,328.421478 678.207397,328.975464 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M704.478760,318.262360 
	C709.710510,317.741241 714.573364,319.511780 719.607239,320.180603 
	C721.959167,320.493073 722.917175,321.942902 722.923279,324.263184 
	C722.932861,327.880737 723.058350,331.497955 723.042175,335.577209 
	C722.503174,336.023773 722.056763,336.008453 721.274475,335.996674 
	C720.619080,335.599609 720.333374,335.176239 719.961182,334.374695 
	C719.474304,331.926453 719.636353,329.809784 719.596252,327.704437 
	C719.550415,325.293152 718.644653,323.636658 715.764771,323.119507 
	C710.849060,322.173615 710.479431,322.400787 711.301392,326.482178 
	C711.820068,329.057861 711.600586,331.408386 710.143311,333.907776 
	C708.877686,333.777618 707.898315,333.452911 706.609680,333.072205 
	C703.333801,330.063599 705.077148,326.303711 704.562195,322.498596 
	C704.584534,320.933441 704.364624,319.810333 704.478760,318.262360 
z"/>
<path fill="#751C4F" opacity="1.000000" stroke="none" 
	d="
M720.655701,333.490601 
	C720.885864,334.265045 720.934021,334.759094 720.960449,335.626678 
	C720.938660,336.000214 720.572876,336.112244 720.381836,336.121033 
	C719.967773,336.212982 719.744751,336.296112 719.202209,336.219849 
	C716.526978,335.647858 714.171265,335.235321 711.416687,334.748291 
	C710.829590,334.599426 710.641235,334.525085 710.208801,334.270081 
	C709.964661,334.089478 709.911987,334.097565 709.884521,334.099976 
	C709.718384,331.152130 710.627258,328.345581 709.243652,325.202240 
	C707.865662,322.071716 710.777954,320.229828 714.836426,321.704742 
	C715.711487,322.963867 715.936096,324.118256 715.923096,325.244904 
	C715.881897,328.822845 717.328552,331.485107 720.655701,333.490601 
z"/>
<path fill="#525074" opacity="1.000000" stroke="none" 
	d="
M656.278198,348.105652 
	C661.144287,348.039734 665.576355,348.184875 670.008667,348.190948 
	C671.940613,348.193604 673.468750,348.837982 673.358704,350.840515 
	C673.252625,352.771606 671.370117,352.110596 670.189026,352.119049 
	C665.909668,352.149628 661.629456,352.063751 656.913818,352.068268 
	C654.638611,351.097534 654.941589,349.728180 656.278198,348.105652 
z"/>
<path fill="#100622" opacity="1.000000" stroke="none" 
	d="
M691.299438,332.986389 
	C692.679016,330.821045 692.376099,328.075867 693.156006,325.268463 
	C695.245117,323.233093 698.368958,323.281158 699.805542,320.284790 
	C701.815918,317.864960 703.509888,317.841644 705.186951,320.662720 
	C705.584839,322.324677 705.457336,323.632935 705.447144,325.305725 
	C704.540100,327.267700 702.924622,327.256226 701.476685,327.296722 
	C698.777649,327.372314 697.597778,328.807373 697.221252,331.625793 
	C695.420959,332.986877 693.584595,333.099701 691.299438,332.986389 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M697.475830,331.948242 
	C695.193787,326.525482 695.654968,326.114410 704.179749,325.972778 
	C706.497803,327.795380 705.037048,330.081970 705.235107,332.537170 
	C702.648865,332.626190 700.263306,332.291321 697.475830,331.948242 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M656.173950,341.789062 
	C661.585510,340.497284 666.690918,341.954254 671.753906,341.520844 
	C672.600281,341.448395 673.566711,341.686310 673.593811,342.693756 
	C673.633606,344.170288 672.344971,343.938965 671.440125,343.936432 
	C666.826721,343.923553 662.213440,343.852600 657.122986,343.927063 
	C656.125793,343.953491 655.772156,343.649231 655.537354,342.794403 
	C655.611450,342.180664 655.706299,341.944763 656.173950,341.789062 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M656.040771,358.088623 
	C661.822205,357.817078 667.222473,357.817078 672.622681,357.817078 
	C672.655457,358.355804 672.688171,358.894501 672.720947,359.433228 
	C667.713989,360.958527 662.360168,360.153259 656.827881,361.002716 
	C656.419739,361.113678 656.159973,361.116333 656.041016,361.064209 
	C655.351685,360.175903 655.231934,359.295135 656.040771,358.088623 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M656.377075,357.411377 
	C656.306702,358.617249 656.191467,359.417450 655.999084,360.614868 
	C655.535278,361.007721 655.148560,361.003357 654.472412,360.967773 
	C654.104309,359.901825 654.025635,358.867096 653.862427,357.451538 
	C653.480347,356.296387 653.242920,355.513855 653.636719,354.302979 
	C653.835815,353.214905 653.849121,352.494507 653.801025,351.417999 
	C653.239990,350.311096 653.117432,349.502899 653.562500,348.259979 
	C653.791443,346.855103 653.828125,345.827759 653.933716,344.420441 
	C654.411682,343.488525 654.773682,342.885651 655.806213,342.807190 
	C656.184631,343.226685 656.247681,343.505157 656.478638,343.917786 
	C656.633728,345.093475 656.621704,346.134796 656.660889,347.563599 
	C656.588074,349.105164 656.463989,350.259277 656.408936,351.764038 
	C656.429382,353.745026 656.380798,355.375366 656.377075,357.411377 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M658.058838,335.062714 
	C662.881653,331.443909 668.798767,333.408813 674.425232,333.637451 
	C676.045776,333.703308 674.411499,334.756317 673.306641,335.095001 
	C668.181152,335.127625 663.373962,335.097748 658.058838,335.062714 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M672.536255,336.898254 
	C673.244934,337.092072 673.522888,337.312103 673.917114,337.773224 
	C669.937195,338.014282 665.841003,338.014282 661.744812,338.014282 
	C665.086365,334.593842 668.691772,337.878540 672.536255,336.898254 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M705.350098,332.991486 
	C704.949585,330.917297 704.864868,328.873535 704.686462,326.400269 
	C704.682373,324.598938 704.771912,323.227142 704.820557,321.443054 
	C704.963867,320.912415 705.148132,320.794067 705.598999,320.867737 
	C706.088257,324.746429 706.310974,328.433014 706.416992,332.567932 
	C706.088928,333.018127 705.877441,333.020020 705.350098,332.991486 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M655.696350,327.033630 
	C656.347961,329.455078 656.490112,331.801575 656.564392,334.588196 
	C656.293335,336.210236 656.588257,337.601349 654.594727,337.924805 
	C655.017029,336.364777 653.757568,334.908752 654.247070,333.305725 
	C654.035767,332.955627 653.894226,332.494202 653.968506,332.264587 
	C654.572266,331.442047 654.524292,330.697601 654.317200,329.729980 
	C653.988098,329.280823 653.969055,329.078125 654.023560,328.720520 
	C654.185974,327.860901 654.564453,327.323822 655.696350,327.033630 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M656.226562,342.677582 
	C655.586243,343.206268 655.050171,343.464508 654.258301,343.881592 
	C654.002563,344.040466 653.798523,343.613220 653.768372,343.378418 
	C653.832275,342.653748 653.926331,342.163879 654.012878,341.298096 
	C654.005371,340.922150 654.096985,340.784363 654.178467,340.770233 
	C654.613525,340.716858 654.967163,340.677734 655.808716,340.854492 
	C656.296753,341.070465 656.610657,341.410858 656.578735,341.640076 
	C656.474792,342.048523 656.402771,342.227814 656.226562,342.677582 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M653.943115,333.203064 
	C655.145691,334.145721 654.982971,335.485474 654.273010,337.226837 
	C654.050781,337.590240 654.034119,337.539490 654.017395,337.558136 
	C653.938660,337.322998 653.876648,337.069214 653.731018,336.432495 
	C653.443604,335.597412 653.366211,335.124542 653.560669,334.294739 
	C653.753845,333.789124 653.802185,333.619781 653.943115,333.203064 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M719.017822,336.200470 
	C719.101196,336.055145 719.319702,336.049896 719.864502,336.087219 
	C719.844849,336.200073 719.498901,336.270294 719.017822,336.200470 
z"/>
<path fill="#5D212C" opacity="1.000000" stroke="none" 
	d="
M710.082397,334.277557 
	C710.252136,334.103241 710.510132,334.197540 710.878296,334.523132 
	C711.017883,334.673798 710.576965,334.695770 710.576965,334.695770 
	C710.576965,334.695770 710.200195,334.465637 710.082397,334.277557 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M656.377930,363.976715 
	C656.211182,363.904327 656.153320,363.684875 656.189148,363.138000 
	C656.371643,363.029999 656.479797,363.244293 656.540833,363.471222 
	C656.569580,363.578125 656.507690,363.709381 656.377930,363.976715 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M656.258911,340.580200 
	C655.954956,341.046326 655.613098,341.022186 654.765625,340.877075 
	C654.525146,339.390411 655.149841,339.083038 656.258911,340.580200 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M778.657837,435.816071 
	C777.007507,436.245422 775.771667,437.470398 774.163086,436.399078 
	C774.949463,434.458313 776.915405,434.062744 778.179871,433.670380 
	C780.479858,432.956696 780.051331,434.442627 778.657837,435.816071 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M768.717896,439.579315 
	C767.714905,439.751160 766.682739,439.339935 767.339172,438.863770 
	C768.811646,437.795654 770.479919,436.590607 772.673157,437.161896 
	C772.062500,439.125183 770.243958,438.761658 768.717896,439.579315 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M772.654663,342.029968 
	C772.867004,349.509613 772.934631,356.842499 772.939880,364.648132 
	C770.484192,368.174042 767.381104,365.837250 764.630005,366.154816 
	C763.963196,366.231781 763.522156,365.392242 763.734924,364.709290 
	C764.306458,362.874237 765.834961,363.845032 766.609924,363.519501 
	C763.747864,362.882812 760.850708,365.880463 757.287903,364.355286 
	C756.482300,362.634583 755.348938,361.955566 753.491455,361.753235 
	C752.266907,361.190979 751.354309,360.683655 750.117676,361.454224 
	C749.792542,362.001587 749.623108,362.326447 749.231934,362.826538 
	C749.030701,363.012482 748.591492,363.091064 748.345276,363.088837 
	C748.057129,364.902954 746.272278,365.095886 745.105957,366.247864 
	C744.888916,366.428680 744.880066,366.496124 744.875793,366.477356 
	C744.305664,365.833954 743.739868,365.209351 743.005615,364.308411 
	C743.127075,361.273254 742.469177,358.425812 744.011963,355.850891 
	C744.806213,355.694122 745.221436,355.472961 746.006104,355.269897 
	C748.218872,355.466309 750.086914,356.997162 752.205933,355.049683 
	C752.844666,354.674896 753.585571,354.644745 753.604736,354.474976 
	C753.663025,353.959686 753.038818,354.578888 752.697144,353.937195 
	C752.403076,353.242371 752.401489,352.811432 752.660034,352.085632 
	C753.202637,351.536072 753.610779,351.361359 754.390503,351.270874 
	C756.562988,351.968140 757.290771,350.391876 758.684082,349.396057 
	C761.227478,349.926270 763.387207,348.991272 765.923462,349.180664 
	C768.103577,352.976227 764.632629,351.759369 763.554626,352.491516 
	C764.774048,352.319305 766.390808,352.439423 767.489990,350.662323 
	C765.482910,347.292969 762.632446,350.230591 759.982117,349.191895 
	C759.477295,348.565063 759.402649,348.101532 759.560913,347.281769 
	C759.858582,346.780884 760.030945,346.617249 760.523315,346.304138 
	C761.706238,345.964325 762.589600,346.066223 763.459167,345.971527 
	C762.662781,345.967529 761.904297,345.824982 760.997437,345.089020 
	C760.181030,342.005432 762.332886,342.017090 764.049377,341.755676 
	C765.989136,341.460297 767.970154,341.870209 770.297791,341.549744 
	C770.920715,341.502319 771.171570,341.513794 771.760559,341.691528 
	C772.098633,341.857727 772.510010,341.883179 772.654663,342.029968 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M747.023560,368.447327 
	C749.090332,370.851501 747.505798,374.140686 748.055786,377.627075 
	C745.777649,375.223297 747.704651,371.922333 747.023560,368.447327 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M739.865967,370.812134 
	C739.578125,370.884003 739.156189,370.766785 738.734314,370.649567 
	C739.048157,369.937042 739.392944,370.388672 739.865967,370.812134 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M740.000000,370.999969 
	C740.257812,371.344696 740.517944,371.687927 740.757080,372.045197 
	C740.761780,372.052277 740.520813,372.223785 740.394470,372.318573 
	C740.252502,372.044067 740.110535,371.769592 739.984253,371.248169 
	C740.000000,371.001221 740.000000,371.000000 740.000000,370.999969 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M770.633789,341.772400 
	C770.185974,344.893341 768.313293,342.360046 766.981079,342.871643 
	C765.146240,343.576294 762.742310,341.997406 760.922974,344.857361 
	C759.094910,346.828156 757.165344,347.339111 754.986816,348.088623 
	C753.645630,348.519623 752.652771,348.944061 751.360229,349.489777 
	C750.844299,349.637543 750.632996,349.676422 750.113892,349.724548 
	C746.784607,350.156158 750.502563,352.310547 748.715698,353.355347 
	C747.429138,354.459778 746.000732,354.641022 744.662781,355.699127 
	C742.454712,350.828857 744.175110,346.980530 749.998169,343.572754 
	C750.230286,343.321686 750.203979,343.299744 750.217285,343.296509 
	C752.056824,341.251007 754.500854,340.947052 757.004272,341.028412 
	C761.432800,341.172272 765.887878,340.514252 770.633789,341.772400 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M744.394775,355.891907 
	C744.940674,354.044525 745.894958,352.711731 748.815674,352.971680 
	C750.519104,353.057892 751.519409,353.087616 752.672485,353.710693 
	C753.292114,354.043640 753.680115,354.188934 754.068054,354.334229 
	C753.833191,354.571106 753.598389,354.807983 753.103882,355.101929 
	C751.474426,357.302307 749.460999,356.703217 747.159607,356.185394 
	C746.267944,355.945374 745.735779,355.928741 744.807861,355.933594 
	C744.412170,355.955078 744.413025,355.904541 744.394775,355.891907 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M774.802124,458.962830 
	C773.537964,460.603485 771.585876,459.739410 769.411743,459.985382 
	C770.355652,457.322083 772.645935,459.084747 774.802124,458.962830 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M764.076599,408.031311 
	C762.002808,407.703979 759.762878,408.509308 757.423218,407.101440 
	C756.730225,405.163239 757.406616,404.023468 759.086182,403.507843 
	C765.200623,401.630615 771.537598,400.925995 777.833557,400.029694 
	C779.144775,399.843048 780.012512,400.583221 780.094116,402.418335 
	C777.193909,404.390167 774.051636,405.352112 770.412354,406.003662 
	C768.019714,406.016998 766.268738,406.906281 764.237000,407.846069 
	C764.007385,408.074860 764.045288,408.012543 764.076599,408.031311 
z"/>
<path fill="#8496B5" opacity="1.000000" stroke="none" 
	d="
M756.542480,395.493683 
	C756.575745,395.546814 756.509155,395.440552 756.542480,395.493683 
z"/>
<path fill="#728BA1" opacity="1.000000" stroke="none" 
	d="
M764.374817,408.056824 
	C765.144348,405.607971 767.378174,405.547211 769.825928,405.768066 
	C768.265625,406.694336 766.503906,407.366547 764.374817,408.056824 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M705.185791,373.914124 
	C704.729248,375.876526 703.737366,377.186401 701.297852,377.061188 
	C701.906250,375.834869 702.872498,374.718933 704.000061,373.324585 
	C704.445435,373.265015 704.729431,373.483856 705.185791,373.914124 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M778.640015,481.830414 
	C778.018982,483.851868 775.030212,481.904297 774.273560,484.752533 
	C773.388062,484.993866 772.605774,484.895874 771.427490,484.787537 
	C770.712097,483.810486 770.392883,482.843750 770.117676,481.564941 
	C772.864746,481.393646 775.567810,481.534424 778.640015,481.830414 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M647.004639,660.666443 
	C645.632141,659.830139 645.153503,658.213684 644.936707,656.082458 
	C646.687012,656.738403 647.085632,658.404358 647.004639,660.666443 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M644.992920,655.089111 
	C644.654907,654.860535 644.315613,654.269226 643.972168,653.334106 
	C644.309204,653.568970 644.650391,654.147705 644.992920,655.089111 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M643.979919,652.713135 
	C643.660339,652.549316 643.327515,652.065369 642.915588,651.279663 
	C643.213196,651.449585 643.589966,651.921326 643.979919,652.713135 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M640.476440,638.444702 
	C640.529175,638.411804 640.423645,638.477661 640.476440,638.444702 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M636.009155,653.700073 
	C635.675171,653.539856 635.344055,653.069946 635.003418,652.295593 
	C635.333374,652.457581 635.672791,652.923950 636.009155,653.700073 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M765.867310,562.990112 
	C765.730835,564.267944 765.432861,565.393860 764.514038,564.995972 
	C763.335693,564.485718 763.605530,563.047791 763.746765,561.949219 
	C763.840820,561.216919 763.830750,560.054749 764.962524,560.206787 
	C766.362976,560.394897 765.806213,561.677185 765.867310,562.990112 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M737.146729,434.154144 
	C737.411743,433.229309 737.986328,433.501495 738.735168,433.741699 
	C738.601257,434.666199 738.100769,434.992645 737.146729,434.154144 
z"/>
<path fill="#B87874" opacity="1.000000" stroke="none" 
	d="
M570.811157,808.090454 
	C570.903442,808.928223 570.635254,809.718445 569.265137,809.726074 
	C569.136108,808.812561 569.558411,808.195618 570.811157,808.090454 
z"/>
<path fill="#AF646C" opacity="1.000000" stroke="none" 
	d="
M553.609009,789.222046 
	C553.027405,788.852295 552.324280,788.557617 553.182983,788.167908 
	C553.511658,788.018860 554.275574,788.239624 554.482178,788.539307 
	C554.853577,789.078186 554.533264,789.445801 553.609009,789.222046 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M544.888306,790.807495 
	C544.729492,790.839233 544.462158,790.650208 544.100342,790.228394 
	C544.317322,790.122681 544.575256,790.319763 544.888306,790.807495 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M597.024597,702.024414 
	C597.044556,702.986755 597.044556,703.930847 597.044556,705.054016 
	C595.456421,704.180603 596.102234,703.262756 596.710815,702.176880 
	C596.960999,701.974182 597.004639,702.006226 597.024597,702.024414 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M601.013916,706.013794 
	C600.887817,706.743530 600.748962,707.460938 600.610107,708.178406 
	C599.698853,707.610779 600.143372,706.955566 600.730835,706.144043 
	C600.972412,705.981323 601.001160,706.001587 601.013916,706.013794 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M602.255371,711.625488 
	C602.011719,711.611023 601.878418,711.478638 601.745117,711.346313 
	C601.951965,711.400024 602.158875,711.453735 602.255371,711.625488 
z"/>
<path fill="#8194B1" opacity="1.000000" stroke="none" 
	d="
M615.131958,703.945923 
	C615.088013,703.963989 615.175964,703.927917 615.131958,703.945923 
z"/>
<path fill="#0D040D" opacity="1.000000" stroke="none" 
	d="
M819.218445,887.487488 
	C828.484802,887.353821 837.563171,887.677368 847.157715,888.067749 
	C848.174072,890.947205 845.940247,889.906860 844.848511,889.934692 
	C839.860352,890.062256 834.867249,889.994080 829.455933,890.038879 
	C825.820374,888.809143 821.695435,891.794922 819.218445,887.487488 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M400.983185,851.701782 
	C399.865479,852.022095 398.896118,852.379639 398.133789,853.702393 
	C397.051666,853.613647 396.250153,853.108154 396.241425,851.928894 
	C397.862427,852.188293 399.069611,848.804565 400.983185,851.701782 
z"/>
<path fill="#B3676E" opacity="1.000000" stroke="none" 
	d="
M386.720581,857.004639 
	C387.641388,857.418213 387.993073,857.932983 387.239899,858.853333 
	C386.855988,859.005798 386.686340,859.004456 386.262207,859.004639 
	C385.605621,858.642273 385.459167,858.194702 385.767334,857.345581 
	C386.134430,857.023743 386.301971,857.019836 386.720581,857.004639 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M389.785217,851.191650 
	C389.948029,851.838562 389.772064,852.573975 389.596069,853.309448 
	C388.785034,852.689148 389.078857,851.987366 389.785217,851.191650 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M384.735382,859.041382 
	C384.657654,859.506836 384.227875,859.921997 383.798096,860.337097 
	C383.645538,860.152283 383.492981,859.967468 383.340393,859.782715 
	C383.688049,859.518860 384.035675,859.254944 384.735382,859.041382 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M402.816223,849.146423 
	C402.958252,849.556946 402.741302,849.963867 402.524353,850.370789 
	C401.961914,849.990967 402.142548,849.570496 402.816223,849.146423 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M386.370789,854.261597 
	C386.383331,854.005615 386.511322,853.868774 386.639343,853.731934 
	C386.588318,853.948181 386.537262,854.164490 386.370789,854.261597 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M382.963928,853.219910 
	C383.094421,853.402283 383.037689,853.580322 382.980957,853.758362 
	C382.912872,853.577454 382.844788,853.396484 382.963928,853.219910 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M385.718506,857.173035 
	C385.980957,857.467041 385.995026,857.906433 386.008423,858.675964 
	C386.007751,859.006104 385.546265,859.047607 385.316864,859.069702 
	C385.087463,859.091736 385.008698,859.009888 384.967712,858.968628 
	C385.107819,858.391052 385.288940,857.854736 385.718506,857.173035 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M402.934021,848.915405 
	C403.087341,848.679443 403.407074,847.992065 403.314301,849.041992 
	C403.175232,849.150085 403.011017,848.997070 402.934021,848.915405 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M392.445068,852.431396 
	C392.521393,852.377075 392.544861,852.590027 392.544861,852.590027 
	C392.544861,852.590027 392.368713,852.485657 392.445068,852.431396 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M389.966095,850.953491 
	C390.078888,850.848694 390.275696,850.024780 390.260010,851.012451 
	C390.123993,851.103088 390.015808,851.006348 389.966095,850.953491 
z"/>
<path fill="#A2555E" opacity="1.000000" stroke="none" 
	d="
M393.442261,855.400513 
	C393.519623,855.341553 393.547668,855.563599 393.547668,855.563599 
	C393.547668,855.563599 393.364868,855.459473 393.442261,855.400513 
z"/>
<path fill="#834649" opacity="1.000000" stroke="none" 
	d="
M384.535583,855.588013 
	C384.442383,855.648865 384.403107,855.408997 384.403107,855.408997 
	C384.403107,855.408997 384.628784,855.527161 384.535583,855.588013 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M816.719604,451.978790 
	C816.753479,456.417328 821.033447,453.609039 822.619141,455.702332 
	C816.343933,457.940948 810.178162,454.083221 803.778015,455.247375 
	C802.702515,455.442993 801.060547,454.999359 801.010986,452.809052 
	C803.204956,450.226349 806.098694,453.320465 808.615601,451.290039 
	C809.769043,451.369812 810.674255,451.688599 811.937439,452.057434 
	C813.384216,452.876282 814.548218,452.677490 815.944458,452.167053 
	C816.168457,451.960754 816.535706,451.980988 816.719604,451.978790 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M808.487427,450.977295 
	C807.304138,455.909851 804.090393,451.813538 801.364990,452.419983 
	C798.908325,450.678772 794.036560,453.303253 794.217224,450.204132 
	C794.346069,447.993835 798.710510,450.681976 801.299622,450.257965 
	C803.476501,449.901550 805.833740,450.646301 808.487427,450.977295 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M806.044678,446.473541 
	C809.658691,445.386292 813.079285,446.939880 816.851929,447.622681 
	C813.330872,448.359161 809.553040,449.040863 806.044678,446.473541 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M817.255127,448.203552 
	C820.327454,447.560699 823.406738,448.736877 826.799194,449.669312 
	C823.722778,450.301910 820.578125,449.590729 817.255127,448.203552 
z"/>
<path fill="#C7B3E1" opacity="1.000000" stroke="none" 
	d="
M815.781189,451.865417 
	C815.422363,455.127960 813.686829,453.196991 812.264832,452.415894 
	C813.328186,451.995026 814.361084,451.882568 815.781189,451.865417 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M802.009521,446.151794 
	C802.136719,445.548370 802.386169,445.444427 802.884888,445.798004 
	C802.919983,446.411682 802.920715,447.132080 802.697815,447.209625 
	C802.080566,447.424347 802.093689,446.800110 802.009521,446.151794 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M814.774780,481.810486 
	C814.065491,483.824799 813.099609,484.065674 812.002991,481.936920 
	C812.805298,481.515350 813.630859,480.658752 814.774780,481.810486 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M809.760376,481.198059 
	C809.879456,481.564545 809.734497,481.970856 809.589478,482.377167 
	C809.400452,482.177032 809.211365,481.976929 808.995911,481.551178 
	C809.145142,481.296295 809.320801,481.267090 809.760376,481.198059 
z"/>
<path fill="#46486B" opacity="1.000000" stroke="none" 
	d="
M807.924805,480.807007 
	C808.001648,480.999695 807.547119,481.029694 807.319397,481.029663 
	C807.235413,480.693970 807.229370,480.085480 807.924805,480.807007 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M874.180542,341.764465 
	C871.552856,339.651245 871.230835,332.336426 873.439209,330.769653 
	C874.642212,329.916077 875.149414,330.958160 875.799011,331.676544 
	C878.550293,334.719238 878.440918,338.522339 877.820312,342.028656 
	C877.243896,345.285400 875.618591,342.725739 874.180542,341.764465 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M874.975403,313.460632 
	C878.042725,314.149323 881.115417,315.163116 884.570923,316.138977 
	C885.876526,317.716187 886.069031,319.475708 885.908447,321.671631 
	C884.947266,321.795990 884.057922,321.539612 882.988403,320.978088 
	C878.850281,320.307953 875.264954,318.655396 871.251587,317.215820 
	C870.943298,317.015320 871.000793,317.000641 870.996216,317.029968 
	C870.839111,316.917145 870.686646,316.774933 870.715515,316.377991 
	C871.910217,314.736115 875.137085,317.216278 874.975403,313.460632 
z"/>
<path fill="#7D2A70" opacity="1.000000" stroke="none" 
	d="
M820.613159,307.286194 
	C820.891357,305.893036 820.923462,304.890991 821.035339,303.520782 
	C821.603455,302.391968 822.357544,302.517517 823.352905,302.818451 
	C823.728882,304.728210 824.317078,306.526611 823.865295,308.007874 
	C822.080688,313.858521 824.967407,314.148376 829.722107,313.069458 
	C827.764893,315.466003 824.823975,314.977478 821.574707,314.853394 
	C821.083862,314.083801 820.999939,313.400299 820.855652,312.371155 
	C819.805176,310.659546 819.590820,309.217194 820.613159,307.286194 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M825.714905,320.017517 
	C832.857117,318.310883 839.739441,316.295227 846.677429,314.442841 
	C840.535828,318.327423 833.672302,319.757172 826.358643,320.983459 
	C825.833496,320.718506 825.717529,320.526428 825.714905,320.017517 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M870.918701,317.397522 
	C875.064392,316.923767 878.330017,319.681061 882.508301,320.535492 
	C878.338623,321.760651 874.783142,319.083374 870.918701,317.397522 
z"/>
<path fill="#E6ECEB" opacity="1.000000" stroke="none" 
	d="
M825.452026,319.555389 
	C825.790527,319.990906 825.853882,320.257050 825.983887,320.704834 
	C824.857422,321.001709 823.765381,321.092834 822.355713,320.916931 
	C822.139893,320.380280 822.175720,320.102142 822.093384,319.610413 
	C823.054199,318.518005 824.064636,319.196411 825.452026,319.555389 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M870.529541,316.031799 
	C870.896912,316.123230 870.963318,316.589325 870.977417,316.824341 
	C870.176331,317.447968 869.526978,317.257904 869.040344,316.500031 
	C869.414246,316.313477 869.788208,316.126923 870.529541,316.031799 
z"/>
<path fill="#E19BD3" opacity="1.000000" stroke="none" 
	d="
M869.904541,298.505737 
	C870.029663,298.673096 869.544800,298.713593 869.544800,298.713593 
	C869.544800,298.713593 869.149170,298.430298 869.095947,298.191589 
	C869.322449,298.016113 869.568054,298.144623 869.904541,298.505737 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M842.318970,270.713715 
	C842.041138,271.267059 841.983154,271.512421 841.784546,272.108887 
	C839.565613,273.779816 837.333435,273.449036 834.707886,272.951965 
	C828.659424,270.643463 822.971130,270.346252 816.881165,272.740448 
	C812.787292,273.880280 809.010010,273.533386 804.874023,273.240723 
	C803.080200,272.969421 801.900269,271.315033 799.927185,272.554749 
	C798.932129,272.828247 798.269836,272.782867 797.370361,272.252777 
	C796.634766,272.275726 796.163879,272.516052 795.458862,272.884644 
	C789.412964,273.947723 783.601257,273.882721 777.359863,272.817139 
	C772.644897,267.092224 773.612854,259.475555 779.417969,256.210510 
	C784.288757,255.038116 788.797913,255.713638 793.714233,255.511597 
	C795.040955,255.514481 795.897461,255.348541 797.165588,254.976242 
	C804.342957,254.720184 810.994080,256.329010 818.185669,255.892395 
	C819.193726,255.700043 819.773376,255.624100 820.797058,255.590424 
	C827.002747,255.569031 832.676941,256.870239 838.842957,256.930084 
	C844.668518,260.056274 844.943787,261.170776 842.318970,270.713715 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M779.631958,256.733063 
	C775.655212,259.269196 774.704773,263.709839 777.070923,271.973633 
	C778.458740,273.884979 778.396790,275.609558 778.031006,277.740234 
	C777.935425,278.699951 777.905334,279.291992 777.917236,280.178772 
	C778.121460,282.265411 778.719788,283.978638 778.932617,286.102234 
	C778.926147,286.964661 778.901245,287.489685 778.913940,288.276489 
	C779.096191,290.002136 778.125061,291.300354 778.345215,293.084442 
	C778.459473,294.451416 778.520264,295.506683 778.415710,296.880646 
	C778.362488,298.252197 778.513245,299.283020 778.891418,300.604797 
	C779.010681,301.125641 779.050232,301.335907 779.128662,301.864502 
	C779.236511,303.023743 779.223999,303.871613 779.445435,305.011902 
	C780.228333,306.729034 780.356140,308.121246 779.330811,309.782806 
	C781.711853,313.029572 784.702942,310.978760 787.465454,311.012604 
	C790.074036,311.044525 793.448425,309.695801 793.499390,314.618103 
	C790.007385,316.358154 786.381958,315.711731 782.922546,316.334625 
	C781.164795,316.651154 779.275757,316.547729 778.597900,319.119476 
	C778.531189,320.169037 778.600342,320.879395 778.265381,321.900574 
	C776.976440,323.866211 776.334045,325.496979 778.559448,327.152405 
	C779.304626,327.543732 779.486938,327.953400 779.215454,328.747314 
	C774.153503,331.280396 774.140381,331.280640 774.039429,325.730957 
	C773.968140,321.819580 773.938599,317.907471 773.836914,313.535278 
	C772.215637,311.012634 772.708679,308.586334 772.573975,305.841461 
	C772.684143,300.939056 771.250549,296.639557 771.159668,291.796478 
	C772.621643,289.292236 772.770203,286.944519 772.593018,284.122253 
	C772.561829,283.143036 772.559326,282.575958 772.570312,281.563843 
	C772.474670,276.163391 772.957458,271.185699 771.749756,266.276581 
	C771.397583,264.845306 771.541382,263.301025 771.675964,261.814575 
	C772.126404,256.839294 774.091125,255.457413 779.631958,256.733063 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M818.391724,279.217163 
	C818.856445,280.836884 818.875183,282.410126 818.877502,284.376465 
	C812.755249,284.772705 806.649353,284.799286 800.543762,284.761810 
	C799.090332,284.752899 797.114990,285.793488 796.891296,282.948517 
	C796.659363,280.000031 798.447754,279.846924 800.608521,279.787415 
	C806.388855,279.628326 812.166809,279.382233 818.391724,279.217163 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M817.774536,312.638977 
	C818.278259,314.270111 818.438904,315.583954 818.658325,317.225647 
	C811.998474,317.656738 805.277344,317.680786 798.562317,317.895386 
	C795.002380,318.009216 796.304810,315.599518 796.352905,313.450897 
	C796.718140,312.815308 796.937378,312.590332 797.580688,312.160583 
	C804.490479,311.541138 810.979675,310.937042 817.774536,312.638977 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M812.360168,349.940186 
	C811.838013,349.959900 811.998108,349.984833 812.036621,349.972534 
	C807.595703,349.937866 803.116150,349.901825 798.636658,349.900970 
	C797.190552,349.900696 796.027771,349.777100 795.999817,347.841949 
	C795.972046,345.924377 796.693909,345.250977 798.635925,345.247864 
	C804.774719,345.238037 810.913208,345.058258 817.517517,344.985229 
	C819.669128,350.186829 816.466736,350.252747 812.360168,349.940186 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M818.474976,288.027161 
	C818.831421,289.726318 818.737671,291.305328 818.331055,293.128967 
	C811.670166,295.277618 805.264343,294.592041 798.444702,293.541901 
	C796.191833,290.380096 795.321045,287.951080 800.340393,287.975433 
	C806.234924,288.004028 812.129883,287.934174 818.474976,288.027161 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M797.082031,272.483337 
	C797.845337,271.935486 798.585022,271.835571 799.680237,271.620056 
	C800.738342,271.200928 801.466248,271.059296 802.598755,271.245270 
	C807.357544,271.447083 811.749939,271.565033 816.588501,271.537415 
	C819.799133,271.352081 820.149109,272.996460 819.460327,275.615845 
	C819.163879,276.187714 819.100159,276.346863 819.005188,276.761719 
	C813.061890,277.016846 807.123962,276.682465 801.247131,277.137268 
	C797.555603,277.422974 796.462097,276.328400 797.082031,272.483337 
z"/>
<path fill="#0D0612" opacity="1.000000" stroke="none" 
	d="
M778.429932,278.029388 
	C776.134705,276.705627 777.295166,274.800690 777.207031,272.739380 
	C783.096497,272.333710 788.906189,272.307709 794.970337,272.647278 
	C795.497070,276.692047 794.013245,278.199463 790.142700,277.868988 
	C786.422729,277.551392 782.646118,277.896820 778.429932,278.029388 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M818.485596,301.049042 
	C818.776184,302.363220 818.670044,303.517517 818.295654,304.901123 
	C811.564514,305.153687 805.099976,305.106689 798.639832,305.252594 
	C797.138489,305.286530 796.088684,305.472260 795.970337,303.504303 
	C795.864014,301.736023 796.231934,300.822174 798.257019,300.618866 
	C804.888062,299.953156 811.487671,300.124115 818.485596,301.049042 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M796.872253,312.839203 
	C796.441406,313.032928 796.462830,313.027649 796.480835,313.033997 
	C795.663818,307.153900 795.663696,307.143341 801.738464,307.083893 
	C806.858215,307.033783 811.978210,307.012054 817.564148,306.907867 
	C818.030151,306.837982 818.419617,307.002838 818.627502,307.041595 
	C821.108948,310.813843 818.992859,311.788605 815.726257,311.971405 
	C809.589905,312.314850 803.405151,311.343994 796.872253,312.839203 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M779.401428,286.307495 
	C776.308472,285.248688 777.378540,283.027313 777.711304,280.776398 
	C782.280396,280.397980 786.601501,280.323700 790.922668,280.246429 
	C792.939087,280.210388 794.887695,279.887268 794.943542,283.069214 
	C794.996948,286.110260 793.005127,285.592682 791.313782,285.687561 
	C787.496033,285.901733 783.672791,286.018799 779.401428,286.307495 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M777.452759,294.131927 
	C777.425476,292.145477 776.006042,290.074524 778.566772,288.659546 
	C783.088318,288.413391 787.237549,288.442902 791.357849,288.112671 
	C794.426575,287.866730 795.143372,289.279541 794.830933,292.300659 
	C789.414856,295.528290 783.633484,295.153381 777.452759,294.131927 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M817.703796,319.870605 
	C818.136963,321.059143 818.099731,322.141541 817.930603,323.608795 
	C817.647827,324.178436 817.496948,324.363251 817.074829,324.314545 
	C811.001099,324.225922 805.183350,323.842346 799.399780,324.691528 
	C797.679993,324.944000 796.173645,324.845062 796.052063,322.349274 
	C795.919861,319.634705 797.682739,319.953308 799.300232,319.932831 
	C805.277710,319.857178 811.255615,319.817627 817.703796,319.870605 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M817.617004,338.563721 
	C818.534790,339.886993 818.836975,341.078125 818.251221,342.754486 
	C811.726868,343.149902 805.414551,343.140076 799.102478,343.103699 
	C797.866089,343.096588 796.284912,343.673309 796.047852,341.603363 
	C795.866394,340.018280 796.394714,339.012299 798.583130,339.011078 
	C804.976318,336.539337 811.054199,337.165527 817.617004,338.563721 
z"/>
<path fill="#0F0E23" opacity="1.000000" stroke="none" 
	d="
M816.896729,324.501343 
	C816.803650,324.081055 817.299683,324.020721 817.549194,324.007202 
	C818.049561,325.927795 818.300415,327.861938 818.309204,330.074097 
	C811.014099,331.623047 803.953125,332.754456 796.387573,331.270508 
	C795.513367,328.192108 796.246277,326.781891 799.511597,326.829071 
	C804.463074,326.900604 809.422241,326.495422 814.376648,326.261353 
	C815.420410,326.212097 816.838562,326.764099 816.896729,324.501343 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M792.866943,315.043823 
	C793.641602,311.951996 791.676697,312.214935 790.020569,312.317719 
	C786.744385,312.520966 783.469238,312.765533 780.201416,313.074036 
	C777.183289,313.359009 776.900330,311.755493 777.758606,309.104187 
	C782.608215,306.721558 787.672668,307.184540 792.825012,306.133301 
	C793.376038,305.914734 793.605408,305.849365 794.184021,305.861084 
	C795.313965,308.648895 794.774780,311.401062 794.696411,314.583405 
	C794.161743,315.365265 793.674377,315.462341 792.866943,315.043823 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M816.649414,331.655273 
	C818.941589,332.592773 818.031311,334.257019 818.201538,335.932037 
	C812.080872,338.019501 805.927124,337.891632 799.347900,337.473450 
	C796.006531,337.948792 795.695435,336.215820 796.015198,333.598816 
	C799.472473,330.916504 803.374756,332.181580 806.993164,331.618347 
	C810.000549,331.150208 813.151367,331.415405 816.649414,331.655273 
z"/>
<path fill="#170D21" opacity="1.000000" stroke="none" 
	d="
M792.244141,314.687408 
	C793.038147,314.842163 793.482178,314.919067 794.264038,315.013489 
	C794.596069,315.764557 794.590210,316.498077 794.468140,317.582550 
	C794.110718,318.488373 793.768433,318.971680 792.925903,319.583191 
	C787.573730,319.721710 782.706970,321.881744 777.452515,319.994202 
	C776.788208,316.642517 777.766663,314.872986 781.090393,314.865295 
	C784.691772,314.856964 788.292908,314.701111 792.244141,314.687408 
z"/>
<path fill="#140B1D" opacity="1.000000" stroke="none" 
	d="
M778.416870,301.157349 
	C777.825623,299.907196 777.565979,298.934265 777.267456,297.654541 
	C779.483643,294.430908 782.854919,294.762238 785.924194,294.586792 
	C788.719666,294.427032 791.558777,294.167023 794.592041,295.062683 
	C794.737732,296.814972 794.657043,298.178070 794.230408,299.762604 
	C793.681091,300.193787 793.477783,300.403564 792.884521,300.812469 
	C787.927490,301.639221 783.334900,301.435242 778.416870,301.157349 
z"/>
<path fill="#100816" opacity="1.000000" stroke="none" 
	d="
M792.909241,300.204651 
	C793.258362,299.944702 793.677185,300.013153 793.780823,299.998596 
	C794.787170,301.581512 795.063660,303.286499 794.647095,305.514557 
	C794.533325,305.938202 794.479675,305.889923 794.449219,305.909363 
	C789.242126,307.505737 784.017944,307.553009 778.414062,306.133759 
	C777.575623,304.858337 777.291138,303.834991 777.824585,302.360352 
	C782.683472,299.844086 787.813721,301.978394 792.909241,300.204651 
z"/>
<path fill="#0B071D" opacity="1.000000" stroke="none" 
	d="
M817.923645,295.681152 
	C818.374939,296.127228 818.473389,296.295349 818.491089,296.744385 
	C817.700562,297.198029 817.507690,297.748505 817.205322,298.594971 
	C811.971680,298.854462 806.954834,298.896454 801.474365,298.887787 
	C800.040588,297.815338 799.971436,296.643311 800.710815,295.013245 
	C805.738220,293.330292 810.577515,294.244812 815.818359,294.152588 
	C816.841736,294.462433 817.278076,294.852631 817.923645,295.681152 
z"/>
<path fill="#9D90A3" opacity="1.000000" stroke="none" 
	d="
M817.206604,331.696594 
	C810.450989,333.270660 803.708923,332.720245 796.581360,333.226440 
	C796.083313,332.706268 796.045349,332.213776 796.011169,331.350739 
	C803.064148,331.089844 810.060974,329.608734 817.598022,330.318909 
	C817.829285,330.739349 817.591431,331.126648 817.206604,331.696594 
z"/>
<path fill="#8E99A4" opacity="1.000000" stroke="none" 
	d="
M798.948120,337.553467 
	C804.986877,336.542389 811.055237,336.022217 817.635254,336.356598 
	C818.046570,336.983307 817.044067,337.568878 818.039062,338.488525 
	C812.025818,338.851410 805.968018,338.991364 799.448730,339.039459 
	C798.980652,338.576141 798.973999,338.204712 798.948120,337.553467 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M794.869019,294.995056 
	C789.266479,296.588867 783.473816,295.171143 777.609619,297.192749 
	C777.155396,296.381134 777.891052,295.391052 777.116699,294.140320 
	C782.780823,294.064270 788.408569,292.382111 794.497681,292.984070 
	C794.888428,293.315033 794.903992,293.926666 794.869019,294.995056 
z"/>
<path fill="#D6CCDE" opacity="1.000000" stroke="none" 
	d="
M817.332764,295.294800 
	C811.987488,295.217773 806.964233,295.156097 801.481262,295.173035 
	C800.250549,295.775604 799.442017,295.787262 798.313721,295.121490 
	C798.030029,294.474060 798.039001,294.133575 798.040649,293.537720 
	C804.392029,292.333466 810.771057,292.698059 817.583496,293.180786 
	C818.055542,293.689423 818.070068,294.006287 818.055237,294.562073 
	C817.917480,294.970001 817.786133,295.140076 817.332764,295.294800 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M797.628662,294.971375 
	C798.771912,294.912659 799.522705,295.010834 800.647583,295.180298 
	C801.008972,296.207825 800.996277,297.164062 800.997070,298.478699 
	C798.237122,299.142975 795.525330,299.386017 797.628662,294.971375 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M794.735962,361.981476 
	C794.339478,361.254883 794.313049,360.493225 794.356567,359.354736 
	C794.868713,359.051392 795.311035,359.124908 796.071594,359.311829 
	C796.389648,360.008423 796.389404,360.591644 796.484741,361.461853 
	C796.088867,361.814728 795.597473,361.880585 794.735962,361.981476 
z"/>
<path fill="#211D35" opacity="1.000000" stroke="none" 
	d="
M792.800171,319.117035 
	C793.337952,318.541992 793.638428,318.272949 794.145447,317.968719 
	C794.869690,318.831268 794.545288,319.617584 793.933472,320.693909 
	C793.667908,320.993347 793.497253,320.977234 793.071411,320.929688 
	C792.524048,320.442230 792.439453,319.950500 792.800171,319.117035 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M817.316040,298.880615 
	C817.262024,298.276489 817.535583,297.740570 818.109741,297.114960 
	C818.463196,297.476593 818.516052,297.927917 818.438721,298.700684 
	C818.086914,298.997711 817.865234,298.973236 817.316040,298.880615 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M772.167236,291.170898 
	C773.034668,295.516113 774.165527,299.495483 774.056946,304.086182 
	C772.213257,306.877899 773.513794,309.811066 772.516724,312.748962 
	C772.303223,322.400665 772.254761,331.679626 772.152466,341.408173 
	C771.908691,341.883331 771.718750,341.908905 771.253052,342.015533 
	C764.299744,341.830231 757.609924,341.342163 750.640198,343.246155 
	C750.292114,340.154663 752.703613,340.130646 754.811951,340.050537 
	C758.457214,339.912048 762.120972,339.852295 765.759338,340.063690 
	C768.994568,340.251678 770.127563,339.083771 770.070068,335.803741 
	C769.901245,326.182465 770.010864,316.556244 770.009033,306.462952 
	C767.373230,302.308105 768.632812,298.175476 768.718567,293.729248 
	C770.392395,289.189056 767.920349,285.249451 768.373169,281.164490 
	C768.713989,278.089203 768.343811,274.951813 768.505920,271.391510 
	C768.915527,265.903839 766.978882,260.628387 770.492798,255.719543 
	C771.530640,255.553726 772.020020,255.797546 772.474243,256.718292 
	C772.599976,257.913025 772.135803,258.679291 772.474854,259.895325 
	C772.686096,267.379242 772.755188,274.458710 773.787048,281.840393 
	C774.060608,282.536194 774.070312,282.895630 774.069214,283.524658 
	C772.107483,285.801056 773.726257,288.664642 772.167236,291.170898 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M792.584106,318.732056 
	C793.016479,319.278229 792.995422,319.745422 792.895325,320.555450 
	C788.214294,321.365784 783.612305,321.833282 778.565308,322.263977 
	C777.823669,321.593536 777.527100,320.959839 777.219482,319.976349 
	C782.245850,320.273560 787.161804,319.057953 792.584106,318.732056 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M779.429688,329.080627 
	C778.973511,328.630829 778.949463,328.227661 778.922302,327.521301 
	C782.614746,326.560150 786.305847,325.875305 790.008850,325.262329 
	C790.989563,325.099976 792.490967,324.072083 792.775574,325.864777 
	C793.055481,327.628174 791.453125,327.798157 790.109131,327.949188 
	C786.692383,328.333069 783.277405,328.733490 779.429688,329.080627 
z"/>
<path fill="#454563" opacity="1.000000" stroke="none" 
	d="
M772.589722,313.160889 
	C772.260925,310.055267 771.076294,306.896149 773.583557,304.247925 
	C774.012939,307.041229 773.982666,309.597595 773.867920,312.614410 
	C773.465149,313.118317 773.146545,313.160065 772.589722,313.160889 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M749.307861,363.225311 
	C749.022888,362.608582 749.015137,362.204651 749.022827,361.497986 
	C749.842041,360.084473 751.025635,360.655884 752.429199,360.664551 
	C753.990723,361.852966 756.940796,359.302582 756.745850,363.148560 
	C755.801575,364.212250 754.619934,364.423218 753.440308,365.749817 
	C751.043579,366.156281 749.558228,365.731018 749.307861,363.225311 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M757.110596,365.325989 
	C756.704163,366.602173 755.819946,366.794739 754.418762,366.941833 
	C753.641602,366.935486 753.372192,366.773743 753.026733,366.325439 
	C752.900513,366.122681 753.092896,365.871033 753.188599,365.744843 
	C754.311829,364.176025 755.517517,363.761078 757.110596,365.325989 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M796.947388,313.052765 
	C800.725769,310.063324 805.579895,311.421936 810.226501,311.234344 
	C812.208984,311.154266 814.224365,310.961090 816.173828,311.213623 
	C819.025940,311.582977 819.118591,309.979919 818.879700,307.521423 
	C819.286011,307.048859 819.736633,307.017395 820.523315,306.940491 
	C820.921448,308.330109 820.983643,309.765076 820.920532,311.612793 
	C820.080750,312.262634 819.366272,312.499756 818.384644,312.846558 
	C811.229492,312.995026 804.341431,313.033813 796.947388,313.052765 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M803.282227,374.641205 
	C804.415894,373.828278 805.537354,373.055634 806.583496,373.906525 
	C808.012207,375.068573 806.318970,375.963531 805.930481,376.789032 
	C805.225464,378.287628 804.585754,380.040558 802.741028,380.849030 
	C801.728394,378.645233 803.794250,376.935883 803.282227,374.641205 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M757.555908,365.992981 
	C756.159851,364.582031 755.001160,364.730988 753.542053,365.507690 
	C752.623413,363.071198 754.242798,363.113647 756.276489,363.367035 
	C760.668579,364.345978 764.696045,362.146271 768.846313,363.374664 
	C767.683716,364.634430 765.633057,363.114380 764.329102,365.144012 
	C767.149719,364.604675 769.537720,366.768311 772.523376,365.145203 
	C773.165283,366.654602 773.471619,368.187683 771.017761,367.903595 
	C766.640686,367.396881 762.122742,368.051483 757.555908,365.992981 
z"/>
<path fill="#B23E74" opacity="1.000000" stroke="none" 
	d="
M787.667786,377.484314 
	C784.913452,376.816650 786.660828,374.869598 786.270996,373.484344 
	C786.083252,372.817596 786.735596,372.215179 787.438110,372.194427 
	C788.358032,372.167175 788.988586,372.820435 789.116821,373.673218 
	C789.318970,375.018005 788.941895,376.267273 787.667786,377.484314 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M794.519531,374.329285 
	C794.230469,375.843262 796.925781,378.845673 792.467224,378.983917 
	C790.926086,378.544373 790.516907,377.346375 791.828674,377.269440 
	C794.080078,377.137482 793.799927,375.647705 794.519531,374.329285 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M790.349792,358.792114 
	C789.986633,358.095428 789.994568,357.474884 789.992188,356.544128 
	C791.298828,356.024811 792.577393,355.947845 793.495728,357.634277 
	C792.721741,358.718445 791.769165,358.952820 790.349792,358.792114 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M833.322083,374.146606 
	C833.350830,372.740723 834.423828,373.029053 835.687866,372.957550 
	C835.579956,374.004761 834.649841,374.199524 833.322083,374.146606 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M821.439331,384.891327 
	C821.032593,383.045929 821.024353,381.300659 821.073181,379.117676 
	C821.780212,378.721924 822.429626,378.786804 823.080200,378.802399 
	C829.898071,378.966003 830.145020,379.219025 830.088623,386.565094 
	C827.482788,385.518707 824.783752,384.751923 821.439331,384.891327 
z"/>
<path fill="#EEE5ED" opacity="1.000000" stroke="none" 
	d="
M930.452393,287.621674 
	C929.682556,282.784271 930.494568,277.852844 929.256104,272.629852 
	C927.975403,268.333954 928.809692,264.329651 928.604614,259.956543 
	C928.621399,258.969391 928.683411,258.411285 928.875305,257.448364 
	C929.010193,255.921051 929.445251,254.874649 929.756470,253.402435 
	C929.980164,252.514648 930.009827,251.993744 930.053223,251.081741 
	C931.121460,250.940857 932.176025,251.191071 933.593201,251.628998 
	C935.813171,260.550415 934.575317,269.406128 934.984863,278.197174 
	C935.077698,280.190887 935.016724,282.191742 935.087646,284.663635 
	C934.289734,286.982758 932.327698,286.884735 930.452393,287.621674 
z"/>
<path fill="#1B1831" opacity="1.000000" stroke="none" 
	d="
M971.638428,354.931641 
	C971.300598,355.974182 970.425537,356.128265 969.195618,355.307556 
	C969.747925,355.009735 970.505188,354.932251 971.638428,354.931641 
z"/>
<path fill="#1E0D21" opacity="1.000000" stroke="none" 
	d="
M899.309692,242.254761 
	C899.004333,240.201202 898.883667,238.462967 898.879761,236.301422 
	C907.733887,238.217224 916.471191,240.556335 925.593811,242.914337 
	C926.822266,244.926865 927.868713,246.929459 925.366821,248.875687 
	C923.500793,249.858398 921.921753,249.369339 919.973145,249.078033 
	C919.096008,248.747803 918.672852,248.433487 918.272034,247.629852 
	C913.816162,246.049210 909.407898,244.863708 904.617188,243.601257 
	C902.438110,244.281525 900.927124,243.620224 899.309692,242.254761 
z"/>
<path fill="#DFC4CB" opacity="1.000000" stroke="none" 
	d="
M898.967346,234.636261 
	C898.132507,234.977600 897.356812,234.783447 896.927368,233.521118 
	C897.803894,233.057968 898.584839,233.248184 898.967346,234.636261 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M918.310791,261.261658 
	C917.955872,260.615509 917.894409,260.135223 917.723022,259.308594 
	C918.421265,257.875488 919.480896,258.542419 921.051270,258.339417 
	C923.711182,258.681427 926.071960,257.748993 928.127930,259.651764 
	C928.536926,260.314850 928.626282,260.747833 928.505310,261.521881 
	C928.120239,262.195038 927.764893,262.436066 926.999756,262.517700 
	C926.205811,262.772858 926.578125,261.603333 926.200195,262.323181 
	C926.439453,262.771820 926.461792,262.986847 926.370850,263.510315 
	C925.802307,264.381531 925.197327,264.594666 924.160339,264.502655 
	C921.905518,263.745148 920.213501,262.658295 918.310791,261.261658 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M929.462402,256.982300 
	C929.513550,257.625214 929.408569,257.947479 929.409363,258.502258 
	C929.413086,258.935364 929.311096,259.135895 928.878601,259.399963 
	C926.295715,258.395111 923.894653,258.338593 921.234131,258.190125 
	C920.995483,257.956940 920.979675,258.001221 921.000122,258.011414 
	C921.712341,256.304504 919.705261,255.632278 919.462708,254.063248 
	C922.452026,254.017731 924.829590,255.467133 927.627441,256.731995 
	C928.383606,256.564606 928.833252,256.518707 929.462402,256.982300 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M919.903442,247.970642 
	C921.528625,247.984970 922.968140,248.260895 924.709839,248.748291 
	C925.457031,249.787338 925.902100,250.614914 927.027039,252.706696 
	C923.699585,250.027863 920.380066,252.363800 918.076050,249.372925 
	C918.000000,248.999390 918.000000,249.000000 918.000000,249.000305 
	C918.448181,248.466370 919.169983,248.543869 919.903442,247.970642 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M917.113281,258.672852 
	C914.086243,261.685974 912.335266,256.431671 908.297607,258.585419 
	C910.518066,256.412842 911.848022,257.209167 913.458435,257.065918 
	C914.400269,258.587189 915.994507,257.699554 917.113281,258.672852 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M906.863831,250.764099 
	C904.095947,250.547882 905.440613,253.060837 904.714417,254.519791 
	C903.897583,252.878494 903.466431,251.475967 904.662720,249.793182 
	C905.579224,249.950577 906.127930,250.231400 906.863831,250.764099 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M911.822144,254.513306 
	C909.979065,255.148972 909.752014,254.017563 909.684082,252.296539 
	C911.620789,251.302124 911.837830,252.608643 911.822144,254.513306 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M914.835449,254.339691 
	C914.410583,254.815018 914.006958,254.950592 913.286499,255.042755 
	C913.089417,254.034134 912.367432,252.622635 913.889404,252.347626 
	C914.952271,252.155563 914.850220,253.246750 914.835449,254.339691 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M929.794067,256.903015 
	C929.240601,257.227997 928.862610,257.152985 928.222778,256.952942 
	C928.446228,255.673157 928.931580,254.518372 929.683716,253.199570 
	C929.956787,254.191391 929.963135,255.347244 929.794067,256.903015 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M908.441711,253.661880 
	C906.640259,254.285736 906.902954,252.886826 906.880066,251.373672 
	C908.353394,251.197128 908.194763,252.344650 908.441711,253.661880 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M908.452271,249.537537 
	C908.420105,249.481339 908.484436,249.593750 908.452271,249.537537 
z"/>
<path fill="#B35D6A" opacity="1.000000" stroke="none" 
	d="
M340.749939,875.000610 
	C341.000000,875.000305 341.000275,875.500122 340.999878,875.749817 
	C340.999512,875.999512 340.499756,876.000305 340.250183,875.999878 
	C340.000610,875.999390 339.999664,875.499695 339.999725,875.250122 
	C340.166473,875.000671 340.333160,875.000793 340.749939,875.000610 
z"/>
<path fill="#F3F3F0" opacity="1.000000" stroke="none" 
	d="
M523.062073,628.647705 
	C522.891296,629.023010 522.686462,629.058289 522.173706,629.146118 
	C521.081848,628.342407 520.386414,627.093567 521.527771,626.470947 
	C522.371704,626.010620 522.806702,627.416382 523.062073,628.647705 
z"/>
<path fill="#847588" opacity="1.000000" stroke="none" 
	d="
M515.243042,619.988953 
	C514.989197,618.755310 514.598267,617.478333 515.694702,616.140869 
	C516.081299,617.020813 516.144531,618.090149 516.139160,619.555542 
	C515.886902,619.964905 515.703186,619.978088 515.243042,619.988953 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M653.552124,353.981750 
	C653.855957,354.720703 653.889526,355.506104 653.850464,356.681091 
	C653.777832,357.070709 653.356140,357.055176 653.151245,357.003174 
	C652.698242,356.457458 652.450134,355.963745 652.098267,355.211548 
	C652.423645,354.644775 652.852783,354.336487 653.552124,353.981750 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M661.940552,372.574066 
	C660.855408,373.749359 659.719849,374.500488 658.272644,375.407043 
	C658.176880,373.165497 658.227905,370.578705 661.940552,372.574066 
z"/>
<path fill="#4E4A92" opacity="1.000000" stroke="none" 
	d="
M302.174316,419.194519 
	C302.186279,419.167053 302.626801,419.118225 302.844177,419.075073 
	C303.061554,419.031921 302.789825,419.359070 302.610535,419.472412 
	C302.431244,419.585754 302.301025,419.427490 302.228149,419.354462 
	C302.155273,419.281433 302.162384,419.221985 302.174316,419.194519 
z"/>
<path fill="#64688A" opacity="1.000000" stroke="none" 
	d="
M652.055054,327.619568 
	C647.053040,327.675110 642.260925,328.401886 637.764526,326.018555 
	C642.165527,326.018555 646.566528,326.018555 651.425964,326.042175 
	C652.333069,326.403961 652.492188,326.846375 652.055054,327.619568 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M656.423096,327.074768 
	C655.700989,327.393341 655.196167,327.678040 654.371399,328.266296 
	C654.051453,328.569885 653.827698,328.353516 653.751099,328.218048 
	C653.460327,327.625061 653.370972,327.144318 653.543945,326.293732 
	C653.729675,325.219299 653.777588,324.491547 653.766602,323.402771 
	C653.817810,321.359406 653.927856,319.677124 654.136536,317.584381 
	C654.465759,317.231903 654.696411,317.289886 655.192749,317.585266 
	C656.395142,319.243011 656.055115,321.005554 656.905884,322.793274 
	C657.216248,323.291962 657.333191,323.498199 657.579041,324.039551 
	C657.878967,325.099884 657.841736,325.809601 657.314941,326.777954 
	C657.080139,327.055542 656.640442,327.040863 656.423096,327.074768 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M637.378235,320.036743 
	C641.241028,317.438202 645.890747,319.610138 650.562988,319.511292 
	C646.457275,319.941681 642.153076,319.993958 637.378235,320.036743 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M653.381470,325.947632 
	C653.732483,326.423920 653.783142,326.900787 653.754150,327.730103 
	C653.246094,328.039124 652.817688,327.995697 652.068726,327.899261 
	C651.805176,327.451782 651.862244,327.057281 651.901855,326.364258 
	C652.283325,326.026550 652.682251,325.987366 653.381470,325.947632 
z"/>
<path fill="#211943" opacity="1.000000" stroke="none" 
	d="
M653.399658,333.966248 
	C653.743591,334.425903 653.781616,334.893280 653.733521,335.705139 
	C653.270447,336.040009 652.893372,336.030365 652.233643,335.996582 
	C651.962769,335.548492 651.974731,335.124603 651.928467,334.387329 
	C652.278076,334.040619 652.685974,334.007294 653.399658,333.966248 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M653.930908,329.784424 
	C654.574158,330.060944 654.808289,330.709106 654.279175,331.757080 
	C653.964844,331.386536 653.886902,330.738098 653.930908,329.784424 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M637.463135,305.091553 
	C637.242615,301.757019 639.217468,303.340057 640.515503,303.676514 
	C644.101135,304.605988 647.211304,307.043976 651.491089,307.094543 
	C652.572021,307.679626 653.262878,308.209686 654.235535,308.914124 
	C654.197144,309.997559 653.524353,310.541199 652.328918,310.942017 
	C651.553589,311.052673 651.106812,311.105011 650.321045,311.153656 
	C648.364197,311.005066 646.845947,310.579498 645.259949,309.369080 
	C642.619751,307.780182 639.782043,307.266632 637.463135,305.091553 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M649.157410,311.558899 
	C648.299194,317.681946 646.591919,318.335083 640.168823,315.471436 
	C641.921997,314.519318 645.608765,316.327606 645.081787,311.666046 
	C646.385010,309.761841 647.720581,310.119873 649.157410,311.558899 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M649.401855,311.903442 
	C648.525330,310.217438 647.071899,311.117889 645.502380,311.173004 
	C645.086182,310.804718 645.048218,310.337219 644.997925,309.518005 
	C646.811279,308.719727 648.293640,309.530975 649.862305,310.807281 
	C649.924866,311.418030 649.787720,311.635681 649.401855,311.903442 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M652.167480,311.245056 
	C652.284302,309.806549 653.350525,309.962921 654.354431,309.409607 
	C654.517273,309.088562 654.481140,309.034546 654.459106,309.010620 
	C655.380737,309.295837 655.529968,310.089661 655.501343,311.314819 
	C655.183411,311.892273 654.981140,312.076233 654.391479,312.125916 
	C653.447571,311.824341 652.891113,311.657043 652.167480,311.245056 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M654.055176,312.330139 
	C654.004089,311.991638 654.342346,311.775513 654.520264,311.682800 
	C655.457703,311.742371 655.868591,312.304047 656.403564,313.219574 
	C656.915955,314.415405 657.022888,315.335968 656.928955,316.623596 
	C656.796387,317.184906 656.715271,317.401886 656.420898,317.891663 
	C655.991333,318.243408 655.775146,318.322327 655.278687,318.199860 
	C654.867310,317.865479 654.736206,317.732513 654.420166,317.386780 
	C654.192200,315.672180 654.149231,314.170441 654.055176,312.330139 
z"/>
<path fill="#302743" opacity="1.000000" stroke="none" 
	d="
M639.086914,311.864868 
	C638.361755,311.487091 638.035156,311.001190 638.652588,310.681854 
	C638.950012,310.528076 639.726196,310.820404 639.974060,311.147095 
	C640.552307,311.909088 639.775635,311.835175 639.086914,311.864868 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M641.452148,350.012604 
	C640.732178,349.501801 640.459290,349.014343 640.080322,348.267944 
	C643.006836,348.004639 646.039368,348.000214 649.524170,348.026550 
	C650.334045,348.424316 650.484253,348.862579 650.186523,349.649597 
	C647.263611,349.963470 644.581482,349.999695 641.452148,350.012604 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M650.246704,350.078796 
	C649.959473,349.511688 649.973267,349.096100 649.981689,348.368896 
	C650.983826,348.010010 651.991211,347.962769 653.376709,347.898987 
	C653.811340,348.681427 653.867981,349.480377 653.832031,350.670624 
	C652.675598,350.784698 651.611633,350.507507 650.246704,350.078796 
z"/>
<path fill="#352C59" opacity="1.000000" stroke="none" 
	d="
M640.788818,354.143372 
	C640.557922,354.448090 640.031555,354.687073 639.210083,354.864685 
	C639.441101,354.561462 639.967285,354.319550 640.788818,354.143372 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M772.347107,256.083649 
	C769.521362,256.428833 770.047485,258.311005 770.022522,259.842712 
	C769.967285,263.244110 769.993103,266.646820 769.982422,270.513519 
	C768.081482,272.417389 765.797668,271.881134 763.694946,272.114624 
	C749.190674,273.725006 734.782166,276.825226 720.030518,274.599213 
	C716.211792,274.022949 712.470032,274.680084 709.238586,277.413788 
	C706.855530,279.429810 705.231873,278.468353 705.047852,275.373688 
	C704.879761,272.546539 705.125671,269.707825 704.794922,266.456482 
	C703.966003,260.298004 704.528442,254.560730 704.777832,248.411209 
	C705.538086,247.948639 706.490051,248.166092 706.817383,247.809723 
	C713.168762,240.896271 721.445801,244.117493 728.718445,244.310989 
	C736.870911,244.527924 744.686768,242.566162 752.736816,242.492599 
	C760.153809,242.424820 767.564026,241.542526 774.975586,240.997040 
	C776.786316,240.863770 778.014465,241.836441 779.422974,242.809952 
	C782.687073,245.065948 786.045349,247.444229 790.327820,246.968613 
	C792.826904,246.691040 793.568726,248.965622 795.589722,249.927765 
	C797.243713,251.392715 797.100952,252.811218 795.618042,254.511246 
	C787.809326,256.095123 780.254456,255.349976 772.347107,256.083649 
z"/>
<path fill="#E9E5C8" opacity="1.000000" stroke="none" 
	d="
M704.578247,266.483765 
	C707.815674,269.347015 704.672607,273.737976 706.790833,277.783722 
	C712.673828,270.181885 720.755859,272.988922 728.000916,273.384674 
	C734.165649,273.721405 740.031799,273.623688 746.193298,272.716553 
	C753.745728,271.604645 761.392578,269.547821 769.589783,270.935455 
	C770.175354,278.138336 770.371765,285.298676 770.293091,292.734741 
	C765.642944,288.868469 761.052490,290.110931 755.663696,291.180145 
	C748.516174,292.598358 741.576111,294.927063 734.400024,295.949310 
	C729.844238,296.598236 725.409241,293.914368 720.632019,294.343689 
	C716.996155,294.670471 713.350891,294.384094 709.936035,296.170898 
	C708.032104,297.167145 706.032227,297.268707 704.831421,294.388245 
	C703.784729,284.998413 704.643311,275.961304 704.578247,266.483765 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M704.580444,294.442078 
	C706.174561,294.706421 707.012451,296.774963 709.374817,295.195435 
	C715.403687,291.164368 722.620544,291.890411 728.550903,293.792847 
	C734.638000,295.745575 739.136047,292.937500 744.223572,291.992828 
	C746.870056,291.501434 749.187561,289.549805 752.178772,290.822662 
	C753.478271,291.375641 754.995728,290.862732 755.914551,289.961151 
	C759.124084,286.811737 763.137573,288.812775 766.717407,288.164459 
	C769.867249,287.593964 768.415344,291.084991 769.739380,292.752075 
	C770.015198,297.029999 770.012329,301.049469 770.008057,305.531433 
	C760.907532,305.820770 752.265991,307.866058 743.706055,310.847382 
	C738.517090,312.654663 733.320496,312.719391 727.841370,310.196899 
	C723.330078,308.120056 718.074768,307.884766 713.485107,305.281036 
	C711.140015,303.950653 708.470093,307.631927 705.104004,307.021667 
	C704.643066,306.570099 704.545776,306.109741 704.593933,305.319397 
	C705.018982,303.892395 705.037781,302.783203 704.830261,301.337860 
	C704.660950,298.961365 704.555847,296.913483 704.580444,294.442078 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M677.475708,237.744217 
	C674.073914,239.836914 673.826721,237.235443 673.382629,235.450317 
	C672.698120,232.698563 674.883301,232.756088 676.427734,233.078690 
	C681.396301,234.116547 686.528625,233.411987 691.496094,234.859772 
	C693.643677,235.485672 696.490356,235.447937 696.118225,238.062424 
	C695.755798,240.608521 692.766174,239.981110 690.706787,239.872375 
	C690.179382,239.844513 689.684631,239.197418 689.087036,238.476944 
	C685.336914,236.748520 681.550598,237.795883 677.475708,237.744217 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M656.148560,313.793274 
	C655.574036,313.388550 655.255798,312.813385 654.817871,311.914154 
	C654.466492,310.917786 654.234741,310.245483 654.220032,309.279968 
	C656.959717,309.969727 659.594666,310.064178 662.692139,309.886292 
	C668.423645,310.259033 673.880859,309.033905 679.177429,311.684204 
	C679.149658,312.317291 678.935791,312.617645 678.468201,313.048950 
	C672.087769,314.894653 665.923828,312.965790 659.406616,313.307739 
	C658.362305,313.060669 657.733032,312.819794 657.238159,312.356995 
	C656.863281,312.953156 656.647339,313.296356 656.148560,313.793274 
z"/>
<path fill="#3B223C" opacity="1.000000" stroke="none" 
	d="
M672.592407,226.909393 
	C670.749878,225.699066 670.582947,224.125061 672.592712,224.284988 
	C677.561646,224.680435 682.480469,225.706528 687.377502,226.915100 
	C682.556396,229.216995 677.775757,226.283432 672.592407,226.909393 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M689.774048,312.775299 
	C687.408813,313.435059 684.874939,312.982300 682.037109,312.251770 
	C680.750305,309.588654 683.053894,309.643341 684.449341,309.273987 
	C687.057068,308.583710 689.694458,309.182159 692.861450,309.578644 
	C690.681213,312.180511 687.975037,310.380829 685.711060,311.279785 
	C686.639099,312.941467 688.472961,311.652435 689.774048,312.775299 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M705.929321,320.699066 
	C705.684509,321.053375 705.503601,321.046906 705.051147,321.035645 
	C703.936584,319.234436 702.544556,318.607117 700.347900,319.229736 
	C701.016907,320.059723 700.877930,320.812164 699.775330,320.697021 
	C697.554260,320.465027 695.459351,319.651215 693.398193,317.987488 
	C693.086731,317.224915 692.974670,316.822205 692.969238,316.124481 
	C694.707703,314.722137 696.150757,315.170990 697.824036,316.615479 
	C699.950684,317.602142 701.783997,318.197876 704.207397,317.924408 
	C704.635132,317.894531 704.576660,317.901917 704.567017,317.875458 
	C705.035950,318.678772 705.514587,319.508545 705.929321,320.699066 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M693.841553,282.604248 
	C691.193787,282.599823 688.989990,282.599823 686.786133,282.599823 
	C689.764160,280.192627 693.049927,281.117615 696.197876,280.954895 
	C696.398499,280.944550 696.900574,281.718414 696.808411,281.923615 
	C696.280212,283.099640 695.183350,282.549438 693.841553,282.604248 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M688.268311,276.021423 
	C687.237671,275.803741 686.343323,275.736053 686.166321,275.344299 
	C685.854065,274.652893 686.521851,274.064270 687.216125,274.120697 
	C690.408691,274.380432 693.675232,273.404327 697.627625,274.647308 
	C694.374817,276.709778 691.434753,275.667664 688.268311,276.021423 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M665.136230,282.306702 
	C664.731018,277.237091 664.731018,272.288361 664.731018,267.339630 
	C665.462097,267.331421 666.193115,267.323242 666.924194,267.315033 
	C665.651550,271.952606 666.384888,276.486542 666.311584,281.516357 
	C666.017151,282.124847 665.779358,282.276215 665.136230,282.306702 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M665.023193,253.910217 
	C665.382446,252.824249 666.654663,252.079849 666.325623,253.079758 
	C665.258362,256.322815 668.459106,259.563782 666.012268,262.634369 
	C665.708313,263.015717 665.852661,263.754211 665.007568,264.265991 
	C665.007568,260.942749 665.007568,257.619476 665.023193,253.910217 
z"/>
<path fill="#6B596D" opacity="1.000000" stroke="none" 
	d="
M683.854919,250.186050 
	C682.328674,250.100784 681.205872,250.041153 679.077881,249.928116 
	C683.313843,248.880890 687.010559,248.954208 690.339111,249.873688 
	C687.952026,250.918243 687.952026,250.918243 683.854919,250.186050 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M698.077393,316.491272 
	C696.698669,316.552155 695.252441,316.240143 693.441040,315.878784 
	C693.015503,315.377899 692.955139,314.926331 692.894897,314.130341 
	C695.328674,312.965393 697.752625,312.166168 698.077393,316.491272 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M695.891052,292.381683 
	C692.161499,293.637115 688.131409,292.982422 684.095581,292.556396 
	C687.897949,291.572510 691.742310,291.945007 695.891052,292.381683 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M666.724243,306.243866 
	C665.894653,307.307648 665.055176,307.662750 664.988525,306.307404 
	C664.895142,304.409088 664.478516,302.439087 665.358826,300.400604 
	C667.119446,302.013916 667.098328,303.930450 666.724243,306.243866 
z"/>
<path fill="#A89CAC" opacity="1.000000" stroke="none" 
	d="
M686.320740,267.671906 
	C689.522888,266.339813 693.047668,267.326477 696.597717,267.887238 
	C693.273010,267.887238 689.948242,267.887238 686.320740,267.671906 
z"/>
<path fill="#5D3A64" opacity="1.000000" stroke="none" 
	d="
M677.535034,237.965973 
	C680.851929,236.192627 684.699585,236.989075 688.764893,237.769882 
	C687.617493,238.121460 686.235657,238.123856 684.440308,238.162415 
	C683.844177,238.257874 683.661560,238.317169 683.227356,238.236237 
	C681.300293,238.060623 679.624878,238.025223 677.535034,237.965973 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M685.951843,255.392365 
	C687.403442,255.371841 688.827148,254.887665 690.047729,256.927032 
	C688.148743,257.018494 686.665588,257.816345 685.951843,255.392365 
z"/>
<path fill="#DDD2CA" opacity="1.000000" stroke="none" 
	d="
M663.793274,238.113708 
	C663.143311,236.463333 661.873718,234.375351 665.102661,233.152222 
	C665.026855,234.710159 664.528931,236.285965 663.793274,238.113708 
z"/>
<path fill="#FAF2CD" opacity="1.000000" stroke="none" 
	d="
M704.619263,301.390686 
	C706.483459,302.055420 706.360657,303.339539 704.994690,304.870422 
	C704.650452,303.916992 704.561462,302.844543 704.619263,301.390686 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M696.632935,257.339417 
	C695.850525,258.092651 694.924255,258.348602 694.204895,257.363342 
	C694.097168,257.215729 694.280457,256.695526 694.480042,256.511108 
	C695.368713,255.690002 695.897217,256.536987 696.632935,257.339417 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M666.061951,286.642944 
	C665.965637,287.006958 665.499084,286.981201 665.265747,286.987274 
	C663.981812,286.218933 664.925232,285.369476 665.007935,284.284668 
	C665.279297,283.896271 665.483398,283.778168 665.990112,283.843262 
	C666.247864,284.777313 666.203064,285.528107 666.061951,286.642944 
z"/>
<path fill="#4F4A6A" opacity="1.000000" stroke="none" 
	d="
M666.481323,283.869110 
	C666.089722,284.021545 665.886719,284.016602 665.379456,284.013031 
	C665.014221,283.604492 664.953247,283.194580 664.811646,282.485229 
	C664.984375,282.148041 665.237793,282.110229 665.873108,282.022949 
	C666.767151,282.463623 667.085144,283.000153 666.481323,283.869110 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M695.725403,310.985992 
	C696.823975,312.024414 695.827942,311.924835 695.367432,312.010925 
	C695.117737,312.057556 694.809082,311.788391 694.526978,311.661682 
	C694.823975,311.422241 695.121033,311.182831 695.725403,310.985992 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M662.707886,266.721130 
	C662.054199,266.839203 661.261719,266.840240 661.260742,266.058014 
	C661.259766,265.330688 661.830627,265.602142 662.452515,265.880371 
	C662.700317,266.140350 662.739258,266.307159 662.707886,266.721130 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M683.071899,238.240601 
	C683.153137,238.090103 683.330505,238.084183 683.767334,238.138428 
	C683.740540,238.260788 683.454346,238.322998 683.071899,238.240601 
z"/>
<path fill="#61507B" opacity="1.000000" stroke="none" 
	d="
M692.067261,313.652710 
	C691.853210,313.778046 691.528259,313.639862 691.049438,313.276520 
	C691.249207,313.163940 691.602844,313.276520 692.067261,313.652710 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M846.516357,257.106323 
	C846.946350,257.424530 846.950745,257.676849 846.990417,258.306030 
	C843.166016,259.850281 841.542542,257.661469 840.850342,254.393295 
	C840.340332,251.985092 840.690674,249.497040 840.566406,247.048965 
	C840.478882,245.325256 840.953613,243.295609 838.164307,242.522736 
	C834.961426,242.200073 832.217834,241.495651 829.372986,241.509750 
	C824.072998,241.536041 823.652893,241.884506 823.516907,247.040817 
	C823.455811,249.358566 823.632996,251.686584 823.091064,254.377487 
	C822.754211,255.264969 822.432556,255.684540 821.634277,256.147888 
	C818.718628,254.097580 819.911377,251.130905 819.661438,248.487198 
	C819.478149,246.547775 819.766357,244.576233 819.245178,242.321838 
	C818.941956,241.827148 818.793457,241.647491 818.403320,241.215057 
	C817.356628,237.305038 819.315308,236.761719 822.326721,237.102386 
	C829.176758,237.877258 836.039612,238.539474 843.307495,239.385956 
	C843.822205,244.167908 843.889832,248.812668 844.052551,253.454086 
	C844.104675,254.940125 843.364807,257.016846 846.516357,257.106323 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M818.869385,256.811829 
	C811.674805,256.587463 804.916748,256.228668 797.733398,255.809082 
	C795.564697,250.209106 796.917725,244.532150 796.740234,238.490753 
	C797.134338,237.318527 796.874817,236.167618 797.989685,236.132736 
	C799.117737,236.097427 799.078552,237.152298 799.081482,237.959885 
	C799.096252,241.958801 799.291626,245.971939 799.019043,249.952393 
	C798.793640,253.244156 800.009949,254.316315 803.207275,254.299698 
	C807.696472,254.276382 812.187744,254.668106 817.082397,254.810333 
	C817.779053,254.657166 818.071533,254.575958 818.768494,254.704330 
	C819.454529,255.483856 819.498474,256.071686 818.869385,256.811829 
z"/>
<path fill="#F9FAF4" opacity="1.000000" stroke="none" 
	d="
M796.649963,238.352112 
	C797.996155,243.634720 797.003662,249.252930 797.251221,255.300079 
	C796.696411,256.068390 796.084656,256.388489 795.130615,256.825317 
	C794.262756,256.215424 794.231384,255.438492 794.810364,254.307144 
	C796.259583,253.152878 795.997192,251.893265 795.983521,250.354523 
	C796.090088,246.212509 796.234863,242.433258 796.649963,238.352112 
z"/>
<path fill="#3F3241" opacity="1.000000" stroke="none" 
	d="
M819.119141,254.684784 
	C818.541992,254.985870 818.327271,254.953827 817.799561,254.830078 
	C817.666748,250.454208 817.846863,246.170074 818.094360,241.424103 
	C818.161804,240.962265 818.514465,240.973465 818.690918,240.973846 
	C821.010437,245.344376 819.953979,249.861420 819.119141,254.684784 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M862.392212,238.624481 
	C862.340576,239.530212 862.071533,240.250488 861.802490,240.970734 
	C861.568054,240.878403 861.135681,240.796280 861.130310,240.692139 
	C861.083008,239.775269 860.758545,238.685989 862.392212,238.624481 
z"/>
<path fill="#CFD2C2" opacity="1.000000" stroke="none" 
	d="
M863.452393,236.530609 
	C863.421875,236.478149 863.482910,236.583054 863.452393,236.530609 
z"/>
<path fill="#260F2E" opacity="1.000000" stroke="none" 
	d="
M823.251099,301.284973 
	C819.658081,299.804352 820.306580,297.940308 822.589172,295.857544 
	C825.984192,293.883667 829.125183,294.244049 832.679688,295.508545 
	C835.087769,295.860291 837.121033,295.903290 839.584839,295.872925 
	C840.486145,295.572876 840.978210,295.508606 841.723511,295.907898 
	C839.759460,299.199066 836.091187,297.614502 832.964722,299.105225 
	C829.511597,299.695648 826.584839,300.649750 823.251099,301.284973 
z"/>
<path fill="#B97FBF" opacity="1.000000" stroke="none" 
	d="
M822.748169,301.390198 
	C825.739258,299.887482 828.748474,299.339417 832.199341,299.197876 
	C830.083984,301.028717 826.558594,300.373840 823.979858,302.920685 
	C822.994568,303.087128 822.370544,303.098694 821.430786,303.131470 
	C821.612610,302.645569 822.110107,302.138519 822.748169,301.390198 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M842.341187,296.178955 
	C841.514771,296.153412 841.074036,296.097717 840.324341,295.920807 
	C840.994324,295.471558 841.973267,295.143524 843.340454,294.725739 
	C844.601501,294.076935 845.501953,294.096344 846.672852,294.755951 
	C846.714539,295.292572 846.504272,295.581451 846.065796,296.022034 
	C844.800659,296.165466 843.763733,296.157135 842.341187,296.178955 
z"/>
<path fill="#E0D2DC" opacity="1.000000" stroke="none" 
	d="
M837.763000,241.437744 
	C841.086548,240.305038 842.193115,241.430222 842.000671,244.614777 
	C841.800781,247.922699 842.076660,251.261108 842.180176,254.585083 
	C842.259644,257.139099 843.586487,258.499420 846.597229,258.631866 
	C851.970581,259.750458 856.878784,261.042053 862.405518,261.201263 
	C861.914917,264.749786 858.984070,264.141998 856.053894,264.408630 
	C852.209473,264.232147 848.723450,264.893799 845.292480,263.683319 
	C845.143311,265.891418 845.897095,268.336548 844.156677,270.757751 
	C843.443237,271.017609 843.058411,271.015350 842.386353,271.017395 
	C842.169556,267.918823 841.441772,264.735779 842.673523,261.743896 
	C843.880249,258.812927 839.051941,260.983185 839.929565,258.107025 
	C839.476685,257.382507 839.170288,256.911163 838.844482,255.975067 
	C839.173767,250.890350 837.196594,246.428696 837.763000,241.437744 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M843.868896,271.365845 
	C844.501038,262.890900 844.501038,262.889679 853.026245,262.939453 
	C853.681580,262.943268 854.336731,262.980438 855.437866,263.055664 
	C856.283752,263.387299 856.486877,263.775146 856.433594,264.592834 
	C856.185791,265.099823 856.027344,265.270050 855.555664,265.591187 
	C855.017029,265.790070 854.791565,265.838043 854.223755,265.897522 
	C853.656799,265.889252 853.432190,265.869446 852.879639,265.800781 
	C849.674133,265.210327 850.565369,267.882019 849.538574,269.363312 
	C845.938110,270.655945 845.830750,268.488892 845.810608,266.238373 
	C846.087097,270.867401 846.491638,271.387177 850.844177,272.455048 
	C853.880737,273.200073 856.999512,273.469696 860.388794,274.202942 
	C862.037842,275.062958 862.400818,276.577271 863.587036,277.867249 
	C863.787537,278.156189 863.827332,278.583344 863.877991,278.791656 
	C860.023193,280.599274 856.088196,280.458496 851.981079,278.844513 
	C850.421753,276.386230 848.258667,278.473999 846.352173,277.745239 
	C845.519653,278.295380 844.974182,278.651733 844.100220,279.026794 
	C843.817749,276.600891 843.863770,274.156342 843.868896,271.365845 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M843.551941,281.752930 
	C846.085022,282.437317 848.670593,281.900452 851.555542,282.190002 
	C855.820312,282.184204 859.828308,281.132324 863.575073,284.009430 
	C864.777832,288.822144 862.786011,289.824127 858.742859,289.034515 
	C854.997192,288.303009 851.187805,287.745819 847.382141,287.516907 
	C843.622437,287.290710 842.285339,285.740234 843.551941,281.752930 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M841.168579,280.133301 
	C841.596069,280.207520 841.601379,280.643250 841.729126,280.819824 
	C841.974731,284.180542 841.101685,285.757416 837.279724,285.269348 
	C832.862793,284.705353 828.326965,284.931335 823.848755,285.046204 
	C821.592712,285.104126 820.951477,284.210785 821.009399,282.140564 
	C821.063782,280.200531 821.425537,279.059387 823.823364,279.232697 
	C829.453125,279.639587 835.100769,279.799347 841.168579,280.133301 
z"/>
<path fill="#130817" opacity="1.000000" stroke="none" 
	d="
M833.565491,271.494446 
	C836.260925,271.905487 838.533997,272.117035 841.225464,272.394287 
	C842.442505,277.089050 840.825928,278.336884 836.081421,277.475830 
	C831.297058,276.607513 826.296509,276.930725 821.149048,276.368774 
	C819.557129,271.049866 819.831421,270.691132 824.781311,270.974915 
	C827.566650,271.134583 830.373413,270.730438 833.565491,271.494446 
z"/>
<path fill="#160C21" opacity="1.000000" stroke="none" 
	d="
M823.346191,293.541260 
	C820.230347,292.748230 820.894287,290.604034 821.177002,288.950134 
	C821.451599,287.343140 823.037476,288.025055 824.065247,288.026886 
	C828.558472,288.034821 833.054321,288.266632 837.543518,288.164612 
	C840.432434,288.098938 841.311890,289.315613 841.071655,292.021393 
	C840.750671,295.637024 838.358887,293.075745 836.552002,293.549255 
	C832.003235,294.406158 827.883301,295.182892 823.346191,293.541260 
z"/>
<path fill="#1C1122" opacity="1.000000" stroke="none" 
	d="
M847.385681,294.952026 
	C846.075439,294.887115 845.225952,294.770477 844.052551,294.644897 
	C842.197632,290.680634 843.216248,289.122131 847.624817,290.160126 
	C851.318115,291.029724 855.135376,291.377991 858.820923,292.273102 
	C860.593689,292.703644 862.966675,292.638092 863.550232,295.599670 
	C858.317139,295.637817 853.081848,295.269073 847.385681,294.952026 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M833.857422,271.333496 
	C830.886719,271.648560 827.757202,271.846649 824.692261,271.490112 
	C821.549866,271.124634 820.486755,272.239624 820.960693,275.610657 
	C820.534241,276.014740 820.161072,276.023834 819.507690,276.030762 
	C818.490479,274.641663 820.414368,272.440704 817.454529,271.498596 
	C822.521179,268.158112 828.134155,269.965424 833.857422,271.333496 
z"/>
<path fill="#E9BAD1" opacity="1.000000" stroke="none" 
	d="
M822.966919,293.621277 
	C827.093018,292.666962 831.229065,293.084473 835.743347,293.425659 
	C835.744507,294.902191 834.441711,294.844757 833.286499,295.583252 
	C830.000854,295.859711 826.947266,295.902161 823.442322,295.874207 
	C822.984924,295.180298 822.978821,294.556732 822.966919,293.621277 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M863.846619,283.979675 
	C860.041748,283.802338 856.294739,283.232574 852.253784,282.395599 
	C855.661316,279.935455 859.591187,281.329041 863.712097,281.700348 
	C863.959839,282.531311 863.932129,283.059235 863.846619,283.979675 
z"/>
<path fill="#1D1629" opacity="1.000000" stroke="none" 
	d="
M817.174622,295.469177 
	C817.180420,295.192322 817.350098,295.105194 817.784302,294.908997 
	C818.145996,294.981598 818.243103,295.163208 818.308350,295.651978 
	C817.963867,295.859070 817.651123,295.758972 817.174622,295.469177 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M846.365173,277.996521 
	C848.091309,276.759552 850.119263,276.224701 851.990662,278.205566 
	C851.495728,278.474548 851.163391,278.468353 850.581909,278.467743 
	C849.775452,278.635010 849.213074,278.653107 848.265869,278.323029 
	C847.479065,278.102081 847.072144,278.078033 846.365173,277.996521 
z"/>
<path fill="#94869B" opacity="1.000000" stroke="none" 
	d="
M847.954712,278.404846 
	C848.440430,278.138000 848.994995,278.149902 849.941162,278.313599 
	C849.669678,279.666473 848.965271,280.431610 847.954712,278.404846 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M855.330200,265.442932 
	C855.614014,264.650879 855.708801,264.212433 855.843628,263.441589 
	C858.086670,262.908081 860.375061,263.111420 862.580017,261.508301 
	C863.073242,261.308655 863.318970,261.348389 863.886047,261.580505 
	C864.113953,266.916077 864.020508,272.059326 863.857300,277.679382 
	C862.384644,277.974152 860.944885,277.839111 860.893921,275.553589 
	C860.897156,275.034821 860.926453,274.865601 861.074646,274.473541 
	C861.365540,273.978790 861.509460,273.692749 861.616760,273.177216 
	C859.521179,272.591766 857.249023,272.809753 855.394165,270.746216 
	C854.609253,268.888641 854.520996,267.346619 855.330200,265.442932 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M829.252686,566.724487 
	C826.794495,567.401489 825.629944,567.059082 825.951538,564.366211 
	C826.309143,561.370544 827.978333,559.482849 830.561218,558.501709 
	C833.099365,557.537720 835.071350,559.069763 836.537903,560.927551 
	C837.528442,562.182251 838.061523,563.798035 838.784668,565.603394 
	C837.634644,567.065735 838.424377,569.091858 836.520630,569.963379 
	C835.594604,568.165649 835.700134,566.052124 833.377930,565.044312 
	C832.042969,566.029785 830.826416,566.396667 829.252686,566.724487 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M836.129272,570.314331 
	C837.591492,569.041992 836.400452,566.826111 838.457581,566.033203 
	C839.409668,569.263184 838.729553,572.290344 836.448853,575.100708 
	C835.675110,574.735657 835.500305,574.248474 835.741516,573.330750 
	C835.981567,572.217957 836.024536,571.457153 836.129272,570.314331 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M834.787903,575.748901 
	C832.745667,578.844543 830.160522,578.125916 827.615173,576.387817 
	C827.075928,576.019653 826.267334,575.114685 827.556458,574.634949 
	C827.955505,574.486511 828.648132,575.127258 829.567200,575.544861 
	C831.397400,574.954163 832.901062,574.848022 834.787903,575.748901 
z"/>
<path fill="#CEC8D6" opacity="1.000000" stroke="none" 
	d="
M832.561951,567.048828 
	C833.057800,568.855652 833.674988,570.899353 832.280457,571.446594 
	C830.640686,572.090149 829.849304,570.368469 829.782471,568.344482 
	C830.347229,566.869995 831.179382,566.372681 832.561951,567.048828 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M835.106201,576.038574 
	C833.675476,576.026917 832.218018,575.990051 830.344360,575.818115 
	C830.862366,573.174377 833.597168,574.153076 835.573730,572.967651 
	C835.916687,573.464050 835.894775,573.949402 835.970886,574.789429 
	C836.068909,575.144165 836.015991,575.091248 836.043152,575.065552 
	C835.777527,575.199158 835.524841,575.407166 835.173828,575.868042 
	C835.035583,576.072266 835.079468,576.013367 835.106201,576.038574 
z"/>
<path fill="#403B54" opacity="1.000000" stroke="none" 
	d="
M832.807861,567.044067 
	C831.934998,567.533936 831.156921,567.648621 830.096680,567.866333 
	C829.556458,567.745667 829.298523,567.521912 828.990479,567.042480 
	C828.968750,564.138916 830.908264,565.167908 832.639648,565.094482 
	C832.981689,565.640625 832.942200,566.154724 832.807861,567.044067 
z"/>
<path fill="#544453" opacity="1.000000" stroke="none" 
	d="
M842.952148,568.896973 
	C842.881226,570.205994 842.813965,571.133484 842.746704,572.060974 
	C842.581604,572.053101 842.416504,572.045166 842.251404,572.037292 
	C842.251404,569.803040 842.251404,567.568787 842.251404,565.181824 
	C843.417603,566.217590 842.720886,567.459106 842.952148,568.896973 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M826.065674,573.109985 
	C824.874878,572.574158 824.881226,571.752625 825.283142,570.838684 
	C825.601196,571.241699 825.919250,571.644653 826.335083,572.311401 
	C826.432922,572.575073 826.303284,573.048523 826.065674,573.109985 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M835.388550,576.180115 
	C835.170593,575.702454 835.305603,575.332581 835.755432,575.001221 
	C835.960693,575.455872 835.851074,575.871887 835.388550,576.180115 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M826.281006,572.723511 
	C826.683533,572.973816 826.934143,573.372620 827.184692,573.771423 
	C826.789734,573.809937 826.394836,573.848450 825.914001,573.529236 
	C825.828125,573.171509 826.129150,572.871948 826.281006,572.723511 
z"/>
<path fill="#2A1137" opacity="1.000000" stroke="none" 
	d="
M816.903503,601.764404 
	C816.698669,601.898132 816.435120,601.733521 816.105164,601.278564 
	C816.311646,601.135498 816.580322,601.294739 816.903503,601.764404 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M867.954102,565.763428 
	C867.341797,565.291443 866.712097,564.453369 866.026123,563.301453 
	C867.543030,563.042053 868.012573,563.997192 867.954102,565.763428 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M865.878784,562.261108 
	C865.643066,562.288757 865.313782,561.990540 864.919739,561.353760 
	C865.165039,561.321899 865.475159,561.628540 865.878784,562.261108 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M909.057251,186.064392 
	C909.077454,187.956802 907.958496,188.165604 906.540894,187.589478 
	C906.057678,187.393097 905.352905,186.517273 905.461121,186.288635 
	C906.155762,184.820572 907.345764,185.868576 908.738831,186.018646 
	C909.128845,186.143524 909.081543,186.090378 909.057251,186.064392 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M909.119873,197.655060 
	C908.244446,198.387634 907.524780,198.166779 906.911133,197.250702 
	C907.701782,196.997116 908.438416,197.139023 909.119873,197.655060 
z"/>
<path fill="#3F1E55" opacity="1.000000" stroke="none" 
	d="
M904.942139,299.233704 
	C905.766235,298.652802 906.554932,298.322876 907.672119,297.984802 
	C908.171997,299.670685 907.080811,299.938965 905.405762,299.963745 
	C904.999084,299.809753 904.952942,299.647217 904.942139,299.233704 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M899.474548,380.458191 
	C899.525208,380.429199 899.423889,380.487183 899.474548,380.458191 
z"/>
<path fill="#A371B4" opacity="1.000000" stroke="none" 
	d="
M902.531372,379.545502 
	C902.479065,379.575226 902.583740,379.515778 902.531372,379.545502 
z"/>
<path fill="#8C7B9D" opacity="1.000000" stroke="none" 
	d="
M915.008911,271.634705 
	C914.233704,272.089294 913.958374,272.672882 913.956299,273.771240 
	C913.988708,274.521545 913.966614,274.925964 914.002136,275.629333 
	C913.990234,276.330383 913.792358,276.658051 913.197266,276.998901 
	C912.745117,277.045288 912.579468,277.014374 912.164246,277.024353 
	C911.914673,277.065186 911.947876,277.013977 911.967041,277.037659 
	C911.474792,276.476288 910.974854,275.878815 910.017578,275.366211 
	C909.394775,275.071991 909.064819,274.859070 908.545471,274.404694 
	C906.602051,270.130371 907.949219,265.900818 907.792969,261.408020 
	C908.139404,260.941681 908.375244,260.822968 908.907898,260.966553 
	C908.917419,262.660095 908.254211,264.137512 909.911316,265.130737 
	C910.503052,264.630676 910.940125,264.520813 911.693359,264.764648 
	C913.947937,266.637146 915.401123,268.544037 915.008911,271.634705 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M925.320923,271.147949 
	C923.831909,267.515045 921.152710,266.299927 917.632202,266.200989 
	C916.570557,266.171143 915.287537,266.152008 914.904358,264.382812 
	C916.275879,263.398956 917.417908,265.828278 918.867554,263.891235 
	C920.470215,262.855469 921.835999,263.421204 923.501465,264.259796 
	C928.380310,266.300995 928.394165,266.350769 925.320923,271.147949 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M898.854980,242.128784 
	C900.633972,242.357300 902.142944,242.775162 903.943237,243.358643 
	C898.592102,246.762924 898.592102,246.762924 898.854980,242.128784 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M924.221802,264.870819 
	C922.553467,264.787354 921.088196,264.380951 919.287720,263.763977 
	C918.730835,262.893707 918.509155,262.234070 918.152466,261.335083 
	C920.319153,260.943542 922.094543,262.238800 924.055481,263.549866 
	C924.235840,264.075623 924.330322,264.311737 924.221802,264.870819 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M906.730957,280.285767 
	C905.937256,279.892975 905.401733,279.680420 904.866272,279.467896 
	C905.499695,279.023438 906.188171,278.151642 906.754944,278.224670 
	C907.890076,278.370972 907.954590,279.447784 907.698792,280.439178 
	C907.675354,280.529938 907.512634,280.650024 907.422668,280.643555 
	C907.274719,280.632996 907.133362,280.530029 906.730957,280.285767 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M908.311523,274.517517 
	C908.729370,274.124268 909.125732,274.049561 909.825073,273.998657 
	C910.559387,274.580322 910.800903,275.197571 910.594727,276.232727 
	C910.345581,276.671600 910.222290,276.793304 909.915527,277.100006 
	C908.438721,276.947174 908.165344,276.008820 908.311523,274.517517 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M909.410217,261.026855 
	C908.988953,261.193176 908.773254,261.157471 908.230469,261.091095 
	C907.337708,260.343567 906.407288,259.405640 907.558533,258.817108 
	C908.011292,258.585663 909.715149,259.310181 909.410217,261.026855 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M915.021606,263.699280 
	C914.162292,264.458374 913.981445,263.746460 913.413330,263.107544 
	C913.170227,262.924255 913.005920,262.476715 913.002930,262.238342 
	C913.935547,262.078339 914.812073,262.246124 915.021606,263.699280 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M912.938538,261.720581 
	C912.469604,262.061249 911.779297,262.567810 911.649048,261.514832 
	C912.058411,261.490265 912.467712,261.465729 912.938538,261.720581 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M911.994385,264.722229 
	C911.555359,265.004364 911.139771,265.032410 910.417603,264.983734 
	C910.167419,264.088593 910.676697,263.727417 911.721619,263.782104 
	C912.018860,264.127930 912.018372,264.298035 911.994385,264.722229 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M919.803467,247.547363 
	C919.611267,248.114212 919.133362,248.519363 918.327759,248.962555 
	C918.029907,248.705627 918.059875,248.410645 918.157104,247.675186 
	C918.655518,247.285034 919.086670,247.335358 919.803467,247.547363 
z"/>
<path fill="#766A82" opacity="1.000000" stroke="none" 
	d="
M907.493225,256.302643 
	C907.726196,256.281860 907.807190,256.383972 907.888184,256.486084 
	C907.705872,256.465912 907.523621,256.445709 907.493225,256.302643 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M902.470154,248.449829 
	C902.528320,248.414612 902.411987,248.485031 902.470154,248.449829 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M904.465088,246.451752 
	C904.520691,246.418549 904.409485,246.484970 904.465088,246.451752 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M924.256714,265.396973 
	C924.044556,264.968567 924.070374,264.743347 924.118835,264.178833 
	C924.706909,263.745026 925.272461,263.650543 925.959961,263.279602 
	C926.668518,262.758728 927.353882,262.676575 927.821350,261.722504 
	C927.751465,261.231964 927.667603,260.999054 927.694824,260.533295 
	C927.845825,259.785919 928.199646,259.419739 929.104309,259.050751 
	C929.457764,258.856964 929.509460,258.808960 929.512329,258.771881 
	C930.414917,262.979645 930.087646,267.239624 929.449097,271.864624 
	C928.128174,272.482300 927.030884,272.736084 925.595825,273.022797 
	C925.059570,273.029266 924.860962,273.002838 924.783691,272.701416 
	C924.915894,272.208252 924.926880,271.990051 924.948364,271.444489 
	C924.130371,269.334839 929.119690,267.062958 924.256714,265.396973 
z"/>
<path fill="#654F78" opacity="1.000000" stroke="none" 
	d="
M924.586609,272.476227 
	C924.904968,272.426453 925.011719,272.779968 925.134949,272.917847 
	C923.828308,276.521759 927.096313,278.616211 927.929626,281.579620 
	C923.736511,279.661133 922.705566,276.984894 924.586609,272.476227 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M923.175049,281.420105 
	C925.893921,283.388336 925.893921,283.388336 926.646667,286.433502 
	C924.770325,285.719635 924.111450,284.003906 922.867310,282.510193 
	C922.786316,281.939789 922.791565,281.687469 923.175049,281.420105 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M922.985352,282.006287 
	C922.079895,280.781403 921.378601,279.370667 920.665588,277.614624 
	C920.653809,277.269287 920.991150,276.989777 921.154907,276.841705 
	C923.107239,277.549072 922.523682,279.490265 923.386353,281.125549 
	C923.432007,281.543549 923.310730,281.681976 922.985352,282.006287 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M913.111267,277.375763 
	C913.106812,276.750122 913.302856,276.424011 913.779297,276.013062 
	C915.223145,277.356934 916.877686,278.628510 915.734558,280.838470 
	C913.464905,280.799500 914.575439,278.365723 913.111267,277.375763 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M913.772217,287.044159 
	C914.760193,283.924500 915.318726,286.626526 915.570435,286.964722 
	C916.101196,287.678131 916.496521,288.820740 915.142761,289.100494 
	C914.802429,289.170837 914.203125,287.987976 913.772217,287.044159 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M917.672607,286.275818 
	C916.699829,285.201263 915.907410,283.969360 916.516968,282.369385 
	C917.916138,282.828156 917.678467,284.161743 918.193970,285.433228 
	C918.140137,285.878540 918.009521,285.995575 917.672607,286.275818 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M919.627197,270.521729 
	C920.339478,271.014923 921.045044,271.425537 920.273743,271.998779 
	C920.018372,272.188568 919.366882,272.174011 919.115295,271.975555 
	C918.485107,271.478485 918.853638,270.926910 919.627197,270.521729 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M910.711914,276.715881 
	C910.350281,275.922241 910.231812,275.294525 910.120728,274.344666 
	C911.508911,274.202148 912.060059,275.062836 912.023071,276.718628 
	C911.642517,277.001495 911.298706,276.941681 910.711914,276.715881 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M661.395630,421.993042 
	C661.584473,419.679138 661.841309,416.941406 665.741333,418.917511 
	C666.149963,422.259155 663.707214,421.755371 661.395630,421.993042 
z"/>
<path fill="#440E34" opacity="1.000000" stroke="none" 
	d="
M658.989258,427.623352 
	C658.465088,427.754242 657.956421,427.536713 657.180054,427.370392 
	C656.723511,427.358032 656.534668,427.294434 656.070068,427.111084 
	C656.145386,426.514374 656.496582,426.037445 656.925293,425.275574 
	C658.431458,425.084839 659.001587,425.931458 658.989258,427.623352 
z"/>
<path fill="#E0CEF7" opacity="1.000000" stroke="none" 
	d="
M676.991943,428.016785 
	C678.458923,422.218842 680.340942,420.936615 683.037598,423.649872 
	C684.072449,424.691162 686.330078,425.552643 684.889038,427.941986 
	C683.821106,429.712646 683.286255,431.875702 680.705994,432.128418 
	C677.921265,432.401093 677.673767,430.207397 676.991943,428.016785 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M670.274658,415.271912 
	C670.259949,415.578979 670.183594,415.825745 670.083374,415.907196 
	C668.973267,415.148499 668.629333,414.223602 669.841248,413.324585 
	C670.098450,413.133698 670.671509,413.368469 671.099060,413.407135 
	C670.829163,413.926392 670.559265,414.445648 670.274658,415.271912 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M674.998413,411.269409 
	C675.167053,411.001221 675.334167,411.001221 675.751831,411.001221 
	C675.817139,411.274261 675.631836,411.547302 675.229126,411.947144 
	C675.006775,411.895172 675.001770,411.716400 674.998413,411.269409 
z"/>
<path fill="#846789" opacity="1.000000" stroke="none" 
	d="
M673.983704,392.715149 
	C671.546875,390.452972 673.941895,388.003784 674.596436,385.228699 
	C675.036377,384.804382 675.202881,384.619110 675.636047,384.695618 
	C675.259888,387.411316 674.617004,389.865295 673.983704,392.715149 
z"/>
<path fill="#4B3C5E" opacity="1.000000" stroke="none" 
	d="
M678.062622,402.298889 
	C679.080994,406.056091 676.840881,404.744385 675.010498,403.870178 
	C675.292969,401.769775 676.657166,402.369476 678.062622,402.298889 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M676.021729,384.613495 
	C675.730713,384.964844 675.558655,384.972351 675.128174,384.984772 
	C674.889038,382.697144 676.042603,380.867706 677.635986,379.020691 
	C678.693542,381.194733 676.542542,382.427643 676.021729,384.613495 
z"/>
<path fill="#3D325B" opacity="1.000000" stroke="none" 
	d="
M678.192505,379.220520 
	C677.970703,378.603912 677.968750,378.225800 678.047852,377.554565 
	C680.764832,377.666107 679.139221,378.620544 678.192505,379.220520 
z"/>
<path fill="#1A0A1E" opacity="1.000000" stroke="none" 
	d="
M674.831909,403.560364 
	C674.949829,403.492767 674.895691,403.489532 674.911072,403.503235 
	C674.926453,403.516907 674.595154,403.466217 674.523499,403.511292 
	C674.451843,403.556335 674.713989,403.627960 674.831909,403.560364 
z"/>
<path fill="#E9DAF1" opacity="1.000000" stroke="none" 
	d="
M693.246338,374.906982 
	C693.500061,374.959351 693.534058,375.144287 693.577881,375.610962 
	C693.252441,375.705750 692.383362,375.870026 693.246338,374.906982 
z"/>
<path fill="#E0CEF7" opacity="1.000000" stroke="none" 
	d="
M655.697388,438.837891 
	C654.552734,439.086700 653.663269,439.087616 652.428223,439.078400 
	C651.851013,438.812225 651.608398,438.567017 651.152954,438.170990 
	C650.949646,438.010803 650.989685,438.046143 650.975708,438.069336 
	C650.946838,436.782318 650.699219,435.420959 650.973083,434.174164 
	C651.355286,432.434387 652.060791,430.209167 654.104797,430.344269 
	C656.148071,430.479370 655.247314,432.872101 655.211182,434.035767 
	C655.160095,435.676788 657.081848,436.898285 655.697388,438.837891 
z"/>
<path fill="#E00CD3" opacity="1.000000" stroke="none" 
	d="
M651.011353,438.293945 
	C651.216064,438.228790 651.482422,438.446747 651.915771,438.866486 
	C651.746155,438.904541 651.409607,438.740814 651.011353,438.293945 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M718.907715,315.507141 
	C718.072083,318.188568 716.255432,316.584015 714.083191,316.750214 
	C715.561096,314.476532 717.105286,315.002045 718.907715,315.507141 
z"/>
<path fill="#E5E5DF" opacity="1.000000" stroke="none" 
	d="
M744.994751,343.005280 
	C743.810120,342.699585 742.182739,343.661652 741.551331,341.942657 
	C741.428345,341.607666 742.074463,340.645172 742.528870,340.506561 
	C744.000427,340.057831 744.562561,341.123138 744.963318,342.655792 
	C745.010071,342.989227 745.000000,343.000000 744.994751,343.005280 
z"/>
<path fill="#F5EDCC" opacity="1.000000" stroke="none" 
	d="
M712.584167,312.401550 
	C712.065674,311.058899 712.331787,310.256836 713.597656,310.230804 
	C714.295837,310.216370 714.797241,310.731201 714.770325,311.425629 
	C714.721497,312.685760 713.920105,312.948669 712.584167,312.401550 
z"/>
<path fill="#0C0C29" opacity="1.000000" stroke="none" 
	d="
M657.052979,327.039185 
	C656.855835,326.377441 656.631531,325.699371 656.386475,324.657745 
	C656.365417,323.725800 656.140015,323.264496 655.613037,322.497253 
	C655.539307,321.233826 655.465332,320.356354 656.451172,319.377686 
	C663.657776,318.456055 670.488403,317.776886 677.613525,319.860931 
	C677.997864,321.811035 678.038269,323.437775 678.060547,325.471313 
	C675.015686,327.989899 671.591736,326.730103 668.355957,326.954620 
	C664.880127,327.195862 661.378296,326.881104 657.430908,327.055023 
	C656.970398,326.992188 657.025879,327.022827 657.052979,327.039185 
z"/>
<path fill="#120E2A" opacity="1.000000" stroke="none" 
	d="
M656.728638,311.610168 
	C663.777222,312.032593 670.543213,312.536285 677.761841,313.109924 
	C678.175598,314.491272 678.136658,315.802612 678.049744,317.506836 
	C671.069031,320.046661 664.026306,318.857117 656.643738,318.278931 
	C656.201660,316.895233 656.129883,315.824280 655.975220,314.358521 
	C655.939087,313.558960 655.985840,313.154205 656.047485,312.443298 
	C656.190186,311.988525 656.318115,311.839966 656.728638,311.610168 
z"/>
<path fill="#F5E4EF" opacity="1.000000" stroke="none" 
	d="
M689.477600,322.952087 
	C689.295837,326.074249 692.270447,330.330109 687.185425,330.847839 
	C682.635803,331.311096 684.211121,326.723083 683.443970,324.221893 
	C683.067078,322.993011 683.229370,321.599670 683.140808,320.281219 
	C682.994019,318.095947 683.238647,315.990356 686.131775,316.449738 
	C688.203186,316.778687 690.519714,317.430206 689.516052,320.581482 
	C689.323669,321.185486 689.460510,321.894318 689.477600,322.952087 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M656.169678,317.949524 
	C663.205078,317.983063 670.136780,317.999939 677.535034,317.958252 
	C678.012024,318.407654 678.022400,318.915588 677.995117,319.803925 
	C671.055542,320.188660 664.153503,320.193024 656.805542,320.182922 
	C655.745972,319.921539 655.478821,319.469696 655.711426,318.403442 
	C655.864624,317.993835 656.065857,317.932892 656.169678,317.949524 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M692.987305,318.014099 
	C695.332825,318.474365 697.813416,317.835175 699.947205,319.275208 
	C702.164795,325.416534 696.947632,323.897491 693.799072,324.972260 
	C692.457886,322.827637 692.463135,320.627258 692.987305,318.014099 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M657.252441,327.302979 
	C663.602905,325.054779 670.396912,326.423401 677.573120,325.943298 
	C678.084351,326.338196 678.126160,326.798248 678.108154,327.598816 
	C671.208252,327.966400 664.361816,328.393402 657.252441,327.302979 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M678.237915,329.152496 
	C678.043091,329.087921 678.015381,328.866791 678.021851,328.313232 
	C678.235840,328.184814 678.443726,328.372314 678.579102,328.602448 
	C678.621521,328.674530 678.468506,328.861511 678.237915,329.152496 
z"/>
<path fill="#F5E1E3" opacity="1.000000" stroke="none" 
	d="
M720.864685,333.326263 
	C716.579163,333.977936 714.448486,332.050629 715.072876,327.718658 
	C715.330627,325.930298 713.620605,324.377808 714.875977,322.273376 
	C719.652954,321.402435 721.894470,323.099792 721.097351,327.985382 
	C720.836182,329.585999 720.949585,331.247742 720.864685,333.326263 
z"/>
<path fill="#0D071B" opacity="1.000000" stroke="none" 
	d="
M703.283569,330.386169 
	C703.150330,330.559479 702.921997,330.586243 702.693604,330.613007 
	C702.858582,330.488556 703.023499,330.364105 703.283569,330.386169 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M751.243530,349.085938 
	C751.881226,348.341766 752.656067,347.773865 753.712036,347.109558 
	C755.963440,348.324280 757.684937,346.098053 759.842896,346.895386 
	C760.067871,347.512329 760.049561,347.852661 760.029968,348.448730 
	C759.507263,350.078278 757.920166,349.133850 756.930847,350.215210 
	C756.565979,350.577026 756.443481,350.740723 756.124634,351.134308 
	C755.779602,351.498352 755.631042,351.632446 755.209106,351.890625 
	C754.484375,352.018341 754.033020,352.021973 753.244629,352.058472 
	C751.992493,352.871582 750.941711,353.275421 749.399536,353.135498 
	C749.067810,353.034454 749.003113,352.997437 748.970581,352.977600 
	C748.153809,351.965302 747.352051,350.986115 746.591309,349.976044 
	C746.024780,349.223877 746.119690,348.439026 746.827026,347.871216 
	C747.981018,346.944885 748.455322,348.120728 749.338196,348.884735 
	C750.057556,349.379425 750.507202,349.791016 751.124573,349.821136 
	C751.789917,349.853638 752.158386,349.459045 751.528198,349.676575 
	C750.898010,349.894043 751.808167,348.750610 751.243530,349.085938 
z"/>
<path fill="#C2CEE8" opacity="1.000000" stroke="none" 
	d="
M755.277527,350.102905 
	C756.247986,348.567169 757.889709,349.228027 759.655762,348.763367 
	C762.827637,348.472198 765.627075,348.063232 768.425293,348.071991 
	C770.190369,348.077515 770.506226,348.960541 768.383728,349.975006 
	C767.837463,350.168274 767.667725,350.310364 767.251770,350.229675 
	C764.399048,350.102875 761.792419,350.198914 758.755249,350.280334 
	C757.868530,350.461426 757.401855,350.627014 756.551636,350.733734 
	C755.955322,350.605499 755.730347,350.501221 755.277527,350.102905 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M760.990479,344.971802 
	C763.489319,345.247528 766.132141,344.655975 768.525513,345.634644 
	C768.518921,346.082672 768.512390,346.530670 768.505859,346.978699 
	C766.319275,346.978699 764.132629,346.978699 761.516052,346.930878 
	C760.700195,346.551147 760.516907,346.136108 760.790833,345.335754 
	C761.012146,345.047241 760.992432,344.998169 760.990479,344.971802 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M766.852661,350.334442 
	C767.172852,349.998016 767.340088,349.989227 767.757202,350.003296 
	C768.944519,351.623383 768.945923,352.853729 766.689941,352.957520 
	C764.898743,353.039886 763.100647,352.974121 759.883423,352.974121 
	C763.034790,351.905182 764.867188,351.283600 766.852661,350.334442 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M762.661804,358.992554 
	C761.954712,358.905457 761.629822,358.842804 761.301941,358.812347 
	C760.762085,358.762115 760.710693,358.417969 761.238647,358.338989 
	C763.942322,357.934326 766.661499,357.633453 769.469543,357.852051 
	C767.621826,359.698883 765.196960,358.736633 762.661804,358.992554 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M769.219238,354.864136 
	C767.073425,356.716766 764.684814,355.426361 762.503296,356.028473 
	C764.596008,354.636200 766.656860,353.206421 769.219238,354.864136 
z"/>
<path fill="#7084BF" opacity="1.000000" stroke="none" 
	d="
M760.644043,345.053009 
	C761.012878,345.456543 761.013672,345.865845 761.050293,346.579102 
	C760.916931,346.922607 760.747742,346.962189 760.332336,347.086884 
	C758.187561,346.967438 756.426208,348.795746 754.225342,347.282410 
	C756.087402,346.361664 758.181641,345.710236 760.644043,345.053009 
z"/>
<path fill="#182466" opacity="1.000000" stroke="none" 
	d="
M747.035645,356.222015 
	C748.601562,355.957672 750.428467,356.218903 752.500122,355.302979 
	C751.811584,359.075317 749.527039,357.718140 747.035645,356.222015 
z"/>
<path fill="#9EB0D3" opacity="1.000000" stroke="none" 
	d="
M755.717651,350.237305 
	C756.434814,350.087402 756.977173,350.101074 757.922119,350.190247 
	C758.607483,352.734222 757.644775,353.544952 755.123169,352.272522 
	C754.935730,352.014740 755.029053,351.621277 755.040649,351.419403 
	C755.160339,350.911987 755.323853,350.639771 755.717651,350.237305 
z"/>
<path fill="#433A81" opacity="1.000000" stroke="none" 
	d="
M749.196899,353.297913 
	C750.123352,352.709869 751.178955,352.385254 752.571045,352.075989 
	C752.931152,352.493713 752.954651,352.896088 752.941162,353.598389 
	C751.719299,353.702332 750.336060,355.613403 749.196899,353.297913 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M756.483032,357.318970 
	C756.661438,356.295990 755.589233,354.535278 757.219055,354.480194 
	C758.241272,354.445618 757.851746,355.624664 757.763306,356.885681 
	C757.379883,357.501984 757.185181,357.547333 756.483032,357.318970 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M752.850098,360.528076 
	C751.799622,360.880066 750.789368,360.946533 749.408691,361.104065 
	C749.948364,359.365936 751.335510,359.465363 752.850098,360.528076 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M757.482788,357.752075 
	C757.882324,359.896881 757.103455,359.476532 756.294495,358.046021 
	C756.614746,357.564453 756.804016,357.545929 757.482788,357.752075 
z"/>
<path fill="#96A2C9" opacity="1.000000" stroke="none" 
	d="
M760.305054,355.654175 
	C759.893677,355.685883 759.647400,355.560852 759.401123,355.435791 
	C759.507568,355.326721 759.648560,355.107361 759.714355,355.127960 
	C759.979004,355.210785 760.220337,355.367859 760.305054,355.654175 
z"/>
<path fill="#6872AE" opacity="1.000000" stroke="none" 
	d="
M748.088257,363.041229 
	C747.668091,362.871887 747.237183,362.657166 746.806213,362.442444 
	C747.160828,362.499146 747.515442,362.555847 748.008179,362.837402 
	C748.146301,363.062195 748.077515,362.995850 748.088257,363.041229 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M757.994629,357.005585 
	C758.366455,357.210999 758.901733,357.322754 758.189880,357.946503 
	C757.972351,357.976746 758.001160,358.001465 758.015137,358.014160 
	C757.850891,357.852875 757.672668,357.678925 757.766357,357.248810 
	C758.038147,356.992615 757.998901,356.986389 757.994629,357.005585 
z"/>
<path fill="#9EB7DC" opacity="1.000000" stroke="none" 
	d="
M756.010254,357.993958 
	C755.847473,357.845612 755.673340,357.705444 755.499268,357.565308 
	C755.575073,357.476196 755.650879,357.387085 755.851074,357.171631 
	C755.975525,357.045258 755.993774,357.011963 755.985962,357.020935 
	C756.153809,357.195038 756.329468,357.360138 756.242188,357.773499 
	C755.979187,358.021729 755.998962,358.002106 756.010254,357.993958 
z"/>
<path fill="#172A7A" opacity="1.000000" stroke="none" 
	d="
M750.724060,348.952271 
	C751.725891,348.977844 752.345398,349.046021 753.018860,349.120148 
	C751.146606,350.832672 751.146606,350.832672 749.618164,349.336548 
	C749.830383,349.034454 750.086060,349.014679 750.724060,348.952271 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M794.603882,254.094498 
	C795.080383,254.740555 795.092773,255.492493 794.946777,256.593262 
	C790.156921,256.086914 785.508362,257.050964 780.417236,256.938232 
	C773.196167,256.664215 773.183777,256.664551 773.365417,263.449951 
	C773.524048,269.377136 773.714783,275.303528 773.971069,281.703491 
	C770.638062,283.766388 772.061584,280.684021 772.033020,279.787933 
	C771.821838,273.164581 771.824829,266.534424 771.701477,259.439697 
	C771.642456,258.972961 771.621643,258.492157 771.653748,258.253693 
	C771.749695,257.573914 771.813599,257.132629 771.889160,256.356445 
	C776.346558,253.651047 781.191345,255.020981 785.840027,254.565567 
	C788.592102,254.295959 791.372314,254.312531 794.603882,254.094498 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M839.560120,255.907043 
	C839.867493,256.597961 839.862427,256.940033 839.863647,257.539795 
	C833.911133,258.533112 828.057434,257.212555 821.729858,256.920563 
	C821.088623,256.812897 820.870239,256.675812 820.921448,256.261414 
	C821.429932,255.741547 821.668823,255.499008 822.011353,255.020111 
	C827.946228,252.381012 833.642151,252.970581 839.560120,255.907043 
z"/>
<path fill="#F6EEED" opacity="1.000000" stroke="none" 
	d="
M821.044739,255.538116 
	C821.191040,255.984055 821.145325,256.479614 821.226196,256.714813 
	C820.668030,256.979919 820.029114,257.009827 818.911499,256.993042 
	C818.558838,256.523621 818.684814,256.100952 818.783752,255.348114 
	C818.834778,250.645340 818.912903,246.272781 818.929199,241.437225 
	C820.819702,239.185379 820.848877,240.553101 820.846741,242.145660 
	C820.840820,246.461121 820.878235,250.776672 821.044739,255.538116 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M802.866760,271.074097 
	C802.233032,271.434265 801.500793,271.539398 800.402161,271.574493 
	C800.588745,269.849304 801.474670,269.521515 802.866760,271.074097 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M778.171387,306.094086 
	C783.263245,305.814972 788.455200,305.777008 794.033020,305.833923 
	C793.886780,307.941681 792.370178,308.183777 790.587158,308.233673 
	C786.637146,308.344177 782.690857,308.589447 778.360107,308.780701 
	C778.381653,308.003021 780.340027,307.411377 778.171387,306.094086 
z"/>
<path fill="#B2ACAF" opacity="1.000000" stroke="none" 
	d="
M792.779297,299.923828 
	C792.051270,302.878204 789.347839,301.470673 787.361572,301.787109 
	C784.606995,302.225952 781.747375,302.005249 778.468506,302.031464 
	C778.005310,301.809113 778.006348,301.622223 778.046265,301.157745 
	C782.763489,299.680145 787.545166,299.984314 792.779297,299.923828 
z"/>
<path fill="#2B2237" opacity="1.000000" stroke="none" 
	d="
M772.420288,291.794006 
	C772.781555,288.763000 770.648010,285.553680 773.648560,283.425537 
	C773.275208,286.494202 775.205566,289.581177 772.420288,291.794006 
z"/>
<path fill="#D8D9C3" opacity="1.000000" stroke="none" 
	d="
M771.552002,258.103760 
	C771.726135,258.177032 771.766418,258.338867 771.724609,258.736847 
	C771.304993,258.779236 771.230164,258.519012 771.552002,258.103760 
z"/>
<path fill="#C2B8CA" opacity="1.000000" stroke="none" 
	d="
M929.087585,258.697021 
	C929.093445,259.223267 928.729187,259.589569 928.026978,260.149231 
	C925.910706,257.500458 922.320984,262.309570 920.860596,258.325500 
	C923.678284,256.701813 926.168396,258.011200 929.087585,258.697021 
z"/>
<path fill="#D0B9E9" opacity="1.000000" stroke="none" 
	d="
M927.616089,261.432983 
	C928.063965,262.162384 928.175598,262.902008 928.287231,263.641632 
	C927.730530,263.520660 927.173828,263.399719 926.349609,263.140961 
	C925.994324,262.847412 925.906555,262.691711 925.708130,262.291809 
	C925.597412,262.047607 925.759277,261.654083 925.854126,261.463654 
	C926.392639,261.329895 926.836243,261.386536 927.616089,261.432983 
z"/>
<path fill="#B399AE" opacity="1.000000" stroke="none" 
	d="
M925.760376,261.888062 
	C925.489136,261.796173 925.368286,261.548462 925.290955,261.287842 
	C925.282776,261.260345 925.530396,261.156952 925.804199,261.181000 
	C925.949036,261.273224 925.923279,261.728546 925.760376,261.888062 
z"/>
<path fill="#E3DFE8" opacity="1.000000" stroke="none" 
	d="
M655.647949,317.970825 
	C655.944336,318.484497 656.024109,318.975128 656.231750,319.817139 
	C656.319153,320.844818 656.278748,321.521149 656.250427,322.536957 
	C656.305298,323.096191 656.348145,323.315918 656.140747,323.759705 
	C654.290161,322.483337 655.237549,320.535706 654.989441,318.398987 
	C654.998352,317.998474 655.431274,317.947784 655.647949,317.970825 
z"/>
<path fill="#645081" opacity="1.000000" stroke="none" 
	d="
M656.000488,324.075012 
	C655.929626,323.791565 655.968567,323.599365 656.135010,323.141815 
	C656.390015,323.195190 656.517578,323.513916 656.505432,324.063416 
	C656.365723,324.294220 656.110352,324.166260 656.000488,324.075012 
z"/>
<path fill="#BFACDB" opacity="1.000000" stroke="none" 
	d="
M656.844360,311.414551 
	C656.860107,311.641174 656.708984,311.753418 656.310120,312.001404 
	C656.267395,311.858154 656.472473,311.579193 656.844360,311.414551 
z"/>
<path fill="#D1D4C4" opacity="1.000000" stroke="none" 
	d="
M839.920776,255.782761 
	C834.310364,255.073730 828.626648,255.467041 822.563965,254.869202 
	C822.087524,250.626785 822.132446,246.467514 822.002075,242.313751 
	C821.935913,240.206100 822.468018,239.339737 824.806030,239.658905 
	C828.918945,240.220413 833.074036,240.473755 837.614990,240.984238 
	C839.616089,245.714615 840.668884,250.391739 839.920776,255.782761 
z"/>
<path fill="#DEDBE7" opacity="1.000000" stroke="none" 
	d="
M855.797485,270.788025 
	C858.120605,270.471649 860.084595,272.995392 862.395386,271.100586 
	C862.912720,270.676422 862.758972,272.540405 862.993286,273.665833 
	C862.825378,274.167603 862.661377,274.329468 862.253662,274.736450 
	C861.817078,275.003815 861.624207,275.026062 861.149658,275.126160 
	C857.925598,274.808624 854.968445,274.500336 852.043945,274.000732 
	C844.748230,272.754425 844.754211,272.719513 845.201782,264.604218 
	C846.389404,266.600983 846.170166,269.267944 849.058105,269.421875 
	C849.455322,269.033051 849.615234,268.866364 850.120605,268.668091 
	C852.275208,268.970520 854.075562,269.328308 855.797485,270.788025 
z"/>
<path fill="#686F91" opacity="1.000000" stroke="none" 
	d="
M856.076660,270.597717 
	C853.972839,271.340851 852.234253,270.257996 850.245117,269.337769 
	C849.955627,267.157623 850.205322,265.550049 852.758179,265.040405 
	C853.121582,265.013367 853.548157,265.002014 853.761475,265.005493 
	C854.381714,265.334839 854.470886,265.763824 854.378113,266.251831 
	C854.893433,266.115601 854.528381,265.452332 855.237793,265.144775 
	C855.509460,265.019867 855.520325,265.053589 855.519775,265.071472 
	C855.715637,266.783081 855.912109,268.476807 856.076660,270.597717 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M852.869507,264.720764 
	C852.305847,266.236359 851.490173,267.459351 850.393982,268.841919 
	C850.113525,269.001495 849.701965,269.097137 849.498657,269.148438 
	C849.162903,266.746033 847.444824,263.188416 852.869507,264.720764 
z"/>
<path fill="#B6B0C6" opacity="1.000000" stroke="none" 
	d="
M855.125977,264.999695 
	C855.224060,265.754974 854.938660,266.490112 854.653320,267.225220 
	C854.464233,266.692505 854.275146,266.159790 854.030457,265.318024 
	C854.230713,264.999115 854.486572,264.989288 855.125977,264.999695 
z"/>
<path fill="#ECCEE2" opacity="1.000000" stroke="none" 
	d="
M862.241760,274.898712 
	C862.117554,274.671661 862.303223,274.419312 862.778198,274.115143 
	C862.939148,274.353363 862.767212,274.623413 862.241760,274.898712 
z"/>
<path fill="#BEA2BB" opacity="1.000000" stroke="none" 
	d="
M909.595032,269.583252 
	C909.480774,269.676270 909.426758,269.341278 909.426758,269.341278 
	C909.426758,269.341278 909.709290,269.490265 909.595032,269.583252 
z"/>
<path fill="#5D4B70" opacity="1.000000" stroke="none" 
	d="
M928.332275,268.420044 
	C928.433960,268.350220 928.496948,268.602783 928.496948,268.602783 
	C928.496948,268.602783 928.230591,268.489868 928.332275,268.420044 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M755.684143,349.999908 
	C755.753784,350.363312 755.615112,350.652924 755.264404,351.080017 
	C755.039490,350.982971 755.026672,350.748413 755.031738,350.161377 
	C755.049683,349.808929 755.475891,349.926086 755.684143,349.999908 
z"/>
<path fill="#5067A2" opacity="1.000000" stroke="none" 
	d="
M756.320923,358.039734 
	C755.979187,358.021729 755.928467,357.525879 755.953247,357.277893 
	C756.434570,356.998901 756.891113,356.967896 757.692871,356.964752 
	C758.030090,357.164886 758.022034,357.337189 758.021545,357.768127 
	C757.573608,358.037109 757.118103,358.047424 756.320923,358.039734 
z"/>
</svg>
)